require({cache:{
'api/diary/Builder':function(){
define([
    "./DiaryNote"
], function(
    DiaryNote
) {
    var Builder = function(config, urlConnectionBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
    };

    Builder.prototype.getDiaryNote = function() {
        return new DiaryNote(
            this.config.getUrl("api_diary_note"),
            this.urlConnectionBuilder.build()
        );
    };

    return Builder;
});

},
'api/diary/DiaryNote':function(){
define([], function() {
    var DiaryNote = function(url, urlConnection) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlConnection.setUrl(this.url);

        this.constants = {
            PARAM_NOTE: "note",
            PARAM_DATE: "date",
            PARAM_PROJECT_STAGE_PK: "projectStagePK"
        };
    };

    DiaryNote.prototype.save = function(diaryNoteVO, handlers) {
        // Build data
        var data = {};
        data[this.constants.PARAM_NOTE] = diaryNoteVO.getNote();
        data[this.constants.PARAM_DATE] = diaryNoteVO.getDiaryDate();
        data[this.constants.PARAM_PROJECT_STAGE_PK] = diaryNoteVO.getProjectStagePK();

        this.urlConnection.setData(data);

        // Set handlers
        this.urlConnection.setSuccessHandler(handlers.getSuccess());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.post();
    };

    return DiaryNote;
});

},
'api/diary/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    var Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_diary_note = 'diary-note/';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});

},
'api/Config':function(){
define([], function() {
    const API_ROOT_V1 = 'v1/';

    const Config = function(rootUrl) {
        this.url_root = rootUrl || baseUrl;
        this.api_root = API_ROOT_V1;
    };

    Config.prototype.getUrl = function(key, apiRoot) {
        return this.url_root + (apiRoot || this.api_root) + this[key];
    };

    return Config;
});
},
'api/favourite/Builder':function(){
define([
    "../parser/Collection",
    "./FavouriteCollection",
    "./ActionCollection",
    "./AlertCollection",
    "./parser/Favourite"
], function(
    Collection, FavouriteCollection, ActionCollection, AlertCollection, FavouriteParser
) {
    var Builder = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Builder.prototype.getFavouriteCollection = function() {
        return new FavouriteCollection(
            this.config.getUrl("api_favourite"),
            this.urlConnectionBuilder.build(),
            new Collection(new FavouriteParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Builder.prototype.getAlertCollection = function() {
        return new AlertCollection(
            this.config.getUrl("api_favourite_alert"),
            this.urlConnectionBuilder.build(),
            new Collection(new FavouriteParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Builder.prototype.getActionCollection = function() {
        return new ActionCollection(
            this.config.getUrl("api_favourite_action"),
            this.urlConnectionBuilder.build(),
            new Collection(new FavouriteParser()),
            this.urlResponseProcessorBuilder
        );
    };

    return Builder;
});

},
'api/parser/Collection':function(){
define([
    './error/InvalidCollection',
    './error/Parse'
], function(InvalidCollection, ParseError) {
    const ACCEPTED_CONTENT_TYPE = 'application/vnd.collection+json';

    const Collection = function(parser) {
        this.parser = parser;
        this.isSingleItemCollection = false;
    };

    Collection.prototype.setIsSingleItemCollection = function(isSingleItemCollection) {
        this.isSingleItemCollection = isSingleItemCollection;
        return this;
    };

    Collection.prototype.getAccepts = function() {
        return ACCEPTED_CONTENT_TYPE;
    };

    Collection.prototype.parse = function(content) {
        let jsonContent;
        try {
            jsonContent = JSON.parse(content);
        } catch(e) {
            throw new ParseError();
        }

        if (jsonContent != null && jsonContent.collection != null && jsonContent.collection.items != null) {
            const parsedItems = [];

            let parser = this.parser;
            const items = jsonContent.collection.items;

            for (let i = 0; i < items.length; i++) {
                const parsedItem = {};
                if (items[i].data != null) {
                    for (let j = 0; j < items[i].data.length; j++) {
                        const datum = items[i].data[j];

                        if (parsedItem[datum.name] != undefined) {
                            if (parsedItem[datum.name] instanceof Array) {
                                parsedItem[datum.name].push(datum.value);
                            } else {
                                // If parsed item already exists for current datum name
                                // but isn't an array it needs to be converted. Put
                                // the existing parsed item and the current datum value
                                // into an array and set that as the parsed item value.
                                const a = [];
                                a.push(parsedItem[datum.name]);
                                a.push(datum.value);

                                parsedItem[datum.name] = a;
                            }
                        } else {
                            parsedItem[datum.name] = datum.value;
                        }
                    }

                    if (typeof this.parser === 'function') {
                        parser = new this.parser();
                    }

                    if (parser) {
                        parsedItems.push(parser.parse(parsedItem));
                    } else {
                        parsedItems.push(parsedItem);
                    }

                    // If parsed items has only parsed one item and
                    // the collection parser is a single item collection
                    // return the first item
                    if (parsedItems.length === 1 && this.isSingleItemCollection) {
                        return parsedItems[0];
                    }
                }
            }

            return parsedItems;
        }

        throw new InvalidCollection();
    };

    return Collection;
});
},
'api/parser/error/InvalidCollection':function(){
define([], function() {
    var InvalidCollection = function() {
        this.error = "invalid_collection";
        this.description = "The collection is invalid";
    };

    InvalidCollection.prototype.getError = function() {
        return this.error;
    };

    InvalidCollection.prototype.getDescription = function() {
        return this.description;
    };

    return InvalidCollection;
});
},
'api/parser/error/Parse':function(){
define([], function() {
    var Parse = function() {
        this.error = "parse_error";
        this.description = "Error parsing content";
    };

    Parse.prototype.getError = function() {
        return this.error;
    };

    Parse.prototype.getDescription = function() {
        return this.description;
    };

    return Parse;
});
},
'api/favourite/FavouriteCollection':function(){
define([], function() {

    var FavouriteCollection = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this.urlConnection.setUrl(this.url);
    };

    FavouriteCollection.prototype.fetch = function(handlers) {
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return FavouriteCollection;
});
},
'api/favourite/ActionCollection':function(){
define([], function() {

    var ActionCollection = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this.urlConnection.setUrl(this.url);
    };

    ActionCollection.prototype.fetch = function(handlers) {
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return ActionCollection;
});
},
'api/favourite/AlertCollection':function(){
define([], function() {

    var AlertCollection = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this.urlConnection.setUrl(this.url);
    };

    AlertCollection.prototype.fetch = function(handlers) {
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return AlertCollection;
});
},
'api/favourite/parser/Favourite':function(){
define([
    "../data/Favourite"
], function(FavouriteVO) {
    var Favourite = function() {
    };

    Favourite.prototype.parse = function(item) {
        var f = new FavouriteVO();

        f.setFavouritePK(item.favouritePK || null);
        f.setPersonPK(item.personPK || null);
        f.setType(item.type || null);
        f.setList(item.list || null);
        f.setName(item.name || null);
        f.setUrl(item.url || null);
        f.setInterval(item.interval || null);
        f.setColour(item.colour || null);
        f.setProjectStagePK(item.projectStagePK || null);
        f.setProjectStageTreeViewPK(item.projectStageTreeViewPK || null);
        f.setIsNonProjectStage(item.isNonProjectStage || null);
        f.setReportPK(item.reportPK || null);
        f.setDocumentPK(item.documentPK || null);
        f.setRevisions(item.revisions || null);
        f.setFilters(item.filters || null);

        return f;
    };

    return Favourite;
});
},
'api/favourite/data/Favourite':function(){
define([], function() {

    var Favourite = function() {
        this.favouritePK = null;
        this.personPK = null;
        this.type = null;
        this.list = null;
        this.name = null;
        this.url = null;
        this.interval = null;
        this.colour = null;
        this.projectStagePK = null;
        this.projectStageTreeViewPK = null;
        this.isNonProjectStage = null;
        this.reportPK = null;
        this.documentPK = null;
        this.revisions = null;
        this.filters = null;
    };

    Favourite.prototype.getFavouritePK = function() {
        return this.favouritePK;
    };

    Favourite.prototype.setFavouritePK = function(favouritePK) {
        this.favouritePK = favouritePK;
    };

    Favourite.prototype.getPersonPK = function() {
        return this.personPK;
    };

    Favourite.prototype.setPersonPK = function(personPK) {
        this.personPK = personPK;
    };

    Favourite.prototype.getType = function() {
        return this.type;
    };

    Favourite.prototype.setType = function(type) {
        this.type = type;
    };

    Favourite.prototype.getList = function() {
        return this.list;
    };

    Favourite.prototype.setList = function(list) {
        this.list = list;
    };

    Favourite.prototype.getName = function() {
        return this.name;
    };

    Favourite.prototype.setName = function(name) {
        this.name = name;
    };

    Favourite.prototype.getUrl = function() {
        return this.url;
    };

    Favourite.prototype.setUrl = function(url) {
        this.url = url;
    };

    Favourite.prototype.getInterval = function() {
        return this.interval;
    };

    Favourite.prototype.setInterval = function(interval) {
        this.interval = interval;
    };

    Favourite.prototype.getColour = function() {
        return this.colour;
    };

    Favourite.prototype.setColour = function(colour) {
        this.colour = colour;
    };

    Favourite.prototype.getProjectStagePK = function() {
        return this.projectStagePK;
    };

    Favourite.prototype.setProjectStagePK = function(projectStagePK) {
        this.projectStagePK = projectStagePK;
    };

    Favourite.prototype.getProjectStageTreeViewPK = function() {
        return this.projectStageTreeViewPK;
    };

    Favourite.prototype.setProjectStageTreeViewPK = function(projectStageTreeViewPK) {
        this.projectStageTreeViewPK = projectStageTreeViewPK;
    };

    Favourite.prototype.getIsNonProjectStage = function() {
        return this.isNonProjectStage;
    };

    Favourite.prototype.setIsNonProjectStage = function(isNonProjectStage) {
        this.isNonProjectStage = isNonProjectStage;
    };

    Favourite.prototype.getReportPK = function() {
        return this.reportPK;
    };

    Favourite.prototype.setReportPK = function(reportPK) {
        this.reportPK = reportPK;
    };

    Favourite.prototype.setDocumentPK = function() {
        return this.contactIsExternal;
    };

    Favourite.prototype.getDocumentPK = function(documentPK) {
        this.documentPK = documentPK;
    };

    Favourite.prototype.getRevisions = function() {
        return this.revisions;
    };

    Favourite.prototype.setRevisions = function(revisions) {
        this.revisions = revisions;
    };

    Favourite.prototype.getFilters = function() {
        return this.filters;
    };

    Favourite.prototype.setFilters = function(filters) {
        this.filters = filters;
    };

    return Favourite;
});
},
'api/favourite/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    var Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_alert = 'alert/';
        this.api_alert_document = 'alert/document/';
        this.api_alert_document_search = 'alert/document/search/';
        this.api_alert_document_search_collection = 'alert/document/search/collection';
        this.api_alert_tree_node = 'alert/tree/node/';
        this.api_favourite = 'favourite/';
        this.api_favourite_action = 'action/';
        this.api_favourite_alert = 'alert/';
        this.api_favourite_document = 'favourite/document/';
        this.api_favourite_document_search = 'favourite/document/search/';
        this.api_favourite_document_search_collection = 'favourite/document/search/collection';
        this.api_favourite_tree_node = 'favourite/tree/node/';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});

},
'api/mail/Factory':function(){
define([
    '@lib/api/mail/project/StageDetector',
    '@lib/api/mail/project/parser/StageSuggestion',
    '../parser/application/JSON',
    '../parser/Collection',
    './parser/Address',
    './parser/Attachment',
    './parser/Body',
    './parser/Draft',
    './parser/Filter',
    './parser/Folder',
    './parser/Header',
    './parser/Mailbox',
    './parser/Message',
    './parser/Sibling',
    './parser/Thread',
    './Attachment',
    './draft/AttachmentCollection',
    './Draft',
    './DraftAction',
    './DraftCollection',
    './DraftCollectionAction',
    './DraftContent',
    './filter/Collection',
    './filter/Filter',
    './FolderAction',
    './FolderCollection',
    './group/MemberCollection',
    './mailbox/Collection',
    './mailbox/Mailbox',
    './my-group/MemberCollection',
    './folder/Folder',
    './message/Message',
    './message/Action',
    './message/BodyAttachmentLog',
    './message/Collection',
    './message/CollectionAction',
    './message/Content',
    './message/Sibling',
    './message/Thread',
    './out-of-office/parser/Reply',
    './out-of-office/Reply',
    './out-of-office/ReplyCollection',
    './MessageSender',
    './MessageSignature',
    './RecentMessageCount',
    './search/Message',
    './search/parser/Message',
    'library/request/fetch/Factory',
    'spencer/parse/Collection',
    'spencer/parse/CollectionAndTotal',
    'spencer/parse/JSONParser'
], function(
    MessageStageDetector,
    StageSuggestionParser,
    ApplicationJSONParser,
    CollectionParser,
    AddressParser,
    AttachmentParser,
    BodyParser,
    DraftParser,
    FilterParser,
    FolderParser,
    HeaderParser,
    MailboxParser,
    MessageParser,
    SiblingParser,
    ThreadParser,
    Attachment,
    DraftAttachmentCollection,
    Draft,
    DraftAction,
    DraftCollection,
    DraftCollectionAction,
    DraftContent,
    FilterCollection,
    Filter,
    FolderAction,
    FolderCollection,
    GroupMemberCollection,
    MailboxCollection,
    Mailbox,
    MyGroupMemberCollection,
    Folder,
    Message,
    MessageAction,
    MessageBodyAttachmentLog,
    MessageCollection,
    MessageCollectionAction,
    MessageContent,
    MessageSibling,
    MessageThread,
    OutOfOfficeReplyParser,
    OutOfOfficeReply,
    OutOfOfficeReplyCollection,
    MessageSender,
    MessageSignature,
    RecentMessageCount,
    SearchMessage,
    SearchMessageParser,
    FetchFactory,
    SpencerCollectionParser,
    SpencerCollectionAndTotalParser,
    SpencerJSONParser
) {
    const Factory = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Factory.prototype.getAttachment = function() {
        return new Attachment(
            this.config.getUrl('api_attachment'),
            this.urlConnectionBuilder.build()
        );
    };

    Factory.prototype.getFilter = function() {
        return new Filter(
            this.config.getUrl('api_filter'),
            this.urlConnectionBuilder
        );
    };

    Factory.prototype.getFilterCollection = function() {
        return new FilterCollection(
            this.config.getUrl('api_filter'),
            this.urlConnectionBuilder.build(),
            new CollectionParser(new FilterParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getFolderAction = function() {
        return new FolderAction(
            this.config.getUrl('api_folder'),
            this.urlConnectionBuilder
        );
    };

    Factory.prototype.getFolderCollection = function() {
        return new FolderCollection(
            this.config.getUrl('api_folder'),
            this.urlConnectionBuilder.build(),
            new CollectionParser(new FolderParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getMailbox = function() {
        const cp = new CollectionParser(new MailboxParser());
        cp.setIsSingleItemCollection(true);

        return new Mailbox(
            this.config.getUrl('api_mailbox'),
            this.urlConnectionBuilder.build(),
            cp,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getMailboxCollection = function() {
        return new MailboxCollection(
            this.config.getUrl('api_mailbox'),
            this.urlConnectionBuilder.build(),
            new CollectionParser(new MailboxParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getFolder = function() {
        const cp = new CollectionParser(new FolderParser());
        cp.setIsSingleItemCollection(true);

        return new Folder(
            this.config.getUrl('api_folder'),
            this.urlConnectionBuilder.build(),
            cp,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getGroupMemberCollection = function() {
        return new GroupMemberCollection(
            this.config.getUrl('api_mail_group'),
            this.urlConnectionBuilder.build(),
            new CollectionParser(),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getMyGroupMemberCollection = function() {
        return new MyGroupMemberCollection(
            this.config.getUrl('api_mail_my_group'),
            this.urlConnectionBuilder.build(),
            new CollectionParser(),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getMessage = function() {
        const cp = new CollectionParser(new MessageParser());
        cp.setIsSingleItemCollection(true);

        return new Message(
            this.config.getUrl('api_message'),
            this.urlConnectionBuilder.build(),
            cp,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getMessageAction = function() {
        return new MessageAction(
            this.config.getUrl('api_message'),
            this.urlConnectionBuilder
        );
    };

    Factory.prototype.getMessageBodyAttachmentLog = function() {
        return new MessageBodyAttachmentLog(
            this.config.getUrl('api_message_body_attachment_log'),
            this.urlConnectionBuilder.build()
        );
    };

    Factory.prototype.getMessageCollection = function() {
        return new MessageCollection(
            this.config.getUrl('api_message'),
            this.urlConnectionBuilder.build(),
            new CollectionParser(new MessageParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getMessageCollectionAction = function() {
        return new MessageCollectionAction(
            this.config.getUrl('api_message'),
            this.urlConnectionBuilder
        );
    };

    Factory.prototype.getMessageContent = function() {
        return new MessageContent(
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder,
            this.config.getUrl('api_body', 'v2/'),
            this.config.getUrl('api_attachment'),
            this.config.getUrl('api_recipient_to'),
            this.config.getUrl('api_recipient_cc'),
            this.config.getUrl('api_from'),
            new ApplicationJSONParser(new BodyParser()),
            new CollectionParser(new AttachmentParser()),
            new CollectionParser(new AddressParser())
        );
    };

    Factory.prototype.getMessageSibling = function() {
        const cp = new CollectionParser(new SiblingParser());
        cp.setIsSingleItemCollection(true);

        return new MessageSibling(
            this.config.getUrl('api_message_sibling'),
            this.urlConnectionBuilder.build(),
            cp,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getMessageThread = function() {
        return new MessageThread(
            this.config.getUrl('api_message_thread'),
            this.urlConnectionBuilder.build(),
            new ThreadParser(
                new CollectionParser(),
                new HeaderParser()
            ),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getMessageProjectStageDetector = function() {
        return new MessageStageDetector(
            this.config.getUrl('api_mail_message_project_detector', 'v2/'),
            new SpencerCollectionParser(new StageSuggestionParser()),
            new FetchFactory()
        );
    };

    Factory.prototype.getOutOfOfficeReply = function() {
        return new OutOfOfficeReply(
            this.config.getUrl('api_out_of_office'),
            this.urlConnectionBuilder.build(),
            new OutOfOfficeReplyParser(),
            this.urlResponseProcessorBuilder
        )
    };

    Factory.prototype.getOutOfOfficeReplyCollection = function() {
        return new OutOfOfficeReplyCollection(
            this.config.getUrl('api_out_of_office'),
            this.urlConnectionBuilder.build(),
            new CollectionParser(new OutOfOfficeReplyParser()),
            this.urlResponseProcessorBuilder
        )
    };

    Factory.prototype.getMessageSignature = function() {
        return new MessageSignature(
            this.config.getUrl('api_signature'),
            this.urlConnectionBuilder.build()
        );
    };

    Factory.prototype.getDraft = function() {
        const cp = new CollectionParser(new DraftParser());
        cp.setIsSingleItemCollection(true);

        return new Draft(
            this.config.getUrl('api_draft'),
            this.urlConnectionBuilder.build(),
            cp,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getDraftAction = function() {
        return new DraftAction(
            this.config.getUrl('api_draft'),
            this.urlConnectionBuilder
        );
    };

    Factory.prototype.getDraftAttachmentCollection = function() {
        return new DraftAttachmentCollection(
            this.config.getUrl('api_draft_attachment', 'v2/'),
            this.urlConnectionBuilder,
            new SpencerJSONParser(new SpencerCollectionParser(new AttachmentParser())),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getDraftCollection = function() {
        return new DraftCollection(
            this.config.getUrl('api_draft'),
            this.urlConnectionBuilder.build(),
            new CollectionParser(new DraftParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getDraftCollectionAction = function() {
        return new DraftCollectionAction(
            this.config.getUrl('api_draft'),
            this.urlConnectionBuilder
        )
    };

    Factory.prototype.getDraftContent = function() {
        return new DraftContent(
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder,
            this.config.getUrl('api_draft_body'),
            this.config.getUrl('api_draft_recipient_to'),
            this.config.getUrl('api_draft_recipient_cc'),
            new CollectionParser(new BodyParser()),
            new CollectionParser(new AddressParser())
        );
    };
    
    Factory.prototype.getMessageSender = function() {
        return new MessageSender(
            this.config.getUrl('api_send'),
            this.urlConnectionBuilder.build()
        );
    };

    Factory.prototype.getRecentMessageCount = function() {
        return new RecentMessageCount(
            this.urlConnectionBuilder.build(),
            this.config.getUrl('api_recent_message_count')
        );
    };

    Factory.prototype.getSearchMessage = function() {
        return new SearchMessage(
            this.config.getUrl('api_search_message', 'v2/'),
            this.urlConnectionBuilder.build(),
            new SpencerJSONParser(
                new SpencerCollectionAndTotalParser(
                    new SpencerCollectionParser(
                        new SearchMessageParser()
                    )
                )
            ),
            this.urlResponseProcessorBuilder
        );
    };

    return Factory;
});

},
'@lib/api/mail/project/StageDetector':function(){
define(["require", "exports", "@lib/request/data/HTTPResponseCodes"], function (require, exports, HTTPResponseCodes) {
    "use strict";
    class StageDetector {
        constructor(url, parser, fetchFactory) {
            this.url = url;
            this.parser = parser;
            this.fetchFactory = fetchFactory;
            this.url = url;
            this.parser = parser;
            this.fetchFactory = fetchFactory;
        }
        get(handlers, uid, folderId) {
            const fetchProcessor = this.fetchFactory.get();
            fetchProcessor.setSuccessHandler(async (response) => {
                response.json().then(data => {
                    handlers.getSuccess()(this.parser.parse(data.projectStageCollection));
                });
            });
            fetchProcessor.setHandler(HTTPResponseCodes.accepted, async (response) => {
                response.json().then(data => {
                    handlers.getAccepted()(data.documentEventReference);
                });
            });
            fetchProcessor.setErrorHandler(handlers.getError());
            fetchProcessor.get(this.url.replace(':uid', uid.toString()) + this.buildQuery(folderId));
            return fetchProcessor;
        }
        buildQuery(folderId) {
            return folderId ? `?${new URLSearchParams({ folderId: folderId }).toString()}` : '';
        }
    }
    return StageDetector;
});

},
'@lib/request/data/HTTPResponseCodes':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    return {
        cancelled: 0,
        ok: 200,
        created: 201,
        accepted: 202,
        no_content: 204,
        reset_content: 205,
        bad_request: 400,
        unauthorized: 401,
        forbidden: 403,
        not_found: 404,
        method_not_allowed: 405,
        conflict: 409,
        gone: 410,
        length_required: 411,
        content_too_large: 413,
        unprocessable_content: 422,
        locked: 423,
        server_error: 500
    };
});

},
'@lib/api/mail/project/parser/StageSuggestion':function(){
define(["require", "exports", "../data/StageSuggestion"], function (require, exports, StageSuggestionVO) {
    "use strict";
    class StageSuggestion {
        parse(item) {
            return (new StageSuggestionVO())
                .setProjectStagePK(parseInt(item.projectStagePK) || 0)
                .setStageNumber(item.stageNumber || '')
                .setTitle(item.title || '')
                .setType(item.type || '')
                .setConfidence(parseFloat(item.confidence) || 0);
        }
    }
    return StageSuggestion;
});

},
'@lib/api/mail/project/data/StageSuggestion':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class StageSuggestion {
        getProjectStagePK() {
            return this.projectStagePK;
        }
        setProjectStagePK(value) {
            this.projectStagePK = value;
            return this;
        }
        getStageNumber() {
            return this.stageNumber;
        }
        setStageNumber(value) {
            this.stageNumber = value;
            return this;
        }
        getTitle() {
            return this.title;
        }
        setTitle(value) {
            this.title = value;
            return this;
        }
        getType() {
            return this.type;
        }
        setType(value) {
            this.type = value;
            return this;
        }
        getConfidence() {
            return this.confidence;
        }
        setConfidence(value) {
            this.confidence = value;
            return this;
        }
    }
    return StageSuggestion;
});

},
'api/parser/application/JSON':function(){
define([
    '../error/Parse'
], function(ParseError) {
    const ACCEPTED_CONTENT_TYPE = 'application/json';

    const ApplicationJSON = function(itemParser) {
        this.itemParser = itemParser;
    };

    ApplicationJSON.prototype.getAccepts = function() {
        return ACCEPTED_CONTENT_TYPE;
    };

    ApplicationJSON.prototype.parse = function(content) {
        let parsedContent;
        try {
            parsedContent = JSON.parse(content);
        } catch(e) {
            throw new ParseError();
        }

        if (parsedContent && this.itemParser) {
            if (Array.isArray(parsedContent)) {
                const r = [];
                for(let i = 0; i < parsedContent.length; i++) {
                    r.push(this.itemParser.parse(parsedContent[i]));
                }
                return r;
            } else if (typeof parsedContent === 'object') {
                return this.itemParser.parse(parsedContent);
            }
        }

        return parsedContent;
    };

    return ApplicationJSON;
});
},
'api/mail/parser/Address':function(){
define([
    '../../contact/data/Contact'
], function(ContactVO) {
    const Address = function() {};

    Address.prototype.parse = function(item) {
        const c = new ContactVO();
        c.setContactPK(item.contactPK || null);
        c.setPersonPK(item.personPK || null);
        c.setBranchOfficePK(item.branchOfficePK || null);
        c.setBranchOfficeEmailPK(item.branchOfficeEmailPK || null);
        c.setPreferredName(item.preferredName || null);
        c.setName(item.name || null);
        c.setEmail(item.email || null);
        c.setOrganisation(item.organisation || null);
        c.setOrganisationPK(item.organisationPK || null);
        c.setPersonType(item.personType || null);
        c.setJobTitle(item.jobTitle || null);
        c.setIsBranchOffice(item.isBranchOffice || false);
        c.setIsSc(item.isSc || false);
        c.setIsExternal(item.isExternal || false);
        c.setImageUrl(item.imageUrl || null);

        return c;
    };

    return Address;
});
},
'api/contact/data/Contact':function(){
define([], function() {
    const Contact = function() {
        this.contactPK = null;
        this.personPK = null;
        this.branchOfficePK = null;
        this.branchOfficeEmailPK = null;
        this.name = null;
        this.preferredName = null;
        this.email = null;
        this.organisation = null;
        this.organisationPreferredName = null;
        this.organisationPK = null;
        this.personType = null;
        this.jobTitle = null;
        this.contactIsBranchOffice = false;
        this.contactIsSc = false;
        this.contactIsExternal = false;
        this.imageUrl = null;
    };

    Contact.prototype.getContactPK = function() {
        return this.contactPK;
    };

    Contact.prototype.setContactPK = function(contactPK) {
        this.contactPK = contactPK;
        return this;
    };

    Contact.prototype.getPersonPK = function() {
        return this.personPK;
    };

    Contact.prototype.setPersonPK = function(personPK) {
        this.personPK = personPK;
        return this;
    };

    Contact.prototype.getBranchOfficePK = function() {
        return this.branchOfficePK;
    };

    Contact.prototype.setBranchOfficePK = function(branchOfficePK) {
        this.branchOfficePK = branchOfficePK;
        return this;
    };

    Contact.prototype.getBranchOfficeEmailPK = function() {
        return this.branchOfficeEmailPK;
    };

    Contact.prototype.setBranchOfficeEmailPK = function(branchOfficeEmailPK) {
        this.branchOfficeEmailPK = branchOfficeEmailPK;
        return this;
    };

    Contact.prototype.getName = function() {
        return this.name;
    };

    Contact.prototype.setName = function(name) {
        this.name = name;
        return this;
    };

    Contact.prototype.getPreferredName = function() {
        return this.preferredName;
    };

    Contact.prototype.setPreferredName = function(preferredName) {
        this.preferredName = preferredName;
        return this;
    };

    Contact.prototype.getEmail = function() {
        return this.email;
    };

    Contact.prototype.setEmail = function(email) {
        this.email = email;
        return this;
    };

    Contact.prototype.getOrganisation = function() {
        return this.organisation;
    };

    Contact.prototype.setOrganisation = function(organisation) {
        this.organisation = organisation;
        return this;
    };

    Contact.prototype.getOrganisationPreferredName = function() {
        return this.organisationPreferredName;
    };

    Contact.prototype.setOrganisationPreferredName = function(name) {
        this.organisationPreferredName = name;
        return this;
    };

    Contact.prototype.getOrganisationPK = function() {
        return this.organisationPK;
    };

    Contact.prototype.setOrganisationPK = function(organisationPK) {
        this.organisationPK = organisationPK;
        return this;
    };

    Contact.prototype.getPersonType = function() {
        return this.personType;
    };

    Contact.prototype.setPersonType = function(personType) {
        this.personType = personType;
        return this;
    };

    Contact.prototype.getJobTitle = function() {
        return this.jobTitle;
    };

    Contact.prototype.setJobTitle = function(jobTitle) {
        this.jobTitle = jobTitle;
        return this;
    };

    Contact.prototype.isBranchOffice = function() {
        return this.contactIsBranchOffice;
    };

    Contact.prototype.setIsBranchOffice = function(isBranchOffice) {
        this.contactIsBranchOffice = isBranchOffice;
        return this;
    };

    Contact.prototype.isSc = function() {
        return this.contactIsSc;
    };

    Contact.prototype.setIsSc = function(isSc) {
        this.contactIsSc = isSc;
        return this;
    };

    Contact.prototype.isExternal = function() {
        return this.contactIsExternal;
    };

    Contact.prototype.setIsExternal = function(isExternal) {
        this.contactIsExternal = isExternal;
        return this;
    };

    Contact.prototype.getImageUrl = function() {
        return this.imageUrl;
    };

    Contact.prototype.setImageUrl = function(imageUrl) {
        this.imageUrl = imageUrl;
        return this;
    };

    return Contact;
});
},
'api/mail/parser/Attachment':function(){
define([
    'spencer/mail/data/Attachment',
    'api/doccontrol/parser/RegistrationDetails'
], function(
    AttachmentVO,
    RegistrationDetailsParser
) {
    return class Attachment {
        constructor() {
            this.registrationDetailsParser = new RegistrationDetailsParser();
        }

        parse(item) {
            const a = new AttachmentVO();
            a.setFileName(item.fileName || null);
            a.setFileSize(item.fileSize || null);
            a.setMd5(item.md5 || null);
            a.setType(item.type || null);
            a.setSubType(item.subType || null);
            a.setIsRegistered(item.isRegistered || false);
            a.setRegisteredTitle(item.registeredTitle || null);
            a.setProjectStageTitle(item.projectStageTitle || null);
            a.setProjectStageNumber(item.projectStageNumber || null);
            a.setParentProjectStageTreeViewName(item.parentProjectStageTreeViewName || null);
            a.setProjectStageTreeViewName(item.projectStageTreeViewName || null);
            a.setPrivate(item.isPrivate || false);
            a.setDeleted(item.isDeleted || false);
            a.setRegistrationDetails(this.registrationDetailsParser.parse(item.registrationDetails || {}));
            a.setProcessed(item.isProcessed || false);

            return a;
        };
    }
});
},
'spencer/mail/data/Attachment':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Attachment {
        constructor() {
            this.fileName = null;
            this.fileSize = null;
            this.md5 = null;
            this.type = null;
            this.subType = null;
            this.attachmentIsRegistered = false;
            this.registeredTitle = null;
            this.projectStageTitle = null;
            this.projectStageNumber = null;
            this.parentProjectStageTreeViewName = null;
            this.projectStageTreeView = null;
            this.projectStageTreeViewName = null;
            this.isPrivateAttr = false;
            this.deleted = false;
            this.registrationDetails = null;
            this.smartRegistrationDetails = null;
            this.smartRegistrationProcessingStep = null;
            this.processed = false;
        }
        getFileName() {
            return this.fileName;
        }
        setFileName(fileName) {
            this.fileName = fileName;
            return this;
        }
        getFileSize() {
            return this.fileSize;
        }
        setFileSize(fileSize) {
            this.fileSize = fileSize;
            return this;
        }
        getMd5() {
            return this.md5;
        }
        setMd5(md5) {
            this.md5 = md5;
            return this;
        }
        getType() {
            return this.type;
        }
        setType(type) {
            this.type = type;
            return this;
        }
        getSubType() {
            return this.subType;
        }
        setSubType(subType) {
            this.subType = subType;
            return this;
        }
        isRegistered() {
            return this.attachmentIsRegistered;
        }
        setIsRegistered(isRegistered) {
            this.attachmentIsRegistered = isRegistered;
            return this;
        }
        getRegisteredTitle() {
            return this.registeredTitle;
        }
        setRegisteredTitle(registeredTitle) {
            this.registeredTitle = registeredTitle;
            return this;
        }
        getRegistrationDetails() {
            return this.registrationDetails;
        }
        setRegistrationDetails(registrationDetails) {
            this.registrationDetails = registrationDetails;
            return this;
        }
        getSmartRegistrationDetails() {
            return this.smartRegistrationDetails;
        }
        setSmartRegistrationDetails(smartRegistrationDetails) {
            this.smartRegistrationDetails = smartRegistrationDetails;
            return this;
        }
        getProjectStageTitle() {
            return this.projectStageTitle;
        }
        setProjectStageTitle(projectStageTitle) {
            this.projectStageTitle = projectStageTitle;
            return this;
        }
        getProjectStageNumber() {
            return this.projectStageNumber;
        }
        setProjectStageNumber(projectStageNumber) {
            this.projectStageNumber = projectStageNumber;
            return this;
        }
        getParentProjectStageTreeViewName() {
            return this.parentProjectStageTreeViewName;
        }
        setParentProjectStageTreeViewName(parentProjectStageTreeViewName) {
            this.parentProjectStageTreeViewName = parentProjectStageTreeViewName;
            return this;
        }
        getProjectStageTreeViewName() {
            return this.projectStageTreeViewName;
        }
        setProjectStageTreeViewName(projectStageTreeViewName) {
            this.projectStageTreeViewName = projectStageTreeViewName;
            return this;
        }
        getProjectStageTreeView() {
            return this.projectStageTreeView;
        }
        setProjectStageTreeView(projectStageTreeView) {
            this.projectStageTreeView = projectStageTreeView;
            return this;
        }
        isPrivate() {
            return this.isPrivateAttr;
        }
        setPrivate(isPrivate) {
            this.isPrivateAttr = isPrivate;
            return this;
        }
        isDeleted() {
            return this.deleted;
        }
        setDeleted(isDeleted) {
            this.deleted = isDeleted;
            return this;
        }
        setSmartRegisterProcessingStep(smartRegistrationProcessingStep) {
            this.smartRegistrationProcessingStep = smartRegistrationProcessingStep;
            return this;
        }
        getSmartRegistrationProcessingStep() {
            return this.smartRegistrationProcessingStep;
        }
        isProcessed() {
            return this.processed;
        }
        setProcessed(processed) {
            this.processed = processed;
            return this;
        }
    }
    return Attachment;
});

},
'api/doccontrol/parser/RegistrationDetails':function(){
define([
    '../data/RegistrationDetails',
    'api/contact/parser/Contact'
], function(
    RegistrationDetailsVO,
    ContactParser
) {
    return class RegistrationDetails {
        constructor() {
            this.contactParser = new ContactParser;
        }

        parse(item) {
            return (new RegistrationDetailsVO())
                .setTreeViewPK(item.treeViewPK || null)
                .setMd5(item.md5 || null)
                .setType(item.type || null)
                .setNodeReference(item.nodeReference || null)
                .setPersonPK(item.personPK || null)
                .setTitle(item.title || null)
                .setDate(item.date || null)
                .setDiscipline(item.disciplinePK || item.disciplineVO?.drawingDisciplinePK || null)
                .setDisciplineVO(item.disciplineVO || null)
                .setIsPrivate(item.isPrivate || false)
                .setRevision(item.revision || null)
                .setReference(item.reference || null)
                .setStatus(item.statusPK || item.statusVO?.statusPK || null)
                .setStatusVO(item.statusVO || null)
                .setProjectStagePK(item.projectStagePK || null)
                .setRecipientContact(
                    item.recipientContact ?
                        this.contactParser.parse(item.recipientContact):
                        null
                )
                .setOriginatorContact(
                    item.originatorContact?
                        this.contactParser.parse(item.originatorContact):
                        null
                );
        }
    }
});
},
'api/doccontrol/data/RegistrationDetails':function(){
define([], function() {
    const RegistrationDetails = function() {
        this.treeViewPK = null;
        this.md5 = null;
        this.type = null;
        this.nodeReference = null;
        this.personPK = null;
        this.branchOfficePK = null;
        this.originatorContact = null;
        this.recipientContact = null;
        this.title = null;
        this.date = null;
        this.isPrivateAttr = false;
        this.page = null;
        this.discipline = null;
        this.disciplineVO = null;
        this.revision = null;
        this.reference = null;
        this.status = null;
        this.statusVO = null;
        this.location = null;
        this.projectStagePK = null;
        this.registrarPersonPK = null;
        this.subject = null;
        this.to = null;
        this.quickRegister = false;
        this.metaDataCollection = [];
    };

    RegistrationDetails.prototype.setTreeViewPK = function(treeViewPK) {
        this.treeViewPK = treeViewPK;
        return this;
    };

    RegistrationDetails.prototype.getTreeViewPK = function() {
        return this.treeViewPK;
    };

    RegistrationDetails.prototype.setMd5 = function(md5) {
        this.md5 = md5;
        return this;
    };

    RegistrationDetails.prototype.getMd5 = function() {
        return this.md5;
    };

    RegistrationDetails.prototype.setType = function(type) {
        this.type = type;
        return this;
    };

    RegistrationDetails.prototype.getType = function() {
        return this.type;
    };

    RegistrationDetails.prototype.setNodeReference = function(nodeReference) {
        this.nodeReference = nodeReference;
        return this;
    };

    RegistrationDetails.prototype.getNodeReference = function() {
        return this.nodeReference;
    };

    RegistrationDetails.prototype.setPersonPK = function(personPK) {
        this.personPK = personPK;
        return this;
    };

    RegistrationDetails.prototype.getPersonPK = function() {
        return this.personPK;
    };

    RegistrationDetails.prototype.setBranchOfficePK = function(branchOfficePK) {
        this.branchOfficePK = branchOfficePK;
        return this;
    };

    RegistrationDetails.prototype.getBranchOfficePK = function() {
        return this.branchOfficePK;
    };

    RegistrationDetails.prototype.setOriginatorContact = function(originatorContact) {
        this.originatorContact = originatorContact;
        return this;
    };

    RegistrationDetails.prototype.getOriginatorContact = function() {
        return this.originatorContact;
    };

    RegistrationDetails.prototype.setRecipientContact = function(recipientContact) {
        this.recipientContact = recipientContact;
        return this;
    };

    RegistrationDetails.prototype.getRecipientContact = function() {
        return this.recipientContact;
    };

    RegistrationDetails.prototype.setTitle = function(title) {
        this.title = title;
        return this;
    };

    RegistrationDetails.prototype.getTitle = function() {
        return this.title;
    };

    RegistrationDetails.prototype.setDate = function(date) {
        this.date = date;
        return this;
    };

    RegistrationDetails.prototype.getDate = function() {
        return this.date;
    };

    RegistrationDetails.prototype.getDisciplineVO = function() {
        return this.disciplineVO;
    };

    RegistrationDetails.prototype.setDisciplineVO = function(disciplineVO) {
        this.disciplineVO = disciplineVO;
        return this;
    };

    RegistrationDetails.prototype.getDiscipline = function() {
        return this.discipline;
    };

    RegistrationDetails.prototype.setDiscipline = function(discipline) {
        this.discipline = discipline;
        return this;
    };

    RegistrationDetails.prototype.setIsPrivate = function(isPrivate) {
        this.isPrivateAttr = isPrivate;
        return this;
    };

    RegistrationDetails.prototype.isPrivate = function() {
        return this.isPrivateAttr;
    };

    RegistrationDetails.prototype.setPage = function(page) {
        this.page = page;
        return this;
    };

    RegistrationDetails.prototype.getPage = function() {
        return this.page;
    };

    RegistrationDetails.prototype.setProjectStagePK = function(projectStagePK) {
        this.projectStagePK = projectStagePK;
        return this;
    };

    RegistrationDetails.prototype.getProjectStagePK = function() {
        return this.projectStagePK;
    };

    RegistrationDetails.prototype.setRegistrarPersonPK = function(registrarPersonPK) {
        this.registrarPersonPK = registrarPersonPK;
        return this;
    };

    RegistrationDetails.prototype.getRegistrarPersonPK = function() {
        return this.registrarPersonPK;
    };

    RegistrationDetails.prototype.getSubject = function() {
        return this.subject;
    };

    RegistrationDetails.prototype.setSubject = function(subject) {
        this.subject = subject;
        return this;
    };

    RegistrationDetails.prototype.getTo = function() {
        return this.to;
    };

    RegistrationDetails.prototype.setTo = function(to) {
        this.to = to;
        return this;
    };

    RegistrationDetails.prototype.getRevision = function() {
        return this.revision;
    };

    RegistrationDetails.prototype.setRevision = function(revision) {
        this.revision = revision;
        return this;
    };

    RegistrationDetails.prototype.getReference = function() {
        return this.reference;
    };

    RegistrationDetails.prototype.setReference = function(reference) {
        this.reference = reference;
        return this;
    };

    RegistrationDetails.prototype.getStatus = function() {
        return this.status;
    };

    RegistrationDetails.prototype.setStatus = function(status) {
        this.status = status;
        return this;
    };

    RegistrationDetails.prototype.getStatusVO = function() {
        return this.statusVO;
    };

    RegistrationDetails.prototype.setStatusVO = function(statusVO) {
        this.statusVO = statusVO;
        return this;
    };

    RegistrationDetails.prototype.getLocation = function() {
        return this.location;
    };

    RegistrationDetails.prototype.setLocation = function(location) {
        this.location = location;
        return this;
    };

    RegistrationDetails.prototype.isQuickRegister = function() {
        return this.quickRegister;
    };

    RegistrationDetails.prototype.setQuickRegister = function(quickRegister) {
        this.quickRegister = quickRegister;
        return this;
    };

    RegistrationDetails.prototype.getMetaDataCollection = function() {
        return this.metaDataCollection;
    };

    RegistrationDetails.prototype.addMetaData = function(metaData) {
        this.metaDataCollection.push(metaData);
        return this;
    };

    return RegistrationDetails;
});
},
'api/contact/parser/Contact':function(){
define([
    "../data/Contact"
], function(ContactVO) {
    var Contact = function() {
    };

    Contact.prototype.parse = function(item) {
        var c = new ContactVO();

        c.setContactPK(item.contactPK || null);
        c.setPersonPK(item.personPK || null);
        c.setBranchOfficePK(item.branchOfficePK || null);
        c.setBranchOfficeEmailPK(item.branchOfficeEmailPK || null);
        c.setName(item.name || null);
        c.setPreferredName(item.preferredName || null);
        c.setEmail(item.email || null);
        c.setOrganisation(item.organisation || null);
        c.setOrganisationPreferredName(item.organisationPreferredName || null);
        c.setOrganisationPK(item.organisationPK || null);
        c.setPersonType(item.personType || null);
        c.setJobTitle(item.jobTitle || null);
        c.setIsBranchOffice(item.isBranchOffice || false);
        c.setIsSc(item.isSc || false);
        c.setIsExternal(item.isExternal || false);
        c.setImageUrl(item.imageUrl || null);

        return c;
    };

    return Contact;
});
},
'api/mail/parser/Body':function(){
define([
    '../data/Body',
    './Header'
], function(
    BodyData,
    HeaderParser
) {
    const TYPE_MESSAGE = 'message';
    const SUBTYPE_RFC822 = 'rfc822';

    const Body = function() {
        this.headerParser = new HeaderParser();

        this._objectToBody = function(object) {
            return (new BodyData())
                .setContentId(object.hasOwnProperty('contentId') ? object.contentId : null)
                .setData(object.data || null)
                .setSubType(object.subType || null)
                .setType(object.type || null)
                .setDisposition(object.hasOwnProperty('disposition') ? object.disposition : null)
                .setFileName(object.hasOwnProperty('fileName') ? object.fileName : null)
                .setEncoding(object.encoding || null)
                .setMd5(object.md5 || null);
        };
    };

    Body.prototype.parse = function(object) {
        const b = this._objectToBody(object);

        if (object.subBodies) {
            object.subBodies.forEach(function(body) {
                b.addSubBody(this.parse(body));
            }, this);
        }

        if (b.getType() === TYPE_MESSAGE && b.getSubType() === SUBTYPE_RFC822) {
            b.setHeader(this.headerParser.parse(object.header));
        }

        return b;
    };

    return Body;
});
},
'api/mail/data/Body':function(){
define([], function() {
    const Body = function() {
        this.contentId = null;
        this.data = null;
        this.subType = null;
        this.type = null;
        this.disposition = null;
        this.fileName = null;
        this.encoding = null;
        this.md5 = null;
        this.subBodies = [];
        this.header = null;
    };

    Body.prototype.getContentId = function() {
        return this.contentId;
    };

    Body.prototype.setContentId = function(contentId) {
        this.contentId = contentId;
        return this;
    };

    Body.prototype.getData = function() {
        return this.data;
    };

    Body.prototype.setData = function(data) {
        this.data = data;
        return this;
    };

    Body.prototype.getSubType = function() {
        return this.subType;
    };

    Body.prototype.setSubType = function(subType) {
        this.subType = subType;
        return this;
    };

    Body.prototype.getType = function() {
        return this.type;
    };

    Body.prototype.setType = function(type) {
        this.type = type;
        return this;
    };

    Body.prototype.getDisposition = function() {
        return this.disposition;
    };

    Body.prototype.setDisposition = function(disposition) {
        this.disposition = disposition;
        return this;
    };

    Body.prototype.getFileName = function() {
        return this.fileName;
    };

    Body.prototype.setFileName = function(fileName) {
        this.fileName = fileName;
        return this;
    };

    Body.prototype.getEncoding = function() {
        return this.encoding;
    };

    Body.prototype.setEncoding = function(encoding) {
        this.encoding = encoding;
        return this;
    };

    Body.prototype.getMd5 = function() {
        return this.md5;
    };

    Body.prototype.setMd5 = function(md5) {
        this.md5 = md5;
        return this;
    };

    Body.prototype.getSubBodies = function() {
        return this.subBodies;
    };

    Body.prototype.addSubBody = function(body) {
        this.subBodies.push(body);
        return this;
    };

    Body.prototype.getHeader = function() {
        return this.header;
    };

    Body.prototype.setHeader = function(header) {
        this.header = header;
        return this;
    };

    return Body;
});
},
'api/mail/parser/Header':function(){
define([
    '../data/Header',
    './MessageContact'
], function(HeaderData, MessageContactParser) {
    const Header = function() {
        this.messageContactParser = new MessageContactParser();

        this._createMessageContactData = function(contacts) {
            const array = [];

            if (contacts instanceof Array) {
                for (let i = 0; i < contacts.length; i++) {
                    array.push(this.createMessageContactDataFromString(contacts[i]));
                }
            } else {
                array.push(this.createMessageContactDataFromString(contacts));
            }

            return array;
        };

        this.createMessageContactDataFromString = function(contactString) {
            return this.messageContactParser.parse(contactString);
        };
    };

    Header.prototype.parse = function(item) {
        let fromArray = [];
        if (item.from) {
            fromArray = this._createMessageContactData(item.from);
        }

        let toArray = [];
        if (item.to) {
            toArray = this._createMessageContactData(item.to);
        }

        let ccArray = [];
        if (item.cc) {
            ccArray = this._createMessageContactData(item.cc);
        }

        let bccArray = [];
        if (item.bcc) {
            bccArray = this._createMessageContactData(item.bcc);
        }

        let replyToArray = [];
        if (item.replyTo) {
            replyToArray = this._createMessageContactData(item.replyTo);
        }

        const h = new HeaderData();
        h.setUid(item.uid || null);
        h.setFolderId(item.folderId || null);
        h.setFromRegistered(item.isFromRegistered || false);
        h.setFromClient(item.isFromClient || false);
        h.setSnippet(item.snippet || '');
        h.setSubject(item.subject || '');
        h.setDate(item.date ? new Date(item.date) : null);
        h.setIsRead(item.isRead || false);
        h.setIsAnswered(item.isAnswered || false);
        h.setIsFlagged(item.isFlagged || false);
        h.setHasAttachments(item.hasAttachments || false);
        h.setProjectStagePK(item.projectStagePK || null);
        h.setProjectStage(item.projectStage || null);
        h.setProjectStageNumber(item.projectStageNumber || null);
        h.setRegistrarPersonPK(item.registrarPersonPK || null);
        h.setRegistrarPersonDisplayName(item.registrarPersonDisplayName || null);
        h.setGuid(item.guid || null);
        h.setInReplyTo(item.inReplyTo || null);
        h.setMessageID(item.messageID || null);
        h.setFrom(fromArray);
        h.setTo(toArray);
        h.setCc(ccArray);
        h.setBcc(bccArray);
        h.setReplyTo(replyToArray);

        return h;
    };

    return Header;
});
},
'api/mail/data/Header':function(){
define([], function() {
    const Header = function() {
        this.uid = null;
        this.folderId = null;
        this.fromRegistered = false;
        this.fromClient = false;
        this.snippet = '';
        this.subject = '';
        this.date = null;
        this.messageIsRead = false;
        this.messageIsAnswered = false;
        this.messageIsFlagged = false;
        this.messageHasAttachments = false;
        this.projectStagePK = null;
        this.projectStage = null;
        this.projectStageNumber = null;
        this.registrarPersonPK = null;
        this.registrarPersonDisplayName = null;
        this.guid = null;
        this.inReplyTo = null;
        this.messageID = null;
        this.from = [];
        this.to = [];
        this.cc = [];
        this.bcc = [];
        this.replyTo = [];
    };

    Header.prototype.getUid = function() {
        return this.uid;
    };

    Header.prototype.setUid = function(uid) {
        this.uid = uid;
        return this;
    };

    Header.prototype.getFolderId = function() {
        return this.folderId;
    };

    Header.prototype.setFolderId = function(folderId) {
        this.folderId = folderId;
        return this;
    };

    Header.prototype.isFromRegistered = function() {
        return this.fromRegistered;
    };

    Header.prototype.setFromRegistered = function(fromRegistered) {
        this.fromRegistered = fromRegistered;
        return this;
    };

    Header.prototype.isFromClient = function() {
        return this.fromClient;
    };

    Header.prototype.setFromClient = function(fromClient) {
        this.fromClient = fromClient;
        return this;
    };

    Header.prototype.getSnippet = function() {
        return this.snippet;
    };

    Header.prototype.setSnippet = function(snippet) {
        this.snippet = snippet;
        return this;
    };

    Header.prototype.getSubject = function() {
        return this.subject;
    };

    Header.prototype.setSubject = function(subject) {
        this.subject = subject;
        return this;
    };

    Header.prototype.getDate = function() {
        return this.date;
    };

    Header.prototype.setDate = function(date) {
        this.date = date;
        return this;
    };

    Header.prototype.isRead = function() {
        return this.messageIsRead;
    };

    Header.prototype.setIsRead = function(isRead) {
        this.messageIsRead = isRead;
        return this;
    };

    Header.prototype.isAnswered = function() {
        return this.messageIsAnswered;
    };

    Header.prototype.setIsAnswered = function(isAnswered) {
        this.messageIsAnswered = isAnswered;
        return this;
    };

    Header.prototype.isFlagged = function() {
        return this.messageIsFlagged;
    };

    Header.prototype.setIsFlagged = function(isFlagged) {
        this.messageIsFlagged = isFlagged;
        return this;
    };

    Header.prototype.hasAttachments = function() {
        return this.messageHasAttachments;
    };

    Header.prototype.setHasAttachments = function(hasAttachments) {
        this.messageHasAttachments = hasAttachments;
        return this;
    };

    Header.prototype.getProjectStagePK = function() {
        return this.projectStagePK;
    };

    Header.prototype.setProjectStagePK = function(projectStagePK) {
        this.projectStagePK = projectStagePK;
        return this;
    };

    Header.prototype.getProjectStage = function() {
        return this.projectStage;
    };

    Header.prototype.setProjectStage = function(projectStage) {
        this.projectStage = projectStage;
        return this;
    };

    Header.prototype.getProjectStageNumber = function() {
        return this.projectStageNumber;
    };

    Header.prototype.setProjectStageNumber = function(projectStageNumber) {
        this.projectStageNumber = projectStageNumber;
        return this;
    };

    Header.prototype.getRegistrarPersonPK = function() {
        return this.registrarPersonPK;
    };

    Header.prototype.setRegistrarPersonPK = function(registrarPersonPK) {
        this.registrarPersonPK = registrarPersonPK;
        return this;
    };

    Header.prototype.getRegistrarPersonDisplayName = function() {
        return this.registrarPersonDisplayName;
    };

    Header.prototype.setRegistrarPersonDisplayName = function(registrarPersonDisplayName) {
        this.registrarPersonDisplayName = registrarPersonDisplayName;
        return this;
    };

    Header.prototype.getGuid = function() {
        return this.guid;
    };

    Header.prototype.setGuid = function(guid) {
        this.guid = guid;
        return this;
    };

    Header.prototype.getInReplyTo = function() {
        return this.inReplyTo;
    };

    Header.prototype.setInReplyTo = function(inReplyTo) {
        this.inReplyTo = inReplyTo;
        return this;
    };

    Header.prototype.getMessageID = function() {
        return this.messageID;
    };

    Header.prototype.setMessageID = function(messageID) {
        this.messageID = messageID;
        return this;
    };

    Header.prototype.getFrom = function() {
        return this.from;
    };

    Header.prototype.setFrom = function(from) {
        this.from = from;
        return this;
    };

    Header.prototype.getTo = function() {
        return this.to;
    };

    Header.prototype.setTo = function(to) {
        this.to = to;
        return this;
    };

    Header.prototype.getCc = function() {
        return this.cc;
    };

    Header.prototype.setCc = function(cc) {
        this.cc = cc;
        return this;
    };

    Header.prototype.getBcc = function() {
        return this.bcc;
    };

    Header.prototype.setBcc = function(bcc) {
        this.bcc = bcc;
        return this;
    };

    Header.prototype.getReplyTo = function() {
        return this.replyTo;
    };

    Header.prototype.setReplyTo = function(replyTo) {
        this.replyTo = replyTo;
        return this;
    };

    return Header;
});
},
'api/mail/parser/MessageContact':function(){
define([
    "../data/Message",
    "../data/MessageContact"
], function(MessageVO, MessageContactVO) {
    const CONTACT_REG_EXP = /"(.*)"\s<(.+)>/;
    const VALUE_NULL = 'null';

    const MessageContact = function() {
        this._createMessageContactVOFromString = function(contactString) {
            const mc = new MessageContactVO();

            const match = contactString.match(CONTACT_REG_EXP);

            if (match) {
                mc.setName(match[1] !== VALUE_NULL ? match[1] : null);
                mc.setAddress(match[2]);
            } else {
                mc.setAddress(contactString);
            }

            return mc;
        };
    };

    MessageContact.prototype.parse = function(contactString) {
        return this._createMessageContactVOFromString(contactString);
    };

    return MessageContact;
});
},
'api/mail/data/Message':function(){
define([
    './Header'
], function(Header) {
    /**
     * Deprecated, use Header instead.
     */

    return Header;
});
},
'api/mail/data/MessageContact':function(){
define([], function() {
    const MessageContact = function() {
        this.name = null;
        this.address = null;
    };

    MessageContact.prototype.getName = function() {
        return this.name;
    };

    MessageContact.prototype.setName = function(name) {
        this.name = name;
        return this;
    };

    MessageContact.prototype.getAddress = function() {
        return this.address;
    };

    MessageContact.prototype.setAddress = function(address) {
        this.address = address;
        return this;
    };

    return MessageContact;
});
},
'api/mail/parser/Draft':function(){
define([
    "../data/Draft",
    "../data/MessageContact"
], function(DraftVO, MessageContactVO) {
    var Draft = function() {
        this.constants = {
            CONTACT_REG_EXP: /".*"\s<.*>/,
            CONTACT_SEPARATOR: /\s</,
            CONTACT_NAME_QUOTE: /"/g,
            CONTACT_ADDRESS_SUFFIX: />/g,
            FOLDER_ID: 'INBOX.Drafts'
        };

        this.createMessageContactVOs = function(contacts) {
            var array = [];

            if (contacts instanceof Array) {
                for (var i = 0; i < contacts.length; i++) {
                    array.push(this.createMessageContactVOFromString(contacts[i]));
                }
            } else {
                array.push(this.createMessageContactVOFromString(contacts));
            }

            return array;
        };

        this.createMessageContactVOFromString = function(contactString) {
            var mc = new MessageContactVO();

            if (contactString.match(this.constants.CONTACT_REG_EXP)) {
                var c = contactString.split(this.constants.CONTACT_SEPARATOR);
                mc.setName(c[0].replace(this.constants.CONTACT_NAME_QUOTE, ""));
                mc.setAddress(c[1].replace(this.constants.CONTACT_ADDRESS_SUFFIX, ""));
            } else {
                mc.setAddress(contactString);
            }

            return mc;
        };

        this.parseDateString = function(/** HH:mm dd/MM/yyyy */ dateString) {
            var timeAndDate = dateString.split(' ');
            var time = timeAndDate[0].split(':');
            var date = timeAndDate[1].split('/');

            /** year, month, day, hours, minutes, seconds */
            return new Date(date[2], date[1] - 1, date[0], time[0], time[1], 0);
        };
    };

    Draft.prototype.parse = function(item) {
        var toArray = [];
        if (item.to) {
            toArray = this.createMessageContactVOs(item.to);
        }

        var ccArray = [];
        if (item.cc) {
            ccArray = this.createMessageContactVOs(item.cc);
        }

        var bccArray = [];
        if (item.bcc) {
            bccArray = this.createMessageContactVOs(item.bcc);
        }

        var d = new DraftVO();
        d.setUid(item.uid || null);
        d.setFolderId(this.constants.FOLDER_ID);
        d.setInReplyTo(item.inReplyTo || null);
        d.setSnippet(item.snippet || null);
        d.setSubject(item.subject || null);
        d.setDate(item.date ? this.parseDateString(item.date) : null);
        d.setProjectStagePK(item.projectStagePK || null);
        d.setProjectStage(item.projectStage || null);
        d.setProjectStageNumber(item.projectStageNumber || null);
        d.setHasAttachments(item.hasAttachments || false);
        d.setDraftId(item.draftid || null);
        d.setFromAddress(item.fromAddress || null);
        d.setFromName(item.fromName || null);
        d.setInReplyTo(item.inReplyTo || null);
        d.setInReplyToDate(item.inReplyToDate ? new Date(item.inReplyToDate) : null);
        d.setTo(toArray);
        d.setCc(ccArray);
        d.setBcc(bccArray);

        return d;
    };

    return Draft;
});
},
'api/mail/data/Draft':function(){
define([], function() {
    var Draft = function() {
        this.uid = null;
        this.folderId = null;
        this.inReplyTo = null;
        this.inReplyToDate = null;
        this.inReplyToFolderId = null;
        this.inReplyToUid = null;
        this.snippet = null;
        this.subject = null;
        this.date = null;
        this.projectStagePK = null;
        this.projectStage = null;
        this.projectStageNumber = null;
        this.private = false;
        this.draftHasAttachments = false;
        this.draftId = null;
        this.fromAddress = null;
        this.fromName = null;
        this.to = [];
        this.toGroups = [];
        this.toMyGroups = [];
        this.cc = [];
        this.ccGroups = [];
        this.ccMyGroups = [];
        this.bcc = [];
        this.md5s = [];
        this.attachments = [];
        this.files = [];
        this.revisionPKs = [];
    };

    Draft.prototype.getUid = function() {
        return this.uid;
    };

    Draft.prototype.setUid = function(uid) {
        this.uid = uid;
    };

    Draft.prototype.getFolderId = function() {
        return this.folderId;
    };

    Draft.prototype.setFolderId = function(folderId) {
        this.folderId = folderId;
    };

    Draft.prototype.setInReplyTo = function(inReplyTo) {
        this.inReplyTo = inReplyTo;
    };

    Draft.prototype.getInReplyTo = function() {
        return this.inReplyTo;
    };

    Draft.prototype.setInReplyToDate = function(inReplyToDate) {
        this.inReplyToDate = inReplyToDate;
    };

    Draft.prototype.getInReplyToDate = function() {
        return this.inReplyToDate;
    };

    Draft.prototype.setInReplyToFolderId = function(inReplyToFolderId) {
        this.inReplyToFolderId = inReplyToFolderId;
    };

    Draft.prototype.getInReplyToFolderId = function() {
        return this.inReplyToFolderId;
    };

    Draft.prototype.setInReplyToUid = function(inReplyToUid) {
        this.inReplyToUid = inReplyToUid;
    };

    Draft.prototype.getInReplyToUid = function() {
        return this.inReplyToUid;
    };

    Draft.prototype.getSnippet = function() {
        return this.snippet;
    };

    Draft.prototype.setSnippet = function(snippet) {
        this.snippet = snippet;
    };

    Draft.prototype.getSubject = function() {
        return this.subject;
    };

    Draft.prototype.setSubject = function(subject) {
        this.subject = subject;
    };

    Draft.prototype.getDate = function() {
        return this.date;
    };

    Draft.prototype.setDate = function(date) {
        this.date = date;
    };

    Draft.prototype.getProjectStagePK = function() {
        return this.projectStagePK;
    };

    Draft.prototype.setProjectStagePK = function(projectStagePK) {
        this.projectStagePK = projectStagePK;
    };

    Draft.prototype.getProjectStage = function() {
        return this.projectStage;
    };

    Draft.prototype.setProjectStage = function(projectStage) {
        this.projectStage = projectStage;
    };

    Draft.prototype.getProjectStageNumber = function() {
        return this.projectStageNumber;
    };

    Draft.prototype.setProjectStageNumber = function(projectStageNumber) {
        this.projectStageNumber = projectStageNumber;
    };

    Draft.prototype.isPrivate = function() {
        return this.private;
    };

    Draft.prototype.setPrivate = function(isPrivate) {
        this.private = isPrivate;
    };

    Draft.prototype.hasAttachments = function() {
        return this.draftHasAttachments;
    };

    Draft.prototype.setHasAttachments = function(hasAttachments) {
        this.draftHasAttachments = hasAttachments;
    };

    Draft.prototype.getDraftId = function() {
        return this.draftId;
    };

    Draft.prototype.setDraftId = function(draftId) {
        this.draftId = draftId;
    };

    Draft.prototype.getFromAddress = function() {
        return this.fromAddress;
    };

    Draft.prototype.setFromAddress = function(fromAddress) {
        this.fromAddress = fromAddress;
    };

    Draft.prototype.getFromName = function() {
        return this.fromName;
    };

    Draft.prototype.setFromName = function(fromName) {
        this.fromName = fromName;
    };

    Draft.prototype.getTo = function() {
        return this.to;
    };

    Draft.prototype.setTo = function(to) {
        this.to = to;
    };

    Draft.prototype.addTo = function(messageContactVO) {
        this.to.push(messageContactVO);
    };

    Draft.prototype.getToGroups = function() {
        return this.toGroups;
    };

    Draft.prototype.setToGroups = function(toGroups) {
        this.toGroups = toGroups;
    };

    Draft.prototype.addToGroup = function(toGroup) {
        this.toGroups.push(toGroup);
    };

    Draft.prototype.getToMyGroups = function() {
        return this.toMyGroups;
    };

    Draft.prototype.setToMyGroups = function(toMyGroups) {
        this.toMyGroups = toMyGroups;
    };

    Draft.prototype.addToMyGroup = function(toMyGroup) {
        this.toMyGroups.push(toMyGroup);
    };

    Draft.prototype.getCc = function() {
        return this.cc;
    };

    Draft.prototype.setCc = function(cc) {
        this.cc = cc;
    };

    Draft.prototype.addCc = function(messageContactVO) {
        this.cc.push(messageContactVO);
    };

    Draft.prototype.getCcGroups = function() {
        return this.ccGroups;
    };

    Draft.prototype.setCcGroups = function(ccGroups) {
        this.ccGroups = ccGroups;
    };

    Draft.prototype.addCcGroup = function(ccGroup) {
        this.ccGroups.push(ccGroup);
    };

    Draft.prototype.getCcMyGroups = function() {
        return this.ccMyGroups;
    };

    Draft.prototype.setCcMyGroups = function(ccMyGroups) {
        this.ccMyGroups = ccMyGroups;
    };

    Draft.prototype.addCcMyGroup = function(ccMyGroup) {
        this.ccMyGroups.push(ccMyGroup);
    };

    Draft.prototype.getBcc = function() {
        return this.bcc;
    };

    Draft.prototype.setBcc = function(bcc) {
        this.bcc = bcc;
    };

    Draft.prototype.addBcc = function(messageContactVO) {
        this.bcc.push(messageContactVO);
    };

    Draft.prototype.setAttachments = function(attachments) {
        this.attachments = attachments;
    };

    Draft.prototype.getAttachments = function() {
        return this.attachments;
    };

    Draft.prototype.addAttachment = function(attachment) {
        this.attachments.push(attachment);
    };

    Draft.prototype.setMd5s = function(md5s) {
        this.md5s = md5s;
    };

    Draft.prototype.getMd5s = function() {
        return this.md5s;
    };

    Draft.prototype.addMd5 = function(md5) {
        this.md5s.push(md5);
    };

    Draft.prototype.setFiles = function(files) {
        this.files = files;
    };

    Draft.prototype.getFiles = function() {
        return this.files;
    };

    Draft.prototype.addFile = function(file) {
        this.files.push(file);
    };

    Draft.prototype.setRevisionPKs = function(revisionPKs) {
        this.revisionPKs = revisionPKs;
    };

    Draft.prototype.getRevisionPKs = function() {
        return this.revisionPKs;
    };

    Draft.prototype.addRevisionPK = function(revisionPK) {
        this.revisionPKs.push(revisionPK);
    };

    return Draft;
});
},
'api/mail/parser/Filter':function(){
define([
    "../data/Filter"
], function(FilterVO) {
    var Filter = function() {
    };

    Filter.prototype.parse = function(item) {
        var f = new FilterVO();
        f.setId(parseInt(item.id));
        f.setPriority(parseInt(item.priority));
        f.setFilter(item.filter);
        f.setLanguageVersion(parseFloat(item.languageVersion));

        return f;
    };

    return Filter;
});
},
'api/mail/data/Filter':function(){
define([], function() {
    const Filter = function() {
        this.id = null;
        this.priority = null;
        this.filter = null;
        this.languageVersion = null;
    };

    Filter.prototype.getId = function() {
        return this.id;
    };

    Filter.prototype.setId = function(id) {
        this.id = id;
        return this;
    };

    Filter.prototype.getPriority = function() {
        return this.priority;
    };

    Filter.prototype.setPriority = function(priority) {
        this.priority = priority;
        return this;
    };

    Filter.prototype.getFilter = function() {
        return this.filter;
    };

    Filter.prototype.setFilter = function(filter) {
        this.filter = filter;
        return this;
    };

    Filter.prototype.getLanguageVersion = function() {
        return this.languageVersion;
    };

    Filter.prototype.setLanguageVersion = function(languageVersion) {
        this.languageVersion = languageVersion;
        return this;
    };

    return Filter;
});
},
'api/mail/parser/Folder':function(){
define([
    "../data/Folder"
], function(FolderVO) {
    var Folder = function() {
    };

    Folder.prototype.parse = function(item) {
        var f = new FolderVO();
        f.setFolderId(item.folderId || null);
        f.setName(item.name || null);
        f.setParentFolderId(item.parentFolderId || null);
        f.setIsSubscribed(item.isSubscribed || false);
        f.setMessageCount(item.messageCount != undefined ? item.messageCount : null);
        f.setUnseenMessageCount(item.unseenMessageCount != undefined ? item.unseenMessageCount : null);

        return f;
    };

    return Folder;
});
},
'api/mail/data/Folder':function(){
define([], function() {
    const Folder = function() {
        this.folderId = null;
        this.name = null;
        this.parentFolderId = null;
        this.folderSubscribed = false;
        this.messageCount = null;
        this.unseenMessageCount = null;
    };

    Folder.prototype.getFolderId = function() {
        return this.folderId;
    };

    Folder.prototype.setFolderId = function(folderId) {
        this.folderId = folderId;
        return this;
    };

    Folder.prototype.getName = function() {
        return this.name;
    };

    Folder.prototype.setName = function(name) {
        this.name = name;
        return this;
    };

    Folder.prototype.getParentFolderId = function() {
        return this.parentFolderId;
    };

    Folder.prototype.setParentFolderId = function(parentFolderId) {
        this.parentFolderId = parentFolderId;
        return this;
    };

    Folder.prototype.isSubscribed = function() {
        return this.folderSubscribed;
    };

    Folder.prototype.setIsSubscribed = function(isSubscribed) {
        this.folderSubscribed = isSubscribed;
        return this;
    };

    Folder.prototype.getMessageCount = function() {
        return this.messageCount;
    };

    Folder.prototype.setMessageCount = function(messageCount) {
        this.messageCount = messageCount;
        return this;
    };

    Folder.prototype.getUnseenMessageCount = function() {
        return this.unseenMessageCount;
    };

    Folder.prototype.setUnseenMessageCount = function(unseenMessageCount) {
        this.unseenMessageCount = unseenMessageCount;
        return this;
    };

    return Folder;
});
},
'api/mail/parser/Mailbox':function(){
define([
    '../data/Mailbox'
], function(MailboxVO) {
    const Mailbox = function() {};

    Mailbox.prototype.parse = function(item) {
        const mb = new MailboxVO();
        mb.setMailboxId(item.mailboxId || null);
        mb.setName(item.name || null);
        mb.setEmail(item.email || null);
        mb.setIsSubscribed(item.isSubscribed || false);
        
        return mb;
    };

    return Mailbox;
});
},
'api/mail/data/Mailbox':function(){
define([], function() {
    const Mailbox = function() {
        this.mailboxId = null;
        this.name = null;
        this.email = null;
        this.isSubscribedValue = false;
    };

    Mailbox.prototype.getMailboxId = function() {
        return this.mailboxId;
    };

    Mailbox.prototype.setMailboxId = function(mailboxId) {
        this.mailboxId = mailboxId;
        return this;
    };

    Mailbox.prototype.getName = function() {
        return this.name;
    };

    Mailbox.prototype.setName = function(name) {
        this.name = name;
        return this;
    };

    Mailbox.prototype.getEmail = function() {
        return this.email;
    };

    Mailbox.prototype.setEmail = function(email) {
        this.email = email;
        return this;
    };

    Mailbox.prototype.isSubscribed = function() {
        return this.isSubscribedValue;
    };

    Mailbox.prototype.setIsSubscribed = function(isSubscribed) {
        this.isSubscribedValue = isSubscribed;
        return this;
    };

    return Mailbox;
});
},
'api/mail/parser/Message':function(){
define([
    '../data/Message',
    './MessageContact'
], function(MessageVO, MessageContactParser) {
    var Message = function() {
        this.constants = {
            NULL: 'null'
        };
        this.messageContactParser = new MessageContactParser();

        this._createMessageContactVOs = function(contacts) {
            var array = [];

            if (contacts instanceof Array) {
                for (var i = 0; i < contacts.length; i++) {
                    array.push(this._createMessageContactVOFromString(contacts[i]));
                }
            } else {
                array.push(this._createMessageContactVOFromString(contacts));
            }

            return array;
        };

        this._createMessageContactVOFromString = function(contactString) {
            return this.messageContactParser.parse(contactString);
        };

        this._parseDateString = function(/** HH:mm dd/MM/yyyy */ dateString) {
            var timeAndDate = dateString.split(' ');
            var time = timeAndDate[0].split(':');
            var date = timeAndDate[1].split('/');

            /** year, month, day, hours, minutes, seconds */
            return new Date(date[2], date[1] - 1, date[0], time[0], time[1], 0);
        };
    };

    Message.prototype.parse = function(item) {
        var fromArray = [];
        if (item.from) {
            fromArray = this._createMessageContactVOs(item.from);
        }

        var toArray = [];
        if (item.to) {
            toArray = this._createMessageContactVOs(item.to);
        }

        var ccArray = [];
        if (item.cc) {
            ccArray = this._createMessageContactVOs(item.cc);
        }

        var bccArray = [];
        if (item.bcc) {
            bccArray = this._createMessageContactVOs(item.bcc);
        }

        var replyToArray = [];
        if (item.replyTo) {
            replyToArray = this._createMessageContactVOs(item.replyTo);
        }

        var m = new MessageVO();
        m.setUid(item.uid || null);
        m.setFolderId(item.folderId || null);
        m.setFromRegistered(item.isFromRegistered || false);
        m.setFromClient(item.isFromClient || false);
        m.setSnippet(item.snippet || '');
        m.setSubject(item.subject || '');
        m.setDate(item.date ? this._parseDateString(item.date) : null);
        m.setIsRead(item.isRead || false);
        m.setIsAnswered(item.isAnswered || false);
        m.setIsFlagged(item.isFlagged || false);
        m.setHasAttachments(item.hasAttachments || false);
        m.setProjectStagePK(item.projectStagePK || null);
        m.setProjectStage(item.projectStage || null);
        m.setProjectStageNumber(item.projectStageNumber || null);
        m.setRegistrarPersonPK(item.registrarPersonPK || null);
        m.setRegistrarPersonDisplayName(item.registrarPersonDisplayName || null);
        m.setGuid(item.guid || null);
        m.setInReplyTo(item.inReplyTo || null);
        m.setMessageID(item.messageID || null);
        m.setFrom(fromArray);
        m.setTo(toArray);
        m.setCc(ccArray);
        m.setBcc(bccArray);
        m.setReplyTo(replyToArray);

        return m;
    };

    return Message;
});
},
'api/mail/parser/Sibling':function(){
define([
    "../data/Sibling"
], function(SiblingVO) {
    var Sibling = function() {};

    Sibling.prototype.parse = function(item) {
        var s = new SiblingVO();
        s.setPreviousUid(item.previousUid ? parseInt(item.previousUid) : null);
        s.setCurrentUid(item.currentUid ? parseInt(item.currentUid) : null);
        s.setNextUid(item.nextUid ? parseInt(item.nextUid) : null);

        return s;
    };

    return Sibling;
});
},
'api/mail/data/Sibling':function(){
define([], function() {
    var Sibling = function() {
        this.previousUid = null;
        this.currentUid = null;
        this.nextUid = null;
    };

    Sibling.prototype.getPreviousUid = function() {
        return this.previousUid;
    };

    Sibling.prototype.setPreviousUid = function(previousUid) {
        this.previousUid = previousUid;
    };

    Sibling.prototype.getCurrentUid = function() {
        return this.currentUid;
    };

    Sibling.prototype.setCurrentUid = function(currentUid) {
        this.currentUid = currentUid;
    };

    Sibling.prototype.getNextUid = function() {
        return this.nextUid;
    };

    Sibling.prototype.setNextUid = function(nextUid) {
        this.nextUid = nextUid;
    };

    return Sibling;
});
},
'api/mail/parser/Thread':function(){
define([
    '@lib/email/data/Thread'
], function(ThreadData) {
    const ERROR_THREAD_ROOT_MISSING = 'Thread root missing';
    const THREAD_INDEX_START = '0';

    const Thread = function(collectionParser, headerParser) {
        this.collectionParser = collectionParser;
        this.headerParser = headerParser;

        this._convertItemsToAssocHeaderArray = function(items) {
            const headers = {};
            for(let i = 0; i < items.length; i++) {
                if (items.hasOwnProperty(i)) {
                    headers[items[i].threadIndex] = this.headerParser.parse(items[i]);
                }
            }
            return headers;
        };

        this._createRegExpForIndex = function(index) {
            return new RegExp('^' + index + '(.[0-9]+)?$');
        };

        this._parseHeaders = function(headers, index) {
            if (!headers.hasOwnProperty(index)) {
                throw ERROR_THREAD_ROOT_MISSING;
            }

            const re = this._createRegExpForIndex(index);

            const tc = [];
            for(let i in headers) {
                if (
                    headers.hasOwnProperty(i) &&
                    index !== i &&
                    re.test(i)
                ) {
                    tc.push(this._parseHeaders(headers, i));
                }
            }

            return new ThreadData(
                headers[index],
                tc
            );
        };
    };

    Thread.prototype.parse = function(content) {
        const items = this.collectionParser.parse(content);

        if (!items.length) {
            return new ThreadData();
        }

        return this._parseHeaders(this._convertItemsToAssocHeaderArray(items), THREAD_INDEX_START);
    };

    return Thread;
});
},
'@lib/email/data/Thread':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Thread {
        constructor(header, threadCollection = []) {
            this.header = header;
            this.threadCollection = threadCollection;
        }
        getHeader() {
            return this.header;
        }
        getThreadCollection() {
            return this.threadCollection;
        }
    }
    return Thread;
});

},
'api/mail/Attachment':function(){
define([], function() {
    var Attachment = function(url, urlConnection) {
        this.url = url;
        this.urlConnection = urlConnection;

        this.attachmentVO = null;
        this.messageVO = null;
        this.folderId = null;

        this.constants = {
            URL_PARAM_FOLDER_ID: "folderId",
            URL_PARAM_MESSAGE_ID: "messageId"
        };

        this.createBasicQuery = function() {
            var q = {};

            q[this.constants.URL_PARAM_MESSAGE_ID] = this.messageVO.getUid();

            if (this.folderId) {
                q[this.constants.URL_PARAM_FOLDER_ID] = this.folderId;
            }

            return q;
        };
    };

    Attachment.prototype.setAttachmentVO = function(attachmentVO) {
        this.attachmentVO = attachmentVO;
    };

    Attachment.prototype.setMessageVO = function(messageVO) {
        this.messageVO = messageVO;
    };

    Attachment.prototype.changeFolder = function(folderId) {
        this.folderId = folderId;
    };

    Attachment.prototype.getData = function(handlers) {
        this.urlConnection.setUrl(this.url + this.attachmentVO.getMd5());
        this.urlConnection.setQuery(this.createBasicQuery());
        this.urlConnection.setSuccessHandler(handlers.getSuccess());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return Attachment;
});
},
'api/mail/draft/AttachmentCollection':function(){
define([], function() {
    return class AttachmentCollection {
        constructor(url, urlConnectionBuilder, parser, urlResponseProcessorBuilder) {
            this.url = url;
            this.urlConnectionBuilder = urlConnectionBuilder;
            this.parser = parser;
            this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        }

        fetch(handlers, uid) {
            const urlConnection = this.urlConnectionBuilder.build();

            urlConnection.setUrl(this.url.replace(':draftId', uid.toString()));
            urlConnection.setSuccessHandler(
                this.urlResponseProcessorBuilder.createProcessor(
                    this.parser,
                    handlers.getSuccess(),
                    handlers.getError()
                )
            );
            urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
            urlConnection.setProgressHandler(handlers.getProgress());
            urlConnection.setErrorHandler(handlers.getError());

            return urlConnection.get();
        };
    };
});
},
'api/mail/Draft':function(){
define([], function() {
    var Draft = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    Draft.prototype.get = function(handlers, uid) {
        this.urlConnection.setUrl(this.url + encodeURIComponent(uid));
        this.urlConnection.setQuery({'folderId': 'INBOX.Drafts'});

        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return Draft;
});
},
'api/mail/DraftAction':function(){
define([
    'spencer/date-time/Format'
], function(
    DateTimeFormatter
) {
    const PARAM_IN_REPLY_TO = 'inReplyTo';
    const PARAM_IN_REPLY_TO_DATE = 'inReplyToDate';
    const PARAM_TO = 'to';
    const PARAM_TO_MY_GROUPS = 'toMyGroups';
    const PARAM_TO_GROUPS = 'toGroups';
    const PARAM_CC = 'cc';
    const PARAM_CC_MY_GROUPS = 'ccMyGroups';
    const PARAM_CC_GROUPS = 'ccGroups';
    const PARAM_BODY = 'body';
    const PARAM_FROM_ADDRESS = 'fromAddress';
    const PARAM_FROM_NAME = 'fromName';
    const PARAM_SUBJECT = 'subject';
    const PARAM_PROJECT_STAGE = 'projectStage';
    const PARAM_PROJECT_STAGE_ID = 'projectStagePK';
    const PARAM_CONTACT_ADDRESS = 'address';
    const PARAM_CONTACT_NAME = 'name';
    const PARAM_ATTACHMENTS = 'attachments';
    const PARAM_ATTACHMENT_MD5 = 'md5';
    const PARAM_ATTACHMENT_REGISTRATION_DETAILS = 'attachmentRegistrationDetails';
    const PARAM_FILE_KEY = 'fileKey';
    const PARAM_FILE_REGISTRATION_DETAILS = 'fileRegistrationDetails';
    const PARAM_FILE_TREE_PK = 'projectStageTreeViewPK';
    const PARAM_REVISION_PK = 'revisionPK';

    const PARAM_REGISTRATION_DETAILS_DATE = 'date',
        PARAM_REGISTRATION_DETAILS_DISCIPLINE = 'discipline',
        PARAM_REGISTRATION_DETAILS_PERSON_PK = 'personPK',
        PARAM_REGISTRATION_DETAILS_OFFICE_PK = 'officePK',
        PARAM_REGISTRATION_DETAILS_PROJECT_STAGE_PK = 'projectStagePK',
        PARAM_REGISTRATION_DETAILS_REFERENCE = 'reference',
        PARAM_REGISTRATION_DETAILS_REVISION = 'revision',
        PARAM_REGISTRATION_DETAILS_STATUS = 'status',
        PARAM_REGISTRATION_DETAILS_TREE_VIEW_PK = 'treeViewPK',
        PARAM_REGISTRATION_DETAILS_TITLE = 'title',
        PARAM_REGISTRATION_DETAILS_TYPE = 'type',
        PARAM_REGISTRATION_DETAILS_NODE_REFERENCE = 'nodeReference',
        PARAM_REGISTRATION_DETAILS_ORIGINATOR_PERSON_PK = 'originatorPersonPK',
        PARAM_REGISTRATION_DETAILS_RECIPIENT_BRANCH_OFFICE_PK = 'recipientBranchOfficePK',
        PARAM_REGISTRATION_DETAILS_RECIPIENT_PERSON_PK = 'recipientPersonPK';

    const DraftAction = function(url, urlConnectionBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;

        this.dateTimeFormatter = new DateTimeFormatter();

        this.draftVO = null;

        this.createDataObject = function(draftVO, body) {
            const q = {};

            q[PARAM_IN_REPLY_TO] = draftVO.getInReplyTo();
            q[PARAM_FROM_ADDRESS] = draftVO.getFromAddress();
            q[PARAM_FROM_NAME] = draftVO.getFromName();
            q[PARAM_SUBJECT] = draftVO.getSubject();
            q[PARAM_PROJECT_STAGE] = draftVO.getProjectStage();
            q[PARAM_PROJECT_STAGE_ID] = draftVO.getProjectStagePK();
            q[PARAM_TO] = this.createJsonListFromContactVOs(draftVO.getTo());
            q[PARAM_TO_MY_GROUPS] = this.createListFromGroupContactVOs(draftVO.getToMyGroups());
            q[PARAM_TO_GROUPS] = this.createListFromGroupContactVOs(draftVO.getToGroups());
            q[PARAM_CC] = this.createJsonListFromContactVOs(draftVO.getCc());
            q[PARAM_CC_MY_GROUPS] = this.createListFromGroupContactVOs(draftVO.getCcMyGroups());
            q[PARAM_CC_GROUPS] = this.createListFromGroupContactVOs(draftVO.getCcGroups());
            q[PARAM_BODY] = body;
            q[PARAM_ATTACHMENTS] = draftVO.getAttachments().map((a) => a.getMd5());
            q[PARAM_ATTACHMENT_REGISTRATION_DETAILS] = this.createJsonListFromAttachments(draftVO.getAttachments());
            q[PARAM_FILE_KEY] = draftVO.getFiles().map((f) => f.getKey());
            q[PARAM_FILE_REGISTRATION_DETAILS] = this.createJsonListFromFiles(draftVO.getFiles());
            q[PARAM_REVISION_PK] = draftVO.getRevisionPKs();

            if (draftVO.getInReplyToDate()) {
                q[PARAM_IN_REPLY_TO_DATE] = this.dateTimeFormatter.toLocaleISOString(draftVO.getInReplyToDate());
            }

            return q;
        };

        this.createJsonListFromAttachments = function(attachments) {
            return attachments.map((attachment) => {
                let c = {};

                c[PARAM_ATTACHMENT_MD5] = attachment.getMd5();

                if (attachment.getRegistrationDetails()) {
                    Object.assign(c, this.parseRegistrationDetailsParams(attachment.getRegistrationDetails()));
                }

                return JSON.stringify(c);
            });
        };

        this.createJsonListFromFiles = function(files) {
            return files.map((file) => {
                let c = {};

                c[PARAM_FILE_KEY] = file.getKey();

                if (file.getRegistrationDetails()) {
                    Object.assign(c, this.parseRegistrationDetailsParams(file.getRegistrationDetails()));
                }

                return JSON.stringify(c);
            });
        };

        this.parseRegistrationDetailsParams = function(registrationDetails) {
            const params = {};

            if (registrationDetails.date) {
                params[PARAM_REGISTRATION_DETAILS_DATE] = registrationDetails.date;
            }

            if (registrationDetails.discipline) {
                params[PARAM_REGISTRATION_DETAILS_DISCIPLINE] = registrationDetails.discipline;
            }

            if (registrationDetails.personPK) {
                params[PARAM_REGISTRATION_DETAILS_PERSON_PK] = registrationDetails.personPK;
            }

            if (registrationDetails.branchOfficePK) {
                params[PARAM_REGISTRATION_DETAILS_OFFICE_PK] = registrationDetails.branchOfficePK;
            }

            if (registrationDetails.projectStagePK) {
                params[PARAM_REGISTRATION_DETAILS_PROJECT_STAGE_PK] = registrationDetails.projectStagePK;
            }

            if (registrationDetails.reference) {
                params[PARAM_REGISTRATION_DETAILS_REFERENCE] = registrationDetails.reference;
            }

            if (registrationDetails.revision) {
                params[PARAM_REGISTRATION_DETAILS_REVISION] = registrationDetails.revision;
            }

            if (registrationDetails.status) {
                params[PARAM_REGISTRATION_DETAILS_STATUS] = registrationDetails.status;
            }

            if (registrationDetails.treeViewPK) {
                params[PARAM_REGISTRATION_DETAILS_TREE_VIEW_PK] = registrationDetails.treeViewPK;
            }

            if (registrationDetails.title) {
                params[PARAM_REGISTRATION_DETAILS_TITLE] = registrationDetails.title;
            }

            if (registrationDetails.type) {
                params[PARAM_REGISTRATION_DETAILS_TYPE] = registrationDetails.type;
            }

            if (registrationDetails.nodeReference) {
                params[PARAM_REGISTRATION_DETAILS_NODE_REFERENCE] = registrationDetails.nodeReference;
            }

            if (registrationDetails.recipientContact) {
                if (registrationDetails.recipientContact.branchOfficePK) {
                    params[PARAM_REGISTRATION_DETAILS_RECIPIENT_BRANCH_OFFICE_PK] = registrationDetails.recipientContact.branchOfficePK;
                }

                if (registrationDetails.recipientContact.personPK) {
                    params[PARAM_REGISTRATION_DETAILS_RECIPIENT_PERSON_PK] = registrationDetails.recipientContact.personPK;
                }
            }

            if (registrationDetails.originatorContact) {
                params[PARAM_REGISTRATION_DETAILS_ORIGINATOR_PERSON_PK] = registrationDetails.originatorContact.personPK;
            }

            return params;
        }

        this.createJsonListFromContactVOs = function(messageContactVOs) {
            const l = [];

            if (messageContactVOs) {
                for (const i in messageContactVOs) {
                    if (messageContactVOs.hasOwnProperty(i)) {
                        const c = {};

                        c[PARAM_CONTACT_ADDRESS] = messageContactVOs[i].getAddress();
                        c[PARAM_CONTACT_NAME] =  messageContactVOs[i].getName();

                        l.push(JSON.stringify(c));
                    }
                }
            }

            return l;
        };

        this.createListFromGroupContactVOs = function(messageGroupContactVOs) {
            const l = [];

            if (messageGroupContactVOs) {
                for (const i in messageGroupContactVOs) {
                    if (messageGroupContactVOs.hasOwnProperty(i)) {
                        l.push(messageGroupContactVOs[i].getGroupId());
                    }
                }
            }

            return l;
        };

        this.createBasicUrlConnection = function(handlers) {
            const urlConnection = this.urlConnectionBuilder.build();
            urlConnection.setSuccessHandler(handlers.getSuccess());
            urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
            urlConnection.setProgressHandler(handlers.getProgress());
            urlConnection.setErrorHandler(handlers.getError());

            return urlConnection;
        };
    };

    DraftAction.prototype.setVO = function(draftVO) {
        this.draftVO = draftVO;
    };

    DraftAction.prototype.del = function(handlers) {
        const urlConnection = this.createBasicUrlConnection(handlers);
        urlConnection.setUrl(this.url + this.draftVO.getUid());

        return urlConnection.del();
    };

    DraftAction.prototype.save = function(handlers, body) {
        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setSuccessHandler(function(uid) {
            const successHandler = handlers.getSuccess();
            successHandler(parseInt(uid));
        });
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());
        urlConnection.setUrl(this.url);
        urlConnection.setData(this.createDataObject(this.draftVO, body));

        return urlConnection.put();
    };

    DraftAction.prototype.update = function(handlers, body) {
        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setSuccessHandler(function(uid) {
            const successHandler = handlers.getSuccess();
            successHandler(parseInt(uid));
        });
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());
        urlConnection.setUrl(this.url + this.draftVO.getUid());
        urlConnection.setData(this.createDataObject(this.draftVO, body));

        return urlConnection.put();
    };

    return DraftAction;
});
},
'spencer/date-time/Format':function(){
define([], function() {
    return class Format {
        secondsToHMS(seconds) {
            if (isNaN(seconds)) {
                throw new TypeError("Seconds must be a number");
            }

            if (seconds < 0) {
                throw new RangeError("Cannot format a negative value of seconds");
            }

            if (seconds >= 24 * 60 * 60) {
                throw new RangeError("Cannot format more than a days worth of seconds");
            }

            return new Date(seconds * 1000).toISOString()
                .substr(11, 8)            // hh:mm:ss
                .replace(/^(00:|0)/, ''); // 00:00:01 -> 00:01, 01:00:01 -> 1:00:01
        }

        toLocaleISOString(date) {
            return new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString();
        }

        toLongLocaleDateString(date) {
            return new Date(date).toLocaleDateString('en-GB', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
        }

        toYYYYMMDD(date) {
            return `${date.getFullYear()}-${('0' + (date.getMonth()+1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
        }

        toDDMMYY(date) {
            return `${('0' + date.getDate()).slice(-2)}/${('0' + (date.getMonth()+1)).slice(-2)}/${(date.getFullYear()).toString().slice(-2)}`;
        }
    }
});
},
'api/mail/DraftCollection':function(){
define([], function() {
    var DraftCollection = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.constants = {
            URL_PARAM_LIMIT: "limit",
            URL_PARAM_OFFSET: "offset",
            URL_PARAM_SORT_BY: "sortBy",
            URL_PARAM_SORT_DESCENDING: "sortDescending",
            SORT_BY_COLUMN_DATE: "arrival",
            SORT_BY_COLUMN_SUBJECT: "subject",
            SORT_BY_COLUMN_TO: "to",
            BOOLEAN_STRING_TRUE: "true",
            BOOLEAN_STRING_FALSE: "false"
        };

        this.url = url;
        this.urlConnection = urlConnection;
        this.parser = parser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.limit = 10;
        this.offset = 0;
        this.column = this.constants.SORT_BY_COLUMN_DATE;
        this.sortDescendingValue = this.constants.BOOLEAN_STRING_FALSE;

        this.createBasicQuery = function() {
            var q = {};

            q[this.constants.URL_PARAM_LIMIT] = this.limit;
            q[this.constants.URL_PARAM_OFFSET] = this.offset;
            q[this.constants.URL_PARAM_SORT_BY] = this.column;
            q[this.constants.URL_PARAM_SORT_DESCENDING] = this.sortDescendingValue;

            return q;
        };

        this.urlConnection.setUrl(this.url);
    };

    DraftCollection.prototype.getLimit = function() {
        return this.limit;
    };

    DraftCollection.prototype.setLimit = function(limit) {
        this.limit = limit;
    };

    DraftCollection.prototype.setOffset = function(offset) {
        this.offset = offset;
    };

    DraftCollection.prototype.sortDescending = function() {
        this.sortDescendingValue = this.constants.BOOLEAN_STRING_TRUE;
    };

    DraftCollection.prototype.sortAscending = function() {
        this.sortDescendingValue = this.constants.BOOLEAN_STRING_FALSE;
    };

    DraftCollection.prototype.byDate = function() {
        this.column = this.constants.SORT_BY_COLUMN_DATE;
    };

    DraftCollection.prototype.bySubject = function() {
        this.column = this.constants.SORT_BY_COLUMN_SUBJECT;
    };

    DraftCollection.prototype.byTo = function() {
        this.column = this.constants.SORT_BY_COLUMN_TO;
    };

    DraftCollection.prototype.fetch = function(handlers) {
        this.urlConnection.setQuery(this.createBasicQuery());
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return DraftCollection;
});
},
'api/mail/DraftCollectionAction':function(){
define([], function() {
    var DraftCollectionAction = function(url, urlConnectionBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;

        this.folderId = 'INBOX.Drafts';

        this.constants = {
            URL_PARAM_DELETE: 'delete',
            URL_PARAM_FOLDER_ID: 'folderId',
            URL_PARAM_ID: 'id'
        };

        this._gatherUids = function(messageCollection) {
            var r = [];
            for(var i = 0; i < messageCollection.length; i++) {
                r.push(messageCollection[i].getUid());
            }
            return r;
        };

        this.createBasicQuery = function() {
            var q = {};
            q[this.constants.URL_PARAM_FOLDER_ID] = this.folderId;
            return q;
        };

        this.createBasicUrlConnection = function(handlers, data) {
            var urlConnection = this.urlConnectionBuilder.build();

            urlConnection.setUrl(this.url);
            urlConnection.setQuery(this.createBasicQuery());
            urlConnection.setData(data);
            urlConnection.setSuccessHandler(handlers.getSuccess());
            urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
            urlConnection.setProgressHandler(handlers.getProgress());
            urlConnection.setErrorHandler(handlers.getError());

            return urlConnection;
        };
    };

    DraftCollectionAction.prototype.del = function(messageCollection, handlers) {
        var d = {};
        d[this.constants.URL_PARAM_ID] = this._gatherUids(messageCollection);
        d[this.constants.URL_PARAM_DELETE] = 'true';

        return this.createBasicUrlConnection(handlers, d).post();
    };

    return DraftCollectionAction;
});
},
'api/mail/DraftContent':function(){
define([], function() {
    const DraftContent = function(
        urlConnectionBuilder,
        urlResponseProcessorBuilder,
        draftBodyUrl,
        draftRecipientToUrl,
        draftRecipientCcUrl,
        draftBodyCollectionParser,
        draftRecipientCollectionParser
    ) {
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;

        this.draftBodyUrl = draftBodyUrl;
        this.draftRecipientToUrl = draftRecipientToUrl;
        this.draftRecipientCcUrl = draftRecipientCcUrl;

        this.bodyCollectionParser = draftBodyCollectionParser;
        this.draftRecipientCollectionParser = draftRecipientCollectionParser;

        this.draftVO = null;

        this.constants = {
            URL_PARAM_DRAFT_ID: 'draftId'
        };

        this.createBasicQuery = function() {
            const q = {};

            q[this.constants.URL_PARAM_DRAFT_ID] = this.draftVO.getUid();

            return q;
        };
    };

    DraftContent.prototype.setVO = function(draftVO) {
        this.draftVO = draftVO;
    };

    DraftContent.prototype.getBody = function(handlers) {
        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.draftBodyUrl);
        urlConnection.setQuery(this.createBasicQuery());

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.bodyCollectionParser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    DraftContent.prototype.getToRecipients = function(handlers) {
        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.draftRecipientToUrl);
        urlConnection.setQuery(this.createBasicQuery());

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.draftRecipientCollectionParser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    DraftContent.prototype.getCcRecipients = function(handlers) {
        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.draftRecipientCcUrl);
        urlConnection.setQuery(this.createBasicQuery());

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.draftRecipientCollectionParser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    return DraftContent;
});
},
'api/mail/filter/Collection':function(){
define([], function() {
    var Collection = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this.urlConnection.setUrl(this.url);
    };

    Collection.prototype.fetch = function(handlers) {
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return Collection;
});
},
'api/mail/filter/Filter':function(){
define([], function() {
    var Filter = function(url, urlConnectionBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;

        this.constants = {
            PARAM_FILTER: 'filter',
            PARAM_LANGUAGE_VERSION: 'languageVersion',
            PARAM_PRIORITY: 'priority'
        };
    };

    Filter.prototype.add = function(handlers, filterVO) {
        var data = {};
        data[this.constants.PARAM_FILTER] = filterVO.getFilter();
        data[this.constants.PARAM_LANGUAGE_VERSION] = filterVO.getLanguageVersion();

        var urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url);
        urlConnection.setData(data);
        urlConnection.setSuccessHandler(handlers.getSuccess());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());
        return urlConnection.post();
    };

    Filter.prototype.del = function(handlers, id) {
        var urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url + id);
        urlConnection.setSuccessHandler(handlers.getSuccess());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());
        return urlConnection.del();
    };

    Filter.prototype.update = function(handlers, filterVO) {
        var data = {};
        data[this.constants.PARAM_FILTER] = filterVO.getFilter();
        data[this.constants.PARAM_LANGUAGE_VERSION] = filterVO.getLanguageVersion();
        data[this.constants.PARAM_PRIORITY] = filterVO.getPriority();

        var urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url + filterVO.getId());
        urlConnection.setData(data);
        urlConnection.setSuccessHandler(handlers.getSuccess());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());
        return urlConnection.put();
    };

    return Filter;
});
},
'api/mail/FolderAction':function(){
define([], function() {
    const FolderAction = function(url, urlConnectionBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;

        this.constants = {
            PARAM_CLEAR: 'clear',
            PARAM_FOLDER_ID: 'folderId',
            PARAM_FOLDER_NAME: 'name',
            PARAM_PARENT_FOLDER_ID: 'parentFolderId'
        };
    };

    FolderAction.prototype.add = function(handlers, name) {
        const data = {};
        data[this.constants.PARAM_FOLDER_NAME] = name;

        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url);
        urlConnection.setData(data);
        urlConnection.setSuccessHandler(handlers.getSuccess());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());
        return urlConnection.post();
    };

    FolderAction.prototype.addSubFolder = function(handlers, name, parentFolderId) {
        const data = {};
        data[this.constants.PARAM_FOLDER_NAME] = name;
        data[this.constants.PARAM_PARENT_FOLDER_ID] = parentFolderId;

        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url);
        urlConnection.setData(data);
        urlConnection.setSuccessHandler(handlers.getSuccess());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());
        return urlConnection.post();
    };

    FolderAction.prototype.clear = function(handlers, folderId) {
        const data = {};
        data[this.constants.PARAM_CLEAR] = 'true';
        data[this.constants.PARAM_FOLDER_ID] = folderId;

        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url);
        urlConnection.setData(data);
        urlConnection.setSuccessHandler(handlers.getSuccess());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());
        return urlConnection.post();
    };

    FolderAction.prototype.del = function(handlers, folderId) {
        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url + encodeURIComponent(folderId));
        urlConnection.setSuccessHandler(handlers.getSuccess());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());
        return urlConnection.del();
    };

    FolderAction.prototype.rename = function(handlers, folderId, newName) {
        const data = {};
        data[this.constants.PARAM_FOLDER_NAME] = newName;

        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url + encodeURIComponent(folderId));
        urlConnection.setData(data);
        urlConnection.setSuccessHandler(handlers.getSuccess());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());
        return urlConnection.put();
    };

    FolderAction.prototype.move = function(handlers, folderId, parentFolderId) {
        const data = {};
        data[this.constants.PARAM_PARENT_FOLDER_ID] = parentFolderId;

        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url + encodeURIComponent(folderId));
        urlConnection.setData(data);
        urlConnection.setSuccessHandler(handlers.getSuccess());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());
        return urlConnection.put();
    };

    return FolderAction;
});
},
'api/mail/FolderCollection':function(){
define([], function() {
    var FolderCollection = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this.urlConnection.setUrl(this.url);
    };

    FolderCollection.prototype.fetch = function(handlers, mailboxId) {
        this.urlConnection.setQuery({'mailboxId': mailboxId});
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return FolderCollection;
});
},
'api/mail/group/MemberCollection':function(){
define([], function() {
    var MemberCollection = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this.urlConnection.setUrl(this.url);
    };

    MemberCollection.prototype.fetch = function(handlers, mailGroupId) {
        this.urlConnection.setQuery({'mailGroupPK': mailGroupId});
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return MemberCollection;
});
},
'api/mail/mailbox/Collection':function(){
define([], function() {
    var Collection = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this.urlConnection.setUrl(this.url);
    };

    Collection.prototype.fetch = function(handlers) {
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return Collection;
});
},
'api/mail/mailbox/Mailbox':function(){
define([], function() {
    const Mailbox = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    Mailbox.prototype.get = function(handlers, mailboxId) {
        this.urlConnection.setUrl(this.url + encodeURIComponent(mailboxId));

        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return Mailbox;
});
},
'api/mail/my-group/MemberCollection':function(){
define([
    './filter/IncludeInactive'
], function(
    IncludeInactive
) {
    var MemberCollection = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this.urlConnection.setUrl(this.url);

        this.createBasicQuery = function (filterCollection, mailMyGroupId) {
            let q = {'mailMyGroupPK': mailMyGroupId};

            if (filterCollection.getFilterByClass(IncludeInactive)) {
                q['includeInactive'] = true
            }

            return q;
        }
    };

    MemberCollection.prototype.fetch = function(handlers, filterCollection, mailMyGroupId) {
        this.urlConnection.setQuery(this.createBasicQuery(filterCollection, mailMyGroupId));
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return MemberCollection;
});
},
'api/mail/my-group/filter/IncludeInactive':function(){
define([], function() {
    return function() {}
});
},
'api/mail/folder/Folder':function(){
define([], function() {
    var Folder = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    Folder.prototype.get = function(handlers, folderId) {
        this.urlConnection.setUrl(this.url + encodeURIComponent(folderId));

        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return Folder;
});
},
'api/mail/message/Message':function(){
define([], function() {
    var Message = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this.folderId = null;
    };

    Message.prototype.changeFolder = function(folderId) {
        this.folderId = folderId;
    };

    Message.prototype.get = function(handlers, messageId) {
        this.urlConnection.setUrl(this.url + encodeURIComponent(messageId));

        if (this.folderId) {
            this.urlConnection.setQuery({'folderId': this.folderId});
        }

        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return Message;
});
},
'api/mail/message/Action':function(){
define([
    './action-persistence/Persister'
], function(ActionPersister) {
    const Action = function(url, urlConnectionBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;

        this.messageVO = null;
        this.folderId = null;

        this.constants = {
            URL_PARAM_FOLDER_ID: 'folderId',
            URL_PARAM_IS_FLAGGED: 'isFlagged',
            URL_PARAM_IS_READ: 'isRead',
            FOLDER_ID_ARCHIVE: 'INBOX.Archive'
        };

        this.createBasicQuery = function() {
            let q = {};

            if (this.folderId) {
                q[this.constants.URL_PARAM_FOLDER_ID] = this.folderId;
            }

            return q;
        };

        this.createBasicUrlConnection = function(handlers, data) {
            let urlConnection = this.urlConnectionBuilder.build();

            urlConnection.setUrl(this.url + this.messageVO.getUid());
            urlConnection.setQuery(this.createBasicQuery());
            urlConnection.setData(data);
            urlConnection.setSuccessHandler(handlers.getSuccess());
            urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
            urlConnection.setProgressHandler(handlers.getProgress());
            urlConnection.setErrorHandler(handlers.getError());

            return urlConnection;
        };
    };

    Action.prototype.setVO = function(messageVO) {
        this.messageVO = messageVO;
        return this;
    };

    Action.prototype.changeFolder = function(folderId) {
        this.folderId = folderId;
        return this;
    };

    Action.prototype.del = function(handlers) {
        return new ActionPersister(this.createBasicUrlConnection(handlers, null));
    };

    Action.prototype.archive = function(handlers) {
        let d = {};
        d[this.constants.URL_PARAM_FOLDER_ID] = this.constants.FOLDER_ID_ARCHIVE;

        return this.createBasicUrlConnection(handlers, d).put();
    };

    Action.prototype.flag = function(handlers) {
        let d = {};
        d[this.constants.URL_PARAM_IS_FLAGGED] = true;

        return this.createBasicUrlConnection(handlers, d).put();
    };

    Action.prototype.unflag = function(handlers) {
        let d = {};
        d[this.constants.URL_PARAM_IS_FLAGGED] = false;

        return this.createBasicUrlConnection(handlers, d).put();
    };

    Action.prototype.move = function(folderId, handlers) {
        let d = {};
        d[this.constants.URL_PARAM_FOLDER_ID] = folderId;

        return this.createBasicUrlConnection(handlers, d).put();
    };

    Action.prototype.markAsUnread = function(handlers) {
        let d = {};
        d[this.constants.URL_PARAM_IS_READ] = false;

        return this.createBasicUrlConnection(handlers, d).put();
    };

    Action.prototype.markAsRead = function(handlers) {
        let d = {};
        d[this.constants.URL_PARAM_IS_READ] = true;

        return this.createBasicUrlConnection(handlers, d).put();
    };

    return Action;
});
},
'api/mail/message/action-persistence/Persister':function(){
define([
    './AlwaysTrigger'
], function(AlwaysTrigger) {
    const PARAM_ALWAYS = 'always';

    const Persister = function(configuredUrlConnection) {
        this.configuredUrlConnection = configuredUrlConnection;
    };

    Persister.prototype.once = function() {
        let q = this.configuredUrlConnection.getQuery();
        delete q[PARAM_ALWAYS];
        this.configuredUrlConnection.setQuery(q);
        
        return this.configuredUrlConnection.del();
    };

    Persister.prototype.always = function() {
        return new AlwaysTrigger(this.configuredUrlConnection);
    };

    return Persister;
});
},
'api/mail/message/action-persistence/AlwaysTrigger':function(){
define([], function() {
    const PARAM_ALWAYS = 'always';
    const PARAM_VALUE_TRUE = 'true';

    const AlwaysTrigger = function(configuredUrlConnection) {
        this.configuredUrlConnection = configuredUrlConnection;
    };

    AlwaysTrigger.prototype.fromAddress = function() {
        let q = this.configuredUrlConnection.getQuery();
        q[PARAM_ALWAYS] = PARAM_VALUE_TRUE;

        this.configuredUrlConnection.setQuery(q);

        return this.configuredUrlConnection.del();
    };

    return AlwaysTrigger;
});
},
'api/mail/message/BodyAttachmentLog':function(){
define([], function() {
    const URL_PARAM_FOLDER_ID = 'folderId';
    const URL_PARAM_MESSAGE_ID = 'messageId';

    const BodyAttachmentLog = function(url, urlConnection) {
        this.url = url;
        this.urlConnection = urlConnection;

        this.createBasicQuery = function(folderId, uid) {
            let q = {};

            q[URL_PARAM_FOLDER_ID] = folderId;
            q[URL_PARAM_MESSAGE_ID] = uid;

            return q;
        };
    };

    BodyAttachmentLog.prototype.log = function(handlers, folderId, uid, md5) {
        this.urlConnection.setUrl(this.url + md5);
        this.urlConnection.setQuery(this.createBasicQuery(folderId, uid));
        this.urlConnection.setSuccessHandler(handlers.getSuccess());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.put();
    };

    return BodyAttachmentLog;
});
},
'api/mail/message/Collection':function(){
define([], function() {
    const FALSE = 'false';
    const SORT_BY_DATE = 'arrival';
    const SORT_BY_FROM = 'from';
    const SORT_BY_SUBJECT = 'subject';
    const SORT_BY_TO = 'to';
    const TRUE = 'true';
    const URL_PARAM_FOLDER_ID = 'folderId';
    const URL_PARAM_IS_READ = 'isRead';
    const URL_PARAM_IS_UNREAD = 'isUnread';
    const URL_PARAM_LIMIT = 'limit';
    const URL_PARAM_OFFSET = 'offset';
    const URL_PARAM_SORT_BY = 'sortBy';
    const URL_PARAM_SORT_DESCENDING = 'sortDescending';

    const Collection = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this.folderId = null;
        this.limit = 15;
        this.offset = 0;
        this.column = null;
        this.sortDescendingValue = FALSE;
        this.isReadAttr = false;
        this.isUnreadAttr = false;

        this.createBasicQuery = function() {
            const q = {};

            q[URL_PARAM_LIMIT] = this.limit;
            q[URL_PARAM_OFFSET] = this.offset;

            if (this.folderId) {
                q[URL_PARAM_FOLDER_ID] = this.folderId;
            }

            if (this.column) {
                q[URL_PARAM_SORT_BY] = this.column;
            }

            q[URL_PARAM_SORT_DESCENDING] = this.sortDescendingValue;

            if (this.isUnreadAttr) {
                q[URL_PARAM_IS_UNREAD] = true;
            } else if (this.isReadAttr) {
                q[URL_PARAM_IS_READ] = true;
            }

            return q;
        };

        this.urlConnection.setUrl(this.url);
    };

    Collection.prototype.changeFolder = function(folderId) {
        this.folderId = folderId;
        return this;
    };

    Collection.prototype.getLimit = function() {
        return this.limit;
    };

    Collection.prototype.setLimit = function(limit) {
        this.limit = limit;
        return this;
    };

    Collection.prototype.setOffset = function(offset) {
        this.offset = offset;
        return this;
    };

    Collection.prototype.getOffset = function() {
        return this.offset;
    };

    Collection.prototype.sortDescending = function() {
        this.sortDescendingValue = TRUE;
        return this;
    };

    Collection.prototype.sortAscending = function() {
        this.sortDescendingValue = FALSE;
        return this;
    };

    Collection.prototype.byDate = function() {
        this.column = SORT_BY_DATE;
        return this;
    };

    Collection.prototype.byFrom = function() {
        this.column = SORT_BY_FROM;
        return this;
    };

    Collection.prototype.bySubject = function() {
        this.column = SORT_BY_SUBJECT;
        return this;
    };

    Collection.prototype.byTo = function() {
        this.column = SORT_BY_TO;
        return this;
    };

    Collection.prototype.isRead = function() {
        this.isReadAttr = true;
        return this;
    };

    Collection.prototype.isUnread = function() {
        this.isUnreadAttr = true;
        return this;
    };

    Collection.prototype.fetch = function(handlers) {
        this.urlConnection.setQuery(this.createBasicQuery());
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return Collection;
});
},
'api/mail/message/CollectionAction':function(){
define([], function() {
    const CollectionAction = function(url, urlConnectionBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;

        this.folderId = null;

        this.constants = {
            URL_PARAM_ARCHIVE: 'archive',
            URL_PARAM_DELETE: 'delete',
            URL_PARAM_ID: 'id',
            URL_PARAM_FOLDER_ID: 'folderId',
            URL_PARAM_IS_FLAGGED: 'isFlagged',
            URL_PARAM_IS_READ: 'isRead',
            URL_PARAM_TO_FOLDER_ID: 'toFolderId'
        };

        this._gatherUids = function(messageCollection) {
            const r = [];
            for(let i = 0; i < messageCollection.length; i++) {
                r.push(messageCollection[i].getUid());
            }
            return r;
        };

        this.createBasicQuery = function() {
            const q = {};

            if (this.folderId) {
                q[this.constants.URL_PARAM_FOLDER_ID] = this.folderId;
            }

            return q;
        };

        this.createBasicUrlConnection = function(handlers, data) {
            const urlConnection = this.urlConnectionBuilder.build();

            urlConnection.setUrl(this.url);
            urlConnection.setQuery(this.createBasicQuery());
            urlConnection.setData(data);
            urlConnection.setSuccessHandler(handlers.getSuccess());
            urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
            urlConnection.setProgressHandler(handlers.getProgress());
            urlConnection.setErrorHandler(handlers.getError());

            return urlConnection;
        };
    };

    CollectionAction.prototype.changeFolder = function(folderId) {
        this.folderId = folderId;
        return this;
    };

    CollectionAction.prototype.archive = function(messageCollection, handlers) {
        const d = {};
        d[this.constants.URL_PARAM_ID] = this._gatherUids(messageCollection);
        d[this.constants.URL_PARAM_ARCHIVE] = 'true';

        return this.createBasicUrlConnection(handlers, d).post();
    };

    CollectionAction.prototype.del = function(messageCollection, handlers) {
        const d = {};
        d[this.constants.URL_PARAM_ID] = this._gatherUids(messageCollection);
        d[this.constants.URL_PARAM_DELETE] = 'true';

        return this.createBasicUrlConnection(handlers, d).post();
    };

    CollectionAction.prototype.flag = function(messageCollection, handlers) {
        const d = {};
        d[this.constants.URL_PARAM_ID] = this._gatherUids(messageCollection);
        d[this.constants.URL_PARAM_IS_FLAGGED] = 'true';

        return this.createBasicUrlConnection(handlers, d).post();
    };

    CollectionAction.prototype.unflag = function(messageCollection, handlers) {
        const d = {};
        d[this.constants.URL_PARAM_ID] = this._gatherUids(messageCollection);
        d[this.constants.URL_PARAM_IS_FLAGGED] = 'false';

        return this.createBasicUrlConnection(handlers, d).post();
    };

    CollectionAction.prototype.markAsRead = function(messageCollection, handlers) {
        const d = {};
        d[this.constants.URL_PARAM_ID] = this._gatherUids(messageCollection);
        d[this.constants.URL_PARAM_IS_READ] = 'true';

        return this.createBasicUrlConnection(handlers, d).post();
    };

    CollectionAction.prototype.markAsUnread = function(messageCollection, handlers) {
        const d = {};
        d[this.constants.URL_PARAM_ID] = this._gatherUids(messageCollection);
        d[this.constants.URL_PARAM_IS_READ] = 'false';

        return this.createBasicUrlConnection(handlers, d).post();
    };

    CollectionAction.prototype.move = function(messageCollection, toFolderId, handlers) {
        const d = {};
        d[this.constants.URL_PARAM_ID] = this._gatherUids(messageCollection);
        d[this.constants.URL_PARAM_TO_FOLDER_ID] = toFolderId;

        return this.createBasicUrlConnection(handlers, d).post();
    };

    return CollectionAction;
});
},
'api/mail/message/Content':function(){
define([], function() {
    const URL_HEADER_ACCEPT = 'Accept';
    const URL_PARAM_FOLDER_ID = 'folderId';
    const URL_PARAM_MESSAGE_ID = 'messageId';
    const URL_PARAM_UID = 'uid';

    const Content = function(
        urlConnectionBuilder,
        urlResponseProcessorBuilder,
        bodyUrl,
        attachmentsUrl,
        messageRecipientToUrl,
        messageRecipientCcUrl,
        messageFromUrl,
        bodyCollectionParser,
        attachmentCollectionParser,
        messageAddressCollectionParser
    ) {
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;

        this.bodyUrl = bodyUrl;
        this.attachmentsUrl = attachmentsUrl;
        this.messageRecipientToUrl = messageRecipientToUrl;
        this.messageRecipientCcUrl = messageRecipientCcUrl;
        this.messageFromUrl = messageFromUrl;

        this.bodyCollectionParser = bodyCollectionParser;
        this.attachmentCollectionParser = attachmentCollectionParser;
        this.messageAddressCollectionParser = messageAddressCollectionParser;

        this.messageVO = null;
        this.folderId = null;

        this.createBasicQuery = function(idParamName) {
            const q = {};

            q[idParamName] = idParamName === URL_PARAM_UID ? this.messageVO.getUid() : this.messageVO.getUid() || this.messageVO.getMessageID();

            if (this.folderId) {
                q[URL_PARAM_FOLDER_ID] = this.folderId;
            }

            return q;
        };
    };

    Content.prototype.setVO = function(messageVO) {
        this.messageVO = messageVO;
        return this;
    };

    Content.prototype.changeFolder = function(folderId) {
        this.folderId = folderId;
        return this;
    };

    Content.prototype.getBody = function(handlers) {
        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.bodyUrl);
        urlConnection.setQuery(this.createBasicQuery(URL_PARAM_UID));

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.bodyCollectionParser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());
        urlConnection.setHeader(URL_HEADER_ACCEPT, this.bodyCollectionParser.getAccepts());

        return urlConnection.get();
    };

    Content.prototype.listAttachments = function(handlers) {
        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.attachmentsUrl);
        urlConnection.setQuery(this.createBasicQuery(URL_PARAM_MESSAGE_ID));

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.attachmentCollectionParser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    Content.prototype.getToRecipients = function(handlers) {
        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.messageRecipientToUrl);
        urlConnection.setQuery(this.createBasicQuery(URL_PARAM_MESSAGE_ID));

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.messageAddressCollectionParser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    Content.prototype.getCcRecipients = function(handlers) {
        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.messageRecipientCcUrl);
        urlConnection.setQuery(this.createBasicQuery(URL_PARAM_MESSAGE_ID));

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.messageAddressCollectionParser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    Content.prototype.getFrom = function(handlers) {
        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.messageFromUrl);
        urlConnection.setQuery(this.createBasicQuery(URL_PARAM_MESSAGE_ID));

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.messageAddressCollectionParser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    return Content;
});
},
'api/mail/message/Sibling':function(){
define([], function() {
    var Sibling = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this.constants = {
            FALSE: 'false',
            SORT_BY_DATE: 'arrival',
            SORT_BY_FROM: 'from',
            SORT_BY_TO: 'to',
            SORT_BY_SUBJECT: 'subject',
            TRUE: 'true',
            URL_PARAM_FOLDER_ID: 'folderId',
            URL_PARAM_SORT_BY: 'sortBy',
            URL_PARAM_SORT_DESCENDING: 'sortDescending'
        };

        this.folderId = null;
        this.sortColumn = null;
        this.sortDescendingValue = null;

        this._createQuery = function() {
            var q = {};

            if (this.folderId) {
                q[this.constants.URL_PARAM_FOLDER_ID] = this.folderId;
            }

            if (this.sortColumn) {
                q[this.constants.URL_PARAM_SORT_BY] = this.sortColumn;
            }

            if (this.sortDescendingValue !== null) {
                q[this.constants.URL_PARAM_SORT_DESCENDING] = this.sortDescendingValue;
            }

            return q;
        };
    };

    Sibling.prototype.changeFolder = function(folderId) {
        this.folderId = folderId;
    };

    Sibling.prototype.sortDescending = function() {
        this.sortDescendingValue = this.constants.TRUE;
    };

    Sibling.prototype.sortAscending = function() {
        this.sortDescendingValue = this.constants.FALSE;
    };

    Sibling.prototype.byDate = function() {
        this.sortColumn = this.constants.SORT_BY_DATE;
    };

    Sibling.prototype.byFrom = function() {
        this.sortColumn = this.constants.SORT_BY_FROM;
    };

    Sibling.prototype.bySubject = function() {
        this.sortColumn = this.constants.SORT_BY_SUBJECT;
    };

    Sibling.prototype.byTo = function() {
        this.sortColumn = this.constants.SORT_BY_TO;
    };

    Sibling.prototype.get = function(handlers, uid) {
        this.urlConnection.setUrl(this.url + encodeURIComponent(uid));
        this.urlConnection.setQuery(this._createQuery());

        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return Sibling;
});
},
'api/mail/message/Thread':function(){
define([], function() {
    const URL_PARAM_FOLDER_ID = 'folderId';
    const URL_PARAM_ID = 'id';

    const Thread = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this.folderId = null;
        this.sortColumn = null;

        this._createQuery = function(folderId, uid) {
            const q = {};

            if (folderId) {
                q[URL_PARAM_FOLDER_ID] = folderId;
            }

            if (uid) {
                q[URL_PARAM_ID] = uid;
            }

            return q;
        };
    };

    Thread.prototype.get = function(handlers, folderId, uid) {
        this.urlConnection.setUrl(this.url);
        this.urlConnection.setQuery(this._createQuery(folderId, uid));

        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return Thread;
});
},
'api/mail/out-of-office/parser/Reply':function(){
define([
    "../data/Reply"
], function(ReplyVO) {
    var Reply = function() {};

    Reply.prototype.parse = function(item) {
        const fromDate = new Date(item.dateFrom);
        const toDate = new Date(item.dateTo);

        var reply = new ReplyVO();
        reply.setId(item.id || null);
        reply.setMessage(item.message || null);
        reply.setSubject(item.subject || null);
        reply.setDateFrom(!isNaN(fromDate.getTime()) ? fromDate : null);
        reply.setDateTo(!isNaN(toDate.getTime()) ? toDate : null);
        reply.setInternalOnly(item.internalOnly || false);

        return reply;
    };

    return Reply;
});
},
'api/mail/out-of-office/data/Reply':function(){
define([], function() {
    var Reply = function() {
        this.id = null;
        this.message = null;
        this.subject = null;
        this.dateFrom = null;
        this.dateTo = null;
        this.internalOnly = false;
    };

    Reply.prototype.getId = function() {
        return this.id;
    };

    Reply.prototype.setId = function(id) {
        this.id = id;
    };

    Reply.prototype.getMessage = function() {
        return this.message;
    };

    Reply.prototype.setMessage = function(message) {
        this.message = message;
    };

    Reply.prototype.getSubject = function() {
        return this.subject;
    };

    Reply.prototype.setSubject = function(subject) {
        this.subject = subject;
    };

    Reply.prototype.getDateFrom = function() {
        return this.dateFrom;
    };

    Reply.prototype.setDateFrom = function(dateFrom) {
        this.dateFrom = dateFrom;
    };

    Reply.prototype.getDateTo = function() {
        return this.dateTo;
    };

    Reply.prototype.setDateTo = function(dateTo) {
        this.dateTo = dateTo;
    };

    Reply.prototype.isInternalOnly = function() {
        return this.internalOnly;
    };

    Reply.prototype.setInternalOnly = function(internalOnly) {
        this.internalOnly = internalOnly;
    };

    return Reply;
});
},
'api/mail/out-of-office/Reply':function(){
define([], function() {
    var Reply = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    Reply.prototype.get = function(handlers, id) {
        this.urlConnection.setUrl(this.url + encodeURIComponent(id));

        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    Reply.prototype.add = function(handlers, reply) {
        this.urlConnection.setUrl(this.url);

        var data = {
            'subject': reply.getSubject(),
            'message': reply.getMessage(),
            'dateFrom': reply.getDateFrom(),
            'dateTo': reply.getDateTo(),
            'internalOnly': reply.isInternalOnly()
        };

        this.urlConnection.setData(data);
        this.urlConnection.setSuccessHandler(handlers.getSuccess());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.post();
    };

    Reply.prototype.update = function (handlers, reply) {
        this.urlConnection.setUrl(this.url + encodeURIComponent(reply.getId()));

        var data = {
            'subject' : reply.getSubject(),
            'message' : reply.getMessage(),
            'dateFrom' : reply.getDateFrom(),
            'dateTo' : reply.getDateTo(),
            'internalOnly': reply.isInternalOnly()
        };

        this.urlConnection.setData(data);
        this.urlConnection.setSuccessHandler(handlers.getSuccess());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.put();
    };
    
    Reply.prototype.del = function (handlers, id) {
        this.urlConnection.setUrl(this.url + encodeURIComponent(id));

        this.urlConnection.setSuccessHandler(handlers.getSuccess());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.del();
    };

    return Reply;
});
},
'api/mail/out-of-office/ReplyCollection':function(){
define([], function() {
    var ReplyCollection = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    ReplyCollection.prototype.fetch = function(handlers) {
        this.urlConnection.setUrl(this.url);

        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return ReplyCollection;
});
},
'api/mail/MessageSender':function(){
define([
    'spencer/date-time/Format'
], function(
    DateTimeFormatter
) {
    const PARAM_BODY = 'body';
    const PARAM_DRAFT_ID = 'draftId';
    const PARAM_FROM_ADDRESS = 'fromAddress';
    const PARAM_FROM_NAME = 'fromName';
    const PARAM_IN_REPLY_TO = 'inReplyTo';
    const PARAM_IN_REPLY_TO_DATE = 'inReplyToDate';
    const PARAM_IN_REPLY_TO_FOLDER_ID = 'inReplyToFolderId';
    const PARAM_IN_REPLY_TO_UID = 'inReplyToUid';
    const PARAM_PROJECT_STAGE_ID = 'projectStagePK';
    const PARAM_PROJECT_STAGE = 'projectStage';
    const PARAM_SUBJECT = 'subject';
    const PARAM_TO = 'to';
    const PARAM_TO_GROUPS = 'toGroups';
    const PARAM_TO_MY_GROUPS = 'toMyGroups';
    const PARAM_CC = 'cc';
    const PARAM_CC_GROUPS = 'ccGroups';
    const PARAM_CC_MY_GROUPS = 'ccMyGroups';
    const PARAM_CONTACT_ADDRESS = 'address';
    const PARAM_CONTACT_NAME = 'name';
    const PARAM_GROUP_ID = 'groupId';
    const PARAM_ATTACHMENTS = 'attachments';
    const PARAM_ATTACHMENT_MD5 = 'md5';
    const PARAM_ATTACHMENT_REGISTRATION_DETAILS = 'attachmentRegistrationDetails';
    const PARAM_PRIVATE = 'private';
    const PARAM_FILE_KEY = 'fileKey';
    const PARAM_FILE_REGISTRATION_DETAILS = 'fileRegistrationDetails';
    const PARAM_REVISION_PK = 'revisionPK';
    const PARAM_CLIENT_INFO = 'clientInfo';

    const PARAM_REGISTRATION_DETAILS_DATE = 'date',
        PARAM_REGISTRATION_DETAILS_DISCIPLINE = 'discipline',
        PARAM_REGISTRATION_DETAILS_PERSON_PK = 'personPK',
        PARAM_REGISTRATION_DETAILS_OFFICE_PK = 'officePK',
        PARAM_REGISTRATION_DETAILS_PROJECT_STAGE_PK = 'projectStagePK',
        PARAM_REGISTRATION_DETAILS_REFERENCE = 'reference',
        PARAM_REGISTRATION_DETAILS_REVISION = 'revision',
        PARAM_REGISTRATION_DETAILS_STATUS = 'status',
        PARAM_REGISTRATION_DETAILS_TREE_VIEW_PK = 'treeViewPK',
        PARAM_REGISTRATION_DETAILS_TITLE = 'title',
        PARAM_REGISTRATION_DETAILS_TYPE = 'type',
        PARAM_REGISTRATION_DETAILS_NODE_REFERENCE = 'nodeReference',
        PARAM_REGISTRATION_DETAILS_ORIGINATOR_PERSON_PK = 'originatorPersonPK',
        PARAM_REGISTRATION_DETAILS_RECIPIENT_BRANCH_OFFICE_PK = 'recipientBranchOfficePK',
        PARAM_REGISTRATION_DETAILS_RECIPIENT_PERSON_PK = 'recipientPersonPK';


    const MessageSender = function(url, urlConnection) {
        this.url = url;
        this.urlConnection = urlConnection;

        this.applicationVersion = null;
        this.userAgent = null;

        this.dateTimeFormatter = new DateTimeFormatter();

        this.createJsonListFromContactVOs = function(messageContactVOs) {
            const l = [];

            if (messageContactVOs.length > 0) {
                for (const i in messageContactVOs) {
                    if (messageContactVOs.hasOwnProperty(i)) {
                        const c = {};

                        c[PARAM_CONTACT_ADDRESS] = messageContactVOs[i].getAddress();
                        c[PARAM_CONTACT_NAME] =  messageContactVOs[i].getName();

                        l.push(JSON.stringify(c));
                    }
                }
            }

            return l;
        };

        this.createJsonListFromAttachments = function(attachments) {
            return attachments.map((attachment) => {
                let c = {};

                c[PARAM_ATTACHMENT_MD5] = attachment.getMd5();

                if (attachment.getRegistrationDetails()) {
                    Object.assign(c, this.parseRegistrationDetailsParams(attachment.getRegistrationDetails()));
                }

                return JSON.stringify(c);
            });
        };

        this.createJsonListFromFiles = function(files) {
            return files.map((file) => {
                let c = {};

                c[PARAM_FILE_KEY] = file.getKey();

                if (file.getRegistrationDetails()) {
                    Object.assign(c, this.parseRegistrationDetailsParams(file.getRegistrationDetails()));
                }

                return JSON.stringify(c);
            });
        };

        this.parseRegistrationDetailsParams = function(registrationDetails) {
            const params = {};

            if (registrationDetails.date) {
                params[PARAM_REGISTRATION_DETAILS_DATE] = registrationDetails.date;
            }

            if (registrationDetails.discipline) {
                params[PARAM_REGISTRATION_DETAILS_DISCIPLINE] = registrationDetails.discipline;
            }

            if (registrationDetails.personPK) {
                params[PARAM_REGISTRATION_DETAILS_PERSON_PK] = registrationDetails.personPK;
            }

            if (registrationDetails.branchOfficePK) {
                params[PARAM_REGISTRATION_DETAILS_OFFICE_PK] = registrationDetails.branchOfficePK;
            }

            if (registrationDetails.projectStagePK) {
                params[PARAM_REGISTRATION_DETAILS_PROJECT_STAGE_PK] = registrationDetails.projectStagePK;
            }

            if (registrationDetails.reference) {
                params[PARAM_REGISTRATION_DETAILS_REFERENCE] = registrationDetails.reference;
            }

            if (registrationDetails.revision) {
                params[PARAM_REGISTRATION_DETAILS_REVISION] = registrationDetails.revision;
            }

            if (registrationDetails.status) {
                params[PARAM_REGISTRATION_DETAILS_STATUS] = registrationDetails.status;
            }

            if (registrationDetails.treeViewPK) {
                params[PARAM_REGISTRATION_DETAILS_TREE_VIEW_PK] = registrationDetails.treeViewPK;
            }

            if (registrationDetails.title) {
                params[PARAM_REGISTRATION_DETAILS_TITLE] = registrationDetails.title;
            }

            if (registrationDetails.type) {
                params[PARAM_REGISTRATION_DETAILS_TYPE] = registrationDetails.type;
            }

            if (registrationDetails.nodeReference) {
                params[PARAM_REGISTRATION_DETAILS_NODE_REFERENCE] = registrationDetails.nodeReference;
            }

            if (registrationDetails.recipientContact) {
                if (registrationDetails.recipientContact.branchOfficePK) {
                    params[PARAM_REGISTRATION_DETAILS_RECIPIENT_BRANCH_OFFICE_PK] = registrationDetails.recipientContact.branchOfficePK;
                }

                if (registrationDetails.recipientContact.personPK) {
                    params[PARAM_REGISTRATION_DETAILS_RECIPIENT_PERSON_PK] = registrationDetails.recipientContact.personPK;
                }
            }

            if (registrationDetails.originatorContact) {
                params[PARAM_REGISTRATION_DETAILS_ORIGINATOR_PERSON_PK] = registrationDetails.originatorContact.personPK;
            }

            return params;
        };

        this.createListFromContactGroupVOs = function(messageContactGroupVOs) {
            const l = [];

            if (messageContactGroupVOs.length > 0) {
                for (const i in messageContactGroupVOs) {
                    if (messageContactGroupVOs.hasOwnProperty(i)) {
                        l.push(messageContactGroupVOs[i].getGroupId());
                    }
                }
            }

            return l;
        };

        this.generateClientInfo = function() {
            let clientInfo = '';

            if (this.applicationVersion) {
                clientInfo += 'SOS: ' + this.applicationVersion + '; ';
            }

            if (this.userAgent) {
                clientInfo += this.userAgent;
            }

            return clientInfo;
        };
    };

    MessageSender.prototype.setApplicationVersion = function(applicationVersion) {
        this.applicationVersion = applicationVersion;
        return this;
    };

    MessageSender.prototype.setUserAgent = function(userAgent) {
        this.userAgent = userAgent;
        return this;
    };

    MessageSender.prototype.send = function(draftVO, body, handlers) {
        // Build url
        let url = this.url;
        if (draftVO.getUid()) {
            url += draftVO.getUid();
        }
        this.urlConnection.setUrl(url);

        // Build data
        const data = {};
        data[PARAM_ATTACHMENTS] = draftVO.getAttachments().map((a) => a.getMd5());
        data[PARAM_ATTACHMENT_REGISTRATION_DETAILS] = this.createJsonListFromAttachments(draftVO.getAttachments());
        data[PARAM_BODY] = body;
        if (draftVO.getDraftId()) {
            data[PARAM_DRAFT_ID] = draftVO.getDraftId();
        }
        if (draftVO.getInReplyTo()) {
            data[PARAM_IN_REPLY_TO] = draftVO.getInReplyTo();
        }
        if (draftVO.getInReplyToDate()) {
            data[PARAM_IN_REPLY_TO_DATE] = this.dateTimeFormatter.toLocaleISOString(draftVO.getInReplyToDate());
        }
        if (draftVO.getInReplyToFolderId()) {
            data[PARAM_IN_REPLY_TO_FOLDER_ID] = draftVO.getInReplyToFolderId();
        }
        if (draftVO.getInReplyToUid()) {
            data[PARAM_IN_REPLY_TO_UID] = draftVO.getInReplyToUid();
        }
        data[PARAM_FILE_KEY] = draftVO.getFiles().map((f) => f.getKey());
        data[PARAM_FILE_REGISTRATION_DETAILS] = this.createJsonListFromFiles(draftVO.getFiles());
        data[PARAM_FROM_ADDRESS] = draftVO.getFromAddress();
        data[PARAM_FROM_NAME] = draftVO.getFromName();
        data[PARAM_PROJECT_STAGE_ID] = draftVO.getProjectStagePK();
        data[PARAM_PROJECT_STAGE] = draftVO.getProjectStage();
        data[PARAM_REVISION_PK] = draftVO.getRevisionPKs();
        data[PARAM_SUBJECT] = draftVO.getSubject();
        data[PARAM_PRIVATE] = draftVO.isPrivate();
        data[PARAM_TO] = this.createJsonListFromContactVOs(draftVO.getTo());
        data[PARAM_TO_GROUPS] = this.createListFromContactGroupVOs(draftVO.getToGroups());
        data[PARAM_TO_MY_GROUPS] = this.createListFromContactGroupVOs(draftVO.getToMyGroups());
        data[PARAM_CC] = this.createJsonListFromContactVOs(draftVO.getCc());
        data[PARAM_CC_GROUPS] = this.createListFromContactGroupVOs(draftVO.getCcGroups());
        data[PARAM_CC_MY_GROUPS] = this.createListFromContactGroupVOs(draftVO.getCcMyGroups());

        data[PARAM_CLIENT_INFO] = this.generateClientInfo();

        this.urlConnection.setData(data);

        // Set handlers
        this.urlConnection.setSuccessHandler(handlers.getSuccess());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());
        this.urlConnection.setConflictHandler(handlers.getConflict());

        return this.urlConnection.put();
    };

    return MessageSender;
});
},
'api/mail/MessageSignature':function(){
define([], function() {
    var MessageSignature = function(url, urlConnection) {
        this.url = url;
        this.urlConnection = urlConnection;

        this.urlConnection.setUrl(this.url);
    };

    MessageSignature.prototype.get = function(handlers) {
        this.urlConnection.setSuccessHandler(handlers.getSuccess());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return MessageSignature;
});
},
'api/mail/RecentMessageCount':function(){
define([], function() {
    var RecentMessageCount = function(
        urlConnection,
        recentMessageCountUrl
    ) {
        this.urlConnection = urlConnection;

        this.recentMessageCountUrl = recentMessageCountUrl;
    };

    RecentMessageCount.prototype.getCount = function(handlers) {
        this.urlConnection.setUrl(this.recentMessageCountUrl);

        this.urlConnection.setSuccessHandler(handlers.getSuccess());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return RecentMessageCount;
});
},
'api/mail/search/Message':function(){
define([], function() {
    const DEFAULT_LIMIT = 15;
    const DEFAULT_OFFSET = 0;
    const ENHANCED_SEARCH_ENABLED = true;
    const URL_PARAM_SEARCH_ALL_MAILBOXES = 'searchAllMailboxes';
    const URL_PARAM_MAILBOXES = 'mailboxes[]';
    const URL_PARAM_LIMIT = 'limit';
    const URL_PARAM_OFFSET = 'offset';
    const URL_PARAM_ENHANCED_SEARCH_ENABLED = 'enhancedSearchEnabled';
    const URL_PARAM_ALL = 'all';
    const URL_PARAM_SUBJECT = 'subject';
    const URL_PARAM_FROM = 'from';
    const URL_PARAM_TO = 'to';
    const URL_PARAM_CC = 'cc';
    const URL_PARAM_BODY = 'body';
    const URL_PARAM_DATE_FROM = 'dateFrom';
    const URL_PARAM_DATE_TO = 'dateTo';
    const URL_PARAM_FOLDER_ID = 'folderId';
    const URL_PARAM_REGISTRAR_PERSON_PK = 'registrarPersonPK';
    const URL_PARAM_PROJECT_STAGE_PK = 'projectStagePK';
    const URL_PARAM_ATTACHMENT = 'attachment';
    const URL_PARAM_INCLUDE_SUB_FOLDERS_SEARCH = 'includeSubFolders';
    const URL_PARAM_HAS_ATTACHMENTS = 'hasAttachments';
    const URL_PARAM_IS_REGISTERED = 'isRegistered';

    const Message = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this.limit = DEFAULT_LIMIT;
        this.offset = DEFAULT_OFFSET;
        this.enhancedSearchEnabled = ENHANCED_SEARCH_ENABLED;

        this.urlConnection.setUrl(this.url);
    };

    Message.prototype.setLimit = function(limit) {
        this.limit = limit;
        return this;
    };

    Message.prototype.setOffset = function(offset) {
        this.offset = offset;
        return this;
    };

    Message.prototype.setEnhancedSearchEnabled = function(enhancedSearchEnabled) {
        this.enhancedSearchEnabled  = enhancedSearchEnabled;
        return this;
    };

    Message.prototype.search = function(handlers, messageQueryData) {
        const q = {};
        q[URL_PARAM_LIMIT] = this.limit;
        q[URL_PARAM_OFFSET] = this.offset;
        q[URL_PARAM_ENHANCED_SEARCH_ENABLED] = this.enhancedSearchEnabled;
        q[URL_PARAM_SEARCH_ALL_MAILBOXES] = messageQueryData.getSearchAllMailboxes();
        if (!messageQueryData.getSearchAllMailboxes() && messageQueryData.getMailboxes().length) q[URL_PARAM_MAILBOXES] = messageQueryData.getMailboxes();
        if (messageQueryData.getAll()) q[URL_PARAM_ALL] = messageQueryData.getAll();
        if (messageQueryData.getSubject()) q[URL_PARAM_SUBJECT] = messageQueryData.getSubject();
        if (messageQueryData.getFrom()) q[URL_PARAM_FROM] = messageQueryData.getFrom();
        if (messageQueryData.getTo()) q[URL_PARAM_TO] = messageQueryData.getTo();
        if (messageQueryData.getCc()) q[URL_PARAM_CC] = messageQueryData.getCc();
        if (messageQueryData.getBody()) q[URL_PARAM_BODY] = messageQueryData.getBody();
        if (messageQueryData.getDateFrom()) q[URL_PARAM_DATE_FROM] = messageQueryData.getDateFrom();
        if (messageQueryData.getDateTo()) q[URL_PARAM_DATE_TO] = messageQueryData.getDateTo();
        if (messageQueryData.getFolderId()) q[URL_PARAM_FOLDER_ID] = messageQueryData.getFolderId();
        if (messageQueryData.getRegistrarPersonPK()) q[URL_PARAM_REGISTRAR_PERSON_PK] = messageQueryData.getRegistrarPersonPK();
        if (messageQueryData.getProjectStagePK()) q[URL_PARAM_PROJECT_STAGE_PK] = messageQueryData.getProjectStagePK();
        if (messageQueryData.getAttachment()) q[URL_PARAM_ATTACHMENT] = messageQueryData.getAttachment();
        if (messageQueryData.getIncludeSubFolders()) q[URL_PARAM_INCLUDE_SUB_FOLDERS_SEARCH] = messageQueryData.getIncludeSubFolders();
        if (messageQueryData.getHasAttachments() !== null) q[URL_PARAM_HAS_ATTACHMENTS] = messageQueryData.getHasAttachments();
        if (messageQueryData.getIsRegistered() !== null) q[URL_PARAM_IS_REGISTERED] = messageQueryData.getIsRegistered();

        this.urlConnection.setQuery(q);
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return Message;
});
},
'api/mail/search/parser/Message':function(){
define([
    '../data/Message',
    '../../parser/MessageContact'
], function(MessageVO, MessageContactParser) {
    const Message = function() {
        this.messageContactParser = new MessageContactParser();

        this._createMessageContactVOs = function(contacts) {
            const array = [];

            if (contacts instanceof Array) {
                for (var i = 0; i < contacts.length; i++) {
                    array.push(this._createMessageContactVOFromString(contacts[i]));
                }
            } else {
                array.push(this._createMessageContactVOFromString(contacts));
            }

            return array;
        };

        this._createMessageContactVOFromString = function(contactString) {
            return this.messageContactParser.parse(contactString);
        };
    };
    
    Message.prototype.parse = function(item) {
        let toArray = [];
        if (item.to) {
            toArray = this._createMessageContactVOs(item.to);
        }

        const m = new MessageVO();
        m.setMailbox(item.mailbox || null);
        m.setDate(item.date ? new Date(item.date) : null);
        m.setFolderId(item.folderId || null);
        m.setFolderName(item.folderName || null);
        m.setIsFlagged(item.isFlagged || false);
        m.setIsRead(item.isRead || false);
        m.setMessageId(item.messageId || null);
        m.setUid(item.uid || null);
        m.setSubject(item.subject || null);
        m.setSnippet(item.snippet || null);
        m.setFrom(item.from ? this._createMessageContactVOFromString(item.from) : null);
        m.setTo(toArray);
        m.setHasAttachments(item.hasAttachments || false);
        m.setFromClient(item.isFromClient || false);
        m.setProjectStagePK(item.projectStagePK || null);
        m.setProjectStage(item.projectStage || null);
        m.setProjectStageNumber(item.projectStageNumber || null);
        m.setIsReadOnly(item.isReadOnly || false);

        return m;
    };

    return Message;
});
},
'api/mail/search/data/Message':function(){
define([], function() {
    const Message = function() {
        this.mailbox = null;
        this.date = null;
        this.folderId = null;
        this.folderName = null;
        this.isFlaggedAttr = false;
        this.isReadAttr = false;
        this.messageId = null;
        this.uid = null;
        this.subject = null;
        this.snippet = null;
        this.from = null;
        this.to = [];
        this.hasAttachmentsAttr = false;
        this.fromClient = false;
        this.projectStagePK = null;
        this.projectStage = null;
        this.projectStageNumber = null;
        this.isReadOnlyAttr = false;
    };

    Message.prototype.getMailbox = function() {
        return this.mailbox;
    };

    Message.prototype.setMailbox = function(mailbox) {
        this.mailbox = mailbox;
        return this;
    };

    Message.prototype.getDate = function() {
        return this.date;
    };

    Message.prototype.setDate = function(date) {
        this.date = date;
        return this;
    };

    Message.prototype.getFolderId = function() {
        return this.folderId;
    };

    Message.prototype.setFolderId = function(folderId) {
        this.folderId = folderId;
        return this;
    };

    Message.prototype.getFolderName = function() {
        return this.folderName;
    };

    Message.prototype.setFolderName = function(folderName) {
        this.folderName = folderName;
        return this;
    };

    Message.prototype.isFlagged = function() {
        return this.isFlaggedAttr;
    };

    Message.prototype.setIsFlagged = function(isFlagged) {
        this.isFlaggedAttr = isFlagged;
        return this;
    };

    Message.prototype.isRead = function() {
        return this.isReadAttr;
    };

    Message.prototype.setIsRead = function(isRead) {
        this.isReadAttr = isRead;
        return this;
    };

    Message.prototype.getMessageId = function() {
        return this.messageId;
    };

    Message.prototype.setMessageId = function(messageId) {
        this.messageId = messageId;
        return this;
    };

    Message.prototype.getUid = function() {
        return this.uid;
    };

    Message.prototype.setUid = function(uid) {
        this.uid = uid;
        return this;
    };

    Message.prototype.getSubject = function() {
        return this.subject;
    };

    Message.prototype.setSubject = function(subject) {
        this.subject = subject;
        return this;
    };

    Message.prototype.getSnippet = function() {
        return this.snippet;
    };

    Message.prototype.setSnippet = function(snippet) {
        this.snippet = snippet;
        return this;
    };

    Message.prototype.getFrom = function() {
        return this.from;
    };

    Message.prototype.setFrom = function(from) {
        this.from = from;
        return this;
    };

    Message.prototype.getTo = function() {
        return this.to;
    };

    Message.prototype.setTo = function(to) {
        this.to = to;
        return this;
    };

    Message.prototype.hasAttachments = function() {
        return this.hasAttachmentsAttr;
    };

    Message.prototype.setHasAttachments = function(hasAttachments) {
        this.hasAttachmentsAttr = hasAttachments;
        return this;
    };

    Message.prototype.isFromClient = function() {
        return this.fromClient;
    };

    Message.prototype.setFromClient = function(fromClient) {
        this.fromClient = fromClient;
        return this;
    };

    Message.prototype.getProjectStagePK = function() {
        return this.projectStagePK;
    };

    Message.prototype.setProjectStagePK = function(projectStagePK) {
        this.projectStagePK = projectStagePK;
        return this;
    };

    Message.prototype.getProjectStage = function() {
        return this.projectStage;
    };

    Message.prototype.setProjectStage = function(projectStage) {
        this.projectStage = projectStage;
        return this;
    };

    Message.prototype.getProjectStageNumber = function() {
        return this.projectStageNumber;
    };

    Message.prototype.setProjectStageNumber = function(projectStageNumber) {
        this.projectStageNumber = projectStageNumber;
        return this;
    };

    Message.prototype.isReadOnly = function() {
        return this.isReadOnlyAttr;
    };

    Message.prototype.setIsReadOnly = function(isReadOnly) {
        this.isReadOnlyAttr = isReadOnly;
        return this;
    };

    return Message;
});
},
'library/request/fetch/Factory':function(){
/// <amd-dependency path="library/request/helper/DefaultUnauthorisedHandler" name="DefaultUnauthorisedHandler" />
define(["require", "exports", "library/request/helper/DefaultUnauthorisedHandler", "./Processor", "../../AbortControllerFactory", "./Wrapper"], function (require, exports, DefaultUnauthorisedHandler, Processor, AbortControllerFactory, Wrapper_1) {
    "use strict";
    class Factory {
        constructor() {
            this.defaultUnauthorisedHandler = new DefaultUnauthorisedHandler();
            this.abortControllerFactory = new AbortControllerFactory();
        }
        get() {
            return new Processor(this.defaultUnauthorisedHandler, Wrapper_1.request, this.abortControllerFactory);
        }
    }
    return Factory;
});

},
'library/request/helper/DefaultUnauthorisedHandler':function(){
define([
    './DefaultUnauthorisedCallback',
    'style-guide/v1/notifications/Notification'
], function (
    defaultUnauthorisedCallback,
    Notification
) {
    const NOTIFICATION_TIME_TO_DISPLAY = 5000;

    return class DefaultUnauthorisedHandler {
        constructor() {
            this.redirecting = false;
            this.notification = new Notification(
                'library/request/helper/templates/',
                {
                    REAUTHENTICATE_INFO: 'ReauthenticateInfo.html'
                }
            );
        }

        redirect(timeToDisplay) {
            if (this.redirecting) {
                return;
            }

            this.redirecting = true;
            this.notification.information('REAUTHENTICATE_INFO', null, null, timeToDisplay ? timeToDisplay : NOTIFICATION_TIME_TO_DISPLAY);

            setTimeout(() => {
                defaultUnauthorisedCallback()
            }, timeToDisplay ? timeToDisplay : NOTIFICATION_TIME_TO_DISPLAY);

            throw new Error('Client unauthorised. Redirecting to login.');
        }
    }
});
},
'library/request/helper/DefaultUnauthorisedCallback':function(){
define([], function() {
    const LOGOUT_ROUTE = '/auth/logout';

    return function() {
        window.location.replace(LOGOUT_ROUTE + '?referrer=' + window.location.href);
    };
});
},
'style-guide/v1/notifications/Notification':function(){
define([
    'dojo/topic',
    'vendor/ejs/ejs',
    'require',
    'spencer/utility/UUIDGenerator'
], function(
    topic,
    ejs,
    require,
    UUIDGenerator
) {
    const Notification = function(TEMPLATE_PATH, TEMPLATES) {
        this.constants = {
            TIME_TO_DISPLAY: {
                'SUCCESS': 2000,
                'INFORMATION': 2000,
                'WARNING': 4000
            },
            TEXT_PLUGIN: 'dojo/text!'
        };

        this.templatePath = TEMPLATE_PATH;
        this.templates = TEMPLATES;
        this.uuidGenerator = new UUIDGenerator();

        this._showNotification = function(type, templateKey, data, timeToDisplay) {
            require([
                this.constants.TEXT_PLUGIN + this.templatePath + this.templates[templateKey]
            ], function(template) {
                topic.publish(
                    'sos-system-notification',
                    ejs.render(template, data),
                    type,
                    timeToDisplay || timeToDisplay === 0 ? timeToDisplay : this.constants.TIME_TO_DISPLAY[type.toUpperCase()],
                    data.icon ? data.icon : null,
                    data.callback ? data.callback : null
                );
            }.bind(this));
        };

        this._showProgressNotification = function(uid, templateKey, data, hideable) {
            require([
                this.constants.TEXT_PLUGIN + this.templatePath + this.templates[templateKey]
            ], function(template) {
                topic.publish(
                    'sos-system-notification-progress',
                    ejs.render(template, data),
                    uid,
                    { hideable: !!hideable }
                );
            }.bind(this));
        };

        this._updateProgressPercentage = function(uid, percentage) {
            topic.publish(
                'sos-system-notification-progress-update',
                uid,
                percentage
            );
        };

        this._finaliseProgressNotification = function(uid, type, templateKey, data, timeToDisplay) {
            require([
                this.constants.TEXT_PLUGIN + this.templatePath + this.templates[templateKey]
            ], function(template) {
                topic.publish(
                    'sos-system-notification-progress-complete',
                    uid,
                    ejs.render(template, data),
                    type,
                    timeToDisplay || timeToDisplay === 0 ? timeToDisplay : this.constants.TIME_TO_DISPLAY[type.toUpperCase()]
                );
            }.bind(this));
        };
    };

    Notification.prototype.success = function(templateKey, data, uid, timeToDisplay) {
        if (!data) data = {};

        if (uid) {
            this._finaliseProgressNotification(uid, 'success', templateKey, data, timeToDisplay);
            return;
        }

        this._showNotification('success', templateKey, data, timeToDisplay);
    };

    Notification.prototype.hideableProgress = function(templateKey, data) {
        if (!data) data = {};

        const uid = this.uuidGenerator.generate();
        this._showProgressNotification(uid, templateKey, data, true);
        return uid;
    };

    Notification.prototype.progress = function(templateKey, data) {
        if (!data) data = {};

        const uid = this.uuidGenerator.generate();
        this._showProgressNotification(uid, templateKey, data);
        return uid;
    };

    Notification.prototype.progressPercentageUpdate = function(uid, percentage) {
        this._updateProgressPercentage(uid, percentage);
    };

    Notification.prototype.error = function(templateKey, data, uid, timeToDisplay) {
        if (!data) {
            data = {};
        }

        if (uid) {
            this._finaliseProgressNotification(uid, 'error', templateKey, data, timeToDisplay);
            return;
        }

        this._showNotification('error', templateKey, data, timeToDisplay);
    };

    Notification.prototype.information = function(templateKey, data, uid, timeToDisplay) {
        if (!data) {
            data = {};
        }

        if (uid) {
            this._finaliseProgressNotification(uid, 'information', templateKey, data, timeToDisplay);
            return;
        }

        this._showNotification('information', templateKey, data, timeToDisplay);
    };

    Notification.prototype.warning = function(templateKey, data, uid, timeToDisplay) {
        if (!data) data = {};

        if (uid) {
            this._finaliseProgressNotification(uid, 'warning', templateKey, data, timeToDisplay);
            return;
        }

        this._showNotification('warning', templateKey, data, timeToDisplay);
    };

    Notification.prototype.hideProgress = function(uid) {
        topic.publish('sos-system-notification-progress-cancel', uid);
    };

    Notification.prototype.closeAll = function(uid) {
        topic.publish('sos-system-notification-close-all', uid);
    };

    return Notification;
});

},
'spencer/utility/UUIDGenerator':function(){
define([], function(){
    const UUIDGenerator = function() {
        this.UUID_TEMPLATE = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    };

    UUIDGenerator.prototype.generate = function() {
        let d = new Date().getTime();
        return this.UUID_TEMPLATE.replace(/[xy]/g, function(c) {
            let r = (d + Math.random()*16)%16 | 0;
            d = Math.floor(d/16);
            return (c=='x' ? r : (r&0x3|0x8)).toString(16);
        });
    };

    return UUIDGenerator;
});

},
'library/request/fetch/Processor':function(){
define(["require", "exports", "library/request/data/HTTPResponseCodes"], function (require, exports, HTTP_RESPONSE_CODES) {
    "use strict";
    class Processor {
        constructor(defaultUnauthorisedHandler, requestHandler, abortControllerFactory) {
            this.defaultUnauthorisedHandler = defaultUnauthorisedHandler;
            this.requestHandler = requestHandler;
            this.abortControllerFactory = abortControllerFactory;
            this.cancelled = false;
            this.abortController = abortControllerFactory.get();
            this.responseHandlers = new Map();
        }
        setHandler(responseCode, handler) {
            this.responseHandlers.set(responseCode, handler);
            return this;
        }
        setSuccessHandler(successHandler) {
            this.successHandler = successHandler;
            return this;
        }
        setErrorHandler(errorHandler) {
            this.errorHandler = errorHandler;
            return this;
        }
        async get(url, options) {
            return this.processRequest('GET', url, options);
        }
        async post(url, options) {
            return this.processRequest('POST', url, options);
        }
        async put(url, options) {
            return this.processRequest('PUT', url, options);
        }
        async del(url, options) {
            return this.processRequest('DELETE', url, options);
        }
        async options(url, options) {
            return this.processRequest('OPTIONS', url, options);
        }
        async patch(url, options) {
            return this.processRequest('PATCH', url, options);
        }
        cancel() {
            this.cancelled = true;
            this.abortController.abort('Request cancelled');
        }
        isCancelled() {
            return this.cancelled;
        }
        async processRequest(method, url, options) {
            this.cancelled = false;
            const generatedOptions = this.generateOptions(method, options);
            return this.processResponse(url, generatedOptions);
        }
        generateOptions(method, options) {
            const defaultOptions = {
                method: method,
                signal: this.abortController.signal
            };
            if (!options) {
                return defaultOptions;
            }
            return Object.assign(options, defaultOptions);
        }
        async processResponse(url, generatedOptions) {
            const response = await this.requestHandler(url, generatedOptions);
            if (this.responseHandlers.has(response.status)) {
                return this.responseHandlers.get(response.status)(response);
            }
            if (response.status === HTTP_RESPONSE_CODES.unauthorized) {
                this.defaultUnauthorisedHandler.redirect();
                return;
            }
            if (this.successHandler && response.ok) {
                return this.successHandler(response);
            }
            if (response.ok) {
                return;
            }
            if (this.errorHandler && Processor.shouldCallErrorHandler(response.status)) {
                await this.errorHandler(response);
                return;
            }
            throw new Error(`No handler found for response code ${response.status}`);
        }
        static shouldCallErrorHandler(status) {
            return status >= 400;
        }
    }
    return Processor;
});

},
'library/request/data/HTTPResponseCodes':function(){
define(["require", "exports", "@lib/request/data/HTTPResponseCodes"], function (require, exports, HTTPResponseCodes) {
    "use strict";
    return HTTPResponseCodes;
});

},
'library/AbortControllerFactory':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    //AbortController will break our tests until we upgrade to Node 15.0.0+
    class AbortControllerFactory {
        get() {
            return new AbortController();
        }
    }
    return AbortControllerFactory;
});

},
'library/request/fetch/Wrapper':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.request = request;
    async function request(url, options) {
        return fetch(url, options);
    }
});

},
'spencer/parse/Collection':function(){
define([], function() {
    var Collection = function(Parser) {
        this.parser = Parser;
    };

    Collection.prototype.parse = function(items) {
        var collection = [];

        for (var i = 0; i < items.length; i++) {
            collection.push(this.parser.parse(items[i]));
        }

        return collection;
    };

    return Collection;
});

},
'spencer/parse/CollectionAndTotal':function(){
define([], function() {
    const CollectionAndTotal = function(CollectionParser) {
        this.collectionParser = CollectionParser;
    };

    CollectionAndTotal.prototype.parse = function(content) {
        return {
            collection: this.collectionParser.parse(content.collection),
            total: content.total
        };
    };

    return CollectionAndTotal;
});

},
'spencer/parse/JSONParser':function(){
define([
    "./error/Parse"
], function(ParseError) {
    var JSONParser = function (parser) {
        this.parser = parser;
    };

    JSONParser.prototype.parse = function (content) {
        try {
            var jsonContent = JSON.parse(content);
        } catch (e) {
            throw new ParseError();
        }

        return this.parser.parse(jsonContent);
    };

    return JSONParser;
});
},
'spencer/parse/error/Parse':function(){
define([], function() {
    var Parse = function() {
        this.error = "parse_error";
        this.description = "Error parsing content";
    };

    Parse.prototype.getError = function() {
        return this.error;
    };

    Parse.prototype.getDescription = function() {
        return this.description;
    };

    return Parse;
});

},
'api/mail/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    const Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_attachment = 'message-attachment/';
        this.api_body = 'mail/message/body/';
        this.api_draft = 'message-draft/';
        this.api_draft_attachment = 'mail/draft/:draftId/attachment';
        this.api_draft_body = 'message-draft-body';
        this.api_draft_recipient_to = 'message-draft-recipient-to/';
        this.api_draft_recipient_cc = 'message-draft-recipient-cc/';
        this.api_filter = 'mail_filter/';
        this.api_folder = 'mailbox-folder/';
        this.api_mailbox = 'mailbox/';
        this.api_mail_message_project_detector = 'mail/message/:uid/project/detector';
        this.api_mail_group = 'mail-group-members/';
        this.api_mail_group_my_group = 'mail/group/my-group/';
        this.api_mail_my_group = 'mail-my-group-members/';
        this.api_message = 'message/';
        this.api_message_body_attachment_log = 'mail_message_body-attachment-log/';
        this.api_message_raw = 'mail/message/raw/';
        this.api_message_sibling = 'mail_message_sibling/';
        this.api_message_thread = 'mail_message_thread/';
        this.api_message_uid = 'mail/message/uid/';
        this.api_out_of_office = 'out-of-office/';
        this.api_recent_message_count = 'recent-message-count/';
        this.api_recipient_to = 'message-recipient-to/';
        this.api_recipient_cc = 'message-recipient-cc/';
        this.api_from = 'message-from/';
        this.api_search_message = 'mail/message/search/';
        this.api_send = 'message-send/';
        this.api_signature = 'message-signature/';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});

},
'api/search/Builder':function(){
define([
    './Factory'
], function(Factory) {
    /**
     * Deprecated use Factory instead.
     */
    const Builder = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.factory = new Factory(config, urlConnectionBuilder, urlResponseProcessorBuilder);
    };

    Builder.prototype.getContactCollection = function() {
        return this.factory.getContactCollection();
    };

    return Builder;
});

},
'api/search/Factory':function(){
define([
    '../parser/Collection',
    './ContactCollection',
    './parser/Contact'
], function(
    Collection, ContactCollection, ContactParser
) {
    const Factory = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Factory.prototype.getContactCollection = function() {
        return new ContactCollection(
            this.config.getUrl('api_search_contact'),
            this.urlConnectionBuilder.build(),
            new Collection(new ContactParser()),
            this.urlResponseProcessorBuilder
        )
    };

    return Factory;
});

},
'api/search/ContactCollection':function(){
define(['./filter/IncludeContactsWithoutEmail'], function(IncludeContactsWithoutEmail) {
    const ContactCollection = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this.limit = 10;
        this.offset = 0;
        this.query = null;

        this.constants = {
            URL_PARAM_QUERY: "search",
            URL_PARAM_LIMIT: "limit",
            URL_PARAM_OFFSET: "offset",
            URL_PARAM_INCLUDE_CONTACTS_WITHOUT_EMAIL: "includeContactsWithoutEmail"
        };

        this.createBasicQuery = function(filterCollection) {
            const q = {};

            if (filterCollection && filterCollection.hasFilterForClass(IncludeContactsWithoutEmail)) {
                q[this.constants.URL_PARAM_INCLUDE_CONTACTS_WITHOUT_EMAIL] = true;
            }

            q[this.constants.URL_PARAM_LIMIT] = this.limit;
            q[this.constants.URL_PARAM_OFFSET] = this.offset;

            if (this.query && this.query != "") {
                q[this.constants.URL_PARAM_QUERY] = this.query;
            }

            return q;
        };

        this.urlConnection.setUrl(this.url);
    };

    ContactCollection.prototype.setLimit = function(limit) {
        this.limit = limit;
    };

    ContactCollection.prototype.setOffset = function(offset) {
        this.offset = offset;
    };

    ContactCollection.prototype.setQuery = function(query) {
        this.query = query;
    };

    ContactCollection.prototype.fetch = function(handlers, filterCollection) {
        this.urlConnection.setQuery(this.createBasicQuery(filterCollection));
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return ContactCollection;
});
},
'api/search/filter/IncludeContactsWithoutEmail':function(){
define([], function() {
    return function IncludeContactsWithoutEmail() {};
});
},
'api/search/parser/Contact':function(){
define([
    "../data/Contact"
], function(ContactVO) {
    const Contact = function() {};

    const createTradesArray = function (trades) {
        const tradesArray = [];

        if (trades instanceof Array) {
            for (let i = 0; i < trades.length; i++) {
                tradesArray.push(trades[i]);
            }
        } else if (trades) {
            tradesArray.push(trades);
        }

        return tradesArray;
    };

    Contact.prototype.parse = function(item) {
        const c = new ContactVO();

        c.setId(item.id || null);
        c.setPersonPK(item.personPK || null);
        c.setOrganisationPK(item.organisationPK || null);
        c.setBranchOfficePK(item.branchOfficePK || null);
        c.setName(item.name || null);
        c.setPreferredName(item.preferredName || null);
        c.setOrganisation(item.organisation || null);
        c.setType(item.type || null);
        c.setJobTitle(item.jobTitle || null);
        c.setImageURL(item.imageURL || null);
        c.setTelephone(item.telephone || null);

        c.setTrades(createTradesArray(item.trade));

        return c;
    };

    return Contact;
});
},
'api/search/data/Contact':function(){
define([], function() {
    const Contact = function() {
        this.id = null;
        this.personPK = null;
        this.organisationPK = null;
        this.branchOfficePK = null;
        this.name = null;
        this.preferredName = null;
        this.organisation = null;
        this.type = null;
        this.jobTitle = null;
        this.trades = [];
        this.imageURL = null;
        this.telephone = null;
    };

    Contact.prototype.getId = function() {
        return this.id;
    };

    Contact.prototype.setId = function(id) {
        this.id = id;
    };

    Contact.prototype.getPersonPK = function() {
        return this.personPK;
    };

    Contact.prototype.setPersonPK = function(personPK) {
        this.personPK = personPK;
    };

    Contact.prototype.getOrganisationPK = function() {
        return this.organisationPK;
    };

    Contact.prototype.setOrganisationPK = function(organisationPK) {
        this.organisationPK = organisationPK;
    };

    Contact.prototype.getBranchOfficePK = function() {
        return this.branchOfficePK;
    };

    Contact.prototype.setBranchOfficePK = function(branchOfficePK) {
        this.branchOfficePK = branchOfficePK;
    };

    Contact.prototype.getName = function() {
        return this.name;
    };

    Contact.prototype.setName = function(name) {
        this.name = name;
    };

    Contact.prototype.getPreferredName = function() {
        return this.preferredName;
    };

    Contact.prototype.setPreferredName = function(preferredName) {
        this.preferredName = preferredName;
    };

    Contact.prototype.getOrganisation = function() {
        return this.organisation;
    };

    Contact.prototype.setOrganisation = function(organisation) {
        this.organisation = organisation;
    };

    Contact.prototype.getType = function() {
        return this.type;
    };

    Contact.prototype.setType = function(type) {
        this.type = type;
    };

    Contact.prototype.getJobTitle = function() {
        return this.jobTitle;
    };

    Contact.prototype.setJobTitle = function(jobTitle) {
        this.jobTitle = jobTitle;
    };

    Contact.prototype.getTrades = function() {
        return this.trades;
    };

    Contact.prototype.setTrades = function(trades) {
        this.trades = trades;
    };

    Contact.prototype.getImageURL = function() {
        return this.imageURL;
    };

    Contact.prototype.setImageURL = function(imageURL) {
        this.imageURL = imageURL;
    };

    Contact.prototype.getTelephone = function() {
        return this.telephone;
    };

    Contact.prototype.setTelephone = function(telephone) {
        this.telephone = telephone;
    };

    return Contact;
});
},
'api/search/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    var Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_search_contact = 'search/contact/';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});
},
'contactdetailspopup/Contact':function(){
define([
    'dojo/query',
    'dojo/dom-construct',
    'contactdetailspopup/Person',
    'contactdetailspopup/Organisation',
    'contactdetailspopup/Email',
    'contactdetailspopup/OrganisationPopup',
    'dojo/domReady!'
], function(
    query,
    domConstruct,
    personDetails,
    organisationDetails,
    emailDetails,
    organisationPopup
) {
    return {
        personDetails: null,
        organisationDetails: null,
        subcontractorDetails: null,

        /**
         * Initialise all the on click events for links that should open a contactdetailspopup in a given queryNode
         * (uses entire dom tree if queryNode is not provided)
         */
        initialise: function(queryNode) {
            this.initialisePersonDetails(queryNode);

            this.initialiseOrganisationDetails(queryNode);

            this.initialiseEmailDetails(queryNode);

            this.initialiseOrganisationPopup(queryNode);
        },

        // Initialise all the person specific contactdetailspopups
        initialisePersonDetails: function(queryNode) {
            this.getPersonDetailsPopup().initialise(queryNode);
        },

        // Returns the personDetails popup (creating first it if necessary)
        getPersonDetailsPopup: function() {
            if (!this.personDetails) {
                var div = domConstruct.create('span', {}, this.domNode, 'after');
                this.personDetails = new personDetails({}, div);
            }
            return this.personDetails;
        },

        // Initialise all the organisation/branch-office specific organisationpopup
        initialiseOrganisationDetails: function(queryNode) {
            this.getOrganisationDetailsPopup().initialise(queryNode);
        },

        // Returns the organisationDetails popup (creating first it if necessary)
        getOrganisationDetailsPopup: function() {
            if (!this.organisationDetails) {
                var div = domConstruct.create('span', {}, this.domNode, 'after');
                this.organisationDetails = new organisationDetails({}, div);
            }
            return this.organisationDetails;
        },

        // Initialise all the organisation/subcontractor specific organisationpopup
        initialiseOrganisationPopup: function(queryNode) {
            this.getOrganisationPopup().initialise(queryNode);
        },

        // Returns the subcontractorDetails popup (creating first it if necessary)
        getOrganisationPopup: function() {
            if (!this.organisationPopup) {
                var div = domConstruct.create('span', {}, this.domNode, 'after');
                this.organisationPopup = new organisationPopup({}, div);
            }
            return this.organisationPopup;
        },

        // Initialise all the email address specific contactdetailspopups
        initialiseEmailDetails: function(queryNode) {
            // Use existing personDetails and organisationDetails popups for emailDetails
            emailDetails.personDetails = this.getPersonDetailsPopup();
            emailDetails.organisationDetails = this.getOrganisationDetailsPopup();
            emailDetails.subcontractorDetails = this.getOrganisationPopup();
            emailDetails.initialise(queryNode);
        }
    };
});

},
'contactdetailspopup/Person':function(){
define([
    './WorkingHours',
    'dojo/_base/declare',
    'dojo/_base/xhr',
    'dojo/html',
    'dojo/on',
    'dojo/query',
    'dojo/dom',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/dom-style',
    'soso/dijit/TooltipDialog',
    'dijit/_WidgetBase',
    'dijit/_Templated'
], function(
    WorkingHours,
    declare,
    xhr,
    html,
    on,
    query,
    dom,
    domAttr,
    domClass,
    domStyle,
    TooltipDialog,
    _WidgetBase,
    _Templated
) {
    const EMPLOYEE_PERSON_TYPE = '5';

    return declare('contactdetailspopup.Person', [_WidgetBase, _Templated], {
        popup: null,
        target: null,
        templatePath: require.toUrl('contactdetailspopup/templates/Person.html'),
        workingHoursNode: null,

        postCreate: function() {
            this.inherited(arguments);
            this.popup =  new TooltipDialog({
                id: this.id + '_popup'
            }, this.domNode);

            domClass.add(this.popup.domNode, 'contactsPopupWrapper');

            on(this.popup, 'blur', function() {
                this.hide();
            });
        },

        initialise: function(queryNode) {
            query('a.contactpopup', queryNode).on('click', this._contactPopupLinkClick.bind(this));
        },

        _contactPopupLinkClick: function(evt) {
            evt.preventDefault();
            const item = evt.currentTarget;
            let personPK = domAttr.get(item, 'data-personpk');
            if (!personPK) {
                personPK = domAttr.get(item, 'personpk');
            }

            this.loadDetails(personPK, item);
            this.workingHours = new WorkingHours(
                {workingHoursRow: this.workingHoursRow},
                this.workingHoursNode
            );
        },

        loadDetails: function(personPK, target) {
            this.target = target;

            xhr.get({
                url: baseUrl + '/api/?method=ContactsManager.getPersonDetails&personPK=' + personPK,
                handleAs: 'json',
                load: this.getResponse.bind(this),
                error: function() {
                    alert('Error: Failed to update');
                }
            })
        },

        getResponse: function(responseObject) {
            this.load(responseObject.ContactsManager.getPersonDetails.response);
        },

        // Populate the template with person details from the xhr response
        load: function(response) {
            html.set(this.personName, response.fullName ? response.fullName : '-');
            html.set(this.jobTitle, response.displayJobTitle ? response.displayJobTitle : '-');
            html.set(this.companyName, response.companyName ? response.companyName : '-');
            html.set(this.directDial, response.directDialNumber ? response.directDialNumber : '-');
            html.set(this.extNumber, response.extensionNo);
            if (!response.email) {
                html.set(this.email, '-');
            } else if (response.isActive == 0) {
                html.set(this.email, 'This contact has been');
                html.set(this.emailNewWindow, 'marked as inactive');
            } else {
                html.set(
                    this.email,
                    '<a href="' + baseUrl + 'project-overview#email/compose/personPK/' + parseInt(response.personPK)
                    + '">Click to Email Contact</a>'
                );
                html.set(
                    this.emailNewWindow,
                    '<a href="' + baseUrl + 'project-overview#email/compose/personPK/' + parseInt(response.personPK)
                    + '" target="_blank">(in a new window)</a>'
                );
            }
            if (response.team) {
                for (var i in response.team) {
                    html.set(this.team, response.team[i].name);
                }
            }

            html.set(this.branchOffice, response.branchOfficeName);
            html.set(this.branchOfficeAddress1, response.branchOfficeAddress1);
            html.set(this.branchOfficeAddress2, response.branchOfficeAddress2);
            html.set(this.branchOfficeAddress3, response.branchOfficeAddress3);
            html.set(this.town, response.branchOfficeTown);
            html.set(this.branchOfficePostcode, response.branchOfficePostcode);
            html.set(this.branchOfficeTelephone, response.branchOfficeTelephone);
            html.set(this.branchOfficeFax, response.branchOfficeFax ? response.branchOfficeFax : '-');
            html.set(this.mob, response.mobile ?? '-');

            if (response.organisationPK == 1) {
                domStyle.set(dom.byId('tradeRow'), 'display', 'none');
            } else {
                domStyle.set(dom.byId('tradeRow'), 'display', '');
                html.set(this.trades, response.trades);
            }

            if (response.orgIntranetOwner == 1) {
                domStyle.set(this.websiteRow, 'display', 'none');
                html.set(this.website, response.orgWebsite);
            } else {
                domStyle.set(this.websiteRow, 'display', '');
                domAttr.set(this.website, 'innerHTML', response.orgWebsite);
                domAttr.set(this.website, 'href', response.orgWebsite);
            }

            const fromAutoFilter = response.displayName + ' - '
                           + (response.preferredCompanyName ? response.preferredCompanyName : response.companyName);

            domAttr.set(
                this.docs,
                'href',
                baseUrl + 'doccontrol/?action=search&fromAutoFilter='
                        + encodeURIComponent(fromAutoFilter)
                        + '&matchAny=1&searchWithin=all&clearFilters=1&resetSearch=1'
            );

            if (response.type === EMPLOYEE_PERSON_TYPE) {
                this.workingHours.show(response.personPK);
            }

            this.popup.show({
                popup: this.popup,
                around: this.target
            });
        }
    });
});

},
'contactdetailspopup/WorkingHours':function(){
define([
    'dijit/_WidgetBase',
    'dojo/_base/declare',
    'dojo/text!./templates/WorkingHours.html',
    'library/request/fetch/Factory',
    'soso/sosox/ejs/_Templated'
], function (
    _WidgetBase,
    declare,
    template,
    FetchFactory,
    _Templated
) {
    const WEEKDAYS = [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday'
    ];

    return declare([_WidgetBase, _Templated], {
        personPK: null,

        fetchProcessor: null,

        templateString: template,

        workingHoursRow: null,

        postCreate: function() {
            this.fetchProcessor = new FetchFactory().get();
        },

        show: function(personPK) {
            this._initialise(personPK);
        },

        _initialise: function(personPK) {
            this._showWorkingHours();
            this._initialiseWorkingDayNodes();
            this.fetchProcessor.setSuccessHandler(async response => {
                const workingDays = (await response.json())['workingDays'];
                if (workingDays && workingDays.length > 0) {
                    this._handleDays(workingDays);
                } else {
                    this._hideWorkingHours();
                }
            });

            this.fetchProcessor.get('/v2/person/employment-history/' + personPK, {});
        },

        _hideWorkingHours: function() {
            this.workingHoursRow.classList.add('hide');
        },

        _showWorkingHours: function() {
            this.workingHoursRow.classList.remove('hide');
        },

        _initialiseWorkingDayNodes: function() {
            WEEKDAYS.forEach(day => this._dayQuery(day).innerHTML = '-');
        },

        _handleDays: function(days) {
            days.forEach(day => {
                if (this._parsedAsPM(day) || this._parsedAsAM(day)) {
                    return;
                }

                this._parseAsAllDay(day);
            });
        },

        _dayQuery: function(day) {
            return document.querySelector(`.working-hours-grid-container > .body > .${day}`)
        },

        _parsedAsPM: function(day) {
            const startHour = day.start.split(':')[0];
            if (parseInt(startHour) > 11) {
                this._dayQuery(day.day).innerHTML = 'PM';
                return true;
            }

            return false;
        },

        _parsedAsAM: function(day) {
            const endParts = day.end.split(':');
            if (parseInt(endParts[0]) < 12 || (parseInt(endParts[0]) === 12 && parseInt(endParts[1]) === 0)) {
                this._dayQuery(day.day).innerHTML = 'AM';
                return true;
            }

            return false;
        },

        _parseAsAllDay: function(day) {
            this._dayQuery(day.day).innerHTML = 'AD';
        }
    })
});

},
'dijit/_WidgetBase':function(){
define([
	"require", // require.toUrl
	"dojo/_base/array", // array.forEach array.map
	"dojo/aspect",
	"dojo/_base/config", // config.blankGif
	"dojo/_base/connect", // connect.connect
	"dojo/_base/declare", // declare
	"dojo/dom", // dom.byId
	"dojo/dom-attr", // domAttr.set domAttr.remove
	"dojo/dom-class", // domClass.add domClass.replace
	"dojo/dom-construct", // domConstruct.destroy domConstruct.place
	"dojo/dom-geometry", // isBodyLtr
	"dojo/dom-style", // domStyle.set, domStyle.get
	"dojo/has",
	"dojo/_base/kernel",
	"dojo/_base/lang", // mixin(), isArray(), etc.
	"dojo/on",
	"dojo/ready",
	"dojo/Stateful", // Stateful
	"dojo/topic",
	"dojo/_base/window", // win.body()
	"./Destroyable",
	"dojo/has!dojo-bidi?./_BidiMixin",
	"./registry"    // registry.getUniqueId(), registry.findWidgets()
], function(require, array, aspect, config, connect, declare,
			dom, domAttr, domClass, domConstruct, domGeometry, domStyle, has, kernel,
			lang, on, ready, Stateful, topic, win, Destroyable, _BidiMixin, registry){

	// module:
	//		dijit/_WidgetBase

	// Flag to make dijit load modules the app didn't explicitly request, for backwards compatibility
	has.add("dijit-legacy-requires", !kernel.isAsync);

	// Flag to enable support for textdir attribute
	has.add("dojo-bidi", false);


	// For back-compat, remove in 2.0.
	if(has("dijit-legacy-requires")){
		ready(0, function(){
			var requires = ["dijit/_base/manager"];
			require(requires);	// use indirection so modules not rolled into a build
		});
	}

	// Nested hash listing attributes for each tag, all strings in lowercase.
	// ex: {"div": {"style": true, "tabindex" true}, "form": { ...
	var tagAttrs = {};

	function getAttrs(obj){
		var ret = {};
		for(var attr in obj){
			ret[attr.toLowerCase()] = true;
		}
		return ret;
	}

	function nonEmptyAttrToDom(attr){
		// summary:
		//		Returns a setter function that copies the attribute to this.domNode,
		//		or removes the attribute from this.domNode, depending on whether the
		//		value is defined or not.
		return function(val){
			domAttr[val ? "set" : "remove"](this.domNode, attr, val);
			this._set(attr, val);
		};
	}

	function isEqual(a, b){
		//	summary:
		//		Function that determines whether two values are identical,
		//		taking into account that NaN is not normally equal to itself
		//		in JS.

		return a === b || (/* a is NaN */ a !== a && /* b is NaN */ b !== b);
	}

	var _WidgetBase = declare("dijit._WidgetBase", [Stateful, Destroyable], {
		// summary:
		//		Future base class for all Dijit widgets.
		// description:
		//		Future base class for all Dijit widgets.
		//		_Widget extends this class adding support for various features needed by desktop.
		//
		//		Provides stubs for widget lifecycle methods for subclasses to extend, like postMixInProperties(), buildRendering(),
		//		postCreate(), startup(), and destroy(), and also public API methods like set(), get(), and watch().
		//
		//		Widgets can provide custom setters/getters for widget attributes, which are called automatically by set(name, value).
		//		For an attribute XXX, define methods _setXXXAttr() and/or _getXXXAttr().
		//
		//		_setXXXAttr can also be a string/hash/array mapping from a widget attribute XXX to the widget's DOMNodes:
		//
		//		- DOM node attribute
		// |		_setFocusAttr: {node: "focusNode", type: "attribute"}
		// |		_setFocusAttr: "focusNode"	(shorthand)
		// |		_setFocusAttr: ""		(shorthand, maps to this.domNode)
		//		Maps this.focus to this.focusNode.focus, or (last example) this.domNode.focus
		//
		//		- DOM node innerHTML
		//	|		_setTitleAttr: { node: "titleNode", type: "innerHTML" }
		//		Maps this.title to this.titleNode.innerHTML
		//
		//		- DOM node innerText
		//	|		_setTitleAttr: { node: "titleNode", type: "innerText" }
		//		Maps this.title to this.titleNode.innerText
		//
		//		- DOM node CSS class
		// |		_setMyClassAttr: { node: "domNode", type: "class" }
		//		Maps this.myClass to this.domNode.className
		//
		//		- Toggle DOM node CSS class
		// |		_setMyClassAttr: { node: "domNode", type: "toggleClass" }
		//		Toggles myClass on this.domNode by this.myClass
		//
		//		If the value of _setXXXAttr is an array, then each element in the array matches one of the
		//		formats of the above list.
		//
		//		If the custom setter is null, no action is performed other than saving the new value
		//		in the widget (in this).
		//
		//		If no custom setter is defined for an attribute, then it will be copied
		//		to this.focusNode (if the widget defines a focusNode), or this.domNode otherwise.
		//		That's only done though for attributes that match DOMNode attributes (title,
		//		alt, aria-labelledby, etc.)

		// id: [const] String
		//		A unique, opaque ID string that can be assigned by users or by the
		//		system. If the developer passes an ID which is known not to be
		//		unique, the specified ID is ignored and the system-generated ID is
		//		used instead.
		id: "",
		_setIdAttr: "domNode", // to copy to this.domNode even for auto-generated id's

		// lang: [const] String
		//		Rarely used.  Overrides the default Dojo locale used to render this widget,
		//		as defined by the [HTML LANG](http://www.w3.org/TR/html401/struct/dirlang.html#adef-lang) attribute.
		//		Value must be among the list of locales specified during by the Dojo bootstrap,
		//		formatted according to [RFC 3066](http://www.ietf.org/rfc/rfc3066.txt) (like en-us).
		lang: "",
		// set on domNode even when there's a focus node.	but don't set lang="", since that's invalid.
		_setLangAttr: nonEmptyAttrToDom("lang"),

		// dir: [const] String
		//		Bi-directional support, as defined by the [HTML DIR](http://www.w3.org/TR/html401/struct/dirlang.html#adef-dir)
		//		attribute. Either left-to-right "ltr" or right-to-left "rtl".  If undefined, widgets renders in page's
		//		default direction.
		dir: "",
		// set on domNode even when there's a focus node.	but don't set dir="", since that's invalid.
		_setDirAttr: nonEmptyAttrToDom("dir"), // to set on domNode even when there's a focus node

		// class: String
		//		HTML class attribute
		"class": "",
		_setClassAttr: { node: "domNode", type: "class" },

		// Override automatic assigning type --> focusNode, it causes exception on IE6-8.
		// Instead, type must be specified as ${type} in the template, as part of the original DOM.
		_setTypeAttr: null,

		// style: String||Object
		//		HTML style attributes as cssText string or name/value hash
		style: "",

		// title: String
		//		HTML title attribute.
		//
		//		For form widgets this specifies a tooltip to display when hovering over
		//		the widget (just like the native HTML title attribute).
		//
		//		For TitlePane or for when this widget is a child of a TabContainer, AccordionContainer,
		//		etc., it's used to specify the tab label, accordion pane title, etc.  In this case it's
		//		interpreted as HTML.
		title: "",

		// tooltip: String
		//		When this widget's title attribute is used to for a tab label, accordion pane title, etc.,
		//		this specifies the tooltip to appear when the mouse is hovered over that text.
		tooltip: "",

		// baseClass: [protected] String
		//		Root CSS class of the widget (ex: dijitTextBox), used to construct CSS classes to indicate
		//		widget state.
		baseClass: "",

		// srcNodeRef: [readonly] DomNode
		//		pointer to original DOM node
		srcNodeRef: null,

		// domNode: [readonly] DomNode
		//		This is our visible representation of the widget! Other DOM
		//		Nodes may by assigned to other properties, usually through the
		//		template system's data-dojo-attach-point syntax, but the domNode
		//		property is the canonical "top level" node in widget UI.
		domNode: null,

		// containerNode: [readonly] DomNode
		//		Designates where children of the source DOM node will be placed.
		//		"Children" in this case refers to both DOM nodes and widgets.
		//		For example, for myWidget:
		//
		//		|	<div data-dojo-type=myWidget>
		//		|		<b> here's a plain DOM node
		//		|		<span data-dojo-type=subWidget>and a widget</span>
		//		|		<i> and another plain DOM node </i>
		//		|	</div>
		//
		//		containerNode would point to:
		//
		//		|		<b> here's a plain DOM node
		//		|		<span data-dojo-type=subWidget>and a widget</span>
		//		|		<i> and another plain DOM node </i>
		//
		//		In templated widgets, "containerNode" is set via a
		//		data-dojo-attach-point assignment.
		//
		//		containerNode must be defined for any widget that accepts innerHTML
		//		(like ContentPane or BorderContainer or even Button), and conversely
		//		is null for widgets that don't, like TextBox.
		containerNode: null,

		// ownerDocument: [const] Document?
		//		The document this widget belongs to.  If not specified to constructor, will default to
		//		srcNodeRef.ownerDocument, or if no sourceRef specified, then to the document global
		ownerDocument: null,
		_setOwnerDocumentAttr: function(val){
			// this setter is merely to avoid automatically trying to set this.domNode.ownerDocument
			this._set("ownerDocument", val);
		},

		/*=====
		// _started: [readonly] Boolean
		//		startup() has completed.
		_started: false,
		=====*/

		// attributeMap: [protected] Object
		//		Deprecated.	Instead of attributeMap, widget should have a _setXXXAttr attribute
		//		for each XXX attribute to be mapped to the DOM.
		//
		//		attributeMap sets up a "binding" between attributes (aka properties)
		//		of the widget and the widget's DOM.
		//		Changes to widget attributes listed in attributeMap will be
		//		reflected into the DOM.
		//
		//		For example, calling set('title', 'hello')
		//		on a TitlePane will automatically cause the TitlePane's DOM to update
		//		with the new title.
		//
		//		attributeMap is a hash where the key is an attribute of the widget,
		//		and the value reflects a binding to a:
		//
		//		- DOM node attribute
		// |		focus: {node: "focusNode", type: "attribute"}
		//		Maps this.focus to this.focusNode.focus
		//
		//		- DOM node innerHTML
		//	|		title: { node: "titleNode", type: "innerHTML" }
		//		Maps this.title to this.titleNode.innerHTML
		//
		//		- DOM node innerText
		//	|		title: { node: "titleNode", type: "innerText" }
		//		Maps this.title to this.titleNode.innerText
		//
		//		- DOM node CSS class
		// |		myClass: { node: "domNode", type: "class" }
		//		Maps this.myClass to this.domNode.className
		//
		//		If the value is an array, then each element in the array matches one of the
		//		formats of the above list.
		//
		//		There are also some shorthands for backwards compatibility:
		//
		//		- string --> { node: string, type: "attribute" }, for example:
		//
		//	|	"focusNode" ---> { node: "focusNode", type: "attribute" }
		//
		//		- "" --> { node: "domNode", type: "attribute" }
		attributeMap: {},

		// _blankGif: [protected] String
		//		Path to a blank 1x1 image.
		//		Used by `<img>` nodes in templates that really get their image via CSS background-image.
		_blankGif: config.blankGif || require.toUrl("dojo/resources/blank.gif"),

		// textDir: String
		//		Bi-directional support,	the main variable which is responsible for the direction of the text.
		//		The text direction can be different than the GUI direction by using this parameter in creation
		//		of a widget.
		//
		//		This property is only effective when `has("dojo-bidi")` is defined to be true.
		//
		//		Allowed values:
		//
		//		1. "" - default value; text is same direction as widget
		//		2. "ltr"
		//		3. "rtl"
		//		4. "auto" - contextual the direction of a text defined by first strong letter.
		textDir: "",

		//////////// INITIALIZATION METHODS ///////////////////////////////////////

		/*=====
		constructor: function(params, srcNodeRef){
			// summary:
			//		Create the widget.
			// params: Object|null
			//		Hash of initialization parameters for widget, including scalar values (like title, duration etc.)
			//		and functions, typically callbacks like onClick.
			//		The hash can contain any of the widget's properties, excluding read-only properties.
			// srcNodeRef: DOMNode|String?
			//		If a srcNodeRef (DOM node) is specified:
			//
			//		- use srcNodeRef.innerHTML as my contents
			//		- if this is a behavioral widget then apply behavior to that srcNodeRef
			//		- otherwise, replace srcNodeRef with my generated DOM tree
		},
		=====*/

		_introspect: function(){
			// summary:
			//		Collect metadata about this widget (only once per class, not once per instance):
			//
			//			- list of attributes with custom setters, storing in this.constructor._setterAttrs
			//			- generate this.constructor._onMap, mapping names like "mousedown" to functions like onMouseDown

			var ctor = this.constructor;
			if(!ctor._setterAttrs){
				var proto = ctor.prototype,
					attrs = ctor._setterAttrs = [], // attributes with custom setters
					onMap = (ctor._onMap = {});

				// Items in this.attributeMap are like custom setters.  For back-compat, remove for 2.0.
				for(var name in proto.attributeMap){
					attrs.push(name);
				}

				// Loop over widget properties, collecting properties with custom setters and filling in ctor._onMap.
				for(name in proto){
					if(/^on/.test(name)){
						onMap[name.substring(2).toLowerCase()] = name;
					}

					if(/^_set[A-Z](.*)Attr$/.test(name)){
						name = name.charAt(4).toLowerCase() + name.substr(5, name.length - 9);
						if(!proto.attributeMap || !(name in proto.attributeMap)){
							attrs.push(name);
						}
					}
				}

				// Note: this isn't picking up info on properties like aria-label and role, that don't have custom setters
				// but that set() maps to attributes on this.domNode or this.focusNode
			}
		},

		postscript: function(/*Object?*/params, /*DomNode|String*/srcNodeRef){
			// summary:
			//		Kicks off widget instantiation.  See create() for details.
			// tags:
			//		private

			// Note that we skip calling this.inherited(), i.e. dojo/Stateful::postscript(), because 1.x widgets don't
			// expect their custom setters to get called until after buildRendering().  Consider changing for 2.0.

			this.create(params, srcNodeRef);
		},

		create: function(params, srcNodeRef){
			// summary:
			//		Kick off the life-cycle of a widget
			// description:
			//		Create calls a number of widget methods (postMixInProperties, buildRendering, postCreate,
			//		etc.), some of which of you'll want to override. See http://dojotoolkit.org/reference-guide/dijit/_WidgetBase.html
			//		for a discussion of the widget creation lifecycle.
			//
			//		Of course, adventurous developers could override create entirely, but this should
			//		only be done as a last resort.
			// params: Object|null
			//		Hash of initialization parameters for widget, including scalar values (like title, duration etc.)
			//		and functions, typically callbacks like onClick.
			//		The hash can contain any of the widget's properties, excluding read-only properties.
			// srcNodeRef: DOMNode|String?
			//		If a srcNodeRef (DOM node) is specified:
			//
			//		- use srcNodeRef.innerHTML as my contents
			//		- if this is a behavioral widget then apply behavior to that srcNodeRef
			//		- otherwise, replace srcNodeRef with my generated DOM tree
			// tags:
			//		private

			// First time widget is instantiated, scan prototype to figure out info about custom setters etc.
			this._introspect();

			// store pointer to original DOM tree
			this.srcNodeRef = dom.byId(srcNodeRef);

			// No longer used, remove for 2.0.
			this._connects = [];
			this._supportingWidgets = [];

			// this is here for back-compat, remove in 2.0 (but check NodeList-instantiate.html test)
			if(this.srcNodeRef && this.srcNodeRef.id  && (typeof this.srcNodeRef.id == "string")){
				this.id = this.srcNodeRef.id;
			}

			// mix in our passed parameters
			if(params){
				this.params = params;
				lang.mixin(this, params);
			}
			this.postMixInProperties();

			// Generate an id for the widget if one wasn't specified, or it was specified as id: undefined.
			// Do this before buildRendering() because it might expect the id to be there.
			if(!this.id){
				this.id = registry.getUniqueId(this.declaredClass.replace(/\./g, "_"));
				if(this.params){
					// if params contains {id: undefined}, prevent _applyAttributes() from processing it
					delete this.params.id;
				}
			}

			// The document and <body> node this widget is associated with
			this.ownerDocument = this.ownerDocument || (this.srcNodeRef ? this.srcNodeRef.ownerDocument : document);
			this.ownerDocumentBody = win.body(this.ownerDocument);

			registry.add(this);

			this.buildRendering();

			var deleteSrcNodeRef;

			if(this.domNode){
				// Copy attributes listed in attributeMap into the [newly created] DOM for the widget.
				// Also calls custom setters for all attributes with custom setters.
				this._applyAttributes();

				// If srcNodeRef was specified, then swap out original srcNode for this widget's DOM tree.
				// For 2.0, move this after postCreate().  postCreate() shouldn't depend on the
				// widget being attached to the DOM since it isn't when a widget is created programmatically like
				// new MyWidget({}).	See #11635.
				var source = this.srcNodeRef;
				if(source && source.parentNode && this.domNode !== source){
					source.parentNode.replaceChild(this.domNode, source);
					deleteSrcNodeRef = true;
				}

				// Note: for 2.0 may want to rename widgetId to dojo._scopeName + "_widgetId",
				// assuming that dojo._scopeName even exists in 2.0
				this.domNode.setAttribute("widgetId", this.id);
			}
			this.postCreate();

			// If srcNodeRef has been processed and removed from the DOM (e.g. TemplatedWidget) then delete it to allow GC.
			// I think for back-compatibility it isn't deleting srcNodeRef until after postCreate() has run.
			if(deleteSrcNodeRef){
				delete this.srcNodeRef;
			}

			this._created = true;
		},

		_applyAttributes: function(){
			// summary:
			//		Step during widget creation to copy  widget attributes to the
			//		DOM according to attributeMap and _setXXXAttr objects, and also to call
			//		custom _setXXXAttr() methods.
			//
			//		Skips over blank/false attribute values, unless they were explicitly specified
			//		as parameters to the widget, since those are the default anyway,
			//		and setting tabIndex="" is different than not setting tabIndex at all.
			//
			//		For backwards-compatibility reasons attributeMap overrides _setXXXAttr when
			//		_setXXXAttr is a hash/string/array, but _setXXXAttr as a functions override attributeMap.
			// tags:
			//		private

			// Call this.set() for each property that was either specified as parameter to constructor,
			// or is in the list found above.	For correlated properties like value and displayedValue, the one
			// specified as a parameter should take precedence.
			// Particularly important for new DateTextBox({displayedValue: ...}) since DateTextBox's default value is
			// NaN and thus is not ignored like a default value of "".

			// Step 1: Save the current values of the widget properties that were specified as parameters to the constructor.
			// Generally this.foo == this.params.foo, except if postMixInProperties() changed the value of this.foo.
			var params = {};
			for(var key in this.params || {}){
				params[key] = this._get(key);
			}

			// Step 2: Call set() for each property with a non-falsy value that wasn't passed as a parameter to the constructor
			array.forEach(this.constructor._setterAttrs, function(key){
				if(!(key in params)){
					var val = this._get(key);
					if(val){
						this.set(key, val);
					}
				}
			}, this);

			// Step 3: Call set() for each property that was specified as parameter to constructor.
			// Use params hash created above to ignore side effects from step #2 above.
			for(key in params){
				this.set(key, params[key]);
			}
		},

		postMixInProperties: function(){
			// summary:
			//		Called after the parameters to the widget have been read-in,
			//		but before the widget template is instantiated. Especially
			//		useful to set properties that are referenced in the widget
			//		template.
			// tags:
			//		protected
		},

		buildRendering: function(){
			// summary:
			//		Construct the UI for this widget, setting this.domNode.
			//		Most widgets will mixin `dijit._TemplatedMixin`, which implements this method.
			// tags:
			//		protected

			if(!this.domNode){
				// Create root node if it wasn't created by _TemplatedMixin
				this.domNode = this.srcNodeRef || this.ownerDocument.createElement("div");
			}

			// baseClass is a single class name or occasionally a space-separated list of names.
			// Add those classes to the DOMNode.  If RTL mode then also add with Rtl suffix.
			// TODO: make baseClass custom setter
			if(this.baseClass){
				var classes = this.baseClass.split(" ");
				if(!this.isLeftToRight()){
					classes = classes.concat(array.map(classes, function(name){
						return name + "Rtl";
					}));
				}
				domClass.add(this.domNode, classes);
			}
		},

		postCreate: function(){
			// summary:
			//		Processing after the DOM fragment is created
			// description:
			//		Called after the DOM fragment has been created, but not necessarily
			//		added to the document.  Do not include any operations which rely on
			//		node dimensions or placement.
			// tags:
			//		protected
		},

		startup: function(){
			// summary:
			//		Processing after the DOM fragment is added to the document
			// description:
			//		Called after a widget and its children have been created and added to the page,
			//		and all related widgets have finished their create() cycle, up through postCreate().
			//
			//		Note that startup() may be called while the widget is still hidden, for example if the widget is
			//		inside a hidden dijit/Dialog or an unselected tab of a dijit/layout/TabContainer.
			//		For widgets that need to do layout, it's best to put that layout code inside resize(), and then
			//		extend dijit/layout/_LayoutWidget so that resize() is called when the widget is visible.
			if(this._started){
				return;
			}
			this._started = true;
			array.forEach(this.getChildren(), function(obj){
				if(!obj._started && !obj._destroyed && lang.isFunction(obj.startup)){
					obj.startup();
					obj._started = true;
				}
			});
		},

		//////////// DESTROY FUNCTIONS ////////////////////////////////

		destroyRecursive: function(/*Boolean?*/ preserveDom){
			// summary:
			//		Destroy this widget and its descendants
			// description:
			//		This is the generic "destructor" function that all widget users
			//		should call to cleanly discard with a widget. Once a widget is
			//		destroyed, it is removed from the manager object.
			// preserveDom:
			//		If true, this method will leave the original DOM structure
			//		alone of descendant Widgets. Note: This will NOT work with
			//		dijit._TemplatedMixin widgets.

			this._beingDestroyed = true;
			this.destroyDescendants(preserveDom);
			this.destroy(preserveDom);
		},

		destroy: function(/*Boolean*/ preserveDom){
			// summary:
			//		Destroy this widget, but not its descendants.  Descendants means widgets inside of
			//		this.containerNode.   Will also destroy any resources (including widgets) registered via this.own().
			//
			//		This method will also destroy internal widgets such as those created from a template,
			//		assuming those widgets exist inside of this.domNode but outside of this.containerNode.
			//
			//		For 2.0 it's planned that this method will also destroy descendant widgets, so apps should not
			//		depend on the current ability to destroy a widget without destroying its descendants.   Generally
			//		they should use destroyRecursive() for widgets with children.
			// preserveDom: Boolean
			//		If true, this method will leave the original DOM structure alone.
			//		Note: This will not yet work with _TemplatedMixin widgets

			this._beingDestroyed = true;
			this.uninitialize();

			function destroy(w){
				if(w.destroyRecursive){
					w.destroyRecursive(preserveDom);
				}else if(w.destroy){
					w.destroy(preserveDom);
				}
			}

			// Back-compat, remove for 2.0
			array.forEach(this._connects, lang.hitch(this, "disconnect"));
			array.forEach(this._supportingWidgets, destroy);

			// Destroy supporting widgets, but not child widgets under this.containerNode (for 2.0, destroy child widgets
			// here too).   if() statement is to guard against exception if destroy() called multiple times (see #15815).
			if(this.domNode){
				array.forEach(registry.findWidgets(this.domNode, this.containerNode), destroy);
			}

			this.destroyRendering(preserveDom);
			registry.remove(this.id);
			this._destroyed = true;
		},

		destroyRendering: function(/*Boolean?*/ preserveDom){
			// summary:
			//		Destroys the DOM nodes associated with this widget.
			// preserveDom:
			//		If true, this method will leave the original DOM structure alone
			//		during tear-down. Note: this will not work with _Templated
			//		widgets yet.
			// tags:
			//		protected

			if(this.bgIframe){
				this.bgIframe.destroy(preserveDom);
				delete this.bgIframe;
			}

			if(this.domNode){
				if(preserveDom){
					domAttr.remove(this.domNode, "widgetId");
				}else{
					domConstruct.destroy(this.domNode);
				}
				delete this.domNode;
			}

			if(this.srcNodeRef){
				if(!preserveDom){
					domConstruct.destroy(this.srcNodeRef);
				}
				delete this.srcNodeRef;
			}
		},

		destroyDescendants: function(/*Boolean?*/ preserveDom){
			// summary:
			//		Recursively destroy the children of this widget and their
			//		descendants.
			// preserveDom:
			//		If true, the preserveDom attribute is passed to all descendant
			//		widget's .destroy() method. Not for use with _Templated
			//		widgets.

			// get all direct descendants and destroy them recursively
			array.forEach(this.getChildren(), function(widget){
				if(widget.destroyRecursive){
					widget.destroyRecursive(preserveDom);
				}
			});
		},

		uninitialize: function(){
			// summary:
			//		Deprecated. Override destroy() instead to implement custom widget tear-down
			//		behavior.
			// tags:
			//		protected
			return false;
		},

		////////////////// GET/SET, CUSTOM SETTERS, ETC. ///////////////////

		_setStyleAttr: function(/*String||Object*/ value){
			// summary:
			//		Sets the style attribute of the widget according to value,
			//		which is either a hash like {height: "5px", width: "3px"}
			//		or a plain string
			// description:
			//		Determines which node to set the style on based on style setting
			//		in attributeMap.
			// tags:
			//		protected

			var mapNode = this.domNode;

			// Note: technically we should revert any style setting made in a previous call
			// to his method, but that's difficult to keep track of.

			if(lang.isObject(value)){
				domStyle.set(mapNode, value);
			}else{
				if(mapNode.style.cssText){
					mapNode.style.cssText += "; " + value;
				}else{
					mapNode.style.cssText = value;
				}
			}

			this._set("style", value);
		},

		_attrToDom: function(/*String*/ attr, /*String*/ value, /*Object?*/ commands){
			// summary:
			//		Reflect a widget attribute (title, tabIndex, duration etc.) to
			//		the widget DOM, as specified by commands parameter.
			//		If commands isn't specified then it's looked up from attributeMap.
			//		Note some attributes like "type"
			//		cannot be processed this way as they are not mutable.
			// attr:
			//		Name of member variable (ex: "focusNode" maps to this.focusNode) pointing
			//		to DOMNode inside the widget, or alternately pointing to a subwidget
			// tags:
			//		private

			commands = arguments.length >= 3 ? commands : this.attributeMap[attr];

			array.forEach(lang.isArray(commands) ? commands : [commands], function(command){

				// Get target node and what we are doing to that node
				var mapNode = this[command.node || command || "domNode"];	// DOM node
				var type = command.type || "attribute";	// class, innerHTML, innerText, or attribute

				switch(type){
					case "attribute":
						if(lang.isFunction(value)){ // functions execute in the context of the widget
							value = lang.hitch(this, value);
						}

						// Get the name of the DOM node attribute; usually it's the same
						// as the name of the attribute in the widget (attr), but can be overridden.
						// Also maps handler names to lowercase, like onSubmit --> onsubmit
						var attrName = command.attribute ? command.attribute :
							(/^on[A-Z][a-zA-Z]*$/.test(attr) ? attr.toLowerCase() : attr);

						if(mapNode.tagName){
							// Normal case, mapping to a DOMNode.  Note that modern browsers will have a mapNode.set()
							// method, but for consistency we still call domAttr
							domAttr.set(mapNode, attrName, value);
						}else{
							// mapping to a sub-widget
							mapNode.set(attrName, value);
						}
						break;
					case "innerText":
						// Deprecated, use "textContent" instead.
						mapNode.innerHTML = "";
						mapNode.appendChild(this.ownerDocument.createTextNode(value));
						break;
					case "textContent":
						mapNode.textContent = value;
						break;
					case "innerHTML":
						mapNode.innerHTML = value;
						break;
					case "class":
						domClass.replace(mapNode, value, this[attr]);
						break;
					case "toggleClass":
						domClass.toggle(mapNode, command.className || attr, value);
						break;
				}
			}, this);
		},

		get: function(name){
			// summary:
			//		Get a property from a widget.
			// name:
			//		The property to get.
			// description:
			//		Get a named property from a widget. The property may
			//		potentially be retrieved via a getter method. If no getter is defined, this
			//		just retrieves the object's property.
			//
			//		For example, if the widget has properties `foo` and `bar`
			//		and a method named `_getFooAttr()`, calling:
			//		`myWidget.get("foo")` would be equivalent to calling
			//		`widget._getFooAttr()` and `myWidget.get("bar")`
			//		would be equivalent to the expression
			//		`widget.bar2`
			var names = this._getAttrNames(name);
			return this[names.g] ? this[names.g]() : this._get(name);
		},

		set: function(name, value){
			// summary:
			//		Set a property on a widget
			// name:
			//		The property to set.
			// value:
			//		The value to set in the property.
			// description:
			//		Sets named properties on a widget which may potentially be handled by a
			//		setter in the widget.
			//
			//		For example, if the widget has properties `foo` and `bar`
			//		and a method named `_setFooAttr()`, calling
			//		`myWidget.set("foo", "Howdy!")` would be equivalent to calling
			//		`widget._setFooAttr("Howdy!")` and `myWidget.set("bar", 3)`
			//		would be equivalent to the statement `widget.bar = 3;`
			//
			//		set() may also be called with a hash of name/value pairs, ex:
			//
			//	|	myWidget.set({
			//	|		foo: "Howdy",
			//	|		bar: 3
			//	|	});
			//
			//	This is equivalent to calling `set(foo, "Howdy")` and `set(bar, 3)`

			if(typeof name === "object"){
				for(var x in name){
					this.set(x, name[x]);
				}
				return this;
			}
			var names = this._getAttrNames(name),
				setter = this[names.s];
			if(lang.isFunction(setter)){
				// use the explicit setter
				var result = setter.apply(this, Array.prototype.slice.call(arguments, 1));
			}else{
				// Mapping from widget attribute to DOMNode/subwidget attribute/value/etc.
				// Map according to:
				//		1. attributeMap setting, if one exists (TODO: attributeMap deprecated, remove in 2.0)
				//		2. _setFooAttr: {...} type attribute in the widget (if one exists)
				//		3. apply to focusNode or domNode if standard attribute name, excluding funcs like onClick.
				// Checks if an attribute is a "standard attribute" by whether the DOMNode JS object has a similar
				// attribute name (ex: accept-charset attribute matches jsObject.acceptCharset).
				// Note also that Tree.focusNode() is a function not a DOMNode, so test for that.
				var defaultNode = this.focusNode && !lang.isFunction(this.focusNode) ? "focusNode" : "domNode",
					tag = this[defaultNode] && this[defaultNode].tagName,
					attrsForTag = tag && (tagAttrs[tag] || (tagAttrs[tag] = getAttrs(this[defaultNode]))),
					map = name in this.attributeMap ? this.attributeMap[name] :
						names.s in this ? this[names.s] :
							((attrsForTag && names.l in attrsForTag && typeof value != "function") ||
								/^aria-|^data-|^role$/.test(name)) ? defaultNode : null;
				if(map != null){
					this._attrToDom(name, value, map);
				}
				this._set(name, value);
			}
			return result || this;
		},

		_attrPairNames: {}, // shared between all widgets
		_getAttrNames: function(name){
			// summary:
			//		Helper function for get() and set().
			//		Caches attribute name values so we don't do the string ops every time.
			// tags:
			//		private

			var apn = this._attrPairNames;
			if(apn[name]){
				return apn[name];
			}
			var uc = name.replace(/^[a-z]|-[a-zA-Z]/g, function(c){
				return c.charAt(c.length - 1).toUpperCase();
			});
			return (apn[name] = {
				n: name + "Node",
				s: "_set" + uc + "Attr", // converts dashes to camel case, ex: accept-charset --> _setAcceptCharsetAttr
				g: "_get" + uc + "Attr",
				l: uc.toLowerCase()        // lowercase name w/out dashes, ex: acceptcharset
			});
		},

		_set: function(/*String*/ name, /*anything*/ value){
			// summary:
			//		Helper function to set new value for specified property, and call handlers
			//		registered with watch() if the value has changed.
			var oldValue = this[name];
			this[name] = value;
			if(this._created && !isEqual(oldValue, value)){
				if(this._watchCallbacks){
					this._watchCallbacks(name, oldValue, value);
				}
				this.emit("attrmodified-" + name, {
					detail: {
						prevValue: oldValue,
						newValue: value
					}
				});
			}
		},

		_get: function(/*String*/ name){
			// summary:
			//		Helper function to get value for specified property stored by this._set(),
			//		i.e. for properties with custom setters.  Used mainly by custom getters.
			//
			//		For example, CheckBox._getValueAttr() calls this._get("value").

			// future: return name in this.props ? this.props[name] : this[name];
			return this[name];
		},

		emit: function(/*String*/ type, /*Object?*/ eventObj, /*Array?*/ callbackArgs){
			// summary:
			//		Used by widgets to signal that a synthetic event occurred, ex:
			//	|	myWidget.emit("attrmodified-selectedChildWidget", {}).
			//
			//		Emits an event on this.domNode named type.toLowerCase(), based on eventObj.
			//		Also calls onType() method, if present, and returns value from that method.
			//		By default passes eventObj to callback, but will pass callbackArgs instead, if specified.
			//		Modifies eventObj by adding missing parameters (bubbles, cancelable, widget).
			// tags:
			//		protected

			// Specify fallback values for bubbles, cancelable in case they are not set in eventObj.
			// Also set pointer to widget, although since we can't add a pointer to the widget for native events
			// (see #14729), maybe we shouldn't do it here?
			eventObj = eventObj || {};
			if(eventObj.bubbles === undefined){
				eventObj.bubbles = true;
			}
			if(eventObj.cancelable === undefined){
				eventObj.cancelable = true;
			}
			if(!eventObj.detail){
				eventObj.detail = {};
			}
			eventObj.detail.widget = this;

			var ret, callback = this["on" + type];
			if(callback){
				ret = callback.apply(this, callbackArgs ? callbackArgs : [eventObj]);
			}

			// Emit event, but avoid spurious emit()'s as parent sets properties on child during startup/destroy
			if(this._started && !this._beingDestroyed){
				on.emit(this.domNode, type.toLowerCase(), eventObj);
			}

			return ret;
		},

		on: function(/*String|Function*/ type, /*Function*/ func){
			// summary:
			//		Call specified function when event occurs, ex: myWidget.on("click", function(){ ... }).
			// type:
			//		Name of event (ex: "click") or extension event like touch.press.
			// description:
			//		Call specified function when event `type` occurs, ex: `myWidget.on("click", function(){ ... })`.
			//		Note that the function is not run in any particular scope, so if (for example) you want it to run in the
			//		widget's scope you must do `myWidget.on("click", lang.hitch(myWidget, func))`.

			// For backwards compatibility, if there's an onType() method in the widget then connect to that.
			// Remove in 2.0.
			var widgetMethod = this._onMap(type);
			if(widgetMethod){
				return aspect.after(this, widgetMethod, func, true);
			}

			// Otherwise, just listen for the event on this.domNode.
			return this.own(on(this.domNode, type, func))[0];
		},

		_onMap: function(/*String|Function*/ type){
			// summary:
			//		Maps on() type parameter (ex: "mousemove") to method name (ex: "onMouseMove").
			//		If type is a synthetic event like touch.press then returns undefined.
			var ctor = this.constructor, map = ctor._onMap;
			if(!map){
				map = (ctor._onMap = {});
				for(var attr in ctor.prototype){
					if(/^on/.test(attr)){
						map[attr.replace(/^on/, "").toLowerCase()] = attr;
					}
				}
			}
			return map[typeof type == "string" && type.toLowerCase()];	// String
		},

		toString: function(){
			// summary:
			//		Returns a string that represents the widget.
			// description:
			//		When a widget is cast to a string, this method will be used to generate the
			//		output. Currently, it does not implement any sort of reversible
			//		serialization.
			return '[Widget ' + this.declaredClass + ', ' + (this.id || 'NO ID') + ']'; // String
		},

		getChildren: function(){
			// summary:
			//		Returns all direct children of this widget, i.e. all widgets underneath this.containerNode whose parent
			//		is this widget.   Note that it does not return all descendants, but rather just direct children.
			//		Analogous to [Node.childNodes](https://developer.mozilla.org/en-US/docs/DOM/Node.childNodes),
			//		except containing widgets rather than DOMNodes.
			//
			//		The result intentionally excludes internally created widgets (a.k.a. supporting widgets)
			//		outside of this.containerNode.
			//
			//		Note that the array returned is a simple array.  Application code should not assume
			//		existence of methods like forEach().

			return this.containerNode ? registry.findWidgets(this.containerNode) : []; // dijit/_WidgetBase[]
		},

		getParent: function(){
			// summary:
			//		Returns the parent widget of this widget.

			return registry.getEnclosingWidget(this.domNode.parentNode);
		},

		connect: function(/*Object|null*/ obj, /*String|Function*/ event, /*String|Function*/ method){
			// summary:
			//		Deprecated, will be removed in 2.0, use this.own(on(...)) or this.own(aspect.after(...)) instead.
			//
			//		Connects specified obj/event to specified method of this object
			//		and registers for disconnect() on widget destroy.
			//
			//		Provide widget-specific analog to dojo.connect, except with the
			//		implicit use of this widget as the target object.
			//		Events connected with `this.connect` are disconnected upon
			//		destruction.
			// returns:
			//		A handle that can be passed to `disconnect` in order to disconnect before
			//		the widget is destroyed.
			// example:
			//	|	var btn = new Button();
			//	|	// when foo.bar() is called, call the listener we're going to
			//	|	// provide in the scope of btn
			//	|	btn.connect(foo, "bar", function(){
			//	|		console.debug(this.toString());
			//	|	});
			// tags:
			//		protected

			return this.own(connect.connect(obj, event, this, method))[0];	// handle
		},

		disconnect: function(handle){
			// summary:
			//		Deprecated, will be removed in 2.0, use handle.remove() instead.
			//
			//		Disconnects handle created by `connect`.
			// tags:
			//		protected

			handle.remove();
		},

		subscribe: function(t, method){
			// summary:
			//		Deprecated, will be removed in 2.0, use this.own(topic.subscribe()) instead.
			//
			//		Subscribes to the specified topic and calls the specified method
			//		of this object and registers for unsubscribe() on widget destroy.
			//
			//		Provide widget-specific analog to dojo.subscribe, except with the
			//		implicit use of this widget as the target object.
			// t: String
			//		The topic
			// method: Function
			//		The callback
			// example:
			//	|	var btn = new Button();
			//	|	// when /my/topic is published, this button changes its label to
			//	|	// be the parameter of the topic.
			//	|	btn.subscribe("/my/topic", function(v){
			//	|		this.set("label", v);
			//	|	});
			// tags:
			//		protected
			return this.own(topic.subscribe(t, lang.hitch(this, method)))[0];	// handle
		},

		unsubscribe: function(/*Object*/ handle){
			// summary:
			//		Deprecated, will be removed in 2.0, use handle.remove() instead.
			//
			//		Unsubscribes handle created by this.subscribe.
			//		Also removes handle from this widget's list of subscriptions
			// tags:
			//		protected

			handle.remove();
		},

		isLeftToRight: function(){
			// summary:
			//		Return this widget's explicit or implicit orientation (true for LTR, false for RTL)
			// tags:
			//		protected
			return this.dir ? (this.dir.toLowerCase() == "ltr") : domGeometry.isBodyLtr(this.ownerDocument); //Boolean
		},

		isFocusable: function(){
			// summary:
			//		Return true if this widget can currently be focused
			//		and false if not
			return this.focus && (domStyle.get(this.domNode, "display") != "none");
		},

		placeAt: function(/*String|DomNode|DocumentFragment|dijit/_WidgetBase*/ reference, /*String|Int?*/ position){
			// summary:
			//		Place this widget somewhere in the DOM based
			//		on standard domConstruct.place() conventions.
			// description:
			//		A convenience function provided in all _Widgets, providing a simple
			//		shorthand mechanism to put an existing (or newly created) Widget
			//		somewhere in the dom, and allow chaining.
			// reference:
			//		Widget, DOMNode, DocumentFragment, or id of widget or DOMNode
			// position:
			//		If reference is a widget (or id of widget), and that widget has an ".addChild" method,
			//		it will be called passing this widget instance into that method, supplying the optional
			//		position index passed.  In this case position (if specified) should be an integer.
			//
			//		If reference is a DOMNode (or id matching a DOMNode but not a widget),
			//		the position argument can be a numeric index or a string
			//		"first", "last", "before", or "after", same as dojo/dom-construct::place().
			// returns: dijit/_WidgetBase
			//		Provides a useful return of the newly created dijit._Widget instance so you
			//		can "chain" this function by instantiating, placing, then saving the return value
			//		to a variable.
			// example:
			//	|	// create a Button with no srcNodeRef, and place it in the body:
			//	|	var button = new Button({ label:"click" }).placeAt(win.body());
			//	|	// now, 'button' is still the widget reference to the newly created button
			//	|	button.on("click", function(e){ console.log('click'); }));
			// example:
			//	|	// create a button out of a node with id="src" and append it to id="wrapper":
			//	|	var button = new Button({},"src").placeAt("wrapper");
			// example:
			//	|	// place a new button as the first element of some div
			//	|	var button = new Button({ label:"click" }).placeAt("wrapper","first");
			// example:
			//	|	// create a contentpane and add it to a TabContainer
			//	|	var tc = dijit.byId("myTabs");
			//	|	new ContentPane({ href:"foo.html", title:"Wow!" }).placeAt(tc)

			var refWidget = !reference.tagName && registry.byId(reference);
			if(refWidget && refWidget.addChild && (!position || typeof position === "number")){
				// Adding this to refWidget and can use refWidget.addChild() to handle everything.
				refWidget.addChild(this, position);
			}else{
				// "reference" is a plain DOMNode, or we can't use refWidget.addChild().   Use domConstruct.place() and
				// target refWidget.containerNode for nested placement (position==number, "first", "last", "only"), and
				// refWidget.domNode otherwise ("after"/"before"/"replace").  (But not supported officially, see #14946.)
				var ref = refWidget && ("domNode" in refWidget) ?
					(refWidget.containerNode && !/after|before|replace/.test(position || "") ?
						refWidget.containerNode : refWidget.domNode) : dom.byId(reference, this.ownerDocument);
				domConstruct.place(this.domNode, ref, position);

				// Start this iff it has a parent widget that's already started.
				// TODO: for 2.0 maybe it should also start the widget when this.getParent() returns null??
				if(!this._started && (this.getParent() || {})._started){
					this.startup();
				}
			}
			return this;
		},

		defer: function(fcn, delay){
			// summary:
			//		Wrapper to setTimeout to avoid deferred functions executing
			//		after the originating widget has been destroyed.
			//		Returns an object handle with a remove method (that returns null) (replaces clearTimeout).
			// fcn: Function
			//		Function reference.
			// delay: Number?
			//		Delay, defaults to 0.
			// tags:
			//		protected

			var timer = setTimeout(lang.hitch(this,
				function(){
					if(!timer){
						return;
					}
					timer = null;
					if(!this._destroyed){
						lang.hitch(this, fcn)();
					}
				}),
				delay || 0
			);
			return {
				remove: function(){
					if(timer){
						clearTimeout(timer);
						timer = null;
					}
					return null; // so this works well: handle = handle.remove();
				}
			};
		}
	});

	if(has("dojo-bidi")){
		_WidgetBase.extend(_BidiMixin);
	}

	return _WidgetBase;
});

},
'dojo/Stateful':function(){
define(["./_base/declare", "./_base/lang", "./_base/array", "./when"], function(declare, lang, array, when){
	// module:
	//		dojo/Stateful

return declare("dojo.Stateful", null, {
	// summary:
	//		Base class for objects that provide named properties with optional getter/setter
	//		control and the ability to watch for property changes
	//
	//		The class also provides the functionality to auto-magically manage getters
	//		and setters for object attributes/properties.
	//		
	//		Getters and Setters should follow the format of _xxxGetter or _xxxSetter where 
	//		the xxx is a name of the attribute to handle.  So an attribute of "foo" 
	//		would have a custom getter of _fooGetter and a custom setter of _fooSetter.
	//
	// example:
	//	|	require(["dojo/Stateful", function(Stateful) {
	//	|		var obj = new Stateful();
	//	|		obj.watch("foo", function(){
	//	|			console.log("foo changed to " + this.get("foo"));
	//	|		});
	//	|		obj.set("foo","bar");
	//	|	});

	// _attrPairNames: Hash
	//		Used across all instances a hash to cache attribute names and their getter 
	//		and setter names.
	_attrPairNames: {},

	_getAttrNames: function(name){
		// summary:
		//		Helper function for get() and set().
		//		Caches attribute name values so we don't do the string ops every time.
		// tags:
		//		private

		var apn = this._attrPairNames;
		if(apn[name]){ return apn[name]; }
		return (apn[name] = {
			s: "_" + name + "Setter",
			g: "_" + name + "Getter"
		});
	},

	postscript: function(/*Object?*/ params){
		// Automatic setting of params during construction
		if (params){ this.set(params); }
	},

	_get: function(name, names){
		// summary:
		//		Private function that does a get based off a hash of names
		// names:
		//		Hash of names of custom attributes
		return typeof this[names.g] === "function" ? this[names.g]() : this[name];
	},
	get: function(/*String*/name){
		// summary:
		//		Get a property on a Stateful instance.
		// name:
		//		The property to get.
		// returns:
		//		The property value on this Stateful instance.
		// description:
		//		Get a named property on a Stateful object. The property may
		//		potentially be retrieved via a getter method in subclasses. In the base class
		//		this just retrieves the object's property.
		// example:
		//	|	require(["dojo/Stateful", function(Stateful) {
		//	|		var stateful = new Stateful({foo: 3});
		//	|		stateful.get("foo") // returns 3
		//	|		stateful.foo // returns 3
		//	|	});

		return this._get(name, this._getAttrNames(name)); //Any
	},
	set: function(/*String*/name, /*Object*/value){
		// summary:
		//		Set a property on a Stateful instance
		// name:
		//		The property to set.
		// value:
		//		The value to set in the property.
		// returns:
		//		The function returns this dojo.Stateful instance.
		// description:
		//		Sets named properties on a stateful object and notifies any watchers of
		//		the property. A programmatic setter may be defined in subclasses.
		// example:
		//	|	require(["dojo/Stateful", function(Stateful) {
		//	|		var stateful = new Stateful();
		//	|		stateful.watch(function(name, oldValue, value){
		//	|			// this will be called on the set below
		//	|		}
		//	|		stateful.set(foo, 5);
		//	set() may also be called with a hash of name/value pairs, ex:
		//	|		stateful.set({
		//	|			foo: "Howdy",
		//	|			bar: 3
		//	|		});
		//	|	});
		//	This is equivalent to calling set(foo, "Howdy") and set(bar, 3)

		// If an object is used, iterate through object
		if(typeof name === "object"){
			for(var x in name){
				if(name.hasOwnProperty(x) && x !="_watchCallbacks"){
					this.set(x, name[x]);
				}
			}
			return this;
		}

		var names = this._getAttrNames(name),
			oldValue = this._get(name, names),
			setter = this[names.s],
			result;
		if(typeof setter === "function"){
			// use the explicit setter
			result = setter.apply(this, Array.prototype.slice.call(arguments, 1));
		}else{
			// no setter so set attribute directly
			this[name] = value;
		}
		if(this._watchCallbacks){
			var self = this;
			// If setter returned a promise, wait for it to complete, otherwise call watches immediately
			when(result, function(){
				self._watchCallbacks(name, oldValue, value);
			});
		}
		return this; // dojo/Stateful
	},
	_changeAttrValue: function(name, value){
		// summary:
		//		Internal helper for directly changing an attribute value.
		//
		// name: String
		//		The property to set.
		// value: Mixed
		//		The value to set in the property.
		//
		// description:
		//		Directly change the value of an attribute on an object, bypassing any 
		//		accessor setter.  Also handles the calling of watch and emitting events. 
		//		It is designed to be used by descendant class when there are two values 
		//		of attributes that are linked, but calling .set() is not appropriate.

		var oldValue = this.get(name);
		this[name] = value;
		if(this._watchCallbacks){
			this._watchCallbacks(name, oldValue, value);
		}
		return this; // dojo/Stateful
	},
	watch: function(/*String?*/name, /*Function*/callback){
		// summary:
		//		Watches a property for changes
		// name:
		//		Indicates the property to watch. This is optional (the callback may be the
		//		only parameter), and if omitted, all the properties will be watched
		// returns:
		//		An object handle for the watch. The unwatch method of this object
		//		can be used to discontinue watching this property:
		//		|	var watchHandle = obj.watch("foo", callback);
		//		|	watchHandle.unwatch(); // callback won't be called now
		// callback:
		//		The function to execute when the property changes. This will be called after
		//		the property has been changed. The callback will be called with the |this|
		//		set to the instance, the first argument as the name of the property, the
		//		second argument as the old value and the third argument as the new value.

		var callbacks = this._watchCallbacks;
		if(!callbacks){
			var self = this;
			callbacks = this._watchCallbacks = function(name, oldValue, value, ignoreCatchall){
				var notify = function(propertyCallbacks){
					if(propertyCallbacks){
						propertyCallbacks = propertyCallbacks.slice();
						for(var i = 0, l = propertyCallbacks.length; i < l; i++){
							propertyCallbacks[i].call(self, name, oldValue, value);
						}
					}
				};
				notify(callbacks['_' + name]);
				if(!ignoreCatchall){
					notify(callbacks["*"]); // the catch-all
				}
			}; // we use a function instead of an object so it will be ignored by JSON conversion
		}
		if(!callback && typeof name === "function"){
			callback = name;
			name = "*";
		}else{
			// prepend with dash to prevent name conflicts with function (like "name" property)
			name = '_' + name;
		}
		var propertyCallbacks = callbacks[name];
		if(typeof propertyCallbacks !== "object"){
			propertyCallbacks = callbacks[name] = [];
		}
		propertyCallbacks.push(callback);

		// TODO: Remove unwatch in 2.0
		var handle = {};
		handle.unwatch = handle.remove = function(){
			var index = array.indexOf(propertyCallbacks, callback);
			if(index > -1){
				propertyCallbacks.splice(index, 1);
			}
		};
		return handle; //Object
	}

});

});

},
'dijit/Destroyable':function(){
define([
	"dojo/_base/array", // array.forEach array.map
	"dojo/aspect",
	"dojo/_base/declare"
], function(array, aspect, declare){

	// module:
	//		dijit/Destroyable

	return declare("dijit.Destroyable", null, {
		// summary:
		//		Mixin to track handles and release them when instance is destroyed.
		// description:
		//		Call this.own(...) on list of handles (returned from dojo/aspect, dojo/on,
		//		dojo/Stateful::watch, or any class (including widgets) with a destroyRecursive() or destroy() method.
		//		Then call destroy() later to destroy this instance and release the resources.

		destroy: function(/*Boolean*/ preserveDom){
			// summary:
			//		Destroy this class, releasing any resources registered via own().
			this._destroyed = true;
		},

		own: function(){
			// summary:
			//		Track specified handles and remove/destroy them when this instance is destroyed, unless they were
			//		already removed/destroyed manually.
			// tags:
			//		protected
			// returns:
			//		The array of specified handles, so you can do for example:
			//	|		var handle = this.own(on(...))[0];

			var cleanupMethods = [
				"destroyRecursive",
				"destroy",
				"remove"
			];

			array.forEach(arguments, function(handle){
				// When this.destroy() is called, destroy handle.  Since I'm using aspect.before(),
				// the handle will be destroyed before a subclass's destroy() method starts running, before it calls
				// this.inherited() or even if it doesn't call this.inherited() at all.  If that's an issue, make an
				// onDestroy() method and connect to that instead.
				var destroyMethodName;
				var odh = aspect.before(this, "destroy", function (preserveDom){
					handle[destroyMethodName](preserveDom);
				});

				// Callback for when handle is manually destroyed.
				var hdhs = [];
				function onManualDestroy(){
					odh.remove();
					array.forEach(hdhs, function(hdh){
						hdh.remove();
					});
				}

				// Setup listeners for manual destroy of handle.
				// Also computes destroyMethodName, used in listener above.
				if(handle.then){
					// Special path for Promises.  Detect when Promise is resolved, rejected, or
					// canceled (nb: cancelling a Promise causes it to be rejected).
					destroyMethodName = "cancel";
					handle.then(onManualDestroy, onManualDestroy);
				}else{
					// Path for other handles.  Just use AOP to detect when handle is manually destroyed.
					array.forEach(cleanupMethods, function(cleanupMethod){
						if(typeof handle[cleanupMethod] === "function"){
							if(!destroyMethodName){
								// Use first matching method name in above listener (prefer destroyRecursive() to destroy())
								destroyMethodName = cleanupMethod;
							}
							hdhs.push(aspect.after(handle, cleanupMethod, onManualDestroy, true));
						}
					});
				}
			}, this);

			return arguments;		// handle
		}
	});
});

},
'dijit/registry':function(){
define([
	"dojo/_base/array", // array.forEach array.map
	"dojo/_base/window", // win.body
	"./main"	// dijit._scopeName
], function(array, win, dijit){

	// module:
	//		dijit/registry

	var _widgetTypeCtr = {}, hash = {};

	var registry =  {
		// summary:
		//		Registry of existing widget on page, plus some utility methods.

		// length: Number
		//		Number of registered widgets
		length: 0,

		add: function(widget){
			// summary:
			//		Add a widget to the registry. If a duplicate ID is detected, a error is thrown.
			// widget: dijit/_WidgetBase
			//		Any dijit/_WidgetBase subclass.
			if(hash[widget.id]){
				throw new Error("Tried to register widget with id==" + widget.id + " but that id is already registered");
			}
			hash[widget.id] = widget;
			this.length++;
		},

		remove: function(/*String*/ id){
			// summary:
			//		Remove a widget from the registry. Does not destroy the widget; simply
			//		removes the reference.
			if(hash[id]){
				delete hash[id];
				this.length--;
			}
		},

		byId: function(/*String|Widget*/ id){
			// summary:
			//		Find a widget by it's id.
			//		If passed a widget then just returns the widget.
			return typeof id == "string" ? hash[id] : id;	// dijit/_WidgetBase
		},

		byNode: function(/*DOMNode*/ node){
			// summary:
			//		Returns the widget corresponding to the given DOMNode
			return hash[node.getAttribute("widgetId")]; // dijit/_WidgetBase
		},

		toArray: function(){
			// summary:
			//		Convert registry into a true Array
			//
			// example:
			//		Work with the widget .domNodes in a real Array
			//		|	array.map(registry.toArray(), function(w){ return w.domNode; });

			var ar = [];
			for(var id in hash){
				ar.push(hash[id]);
			}
			return ar;	// dijit/_WidgetBase[]
		},

		getUniqueId: function(/*String*/widgetType){
			// summary:
			//		Generates a unique id for a given widgetType

			var id;
			do{
				id = widgetType + "_" +
					(widgetType in _widgetTypeCtr ?
						++_widgetTypeCtr[widgetType] : _widgetTypeCtr[widgetType] = 0);
			}while(hash[id]);
			return dijit._scopeName == "dijit" ? id : dijit._scopeName + "_" + id; // String
		},

		findWidgets: function(root, skipNode){
			// summary:
			//		Search subtree under root returning widgets found.
			//		Doesn't search for nested widgets (ie, widgets inside other widgets).
			// root: DOMNode
			//		Node to search under.
			// skipNode: DOMNode
			//		If specified, don't search beneath this node (usually containerNode).

			var outAry = [];

			function getChildrenHelper(root){
				for(var node = root.firstChild; node; node = node.nextSibling){
					if(node.nodeType == 1){
						var widgetId = node.getAttribute("widgetId");
						if(widgetId){
							var widget = hash[widgetId];
							if(widget){	// may be null on page w/multiple dojo's loaded
								outAry.push(widget);
							}
						}else if(node !== skipNode){
							getChildrenHelper(node);
						}
					}
				}
			}

			getChildrenHelper(root);
			return outAry;
		},

		_destroyAll: function(){
			// summary:
			//		Code to destroy all widgets and do other cleanup on page unload

			// Clean up focus manager lingering references to widgets and nodes
			dijit._curFocus = null;
			dijit._prevFocus = null;
			dijit._activeStack = [];

			// Destroy all the widgets, top down
			array.forEach(registry.findWidgets(win.body()), function(widget){
				// Avoid double destroy of widgets like Menu that are attached to <body>
				// even though they are logically children of other widgets.
				if(!widget._destroyed){
					if(widget.destroyRecursive){
						widget.destroyRecursive();
					}else if(widget.destroy){
						widget.destroy();
					}
				}
			});
		},

		getEnclosingWidget: function(/*DOMNode*/ node){
			// summary:
			//		Returns the widget whose DOM tree contains the specified DOMNode, or null if
			//		the node is not contained within the DOM tree of any widget
			while(node){
				var id = node.nodeType == 1 && node.getAttribute("widgetId");
				if(id){
					return hash[id];
				}
				node = node.parentNode;
			}
			return null;
		},

		// In case someone needs to access hash.
		// Actually, this is accessed from WidgetSet back-compatibility code
		_hash: hash
	};

	dijit.registry = registry;

	return registry;
});

},
'dojo/text':function(){
define(["./_base/kernel", "require", "./has", "./request"], function(dojo, require, has, request){
	// module:
	//		dojo/text

	var getText;
	if( 1 ){
		getText= function(url, sync, load){
			request(url, {sync:!!sync, headers: { 'X-Requested-With': null } }).then(load);
		};
	}else{
		// Path for node.js and rhino, to load from local file system.
		// TODO: use node.js native methods rather than depending on a require.getText() method to exist.
		if(require.getText){
			getText= require.getText;
		}else{
			console.error("dojo/text plugin failed to load because loader does not support getText");
		}
	}

	var
		theCache = {},

		strip= function(text){
			//Strips <?xml ...?> declarations so that external SVG and XML
			//documents can be added to a document without worry. Also, if the string
			//is an HTML document, only the part inside the body tag is returned.
			if(text){
				text= text.replace(/^\s*<\?xml(\s)+version=[\'\"](\d)*.(\d)*[\'\"](\s)*\?>/im, "");
				var matches= text.match(/<body[^>]*>\s*([\s\S]+)\s*<\/body>/im);
				if(matches){
					text= matches[1];
				}
			}else{
				text = "";
			}
			return text;
		},

		notFound = {},

		pending = {};

	dojo.cache = function(/*String||Object*/module, /*String*/url, /*String||Object?*/value){
		// summary:
		//		A getter and setter for storing the string content associated with the
		//		module and url arguments.
		// description:
		//		If module is a string that contains slashes, then it is interpretted as a fully
		//		resolved path (typically a result returned by require.toUrl), and url should not be
		//		provided. This is the preferred signature. If module is a string that does not
		//		contain slashes, then url must also be provided and module and url are used to
		//		call `dojo.moduleUrl()` to generate a module URL. This signature is deprecated.
		//		If value is specified, the cache value for the moduleUrl will be set to
		//		that value. Otherwise, dojo.cache will fetch the moduleUrl and store it
		//		in its internal cache and return that cached value for the URL. To clear
		//		a cache value pass null for value. Since XMLHttpRequest (XHR) is used to fetch the
		//		the URL contents, only modules on the same domain of the page can use this capability.
		//		The build system can inline the cache values though, to allow for xdomain hosting.
		// module: String||Object
		//		If a String with slashes, a fully resolved path; if a String without slashes, the
		//		module name to use for the base part of the URL, similar to module argument
		//		to `dojo.moduleUrl`. If an Object, something that has a .toString() method that
		//		generates a valid path for the cache item. For example, a dojo._Url object.
		// url: String
		//		The rest of the path to append to the path derived from the module argument. If
		//		module is an object, then this second argument should be the "value" argument instead.
		// value: String||Object?
		//		If a String, the value to use in the cache for the module/url combination.
		//		If an Object, it can have two properties: value and sanitize. The value property
		//		should be the value to use in the cache, and sanitize can be set to true or false,
		//		to indicate if XML declarations should be removed from the value and if the HTML
		//		inside a body tag in the value should be extracted as the real value. The value argument
		//		or the value property on the value argument are usually only used by the build system
		//		as it inlines cache content.
		// example:
		//		To ask dojo.cache to fetch content and store it in the cache (the dojo["cache"] style
		//		of call is used to avoid an issue with the build system erroneously trying to intern
		//		this example. To get the build system to intern your dojo.cache calls, use the
		//		"dojo.cache" style of call):
		//		| //If template.html contains "<h1>Hello</h1>" that will be
		//		| //the value for the text variable.
		//		| //Note: This is pre-AMD, deprecated syntax
		//		| var text = dojo["cache"]("my.module", "template.html");
		// example:
		//		To ask dojo.cache to fetch content and store it in the cache, and sanitize the input
		//		 (the dojo["cache"] style of call is used to avoid an issue with the build system
		//		erroneously trying to intern this example. To get the build system to intern your
		//		dojo.cache calls, use the "dojo.cache" style of call):
		//		| //If template.html contains "<html><body><h1>Hello</h1></body></html>", the
		//		| //text variable will contain just "<h1>Hello</h1>".
		//		| //Note: This is pre-AMD, deprecated syntax
		//		| var text = dojo["cache"]("my.module", "template.html", {sanitize: true});
		// example:
		//		Same example as previous, but demonstrates how an object can be passed in as
		//		the first argument, then the value argument can then be the second argument.
		//		| //If template.html contains "<html><body><h1>Hello</h1></body></html>", the
		//		| //text variable will contain just "<h1>Hello</h1>".
		//		| //Note: This is pre-AMD, deprecated syntax
		//		| var text = dojo["cache"](new dojo._Url("my/module/template.html"), {sanitize: true});

		//	 * (string string [value]) => (module, url, value)
		//	 * (object [value])        => (module, value), url defaults to ""
		//
		//	 * if module is an object, then it must be convertable to a string
		//	 * (module, url) module + (url ? ("/" + url) : "") must be a legal argument to require.toUrl
		//	 * value may be a string or an object; if an object then may have the properties "value" and/or "sanitize"
		var key;
		if(typeof module=="string"){
			if(/\//.test(module)){
				// module is a version 1.7+ resolved path
				key = module;
				value = url;
			}else{
				// module is a version 1.6- argument to dojo.moduleUrl
				key = require.toUrl(module.replace(/\./g, "/") + (url ? ("/" + url) : ""));
			}
		}else{
			key = module + "";
			value = url;
		}
		var
			val = (value != undefined && typeof value != "string") ? value.value : value,
			sanitize = value && value.sanitize;

		if(typeof val == "string"){
			//We have a string, set cache value
			theCache[key] = val;
			return sanitize ? strip(val) : val;
		}else if(val === null){
			//Remove cached value
			delete theCache[key];
			return null;
		}else{
			//Allow cache values to be empty strings. If key property does
			//not exist, fetch it.
			if(!(key in theCache)){
				getText(key, true, function(text){
					theCache[key]= text;
				});
			}
			return sanitize ? strip(theCache[key]) : theCache[key];
		}
	};

	return {
		// summary:
		//		This module implements the dojo/text! plugin and the dojo.cache API.
		// description:
		//		We choose to include our own plugin to leverage functionality already contained in dojo
		//		and thereby reduce the size of the plugin compared to various foreign loader implementations.
		//		Also, this allows foreign AMD loaders to be used without their plugins.
		//
		//		CAUTION: this module is designed to optionally function synchronously to support the dojo v1.x synchronous
		//		loader. This feature is outside the scope of the CommonJS plugins specification.

		// the dojo/text caches it's own resources because of dojo.cache
		dynamic: true,

		normalize: function(id, toAbsMid){
			// id is something like (path may be relative):
			//
			//	 "path/to/text.html"
			//	 "path/to/text.html!strip"
			var parts= id.split("!"),
				url= parts[0];
			return (/^\./.test(url) ? toAbsMid(url) : url) + (parts[1] ? "!" + parts[1] : "");
		},

		load: function(id, require, load){
			// id: String
			//		Path to the resource.
			// require: Function
			//		Object that include the function toUrl with given id returns a valid URL from which to load the text.
			// load: Function
			//		Callback function which will be called, when the loading finished.

			// id is something like (path is always absolute):
			//
			//	 "path/to/text.html"
			//	 "path/to/text.html!strip"
			var
				parts= id.split("!"),
				stripFlag= parts.length>1,
				absMid= parts[0],
				url = require.toUrl(parts[0]),
				requireCacheUrl = "url:" + url,
				text = notFound,
				finish = function(text){
					load(stripFlag ? strip(text) : text);
				};
			if(absMid in theCache){
				text = theCache[absMid];
			}else if(require.cache && requireCacheUrl in require.cache){
				text = require.cache[requireCacheUrl];
			}else if(url in theCache){
				text = theCache[url];
			}
			if(text===notFound){
				if(pending[url]){
					pending[url].push(finish);
				}else{
					var pendingList = pending[url] = [finish];
					getText(url, !require.async, function(text){
						theCache[absMid]= theCache[url]= text;
						for(var i = 0; i<pendingList.length;){
							pendingList[i++](text);
						}
						delete pending[url];
					});
				}
			}else{
				finish(text);
			}
		}
	};

});


},
'dojo/request':function(){
define([
	'./request/default!'/*=====,
	'./_base/declare',
	'./promise/Promise' =====*/
], function(request/*=====, declare, Promise =====*/){
	/*=====
	request = function(url, options){
		// summary:
		//		Send a request using the default transport for the current platform.
		// url: String
		//		The URL to request.
		// options: dojo/request.__Options?
		//		Options for the request.
		// returns: dojo/request.__Promise
	};
	request.__Promise = declare(Promise, {
		// response: dojo/promise/Promise
		//		A promise resolving to an object representing
		//		the response from the server.
	});
	request.__BaseOptions = declare(null, {
		// query: String|Object?
		//		Query parameters to append to the URL.
		// data: String|Object?
		//		Data to transfer.  This is ignored for GET and DELETE
		//		requests.
		// preventCache: Boolean?
		//		Whether to append a cache-busting parameter to the URL.
		// timeout: Integer?
		//		Milliseconds to wait for the response.  If this time
		//		passes, the then the promise is rejected.
		// handleAs: String?
		//		How to handle the response from the server.  Default is
		//		'text'.  Other values are 'json', 'javascript', and 'xml'.
	});
	request.__MethodOptions = declare(null, {
		// method: String?
		//		The HTTP method to use to make the request.  Must be
		//		uppercase.
	});
	request.__Options = declare([request.__BaseOptions, request.__MethodOptions]);

	request.get = function(url, options){
		// summary:
		//		Send an HTTP GET request using the default transport for the current platform.
		// url: String
		//		URL to request
		// options: dojo/request.__BaseOptions?
		//		Options for the request.
		// returns: dojo/request.__Promise
	};
	request.post = function(url, options){
		// summary:
		//		Send an HTTP POST request using the default transport for the current platform.
		// url: String
		//		URL to request
		// options: dojo/request.__BaseOptions?
		//		Options for the request.
		// returns: dojo/request.__Promise
	};
	request.put = function(url, options){
		// summary:
		//		Send an HTTP POST request using the default transport for the current platform.
		// url: String
		//		URL to request
		// options: dojo/request.__BaseOptions?
		//		Options for the request.
		// returns: dojo/request.__Promise
	};
	request.del = function(url, options){
		// summary:
		//		Send an HTTP DELETE request using the default transport for the current platform.
		// url: String
		//		URL to request
		// options: dojo/request.__BaseOptions?
		//		Options for the request.
		// returns: dojo/request.__Promise
	};
	=====*/
	return request;
});

},
'dojo/request/default':function(){
define([
	'exports',
	'require',
	'../has'
], function(exports, require, has){
	var defId = has('config-requestProvider'),
		platformId;

	if( 1  || has('host-webworker')){
		platformId = './xhr';
	}else if( 0 ){
		platformId = './node';
	/* TODO:
	}else if( 0 ){
		platformId = './rhino';
   */
	}

	if(!defId){
		defId = platformId;
	}

	exports.getPlatformDefaultId = function(){
		return platformId;
	};

	exports.load = function(id, parentRequire, loaded, config){
		require([id == 'platform' ? platformId : defId], function(provider){
			loaded(provider);
		});
	};
});

},
'soso/sosox/ejs/_Templated':function(){
define([
    "dojo/_base/array",
    "dojo/_base/declare",
    "dojo/_base/kernel",
    "dojo/_base/lang",
    "dojo/dom-construct",
    "dojo/text",
    "dijit/registry",
    "dijit/_TemplatedMixin",
    "vendor/ejs/ejs",
    "./Helpers"
], function(array, declare, dojo, lang, domConstruct, text, registry, _TemplatedMixin, ejs, Helpers){
    return declare('soso.sosox.ejs._Templated', [_TemplatedMixin], {
        _customViewHelpers: {},
        _substituteVariables: true,

        constructor: function() {
            this._customViewHelpers = {};
        },

        render: function(data){
            var originalNode = this.domNode;
            this.destroyRendering();
            this.buildRendering(data);
            if(this.domNode){
                // Note: for 2.0 may want to rename widgetId to dojo._scopeName + "_widgetId",
                // assuming that dojo._scopeName even exists in 2.0
                this.domNode.setAttribute("widgetId", this.id);
            }

            // If srcNodeRef has been processed and removed from the DOM (e.g. TemplatedWidget) then delete it to allow GC.
            if(this.srcNodeRef && !this.srcNodeRef.parentNode){
                delete this.srcNodeRef;
            }
            domConstruct.place(this.domNode, originalNode, "replace");
            domConstruct.destroy(originalNode);
            delete originalNode;
        },

        destroyRendering: function(){
            // Delete all attach points to prevent IE6 memory leaks.
            array.forEach(this._attachPoints, function(point){
                delete this[point];
            }, this);
            this._attachPoints = [];

            // And same for event handlers
            array.forEach(this._attachEvents, this.disconnect, this);
            this._attachEvents = [];

            if (!this.domNode) {
                return;
            }

            // Destroy existing widgets to prevent the error:
            //     "Error: Tried to register widget with id==____ but that id is already registered"
            array.forEach(registry.findWidgets(this.domNode), function(w) {
                w.destroyRecursive(false);
            });
        },

        buildRendering: function(data){
            // summary:
            // Construct the UI for this widget from a template, setting this.domNode.
            // tags:
            // protected

            if(!this.templateString){
                this.templateString = dojo.cache(this.templatePath, {sanitize: true});
            }

            // Lookup cached version of template, and download to cache if it
            // isn't there already.  Returns either a DomNode or a string, depending on
            // whether or not the template contains ${foo} replacement parameters.
            var cached = _TemplatedMixin.getCachedTemplate(this.templateString, true);

            if(!data) data = this.data;

            var helpers = lang.mixin(new Helpers, this._customViewHelpers);

            cached = ejs.render(cached.toString(), lang.mixin(helpers, data));

            var node;
            if(lang.isString(cached)){
                node = domConstruct.toDom(this._substituteVariables ? this._stringRepl(cached) : cached);
                if(node.nodeType != 1){
                    // Flag common problems such as templates with multiple top level nodes (nodeType == 11)
                    throw new Error("Invalid template: " + cached);
                }
            }else{
                // if it's a node, all we have to do is clone it
                node = cached.cloneNode(true);
            }

            this.domNode = node;

            // Call down to _Widget.buildRendering() to get base classes assigned
            // TODO: change the baseClass assignment to _setBaseClassAttr

            // Not sure what to do about this yet?
            //this.inherited(arguments);

            // recurse through the node, looking for, and attaching to, our
            // attachment points and events, which should be defined on the template node.
            this._attachTemplateNodes(node, function(n,p){ return n.getAttribute(p); });

            this._beforeFillContent();		// hook for _WidgetsInTemplateMixin

            this._fillContent(this.srcNodeRef);
        },

        addCustomViewHelper: function(name, customViewHelper) {
            this._customViewHelpers[name] = customViewHelper;
        },

        setCustomViewHelpers: function(customViewHelpers) {
            this._customViewHelpers = customViewHelpers;
        },

        getCustomViewHelpers: function() {
            return this._customViewHelpers;
        },

        _disableVariableSubstitution: function() {
            this._substituteVariables = false;
        },

        _enableVariableSubstitution: function() {
            this._substituteVariables = true;
        }
    });
});
},
'dijit/_TemplatedMixin':function(){
define([
	"dojo/cache",	// dojo.cache
	"dojo/_base/declare", // declare
	"dojo/dom-construct", // domConstruct.destroy, domConstruct.toDom
	"dojo/_base/lang", // lang.getObject
	"dojo/on",
	"dojo/sniff", // has("ie")
	"dojo/string", // string.substitute string.trim
	"./_AttachMixin"
], function(cache, declare, domConstruct, lang, on, has, string, _AttachMixin){

	// module:
	//		dijit/_TemplatedMixin

	var _TemplatedMixin = declare("dijit._TemplatedMixin", _AttachMixin, {
		// summary:
		//		Mixin for widgets that are instantiated from a template

		// templateString: [protected] String
		//		A string that represents the widget template.
		//		Use in conjunction with dojo.cache() to load from a file.
		templateString: null,

		// templatePath: [protected deprecated] String
		//		Path to template (HTML file) for this widget relative to dojo.baseUrl.
		//		Deprecated: use templateString with require([... "dojo/text!..."], ...) instead
		templatePath: null,

		// skipNodeCache: [protected] Boolean
		//		If using a cached widget template nodes poses issues for a
		//		particular widget class, it can set this property to ensure
		//		that its template is always re-built from a string
		_skipNodeCache: false,

/*=====
		// _rendered: Boolean
		//		Not normally use, but this flag can be set by the app if the server has already rendered the template,
		//		i.e. already inlining the template for the widget into the main page.   Reduces _TemplatedMixin to
		//		just function like _AttachMixin.
		_rendered: false,
=====*/

		// Set _AttachMixin.searchContainerNode to true for back-compat for widgets that have data-dojo-attach-point's
		// and events inside this.containerNode.   Remove for 2.0.
		searchContainerNode: true,

		_stringRepl: function(tmpl){
			// summary:
			//		Does substitution of ${foo} type properties in template string
			// tags:
			//		private
			var className = this.declaredClass, _this = this;
			// Cache contains a string because we need to do property replacement
			// do the property replacement
			return string.substitute(tmpl, this, function(value, key){
				if(key.charAt(0) == '!'){ value = lang.getObject(key.substr(1), false, _this); }
				if(typeof value == "undefined"){ throw new Error(className+" template:"+key); } // a debugging aide
				if(value == null){ return ""; }

				// Substitution keys beginning with ! will skip the transform step,
				// in case a user wishes to insert unescaped markup, e.g. ${!foo}
				return key.charAt(0) == "!" ? value : this._escapeValue("" + value);
			}, this);
		},

		_escapeValue: function(/*String*/ val){
			// summary:
			//		Escape a value to be inserted into the template, either into an attribute value
			//		(ex: foo="${bar}") or as inner text of an element (ex: <span>${foo}</span>)

			// Safer substitution, see heading "Attribute values" in
			// http://www.w3.org/TR/REC-html40/appendix/notes.html#h-B.3.2
			// and also https://www.owasp.org/index.php/XSS_%28Cross_Site_Scripting%29_Prevention_Cheat_Sheet#RULE_.231_-_HTML_Escape_Before_Inserting_Untrusted_Data_into_HTML_Element_Content
			return val.replace(/["'<>&]/g, function(val){
				return {
					"&": "&amp;",
					"<": "&lt;",
					">": "&gt;",
					"\"": "&quot;",
					"'": "&#x27;"
				}[val];
			});
		},

		buildRendering: function(){
			// summary:
			//		Construct the UI for this widget from a template, setting this.domNode.
			// tags:
			//		protected

			if(!this._rendered){
				if(!this.templateString){
					this.templateString = cache(this.templatePath, {sanitize: true});
				}

				// Lookup cached version of template, and download to cache if it
				// isn't there already.  Returns either a DomNode or a string, depending on
				// whether or not the template contains ${foo} replacement parameters.
				var cached = _TemplatedMixin.getCachedTemplate(this.templateString, this._skipNodeCache, this.ownerDocument);

				var node;
				if(lang.isString(cached)){
					node = domConstruct.toDom(this._stringRepl(cached), this.ownerDocument);
					if(node.nodeType != 1){
						// Flag common problems such as templates with multiple top level nodes (nodeType == 11)
						throw new Error("Invalid template: " + cached);
					}
				}else{
					// if it's a node, all we have to do is clone it
					node = cached.cloneNode(true);
				}

				this.domNode = node;
			}

			// Call down to _WidgetBase.buildRendering() to get base classes assigned
			// TODO: change the baseClass assignment to _setBaseClassAttr
			this.inherited(arguments);

			if(!this._rendered){
				this._fillContent(this.srcNodeRef);
			}

			this._rendered = true;
		},

		_fillContent: function(/*DomNode*/ source){
			// summary:
			//		Relocate source contents to templated container node.
			//		this.containerNode must be able to receive children, or exceptions will be thrown.
			// tags:
			//		protected
			var dest = this.containerNode;
			if(source && dest){
				while(source.hasChildNodes()){
					dest.appendChild(source.firstChild);
				}
			}
		}

	});

	// key is templateString; object is either string or DOM tree
	_TemplatedMixin._templateCache = {};

	_TemplatedMixin.getCachedTemplate = function(templateString, alwaysUseString, doc){
		// summary:
		//		Static method to get a template based on the templatePath or
		//		templateString key
		// templateString: String
		//		The template
		// alwaysUseString: Boolean
		//		Don't cache the DOM tree for this template, even if it doesn't have any variables
		// doc: Document?
		//		The target document.   Defaults to document global if unspecified.
		// returns: Mixed
		//		Either string (if there are ${} variables that need to be replaced) or just
		//		a DOM tree (if the node can be cloned directly)

		// is it already cached?
		var tmplts = _TemplatedMixin._templateCache;
		var key = templateString;
		var cached = tmplts[key];
		if(cached){
			try{
				// if the cached value is an innerHTML string (no ownerDocument) or a DOM tree created within the
				// current document, then use the current cached value
				if(!cached.ownerDocument || cached.ownerDocument == (doc || document)){
					// string or node of the same document
					return cached;
				}
			}catch(e){ /* squelch */ } // IE can throw an exception if cached.ownerDocument was reloaded
			domConstruct.destroy(cached);
		}

		templateString = string.trim(templateString);

		if(alwaysUseString || templateString.match(/\$\{([^\}]+)\}/g)){
			// there are variables in the template so all we can do is cache the string
			return (tmplts[key] = templateString); //String
		}else{
			// there are no variables in the template so we can cache the DOM tree
			var node = domConstruct.toDom(templateString, doc);
			if(node.nodeType != 1){
				throw new Error("Invalid template: " + templateString);
			}
			return (tmplts[key] = node); //Node
		}
	};

	if(has("ie")){
		on(window, "unload", function(){
			var cache = _TemplatedMixin._templateCache;
			for(var key in cache){
				var value = cache[key];
				if(typeof value == "object"){ // value is either a string or a DOM node template
					domConstruct.destroy(value);
				}
				delete cache[key];
			}
		});
	}

	return _TemplatedMixin;
});

},
'dojo/cache':function(){
define(["./_base/kernel", "./text"], function(dojo){
	// module:
	//		dojo/cache

	// dojo.cache is defined in dojo/text
	return dojo.cache;
});

},
'dojo/string':function(){
define([
	"./_base/kernel",	// kernel.global
	"./_base/lang"
], function(kernel, lang){

// module:
//		dojo/string
var ESCAPE_REGEXP = /[&<>'"\/]/g;
var ESCAPE_MAP = {
	'&': '&amp;',
	'<': '&lt;',
	'>': '&gt;',
	'"': '&quot;',
	"'": '&#x27;',
	'/': '&#x2F;'
};
var string = {
	// summary:
	//		String utilities for Dojo
};
lang.setObject("dojo.string", string);

string.escape = function(/*String*/str){
	// summary:
	//		Efficiently escape a string for insertion into HTML (innerHTML or attributes), replacing &, <, >, ", ', and / characters.
	// str:
	//		the string to escape
	if(!str){ return ""; }
	return str.replace(ESCAPE_REGEXP, function(c) {
		return ESCAPE_MAP[c];
	});
};

// Adapted from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/codePointAt#Polyfill
string.codePointAt = String.prototype.codePointAt ?
	function (str, position) {
		return String.prototype.codePointAt.call(str, position);
	} :
	function(str, position) {
		if (str == null) {
			throw new TypeError('codePointAt called on null or undefined');
		}

		var size;
		var first;
		var second;
		var index;

		str = String(str);
		size = str.length;
		// `ToInteger`
		index = position ? Number(position) : 0;

		if (index != index) { // better `isNaN`
			index = 0;
		}

		// Account for out-of-bounds indices:
		if (index < 0 || index >= size) {
			return undefined;
		}

		// Get the first code unit
		first = str.charCodeAt(index);

		// check if it's the start of a surrogate pair
		if (first >= 0xD800 && first <= 0xDBFF && // high surrogate
			size > index + 1 // there is a next code unit
		) {
			second = str.charCodeAt(index + 1);
			if (second >= 0xDC00 && second <= 0xDFFF) { // low surrogate
				// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
				return (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
			}
		}

		return first;
	};

// Adapted from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/fromCodePoint#Polyfill
string.fromCodePoint = String.fromCodePoint || function () {
	var codeUnits = [];
	var codeLen = 0;
	var result = "";
	var codePoint;
	var index;

	for (index = 0, len = arguments.length; index !== len; ++index) {
		codePoint = +arguments[index];
		// correctly handles all cases including `NaN`, `-Infinity`, `+Infinity`
		// The surrounding `!(...)` is required to correctly handle `NaN` cases
		// The (codePoint>>>0) === codePoint clause handles decimals and negatives
		if (!(codePoint < 0x10FFFF && (codePoint>>>0) === codePoint)) {
			throw RangeError("Invalid code point: " + codePoint);
		}

		if (codePoint <= 0xFFFF) { // BMP code point
			codeLen = codeUnits.push(codePoint);
		} else { // Astral code point; split in surrogate halves
			// https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
			codePoint -= 0x10000;
			codeLen = codeUnits.push(
				(codePoint >> 10) + 0xD800,  // highSurrogate
				(codePoint % 0x400) + 0xDC00 // lowSurrogate
			);
		}

		if (codeLen >= 0x3fff) {
			result += String.fromCharCode.apply(null, codeUnits);
			codeUnits.length = 0;
		}
	}

	return result + String.fromCharCode.apply(null, codeUnits);
};

string.rep = function(/*String*/str, /*Integer*/num){
	// summary:
	//		Efficiently replicate a string `n` times.
	// str:
	//		the string to replicate
	// num:
	//		number of times to replicate the string

	if(num <= 0 || !str){ return ""; }

	var buf = [];
	for(;;){
		if(num & 1){
			buf.push(str);
		}
		if(!(num >>= 1)){ break; }
		str += str;
	}
	return buf.join("");	// String
};

string.pad = function(/*String*/text, /*Integer*/size, /*String?*/ch, /*Boolean?*/end){
	// summary:
	//		Pad a string to guarantee that it is at least `size` length by
	//		filling with the character `ch` at either the start or end of the
	//		string. Pads at the start, by default.
	// text:
	//		the string to pad
	// size:
	//		length to provide padding
	// ch:
	//		character to pad, defaults to '0'
	// end:
	//		adds padding at the end if true, otherwise pads at start
	// example:
	//	|	// Fill the string to length 10 with "+" characters on the right.  Yields "Dojo++++++".
	//	|	string.pad("Dojo", 10, "+", true);

	if(!ch){
		ch = '0';
	}
	var out = String(text),
		pad = string.rep(ch, Math.ceil((size - out.length) / ch.length));
	return end ? out + pad : pad + out;	// String
};

string.substitute = function(	/*String*/		template,
									/*Object|Array*/map,
									/*Function?*/	transform,
									/*Object?*/		thisObject){
	// summary:
	//		Performs parameterized substitutions on a string. Throws an
	//		exception if any parameter is unmatched.
	// template:
	//		a string with expressions in the form `${key}` to be replaced or
	//		`${key:format}` which specifies a format function. keys are case-sensitive.
	//		The special sequence `${}` can be used escape `$`.
	// map:
	//		hash to search for substitutions
	// transform:
	//		a function to process all parameters before substitution takes
	//		place, e.g. mylib.encodeXML
	// thisObject:
	//		where to look for optional format function; default to the global
	//		namespace
	// example:
	//		Substitutes two expressions in a string from an Array or Object
	//	|	// returns "File 'foo.html' is not found in directory '/temp'."
	//	|	// by providing substitution data in an Array
	//	|	string.substitute(
	//	|		"File '${0}' is not found in directory '${1}'.",
	//	|		["foo.html","/temp"]
	//	|	);
	//	|
	//	|	// also returns "File 'foo.html' is not found in directory '/temp'."
	//	|	// but provides substitution data in an Object structure.  Dotted
	//	|	// notation may be used to traverse the structure.
	//	|	string.substitute(
	//	|		"File '${name}' is not found in directory '${info.dir}'.",
	//	|		{ name: "foo.html", info: { dir: "/temp" } }
	//	|	);
	// example:
	//		Use a transform function to modify the values:
	//	|	// returns "file 'foo.html' is not found in directory '/temp'."
	//	|	string.substitute(
	//	|		"${0} is not found in ${1}.",
	//	|		["foo.html","/temp"],
	//	|		function(str){
	//	|			// try to figure out the type
	//	|			var prefix = (str.charAt(0) == "/") ? "directory": "file";
	//	|			return prefix + " '" + str + "'";
	//	|		}
	//	|	);
	// example:
	//		Use a formatter
	//	|	// returns "thinger -- howdy"
	//	|	string.substitute(
	//	|		"${0:postfix}", ["thinger"], null, {
	//	|			postfix: function(value, key){
	//	|				return value + " -- howdy";
	//	|			}
	//	|		}
	//	|	);

	thisObject = thisObject || kernel.global;
	transform = transform ?
		lang.hitch(thisObject, transform) : function(v){ return v; };

	return template.replace(/\$\{([^\s\:\}]*)(?:\:([^\s\:\}]+))?\}/g,
		function(match, key, format){
			if (key == ''){
				return '$';
			}
			var value = lang.getObject(key, false, map);
			if(format){
				value = lang.getObject(format, false, thisObject).call(thisObject, value, key);
			}
			var result = transform(value, key);

			if (typeof result === 'undefined') {
				throw new Error('string.substitute could not find key "' + key + '" in template');
			}

			return result.toString();
		}); // String
};

string.trim = String.prototype.trim ?
	lang.trim : // aliasing to the native function
	function(str){
		str = str.replace(/^\s+/, '');
		for(var i = str.length - 1; i >= 0; i--){
			if(/\S/.test(str.charAt(i))){
				str = str.substring(0, i + 1);
				break;
			}
		}
		return str;
	};

/*=====
 string.trim = function(str){
	 // summary:
	 //		Trims whitespace from both sides of the string
	 // str: String
	 //		String to be trimmed
	 // returns: String
	 //		Returns the trimmed string
	 // description:
	 //		This version of trim() was taken from [Steven Levithan's blog](http://blog.stevenlevithan.com/archives/faster-trim-javascript).
	 //		The short yet performant version of this function is dojo/_base/lang.trim(),
	 //		which is part of Dojo base.  Uses String.prototype.trim instead, if available.
	 return "";	// String
 };
 =====*/

	return string;
});

},
'dijit/_AttachMixin':function(){
define([
	"require",
	"dojo/_base/array", // array.forEach
	"dojo/_base/connect",	// remove for 2.0
	"dojo/_base/declare", // declare
	"dojo/_base/lang", // lang.getObject
	"dojo/mouse",
	"dojo/on",
	"dojo/touch",
	"./_WidgetBase"
], function(require, array, connect, declare, lang, mouse, on, touch, _WidgetBase){

	// module:
	//		dijit/_AttachMixin

	// Map from string name like "mouseenter" to synthetic event like mouse.enter
	var synthEvents = lang.delegate(touch, {
		"mouseenter": mouse.enter,
		"mouseleave": mouse.leave,
		"keypress": connect._keypress	// remove for 2.0
	});

	// To be lightweight, _AttachMixin doesn't require() dijit/a11yclick.
	// If the subclass has a template using "ondijitclick", it must load dijit/a11yclick itself.
	// In that case, the a11yclick variable below will get set to point to that synthetic event.
	var a11yclick;

	var _AttachMixin = declare("dijit._AttachMixin", null, {
		// summary:
		//		Mixin for widgets to attach to dom nodes and setup events via
		//		convenient data-dojo-attach-point and data-dojo-attach-event DOM attributes.
		//
		//		Superclass of _TemplatedMixin, and can also be used standalone when templates are pre-rendered on the
		//		server.
		//
		//		Does not [yet] handle widgets like ContentPane with this.containerNode set.   It should skip
		//		scanning for data-dojo-attach-point and data-dojo-attach-event inside this.containerNode, but it
		//		doesn't.

/*=====
		// _attachPoints: [private] String[]
		//		List of widget attribute names associated with data-dojo-attach-point=... in the
		//		template, ex: ["containerNode", "labelNode"]
		_attachPoints: [],

		// _attachEvents: [private] Handle[]
		//		List of connections associated with data-dojo-attach-event=... in the
		//		template
		_attachEvents: [],

		// attachScope: [public] Object
		//		Object to which attach points and events will be scoped.  Defaults
		//		to 'this'.
		attachScope: undefined,

		// searchContainerNode: [protected] Boolean
		//		Search descendants of this.containerNode for data-dojo-attach-point and data-dojo-attach-event.
		//		Should generally be left false (the default value) both for performance and to avoid failures when
		//		this.containerNode holds other _AttachMixin instances with their own attach points and events.
 		searchContainerNode: false,
 =====*/

		constructor: function(/*===== params, srcNodeRef =====*/){
			// summary:
			//		Create the widget.
			// params: Object|null
			//		Hash of initialization parameters for widget, including scalar values (like title, duration etc.)
			//		and functions, typically callbacks like onClick.
			//		The hash can contain any of the widget's properties, excluding read-only properties.
			// srcNodeRef: DOMNode|String?
			//		If a srcNodeRef (DOM node) is specified, replace srcNodeRef with my generated DOM tree.

			this._attachPoints = [];
			this._attachEvents = [];
		},


		buildRendering: function(){
			// summary:
			//		Attach to DOM nodes marked with special attributes.
			// tags:
			//		protected

			this.inherited(arguments);

			// recurse through the node, looking for, and attaching to, our
			// attachment points and events, which should be defined on the template node.
			this._attachTemplateNodes(this.domNode);

			this._beforeFillContent();		// hook for _WidgetsInTemplateMixin
		},

		_beforeFillContent: function(){
		},

		_attachTemplateNodes: function(rootNode){
			// summary:
			//		Iterate through the dom nodes and attach functions and nodes accordingly.
			// description:
			//		Map widget properties and functions to the handlers specified in
			//		the dom node and it's descendants. This function iterates over all
			//		nodes and looks for these properties:
			//
			//		- dojoAttachPoint/data-dojo-attach-point
			//		- dojoAttachEvent/data-dojo-attach-event
			// rootNode: DomNode
			//		The node to search for properties. All descendants will be searched.
			// tags:
			//		private

			// DFS to process all nodes except those inside of this.containerNode
			var node = rootNode;
			while(true){
				if(node.nodeType == 1 && (this._processTemplateNode(node, function(n,p){ return n.getAttribute(p); },
						this._attach) || this.searchContainerNode) && node.firstChild){
					node = node.firstChild;
				}else{
					if(node == rootNode){ return; }
					while(!node.nextSibling){
						node = node.parentNode;
						if(node == rootNode){ return; }
					}
					node = node.nextSibling;
				}
			}
		},

		_processTemplateNode: function(/*DOMNode|Widget*/ baseNode, getAttrFunc, attachFunc){
			// summary:
			//		Process data-dojo-attach-point and data-dojo-attach-event for given node or widget.
			//		Returns true if caller should process baseNode's children too.

			var ret = true;

			// Process data-dojo-attach-point
			var _attachScope = this.attachScope || this,
				attachPoint = getAttrFunc(baseNode, "dojoAttachPoint") || getAttrFunc(baseNode, "data-dojo-attach-point");
			if(attachPoint){
				var point, points = attachPoint.split(/\s*,\s*/);
				while((point = points.shift())){
					if(lang.isArray(_attachScope[point])){
						_attachScope[point].push(baseNode);
					}else{
						_attachScope[point] = baseNode;
					}
					ret = (point != "containerNode");
					this._attachPoints.push(point);
				}
			}

			// Process data-dojo-attach-event
			var attachEvent = getAttrFunc(baseNode, "dojoAttachEvent") || getAttrFunc(baseNode, "data-dojo-attach-event");
			if(attachEvent){
				// NOTE: we want to support attributes that have the form
				// "domEvent: nativeEvent, ..."
				var event, events = attachEvent.split(/\s*,\s*/);
				var trim = lang.trim;
				while((event = events.shift())){
					if(event){
						var thisFunc = null;
						if(event.indexOf(":") != -1){
							// oh, if only JS had tuple assignment
							var funcNameArr = event.split(":");
							event = trim(funcNameArr[0]);
							thisFunc = trim(funcNameArr[1]);
						}else{
							event = trim(event);
						}
						if(!thisFunc){
							thisFunc = event;
						}

						this._attachEvents.push(attachFunc(baseNode, event, lang.hitch(_attachScope, thisFunc)));
					}
				}
			}

			return ret;
		},

		_attach: function(node, type, func){
			// summary:
			//		Roughly corresponding to dojo/on, this is the default function for processing a
			//		data-dojo-attach-event.  Meant to attach to DOMNodes, not to widgets.
			// node: DOMNode
			//		The node to setup a listener on.
			// type: String
			//		Event name like "click".
			// getAttrFunc: Function
			//		Function to get the specified property for a given DomNode/Widget.
			// attachFunc: Function?
			//		Attaches an event handler from the specified node/widget to specified function.

			// Map special type names like "mouseenter" to synthetic events.
			// Subclasses are responsible to require() dijit/a11yclick if they want to use it.
			type = type.replace(/^on/, "").toLowerCase();
			if(type == "dijitclick"){
				type = a11yclick || (a11yclick = require("./a11yclick"));
			}else{
				type = synthEvents[type] || type;
			}

			return on(node, type, func);
		},

		_detachTemplateNodes: function() {
			// summary:
			//		Detach and clean up the attachments made in _attachtempalteNodes.

			// Delete all attach points to prevent IE6 memory leaks.
			var _attachScope = this.attachScope || this;
			array.forEach(this._attachPoints, function(point){
				delete _attachScope[point];
			});
			this._attachPoints = [];

			// And same for event handlers
			array.forEach(this._attachEvents, function(handle){ handle.remove(); });
			this._attachEvents = [];
		},

		destroyRendering: function(){
			this._detachTemplateNodes();
			this.inherited(arguments);
		}
	});

	// These arguments can be specified for widgets which are used in templates.
	// Since any widget can be specified as sub widgets in template, mix it
	// into the base widget class.  (This is a hack, but it's effective.).
	// Remove for 2.0.   Also, hide from API doc parser.
	lang.extend(_WidgetBase, /*===== {} || =====*/ {
		dojoAttachEvent: "",
		dojoAttachPoint: ""
	});
	
	return _AttachMixin;
});

},
'dojo/touch':function(){
define(["./_base/kernel", "./aspect", "./dom", "./dom-class", "./_base/lang", "./on", "./has", "./mouse", "./domReady", "./_base/window"],
function(dojo, aspect, dom, domClass, lang, on, has, mouse, domReady, win){

	// module:
	//		dojo/touch

	var ios4 = has("ios") < 5;

	// Detect if platform supports Pointer Events, and if so, the names of the events (pointerdown vs. MSPointerDown).
	var hasPointer = has("pointer-events") || has("MSPointer"),
		pointer = (function () {
			var pointer = {};
			for (var type in { down: 1, move: 1, up: 1, cancel: 1, over: 1, out: 1 }) {
				pointer[type] = has("MSPointer") ?
					"MSPointer" + type.charAt(0).toUpperCase() + type.slice(1) :
					"pointer" + type;
			}
			return pointer;
		})();

	// Detect if platform supports the webkit touchstart/touchend/... events
	var hasTouch = has("touch-events");

	// Click generation variables
	var clicksInited, clickTracker, useTarget = false, clickTarget, clickX, clickY, clickDx, clickDy, clickTime;

	// Time of most recent touchstart, touchmove, or touchend event
	var lastTouch;

	function dualEvent(mouseType, touchType, pointerType){
		// Returns synthetic event that listens for both the specified mouse event and specified touch event.
		// But ignore fake mouse events that were generated due to the user touching the screen.
		if(hasPointer && pointerType){
			// IE10+: MSPointer* events are designed to handle both mouse and touch in a uniform way,
			// so just use that regardless of hasTouch.
			return function(node, listener){
				return on(node, pointerType, listener);
			};
		}else if(hasTouch){
			return function(node, listener){
				var handle1 = on(node, touchType, function(evt){
						listener.call(this, evt);

						// On slow mobile browsers (see https://bugs.dojotoolkit.org/ticket/17634),
						// a handler for a touch event may take >1s to run.  That time shouldn't
						// be included in the calculation for lastTouch.
						lastTouch = (new Date()).getTime();
					}),
					handle2 = on(node, mouseType, function(evt){
						if(!lastTouch || (new Date()).getTime() > lastTouch + 1000){
							listener.call(this, evt);
						}
					});
				return {
					remove: function(){
						handle1.remove();
						handle2.remove();
					}
				};
			};
		}else{
			// Avoid creating listeners for touch events on performance sensitive older browsers like IE6
			return function(node, listener){
				return on(node, mouseType, listener);
			};
		}
	}

	function marked(/*DOMNode*/ node){
		// Search for node ancestor has been marked with the dojoClick property to indicate special processing.
		// Returns marked ancestor.
		do{
			if(node.dojoClick !== undefined){ return node; }
		}while(node = node.parentNode);
	}

	function doClicks(e, moveType, endType){
		// summary:
		//		Setup touch listeners to generate synthetic clicks immediately (rather than waiting for the browser
		//		to generate clicks after the double-tap delay) and consistently (regardless of whether event.preventDefault()
		//		was called in an event listener. Synthetic clicks are generated only if a node or one of its ancestors has
		//		its dojoClick property set to truthy. If a node receives synthetic clicks because one of its ancestors has its
		//      dojoClick property set to truthy, you can disable synthetic clicks on this node by setting its own dojoClick property
		//      to falsy.

		if(mouse.isRight(e)){
			return;		// avoid spurious dojoclick event on IE10+; right click is just for context menu
		}

		var markedNode = marked(e.target);
		clickTracker  = !e.target.disabled && markedNode && markedNode.dojoClick; // click threshold = true, number, x/y object, or "useTarget"
		if(clickTracker){
			useTarget = (clickTracker == "useTarget");
			clickTarget = (useTarget?markedNode:e.target);
			if(useTarget){
				// We expect a click, so prevent any other
				// default action on "touchpress"
				e.preventDefault();
			}
			clickX = e.changedTouches ? e.changedTouches[0].pageX - win.global.pageXOffset : e.clientX;
			clickY = e.changedTouches ? e.changedTouches[0].pageY - win.global.pageYOffset : e.clientY;
			clickDx = (typeof clickTracker == "object" ? clickTracker.x : (typeof clickTracker == "number" ? clickTracker : 0)) || 4;
			clickDy = (typeof clickTracker == "object" ? clickTracker.y : (typeof clickTracker == "number" ? clickTracker : 0)) || 4;

			// add move/end handlers only the first time a node with dojoClick is seen,
			// so we don't add too much overhead when dojoClick is never set.
			if(!clicksInited){
				clicksInited = true;

				var updateClickTracker = function updateClickTracker(e){
					if(useTarget){
						clickTracker = dom.isDescendant(
							win.doc.elementFromPoint(
								(e.changedTouches ? e.changedTouches[0].pageX - win.global.pageXOffset : e.clientX),
								(e.changedTouches ? e.changedTouches[0].pageY - win.global.pageYOffset : e.clientY)),
							clickTarget);
					}else{
						clickTracker = clickTracker &&
							(e.changedTouches ? e.changedTouches[0].target : e.target) == clickTarget &&
							Math.abs((e.changedTouches ? e.changedTouches[0].pageX - win.global.pageXOffset : e.clientX) - clickX) <= clickDx &&
							Math.abs((e.changedTouches ? e.changedTouches[0].pageY - win.global.pageYOffset : e.clientY) - clickY) <= clickDy;
					}
				};

				win.doc.addEventListener(moveType, function(e){
					if(mouse.isRight(e)){
						return;		// avoid spurious dojoclick event on IE10+; right click is just for context menu
					}
					updateClickTracker(e);
					if(useTarget){
						// prevent native scroll event and ensure touchend is
						// fire after touch moves between press and release.
						e.preventDefault();
					}
				}, true);

				win.doc.addEventListener(endType, function(e){
					if(mouse.isRight(e)){
						return;		// avoid spurious dojoclick event on IE10+; right click is just for context menu
					}
					updateClickTracker(e);
					if(clickTracker){
						clickTime = (new Date()).getTime();
						var target = (useTarget?clickTarget:e.target);
						if(target.tagName === "LABEL"){
							// when clicking on a label, forward click to its associated input if any
							target = dom.byId(target.getAttribute("for")) || target;
						}
						//some attributes can be on the Touch object, not on the Event:
						//http://www.w3.org/TR/touch-events/#touch-interface
						var src = (e.changedTouches) ? e.changedTouches[0] : e;
						var createMouseEvent = function createMouseEvent(type){
							//create the synthetic event.
							//http://www.w3.org/TR/DOM-Level-3-Events/#widl-MouseEvent-initMouseEvent
							var evt = document.createEvent("MouseEvents");
							evt._dojo_click = true;
							evt.initMouseEvent(type,
								true, //bubbles
								true, //cancelable
								e.view,
								e.detail,
								src.screenX,
								src.screenY,
								src.clientX,
								src.clientY,
								e.ctrlKey,
								e.altKey,
								e.shiftKey,
								e.metaKey,
								0, //button
								null //related target
							);
							return evt;
						};
						var mouseDownEvt = createMouseEvent("mousedown");
						var mouseUpEvt = createMouseEvent("mouseup");
						var clickEvt = createMouseEvent("click");

						setTimeout(function(){
							on.emit(target, "mousedown", mouseDownEvt);
							on.emit(target, "mouseup", mouseUpEvt);
							on.emit(target, "click", clickEvt);

							// refresh clickTime in case app-defined click handler took a long time to run
							clickTime = (new Date()).getTime();
						}, 0);
					}
				}, true);

				var stopNativeEvents = function stopNativeEvents(type){
					win.doc.addEventListener(type, function(e){
						// Stop native events when we emitted our own click event.  Note that the native click may occur
						// on a different node than the synthetic click event was generated on.  For example,
						// click on a menu item, causing the menu to disappear, and then (~300ms later) the browser
						// sends a click event to the node that was *underneath* the menu.  So stop all native events
						// sent shortly after ours, similar to what is done in dualEvent.
						// The INPUT.dijitOffScreen test is for offscreen inputs used in dijit/form/Button, on which
						// we call click() explicitly, we don't want to stop this event.
						var target = e.target;
						if(clickTracker && !e._dojo_click &&
								(new Date()).getTime() <= clickTime + 1000 &&
								!(target.tagName == "INPUT" && domClass.contains(target, "dijitOffScreen"))){
							e.stopPropagation();
							e.stopImmediatePropagation && e.stopImmediatePropagation();
							if(type == "click" &&
								(target.tagName != "INPUT" ||
								(target.type == "radio" &&
									// #18352 Do not preventDefault for radios that are not dijit or
									// dojox/mobile widgets.
									// (The CSS class dijitCheckBoxInput holds for both checkboxes and radio buttons.)
									(domClass.contains(target, "dijitCheckBoxInput") ||
										domClass.contains(target, "mblRadioButton"))) ||
								(target.type == "checkbox" &&
									// #18352 Do not preventDefault for checkboxes that are not dijit or
									// dojox/mobile widgets.
									(domClass.contains(target, "dijitCheckBoxInput") ||
										domClass.contains(target, "mblCheckBox")))) &&
								target.tagName != "TEXTAREA" && target.tagName != "AUDIO" && target.tagName != "VIDEO"){
								// preventDefault() breaks textual <input>s on android, keyboard doesn't popup,
								// but it is still needed for checkboxes and radio buttons, otherwise in some cases
								// the checked state becomes inconsistent with the widget's state
								e.preventDefault();
							}
						}
					}, true);
				};

				stopNativeEvents("click");

				// We also stop mousedown/up since these would be sent well after with our "fast" click (300ms),
				// which can confuse some dijit widgets.
				stopNativeEvents("mousedown");
				stopNativeEvents("mouseup");
			}
		}
	}

	var hoveredNode;

	if(has("touch")){
		if(hasPointer){
			// MSPointer (IE10+) already has support for over and out, so we just need to init click support
			domReady(function(){
				win.doc.addEventListener(pointer.down, function(evt){
					doClicks(evt, pointer.move, pointer.up);
				}, true);
			});
		}else{
			domReady(function(){
				// Keep track of currently hovered node
				hoveredNode = win.body();	// currently hovered node

				win.doc.addEventListener("touchstart", function(evt){
						lastTouch = (new Date()).getTime();

					// Precede touchstart event with touch.over event.  DnD depends on this.
					// Use addEventListener(cb, true) to run cb before any touchstart handlers on node run,
					// and to ensure this code runs even if the listener on the node does event.stop().
					var oldNode = hoveredNode;
					hoveredNode = evt.target;
					on.emit(oldNode, "dojotouchout", {
						relatedTarget: hoveredNode,
						bubbles: true
					});
					on.emit(hoveredNode, "dojotouchover", {
						relatedTarget: oldNode,
						bubbles: true
					});

					doClicks(evt, "touchmove", "touchend"); // init click generation
				}, true);

				function copyEventProps(evt){
					// Make copy of event object and also set bubbles:true.  Used when calling on.emit().
					var props = lang.delegate(evt, {
						bubbles: true
					});

					if(has("ios") >= 6){
						// On iOS6 "touches" became a non-enumerable property, which
						// is not hit by for...in.  Ditto for the other properties below.
						props.touches = evt.touches;
						props.altKey = evt.altKey;
						props.changedTouches = evt.changedTouches;
						props.ctrlKey = evt.ctrlKey;
						props.metaKey = evt.metaKey;
						props.shiftKey = evt.shiftKey;
						props.targetTouches = evt.targetTouches;
					}

					return props;
				}

				on(win.doc, "touchmove", function(evt){
					lastTouch = (new Date()).getTime();

					var newNode = win.doc.elementFromPoint(
						evt.pageX - (ios4 ? 0 : win.global.pageXOffset), // iOS 4 expects page coords
						evt.pageY - (ios4 ? 0 : win.global.pageYOffset)
					);

					if(newNode){
						// Fire synthetic touchover and touchout events on nodes since the browser won't do it natively.
						if(hoveredNode !== newNode){
							// touch out on the old node
							on.emit(hoveredNode, "dojotouchout", {
								relatedTarget: newNode,
								bubbles: true
							});

							// touchover on the new node
							on.emit(newNode, "dojotouchover", {
								relatedTarget: hoveredNode,
								bubbles: true
							});

							hoveredNode = newNode;
						}

						// Unlike a listener on "touchmove", on(node, "dojotouchmove", listener) fires when the finger
						// drags over the specified node, regardless of which node the touch started on.
						if(!on.emit(newNode, "dojotouchmove", copyEventProps(evt))){
							// emit returns false when synthetic event "dojotouchmove" is cancelled, so we prevent the
							// default behavior of the underlying native event "touchmove".
							evt.preventDefault();
						}
					}
				});

				// Fire a dojotouchend event on the node where the finger was before it was removed from the screen.
				// This is different than the native touchend, which fires on the node where the drag started.
				on(win.doc, "touchend", function(evt){
						lastTouch = (new Date()).getTime();
					var node = win.doc.elementFromPoint(
						evt.pageX - (ios4 ? 0 : win.global.pageXOffset), // iOS 4 expects page coords
						evt.pageY - (ios4 ? 0 : win.global.pageYOffset)
					) || win.body(); // if out of the screen

					on.emit(node, "dojotouchend", copyEventProps(evt));
				});
			});
		}
	}

	//device neutral events - touch.press|move|release|cancel/over/out
	var touch = {
		press: dualEvent("mousedown", "touchstart", pointer.down),
		move: dualEvent("mousemove", "dojotouchmove", pointer.move),
		release: dualEvent("mouseup", "dojotouchend", pointer.up),
		cancel: dualEvent(mouse.leave, "touchcancel", hasPointer ? pointer.cancel : null),
		over: dualEvent("mouseover", "dojotouchover", pointer.over),
		out: dualEvent("mouseout", "dojotouchout", pointer.out),
		enter: mouse._eventHandler(dualEvent("mouseover","dojotouchover", pointer.over)),
		leave: mouse._eventHandler(dualEvent("mouseout", "dojotouchout", pointer.out))
	};

	/*=====
	touch = {
		// summary:
		//		This module provides unified touch event handlers by exporting
		//		press, move, release and cancel which can also run well on desktop.
		//		Based on http://dvcs.w3.org/hg/webevents/raw-file/tip/touchevents.html
		//      Also, if the dojoClick property is set to truthy on a DOM node, dojo/touch generates
		//      click events immediately for this node and its descendants (except for descendants that
		//      have a dojoClick property set to falsy), to avoid the delay before native browser click events,
		//      and regardless of whether evt.preventDefault() was called in a touch.press event listener.
		//
		// example:
		//		Used with dojo/on
		//		|	define(["dojo/on", "dojo/touch"], function(on, touch){
		//		|		on(node, touch.press, function(e){});
		//		|		on(node, touch.move, function(e){});
		//		|		on(node, touch.release, function(e){});
		//		|		on(node, touch.cancel, function(e){});
		// example:
		//		Used with touch.* directly
		//		|	touch.press(node, function(e){});
		//		|	touch.move(node, function(e){});
		//		|	touch.release(node, function(e){});
		//		|	touch.cancel(node, function(e){});
		// example:
		//		Have dojo/touch generate clicks without delay, with a default move threshold of 4 pixels
		//		|	node.dojoClick = true;
		// example:
		//		Have dojo/touch generate clicks without delay, with a move threshold of 10 pixels horizontally and vertically
		//		|	node.dojoClick = 10;
		// example:
		//		Have dojo/touch generate clicks without delay, with a move threshold of 50 pixels horizontally and 10 pixels vertically
		//		|	node.dojoClick = {x:50, y:5};
		// example:
		//		Disable clicks without delay generated by dojo/touch on a node that has an ancestor with property dojoClick set to truthy
		//		|  node.dojoClick = false;

		press: function(node, listener){
			// summary:
			//		Register a listener to 'touchstart'|'mousedown' for the given node
			// node: Dom
			//		Target node to listen to
			// listener: Function
			//		Callback function
			// returns:
			//		A handle which will be used to remove the listener by handle.remove()
		},
		move: function(node, listener){
			// summary:
			//		Register a listener that fires when the mouse cursor or a finger is dragged over the given node.
			// node: Dom
			//		Target node to listen to
			// listener: Function
			//		Callback function
			// returns:
			//		A handle which will be used to remove the listener by handle.remove()
		},
		release: function(node, listener){
			// summary:
			//		Register a listener to releasing the mouse button while the cursor is over the given node
			//		(i.e. "mouseup") or for removing the finger from the screen while touching the given node.
			// node: Dom
			//		Target node to listen to
			// listener: Function
			//		Callback function
			// returns:
			//		A handle which will be used to remove the listener by handle.remove()
		},
		cancel: function(node, listener){
			// summary:
			//		Register a listener to 'touchcancel'|'mouseleave' for the given node
			// node: Dom
			//		Target node to listen to
			// listener: Function
			//		Callback function
			// returns:
			//		A handle which will be used to remove the listener by handle.remove()
		},
		over: function(node, listener){
			// summary:
			//		Register a listener to 'mouseover' or touch equivalent for the given node
			// node: Dom
			//		Target node to listen to
			// listener: Function
			//		Callback function
			// returns:
			//		A handle which will be used to remove the listener by handle.remove()
		},
		out: function(node, listener){
			// summary:
			//		Register a listener to 'mouseout' or touch equivalent for the given node
			// node: Dom
			//		Target node to listen to
			// listener: Function
			//		Callback function
			// returns:
			//		A handle which will be used to remove the listener by handle.remove()
		},
		enter: function(node, listener){
			// summary:
			//		Register a listener to mouse.enter or touch equivalent for the given node
			// node: Dom
			//		Target node to listen to
			// listener: Function
			//		Callback function
			// returns:
			//		A handle which will be used to remove the listener by handle.remove()
		},
		leave: function(node, listener){
			// summary:
			//		Register a listener to mouse.leave or touch equivalent for the given node
			// node: Dom
			//		Target node to listen to
			// listener: Function
			//		Callback function
			// returns:
			//		A handle which will be used to remove the listener by handle.remove()
		}
	};
	=====*/

	 1  && (dojo.touch = touch);

	return touch;
});

},
'soso/sosox/ejs/Helpers':function(){
define([
    'dojo/_base/declare',
    'dojo/_base/array',
    'dojo/_base/lang',
    'dojo/currency',
    'dojo/number',
    'dojo/date',
    'dojo/date/locale',
    'soso/sosox/Formats',
    'soso/sosox/Helpers',
    'spencer/encoding/Template',
    'spencer/format/ProjectStageTitle',
    'spencer/parse/URLToLink',
    'spencer/date-time/Format',
    'vendor/ejs/ejs'
], function(
    declare,
    dojoArray,
    dojoLang,
    dojoCurrency,
    dojoNumber,
    dojoDate,
    dojoDateLocale,
    Formats,
    SosoHelpers,
    TemplateEncoder,
    ProjectStageTitle,
    URLToLink,
    DateTimeFormat,
    templateRenderer
) {
    var Helpers = declare('soso.sosox.ejs.Helpers', [], {
        /**
         * For a given value, tries to create a human representation.
         * @param {Object} input the value being converted.
         * @param {Object} null_text what text should be present if input == null or undefined, defaults to ''
         * @return {String}
         */
        to_text: function(input, null_text) {
            if (input == null || input === undefined) {
                return null_text || '';
            }
            if (input instanceof Date){
                return input.toDateString();
            }
            if (input.toString) {
                return input.toString().replace(/\n/g, '<br />').replace(/''/g, "'");
            }
            return '';
        },
        date_tag: function(name, value , html_options) {
            if (!(value instanceof Date)) {
                value = new Date();
            }
            var month_names = ['January', 'February', 'March', 'April', 'May', 'June',
                               'July', 'August', 'September', 'October', 'November', 'December'];
            var years = [], months = [], days = [];
            var year = value.getFullYear();
            var month = value.getMonth();
            var day = value.getDate();
            for (var y = year - 15; y < year + 15 ; y++) {
                years.push({value: y, text: y});
            }
            for (var m = 0; m < 12; m++) {
                months.push({value: (m), text: month_names[m]});
            }
            for (var d = 0; d < 31; d++) {
                days.push({value: (d + 1), text: (d + 1)});
            }
            var year_select = this.select_tag(name + '[year]', year, years, {id: name + '[year]'} );
            var month_select = this.select_tag(name + '[month]', month, months, {id: name + '[month]'});
            var day_select = this.select_tag(name + '[day]', day, days, {id: name + '[day]'});

            return year_select + month_select + day_select;
        },
        form_tag: function(action, html_options) {
            html_options = html_options    || {};
            html_options.action = action;
            if (html_options.multipart == true) {
                html_options.method = 'post';
                html_options.enctype = 'multipart/form-data';
            }

            return this.start_tag_for('form', html_options);
        },
        form_tag_end: function() {
            return this.tag_end('form');
        },
        hidden_field_tag: function(name, value, html_options) {
            return this.input_field_tag(name, value, 'hidden', html_options);
        },
        input_field_tag: function(name, value , inputType, html_options) {

            html_options = html_options || {};
            html_options.id = html_options.id || name;
            html_options.value = value || '';
            html_options.type = inputType || 'text';
            html_options.name = name;

            return this.single_tag_for('input', html_options);
        },
        is_current_page: function(url) {
            return (window.location.href == url || window.location.pathname == url ? true : false);
        },
        link_to: function(name, url, html_options) {
            if (!name) {
                name = 'null';
            }
            if (!html_options) {
                html_options = {};
            }

            if (html_options.confirm) {
                html_options.onclick =
                    " var ret_confirm = confirm(\"" + html_options.confirm + "\"); if(!ret_confirm){ return false;} ";
                html_options.confirm = null;
            }
            html_options.href = url
            return this.start_tag_for('a', html_options) + name + this.tag_end('a');
        },
        leftPadZeros: function(toPad, length) {
            toPad = toPad.toString();

            while (toPad.length < length)
                toPad = 0 + toPad;
            return toPad;
        },
        submit_link_to: function(name, url, html_options) {
            if (!name) {
                name = 'null';
            };
            if (!html_options) {
                html_options = {}
            };
            html_options.onclick = html_options.onclick || '';

            if (html_options.confirm) {
                html_options.onclick =
                    " var ret_confirm = confirm(\"" + html_options.confirm + "\"); if(!ret_confirm){ return false;} ";
                html_options.confirm = null;
            }

            html_options.value = name;
            html_options.type = 'submit';
            html_options.onclick = html_options.onclick +
                (url ? this.url_for(url) : '') + 'return false;';
            return this.start_tag_for('input', html_options);
        },
        link_to_if: function(condition, name, url, html_options, post, block) {
            return this.link_to_unless((condition == false), name, url, html_options, post, block);
        },
        link_to_unless: function(condition, name, url, html_options, block) {
            html_options = html_options || {};
            if (condition) {
                if (block && typeof block == 'function') {
                    return block(name, url, html_options, block);
                } else {
                    return name;
                }
            } else {
                return this.link_to(name, url, html_options);
            }
        },
        link_to_unless_current: function(name, url, html_options, block) {
            html_options = html_options || {};
            return this.link_to_unless(this.is_current_page(url), name, url, html_options, block);
        },
        password_field_tag: function(name, value, html_options) {
            return this.input_field_tag(name, value, 'password', html_options);
        },
        select_tag: function(name, value, choices, html_options) {
            html_options = html_options || {};
            html_options.id = html_options.id || name;
            html_options.value = value;
            html_options.name = name;

            var txt = '';
            txt += this.start_tag_for('select', html_options);

            for (var i = 0; i < choices.length; i++) {
                var choice = choices[i];
                var optionOptions = {
                    value: choice.value
                }
                if (choice.value == value) {
                    optionOptions.selected = 'selected';
                }
                txt += this.start_tag_for('option', optionOptions ) + choice.text + this.tag_end('option');
            }
            txt += this.tag_end('select');
            return txt;
        },
        single_tag_for: function(tag, html_options) {
            return this.tag(tag, html_options, '/>');
        },
        start_tag_for: function(tag, html_options) {
            return this.tag(tag, html_options);
        },
        submit_tag: function(name, html_options) {
            html_options = html_options || {};
            html_options.type = html_options.type || 'submit';
            html_options.value = name || 'Submit';
            return this.single_tag_for('input', html_options);
        },
        tag: function(tag, html_options, end) {
            if (!end) {
                end = '>';
            };
            var txt = ' ';
            for (var attr in html_options) {
                if (html_options[attr] != null) {
                    var value = html_options[attr].toString();
                } else {
                    var value = '';
                }
                if (attr == "Class") { // special case because "class" is a reserved word in IE
                    attr = "class";
                }
                if (value.indexOf("'") != -1) {
                    txt += attr + '=\"' + value + '\" ';
                } else {
                    txt += attr + "='" + value + "' ";
                }
            }
            return '<' + tag + txt + end;
        },
        tag_end: function(tag) {
            return '</' + tag + '>';
        },
        text_area_tag: function(name, value, html_options) {
            html_options = html_options || {};
            html_options.id = html_options.id || name;
            html_options.name = html_options.name || name;
            value = value || ''
            if (html_options.size) {
                html_options.cols = html_options.size.split('x')[0];
                html_options.rows = html_options.size.split('x')[1];
                delete html_options.size;
            }

            html_options.cols = html_options.cols || 50;
            html_options.rows = html_options.rows || 4;

            return this.start_tag_for('textarea', html_options) + value + this.tag_end('textarea');
        },
        text_field_tag: function(name, value, html_options) {
            return this.input_field_tag(name, value, 'text', html_options);
        },
        url_for: function(url) {
            return 'window.location="' + url +'";';
        },
        img_tag: function(image_location, alt, options) {
            options = options || {};
            options.src = image_location;
            options.alt = alt;
            return this.single_tag_for('img', options);
        },

        formats: Formats,

        accountingCurrency: function(value, isDeductable) {
            var format = this.formats.currency.standard;
            var formatted = dojoCurrency.format(value, format);

            if (this.isNegative(value) || (isDeductable && parseFloat(value) > 0)) {
                formatted = formatted.replace("-", "");
                formatted = "<span class='sos-text-numeric-negative'>(" + formatted + ")</span>";
            }

            return formatted;
        },

        currency: function(value, format) {
            if (format === undefined) {
                format = this.formats.currency.standard;
            }

            if (format.currency === undefined) {
                format.currency = this.formats.currency.code;
            }

            if (format.pattern === undefined) {
                format.pattern = this.formats.currency.standard.pattern;
            }

            if (format.places === undefined) {
                format.places = this.formats.currency.standard.places;
            }

            if (typeof value == "string") {
                value = dojoCurrency.parse(value, format);
            }
            return dojoCurrency.format(value, format);
        },

        number: function(value, format) {
            if (format === undefined) {
                format = this.formats.number.standard;
            }

            if (typeof value == "string") {
                value = dojoNumber.parse(value, format);
            }
            return dojoNumber.format(value, format);
        },
        dateFormat: {
            locale: 'en-gb',
            formatLength: 'short',
            selector: 'date'
        },

        dateFormatLong: {
            locale: 'en-gb',
            formatLength: 'long',
            timePattern: "HH:mm:ss"
        },

        toLocaleISOString: function (date) {
            return new DateTimeFormat().toLocaleISOString(date);
        },

        toLongLocaleDateString: function(date) {
            return new DateTimeFormat().toLongLocaleDateString(date);
        },

        date: function(date, format) {
            var dateString = date;
            if (format === undefined) {
                format = this.dateFormat;
            }

            if(format === 'formatLong') {
                format = this.dateFormatLong;
            }

            // If date isn't a Date object, assume ISO string representation
            if (!(date instanceof Date)) {
                date = dojoDateLocale.parse(date, {
                    selector: "date",
                    datePattern: "yyy-MM-dd"
                });
            }

            // If the date could not be parsed into a date object attempt to create a new Date object from the
            // provided date string
            if(!(date instanceof Date)) {
                date = new Date(dateString);
            }

            // If dojo was not able to parse the date it's because it is in the wrong format:
            // - return empty string instead of NaN/NaN/NaN
            if (!(date instanceof Date)) {
                return "";
            }
            return dojoDateLocale.format(date, format);
        },
        dateIntervals: ["year", "month", "day", "hour", "minute", "second", "millisecond", "quarter", "week", "weekday"],
        dateAdd: function(date, value, interval) {
            // If date isn't a Date object, assume ISO string representation
            if (!(date instanceof Date)) {
                date = dojoDateLocale.parse(date, {
                    selector: "date",
                    datePattern: "yyy-MM-dd"
                });
            }
            // If Dojo was not able to parse the date or the duration to add to the date is not valid
            // - force return
            if (!(date instanceof Date) || isNaN(parseInt(value))
                || dojoArray.indexOf(this.dateIntervals, interval) == -1
            ) {
                return;
            }
            return dojoDate.add(date, interval, parseInt(value));
        },
        fileSize: function(bytes, precision) {
            return SosoHelpers.fileSize(bytes, precision);
        },
        fileExtension: function(filename) {
            return SosoHelpers.fileExtension(filename);
        },
        revisionDownloadLink: function(revisionPK) {
            return SosoHelpers.revisionDownloadLink(revisionPK);
        },
        temporaryDocumentDownloadLink: function(temporaryDocumentPK, md5Hash) {
            return SosoHelpers.temporaryDocumentDownloadLink(temporaryDocumentPK, md5Hash);
        },

        isNegative: function(value) {
            return parseFloat(value) < 0;
        },

        personDisplayName: function(person) {
            if(person.jobTitle) {
                return person.displayName + " [" + person.jobTitle +"]";
            }

            return person.displayName;
        },

        projectStageDisplayName: function(projectStage) {
            var projectStageTitle = new ProjectStageTitle();
            projectStageTitle.setStageNumber(projectStage.stageNumber);
            projectStageTitle.setTitle(projectStage.title);

            return projectStageTitle.format();
        },
        nl2br: function(str) {
            if (typeof str === 'undefined' || str === null) {
                return ''
            }

            return (str + '')
                .replace(/(\r\n|\n\r|\r|\n)/g, '<br />' + '$1');
        },
        summariseText: function(str, maxLength, maxBreaks) {
           return this.formatText(str.replace(/\n\s*\n/g, '\n').trim(), maxLength, maxBreaks);
        },
        formatText: function(str, maxLength, maxBreaks) {
            if (typeof str === 'undefined' || str === null) {
                return ''
            }

            if (typeof maxLength !== 'undefined') {
                if (str.length > maxLength) {
                    str = str.substring(0, maxLength) + " ...";
                }
            }

            str = this.nl2br(templateRenderer.escapeXML(str));

            if (typeof maxBreaks !== 'undefined') {
                var lines = str.split('<br />');

                str = '';
                for (var i = 1; i <= lines.length && i <= maxBreaks; i++) {
                    str += lines[i - 1];

                    if (i !== maxBreaks && i !== lines.length) {
                        str += '<br />';
                    }
                }
            }

            return str;
        },
        generateDocumentNodePath: function(nodeName, isRootNode) {
            let path = '';

            if (nodeName && !isRootNode) {
                path = "/ ... / " + nodeName
            }

            if (nodeName && isRootNode) {
                path = "/ " + nodeName
            }

            return path;
        },
        encode: function(text) {
            return new TemplateEncoder().encode(text);
        },
        convertWebAddressesToAnchors: function(string, options) {
            return new URLToLink().parse(string, options)
        },
        timestampToDateTime: function(timestamp, format) {
            return dojoDateLocale.format(new Date(this._convertUnixTimestampToMilliseconds(timestamp)), format);
        },
        _convertUnixTimestampToMilliseconds: function(timestamp) {
            return timestamp.toString().length === 10 ? timestamp*1000 : timestamp;
        },

        generateGhostRows: function(columnCount, rowCount) {
            const container = document.createElement("tbody");

            for(let j = 0; j < rowCount; j++) {
                const tr = document.createElement('tr');
                tr.setAttribute('class', 'sos-table-ghost-row');

                for (let h = 0; h < columnCount; h++) {
                    tr.appendChild(document.createElement('td'));
                }

                container.appendChild(tr);
            }

            return container.innerHTML;
        }
    });

    Helpers.prototype.render = function(template, data, customViewHelpers) {
        if (customViewHelpers === undefined) {
            customViewHelpers = {};
        }
        return templateRenderer.render(template, dojoLang.mixin(new Helpers, data, customViewHelpers))
    };

    return Helpers;
});

},
'dojo/currency':function(){
define([
	"./_base/array",
	"./_base/lang",
	/*===== "./_base/declare", =====*/
	"./number",
	"./i18n", "./i18n!./cldr/nls/currency",
	"./cldr/monetary"
], function(darray, lang, /*===== declare, =====*/ dnumber, i18n, nlsCurrency, cldrMonetary){

// module:
//		dojo/currency

var currency = {
	// summary:
	//		localized formatting and parsing routines for currencies
	// description:
	//		extends dojo.number to provide culturally-appropriate formatting of values
	//		in various world currencies, including use of a currency symbol.  The currencies are specified
	//		by a three-letter international symbol in all uppercase, and support for the currencies is
	//		provided by the data in `dojo.cldr`.  The scripts generating dojo.cldr specify which
	//		currency support is included.  A fixed number of decimal places is determined based
	//		on the currency type and is not determined by the 'pattern' argument.  The fractional
	//		portion is optional, by default, and variable length decimals are not supported.
};
lang.setObject("dojo.currency", currency);

currency._mixInDefaults = function(options){
	options = options || {};
	options.type = "currency";

	// Get locale-dependent currency data, like the symbol
	var bundle = i18n.getLocalization("dojo.cldr", "currency", options.locale) || {};

	// Mixin locale-independent currency data, like # of places
	var iso = options.currency;
	var data = cldrMonetary.getData(iso);

	darray.forEach(["displayName","symbol","group","decimal"], function(prop){
		data[prop] = bundle[iso+"_"+prop];
	});

	data.fractional = [true, false];

	// Mixin with provided options
	return lang.mixin(data, options);
};

/*=====
currency.__FormatOptions = declare([dnumber.__FormatOptions], {
	// type: String?
	//		Should not be set.  Value is assumed to be "currency".
	// symbol: String?
	//		localized currency symbol. The default will be looked up in table of supported currencies in `dojo.cldr`
	//		A [ISO4217](http://en.wikipedia.org/wiki/ISO_4217) currency code will be used if not found.
	// currency: String?
	//		an [ISO4217](http://en.wikipedia.org/wiki/ISO_4217) currency code, a three letter sequence like "USD".
	//		For use with dojo.currency only.
	// places: Number?
	//		number of decimal places to show.  Default is defined based on which currency is used.
	type: "",
	symbol: "",
	currency: "",
	places: ""
});
=====*/

currency.format = function(/*Number*/ value, /*__FormatOptions?*/ options){
	// summary:
	//		Format a Number as a currency, using locale-specific settings
	//
	// description:
	//		Create a string from a Number using a known, localized pattern.
	//		[Formatting patterns](http://www.unicode.org/reports/tr35/#Number_Elements)
	//		appropriate to the locale are chosen from the [CLDR](http://unicode.org/cldr)
	//		as well as the appropriate symbols and delimiters and number of decimal places.
	//
	// value:
	//		the number to be formatted.

	return dnumber.format(value, currency._mixInDefaults(options));
};

currency.regexp = function(/*dnumber.__RegexpOptions?*/ options){
	//
	// summary:
	//		Builds the regular needed to parse a currency value
	//
	// description:
	//		Returns regular expression with positive and negative match, group and decimal separators
	//		Note: the options.places default, the number of decimal places to accept, is defined by the currency type.
	return dnumber.regexp(currency._mixInDefaults(options)); // String
};

/*=====
var __ParseOptions = currency.__ParseOptions = declare(dnumber.__ParseOptions, {
	// type: String?
	//		Should not be set.  Value is assumed to be currency.
	// currency: String?
	//		an [ISO4217](http://en.wikipedia.org/wiki/ISO_4217) currency code, a three letter sequence like "USD".
	//		For use with dojo.currency only.
	// symbol: String?
	//		localized currency symbol. The default will be looked up in table of supported currencies in `dojo.cldr`
	//		A [ISO4217](http://en.wikipedia.org/wiki/ISO_4217) currency code will be used if not found.
	// places: Number?
	//		fixed number of decimal places to accept.  The default is determined based on which currency is used.
	// fractional: Boolean|Array?
	//		Whether to include the fractional portion, where the number of decimal places are implied by the currency
	//		or explicit 'places' parameter.  The value [true,false] makes the fractional portion optional.
	//		By default for currencies, it the fractional portion is optional.
});
=====*/

currency.parse = function(/*String*/ expression, /*__ParseOptions?*/ options){
	//
	// summary:
	//		Convert a properly formatted currency string to a primitive Number,
	//		using locale-specific settings.
	// description:
	//		Create a Number from a string using a known, localized pattern.
	//		[Formatting patterns](http://www.unicode.org/reports/tr35/#Number_Format_Patterns)
	//		are chosen appropriate to the locale, as well as the appropriate symbols and delimiters
	//		and number of decimal places.
	// expression:
	//		A string representation of a currency value

	return dnumber.parse(expression, currency._mixInDefaults(options));
};

return currency;
});

},
'dojo/number':function(){
define([/*===== "./_base/declare", =====*/ "./_base/lang", "./i18n", "./i18n!./cldr/nls/number", "./string", "./regexp"],
	function(/*===== declare, =====*/ lang, i18n, nlsNumber, dstring, dregexp){

// module:
//		dojo/number

var number = {
	// summary:
	//		localized formatting and parsing routines for Number
};
lang.setObject("dojo.number", number);

/*=====
number.__FormatOptions = declare(null, {
	// pattern: String?
	//		override [formatting pattern](http://www.unicode.org/reports/tr35/#Number_Format_Patterns)
	//		with this string.  Default value is based on locale.  Overriding this property will defeat
	//		localization.  Literal characters in patterns are not supported.
	// type: String?
	//		choose a format type based on the locale from the following:
	//		decimal, scientific (not yet supported), percent, currency. decimal by default.
	// places: Number?
	//		fixed number of decimal places to show.  This overrides any
	//		information in the provided pattern.
	// round: Number?
	//		5 rounds to nearest .5; 0 rounds to nearest whole (default). -1
	//		means do not round.
	// locale: String?
	//		override the locale used to determine formatting rules
	// fractional: Boolean?
	//		If false, show no decimal places, overriding places and pattern settings.
});
=====*/

number.format = function(/*Number*/ value, /*number.__FormatOptions?*/ options){
	// summary:
	//		Format a Number as a String, using locale-specific settings
	// description:
	//		Create a string from a Number using a known localized pattern.
	//		Formatting patterns appropriate to the locale are chosen from the
	//		[Common Locale Data Repository](http://unicode.org/cldr) as well as the appropriate symbols and
	//		delimiters.
	//		If value is Infinity, -Infinity, or is not a valid JavaScript number, return null.
	// value:
	//		the number to be formatted

	options = lang.mixin({}, options || {});
	var locale = i18n.normalizeLocale(options.locale),
		bundle = i18n.getLocalization("dojo.cldr", "number", locale);
	options.customs = bundle;
	var pattern = options.pattern || bundle[(options.type || "decimal") + "Format"];
	if(isNaN(value) || Math.abs(value) == Infinity){ return null; } // null
	return number._applyPattern(value, pattern, options); // String
};

//number._numberPatternRE = /(?:[#0]*,?)*[#0](?:\.0*#*)?/; // not precise, but good enough
number._numberPatternRE = /[#0,]*[#0](?:\.0*#*)?/; // not precise, but good enough

number._applyPattern = function(/*Number*/ value, /*String*/ pattern, /*number.__FormatOptions?*/ options){
	// summary:
	//		Apply pattern to format value as a string using options. Gives no
	//		consideration to local customs.
	// value:
	//		the number to be formatted.
	// pattern:
	//		a pattern string as described by
	//		[unicode.org TR35](http://www.unicode.org/reports/tr35/#Number_Format_Patterns)
	// options: number.__FormatOptions?
	//		_applyPattern is usually called via `dojo/number.format()` which
	//		populates an extra property in the options parameter, "customs".
	//		The customs object specifies group and decimal parameters if set.

	//TODO: support escapes
	options = options || {};
	var group = options.customs.group,
		decimal = options.customs.decimal,
		patternList = pattern.split(';'),
		positivePattern = patternList[0];
	pattern = patternList[(value < 0) ? 1 : 0] || ("-" + positivePattern);

	//TODO: only test against unescaped
	if(pattern.indexOf('%') != -1){
		value *= 100;
	}else if(pattern.indexOf('\u2030') != -1){
		value *= 1000; // per mille
	}else if(pattern.indexOf('\u00a4') != -1){
		group = options.customs.currencyGroup || group;//mixins instead?
		decimal = options.customs.currencyDecimal || decimal;// Should these be mixins instead?
		pattern = pattern.replace(/([\s\xa0\u202f]*)(\u00a4{1,3})([\s\xa0\u202f]*)/, function(match, before, target, after){
			var prop = ["symbol", "currency", "displayName"][target.length-1],
				symbol = options[prop] || options.currency || "";
			// if there is no symbol, also remove surrounding whitespaces
			if(!symbol){
				return "";
			}
			return before+symbol+after;
		});
	}else if(pattern.indexOf('E') != -1){
		throw new Error("exponential notation not supported");
	}

	//TODO: support @ sig figs?
	var numberPatternRE = number._numberPatternRE;
	var numberPattern = positivePattern.match(numberPatternRE);
	if(!numberPattern){
		throw new Error("unable to find a number expression in pattern: "+pattern);
	}
	if(options.fractional === false){ options.places = 0; }
	return pattern.replace(numberPatternRE,
		number._formatAbsolute(value, numberPattern[0], {decimal: decimal, group: group, places: options.places, round: options.round}));
};

number.round = function(/*Number*/ value, /*Number?*/ places, /*Number?*/ increment){
	// summary:
	//		Rounds to the nearest value with the given number of decimal places, away from zero
	// description:
	//		Rounds to the nearest value with the given number of decimal places, away from zero if equal.
	//		Similar to Number.toFixed(), but compensates for browser quirks. Rounding can be done by
	//		fractional increments also, such as the nearest quarter.
	//		NOTE: Subject to floating point errors.  See dojox/math/round for experimental workaround.
	// value:
	//		The number to round
	// places:
	//		The number of decimal places where rounding takes place.  Defaults to 0 for whole rounding.
	//		Must be non-negative.
	// increment:
	//		Rounds next place to nearest value of increment/10.  10 by default.
	// example:
	// |	>>> number.round(-0.5)
	// |	-1
	// |	>>> number.round(162.295, 2)
	// |	162.29  // note floating point error.  Should be 162.3
	// |	>>> number.round(10.71, 0, 2.5)
	// |	10.75
	var factor = 10 / (increment || 10);
	return (factor * +value).toFixed(places) / factor; // Number
};

if((0.9).toFixed() == 0){
	// (isIE) toFixed() bug workaround: Rounding fails on IE when most significant digit
	// is just after the rounding place and is >=5
	var round = number.round;
	number.round = function(v, p, m){
		var d = Math.pow(10, -p || 0), a = Math.abs(v);
		if(!v || a >= d){
			d = 0;
		}else{
			a /= d;
			if(a < 0.5 || a >= 0.95){
				d = 0;
			}
		}
		return round(v, p, m) + (v > 0 ? d : -d);
	};

	// Use "doc hint" so the doc parser ignores this new definition of round(), and uses the one above.
	/*===== number.round = round; =====*/
}

/*=====
number.__FormatAbsoluteOptions = declare(null, {
	// decimal: String?
	//		the decimal separator
	// group: String?
	//		the group separator
	// places: Number|String?
	//		number of decimal places.  the range "n,m" will format to m places.
	// round: Number?
	//		5 rounds to nearest .5; 0 rounds to nearest whole (default). -1
	//		means don't round.
});
=====*/

number._formatAbsolute = function(/*Number*/ value, /*String*/ pattern, /*number.__FormatAbsoluteOptions?*/ options){
	// summary:
	//		Apply numeric pattern to absolute value using options. Gives no
	//		consideration to local customs.
	// value:
	//		the number to be formatted, ignores sign
	// pattern:
	//		the number portion of a pattern (e.g. `#,##0.00`)
	options = options || {};
	if(options.places === true){options.places=0;}
	if(options.places === Infinity){options.places=6;} // avoid a loop; pick a limit

	var patternParts = pattern.split("."),
		comma = typeof options.places == "string" && options.places.indexOf(","),
		maxPlaces = options.places;
	if(comma){
		maxPlaces = options.places.substring(comma + 1);
	}else if(!(maxPlaces >= 0)){
		maxPlaces = (patternParts[1] || []).length;
	}
	if(!(options.round < 0)){
		value = number.round(value, maxPlaces, options.round);
	}

	var valueParts = String(Math.abs(value)).split("."),
		fractional = valueParts[1] || "";
	if(patternParts[1] || options.places){
		if(comma){
			options.places = options.places.substring(0, comma);
		}
		// Pad fractional with trailing zeros
		var pad = options.places !== undefined ? options.places : (patternParts[1] && patternParts[1].lastIndexOf("0") + 1);
		if(pad > fractional.length){
			valueParts[1] = dstring.pad(fractional, pad, '0', true);
		}

		// Truncate fractional
		if(maxPlaces < fractional.length){
			valueParts[1] = fractional.substr(0, maxPlaces);
		}
	}else{
		if(valueParts[1]){ valueParts.pop(); }
	}

	// Pad whole with leading zeros
	var patternDigits = patternParts[0].replace(',', '');
	pad = patternDigits.indexOf("0");
	if(pad != -1){
		pad = patternDigits.length - pad;
		if(pad > valueParts[0].length){
			valueParts[0] = dstring.pad(valueParts[0], pad);
		}

		// Truncate whole
		if(patternDigits.indexOf("#") == -1){
			valueParts[0] = valueParts[0].substr(valueParts[0].length - pad);
		}
	}

	// Add group separators
	var index = patternParts[0].lastIndexOf(','),
		groupSize, groupSize2;
	if(index != -1){
		groupSize = patternParts[0].length - index - 1;
		var remainder = patternParts[0].substr(0, index);
		index = remainder.lastIndexOf(',');
		if(index != -1){
			groupSize2 = remainder.length - index - 1;
		}
	}
	var pieces = [];
	for(var whole = valueParts[0]; whole;){
		var off = whole.length - groupSize;
		pieces.push((off > 0) ? whole.substr(off) : whole);
		whole = (off > 0) ? whole.slice(0, off) : "";
		if(groupSize2){
			groupSize = groupSize2;
			groupSize2 = undefined;
		}
	}
	valueParts[0] = pieces.reverse().join(options.group || ",");

	return valueParts.join(options.decimal || ".");
};

/*=====
number.__RegexpOptions = declare(null, {
	// pattern: String?
	//		override [formatting pattern](http://www.unicode.org/reports/tr35/#Number_Format_Patterns)
	//		with this string.  Default value is based on locale.  Overriding this property will defeat
	//		localization.
	// type: String?
	//		choose a format type based on the locale from the following:
	//		decimal, scientific (not yet supported), percent, currency. decimal by default.
	// locale: String?
	//		override the locale used to determine formatting rules
	// strict: Boolean?
	//		strict parsing, false by default.  Strict parsing requires input as produced by the format() method.
	//		Non-strict is more permissive, e.g. flexible on white space, omitting thousands separators
	// places: Number|String?
	//		number of decimal places to accept: Infinity, a positive number, or
	//		a range "n,m".  Defined by pattern or Infinity if pattern not provided.
});
=====*/
number.regexp = function(/*number.__RegexpOptions?*/ options){
	// summary:
	//		Builds the regular needed to parse a number
	// description:
	//		Returns regular expression with positive and negative match, group
	//		and decimal separators
	return number._parseInfo(options).regexp; // String
};

number._parseInfo = function(/*Object?*/ options){
	options = options || {};
	var locale = i18n.normalizeLocale(options.locale),
		bundle = i18n.getLocalization("dojo.cldr", "number", locale),
		pattern = options.pattern || bundle[(options.type || "decimal") + "Format"],
//TODO: memoize?
		group = bundle.group,
		decimal = bundle.decimal,
		factor = 1;

	if(pattern.indexOf('%') != -1){
		factor /= 100;
	}else if(pattern.indexOf('\u2030') != -1){
		factor /= 1000; // per mille
	}else{
		var isCurrency = pattern.indexOf('\u00a4') != -1;
		if(isCurrency){
			group = bundle.currencyGroup || group;
			decimal = bundle.currencyDecimal || decimal;
		}
	}

	//TODO: handle quoted escapes
	var patternList = pattern.split(';');
	if(patternList.length == 1){
		patternList.push("-" + patternList[0]);
	}

	var re = dregexp.buildGroupRE(patternList, function(pattern){
		pattern = "(?:"+dregexp.escapeString(pattern, '.')+")";
		return pattern.replace(number._numberPatternRE, function(format){
			var flags = {
				signed: false,
				separator: options.strict ? group : [group,""],
				fractional: options.fractional,
				decimal: decimal,
				exponent: false
				},

				parts = format.split('.'),
				places = options.places;

			// special condition for percent (factor != 1)
			// allow decimal places even if not specified in pattern
			if(parts.length == 1 && factor != 1){
			    parts[1] = "###";
			}
			if(parts.length == 1 || places === 0){
				flags.fractional = false;
			}else{
				if(places === undefined){ places = options.pattern ? parts[1].lastIndexOf('0') + 1 : Infinity; }
				if(places && options.fractional == undefined){flags.fractional = true;} // required fractional, unless otherwise specified
				if(!options.places && (places < parts[1].length)){ places += "," + parts[1].length; }
				flags.places = places;
			}
			var groups = parts[0].split(',');
			if(groups.length > 1){
				flags.groupSize = groups.pop().length;
				if(groups.length > 1){
					flags.groupSize2 = groups.pop().length;
				}
			}
			return "("+number._realNumberRegexp(flags)+")";
		});
	}, true);

	if(isCurrency){
		// substitute the currency symbol for the placeholder in the pattern
		re = re.replace(/([\s\xa0\u202f]*)(\u00a4{1,3})([\s\xa0\u202f]*)/g, function(match, before, target, after){
			var prop = ["symbol", "currency", "displayName"][target.length-1],
				symbol = dregexp.escapeString(options[prop] || options.currency || "");

			// if there is no symbol there is no need to take white-spaces into account.
			if(!symbol){
				return "";
			}

			before = before ? "[\\s\\xa0\\u202f]" : "";
			after = after ? "[\\s\\xa0\\u202f]" : "";
			if(!options.strict){
				if(before){before += "*";}
				if(after){after += "*";}
				return "(?:"+before+symbol+after+")?";
			}
			return before+symbol+after;
		});
	}

//TODO: substitute localized sign/percent/permille/etc.?

	// normalize whitespace and return
	return {regexp: re.replace(/[\xa0\u202f ]/g, "[\\s\\xa0\\u202f]"), group: group, decimal: decimal, factor: factor}; // Object
};

/*=====
number.__ParseOptions = declare(null, {
	// pattern: String?
	//		override [formatting pattern](http://www.unicode.org/reports/tr35/#Number_Format_Patterns)
	//		with this string.  Default value is based on locale.  Overriding this property will defeat
	//		localization.  Literal characters in patterns are not supported.
	// type: String?
	//		choose a format type based on the locale from the following:
	//		decimal, scientific (not yet supported), percent, currency. decimal by default.
	// locale: String?
	//		override the locale used to determine formatting rules
	// strict: Boolean?
	//		strict parsing, false by default.  Strict parsing requires input as produced by the format() method.
	//		Non-strict is more permissive, e.g. flexible on white space, omitting thousands separators
	// fractional: Boolean|Array?
	//		Whether to include the fractional portion, where the number of decimal places are implied by pattern
	//		or explicit 'places' parameter.  The value [true,false] makes the fractional portion optional.
});
=====*/
number.parse = function(/*String*/ expression, /*number.__ParseOptions?*/ options){
	// summary:
	//		Convert a properly formatted string to a primitive Number, using
	//		locale-specific settings.
	// description:
	//		Create a Number from a string using a known localized pattern.
	//		Formatting patterns are chosen appropriate to the locale
	//		and follow the syntax described by
	//		[unicode.org TR35](http://www.unicode.org/reports/tr35/#Number_Format_Patterns)
    	//		Note that literal characters in patterns are not supported.
	// expression:
	//		A string representation of a Number
	var info = number._parseInfo(options),
		results = (new RegExp("^"+info.regexp+"$")).exec(expression);
	if(!results){
		return NaN; //NaN
	}
	var absoluteMatch = results[1]; // match for the positive expression
	if(!results[1]){
		if(!results[2]){
			return NaN; //NaN
		}
		// matched the negative pattern
		absoluteMatch =results[2];
		info.factor *= -1;
	}

	// Transform it to something Javascript can parse as a number.  Normalize
	// decimal point and strip out group separators or alternate forms of whitespace
	absoluteMatch = absoluteMatch.
		replace(new RegExp("["+info.group + "\\s\\xa0\\u202f"+"]", "g"), "").
		replace(info.decimal, ".");
	// Adjust for negative sign, percent, etc. as necessary
	return absoluteMatch * info.factor; //Number
};

/*=====
number.__RealNumberRegexpFlags = declare(null, {
	// places: Number?
	//		The integer number of decimal places or a range given as "n,m".  If
	//		not given, the decimal part is optional and the number of places is
	//		unlimited.
	// decimal: String?
	//		A string for the character used as the decimal point.  Default
	//		is ".".
	// fractional: Boolean|Array?
	//		Whether decimal places are used.  Can be true, false, or [true,
	//		false].  Default is [true, false] which means optional.
	// exponent: Boolean|Array?
	//		Express in exponential notation.  Can be true, false, or [true,
	//		false]. Default is [true, false], (i.e. will match if the
	//		exponential part is present are not).
	// eSigned: Boolean|Array?
	//		The leading plus-or-minus sign on the exponent.  Can be true,
	//		false, or [true, false].  Default is [true, false], (i.e. will
	//		match if it is signed or unsigned).  flags in regexp.integer can be
	//		applied.
});
=====*/

number._realNumberRegexp = function(/*__RealNumberRegexpFlags?*/ flags){
	// summary:
	//		Builds a regular expression to match a real number in exponential
	//		notation

	// assign default values to missing parameters
	flags = flags || {};
	//TODO: use mixin instead?
	if(!("places" in flags)){ flags.places = Infinity; }
	if(typeof flags.decimal != "string"){ flags.decimal = "."; }
	if(!("fractional" in flags) || /^0/.test(flags.places)){ flags.fractional = [true, false]; }
	if(!("exponent" in flags)){ flags.exponent = [true, false]; }
	if(!("eSigned" in flags)){ flags.eSigned = [true, false]; }

	var integerRE = number._integerRegexp(flags),
		decimalRE = dregexp.buildGroupRE(flags.fractional,
		function(q){
			var re = "";
			if(q && (flags.places!==0)){
				re = "\\" + flags.decimal;
				if(flags.places == Infinity){
					re = "(?:" + re + "\\d+)?";
				}else{
					re += "\\d{" + flags.places + "}";
				}
			}
			return re;
		},
		true
	);

	var exponentRE = dregexp.buildGroupRE(flags.exponent,
		function(q){
			if(q){ return "([eE]" + number._integerRegexp({ signed: flags.eSigned}) + ")"; }
			return "";
		}
	);

	var realRE = integerRE + decimalRE;
	// allow for decimals without integers, e.g. .25
	if(decimalRE){realRE = "(?:(?:"+ realRE + ")|(?:" + decimalRE + "))";}
	return realRE + exponentRE; // String
};

/*=====
number.__IntegerRegexpFlags = declare(null, {
	// signed: Boolean?
	//		The leading plus-or-minus sign. Can be true, false, or `[true,false]`.
	//		Default is `[true, false]`, (i.e. will match if it is signed
	//		or unsigned).
	// separator: String?
	//		The character used as the thousands separator. Default is no
	//		separator. For more than one symbol use an array, e.g. `[",", ""]`,
	//		makes ',' optional.
	// groupSize: Number?
	//		group size between separators
	// groupSize2: Number?
	//		second grouping, where separators 2..n have a different interval than the first separator (for India)
});
=====*/

number._integerRegexp = function(/*number.__IntegerRegexpFlags?*/ flags){
	// summary:
	//		Builds a regular expression that matches an integer

	// assign default values to missing parameters
	flags = flags || {};
	if(!("signed" in flags)){ flags.signed = [true, false]; }
	if(!("separator" in flags)){
		flags.separator = "";
	}else if(!("groupSize" in flags)){
		flags.groupSize = 3;
	}

	var signRE = dregexp.buildGroupRE(flags.signed,
		function(q){ return q ? "[-+]" : ""; },
		true
	);

	var numberRE = dregexp.buildGroupRE(flags.separator,
		function(sep){
			if(!sep){
				return "(?:\\d+)";
			}

			sep = dregexp.escapeString(sep);
			if(sep == " "){ sep = "\\s"; }
			else if(sep == "\xa0"){ sep = "\\s\\xa0"; }
			else if(sep == "\u202f"){ sep = "\\s\\u202f"; }

			var grp = flags.groupSize, grp2 = flags.groupSize2;
			//TODO: should we continue to enforce that numbers with separators begin with 1-9?  See #6933
			if(grp2){
				var grp2RE = "(?:0|[1-9]\\d{0," + (grp2-1) + "}(?:[" + sep + "]\\d{" + grp2 + "})*[" + sep + "]\\d{" + grp + "})";
				return ((grp-grp2) > 0) ? "(?:" + grp2RE + "|(?:0|[1-9]\\d{0," + (grp-1) + "}))" : grp2RE;
			}
			return "(?:0|[1-9]\\d{0," + (grp-1) + "}(?:[" + sep + "]\\d{" + grp + "})*)";
		},
		true
	);

	return signRE + numberRE; // String
};

return number;
});

},
'dojo/i18n':function(){
define(["./_base/kernel", "require", "./has", "./_base/array", "./_base/config", "./_base/lang", "./_base/xhr", "./json", "module"],
	function(dojo, require, has, array, config, lang, xhr, json, module){

	// module:
	//		dojo/i18n

	has.add("dojo-preload-i18n-Api",
		// if true, define the preload localizations machinery
		1
	);

	 1 || has.add("dojo-v1x-i18n-Api",
		// if true, define the v1.x i18n functions
		1
	);

	var
		thisModule = dojo.i18n =
			{
				// summary:
				//		This module implements the dojo/i18n! plugin and the v1.6- i18n API
				// description:
				//		We choose to include our own plugin to leverage functionality already contained in dojo
				//		and thereby reduce the size of the plugin compared to various loader implementations. Also, this
				//		allows foreign AMD loaders to be used without their plugins.
			},

		nlsRe =
			// regexp for reconstructing the master bundle name from parts of the regexp match
			// nlsRe.exec("foo/bar/baz/nls/en-ca/foo") gives:
			// ["foo/bar/baz/nls/en-ca/foo", "foo/bar/baz/nls/", "/", "/", "en-ca", "foo"]
			// nlsRe.exec("foo/bar/baz/nls/foo") gives:
			// ["foo/bar/baz/nls/foo", "foo/bar/baz/nls/", "/", "/", "foo", ""]
			// so, if match[5] is blank, it means this is the top bundle definition.
			// courtesy of http://requirejs.org
			/(^.*(^|\/)nls)(\/|$)([^\/]*)\/?([^\/]*)/,

		getAvailableLocales = function(
			root,
			locale,
			bundlePath,
			bundleName
		){
			// summary:
			//		return a vector of module ids containing all available locales with respect to the target locale
			//		For example, assuming:
			//
			//		- the root bundle indicates specific bundles for "fr" and "fr-ca",
			//		-  bundlePath is "myPackage/nls"
			//		- bundleName is "myBundle"
			//
			//		Then a locale argument of "fr-ca" would return
			//
			//			["myPackage/nls/myBundle", "myPackage/nls/fr/myBundle", "myPackage/nls/fr-ca/myBundle"]
			//
			//		Notice that bundles are returned least-specific to most-specific, starting with the root.
			//
			//		If root===false indicates we're working with a pre-AMD i18n bundle that doesn't tell about the available locales;
			//		therefore, assume everything is available and get 404 errors that indicate a particular localization is not available

			for(var result = [bundlePath + bundleName], localeParts = locale.split("-"), current = "", i = 0; i<localeParts.length; i++){
				current += (current ? "-" : "") + localeParts[i];
				if(!root || root[current]){
					result.push(bundlePath + current + "/" + bundleName);
					result.specificity = current;
				}
			}
			return result;
		},

		cache = {},

		getBundleName = function(moduleName, bundleName, locale){
			locale = locale ? locale.toLowerCase() : dojo.locale;
			moduleName = moduleName.replace(/\./g, "/");
			bundleName = bundleName.replace(/\./g, "/");
			return (/root/i.test(locale)) ?
				(moduleName + "/nls/" + bundleName) :
				(moduleName + "/nls/" + locale + "/" + bundleName);
		},

		getL10nName = dojo.getL10nName = function(moduleName, bundleName, locale){
			return moduleName = module.id + "!" + getBundleName(moduleName, bundleName, locale);
		},

		doLoad = function(require, bundlePathAndName, bundlePath, bundleName, locale, load){
			// summary:
			//		get the root bundle which instructs which other bundles are required to construct the localized bundle
			require([bundlePathAndName], function(root){
				var current = lang.clone(root.root || root.ROOT),// 1.6 built bundle defined ROOT
					availableLocales = getAvailableLocales(!root._v1x && root, locale, bundlePath, bundleName);
				require(availableLocales, function(){
					for (var i = 1; i<availableLocales.length; i++){
						current = lang.mixin(lang.clone(current), arguments[i]);
					}
					// target may not have been resolve (e.g., maybe only "fr" exists when "fr-ca" was requested)
					var target = bundlePathAndName + "/" + locale;
					cache[target] = current;
					current.$locale = availableLocales.specificity;
					load();
				});
			});
		},

		normalize = function(id, toAbsMid){
			// summary:
			//		id may be relative.
			//		preload has form `*preload*<path>/nls/<module>*<flattened locales>` and
			//		therefore never looks like a relative
			return /^\./.test(id) ? toAbsMid(id) : id;
		},

		getLocalesToLoad = function(targetLocale){
			var list = config.extraLocale || [];
			list = lang.isArray(list) ? list : [list];
			list.push(targetLocale);
			return list;
		},

		load = function(id, require, load){
			// summary:
			//		id is in one of the following formats
			//
			//		1. <path>/nls/<bundle>
			//			=> load the bundle, localized to config.locale; load all bundles localized to
			//			config.extraLocale (if any); return the loaded bundle localized to config.locale.
			//
			//		2. <path>/nls/<locale>/<bundle>
			//			=> load then return the bundle localized to <locale>
			//
			//		3. *preload*<path>/nls/<module>*<JSON array of available locales>
			//			=> for config.locale and all config.extraLocale, load all bundles found
			//			in the best-matching bundle rollup. A value of 1 is returned, which
			//			is meaningless other than to say the plugin is executing the requested
			//			preloads
			//
			//		In cases 1 and 2, <path> is always normalized to an absolute module id upon entry; see
			//		normalize. In case 3, it <path> is assumed to be absolute; this is arranged by the builder.
			//
			//		To load a bundle means to insert the bundle into the plugin's cache and publish the bundle
			//		value to the loader. Given <path>, <bundle>, and a particular <locale>, the cache key
			//
			//			<path>/nls/<bundle>/<locale>
			//
			//		will hold the value. Similarly, then plugin will publish this value to the loader by
			//
			//			define("<path>/nls/<bundle>/<locale>", <bundle-value>);
			//
			//		Given this algorithm, other machinery can provide fast load paths be preplacing
			//		values in the plugin's cache, which is public. When a load is demanded the
			//		cache is inspected before starting any loading. Explicitly placing values in the plugin
			//		cache is an advanced/experimental feature that should not be needed; use at your own risk.
			//
			//		For the normal AMD algorithm, the root bundle is loaded first, which instructs the
			//		plugin what additional localized bundles are required for a particular locale. These
			//		additional locales are loaded and a mix of the root and each progressively-specific
			//		locale is returned. For example:
			//
			//		1. The client demands "dojo/i18n!some/path/nls/someBundle
			//
			//		2. The loader demands load(some/path/nls/someBundle)
			//
			//		3. This plugin require's "some/path/nls/someBundle", which is the root bundle.
			//
			//		4. Assuming config.locale is "ab-cd-ef" and the root bundle indicates that localizations
			//		are available for "ab" and "ab-cd-ef" (note the missing "ab-cd", then the plugin
			//		requires "some/path/nls/ab/someBundle" and "some/path/nls/ab-cd-ef/someBundle"
			//
			//		5. Upon receiving all required bundles, the plugin constructs the value of the bundle
			//		ab-cd-ef as...
			//
			//				mixin(mixin(mixin({}, require("some/path/nls/someBundle"),
			//		  			require("some/path/nls/ab/someBundle")),
			//					require("some/path/nls/ab-cd-ef/someBundle"));
			//
			//		This value is inserted into the cache and published to the loader at the
			//		key/module-id some/path/nls/someBundle/ab-cd-ef.
			//
			//		The special preload signature (case 3) instructs the plugin to stop servicing all normal requests
			//		(further preload requests will be serviced) until all ongoing preloading has completed.
			//
			//		The preload signature instructs the plugin that a special rollup module is available that contains
			//		one or more flattened, localized bundles. The JSON array of available locales indicates which locales
			//		are available. Here is an example:
			//
			//			*preload*some/path/nls/someModule*["root", "ab", "ab-cd-ef"]
			//
			//		This indicates the following rollup modules are available:
			//
			//			some/path/nls/someModule_ROOT
			//			some/path/nls/someModule_ab
			//			some/path/nls/someModule_ab-cd-ef
			//
			//		Each of these modules is a normal AMD module that contains one or more flattened bundles in a hash.
			//		For example, assume someModule contained the bundles some/bundle/path/someBundle and
			//		some/bundle/path/someOtherBundle, then some/path/nls/someModule_ab would be expressed as follows:
			//
			//			define({
			//				some/bundle/path/someBundle:<value of someBundle, flattened with respect to locale ab>,
			//				some/bundle/path/someOtherBundle:<value of someOtherBundle, flattened with respect to locale ab>,
			//			});
			//
			//		E.g., given this design, preloading for locale=="ab" can execute the following algorithm:
			//
			//			require(["some/path/nls/someModule_ab"], function(rollup){
			//				for(var p in rollup){
			//					var id = p + "/ab",
			//					cache[id] = rollup[p];
			//					define(id, rollup[p]);
			//				}
			//			});
			//
			//		Similarly, if "ab-cd" is requested, the algorithm can determine that "ab" is the best available and
			//		load accordingly.
			//
			//		The builder will write such rollups for every layer if a non-empty localeList  profile property is
			//		provided. Further, the builder will include the following cache entry in the cache associated with
			//		any layer.
			//
			//			"*now":function(r){r(['dojo/i18n!*preload*<path>/nls/<module>*<JSON array of available locales>']);}
			//
			//		The *now special cache module instructs the loader to apply the provided function to context-require
			//		with respect to the particular layer being defined. This causes the plugin to hold all normal service
			//		requests until all preloading is complete.
			//
			//		Notice that this algorithm is rarely better than the standard AMD load algorithm. Consider the normal case
			//		where the target locale has a single segment and a layer depends on a single bundle:
			//
			//		Without Preloads:
			//
			//		1. Layer loads root bundle.
			//		2. bundle is demanded; plugin loads single localized bundle.
			//
			//		With Preloads:
			//
			//		1. Layer causes preloading of target bundle.
			//		2. bundle is demanded; service is delayed until preloading complete; bundle is returned.
			//
			//		In each case a single transaction is required to load the target bundle. In cases where multiple bundles
			//		are required and/or the locale has multiple segments, preloads still requires a single transaction whereas
			//		the normal path requires an additional transaction for each additional bundle/locale-segment. However all
			//		of these additional transactions can be done concurrently. Owing to this analysis, the entire preloading
			//		algorithm can be discard during a build by setting the has feature dojo-preload-i18n-Api to false.

			var match = nlsRe.exec(id),
				bundlePath = match[1] + "/",
				bundleName = match[5] || match[4],
				bundlePathAndName = bundlePath + bundleName,
				localeSpecified = (match[5] && match[4]),
				targetLocale =	localeSpecified || dojo.locale || "",
				loadTarget = bundlePathAndName + "/" + targetLocale,
				loadList = localeSpecified ? [targetLocale] : getLocalesToLoad(targetLocale),
				remaining = loadList.length,
				finish = function(){
					if(!--remaining){
						load(lang.delegate(cache[loadTarget]));
					}
				},
				split = id.split("*"),
				preloadDemand = split[1] == "preload";

			if(has("dojo-preload-i18n-Api")){
				if(preloadDemand){
					if(!cache[id]){
						// use cache[id] to prevent multiple preloads of the same preload; this shouldn't happen, but
						// who knows what over-aggressive human optimizers may attempt
						cache[id] = 1;
						preloadL10n(split[2], json.parse(split[3]), 1, require);
					}
					// don't stall the loader!
					load(1);
				}
				if(preloadDemand || (waitForPreloads(id, require, load) && !cache[loadTarget])){
					return;
				}
			}
			else if (preloadDemand) {
				// If a build is created with nls resources and 'dojo-preload-i18n-Api' has not been set to false,
				// the built file will include a preload in the cache (which looks about like so:)
				// '*now':function(r){r(['dojo/i18n!*preload*dojo/nls/dojo*["ar","ca","cs","da","de","el","en-gb","en-us","es-es","fi-fi","fr-fr","he-il","hu","it-it","ja-jp","ko-kr","nl-nl","nb","pl","pt-br","pt-pt","ru","sk","sl","sv","th","tr","zh-tw","zh-cn","ROOT"]']);}
				// If the consumer of the build sets 'dojo-preload-i18n-Api' to false in the Dojo config, the cached
				// preload will not be parsed and will result in an attempt to call 'require' passing it the unparsed
				// preload, which is not a valid module id.
				// In this case we should skip this request.
				load(1);

				return;
			}

			array.forEach(loadList, function(locale){
				var target = bundlePathAndName + "/" + locale;
				if(has("dojo-preload-i18n-Api")){
					checkForLegacyModules(target);
				}
				if(!cache[target]){
					doLoad(require, bundlePathAndName, bundlePath, bundleName, locale, finish);
				}else{
					finish();
				}
			});
		};

	if(has("dojo-preload-i18n-Api") ||  1 ){
		var normalizeLocale = thisModule.normalizeLocale = function(locale){
				var result = locale ? locale.toLowerCase() : dojo.locale;
				return result == "root" ? "ROOT" : result;
			},

			isXd = function(mid, contextRequire){
				return ( 1  &&  1 ) ?
					contextRequire.isXdUrl(require.toUrl(mid + ".js")) :
					true;
			},

			preloading = 0,

			preloadWaitQueue = [],

			preloadL10n = thisModule._preloadLocalizations = function(/*String*/bundlePrefix, /*Array*/localesGenerated, /*boolean?*/ guaranteedAmdFormat, /*function?*/ contextRequire){
				// summary:
				//		Load available flattened resource bundles associated with a particular module for dojo/locale and all dojo/config.extraLocale (if any)
				// description:
				//		Only called by built layer files. The entire locale hierarchy is loaded. For example,
				//		if locale=="ab-cd", then ROOT, "ab", and "ab-cd" are loaded. This is different than v1.6-
				//		in that the v1.6- would only load ab-cd...which was *always* flattened.
				//
				//		If guaranteedAmdFormat is true, then the module can be loaded with require thereby circumventing the detection algorithm
				//		and the extra possible extra transaction.

				// If this function is called from legacy code, then guaranteedAmdFormat and contextRequire will be undefined. Since the function
				// needs a require in order to resolve module ids, fall back to the context-require associated with this dojo/i18n module, which
				// itself may have been mapped.
				contextRequire = contextRequire || require;

				function doRequire(mid, callback){
					if(isXd(mid, contextRequire) || guaranteedAmdFormat){
						contextRequire([mid], callback);
					}else{
						syncRequire([mid], callback, contextRequire);
					}
				}

				function forEachLocale(locale, func){
					// given locale= "ab-cd-ef", calls func on "ab-cd-ef", "ab-cd", "ab", "ROOT"; stops calling the first time func returns truthy
					var parts = locale.split("-");
					while(parts.length){
						if(func(parts.join("-"))){
							return;
						}
						parts.pop();
					}
					func("ROOT");
				}

					function preloadingAddLock(){
						preloading++;
					}

					function preloadingRelLock(){
						--preloading;
						while(!preloading && preloadWaitQueue.length){
							load.apply(null, preloadWaitQueue.shift());
						}
					}

					function cacheId(path, name, loc, require){
						// path is assumed to have a trailing "/"
						return require.toAbsMid(path + name + "/" + loc)
					}

					function preload(locale){
						locale = normalizeLocale(locale);
						forEachLocale(locale, function(loc){
							if(array.indexOf(localesGenerated, loc) >= 0){
								var mid = bundlePrefix.replace(/\./g, "/") + "_" + loc;
								preloadingAddLock();
								doRequire(mid, function(rollup){
									for(var p in rollup){
										var bundle = rollup[p],
											match = p.match(/(.+)\/([^\/]+)$/),
											bundleName, bundlePath;

											// If there is no match, the bundle is not a regular bundle from an AMD layer.
											if (!match){continue;}

											bundleName = match[2];
											bundlePath = match[1] + "/";

										// backcompat
										if(!bundle._localized){continue;}

										var localized;
										if(loc === "ROOT"){
											var root = localized = bundle._localized;
											delete bundle._localized;
											root.root = bundle;
											cache[require.toAbsMid(p)] = root;
										}else{
											localized = bundle._localized;
											cache[cacheId(bundlePath, bundleName, loc, require)] = bundle;
										}

										if(loc !== locale){
											// capture some locale variables
											var improveBundle = function improveBundle(bundlePath, bundleName, bundle, localized){
												// locale was not flattened and we've fallen back to a less-specific locale that was flattened
												// for example, we had a flattened 'fr', a 'fr-ca' is available for at least this bundle, and
												// locale==='fr-ca'; therefore, we must improve the bundle as retrieved from the rollup by
												// manually loading the fr-ca version of the bundle and mixing this into the already-retrieved 'fr'
												// version of the bundle.
												//
												// Remember, different bundles may have different sets of locales available.
												//
												// we are really falling back on the regular algorithm here, but--hopefully--starting with most
												// of the required bundles already on board as given by the rollup and we need to "manually" load
												// only one locale from a few bundles...or even better...we won't find anything better to load.
												// This algorithm ensures there is nothing better to load even when we can only load a less-specific rollup.
												//
												// note: this feature is only available in async mode

												// inspect the loaded bundle that came from the rollup to see if something better is available
												// for any bundle in a rollup, more-specific available locales are given at localized.
												var requiredBundles = [],
													cacheIds = [];
												forEachLocale(locale, function(loc){
													if(localized[loc]){
														requiredBundles.push(require.toAbsMid(bundlePath + loc + "/" + bundleName));
														cacheIds.push(cacheId(bundlePath, bundleName, loc, require));
													}
												});

												if(requiredBundles.length){
													preloadingAddLock();
													contextRequire(requiredBundles, function(){
														// requiredBundles was constructed by forEachLocale so it contains locales from
														// less specific to most specific.
														// the loop starts with the most specific locale, the last one.
														for(var i = requiredBundles.length - 1; i >= 0 ; i--){
															bundle = lang.mixin(lang.clone(bundle), arguments[i]);
															cache[cacheIds[i]] = bundle;
														}
														// this is the best possible (maybe a perfect match, maybe not), accept it
														cache[cacheId(bundlePath, bundleName, locale, require)] = lang.clone(bundle);
														preloadingRelLock();
													});
												}else{
													// this is the best possible (definitely not a perfect match), accept it
													cache[cacheId(bundlePath, bundleName, locale, require)] = bundle;
												}
											};
											improveBundle(bundlePath, bundleName, bundle, localized);
										}
									}
									preloadingRelLock();
								});
								return true;
							}
							return false;
						});
					}

				preload();
				array.forEach(dojo.config.extraLocale, preload);
			},

			waitForPreloads = function(id, require, load){
				if(preloading){
					preloadWaitQueue.push([id, require, load]);
				}
				return preloading;
			},

			checkForLegacyModules = function()
				{};
	}

	if( 1 ){
		// this code path assumes the dojo loader and won't work with a standard AMD loader
		var amdValue = {},
			l10nCache = {},
			evalBundle,

			syncRequire = function(deps, callback, require){
				var results = [];
				array.forEach(deps, function(mid){
					var url = require.toUrl(mid + ".js");

					function load(text){
						if (!evalBundle) {
							// use the function ctor to keep the minifiers away (also come close to global scope, but this is secondary)
							evalBundle = new Function(
								"__bundle",				   // the bundle to evalutate
								"__checkForLegacyModules", // a function that checks if __bundle defined __mid in the global space
								"__mid",				   // the mid that __bundle is intended to define
								"__amdValue",

								// returns one of:
								//		1 => the bundle was an AMD bundle
								//		a legacy bundle object that is the value of __mid
								//		instance of Error => could not figure out how to evaluate bundle

								// used to detect when __bundle calls define
								"var define = function(mid, factory){define.called = 1; __amdValue.result = factory || mid;},"
								+ "	   require = function(){define.called = 1;};"

								+ "try{"
								+		"define.called = 0;"
								+		"eval(__bundle);"
								+		"if(define.called==1)"
											// bundle called define; therefore signal it's an AMD bundle
								+			"return __amdValue;"

								+		"if((__checkForLegacyModules = __checkForLegacyModules(__mid)))"
											// bundle was probably a v1.6- built NLS flattened NLS bundle that defined __mid in the global space
								+			"return __checkForLegacyModules;"

								+ "}catch(e){}"
								// evaulating the bundle was *neither* an AMD *nor* a legacy flattened bundle
								// either way, re-eval *after* surrounding with parentheses

								+ "try{"
								+		"return eval('('+__bundle+')');"
								+ "}catch(e){"
								+		"return e;"
								+ "}"
							);
						}
						var result = evalBundle(text, checkForLegacyModules, mid, amdValue);
						if(result===amdValue){
							// the bundle was an AMD module; re-inject it through the normal AMD path
							// we gotta do this since it could be an anonymous module and simply evaluating
							// the text here won't provide the loader with the context to know what
							// module is being defined()'d. With browser caching, this should be free; further
							// this entire code path can be circumvented by using the AMD format to begin with
							results.push(cache[url] = amdValue.result);
						}else{
							if(result instanceof Error){
								console.error("failed to evaluate i18n bundle; url=" + url, result);
								result = {};
							}
							// nls/<locale>/<bundle-name> indicates not the root.
							results.push(cache[url] = (/nls\/[^\/]+\/[^\/]+$/.test(url) ? result : {root:result, _v1x:1}));
						}
					}

					if(cache[url]){
						results.push(cache[url]);
					}else{
						var bundle = require.syncLoadNls(mid);
						// need to check for legacy module here because there might be a legacy module for a
						// less specific locale (which was not looked up during the first checkForLegacyModules
						// call in load()).
						// Also need to reverse the locale and the module name in the mid because syncRequire
						// deps parameters uses the AMD style package/nls/locale/module while legacy code uses
						// package/nls/module/locale.
						if(!bundle){
							bundle = checkForLegacyModules(mid.replace(/nls\/([^\/]*)\/([^\/]*)$/, "nls/$2/$1"));
						}
						if(bundle){
							results.push(bundle);
						}else{
							if(!xhr){
								try{
									require.getText(url, true, load);
								}catch(e){
									results.push(cache[url] = {});
								}
							}else{
								xhr.get({
									url:url,
									sync:true,
									load:load,
									error:function(){
										results.push(cache[url] = {});
									}
								});
							}
						}
					}
				});
				callback && callback.apply(null, results);
			};

		checkForLegacyModules = function(target){
			// legacy code may have already loaded [e.g] the raw bundle x/y/z at x.y.z; when true, push into the cache
			for(var result, names = target.split("/"), object = dojo.global[names[0]], i = 1; object && i<names.length-1; object = object[names[i++]]){}
			if(object){
				result = object[names[i]];
				if(!result){
					// fallback for incorrect bundle build of 1.6
					result = object[names[i].replace(/-/g,"_")];
				}
				if(result){
					cache[target] = result;
				}
			}
			return result;
		};

		thisModule.getLocalization = function(moduleName, bundleName, locale){
			var result,
				l10nName = getBundleName(moduleName, bundleName, locale);

			if (l10nCache[l10nName]) {
				return l10nCache[l10nName];
			}

			load(
				l10nName,

				// isXd() and syncRequire() need a context-require in order to resolve the mid with respect to a reference module.
				// Since this legacy function does not have the concept of a reference module, resolve with respect to this
				// dojo/i18n module, which, itself may have been mapped.
				(!isXd(l10nName, require) ? function(deps, callback){ syncRequire(deps, callback, require); } : require),

				function(result_){
					l10nCache[l10nName] = result_;
					result = result_;
				}
			);
			return result;
		};
	}
	else {
		thisModule.getLocalization = function(moduleName, bundleName, locale){
			var key = moduleName.replace(/\./g, '/') + '/nls/' + bundleName + '/' + (locale || config.locale);
			return this.cache[key];
		};
	}

	return lang.mixin(thisModule, {
		dynamic:true,
		normalize:normalize,
		load:load,
		cache:cache,
		getL10nName: getL10nName
	});
});

},
'dojo/regexp':function(){
define(["./_base/kernel", "./_base/lang"], function(dojo, lang){

// module:
//		dojo/regexp

var regexp = {
	// summary:
	//		Regular expressions and Builder resources
};
lang.setObject("dojo.regexp", regexp);

regexp.escapeString = function(/*String*/str, /*String?*/except){
	// summary:
	//		Adds escape sequences for special characters in regular expressions
	// except:
	//		a String with special characters to be left unescaped

	return str.replace(/([\.$?*|{}\(\)\[\]\\\/\+\-^])/g, function(ch){
		if(except && except.indexOf(ch) != -1){
			return ch;
		}
		return "\\" + ch;
	}); // String
};

regexp.buildGroupRE = function(/*Object|Array*/arr, /*Function*/re, /*Boolean?*/nonCapture){
	// summary:
	//		Builds a regular expression that groups subexpressions
	// description:
	//		A utility function used by some of the RE generators. The
	//		subexpressions are constructed by the function, re, in the second
	//		parameter.  re builds one subexpression for each elem in the array
	//		a, in the first parameter. Returns a string for a regular
	//		expression that groups all the subexpressions.
	// arr:
	//		A single value or an array of values.
	// re:
	//		A function. Takes one parameter and converts it to a regular
	//		expression.
	// nonCapture:
	//		If true, uses non-capturing match, otherwise matches are retained
	//		by regular expression. Defaults to false

	// case 1: a is a single value.
	if(!(arr instanceof Array)){
		return re(arr); // String
	}

	// case 2: a is an array
	var b = [];
	for(var i = 0; i < arr.length; i++){
		// convert each elem to a RE
		b.push(re(arr[i]));
	}

	 // join the REs as alternatives in a RE group.
	return regexp.group(b.join("|"), nonCapture); // String
};

regexp.group = function(/*String*/expression, /*Boolean?*/nonCapture){
	// summary:
	//		adds group match to expression
	// nonCapture:
	//		If true, uses non-capturing match, otherwise matches are retained
	//		by regular expression.
	return "(" + (nonCapture ? "?:":"") + expression + ")"; // String
};

return regexp;
});

},
'dojo/cldr/monetary':function(){
define(["../_base/kernel", "../_base/lang"], function(dojo, lang){

// module:
//		dojo/cldr/monetary

var monetary = {
	// summary:
	//		TODOC
};
lang.setObject("dojo.cldr.monetary", monetary);

monetary.getData = function(/*String*/ code){
	// summary:
	//		A mapping of currency code to currency-specific formatting information. Returns a unique object with properties: places, round.
	// code:
	//		an [ISO 4217](http://en.wikipedia.org/wiki/ISO_4217) currency code

	// from http://www.unicode.org/cldr/data/common/supplemental/supplementalData.xml:supplementalData/currencyData/fractions

	var placesData = {
		ADP:0,AFN:0,ALL:0,AMD:0,BHD:3,BIF:0,BYR:0,CLF:0,CLP:0,
		COP:2,CRC:0,DJF:0,ESP:0,GNF:0,GYD:0,HUF:0,IDR:0,IQD:0,
		IRR:3,ISK:0,ITL:0,JOD:3,JPY:0,KMF:0,KPW:0,KRW:0,KWD:3,
		LAK:0,LBP:0,LUF:0,LYD:3,MGA:0,MGF:0,MMK:0,MNT:0,MRO:0,
		MUR:0,OMR:3,PKR:2,PYG:0,RSD:0,RWF:0,SLL:0,SOS:0,STD:0,
		SYP:0,TMM:0,TND:3,TRL:0,TZS:0,UGX:0,UZS:0,VND:0,VUV:0,
		XAF:0,XOF:0,XPF:0,YER:0,ZMK:0,ZWD:0
	};

	var roundingData = {};

	var places = placesData[code], round = roundingData[code];
	if(typeof places == "undefined"){ places = 2; }
	if(typeof round == "undefined"){ round = 0; }

	return {places: places, round: round}; // Object
};

return monetary;
});

},
'dojo/date':function(){
define(["./has", "./_base/lang"], function(has, lang){
// module:
//		dojo/date

var date = {
	// summary:
	//		Date manipulation utilities
};

date.getDaysInMonth = function(/*Date*/dateObject){
	// summary:
	//		Returns the number of days in the month used by dateObject
	var month = dateObject.getMonth();
	var days = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	if(month == 1 && date.isLeapYear(dateObject)){ return 29; } // Number
	return days[month]; // Number
};

date.isLeapYear = function(/*Date*/dateObject){
	// summary:
	//		Determines if the year of the dateObject is a leap year
	// description:
	//		Leap years are years with an additional day YYYY-02-29, where the
	//		year number is a multiple of four with the following exception: If
	//		a year is a multiple of 100, then it is only a leap year if it is
	//		also a multiple of 400. For example, 1900 was not a leap year, but
	//		2000 is one.

	var year = dateObject.getFullYear();
	return !(year%400) || (!(year%4) && !!(year%100)); // Boolean
};

// FIXME: This is not localized
date.getTimezoneName = function(/*Date*/dateObject){
	// summary:
	//		Get the user's time zone as provided by the browser
	// dateObject:
	//		Needed because the timezone may vary with time (daylight savings)
	// description:
	//		Try to get time zone info from toString or toLocaleString method of
	//		the Date object -- UTC offset is not a time zone.  See
	//		http://www.twinsun.com/tz/tz-link.htm Note: results may be
	//		inconsistent across browsers.

	var str = dateObject.toString(); // Start looking in toString
	var tz = ''; // The result -- return empty string if nothing found
	var match;

	// First look for something in parentheses -- fast lookup, no regex
	var pos = str.indexOf('(');
	if(pos > -1){
		tz = str.substring(++pos, str.indexOf(')'));
	}else{
		// If at first you don't succeed ...
		// If IE knows about the TZ, it appears before the year
		// Capital letters or slash before a 4-digit year
		// at the end of string
		var pat = /([A-Z\/]+) \d{4}$/;
		if((match = str.match(pat))){
			tz = match[1];
		}else{
		// Some browsers (e.g. Safari) glue the TZ on the end
		// of toLocaleString instead of putting it in toString
			str = dateObject.toLocaleString();
			// Capital letters or slash -- end of string,
			// after space
			pat = / ([A-Z\/]+)$/;
			if((match = str.match(pat))){
				tz = match[1];
			}
		}
	}

	// Make sure it doesn't somehow end up return AM or PM
	return (tz == 'AM' || tz == 'PM') ? '' : tz; // String
};

// Utility methods to do arithmetic calculations with Dates

date.compare = function(/*Date*/date1, /*Date?*/date2, /*String?*/portion){
	// summary:
	//		Compare two date objects by date, time, or both.
	// description:
	//		Returns 0 if equal, positive if a > b, else negative.
	// date1:
	//		Date object
	// date2:
	//		Date object.  If not specified, the current Date is used.
	// portion:
	//		A string indicating the "date" or "time" portion of a Date object.
	//		Compares both "date" and "time" by default.  One of the following:
	//		"date", "time", "datetime"

	// Extra step required in copy for IE - see #3112
	date1 = new Date(+date1);
	date2 = new Date(+(date2 || new Date()));

	if(portion == "date"){
		// Ignore times and compare dates.
		date1.setHours(0, 0, 0, 0);
		date2.setHours(0, 0, 0, 0);
	}else if(portion == "time"){
		// Ignore dates and compare times.
		date1.setFullYear(0, 0, 0);
		date2.setFullYear(0, 0, 0);
	}

	if(date1 > date2){ return 1; } // int
	if(date1 < date2){ return -1; } // int
	return 0; // int
};

date.add = function(/*Date*/date, /*String*/interval, /*int*/amount){
	// summary:
	//		Add to a Date in intervals of different size, from milliseconds to years
	// date: Date
	//		Date object to start with
	// interval:
	//		A string representing the interval.  One of the following:
	//		"year", "month", "day", "hour", "minute", "second",
	//		"millisecond", "quarter", "week", "weekday"
	// amount:
	//		How much to add to the date.

	var sum = new Date(+date); // convert to Number before copying to accommodate IE (#3112)
	var fixOvershoot = false;
	var property = "Date";

	switch(interval){
		case "day":
			break;
		case "weekday":
			//i18n FIXME: assumes Saturday/Sunday weekend, but this is not always true.  see dojo/cldr/supplemental

			// Divide the increment time span into weekspans plus leftover days
			// e.g., 8 days is one 5-day weekspan / and two leftover days
			// Can't have zero leftover days, so numbers divisible by 5 get
			// a days value of 5, and the remaining days make up the number of weeks
			var days, weeks;
			var mod = amount % 5;
			if(!mod){
				days = (amount > 0) ? 5 : -5;
				weeks = (amount > 0) ? ((amount-5)/5) : ((amount+5)/5);
			}else{
				days = mod;
				weeks = parseInt(amount/5);
			}
			// Get weekday value for orig date param
			var strt = date.getDay();
			// Orig date is Sat / positive incrementer
			// Jump over Sun
			var adj = 0;
			if(strt == 6 && amount > 0){
				adj = 1;
			}else if(strt == 0 && amount < 0){
			// Orig date is Sun / negative incrementer
			// Jump back over Sat
				adj = -1;
			}
			// Get weekday val for the new date
			var trgt = strt + days;
			// New date is on Sat or Sun
			if(trgt == 0 || trgt == 6){
				adj = (amount > 0) ? 2 : -2;
			}
			// Increment by number of weeks plus leftover days plus
			// weekend adjustments
			amount = (7 * weeks) + days + adj;
			break;
		case "year":
			property = "FullYear";
			// Keep increment/decrement from 2/29 out of March
			fixOvershoot = true;
			break;
		case "week":
			amount *= 7;
			break;
		case "quarter":
			// Naive quarter is just three months
			amount *= 3;
			// fallthrough...
		case "month":
			// Reset to last day of month if you overshoot
			fixOvershoot = true;
			property = "Month";
			break;
//		case "hour":
//		case "minute":
//		case "second":
//		case "millisecond":
		default:
			property = "UTC"+interval.charAt(0).toUpperCase() + interval.substring(1) + "s";
	}

	if(property){
		sum["set"+property](sum["get"+property]()+amount);
	}

	if(fixOvershoot && (sum.getDate() < date.getDate())){
		sum.setDate(0);
	}

	return sum; // Date
};

date.difference = function(/*Date*/date1, /*Date?*/date2, /*String?*/interval){
	// summary:
	//		Get the difference in a specific unit of time (e.g., number of
	//		months, weeks, days, etc.) between two dates, rounded to the
	//		nearest integer.
	// date1:
	//		Date object
	// date2:
	//		Date object.  If not specified, the current Date is used.
	// interval:
	//		A string representing the interval.  One of the following:
	//		"year", "month", "day", "hour", "minute", "second",
	//		"millisecond", "quarter", "week", "weekday"
	//
	//		Defaults to "day".

	date2 = date2 || new Date();
	interval = interval || "day";
	var yearDiff = date2.getFullYear() - date1.getFullYear();
	var delta = 1; // Integer return value

	switch(interval){
		case "quarter":
			var m1 = date1.getMonth();
			var m2 = date2.getMonth();
			// Figure out which quarter the months are in
			var q1 = Math.floor(m1/3) + 1;
			var q2 = Math.floor(m2/3) + 1;
			// Add quarters for any year difference between the dates
			q2 += (yearDiff * 4);
			delta = q2 - q1;
			break;
		case "weekday":
			var days = Math.round(date.difference(date1, date2, "day"));
			var weeks = parseInt(date.difference(date1, date2, "week"));
			var mod = days % 7;

			// Even number of weeks
			if(mod == 0){
				days = weeks*5;
			}else{
				// Weeks plus spare change (< 7 days)
				var adj = 0;
				var aDay = date1.getDay();
				var bDay = date2.getDay();

				weeks = parseInt(days/7);
				mod = days % 7;
				// Mark the date advanced by the number of
				// round weeks (may be zero)
				var dtMark = new Date(date1);
				dtMark.setDate(dtMark.getDate()+(weeks*7));
				var dayMark = dtMark.getDay();

				// Spare change days -- 6 or less
				if(days > 0){
					switch(true){
						// Range starts on Sat
						case aDay == 6:
							adj = -1;
							break;
						// Range starts on Sun
						case aDay == 0:
							adj = 0;
							break;
						// Range ends on Sat
						case bDay == 6:
							adj = -1;
							break;
						// Range ends on Sun
						case bDay == 0:
							adj = -2;
							break;
						// Range contains weekend
						case (dayMark + mod) > 5:
							adj = -2;
					}
				}else if(days < 0){
					switch(true){
						// Range starts on Sat
						case aDay == 6:
							adj = 0;
							break;
						// Range starts on Sun
						case aDay == 0:
							adj = 1;
							break;
						// Range ends on Sat
						case bDay == 6:
							adj = 2;
							break;
						// Range ends on Sun
						case bDay == 0:
							adj = 1;
							break;
						// Range contains weekend
						case (dayMark + mod) < 0:
							adj = 2;
					}
				}
				days += adj;
				days -= (weeks*2);
			}
			delta = days;
			break;
		case "year":
			delta = yearDiff;
			break;
		case "month":
			delta = (date2.getMonth() - date1.getMonth()) + (yearDiff * 12);
			break;
		case "week":
			// Truncate instead of rounding
			// Don't use Math.floor -- value may be negative
			delta = parseInt(date.difference(date1, date2, "day")/7);
			break;
		case "day":
			delta /= 24;
			// fallthrough
		case "hour":
			delta /= 60;
			// fallthrough
		case "minute":
			delta /= 60;
			// fallthrough
		case "second":
			delta /= 1000;
			// fallthrough
		case "millisecond":
			delta *= date2.getTime() - date1.getTime();
	}

	// Round for fractional values and DST leaps
	return Math.round(delta); // Number (integer)
};

// Don't use setObject() because it may overwrite dojo/date/stamp (if that has already been loaded)
 1  && lang.mixin(lang.getObject("dojo.date", true), date);

return date;
});

},
'dojo/date/locale':function(){
define([
	"../_base/lang",
	"../_base/array",
	"../date",
	/*===== "../_base/declare", =====*/
	"../cldr/supplemental",
	"../i18n",
	"../regexp",
	"../string",
	"../i18n!../cldr/nls/gregorian",
	"module"
], function(lang, array, date, /*===== declare, =====*/ supplemental, i18n, regexp, string, gregorian, module){

// module:
//		dojo/date/locale

var exports = {
	// summary:
	//		This modules defines dojo/date/locale, localization methods for Date.
};
lang.setObject(module.id.replace(/\//g, "."), exports);

// Localization methods for Date.   Honor local customs using locale-dependent dojo.cldr data.

// Load the bundles containing localization information for
// names and formats

//NOTE: Everything in this module assumes Gregorian calendars.
// Other calendars will be implemented in separate modules.

	// Format a pattern without literals
	function formatPattern(dateObject, bundle, options, pattern){
		return pattern.replace(/([a-z])\1*/ig, function(match){
			var s, pad,
				c = match.charAt(0),
				l = match.length,
				widthList = ["abbr", "wide", "narrow"];
			switch(c){
				case 'G':
					s = bundle[(l < 4) ? "eraAbbr" : "eraNames"][dateObject.getFullYear() < 0 ? 0 : 1];
					break;
				case 'y':
					s = dateObject.getFullYear();
					switch(l){
						case 1:
							break;
						case 2:
							if(!options.fullYear){
								s = String(s); s = s.substr(s.length - 2);
								break;
							}
							// fallthrough
						default:
							pad = true;
					}
					break;
				case 'Q':
				case 'q':
					s = Math.ceil((dateObject.getMonth()+1)/3);
//					switch(l){
//						case 1: case 2:
							pad = true;
//							break;
//						case 3: case 4: // unimplemented
//					}
					break;
				case 'M':
				case 'L':
					var m = dateObject.getMonth();
					if(l<3){
						s = m+1; pad = true;
					}else{
						var propM = [
							"months",
							c == 'L' ? "standAlone" : "format",
							widthList[l-3]
						].join("-");
						s = bundle[propM][m];
					}
					break;
				case 'w':
					var firstDay = 0;
					s = exports._getWeekOfYear(dateObject, firstDay); pad = true;
					break;
				case 'd':
					s = dateObject.getDate(); pad = true;
					break;
				case 'D':
					s = exports._getDayOfYear(dateObject); pad = true;
					break;
				case 'e':
				case 'c':
					var d = dateObject.getDay();
					if(l<2){
						s = (d - supplemental.getFirstDayOfWeek(options.locale) + 8) % 7
						break;
					}
					// fallthrough
				case 'E':
					d = dateObject.getDay();
					if(l<3){
						s = d+1; pad = true;
					}else{
						var propD = [
							"days",
							c == 'c' ? "standAlone" : "format",
							widthList[l-3]
						].join("-");
						s = bundle[propD][d];
					}
					break;
				case 'a':
					var timePeriod = dateObject.getHours() < 12 ? 'am' : 'pm';
					s = options[timePeriod] || bundle['dayPeriods-format-wide-' + timePeriod];
					break;
				case 'h':
				case 'H':
				case 'K':
				case 'k':
					var h = dateObject.getHours();
					// strange choices in the date format make it impossible to write this succinctly
					switch (c){
						case 'h': // 1-12
							s = (h % 12) || 12;
							break;
						case 'H': // 0-23
							s = h;
							break;
						case 'K': // 0-11
							s = (h % 12);
							break;
						case 'k': // 1-24
							s = h || 24;
							break;
					}
					pad = true;
					break;
				case 'm':
					s = dateObject.getMinutes(); pad = true;
					break;
				case 's':
					s = dateObject.getSeconds(); pad = true;
					break;
				case 'S':
					s = Math.round(dateObject.getMilliseconds() * Math.pow(10, l-3)); pad = true;
					break;
				case 'v': // FIXME: don't know what this is. seems to be same as z?
				case 'z':
					// We only have one timezone to offer; the one from the browser
					s = exports._getZone(dateObject, true, options);
					if(s){break;}
					l=4;
					// fallthrough... use GMT if tz not available
				case 'Z':
					var offset = exports._getZone(dateObject, false, options);
					var tz = [
						(offset<=0 ? "+" : "-"),
						string.pad(Math.floor(Math.abs(offset)/60), 2),
						string.pad(Math.abs(offset)% 60, 2)
					];
					if(l==4){
						tz.splice(0, 0, "GMT");
						tz.splice(3, 0, ":");
					}
					s = tz.join("");
					break;
//				case 'Y': case 'u': case 'W': case 'F': case 'g': case 'A':
//					console.log(match+" modifier unimplemented");
				default:
					throw new Error("dojo.date.locale.format: invalid pattern char: "+pattern);
			}
			if(pad){ s = string.pad(s, l); }
			return s;
		});
	}

/*=====
var __FormatOptions = exports.__FormatOptions = declare(null, {
	// selector: String
	//		choice of 'time','date' (default: date and time)
	// formatLength: String
	//		choice of long, short, medium or full (plus any custom additions).  Defaults to 'short'
	// datePattern:String
	//		override pattern with this string
	// timePattern:String
	//		override pattern with this string
	// am: String
	//		override strings for am in times
	// pm: String
	//		override strings for pm in times
	// locale: String
	//		override the locale used to determine formatting rules
	// fullYear: Boolean
	//		(format only) use 4 digit years whenever 2 digit years are called for
	// strict: Boolean
	//		(parse only) strict parsing, off by default
});
=====*/

exports._getZone = function(/*Date*/ dateObject, /*boolean*/ getName, /*__FormatOptions?*/ options){
	// summary:
	//		Returns the zone (or offset) for the given date and options.  This
	//		is broken out into a separate function so that it can be overridden
	//		by timezone-aware code.
	//
	// dateObject:
	//		the date and/or time being formatted.
	//
	// getName:
	//		Whether to return the timezone string (if true), or the offset (if false)
	//
	// options:
	//		The options being used for formatting
	if(getName){
		return date.getTimezoneName(dateObject);
	}else{
		return dateObject.getTimezoneOffset();
	}
};


exports.format = function(/*Date*/ dateObject, /*__FormatOptions?*/ options){
	// summary:
	//		Format a Date object as a String, using locale-specific settings.
	//
	// description:
	//		Create a string from a Date object using a known localized pattern.
	//		By default, this method formats both date and time from dateObject.
	//		Formatting patterns are chosen appropriate to the locale.  Different
	//		formatting lengths may be chosen, with "full" used by default.
	//		Custom patterns may be used or registered with translations using
	//		the dojo/date/locale.addCustomFormats() method.
	//		Formatting patterns are implemented using [the syntax described at
	//		unicode.org](http://www.unicode.org/reports/tr35/tr35-4.html#Date_Format_Patterns)
	//
	// dateObject:
	//		the date and/or time to be formatted.  If a time only is formatted,
	//		the values in the year, month, and day fields are irrelevant.  The
	//		opposite is true when formatting only dates.

	options = options || {};

	var locale = i18n.normalizeLocale(options.locale),
		formatLength = options.formatLength || 'short',
		bundle = exports._getGregorianBundle(locale),
		str = [],
		sauce = lang.hitch(this, formatPattern, dateObject, bundle, options);
	if(options.selector == "year"){
		return _processPattern(bundle["dateFormatItem-yyyy"] || "yyyy", sauce);
	}
	var pattern;
	if(options.selector != "date"){
		pattern = options.timePattern || bundle["timeFormat-"+formatLength];
		if(pattern){str.push(_processPattern(pattern, sauce));}
	}
	if(options.selector != "time"){
		pattern = options.datePattern || bundle["dateFormat-"+formatLength];
		if(pattern){str.push(_processPattern(pattern, sauce));}
	}

	return str.length == 1 ? str[0] : bundle["dateTimeFormat-"+formatLength].replace(/\'/g,'').replace(/\{(\d+)\}/g,
		function(match, key){ return str[key]; }); // String
};

exports.regexp = function(/*__FormatOptions?*/ options){
	// summary:
	//		Builds the regular needed to parse a localized date

	return exports._parseInfo(options).regexp; // String
};

exports._parseInfo = function(/*__FormatOptions?*/ options){
	options = options || {};
	var locale = i18n.normalizeLocale(options.locale),
		bundle = exports._getGregorianBundle(locale),
		formatLength = options.formatLength || 'short',
		datePattern = options.datePattern || bundle["dateFormat-" + formatLength],
		timePattern = options.timePattern || bundle["timeFormat-" + formatLength],
		pattern;
	if(options.selector == 'date'){
		pattern = datePattern;
	}else if(options.selector == 'time'){
		pattern = timePattern;
	}else{
		pattern = bundle["dateTimeFormat-"+formatLength].replace(/\{(\d+)\}/g,
			function(match, key){ return [timePattern, datePattern][key]; });
	}

	var tokens = [],
		re = _processPattern(pattern, lang.hitch(this, _buildDateTimeRE, tokens, bundle, options));
	return {regexp: re, tokens: tokens, bundle: bundle};
};

exports.parse = function(/*String*/ value, /*__FormatOptions?*/ options){
	// summary:
	//		Convert a properly formatted string to a primitive Date object,
	//		using locale-specific settings.
	//
	// description:
	//		Create a Date object from a string using a known localized pattern.
	//		By default, this method parses looking for both date and time in the string.
	//		Formatting patterns are chosen appropriate to the locale.  Different
	//		formatting lengths may be chosen, with "full" used by default.
	//		Custom patterns may be used or registered with translations using
	//		the dojo/date/locale.addCustomFormats() method.
	//
	//		Formatting patterns are implemented using [the syntax described at
	//		unicode.org](http://www.unicode.org/reports/tr35/tr35-4.html#Date_Format_Patterns)
	//		When two digit years are used, a century is chosen according to a sliding
	//		window of 80 years before and 20 years after present year, for both `yy` and `yyyy` patterns.
	//		year < 100CE requires strict mode.
	//
	// value:
	//		A string representation of a date

	// remove non-printing bidi control chars from input and pattern
	var controlChars = /[\u200E\u200F\u202A\u202E]/g,
		info = exports._parseInfo(options),
		tokens = info.tokens, bundle = info.bundle,
		re = new RegExp("^" + info.regexp.replace(controlChars, "") + "$",
			info.strict ? "" : "i"),
		match = re.exec(value && value.replace(controlChars, ""));

	if(!match){ return null; } // null

	var widthList = ['abbr', 'wide', 'narrow'],
		result = [1970,0,2,0,0,0,0], // will get converted to a Date at the end; patched for SOS-12875, based on http://bugs.dojotoolkit.org/ticket/9107
		amPm = "",
		valid = array.every(match, function(v, i){
		if(!i){return true;}
		var token = tokens[i-1],
			l = token.length,
			c = token.charAt(0);
		switch(c){
			case 'y':
				if(l != 2 && options.strict){
					//interpret year literally, so '5' would be 5 A.D.
					result[0] = v;
				}else{
					if(v<100){
						v = Number(v);
						//choose century to apply, according to a sliding window
						//of 80 years before and 20 years after present year
						var year = '' + new Date().getFullYear(),
							century = year.substring(0, 2) * 100,
							cutoff = Math.min(Number(year.substring(2, 4)) + 20, 99);
						result[0] = (v < cutoff) ? century + v : century - 100 + v;
					}else{
						//we expected 2 digits and got more...
						if(options.strict){
							return false;
						}
						//interpret literally, so '150' would be 150 A.D.
						//also tolerate '1950', if 'yyyy' input passed to 'yy' format
						result[0] = v;
					}
				}
				break;
			case 'M':
			case 'L':
				if(l>2){
					var months = bundle['months-' +
							    (c == 'L' ? 'standAlone' : 'format') +
							    '-' + widthList[l-3]].concat();
					if(!options.strict){
						//Tolerate abbreviating period in month part
						//Case-insensitive comparison
						v = v.replace(".","").toLowerCase();
						months = array.map(months, function(s){ return s.replace(".","").toLowerCase(); } );
					}
					v = array.indexOf(months, v);
					if(v == -1){
//						console.log("dojo/date/locale.parse: Could not parse month name: '" + v + "'.");
						return false;
					}
				}else{
					v--;
				}
				result[1] = v;
				break;
			case 'E':
			case 'e':
			case 'c':
				var days = bundle['days-' +
						  (c == 'c' ? 'standAlone' : 'format') +
						  '-' + widthList[l-3]].concat();
				if(!options.strict){
					//Case-insensitive comparison
					v = v.toLowerCase();
					days = array.map(days, function(d){return d.toLowerCase();});
				}
				v = array.indexOf(days, v);
				if(v == -1){
//					console.log("dojo/date/locale.parse: Could not parse weekday name: '" + v + "'.");
					return false;
				}

				//TODO: not sure what to actually do with this input,
				//in terms of setting something on the Date obj...?
				//without more context, can't affect the actual date
				//TODO: just validate?
				break;
			case 'D':
				result[1] = 0;
				// fallthrough...
			case 'd':
				result[2] = v;
				break;
			case 'a': //am/pm
				var am = options.am || bundle['dayPeriods-format-wide-am'],
					pm = options.pm || bundle['dayPeriods-format-wide-pm'];
				if(!options.strict){
					var period = /\./g;
					v = v.replace(period,'').toLowerCase();
					am = am.replace(period,'').toLowerCase();
					pm = pm.replace(period,'').toLowerCase();
				}
				if(options.strict && v != am && v != pm){
//					console.log("dojo/date/locale.parse: Could not parse am/pm part.");
					return false;
				}

				// we might not have seen the hours field yet, so store the state and apply hour change later
				amPm = (v == pm) ? 'p' : (v == am) ? 'a' : '';
				break;
			case 'K': //hour (1-24)
				if(v == 24){ v = 0; }
				// fallthrough...
			case 'h': //hour (1-12)
			case 'H': //hour (0-23)
			case 'k': //hour (0-11)
				//TODO: strict bounds checking, padding
				if(v > 23){
//					console.log("dojo/date/locale.parse: Illegal hours value");
					return false;
				}

				//in the 12-hour case, adjusting for am/pm requires the 'a' part
				//which could come before or after the hour, so we will adjust later
				result[3] = v;
				break;
			case 'm': //minutes
				result[4] = v;
				break;
			case 's': //seconds
				result[5] = v;
				break;
			case 'S': //milliseconds
				result[6] = v;
//				break;
//			case 'w':
//TODO				var firstDay = 0;
//			default:
//TODO: throw?
//				console.log("dojo/date/locale.parse: unsupported pattern char=" + token.charAt(0));
		}
		return true;
	});

	var hours = +result[3];
	if(amPm === 'p' && hours < 12){
		result[3] = hours + 12; //e.g., 3pm -> 15
	}else if(amPm === 'a' && hours == 12){
		result[3] = 0; //12am -> 0
	}

	//TODO: implement a getWeekday() method in order to test
	//validity of input strings containing 'EEE' or 'EEEE'...

	var dateObject = new Date(result[0], result[1], result[2], result[3], result[4], result[5], result[6]); // Date
	if(options.strict){
		dateObject.setFullYear(result[0]);
	}

	// Check for overflow.  The Date() constructor normalizes things like April 32nd...
	//TODO: why isn't this done for times as well?
	var allTokens = tokens.join(""),
		dateToken = allTokens.indexOf('d') != -1,
		monthToken = allTokens.indexOf('M') != -1;

	if(!valid ||
		(monthToken && dateObject.getMonth() > result[1]) ||
		(dateToken && dateObject.getDate() > result[2])){
		return null;
	}

	// Check for underflow, due to DST shifts.  See #9366
	// This assumes a 1 hour dst shift correction at midnight
	// We could compare the timezone offset after the shift and add the difference instead.
	if((monthToken && dateObject.getMonth() < result[1]) ||
		(dateToken && dateObject.getDate() < result[2])){
		dateObject = date.add(dateObject, "hour", 1);
	}

	return dateObject; // Date
};

function _processPattern(pattern, applyPattern, applyLiteral, applyAll){
	//summary: Process a pattern with literals in it

	// Break up on single quotes, treat every other one as a literal, except '' which becomes '
	var identity = function(x){return x;};
	applyPattern = applyPattern || identity;
	applyLiteral = applyLiteral || identity;
	applyAll = applyAll || identity;

	//split on single quotes (which escape literals in date format strings)
	//but preserve escaped single quotes (e.g., o''clock)
	var chunks = pattern.match(/(''|[^'])+/g),
		literal = pattern.charAt(0) == "'";

	array.forEach(chunks, function(chunk, i){
		if(!chunk){
			chunks[i]='';
		}else{
			chunks[i]=(literal ? applyLiteral : applyPattern)(chunk.replace(/''/g, "'"));
			literal = !literal;
		}
	});
	return applyAll(chunks.join(''));
}

var widthList = ['abbr', 'wide', 'narrow'];
function _buildDateTimeRE(tokens, bundle, options, pattern){
	pattern = regexp.escapeString(pattern);
	if(!options.strict){ pattern = pattern.replace(" a", " ?a"); } // kludge to tolerate no space before am/pm
	return pattern.replace(/([a-z])\1*/ig, function(match){
		// Build a simple regexp.  Avoid captures, which would ruin the tokens list
		var s,
			c = match.charAt(0),
			l = match.length,
			p2 = '', p3 = '';
		if(options.strict){
			if(l > 1){ p2 = '0' + '{'+(l-1)+'}'; }
			if(l > 2){ p3 = '0' + '{'+(l-2)+'}'; }
		}else{
			p2 = '0?'; p3 = '0{0,2}';
		}
		switch(c){
			case 'y':
				s = '\\d{2,4}';
				break;
			case 'M':
			case 'L':
				if(l>2){
					var months = bundle[
						'months-' +
						(c == 'L' ? 'standAlone' : 'format') +
						'-' + widthList[l-3]
					].slice(0);
					s = months.join('|');
					if(!options.strict){
						s = s.replace(/\./g, '');
						//Tolerate abbreviating period in month part
						s = '(?:' + s + ')\\.?';
					}
				}else{
					s = '1[0-2]|'+p2+'[1-9]';
				}
				break;
			case 'D':
				s = '[12][0-9][0-9]|3[0-5][0-9]|36[0-6]|'+p2+'[1-9][0-9]|'+p3+'[1-9]';
				break;
			case 'd':
				s = '3[01]|[12]\\d|'+p2+'[1-9]';
				break;
			case 'w':
				s = '[1-4][0-9]|5[0-3]|'+p2+'[1-9]';
				break;
			case 'E':
			case 'e':
			case 'c':
				s = '.+?'; // match anything including spaces until the first pattern delimiter is found such as a comma or space
				break;
			case 'h': //hour (1-12)
				s = '1[0-2]|'+p2+'[1-9]';
				break;
			case 'k': //hour (0-11)
				s = '1[01]|'+p2+'\\d';
				break;
			case 'H': //hour (0-23)
				s = '1\\d|2[0-3]|'+p2+'\\d';
				break;
			case 'K': //hour (1-24)
				s = '1\\d|2[0-4]|'+p2+'[1-9]';
				break;
			case 'm':
			case 's':
				s = '[0-5]\\d';
				break;
			case 'S':
				s = '\\d{'+l+'}';
				break;
			case 'a':
				var am = options.am || bundle['dayPeriods-format-wide-am'],
					pm = options.pm || bundle['dayPeriods-format-wide-pm'];
					s = am + '|' + pm;
				if(!options.strict){
					if(am != am.toLowerCase()){ s += '|' + am.toLowerCase(); }
					if(pm != pm.toLowerCase()){ s += '|' + pm.toLowerCase(); }
					if(s.indexOf('.') != -1){ s += '|' + s.replace(/\./g, ""); }
				}
				s = s.replace(/\./g, "\\.");
				break;
			default:
			// case 'v':
			// case 'z':
			// case 'Z':
				s = ".*";
//				console.log("parse of date format, pattern=" + pattern);
		}

		if(tokens){ tokens.push(match); }

		return "(" + s + ")"; // add capture
	}).replace(/[\xa0 ]/g, "[\\s\\xa0]"); // normalize whitespace.  Need explicit handling of \xa0 for IE.
}

var _customFormats = [];
var _cachedGregorianBundles = {};
exports.addCustomFormats = function(/*String*/ packageName, /*String*/ bundleName){
	// summary:
	//		Add a reference to a bundle containing localized custom formats to be
	//		used by date/time formatting and parsing routines.
	//
	// description:
	//		The user may add custom localized formats where the bundle has properties following the
	//		same naming convention used by dojo.cldr: `dateFormat-xxxx` / `timeFormat-xxxx`
	//		The pattern string should match the format used by the CLDR.
	//		See dojo/date/locale.format() for details.
	//		The resources must be loaded by dojo.requireLocalization() prior to use

	_customFormats.push({pkg:packageName,name:bundleName});
	_cachedGregorianBundles = {};
};

exports._getGregorianBundle = function(/*String*/ locale){
	if(_cachedGregorianBundles[locale]){
		return _cachedGregorianBundles[locale];
	}
	var gregorian = {};
	array.forEach(_customFormats, function(desc){
		var bundle = i18n.getLocalization(desc.pkg, desc.name, locale);
		gregorian = lang.mixin(gregorian, bundle);
	}, this);
	return _cachedGregorianBundles[locale] = gregorian; /*Object*/
};

exports.addCustomFormats(module.id.replace(/\/date\/locale$/, ".cldr"),"gregorian");

exports.getNames = function(/*String*/ item, /*String*/ type, /*String?*/ context, /*String?*/ locale){
	// summary:
	//		Used to get localized strings from dojo.cldr for day or month names.
	//
	// item:
	//	'months' || 'days'
	// type:
	//	'wide' || 'abbr' || 'narrow' (e.g. "Monday", "Mon", or "M" respectively, in English)
	// context:
	//	'standAlone' || 'format' (default)
	// locale:
	//	override locale used to find the names

	var label,
		lookup = exports._getGregorianBundle(locale),
		props = [item, context, type];
	if(context == 'standAlone'){
		var key = props.join('-');
		label = lookup[key];
		// Fall back to 'format' flavor of name
		if(label[0] == 1){ label = undefined; } // kludge, in the absence of real aliasing support in dojo.cldr
	}
	props[1] = 'format';

	// return by copy so changes won't be made accidentally to the in-memory model
	return (label || lookup[props.join('-')]).concat(); /*Array*/
};

exports.isWeekend = function(/*Date?*/ dateObject, /*String?*/ locale){
	// summary:
	//	Determines if the date falls on a weekend, according to local custom.

	var weekend = supplemental.getWeekend(locale),
		day = (dateObject || new Date()).getDay();
	if(weekend.end < weekend.start){
		weekend.end += 7;
		if(day < weekend.start){ day += 7; }
	}
	return day >= weekend.start && day <= weekend.end; // Boolean
};

// These are used only by format and strftime.  Do they need to be public?  Which module should they go in?

exports._getDayOfYear = function(/*Date*/ dateObject){
	// summary:
	//		gets the day of the year as represented by dateObject
	return date.difference(new Date(dateObject.getFullYear(), 0, 1, dateObject.getHours()), dateObject) + 1; // Number
};

exports._getWeekOfYear = function(/*Date*/ dateObject, /*Number*/ firstDayOfWeek){
	if(arguments.length == 1){ firstDayOfWeek = 0; } // Sunday

	var firstDayOfYear = new Date(dateObject.getFullYear(), 0, 1).getDay(),
		adj = (firstDayOfYear - firstDayOfWeek + 7) % 7,
		week = Math.floor((exports._getDayOfYear(dateObject) + adj - 1) / 7);

	// if year starts on the specified day, start counting weeks at 1
	if(firstDayOfYear == firstDayOfWeek){ week++; }

	return week; // Number
};

return exports;
});

},
'dojo/cldr/supplemental':function(){
define(["../_base/lang", "../i18n"], function(lang, i18n){

// module:
//		dojo/cldr/supplemental


var supplemental = {
	// summary:
	//		TODOC
};
lang.setObject("dojo.cldr.supplemental", supplemental);

supplemental.getFirstDayOfWeek = function(/*String?*/locale){
	// summary:
	//		Returns a zero-based index for first day of the week
	// description:
	//		Returns a zero-based index for first day of the week, as used by the local (Gregorian) calendar.
	//		e.g. Sunday (returns 0), or Monday (returns 1)

	// from http://www.unicode.org/cldr/data/common/supplemental/supplementalData.xml:supplementalData/weekData/firstDay
	var firstDay = {/*default is 1=Monday*/
		bd:5,mv:5,
		ae:6,af:6,bh:6,dj:6,dz:6,eg:6,iq:6,ir:6,jo:6,kw:6,
		ly:6,ma:6,om:6,qa:6,sa:6,sd:6,sy:6,ye:6,
		ag:0,ar:0,as:0,au:0,br:0,bs:0,bt:0,bw:0,by:0,bz:0,ca:0,cn:0,
		co:0,dm:0,'do':0,et:0,gt:0,gu:0,hk:0,hn:0,id:0,ie:0,il:0,'in':0,
		jm:0,jp:0,ke:0,kh:0,kr:0,la:0,mh:0,mm:0,mo:0,mt:0,mx:0,mz:0,
		ni:0,np:0,nz:0,pa:0,pe:0,ph:0,pk:0,pr:0,py:0,sg:0,sv:0,th:0,
		tn:0,tt:0,tw:0,um:0,us:0,ve:0,vi:0,ws:0,za:0,zw:0
	};

	var country = supplemental._region(locale);
	var dow = firstDay[country];
	return (dow === undefined) ? 1 : dow; /*Number*/
};

supplemental._region = function(/*String?*/locale){
	locale = i18n.normalizeLocale(locale);
	var tags = locale.split('-');
	var region = tags[1];
	if(!region){
		// IE often gives language only (#2269)
		// Arbitrary mappings of language-only locales to a country:
		region = {
			aa:"et", ab:"ge", af:"za", ak:"gh", am:"et", ar:"eg", as:"in", av:"ru", ay:"bo", az:"az", ba:"ru",
			be:"by", bg:"bg", bi:"vu", bm:"ml", bn:"bd", bo:"cn", br:"fr", bs:"ba", ca:"es", ce:"ru", ch:"gu",
			co:"fr", cr:"ca", cs:"cz", cv:"ru", cy:"gb", da:"dk", de:"de", dv:"mv", dz:"bt", ee:"gh", el:"gr",
			en:"us", es:"es", et:"ee", eu:"es", fa:"ir", ff:"sn", fi:"fi", fj:"fj", fo:"fo", fr:"fr", fy:"nl",
			ga:"ie", gd:"gb", gl:"es", gn:"py", gu:"in", gv:"gb", ha:"ng", he:"il", hi:"in", ho:"pg", hr:"hr",
			ht:"ht", hu:"hu", hy:"am", ia:"fr", id:"id", ig:"ng", ii:"cn", ik:"us", "in":"id", is:"is", it:"it",
			iu:"ca", iw:"il", ja:"jp", ji:"ua", jv:"id", jw:"id", ka:"ge", kg:"cd", ki:"ke", kj:"na", kk:"kz",
			kl:"gl", km:"kh", kn:"in", ko:"kr", ks:"in", ku:"tr", kv:"ru", kw:"gb", ky:"kg", la:"va", lb:"lu",
			lg:"ug", li:"nl", ln:"cd", lo:"la", lt:"lt", lu:"cd", lv:"lv", mg:"mg", mh:"mh", mi:"nz", mk:"mk",
			ml:"in", mn:"mn", mo:"ro", mr:"in", ms:"my", mt:"mt", my:"mm", na:"nr", nb:"no", nd:"zw", ne:"np",
			ng:"na", nl:"nl", nn:"no", no:"no", nr:"za", nv:"us", ny:"mw", oc:"fr", om:"et", or:"in", os:"ge",
			pa:"in", pl:"pl", ps:"af", pt:"br", qu:"pe", rm:"ch", rn:"bi", ro:"ro", ru:"ru", rw:"rw", sa:"in",
			sd:"in", se:"no", sg:"cf", si:"lk", sk:"sk", sl:"si", sm:"ws", sn:"zw", so:"so", sq:"al", sr:"rs",
			ss:"za", st:"za", su:"id", sv:"se", sw:"tz", ta:"in", te:"in", tg:"tj", th:"th", ti:"et", tk:"tm",
			tl:"ph", tn:"za", to:"to", tr:"tr", ts:"za", tt:"ru", ty:"pf", ug:"cn", uk:"ua", ur:"pk", uz:"uz",
			ve:"za", vi:"vn", wa:"be", wo:"sn", xh:"za", yi:"il", yo:"ng", za:"cn", zh:"cn", zu:"za",
			ace:"id", ady:"ru", agq:"cm", alt:"ru", amo:"ng", asa:"tz", ast:"es", awa:"in", bal:"pk",
			ban:"id", bas:"cm", bax:"cm", bbc:"id", bem:"zm", bez:"tz", bfq:"in", bft:"pk", bfy:"in",
			bhb:"in", bho:"in", bik:"ph", bin:"ng", bjj:"in", bku:"ph", bqv:"ci", bra:"in", brx:"in",
			bss:"cm", btv:"pk", bua:"ru", buc:"yt", bug:"id", bya:"id", byn:"er", cch:"ng", ccp:"in",
			ceb:"ph", cgg:"ug", chk:"fm", chm:"ru", chp:"ca", chr:"us", cja:"kh", cjm:"vn", ckb:"iq",
			crk:"ca", csb:"pl", dar:"ru", dav:"ke", den:"ca", dgr:"ca", dje:"ne", doi:"in", dsb:"de",
			dua:"cm", dyo:"sn", dyu:"bf", ebu:"ke", efi:"ng", ewo:"cm", fan:"gq", fil:"ph", fon:"bj",
			fur:"it", gaa:"gh", gag:"md", gbm:"in", gcr:"gf", gez:"et", gil:"ki", gon:"in", gor:"id",
			grt:"in", gsw:"ch", guz:"ke", gwi:"ca", haw:"us", hil:"ph", hne:"in", hnn:"ph", hoc:"in",
			hoj:"in", ibb:"ng", ilo:"ph", inh:"ru", jgo:"cm", jmc:"tz", kaa:"uz", kab:"dz", kaj:"ng",
			kam:"ke", kbd:"ru", kcg:"ng", kde:"tz", kdt:"th", kea:"cv", ken:"cm", kfo:"ci", kfr:"in",
			kha:"in", khb:"cn", khq:"ml", kht:"in", kkj:"cm", kln:"ke", kmb:"ao", koi:"ru", kok:"in",
			kos:"fm", kpe:"lr", krc:"ru", kri:"sl", krl:"ru", kru:"in", ksb:"tz", ksf:"cm", ksh:"de",
			kum:"ru", lag:"tz", lah:"pk", lbe:"ru", lcp:"cn", lep:"in", lez:"ru", lif:"np", lis:"cn",
			lki:"ir", lmn:"in", lol:"cd", lua:"cd", luo:"ke", luy:"ke", lwl:"th", mad:"id", mag:"in",
			mai:"in", mak:"id", man:"gn", mas:"ke", mdf:"ru", mdh:"ph", mdr:"id", men:"sl", mer:"ke",
			mfe:"mu", mgh:"mz", mgo:"cm", min:"id", mni:"in", mnk:"gm", mnw:"mm", mos:"bf", mua:"cm",
			mwr:"in", myv:"ru", nap:"it", naq:"na", nds:"de", "new":"np", niu:"nu", nmg:"cm", nnh:"cm",
			nod:"th", nso:"za", nus:"sd", nym:"tz", nyn:"ug", pag:"ph", pam:"ph", pap:"bq", pau:"pw",
			pon:"fm", prd:"ir", raj:"in", rcf:"re", rej:"id", rjs:"np", rkt:"in", rof:"tz", rwk:"tz",
			saf:"gh", sah:"ru", saq:"ke", sas:"id", sat:"in", saz:"in", sbp:"tz", scn:"it", sco:"gb",
			sdh:"ir", seh:"mz", ses:"ml", shi:"ma", shn:"mm", sid:"et", sma:"se", smj:"se", smn:"fi",
			sms:"fi", snk:"ml", srn:"sr", srr:"sn", ssy:"er", suk:"tz", sus:"gn", swb:"yt", swc:"cd",
			syl:"bd", syr:"sy", tbw:"ph", tcy:"in", tdd:"cn", tem:"sl", teo:"ug", tet:"tl", tig:"er",
			tiv:"ng", tkl:"tk", tmh:"ne", tpi:"pg", trv:"tw", tsg:"ph", tts:"th", tum:"mw", tvl:"tv",
			twq:"ne", tyv:"ru", tzm:"ma", udm:"ru", uli:"fm", umb:"ao", unr:"in", unx:"in", vai:"lr",
			vun:"tz", wae:"ch", wal:"et", war:"ph", xog:"ug", xsr:"np", yao:"mz", yap:"fm", yav:"cm", zza:"tr"
		}[tags[0]];
	}else if(region.length == 4){
		// The ISO 3166 country code is usually in the second position, unless a
		// 4-letter script is given. See http://www.ietf.org/rfc/rfc4646.txt
		region = tags[2];
	}
	return region;
};

supplemental.getWeekend = function(/*String?*/locale){
	// summary:
	//		Returns a hash containing the start and end days of the weekend
	// description:
	//		Returns a hash containing the start and end days of the weekend according to local custom using locale,
	//		or by default in the user's locale.
	//		e.g. {start:6, end:0}

	// from http://www.unicode.org/cldr/data/common/supplemental/supplementalData.xml:supplementalData/weekData/weekend{Start,End}
	var weekendStart = {/*default is 6=Saturday*/
			'in':0,
			af:4,dz:4,ir:4,om:4,sa:4,ye:4,
			ae:5,bh:5,eg:5,il:5,iq:5,jo:5,kw:5,ly:5,ma:5,qa:5,sd:5,sy:5,tn:5
		},

		weekendEnd = {/*default is 0=Sunday*/
			af:5,dz:5,ir:5,om:5,sa:5,ye:5,
			ae:6,bh:5,eg:6,il:6,iq:6,jo:6,kw:6,ly:6,ma:6,qa:6,sd:6,sy:6,tn:6
		},

		country = supplemental._region(locale),
		start = weekendStart[country],
		end = weekendEnd[country];

	if(start === undefined){start=6;}
	if(end === undefined){end=0;}
	return {start:start, end:end}; /*Object {start,end}*/
};

return supplemental;
});

},
'soso/sosox/Formats':function(){
define([], function() {
    return {
        number: {
            standard: { pattern: "#,##0.##", places: 2},
            accountancy: { pattern: "#,##0.##;(#,##0.##)", places: 2 }
        },
        currency: {
            code: "GBP",
            standard: { currency: "GBP", pattern: "¤#,##0.00", places: 2 },
            accountancy: { currency: "GBP", pattern: "¤#,##0.00;(¤#,##0.00)", places: 2 }
        },
        currencyPrecise: {
            code: "GBP",
            standard: { currency: "GBP", pattern: "¤#,##0.00000", places: 5 },
            accountancy: { currency: "GBP", pattern: "¤#,##0.00000;(¤#,##0.00000)", places: 5 }
        }
    }
});

},
'soso/sosox/Helpers':function(){
define([
    'style-guide/v1/icons/FileTypeToAnchorClass'
], function() {
    return {
        fileSize: function(bytes, precision) {
            bytes = parseFloat(bytes);
            if (isNaN(bytes)) {
                return '';
            }

            if (precision === undefined) {
                precision = 1;
            }

            var ONE_MB_IN_BYTES = 1048576;
            var ONE_KB_IN_BYTES = 1024;

            if (bytes >= ONE_MB_IN_BYTES) {
                return (bytes / ONE_MB_IN_BYTES).toFixed(precision) + ' MB';

            } else if (bytes >= ONE_KB_IN_BYTES) {
                return (bytes / ONE_KB_IN_BYTES).toFixed(precision) + ' KB';

            } else {
                return bytes + ' B';
            }
        },
        /**
         * @param Array values
         */
        getMaxPrecision: function(values, minPrecision) {
            var maxPrecision = (minPrecision === undefined ? 0 : minPrecision);

            for (var i in values) {
                var value = parseFloat(values[i]).toString();
                var decimalPointPosition = value.indexOf('.')

                if (decimalPointPosition > -1) {
                    var precision = value.substring(decimalPointPosition).length - 1;
                    maxPrecision = Math.max(maxPrecision, precision);
                }
            }
            return maxPrecision;
        },

        fileExtension: function(filename) {
            if (!filename || filename.indexOf('.') === -1) {
                return '';
            }

            return filename.split('.').pop().toUpperCase();
        },

        revisionDownloadLink: function(revisionPK) {
            return baseUrl + 'doccontrol/download.php?revisionPK=' + revisionPK;
        },

        temporaryDocumentDownloadLink: function(temporaryDocumentPK, hash) {
            let url = baseUrl + 'doccontrol/download.php?tempDocumentPK=' + temporaryDocumentPK;

            if (hash) {
                return url + '&hash=' + hash;
            } else {
                return url;
            }
        }
    }
});

},
'style-guide/v1/icons/FileTypeToAnchorClass':function(){
define([
    'dojo/_base/declare'
], function(declare) {
    return declare('style-guide.v1.icons.filetypetoanchorclass', [], {
        ICON_CLASS_PREFIX: 'sos-anchor',

        getClass: function(type, subtype) {
            if (arguments.length === 1 && type) {
                var fileType = type.split('/');
                type = fileType[0];
                subtype = fileType[1];
            }

            if (type === 'image' && subtype !== 'gif') {
                return this.ICON_CLASS_PREFIX + '-view';
            }

            if (type === 'message') {
                return this.ICON_CLASS_PREFIX + '-view';
            }

            return this.ICON_CLASS_PREFIX + '-download';
        }
    })
});

},
'spencer/encoding/Template':function(){
define(function() {
    var Template = function() {
        const TEMPLATE_VARIABLE_REGEX = '(\\\$)(?={)';
        const SUBJECT_CHARACTERS_REGEX = '([\\\\"<>])';

        this._getRegularExpression = function() {
            let regexString = TEMPLATE_VARIABLE_REGEX + '|' + SUBJECT_CHARACTERS_REGEX;
            return new RegExp(regexString, 'g');
        };
    };

    Template.prototype.encode = function(text) {
        if (!text) {
            return '';
        }

        return text.replace(this._getRegularExpression(), function(match) {
            return '&#' + match.charCodeAt(0) + ';';
        });
    };

    return Template;
});
},
'spencer/format/ProjectStageTitle':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class ProjectStageTitle {
        constructor() {
            this.NO_TITLE = '[No Project Stage Title]';
            this.stageNumber = null;
            this.title = null;
        }
        setStageNumber(stageNumber) {
            this.stageNumber = stageNumber;
            return this;
        }
        setTitle(title) {
            this.title = title;
            return this;
        }
        format() {
            if (!this.stageNumber) {
                if (!this.title) {
                    return this.NO_TITLE;
                }
                return this.title;
            }
            return this.stageNumber + (this.title ? ' - ' + this.title : '');
        }
    }
    return ProjectStageTitle;
});

},
'spencer/parse/URLToLink':function(){
define([
    'vendor/autolinker/dist/autolinker'
], function(Autolinker) {
    const URLToLink = function() {};

    URLToLink.prototype.parse = function(string, options) {
        return Autolinker.link(string, options);
    };

    return URLToLink;
});
},
'vendor/autolinker/dist/autolinker':function(){
/*!
 * Autolinker.js
 * v4.1.5
 *
 * Copyright(c) 2025 Gregory Jacobs <greg@greg-jacobs.com>
 * MIT License
 *
 * https://github.com/gregjacobs/Autolinker.js
 */
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.Autolinker = factory());
})(this, (function () { 'use strict';

    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise, SuppressedError, Symbol, Iterator */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || Array.prototype.slice.call(from));
    }

    typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
        var e = new Error(message);
        return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
    };

    // Important: this file is generated from the 'build' script and should not be
    // edited directly
    var version = '4.1.5';

    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
     * Simpler helper method to check for a boolean type simply for the benefit of
     * gaining better compression when minified by not needing to have multiple
     * `typeof` comparisons in the codebase.
     */
    function isBoolean(value) {
        return typeof value === 'boolean';
    }
    /**
     * Truncates the `str` at `len - ellipsisChars.length`, and adds the `ellipsisChars` to the
     * end of the string (by default, two periods: '..'). If the `str` length does not exceed
     * `len`, the string will be returned unchanged.
     *
     * @param {String} str The string to truncate and add an ellipsis to.
     * @param {Number} truncateLen The length to truncate the string at.
     * @param {String} [ellipsisChars=...] The ellipsis character(s) to add to the end of `str`
     *   when truncated. Defaults to '...'
     */
    function ellipsis(str, truncateLen, ellipsisChars) {
        var ellipsisLength;
        if (str.length > truncateLen) {
            if (ellipsisChars == null) {
                ellipsisChars = '&hellip;';
                ellipsisLength = 3;
            }
            else {
                ellipsisLength = ellipsisChars.length;
            }
            str = str.substring(0, truncateLen - ellipsisLength) + ellipsisChars;
        }
        return str;
    }
    /**
     * Removes array elements based on a filtering function. Mutates the input
     * array.
     *
     * Using this instead of the ES5 Array.prototype.filter() function to prevent
     * creating many new arrays in memory for filtering.
     *
     * @param arr The array to remove elements from. This array is mutated.
     * @param fn The predicate function which should return `true` to remove an
     *   element.
     */
    function removeWithPredicate(arr, fn) {
        for (var i = arr.length - 1; i >= 0; i--) {
            if (fn(arr[i]) === true) {
                arr.splice(i, 1);
            }
        }
    }
    /**
     * Function that should never be called but is used to check that every
     * enum value is handled using TypeScript's 'never' type.
     */
    /* istanbul ignore next */
    function assertNever(theValue) {
        throw new Error("Unhandled case for value: '".concat(theValue, "'"));
    }

    // Regular expression to match whitespace
    var whitespaceRe = /\s+/;
    /**
     * @class Autolinker.HtmlTag
     * @extends Object
     *
     * Represents an HTML tag, which can be used to easily build/modify HTML tags programmatically.
     *
     * Autolinker uses this abstraction to create HTML tags, and then write them out as strings. You may also use
     * this class in your code, especially within a {@link Autolinker#replaceFn replaceFn}.
     *
     * ## Examples
     *
     * Example instantiation:
     *
     *     var tag = new Autolinker.HtmlTag( {
     *         tagName : 'a',
     *         attrs   : { 'href': 'http://google.com', 'class': 'external-link' },
     *         innerHtml : 'Google'
     *     } );
     *
     *     tag.toAnchorString();  // <a href="http://google.com" class="external-link">Google</a>
     *
     *     // Individual accessor methods
     *     tag.getTagName();                 // 'a'
     *     tag.getAttr( 'href' );            // 'http://google.com'
     *     tag.hasClass( 'external-link' );  // true
     *
     *
     * Using mutator methods (which may be used in combination with instantiation config properties):
     *
     *     var tag = new Autolinker.HtmlTag();
     *     tag.setTagName( 'a' );
     *     tag.setAttr( 'href', 'http://google.com' );
     *     tag.addClass( 'external-link' );
     *     tag.setInnerHtml( 'Google' );
     *
     *     tag.getTagName();                 // 'a'
     *     tag.getAttr( 'href' );            // 'http://google.com'
     *     tag.hasClass( 'external-link' );  // true
     *
     *     tag.toAnchorString();  // <a href="http://google.com" class="external-link">Google</a>
     *
     *
     * ## Example use within a {@link Autolinker#replaceFn replaceFn}
     *
     *     var html = Autolinker.link( "Test google.com", {
     *         replaceFn : function( match ) {
     *             var tag = match.buildTag();  // returns an {@link Autolinker.HtmlTag} instance, configured with the Match's href and anchor text
     *             tag.setAttr( 'rel', 'nofollow' );
     *
     *             return tag;
     *         }
     *     } );
     *
     *     // generated html:
     *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
     *
     *
     * ## Example use with a new tag for the replacement
     *
     *     var html = Autolinker.link( "Test google.com", {
     *         replaceFn : function( match ) {
     *             var tag = new Autolinker.HtmlTag( {
     *                 tagName : 'button',
     *                 attrs   : { 'title': 'Load URL: ' + match.getAnchorHref() },
     *                 innerHtml : 'Load URL: ' + match.getAnchorText()
     *             } );
     *
     *             return tag;
     *         }
     *     } );
     *
     *     // generated html:
     *     //   Test <button title="Load URL: http://google.com">Load URL: google.com</button>
     */
    var HtmlTag = /** @class */ (function () {
        /**
         * @method constructor
         * @param {Object} [cfg] The configuration properties for this class, in an Object (map)
         */
        function HtmlTag(cfg) {
            if (cfg === void 0) { cfg = {}; }
            /**
             * @cfg {String} tagName
             *
             * The tag name. Ex: 'a', 'button', etc.
             *
             * Not required at instantiation time, but should be set using {@link #setTagName} before {@link #toAnchorString}
             * is executed.
             */
            this.tagName = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @cfg {Object.<String, String>} attrs
             *
             * An key/value Object (map) of attributes to create the tag with. The keys are the attribute names, and the
             * values are the attribute values.
             */
            this.attrs = {}; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @cfg {String} innerHTML
             *
             * The inner HTML for the tag.
             */
            this.innerHTML = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
            this.tagName = cfg.tagName || '';
            this.attrs = cfg.attrs || {};
            this.innerHTML = cfg.innerHtml || cfg.innerHTML || ''; // accept either the camelCased form or the fully capitalized acronym as in the DOM
        }
        /**
         * Sets the tag name that will be used to generate the tag with.
         *
         * @param {String} tagName
         * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
         */
        HtmlTag.prototype.setTagName = function (tagName) {
            this.tagName = tagName;
            return this;
        };
        /**
         * Retrieves the tag name.
         *
         * @return {String}
         */
        HtmlTag.prototype.getTagName = function () {
            return this.tagName;
        };
        /**
         * Sets an attribute on the HtmlTag.
         *
         * @param {String} attrName The attribute name to set.
         * @param {String} attrValue The attribute value to set.
         * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
         */
        HtmlTag.prototype.setAttr = function (attrName, attrValue) {
            var tagAttrs = this.getAttrs();
            tagAttrs[attrName] = attrValue;
            return this;
        };
        /**
         * Retrieves an attribute from the HtmlTag. If the attribute does not exist, returns `undefined`.
         *
         * @param {String} attrName The attribute name to retrieve.
         * @return {String} The attribute's value, or `undefined` if it does not exist on the HtmlTag.
         */
        HtmlTag.prototype.getAttr = function (attrName) {
            return this.getAttrs()[attrName];
        };
        /**
         * Sets one or more attributes on the HtmlTag.
         *
         * @param {Object.<String, String>} attrs A key/value Object (map) of the attributes to set.
         * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
         */
        HtmlTag.prototype.setAttrs = function (attrs) {
            Object.assign(this.getAttrs(), attrs);
            return this;
        };
        /**
         * Retrieves the attributes Object (map) for the HtmlTag.
         *
         * @return {Object.<String, String>} A key/value object of the attributes for the HtmlTag.
         */
        HtmlTag.prototype.getAttrs = function () {
            return this.attrs;
        };
        /**
         * Sets the provided `cssClass`, overwriting any current CSS classes on the HtmlTag.
         *
         * @param {String} cssClass One or more space-separated CSS classes to set (overwrite).
         * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
         */
        HtmlTag.prototype.setClass = function (cssClass) {
            return this.setAttr('class', cssClass);
        };
        /**
         * Convenience method to add one or more CSS classes to the HtmlTag. Will not add duplicate CSS classes.
         *
         * @param {String} cssClass One or more space-separated CSS classes to add.
         * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
         */
        HtmlTag.prototype.addClass = function (cssClass) {
            var classAttr = this.getClass();
            var classes = !classAttr ? [] : classAttr.split(whitespaceRe);
            var newClasses = cssClass.split(whitespaceRe);
            var newClass;
            while ((newClass = newClasses.shift())) {
                if (classes.indexOf(newClass) === -1) {
                    classes.push(newClass);
                }
            }
            this.getAttrs()['class'] = classes.join(' ');
            return this;
        };
        /**
         * Convenience method to remove one or more CSS classes from the HtmlTag.
         *
         * @param {String} cssClass One or more space-separated CSS classes to remove.
         * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
         */
        HtmlTag.prototype.removeClass = function (cssClass) {
            var classAttr = this.getClass();
            var classes = !classAttr ? [] : classAttr.split(whitespaceRe);
            var removeClasses = cssClass.split(whitespaceRe);
            var removeClass;
            while (classes.length && (removeClass = removeClasses.shift())) {
                var idx = classes.indexOf(removeClass);
                if (idx !== -1) {
                    classes.splice(idx, 1);
                }
            }
            this.getAttrs()['class'] = classes.join(' ');
            return this;
        };
        /**
         * Convenience method to retrieve the CSS class(es) for the HtmlTag, which will each be separated by spaces when
         * there are multiple.
         *
         * @return {String}
         */
        HtmlTag.prototype.getClass = function () {
            return this.getAttrs()['class'] || '';
        };
        /**
         * Convenience method to check if the tag has a CSS class or not.
         *
         * @param {String} cssClass The CSS class to check for.
         * @return {Boolean} `true` if the HtmlTag has the CSS class, `false` otherwise.
         */
        HtmlTag.prototype.hasClass = function (cssClass) {
            return (' ' + this.getClass() + ' ').indexOf(' ' + cssClass + ' ') !== -1;
        };
        /**
         * Sets the inner HTML for the tag.
         *
         * @param {String} html The inner HTML to set.
         * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
         */
        HtmlTag.prototype.setInnerHTML = function (html) {
            this.innerHTML = html;
            return this;
        };
        /**
         * Backwards compatibility method name.
         *
         * @param {String} html The inner HTML to set.
         * @return {Autolinker.HtmlTag} This HtmlTag instance, so that method calls may be chained.
         */
        HtmlTag.prototype.setInnerHtml = function (html) {
            return this.setInnerHTML(html);
        };
        /**
         * Retrieves the inner HTML for the tag.
         *
         * @return {String}
         */
        HtmlTag.prototype.getInnerHTML = function () {
            return this.innerHTML || '';
        };
        /**
         * Backward compatibility method name.
         *
         * @return {String}
         */
        HtmlTag.prototype.getInnerHtml = function () {
            return this.getInnerHTML();
        };
        /**
         * Generates the HTML string for the tag.
         *
         * @return {String}
         */
        HtmlTag.prototype.toAnchorString = function () {
            var tagName = this.getTagName();
            var attrsStr = this.buildAttrsStr();
            attrsStr = attrsStr ? ' ' + attrsStr : ''; // prepend a space if there are actually attributes
            return ['<', tagName, attrsStr, '>', this.getInnerHtml(), '</', tagName, '>'].join('');
        };
        /**
         * Support method for {@link #toAnchorString}, returns the string space-separated key="value" pairs, used to populate
         * the stringified HtmlTag.
         *
         * @protected
         * @return {String} Example return: `attr1="value1" attr2="value2"`
         */
        HtmlTag.prototype.buildAttrsStr = function () {
            var attrs = this.getAttrs(), attrsArr = [];
            for (var prop in attrs) {
                if (hasOwnProperty.call(attrs, prop)) {
                    attrsArr.push(prop + '="' + attrs[prop] + '"');
                }
            }
            return attrsArr.join(' ');
        };
        return HtmlTag;
    }());

    /**
     * Date: 2015-10-05
     * Author: Kasper Søfren <soefritz@gmail.com> (https://github.com/kafoso)
     *
     * A truncation feature, where the ellipsis will be placed at a section within
     * the URL making it still somewhat human readable.
     *
     * @param {String} url						 A URL.
     * @param {Number} truncateLen		 The maximum length of the truncated output URL string.
     * @param {String} ellipsisChars	 The characters to place within the url, e.g. "...".
     * @return {String} The truncated URL.
     */
    function truncateSmart(url, truncateLen, ellipsisChars) {
        var ellipsisLengthBeforeParsing;
        var ellipsisLength;
        if (ellipsisChars == null) {
            ellipsisChars = '&hellip;';
            ellipsisLength = 3;
            ellipsisLengthBeforeParsing = 8;
        }
        else {
            ellipsisLength = ellipsisChars.length;
            ellipsisLengthBeforeParsing = ellipsisChars.length;
        }
        // If the URL is shorter than the truncate length, return it as is
        if (url.length <= truncateLen) {
            return url;
        }
        var availableLength = truncateLen - ellipsisLength;
        var urlObj = parseUrl(url);
        // Clean up the URL by removing any malformed query string
        // (e.g. "?foo=bar?ignorethis")
        if (urlObj.query) {
            var matchQuery = urlObj.query.match(/^(.*?)(?=(\?|#))(.*?)$/i);
            if (matchQuery) {
                // Malformed URL; two or more "?". Removed any content behind the 2nd.
                urlObj.query = urlObj.query.substr(0, matchQuery[1].length);
                url = buildUrl(urlObj);
            }
        }
        if (url.length <= truncateLen) {
            return url; // removing a malformed query string brought the URL under the truncateLength
        }
        // Clean up the URL by removing 'www.' from the host if it exists
        if (urlObj.host) {
            urlObj.host = urlObj.host.replace(/^www\./, '');
            url = buildUrl(urlObj);
        }
        if (url.length <= truncateLen) {
            return url; // removing 'www.' brought the URL under the truncateLength
        }
        // Process and build the truncated URL, starting with the hostname
        var truncatedUrl = '';
        if (urlObj.host) {
            truncatedUrl += urlObj.host;
        }
        if (truncatedUrl.length >= availableLength) {
            if (urlObj.host.length === truncateLen) {
                return (urlObj.host.substr(0, truncateLen - ellipsisLength) + ellipsisChars).substr(0, availableLength + ellipsisLengthBeforeParsing);
            }
            return buildSegment(truncatedUrl, availableLength, ellipsisChars).substr(0, availableLength + ellipsisLengthBeforeParsing);
        }
        // If we still have available chars left, add the path and query string
        var pathAndQuery = '';
        if (urlObj.path) {
            pathAndQuery += '/' + urlObj.path;
        }
        if (urlObj.query) {
            pathAndQuery += '?' + urlObj.query;
        }
        if (pathAndQuery) {
            if ((truncatedUrl + pathAndQuery).length >= availableLength) {
                if ((truncatedUrl + pathAndQuery).length == truncateLen) {
                    return (truncatedUrl + pathAndQuery).substr(0, truncateLen);
                }
                var remainingAvailableLength = availableLength - truncatedUrl.length;
                return (truncatedUrl + buildSegment(pathAndQuery, remainingAvailableLength, ellipsisChars)).substr(0, availableLength + ellipsisLengthBeforeParsing);
            }
            else {
                truncatedUrl += pathAndQuery;
            }
        }
        // If we still have available chars left, add the fragment
        if (urlObj.fragment) {
            var fragment = '#' + urlObj.fragment;
            if ((truncatedUrl + fragment).length >= availableLength) {
                if ((truncatedUrl + fragment).length == truncateLen) {
                    return (truncatedUrl + fragment).substr(0, truncateLen);
                }
                var remainingAvailableLength2 = availableLength - truncatedUrl.length;
                return (truncatedUrl + buildSegment(fragment, remainingAvailableLength2, ellipsisChars)).substr(0, availableLength + ellipsisLengthBeforeParsing);
            }
            else {
                truncatedUrl += fragment;
            }
        }
        // If we still have available chars left, add the scheme
        if (urlObj.scheme && urlObj.host) {
            var scheme = urlObj.scheme + '://';
            if ((truncatedUrl + scheme).length < availableLength) {
                return (scheme + truncatedUrl).substr(0, truncateLen);
            }
        }
        if (truncatedUrl.length <= truncateLen) {
            return truncatedUrl;
        }
        var end = '';
        if (availableLength > 0) {
            end = truncatedUrl.substr(-1 * Math.floor(availableLength / 2));
        }
        return (truncatedUrl.substr(0, Math.ceil(availableLength / 2)) + ellipsisChars + end).substr(0, availableLength + ellipsisLengthBeforeParsing);
    }
    /**
     * Parses a URL into its components: scheme, host, path, query, and fragment.
     */
    function parseUrl(url) {
        // Functionality inspired by PHP function of same name
        var urlObj = {};
        var urlSub = url;
        // Parse scheme
        var match = urlSub.match(/^([a-z]+):\/\//i);
        if (match) {
            urlObj.scheme = match[1];
            urlSub = urlSub.slice(match[0].length);
        }
        // Parse host
        match = urlSub.match(/^(.*?)(?=(\?|#|\/|$))/i);
        if (match) {
            urlObj.host = match[1];
            urlSub = urlSub.slice(match[0].length);
        }
        // Parse path
        match = urlSub.match(/^\/(.*?)(?=(\?|#|$))/i);
        if (match) {
            urlObj.path = match[1];
            urlSub = urlSub.slice(match[0].length);
        }
        // Parse query
        match = urlSub.match(/^\?(.*?)(?=(#|$))/i);
        if (match) {
            urlObj.query = match[1];
            urlSub = urlSub.slice(match[0].length);
        }
        // Parse fragment
        match = urlSub.match(/^#(.*?)$/i);
        if (match) {
            urlObj.fragment = match[1];
            //urlSub = urlSub.slice(match[0].length);  -- not used. Uncomment if adding another block.
        }
        return urlObj;
    }
    function buildUrl(urlObj) {
        var url = '';
        if (urlObj.scheme && urlObj.host) {
            url += urlObj.scheme + '://';
        }
        if (urlObj.host) {
            url += urlObj.host;
        }
        if (urlObj.path) {
            url += '/' + urlObj.path;
        }
        if (urlObj.query) {
            url += '?' + urlObj.query;
        }
        if (urlObj.fragment) {
            url += '#' + urlObj.fragment;
        }
        return url;
    }
    function buildSegment(segment, remainingAvailableLength, ellipsisChars) {
        var remainingAvailableLengthHalf = remainingAvailableLength / 2;
        var startOffset = Math.ceil(remainingAvailableLengthHalf);
        var endOffset = -1 * Math.floor(remainingAvailableLengthHalf);
        var end = '';
        if (endOffset < 0) {
            end = segment.substr(endOffset);
        }
        return segment.substr(0, startOffset) + ellipsisChars + end;
    }

    /**
     * Date: 2015-10-05
     * Author: Kasper Søfren <soefritz@gmail.com> (https://github.com/kafoso)
     *
     * A truncation feature, where the ellipsis will be placed in the dead-center of the URL.
     *
     * @param {String} url             A URL.
     * @param {Number} truncateLen     The maximum length of the truncated output URL string.
     * @param {String} ellipsisChars   The characters to place within the url, e.g. "..".
     * @return {String} The truncated URL.
     */
    function truncateMiddle(url, truncateLen, ellipsisChars) {
        if (url.length <= truncateLen) {
            return url;
        }
        var ellipsisLengthBeforeParsing;
        var ellipsisLength;
        if (ellipsisChars == null) {
            ellipsisChars = '&hellip;';
            ellipsisLengthBeforeParsing = 8;
            ellipsisLength = 3;
        }
        else {
            ellipsisLengthBeforeParsing = ellipsisChars.length;
            ellipsisLength = ellipsisChars.length;
        }
        var availableLength = truncateLen - ellipsisLength;
        var end = '';
        if (availableLength > 0) {
            end = url.substr(-1 * Math.floor(availableLength / 2));
        }
        return (url.substr(0, Math.ceil(availableLength / 2)) + ellipsisChars + end).substr(0, availableLength + ellipsisLengthBeforeParsing);
    }

    /**
     * A truncation feature where the ellipsis will be placed at the end of the URL.
     *
     * @param {String} anchorText
     * @param {Number} truncateLen The maximum length of the truncated output URL string.
     * @param {String} ellipsisChars The characters to place within the url, e.g. "..".
     * @return {String} The truncated URL.
     */
    function truncateEnd(anchorText, truncateLen, ellipsisChars) {
        return ellipsis(anchorText, truncateLen, ellipsisChars);
    }

    /**
     * @protected
     * @class Autolinker.AnchorTagBuilder
     * @extends Object
     *
     * Builds anchor (&lt;a&gt;) tags for the Autolinker utility when a match is
     * found.
     *
     * Normally this class is instantiated, configured, and used internally by an
     * {@link Autolinker} instance, but may actually be used indirectly in a
     * {@link Autolinker#replaceFn replaceFn} to create {@link Autolinker.HtmlTag HtmlTag}
     * instances which may be modified before returning from the
     * {@link Autolinker#replaceFn replaceFn}. For example:
     *
     *     var html = Autolinker.link("Test google.com", {
     *         replaceFn: function(match) {
     *             var tag = match.buildTag();  // returns an {@link Autolinker.HtmlTag} instance
     *             tag.setAttr('rel', 'nofollow');
     *
     *             return tag;
     *         }
     *     });
     *
     *     // generated html:
     *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
     */
    var AnchorTagBuilder = /** @class */ (function () {
        /**
         * @method constructor
         * @param {Object} [cfg] The configuration options for the AnchorTagBuilder instance, specified in an Object (map).
         */
        function AnchorTagBuilder(cfg) {
            if (cfg === void 0) { cfg = {}; }
            /**
             * @cfg {Boolean} newWindow
             * @inheritdoc Autolinker#newWindow
             */
            this.newWindow = false; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @cfg {Object} truncate
             * @inheritdoc Autolinker#truncate
             */
            this.truncate = {}; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @cfg {String} className
             * @inheritdoc Autolinker#className
             */
            this.className = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
            this.newWindow = cfg.newWindow || false;
            this.truncate = cfg.truncate || {};
            this.className = cfg.className || '';
        }
        /**
         * Generates the actual anchor (&lt;a&gt;) tag to use in place of the
         * matched text, via its `match` object.
         *
         * @param match The Match instance to generate an anchor tag from.
         * @return The HtmlTag instance for the anchor tag.
         */
        AnchorTagBuilder.prototype.build = function (match) {
            return new HtmlTag({
                tagName: 'a',
                attrs: this.createAttrs(match),
                innerHtml: this.processAnchorText(match.getAnchorText()),
            });
        };
        /**
         * Creates the Object (map) of the HTML attributes for the anchor (&lt;a&gt;)
         *   tag being generated.
         *
         * @protected
         * @param match The Match instance to generate an anchor tag from.
         * @return A key/value Object (map) of the anchor tag's attributes.
         */
        AnchorTagBuilder.prototype.createAttrs = function (match) {
            var attrs = {
                href: match.getAnchorHref(), // we'll always have the `href` attribute
            };
            var cssClass = this.createCssClass(match);
            if (cssClass) {
                attrs['class'] = cssClass;
            }
            if (this.newWindow) {
                attrs['target'] = '_blank';
                attrs['rel'] = 'noopener noreferrer'; // Issue #149. See https://mathiasbynens.github.io/rel-noopener/
            }
            if (this.truncate.length && this.truncate.length < match.getAnchorText().length) {
                attrs['title'] = match.getAnchorHref();
            }
            return attrs;
        };
        /**
         * Creates the CSS class that will be used for a given anchor tag, based on
         * the `matchType` and the {@link #className} config.
         *
         * Example returns:
         *
         * - ""                                      // no {@link #className}
         * - "myLink myLink-url"                     // url match
         * - "myLink myLink-email"                   // email match
         * - "myLink myLink-phone"                   // phone match
         * - "myLink myLink-hashtag"                 // hashtag match
         * - "myLink myLink-mention myLink-twitter"  // mention match with Twitter service
         *
         * @protected
         * @param match The Match instance to generate an
         *   anchor tag from.
         * @return The CSS class string for the link. Example return:
         *   "myLink myLink-url". If no {@link #className} was configured, returns
         *   an empty string.
         */
        AnchorTagBuilder.prototype.createCssClass = function (match) {
            var className = this.className;
            if (!className) {
                return '';
            }
            else {
                var returnClasses = [className], cssClassSuffixes = match.getCssClassSuffixes();
                for (var i = 0, len = cssClassSuffixes.length; i < len; i++) {
                    returnClasses.push(className + '-' + cssClassSuffixes[i]);
                }
                return returnClasses.join(' ');
            }
        };
        /**
         * Processes the `anchorText` by truncating the text according to the
         * {@link #truncate} config.
         *
         * @private
         * @param anchorText The anchor tag's text (i.e. what will be
         *   displayed).
         * @return The processed `anchorText`.
         */
        AnchorTagBuilder.prototype.processAnchorText = function (anchorText) {
            anchorText = this.doTruncate(anchorText);
            return anchorText;
        };
        /**
         * Performs the truncation of the `anchorText` based on the {@link #truncate}
         * option. If the `anchorText` is longer than the length specified by the
         * {@link #truncate} option, the truncation is performed based on the
         * `location` property. See {@link #truncate} for details.
         *
         * @private
         * @param anchorText The anchor tag's text (i.e. what will be
         *   displayed).
         * @return The truncated anchor text.
         */
        AnchorTagBuilder.prototype.doTruncate = function (anchorText) {
            var truncate = this.truncate;
            if (!truncate.length)
                return anchorText;
            var truncateLength = truncate.length, truncateLocation = truncate.location;
            if (truncateLocation === 'smart') {
                return truncateSmart(anchorText, truncateLength);
            }
            else if (truncateLocation === 'middle') {
                return truncateMiddle(anchorText, truncateLength);
            }
            else {
                return truncateEnd(anchorText, truncateLength);
            }
        };
        return AnchorTagBuilder;
    }());

    /**
     * @abstract
     * @class Autolinker.match.AbstractMatch
     *
     * Represents a match found in an input string which should be Autolinked. A Match object is what is provided in a
     * {@link Autolinker#replaceFn replaceFn}, and may be used to query for details about the match.
     *
     * For example:
     *
     *     var input = "...";  // string with URLs, Email Addresses, and Mentions (Twitter, Instagram, Soundcloud)
     *
     *     var linkedText = Autolinker.link( input, {
     *         replaceFn : function( match ) {
     *             console.log( "href = ", match.getAnchorHref() );
     *             console.log( "text = ", match.getAnchorText() );
     *
     *             switch( match.getType() ) {
     *                 case 'url' :
     *                     console.log( "url: ", match.getUrl() );
     *
     *                 case 'email' :
     *                     console.log( "email: ", match.getEmail() );
     *
     *                 case 'mention' :
     *                     console.log( "mention: ", match.getMention() );
     *             }
     *         }
     *     } );
     *
     * See the {@link Autolinker} class for more details on using the {@link Autolinker#replaceFn replaceFn}.
     */
    var AbstractMatch = /** @class */ (function () {
        /**
         * @member Autolinker.match.Match
         * @method constructor
         * @param {Object} cfg The configuration properties for the Match
         *   instance, specified in an Object (map).
         */
        function AbstractMatch(cfg) {
            /**
             * @cfg {Autolinker.AnchorTagBuilder} tagBuilder (required)
             *
             * Reference to the AnchorTagBuilder instance to use to generate an anchor
             * tag for the Match.
             */
            // @ts-expect-error Property used just to get the above doc comment into the ES5 output and documentation generator
            this._ = null;
            /**
             * @cfg {String} matchedText (required)
             *
             * The original text that was matched by the {@link Autolinker.matcher.Matcher}.
             */
            this.matchedText = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @cfg {Number} offset (required)
             *
             * The offset of where the match was made in the input string.
             */
            this.offset = 0; // default value just to get the above doc comment in the ES5 output and documentation generator
            this.tagBuilder = cfg.tagBuilder;
            this.matchedText = cfg.matchedText;
            this.offset = cfg.offset;
        }
        /**
         * Returns the original text that was matched.
         *
         * @return {String}
         */
        AbstractMatch.prototype.getMatchedText = function () {
            return this.matchedText;
        };
        /**
         * Sets the {@link #offset} of where the match was made in the input string.
         *
         * A {@link Autolinker.matcher.Matcher} will be fed only HTML text nodes,
         * and will therefore set an original offset that is relative to the HTML
         * text node itself. However, we want this offset to be relative to the full
         * HTML input string, and thus if using {@link Autolinker#parse} (rather
         * than calling a {@link Autolinker.matcher.Matcher} directly), then this
         * offset is corrected after the Matcher itself has done its job.
         *
         * @private
         * @param {Number} offset
         */
        AbstractMatch.prototype.setOffset = function (offset) {
            this.offset = offset;
        };
        /**
         * Returns the offset of where the match was made in the input string. This
         * is the 0-based index of the match.
         *
         * @return {Number}
         */
        AbstractMatch.prototype.getOffset = function () {
            return this.offset;
        };
        /**
         * Returns the CSS class suffix(es) for this match.
         *
         * A CSS class suffix is appended to the {@link Autolinker#className} in
         * the {@link Autolinker.AnchorTagBuilder} when a match is translated into
         * an anchor tag.
         *
         * For example, if {@link Autolinker#className} was configured as 'myLink',
         * and this method returns `[ 'url' ]`, the final class name of the element
         * will become: 'myLink myLink-url'.
         *
         * The match may provide multiple CSS class suffixes to be appended to the
         * {@link Autolinker#className} in order to facilitate better styling
         * options for different match criteria. See {@link Autolinker.match.Mention}
         * for an example.
         *
         * By default, this method returns a single array with the match's
         * {@link #getType type} name, but may be overridden by subclasses.
         *
         * @return {String[]}
         */
        AbstractMatch.prototype.getCssClassSuffixes = function () {
            return [this.type];
        };
        /**
         * Builds and returns an {@link Autolinker.HtmlTag} instance based on the
         * Match.
         *
         * This can be used to easily generate anchor tags from matches, and either
         * return their HTML string, or modify them before doing so.
         *
         * Example Usage:
         *
         *     var tag = match.buildTag();
         *     tag.addClass( 'cordova-link' );
         *     tag.setAttr( 'target', '_system' );
         *
         *     tag.toAnchorString();  // <a href="http://google.com" class="cordova-link" target="_system">Google</a>
         *
         * Example Usage in {@link Autolinker#replaceFn}:
         *
         *     var html = Autolinker.link( "Test google.com", {
         *         replaceFn : function( match ) {
         *             var tag = match.buildTag();  // returns an {@link Autolinker.HtmlTag} instance
         *             tag.setAttr( 'rel', 'nofollow' );
         *
         *             return tag;
         *         }
         *     } );
         *
         *     // generated html:
         *     //   Test <a href="http://google.com" target="_blank" rel="nofollow">google.com</a>
         */
        AbstractMatch.prototype.buildTag = function () {
            return this.tagBuilder.build(this);
        };
        return AbstractMatch;
    }());

    // NOTE: THIS FILE IS GENERATED. DO NOT EDIT.
    // INSTEAD, RUN: npm run generate-char-utils
    /**
     * Determines if the given character `c` matches the regular expression /[\x00-\x1F\x7F]/
     * by checking it via character code in a binary search fashion.
     *
     * This technique speeds this function up by a factor of ~10x vs. running RegExp.prototype.test()
     * on the character itself.
     *
     * NOTE: This function is generated. Do not edit manually. To regenerate, run:
     *
     *     npm run generate-char-utils
     */
    function isControlChar(c) {
        return ((c >= 0 && c <= 31) || c == 127);
    }
    /**
     * Determines if the given character `c` matches the regular expression /[A-Za-z]/
     * by checking it via character code in a binary search fashion.
     *
     * This technique speeds this function up by a factor of ~10x vs. running RegExp.prototype.test()
     * on the character itself.
     *
     * NOTE: This function is generated. Do not edit manually. To regenerate, run:
     *
     *     npm run generate-char-utils
     */
    function isAsciiLetterChar(c) {
        return ((c >= 65 && c <= 90) || (c >= 97 && c <= 122));
    }
    /**
     * Determines if the given character `c` matches the regular expression /\d/
     * by checking it via character code in a binary search fashion.
     *
     * This technique speeds this function up by a factor of ~10x vs. running RegExp.prototype.test()
     * on the character itself.
     *
     * NOTE: This function is generated. Do not edit manually. To regenerate, run:
     *
     *     npm run generate-char-utils
     */
    function isDigitChar(c) {
        return (c >= 48 && c <= 57);
    }
    /**
     * Determines if the given character `c` matches the regular expression /['"]/
     * by checking it via character code in a binary search fashion.
     *
     * This technique speeds this function up by a factor of ~10x vs. running RegExp.prototype.test()
     * on the character itself.
     *
     * NOTE: This function is generated. Do not edit manually. To regenerate, run:
     *
     *     npm run generate-char-utils
     */
    function isQuoteChar(c) {
        return (c == 34 || c == 39);
    }
    /**
     * Determines if the given character `c` matches the regular expression /\s/
     * by checking it via character code in a binary search fashion.
     *
     * This technique speeds this function up by a factor of ~10x vs. running RegExp.prototype.test()
     * on the character itself.
     *
     * NOTE: This function is generated. Do not edit manually. To regenerate, run:
     *
     *     npm run generate-char-utils
     */
    function isWhitespaceChar(c) {
        return (c < 8232 ? (c < 160 ? ((c >= 9 && c <= 13) || c == 32) : (c < 5760 ? c == 160 : (c == 5760 || (c >= 8192 && c <= 8202)))) : (c < 8287 ? ((c >= 8232 && c <= 8233) || c == 8239) : (c < 12288 ? c == 8287 : (c == 12288 || c == 65279))));
    }
    /**
     * Determines if the given character `c` matches the regular expression /[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC\u2700-\u27bf\udde6-\uddff\ud800-\udbff\udc00-\udfff\ufe0e\ufe0f\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0\ud83c\udffb-\udfff\u200d\u3299\u3297\u303d\u3030\u24c2\ud83c\udd70-\udd71\udd7e-\udd7f\udd8e\udd91-\udd9a\udde6-\uddff\ude01-\ude02\ude1a\ude2f\ude32-\ude3a\ude50-\ude51\u203c\u2049\u25aa-\u25ab\u25b6\u25c0\u25fb-\u25fe\u00a9\u00ae\u2122\u2139\udc04\u2600-\u26FF\u2b05\u2b06\u2b07\u2b1b\u2b1c\u2b50\u2b55\u231a\u231b\u2328\u23cf\u23e9-\u23f3\u23f8-\u23fa\udccf\u2935\u2934\u2190-\u21ff\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D4-\u08E1\u08E3-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962\u0963\u0981-\u0983\u09BC\u09BE-\u09C4\u09C7\u09C8\u09CB-\u09CD\u09D7\u09E2\u09E3\u0A01-\u0A03\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81-\u0A83\u0ABC\u0ABE-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AE2\u0AE3\u0B01-\u0B03\u0B3C\u0B3E-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B62\u0B63\u0B82\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD7\u0C00-\u0C03\u0C3E-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81-\u0C83\u0CBC\u0CBE-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D01-\u0D03\u0D3E-\u0D44\u0D46-\u0D48\u0D4A-\u0D4D\u0D57\u0D62\u0D63\u0D82\u0D83\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DF2\u0DF3\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F3E\u0F3F\u0F71-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102B-\u103E\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u192B\u1930-\u193B\u1A17-\u1A1B\u1A55-\u1A5E\u1A60-\u1A7C\u1A7F\u1AB0-\u1ABE\u1B00-\u1B04\u1B34-\u1B44\u1B6B-\u1B73\u1B80-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BF3\u1C24-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE8\u1CED\u1CF2-\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF5\u1DFB-\u1DFF\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA823-\uA827\uA880\uA881\uA8B4-\uA8C5\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA953\uA980-\uA983\uA9B3-\uA9C0\uA9E5\uAA29-\uAA36\uAA43\uAA4C\uAA4D\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEB-\uAAEF\uAAF5\uAAF6\uABE3-\uABEA\uABEC\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]/
     * by checking it via character code in a binary search fashion.
     *
     * This technique speeds this function up by a factor of ~10x vs. running RegExp.prototype.test()
     * on the character itself.
     *
     * NOTE: This function is generated. Do not edit manually. To regenerate, run:
     *
     *     npm run generate-char-utils
     */
    function isAlphaNumericOrMarkChar(c) {
        return (c < 4800 ? (c < 2949 ? (c < 2451 ? (c < 1425 ? (c < 768 ? (c < 192 ? (c < 169 ? (c < 65 ? (c >= 48 && c <= 57) : ((c >= 65 && c <= 90) || (c >= 97 && c <= 122))) : (c < 181 ? ((c >= 169 && c <= 170) || c == 174) : (c == 181 || c == 186))) : (c < 710 ? (c < 216 ? (c >= 192 && c <= 214) : ((c >= 216 && c <= 246) || (c >= 248 && c <= 705))) : (c < 748 ? ((c >= 710 && c <= 721) || (c >= 736 && c <= 740)) : (c == 748 || c == 750)))) : (c < 910 ? (c < 895 ? (c < 886 ? (c >= 768 && c <= 884) : ((c >= 886 && c <= 887) || (c >= 890 && c <= 893))) : (c < 904 ? (c == 895 || c == 902) : ((c >= 904 && c <= 906) || c == 908))) : (c < 1155 ? (c < 931 ? (c >= 910 && c <= 929) : ((c >= 931 && c <= 1013) || (c >= 1015 && c <= 1153))) : (c < 1369 ? ((c >= 1155 && c <= 1327) || (c >= 1329 && c <= 1366)) : (c == 1369 || (c >= 1377 && c <= 1415)))))) : (c < 1808 ? (c < 1552 ? (c < 1476 ? (c < 1471 ? (c >= 1425 && c <= 1469) : (c == 1471 || (c >= 1473 && c <= 1474))) : (c < 1488 ? ((c >= 1476 && c <= 1477) || c == 1479) : ((c >= 1488 && c <= 1514) || (c >= 1520 && c <= 1522)))) : (c < 1749 ? (c < 1568 ? (c >= 1552 && c <= 1562) : ((c >= 1568 && c <= 1641) || (c >= 1646 && c <= 1747))) : (c < 1770 ? ((c >= 1749 && c <= 1756) || (c >= 1759 && c <= 1768)) : ((c >= 1770 && c <= 1788) || c == 1791)))) : (c < 2230 ? (c < 2042 ? (c < 1869 ? (c >= 1808 && c <= 1866) : ((c >= 1869 && c <= 1969) || (c >= 1984 && c <= 2037))) : (c < 2112 ? (c == 2042 || (c >= 2048 && c <= 2093)) : ((c >= 2112 && c <= 2139) || (c >= 2208 && c <= 2228)))) : (c < 2406 ? (c < 2260 ? (c >= 2230 && c <= 2237) : ((c >= 2260 && c <= 2273) || (c >= 2275 && c <= 2403))) : (c < 2437 ? ((c >= 2406 && c <= 2415) || (c >= 2417 && c <= 2435)) : ((c >= 2437 && c <= 2444) || (c >= 2447 && c <= 2448))))))) : (c < 2693 ? (c < 2579 ? (c < 2519 ? (c < 2486 ? (c < 2474 ? (c >= 2451 && c <= 2472) : ((c >= 2474 && c <= 2480) || c == 2482)) : (c < 2503 ? ((c >= 2486 && c <= 2489) || (c >= 2492 && c <= 2500)) : ((c >= 2503 && c <= 2504) || (c >= 2507 && c <= 2510)))) : (c < 2534 ? (c < 2524 ? c == 2519 : ((c >= 2524 && c <= 2525) || (c >= 2527 && c <= 2531))) : (c < 2565 ? ((c >= 2534 && c <= 2545) || (c >= 2561 && c <= 2563)) : ((c >= 2565 && c <= 2570) || (c >= 2575 && c <= 2576))))) : (c < 2631 ? (c < 2613 ? (c < 2602 ? (c >= 2579 && c <= 2600) : ((c >= 2602 && c <= 2608) || (c >= 2610 && c <= 2611))) : (c < 2620 ? ((c >= 2613 && c <= 2614) || (c >= 2616 && c <= 2617)) : (c == 2620 || (c >= 2622 && c <= 2626)))) : (c < 2649 ? (c < 2635 ? (c >= 2631 && c <= 2632) : ((c >= 2635 && c <= 2637) || c == 2641)) : (c < 2662 ? ((c >= 2649 && c <= 2652) || c == 2654) : ((c >= 2662 && c <= 2677) || (c >= 2689 && c <= 2691)))))) : (c < 2821 ? (c < 2759 ? (c < 2730 ? (c < 2703 ? (c >= 2693 && c <= 2701) : ((c >= 2703 && c <= 2705) || (c >= 2707 && c <= 2728))) : (c < 2741 ? ((c >= 2730 && c <= 2736) || (c >= 2738 && c <= 2739)) : ((c >= 2741 && c <= 2745) || (c >= 2748 && c <= 2757)))) : (c < 2784 ? (c < 2763 ? (c >= 2759 && c <= 2761) : ((c >= 2763 && c <= 2765) || c == 2768)) : (c < 2809 ? ((c >= 2784 && c <= 2787) || (c >= 2790 && c <= 2799)) : (c == 2809 || (c >= 2817 && c <= 2819))))) : (c < 2887 ? (c < 2858 ? (c < 2831 ? (c >= 2821 && c <= 2828) : ((c >= 2831 && c <= 2832) || (c >= 2835 && c <= 2856))) : (c < 2869 ? ((c >= 2858 && c <= 2864) || (c >= 2866 && c <= 2867)) : ((c >= 2869 && c <= 2873) || (c >= 2876 && c <= 2884)))) : (c < 2911 ? (c < 2902 ? ((c >= 2887 && c <= 2888) || (c >= 2891 && c <= 2893)) : ((c >= 2902 && c <= 2903) || (c >= 2908 && c <= 2909))) : (c < 2929 ? ((c >= 2911 && c <= 2915) || (c >= 2918 && c <= 2927)) : (c == 2929 || (c >= 2946 && c <= 2947)))))))) : (c < 3517 ? (c < 3205 ? (c < 3046 ? (c < 2984 ? (c < 2969 ? (c < 2958 ? (c >= 2949 && c <= 2954) : ((c >= 2958 && c <= 2960) || (c >= 2962 && c <= 2965))) : (c < 2974 ? ((c >= 2969 && c <= 2970) || c == 2972) : ((c >= 2974 && c <= 2975) || (c >= 2979 && c <= 2980)))) : (c < 3014 ? (c < 2990 ? (c >= 2984 && c <= 2986) : ((c >= 2990 && c <= 3001) || (c >= 3006 && c <= 3010))) : (c < 3024 ? ((c >= 3014 && c <= 3016) || (c >= 3018 && c <= 3021)) : (c == 3024 || c == 3031)))) : (c < 3142 ? (c < 3086 ? (c < 3072 ? (c >= 3046 && c <= 3055) : ((c >= 3072 && c <= 3075) || (c >= 3077 && c <= 3084))) : (c < 3114 ? ((c >= 3086 && c <= 3088) || (c >= 3090 && c <= 3112)) : ((c >= 3114 && c <= 3129) || (c >= 3133 && c <= 3140)))) : (c < 3160 ? (c < 3146 ? (c >= 3142 && c <= 3144) : ((c >= 3146 && c <= 3149) || (c >= 3157 && c <= 3158))) : (c < 3174 ? ((c >= 3160 && c <= 3162) || (c >= 3168 && c <= 3171)) : ((c >= 3174 && c <= 3183) || (c >= 3200 && c <= 3203)))))) : (c < 3333 ? (c < 3274 ? (c < 3242 ? (c < 3214 ? (c >= 3205 && c <= 3212) : ((c >= 3214 && c <= 3216) || (c >= 3218 && c <= 3240))) : (c < 3260 ? ((c >= 3242 && c <= 3251) || (c >= 3253 && c <= 3257)) : ((c >= 3260 && c <= 3268) || (c >= 3270 && c <= 3272)))) : (c < 3296 ? (c < 3285 ? (c >= 3274 && c <= 3277) : ((c >= 3285 && c <= 3286) || c == 3294)) : (c < 3313 ? ((c >= 3296 && c <= 3299) || (c >= 3302 && c <= 3311)) : ((c >= 3313 && c <= 3314) || (c >= 3329 && c <= 3331))))) : (c < 3423 ? (c < 3389 ? (c < 3342 ? (c >= 3333 && c <= 3340) : ((c >= 3342 && c <= 3344) || (c >= 3346 && c <= 3386))) : (c < 3402 ? ((c >= 3389 && c <= 3396) || (c >= 3398 && c <= 3400)) : ((c >= 3402 && c <= 3406) || (c >= 3412 && c <= 3415)))) : (c < 3458 ? (c < 3430 ? (c >= 3423 && c <= 3427) : ((c >= 3430 && c <= 3439) || (c >= 3450 && c <= 3455))) : (c < 3482 ? ((c >= 3458 && c <= 3459) || (c >= 3461 && c <= 3478)) : ((c >= 3482 && c <= 3505) || (c >= 3507 && c <= 3515))))))) : (c < 3804 ? (c < 3722 ? (c < 3570 ? (c < 3535 ? (c < 3520 ? c == 3517 : ((c >= 3520 && c <= 3526) || c == 3530)) : (c < 3544 ? ((c >= 3535 && c <= 3540) || c == 3542) : ((c >= 3544 && c <= 3551) || (c >= 3558 && c <= 3567)))) : (c < 3664 ? (c < 3585 ? (c >= 3570 && c <= 3571) : ((c >= 3585 && c <= 3642) || (c >= 3648 && c <= 3662))) : (c < 3716 ? ((c >= 3664 && c <= 3673) || (c >= 3713 && c <= 3714)) : (c == 3716 || (c >= 3719 && c <= 3720))))) : (c < 3754 ? (c < 3737 ? (c < 3725 ? c == 3722 : (c == 3725 || (c >= 3732 && c <= 3735))) : (c < 3749 ? ((c >= 3737 && c <= 3743) || (c >= 3745 && c <= 3747)) : (c == 3749 || c == 3751))) : (c < 3776 ? (c < 3757 ? (c >= 3754 && c <= 3755) : ((c >= 3757 && c <= 3769) || (c >= 3771 && c <= 3773))) : (c < 3784 ? ((c >= 3776 && c <= 3780) || c == 3782) : ((c >= 3784 && c <= 3789) || (c >= 3792 && c <= 3801)))))) : (c < 4176 ? (c < 3902 ? (c < 3872 ? (c < 3840 ? (c >= 3804 && c <= 3807) : (c == 3840 || (c >= 3864 && c <= 3865))) : (c < 3895 ? ((c >= 3872 && c <= 3881) || c == 3893) : (c == 3895 || c == 3897))) : (c < 3974 ? (c < 3913 ? (c >= 3902 && c <= 3911) : ((c >= 3913 && c <= 3948) || (c >= 3953 && c <= 3972))) : (c < 4038 ? ((c >= 3974 && c <= 3991) || (c >= 3993 && c <= 4028)) : (c == 4038 || (c >= 4096 && c <= 4169))))) : (c < 4688 ? (c < 4301 ? (c < 4256 ? (c >= 4176 && c <= 4253) : ((c >= 4256 && c <= 4293) || c == 4295)) : (c < 4348 ? (c == 4301 || (c >= 4304 && c <= 4346)) : ((c >= 4348 && c <= 4680) || (c >= 4682 && c <= 4685)))) : (c < 4746 ? (c < 4698 ? ((c >= 4688 && c <= 4694) || c == 4696) : ((c >= 4698 && c <= 4701) || (c >= 4704 && c <= 4744))) : (c < 4786 ? ((c >= 4746 && c <= 4749) || (c >= 4752 && c <= 4784)) : ((c >= 4786 && c <= 4789) || (c >= 4792 && c <= 4798))))))))) : (c < 11035 ? (c < 7416 ? (c < 6176 ? (c < 5873 ? (c < 4992 ? (c < 4824 ? (c < 4802 ? c == 4800 : ((c >= 4802 && c <= 4805) || (c >= 4808 && c <= 4822))) : (c < 4888 ? ((c >= 4824 && c <= 4880) || (c >= 4882 && c <= 4885)) : ((c >= 4888 && c <= 4954) || (c >= 4957 && c <= 4959)))) : (c < 5121 ? (c < 5024 ? (c >= 4992 && c <= 5007) : ((c >= 5024 && c <= 5109) || (c >= 5112 && c <= 5117))) : (c < 5761 ? ((c >= 5121 && c <= 5740) || (c >= 5743 && c <= 5759)) : ((c >= 5761 && c <= 5786) || (c >= 5792 && c <= 5866))))) : (c < 6002 ? (c < 5920 ? (c < 5888 ? (c >= 5873 && c <= 5880) : ((c >= 5888 && c <= 5900) || (c >= 5902 && c <= 5908))) : (c < 5984 ? ((c >= 5920 && c <= 5940) || (c >= 5952 && c <= 5971)) : ((c >= 5984 && c <= 5996) || (c >= 5998 && c <= 6000)))) : (c < 6108 ? (c < 6016 ? (c >= 6002 && c <= 6003) : ((c >= 6016 && c <= 6099) || c == 6103)) : (c < 6155 ? ((c >= 6108 && c <= 6109) || (c >= 6112 && c <= 6121)) : ((c >= 6155 && c <= 6157) || (c >= 6160 && c <= 6169)))))) : (c < 6783 ? (c < 6512 ? (c < 6400 ? (c < 6272 ? (c >= 6176 && c <= 6263) : ((c >= 6272 && c <= 6314) || (c >= 6320 && c <= 6389))) : (c < 6448 ? ((c >= 6400 && c <= 6430) || (c >= 6432 && c <= 6443)) : ((c >= 6448 && c <= 6459) || (c >= 6470 && c <= 6509)))) : (c < 6608 ? (c < 6528 ? (c >= 6512 && c <= 6516) : ((c >= 6528 && c <= 6571) || (c >= 6576 && c <= 6601))) : (c < 6688 ? ((c >= 6608 && c <= 6617) || (c >= 6656 && c <= 6683)) : ((c >= 6688 && c <= 6750) || (c >= 6752 && c <= 6780))))) : (c < 7040 ? (c < 6832 ? (c < 6800 ? (c >= 6783 && c <= 6793) : ((c >= 6800 && c <= 6809) || c == 6823)) : (c < 6992 ? ((c >= 6832 && c <= 6846) || (c >= 6912 && c <= 6987)) : ((c >= 6992 && c <= 7001) || (c >= 7019 && c <= 7027)))) : (c < 7245 ? (c < 7168 ? (c >= 7040 && c <= 7155) : ((c >= 7168 && c <= 7223) || (c >= 7232 && c <= 7241))) : (c < 7376 ? ((c >= 7245 && c <= 7293) || (c >= 7296 && c <= 7304)) : ((c >= 7376 && c <= 7378) || (c >= 7380 && c <= 7414))))))) : (c < 8450 ? (c < 8130 ? (c < 8025 ? (c < 7960 ? (c < 7424 ? (c >= 7416 && c <= 7417) : ((c >= 7424 && c <= 7669) || (c >= 7675 && c <= 7957))) : (c < 8008 ? ((c >= 7960 && c <= 7965) || (c >= 7968 && c <= 8005)) : ((c >= 8008 && c <= 8013) || (c >= 8016 && c <= 8023)))) : (c < 8031 ? (c < 8027 ? c == 8025 : (c == 8027 || c == 8029)) : (c < 8118 ? ((c >= 8031 && c <= 8061) || (c >= 8064 && c <= 8116)) : ((c >= 8118 && c <= 8124) || c == 8126)))) : (c < 8205 ? (c < 8150 ? (c < 8134 ? (c >= 8130 && c <= 8132) : ((c >= 8134 && c <= 8140) || (c >= 8144 && c <= 8147))) : (c < 8178 ? ((c >= 8150 && c <= 8155) || (c >= 8160 && c <= 8172)) : ((c >= 8178 && c <= 8180) || (c >= 8182 && c <= 8188)))) : (c < 8305 ? (c < 8252 ? c == 8205 : (c == 8252 || c == 8265)) : (c < 8336 ? (c == 8305 || c == 8319) : ((c >= 8336 && c <= 8348) || (c >= 8400 && c <= 8432)))))) : (c < 8579 ? (c < 8486 ? (c < 8469 ? (c < 8455 ? c == 8450 : (c == 8455 || (c >= 8458 && c <= 8467))) : (c < 8482 ? (c == 8469 || (c >= 8473 && c <= 8477)) : (c == 8482 || c == 8484))) : (c < 8495 ? (c < 8488 ? c == 8486 : (c == 8488 || (c >= 8490 && c <= 8493))) : (c < 8517 ? ((c >= 8495 && c <= 8505) || (c >= 8508 && c <= 8511)) : ((c >= 8517 && c <= 8521) || c == 8526)))) : (c < 9410 ? (c < 9000 ? (c < 8592 ? (c >= 8579 && c <= 8580) : ((c >= 8592 && c <= 8703) || (c >= 8986 && c <= 8987))) : (c < 9193 ? (c == 9000 || c == 9167) : ((c >= 9193 && c <= 9203) || (c >= 9208 && c <= 9210)))) : (c < 9723 ? (c < 9654 ? (c == 9410 || (c >= 9642 && c <= 9643)) : (c == 9654 || c == 9664)) : (c < 10548 ? ((c >= 9723 && c <= 9726) || (c >= 9728 && c <= 10175)) : ((c >= 10548 && c <= 10549) || (c >= 11013 && c <= 11015)))))))) : (c < 43259 ? (c < 12445 ? (c < 11688 ? (c < 11520 ? (c < 11264 ? (c < 11088 ? (c >= 11035 && c <= 11036) : (c == 11088 || c == 11093)) : (c < 11360 ? ((c >= 11264 && c <= 11310) || (c >= 11312 && c <= 11358)) : ((c >= 11360 && c <= 11492) || (c >= 11499 && c <= 11507)))) : (c < 11568 ? (c < 11559 ? (c >= 11520 && c <= 11557) : (c == 11559 || c == 11565)) : (c < 11647 ? ((c >= 11568 && c <= 11623) || c == 11631) : ((c >= 11647 && c <= 11670) || (c >= 11680 && c <= 11686))))) : (c < 11744 ? (c < 11712 ? (c < 11696 ? (c >= 11688 && c <= 11694) : ((c >= 11696 && c <= 11702) || (c >= 11704 && c <= 11710))) : (c < 11728 ? ((c >= 11712 && c <= 11718) || (c >= 11720 && c <= 11726)) : ((c >= 11728 && c <= 11734) || (c >= 11736 && c <= 11742)))) : (c < 12330 ? (c < 11823 ? (c >= 11744 && c <= 11775) : (c == 11823 || (c >= 12293 && c <= 12294))) : (c < 12353 ? ((c >= 12330 && c <= 12341) || (c >= 12347 && c <= 12349)) : ((c >= 12353 && c <= 12438) || (c >= 12441 && c <= 12442)))))) : (c < 42512 ? (c < 12951 ? (c < 12549 ? (c < 12449 ? (c >= 12445 && c <= 12447) : ((c >= 12449 && c <= 12538) || (c >= 12540 && c <= 12543))) : (c < 12704 ? ((c >= 12549 && c <= 12589) || (c >= 12593 && c <= 12686)) : ((c >= 12704 && c <= 12730) || (c >= 12784 && c <= 12799)))) : (c < 19968 ? (c < 12953 ? c == 12951 : (c == 12953 || (c >= 13312 && c <= 19893))) : (c < 42192 ? ((c >= 19968 && c <= 40917) || (c >= 40960 && c <= 42124)) : ((c >= 42192 && c <= 42237) || (c >= 42240 && c <= 42508))))) : (c < 42891 ? (c < 42623 ? (c < 42560 ? (c >= 42512 && c <= 42539) : ((c >= 42560 && c <= 42610) || (c >= 42612 && c <= 42621))) : (c < 42775 ? ((c >= 42623 && c <= 42725) || (c >= 42736 && c <= 42737)) : ((c >= 42775 && c <= 42783) || (c >= 42786 && c <= 42888)))) : (c < 43072 ? (c < 42928 ? (c >= 42891 && c <= 42926) : ((c >= 42928 && c <= 42935) || (c >= 42999 && c <= 43047))) : (c < 43216 ? ((c >= 43072 && c <= 43123) || (c >= 43136 && c <= 43205)) : ((c >= 43216 && c <= 43225) || (c >= 43232 && c <= 43255))))))) : (c < 55243 ? (c < 43744 ? (c < 43488 ? (c < 43312 ? (c < 43261 ? c == 43259 : (c == 43261 || (c >= 43264 && c <= 43309))) : (c < 43392 ? ((c >= 43312 && c <= 43347) || (c >= 43360 && c <= 43388)) : ((c >= 43392 && c <= 43456) || (c >= 43471 && c <= 43481)))) : (c < 43600 ? (c < 43520 ? (c >= 43488 && c <= 43518) : ((c >= 43520 && c <= 43574) || (c >= 43584 && c <= 43597))) : (c < 43642 ? ((c >= 43600 && c <= 43609) || (c >= 43616 && c <= 43638)) : ((c >= 43642 && c <= 43714) || (c >= 43739 && c <= 43741))))) : (c < 43824 ? (c < 43785 ? (c < 43762 ? (c >= 43744 && c <= 43759) : ((c >= 43762 && c <= 43766) || (c >= 43777 && c <= 43782))) : (c < 43808 ? ((c >= 43785 && c <= 43790) || (c >= 43793 && c <= 43798)) : ((c >= 43808 && c <= 43814) || (c >= 43816 && c <= 43822)))) : (c < 44012 ? (c < 43868 ? (c >= 43824 && c <= 43866) : ((c >= 43868 && c <= 43877) || (c >= 43888 && c <= 44010))) : (c < 44032 ? ((c >= 44012 && c <= 44013) || (c >= 44016 && c <= 44025)) : ((c >= 44032 && c <= 55203) || (c >= 55216 && c <= 55238)))))) : (c < 64848 ? (c < 64298 ? (c < 64112 ? (c < 55296 ? (c >= 55243 && c <= 55291) : ((c >= 55296 && c <= 57343) || (c >= 63744 && c <= 64109))) : (c < 64275 ? ((c >= 64112 && c <= 64217) || (c >= 64256 && c <= 64262)) : ((c >= 64275 && c <= 64279) || (c >= 64285 && c <= 64296)))) : (c < 64320 ? (c < 64312 ? (c >= 64298 && c <= 64310) : ((c >= 64312 && c <= 64316) || c == 64318)) : (c < 64326 ? ((c >= 64320 && c <= 64321) || (c >= 64323 && c <= 64324)) : ((c >= 64326 && c <= 64433) || (c >= 64467 && c <= 64829))))) : (c < 65296 ? (c < 65024 ? (c < 64914 ? (c >= 64848 && c <= 64911) : ((c >= 64914 && c <= 64967) || (c >= 65008 && c <= 65019))) : (c < 65136 ? ((c >= 65024 && c <= 65039) || (c >= 65056 && c <= 65071)) : ((c >= 65136 && c <= 65140) || (c >= 65142 && c <= 65276)))) : (c < 65474 ? (c < 65345 ? ((c >= 65296 && c <= 65305) || (c >= 65313 && c <= 65338)) : ((c >= 65345 && c <= 65370) || (c >= 65382 && c <= 65470))) : (c < 65490 ? ((c >= 65474 && c <= 65479) || (c >= 65482 && c <= 65487)) : ((c >= 65490 && c <= 65495) || (c >= 65498 && c <= 65500))))))))));
    }
    /**
     * Determines if the given character `c` matches the regular expression /[!#$%&'*+/=?^_`{|}~-]/
     * by checking it via character code in a binary search fashion.
     *
     * This technique speeds this function up by a factor of ~10x vs. running RegExp.prototype.test()
     * on the character itself.
     *
     * NOTE: This function is generated. Do not edit manually. To regenerate, run:
     *
     *     npm run generate-char-utils
     */
    function isValidEmailLocalPartSpecialChar(c) {
        return (c < 47 ? (c < 42 ? (c == 33 || (c >= 35 && c <= 39)) : ((c >= 42 && c <= 43) || c == 45)) : (c < 63 ? (c == 47 || c == 61) : (c < 94 ? c == 63 : ((c >= 94 && c <= 96) || (c >= 123 && c <= 126)))));
    }
    /**
     * Determines if the given character `c` matches the regular expression /[-+&@#/%=~_()|'$*[\]{}\u2713]/
     * by checking it via character code in a binary search fashion.
     *
     * This technique speeds this function up by a factor of ~10x vs. running RegExp.prototype.test()
     * on the character itself.
     *
     * NOTE: This function is generated. Do not edit manually. To regenerate, run:
     *
     *     npm run generate-char-utils
     */
    function isUrlSuffixAllowedSpecialChar(c) {
        return (c < 91 ? (c < 47 ? ((c >= 35 && c <= 43) || c == 45) : (c < 61 ? c == 47 : (c == 61 || c == 64))) : (c < 95 ? (c == 91 || c == 93) : (c < 123 ? c == 95 : ((c >= 123 && c <= 126) || c == 10003))));
    }
    /**
     * Determines if the given character `c` matches the regular expression /[?!:,.;^]/
     * by checking it via character code in a binary search fashion.
     *
     * This technique speeds this function up by a factor of ~10x vs. running RegExp.prototype.test()
     * on the character itself.
     *
     * NOTE: This function is generated. Do not edit manually. To regenerate, run:
     *
     *     npm run generate-char-utils
     */
    function isUrlSuffixNotAllowedAsFinalChar(c) {
        return (c < 58 ? (c < 44 ? c == 33 : (c == 44 || c == 46)) : (c < 63 ? (c >= 58 && c <= 59) : (c == 63 || c == 94)));
    }
    /**
     * Determines if the given character `c` matches the regular expression /[({[]/
     * by checking it via character code in a binary search fashion.
     *
     * This technique speeds this function up by a factor of ~10x vs. running RegExp.prototype.test()
     * on the character itself.
     *
     * NOTE: This function is generated. Do not edit manually. To regenerate, run:
     *
     *     npm run generate-char-utils
     */
    function isOpenBraceChar(c) {
        return (c < 91 ? c == 40 : (c == 91 || c == 123));
    }
    /**
     * Determines if the given character `c` matches the regular expression /[)}\]]/
     * by checking it via character code in a binary search fashion.
     *
     * This technique speeds this function up by a factor of ~10x vs. running RegExp.prototype.test()
     * on the character itself.
     *
     * NOTE: This function is generated. Do not edit manually. To regenerate, run:
     *
     *     npm run generate-char-utils
     */
    function isCloseBraceChar(c) {
        return (c < 93 ? c == 41 : (c == 93 || c == 125));
    }

    // NOTE: THIS IS A GENERATED FILE
    // To update with the latest TLD list, run `npm run update-known-tlds`
    var tldRegex = /^(?:xn--vermgensberatung-pwb|xn--vermgensberater-ctb|xn--clchc0ea0b2g2a9gcd|xn--w4r85el8fhu5dnra|travelersinsurance|vermögensberatung|xn--5su34j936bgsg|xn--bck1b9a5dre4c|xn--mgbah1a3hjkrd|xn--mgbai9azgqp6j|xn--mgberp4a5d4ar|xn--xkc2dl3a5ee0h|vermögensberater|xn--fzys8d69uvgm|xn--mgba7c0bbn0a|xn--mgbcpq6gpa1a|xn--xkc2al3hye2a|americanexpress|kerryproperties|sandvikcoromant|xn--i1b6b1a6a2e|xn--kcrx77d1x4a|xn--lgbbat1ad8j|xn--mgba3a4f16a|xn--mgbc0a9azcg|xn--nqv7fs00ema|americanfamily|weatherchannel|xn--54b7fta0cc|xn--6qq986b3xl|xn--80aqecdr1a|xn--b4w605ferd|xn--fiq228c5hs|xn--h2breg3eve|xn--jlq480n2rg|xn--mgba3a3ejt|xn--mgbaam7a8h|xn--mgbayh7gpa|xn--mgbbh1a71e|xn--mgbca7dzdo|xn--mgbi4ecexp|xn--mgbx4cd0ab|xn--rvc1e0am3e|international|lifeinsurance|wolterskluwer|xn--cckwcxetd|xn--eckvdtc9d|xn--fpcrj9c3d|xn--fzc2c9e2c|xn--h2brj9c8c|xn--tiq49xqyj|xn--yfro4i67o|xn--ygbi2ammx|construction|lplfinancial|scholarships|versicherung|xn--3e0b707e|xn--45br5cyl|xn--4dbrk0ce|xn--80adxhks|xn--80asehdb|xn--8y0a063a|xn--gckr3f0f|xn--mgb9awbf|xn--mgbab2bd|xn--mgbgu82a|xn--mgbpl2fh|xn--mgbt3dhd|xn--mk1bu44c|xn--ngbc5azd|xn--ngbe9e0a|xn--ogbpf8fl|xn--qcka1pmc|accountants|barclaycard|blackfriday|blockbuster|bridgestone|calvinklein|contractors|creditunion|engineering|enterprises|investments|kerryhotels|lamborghini|motorcycles|olayangroup|photography|playstation|productions|progressive|redumbrella|williamhill|xn--11b4c3d|xn--1ck2e1b|xn--1qqw23a|xn--2scrj9c|xn--3bst00m|xn--3ds443g|xn--3hcrj9c|xn--42c2d9a|xn--45brj9c|xn--55qw42g|xn--6frz82g|xn--80ao21a|xn--9krt00a|xn--cck2b3b|xn--czr694b|xn--d1acj3b|xn--efvy88h|xn--fct429k|xn--fjq720a|xn--flw351e|xn--g2xx48c|xn--gecrj9c|xn--gk3at1e|xn--h2brj9c|xn--hxt814e|xn--imr513n|xn--j6w193g|xn--jvr189m|xn--kprw13d|xn--kpry57d|xn--mgbbh1a|xn--mgbtx2b|xn--mix891f|xn--nyqy26a|xn--otu796d|xn--pgbs0dh|xn--q9jyb4c|xn--rhqv96g|xn--rovu88b|xn--s9brj9c|xn--ses554g|xn--t60b56a|xn--vuq861b|xn--w4rs40l|xn--xhq521b|xn--zfr164b|சிங்கப்பூர்|accountant|apartments|associates|basketball|bnpparibas|boehringer|capitalone|consulting|creditcard|cuisinella|eurovision|extraspace|foundation|healthcare|immobilien|industries|management|mitsubishi|nextdirect|properties|protection|prudential|realestate|republican|restaurant|schaeffler|tatamotors|technology|university|vlaanderen|xn--30rr7y|xn--3pxu8k|xn--45q11c|xn--4gbrim|xn--55qx5d|xn--5tzm5g|xn--80aswg|xn--90a3ac|xn--9dbq2a|xn--9et52u|xn--c2br7g|xn--cg4bki|xn--czrs0t|xn--czru2d|xn--fiq64b|xn--fiqs8s|xn--fiqz9s|xn--io0a7i|xn--kput3i|xn--mxtq1m|xn--o3cw4h|xn--pssy2u|xn--q7ce6a|xn--unup4y|xn--wgbh1c|xn--wgbl6a|xn--y9a3aq|accenture|allfinanz|amsterdam|analytics|aquarelle|barcelona|bloomberg|christmas|community|directory|education|equipment|fairwinds|financial|firestone|fresenius|furniture|goldpoint|hisamitsu|homedepot|homegoods|homesense|institute|insurance|kuokgroup|landrover|lifestyle|marketing|marshalls|melbourne|microsoft|panasonic|pramerica|richardli|shangrila|solutions|statebank|statefarm|stockholm|travelers|vacations|xn--90ais|xn--c1avg|xn--d1alf|xn--e1a4c|xn--fhbei|xn--j1aef|xn--j1amh|xn--l1acc|xn--ngbrx|xn--nqv7f|xn--p1acf|xn--qxa6a|xn--tckwe|xn--vhquv|yodobashi|موريتانيا|abudhabi|airforce|allstate|attorney|barclays|barefoot|bargains|baseball|boutique|bradesco|broadway|brussels|builders|business|capetown|catering|catholic|cipriani|cleaning|clinique|clothing|commbank|computer|delivery|deloitte|democrat|diamonds|discount|discover|download|engineer|ericsson|exchange|feedback|fidelity|firmdale|football|frontier|goodyear|grainger|graphics|hdfcbank|helsinki|holdings|hospital|infiniti|ipiranga|istanbul|jpmorgan|lighting|lundbeck|marriott|mckinsey|memorial|merckmsd|mortgage|observer|partners|pharmacy|pictures|plumbing|property|redstone|reliance|saarland|samsclub|security|services|shopping|softbank|software|stcgroup|supplies|training|vanguard|ventures|verisign|woodside|xn--90ae|xn--node|xn--p1ai|xn--qxam|yokohama|السعودية|abogado|academy|agakhan|alibaba|android|athleta|auction|audible|auspost|banamex|bauhaus|bestbuy|booking|brother|capital|caravan|careers|channel|charity|chintai|citadel|clubmed|college|cologne|company|compare|contact|cooking|corsica|country|coupons|courses|cricket|cruises|dentist|digital|domains|exposed|express|farmers|fashion|ferrari|ferrero|finance|fishing|fitness|flights|florist|flowers|forsale|frogans|fujitsu|gallery|genting|godaddy|grocery|guitars|hamburg|hangout|hitachi|holiday|hosting|hotmail|hyundai|ismaili|jewelry|juniper|kitchen|komatsu|lacaixa|lanxess|lasalle|latrobe|leclerc|limited|lincoln|markets|monster|netbank|netflix|network|neustar|okinawa|organic|origins|philips|pioneer|politie|realtor|recipes|rentals|reviews|rexroth|samsung|sandvik|schmidt|schwarz|science|shiksha|singles|staples|storage|support|surgery|systems|temasek|theater|theatre|tickets|toshiba|trading|walmart|wanggou|watches|weather|website|wedding|whoswho|windows|winners|yamaxun|youtube|zuerich|католик|البحرين|الجزائر|العليان|پاکستان|كاثوليك|இந்தியா|abbott|abbvie|africa|agency|airbus|airtel|alipay|alsace|alstom|amazon|anquan|aramco|author|bayern|beauty|berlin|bharti|bostik|boston|broker|camera|career|casino|center|chanel|chrome|church|circle|claims|clinic|coffee|comsec|condos|coupon|credit|cruise|dating|datsun|dealer|degree|dental|design|direct|doctor|dunlop|dupont|durban|emerck|energy|estate|events|expert|family|flickr|futbol|gallup|garden|george|giving|global|google|gratis|health|hermes|hiphop|hockey|hotels|hughes|imamat|insure|intuit|jaguar|joburg|juegos|kaufen|kindle|kosher|latino|lawyer|lefrak|living|locker|london|luxury|madrid|maison|makeup|market|mattel|mobile|monash|mormon|moscow|museum|nagoya|nissan|nissay|norton|nowruz|office|olayan|online|oracle|orange|otsuka|pfizer|photos|physio|pictet|quebec|racing|realty|reisen|repair|report|review|rogers|ryukyu|safety|sakura|sanofi|school|schule|search|secure|select|shouji|soccer|social|stream|studio|supply|suzuki|swatch|sydney|taipei|taobao|target|tattoo|tennis|tienda|tjmaxx|tkmaxx|toyota|travel|unicom|viajes|viking|villas|virgin|vision|voting|voyage|walter|webcam|xihuan|yachts|yandex|zappos|москва|онлайн|ابوظبي|ارامكو|الاردن|المغرب|امارات|فلسطين|مليسيا|भारतम्|இலங்கை|ファッション|actor|adult|aetna|amfam|amica|apple|archi|audio|autos|azure|baidu|beats|bible|bingo|black|boats|bosch|build|canon|cards|chase|cheap|cisco|citic|click|cloud|coach|codes|crown|cymru|dance|deals|delta|drive|dubai|earth|edeka|email|epson|faith|fedex|final|forex|forum|gallo|games|gifts|gives|glass|globo|gmail|green|gripe|group|gucci|guide|homes|honda|horse|house|hyatt|ikano|irish|jetzt|koeln|kyoto|lamer|lease|legal|lexus|lilly|loans|locus|lotte|lotto|mango|media|miami|money|movie|music|nexus|nikon|ninja|nokia|nowtv|omega|osaka|paris|parts|party|phone|photo|pizza|place|poker|praxi|press|prime|promo|quest|radio|rehab|reise|ricoh|rocks|rodeo|rugby|salon|sener|seven|sharp|shell|shoes|skype|sling|smart|smile|solar|space|sport|stada|store|study|style|sucks|swiss|tatar|tires|tirol|tmall|today|tokyo|tools|toray|total|tours|trade|trust|tunes|tushu|ubank|vegas|video|vodka|volvo|wales|watch|weber|weibo|works|world|xerox|yahoo|ישראל|ایران|بازار|بھارت|سودان|سورية|همراه|भारोत|संगठन|বাংলা|భారత్|ഭാരതം|嘉里大酒店|aarp|able|aero|akdn|ally|amex|arab|army|arpa|arte|asda|asia|audi|auto|baby|band|bank|bbva|beer|best|bike|bing|blog|blue|bofa|bond|book|buzz|cafe|call|camp|care|cars|casa|case|cash|cbre|cern|chat|citi|city|club|cool|coop|cyou|data|date|dclk|deal|dell|desi|diet|dish|docs|dvag|erni|fage|fail|fans|farm|fast|fido|film|fire|fish|flir|food|ford|free|fund|game|gbiz|gent|ggee|gift|gmbh|gold|golf|goog|guge|guru|hair|haus|hdfc|help|here|host|hsbc|icbc|ieee|imdb|immo|info|itau|java|jeep|jobs|jprs|kddi|kids|kiwi|kpmg|kred|land|lego|lgbt|lidl|life|like|limo|link|live|loan|love|ltda|luxe|maif|meet|meme|menu|mini|mint|mobi|moda|moto|name|navy|news|next|nico|nike|ollo|open|page|pars|pccw|pics|ping|pink|play|plus|pohl|porn|post|prod|prof|qpon|read|reit|rent|rest|rich|room|rsvp|ruhr|safe|sale|sarl|save|saxo|scot|seat|seek|sexy|shia|shop|show|silk|sina|site|skin|sncf|sohu|song|sony|spot|star|surf|talk|taxi|team|tech|teva|tiaa|tips|town|toys|tube|vana|visa|viva|vivo|vote|voto|wang|weir|wien|wiki|wine|work|xbox|yoga|zara|zero|zone|дети|сайт|بارت|بيتك|ڀارت|تونس|شبكة|عراق|عمان|موقع|भारत|ভারত|ভাৰত|ਭਾਰਤ|ભારત|ଭାରତ|ಭಾರತ|ලංකා|アマゾン|グーグル|クラウド|ポイント|组织机构|電訊盈科|香格里拉|aaa|abb|abc|aco|ads|aeg|afl|aig|anz|aol|app|art|aws|axa|bar|bbc|bbt|bcg|bcn|bet|bid|bio|biz|bms|bmw|bom|boo|bot|box|buy|bzh|cab|cal|cam|car|cat|cba|cbn|ceo|cfa|cfd|com|cpa|crs|dad|day|dds|dev|dhl|diy|dnp|dog|dot|dtv|dvr|eat|eco|edu|esq|eus|fan|fit|fly|foo|fox|frl|ftr|fun|fyi|gal|gap|gay|gdn|gea|gle|gmo|gmx|goo|gop|got|gov|hbo|hiv|hkt|hot|how|ibm|ice|icu|ifm|inc|ing|ink|int|ist|itv|jcb|jio|jll|jmp|jnj|jot|joy|kfh|kia|kim|kpn|krd|lat|law|lds|llc|llp|lol|lpl|ltd|man|map|mba|med|men|mil|mit|mlb|mls|mma|moe|moi|mom|mov|msd|mtn|mtr|nab|nba|nec|net|new|nfl|ngo|nhk|now|nra|nrw|ntt|nyc|obi|one|ong|onl|ooo|org|ott|ovh|pay|pet|phd|pid|pin|pnc|pro|pru|pub|pwc|red|ren|ril|rio|rip|run|rwe|sap|sas|sbi|sbs|scb|sew|sex|sfr|ski|sky|soy|spa|srl|stc|tab|tax|tci|tdk|tel|thd|tjx|top|trv|tui|tvs|ubs|uno|uol|ups|vet|vig|vin|vip|wed|win|wme|wow|wtc|wtf|xin|xxx|xyz|you|yun|zip|бел|ком|қаз|мкд|мон|орг|рус|срб|укр|հայ|קום|عرب|قطر|كوم|مصر|कॉम|नेट|คอม|ไทย|ລາວ|ストア|セール|みんな|中文网|亚马逊|天主教|我爱你|新加坡|淡马锡|飞利浦|ac|ad|ae|af|ag|ai|al|am|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cu|cv|cw|cx|cy|cz|de|dj|dk|dm|do|dz|ec|ee|eg|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|me|mg|mh|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ro|rs|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|ss|st|su|sv|sx|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tr|tt|tv|tw|tz|ua|ug|uk|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|za|zm|zw|ελ|ευ|бг|ею|рф|გე|닷넷|닷컴|삼성|한국|コム|世界|中信|中国|中國|企业|佛山|信息|健康|八卦|公司|公益|台湾|台灣|商城|商店|商标|嘉里|在线|大拿|娱乐|家電|广东|微博|慈善|手机|招聘|政务|政府|新闻|时尚|書籍|机构|游戏|澳門|点看|移动|网址|网店|网站|网络|联通|谷歌|购物|通販|集团|食品|餐厅|香港)$/;

    /**
     * Regular expression to match an http:// or https:// scheme.
     */
    var httpSchemeRe = /https?:\/\//i;
    /**
     * Regular expression to match an http:// or https:// scheme as the prefix of
     * a string.
     */
    var httpSchemePrefixRe = new RegExp('^' + httpSchemeRe.source, 'i');
    /**
     * A regular expression used to determine the schemes we should not autolink
     */
    var invalidSchemeRe = /^(javascript|vbscript):/i;
    // A regular expression used to determine if the URL is a scheme match (such as
    // 'http://google.com', and as opposed to a "TLD match"). This regular
    // expression is used to parse out the host along with if the URL has an
    // authority component (i.e. '//')
    //
    // Capturing groups:
    //    1. '//' if the URL has an authority component, empty string otherwise
    //    2. The host (if one exists). Ex: 'google.com'
    //
    // See https://www.rfc-editor.org/rfc/rfc3986#appendix-A for terminology
    var schemeUrlRe = /^[A-Za-z][-.+A-Za-z0-9]*:(\/\/)?([^:/]*)/;
    // A regular expression used to determine if the URL is a TLD match (such as
    // 'google.com', and as opposed to a "scheme match"). This regular
    // expression is used to help parse out the TLD (top-level domain) of the host.
    //
    // See https://www.rfc-editor.org/rfc/rfc3986#appendix-A for terminology
    var tldUrlHostRe = /^(?:\/\/)?([^/#?:]+)/; // optionally prefixed with protocol-relative '//' chars
    /**
     * Determines if the given character code represents a character that may start
     * a scheme (ex: the 'h' in 'http')
     */
    var isSchemeStartChar = isAsciiLetterChar; // Equivalent to checking the RegExp `/[A-Za-z]/`, but aliased for clarity and maintainability
    /**
     * Determines if the given character is a valid character in a scheme (such as
     * 'http' or 'ssh+git'), but only after the start char (which is handled by
     * {@link isSchemeStartChar}.
     */
    function isSchemeChar(charCode) {
        return (isAsciiLetterChar(charCode) ||
            isDigitChar(charCode) ||
            charCode === 43 /* Char.Plus */ || // '+'
            charCode === 45 /* Char.Dash */ || // '-'
            charCode === 46 /* Char.Dot */ // '.'
        );
    }
    /**
     * Determines if the character can begin a domain label, which must be an
     * alphanumeric character and not an underscore or dash.
     *
     * A domain label is a segment of a hostname such as subdomain.google.com.
     */
    var isDomainLabelStartChar = isAlphaNumericOrMarkChar; // alias function for clarity
    /**
     * Determines if the character is part of a domain label (but not a domain label
     * start character).
     *
     * A domain label is a segment of a hostname such as subdomain.google.com.
     */
    function isDomainLabelChar(charCode) {
        return charCode === 95 /* Char.Underscore */ || isDomainLabelStartChar(charCode);
    }
    /**
     * Determines if the character is a path character ("pchar") as defined by
     * https://tools.ietf.org/html/rfc3986#appendix-A
     *
     *     pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
     *
     *     unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
     *     pct-encoded   = "%" HEXDIG HEXDIG
     *     sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
     *                   / "*" / "+" / "," / ";" / "="
     *
     * Note that this implementation doesn't follow the spec exactly, but rather
     * follows URL path characters found out in the wild (spec might be out of date?)
     */
    function isPathChar(charCode) {
        return (isAlphaNumericOrMarkChar(charCode) ||
            isUrlSuffixAllowedSpecialChar(charCode) ||
            isUrlSuffixNotAllowedAsFinalChar(charCode) // characters in addition to those allowed by isUrlSuffixAllowedSpecialChar()
        );
    }
    /**
     * Determines if the character given may begin the "URL Suffix" section of a
     * URI (i.e. the path, query, or hash section). These are the '/', '?' and '#'
     * characters.
     *
     * See https://tools.ietf.org/html/rfc3986#appendix-A
     */
    function isUrlSuffixStartChar(charCode) {
        return (charCode === 47 /* Char.Slash */ || // '/'
            charCode === 63 /* Char.Question */ || // '?'
            charCode === 35 /* Char.NumberSign */ // '#'
        );
    }
    /**
     * Determines if the top-level domain (TLD) read in the host is a known TLD.
     *
     * Example: 'com' would be a known TLD (for a host of 'google.com'), but
     * 'local' would not (for a domain name of 'my-computer.local').
     */
    function isKnownTld(tld) {
        return tldRegex.test(tld.toLowerCase()); // make sure the tld is lowercase for the regex
    }
    /**
     * Determines if the given `url` is a valid scheme-prefixed URL.
     */
    function isValidSchemeUrl(url) {
        // If the scheme is 'javascript:' or 'vbscript:', these link
        // types can be dangerous. Don't link them.
        if (invalidSchemeRe.test(url)) {
            return false;
        }
        var schemeMatch = url.match(schemeUrlRe);
        if (!schemeMatch) {
            return false;
        }
        var isAuthorityMatch = !!schemeMatch[1];
        var host = schemeMatch[2];
        if (isAuthorityMatch) {
            // Any match that has an authority ('//' chars) after the scheme is
            // valid, such as 'http://anything'
            return true;
        }
        // If there's no authority ('//' chars), check that we have a hostname
        // that looks valid.
        //
        // The host must contain at least one '.' char and have a domain label
        // with at least one letter to be considered valid.
        //
        // Accept:
        //   - git:domain.com (scheme followed by a host
        // Do not accept:
        //   - git:something ('something' doesn't look like a host)
        //   - version:1.0   ('1.0' doesn't look like a host)
        if (host.indexOf('.') === -1 || !/[A-Za-z]/.test(host)) {
            // `letterRe` RegExp checks for a letter anywhere in the host string
            return false;
        }
        return true;
    }
    /**
     * Determines if the given `url` is a match with a valid TLD.
     */
    function isValidTldMatch(url) {
        // TLD URL such as 'google.com', we need to confirm that we have a valid
        // top-level domain
        var tldUrlHostMatch = url.match(tldUrlHostRe);
        if (!tldUrlHostMatch) {
            // At this point, if the URL didn't match our TLD re, it must be invalid
            // (highly unlikely to happen, but just in case)
            return false;
        }
        var host = tldUrlHostMatch[0];
        var hostLabels = host.split('.');
        if (hostLabels.length < 2) {
            // 0 or 1 host label, there's no TLD. Ex: 'localhost'
            return false;
        }
        var tld = hostLabels[hostLabels.length - 1];
        if (!isKnownTld(tld)) {
            return false;
        }
        // TODO: Implement these conditions for TLD matcher:
        // (
        //     this.longestDomainLabelLength <= 63 &&
        //     this.domainNameLength <= 255
        // );
        return true;
    }
    // Regular expression to confirm a valid IPv4 address (ex: '192.168.0.1')
    // TODO: encode this into the state machine so that we don't need to run this
    //       regexp separately to confirm the match
    var ipV4Re = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    // Regular expression used to split the IPv4 address itself from any port/path/query/hash
    var ipV4PartRe = /[:/?#]/;
    /**
     * Determines if the given URL is a valid IPv4-prefixed URL.
     */
    function isValidIpV4Address(url) {
        // Grab just the IP address
        var ipV4Part = url.split(ipV4PartRe, 1)[0]; // only 1 result needed
        return ipV4Re.test(ipV4Part);
    }

    /**
     * A regular expression used to remove the 'www.' from URLs.
     */
    var wwwPrefixRegex = /^(https?:\/\/)?(?:www\.)?/i;
    /**
     * The regular expression used to remove the protocol-relative '//' from a URL
     * string, for purposes of formatting the anchor text. A protocol-relative URL
     * is, for example, "//yahoo.com"
     */
    var protocolRelativeRegex = /^\/\//;
    /**
     * @class Autolinker.match.Url
     * @extends Autolinker.match.AbstractMatch
     *
     * Represents a Url match found in an input string which should be Autolinked.
     *
     * See this class's superclass ({@link Autolinker.match.Match}) for more details.
     */
    var UrlMatch = /** @class */ (function (_super) {
        __extends(UrlMatch, _super);
        /**
         * @method constructor
         * @param {Object} cfg The configuration properties for the Match
         *   instance, specified in an Object (map).
         */
        function UrlMatch(cfg) {
            var _this = _super.call(this, cfg) || this;
            /**
             * @public
             * @property {'url'} type
             *
             * A string name for the type of match that this class represents. Can be
             * used in a TypeScript discriminating union to type-narrow from the
             * `Match` type.
             */
            _this.type = 'url';
            /**
             * @cfg {String} url (required)
             *
             * The url that was matched.
             */
            _this.url = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @cfg {"scheme"/"www"/"tld"} urlMatchType (required)
             *
             * The type of URL match that this class represents. This helps to determine
             * if the match was made in the original text with a prefixed scheme (ex:
             * 'http://www.google.com'), a prefixed 'www' (ex: 'www.google.com'), or
             * was matched by a known top-level domain (ex: 'google.com').
             */
            _this.urlMatchType = 'scheme'; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @cfg {Boolean} protocolRelativeMatch (required)
             *
             * `true` if the URL is a protocol-relative match. A protocol-relative match
             * is a URL that starts with '//', and will be either http:// or https://
             * based on the protocol that the site is loaded under.
             */
            _this.protocolRelativeMatch = false; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @cfg {Object} stripPrefix (required)
             *
             * The Object form of {@link Autolinker#cfg-stripPrefix}.
             */
            _this.stripPrefix = {
                scheme: true,
                www: true,
            }; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @cfg {Boolean} stripTrailingSlash (required)
             * @inheritdoc Autolinker#cfg-stripTrailingSlash
             */
            _this.stripTrailingSlash = true; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @cfg {Boolean} decodePercentEncoding (required)
             * @inheritdoc Autolinker#cfg-decodePercentEncoding
             */
            _this.decodePercentEncoding = true; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @private
             * @property {Boolean} protocolPrepended
             *
             * Will be set to `true` if the 'http://' protocol has been prepended to the {@link #url} (because the
             * {@link #url} did not have a protocol)
             */
            _this.protocolPrepended = false;
            _this.urlMatchType = cfg.urlMatchType;
            _this.url = cfg.url;
            _this.protocolRelativeMatch = cfg.protocolRelativeMatch;
            _this.stripPrefix = cfg.stripPrefix;
            _this.stripTrailingSlash = cfg.stripTrailingSlash;
            _this.decodePercentEncoding = cfg.decodePercentEncoding;
            return _this;
        }
        /**
         * Returns a string name for the type of match that this class represents.
         * For the case of UrlMatch, returns 'url'.
         *
         * @return {String}
         */
        UrlMatch.prototype.getType = function () {
            return 'url';
        };
        /**
         * Returns a string name for the type of URL match that this class
         * represents.
         *
         * This helps to determine if the match was made in the original text with a
         * prefixed scheme (ex: 'http://www.google.com'), a prefixed 'www' (ex:
         * 'www.google.com'), or was matched by a known top-level domain (ex:
         * 'google.com').
         *
         * @return {"scheme"/"www"/"tld"}
         */
        UrlMatch.prototype.getUrlMatchType = function () {
            return this.urlMatchType;
        };
        /**
         * Returns the url that was matched, assuming the protocol to be 'http://' if the original
         * match was missing a protocol.
         *
         * @return {String}
         */
        UrlMatch.prototype.getUrl = function () {
            var url = this.url;
            // if the url string doesn't begin with a scheme, assume 'http://'
            if (!this.protocolRelativeMatch &&
                this.urlMatchType !== 'scheme' &&
                !this.protocolPrepended) {
                url = this.url = 'http://' + url;
                this.protocolPrepended = true;
            }
            return url;
        };
        /**
         * Returns the anchor href that should be generated for the match.
         *
         * @return {String}
         */
        UrlMatch.prototype.getAnchorHref = function () {
            var url = this.getUrl();
            return url.replace(/&amp;/g, '&'); // any &amp;'s in the URL should be converted back to '&' if they were displayed as &amp; in the source html
        };
        /**
         * Returns the anchor text that should be generated for the match.
         *
         * @return {String}
         */
        UrlMatch.prototype.getAnchorText = function () {
            var anchorText = this.getMatchedText();
            if (this.protocolRelativeMatch) {
                // Strip off any protocol-relative '//' from the anchor text
                anchorText = stripProtocolRelativePrefix(anchorText);
            }
            if (this.stripPrefix.scheme) {
                anchorText = stripSchemePrefix(anchorText);
            }
            if (this.stripPrefix.www) {
                anchorText = stripWwwPrefix(anchorText);
            }
            if (this.stripTrailingSlash) {
                anchorText = removeTrailingSlash(anchorText); // remove trailing slash, if there is one
            }
            if (this.decodePercentEncoding) {
                anchorText = removePercentEncoding(anchorText);
            }
            return anchorText;
        };
        return UrlMatch;
    }(AbstractMatch));
    // Utility Functionality
    /**
     * Strips the scheme prefix (such as "http://" or "https://") from the given
     * `url`.
     *
     * @private
     * @param {String} url The text of the anchor that is being generated, for
     *   which to strip off the url scheme.
     * @return {String} The `url`, with the scheme stripped.
     */
    function stripSchemePrefix(url) {
        return url.replace(httpSchemePrefixRe, '');
    }
    /**
     * Strips the 'www' prefix from the given `url`.
     *
     * @private
     * @param {String} url The text of the anchor that is being generated, for
     *   which to strip off the 'www' if it exists.
     * @return {String} The `url`, with the 'www' stripped.
     */
    function stripWwwPrefix(url) {
        // If the URL doesn't actually include 'www.' in it, skip running the
        // .replace() regexp on it, which is fairly slow even just to check the
        // string for the 'www.'s existence. Most URLs these days do not have 'www.'
        // in it, so most of the time we skip running the .replace(). One other
        // option in the future is to run a state machine on the `url` string
        if (!url.includes('www.')) {
            return url;
        }
        else {
            return url.replace(wwwPrefixRegex, '$1'); // leave any scheme ($1), it one exists
        }
    }
    /**
     * Strips any protocol-relative '//' from the anchor text.
     *
     * @private
     * @param {String} text The text of the anchor that is being generated, for which to strip off the
     *   protocol-relative prefix (such as stripping off "//")
     * @return {String} The `anchorText`, with the protocol-relative prefix stripped.
     */
    function stripProtocolRelativePrefix(text) {
        return text.replace(protocolRelativeRegex, '');
    }
    /**
     * Removes any trailing slash from the given `anchorText`, in preparation for the text to be displayed.
     *
     * @private
     * @param {String} anchorText The text of the anchor that is being generated, for which to remove any trailing
     *   slash ('/') that may exist.
     * @return {String} The `anchorText`, with the trailing slash removed.
     */
    function removeTrailingSlash(anchorText) {
        if (anchorText.charAt(anchorText.length - 1) === '/') {
            anchorText = anchorText.slice(0, -1);
        }
        return anchorText;
    }
    /**
     * Decodes percent-encoded characters from the given `anchorText`, in
     * preparation for the text to be displayed.
     *
     * @private
     * @param {String} anchorText The text of the anchor that is being
     *   generated, for which to decode any percent-encoded characters.
     * @return {String} The `anchorText`, with the percent-encoded characters
     *   decoded.
     */
    function removePercentEncoding(anchorText) {
        // First, convert a few of the known % encodings to the corresponding
        // HTML entities that could accidentally be interpretted as special
        // HTML characters
        // NOTE: This used to be written as 5 separate .replace() calls, but that
        //       was 25% slower than the current form below according to jsperf
        var preProcessedEntityAnchorText = anchorText.replace(/%(?:22|26|27|3C|3E)/gi, function (match) {
            if (match === '%22')
                return '&quot;'; // %22: '"' char
            if (match === '%26')
                return '&amp;'; // %26: '&' char
            if (match === '%27')
                return '&#39;'; // %27: "'" char
            if (match === '%3C' || match === '%3c')
                return '&lt;'; // %3C: '<' char
            /*if (match === '%3E' || match === '%3e')*/ return '&gt;'; // %3E: '>' char
        });
        // Now attempt to URL-decode the rest of the anchor text. However,
        // decodeURIComponent() is a slow function. Only call it if we have
        // remaining %-encoded entities. Adding this check added ~300 ops/sec to
        // benchmark
        if (preProcessedEntityAnchorText.includes('%')) {
            try {
                return decodeURIComponent(preProcessedEntityAnchorText);
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
            }
            catch (error) {
                // Invalid % escape sequence in the anchor text, we'll simply return
                // the preProcessedEntityAnchorText below
            }
        }
        return preProcessedEntityAnchorText;
    }

    /**
     * A regular expression to match a 'mailto:' prefix on an email address.
     */
    var mailtoSchemePrefixRe = /^mailto:/i;
    /**
     * Determines if the given character may start the "local part" of an email
     * address. The local part is the part to the left of the '@' sign.
     *
     * Technically according to the email spec, any of the characters in the
     * {@link emailLocalPartCharRegex} can start an email address (including any of
     * the special characters), but this is so rare in the wild and the
     * implementation is much simpler by only starting an email address with a word
     * character. This is especially important when matching the '{' character which
     * generally starts a brace that isn't part of the email address.
     */
    var isEmailLocalPartStartChar = isAlphaNumericOrMarkChar; // alias for clarity
    /**
     * Determines if the given character can be part of the "local part" of an email
     * address. The local part is the part to the left of the '@' sign.
     *
     * Checking for an email address's start char is handled with {@link #isEmailLocalPartStartChar}
     */
    function isEmailLocalPartChar(charCode) {
        return isEmailLocalPartStartChar(charCode) || isValidEmailLocalPartSpecialChar(charCode);
    }
    /**
     * Determines if the given email address is valid. We consider it valid if it
     * has a valid TLD in its host.
     *
     * @param emailAddress email address
     * @return true is email have valid TLD, false otherwise
     */
    function isValidEmail(emailAddress) {
        var emailAddressTld = emailAddress.split('.').pop(); // as long as we have a valid string (as opposed to null or undefined), we will always get at least one element in the .split('.') array
        return isKnownTld(emailAddressTld);
    }

    /**
     * @class Autolinker.match.Email
     * @extends Autolinker.match.AbstractMatch
     *
     * Represents a Email match found in an input string which should be Autolinked.
     *
     * See this class's superclass ({@link Autolinker.match.Match}) for more details.
     */
    var EmailMatch = /** @class */ (function (_super) {
        __extends(EmailMatch, _super);
        /**
         * @method constructor
         * @param {Object} cfg The configuration properties for the Match
         *   instance, specified in an Object (map).
         */
        function EmailMatch(cfg) {
            var _this = _super.call(this, cfg) || this;
            /**
             * @public
             * @property {'email'} type
             *
             * A string name for the type of match that this class represents. Can be
             * used in a TypeScript discriminating union to type-narrow from the
             * `Match` type.
             */
            _this.type = 'email';
            /**
             * @cfg {String} email (required)
             *
             * The email address that was matched.
             */
            _this.email = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
            _this.email = cfg.email;
            return _this;
        }
        /**
         * Returns a string name for the type of match that this class represents.
         * For the case of EmailMatch, returns 'email'.
         *
         * @return {String}
         */
        EmailMatch.prototype.getType = function () {
            return 'email';
        };
        /**
         * Returns the email address that was matched.
         *
         * @return {String}
         */
        EmailMatch.prototype.getEmail = function () {
            return this.email;
        };
        /**
         * Returns the anchor href that should be generated for the match.
         *
         * @return {String}
         */
        EmailMatch.prototype.getAnchorHref = function () {
            return 'mailto:' + this.email;
        };
        /**
         * Returns the anchor text that should be generated for the match.
         *
         * @return {String}
         */
        EmailMatch.prototype.getAnchorText = function () {
            return this.email;
        };
        return EmailMatch;
    }(AbstractMatch));

    /**
     * Determines if the given `char` is a an allowed character in a hashtag. These
     * are underscores or any alphanumeric char.
     */
    function isHashtagTextChar(charCode) {
        return charCode === 95 /* Char.Underscore */ || isAlphaNumericOrMarkChar(charCode);
    }
    /**
     * Determines if a hashtag match is valid.
     */
    function isValidHashtag(hashtag) {
        // Max length of 140 for a hashtag ('#' char + 139 word chars)
        return hashtag.length <= 140;
    }
    var hashtagServices = [
        'twitter',
        'facebook',
        'instagram',
        'tiktok',
        'youtube',
    ];

    /**
     * @class Autolinker.match.Hashtag
     * @extends Autolinker.match.AbstractMatch
     *
     * Represents a Hashtag match found in an input string which should be
     * Autolinked.
     *
     * See this class's superclass ({@link Autolinker.match.Match}) for more
     * details.
     */
    var HashtagMatch = /** @class */ (function (_super) {
        __extends(HashtagMatch, _super);
        /**
         * @method constructor
         * @param {Object} cfg The configuration properties for the Match
         *   instance, specified in an Object (map).
         */
        function HashtagMatch(cfg) {
            var _this = _super.call(this, cfg) || this;
            /**
             * @public
             * @property {'hashtag'} type
             *
             * A string name for the type of match that this class represents. Can be
             * used in a TypeScript discriminating union to type-narrow from the
             * `Match` type.
             */
            _this.type = 'hashtag';
            /**
             * @cfg {String} serviceName
             *
             * The service to point hashtag matches to. See {@link Autolinker#hashtag}
             * for available values.
             */
            _this.serviceName = 'twitter'; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @cfg {String} hashtag (required)
             *
             * The HashtagMatch that was matched, without the '#'.
             */
            _this.hashtag = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
            _this.serviceName = cfg.serviceName;
            _this.hashtag = cfg.hashtag;
            return _this;
        }
        /**
         * Returns a string name for the type of match that this class represents.
         * For the case of HashtagMatch, returns 'hashtag'.
         *
         * @return {String}
         */
        HashtagMatch.prototype.getType = function () {
            return 'hashtag';
        };
        /**
         * Returns the configured {@link #serviceName} to point the HashtagMatch to.
         * Ex: 'facebook', 'twitter'.
         *
         * @return {String}
         */
        HashtagMatch.prototype.getServiceName = function () {
            return this.serviceName;
        };
        /**
         * Returns the matched hashtag, without the '#' character.
         *
         * @return {String}
         */
        HashtagMatch.prototype.getHashtag = function () {
            return this.hashtag;
        };
        /**
         * Returns the anchor href that should be generated for the match.
         *
         * @return {String}
         */
        HashtagMatch.prototype.getAnchorHref = function () {
            var serviceName = this.serviceName, hashtag = this.hashtag;
            switch (serviceName) {
                case 'twitter':
                    return 'https://twitter.com/hashtag/' + hashtag;
                case 'facebook':
                    return 'https://www.facebook.com/hashtag/' + hashtag;
                case 'instagram':
                    return 'https://instagram.com/explore/tags/' + hashtag;
                case 'tiktok':
                    return 'https://www.tiktok.com/tag/' + hashtag;
                case 'youtube':
                    return 'https://youtube.com/hashtag/' + hashtag;
                /* istanbul ignore next */
                default:
                    // Should never happen because Autolinker's constructor should block any invalid values, but just in case
                    assertNever(serviceName);
            }
        };
        /**
         * Returns the anchor text that should be generated for the match.
         *
         * @return {String}
         */
        HashtagMatch.prototype.getAnchorText = function () {
            return '#' + this.hashtag;
        };
        /**
         * Returns the CSS class suffixes that should be used on a tag built with
         * the match. See {@link Autolinker.match.Match#getCssClassSuffixes} for
         * details.
         *
         * @return {String[]}
         */
        HashtagMatch.prototype.getCssClassSuffixes = function () {
            var cssClassSuffixes = _super.prototype.getCssClassSuffixes.call(this), serviceName = this.getServiceName();
            if (serviceName) {
                cssClassSuffixes.push(serviceName);
            }
            return cssClassSuffixes;
        };
        return HashtagMatch;
    }(AbstractMatch));

    var mentionRegexes = {
        twitter: /^@\w{1,15}$/,
        instagram: /^@[_\w]{1,30}$/,
        soundcloud: /^@[-a-z0-9_]{3,25}$/,
        // TikTok usernames are 1-24 characters containing letters, numbers, underscores
        // and periods, but cannot end in a period: https://support.tiktok.com/en/getting-started/setting-up-your-profile/changing-your-username
        tiktok: /^@[.\w]{1,23}[\w]$/,
        // Youtube usernames are 3-30 characters containing letters, numbers, underscores,
        // dashes, or latin middle dots ('·').
        // https://support.google.com/youtube/answer/11585688?hl=en&co=GENIE.Platform%3DAndroid#tns
        youtube: /^@[-.·\w]{3,30}$/,
    };
    /**
     * Determines if the given character can be part of a mention's text characters.
     *
     * Accepts characters that match the RegExp `/[-\w.]/`, which are the possible
     * mention characters for any service.
     *
     * We'll confirm the match based on the user-configured service name after the
     * match is found.
     */
    function isMentionTextChar(charCode) {
        return (charCode === 45 /* Char.Dash */ || // '-'
            charCode === 46 /* Char.Dot */ || // '.'
            charCode === 95 /* Char.Underscore */ || // '_'
            isAsciiLetterChar(charCode) ||
            isDigitChar(charCode));
    }
    /**
     * Determines if the given `mention` text is valid.
     */
    function isValidMention(mention, serviceName) {
        var re = mentionRegexes[serviceName];
        return re.test(mention);
    }
    var mentionServices = [
        'twitter',
        'instagram',
        'soundcloud',
        'tiktok',
        'youtube',
    ];

    /**
     * @class Autolinker.match.Mention
     * @extends Autolinker.match.AbstractMatch
     *
     * Represents a Mention match found in an input string which should be Autolinked.
     *
     * See this class's superclass ({@link Autolinker.match.Match}) for more details.
     */
    var MentionMatch = /** @class */ (function (_super) {
        __extends(MentionMatch, _super);
        /**
         * @method constructor
         * @param {Object} cfg The configuration properties for the Match
         *   instance, specified in an Object (map).
         */
        function MentionMatch(cfg) {
            var _this = _super.call(this, cfg) || this;
            /**
             * @public
             * @property {'mention'} type
             *
             * A string name for the type of match that this class represents. Can be
             * used in a TypeScript discriminating union to type-narrow from the
             * `Match` type.
             */
            _this.type = 'mention';
            /**
             * @cfg {String} serviceName
             *
             * The service to point mention matches to. See {@link Autolinker#mention}
             * for available values.
             */
            _this.serviceName = 'twitter'; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @cfg {String} mention (required)
             *
             * The Mention that was matched, without the '@' character.
             */
            _this.mention = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
            _this.mention = cfg.mention;
            _this.serviceName = cfg.serviceName;
            return _this;
        }
        /**
         * Returns a string name for the type of match that this class represents.
         * For the case of MentionMatch, returns 'mention'.
         *
         * @return {String}
         */
        MentionMatch.prototype.getType = function () {
            return 'mention';
        };
        /**
         * Returns the mention, without the '@' character.
         *
         * @return {String}
         */
        MentionMatch.prototype.getMention = function () {
            return this.mention;
        };
        /**
         * Returns the configured {@link #serviceName} to point the mention to.
         * Ex: 'instagram', 'twitter', 'soundcloud'.
         *
         * @return {String}
         */
        MentionMatch.prototype.getServiceName = function () {
            return this.serviceName;
        };
        /**
         * Returns the anchor href that should be generated for the match.
         *
         * @return {String}
         */
        MentionMatch.prototype.getAnchorHref = function () {
            switch (this.serviceName) {
                case 'twitter':
                    return 'https://twitter.com/' + this.mention;
                case 'instagram':
                    return 'https://instagram.com/' + this.mention;
                case 'soundcloud':
                    return 'https://soundcloud.com/' + this.mention;
                case 'tiktok':
                    return 'https://www.tiktok.com/@' + this.mention;
                case 'youtube':
                    return 'https://youtube.com/@' + this.mention;
                /* istanbul ignore next */
                default:
                    // Should never happen because Autolinker's constructor should block any invalid values, but just in case.
                    assertNever(this.serviceName);
            }
        };
        /**
         * Returns the anchor text that should be generated for the match.
         *
         * @return {String}
         */
        MentionMatch.prototype.getAnchorText = function () {
            return '@' + this.mention;
        };
        /**
         * Returns the CSS class suffixes that should be used on a tag built with
         * the match. See {@link Autolinker.match.Match#getCssClassSuffixes} for
         * details.
         *
         * @return {String[]}
         */
        MentionMatch.prototype.getCssClassSuffixes = function () {
            var cssClassSuffixes = _super.prototype.getCssClassSuffixes.call(this), serviceName = this.getServiceName();
            if (serviceName) {
                cssClassSuffixes.push(serviceName);
            }
            return cssClassSuffixes;
        };
        return MentionMatch;
    }(AbstractMatch));

    // Regex that specifies any delimiter char that allows us to treat the number as
    // a phone number rather than just any other number that could appear in text.
    var hasDelimCharsRe = /[-. ()]/;
    // Over the years, many people have added to this regex, but it should have been
    // split up by country. Maybe one day we can break this down.
    var mostPhoneNumbers = /(?:(?:(?:(\+)?\d{1,3}[-. ]?)?\(?\d{3}\)?[-. ]?\d{3}[-. ]?\d{4})|(?:(\+)(?:9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)[-. ]?(?:\d[-. ]?){6,12}\d+))([,;]+[0-9]+#?)*/;
    // Regex for Japanese phone numbers
    var japanesePhoneRe = /(0([1-9]-?[1-9]\d{3}|[1-9]{2}-?\d{3}|[1-9]{2}\d{1}-?\d{2}|[1-9]{2}\d{2}-?\d{1})-?\d{4}|0[789]0-?\d{4}-?\d{4}|050-?\d{4}-?\d{4})/;
    // Combined regex
    var validPhoneNumberRe = new RegExp("^".concat(mostPhoneNumbers.source, "|").concat(japanesePhoneRe.source, "$"));
    /**
     * Determines if the character is a phone number separator character (i.e.
     * '-', '.', or ' ' (space))
     */
    function isPhoneNumberSeparatorChar(charCode) {
        return (charCode === 45 /* Char.Dash */ || // '-'
            charCode === 46 /* Char.Dot */ || // '.'
            charCode === 32 /* Char.Space */ // ' '
        );
    }
    /**
     * Determines if the character is a control character in a phone number. Control
     * characters are as follows:
     *
     * - ',': A 1 second pause. Useful for dialing extensions once the main phone number has been reached
     * - ';': A "wait" that waits for the user to take action (tap something, for instance on a smart phone)
     */
    function isPhoneNumberControlChar(charCode) {
        return (charCode === 44 /* Char.Comma */ || // ','
            charCode === 59 /* Char.SemiColon */ // ';'
        );
    }
    /**
     * Determines if the given phone number text found in a string is a valid phone
     * number.
     *
     * Our state machine parser is simplified to grab anything that looks like a
     * phone number, and this function confirms the match.
     */
    function isValidPhoneNumber(phoneNumberText) {
        // We'll only consider the match as a phone number if there is some kind of
        // delimiter character (a prefixed '+' sign, or separator chars).
        //
        // Accepts:
        //     (123) 456-7890
        //     +38755233976
        // Does not accept:
        //     1234567890  (no delimiter chars - may just be a random number that's not a phone number)
        var hasDelimiters = phoneNumberText.charAt(0) === '+' || hasDelimCharsRe.test(phoneNumberText);
        return hasDelimiters && validPhoneNumberRe.test(phoneNumberText);
    }

    /**
     * @class Autolinker.match.Phone
     * @extends Autolinker.match.AbstractMatch
     *
     * Represents a Phone number match found in an input string which should be
     * Autolinked.
     *
     * See this class's superclass ({@link Autolinker.match.Match}) for more
     * details.
     */
    var PhoneMatch = /** @class */ (function (_super) {
        __extends(PhoneMatch, _super);
        /**
         * @method constructor
         * @param {Object} cfg The configuration properties for the Match
         *   instance, specified in an Object (map).
         */
        function PhoneMatch(cfg) {
            var _this = _super.call(this, cfg) || this;
            /**
             * @public
             * @property {'phone'} type
             *
             * A string name for the type of match that this class represents. Can be
             * used in a TypeScript discriminating union to type-narrow from the
             * `Match` type.
             */
            _this.type = 'phone';
            /**
             * @protected
             * @property {String} number (required)
             *
             * The phone number that was matched, without any delimiter characters.
             *
             * Note: This is a string to allow for prefixed 0's.
             */
            _this.number = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @protected
             * @property  {Boolean} plusSign (required)
             *
             * `true` if the matched phone number started with a '+' sign. We'll include
             * it in the `tel:` URL if so, as this is needed for international numbers.
             *
             * Ex: '+1 (123) 456 7879'
             */
            _this.plusSign = false; // default value just to get the above doc comment in the ES5 output and documentation generator
            _this.number = cfg.number;
            _this.plusSign = cfg.plusSign;
            return _this;
        }
        /**
         * Returns a string name for the type of match that this class represents.
         * For the case of PhoneMatch, returns 'phone'.
         *
         * @return {String}
         */
        PhoneMatch.prototype.getType = function () {
            return 'phone';
        };
        /**
         * Returns the phone number that was matched as a string, without any
         * delimiter characters.
         *
         * Note: This is a string to allow for prefixed 0's.
         *
         * @return {String}
         */
        PhoneMatch.prototype.getPhoneNumber = function () {
            return this.number;
        };
        /**
         * Alias of {@link #getPhoneNumber}, returns the phone number that was
         * matched as a string, without any delimiter characters.
         *
         * Note: This is a string to allow for prefixed 0's.
         *
         * @return {String}
         */
        PhoneMatch.prototype.getNumber = function () {
            return this.getPhoneNumber();
        };
        /**
         * Returns the anchor href that should be generated for the match.
         *
         * @return {String}
         */
        PhoneMatch.prototype.getAnchorHref = function () {
            return 'tel:' + (this.plusSign ? '+' : '') + this.number;
        };
        /**
         * Returns the anchor text that should be generated for the match.
         *
         * @return {String}
         */
        PhoneMatch.prototype.getAnchorText = function () {
            return this.matchedText;
        };
        return PhoneMatch;
    }(AbstractMatch));

    // For debugging: search for and uncomment other "For debugging" lines
    // import CliTable from 'cli-table';
    /**
     * Context object containing all the state needed by the state machine functions.
     *
     * ## Historical note
     *
     * In v4.1.1, we used nested functions to handle the context via closures, but
     * this necessitated re-creating the functions for each call to `parseMatches()`,
     * which made them difficult for v8 to JIT optimize. In v4.1.2, we lifted all of
     * the functions to the top-level scope and passed the context object between
     * them, which allows the functions to be JIT compiled once and reused.
     */
    var ParseMatchesContext = /** @class */ (function () {
        function ParseMatchesContext(text, args) {
            this.charIdx = 0; // Current character index being processed
            this.matches = []; // Collection of matches found
            this._stateMachines = []; // Array of active state machines
            this.schemeUrlMachinesCount = 0; // part of an optimization to remove the need to go into a slow code block when unnecessary. Since it's been so long since the initial implementation, not sure that this can ever go above 1, but keeping it as a counter to be safe
            this.text = text;
            this.tagBuilder = args.tagBuilder;
            this.stripPrefix = args.stripPrefix;
            this.stripTrailingSlash = args.stripTrailingSlash;
            this.decodePercentEncoding = args.decodePercentEncoding;
            this.hashtagServiceName = args.hashtagServiceName;
            this.mentionServiceName = args.mentionServiceName;
        }
        Object.defineProperty(ParseMatchesContext.prototype, "stateMachines", {
            get: function () {
                return this._stateMachines;
            },
            enumerable: false,
            configurable: true
        });
        ParseMatchesContext.prototype.addMachine = function (stateMachine) {
            this._stateMachines.push(stateMachine);
            if (isSchemeUrlStateMachine(stateMachine)) {
                this.schemeUrlMachinesCount++;
            }
        };
        ParseMatchesContext.prototype.removeMachine = function (stateMachine) {
            // Performance note: this was originally implemented with Array.prototype.splice()
            // and mutated the array in place. Switching to filter added ~280ops/sec
            // on the benchmark, although likely at the expense of GC time. Perhaps
            // in the future, we implement a rotating array so we never need to move
            // or clean anything up
            this._stateMachines = this._stateMachines.filter(function (m) { return m !== stateMachine; });
            // If we've removed the URL state machine, set the flag to false.
            // This flag is a quick test that helps us skip a slow section of
            // code when there is already a URL state machine present.
            if (isSchemeUrlStateMachine(stateMachine)) {
                this.schemeUrlMachinesCount--;
            }
        };
        ParseMatchesContext.prototype.hasSchemeUrlMachine = function () {
            return this.schemeUrlMachinesCount > 0;
        };
        return ParseMatchesContext;
    }());
    /**
     * Parses URL, email, twitter, mention, and hashtag matches from the given
     * `text`.
     */
    function parseMatches(text, args) {
        // Create the context object that will be passed to all state functions
        var context = new ParseMatchesContext(text, args);
        // For debugging: search for and uncomment other "For debugging" lines
        // const table = new CliTable({
        //     head: ['charIdx', 'char', 'code', 'type', 'states', 'startIdx', 'reached accept state'],
        // });
        for (; context.charIdx < context.text.length; context.charIdx++) {
            var char = text.charAt(context.charIdx);
            var charCode = text.charCodeAt(context.charIdx);
            if (context.stateMachines.length === 0) {
                stateNoMatch(context, char, charCode);
            }
            else {
                // Must loop through the state machines backwards for when one
                // is removed
                for (var stateIdx = context.stateMachines.length - 1; stateIdx >= 0; stateIdx--) {
                    var stateMachine = context.stateMachines[stateIdx];
                    switch (stateMachine.state) {
                        // Protocol-relative URL states
                        case 11 /* State.ProtocolRelativeSlash1 */:
                            stateProtocolRelativeSlash1(context, stateMachine, charCode);
                            break;
                        case 12 /* State.ProtocolRelativeSlash2 */:
                            stateProtocolRelativeSlash2(context, stateMachine, charCode);
                            break;
                        case 0 /* State.SchemeChar */:
                            stateSchemeChar(context, stateMachine, charCode);
                            break;
                        case 1 /* State.SchemeHyphen */:
                            stateSchemeHyphen(context, stateMachine, charCode);
                            break;
                        case 2 /* State.SchemeColon */:
                            stateSchemeColon(context, stateMachine, charCode);
                            break;
                        case 3 /* State.SchemeSlash1 */:
                            stateSchemeSlash1(context, stateMachine, charCode);
                            break;
                        case 4 /* State.SchemeSlash2 */:
                            stateSchemeSlash2(context, stateMachine, char, charCode);
                            break;
                        case 5 /* State.DomainLabelChar */:
                            stateDomainLabelChar(context, stateMachine, charCode);
                            break;
                        case 6 /* State.DomainHyphen */:
                            stateDomainHyphen(context, stateMachine, char, charCode);
                            break;
                        case 7 /* State.DomainDot */:
                            stateDomainDot(context, stateMachine, char, charCode);
                            break;
                        case 13 /* State.IpV4Digit */:
                            stateIpV4Digit(context, stateMachine, charCode);
                            break;
                        case 14 /* State.IpV4Dot */:
                            stateIpV4Dot(context, stateMachine, charCode);
                            break;
                        case 8 /* State.PortColon */:
                            statePortColon(context, stateMachine, charCode);
                            break;
                        case 9 /* State.PortNumber */:
                            statePortNumber(context, stateMachine, charCode);
                            break;
                        case 10 /* State.Path */:
                            statePath(context, stateMachine, charCode);
                            break;
                        // Email States
                        case 15 /* State.EmailMailto_M */:
                            stateEmailMailto_M(context, stateMachine, char, charCode);
                            break;
                        case 16 /* State.EmailMailto_A */:
                            stateEmailMailto_A(context, stateMachine, char, charCode);
                            break;
                        case 17 /* State.EmailMailto_I */:
                            stateEmailMailto_I(context, stateMachine, char, charCode);
                            break;
                        case 18 /* State.EmailMailto_L */:
                            stateEmailMailto_L(context, stateMachine, char, charCode);
                            break;
                        case 19 /* State.EmailMailto_T */:
                            stateEmailMailto_T(context, stateMachine, char, charCode);
                            break;
                        case 20 /* State.EmailMailto_O */:
                            stateEmailMailto_O(context, stateMachine, charCode);
                            break;
                        case 21 /* State.EmailMailto_Colon */:
                            stateEmailMailtoColon(context, stateMachine, charCode);
                            break;
                        case 22 /* State.EmailLocalPart */:
                            stateEmailLocalPart(context, stateMachine, charCode);
                            break;
                        case 23 /* State.EmailLocalPartDot */:
                            stateEmailLocalPartDot(context, stateMachine, charCode);
                            break;
                        case 24 /* State.EmailAtSign */:
                            stateEmailAtSign(context, stateMachine, charCode);
                            break;
                        case 25 /* State.EmailDomainChar */:
                            stateEmailDomainChar(context, stateMachine, charCode);
                            break;
                        case 26 /* State.EmailDomainHyphen */:
                            stateEmailDomainHyphen(context, stateMachine, charCode);
                            break;
                        case 27 /* State.EmailDomainDot */:
                            stateEmailDomainDot(context, stateMachine, charCode);
                            break;
                        // Hashtag states
                        case 28 /* State.HashtagHashChar */:
                            stateHashtagHashChar(context, stateMachine, charCode);
                            break;
                        case 29 /* State.HashtagTextChar */:
                            stateHashtagTextChar(context, stateMachine, charCode);
                            break;
                        // Mention states
                        case 30 /* State.MentionAtChar */:
                            stateMentionAtChar(context, stateMachine, charCode);
                            break;
                        case 31 /* State.MentionTextChar */:
                            stateMentionTextChar(context, stateMachine, charCode);
                            break;
                        // Phone number states
                        case 32 /* State.PhoneNumberOpenParen */:
                            statePhoneNumberOpenParen(context, stateMachine, char, charCode);
                            break;
                        case 33 /* State.PhoneNumberAreaCodeDigit1 */:
                            statePhoneNumberAreaCodeDigit1(context, stateMachine, charCode);
                            break;
                        case 34 /* State.PhoneNumberAreaCodeDigit2 */:
                            statePhoneNumberAreaCodeDigit2(context, stateMachine, charCode);
                            break;
                        case 35 /* State.PhoneNumberAreaCodeDigit3 */:
                            statePhoneNumberAreaCodeDigit3(context, stateMachine, charCode);
                            break;
                        case 36 /* State.PhoneNumberCloseParen */:
                            statePhoneNumberCloseParen(context, stateMachine, char, charCode);
                            break;
                        case 37 /* State.PhoneNumberPlus */:
                            statePhoneNumberPlus(context, stateMachine, char, charCode);
                            break;
                        case 38 /* State.PhoneNumberDigit */:
                            statePhoneNumberDigit(context, stateMachine, char, charCode);
                            break;
                        case 39 /* State.PhoneNumberSeparator */:
                            statePhoneNumberSeparator(context, stateMachine, char, charCode);
                            break;
                        case 40 /* State.PhoneNumberControlChar */:
                            statePhoneNumberControlChar(context, stateMachine, charCode);
                            break;
                        case 41 /* State.PhoneNumberPoundChar */:
                            statePhoneNumberPoundChar(context, stateMachine, charCode);
                            break;
                        /* istanbul ignore next */
                        default:
                            assertNever(stateMachine.state);
                    }
                }
                // Special case for handling a colon (or other non-alphanumeric)
                // when preceded by another character, such as in the text:
                //     Link 1:http://google.com
                // In this case, the 'h' character after the colon wouldn't start a
                // new scheme url because we'd be in a ipv4 or tld url and the colon
                // would be interpreted as a port ':' char. Also, only start a new
                // scheme url machine if there isn't currently one so we don't start
                // new ones for colons inside a url
                //
                // TODO: The addition of this snippet (to fix the bug) in 4.0.1 lost
                // us ~500 ops/sec on the benchmarks. Optimizing it with the
                // hasSchemeUrlMachine() flag and optimizing the isSchemeStartChar()
                // method for 4.1.3 got us back about ~400ops/sec. One potential way
                // to improve this even ore is to add this snippet to individual
                // state handler functions where it can occur to prevent running it
                // on every loop interation.
                if (!context.hasSchemeUrlMachine() &&
                    context.charIdx > 0 &&
                    isSchemeStartChar(charCode)) {
                    var prevCharCode = context.text.charCodeAt(context.charIdx - 1);
                    if (!isSchemeStartChar(prevCharCode)) {
                        context.addMachine(createSchemeUrlStateMachine(context.charIdx, 0 /* State.SchemeChar */));
                    }
                }
            }
            // For debugging: search for and uncomment other "For debugging" lines
            // table.push([
            //     String(context.charIdx),
            //     char,
            //     `10: ${char.charCodeAt(0)}\n0x: ${char.charCodeAt(0).toString(16)}\nU+${char.codePointAt(0)}`,
            //     context.stateMachines.map(machine => `${StateMachineType[machine.type]}${'matchType' in machine ? ` (${UrlStateMachineMatchType[machine.matchType]})` : ''}`).join('\n') || '(none)',
            //     context.stateMachines.map(machine => State[machine.state]).join('\n') || '(none)',
            //     context.stateMachines.map(m => m.startIdx).join('\n'),
            //     context.stateMachines.map(m => m.acceptStateReached).join('\n'),
            // ]);
        }
        // Capture any valid match at the end of the string
        // Note: this loop must happen in reverse because
        // captureMatchIfValidAndRemove() removes state machines from the array
        // and we'll end up skipping every other one if we remove while looping
        // forward
        for (var i = context.stateMachines.length - 1; i >= 0; i--) {
            context.stateMachines.forEach(function (stateMachine) {
                return captureMatchIfValidAndRemove(context, stateMachine);
            });
        }
        // For debugging: search for and uncomment other "For debugging" lines
        // console.log(`\nRead string:\n  ${text}`);
        // console.log(table.toString());
        return context.matches;
    }
    /**
     * Handles the state when we're not in a URL/email/etc. (i.e. when no state machines exist)
     */
    function stateNoMatch(context, char, charCode) {
        var charIdx = context.charIdx;
        if (charCode === 35 /* Char.NumberSign */ /* '#' */) {
            // Hash char, start a Hashtag match
            context.addMachine(createHashtagStateMachine(charIdx, 28 /* State.HashtagHashChar */));
        }
        else if (charCode === 64 /* Char.AtSign */ /* '@' */) {
            // '@' char, start a Mention match
            context.addMachine(createMentionStateMachine(charIdx, 30 /* State.MentionAtChar */));
        }
        else if (charCode === 47 /* Char.Slash */ /* '/' */) {
            // A slash could begin a protocol-relative URL
            context.addMachine(createTldUrlStateMachine(charIdx, 11 /* State.ProtocolRelativeSlash1 */));
        }
        else if (charCode === 43 /* Char.Plus */ /* '+' */) {
            // A '+' char can start a Phone number
            context.addMachine(createPhoneNumberStateMachine(charIdx, 37 /* State.PhoneNumberPlus */));
        }
        else if (charCode === 40 /* Char.OpenParen */ /* '(' */) {
            context.addMachine(createPhoneNumberStateMachine(charIdx, 32 /* State.PhoneNumberOpenParen */));
        }
        else {
            if (isDigitChar(charCode)) {
                // A digit could start a phone number
                context.addMachine(createPhoneNumberStateMachine(charIdx, 38 /* State.PhoneNumberDigit */));
                // A digit could start an IP address
                context.addMachine(createIpV4UrlStateMachine(charIdx, 13 /* State.IpV4Digit */));
            }
            if (isEmailLocalPartStartChar(charCode)) {
                // Any email local part. An 'm' character in particular could
                // start a 'mailto:' match
                var startState = char.toLowerCase() === 'm' ? 15 /* State.EmailMailto_M */ : 22 /* State.EmailLocalPart */;
                context.addMachine(createEmailStateMachine(charIdx, startState));
            }
            if (isSchemeStartChar(charCode)) {
                // An uppercase or lowercase letter may start a scheme match
                context.addMachine(createSchemeUrlStateMachine(charIdx, 0 /* State.SchemeChar */));
            }
            if (isAlphaNumericOrMarkChar(charCode)) {
                // A unicode alpha character or digit could start a domain name
                // label for a TLD match
                context.addMachine(createTldUrlStateMachine(charIdx, 5 /* State.DomainLabelChar */));
            }
        }
        // Anything else, remain in the "non-url" state by not creating any
        // state machines
    }
    // Implements ABNF: ALPHA *( ALPHA / DIGIT / "+" / "-" / "." )
    function stateSchemeChar(context, stateMachine, charCode) {
        if (charCode === 58 /* Char.Colon */ /* ':' */) {
            stateMachine.state = 2 /* State.SchemeColon */;
        }
        else if (charCode === 45 /* Char.Dash */ /* '-' */) {
            stateMachine.state = 1 /* State.SchemeHyphen */;
        }
        else if (isSchemeChar(charCode)) ;
        else {
            // Any other character, not a scheme
            context.removeMachine(stateMachine);
        }
    }
    function stateSchemeHyphen(context, stateMachine, charCode) {
        var charIdx = context.charIdx;
        if (charCode === 45 /* Char.Dash */ /* '-' */) ;
        else if (charCode === 47 /* Char.Slash */ /* '/' */) {
            // Not a valid scheme match, but may be the start of a
            // protocol-relative match (such as //google.com)
            context.removeMachine(stateMachine);
            context.addMachine(createTldUrlStateMachine(charIdx, 11 /* State.ProtocolRelativeSlash1 */));
        }
        else if (isSchemeChar(charCode)) {
            stateMachine.state = 0 /* State.SchemeChar */;
        }
        else {
            // Any other character, not a scheme
            context.removeMachine(stateMachine);
        }
    }
    // https://tools.ietf.org/html/rfc3986#appendix-A
    function stateSchemeColon(context, stateMachine, charCode) {
        var charIdx = context.charIdx;
        if (charCode === 47 /* Char.Slash */ /* '/' */) {
            stateMachine.state = 3 /* State.SchemeSlash1 */;
        }
        else if (charCode === 46 /* Char.Dot */ /* '.' */) {
            // We've read something like 'hello:.' - don't capture
            context.removeMachine(stateMachine);
        }
        else if (isDomainLabelStartChar(charCode)) {
            stateMachine.state = 5 /* State.DomainLabelChar */;
            // It's possible that we read an "introduction" piece of text,
            // and the character after the current colon actually starts an
            // actual scheme. An example of this is:
            //     "The link:http://google.com"
            // Hence, start a new machine to capture this match if so
            if (isSchemeStartChar(charCode)) {
                context.addMachine(createSchemeUrlStateMachine(charIdx, 0 /* State.SchemeChar */));
            }
        }
        else {
            context.removeMachine(stateMachine);
        }
    }
    // https://tools.ietf.org/html/rfc3986#appendix-A
    function stateSchemeSlash1(context, stateMachine, charCode) {
        if (charCode === 47 /* Char.Slash */ /* '/' */) {
            stateMachine.state = 4 /* State.SchemeSlash2 */;
        }
        else if (isPathChar(charCode)) {
            stateMachine.state = 10 /* State.Path */;
            stateMachine.acceptStateReached = true;
        }
        else {
            captureMatchIfValidAndRemove(context, stateMachine);
        }
    }
    function stateSchemeSlash2(context, stateMachine, char, charCode) {
        if (charCode === 47 /* Char.Slash */ /* '/' */) {
            // 3rd slash, must be an absolute path (`path-absolute` in the
            // ABNF), such as in "file:///c:/windows/etc". See
            // https://tools.ietf.org/html/rfc3986#appendix-A
            stateMachine.state = 10 /* State.Path */;
            stateMachine.acceptStateReached = true;
        }
        else if (isDomainLabelStartChar(charCode)) {
            // start of "authority" section - see https://tools.ietf.org/html/rfc3986#appendix-A
            stateMachine.state = 5 /* State.DomainLabelChar */;
            stateMachine.acceptStateReached = true;
        }
        else {
            // not valid
            context.removeMachine(stateMachine);
        }
    }
    // Handles after we've read a '/' from the NonUrl state
    function stateProtocolRelativeSlash1(context, stateMachine, charCode) {
        if (charCode === 47 /* Char.Slash */ /* '/' */) {
            stateMachine.state = 12 /* State.ProtocolRelativeSlash2 */;
        }
        else {
            // Anything else, cannot be the start of a protocol-relative
            // URL.
            context.removeMachine(stateMachine);
        }
    }
    // Handles after we've read a second '/', which could start a protocol-relative URL
    function stateProtocolRelativeSlash2(context, stateMachine, charCode) {
        if (isDomainLabelStartChar(charCode)) {
            stateMachine.state = 5 /* State.DomainLabelChar */;
        }
        else {
            // Anything else, not a URL
            context.removeMachine(stateMachine);
        }
    }
    // Handles when we have read a domain label character
    function stateDomainLabelChar(context, stateMachine, charCode) {
        if (charCode === 46 /* Char.Dot */ /* '.' */) {
            stateMachine.state = 7 /* State.DomainDot */;
        }
        else if (charCode === 45 /* Char.Dash */ /* '-' */) {
            stateMachine.state = 6 /* State.DomainHyphen */;
        }
        else if (charCode === 58 /* Char.Colon */ /* ':' */) {
            // Beginning of a port number, end the domain name
            stateMachine.state = 8 /* State.PortColon */;
        }
        else if (isUrlSuffixStartChar(charCode)) {
            // '/', '?', or '#'
            stateMachine.state = 10 /* State.Path */;
        }
        else if (isDomainLabelChar(charCode)) ;
        else {
            // Anything else, end the domain name
            captureMatchIfValidAndRemove(context, stateMachine);
        }
    }
    function stateDomainHyphen(context, stateMachine, char, charCode) {
        if (charCode === 45 /* Char.Dash */ /* '-' */) ;
        else if (charCode === 46 /* Char.Dot */ /* '.' */) {
            // Not valid to have a '-.' in a domain label
            captureMatchIfValidAndRemove(context, stateMachine);
        }
        else if (isDomainLabelStartChar(charCode)) {
            stateMachine.state = 5 /* State.DomainLabelChar */;
        }
        else {
            captureMatchIfValidAndRemove(context, stateMachine);
        }
    }
    function stateDomainDot(context, stateMachine, char, charCode) {
        if (charCode === 46 /* Char.Dot */ /* '.' */) {
            // domain names cannot have multiple '.'s next to each other.
            // It's possible we've already read a valid domain name though,
            // and that the '..' sequence just forms an ellipsis at the end
            // of a sentence
            captureMatchIfValidAndRemove(context, stateMachine);
        }
        else if (isDomainLabelStartChar(charCode)) {
            stateMachine.state = 5 /* State.DomainLabelChar */;
            stateMachine.acceptStateReached = true; // after hitting a dot, and then another domain label, we've reached an accept state
        }
        else {
            // Anything else, end the domain name
            captureMatchIfValidAndRemove(context, stateMachine);
        }
    }
    function stateIpV4Digit(context, stateMachine, charCode) {
        if (charCode === 46 /* Char.Dot */ /* '.' */) {
            stateMachine.state = 14 /* State.IpV4Dot */;
        }
        else if (charCode === 58 /* Char.Colon */ /* ':' */) {
            // Beginning of a port number
            stateMachine.state = 8 /* State.PortColon */;
        }
        else if (isDigitChar(charCode)) ;
        else if (isUrlSuffixStartChar(charCode)) {
            stateMachine.state = 10 /* State.Path */;
        }
        else if (isAlphaNumericOrMarkChar(charCode)) {
            // If we hit an alpha character, must not be an IPv4
            // Example of this: 1.2.3.4abc
            context.removeMachine(stateMachine);
        }
        else {
            captureMatchIfValidAndRemove(context, stateMachine);
        }
    }
    function stateIpV4Dot(context, stateMachine, charCode) {
        if (isDigitChar(charCode)) {
            stateMachine.octetsEncountered++;
            // Once we have encountered 4 octets, it's *potentially* a valid
            // IPv4 address. Our IPv4 regex will confirm the match later
            // though to make sure each octet is in the 0-255 range, and
            // there's exactly 4 octets (not 5 or more)
            if (stateMachine.octetsEncountered === 4) {
                stateMachine.acceptStateReached = true;
            }
            stateMachine.state = 13 /* State.IpV4Digit */;
        }
        else {
            captureMatchIfValidAndRemove(context, stateMachine);
        }
    }
    function statePortColon(context, stateMachine, charCode) {
        if (isDigitChar(charCode)) {
            stateMachine.state = 9 /* State.PortNumber */;
        }
        else {
            captureMatchIfValidAndRemove(context, stateMachine);
        }
    }
    function statePortNumber(context, stateMachine, charCode) {
        if (isDigitChar(charCode)) ;
        else if (isUrlSuffixStartChar(charCode)) {
            // '/', '?', or '#'
            stateMachine.state = 10 /* State.Path */;
        }
        else {
            captureMatchIfValidAndRemove(context, stateMachine);
        }
    }
    function statePath(context, stateMachine, charCode) {
        if (isPathChar(charCode)) ;
        else {
            captureMatchIfValidAndRemove(context, stateMachine);
        }
    }
    // Handles if we're reading a 'mailto:' prefix on the string
    function stateEmailMailto_M(context, stateMachine, char, charCode) {
        if (char.toLowerCase() === 'a') {
            stateMachine.state = 16 /* State.EmailMailto_A */;
        }
        else {
            stateEmailLocalPart(context, stateMachine, charCode);
        }
    }
    function stateEmailMailto_A(context, stateMachine, char, charCode) {
        if (char.toLowerCase() === 'i') {
            stateMachine.state = 17 /* State.EmailMailto_I */;
        }
        else {
            stateEmailLocalPart(context, stateMachine, charCode);
        }
    }
    function stateEmailMailto_I(context, stateMachine, char, charCode) {
        if (char.toLowerCase() === 'l') {
            stateMachine.state = 18 /* State.EmailMailto_L */;
        }
        else {
            stateEmailLocalPart(context, stateMachine, charCode);
        }
    }
    function stateEmailMailto_L(context, stateMachine, char, charCode) {
        if (char.toLowerCase() === 't') {
            stateMachine.state = 19 /* State.EmailMailto_T */;
        }
        else {
            stateEmailLocalPart(context, stateMachine, charCode);
        }
    }
    function stateEmailMailto_T(context, stateMachine, char, charCode) {
        if (char.toLowerCase() === 'o') {
            stateMachine.state = 20 /* State.EmailMailto_O */;
        }
        else {
            stateEmailLocalPart(context, stateMachine, charCode);
        }
    }
    function stateEmailMailto_O(context, stateMachine, charCode) {
        if (charCode === 58 /* Char.Colon */ /* ':' */) {
            stateMachine.state = 21 /* State.EmailMailto_Colon */;
        }
        else {
            stateEmailLocalPart(context, stateMachine, charCode);
        }
    }
    function stateEmailMailtoColon(context, stateMachine, charCode) {
        if (isEmailLocalPartChar(charCode)) {
            stateMachine.state = 22 /* State.EmailLocalPart */;
        }
        else {
            context.removeMachine(stateMachine);
        }
    }
    // Handles the state when we're currently in the "local part" of an
    // email address (as opposed to the "domain part")
    function stateEmailLocalPart(context, stateMachine, charCode) {
        if (charCode === 46 /* Char.Dot */ /* '.' */) {
            stateMachine.state = 23 /* State.EmailLocalPartDot */;
        }
        else if (charCode === 64 /* Char.AtSign */ /* '@' */) {
            stateMachine.state = 24 /* State.EmailAtSign */;
        }
        else if (isEmailLocalPartChar(charCode)) {
            // stay in the "local part" of the email address
            // Note: because stateEmailLocalPart() is called from the
            // 'mailto' states (when the 'mailto' prefix itself has been
            // broken), make sure to set the state to EmailLocalPart
            stateMachine.state = 22 /* State.EmailLocalPart */;
        }
        else {
            // not an email address character
            context.removeMachine(stateMachine);
        }
    }
    // Handles the state where we've read a '.' character in the local part of
    // the email address (i.e. the part before the '@' character)
    function stateEmailLocalPartDot(context, stateMachine, charCode) {
        if (charCode === 46 /* Char.Dot */ /* '.' */) {
            // We read a second '.' in a row, not a valid email address
            // local part
            context.removeMachine(stateMachine);
        }
        else if (charCode === 64 /* Char.AtSign */ /* '@' */) {
            // We read the '@' character immediately after a dot ('.'), not
            // an email address
            context.removeMachine(stateMachine);
        }
        else if (isEmailLocalPartChar(charCode)) {
            stateMachine.state = 22 /* State.EmailLocalPart */;
        }
        else {
            // Anything else, not an email address
            context.removeMachine(stateMachine);
        }
    }
    function stateEmailAtSign(context, stateMachine, charCode) {
        if (isDomainLabelStartChar(charCode)) {
            stateMachine.state = 25 /* State.EmailDomainChar */;
        }
        else {
            // Anything else, not an email address
            context.removeMachine(stateMachine);
        }
    }
    function stateEmailDomainChar(context, stateMachine, charCode) {
        if (charCode === 46 /* Char.Dot */ /* '.' */) {
            stateMachine.state = 27 /* State.EmailDomainDot */;
        }
        else if (charCode === 45 /* Char.Dash */ /* '-' */) {
            stateMachine.state = 26 /* State.EmailDomainHyphen */;
        }
        else if (isDomainLabelChar(charCode)) ;
        else {
            // Anything else, we potentially matched if the criteria has
            // been met
            captureMatchIfValidAndRemove(context, stateMachine);
        }
    }
    function stateEmailDomainHyphen(context, stateMachine, charCode) {
        if (charCode === 45 /* Char.Dash */ /* '-' */ || charCode === 46 /* Char.Dot */ /* '.' */) {
            // Not valid to have two hyphens ("--") or hypen+dot ("-.")
            captureMatchIfValidAndRemove(context, stateMachine);
        }
        else if (isDomainLabelChar(charCode)) {
            stateMachine.state = 25 /* State.EmailDomainChar */;
        }
        else {
            // Anything else
            captureMatchIfValidAndRemove(context, stateMachine);
        }
    }
    function stateEmailDomainDot(context, stateMachine, charCode) {
        if (charCode === 46 /* Char.Dot */ /* '.' */ || charCode === 45 /* Char.Dash */ /* '-' */) {
            // not valid to have two dots ("..") or dot+hypen (".-")
            captureMatchIfValidAndRemove(context, stateMachine);
        }
        else if (isDomainLabelStartChar(charCode)) {
            stateMachine.state = 25 /* State.EmailDomainChar */;
            // After having read a '.' and then a valid domain character,
            // we now know that the domain part of the email is valid, and
            // we have found at least a partial EmailMatch (however, the
            // email address may have additional characters from this point)
            stateMachine.acceptStateReached = true;
        }
        else {
            // Anything else
            captureMatchIfValidAndRemove(context, stateMachine);
        }
    }
    // Handles the state when we've just encountered a '#' character
    function stateHashtagHashChar(context, stateMachine, charCode) {
        if (isHashtagTextChar(charCode)) {
            // '#' char with valid hash text char following
            stateMachine.state = 29 /* State.HashtagTextChar */;
            stateMachine.acceptStateReached = true;
        }
        else {
            context.removeMachine(stateMachine);
        }
    }
    // Handles the state when we're currently in the hash tag's text chars
    function stateHashtagTextChar(context, stateMachine, charCode) {
        if (isHashtagTextChar(charCode)) ;
        else {
            captureMatchIfValidAndRemove(context, stateMachine);
        }
    }
    // Handles the state when we've just encountered a '@' character
    function stateMentionAtChar(context, stateMachine, charCode) {
        if (isMentionTextChar(charCode)) {
            // '@' char with valid mention text char following
            stateMachine.state = 31 /* State.MentionTextChar */;
            stateMachine.acceptStateReached = true;
        }
        else {
            context.removeMachine(stateMachine);
        }
    }
    // Handles the state when we're currently in the mention's text chars
    function stateMentionTextChar(context, stateMachine, charCode) {
        if (isMentionTextChar(charCode)) ;
        else if (isAlphaNumericOrMarkChar(charCode)) {
            // Char is invalid for a mention text char, not a valid match.
            // Note that ascii alphanumeric chars are okay (which are tested
            // in the previous 'if' statement, but others are not)
            context.removeMachine(stateMachine);
        }
        else {
            captureMatchIfValidAndRemove(context, stateMachine);
        }
    }
    function statePhoneNumberPlus(context, stateMachine, char, charCode) {
        if (isDigitChar(charCode)) {
            stateMachine.state = 38 /* State.PhoneNumberDigit */;
        }
        else {
            context.removeMachine(stateMachine);
            // This character may start a new match. Add states for it
            stateNoMatch(context, char, charCode);
        }
    }
    function statePhoneNumberOpenParen(context, stateMachine, char, charCode) {
        if (isDigitChar(charCode)) {
            stateMachine.state = 33 /* State.PhoneNumberAreaCodeDigit1 */;
        }
        else {
            context.removeMachine(stateMachine);
        }
        // It's also possible that the paren was just an open brace for
        // a piece of text. Start other machines
        stateNoMatch(context, char, charCode);
    }
    function statePhoneNumberAreaCodeDigit1(context, stateMachine, charCode) {
        if (isDigitChar(charCode)) {
            stateMachine.state = 34 /* State.PhoneNumberAreaCodeDigit2 */;
        }
        else {
            context.removeMachine(stateMachine);
        }
    }
    function statePhoneNumberAreaCodeDigit2(context, stateMachine, charCode) {
        if (isDigitChar(charCode)) {
            stateMachine.state = 35 /* State.PhoneNumberAreaCodeDigit3 */;
        }
        else {
            context.removeMachine(stateMachine);
        }
    }
    function statePhoneNumberAreaCodeDigit3(context, stateMachine, charCode) {
        if (charCode === 41 /* Char.CloseParen */ /* ')' */) {
            stateMachine.state = 36 /* State.PhoneNumberCloseParen */;
        }
        else {
            context.removeMachine(stateMachine);
        }
    }
    function statePhoneNumberCloseParen(context, stateMachine, char, charCode) {
        if (isDigitChar(charCode)) {
            stateMachine.state = 38 /* State.PhoneNumberDigit */;
        }
        else if (isPhoneNumberSeparatorChar(charCode)) {
            stateMachine.state = 39 /* State.PhoneNumberSeparator */;
        }
        else {
            context.removeMachine(stateMachine);
        }
    }
    function statePhoneNumberDigit(context, stateMachine, char, charCode) {
        var charIdx = context.charIdx;
        // For now, if we've reached any digits, we'll say that the machine
        // has reached its accept state. The phone regex will confirm the
        // match later.
        // Alternatively, we could count the number of digits to avoid
        // invoking the phone number regex
        stateMachine.acceptStateReached = true;
        if (isPhoneNumberControlChar(charCode)) {
            stateMachine.state = 40 /* State.PhoneNumberControlChar */;
        }
        else if (charCode === 35 /* Char.NumberSign */ /* '#' */) {
            stateMachine.state = 41 /* State.PhoneNumberPoundChar */;
        }
        else if (isDigitChar(charCode)) ;
        else if (charCode === 40 /* Char.OpenParen */ /* '(' */) {
            stateMachine.state = 32 /* State.PhoneNumberOpenParen */;
        }
        else if (isPhoneNumberSeparatorChar(charCode)) {
            stateMachine.state = 39 /* State.PhoneNumberSeparator */;
        }
        else {
            captureMatchIfValidAndRemove(context, stateMachine);
            // The transition from a digit character to a letter can be the
            // start of a new scheme URL match
            if (isSchemeStartChar(charCode)) {
                context.addMachine(createSchemeUrlStateMachine(charIdx, 0 /* State.SchemeChar */));
            }
        }
    }
    function statePhoneNumberSeparator(context, stateMachine, char, charCode) {
        if (isDigitChar(charCode)) {
            stateMachine.state = 38 /* State.PhoneNumberDigit */;
        }
        else if (charCode === 40 /* Char.OpenParen */ /* '(' */) {
            stateMachine.state = 32 /* State.PhoneNumberOpenParen */;
        }
        else {
            captureMatchIfValidAndRemove(context, stateMachine);
            // This character may start a new match. Add states for it
            stateNoMatch(context, char, charCode);
        }
    }
    // The ";" characters is "wait" in a phone number
    // The "," characters is "pause" in a phone number
    function statePhoneNumberControlChar(context, stateMachine, charCode) {
        if (isPhoneNumberControlChar(charCode)) ;
        else if (charCode === 35 /* Char.NumberSign */ /* '#' */) {
            stateMachine.state = 41 /* State.PhoneNumberPoundChar */;
        }
        else if (isDigitChar(charCode)) {
            stateMachine.state = 38 /* State.PhoneNumberDigit */;
        }
        else {
            captureMatchIfValidAndRemove(context, stateMachine);
        }
    }
    // The "#" characters is "pound" in a phone number
    function statePhoneNumberPoundChar(context, stateMachine, charCode) {
        if (isPhoneNumberControlChar(charCode)) {
            stateMachine.state = 40 /* State.PhoneNumberControlChar */;
        }
        else if (isDigitChar(charCode)) {
            // According to some of the older tests, if there's a digit
            // after a '#' sign, the match is invalid. TODO: Revisit if this is true
            context.removeMachine(stateMachine);
        }
        else {
            captureMatchIfValidAndRemove(context, stateMachine);
        }
    }
    /*
     * Captures a match if it is valid (i.e. has a full domain name for a
     * TLD match). If a match is not valid, it is possible that we want to
     * keep reading characters in order to make a full match.
     */
    function captureMatchIfValidAndRemove(context, stateMachine) {
        var matches = context.matches, text = context.text, charIdx = context.charIdx, tagBuilder = context.tagBuilder, stripPrefix = context.stripPrefix, stripTrailingSlash = context.stripTrailingSlash, decodePercentEncoding = context.decodePercentEncoding, hashtagServiceName = context.hashtagServiceName, mentionServiceName = context.mentionServiceName;
        // Remove the state machine first. There are a number of code paths
        // which return out of this function early, so make sure we have
        // this done
        context.removeMachine(stateMachine);
        // Make sure the state machine being checked has actually reached an
        // "accept" state. If it hasn't reach one, it can't be a match
        if (!stateMachine.acceptStateReached) {
            return;
        }
        var startIdx = stateMachine.startIdx;
        var matchedText = text.slice(stateMachine.startIdx, charIdx);
        // Handle any unbalanced braces (parens, square brackets, or curly
        // brackets) inside the URL. This handles situations like:
        //     The link (google.com)
        // and
        //     Check out this link here (en.wikipedia.org/wiki/IANA_(disambiguation))
        //
        // And also remove any punctuation chars at the end such as:
        //     '?', ',', ':', '.', etc.
        matchedText = excludeUnbalancedTrailingBracesAndPunctuation(matchedText);
        switch (stateMachine.type) {
            case 0 /* StateMachineType.Url */: {
                // We don't want to accidentally match a URL that is preceded by an
                // '@' character, which would be an email address
                var charBeforeUrlMatch = text.charCodeAt(stateMachine.startIdx - 1);
                if (charBeforeUrlMatch === 64 /* Char.AtSign */ /* '@' */) {
                    return;
                }
                switch (stateMachine.matchType) {
                    case 0 /* UrlStateMachineMatchType.Scheme */: {
                        // Autolinker accepts many characters in a url's scheme (like `fake://test.com`).
                        // However, in cases where a URL is missing whitespace before an obvious link,
                        // (for example: `nowhitespacehttp://www.test.com`), we only want the match to start
                        // at the http:// part. We will check if the match contains a common scheme and then
                        // shift the match to start from there.
                        var httpSchemeMatch = httpSchemeRe.exec(matchedText);
                        if (httpSchemeMatch) {
                            // If we found an overmatched URL, we want to find the index
                            // of where the match should start and shift the match to
                            // start from the beginning of the common scheme
                            startIdx = startIdx + httpSchemeMatch.index;
                            matchedText = matchedText.slice(httpSchemeMatch.index);
                        }
                        if (!isValidSchemeUrl(matchedText)) {
                            return; // not a valid match
                        }
                        break;
                    }
                    case 1 /* UrlStateMachineMatchType.Tld */: {
                        if (!isValidTldMatch(matchedText)) {
                            return; // not a valid match
                        }
                        break;
                    }
                    case 2 /* UrlStateMachineMatchType.IpV4 */: {
                        if (!isValidIpV4Address(matchedText)) {
                            return; // not a valid match
                        }
                        break;
                    }
                    /* istanbul ignore next */
                    default:
                        assertNever(stateMachine);
                }
                matches.push(new UrlMatch({
                    tagBuilder: tagBuilder,
                    matchedText: matchedText,
                    offset: startIdx,
                    urlMatchType: toUrlMatchType(stateMachine.matchType),
                    url: matchedText,
                    protocolRelativeMatch: matchedText.slice(0, 2) === '//',
                    // TODO: Do these settings need to be passed to the match,
                    // or should we handle them here in UrlMatcher?
                    stripPrefix: stripPrefix,
                    stripTrailingSlash: stripTrailingSlash,
                    decodePercentEncoding: decodePercentEncoding,
                }));
                break;
            }
            case 1 /* StateMachineType.Email */: {
                // if the email address has a valid TLD, add it to the list of matches
                if (isValidEmail(matchedText)) {
                    matches.push(new EmailMatch({
                        tagBuilder: tagBuilder,
                        matchedText: matchedText,
                        offset: startIdx,
                        email: matchedText.replace(mailtoSchemePrefixRe, ''),
                    }));
                }
                break;
            }
            case 2 /* StateMachineType.Hashtag */: {
                if (isValidHashtag(matchedText)) {
                    matches.push(new HashtagMatch({
                        tagBuilder: tagBuilder,
                        matchedText: matchedText,
                        offset: startIdx,
                        serviceName: hashtagServiceName,
                        hashtag: matchedText.slice(1),
                    }));
                }
                break;
            }
            case 3 /* StateMachineType.Mention */: {
                if (isValidMention(matchedText, mentionServiceName)) {
                    matches.push(new MentionMatch({
                        tagBuilder: tagBuilder,
                        matchedText: matchedText,
                        offset: startIdx,
                        serviceName: mentionServiceName,
                        mention: matchedText.slice(1), // strip off the '@' character at the beginning
                    }));
                }
                break;
            }
            case 4 /* StateMachineType.Phone */: {
                // remove any trailing spaces that were considered as "separator"
                // chars by the state machine
                matchedText = matchedText.replace(/ +$/g, '');
                if (isValidPhoneNumber(matchedText)) {
                    var cleanNumber = matchedText.replace(/[^0-9,;#]/g, ''); // strip out non-digit characters exclude comma semicolon and #
                    matches.push(new PhoneMatch({
                        tagBuilder: tagBuilder,
                        matchedText: matchedText,
                        offset: startIdx,
                        number: cleanNumber,
                        plusSign: matchedText.charAt(0) === '+',
                    }));
                }
                break;
            }
            /* istanbul ignore next */
            default:
                assertNever(stateMachine);
        }
    }
    /**
     * Helper function to convert a UrlStateMachineMatchType value to its
     * UrlMatchType equivalent.
     */
    function toUrlMatchType(stateMachineMatchType) {
        switch (stateMachineMatchType) {
            case 0 /* UrlStateMachineMatchType.Scheme */:
                return 'scheme';
            case 1 /* UrlStateMachineMatchType.Tld */:
                return 'tld';
            case 2 /* UrlStateMachineMatchType.IpV4 */:
                return 'ipV4';
            /* istanbul ignore next */
            default:
                assertNever(stateMachineMatchType);
        }
    }
    var oppositeBrace = {
        ')': '(',
        '}': '{',
        ']': '[',
    };
    /**
     * Determines if a match found has unmatched closing parenthesis,
     * square brackets or curly brackets. If so, these unbalanced symbol(s) will be
     * removed from the URL match itself.
     *
     * A match may have an extra closing parenthesis/square brackets/curly brackets
     * at the end of the match because these are valid URL path characters. For
     * example, "wikipedia.com/something_(disambiguation)" should be auto-linked.
     *
     * However, an extra parenthesis *will* be included when the URL itself is
     * wrapped in parenthesis, such as in the case of:
     *
     *     "(wikipedia.com/something_(disambiguation))"
     *
     * In this case, the last closing parenthesis should *not* be part of the
     * URL itself, and this method will exclude it from the returned URL.
     *
     * For square brackets in URLs such as in PHP arrays, the same behavior as
     * parenthesis discussed above should happen:
     *
     *     "[http://www.example.com/foo.php?bar[]=1&bar[]=2&bar[]=3]"
     *
     * The very last closing square bracket should not be part of the URL itself,
     * and therefore this method will remove it.
     *
     * @param matchedText The full matched URL/email/hashtag/etc. from the state
     *   machine parser.
     * @return The updated matched text with extraneous suffix characters removed.
     */
    function excludeUnbalancedTrailingBracesAndPunctuation(matchedText) {
        var braceCounts = {
            '(': 0,
            '{': 0,
            '[': 0,
        };
        for (var i = 0; i < matchedText.length; i++) {
            var char = matchedText.charAt(i);
            var charCode = matchedText.charCodeAt(i);
            if (isOpenBraceChar(charCode)) {
                braceCounts[char]++;
            }
            else if (isCloseBraceChar(charCode)) {
                braceCounts[oppositeBrace[char]]--;
            }
        }
        var endIdx = matchedText.length - 1;
        while (endIdx >= 0) {
            var char = matchedText.charAt(endIdx);
            var charCode = matchedText.charCodeAt(endIdx);
            if (isCloseBraceChar(charCode)) {
                var oppositeBraceChar = oppositeBrace[char];
                if (braceCounts[oppositeBraceChar] < 0) {
                    braceCounts[oppositeBraceChar]++;
                    endIdx--;
                }
                else {
                    break;
                }
            }
            else if (isUrlSuffixNotAllowedAsFinalChar(charCode)) {
                // Walk back a punctuation char like '?', ',', ':', '.', etc.
                endIdx--;
            }
            else {
                break;
            }
        }
        return matchedText.slice(0, endIdx + 1);
    }
    function createSchemeUrlStateMachine(startIdx, state) {
        return {
            type: 0 /* StateMachineType.Url */,
            startIdx: startIdx,
            state: state,
            acceptStateReached: false,
            matchType: 0 /* UrlStateMachineMatchType.Scheme */,
        };
    }
    function createTldUrlStateMachine(startIdx, state) {
        return {
            type: 0 /* StateMachineType.Url */,
            startIdx: startIdx,
            state: state,
            acceptStateReached: false,
            matchType: 1 /* UrlStateMachineMatchType.Tld */,
        };
    }
    function createIpV4UrlStateMachine(startIdx, state) {
        return {
            type: 0 /* StateMachineType.Url */,
            startIdx: startIdx,
            state: state,
            acceptStateReached: false,
            matchType: 2 /* UrlStateMachineMatchType.IpV4 */,
            octetsEncountered: 1, // starts at 1 because we create this machine when encountering the first octet
        };
    }
    function createEmailStateMachine(startIdx, state) {
        return {
            type: 1 /* StateMachineType.Email */,
            startIdx: startIdx,
            state: state,
            acceptStateReached: false,
        };
    }
    function createHashtagStateMachine(startIdx, state) {
        return {
            type: 2 /* StateMachineType.Hashtag */,
            startIdx: startIdx,
            state: state,
            acceptStateReached: false,
        };
    }
    function createMentionStateMachine(startIdx, state) {
        return {
            type: 3 /* StateMachineType.Mention */,
            startIdx: startIdx,
            state: state,
            acceptStateReached: false,
        };
    }
    function createPhoneNumberStateMachine(startIdx, state) {
        return {
            type: 4 /* StateMachineType.Phone */,
            startIdx: startIdx,
            state: state,
            acceptStateReached: false,
        };
    }
    function isSchemeUrlStateMachine(machine) {
        return (machine.type === 0 /* StateMachineType.Url */ &&
            machine.matchType === 0 /* UrlStateMachineMatchType.Scheme */);
    }

    // For debugging: search for other "For debugging" lines
    // import CliTable from 'cli-table';
    var CurrentTag = /** @class */ (function () {
        function CurrentTag(cfg) {
            if (cfg === void 0) { cfg = {}; }
            this.idx = cfg.idx !== undefined ? cfg.idx : -1;
            this.type = cfg.type || 'tag';
            this.name = cfg.name || '';
            this.isOpening = !!cfg.isOpening;
            this.isClosing = !!cfg.isClosing;
        }
        return CurrentTag;
    }());
    var noCurrentTag = new CurrentTag(); // shared reference for when there is no current tag currently being read
    /**
     * Context object containing all the state needed by the HTML parsing state
     * machine function.
     *
     * ## Historical note
     *
     * In v4.1.5, we used nested functions to handle the context via closures, but
     * this necessitated re-creating the functions for each call to `parseHtml()`,
     * which made them difficult for v8 to JIT optimize. In v4.1.6, we lifted all of
     * the functions to the top-level scope and passed the context object between
     * them, which allows the functions to be JIT compiled once and reused.
     */
    var ParseHtmlContext = /** @class */ (function () {
        function ParseHtmlContext(html, callbacks) {
            this.charIdx = 0; // Current character index being processed
            this.state = 0 /* State.Data */; // begin in the Data state
            this.currentDataIdx = 0; // where the current data start index is
            this.currentTag = noCurrentTag; // describes the current tag that is being read
            this.html = html;
            this.callbacks = callbacks;
        }
        return ParseHtmlContext;
    }());
    /**
     * Parses an HTML string, calling the callbacks to notify of tags and text.
     *
     * ## History
     *
     * This file previously used a regular expression to find html tags in the input
     * text. Unfortunately, we ran into a bunch of catastrophic backtracking issues
     * with certain input text, causing Autolinker to either hang or just take a
     * really long time to parse the string.
     *
     * The current code is intended to be a O(n) algorithm that walks through
     * the string in one pass, and tries to be as cheap as possible. We don't need
     * to implement the full HTML spec, but rather simply determine where the string
     * looks like an HTML tag, and where it looks like text (so that we can autolink
     * that).
     *
     * This state machine parser is intended just to be a simple but performant
     * parser of HTML for the subset of requirements we have. We simply need to:
     *
     * 1. Determine where HTML tags are
     * 2. Determine the tag name (Autolinker specifically only cares about <a>,
     *    <script>, and <style> tags, so as not to link any text within them)
     *
     * We don't need to:
     *
     * 1. Create a parse tree
     * 2. Auto-close tags with invalid markup
     * 3. etc.
     *
     * The other intention behind this is that we didn't want to add external
     * dependencies on the Autolinker utility which would increase its size. For
     * instance, adding htmlparser2 adds 125kb to the minified output file,
     * increasing its final size from 47kb to 172kb (at the time of writing). It
     * also doesn't work exactly correctly, treating the string "<3 blah blah blah"
     * as an HTML tag.
     *
     * Reference for HTML spec:
     *
     *     https://www.w3.org/TR/html51/syntax.html#sec-tokenization
     *
     * @param {String} html The HTML to parse
     * @param {Object} callbacks
     * @param {Function} callbacks.onOpenTag Callback function to call when an open
     *   tag is parsed. Called with the tagName as its argument.
     * @param {Function} callbacks.onCloseTag Callback function to call when a close
     *   tag is parsed. Called with the tagName as its argument. If a self-closing
     *   tag is found, `onCloseTag` is called immediately after `onOpenTag`.
     * @param {Function} callbacks.onText Callback function to call when text (i.e
     *   not an HTML tag) is parsed. Called with the text (string) as its first
     *   argument, and offset (number) into the string as its second.
     */
    function parseHtml(html, callbacks) {
        var context = new ParseHtmlContext(html, callbacks);
        // For debugging: search for other "For debugging" lines
        // const table = new CliTable( {
        // 	head: [ 'charIdx', 'char', 'state', 'currentDataIdx', 'currentOpenTagIdx', 'tag.type' ]
        // } );
        var len = html.length;
        while (context.charIdx < len) {
            var char = html.charAt(context.charIdx);
            var charCode = html.charCodeAt(context.charIdx);
            // For debugging: search for other "For debugging" lines
            // ALSO: Temporarily remove the 'const' keyword on the State enum
            // table.push([
            //     String(charIdx),
            //     char,
            //     State[state],
            //     String(currentDataIdx),
            //     String(currentTag.idx),
            //     currentTag.idx === -1 ? '' : currentTag.type
            // ]);
            switch (context.state) {
                case 0 /* State.Data */:
                    stateData(context, char);
                    break;
                case 1 /* State.TagOpen */:
                    stateTagOpen(context, char, charCode);
                    break;
                case 2 /* State.EndTagOpen */:
                    stateEndTagOpen(context, char, charCode);
                    break;
                case 3 /* State.TagName */:
                    stateTagName(context, char, charCode);
                    break;
                case 4 /* State.BeforeAttributeName */:
                    stateBeforeAttributeName(context, char, charCode);
                    break;
                case 5 /* State.AttributeName */:
                    stateAttributeName(context, char, charCode);
                    break;
                case 6 /* State.AfterAttributeName */:
                    stateAfterAttributeName(context, char, charCode);
                    break;
                case 7 /* State.BeforeAttributeValue */:
                    stateBeforeAttributeValue(context, char, charCode);
                    break;
                case 8 /* State.AttributeValueDoubleQuoted */:
                    stateAttributeValueDoubleQuoted(context, char);
                    break;
                case 9 /* State.AttributeValueSingleQuoted */:
                    stateAttributeValueSingleQuoted(context, char);
                    break;
                case 10 /* State.AttributeValueUnquoted */:
                    stateAttributeValueUnquoted(context, char, charCode);
                    break;
                case 11 /* State.AfterAttributeValueQuoted */:
                    stateAfterAttributeValueQuoted(context, char, charCode);
                    break;
                case 12 /* State.SelfClosingStartTag */:
                    stateSelfClosingStartTag(context, char);
                    break;
                case 13 /* State.MarkupDeclarationOpenState */:
                    stateMarkupDeclarationOpen(context);
                    break;
                case 14 /* State.CommentStart */:
                    stateCommentStart(context, char);
                    break;
                case 15 /* State.CommentStartDash */:
                    stateCommentStartDash(context, char);
                    break;
                case 16 /* State.Comment */:
                    stateComment(context, char);
                    break;
                case 17 /* State.CommentEndDash */:
                    stateCommentEndDash(context, char);
                    break;
                case 18 /* State.CommentEnd */:
                    stateCommentEnd(context, char);
                    break;
                case 19 /* State.CommentEndBang */:
                    stateCommentEndBang(context, char);
                    break;
                case 20 /* State.Doctype */:
                    stateDoctype(context, char);
                    break;
                /* istanbul ignore next */
                default:
                    assertNever(context.state);
            }
            // For debugging: search for other "For debugging" lines
            // ALSO: Temporarily remove the 'const' keyword on the State enum
            // table.push([
            //     String(context.charIdx),
            //     char,
            //     State[context.state],
            //     String(context.currentDataIdx),
            //     String(context.currentTag.idx),
            //     context.currentTag.idx === -1 ? '' : context.currentTag.type
            // ]);
            context.charIdx++;
        }
        if (context.currentDataIdx < context.charIdx) {
            emitText(context);
        }
        // For debugging: search for other "For debugging" lines
        // console.log( '\n' + table.toString() );
    }
    // Called when non-tags are being read (i.e. the text around HTML †ags)
    // https://www.w3.org/TR/html51/syntax.html#data-state
    function stateData(context, char) {
        if (char === '<') {
            startNewTag(context);
        }
    }
    // Called after a '<' is read from the Data state
    // https://www.w3.org/TR/html51/syntax.html#tag-open-state
    function stateTagOpen(context, char, charCode) {
        if (char === '!') {
            context.state = 13 /* State.MarkupDeclarationOpenState */;
        }
        else if (char === '/') {
            context.state = 2 /* State.EndTagOpen */;
            context.currentTag = new CurrentTag(__assign(__assign({}, context.currentTag), { isClosing: true }));
        }
        else if (char === '<') {
            // start of another tag (ignore the previous, incomplete one)
            startNewTag(context);
        }
        else if (isAsciiLetterChar(charCode)) {
            // tag name start (and no '/' read)
            context.state = 3 /* State.TagName */;
            context.currentTag = new CurrentTag(__assign(__assign({}, context.currentTag), { isOpening: true }));
        }
        else {
            // Any other
            context.state = 0 /* State.Data */;
            context.currentTag = noCurrentTag;
        }
    }
    // After a '<x', '</x' sequence is read (where 'x' is a letter character),
    // this is to continue reading the tag name
    // https://www.w3.org/TR/html51/syntax.html#tag-name-state
    function stateTagName(context, char, charCode) {
        if (isWhitespaceChar(charCode)) {
            context.currentTag = new CurrentTag(__assign(__assign({}, context.currentTag), { name: captureTagName(context) }));
            context.state = 4 /* State.BeforeAttributeName */;
        }
        else if (char === '<') {
            // start of another tag (ignore the previous, incomplete one)
            startNewTag(context);
        }
        else if (char === '/') {
            context.currentTag = new CurrentTag(__assign(__assign({}, context.currentTag), { name: captureTagName(context) }));
            context.state = 12 /* State.SelfClosingStartTag */;
        }
        else if (char === '>') {
            context.currentTag = new CurrentTag(__assign(__assign({}, context.currentTag), { name: captureTagName(context) }));
            emitTagAndPreviousTextNode(context); // resets to Data state as well
        }
        else if (!isAsciiLetterChar(charCode) && !isDigitChar(charCode) && char !== ':') {
            // Anything else that does not form an html tag. Note: the colon
            // character is accepted for XML namespaced tags
            resetToDataState(context);
        }
        else ;
    }
    // Called after the '/' is read from a '</' sequence
    // https://www.w3.org/TR/html51/syntax.html#end-tag-open-state
    function stateEndTagOpen(context, char, charCode) {
        if (char === '>') {
            // parse error. Encountered "</>". Skip it without treating as a tag
            resetToDataState(context);
        }
        else if (isAsciiLetterChar(charCode)) {
            context.state = 3 /* State.TagName */;
        }
        else {
            // some other non-tag-like character, don't treat this as a tag
            resetToDataState(context);
        }
    }
    // https://www.w3.org/TR/html51/syntax.html#before-attribute-name-state
    function stateBeforeAttributeName(context, char, charCode) {
        if (isWhitespaceChar(charCode)) ;
        else if (char === '/') {
            context.state = 12 /* State.SelfClosingStartTag */;
        }
        else if (char === '>') {
            emitTagAndPreviousTextNode(context); // resets to Data state as well
        }
        else if (char === '<') {
            // start of another tag (ignore the previous, incomplete one)
            startNewTag(context);
        }
        else if (char === "=" || isQuoteChar(charCode) || isControlChar(charCode)) {
            // "Parse error" characters that, according to the spec, should be
            // appended to the attribute name, but we'll treat these characters
            // as not forming a real HTML tag
            resetToDataState(context);
        }
        else {
            // Any other char, start of a new attribute name
            context.state = 5 /* State.AttributeName */;
        }
    }
    // https://www.w3.org/TR/html51/syntax.html#attribute-name-state
    function stateAttributeName(context, char, charCode) {
        if (isWhitespaceChar(charCode)) {
            context.state = 6 /* State.AfterAttributeName */;
        }
        else if (char === '/') {
            context.state = 12 /* State.SelfClosingStartTag */;
        }
        else if (char === '=') {
            context.state = 7 /* State.BeforeAttributeValue */;
        }
        else if (char === '>') {
            emitTagAndPreviousTextNode(context); // resets to Data state as well
        }
        else if (char === '<') {
            // start of another tag (ignore the previous, incomplete one)
            startNewTag(context);
        }
        else if (isQuoteChar(charCode)) {
            // "Parse error" characters that, according to the spec, should be
            // appended to the attribute name, but we'll treat these characters
            // as not forming a real HTML tag
            resetToDataState(context);
        }
        else ;
    }
    // https://www.w3.org/TR/html51/syntax.html#after-attribute-name-state
    function stateAfterAttributeName(context, char, charCode) {
        if (isWhitespaceChar(charCode)) ;
        else if (char === '/') {
            context.state = 12 /* State.SelfClosingStartTag */;
        }
        else if (char === '=') {
            context.state = 7 /* State.BeforeAttributeValue */;
        }
        else if (char === '>') {
            emitTagAndPreviousTextNode(context);
        }
        else if (char === '<') {
            // start of another tag (ignore the previous, incomplete one)
            startNewTag(context);
        }
        else if (isQuoteChar(charCode)) {
            // "Parse error" characters that, according to the spec, should be
            // appended to the attribute name, but we'll treat these characters
            // as not forming a real HTML tag
            resetToDataState(context);
        }
        else {
            // Any other character, start a new attribute in the current tag
            context.state = 5 /* State.AttributeName */;
        }
    }
    // https://www.w3.org/TR/html51/syntax.html#before-attribute-value-state
    function stateBeforeAttributeValue(context, char, charCode) {
        if (isWhitespaceChar(charCode)) ;
        else if (char === "\"") {
            context.state = 8 /* State.AttributeValueDoubleQuoted */;
        }
        else if (char === "'") {
            context.state = 9 /* State.AttributeValueSingleQuoted */;
        }
        else if (/[>=`]/.test(char)) {
            // Invalid chars after an '=' for an attribute value, don't count
            // the current tag as an HTML tag
            resetToDataState(context);
        }
        else if (char === '<') {
            // start of another tag (ignore the previous, incomplete one)
            startNewTag(context);
        }
        else {
            // Any other character, consider it an unquoted attribute value
            context.state = 10 /* State.AttributeValueUnquoted */;
        }
    }
    // https://www.w3.org/TR/html51/syntax.html#attribute-value-double-quoted-state
    function stateAttributeValueDoubleQuoted(context, char) {
        if (char === "\"") {
            // end the current double-quoted attribute
            context.state = 11 /* State.AfterAttributeValueQuoted */;
        }
    }
    // https://www.w3.org/TR/html51/syntax.html#attribute-value-single-quoted-state
    function stateAttributeValueSingleQuoted(context, char) {
        if (char === "'") {
            // end the current single-quoted attribute
            context.state = 11 /* State.AfterAttributeValueQuoted */;
        }
    }
    // https://www.w3.org/TR/html51/syntax.html#attribute-value-unquoted-state
    function stateAttributeValueUnquoted(context, char, charCode) {
        if (isWhitespaceChar(charCode)) {
            context.state = 4 /* State.BeforeAttributeName */;
        }
        else if (char === '>') {
            emitTagAndPreviousTextNode(context);
        }
        else if (char === '<') {
            // start of another tag (ignore the previous, incomplete one)
            startNewTag(context);
        }
        else ;
    }
    // Called after a double-quoted or single-quoted attribute value is read
    // (i.e. after the closing quote character)
    // https://www.w3.org/TR/html51/syntax.html#after-attribute-value-quoted-state
    function stateAfterAttributeValueQuoted(context, char, charCode) {
        if (isWhitespaceChar(charCode)) {
            context.state = 4 /* State.BeforeAttributeName */;
        }
        else if (char === '/') {
            context.state = 12 /* State.SelfClosingStartTag */;
        }
        else if (char === '>') {
            emitTagAndPreviousTextNode(context);
        }
        else if (char === '<') {
            // start of another tag (ignore the previous, incomplete one)
            startNewTag(context);
        }
        else {
            // Any other character, "parse error". Spec says to switch to the
            // BeforeAttributeState and re-consume the character, as it may be
            // the start of a new attribute name
            context.state = 4 /* State.BeforeAttributeName */;
            reconsumeCurrentChar(context);
        }
    }
    // A '/' has just been read in the current tag (presumably for '/>'), and
    // this handles the next character
    // https://www.w3.org/TR/html51/syntax.html#self-closing-start-tag-state
    function stateSelfClosingStartTag(context, char) {
        if (char === '>') {
            context.currentTag = new CurrentTag(__assign(__assign({}, context.currentTag), { isClosing: true }));
            emitTagAndPreviousTextNode(context); // resets to Data state as well
        }
        else {
            // Note: the spec calls for a character after a '/' within a start
            // tag to go back into the BeforeAttributeName state (in order to
            // read more attributes, but for the purposes of Autolinker, this is
            // most likely not a valid HTML tag. For example: "<something / other>"
            // state = State.BeforeAttributeName;
            // Instead, just treat as regular text
            resetToDataState(context);
        }
    }
    // https://www.w3.org/TR/html51/syntax.html#markup-declaration-open-state
    // (HTML Comments or !DOCTYPE)
    function stateMarkupDeclarationOpen(context) {
        var html = context.html, charIdx = context.charIdx;
        if (html.slice(charIdx, charIdx + 2) === '--') {
            // html comment
            context.charIdx++; // "consume" the second '-' character. Next loop iteration will consume the character after the '<!--' sequence
            context.currentTag = new CurrentTag(__assign(__assign({}, context.currentTag), { type: 'comment' }));
            context.state = 14 /* State.CommentStart */;
        }
        else if (html.slice(charIdx, charIdx + 7).toUpperCase() === 'DOCTYPE') {
            context.charIdx += 6; // "consume" the characters "OCTYPE" (the current loop iteraction consumed the 'D'). Next loop iteration will consume the character after the '<!DOCTYPE' sequence
            context.currentTag = new CurrentTag(__assign(__assign({}, context.currentTag), { type: 'doctype' }));
            context.state = 20 /* State.Doctype */;
        }
        else {
            // At this point, the spec specifies that the state machine should
            // enter the "bogus comment" state, in which case any character(s)
            // after the '<!' that were read should become an HTML comment up
            // until the first '>' that is read (or EOF). Instead, we'll assume
            // that a user just typed '<!' as part of some piece of non-html
            // text
            resetToDataState(context);
        }
    }
    // Handles after the sequence '<!--' has been read
    // https://www.w3.org/TR/html51/syntax.html#comment-start-state
    function stateCommentStart(context, char) {
        if (char === '-') {
            // We've read the sequence '<!---' at this point (3 dashes)
            context.state = 15 /* State.CommentStartDash */;
        }
        else if (char === '>') {
            // At this point, we'll assume the comment wasn't a real comment
            // so we'll just emit it as data. We basically read the sequence
            // '<!-->'
            resetToDataState(context);
        }
        else {
            // Any other char, take it as part of the comment
            context.state = 16 /* State.Comment */;
        }
    }
    // We've read the sequence '<!---' at this point (3 dashes)
    // https://www.w3.org/TR/html51/syntax.html#comment-start-dash-state
    function stateCommentStartDash(context, char) {
        if (char === '-') {
            // We've read '<!----' (4 dashes) at this point
            context.state = 18 /* State.CommentEnd */;
        }
        else if (char === '>') {
            // At this point, we'll assume the comment wasn't a real comment
            // so we'll just emit it as data. We basically read the sequence
            // '<!--->'
            resetToDataState(context);
        }
        else {
            // Anything else, take it as a valid comment
            context.state = 16 /* State.Comment */;
        }
    }
    // Currently reading the comment's text (data)
    // https://www.w3.org/TR/html51/syntax.html#comment-state
    function stateComment(context, char) {
        if (char === '-') {
            context.state = 17 /* State.CommentEndDash */;
        }
    }
    // When we we've read the first dash inside a comment, it may signal the
    // end of the comment if we read another dash
    // https://www.w3.org/TR/html51/syntax.html#comment-end-dash-state
    function stateCommentEndDash(context, char) {
        if (char === '-') {
            context.state = 18 /* State.CommentEnd */;
        }
        else {
            // Wasn't a dash, must still be part of the comment
            context.state = 16 /* State.Comment */;
        }
    }
    // After we've read two dashes inside a comment, it may signal the end of
    // the comment if we then read a '>' char
    // https://www.w3.org/TR/html51/syntax.html#comment-end-state
    function stateCommentEnd(context, char) {
        if (char === '>') {
            emitTagAndPreviousTextNode(context);
        }
        else if (char === '!') {
            context.state = 19 /* State.CommentEndBang */;
        }
        else if (char === '-') ;
        else {
            // Anything else, switch back to the comment state since we didn't
            // read the full "end comment" sequence (i.e. '-->')
            context.state = 16 /* State.Comment */;
        }
    }
    // We've read the sequence '--!' inside of a comment
    // https://www.w3.org/TR/html51/syntax.html#comment-end-bang-state
    function stateCommentEndBang(context, char) {
        if (char === '-') {
            // We read the sequence '--!-' inside of a comment. The last dash
            // could signify that the comment is going to close
            context.state = 17 /* State.CommentEndDash */;
        }
        else if (char === '>') {
            // End of comment with the sequence '--!>'
            emitTagAndPreviousTextNode(context);
        }
        else {
            // The '--!' was not followed by a '>', continue reading the
            // comment's text
            context.state = 16 /* State.Comment */;
        }
    }
    /**
     * For DOCTYPES in particular, we don't care about the attributes. Just
     * advance to the '>' character and emit the tag, unless we find a '<'
     * character in which case we'll start a new tag.
     *
     * Example doctype tag:
     *    <!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01//EN" "http://www.w3.org/TR/html4/strict.dtd">
     *
     * Actual spec: https://www.w3.org/TR/html51/syntax.html#doctype-state
     */
    function stateDoctype(context, char) {
        if (char === '>') {
            emitTagAndPreviousTextNode(context);
        }
        else if (char === '<') {
            startNewTag(context);
        }
        else ;
    }
    /**
     * Resets the state back to the Data state, and removes the current tag.
     *
     * We'll generally run this function whenever a "parse error" is
     * encountered, where the current tag that is being read no longer looks
     * like a real HTML tag.
     */
    function resetToDataState(context) {
        context.state = 0 /* State.Data */;
        context.currentTag = noCurrentTag;
    }
    /**
     * Starts a new HTML tag at the current index, ignoring any previous HTML
     * tag that was being read.
     *
     * We'll generally run this function whenever we read a new '<' character,
     * including when we read a '<' character inside of an HTML tag that we were
     * previously reading.
     */
    function startNewTag(context) {
        context.state = 1 /* State.TagOpen */;
        context.currentTag = new CurrentTag({ idx: context.charIdx });
    }
    /**
     * Once we've decided to emit an open tag, that means we can also emit the
     * text node before it.
     */
    function emitTagAndPreviousTextNode(context) {
        var textBeforeTag = context.html.slice(context.currentDataIdx, context.currentTag.idx);
        if (textBeforeTag) {
            // the html tag was the first element in the html string, or two
            // tags next to each other, in which case we should not emit a text
            // node
            context.callbacks.onText(textBeforeTag, context.currentDataIdx);
        }
        var currentTag = context.currentTag;
        if (currentTag.type === 'comment') {
            context.callbacks.onComment(currentTag.idx);
        }
        else if (currentTag.type === 'doctype') {
            context.callbacks.onDoctype(currentTag.idx);
        }
        else {
            if (currentTag.isOpening) {
                context.callbacks.onOpenTag(currentTag.name, currentTag.idx);
            }
            if (currentTag.isClosing) {
                // note: self-closing tags will emit both opening and closing
                context.callbacks.onCloseTag(currentTag.name, currentTag.idx);
            }
        }
        // Since we just emitted a tag, reset to the data state for the next char
        resetToDataState(context);
        context.currentDataIdx = context.charIdx + 1;
    }
    function emitText(context) {
        var text = context.html.slice(context.currentDataIdx, context.charIdx);
        context.callbacks.onText(text, context.currentDataIdx);
        context.currentDataIdx = context.charIdx + 1;
    }
    /**
     * Captures the tag name from the start of the tag to the current character
     * index, and converts it to lower case
     */
    function captureTagName(context) {
        var startIdx = context.currentTag.idx + (context.currentTag.isClosing ? 2 : 1);
        return context.html.slice(startIdx, context.charIdx).toLowerCase();
    }
    /**
     * Causes the main loop to re-consume the current character, such as after
     * encountering a "parse error" that changed state and needs to reconsume
     * the same character in that new state.
     */
    function reconsumeCurrentChar(context) {
        context.charIdx--;
    }

    /**
     * @class Autolinker
     * @extends Object
     *
     * Utility class used to process a given string of text, and wrap the matches in
     * the appropriate anchor (&lt;a&gt;) tags to turn them into links.
     *
     * Any of the configuration options may be provided in an Object provided
     * to the Autolinker constructor, which will configure how the {@link #link link()}
     * method will process the links.
     *
     * For example:
     *
     *     var autolinker = new Autolinker( {
     *         newWindow : false,
     *         truncate  : 30
     *     } );
     *
     *     var html = autolinker.link( "Joe went to www.yahoo.com" );
     *     // produces: 'Joe went to <a href="http://www.yahoo.com">yahoo.com</a>'
     *
     *
     * The {@link #static-link static link()} method may also be used to inline
     * options into a single call, which may be more convenient for one-off uses.
     * For example:
     *
     *     var html = Autolinker.link( "Joe went to www.yahoo.com", {
     *         newWindow : false,
     *         truncate  : 30
     *     } );
     *     // produces: 'Joe went to <a href="http://www.yahoo.com">yahoo.com</a>'
     *
     *
     * ## Custom Replacements of Links
     *
     * If the configuration options do not provide enough flexibility, a {@link #replaceFn}
     * may be provided to fully customize the output of Autolinker. This function is
     * called once for each URL/Email/Phone#/Hashtag/Mention (Twitter, Instagram, Soundcloud)
     * match that is encountered.
     *
     * For example:
     *
     *     var input = "...";  // string with URLs, Email Addresses, Phone #s, Hashtags, and Mentions (Twitter, Instagram, Soundcloud)
     *
     *     var linkedText = Autolinker.link( input, {
     *         replaceFn : function( match ) {
     *             console.log( "href = ", match.getAnchorHref() );
     *             console.log( "text = ", match.getAnchorText() );
     *
     *             switch( match.getType() ) {
     *                 case 'url' :
     *                     console.log( "url: ", match.getUrl() );
     *
     *                     if( match.getUrl().indexOf( 'mysite.com' ) === -1 ) {
     *                         var tag = match.buildTag();  // returns an `Autolinker.HtmlTag` instance, which provides mutator methods for easy changes
     *                         tag.setAttr( 'rel', 'nofollow' );
     *                         tag.addClass( 'external-link' );
     *
     *                         return tag;
     *
     *                     } else {
     *                         return true;  // let Autolinker perform its normal anchor tag replacement
     *                     }
     *
     *                 case 'email' :
     *                     var email = match.getEmail();
     *                     console.log( "email: ", email );
     *
     *                     if( email === "my@own.address" ) {
     *                         return false;  // don't auto-link this particular email address; leave as-is
     *                     } else {
     *                         return;  // no return value will have Autolinker perform its normal anchor tag replacement (same as returning `true`)
     *                     }
     *
     *                 case 'phone' :
     *                     var phoneNumber = match.getPhoneNumber();
     *                     console.log( phoneNumber );
     *
     *                     return '<a href="http://newplace.to.link.phone.numbers.to/">' + phoneNumber + '</a>';
     *
     *                 case 'hashtag' :
     *                     var hashtag = match.getHashtag();
     *                     console.log( hashtag );
     *
     *                     return '<a href="http://newplace.to.link.hashtag.handles.to/">' + hashtag + '</a>';
     *
     *                 case 'mention' :
     *                     var mention = match.getMention();
     *                     console.log( mention );
     *
     *                     return '<a href="http://newplace.to.link.mention.to/">' + mention + '</a>';
     *             }
     *         }
     *     } );
     *
     *
     * The function may return the following values:
     *
     * - `true` (Boolean): Allow Autolinker to replace the match as it normally
     *   would.
     * - `false` (Boolean): Do not replace the current match at all - leave as-is.
     * - Any String: If a string is returned from the function, the string will be
     *   used directly as the replacement HTML for the match.
     * - An {@link Autolinker.HtmlTag} instance, which can be used to build/modify
     *   an HTML tag before writing out its HTML text.
     */
    var Autolinker = /** @class */ (function () {
        /**
         * @method constructor
         * @param {Object} [cfg] The configuration options for the Autolinker instance,
         *   specified in an Object (map).
         */
        function Autolinker(cfg) {
            if (cfg === void 0) { cfg = {}; }
            /**
             * The Autolinker version number exposed on the instance itself.
             *
             * Ex: 0.25.1
             *
             * @property {String} version
             */
            this.version = Autolinker.version;
            /**
             * @cfg {Boolean/Object} [urls]
             *
             * `true` if URLs should be automatically linked, `false` if they should not
             * be. Defaults to `true`.
             *
             * Examples:
             *
             *     urls: true
             *
             *     // or
             *
             *     urls: {
             *         schemeMatches : true,
             *         tldMatches    : true,
             *         ipV4Matches   : true
             *     }
             *
             * As shown above, this option also accepts an Object form with 3 properties
             * to allow for more customization of what exactly gets linked. All default
             * to `true`:
             *
             * @cfg {Boolean} [urls.schemeMatches] `true` to match URLs found prefixed
             *   with a scheme, i.e. `http://google.com`, or `other+scheme://google.com`,
             *   `false` to prevent these types of matches.
             * @cfg {Boolean} [urls.tldMatches] `true` to match URLs with known top
             *   level domains (.com, .net, etc.) that are not prefixed with a scheme
             *   (such as 'http://'). This option attempts to match anything that looks
             *   like a URL in the given text. Ex: `google.com`, `asdf.org/?page=1`, etc.
             *   `false` to prevent these types of matches.
             * @cfg {Boolean} [urls.ipV4Matches] `true` to match IPv4 addresses in text
             *   that are not prefixed with a scheme (such as 'http://'). This option
             *   attempts to match anything that looks like an IPv4 address in text. Ex:
             *   `192.168.0.1`, `10.0.0.1/?page=1`, etc. `false` to prevent these types
             *   of matches.
             */
            this.urls = {}; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @cfg {Boolean} [email=true]
             *
             * `true` if email addresses should be automatically linked, `false` if they
             * should not be.
             */
            this.email = true; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @cfg {Boolean} [phone=true]
             *
             * `true` if Phone numbers ("(555)555-5555") should be automatically linked,
             * `false` if they should not be.
             */
            this.phone = true; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @cfg {Boolean/String} [hashtag=false]
             *
             * A string for the service name to have hashtags (ex: "#myHashtag")
             * auto-linked to. The currently-supported values are:
             *
             * - 'twitter'
             * - 'facebook'
             * - 'instagram'
             * - 'tiktok'
             * - 'youtube'
             *
             * Pass `false` to skip auto-linking of hashtags.
             */
            this.hashtag = false; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @cfg {String/Boolean} [mention=false]
             *
             * A string for the service name to have mentions (ex: "@myuser")
             * auto-linked to. The currently supported values are:
             *
             * - 'twitter'
             * - 'instagram'
             * - 'soundcloud'
             * - 'tiktok'
             * - 'youtube'
             *
             * Defaults to `false` to skip auto-linking of mentions.
             */
            this.mention = false; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @cfg {Boolean} [newWindow=true]
             *
             * `true` if the links should open in a new window, `false` otherwise.
             */
            this.newWindow = true; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @cfg {Boolean/Object} [stripPrefix=true]
             *
             * `true` if 'http://' (or 'https://') and/or the 'www.' should be stripped
             * from the beginning of URL links' text, `false` otherwise. Defaults to
             * `true`.
             *
             * Examples:
             *
             *     stripPrefix: true
             *
             *     // or
             *
             *     stripPrefix: {
             *         scheme : true,
             *         www    : true
             *     }
             *
             * As shown above, this option also accepts an Object form with 2 properties
             * to allow for more customization of what exactly is prevented from being
             * displayed. Both default to `true`:
             *
             * @cfg {Boolean} [stripPrefix.scheme] `true` to prevent the scheme part of
             *   a URL match from being displayed to the user. Example:
             *   `'http://google.com'` will be displayed as `'google.com'`. `false` to
             *   not strip the scheme. NOTE: Only an `'http://'` or `'https://'` scheme
             *   will be removed, so as not to remove a potentially dangerous scheme
             *   (such as `'file://'` or `'javascript:'`)
             * @cfg {Boolean} [stripPrefix.www] www (Boolean): `true` to prevent the
             *   `'www.'` part of a URL match from being displayed to the user. Ex:
             *   `'www.google.com'` will be displayed as `'google.com'`. `false` to not
             *   strip the `'www'`.
             */
            this.stripPrefix = {
                scheme: true,
                www: true,
            }; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @cfg {Boolean} [stripTrailingSlash=true]
             *
             * `true` to remove the trailing slash from URL matches, `false` to keep
             *  the trailing slash.
             *
             *  Example when `true`: `http://google.com/` will be displayed as
             *  `http://google.com`.
             */
            this.stripTrailingSlash = true; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @cfg {Boolean} [decodePercentEncoding=true]
             *
             * `true` to decode percent-encoded characters in URL matches, `false` to keep
             *  the percent-encoded characters.
             *
             *  Example when `true`: `https://en.wikipedia.org/wiki/San_Jos%C3%A9` will
             *  be displayed as `https://en.wikipedia.org/wiki/San_José`.
             */
            this.decodePercentEncoding = true; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @cfg {Number/Object} [truncate=0]
             *
             * ## Number Form
             *
             * A number for how many characters matched text should be truncated to
             * inside the text of a link. If the matched text is over this number of
             * characters, it will be truncated to this length by adding a two period
             * ellipsis ('..') to the end of the string.
             *
             * For example: A url like 'http://www.yahoo.com/some/long/path/to/a/file'
             * truncated to 25 characters might look something like this:
             * 'yahoo.com/some/long/pat..'
             *
             * Example Usage:
             *
             *     truncate: 25
             *
             *
             *  Defaults to `0` for "no truncation."
             *
             *
             * ## Object Form
             *
             * An Object may also be provided with two properties: `length` (Number) and
             * `location` (String). `location` may be one of the following: 'end'
             * (default), 'middle', or 'smart'.
             *
             * Example Usage:
             *
             *     truncate: { length: 25, location: 'middle' }
             *
             * @cfg {Number} [truncate.length=0] How many characters to allow before
             *   truncation will occur. Defaults to `0` for "no truncation."
             * @cfg {"end"/"middle"/"smart"} [truncate.location="end"]
             *
             * - 'end' (default): will truncate up to the number of characters, and then
             *   add an ellipsis at the end. Ex: 'yahoo.com/some/long/pat..'
             * - 'middle': will truncate and add the ellipsis in the middle. Ex:
             *   'yahoo.com/s..th/to/a/file'
             * - 'smart': for URLs where the algorithm attempts to strip out unnecessary
             *   parts first (such as the 'www.', then URL scheme, hash, etc.),
             *   attempting to make the URL human-readable before looking for a good
             *   point to insert the ellipsis if it is still too long. Ex:
             *   'yahoo.com/some..to/a/file'. For more details, see
             *   {@link Autolinker.truncate.TruncateSmart}.
             */
            this.truncate = {
                length: 0,
                location: 'end',
            }; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @cfg {String} className
             *
             * A CSS class name to add to the generated links. This class will be added
             * to all links, as well as this class plus match suffixes for styling
             * url/email/phone/hashtag/mention links differently.
             *
             * For example, if this config is provided as "myLink", then:
             *
             * - URL links will have the CSS classes: "myLink myLink-url"
             * - Email links will have the CSS classes: "myLink myLink-email", and
             * - Phone links will have the CSS classes: "myLink myLink-phone"
             * - Hashtag links will have the CSS classes: "myLink myLink-hashtag"
             * - Mention links will have the CSS classes: "myLink myLink-mention myLink-[type]"
             *   where [type] is either "instagram", "twitter" or "soundcloud"
             */
            this.className = ''; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @cfg {Function} replaceFn
             *
             * A function to individually process each match found in the input string.
             *
             * See the class's description for usage.
             *
             * The `replaceFn` can be called with a different context object (`this`
             * reference) using the {@link #context} cfg.
             *
             * This function is called with the following parameter:
             *
             * @cfg {Autolinker.match.Match} replaceFn.match The Match instance which
             *   can be used to retrieve information about the match that the `replaceFn`
             *   is currently processing. See {@link Autolinker.match.Match} subclasses
             *   for details.
             */
            this.replaceFn = null; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @cfg {Object} context
             *
             * The context object (`this` reference) to call the `replaceFn` with.
             *
             * Defaults to this Autolinker instance.
             */
            this.context = undefined; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @cfg {Boolean} [sanitizeHtml=false]
             *
             * `true` to HTML-encode the start and end brackets of existing HTML tags found
             * in the input string. This will escape `<` and `>` characters to `&lt;` and
             * `&gt;`, respectively.
             *
             * Setting this to `true` will prevent XSS (Cross-site Scripting) attacks,
             * but will remove the significance of existing HTML tags in the input string. If
             * you would like to maintain the significance of existing HTML tags while also
             * making the output HTML string safe, leave this option as `false` and use a
             * tool like https://github.com/cure53/DOMPurify (or others) on the input string
             * before running Autolinker.
             */
            this.sanitizeHtml = false; // default value just to get the above doc comment in the ES5 output and documentation generator
            /**
             * @private
             * @property {Autolinker.AnchorTagBuilder} tagBuilder
             *
             * The AnchorTagBuilder instance used to build match replacement anchor tags.
             * Note: this is lazily instantiated in the {@link #getTagBuilder} method.
             */
            this.tagBuilder = null;
            // Note: when `this.something` is used in the rhs of these assignments,
            //       it refers to the default values set above the constructor
            this.urls = normalizeUrlsCfg(cfg.urls);
            this.email = isBoolean(cfg.email) ? cfg.email : this.email;
            this.phone = isBoolean(cfg.phone) ? cfg.phone : this.phone;
            this.hashtag = cfg.hashtag || this.hashtag;
            this.mention = cfg.mention || this.mention;
            this.newWindow = isBoolean(cfg.newWindow) ? cfg.newWindow : this.newWindow;
            this.stripPrefix = normalizeStripPrefixCfg(cfg.stripPrefix);
            this.stripTrailingSlash = isBoolean(cfg.stripTrailingSlash)
                ? cfg.stripTrailingSlash
                : this.stripTrailingSlash;
            this.decodePercentEncoding = isBoolean(cfg.decodePercentEncoding)
                ? cfg.decodePercentEncoding
                : this.decodePercentEncoding;
            this.sanitizeHtml = cfg.sanitizeHtml || false;
            // Validate the value of the `mention` cfg
            var mention = this.mention;
            if (mention !== false && mentionServices.indexOf(mention) === -1) {
                throw new Error("invalid `mention` cfg '".concat(mention, "' - see docs"));
            }
            // Validate the value of the `hashtag` cfg
            var hashtag = this.hashtag;
            if (hashtag !== false && hashtagServices.indexOf(hashtag) === -1) {
                throw new Error("invalid `hashtag` cfg '".concat(hashtag, "' - see docs"));
            }
            this.truncate = normalizeTruncateCfg(cfg.truncate);
            this.className = cfg.className || this.className;
            this.replaceFn = cfg.replaceFn || this.replaceFn;
            this.context = cfg.context || this;
        }
        /**
         * Automatically links URLs, Email addresses, Phone Numbers, Twitter handles,
         * Hashtags, and Mentions found in the given chunk of HTML. Does not link URLs
         * found within HTML tags.
         *
         * For instance, if given the text: `You should go to http://www.yahoo.com`,
         * then the result will be `You should go to &lt;a href="http://www.yahoo.com"&gt;http://www.yahoo.com&lt;/a&gt;`
         *
         * Example:
         *
         *     var linkedText = Autolinker.link( "Go to google.com", { newWindow: false } );
         *     // Produces: "Go to <a href="http://google.com">google.com</a>"
         *
         * @static
         * @param {String} textOrHtml The HTML or text to find matches within (depending
         *   on if the {@link #urls}, {@link #email}, {@link #phone}, {@link #mention},
         *   {@link #hashtag}, and {@link #mention} options are enabled).
         * @param {Object} [options] Any of the configuration options for the Autolinker
         *   class, specified in an Object (map). See the class description for an
         *   example call.
         * @return {String} The HTML text, with matches automatically linked.
         */
        Autolinker.link = function (textOrHtml, options) {
            var autolinker = new Autolinker(options);
            return autolinker.link(textOrHtml);
        };
        /**
         * Parses the input `textOrHtml` looking for URLs, email addresses, phone
         * numbers, username handles, and hashtags (depending on the configuration
         * of the Autolinker instance), and returns an array of {@link Autolinker.match.Match}
         * objects describing those matches (without making any replacements).
         *
         * Note that if parsing multiple pieces of text, it is slightly more efficient
         * to create an Autolinker instance, and use the instance-level {@link #parse}
         * method.
         *
         * Example:
         *
         *     var matches = Autolinker.parse("Hello google.com, I am asdf@asdf.com", {
         *         urls: true,
         *         email: true
         *     });
         *
         *     console.log(matches.length);         // 2
         *     console.log(matches[0].getType());   // 'url'
         *     console.log(matches[0].getUrl());    // 'google.com'
         *     console.log(matches[1].getType());   // 'email'
         *     console.log(matches[1].getEmail());  // 'asdf@asdf.com'
         *
         * @static
         * @param {String} textOrHtml The HTML or text to find matches within
         *   (depending on if the {@link #urls}, {@link #email}, {@link #phone},
         *   {@link #hashtag}, and {@link #mention} options are enabled).
         * @param {Object} [options] Any of the configuration options for the Autolinker
         *   class, specified in an Object (map). See the class description for an
         *   example call.
         * @return {Autolinker.match.Match[]} The array of Matches found in the
         *   given input `textOrHtml`.
         */
        Autolinker.parse = function (textOrHtml, options) {
            var autolinker = new Autolinker(options);
            return autolinker.parse(textOrHtml);
        };
        /**
         * Parses the input `textOrHtml` looking for URLs, email addresses, phone
         * numbers, username handles, and hashtags (depending on the configuration
         * of the Autolinker instance), and returns an array of {@link Autolinker.match.Match}
         * objects describing those matches (without making any replacements).
         *
         * This method is used by the {@link #link} method, but can also be used to
         * simply do parsing of the input in order to discover what kinds of links
         * there are and how many.
         *
         * Example usage:
         *
         *     var autolinker = new Autolinker( {
         *         urls: true,
         *         email: true
         *     } );
         *
         *     var matches = autolinker.parse( "Hello google.com, I am asdf@asdf.com" );
         *
         *     console.log( matches.length );           // 2
         *     console.log( matches[ 0 ].getType() );   // 'url'
         *     console.log( matches[ 0 ].getUrl() );    // 'google.com'
         *     console.log( matches[ 1 ].getType() );   // 'email'
         *     console.log( matches[ 1 ].getEmail() );  // 'asdf@asdf.com'
         *
         * @param {String} textOrHtml The HTML or text to find matches within
         *   (depending on if the {@link #urls}, {@link #email}, {@link #phone},
         *   {@link #hashtag}, and {@link #mention} options are enabled).
         * @return {Autolinker.match.Match[]} The array of Matches found in the
         *   given input `textOrHtml`.
         */
        Autolinker.prototype.parse = function (textOrHtml) {
            var _this = this;
            var skipTagNames = ['a', 'style', 'script'];
            var skipTagsStackCount = 0; // used to only Autolink text outside of anchor/script/style tags. We don't want to autolink something that is already linked inside of an <a> tag, for instance
            var matches = [];
            // Find all matches within the `textOrHtml` (but not matches that are
            // already nested within <a>, <style> and <script> tags)
            parseHtml(textOrHtml, {
                onOpenTag: function (tagName) {
                    if (skipTagNames.indexOf(tagName) >= 0) {
                        skipTagsStackCount++;
                    }
                },
                onText: function (text, offset) {
                    // Only process text nodes that are not within an <a>, <style> or <script> tag
                    if (skipTagsStackCount === 0) {
                        // "Walk around" common HTML entities. An '&nbsp;' (for example)
                        // could be at the end of a URL, but we don't want to
                        // include the trailing '&' in the URL. See issue #76
                        // TODO: Handle HTML entities separately in parseHtml() and
                        // don't emit them as "text" except for &amp; entities
                        var htmlCharacterEntitiesRegex = /(&nbsp;|&#160;|&lt;|&#60;|&gt;|&#62;|&quot;|&#34;|&#39;)/gi; // NOTE: capturing group is significant to include the split characters in the .split() call below
                        var textSplit = text.split(htmlCharacterEntitiesRegex);
                        var currentOffset_1 = offset;
                        textSplit.forEach(function (splitText, i) {
                            // even number matches are text, odd numbers are html entities
                            if (i % 2 === 0) {
                                var textNodeMatches = _this.parseText(splitText, currentOffset_1);
                                matches.push.apply(matches, __spreadArray([], __read(textNodeMatches), false));
                            }
                            currentOffset_1 += splitText.length;
                        });
                    }
                },
                onCloseTag: function (tagName) {
                    if (skipTagNames.indexOf(tagName) >= 0) {
                        skipTagsStackCount = Math.max(skipTagsStackCount - 1, 0); // attempt to handle extraneous </a> tags by making sure the stack count never goes below 0
                    }
                },
                onComment: function ( /*_offset: number*/) { }, // no need to process comment nodes
                onDoctype: function ( /*_offset: number*/) { }, // no need to process doctype nodes
            });
            // After we have found all matches, remove subsequent matches that
            // overlap with a previous match. This can happen for instance with an
            // email address where the local-part of the email is also a top-level
            // domain, such as in "google.com@aaa.com". In this case, the entire
            // email address should be linked rather than just the 'google.com'
            // part.
            matches = this.compactMatches(matches);
            // And finally, remove matches for match types that have been turned
            // off. We needed to have all match types turned on initially so that
            // things like hashtags could be filtered out if they were really just
            // part of a URL match (for instance, as a named anchor).
            matches = this.removeUnwantedMatches(matches);
            return matches;
        };
        /**
         * After we have found all matches, we need to remove matches that overlap
         * with a previous match. This can happen for instance with an
         * email address where the local-part of the email is also a top-level
         * domain, such as in "google.com@aaa.com". In this case, the entire email
         * address should be linked rather than just the 'google.com' part.
         *
         * @private
         * @param {Autolinker.match.Match[]} matches
         * @return {Autolinker.match.Match[]}
         */
        Autolinker.prototype.compactMatches = function (matches) {
            // First, the matches need to be sorted in order of offset in the input
            // string
            matches.sort(byMatchOffset);
            var i = 0;
            while (i < matches.length - 1) {
                var match = matches[i];
                var offset = match.getOffset();
                var matchedTextLength = match.getMatchedText().length;
                if (i + 1 < matches.length) {
                    // Remove subsequent matches that equal offset with current match
                    // This can happen when matching the text "google.com@aaa.com"
                    // where we have both a URL ('google.com') and an email. We
                    // should only keep the email match in this case.
                    if (matches[i + 1].getOffset() === offset) {
                        // Remove the shorter match
                        var removeIdx = matches[i + 1].getMatchedText().length > matchedTextLength ? i : i + 1;
                        matches.splice(removeIdx, 1);
                        continue;
                    }
                    // Remove subsequent matches that overlap with the current match
                    //
                    // NOTE: This was a fundamental snippet of the Autolinker.js v3
                    // algorithm where we had multiple regular expressions searching
                    // the input string for matches. The regexes would sometimes
                    // overlap such as in the case of "google.com/#link", where we
                    // would have both a URL match and a hashtag match.
                    //
                    // However, the Autolinker.js v4 algorithm uses a state machine
                    // parser and knows that the '#link' part of 'google.com/#link'
                    // is part of the URL that precedes it, so we don't need this
                    // piece of code any more. Keeping it here commented for now in
                    // case we need to put it back at some point, but none of the
                    // test cases are currently able to trigger the need for it.
                    // const endIdx = offset + matchedTextLength;
                    // if (matches[i + 1].getOffset() < endIdx) {
                    //     matches.splice(i + 1, 1);
                    //     continue;
                    // }
                }
                i++;
            }
            return matches;
        };
        /**
         * Removes matches for matchers that were turned off in the options. For
         * example, if {@link #hashtag hashtags} were not to be matched, we'll
         * remove them from the `matches` array here.
         *
         * Note: we *must* use all Matchers on the input string, and then filter
         * them out later. For example, if the options were `{ url: false, hashtag: true }`,
         * we wouldn't want to match the text '#link' as a HashTag inside of the text
         * 'google.com/#link'. The way the algorithm works is that we match the full
         * URL first (which prevents the accidental HashTag match), and then we'll
         * simply throw away the URL match.
         *
         * @private
         * @param {Autolinker.match.Match[]} matches The array of matches to remove
         *   the unwanted matches from. Note: this array is mutated for the
         *   removals.
         * @return {Autolinker.match.Match[]} The mutated input `matches` array.
         */
        Autolinker.prototype.removeUnwantedMatches = function (matches) {
            if (!this.hashtag)
                removeWithPredicate(matches, function (match) {
                    return match.getType() === 'hashtag';
                });
            if (!this.email)
                removeWithPredicate(matches, function (match) {
                    return match.getType() === 'email';
                });
            if (!this.phone)
                removeWithPredicate(matches, function (match) {
                    return match.getType() === 'phone';
                });
            if (!this.mention)
                removeWithPredicate(matches, function (match) {
                    return match.getType() === 'mention';
                });
            if (!this.urls.schemeMatches) {
                removeWithPredicate(matches, function (m) {
                    return m.getType() === 'url' && m.getUrlMatchType() === 'scheme';
                });
            }
            if (!this.urls.tldMatches) {
                removeWithPredicate(matches, function (m) { return m.getType() === 'url' && m.getUrlMatchType() === 'tld'; });
            }
            if (!this.urls.ipV4Matches) {
                removeWithPredicate(matches, function (m) { return m.getType() === 'url' && m.getUrlMatchType() === 'ipV4'; });
            }
            return matches;
        };
        /**
         * Parses the input `text` looking for URLs, email addresses, phone
         * numbers, username handles, and hashtags (depending on the configuration
         * of the Autolinker instance), and returns an array of {@link Autolinker.match.Match}
         * objects describing those matches.
         *
         * This method processes a **non-HTML string**, and is used to parse and
         * match within the text nodes of an HTML string. This method is used
         * internally by {@link #parse}.
         *
         * @private
         * @param {String} text The text to find matches within (depending on if the
         *   {@link #urls}, {@link #email}, {@link #phone},
         *   {@link #hashtag}, and {@link #mention} options are enabled). This must be a non-HTML string.
         * @param {Number} [offset=0] The offset of the text node within the
         *   original string. This is used when parsing with the {@link #parse}
         *   method to generate correct offsets within the {@link Autolinker.match.Match}
         *   instances, but may be omitted if calling this method publicly.
         * @return {Autolinker.match.Match[]} The array of Matches found in the
         *   given input `text`.
         */
        Autolinker.prototype.parseText = function (text, offset) {
            offset = offset || 0;
            var matches = parseMatches(text, {
                tagBuilder: this.getTagBuilder(),
                stripPrefix: this.stripPrefix,
                stripTrailingSlash: this.stripTrailingSlash,
                decodePercentEncoding: this.decodePercentEncoding,
                hashtagServiceName: this.hashtag,
                mentionServiceName: this.mention || 'twitter',
            });
            // Correct the offset of each of the matches. They are originally
            // the offset of the match within the provided text node, but we
            // need to correct them to be relative to the original HTML input
            // string (i.e. the one provided to #parse).
            for (var i = 0, numTextMatches = matches.length; i < numTextMatches; i++) {
                matches[i].setOffset(offset + matches[i].getOffset());
            }
            return matches;
        };
        /**
         * Automatically links URLs, Email addresses, Phone numbers, Hashtags,
         * and Mentions (Twitter, Instagram, Soundcloud) found in the given chunk of HTML. Does not link
         * URLs found within HTML tags.
         *
         * For instance, if given the text: `You should go to http://www.yahoo.com`,
         * then the result will be `You should go to
         * &lt;a href="http://www.yahoo.com"&gt;http://www.yahoo.com&lt;/a&gt;`
         *
         * This method finds the text around any HTML elements in the input
         * `textOrHtml`, which will be the text that is processed. Any original HTML
         * elements will be left as-is, as well as the text that is already wrapped
         * in anchor (&lt;a&gt;) tags.
         *
         * @param {String} textOrHtml The HTML or text to autolink matches within
         *   (depending on if the {@link #urls}, {@link #email}, {@link #phone}, {@link #hashtag}, and {@link #mention} options are enabled).
         * @return {String} The HTML, with matches automatically linked.
         */
        Autolinker.prototype.link = function (textOrHtml) {
            if (!textOrHtml) {
                return '';
            } // handle `null` and `undefined` (for JavaScript users that don't have TypeScript support), and nothing to do with an empty string too
            /* We would want to sanitize the start and end characters of a tag
             * before processing the string in order to avoid an XSS scenario.
             * This behaviour can be changed by toggling the sanitizeHtml option.
             */
            if (this.sanitizeHtml) {
                textOrHtml = textOrHtml.replace(/</g, '&lt;').replace(/>/g, '&gt;');
            }
            var matches = this.parse(textOrHtml);
            var newHtml = new Array(matches.length * 2 + 1);
            var lastIndex = 0;
            for (var i = 0, len = matches.length; i < len; i++) {
                var match = matches[i];
                newHtml.push(textOrHtml.substring(lastIndex, match.getOffset()));
                newHtml.push(this.createMatchReturnVal(match));
                lastIndex = match.getOffset() + match.getMatchedText().length;
            }
            newHtml.push(textOrHtml.substring(lastIndex)); // handle the text after the last match
            return newHtml.join('');
        };
        /**
         * Creates the return string value for a given match in the input string.
         *
         * This method handles the {@link #replaceFn}, if one was provided.
         *
         * @private
         * @param {Autolinker.match.Match} match The Match object that represents
         *   the match.
         * @return {String} The string that the `match` should be replaced with.
         *   This is usually the anchor tag string, but may be the `matchStr` itself
         *   if the match is not to be replaced.
         */
        Autolinker.prototype.createMatchReturnVal = function (match) {
            // Handle a custom `replaceFn` being provided
            var replaceFnResult;
            if (this.replaceFn) {
                replaceFnResult = this.replaceFn.call(this.context, match); // Autolinker instance is the context
            }
            if (typeof replaceFnResult === 'string') {
                return replaceFnResult; // `replaceFn` returned a string, use that
            }
            else if (replaceFnResult === false) {
                return match.getMatchedText(); // no replacement for the match
            }
            else if (replaceFnResult instanceof HtmlTag) {
                return replaceFnResult.toAnchorString();
            }
            else {
                // replaceFnResult === true, or no/unknown return value from function
                // Perform Autolinker's default anchor tag generation
                var anchorTag = match.buildTag(); // returns an Autolinker.HtmlTag instance
                return anchorTag.toAnchorString();
            }
        };
        /**
         * Returns the {@link #tagBuilder} instance for this Autolinker instance,
         * lazily instantiating it if it does not yet exist.
         *
         * @private
         * @return {Autolinker.AnchorTagBuilder}
         */
        Autolinker.prototype.getTagBuilder = function () {
            var tagBuilder = this.tagBuilder;
            if (!tagBuilder) {
                tagBuilder = this.tagBuilder = new AnchorTagBuilder({
                    newWindow: this.newWindow,
                    truncate: this.truncate,
                    className: this.className,
                });
            }
            return tagBuilder;
        };
        // NOTE: must be 'export default' here for UMD module
        /**
         * @static
         * @property {String} version
         *
         * The Autolinker version number in the form major.minor.patch
         *
         * Ex: 3.15.0
         */
        Autolinker.version = version;
        return Autolinker;
    }());
    /**
     * Normalizes the {@link #urls} config into an Object with its 2 properties:
     * `schemeMatches` and `tldMatches`, both booleans.
     *
     * See {@link #urls} config for details.
     *
     * @private
     * @param {Boolean/Object} urls
     * @return {Object}
     */
    function normalizeUrlsCfg(urls) {
        if (urls == null)
            urls = true; // default to `true`
        if (isBoolean(urls)) {
            return { schemeMatches: urls, tldMatches: urls, ipV4Matches: urls };
        }
        else {
            // object form
            return {
                schemeMatches: isBoolean(urls.schemeMatches) ? urls.schemeMatches : true,
                tldMatches: isBoolean(urls.tldMatches) ? urls.tldMatches : true,
                ipV4Matches: isBoolean(urls.ipV4Matches) ? urls.ipV4Matches : true,
            };
        }
    }
    /**
     * Normalizes the {@link #stripPrefix} config into an Object with 2
     * properties: `scheme`, and `www` - both Booleans.
     *
     * See {@link #stripPrefix} config for details.
     *
     * @private
     * @param {Boolean/Object} stripPrefix
     * @return {Object}
     */
    function normalizeStripPrefixCfg(stripPrefix) {
        if (stripPrefix == null)
            stripPrefix = true; // default to `true`
        if (isBoolean(stripPrefix)) {
            return { scheme: stripPrefix, www: stripPrefix };
        }
        else {
            // object form
            return {
                scheme: isBoolean(stripPrefix.scheme) ? stripPrefix.scheme : true,
                www: isBoolean(stripPrefix.www) ? stripPrefix.www : true,
            };
        }
    }
    /**
     * Normalizes the {@link #truncate} config into an Object with 2 properties:
     * `length` (Number), and `location` (String).
     *
     * See {@link #truncate} config for details.
     *
     * @private
     * @param {Number/Object} truncate
     * @return {Object}
     */
    function normalizeTruncateCfg(truncate) {
        if (typeof truncate === 'number') {
            return { length: truncate, location: 'end' };
        }
        else {
            // object, or undefined/null
            return __assign({ length: Number.POSITIVE_INFINITY, location: 'end' }, truncate);
        }
    }
    /**
     * Helper function for Array.prototype.sort() to sort the Matches by
     * their offset in the input string.
     */
    function byMatchOffset(a, b) {
        return a.getOffset() - b.getOffset();
    }

    return Autolinker;

}));
//# sourceMappingURL=autolinker.js.map

},
'dojo/html':function(){
define(["./_base/kernel", "./_base/lang", "./_base/array", "./_base/declare", "./dom", "./dom-construct", "./parser"],
	function(kernel, lang, darray, declare, dom, domConstruct, parser){
	// module:
	//		dojo/html

	// the parser might be needed..

	// idCounter is incremented with each instantiation to allow assignment of a unique id for tracking, logging purposes
	var idCounter = 0;

	var html = {
		// summary:
		//		TODOC

		_secureForInnerHtml: function(/*String*/ cont){
			// summary:
			//		removes !DOCTYPE and title elements from the html string.
			//
			//		khtml is picky about dom faults, you can't attach a style or `<title>` node as child of body
			//		must go into head, so we need to cut out those tags
			// cont:
			//		An html string for insertion into the dom
			//
			return cont.replace(/(?:\s*<!DOCTYPE\s[^>]+>|<title[^>]*>[\s\S]*?<\/title>)/ig, ""); // String
		},

		// Deprecated, should use dojo/dom-constuct.empty() directly, remove in 2.0.
		_emptyNode: domConstruct.empty,

		_setNodeContent: function(/*DomNode*/ node, /*String|DomNode|NodeList*/ cont){
			// summary:
			//		inserts the given content into the given node
			// node:
			//		the parent element
			// content:
			//		the content to be set on the parent element.
			//		This can be an html string, a node reference or a NodeList, dojo/NodeList, Array or other enumerable list of nodes

			// always empty
			domConstruct.empty(node);

			if(cont){
				if(typeof cont == "number"){
					cont = cont.toString();
				}
				if(typeof cont == "string"){
					cont = domConstruct.toDom(cont, node.ownerDocument);
				}
				if(!cont.nodeType && lang.isArrayLike(cont)){
					// handle as enumerable, but it may shrink as we enumerate it
					for(var startlen=cont.length, i=0; i<cont.length; i=startlen==cont.length ? i+1 : 0){
						domConstruct.place( cont[i], node, "last");
					}
				}else{
					// pass nodes, documentFragments and unknowns through to dojo.place
					domConstruct.place(cont, node, "last");
				}
			}

			// return DomNode
			return node;
		},

		// we wrap up the content-setting operation in a object
		_ContentSetter: declare("dojo.html._ContentSetter", null, {
			// node: DomNode|String
			//		An node which will be the parent element that we set content into
			node: "",

			// content: String|DomNode|DomNode[]
			//		The content to be placed in the node. Can be an HTML string, a node reference, or a enumerable list of nodes
			content: "",

			// id: String?
			//		Usually only used internally, and auto-generated with each instance
			id: "",

			// cleanContent: Boolean
			//		Should the content be treated as a full html document,
			//		and the real content stripped of <html>, <body> wrapper before injection
			cleanContent: false,

			// extractContent: Boolean
			//		Should the content be treated as a full html document,
			//		and the real content stripped of `<html> <body>` wrapper before injection
			extractContent: false,

			// parseContent: Boolean
			//		Should the node by passed to the parser after the new content is set
			parseContent: false,

			// parserScope: String
			//		Flag passed to parser.	Root for attribute names to search for.	  If scopeName is dojo,
			//		will search for data-dojo-type (or dojoType).  For backwards compatibility
			//		reasons defaults to dojo._scopeName (which is "dojo" except when
			//		multi-version support is used, when it will be something like dojo16, dojo20, etc.)
			parserScope: kernel._scopeName,

			// startup: Boolean
			//		Start the child widgets after parsing them.	  Only obeyed if parseContent is true.
			startup: true,

			// lifecycle methods
			constructor: function(/*Object*/ params, /*String|DomNode*/ node){
				// summary:
				//		Provides a configurable, extensible object to wrap the setting on content on a node
				//		call the set() method to actually set the content..

				// the original params are mixed directly into the instance "this"
				lang.mixin(this, params || {});

				// give precedence to params.node vs. the node argument
				// and ensure its a node, not an id string
				node = this.node = dom.byId( this.node || node );

				if(!this.id){
					this.id = [
						"Setter",
						(node) ? node.id || node.tagName : "",
						idCounter++
					].join("_");
				}
			},
			set: function(/* String|DomNode|NodeList? */ cont, /*Object?*/ params){
				// summary:
				//		front-end to the set-content sequence
				// cont:
				//		An html string, node or enumerable list of nodes for insertion into the dom
				//		If not provided, the object's content property will be used
				if(undefined !== cont){
					this.content = cont;
				}
				if(typeof cont == 'number'){
					cont = cont.toString();
				}
				// in the re-use scenario, set needs to be able to mixin new configuration
				if(params){
					this._mixin(params);
				}

				this.onBegin();
				this.setContent();

				var ret = this.onEnd();

				if(ret && ret.then){
					// Make dojox/html/_ContentSetter.set() return a Promise that resolves when load and parse complete.
					return ret;
				}else{
					// Vanilla dojo/html._ContentSetter.set() returns a DOMNode for back compat.   For 2.0, switch it to
					// return a Deferred like above.
					return this.node;
				}
			},

			setContent: function(){
				// summary:
				//		sets the content on the node

				var node = this.node;
				if(!node){
					// can't proceed
					throw new Error(this.declaredClass + ": setContent given no node");
				}
				try{
					node = html._setNodeContent(node, this.content);
				}catch(e){
					// check if a domfault occurs when we are appending this.errorMessage
					// like for instance if domNode is a UL and we try append a DIV

					// FIXME: need to allow the user to provide a content error message string
					var errMess = this.onContentError(e);
					try{
						node.innerHTML = errMess;
					}catch(e){
						console.error('Fatal ' + this.declaredClass + '.setContent could not change content due to '+e.message, e);
					}
				}
				// always put back the node for the next method
				this.node = node; // DomNode
			},

			empty: function(){
				// summary:
				//		cleanly empty out existing content

				// If there is a parse in progress, cancel it.
				if(this.parseDeferred){
					if(!this.parseDeferred.isResolved()){
						this.parseDeferred.cancel();
					}
					delete this.parseDeferred;
				}

				// destroy any widgets from a previous run
				// NOTE: if you don't want this you'll need to empty
				// the parseResults array property yourself to avoid bad things happening
				if(this.parseResults && this.parseResults.length){
					darray.forEach(this.parseResults, function(w){
						if(w.destroy){
							w.destroy();
						}
					});
					delete this.parseResults;
				}
				// this is fast, but if you know its already empty or safe, you could
				// override empty to skip this step
				domConstruct.empty(this.node);
			},

			onBegin: function(){
				// summary:
				//		Called after instantiation, but before set();
				//		It allows modification of any of the object properties -
				//		including the node and content provided - before the set operation actually takes place
				//		This default implementation checks for cleanContent and extractContent flags to
				//		optionally pre-process html string content
				var cont = this.content;

				if(lang.isString(cont)){
					if(this.cleanContent){
						cont = html._secureForInnerHtml(cont);
					}

					if(this.extractContent){
						var match = cont.match(/<body[^>]*>\s*([\s\S]+)\s*<\/body>/im);
						if(match){ cont = match[1]; }
					}
				}

				// clean out the node and any cruft associated with it - like widgets
				this.empty();

				this.content = cont;
				return this.node; // DomNode
			},

			onEnd: function(){
				// summary:
				//		Called after set(), when the new content has been pushed into the node
				//		It provides an opportunity for post-processing before handing back the node to the caller
				//		This default implementation checks a parseContent flag to optionally run the dojo parser over the new content
				if(this.parseContent){
					// populates this.parseResults and this.parseDeferred if you need those..
					this._parse();
				}
				return this.node; // DomNode
				// TODO: for 2.0 return a Promise indicating that the parse completed.
			},

			tearDown: function(){
				// summary:
				//		manually reset the Setter instance if its being re-used for example for another set()
				// description:
				//		tearDown() is not called automatically.
				//		In normal use, the Setter instance properties are simply allowed to fall out of scope
				//		but the tearDown method can be called to explicitly reset this instance.
				delete this.parseResults;
				delete this.parseDeferred;
				delete this.node;
				delete this.content;
			},

			onContentError: function(err){
				return "Error occurred setting content: " + err;
			},

			onExecError: function(err){
				return "Error occurred executing scripts: " + err;
			},

			_mixin: function(params){
				// mix properties/methods into the instance
				// TODO: the intention with tearDown is to put the Setter's state
				// back to that of the original constructor (vs. deleting/resetting everything regardless of ctor params)
				// so we could do something here to move the original properties aside for later restoration
				var empty = {}, key;
				for(key in params){
					if(key in empty){ continue; }
					// TODO: here's our opportunity to mask the properties we don't consider configurable/overridable
					// .. but history shows we'll almost always guess wrong
					this[key] = params[key];
				}
			},
			_parse: function(){
				// summary:
				//		runs the dojo parser over the node contents, storing any results in this.parseResults
				//		and the parse promise in this.parseDeferred
				//		Any errors resulting from parsing are passed to _onError for handling

				var rootNode = this.node;
				try{
					// store the results (widgets, whatever) for potential retrieval
					var inherited = {};
					darray.forEach(["dir", "lang", "textDir"], function(name){
						if(this[name]){
							inherited[name] = this[name];
						}
					}, this);
					var self = this;
					this.parseDeferred = parser.parse({
						rootNode: rootNode,
						noStart: !this.startup,
						inherited: inherited,
						scope: this.parserScope
					}).then(function(results){
							return self.parseResults = results;
						}, function(e){
							self._onError('Content', e, "Error parsing in _ContentSetter#" + self.id);
						});
				}catch(e){
					this._onError('Content', e, "Error parsing in _ContentSetter#" + this.id);
				}
			},

			_onError: function(type, err, consoleText){
				// summary:
				//		shows user the string that is returned by on[type]Error
				//		override/implement on[type]Error and return your own string to customize
				var errText = this['on' + type + 'Error'].call(this, err);
				if(consoleText){
					console.error(consoleText, err);
				}else if(errText){ // a empty string won't change current content
					html._setNodeContent(this.node, errText, true);
				}
			}
		}), // end declare()

		set: function(/*DomNode*/ node, /*String|DomNode|NodeList*/ cont, /*Object?*/ params){
			// summary:
			//		inserts (replaces) the given content into the given node. dojo/dom-construct.place(cont, node, "only")
			//		may be a better choice for simple HTML insertion.
			// description:
			//		Unless you need to use the params capabilities of this method, you should use
			//		dojo/dom-construct.place(cont, node, "only"). dojo/dom-construct..place() has more robust support for injecting
			//		an HTML string into the DOM, but it only handles inserting an HTML string as DOM
			//		elements, or inserting a DOM node. dojo/dom-construct..place does not handle NodeList insertions
			//		dojo/dom-construct.place(cont, node, "only"). dojo/dom-construct.place() has more robust support for injecting
			//		an HTML string into the DOM, but it only handles inserting an HTML string as DOM
			//		elements, or inserting a DOM node. dojo/dom-construct.place does not handle NodeList insertions
			//		or the other capabilities as defined by the params object for this method.
			// node:
			//		the parent element that will receive the content
			// cont:
			//		the content to be set on the parent element.
			//		This can be an html string, a node reference or a NodeList, dojo/NodeList, Array or other enumerable list of nodes
			// params:
			//		Optional flags/properties to configure the content-setting. See dojo/html/_ContentSetter
			// example:
			//		A safe string/node/nodelist content replacement/injection with hooks for extension
			//		Example Usage:
			//	|	html.set(node, "some string");
			//	|	html.set(node, contentNode, {options});
			//	|	html.set(node, myNode.childNodes, {options});
			if(undefined == cont){
				console.warn("dojo.html.set: no cont argument provided, using empty string");
				cont = "";
			}
			if (typeof cont == 'number'){
				cont = cont.toString();
			}
			if(!params){
				// simple and fast
				return html._setNodeContent(node, cont, true);
			}else{
				// more options but slower
				// note the arguments are reversed in order, to match the convention for instantiation via the parser
				var op = new html._ContentSetter(lang.mixin(
					params,
					{ content: cont, node: node }
				));
				return op.set();
			}
		}
	};
	lang.setObject("dojo.html", html);

	return html;
});

},
'dojo/parser':function(){
define([
	"require", "./_base/kernel", "./_base/lang", "./_base/array", "./_base/config", "./dom", "./_base/window",
	"./_base/url", "./aspect", "./promise/all", "./date/stamp", "./Deferred", "./has", "./json5", "./query", "./on",
	"./ready"
], function(require, dojo, dlang, darray, config, dom, dwindow, _Url, aspect, all, dates, Deferred, has, json5, query,
	don, ready){

	// module:
	//		dojo/parser

	new Date("X"); // workaround for #11279, new Date("") == NaN

	var myEval;
	if(has('csp-restrictions')) {
		// JSON5 data attributes can be parsed without using eval; JS expressions will throw an error
		myEval = json5.parse;
	}
	else {
		myEval = function(text){
			// data-dojo-props etc. is not restricted to JSON, it can be any javascript
			/* jshint -W061 */
			return eval("(" + text + ")");
		};
	}

	// Widgets like BorderContainer add properties to _Widget via dojo.extend().
	// If BorderContainer is loaded after _Widget's parameter list has been cached,
	// we need to refresh that parameter list (for _Widget and all widgets that extend _Widget).
	var extendCnt = 0;
	aspect.after(dlang, "extend", function(){
		extendCnt++;
	}, true);

	function getNameMap(ctor){
		// summary:
		//		Returns map from lowercase name to attribute name in class, ex: {onclick: "onClick"}
		var map = ctor._nameCaseMap, proto = ctor.prototype;

		// Create the map if it's undefined.
		// Refresh the map if a superclass was possibly extended with new methods since the map was created.
		if(!map || map._extendCnt < extendCnt){
			map = ctor._nameCaseMap = {};
			for(var name in proto){
				if(name.charAt(0) === "_"){
					continue;
				}	// skip internal properties
				map[name.toLowerCase()] = name;
			}
			map._extendCnt = extendCnt;
		}
		return map;
	}

	function getCtor(/*String[]*/ types, /*Function?*/ contextRequire){
		// summary:
		//		Retrieves a constructor.  If the types array contains more than one class/MID then the
		//		subsequent classes will be mixed into the first class and a unique constructor will be
		//		returned for that array.

		if(!contextRequire){
			contextRequire = require;
		}

		// Map from widget name or list of widget names(ex: "dijit/form/Button,acme/MyMixin") to a constructor.
		// Keep separate map for each requireContext to avoid false matches (ex: "./Foo" can mean different things
		// depending on context.)
		var ctorMap = contextRequire._dojoParserCtorMap || (contextRequire._dojoParserCtorMap = {});

		var ts = types.join();
		if(!ctorMap[ts]){
			var mixins = [];
			for(var i = 0, l = types.length; i < l; i++){
				var t = types[i];
				// TODO: Consider swapping getObject and require in the future
				mixins[mixins.length] = (ctorMap[t] = ctorMap[t] || (dlang.getObject(t) || (~t.indexOf('/') &&
					contextRequire(t))));
			}
			var ctor = mixins.shift();
			ctorMap[ts] = mixins.length ? (ctor.createSubclass ? ctor.createSubclass(mixins) : ctor.extend.apply(ctor, mixins)) : ctor;
		}

		return ctorMap[ts];
	}

	var parser = {
		// summary:
		//		The Dom/Widget parsing package

		_clearCache: function(){
			// summary:
			//		Clear cached data.   Used mainly for benchmarking.
			extendCnt++;
			_ctorMap = {};
		},

		_functionFromScript: function(script, attrData){
			// summary:
			//		Convert a `<script type="dojo/method" args="a, b, c"> ... </script>`
			//		into a function
			// script: DOMNode
			//		The `<script>` DOMNode
			// attrData: String
			//		For HTML5 compliance, searches for attrData + "args" (typically
			//		"data-dojo-args") instead of "args"
			var preamble = "",
				suffix = "",
				argsStr = (script.getAttribute(attrData + "args") || script.getAttribute("args")),
				withStr = script.getAttribute("with");

			// Convert any arguments supplied in script tag into an array to be passed to the
			var fnArgs = (argsStr || "").split(/\s*,\s*/);

			if(withStr && withStr.length){
				darray.forEach(withStr.split(/\s*,\s*/), function(part){
					preamble += "with(" + part + "){";
					suffix += "}";
				});
			}

			return new Function(fnArgs, preamble + script.innerHTML + suffix);
		},

		instantiate: function(nodes, mixin, options){
			// summary:
			//		Takes array of nodes, and turns them into class instances and
			//		potentially calls a startup method to allow them to connect with
			//		any children.
			// nodes: Array
			//		Array of DOM nodes
			// mixin: Object?
			//		An object that will be mixed in with each node in the array.
			//		Values in the mixin will override values in the node, if they
			//		exist.
			// options: Object?
			//		An object used to hold kwArgs for instantiation.
			//		See parse.options argument for details.
			// returns:
			//		Array of instances.

			mixin = mixin || {};
			options = options || {};

			var dojoType = (options.scope || dojo._scopeName) + "Type", // typically "dojoType"
				attrData = "data-" + (options.scope || dojo._scopeName) + "-", // typically "data-dojo-"
				dataDojoType = attrData + "type", // typically "data-dojo-type"
				dataDojoMixins = attrData + "mixins";					// typically "data-dojo-mixins"

			var list = [];
			darray.forEach(nodes, function(node){
				var type = dojoType in mixin ? mixin[dojoType] : node.getAttribute(dataDojoType) || node.getAttribute(dojoType);
				if(type){
					var mixinsValue = node.getAttribute(dataDojoMixins),
						types = mixinsValue ? [type].concat(mixinsValue.split(/\s*,\s*/)) : [type];

					list.push({
						node: node,
						types: types
					});
				}
			});

			// Instantiate the nodes and return the list of instances.
			return this._instantiate(list, mixin, options);
		},

		_instantiate: function(nodes, mixin, options, returnPromise){
			// summary:
			//		Takes array of objects representing nodes, and turns them into class instances and
			//		potentially calls a startup method to allow them to connect with
			//		any children.
			// nodes: Array
			//		Array of objects like
			//	|		{
			//	|			ctor: Function (may be null)
			//	|			types: ["dijit/form/Button", "acme/MyMixin"] (used if ctor not specified)
			//	|			node: DOMNode,
			//	|			scripts: [ ... ],	// array of <script type="dojo/..."> children of node
			//	|			inherited: { ... }	// settings inherited from ancestors like dir, theme, etc.
			//	|		}
			// mixin: Object
			//		An object that will be mixed in with each node in the array.
			//		Values in the mixin will override values in the node, if they
			//		exist.
			// options: Object
			//		An options object used to hold kwArgs for instantiation.
			//		See parse.options argument for details.
			// returnPromise: Boolean
			//		Return a Promise rather than the instance; supports asynchronous widget creation.
			// returns:
			//		Array of instances, or if returnPromise is true, a promise for array of instances
			//		that resolves when instances have finished initializing.

			// Call widget constructors.   Some may be asynchronous and return promises.
			var thelist = darray.map(nodes, function(obj){
				var ctor = obj.ctor || getCtor(obj.types, options.contextRequire);
				// If we still haven't resolved a ctor, it is fatal now
				if(!ctor){
					throw new Error("Unable to resolve constructor for: '" + obj.types.join() + "'");
				}
				return this.construct(ctor, obj.node, mixin, options, obj.scripts, obj.inherited);
			}, this);

			// After all widget construction finishes, call startup on each top level instance if it makes sense (as for
			// widgets).  Parent widgets will recursively call startup on their (non-top level) children
			function onConstruct(thelist){
				if(!mixin._started && !options.noStart){
					darray.forEach(thelist, function(instance){
						if(typeof instance.startup === "function" && !instance._started){
							instance.startup();
						}
					});
				}

				return thelist;
			}

			if(returnPromise){
				return all(thelist).then(onConstruct);
			}else{
				// Back-compat path, remove for 2.0
				return onConstruct(thelist);
			}
		},

		construct: function(ctor, node, mixin, options, scripts, inherited){
			// summary:
			//		Calls new ctor(params, node), where params is the hash of parameters specified on the node,
			//		excluding data-dojo-type and data-dojo-mixins.   Does not call startup().
			// ctor: Function
			//		Widget constructor.
			// node: DOMNode
			//		This node will be replaced/attached to by the widget.  It also specifies the arguments to pass to ctor.
			// mixin: Object?
			//		Attributes in this object will be passed as parameters to ctor,
			//		overriding attributes specified on the node.
			// options: Object?
			//		An options object used to hold kwArgs for instantiation.   See parse.options argument for details.
			// scripts: DomNode[]?
			//		Array of `<script type="dojo/*">` DOMNodes.  If not specified, will search for `<script>` tags inside node.
			// inherited: Object?
			//		Settings from dir=rtl or lang=... on a node above this node.   Overrides options.inherited.
			// returns:
			//		Instance or Promise for the instance, if markupFactory() itself returned a promise

			var proto = ctor && ctor.prototype;
			options = options || {};

			// Setup hash to hold parameter settings for this widget.	Start with the parameter
			// settings inherited from ancestors ("dir" and "lang").
			// Inherited setting may later be overridden by explicit settings on node itself.
			var params = {};

			if(options.defaults){
				// settings for the document itself (or whatever subtree is being parsed)
				dlang.mixin(params, options.defaults);
			}
			if(inherited){
				// settings from dir=rtl or lang=... on a node above this node
				dlang.mixin(params, inherited);
			}

			// Get list of attributes explicitly listed in the markup
			var attributes;
			if(has("dom-attributes-explicit")){
				// Standard path to get list of user specified attributes
				attributes = node.attributes;
			}else if(has("dom-attributes-specified-flag")){
				// Special processing needed for IE8, to skip a few faux values in attributes[]
				attributes = darray.filter(node.attributes, function(a){
					return a.specified;
				});
			}else{
				// Special path for IE6-7, avoid (sometimes >100) bogus entries in node.attributes
				var clone = /^input$|^img$/i.test(node.nodeName) ? node : node.cloneNode(false),
					attrs = clone.outerHTML.replace(/=[^\s"']+|="[^"]*"|='[^']*'/g, "").replace(/^\s*<[a-zA-Z0-9]*\s*/, "").replace(/\s*>.*$/, "");

				attributes = darray.map(attrs.split(/\s+/), function(name){
					var lcName = name.toLowerCase();
					return {
						name: name,
						// getAttribute() doesn't work for button.value, returns innerHTML of button.
						// but getAttributeNode().value doesn't work for the form.encType or li.value
						value: (node.nodeName == "LI" && name == "value") || lcName == "enctype" ?
							node.getAttribute(lcName) : node.getAttributeNode(lcName).value
					};
				});
			}

			// Hash to convert scoped attribute name (ex: data-dojo17-params) to something friendly (ex: data-dojo-params)
			// TODO: remove scope for 2.0
			var scope = options.scope || dojo._scopeName,
				attrData = "data-" + scope + "-", // typically "data-dojo-"
				hash = {};
			if(scope !== "dojo"){
				hash[attrData + "props"] = "data-dojo-props";
				hash[attrData + "type"] = "data-dojo-type";
				hash[attrData + "mixins"] = "data-dojo-mixins";
				hash[scope + "type"] = "dojotype";
				hash[attrData + "id"] = "data-dojo-id";
			}

			// Read in attributes and process them, including data-dojo-props, data-dojo-type,
			// dojoAttachPoint, etc., as well as normal foo=bar attributes.
			var i = 0, item, funcAttrs = [], jsname, extra;
			while(item = attributes[i++]){
				var name = item.name,
					lcName = name.toLowerCase(),
					value = item.value;

				switch(hash[lcName] || lcName){
				// Already processed, just ignore
				case "data-dojo-type":
				case "dojotype":
				case "data-dojo-mixins":
					break;

				// Data-dojo-props.   Save for later to make sure it overrides direct foo=bar settings
				case "data-dojo-props":
					extra = value;
					break;

				// data-dojo-id or jsId. TODO: drop jsId in 2.0
				case "data-dojo-id":
				case "jsid":
					jsname = value;
					break;

				// For the benefit of _Templated
				case "data-dojo-attach-point":
				case "dojoattachpoint":
					params.dojoAttachPoint = value;
					break;
				case "data-dojo-attach-event":
				case "dojoattachevent":
					params.dojoAttachEvent = value;
					break;

				// Special parameter handling needed for IE
				case "class":
					params["class"] = node.className;
					break;
				case "style":
					params["style"] = node.style && node.style.cssText;
					break;
				default:
					// Normal attribute, ex: value="123"

					// Find attribute in widget corresponding to specified name.
					// May involve case conversion, ex: onclick --> onClick
					if(!(name in proto)){
						var map = getNameMap(ctor);
						name = map[lcName] || name;
					}

					// Set params[name] to value, doing type conversion
					if(name in proto){
						switch(typeof proto[name]){
						case "string":
							params[name] = value;
							break;
						case "number":
							params[name] = value.length ? Number(value) : NaN;
							break;
						case "boolean":
							// for checked/disabled value might be "" or "checked".	 interpret as true.
							params[name] = value.toLowerCase() != "false";
							break;
						case "function":
							if(value === "" || value.search(/[^\w\.]+/i) != -1){
								// The user has specified some text for a function like "return x+5"
								params[name] = new Function(value);
							}else{
								// The user has specified the name of a global function like "myOnClick"
								// or a single word function "return"
								params[name] = dlang.getObject(value, false) || new Function(value);
							}
							funcAttrs.push(name);	// prevent "double connect", see #15026
							break;
						default:
							var pVal = proto[name];
							try{
								params[name] =
									(pVal && "length" in pVal) ? (value ? value.split(/\s*,\s*/) : []) :	// array
										(pVal instanceof Date) ?
											(value == "" ? new Date("") :	// the NaN of dates
											value == "now" ? new Date() :	// current date
											dates.fromISOString(value)) :
									(pVal instanceof _Url) ? (dojo.baseUrl + value) :
									myEval(value);
							}
							catch(error){
								console.error(error);
							}
						}
					}else{
						params[name] = value;
					}
				}
			}

			// Remove function attributes from DOMNode to prevent "double connect" problem, see #15026.
			// Do this as a separate loop since attributes[] is often a live collection (depends on the browser though).
			for(var j = 0; j < funcAttrs.length; j++){
				var lcfname = funcAttrs[j].toLowerCase();
				node.removeAttribute(lcfname);
				node[lcfname] = null;
			}

			// Mix things found in data-dojo-props into the params, overriding any direct settings
			if(extra){
				try{
					extra = myEval.call(options.propsThis, "{" + extra + "}");
					dlang.mixin(params, extra);
				}catch(e){
					// give the user a pointer to their invalid parameters. FIXME: can we kill this in production?
					throw new Error(e.toString() + " in data-dojo-props='" + extra + "'");
				}
			}

			// Any parameters specified in "mixin" override everything else.
			dlang.mixin(params, mixin);

			// Get <script> nodes associated with this widget, if they weren't specified explicitly
			if(!scripts){
				scripts = (ctor && (ctor._noScript || proto._noScript) ? [] : query("> script[type^='dojo/']", node));
			}

			// Process <script type="dojo/*"> script tags
			// <script type="dojo/method" data-dojo-event="foo"> tags are added to params, and passed to
			// the widget on instantiation.
			// <script type="dojo/method"> tags (with no event) are executed after instantiation
			// <script type="dojo/connect" data-dojo-event="foo"> tags are dojo.connected after instantiation,
			// and likewise with <script type="dojo/aspect" data-dojo-method="foo">
			// <script type="dojo/watch" data-dojo-prop="foo"> tags are dojo.watch after instantiation
			// <script type="dojo/on" data-dojo-event="foo"> tags are dojo.on after instantiation
			// note: dojo/* script tags cannot exist in self closing widgets, like <input />
			var aspects = [],	// aspects to connect after instantiation
				calls = [],		// functions to call after instantiation
				watches = [],  // functions to watch after instantiation
				ons = []; // functions to on after instantiation

			if(scripts){
				for(i = 0; i < scripts.length; i++){
					var script = scripts[i];
					node.removeChild(script);
					// FIXME: drop event="" support in 2.0. use data-dojo-event="" instead
					var event = (script.getAttribute(attrData + "event") || script.getAttribute("event")),
						prop = script.getAttribute(attrData + "prop"),
						method = script.getAttribute(attrData + "method"),
						advice = script.getAttribute(attrData + "advice"),
						scriptType = script.getAttribute("type"),
						nf = this._functionFromScript(script, attrData);
					if(event){
						if(scriptType == "dojo/connect"){
							aspects.push({ method: event, func: nf });
						}else if(scriptType == "dojo/on"){
							ons.push({ event: event, func: nf });
						}else{
							// <script type="dojo/method" data-dojo-event="foo">
							// TODO for 2.0: use data-dojo-method="foo" instead (also affects dijit/Declaration)
							params[event] = nf;
						}
					}else if(scriptType == "dojo/aspect"){
						aspects.push({ method: method, advice: advice, func: nf });
					}else if(scriptType == "dojo/watch"){
						watches.push({ prop: prop, func: nf });
					}else{
						calls.push(nf);
					}
				}
			}

			// create the instance
			var markupFactory = ctor.markupFactory || proto.markupFactory;
			var instance = markupFactory ? markupFactory(params, node, ctor) : new ctor(params, node);

			function onInstantiate(instance){
				// map it to the JS namespace if that makes sense
				if(jsname){
					dlang.setObject(jsname, instance);
				}

				// process connections and startup functions
				for(i = 0; i < aspects.length; i++){
					aspect[aspects[i].advice || "after"](instance, aspects[i].method, dlang.hitch(instance, aspects[i].func), true);
				}
				for(i = 0; i < calls.length; i++){
					calls[i].call(instance);
				}
				for(i = 0; i < watches.length; i++){
					instance.watch(watches[i].prop, watches[i].func);
				}
				for(i = 0; i < ons.length; i++){
					don(instance, ons[i].event, ons[i].func);
				}

				return instance;
			}

			if(instance.then){
				return instance.then(onInstantiate);
			}else{
				return onInstantiate(instance);
			}
		},

		scan: function(root, options){
			// summary:
			//		Scan a DOM tree and return an array of objects representing the DOMNodes
			//		that need to be turned into widgets.
			// description:
			//		Search specified node (or document root node) recursively for class instances
			//		and return an array of objects that represent potential widgets to be
			//		instantiated. Searches for either data-dojo-type="MID" or dojoType="MID" where
			//		"MID" is a module ID like "dijit/form/Button" or a fully qualified Class name
			//		like "dijit/form/Button".  If the MID is not currently available, scan will
			//		attempt to require() in the module.
			//
			//		See parser.parse() for details of markup.
			// root: DomNode?
			//		A default starting root node from which to start the parsing. Can be
			//		omitted, defaulting to the entire document. If omitted, the `options`
			//		object can be passed in this place. If the `options` object has a
			//		`rootNode` member, that is used.
			// options: Object
			//		a kwArgs options object, see parse() for details
			//
			// returns: Promise
			//		A promise that is resolved with the nodes that have been parsed.

			var list = [], // Output List
				mids = [], // An array of modules that are not yet loaded
				midsHash = {}; // Used to keep the mids array unique

			var dojoType = (options.scope || dojo._scopeName) + "Type", // typically "dojoType"
				attrData = "data-" + (options.scope || dojo._scopeName) + "-", // typically "data-dojo-"
				dataDojoType = attrData + "type", // typically "data-dojo-type"
				dataDojoTextDir = attrData + "textdir", // typically "data-dojo-textdir"
				dataDojoMixins = attrData + "mixins";					// typically "data-dojo-mixins"

			// Info on DOMNode currently being processed
			var node = root.firstChild;

			// Info on parent of DOMNode currently being processed
			//	- inherited: dir, lang, and textDir setting of parent, or inherited by parent
			//	- parent: pointer to identical structure for my parent (or null if no parent)
			//	- scripts: if specified, collects <script type="dojo/..."> type nodes from children
			var inherited = options.inherited;
			if(!inherited){
				var findAncestorAttr = function findAncestorAttr(node, attr){
					return (node.getAttribute && node.getAttribute(attr)) ||
						(node.parentNode && findAncestorAttr(node.parentNode, attr));
				};

				inherited = {
					dir: findAncestorAttr(root, "dir"),
					lang: findAncestorAttr(root, "lang"),
					textDir: findAncestorAttr(root, dataDojoTextDir)
				};
				for(var key in inherited){
					if(!inherited[key]){
						delete inherited[key];
					}
				}
			}

			// Metadata about parent node
			var parent = {
				inherited: inherited
			};

			// For collecting <script type="dojo/..."> type nodes (when null, we don't need to collect)
			var scripts;

			// when true, only look for <script type="dojo/..."> tags, and don't recurse to children
			var scriptsOnly;

			function getEffective(parent){
				// summary:
				//		Get effective dir, lang, textDir settings for specified obj
				//		(matching "parent" object structure above), and do caching.
				//		Take care not to return null entries.
				if(!parent.inherited){
					parent.inherited = {};
					var node = parent.node,
						grandparent = getEffective(parent.parent);
					var inherited = {
						dir: node.getAttribute("dir") || grandparent.dir,
						lang: node.getAttribute("lang") || grandparent.lang,
						textDir: node.getAttribute(dataDojoTextDir) || grandparent.textDir
					};
					for(var key in inherited){
						if(inherited[key]){
							parent.inherited[key] = inherited[key];
						}
					}
				}
				return parent.inherited;
			}

			// DFS on DOM tree, collecting nodes with data-dojo-type specified.
			while(true){
				if(!node){
					// Finished this level, continue to parent's next sibling
					if(!parent || !parent.node){
						break;
					}
					node = parent.node.nextSibling;
					scriptsOnly = false;
					parent = parent.parent;
					scripts = parent.scripts;
					continue;
				}

				if(node.nodeType != 1){
					// Text or comment node, skip to next sibling
					node = node.nextSibling;
					continue;
				}

				if(scripts && node.nodeName.toLowerCase() == "script"){
					// Save <script type="dojo/..."> for parent, then continue to next sibling
					type = node.getAttribute("type");
					if(type && /^dojo\/\w/i.test(type)){
						scripts.push(node);
					}
					node = node.nextSibling;
					continue;
				}
				if(scriptsOnly){
					// scriptsOnly flag is set, we have already collected scripts if the parent wants them, so now we shouldn't
					// continue further analysis of the node and will continue to the next sibling
					node = node.nextSibling;
					continue;
				}

				// Check for data-dojo-type attribute, fallback to backward compatible dojoType
				// TODO: Remove dojoType in 2.0
				var type = node.getAttribute(dataDojoType) || node.getAttribute(dojoType);

				// Short circuit for leaf nodes containing nothing [but text]
				var firstChild = node.firstChild;
				if(!type && (!firstChild || (firstChild.nodeType == 3 && !firstChild.nextSibling))){
					node = node.nextSibling;
					continue;
				}

				// Meta data about current node
				var current;

				var ctor = null;
				if(type){
					// If dojoType/data-dojo-type specified, add to output array of nodes to instantiate.
					var mixinsValue = node.getAttribute(dataDojoMixins),
						types = mixinsValue ? [type].concat(mixinsValue.split(/\s*,\s*/)) : [type];

					// Note: won't find classes declared via dojo/Declaration or any modules that haven't been
					// loaded yet so use try/catch to avoid throw from require()
					try{
						ctor = getCtor(types, options.contextRequire);
					}catch(e){}

					// If the constructor was not found, check to see if it has modules that can be loaded
					if(!ctor){
						darray.forEach(types, function(t){
							if(~t.indexOf('/') && !midsHash[t]){
								// If the type looks like a MID and it currently isn't in the array of MIDs to load, add it.
								midsHash[t] = true;
								mids[mids.length] = t;
							}
						});
					}

					var childScripts = ctor && !ctor.prototype._noScript ? [] : null; // <script> nodes that are parent's children

					// Setup meta data about this widget node, and save it to list of nodes to instantiate
					current = {
						types: types,
						ctor: ctor,
						parent: parent,
						node: node,
						scripts: childScripts
					};
					current.inherited = getEffective(current); // dir & lang settings for current node, explicit or inherited
					list.push(current);
				}else{
					// Meta data about this non-widget node
					current = {
						node: node,
						scripts: scripts,
						parent: parent
					};
				}

				// Recurse, collecting <script type="dojo/..."> children, and also looking for
				// descendant nodes with dojoType specified (unless the widget has the stopParser flag).
				// When finished with children, go to my next sibling.
				scripts = childScripts;
				scriptsOnly = node.stopParser || (ctor && ctor.prototype.stopParser && !(options.template));
				parent = current;
				node = firstChild;
			}

			var d = new Deferred();

			// If there are modules to load then require them in
			if(mids.length){
				// Warn that there are modules being auto-required
				if(has("dojo-debug-messages")){
					console.warn("WARNING: Modules being Auto-Required: " + mids.join(", "));
				}
				var r = options.contextRequire || require;
				r(mids, function(){
					// Go through list of widget nodes, filling in missing constructors, and filtering out nodes that shouldn't
					// be instantiated due to a stopParser flag on an ancestor that we belatedly learned about due to
					// auto-require of a module like ContentPane.   Assumes list is in DFS order.
					d.resolve(darray.filter(list, function(widget){
						if(!widget.ctor){
							// Attempt to find the constructor again.   Still won't find classes defined via
							// dijit/Declaration so need to try/catch.
							try{
								widget.ctor = getCtor(widget.types, options.contextRequire);
							}catch(e){}
						}

						// Get the parent widget
						var parent = widget.parent;
						while(parent && !parent.types){
							parent = parent.parent;
						}

						// Return false if this node should be skipped due to stopParser on an ancestor.
						// Since list[] is in DFS order, this loop will always set parent.instantiateChildren before
						// trying to compute widget.instantiate.
						var proto = widget.ctor && widget.ctor.prototype;
						widget.instantiateChildren = !(proto && proto.stopParser && !(options.template));
						widget.instantiate = !parent || (parent.instantiate && parent.instantiateChildren);
						return widget.instantiate;
					}));
				});
			}else{
				// There were no modules to load, so just resolve with the parsed nodes.   This separate code path is for
				// efficiency, to avoid running the require() and the callback code above.
				d.resolve(list);
			}

			// Return the promise
			return d.promise;
		},

		_require: function(/*DOMNode*/ script, /*Object?*/ options){
			// summary:
			//		Helper for _scanAMD().  Takes a `<script type=dojo/require>bar: "acme/bar", ...</script>` node,
			//		calls require() to load the specified modules and (asynchronously) assign them to the specified global
			//		variables, and returns a Promise for when that operation completes.
			//
			//		In the example above, it is effectively doing a require(["acme/bar", ...], function(a){ bar = a; }).

			var hash = myEval("{" + script.innerHTML + "}"), // can't use dojo/json::parse() because maybe no quotes
				vars = [],
				mids = [],
				d = new Deferred();

			var contextRequire = (options && options.contextRequire) || require;

			for(var name in hash){
				vars.push(name);
				mids.push(hash[name]);
			}

			contextRequire(mids, function(){
				for(var i = 0; i < vars.length; i++){
					dlang.setObject(vars[i], arguments[i]);
				}
				d.resolve(arguments);
			});

			return d.promise;
		},

		_scanAmd: function(root, options){
			// summary:
			//		Scans the DOM for any declarative requires and returns their values.
			// description:
			//		Looks for `<script type=dojo/require>bar: "acme/bar", ...</script>` node, calls require() to load the
			//		specified modules and (asynchronously) assign them to the specified global variables,
			//		and returns a Promise for when those operations complete.
			// root: DomNode
			//		The node to base the scan from.
			// options: Object?
			//		a kwArgs options object, see parse() for details

			// Promise that resolves when all the <script type=dojo/require> nodes have finished loading.
			var deferred = new Deferred(),
				promise = deferred.promise;
			deferred.resolve(true);

			var self = this;
			query("script[type='dojo/require']", root).forEach(function(node){
				// Fire off require() call for specified modules.  Chain this require to fire after
				// any previous requires complete, so that layers can be loaded before individual module require()'s fire.
				promise = promise.then(function(){
					return self._require(node, options);
				});

				// Remove from DOM so it isn't seen again
				node.parentNode.removeChild(node);
			});

			return promise;
		},

		parse: function(rootNode, options){
			// summary:
			//		Scan the DOM for class instances, and instantiate them.
			// description:
			//		Search specified node (or root node) recursively for class instances,
			//		and instantiate them. Searches for either data-dojo-type="Class" or
			//		dojoType="Class" where "Class" is a a fully qualified class name,
			//		like `dijit/form/Button`
			//
			//		Using `data-dojo-type`:
			//		Attributes using can be mixed into the parameters used to instantiate the
			//		Class by using a `data-dojo-props` attribute on the node being converted.
			//		`data-dojo-props` should be a string attribute to be converted from JSON.
			//
			//		Using `dojoType`:
			//		Attributes are read from the original domNode and converted to appropriate
			//		types by looking up the Class prototype values. This is the default behavior
			//		from Dojo 1.0 to Dojo 1.5. `dojoType` support is deprecated, and will
			//		go away in Dojo 2.0.
			// rootNode: DomNode?
			//		A default starting root node from which to start the parsing. Can be
			//		omitted, defaulting to the entire document. If omitted, the `options`
			//		object can be passed in this place. If the `options` object has a
			//		`rootNode` member, that is used.
			// options: Object?
			//		A hash of options.
			//
			//		- noStart: Boolean?:
			//			when set will prevent the parser from calling .startup()
			//			when locating the nodes.
			//		- rootNode: DomNode?:
			//			identical to the function's `rootNode` argument, though
			//			allowed to be passed in via this `options object.
			//		- template: Boolean:
			//			If true, ignores ContentPane's stopParser flag and parses contents inside of
			//			a ContentPane inside of a template.   This allows dojoAttachPoint on widgets/nodes
			//			nested inside the ContentPane to work.
			//		- inherited: Object:
			//			Hash possibly containing dir and lang settings to be applied to
			//			parsed widgets, unless there's another setting on a sub-node that overrides
			//		- scope: String:
			//			Root for attribute names to search for.   If scopeName is dojo,
			//			will search for data-dojo-type (or dojoType).   For backwards compatibility
			//			reasons defaults to dojo._scopeName (which is "dojo" except when
			//			multi-version support is used, when it will be something like dojo16, dojo20, etc.)
			//		- propsThis: Object:
			//			If specified, "this" referenced from data-dojo-props will refer to propsThis.
			//			Intended for use from the widgets-in-template feature of `dijit._WidgetsInTemplateMixin`
			//		- contextRequire: Function:
			//			If specified, this require is utilised for looking resolving modules instead of the
			//			`dojo/parser` context `require()`.  Intended for use from the widgets-in-template feature of
			//			`dijit._WidgetsInTemplateMixin`.
			// returns: Mixed
			//		Returns a blended object that is an array of the instantiated objects, but also can include
			//		a promise that is resolved with the instantiated objects.  This is done for backwards
			//		compatibility.  If the parser auto-requires modules, it will always behave in a promise
			//		fashion and `parser.parse().then(function(instances){...})` should be used.
			// example:
			//		Parse all widgets on a page:
			//	|		parser.parse();
			// example:
			//		Parse all classes within the node with id="foo"
			//	|		parser.parse(dojo.byId('foo'));
			// example:
			//		Parse all classes in a page, but do not call .startup() on any
			//		child
			//	|		parser.parse({ noStart: true })
			// example:
			//		Parse all classes in a node, but do not call .startup()
			//	|		parser.parse(someNode, { noStart:true });
			//	|		// or
			//	|		parser.parse({ noStart:true, rootNode: someNode });

			// determine the root node and options based on the passed arguments.
			if(rootNode && typeof rootNode != "string" && !("nodeType" in rootNode)){
				// If called as parse(options) rather than parse(), parse(rootNode), or parse(rootNode, options)...
				options = rootNode;
				rootNode = options.rootNode;
			}
			var root = rootNode ? dom.byId(rootNode) : dwindow.body();
			options = options || {};

			var mixin = options.template ? { template: true } : {},
				instances = [],
				self = this;

			// First scan for any <script type=dojo/require> nodes, and execute.
			// Then scan for all nodes with data-dojo-type, and load any unloaded modules.
			// Then build the object instances.  Add instances to already existing (but empty) instances[] array,
			// which may already have been returned to caller.  Also, use otherwise to collect and throw any errors
			// that occur during the parse().
			var p =
				this._scanAmd(root, options).then(function(){
					return self.scan(root, options);
				}).then(function(parsedNodes){
					return self._instantiate(parsedNodes, mixin, options, true);
				}).then(function(_instances){
					// Copy the instances into the instances[] array we declared above, and are accessing as
					// our return value.
					return instances = instances.concat(_instances);
				}).otherwise(function(e){
					// TODO Modify to follow better pattern for promise error management when available
					console.error("dojo/parser::parse() error", e);
					throw e;
				});

			// Blend the array with the promise
			dlang.mixin(instances, p);
			return instances;
		}
	};

	if( 1 ){
		dojo.parser = parser;
	}

	// Register the parser callback. It should be the first callback
	// after the a11y test.
	if(config.parseOnLoad){
		ready(100, parser, "parse");
	}

	return parser;
});

},
'dojo/_base/url':function(){
define(["./kernel"], function(dojo){
	// module:
	//		dojo/url

	var
		ore = new RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?$"),
		ire = new RegExp("^((([^\\[:]+):)?([^@]+)@)?(\\[([^\\]]+)\\]|([^\\[:]*))(:([0-9]+))?$"),
		_Url = function(){
			var n = null,
				_a = arguments,
				uri = [_a[0]];
			// resolve uri components relative to each other
			for(var i = 1; i<_a.length; i++){
				if(!_a[i]){ continue; }

				// Safari doesn't support this.constructor so we have to be explicit
				// FIXME: Tracked (and fixed) in Webkit bug 3537.
				//		http://bugs.webkit.org/show_bug.cgi?id=3537
				var relobj = new _Url(_a[i]+""),
					uriobj = new _Url(uri[0]+"");

				if(
					relobj.path == "" &&
					!relobj.scheme &&
					!relobj.authority &&
					!relobj.query
				){
					if(relobj.fragment != n){
						uriobj.fragment = relobj.fragment;
					}
					relobj = uriobj;
				}else if(!relobj.scheme){
					relobj.scheme = uriobj.scheme;

					if(!relobj.authority){
						relobj.authority = uriobj.authority;

						if(relobj.path.charAt(0) != "/"){
							var path = uriobj.path.substring(0,
								uriobj.path.lastIndexOf("/") + 1) + relobj.path;

							var segs = path.split("/");
							for(var j = 0; j < segs.length; j++){
								if(segs[j] == "."){
									// flatten "./" references
									if(j == segs.length - 1){
										segs[j] = "";
									}else{
										segs.splice(j, 1);
										j--;
									}
								}else if(j > 0 && !(j == 1 && segs[0] == "") &&
									segs[j] == ".." && segs[j-1] != ".."){
									// flatten "../" references
									if(j == (segs.length - 1)){
										segs.splice(j, 1);
										segs[j - 1] = "";
									}else{
										segs.splice(j - 1, 2);
										j -= 2;
									}
								}
							}
							relobj.path = segs.join("/");
						}
					}
				}

				uri = [];
				if(relobj.scheme){
					uri.push(relobj.scheme, ":");
				}
				if(relobj.authority){
					uri.push("//", relobj.authority);
				}
				uri.push(relobj.path);
				if(relobj.query){
					uri.push("?", relobj.query);
				}
				if(relobj.fragment){
					uri.push("#", relobj.fragment);
				}
			}

			this.uri = uri.join("");

			// break the uri into its main components
			var r = this.uri.match(ore);

			this.scheme = r[2] || (r[1] ? "" : n);
			this.authority = r[4] || (r[3] ? "" : n);
			this.path = r[5]; // can never be undefined
			this.query = r[7] || (r[6] ? "" : n);
			this.fragment	 = r[9] || (r[8] ? "" : n);

			if(this.authority != n){
				// server based naming authority
				r = this.authority.match(ire);

				this.user = r[3] || n;
				this.password = r[4] || n;
				this.host = r[6] || r[7]; // ipv6 || ipv4
				this.port = r[9] || n;
			}
		};
	_Url.prototype.toString = function(){ return this.uri; };

	return dojo._Url = _Url;
});

},
'dojo/promise/all':function(){
define([
	"../_base/array",
	"../_base/lang",
	"../Deferred",
	"../when"
], function(array, lang, Deferred, when){
	"use strict";

	// module:
	//		dojo/promise/all

	var some = array.some;

	return function all(objectOrArray){
		// summary:
		//		Takes multiple promises and returns a new promise that is fulfilled
		//		when all promises have been resolved or one has been rejected.
		// description:
		//		Takes multiple promises and returns a new promise that is fulfilled
		//		when all promises have been resolved or one has been rejected. If one of
		//		the promises is rejected, the returned promise is also rejected. Canceling
		//		the returned promise will *not* cancel any passed promises.
		// objectOrArray: Object|Array?
		//		The promise will be fulfilled with a list of results if invoked with an
		//		array, or an object of results when passed an object (using the same
		//		keys). If passed neither an object or array it is resolved with an
		//		undefined value.
		// returns: dojo/promise/Promise

		var object, array;
		if(lang.isArray(objectOrArray)){
			array = objectOrArray;
		}else if(objectOrArray && typeof objectOrArray === "object"){
			object = objectOrArray;
		}

		var results;
		var keyLookup = [];
		if(object){
			array = [];
			for(var key in object){
				if(Object.hasOwnProperty.call(object, key)){
					keyLookup.push(key);
					array.push(object[key]);
				}
			}
			results = {};
		}else if(array){
			results = [];
		}

		if(!array || !array.length){
			return new Deferred().resolve(results);
		}

		var deferred = new Deferred();
		deferred.promise.always(function(){
			results = keyLookup = null;
		});
		var waiting = array.length;
		some(array, function(valueOrPromise, index){
			if(!object){
				keyLookup.push(index);
			}
			when(valueOrPromise, function(value){
				if(!deferred.isFulfilled()){
					results[keyLookup[index]] = value;
					if(--waiting === 0){
						deferred.resolve(results);
					}
				}
			}, deferred.reject);
			return deferred.isFulfilled();
		});
		return deferred.promise;	// dojo/promise/Promise
	};
});

},
'dojo/date/stamp':function(){
define(["../_base/lang", "../_base/array"], function(lang, array){

// module:
//		dojo/date/stamp

var stamp = {
	// summary:
	//		TODOC
};
lang.setObject("dojo.date.stamp", stamp);

// Methods to convert dates to or from a wire (string) format using well-known conventions

stamp.fromISOString = function(/*String*/ formattedString, /*Number?*/ defaultTime){
	// summary:
	//		Returns a Date object given a string formatted according to a subset of the ISO-8601 standard.
	//
	// description:
	//		Accepts a string formatted according to a profile of ISO8601 as defined by
	//		[RFC3339](http://www.ietf.org/rfc/rfc3339.txt), except that partial input is allowed.
	//		Can also process dates as specified [by the W3C](http://www.w3.org/TR/NOTE-datetime)
	//		The following combinations are valid:
	//
	//		- dates only
	//			- yyyy
	//			- yyyy-MM
	//			- yyyy-MM-dd
	//		- times only, with an optional time zone appended
	//			- THH:mm
	//			- THH:mm:ss
	//			- THH:mm:ss.SSS
	//		- and "datetimes" which could be any combination of the above
	//
	//		timezones may be specified as Z (for UTC) or +/- followed by a time expression HH:mm
	//		Assumes the local time zone if not specified.  Does not validate.  Improperly formatted
	//		input may return null.  Arguments which are out of bounds will be handled
	//		by the Date constructor (e.g. January 32nd typically gets resolved to February 1st)
	//		Only years between 100 and 9999 are supported.
  	// formattedString:
	//		A string such as 2005-06-30T08:05:00-07:00 or 2005-06-30 or T08:05:00
	// defaultTime:
	//		Used for defaults for fields omitted in the formattedString.
	//		Uses 1970-01-01T00:00:00.0Z by default.

	if(!stamp._isoRegExp){
		stamp._isoRegExp =
//TODO: could be more restrictive and check for 00-59, etc.
			/^(?:(\d{4})(?:-(\d{2})(?:-(\d{2}))?)?)?(?:T(\d{2}):(\d{2})(?::(\d{2})(.\d+)?)?((?:[+-](\d{2}):(\d{2}))|Z)?)?$/;
	}

	var match = stamp._isoRegExp.exec(formattedString),
		result = null;

	if(match){
		match.shift();
		if(match[1]){match[1]--;} // Javascript Date months are 0-based
		if(match[6]){match[6] *= 1000;} // Javascript Date expects fractional seconds as milliseconds

		if(defaultTime){
			// mix in defaultTime.  Relatively expensive, so use || operators for the fast path of defaultTime === 0
			defaultTime = new Date(defaultTime);
			array.forEach(array.map(["FullYear", "Month", "Date", "Hours", "Minutes", "Seconds", "Milliseconds"], function(prop){
				return defaultTime["get" + prop]();
			}), function(value, index){
				match[index] = match[index] || value;
			});
		}
		result = new Date(match[0]||1970, match[1]||0, match[2]||1, match[3]||0, match[4]||0, match[5]||0, match[6]||0); //TODO: UTC defaults
		if(match[0] < 100){
			result.setFullYear(match[0] || 1970);
		}

		var offset = 0,
			zoneSign = match[7] && match[7].charAt(0);
		if(zoneSign != 'Z'){
			offset = ((match[8] || 0) * 60) + (Number(match[9]) || 0);
			if(zoneSign != '-'){ offset *= -1; }
		}
		if(zoneSign){
			offset -= result.getTimezoneOffset();
		}
		if(offset){
			result.setTime(result.getTime() + offset * 60000);
		}
	}

	return result; // Date or null
};

/*=====
var __Options = {
	// selector: String
	//		"date" or "time" for partial formatting of the Date object.
	//		Both date and time will be formatted by default.
	// zulu: Boolean
	//		if true, UTC/GMT is used for a timezone
	// milliseconds: Boolean
	//		if true, output milliseconds
};
=====*/

stamp.toISOString = function(/*Date*/ dateObject, /*__Options?*/ options){
	// summary:
	//		Format a Date object as a string according a subset of the ISO-8601 standard
	//
	// description:
	//		When options.selector is omitted, output follows [RFC3339](http://www.ietf.org/rfc/rfc3339.txt)
	//		The local time zone is included as an offset from GMT, except when selector=='time' (time without a date)
	//		Does not check bounds.  Only years between 100 and 9999 are supported.
	//
	// dateObject:
	//		A Date object

	var _ = function(n){ return (n < 10) ? "0" + n : n; };
	options = options || {};
	var formattedDate = [],
		getter = options.zulu ? "getUTC" : "get",
		date = "";
	if(options.selector != "time"){
		var year = dateObject[getter+"FullYear"]();
		date = ["0000".substr((year+"").length)+year, _(dateObject[getter+"Month"]()+1), _(dateObject[getter+"Date"]())].join('-');
	}
	formattedDate.push(date);
	if(options.selector != "date"){
		var time = [_(dateObject[getter+"Hours"]()), _(dateObject[getter+"Minutes"]()), _(dateObject[getter+"Seconds"]())].join(':');
		var millis = dateObject[getter+"Milliseconds"]();
		if(options.milliseconds){
			time += "."+ (millis < 100 ? "0" : "") + _(millis);
		}
		if(options.zulu){
			time += "Z";
		}else if(options.selector != "time"){
			var timezoneOffset = dateObject.getTimezoneOffset();
			var absOffset = Math.abs(timezoneOffset);
			time += (timezoneOffset > 0 ? "-" : "+") +
				_(Math.floor(absOffset/60)) + ":" + _(absOffset%60);
		}
		formattedDate.push(time);
	}
	return formattedDate.join('T'); // String
};

return stamp;
});

},
'dojo/json5':function(){
define([
	'./json5/parse'
], function (parse) {
	return {
		parse: parse
	};
});

},
'dojo/json5/parse':function(){
define([
	'../string',
	'./util'
], function (dstring, util) {
	var source;
	var parseState;
	var stack;
	var pos;
	var line;
	var column;
	var token;
	var key;
	var root;

	function parse(text, reviver) {
		source = String(text);
		parseState = 'start';
		stack = [];
		pos = 0;
		line = 1;
		column = 0;
		token = undefined;
		key = undefined;
		root = undefined;
		do {
			token = lex();
			parseStates[parseState]();
		} while (token.type !== 'eof');
		if (typeof reviver === 'function') {
			return internalize({ '': root }, '', reviver);
		}
		return root;
	}
	function internalize(holder, name, reviver) {
		var value = holder[name];
		if (value != null && typeof value === 'object') {
			for (var key_1 in value) {
				var replacement = internalize(value, key_1, reviver);
				if (replacement === undefined) {
					delete value[key_1];
				}
				else {
					value[key_1] = replacement;
				}
			}
		}
		return reviver.call(holder, name, value);
	}
	var lexState;
	var buffer;
	var doubleQuote;
	var sign;
	var c;
	function lex() {
		lexState = 'default';
		buffer = '';
		doubleQuote = false;
		sign = 1;
		for (;;) {
			c = peek();
			var token_1 = lexStates[lexState]();
			if (token_1) {
				return token_1;
			}
		}
	}
	function peek() {
		if (source[pos]) {
			return dstring.fromCodePoint(dstring.codePointAt(source, pos));
		}
	}
	function read() {
		var c = peek();
		if (c === '\n') {
			line++;
			column = 0;
		}
		else if (c) {
			column += c.length;
		}
		else {
			column++;
		}
		if (c) {
			pos += c.length;
		}
		return c;
	}
	var lexStates = {
		'default': function () {
			switch (c) {
				case '\t':
				case '\v':
				case '\f':
				case ' ':
				case '\u00A0':
				case '\uFEFF':
				case '\n':
				case '\r':
				case '\u2028':
				case '\u2029':
					read();
					return;
				case '/':
					read();
					lexState = 'comment';
					return;
				case undefined:
					read();
					return newToken('eof');
			}
			if (util.isSpaceSeparator(c)) {
				read();
				return;
			}
			return lexStates[parseState]();
		},
		comment: function () {
			switch (c) {
				case '*':
					read();
					lexState = 'multiLineComment';
					return;
				case '/':
					read();
					lexState = 'singleLineComment';
					return;
			}
			throw invalidChar(read());
		},
		multiLineComment: function () {
			switch (c) {
				case '*':
					read();
					lexState = 'multiLineCommentAsterisk';
					return;
				case undefined:
					throw invalidChar(read());
			}
			read();
		},
		multiLineCommentAsterisk: function () {
			switch (c) {
				case '*':
					read();
					return;
				case '/':
					read();
					lexState = 'default';
					return;
				case undefined:
					throw invalidChar(read());
			}
			read();
			lexState = 'multiLineComment';
		},
		singleLineComment: function () {
			switch (c) {
				case '\n':
				case '\r':
				case '\u2028':
				case '\u2029':
					read();
					lexState = 'default';
					return;
				case undefined:
					read();
					return newToken('eof');
			}
			read();
		},
		value: function () {
			switch (c) {
				case '{':
				case '[':
					return newToken('punctuator', read());
				case 'n':
					read();
					literal('ull');
					return newToken('null', null);
				case 't':
					read();
					literal('rue');
					return newToken('boolean', true);
				case 'f':
					read();
					literal('alse');
					return newToken('boolean', false);
				case '-':
				case '+':
					if (read() === '-') {
						sign = -1;
					}
					lexState = 'sign';
					return;
				case '.':
					buffer = read();
					lexState = 'decimalPointLeading';
					return;
				case '0':
					buffer = read();
					lexState = 'zero';
					return;
				case '1':
				case '2':
				case '3':
				case '4':
				case '5':
				case '6':
				case '7':
				case '8':
				case '9':
					buffer = read();
					lexState = 'decimalInteger';
					return;
				case 'I':
					read();
					literal('nfinity');
					return newToken('numeric', Infinity);
				case 'N':
					read();
					literal('aN');
					return newToken('numeric', NaN);
				case '"':
				case "'":
					doubleQuote = (read() === '"');
					buffer = '';
					lexState = 'string';
					return;
			}
			throw invalidChar(read());
		},
		identifierNameStartEscape: function () {
			if (c !== 'u') {
				throw invalidChar(read());
			}
			read();
			var u = unicodeEscape();
			switch (u) {
				case '$':
				case '_':
					break;
				default:
					if (!util.isIdStartChar(u)) {
						throw invalidIdentifier();
					}
					break;
			}
			buffer += u;
			lexState = 'identifierName';
		},
		identifierName: function () {
			switch (c) {
				case '$':
				case '_':
				case '\u200C':
				case '\u200D':
					buffer += read();
					return;
				case '\\':
					read();
					lexState = 'identifierNameEscape';
					return;
			}
			if (util.isIdContinueChar(c)) {
				buffer += read();
				return;
			}
			return newToken('identifier', buffer);
		},
		identifierNameEscape: function () {
			if (c !== 'u') {
				throw invalidChar(read());
			}
			read();
			var u = unicodeEscape();
			switch (u) {
				case '$':
				case '_':
				case '\u200C':
				case '\u200D':
					break;
				default:
					if (!util.isIdContinueChar(u)) {
						throw invalidIdentifier();
					}
					break;
			}
			buffer += u;
			lexState = 'identifierName';
		},
		sign: function () {
			switch (c) {
				case '.':
					buffer = read();
					lexState = 'decimalPointLeading';
					return;
				case '0':
					buffer = read();
					lexState = 'zero';
					return;
				case '1':
				case '2':
				case '3':
				case '4':
				case '5':
				case '6':
				case '7':
				case '8':
				case '9':
					buffer = read();
					lexState = 'decimalInteger';
					return;
				case 'I':
					read();
					literal('nfinity');
					return newToken('numeric', sign * Infinity);
				case 'N':
					read();
					literal('aN');
					return newToken('numeric', NaN);
			}
			throw invalidChar(read());
		},
		zero: function () {
			switch (c) {
				case '.':
					buffer += read();
					lexState = 'decimalPoint';
					return;
				case 'e':
				case 'E':
					buffer += read();
					lexState = 'decimalExponent';
					return;
				case 'x':
				case 'X':
					buffer += read();
					lexState = 'hexadecimal';
					return;
			}
			return newToken('numeric', sign * 0);
		},
		decimalInteger: function () {
			switch (c) {
				case '.':
					buffer += read();
					lexState = 'decimalPoint';
					return;
				case 'e':
				case 'E':
					buffer += read();
					lexState = 'decimalExponent';
					return;
			}
			if (util.isDigit(c)) {
				buffer += read();
				return;
			}
			return newToken('numeric', sign * Number(buffer));
		},
		decimalPointLeading: function () {
			if (util.isDigit(c)) {
				buffer += read();
				lexState = 'decimalFraction';
				return;
			}
			throw invalidChar(read());
		},
		decimalPoint: function () {
			switch (c) {
				case 'e':
				case 'E':
					buffer += read();
					lexState = 'decimalExponent';
					return;
			}
			if (util.isDigit(c)) {
				buffer += read();
				lexState = 'decimalFraction';
				return;
			}
			return newToken('numeric', sign * Number(buffer));
		},
		decimalFraction: function () {
			switch (c) {
				case 'e':
				case 'E':
					buffer += read();
					lexState = 'decimalExponent';
					return;
			}
			if (util.isDigit(c)) {
				buffer += read();
				return;
			}
			return newToken('numeric', sign * Number(buffer));
		},
		decimalExponent: function () {
			switch (c) {
				case '+':
				case '-':
					buffer += read();
					lexState = 'decimalExponentSign';
					return;
			}
			if (util.isDigit(c)) {
				buffer += read();
				lexState = 'decimalExponentInteger';
				return;
			}
			throw invalidChar(read());
		},
		decimalExponentSign: function () {
			if (util.isDigit(c)) {
				buffer += read();
				lexState = 'decimalExponentInteger';
				return;
			}
			throw invalidChar(read());
		},
		decimalExponentInteger: function () {
			if (util.isDigit(c)) {
				buffer += read();
				return;
			}
			return newToken('numeric', sign * Number(buffer));
		},
		hexadecimal: function () {
			if (util.isHexDigit(c)) {
				buffer += read();
				lexState = 'hexadecimalInteger';
				return;
			}
			throw invalidChar(read());
		},
		hexadecimalInteger: function () {
			if (util.isHexDigit(c)) {
				buffer += read();
				return;
			}
			return newToken('numeric', sign * Number(buffer));
		},
		string: function () {
			switch (c) {
				case '\\':
					read();
					buffer += escape();
					return;
				case '"':
					if (doubleQuote) {
						read();
						return newToken('string', buffer);
					}
					buffer += read();
					return;
				case "'":
					if (!doubleQuote) {
						read();
						return newToken('string', buffer);
					}
					buffer += read();
					return;
				case '\n':
				case '\r':
					throw invalidChar(read());
				case '\u2028':
				case '\u2029':
					separatorChar(c);
					break;
				case undefined:
					throw invalidChar(read());
			}
			buffer += read();
		},
		start: function () {
			switch (c) {
				case '{':
				case '[':
					return newToken('punctuator', read());
			}
			lexState = 'value';
		},
		beforePropertyName: function () {
			switch (c) {
				case '$':
				case '_':
					buffer = read();
					lexState = 'identifierName';
					return;
				case '\\':
					read();
					lexState = 'identifierNameStartEscape';
					return;
				case '}':
					return newToken('punctuator', read());
				case '"':
				case "'":
					doubleQuote = (read() === '"');
					lexState = 'string';
					return;
			}
			if (util.isIdStartChar(c)) {
				buffer += read();
				lexState = 'identifierName';
				return;
			}
			throw invalidChar(read());
		},
		afterPropertyName: function () {
			if (c === ':') {
				return newToken('punctuator', read());
			}
			throw invalidChar(read());
		},
		beforePropertyValue: function () {
			lexState = 'value';
		},
		afterPropertyValue: function () {
			switch (c) {
				case ',':
				case '}':
					return newToken('punctuator', read());
			}
			throw invalidChar(read());
		},
		beforeArrayValue: function () {
			if (c === ']') {
				return newToken('punctuator', read());
			}
			lexState = 'value';
		},
		afterArrayValue: function () {
			switch (c) {
				case ',':
				case ']':
					return newToken('punctuator', read());
			}
			throw invalidChar(read());
		},
		end: function () {
			throw invalidChar(read());
		}
	};
	function newToken(type, value) {
		return {
			type: type,
			value: value,
			line: line,
			column: column
		};
	}
	function literal(s) {
		for (var _i = 0, s_1 = s; _i < s_1.length; _i++) {
			var c_1 = s_1[_i];
			var p = peek();
			if (p !== c_1) {
				throw invalidChar(read());
			}
			read();
		}
	}
	function escape() {
		var c = peek();
		switch (c) {
			case 'b':
				read();
				return '\b';
			case 'f':
				read();
				return '\f';
			case 'n':
				read();
				return '\n';
			case 'r':
				read();
				return '\r';
			case 't':
				read();
				return '\t';
			case 'v':
				read();
				return '\v';
			case '0':
				read();
				if (util.isDigit(peek())) {
					throw invalidChar(read());
				}
				return '\0';
			case 'x':
				read();
				return hexEscape();
			case 'u':
				read();
				return unicodeEscape();
			case '\n':
			case '\u2028':
			case '\u2029':
				read();
				return '';
			case '\r':
				read();
				if (peek() === '\n') {
					read();
				}
				return '';
			case '1':
			case '2':
			case '3':
			case '4':
			case '5':
			case '6':
			case '7':
			case '8':
			case '9':
				throw invalidChar(read());
			case undefined:
				throw invalidChar(read());
		}
		return read();
	}
	function hexEscape() {
		var buffer = '';
		var c = peek();
		if (!util.isHexDigit(c)) {
			throw invalidChar(read());
		}
		buffer += read();
		c = peek();
		if (!util.isHexDigit(c)) {
			throw invalidChar(read());
		}
		buffer += read();
		return dstring.fromCodePoint(parseInt(buffer, 16));
	}
	function unicodeEscape() {
		var buffer = '';
		var count = 4;
		while (count-- > 0) {
			var c_2 = peek();
			if (!util.isHexDigit(c_2)) {
				throw invalidChar(read());
			}
			buffer += read();
		}
		return dstring.fromCodePoint(parseInt(buffer, 16));
	}
	var parseStates = {
		start: function () {
			if (token.type === 'eof') {
				throw invalidEOF();
			}
			push();
		},
		beforePropertyName: function () {
			switch (token.type) {
				case 'identifier':
				case 'string':
					key = token.value;
					parseState = 'afterPropertyName';
					return;
				case 'punctuator':
					pop();
					return;
				case 'eof':
					throw invalidEOF();
			}
		},
		afterPropertyName: function () {
			if (token.type === 'eof') {
				throw invalidEOF();
			}
			parseState = 'beforePropertyValue';
		},
		beforePropertyValue: function () {
			if (token.type === 'eof') {
				throw invalidEOF();
			}
			push();
		},
		beforeArrayValue: function () {
			if (token.type === 'eof') {
				throw invalidEOF();
			}
			if (token.type === 'punctuator' && token.value === ']') {
				pop();
				return;
			}
			push();
		},
		afterPropertyValue: function () {
			if (token.type === 'eof') {
				throw invalidEOF();
			}
			switch (token.value) {
				case ',':
					parseState = 'beforePropertyName';
					return;
				case '}':
					pop();
			}
		},
		afterArrayValue: function () {
			if (token.type === 'eof') {
				throw invalidEOF();
			}
			switch (token.value) {
				case ',':
					parseState = 'beforeArrayValue';
					return;
				case ']':
					pop();
			}
		},
		end: function () {
		}
	};
	function push() {
		var value;
		switch (token.type) {
			case 'punctuator':
				switch (token.value) {
					case '{':
						value = {};
						break;
					case '[':
						value = [];
						break;
				}
				break;
			case 'null':
			case 'boolean':
			case 'numeric':
			case 'string':
				value = token.value;
				break;
		}
		if (root === undefined) {
			root = value;
		}
		else {
			var parent_1 = stack[stack.length - 1];
			if (Array.isArray(parent_1)) {
				parent_1.push(value);
			}
			else {
				parent_1[key] = value;
			}
		}
		if (value !== null && typeof value === 'object') {
			stack.push(value);
			if (Array.isArray(value)) {
				parseState = 'beforeArrayValue';
			}
			else {
				parseState = 'beforePropertyName';
			}
		}
		else {
			var current = stack[stack.length - 1];
			if (current == null) {
				parseState = 'end';
			}
			else if (Array.isArray(current)) {
				parseState = 'afterArrayValue';
			}
			else {
				parseState = 'afterPropertyValue';
			}
		}
	}
	function pop() {
		stack.pop();
		var current = stack[stack.length - 1];
		if (current == null) {
			parseState = 'end';
		}
		else if (Array.isArray(current)) {
			parseState = 'afterArrayValue';
		}
		else {
			parseState = 'afterPropertyValue';
		}
	}
	function invalidChar(c) {
		if (c === undefined) {
			return syntaxError("JSON5: invalid end of input at " + line + ":" + column);
		}
		return syntaxError("JSON5: invalid character '" + formatChar(c) + "' at " + line + ":" + column);
	}
	function invalidEOF() {
		return syntaxError("JSON5: invalid end of input at " + line + ":" + column);
	}
	function invalidIdentifier() {
		column -= 5;
		return syntaxError("JSON5: invalid identifier character at " + line + ":" + column);
	}
	function separatorChar(c) {
		console.warn("JSON5: '" + formatChar(c) + "' in strings is not valid ECMAScript; consider escaping");
	}
	function formatChar(c) {
		var replacements = {
			"'": "\\'",
			'"': '\\"',
			'\\': '\\\\',
			'\b': '\\b',
			'\f': '\\f',
			'\n': '\\n',
			'\r': '\\r',
			'\t': '\\t',
			'\v': '\\v',
			'\0': '\\0',
			'\u2028': '\\u2028',
			'\u2029': '\\u2029'
		};
		if (replacements[c]) {
			return replacements[c];
		}
		if (c < ' ') {
			var hexString = c.charCodeAt(0).toString(16);
			return '\\x' + ('00' + hexString).substring(hexString.length);
		}
		return c;
	}
	function syntaxError(message) {
		var err = new SyntaxError(message);
		err.lineNumber = line;
		err.columnNumber = column;
		return err;
	}

	return parse;
});

},
'dojo/json5/util':function(){
define([
	'./unicode'
], function (unicode) {
	return {
		isSpaceSeparator: function (c) {
			return typeof c === 'string' && unicode.Space_Separator.test(c);
		},
		isIdStartChar: function (c) {
			return typeof c === 'string' && ((c >= 'a' && c <= 'z') ||
				(c >= 'A' && c <= 'Z') ||
				(c === '$') || (c === '_') ||
				unicode.ID_Start.test(c));
		},
		isIdContinueChar: function (c) {
			return typeof c === 'string' && ((c >= 'a' && c <= 'z') ||
				(c >= 'A' && c <= 'Z') ||
				(c >= '0' && c <= '9') ||
				(c === '$') || (c === '_') ||
				(c === '\u200C') || (c === '\u200D') ||
				unicode.ID_Continue.test(c));
		},
		isDigit: function (c) {
			return typeof c === 'string' && /[0-9]/.test(c);
		},
		isHexDigit: function (c) {
			return typeof c === 'string' && /[0-9A-Fa-f]/.test(c);
		},
	};
});

},
'dojo/json5/unicode':function(){
define({
	Space_Separator: /[\u1680\u2000-\u200A\u202F\u205F\u3000]/,
	ID_Start: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE83\uDE86-\uDE89\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]/,
	ID_Continue: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u09FC\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9-\u0AFF\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D00-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF9\u1D00-\u1DF9\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDE00-\uDE3E\uDE47\uDE50-\uDE83\uDE86-\uDE99\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD47\uDD50-\uDD59]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/
});

},
'soso/dijit/TooltipDialog':function(){
define([
    "dojo/_base/declare",
    "dojo/dom-class",
    "dojo/keys",
    "dijit/focus",
    "dijit/popup",
    "dijit/TooltipDialog"
], function(declare, domClass, keys, focusUtil, popup, TooltipDialog) {
    return declare("soso.dijit.TooltipDialog", [TooltipDialog], {
            postCreate: function(){
                this.inherited(arguments);

                this.connect(this, "onKeyUp", "_onKey");
                popup.moveOffScreen(this);

                domClass.add(this.domNode, 'sos-v1 sos-tooltip');
            },
            
            show: function(args){
                popup.open(args);
                this._getFocusItems();
                focusUtil.focus(this._firstFocusItem);
                this.openVar = true;
            },
            
            onCancel: function(evt){
                this.hide();
            },
            
           _onKey: function(/*Event*/ evt){
                if(evt.keyCode == keys.ESCAPE){
                    this.hide();
                }else{
                    this.inherited(arguments)
                }
            },
            
            hide: function(){
                popup.close(this);
                this.openVar = false;
            }
    });
});
},
'dijit/focus':function(){
define([
	"dojo/aspect",
	"dojo/_base/declare", // declare
	"dojo/dom", // domAttr.get dom.isDescendant
	"dojo/dom-attr", // domAttr.get dom.isDescendant
	"dojo/dom-class",
	"dojo/dom-construct", // connect to domConstruct.empty, domConstruct.destroy
	"dojo/Evented",
	"dojo/_base/lang", // lang.hitch
	"dojo/on",
	"dojo/domReady",
	"dojo/sniff", // has("ie")
	"dojo/Stateful",
	"dojo/_base/window", // win.body
	"dojo/window", // winUtils.get
	"./a11y",	// a11y.isTabNavigable
	"./registry",	// registry.byId
	"./main"		// to set dijit.focus
], function(aspect, declare, dom, domAttr, domClass, domConstruct, Evented, lang, on, domReady, has, Stateful, win, winUtils,
			a11y, registry, dijit){

	// module:
	//		dijit/focus

	// Time of the last focusin event
	var lastFocusin;

	// Time of the last touch/mousedown or focusin event
	var lastTouchOrFocusin;

	var FocusManager = declare([Stateful, Evented], {
		// summary:
		//		Tracks the currently focused node, and which widgets are currently "active".
		//		Access via require(["dijit/focus"], function(focus){ ... }).
		//
		//		A widget is considered active if it or a descendant widget has focus,
		//		or if a non-focusable node of this widget or a descendant was recently clicked.
		//
		//		Call focus.watch("curNode", callback) to track the current focused DOMNode,
		//		or focus.watch("activeStack", callback) to track the currently focused stack of widgets.
		//
		//		Call focus.on("widget-blur", func) or focus.on("widget-focus", ...) to monitor when
		//		when widgets become active/inactive
		//
		//		Finally, focus(node) will focus a node, suppressing errors if the node doesn't exist.

		// curNode: DomNode
		//		Currently focused item on screen
		curNode: null,

		// activeStack: dijit/_WidgetBase[]
		//		List of currently active widgets (focused widget and it's ancestors)
		activeStack: [],

		constructor: function(){
			// Don't leave curNode/prevNode pointing to bogus elements
			var check = lang.hitch(this, function(node){
				if(dom.isDescendant(this.curNode, node)){
					this.set("curNode", null);
				}
				if(dom.isDescendant(this.prevNode, node)){
					this.set("prevNode", null);
				}
			});
			aspect.before(domConstruct, "empty", check);
			aspect.before(domConstruct, "destroy", check);
		},

		registerIframe: function(/*DomNode*/ iframe){
			// summary:
			//		Registers listeners on the specified iframe so that any click
			//		or focus event on that iframe (or anything in it) is reported
			//		as a focus/click event on the `<iframe>` itself.
			// description:
			//		Currently only used by editor.
			// returns:
			//		Handle with remove() method to deregister.
			return this.registerWin(iframe.contentWindow, iframe);
		},

		registerWin: function(/*Window?*/targetWindow, /*DomNode?*/ effectiveNode){
			// summary:
			//		Registers listeners on the specified window (either the main
			//		window or an iframe's window) to detect when the user has clicked somewhere
			//		or focused somewhere.
			// description:
			//		Users should call registerIframe() instead of this method.
			// targetWindow:
			//		If specified this is the window associated with the iframe,
			//		i.e. iframe.contentWindow.
			// effectiveNode:
			//		If specified, report any focus events inside targetWindow as
			//		an event on effectiveNode, rather than on evt.target.
			// returns:
			//		Handle with remove() method to deregister.

			// TODO: make this function private in 2.0; Editor/users should call registerIframe(),

			// Listen for blur and focus events on targetWindow's document.
			var _this = this,
				body = targetWindow.document && targetWindow.document.body;

			if(body){
				// Listen for touches or mousedowns... could also use dojo/touch.press here.
				var event = has("pointer-events") ? "pointerdown" : has("MSPointer") ? "MSPointerDown" :
					has("touch-events") ? "mousedown, touchstart" : "mousedown";
				var mdh = on(targetWindow.document, event, function(evt){
					// workaround weird IE bug where the click is on an orphaned node
					// (first time clicking a Select/DropDownButton inside a TooltipDialog).
					// actually, strangely this is happening on latest chrome too.
					if(evt && evt.target && evt.target.parentNode == null){
						return;
					}

					_this._onTouchNode(effectiveNode || evt.target, "mouse");
				});

				var fih = on(body, 'focusin', function(evt){
					// When you refocus the browser window, IE gives an event with an empty srcElement
					if(!evt.target.tagName) { return; }

					// IE reports that nodes like <body> have gotten focus, even though they have tabIndex=-1,
					// ignore those events
					var tag = evt.target.tagName.toLowerCase();
					if(tag == "#document" || tag == "body"){ return; }

					if(a11y.isFocusable(evt.target)){
						_this._onFocusNode(effectiveNode || evt.target);
					}else{
						// Previous code called _onTouchNode() for any activate event on a non-focusable node.   Can
						// probably just ignore such an event as it will be handled by onmousedown handler above, but
						// leaving the code for now.
						_this._onTouchNode(effectiveNode || evt.target);
					}
				});

				var foh = on(body, 'focusout', function(evt){
					_this._onBlurNode(effectiveNode || evt.target);
				});

				return {
					remove: function(){
						mdh.remove();
						fih.remove();
						foh.remove();
						mdh = fih = foh = null;
						body = null;	// prevent memory leak (apparent circular reference via closure)
					}
				};
			}
		},

		_onBlurNode: function(/*DomNode*/ node){
			// summary:
			//		Called when focus leaves a node.
			//		Usually ignored, _unless_ it *isn't* followed by touching another node,
			//		which indicates that we tabbed off the last field on the page,
			//		in which case every widget is marked inactive

			var now = (new Date()).getTime();

			// IE9+ and chrome have a problem where focusout events come after the corresponding focusin event.
			// For chrome problem see https://bugs.dojotoolkit.org/ticket/17668.
			// IE problem happens when moving focus from the Editor's <iframe> to a normal DOMNode.
			if(now < lastFocusin + 100){
				return;
			}

			// If the blur event isn't followed by a focus event, it means the user clicked on something unfocusable,
			// so clear focus.
			if(this._clearFocusTimer){
				clearTimeout(this._clearFocusTimer);
			}
			this._clearFocusTimer = setTimeout(lang.hitch(this, function(){
				this.set("prevNode", this.curNode);
				this.set("curNode", null);
			}), 0);

			// Unset timer to zero-out widget stack; we'll reset it below if appropriate.
			if(this._clearActiveWidgetsTimer){
				clearTimeout(this._clearActiveWidgetsTimer);
			}

			if(now < lastTouchOrFocusin + 100){
				// This blur event is coming late (after the call to _onTouchNode() rather than before.
				// So let _onTouchNode() handle setting the widget stack.
				// See https://bugs.dojotoolkit.org/ticket/17668
				return;
			}

			// If the blur event isn't followed (or preceded) by a focus or touch event then mark all widgets as inactive.
			this._clearActiveWidgetsTimer = setTimeout(lang.hitch(this, function(){
				delete this._clearActiveWidgetsTimer;
				this._setStack([]);
			}), 0);
		},

		_onTouchNode: function(/*DomNode*/ node, /*String*/ by){
			// summary:
			//		Callback when node is focused or touched.
			//		Note that _onFocusNode() calls _onTouchNode().
			// node:
			//		The node that was touched.
			// by:
			//		"mouse" if the focus/touch was caused by a mouse down event

			// Keep track of time of last focusin or touch event.
			lastTouchOrFocusin = (new Date()).getTime();

			if(this._clearActiveWidgetsTimer){
				// forget the recent blur event
				clearTimeout(this._clearActiveWidgetsTimer);
				delete this._clearActiveWidgetsTimer;
			}

			// if the click occurred on the scrollbar of a dropdown, treat it as a click on the dropdown,
			// even though the scrollbar is technically on the popup wrapper (see #10631)
			if(domClass.contains(node, "dijitPopup")){
				node = node.firstChild;
			}

			// compute stack of active widgets (ex: ComboButton --> Menu --> MenuItem)
			var newStack=[];
			try{
				while(node){
					var popupParent = domAttr.get(node, "dijitPopupParent");
					if(popupParent){
						node=registry.byId(popupParent).domNode;
					}else if(node.tagName && node.tagName.toLowerCase() == "body"){
						// is this the root of the document or just the root of an iframe?
						if(node === win.body()){
							// node is the root of the main document
							break;
						}
						// otherwise, find the iframe this node refers to (can't access it via parentNode,
						// need to do this trick instead). window.frameElement is supported in IE/FF/Webkit
						node=winUtils.get(node.ownerDocument).frameElement;
					}else{
						// if this node is the root node of a widget, then add widget id to stack,
						// except ignore clicks on disabled widgets (actually focusing a disabled widget still works,
						// to support MenuItem)
						var id = node.getAttribute && node.getAttribute("widgetId"),
							widget = id && registry.byId(id);
						if(widget && !(by == "mouse" && widget.get("disabled"))){
							newStack.unshift(id);
						}
						node=node.parentNode;
					}
				}
			}catch(e){ /* squelch */ }

			this._setStack(newStack, by);
		},

		_onFocusNode: function(/*DomNode*/ node){
			// summary:
			//		Callback when node is focused

			if(!node){
				return;
			}

			if(node.nodeType == 9){
				// Ignore focus events on the document itself.  This is here so that
				// (for example) clicking the up/down arrows of a spinner
				// (which don't get focus) won't cause that widget to blur. (FF issue)
				return;
			}

			// Keep track of time of last focusin event.
			lastFocusin = (new Date()).getTime();

			// There was probably a blur event right before this event, but since we have a new focus,
			// forget about the blur
			if(this._clearFocusTimer){
				clearTimeout(this._clearFocusTimer);
				delete this._clearFocusTimer;
			}

			this._onTouchNode(node);

			if(node == this.curNode){ return; }
			this.set("prevNode", this.curNode);
			this.set("curNode", node);
		},

		_setStack: function(/*String[]*/ newStack, /*String*/ by){
			// summary:
			//		The stack of active widgets has changed.  Send out appropriate events and records new stack.
			// newStack:
			//		array of widget id's, starting from the top (outermost) widget
			// by:
			//		"mouse" if the focus/touch was caused by a mouse down event

			var oldStack = this.activeStack, lastOldIdx = oldStack.length - 1, lastNewIdx = newStack.length - 1;

			if(newStack[lastNewIdx] == oldStack[lastOldIdx]){
				// no changes, return now to avoid spurious notifications about changes to activeStack
				return;
			}

			this.set("activeStack", newStack);

			var widget, i;

			// for all elements that have gone out of focus, set focused=false
			for(i = lastOldIdx; i >= 0 && oldStack[i] != newStack[i]; i--){
				widget = registry.byId(oldStack[i]);
				if(widget){
					widget._hasBeenBlurred = true;		// TODO: used by form widgets, should be moved there
					widget.set("focused", false);
					if(widget._focusManager == this){
						widget._onBlur(by);
					}
					this.emit("widget-blur", widget, by);
				}
			}

			// for all element that have come into focus, set focused=true
			for(i++; i <= lastNewIdx; i++){
				widget = registry.byId(newStack[i]);
				if(widget){
					widget.set("focused", true);
					if(widget._focusManager == this){
						widget._onFocus(by);
					}
					this.emit("widget-focus", widget, by);
				}
			}
		},

		focus: function(node){
			// summary:
			//		Focus the specified node, suppressing errors if they occur
			if(node){
				try{ node.focus(); }catch(e){/*quiet*/}
			}
		}
	});

	var singleton = new FocusManager();

	// register top window and all the iframes it contains
	domReady(function(){
		var handle = singleton.registerWin(winUtils.get(document));
		if(has("ie")){
			on(window, "unload", function(){
				if(handle){	// because this gets called twice when doh.robot is running
					handle.remove();
					handle = null;
				}
			});
		}
	});

	// Setup dijit.focus as a pointer to the singleton but also (for backwards compatibility)
	// as a function to set focus.   Remove for 2.0.
	dijit.focus = function(node){
		singleton.focus(node);	// indirection here allows dijit/_base/focus.js to override behavior
	};
	for(var attr in singleton){
		if(!/^_/.test(attr)){
			dijit.focus[attr] = typeof singleton[attr] == "function" ? lang.hitch(singleton, attr) : singleton[attr];
		}
	}
	singleton.watch(function(attr, oldVal, newVal){
		dijit.focus[attr] = newVal;
	});

	return singleton;
});

},
'dojo/window':function(){
define(["./_base/lang", "./sniff", "./_base/window", "./dom", "./dom-geometry", "./dom-style", "./dom-construct"],
	function(lang, has, baseWindow, dom, geom, style, domConstruct){

	// feature detection
	/* not needed but included here for future reference
	has.add("rtl-innerVerticalScrollBar-on-left", function(win, doc){
		var	body = baseWindow.body(doc),
			scrollable = domConstruct.create('div', {
				style: {overflow:'scroll', overflowX:'hidden', direction:'rtl', visibility:'hidden', position:'absolute', left:'0', width:'64px', height:'64px'}
			}, body, "last"),
			center = domConstruct.create('center', {
				style: {overflow:'hidden', direction:'ltr'}
			}, scrollable, "last"),
			inner = domConstruct.create('div', {
				style: {overflow:'visible', display:'inline' }
			}, center, "last");
		inner.innerHTML="&nbsp;";
		var midPoint = Math.max(inner.offsetLeft, geom.position(inner).x);
		var ret = midPoint >= 32;
		center.removeChild(inner);
		scrollable.removeChild(center);
		body.removeChild(scrollable);
		return ret;
	});
	*/
	has.add("rtl-adjust-position-for-verticalScrollBar", function(win, doc){
		var	body = baseWindow.body(doc),
			scrollable = domConstruct.create('div', {
				style: {overflow:'scroll', overflowX:'visible', direction:'rtl', visibility:'hidden', position:'absolute', left:'0', top:'0', width:'64px', height:'64px'}
			}, body, "last"),
			div = domConstruct.create('div', {
				style: {overflow:'hidden', direction:'ltr'}
			}, scrollable, "last"),
			ret = geom.position(div).x != 0;
		scrollable.removeChild(div);
		body.removeChild(scrollable);
		return ret;
	});

	has.add("position-fixed-support", function(win, doc){
		// IE6, IE7+quirks, and some older mobile browsers don't support position:fixed
		var	body = baseWindow.body(doc),
			outer = domConstruct.create('span', {
				style: {visibility:'hidden', position:'fixed', left:'1px', top:'1px'}
			}, body, "last"),
			inner = domConstruct.create('span', {
				style: {position:'fixed', left:'0', top:'0'}
			}, outer, "last"),
			ret = geom.position(inner).x != geom.position(outer).x;
		outer.removeChild(inner);
		body.removeChild(outer);
		return ret;
	});

	// module:
	//		dojo/window

	var window = {
		// summary:
		//		TODOC

		getBox: function(/*Document?*/ doc){
			// summary:
			//		Returns the dimensions and scroll position of the viewable area of a browser window

			doc = doc || baseWindow.doc;

			var
				scrollRoot = (doc.compatMode == 'BackCompat') ? baseWindow.body(doc) : doc.documentElement,
				// get scroll position
				scroll = geom.docScroll(doc), // scrollRoot.scrollTop/Left should work
				w, h;

			if(has("touch")){ // if(scrollbars not supported)
				var uiWindow = window.get(doc);   // use UI window, not dojo.global window
				// on mobile, scrollRoot.clientHeight <= uiWindow.innerHeight <= scrollRoot.offsetHeight, return uiWindow.innerHeight
				w = uiWindow.innerWidth || scrollRoot.clientWidth; // || scrollRoot.clientXXX probably never evaluated
				h = uiWindow.innerHeight || scrollRoot.clientHeight;
			}else{
				// on desktops, scrollRoot.clientHeight <= scrollRoot.offsetHeight <= uiWindow.innerHeight, return scrollRoot.clientHeight
				// uiWindow.innerWidth/Height includes the scrollbar and cannot be used
				w = scrollRoot.clientWidth;
				h = scrollRoot.clientHeight;
			}
			return {
				l: scroll.x,
				t: scroll.y,
				w: w,
				h: h
			};
		},

		get: function(/*Document*/ doc){
			// summary:
			//		Get window object associated with document doc.
			// doc:
			//		The document to get the associated window for.

			// In some IE versions (at least 6.0), document.parentWindow does not return a
			// reference to the real window object (maybe a copy), so we must fix it as well
			// We use IE specific execScript to attach the real window reference to
			// document._parentWindow for later use
			if(has("ie") && window !== document.parentWindow){
				/*
				In IE 6, only the variable "window" can be used to connect events (others
				may be only copies).
				*/
				doc.parentWindow.execScript("document._parentWindow = window;", "Javascript");
				//to prevent memory leak, unset it after use
				//another possibility is to add an onUnload handler which seems overkill to me (liucougar)
				var win = doc._parentWindow;
				doc._parentWindow = null;
				return win;	//	Window
			}

			return doc.parentWindow || doc.defaultView;	//	Window
		},

		scrollIntoView: function(/*DomNode*/ node, /*Object?*/ pos){
			// summary:
			//		Scroll the passed node into view using minimal movement, if it is not already.

			// Don't rely on node.scrollIntoView working just because the function is there since
			// it forces the node to the page's bottom or top (and left or right in IE) without consideration for the minimal movement.
			// WebKit's node.scrollIntoViewIfNeeded doesn't work either for inner scrollbars in right-to-left mode
			// and when there's a fixed position scrollable element

			try{ // catch unexpected/unrecreatable errors (#7808) since we can recover using a semi-acceptable native method
				node = dom.byId(node);
				var	doc = node.ownerDocument || baseWindow.doc,	// TODO: why baseWindow.doc?  Isn't node.ownerDocument always defined?
					body = baseWindow.body(doc),
					html = doc.documentElement || body.parentNode,
					isIE = has("ie") || has("trident"),
					isWK = has("webkit");
				// if an untested browser, then use the native method
				if(node == body || node == html){ return; }
				if(!(has("mozilla") || isIE || isWK || has("opera") || has("trident") || has("edge"))
						&& ("scrollIntoView" in node)){
					node.scrollIntoView(false); // short-circuit to native if possible
					return;
				}
				var	backCompat = doc.compatMode == 'BackCompat',
					rootWidth = Math.min(body.clientWidth || html.clientWidth, html.clientWidth || body.clientWidth),
					rootHeight = Math.min(body.clientHeight || html.clientHeight, html.clientHeight || body.clientHeight),
					scrollRoot = (isWK || backCompat) ? body : html,
					nodePos = pos || geom.position(node),
					el = node.parentNode,
					isFixed = function(el){
						return (isIE <= 6 || (isIE == 7 && backCompat))
							? false
							: (has("position-fixed-support") && (style.get(el, 'position').toLowerCase() == "fixed"));
					},
					self = this,
					scrollElementBy = function(el, x, y){
						if(el.tagName == "BODY" || el.tagName == "HTML"){
							self.get(el.ownerDocument).scrollBy(x, y);
						}else{
							x && (el.scrollLeft += x);
							y && (el.scrollTop += y);
						}
					};
				if(isFixed(node)){ return; } // nothing to do
				while(el){
					if(el == body){ el = scrollRoot; }
					var	elPos = geom.position(el),
						fixedPos = isFixed(el),
						rtl = style.getComputedStyle(el).direction.toLowerCase() == "rtl";

					if(el == scrollRoot){
						elPos.w = rootWidth; elPos.h = rootHeight;
						if(scrollRoot == html && (isIE || has("trident")) && rtl){
							elPos.x += scrollRoot.offsetWidth-elPos.w;// IE workaround where scrollbar causes negative x
						}
						elPos.x = 0;
						elPos.y = 0;
					}else{
						var pb = geom.getPadBorderExtents(el);
						elPos.w -= pb.w; elPos.h -= pb.h; elPos.x += pb.l; elPos.y += pb.t;
						var clientSize = el.clientWidth,
							scrollBarSize = elPos.w - clientSize;
						if(clientSize > 0 && scrollBarSize > 0){
							if(rtl && has("rtl-adjust-position-for-verticalScrollBar")){
								elPos.x += scrollBarSize;
							}
							elPos.w = clientSize;
						}
						clientSize = el.clientHeight;
						scrollBarSize = elPos.h - clientSize;
						if(clientSize > 0 && scrollBarSize > 0){
							elPos.h = clientSize;
						}
					}
					if(fixedPos){ // bounded by viewport, not parents
						if(elPos.y < 0){
							elPos.h += elPos.y; elPos.y = 0;
						}
						if(elPos.x < 0){
							elPos.w += elPos.x; elPos.x = 0;
						}
						if(elPos.y + elPos.h > rootHeight){
							elPos.h = rootHeight - elPos.y;
						}
						if(elPos.x + elPos.w > rootWidth){
							elPos.w = rootWidth - elPos.x;
						}
					}
					// calculate overflow in all 4 directions
					var	l = nodePos.x - elPos.x, // beyond left: < 0
//						t = nodePos.y - Math.max(elPos.y, 0), // beyond top: < 0
						t = nodePos.y - elPos.y, // beyond top: < 0
						r = l + nodePos.w - elPos.w, // beyond right: > 0
						bot = t + nodePos.h - elPos.h; // beyond bottom: > 0
					var s, old;
					if(r * l > 0 && (!!el.scrollLeft || el == scrollRoot || el.scrollWidth > el.offsetHeight)){
						s = Math[l < 0? "max" : "min"](l, r);
						if(rtl && ((isIE == 8 && !backCompat) || has("trident") >= 5)){ s = -s; }
						old = el.scrollLeft;
						scrollElementBy(el, s, 0);
						s = el.scrollLeft - old;
						nodePos.x -= s;
					}
					if(bot * t > 0 && (!!el.scrollTop || el == scrollRoot || el.scrollHeight > el.offsetHeight)){
						s = Math.ceil(Math[t < 0? "max" : "min"](t, bot));
						old = el.scrollTop;
						scrollElementBy(el, 0, s);
						s = el.scrollTop - old;
						nodePos.y -= s;
					}
					el = (el != scrollRoot) && !fixedPos && el.parentNode;
				}
			}catch(error){
				console.error('scrollIntoView: ' + error);
				node.scrollIntoView(false);
			}
		}
	};

	 1  && lang.setObject("dojo.window", window);

	return window;
});

},
'dijit/a11y':function(){
define([
	"dojo/_base/array", // array.forEach array.map
	"dojo/dom",			// dom.byId
	"dojo/dom-attr", // domAttr.attr domAttr.has
	"dojo/dom-style", // domStyle.style
	"dojo/_base/lang", // lang.mixin()
	"dojo/sniff", // has("ie")  1 
	"./main"	// for exporting methods to dijit namespace
], function(array, dom, domAttr, domStyle, lang, has, dijit){

	// module:
	//		dijit/a11y

	var undefined;

	var a11y = {
		// summary:
		//		Accessibility utility functions (keyboard, tab stops, etc.)

		_isElementShown: function(/*Element*/ elem){
			var s = domStyle.get(elem);
			return (s.visibility != "hidden")
				&& (s.visibility != "collapsed")
				&& (s.display != "none")
				&& (domAttr.get(elem, "type") != "hidden");
		},

		hasDefaultTabStop: function(/*Element*/ elem){
			// summary:
			//		Tests if element is tab-navigable even without an explicit tabIndex setting

			// No explicit tabIndex setting, need to investigate node type
			switch(elem.nodeName.toLowerCase()){
				case "a":
					// An <a> w/out a tabindex is only navigable if it has an href
					return domAttr.has(elem, "href");
				case "area":
				case "button":
				case "input":
				case "object":
				case "select":
				case "textarea":
					// These are navigable by default
					return true;
				case "iframe":
					// If it's an editor <iframe> then it's tab navigable.
					var body;
					try{
						// non-IE
						var contentDocument = elem.contentDocument;
						if("designMode" in contentDocument && contentDocument.designMode == "on"){
							return true;
						}
						body = contentDocument.body;
					}catch(e1){
						// contentWindow.document isn't accessible within IE7/8
						// if the iframe.src points to a foreign url and this
						// page contains an element, that could get focus
						try{
							body = elem.contentWindow.document.body;
						}catch(e2){
							return false;
						}
					}
					return body && (body.contentEditable == 'true' ||
						(body.firstChild && body.firstChild.contentEditable == 'true'));
				default:
					return elem.contentEditable == 'true';
			}
		},

		effectiveTabIndex: function(/*Element*/ elem){
			// summary:
			//		Returns effective tabIndex of an element, either a number, or undefined if element isn't focusable.

			if(domAttr.get(elem, "disabled")){
				return undefined;
			}else if(domAttr.has(elem, "tabIndex")){
				// Explicit tab index setting
				return +domAttr.get(elem, "tabIndex");// + to convert string --> number
			}else{
				// No explicit tabIndex setting, so depends on node type
				return a11y.hasDefaultTabStop(elem) ? 0 : undefined;
			}
		},

		isTabNavigable: function(/*Element*/ elem){
			// summary:
			//		Tests if an element is tab-navigable

			return a11y.effectiveTabIndex(elem) >= 0;
		},

		isFocusable: function(/*Element*/ elem){
			// summary:
			//		Tests if an element is focusable by tabbing to it, or clicking it with the mouse.

			return a11y.effectiveTabIndex(elem) >= -1;
		},

		_getTabNavigable: function(/*DOMNode*/ root){
			// summary:
			//		Finds descendants of the specified root node.
			// description:
			//		Finds the following descendants of the specified root node:
			//
			//		- the first tab-navigable element in document order
			//		  without a tabIndex or with tabIndex="0"
			//		- the last tab-navigable element in document order
			//		  without a tabIndex or with tabIndex="0"
			//		- the first element in document order with the lowest
			//		  positive tabIndex value
			//		- the last element in document order with the highest
			//		  positive tabIndex value
			var first, last, lowest, lowestTabindex, highest, highestTabindex, radioSelected = {};

			function radioName(node){
				// If this element is part of a radio button group, return the name for that group.
				return node && node.tagName.toLowerCase() == "input" &&
					node.type && node.type.toLowerCase() == "radio" &&
					node.name && node.name.toLowerCase();
			}

			var shown = a11y._isElementShown, effectiveTabIndex = a11y.effectiveTabIndex;
			var walkTree = function(/*DOMNode*/ parent){
				for(var child = parent.firstChild; child; child = child.nextSibling){
					// Skip text elements, hidden elements, and also non-HTML elements (those in custom namespaces) in IE,
					// since show() invokes getAttribute("type"), which crash on VML nodes in IE.
					if(child.nodeType != 1 || (has("ie") <= 9 && child.scopeName !== "HTML") || !shown(child)){
						continue;
					}

					var tabindex = effectiveTabIndex(child);
					if(tabindex >= 0){
						if(tabindex == 0){
							if(!first){
								first = child;
							}
							last = child;
						}else if(tabindex > 0){
							if(!lowest || tabindex < lowestTabindex){
								lowestTabindex = tabindex;
								lowest = child;
							}
							if(!highest || tabindex >= highestTabindex){
								highestTabindex = tabindex;
								highest = child;
							}
						}
						var rn = radioName(child);
						if(domAttr.get(child, "checked") && rn){
							radioSelected[rn] = child;
						}
					}
					if(child.nodeName.toUpperCase() != 'SELECT'){
						walkTree(child);
					}
				}
			};
			if(shown(root)){
				walkTree(root);
			}
			function rs(node){
				// substitute checked radio button for unchecked one, if there is a checked one with the same name.
				return radioSelected[radioName(node)] || node;
			}

			return { first: rs(first), last: rs(last), lowest: rs(lowest), highest: rs(highest) };
		},

		getFirstInTabbingOrder: function(/*String|DOMNode*/ root, /*Document?*/ doc){
			// summary:
			//		Finds the descendant of the specified root node
			//		that is first in the tabbing order
			var elems = a11y._getTabNavigable(dom.byId(root, doc));
			return elems.lowest ? elems.lowest : elems.first; // DomNode
		},

		getLastInTabbingOrder: function(/*String|DOMNode*/ root, /*Document?*/ doc){
			// summary:
			//		Finds the descendant of the specified root node
			//		that is last in the tabbing order
			var elems = a11y._getTabNavigable(dom.byId(root, doc));
			return elems.last ? elems.last : elems.highest; // DomNode
		}
	};

	 1  && lang.mixin(dijit, a11y);

	return a11y;
});

},
'dijit/popup':function(){
define([
	"dojo/_base/array", // array.forEach array.some
	"dojo/aspect",
	"dojo/_base/declare", // declare
	"dojo/dom", // dom.isDescendant
	"dojo/dom-attr", // domAttr.set
	"dojo/dom-construct", // domConstruct.create domConstruct.destroy
	"dojo/dom-geometry", // domGeometry.isBodyLtr
	"dojo/dom-style", // domStyle.set
	"dojo/has", // has("config-bgIframe")
	"dojo/keys",
	"dojo/_base/lang", // lang.hitch
	"dojo/on",
	"./place",
	"./BackgroundIframe",
	"./Viewport",
	"./main",    // dijit (defining dijit.popup to match API doc)
	"dojo/touch"		// use of dojoClick
], function(array, aspect, declare, dom, domAttr, domConstruct, domGeometry, domStyle, has, keys, lang, on,
			place, BackgroundIframe, Viewport, dijit){

	// module:
	//		dijit/popup

	/*=====
	 var __OpenArgs = {
		 // popup: Widget
		 //		widget to display
		 // parent: Widget
		 //		the button etc. that is displaying this popup
		 // around: DomNode
		 //		DOM node (typically a button); place popup relative to this node.  (Specify this *or* "x" and "y" parameters.)
		 // x: Integer
		 //		Absolute horizontal position (in pixels) to place node at.  (Specify this *or* "around" parameter.)
		 // y: Integer
		 //		Absolute vertical position (in pixels) to place node at.  (Specify this *or* "around" parameter.)
		 // orient: Object|String
		 //		When the around parameter is specified, orient should be a list of positions to try, ex:
		 //	|	[ "below", "above" ]
		 //		For backwards compatibility it can also be an (ordered) hash of tuples of the form
		 //		(around-node-corner, popup-node-corner), ex:
		 //	|	{ "BL": "TL", "TL": "BL" }
		 //		where BL means "bottom left" and "TL" means "top left", etc.
		 //
		 //		dijit/popup.open() tries to position the popup according to each specified position, in order,
		 //		until the popup appears fully within the viewport.
		 //
		 //		The default value is ["below", "above"]
		 //
		 //		When an (x,y) position is specified rather than an around node, orient is either
		 //		"R" or "L".  R (for right) means that it tries to put the popup to the right of the mouse,
		 //		specifically positioning the popup's top-right corner at the mouse position, and if that doesn't
		 //		fit in the viewport, then it tries, in order, the bottom-right corner, the top left corner,
		 //		and the top-right corner.
		 // onCancel: Function
		 //		callback when user has canceled the popup by:
		 //
		 //		1. hitting ESC or
		 //		2. by using the popup widget's proprietary cancel mechanism (like a cancel button in a dialog);
		 //		   i.e. whenever popupWidget.onCancel() is called, args.onCancel is called
		 // onClose: Function
		 //		callback whenever this popup is closed
		 // onExecute: Function
		 //		callback when user "executed" on the popup/sub-popup by selecting a menu choice, etc. (top menu only)
		 // padding: place.__Position
		 //		adding a buffer around the opening position. This is only useful when around is not set.
		 // maxHeight: Integer
		 //		The max height for the popup.  Any popup taller than this will have scrollbars.
		 //		Set to Infinity for no max height.  Default is to limit height to available space in viewport,
		 //		above or below the aroundNode or specified x/y position.
	 };
	 =====*/

	function destroyWrapper(){
		// summary:
		//		Function to destroy wrapper when popup widget is destroyed.
		//		Left in this scope to avoid memory leak on IE8 on refresh page, see #15206.
		if(this._popupWrapper){
			domConstruct.destroy(this._popupWrapper);
			delete this._popupWrapper;
		}
	}

	var PopupManager = declare(null, {
		// summary:
		//		Used to show drop downs (ex: the select list of a ComboBox)
		//		or popups (ex: right-click context menus).

		// _stack: dijit/_WidgetBase[]
		//		Stack of currently popped up widgets.
		//		(someone opened _stack[0], and then it opened _stack[1], etc.)
		_stack: [],

		// _beginZIndex: Number
		//		Z-index of the first popup.   (If first popup opens other
		//		popups they get a higher z-index.)
		_beginZIndex: 1000,

		_idGen: 1,

		_repositionAll: function(){
			// summary:
			//		If screen has been scrolled, reposition all the popups in the stack.
			//		Then set timer to check again later.

			if(this._firstAroundNode){	// guard for when clearTimeout() on IE doesn't work
				var oldPos = this._firstAroundPosition,
					newPos = domGeometry.position(this._firstAroundNode, true),
					dx = newPos.x - oldPos.x,
					dy = newPos.y - oldPos.y;

				if(dx || dy){
					this._firstAroundPosition = newPos;
					for(var i = 0; i < this._stack.length; i++){
						var style = this._stack[i].wrapper.style;
						style.top = (parseFloat(style.top) + dy) + "px";
						if(style.right == "auto"){
							style.left = (parseFloat(style.left) + dx) + "px";
						}else{
							style.right = (parseFloat(style.right) - dx) + "px";
						}
					}
				}

				this._aroundMoveListener = setTimeout(lang.hitch(this, "_repositionAll"), dx || dy ? 10 : 50);
			}
		},

		_createWrapper: function(/*Widget*/ widget){
			// summary:
			//		Initialization for widgets that will be used as popups.
			//		Puts widget inside a wrapper DIV (if not already in one),
			//		and returns pointer to that wrapper DIV.

			var wrapper = widget._popupWrapper,
				node = widget.domNode;

			if(!wrapper){
				// Create wrapper <div> for when this widget [in the future] will be used as a popup.
				// This is done early because of IE bugs where creating/moving DOM nodes causes focus
				// to go wonky, see tests/robot/Toolbar.html to reproduce
				wrapper = domConstruct.create("div", {
					"class": "dijitPopup",
					style: { display: "none"},
					role: "region",
					"aria-label": widget["aria-label"] || widget.label || widget.name || widget.id
				}, widget.ownerDocumentBody);
				wrapper.appendChild(node);

				var s = node.style;
				s.display = "";
				s.visibility = "";
				s.position = "";
				s.top = "0px";

				widget._popupWrapper = wrapper;
				aspect.after(widget, "destroy", destroyWrapper, true);

				// Workaround iOS problem where clicking a Menu can focus an <input> (or click a button) behind it.
				// Need to be careful though that you can still focus <input>'s and click <button>'s in a TooltipDialog.
				// Also, be careful not to break (native) scrolling of dropdown like ComboBox's options list.
				if("ontouchend" in document) {
					on(wrapper, "touchend", function (evt){
						if(!/^(input|button|textarea)$/i.test(evt.target.tagName)) {
							evt.preventDefault();
						}
					});
				}

				// Calling evt.preventDefault() suppresses the native click event on most browsers.  However, it doesn't
				// suppress the synthetic click event emitted by dojo/touch.  In order for clicks in popups to work
				// consistently, always use dojo/touch in popups.  See #18150.
				wrapper.dojoClick = true;
			}

			return wrapper;
		},

		moveOffScreen: function(/*Widget*/ widget){
			// summary:
			//		Moves the popup widget off-screen.
			//		Do not use this method to hide popups when not in use, because
			//		that will create an accessibility issue: the offscreen popup is
			//		still in the tabbing order.

			// Create wrapper if not already there
			var wrapper = this._createWrapper(widget);

			// Besides setting visibility:hidden, move it out of the viewport, see #5776, #10111, #13604
			var ltr = domGeometry.isBodyLtr(widget.ownerDocument),
				style = {
					visibility: "hidden",
					top: "-9999px",
					display: ""
				};
			style[ltr ? "left" : "right"] = "-9999px";
			style[ltr ? "right" : "left"] = "auto";
			domStyle.set(wrapper, style);

			return wrapper;
		},

		hide: function(/*Widget*/ widget){
			// summary:
			//		Hide this popup widget (until it is ready to be shown).
			//		Initialization for widgets that will be used as popups
			//
			//		Also puts widget inside a wrapper DIV (if not already in one)
			//
			//		If popup widget needs to layout it should
			//		do so when it is made visible, and popup._onShow() is called.

			// Create wrapper if not already there
			var wrapper = this._createWrapper(widget);

			domStyle.set(wrapper, {
				display: "none",
				height: "auto",			// Open() may have limited the height to fit in the viewport,
				overflowY: "visible",	// and set overflowY to "auto".
				border: ""				// Open() may have moved border from popup to wrapper.
			});

			// Open() may have moved border from popup to wrapper.  Move it back.
			var node = widget.domNode;
			if("_originalStyle" in node){
				node.style.cssText = node._originalStyle;
			}
		},

		getTopPopup: function(){
			// summary:
			//		Compute the closest ancestor popup that's *not* a child of another popup.
			//		Ex: For a TooltipDialog with a button that spawns a tree of menus, find the popup of the button.
			var stack = this._stack;
			for(var pi = stack.length - 1; pi > 0 && stack[pi].parent === stack[pi - 1].widget; pi--){
				/* do nothing, just trying to get right value for pi */
			}
			return stack[pi];
		},

		open: function(/*__OpenArgs*/ args){
			// summary:
			//		Popup the widget at the specified position
			//
			// example:
			//		opening at the mouse position
			//		|		popup.open({popup: menuWidget, x: evt.pageX, y: evt.pageY});
			//
			// example:
			//		opening the widget as a dropdown
			//		|		popup.open({parent: this, popup: menuWidget, around: this.domNode, onClose: function(){...}});
			//
			//		Note that whatever widget called dijit/popup.open() should also listen to its own _onBlur callback
			//		(fired from _base/focus.js) to know that focus has moved somewhere else and thus the popup should be closed.

			var stack = this._stack,
				widget = args.popup,
				node = widget.domNode,
				orient = args.orient || ["below", "below-alt", "above", "above-alt"],
				ltr = args.parent ? args.parent.isLeftToRight() : domGeometry.isBodyLtr(widget.ownerDocument),
				around = args.around,
				id = (args.around && args.around.id) ? (args.around.id + "_dropdown") : ("popup_" + this._idGen++);

			// If we are opening a new popup that isn't a child of a currently opened popup, then
			// close currently opened popup(s).   This should happen automatically when the old popups
			// gets the _onBlur() event, except that the _onBlur() event isn't reliable on IE, see [22198].
			while(stack.length && (!args.parent || !dom.isDescendant(args.parent.domNode, stack[stack.length - 1].widget.domNode))){
				this.close(stack[stack.length - 1].widget);
			}

			// Get pointer to popup wrapper, and create wrapper if it doesn't exist.  Remove display:none (but keep
			// off screen) so we can do sizing calculations.
			var wrapper = this.moveOffScreen(widget);

			if(widget.startup && !widget._started){
				widget.startup(); // this has to be done after being added to the DOM
			}

			// Limit height to space available in viewport either above or below aroundNode (whichever side has more
			// room), adding scrollbar if necessary. Can't add scrollbar to widget because it may be a <table> (ex:
			// dijit/Menu), so add to wrapper, and then move popup's border to wrapper so scroll bar inside border.
			var maxHeight, popupSize = domGeometry.position(node);
			if("maxHeight" in args && args.maxHeight != -1){
				maxHeight = args.maxHeight || Infinity;	// map 0 --> infinity for back-compat of _HasDropDown.maxHeight
			}else{
				var viewport = Viewport.getEffectiveBox(this.ownerDocument),
					aroundPos = around ? domGeometry.position(around, false) : {y: args.y - (args.padding||0), h: (args.padding||0) * 2};
				maxHeight = Math.floor(Math.max(aroundPos.y, viewport.h - (aroundPos.y + aroundPos.h)));
			}
			if(popupSize.h > maxHeight){
				// Get style of popup's border.  Unfortunately domStyle.get(node, "border") doesn't work on FF or IE,
				// and domStyle.get(node, "borderColor") etc. doesn't work on FF, so need to use fully qualified names.
				var cs = domStyle.getComputedStyle(node),
					borderStyle = cs.borderLeftWidth + " " + cs.borderLeftStyle + " " + cs.borderLeftColor;
				domStyle.set(wrapper, {
					overflowY: "scroll",
					height: maxHeight + "px",
					border: borderStyle	// so scrollbar is inside border
				});
				node._originalStyle = node.style.cssText;
				node.style.border = "none";
			}

			domAttr.set(wrapper, {
				id: id,
				style: {
					zIndex: this._beginZIndex + stack.length
				},
				"class": "dijitPopup " + (widget.baseClass || widget["class"] || "").split(" ")[0] + "Popup",
				dijitPopupParent: args.parent ? args.parent.id : ""
			});

			if(stack.length == 0 && around){
				// First element on stack. Save position of aroundNode and setup listener for changes to that position.
				this._firstAroundNode = around;
				this._firstAroundPosition = domGeometry.position(around, true);
				this._aroundMoveListener = setTimeout(lang.hitch(this, "_repositionAll"), 50);
			}

			if(has("config-bgIframe") && !widget.bgIframe){
				// setting widget.bgIframe triggers cleanup in _WidgetBase.destroyRendering()
				widget.bgIframe = new BackgroundIframe(wrapper);
			}

			// position the wrapper node and make it visible
			var layoutFunc = widget.orient ? lang.hitch(widget, "orient") : null,
				best = around ?
					place.around(wrapper, around, orient, ltr, layoutFunc) :
					place.at(wrapper, args, orient == 'R' ? ['TR', 'BR', 'TL', 'BL'] : ['TL', 'BL', 'TR', 'BR'], args.padding,
						layoutFunc);

			wrapper.style.visibility = "visible";
			node.style.visibility = "visible";	// counteract effects from _HasDropDown

			var handlers = [];

			// provide default escape and tab key handling
			// (this will work for any widget, not just menu)
			handlers.push(on(wrapper, "keydown", lang.hitch(this, function(evt){
				if(evt.keyCode == keys.ESCAPE && args.onCancel){
					evt.stopPropagation();
					evt.preventDefault();
					args.onCancel();
				}else if(evt.keyCode == keys.TAB){
					evt.stopPropagation();
					evt.preventDefault();
					var topPopup = this.getTopPopup();
					if(topPopup && topPopup.onCancel){
						topPopup.onCancel();
					}
				}
			})));

			// watch for cancel/execute events on the popup and notify the caller
			// (for a menu, "execute" means clicking an item)
			if(widget.onCancel && args.onCancel){
				handlers.push(widget.on("cancel", args.onCancel));
			}

			handlers.push(widget.on(widget.onExecute ? "execute" : "change", lang.hitch(this, function(){
				var topPopup = this.getTopPopup();
				if(topPopup && topPopup.onExecute){
					topPopup.onExecute();
				}
			})));

			stack.push({
				widget: widget,
				wrapper: wrapper,
				parent: args.parent,
				onExecute: args.onExecute,
				onCancel: args.onCancel,
				onClose: args.onClose,
				handlers: handlers
			});

			if(widget.onOpen){
				// TODO: in 2.0 standardize onShow() (used by StackContainer) and onOpen() (used here)
				widget.onOpen(best);
			}

			return best;
		},

		close: function(/*Widget?*/ popup){
			// summary:
			//		Close specified popup and any popups that it parented.
			//		If no popup is specified, closes all popups.

			var stack = this._stack;

			// Basically work backwards from the top of the stack closing popups
			// until we hit the specified popup, but IIRC there was some issue where closing
			// a popup would cause others to close too.  Thus if we are trying to close B in [A,B,C]
			// closing C might close B indirectly and then the while() condition will run where stack==[A]...
			// so the while condition is constructed defensively.
			while((popup && array.some(stack, function(elem){
				return elem.widget == popup;
			})) ||
				(!popup && stack.length)){
				var top = stack.pop(),
					widget = top.widget,
					onClose = top.onClose;

				if (widget.bgIframe) {
					// push the iframe back onto the stack.
					widget.bgIframe.destroy();
					delete widget.bgIframe;
				}

				if(widget.onClose){
					// TODO: in 2.0 standardize onHide() (used by StackContainer) and onClose() (used here).
					// Actually, StackContainer also calls onClose(), but to mean that the pane is being deleted
					// (i.e. that the TabContainer's tab's [x] icon was clicked)
					widget.onClose();
				}

				var h;
				while(h = top.handlers.pop()){
					h.remove();
				}

				// Hide the widget and it's wrapper unless it has already been destroyed in above onClose() etc.
				if(widget && widget.domNode){
					this.hide(widget);
				}

				if(onClose){
					onClose();
				}
			}

			if(stack.length == 0 && this._aroundMoveListener){
				clearTimeout(this._aroundMoveListener);
				this._firstAroundNode = this._firstAroundPosition = this._aroundMoveListener = null;
			}
		}
	});

	return (dijit.popup = new PopupManager());
});

},
'dijit/place':function(){
define([
	"dojo/_base/array", // array.forEach array.map array.some
	"dojo/dom-geometry", // domGeometry.position
	"dojo/dom-style", // domStyle.getComputedStyle
	"dojo/_base/kernel", // kernel.deprecated
	"dojo/_base/window", // win.body
	"./Viewport", // getEffectiveBox
	"./main"	// dijit (defining dijit.place to match API doc)
], function(array, domGeometry, domStyle, kernel, win, Viewport, dijit){

	// module:
	//		dijit/place


	function _place(/*DomNode*/ node, choices, layoutNode, aroundNodeCoords){
		// summary:
		//		Given a list of spots to put node, put it at the first spot where it fits,
		//		of if it doesn't fit anywhere then the place with the least overflow
		// choices: Array
		//		Array of elements like: {corner: 'TL', pos: {x: 10, y: 20} }
		//		Above example says to put the top-left corner of the node at (10,20)
		// layoutNode: Function(node, aroundNodeCorner, nodeCorner, size)
		//		for things like tooltip, they are displayed differently (and have different dimensions)
		//		based on their orientation relative to the parent.	 This adjusts the popup based on orientation.
		//		It also passes in the available size for the popup, which is useful for tooltips to
		//		tell them that their width is limited to a certain amount.	 layoutNode() may return a value expressing
		//		how much the popup had to be modified to fit into the available space.	 This is used to determine
		//		what the best placement is.
		// aroundNodeCoords: Object
		//		Size of aroundNode, ex: {w: 200, h: 50}

		// get {x: 10, y: 10, w: 100, h:100} type obj representing position of
		// viewport over document
		var view = Viewport.getEffectiveBox(node.ownerDocument);

		// This won't work if the node is inside a <div style="position: relative">,
		// so reattach it to <body>.	 (Otherwise, the positioning will be wrong
		// and also it might get cutoff.)
		if(!node.parentNode || String(node.parentNode.tagName).toLowerCase() != "body"){
			win.body(node.ownerDocument).appendChild(node);
		}

		var best = null;
		array.some(choices, function(choice){
			var corner = choice.corner;
			var pos = choice.pos;
			var overflow = 0;

			// calculate amount of space available given specified position of node
			var spaceAvailable = {
				w: {
					'L': view.l + view.w - pos.x,
					'R': pos.x - view.l,
					'M': view.w
				}[corner.charAt(1)],
				h: {
					'T': view.t + view.h - pos.y,
					'B': pos.y - view.t,
					'M': view.h
				}[corner.charAt(0)]
			};

			// Clear left/right position settings set earlier so they don't interfere with calculations,
			// specifically when layoutNode() (a.k.a. Tooltip.orient()) measures natural width of Tooltip
			var s = node.style;
			s.left = s.right = "auto";

			// configure node to be displayed in given position relative to button
			// (need to do this in order to get an accurate size for the node, because
			// a tooltip's size changes based on position, due to triangle)
			if(layoutNode){
				var res = layoutNode(node, choice.aroundCorner, corner, spaceAvailable, aroundNodeCoords);
				overflow = typeof res == "undefined" ? 0 : res;
			}

			// get node's size
			var style = node.style;
			var oldDisplay = style.display;
			var oldVis = style.visibility;
			if(style.display == "none"){
				style.visibility = "hidden";
				style.display = "";
			}
			var bb = domGeometry.position(node);
			style.display = oldDisplay;
			style.visibility = oldVis;

			// coordinates and size of node with specified corner placed at pos,
			// and clipped by viewport
			var
				startXpos = {
					'L': pos.x,
					'R': pos.x - bb.w,
					'M': Math.max(view.l, Math.min(view.l + view.w, pos.x + (bb.w >> 1)) - bb.w) // M orientation is more flexible
				}[corner.charAt(1)],
				startYpos = {
					'T': pos.y,
					'B': pos.y - bb.h,
					'M': Math.max(view.t, Math.min(view.t + view.h, pos.y + (bb.h >> 1)) - bb.h)
				}[corner.charAt(0)],
				startX = Math.max(view.l, startXpos),
				startY = Math.max(view.t, startYpos),
				endX = Math.min(view.l + view.w, startXpos + bb.w),
				endY = Math.min(view.t + view.h, startYpos + bb.h),
				width = endX - startX,
				height = endY - startY;

			overflow += (bb.w - width) + (bb.h - height);

			if(best == null || overflow < best.overflow){
				best = {
					corner: corner,
					aroundCorner: choice.aroundCorner,
					x: startX,
					y: startY,
					w: width,
					h: height,
					overflow: overflow,
					spaceAvailable: spaceAvailable
				};
			}

			return !overflow;
		});

		// In case the best position is not the last one we checked, need to call
		// layoutNode() again.
		if(best.overflow && layoutNode){
			layoutNode(node, best.aroundCorner, best.corner, best.spaceAvailable, aroundNodeCoords);
		}

		// And then position the node.  Do this last, after the layoutNode() above
		// has sized the node, due to browser quirks when the viewport is scrolled
		// (specifically that a Tooltip will shrink to fit as though the window was
		// scrolled to the left).

		var top = best.y,
			side = best.x,
			body = win.body(node.ownerDocument);

		if(/relative|absolute/.test(domStyle.get(body, "position"))){
			// compensate for margin on <body>, see #16148
			top -= domStyle.get(body, "marginTop");
			side -= domStyle.get(body, "marginLeft");
		}

		var s = node.style;
		s.top = top + "px";
		s.left = side + "px";
		s.right = "auto";	// needed for FF or else tooltip goes to far left

		return best;
	}

	var reverse = {
		// Map from corner to kitty-corner
		"TL": "BR",
		"TR": "BL",
		"BL": "TR",
		"BR": "TL"
	};

	var place = {
		// summary:
		//		Code to place a DOMNode relative to another DOMNode.
		//		Load using require(["dijit/place"], function(place){ ... }).

		at: function(node, pos, corners, padding, layoutNode){
			// summary:
			//		Positions node kitty-corner to the rectangle centered at (pos.x, pos.y) with width and height of
			//		padding.x * 2 and padding.y * 2, or zero if padding not specified.  Picks first corner in corners[]
			//		where node is fully visible, or the corner where it's most visible.
			//
			//		Node is assumed to be absolutely or relatively positioned.
			// node: DOMNode
			//		The node to position
			// pos: dijit/place.__Position
			//		Object like {x: 10, y: 20}
			// corners: String[]
			//		Array of Strings representing order to try corners of the node in, like ["TR", "BL"].
			//		Possible values are:
			//
			//		- "BL" - bottom left
			//		- "BR" - bottom right
			//		- "TL" - top left
			//		- "TR" - top right
			// padding: dijit/place.__Position?
			//		Optional param to set padding, to put some buffer around the element you want to position.
			//		Defaults to zero.
			// layoutNode: Function(node, aroundNodeCorner, nodeCorner)
			//		For things like tooltip, they are displayed differently (and have different dimensions)
			//		based on their orientation relative to the parent.  This adjusts the popup based on orientation.
			// example:
			//		Try to place node's top right corner at (10,20).
			//		If that makes node go (partially) off screen, then try placing
			//		bottom left corner at (10,20).
			//	|	place(node, {x: 10, y: 20}, ["TR", "BL"])
			var choices = array.map(corners, function(corner){
				var c = {
					corner: corner,
					aroundCorner: reverse[corner],	// so TooltipDialog.orient() gets aroundCorner argument set
					pos: {x: pos.x,y: pos.y}
				};
				if(padding){
					c.pos.x += corner.charAt(1) == 'L' ? padding.x : -padding.x;
					c.pos.y += corner.charAt(0) == 'T' ? padding.y : -padding.y;
				}
				return c;
			});

			return _place(node, choices, layoutNode);
		},

		around: function(
			/*DomNode*/		node,
			/*DomNode|dijit/place.__Rectangle*/ anchor,
			/*String[]*/	positions,
			/*Boolean*/		leftToRight,
			/*Function?*/	layoutNode){

			// summary:
			//		Position node adjacent or kitty-corner to anchor
			//		such that it's fully visible in viewport.
			// description:
			//		Place node such that corner of node touches a corner of
			//		aroundNode, and that node is fully visible.
			// anchor:
			//		Either a DOMNode or a rectangle (object with x, y, width, height).
			// positions:
			//		Ordered list of positions to try matching up.
			//
			//		- before: places drop down to the left of the anchor node/widget, or to the right in the case
			//			of RTL scripts like Hebrew and Arabic; aligns either the top of the drop down
			//			with the top of the anchor, or the bottom of the drop down with bottom of the anchor.
			//		- after: places drop down to the right of the anchor node/widget, or to the left in the case
			//			of RTL scripts like Hebrew and Arabic; aligns either the top of the drop down
			//			with the top of the anchor, or the bottom of the drop down with bottom of the anchor.
			//		- before-centered: centers drop down to the left of the anchor node/widget, or to the right
			//			in the case of RTL scripts like Hebrew and Arabic
			//		- after-centered: centers drop down to the right of the anchor node/widget, or to the left
			//			in the case of RTL scripts like Hebrew and Arabic
			//		- above-centered: drop down is centered above anchor node
			//		- above: drop down goes above anchor node, left sides aligned
			//		- above-alt: drop down goes above anchor node, right sides aligned
			//		- below-centered: drop down is centered above anchor node
			//		- below: drop down goes below anchor node
			//		- below-alt: drop down goes below anchor node, right sides aligned
			// layoutNode: Function(node, aroundNodeCorner, nodeCorner)
			//		For things like tooltip, they are displayed differently (and have different dimensions)
			//		based on their orientation relative to the parent.	 This adjusts the popup based on orientation.
			// leftToRight:
			//		True if widget is LTR, false if widget is RTL.   Affects the behavior of "above" and "below"
			//		positions slightly.
			// example:
			//	|	placeAroundNode(node, aroundNode, ['below', 'above-alt']);
			//		This will try to position node such that node's top-left corner is at the same position
			//		as the bottom left corner of the aroundNode (ie, put node below
			//		aroundNode, with left edges aligned).	If that fails it will try to put
			//		the bottom-right corner of node where the top right corner of aroundNode is
			//		(ie, put node above aroundNode, with right edges aligned)
			//

			// If around is a DOMNode (or DOMNode id), convert to coordinates.
			var aroundNodePos;
			if(typeof anchor == "string" || "offsetWidth" in anchor || "ownerSVGElement" in anchor){
				aroundNodePos = domGeometry.position(anchor, true);

				// For above and below dropdowns, subtract width of border so that popup and aroundNode borders
				// overlap, preventing a double-border effect.  Unfortunately, difficult to measure the border
				// width of either anchor or popup because in both cases the border may be on an inner node.
				if(/^(above|below)/.test(positions[0])){
					var anchorBorder = domGeometry.getBorderExtents(anchor),
						anchorChildBorder = anchor.firstChild ? domGeometry.getBorderExtents(anchor.firstChild) : {t:0,l:0,b:0,r:0},
						nodeBorder =  domGeometry.getBorderExtents(node),
						nodeChildBorder = node.firstChild ? domGeometry.getBorderExtents(node.firstChild) : {t:0,l:0,b:0,r:0};
					aroundNodePos.y += Math.min(anchorBorder.t + anchorChildBorder.t, nodeBorder.t + nodeChildBorder.t);
					aroundNodePos.h -=  Math.min(anchorBorder.t + anchorChildBorder.t, nodeBorder.t+ nodeChildBorder.t) +
						Math.min(anchorBorder.b + anchorChildBorder.b, nodeBorder.b + nodeChildBorder.b);
				}
			}else{
				aroundNodePos = anchor;
			}

			// Compute position and size of visible part of anchor (it may be partially hidden by ancestor nodes w/scrollbars)
			if(anchor.parentNode){
				// ignore nodes between position:relative and position:absolute
				var sawPosAbsolute = domStyle.getComputedStyle(anchor).position == "absolute";
				var parent = anchor.parentNode;
				while(parent && parent.nodeType == 1 && parent.nodeName != "BODY"){  //ignoring the body will help performance
					var parentPos = domGeometry.position(parent, true),
						pcs = domStyle.getComputedStyle(parent);
					if(/relative|absolute/.test(pcs.position)){
						sawPosAbsolute = false;
					}
					if(!sawPosAbsolute && /hidden|auto|scroll/.test(pcs.overflow)){
						var bottomYCoord = Math.min(aroundNodePos.y + aroundNodePos.h, parentPos.y + parentPos.h);
						var rightXCoord = Math.min(aroundNodePos.x + aroundNodePos.w, parentPos.x + parentPos.w);
						aroundNodePos.x = Math.max(aroundNodePos.x, parentPos.x);
						aroundNodePos.y = Math.max(aroundNodePos.y, parentPos.y);
						aroundNodePos.h = bottomYCoord - aroundNodePos.y;
						aroundNodePos.w = rightXCoord - aroundNodePos.x;
					}
					if(pcs.position == "absolute"){
						sawPosAbsolute = true;
					}
					parent = parent.parentNode;
				}
			}

			var x = aroundNodePos.x,
				y = aroundNodePos.y,
				width = "w" in aroundNodePos ? aroundNodePos.w : (aroundNodePos.w = aroundNodePos.width),
				height = "h" in aroundNodePos ? aroundNodePos.h : (kernel.deprecated("place.around: dijit/place.__Rectangle: { x:"+x+", y:"+y+", height:"+aroundNodePos.height+", width:"+width+" } has been deprecated.  Please use { x:"+x+", y:"+y+", h:"+aroundNodePos.height+", w:"+width+" }", "", "2.0"), aroundNodePos.h = aroundNodePos.height);

			// Convert positions arguments into choices argument for _place()
			var choices = [];
			function push(aroundCorner, corner){
				choices.push({
					aroundCorner: aroundCorner,
					corner: corner,
					pos: {
						x: {
							'L': x,
							'R': x + width,
							'M': x + (width >> 1)
						}[aroundCorner.charAt(1)],
						y: {
							'T': y,
							'B': y + height,
							'M': y + (height >> 1)
						}[aroundCorner.charAt(0)]
					}
				})
			}
			array.forEach(positions, function(pos){
				var ltr =  leftToRight;
				switch(pos){
					case "above-centered":
						push("TM", "BM");
						break;
					case "below-centered":
						push("BM", "TM");
						break;
					case "after-centered":
						ltr = !ltr;
						// fall through
					case "before-centered":
						push(ltr ? "ML" : "MR", ltr ? "MR" : "ML");
						break;
					case "after":
						ltr = !ltr;
						// fall through
					case "before":
						push(ltr ? "TL" : "TR", ltr ? "TR" : "TL");
						push(ltr ? "BL" : "BR", ltr ? "BR" : "BL");
						break;
					case "below-alt":
						ltr = !ltr;
						// fall through
					case "below":
						// first try to align left borders, next try to align right borders (or reverse for RTL mode)
						push(ltr ? "BL" : "BR", ltr ? "TL" : "TR");
						push(ltr ? "BR" : "BL", ltr ? "TR" : "TL");
						break;
					case "above-alt":
						ltr = !ltr;
						// fall through
					case "above":
						// first try to align left borders, next try to align right borders (or reverse for RTL mode)
						push(ltr ? "TL" : "TR", ltr ? "BL" : "BR");
						push(ltr ? "TR" : "TL", ltr ? "BR" : "BL");
						break;
					default:
						// To assist dijit/_base/place, accept arguments of type {aroundCorner: "BL", corner: "TL"}.
						// Not meant to be used directly.  Remove for 2.0.
						push(pos.aroundCorner, pos.corner);
				}
			});

			var position = _place(node, choices, layoutNode, {w: width, h: height});
			position.aroundNodePos = aroundNodePos;

			return position;
		}
	};

	/*=====
	place.__Position = {
		// x: Integer
		//		horizontal coordinate in pixels, relative to document body
		// y: Integer
		//		vertical coordinate in pixels, relative to document body
	};
	place.__Rectangle = {
		// x: Integer
		//		horizontal offset in pixels, relative to document body
		// y: Integer
		//		vertical offset in pixels, relative to document body
		// w: Integer
		//		width in pixels.   Can also be specified as "width" for backwards-compatibility.
		// h: Integer
		//		height in pixels.   Can also be specified as "height" for backwards-compatibility.
	};
	=====*/

	return dijit.place = place;	// setting dijit.place for back-compat, remove for 2.0
});

},
'dijit/Viewport':function(){
define([
	"dojo/Evented",
	"dojo/on",
	"dojo/domReady",
	"dojo/sniff",	// has("ie"), has("ios")
	"dojo/window" // getBox()
], function(Evented, on, domReady, has, winUtils){

	// module:
	//		dijit/Viewport

	/*=====
	return {
		// summary:
		//		Utility singleton to watch for viewport resizes, avoiding duplicate notifications
		//		which can lead to infinite loops.
		// description:
		//		Usage: Viewport.on("resize", myCallback).
		//
		//		myCallback() is called without arguments in case it's _WidgetBase.resize(),
		//		which would interpret the argument as the size to make the widget.
	};
	=====*/

	var Viewport = new Evented();

	var focusedNode;

	domReady(function(){
		var oldBox = winUtils.getBox();
		Viewport._rlh = on(window, "resize", function(){
			var newBox = winUtils.getBox();
			if(oldBox.h == newBox.h && oldBox.w == newBox.w){ return; }
			oldBox = newBox;
			Viewport.emit("resize");
		});

		// Also catch zoom changes on IE8, since they don't naturally generate resize events
		if(has("ie") == 8){
			var deviceXDPI = screen.deviceXDPI;
			setInterval(function(){
				if(screen.deviceXDPI != deviceXDPI){
					deviceXDPI = screen.deviceXDPI;
					Viewport.emit("resize");
				}
			}, 500);
		}

		// On iOS, keep track of the focused node so we can guess when the keyboard is/isn't being displayed.
		if(has("ios")){
			on(document, "focusin", function(evt){
				focusedNode = evt.target;
			});
			on(document, "focusout", function(evt){
				focusedNode = null;
			});
		}
	});

	Viewport.getEffectiveBox = function(/*Document*/ doc){
		// summary:
		//		Get the size of the viewport, or on mobile devices, the part of the viewport not obscured by the
		//		virtual keyboard.

		var box = winUtils.getBox(doc);

		// Account for iOS virtual keyboard, if it's being shown.  Unfortunately no direct way to check or measure.
		var tag = focusedNode && focusedNode.tagName && focusedNode.tagName.toLowerCase();
		if(has("ios") && focusedNode && !focusedNode.readOnly && (tag == "textarea" || (tag == "input" &&
			/^(color|email|number|password|search|tel|text|url)$/.test(focusedNode.type)))){

			// Box represents the size of the viewport.  Some of the viewport is likely covered by the keyboard.
			// Estimate height of visible viewport assuming viewport goes to bottom of screen, but is covered by keyboard.
			box.h *= (orientation == 0 || orientation == 180 ? 0.66 : 0.40);

			// Above measurement will be inaccurate if viewport was scrolled up so far that it ends before the bottom
			// of the screen.   In this case, keyboard isn't covering as much of the viewport as we thought.
			// We know the visible size is at least the distance from the top of the viewport to the focused node.
			var rect = focusedNode.getBoundingClientRect();
			box.h = Math.max(box.h, rect.top + rect.height);
		}

		return box;
	};

	return Viewport;
});

},
'dijit/BackgroundIframe':function(){
define([
	"require",			// require.toUrl
	"./main",	// to export dijit.BackgroundIframe
	"dojo/_base/config",
	"dojo/dom-construct", // domConstruct.create
	"dojo/dom-style", // domStyle.set
	"dojo/_base/lang", // lang.extend lang.hitch
	"dojo/on",
	"dojo/sniff" // has("ie"), has("trident"), has("quirks")
], function(require, dijit, config, domConstruct, domStyle, lang, on, has){

	// module:
	//		dijit/BackgroundIFrame

	// Flag for whether to create background iframe behind popups like Menus and Dialog.
	// A background iframe is useful to prevent problems with popups appearing behind applets/pdf files,
	// and is also useful on older versions of IE (IE6 and IE7) to prevent the "bleed through select" problem.
	// By default, it's enabled for IE6-11, excluding Windows Phone 8.
	// TODO: For 2.0, make this false by default.  Also, possibly move definition to has.js so that this module can be
	// conditionally required via  dojo/has!bgIfame?dijit/BackgroundIframe
	has.add("config-bgIframe",
    	(has("ie") || has("trident")) && !/IEMobile\/10\.0/.test(navigator.userAgent)); // No iframe on WP8, to match 1.9 behavior

	var _frames = new function(){
		// summary:
		//		cache of iframes

		var queue = [];

		this.pop = function(){
			var iframe;
			if(queue.length){
				iframe = queue.pop();
				iframe.style.display="";
			}else{
				// transparency needed for DialogUnderlay and for tooltips on IE (to see screen near connector)
				if(has("ie") < 9){
					var burl = config["dojoBlankHtmlUrl"] || require.toUrl("dojo/resources/blank.html") || "javascript:\"\"";
					var html="<iframe src='" + burl + "' role='presentation'"
						+ " style='position: absolute; left: 0px; top: 0px;"
						+ "z-index: -1; filter:Alpha(Opacity=\"0\");'>";
					iframe = document.createElement(html);
				}else{
					iframe = domConstruct.create("iframe");
					iframe.src = 'javascript:""';
					iframe.className = "dijitBackgroundIframe";
					iframe.setAttribute("role", "presentation");
					domStyle.set(iframe, "opacity", 0.1);
				}
				iframe.tabIndex = -1; // Magic to prevent iframe from getting focus on tab keypress - as style didn't work.
			}
			return iframe;
		};

		this.push = function(iframe){
			iframe.style.display="none";
			queue.push(iframe);
		}
	}();


	dijit.BackgroundIframe = function(/*DomNode*/ node){
		// summary:
		//		For IE/FF z-index shenanigans. id attribute is required.
		//
		// description:
		//		new dijit.BackgroundIframe(node).
		//
		//		Makes a background iframe as a child of node, that fills
		//		area (and position) of node

		if(!node.id){ throw new Error("no id"); }
		if(has("config-bgIframe")){
			var iframe = (this.iframe = _frames.pop());
			node.appendChild(iframe);
			if(has("ie")<7 || has("quirks")){
				this.resize(node);
				this._conn = on(node, 'resize', lang.hitch(this, "resize", node));
			}else{
				domStyle.set(iframe, {
					width: '100%',
					height: '100%'
				});
			}
		}
	};

	lang.extend(dijit.BackgroundIframe, {
		resize: function(node){
			// summary:
			//		Resize the iframe so it's the same size as node.
			//		Needed on IE6 and IE/quirks because height:100% doesn't work right.
			if(this.iframe){
				domStyle.set(this.iframe, {
					width: node.offsetWidth + 'px',
					height: node.offsetHeight + 'px'
				});
			}
		},
		destroy: function(){
			// summary:
			//		destroy the iframe
			if(this._conn){
				this._conn.remove();
				this._conn = null;
			}
			if(this.iframe){
				this.iframe.parentNode.removeChild(this.iframe);
				_frames.push(this.iframe);
				delete this.iframe;
			}
		}
	});

	return dijit.BackgroundIframe;
});

},
'dijit/TooltipDialog':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/dom-class", // domClass.replace
	"dojo/has",
	"dojo/keys", // keys
	"dojo/_base/lang", // lang.hitch
	"dojo/on",
	"./focus",
	"./layout/ContentPane",
	"./_DialogMixin",
	"./form/_FormMixin",
	"./_TemplatedMixin",
	"dojo/text!./templates/TooltipDialog.html",
	"./main"        // exports methods to dijit global
], function(declare, domClass, has, keys, lang, on, focus, ContentPane, _DialogMixin, _FormMixin, _TemplatedMixin, template, dijit){

	// module:
	//		dijit/TooltipDialog


	var TooltipDialog = declare("dijit.TooltipDialog",
		[ContentPane, _TemplatedMixin, _FormMixin, _DialogMixin], {
			// summary:
			//		Pops up a dialog that appears like a Tooltip

			// title: String
			//		Description of tooltip dialog (required for a11y)
			title: "",

			// doLayout: [protected] Boolean
			//		Don't change this parameter from the default value.
			//		This ContentPane parameter doesn't make sense for TooltipDialog, since TooltipDialog
			//		is never a child of a layout container, nor can you specify the size of
			//		TooltipDialog in order to control the size of an inner widget.
			doLayout: false,

			// autofocus: Boolean
			//		A Toggle to modify the default focus behavior of a Dialog, which
			//		is to focus on the first dialog element after opening the dialog.
			//		False will disable autofocusing.  Default: true.
			autofocus: true,

			// baseClass: [protected] String
			//		The root className to use for the various states of this widget
			baseClass: "dijitTooltipDialog",

			// _firstFocusItem: [private readonly] DomNode
			//		The pointer to the first focusable node in the dialog.
			//		Set by `dijit/_DialogMixin._getFocusItems()`.
			_firstFocusItem: null,

			// _lastFocusItem: [private readonly] DomNode
			//		The pointer to which node has focus prior to our dialog.
			//		Set by `dijit/_DialogMixin._getFocusItems()`.
			_lastFocusItem: null,

			templateString: template,

			_setTitleAttr: "containerNode",

			postCreate: function(){
				this.inherited(arguments);
				this.own(on(this.domNode, "keydown", lang.hitch(this, "_onKey")));
			},

			orient: function(/*DomNode*/ node, /*String*/ aroundCorner, /*String*/ tooltipCorner){
				// summary:
				//		Configure widget to be displayed in given position relative to the button.
				//		This is called from the dijit.popup code, and should not be called
				//		directly.
				// tags:
				//		protected

				// Note: intentionally not using dijitTooltip class since that sets position:absolute, which
				// confuses dijit/popup trying to get the size of the tooltip.
				var newC = {
					// Real around node
					"MR-ML": "dijitTooltipRight",
					"ML-MR": "dijitTooltipLeft",
					"TM-BM": "dijitTooltipAbove",
					"BM-TM": "dijitTooltipBelow",
					"BL-TL": "dijitTooltipBelow dijitTooltipABLeft",
					"TL-BL": "dijitTooltipAbove dijitTooltipABLeft",
					"BR-TR": "dijitTooltipBelow dijitTooltipABRight",
					"TR-BR": "dijitTooltipAbove dijitTooltipABRight",
					"BR-BL": "dijitTooltipRight",
					"BL-BR": "dijitTooltipLeft",

					// Positioning "around" a point, ex: mouse position
					"BR-TL": "dijitTooltipBelow dijitTooltipABLeft",
					"BL-TR": "dijitTooltipBelow dijitTooltipABRight",
					"TL-BR": "dijitTooltipAbove dijitTooltipABRight",
					"TR-BL": "dijitTooltipAbove dijitTooltipABLeft"
				}[aroundCorner + "-" + tooltipCorner];

				domClass.replace(this.domNode, newC, this._currentOrientClass || "");
				this._currentOrientClass = newC;

				// Tooltip.orient() has code to reposition connector for when Tooltip is before/after anchor.
				// Not putting here to avoid code bloat, and since TooltipDialogs are generally above/below.
				// Should combine code from Tooltip and TooltipDialog.
			},

			focus: function(){
				// summary:
				//		Focus on first field
				this._getFocusItems();
				focus.focus(this._firstFocusItem);
			},

			onOpen: function(/*Object*/ pos){
				// summary:
				//		Called when dialog is displayed.
				//		This is called from the dijit.popup code, and should not be called directly.
				// tags:
				//		protected

				this.orient(this.domNode, pos.aroundCorner, pos.corner);

				// Position the tooltip connector for middle alignment.
				// This could not have been done in orient() since the tooltip wasn't positioned at that time.
				var aroundNodeCoords = pos.aroundNodePos;
				if(pos.corner.charAt(0) == 'M' && pos.aroundCorner.charAt(0) == 'M'){
					this.connectorNode.style.top = aroundNodeCoords.y + ((aroundNodeCoords.h - this.connectorNode.offsetHeight) >> 1) - pos.y + "px";
					this.connectorNode.style.left = "";
				}else if(pos.corner.charAt(1) == 'M' && pos.aroundCorner.charAt(1) == 'M'){
					this.connectorNode.style.left = aroundNodeCoords.x + ((aroundNodeCoords.w - this.connectorNode.offsetWidth) >> 1) - pos.x + "px";
				}

				this._onShow(); // lazy load trigger  (TODO: shouldn't we load before positioning?)
			},

			onClose: function(){
				// summary:
				//		Called when dialog is hidden.
				//		This is called from the dijit.popup code, and should not be called directly.
				// tags:
				//		protected
				this.onHide();
			},

			_onKey: function(/*Event*/ evt){
				// summary:
				//		Handler for keydown events
				// description:
				//		Keep keyboard focus in dialog; close dialog on escape key
				// tags:
				//		private

				if(evt.keyCode == keys.ESCAPE){
					// Use defer to avoid crash on IE, see #10396.  Not sure if this is still needed or not.
					// If this if() wasn't here, presumably dijit/popup would catch the ESCAPE key and close the popup.
					this.defer("onCancel");
					evt.stopPropagation();
					evt.preventDefault();
				}else if(evt.keyCode == keys.TAB){
					var node = evt.target;
					this._getFocusItems();
					if(this._firstFocusItem == this._lastFocusItem){
						evt.stopPropagation();
						evt.preventDefault();
					}else if(node == this._firstFocusItem && evt.shiftKey){
						focus.focus(this._lastFocusItem); // send focus to last item in dialog
						evt.stopPropagation();
						evt.preventDefault();
					}else if(node == this._lastFocusItem && !evt.shiftKey){
						focus.focus(this._firstFocusItem); // send focus to first item in dialog
						evt.stopPropagation();
						evt.preventDefault();
					}else{
						// we want the browser's default tab handling to move focus
						// but we don't want the tab to propagate upwards
						evt.stopPropagation();
					}
				}
			}
		});

	if(has("dojo-bidi")){
		TooltipDialog.extend({
			_setTitleAttr: function(/*String*/ title){
				this.containerNode.title = (this.textDir && this.enforceTextDirWithUcc) ? this.enforceTextDirWithUcc(null, title) : title;
				this._set("title", title);
			},

			_setTextDirAttr: function(/*String*/ textDir){
				if(!this._created || this.textDir != textDir){
					this._set("textDir", textDir);
					if(this.textDir && this.title){
						this.containerNode.title = this.enforceTextDirWithUcc(null, this.title);
					}
				}
			}
		});
	}

	return TooltipDialog;
});

},
'dijit/layout/ContentPane':function(){
define([
	"dojo/_base/kernel", // kernel.deprecated
	"dojo/_base/lang", // lang.mixin lang.delegate lang.hitch lang.isFunction lang.isObject
	"../_Widget",
	"../_Container",
	"./_ContentPaneResizeMixin",
	"dojo/string", // string.substitute
	"dojo/html", // html._ContentSetter
	"dojo/_base/array", // array.forEach
	"dojo/_base/declare", // declare
	"dojo/_base/Deferred", // Deferred
	"dojo/dom", // dom.byId
	"dojo/dom-attr", // domAttr.attr
	"dojo/dom-construct", // empty()
	"dojo/_base/xhr", // xhr.get
	"dojo/i18n", // i18n.getLocalization
	"dojo/when",
	"dojo/i18n!../nls/loading"
], function(kernel, lang, _Widget, _Container, _ContentPaneResizeMixin, string, html, array, declare,
			Deferred, dom, domAttr, domConstruct, xhr, i18n, when){

	// module:
	//		dijit/layout/ContentPane

	return declare("dijit.layout.ContentPane", [_Widget, _Container, _ContentPaneResizeMixin], {
		// summary:
		//		A widget containing an HTML fragment, specified inline
		//		or by uri.  Fragment may include widgets.
		//
		// description:
		//		This widget embeds a document fragment in the page, specified
		//		either by uri, javascript generated markup or DOM reference.
		//		Any widgets within this content are instantiated and managed,
		//		but laid out according to the HTML structure.  Unlike IFRAME,
		//		ContentPane embeds a document fragment as would be found
		//		inside the BODY tag of a full HTML document.  It should not
		//		contain the HTML, HEAD, or BODY tags.
		//		For more advanced functionality with scripts and
		//		stylesheets, see dojox/layout/ContentPane.  This widget may be
		//		used stand alone or as a base class for other widgets.
		//		ContentPane is useful as a child of other layout containers
		//		such as BorderContainer or TabContainer, but note that those
		//		widgets can contain any widget as a child.
		//
		// example:
		//		Some quick samples:
		//		To change the innerHTML:
		// |		cp.set('content', '<b>new content</b>')`
		//		Or you can send it a NodeList:
		// |		cp.set('content', dojo.query('div [class=selected]', userSelection))
		//		To do an ajax update:
		// |		cp.set('href', url)

		// href: String
		//		The href of the content that displays now.
		//		Set this at construction if you want to load data externally when the
		//		pane is shown.  (Set preload=true to load it immediately.)
		//		Changing href after creation doesn't have any effect; Use set('href', ...);
		href: "",

		// content: String|DomNode|NodeList|dijit/_Widget
		//		The innerHTML of the ContentPane.
		//		Note that the initialization parameter / argument to set("content", ...)
		//		can be a String, DomNode, Nodelist, or _Widget.
		content: "",

		// extractContent: Boolean
		//		Extract visible content from inside of `<body> .... </body>`.
		//		I.e., strip `<html>` and `<head>` (and it's contents) from the href
		extractContent: false,

		// parseOnLoad: Boolean
		//		Parse content and create the widgets, if any.
		parseOnLoad: true,

		// parserScope: String
		//		Flag passed to parser.  Root for attribute names to search for.   If scopeName is dojo,
		//		will search for data-dojo-type (or dojoType).  For backwards compatibility
		//		reasons defaults to dojo._scopeName (which is "dojo" except when
		//		multi-version support is used, when it will be something like dojo16, dojo20, etc.)
		parserScope: kernel._scopeName,

		// preventCache: Boolean
		//		Prevent caching of data from href's by appending a timestamp to the href.
		preventCache: false,

		// preload: Boolean
		//		Force load of data on initialization even if pane is hidden.
		preload: false,

		// refreshOnShow: Boolean
		//		Refresh (re-download) content when pane goes from hidden to shown
		refreshOnShow: false,

		// loadingMessage: String
		//		Message that shows while downloading
		loadingMessage: "<span class='dijitContentPaneLoading'><span class='dijitInline dijitIconLoading'></span>${loadingState}</span>",

		// errorMessage: String
		//		Message that shows if an error occurs
		errorMessage: "<span class='dijitContentPaneError'><span class='dijitInline dijitIconError'></span>${errorState}</span>",

		// isLoaded: [readonly] Boolean
		//		True if the ContentPane has data in it, either specified
		//		during initialization (via href or inline content), or set
		//		via set('content', ...) / set('href', ...)
		//
		//		False if it doesn't have any content, or if ContentPane is
		//		still in the process of downloading href.
		isLoaded: false,

		baseClass: "dijitContentPane",

		/*======
		 // ioMethod: dojo/_base/xhr.get|dojo._base/xhr.post
		 //		Function that should grab the content specified via href.
		 ioMethod: dojo.xhrGet,
		 ======*/

		// ioArgs: Object
		//		Parameters to pass to xhrGet() request, for example:
		// |	<div data-dojo-type="dijit/layout/ContentPane" data-dojo-props="href: './bar', ioArgs: {timeout: 500}">
		ioArgs: {},

		// onLoadDeferred: [readonly] dojo.Deferred
		//		This is the `dojo.Deferred` returned by set('href', ...) and refresh().
		//		Calling onLoadDeferred.then() registers your
		//		callback to be called only once, when the prior set('href', ...) call or
		//		the initial href parameter to the constructor finishes loading.
		//
		//		This is different than an onLoad() handler which gets called any time any href
		//		or content is loaded.
		onLoadDeferred: null,

		// Cancel _WidgetBase's _setTitleAttr because we don't want the title attribute (used to specify
		// tab labels) to be copied to ContentPane.domNode... otherwise a tooltip shows up over the
		// entire pane.
		_setTitleAttr: null,

		// Flag to parser that I'll parse my contents, so it shouldn't.
		stopParser: true,

		// template: [private] Boolean
		//		Flag from the parser that this ContentPane is inside a template
		//		so the contents are pre-parsed.
		// TODO: this declaration can be commented out in 2.0
		template: false,

		markupFactory: function(params, node, ctor){
			var self = new ctor(params, node);

			// If a parse has started but is waiting for modules to load, then return a Promise for when the parser
			// finishes.  Don't return a promise though for the case when content hasn't started loading because the
			// ContentPane is hidden and it has an href (ex: hidden pane of a TabContainer).   In that case we consider
			// that initialization has already finished.
			return !self.href && self._contentSetter && self._contentSetter.parseDeferred && !self._contentSetter.parseDeferred.isFulfilled() ?
				self._contentSetter.parseDeferred.then(function(){
					return self;
				}) : self;
		},

		create: function(params, srcNodeRef){
			// Convert a srcNodeRef argument into a content parameter, so that the original contents are
			// processed in the same way as contents set via set("content", ...), calling the parser etc.
			// Avoid modifying original params object since that breaks NodeList instantiation, see #11906.
			if((!params || !params.template) && srcNodeRef && !("href" in params) && !("content" in params)){
				srcNodeRef = dom.byId(srcNodeRef);
				var df = srcNodeRef.ownerDocument.createDocumentFragment();
				while(srcNodeRef.firstChild){
					df.appendChild(srcNodeRef.firstChild);
				}
				params = lang.delegate(params, {content: df});
			}
			this.inherited(arguments, [params, srcNodeRef]);
		},

		postMixInProperties: function(){
			this.inherited(arguments);
			var messages = i18n.getLocalization("dijit", "loading", this.lang);
			this.loadingMessage = string.substitute(this.loadingMessage, messages);
			this.errorMessage = string.substitute(this.errorMessage, messages);
		},

		buildRendering: function(){
			this.inherited(arguments);

			// Since we have no template we need to set this.containerNode ourselves, to make getChildren() work.
			// For subclasses of ContentPane that do have a template, does nothing.
			if(!this.containerNode){
				this.containerNode = this.domNode;
			}

			// remove the title attribute so it doesn't show up when hovering
			// over a node  (TODO: remove in 2.0, no longer needed after #11490)
			this.domNode.removeAttribute("title");
		},

		startup: function(){
			// summary:
			//		Call startup() on all children including non _Widget ones like dojo/dnd/Source objects

			// This starts all the widgets
			this.inherited(arguments);

			// And this catches stuff like dojo/dnd/Source
			if(this._contentSetter){
				array.forEach(this._contentSetter.parseResults, function(obj){
					if(!obj._started && !obj._destroyed && lang.isFunction(obj.startup)){
						obj.startup();
						obj._started = true;
					}
				}, this);
			}
		},

		_startChildren: function(){
			// summary:
			//		Called when content is loaded.   Calls startup on each child widget.   Similar to ContentPane.startup()
			//		itself, but avoids marking the ContentPane itself as "restarted" (see #15581).

			// This starts all the widgets
			array.forEach(this.getChildren(), function(obj){
				if(!obj._started && !obj._destroyed && lang.isFunction(obj.startup)){
					obj.startup();
					obj._started = true;
				}
			});

			// And this catches stuff like dojo/dnd/Source
			if(this._contentSetter){
				array.forEach(this._contentSetter.parseResults, function(obj){
					if(!obj._started && !obj._destroyed && lang.isFunction(obj.startup)){
						obj.startup();
						obj._started = true;
					}
				}, this);
			}
		},

		setHref: function(/*String|Uri*/ href){
			// summary:
			//		Deprecated.   Use set('href', ...) instead.
			kernel.deprecated("dijit.layout.ContentPane.setHref() is deprecated. Use set('href', ...) instead.", "", "2.0");
			return this.set("href", href);
		},
		_setHrefAttr: function(/*String|Uri*/ href){
			// summary:
			//		Hook so set("href", ...) works.
			// description:
			//		Reset the (external defined) content of this pane and replace with new url
			//		Note: It delays the download until widget is shown if preload is false.
			// href:
			//		url to the page you want to get, must be within the same domain as your mainpage

			// Cancel any in-flight requests (a set('href', ...) will cancel any in-flight set('href', ...))
			this.cancel();

			this.onLoadDeferred = new Deferred(lang.hitch(this, "cancel"));
			this.onLoadDeferred.then(lang.hitch(this, "onLoad"));

			this._set("href", href);

			// _setHrefAttr() is called during creation and by the user, after creation.
			// Assuming preload == false, only in the second case do we actually load the URL;
			// otherwise it's done in startup(), and only if this widget is shown.
			if(this.preload || (this._created && this._isShown())){
				this._load();
			}else{
				// Set flag to indicate that href needs to be loaded the next time the
				// ContentPane is made visible
				this._hrefChanged = true;
			}

			return this.onLoadDeferred;		// Deferred
		},

		setContent: function(/*String|DomNode|Nodelist*/data){
			// summary:
			//		Deprecated.   Use set('content', ...) instead.
			kernel.deprecated("dijit.layout.ContentPane.setContent() is deprecated.  Use set('content', ...) instead.", "", "2.0");
			this.set("content", data);
		},
		_setContentAttr: function(/*String|DomNode|Nodelist*/data){
			// summary:
			//		Hook to make set("content", ...) work.
			//		Replaces old content with data content, include style classes from old content
			// data:
			//		the new Content may be String, DomNode or NodeList
			//
			//		if data is a NodeList (or an array of nodes) nodes are copied
			//		so you can import nodes from another document implicitly

			// clear href so we can't run refresh and clear content
			// refresh should only work if we downloaded the content
			this._set("href", "");

			// Cancel any in-flight requests (a set('content', ...) will cancel any in-flight set('href', ...))
			this.cancel();

			// Even though user is just setting content directly, still need to define an onLoadDeferred
			// because the _onLoadHandler() handler is still getting called from setContent()
			this.onLoadDeferred = new Deferred(lang.hitch(this, "cancel"));
			if(this._created){
				// For back-compat reasons, call onLoad() for set('content', ...)
				// calls but not for content specified in srcNodeRef (ie: <div data-dojo-type=ContentPane>...</div>)
				// or as initialization parameter (ie: new ContentPane({content: ...})
				this.onLoadDeferred.then(lang.hitch(this, "onLoad"));
			}

			this._setContent(data || "");

			this._isDownloaded = false; // mark that content is from a set('content') not a set('href')

			return this.onLoadDeferred;	// Deferred
		},
		_getContentAttr: function(){
			// summary:
			//		Hook to make get("content") work
			return this.containerNode.innerHTML;
		},

		cancel: function(){
			// summary:
			//		Cancels an in-flight download of content
			if(this._xhrDfd && (this._xhrDfd.fired == -1)){
				this._xhrDfd.cancel();
			}
			delete this._xhrDfd; // garbage collect

			this.onLoadDeferred = null;
		},

		destroy: function(){
			this.cancel();
			this.inherited(arguments);
		},

		destroyRecursive: function(/*Boolean*/ preserveDom){
			// summary:
			//		Destroy the ContentPane and its contents

			// if we have multiple controllers destroying us, bail after the first
			if(this._beingDestroyed){
				return;
			}
			this.inherited(arguments);
		},

		_onShow: function(){
			// summary:
			//		Called when the ContentPane is made visible
			// description:
			//		For a plain ContentPane, this is called on initialization, from startup().
			//		If the ContentPane is a hidden pane of a TabContainer etc., then it's
			//		called whenever the pane is made visible.
			//
			//		Does necessary processing, including href download and layout/resize of
			//		child widget(s)

			this.inherited(arguments);

			if(this.href){
				if(!this._xhrDfd && // if there's an href that isn't already being loaded
					(!this.isLoaded || this._hrefChanged || this.refreshOnShow)
					){
					return this.refresh();	// If child has an href, promise that fires when the load is complete
				}
			}
		},

		refresh: function(){
			// summary:
			//		[Re]download contents of href and display
			// description:
			//		1. cancels any currently in-flight requests
			//		2. posts "loading..." message
			//		3. sends XHR to download new data

			// Cancel possible prior in-flight request
			this.cancel();

			this.onLoadDeferred = new Deferred(lang.hitch(this, "cancel"));
			this.onLoadDeferred.then(lang.hitch(this, "onLoad"));
			this._load();
			return this.onLoadDeferred;		// If child has an href, promise that fires when refresh is complete
		},

		_load: function(){
			// summary:
			//		Load/reload the href specified in this.href

			// display loading message
			this._setContent(this.onDownloadStart(), true);

			var self = this;
			var getArgs = {
				preventCache: (this.preventCache || this.refreshOnShow),
				url: this.href,
				handleAs: "text"
			};
			if(lang.isObject(this.ioArgs)){
				lang.mixin(getArgs, this.ioArgs);
			}

			var hand = (this._xhrDfd = (this.ioMethod || xhr.get)(getArgs)),
				returnedHtml;

			hand.then(
				function(html){
					returnedHtml = html;
					try{
						self._isDownloaded = true;
						return self._setContent(html, false);
					}catch(err){
						self._onError('Content', err); // onContentError
					}
				},
				function(err){
					if(!hand.canceled){
						// show error message in the pane
						self._onError('Download', err); // onDownloadError
					}
					delete self._xhrDfd;
					return err;
				}
			).then(function(){
					self.onDownloadEnd();
					delete self._xhrDfd;
					return returnedHtml;
				});

			// Remove flag saying that a load is needed
			delete this._hrefChanged;
		},

		_onLoadHandler: function(data){
			// summary:
			//		This is called whenever new content is being loaded
			this._set("isLoaded", true);
			try{
				this.onLoadDeferred.resolve(data);
			}catch(e){
				console.error('Error ' + (this.widgetId || this.id) + ' running custom onLoad code: ' + e.message);
			}
		},

		_onUnloadHandler: function(){
			// summary:
			//		This is called whenever the content is being unloaded
			this._set("isLoaded", false);
			try{
				this.onUnload();
			}catch(e){
				console.error('Error ' + this.widgetId + ' running custom onUnload code: ' + e.message);
			}
		},

		destroyDescendants: function(/*Boolean*/ preserveDom){
			// summary:
			//		Destroy all the widgets inside the ContentPane and empty containerNode

			// Make sure we call onUnload (but only when the ContentPane has real content)
			if(this.isLoaded){
				this._onUnloadHandler();
			}

			// Even if this.isLoaded == false there might still be a "Loading..." message
			// to erase, so continue...

			// For historical reasons we need to delete all widgets under this.containerNode,
			// even ones that the user has created manually.
			var setter = this._contentSetter;
			array.forEach(this.getChildren(), function(widget){
				if(widget.destroyRecursive){
					// All widgets will hit this branch
					widget.destroyRecursive(preserveDom);
				}else if(widget.destroy){
					// Things like dojo/dnd/Source have destroy(), not destroyRecursive()
					widget.destroy(preserveDom);
				}
				widget._destroyed = true;
			});
			if(setter){
				// Most of the widgets in setter.parseResults have already been destroyed, but
				// things like Menu that have been moved to <body> haven't yet
				array.forEach(setter.parseResults, function(widget){
					if(!widget._destroyed){
						if(widget.destroyRecursive){
							// All widgets will hit this branch
							widget.destroyRecursive(preserveDom);
						}else if(widget.destroy){
							// Things like dojo/dnd/Source have destroy(), not destroyRecursive()
							widget.destroy(preserveDom);
						}
						widget._destroyed = true;
					}
				});
				delete setter.parseResults;
			}

			// And then clear away all the DOM nodes
			if(!preserveDom){
				domConstruct.empty(this.containerNode);
			}

			// Delete any state information we have about current contents
			delete this._singleChild;
		},

		_setContent: function(/*String|DocumentFragment*/ cont, /*Boolean*/ isFakeContent){
			// summary:
			//		Insert the content into the container node
			// returns:
			//		Returns a Deferred promise that is resolved when the content is parsed.

			cont = this.preprocessContent(cont);
			// first get rid of child widgets
			this.destroyDescendants();

			// html.set will take care of the rest of the details
			// we provide an override for the error handling to ensure the widget gets the errors
			// configure the setter instance with only the relevant widget instance properties
			// NOTE: unless we hook into attr, or provide property setters for each property,
			// we need to re-configure the ContentSetter with each use
			var setter = this._contentSetter;
			if(!(setter && setter instanceof html._ContentSetter)){
				setter = this._contentSetter = new html._ContentSetter({
					node: this.containerNode,
					_onError: lang.hitch(this, this._onError),
					onContentError: lang.hitch(this, function(e){
						// fires if a domfault occurs when we are appending this.errorMessage
						// like for instance if domNode is a UL and we try append a DIV
						var errMess = this.onContentError(e);
						try{
							this.containerNode.innerHTML = errMess;
						}catch(e){
							console.error('Fatal ' + this.id + ' could not change content due to ' + e.message, e);
						}
					})/*,
					 _onError */
				});
			}

			var setterParams = lang.mixin({
				cleanContent: this.cleanContent,
				extractContent: this.extractContent,
				parseContent: !cont.domNode && this.parseOnLoad,
				parserScope: this.parserScope,
				startup: false,
				dir: this.dir,
				lang: this.lang,
				textDir: this.textDir
			}, this._contentSetterParams || {});

			var p = setter.set((lang.isObject(cont) && cont.domNode) ? cont.domNode : cont, setterParams);

			// dojox/layout/html/_base::_ContentSetter.set() returns a Promise that indicates when everything is completed.
			// dojo/html::_ContentSetter.set() currently returns the DOMNode, but that will be changed for 2.0.
			// So, if set() returns a promise then use it, otherwise fallback to waiting on setter.parseDeferred
			var self = this;
			return when(p && p.then ? p : setter.parseDeferred, function(){
				// setter params must be pulled afresh from the ContentPane each time
				delete self._contentSetterParams;

				if(!isFakeContent){
					if(self._started){
						// Startup each top level child widget (and they will start their children, recursively)
						self._startChildren();

						// Call resize() on each of my child layout widgets,
						// or resize() on my single child layout widget...
						// either now (if I'm currently visible) or when I become visible
						self._scheduleLayout();
					}
					self._onLoadHandler(cont);
				}
			});
		},

		preprocessContent: function(/*String|DocumentFragment*/ content){
			// summary:
			//		Hook, called after content has loaded, before being processed.
			// description:
			//		A subclass should preprocess the content and return the preprocessed content.
			//		See https://bugs.dojotoolkit.org/ticket/9622
			// returns:
			//		Returns preprocessed content, either a String or DocumentFragment
			return content;
		},

		_onError: function(type, err, consoleText){
			this.onLoadDeferred.reject(err);

			// shows user the string that is returned by on[type]Error
			// override on[type]Error and return your own string to customize
			var errText = this['on' + type + 'Error'].call(this, err);
			if(consoleText){
				console.error(consoleText, err);
			}else if(errText){// a empty string won't change current content
				this._setContent(errText, true);
			}
		},

		// EVENT's, should be overide-able
		onLoad: function(/*===== data =====*/){
			// summary:
			//		Event hook, is called after everything is loaded and widgetified
			// tags:
			//		callback
		},

		onUnload: function(){
			// summary:
			//		Event hook, is called before old content is cleared
			// tags:
			//		callback
		},

		onDownloadStart: function(){
			// summary:
			//		Called before download starts.
			// description:
			//		The string returned by this function will be the html
			//		that tells the user we are loading something.
			//		Override with your own function if you want to change text.
			// tags:
			//		extension
			return this.loadingMessage;
		},

		onContentError: function(/*Error*/ /*===== error =====*/){
			// summary:
			//		Called on DOM faults, require faults etc. in content.
			//
			//		In order to display an error message in the pane, return
			//		the error message from this method, as an HTML string.
			//
			//		By default (if this method is not overriden), it returns
			//		nothing, so the error message is just printed to the console.
			// tags:
			//		extension
		},

		onDownloadError: function(/*Error*/ /*===== error =====*/){
			// summary:
			//		Called when download error occurs.
			//
			//		In order to display an error message in the pane, return
			//		the error message from this method, as an HTML string.
			//
			//		Default behavior (if this method is not overriden) is to display
			//		the error message inside the pane.
			// tags:
			//		extension
			return this.errorMessage;
		},

		onDownloadEnd: function(){
			// summary:
			//		Called when download is finished.
			// tags:
			//		callback
		}
	});
});

},
'dijit/_Widget':function(){
define([
	"dojo/aspect",	// aspect.around
	"dojo/_base/config",	// config.isDebug
	"dojo/_base/connect",	// connect.connect
	"dojo/_base/declare", // declare
	"dojo/has",
	"dojo/_base/kernel", // kernel.deprecated
	"dojo/_base/lang", // lang.hitch
	"dojo/query",
	"dojo/ready",
	"./registry",	// registry.byNode
	"./_WidgetBase",
	"./_OnDijitClickMixin",
	"./_FocusMixin",
	"dojo/uacss",		// browser sniffing (included for back-compat; subclasses may be using)
	"./hccss"		// high contrast mode sniffing (included to set CSS classes on <body>, module ret value unused)
], function(aspect, config, connect, declare, has, kernel, lang, query, ready,
			registry, _WidgetBase, _OnDijitClickMixin, _FocusMixin){


// module:
//		dijit/_Widget


function connectToDomNode(){
	// summary:
	//		If user connects to a widget method === this function, then they will
	//		instead actually be connecting the equivalent event on this.domNode
}

// Trap dojo.connect() calls to connectToDomNode methods, and redirect to _Widget.on()
function aroundAdvice(originalConnect){
	return function(obj, event, scope, method){
		if(obj && typeof event == "string" && obj[event] == connectToDomNode){
			return obj.on(event.substring(2).toLowerCase(), lang.hitch(scope, method));
		}
		return originalConnect.apply(connect, arguments);
	};
}
aspect.around(connect, "connect", aroundAdvice);
if(kernel.connect){
	aspect.around(kernel, "connect", aroundAdvice);
}

var _Widget = declare("dijit._Widget", [_WidgetBase, _OnDijitClickMixin, _FocusMixin], {
	// summary:
	//		Old base class for widgets.   New widgets should extend `dijit/_WidgetBase` instead
	// description:
	//		Old Base class for Dijit widgets.
	//
	//		Extends _WidgetBase, adding support for:
	//
	//		- declaratively/programatically specifying widget initialization parameters like
	//			onMouseMove="foo" that call foo when this.domNode gets a mousemove event
	//		- ondijitclick:
	//			Support new data-dojo-attach-event="ondijitclick: ..." that is triggered by a mouse click or a SPACE/ENTER keypress
	//		- focus related functions:
	//			In particular, the onFocus()/onBlur() callbacks.   Driven internally by
	//			dijit/_base/focus.js.
	//		- deprecated methods
	//		- onShow(), onHide(), onClose()
	//
	//		Also, by loading code in dijit/_base, turns on:
	//
	//		- browser sniffing (putting browser class like `dj_ie` on `<html>` node)
	//		- high contrast mode sniffing (add `dijit_a11y` class to `<body>` if machine is in high contrast mode)


	////////////////// DEFERRED CONNECTS ///////////////////

	onClick: connectToDomNode,
	/*=====
	onClick: function(event){
		// summary:
		//		Connect to this function to receive notifications of mouse click events.
		// event:
		//		mouse Event
		// tags:
		//		callback
	},
	=====*/
	onDblClick: connectToDomNode,
	/*=====
	onDblClick: function(event){
		// summary:
		//		Connect to this function to receive notifications of mouse double click events.
		// event:
		//		mouse Event
		// tags:
		//		callback
	},
	=====*/
	onKeyDown: connectToDomNode,
	/*=====
	onKeyDown: function(event){
		// summary:
		//		Connect to this function to receive notifications of keys being pressed down.
		// event:
		//		key Event
		// tags:
		//		callback
	},
	=====*/
	onKeyPress: connectToDomNode,
	/*=====
	onKeyPress: function(event){
		// summary:
		//		Connect to this function to receive notifications of printable keys being typed.
		// event:
		//		key Event
		// tags:
		//		callback
	},
	=====*/
	onKeyUp: connectToDomNode,
	/*=====
	onKeyUp: function(event){
		// summary:
		//		Connect to this function to receive notifications of keys being released.
		// event:
		//		key Event
		// tags:
		//		callback
	},
	=====*/
	onMouseDown: connectToDomNode,
	/*=====
	onMouseDown: function(event){
		// summary:
		//		Connect to this function to receive notifications of when the mouse button is pressed down.
		// event:
		//		mouse Event
		// tags:
		//		callback
	},
	=====*/
	onMouseMove: connectToDomNode,
	/*=====
	onMouseMove: function(event){
		// summary:
		//		Connect to this function to receive notifications of when the mouse moves over nodes contained within this widget.
		// event:
		//		mouse Event
		// tags:
		//		callback
	},
	=====*/
	onMouseOut: connectToDomNode,
	/*=====
	onMouseOut: function(event){
		// summary:
		//		Connect to this function to receive notifications of when the mouse moves off of nodes contained within this widget.
		// event:
		//		mouse Event
		// tags:
		//		callback
	},
	=====*/
	onMouseOver: connectToDomNode,
	/*=====
	onMouseOver: function(event){
		// summary:
		//		Connect to this function to receive notifications of when the mouse moves onto nodes contained within this widget.
		// event:
		//		mouse Event
		// tags:
		//		callback
	},
	=====*/
	onMouseLeave: connectToDomNode,
	/*=====
	onMouseLeave: function(event){
		// summary:
		//		Connect to this function to receive notifications of when the mouse moves off of this widget.
		// event:
		//		mouse Event
		// tags:
		//		callback
	},
	=====*/
	onMouseEnter: connectToDomNode,
	/*=====
	onMouseEnter: function(event){
		// summary:
		//		Connect to this function to receive notifications of when the mouse moves onto this widget.
		// event:
		//		mouse Event
		// tags:
		//		callback
	},
	=====*/
	onMouseUp: connectToDomNode,
	/*=====
	onMouseUp: function(event){
		// summary:
		//		Connect to this function to receive notifications of when the mouse button is released.
		// event:
		//		mouse Event
		// tags:
		//		callback
	},
	=====*/

	constructor: function(params /*===== ,srcNodeRef =====*/){
		// summary:
		//		Create the widget.
		// params: Object|null
		//		Hash of initialization parameters for widget, including scalar values (like title, duration etc.)
		//		and functions, typically callbacks like onClick.
		//		The hash can contain any of the widget's properties, excluding read-only properties.
		// srcNodeRef: DOMNode|String?
		//		If a srcNodeRef (DOM node) is specified:
		//
		//		- use srcNodeRef.innerHTML as my contents
		//		- if this is a behavioral widget then apply behavior to that srcNodeRef
		//		- otherwise, replace srcNodeRef with my generated DOM tree

		// extract parameters like onMouseMove that should connect directly to this.domNode
		this._toConnect = {};
		for(var name in params){
			if(this[name] === connectToDomNode){
				this._toConnect[name.replace(/^on/, "").toLowerCase()] = params[name];
				delete params[name];
			}
		}
	},

	postCreate: function(){
		this.inherited(arguments);

		// perform connection from this.domNode to user specified handlers (ex: onMouseMove)
		for(var name in this._toConnect){
			this.on(name, this._toConnect[name]);
		}
		delete this._toConnect;
	},

	on: function(/*String|Function*/ type, /*Function*/ func){
		if(this[this._onMap(type)] === connectToDomNode){
			// Use connect.connect() rather than on() to get handling for "onmouseenter" on non-IE,
			// normalization of onkeypress/onkeydown to behave like firefox, etc.
			// Also, need to specify context as "this" rather than the default context of the DOMNode
			// Remove in 2.0.
			return connect.connect(this.domNode, type.toLowerCase(), this, func);
		}
		return this.inherited(arguments);
	},

	_setFocusedAttr: function(val){
		// Remove this method in 2.0 (or sooner), just here to set _focused == focused, for back compat
		// (but since it's a private variable we aren't required to keep supporting it).
		this._focused = val;
		this._set("focused", val);
	},

	////////////////// DEPRECATED METHODS ///////////////////

	setAttribute: function(/*String*/ attr, /*anything*/ value){
		// summary:
		//		Deprecated.  Use set() instead.
		// tags:
		//		deprecated
		kernel.deprecated(this.declaredClass+"::setAttribute(attr, value) is deprecated. Use set() instead.", "", "2.0");
		this.set(attr, value);
	},

	attr: function(/*String|Object*/name, /*Object?*/value){
		// summary:
		//		This method is deprecated, use get() or set() directly.
		// name:
		//		The property to get or set. If an object is passed here and not
		//		a string, its keys are used as names of attributes to be set
		//		and the value of the object as values to set in the widget.
		// value:
		//		Optional. If provided, attr() operates as a setter. If omitted,
		//		the current value of the named property is returned.
		// tags:
		//		deprecated

		var args = arguments.length;
		if(args >= 2 || typeof name === "object"){ // setter
			return this.set.apply(this, arguments);
		}else{ // getter
			return this.get(name);
		}
	},

	getDescendants: function(){
		// summary:
		//		Returns all the widgets contained by this, i.e., all widgets underneath this.containerNode.
		//		This method should generally be avoided as it returns widgets declared in templates, which are
		//		supposed to be internal/hidden, but it's left here for back-compat reasons.

		kernel.deprecated(this.declaredClass+"::getDescendants() is deprecated. Use getChildren() instead.", "", "2.0");
		return this.containerNode ? query('[widgetId]', this.containerNode).map(registry.byNode) : []; // dijit/_WidgetBase[]
	},

	////////////////// MISCELLANEOUS METHODS ///////////////////

	_onShow: function(){
		// summary:
		//		Internal method called when this widget is made visible.
		//		See `onShow` for details.
		this.onShow();
	},

	onShow: function(){
		// summary:
		//		Called when this widget becomes the selected pane in a
		//		`dijit/layout/TabContainer`, `dijit/layout/StackContainer`,
		//		`dijit/layout/AccordionContainer`, etc.
		//
		//		Also called to indicate display of a `dijit.Dialog`, `dijit.TooltipDialog`, or `dijit.TitlePane`.
		// tags:
		//		callback
	},

	onHide: function(){
		// summary:
		//		Called when another widget becomes the selected pane in a
		//		`dijit/layout/TabContainer`, `dijit/layout/StackContainer`,
		//		`dijit/layout/AccordionContainer`, etc.
		//
		//		Also called to indicate hide of a `dijit.Dialog`, `dijit.TooltipDialog`, or `dijit.TitlePane`.
		// tags:
		//		callback
	},

	onClose: function(){
		// summary:
		//		Called when this widget is being displayed as a popup (ex: a Calendar popped
		//		up from a DateTextBox), and it is hidden.
		//		This is called from the dijit.popup code, and should not be called directly.
		//
		//		Also used as a parameter for children of `dijit/layout/StackContainer` or subclasses.
		//		Callback if a user tries to close the child.   Child will be closed if this function returns true.
		// tags:
		//		extension

		return true;		// Boolean
	}
});

// For back-compat, remove in 2.0.
if(has("dijit-legacy-requires")){
	ready(0, function(){
		var requires = ["dijit/_base"];
		require(requires);	// use indirection so modules not rolled into a build
	});
}
return _Widget;
});

},
'dijit/_OnDijitClickMixin':function(){
define([
	"dojo/on",
	"dojo/_base/array", // array.forEach
	"dojo/keys", // keys.ENTER keys.SPACE
	"dojo/_base/declare", // declare
	"dojo/has", // has("dom-addeventlistener")
	"./a11yclick"
], function(on, array, keys, declare, has, a11yclick){

	// module:
	//		dijit/_OnDijitClickMixin

	var ret = declare("dijit._OnDijitClickMixin", null, {
		// summary:
		//		Deprecated.   New code should access the dijit/a11yclick event directly, ex:
		//		|	this.own(on(node, a11yclick, function(){ ... }));
		//
		//		Mixing in this class will make _WidgetBase.connect(node, "ondijitclick", ...) work.
		//		It also used to be necessary to make templates with ondijitclick work, but now you can just require
		//		dijit/a11yclick.

		connect: function(obj, event, method){
			// override _WidgetBase.connect() to make this.connect(node, "ondijitclick", ...) work
			return this.inherited(arguments, [obj, event == "ondijitclick" ? a11yclick : event, method]);
		}
	});

	ret.a11yclick = a11yclick;	// back compat

	return ret;
});

},
'dijit/a11yclick':function(){
define([
	"dojo/keys", // keys.ENTER keys.SPACE
	"dojo/mouse",
	"dojo/on",
	"dojo/touch" // touch support for click is now there
], function(keys, mouse, on, touch){

	// module:
	//		dijit/a11yclick

	/*=====
	return {
		// summary:
		//		Custom press, release, and click synthetic events
		//		which trigger on a left mouse click, touch, or space/enter keyup.

		click: function(node, listener){
			// summary:
			//		Logical click operation for mouse, touch, or keyboard (space/enter key)
		},
		press: function(node, listener){
			// summary:
			//		Mousedown (left button), touchstart, or keydown (space or enter) corresponding to logical click operation.
		},
		release: function(node, listener){
			// summary:
			//		Mouseup (left button), touchend, or keyup (space or enter) corresponding to logical click operation.
		},
		move: function(node, listener){
			// summary:
			//		Mouse cursor or a finger is dragged over the given node.
		}
	};
	=====*/

	function clickKey(/*Event*/ e){
		// Test if this keyboard event should be tracked as the start (if keydown) or end (if keyup) of a click event.
		// Only track for nodes marked to be tracked, and not for buttons or inputs,
		// since buttons handle keyboard click natively, and text inputs should not
		// prevent typing spaces or newlines.
		if((e.keyCode === keys.ENTER || e.keyCode === keys.SPACE) && !/input|button|textarea/i.test(e.target.nodeName)){

			// Test if a node or its ancestor has been marked with the dojoClick property to indicate special processing
			for(var node = e.target; node; node = node.parentNode){
				if(node.dojoClick){ return true; }
			}
		}
	}

	var lastKeyDownNode;

	on(document, "keydown", function(e){
		//console.log("a11yclick: onkeydown, e.target = ", e.target, ", lastKeyDownNode was ", lastKeyDownNode, ", equality is ", (e.target === lastKeyDownNode));
		if(clickKey(e)){
			// needed on IE for when focus changes between keydown and keyup - otherwise dropdown menus do not work
			lastKeyDownNode = e.target;

			// Prevent viewport scrolling on space key in IE<9.
			// (Reproducible on test_Button.html on any of the first dijit/form/Button examples)
			e.preventDefault();
		}else{
			lastKeyDownNode = null;
		}
	});

	on(document, "keyup", function(e){
		//console.log("a11yclick: onkeyup, e.target = ", e.target, ", lastKeyDownNode was ", lastKeyDownNode, ", equality is ", (e.target === lastKeyDownNode));
		if(clickKey(e) && e.target == lastKeyDownNode){	// === breaks greasemonkey
			//need reset here or have problems in FF when focus returns to trigger element after closing popup/alert
			lastKeyDownNode = null;

			on.emit(e.target, "click", {
				cancelable: true,
				bubbles: true,
				ctrlKey: e.ctrlKey,
				shiftKey: e.shiftKey,
				metaKey: e.metaKey,
				altKey: e.altKey,
				_origType: e.type
			});
		}
	});

	// I want to return a hash of the synthetic events, but for backwards compatibility the main return value
	// needs to be the click event.   Change for 2.0.

	var click = function(node, listener){
		// Set flag on node so that keydown/keyup above emits click event.
		// Also enables fast click processing from dojo/touch.
		node.dojoClick = true;

		return on(node, "click", listener);
	};
	click.click = click;	// forward compatibility with 2.0

	click.press =  function(node, listener){
		var touchListener = on(node, touch.press, function(evt){
			if(evt.type == "mousedown" && !mouse.isLeft(evt)){
				// Ignore right click
				return;
			}
			listener(evt);
		}), keyListener = on(node, "keydown", function(evt){
			if(evt.keyCode === keys.ENTER || evt.keyCode === keys.SPACE){
				listener(evt);
			}
		});
		return {
			remove: function(){
				touchListener.remove();
				keyListener.remove();
			}
		};
	};

	click.release =  function(node, listener){
		var touchListener = on(node, touch.release, function(evt){
			if(evt.type == "mouseup" && !mouse.isLeft(evt)){
				// Ignore right click
				return;
			}
			listener(evt);
		}), keyListener = on(node, "keyup", function(evt){
			if(evt.keyCode === keys.ENTER || evt.keyCode === keys.SPACE){
				listener(evt);
			}
		});
		return {
			remove: function(){
				touchListener.remove();
				keyListener.remove();
			}
		};
	};

	click.move = touch.move;	// just for convenience

	return click;
});

},
'dijit/_FocusMixin':function(){
define([
	"./focus",
	"./_WidgetBase",
	"dojo/_base/declare", // declare
	"dojo/_base/lang" // lang.extend
], function(focus, _WidgetBase, declare, lang){

	// module:
	//		dijit/_FocusMixin

	// We don't know where _FocusMixin will occur in the inheritance chain, but we need the _onFocus()/_onBlur() below
	// to be last in the inheritance chain, so mixin to _WidgetBase.
	lang.extend(_WidgetBase, {
		// focused: [readonly] Boolean
		//		This widget or a widget it contains has focus, or is "active" because
		//		it was recently clicked.
		focused: false,

		onFocus: function(){
			// summary:
			//		Called when the widget becomes "active" because
			//		it or a widget inside of it either has focus, or has recently
			//		been clicked.
			// tags:
			//		callback
		},

		onBlur: function(){
			// summary:
			//		Called when the widget stops being "active" because
			//		focus moved to something outside of it, or the user
			//		clicked somewhere outside of it, or the widget was
			//		hidden.
			// tags:
			//		callback
		},

		_onFocus: function(){
			// summary:
			//		This is where widgets do processing for when they are active,
			//		such as changing CSS classes.  See onFocus() for more details.
			// tags:
			//		protected
			this.onFocus();
		},

		_onBlur: function(){
			// summary:
			//		This is where widgets do processing for when they stop being active,
			//		such as changing CSS classes.  See onBlur() for more details.
			// tags:
			//		protected
			this.onBlur();
		}
	});

	return declare("dijit._FocusMixin", null, {
		// summary:
		//		Mixin to widget to provide _onFocus() and _onBlur() methods that
		//		fire when a widget or its descendants get/lose focus

		// flag that I want _onFocus()/_onBlur() notifications from focus manager
		_focusManager: focus
	});

});

},
'dojo/uacss':function(){
define(["./dom-geometry", "./_base/lang", "./domReady", "./sniff", "./_base/window"],
	function(geometry, lang, domReady, has, baseWindow){

	// module:
	//		dojo/uacss

	/*=====
	return {
		// summary:
		//		Applies pre-set CSS classes to the top-level HTML node, based on:
		//
		//		- browser (ex: dj_ie)
		//		- browser version (ex: dj_ie6)
		//		- box model (ex: dj_contentBox)
		//		- text direction (ex: dijitRtl)
		//
		//		In addition, browser, browser version, and box model are
		//		combined with an RTL flag when browser text is RTL. ex: dj_ie-rtl.
		//
		//		Returns the has() method.
	};
	=====*/

	var
		html = baseWindow.doc.documentElement,
		ie = has("ie"),
		trident = has("trident"),
		opera = has("opera"),
		maj = Math.floor,
		ff = has("ff"),
		boxModel = geometry.boxModel.replace(/-/,''),

		classes = {
			"dj_quirks": has("quirks"),

			// NOTE: Opera not supported by dijit
			"dj_opera": opera,

			"dj_khtml": has("khtml"),

			"dj_webkit": has("webkit"),
			"dj_safari": has("safari"),
			"dj_chrome": has("chrome"),
			"dj_edge": has("edge"),

			"dj_gecko": has("mozilla"),

			"dj_ios": has("ios"),
			"dj_android": has("android")
		}; // no dojo unsupported browsers

	if(ie){
		classes["dj_ie"] = true;
		classes["dj_ie" + maj(ie)] = true;
		classes["dj_iequirks"] = has("quirks");
	}
	if(trident){
		classes["dj_trident"] = true;
		classes["dj_trident" + maj(trident)] = true;
	}
	if(ff){
		classes["dj_ff" + maj(ff)] = true;
	}

	classes["dj_" + boxModel] = true;

	// apply browser, browser version, and box model class names
	var classStr = "";
	for(var clz in classes){
		if(classes[clz]){
			classStr += clz + " ";
		}
	}
	html.className = lang.trim(html.className + " " + classStr);

	// If RTL mode, then add dj_rtl flag plus repeat existing classes with -rtl extension.
	// We can't run the code below until the <body> tag has loaded (so we can check for dir=rtl).
	domReady(function(){
		if(!geometry.isBodyLtr()){
			var rtlClassStr = "dj_rtl dijitRtl " + classStr.replace(/ /g, "-rtl ");
			html.className = lang.trim(html.className + " " + rtlClassStr + "dj_rtl dijitRtl " + classStr.replace(/ /g, "-rtl "));
		}
	});
	return has;
});

},
'dijit/hccss':function(){
define(["dojo/dom-class", "dojo/hccss", "dojo/domReady", "dojo/_base/window"], function(domClass, has, domReady, win){

	// module:
	//		dijit/hccss

	/*=====
	return function(){
		// summary:
		//		Test if computer is in high contrast mode, and sets `dijit_a11y` flag on `<body>` if it is.
		//		Deprecated, use ``dojo/hccss`` instead.
	};
	=====*/

	domReady(function(){
		if(has("highcontrast")){
			domClass.add(win.body(), "dijit_a11y");
		}
	});

	return has;
});

},
'dojo/hccss':function(){
define([
	"require",			// require, require.toUrl
	"./_base/config", // config.blankGif
	"./dom-class", // domClass.add
	"./dom-style", // domStyle.getComputedStyle
	"./has",
	"./domReady",
	"./_base/window" // win.body
], function(require, config, domClass, domStyle, has, domReady, win){

	// module:
	//		dojo/hccss

	/*=====
	return function(){
		// summary:
		//		Test if computer is in high contrast mode (i.e. if browser is not displaying background images).
		//		Defines `has("highcontrast")` and sets `dj_a11y` CSS class on `<body>` if machine is in high contrast mode.
		//		Returns `has()` method;
	};
	=====*/

	// Has() test for when background images aren't displayed.  Don't call has("highcontrast") before dojo/domReady!.
	has.add("highcontrast", function(){
		// note: if multiple documents, doesn't matter which one we use
		var div = win.doc.createElement("div");
		try{
			div.style.cssText = "border: 1px solid; border-color:red green; position: absolute; height: 5px; top: -999px;" +
				"background-image: url(\"" + (config.blankGif || require.toUrl("./resources/blank.gif")) + "\");";
			win.body().appendChild(div);

			var cs = domStyle.getComputedStyle(div),
				bkImg = cs.backgroundImage;
			return cs.borderTopColor == cs.borderRightColor ||
				(bkImg && (bkImg == "none" || bkImg == "url(invalid-url:)" ));
		}catch(e){
			console.warn("hccss: exception detecting high-contrast mode, document is likely hidden: " + e.toString());
			return false;
		}finally{
			if(has("ie") <= 8){
				div.outerHTML = "";		// prevent mixed-content warning, see http://support.microsoft.com/kb/925014
			}else{
				win.body().removeChild(div);
			}
		}
	});

	domReady(function(){
		if(has("highcontrast")){
			domClass.add(win.body(), "dj_a11y");
		}
	});

	return has;
});

},
'dijit/_Container':function(){
define([
	"dojo/_base/array", // array.forEach array.indexOf
	"dojo/_base/declare", // declare
	"dojo/dom-construct", // domConstruct.place
	"dojo/_base/kernel" // kernel.deprecated
], function(array, declare, domConstruct, kernel){

	// module:
	//		dijit/_Container

	return declare("dijit._Container", null, {
		// summary:
		//		Mixin for widgets that contain HTML and/or a set of widget children.

		buildRendering: function(){
			this.inherited(arguments);
			if(!this.containerNode){
				// All widgets with descendants must set containerNode.
				// NB: this code doesn't quite work right because for TabContainer it runs before
				// _TemplatedMixin::buildRendering(), and thus
				// sets this.containerNode to this.domNode, later to be overridden by the assignment in the template.
				this.containerNode = this.domNode;
			}
		},

		addChild: function(/*dijit/_WidgetBase*/ widget, /*int?*/ insertIndex){
			// summary:
			//		Makes the given widget a child of this widget.
			// description:
			//		Inserts specified child widget's dom node as a child of this widget's
			//		container node, and possibly does other processing (such as layout).

			// I want to just call domConstruct.place(widget.domNode, this.containerNode, insertIndex), but the counting
			// is thrown off by text nodes and comment nodes that show up when constructed by markup.
			// In the future consider stripping those nodes on construction, either in the parser or this widget code.
			var refNode = this.containerNode;
			if(insertIndex > 0){
				// Old-school way to get nth child; dojo.query would be easier but _Container was weened from dojo.query
				// in #10087 to minimize download size.   Not sure if that's still and issue with new smaller dojo/query.
				refNode = refNode.firstChild;
				while(insertIndex > 0){
					if(refNode.nodeType == 1){ insertIndex--; }
					refNode = refNode.nextSibling;
				}
				if(refNode){
					insertIndex = "before";
				}else{
					// to support addChild(child, n-1) where there are n children (should add child at end)
					refNode = this.containerNode;
					insertIndex = "last";
				}
			}

			domConstruct.place(widget.domNode, refNode, insertIndex);

			// If I've been started but the child widget hasn't been started,
			// start it now.  Make sure to do this after widget has been
			// inserted into the DOM tree, so it can see that it's being controlled by me,
			// so it doesn't try to size itself.
			if(this._started && !widget._started){
				widget.startup();
			}
		},

		removeChild: function(/*Widget|int*/ widget){
			// summary:
			//		Removes the passed widget instance from this widget but does
			//		not destroy it.  You can also pass in an integer indicating
			//		the index within the container to remove (ie, removeChild(5) removes the sixth widget).

			if(typeof widget == "number"){
				widget = this.getChildren()[widget];
			}

			if(widget){
				var node = widget.domNode;
				if(node && node.parentNode){
					node.parentNode.removeChild(node); // detach but don't destroy
				}
			}
		},

		hasChildren: function(){
			// summary:
			//		Returns true if widget has child widgets, i.e. if this.containerNode contains widgets.
			return this.getChildren().length > 0;	// Boolean
		},

		_getSiblingOfChild: function(/*dijit/_WidgetBase*/ child, /*int*/ dir){
			// summary:
			//		Get the next or previous widget sibling of child
			// dir:
			//		if 1, get the next sibling
			//		if -1, get the previous sibling
			// tags:
			//		private
			var children = this.getChildren(),
				idx = array.indexOf(children, child);	// int
			return children[idx + dir];
		},

		getIndexOfChild: function(/*dijit/_WidgetBase*/ child){
			// summary:
			//		Gets the index of the child in this container or -1 if not found
			return array.indexOf(this.getChildren(), child);	// int
		}
	});
});

},
'dijit/layout/_ContentPaneResizeMixin':function(){
define([
	"dojo/_base/array", // array.filter array.forEach
	"dojo/_base/declare", // declare
	"dojo/dom-class", // domClass.contains domClass.toggle
	"dojo/dom-geometry", // domGeometry.contentBox domGeometry.marginBox
	"dojo/dom-style",
	"dojo/_base/lang", // lang.mixin
	"dojo/query", // query
	"../registry", // registry.byId
	"../Viewport",
	"./utils" // marginBox2contextBox
], function(array, declare, domClass, domGeometry, domStyle, lang, query,
			registry, Viewport, layoutUtils){

	// module:
	//		dijit/layout/_ContentPaneResizeMixin

	return declare("dijit.layout._ContentPaneResizeMixin", null, {
		// summary:
		//		Resize() functionality of ContentPane.   If there's a single layout widget
		//		child then it will call resize() with the same dimensions as the ContentPane.
		//		Otherwise just calls resize on each child.
		//
		//		Also implements basic startup() functionality, where starting the parent
		//		will start the children

		// doLayout: Boolean
		//		- false - don't adjust size of children
		//		- true - if there is a single visible child widget, set it's size to however big the ContentPane is
		doLayout: true,

		// isLayoutContainer: [protected] Boolean
		//		Indicates that this widget will call resize() on it's child widgets
		//		when they become visible.
		isLayoutContainer: true,

		startup: function(){
			// summary:
			//		See `dijit/layout/_LayoutWidget.startup()` for description.
			//		Although ContentPane doesn't extend _LayoutWidget, it does implement
			//		the same API.

			if(this._started){
				return;
			}

			var parent = this.getParent();
			this._childOfLayoutWidget = parent && parent.isLayoutContainer;

			// I need to call resize() on my child/children (when I become visible), unless
			// I'm the child of a layout widget in which case my parent will call resize() on me and I'll do it then.
			this._needLayout = !this._childOfLayoutWidget;

			this.inherited(arguments);

			if(this._isShown()){
				this._onShow();
			}

			if(!this._childOfLayoutWidget){
				// Since my parent isn't a layout container, and my style *may be* width=height=100%
				// or something similar (either set directly or via a CSS class),
				// monitor when viewport size changes so that I can re-layout.
				// This is more for subclasses of ContentPane than ContentPane itself, although it
				// could be useful for a ContentPane if it has a single child widget inheriting ContentPane's size.
				this.own(Viewport.on("resize", lang.hitch(this, "resize")));
			}
		},

		_checkIfSingleChild: function(){
			// summary:
			//		Test if we have exactly one visible widget as a child,
			//		and if so assume that we are a container for that widget,
			//		and should propagate startup() and resize() calls to it.
			//		Skips over things like data stores since they aren't visible.

			if(!this.doLayout){ return; }

			var candidateWidgets = [],
				otherVisibleNodes = false;

			query("> *", this.containerNode).some(function(node){
				var widget = registry.byNode(node);
				if(widget && widget.resize){
					candidateWidgets.push(widget);
				}else if(!/script|link|style/i.test(node.nodeName) && node.offsetHeight){
					otherVisibleNodes = true;
				}
			});

			this._singleChild = candidateWidgets.length == 1 && !otherVisibleNodes ?
				candidateWidgets[0] : null;

			// So we can set overflow: hidden to avoid a safari bug w/scrollbars showing up (#9449)
			domClass.toggle(this.containerNode, this.baseClass + "SingleChild", !!this._singleChild);
		},

		resize: function(changeSize, resultSize){
			// summary:
			//		See `dijit/layout/_LayoutWidget.resize()` for description.
			//		Although ContentPane doesn't extend _LayoutWidget, it does implement
			//		the same API.

			this._resizeCalled = true;

			this._scheduleLayout(changeSize, resultSize);
		},

		_scheduleLayout: function(changeSize, resultSize){
			// summary:
			//		Resize myself, and call resize() on each of my child layout widgets, either now
			//		(if I'm currently visible) or when I become visible
			if(this._isShown()){
				this._layout(changeSize, resultSize);
			}else{
				this._needLayout = true;
				this._changeSize = changeSize;
				this._resultSize = resultSize;
			}
		},

		_layout: function(changeSize, resultSize){
			// summary:
			//		Resize myself according to optional changeSize/resultSize parameters, like a layout widget.
			//		Also, since I am an isLayoutContainer widget, each of my children expects me to
			//		call resize() or layout() on it.
			//
			//		Should be called on initialization and also whenever we get new content
			//		(from an href, or from set('content', ...))... but deferred until
			//		the ContentPane is visible

			delete this._needLayout;

			// For the TabContainer --> BorderContainer --> ContentPane case, _onShow() is
			// never called directly, so resize() is our trigger to do the initial href download (see [20099]).
			// However, don't load href for closed TitlePanes.
			if(!this._wasShown && this.open !== false){
				this._onShow();
			}

			// Set margin box size, unless it wasn't specified, in which case use current size.
			if(changeSize){
				domGeometry.setMarginBox(this.domNode, changeSize);
			}

			// Compute content box size of containerNode in case we [later] need to size our single child.
			var cn = this.containerNode;
			if(cn === this.domNode){
				// If changeSize or resultSize was passed to this method and this.containerNode ==
				// this.domNode then we can compute the content-box size without querying the node,
				// which is more reliable (similar to LayoutWidget.resize) (see for example #9449).
				var mb = resultSize || {};
				lang.mixin(mb, changeSize || {}); // changeSize overrides resultSize
				if(!("h" in mb) || !("w" in mb)){
					mb = lang.mixin(domGeometry.getMarginBox(cn), mb); // just use domGeometry.setMarginBox() to fill in missing values
				}
				this._contentBox = layoutUtils.marginBox2contentBox(cn, mb);
			}else{
				this._contentBox = domGeometry.getContentBox(cn);
			}

			this._layoutChildren();
		},

		_layoutChildren: function(){
			// Call _checkIfSingleChild() again in case app has manually mucked w/the content
			// of the ContentPane (rather than changing it through the set("content", ...) API.
			this._checkIfSingleChild();

			if(this._singleChild && this._singleChild.resize){
				var cb = this._contentBox || domGeometry.getContentBox(this.containerNode);

				// note: if widget has padding this._contentBox will have l and t set,
				// but don't pass them to resize() or it will doubly-offset the child
				this._singleChild.resize({w: cb.w, h: cb.h});
			}else{
				// All my child widgets are independently sized (rather than matching my size),
				// but I still need to call resize() on each child to make it layout.
				var children = this.getChildren(),
					widget,
					i = 0;
				while(widget = children[i++]){
					if(widget.resize){
						widget.resize();
					}
				}
			}
		},

		_isShown: function(){
			// summary:
			//		Returns true if the content is currently shown.
			// description:
			//		If I am a child of a layout widget then it actually returns true if I've ever been visible,
			//		not whether I'm currently visible, since that's much faster than tracing up the DOM/widget
			//		tree every call, and at least solves the performance problem on page load by deferring loading
			//		hidden ContentPanes until they are first shown

			if(this._childOfLayoutWidget){
				// If we are TitlePane, etc - we return that only *IF* we've been resized
				if(this._resizeCalled && "open" in this){
					return this.open;
				}
				return this._resizeCalled;
			}else if("open" in this){
				return this.open;		// for TitlePane, etc.
			}else{
				var node = this.domNode, parent = this.domNode.parentNode;
				return (node.style.display != 'none') && (node.style.visibility != 'hidden') && !domClass.contains(node, "dijitHidden") &&
					parent && parent.style && (parent.style.display != 'none');
			}
		},

		_onShow: function(){
			// summary:
			//		Called when the ContentPane is made visible
			// description:
			//		For a plain ContentPane, this is called on initialization, from startup().
			//		If the ContentPane is a hidden pane of a TabContainer etc., then it's
			//		called whenever the pane is made visible.
			//
			//		Does layout/resize of child widget(s)

			// Need to keep track of whether ContentPane has been shown (which is different than
			// whether or not it's currently visible).
			this._wasShown = true;

			if(this._needLayout){
				// If a layout has been scheduled for when we become visible, do it now
				this._layout(this._changeSize, this._resultSize);
			}

			this.inherited(arguments);
		}
	});
});

},
'dijit/layout/utils':function(){
define([
	"dojo/_base/array", // array.filter array.forEach
	"dojo/dom-class", // domClass.add domClass.remove
	"dojo/dom-geometry", // domGeometry.marginBox
	"dojo/dom-style", // domStyle.getComputedStyle
	"dojo/_base/lang" // lang.mixin, lang.setObject
], function(array, domClass, domGeometry, domStyle, lang){

	// module:
	//		dijit/layout/utils

	function capitalize(word){
		return word.substring(0,1).toUpperCase() + word.substring(1);
	}

	function size(widget, dim){
		// size the child
		var newSize = widget.resize ? widget.resize(dim) : domGeometry.setMarginBox(widget.domNode, dim);

		// record child's size
		if(newSize){
			// if the child returned it's new size then use that
			lang.mixin(widget, newSize);
		}else{
			// otherwise, call getMarginBox(), but favor our own numbers when we have them.
			// the browser lies sometimes
			lang.mixin(widget, domGeometry.getMarginBox(widget.domNode));
			lang.mixin(widget, dim);
		}
	}

	var utils = {
		// summary:
		//		Utility functions for doing layout

		marginBox2contentBox: function(/*DomNode*/ node, /*Object*/ mb){
			// summary:
			//		Given the margin-box size of a node, return its content box size.
			//		Functions like domGeometry.contentBox() but is more reliable since it doesn't have
			//		to wait for the browser to compute sizes.
			var cs = domStyle.getComputedStyle(node);
			var me = domGeometry.getMarginExtents(node, cs);
			var pb = domGeometry.getPadBorderExtents(node, cs);
			return {
				l: domStyle.toPixelValue(node, cs.paddingLeft),
				t: domStyle.toPixelValue(node, cs.paddingTop),
				w: mb.w - (me.w + pb.w),
				h: mb.h - (me.h + pb.h)
			};
		},


		layoutChildren: function(/*DomNode*/ container, /*Object*/ dim, /*Widget[]*/ children,
				/*String?*/ changedRegionId, /*Number?*/ changedRegionSize){
			// summary:
			//		Layout a bunch of child dom nodes within a parent dom node
			// container:
			//		parent node
			// dim:
			//		{l, t, w, h} object specifying dimensions of container into which to place children
			// children:
			//		An array of Widgets or at least objects containing:
			//
			//		- domNode: pointer to DOM node to position
			//		- region or layoutAlign: position to place DOM node
			//		- resize(): (optional) method to set size of node
			//		- id: (optional) Id of widgets, referenced from resize object, below.
			//
			//		The widgets in this array should be ordered according to how they should be laid out
			//		(each element will be processed in order, and take up as much remaining space as needed),
			//		with the center widget last.
			// changedRegionId:
			//		If specified, the slider for the region with the specified id has been dragged, and thus
			//		the region's height or width should be adjusted according to changedRegionSize
			// changedRegionSize:
			//		See changedRegionId.

			// copy dim because we are going to modify it
			dim = lang.mixin({}, dim);

			domClass.add(container, "dijitLayoutContainer");

			// Move "client" elements to the end of the array for layout.  a11y dictates that the author
			// needs to be able to put them in the document in tab-order, but this algorithm requires that
			// client be last.    TODO: remove for 2.0, all dijit client code already sends children as last item.
			children = array.filter(children, function(item){ return item.region != "center" && item.layoutAlign != "client"; })
				.concat(array.filter(children, function(item){ return item.region == "center" || item.layoutAlign == "client"; }));

			// set positions/sizes
			array.forEach(children, function(child){
				var elm = child.domNode,
					pos = (child.region || child.layoutAlign);
				if(!pos){
					throw new Error("No region setting for " + child.id)
				}

				// set elem to upper left corner of unused space; may move it later
				var elmStyle = elm.style;
				elmStyle.left = dim.l+"px";
				elmStyle.top = dim.t+"px";
				elmStyle.position = "absolute";

				domClass.add(elm, "dijitAlign" + capitalize(pos));

				// Size adjustments to make to this child widget
				var sizeSetting = {};

				// Check for optional size adjustment due to splitter drag (height adjustment for top/bottom align
				// panes and width adjustment for left/right align panes.
				if(changedRegionId && changedRegionId == child.id){
					sizeSetting[child.region == "top" || child.region == "bottom" ? "h" : "w"] = changedRegionSize;
				}

				if(pos == "leading"){
					pos = child.isLeftToRight() ? "left" : "right";
				}
				if(pos == "trailing"){
					pos = child.isLeftToRight() ? "right" : "left";
				}

				// set size && adjust record of remaining space.
				// note that setting the width of a <div> may affect its height.
				if(pos == "top" || pos == "bottom"){
					sizeSetting.w = dim.w;
					size(child, sizeSetting);
					dim.h -= child.h;
					if(pos == "top"){
						dim.t += child.h;
					}else{
						elmStyle.top = dim.t + dim.h + "px";
					}
				}else if(pos == "left" || pos == "right"){
					sizeSetting.h = dim.h;
					size(child, sizeSetting);
					dim.w -= child.w;
					if(pos == "left"){
						dim.l += child.w;
					}else{
						elmStyle.left = dim.l + dim.w + "px";
					}
				}else if(pos == "client" || pos == "center"){
					size(child, dim);
				}
			});
		}
	};

	lang.setObject("dijit.layout.utils", utils);	// remove for 2.0

	return utils;
});

},
'dijit/_DialogMixin':function(){
define([
	"dojo/_base/declare", // declare
	"./a11y"	// _getTabNavigable
], function(declare, a11y){

	// module:
	//		dijit/_DialogMixin

	return declare("dijit._DialogMixin", null, {
		// summary:
		//		This provides functions useful to Dialog and TooltipDialog

		// actionBarTemplate: String
		//		HTML snippet to show the action bar (gray bar with OK/cancel buttons).
		//		Blank by default, but used by ConfirmDialog/ConfirmTooltipDialog subclasses.
		actionBarTemplate: "",

		execute: function(/*Object*/ /*===== formContents =====*/){
			// summary:
			//		Callback when the user hits the submit button.
			//		Override this method to handle Dialog execution.
			// description:
			//		After the user has pressed the submit button, the Dialog
			//		first calls onExecute() to notify the container to hide the
			//		dialog and restore focus to wherever it used to be.
			//
			//		*Then* this method is called.
			// type:
			//		callback
		},

		onCancel: function(){
			// summary:
			//		Called when user has pressed the Dialog's cancel button, to notify container.
			// description:
			//		Developer shouldn't override or connect to this method;
			//		it's a private communication device between the TooltipDialog
			//		and the thing that opened it (ex: `dijit/form/DropDownButton`)
			// type:
			//		protected
		},

		onExecute: function(){
			// summary:
			//		Called when user has pressed the dialog's OK button, to notify container.
			// description:
			//		Developer shouldn't override or connect to this method;
			//		it's a private communication device between the TooltipDialog
			//		and the thing that opened it (ex: `dijit/form/DropDownButton`)
			// type:
			//		protected
		},

		_onSubmit: function(){
			// summary:
			//		Callback when user hits submit button
			// type:
			//		protected
			this.onExecute();	// notify container that we are about to execute
			this.execute(this.get('value'));
		},

		_getFocusItems: function(){
			// summary:
			//		Finds focusable items in dialog,
			//		and sets this._firstFocusItem and this._lastFocusItem
			// tags:
			//		protected

			var elems = a11y._getTabNavigable(this.domNode);
			this._firstFocusItem = elems.lowest || elems.first || this.closeButtonNode || this.domNode;
			this._lastFocusItem = elems.last || elems.highest || this._firstFocusItem;
		}
	});
});

},
'dijit/form/_FormMixin':function(){
define([
	"dojo/_base/array", // array.every array.filter array.forEach array.indexOf array.map
	"dojo/_base/declare", // declare
	"dojo/_base/kernel", // kernel.deprecated
	"dojo/_base/lang", // lang.hitch lang.isArray
	"dojo/on",
	"dojo/window" // winUtils.scrollIntoView
], function(array, declare, kernel, lang, on, winUtils){

	// module:
	//		dijit/form/_FormMixin

	return declare("dijit.form._FormMixin", null, {
		// summary:
		//		Mixin for containers of form widgets (i.e. widgets that represent a single value
		//		and can be children of a `<form>` node or `dijit/form/Form` widget)
		// description:
		//		Can extract all the form widgets
		//		values and combine them into a single javascript object, or alternately
		//		take such an object and set the values for all the contained
		//		form widgets

	/*=====
		// value: Object
		//		Name/value hash for each child widget with a name and value.
		//		Child widgets without names are not part of the hash.
		//
		//		If there are multiple child widgets w/the same name, value is an array,
		//		unless they are radio buttons in which case value is a scalar (since only
		//		one radio button can be checked at a time).
		//
		//		If a child widget's name is a dot separated list (like a.b.c.d), it's a nested structure.
		//
		//		Example:
		//	|	{ name: "John Smith", interests: ["sports", "movies"] }
	=====*/

		// state: [readonly] String
		//		Will be "Error" if one or more of the child widgets has an invalid value,
		//		"Incomplete" if not all of the required child widgets are filled in.  Otherwise, "",
		//		which indicates that the form is ready to be submitted.
		state: "",

		// TODO:
		//	* Repeater
		//	* better handling for arrays.  Often form elements have names with [] like
		//	* people[3].sex (for a list of people [{name: Bill, sex: M}, ...])


		_getDescendantFormWidgets: function(/*dijit/_WidgetBase[]?*/ children){
			// summary:
			//		Returns all form widget descendants, searching through non-form child widgets like BorderContainer
			var res = [];
			array.forEach(children || this.getChildren(), function(child){
				if("value" in child){
					res.push(child);
				}else{
					res = res.concat(this._getDescendantFormWidgets(child.getChildren()));
				}
			}, this);
			return res;
		},

		reset: function(){
			array.forEach(this._getDescendantFormWidgets(), function(widget){
				if(widget.reset){
					widget.reset();
				}
			});
		},

		validate: function(){
			// summary:
			//		returns if the form is valid - same as isValid - but
			//		provides a few additional (ui-specific) features:
			//
			//		1. it will highlight any sub-widgets that are not valid
			//		2. it will call focus() on the first invalid sub-widget
			var didFocus = false;
			return array.every(array.map(this._getDescendantFormWidgets(), function(widget){
				// Need to set this so that "required" widgets get their
				// state set.
				widget._hasBeenBlurred = true;
				var valid = widget.disabled || !widget.validate || widget.validate();
				if(!valid && !didFocus){
					// Set focus of the first non-valid widget
					winUtils.scrollIntoView(widget.containerNode || widget.domNode);
					widget.focus();
					didFocus = true;
				}
				return valid;
			}), function(item){ return item; });
		},

		setValues: function(val){
			kernel.deprecated(this.declaredClass+"::setValues() is deprecated. Use set('value', val) instead.", "", "2.0");
			return this.set('value', val);
		},
		_setValueAttr: function(/*Object*/ obj){
			// summary:
			//		Fill in form values from according to an Object (in the format returned by get('value'))

			// generate map from name --> [list of widgets with that name]
			var map = { };
			array.forEach(this._getDescendantFormWidgets(), function(widget){
				if(!widget.name){ return; }
				var entry = map[widget.name] || (map[widget.name] = [] );
				entry.push(widget);
			});

			for(var name in map){
				if(!map.hasOwnProperty(name)){
					continue;
				}
				var widgets = map[name],						// array of widgets w/this name
					values = lang.getObject(name, false, obj);	// list of values for those widgets

				if(values === undefined){
					continue;
				}
				values = [].concat(values);
				if(typeof widgets[0].checked == 'boolean'){
					// for checkbox/radio, values is a list of which widgets should be checked
					array.forEach(widgets, function(w){
						w.set('value', array.indexOf(values, w._get('value')) != -1);
					});
				}else if(widgets[0].multiple){
					// it takes an array (e.g. multi-select)
					widgets[0].set('value', values);
				}else{
					// otherwise, values is a list of values to be assigned sequentially to each widget
					array.forEach(widgets, function(w, i){
						w.set('value', values[i]);
					});
				}
			}

			/***
			 *	TODO: code for plain input boxes (this shouldn't run for inputs that are part of widgets)

			array.forEach(this.containerNode.elements, function(element){
				if(element.name == ''){return};	// like "continue"
				var namePath = element.name.split(".");
				var myObj=obj;
				var name=namePath[namePath.length-1];
				for(var j=1,len2=namePath.length;j<len2;++j){
					var p=namePath[j - 1];
					// repeater support block
					var nameA=p.split("[");
					if(nameA.length > 1){
						if(typeof(myObj[nameA[0]]) == "undefined"){
							myObj[nameA[0]]=[ ];
						} // if

						nameIndex=parseInt(nameA[1]);
						if(typeof(myObj[nameA[0]][nameIndex]) == "undefined"){
							myObj[nameA[0]][nameIndex] = { };
						}
						myObj=myObj[nameA[0]][nameIndex];
						continue;
					} // repeater support ends

					if(typeof(myObj[p]) == "undefined"){
						myObj=undefined;
						break;
					};
					myObj=myObj[p];
				}

				if(typeof(myObj) == "undefined"){
					return;		// like "continue"
				}
				if(typeof(myObj[name]) == "undefined" && this.ignoreNullValues){
					return;		// like "continue"
				}

				// TODO: widget values (just call set('value', ...) on the widget)

				// TODO: maybe should call dojo.getNodeProp() instead
				switch(element.type){
					case "checkbox":
						element.checked = (name in myObj) &&
							array.some(myObj[name], function(val){ return val == element.value; });
						break;
					case "radio":
						element.checked = (name in myObj) && myObj[name] == element.value;
						break;
					case "select-multiple":
						element.selectedIndex=-1;
						array.forEach(element.options, function(option){
							option.selected = array.some(myObj[name], function(val){ return option.value == val; });
						});
						break;
					case "select-one":
						element.selectedIndex="0";
						array.forEach(element.options, function(option){
							option.selected = option.value == myObj[name];
						});
						break;
					case "hidden":
					case "text":
					case "textarea":
					case "password":
						element.value = myObj[name] || "";
						break;
				}
			});
			*/

			// Note: no need to call this._set("value", ...) as the child updates will trigger onChange events
			// which I am monitoring.
		},

		getValues: function(){
			kernel.deprecated(this.declaredClass+"::getValues() is deprecated. Use get('value') instead.", "", "2.0");
			return this.get('value');
		},
		_getValueAttr: function(){
			// summary:
			//		Returns Object representing form values.   See description of `value` for details.
			// description:

			// The value is updated into this.value every time a child has an onChange event,
			// so in the common case this function could just return this.value.   However,
			// that wouldn't work when:
			//
			// 1. User presses return key to submit a form.  That doesn't fire an onchange event,
			// and even if it did it would come too late due to the defer(...) in _handleOnChange()
			//
			// 2. app for some reason calls this.get("value") while the user is typing into a
			// form field.   Not sure if that case needs to be supported or not.

			// get widget values
			var obj = { };
			array.forEach(this._getDescendantFormWidgets(), function(widget){
				var name = widget.name;
				if(!name || widget.disabled){ return; }

				// Single value widget (checkbox, radio, or plain <input> type widget)
				var value = widget.get('value');

				// Store widget's value(s) as a scalar, except for checkboxes which are automatically arrays
				if(typeof widget.checked == 'boolean'){
					if(/Radio/.test(widget.declaredClass)){
						// radio button
						if(value !== false){
							lang.setObject(name, value, obj);
						}else{
							// give radio widgets a default of null
							value = lang.getObject(name, false, obj);
							if(value === undefined){
								lang.setObject(name, null, obj);
							}
						}
					}else{
						// checkbox/toggle button
						var ary=lang.getObject(name, false, obj);
						if(!ary){
							ary=[];
							lang.setObject(name, ary, obj);
						}
						if(value !== false){
							ary.push(value);
						}
					}
				}else{
					var prev=lang.getObject(name, false, obj);
					if(typeof prev != "undefined"){
						if(lang.isArray(prev)){
							prev.push(value);
						}else{
							lang.setObject(name, [prev, value], obj);
						}
					}else{
						// unique name
						lang.setObject(name, value, obj);
					}
				}
			});

			/***
			 * code for plain input boxes (see also domForm.formToObject, can we use that instead of this code?
			 * but it doesn't understand [] notation, presumably)
			var obj = { };
			array.forEach(this.containerNode.elements, function(elm){
				if(!elm.name)	{
					return;		// like "continue"
				}
				var namePath = elm.name.split(".");
				var myObj=obj;
				var name=namePath[namePath.length-1];
				for(var j=1,len2=namePath.length;j<len2;++j){
					var nameIndex = null;
					var p=namePath[j - 1];
					var nameA=p.split("[");
					if(nameA.length > 1){
						if(typeof(myObj[nameA[0]]) == "undefined"){
							myObj[nameA[0]]=[ ];
						} // if
						nameIndex=parseInt(nameA[1]);
						if(typeof(myObj[nameA[0]][nameIndex]) == "undefined"){
							myObj[nameA[0]][nameIndex] = { };
						}
					}else if(typeof(myObj[nameA[0]]) == "undefined"){
						myObj[nameA[0]] = { }
					} // if

					if(nameA.length == 1){
						myObj=myObj[nameA[0]];
					}else{
						myObj=myObj[nameA[0]][nameIndex];
					} // if
				} // for

				if((elm.type != "select-multiple" && elm.type != "checkbox" && elm.type != "radio") || (elm.type == "radio" && elm.checked)){
					if(name == name.split("[")[0]){
						myObj[name]=elm.value;
					}else{
						// can not set value when there is no name
					}
				}else if(elm.type == "checkbox" && elm.checked){
					if(typeof(myObj[name]) == 'undefined'){
						myObj[name]=[ ];
					}
					myObj[name].push(elm.value);
				}else if(elm.type == "select-multiple"){
					if(typeof(myObj[name]) == 'undefined'){
						myObj[name]=[ ];
					}
					for(var jdx=0,len3=elm.options.length; jdx<len3; ++jdx){
						if(elm.options[jdx].selected){
							myObj[name].push(elm.options[jdx].value);
						}
					}
				} // if
				name=undefined;
			}); // forEach
			***/
			return obj;
		},

		isValid: function(){
			// summary:
			//		Returns true if all of the widgets are valid.
			//		Deprecated, will be removed in 2.0.  Use get("state") instead.

			return this.state == "";
		},

		onValidStateChange: function(/*Boolean*/ /*===== isValid =====*/){
			// summary:
			//		Stub function to connect to if you want to do something
			//		(like disable/enable a submit button) when the valid
			//		state changes on the form as a whole.
			//
			//		Deprecated.  Will be removed in 2.0.  Use watch("state", ...) instead.
		},

		_getState: function(){
			// summary:
			//		Compute what this.state should be based on state of children
			var states = array.map(this._descendants, function(w){
				return w.get("state") || "";
			});

			return array.indexOf(states, "Error") >= 0 ? "Error" :
				array.indexOf(states, "Incomplete") >= 0 ? "Incomplete" : "";
		},

		disconnectChildren: function(){
			// summary:
			//		Deprecated method.   Applications no longer need to call this.   Remove for 2.0.
		},

		connectChildren: function(/*Boolean*/ inStartup){
			// summary:
			//		You can call this function directly, ex. in the event that you
			//		programmatically add a widget to the form *after* the form has been
			//		initialized.

			// TODO: rename for 2.0

			this._descendants = this._getDescendantFormWidgets();

			// To get notifications from children they need to be started.   Children didn't used to need to be started,
			// so for back-compat, start them here
			array.forEach(this._descendants, function(child){
				if(!child._started){ child.startup(); }
			});

			if(!inStartup){
				this._onChildChange();
			}
		},

		_onChildChange: function(/*String*/ attr){
			// summary:
			//		Called when child's value or disabled state changes

			// The unit tests expect state update to be synchronous, so update it immediately.
			if(!attr || attr == "state" || attr == "disabled"){
				this._set("state", this._getState());
			}

			// Use defer() to collapse value changes in multiple children into a single
			// update to my value.   Multiple updates will occur on:
			//	1. Form.set()
			//	2. Form.reset()
			//	3. user selecting a radio button (which will de-select another radio button,
			//		 causing two onChange events)
			if(!attr || attr == "value" || attr == "disabled" || attr == "checked"){
				if(this._onChangeDelayTimer){
					this._onChangeDelayTimer.remove();
				}
				this._onChangeDelayTimer = this.defer(function(){
					delete this._onChangeDelayTimer;
					this._set("value", this.get("value"));
				}, 10);
			}
		},

		startup: function(){
			this.inherited(arguments);

			// Set initial this.value and this.state.   Don't emit watch() notifications.
			this._descendants = this._getDescendantFormWidgets();
			this.value = this.get("value");
			this.state = this._getState();

			// Initialize value and valid/invalid state tracking.
			var self = this;
			this.own(
				on(
					this.containerNode,
					"attrmodified-state, attrmodified-disabled, attrmodified-value, attrmodified-checked",
					function(evt){
						if(evt.target == self.domNode){
							return;	// ignore events that I fire on myself because my children changed
						}
						self._onChildChange(evt.type.replace("attrmodified-", ""));
					}
				)
			);

			// Make state change call onValidStateChange(), will be removed in 2.0
			this.watch("state", function(attr, oldVal, newVal){ this.onValidStateChange(newVal == ""); });
		},

		destroy: function(){
			this.inherited(arguments);
		}

	});
});

},
'dijit/_Templated':function(){
define([
	"./_WidgetBase",
	"./_TemplatedMixin",
	"./_WidgetsInTemplateMixin",
	"dojo/_base/array", // array.forEach
	"dojo/_base/declare", // declare
	"dojo/_base/lang", // lang.extend lang.isArray
	"dojo/_base/kernel" // kernel.deprecated
], function(_WidgetBase, _TemplatedMixin, _WidgetsInTemplateMixin, array, declare, lang, kernel){

	// module:
	//		dijit/_Templated

	// These arguments can be specified for widgets which are used in templates.
	// Since any widget can be specified as sub widgets in template, mix it
	// into the base widget class.  (This is a hack, but it's effective.)
	// Remove for 2.0.   Also, hide from API doc parser.
	lang.extend(_WidgetBase, /*===== {} || =====*/ {
		waiRole: "",
		waiState:""
	});

	return declare("dijit._Templated", [_TemplatedMixin, _WidgetsInTemplateMixin], {
		// summary:
		//		Deprecated mixin for widgets that are instantiated from a template.
		//		Widgets should use _TemplatedMixin plus if necessary _WidgetsInTemplateMixin instead.

		constructor: function(){
			kernel.deprecated(this.declaredClass + ": dijit._Templated deprecated, use dijit._TemplatedMixin and if necessary dijit._WidgetsInTemplateMixin", "", "2.0");
		},

		_processNode: function(baseNode, getAttrFunc){
			var ret = this.inherited(arguments);

			// Do deprecated waiRole and waiState
			var role = getAttrFunc(baseNode, "waiRole");
			if(role){
				baseNode.setAttribute("role", role);
			}
			var values = getAttrFunc(baseNode, "waiState");
			if(values){
				array.forEach(values.split(/\s*,\s*/), function(stateValue){
					if(stateValue.indexOf('-') != -1){
						var pair = stateValue.split('-');
						baseNode.setAttribute("aria-"+pair[0], pair[1]);
					}
				});
			}

			return ret;
		}
	});
});

},
'dijit/_WidgetsInTemplateMixin':function(){
define([
	"dojo/_base/array", // forEach()
	"dojo/aspect", // after()
	"dojo/_base/declare", // declare()
	"dojo/_base/lang",	// hitch()
	"dojo/parser" // parse()
], function(array, aspect, declare, lang, parser){

	// module:
	//		dijit/_WidgetsInTemplateMixin

	return declare("dijit._WidgetsInTemplateMixin", null, {
		// summary:
		//		Mixin to supplement _TemplatedMixin when template contains widgets

		// _earlyTemplatedStartup: Boolean
		//		A fallback to preserve the 1.0 - 1.3 behavior of children in
		//		templates having their startup called before the parent widget
		//		fires postCreate. Defaults to 'false', causing child widgets to
		//		have their .startup() called immediately before a parent widget
		//		.startup(), but always after the parent .postCreate(). Set to
		//		'true' to re-enable to previous, arguably broken, behavior.
		_earlyTemplatedStartup: false,

		// contextRequire: Function
		//		Used to provide a context require to the dojo/parser in order to be
		//		able to use relative MIDs (e.g. `./Widget`) in the widget's template.
		contextRequire: null,

		_beforeFillContent: function(){
			// Short circuit the parser when the template doesn't contain any widgets.  Note that checking against
			// this.templateString is insufficient because the data-dojo-type=... may appear through a substitution
			// variable, like in ConfirmDialog, where the widget is hidden inside of the ${!actionBarTemplate}.
			if(/dojoType|data-dojo-type/i.test(this.domNode.innerHTML)){
				// Before copying over content, instantiate widgets in template
				var node = this.domNode;

				if(this.containerNode && !this.searchContainerNode){
					// Tell parse call below not to look for widgets inside of this.containerNode
					this.containerNode.stopParser = true;
				}

				parser.parse(node, {
					noStart: !this._earlyTemplatedStartup,
					template: true,
					inherited: {dir: this.dir, lang: this.lang, textDir: this.textDir},
					propsThis: this,	// so data-dojo-props of widgets in the template can reference "this" to refer to me
					contextRequire: this.contextRequire,
					scope: "dojo"	// even in multi-version mode templates use dojoType/data-dojo-type
				}).then(lang.hitch(this, function(widgets){
					this._startupWidgets = widgets;

					// _WidgetBase::destroy() will destroy any supporting widgets under this.domNode.
					// If we wanted to, we could call this.own() on anything in this._startupWidgets that was moved outside
					// of this.domNode (like Dialog, which is moved to <body>).

					// Hook up attach points and events for nodes that were converted to widgets
					for(var i = 0; i < widgets.length; i++){
						this._processTemplateNode(widgets[i], function(n,p){
							// callback to get a property of a widget
							return n[p];
						}, function(widget, type, callback){
							// callback to do data-dojo-attach-event to a widget
							if(type in widget){
								// back-compat, remove for 2.0
								return widget.connect(widget, type, callback);
							}else{
								// 1.x may never hit this branch, but it's the default for 2.0
								return widget.on(type, callback, true);
							}
						});
					}

					// Cleanup flag set above, just in case
					if(this.containerNode && this.containerNode.stopParser){
						delete this.containerNode.stopParser;
					}
				}));

				if(!this._startupWidgets){
					throw new Error(this.declaredClass + ": parser returned unfilled promise (probably waiting for module auto-load), " +
						"unsupported by _WidgetsInTemplateMixin.   Must pre-load all supporting widgets before instantiation.");
				}
			}
		},

		_processTemplateNode: function(/*DOMNode|Widget*/ baseNode, getAttrFunc, attachFunc){
			// Override _AttachMixin._processNode to skip DOMNodes with data-dojo-type set.   They are handled separately
			// in the _beforeFillContent() code above.

			if(getAttrFunc(baseNode, "dojoType") || getAttrFunc(baseNode, "data-dojo-type")){
				return true;
			}

			return this.inherited(arguments);
		},

		startup: function(){
			array.forEach(this._startupWidgets, function(w){
				if(w && !w._started && w.startup){
					w.startup();
				}
			});
			this._startupWidgets = null;
			this.inherited(arguments);
		}
	});
});

},
'contactdetailspopup/Organisation':function(){
define([
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dojo/_base/xhr',
    'dojo/html',
    'dojo/on',
    'dojo/query',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/dom-style',
    'soso/dijit/TooltipDialog',
    'dijit/_WidgetBase',
    'dijit/_Templated'
], function(declare, lang, xhr, html, on, query, domAttr, domClass, domStyle,
            TooltipDialog, _WidgetBase, _Templated) {

    return declare('contactdetailspopup.Organisation', [_WidgetBase, _Templated], {
        templatePath: require.toUrl('contactdetailspopup/templates/Organisation.html'),

        popup: null,
        target: null,

        // Create the TooltipDialog
        postCreate: function(){
            this.inherited(arguments);
            this.popup =  new TooltipDialog({ id: this.id + '_popup' }, this.domNode);
            domClass.add(this.popup.domNode, 'contactsPopupWrapper');

            // Hide the TooltipDialog when it loses focus
            on(this.popup, 'blur', function(evt) {
                this.hide();
            });
        },

        // Add on click events for all links with "organisationpopup" class in queryNode to open populated TooltipDialog
        initialise: function(queryNode) {
            query('.organisationpopup', queryNode).on('click', lang.hitch(this, function(evt) {
                evt.preventDefault();
                var item = evt.currentTarget;
                var branchofficepk = domAttr.get(item, 'data-branchofficepk');
                if (!branchofficepk) {
                    branchofficepk = domAttr.get(item, 'branchofficepk');
                }

                this.loadDetails(branchofficepk, item);
            }));
        },

        // Fetch the branch office's details via xhr and pass results to TooltipDialog
        loadDetails: function(branchOfficePK, target) {
            this.target = target;
            this.branchOfficePK = branchOfficePK;
            xhr.get({
                url: baseUrl + '/api/?method=ContactsManager.getBranchOfficeDetails&branchOfficePK=' + branchOfficePK,
                handleAs: 'json',
                load: lang.hitch(this, 'getResponse'),
                error: function() {
                    alert('Error: Failed to update');
                }
            })
        },

        // Pass the reponse from the responseObject to the load function
        getResponse: function(responseObject) {
            response = responseObject.ContactsManager.getBranchOfficeDetails.response;
            this.load(response);
        },

        // Populate the template with branch office details from the xhr response
        load: function(response) {
            html.set(this.organisationName, response.Organisation);
            if (response.intranetOwner == 1) {
                domStyle.set(this.websiteRow, 'display', 'none');
            } else {
                domStyle.set(this.websiteRow, 'display', '');
                domAttr.set(this.website, 'innerHTML', response.website);
                domAttr.set(this.website, 'href', response.website);
            }
            html.set(this.branchOffice, response.name);
            html.set(this.address1, response.address1);
            html.set(this.address2, response.address2);
            html.set(this.address3, response.address3);
            html.set(this.town, response.town);
            html.set(this.postcode, response.postcode);
            html.set(this.telephone, response.telephone);
            html.set(this.fax, response.fax);
            html.set(
                this.email,
                '<a href="' + baseUrl + 'project-overview#email/compose/branchOfficePK/'
                            + parseInt(this.branchOfficePK) + '">Email Branch Office</a>'
            );
            html.set(
                this.emailNewWindow,
                '<a href="' + baseUrl + 'project-overview#email/compose/branchOfficePK/'
                            + parseInt(this.branchOfficePK) + '" target="_blank">(in a new window)</a>'
            );
            html.set(this.trades, response.trades);

            domAttr.set(
                this.docs,
                'href',
                baseUrl + 'doccontrol/?action=search&fromAutoFilter='
                        + encodeURIComponent(response.Organisation)
                        + '&matchAny=1&searchWithin=all&clearFilters=1&resetSearch=1'
            );

            // Display the Tooltip dialog around the clicked link
            this.popup.show({ popup: this.popup, around: this.target });
        }

    });
});

},
'contactdetailspopup/Email':function(){
define([
    'dojo/_base/lang',
    'dojo/_base/xhr',
    'dojo/query',
    'dojo/dom-attr',
    'dojo/dom-construct',
    'contactdetailspopup/Person',
    'contactdetailspopup/Organisation',
    'dojo/domReady!'
], function (lang, xhr, query, domAttr, domConstruct, personDetails, organisationDetails) {
    return {
        personDetails: null,
        organisationDetails: null,

        // Add on click events for all links with 'email contactPopup' classes in queryNode to open the populated TooltipDialog
        initialise: function(queryNode) {

            query('.email.contactPopup', queryNode).on('click', lang.hitch(this, function(evt) {
                evt.preventDefault();
                var emailAddress = evt.currentTarget.innerHTML;
                var target = evt.currentTarget;
                this.loadDetails(emailAddress, target);
            }));
        },

        // Fetch the person/branch-office details for the email address via xhr and pass results to TooltipDialog
        loadDetails: function(emailAddress, target) {
            xhr.get({
                url: baseUrl + '/api/?method=ContactsManager.getDetailsByEmail&email=' + emailAddress,
                handleAs: 'json',
                load: lang.hitch(this, function(results) {
                    details = results.ContactsManager.getDetailsByEmail.response
                    // check whether we need to show the personDetails popup or organisationDetails popup
                    if (details.personPK) {
                        this.getPersonDetailsPopup().target = target;
                        this.getPersonDetailsPopup().load(details);
                    } else if(details.branchOfficePK) {
                        this.getOrganisationDetailsPopup().target = target;
                        this.getOrganisationDetailsPopup().load(details);
                    } else {
                        alert("Couldn't fetch details");
                    }
                }),
                error: function() {
                    alert("Couldn't fetch details");
                }
            });
        },

        // Returns the personDetails popup (creating first it if necessary)
        getPersonDetailsPopup: function() {
            if (!this.personDetails) {
                var div = domConstruct.create('span', {}, this.domNode, 'after');
                this.personDetails = new personDetails({}, div);
            }
            return this.personDetails;
        },

        // Returns the organisationDetails popup (creating first it if necessary)
        getOrganisationDetailsPopup: function() {
            if (!this.organisationDetails) {
                var div = domConstruct.create('span', {}, this.domNode, 'after');
                this.organisationDetails = new organisationDetails({}, div);
            }
            return this.organisationDetails;
        }
    };
});

},
'contactdetailspopup/OrganisationPopup':function(){
define([
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dojo/_base/xhr',
    'dojo/html',
    'dojo/on',
    'dojo/query',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/dom-style',
    'soso/dijit/TooltipDialog',
    'dijit/_WidgetBase',
    'dijit/_Templated'
], function (declare,
             lang,
             xhr,
             html,
             on,
             query,
             domAttr,
             domClass,
             domStyle,
             TooltipDialog,
             _WidgetBase,
             _Templated) {
    return declare('organisationpopup.organisationPopup', [_WidgetBase, _Templated], {
        templatePath: require.toUrl('contactdetailspopup/templates/OrganisationPopup.html'),

        popup: null,
        target: null,

        // Create the TooltipDialog
        postCreate: function () {
            this.inherited(arguments);
            this.popup = new TooltipDialog({id: this.id + '_popup'}, this.domNode);
            domClass.add(this.popup.domNode, 'contactsPopupWrapper');

            // Hide the TooltipDialog when it loses focus
            on(this.popup, 'blur', function (evt) {
                this.hide();
            });
        },

        // Add on click events for all links with "organisation" class in queryNode to open populated TooltipDialog
        initialise: function (queryNode) {
            query('.organisation', queryNode).on('click', lang.hitch(this, function (evt) {
                evt.preventDefault();
                var item = evt.currentTarget;
                var organisationpk = domAttr.get(item, 'data-organisationpopup-pk');
                if (!organisationpk) {
                    organisationpk = domAttr.get(item, 'organisationpopup-pk');
                }

                this.loadDetails(organisationpk, item);
            }));
        },

        // Fetch the Subcontractor details via xhr and pass results to TooltipDialog
        loadDetails: function (organisationPK, target) {
            this.target = target;
            this.organisationPK = organisationPK;

            xhr.get({
                url: baseUrl + '/api/?method=ContactsManager.getOrganisationDetails&organisationPK=' + organisationPK,
                handleAs: 'json',
                load: lang.hitch(this, 'getResponse'),
                error: function () {
                    alert('Error: Failed to update');
                }
            })
        },

        // Pass the response from the responseObject to the load function
        getResponse: function (responseObject) {
            response = responseObject.ContactsManager.getOrganisationDetails.response;
            this.load(response);
        },

        // Populate the template with each organisations details from the xhr response
        load: function (response) {
            html.set(this.subcontractorName, response.organisation.fullName);
            html.set(this.address1, response.headOffice.address1);
            html.set(this.address2, response.headOffice.address2);
            html.set(this.address3, response.headOffice.address3);
            html.set(this.town, response.headOffice.town);
            html.set(this.postcode, response.headOffice.postcode);
            html.set(this.telephone, response.headOffice.telephone);
            html.set(this.fax, response.headOffice.fax);

            if (response.intranetOwner == 1) {
                domStyle.set(this.websiteRow, 'display', 'none');
            } else {
                domStyle.set(this.websiteRow, 'display', '');
                domAttr.set(this.website, 'innerHTML', response.organisation.website);
                domAttr.set(this.website, 'href', response.organisation.website);
            }

            domAttr.set(
                this.docs,
                'href',
                baseUrl + 'project-overview#super-search/organisation/'
                + response.organisation.organisationPK
            );

            // Display the Tooltip dialog around the clicked link
            this.popup.show({popup: this.popup, around: this.target});
        }

    });
});

},
'doccontrol/viewer/Initialiser':function(){
define([
    './Topics',
    './TopicSubscriber',
    './config/Viewer',
    './dojo/Container',
    './dojo/InitialisingScreen',
    './model/Factory',
    './model/Viewer',
    './model/Annotation',
    './model/Information',
    './observable/Container',
    './state-machine/Factory',
    './state-machine/States',
    './socket/Subscriber',
    'api/doccontrol/Config',
    'api/doccontrol/Factory',
    'api/doccontrol/template/Config',
    'api/doccontrol/template/Factory',
    'api/file/Downloader',
    'api/file/parser/blob/ToDataUrl',
    'api/file-tray/Config',
    'api/file-tray/Factory',
    'doccontrol/viewer/data-manager/Factory',
    'dojo/_base/lang',
    'dojo/topic',
    'library/DojoObservableWrapper',
    'library/DojoTopicWrapper',
    'library/PromiseFactory',
    'library/request/data/Handlers',
    'library/request/dojo/URLConnectionProcessorBuilder',
    'library/request/helper/DefaultUnauthorisedCallback',
    'library/request/URLConnectionBuilder',
    'library/request/URLResponseProcessorBuilder',
    '@lib/request/socket/Socket',
    'library/request/socket/adapter/SocketIOSingleton',
    'pdf/Retriever',
    'spencer/data-manager/core/request/ActionContainer',
    'spencer/data-manager/core/request/URLConfig',
    'spencer/data-manager/core/request/URLParams',
    'spencer/data-manager/request/Container',
    'spencer/data-manager/request/URLConnectionBuilderFactory',
    'spencer/doc-control/data/Revision',
    'spencer/utility/Binder'
], function(
    Topics,
    TopicSubscriber,
    ViewerConfig,
    DojoContainer,
    InitialisingScreen,
    ModelFactory,
    ViewerModel,
    AnnotationModel,
    InformationModel,
    ContainerObservable,
    StateMachineFactory,
    STATES,
    SocketSubscriber,
    DocControlConfig,
    DocControlFactory,
    TemplateConfig,
    TemplateFactory,
    FileDownloader,
    BlobToDataUrlParser,
    FileTrayConfig,
    FileTrayFactory,
    DataManagerFactory,
    lang,
    topic,
    DojoObservableWrapper,
    DojoTopicWrapper,
    PromiseFactory,
    HandlersVO,
    URLConnectionProcessorBuilder,
    DefaultUnauthorisedCallback,
    URLConnectionBuilder,
    URLResponseProcessorBuilder,
    Socket,
    SocketAdapterSingleton,
    PdfRetriever,
    CoreActionContainer,
    CORE_URL_CONFIG,
    CORE_URL_PARAMS,
    RequestContainer,
    URLConnectionBuilderFactory,
    RevisionVO,
    Binder
) {
    return {
        revisionPK: null,
        personPK: null,
        temporaryDocumentPK: null,
        href: null,
        fileType: null,
        isRegistered: null,
        md5: null,
        documentCollection: [],
        activeIndex: null,
        keywordSearch: null,
        openInformation: false,
        expandInformationPane: null,
        inline: false,
        screenWidthPercentage: null,
        revisionSideBar: false,
        standalone: false,
        initialisingScreen: null,

        initialised: false,

        viewerConfig: null,
        docControlFactory: null,
        fileTrayFactory: null,
        annotationModel: null,
        informationModel: null,
        routeContainer: null,
        viewerModel: null,
        pdfRetriever: null,
        topicSubscriber: null,
        socketSubscriber: null,

        mediaTypes: [
            'video',
            'audio'
        ],

        constants: {
            FILE_TYPE_CORRESPONDENCE: 'message/rfc822'
        },

        initDataManager: async function () {
            const promiseFactory = new PromiseFactory();
            const urlConnectionBuilderFactory = new URLConnectionBuilderFactory();
            const requestContainer = new RequestContainer();

            requestContainer.addActionContainer(
                new CoreActionContainer(
                    promiseFactory,
                    urlConnectionBuilderFactory,
                    CORE_URL_CONFIG,
                    CORE_URL_PARAMS
                )
            );

            this.modelDataManager = new DataManagerFactory(
                requestContainer
            ).get();

            this.modelDataManager.startUp();
        },

        setRevisionPK: function(revisionPK) {
            this.revisionPK = revisionPK;

            if (revisionPK) {
                this.setHref(this.routeContainer.get('downloadRevision', {id: revisionPK}));

                this.temporaryDocumentPK = null;
                this.isRegistered = true;
                this.activeIndex = null;
                this.documentCollection = [];
            }

            return this;
        },

        setTemporaryDocumentPK: function(temporaryDocumentPK) {
            this.temporaryDocumentPK = temporaryDocumentPK;

            if (temporaryDocumentPK) {
                this.setHref(this.routeContainer.get('downloadTemporaryDocument', {id: temporaryDocumentPK}));

                this.revisionPK = null;
                this.isRegistered = false;
                this.activeIndex = null;
                this.documentCollection = [];
            }

            return this;
        },

        setHref: function(href) {
            this.href = href;
            return this;
        },

        setFileType: function(fileType) {
            this.fileType = (typeof fileType === 'string') ? fileType.toLowerCase() : fileType;
            return this;
        },

        setDocumentCollection: function(documentCollection) {
            this.documentCollection = documentCollection;
            return this;
        },

        setActiveIndex: function(index) {
            this.activeIndex = index;
            return this;
        },

        setRouteContainer: function (routeContainer) {
            this.routeContainer = routeContainer;
            return this;
        },

        setMd5: function(md5) {
            this.md5 = md5;

            if (md5) {
                this.href = null;
                this.revisionPK = null;
                this.temporaryDocumentPK = null;
                this.activeIndex = null;
                this.documentCollection = [];
            }

            return this;
        },

        setIsRegistered: function(isRegistered) {
            this.isRegistered = isRegistered;
            return this;
        },

        setKeywordSearch: function(keywordSearch) {
            this.keywordSearch = keywordSearch;
            return this;
        },

        setPreviousDocumentHandler: function(previousDocumentHandler) {
            this._previousDocumentHandler = previousDocumentHandler;
        },

        setNextDocumentHandler: function(nextDocumentHandler) {
            this._nextDocumentHandler = nextDocumentHandler;
        },

        setExpandInformationPane: function(expandInformationPane) {
            this.expandInformationPane = expandInformationPane;
        },

        initInformation: function() {
            this.openInformation = true;
        },

        initDefault: function() {
            this.openInformation = false;
            this.inline = false;
            this.screenWidthPercentage = null;
            this.revisionSideBar = false;
        },

        initInline: function() {
            this.inline = true;
        },

        initRevisionSidebar: function() {
            this.revisionSideBar = true;
            return this;
        },

        initStandalone: function() {
            this.standalone = true;
            return this;
        },

        navigatePrevious: function() {
            if (this.activeIndex > 0) {
                this.activeIndex--;
                this.execute();
                this._previousDocumentHandler(this.documentCollection[this.activeIndex]);
            }
        },

        navigateNext: function() {
            if (this.activeIndex < this.documentCollection.length - 1) {
                this.activeIndex++;
                this.execute();
                this._nextDocumentHandler(this.documentCollection[this.activeIndex]);
            }
        },

        initViewer: function() {
            if (this.initialised === false) {
                this._initViewerConfig();
                this._updateViewerConfig();

                this.initStateMachine();
                this._createTopicSubscriber();
                this._createSocketSubscriber();
                this._initObservers();

                this.initialised = true;
            }
        },

        initStateMachine: function() {
            this.containerWidget = new DojoContainer(this.routeContainer, this.modelDataManager);

            this.containerObservable = new ContainerObservable(new DojoObservableWrapper());

            const stateMachineFactory = new StateMachineFactory(
                this.containerWidget,
                this.viewerModel,
                this.annotationModel,
                this.informationModel
            );

            this.stateMachine = stateMachineFactory.getStateMachine();
        },

        _initModels: function() {
            this._buildWebSocketHandler();
            this._createAnnotationModel();
            this._createFileTrayFactory();
            this._createDocControlFactory();
            this._initViewerModel();
            this._initInformationModel();
        },

        _initObservers: function() {
            this.containerObservable.get('page-data').addObserver(lang.hitch(this, function(name, oldPage, newPage) {
                this.containerWidget.get('annotation-workspace').updateCanvas(newPage.pageNum, newPage.scale, newPage.rotation, newPage.height, newPage.width);

                if (oldPage && oldPage.pageNum !== newPage.pageNum) {
                    this.containerWidget.get('view-annotation-pin-sidebar').hide();
                }
            }));

            this.containerObservable.get('connected-users').addObserver(lang.hitch(this, function(name, oldValue, newValue) {
                this.containerWidget.get('view-annotation-toolbar').setConnectedUsers(newValue);
            }));
        },

        showInitialiser: function(onCancel) {
            this._initInitialisingScreen(onCancel);
        },

        execute: function() {
            this._initInitialisingScreen();

            this._initModels();
            this.viewerModel.cancelAllRequests();
            this.initDataManager();

            if (this.documentCollection.length && this.activeIndex !== null) {
                const activeDocument = this.documentCollection[this.activeIndex];

                if (activeDocument.getRevisionPK()) {
                    this._fetchMetaDataByRevisionPK(activeDocument.getRevisionPK());
                } else if (activeDocument.getMd5()) {
                    this._fetchMetaDataByMd5(activeDocument.getMd5());
                }
                return;
            }

            if (!this._containsMetaData() && this.md5) {
                this._fetchMetaDataByMd5(this.md5);
                return;
            }

            this.initViewer();
            this._publishTopics();
            this._hideInitialisingScreen();
        },

        hide: function() {
            this._hideInitialisingScreen();

            topic.publish(Topics.DOCUMENT_VIEWER_HIDE);
        },

        _publishTopics: function() {
            topic.publish(Topics.DOCUMENT_VIEWER_HIDE);
            this._updateViewerConfig();

            if (this._isMedia(this.fileType)) {
                topic.publish(Topics.MEDIA_VIEWER_SHOW, {
                    fileType: this.fileType,
                    href: this.href,
                    revisionPK: this.revisionPK,
                    md5: this.md5,
                    temporaryDocumentPK: this.temporaryDocumentPK,
                    isRegistered: this.isRegistered,
                    previousDocument: this._getPreviousDocument(),
                    nextDocument: this._getNextDocument()
                });
            } else if (this._isCorrespondence(this.fileType)) {
                topic.publish(Topics.CORRESPONDENCE_VIEWER_SHOW, {
                    fileType: this.fileType,
                    href: this.href,
                    revisionPK: this.revisionPK,
                    md5: this.md5,
                    temporaryDocumentPK: this.temporaryDocumentPK,
                    isRegistered: this.isRegistered,
                    previousDocument: this._getPreviousDocument(),
                    nextDocument: this._getNextDocument(),
                    keywordSearch: this.keywordSearch
                });
            } else {
                this.openSocketConnection();

                topic.publish(Topics.DOCUMENT_VIEWER_SHOW, {
                    fileType: this.fileType,
                    href: this.href,
                    revisionPK: this.revisionPK,
                    personPK: this.personPK,
                    md5: this.md5,
                    temporaryDocumentPK: this.temporaryDocumentPK,
                    isRegistered: this.isRegistered,
                    previousDocument: this._getPreviousDocument(),
                    nextDocument: this._getNextDocument()
                });
            }

            if (this.openInformation) {
                topic.publish(Topics.DOCUMENT_VIEWER_TOGGLE_INFORMATION);
                this.openInformation = false;
            }

            if (this.expandInformationPane) {
                topic.publish(Topics.DOCUMENT_VIEWER_EXPAND_INFORMATION_PANE, this.expandInformationPane);
                this.expandInformationPane = null;
            }

            if (this.inline) {
                topic.publish(Topics.DOCUMENT_VIEWER_ENABLE_INLINE);
                this.inline = false;
            }

            if (this.standalone) {
                topic.publish(Topics.DOCUMENT_VIEWER_ENABLE_STANDALONE);
            }

            if (this.screenWidthPercentage) {
                topic.publish(Topics.DOCUMENT_VIEWER_SET_INLINE_WIDTH, this.screenWidthPercentage);
            }

            if (this.revisionSideBar) {
                topic.publish(Topics.DOCUMENT_VIEWER_ENABLE_REVISION_SIDEBAR);
                this.revisionSideBar = false;
            }
        },

        _initInitialisingScreen: function(onCancel) {
            this._hideInitialisingScreen();

            if (this.standalone) return;

            this._initModels();
            this.initialisingScreen = new InitialisingScreen(
                () => {
                    this.viewerModel.cancelAllRequests();
                    this._hideInitialisingScreen();

                    if (onCancel) onCancel();
                },
                this.inline,
                this.screenWidthPercentage
            );
        },

        _hideInitialisingScreen: function() {
            if (!this.initialisingScreen) return;

            this.initialisingScreen.destroy();
            this.initialisingScreen = null;
        },

        setWidth(percentage) {
            this.screenWidthPercentage = percentage;
            topic.publish(Topics.DOCUMENT_VIEWER_SET_INLINE_WIDTH, percentage);
        },

        unsetWidth() {
            this.screenWidthPercentage = null;
            topic.publish(Topics.DOCUMENT_VIEWER_UNSET_INLINE_WIDTH);
        },

        _getPreviousDocument: function() {
            if (this.activeIndex > 0) {
                return this.documentCollection[this.activeIndex - 1];
            }
            return null;
        },

        _getNextDocument: function() {
            if (this.activeIndex < this.documentCollection.length - 1) {
                return this.documentCollection[this.activeIndex + 1]
            }
            return null;
        },

        _containsMetaData: function() {
            return (this.temporaryDocumentPK || this.revisionPK || (this.md5 && this.isRegistered !== null))
                && this.fileType && this.href;
        },

        _fetchMetaDataByMd5: function(md5) {
            this.viewerModel.getDocumentDetails(
                new HandlersVO(
                    function(details) {
                        if(details.getDocumentType() === 'Revision') {
                            this.isRegistered = true;
                            this.revisionPK = details.getId();
                            this.temporaryDocumentPK = null;
                            this.setHref(this.routeContainer.get('downloadRevision', {id: this.revisionPK}));
                        } else {
                            this.isRegistered = false;
                            this.temporaryDocumentPK = details.getId();
                            this.revisionPK = null;
                            this.setHref(this.routeContainer.get('downloadTemporaryDocument', {id: this.temporaryDocumentPK}));
                        }
                        this.setFileType(details.getFileType());
                        this.initViewer();
                        this._publishTopics();
                        this._hideInitialisingScreen();
                    }.bind(this),
                    function(result) {},
                    DefaultUnauthorisedCallback,
                    function(result) {},
                    function(result) {}
                ), md5
            )
        },

        _fetchMetaDataByRevisionPK: function(revisionPK) {
            this.viewerModel.getRevision(new HandlersVO(
                function(revision) {
                    this.isRegistered = true;
                    this.revisionPK = revision.getRevisionPK();
                    this.temporaryDocumentPK = null;
                    this.setFileType(revision.getFileType());
                    this.setHref(this.routeContainer.get('downloadRevision', {id: this.revisionPK}));
                    this.initViewer();
                    this._publishTopics();
                    this._hideInitialisingScreen();
                }.bind(this),
                function(result) {},
                DefaultUnauthorisedCallback,
                function(error, message) {},
                function(result) {}
            ), (new RevisionVO()).setRevisionPK(revisionPK));
        },

        _createAnnotationModel: function() {
            if (!this.annotationModel) {
                const modelFactory = new ModelFactory();
                this.annotationModel = new AnnotationModel(
                    this.socket,
                    modelFactory.getAnnotationGenerator(),
                    modelFactory.getPrintableAnnotationGenerator(),
                    modelFactory.getAnnotatedTemporaryDocumentCreator()
                );
            }
        },

        _createDocControlFactory: function() {
            if (!this.docControlFactory) {
                this.docControlFactory = new DocControlFactory(
                    new DocControlConfig(),
                    new URLConnectionBuilder(
                        new URLConnectionProcessorBuilder()
                    ),
                    new URLResponseProcessorBuilder()
                );
            }
        },

        _createFileTrayFactory: function() {
            if (!this.fileTrayFactory) {
                this.fileTrayFactory = new FileTrayFactory(
                    new FileTrayConfig(),
                    new URLConnectionBuilder(
                        new URLConnectionProcessorBuilder()
                    ),
                    new URLResponseProcessorBuilder()
                );
            }
        },

        _initViewerConfig: function() {
            if (!this.viewerConfig) {
                this.viewerConfig = new ViewerConfig();
            }
        },

        _initViewerModel: function() {
            if (!this.viewerModel) {
                this.viewerModel = new ViewerModel(
                    this.docControlFactory,
                    new PdfRetriever(),
                    this._buildFileDownloader(),
                    this._buildMetaDataCollection()
                );
            }
        },

        _initInformationModel: function() {
            if (!this.informationModel) {
                this.informationModel = new InformationModel(new DojoTopicWrapper());
            }
        },

        _buildFileDownloader: function() {
            return new FileDownloader(
                new URLConnectionBuilder(new URLConnectionProcessorBuilder()),
                new BlobToDataUrlParser(new FileReader())
            );
        },

        _buildMetaDataCollection: function() {
            const templateFactory = new TemplateFactory(
                new TemplateConfig(),
                new URLConnectionBuilder(
                    new URLConnectionProcessorBuilder()
                ),
                new URLResponseProcessorBuilder()
            );

            return templateFactory.getRevisionMetaData();
        },

        _buildWebSocketHandler: function() {
            if (!this.socket) {
                this.socket = new Socket(SocketAdapterSingleton.getInstance(dojoConfig.socketUrl));
            }
        },

        _createSocketSubscriber: function() {
            this.socketSubscriber = new SocketSubscriber(
                this.socket,
                topic,
                new Binder(),
                lang.mixin
            );
        },

        _createTopicSubscriber: function() {
            this.topicSubscriber = new TopicSubscriber(
                new DojoTopicWrapper(),
                this,
                this.viewerModel,
                this.annotationModel,
                this.containerWidget,
                this.containerObservable,
                new Binder(),
                this.stateMachine,
                this.routeContainer,
                dojoConfig.user,
                this.fileTrayFactory.getItem()
            );

            this.topicSubscriber.startup();
        },

        openSocketConnection: async function() {
            try {
                await this.socket.open();
                this.socketSubscriber.startup();
                topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_CONNECTED);
            } catch (e) {
                topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_CONNECT_ERROR);
            }
        },

        _isMedia: function(type) {
            return this.mediaTypes.some(function(v) { return type.indexOf(v) >= 0; });
        },

        _isCorrespondence: function(type) {
            return type === this.constants.FILE_TYPE_CORRESPONDENCE;
        },

        _updateViewerConfig: function() {
            if (this._isMedia(this.fileType)) {
                this.viewerConfig.setViewerViewState(STATES.MEDIA_VIEW);
            } else if (this._isCorrespondence(this.fileType)) {
                this.viewerConfig.setViewerViewState(STATES.CORRESPONDENCE_VIEW);
            } else {
                this.viewerConfig.setViewerViewState(STATES.VIEW);
            }
        },

        _previousDocumentHandler: function() {},

        _nextDocumentHandler: function() {}
    };
});
},
'doccontrol/viewer/Topics':function(){
define([], function() {
    return {
        CORRESPONDENCE_VIEWER_SHOW: '/correspondence/viewer/show',
        DOCUMENT_VIEWER_ADD_TO_BASKET: '/document/viewer/add/to/basket',
        DOCUMENT_VIEWER_ANNOTATION_CHANGE_COLOUR: '/document/viewer/annotation/tool/color/change',
        DOCUMENT_VIEWER_ANNOTATION_CHANGE_COLOUR_FILL: '/document/viewer/annotation/tool/color-fill/change',
        DOCUMENT_VIEWER_ANNOTATION_CHANGE_LINE_STYLE: '/document/viewer/annotation/tool/line-style/change',
        DOCUMENT_VIEWER_ANNOTATION_CHANGE_LINE_WIDTH: '/document/viewer/annotation/tool/line-width/change',
        DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DELETE_SELECTION: '/document/viewer/annotation/tool/click/delete/selection',
        DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_CLEAR_ALL: '/document/viewer/annotation/tool/click/clear/all',
        DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_SHOW_USERS: '/document/viewer/annotation/tool/click/show/users',
        DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAG_MODE: '/document/viewer/annotation/tool/click/drag',
        DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_FREE: '/document/viewer/annotation/tool/click/draw/free',
        DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_HIGHLIGHT: '/document/viewer/annotation/tool/click/draw/highlight',
        DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_LINE: '/document/viewer/annotation/tool/click/draw/line',
        DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_ELLIPSE: '/document/viewer/annotation/tool/click/draw/ellipse',
        DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_RECTANGLE: '/document/viewer/annotation/tool/click/draw/rectangle',
        DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_HEXAGON: '/document/viewer/annotation/tool/click/draw/haxgon',
        DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_POLYGON: '/document/viewer/annotation/tool/click/draw/polygon',
        DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_HIGHLIGHT_REGION: '/document/viewer/annotation/tool/click/draw/highlight/region',
        DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_ARROW: '/document/viewer/annotation/tool/click/draw/arrow',
        DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_TEXT: '/document/viewer/annotation/tool/click/draw/text',
        DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_TEXT_COMPLETE: '/document/viewer/annotation/tool/click/draw/text/complete',
        DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_PIN: '/document/viewer/annotation/tool/click/pin',
        DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_SELECT_MODE: '/document/viewer/annotation/tool/click/select',
        DOCUMENT_VIEWER_ANNOTATION_TOOL_APPLY_IMAGE_FILE: '/document/viewer/annotation/tool/upload/image',
        DOCUMENT_VIEWER_ANNOTATION_TOOL_APPLY_IMAGE_URL: '/document/viewer/annotation/tool/url/image',
        DOCUMENT_VIEWER_ANNOTATION_TOOL_PIN_SELECTED: '/document/viewer/annotation/tool/pin/selected',
        DOCUMENT_VIEWER_ANNOTATION_TOOL_PIN_DESELECTED: '/document/viewer/annotation/tool/pin/deselected',
        DOCUMENT_VIEWER_ANNOTATION_PIN_UPDATED: '/document/viewer/annotation/pin/updated',
        DOCUMENT_VIEWER_ANNOTATION_PIN_DELETED: '/document/viewer/annotation/pin/deleted',
        DOCUMENT_VIEWER_ANNOTATION_TOOL_PIN_SIDEBAR_CLOSE: '/document/viewer/annotation/tool/pin/sidebar/close',
        DOCUMENT_VIEWER_ANNOTATION_SOCKET_DISCONNECTED: '/document/annotation/socket/disconnected',
        DOCUMENT_VIEWER_ANNOTATION_SOCKET_CONNECTED: '/document/annotation/socket/connected',
        DOCUMENT_VIEWER_ANNOTATION_SOCKET_CONNECT: '/document/annotation/socket/connect',
        DOCUMENT_VIEWER_ANNOTATION_SOCKET_CONNECT_ERROR: '/document/annotation/socket/connect/error',
        DOCUMENT_VIEWER_ANNOTATION_SOCKET_SET_ID: '/document/annotation/socket/set/id',
        DOCUMENT_VIEWER_ANNOTATION_SOCKET_SEND: '/document/annotation/socket/send',
        DOCUMENT_VIEWER_ANNOTATION_SOCKET_MODIFIED: '/document/annotation/socket/modified',
        DOCUMENT_VIEWER_ANNOTATION_SOCKET_DELETED: '/document/annotation/socket/deleted',
        DOCUMENT_VIEWER_ANNOTATION_SOCKET_CLEARED: '/document/annotation/socket/cleared',
        DOCUMENT_VIEWER_ANNOTATION_SOCKET_RECEIVED: '/document/annotation/socket/received',
        DOCUMENT_VIEWER_ANNOTATION_INITIAL_SOCKET_RECEIVED: '/document/annotation/socket/received/initial',
        DOCUMENT_VIEWER_ANNOTATION_SOCKET_RECEIVED_MODIFIED: '/document/annotation/socket/received/modified',
        DOCUMENT_VIEWER_ANNOTATION_SOCKET_RECEIVED_DELETED: '/document/annotation/socket/received/deleted',
        DOCUMENT_VIEWER_ANNOTATION_SOCKET_RECEIVED_CLEARED: '/document/annotation/socket/received/cleared',
        DOCUMENT_VIEWER_ENABLE_TOOLBARS: '/document/viewer/toolbars/enable',
        DOCUMENT_VIEWER_ANNOTATION_SOCKET_USER_CONNECT: '/document/annotation/socket/connect/user',
        DOCUMENT_VIEWER_ANNOTATION_SOCKET_USER_DISCONNECT: '/document/annotation/socket/disconnect/user',
        DOCUMENT_VIEWER_ANNOTATION_USER_CHANGE_VISIBILITY: '/document/annotation/user/change/visibility',
        DOCUMENT_VIEWER_ANNOTATION_USER_REMOVE: '/document/annotation/user/remove',
        DOCUMENT_VIEWER_DOWNLOAD: '/document/viewer/download',
        DOCUMENT_VIEWER_DOWNLOAD_WITH_ANNOTATIONS: '/document/viewer/download/annotated',
        DOCUMENT_VIEWER_DOWNLOAD_WITH_ANNOTATIONS_IN_BROWSER: '/document/viewer/download/annotated/in/browser',
        DOCUMENT_VIEWER_GENERATE_ANNOTATED_DOCUMENT_CANCEL: '/document/viewer/generate/annotated/document/cancel',
        DOCUMENT_VIEWER_FIT_PAGE: '/document/viewer/fit/page',
        DOCUMENT_VIEWER_FIT_WIDTH: '/document/viewer/fit/width',
        DOCUMENT_VIEWER_HIDE: '/document/viewer/hide',
        DOCUMENT_VIEWER_OCR: '/document/viewer/ocr',
        DOCUMENT_VIEWER_DISABLE_INFORMATION_DOWNLOAD: '/document/viewer/disableInformationDownload',
        DOCUMENT_VIEWER_DISABLE_VIEWER_TOOLBARS: '/document/viewer/disable/viewer/toolbars',
        DOCUMENT_VIEWER_ENABLE_DELETE_SELECTION: '/document/viewer/delete/selection/enable',
        DOCUMENT_VIEWER_DISABLE_DELETE_SELECTION: '/document/viewer/delete/selection/disable',
        DOCUMENT_VIEWER_TOGGLE_INFORMATION: '/document/viewer/information/toggle',
        DOCUMENT_VIEWER_EXPAND_INFORMATION_PANE: '/document/viewer/information/expand/pane',
        DOCUMENT_VIEWER_DISABLE_INLINE: '/document/viewer/inline/disable',
        DOCUMENT_VIEWER_ENABLE_STANDALONE: '/document/viewer/standalone/enable',
        DOCUMENT_VIEWER_ENABLE_INLINE: '/document/viewer/inline/enable',
        DOCUMENT_VIEWER_SET_INLINE_WIDTH: '/document/viewer/inline/width',
        DOCUMENT_VIEWER_UNSET_INLINE_WIDTH: '/document/viewer/inline/width/unset',
        DOCUMENT_VIEWER_ENABLE_REVISION_SIDEBAR: '/document/viewer/revision-sidebar/enable',
        DOCUMENT_VIEWER_SHOW_REVISION_SIDEBAR: '/document/viewer/revision-sidebar/show',
        DOCUMENT_VIEWER_HIDE_INFORMATION: '/document/viewer/information/hide',
        DOCUMENT_VIEWER_NAVIGATE_PREVIOUS: '/document/viewer/navigate/previous',
        DOCUMENT_VIEWER_NAVIGATE_NEXT: '/document/viewer/navigate/next',
        DOCUMENT_VIEWER_PAGE_DATA_CHANGE: '/document/viewer/page/data/change',
        DOCUMENT_VIEWER_RELOAD_DOCUMENT: '/document/viewer/reload/document',
        DOCUMENT_VIEWER_RELOAD_MEDIA: '/document/viewer/reload/media',
        DOCUMENT_VIEWER_ROTATE_CLOCKWISE: '/document/viewer/rotate/clockwise',
        DOCUMENT_VIEWER_SHARE_TO_EMAIL: '/document/viewer/share/to/email',
        DOCUMENT_VIEWER_SHARE_ANNOTATED_TO_EMAIL: '/document/viewer/share/annotated/to/email',
        DOCUMENT_VIEWER_REGISTER_ANNOTATED: '/document/viewer/register/annotated',
        DOCUMENT_VIEWER_REGISTER: '/document/viewer/register',
        DOCUMENT_VIEWER_REVISE_ANNOTATED: '/document/viewer/revise/annotated',
        DOCUMENT_VIEWER_SHOW: '/document/viewer/show',
        DOCUMENT_VIEWER_SHOW_ANNOTATION_OPTIONS: '/document/viewer/show/annotation/options',
        DOCUMENT_VIEWER_SHOW_OPTIONS: '/document/viewer/show/options',
        DOCUMENT_VIEWER_VIEW: '/document/viewer/view',
        DOCUMENT_VIEWER_VIEW_WITH_REVISION_HISTORY: '/document/viewer/view/revision-history',
        DOCUMENT_VIEWER_TITLE: '/document/viewer/title',
        DOCUMENT_VIEWER_ZOOM_IN: '/document/viewer/zoom/in',
        DOCUMENT_VIEWER_ZOOM_OUT: '/document/viewer/zoom/out',
        DOCUMENT_VIEWER_ZOOM_SPECIFIC: '/document/viewer/zoom/specific',
        DOCUMENT_VIEWER_ZOOM_VALUE: '/document/viewer/zoom/value',
        DOCUMENT_VIEWER_ANNOTATION_DRAG_ENABLED: '/document/viewer/annotation/drag/enabled',
        DOCUMENT_VIEWER_ANNOTATION_TOOLBAR_TOGGLE: '/document/viewer/annotation/toolbar/toggle',
        DOCUMENT_VIEWER_ANNOTATION_LOAD: '/document/viewer/annotation/load',
        DOCUMENT_VIEWER_ANNOTATION_LOADED: '/document/viewer/annotation/loaded',
        DOCUMENT_VIEWER_ANNOTATIONS_CHANGED: '/document/viewer/annotation/changed',
        DOCUMENT_VIEWER_EXISTING_ANNOTATIONS_ICON_SHOW: '/document/viewer/existing-annotations-icon/show',
        DOCUMENT_VIEWER_EXISTING_ANNOTATIONS_ICON_HIDE: '/document/viewer/existing-annotations-icon/hide',
        DOCUMENT_VIEWER_INFORMATION_NOTIFICATION_ICON_SHOW: '/document/viewer/information-notification-icon/show',
        MEDIA_VIEWER_SHOW: '/media/viewer/show'
    };
});
},
'doccontrol/viewer/TopicSubscriber':function(){
define([
    'api/doccontrol/data/Revision',
    'api/doccontrol/data/TemporaryDocument',
    './helper/PdfToBlob',
    './helper/ShareToEmail',
    'library/request/data/Handlers',
    'library/request/data/HTTPResponseCodes',
    'library/request/helper/DefaultUnauthorisedCallback',
    'pdf/request/data/Handlers',
    'style-guide/v1/file-tray/config/BroadcastChannel',
    './Topics',
    './state-machine/States',
    './parser/pins/Pin',
    './model/AnnotatedDocumentGenerator',
    './model/Register',
    './model/Revise'
], function(
    RevisionVO,
    TemporaryDocumentVO,
    PdfToBlob,
    ShareToEmail,
    HandlersVO,
    HTTPResponseCodes,
    DefaultUnauthorisedCallback,
    PdfHandlersVO,
    BroadcastChannelConfig,
    Topics,
    STATES,
    PinParser,
    AnnotatedDocumentGenerator,
    Register,
    Revise
) {
    const ADD_TO_BASKET_NOTIFICATION_UID = 'document-viewer-add-to-basket';
    const ADD_TO_BASKET_ALREADY_EXISTS_ERROR = 'item_already_exists';
    const ADD_TO_BASKET_DELETED_ERROR = 'file_deleted';

    const TopicSubscriber = function(
        topicWrapper,
        initialiser,
        viewerModel,
        annotationModel,
        containerWidget,
        containerObservable,
        binder,
        stateMachine,
        routeContainer,
        user,
        FileTrayItem
    ) {
        this.topicWrapper = topicWrapper;
        this.initialiser = initialiser;
        this.viewerModel = viewerModel;
        this.annotationModel = annotationModel;
        this.stateMachine = stateMachine;
        this.containerObservable = containerObservable;
        this.containerWidget = containerWidget;
        this.routeContainer = routeContainer;
        this.user = user;
        this.fileTrayItem = FileTrayItem;
        this.viewer = null;
        this.viewerToolbar = null;
        this.dialogToolbar = null;
        this.annotationsAllowed = false;

        this.pinParser = new PinParser();

        this.registerModel = new Register(
            this.containerWidget
        );

        this.reviseModel = new Revise(
            this.containerWidget
        );

        this.annotatedDocumentGenerator = new AnnotatedDocumentGenerator(
            this.containerWidget,
            this.viewerModel,
            this.annotationModel,
            this.routeContainer,
            this.registerModel,
            this.reviseModel,
            new ShareToEmail(this.routeContainer.get('shareToEmail'), window),
            this.topicWrapper,
            binder,
            window
        );

        this.annotationToolStates = [
            STATES.ANNOTATION_MODE_DRAG,
            STATES.ANNOTATION_MODE_FREEHAND,
            STATES.ANNOTATION_MODE_HIGHLIGHT,
            STATES.ANNOTATION_MODE_LINE,
            STATES.ANNOTATION_MODE_TEXT,
            STATES.ANNOTATION_MODE_SELECT,
            STATES.ANNOTATION_MODE_ELLIPSE,
            STATES.ANNOTATION_MODE_RECTANGLE,
            STATES.ANNOTATION_MODE_HEXAGON,
            STATES.ANNOTATION_MODE_HIGHLIGHT_REGION,
            STATES.ANNOTATION_MODE_ARROW,
            STATES.ANNOTATION_MODE_PIN
        ];

        this.getFile = function(annotationWorkspace, href, revisionVO) {
            const viewerWidget = this.viewer;
            const viewerModel = this.viewerModel;
            const annotationModel = this.annotationModel;
            const fileHandlers = new HandlersVO(
                function success(dataUrl) {
                    if (revisionVO) {
                        viewerModel.logView(revisionVO);
                    }

                    viewerWidget.setDataUrl(dataUrl);
                },
                function progress() {},
                function unauthorised() {
                    viewerWidget.showUnauthorisedMessage();
                    annotationModel.disconnect();
                },
                function error() {
                    viewerWidget.showErrorMessage();
                    annotationModel.disconnect();
                },
                function abort() {
                    viewerWidget.setReloadHref(href);
                    annotationModel.disconnect();
                }
            );
            fileHandlers.setGone(function() {
                viewerWidget.showDeletedMessage();
            });
            viewerModel.getFile(fileHandlers, href);
        };

        this.showViewOptionsToolbar = function() {
            if (this.viewerToolbar) {
                this.viewerToolbar.show();
            }
            if (this.viewer.showViewOptionsToolbar) {
                this.viewer.showViewOptionsToolbar();
            }
        };

        this.hideViewOptionsToolbar = function() {
            if (this.viewerToolbar) {
                this.viewerToolbar.hide();
            }
            if (this.viewer.hideViewOptionsToolbar) {
                this.viewer.hideViewOptionsToolbar();
            }
        };

        this.parsePageCollection = function(collection) {
            collection.forEach(function(page) {
                page.annotations.forEach(function(annotation) {
                    if (annotation.pin) {
                        annotation.pin = this.pinParser.parse(annotation.pin);
                    }
                }.bind(this));
            }.bind(this));
        };

        this.setAnnotationsDisabledInToolbar = function() {
            this.containerWidget.get('dialog-toolbar').setAnnotationsDisabled();
        };

        this.setAnnotationsEnabledInToolbar = function() {
            this.containerWidget.get('dialog-toolbar').setAnnotationsEnabled();
        };
    };

    TopicSubscriber.prototype.startup = function() {
        this.topicWrapper.subscribe(
            Topics.CORRESPONDENCE_VIEWER_SHOW,
            function(data) {
                const revisionVO = new RevisionVO();
                const temporaryDocumentVO = new TemporaryDocumentVO();

                if (data.isRegistered || data.revisionPK) {
                    revisionVO.setRevisionPK(data.revisionPK || null);
                    revisionVO.setMd5(data.md5 || null);
                } else {
                    temporaryDocumentVO.setTemporaryDocumentPK(data.temporaryDocumentPK || null);
                    temporaryDocumentVO.setMd5(data.md5 || null);
                }

                this.annotationsAllowed = false;

                this.stateMachine.correspondenceViewShow(data.fileType, data.href, revisionVO, temporaryDocumentVO, data.previousDocument, data.nextDocument);

                this.viewer = this.containerWidget.get('correspondence-view');
                this.viewer.setKeywordSearch(data.keywordSearch);

                this.dialogToolbar = this.containerWidget.get('dialog-toolbar');
                this.viewerToolbar =  null;
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ADD_TO_BASKET,
            (md5, title) => {
                this.topicWrapper.publish(
                    'sos-system-notification-progress',
                    `Adding '${title}' to basket...`,
                    ADD_TO_BASKET_NOTIFICATION_UID
                );

                const successMessage = () => {
                    this.topicWrapper.publish(
                        'sos-system-notification-progress-complete',
                        ADD_TO_BASKET_NOTIFICATION_UID,
                        `'${title}' has been added to basket.`,
                        'success',
                        5000
                    );
                };

                this.fileTrayItem.add(
                    new HandlersVO(
                        /*success*/() => {
                            successMessage();
                            const bc = new BroadcastChannel(BroadcastChannelConfig.CHANNEL.CURRENT);
                            bc.postMessage(BroadcastChannelConfig.MESSAGE.REFRESH);
                            bc.close();
                        },
                        /*progress*/() => {},
                        DefaultUnauthorisedCallback,
                        /*error*/(error) => {
                            if (error === ADD_TO_BASKET_ALREADY_EXISTS_ERROR) {
                                successMessage();
                                return;
                            }

                            if (error === ADD_TO_BASKET_DELETED_ERROR) {
                                this.topicWrapper.publish(
                                    'sos-system-notification-progress-complete',
                                    ADD_TO_BASKET_NOTIFICATION_UID,
                                    `We could not add '${title}' to your basket because it has been deleted for GDPR purposes.`,
                                    'error',
                                    5000
                                );
                            }

                            console.error(error);
                            this.topicWrapper.publish(
                                'sos-system-notification-progress-complete',
                                ADD_TO_BASKET_NOTIFICATION_UID,
                                `We could not add '${title}' to your basket at this time.<br />Please try again and if this problem persists contact support.`,
                                'error',
                                5000
                            );
                        }
                    ),
                    md5
                );
            }
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_CHANGE_COLOUR,
            function(color) {
                this.containerWidget.get('annotation-workspace').setAnnotationColor(color);
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_CHANGE_COLOUR_FILL,
            function(isFilled) {
                this.containerWidget.get('annotation-workspace').setAnnotationIsColorFilled(isFilled);
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_CHANGE_LINE_STYLE,
            (lineStyle) => {
                this.containerWidget.get('annotation-workspace').setLineStyle(lineStyle);
            }
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_CHANGE_LINE_WIDTH,
            function(width) {
                this.containerWidget.get('annotation-workspace').setLineWidth(width);
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_TEXT_COMPLETE,
            this.stateMachine.annotationModeTextEnable.bind(this.stateMachine)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_DRAG_ENABLED,
            function() {
                this.containerWidget.get('view').enableDragMode();
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_CLEAR_ALL,
            this.stateMachine.viewAnnotationOptionsShow.bind(this.stateMachine)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAG_MODE,
            this.stateMachine.annotationModeDragEnable.bind(this.stateMachine)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_FREE,
            this.stateMachine.annotationModeFreehandEnable.bind(this.stateMachine)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_HIGHLIGHT,
            this.stateMachine.annotationModeHighlightEnable.bind(this.stateMachine)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_LINE,
            this.stateMachine.annotationModeLineEnable.bind(this.stateMachine)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_SELECT_MODE,
            this.stateMachine.annotationModeSelectEnable.bind(this.stateMachine)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_ELLIPSE,
            this.stateMachine.annotationModeEllipseEnable.bind(this.stateMachine)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_RECTANGLE,
            this.stateMachine.annotationModeRectangleEnable.bind(this.stateMachine)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_HEXAGON,
            this.stateMachine.annotationModeHexagonEnable.bind(this.stateMachine)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_POLYGON,
            this.stateMachine.annotationModePolygonEnable.bind(this.stateMachine)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_HIGHLIGHT_REGION,
            this.stateMachine.annotationModeHighlightRegionEnable.bind(this.stateMachine)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_ARROW,
            this.stateMachine.annotationModeArrowEnable.bind(this.stateMachine)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_TEXT,
            this.stateMachine.annotationModeTextEnable.bind(this.stateMachine)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_APPLY_IMAGE_FILE,
            function(image) {
                this.containerWidget.get('annotation-workspace').applyImageFile(image);
                this.stateMachine.annotationModeSelectEnable();
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_APPLY_IMAGE_URL,
            function(imageUrl) {
                this.containerWidget.get('annotation-workspace').applyImageFromURL(imageUrl);
                this.stateMachine.annotationModeSelectEnable();
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_PIN,
            this.stateMachine.annotationModePinEnable.bind(this.stateMachine)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_PIN_SELECTED,
            function(pin) {
                this.containerWidget.get('view-annotation-pin-sidebar').show(pin);
            }.bind(this)
        );
        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_PIN_DESELECTED,
            function() {
                this.containerWidget.get('view-annotation-pin-sidebar').reset();
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_PIN_SIDEBAR_CLOSE,
            function() {
                this.containerWidget.get('annotation-workspace').deselectActivePin();
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATIONS_CHANGED,
            () => {
                if (this.reviseModel.isInProgress() || this.registerModel.isInProgress()) {
                    this.containerWidget.get('annotation-workspace').showAnnotationsHaveChangedMessage();
                }
            }
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_DOWNLOAD,
            function() {
                this.viewerModel.cancelGetDocument();
                this.viewer.showAbortMessage();
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_DOWNLOAD_WITH_ANNOTATIONS_IN_BROWSER,
            this.annotatedDocumentGenerator.view.bind(this.annotatedDocumentGenerator)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_DOWNLOAD_WITH_ANNOTATIONS,
            this.annotatedDocumentGenerator.download.bind(this.annotatedDocumentGenerator)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_GENERATE_ANNOTATED_DOCUMENT_CANCEL,
            function() {
                this.annotationModel.cancelRequests();
                this.containerWidget.get('view-annotation-toolbar').enableToolbar();
                this.containerWidget.get('annotation-workspace').hideGeneratingAnnotatedDocumentMessage();
                this.containerWidget.get('view').renderCurrentPage();
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_RELOAD_DOCUMENT,
            function(href, revisionVO) {
                this.initialiser.openSocketConnection();

                const viewer = this.containerWidget.get('view');
                const viewerModel = this.viewerModel;
                const annotationModel = this.annotationModel;

                viewer.startLongLoadMessageTimer();

                if (viewer.isImage()) {
                    this.getFile(this.containerWidget.get('annotation-workspace'), href, revisionVO);
                    return;
                }

                viewerModel.getPdf(
                    new PdfHandlersVO(
                        function success(pdf) {
                            if (revisionVO) {
                                viewerModel.logView(revisionVO);
                            }
                            viewer.setPdfDocument(pdf);
                        },
                        function error() {
                            viewer.showErrorMessage();
                            annotationModel.disconnect();
                        },
                        function unauthorised() {
                            viewer.showUnauthorisedMessage();
                            annotationModel.disconnect();
                        },
                        function abort() {
                            annotationModel.disconnect();
                        },
                        function password(updatePasswordCallback, reason) {
                            const prompt = viewerModel.constants.PASSWORD_RESPONSES[reason];
                            viewer.showPasswordForm(prompt).then(function(password) {
                                updatePasswordCallback(password);
                            });
                        },
                        function gone(error) {
                            viewer.showDeletedMessage();
                        }
                    ),
                    href
                );
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_RELOAD_MEDIA,
            function(href, revisionVO) {
                this.getFile(null, href, revisionVO);
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_VIEW,
            function(data) {
                this.topicWrapper.publish(Topics.DOCUMENT_VIEWER_HIDE);

                this.initialiser
                    .setRevisionPK(data.revisionPK || null)
                    .setTemporaryDocumentPK(data.temporaryDocumentPK || null)
                    .setIsRegistered(data.isRegistered || Boolean(data.revisionPK))
                    .setMd5(data.md5)
                    .setHref(data.href)
                    .setFileType(data.fileType)
                    .execute();
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_VIEW_WITH_REVISION_HISTORY,
            (data) => {
                this.topicWrapper.publish(Topics.DOCUMENT_VIEWER_HIDE);

                this.initialiser
                    .setRevisionPK(data.revisionPK || null)
                    .setIsRegistered(data.isRegistered || Boolean(data.revisionPK))
                    .setMd5(data.md5)
                    .setHref(data.href)
                    .setFileType(data.fileType)
                    .initRevisionSidebar()
                    .execute();
            }
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_TOGGLE_INFORMATION,
            function() {
                if (this.viewer.getInformation().isShowing()) {
                    this.dialogToolbar.unselectMenus();
                    this.viewer.getInformation().hide();
                    this.showViewOptionsToolbar();
                    return;
                }

                this.hideViewOptionsToolbar();

                if (this.annotationToolStates.indexOf(this.stateMachine.getCurrentState()) !== -1) {
                    this.stateMachine.viewAnnotationOptionsHide();
                }

                this.dialogToolbar.setInformationSelected();
                this.viewer.getInformation().show();
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_EXPAND_INFORMATION_PANE,
            pane => this.viewer.getInformation().expandPane(pane)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ENABLE_INLINE,
            () => this.viewer.showInline()
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_SET_INLINE_WIDTH,
            (percentage) => this.viewer.setWidth(percentage)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_UNSET_INLINE_WIDTH,
            () => this.viewer.unsetWidth()
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_DISABLE_INLINE,
            () => {
                this.containerWidget.get('annotation-workspace').hideAnnotationsHaveChangedMessage();
                this.viewer.hideInline()
            }
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ENABLE_STANDALONE,
            () => {
                this.viewer.enableStandalone();
            }
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ENABLE_REVISION_SIDEBAR,
            () => this.viewer.showRevisionSidebar()
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_SHOW_REVISION_SIDEBAR,
            (revisionCollection, currentRevision) => this.containerWidget.get('view-revision-history-sidebar', true)
                .setRevisionCollection(revisionCollection)
                .setCurrentRevision(currentRevision)
                .reload()
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_HIDE_INFORMATION,
            function() {
                if (this.viewer.getInformation().isShowing()) {
                    this.viewer.getInformation().hide();
                    this.showViewOptionsToolbar();
                }
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_NAVIGATE_PREVIOUS,
            this.initialiser.navigatePrevious.bind(this.initialiser)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_NAVIGATE_NEXT,
            this.initialiser.navigateNext.bind(this.initialiser)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_HIDE,
            function() {
                this.stateMachine.viewHide();
                this.annotationModel.cancelRequestsAndDisconnect();
                this.viewerModel.cancelAllRequests();
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_PAGE_DATA_CHANGE,
            function(pageData) {
                this.containerObservable.get('page-data').set(pageData);
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_EXISTING_ANNOTATIONS_ICON_SHOW,
            () => this.dialogToolbar.showExistingAnnotationsIcon()
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_EXISTING_ANNOTATIONS_ICON_HIDE,
            () => this.dialogToolbar.hideExistingAnnotationsIcon()
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_INFORMATION_NOTIFICATION_ICON_SHOW,
            function() {
                if (!this.dialogToolbar) {
                    return;
                }

                this.dialogToolbar.showInformationNotificationIcon();
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_SHARE_TO_EMAIL,
            function(documentReference) {
                new ShareToEmail(this.routeContainer.get('shareToEmail'), window).share(documentReference);
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_SHARE_ANNOTATED_TO_EMAIL,
            this.annotatedDocumentGenerator.email.bind(this.annotatedDocumentGenerator)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_REGISTER_ANNOTATED,
            this.annotatedDocumentGenerator.register.bind(this.annotatedDocumentGenerator)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_REGISTER,
            (data) => this.registerModel.start(data)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_REVISE_ANNOTATED,
            this.annotatedDocumentGenerator.revise.bind(this.annotatedDocumentGenerator)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_SHOW,
            function(data) {
                let revisionVO = null;
                let temporaryDocumentVO = null;

                if (data.revisionPK || data.isRegistered) {
                    revisionVO = new RevisionVO();
                    revisionVO.setRevisionPK(data.revisionPK);
                    revisionVO.setMd5(data.md5);
                } else {
                    temporaryDocumentVO = new TemporaryDocumentVO();
                    temporaryDocumentVO.setTemporaryDocumentPK(data.temporaryDocumentPK);
                    temporaryDocumentVO.setMd5(data.md5);
                }

                this.stateMachine.viewShow(data.fileType, data.href, revisionVO, temporaryDocumentVO, data.previousDocument, data.nextDocument);

                this.annotationsAllowed = true;
                this.viewer = this.containerWidget.get('view');

                this.dialogToolbar = this.containerWidget.get('dialog-toolbar');
                this.viewerToolbar = this.containerWidget.get('view-options-toolbar');
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_SHOW_ANNOTATION_OPTIONS,
            function(mode) {
                if (this.annotationToolStates.indexOf(this.stateMachine.getCurrentState()) !== -1) {
                    this.dialogToolbar.unselectMenus();
                    this.stateMachine.viewAnnotationOptionsHide();
                    this.setAnnotationsDisabledInToolbar();
                } else {
                    this.stateMachine.viewAnnotationOptionsShow(mode);
                    this.dialogToolbar.setAnnotationsSelected();
                    this.setAnnotationsEnabledInToolbar();
                }
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_DISABLE_INFORMATION_DOWNLOAD,
            function() {
                this.dialogToolbar.disableInformation()
                    .disableDownload();
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_DISABLE_VIEWER_TOOLBARS,
            function() {
                this.dialogToolbar.disableOcr();
                if (this.annotationsAllowed) {
                    this.dialogToolbar.disableAnnotationOptions();
                }

                this.hideViewOptionsToolbar();
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ENABLE_TOOLBARS,
            function() {
                this.dialogToolbar.enableOcr();
                if (this.annotationsAllowed) {
                    this.dialogToolbar.enableAnnotationOptions();
                }

                this.showViewOptionsToolbar();
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_USER_CHANGE_VISIBILITY,
            function(personPK, visible) {
                if (visible) {
                    this.containerWidget.get('annotation-workspace').showUserAnnotations(personPK);
                    this.containerWidget.get('view-annotation-toolbar').showUserAnnotations(personPK);
                } else {
                    this.containerWidget.get('annotation-workspace').hideUserAnnotations(personPK);
                    this.containerWidget.get('view-annotation-toolbar').hideUserAnnotations(personPK);
                }
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_USER_REMOVE,
            function(user) {
                this.containerWidget.get('view-annotation-toolbar').removeUser(user);
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.MEDIA_VIEWER_SHOW,
            function(data) {
                if (data.revisionPK || data.isRegistered) {
                    var revisionVO = new RevisionVO();
                    revisionVO.setRevisionPK(data.revisionPK);
                    revisionVO.setMd5(data.md5);
                } else {
                    var temporaryDocumentVO = new TemporaryDocumentVO();
                    temporaryDocumentVO.setTemporaryDocumentPK(data.temporaryDocumentPK);
                    temporaryDocumentVO.setMd5(data.md5);
                }

                this.stateMachine.mediaViewShow(data.fileType, data.href, revisionVO, temporaryDocumentVO, data.previousDocument, data.nextDocument);

                this.annotationsAllowed = false;
                this.viewer = this.containerWidget.get('media-view');
                this.dialogToolbar = this.containerWidget.get('dialog-toolbar');
                this.viewerToolbar = null;
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_CONNECT,
            async () => {
                try {
                    await this.annotationModel.connect();
                    this.topicWrapper.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_CONNECTED);
                } catch(e) {
                    this.topicWrapper.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_CONNECT_ERROR);
                }
            }
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_SET_ID,
            function(roomName) {
                this.annotationModel.joinRoom({
                    roomName: roomName,
                    client: {
                        personPK: this.user.getPerson().getPersonPK(),
                        displayName: this.user.getPerson().getDisplayName(),
                        username: this.user.getUsername(),
                        jobTitle: this.user.getPerson().getJobTitle(),
                        avatar: this.user.getProfilePictureURL()
                    }
                });
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_SEND,
            this.annotationModel.sendAnnotation.bind(this.annotationModel)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_RECEIVED,
            function(data) {
                if (data.annotation.pin) {
                    data.annotation.pin = this.pinParser.parse(data.annotation.pin);
                }
                this.containerWidget.get('annotation-workspace').applyAnnotationToPage(data.annotation, data.pageNumber);
                this.containerWidget.get('view-annotation-toolbar').addUser(data.annotation.user);
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_INITIAL_SOCKET_RECEIVED,
            function(data) {
                this.parsePageCollection(data.room.pageCollection);

                this.annotationModel.setConnectedUsers(data.clients);
                this.containerObservable.get('connected-users').set(this.annotationModel.getConnectedUsers());
                this.containerWidget.get('view-annotation-toolbar').setUsers(this.annotationModel.getUsersFromRoom(data.room));
                this.containerWidget.get('view-annotation-toolbar').setConnectedUsers(data.clients);
                this.containerWidget.get('annotation-workspace').applyPageCollection(data.room.pageCollection);
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_MODIFIED,
            this.annotationModel.sendModifiedAnnotation.bind(this.annotationModel)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_RECEIVED_MODIFIED,
            function(data) {
                if (data.annotation.pin) {
                    data.annotation.pin = this.pinParser.parse(data.annotation.pin);

                    if (this.containerWidget.get('view-annotation-pin-sidebar').isShowing(data.annotation.id)) {
                        this.containerWidget.get('view-annotation-pin-sidebar').show(data.annotation.pin);
                    }
                }

                this.containerWidget.get('annotation-workspace').modifyAnnotation(data);
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_DELETED,
            this.annotationModel.deleteAnnotation.bind(this.annotationModel)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_CLEARED,
            this.annotationModel.clearAllAnnotations.bind(this.annotationModel)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_RECEIVED_DELETED,
            function(data) {
                this.containerWidget.get('annotation-workspace').deleteAnnotation(data);

                if (this.containerWidget.get('view-annotation-pin-sidebar').isShowing(data.annotationObjectID)) {
                    this.containerWidget.get('view-annotation-pin-sidebar').hide();
                }
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_RECEIVED_CLEARED,
            function() {
                this.containerWidget.get('annotation-workspace').clearAllAnnotations();
                this.containerWidget.get('view-annotation-pin-sidebar').hide();
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_USER_CONNECT,
            function(user) {
                this.containerWidget.get('view-annotation-toolbar').connectUser(user);
                this.annotationModel.addConnectedUser(user);
                this.containerObservable.get('connected-users').set(this.annotationModel.getConnectedUsers());
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_USER_DISCONNECT,
            function(user) {
                this.containerWidget.get('view-annotation-toolbar').disconnectUser(user);
                this.annotationModel.removeConnectedUser(user);
                this.containerObservable.get('connected-users').set(this.annotationModel.getConnectedUsers());
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            Topics.DOCUMENT_VIEWER_OCR,
            function() {
                if (this.viewer.ocr) {
                    if (this.annotationToolStates.indexOf(this.stateMachine.getCurrentState()) !== -1) {
                        this.stateMachine.viewAnnotationOptionsHide();
                    }

                    if (this.viewer.getInformation().isShowing()) {
                        this.viewer.getInformation().hide();
                        this.showViewOptionsToolbar();
                    }

                    this.viewer.ocr();
                    this.dialogToolbar.toggleOcrSelected();
                }
            }.bind(this)
        );
    };

    return TopicSubscriber;
});
},
'api/doccontrol/data/Revision':function(){
define([
    'spencer/doc-control/data/Revision'
], function(Revision) {
    /**
     * Deprecated use 'spencer/doc-control/data/Revision.js' instead.
     */
    Revision.markedAsPrivate = false;

    Revision.prototype.markAsPrivate = function() {
        this.markedAsPrivate = true;
        return this;
    };

    Revision.prototype.isMarkedAsPrivate = function() {
        return this.markedAsPrivate;
    };

    return Revision;
});
},
'spencer/doc-control/data/Revision':function(){
define([], function() {
    const Revision = function() {
        this.revisionPK = null;
        this.documentPK = null;
        this.personPK = null;
        this.senderID = null;
        this.location = null;
        this.revisionNumber = null;
        this.realName = null;
        this.title = null;
        this.fileType = null;
        this.fileSize = null;
        this.md5 = null;
        this.dateUploaded = null;
        this.personUploader = null;
        this.personSender = null;
        this.markedAsPrivate = false;
        this.markedAsLatest = false;
        this.markedForDeletion = false;
        this.recipient = null;
        this.reference = null;
        this.revisionNumber = null;
        this.status = null;
        this.revisionDate = null;
        this.disciplinePK = null;
        this.discipline = null;
        this.reference = null;
        this.revisionNumber = null;
        this.recipientCollection = [];
        this.deleted = false;
        this.organisationFrom = null;
        this.softLinked = false;
        this.softLink = false;
        this.favourited = false;
        this.alerted = false;
        this.attachedTempDocTotal = 0;
        this.attachedRevisionTotal = 0;
        this.timeModified = null;
    };

    Revision.prototype.getRevisionPK = function() {
        return this.revisionPK;
    };

    Revision.prototype.setRevisionPK = function(revisionPK) {
        this.revisionPK = revisionPK;
        return this;
    };

    Revision.prototype.getDocumentPK = function() {
        return this.documentPK;
    };

    Revision.prototype.setDocumentPK = function(documentPK) {
        this.documentPK = documentPK;
        return this;
    };

    Revision.prototype.getPersonPK = function() {
        return this.personPK;
    };

    Revision.prototype.setPersonPK = function(personPK) {
        this.personPK = personPK;
        return this;
    };

    Revision.prototype.getSenderID = function() {
        return this.senderID;
    };

    Revision.prototype.setSenderID = function(senderID) {
        this.senderID = senderID;
        return this;
    };

    Revision.prototype.getLocation = function() {
        return this.location;
    };

    Revision.prototype.setLocation = function(location) {
        this.location = location;
        return this;
    };

    Revision.prototype.getRevisionNumber = function() {
        return this.revisionNumber;
    };

    Revision.prototype.setRevisionNumber = function(revisionNumber) {
        this.revisionNumber = revisionNumber;
        return this;
    };

    Revision.prototype.getRealName = function() {
        return this.realName;
    };
    
    Revision.prototype.setRealName = function(realName) {
        this.realName = realName;
        return this;
    };
    
    Revision.prototype.getTitle = function() {
        return this.title;
    };
    
    Revision.prototype.setTitle = function(title) {
        this.title = title;
        return this;
    };
    
    Revision.prototype.getFileType = function() {
        return this.fileType;
    };
    
    Revision.prototype.setFileType = function(fileType) {
        this.fileType = fileType;
        return this;
    };
    
    Revision.prototype.getFileSize = function() {
        return this.fileSize;
    };
    
    Revision.prototype.setFileSize = function(fileSize) {
        this.fileSize = fileSize;
        return this;
    };
    
    Revision.prototype.getMd5 = function() {
        return this.md5;
    };
    
    Revision.prototype.setMd5 = function(md5) {
        this.md5 = md5;
        return this;
    };

    Revision.prototype.getDateUploaded = function() {
        return this.dateUploaded;
    };

    Revision.prototype.setDateUploaded = function(dateUploaded) {
        this.dateUploaded = dateUploaded;
        return this;
    };

    Revision.prototype.getPersonUploader = function() {
        return this.personUploader;
    };

    Revision.prototype.setPersonUploader = function(personUploader) {
        this.personUploader = personUploader;
        return this;
    };

    Revision.prototype.getPersonSender = function() {
        return this.personSender;
    };

    Revision.prototype.setPersonSender = function(personSender) {
        this.personSender = personSender;
        return this;
    };

    Revision.prototype.markAsPrivate = function() {
        this.markedAsPrivate = true;
        return this;
    };

    Revision.prototype.setIsPrivate = function(isPrivate) {
        this.markedAsPrivate = isPrivate;
        return this;
    };

    Revision.prototype.isPrivate = function() {
        return this.markedAsPrivate;
    };

    Revision.prototype.markAsLatest = function() {
        this.markedAsLatest = true;
        return this;
    };

    Revision.prototype.unmarkAsLatest = function() {
        this.markedAsLatest = false;
        return this;
    };

    Revision.prototype.isMarkedForDeletion = function() {
        return this.markedForDeletion;
    };

    Revision.prototype.setMarkedForDeletion = function(markedForDeletion) {
        this.markedForDeletion = markedForDeletion;
        return this;
    };

    Revision.prototype.isLatest = function() {
        return this.markedAsLatest;
    };

    Revision.prototype.getRecipient = function() {
        return this.recipient;
    };

    Revision.prototype.setRecipient = function(recipient) {
        this.recipient = recipient;
        return this;
    };

    Revision.prototype.setReference = function(reference) {
        this.reference = reference;
        return this;
    };

    Revision.prototype.getReference = function() {
        return this.reference;
    };

    Revision.prototype.setRevisionNumber = function(revisionNumber) {
        this.revisionNumber = revisionNumber;
        return this;
    };

    Revision.prototype.getRevisionNumber = function() {
        return this.revisionNumber;
    };

    Revision.prototype.setStatus = function(status) {
        this.status = status;
        return this;
    };

    Revision.prototype.getStatus = function() {
        return this.status;
    };

    Revision.prototype.setRevisionDate = function(date) {
        this.revisionDate = date;
        return this;
    };

    Revision.prototype.getRevisionDate = function() {
        return this.revisionDate;
    };

    Revision.prototype.setDisciplinePK = function(disciplinePK) {
        this.disciplinePK = disciplinePK;
        return this;
    };

    Revision.prototype.getDisciplinePK = function() {
        return this.disciplinePK;
    };

    Revision.prototype.setDiscipline = function(discipline) {
        this.discipline = discipline;
        return this;
    };

    Revision.prototype.getDiscipline = function() {
        return this.discipline;
    };

    Revision.prototype.getReference = function() {
        return this.reference;
    };

    Revision.prototype.setReference = function(reference) {
        this.reference = reference;
        return this;
    };

    Revision.prototype.getRevisionNumber = function() {
        return this.revisionNumber;
    };

    Revision.prototype.setRevisionNumber = function(revisionNumber) {
        this.revisionNumber = revisionNumber;
        return this;
    };

    Revision.prototype.setRecipientCollection = function(recipientCollection) {
        this.recipientCollection = recipientCollection;
        return this;
    };

    Revision.prototype.getRecipientCollection = function() {
        return this.recipientCollection;
    };

    Revision.prototype.setDeleted = function(deleted) {
        this.deleted = deleted;
        return this;
    };

    Revision.prototype.isDeleted = function() {
        return this.deleted;
    };

    Revision.prototype.setOrganisationFrom = function(organisationFrom) {
        this.organisationFrom = organisationFrom;
        return this;
    };

    Revision.prototype.getOrganisationFrom = function() {
        return this.organisationFrom;
    };

    Revision.prototype.setIsSoftLinked = function(isSoftLinked) {
        this.softLinked = isSoftLinked;
        return this;
    };

    Revision.prototype.isSoftLinked = function() {
        return this.softLinked;
    };

    Revision.prototype.setIsSoftLink = function(isSoftLink) {
        this.softLink = isSoftLink;
        return this;
    };

    Revision.prototype.isSoftLink = function() {
        return this.softLink;
    };

    Revision.prototype.favourite = function() {
        this.favourited = true;
        return this;
    };

    Revision.prototype.unfavourite = function() {
        this.favourited = false;
        return this;
    };

    Revision.prototype.isFavourite = function() {
        return this.favourited;
    };

    Revision.prototype.alert = function() {
        this.alerted = true;
        return this;
    };

    Revision.prototype.removeAlert = function() {
        this.alerted = false;
        return this;
    };

    Revision.prototype.isAlerted = function() {
        return this.alerted;
    };

    Revision.prototype.setAttachedTempDocTotal = function(attachedTempDocTotal) {
        this.attachedTempDocTotal = attachedTempDocTotal;
        return this;
    };

    Revision.prototype.getAttachedTempDocTotal = function() {
        return this.attachedTempDocTotal;
    };

    Revision.prototype.setAttachedRevisionTotal = function(attachedRevisionTotal) {
        this.attachedRevisionTotal = attachedRevisionTotal;
        return this;
    };

    Revision.prototype.getAttachedRevisionTotal = function() {
        return this.attachedRevisionTotal;
    };

    Revision.prototype.getAttachedTotal = function() {
        return this.attachedTempDocTotal + this.attachedRevisionTotal;
    };

    Revision.prototype.getTimeModified = function() {
        return this.timeModified;
    };

    Revision.prototype.setTimeModified = function(date) {
        this.timeModified = date;
        return this;
    };

    return Revision;
});
},
'api/doccontrol/data/TemporaryDocument':function(){
define([
    'spencer/doc-control/data/TemporaryDocument'
], function (TemporaryDocument) {
    /**
     * Deprecated use 'spencer/doc-control/data/TemporaryDocument.js' instead.
     */
    return TemporaryDocument;
});

},
'spencer/doc-control/data/TemporaryDocument':function(){
define([], function () {
    const TemporaryDocument = function () {
        this.temporaryDocumentPK = null;
        this.location = null;
        this.name = null;
        this.size = null;
        this.type = null;
        this.subType = null;
        this.timeModified = null;
        this.md5 = null;
    };

    TemporaryDocument.prototype.getTemporaryDocumentPK = function() {
        return this.temporaryDocumentPK;
    };

    TemporaryDocument.prototype.setTemporaryDocumentPK = function(temporaryDocumentPK) {
        this.temporaryDocumentPK = temporaryDocumentPK;
        return this;
    };

    TemporaryDocument.prototype.getLocation = function() {
        return this.location;
    };

    TemporaryDocument.prototype.setLocation = function(location) {
        this.location = location;
        return this;
    };

    TemporaryDocument.prototype.getName = function() {
        return this.name;
    };

    TemporaryDocument.prototype.setName = function(name) {
        this.name = name;
        return this;
    };

    TemporaryDocument.prototype.getSize = function() {
        return this.size;
    };

    TemporaryDocument.prototype.setSize = function(size) {
        this.size = size;
        return this;
    };

    TemporaryDocument.prototype.getType = function() {
        return this.type;
    };

    TemporaryDocument.prototype.setType = function(type) {
        this.type = type;
        return this;
    };

    TemporaryDocument.prototype.getSubType = function() {
        return this.subType;
    };

    TemporaryDocument.prototype.setSubType = function(subType) {
        this.subType = subType;
        return this;
    };

    TemporaryDocument.prototype.getFileType = function() {
        if (!this.subType) {
            return this.type;
        }

        return this.type + '/' + this.subType;
    };

    TemporaryDocument.prototype.getTimeModified = function() {
        return this.timeModified;
    };

    TemporaryDocument.prototype.setTimeModified = function(timeModified) {
        this.timeModified = timeModified;
        return this;
    };

    TemporaryDocument.prototype.getMd5 = function() {
        return this.md5;
    };

    TemporaryDocument.prototype.setMd5 = function(md5) {
        this.md5 = md5;
        return this;
    };

    return TemporaryDocument;
});

},
'doccontrol/viewer/helper/PdfToBlob':function(){
define([], function() {
    const BLOB_CONVERSION_CHUNK_SIZE = 512;
    const PdfToBlob = function() {};

    PdfToBlob.prototype.convert = function(data, type) {
        if (data === null) {
            return new Blob([], {type: type});
        }

        let byteCharacters;

        try {
            byteCharacters = atob(data.replace(/\s/g, ''));
        } catch (error) {
            return new Blob([data], {type: type});
        }

        const parts = [];

        for (let offset = 0; offset < byteCharacters.length; offset += BLOB_CONVERSION_CHUNK_SIZE) {
            const slice = byteCharacters.slice(offset, offset + BLOB_CONVERSION_CHUNK_SIZE);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);

            parts.push(byteArray);
        }

        return new Blob(parts, {type: type});
    };

    return PdfToBlob;
});
},
'doccontrol/viewer/helper/ShareToEmail':function(){
define(["require", "exports", "@app/url/helper/ParamStringGenerator"], function (require, exports, ParamStringGenerator) {
    "use strict";
    class ShareToEmail {
        constructor(route, windowObj) {
            this.route = route;
            this.windowObj = windowObj;
            this.paramStringGenerator = new ParamStringGenerator();
        }
        share(documentReference) {
            const parameters = {
                revisionPK: [],
                temporaryDocumentPK: []
            };
            if (typeof documentReference.getRevisionPK === 'function'
                && documentReference.getRevisionPK()) {
                parameters.revisionPK.push(documentReference.getRevisionPK());
            }
            else if (typeof documentReference.getTemporaryDocumentPK === 'function'
                && documentReference.getTemporaryDocumentPK()) {
                parameters.temporaryDocumentPK.push(documentReference.getTemporaryDocumentPK());
            }
            this.windowObj.open(this.route + this.paramStringGenerator.generate(parameters));
        }
    }
    return ShareToEmail;
});

},
'@app/url/helper/ParamStringGenerator':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class ParamStringGenerator {
        constructor() {
            this.URL_SLASH = '/';
        }
        generate(params) {
            let r = '';
            for (let paramName in params) {
                if (params.hasOwnProperty(paramName)) {
                    if (!Array.isArray(params[paramName])) {
                        r += this.URL_SLASH + paramName + this.URL_SLASH + params[paramName];
                        continue;
                    }
                    for (let j = 0; j < params[paramName].length; j++) {
                        r += this.URL_SLASH + paramName + this.URL_SLASH + params[paramName][j];
                    }
                }
            }
            return r;
        }
    }
    return ParamStringGenerator;
});

},
'library/request/data/Handlers':function(){
define(['@lib/request/data/Handlers'], function(TSHandlers) {
    return class Handlers extends TSHandlers {
        constructor(success, progress, unauthorised, error, abort, forbidden) {
            super(success, error);

            if (progress) this.setProgress(progress);
            if (unauthorised) this.setUnauthorised(unauthorised);
            if (abort) this.setAbort(abort);
            if (forbidden) this.setForbidden(forbidden);
        }
    }
});
},
'@lib/request/data/Handlers':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Handlers {
        constructor(success = null, error = null) {
            this.success = success;
            this.error = error;
            this.unauthorised = null;
            this.forbidden = null;
            this.progress = null;
            this.abort = null;
            this.conflict = null;
            this.gone = null;
            this.resetContent = null;
            this.noContent = null;
            this.accepted = null;
            this.methodNotAllowed = null;
        }
        setSuccess(success) {
            this.success = success;
            return this;
        }
        getSuccess() {
            return this.success;
        }
        setProgress(progress) {
            this.progress = progress;
            return this;
        }
        getProgress() {
            return this.progress;
        }
        setUnauthorised(unauthorised) {
            this.unauthorised = unauthorised;
            return this;
        }
        getUnauthorised() {
            return this.unauthorised;
        }
        setError(error) {
            this.error = error;
            return this;
        }
        getError() {
            return this.error;
        }
        setAbort(abort) {
            this.abort = abort;
            return this;
        }
        getAbort() {
            return this.abort;
        }
        setForbidden(forbidden) {
            this.forbidden = forbidden;
            return this;
        }
        getForbidden() {
            return this.forbidden;
        }
        setConflict(conflict) {
            this.conflict = conflict;
            return this;
        }
        getConflict() {
            return this.conflict;
        }
        setGone(gone) {
            this.gone = gone;
            return this;
        }
        getGone() {
            return this.gone;
        }
        setResetContent(resetContent) {
            this.resetContent = resetContent;
            return this;
        }
        getResetContent() {
            return this.resetContent;
        }
        setNoContent(noContent) {
            this.noContent = noContent;
            return this;
        }
        getNoContent() {
            return this.noContent;
        }
        setAccepted(accepted) {
            this.accepted = accepted;
            return this;
        }
        getAccepted() {
            return this.accepted;
        }
        setMethodNotAllowed(methodNotAllowed) {
            this.methodNotAllowed = methodNotAllowed;
            return this;
        }
        getMethodNotAllowed() {
            return this.methodNotAllowed;
        }
    }
    return Handlers;
});

},
'pdf/request/data/Handlers':function(){
define(['@lib/request/data/Handlers'], function(Handlers) {
    return class PdfHandlers extends Handlers {
        constructor(success, error, unauthorised, abort, password, gone) {
            super(success, error);

            if (unauthorised) this.setUnauthorised(unauthorised);
            if (abort) this.setAbort(abort);
            if (gone) this.setGone(gone);

            this.password = password;
        }

        getPassword() {
            return this.password;
        }
    }
});
},
'style-guide/v1/file-tray/config/BroadcastChannel':function(){
define([], function() {
    return {
        CHANNEL: {
            CURRENT: 'current_file_tray_channel',
            SAVED: 'saved_file_tray_channel'
        },
        MESSAGE: {
            REFRESH: 'refresh'
        }
    };
});
},
'doccontrol/viewer/state-machine/States':function(){
define([], function() {
    return {
        ANNOTATION_MODE_DRAG: 'annotation-mode-drag',
        ANNOTATION_MODE_FREEHAND: 'annotation-mode-freehand',
        ANNOTATION_MODE_HIGHLIGHT: 'annotation-mode-highlight',
        ANNOTATION_MODE_TEXT: 'annotation-mode-text',
        ANNOTATION_MODE_LINE: 'annotation-mode-line',
        ANNOTATION_MODE_SELECT: 'annotation-mode-select',
        ANNOTATION_MODE_ELLIPSE: 'annotation-mode-ellipse',
        ANNOTATION_MODE_RECTANGLE: 'annotation-mode-rectangle',
        ANNOTATION_MODE_HEXAGON: 'annotation-mode-hexagon',
        ANNOTATION_MODE_POLYGON: 'annotation-mode-polygon',
        ANNOTATION_MODE_HIGHLIGHT_REGION: 'annotation-mode-highlight-region',
        ANNOTATION_MODE_ARROW: 'annotation-mode-arrow',
        ANNOTATION_MODE_PIN: 'annotation-mode-pin',
        CORRESPONDENCE_VIEW: 'correspondence-view',
        EMAIL_VIEW: 'email-view',
        EMAIL_VIEW_LOADING: 'email-view-loading',
        INITIAL: 'initial',
        MEDIA_VIEW: 'media-view',
        VIEW: 'view',
        VIEW_ANNOTATION_OPTIONS: 'view-annotation-options'
    };
});
},
'doccontrol/viewer/parser/pins/Pin':function(){
define([
    '../../data/pins/Pin',
    './Comment',
    'spencer/doc-control/parser/Revision',
    'spencer/doc-control/parser/TemporaryDocument'
], function(PinVO, CommentParser, RevisionParser, TemporaryDocumentParser) {
    const Pin = function() {
        this.commentParser = new CommentParser();
        this.revisionParser = new RevisionParser();
        this.temporaryDocumentParser = new TemporaryDocumentParser();
    };

    Pin.prototype.parse = function(item) {
        const pvo = (new PinVO())
            .setId(item.id || null)
            .setReference(parseInt(item.reference) || null)
            .setComments(Array.isArray(item.comments) ? item.comments.map(this.commentParser.parse) : []);

        if (Array.isArray(item.attachments)) {
            item.attachments.forEach(function(attachment) {
                pvo.addAttachment(
                    attachment.revisionPK
                        ? this.revisionParser.parse(attachment)
                        : this.temporaryDocumentParser.parse(attachment)
                );
            }.bind(this));
        }

        return pvo;
    };

    return Pin;
});
},
'doccontrol/viewer/data/pins/Pin':function(){
define([], function() {
    const Pin = function() {
        this.id = null;
        this.reference = null;
        this.comments = [];
        this.attachments = [];
    };

    Pin.prototype.setId = function(id) {
        this.id = id;
        return this;
    };

    Pin.prototype.getId = function() {
        return this.id;
    };

    Pin.prototype.setReference = function(reference) {
        this.reference = reference;
        return this;
    };

    Pin.prototype.getReference = function() {
        return this.reference;
    };

    Pin.prototype.setComments = function(comments) {
        this.comments = comments;
        return this;
    };

    Pin.prototype.getComments = function() {
        return this.comments;
    };

    Pin.prototype.addComment = function(comment) {
        this.comments.push(comment);
        return this;
    };

    Pin.prototype.addAttachment = function(attachment) {
        this.attachments.push(attachment);
        return this;
    };

    Pin.prototype.getAttachments = function() {
        return this.attachments;
    };

    Pin.prototype.removeAttachmentByMd5 = function(md5) {
        for (let i = 0; i < this.attachments.length; i++) {
            if (this.attachments[i].getMd5() === md5) {
                this.attachments.splice(i, 1);
                break;
            }
        }

        return this;
    };

    return Pin;
});
},
'doccontrol/viewer/parser/pins/Comment':function(){
define([
    '../../data/pins/Comment'
], function(
    CommentVO
) {
    const Comment = function() {};

    Comment.prototype.parse = function(item) {
        return (new CommentVO())
            .setCommentId(item.commentId || null)
            .setPersonPK(item.personPK || null)
            .setDisplayName(item.displayName || null)
            .setText(item.text || null)
            .setTime(item.time ? new Date(item.time) : new Date());
    };

    return Comment;
});
},
'doccontrol/viewer/data/pins/Comment':function(){
define([], function() {
    const Comment = function() {
        this.commentId = null;
        this.personPK = null;
        this.displayName = null;
        this.text = null;
        this.time = null;
    };

    Comment.prototype.setCommentId = function(commentId) {
        this.commentId = commentId;
        return this;
    };

    Comment.prototype.getCommentId = function() {
        return this.commentId;
    };

    Comment.prototype.setPersonPK = function(personPK) {
        this.personPK = personPK;
        return this;
    };

    Comment.prototype.getPersonPK = function() {
        return this.personPK;
    };

    Comment.prototype.setDisplayName = function(displayName) {
        this.displayName = displayName;
        return this;
    };

    Comment.prototype.getDisplayName = function() {
        return this.displayName;
    };

    Comment.prototype.setText = function(text) {
        this.text = text;
        return this;
    };

    Comment.prototype.getText = function() {
        return this.text;
    };

    Comment.prototype.setTime = function(time) {
        this.time = time;
        return this;
    };

    Comment.prototype.getTime = function() {
        return this.time;
    };

    return Comment;
});
},
'spencer/doc-control/parser/Revision':function(){
define([
    '../data/Revision',
    'spencer/core/parser/Person',
    'spencer/parse/Collection',
    './Recipient',
    'spencer/core/parser/Organisation'
], function(
    RevisionVO,
    PersonParser,
    CollectionParser,
    RecipientParser,
    OrganisationParser
) {
    const Revision = function(revisionStatusParser) {
        this.personParser = new PersonParser();
        this.recipientCollectionParser = new CollectionParser(
            new RecipientParser()
        );
        this.organisationParser = new OrganisationParser();

        this.revisionStatusParser = revisionStatusParser;
    };

    Revision.prototype.parse = function(item) {
        let rvo = new RevisionVO();
        rvo.setRevisionPK(parseInt(item.revisionPK) || null)
            .setDocumentPK(parseInt(item.documentPK) || null)
            .setPersonPK(parseInt(item.personPK) || null)
            .setSenderID(parseInt(item.senderID) || null)
            .setLocation(item.location || null)
            .setRealName(item.realName || item.name || null)
            .setReference(item.reference || null)
            .setRevisionNumber(item.revisionNumber || null)
            .setTitle(item.title || null)
            .setFileType(item.fileType || item.type || null)
            .setFileSize(item.fileSize || item.size || null)
            .setMarkedForDeletion(item.markedForDeletion || false)
            .setMd5(item.md5 || null)
            .setDeleted(item.deleted == '1' || (typeof item.deleted == 'string' && item.deleted.toLowerCase() === 'true') || false)
            .setDateUploaded(item.dateUploaded ? new Date(item.dateUploaded) : null)
            .setPersonUploader(item.personUploader ? this.personParser.parse(item.personUploader) : null)
            .setPersonSender(item.personSender ? this.personParser.parse(item.personSender) : null)
            .setRecipient(item.recipient ? this.personParser.parse(item.recipient) : null)
            .setReference(item.reference || null)
            .setRevisionDate(item.revisionDate ? new Date(item.revisionDate) : null)
            .setDisciplinePK(item.disciplinePK || null)
            .setDiscipline(item.discipline || null)
            .setRecipientCollection(
                item.recipientCollection
                    ? this.recipientCollectionParser.parse(item.recipientCollection)
                    : []
            )
            .setOrganisationFrom(
                item.organisationFrom
                    ? this.organisationParser.parse(item.organisationFrom)
                    : null
            )
            .setIsSoftLinked(item.isSoftLinked || false)
            .setIsSoftLink(item.isSoftLink || false)
            .setAttachedTempDocTotal(item.attachedTempDocTotal || 0)
            .setAttachedRevisionTotal(item.attachedRevisionTotal || 0);
        
        if (this.revisionStatusParser) {
            rvo.setStatus(this.revisionStatusParser.parse(item.status || {}));
        }

        if (item.markedAsPrivate) {
            rvo.markAsPrivate();
        }

        if (item.markedAsLatest) {
            rvo.markAsLatest();
        }

        if (item.isFavourited) {
            rvo.favourite();
        }

        if (item.isAlert) {
            rvo.alert();
        }

        if (item.timeModified) {
            rvo.setTimeModified(item.timeModified ? new Date(item.timeModified) : null);
        }

        return rvo;
    };

    return Revision;
});
},
'spencer/core/parser/Person':function(){
define([
    '../data/Person'
], function(PersonVO) {
    var Person = function() {};

    Person.prototype.parse = function(item) {
        var p = new PersonVO();

        p.setPersonPK(item.personPK || null);
        p.setDisplayName(item.displayName || item.name || null);
        p.setJobTitle(item.jobTitle || null);
        p.setEmail(item.email || null);
        p.setOrganisationPK(item.organisationPK || false);
        p.setOrganisation(item.organisation || null);

        return p;
    };

    return Person;
});
},
'spencer/core/data/Person':function(){
define(["require", "exports", "@lib/spencer/core/data/Person"], function (require, exports, PersonVO) {
    "use strict";
    /** @deprecated use @lib/spencer/core/data/Person.ts directly */
    class Person extends PersonVO {
    }
    return Person;
});

},
'@lib/spencer/core/data/Person':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Person {
        constructor() {
            this.personPK = null;
            this.title = null;
            this.firstName = null;
            this.middleName = null;
            this.lastName = null;
            this.displayName = null;
            this.name = null;
            this.jobTitle = null;
            this.email = null;
            this.phoneNumbers = {};
            this.organisationPK = false;
            this.organisation = null;
            this.type = null;
            this.displayNameAndJobTitle = null;
        }
        getPersonPK() {
            return this.personPK;
        }
        setPersonPK(personPK) {
            this.personPK = personPK;
            return this;
        }
        getTitle() {
            return this.title;
        }
        setTitle(title) {
            this.title = title;
            return this;
        }
        getFirstName() {
            return this.firstName;
        }
        setFirstName(firstName) {
            this.firstName = firstName;
            return this;
        }
        getMiddleName() {
            return this.middleName;
        }
        setMiddleName(middleName) {
            this.middleName = middleName;
            return this;
        }
        getLastName() {
            return this.lastName;
        }
        setLastName(lastName) {
            this.lastName = lastName;
            return this;
        }
        getDisplayName() {
            return this.displayName;
        }
        setDisplayName(displayName) {
            this.displayName = displayName;
            return this;
        }
        getName() {
            return this.name;
        }
        setName(name) {
            this.name = name;
            return this;
        }
        getJobTitle() {
            return this.jobTitle;
        }
        setJobTitle(jobTitle) {
            this.jobTitle = jobTitle;
            return this;
        }
        getEmail() {
            return this.email;
        }
        setEmail(email) {
            this.email = email;
            return this;
        }
        getPhoneNumbers() {
            return this.phoneNumbers;
        }
        addPhoneNumber(type, number) {
            this.phoneNumbers[type] = number;
            return this;
        }
        getOrganisationPK() {
            return this.organisationPK;
        }
        setOrganisationPK(organisationPK) {
            this.organisationPK = organisationPK;
            return this;
        }
        getOrganisation() {
            return this.organisation;
        }
        setOrganisation(organisation) {
            this.organisation = organisation;
            return this;
        }
        getType() {
            return this.type;
        }
        setType(type) {
            this.type = type;
            return this;
        }
        setDisplayNameAndJobTitle(displayNameAndJobTitle) {
            this.displayNameAndJobTitle = displayNameAndJobTitle;
            return this;
        }
        getDisplayNameAndJobTitle() {
            return this.displayNameAndJobTitle;
        }
    }
    return Person;
});

},
'spencer/doc-control/parser/Recipient':function(){
define([
    '../data/Recipient',
    'spencer/core/parser/Person',
    'spencer/core/parser/Organisation'
], function(
    RecipientData,
    PersonParser,
    OrganisationParser
) {
    const Recipient = function() {
        this.personParser = new PersonParser();
        this.organisationParser = new OrganisationParser();
    };

    Recipient.prototype.parse = function(item) {
        const person = item.person;
        const organisation = item.organisation;
        let label = '';

        if (person) {
            label += person.displayName || person.name;
        }

        if (person && organisation) {
            label += ' - ';
        }

        if (organisation) {
            label += organisation.name;
        }

        return (new RecipientData())
            .setUid(label)
            .setPerson(item.person ? this.personParser.parse(item.person) : null)
            .setOrganisation(item.organisation ? this.organisationParser.parse(item.organisation) : null)
    };

    return Recipient;
});
},
'spencer/doc-control/data/Recipient':function(){
define([], function() {
    const Recipient = function() {
        this.uid = null;
        this.person = {};
        this.organisation = {};
    };

    Recipient.prototype.setUid = function(uid) {
        this.uid = uid;
        return this;
    };

    Recipient.prototype.getUid = function() {
        return this.uid;
    };

    Recipient.prototype.setPerson = function(person) {
        this.person = person;
        return this;
    };

    Recipient.prototype.getPerson = function() {
        return this.person;
    };

    Recipient.prototype.setOrganisation = function(organisation) {
        this.organisation = organisation;
        return this;
    };

    Recipient.prototype.getOrganisation = function() {
        return this.organisation;
    };

    return Recipient;
});
},
'spencer/core/parser/Organisation':function(){
define([
    '../data/Organisation'
], function(OrganisationVO) {
    var Organisation = function() {};

    Organisation.prototype.parse = function(item) {
        var o = new OrganisationVO();

        o.setOrganisationPK(item.organisationPK || null);
        o.setName(item.name || null);
        o.setPreferredName(item.preferredName || null);

        return o;
    };

    return Organisation;
});
},
'spencer/core/data/Organisation':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Organisation {
        constructor() {
            this.organisationPK = null;
            this.description = null;
            this.name = null;
            this.preferredName = null;
            this.website = null;
        }
        getOrganisationPK() {
            return this.organisationPK;
        }
        setOrganisationPK(organisationPK) {
            this.organisationPK = organisationPK;
            return this;
        }
        getDescription() {
            return this.description;
        }
        setDescription(description) {
            this.description = description;
            return this;
        }
        getName() {
            return this.name;
        }
        setName(name) {
            this.name = name;
            return this;
        }
        getPreferredName() {
            return this.preferredName;
        }
        setPreferredName(preferredName) {
            this.preferredName = preferredName;
            return this;
        }
        getWebsite() {
            return this.website;
        }
        setWebsite(website) {
            this.website = website;
            return this;
        }
    }
    return Organisation;
});

},
'spencer/doc-control/parser/TemporaryDocument':function(){
define([
    'spencer/doc-control/data/TemporaryDocument'
], function (
    TemporaryDocumentData
) {
    const TemporaryDocument = function() {};

    TemporaryDocument.prototype.parse = function(data) {
        const tempDoc = new TemporaryDocumentData();
        tempDoc.setTemporaryDocumentPK(data.temporaryDocumentPK);
        tempDoc.setName(data.name);
        tempDoc.setMd5(data.md5);
        tempDoc.setLocation(data.location);
        tempDoc.setSize(data.size);
        tempDoc.setType(data.type);
        tempDoc.setSubType(data.subType);
        tempDoc.setTimeModified(data.timeModified);

        return tempDoc;
    };

    return TemporaryDocument;
});
},
'doccontrol/viewer/model/AnnotatedDocumentGenerator':function(){
define([
    'api/doccontrol/data/TemporaryDocument',
    'library/request/data/Handlers',
    'library/request/data/HTTPResponseCodes',
    'library/request/helper/DefaultUnauthorisedCallback',
], function(
    TemporaryDocument,
    HandlersVO,
    HTTPResponseCodes,
    DefaultUnauthorisedCallback,
) {
    const AnnotatedDocumentGenerator = function(
        widgetContainer,
        viewerModel,
        annotationModel,
        routeContainer,
        registerModel,
        reviseModel,
        shareToEmail,
        topic,
        binder,
        windowObj
    ) {
        this.widgetContainer = widgetContainer;
        this.viewerModel = viewerModel;
        this.annotationModel = annotationModel;
        this.registerModel = registerModel;
        this.reviseModel = reviseModel;
        this.binder = binder;

        this.restoreViewerState = function() {
            this.widgetContainer.get('view-annotation-toolbar').enableToolbar();
            this.widgetContainer.get('annotation-workspace').hideGeneratingAnnotatedDocumentMessage();
            this.widgetContainer.get('view').renderCurrentPage();
        };

        this.getDownloadHandlers = function(routeIdentifier) {
            const annotationToolbar = this.widgetContainer.get('view-annotation-toolbar');
            const annotationWorkspace = this.widgetContainer.get('annotation-workspace');
            const viewerWidget = this.widgetContainer.get('view');
            const documentDetails = viewerWidget.getDocumentDetails();

            return new HandlersVO(
                function success(data) {
                    const popup = windowObj.open(routeContainer.get(routeIdentifier, {token: data.token}), '_blank');
                    const popupBlocked = !popup || popup.closed || typeof popup.closed == 'undefined';

                    if (popupBlocked) {
                        topic.publish(
                            'sos-system-notification',
                            'This document could not be downloaded as your browser blocked the download. Please try again, or if the problem persists, please contact support.',
                            'error',
                            6000
                        );
                    }

                    if (!popupBlocked && typeof documentDetails.getRevisionPK === 'function' && documentDetails.getRevisionPK()) {
                        viewerModel.logDownload(documentDetails);
                    }

                    this.restoreViewerState();
                }.bind(this),
                function progress() {},
                DefaultUnauthorisedCallback,
                function error(error, description, code) {
                    const errorMessage = 'Unable to generate annotated :documentType.<br/>:errorDescription'
                        .replace(':documentType', viewerWidget.isImage() ? 'image' : 'PDF')
                        .replace(
                            ':errorDescription',
                            code === HTTPResponseCodes.method_not_allowed
                                ? description
                                : 'Please try again. If the problem persists, please contact support.'
                        );
                    topic.publish('sos-system-notification', errorMessage, 'error', 5000);

                    this.restoreViewerState();
                }.bind(this)
            );
        };

        this.getShareToEmailHandlers = function() {
            const annotationToolbar = this.widgetContainer.get('view-annotation-toolbar');
            const annotationWorkspace = this.widgetContainer.get('annotation-workspace');
            const viewerWidget = this.widgetContainer.get('view');

            return new HandlersVO(
                function success(data) {
                    shareToEmail.share(
                        (new TemporaryDocument()).setTemporaryDocumentPK(data.temporaryDocumentPK)
                    );
                    this.restoreViewerState();
                }.bind(this),
                function progress() {},
                DefaultUnauthorisedCallback,
                function error() {
                    topic.publish(
                        'sos-system-notification',
                        'Unable to create annotated temporary document attachment.<br/>'
                        + 'Please try again. If the problem persists, please contact support.',
                        'error',
                        7000
                    );

                    this.restoreViewerState();
                }.bind(this)
            );
        };

        this.getRegisterHandlers = function() {
            const annotationToolbar = this.widgetContainer.get('view-annotation-toolbar');
            const annotationWorkspace = this.widgetContainer.get('annotation-workspace');
            const viewerWidget = this.widgetContainer.get('view');

            return new HandlersVO(
                (data) => {
                    this.restoreViewerState();
                    this.registerModel.start(data);
                },
                () => {},
                DefaultUnauthorisedCallback,
                () => {
                    topic.publish(
                        'sos-system-notification',
                        'Unable to create annotated document for registration.<br/>'
                        + 'Please try again. If the problem persists, please contact support.',
                        'error',
                        7000
                    );

                    this.restoreViewerState();
                }
            );
        };

        this.getReviseHandlers = function(originalDocument) {
            const annotationToolbar = this.widgetContainer.get('view-annotation-toolbar');
            const annotationWorkspace = this.widgetContainer.get('annotation-workspace');
            const viewerWidget = this.widgetContainer.get('view');

            return new HandlersVO(
                (newDocument) => {
                    this.restoreViewerState();
                    this.reviseModel.start(newDocument, originalDocument);
                },
                () => {},
                DefaultUnauthorisedCallback,
                () => {
                    topic.publish(
                        'sos-system-notification',
                        'Unable to create annotated document for registration.<br/>'
                        + 'Please try again. If the problem persists, please contact support.',
                        'error',
                        7000
                    );

                    this.restoreViewerState();
                }
            );
        };

        this.generateAnnotatedDocument = function(generateCallback, handlers) {
            const viewerWidget = this.widgetContainer.get('view');
            const documentDetails = viewerWidget.getDocumentDetails();
            const annotationWorkspace = this.widgetContainer.get('annotation-workspace');
            const annotationToolbar = this.widgetContainer.get('view-annotation-toolbar');

            if (viewerWidget.isImage()) {
                annotationToolbar.disableToolbar();
                annotationWorkspace.showGeneratingAnnotatedDocumentMessage();

                annotationWorkspace.getAnnotationsForImage(viewerWidget.getImage()).then(function(annotations) {
                    generateCallback(handlers, documentDetails.getMd5(), annotations, annotationWorkspace.getPins());
                }).catch(function(error) {
                    annotationWorkspace.hideGeneratingAnnotatedDocumentMessage();

                    topic.publish(
                        'sos-system-notification',
                        'Unable to create annotated image.<br/>Try reconnecting to the server before trying again.',
                        'error',
                        7000
                    );
                });
            } else {
                annotationToolbar.disableToolbar();
                annotationWorkspace.showGeneratingAnnotatedDocumentMessage();

                viewerWidget.getAllPages().then(async function(pages) {
                    const annotations = {};

                    let pageNumber = 1;

                    try {
                        for (const page of pages) {
                            await annotationWorkspace.getAnnotationsForPage(pageNumber, page.pageRotate, page.pageHeight, page.pageWidth)
                                .then(function(annotationData) {
                                    if (annotationData !== undefined) {
                                        annotations[pageNumber] = annotationData;
                                    }
                                });

                            pageNumber++;
                        }

                        generateCallback(handlers, documentDetails.getMd5(), annotations, annotationWorkspace.getPins());
                    } catch(error) {
                        annotationWorkspace.hideGeneratingAnnotatedDocumentMessage();

                        topic.publish(
                            'sos-system-notification',
                            'Unable to create annotated document.<br/>Try reconnecting to the server before trying again.',
                            'error',
                            7000
                        );
                    }
                });
            }
        };
    };

    AnnotatedDocumentGenerator.prototype.download = function() {
        this.generateAnnotatedDocument(
            this.binder.bindScope(this.annotationModel.generate, this.annotationModel),
            this.getDownloadHandlers('tokenFileDownload')
        );
    };

    AnnotatedDocumentGenerator.prototype.view = function() {
        this.generateAnnotatedDocument(
            this.binder.bindScope(this.annotationModel.generatePrintable, this.annotationModel),
            this.getDownloadHandlers('tokenFileView')
        );
    };

    AnnotatedDocumentGenerator.prototype.email = function() {
        this.generateAnnotatedDocument(
            this.binder.bindScope(this.annotationModel.generateTemporaryDocument, this.annotationModel),
            this.getShareToEmailHandlers()
        );
    };

    AnnotatedDocumentGenerator.prototype.register = function() {
        this.generateAnnotatedDocument(
            this.binder.bindScope(this.annotationModel.generateTemporaryDocument, this.annotationModel),
            this.getRegisterHandlers()
        );
    };

    AnnotatedDocumentGenerator.prototype.revise = function(data) {
        this.generateAnnotatedDocument(
            this.binder.bindScope(this.annotationModel.generateTemporaryDocument, this.annotationModel),
            this.getReviseHandlers(data)
        );
    };

    return AnnotatedDocumentGenerator;
});
},
'doccontrol/viewer/model/Register':function(){
define(["require", "exports", "library/request/helper/DefaultUnauthorisedCallback", "api/doccontrol/Config", "api/doccontrol/Factory", "library/request/data/Handlers", "api/doccontrol/data/RegistrationDetails", "spencer/doc-control/data/Revision", "../Topics", "api/doccontrol/TemporaryDocumentRegisterFactory", "library/request/URLConnectionBuilder", "library/request/dojo/URLConnectionProcessorBuilder", "library/request/URLResponseProcessorBuilder", "dojo/topic"], function (require, exports, DefaultUnauthorisedCallback, DocControlConfig, DocControlFactory, HandlersVO, RegistrationDetailsData, RevisionVO, TOPICS, TemporaryDocumentRegisterFactory, URLConnectionBuilder, URLConnectionProcessorBuilder, URLResponseProcessorBuilder, topic) {
    "use strict";
    const NOTIFICATION_UID = 'documentViewerRegistrationNotification';
    class Register {
        constructor(widgetContainer) {
            this.widgetContainer = widgetContainer;
            this.inProgress = false;
            this.apiTemporaryDocumentRegister = new TemporaryDocumentRegisterFactory(new DocControlConfig(), new URLConnectionBuilder(new URLConnectionProcessorBuilder())).getTemporaryDocumentRegister();
            this.apiRevision = new DocControlFactory(new DocControlConfig(), new URLConnectionBuilder(new URLConnectionProcessorBuilder()), new URLResponseProcessorBuilder()).getRevision();
            this.widgetDocumentRegisterFormPane = this.widgetContainer.get('document-register-form-pane');
            this.widgetDocumentReviseFormPane = this.widgetContainer.get('document-revise-form-pane');
        }
        start(data) {
            this.inProgress = true;
            this.widgetDocumentReviseFormPane.close();
            this.widgetDocumentRegisterFormPane
                .setCallbackOnClose(() => {
                this.inProgress = false;
                topic.publish(TOPICS.DOCUMENT_VIEWER_DISABLE_INLINE);
            })
                .setCallbackOnRegister((registrationDetails) => {
                this.register(registrationDetails);
            })
                .setCallbackOnQuickRegister((registrationDetails) => {
                this.register(registrationDetails);
            });
            topic.publish(TOPICS.DOCUMENT_VIEWER_ENABLE_INLINE);
            this.widgetDocumentRegisterFormPane.reset();
            this.widgetDocumentRegisterFormPane.setData(data);
            this.widgetDocumentRegisterFormPane.open();
        }
        isInProgress() {
            return this.inProgress;
        }
        register(registrationDetails) {
            topic.publish('sos-system-notification-progress', 'Registering Document...', NOTIFICATION_UID);
            const registrationDetailsData = new RegistrationDetailsData()
                .setMd5(registrationDetails.md5)
                .setTreeViewPK(registrationDetails.treeViewPK)
                .setType(registrationDetails.type)
                .setPersonPK(registrationDetails.personPK)
                .setBranchOfficePK(registrationDetails.branchOfficePK)
                .setRecipientContact(registrationDetails.recipientContact)
                .setTitle(registrationDetails.title)
                .setDate(registrationDetails.date)
                .setIsPrivate(registrationDetails.isPrivate)
                .setDiscipline(registrationDetails.discipline)
                .setRevision(registrationDetails.revision)
                .setReference(registrationDetails.reference)
                .setStatus(registrationDetails.status)
                .setLocation(registrationDetails.location)
                .setProjectStagePK(registrationDetails.projectStagePK)
                .setQuickRegister(registrationDetails.quickRegister);
            this.apiTemporaryDocumentRegister.register(new HandlersVO((data) => {
                topic.publish('sos-system-notification-progress-update', NOTIFICATION_UID, 25);
                topic.publish('sos-system-notification-message-update', NOTIFICATION_UID, 'Document successfully Registered. Fetching document details...');
                this.requestRevision(JSON.parse(data));
            }, () => {
            }, DefaultUnauthorisedCallback, () => {
                topic.publish('sos-system-notification-progress-complete', NOTIFICATION_UID, 'There was an error while uploading your document. Please contact support.', 'error');
            }).setConflict((error, data) => {
                topic.publish('sos-system-notification-message-update', NOTIFICATION_UID, 'The uploaded document already exists on the system. Fetching document details...');
                this.requestRevision(data);
            }), registrationDetailsData);
        }
        requestRevision(data) {
            this.apiRevision.get(new HandlersVO((revision) => {
                topic.publish('sos-system-notification-progress-complete', NOTIFICATION_UID, 'Document loaded successfully.', 'success', 3000);
                this.widgetDocumentRegisterFormPane.close();
                topic.publish(TOPICS.DOCUMENT_VIEWER_VIEW, revision);
            }, () => { }, DefaultUnauthorisedCallback, () => {
                topic.publish('sos-system-notification-progress-complete', NOTIFICATION_UID, 'The document was registered successfully, but its data could not be fetched from the server.', 'error');
                this.widgetDocumentRegisterFormPane.close();
            }), new RevisionVO().setRevisionPK(data.revisionPK));
        }
    }
    return Register;
});

},
'api/doccontrol/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    const Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_doc_control_add_folder = 'doc-control/node/add-folder';
        this.api_doc_control_copy_node = 'doc-control/node/copy';
        this.api_doc_control_copy_node_organisation = 'doc-control/node/copy-organisation';
        this.api_doc_control_document = 'doc-control/document/';
        this.api_doc_control_document_details = 'doc-control/document/:md5/details';
        this.api_doc_control_document_move = 'doc-control/document/:documentId/move';
        this.api_doc_control_document_note = 'doc-control/document/:documentId/note';
        this.api_doc_control_document_revision = 'doc-control/document/:documentId/revision';
        this.api_doc_control_document_soft_link = 'doc-control/document/:documentId/soft-link';
        this.api_doc_control_document_soft_link_event = 'doc-control/document/:documentId/soft-link-event';
        this.api_doc_control_email_registration_details = 'doc-control/email/:messageID/registration-location'
        this.api_doc_control_linked_revisions = 'doc-control/revision/:revisionId/linked';
        this.api_doc_control_multi_node_listing_view = 'doc-control/tree/multi-node/:projectStagePK/type/:type';
        this.api_doc_control_project_tree = 'doc-control/tree/:projectStagePK';
        this.api_doc_control_project_tree_node = 'doc-control/tree/:projectStagePK/node/:treeViewPK';
        this.api_doc_control_project_tree_structure = 'doc-control/tree/:projectStagePK/structure';
        this.api_doc_control_registration_basket = 'doc-control/registration-basket';
        this.api_doc_control_revision = 'doc-control/revision/';
        this.api_doc_control_revision_access_log = 'doc-control/revision/:revisionId/access-log/';
        this.api_doc_control_revision_attachment_collection = 'doc-control/revision/:revisionId/attachment';
        this.api_doc_control_revision_correspondence = 'doc-control/revision/:revisionId/correspondence';
        this.api_doc_control_revision_file = 'doc-control/revision/:revisionId/file';
        this.api_doc_control_revision_registration_location = 'doc-control/revision/registration-location';
        this.api_doc_control_revision_transmittal = 'doc-control/revision/:revisionId/transmittal';
        this.api_doc_control_temporary_document = 'doc-control/temporary-document/';
        this.api_doc_control_temporary_document_file = 'doc-control/temporary-document/:tempDocumentId/file';
        this.api_doc_control_temporary_document_access = 'doc-control/temporary-document/access';
        this.api_doc_control_temporary_document_bulk_register = 'doc-control/temporary-document/bulk-register';
        this.api_doc_control_temporary_document_correspondence = 'doc-control/temporary-document/:temporaryDocumentId/correspondence';
        this.api_doc_control_temporary_document_register = 'doc-control/temporary-document/register';
        this.api_doc_control_tree = 'doc-control_tree/';
        this.api_doc_control_tree_node_name = 'doc-control/tree/:projectStagePK/node/name/:name';
        this.api_doc_control_tree_node_revision = 'doc-control_tree-node-revision/';
        this.api_doc_control_temporary_document_collection = 'doc-control/temporary-document';
        this.api_doc_control_temporary_document_hide = 'doc-control/temporary-document/:temporaryDocumentPK/hide';
        this.api_register = 'registered-message/';
        this.api_register_attachment = 'registered-attachment/';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});

},
'api/doccontrol/Factory':function(){
define([
    '../parser/Collection',
    './DocumentDetails',
    './DocumentCollection',
    './DocumentRevisionCollection',
    './EmailAttachmentRegistrar',
    './EmailCorrespondenceRegistrar',
    './LinkedRevisionCollection',
    './MoveCollection',
    './NoteCollection',
    './Note',
    './ProjectTree',
    './Revision',
    './RevisionAccessLog',
    './RevisionCorrespondence',
    './RevisionCollection',
    './RevisionCollectionUploader',
    './RevisionRegistrationLocation',
    './RevisionTransmittalCollection',
    './SoftLinkCollection',
    './SoftLinkEventCollection',
    './TemporaryDocument',
    './TemporaryDocumentAccess',
    './TemporaryDocumentRegister',
    './TemporaryDocumentCollection',
    './TemporaryDocumentCorrespondence',
    './Tree',
    './TreeNode',
    './TreeNodeRevisionCollection',
    './parser/AccessLog',
    './parser/Correspondence',
    './parser/Document',
    './parser/DocumentDetails',
    './parser/Move',
    './parser/Note',
    './parser/RevisionUpload',
    './parser/SoftLink',
    './parser/SoftLinkEvent',
    './parser/TemporaryDocument',
    'spencer/doc-control/parser/Revision',
    'spencer/doc-control/parser/RevisionTreeNodeCollection',
    'spencer/doc-control/parser/Transmittal',
    'spencer/parse/Collection',
    'spencer/parse/JSONParser',
    './parser/RevisionStatus',
    '@lib/api/doc-control/tree/parser/Node',
    '@lib/api/project/parser/ProjectStage'
], function(
    CollectionParser,
    DocumentDetails,
    DocumentCollection,
    DocumentRevisionCollection,
    EmailAttachmentRegistrar,
    EmailCorrespondenceRegistrar,
    LinkedRevisionCollection,
    MoveCollection,
    NoteCollection,
    Note,
    ProjectTree,
    Revision,
    RevisionAccessLog,
    RevisionCorrespondence,
    RevisionCollection,
    RevisionCollectionUploader,
    RevisionRegistrationLocation,
    RevisionTransmittalCollection,
    SoftLinkCollection,
    SoftLinkEventCollection,
    TemporaryDocument,
    TemporaryDocumentAccess,
    TemporaryDocumentRegister,
    TemporaryDocumentCollection,
    TemporaryDocumentCorrespondence,
    Tree,
    TreeNode,
    TreeNodeRevisionCollection,
    AccessLogParser,
    CorrespondenceParser,
    DocumentParser,
    DocumentDetailsParser,
    MoveParser,
    NoteParser,
    RevisionUploadParser,
    SoftLinkParser,
    SoftLinkEventParser,
    TemporaryDocumentParser,
    RevisionParser,
    RevisionTreeNodeCollectionParser,
    TransmittalParser,
    SpencerCollectionParser,
    JSONParser,
    RevisionStatusParser,
    NodeParser,
    ProjectStageParser
) {
    const Factory = function(
        config,
        urlConnectionBuilder,
        urlResponseProcessorBuilder
    ) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Factory.prototype.getDocumentDetails = function() {
        return new DocumentDetails(
            this.config.getUrl('api_doc_control_document_details', 'v2/'),
            this.urlConnectionBuilder,
            new JSONParser(
                new DocumentDetailsParser()
            ),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getRegistrableEmailCorrespondence = function() {
        return new EmailCorrespondenceRegistrar(
            this.config.getUrl('api_register'),
            this.urlConnectionBuilder.build()
        );
    };

    Factory.prototype.getRegistrableEmailAttachment = function() {
        return new EmailAttachmentRegistrar(
            this.config.getUrl('api_register_attachment'),
            this.urlConnectionBuilder.build()
        );
    };

    Factory.prototype.getRevision = function(isV2) {
        return new Revision(
            this.config.getUrl('api_doc_control_revision', isV2 ? 'v2/' : ''),
            this.urlConnectionBuilder,
            new CollectionParser(
                new RevisionParser(
                    new RevisionStatusParser()
                )
            ),
            new RevisionParser(
                new RevisionStatusParser()
            ),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getCorrespondence = function() {
        return new RevisionCorrespondence(
            this.config.getUrl('api_doc_control_revision_correspondence'),
            this.urlConnectionBuilder,
            new CollectionParser(new CorrespondenceParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getTemporaryDocumentCorrespondence = function() {
        return new TemporaryDocumentCorrespondence(
            this.config.getUrl('api_doc_control_temporary_document_correspondence'),
            this.urlConnectionBuilder,
            new CollectionParser(new CorrespondenceParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getRevisionAccessLog = function() {
        return new RevisionAccessLog(
            this.config.getUrl('api_doc_control_revision_access_log'),
            this.urlConnectionBuilder,
            new CollectionParser(new AccessLogParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getRevisionCollection = function() {
        return new RevisionCollection(
            this.config.getUrl('api_doc_control_revision'),
            this.urlConnectionBuilder,
            new CollectionParser(
                new RevisionParser(
                    new RevisionStatusParser()
                )),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getDocumentRevisionCollection = function() {
        return new DocumentRevisionCollection(
            this.config.getUrl('api_doc_control_document_revision'),
            this.urlConnectionBuilder,
            new CollectionParser(
                new RevisionParser(
                    new RevisionStatusParser()
                )
            ),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getLinkedRevisionCollection = function() {
        return new LinkedRevisionCollection(
            this.config.getUrl('api_doc_control_linked_revisions'),
            this.urlConnectionBuilder,
            new CollectionParser(new RevisionParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getProjectTree = function() {
        const parser = new JSONParser(new NodeParser(new RevisionParser(), new ProjectStageParser()));

        return new ProjectTree(
            this.config.getUrl('api_doc_control_project_tree', 'v2/'),
            this.urlConnectionBuilder.build(),
            parser,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getRevisionCollectionUploader = function() {
        return new RevisionCollectionUploader(
            this.config.getUrl('api_doc_control_revision'),
            this.urlConnectionBuilder,
            new CollectionParser(new RevisionUploadParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getRevisionRegistrationLocation = function() {
        return new RevisionRegistrationLocation(
            this.config.getUrl('api_doc_control_revision_registration_location'),
            this.urlConnectionBuilder,
            new CollectionParser(new NodeParser(new RevisionParser(), new ProjectStageParser())),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getRevisionTransmittalCollection = function() {
        return new RevisionTransmittalCollection(
            this.config.getUrl('api_doc_control_revision_transmittal'),
            this.urlConnectionBuilder,
            new CollectionParser(TransmittalParser),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getTemporaryDocument = function() {
        return new TemporaryDocument(
            this.config.getUrl('api_doc_control_temporary_document'),
            this.urlConnectionBuilder,
            new CollectionParser(new TemporaryDocumentParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getTemporaryDocumentAccess = function() {
        return new TemporaryDocumentAccess(
            this.config.getUrl('api_doc_control_temporary_document_access'),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getTemporaryDocumentRegister = function() {
        return new TemporaryDocumentRegister(
            this.config.getUrl('api_doc_control_temporary_document_register'),
            this.urlConnectionBuilder
        );
    };

    Factory.prototype.getTemporaryDocumentCollection = function() {
        return new TemporaryDocumentCollection(
            this.config.getUrl('api_doc_control_temporary_document'),
            this.urlConnectionBuilder,
            new CollectionParser(new TemporaryDocumentParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getDocumentCollection = function() {
        return new DocumentCollection(
            this.config.getUrl('api_doc_control_document'),
            this.urlConnectionBuilder,
            new CollectionParser(new DocumentParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getTree = function() {
        const collectionParser = new CollectionParser(new NodeParser(new RevisionParser(), new ProjectStageParser()));
        collectionParser.setIsSingleItemCollection(true);

        return new Tree(
            this.config.getUrl('api_doc_control_tree'),
            this.urlConnectionBuilder.build(),
            collectionParser,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getTreeNode = function() {
        const parser = new JSONParser(new NodeParser(new RevisionParser(), new ProjectStageParser()));

        return new TreeNode(
            this.config.getUrl('api_doc_control_tree_node_name', 'v2/'),
            this.urlConnectionBuilder.build(),
            parser,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getTreeNodeRevisionCollection = function() {
        return new TreeNodeRevisionCollection(
            this.config.getUrl('api_doc_control_tree_node_revision'),
            this.urlConnectionBuilder.build(),
            new CollectionParser(
                new RevisionParser(
                    new RevisionStatusParser()
                )
            ),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getSoftLinkCollection = function() {
        return new SoftLinkCollection(
            this.config.getUrl('api_doc_control_document_soft_link'),
            this.urlConnectionBuilder.build(),
            new CollectionParser(new SoftLinkParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getSoftLinkEventCollection = function() {
        return new SoftLinkEventCollection(
            this.config.getUrl('api_doc_control_document_soft_link_event'),
            this.urlConnectionBuilder.build(),
            new CollectionParser(new SoftLinkEventParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getMoveCollection = function() {
        return new MoveCollection(
            this.config.getUrl('api_doc_control_document_move'),
            this.urlConnectionBuilder.build(),
            new CollectionParser(new MoveParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getNoteCollection = function() {
        return new NoteCollection(
            this.config.getUrl('api_doc_control_document_note'),
            this.urlConnectionBuilder.build(),
            new CollectionParser(new NoteParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getNote = function() {
        return new Note(
            this.config.getUrl('api_doc_control_document_note', 'v2/'),
            this.urlConnectionBuilder.build(),
            this.urlResponseProcessorBuilder,
            new JSONParser(new NoteParser())
        );
    };

    Factory.prototype.getRevisionTreeNodeCollectionParser = function() {
        return new RevisionTreeNodeCollectionParser();
    };

    return Factory;
});

},
'api/doccontrol/DocumentDetails':function(){
define([], function() {
    const DocumentDetails = function(url, urlConnectionBuilder, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    DocumentDetails.prototype.get = function(handlers, md5) {
        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url.replace(':md5', md5));

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };
    
    return DocumentDetails;
});
},
'api/doccontrol/DocumentCollection':function(){
define([], function() {
    const DocumentCollection = function(url, urlConnectionBuilder, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.parser = parser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.fileKeys = [];

        this.constants = {
            URL_PARAM_FILEKEYS: 'fileKeys[]',
            URL_PARAM_MD5S: 'md5s[]'
        };

        this.createBasicQuery = function() {
            let q = {};

            if (this.fileKeys) {
                q[this.constants.URL_PARAM_FILEKEYS] = this.fileKeys;
            }

            if (this.md5s) {
                q[this.constants.URL_PARAM_MD5S] = this.md5s;
            }

            return q;
        };
    };

    DocumentCollection.prototype.setFileKeys = function(fileKeys) {
        this.fileKeys = fileKeys;
        return this;
    };

    DocumentCollection.prototype.setMd5s = function(md5s) {
        this.md5s = md5s;
        return this;
    };

    DocumentCollection.prototype.fetch = function(handlersVO) {
        let urlConnection = this.urlConnectionBuilder.build();

        urlConnection.setUrl(this.url);
        urlConnection.setQuery(this.createBasicQuery());
        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlersVO.getSuccess(),
                handlersVO.getError()
            )
        );
        urlConnection.setProgressHandler(handlersVO.getProgress());
        urlConnection.setUnauthorisedHandler(handlersVO.getUnauthorised());
        urlConnection.setErrorHandler(handlersVO.getError());

        return urlConnection.get();
    };

    DocumentCollection.prototype.create = function(handlersVO) {
        let urlConnection = this.urlConnectionBuilder.build();

        urlConnection.setUrl(this.url);
        urlConnection.setQuery(this.createBasicQuery());
        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlersVO.getSuccess(),
                handlersVO.getError()
            )
        );
        urlConnection.setProgressHandler(handlersVO.getProgress());
        urlConnection.setUnauthorisedHandler(handlersVO.getUnauthorised());
        urlConnection.setErrorHandler(handlersVO.getError());

        return urlConnection.post();
    };

    return DocumentCollection;
});

},
'api/doccontrol/DocumentRevisionCollection':function(){
define([], function() {
    var DocumentRevisionCollection = function(url, urlConnectionBuilder, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    DocumentRevisionCollection.prototype.fetch = function(handlers, revisionVO) {
        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url.replace(':documentId', revisionVO.getDocumentPK()));

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    DocumentRevisionCollection.prototype.fetchForCollection = function(handlers, revisionCollection) {
        const urlConnection = this.urlConnectionBuilder.build();

        let documentPKs = revisionCollection.map(function(revision) { return revision.getDocumentPK(); }).join();

        urlConnection.setUrl(this.url.replace(':documentId', documentPKs));

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    return DocumentRevisionCollection;
});

},
'api/doccontrol/EmailAttachmentRegistrar':function(){
define([], function() {
    const URL_PARAM_FOLDER_ID = 'folderId',
          URL_PARAM_GUID = 'guid',
          URL_PARAM_MESSAGE_ID = 'messageId',
          URL_PARAM_MD5 = 'md5',
          URL_PARAM_PROJECT_STAGE_PK = 'projectStagePK',
          URL_PARAM_TREE_VIEW_PK = 'treeViewPK',
          URL_PARAM_NODE_TYPE = 'type',
          URL_PARAM_NODE_REFERENCE = 'nodeReference',
          URL_PARAM_PERSON_PK = 'personPK',
          URL_PARAM_OFFICE_PK = 'officePK',
          URL_PARAM_RECIPIENT_PERSON_PK = 'recipientPersonPK',
          URL_PARAM_RECIPIENT_BRANCH_OFFICE_PK = 'recipientBranchOfficePK',
          URL_PARAM_TITLE = 'title',
          URL_PARAM_DATE = 'date',
          URL_PARAM_PRIVATE = 'private',
          URL_PARAM_DISCIPLINE = 'discipline',
          URL_PARAM_REVISION = 'revision',
          URL_PARAM_REFERENCE = 'reference',
          URL_PARAM_STATUS = 'status',
          URL_PARAM_QUICK_REGISTER = 'quickRegister';

    const EmailAttachmentRegistrar = function(url, urlConnection) {
        this.url = url;
        this.urlConnection = urlConnection;

        this.folderVO = null;
        this.messageData = null;
        this.registrationDetails = null;

        this.createBasicQuery = function() {
            const q = {};

            if (this.folderVO) {
                q[URL_PARAM_FOLDER_ID] = this.folderVO.getFolderId();
            }

            return q;
        };

        this.createFormFields = function(md5) {
            const f = {};

            f[URL_PARAM_GUID] = this.messageData.getGuid();
            f[URL_PARAM_MESSAGE_ID] = this.messageData.getMessageID();
            f[URL_PARAM_MD5] = md5;

            if (this.treeViewPK) {
                f[URL_PARAM_TREE_VIEW_PK] = this.treeViewPK;
            }

            if (this.registrationDetails) {
                if (this.registrationDetails.getProjectStagePK()) f[URL_PARAM_PROJECT_STAGE_PK] = this.registrationDetails.getProjectStagePK();
                if (this.registrationDetails.getTreeViewPK()) f[URL_PARAM_TREE_VIEW_PK] = this.registrationDetails.getTreeViewPK();
                if (this.registrationDetails.getType()) f[URL_PARAM_NODE_TYPE] = this.registrationDetails.getType();
                if (this.registrationDetails.getNodeReference()) f[URL_PARAM_NODE_REFERENCE] = this.registrationDetails.getNodeReference();
                if (this.registrationDetails.getPersonPK()) f[URL_PARAM_PERSON_PK] = this.registrationDetails.getPersonPK();
                if (this.registrationDetails.getBranchOfficePK()) f[URL_PARAM_OFFICE_PK] = this.registrationDetails.getBranchOfficePK();
                if (this.registrationDetails.getRecipientContact()) {
                    const contact = this.registrationDetails.getRecipientContact();

                    if (contact.getPersonPK()) f[URL_PARAM_RECIPIENT_PERSON_PK] = contact.getPersonPK();
                    if (contact.getBranchOfficePK()) f[URL_PARAM_RECIPIENT_BRANCH_OFFICE_PK] = contact.getBranchOfficePK();
                }
                if (this.registrationDetails.getTitle()) f[URL_PARAM_TITLE] = this.registrationDetails.getTitle();
                if (this.registrationDetails.getDate()) f[URL_PARAM_DATE] = this.registrationDetails.getDate();
                if (this.registrationDetails.isPrivate()) f[URL_PARAM_PRIVATE] = this.registrationDetails.isPrivate();
                if (this.registrationDetails.getDiscipline()) f[URL_PARAM_DISCIPLINE] = this.registrationDetails.getDiscipline();
                if (this.registrationDetails.getRevision()) f[URL_PARAM_REVISION] = this.registrationDetails.getRevision();
                if (this.registrationDetails.getReference()) f[URL_PARAM_REFERENCE] = this.registrationDetails.getReference();
                if (this.registrationDetails.getStatus()) f[URL_PARAM_STATUS] = this.registrationDetails.getStatus();
                if (this.registrationDetails.isQuickRegister()) f[URL_PARAM_QUICK_REGISTER] = true;
            }

            return f;
        };
    };

    EmailAttachmentRegistrar.prototype.changeFolder = function(folderVO) {
        this.folderVO = folderVO;
        return this;
    };

    EmailAttachmentRegistrar.prototype.setVO = function(messageData) {
        this.messageData = messageData;
        return this;
    };

    EmailAttachmentRegistrar.prototype.setTreeViewPK = function(treeViewPK) {
        this.treeViewPK = treeViewPK;
        return this;
    };

    EmailAttachmentRegistrar.prototype.setRevisionDetails = function(registrationDetailsData) {
        this.registrationDetails = registrationDetailsData;
        return this;
    };

    EmailAttachmentRegistrar.prototype.register = function(md5, handlers) {
        this.urlConnection.setUrl(this.url + md5);
        this.urlConnection.setQuery(this.createBasicQuery());
        this.urlConnection.setData(this.createFormFields(md5));
        this.urlConnection.setSuccessHandler(handlers.getSuccess());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.put();
    };

    return EmailAttachmentRegistrar;
});
},
'api/doccontrol/EmailCorrespondenceRegistrar':function(){
define([], function() {
    const EmailCorrespondenceRegistrar = function(url, urlConnection) {
        this.url = url;
        this.urlConnection = urlConnection;

        this.folderVO = null;
        this.messageVO = null;

        this.constants = {
            URL_PARAM_FOLDER_ID: 'folderId',
            URL_PARAM_PROJECT_STAGE_ID: 'projectStagePK',
            URL_PARAM_REGISTER_ATTACHMENTS: 'registerAttachments',
            URL_PARAM_TITLE: 'title'
        };

        this.createBasicQuery = function() {
            const q = {};
            if (this.folderVO) q[this.constants.URL_PARAM_FOLDER_ID] = this.folderVO.getFolderId();
            return q;
        };

        this.createFormFields = function(projectStageVO, title) {
            const f = {};
            f[this.constants.URL_PARAM_PROJECT_STAGE_ID] = projectStageVO.getProjectStagePK();
            if (title) f[this.constants.URL_PARAM_TITLE] = title;
            return f;
        };
    };

    EmailCorrespondenceRegistrar.prototype.changeFolder = function(folderVO) {
        this.folderVO = folderVO;
    };

    EmailCorrespondenceRegistrar.prototype.setVO = function(messageVO) {
        this.messageVO = messageVO;
    };

    EmailCorrespondenceRegistrar.prototype.register = function(projectStageVO, title, handlers) {
        this.urlConnection.setUrl(this.url + this.messageVO.getUid());
        this.urlConnection.setQuery(this.createBasicQuery());
        this.urlConnection.setData(this.createFormFields(projectStageVO, title));
        this.urlConnection.setSuccessHandler(handlers.getSuccess());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.put();
    };

    return EmailCorrespondenceRegistrar;
});
},
'api/doccontrol/LinkedRevisionCollection':function(){
define([], function() {
    var LinkedRevisionCollection = function(url, urlConnectionBuilder, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    LinkedRevisionCollection.prototype.fetch = function(handlers, revisionVO) {
        var urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url.replace(':revisionId', revisionVO.getRevisionPK()));

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    return LinkedRevisionCollection;
});

},
'api/doccontrol/MoveCollection':function(){
define([], function() {
    const MoveCollection = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    MoveCollection.prototype.get = function(handlers, documentPK) {
        const urlConnection = this.urlConnection;
        urlConnection.setUrl(this.url.replace(':documentId', documentPK));

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    return MoveCollection;
});

},
'api/doccontrol/NoteCollection':function(){
define([], function() {
    return class NoteCollection {
        constructor(url, urlConnection, parser, urlResponseProcessorBuilder) {
            this.url = url;
            this.urlConnection = urlConnection;
            this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
            this.parser = parser;
        }

        get(handlers, documentPK) {
            this.urlConnection.setUrl(this.url.replace(':documentId', documentPK));

            this.urlConnection.setSuccessHandler(
                this.urlResponseProcessorBuilder.createProcessor(
                    this.parser,
                    handlers.getSuccess(),
                    handlers.getError()
                )
            );
            this.urlConnection.setProgressHandler(handlers.getProgress());
            this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
            this.urlConnection.setErrorHandler(handlers.getError());

            return this.urlConnection.get();
        }
    };
});

},
'api/doccontrol/Note':function(){
define([], function() {
    return class Note {
        constructor(url, urlConnection, urlResponseProcessorBuilder, parser) {
            this.url = url;
            this.urlConnection = urlConnection;
            this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
            this.parser = parser;
        }

        add(handlers, note) {
            this.urlConnection.setUrl(this.url.replace(':documentId', note.getDocumentPK()));
            this.urlConnection.setData(this._createQuery(note));

            this.urlConnection.setSuccessHandler(
                this.urlResponseProcessorBuilder.createProcessor(
                    this.parser,
                    handlers.getSuccess(),
                    handlers.getError()
                )
            );
            this.urlConnection.setProgressHandler(handlers.getProgress());
            this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
            this.urlConnection.setErrorHandler(handlers.getError());

            return this.urlConnection.post();
        }

        _createQuery(note) {
            const q = {};

            q['note'] = note.getNote();

            return q;
        }
    };
});

},
'api/doccontrol/ProjectTree':function(){
define([], function() {
    const QUERY_PARAM_NAME = 'name';

    const ProjectTree = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this._createUrl = function(projectStagePK) {
            let params = {
                ':projectStagePK': projectStagePK
            };

            const re = new RegExp(Object.keys(params).join("|"),"gi");
            return this.url.replace(re, function(matched){
                return params[matched];
            });
        };

        this._createQuery = function(name) {
            const q = {};

            q[QUERY_PARAM_NAME] = name;

            return q;
        };
    };

    ProjectTree.prototype.get = function(handlers, projectStagePK) {
        this.urlConnection.setUrl(this._createUrl(projectStagePK));
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());
        this.urlConnection.setAbortHandler(handlers.getAbort());

        if (handlers.getForbidden()) {
            this.urlConnection.setForbiddenHandler(handlers.getForbidden());
        }

        return this.urlConnection.get();
    };

    ProjectTree.prototype.getByName = function(handlers, projectStagePK, name) {
        this.urlConnection.setUrl(this._createUrl(projectStagePK));
        this.urlConnection.setQuery(this._createQuery(name));
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());
        this.urlConnection.setAbortHandler(handlers.getAbort());

        if (handlers.getForbidden()) {
            this.urlConnection.setForbiddenHandler(handlers.getForbidden());
        }

        return this.urlConnection.get();
    };

    return ProjectTree;
});
},
'api/doccontrol/Revision':function(){
define([], function() {
    const Revision = function(url, urlConnectionBuilder, parser, singleParser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
        this.singleParser = singleParser;
    };

    Revision.prototype.get = function(handlers, revisionVO) {
        this.parser.setIsSingleItemCollection(true);
        
        var urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url + (revisionVO.getRevisionPK() || revisionVO.getMd5()));

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    Revision.prototype.getByReferenceAndNode = function(handlers, reference, node) {
        this.parser.setIsSingleItemCollection(true);

        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url + 'reference/' + reference);
        urlConnection.setQuery({
            projectStagePK: node.getProjectStage().getProjectStagePK(),
            treeViewPK: node.getProjectStageTreeViewPK()
        });

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.singleParser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    Revision.prototype.patch = function(handlers, revisionPK, data) {
        const connection = this.urlConnectionBuilder.build();

        connection.setUrl(this.url + revisionPK);
        connection.setData(data);

        connection.setSuccessHandler(handlers.getSuccess());
        connection.setConflictHandler(handlers.getConflict());
        connection.setErrorHandler(handlers.getError());
        connection.setAbortHandler(handlers.getAbort());
        connection.setProgressHandler(handlers.getProgress());
        connection.setUnauthorisedHandler(handlers.getUnauthorised());

        return connection.patch();
    };
    
    return Revision;
});
},
'api/doccontrol/RevisionAccessLog':function(){
define([], function() {
    var RevisionAccessLog = function(url, urlConnectionBuilder, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this.constants = {
            ACCESS_DOWNLOAD: 'download',
            ACCESS_VIEW: 'view',
            URL_PARAM_TYPE: 'type'
        };

        this.log = function(handlers, revisionVO, data) {
            var urlConnection = this.urlConnectionBuilder.build();
            urlConnection.setUrl(this.url.replace(':revisionId', revisionVO.getRevisionPK() || revisionVO.getMd5()));
            urlConnection.setData(data);
            urlConnection.setSuccessHandler(handlers.getSuccess());
            urlConnection.setProgressHandler(handlers.getProgress());
            urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
            urlConnection.setErrorHandler(handlers.getError());
            urlConnection.setAbortHandler(handlers.getAbort());

            return urlConnection.post();
        };
    };

    RevisionAccessLog.prototype.fetch = function(handlers, revisionVO) {
        var urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url.replace(':revisionId', revisionVO.getRevisionPK()));

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    RevisionAccessLog.prototype.logView = function(handlers, revisionVO) {
        var data = {};
        data[this.constants.URL_PARAM_TYPE] = this.constants.ACCESS_VIEW;

        return this.log(handlers, revisionVO, data);
    };

    RevisionAccessLog.prototype.logDownload = function(handlers, revisionVO) {
        var data = {};
        data[this.constants.URL_PARAM_TYPE] = this.constants.ACCESS_DOWNLOAD;

        return this.log(handlers, revisionVO, data);
    };

    return RevisionAccessLog;
});
},
'api/doccontrol/RevisionCorrespondence':function(){
define([], function() {
    var RevisionCorrespondence = function(url, urlConnectionBuilder, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    RevisionCorrespondence.prototype.get = function(handlers, revisionVO) {
        this.parser.setIsSingleItemCollection(true);

        var urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url.replace(':revisionId', revisionVO.getRevisionPK() || revisionVO.getMd5()));

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());
        urlConnection.setGoneHandler(handlers.getGone());

        return urlConnection.get();
    };

    return RevisionCorrespondence;
});
},
'api/doccontrol/RevisionCollection':function(){
define([], function() {
    var RevisionCollection = function(url, urlConnectionBuilder, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.parser = parser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.revisionPKs = [];

        this.constants = {
            URL_PARAM_REVISIONPKS: 'revisionPKs[]'
        };

        this.createBasicQuery = function() {
            var q = {};

            if (this.revisionPKs) {
                q[this.constants.URL_PARAM_REVISIONPKS] = this.revisionPKs;
            }

            return q;
        };
    };

    RevisionCollection.prototype.setRevisionPKs = function(revisionPKs) {
        this.revisionPKs = revisionPKs;
    };

    RevisionCollection.prototype.fetch = function(handlersVO) {
        var urlConnection = this.urlConnectionBuilder.build();

        urlConnection.setUrl(this.url);
        urlConnection.setQuery(this.createBasicQuery());
        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlersVO.getSuccess(),
                handlersVO.getError()
            )
        );
        urlConnection.setProgressHandler(handlersVO.getProgress());
        urlConnection.setUnauthorisedHandler(handlersVO.getUnauthorised());
        urlConnection.setErrorHandler(handlersVO.getError());

        return urlConnection.get();
    };

    return RevisionCollection;
});

},
'api/doccontrol/RevisionCollectionUploader':function(){
define([], function() {
    var RevisionCollectionUploader = function(url, urlConnectionBuilder, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
        this.registrationLocationKeyVO = null;
        this.registrationLocationVO = null;

        this.constants = {
            PARAM_PROJECT_STAGE_PK: 'projectStagePK',
            PARAM_PROJECT_STAGE_TREE_VIEW_NAME: 'projectStageTreeViewName',
            PARAM_PROJECT_STAGE_TREE_VIEW_TYPE: 'projectStageTreeViewType',
            PARAM_PROJECT_REGISTRATION_LOCATION_KEY: 'registrationLocationKey'
        };

        this.generateData = function() {
            var data = {};

            // Key takes priority
            if (this.registrationLocationKeyVO) {
                data[this.constants.PARAM_PROJECT_STAGE_PK] = this.registrationLocationKeyVO.getProjectStagePK();
                data[this.constants.PARAM_PROJECT_REGISTRATION_LOCATION_KEY] = this.registrationLocationKeyVO.getKey();
            } else {
                data[this.constants.PARAM_PROJECT_STAGE_PK] = this.registrationLocationVO.getProjectStagePK();
                data[this.constants.PARAM_PROJECT_STAGE_TREE_VIEW_NAME] = this.registrationLocationVO.getProjectStageTreeViewName();
                data[this.constants.PARAM_PROJECT_STAGE_TREE_VIEW_TYPE] = this.registrationLocationVO.getProjectStageTreeViewType();
            }

            return data;
        };
    };

    RevisionCollectionUploader.prototype.setRegistrationLocationKeyVO = function(registrationLocationKeyVO) {
        this.registrationLocationKeyVO = registrationLocationKeyVO;
    };

    RevisionCollectionUploader.prototype.setRegistrationLocationVO = function(registrationLocationVO) {
        this.registrationLocationVO = registrationLocationVO;
    };

    RevisionCollectionUploader.prototype.upload = function(handlersVO, form) {
        var urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url);
        
        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlersVO.getSuccess(),
                handlersVO.getError()
            )
        );
        urlConnection.setProgressHandler(handlersVO.getProgress());
        urlConnection.setUnauthorisedHandler(handlersVO.getUnauthorised());
        urlConnection.setErrorHandler(handlersVO.getError());
        urlConnection.setForm(form);
        urlConnection.setData(this.generateData());

        return urlConnection.post();
    };

    return RevisionCollectionUploader;
});
},
'api/doccontrol/RevisionRegistrationLocation':function(){
define([], function() {
    var RevisionRegistrationLocation = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        const URL_PARAM_REVISIONPKS = 'revisionPKs[]';

        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this.createBasicQuery = function(revisionCollection) {
            let q = {};

            if (revisionCollection) {
                q[URL_PARAM_REVISIONPKS] = Array.isArray(revisionCollection)
                    ? revisionCollection.map(function(revision) { return revision.getRevisionPK(); })
                    : [revisionCollection.getRevisionPK()];
            }

            return q;
        };
    };

    RevisionRegistrationLocation.prototype.fetch = function(handlers, revisionCollection) {
        let urlConnection = this.urlConnection.build();

        urlConnection.setUrl(this.url);
        urlConnection.setQuery(this.createBasicQuery(revisionCollection));

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());
        urlConnection.setAbortHandler(handlers.getAbort());

        return urlConnection.get();
    };

    return RevisionRegistrationLocation;
});
},
'api/doccontrol/RevisionTransmittalCollection':function(){
define([], function() {
    const RevisionTransmittalCollection = function(url, urlConnectionBuilder, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    RevisionTransmittalCollection.prototype.fetch = function(handlers, revisionVO) {
        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url.replace(':revisionId', revisionVO.getRevisionPK()));

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    return RevisionTransmittalCollection;
});

},
'api/doccontrol/SoftLinkCollection':function(){
define([], function() {
    const SoftLinkCollection = function(url, urlConnectionBuilder, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    SoftLinkCollection.prototype.get = function(handlers, documentPK) {
        const urlConnection = this.urlConnectionBuilder;
        urlConnection.setUrl(this.url.replace(':documentId', documentPK));

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    return SoftLinkCollection;
});

},
'api/doccontrol/SoftLinkEventCollection':function(){
define([], function() {
    return class SoftLinkEventCollection {
        constructor(url, urlConnectionBuilder, parser, urlResponseProcessorBuilder) {
            this.url = url;
            this.urlConnectionBuilder = urlConnectionBuilder;
            this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
            this.parser = parser;
        }

        get(handlers, documentPK) {
            this.urlConnectionBuilder.setUrl(this.url.replace(':documentId', documentPK));

            this.urlConnectionBuilder.setSuccessHandler(
                this.urlResponseProcessorBuilder.createProcessor(
                    this.parser,
                    handlers.getSuccess(),
                    handlers.getError()
                )
            );
            this.urlConnectionBuilder.setProgressHandler(handlers.getProgress());
            this.urlConnectionBuilder.setUnauthorisedHandler(handlers.getUnauthorised());
            this.urlConnectionBuilder.setErrorHandler(handlers.getError());

            return this.urlConnectionBuilder.get();
        }
    }
});

},
'api/doccontrol/TemporaryDocument':function(){
define([], function() {
    var TemporaryDocument = function(url, urlConnectionBuilder, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    TemporaryDocument.prototype.get = function(handlers, temporaryDocumentVO) {
        this.parser.setIsSingleItemCollection(true);

        var urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url + (temporaryDocumentVO.getTemporaryDocumentPK() || temporaryDocumentVO.getMd5()));

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    return TemporaryDocument;
});

},
'api/doccontrol/TemporaryDocumentAccess':function(){
define([], function() {
    const TemporaryDocument = function(url, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;

        this.createBasicQuery = function(md5, makePublic) {
            let q = {};

            if (md5) {
                q['md5'] = md5;
            }

            q['public'] = makePublic ? true : false;

            return q;
        };
    };

    TemporaryDocument.prototype.makePublic = function(handlers, md5) {
        const urlConnection = this.urlConnectionBuilder.build();

        urlConnection.setUrl(this.url);
        urlConnection.setQuery(this.createBasicQuery(md5, true));
        urlConnection.setSuccessHandler(handlers.getSuccess());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.put();
    };

    TemporaryDocument.prototype.revokePublic = function(handlers, md5) {
        const urlConnection = this.urlConnectionBuilder.build();

        urlConnection.setUrl(this.url);
        urlConnection.setQuery(this.createBasicQuery(md5, false));
        urlConnection.setSuccessHandler(handlers.getSuccess());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.put();
    };

    return TemporaryDocument;
});

},
'api/doccontrol/TemporaryDocumentRegister':function(){
define([], function() {
    const PARAM_DATE = 'date';
    const PARAM_DISCIPLINE = 'discipline';
    const PARAM_MD5 = 'md5';
    const PARAM_PERSON_PK = 'personPK';
    const PARAM_OFFICE_PK = 'officePK';
    const PARAM_PRIVATE = 'private';
    const PARAM_PROJECT_STAGE_PK = 'projectStagePK';
    const PARAM_RECIPIENT_PERSON_PK = 'recipientPersonPK';
    const PARAM_RECIPIENT_BRANCH_OFFICE_PK = 'recipientBranchOfficePK';
    const PARAM_REFERENCE = 'reference';
    const PARAM_REVISION = 'revision';
    const PARAM_STATUS = 'status';
    const PARAM_TREE_VIEW_PK = 'treeViewPK';
    const PARAM_TITLE = 'title';
    const PARAM_TYPE = 'type';

    const TemporaryDocumentRegister = function(url, urlConnectionBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
    };

    TemporaryDocumentRegister.prototype.register = function(handlers, registrationDetails) {
        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url);

        const data = {};

        if (registrationDetails.getTreeViewPK()) data[PARAM_TREE_VIEW_PK] = registrationDetails.getTreeViewPK();
        if (registrationDetails.getMd5()) data[PARAM_MD5] = registrationDetails.getMd5();
        if (registrationDetails.getType()) data[PARAM_TYPE] = registrationDetails.getType();
        if (registrationDetails.getPersonPK()) data[PARAM_PERSON_PK] = registrationDetails.getPersonPK();
        if (registrationDetails.getBranchOfficePK()) data[PARAM_OFFICE_PK] = registrationDetails.getBranchOfficePK();
        if (registrationDetails.getRecipientContact()) {
            const contact = registrationDetails.getRecipientContact();

            if (contact.getPersonPK()) data[PARAM_RECIPIENT_PERSON_PK] = contact.getPersonPK();
            if (contact.getBranchOfficePK()) data[PARAM_RECIPIENT_BRANCH_OFFICE_PK] = contact.getBranchOfficePK();
        }
        if (registrationDetails.getTitle()) data[PARAM_TITLE] = registrationDetails.getTitle();
        if (registrationDetails.getDate()) data[PARAM_DATE] = registrationDetails.getDate();
        if (registrationDetails.isPrivate()) data[PARAM_PRIVATE] = registrationDetails.isPrivate();
        if (registrationDetails.getDiscipline()) data[PARAM_DISCIPLINE] = registrationDetails.getDiscipline();
        if (registrationDetails.getReference()) data[PARAM_REFERENCE] = registrationDetails.getReference();
        if (registrationDetails.getRevision()) data[PARAM_REVISION] = registrationDetails.getRevision();
        if (registrationDetails.getStatus()) data[PARAM_STATUS] = registrationDetails.getStatus();
        if (registrationDetails.getProjectStagePK()) data[PARAM_PROJECT_STAGE_PK] = registrationDetails.getProjectStagePK();

        urlConnection.setData(data);

        urlConnection.setSuccessHandler(handlers.getSuccess());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());
        urlConnection.setConflictHandler(handlers.getConflict());

        return urlConnection.post();
    };

    return TemporaryDocumentRegister;
});

},
'api/doccontrol/TemporaryDocumentCollection':function(){
define([], function() {
    const TemporaryDocumentCollection = function(url, urlConnectionBuilder, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.parser = parser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.md5s = [];

        this.constants = {
            URL_PARAM_MD5: 'md5s[]'
        };

        this.createBasicQuery = function() {
            let q = {};

            if (this.md5s) {
                q[this.constants.URL_PARAM_MD5] = this.md5s;
            }

            return q;
        };
    };

    TemporaryDocumentCollection.prototype.setMd5s = function(md5s) {
        this.md5s = md5s;
    };

    TemporaryDocumentCollection.prototype.fetch = function(handlersVO) {
        let urlConnection = this.urlConnectionBuilder.build();

        urlConnection.setUrl(this.url);
        urlConnection.setQuery(this.createBasicQuery());
        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlersVO.getSuccess(),
                handlersVO.getError()
            )
        );
        urlConnection.setProgressHandler(handlersVO.getProgress());
        urlConnection.setUnauthorisedHandler(handlersVO.getUnauthorised());
        urlConnection.setErrorHandler(handlersVO.getError());

        return urlConnection.get();
    };

    return TemporaryDocumentCollection;
});

},
'api/doccontrol/TemporaryDocumentCorrespondence':function(){
define([], function() {
    const TemporaryDocumentCorrespondence = function(url, urlConnectionBuilder, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    TemporaryDocumentCorrespondence.prototype.get = function(handlers, temporaryDocumentVO) {
        this.parser.setIsSingleItemCollection(true);

        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(
            this.url.replace(':temporaryDocumentId', temporaryDocumentVO.getTemporaryDocumentPK() || temporaryDocumentVO.getMd5())
        );

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    return TemporaryDocumentCorrespondence;
});
},
'api/doccontrol/Tree':function(){
define([
    './filter/IncludeDocumentCount',
    './filter/ShowOnlyNodesContainingDocuments'
], function(
    FilterIncludeDocumentCount,
    FilterShowOnlyNodesContainingDocuments
) {
    const URL_PARAM_INCLUDE_DOC_COUNT = 'includeDocumentCount',
          URL_PARAM_SHOW_ONLY_NODES_CONTAINING_DOCUMENTS = 'showOnlyNodesContainingDocuments';

    const Tree = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this._createBasicQuery = function(filterCollection) {
            let query = {};

            if(!filterCollection) {
                return query;
            }

            let includeDocumentCount = filterCollection.getFilterByClass(FilterIncludeDocumentCount);
            if (includeDocumentCount) {
                query[URL_PARAM_INCLUDE_DOC_COUNT] = true;
            }

            let showOnlyNodesContainingDocuments = filterCollection.getFilterByClass(FilterShowOnlyNodesContainingDocuments);
            if (showOnlyNodesContainingDocuments) {
                query[URL_PARAM_SHOW_ONLY_NODES_CONTAINING_DOCUMENTS] = true;
            }

            return query;
        };
    };

    Tree.prototype.get = function(handlers, projectStagePK, filterCollection) {
        this.urlConnection.setUrl(this.url + projectStagePK);
        this.urlConnection.setQuery(this._createBasicQuery(filterCollection));
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());
        this.urlConnection.setAbortHandler(handlers.getAbort());

        return this.urlConnection.get();
    };

    return Tree;
});
},
'api/doccontrol/filter/IncludeDocumentCount':function(){
define([], function() {
    return function() {}
});
},
'api/doccontrol/filter/ShowOnlyNodesContainingDocuments':function(){
define([], function() {
    return function() {};
});
},
'api/doccontrol/TreeNode':function(){
define([], function() {
    const TreeNode = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this._createUrl = function(projectStagePK, name) {
            let params = {
                ':projectStagePK': projectStagePK,
                ':name': name
            };

            const re = new RegExp(Object.keys(params).join("|"),"gi");
            return this.url.replace(re, function(matched){
                return params[matched];
            });
        }
    };

    TreeNode.prototype.getByName = function(handlers, projectStagePK, name) {
        this.urlConnection.setUrl(this._createUrl(projectStagePK, name));
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());
        this.urlConnection.setAbortHandler(handlers.getAbort());

        return this.urlConnection.get();
    };

    return TreeNode;
});
},
'api/doccontrol/TreeNodeRevisionCollection':function(){
define([
    './filter/DocumentTitle',
    './filter/ProjectStagePK',
    './filter/ProjectStageTreeViewPK',
    'spencer/core/filter/Pagination',
    '@lib/doc-control/tree/data/Node'
], function(
    DocumentTitleFilter,
    ProjectStagePKFilter,
    ProjectStageTreeViewPKFilter,
    PaginationFilter,
    NodeVO
) {
    const TreeNodeRevisionCollection = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this._createQuery = function(filterCollection) {
            const query = {};
            const projectStagePKFilter = filterCollection.getFilterByClass(ProjectStagePKFilter);
            const projectStageTreeViewPKFilter = filterCollection.getFilterByClass(ProjectStageTreeViewPKFilter);
            const paginationFilter = filterCollection.getFilterByClass(PaginationFilter);
            const documentTitleFilter = filterCollection.getFilterByClass(DocumentTitleFilter);
            const node = filterCollection.getFilterByClass(NodeVO);

            if (projectStagePKFilter) query['projectStagePK'] = projectStagePKFilter.getProjectStagePK();
            if (projectStageTreeViewPKFilter) query['projectStageTreeViewPK'] = projectStageTreeViewPKFilter.getProjectStageTreeViewPK();
            if (documentTitleFilter) query['title'] = documentTitleFilter.getDocumentTitle();

            if (node) {
                query['projectStagePK'] = node.getProjectStagePK();
                query['projectStageTreeViewPK'] = node.getProjectStageTreeViewPK();
            }

            if(paginationFilter) {
                query['offset'] = paginationFilter.getOffset();
                query['limit'] = paginationFilter.getLimit();
            }

            return query;
        };
    };

    TreeNodeRevisionCollection.prototype.fetch = function(handlers, filterCollection) {
        this.urlConnection.setUrl(this.url);
        this.urlConnection.setQuery(this._createQuery(filterCollection));

        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());
        this.urlConnection.setAbortHandler(handlers.getAbort());

        return this.urlConnection.get();
    };

    return TreeNodeRevisionCollection;
});
},
'api/doccontrol/filter/DocumentTitle':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class DocumentTitle {
        constructor(documentTitle) {
            this.documentTitle = documentTitle;
        }
        getDocumentTitle() {
            return this.documentTitle;
        }
    }
    return DocumentTitle;
});

},
'api/doccontrol/filter/ProjectStagePK':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class ProjectStagePK {
        constructor(projectStagePK) {
            this.projectStagePK = projectStagePK;
        }
        getProjectStagePK() {
            return this.projectStagePK;
        }
    }
    return ProjectStagePK;
});

},
'api/doccontrol/filter/ProjectStageTreeViewPK':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class ProjectStageTreeViewPK {
        constructor(projectStageTreeViewPK) {
            this.projectStageTreeViewPK = projectStageTreeViewPK;
        }
        getProjectStageTreeViewPK() {
            return this.projectStageTreeViewPK;
        }
    }
    return ProjectStageTreeViewPK;
});

},
'spencer/core/filter/Pagination':function(){
define(["require", "exports", "@lib/spencer/core/filter/Pagination"], function (require, exports, Pagination_1) {
    "use strict";
    /** Deprecated - use @lib/spencer/core/filter/Pagination */
    class Pagination extends Pagination_1.default {
    }
    return Pagination;
});

},
'@lib/spencer/core/filter/Pagination':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    class Pagination {
        constructor(offset = 0, limit = 10) {
            this.offset = offset;
            this.limit = limit;
        }
        setOffset(offset) {
            this.offset = offset;
            return this;
        }
        getOffset() {
            return this.offset;
        }
        setLimit(limit) {
            this.limit = limit;
            return this;
        }
        getLimit() {
            return this.limit;
        }
    }
    exports.default = Pagination;
});

},
'@lib/doc-control/tree/data/Node':function(){
define(["require", "exports", "@lib/spencer/format/NodePath"], function (require, exports, NodePath) {
    "use strict";
    class Node {
        constructor() {
            this.name = '';
            this.type = '';
            this.description = '';
            this.reference = null;
            this.referenceFormat = null;
            this.isActiveAttr = false;
            this.documentCount = 0;
            this.children = [];
            this.rootNode = false;
            this.fullPath = '';
        }
        getProjectStageTreeViewPK() {
            return this.projectStageTreeViewPK;
        }
        setProjectStageTreeViewPK(projectStageTreeViewPK) {
            this.projectStageTreeViewPK = projectStageTreeViewPK;
            return this;
        }
        getProjectStagePK() {
            return this.projectStagePK;
        }
        setProjectStagePK(projectStagePK) {
            this.projectStagePK = projectStagePK;
            return this;
        }
        getProjectStage() {
            return this.projectStage;
        }
        setProjectStage(projectStage) {
            this.projectStage = projectStage;
            return this;
        }
        getName() {
            return this.name;
        }
        setName(name) {
            this.name = name;
            return this;
        }
        getType() {
            return this.type;
        }
        setType(type) {
            this.type = type;
            return this;
        }
        getDescription() {
            return this.description;
        }
        setDescription(description) {
            this.description = description;
            return this;
        }
        getReference() {
            return this.reference;
        }
        setReference(reference) {
            this.reference = reference;
            return this;
        }
        getReferenceFormat() {
            return this.referenceFormat;
        }
        setReferenceFormat(referenceFormat) {
            this.referenceFormat = referenceFormat;
            return this;
        }
        isActive() {
            return this.isActiveAttr;
        }
        setIsActive(isActive) {
            this.isActiveAttr = isActive;
            return this;
        }
        getDocumentCount() {
            return this.documentCount;
        }
        setDocumentCount(documentCount) {
            this.documentCount = documentCount;
        }
        getParent() {
            return this.parent;
        }
        setParent(parent) {
            this.parent = parent;
            return this;
        }
        getChildren() {
            return this.children;
        }
        addChild(child) {
            this.children.push(child);
            return this;
        }
        getLatestRevisionModifiedDate() {
            return this.latestRevisionModifiedDate;
        }
        setLatestRevisionModifiedDate(latestRevisionModifiedDate) {
            this.latestRevisionModifiedDate = latestRevisionModifiedDate;
            return this;
        }
        getTemplate() {
            return this.template;
        }
        setTemplate(template) {
            this.template = template;
            return this;
        }
        hasTemplate() {
            return !!this.template;
        }
        setRootNode() {
            this.rootNode = true;
            return this;
        }
        isRootNode() {
            return this.rootNode;
        }
        getFullPath() {
            if (!this.fullPath) {
                this.fullPath = NodePath.nodeToString(this, true, ' => ');
            }
            return this.fullPath;
        }
        getDateCreated() {
            return this.dateCreated;
        }
        setDateCreated(dateCreated) {
            this.dateCreated = dateCreated;
            return this;
        }
        getDateModified() {
            return this.dateModified;
        }
        setDateModified(dateModified) {
            this.dateModified = dateModified;
            return this;
        }
        getCreatedBy() {
            return this.createdBy;
        }
        setCreatedBy(createdBy) {
            this.createdBy = createdBy;
            return this;
        }
        getModifiedBy() {
            return this.modifiedBy;
        }
        setModifiedBy(modifiedBy) {
            this.modifiedBy = modifiedBy;
            return this;
        }
    }
    return Node;
});

},
'@lib/spencer/format/NodePath':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.nodeToArray = nodeToArray;
    exports.nodeToString = nodeToString;
    exports.arrayToString = arrayToString;
    function stripExampleDocumentReferenceAndReferenceFormatFromName(node) {
        if (!node.getReferenceFormat())
            return node.getName().replace(/^(.*) \(e\.g\. .+\)$/, '$1');
        const referencePrefix = node.getReferenceFormat().split('%')[0];
        const regex = new RegExp(`^(.*) \\((${referencePrefix}.+|e\.g\. .+)\\)$`);
        return node.getName().replace(regex, '$1');
    }
    function stripExampleDocumentReferenceFromName(node) {
        return node.getName().replace(/^(.*) \(e\.g\. .+\)$/, '$1');
    }
    function nodeToArray(node, includeProjectStageTitle = false, includeReferenceFormatInName = false) {
        if (!node.getParent()) {
            return [node.getName()];
        }
        const fullPath = [];
        let curNode = node;
        while (curNode) {
            if (!includeProjectStageTitle && curNode.isRootNode())
                break;
            fullPath.unshift(includeReferenceFormatInName
                ? stripExampleDocumentReferenceFromName(curNode)
                : stripExampleDocumentReferenceAndReferenceFormatFromName(curNode));
            curNode = curNode.getParent();
        }
        return fullPath;
    }
    function nodeToString(node, includeProjectStageTitle = false, separator = ' / ') {
        return arrayToString(nodeToArray(node, includeProjectStageTitle, true), separator);
    }
    function arrayToString(pathArray, separator = ' / ') {
        return pathArray.join(separator);
    }
});

},
'api/doccontrol/parser/AccessLog':function(){
define([
    '../data/AccessLog',
    '../../person/parser/Person',
    './Revision'
], function(
    AccessLogVO,
    PersonParser,
    RevisionParser
) {
    var AccessLog = function() {
        this.personParser = new PersonParser();
        this.revisionParser = new RevisionParser();
    };

    AccessLog.prototype.parse = function(item) {
        var avo = new AccessLogVO();

        avo.setRevisionAccessLogPK(item.revisionAccessLogPK || null);
        avo.setRevision(item.revision ? this.revisionParser.parse(item.revision) : null);
        avo.setPerson(item.person ? this.personParser.parse(item.person) : null);
        avo.setDate(item.date ? new Date(item.date) : null);
        avo.setType(item.type || null);

        return avo;
    };

    return AccessLog;
});
},
'api/doccontrol/data/AccessLog':function(){
define([], function() {
    var AccessLog = function() {
        this.revisionAccessLogPK = null;
        this.revision = null;
        this.person = null;
        this.date = null;
        this.type = null;
    };

    AccessLog.prototype.getRevisionAccessLogPK = function() {
        return this.revisionAccessLogPK;
    };

    AccessLog.prototype.setRevisionAccessLogPK = function(revisionAccessLogPK) {
        this.revisionAccessLogPK = revisionAccessLogPK;
    };

    AccessLog.prototype.getRevision = function() {
        return this.revision;
    };

    AccessLog.prototype.setRevision = function(revision) {
        this.revision = revision;
    };

    AccessLog.prototype.getPerson = function() {
        return this.person;
    };

    AccessLog.prototype.setPerson = function(person) {
        this.person = person;
    };

    AccessLog.prototype.getDate = function() {
        return this.date;
    };

    AccessLog.prototype.setDate = function(date) {
        this.date = date;
    };

    AccessLog.prototype.getType = function() {
        return this.type;
    };

    AccessLog.prototype.setType = function(type) {
        this.type = type;
    };

    return AccessLog;
});
},
'api/person/parser/Person':function(){
define([
    "../data/Person"
], function(PersonVO) {
    const Person = function() {
    };

    Person.prototype.parse = function(item) {
        const p = new PersonVO();

        p.setPersonPK(item.personPK || null);
        p.setDisplayName(item.displayName || null);
        p.setName(item.displayName || null);
        p.setJobTitle(item.jobTitle || null);
        p.setEmail(item.email || null);
        p.setOrganisationPK(item.organisationPK || false);
        p.setOrganisation(item.organisation || null);
        p.setType(item.type || null);
        p.setDisplayNameAndJobTitle(item.displayNameAndJobTitle || null);

        return p;
    };

    return Person;
});
},
'api/person/data/Person':function(){
define([
    'spencer/core/data/Person'
], function(CorePerson) {
    return CorePerson;
});
},
'api/doccontrol/parser/Revision':function(){
define([
    '../data/Revision',
    '../../person/parser/Person',
    'spencer/parse/Collection',
    'spencer/doc-control/parser/Recipient'
], function(
    RevisionVO,
    PersonParser,
    CollectionParser,
    RecipientParser
) {
    const Revision = function() {
        this.personParser = new PersonParser();
        this.recipientCollectionParser = new CollectionParser(
            new RecipientParser()
        );
    };

    Revision.prototype.parse = function(item) {
        const rvo = new RevisionVO();
        rvo.setRevisionPK(parseInt(item.revisionPK) || null);
        rvo.setDocumentPK(parseInt(item.documentPK) || null);
        rvo.setPersonPK(parseInt(item.personPK) || null);
        rvo.setSenderID(parseInt(item.senderID) || null);
        rvo.setLocation(item.location || null);
        rvo.setRealName(item.realName || item.name || null);
        rvo.setReference(item.reference || null);
        rvo.setRevisionNumber(item.revisionNumber || null);
        rvo.setTitle(item.title || null);
        rvo.setFileType(item.fileType || item.type || null);
        rvo.setFileSize(parseInt(item.fileSize) || item.size || null);
        rvo.setMd5(item.md5 || null);
        rvo.setDeleted(item.deleted && item.deleted === '1' ? true : false);
        rvo.setDateUploaded(item.dateUploaded ? new Date(item.dateUploaded) : null);
        rvo.setPersonUploader(item.personUploader ? this.personParser.parse(item.personUploader) : null);
        rvo.setRecipientCollection(
            item.recipientCollection
                ? this.recipientCollectionParser.parse(item.recipientCollection)
                : []
        );

        if (item.markedAsPrivate) {
            rvo.markAsPrivate();
        }

        return rvo;
    };

    return Revision;
});
},
'api/doccontrol/parser/Correspondence':function(){
define([
    'api/doccontrol/parser/Revision',
    '../data/Correspondence',
    './RevisionCollection',
    './TemporaryDocumentCollection',
    '@lib/api/doc-control/tree/parser/Node',
    '@lib/api/project/parser/ProjectStage'
], function(
    RevisionParser,
    CorrespondenceVO,
    RevisionCollection,
    TemporaryDocumentCollection,
    NodeParser,
    ProjectStageParser
) {
    return class Correspondence {
        parse(item) {
            const cvo = new CorrespondenceVO();

            cvo.setRevisionPK(item.revisionPK || null);
            cvo.setEmailPK(item.emailPK || null);
            cvo.setTo(item.to ? this._parseRecipients(item.to) : null);
            cvo.setCC(item.cc ? this._parseRecipients(item.cc) : null);
            cvo.setFrom(item.from ?this._parseRecipients(item.from) : null);
            cvo.setDate(item.date ? new Date(item.date) : null);
            cvo.setSubject(item.subject || null);
            cvo.setContents(item.contents || null);

            if (item.revisions) {
                cvo.setRevisions((new RevisionCollection).parse(item.revisions));
            }

            if (item.temporaryDocuments) {
                cvo.setTemporaryDocuments((new TemporaryDocumentCollection).parse(item.temporaryDocuments));
            }

            if (item.registrationLocation) {
                cvo.setRegistrationLocation((new NodeParser(new RevisionParser(), new ProjectStageParser())).parse(item.registrationLocation));
            }

            return cvo;
        }

        _parseRecipients(recipients) {
            return Object.entries(recipients).map(([emailAddress, displayName]) => {
                if (!displayName) return emailAddress;

                return `${displayName} <${emailAddress}>`;
            }).join(', ');
        }
    }
});
},
'api/doccontrol/data/Correspondence':function(){
define([], function() {
    var Correspondence = function() {
        this.revisionPK = null;
        this.emailPK = null;
        this.to = null;
        this.cc = null;
        this.from = null;
        this.subject = null;
        this.date = null;
        this.contents = null;
        this.revisions = null;
        this.temporaryDocuments = null;
        this.registrationLocation = null;
    };

    Correspondence.prototype.getRevisionPK = function() {
        return this.revisionPK;
    };

    Correspondence.prototype.setRevisionPK = function(revisionPK) {
        this.revisionPK = revisionPK;
    };

    Correspondence.prototype.getEmailPK = function() {
        return this.emailPK;
    };

    Correspondence.prototype.setEmailPK = function(emailPK) {
        this.emailPK = emailPK;
    };

    Correspondence.prototype.getTo = function() {
        return this.to;
    };

    Correspondence.prototype.setTo = function(to) {
        this.to = to;
    };

    Correspondence.prototype.getCC = function() {
        return this.cc;
    };

    Correspondence.prototype.setCC = function(cc) {
        this.cc = cc;
    };

    Correspondence.prototype.getFrom = function() {
        return this.from;
    };

    Correspondence.prototype.setFrom = function(from) {
        this.from = from;
    };

    Correspondence.prototype.getSubject = function() {
        return this.subject;
    };

    Correspondence.prototype.setSubject = function(subject) {
        this.subject = subject;
    };

    Correspondence.prototype.getDate = function() {
        return this.date;
    };

    Correspondence.prototype.setDate = function(date) {
        this.date = date;
    };

    Correspondence.prototype.getContents = function() {
        return this.contents;
    };

    Correspondence.prototype.setContents = function(contents) {
        this.contents = contents;
    };

    Correspondence.prototype.getRevisions = function() {
        return this.revisions;
    };

    Correspondence.prototype.setRevisions = function(revisions) {
        this.revisions = revisions;
    };

    Correspondence.prototype.getTemporaryDocuments = function() {
        return this.temporaryDocuments;
    };

    Correspondence.prototype.setTemporaryDocuments = function(temporaryDocuments) {
        this.temporaryDocuments = temporaryDocuments;
    };

    Correspondence.prototype.getRegistrationLocation = function() {
        return this.registrationLocation;
    };

    Correspondence.prototype.setRegistrationLocation = function(registrationLocation) {
        this.registrationLocation = registrationLocation;
    };

    return Correspondence;
});
},
'api/doccontrol/parser/RevisionCollection':function(){
define([
    "./Revision"
], function(RevisionParser) {
    var RevisionCollection = function() {};

    RevisionCollection.prototype.parse = function(items) {
        var parsedRevisions = [];

        for (var i = 0; i < items.length; i++) {
            parsedRevisions.push((new RevisionParser()).parse(items[i]));
        }

        return parsedRevisions;
    };

    return RevisionCollection;
});
},
'api/doccontrol/parser/TemporaryDocumentCollection':function(){
define([
    "./TemporaryDocument"
], function(TemporaryDocumentParser) {
    var TemporaryDocumentCollection = function() {
    };

    TemporaryDocumentCollection.prototype.parse = function(items) {
        var parsedTemporaryDocuments = [];

        for (var i = 0; i < items.length; i++) {
            parsedTemporaryDocuments.push((new TemporaryDocumentParser()).parse(items[i]));
        }

        return parsedTemporaryDocuments;
    };

    return TemporaryDocumentCollection;
});
},
'api/doccontrol/parser/TemporaryDocument':function(){
define([
    '../data/TemporaryDocument'
], function(
    TemporaryDocumentVO
) {
    const TemporaryDocument = function() {};

    TemporaryDocument.prototype.parse = function(item) {
        const vo = new TemporaryDocumentVO();
        vo.setTemporaryDocumentPK(item.temporaryDocumentPK || null);
        vo.setName(item.name || null);
        vo.setType(item.type || null);
        vo.setSubType(item.subType || null);
        vo.setSize(item.size || null);
        vo.setLocation(item.location || null);
        vo.setMd5(item.md5 || null);
        vo.setTimeModified(item.timeModified ? new Date(item.timeModified) : null);

        return vo;
    };

    return TemporaryDocument;
});
},
'@lib/api/doc-control/tree/parser/Node':function(){
define(["require", "exports", "@lib/doc-control/tree/data/Node", "@lib/spencer/core/data/Person"], function (require, exports, NodeVO, Person) {
    "use strict";
    const VIRTUAL_ROOT_NODE = 'VIRTUAL ROOT NODE';
    class Node {
        constructor(revisionParser, projectStageParser) {
            this.revisionParser = revisionParser;
            this.projectStageParser = projectStageParser;
            this.parsedNodes = {};
        }
        parse(item) {
            const key = this.generateKey(item);
            if (this.parsedNodes[key]) {
                return this.parsedNodes[key];
            }
            const vo = new NodeVO();
            vo.setProjectStageTreeViewPK(parseInt(item.projectStageTreeViewPK) || null);
            vo.setProjectStage(item.projectStage ? this.projectStageParser.parse(item.projectStage) : null);
            vo.setName(item.name || '');
            vo.setType(item.type || null);
            vo.setDescription(item.description || '');
            vo.setReference(item.reference || null);
            vo.setReferenceFormat(item.referenceFormat || null);
            vo.setIsActive(item.isActive || item.isActiveAttr || false);
            vo.setDocumentCount(item.documentCount || 0);
            if (item.projectStageTreeViewPK === 'root'
                || item.name === VIRTUAL_ROOT_NODE) {
                vo.setRootNode();
            }
            if (item.projectStagePK) {
                vo.setProjectStagePK(item.projectStagePK);
            }
            else if (item.projectStage) {
                vo.setProjectStagePK(item.projectStage.projectStagePK);
            }
            else {
                vo.setProjectStagePK(null);
            }
            if (item.latestRevisionModifiedDate)
                vo.setLatestRevisionModifiedDate(new Date(item.latestRevisionModifiedDate));
            if (item.dateCreated)
                vo.setDateCreated(new Date(item.dateCreated));
            if (item.dateModified)
                vo.setDateModified(new Date(item.dateModified));
            if (item.createdBy) {
                vo.setCreatedBy((new Person()).setPersonPK(item.createdBy.personPK ?? 0)
                    .setDisplayName(item.createdBy.displayName ?? '')
                    .setJobTitle(item.createdBy.jobTitle ?? ''));
            }
            if (item.modifiedBy) {
                vo.setModifiedBy((new Person()).setPersonPK(item.modifiedBy.personPK ?? 0)
                    .setDisplayName(item.modifiedBy.displayName ?? '')
                    .setJobTitle(item.modifiedBy.jobTitle ?? ''));
            }
            this.parsedNodes[key] = vo;
            if (item.parent) {
                vo.setParent(this.parse(item.parent));
            }
            if (item.template) {
                vo.setTemplate(this.revisionParser.parse(item.template));
            }
            for (const i in item.children) {
                if (item.children.hasOwnProperty(i)) {
                    vo.addChild(this.parse(item.children[i]));
                }
            }
            return vo;
        }
        generateKey(item) {
            let key = item.projectStageTreeViewPK;
            if (item.projectStage) {
                key += '_' + item.projectStage.projectStagePK;
            }
            else {
                key += '_' + item.projectStagePK;
            }
            return key;
        }
    }
    return Node;
});

},
'@lib/api/project/parser/ProjectStage':function(){
define(["require", "exports", "@lib/project/data/ProjectStage"], function (require, exports, ProjectStageVO) {
    "use strict";
    class ProjectStage {
        parse(item) {
            const projectStageVO = new ProjectStageVO();
            if (item.projectStagePK)
                projectStageVO.setProjectStagePK(item.projectStagePK);
            if (item.stagePK)
                projectStageVO.setStagePK(item.stagePK);
            if (item.projectPK)
                projectStageVO.setProjectPK(item.projectPK);
            if (item.stageNumber)
                projectStageVO.setStageNumber(item.stageNumber);
            if (item.title)
                projectStageVO.setTitle(item.title);
            if (item.stageNumberRangePK)
                projectStageVO.setStageNumberRangePK(item.stageNumberRangePK);
            if (item.organisationPK)
                projectStageVO.setOrganisationPK(item.organisationPK);
            if (item.type)
                projectStageVO.setType(item.type);
            if (item.timeCreated)
                projectStageVO.setTimeCreated(new Date(item.timeCreated));
            if (item.timeModified)
                projectStageVO.setTimeModified(new Date(item.timeModified));
            if (item.active || item.isActive)
                projectStageVO.setIsActive();
            if (item.visible)
                projectStageVO.setVisible();
            return projectStageVO;
        }
    }
    return ProjectStage;
});

},
'@lib/project/data/ProjectStage':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class ProjectStage {
        constructor() {
            this.visible = false;
            this.active = false;
        }
        getProjectStagePK() {
            return this.projectStagePK;
        }
        setProjectStagePK(value) {
            this.projectStagePK = value;
            return this;
        }
        getStagePK() {
            return this.stagePK;
        }
        setStagePK(value) {
            this.stagePK = value;
            return this;
        }
        getProjectPK() {
            return this.projectPK;
        }
        setProjectPK(value) {
            this.projectPK = value;
            return this;
        }
        getStageNumber() {
            return this.stageNumber;
        }
        setStageNumber(value) {
            this.stageNumber = value;
            return this;
        }
        getTitle() {
            return this.title;
        }
        setTitle(value) {
            this.title = value;
            return this;
        }
        getStageNumberRangePK() {
            return this.stageNumberRangePK;
        }
        setStageNumberRangePK(value) {
            this.stageNumberRangePK = value;
            return this;
        }
        isVisible() {
            return this.visible;
        }
        setVisible() {
            this.visible = true;
            return this;
        }
        isActive() {
            return this.active;
        }
        setIsActive() {
            this.active = true;
            return this;
        }
        getOrganisationPK() {
            return this.organisationPK;
        }
        setOrganisationPK(value) {
            this.organisationPK = value;
            return this;
        }
        getType() {
            return this.type;
        }
        setType(value) {
            this.type = value;
            return this;
        }
        getTreeTemplatePK() {
            return this.treeTemplatePK;
        }
        setTreeTemplatePK(value) {
            this.treeTemplatePK = value;
            return this;
        }
        getTimeCreated() {
            return this.timeCreated;
        }
        setTimeCreated(value) {
            this.timeCreated = value;
            return this;
        }
        getTimeModified() {
            return this.timeModified;
        }
        setTimeModified(value) {
            this.timeModified = value;
            return this;
        }
    }
    return ProjectStage;
});

},
'api/doccontrol/parser/Document':function(){
define([
    './Revision',
    './TemporaryDocument'
], function(
    RevisionParser,
    TemporaryDocumentParser
) {
    const Document = function() {};

    Document.prototype.parse = function(item) {
        if (typeof item.revisionPK !== 'undefined') {
            return new RevisionParser().parse(item);
        }

        return new TemporaryDocumentParser().parse(item);
    };

    return Document;
});

},
'api/doccontrol/parser/DocumentDetails':function(){
define([
    '../data/DocumentDetails'
], function(
    DocumentDetailsVO
) {
    const DocumentDetails = function() {};

    DocumentDetails.prototype.parse = function(item) {
        return (new DocumentDetailsVO())
            .setId(item.id ? parseInt(item.id) : null)
            .setFileType(item.fileType || null)
            .setMd5(item.md5 || null)
            .setLocation(item.location || null)
            .setDocumentType(item.documentType || null)
            .setTitle(item.title || null)
            .setSize(item.size || null);
    };

    return DocumentDetails;
});
},
'api/doccontrol/data/DocumentDetails':function(){
define([], function() {
    const DocumentDetails = function() {
        this.id = null;
        this.fileType = null;
        this.md5 = null;
        this.location = null;
        this.documentType = null;
        this.title = null;
        this.size = null;
    };

    DocumentDetails.prototype.getId = function() {
        return this.id;
    };

    DocumentDetails.prototype.setId = function(id) {
        this.id = id;
        return this;
    };

    DocumentDetails.prototype.getFileType = function() {
        return this.fileType;
    };

    DocumentDetails.prototype.setFileType = function(fileType) {
        this.fileType = fileType;
        return this;
    };

    DocumentDetails.prototype.getMd5 = function() {
        return this.md5;
    };

    DocumentDetails.prototype.setMd5 = function(md5) {
        this.md5 = md5;
        return this;
    };

    DocumentDetails.prototype.getLocation = function() {
        return this.location;
    };

    DocumentDetails.prototype.setLocation = function(location) {
        this.location = location;
        return this;
    };

    DocumentDetails.prototype.getDocumentType = function() {
        return this.documentType;
    };

    DocumentDetails.prototype.setDocumentType = function(documentType) {
        this.documentType = documentType;
        return this;
    };

    DocumentDetails.prototype.getTitle = function() {
        return this.title;
    };

    DocumentDetails.prototype.setTitle = function(title) {
        this.title = title;
        return this;
    };

    DocumentDetails.prototype.getSize = function() {
        return this.size;
    };

    DocumentDetails.prototype.setSize = function(size) {
        this.size = size;
        return this;
    };

    return DocumentDetails;
});
},
'api/doccontrol/parser/Move':function(){
define([
    '../data/Move',
    'api/person/parser/Person'
], function(
    MoveVO,
    PersonParser
) {
    const Move = function() {};

    Move.prototype.parse = function(item) {
        const moveVO = new MoveVO();

        moveVO.setDocumentPK(item.documentPK || null);
        moveVO.setDestination(item.destination || null);

        if (item.person) {
            moveVO.setPerson((new PersonParser()).parse(item.person));
        }

        moveVO.setTimeCreated(item.timeCreated ? new Date(item.timeCreated) : null);

        return moveVO;
    };

    return Move;
});
},
'api/doccontrol/data/Move':function(){
define([], function() {
    const Move = function() {
        this.documentPK = null;
        this.destination = null;
        this.person = null;
        this.timeCreated = null;
    };

    Move.prototype.getDocumentPK = function() {
        return this.documentPK;
    };

    Move.prototype.setDocumentPK = function(documentPK) {
        this.documentPK = documentPK;
        return this;
    };

    Move.prototype.getDestination = function() {
        return this.destination;
    };

    Move.prototype.setDestination = function(destination) {
        this.destination = destination;
        return this;
    };

    Move.prototype.getPerson = function() {
        return this.person;
    };

    Move.prototype.setPerson = function(person) {
        this.person = person;
        return this;
    };

    Move.prototype.getTimeCreated = function() {
        return this.timeCreated;
    };

    Move.prototype.setTimeCreated = function(timeCreated) {
        this.timeCreated = timeCreated;
        return this;
    };

    return Move;
});
},
'api/doccontrol/parser/Note':function(){
define([
    '../data/Note',
    'api/person/parser/Person'
], function(
    NoteVO,
    PersonParser
) {
    return class Note {
        parse(item) {
            return new NoteVO()
                .setDocumentPK(item.documentPK || null)
                .setNote(item.note || null)
                .setPerson(item.person ? (new PersonParser()).parse(item.person) : null)
                .setTimeCreated(item.timeCreated ? new Date(item.timeCreated) : null);
        }
    };
});
},
'api/doccontrol/data/Note':function(){
define(['./DocumentEvent'], function(DocumentEvent) {
    return class Note extends DocumentEvent {
        constructor() {
            super();

            this.documentPK = null;
            this.note = null;
            this.person = null;
            this.timeCreated = null;
        }

        getDocumentPK() {
            return this.documentPK;
        }

        setDocumentPK(documentPK) {
            this.documentPK = documentPK;
            return this;
        }

        getNote() {
            return this.note;
        }

        setNote(note) {
            this.note = note;
            return this;
        }

        getPerson() {
            return this.person;
        }

        setPerson(person) {
            this.person = person;
            return this;
        }

        getTimeCreated() {
            return this.timeCreated;
        }

        setTimeCreated(timeCreated) {
            this.timeCreated = timeCreated;
            return this;
        }
    };
});
},
'api/doccontrol/data/DocumentEvent':function(){
define([], function() {
    return class DocumentEvent {
        constructor() {
            this.documentPK = null;
            this.description = null;
            this.person = null;
            this.dateCreated = null;
        }

        setDocumentPK(documentPK) {
            this.documentPK = documentPK;
            return this;
        }

        getDocumentPK() {
            return this.documentPK;
        }

        setDescription(description) {
            this.description = description;
            return this;
        }

        getDescription() {
            return this.description;
        }

        setPerson(person) {
            this.person = person;
            return this;
        }

        getPerson() {
            return this.person;
        }

        setDateCreated(dateCreated) {
            this.dateCreated = dateCreated;
            return this;
        }

        getDateCreated() {
            return this.dateCreated;
        }
    };
});
},
'api/doccontrol/parser/RevisionUpload':function(){
define([
    "../data/RevisionUpload"
], function(RevisionUploadVO) {
    var RevisionUpload = function() {
    };

    RevisionUpload.prototype.parse = function(item) {
        var ruvo = new RevisionUploadVO();
        ruvo.setRevisionPK(item.revisionPK || null);
        ruvo.setFileName(item.fileName || null);
        ruvo.setSizeInBytes(item.sizeInBytes || null);
        ruvo.setType(item.type || null);

        if (item.error) {
            if (item.error instanceof Array) {
                for (var i in item.error) {
                    ruvo.addError(item.error[i] || null);
                }
            } else {
                ruvo.addError(item.error);
            }
        }

        return ruvo;
    };

    return RevisionUpload;
});
},
'api/doccontrol/data/RevisionUpload':function(){
define([], function() {
    var RevisionUpload = function() {
        this.revisionPK = null;
        this.fileName = null;
        this.sizeInBytes = null;
        this.type = null;
        this.errors = [];
    };

    RevisionUpload.prototype.getRevisionPK = function() {
        return this.revisionPK;
    };

    RevisionUpload.prototype.setRevisionPK = function(revisionPK) {
        this.revisionPK = revisionPK;
    };

    RevisionUpload.prototype.getFileName = function() {
        return this.fileName;
    };

    RevisionUpload.prototype.setFileName = function(fileName) {
        this.fileName = fileName;
    };

    RevisionUpload.prototype.getSizeInBytes = function() {
        return this.sizeInBytes;
    };

    RevisionUpload.prototype.setSizeInBytes = function(sizeInBytes) {
        this.sizeInBytes = sizeInBytes;
    };

    RevisionUpload.prototype.getType = function() {
        return this.type;
    };

    RevisionUpload.prototype.setType = function(type) {
        this.type = type;
    };

    RevisionUpload.prototype.getErrors = function() {
        return this.errors;
    };

    RevisionUpload.prototype.addError = function(error) {
        this.errors.push(error);
    };

    return RevisionUpload;
});
},
'api/doccontrol/parser/SoftLink':function(){
define([
    '../data/SoftLink',
    'api/doccontrol/parser/Revision',
    'api/person/parser/Person',
    '@lib/api/doc-control/tree/parser/Node',
    '@lib/api/project/parser/ProjectStage'
], function(
    SoftLinkVO,
    RevisionParser,
    PersonParser,
    NodeParser,
    ProjectStageParser
) {
    const SoftLink = function() {};

    SoftLink.prototype.parse = function(item) {
        const slvo = new SoftLinkVO();

        slvo.setTitle(item.title || null);

        slvo.setParentDocumentPK(item.parentDocumentPK || null);

        if (item.person) {
            slvo.setPerson((new PersonParser()).parse(item.person));
        }

        if (item.location) {
            slvo.setLocation((new NodeParser(new RevisionParser(), new ProjectStageParser())).parse(item.location));
        }

        return slvo;
    };

    return SoftLink;
});
},
'api/doccontrol/data/SoftLink':function(){
define([], function() {
    const SoftLink = function() {
        this.title = null;
        this.parentDocumentPK = null;
        this.person = null;
        this.location = null;
    };

    SoftLink.prototype.getTitle = function() {
        return this.title;
    };

    SoftLink.prototype.setTitle = function(title) {
        this.title = title;
        return this;
    };

    SoftLink.prototype.getParentDocumentPK = function() {
        return this.parentDocumentPK;
    };

    SoftLink.prototype.setParentDocumentPK = function(parentDocumentPK) {
        this.parentDocumentPK = parentDocumentPK;
        return this;
    };

    SoftLink.prototype.getPerson = function() {
        return this.person;
    };

    SoftLink.prototype.setPerson = function(person) {
        this.person = person;
        return this;
    };

    SoftLink.prototype.getLocation = function() {
        return this.location;
    };

    SoftLink.prototype.setLocation = function(location) {
        this.location = location;
        return this;
    };

    return SoftLink;
});
},
'api/doccontrol/parser/SoftLinkEvent':function(){
define([
    '../data/SoftLinkEvent',
    'api/person/parser/Person'
], function(
    SoftLinkEventVO,
    PersonParser
) {
    return class SoftLinkEvent {
        parse(item) {
            return new SoftLinkEventVO()
                .setDocumentPK(item.documentPK || null)
                .setDescription(item.description || null)
                .setPerson(item.person ? new PersonParser().parse(item.person) : null)
                .setDateCreated(item.dateCreated ? new Date(item.dateCreated) : null)
        }
    }
});
},
'api/doccontrol/data/SoftLinkEvent':function(){
define(['./DocumentEvent'], function(DocumentEvent) {
    return class SoftLinkEvent extends DocumentEvent {};
});
},
'spencer/doc-control/parser/RevisionTreeNodeCollection':function(){
define(['../data/RevisionTreeNode'], function(RevisionTreeNodeVO) {
    var RevisionTreeNodeCollection = function() {
    };

    RevisionTreeNodeCollection.prototype.parse = function(revisionCollection, treeNodeCollection) {
        let revisionTreeNodeCollection = [];

        for (let i = 0; i < revisionCollection.length; i++) {
            let revisionTreeNode = new RevisionTreeNodeVO()
                .setRevision(revisionCollection[i])
                .setTreeNode(treeNodeCollection[i]);
            revisionTreeNodeCollection.push(revisionTreeNode);
        }

        return revisionTreeNodeCollection;
    };

    return RevisionTreeNodeCollection;
});
},
'spencer/doc-control/data/RevisionTreeNode':function(){
define([], function() {
    var RevisionTreeNode = function () {
        this.revision = null;
        this.treeNode = null;
    };

    RevisionTreeNode.prototype.getRevision = function() {
        return this.revision;
    };

    RevisionTreeNode.prototype.setRevision = function(revision) {
        this.revision = revision;
        return this;
    };

    RevisionTreeNode.prototype.getTreeNode = function() {
        return this.treeNode;
    };

    RevisionTreeNode.prototype.setTreeNode = function(treeNode) {
        this.treeNode = treeNode;
        return this;
    };

    return RevisionTreeNode;
});
},
'spencer/doc-control/parser/Transmittal':function(){
define([
    '../data/Transmittal',
    'api/contact/parser/Contact',
    'spencer/doc-control/parser/Revision'
], function(
    TransmittalVO,
    ContactParser,
    RevisionParser
) {
    const Transmittal = function() {
        this.contactParser = new ContactParser();
        this.revisionParser = new RevisionParser();
    };

    Transmittal.prototype.parse = function(item) {
        let tvo = (new TransmittalVO())
            .setEmailRevisionPK(item.emailRevisionPK || null)
            .setSender(item.sender ? this.contactParser.parse(item.sender) : null)
            .setDateTransmitted(item.date_transmitted ? new Date(item.date_transmitted) : null)
            .setComment(item.comment || null);

        if (item.recipients && Array.isArray(item.recipients)) {
            for (let i = 0; i < item.recipients.length; i++) {
                tvo.addRecipient(this.contactParser.parse(item.recipients[i]));
            }
        }

        if (item.revisions && Array.isArray(item.revisions)) {
            for (let i = 0; i < item.revisions.length; i++) {
                tvo.addRevision(this.revisionParser.parse(item.revisions[i]));
            }
        }

        return tvo;
    };

    return Transmittal;
});
},
'spencer/doc-control/data/Transmittal':function(){
define([], function() {
    const Transmittal = function() {
        this.emailRevisionPK = null;
        this.sender = null;
        this.recipients = [];
        this.dateTransmitted = null;
        this.comment = null;
        this.revisions = [];
    };

    Transmittal.prototype.setEmailRevisionPK = function(emailRevisionPK) {
        this.emailRevisionPK = emailRevisionPK;
        return this;
    };

    Transmittal.prototype.getEmailRevisionPK = function() {
        return this.emailRevisionPK;
    };

    Transmittal.prototype.setSender = function(sender) {
        this.sender = sender;
        return this;
    };

    Transmittal.prototype.getSender = function() {
        return this.sender;
    };

    Transmittal.prototype.addRecipient = function(recipient) {
        this.recipients.push(recipient);
        return this;
    };

    Transmittal.prototype.getRecipients = function() {
        return this.recipients;
    };

    Transmittal.prototype.setDateTransmitted = function(dateTransmitted) {
        this.dateTransmitted = dateTransmitted;
        return this;
    };

    Transmittal.prototype.getDateTransmitted = function() {
        return this.dateTransmitted;
    };

    Transmittal.prototype.setComment = function(comment) {
        this.comment = comment;
        return this;
    };

    Transmittal.prototype.getComment = function() {
        return this.comment;
    };

    Transmittal.prototype.addRevision = function(revision) {
        this.revisions.push(revision);
        return this;
    };

    Transmittal.prototype.getRevisions = function() {
        return this.revisions;
    };

    return Transmittal;
});
},
'api/doccontrol/parser/RevisionStatus':function(){
define([
    '../data/RevisionStatus'
], function(
    RevisionStatusVO
) {
    var RevisionStatus = function() {};
    RevisionStatus.prototype.parse = function(item) {
        var rsvo = new RevisionStatusVO();
        rsvo.setId(item.id || null);
        rsvo.setCode(item.code || null);
        rsvo.setDescription(item.description || null);

        return rsvo;
    };

    return RevisionStatus;
});
},
'api/doccontrol/data/RevisionStatus':function(){
define([], function() {
    var RevisionStatus = function() {
        this.id = null;
        this.code = null;
        this.description = null;
    };

    RevisionStatus.prototype.setId = function(id) {
        this.id = id;
        return this;
    };

    RevisionStatus.prototype.getId = function() {
        return this.id;
    };

    RevisionStatus.prototype.setCode = function(code) {
        this.code = code;
        return this;
    };

    RevisionStatus.prototype.getCode = function() {
        return this.code;
    };

    RevisionStatus.prototype.setDescription = function(description) {
        this.description = description;
        return this;
    };

    RevisionStatus.prototype.getDescription = function() {
        return this.description;
    };

    return RevisionStatus;
});
},
'api/doccontrol/TemporaryDocumentRegisterFactory':function(){
define([
    './TemporaryDocumentRegister'
], function(
    TemporaryDocumentRegister
) {
    const Factory = function(config, urlConnectionBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
    };

    Factory.prototype.getTemporaryDocumentRegister = function() {
        return new TemporaryDocumentRegister(
            this.config.getUrl('api_doc_control_temporary_document_register'),
            this.urlConnectionBuilder
        );
    };

    return Factory;
});
},
'library/request/URLConnectionBuilder':function(){
define([
    "./URLConnection"
], function(URLConnection) {
    var URLConnectionBuilder = function(urlConnectionProcessorBuilder) {
        this.urlConnectionProcessorBuilder = urlConnectionProcessorBuilder;
    };

    URLConnectionBuilder.prototype.build = function() {
        return new URLConnection(this.urlConnectionProcessorBuilder.build());
    };

    return URLConnectionBuilder;
});
},
'library/request/URLConnection':function(){
define([
    './data/URLOptions',
    './HeadersSingleton'
], function(
    URLOptions,
    HeadersSingleton
) {
    const URLConnection = function(urlConnectionProcessor) {
        this.urlConnectionProcessor = urlConnectionProcessor;

        this.abortHandler = null;
        this.conflictHandler = null;
        this.errorHandler = null;
        this.goneHandler = null;
        this.progressHandler = null;
        this.successHandler = null;
        this.unauthorisedHandler = null;
        this.forbiddenHandler = null;

        this.url = null;
        this.data = null;
        this.form = null;
        this.query = null;
        this.format = null;
        this.headers = HeadersSingleton.getHeaders();

        this.createURLOptions = function() {
            let urlOptions = new URLOptions();
            urlOptions.setSuccessHandler(this.successHandler);
            urlOptions.setProgressHandler(this.progressHandler);
            urlOptions.setUnauthorisedHandler(this.unauthorisedHandler);
            urlOptions.setErrorHandler(this.errorHandler);
            urlOptions.setAbortHandler(this.abortHandler);
            urlOptions.setConflictHandler(this.conflictHandler);
            urlOptions.setGoneHandler(this.goneHandler);
            urlOptions.setForbiddenHandler(this.forbiddenHandler);
            urlOptions.setQuery(this.query);
            urlOptions.setFormat(this.format);
            urlOptions.setHeaders(this.headers);

            return urlOptions;
        };
    };

    URLConnection.prototype.setSuccessHandler = function(successHandler) {
        this.successHandler = successHandler;
        return this;
    };

    URLConnection.prototype.setProgressHandler = function(progressHandler) {
        this.progressHandler = progressHandler;
        return this;
    };

    URLConnection.prototype.setUnauthorisedHandler = function(unauthorisedHandler) {
        this.unauthorisedHandler = unauthorisedHandler;
        return this;
    };

    URLConnection.prototype.setErrorHandler = function(errorHandler) {
        this.errorHandler = errorHandler;
        return this;
    };

    URLConnection.prototype.setAbortHandler = function(abortHandler) {
        this.abortHandler = abortHandler;
        return this;
    };

    URLConnection.prototype.setConflictHandler = function(conflictHandler) {
        this.conflictHandler = conflictHandler;
        return this;
    };

    URLConnection.prototype.setGoneHandler = function(goneHandler) {
        this.goneHandler = goneHandler;
        return this;
    };

    URLConnection.prototype.setForbiddenHandler = function(forbiddenHandler) {
        this.forbiddenHandler = forbiddenHandler;
        return this;
    };

    URLConnection.prototype.setUrl = function(url) {
        this.url = url;
        return this;
    };

    URLConnection.prototype.setData = function(data) {
        this.data = data;
        return this;
    };
    
    URLConnection.prototype.setForm = function(form) {
        this.form = form;
        return this;
    };

    URLConnection.prototype.setQuery = function(query) {
        this.query = query;
        return this;
    };

    URLConnection.prototype.getQuery = function() {
        return this.query;
    };

    URLConnection.prototype.setFormat = function(format) {
        this.format = format;
        return this;
    };

    URLConnection.prototype.setHeaders = function(headers) {
        this.headers = headers;
        return this;
    };

    URLConnection.prototype.setHeader = function(key, value) {
        this.headers[key] = value;
        return this;
    };

    /*
     * BUILD METHODS
     */

    URLConnection.prototype.get = function() {
        this.urlConnectionProcessor.setUrl(this.url);
        this.urlConnectionProcessor.setURLOptions(this.createURLOptions());
        return this.urlConnectionProcessor.get();
    };

    URLConnection.prototype.post = function() {
        let urlOptions = this.createURLOptions();
        urlOptions.setData(this.data);
        urlOptions.setForm(this.form);

        this.urlConnectionProcessor.setUrl(this.url);
        this.urlConnectionProcessor.setURLOptions(urlOptions);
        return this.urlConnectionProcessor.post();
    };

    URLConnection.prototype.put = function() {
        let urlOptions = this.createURLOptions();
        urlOptions.setData(this.data);
        urlOptions.setForm(this.form);

        this.urlConnectionProcessor.setUrl(this.url);
        this.urlConnectionProcessor.setURLOptions(urlOptions);
        return this.urlConnectionProcessor.put();
    };

    URLConnection.prototype.del = function() {
        let urlOptions = this.createURLOptions();
        urlOptions.setData(this.data);
        urlOptions.setForm(this.form);

        this.urlConnectionProcessor.setUrl(this.url);
        this.urlConnectionProcessor.setURLOptions(urlOptions);
        return this.urlConnectionProcessor.del();
    };

    URLConnection.prototype.patch = function() {
        let urlOptions = this.createURLOptions();
        urlOptions.setData(this.data);
        urlOptions.setForm(this.form);

        this.urlConnectionProcessor.setUrl(this.url);
        this.urlConnectionProcessor.setURLOptions(urlOptions);
        return this.urlConnectionProcessor.patch();
    };

    URLConnection.prototype.options = function() {
        let urlOptions = this.createURLOptions();
        urlOptions.setData(this.data);
        urlOptions.setForm(this.form);

        this.urlConnectionProcessor.setUrl(this.url);
        this.urlConnectionProcessor.setURLOptions(urlOptions);
        return this.urlConnectionProcessor.options();
    };

    return URLConnection;
});

},
'library/request/data/URLOptions':function(){
define([], function() {
    const URLOptions = function() {
        this.successHandler = null;
        this.progressHandler = null;
        this.unauthorisedHandler = null;
        this.errorHandler = null;
        this.abortHandler = null;
        this.conflictHandler = null;
        this.goneHandler = null;
        this.forbiddenHandler = null;

        this.data = null;
        this.form = null;
        this.query = null;
        this.format = null;
        this.headers = {};
    };

    URLOptions.prototype.setSuccessHandler = function(successHandler) {
        this.successHandler = successHandler;
        return this;
    };

    URLOptions.prototype.getSuccessHandler = function() {
        return this.successHandler;
    };

    URLOptions.prototype.setProgressHandler = function(progressHandler) {
        this.progressHandler = progressHandler;
        return this;
    };

    URLOptions.prototype.getProgressHandler = function() {
        return this.progressHandler;
    };

    URLOptions.prototype.setUnauthorisedHandler = function(unauthorisedHandler) {
        this.unauthorisedHandler = unauthorisedHandler;
        return this;
    };

    URLOptions.prototype.getUnauthorisedHandler = function() {
        return this.unauthorisedHandler;
    };

    URLOptions.prototype.setErrorHandler = function(errorHandler) {
        this.errorHandler = errorHandler;
        return this;
    };

    URLOptions.prototype.getErrorHandler = function() {
        return this.errorHandler;
    };

    URLOptions.prototype.setAbortHandler = function(abortHandler) {
        this.abortHandler = abortHandler;
        return this;
    };

    URLOptions.prototype.getAbortHandler = function() {
        return this.abortHandler;
    };

    URLOptions.prototype.setConflictHandler = function(conflictHandler) {
        this.conflictHandler = conflictHandler;
        return this;
    };

    URLOptions.prototype.getConflictHandler = function() {
        return this.conflictHandler;
    };

    URLOptions.prototype.setGoneHandler = function(goneHandler) {
        this.goneHandler = goneHandler;
        return this;
    };

    URLOptions.prototype.getGoneHandler = function() {
        return this.goneHandler;
    };

    URLOptions.prototype.setForbiddenHandler = function(forbiddenHandler) {
        this.forbiddenHandler = forbiddenHandler;
        return this;
    };

    URLOptions.prototype.getForbiddenHandler = function() {
        return this.forbiddenHandler;
    };

    URLOptions.prototype.setData = function(data) {
        this.data = data;
        return this;
    };

    URLOptions.prototype.getData = function() {
        return this.data;
    };

    URLOptions.prototype.setForm = function(form) {
        this.form = form;
        return this;
    };

    URLOptions.prototype.getForm = function() {
        return this.form;
    };

    URLOptions.prototype.setQuery = function(query) {
        this.query = query;
        return this;
    };

    URLOptions.prototype.getQuery = function() {
        return this.query;
    };

    URLOptions.prototype.setFormat = function(format) {
        this.format = format;
        return this;
    };

    URLOptions.prototype.getFormat = function() {
        return this.format;
    };

    URLOptions.prototype.setHeaders = function(headers) {
        this.headers = headers;
        return this;
    };

    URLOptions.prototype.getHeaders = function() {
        return this.headers;
    };

    return URLOptions;
});
},
'library/request/HeadersSingleton':function(){
define([], function() {
    return {
        headers: {},

        setHeader: function(key, header) {
            this.headers[key] = header;
            return this;
        },

        getHeaders: function() {
            return this.headers;
        }
    };
});
},
'library/request/dojo/URLConnectionProcessorBuilder':function(){
define([
    'dojo/request',
    './URLConnectionProcessor',
    './HTML5RequestOptionsGenerator',
    '../FormDataGenerator',
    '../URLParamsGenerator'
], function(
    request,
    URLConnectionProcessor,
    HTML5RequestOptionsGenerator,
    FormDataGenerator,
    URLParamsGenerator
) {
    const URLConnectionProcessorBuilder = function() {};

    URLConnectionProcessorBuilder.prototype.build = function() {
        return new URLConnectionProcessor(
            request,
            new HTML5RequestOptionsGenerator(
                new URLParamsGenerator(),
                new FormDataGenerator()
            )
        );
    };

    return URLConnectionProcessorBuilder;
});
},
'library/request/dojo/URLConnectionProcessor':function(){
define([
    './URLCanceller',
    './../data/HTTPResponseCodes',
    'dojo/Deferred',
    'dojo/io-query'
], function(URLCanceller, HTTPResponseCodes, Deferred, ioQuery) {
    const HEADER_CONTENT_TYPE = 'Content-Type';
    const CONTENT_TYPE_APPLICATION_FORM = 'application/x-www-form-urlencoded';
    const METHOD_OPTIONS = 'OPTIONS';
    const METHOD_PATCH = 'PATCH';
    const METHOD_POST = 'POST';
    const ERROR_NOT_FOUND = 'not_found';
    const ERROR_NOT_FOUND_DESCRIPTION = 'The resource could not be found.';
    const ERROR_UNKNOWN = 'unknown_error';
    const ERROR_UNKNOWN_DESCRIPTION = 'An unknown error occurred.';

    const URLConnectionProcessor = function(dojoRequest, requestOptionsGenerator) {
        this.dojoRequest = dojoRequest;
        this.requestOptionsGenerator = requestOptionsGenerator;

        this.url = null;
        this.urlOptions = null;

        const connectionNotCancelled = function(xhr) {
            return !xhr || xhr.status !== HTTPResponseCodes.cancelled;
        };

        this.getData = function(options) {
            return ioQuery.objectToQuery(options.getData());
        };

        this.getSuccessCodes = function() {
            return [
                HTTPResponseCodes.ok,
                HTTPResponseCodes.created,
                HTTPResponseCodes.no_content
            ];
        };

        this.getSuccessHandler = function() {
            const successHandler = this.urlOptions.getSuccessHandler();

            return function(content) {
                if (successHandler != null) {
                    successHandler(content);
                }
            };
        };

        this.getProgressHandler = function() {
            const progressHandler = this.urlOptions.getProgressHandler();

            return function(response) {
                if (progressHandler != null) {
                    progressHandler(response.loaded, response.total, this.isUploadProgressEvent(response));
                }
            }.bind(this);
        };

        this.isUploadProgressEvent = function(response) {
            return response.currentTarget instanceof XMLHttpRequestUpload;
        };

        this.getErrorHandler = function() {
            const unauthorisedHandler = this.urlOptions.getUnauthorisedHandler();
            const errorHandler = this.urlOptions.getErrorHandler();
            const abortHandler = this.urlOptions.getAbortHandler();
            const conflictHandler = this.urlOptions.getConflictHandler();
            const goneHandler = this.urlOptions.getGoneHandler();
            const forbiddenHandler = this.urlOptions.getForbiddenHandler();

            return function(e) {
                const response = e.response;

                if (response.status === HTTPResponseCodes.forbidden) {
                    forbiddenHandler ? forbiddenHandler() : unauthorisedHandler(response.status);
                } else if (response.status === HTTPResponseCodes.unauthorized) {
                    unauthorisedHandler(response.status);
                } else if (connectionNotCancelled(response.xhr)) {
                    let error;

                    try {
                        error = JSON.parse(response.text);
                    } catch (e) {
                        error = {
                            error: 'unknown_error',
                            description: response.text || ERROR_UNKNOWN_DESCRIPTION
                        };
                    }

                    if (response.status === HTTPResponseCodes.conflict && conflictHandler) {
                        conflictHandler(error.error, error.description, error.data);
                    } else if (response.status === HTTPResponseCodes.gone && goneHandler) {
                        goneHandler(error.error, error.description);
                    } else if (response.status === HTTPResponseCodes.not_found) {
                        if (!error || error.error === ERROR_UNKNOWN || !error.error) {
                            errorHandler(ERROR_NOT_FOUND, ERROR_NOT_FOUND_DESCRIPTION, response.status);
                        } else {
                            errorHandler(error.error, error.description, response.status);
                        }
                    } else if (error) {
                        errorHandler(error.error, error.description, response.status);
                    } else {
                        errorHandler(ERROR_UNKNOWN, ERROR_UNKNOWN_DESCRIPTION, response.status);
                    }
                } else if (typeof abortHandler === 'function') {
                    abortHandler();
                }
            }
        };

        this.request = function(method, url, options) {
            const xhr = new XMLHttpRequest();

            const deferred = new Deferred(function() {
                this.abort();
                return {
                    response: {
                        status: this.status,
                        xhr: this,
                        text: this.responseText
                    }
                };
            }.bind(xhr));

            if(options.getQuery()) {
                url += '?' + ioQuery.objectToQuery(options.getQuery());
            }

            xhr.open(method, url, true);

            xhr.successCodes = this.getSuccessCodes();

            xhr.onload = function() {
                if(xhr.successCodes.indexOf(this.status) !== -1) {
                    if(method === METHOD_OPTIONS) {
                        deferred.resolve(
                            this.getResponseHeader('access-control-allow-methods')
                        );
                        return;
                    }

                    deferred.resolve(this.response);
                } else {
                    deferred.reject({
                        response: {
                            status: this.status,
                            xhr: this,
                            text: this.responseText
                        }
                    });
                }
            };

            xhr.onprogress = function(e) {
                deferred.progress(e);
            };
            xhr.upload.onprogress = function(e) {
                deferred.progress(e);
            };

            xhr.onerror = function() {
                deferred.reject({
                    response: {
                        status: this.status,
                        xhr: this,
                        text: this.responseText
                    }
                });
            };

            for(let key in options.getHeaders()) {
                if (options.getHeaders().hasOwnProperty(key)) {
                    xhr.setRequestHeader(key, options.getHeaders()[key]);
                }
            }

            const data = this.requestOptionsGenerator.generate(options).data;
            if (data && typeof data === 'string' && method === METHOD_POST) {
                xhr.setRequestHeader(HEADER_CONTENT_TYPE, CONTENT_TYPE_APPLICATION_FORM);
            }
            xhr.send(data);

            return deferred.promise;
        };
    };

    URLConnectionProcessor.prototype.setUrl = function(url) {
        this.url = url;
    };

    URLConnectionProcessor.prototype.setURLOptions = function(urlOptions) {
        this.urlOptions = urlOptions;
    };

    URLConnectionProcessor.prototype.get = function() {
        const promise = this.dojoRequest.get(this.url, this.requestOptionsGenerator.generate(this.urlOptions));
        promise.then(this.getSuccessHandler(), this.getErrorHandler(), this.getProgressHandler());

        return new URLCanceller(promise);
    };

    URLConnectionProcessor.prototype.put = function() {
        const promise = this.dojoRequest.put(this.url, this.requestOptionsGenerator.generate(this.urlOptions));
        promise.then(this.getSuccessHandler(), this.getErrorHandler(), this.getProgressHandler());

        return new URLCanceller(promise);
    };

    URLConnectionProcessor.prototype.post = function() {
        const promise = this.request(METHOD_POST, this.url, this.urlOptions);
        promise.then(this.getSuccessHandler(), this.getErrorHandler(), this.getProgressHandler());

        return new URLCanceller(promise);
    };

    URLConnectionProcessor.prototype.del = function() {
        const promise = this.dojoRequest.del(this.url, this.requestOptionsGenerator.generate(this.urlOptions));
        promise.then(this.getSuccessHandler(), this.getErrorHandler(), this.getProgressHandler());

        return new URLCanceller(promise);
    };

    URLConnectionProcessor.prototype.patch = function() {
        const promise = this.request(
            METHOD_PATCH,
            this.url,
            this.urlOptions
        );

        promise.then(
            this.getSuccessHandler().bind(this),
            this.getErrorHandler().bind(this),
            this.getProgressHandler().bind(this)
        );

        return new URLCanceller(promise);
    };

    URLConnectionProcessor.prototype.options = function() {
        const promise = this.request(
            METHOD_OPTIONS,
            this.url,
            this.urlOptions
        );

        promise.then(
            this.getSuccessHandler().bind(this),
            this.getErrorHandler().bind(this),
            this.getProgressHandler().bind(this)
        );

        return new URLCanceller(promise);
    };

    return URLConnectionProcessor;
});

},
'library/request/dojo/URLCanceller':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class URLCanceller {
        constructor(dojoPromise) {
            this.dojoPromise = dojoPromise;
        }
        getPromise() {
            return this.dojoPromise;
        }
        cancel() {
            this.dojoPromise.cancel();
        }
        isCancelled() {
            return this.dojoPromise.isCanceled();
        }
    }
    return URLCanceller;
});

},
'library/request/dojo/HTML5RequestOptionsGenerator':function(){
define([], function() {
    const HTML5RequestOptionsGenerator = function(urlParamsGenerator, formDataGenerator) {
        this.urlParamsGenerator = urlParamsGenerator;
        this.formDataGenerator = formDataGenerator;

        this.constants = {
            DEFAULT_FORMAT: "text"
        };
    };

    HTML5RequestOptionsGenerator.prototype.generate = function(urlOptions) {
        let data = null;
        const form = urlOptions.getForm();

        if (form && form.getId()) {
            this.formDataGenerator.setId(form.getId());
            data = this.formDataGenerator.generate();

            const d = urlOptions.getData();
            for(let key in d) {
                if (d.hasOwnProperty(key)) {
                    data.append(key, d[key]);
                }
            }

            if (form.getFileKey()) {
                // IE doesn't support delete
                if (typeof data['delete'] === 'function') {
                    // Clear any files with the same key so
                    // we don't upload duplicates.
                    // NOTE: Can't call delete directly as its
                    // a reserved word.
                    data['delete'](form.getFileKey());
                }

                const f = form.getFiles();
                for(let key in f) {
                    if (f.hasOwnProperty(key)) {
                        data.append(form.getFileKey(), f[key]);
                    }
                }
            }
        } else if (typeof urlOptions.getData() === 'object') {
            data = this.urlParamsGenerator.encode(urlOptions.getData());
        } else {
            data = urlOptions.getData();
        }

        return {
            query: this.urlParamsGenerator.encode(urlOptions.getQuery()),
            handleAs: urlOptions.getFormat() || this.constants.DEFAULT_FORMAT,
            data: data,
            headers: urlOptions.getHeaders() || {}
        };
    };
    
    return HTML5RequestOptionsGenerator;
});

},
'library/request/FormDataGenerator':function(){
define([], function() {
    var FormDataGenerator = function() {
        this.id = null;
    };

    FormDataGenerator.prototype.setId = function(id) {
        this.id = id;
    };

    FormDataGenerator.prototype.generate = function() {
        return new FormData(document.getElementById(this.id));
    };

    return FormDataGenerator;
});
},
'library/request/URLParamsGenerator':function(){
define([], function() {
    const URLParamsGenerator = function() {
        this.constants = {
            KEY_VALUE_SEPARATOR: "=",
            SEPARATOR: "&",
            ARRAY_SYMBOL: "[]"
        };
    };

    URLParamsGenerator.prototype.encode = function(data) {
        let r = "";

        for (let key in data) {
            if (data.hasOwnProperty(key)) {
                if (data[key] instanceof Array) {
                    for (let i in data[key]) {
                        if (data[key].hasOwnProperty(i)) {
                            r += encodeURIComponent(key);

                            if(!key.endsWith('[]')) {
                                r += this.constants.ARRAY_SYMBOL;
                            }

                            r += this.constants.KEY_VALUE_SEPARATOR +
                                encodeURIComponent(data[key][i]) +
                                this.constants.SEPARATOR;
                        }
                    }
                } else {
                    r += encodeURIComponent(key) +
                        this.constants.KEY_VALUE_SEPARATOR +
                        encodeURIComponent(data[key]);

                    r += this.constants.SEPARATOR;
                }
            }
        }

        // Remove final unnecessary separator
        return r.slice(0, r.length - 1);
    };

    return URLParamsGenerator;
});
},
'library/request/URLResponseProcessorBuilder':function(){
define([], function() {
    const URLResponseProcessorBuilder = function() {};

    URLResponseProcessorBuilder.prototype.createProcessor = function(parser, successHandler, errorHandler) {
        const _isCustomErrorObject = function(error) {
            return typeof error.getError === 'function' && typeof error.getDescription === 'function';
        };

        return function(data) {
            try {
                if (typeof successHandler == "function") {
                    successHandler(parser.parse(data));
                }
            } catch (error) {
                if (_isCustomErrorObject(error)) {
                    errorHandler(error.getError(), error.getDescription());

                    return;
                }

                if (!(error instanceof Error)) {
                    throw new Error(error);
                }

                throw error;
            }
        }
    };

    return URLResponseProcessorBuilder;
});
},
'doccontrol/viewer/model/Revise':function(){
define(["require", "exports", "library/request/helper/DefaultUnauthorisedCallback", "api/doccontrol/Config", "api/doccontrol/Factory", "library/request/data/Handlers", "spencer/doc-control/data/Revision", "../Topics", "library/request/URLConnectionBuilder", "library/request/dojo/URLConnectionProcessorBuilder", "library/request/URLResponseProcessorBuilder", "dojo/topic"], function (require, exports, DefaultUnauthorisedCallback, DocControlConfig, DocControlFactory, HandlersVO, RevisionVO, TOPICS, URLConnectionBuilder, URLConnectionProcessorBuilder, URLResponseProcessorBuilder, topic) {
    "use strict";
    class Revise {
        constructor(widgetContainer) {
            this.widgetContainer = widgetContainer;
            this.inProgress = false;
            this.apiRevision = new DocControlFactory(new DocControlConfig(), new URLConnectionBuilder(new URLConnectionProcessorBuilder()), new URLResponseProcessorBuilder()).getRevision();
            this.widgetDocumentReviseFormPane = this.widgetContainer.get('document-revise-form-pane');
            this.widgetDocumentRegisterFormPane = this.widgetContainer.get('document-register-form-pane');
            this.widgetDocumentReviseFormPane.setOnCloseCallback(() => {
                this.inProgress = false;
                topic.publish(TOPICS.DOCUMENT_VIEWER_DISABLE_INLINE);
            });
        }
        start(newDocument, originalDocument) {
            this.inProgress = true;
            this.widgetDocumentReviseFormPane.open();
            this.widgetDocumentRegisterFormPane.close();
            topic.publish(TOPICS.DOCUMENT_VIEWER_ENABLE_INLINE);
            this.widgetDocumentReviseFormPane.setDocumentPK(originalDocument.documentPK);
            this.widgetDocumentReviseFormPane.setOnSuccessCallback((revisionPK) => {
                topic.publish('sos-system-notification', 'Document successfully Revised.', 'success', 5000);
                this.requestRevision(revisionPK);
            });
            this.widgetDocumentReviseFormPane.reload();
            this.widgetDocumentReviseFormPane.setTemporaryDocument(newDocument);
        }
        isInProgress() {
            return this.inProgress;
        }
        requestRevision(revisionPK) {
            this.apiRevision.get(new HandlersVO((revision) => {
                this.widgetDocumentReviseFormPane.close();
                topic.publish(TOPICS.DOCUMENT_VIEWER_VIEW, revision);
            }, () => { }, DefaultUnauthorisedCallback, () => {
                this.widgetDocumentRegisterFormPane.close();
            }), new RevisionVO().setRevisionPK(revisionPK));
        }
    }
    return Revise;
});

},
'doccontrol/viewer/config/Viewer':function(){
define([], function() {
    var Viewer = function() {
        this.viewerViewState = null;
    };

    Viewer.prototype.setViewerViewState = function(viewerViewState) {
        this.viewerViewState = viewerViewState;
    };

    Viewer.prototype.getViewerViewState = function() {
        return this.viewerViewState;
    };

    return Viewer;
});
},
'doccontrol/viewer/dojo/Container':function(){
define([
    './AnnotationToolbar',
    './AnnotationWorkspace',
    './CorrespondenceViewer',
    './FileTypeTile',
    './MediaViewer',
    './MediaViewerBody',
    './DialogToolbar',
    './NavigationBar',
    './pin/Sidebar',
    './RevisionHistorySidebar',
    './Viewer',
    './ViewOptionsToolbar',
    '../config/LocalStorageDefault',
    'doccontrol/viewer/model/Factory',
    'library/DojoCookieWrapper',
    'library/JsonWrapper',
    'spencer/user-config/storage/Local',
    'style-guide/v1/doc-control/registration-details/DocumentRegister/FormPane',
    'style-guide/v1/doc-control/document/revise/FormPaneWrapper'
], function(
    AnnotationToolbar,
    AnnotationWorkspace,
    CorrespondenceViewer,
    FileTypeTile,
    MediaViewer,
    MediaViewerBody,
    DialogToolbar,
    NavigationBar,
    PinSidebar,
    RevisionHistorySidebar,
    Viewer,
    ViewOptionsToolbar,
    LocalStorageDefault,
    ViewerModelFactory,
    CookieWrapper,
    JsonWrapper,
    LocalStorage,
    DocumentRegisterFormPane,
    DocumentReviseFormPane
) {
    const LOCAL_STORAGE_PREFIX = 'ANNOTATIONS_';
    const Container = function(routeContainer, dataManager) {
        this.routeContainer = routeContainer;
        this.dataManager =  dataManager;
        this.constants = {
            DOM_ID: {
                VIEW: 'viewContainer',
                MEDIA_VIEW: 'mediaViewContainer',
                CORRESPONDENCE_VIEW: 'correspondenceViewContainer',
                VIEW_OPTIONS_TOOLBAR: 'viewOptionsToolbar',
                VIEW_ANNOTATION_PIN_SIDEBAR: 'viewAnnotationPinSidebar',
                VIEW_REVISION_HISTORY_SIDEBAR: 'viewRevisionHistorySidebar',
                VIEW_DIALOG_TOOLBAR: 'dialogToolbar',
                VIEW_NAVIGATION: 'navigationBar',
                ANNOTATION_WORKSPACE: 'annotationWorkspace'
            },
            IDENTIFYING_CLASS: {
                VIEW_ANNOTATION_TOOLBAR: 'viewAnnotationOptionsTools'
            },
            NOTIFICATION: 'notification',
            VIEW: 'view',
            MEDIA_VIEW: 'media-view',
            CORRESPONDENCE_VIEW: 'correspondence-view',
            VIEW_OPTIONS_TOOLBAR: 'view-options-toolbar',
            VIEW_DIALOG_TOOLBAR: 'dialog-toolbar',
            VIEW_ANNOTATION_TOOLBAR: 'view-annotation-toolbar',
            VIEW_ANNOTATION_PIN_SIDEBAR: 'view-annotation-pin-sidebar',
            VIEW_REVISION_HISTORY_SIDEBAR: 'view-revision-history-sidebar',
            VIEW_NAVIGATION: 'navigation-bar',
            ANNOTATION_WORKSPACE: 'annotation-workspace',
            DOCUMENT_REGISTER_FORM_PANE: 'document-register-form-pane',
            DOCUMENT_REVISE_FORM_PANE: 'document-revise-form-pane'
        };

        this.widgetView = null;
        this.widgetMediaView = null;
        this.widgetCorrespondenceView = null;
        this.widgetDialogToolbar = null;
        this.widgetViewOptionsToolbar = null;
        this.widgetAnnotationToolbar = null;
        this.widgetPinSidebar = null;
        this.widgetRevisionHistorySidebar = null;
        this.widgetNavigationBar = null;
        this.widgetAnnotationWorkspace = null;
        this.localStorage = new LocalStorage(
            LocalStorageDefault,
            new CookieWrapper(),
            new JsonWrapper(),
            LOCAL_STORAGE_PREFIX
        );
        this.viewerModelFactory = new ViewerModelFactory();

        const _getWidgetView = function(reset) {
            if (reset && this.widgetView) {
                this.widgetView.destroyRecursive();
                this.widgetView = null;
            }

            if (!this.widgetView) {
                this.widgetView = new Viewer(
                    this.routeContainer,
                    this.dataManager
                );
            }

            return this.widgetView;
        };

        const _getWidgetMediaView = function(reset) {
            if (reset && this.widgetMediaView) {
                this.widgetMediaView.destroy();
                this.widgetMediaView = null;
            }

            if (!this.widgetMediaView) {
                this.widgetMediaView = new MediaViewer(
                    this.routeContainer,
                    this.dataManager
                );
            }

            return this.widgetMediaView;
        };

        const _getWidgetCorrespondenceView = function(reset) {
            if (reset && this.widgetCorrespondenceView) {
                this.widgetCorrespondenceView.destroy();
                this.widgetCorrespondenceView = null;
            }

            if (!this.widgetCorrespondenceView) {
                this.widgetCorrespondenceView = new CorrespondenceViewer(
                    this.routeContainer,
                    this.dataManager
                );
            }

            return this.widgetCorrespondenceView;
        };

        const _getWidgetDialogToolbar = function(reset) {
            if (reset && this.widgetDialogToolbar) {
                this.widgetDialogToolbar.destroy();
                this.widgetDialogToolbar = null;
            }

            if (!this.widgetDialogToolbar) {
                this.widgetDialogToolbar = new DialogToolbar(
                    this.routeContainer,
                    this.constants.DOM_ID.VIEW_DIALOG_TOOLBAR,
                    this.dataManager,
                    this.localStorage
                );
            }

            return this.widgetDialogToolbar;
        };

        const _getWidgetViewOptionsToolbar = function(reset) {
            if (reset && this.widgetViewOptionsToolbar) {
                this.widgetViewOptionsToolbar.destroy();
                this.widgetViewOptionsToolbar = null;
            }

            if (!this.widgetViewOptionsToolbar) {
                this.widgetViewOptionsToolbar = new ViewOptionsToolbar(this.constants.DOM_ID.VIEW_OPTIONS_TOOLBAR);
            }

            return this.widgetViewOptionsToolbar;
        };

        const _getWidgetAnnotationToolbar = function(reset) {
            if (reset && this.widgetAnnotationToolbar) {
                delete this.widgetAnnotationToolbar;
            }

            if (!this.widgetAnnotationToolbar) {
                this.widgetAnnotationToolbar = new AnnotationToolbar(
                    this.constants.IDENTIFYING_CLASS.VIEW_ANNOTATION_TOOLBAR,
                    this.localStorage
                );
            }

            return this.widgetAnnotationToolbar;
        };

        const _getWidgetPinSidebar = function(reset) {
            if (reset && this.widgetPinSidebar) {
                this.widgetPinSidebar.destroy();
                this.widgetPinSidebar = null;
            }

            if (!this.widgetPinSidebar) {
                this.widgetPinSidebar = new PinSidebar(this.routeContainer, this.constants.DOM_ID.VIEW_ANNOTATION_PIN_SIDEBAR);
            }

            return this.widgetPinSidebar;
        };

        const _getRevisionHistorySidebar = function(reset) {
            if (reset && this.widgetRevisionHistorySidebar) {
                this.widgetRevisionHistorySidebar.destroy();
                this.widgetRevisionHistorySidebar = null;
            }

            if (!this.widgetRevisionHistorySidebar) {
                this.widgetRevisionHistorySidebar = new RevisionHistorySidebar(
                    this.routeContainer,
                    this.constants.DOM_ID.VIEW_REVISION_HISTORY_SIDEBAR
                );
            }

            return this.widgetRevisionHistorySidebar;
        };

        const _getWidgetNavigationBar = function(reset) {
            if (reset && this.widgetNavigationBar) {
                this.widgetNavigationBar.destroy();
                this.widgetNavigationBar = null;
            }

            if (!this.widgetNavigationBar) {
                this.widgetNavigationBar = new NavigationBar(this.constants.DOM_ID.VIEW_NAVIGATION);
            }

            return this.widgetNavigationBar;
        };

        const _getWidgetAnnotationWorkspace = function(reset) {
            if (reset && this.widgetAnnotationWorkspace) {
                this.widgetAnnotationWorkspace.destroy();
                this.widgetAnnotationWorkspace = null;
            }

            if (!this.widgetAnnotationWorkspace) {
                if (!this.widgetView) {
                    this.widgetView = _getWidgetView();
                }

                this.widgetAnnotationWorkspace = new AnnotationWorkspace(
                    this.constants.DOM_ID.ANNOTATION_WORKSPACE,
                    this.widgetView.getScrollableOverlay(),
                    this.widgetView.getWorkspace(),
                    this.localStorage
                );

                this.widgetView.setAnnotationWorkspace(this.widgetAnnotationWorkspace);
            }

            return this.widgetAnnotationWorkspace;
        };

        const _getWidgetDocumentRegisterFormPane = function() {
            if (!this.widgetDocumentRegisterFormPane) {
                this.widgetDocumentRegisterFormPane = new DocumentRegisterFormPane();

                if (!this.currentContact) {
                    this.viewerModelFactory.getContactByEmail(dojoConfig.user.getEmail()).then(contact => {
                        this.currentContact = contact;
                        this.widgetDocumentRegisterFormPane.setCurrentContact(contact);
                    });
                }
            }

            return this.widgetDocumentRegisterFormPane;
        };

        const _getWidgetDocumentReviseFormPane = function() {
            if (!this.widgetDocumentReviseFormPane) {
                this.widgetDocumentReviseFormPane = new DocumentReviseFormPane();
            }

            return this.widgetDocumentReviseFormPane;
        };

        this.supportedWidgets = {};
        this.supportedWidgets[this.constants.VIEW] = _getWidgetView.bind(this);
        this.supportedWidgets[this.constants.MEDIA_VIEW] = _getWidgetMediaView.bind(this);
        this.supportedWidgets[this.constants.CORRESPONDENCE_VIEW] = _getWidgetCorrespondenceView.bind(this);
        this.supportedWidgets[this.constants.VIEW_DIALOG_TOOLBAR] = _getWidgetDialogToolbar.bind(this);
        this.supportedWidgets[this.constants.VIEW_OPTIONS_TOOLBAR] = _getWidgetViewOptionsToolbar.bind(this);
        this.supportedWidgets[this.constants.VIEW_ANNOTATION_TOOLBAR] = _getWidgetAnnotationToolbar.bind(this);
        this.supportedWidgets[this.constants.VIEW_ANNOTATION_PIN_SIDEBAR] = _getWidgetPinSidebar.bind(this);
        this.supportedWidgets[this.constants.VIEW_REVISION_HISTORY_SIDEBAR] = _getRevisionHistorySidebar.bind(this);
        this.supportedWidgets[this.constants.VIEW_NAVIGATION] = _getWidgetNavigationBar.bind(this);
        this.supportedWidgets[this.constants.ANNOTATION_WORKSPACE] = _getWidgetAnnotationWorkspace.bind(this);
        this.supportedWidgets[this.constants.DOCUMENT_REGISTER_FORM_PANE] = _getWidgetDocumentRegisterFormPane.bind(this);
        this.supportedWidgets[this.constants.DOCUMENT_REVISE_FORM_PANE] = _getWidgetDocumentReviseFormPane.bind(this);
    };

    Container.prototype.has = function(name) {
        return this.supportedWidgets[name] !== undefined;
    };

    Container.prototype.get = function(name, reset) {
        if (!this.has(name)) {
            throw new Error('No widget exists named "' + name + '"');
        }

        return this.supportedWidgets[name](reset);
    };

    return Container;
});

},
'doccontrol/viewer/dojo/AnnotationToolbar':function(){
define([
    'api/Factory',
    'api/person/data/Person',
    'library/request/data/Handlers',
    'doccontrol/viewer/config/Stamps',
    'doccontrol/viewer/config/Modes',
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/dom-construct',
    'dojo/dom-style',
    'dojo/html',
    'dojo/topic',
    'dojo/touch',
    'dojo/on',
    'dojo/query',
    './LineWidthPicker',
    './LineStylePicker',
    './Users',
    './Notification',
    '../Topics',
    'dijit/_WidgetBase',
    'dojo/text!./template/AnnotationToolbar.html',
    'soso/sosox/ejs/_Templated',
    'style-guide/v1/color-picker/LimitedColorPicker',
    'style-guide/v1/navigation/SideNavigation',
    'style-guide/v1/tooltip/Tooltip',
    'style-guide/v1/media/capture-camera/CaptureCamera',
    'dojo/NodeList-dom'
], function(
    apiFactory,
    personVO,
    HandlersVO,
    StampConfig,
    MODES,
    declare,
    domAttr,
    domClass,
    domConstruct,
    domStyle,
    html,
    topic,
    touch,
    on,
    query,
    LineWidthPicker,
    LineStylePicker,
    Users,
    Notification,
    Topics,
    WidgetBase,
    Template,
    Templated,
    LimitedColorPicker,
    SideNavigation,
    Tooltip,
    CaptureCamera
) {
    const AnnotationToolbar = function(node, localStorage) {
        const DEFAULT_COLORS = [
            '#000000',
            '#7f8fa6',
            '#ffffff',
            '#e84118',
            '#4cd137',
            '#00a8ff',
            '#FFFF00',
            '#F79544',
            '#9c88ff',
            '#273c75'
        ];
        const DEFAULT_LINE_WIDTHS = [1, 2, 4, 8, 16];
        const LIGHT_COLOR_LUMINANCE_THRESHOLD = 10;

        const COLLAPSE_TOOLTIP_CONTENT = 'Click to collapse toolbar';
        const EXPAND_TOOLTIP_CONTENT = 'Click to expand toolbar';

        const CAPTURE_OUTPUT_FORMAT = 'image/webp'

        const View = declare([WidgetBase, Templated], {
            templateString: Template,
            toolbar: null,
            apiPerson: null,
            notifier: null,
            colorPicker: null,
            lineWidthPicker: null,
            lineStylePicker: null,
            connectedUsersWidget: null,
            connectedUsersOpen: false,
            users: null,
            connectedUsersCollection: [],
            usersCollection: [],
            hiddenUsers: [],
            data: {
                stamps: StampConfig.STAMPS,
                isColorFilled: localStorage.get('COLOR_FILLED'),
                toolbarState: localStorage.get('TOOLBAR_STATE')
            },
            elementColorIcon: null,
            elementColorPicker: null,
            elementConnectedUserIcon: null,
            elementConnectedUsers: null,
            elementLineStylePicker: null,
            elementLineThicknessIndicator: null,
            elementLineThicknessPicker: null,
            elementLineWidthPickerMenu: null,
            elementNavigation: null,
            elementNotificationContainer: null,
            elementToggleWidth: null,
            elementToolArrow: null,
            elementToolClear: null,
            elementToolDeleteSelection: null,
            elementToolDrag: null,
            elementToolEllipse: null,
            elementToolFreehand: null,
            elementToolHexagon: null,
            elementToolPolygon: null,
            elementToolHighlightRegion: null,
            elementToolHighlight: null,
            elementToolImageUpload: null,
            elementToolLine: null,
            elementToolPin: null,
            elementToolRectangle: null,
            elementToolSelect: null,
            elementToolText: null,
            localStorage: localStorage,

            destroyRecursive: function() {
                this.domNode.innerHTML = '';
                this.domNode = null;
                this.inherited(arguments);
            },

            postCreate: function() {
                this.inherited(arguments);

                this.notifier = new Notification(this.elementNotificationContainer);

                const color = this.localStorage.get('COLOR');
                this.colorPicker = new LimitedColorPicker({
                    colors: DEFAULT_COLORS,
                    selected: color
                }, this.elementColorPicker);
                this._updateColorIcon(color);

                const lineStyle = this.localStorage.get('LINE_STYLE');
                this.lineStylePicker = new LineStylePicker(
                    lineStyle,
                    this.elementLineStylePicker
                );
                this._updateLineStyle(lineStyle);

                this.lineWidthPicker = new LineWidthPicker({
                    lineWidths: DEFAULT_LINE_WIDTHS,
                    selected: this.localStorage.get('LINE_WIDTH')
                }, this.elementLineThicknessPicker);
                this._setLineThicknessIndicator(DEFAULT_LINE_WIDTHS[0]);

                this.toolbar = new SideNavigation({
                    activeItemsShouldBeExpanded: false,
                    navigation: this.elementNavigation
                });

                on(this.toolbar, 'item-collapsed', (item) => {
                    this.data.toolbarState[item.getAttribute('data-toolbar-state-flag')] = false;
                    this.localStorage.set('TOOLBAR_STATE', this.data.toolbarState);
                });

                on(this.toolbar, 'item-expanded', (item) => {
                    this.data.toolbarState[item.getAttribute('data-toolbar-state-flag')] = true;
                    this.localStorage.set('TOOLBAR_STATE', this.data.toolbarState);
                });

                this._createEvents();
                this._subscribe();
                this._disable();
                this._determineTooltipContent();
                this._initCaptureDialog();
            },

            _updateColorIcon: function(color) {
                domStyle.set(this.elementColorIcon, 'color', color);

                if (this._isLightColor(color)) {
                    domClass.add(this.elementColorIcon, 'show-outline');
                } else {
                    domClass.remove(this.elementColorIcon, 'show-outline');
                }
            },

            _isLightColor: function(hexCode) {
                let r = parseInt(hexCode.slice(1, 3), 16);
                let g = parseInt(hexCode.slice(3, 5), 16);
                let b = parseInt(hexCode.slice(5, 7), 16);

                let luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

                return luminance > LIGHT_COLOR_LUMINANCE_THRESHOLD;
            },

            _toggleWidth: function() {
                domClass.toggle(this.elementToggleWidth, ['sos-icon-toggle-on', 'sos-icon-toggle-off']);
                this.data.toolbarState.isVerbose = domClass.contains(this.elementToggleWidth, 'sos-icon-toggle-off');
                this.localStorage.set('TOOLBAR_STATE', this.data.toolbarState);

                if (domClass.contains(this.domNode, 'full-width')) {
                    domClass.remove(this.domNode, 'verbose');
                    domClass.remove(this.domNode, 'full-width');
                    this._determineTooltipContent();
                    return;
                }

                domClass.toggle(this.domNode, 'verbose');
                this._determineTooltipContent();
            },

            _determineTooltipContent: function () {
                if (domClass.contains(this.domNode, 'full-width') || domClass.contains(this.domNode, 'verbose')) {
                    domAttr.set(this.elementToggleWidth, 'data-tooltip-content', COLLAPSE_TOOLTIP_CONTENT);
                    return;
                }

                domAttr.set(this.elementToggleWidth, 'data-tooltip-content', EXPAND_TOOLTIP_CONTENT);
            },

            _setLineThicknessIndicator: function(width) {
                html.set(this.elementLineThicknessIndicator, width);
            },

            _updateLineStyle: function(lineStyleConfig) {
                for (const key in lineStyleConfig) {
                    if (lineStyleConfig[key] === true) {
                        return topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_CHANGE_LINE_STYLE, key);
                    }
                }
            },

            _createEvents: function() {
                this.colorPicker.get().on('change', function(color) {
                    this.localStorage.set('COLOR', color);
                    this._updateColorIcon(color);
                    topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_CHANGE_COLOUR, color);
                }.bind(this));

                this.lineStylePicker.get().on('change', (lineStyleConfig) => {
                    this.localStorage.set('LINE_STYLE', lineStyleConfig)
                    this._updateLineStyle(lineStyleConfig);
                });

                this.lineWidthPicker.get().on('change', function(width) {
                    this.localStorage.set('LINE_WIDTH', width);
                    this._setLineThicknessIndicator(width);
                    topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_CHANGE_LINE_WIDTH, width);
                }.bind(this));

                query('.tooltip-target', this.domNode).on('mouseenter', function (e) {
                    new Tooltip({
                        target: e.target,
                        position: 'right',
                        data: {
                            content: domAttr.get(e.target, 'data-tooltip-content')
                        },
                        hover: true
                    });
                });

                touch.press(this.elementToggleWidth, this._toggleWidth.bind(this));

                touch.press(this.elementToolDrag, function() {
                    this.localStorage.set('MODE', MODES.DRAG);
                    topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAG_MODE);
                }.bind(this));

                touch.press(this.elementToolSelect, function() {
                    if (!domAttr.has(this.elementToolSelect, 'disabled')) {
                        this.localStorage.set('MODE', MODES.SELECT);
                        topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_SELECT_MODE);
                    }
                }.bind(this));

                touch.press(this.elementToolFreehand, function(e) {
                    if (!domAttr.has(this.elementToolFreehand, 'disabled')) {
                        this.localStorage.set('MODE', MODES.PENCIL);
                        topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_FREE);
                        e.stopImmediatePropagation();
                    }
                }.bind(this));

                touch.press(this.elementToolHighlight, function(e) {
                    if (!domAttr.has(this.elementToolHighlight, 'disabled')) {
                        this.localStorage.set('MODE', MODES.HIGHLIGHTER);
                        topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_HIGHLIGHT);
                        e.stopImmediatePropagation();
                    }
                }.bind(this));

                touch.press(this.elementToolLine, function(e) {
                    if (!domAttr.has(this.elementToolLine, 'disabled')) {
                        this.localStorage.set('MODE', MODES.LINE);
                        topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_LINE);
                        e.stopImmediatePropagation();
                    }
                }.bind(this));

                touch.press(this.elementToolArrow, function(e) {
                    if (!domAttr.has(this.elementToolArrow, 'disabled')) {
                        this.localStorage.set('MODE', MODES.ARROW);
                        topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_ARROW);
                        e.stopImmediatePropagation();
                    }
                }.bind(this));

                touch.press(this.elementToolRectangle, function(e) {
                    if (!domAttr.has(this.elementToolRectangle, 'disabled')) {
                        this.localStorage.set('MODE', MODES.RECTANGLE);
                        topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_RECTANGLE);
                        e.stopImmediatePropagation();
                    }
                }.bind(this));

                touch.press(this.elementToolEllipse, function(e) {
                    if (!domAttr.has(this.elementToolEllipse, 'disabled')) {
                        this.localStorage.set('MODE', MODES.ELLIPSE);
                        topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_ELLIPSE);
                        e.stopImmediatePropagation();
                    }
                }.bind(this));

                touch.press(this.elementToolHexagon, function(e) {
                    if (!domAttr.has(this.elementToolHexagon, 'disabled')) {
                        this.localStorage.set('MODE', MODES.HEXAGON);
                        topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_HEXAGON);
                        e.stopImmediatePropagation();
                    }
                }.bind(this));

                touch.press(this.elementToolPolygon, function(e) {
                    if (!domAttr.has(this.elementToolPolygon, 'disabled')) {
                        this.localStorage.set('MODE', MODES.POLYGON);
                        topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_POLYGON);
                        e.stopImmediatePropagation();
                    }
                }.bind(this));

                touch.press(this.elementToolHighlightRegion, function(e) {
                    if (!domAttr.has(this.elementToolHighlightRegion, 'disabled')) {
                        this.localStorage.set('MODE', MODES.HIGHLIGHT_REGION);
                        topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_HIGHLIGHT_REGION);
                        e.stopImmediatePropagation();
                    }
                }.bind(this));

                touch.press(this.elementToolText, function() {
                    if (!domAttr.has(this.elementToolText, 'disabled')) {
                        this.localStorage.set('MODE', MODES.TEXT);
                        topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAW_TEXT);
                    }
                }.bind(this));

                touch.press(this.elementToolPin, function() {
                    if (!domAttr.has(this.elementToolPin, 'disabled')) {
                        this.localStorage.set('MODE', MODES.PIN);
                        topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_PIN);
                    }
                }.bind(this));

                touch.press(this.elementToolDeleteSelection, function() {
                    if (!domAttr.has(this.elementToolDeleteSelection, 'disabled')) {
                        topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DELETE_SELECTION);
                    }
                }.bind(this));

                touch.press(this.elementToolClear, function() {
                    if (!domAttr.has(this.elementToolClear, 'disabled')) {
                        topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_CLEAR_ALL, this.localStorage.get('MODE'));
                    }
                }.bind(this));
            },

            _subscribe: function() {
                this.own(
                    topic.subscribe(Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_DISCONNECTED, this._disable.bind(this)),
                    topic.subscribe(Topics.DOCUMENT_VIEWER_ANNOTATION_INITIAL_SOCKET_RECEIVED, this._enable.bind(this)),
                    topic.subscribe(Topics.DOCUMENT_VIEWER_DISABLE_DELETE_SELECTION, this.disableDeleteSelection.bind(this)),
                    topic.subscribe(Topics.DOCUMENT_VIEWER_ENABLE_DELETE_SELECTION, this.enableDeleteSelection.bind(this))
                );
            },

            _disable: function() {
                this.toolbar._getNavigationItems().forEach(this.disableItem);
                this.enableItem(this.elementToggleWidth);
                this.colorPicker.disable();
                if (this.users) {
                    this.users.disconnected();
                    domAttr.remove(this.elementConnectedUserIcon, 'data-counter');
                    query('.sos-form-checkbox input', this.users.view.domNode).forEach(this.disableItem);
                }
            },

            _enable: function() {
                this.toolbar._getNavigationItems().forEach(this.enableItem);
                this.colorPicker.enable();
                this.disableDeleteSelection();
                if (this.users) {
                    this.users.connected();
                    if (this.connectedUsersCollection.length > 1) {
                        domAttr.set(
                            this.elementConnectedUserIcon,
                            'data-counter',
                            this.connectedUsersCollection.length - 1 > 9 ? '9+' : this.connectedUsersCollection.length - 1
                        );
                    }
                    query('.sos-form-checkbox input', this.users.view.domNode).forEach(this.enableItem);
                }
            },

            _renderUsers: function() {
                if (this.users) {
                    let userCollection = [];

                    this.connectedUsersCollection.forEach(function(user) {
                        user.isHidden = this.hiddenUsers.indexOf(user.personPK) < 0;
                        user.isConnected = true;
                        userCollection.push(user)
                    }.bind(this));

                    this.usersCollection.forEach(function(user) {
                        if (!userCollection.some(function(existingUser) { return existingUser.personPK === user.personPK; })) {
                            user.isHidden = this.hiddenUsers.indexOf(user.personPK) < 0;
                            user.isConnected = false;
                            userCollection.push(user);
                        }
                    }.bind(this));

                    this.users.setUsers(userCollection);
                }
            },

            connectUser: function(user) {
                this.notifier.show(user.displayName + ' connected.');
            },

            disconnectUser: function(user) {
                this.notifier.show(user.displayName + ' disconnected.');
            },

            show: function() {
                domClass.remove(this.domNode, 'hidden');
            },

            hide: function() {
                domClass.add(this.domNode, 'hidden');
            },

            setUsers: function(userCollection) {
                this.usersCollection = userCollection;
            },

            setConnectedUsers: function(users) {
                this.connectedUsersCollection = users;

                if (this.connectedUsersCollection.length > 1) {
                    domAttr.set(
                        this.elementConnectedUserIcon,
                        'data-counter',
                        this.connectedUsersCollection.length - 1 > 9 ? '9+' : this.connectedUsersCollection.length - 1
                    );
                } else {
                    domAttr.remove(this.elementConnectedUserIcon, 'data-counter');
                }

                this.showConnectedUsers();
            },

            showConnectedUsers: function() {
                if (!this.users) {
                    this.users = new Users({
                        pastContributors: [],
                        pastContributorsExpanded: true,
                        connectedUsers: [],
                        connectedUsersExpanded: true
                    }, this.elementConnectedUsers);
                }

                this._renderUsers();
            },

            showFreehand: function() {
                domClass.add(this.elementToolFreehand, 'active');
            },

            hideFreehand: function() {
                domClass.remove(this.elementToolFreehand, 'active');
            },

            showHighlight: function() {
                domClass.add(this.elementToolHighlight, 'active');
            },

            hideHighlight: function() {
                domClass.remove(this.elementToolHighlight, 'active');
            },

            showText: function() {
                domClass.add(this.elementToolText, 'active');
            },

            hideText: function() {
                domClass.remove(this.elementToolText, 'active');
            },

            showPin: function() {
                domClass.add(this.elementToolPin, 'active');
            },

            hidePin: function() {
                domClass.remove(this.elementToolPin, 'active');
            },

            showLine: function() {
                domClass.add(this.elementToolLine, 'active');
            },

            hideLine: function() {
                domClass.remove(this.elementToolLine, 'active');
            },

            showSelect: function() {
                domClass.add(this.elementToolSelect, 'active');
            },

            hideSelect: function() {
                domClass.remove(this.elementToolSelect, 'active');
            },

            showEllipse: function() {
                domClass.add(this.elementToolEllipse, 'active');
            },

            hideEllipse: function() {
                domClass.remove(this.elementToolEllipse, 'active');
            },

            showRectangle: function() {
                domClass.add(this.elementToolRectangle, 'active');
            },

            hideRectangle: function() {
                domClass.remove(this.elementToolRectangle, 'active');
            },

            showHexagon: function() {
                domClass.add(this.elementToolHexagon, 'active');
            },

            hideHexagon: function() {
                domClass.remove(this.elementToolHexagon, 'active');
            },

            showPolygon: function() {
                domClass.add(this.elementToolPolygon, 'active');
            },

            hidePolygon: function() {
                domClass.remove(this.elementToolPolygon, 'active');
            },

            showHighlightRegion: function() {
                domClass.add(this.elementToolHighlightRegion, 'active');
            },

            hideHighlightRegion: function() {
                domClass.remove(this.elementToolHighlightRegion, 'active');
            },

            showArrow: function() {
                domClass.add(this.elementToolArrow, 'active');
            },

            hideArrow: function() {
                domClass.remove(this.elementToolArrow, 'active');
            },

            showDrag: function() {
                domClass.add(this.elementToolDrag, 'active');
            },

            hideDrag: function() {
                domClass.remove(this.elementToolDrag, 'active');
            },

            addUser: function(user) {
                for (let i = 0; i < this.usersCollection.length; i++) {
                    if (this.usersCollection[i].personPK === user.personPK) {
                        return;
                    }
                }

                this.usersCollection.push(user);
            },

            removeUser: function (user) {
                for (let i = 0; i < this.usersCollection.length; i++) {
                    if (this.usersCollection[i].personPK === user.personPK) {
                        this.usersCollection.splice(i, 1);
                        break;
                    }
                }

                this._renderUsers();
            },

            showUserAnnotations: function (user) {
                for (let i = 0; i < this.hiddenUsers.length; i++) {
                    if (this.hiddenUsers[i] === user) {
                        this.hiddenUsers.splice(i, 1);
                    }
                }
            },

            hideUserAnnotations: function (user) {
                this.hiddenUsers.push(user);
            },

            disableItem: function(item) {
                domAttr.set(item, 'disabled', 'disabled');
                query('a, input', item).attr('disabled', 'disabled');
            },

            enableItem: function(item) {
                domAttr.remove(item, 'disabled');
                query('a, input', item).removeAttr('disabled');
            },

            disableDeleteSelection: function() {
                this.disableItem(this.elementToolDeleteSelection);
            },

            enableDeleteSelection: function() {
                this.enableItem(this.elementToolDeleteSelection);
            },

            disableCloudStyle: function() {
                this.lineStylePicker.disableCloud();
            },

            enableCloudStyle: function() {
                this.lineStylePicker.enableCloud();
            },

            _initCaptureDialog: function() {
                const captureCameraDialog = new CaptureCamera();

                captureCameraDialog.on('submit', async (capturedImage) => {
                    let capturedFile = await fetch(capturedImage)
                        .then(r => r.blob())
                        .then(blobFile => new File([blobFile], 'capture', {type: CAPTURE_OUTPUT_FORMAT}));
                    topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_APPLY_IMAGE_FILE, capturedFile);
                });

                this.openCaptureDialogBtn.addEventListener('click', () => {
                    captureCameraDialog.open();
                });
            },

            _onParentOnlyClick: function(e) {
                e.target.nextElementSibling.click();
            },

            _onAddImageChange: function(e) {
                topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_APPLY_IMAGE_FILE, e.target.files[0]);
                this.elementToolImageUpload.value = '';
            },

            _onStampClicked: function(e) {
                let stampName = domAttr.get(e.target, 'data-stamp');
                let isDisabled = domAttr.has(e.target, 'disabled');

                if (!stampName) {
                    const stamp = e.target.closest('.image-preview-dropdown-button');
                    stampName = domAttr.get(stamp, 'data-stamp');
                    isDisabled = domAttr.has(stamp, 'disabled');
                }

                if (!isDisabled) {
                    const foundStamp = StampConfig.STAMPS.find(function (stamp) {
                        return stamp.name === stampName;
                    });

                    topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_APPLY_IMAGE_URL, foundStamp.href);
                }
            },

            _onFillChanged: function(e) {
                const isFilled = e.target.checked;
                this.localStorage.set('COLOR_FILLED', isFilled)
                topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_CHANGE_COLOUR_FILL, isFilled);
            }
        });

        this.view = new View({}, document.querySelector(`.${node}`));
    };

    AnnotationToolbar.prototype.setConnectedUsers = function(connectedUsers) {
        this.view.setConnectedUsers(connectedUsers);
    };

    AnnotationToolbar.prototype.connectUser = function(user) {
        this.view.connectUser(user);
    };

    AnnotationToolbar.prototype.disconnectUser = function(user) {
        this.view.disconnectUser(user);
    };

    AnnotationToolbar.prototype.hide = function() {
        this.view.hide();
    };

    AnnotationToolbar.prototype.show = function() {
        this.view.show();
    };

    AnnotationToolbar.prototype.showFreehand = function() {
        this.view.showFreehand();
    };

    AnnotationToolbar.prototype.hideFreehand = function() {
        this.view.hideFreehand();
    };

    AnnotationToolbar.prototype.showHighlight = function() {
        this.view.showHighlight();
    };

    AnnotationToolbar.prototype.hideHighlight = function() {
        this.view.hideHighlight();
    };

    AnnotationToolbar.prototype.showText = function() {
        this.view.showText();
    };

    AnnotationToolbar.prototype.hideText = function() {
        this.view.hideText();
    };

    AnnotationToolbar.prototype.showPin = function() {
        this.view.showPin();
    };

    AnnotationToolbar.prototype.hidePin = function() {
        this.view.hidePin();
    };

    AnnotationToolbar.prototype.showLine = function() {
        this.view.showLine();
    };

    AnnotationToolbar.prototype.hideLine = function() {
        this.view.hideLine();
    };

    AnnotationToolbar.prototype.showSelect = function() {
        this.view.showSelect();
    };

    AnnotationToolbar.prototype.hideSelect = function() {
        this.view.hideSelect();
    };

    AnnotationToolbar.prototype.showDrag = function() {
        this.view.showDrag();
    };

    AnnotationToolbar.prototype.hideDrag = function() {
        this.view.hideDrag();
    };

    AnnotationToolbar.prototype.showEllipse = function() {
        this.view.showEllipse();
    };

    AnnotationToolbar.prototype.hideEllipse = function() {
        this.view.hideEllipse();
    };

    AnnotationToolbar.prototype.showRectangle = function() {
        this.view.showRectangle();
    };

    AnnotationToolbar.prototype.hideRectangle = function() {
        this.view.hideRectangle();
    };

    AnnotationToolbar.prototype.showHexagon = function() {
        this.view.showHexagon();
    };

    AnnotationToolbar.prototype.hideHexagon = function() {
        this.view.hideHexagon();
    };

    AnnotationToolbar.prototype.showPolygon = function() {
        this.view.showPolygon();
    };

    AnnotationToolbar.prototype.hidePolygon = function() {
        this.view.hidePolygon();
    };

    AnnotationToolbar.prototype.showHighlightRegion = function() {
        this.view.showHighlightRegion();
    };

    AnnotationToolbar.prototype.hideHighlightRegion = function() {
        this.view.hideHighlightRegion();
    };

    AnnotationToolbar.prototype.showArrow = function() {
        this.view.showArrow();
    };

    AnnotationToolbar.prototype.hideArrow = function() {
        this.view.hideArrow();
    };

    AnnotationToolbar.prototype.destroy = function() {
        this.view.destroyRecursive();
    };

    AnnotationToolbar.prototype.setUsers = function(users) {
        this.view.setUsers(users);
    };

    AnnotationToolbar.prototype.setConnectedUsers = function(users) {
        this.view.setConnectedUsers(users);
    };

    AnnotationToolbar.prototype.showConnectedUsers = function() {
        this.view.showConnectedUsers();
    };

    AnnotationToolbar.prototype.enableToolbar = function() {
        this.view._enable();
    };

    AnnotationToolbar.prototype.disableToolbar = function() {
        this.view._disable();
    };

    AnnotationToolbar.prototype.addUser = function(personPK) {
        this.view.addUser(personPK);
    };

    AnnotationToolbar.prototype.removeUser = function(user) {
        this.view.removeUser(user);
    };

    AnnotationToolbar.prototype.showUserAnnotations = function(personPK) {
        this.view.showUserAnnotations(personPK);
    };

    AnnotationToolbar.prototype.hideUserAnnotations = function(personPK) {
        this.view.hideUserAnnotations(personPK);
    };

    AnnotationToolbar.prototype.disableDeleteSelection = function() {
        this.view.disableDeleteSelection();
    };

    AnnotationToolbar.prototype.enableDeleteSelection = function() {
        this.view.enableDeleteSelection();
    };

    AnnotationToolbar.prototype.disableCloudStyle = function() {
        this.view.disableCloudStyle();
    };

    AnnotationToolbar.prototype.enableCloudStyle = function() {
        this.view.enableCloudStyle();
    };

    return AnnotationToolbar;
});
},
'api/Factory':function(){
define([
    'library/request/fetch/Factory',
    'library/request/URLConnectionBuilder',
    'library/request/URLResponseProcessorBuilder',
    'library/request/dojo/URLConnectionProcessorBuilder',
    './address/Config',
    './address/Factory',
    './branch-office/Config',
    './branch-office/Factory',
    './calendar/Config',
    './calendar/Factory',
    './contact/Config',
    './contact/Factory',
    './contact-category/Config',
    './contact-category/Factory',
    './doccontrol/Config',
    './doccontrol/Factory',
    './doccontrol/document/Config',
    './doccontrol/document/Factory',
    './doccontrol/drawing-discipline/Config',
    './doccontrol/drawing-discipline/Factory',
    './doccontrol/document/revision/Config',
    './doccontrol/document/revision/Factory',
    './doccontrol/document/tree/Config',
    './doccontrol/document/tree/Factory',
    './doccontrol/correspondence/Config',
    './doccontrol/correspondence/Factory',
    './doccontrol/retirement/Config',
    './doccontrol/retirement/Factory',
    './doccontrol/revision/Config',
    './doccontrol/revision/Factory',
    './doccontrol/revision-details/Config',
    './doccontrol/revision-details/Factory',
    './doccontrol/search/Factory',
    './doccontrol/search/Config',
    './doccontrol/template/Config',
    './doccontrol/template/Factory',
    './doccontrol/tree/node/Factory',
    './doccontrol/tree/node/Config',
    './file/Config',
    './file/Factory',
    './file-tray/Config',
    './file-tray/Factory',
    './log/Config',
    './log/Factory',
    './my-group/Factory',
    './my-group/Config',
    './mail/Config',
    './mail/Factory',
    './organisation/Config',
    './organisation/Factory',
    './person/Config',
    './person/Factory',
    './project/Config',
    './project/Factory',
    './project-stage/Factory',
    './project-stage/Config',
    './role/project-stage/Factory',
    './role/project-stage/Config',
    './search/Config',
    './search/Factory',
    './system/Config',
    './system/Factory',
    './trade/Config',
    './trade/Factory',
    './user/Config',
    './user/Factory'
], function(
    FetchFactory,
    URLConnectionBuilder,
    URLResponseProcessorBuilder,
    URLConnectionProcessorBuilder,
    AddressConfig,
    AddressFactory,
    BranchOfficeConfig,
    BranchOfficeFactory,
    CalendarConfig,
    CalendarFactory,
    ContactConfig,
    ContactFactory,
    ContactCategoryConfig,
    ContactCategoryFactory,
    DocControlConfig,
    DocControlFactory,
    DocControlDocumentConfig,
    DocControlDocumentFactory,
    DocControlDrawingDisciplineConfig,
    DocControlDrawingDisciplineFactory,
    DocControlDocumentRevisionConfig,
    DocControlDocumentRevisionFactory,
    DocControlDocumentTreeConfig,
    DocControlDocumentTreeFactory,
    DocControlCorrespondenceConfig,
    DocControlCorrespondenceFactory,
    DocControlRetirementConfig,
    DocControlRetirementFactory,
    DocControlRevisionConfig,
    DocControlRevisionFactory,
    DocControlRevisionDetailsConfig,
    DocControlRevisionDetailsFactory,
    DocControlSearchFactory,
    DocControlSearchConfig,
    DocControlTemplateConfig,
    DocControlTemplateFactory,
    DocControlTreeNodeFactory,
    DocControlTreeNodeConfig,
    FileConfig,
    FileFactory,
    FileTrayConfig,
    FileTrayFactory,
    LogConfig,
    LogFactory,
    MyGroupsFactory,
    MyGroupsConfig,
    MailConfig,
    MailFactory,
    OrganisationConfig,
    OrganisationFactory,
    PersonConfig,
    PersonFactory,
    ProjectConfig,
    ProjectFactory,
    ProjectStageFactory,
    ProjectStageConfig,
    RoleProjectStageFactory,
    RoleProjectStageConfig,
    SearchConfig,
    SearchFactory,
    SystemConfig,
    SystemFactory,
    TradeConfig,
    TradeFactory,
    UserConfig,
    UserFactory
) {
    const Factory = function(rootUrl) {
        this.rootUrl = rootUrl;

        this.urlConnectionBuilder = new URLConnectionBuilder(
            new URLConnectionProcessorBuilder()
        );

        this.urlResponseProcessorBuilder = new URLResponseProcessorBuilder();
    };

    Factory.prototype.getAddressFactory = function() {
        return new AddressFactory(
            new AddressConfig(this.rootUrl),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getBranchOfficeFactory = function() {
        return new BranchOfficeFactory(
            new BranchOfficeConfig(this.rootUrl),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getCalendarFactory = function() {
        return new CalendarFactory(
            new CalendarConfig(this.rootUrl),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getContactCategoryFactory = function() {
        return new ContactCategoryFactory(
            new ContactCategoryConfig(this.rootUrl),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getContactFactory = function() {
        return new ContactFactory(
            new ContactConfig(this.rootUrl),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getDocControlFactory = function() {
        return new DocControlFactory(
            new DocControlConfig(this.rootUrl),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getDocControlCorrespondenceFactory = function() {
        return new DocControlCorrespondenceFactory(
            new DocControlCorrespondenceConfig(this.rootUrl),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getDocControlDocumentFactory = function() {
        return new DocControlDocumentFactory(
            new DocControlDocumentConfig(this.rootUrl),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getDocControlDrawingDisciplineFactory = function() {
        return new DocControlDrawingDisciplineFactory(
            new DocControlDrawingDisciplineConfig(this.rootUrl),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getDocControlDocumentRevisionFactory = function() {
        return new DocControlDocumentRevisionFactory(
            new DocControlDocumentRevisionConfig(this.rootUrl),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getDocControlDocumentTreeFactory = function() {
        return new DocControlDocumentTreeFactory(
            new DocControlDocumentTreeConfig(this.rootUrl),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getDocControlRetirementFactory = function() {
        return new DocControlRetirementFactory(
            new DocControlRetirementConfig(this.rootUrl),
            new URLConnectionBuilder(
                new URLConnectionProcessorBuilder()
            ),
            new URLResponseProcessorBuilder()
        );
    };

    Factory.prototype.getDocControlRevisionFactory = function() {
        return new DocControlRevisionFactory(
            new DocControlRevisionConfig(this.rootUrl),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getDocControlRevisionDetailsFactory = function() {
        return new DocControlRevisionDetailsFactory(
            new DocControlRevisionDetailsConfig(this.rootUrl),
            new URLConnectionBuilder(
                new URLConnectionProcessorBuilder()
            ),
            new URLResponseProcessorBuilder()
        );
    };

    Factory.prototype.getDocControlTreeNodeFactory = function() {
        return new DocControlTreeNodeFactory(
            new DocControlTreeNodeConfig(this.rootUrl),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getFileFactory = function() {
        return new FileFactory(
            new FileConfig(),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getFileTrayFactory = function() {
        return new FileTrayFactory(
            new FileTrayConfig(),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getLogFactory = function() {
        return new LogFactory(
            new LogConfig(this.rootUrl),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getMailFactory = function() {
        return new MailFactory(
            new MailConfig(this.rootUrl),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getMyGroupsFactory = function() {
        return new MyGroupsFactory(
            new MyGroupsConfig(this.rootUrl),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getOrganisationFactory = function() {
        return new OrganisationFactory(
            new OrganisationConfig(this.rootUrl),
            new FetchFactory(),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getPersonFactory = function() {
        return new PersonFactory(
            new PersonConfig(this.rootUrl),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getProjectFactory = function() {
        return new ProjectFactory(
            new ProjectConfig(this.rootUrl),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getProjectStageFactory = function() {
        return new ProjectStageFactory(
            new ProjectStageConfig(this.rootUrl),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getRoleProjectStageFactory = function() {
        return new RoleProjectStageFactory(
            new RoleProjectStageConfig(this.rootUrl),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getSearchFactory = function() {
        return new SearchFactory(
            new SearchConfig(this.rootUrl),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getSystemFactory = function() {
        return new SystemFactory(
            new SystemConfig(this.rootUrl),
            this.urlConnectionBuilder
        );
    };

    Factory.prototype.getTradeFactory = function() {
        return new TradeFactory(
            new TradeConfig(),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getUserFactory = function() {
        return new UserFactory(
            new UserConfig(),
            this.urlConnectionBuilder
        );
    };

    Factory.prototype.getDocControlSearchFactory = function() {
        return new DocControlSearchFactory(
            new DocControlSearchConfig(this.rootUrl),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getDocControlTemplateFactory = function() {
        return new DocControlTemplateFactory(
            new DocControlTemplateConfig(this.rootUrl),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    return Factory;
});

},
'api/address/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    var Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_address_country = 'address/country/';
        this.api_address_county = 'address/county/';
        this.api_country = 'country/';
        this.api_county = 'county/';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});

},
'api/address/Factory':function(){
define([
    'api/parser/Collection',
    'spencer/core/parser/Country',
    'spencer/core/parser/County',
    './CountryCollection',
    './CountyCollection'
], function(
    CollectionParser,
    CountryParser,
    CountyParser,
    CountryCollection,
    CountyCollection
) {
    var Factory = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Factory.prototype.getCountryCollection = function() {
        return new CountryCollection(
            this.config.getUrl('api_country'),
            this.urlConnectionBuilder,
            new CollectionParser(new CountryParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getCountyCollection = function() {
        return new CountyCollection(
            this.config.getUrl('api_county'),
            this.urlConnectionBuilder,
            new CollectionParser(new CountyParser()),
            this.urlResponseProcessorBuilder
        );
    };

    return Factory;
});

},
'spencer/core/parser/Country':function(){
define([
    'spencer/core/data/Country'
], function (CountryVO) {
    var Country = function () {};

    Country.prototype.parse = function(item) {
        var vo = new CountryVO();
        vo.setCountryPK(item.countryPK || null)
            .setName(item.name || null);

        return vo;
    };

    return Country;
});
},
'spencer/core/data/Country':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Country {
        constructor() {
            this.countryPK = null;
            this.name = null;
        }
        setCountryPK(countryPK) {
            this.countryPK = countryPK;
            return this;
        }
        getCountryPK() {
            return this.countryPK;
        }
        setName(name) {
            this.name = name;
            return this;
        }
        getName() {
            return this.name;
        }
    }
    return Country;
});

},
'spencer/core/parser/County':function(){
define([
    'spencer/core/data/County'
], function (CountyVO) {
    var County = function () {};

    County.prototype.parse = function(item) {
        var vo = new CountyVO();
        vo.setCountryPK(item.countryPK || null)
            .setCountyPK(item.countyPK || null)
            .setName(item.name || null);

        return vo;
    };

    return County;
});
},
'spencer/core/data/County':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class County {
        constructor() {
            this.countryPK = null;
            this.countyPK = null;
            this.name = null;
        }
        setCountryPK(countryPK) {
            this.countryPK = countryPK;
            return this;
        }
        getCountryPK() {
            return this.countryPK;
        }
        setCountyPK(countyPK) {
            this.countyPK = countyPK;
            return this;
        }
        getCountyPK() {
            return this.countyPK;
        }
        setName(name) {
            this.name = name;
            return this;
        }
        getName() {
            return this.name;
        }
    }
    return County;
});

},
'api/address/CountryCollection':function(){
define([], function () {
    var CountryCollection = function (url, urlConnectionBuilder, collectionParser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.parser = collectionParser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    CountryCollection.prototype.fetch = function (handlers) {
        var urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url);
        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    return CountryCollection;
});
},
'api/address/CountyCollection':function(){
define([
    './filter/Country'
], function (FilterCountry) {
    var CountyCollection = function (url, urlConnectionBuilder, collectionParser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.parser = collectionParser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;

        this.constants = {
            URL_PARAM_COUNTRY_PK: 'countryPK'
        };

        this._createBasicQuery = function(filterCollection) {
            var query = {};

            var countryFilter = filterCollection.getFilterByClass(FilterCountry);
            if (countryFilter) {
                query[this.constants.URL_PARAM_COUNTRY_PK] = countryFilter.getCountryPK();
            }

            return query;
        };
    };

    CountyCollection.prototype.fetch = function (handlers, filterCollection) {
        var urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url);
        urlConnection.setQuery(this._createBasicQuery(filterCollection));
        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    return CountyCollection;
});
},
'api/address/filter/Country':function(){
define([], function() {
    var Country = function(countryPK) {
        this.countryPK = countryPK;
    };

    Country.prototype.getCountryPK = function() {
        return this.countryPK;
    };

    return Country;
});
},
'api/branch-office/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    var Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_branch_office = 'branch-office/';
        this.api_branch_office_email = 'branch-office-email/';
        this.api_branch_office_email_collection = 'branch-office/email/'
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});

},
'api/branch-office/Factory':function(){
define([
    'api/parser/Collection',
    'spencer/core/parser/BranchOffice',
    'spencer/core/parser/BranchOfficeEmail',
    './BranchOffice',
    './Collection',
    './Email',
    './EmailCollection',
    './ManagerFactory',
    '@lib/api/branch-office/email/Collection',
    '@lib/api/branch-office/email/parser/Collection',
    'library/request/fetch/Factory'
], function(
    CollectionParser,
    BranchOfficeParser,
    BranchOfficeEmailParser,
    BranchOffice,
    Collection,
    Email,
    EmailCollection,
    ManagerFactory,
    BranchOfficeEmailCollection,
    BranchOfficeEmailCollectionParser,
    FetchFactory
) {
    var Factory = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Factory.prototype.getBranchOffice = function() {
        var c = new CollectionParser(new BranchOfficeParser());
        c.setIsSingleItemCollection(true);

        return new BranchOffice(
            this.config.getUrl('api_branch_office'),
            this.urlConnectionBuilder,
            c,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getCollection = function() {
        return new Collection(
            this.config.getUrl('api_branch_office'),
            this.urlConnectionBuilder.build(),
            new CollectionParser(new BranchOfficeParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getEmail = function() {
        return new Email(
            this.config.getUrl('api_branch_office_email'),
            this.urlConnectionBuilder.build()
        );
    };

    Factory.prototype.getEmailCollection = function() {
        return new EmailCollection(
            this.config.getUrl('api_branch_office_email'),
            this.urlConnectionBuilder.build(),
            new CollectionParser(new BranchOfficeEmailParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getManagerFactory = function() {
        return new ManagerFactory(
            this.config.getUrl('api_branch_office'),
            this.urlConnectionBuilder
        );
    };

    Factory.prototype.getBranchOfficeEmailCollection = function () {
        return new BranchOfficeEmailCollection(
            this.config.getUrl('api_branch_office_email_collection', 'v2/'),
            new FetchFactory(),
            new BranchOfficeEmailCollectionParser()
        );
    }

    return Factory;
});

},
'spencer/core/parser/BranchOffice':function(){
define([
    'spencer/core/data/BranchOffice',
    './Address'
], function(BranchOfficeVO, AddressParser) {
    var BranchOffice = function() {
        this.addressParser = new AddressParser();
    };

    BranchOffice.prototype.parse = function(item) {
        const bo = new BranchOfficeVO();

        if(item === undefined) {
            return bo;
        }

        bo.setAddress(this.addressParser.parse(item));
        bo.setBranchOfficePK(item.branchOfficePK || null);
        bo.setHeadOffice(item.isHeadOffice || null);
        bo.setName(item.name || null);
        bo.setTelephone(item.telephone || null);

        return bo;
    };

    return BranchOffice;
});
},
'spencer/core/data/BranchOffice':function(){
define(["require", "exports", "./Address"], function (require, exports, Address) {
    "use strict";
    class BranchOffice {
        constructor() {
            this.headOffice = false;
            this.address = new Address();
        }
        setAddress(address) {
            this.address = address;
            return this;
        }
        getAddress() {
            return this.address;
        }
        getBranchOfficePK() {
            return this.branchOfficePK;
        }
        setBranchOfficePK(branchOfficePK) {
            this.branchOfficePK = branchOfficePK;
            return this;
        }
        isHeadOffice() {
            return this.headOffice;
        }
        setHeadOffice(headOffice) {
            this.headOffice = headOffice;
            return this;
        }
        getName() {
            return this.name;
        }
        setName(name) {
            this.name = name;
            return this;
        }
        getTelephone() {
            return this.telephone;
        }
        setTelephone(telephone) {
            this.telephone = telephone;
            return this;
        }
    }
    return BranchOffice;
});

},
'spencer/core/data/Address':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Address {
        setAddress1(address1) {
            this.address1 = address1;
            return this;
        }
        getAddress1() {
            return this.address1;
        }
        setAddress2(address2) {
            this.address2 = address2;
            return this;
        }
        getAddress2() {
            return this.address2;
        }
        setAddress3(address3) {
            this.address3 = address3;
            return this;
        }
        getAddress3() {
            return this.address3;
        }
        setTown(town) {
            this.town = town;
            return this;
        }
        getTown() {
            return this.town;
        }
        setCountryPK(countryPK) {
            this.countryPK = countryPK;
            return this;
        }
        getCountryPK() {
            return this.countryPK;
        }
        setCountry(country) {
            this.country = country;
            return this;
        }
        getCountry() {
            return this.country;
        }
        setCounty(county) {
            this.county = county;
            return this;
        }
        getCounty() {
            return this.county;
        }
        setCountyPK(countyPK) {
            this.countyPK = countyPK;
            return this;
        }
        getCountyPK() {
            return this.countyPK;
        }
        setPostCode(postCode) {
            this.postCode = postCode;
            return this;
        }
        getPostCode() {
            return this.postCode;
        }
        equals(address) {
            const county = this.county ? this.county.trim() : null;
            const incomingCounty = address.county ? address.county.trim() : null;
            const town = this.town ? this.town.trim() : null;
            const incomingTown = address.town ? address.town.trim() : null;
            return this.address1.trim() === address.address1.trim()
                && this.address2.trim() === address.address2.trim()
                && this.address3.trim() === address.address3.trim()
                && this.countryPK === address.countryPK
                && county === incomingCounty
                && this.country.trim() === address.country.trim()
                && this.countyPK === address.countyPK
                && this.postCode.trim() === address.postCode.trim()
                && town === incomingTown;
        }
        clone() {
            return new Address()
                .setAddress1(this.address1)
                .setAddress2(this.address2)
                .setAddress3(this.address3)
                .setTown(this.town)
                .setCountryPK(this.countryPK)
                .setCountry(this.country)
                .setCounty(this.county)
                .setCountyPK(this.countyPK)
                .setPostCode(this.postCode);
        }
    }
    return Address;
});

},
'spencer/core/parser/Address':function(){
define([
    'spencer/core/data/Address'
], function (AddressVO) {
    var Address = function () {};

    Address.prototype.parse = function(item) {
        if (item === undefined) {
            return new AddressVO();
        }

        return (new AddressVO()).setAddress1(item.address1)
            .setAddress2(item.address2)
            .setAddress3(item.address3)
            .setTown(item.town || null)
            .setCountyPK(item.countyPK || null)
            .setCounty(item.county || null)
            .setCountryPK(item.countryPK || null)
            .setCountry(item.country || null)
            .setPostCode(item.postCode);
    };

    return Address;
});

},
'spencer/core/parser/BranchOfficeEmail':function(){
define([
    'spencer/core/data/BranchOfficeEmail'
], function(BranchOfficeEmailVO) {
    const BranchOfficeEmail = function() {
    };

    BranchOfficeEmail.prototype.parse = function(item) {
        const boe = new BranchOfficeEmailVO();

        boe.setBranchOfficePK(item.branchOfficePK || null);
        boe.setBranchOfficeEmailPK(item.branchOfficeEmailPK || null);
        boe.setEmail(item.email || null);

        return boe;
    };

    return BranchOfficeEmail;
});
},
'spencer/core/data/BranchOfficeEmail':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Email {
        constructor() {
            this.branchOfficePK = null;
            this.branchOfficeEmailPK = null;
            this.email = null;
        }
        getBranchOfficePK() {
            return this.branchOfficePK;
        }
        setBranchOfficePK(branchOfficePK) {
            this.branchOfficePK = branchOfficePK;
            return this;
        }
        getBranchOfficeEmailPK() {
            return this.branchOfficeEmailPK;
        }
        setBranchOfficeEmailPK(branchOfficeEmailPK) {
            this.branchOfficeEmailPK = branchOfficeEmailPK;
            return this;
        }
        getEmail() {
            return this.email;
        }
        setEmail(email) {
            this.email = email;
            return this;
        }
    }
    return Email;
});

},
'api/branch-office/BranchOffice':function(){
define([], function () {
    const BranchOffice = function (url, urlConnectionBuilder, collectionParser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.parser = collectionParser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    BranchOffice.prototype.get = function (handlers, branchOfficePK) {
        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url + branchOfficePK);
        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    return BranchOffice;
});
},
'api/branch-office/Collection':function(){
define([
    './filter/Organisation',
    './filter/Query'
], function (FilterOrganisation, FilterQuery) {
    var Collection = function (url, urlConnection, collectionParser, urlResponseProcessorBuilder) {
        this.urlConnection = urlConnection;
        this.parser = collectionParser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;

        this.constants = {
            DEFAULT_LIMIT: 10,
            DEFAULT_OFFSET: 0,
            URL_PARAM_LIMIT: 'limit',
            URL_PARAM_OFFSET: 'offset',
            URL_PARAM_ORGANISATION_PK: 'organisationPK',
            URL_PARAM_SEARCH: 'search'
        };

        this.limit = this.constants.DEFAULT_LIMIT;
        this.offset = this.constants.DEFAULT_OFFSET;
        this.query = null;

        this.urlConnection.setUrl(url);

        this._configureConnection = function (handlers, filterCollection) {
            this.urlConnection.setQuery(this._createBasicQuery(filterCollection));
            this.urlConnection.setSuccessHandler(
                this.urlResponseProcessorBuilder.createProcessor(
                    this.parser,
                    handlers.getSuccess(),
                    handlers.getError()
                )
            );

            this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
            this.urlConnection.setProgressHandler(handlers.getProgress());
            this.urlConnection.setErrorHandler(handlers.getError());
        };

        this._createBasicQuery = function(filterCollection) {
            var query = {};
            query[this.constants.URL_PARAM_LIMIT] = this.limit;
            query[this.constants.URL_PARAM_OFFSET] = this.offset;

            var organisationFilter = filterCollection.getFilterByClass(FilterOrganisation);
            if (organisationFilter) {
                query[this.constants.URL_PARAM_ORGANISATION_PK] = organisationFilter.getOrganisationPK();
            }

            var queryFilter = filterCollection.getFilterByClass(FilterQuery);
            if (queryFilter) {
                query[this.constants.URL_PARAM_SEARCH] = queryFilter.getQuery();
            }

            return query;
        };
    };

    Collection.prototype.setLimit = function (limit) {
        this.limit = limit;
    };

    Collection.prototype.setOffset = function (offset) {
        this.offset = offset;
    };

    Collection.prototype.fetch = function (handlers, filterCollection) {
        this._configureConnection(handlers, filterCollection);
        return this.urlConnection.get();
    };

    return Collection;
});
},
'api/branch-office/filter/Organisation':function(){
define([], function() {
    var Organisation = function(organisationPK) {
        this.organisationPK = organisationPK;
    };

    Organisation.prototype.getOrganisationPK = function() {
        return this.organisationPK;
    };

    return Organisation;
});
},
'api/branch-office/filter/Query':function(){
define([], function() {
    var Query = function(query) {
        this.query = query;
    };

    Query.prototype.getQuery = function() {
        return this.query;
    };

    return Query;
});
},
'api/branch-office/Email':function(){
define([], function() {
    var Email = function(url, urlConnection) {
        this.contactCategoryPKs = [];
        this.url = url;
        this.urlConnection = urlConnection;

        this._branchOfficeEmailToData = function(branchOfficeEmailVO) {
            var r = {
                'branchOfficePK': branchOfficeEmailVO.getBranchOfficePK(),
                'email': branchOfficeEmailVO.getEmail()
            };

            if (this.contactCategoryPKs.length) {
                r['contactCategoryPK'] = this.contactCategoryPKs;
            }

            return r;
        };
    };

    Email.prototype.linkContactCategory = function(contactCategoryPK) {
        this.contactCategoryPKs.push(contactCategoryPK);
        return this;
    };

    Email.prototype.add = function(handlers, branchOfficeEmailVO) {
        this.urlConnection.setSuccessHandler(handlers.getSuccess());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());
        this.urlConnection.setUrl(this.url);
        this.urlConnection.setData(this._branchOfficeEmailToData(branchOfficeEmailVO));

        return this.urlConnection.post();
    };

    return Email;
});
},
'api/branch-office/EmailCollection':function(){
define([
    './filter/BranchOffice'
], function(FilterBranchOffice) {
    const URL_PARAM_BRANCH_OFFICE_PK = 'branchOfficePK';
    const URL_PARAM_LIMIT = 'limit';
    const DEFAULT_LIMIT = 10;
    const Email = function(url, urlConnection, collectionParser, urlResponseProcessorBuilder) {
        this.urlConnection = urlConnection;
        this.parser = collectionParser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;

        this.urlConnection.setUrl(url);
        this.limit = DEFAULT_LIMIT;

        this._createBasicQuery = function(filterCollection) {
            const query = {};
            query[URL_PARAM_LIMIT] = this.limit;

            const branchOfficeFilter = filterCollection.getFilterByClass(FilterBranchOffice);
            if (branchOfficeFilter) {
                query[URL_PARAM_BRANCH_OFFICE_PK] = branchOfficeFilter.getBranchOfficePK();
            }

            return query;
        };
    };

    Email.prototype.setLimit = function(limit) {
        this.limit = limit;
    };

    Email.prototype.fetch = function(handlers, filterCollection) {
        this.urlConnection.setQuery(this._createBasicQuery(filterCollection));
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return Email;
});
},
'api/branch-office/filter/BranchOffice':function(){
define([], function() {
    const BranchOffice = function(branchOfficePK) {
        this.branchOfficePK = branchOfficePK;
    };

    BranchOffice.prototype.getBranchOfficePK = function() {
        return this.branchOfficePK;
    };

    return BranchOffice;
});
},
'api/branch-office/ManagerFactory':function(){
define(['./Manager'], function(Manager) {
    var ManagerFactory = function(url, urlConnectionBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
    };

    ManagerFactory.prototype.get = function(organisationPK) {
        return new Manager(
            this.url,
            this.urlConnectionBuilder.build(),
            organisationPK
        );
    };

    return ManagerFactory;
});
},
'api/branch-office/Manager':function(){
define([], function() {
    var Manager = function(url, urlConnection, organisationPK) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.organisationPK = organisationPK;

        this._branchOfficeToData = function(branchOfficeVO) {
            var a = branchOfficeVO.getAddress();

            return {
                'address1': a.getAddress1(),
                'address2': a.getAddress2(),
                'address3': a.getAddress3(),
                'countryPK': a.getCountryPK(),
                'countyPK': a.getCountyPK(),
                'isHeadOffice': branchOfficeVO.isHeadOffice(),
                'name': branchOfficeVO.getName(),
                'organisationPK': this.organisationPK,
                'postCode': a.getPostCode(),
                'telephone': branchOfficeVO.getTelephone(),
                'town': a.getTown()
            };
        };
    };

    Manager.prototype.add = function(handlers, branchOfficeVO) {
        this.urlConnection.setSuccessHandler(handlers.getSuccess());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());
        this.urlConnection.setUrl(this.url);
        this.urlConnection.setData(this._branchOfficeToData(branchOfficeVO));

        return this.urlConnection.post();
    };

    return Manager;
});
},
'@lib/api/branch-office/email/Collection':function(){
define(["require", "exports", "@lib/request/data/HTTPResponseCodes", "@lib/request/data/ErrorResponse"], function (require, exports, HTTPResponseCodes, ErrorResponse_1) {
    "use strict";
    class Collection {
        constructor(url, fetchFactory, parser) {
            this.url = url;
            this.fetchFactory = fetchFactory;
            this.parser = parser;
            this.active = false;
            this.limit = 10;
            this.offset = 0;
            this.processor = fetchFactory.get();
        }
        setOrganisationPK(organisationPK) {
            this.organisationPK = organisationPK;
            return this;
        }
        isActive() {
            this.active = true;
            return this;
        }
        setQuery(query) {
            this.query = query;
            return this;
        }
        setLimit(limit) {
            this.limit = limit;
            return this;
        }
        setOffset(offset) {
            this.offset = offset;
            return this;
        }
        async fetch() {
            this.processor.setSuccessHandler(async (response) => {
                const data = await response.json();
                return this.parser.parse(data);
            });
            this.processor.setHandler(HTTPResponseCodes.not_found, () => {
                throw new ErrorResponse_1.NotFoundResponse();
            });
            const searchParams = new URLSearchParams();
            if (this.organisationPK) {
                searchParams.set('organisationPK', this.organisationPK.toString());
            }
            if (this.active) {
                searchParams.set('isActive', '1');
            }
            if (this.query) {
                searchParams.set('query', this.query);
            }
            searchParams.set('offset', this.offset.toString());
            searchParams.set('limit', this.limit.toString());
            return await this.processor.get(this.url.concat('?'.concat(searchParams.toString())));
        }
    }
    return Collection;
});

},
'@lib/request/data/ErrorResponse':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ForbiddenResponse = exports.MethodNotAllowedResponse = exports.NotFoundResponse = exports.ErrorResponse = void 0;
    class ErrorResponse extends Error {
    }
    exports.ErrorResponse = ErrorResponse;
    class NotFoundResponse extends Error {
    }
    exports.NotFoundResponse = NotFoundResponse;
    class MethodNotAllowedResponse extends Error {
    }
    exports.MethodNotAllowedResponse = MethodNotAllowedResponse;
    class ForbiddenResponse extends Error {
    }
    exports.ForbiddenResponse = ForbiddenResponse;
});

},
'@lib/api/branch-office/email/parser/Collection':function(){
define(["require", "exports", "./Email"], function (require, exports, EmailParser) {
    "use strict";
    class Collection {
        parse(items) {
            return items.map(i => EmailParser.parse(i));
        }
    }
    return Collection;
});

},
'@lib/api/branch-office/email/parser/Email':function(){
define(["require", "exports", "@lib/api/branch-office/email/data/Email"], function (require, exports, Email_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.parse = parse;
    function parse(i) {
        return new Email_1.Email(i.branchOfficeEmailPK, i.branchOfficePK, i.email, i.isActive);
    }
});

},
'@lib/api/branch-office/email/data/Email':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Email = void 0;
    class Email {
        constructor(branchOfficeEmailPK, branchOfficePK, email, active) {
            this.branchOfficeEmailPK = branchOfficeEmailPK;
            this.branchOfficePK = branchOfficePK;
            this.email = email;
            this.active = active;
        }
        getBranchOfficeEmailPK() {
            return this.branchOfficeEmailPK;
        }
        getBranchOfficePK() {
            return this.branchOfficePK;
        }
        getEmail() {
            return this.email;
        }
        isActive() {
            return this.active;
        }
    }
    exports.Email = Email;
});

},
'api/calendar/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    const Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_calendar_event = 'calendar/event/';
        this.api_calendar_event_invitation = 'calendar/event-invitation';
        this.api_calendar_event_resend_invitation = 'calendar/resend-invitation';
        this.api_calendar_event_response = 'calendar/event/:eventUID/response';
        this.api_calendar_event_invalid = 'calendar/event/invalid/';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});
},
'api/calendar/Factory':function(){
define([
    '../parser/application/JSON',
    './event/parser/Invalid',
    './event/parser/Response',
    './event/Invalid',
    './event/Response',
    './Event',
    './EventInvitation',
    './ResendInvitation'
], function(
    ApplicationJSONParser,
    EventInvalidParser,
    EventResponseParser,
    Invalid,
    EventResponse,
    Event,
    MeetingRequest,
    ResendInvitation
) {
    const Factory = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Factory.prototype.getEvent = function() {
        return new Event(
            this.config.getUrl('api_calendar_event'),
            this.urlConnectionBuilder.build(),
            this.urlResponseProcessorBuilder
        )
    };

    Factory.prototype.getEventInvitation = function() {
        return new MeetingRequest(
            this.config.getUrl('api_calendar_event_invitation'),
            this.urlConnectionBuilder.build(),
            this.urlResponseProcessorBuilder
        )
    };

    Factory.prototype.getResendInvitation = function() {
        return new ResendInvitation(
            this.config.getUrl('api_calendar_event_resend_invitation'),
            this.urlConnectionBuilder.build(),
            this.urlResponseProcessorBuilder
        )
    };

    Factory.prototype.getEventResponse = function() {
        return new EventResponse(
            this.config.getUrl('api_calendar_event_response', 'v2/'),
            this.urlConnectionBuilder.build(),
            this.urlResponseProcessorBuilder,
            new ApplicationJSONParser(new EventResponseParser())
        )
    };

    Factory.prototype.getEventInvalid = function() {
        return new Invalid(
            this.config.getUrl('api_calendar_event_invalid'),
            this.urlConnectionBuilder.build(),
            this.urlResponseProcessorBuilder
        )
    };

    return Factory;
});

},
'api/calendar/event/parser/Invalid':function(){
define([
    '../data/Event'
], function (Event) {
    const Response = function() {};

    Response.prototype.parse = function(data) {
        return new Event(
            data.eventUID || null
        );
    };

    return Response;
});
},
'api/calendar/event/data/Event':function(){
define([], function () {
    const Event = function(eventUID) {
        this.UID = eventUID;
    };

    Event.prototype.getUid = function() {
        return this.UID;
    };

    return Event;
});
},
'api/calendar/event/parser/Response':function(){
define([
    '../data/Response'
], function (ResponseData) {
    const Response = function() {};

    Response.prototype.parse = function(data) {
        return new ResponseData(
            data.eventUID || null,
            data.hasResponded || false,
            data.hasAccepted || false,
            data.isTentative || false,
            data.hasDeclined || false
        );
    };

    return Response;
});
},
'api/calendar/event/data/Response':function(){
define([], function () {
    const Response = function(eventUID, hasResponded, hasAccepted, isTentative, hasDeclined) {
        this.eventUID = eventUID;
        this.hasRespondedAttr = hasResponded;
        this.hasAcceptedAttr = hasAccepted;
        this.isTentativeAttr = isTentative;
        this.hasDeclinedAttr = hasDeclined;
    };

    Response.prototype.getEventUID = function() {
        return this.eventUID;
    };

    Response.prototype.hasResponded = function() {
        return this.hasRespondedAttr;
    };

    Response.prototype.hasAccepted = function() {
        return this.hasAcceptedAttr;
    };

    Response.prototype.isTentative = function() {
        return this.isTentativeAttr;
    };

    Response.prototype.hasDeclined = function() {
        return this.hasDeclinedAttr;
    };

    return Response;
});
},
'api/calendar/event/Invalid':function(){
define([], function() {
    var Invalid = function(url, urlConnection, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;

        this._createData = function(context) {
            for (const key in context) {
                if(context.hasOwnProperty(key)) {
                    if(context[key] === null) {
                        delete context[key];
                    }
                }
            }

            return context;
        }
    };

    Invalid.prototype.post = function(handlers, context) {
        this.urlConnection.setUrl(this.url);
        this.urlConnection.setData(this._createData(context));
        this.urlConnection.setSuccessHandler(handlers.getSuccess());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.post();
    };

    return Invalid;
});
},
'api/calendar/event/Response':function(){
define([], function () {
    const Response = function(url, urlConnection, urlResponseProcessorBuilder, parser) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    Response.prototype.get = function(handlers, eventUID, eventData) {
        this.urlConnection.setUrl(this.url.replace(':eventUID', eventUID));
        this.urlConnection.setData({eventData});
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.post();
    };

    return Response;
});
},
'api/calendar/Event':function(){
define([
    './EventParameterGenerator'
], function (
    EventParameterGenerator
) {
    var Event = function(url, urlConnection) {
        this.url = url;
        this.urlConnection = urlConnection;

        var eventParameterGenerator = new EventParameterGenerator();

        this.generateDataFromVO = function(eventVO) {
            return eventParameterGenerator.generate(eventVO);
        };
    };

    Event.prototype.add = function(handlers, eventVO) {
        this.urlConnection.setUrl(this.url);
        this.urlConnection.setData(this.generateDataFromVO(eventVO));
        this.urlConnection.setSuccessHandler(handlers.getSuccess());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.post();
    };

    return Event;
});
},
'api/calendar/EventParameterGenerator':function(){
define([
    'spencer/date-time/Format'
], function (
    DateTimeFormat
) {
    var EventParameterGenerator = function () {
        this.dateTimeFormat = new DateTimeFormat();
    };

    EventParameterGenerator.prototype.generate = function(eventVO) {
        var data = {
            uid: eventVO.getUid(),
            startDate: eventVO.getStartDate(),
            endDate: eventVO.getEndDate(),
            summary: eventVO.getSummary(),
            description: eventVO.getDescription(),
            location: eventVO.getLocation(),
            category: JSON.stringify({
                name: eventVO.getCategory() ? eventVO.getCategory().getName() : null
            }),
            organiser: JSON.stringify({
                email: eventVO.getOrganiser().getEmail()
            }),
            attendees: []
        };

        for (const i in eventVO.getAttendees()) {
            const attendee = eventVO.getAttendees()[i];
            const attendeeData = {
                email: attendee.getEmail()
            };

            if (attendee.getName()) {
                attendeeData.name = attendee.getName();
            }

            if (attendee.getRSVP()) {
                attendeeData.rsvp = attendee.getRSVP();
            }

            if (attendee.getStatus()) {
                attendeeData.status = attendee.getStatus();
            }

            data.attendees.push(JSON.stringify(attendeeData));
        }

        return data;
    };

    return EventParameterGenerator;
});

},
'api/calendar/EventInvitation':function(){
define([
    './EventParameterGenerator'
], function(
    EventParameterGenerator
) {
    var EventInvitation = function(url, urlConnection, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;

        var eventParameterGenerator = new EventParameterGenerator();

        this._generateData = function(responseVO, eventVO) {
            if (responseVO.getOriginalCalendarString()) {
                return {
                    to: responseVO.getToAddress(),
                    from: responseVO.getFromAddress(),
                    originalCalendarString: responseVO.getOriginalCalendarString(),
                    data: responseVO.getData(),
                    status: responseVO.getStatus(),
                    event: JSON.stringify(eventParameterGenerator.generate(eventVO))
                };
            } else {
                return {
                    to: responseVO.getToAddress(),
                    from: responseVO.getFromAddress(),
                    data: responseVO.getData(),
                    status: responseVO.getStatus(),
                    event: JSON.stringify(eventParameterGenerator.generate(eventVO))
                };
            }
        };
    };

    EventInvitation.prototype.respond = function(handlers, responseVO, eventVO) {
        this.urlConnection.setUrl(this.url);
        this.urlConnection.setData(this._generateData(responseVO, eventVO));
        this.urlConnection.setSuccessHandler(handlers.getSuccess());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.post();
    };

    return EventInvitation;
});

},
'api/calendar/ResendInvitation':function(){
define([
], function() {
    var ResendInvitation = function(url, urlConnection, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;

        this._generateData = function(uid, attendee) {
            return {
                attendee: attendee,
                uid: uid
            };
        };
    };

    ResendInvitation.prototype.resend = function(handlers, uid, attendee) {
        this.urlConnection.setUrl(this.url);
        this.urlConnection.setData(this._generateData(uid, attendee));
        this.urlConnection.setSuccessHandler(handlers.getSuccess());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.post();
    };

    return ResendInvitation;
});

},
'api/contact/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    const Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_contact = 'contacts/';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});
},
'api/contact/Factory':function(){
define([
    "../parser/Collection",
    "./Contact",
    "./ContactCollection",
    "./parser/Contact"
], function(
    Collection, Contact, ContactCollection, ContactParser
) {
    var Factory = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Factory.prototype.getContactCollection = function() {
        return new ContactCollection(
            this.config.getUrl("api_contact"),
            this.urlConnectionBuilder.build(),
            new Collection(new ContactParser()),
            this.urlResponseProcessorBuilder
        )
    };

    Factory.prototype.getContact = function() {
        var c = new Collection(new ContactParser());
        c.setIsSingleItemCollection(true);

        return new Contact(
            this.config.getUrl("api_contact"),
            this.urlConnectionBuilder.build(),
            c,
            this.urlResponseProcessorBuilder
        )
    };

    return Factory;
});

},
'api/contact/Contact':function(){
define([], function() {
    var Contact = function(URL, URLConnection, parser, URLResponseProcessorBuilder) {
        this.url = URL;
        this.URLConnection = URLConnection;
        this.URLResponseProcessorBuilder = URLResponseProcessorBuilder;
        this.parser = parser;

        this._getRequest = function(handlers, id) {
            this.URLConnection.setSuccessHandler(
                this.URLResponseProcessorBuilder.createProcessor(
                    this.parser,
                    handlers.getSuccess(),
                    handlers.getError()
                )
            );

            this.URLConnection.setUnauthorisedHandler(handlers.getUnauthorised());
            this.URLConnection.setProgressHandler(handlers.getProgress());
            this.URLConnection.setErrorHandler(handlers.getError());

            this.URLConnection.setUrl(this.url + id);

            return this.URLConnection.get();
        };
    };

    Contact.prototype.get = function(handlers, contactVO) {
        return this._getRequest(handlers, contactVO.getContactPK());
    };

    Contact.prototype.getByEmail = function(handlers, contactVO) {
        return this._getRequest(handlers, encodeURIComponent(contactVO.getEmail()));
    };

    return Contact;
});
},
'api/contact/ContactCollection':function(){
define([
    'spencer/contact/config/ContactTypes'
], function(
    CONTACT_TYPES
) {
    const URL_PARAM_QUERY = 'search';
    const URL_PARAM_ORGANISATION_PK = 'organisationPK';
    const URL_PARAM_BRANCH_OFFICE_PK = 'branchOfficePK';
    const URL_PARAM_CONTACT_CATEGORY_PK = 'contactCategoryPK';
    const URL_PARAM_LIMIT = 'limit';
    const URL_PARAM_OFFSET = 'offset';
    const URL_PARAM_IS_PERSON = 'isPerson';
    const URL_PARAM_IS_BRANCH_OFFICE = 'isBranchOffice';
    const URL_PARAM_PERSON_WITH_EMAIL = 'filterPeopleWithEmail';

    const ContactCollection = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this.limit = 10;
        this.offset = 0;
        this.query = null;
        this.organisationPK = null;
        this.branchOfficePK = null;
        this.contactCategoryPK = null;
        this.type = null;
        this.filterPeopleWithEmail = false;

        this.createBasicQuery = function() {
            let q = {};

            q[URL_PARAM_LIMIT] = this.limit;
            q[URL_PARAM_OFFSET] = this.offset;

            if (this.query && this.query !== '') {
                q[URL_PARAM_QUERY] = this.query;
            }

            if (this.organisationPK) {
                q[URL_PARAM_ORGANISATION_PK] = this.organisationPK;
            }

            if (this.branchOfficePK) {
                q[URL_PARAM_BRANCH_OFFICE_PK] = this.branchOfficePK;
            }

            if (this.filterPeopleWithEmail) {
                q[URL_PARAM_PERSON_WITH_EMAIL] = this.filterPeopleWithEmail;
            }

            if (this.contactCategoryPK) {
                q[URL_PARAM_CONTACT_CATEGORY_PK] = this.contactCategoryPK;
            }

            switch (this.type) {
                case CONTACT_TYPES.PERSON:
                    q[URL_PARAM_IS_PERSON] = 1;
                    break;
                case CONTACT_TYPES.BRANCH_OFFICE:
                    q[URL_PARAM_IS_BRANCH_OFFICE] = 1;
                    break;
            }

            return q;
        };

        this.urlConnection.setUrl(this.url);
    };

    ContactCollection.prototype.setLimit = function(limit) {
        this.limit = limit;
        return this;
    };

    ContactCollection.prototype.setOffset = function(offset) {
        this.offset = offset;
        return this;
    };

    ContactCollection.prototype.setQuery = function(query) {
        this.query = query;
        return this;
    };

    ContactCollection.prototype.setOrganisationPK = function(organisationPK) {
        this.organisationPK = organisationPK;
        return this;
    };

    ContactCollection.prototype.setBranchOfficePK = function(branchOfficePK) {
        this.branchOfficePK = branchOfficePK;
        return this;
    };

    ContactCollection.prototype.setContactCategoryPK = function(contactCategoryPK) {
        this.contactCategoryPK = contactCategoryPK;
        return this;
    };

    ContactCollection.prototype.setType = function(type) {
        this.type = type;
        return this;
    };

    ContactCollection.prototype.setFilterPeopleWIthEmail = function(filterPeopleWithEmail) {
        this.filterPeopleWithEmail = filterPeopleWithEmail;
        return this;
    };

    ContactCollection.prototype.fetch = function(handlers) {
        this.urlConnection.setQuery(this.createBasicQuery());
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return ContactCollection;
});
},
'spencer/contact/config/ContactTypes':function(){
define([], function() {
    return {
        PERSON: 'person',
        BRANCH_OFFICE: 'branch_office'
    };
});
},
'api/contact-category/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    var Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_contact_category = 'contact-category/';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});
},
'api/contact-category/Factory':function(){
define([
    'api/parser/Collection',
    './parser/ContactCategory',
    './Collection'
], function(
    CollectionParser,
    ContactCategoryParser,
    Collection
) {
    var Factory = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Factory.prototype.getCollection = function() {
        return new Collection(
            this.config.getUrl('api_contact_category'),
            this.urlConnectionBuilder.build(),
            new CollectionParser(new ContactCategoryParser()),
            this.urlResponseProcessorBuilder
        );
    };

    return Factory;
});

},
'api/contact-category/parser/ContactCategory':function(){
define([
    'api/contact-category/data/ContactCategory'
], function (ContactCategoryData) {
    var ContactCategory = function () {};

    ContactCategory.prototype.parse = function(item) {
        if (item === undefined) {
            return new ContactCategoryData();
        }

        return (new ContactCategoryData())
            .setContactCategoryPK(item.contactCategoryPK || null)
            .setName(item.name || null);
    };

    return ContactCategory;
});
},
'api/contact-category/data/ContactCategory':function(){
define([], function() {
    var ContactCategory = function() {
        this.contactCategoryPK = null;
        this.name = null;
    };

    ContactCategory.prototype.getContactCategoryPK = function() {
        return this.contactCategoryPK;
    };

    ContactCategory.prototype.setContactCategoryPK = function(contactCategoryPK) {
        this.contactCategoryPK = contactCategoryPK;
        return this;
    };

    ContactCategory.prototype.getName = function() {
        return this.name;
    };

    ContactCategory.prototype.setName = function(name) {
        this.name = name;
        return this;
    };

    return ContactCategory;
});

},
'api/contact-category/Collection':function(){
define([], function () {
    var Collection = function (url, urlConnection, collectionParser, urlResponseProcessorBuilder) {
        this.urlConnection = urlConnection;
        this.parser = collectionParser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;

        this.urlConnection.setUrl(url);
    };

    Collection.prototype.fetch = function (handlers) {
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return Collection;
});
},
'api/doccontrol/document/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    const Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_doc_control_document_basket = 'doc-control/document/basket';
        this.api_doc_control_document_basket_collaborator = 'doc-control/document/basket/:basketPK/collaborator';
        this.api_doc_control_document_basket_revision_collection = 'doc-control/document/basket/:basketPK/revision';
        this.api_doc_control_document_location = 'doc-control/document/:id/location';
        this.api_doc_control_document_location_from = 'doc-control/document/location/from';
        this.api_doc_control_document_location_to = 'doc-control/document/location/to';
        this.api_doc_control_document_merge = 'doc-control/document/:id/merge';
        this.api_doc_control_document_soft_link = 'doc-control/document/:id/soft-link';
        this.api_doc_control_document_revision = 'doc-control/document/:id/revision';
        this.api_doc_control_document_reference_checker = "doc-control/document/reference/checker";
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});

},
'api/doccontrol/document/Factory':function(){
define([
    '../parser/RevisionCollection',
    'api/doccontrol/document/FromCollection',
    'api/doccontrol/document/Location',
    'api/doccontrol/document/ReferenceChecker',
    'api/doccontrol/document/Reviser',
    'api/doccontrol/document/SoftLink',
    'api/doccontrol/document/TemporaryDocumentCreator',
    'api/doccontrol/document/To',
    'library/request/fetch/Factory',
    'spencer/doc-control/parser/DocumentsRequiringReferenceChange',
    'spencer/doc-control/parser/FromCollection',
    'spencer/parse/JSONParser',
    '@lib/api/doc-control/document/Basket',
    '@lib/api/doc-control/document/basket/Collaborator',
    '@lib/api/doc-control/document/basket/Collection',
    '@lib/api/doc-control/document/basket/RevisionCollection',
    '@lib/api/doc-control/document/Merger',
    '@lib/api/doc-control/document/parser/Basket',
    '@lib/api/doc-control/document/parser/BasketCollection',
    '@lib/request/FormDataWrapper',
    '@lib/request/parser/Options'
], function(
    RevisionCollectionParser,
    FromCollection,
    Location,
    ReferenceChecker,
    Reviser,
    SoftLink,
    TemporaryDocumentCreator,
    To,
    FetchFactory,
    DocumentsRequiringReferenceChangeParser,
    FromCollectionParser,
    JSONParser,
    Basket,
    BasketCollaborator,
    BasketCollection,
    BasketRevisionCollection,
    Merger,
    BasketParser,
    BasketCollectionParser,
    FormDataWrapper,
    OptionsParser
) {
    const Factory = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Factory.prototype.getBasket = function() {
        return new Basket(
            this.config.getUrl('api_doc_control_document_basket', 'v2/'),
            new FetchFactory(),
            new BasketParser(),
            new FormDataWrapper()
        );
    };

    Factory.prototype.getBasketCollaborator = function() {
        return new BasketCollaborator(
            this.config.getUrl('api_doc_control_document_basket_collaborator', 'v2/'),
            new FetchFactory()
        );
    };

    Factory.prototype.getBasketCollection = function() {
        return new BasketCollection(
            this.config.getUrl('api_doc_control_document_basket', 'v2/'),
            new FetchFactory(),
            new BasketCollectionParser()
        );
    };

    Factory.prototype.getBasketRevisionCollection = function() {
        return new BasketRevisionCollection(
            this.config.getUrl('api_doc_control_document_basket_revision_collection', 'v2/'),
            new FetchFactory(),
            new RevisionCollectionParser()
        );
    };

    Factory.prototype.getFromCollection = function() {
        return new FromCollection(
            this.config.getUrl('api_doc_control_document_location_from', 'v2/'),
            this.urlConnectionBuilder.build(),
            new JSONParser(new FromCollectionParser),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getLocation = function() {
        return new Location(
            this.config.getUrl('api_doc_control_document_location', 'v2/'),
            this.urlConnectionBuilder.build(),
            new OptionsParser()
        );
    };

    Factory.prototype.getMerger = function() {
        return new Merger(
            this.config.getUrl('api_doc_control_document_merge', 'v2/'),
            new FetchFactory(),
            new OptionsParser()
        );
    };

    Factory.prototype.getReviser = function() {
        return new Reviser(
            this.config.getUrl('api_doc_control_document_revision', 'v2/'),
            this.urlConnectionBuilder,
            new OptionsParser()
        );
    };

    Factory.prototype.getSoftLink = function() {
        return new SoftLink(
            this.config.getUrl('api_doc_control_document_soft_link', 'v2/'),
            this.urlConnectionBuilder.build()
        );
    };

    Factory.prototype.getTemporaryDocumentCreator = function() {
        return new TemporaryDocumentCreator(
            this.config.getUrl('api_doc_control_document'),
            this.urlConnectionBuilder.build()
        );
    };

    Factory.prototype.getTo = function() {
        return new To(
            this.config.getUrl('api_doc_control_document_location_to', 'v2/'),
            this.urlConnectionBuilder.build()
        );
    };

    Factory.prototype.getReferenceChecker = function () {
        return new ReferenceChecker(
            this.config.getUrl('api_doc_control_document_reference_checker', 'v2/'),
            this.urlConnectionBuilder.build(),
            new JSONParser(new DocumentsRequiringReferenceChangeParser),
            this.urlResponseProcessorBuilder
        );
    };

    return Factory;
});

},
'api/doccontrol/document/FromCollection':function(){
define([], function() {
    const FromCollection = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    FromCollection.prototype.canMove = function(handlers, documentPKs) {
        this.urlConnection.setUrl(this.url);
        this.urlConnection.setQuery({'documents': documentPKs.join(',')});
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return FromCollection;
});
},
'api/doccontrol/document/Location':function(){
define([], function() {
    const Location = function(url, urlConnection, optionsParser) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.optionsParser = optionsParser;
    };

    Location.prototype.canMove = function(handlers, documentID) {
        this.urlConnection.setUrl(this.url.replace(':id', documentID));

        this.urlConnection.setSuccessHandler(
            function(data) {
                const options = this.optionsParser.parse(data);
                handlers.getSuccess()(options.indexOf('PATCH') !== -1);
            }.bind(this)
        );

        this.urlConnection.setErrorHandler(handlers.getError());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setConflictHandler(handlers.getConflict());

        return this.urlConnection.options();
    };

    Location.prototype.move = function(handlers, documentID, projectStagePK, projectStageTreeViewPK, validateOnly, form) {
        this.urlConnection.setUrl(this.url.replace(':id', documentID));

        form.projectStagePK = projectStagePK;
        form.projectStageTreeViewPK = projectStageTreeViewPK;
        form.validateOnly = validateOnly;

        this.urlConnection.setQuery(form);

        this.urlConnection.setSuccessHandler(handlers.getSuccess());
        this.urlConnection.setErrorHandler(handlers.getError());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setConflictHandler(handlers.getConflict());

        return this.urlConnection.patch();
    };

    return Location;
});
},
'api/doccontrol/document/ReferenceChecker':function(){
define([], function () {
    const ReferenceChecker = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.parser = parser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    ReferenceChecker.prototype.requireChangeForDestination = function(handlers, references, projectStagePK, projectStageTreeViewPK) {
        this.urlConnection.setUrl(this.url);

        this.urlConnection.setData({
            'references': JSON.stringify(references),
            'projectStagePK': projectStagePK,
            'projectStageTreeViewPK': projectStageTreeViewPK
        });

        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setErrorHandler(handlers.getError());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());

        return this.urlConnection.post();
    };

    return ReferenceChecker;
});
},
'api/doccontrol/document/Reviser':function(){
define([], function() {
    const Reviser = function(url, urlConnectionBuilder, optionsParser) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.optionsParser = optionsParser;
    };

    Reviser.prototype.revise = function(
        handlers,
        documentPK,
        data,
        form
    ) {
        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(
            this.url.replace(':id', documentPK)
        );

        urlConnection.setQuery(data);
        if (form) urlConnection.setForm(form);
        urlConnection.setSuccessHandler(handlers.getSuccess());
        urlConnection.setErrorHandler(handlers.getError());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());

        return urlConnection.post();
    };

    Reviser.prototype.canRevise = function(handlers, documentPK) {
        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(
            this.url.replace(':id', documentPK)
        );

        urlConnection.setSuccessHandler(function(options) {
            options = this.optionsParser.parse(options);
            handlers.getSuccess()(options.indexOf('POST') !== -1);
        }.bind(this));

        urlConnection.setErrorHandler(handlers.getError());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());

        return urlConnection.options();
    };

    return Reviser;
});
},
'api/doccontrol/document/SoftLink':function(){
define([], function() {
    const SoftLink = function(url, urlConnection) {
        this.url = url;
        this.urlConnection = urlConnection;
    };

    SoftLink.prototype.create = function(
        handlers,
        documentPK,
        projectStagePK,
        treeViewPK,
        dryRun,
        form
    ) {
        this.urlConnection.setUrl(
            this.url.replace(':id', documentPK)
        );

        form.projectStagePK = projectStagePK;
        form.projectStageTreeViewPK = treeViewPK;
        form.dryRun = dryRun;

        this.urlConnection.setQuery(form);

        this.urlConnection.setSuccessHandler(handlers.getSuccess());
        this.urlConnection.setErrorHandler(handlers.getError());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());

        return this.urlConnection.post();
    };

    return SoftLink;
});
},
'api/doccontrol/document/TemporaryDocumentCreator':function(){
define([], function () {
    const TemporaryDocumentCreator = function(url, urlConnection) {
        this.url = url;
        this.urlConnection = urlConnection;
    };

    TemporaryDocumentCreator.prototype.create = function(handlers, fileKeys) {
        this.urlConnection.setUrl(this.url);

        this.urlConnection.setData({
            'fileKeys': fileKeys
        });

        this.urlConnection.setSuccessHandler(handlers.getSuccess());
        this.urlConnection.setErrorHandler(handlers.getError());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());

        return this.urlConnection.post();
    };

    return TemporaryDocumentCreator;
});
},
'api/doccontrol/document/To':function(){
define([], function () {
    const To = function(url, urlConnection) {
        this.url = url;
        this.urlConnection = urlConnection;

        this._prepareDocuments = function (documents) {
            let data = [];
            for (let i in documents) {
                data.push(JSON.stringify(documents[i]));
            }
            return data;
        }
    };

    To.prototype.canMove = function(handlers, documentPKs, projectStagePK, projectStageTreeViewPK) {
        this.urlConnection.setUrl(this.url);

        this.urlConnection.setQuery({
            'documents': documentPKs.join(','),
            'projectStagePK': projectStagePK,
            'projectStageTreeViewPK': projectStageTreeViewPK
        });

        this.urlConnection.setSuccessHandler(handlers.getSuccess());
        this.urlConnection.setErrorHandler(handlers.getError());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());

        return this.urlConnection.get();
    };

    To.prototype.move = function(handlers, documents) {
        this.urlConnection.setUrl(this.url);

        this.urlConnection.setData({documents: this._prepareDocuments(documents)});

        this.urlConnection.setSuccessHandler(handlers.getSuccess());
        this.urlConnection.setErrorHandler(handlers.getError());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());

        return this.urlConnection.post();
    };

    return To;
});
},
'spencer/doc-control/parser/DocumentsRequiringReferenceChange':function(){
define([], function() {
    const DocumentsRequiringReferenceChange = function() {};

    DocumentsRequiringReferenceChange.prototype.parse = function(documents) {
        return documents['documents'];
    };

    return DocumentsRequiringReferenceChange;
});
},
'spencer/doc-control/parser/FromCollection':function(){
define([
    'spencer/doc-control/parser/From',
    'spencer/doc-control/data/FromCollection'
], function(
    FromParser,
    FromCollectionVO
) {
    const FromCollection = function() {
        this.fromParser = new FromParser;
    };

    FromCollection.prototype.parse = function(collection) {
        let fromCollection = new FromCollectionVO();

        collection.forEach(function(moveable){
            fromCollection.setFrom(this.fromParser.parse(moveable));
        }.bind(this));

        return fromCollection;
    };

    return FromCollection;
});
},
'spencer/doc-control/parser/From':function(){
define([
    'spencer/doc-control/data/From'
], function(
    FromVO
) {
    const From = function() {};

    From.prototype.parse = function(from) {
        return new FromVO()
            .setDocumentPK(parseInt(from.documentPK) || null)
            .setMoveable(Boolean(from.moveable))
            .setReason(from.reason || null)
    };

    return From;
});
},
'spencer/doc-control/data/From':function(){
define([], function() {
    const From = function() {
        this.document = null;
        this.moveable = false;
        this.reason = null;
    };

    From.prototype.setDocumentPK = function(document) {
        this.document = document;
        return this;
    };

    From.prototype.getDocumentPK = function() {
        return this.document;
    };

    From.prototype.setMoveable = function(moveable) {
        this.moveable = moveable;
        return this;
    };

    From.prototype.isMoveable = function() {
        return this.moveable;
    };

    From.prototype.setReason = function(reason) {
        this.reason = reason;
        return this;
    };

    From.prototype.getReason = function() {
        return this.reason;
    };

    return From;
});
},
'spencer/doc-control/data/FromCollection':function(){
define([], function() {
    const FromCollection = function() {
        this.from = [];
    };

    FromCollection.prototype.setFrom = function(from) {
        this.from.push(from);
        return this;
    };

    FromCollection.prototype.getFrom = function() {
        return this.from;
    };

    return FromCollection;
});
},
'@lib/api/doc-control/document/Basket':function(){
define(["require", "exports", "@lib/request/data/HTTPResponseCodes"], function (require, exports, HTTPResponseCodes) {
    "use strict";
    class Basket {
        constructor(url, fetchFactory, parser, formData) {
            this.url = url;
            this.fetchFactory = fetchFactory;
            this.parser = parser;
            this.formData = formData;
            this.fetchWrapper = fetchFactory.get();
        }
        save(basket, handlers) {
            this.fetchWrapper.setSuccessHandler(async (response) => {
                handlers.getSuccess()(this.parser.parse(await response.json()));
            });
            this.fetchWrapper.setErrorHandler(handlers.getError());
            this.formData.reset();
            this.formData.append('name', basket.getName());
            return this.fetchWrapper.post(this.url, {
                body: this.formData.get()
            });
        }
        update(basket, handlers) {
            this.fetchWrapper.setSuccessHandler(handlers.getSuccess());
            this.fetchWrapper.setErrorHandler(handlers.getError());
            return this.fetchWrapper.put(`${this.url}/${basket.getId()}`, {
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ name: basket.getName() })
            });
        }
        delete(basket, handlers) {
            this.fetchWrapper.setSuccessHandler(handlers.getSuccess());
            this.fetchWrapper.setErrorHandler(handlers.getError());
            this.fetchWrapper.setHandler(HTTPResponseCodes.forbidden, handlers.getForbidden());
            return this.fetchWrapper.del(`${this.url}/${basket.getId()}`);
        }
    }
    return Basket;
});

},
'@lib/api/doc-control/document/basket/Collaborator':function(){
define(["require", "exports", "@lib/request/data/HTTPResponseCodes"], function (require, exports, HTTPResponseCodes) {
    "use strict";
    class Collaborator {
        constructor(url, fetchFactory) {
            this.url = url;
            this.fetchFactory = fetchFactory;
        }
        add(basketId, personPKs, handlers) {
            const fetchWrapper = this.fetchFactory.get();
            fetchWrapper.setSuccessHandler(async () => handlers.getSuccess()(null));
            fetchWrapper.setErrorHandler(handlers.getError());
            fetchWrapper.setHandler(HTTPResponseCodes.forbidden, handlers.getForbidden());
            return fetchWrapper.post(this.url.replace(':basketPK', basketId.toString()), {
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ personPK: personPKs })
            });
        }
        remove(basketId, personPKs, handlers) {
            const fetchWrapper = this.fetchFactory.get();
            fetchWrapper.setSuccessHandler(async () => handlers.getSuccess()(null));
            fetchWrapper.setErrorHandler(handlers.getError());
            fetchWrapper.setHandler(HTTPResponseCodes.forbidden, handlers.getForbidden());
            return fetchWrapper.del(this.url.replace(':basketPK', basketId.toString()), {
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ personPK: personPKs })
            });
        }
    }
    return Collaborator;
});

},
'@lib/api/doc-control/document/basket/Collection':function(){
define(["require", "exports", "@lib/request/data/HTTPResponseCodes"], function (require, exports, HTTPResponseCodes) {
    "use strict";
    class Collection {
        constructor(url, fetchFactory, parser) {
            this.url = url;
            this.parser = parser;
            this.fetchProcessor = fetchFactory.get();
        }
        fetch(handlers, urlSearchParams = null) {
            this.fetchProcessor.setSuccessHandler(async (response) => {
                handlers.getSuccess()(this.parser.parse(await response.json()));
            });
            this.fetchProcessor.setErrorHandler(handlers.getError());
            this.fetchProcessor.setHandler(HTTPResponseCodes.forbidden, handlers.getForbidden());
            return this.fetchProcessor.get(this.generateUrl(urlSearchParams));
        }
        generateUrl(urlSearchParams) {
            if (!urlSearchParams)
                return this.url;
            return this.url + `?${urlSearchParams.toString()}`;
        }
    }
    return Collection;
});

},
'@lib/api/doc-control/document/basket/RevisionCollection':function(){
define(["require", "exports", "@lib/request/data/HTTPResponseCodes"], function (require, exports, HTTPResponseCodes) {
    "use strict";
    class RevisionCollection {
        constructor(url, fetchFactory, parser) {
            this.url = url;
            this.fetchFactory = fetchFactory;
            this.parser = parser;
        }
        fetch(handlers, basketPK) {
            this.fetchWrapper = this.fetchFactory.get();
            this.fetchWrapper.setSuccessHandler(async (response) => {
                handlers.getSuccess()(this.parser.parse(await response.json()));
            });
            this.fetchWrapper.setErrorHandler(handlers.getError());
            this.fetchWrapper.setHandler(403, handlers.getForbidden());
            return this.fetchWrapper.get(this.url.replace(':basketPK', String(basketPK)));
        }
        save(handlers, basketPK, revisionPKs) {
            this.fetchWrapper = this.fetchFactory.get();
            this.fetchWrapper.setSuccessHandler(handlers.getSuccess());
            this.fetchWrapper.setErrorHandler(handlers.getError());
            this.fetchWrapper.setHandler(HTTPResponseCodes.forbidden, handlers.getForbidden());
            return this.fetchWrapper.put(this.url.replace(':basketPK', String(basketPK)), {
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ revisionPKs: revisionPKs.join(',') })
            });
        }
        cancel() {
            if (this.fetchWrapper) {
                this.fetchWrapper.cancel();
            }
        }
    }
    return RevisionCollection;
});

},
'@lib/api/doc-control/document/Merger':function(){
define(["require", "exports", "@lib/request/data/HTTPResponseCodes"], function (require, exports, HTTP_RESPONSE_CODES) {
    "use strict";
    class Merger {
        constructor(url, fetchFactory, optionsParser) {
            this.url = url;
            this.fetchFactory = fetchFactory;
            this.optionsParser = optionsParser;
        }
        canMerge(documentID, handlers) {
            const fetchProcessor = this.fetchFactory.get();
            fetchProcessor.setSuccessHandler((response) => {
                const options = this.optionsParser.parse(response.headers.get('access-control-allow-methods'));
                handlers.getSuccess()(options.indexOf('PATCH') !== -1);
            });
            fetchProcessor.setErrorHandler(handlers.getError());
            fetchProcessor.options(this.url.replace(':id', documentID.toString()));
            return fetchProcessor;
        }
        merge(documentId, data, handlers) {
            const fetchProcessor = this.fetchFactory.get();
            fetchProcessor.setHandler(HTTP_RESPONSE_CODES.no_content, handlers.getNoContent());
            fetchProcessor.setErrorHandler(handlers.getError());
            fetchProcessor.patch(this.url.replace(':id', documentId.toString()), {
                body: JSON.stringify(data),
                headers: { 'Content-Type': 'application/json' }
            });
            return fetchProcessor;
        }
    }
    return Merger;
});

},
'@lib/api/doc-control/document/parser/Basket':function(){
define(["require", "exports", "../data/Basket", "@lib/spencer/core/data/Person"], function (require, exports, BasketVO, PersonVO) {
    "use strict";
    class Basket {
        parse(item) {
            return new BasketVO(item.id, item.name, item.count, item.owner ? this.parsePerson(item.owner) : null, item.collaborators ? item.collaborators.map((c) => this.parsePerson(c)) : []);
        }
        parsePerson(item) {
            return (new PersonVO())
                .setPersonPK(item.personPK)
                .setDisplayName(item.displayName);
        }
    }
    return Basket;
});

},
'@lib/api/doc-control/document/data/Basket':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Basket {
        constructor(id = null, name = null, count = null, owner = null, collaborators = []) {
            this.id = id;
            this.name = name;
            this.count = count;
            this.owner = owner;
            this.collaborators = collaborators;
        }
        getId() {
            return this.id;
        }
        setId(id) {
            this.id = id;
            return this;
        }
        getName() {
            return this.name;
        }
        setName(name) {
            this.name = name;
            return this;
        }
        getCount() {
            return this.count;
        }
        setCount(count) {
            this.count = count;
            return this;
        }
        getOwner() {
            return this.owner;
        }
        getCollaborators() {
            return this.collaborators;
        }
    }
    return Basket;
});

},
'@lib/api/doc-control/document/parser/BasketCollection':function(){
define(["require", "exports", "./Basket"], function (require, exports, BasketParser) {
    "use strict";
    class BasketCollection {
        constructor() {
            this.basketParser = new BasketParser();
        }
        parse(items) {
            return items.map(item => this.basketParser.parse(item));
        }
    }
    return BasketCollection;
});

},
'@lib/request/FormDataWrapper':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class FormDataWrapper {
        constructor() {
            this.formData = new FormData();
        }
        append(key, value) {
            this.formData.append(key, value);
        }
        get() {
            return this.formData;
        }
        reset() {
            this.formData = new FormData();
        }
    }
    return FormDataWrapper;
});

},
'@lib/request/parser/Options':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Options {
        parse(data) {
            return data?.split?.(', ') ?? [];
        }
    }
    return Options;
});

},
'api/doccontrol/drawing-discipline/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    const Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_doc_control_drawing_discipline_collection = 'doc-control/drawing-discipline';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});

},
'api/doccontrol/drawing-discipline/Factory':function(){
define([
    './Collection',
    'spencer/doc-control/parser/DrawingDiscipline',
    'spencer/parse/Collection',
    'spencer/parse/JSONParser'
], function(
    Collection,
    DrawingDisciplineParser,
    CollectionParser,
    JSONParser
) {
    const Factory = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Factory.prototype.getCollection = function() {
        return new Collection(
            this.config.getUrl('api_doc_control_drawing_discipline_collection', 'v2/'),
            this.urlConnectionBuilder.build(),
            this.urlResponseProcessorBuilder,
            new JSONParser (
                new CollectionParser(
                    new DrawingDisciplineParser()
                )
            )
        );
    };

    return Factory;
});

},
'api/doccontrol/drawing-discipline/Collection':function(){
define([], function() {
    const Collection = function(url, urlConnection, urlResponseProcessorBuilder, parser) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    Collection.prototype.get = function(handlers) {
        this.urlConnection.setUrl(this.url);

        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.urlConnection.setErrorHandler(handlers.getError());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());

        return this.urlConnection.get();
    };

    return Collection;
});
},
'spencer/doc-control/parser/DrawingDiscipline':function(){
define([
    '../data/DrawingDiscipline'
], function(
    DrawingDisciplineVO
) {
    const DrawingDiscipline = function() {};

    DrawingDiscipline.prototype.parse = function(item) {
        return (new DrawingDisciplineVO())
            .setDiscipline(item.discipline || null)
            .setDrawingDisciplinePK(item.drawingDisciplinePK || null)
            .setCode(item.code || null)
    };

    return DrawingDiscipline;
});
},
'spencer/doc-control/data/DrawingDiscipline':function(){
define([], function() {
    const DrawingDiscipline = function() {
        this.drawingDisciplinePK = null;
        this.discipline = null;
        this.code = null;
    };

    DrawingDiscipline.prototype.setDrawingDisciplinePK = function(drawingDisciplinePK) {
        this.drawingDisciplinePK = drawingDisciplinePK;
        return this;
    };

    DrawingDiscipline.prototype.getDrawingDisciplinePK = function() {
        return this.drawingDisciplinePK;
    };

    DrawingDiscipline.prototype.setDiscipline = function(discipline) {
        this.discipline = discipline;
        return this;
    };

    DrawingDiscipline.prototype.getDiscipline = function() {
        return this.discipline;
    };

    DrawingDiscipline.prototype.setCode = function(code) {
        this.code = code;
        return this;
    };

    DrawingDiscipline.prototype.getCode = function() {
        return this.code;
    };

    return DrawingDiscipline;
});
},
'api/doccontrol/document/revision/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    const Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_doc_control_document_revision_latest = 'doc-control/document/:id/revision/latest';
        this.api_doc_control_document_revision_latest_collection = 'doc-control/document/revision/latest';
        this.api_doc_control_document_revision_collection = 'doc-control/document/revision';
        this.api_doc_control_revision_attribute_collection = 'doc-control/revision/:id/attribute';
        this.api_doc_control_document_revision_set_latest = 'doc-control/document/:id/revision/:revisionPK'
        this.api_doc_control_document_revision_number = 'doc-control/document/:id/revision-number';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});

},
'api/doccontrol/document/revision/Factory':function(){
define([
    'api/doccontrol/document/revision/Collection',
    'api/doccontrol/document/revision/Latest',
    'api/parser/Collection',
    'library/request/fetch/Factory',
    'spencer/doc-control/parser/Revision',
    'spencer/parse/JSONParser',
    'spencer/doc-control/parser/Status',
    '@lib/api/doc-control/revision/AttributeCollection',
    '@lib/api/doc-control/revision/parser/AttributeCollection'
], function(
    Collection,
    Latest,
    CollectionParser,
    FetchFactory,
    RevisionParser,
    JSONParser,
    StatusParser,
    AttributeCollection,
    AttributeCollectionParser
) {
    const Factory = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Factory.prototype.getAttributeCollection = function() {
        return new AttributeCollection(
            this.config.getUrl('api_doc_control_revision_attribute_collection', 'v2/'),
            new FetchFactory(),
            new AttributeCollectionParser()
        );
    };

    Factory.prototype.getLatest = function() {
        return new Latest(
            this.config.getUrl('api_doc_control_document_revision_latest', 'v2/'),
            this.urlConnectionBuilder.build(),
            new JSONParser(
                new RevisionParser(
                    new StatusParser()
                )
            ),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getCollection = function() {
        return new Collection(
            this.config.getUrl('api_doc_control_document_revision_collection', 'v2/'),
            this.urlConnectionBuilder.build(),
            new CollectionParser(
                new RevisionParser(
                    new StatusParser()
                )
            ),
            this.urlResponseProcessorBuilder
        );
    };

    return Factory;
});
},
'api/doccontrol/document/revision/Collection':function(){
define([
    'api/doccontrol/filter/DocumentReference',
    'api/doccontrol/filter/ProjectStagePK',
    'api/doccontrol/filter/ProjectStageTreeViewPK'
], function(
    FilterDocumentReference,
    FilterProjectStagePK,
    FilterProjectStageTreeViewPK
) {
    return class Collection {
        constructor(url, urlConnection, parser, urlResponseProcessorBuilder) {
            this.url = url;
            this.urlConnection = urlConnection;
            this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
            this.parser = parser;
        }

        _createQuery(filters) {
            const query = {};

            const projectStagePKFilter = filters.getFilterByClass(FilterProjectStagePK);
            const projectStageTreeViewPKFilter = filters.getFilterByClass(FilterProjectStageTreeViewPK);
            const documentReferenceFilter = filters.getFilterByClass(FilterDocumentReference);

            if (projectStagePKFilter) query['projectStagePK'] = projectStagePKFilter.getProjectStagePK();
            if (projectStageTreeViewPKFilter) query['projectStageTreeViewPK'] = projectStageTreeViewPKFilter.getProjectStageTreeViewPK();
            if (documentReferenceFilter) query['reference[]'] = documentReferenceFilter.getDocumentReference();

            return query;
        }

        get(handlers, filters) {
            this.urlConnection.setUrl(this.url);
            this.urlConnection.setQuery(this._createQuery(filters));
            this.urlConnection.setSuccessHandler(
                this.urlResponseProcessorBuilder.createProcessor(
                    this.parser,
                    handlers.getSuccess(),
                    handlers.getError()
                )
            );
            this.urlConnection.setProgressHandler(handlers.getProgress());
            this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
            this.urlConnection.setErrorHandler(handlers.getError());

            return this.urlConnection.get();
        };
    }
});
},
'api/doccontrol/filter/DocumentReference':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class DocumentReference {
        constructor(documentReference) {
            this.documentReference = documentReference;
        }
        getDocumentReference() {
            return this.documentReference;
        }
    }
    return DocumentReference;
});

},
'api/doccontrol/document/revision/Latest':function(){
define([], function() {
    const Latest = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    Latest.prototype.get = function(handlers, documentPK) {
        this.urlConnection.setUrl(this.url.replace(':id', documentPK));

        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return Latest;
});
},
'spencer/doc-control/parser/Status':function(){
define([
    '../data/Status'
], function(
    StatusVO
) {
    const Status = function() {};

    Status.prototype.parse = function(item) {
        return (new StatusVO())
            .setDescription(item.description || null)
            .setCode(item.code || null)
            .setStatusPK(item.statusPK || null)
            .setDocumentType(item.documentType || null)
    };

    return Status;
});
},
'spencer/doc-control/data/Status':function(){
define([], function() {
    const Status = function() {
        this.statusPK = null;
        this.code = null;
        this.description = null;
        this.documentType = null;
    };

    Status.prototype.setStatusPK = function(statusPK) {
        this.statusPK = statusPK;
        return this;
    };

    Status.prototype.getStatusPK = function() {
        return this.statusPK;
    };

    Status.prototype.setCode = function(code) {
        this.code = code;
        return this;
    };

    Status.prototype.getCode = function() {
        return this.code;
    };

    Status.prototype.setDescription = function(description) {
        this.description = description;
        return this;
    };

    Status.prototype.getDescription = function() {
        return this.description;
    };

    Status.prototype.setDocumentType = function(documentType) {
        this.documentType = documentType;
        return this;
    };

    Status.prototype.getDocumentType = function() {
        return this.documentType;
    };

    return Status;
});
},
'@lib/api/doc-control/revision/AttributeCollection':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class AttributeCollection {
        constructor(url, fetchFactory, parser) {
            this.url = url;
            this.fetchFactory = fetchFactory;
            this.parser = parser;
            this.requests = [];
        }
        fetch(revision, handlers) {
            const fetchWrapper = this.fetchFactory.get();
            this.requests.push(fetchWrapper);
            fetchWrapper.setSuccessHandler(async (response) => {
                handlers.getSuccess()(this.parser.parse(await response.json()));
            });
            fetchWrapper.setErrorHandler(handlers.getError());
            return fetchWrapper.get(this.url.replace(':id', revision.getRevisionPK().toString()));
        }
        cancel() {
            this.requests.forEach(request => request.cancel?.());
            this.requests = [];
        }
    }
    return AttributeCollection;
});

},
'@lib/api/doc-control/revision/parser/AttributeCollection':function(){
define(["require", "exports", "./Attribute"], function (require, exports, AttributeParser) {
    "use strict";
    class AttributeCollection {
        constructor() {
            this.parser = new AttributeParser();
        }
        parse(data) {
            return data.map(datum => {
                return this.parser.parse(datum);
            });
        }
    }
    return AttributeCollection;
});

},
'@lib/api/doc-control/revision/parser/Attribute':function(){
define(["require", "exports", "@lib/doc-control/revision/data/Attribute"], function (require, exports, AttributeVO) {
    "use strict";
    class Attribute {
        parse(data) {
            return new AttributeVO(data.revisionPK, data.key, data.value || null);
        }
    }
    return Attribute;
});

},
'@lib/doc-control/revision/data/Attribute':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Attribute {
        constructor(revisionPK, key, value) {
            this.revisionPK = revisionPK;
            this.key = key;
            this.value = value;
        }
        getRevisionPK() {
            return this.revisionPK;
        }
        getKey() {
            return this.key;
        }
        getValue() {
            return this.value;
        }
    }
    return Attribute;
});

},
'api/doccontrol/document/tree/Config':function(){
define([
    'api/Config'
], function(apiConfig) {
    const Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_doc_control_document_tree_node = 'doc-control/document/:id/tree/node/original';
        this.api_doc_control_document_tree_node_collection = 'doc-control/document/tree/node/original';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});

},
'api/doccontrol/document/tree/Factory':function(){
define([
    'api/doccontrol/document/tree/Node',
    'api/doccontrol/document/tree/NodeCollection',
    'api/doccontrol/parser/Revision',
    'spencer/doc-control/tree/parser/NodeCollection',
    'spencer/parse/JSONParser',
    '@lib/api/doc-control/tree/parser/Node',
    '@lib/api/project/parser/ProjectStage'
], function(
    Node,
    NodeCollection,
    RevisionParser,
    NodeCollectionParser,
    JSONParser,
    NodeParser,
    ProjectStageParser
) {
    const Factory = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Factory.prototype.getNode = function() {
        return new Node(
            this.config.getUrl('api_doc_control_document_tree_node', 'v2/'),
            this.urlConnectionBuilder.build(),
            new JSONParser(
                new NodeParser(new RevisionParser(), new ProjectStageParser())
            ),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getNodeCollection = function () {
        return new NodeCollection(
            this.config.getUrl('api_doc_control_document_tree_node_collection', 'v2/'),
            this.urlConnectionBuilder.build(),
            new JSONParser(
                new NodeCollectionParser()
            ),
            this.urlResponseProcessorBuilder
        );
    };

    return Factory;
});
},
'api/doccontrol/document/tree/Node':function(){
define([], function() {
    const Node = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    Node.prototype.get = function(handlers, documentPK) {
        this.urlConnection.setUrl(this.url.replace(':id', documentPK));

        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return Node;
});
},
'api/doccontrol/document/tree/NodeCollection':function(){
define([], function() {
    const NodeCollection = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this.constants = {
            URL_PARAM_DOCUMENT_PKS: 'documentPKs[]'
        };

        this.createBasicQuery = function(documentPKs) {
            var q = {};

            if (documentPKs) {
                q[this.constants.URL_PARAM_DOCUMENT_PKS] = documentPKs;
            }

            return q;
        };
    };

    NodeCollection.prototype.get = function(handlers, documentPKs) {
        this.urlConnection.setUrl(this.url);
        this.urlConnection.setQuery(this.createBasicQuery(documentPKs));
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return NodeCollection;
});
},
'spencer/doc-control/tree/parser/NodeCollection':function(){
define([
    'spencer/doc-control/tree/data/NodeCollection',
    'spencer/doc-control/tree/parser/Node'
], function(
    CollectionVO,
    NodeParser
) {
    const NodeCollection = function() {
        this.nodeParser = new NodeParser();
    };

    NodeCollection.prototype.parse = function(nodes) {
        let collection = new CollectionVO();

        nodes.forEach(function (node) {
            collection.add(this.nodeParser.parse(node));
        }.bind(this));

        return collection;
    };

    return NodeCollection;
});
},
'spencer/doc-control/tree/data/NodeCollection':function(){
define([], function() {
    const NodeCollection = function() {
        this.nodes = [];
    };

    NodeCollection.prototype.add = function(node) {
        this.nodes.push(node);
        return this;
    };

    NodeCollection.prototype.getNodes = function() {
        return this.nodes;
    };

    return NodeCollection;
});
},
'spencer/doc-control/tree/parser/Node':function(){
define([
    'spencer/doc-control/tree/data/Node',
    'spencer/core/parser/ProjectStage'
], function(
    NodeVO,
    ProjectStageParser
) {
    const Node = function() {
        this.projectStageParser = new ProjectStageParser();
    };

    Node.prototype.parse = function(item) {
        return (new NodeVO())
            .setProjectStage(this.projectStageParser.parse(item.projectStage || {}))
            .setProjectStagePK(item.projectStage && item.projectStage.projectStagePK ? item.projectStage.projectStagePK : null)
            .setProjectStageTreeViewPK(item.projectStageTreeViewPK || item.treeViewPK || null)
            .setName(item.title || item.name || null)
            .setType(item.type || null);
    };

    return Node;
});
},
'spencer/doc-control/tree/data/Node':function(){
define([], function() {
    const Node = function() {
        this.projectStage = null;
        this.projectStagePK = null;
        this.projectStageTreeViewPK = null;
        this.name = null;
        this.type = null;
        this.isRevisionableAttr = false;
    };

    Node.prototype.setProjectStage = function(projectStage) {
        this.projectStage = projectStage;
        return this;
    };

    Node.prototype.getProjectStage = function() {
        return this.projectStage;
    };

    Node.prototype.setProjectStagePK = function(projectStagePK) {
        this.projectStagePK = projectStagePK;
        return this;
    };

    Node.prototype.getProjectStagePK = function() {
        return this.projectStagePK;
    }

    Node.prototype.getProjectStageTreeViewPK = function() {
        return this.projectStageTreeViewPK;
    };

    Node.prototype.setProjectStageTreeViewPK = function(projectStageTreeViewPK) {
        this.projectStageTreeViewPK = projectStageTreeViewPK;
        return this;
    };

    Node.prototype.getName = function() {
        return this.name;
    };

    Node.prototype.setName = function(name) {
        this.name = name;
        return this;
    };

    Node.prototype.getType = function() {
        return this.type;
    };

    Node.prototype.setType = function(type) {
        this.type = type;
        return this;
    };

    Node.prototype.isRevisionable = function() {
        return this.isRevisionableAttr;
    };

    Node.prototype.setIsRevisionable = function(isRevisionable) {
        this.isRevisionableAttr = isRevisionable;
        return this;
    };

    return Node;
});
},
'spencer/core/parser/ProjectStage':function(){
define([
    '../data/ProjectStage'
], function(ProjectStageVO) {
    const ProjectStage = function() {};

    ProjectStage.prototype.parse = function(item) {
        const ps = (new ProjectStageVO())
            .setProjectStagePK(item.projectStagePK || null)
            .setProjectPK(item.projectPK || null)
            .setTitle(item.title || '')
            .setStageNumber(item.stageNumber || '')
            .setOrganisationPK(item.organisationPK || null)
            .setType(item.type || null)
            .setTreeTemplatePK(item.treeTemplatePK || null);

        if (item.isActive || item.active) {
            ps.setIsActive();
        }

        return ps;
    };

    return ProjectStage;
});
},
'spencer/core/data/ProjectStage':function(){
define(["require", "exports", "@lib/project/data/ProjectStage"], function (require, exports, ProjectStageVO) {
    "use strict";
    class ProjectStage extends ProjectStageVO {
        constructor() {
            super();
            this.projectStagePK = null;
            this.stagePK = null;
            this.projectPK = null;
            this.stageNumber = "";
            this.title = "";
            this.stageNumberRangePK = null;
            this.organisationPK = null;
            this.type = null;
            this.treeTemplatePK = null;
            this.timeCreated = null;
            this.timeModified = null;
            this.treeTemplatePK = null;
        }
    }
    return ProjectStage;
});

},
'api/doccontrol/correspondence/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    const Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_doc_control_correspondence_conversation = 'doc-control/correspondence/:id/conversation';
        this.api_doc_control_correspondence_email_document = 'doc-control/email/:messageId/document';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});

},
'api/doccontrol/correspondence/Factory':function(){
define([
    '../../parser/Collection',
    './Conversation',
    './parser/Email',
    'library/request/fetch/Factory',
    '@lib/api/doc-control/correspondence/email/Document'
], function(CollectionParser, Conversation, EmailParser, FetchFactory, Document) {
    const Factory = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Factory.prototype.getConversation = function() {
        return new Conversation(
            this.config.getUrl('api_doc_control_correspondence_conversation'),
            this.urlConnectionBuilder.build(),
            this.urlResponseProcessorBuilder,
            new CollectionParser(new EmailParser())
        );
    };

    Factory.prototype.getEmailDocument = function() {
        return new Document(
            this.config.getUrl('api_doc_control_correspondence_email_document', 'v2/'),
            new FetchFactory()
        );
    };

    return Factory;
});

},
'api/doccontrol/correspondence/Conversation':function(){
define([], function() {
    const Conversation = function(url, urlConnection, urlResponseProcessorBuilder, parser) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    Conversation.prototype.getForMessageID = function(handlers, messageID) {
        this.urlConnection.setUrl(this.url.replace(':id', messageID));

        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return Conversation;
});

},
'api/doccontrol/correspondence/parser/Email':function(){
define([
    '../data/Email'
], function(
    EmailData
) {
    const Email = function() {};

    Email.prototype.parse = function(item) {
        return (new EmailData())
            .setEmailPK(item.emailPK || null)
            .setRevisionPK(item.revisionPK || null)
            .setDateReceived(item.dateReceived ? new Date(item.dateReceived) : null)
            .setSubject(item.subject || null)
            .setFrom(item.from || null)
            .setConversation(item.conversation || null)
            .setMessageID(item.messageID || null);
    };

    return Email;
});
},
'api/doccontrol/correspondence/data/Email':function(){
define([], function() {
    const Email = function() {
        this.emailPK = null;
        this.revisionPK = null;
        this.dateReceived = null;
        this.subject = null;
        this.from = null;
        this.conversation = null;
        this.messageID = null;
    };

    Email.prototype.getEmailPK = function() {
        return this.emailPK;
    };

    Email.prototype.setEmailPK = function(emailPK) {
        this.emailPK = emailPK;
        return this;
    };

    Email.prototype.getRevisionPK = function() {
        return this.revisionPK;
    };

    Email.prototype.setRevisionPK = function(revisionPK) {
        this.revisionPK = revisionPK;
        return this;
    };

    Email.prototype.getDateReceived = function() {
        return this.dateReceived;
    };

    Email.prototype.setDateReceived = function(dateReceived) {
        this.dateReceived = dateReceived;
        return this;
    };

    Email.prototype.getSubject = function() {
        return this.subject;
    };

    Email.prototype.setSubject = function(subject) {
        this.subject = subject;
        return this;
    };

    Email.prototype.getFrom = function() {
        return this.from;
    };

    Email.prototype.setFrom = function(from) {
        this.from = from;
        return this;
    };

    Email.prototype.getConversation = function() {
        return this.conversation;
    };

    Email.prototype.setConversation = function(conversation) {
        this.conversation = conversation;
        return this;
    };

    Email.prototype.getMessageID = function() {
        return this.messageID;
    };

    Email.prototype.setMessageID = function(messageID) {
        this.messageID = messageID;
        return this;
    };

    return Email;
});

},
'@lib/api/doc-control/correspondence/email/Document':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Document {
        constructor(url, fetchFactory) {
            this.url = url;
            this.fetchFactory = fetchFactory;
        }
        async getDocumentPK(messageID) {
            const fetch = this.fetchFactory.get();
            fetch.setSuccessHandler(async (response) => {
                return parseInt((await response.json())['documentPK']);
            });
            return fetch.get(this.url.replace(':messageId', messageID));
        }
    }
    return Document;
});

},
'api/doccontrol/retirement/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    const Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_doc_control_revision_retirement_mark = 'doc-control/revision/retirement/mark';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});

},
'api/doccontrol/retirement/Factory':function(){
define([
    'api/doccontrol/parser/Revision',
    'api/doccontrol/retirement/parser/Retirement',
    'api/doccontrol/retirement/RetirementCollection',
    'api/parser/Collection',
    '@lib/api/doc-control/tree/parser/Node',
    '@lib/api/project/parser/ProjectStage'
], function(
    RevisionParser,
    RetirementParser,
    RetirementCollection,
    CollectionParser,
    TreeNodeParser,
    ProjectStageParser
) {
    const Factory = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Factory.prototype.getRetirementCollection = function() {
        return new RetirementCollection(
            this.config.getUrl('api_doc_control_revision_retirement_mark'),
            this.urlConnectionBuilder.build(),
            this.urlResponseProcessorBuilder,
            new CollectionParser(new RetirementParser(new TreeNodeParser(new RevisionParser(), new ProjectStageParser())))
        );
    };

    return Factory;
});

},
'api/doccontrol/retirement/parser/Retirement':function(){
define([
    '../data/Retirement',
    'api/doccontrol/parser/Revision',
    'api/person/parser/Person'
], function(
    RetirementVO,
    RevisionParser,
    PersonParser
) {
    const Retirement = function(treeNodeParser) {
        this.personParser = new PersonParser();
        this.revisionParser = new RevisionParser();
        this.treeNodeParser = treeNodeParser;
    };

    Retirement.prototype.parse = function(item) {
        let retirement = new RetirementVO();
        retirement.setRevisionRetirementPK(parseInt(item.revisionRetirementPK) || null);
        retirement.setReason(item.reason || null);
        retirement.setRevision(item.revision ? this.revisionParser.parse(item.revision) : null);
        retirement.setTimeCreated(item.timeCreated ? new Date(item.timeCreated) : null);
        retirement.setTimeModified(item.timeModified ? new Date(item.timeModified) : null);
        retirement.setPersonCreated(item.personCreated ? this.personParser.parse(item.personCreated) : null);
        retirement.setPersonModified(item.personModified ? this.personParser.parse(item.personModified) : null);

        if (item.registrationLocation) {
            retirement.setRegistrationLocation(this.treeNodeParser.parse(item.registrationLocation));
        }

        return retirement;
    };

    return Retirement;
});
},
'api/doccontrol/retirement/data/Retirement':function(){
define([], function() {
    var Retirement = function() {
        this.revision = null;
        this.revisionRetirementPK = null;
        this.reason = null;
        this.timeCreated = null;
        this.timeModified = null;
        this.personCreated = null;
        this.personModified = null;
        this.registrationLocation = null;
    };

    Retirement.prototype.setRevision = function(revision) {
        this.revision = revision;
    };

    Retirement.prototype.getRevision = function() {
        return this.revision;
    };

    Retirement.prototype.setRegistrationLocation = function(registrationLocation) {
        this.registrationLocation = registrationLocation;
    };

    Retirement.prototype.getRegistrationLocation = function() {
        return this.registrationLocation;
    };

    Retirement.prototype.setRevisionRetirementPK = function(revisionRetirementPK) {
        this.revisionRetirementPK = revisionRetirementPK;
    };

    Retirement.prototype.getRevisionRetirementPK = function() {
        return this.revisionRetirementPK;
    };

    Retirement.prototype.setReason = function(reason) {
        this.reason = reason;
    };

    Retirement.prototype.getReason = function() {
        return this.reason;
    };

    Retirement.prototype.setTimeCreated= function(timeCreated) {
        this.timeCreated = timeCreated;
    };

    Retirement.prototype.getTimeCreated = function() {
        return this.timeCreated;
    };

    Retirement.prototype.setTimeModified = function(timeModified) {
        this.timeModified = timeModified;
    };

    Retirement.prototype.getTimeModified = function() {
        return this.timeModified;
    };

    Retirement.prototype.setPersonCreated = function(personCreated) {
        this.personCreated = personCreated;
    };

    Retirement.prototype.getPersonCreated = function() {
        return this.personCreated;
    };

    Retirement.prototype.setPersonModified = function(personModified) {
        this.personModified = personModified;
    };

    Retirement.prototype.getPersonModified = function() {
        return this.personModified;
    };
    
    return Retirement;
});

},
'api/doccontrol/retirement/RetirementCollection':function(){
define([], function() {
    const RetirementCollection = function(url, urlConnection, urlResponseProcessorBuilder, parser) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    RetirementCollection.prototype.fetch = function(handlers) {
        this.urlConnection.setUrl(this.url);

        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return RetirementCollection;
});

},
'api/doccontrol/revision/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    const Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_doc_control_revision_registration_location = 'doc-control_revision_registration-location/';
        this.api_doc_control_revision_status = 'doc-control_revision_status/';

        this.api_doc_control_revision_collection = 'doc-control/revision';
        this.api_doc_control_revision_drawing_discipline_collection = 'doc-control/revision/drawing-discipline';
        this.api_doc_control_revision_file_type_collection = 'doc-control/revision/file-type';
        this.api_doc_control_revision_originator = 'doc-control/revision/:revisionPK/originator';
        this.api_doc_control_revision_originator_collection = 'doc-control/revision/originator';
        this.api_doc_control_revision_recipient_collection = 'doc-control/revision/recipient';
        this.api_doc_control_revision_reference_collection = 'doc-control/revision/reference';
        this.api_doc_control_revision_revision_number_collection = 'doc-control/revision/revision-number';
        this.api_doc_control_revision_revision_number_increment = 'doc-control/revision/revision-number/:revisionPK/increment';
        this.api_doc_control_revision_status_collection = 'doc-control/revision/status';
        this.api_doc_control_revision_type_collection = 'doc-control/document/type';
        this.api_doc_control_revision_title_collection = 'doc-control/revision/title';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});
},
'api/doccontrol/revision/Factory':function(){
define([
    'api/doccontrol/revision/Collection',
    'api/doccontrol/revision/DocumentTypeCollection',
    'api/doccontrol/revision/DrawingDisciplineCollection',
    'api/doccontrol/revision/FileTypeCollection',
    'api/doccontrol/revision/Originator',
    'api/doccontrol/revision/OriginatorCollection',
    'api/doccontrol/revision/RecipientCollection',
    'api/doccontrol/revision/ReferenceCollection',
    'api/doccontrol/revision/RevisionNumberCollection',
    'api/doccontrol/revision/TitleCollection',
    'api/doccontrol/revision/RegistrationLocation',
    'api/doccontrol/revision/Status',
    'api/doccontrol/revision/StatusCollection',
    'api/doccontrol/parser/RegistrationLocation',
    'api/parser/CollectionAndTotal',
    'api/parser/Collection',
    'api/person/parser/Person',
    'spencer/doc-control/parser/DocumentType',
    'spencer/doc-control/parser/DrawingDiscipline',
    'spencer/doc-control/parser/FileType',
    'spencer/doc-control/parser/Recipient',
    'spencer/doc-control/parser/Originator',
    'spencer/doc-control/parser/Reference',
    'spencer/doc-control/parser/RevisionNumber',
    'spencer/doc-control/parser/Title',
    'spencer/doc-control/parser/Revision',
    'spencer/doc-control/parser/Status',
    'spencer/doc-control/revision/parser/Status',
    'spencer/parse/Collection',
    'spencer/parse/JSONParser'
], function(
    Collection,
    DocumentTypeCollection,
    DrawingDisciplineCollection,
    FileTypeCollection,
    Originator,
    OriginatorCollection,
    RecipientCollection,
    ReferenceCollection,
    RevisionNumberCollection,
    TitleCollection,
    RegistrationLocation,
    Status,
    StatusCollection,
    RegistrationLocationParser,
    ApiCollectionAndTotalParser,
    ApiCollectionParser,
    PersonParser,
    DocumentTypeParser,
    DrawingDisciplineParser,
    FileTypeParser,
    RecipientParser,
    OriginatorParser,
    ReferenceParser,
    RevisionNumberParser,
    TitleParser,
    RevisionParser,
    RevisionStatusParser,
    StatusParser,
    CollectionParser,
    JSONParser
) {
    const Factory = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Factory.prototype.getCollection = function() {
        return new Collection(
            this.config.getUrl('api_doc_control_revision_collection', 'v2/'),
            this.urlConnectionBuilder.build(),
            new ApiCollectionAndTotalParser(
                new ApiCollectionParser(
                    new RevisionParser(
                        new RevisionStatusParser()
                    )
                )
            ),
            this.urlResponseProcessorBuilder
        )
    };

    Factory.prototype.getDocumentTypeCollection = function() {
        return new DocumentTypeCollection(
            this.config.getUrl('api_doc_control_revision_type_collection', 'v2/'),
            this.urlConnectionBuilder.build(),
            new JSONParser(
                new CollectionParser(
                    new DocumentTypeParser()
                )
            ),
            this.urlResponseProcessorBuilder
        )
    };

    Factory.prototype.getDrawingDisciplineCollection = function() {
        return new DrawingDisciplineCollection(
            this.config.getUrl('api_doc_control_revision_drawing_discipline_collection', 'v2/'),
            this.urlConnectionBuilder.build(),
            new JSONParser (
                new CollectionParser(
                    new DrawingDisciplineParser()
                )
            ),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getFileTypeCollection = function() {
        return new FileTypeCollection(
            this.config.getUrl('api_doc_control_revision_file_type_collection', 'v2/'),
            this.urlConnectionBuilder.build(),
            new JSONParser(
                new CollectionParser(
                    new FileTypeParser()
                )
            ),
            this.urlResponseProcessorBuilder
        )
    };

    Factory.prototype.getOriginator = function() {
        return new Originator(
            this.config.getUrl('api_doc_control_revision_originator', 'v2/'),
            this.urlConnectionBuilder,
            new JSONParser(
                new OriginatorParser()
            ),
            this.urlResponseProcessorBuilder
        )
    };

    Factory.prototype.getOriginatorCollection = function() {
        return new OriginatorCollection(
            this.config.getUrl('api_doc_control_revision_originator_collection', 'v2/'),
            this.urlConnectionBuilder.build(),
            new JSONParser(
                new CollectionParser(
                    new OriginatorParser()
                )
            ),
            this.urlResponseProcessorBuilder
        )
    };

    Factory.prototype.getRecipientCollection = function() {
        return new RecipientCollection(
            this.config.getUrl('api_doc_control_revision_recipient_collection', 'v2/'),
            this.urlConnectionBuilder.build(),
            new JSONParser(
                new CollectionParser(
                    new RecipientParser()
                )
            ),
            this.urlResponseProcessorBuilder
        )
    };

    Factory.prototype.getReferenceCollection = function() {
        return new ReferenceCollection(
            this.config.getUrl('api_doc_control_revision_reference_collection', 'v2/'),
            this.urlConnectionBuilder.build(),
            new JSONParser(
                new CollectionParser(
                    new ReferenceParser()
                )
            ),
            this.urlResponseProcessorBuilder
        )
    };

    Factory.prototype.getRevisionNumberCollection = function() {
        return new ReferenceCollection(
            this.config.getUrl('api_doc_control_revision_revision_number_collection', 'v2/'),
            this.urlConnectionBuilder.build(),
            new JSONParser(
                new CollectionParser(
                    new RevisionNumberParser()
                )
            ),
            this.urlResponseProcessorBuilder
        )
    };

    Factory.prototype.getTitleCollection = function() {
        return new TitleCollection(
            this.config.getUrl('api_doc_control_revision_title_collection', 'v2/'),
            this.urlConnectionBuilder.build(),
            new JSONParser(
                new CollectionParser(
                    new TitleParser()
                )
            ),
            this.urlResponseProcessorBuilder
        )
    };

    Factory.prototype.getRegistrationLocation = function() {
        return new RegistrationLocation(
            this.config.getUrl('api_doc_control_revision_registration_location'),
            this.urlConnectionBuilder,
            new ApiCollectionParser(new RegistrationLocationParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getStatus = function() {
        return new Status(
            this.config.getUrl('api_doc_control_revision_status'),
            this.urlConnectionBuilder,
            new ApiCollectionParser(new StatusParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getStatusCollection = function() {
        return new StatusCollection(
            this.config.getUrl('api_doc_control_revision_status_collection', 'v2/'),
            this.urlConnectionBuilder.build(),
            new JSONParser(
                new CollectionParser(
                    new StatusParser()
                )
            ),
            this.urlResponseProcessorBuilder
        )
    };

    return Factory;
});
},
'api/doccontrol/revision/Collection':function(){
define([
    '../filter/DocumentTitle',
    '../filter/Originator',
    '../filter/ProjectStagePK',
    '../filter/ProjectStageTreeViewPK',
    '../filter/Date',
    'spencer/core/filter/Pagination',
    'spencer/core/filter/Query',
    'library/request/HeadersSingleton',
    '@lib/doc-control/tree/data/Node'
], function(
    DocumentTitleFilter,
    OriginatorFilter,
    ProjectStagePKFilter,
    ProjectStageTreeViewPKFilter,
    DateFilter,
    PaginationFilter,
    QueryFilter,
    HeadersSingleton,
    NodeVO
) {
    const Collection = function(
        url,
        connection,
        parser,
        urlResponseProcessorBuilder
    ) {
        this.url = url;
        this.connection = connection;
        this.parser = parser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;

        this._createQuery = function(filters, sorts) {
            const query = {};
            const projectStagePKFilter = filters.getFilterByClass(ProjectStagePKFilter);
            const projectStageTreeViewPKFilter = filters.getFilterByClass(ProjectStageTreeViewPKFilter);
            const paginationFilter = filters.getFilterByClass(PaginationFilter);
            const documentTitleFilter = filters.getFilterByClass(DocumentTitleFilter);
            const originatorFilter = filters.getFilterByClass(OriginatorFilter);
            const node = filters.getFilterByClass(NodeVO);
            const queryFilter = filters.getFilterByClass(QueryFilter);
            const dateFilter = filters.getFilterByClass(DateFilter);

            if (projectStagePKFilter) query['projectStagePK'] = projectStagePKFilter.getProjectStagePK();
            if (projectStageTreeViewPKFilter) query['projectStageTreeViewPK'] = projectStageTreeViewPKFilter.getProjectStageTreeViewPK();
            if (documentTitleFilter) query['title'] = documentTitleFilter.getDocumentTitle();
            if (originatorFilter) query['originator'] = originatorFilter.getOriginator();
            if (queryFilter) query['query'] = queryFilter.getQuery();
            if (dateFilter) query['date'] = dateFilter.getDate();

            if (node) {
                query['projectStagePK'] = node.getProjectStagePK();
                query['projectStageTreeViewPK'] = node.getProjectStageTreeViewPK();
            }

            if(paginationFilter) {
                query['offset'] = paginationFilter.getOffset();
                query['limit'] = paginationFilter.getLimit();
            }

            if(sorts) {
                sorts.getSorts().forEach(function(sort) {
                    query['sort'] = sort.getAttribute();
                    query['order'] = sort.getOrder();
                });
            }

            return query;
        }
    };

    Collection.prototype.fetch = function(
        handlers,
        filters,
        sorts
    ) {
        HeadersSingleton.setHeader(
            'Accept',
            'application/json'
        );

        this.connection.setUrl(this.url);
        this.connection.setQuery(
            this._createQuery(
                filters,
                sorts
            )
        );

        this.connection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.connection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.connection.setProgressHandler(handlers.getProgress());
        this.connection.setErrorHandler(handlers.getError());
        this.connection.setAbortHandler(handlers.getAbort());

        return this.connection.get();
    };

    return Collection;
});
},
'api/doccontrol/filter/Originator':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Originator {
        constructor(originator) {
            this.originator = originator;
        }
        getOriginator() {
            return this.originator;
        }
    }
    return Originator;
});

},
'api/doccontrol/filter/Date':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Date {
        constructor(date) {
            this.date = date;
        }
        getDate() {
            return this.date;
        }
    }
    return Date;
});

},
'spencer/core/filter/Query':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Query {
        constructor(query) {
            this.query = query;
        }
        getQuery() {
            return this.query;
        }
    }
    return Query;
});

},
'api/doccontrol/revision/DocumentTypeCollection':function(){
define([
    'api/doccontrol/helper/QueryBuilder'
], function(
    QueryBuilder
) {
    const DocumentTypeCollection = function(
        url,
        connection,
        parser,
        urlResponseProcessorBuilder
    ) {
        this.url = url;
        this.connection = connection;
        this.parser = parser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.queryBuilder = new QueryBuilder();
    };

    DocumentTypeCollection.prototype.fetch = function(handlers, filters) {
        this.connection.setUrl(this.url);
        this.connection.setQuery(
            this.queryBuilder.build(filters)
        );

        this.connection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.connection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.connection.setProgressHandler(handlers.getProgress());
        this.connection.setErrorHandler(handlers.getError());
        this.connection.setAbortHandler(handlers.getAbort());

        return this.connection.get();
    };

    return DocumentTypeCollection;
});
},
'api/doccontrol/helper/QueryBuilder':function(){
define([
    'api/doccontrol/filter/Date',
    'api/doccontrol/filter/DocumentRecipient',
    'api/doccontrol/filter/DocumentReference',
    'api/doccontrol/filter/RevisionNumber',
    'api/doccontrol/filter/DocumentTitle',
    'api/doccontrol/filter/DrawingDiscipline',
    'api/doccontrol/filter/FileType',
    'api/doccontrol/filter/Originator',
    'api/doccontrol/filter/ProjectStagePK',
    'api/doccontrol/filter/ProjectStageTreeViewPK',
    'api/doccontrol/filter/Status',
    'api/doccontrol/filter/DocumentType',
    'api/doccontrol/filter/InterchangeableOriginatorRecipient',
    'api/doccontrol/filter/MinDate',
    'api/doccontrol/filter/MaxDate',
    'api/project/filter/ExcludeInactive',
    'spencer/core/filter/Pagination',
    'spencer/core/filter/Query'
], function(
    DateFilter,
    DocumentRecipientFilter,
    DocumentReferenceFilter,
    RevisionNumberFilter,
    DocumentTitleFilter,
    DrawingDisciplineFilter,
    FileTypeFilter,
    OriginatorFilter,
    ProjectStagePKFilter,
    ProjectStageTreeViewPKFilter,
    StatusFilter,
    DocumentTypeFilter,
    InterchangeableOriginatorRecipientFilter,
    MinDateFilter,
    MaxDateFilter,
    ExcludeInactiveFilter,
    PaginationFilter,
    QueryFilter
) {
    const QUERY_PARAM_DISCIPLINE = 'drawingDiscipline[]';
    const QUERY_PARAM_DOCUMENT_RECIPIENT = 'recipient[]';
    const QUERY_PARAM_DOCUMENT_TYPE = 'documentType[]';
    const QUERY_PARAM_FILE_TYPE = 'fileType[]';
    const QUERY_PARAM_ORIGINATOR = 'originator[]';
    const QUERY_PARAM_REFERENCE = 'reference[]';
    const QUERY_PARAM_REVISION_NUMBER = 'revisionNumber[]';
    const QUERY_PARAM_STATUS = 'status[]';
    const QUERY_PARAM_TITLE = 'documentTitle[]';

    const QUERY_PARAM_DATE = 'date';
    const QUERY_PARAM_EXCLUDE_INACTIVE = 'excludeInactiveProjectStages';
    const QUERY_PARAM_INTERCHANGEABLE_ORIGINATOR_RECIPIENT = 'interchangeableOriginatorRecipient';
    const QUERY_PARAM_LIMIT = 'limit';
    const QUERY_PARAM_MAX_DATE = 'maxDate';
    const QUERY_PARAM_MIN_DATE = 'minDate';
    const QUERY_PARAM_OFFSET = 'offset';
    const QUERY_PARAM_ORDER = 'order';
    const QUERY_PARAM_PROJECT_STAGE_PK = 'projectStagePK';
    const QUERY_PARAM_PROJECT_STAGE_TREE_VIEW_PK = 'projectStageTreeViewPK';
    const QUERY_PARAM_QUERY = 'query';
    const QUERY_PARAM_SORT = 'sort';

    const QueryBuilder = function() {};

    QueryBuilder.prototype.build = function(filters, sorts) {
        const query = {};

        const documentRecipientFilters = filters.getFiltersByClass(DocumentRecipientFilter);
        const documentReferenceFilters = filters.getFiltersByClass(DocumentReferenceFilter);
        const documentTitleFilters = filters.getFiltersByClass(DocumentTitleFilter);
        const documentTypeFilters = filters.getFiltersByClass(DocumentTypeFilter);
        const drawingDisciplineFilters = filters.getFiltersByClass(DrawingDisciplineFilter);
        const fileTypeFilters = filters.getFiltersByClass(FileTypeFilter);
        const originatorFilters = filters.getFiltersByClass(OriginatorFilter);
        const paginationFilter = filters.getFilterByClass(PaginationFilter);
        const revisionNumberFilters = filters.getFiltersByClass(RevisionNumberFilter);
        const statusFilters = filters.getFiltersByClass(StatusFilter);

        const dateFilter = filters.getFilterByClass(DateFilter);
        const excludeInactiveFilter = filters.getFilterByClass(ExcludeInactiveFilter);
        const interchangeableFilter = filters.getFilterByClass(InterchangeableOriginatorRecipientFilter);
        const maxDateFilter = filters.getFilterByClass(MaxDateFilter);
        const minDateFilter = filters.getFilterByClass(MinDateFilter);
        const projectStagePKFilter = filters.getFilterByClass(ProjectStagePKFilter);
        const projectStageTreeViewPKFilter = filters.getFilterByClass(ProjectStageTreeViewPKFilter);
        const queryFilter = filters.getFilterByClass(QueryFilter);

        if(documentTitleFilters.length) {
            query[QUERY_PARAM_TITLE] = documentTitleFilters.map(function(filter) {
                return filter.getDocumentTitle();
            });
        }

        if(originatorFilters.length) {
            query[QUERY_PARAM_ORIGINATOR] = originatorFilters.map(function(filter) {
                return filter.getOriginator();
            });
        }

        if(documentReferenceFilters.length) {
            query[QUERY_PARAM_REFERENCE] = documentReferenceFilters.map(function(filter) {
                return filter.getDocumentReference();
            });
        }

        if(documentRecipientFilters.length) {
            query[QUERY_PARAM_DOCUMENT_RECIPIENT] = documentRecipientFilters.map(function(filter) {
                return filter.getDocumentRecipient();
            });
        }

        if(drawingDisciplineFilters.length) {
            query[QUERY_PARAM_DISCIPLINE] = drawingDisciplineFilters.map(function(filter) {
                return filter.getDrawingDiscipline();
            });
        }

        if(fileTypeFilters.length) {
            query[QUERY_PARAM_FILE_TYPE] = fileTypeFilters.map(function(filter) {
                return filter.getFileType()
            });
        }

        if(revisionNumberFilters.length) {
            query[QUERY_PARAM_REVISION_NUMBER] = revisionNumberFilters.map(function(filter) {
                return filter.getRevisionNumber();
            });
        }

        if(statusFilters.length) {
            query[QUERY_PARAM_STATUS] = statusFilters.map(function(filter) {
                return filter.getStatus();
            });
        }

        if(documentTypeFilters.length) {
            query[QUERY_PARAM_DOCUMENT_TYPE] = documentTypeFilters.map(function(filter) {
                return filter.getDocumentType();
            });
        }

        if (dateFilter) query[QUERY_PARAM_DATE] = dateFilter.getDate();
        if (projectStagePKFilter) query[QUERY_PARAM_PROJECT_STAGE_PK] = projectStagePKFilter.getProjectStagePK();
        if (projectStageTreeViewPKFilter) query[QUERY_PARAM_PROJECT_STAGE_TREE_VIEW_PK] = projectStageTreeViewPKFilter.getProjectStageTreeViewPK();
        if (queryFilter) query[QUERY_PARAM_QUERY] = queryFilter.getQuery();
        if (interchangeableFilter) query[QUERY_PARAM_INTERCHANGEABLE_ORIGINATOR_RECIPIENT] = true;
        if (minDateFilter) query[QUERY_PARAM_MIN_DATE] = minDateFilter.getMinDate();
        if (maxDateFilter) query[QUERY_PARAM_MAX_DATE] = maxDateFilter.getMaxDate();
        if (excludeInactiveFilter) query[QUERY_PARAM_EXCLUDE_INACTIVE] = true;

        if(paginationFilter) {
            query[QUERY_PARAM_OFFSET] = paginationFilter.getOffset();
            query[QUERY_PARAM_LIMIT] = paginationFilter.getLimit();
        }

        if(sorts) {
            sorts.getSorts().forEach(function(sort) {
                query[QUERY_PARAM_SORT] = sort.getAttribute();
                query[QUERY_PARAM_ORDER] = sort.getOrder();
            });
        }

        return query;
    };

    return QueryBuilder;
});
},
'api/doccontrol/filter/DocumentRecipient':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class DocumentRecipient {
        constructor(documentRecipient) {
            this.documentRecipient = documentRecipient;
        }
        getDocumentRecipient() {
            return this.documentRecipient;
        }
    }
    return DocumentRecipient;
});

},
'api/doccontrol/filter/RevisionNumber':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class RevisionNumber {
        constructor(revisionNumber) {
            this.revisionNumber = revisionNumber;
        }
        getRevisionNumber() {
            return this.revisionNumber;
        }
    }
    return RevisionNumber;
});

},
'api/doccontrol/filter/DrawingDiscipline':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class DrawingDiscipline {
        constructor(drawingDiscipline) {
            this.drawingDiscipline = drawingDiscipline;
        }
        getDrawingDiscipline() {
            return this.drawingDiscipline;
        }
    }
    return DrawingDiscipline;
});

},
'api/doccontrol/filter/FileType':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class FileType {
        constructor(fileType) {
            this.fileType = fileType;
        }
        getFileType() {
            return this.fileType;
        }
    }
    return FileType;
});

},
'api/doccontrol/filter/Status':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Status {
        constructor(status) {
            this.status = status;
        }
        getStatus() {
            return this.status;
        }
    }
    return Status;
});

},
'api/doccontrol/filter/DocumentType':function(){
define([], function(){
    const DocumentType = function(documentType) {
        this.documentType = documentType;
    };

    DocumentType.prototype.getDocumentType = function() {
        return this.documentType;
    };

    return DocumentType;
});
},
'api/doccontrol/filter/InterchangeableOriginatorRecipient':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class InterchangeableOriginatorRecipient {
    }
    return InterchangeableOriginatorRecipient;
});

},
'api/doccontrol/filter/MinDate':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class MinDate {
        constructor(minDate) {
            this.minDate = minDate;
        }
        getMinDate() {
            return this.minDate;
        }
    }
    return MinDate;
});

},
'api/doccontrol/filter/MaxDate':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class MaxDate {
        constructor(maxDate) {
            this.maxDate = maxDate;
        }
        getMaxDate() {
            return this.maxDate;
        }
    }
    return MaxDate;
});

},
'api/project/filter/ExcludeInactive':function(){
define([], function() {
    return function() {}
});
},
'api/doccontrol/revision/DrawingDisciplineCollection':function(){
define([
    'api/doccontrol/helper/QueryBuilder'
], function(
    QueryBuilder
) {
    const DrawingDisciplineCollection = function(
        url,
        connection,
        parser,
        urlResponseProcessorBuilder
    ) {
        this.url = url;
        this.connection = connection;
        this.parser = parser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.queryBuilder = new QueryBuilder();
    };

    DrawingDisciplineCollection.prototype.fetch = function(handlers, filters) {
        this.connection.setUrl(this.url);
        this.connection.setQuery(
            this.queryBuilder.build(filters)
        );

        this.connection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.connection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.connection.setProgressHandler(handlers.getProgress());
        this.connection.setErrorHandler(handlers.getError());
        this.connection.setAbortHandler(handlers.getAbort());

        return this.connection.get();
    };

    return DrawingDisciplineCollection;
});
},
'api/doccontrol/revision/FileTypeCollection':function(){
define([
    'api/doccontrol/helper/QueryBuilder'
], function(
    QueryBuilder
) {
    const FileTypeCollection = function(
        url,
        connection,
        parser,
        urlResponseProcessorBuilder
    ) {
        this.url = url;
        this.connection = connection;
        this.parser = parser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.queryBuilder = new QueryBuilder();
    };

    FileTypeCollection.prototype.fetch = function(handlers, filters) {
        this.connection.setUrl(this.url);
        this.connection.setQuery(
            this.queryBuilder.build(filters)
        );

        this.connection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.connection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.connection.setProgressHandler(handlers.getProgress());
        this.connection.setErrorHandler(handlers.getError());
        this.connection.setAbortHandler(handlers.getAbort());

        return this.connection.get();
    };

    return FileTypeCollection;
});
},
'api/doccontrol/revision/Originator':function(){
define([], function() {
    const Originator = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    Originator.prototype.get = function(handlers, revisionPK) {
        const urlConnection = this.urlConnection.build();
        urlConnection.setUrl(this.url.replace(':revisionPK', revisionPK));

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    return Originator;
});
},
'api/doccontrol/revision/OriginatorCollection':function(){
define([
    'api/doccontrol/helper/QueryBuilder'
], function(
    QueryBuilder
) {
    const OriginatorCollection = function(
        url,
        connection,
        parser,
        urlResponseProcessorBuilder
    ) {
        this.url = url;
        this.connection = connection;
        this.parser = parser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.queryBuilder = new QueryBuilder();
    };

    OriginatorCollection.prototype.fetch = function(handlers, filters) {
        this.connection.setUrl(this.url);
        this.connection.setQuery(
            this.queryBuilder.build(filters)
        );

        this.connection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.connection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.connection.setProgressHandler(handlers.getProgress());
        this.connection.setErrorHandler(handlers.getError());
        this.connection.setAbortHandler(handlers.getAbort());

        return this.connection.get();
    };

    return OriginatorCollection;
});
},
'api/doccontrol/revision/RecipientCollection':function(){
define([
    'api/doccontrol/helper/QueryBuilder'
], function(
    QueryBuilder
) {
    const RecipientCollection = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
        this.queryBuilder = new QueryBuilder();
    };

    RecipientCollection.prototype.fetch = function(handlers, filterCollection) {
        const urlConnection = this.urlConnection;
        urlConnection.setUrl(this.url);

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        urlConnection.setQuery(this.queryBuilder.build(filterCollection));
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    return RecipientCollection;
});
},
'api/doccontrol/revision/ReferenceCollection':function(){
define([
    'api/doccontrol/helper/QueryBuilder'
], function(
    QueryBuilder
) {
    const Reference = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
        this.queryBuilder = new QueryBuilder();
    };

    Reference.prototype.fetch = function(handlers, filterCollection) {
        const urlConnection = this.urlConnection;
        urlConnection.setUrl(this.url);

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        urlConnection.setQuery(this.queryBuilder.build(filterCollection));
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    return Reference;
});
},
'api/doccontrol/revision/RevisionNumberCollection':function(){
define([
    'api/doccontrol/helper/QueryBuilder'
], function(
    QueryBuilder
) {
    const RevisionNumber = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
        this.queryBuilder = new QueryBuilder();
    };

    RevisionNumber.prototype.fetch = function(handlers, filterCollection) {
        const urlConnection = this.urlConnection;
        urlConnection.setUrl(this.url);

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        urlConnection.setQuery(this.queryBuilder.build(filterCollection));
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    return RevisionNumber;
});
},
'api/doccontrol/revision/TitleCollection':function(){
define([
    'api/doccontrol/helper/QueryBuilder'
], function(
    QueryBuilder
) {
    const Title = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
        this.queryBuilder = new QueryBuilder();
    };

    Title.prototype.fetch = function(handlers, filterCollection) {
        const urlConnection = this.urlConnection;
        urlConnection.setUrl(this.url);

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        urlConnection.setQuery(this.queryBuilder.build(filterCollection));
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    return Title;
});
},
'api/doccontrol/revision/RegistrationLocation':function(){
define([], function() {
    const RegistrationLocation = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
        this.parser.setIsSingleItemCollection(true);
    };

    RegistrationLocation.prototype.get = function(handlers, revisionPK) {
        const urlConnection = this.urlConnection.build();
        urlConnection.setUrl(this.url + revisionPK);

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };
    
    return RegistrationLocation;
});
},
'api/doccontrol/revision/Status':function(){
define([], function() {
    const Status = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
        this.parser.setIsSingleItemCollection(true);
    };

    Status.prototype.getForRevision = function(handlers, revisionPK) {
        const urlConnection = this.urlConnection.build();
        urlConnection.setUrl(this.url + revisionPK);

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };
    
    return Status;
});
},
'api/doccontrol/revision/StatusCollection':function(){
define([
    'api/doccontrol/helper/QueryBuilder'
], function(
    QueryBuilder
) {
    const StatusCollection = function(
        url,
        connection,
        parser,
        urlResponseProcessorBuilder
    ) {
        this.url = url;
        this.connection = connection;
        this.parser = parser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.queryBuilder = new QueryBuilder();
    };

    StatusCollection.prototype.fetch = function(handlers, filters) {
        this.connection.setUrl(this.url);
        this.connection.setQuery(
            this.queryBuilder.build(filters)
        );

        this.connection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.connection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.connection.setProgressHandler(handlers.getProgress());
        this.connection.setErrorHandler(handlers.getError());
        this.connection.setAbortHandler(handlers.getAbort());

        return this.connection.get();
    };

    return StatusCollection;
});
},
'api/doccontrol/parser/RegistrationLocation':function(){
define([
    '../data/RegistrationLocation'
], function(
    RegistrationLocationData
) {
    const RegistrationLocation = function() {};

    RegistrationLocation.prototype.parse = function(item) {
        return (new RegistrationLocationData())
            .setProjectStagePK(item.projectStagePK || null)
            .setProjectStageNumber(item.projectStageNumber || null)
            .setProjectStageTitle(item.projectStageTitle || null)
            .setProjectStageTreeViewPK(item.projectStageTreeViewPK || null)
            .setProjectStageTreeViewName(item.projectStageTreeViewName || null)
            .setProjectStageTreeViewType(item.projectStageTreeViewType || null)
            .setProjectStageTreeViewIsRevisionable(item.projectStageTreeViewIsRevisionable || false);
    };

    return RegistrationLocation;
});
},
'api/doccontrol/data/RegistrationLocation':function(){
define([], function() {
    const RegistrationLocation = function() {
        this.projectStagePK = null;
        this.projectStageNumber = null;
        this.projectStageTitle = null;
        this.projectStageTreeViewPK = null;
        this.projectStageTreeViewName = null;
        this.projectStageTreeViewType = null;
        this.projectStageTreeViewIsRevisionable = false;
    };

    RegistrationLocation.prototype.getProjectStagePK = function() {
        return this.projectStagePK;
    };

    RegistrationLocation.prototype.setProjectStagePK = function(projectStagePK) {
        this.projectStagePK = projectStagePK;
        return this;
    };

    RegistrationLocation.prototype.getProjectStageNumber = function() {
        return this.projectStageNumber;
    };

    RegistrationLocation.prototype.setProjectStageNumber = function(projectStageNumber) {
        this.projectStageNumber = projectStageNumber;
        return this;
    };

    RegistrationLocation.prototype.getProjectStageTitle = function() {
        return this.projectStageTitle;
    };

    RegistrationLocation.prototype.setProjectStageTitle = function(projectStageTitle) {
        this.projectStageTitle = projectStageTitle;
        return this;
    };

    RegistrationLocation.prototype.getProjectStageTreeViewPK = function() {
        return this.projectStageTreeViewPK;
    };

    RegistrationLocation.prototype.setProjectStageTreeViewPK = function(projectStageTreeViewPK) {
        this.projectStageTreeViewPK = projectStageTreeViewPK;
        return this;
    };

    RegistrationLocation.prototype.getProjectStageTreeViewName = function() {
        return this.projectStageTreeViewName;
    };

    RegistrationLocation.prototype.setProjectStageTreeViewName = function(projectStageTreeViewName) {
        this.projectStageTreeViewName = projectStageTreeViewName;
        return this;
    };

    RegistrationLocation.prototype.getProjectStageTreeViewType = function() {
        return this.projectStageTreeViewType;
    };

    RegistrationLocation.prototype.setProjectStageTreeViewType = function(projectStageTreeViewType) {
        this.projectStageTreeViewType = projectStageTreeViewType;
        return this;
    };

    RegistrationLocation.prototype.isProjectStageTreeViewRevisionable = function() {
        return this.projectStageTreeViewIsRevisionable;
    };

    RegistrationLocation.prototype.setProjectStageTreeViewIsRevisionable = function(projectStageTreeViewIsRevisionable) {
        this.projectStageTreeViewIsRevisionable = projectStageTreeViewIsRevisionable;
        return this;
    };

    return RegistrationLocation;
});
},
'api/parser/CollectionAndTotal':function(){
define([], function() {
    const CollectionAndTotal = function(collectionParser) {
        this.collectionParser = collectionParser;
    };

    CollectionAndTotal.prototype.parse = function(content) {
        return {
            collection: this.collectionParser.parse(content),
            total: JSON.parse(content).total
        }
    };

    return CollectionAndTotal;
});
},
'spencer/doc-control/parser/DocumentType':function(){
define([], function() {
    const DocumentType = function() {};

    DocumentType.prototype.parse = function(item) {
        return {'documentType': item};
    };

    return DocumentType;
});
},
'spencer/doc-control/parser/FileType':function(){
define([], function() {
    const FileType = function() {};

    FileType.prototype.parse = function(item) {
        return {'fileType': item};
    };

    return FileType;
});
},
'spencer/doc-control/parser/Originator':function(){
define([
    'spencer/core/parser/Person',
    'spencer/core/parser/Organisation',
    'spencer/core/parser/BranchOffice',
    'spencer/core/parser/BranchOfficeEmail',
    'spencer/doc-control/data/Originator'
], function(
    PersonParser,
    OrganisationParser,
    BranchOfficeParser,
    BranchOfficeEmailParser,
    OriginatorVO
) {
    const Originator = function() {
        this.personParser = new PersonParser();
        this.organisationParser = new OrganisationParser();
        this.branchOfficeParser = new BranchOfficeParser();
        this.branchOfficeEmailParser = new BranchOfficeEmailParser();
    };

    Originator.prototype.parse = function(item) {
        const originator = new OriginatorVO();

        if(item.person) {
            originator.setPerson(this.personParser.parse(item.person));
        }

        if(item.organisation) {
            originator.setOrganisation(this.organisationParser.parse(item.organisation));
        }

        if(item.branchOffice) {
            originator.setBranchOffice(this.branchOfficeParser.parse(item.branchOffice));
            originator.setBranchOfficeEmail(this.branchOfficeEmailParser.parse(item.branchOffice));
        }

        return originator.setUid(
            (item.person ? item.person.name + ' - ' : '') + item.organisation.name
        );
    };

    return Originator;
});
},
'spencer/doc-control/data/Originator':function(){
define([], function() {
    const Originator = function() {
        this.uid = null;
        this.person = null;
        this.organisation = null;
        this.branchOffice = null;
        this.branchOfficeEmail = null;
    };

    Originator.prototype.setUid = function(uid) {
        this.uid = uid;
        return this;
    };

    Originator.prototype.setPerson = function(person) {
        this.person = person;
        return this;
    };

    Originator.prototype.getPerson = function() {
        return this.person;
    };

    Originator.prototype.setOrganisation = function(organisation) {
        this.organisation = organisation;
        return this;
    };

    Originator.prototype.getOrganisation = function() {
        return this.organisation;
    };

    Originator.prototype.setBranchOffice = function(branchOffice) {
        this.branchOffice = branchOffice;
        return this;
    };

    Originator.prototype.getBranchOffice = function() {
        return this.branchOffice;
    };

    Originator.prototype.setBranchOfficeEmail = function(branchOfficeEmail) {
        this.branchOfficeEmail = branchOfficeEmail;
        return this;
    };

    Originator.prototype.getBranchOfficeEmail = function() {
        return this.branchOfficeEmail;
    };

    return Originator;
});
},
'spencer/doc-control/parser/Reference':function(){
define([], function() {
    const Reference = function() {};

    Reference.prototype.parse = function(item) {
        return {'reference': item};
    };

    return Reference;
});
},
'spencer/doc-control/parser/RevisionNumber':function(){
define([], function() {
    const RevisionNumber = function() {};

    RevisionNumber.prototype.parse = function(item) {
        return {'revisionNumber': item};
    };

    return RevisionNumber;
});
},
'spencer/doc-control/parser/Title':function(){
define([], function() {
    const Title = function() {};

    Title.prototype.parse = function(item) {
        return {'title': item};
    };

    return Title;
});
},
'spencer/doc-control/revision/parser/Status':function(){
define([
    '../data/Status'
], function(
    StatusData
) {
    const Status = function() {};

    Status.prototype.parse = function(item) {
        return (new StatusData())
            .setStatusPK(item.statusPK || null)
            .setDocumentType(item.documentType || null)
            .setDescription(item.description || null);
    };

    return Status;
});
},
'spencer/doc-control/revision/data/Status':function(){
define([], function() {
    const Status = function() {
        this.statusPK = null;
        this.description = null;
        this.documentType = null;
    };

    Status.prototype.getStatusPK = function() {
        return this.statusPK;
    };

    Status.prototype.setStatusPK = function(statusPK) {
        this.statusPK = statusPK;
        return this;
    };

    Status.prototype.getDescription = function() {
        return this.description;
    };

    Status.prototype.setDescription = function(description) {
        this.description = description;
        return this;
    };

    Status.prototype.getDocumentType = function() {
        return this.documentType;
    };

    Status.prototype.setDocumentType = function(documentType) {
        this.documentType = documentType;
        return this;
    };

    return Status;
});
},
'api/doccontrol/revision-details/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    const Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_doc_control_revision_details_drawing_discipline = 'doc-control/revision-details/drawing-discipline/';
        this.api_doc_control_revision_details_status = 'doc-control/revision-details/status/';
        this.api_doc_control_status_by_code = 'doc-control/code/:code/document-type/:documentType/status';
        this.api_doc_control_drawing_discipline_by_code = 'doc-control/code/:code/drawing-discipline';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});

},
'api/doccontrol/revision-details/Factory':function(){
define([
    '../../parser/Collection',
    '../parser/RegistrationLocation',
    './DrawingDiscipline',
    './DrawingDisciplineCollection',
    './Status',
    './StatusCollection',
    'library/request/fetch/Factory',
    'spencer/doc-control/parser/DrawingDiscipline',
    'spencer/doc-control/parser/Status'
], function(
    CollectionParser,
    RegistrationLocationParser,
    DrawingDiscipline,
    DrawingDisciplineCollection,
    Status,
    StatusCollection,
    FetchFactory,
    DrawingDisciplineParser,
    StatusParser
) {
    const Factory = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Factory.prototype.getDrawingDisciplineCollection = function() {
        return new DrawingDisciplineCollection(
            this.config.getUrl('api_doc_control_revision_details_drawing_discipline'),
            this.urlConnectionBuilder,
            new CollectionParser(new DrawingDisciplineParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getStatusCollection = function() {
        return new StatusCollection(
            this.config.getUrl('api_doc_control_revision_details_status'),
            this.urlConnectionBuilder,
            new CollectionParser(new StatusParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getStatus = function() {
        return new Status(
            new StatusParser(),
            new FetchFactory()
        );
    };

    Factory.prototype.getDrawingDiscipline = function() {
        return new DrawingDiscipline(
            new DrawingDisciplineParser(),
            new FetchFactory()
        );
    };

    return Factory;
});
},
'api/doccontrol/revision-details/DrawingDiscipline':function(){
define(["require", "exports", "./Config"], function (require, exports, UrlConfig) {
    "use strict";
    class DrawingDiscipline {
        constructor(statusParser, fetchFactory) {
            this.statusParser = statusParser;
            this.fetchFactory = fetchFactory;
            this.fetchProcessor = fetchFactory.get();
            this.urlConfig = new UrlConfig();
        }
        getByCode(code) {
            const url = this.urlConfig.getUrl('api_doc_control_drawing_discipline_by_code', 'v2/').replace(':code', code);
            this.fetchProcessor.setSuccessHandler(async (response) => {
                const data = await response.json();
                return this.statusParser.parse(data);
            });
            return this.fetchProcessor.get(url);
        }
    }
    return DrawingDiscipline;
});

},
'api/doccontrol/revision-details/DrawingDisciplineCollection':function(){
define([], function() {
    const DrawingDisciplineCollection = function(url, urlConnectionBuilder, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    DrawingDisciplineCollection.prototype.fetch = function(handlers) {
        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url);

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };
    
    return DrawingDisciplineCollection;
});
},
'api/doccontrol/revision-details/Status':function(){
define(["require", "exports", "./Config"], function (require, exports, UrlConfig) {
    "use strict";
    class Status {
        constructor(statusParser, fetchFactory) {
            this.statusParser = statusParser;
            this.fetchFactory = fetchFactory;
            this.fetchProcessor = fetchFactory.get();
            this.urlConfig = new UrlConfig();
        }
        getByCode(code, documentType) {
            const url = this.urlConfig.getUrl('api_doc_control_status_by_code', 'v2/')
                .replace(':documentType', documentType)
                .replace(':code', code);
            this.fetchProcessor.setSuccessHandler(async (response) => {
                const data = await response.json();
                return this.statusParser.parse(data);
            });
            return this.fetchProcessor.get(url);
        }
    }
    return Status;
});

},
'api/doccontrol/revision-details/StatusCollection':function(){
define([
    './filter/DocumentType'
], function(FilterDocumentType) {
    const URL_PARAM_DOCUMENT_TYPE = 'documentType';

    const Status = function(url, urlConnectionBuilder, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
        this.documentType = null;

        this._createBasicQuery = function(filterCollection) {
            let query = {};

            let documentTypeFilter = filterCollection.getFilterByClass(FilterDocumentType);
            if (documentTypeFilter) {
                query[URL_PARAM_DOCUMENT_TYPE] = documentTypeFilter.getDocumentType();
            }

            return query;
        };
    };

    Status.prototype.setDocumentType = function(documentType) {
        this.documentType = documentType;
        return this;
    };


    Status.prototype.fetch = function(handlers, filterCollection) {
        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url);

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        urlConnection.setQuery(this._createBasicQuery(filterCollection));
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };
    
    return Status;
});
},
'api/doccontrol/revision-details/filter/DocumentType':function(){
define([], function() {
    const DocumentType = function(documentType) {
        this.documentType = documentType;
    };

    DocumentType.prototype.getDocumentType = function() {
        return this.documentType;
    };

    return DocumentType;
});
},
'api/doccontrol/search/Factory':function(){
define([
    './RevisionCollection',
    'spencer/doc-control/search/parser/Revision',
    'api/parser/CollectionAndTotal',
    'api/parser/Collection'
], function(
    RevisionCollection,
    RevisionParser,
    CollectionAndTotalParser,
    CollectionParser
) {
    const Factory = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Factory.prototype.getRevisionCollection = function() {
        return new RevisionCollection(
            this.config.getUrl('api_doc_control_search_revision_collection', 'v2/'),
            this.urlConnectionBuilder.build(),
            new CollectionAndTotalParser(
                new CollectionParser(
                    new RevisionParser()
                )
            ),
            this.urlResponseProcessorBuilder
        );
    };

    return Factory;
});
},
'api/doccontrol/search/RevisionCollection':function(){
define([
    'api/doccontrol/helper/QueryBuilder',
    '@lib/doc-control/tree/data/Node',
    'library/request/HeadersSingleton'
], function(
    QueryBuilder,
    NodeVO,
    HeadersSingleton
) {
    const RevisionCollection = function(
        url,
        connection,
        parser,
        urlResponseProcessorBuilder
    ) {
        this.url = url;
        this.connection = connection;
        this.parser = parser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.queryBuilder = new QueryBuilder();
    };

    RevisionCollection.prototype.fetch = function(
        handlers,
        filters,
        sorts
    ) {
        HeadersSingleton.setHeader(
            'Accept',
            'application/json'
        );

        this.connection.setUrl(this.url);
        this.connection.setQuery(
            this.queryBuilder.build(
                filters,
                sorts
            )
        );

        this.connection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.connection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.connection.setProgressHandler(handlers.getProgress());
        this.connection.setErrorHandler(handlers.getError());
        this.connection.setAbortHandler(handlers.getAbort());

        return this.connection.get();
    };

    return RevisionCollection;
});
},
'spencer/doc-control/search/parser/Revision':function(){
define([
    '../data/Revision',
    'spencer/doc-control/parser/Revision',
    'spencer/doc-control/parser/Status',
    'spencer/doc-control/tree/parser/Node'
], function(
    RevisionVO,
    RevisionParser,
    RevisionStatusParser,
    TreeNodeParser
) {
    const Revision = function() {
        this.revisionParser = new RevisionParser(
            new RevisionStatusParser()
        );

        this.treeNodeParser = new TreeNodeParser();
    };

    Revision.prototype.parse = function(item) {
        return (new RevisionVO())
            .setRevision(this.revisionParser.parse(item.revision || {}))
            .setScore(item.score || null)
            .setPstvPath(item.pstvPath || null)
            .setDocumentType(item.documentType || null)
            .setNode(this.treeNodeParser.parse(item.node || {}));
    };

    return Revision;
});
},
'spencer/doc-control/search/data/Revision':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Revision {
        constructor() {
            this.score = null;
            this.documentType = null;
            this.pstvPath = null;
        }
        setRevision(revision) {
            this.revision = revision;
            return this;
        }
        ;
        getRevision() {
            return this.revision;
        }
        ;
        setScore(score) {
            this.score = score;
            return this;
        }
        ;
        getScore() {
            return this.score;
        }
        ;
        setDocumentType(documentType) {
            this.documentType = documentType;
            return this;
        }
        ;
        getDocumentType() {
            return this.documentType;
        }
        ;
        setPstvPath(pstvPath) {
            this.pstvPath = pstvPath;
            return this;
        }
        ;
        getPstvPath() {
            return this.pstvPath;
        }
        ;
        setNode(node) {
            this.node = node;
            return this;
        }
        ;
        getNode() {
            return this.node;
        }
        ;
    }
    return Revision;
});

},
'api/doccontrol/search/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    const Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_doc_control_search_revision_collection = 'doc-control/revision/search/';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});

},
'api/doccontrol/template/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    const Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_doc_control_template = 'doc-control/document/template';
        this.api_doc_control_template_collection = 'doc-control/document/template-collection';
        this.api_doc_control_template_document_type_collection = 'doc-control/document/template/document-type';
        this.api_doc_control_template_field = 'doc-control/document/template/field/data-type';
        this.api_doc_control_template_extract = 'doc-control/document/template/extract';
        this.api_doc_control_template_organisation = 'doc-control/document/template/organisation';
        this.api_doc_control_template_organisation_location_finder = 'doc-control/document/template/organisation-location-finder';
        this.api_doc_control_template_person = 'doc-control/document/template/person';
        this.api_doc_control_template_revision_meta_data = 'doc-control/document/template/revision/metadata';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});

},
'api/doccontrol/template/Factory':function(){
define([
    './Collection',
    './DocumentTypeCollection',
    './Extractor',
    './Field',
    './OrganisationCollection',
    './Template',
    './TemplateOrganisationLocationFinder',
    './parser/Template',
    './parser/TemplateCollection',
    './parser/MetaDataCollection',
    './parser/Field',
    './revision/MetaData',
    'api/doccontrol/parser/Revision',
    'api/person/PeopleCollection',
    'library/request/fetch/Factory',
    'spencer/core/parser/Organisation',
    'spencer/core/parser/Person',
    'spencer/parse/Collection',
    'spencer/parse/JSONParser',
    '@lib/api/doc-control/tree/parser/Node',
    '@lib/api/project/parser/ProjectStage'
], function(
    Collection,
    DocumentTypeCollection,
    Extractor,
    Field,
    OrganisationCollection,
    Template,
    TemplateOrganisationLocationFinder,
    TemplateParser,
    TemplateCollectionParser,
    MetaDataCollectionParser,
    FieldParser,
    RevisionMetaData,
    RevisionParser,
    PersonCollection,
    FetchFactory,
    OrganisationParser,
    PersonParser,
    CollectionParser,
    JSONParser,
    TreeNodeParser,
    ProjectStageParser
) {
    const Factory = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Factory.prototype.getDocumentTypeCollection = function() {
        return new DocumentTypeCollection(
            this.config.getUrl('api_doc_control_template_document_type_collection', 'v2/'),
            this.urlConnectionBuilder.build()
        );
    };

    Factory.prototype.getExtractor = function() {
        return new Extractor(
            this.config.getUrl('api_doc_control_template_extract', 'v2/'),
            this.urlConnectionBuilder.build(),
            new JSONParser(
                new CollectionParser(new FieldParser())
            ),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getField = function() {
        return new Field(
            this.config.getUrl('api_doc_control_template_field', 'v2/'),
            this.urlConnectionBuilder.build()
        );
    };

    Factory.prototype.getOrganisationCollection = function() {
        return new OrganisationCollection(
            this.config.getUrl('api_doc_control_template_organisation', 'v2/'),
            this.urlConnectionBuilder.build(),
            new JSONParser(new CollectionParser(new OrganisationParser())),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getPersonCollection = function() {
        return new PersonCollection(
            this.config.getUrl('api_doc_control_template_person', 'v2/'),
            this.urlConnectionBuilder.build(),
            new JSONParser(new CollectionParser(new PersonParser())),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getTemplate = function() {
        return new Template(
            this.config.getUrl('api_doc_control_template', 'v2/'),
            this.urlConnectionBuilder.build(),
            new JSONParser(new TemplateParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getTemplateCollection = function() {
        return new Collection(
            this.config.getUrl('api_doc_control_template_collection', 'v2/'),
            this.urlConnectionBuilder.build(),
            new JSONParser(new TemplateCollectionParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getTemplateOrganisationLocationFinder = function() {
        return new TemplateOrganisationLocationFinder(
            this.config.getUrl('api_doc_control_template_organisation_location_finder', 'v2/'),
            new FetchFactory(),
            new TreeNodeParser(new RevisionParser(), new ProjectStageParser())
        );
    };

    Factory.prototype.getRevisionMetaData = function() {
        return new RevisionMetaData(
            this.config.getUrl('api_doc_control_template_revision_meta_data', 'v2/'),
            this.urlConnectionBuilder.build(),
            new JSONParser(new MetaDataCollectionParser()),
            this.urlResponseProcessorBuilder
        );
    };

    return Factory;
});
},
'api/doccontrol/template/Collection':function(){
define([
    'api/doccontrol/template/filter/DocumentTypeFilter',
    'spencer/core/filter/Pagination',
    'spencer/core/filter/Query',
    'spencer/core/data/Organisation',
    'spencer/core/data/Person',
    './filter/OnlyLatest',
    './filter/Reference',
    './filter/contains/Name',
    './filter/contains/Reference'
], function(
    DocumentTypeFilter,
    PaginationFilter,
    QueryFilter,
    OrganisationVO,
    PersonVO,
    OnlyLatestFilter,
    ReferenceFilter,
    ContainsName,
    ContainsReference
) {
    const URL_PARAM_ONLY_LATEST = 'onlyLatest';
    const URL_PARAM_LIMIT = 'limit';
    const URL_PARAM_OFFSET = 'offset';
    const URL_PARAM_QUERY = 'query';
    const URL_PARAM_NAME = 'name';
    const URL_PARAM_ORGANISATION = 'organisationPK';
    const URL_PARAM_PERSON_CREATED = 'personCreated';
    const URL_PARAM_DOCUMENT_TYPE = 'documentTypePK';
    const URL_PARAM_REFERENCE = 'reference';
    const URL_PARAM_CONTAINS_REFERENCE = 'containsReference';
    const URL_PARAM_SORT = 'sort';
    const URL_PARAM_SORT_ORDER = 'order';

    const Collection = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this._createBasicQuery = function(filterCollection, sort) {
            if (filterCollection) {
                const query = {};

                const paginationFilter = filterCollection.getFilterByClass(PaginationFilter);
                if (paginationFilter) {
                    query[URL_PARAM_LIMIT] = paginationFilter.getLimit();
                    query[URL_PARAM_OFFSET] = paginationFilter.getOffset();
                }

                const queryFilter = filterCollection.getFilterByClass(QueryFilter);
                if (queryFilter) {
                    query[URL_PARAM_QUERY] = queryFilter.getQuery();
                }

                const containsName = filterCollection.getFilterByClass(ContainsName);
                if (containsName) {
                    query[URL_PARAM_NAME] = containsName.getName();
                }

                const organisation = filterCollection.getFilterByClass(OrganisationVO);
                if (organisation) {
                    query[URL_PARAM_ORGANISATION] = organisation.getOrganisationPK();
                }

                const person = filterCollection.getFilterByClass(PersonVO);
                if (person) {
                    query[URL_PARAM_PERSON_CREATED] = person.getPersonPK();
                }

                const documentType = filterCollection.getFilterByClass(DocumentTypeFilter);
                if (documentType) {
                    query[URL_PARAM_DOCUMENT_TYPE] = documentType.getDocumentTypePK();
                }

                const onlyLatest = filterCollection.getFilterByClass(OnlyLatestFilter);
                if (onlyLatest) {
                    query[URL_PARAM_ONLY_LATEST] = true;
                }

                const reference = filterCollection.getFilterByClass(ReferenceFilter);
                if (reference) {
                    query[URL_PARAM_REFERENCE] = reference.getReference();
                }

                const containsReference = filterCollection.getFilterByClass(ContainsReference);
                if (containsReference) {
                    query[URL_PARAM_CONTAINS_REFERENCE] = containsReference.getReference();
                }

                if (sort) {
                    query[URL_PARAM_SORT] = sort.getAttribute();
                    query[URL_PARAM_SORT_ORDER] = sort.getOrder();
                }

                this.urlConnection.setQuery(query);
            }
        };
    };

    Collection.prototype.fetch = function(handlers, filters, sort) {
        const urlConnection = this.urlConnection;
        this._createBasicQuery(filters, sort);

        urlConnection.setUrl(this.url);
        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    return Collection;
});
},
'api/doccontrol/template/filter/DocumentTypeFilter':function(){
define([], function() {
    return class DocumentTypeFilter {
        constructor(documentTypePK) {
            this.documentTypePK = documentTypePK;
        }

        getDocumentTypePK() {
            return this.documentTypePK;
        };
    };
});
},
'api/doccontrol/template/filter/OnlyLatest':function(){
define([], function() {
    return function() {};
});
},
'api/doccontrol/template/filter/Reference':function(){
define([], function() {
    const Reference = function(reference) {
        this.reference = reference;
    };

    Reference.prototype.getReference = function() {
        return this.reference;
    };

    return Reference;
});
},
'api/doccontrol/template/filter/contains/Name':function(){
define([], function() {
    return class Name {
        constructor(name) {
            this.name = name
        }

        getName() {
            return this.name
        }
    };
});
},
'api/doccontrol/template/filter/contains/Reference':function(){
define([], function() {
    return class Reference {
        constructor(reference) {
            this.reference = reference
        }

        getReference() {
            return this.reference
        }
    };
});
},
'api/doccontrol/template/DocumentTypeCollection':function(){
define([], function() {
    const URL_PARAM_EXISTING = 'existing';

    return class DocumentTypeCollection {
        constructor(url, urlConnection) {
            this.url = url;
            this.urlConnection = urlConnection;
            this.existing = false;
        }

        _createBasicQuery() {
            const query = {};

            if (this.existing) {
                query[URL_PARAM_EXISTING] = 1;
            }

            this.urlConnection.setQuery(query);
        }

        fetch(handlers, existing) {
            this.existing = existing;
            this._createBasicQuery();

            this.urlConnection.setUrl(this.url);
            this.urlConnection.setSuccessHandler(handlers.getSuccess());
            this.urlConnection.setProgressHandler(handlers.getProgress());
            this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
            this.urlConnection.setErrorHandler(handlers.getError());

            return this.urlConnection.get();
        }
    }
});
},
'api/doccontrol/template/Extractor':function(){
define([], function() {
    const Extractor = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.parser = parser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Extractor.prototype.extract = function(handlers, md5, templatePK, ignoreCache = false) {
        const q = {
            md5: md5,
            templatePK: templatePK
        };
        if (ignoreCache) q['ignoreCache'] = true;

        const urlConnection = this.urlConnection;
        urlConnection.setQuery(q);

        urlConnection.setUrl(this.url);
        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());
        urlConnection.setAbortHandler(handlers.getAbort());

        return urlConnection.get();
    };

    return Extractor;
});
},
'api/doccontrol/template/Field':function(){
define([], function() {
    return class Field {
        constructor(url, urlConnection) {
            this.url = url;
            this.urlConnection = urlConnection;
        }

        fetchDataTypes(handlers) {
            this.urlConnection.setUrl(this.url);
            this.urlConnection.setSuccessHandler(handlers.getSuccess());
            this.urlConnection.setProgressHandler(handlers.getProgress());
            this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
            this.urlConnection.setErrorHandler(handlers.getError());

            return this.urlConnection.get();
        }
    }
});
},
'api/doccontrol/template/OrganisationCollection':function(){
define([
    './filter/ContactEmail',
    'api/organisation/OrganisationCollection'
], function(
    ContactEmailFilter,
    BaseOrganisationCollection
) {
    const PARAM_CONTACT_EMAIL = 'contactEmail';

    return class OrganisationCollection extends BaseOrganisationCollection {
        _createBasicQuery(filterCollection, sortCollection) {
            const q = super._createBasicQuery(filterCollection, sortCollection);

            if (filterCollection && filterCollection.hasFilterForClass(ContactEmailFilter)) {
                q[PARAM_CONTACT_EMAIL] = filterCollection.getFilterByClass(ContactEmailFilter).getContactEmail();
            }

            return q;
        }
    }
});
},
'api/doccontrol/template/filter/ContactEmail':function(){
define([], function() {
    return class ContactEmail {
        constructor(contactEmail) {
            this.contactEmail = contactEmail;
        }

        getContactEmail() {
            return this.contactEmail;
        }
    }
});
},
'api/organisation/OrganisationCollection':function(){
define([
    './filter/ExcludeInactive',
    './filter/EmailHostSearch',
    './filter/IntranetOwner',
    './filter/OrganisationType',
    './filter/ProjectStage',
    './sort/Name',
    './sort/NumberOfContacts'
], function(
    ExcludeInactiveFilter,
    EmailHostSearchFilter,
    IntranetOwnerFilter,
    OrganisationTypeFilter,
    ProjectStageFilter,
    NameSort,
    NumberOfContactsSort
) {
    const PARAM_EMAIL_HOST_SEARCH = 'emailHostSearch';
    const PARAM_EXCLUDE_INACTIVE = 'excludeInactive';
    const PARAM_SEARCH = 'search';
    const PARAM_LIMIT = 'limit';
    const PARAM_OFFSET = 'offset';
    const PARAM_EXCLUDE_INTRANET_OWNERS = 'excludeIntranetOwners';
    const PARAM_ONLY_INTRANET_OWNERS = 'includeOnlyIntranetOwners';
    const PARAM_ORGANISATION_TYPE = 'organisationType';
    const PARAM_PROJECT_STAGE = "projectStage";
    const PARAM_SORT_BY = 'sortBy';
    const PARAM_SORT_DESCENDING = 'sortDescending';
    const SORT_BY_NAME = 'name';
    const SORT_BY_NUMBER_OF_CONTACTS = 'numberOfContacts';

    return class OrganisationCollection {
        constructor(url, urlConnection, collectionParser, urlResponseProcessorBuilder) {
            this.url = url;
            this.urlConnection = urlConnection;
            this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
            this.parser = collectionParser;

            this.limit = 10;
            this.offset = 0;
            this.query = null;

            this.urlConnection.setUrl(this.url);
        }

        setLimit(limit) {
            this.limit = limit;
            return this;
        }

        setOffset(offset) {
            this.offset = offset;
            return this;
        }

        setQuery(query) {
            this.query = query;
            return this;
        }

        fetch(handlers, filterCollection, sortCollection) {
            this.urlConnection.setQuery(this._createBasicQuery(filterCollection, sortCollection));
            this.urlConnection.setSuccessHandler(
                this.urlResponseProcessorBuilder.createProcessor(
                    this.parser,
                    handlers.getSuccess(),
                    handlers.getError()
                )
            );
            this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
            this.urlConnection.setProgressHandler(handlers.getProgress());
            this.urlConnection.setErrorHandler(handlers.getError());

            return this.urlConnection.get();
        }

        _createBasicQuery(filterCollection, sortCollection) {
            let q = {};

            q[PARAM_LIMIT] = this.limit;
            q[PARAM_OFFSET] = this.offset;

            if (this.query && this.query !== '') {
                q[PARAM_SEARCH] = this.query;
            }

            if (filterCollection) {
                if (filterCollection.hasFilterForClass(EmailHostSearchFilter)) {
                    q[PARAM_EMAIL_HOST_SEARCH] = filterCollection.getFilterByClass(EmailHostSearchFilter).getHost();
                }

                if (filterCollection.hasFilterForClass(IntranetOwnerFilter)) {
                    const intranetOwnerFilter = filterCollection.getFilterByClass(IntranetOwnerFilter);

                    if (intranetOwnerFilter.shouldExcludeIntranetOwners()) {
                        q[PARAM_EXCLUDE_INTRANET_OWNERS] = true;
                    } else if (intranetOwnerFilter.shouldIncludeOnlyIntranetOwners()) {
                        q[PARAM_ONLY_INTRANET_OWNERS] = true;
                    }
                }

                if (filterCollection.hasFilterForClass(ProjectStageFilter)) {
                    q[PARAM_PROJECT_STAGE] = filterCollection
                        .getFilterByClass(ProjectStageFilter)
                        .getProjectStagePK();
                }

                if (filterCollection.hasFilterForClass(ExcludeInactiveFilter)) {
                    q[PARAM_EXCLUDE_INACTIVE] = true;
                }

                if (filterCollection.hasFilterForClass(OrganisationTypeFilter)) {
                    q[PARAM_ORGANISATION_TYPE] = filterCollection
                        .getFilterByClass(OrganisationTypeFilter)
                        .getOrganisationTypeName();
                }
            }

            if (sortCollection) {
                if (sortCollection.hasSortForClass(NameSort)) {
                    q[PARAM_SORT_BY] = SORT_BY_NAME;
                    q[PARAM_SORT_DESCENDING] = sortCollection.getSortByClass(NameSort).isDescending();
                }

                if (sortCollection.hasSortForClass(NumberOfContactsSort)) {
                    q[PARAM_SORT_BY] = SORT_BY_NUMBER_OF_CONTACTS;
                    q[PARAM_SORT_DESCENDING] = sortCollection.getSortByClass(NumberOfContactsSort).isDescending();
                }
            }

            return q;
        }
    }
});
},
'api/organisation/filter/ExcludeInactive':function(){
define([], function() {
    return function() {}
});
},
'api/organisation/filter/EmailHostSearch':function(){
define([], function() {
    let EmailHostSearch = function() {
        this.host = true;
    };

    EmailHostSearch.prototype.setHost = function(host) {
        this.host = host;
        return this;
    };

    EmailHostSearch.prototype.getHost = function() {
        return this.host;
    };

    return EmailHostSearch;
});
},
'api/organisation/filter/IntranetOwner':function(){
define([], function() {
    const IntranetOwner = function() {
        this.paramExcludeIntranetOwners = false;
        this.paramIncludeOnlyIntranetOwners = false;
    };

    IntranetOwner.prototype.excludeIntranetOwners = function() {
        this.paramExcludeIntranetOwners = true;
        return this;
    };

    IntranetOwner.prototype.shouldExcludeIntranetOwners = function() {
        return this.paramExcludeIntranetOwners;
    };

    IntranetOwner.prototype.includeOnlyIntranetOwners = function() {
        this.paramIncludeOnlyIntranetOwners = true;
        return this;
    };

    IntranetOwner.prototype.shouldIncludeOnlyIntranetOwners = function() {
        return this.paramIncludeOnlyIntranetOwners;
    };

    return IntranetOwner;
});
},
'api/organisation/filter/OrganisationType':function(){
define([], function() {
    const OrganisationType = function() {
        this.name = null;
    };

    OrganisationType.prototype.setOrganisationTypeName = function(name) {
        this.name = name;
        return this;
    };

    OrganisationType.prototype.getOrganisationTypeName = function() {
        return this.name;
    };

    return OrganisationType;
});
},
'api/organisation/filter/ProjectStage':function(){
define([], function() {
    var ProjectStage = function() {
        this.projectStagePK = null;
    };

    ProjectStage.prototype.setProjectStagePK = function(projectStagePK) {
        this.projectStagePK = projectStagePK;
        return this;
    };

    ProjectStage.prototype.getProjectStagePK = function() {
        return this.projectStagePK;
    };

    return ProjectStage;
});
},
'api/organisation/sort/Name':function(){
define([
    'spencer/core/sort/Orderable'
], function(
    Orderable
) {
    const Name = function() {
        Orderable.call(this);
    };

    Name.prototype = Object.create(Orderable.prototype);
    Name.prototype.constructor = Name;

    return Name;
});
},
'spencer/core/sort/Orderable':function(){
define([], function() {
    const ASCENDING = 0;
    const DESCENDING = 1;

    const Orderable = function() {
        this.order = ASCENDING;
    };

    Orderable.prototype.ascending = function() {
        this.order = ASCENDING;
        return this;
    };

    Orderable.prototype.descending = function() {
        this.order = DESCENDING;
        return this;
    };

    Orderable.prototype.isDescending = function() {
        return this.order === DESCENDING;
    };

    return Orderable;
});
},
'api/organisation/sort/NumberOfContacts':function(){
define([
    'spencer/core/sort/Orderable'
], function(
    Orderable
) {
    const NumberOfContacts = function() {
        Orderable.call(this);
    };

    NumberOfContacts.prototype = Object.create(Orderable.prototype);
    NumberOfContacts.prototype.constructor = NumberOfContacts;

    return NumberOfContacts;
});
},
'api/doccontrol/template/Template':function(){
define([], function() {
    const Template = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this.createBasicQuery = function(template) {
            let q = {};

            if (template) {
                if (template.getTemplatePK()) {
                    q['templatePK'] = template.getTemplatePK();
                }

                q['name'] = template.getName();
                q['fields'] = JSON.stringify(template.getFieldCollection());

                if (template.getReference()) {
                    q['reference'] = template.getReference();
                }

                if (template.getVersion()) {
                    q['version'] = template.getVersion();
                }

                if (template.getOrganisation()) {
                    q['organisationPK'] = template.getOrganisation().getOrganisationPK();
                }

                if (template.getDocumentType()) {
                    q['documentTypePK'] = template.getDocumentType();
                }

                if (template.getDescription()) {
                    q['description'] = template.getDescription();
                }

                if (template.getFieldDefinitionRevision()) {
                    q['fieldDefinitionRevisionId'] = template.getFieldDefinitionRevision().getRevisionPK();
                }

                if (template.getProjectStageTreeViewPath()) {
                    q['projectStageTreeViewPath'] = template.getProjectStageTreeViewPath();
                } else if (template.getProjectStageTreeView()) {
                    q['projectStageTreeViewPK'] = template.getProjectStageTreeView().getProjectStageTreeViewPK();
                }
            }

            return q;
        };
    };

    Template.prototype.get = function(handlers, template) {
        const urlConnection = this.urlConnection;
        const query = {};

        if (template.getTemplatePK()) {
            query['templatePK'] = template.getTemplatePK();
        }

        if (template.getReference()) {
            query['reference'] = template.getReference();

            if (template.getVersion()) {
                query['version'] = template.getVersion();
            }
        }

        urlConnection.setUrl(this.url);
        urlConnection.setQuery(query);
        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());
        urlConnection.setAbortHandler(handlers.getAbort());

        return urlConnection.get();
    };

    Template.prototype.save = function(template, handlers) {
        const urlConnection = this.urlConnection;

        urlConnection.setUrl(this.url);
        urlConnection.setData(this.createBasicQuery(template));
        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.post();
    };

    Template.prototype.delete = function(template, handlers) {
        const urlConnection = this.urlConnection;

        urlConnection.setUrl(this.url + '/' + template.getTemplatePK());
        urlConnection.setSuccessHandler(handlers.getSuccess());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.del();
    };

    Template.prototype.update = function(template, handlers) {
        const urlConnection = this.urlConnection;

        urlConnection.setUrl(this.url + '/' + template.getTemplatePK());
        urlConnection.setData(this.createBasicQuery(template));
        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.put();
    };

    return Template;
});
},
'api/doccontrol/template/TemplateOrganisationLocationFinder':function(){
define([
    'library/request/data/HTTPResponseCodes'
], function(HTTPResponseCodes) {
    return class TemplateOrganisationLocationFinder {
        constructor(url, fetchFactory, parser) {
            this.url = url;
            this.fetchFactory = fetchFactory;
            this.parser = parser;
        }

        get(handlers, templatePK, projectStagePK, emailFrom) {
            const fetchProcessor = this.fetchFactory.get();
            fetchProcessor.setSuccessHandler(async response => {
                handlers.getSuccess()(this.parser.parse(await response.json()));
            });
            fetchProcessor.setErrorHandler(handlers.getError());
            fetchProcessor.setHandler(HTTPResponseCodes.reset_content, handlers.getResetContent());

            fetchProcessor.get(this.url + this._createQuery(templatePK, projectStagePK, emailFrom));
            return fetchProcessor;
        }

        _createQuery(templatePK, projectStagePK, emailFrom) {
            const q = {};

            q['templatePK'] = templatePK;
            q['projectStagePK'] = projectStagePK;

            if (emailFrom) {
                q['emailFrom'] = emailFrom;
            }

            return '?' + new URLSearchParams(q).toString();
        }
    }
});
},
'api/doccontrol/template/parser/Template':function(){
define([
    './Field',
    '../data/Template',
    'api/doccontrol/parser/Revision',
    'api/person/parser/Person',
    'api/organisation/parser/Organisation',
    './DocumentType',
    '@lib/api/doc-control/tree/parser/Node',
    '@lib/api/project/parser/ProjectStage'
], function(
    FieldParser,
    TemplateVO,
    RevisionParser,
    PersonParser,
    OrganisationParser,
    DocumentTypeParser,
    TreeNodeParser,
    ProjectStageParser
) {
    const Template = function() {
        this.personParser = new PersonParser();
        this.organisationParser = new OrganisationParser();
        this.documentTypeParser = new DocumentTypeParser();
        this.revisionParser = new RevisionParser();
        this.fieldParser = new FieldParser();
        this.treeNodeParser = new TreeNodeParser(this.revisionParser, new ProjectStageParser());

        this.setTreeView = function(item, template) {
            if (item.projectStageTreeViewPath) {
                return template.setProjectStageTreeViewPath(item.projectStageTreeViewPath);
            }

            if (item.treeViewPath) {
                return template.setProjectStageTreeViewPath(item.treeViewPath);
            }

            if (item.projectStageTreeView) {
                return template.setProjectStageTreeView(this.treeNodeParser.parse(item.projectStageTreeView));
            }

            if (item.treeViewPK) {
                return template.setProjectStageTreeView(
                    this.treeNodeParser.parse({projectStageTreeViewPK: item.treeViewPK})
                );
            }
        };
    };

    Template.prototype.parse = function(item) {
        const template = new TemplateVO();
        template.setTemplatePK(item.templatePK || null);
        template.setReference(item.reference || null);
        template.setVersion(item.version || null);
        template.setName(item.name || null);
        template.setDescription(item.description || null);
        template.setPersonCreated(item.personCreated ? this.personParser.parse(item.personCreated) : null);
        template.setPersonModified(item.personModified ? this.personParser.parse(item.personModified) : null);
        template.setTimeCreated(item.timeCreated ? new Date(item.timeCreated) : null);
        template.setTimeModified(item.timeModified ? new Date(item.timeModified) : null);
        template.setOrganisation(item.organisation ? this.organisationParser.parse(item.organisation) : null);
        template.setDocumentType(item.documentType ? this.documentTypeParser.parse(item.documentType) : null);

        if (item.fieldDefinitionRevision) {
            template.setFieldDefinitionRevision(this.revisionParser.parse(item.fieldDefinitionRevision));
        }

        this.setTreeView(item, template);

        if (Array.isArray(item.fieldCollection)) {
            template.setFieldCollection(item.fieldCollection.map(function(field) {
                return this.fieldParser.parse(field);
            }.bind(this)));
        } else {
            template.setFieldCollection([]);
        }

        return template;
    };

    return Template;
});
},
'api/doccontrol/template/parser/Field':function(){
define([
    'ocr/parser/Multiline'
], function(
    MultilineParser
) {
    const Field = function() {};

    Field.prototype.parse = function(item) {
        const value = item.value ? MultilineParser.parse(item.value) : null;

        return {
            templateFieldPK: item.templateFieldPK || null,
            name: item.name && typeof item.name.label == "string" ? item.name.label : (item.name || null),
            refersTo: item.name && item.name.refersTo ? item.name.refersTo : (item.refersTo || null),
            x: item.x || null,
            y: item.y || null,
            width: item.width || null,
            height: item.height || null,
            rotation: item.rotation || null,
            image: item.image || null,
            value: value,
            ocrValue: item.ocrValue ? MultilineParser.parse(item.ocrValue) : value,
            dataType: item.dataType || null,
            pageNumber: item.pageNumber || null
        };
    };

    return Field;
});
},
'ocr/parser/Multiline':function(){
define([], function() {
    return {
        parse: function (value) {
            return value.replace(/[\t\r\n\v\f]/g, ' ');
        }
    };
});
},
'api/doccontrol/template/data/Template':function(){
define([], function() {
    const Template = function() {
        this.templatePK = null;
        this.reference = null;
        this.version = null;
        this.description = null;
        this.name = null;
        this.fieldDefinitionRevision = null;
        this.projectStageTreeView = null;
        this.projectStageTreeViewPath = null;
        this.personCreated = null;
        this.personModified = null;
        this.fieldCollection = [];
        this.timeCreated = null;
        this.timeModified = null;
        this.organisation = null;
        this.documentType = null;
    };

    Template.prototype.setTemplatePK = function(templatePK) {
        this.templatePK = templatePK;
    };

    Template.prototype.getTemplatePK = function() {
        return this.templatePK;
    };

    Template.prototype.setReference = function(reference) {
        this.reference = reference;
    };

    Template.prototype.getReference = function() {
        return this.reference;
    };

    Template.prototype.setVersion = function(version) {
        this.version = version;
    };

    Template.prototype.getVersion = function() {
        return this.version;
    };

    Template.prototype.setDescription = function(description) {
        this.description = description;
    };

    Template.prototype.getDescription = function() {
        return this.description;
    };

    Template.prototype.setName = function(name) {
        this.name = name;
    };

    Template.prototype.getName = function() {
        return this.name;
    };

    Template.prototype.setFieldDefinitionRevision = function(fieldDefinitionRevision) {
        this.fieldDefinitionRevision = fieldDefinitionRevision;
        return this;
    };

    Template.prototype.getFieldDefinitionRevision = function() {
        return this.fieldDefinitionRevision;
    };

    Template.prototype.setProjectStageTreeView = function(projectStageTreeView) {
        this.projectStageTreeView = projectStageTreeView;
        return this;
    };

    Template.prototype.getProjectStageTreeView = function() {
        return this.projectStageTreeView;
    };

    Template.prototype.setProjectStageTreeViewPath = function(projectStageTreeViewPath) {
        this.projectStageTreeViewPath = projectStageTreeViewPath;
        return this;
    };

    Template.prototype.getProjectStageTreeViewPath = function() {
        return this.projectStageTreeViewPath;
    };

    Template.prototype.setPersonCreated = function(personCreated) {
        this.personCreated = personCreated;
    };

    Template.prototype.getPersonCreated = function() {
        return this.personCreated;
    };

    Template.prototype.setPersonModified = function(personModified) {
        this.personModified = personModified;
    };

    Template.prototype.getPersonModified = function() {
        return this.personModified;
    };

    Template.prototype.setFieldCollection = function(fieldCollection) {
        this.fieldCollection = fieldCollection;
    };

    Template.prototype.addField = function(field) {
        this.fieldCollection.push(field);
    };

    Template.prototype.getFieldCollection = function() {
        return this.fieldCollection;
    };

    Template.prototype.setTimeCreated = function(timeCreated) {
        this.timeCreated = timeCreated;
    };

    Template.prototype.getTimeCreated = function() {
        return this.timeCreated;
    };

    Template.prototype.setTimeModified = function(timeModified) {
        this.timeModified = timeModified;
    };

    Template.prototype.getTimeModified = function() {
        return this.timeModified;
    };

    Template.prototype.setOrganisation = function(organisation) {
        this.organisation = organisation;
    };

    Template.prototype.getOrganisation = function() {
        return this.organisation;
    };

    Template.prototype.setDocumentType = function(documentType) {
        this.documentType = documentType;
    };

    Template.prototype.getDocumentType = function() {
        return this.documentType;
    };

    return Template;
});

},
'api/organisation/parser/Organisation':function(){
define([
    "spencer/core/data/Organisation"
], function(OrganisationVO) {
    return class Organisation {
        parse(item) {
            const o = new OrganisationVO();

            o.setOrganisationPK(item.organisationPK || null);
            o.setName(item.name || null);
            o.setPreferredName(item.preferredName || null);
            o.setDescription(item.description || null);
            o.setWebsite(item.website || null);

            return o;
        };
    }
});

},
'api/doccontrol/template/parser/DocumentType':function(){
define ([
    '../data/DocumentType'
], function(
    DocumentTypeVO
) {
    return class DocumentType {
        parse(item) {
            return new DocumentTypeVO(
                item.documentTypePK || null,
                item.type || null
            )
        }
    }
});
},
'api/doccontrol/template/data/DocumentType':function(){
define([], function() {
    return class DocumentType {
        constructor(documentTypePK, type) {
            this.documentTypePK = documentTypePK;
            this.type = type
        }

        getDocumentTypePK() {
            return this.documentTypePK;
        }

        getType() {
            return this.type;
        }
    }
});
},
'api/doccontrol/template/parser/TemplateCollection':function(){
define([
    './Template',
], function(TemplateParser) {
    return class TemplateCollection {
        constructor() {
            this.templateParser = new TemplateParser();
        }

        parse(templates) {
            return {
                templateCollection: templates.templateCollection.map((template) => this.templateParser.parse(template)),
                count: templates.count
            };
        }
    }
});
},
'api/doccontrol/template/parser/MetaDataCollection':function(){
define([
    './MetaData'
], function(MetaDataParser) {
    return class MetaDataCollection {
        constructor() {
            this.metaDataParser = new MetaDataParser();
        }

        parse(metaDataCollection) {
            return metaDataCollection.map((metaData) => this.metaDataParser.parse(metaData));
        }
    }
});
},
'api/doccontrol/template/parser/MetaData':function(){
define([
    'spencer/doc-control/template/revision/data/Metadata'
], function(
    MetaDataVO
) {
    return class MetaData {
        parse(item) {
            const metaData = new MetaDataVO();
            metaData.setTemplateFieldPK(item.templateFieldPK || null);
            metaData.setName(item.name || null);
            metaData.setValue(item.value || null);
            metaData.setMd5(item.md5 || null);

            return metaData;
        }
    }
});
},
'spencer/doc-control/template/revision/data/Metadata':function(){
define([], function() {
    return class Metadata {
        constructor(md5, templateFieldPK, name, value, image, ocrValue) {
            this.md5 = md5 || null;
            this.templateFieldPK = templateFieldPK || null;
            this.name = name || null;
            this.value = value || '';
            this.ocrValue = ocrValue || '';
            this.image = image || null;
        }

        setMd5(md5) {
            this.md5 = md5;
            return this;
        }

        getMd5() {
            return this.md5;
        }

        setTemplateFieldPK(templateFieldPK) {
            this.templateFieldPK = templateFieldPK;
            return this;
        }

        getTemplateFieldPK() {
            return this.templateFieldPK;
        }

        setName(name) {
            this.name = name;
            return this;
        }

        getName() {
            return this.name;
        }

        setValue(value) {
            this.value = value;
            return this;
        }

        getValue() {
            return this.value;
        }

        setOCRValue(ocrValue) {
            this.ocrValue = ocrValue;
            return this;
        }

        getOCRValue() {
            return this.ocrValue;
        }

        setImage(image) {
            this.image = image;
            return this;
        }

        getImage() {
            return this.image;
        }
    }
});
},
'api/doccontrol/template/revision/MetaData':function(){
define([], function() {
    return class MetaData {
        constructor(url, urlConnection, parser, urlResponseProcessorBuilder) {
            this.url = url;
            this.urlConnection = urlConnection;
            this.parser = parser;
            this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        }

        save(handlers, metaDataCollection) {
            const urlConnection = this.urlConnection;

            urlConnection.setUrl(this.url);
            urlConnection.setData(this._createQuery(metaDataCollection));
            urlConnection.setSuccessHandler(handlers.getSuccess());
            urlConnection.setProgressHandler(handlers.getProgress());
            urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
            urlConnection.setErrorHandler(handlers.getError());

            return urlConnection.post();
        }

        get(handlers, md5) {
            const urlConnection = this.urlConnection;

            urlConnection.setUrl(this.url);
            urlConnection.setQuery({'md5': md5})
            urlConnection.setSuccessHandler(
                this.urlResponseProcessorBuilder.createProcessor(
                    this.parser,
                    handlers.getSuccess(),
                    handlers.getError()
                )
            );
            urlConnection.setProgressHandler(handlers.getProgress());
            urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
            urlConnection.setErrorHandler(handlers.getError());

            return urlConnection.get();
        }

        _createQuery(data) {
            const q = {};

            q['metadata'] = JSON.stringify(data.map(metaData => {
                return {
                    'md5': metaData.getMd5(),
                    'templateFieldPK': metaData.getTemplateFieldPK(),
                    'value': metaData.getValue(),
                    'ocrValue': metaData.getOCRValue()
                };
            }));

            return q;
        }
    }
});
},
'api/person/PeopleCollection':function(){
define([], function() {
    const PeopleCollection = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this.limit = 10;
        this.offset = 0;
        this.query = null;
        this.personType = null;
        this.filterField = 'name';
        this.includeLabour = null;
        this.includeInactive = null;

        this.constants = {
            URL_PARAM_QUERY: 'search',
            URL_PARAM_LIMIT: 'limit',
            URL_PARAM_OFFSET: 'offset',
            URL_PARAM_PERSON_TYPES: 'personTypes',
            URL_PARAM_FILTER_FIELD: 'field',
            URL_PARAM_INCLUDE_LABOUR: 'includeLabour',
            URL_PARAM_INCLUDE_INACTIVE: 'includeInactive'
        };

        this.createBasicQuery = function() {
            const q = {};

            q[this.constants.URL_PARAM_LIMIT] = this.limit;
            q[this.constants.URL_PARAM_OFFSET] = this.offset;
            q[this.constants.URL_PARAM_FILTER_FIELD] = this.filterField;

            if (this.query && this.query !== ''){
                q[this.constants.URL_PARAM_QUERY] = this.query;
            }

            if (this.personType !== null) {
                q[this.constants.URL_PARAM_PERSON_TYPES] = this.personType;
            }

            if (this.includeLabour !== null) {
                q[this.constants.URL_PARAM_INCLUDE_LABOUR] = this.includeLabour ? 1 : 0;
            }

            if (this.includeInactive !== null) {
                q[this.constants.URL_PARAM_INCLUDE_INACTIVE] = this.includeInactive ? 1 : 0;
            }

            return q;
        };

        this.urlConnection.setUrl(this.url);
    };

    PeopleCollection.prototype.setLimit = function(limit) {
        this.limit = limit;
    };

    PeopleCollection.prototype.setOffset = function(offset) {
        this.offset = offset;
    };

    PeopleCollection.prototype.setQuery = function(query) {
        this.query = query;
    };

    PeopleCollection.prototype.setPersonType = function(personType) {
        this.personType = personType;
    };

    PeopleCollection.prototype.setFilterField = function(filterField) {
        this.filterField = filterField;
    };

    PeopleCollection.prototype.setIncludeLabour = function(includeLabour) {
        this.includeLabour = includeLabour;
    };

    PeopleCollection.prototype.setIncludeInactive = function(includeInactive) {
        this.includeInactive = includeInactive;
    };

    PeopleCollection.prototype.fetch = function(handlers) {
        this.urlConnection.setQuery(this.createBasicQuery());
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return PeopleCollection;
});
},
'api/doccontrol/tree/node/Factory':function(){
define([
    './AvailableStatusCollection',
    './Detector',
    './FunctionNodeLocationFinder',
    './Node',
    './Path',
    './PathCollection',
    './parser/SuggestedNode',
    'library/request/fetch/Factory',
    'spencer/parse/JSONParser',
    'spencer/parse/NullParser',
    'spencer/parse/Collection',
    'spencer/doc-control/parser/Revision',
    'spencer/doc-control/parser/Status',
    '@lib/api/doc-control/tree/parser/Node',
    '@lib/api/project/parser/ProjectStage'
], function(
    AvailableStatusCollection,
    Detector,
    FunctionNodeLocationFinder,
    Node,
    Path,
    PathCollection,
    SuggestedNodeParser,
    FetchFactory,
    JSONParser,
    NullParser,
    CollectionParser,
    RevisionParser,
    StatusParser,
    NodeParser,
    ProjectStageParser
) {
    const Factory = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Factory.prototype.getDetector = function() {
        return new Detector(
            this.config.getUrl('api_doc_control_tree_node_detector', 'v2/'),
            new CollectionParser(new SuggestedNodeParser()),
            new FetchFactory()
        );
    };

    Factory.prototype.getFunctionNodeLocationFinder = function() {
        return new FunctionNodeLocationFinder(
            this.config.getUrl('api_doc_control_tree_node_function_node_finder', 'v2/'),
            new FetchFactory(),
            new NodeParser()
        );
    };

    Factory.prototype.getNode = function() {
        return new Node(
            this.config.getUrl('api_doc_control_tree_node', 'v2/'),
            new NodeParser(
                new RevisionParser(),
                new ProjectStageParser()
            ),
            new FetchFactory()
        );
    };

    Factory.prototype.getPath = function() {
        return new Path(
            this.config.getUrl('api_doc_control_tree_node_path', 'v2/'),
            this.urlConnectionBuilder.build(),
            new JSONParser(
                new NullParser()
            ),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getPathCollection = function() {
        return new PathCollection(
            this.config.getUrl('api_doc_control_tree_node_path_collection', 'v2/'),
            this.urlConnectionBuilder.build(),
            new JSONParser(
                new NullParser()
            ),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getAvailableStatusCollection = function() {
        return new AvailableStatusCollection(
            this.config.getUrl('api_doc_control_tree_node_available_status_collection', 'v2/'),
            this.urlConnectionBuilder.build(),
            new JSONParser(
                new CollectionParser(
                    new StatusParser()
                )
            ),
            this.urlResponseProcessorBuilder
        );
    };

    return Factory;
});
},
'api/doccontrol/tree/node/AvailableStatusCollection':function(){
define([], function() {
    return class AvailableStatusCollection {
        constructor(url, connection, parser, urlResponseProcessorBuilder) {
            this.url = url;
            this.connection = connection;
            this.parser = parser;
            this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;

            this.availableFilters = {
                ONLY_REVISIONABLE: 'onlyRevisionable'
            };
            this.filters = {};
        };

        onlyRevisionable() {
            this.filters[this.availableFilters.ONLY_REVISIONABLE] = true;
            return this;
        }

        fetch(handlers, projectStagePK, projectStageTreeViewPK) {
            this.connection.setUrl(
                this.url
                    .replace(':projectStagePK', projectStagePK)
                    .replace(':projectStageTreeViewPK', projectStageTreeViewPK)
            );

            this.connection.setQuery(this.filters);

            this.connection.setSuccessHandler(
                this.urlResponseProcessorBuilder.createProcessor(
                    this.parser,
                    handlers.getSuccess(),
                    handlers.getError()
                )
            );

            this.connection.setUnauthorisedHandler(handlers.getUnauthorised());
            this.connection.setProgressHandler(handlers.getProgress());
            this.connection.setErrorHandler(handlers.getError());
            this.connection.setAbortHandler(handlers.getAbort());

            return this.connection.get();
        }
    }
});
},
'api/doccontrol/tree/node/Detector':function(){
define(['library/request/data/HTTPResponseCodes'], function(HTTPResponseCodes) {
    return class Detector {
        constructor(url, parser, fetchFactory) {
            this.url = url;
            this.parser = parser;
            this.fetchFactory = fetchFactory;
        }

        get(handlers, md5, projectStagePK) {
            const fetchProcessor = this.fetchFactory.get();
            fetchProcessor.setSuccessHandler(async response => {
                handlers.getSuccess()(this.parser.parse(await response.json()));
            });
            fetchProcessor.setHandler(HTTPResponseCodes.accepted, handlers.getAccepted());
            fetchProcessor.setErrorHandler(handlers.getError());

            fetchProcessor.get(this.url.replace(':md5', md5).replace(':projectStagePK', projectStagePK))
                .catch(e => {
                    if (!fetchProcessor.isCancelled()) handlers.getError()?.(e);
                    if (fetchProcessor.isCancelled()) handlers.getAbort()?.(e);
                });

            return fetchProcessor;
        }
    }
});
},
'api/doccontrol/tree/node/FunctionNodeLocationFinder':function(){
define(['library/request/data/HTTPResponseCodes'], function(HTTPResponseCodes) {
    return class FunctionNodeLocationFinder {
        constructor(url, fetchFactory, parser) {
            this.url = url;
            this.fetchFactory = fetchFactory;
            this.parser = parser;
        }

        get(handlers, projectStagePK, projectStageTreeViewPK, nodeReference) {
            const fetchProcessor = this.fetchFactory.get();
            fetchProcessor.setSuccessHandler(async response => {
                handlers.getSuccess()(this.parser.parse(await response.json()));
            });
            fetchProcessor.setErrorHandler(handlers.getError());
            fetchProcessor.setHandler(HTTPResponseCodes.reset_content, handlers.getResetContent());

            fetchProcessor.get(this.url + this._createQuery(projectStagePK, projectStageTreeViewPK, nodeReference));

            return fetchProcessor;
        }

        _createQuery(projectStagePK, projectStageTreeViewPK, nodeReference) {
            const q = {
                projectStagePK: projectStagePK,
                projectStageTreeViewPK: projectStageTreeViewPK
            };

            if (nodeReference) q['nodeReference'] = nodeReference;

            return '?' + new URLSearchParams(q).toString();
        }
    }
});
},
'api/doccontrol/tree/node/Node':function(){
/// <amd-dependency path="library/response/error/Forbidden" name="ForbiddenError" />
define(["require", "exports", "library/response/error/Forbidden", "library/request/data/HTTPResponseCodes"], function (require, exports, ForbiddenError, HTTP_RESPONSE_CODES) {
    "use strict";
    class Node {
        constructor(url, nodeParser, fetchFactory) {
            this.url = url;
            this.nodeParser = nodeParser;
            this.fetchFactory = fetchFactory;
            this.fetchProcessor = fetchFactory.get();
        }
        get(projectStagePK, projectStageTreeViewPK) {
            const url = this.url.replace(':projectStagePK', projectStagePK.toString())
                .replace(':treeViewPK', projectStageTreeViewPK.toString());
            this.fetchProcessor.setSuccessHandler(async (response) => {
                const data = await response.json();
                return this.nodeParser.parse(data);
            });
            this.fetchProcessor.setHandler(HTTP_RESPONSE_CODES.forbidden, () => {
                throw new ForbiddenError();
            });
            return this.fetchProcessor.get(url);
        }
    }
    return Node;
});

},
'library/response/error/Forbidden':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Forbidden extends Error {
    }
    return Forbidden;
});

},
'api/doccontrol/tree/node/Path':function(){
define([
    'spencer/doc-control/tree/data/Node',
    '@lib/doc-control/tree/data/Node'
], function(
    LibraryNode,
    LegacyNode
) {
    const Node = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.parser = parser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Node.prototype.get = function(handlers, node, includeProjectStageTitle) {
        if(node instanceof LegacyNode) {
            this.urlConnection.setUrl(
                this.url
                    .replace(':projectStagePK', node.getProjectStagePK())
                    .replace(':projectStageTreeViewPK', node.getProjectStageTreeViewPK())
            );
        }

        if(node instanceof LibraryNode) {
            this.urlConnection.setUrl(
                this.url
                    .replace(':projectStagePK', node.getProjectStage().getProjectStagePK())
                    .replace(':projectStageTreeViewPK', node.getProjectStageTreeViewPK())
            );
        }

        if (includeProjectStageTitle !== undefined) {
            this.urlConnection.setQuery({
                includeProjectStageTitle: includeProjectStageTitle
            });
        }

        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return Node;
});
},
'api/doccontrol/tree/node/PathCollection':function(){
define([], function() {
    const PathCollection = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.parser = parser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    PathCollection.prototype.get = function(handlers, nodes, includeProjectStageTitle) {
        this.urlConnection.setUrl(this.url);
        this.urlConnection.setQuery({
            includeProjectStageTitle: includeProjectStageTitle
        });

        this.urlConnection.setData({"nodes": JSON.stringify(nodes)});

        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.post();
    };

    return PathCollection;
});
},
'api/doccontrol/tree/node/parser/SuggestedNode':function(){
define([
    'api/doccontrol/parser/Revision',
    '@lib/api/doc-control/tree/parser/Node',
    '@lib/api/project/parser/ProjectStage',
    '@lib/doc-control/tree/data/SuggestedNode'
], function(
    RevisionParser,
    NodeParser,
    ProjectStageParser,
    SuggestedNodeVO
) {
    return class SuggestedNode {
        constructor() {
            this.nodeParser = new NodeParser(new RevisionParser(), new ProjectStageParser());
        }

        parse(item) {
            return new SuggestedNodeVO()
                .setFolderName(item.topLevelFolderName || null)
                .setNode(item.node ? this.nodeParser.parse(item.node) : null)
                .setConfidence(item.confidence || 0);
        }
    }
});
},
'@lib/doc-control/tree/data/SuggestedNode':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class SuggestedNode {
        constructor() {
            this.folderName = null;
            this.node = null;
            this.confidence = 0;
            this.checked = false;
        }
        setFolderName(folderName) {
            this.folderName = folderName;
            return this;
        }
        getFolderName() {
            return this.folderName;
        }
        setNode(node) {
            this.node = node;
            return this;
        }
        getNode() {
            return this.node;
        }
        setConfidence(confidence) {
            this.confidence = confidence;
            return this;
        }
        getConfidence() {
            return this.confidence;
        }
    }
    return SuggestedNode;
});

},
'spencer/parse/NullParser':function(){
define([], function() {
    const NullParser = function() {};

    NullParser.prototype.parse = function(content) {
        return content;
    };

    return NullParser;
});
},
'api/doccontrol/tree/node/Config':function(){
define([
    'api/Config'
], function(apiConfig) {
    const Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_doc_control_tree_node = 'doc-control/tree/:projectStagePK/node/:treeViewPK';
        this.api_doc_control_tree_node_detector = 'doc-control/document/:md5/projectStagePK/:projectStagePK/node/detector';
        this.api_doc_control_tree_node_function_node_finder = 'doc-control/tree/function-node-location-finder';
        this.api_doc_control_tree_node_path = 'doc-control/tree/:projectStagePK/node/:projectStageTreeViewPK/path';
        this.api_doc_control_tree_node_path_collection = 'doc-control/tree/node/path';
        this.api_doc_control_tree_node_available_status_collection = 'doc-control/tree/:projectStagePK/node/:projectStageTreeViewPK/available-status'
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});

},
'api/file/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    const Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_temporary = 'file/temporary/';
        this.api_unzip = 'file/:md5/unzip';
        this.api_preview = 'file/:md5/preview';
        this.api_extraction_unzip = 'doc-control/extraction/:md5/unzip';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});

},
'api/file/Factory':function(){
define([
    "@lib/api/doc-control/file/Unzip",
    "@lib/doc-control/parser/File",
    "../parser/Collection",
    "../parser/NullParser",
    "./TemporaryUploader",
    "./parser/TemporaryFileResult",
    "./Previewer",
    "library/request/fetch/Factory"
], function(
    Unzipper,
    FileParser,
    CollectionParser,
    NullParser,
    TemporaryUploader,
    KeyParser,
    Previewer,
    FetchFactory
) {
    const Factory = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Factory.prototype.getTemporaryUploader = function() {
        return new TemporaryUploader(
            this.config.getUrl('api_temporary'),
            this.urlConnectionBuilder,
            new CollectionParser(new KeyParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getPreviewer = function() {
        return new Previewer(
            this.config.getUrl('api_preview', 'v2/'),
            this.urlConnectionBuilder.build(),
            this.urlResponseProcessorBuilder,
            new NullParser()
        );
    };

    Factory.prototype.getUnzipper = function() {
        return new Unzipper(
            new FetchFactory(),
            new FileParser(),
            this.config.getUrl('api_extraction_unzip', 'v2/'),
        );
    };

    return Factory;
});

},
'@lib/api/doc-control/file/Unzip':function(){
define(["require", "exports", "@lib/request/data/HTTPResponseCodes"], function (require, exports, HTTPResponseCodes) {
    "use strict";
    class Unzip {
        constructor(fetchFactory, parser, url) {
            this.fetchFactory = fetchFactory;
            this.parser = parser;
            this.url = url;
        }
        async fetch(md5) {
            const fetchWrapper = this.fetchFactory.get();
            fetchWrapper.setSuccessHandler(async (response) => {
                const data = await response.json();
                return data.map(file => this.parser.parse(file));
            });
            fetchWrapper.setHandler(HTTPResponseCodes.content_too_large, async (response) => {
                const data = await response.json();
                throw new Error(data.error);
            });
            return fetchWrapper.get(this.url.replace(':md5', md5));
        }
    }
    return Unzip;
});

},
'@lib/doc-control/parser/File':function(){
define(["require", "exports", "@lib/doc-control/data/File"], function (require, exports, FileVO) {
    "use strict";
    class Parser {
        parse(data) {
            return new FileVO(data.name, data.md5, data.size, data.type, data.location);
        }
    }
    return Parser;
});

},
'@lib/doc-control/data/File':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class File {
        constructor(name, md5, size, type, location) {
            this.name = name;
            this.md5 = md5;
            this.size = size;
            this.type = type;
            this.location = location;
        }
        getName() {
            return this.name;
        }
        getMd5() {
            return this.md5;
        }
        getSize() {
            return this.size;
        }
        getType() {
            return this.type;
        }
        getLocation() {
            return this.location;
        }
    }
    return File;
});

},
'api/parser/NullParser':function(){
define([], function() {
    const NullParser = function() {};

    NullParser.prototype.parse = function(result) {
        return result;
    };

    return NullParser;
});

},
'api/file/TemporaryUploader':function(){
define([], function() {
    const TemporaryUploader = function(url, urlConnectionBuilder, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    TemporaryUploader.prototype.upload = function(handlersVO, form) {
        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url);

        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlersVO.getSuccess(),
                handlersVO.getError()
            )
        );
        urlConnection.setProgressHandler(handlersVO.getProgress());
        urlConnection.setUnauthorisedHandler(handlersVO.getUnauthorised());
        urlConnection.setErrorHandler(handlersVO.getError());
        urlConnection.setForm(form);

        return urlConnection.post();
    };

    return TemporaryUploader;
});
},
'api/file/parser/TemporaryFileResult':function(){
define([
    '../data/TemporaryFileResult'
], function(TemporaryFileResultData) {
    const TemporaryFileResult = function() {};

    TemporaryFileResult.prototype.parse = function(item) {
        const vo = new TemporaryFileResultData();
        vo.setKey(item.key || null);
        vo.setDocumentPK(item.documentPK || null);
        vo.setDocumentLocationPK(item.documentLocationPK || null);
        vo.setFileName(item.fileName || false);
        vo.setFileSize(item.fileSize || null);
        vo.setFileType(item.fileType || null);
        vo.setRevisionPK(item.revisionPK || false);
        vo.setIsPrivate(item.isPrivate || false);
        vo.setIsRegistered(item.isRegistered || false);
        vo.setMD5(item.md5 || null);
        vo.setRevisionReference(item.revisionReference || null);
        vo.setRevisionNumber(item.revisionNumber || null);
        vo.setRevisionStatusPK(item.statusPK || null);
        vo.setRevisionStatusDescription(item.statusDescription || null);
        vo.setRevisionStatusDocumentType(item.statusDocumentType || null);
        vo.setProjectStagePK(item.projectStagePK || null);
        vo.setProjectStageTitle(item.projectStageTitle || null);
        vo.setProjectStageNumber(item.projectStageNumber || null);
        vo.setProjectStageTreeViewPK(item.projectStageTreeViewPK || null);
        vo.setProjectStageTreeViewName(item.projectStageTreeViewName || null);
        vo.setProjectStageTreeViewType(item.projectStageTreeViewType || null);
        vo.setProjectStageTreeViewIsRevisionable(item.projectStageTreeViewIsRevisionable || false);

        if (item.error) {
            if (item.error instanceof Array) {
                for (let i in item.error) {
                    vo.addError(item.error[i] || null);
                }
            } else {
                vo.addError(item.error);
            }
        }

        return vo;
    };

    return TemporaryFileResult;
});
},
'api/file/data/TemporaryFileResult':function(){
define([], function() {
    const TemporaryFileResult = function() {
        this.key = null;
        this.documentPK = null;
        this.documentLocationPK = null;
        this.fileName = false;
        this.fileSize = null;
        this.fileType = null;
        this.revisionPK = false;
        this.isPrivateValue = false;
        this.isRegisteredValue = false;
        this.md5 = null;
        this.revisionReference = null;
        this.revisionNumber = null;
        this.revisionStatusPK = null;
        this.revisionStatusDescription = null;
        this.revisionStatusDocumentType = null;
        this.projectStage = null;
        this.projectStagePK = null;
        this.projectStageTitle = null;
        this.projectStageNumber = null;
        this.projectStageTreeViewPK = null;
        this.projectStageTreeViewName = null;
        this.projectStageTreeViewType = null;
        this.projectStageTreeViewIsRevisionable = false;
        this.registrationDetails = null;
        this.errors = [];
    };

    TemporaryFileResult.prototype.getKey = function() {
        return this.key;
    };

    TemporaryFileResult.prototype.setKey = function(key) {
        this.key = key;
        return this;
    };

    TemporaryFileResult.prototype.getDocumentPK = function() {
        return this.documentPK;
    };

    TemporaryFileResult.prototype.setDocumentPK = function(documentPK) {
        this.documentPK = documentPK;
        return this;
    };

    TemporaryFileResult.prototype.getDocumentLocationPK = function() {
        return this.documentLocationPK;
    };

    TemporaryFileResult.prototype.setDocumentLocationPK = function(documentLocationPK) {
        this.documentLocationPK = documentLocationPK;
        return this;
    };

    TemporaryFileResult.prototype.getFileName = function() {
        return this.fileName;
    };

    TemporaryFileResult.prototype.setFileName = function(fileName) {
        this.fileName = fileName;
        return this;
    };

    TemporaryFileResult.prototype.getFileSize = function() {
        return this.fileSize
    };

    TemporaryFileResult.prototype.setFileSize = function(fileSize) {
        this.fileSize = fileSize;
        return this;
    };

    TemporaryFileResult.prototype.getFileType = function() {
        return this.fileType;
    };

    TemporaryFileResult.prototype.setFileType = function(fileType) {
        this.fileType = fileType;
        return this;
    };

    TemporaryFileResult.prototype.getRevisionPK = function() {
        return this.revisionPK;
    };

    TemporaryFileResult.prototype.setRevisionPK = function(revisionPK) {
        this.revisionPK = revisionPK;
        return this;
    };

    TemporaryFileResult.prototype.isPrivate = function() {
        return this.isPrivateValue;
    };

    TemporaryFileResult.prototype.setIsPrivate = function(isPrivate) {
        this.isPrivateValue = isPrivate;
        return this;
    };

    TemporaryFileResult.prototype.isRegistered = function() {
        return this.isRegisteredValue;
    };

    TemporaryFileResult.prototype.setIsRegistered = function(isRegistered) {
        this.isRegisteredValue = isRegistered;
        return this;
    };

    TemporaryFileResult.prototype.getMD5 = function() {
        return this.md5;
    };

    TemporaryFileResult.prototype.setMD5 = function(md5) {
        this.md5 = md5;
        return this;
    };

    TemporaryFileResult.prototype.getRevisionReference = function() {
        return this.revisionReference;
    };

    TemporaryFileResult.prototype.setRevisionReference = function(revisionReference) {
        this.revisionReference = revisionReference;
        return this;
    };

    TemporaryFileResult.prototype.getRevisionNumber = function() {
        return this.revisionNumber;
    };

    TemporaryFileResult.prototype.setRevisionNumber = function(revisionNumber) {
        this.revisionNumber = revisionNumber;
        return this;
    };

    TemporaryFileResult.prototype.getRevisionStatusPK = function() {
        return this.revisionStatusPK;
    };

    TemporaryFileResult.prototype.setRevisionStatusPK = function(statusPK) {
        this.revisionStatusPK = statusPK;
        return this;
    };

    TemporaryFileResult.prototype.getRevisionStatusDescription = function() {
        return this.revisionStatusDescription;
    };

    TemporaryFileResult.prototype.setRevisionStatusDescription = function(description) {
        this.revisionStatusDescription = description;
        return this;
    };

    TemporaryFileResult.prototype.getRevisionStatusDocumentType = function() {
        return this.revisionStatusDocumentType;
    };

    TemporaryFileResult.prototype.setRevisionStatusDocumentType = function(documentType) {
        this.revisionStatusDocumentType = documentType;
        return this;
    };

    TemporaryFileResult.prototype.getProjectStage = function() {
        return this.projectStage;
    };

    TemporaryFileResult.prototype.setProjectStage = function(projectStage) {
        this.projectStage = projectStage;
        return this;
    };

    TemporaryFileResult.prototype.getProjectStagePK = function() {
        return this.projectStagePK;
    };

    TemporaryFileResult.prototype.setProjectStagePK = function(projectStagePK) {
        this.projectStagePK = projectStagePK;
        return this;
    };

    TemporaryFileResult.prototype.getProjectStageTitle = function() {
        return this.projectStageTitle;
    };

    TemporaryFileResult.prototype.setProjectStageTitle = function(projectStageTitle) {
        this.projectStageTitle = projectStageTitle;
        return this;
    };

    TemporaryFileResult.prototype.getProjectStageNumber = function() {
        return this.projectStageNumber;
    };

    TemporaryFileResult.prototype.setProjectStageNumber = function(projectStageNumber) {
        this.projectStageNumber = projectStageNumber;
        return this;
    };

    TemporaryFileResult.prototype.getProjectStageTreeViewName = function() {
        return this.projectStageTreeViewName;
    };

    TemporaryFileResult.prototype.setProjectStageTreeViewName = function(projectStageTreeViewName) {
        this.projectStageTreeViewName = projectStageTreeViewName;
        return this;
    };

    TemporaryFileResult.prototype.getProjectStageTreeViewPK = function() {
        return this.projectStageTreeViewPK;
    };

    TemporaryFileResult.prototype.setProjectStageTreeViewPK = function(projectStageTreeViewPK) {
        this.projectStageTreeViewPK = projectStageTreeViewPK;
        return this;
    };

    TemporaryFileResult.prototype.getProjectStageTreeViewType = function() {
        return this.projectStageTreeViewType;
    };

    TemporaryFileResult.prototype.setProjectStageTreeViewType = function(projectStageTreeViewType) {
        this.projectStageTreeViewType = projectStageTreeViewType;
        return this;
    };

    TemporaryFileResult.prototype.isProjectStageTreeViewRevisionable = function() {
        return this.projectStageTreeViewIsRevisionable;
    };

    TemporaryFileResult.prototype.setProjectStageTreeViewIsRevisionable = function(projectStageTreeViewIsRevisionable) {
        this.projectStageTreeViewIsRevisionable = projectStageTreeViewIsRevisionable;
        return this;
    };

    TemporaryFileResult.prototype.getRegistrationDetails = function() {
        return this.registrationDetails;
    };

    TemporaryFileResult.prototype.setRegistrationDetails = function(registrationDetails) {
        this.registrationDetails = registrationDetails;
        return this;
    };

    TemporaryFileResult.prototype.getErrors = function() {
        return this.errors;
    };

    TemporaryFileResult.prototype.addError = function(error) {
        this.errors.push(error);
        return this;
    };

    return TemporaryFileResult;
});
},
'api/file/Previewer':function(){
define([], function() {
    const ProjectStage = function(
        url,
        connection,
        urlResponseProcessorBuilder,
        parser
    ) {
        this.url = url;
        this.connection = connection;
        this.parser = parser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    ProjectStage.prototype.get = function(handlers, md5) {
        this.connection.setUrl(
            this.url.replace(':md5', md5)
        );

        this.connection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.connection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.connection.setProgressHandler(handlers.getProgress());
        this.connection.setErrorHandler(handlers.getError());
        this.connection.setAbortHandler(handlers.getAbort());

        return this.connection.get();
    };

    return ProjectStage;
});

},
'api/file-tray/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    var Config = function () {
        this.base = apiConfig;
        this.base();

        this.api_file_tray = 'file-tray/';
        this.api_file_tray_item = 'file-tray_item/';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});

},
'api/file-tray/Factory':function(){
define([
    '../parser/Collection',
    './Item',
    './ItemCollection',
    './FileTray',
    'spencer/file-tray/parser/Item'
], function(
    CollectionParser,
    Item,
    ItemCollection,
    FileTray,
    ItemParser
) {
    var Factory = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Factory.prototype.getItem = function() {
        return new Item(
            this.config.getUrl('api_file_tray_item'),
            this.urlConnectionBuilder,
            new CollectionParser(new ItemParser()).setIsSingleItemCollection(true),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getItemCollection = function() {
        return new ItemCollection(
            this.config.getUrl('api_file_tray_item'),
            this.urlConnectionBuilder,
            new CollectionParser(new ItemParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getFileTray = function() {
        return new FileTray(
            this.config.getUrl('api_file_tray'),
            this.urlConnectionBuilder
        );
    };

    return Factory;
});

},
'api/file-tray/Item':function(){
define([], function() {
    var Item = function(url, urlConnectionBuilder, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.parser = parser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;

        this.constants = {
            URL_PARAM_MD5: 'md5'
        };
    };

    Item.prototype.add = function(handlers, md5) {
        var urlConnection = this.urlConnectionBuilder.build();

        var data = {};
        data[this.constants.URL_PARAM_MD5] = md5;

        urlConnection.setUrl(this.url);
        urlConnection.setData(data);
        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.put();
    };

    Item.prototype.remove = function(handlers, id) {
        var urlConnection = this.urlConnectionBuilder.build();

        urlConnection.setUrl(this.url + id);
        urlConnection.setSuccessHandler(handlers.getSuccess());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.del();
    };

    return Item;
});
},
'api/file-tray/ItemCollection':function(){
define([], function() {
    var ItemCollection = function(url, urlConnectionBuilder, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.parser = parser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    ItemCollection.prototype.fetch = function(handlers) {
        var urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url);
        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    return ItemCollection;
});
},
'api/file-tray/FileTray':function(){
define([], function() {
    var FileTray = function(url, urlConnectionBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
    };

    FileTray.prototype.removeAllItems = function(handlers) {
        var urlConnection = this.urlConnectionBuilder.build();

        urlConnection.setUrl(this.url);
        urlConnection.setSuccessHandler(handlers.getSuccess());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.del();
    };

    return FileTray;
});
},
'spencer/file-tray/parser/Item':function(){
define([
    '../data/Item'
], function(ItemData) {
    var Item = function() {};

    Item.prototype.parse = function(item) {
        return (new ItemData())
            .setId(item.id)
            .setType(item.type)
            .setData(item);
    };

    return Item;
});
},
'spencer/file-tray/data/Item':function(){
define([], function() {
    var Item = function() {
        this.data = {};
        this.id = null;
        this.type = null;
    };

    Item.prototype.getData = function() {
        return this.data;
    };

    Item.prototype.setData = function(data) {
        this.data = data;
        return this;
    };

    Item.prototype.getId = function() {
        return this.id;
    };

    Item.prototype.setId = function(id) {
        this.id = id;
        return this;
    };

    Item.prototype.getType = function() {
        return this.type;
    };

    Item.prototype.setType = function(type) {
        this.type = type;
        return this;
    };

    return Item;
});
},
'api/log/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    var Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_log = 'log/';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});

},
'api/log/Factory':function(){
define([
    './Logger'
], function(Logger) {
    var Factory = function(config, urlConnectionBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
    };

    Factory.prototype.getLogger = function() {
        return new Logger(
            this.config.getUrl('api_log'),
            this.urlConnectionBuilder.build()
        );
    };

    return Factory;
});

},
'api/log/Logger':function(){
define([], function() {
    var Logger = function(url, urlConnection) {
        this.urlConnection = urlConnection;
        this.urlConnection.setUrl(url);

        this.constants = {
            PARAM_ADDITIONAL_DATA: 'additionalData',
            PARAM_EXCEPTION: 'exception',
            PARAM_REQUEST: 'request',
            PARAM_STACK_TRACE: 'stackTrace'
        };

        this._buildParams = function(log) {
            var data = {};
            data[this.constants.PARAM_ADDITIONAL_DATA] = JSON.stringify(log.getAdditionalData());
            data[this.constants.PARAM_EXCEPTION] = log.getException();
            data[this.constants.PARAM_REQUEST] = log.getRequest();
            data[this.constants.PARAM_STACK_TRACE] = log.getStackTrace();
            return data;
        };
    };

    Logger.prototype.log = function(log) {
        this.urlConnection.setData(this._buildParams(log));

        return this.urlConnection.post();
    };

    return Logger;
});


},
'api/my-group/Factory':function(){
define([
    './Group',
    './GroupCollection',
    './GroupMemberCollection',
    './parser/Group',
    './parser/GroupMember',
    'spencer/parse/Collection',
    'spencer/parse/JSONParser',
    './parser/GroupCollection',
    './parser/GroupMemberCollection',
], function(
    Group,
    GroupCollection,
    GroupMemberCollection,
    GroupParser,
    GroupMemberParser,
    CollectionParser,
    JSONParser,
    GroupCollectionParser,
    GroupMemberCollectionParser
) {
    const Factory = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Factory.prototype.getMyGroupsCollection = function() {
        return new GroupCollection(
            this.config.getUrl('api_my_group', 'v2/'),
            this.urlConnectionBuilder,
            new JSONParser(new CollectionParser(new GroupParser())),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getMyGroups = function() {
        return new Group(
            this.config.getUrl('api_my_group', 'v2/'),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getMyGroupsMembersCollection = function() {
        return new GroupMemberCollection(
            this.config.getUrl('api_my_group_member', 'v2/'),
            this.urlConnectionBuilder,
            new GroupMemberCollectionParser(new GroupMemberParser()),
            this.urlResponseProcessorBuilder
        );
    };

    return Factory;
});
},
'api/my-group/Group':function(){
define([], function () {
    const Group = function (url, urlConnectionBuilder, collectionParser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.parser = collectionParser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Group.prototype.post = function(handlers, name) {
        const urlConnection = this.urlConnectionBuilder.build();

        urlConnection.setUrl(this.url);

        urlConnection.setData({
            'name': name
        });

        urlConnection.setSuccessHandler((groupPK) => handlers.getSuccess()(parseInt(groupPK)));
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.post();
    };

    Group.prototype.del = function(handlers, id) {
        const urlConnection = this.urlConnectionBuilder.build();

        urlConnection.setUrl(this.url + id);

        urlConnection.setData({
            'id': id
        });

        urlConnection.setSuccessHandler(handlers.getSuccess());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.del();
    };

    Group.prototype.patch = function(handlers, groupPK, groupName) {
        const urlConnection = this.urlConnectionBuilder.build();

        urlConnection.setUrl(this.url + groupPK);

        urlConnection.setData({
            'name': groupName
        });

        urlConnection.setSuccessHandler(handlers.getSuccess());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.patch();
    };

    return Group;
});
},
'api/my-group/GroupCollection':function(){
define([], function () {
    const PARAM_SORT_ATTR = 'sortAttr';
    const PARAM_SORT_ORDER = 'sortOrder';
    const GroupCollection = function(url, urlConnectionBuilder, collectionParser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.parser = collectionParser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;

        this.generateUrlSearchParams = function(sortAttribute, sortAscending) {
            if (!sortAttribute) return '';

            const urlSearchParams = new URLSearchParams();
            urlSearchParams.set(PARAM_SORT_ATTR, sortAttribute);
            urlSearchParams.set(PARAM_SORT_ORDER, sortAscending ? 'true' : 'false');

            return '?' + urlSearchParams.toString();
        };
    };

    GroupCollection.prototype.get = function(handlers, sortAttribute, sortAscending) {
        const urlConnection = this.urlConnectionBuilder.build();

        urlConnection.setUrl(this.url + this.generateUrlSearchParams(sortAttribute, sortAscending));
        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    GroupCollection.prototype.patch = function(handlers, groupPK, personPK) {
        const urlConnection = this.urlConnectionBuilder.build();
        urlConnection.setUrl(this.url.replace(':id', groupPK));
        urlConnection.setData({
            'name': personPK
        });
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.patch();
    };

    return GroupCollection;
});
},
'api/my-group/GroupMemberCollection':function(){
define([], function () {
    const PARAM_GROUP_PK = ':id';
    const PARAM_INCLUDE_BRANCH_OFFICES = 'includeBranchOfficeEmails';
    const PARAM_IS_ACTIVE = 'isActive';
    const PARAM_SORT_ATTR = 'sortAttr';
    const PARAM_SORT_ORDER = 'sortOrder';

    const GroupCollection = function (url, urlConnectionBuilder, collectionParser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.parser = collectionParser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;

        this.generateUrlSearchParams = function(params) {
            const urlSearchParams = new URLSearchParams();
            if (params.hasOwnProperty('includeBranchOffices')) {
                urlSearchParams.set(PARAM_INCLUDE_BRANCH_OFFICES, params.includeBranchOffices ? 'true' : 'false');
            }

            if (params.hasOwnProperty('isActive') ) {
                urlSearchParams.set(PARAM_IS_ACTIVE, params.isActive ? 'true' : 'false');
            }

            if (params.hasOwnProperty('sortAttribute')) {
                urlSearchParams.set(PARAM_SORT_ATTR, params.sortAttribute);
                urlSearchParams.set(PARAM_SORT_ORDER, params.sortAscending ? 'true' : 'false');
            }

            return '?' + urlSearchParams.toString();
        };
    };

    GroupCollection.prototype.get = function(handlers, groupPK, params = {}) {
        const urlConnection = this.urlConnectionBuilder.build();

        urlConnection.setUrl(this.url.replace(PARAM_GROUP_PK, groupPK) + this.generateUrlSearchParams(params));
        urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.get();
    };

    GroupCollection.prototype.patch = function(handlers, groupPK, personPKs, branchOfficeEmailPKs) {
        const urlConnection = this.urlConnectionBuilder.build();

        urlConnection.setUrl(this.url.replace(PARAM_GROUP_PK, groupPK));
        urlConnection.setData({
            'id': groupPK,
            'personPKs': personPKs,
            'branchOfficeEmailPKs': branchOfficeEmailPKs
        });

        urlConnection.setSuccessHandler(handlers.getSuccess());
        urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        urlConnection.setProgressHandler(handlers.getProgress());
        urlConnection.setErrorHandler(handlers.getError());

        return urlConnection.patch();
    };

    return GroupCollection;
})
},
'api/my-group/parser/Group':function(){
define([
    'spencer/core/group/data/Group'
], function(
    GroupVO
) {
    const GroupParser = function() {};

    GroupParser.prototype.parse = function(item) {
        const group = new GroupVO();

        group.setGroupPK(parseInt(item.id) || null);
        group.setName(item.name || null);

        return group;
    };

    return GroupParser;
});
},
'spencer/core/group/data/Group':function(){
define([], function(){
   var Group = function(){
        this.groupPK = null;
        this.name = null;
   };

   Group.prototype.getGroupPK = function() {
        return this.groupPK;
   };

   Group.prototype.setGroupPK = function(groupPK) {
       this.groupPK = groupPK;
   };

   Group.prototype.getName = function() {
       return this.name;
   };

   Group.prototype.setName = function(name) {
       this.name = name;
   };

   return Group;
});
},
'api/my-group/parser/GroupMember':function(){
define([
    'spencer/core/group/data/Member'
], function (
    MemberVO
) {
    const MemberParser = function () {};

    MemberParser.prototype.parse = function (item) {
        const groupMember = new MemberVO();

        groupMember.setPersonPK(parseInt(item.personPK) || null);
        groupMember.setDisplayName(item.preferredName || item.name || null);
        groupMember.setEmail(item.email || null);
        groupMember.setJobTitle(item.jobTitle || null);
        groupMember.setBranchOfficeEmailPK(parseInt(item.branchOfficeEmailPK) || null);
        groupMember.setBranchOfficePK(parseInt(item.branchOfficePK) || null);
        groupMember.setOrganisation(item.organisation || null);

        return groupMember;
    };

    return MemberParser;
});
},
'spencer/core/group/data/Member':function(){
define([], function() {
    const Member = function() {
        this.personPK = null;
        this.displayName = null;
        this.email = null;
        this.jobTitle = null;
        this.branchOfficeEmailPK = null;
        this.branchOfficePK = null;
        this.organisation = null;
    };

    Member.prototype.getPersonPK = function() {
        return this.personPK;
    };

    Member.prototype.setPersonPK = function(personPK) {
        this.personPK = personPK;
    };

    Member.prototype.getDisplayName = function() {
        return this.displayName;
    };

    Member.prototype.setDisplayName = function(displayName) {
        this.displayName = displayName;
    };

    Member.prototype.getEmail = function() {
        return this.email;
    };

    Member.prototype.setEmail = function(email) {
        this.email = email;
    };

    Member.prototype.getJobTitle = function() {
        return this.jobTitle;
    };

    Member.prototype.setJobTitle = function(jobTitle) {
        this.jobTitle = jobTitle;
    };

    Member.prototype.getBranchOfficeEmailPK = function() {
        return this.branchOfficeEmailPK;
    };

    Member.prototype.setBranchOfficeEmailPK = function(branchOfficeEmailPK) {
        this.branchOfficeEmailPK = branchOfficeEmailPK;
    };

    Member.prototype.getBranchOfficePK = function() {
        return this.branchOfficePK;
    };

    Member.prototype.setBranchOfficePK = function(branchOfficePK) {
        this.branchOfficePK = branchOfficePK;
    };

    Member.prototype.getOrganisation = function() {
        return this.organisation;
    };

    Member.prototype.setOrganisation = function(organisation) {
        this.organisation = organisation;
    };

    return Member;
});
},
'api/my-group/parser/GroupCollection':function(){
define([], function () {
    const ERROR_PARSE_JSON = 'Parse error: could not parse JSON';

    const GroupCollection = function(parser) {
        this.parser = parser;
    }

    GroupCollection.prototype.parse = function (content) {
        let jsonContent;

        try {
            jsonContent = JSON.parse(content);
        } catch(error) {
            throw new Error(ERROR_PARSE_JSON);
        }

        const parsedGroup = [];
        jsonContent.forEach(group => {
            parsedGroup.push(this.parser.parse(group));
        });

        return parsedGroup;
    }

    return GroupCollection;
})
},
'api/my-group/parser/GroupMemberCollection':function(){
define([], function () {
    const ERROR_PARSE_JSON = 'Parse error: could not parse JSON';

    const GroupMemberCollection = function(parser) {
        this.parser = parser;
    }

    GroupMemberCollection.prototype.parse = function (content) {
        let jsonContent;

        try {
            jsonContent = JSON.parse(content);
        } catch(error) {
            throw new Error(ERROR_PARSE_JSON);
        }

        const parsedGroup = [];
        jsonContent.collection.items.forEach(group => {
            parsedGroup.push(this.parser.parse(group));
        });

        return parsedGroup;
    }

    return GroupMemberCollection;
})
},
'api/my-group/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    const Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_my_group = 'my-group/';
        this.api_my_group_member = 'my-group/:id/member';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});
},
'api/organisation/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    const Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_organisation = 'organisation/';
        this.api_data_request = 'organisation/:organisationPK/data-request/';
        this.api_organisation_intranet_owner = 'organisation/intranet-owner';
        this.api_organisation_rating_collection = 'organisation/:id/rating/enquiry';
        this.api_organisation_delivery_rating_collection = 'organisation/:id/rating/delivery';
        this.api_organisation_type_collection = '/organisation/type-collection';
        this.api_organisation_person_collection = 'organisation/:organisationPK/person';
        this.api_organisation_service_collection = 'organisation/:id/service';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});

},
'api/organisation/Factory':function(){
/// <amd-dependency path="../parser/Collection" name="Collection" />
/// <amd-dependency path="./parser/Organisation" name="OrganisationParser" />
/// <amd-dependency path="./parser/DataRequest" name="RequestedDataParser" />
/// <amd-dependency path="./Creator" name="Creator" />
/// <amd-dependency path="./DataRequest" name="DataRequest" />
/// <amd-dependency path="./DataRequestCollection" name="DataRequestCollection" />
/// <amd-dependency path="./Organisation" name="Organisation" />
/// <amd-dependency path="./OrganisationCollection" name="OrganisationCollection" />
define(["require", "exports", "../parser/Collection", "./parser/Organisation", "./parser/DataRequest", "./Creator", "./DataRequest", "./DataRequestCollection", "./Organisation", "./OrganisationCollection", "@lib/api/config/routes/Organisation", "@lib/api/organisation/parser/OrganisationType", "@lib/api/organisation/parser/OrganisationTypeCollection", "@lib/api/organisation/rating/enquiry/EnquiryRating", "@lib/organisation/rating/parser/BaseRating", "@lib/organisation/rating/parser/Delivery", "@lib/api/organisation/ServiceCollection", "@lib/api/organisation/parser/Service", "@lib/api/organisation/parser/ServiceCollection", "@lib/api/organisation/TypeCollection", "@lib/api/organisation/rating/delivery/DeliveryRating", "@lib/api/organisation/HeadOffice", "@lib/api/organisation/data-request/BranchOffice", "@lib/api/organisation/data-request/Latest", "@lib/api/organisation/data-request/Person", "@lib/api/organisation/data-request/parser/DataRequest"], function (require, exports, Collection, OrganisationParser, RequestedDataParser, Creator, DataRequest, DataRequestCollection, Organisation, OrganisationCollection, ORGANISATION_URL_CONFIG, OrganisationTypeParser, OrganisationTypeCollectionParser, Rating, RatingParser, DeliveryParser, OrganisationServiceCollection, OrganisationServiceParser, OrganisationServiceCollectionParser, OrganisationTypeCollection, DeliveryRating, HeadOffice_1, BranchOffice_1, Latest_1, Person_1, DataRequest_1) {
    "use strict";
    class Factory {
        constructor(config, fetchFactory, urlConnectionBuilder, urlResponseProcessorBuilder) {
            this.config = config;
            this.fetchFactory = fetchFactory;
            this.urlConnectionBuilder = urlConnectionBuilder;
            this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        }
        getOrganisationCollection() {
            return new OrganisationCollection(this.config.getUrl('api_organisation'), this.urlConnectionBuilder.build(), new Collection(new OrganisationParser()), this.urlResponseProcessorBuilder);
        }
        getOrganisationTypeCollection() {
            return new OrganisationTypeCollection(this.config.getUrl('api_organisation_type_collection', 'v2'), this.fetchFactory, new OrganisationTypeCollectionParser(new OrganisationTypeParser()));
        }
        getCreator() {
            return new Creator(this.config.getUrl('api_organisation'), this.urlConnectionBuilder.build(), this.urlResponseProcessorBuilder);
        }
        getOrganisation() {
            const c = new Collection(new OrganisationParser());
            c.setIsSingleItemCollection(true);
            return new Organisation(this.config.getUrl('api_organisation'), this.urlConnectionBuilder.build(), c, this.urlResponseProcessorBuilder);
        }
        getDataRequest() {
            const c = new Collection(new RequestedDataParser());
            c.setIsSingleItemCollection(true);
            return new DataRequest(this.config.getUrl('api_data_request'), this.urlConnectionBuilder.build(), c, this.urlResponseProcessorBuilder);
        }
        getDataRequestCollection() {
            return new DataRequestCollection(this.config.getUrl('api_data_request'), this.urlConnectionBuilder.build(), new Collection(new RequestedDataParser()), this.urlResponseProcessorBuilder);
        }
        getOrganisationRatingCollection() {
            return new Rating(this.config.getUrl('api_organisation_rating_collection', 'v2/'), this.fetchFactory, new RatingParser());
        }
        getOrganisationDeliveryRatingCollection() {
            return new DeliveryRating(this.config.getUrl('api_organisation_delivery_rating_collection', 'v2/'), this.fetchFactory, new DeliveryParser());
        }
        getServiceCollection() {
            return new OrganisationServiceCollection(this.config.getUrl('api_organisation_service_collection', 'v2/'), this.fetchFactory, new OrganisationServiceCollectionParser(new OrganisationServiceParser()));
        }
        getHeadOffice() {
            return new HeadOffice_1.default(this.fetchFactory);
        }
        getPersonDataRequest() {
            return new Person_1.default(this.fetchFactory, ORGANISATION_URL_CONFIG.DATA_REQUEST_PERSON_RECIPIENT);
        }
        getBranchOfficeDataRequest() {
            return new BranchOffice_1.default(this.fetchFactory, ORGANISATION_URL_CONFIG.DATA_REQUEST_BRANCH_OFFICE_RECIPIENT);
        }
        getLatestDataRequest() {
            return new Latest_1.default(this.fetchFactory, ORGANISATION_URL_CONFIG.DATA_REQUEST_LATEST, new DataRequest_1.default());
        }
    }
    return Factory;
});

},
'api/organisation/parser/DataRequest':function(){
define([
    '../data/DataRequest'
], function(DataRequestData) {
    const DataRequest = function() {};

    DataRequest.prototype.parse = function(item) {
        return (new DataRequestData())
            .setRequestPK(item.requestPK || null)
            .setEmail(item.email || null)
            .setDateSent(item.dateSent || null)
            .setSender(item.sender || null)
            .setOrganisationPK(item.organisationPK || null);
    };

    return DataRequest;
});
},
'api/organisation/data/DataRequest':function(){
define([], function() {
    const DataRequest = function() {
        this.requestPK = null;
        this.email = null;
        this.dateSent = null;
        this.sender = null;
        this.organisationPK = null;
    };

    DataRequest.prototype.getRequestPK = function() {
        return this.requestPK;
    };

    DataRequest.prototype.setRequestPK = function(requestPK) {
        this.requestPK = requestPK;
        return this;
    };

    DataRequest.prototype.getEmail = function() {
        return this.email;
    };

    DataRequest.prototype.setEmail = function(email) {
        this.email = email;
        return this;
    };

    DataRequest.prototype.getDateSent = function() {
        return this.dateSent;
    };

    DataRequest.prototype.setDateSent = function(dateSent) {
        this.dateSent = dateSent;
        return this;
    };

    DataRequest.prototype.getSender = function() {
        return this.sender;
    };

    DataRequest.prototype.setSender = function(sender) {
        this.sender = sender;
        return this;
    };

    DataRequest.prototype.getOrganisationPK = function() {
        return this.organisationPK;
    };

    DataRequest.prototype.setOrganisationPK = function(organisationPK) {
        this.organisationPK = organisationPK;
        return this;
    };

    return DataRequest;
});
},
'api/organisation/Creator':function(){
define([], function() {
    var Creator = function(url, urlConnection, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;

        this.trades = [];

        this._organisationToData = function(organisationData) {
            var organisation = {
                'name': organisationData.getName(),
                'description': organisationData.getDescription(),
                'preferredName': organisationData.getPreferredName(),
                'website': organisationData.getWebsite()
            };

            if (this.trades.length) {
                organisation['tradePK'] = this.trades;
            }

            return organisation;
        };
    };

    Creator.prototype.addTrade = function(tradePK) {
        this.trades.push(tradePK);
        return this;
    };

    Creator.prototype.add = function(handlers, organisationData) {
        this.urlConnection.setSuccessHandler(handlers.getSuccess());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());
        this.urlConnection.setUrl(this.url);
        this.urlConnection.setData(this._organisationToData(organisationData));

        return this.urlConnection.post();
    };

    return Creator;
});
},
'api/organisation/DataRequest':function(){
define([], function() {
    const ROUTE_ORGANISATION_PK_PARAM = ':organisationPK';
    const ROUTE_LATEST_PARAM = '/latest';

    const DataRequest = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    DataRequest.prototype.getLatest = function(handlers, organisationPK, email) {
        this.urlConnection.setUrl(this.url.replace(ROUTE_ORGANISATION_PK_PARAM, organisationPK) + email + ROUTE_LATEST_PARAM);

        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    DataRequest.prototype.send = function(handlers, organisationPK, email) {
        this.urlConnection.setSuccessHandler(handlers.getSuccess());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());
        this.urlConnection.setUrl(this.url.replace(ROUTE_ORGANISATION_PK_PARAM, organisationPK));
        this.urlConnection.setData({'email': email});

        return this.urlConnection.post();
    };

    return DataRequest;
});
},
'api/organisation/DataRequestCollection':function(){
define([], function() {
    const ROUTE_ORGANISATION_PK_PARAM = ':organisationPK';

    const DataRequestCollection = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    DataRequestCollection.prototype.fetch = function(handlers, organisationPK, email) {
        this.urlConnection.setUrl(this.url.replace(ROUTE_ORGANISATION_PK_PARAM, organisationPK) + email);

        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return DataRequestCollection;
});
},
'api/organisation/Organisation':function(){
define([], function() {
    var Organisation = function(url, urlConnection, collectionParser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = collectionParser;
        
        this._organisationToData = function(organisationData) {
            var d = {
                'name': organisationData.getName()
            };

            if (organisationData.getDescription()) {
                d['description'] = organisationData.getDescription();
            }

            if (organisationData.getPreferredName()) {
                d['preferredName'] = organisationData.getPreferredName();
            }

            if (organisationData.getWebsite()) {
                d['website'] = organisationData.getWebsite();
            }

            return d;
        };
    };

    Organisation.prototype.get = function(handlers, organisationData) {
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());
        this.urlConnection.setUrl(this.url + organisationData.getOrganisationPK());

        return this.urlConnection.get();
    };

    return Organisation;
});
},
'@lib/api/config/routes/Organisation':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ORGANISATION = exports.HEAD_OFFICE = exports.DATA_REQUEST_PERSON_RECIPIENT = exports.DATA_REQUEST_LATEST = exports.DATA_REQUEST_BRANCH_OFFICE_RECIPIENT = exports.BRANCH_OFFICE_CONTACT_COLLECTION = exports.ACCOUNTS = void 0;
    exports.ACCOUNTS = '/v2/organisation/:id/accounts';
    exports.BRANCH_OFFICE_CONTACT_COLLECTION = '/v2/organisation/:id/branch-office/contact';
    exports.DATA_REQUEST_BRANCH_OFFICE_RECIPIENT = '/v2/organisation/data-request/branch-office/:id';
    exports.DATA_REQUEST_LATEST = '/v2/organisation/data-request/latest/:id';
    exports.DATA_REQUEST_PERSON_RECIPIENT = '/v2/organisation/data-request/person/:id';
    exports.HEAD_OFFICE = '/v2/organisation/:id/branch-office?onlyHeadOffice=1';
    exports.ORGANISATION = '/v2/organisation/:id';
});

},
'@lib/api/organisation/parser/OrganisationType':function(){
define(["require", "exports", "./../data/OrganisationType"], function (require, exports, OrganisationTypeVO) {
    "use strict";
    class OrganisationType {
        parse(item) {
            return new OrganisationTypeVO(item.organisationTypePK || null, item.name || null);
        }
    }
    return OrganisationType;
});

},
'@lib/api/organisation/data/OrganisationType':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class OrganisationType {
        constructor(organisationTypePK, name) {
            this.organisationTypePK = organisationTypePK;
            this.name = name;
        }
        getOrganisationTypePK() {
            return this.organisationTypePK;
        }
        ;
        getName() {
            return this.name;
        }
        ;
    }
    return OrganisationType;
});

},
'@lib/api/organisation/parser/OrganisationTypeCollection':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class OrganisationTypeCollection {
        constructor(parser) {
            this.parser = parser;
        }
        parse(items) {
            const collection = [];
            if (items.length > 0) {
                items.forEach(item => {
                    collection.push(this.parser.parse(item));
                });
            }
            return collection;
        }
        ;
    }
    return OrganisationTypeCollection;
});

},
'@lib/api/organisation/rating/enquiry/EnquiryRating':function(){
define(["require", "exports", "@lib/spencer/project/stage/filter/Type"], function (require, exports, Type_1) {
    "use strict";
    class EnquiryRating {
        constructor(url, fetchFactory, parser) {
            this.url = url;
            this.fetchFactory = fetchFactory;
            this.parser = parser;
            this.requests = [];
        }
        async get(organisationPK, filterCollection) {
            this.fetchWrapper = this.fetchFactory.get();
            this.requests.push(this.fetchWrapper);
            this.fetchWrapper.setSuccessHandler(async (response) => this.parser.parse(await response.json()));
            return this.fetchWrapper.get(this.url.replace(':id', organisationPK.toString()) + this.generateQueryString(filterCollection));
        }
        cancel() {
            this.requests.forEach(request => request.cancel());
            this.requests = [];
        }
        generateQueryString(filterCollection) {
            const urlSearchParams = new URLSearchParams();
            if (filterCollection.hasFilterForClass(Type_1.default)) {
                const type = filterCollection.getFilterByClass(Type_1.default);
                urlSearchParams.append('type', type.getType());
            }
            return '?' + urlSearchParams.toString();
        }
    }
    return EnquiryRating;
});

},
'@lib/spencer/project/stage/filter/Type':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    class Type {
        setType(type) {
            this.type = type;
            return this;
        }
        getType() {
            return this.type;
        }
    }
    exports.default = Type;
});

},
'@lib/organisation/rating/parser/BaseRating':function(){
define(["require", "exports", "../data/BaseRating", "@lib/spencer/core/data/Organisation", "@lib/spencer/core/data/Person", "@lib/project/data/ProjectStage"], function (require, exports, BaseRating_1, OrganisationVO, PersonVO, ProjectStageVO) {
    "use strict";
    class BaseRating {
        parse(data) {
            let baseRatingVOArray = [];
            data.forEach(rating => {
                baseRatingVOArray.push(new BaseRating_1.default(rating.quoteProvided, rating.quoteTimely, rating.quoteCompetitive, rating.reasonProvided, rating.reasonTimely, rating.wasQuoteUsed, rating.wouldUseAgain, rating.comment, rating.rating, new OrganisationVO(rating.organisationId, rating.organisationName, rating.organisationPreferredName), rating.personId ?
                    new PersonVO()
                        .setPersonPK(rating.personId)
                        .setDisplayName(rating.personCreated)
                        .setJobTitle(rating.personCreatedJobTitle) : null, new ProjectStageVO()
                    .setTitle(rating.projectName)
                    .setStageNumber(rating.stageno), rating.enquiryPK, rating.tradeName, rating.dateCreated, rating.enquiryReference));
            });
            return baseRatingVOArray;
        }
    }
    return BaseRating;
});

},
'@lib/organisation/rating/data/BaseRating':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    class BaseRating {
        constructor(quoteProvided, quoteTimely, quoteCompetitive, reasonProvided, reasonTimely, wasQuoteUsed, wouldUseAgain, comment, rating, organisationData, personData, projectStage, enquiryPK, tradeName, dateCreated, enquiryReference) {
            this.quoteProvided = quoteProvided;
            this.quoteTimely = quoteTimely;
            this.quoteCompetitive = quoteCompetitive;
            this.reasonProvided = reasonProvided;
            this.reasonTimely = reasonTimely;
            this.wasQuoteUsed = wasQuoteUsed;
            this.wouldUseAgain = wouldUseAgain;
            this.comment = comment;
            this.rating = rating;
            this.organisationData = organisationData;
            this.personData = personData;
            this.projectStage = projectStage;
            this.enquiryPK = enquiryPK;
            this.tradeName = tradeName;
            this.dateCreated = dateCreated;
            this.enquiryReference = enquiryReference;
        }
        getQuoteProvided() {
            return this.quoteProvided;
        }
        getQuoteTimely() {
            return this.quoteTimely;
        }
        getQuoteCompetitive() {
            return this.quoteCompetitive;
        }
        getReasonProvided() {
            return this.reasonProvided;
        }
        getReasonTimely() {
            return this.reasonTimely;
        }
        getWasQuoteUsed() {
            return this.wasQuoteUsed;
        }
        getWouldUseAgain() {
            return this.wouldUseAgain;
        }
        getComment() {
            return this.comment;
        }
        getRating() {
            return this.rating;
        }
        getOrganisationData() {
            return this.organisationData;
        }
        getPersonData() {
            return this.personData;
        }
        getProjectStageData() {
            return this.projectStage;
        }
        getEnquiryPK() {
            return this.enquiryPK;
        }
        getTradeName() {
            return this.tradeName;
        }
        getDateCreated() {
            return this.dateCreated;
        }
        getEnquiryReference() {
            return this.enquiryReference;
        }
    }
    exports.default = BaseRating;
});

},
'@lib/spencer/core/data/Organisation':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Organisation {
        constructor(organisationPK, name = '', preferredName = '') {
            this.organisationPK = organisationPK;
            this.name = name;
            this.preferredName = preferredName;
        }
        getOrganisationPK() {
            return this.organisationPK;
        }
        getName() {
            return this.name;
        }
        getPreferredName() {
            return this.preferredName;
        }
    }
    return Organisation;
});

},
'@lib/organisation/rating/parser/Delivery':function(){
define(["require", "exports", "../data/Delivery", "@lib/spencer/core/data/Organisation", "@lib/spencer/core/data/Person", "@lib/project/data/ProjectStage"], function (require, exports, Delivery_1, OrganisationVO, PersonVO, ProjectStageVO) {
    "use strict";
    class Delivery {
        parse(data) {
            let deliveryRatingVOArray = [];
            data.forEach(rating => {
                deliveryRatingVOArray.push(new Delivery_1.default(rating.scheduleVariance, rating.makingGoodDefects, rating.supervisionStandards, rating.qualityOfWork, rating.commerciallyAggressive, rating.easyToWorkWith, rating.rightSafetyApproach, rating.environmentalBehaviours, rating.collaborativeBehaviours, rating.weeksToCompletion, rating.comment, rating.rating, new OrganisationVO(rating.organisationId, rating.organisationName, rating.organisationPreferredName), new PersonVO()
                    .setPersonPK(rating.personId)
                    .setDisplayName(rating.reviewer)
                    .setJobTitle(rating.jobTitle), new ProjectStageVO()
                    .setTitle(rating.projectTitle)
                    .setStageNumber(rating.stageno), rating.timeCreated, rating.reviewDate, rating.reviewer));
            });
            return deliveryRatingVOArray;
        }
    }
    return Delivery;
});

},
'@lib/organisation/rating/data/Delivery':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    class Delivery {
        constructor(scheduleVariance, makingGoodDefects, supervisionStandards, qualityOfWork, commerciallyAggressive, easyToWorkWith, rightSafetyApproach, environmentalBehaviours, collaborativeBehaviours, weeksToCompletion, comment, rating, organisationData, personData, projectData, timeCreated, reviewDate, reviewer) {
            this.scheduleVariance = scheduleVariance;
            this.makingGoodDefects = makingGoodDefects;
            this.supervisionStandards = supervisionStandards;
            this.qualityOfWork = qualityOfWork;
            this.commerciallyAggressive = commerciallyAggressive;
            this.easyToWorkWith = easyToWorkWith;
            this.rightSafetyApproach = rightSafetyApproach;
            this.environmentalBehaviours = environmentalBehaviours;
            this.collaborativeBehaviours = collaborativeBehaviours;
            this.weeksToCompletion = weeksToCompletion;
            this.comment = comment;
            this.rating = rating;
            this.organisationData = organisationData;
            this.personData = personData;
            this.projectData = projectData;
            this.timeCreated = timeCreated;
            this.reviewDate = reviewDate;
            this.reviewer = reviewer;
        }
        getScheduleVariance() {
            return this.scheduleVariance;
        }
        getMakingGoodDefects() {
            return this.makingGoodDefects;
        }
        getSupervisionStandards() {
            return this.supervisionStandards;
        }
        getQualityOfWork() {
            return this.qualityOfWork;
        }
        getCommerciallyAggressive() {
            return this.commerciallyAggressive;
        }
        getEasyToWorkWith() {
            return this.easyToWorkWith;
        }
        getRightSafetyApproach() {
            return this.rightSafetyApproach;
        }
        getEnvironmentalBehaviours() {
            return this.environmentalBehaviours;
        }
        getCollaborativeBehaviours() {
            return this.collaborativeBehaviours;
        }
        getWeeksToCompletion() {
            return this.weeksToCompletion;
        }
        getRating() {
            return this.rating;
        }
        getOrganisationData() {
            return this.organisationData;
        }
        getPersonData() {
            return this.personData;
        }
        getProjectStageData() {
            return this.projectData;
        }
        getTimeCreated() {
            return this.timeCreated;
        }
        getReviewDate() {
            return this.reviewDate;
        }
        getReviewer() {
            return this.reviewer;
        }
        getComment() {
            return this.comment;
        }
    }
    exports.default = Delivery;
});

},
'@lib/api/organisation/ServiceCollection':function(){
define(["require", "exports", "@lib/request/data/ErrorResponse"], function (require, exports, ErrorResponse_1) {
    "use strict";
    class ServiceCollection {
        constructor(url, fetchFactory, parser) {
            this.url = url;
            this.fetchFactory = fetchFactory;
            this.parser = parser;
        }
        async fetch(organisationPK) {
            const fetchWrapper = this.fetchFactory.get();
            fetchWrapper.setSuccessHandler(async (response) => this.parser.parse(await response.json()));
            fetchWrapper.setErrorHandler((e) => {
                throw new ErrorResponse_1.ErrorResponse(e);
            });
            return await fetchWrapper.get(this.url.replace(':id', organisationPK.toString()));
        }
    }
    return ServiceCollection;
});

},
'@lib/api/organisation/parser/Service':function(){
define(["require", "exports", "./../data/Service", "@lib/person/data/Person"], function (require, exports, ServiceVO, Person_1) {
    "use strict";
    class Service {
        parse(item) {
            return new ServiceVO(item.tradePK, item.tradeName, new Date(item.timeModified), item.rating || null, item.comment || null, item.organisationTypeName || null, item.personAuthor ? this.getPersonAuthor(item.personAuthor) : null);
        }
        getPersonAuthor(person) {
            return new Person_1.default(person.personPK || null, person.displayName || null, person.jobTitle || null, person.email || null, person.displayNameAndJobTitle || null, person.organisationName || null, person.mobile || null, person.directDialNumber || null, person.type || null, person.internal || null, person.categories || null);
        }
    }
    return Service;
});

},
'@lib/api/organisation/data/Service':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Service {
        constructor(tradePK, name, timeModified, rating, comment, organisationTypeName, author) {
            this.tradePK = tradePK;
            this.name = name;
            this.timeModified = timeModified;
            this.rating = rating;
            this.comment = comment;
            this.organisationTypeName = organisationTypeName;
            this.author = author;
        }
        getTradePK() {
            return this.tradePK;
        }
        getName() {
            return this.name;
        }
        getTimeModified() {
            return this.timeModified;
        }
        getRating() {
            return this.rating;
        }
        getComment() {
            return this.comment;
        }
        getOrganisationTypeName() {
            return this.organisationTypeName;
        }
        getAuthor() {
            return this.author;
        }
    }
    return Service;
});

},
'@lib/person/data/Person':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    class Person {
        constructor(personPK, displayName, jobTitle, email, displayNameAndJobTitle, organisationName, mobile, directDialNumber, type, internal = false, categories = []) {
            this.personPK = personPK;
            this.displayName = displayName;
            this.jobTitle = jobTitle;
            this.email = email;
            this.displayNameAndJobTitle = displayNameAndJobTitle;
            this.organisationName = organisationName;
            this.mobile = mobile;
            this.directDialNumber = directDialNumber;
            this.type = type;
            this.internal = internal;
            this.categories = categories;
        }
        getPersonPK() {
            return this.personPK;
        }
        getDisplayName() {
            return this.displayName;
        }
        getJobTitle() {
            return this.jobTitle;
        }
        getEmail() {
            return this.email;
        }
        getDisplayNameAndJobTitle() {
            return this.displayNameAndJobTitle;
        }
        getOrganisationName() {
            return this.organisationName;
        }
        getMobile() {
            return this.mobile;
        }
        getDirectDialNumber() {
            return this.directDialNumber;
        }
        getType() {
            return this.type;
        }
        isInternal() {
            return this.internal;
        }
        getCategories() {
            return this.categories;
        }
    }
    exports.default = Person;
});

},
'@lib/api/organisation/parser/ServiceCollection':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class ServiceCollection {
        constructor(parser) {
            this.parser = parser;
        }
        parse(items) {
            const collection = [];
            items.forEach(item => {
                collection.push(this.parser.parse(item));
            });
            return collection;
        }
        ;
    }
    return ServiceCollection;
});

},
'@lib/api/organisation/TypeCollection':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class TypeCollection {
        constructor(url, fetchFactory, parser) {
            this.url = url;
            this.fetchFactory = fetchFactory;
            this.parser = parser;
            this.fetchWrapper = fetchFactory.get();
        }
        fetch(handlers) {
            this.fetchWrapper.setSuccessHandler(async (response) => {
                handlers.getSuccess()(this.parser.parse(await response.json()));
            });
            this.fetchWrapper.setErrorHandler(handlers.getError());
            return this.fetchWrapper.get(this.url);
        }
    }
    return TypeCollection;
});

},
'@lib/api/organisation/rating/delivery/DeliveryRating':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class DeliveryRating {
        constructor(url, fetchFactory, deliveryParser) {
            this.url = url;
            this.fetchFactory = fetchFactory;
            this.deliveryParser = deliveryParser;
            this.requests = [];
        }
        async get(organisationPK) {
            this.fetchWrapper = this.fetchFactory.get();
            this.requests.push(this.fetchWrapper);
            this.fetchWrapper.setSuccessHandler(async (response) => this.deliveryParser.parse(await response.json()));
            return this.fetchWrapper.get(this.url.replace(':id', organisationPK.toString()));
        }
        cancel() {
            this.requests.forEach(request => request.cancel());
            this.requests = [];
        }
    }
    return DeliveryRating;
});

},
'@lib/api/organisation/HeadOffice':function(){
define(["require", "exports", "@lib/api/config/routes/Organisation", "@lib/api/branch-office/parser"], function (require, exports, Organisation_1, parser_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    class HeadOffice {
        constructor(fetchFactory) {
            this.fetchFactory = fetchFactory;
            this.fetchWrapper = fetchFactory.get();
        }
        async fetch(organisationPK) {
            this.fetchWrapper.setSuccessHandler(async (response) => {
                const data = await response.json();
                return (0, parser_1.parseBranchOffice)(data.find(branchOffice => branchOffice.isHeadOffice));
            });
            return this.fetchWrapper.get(Organisation_1.HEAD_OFFICE.replace(':id', organisationPK.toString()));
        }
    }
    exports.default = HeadOffice;
});

},
'@lib/api/branch-office/parser':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.parseBranchOffice = parseBranchOffice;
    function parseBranchOffice(data) {
        return {
            branchOfficePK: data.branchOfficePK,
            name: data.name,
            address1: data.address1,
            address2: data.address2,
            address3: data.address3,
            town: data.town,
            postCode: data.postCode,
            isHeadOffice: data.isHeadOffice,
            tel: data.tel,
            isActive: data.isActive,
            countryName: data.countryName,
            countyName: data.countyName
        };
    }
});

},
'@lib/api/organisation/data-request/BranchOffice':function(){
define(["require", "exports", "@lib/request/data/HTTPResponseCodes", "@lib/request/data/ErrorResponse"], function (require, exports, HTTPResponseCodes, ErrorResponse_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    class BranchOffice {
        constructor(fetchFactory, url) {
            this.fetchFactory = fetchFactory;
            this.url = url;
            this.fetchWrapper = this.fetchFactory.get();
        }
        async send(branchOfficePK) {
            this.fetchWrapper.setSuccessHandler(async (response) => {
                return await response.json();
            });
            this.fetchWrapper.setHandler(HTTPResponseCodes.not_found, async () => {
                throw new ErrorResponse_1.NotFoundResponse();
            });
            this.fetchWrapper.setErrorHandler(async () => {
                throw new ErrorResponse_1.ErrorResponse();
            });
            return await this.fetchWrapper.post(this.url.replace(':id', branchOfficePK.toString()));
        }
    }
    exports.default = BranchOffice;
});

},
'@lib/api/organisation/data-request/Latest':function(){
define(["require", "exports", "@lib/request/data/HTTPResponseCodes", "@lib/request/data/ErrorResponse"], function (require, exports, HTTPResponseCodes, ErrorResponse_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    class Latest {
        constructor(fetchFactory, url, parser) {
            this.fetchFactory = fetchFactory;
            this.url = url;
            this.parser = parser;
            this.fetchWrapper = fetchFactory.get();
        }
        async fetch(organisationPK) {
            this.fetchWrapper.setSuccessHandler(async (response) => {
                const data = await response.json();
                return this.parser.parse(data);
            });
            this.fetchWrapper.setHandler(HTTPResponseCodes.not_found, async () => {
                throw new ErrorResponse_1.NotFoundResponse();
            });
            this.fetchWrapper.setErrorHandler(async () => {
                throw new ErrorResponse_1.ErrorResponse();
            });
            return this.fetchWrapper.get(this.url.replace(':id', organisationPK.toString()));
        }
    }
    exports.default = Latest;
});

},
'@lib/api/organisation/data-request/Person':function(){
define(["require", "exports", "@lib/request/data/HTTPResponseCodes", "@lib/request/data/ErrorResponse"], function (require, exports, HTTPResponseCodes, ErrorResponse_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    class Person {
        constructor(fetchFactory, url) {
            this.fetchFactory = fetchFactory;
            this.url = url;
            this.fetchWrapper = this.fetchFactory.get();
        }
        async send(personPK) {
            this.fetchWrapper.setSuccessHandler(async (response) => {
                return await response.json();
            });
            this.fetchWrapper.setHandler(HTTPResponseCodes.not_found, async () => {
                throw new ErrorResponse_1.NotFoundResponse();
            });
            this.fetchWrapper.setErrorHandler(async () => {
                throw new ErrorResponse_1.ErrorResponse();
            });
            return await this.fetchWrapper.post(this.url.replace(':id', personPK.toString()));
        }
    }
    exports.default = Person;
});

},
'@lib/api/organisation/data-request/parser/DataRequest':function(){
define(["require", "exports", "@lib/organisation/data-request/data/DataRequest", "@lib/api/person/parsers", "@lib/api/organisation/parser/Organisation"], function (require, exports, DataRequest_1, parsers_1, Organisation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    class DataRequest {
        parse(data) {
            return new DataRequest_1.default(data.dataRequestPK, data.email, (0, Organisation_1.default)(data.organisation), (0, parsers_1.parseSingle)(data.creator), new Date(data.timeCreated));
        }
    }
    exports.default = DataRequest;
});

},
'@lib/organisation/data-request/data/DataRequest':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    class DataRequest {
        constructor(dataRequestPK, email, organisation, creator, timeCreated) {
            this.dataRequestPK = dataRequestPK;
            this.email = email;
            this.organisation = organisation;
            this.creator = creator;
            this.timeCreated = timeCreated;
        }
        getDataRequestPK() {
            return this.dataRequestPK;
        }
        getEmail() {
            return this.email;
        }
        getOrganisation() {
            return this.organisation;
        }
        getCreator() {
            return this.creator;
        }
        getTimeCreated() {
            return this.timeCreated;
        }
    }
    exports.default = DataRequest;
});

},
'@lib/api/person/parsers':function(){
define(["require", "exports", "@lib/person/data/Person", "@lib/person/data/Category"], function (require, exports, Person_1, Category_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.parsePerson = parsePerson;
    exports.parseCategory = parseCategory;
    exports.parseSingle = parseSingle;
    function parsePerson(data) {
        if (!data['collection']) {
            return;
        }
        const item = data['collection']['items'][0];
        let categories = [];
        if (Array.isArray(item.categories)) {
            categories = item.categories.map(category => {
                return parseCategory(category);
            });
        }
        return new Person_1.default(item.personPK || null, item.displayName || null, item.jobTitle || null, item.email || null, item.displayNameAndJobTitle || null, item.organisationName || null, item.mobile || null, item.directDialNumber || null, item.type || null, item.isInternal || false, categories);
    }
    function parseCategory(data) {
        return new Category_1.default(data.categoryPK, data.name);
    }
    function parseSingle(data) {
        let categories = [];
        if (Array.isArray(data.categories)) {
            categories = data.categories.map(category => {
                return parseCategory(category);
            });
        }
        return new Person_1.default(data.personPK || null, data.displayName || null, data.jobTitle || null, data.email || null, data.displayNameAndJobTitle || null, data.organisationName || null, data.mobile || null, data.directDialNumber || null, data.type || null, data.isInternal || false, categories);
    }
});

},
'@lib/person/data/Category':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    class Category {
        constructor(categoryPK, name) {
            this.categoryPK = categoryPK;
            this.name = name;
        }
        getCategoryPK() {
            return this.categoryPK;
        }
        getName() {
            return this.name;
        }
    }
    exports.default = Category;
});

},
'@lib/api/organisation/parser/Organisation':function(){
define(["require", "exports", "@lib/organisation/data"], function (require, exports, data_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.default = parse;
    function parse(data) {
        const o = new data_1.Organisation(data.organisationPK, data.name, data.preferredName || '', data.description || '', data.website || '', data.isIntranetOwner || false, data.apiKey || '');
        return o;
    }
});

},
'@lib/organisation/data':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Organisation = void 0;
    class Organisation {
        constructor(organisationPK, name = '', preferredName = '', description, website, intranetOwner = false, apiKey = '') {
            this.organisationPK = organisationPK;
            this.name = name;
            this.preferredName = preferredName;
            this.description = description;
            this.website = website;
            this.intranetOwner = intranetOwner;
            this.apiKey = apiKey;
        }
        getOrganisationPK() {
            return this.organisationPK;
        }
        getName() {
            return this.name;
        }
        getPreferredName() {
            return this.preferredName;
        }
        getDescription() {
            return this.description;
        }
        getWebsite() {
            return this.website;
        }
        isIntranetOwner() {
            return this.intranetOwner;
        }
        getApiKey() {
            return this.apiKey;
        }
    }
    exports.Organisation = Organisation;
});

},
'api/person/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    var Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_person = 'person/';
        this.api_person_absence = 'person/:id/absence';
        this.api_person_emergency_contact = 'person/:id/emergency-contact';
        this.api_person_profile_picture = 'person/:id/profile-picture';
        this.api_person_self = 'person/self';
        this.api_person_team = 'person/:id/team';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});
},
'api/person/Factory':function(){
define([
    'spencer/core/parser/Person',
    '../parser/Collection',
    'spencer/parse/JSONParser',
    './ManagerFactory',
    './PeopleCollection',
    './Person',
    './PersonModel',
    './PersonSelf',
    'library/request/fetch/Factory',
    '@lib/api/doc-control/parser/Revision',
    '@lib/api/person/Absence',
    '@lib/api/person/EmergencyContact',
    '@lib/api/person/parser/EmergencyContact',
    '@lib/api/person/parser/Person',
    '@lib/api/person/parser/PersonCollection',
    '@lib/api/person/parser/Team',
    '@lib/api/person/PersonCollection',
    '@lib/api/person/ProfilePicture',
    '@lib/api/person/Team'
], function(
    PersonParserLegacy,
    CollectionParser,
    JSONParser,
    ManagerFactory,
    PeopleCollection,
    PersonLegacy,
    Person,
    PersonSelf,
    FetchFactory,
    RevisionParser,
    Absence,
    EmergencyContact,
    EmergencyContactParser,
    PersonParser,
    PersonCollectionParser,
    TeamParser,
    PersonCollection,
    ProfilePicture,
    Team
) {
    const Factory = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Factory.prototype.getManagerFactory = function() {
        return new ManagerFactory(
            this.config.getUrl('api_person'),
            this.urlConnectionBuilder
        );
    };

    Factory.prototype.getPeopleCollection = function() {
        return new PeopleCollection(
            this.config.getUrl('api_person'),
            this.urlConnectionBuilder.build(),
            new CollectionParser(new PersonParserLegacy()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getPersonCollection = function () {
        return new PersonCollection(
            this.config.getUrl('api_person', 'v2/'),
            this.urlConnectionBuilder.build(),
            this.urlResponseProcessorBuilder,
            new JSONParser(new PersonCollectionParser(
                new PersonParser()
            ))
        );
    };

    Factory.prototype.getPerson = function() {
        const cp = new CollectionParser(new PersonParserLegacy);
        cp.setIsSingleItemCollection(true);

        return new PersonLegacy(
            this.config.getUrl('api_person'),
            this.urlConnectionBuilder.build(),
            cp,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getLibraryPerson = function() {
        return new Person(
            this.config.getUrl('api_person', 'v2/'),
            this.urlConnectionBuilder.build(),
            this.urlResponseProcessorBuilder,
            new JSONParser(new PersonParser())
        );
    };

    Factory.prototype.getPersonSelf = function() {
        return new PersonSelf(
            this.config.getUrl('api_person'),
            this.urlConnectionBuilder.build(),
            new CollectionParser(new PersonParserLegacy()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getAbsence = function() {
        return new Absence(
            new FetchFactory(),
            this.config.getUrl('api_person_absence', 'v2/')
        );
    };

    Factory.prototype.getEmergencyContact = function() {
        return new EmergencyContact(
            new FetchFactory(),
            new EmergencyContactParser(),
            this.config.getUrl('api_person_emergency_contact', 'v2/')
        );
    };

    Factory.prototype.getProfilePicture = function() {
        return new ProfilePicture(
            new FetchFactory(),
            new RevisionParser(),
            this.config.getUrl('api_person_profile_picture', 'v2/')
        );
    };

    Factory.prototype.getTeam = function() {
        return new Team(
            new FetchFactory(),
            new TeamParser(),
            this.config.getUrl('api_person_team', 'v2/')
        );
    };

    return Factory;
});
},
'api/person/ManagerFactory':function(){
define([
    './Manager'
], function(Manager) {
    var ManagerFactory = function(url, urlConnectionBuilder) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
    };

    ManagerFactory.prototype.get = function(branchOfficePK) {
        return new Manager(this.url, this.urlConnectionBuilder.build(), branchOfficePK);
    };

    return ManagerFactory;
});
},
'api/person/Manager':function(){
define([], function() {
    var Manager = function(url, urlConnection, branchOfficePK) {
        this.contactCategoryPKs = [];
        this.branchOfficePK = branchOfficePK;
        this.url = url;
        this.urlConnection = urlConnection;

        this._personToData = function(personVO) {
            var r = {
                'branchOfficePK': this.branchOfficePK,
                'title': personVO.getTitle(),
                'firstName': personVO.getFirstName(),
                'middleName': personVO.getMiddleName(),
                'lastName': personVO.getLastName(),
                'displayName': personVO.getDisplayName(),
                'jobTitle': personVO.getJobTitle(),
                'email': personVO.getEmail()
            };

            if (personVO.getPhoneNumbers().landline) {
                r['landline'] = personVO.getPhoneNumbers().landline;
            }

            if (personVO.getPhoneNumbers().mobile) {
                r['mobile'] = personVO.getPhoneNumbers().mobile;
            }

            if (personVO.VALUE !== undefined) {
                r['type'] = personVO.VALUE;
            }

            if (this.contactCategoryPKs.length) {
                r['contactCategoryPK'] = this.contactCategoryPKs;
            }

            return r;
        };
    };

    Manager.prototype.linkContactCategory = function(contactCategoryPK) {
        this.contactCategoryPKs.push(contactCategoryPK);
        return this;
    };

    Manager.prototype.add = function(handlers, personVO) {
        this.urlConnection.setSuccessHandler(handlers.getSuccess());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());
        this.urlConnection.setUrl(this.url);
        this.urlConnection.setData(this._personToData(personVO));

        return this.urlConnection.post();
    };

    return Manager;
});
},
'api/person/Person':function(){
define([], function() {
    var Person = function(url, urlConnection, collectionParser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = collectionParser;
    };

    Person.prototype.get = function(handlers, personVO) {
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());
        this.urlConnection.setUrl(this.url + personVO.getPersonPK());

        return this.urlConnection.get();
    };

    return Person;
});
},
'api/person/PersonModel':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Person {
        constructor(url, urlConnection, urlResponseProcessorBuilder, parser) {
            this.url = url;
            this.urlConnection = urlConnection;
            this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
            this.parser = parser;
            this.url = url;
            this.urlConnection = urlConnection;
            this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
            this.parser = parser;
        }
        get(handlers, personVO) {
            this.urlConnection.setSuccessHandler(this.urlResponseProcessorBuilder.createProcessor(this.parser, handlers.getSuccess(), handlers.getError()));
            this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
            this.urlConnection.setProgressHandler(handlers.getProgress());
            this.urlConnection.setErrorHandler(handlers.getError());
            this.urlConnection.setUrl(this.url + personVO.getPersonPK());
            return this.urlConnection.get();
        }
    }
    return Person;
});

},
'api/person/PersonSelf':function(){
define([], function() {
    var PersonSelf = function(url, urlConnection, parser, urlResponseProcessorBuilder) {
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this.urlConnection.setUrl(url + "self/");
    };

    PersonSelf.prototype.get = function(handlers) {
        this.parser.setIsSingleItemCollection(true);

        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return PersonSelf;
});
},
'@lib/api/doc-control/parser/Revision':function(){
define(["require", "exports", "@lib/doc-control/data/Revision"], function (require, exports, RevisionVO) {
    "use strict";
    class Revision {
        parse(data) {
            return new RevisionVO(data.revisionPK, data.md5, data.title, data.fileType);
        }
    }
    return Revision;
});

},
'@lib/doc-control/data/Revision':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Revision {
        constructor(revisionPK, md5, title, fileType) {
            this.revisionPK = revisionPK;
            this.md5 = md5;
            this.title = title;
            this.fileType = fileType;
        }
        getRevisionPK() {
            return this.revisionPK;
        }
        getMd5() {
            return this.md5;
        }
        getTitle() {
            return this.title;
        }
        getFileType() {
            return this.fileType;
        }
        getRevisionNumber() {
            return this.revisionNumber;
        }
        setRevisionNumber(revisionNumber) {
            this.revisionNumber = revisionNumber;
            return this;
        }
    }
    return Revision;
});

},
'@lib/api/person/Absence':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Absence {
        constructor(fetchFactory, url) {
            this.url = url;
            this.processor = fetchFactory.get();
        }
        async get(personPK) {
            this.processor.setSuccessHandler(async (response) => {
                return await response.json();
            });
            return this.processor.get(this.url.replace(':id', personPK.toString()));
        }
    }
    return Absence;
});

},
'@lib/api/person/EmergencyContact':function(){
define(["require", "exports", "@lib/request/data/HTTPResponseCodes"], function (require, exports, HTTPResponseCodes) {
    "use strict";
    const ERROR_NO_ACCESS = 'NO_ACCESS';
    const ERROR_NOT_FOUND = 'NOT_FOUND';
    class EmergencyContact {
        constructor(fetchFactory, parser, url) {
            this.parser = parser;
            this.url = url;
            this.processor = fetchFactory.get();
        }
        async get(personPK) {
            this.processor.setSuccessHandler(async (response) => {
                const data = await response.json();
                return this.parser.parse(data);
            });
            this.processor.setHandler(HTTPResponseCodes.forbidden, async () => ERROR_NO_ACCESS);
            this.processor.setHandler(HTTPResponseCodes.not_found, async () => ERROR_NOT_FOUND);
            return this.processor.get(this.url.replace(':id', personPK.toString()));
        }
    }
    return EmergencyContact;
});

},
'@lib/api/person/parser/EmergencyContact':function(){
define(["require", "exports", "@lib/person/data"], function (require, exports, PersonData) {
    "use strict";
    class EmergencyContact {
        parse(item) {
            return new PersonData.EmergencyContact(item.emergencyContact, item.relationship);
        }
    }
    return EmergencyContact;
});

},
'@lib/person/data':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ProfilePicture = exports.Team = exports.EmergencyContact = void 0;
    class EmergencyContact {
        constructor(emergencyContact, relationship) {
            this.emergencyContact = emergencyContact;
            this.relationship = relationship;
        }
        getEmergencyContact() {
            return this.emergencyContact;
        }
        getRelationship() {
            return this.relationship;
        }
    }
    exports.EmergencyContact = EmergencyContact;
    class Team {
        constructor(teamHistoryPK, teamPK, name, code) {
            this.teamHistoryPK = teamHistoryPK;
            this.teamPK = teamPK;
            this.name = name;
            this.code = code;
        }
        getTeamHistoryPK() {
            return this.teamHistoryPK;
        }
        getTeamPK() {
            return this.teamPK;
        }
        getName() {
            return this.name;
        }
        getCode() {
            return this.code;
        }
    }
    exports.Team = Team;
    class ProfilePicture {
        constructor(md5, revisionPK, title) {
            this.md5 = md5;
            this.revisionPK = revisionPK;
            this.title = title;
        }
        getMd5() {
            return this.md5;
        }
        getRevisionPK() {
            return this.revisionPK;
        }
        getTitle() {
            return this.title;
        }
    }
    exports.ProfilePicture = ProfilePicture;
});

},
'@lib/api/person/parser/Person':function(){
define(["require", "exports", "../data/Person", "@lib/api/person/parsers"], function (require, exports, PersonVO, parsers_1) {
    "use strict";
    class Person {
        parse(item) {
            if (item['collection']) {
                item = (item)['collection']['items'][0];
            }
            let categories = [];
            if (Array.isArray(item.categories)) {
                categories = item.categories.map(category => {
                    return (0, parsers_1.parseCategory)(category);
                });
            }
            return new PersonVO(item.personPK || null, item.displayName || null, item.jobTitle || null, item.email || null, item.displayNameAndJobTitle || null, item.organisationName || null, categories);
        }
    }
    return Person;
});

},
'@lib/api/person/data/Person':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    /**
     * @deprecated Use Person inside typescript/lib/person/data.ts instead
     */
    class Person {
        constructor(personPK, displayName, jobTitle, email, displayNameAndJobTitle, organisationName, categories) {
            this.personPK = personPK;
            this.displayName = displayName;
            this.jobTitle = jobTitle;
            this.email = email;
            this.displayNameAndJobTitle = displayNameAndJobTitle;
            this.organisationName = organisationName;
            this.categories = categories;
        }
        getPersonPK() {
            return this.personPK;
        }
        getDisplayName() {
            return this.displayName;
        }
        getJobTitle() {
            return this.jobTitle;
        }
        getEmail() {
            return this.email;
        }
        getDisplayNameAndJobTitle() {
            return this.displayNameAndJobTitle;
        }
        getOrganisationName() {
            return this.organisationName;
        }
        getCategories() {
            return this.categories;
        }
    }
    return Person;
});

},
'@lib/api/person/parser/PersonCollection':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class PersonCollection {
        constructor(parser) {
            this.parser = parser;
        }
        parse(items) {
            const collection = [];
            if (items['collection']['items'].length > 0) {
                items['collection']['items'].forEach(item => {
                    collection.push(this.parser.parse(item));
                });
            }
            return collection;
        }
    }
    return PersonCollection;
});

},
'@lib/api/person/parser/Team':function(){
define(["require", "exports", "@lib/person/data"], function (require, exports, PersonData) {
    "use strict";
    class Team {
        parse(item) {
            return new PersonData.Team(item.teamHistoryPK, item.teamPK, item.name, item.code);
        }
    }
    return Team;
});

},
'@lib/api/person/PersonCollection':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class PersonCollection {
        constructor(url, urlConnection, urlResponseProcessorBuilder, parser) {
            this.url = url;
            this.urlConnection = urlConnection;
            this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
            this.parser = parser;
            this.active = false;
            this.constants = {};
            this.filterField = 'name';
            this.includeLabour = false;
            this.limit = 10;
            this.offset = 0;
            this.organisationPKs = null;
            this.personType = null;
            this.query = null;
            this.withEmail = 0;
            this.constants = {
                URL_PARAM_ACTIVE: 'active',
                URL_PARAM_FILTER_FIELD: 'field',
                URL_PARAM_INCLUDE_LABOUR: 'includeLabour',
                URL_PARAM_LIMIT: 'limit',
                URL_PARAM_OFFSET: 'offset',
                URL_PARAM_ORGANISATION_PKS: 'organisationPKs[]',
                URL_PARAM_PERSON_TYPES: 'personTypes',
                URL_PARAM_QUERY: 'name',
                URL_PARAM_WITH_EMAIL: 'withEmail'
            };
            this._createBasicQuery();
            this.urlConnection.setUrl(this.url);
        }
        _createBasicQuery() {
            const q = {};
            q[this.constants.URL_PARAM_LIMIT] = this.limit;
            q[this.constants.URL_PARAM_OFFSET] = this.offset;
            q[this.constants.URL_PARAM_FILTER_FIELD] = this.filterField;
            if (this.active) {
                q[this.constants.URL_PARAM_ACTIVE] = this.active;
            }
            if (this.query && this.query !== '') {
                q[this.constants.URL_PARAM_QUERY] = this.query;
            }
            if (this.personType !== null) {
                q[this.constants.URL_PARAM_PERSON_TYPES] = this.personType;
            }
            if (this.includeLabour !== null) {
                q[this.constants.URL_PARAM_INCLUDE_LABOUR] = this.includeLabour ? 1 : 0;
            }
            if (this.organisationPKs !== null) {
                q[this.constants.URL_PARAM_ORGANISATION_PKS] = this.organisationPKs;
            }
            if (this.withEmail) {
                q[this.constants.URL_PARAM_WITH_EMAIL] = this.withEmail;
            }
            return q;
        }
        setActive(value) {
            this.active = value;
        }
        setLimit(value) {
            this.limit = value;
        }
        setOffset(value) {
            this.offset = value;
        }
        setQuery(value) {
            this.query = value;
        }
        setPersonType(value) {
            this.personType = value;
        }
        setFilterField(value) {
            this.filterField = value;
        }
        setIncludeLabour(value) {
            this.includeLabour = value;
        }
        setOrganisationPKs(organisationPKs) {
            this.organisationPKs = organisationPKs;
        }
        setWithEmail() {
            this.withEmail = PersonCollection.WITH_EMAIL;
        }
        fetch(handlers) {
            this.urlConnection.setQuery(this._createBasicQuery());
            this.urlConnection.setSuccessHandler(this.urlResponseProcessorBuilder.createProcessor(this.parser, handlers.getSuccess(), handlers.getError()));
            this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
            this.urlConnection.setProgressHandler(handlers.getProgress());
            this.urlConnection.setErrorHandler(handlers.getError());
            return this.urlConnection.get();
        }
    }
    PersonCollection.WITH_EMAIL = 1;
    return PersonCollection;
});

},
'@lib/api/person/ProfilePicture':function(){
define(["require", "exports", "@lib/request/data/HTTPResponseCodes"], function (require, exports, HTTPResponseCodes) {
    "use strict";
    const ERROR_NOT_FOUND = 'NOT_FOUND';
    class ProfilePicture {
        constructor(fetchFactory, parser, url) {
            this.parser = parser;
            this.url = url;
            this.processor = fetchFactory.get();
        }
        async get(personPK) {
            this.processor.setSuccessHandler(async (response) => {
                const data = await response.json();
                return this.parser.parse(data['revision']);
            });
            this.processor.setHandler(HTTPResponseCodes.not_found, async () => ERROR_NOT_FOUND);
            return this.processor.get(this.url.replace(':id', personPK.toString()));
        }
    }
    return ProfilePicture;
});

},
'@lib/api/person/Team':function(){
define(["require", "exports", "@lib/request/data/HTTPResponseCodes"], function (require, exports, HTTPResponseCodes) {
    "use strict";
    const ERROR_NOT_FOUND = 'NOT_FOUND';
    class Team {
        constructor(factory, parser, url) {
            this.parser = parser;
            this.url = url;
            this.processor = factory.get();
        }
        async get(personPK) {
            this.processor.setSuccessHandler(async (response) => {
                const data = await response.json();
                return this.parser.parse(data);
            });
            this.processor.setHandler(HTTPResponseCodes.not_found, async () => ERROR_NOT_FOUND);
            return this.processor.get(this.url.replace(':id', personPK.toString()));
        }
    }
    return Team;
});

},
'api/project/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    const Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_allowance = 'projects/allowance/';
        this.api_budget_activity_code = 'projects/budget/activity-code/';
        this.api_budget_allowance = 'projects/budget/allowance/';
        this.api_my_projects = 'my-projects/';
        this.api_general_stage = 'project/stage/general';
        this.api_project = 'project/';
        this.api_project_by_project_stage = 'project-stage/:projectStagePK/project/';
        this.api_project_collection = 'project/';
        this.api_project_nominated_role = 'projects/:projectStagePK/nominated-role/:roleName';
        this.api_project_nominated_role_collection = 'projects/:projectStagePK/nominated-role/';
        this.api_project_site = 'projects/:projectStagePK/site/:projectSitePK';
        this.api_project_site_collection = 'project/site'
        this.api_project_site_collection = 'projects/:projectStagePK/site/';
        this.api_project_site_create = 'project/site';
        this.api_project_stage = 'project-stage';
        this.api_project_stage_budget = 'project-stage/budget/';
        this.api_get_project_stage_budget = 'project-stage/budget/:projectStagePK';
        this.api_put_project_stage_budget = 'project-stage/budget/:projectStagePK';
        this.api_project_stage_budget_status_collection = 'project-stage/budget/status';
        this.api_project_stage_contract = 'project-stage/contract/';
        this.api_get_project_stage_contract = 'project-stage/contract/:projectStagePK';
        this.api_put_project_stage_contract = 'project-stage/contract/:projectStagePK';
        this.api_project_stage_intelligence = 'project-stage/intelligence';
        this.api_project_stage_lead = 'project-stage/lead';
        this.api_get_project_stage_intelligence = 'project-stage/intelligence/:projectStagePK';
        this.api_put_project_stage_intelligence = 'project-stage/intelligence/:projectStagePK';
        this.api_get_project_stage_lead = 'project-stage/lead/:projectStagePK';
        this.api_put_project_stage_lead = 'project-stage/lead/:projectStagePK';
        this.api_project_stage_lead_team = 'project-stage/lead-team/';
        this.api_project_stage_member_collection = 'project-stage/:id/member';
        this.api_project_stage_number_range_collection = 'project-stage/number-range';
        this.api_project_stage_prequal = 'project-stage/prequal/';
        this.api_get_project_stage_prequal = 'project-stage/prequal/:projectStagePK';
        this.api_put_project_stage_prequal = 'project-stage/prequal/:projectStagePK';
        this.api_project_stage_prequal_for_collection = 'project-stage/prequal/for';
        this.api_project_stage_tender = 'project-stage/tender/';
        this.api_get_project_stage_tender = 'project-stage/tender/:projectStagePK';
        this.api_put_project_stage_tender = 'project-stage/tender/:projectStagePK';
        this.api_project_stage_tender_offer = 'project-stage/tender-offer/';
        this.api_get_project_stage_tender_offer = 'project-stage/tender-offer/:projectStagePK';
        this.api_put_project_stage_tender_offer = 'project-stage/tender-offer/:projectStagePK';
        this.api_project_stage_type_collection = 'project-stage/type';
        this.api_project_stages = 'project-stages/';
        this.api_project_tender_type_collection = 'project/tender-type';
        this.api_put_project_estimated_dates = 'project/:projectPK/estimated-dates/';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});

},
'api/project/Factory':function(){
define([
    '../parser/Collection',
    '../person/parser/Person',
    './parser/ActivityCode',
    './parser/Allowance',
    './parser/BudgetAllowance',
    './parser/NominatedRole',
    './parser/NominatedRoleCollection',
    './parser/ProjectStage',
    './parser/ProjectSite',
    './parser/ProjectSiteCollection',
    './parser/Role',
    'spencer/core/parser/Address',
    'spencer/core/parser/Project',
    'spencer/core/parser/ProjectCollection',
    'spencer/parse/JSONParser',
    './Allowance',
    './AllowanceCollection',
    './BudgetActivityCode',
    './BudgetActivityCodeCollection',
    './BudgetAllowance',
    './BudgetAllowanceCollection',
    './MyProjectCollection',
    './NominatedRole',
    './NominatedRoleCollection',
    './Create',
    './GetByProjectStage',
    './ProjectCollection',
    './ProjectStage',
    './ProjectStageCollection',
    './ProjectSite',
    './ProjectSiteCollection'
], function(
    CollectionParser,
    PersonParser,
    ActivityCodeParser,
    AllowanceParser,
    BudgetAllowanceParser,
    NominatedRoleParser,
    NominatedRoleCollectionParser,
    ProjectStageParser,
    ProjectSiteParser,
    ProjectSiteCollectionParser,
    RoleParser,
    AddressParser,
    ProjectParser,
    ProjectCollectionParser,
    JsonParser,
    Allowance,
    AllowanceCollection,
    BudgetActivityCode,
    BudgetActivityCodeCollection,
    BudgetAllowance,
    BudgetAllowanceCollection,
    MyProjectCollection,
    NominatedRole,
    NominatedRoleCollection,
    ProjectCreate,
    ProjectGetByProjectStage,
    ProjectCollection,
    ProjectStage,
    ProjectStageCollection,
    ProjectSite,
    ProjectSiteCollection
) {
    var Factory = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;

        this.getProjectSiteParser = function() {
            return new ProjectSiteParser(
                new AddressParser()
            );
        };

        this.getNominatedRoleParser = function() {
            return new NominatedRoleParser(
                new RoleParser(),
                new PersonParser()
            )
        };
    };

    Factory.prototype.getAllowance = function() {
        var c = new CollectionParser(new AllowanceParser());
        c.setIsSingleItemCollection(true);

        return new Allowance(
            this.config.getUrl('api_allowance'),
            this.urlConnectionBuilder.build(),
            c,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getAllowanceCollection = function() {
        return new AllowanceCollection(
            this.config.getUrl('api_allowance'),
            this.urlConnectionBuilder.build(),
            new CollectionParser(new AllowanceParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getBudgetAllowance = function() {
        return new BudgetAllowance(
            this.config.getUrl('api_budget_allowance'),
            this.urlConnectionBuilder.build(),
            new BudgetAllowanceParser(),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getBudgetAllowanceCollection = function() {
        return new BudgetAllowanceCollection(
            this.config.getUrl('api_budget_allowance'),
            this.urlConnectionBuilder.build(),
            new CollectionParser(new BudgetAllowanceParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getBudgetActivityCode = function() {
        var c = new CollectionParser(new ActivityCodeParser());
        c.setIsSingleItemCollection(true);
        
        return new BudgetActivityCode(
            this.config.getUrl('api_budget_activity_code'),
            this.urlConnectionBuilder.build(),
            c,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getBudgetActivityCodeCollection = function() {
        return new BudgetActivityCodeCollection(
            this.config.getUrl('api_budget_activity_code'),
            this.urlConnectionBuilder.build(),
            new CollectionParser(new ActivityCodeParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getMyProjectCollection = function() {
        return new MyProjectCollection(
            this.config.getUrl('api_my_projects'),
            this.urlConnectionBuilder.build(),
            new CollectionParser(new ProjectStageParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getProjectCreate = function() {
        return new ProjectCreate(
            this.config.getUrl('api_project', 'v2/'),
            this.urlConnectionBuilder.build(),
            this.urlResponseProcessorBuilder,
            new JsonParser(new ProjectParser())
        );
    };

    Factory.prototype.getProjectGetByProjectStage = function() {
        return new ProjectGetByProjectStage(
            this.config.getUrl('api_project_by_project_stage', 'v2/'),
            this.urlConnectionBuilder.build(),
            this.urlResponseProcessorBuilder,
            new JsonParser(new ProjectParser())
        );
    };

    Factory.prototype.getProjectCollection = function() {
        return new ProjectCollection(
            this.config.getUrl('api_project', 'v2/'),
            this.urlConnectionBuilder.build(),
            this.urlResponseProcessorBuilder,
            new JsonParser(new ProjectCollectionParser())
        );
    };

    Factory.prototype.getProjectStage = function() {
        var c = new CollectionParser(new ProjectStageParser());
        c.setIsSingleItemCollection(true);
        
        return new ProjectStage(
            this.config.getUrl('api_project_stages'),
            this.urlConnectionBuilder.build(),
            c,
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getProjectStageCollection = function() {
        return new ProjectStageCollection(
            this.config.getUrl('api_project_stages'),
            this.urlConnectionBuilder.build(),
            new CollectionParser(new ProjectStageParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getProjectSiteCollection = function() {
        return new ProjectSiteCollection(
            this.config.getUrl('api_project_site_collection'),
            this.urlConnectionBuilder.build(),
            this.urlResponseProcessorBuilder,
            new CollectionParser(new ProjectSiteCollectionParser(this.getProjectSiteParser()))
        );
    };

    Factory.prototype.getProjectSite = function() {
        var c = new CollectionParser(this.getProjectSiteParser());
        c.setIsSingleItemCollection(true);

        return new ProjectSite(
            this.config.getUrl('api_project_site'),
            this.urlConnectionBuilder.build(),
            this.urlResponseProcessorBuilder,
            c
        );
    };

    Factory.prototype.getNominatedRoleCollection = function() {
        return new NominatedRoleCollection(
            this.config.getUrl('api_project_nominated_role_collection'),
            this.urlConnectionBuilder.build(),
            this.urlResponseProcessorBuilder,
            new CollectionParser(new NominatedRoleCollectionParser(this.getNominatedRoleParser()))
        );
    };

    Factory.prototype.getNominatedRole = function() {
        var c = new CollectionParser(this.getNominatedRoleParser());
        c.setIsSingleItemCollection(true);

        return new NominatedRole(
            this.config.getUrl('api_project_nominated_role'),
            this.urlConnectionBuilder.build(),
            this.urlResponseProcessorBuilder,
            c
        );
    };

    return Factory;
});
},
'api/project/parser/ActivityCode':function(){
define([
    "../data/ActivityCode"
], function(ActivityCodeVO) {
    var ActivityCode = function() {
    };

    ActivityCode.prototype.parse = function(item) {
        var ac = new ActivityCodeVO();

        ac.setProjectBudgetAllowancePK(item.projectBudgetAllowancePK || null);
        ac.setName(item.name || null);
        ac.setDescription(item.description || null);

        return ac;
    };

    return ActivityCode;
});
},
'api/project/data/ActivityCode':function(){
define([], function() {
    var ActivityCode = function() {
        this.projectBudgetAllowancePK = null;
        this.projectAllowancePK = null;
        this.name = null;
        this.description = null;
        this.type = null;
    };

    ActivityCode.prototype.getProjectBudgetAllowancePK = function() {
        return this.projectBudgetAllowancePK;
    };

    ActivityCode.prototype.setProjectBudgetAllowancePK = function(projectBudgetAllowancePK) {
        this.projectBudgetAllowancePK = projectBudgetAllowancePK;
    };

    ActivityCode.prototype.getProjectAllowancePK = function() {
        return this.projectAllowancePK;
    };

    ActivityCode.prototype.setProjectAllowancePK = function(projectAllowancePK) {
        this.projectAllowancePK = projectAllowancePK;
    };

    ActivityCode.prototype.getName = function() {
        return this.name;
    };

    ActivityCode.prototype.setName = function(name) {
        this.name = name;
    };

    ActivityCode.prototype.getDescription = function() {
        return this.description;
    };

    ActivityCode.prototype.setDescription = function(description) {
        this.description = description;
    };

    ActivityCode.prototype.getType = function() {
        return this.type;
    };

    ActivityCode.prototype.setType = function(type) {
        this.type = type;
    };

    return ActivityCode;
});
},
'api/project/parser/Allowance':function(){
define([
    "../data/Allowance"
], function(AllowanceVO) {
    var Allowance = function() {
    };

    Allowance.prototype.parse = function(item) {
        var a = new AllowanceVO();

        a.setProjectAllowancePK(item.projectAllowancePK || null);
        a.setLabel(item.label || null);

        return a;
    };

    return Allowance;
});
},
'api/project/data/Allowance':function(){
define([], function() {
    var Allowance = function() {
        this.projectAllowancePK = null;
        this.label = null;
    };

    Allowance.prototype.getProjectAllowancePK = function() {
        return this.projectAllowancePK;
    };

    Allowance.prototype.setProjectAllowancePK = function(projectAllowancePK) {
        this.projectAllowancePK = projectAllowancePK;
    };

    Allowance.prototype.getLabel = function() {
        return this.label;
    };

    Allowance.prototype.setLabel = function(label) {
        this.label = label;
    };

    return Allowance;
});
},
'api/project/parser/BudgetAllowance':function(){
define([
    "../data/ActivityCode"
], function(ActivityCodeVO) {
    var BudgetAllowance = function() {
    };

    BudgetAllowance.prototype.parse = function(item) {
        var ac = new ActivityCodeVO();

        ac.setProjectBudgetAllowancePK(item.projectBudgetAllowancePK || null);
        ac.setProjectAllowancePK(item.projectAllowancePK || null);
        ac.setName(item.name || null);
        ac.setDescription(item.description || null);
        ac.setType(item.type || null);

        return ac;
    };

    return BudgetAllowance;
});
},
'api/project/parser/NominatedRole':function(){
define([
    "../data/NominatedRole"
], function (NominatedRoleVO) {
    var NominatedRole = function (roleParser, personParser) {
        this.roleParser = roleParser;
        this.personParser = personParser;
    };

    NominatedRole.prototype.parse = function(values) {
        var vo = new NominatedRoleVO();

        if (typeof(values) != "undefined") {
            vo.setRole(this.roleParser.parse(values.role));
            vo.setRoleHolder(this.personParser.parse(values.roleHolder));
            vo.setReportsTo(this.personParser.parse(values.reportsTo));
        }

        return vo;
    };

    return NominatedRole;
});
},
'api/project/data/NominatedRole':function(){
define([], function() {
    var NominatedRole = function() {
        this.role = null;
        this.roleHolder = null;
        this.reportsTo = null;
    };

    NominatedRole.prototype.setRole = function(role) {
        this.role = role;
        return this;
    };

    NominatedRole.prototype.getRole = function() {
        return this.role;
    };

    NominatedRole.prototype.setRoleHolder = function(roleHolder) {
        this.roleHolder = roleHolder;
        return this;
    };

    NominatedRole.prototype.getRoleHolder = function() {
        return this.roleHolder;
    };

    NominatedRole.prototype.setReportsTo = function(reportsTo) {
        this.reportsTo = reportsTo;
        return this;
    };

    NominatedRole.prototype.getReportsTo = function() {
        return this.reportsTo;
    };

    return NominatedRole;
});
},
'api/project/parser/NominatedRoleCollection':function(){
define([], function () {
    var NominatedRoleCollection = function (nominatedRoleParser) {
        this.nominatedRoleParser = nominatedRoleParser;
    };

    NominatedRoleCollection.prototype.parse = function(values) {
        var nominatedRoles = [];

        for (var i = 0; i < values.length; i++) {
            nominatedRoles.push(this.nominatedRoleParser.parse(values[i]));
        }

        return nominatedRoles;
    };

    return NominatedRoleCollection;
});
},
'api/project/parser/ProjectStage':function(){
define([
    '../data/ProjectStage'
], function(ProjectStageVO) {
    const Project = function() {};

    Project.prototype.parse = function(item) {
        const p = new ProjectStageVO();

        p.setProjectStagePK(parseInt(item.projectStagePK) || null);
        p.setProjectPK(parseInt(item.projectPK) || null);
        p.setTitle(item.title || '');
        p.setStageNumber(item.stageNo || item.stageNumber || '');
        p.setOrganisationPK(parseInt(item.organisationPK) || null);
        p.setIsActive(
            (item.isActive === null || item.isActive === undefined)
                ? null
                : Boolean(item.isActive)
        );

        return p;
    };

    return Project;
});
},
'api/project/data/ProjectStage':function(){
define([], function() {
    /**
     * Deprecated use 'spencer/core/data/ProjectStage.js' instead.
     */
    const ProjectStage = function() {
        this.projectStagePK = null;
        this.projectPK = null;
        this.title = '';
        this.stageNo = '';
        this.stageNumber = '';
        this.organisationPK = null;
        this.type = null;
        this.active = null;
    };

    ProjectStage.prototype.getProjectStagePK = function() {
        return this.projectStagePK;
    };

    ProjectStage.prototype.setProjectStagePK = function(projectStagePK) {
        this.projectStagePK = projectStagePK;
        return this;
    };

    ProjectStage.prototype.getProjectPK = function() {
        return this.projectPK;
    };

    ProjectStage.prototype.setProjectPK = function(projectPK) {
        this.projectPK = projectPK;
        return this;
    };

    ProjectStage.prototype.getTitle = function() {
        return this.title;
    };

    ProjectStage.prototype.setTitle = function(title) {
        this.title = title;
        return this;
    };

    ProjectStage.prototype.getStageNumber = function() {
        return this.stageNumber;
    };

    ProjectStage.prototype.setStageNumber = function(stageNumber) {
        this.stageNumber = stageNumber;
        this.stageNo = stageNumber;
        return this;
    };

    ProjectStage.prototype.getOrganisationPK = function() {
        return this.organisationPK;
    };

    ProjectStage.prototype.setOrganisationPK = function(organisationPK) {
        this.organisationPK = organisationPK;
        return this;
    };

    ProjectStage.prototype.setType = function (type) {
        this.type = type;
        return this;
    };

    ProjectStage.prototype.getType = function () {
        return this.type;
    };

    ProjectStage.prototype.isActive = function() {
        return this.getIsActive();
    };

    ProjectStage.prototype.setIsActive = function(active) {
        this.active = active;
        return this;
    };

    ProjectStage.prototype.getIsActive = function() {
        return this.active;
    };

    return ProjectStage;
});
},
'api/project/parser/ProjectSite':function(){
define([
    "../data/ProjectSite"
], function (ProjectSiteVO) {
    var ProjectSite = function (addressParser) {
        this.addressParser = addressParser;
    };

    ProjectSite.prototype.parse = function(values) {
        var vo = new ProjectSiteVO();

        if (typeof(values) != "undefined") {
            vo.setProjectPK(values.projectPK)
                .setProjectStagePK(values.projectStagePK)
                .setProjectSitePK(values.projectSitePK)
                .setSiteName(values.siteName)
                .setTelephone(values.telephone)
                .setFax(values.fax)
                .setInstructions(values.instructions)
                .setDocumentPKs(values.documentPKs || []);

            if (values.documentLocation) {
                const docLocation = values.documentLocation;
                vo.setDocumentLocationNode(docLocation.projectStage.concat(' => ', docLocation.node));
            }

            vo.setAddress(this.addressParser.parse(values));
        }

        return vo;
    };

    return ProjectSite;
});
},
'api/project/data/ProjectSite':function(){
define([], function() {
    return class ProjectSite {
        constructor() {
            this.projectPK = null;
            this.projectStagePK = null;
            this.projectSitePK = null;
            this.siteName = null;
            this.address = null;
            this.telephone = null;
            this.fax = null;
            this.instructions = null;
            this.documentPKs = [];
            this.documentLocationNode = '';
        };

        setProjectPK(projectPK) {
            this.projectPK = projectPK;
            return this;
        }

        getProjectPK() {
            return this.projectPK;
        }

        getProjectStagePK() {
            return this.projectStagePK;
        };

        setProjectStagePK(projectStagePK) {
            this.projectStagePK = projectStagePK;
            return this;
        };

        setProjectSitePK(projectSitePK) {
            this.projectSitePK = projectSitePK;
            return this;
        };

        getProjectSitePK() {
            return this.projectSitePK;
        };

        setSiteName(siteName) {
            this.siteName = siteName;
            return this;
        };

        getSiteName() {
            return this.siteName;
        };

        setAddress(address) {
            this.address = address;
            return this;
        };

        getAddress() {
            return this.address;
        };

        setTelephone(telephone) {
            this.telephone = telephone;
            return this;
        };

        getTelephone() {
            return this.telephone;
        };

        setFax(fax) {
            this.fax = fax;
            return this;
        };

        getFax() {
            return this.fax;
        };

        setInstructions(instructions) {
            this.instructions = instructions;
            return this;
        };

        getInstructions() {
            return this.instructions;
        };

        setDocumentPKs(documentPKs) {
            this.documentPKs = documentPKs;
            return this;
        };

        addDocumentPK(documentPK) {
            this.documentPKs.push(documentPK);
            return this;
        };

        getDocumentPKs() {
            return this.documentPKs;
        };

        setDocumentLocationNode(documentLocationNode) {
            this.documentLocationNode = documentLocationNode;
            return this;
        };

        getDocumentLocationNode() {
            return this.documentLocationNode;
        };

        equals(site) {
            const siteName = this.siteName ? this.siteName.trim() : null;
            const incomingSiteName = site.siteName ? site.siteName.trim() : null;
            const telephone = this.telephone ? this.telephone.trim() : null;
            const incomingTelephone = site.telephone ? site.telephone.trim() : null;
            const fax = this.fax ? this.fax.trim() : null;
            const incomingFax = site.fax ? site.fax.trim() : null;
            const instructions = this.instructions ? this.instructions.trim() : null;
            const incomingInstructions = site.instructions ? site.instructions.trim() : null;

            return this.projectPK === site.projectPK
                && this.projectStagePK === site.projectStagePK
                && this.projectSitePK === site.projectSitePK
                && siteName === incomingSiteName
                && this.address.equals(site.address)
                && telephone === incomingTelephone
                && fax === incomingFax
                && instructions === incomingInstructions
                && this._documentPKsEqual(this.documentPKs, site.documentPKs)
                && this.documentLocationNode === site.documentLocationNode;
        };

        clone() {
            return new ProjectSite()
                .setProjectPK(this.projectPK)
                .setProjectStagePK(this.projectStagePK)
                .setProjectSitePK(this.projectSitePK)
                .setSiteName(this.siteName)
                .setAddress(this.address.clone())
                .setTelephone(this.telephone)
                .setFax(this.fax)
                .setInstructions(this.instructions)
                .setDocumentPKs(this.documentPKs)
                .setDocumentLocationNode(this.documentLocationNode);
        }

        _documentPKsEqual(array1, array2) {
            return (array1.length === array2.length)
                && array1.every((element, index) => element === array2[index]);
        }
    }
});

},
'api/project/parser/ProjectSiteCollection':function(){
define([], function () {
    var ProjectSiteCollection = function (projectSiteParser) {
        this.projectSiteParser = projectSiteParser;
    };

    ProjectSiteCollection.prototype.parse = function(values) {
        var projectSites = [];

        for (var i = 0; i < values.length; i++) {
            projectSites.push(this.projectSiteParser.parse(values[i]));
        }

        return projectSites;
    };

    return ProjectSiteCollection;
});
},
'api/project/parser/Role':function(){
define([
    "../data/Role"
], function (RoleVO) {
    var Role = function () {

    };

    Role.prototype.parse = function(values) {
        var vo = new RoleVO();

        if (typeof(values) != 'undefined') {
            vo.setRolePK(values.rolePK)
                .setRole(values.role);
        }

        return vo;
    };

    return Role;
});
},
'api/project/data/Role':function(){
define([], function() {
    var Role = function() {
        this.rolePK = null;
        this.role = null;
    };

    Role.prototype.setRolePK = function(rolePK) {
        this.rolePK = rolePK;
        return this;
    };

    Role.prototype.getRolePK = function() {
        return this.rolePK;
    };

    Role.prototype.setRole = function(role) {
        this.role = role;
        return this;
    };

    Role.prototype.getRole = function() {
        return this.role;
    };

    return Role;
});
},
'spencer/core/parser/Project':function(){
define([
    '../data/Project',
    './Organisation',
    './ProjectStageCollection'
], function(
    ProjectVO,
    OrganisationParser,
    ProjectStageCollectionParser
) {
    const Project = function() {
        this.organisationParser = new OrganisationParser();
        this.projectStageCollectionParser = new ProjectStageCollectionParser();

        this._parseOrganisation = function (organisation) {
            if (organisation && organisation.organisationPK) {
                return this.organisationParser.parse(organisation);
            }

            return null;
        }

        this._parseProjectStageCollection = function (projectStageCollection) {
            if (projectStageCollection) {
                return this.projectStageCollectionParser.parse(projectStageCollection);
            }

            return [];
        }
    };

    Project.prototype.parse = function(item) {
        return (new ProjectVO())
            .setProjectPK(item.projectPK || null)
            .setTitle(item.title || null)
            .setProjectStageCollection(this._parseProjectStageCollection(item.projectStageCollection))
            .setOwnerOrganisation(this._parseOrganisation(item.ownerOrganisation))
            .setClientOrganisation(this._parseOrganisation(item.clientOrganisation));
    };

    return Project;
});
},
'spencer/core/data/Project':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Project {
        constructor() {
            this.projectPK = null;
            this.projectStageCollection = [];
            this.title = null;
            this.ownerOrganisation = null;
            this.clientOrganisation = null;
        }
        getProjectPK() {
            return this.projectPK;
        }
        setProjectPK(projectPK) {
            this.projectPK = projectPK;
            return this;
        }
        addProjectStage(projectStage) {
            this.projectStageCollection.push(projectStage);
            return this;
        }
        getProjectStageCollection() {
            return this.projectStageCollection;
        }
        setProjectStageCollection(projectStageCollection) {
            this.projectStageCollection = projectStageCollection;
            return this;
        }
        getTitle() {
            return this.title;
        }
        setTitle(title) {
            this.title = title;
            return this;
        }
        getOwnerOrganisation() {
            return this.ownerOrganisation;
        }
        setOwnerOrganisation(ownerOrganisation) {
            this.ownerOrganisation = ownerOrganisation;
            return this;
        }
        getClientOrganisation() {
            return this.clientOrganisation;
        }
        setClientOrganisation(clientOrganisation) {
            this.clientOrganisation = clientOrganisation;
            return this;
        }
    }
    return Project;
});

},
'spencer/core/parser/ProjectStageCollection':function(){
define([
    'spencer/core/parser/ProjectStage',
    'spencer/core/data/ProjectStageCollection'
], function (
    ProjectStageParser,
    ProjectStageCollectionVO
) {
    const ProjectStageCollection = function () {
        this.parser = new ProjectStageParser();
    };

    ProjectStageCollection.prototype.parse = function(projectStages) {
        let collection = new ProjectStageCollectionVO();

        for (let i = 0; i < projectStages.length; i++) {
            collection.add(this.parser.parse(projectStages[i]));
        }

        return collection;
    };

    return ProjectStageCollection;
});

},
'spencer/core/data/ProjectStageCollection':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class ProjectStageCollection {
        constructor() {
            this.projectStage = [];
        }
        add(projectStage) {
            this.projectStage.push(projectStage);
            return this;
        }
        ;
        get() {
            return this.projectStage;
        }
        ;
    }
    return ProjectStageCollection;
});

},
'spencer/core/parser/ProjectCollection':function(){
define([
    'spencer/core/parser/Project',
    'spencer/core/data/ProjectCollection'
], function (
    ProjectParser,
    ProjectCollectionVO
) {
    const ProjectCollection = function () {
        this.parser = new ProjectParser;
    };

    ProjectCollection.prototype.parse = function(projects) {
        const collection = new ProjectCollectionVO;

        for (let i = 0; i < projects.length; i++) {
            collection.add(this.parser.parse(projects[i]));
        }

        return collection;
    };

    return ProjectCollection;
});
},
'spencer/core/data/ProjectCollection':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class ProjectCollection {
        constructor() {
            this.project = [];
        }
        add(project) {
            this.project.push(project);
            return this;
        }
        get() {
            return this.project;
        }
    }
    return ProjectCollection;
});

},
'api/project/Allowance':function(){
define([], function() {
    var Allowance = function(url, urlConnection, collectionParser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = collectionParser;
    };

    Allowance.prototype.get = function(handlers, projectAllowanceVO) {
        this.urlConnection.setUrl(this.url + projectAllowanceVO.getProjectAllowancePK());

        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return Allowance;
});
},
'api/project/AllowanceCollection':function(){
define([], function() {
    var AllowanceCollection = function(url, urlConnection, collectionParser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.urlConnection.setUrl(this.url);
        this.parser = collectionParser;

        this.forOrders = null;
        this.query = "";

        this.constants = {
            URL_PARAM_FOR_ORDERS: "forOrders",
            URL_PARAM_SEARCH_QUERY: "search"
        };

        this.createBasicQuery = function() {
            var q = {};

            if (this.query) {
                q[this.constants.URL_PARAM_SEARCH_QUERY] = this.query;
            }
            if (this.forOrders) {
                q[this.constants.URL_PARAM_FOR_ORDERS] = 1;
            }

            return q;
        };
    };

    AllowanceCollection.prototype.setForOrders = function(forOrders) {
        this.forOrders = forOrders;
    };

    AllowanceCollection.prototype.setQuery = function(query) {
        this.query = query;
    };

    AllowanceCollection.prototype.fetch = function(handlers) {
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());
        this.urlConnection.setQuery(this.createBasicQuery());

        return this.urlConnection.get();
    };

    return AllowanceCollection;
});
},
'api/project/BudgetActivityCode':function(){
define([], function() {
    var BudgetActivityCode = function(url, urlConnection, collectionParser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = collectionParser;
        this.allowance = null;
    };

    BudgetActivityCode.prototype.get = function(handlers, projectBudgetAllowancePK) {
        this.urlConnection.setUrl(this.url + projectBudgetAllowancePK);
        
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return BudgetActivityCode;
});
},
'api/project/BudgetActivityCodeCollection':function(){
define([], function() {
    var BudgetActivityCodeCollection = function(url, urlConnection, collectionParser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.urlConnection.setUrl(this.url);
        this.parser = collectionParser;
        this.allowance = null;
        this.allowances = null;

        this.isQueryable = false;
        this.query = null;
        this.limit = null;
        this.offset = null;

        this.constants = {
            URL_PARAM_PROJECT_STAGE_PK: "projectStagePK",
            URL_PARAM_ALLOWANCE_PK: "allowancePK",
            URL_PARAM_ALLOWANCE_PKS: "allowancePKs[]",
            URL_PARAM_SEARCH_QUERY: "query",
            URL_PARAM_LIMIT: "limit",
            URL_PARAM_OFFSET: "offset"
        };
        
        this.createQuery = function(projectStage) {
            var q = {};

            q[this.constants.URL_PARAM_PROJECT_STAGE_PK] = projectStage.getProjectStagePK();

            if (this.allowance) {
                q[this.constants.URL_PARAM_ALLOWANCE_PK] = this.allowance.getProjectAllowancePK();
            }

            if (this.allowances) {
                q[this.constants.URL_PARAM_ALLOWANCE_PKS] = this.allowances;
            }

            if (this.query && this.isQueryable) {
                q[this.constants.URL_PARAM_SEARCH_QUERY] = this.query;
            }

            if (this.limit) {
                q[this.constants.URL_PARAM_LIMIT] = this.limit;
            }

            if (this.offset === 0 || this.offset) {
                q[this.constants.URL_PARAM_OFFSET] = this.offset;
            }

            return q;
        };
    };

    BudgetActivityCodeCollection.prototype.setIsQueryable = function(isQueryable) {
        this.isQueryable = isQueryable;
    };

    BudgetActivityCodeCollection.prototype.setQuery = function(query) {
        this.query = query;
    };

    BudgetActivityCodeCollection.prototype.setLimit = function(limit) {
        this.limit = limit;
    };

    BudgetActivityCodeCollection.prototype.setOffset = function(offset) {
        this.offset = offset;
    };
    
    BudgetActivityCodeCollection.prototype.setAllowance = function(allowance) {
        this.allowance = allowance;
    };

    BudgetActivityCodeCollection.prototype.setAllowances = function(allowances) {
        this.allowances = allowances;
    };

    BudgetActivityCodeCollection.prototype.fetch = function(handlers, projectStage) {
        this.urlConnection.setQuery(this.createQuery(projectStage));
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return BudgetActivityCodeCollection;
});
},
'api/project/BudgetAllowance':function(){
define([], function() {
    var BudgetAllowance = function(url, urlConnection, collectionParser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = collectionParser;
        this.allowance = null;
    };

    BudgetAllowance.prototype.get = function(handlers, projectBudgetAllowancePK) {
        this.urlConnection.setUrl(this.url + projectBudgetAllowancePK);

        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return BudgetAllowance;
});
},
'api/project/BudgetAllowanceCollection':function(){
define([], function() {
    var BudgetAllowanceCollection = function(url, urlConnection, collectionParser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.urlConnection.setUrl(this.url);
        this.parser = collectionParser;

        this.query = null;
        this.limit = null;
        this.offset = null;
        this.allowance = null;
        this.allowances = [];

        this.constants = {
            URL_PARAM_PROJECT_STAGE_PK: "projectStagePK",
            URL_PARAM_ALLOWANCE_PK: "allowancePK",
            URL_PARAM_ALLOWANCE_PKS: "allowancePKs[]",
            URL_PARAM_SEARCH_QUERY: "query",
            URL_PARAM_LIMIT: "limit",
            URL_PARAM_OFFSET: "offset"
        };

        this.createQuery = function(projectStage) {
            var q = {};

            q[this.constants.URL_PARAM_PROJECT_STAGE_PK] = projectStage.getProjectStagePK();

            if (this.query) {
                q[this.constants.URL_PARAM_SEARCH_QUERY] = this.query;
            }

            if (this.limit) {
                q[this.constants.URL_PARAM_LIMIT] = this.limit;
            }

            if (this.offset === 0 || this.offset) {
                q[this.constants.URL_PARAM_OFFSET] = this.offset;
            }

            if (this.allowance) {
                q[this.constants.URL_PARAM_ALLOWANCE_PK] = this.allowance;
            }

            if (this.allowances.length) {
                q[this.constants.URL_PARAM_ALLOWANCE_PKS] = this.allowances;
            }

            return q;
        };
    };

    BudgetAllowanceCollection.prototype.setQuery = function(query) {
        this.query = query;
    };

    BudgetAllowanceCollection.prototype.setLimit = function(limit) {
        this.limit = limit;
    };

    BudgetAllowanceCollection.prototype.setOffset = function(offset) {
        this.offset = offset;
    };

    BudgetAllowanceCollection.prototype.setAllowance = function(allowance) {
        this.allowance = allowance.getProjectAllowancePK();
    };

    BudgetAllowanceCollection.prototype.setAllowances = function(allowances) {
        this.allowances = allowances;
    };

    BudgetAllowanceCollection.prototype.fetch = function(handlers, projectStage) {
        this.urlConnection.setQuery(this.createQuery(projectStage));
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return BudgetAllowanceCollection;
});
},
'api/project/MyProjectCollection':function(){
define([], function() {
    var MyProjectCollection = function(url, urlConnection, collectionParser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.urlConnection.setUrl(this.url);
        this.parser = collectionParser;
    };

    MyProjectCollection.prototype.fetch = function(handlers) {
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return MyProjectCollection;
});
},
'api/project/NominatedRole':function(){
define([], function() {
    var NominatedRole = function(url, urlConnection, urlResponseProcessorBuilder, parser) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this.constants = {
            PLACEHOLDER_PROJECT_STAGE_PK: ':projectStagePK',
            PLACEHOLDER_ROLE_NAME: ':roleName'
        };

        this.performPlaceholderSubstitution = function(projectStageVO, roleVO) {
            var url = this.url;

            return url
                .replace(this.constants.PLACEHOLDER_PROJECT_STAGE_PK, projectStageVO.getProjectStagePK())
                .replace(this.constants.PLACEHOLDER_ROLE_NAME, roleVO.getRole());
        }
    };

    NominatedRole.prototype.get = function(handlers, projectStageVO, roleVO) {
        if (projectStageVO && roleVO) {

            this.urlConnection.setUrl(this.performPlaceholderSubstitution(projectStageVO, roleVO));

            this.urlConnection.setSuccessHandler(
                this.urlResponseProcessorBuilder.createProcessor(
                    this.parser,
                    handlers.getSuccess(),
                    handlers.getError()
                )
            );
            this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
            this.urlConnection.setProgressHandler(handlers.getProgress());
            this.urlConnection.setErrorHandler(handlers.getError());

            return this.urlConnection.get();
        }
    };

    return NominatedRole;
});
},
'api/project/NominatedRoleCollection':function(){
define([], function () {
    var NominatedRoleCollection = function (url, urlConnection, urlResponseProcessorBuilder, parser) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this.projectStageVO = null;

        this.constants = {
            URL_PARAM_PLACEHOLDER_PROJECT_STAGE_PK: ':projectStagePK'
        }
    };

    NominatedRoleCollection.prototype.setProjectStageVO = function(projectStageVO) {
        this.projectStageVO = projectStageVO;
        return this;
    };

    NominatedRoleCollection.prototype.fetch = function(handlers) {
        if (this.projectStageVO) {

            this.urlConnection.setUrl(
                this.url.replace(
                    this.constants.URL_PARAM_PLACEHOLDER_PROJECT_STAGE_PK, this.projectStageVO.getProjectStagePK()
                )
            );

            this.urlConnection.setSuccessHandler(
                this.urlResponseProcessorBuilder.createProcessor(
                    this.parser,
                    handlers.getSuccess(),
                    handlers.getError()
                )
            );

            this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
            this.urlConnection.setProgressHandler(handlers.getProgress());
            this.urlConnection.setErrorHandler(handlers.getError());

            return this.urlConnection.get();
        }
    };

    return NominatedRoleCollection;
});
},
'api/project/Create':function(){
define([], function() {
    const URL_PARAM_TITLE = 'title',
        URL_PARAM_OWNER_ORGANISATION_PK = 'ownerOrganisationPK',
        URL_PARAM_CLIENT_ORGANISATION_PK = 'clientOrganisationPK',
        URL_PARAM_SITE_NAME = 'siteName',
        URL_PARAM_TOWN = 'town',
        URL_PARAM_COUNTY_PK = 'countyPK',
        URL_ROUTE_GET_BY_PROJECT_STAGE = 'project-stage/';

    const Project = function(
        url,
        connection,
        urlResponseProcessorBuilder,
        parser
    )  {
        this.url = url;
        this.connection = connection;
        this.parser = parser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;

        this._createQuery = function(project, siteName, siteAddress) {
            let q = {};

            if (project.getTitle()) {
                q[URL_PARAM_TITLE] = project.getTitle();
            }

            if (project.getOwnerOrganisation()) {
                q[URL_PARAM_OWNER_ORGANISATION_PK] = project.getOwnerOrganisation().getOrganisationPK();
            }

            if (project.getClientOrganisation()) {
                q[URL_PARAM_CLIENT_ORGANISATION_PK] = project.getClientOrganisation().getOrganisationPK();
            }

            if (siteName) {
                q[URL_PARAM_SITE_NAME] = siteName;
            }

            if (siteAddress.getTown()) {
                q[URL_PARAM_TOWN] = siteAddress.getTown();
            }

            if (siteAddress.getCountyPK()) {
                q[URL_PARAM_COUNTY_PK] = siteAddress.getCountyPK();
            }

            return q;
        };
    };

    Project.prototype.create = function(handlers, project, siteName, siteAddress) {
        this.connection.setUrl(this.url);
        this.connection.setData(this._createQuery(project, siteName, siteAddress));

        this.connection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.connection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.connection.setProgressHandler(handlers.getProgress());
        this.connection.setErrorHandler(handlers.getError());
        this.connection.setAbortHandler(handlers.getAbort());

        return this.connection.post();
    };

    return Project;
});
},
'api/project/GetByProjectStage':function(){
define([], function() {
    const URL_PARAM_TITLE = 'title',
        URL_PARAM_OWNER_ORGANISATION_PK = 'ownerOrganisationPK',
        URL_PARAM_CLIENT_ORGANISATION_PK = 'clientOrganisationPK',
        URL_PARAM_SITE_NAME = 'siteName',
        URL_PARAM_TOWN = 'town',
        URL_PARAM_COUNTY_PK = 'countyPK',
        URL_ROUTE_GET_BY_PROJECT_STAGE = 'project-stage/';

    const Project = function(
        url,
        connection,
        urlResponseProcessorBuilder,
        parser
    )  {
        this.url = url;
        this.connection = connection;
        this.parser = parser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;

        this._createQuery = function(project, siteName, siteAddress) {
            let q = {};

            if (project.getTitle()) {
                q[URL_PARAM_TITLE] = project.getTitle();
            }

            if (project.getOwnerOrganisation()) {
                q[URL_PARAM_OWNER_ORGANISATION_PK] = project.getOwnerOrganisation().getOrganisationPK();
            }

            if (project.getClientOrganisation()) {
                q[URL_PARAM_CLIENT_ORGANISATION_PK] = project.getClientOrganisation().getOrganisationPK();
            }

            if (siteName) {
                q[URL_PARAM_SITE_NAME] = siteName;
            }

            if (siteAddress.getTown()) {
                q[URL_PARAM_TOWN] = siteAddress.getTown();
            }

            if (siteAddress.getCountyPK()) {
                q[URL_PARAM_COUNTY_PK] = siteAddress.getCountyPK();
            }

            return q;
        };
    };

    Project.prototype.getByProjectStage = function(handlers, projectStagePK) {
        this.connection.setUrl(this.url.replace(':projectStagePK', projectStagePK));

        this.connection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.connection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.connection.setProgressHandler(handlers.getProgress());
        this.connection.setErrorHandler(handlers.getError());
        this.connection.setAbortHandler(handlers.getAbort());

        return this.connection.get();
    };

    return Project;
});
},
'api/project/ProjectCollection':function(){
define([
    'spencer/core/filter/Pagination',
    'spencer/core/filter/Query'
], function(
    PaginationFilter,
    QueryFilter
) {
    const URL_PARAM_QUERY = 'query',
        URL_PARAM_LIMIT = 'limit',
        URL_PARAM_OFFSET = 'offset';

    const ProjectCollection = function(
        url,
        connection,
        urlResponseProcessorBuilder,
        parser
    )  {
        this.url = url;
        this.connection = connection;
        this.parser = parser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;

        this._createParameters = function(filterCollection) {
            const q = {};

            if (filterCollection) {
                const queryFilter = filterCollection.getFilterByClass(QueryFilter);
                if( queryFilter) {
                    q[URL_PARAM_QUERY] = queryFilter.getQuery();
                }

                const paginationFilter = filterCollection.getFilterByClass(PaginationFilter);
                if (paginationFilter) {
                    q[URL_PARAM_LIMIT] = paginationFilter.getLimit();
                    q[URL_PARAM_OFFSET] = paginationFilter.getOffset();
                }
            }

            return q;
        }
    };

    ProjectCollection.prototype.fetch = function(handlers, filterCollection) {
        this.connection.setUrl(this.url);
        this.connection.setQuery(this._createParameters(filterCollection));

        this.connection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.connection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.connection.setProgressHandler(handlers.getProgress());
        this.connection.setErrorHandler(handlers.getError());
        this.connection.setAbortHandler(handlers.getAbort());

        return this.connection.get();
    };

    return ProjectCollection;
});
},
'api/project/ProjectStage':function(){
define([], function() {
    var ProjectStage = function(url, urlConnection, collectionParser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = collectionParser;
    };

    ProjectStage.prototype.get = function(handlers, projectStageVO) {
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());
        this.urlConnection.setUrl(this.url + (projectStageVO.getProjectStagePK() || projectStageVO.getStageNumber()));

        return this.urlConnection.get();
    };

    return ProjectStage;
});
},
'api/project/ProjectStageCollection':function(){
define([
    'api/project/filter/ProjectStageType',
    'api/project/filter/Organisation',
    'api/project/filter/ExcludeInactive',
    'api/project/filter/ExcludeInvisible',
    'api/project/filter/ExcludeWithNoCorrespondenceNode',
    'api/project/filter/OnlyProjectSpecific',
    'api/project/filter/IntranetOwnerAccess',
    'api/project/filter/IsLinkedToCostCentre'
], function(
    ProjectStageTypeFilter,
    OrganisationFilter,
    ExcludeInactiveFilter, 
    ExcludeInvisibleFilter,
    ExcludeWithNoCorrespondenceNode,
    OnlyProjectSpecific,
    IntranetOwnerAccess,
    IsLinkedToCostCentre
) {
    const ProjectStageCollection = function(url, urlConnection, collectionParser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.urlConnection.setUrl(this.url);
        this.parser = collectionParser;

        this.query = '';
        this.limit = 10;
        this.offset = 0;

        this.constants = {
            URL_PARAM_LIMIT: 'limit',
            URL_PARAM_OFFSET: 'offset',
            URL_PARAM_SEARCH_QUERY: 'search',
            URL_PARAM_CONTRACT_TYPE: 'stageType',
            URL_PARAM_ORGANISATION: 'organisation',
            URL_PARAM_EXCLUDE_INACTIVE: 'excludeInactive',
            URL_PARAM_EXCLUDE_INVISIBLE: 'excludeInvisible',
            URL_PARAM_EXCLUDE_WITH_NO_CORRESPONDENCE_NODE: 'excludeWithNoCorrespondenceNode',
            URL_PARAM_ONLY_PROJECT_SPECIFIC: 'projectSpecific',
            URL_PARAM_INTRANET_OWNER_ACCESS: 'intranetOwnerAccess',
            URL_PARAM_IS_LINKED_TO_COST_CENTRE: 'isLinkedToCostCentre'
        };

        this.createBasicQuery = function(filterCollection) {
            const q = {};

            if (this.query) {
                q[this.constants.URL_PARAM_SEARCH_QUERY] = this.query;
            }

            if(filterCollection) {
                const typeFilter = filterCollection.getFilterByClass(ProjectStageTypeFilter);
                const organisationFilter = filterCollection.getFilterByClass(OrganisationFilter);
                const excludeInactiveFilter = filterCollection.getFilterByClass(ExcludeInactiveFilter);
                const excludeInvisibleFilter = filterCollection.hasFilterForClass(ExcludeInvisibleFilter);
                const onlyProjectSpecificFilter = filterCollection.hasFilterForClass(OnlyProjectSpecific);
                const intranetOwnerAccessFilter = filterCollection.hasFilterForClass(IntranetOwnerAccess);
                const isLinkedToCostCentreFilter = filterCollection.hasFilterForClass(IsLinkedToCostCentre);
                const excludeWithNoCorrespondenceNodeFilter = filterCollection.hasFilterForClass(ExcludeWithNoCorrespondenceNode);

                if (typeFilter) {
                    q[this.constants.URL_PARAM_CONTRACT_TYPE] = typeFilter.getType();
                }

                if (organisationFilter) {
                    q[this.constants.URL_PARAM_ORGANISATION] = organisationFilter.getOrganisationPK();
                }

                if (excludeInactiveFilter) {
                    q[this.constants.URL_PARAM_EXCLUDE_INACTIVE] = 1;
                }

                if (excludeInvisibleFilter) {
                    q[this.constants.URL_PARAM_EXCLUDE_INVISIBLE] = 1;
                }

                if (excludeWithNoCorrespondenceNodeFilter) {
                    q[this.constants.URL_PARAM_EXCLUDE_WITH_NO_CORRESPONDENCE_NODE] = 1;
                }

                if (onlyProjectSpecificFilter) {
                    q[this.constants.URL_PARAM_ONLY_PROJECT_SPECIFIC] = 1;
                }

                if (intranetOwnerAccessFilter) {
                    q[this.constants.URL_PARAM_INTRANET_OWNER_ACCESS] = 1;
                }

                if (isLinkedToCostCentreFilter) {
                    q[this.constants.URL_PARAM_IS_LINKED_TO_COST_CENTRE] = 1;
                }
            }

            q[this.constants.URL_PARAM_LIMIT] = this.limit;
            q[this.constants.URL_PARAM_OFFSET] = this.offset;

            return q;
        };
    };

    ProjectStageCollection.prototype.setQuery = function(query) {
        this.query = query;
    };

    ProjectStageCollection.prototype.setLimit = function(limit) {
        this.limit = limit;
    };

    ProjectStageCollection.prototype.setOffset = function(offset) {
        this.offset = offset;
    };

    ProjectStageCollection.prototype.fetch = function(handlers, filterCollection) {
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());
        this.urlConnection.setQuery(this.createBasicQuery(filterCollection));

        return this.urlConnection.get();
    };

    return ProjectStageCollection;
});
},
'api/project/filter/ProjectStageType':function(){
define([], function() {
    const ProjectStageType = function() {
        this.type = null;
    };

    ProjectStageType.prototype.setType = function(type) {
        this.type = type;
        return this;
    };

    ProjectStageType.prototype.getType = function() {
        return this.type;
    };

    return ProjectStageType;
});
},
'api/project/filter/Organisation':function(){
define([], function() {
    const Organisation = function() {
        this.organisationPK = null;
    };

    Organisation.prototype.setOrganisationPK = function(organisationPK) {
        this.organisationPK = organisationPK;
        return this;
    };

    Organisation.prototype.getOrganisationPK = function() {
        return this.organisationPK;
    };

    return Organisation;
});
},
'api/project/filter/ExcludeInvisible':function(){
define([], function() {
    return function() {}
});
},
'api/project/filter/ExcludeWithNoCorrespondenceNode':function(){
define([], function() {
    return class ExcludeWithNoCorrespondenceNode {};
});
},
'api/project/filter/OnlyProjectSpecific':function(){
define([], function() {
    return function OnlyProjectSpecific() {};
});
},
'api/project/filter/IntranetOwnerAccess':function(){
define([], function() {
    return function IntranetOwnerAccess() {};
});
},
'api/project/filter/IsLinkedToCostCentre':function(){
define([], function() {
    return function IsLinkedToCostCentre() {};
});
},
'api/project/ProjectSite':function(){
define([], function() {
    var ProjectSite = function(url, urlConnection, urlResponseProcessorBuilder, parser) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this.constants = {
            PLACEHOLDER_PROJECT_STAGE_PK: ':projectStagePK',
            PLACEHOLDER_PROJECT_SITE: ':projectSitePK'
        };

        this.performPlaceholderSubstitution = function(projectSiteVO) {
            var url = this.url;

            return url
                .replace(this.constants.PLACEHOLDER_PROJECT_STAGE_PK, projectSiteVO.getProjectStagePK())
                .replace(this.constants.PLACEHOLDER_PROJECT_SITE, projectSiteVO.getProjectSitePK());
        }
    };

    ProjectSite.prototype.get = function(handlers, projectSiteVO) {
        if (projectSiteVO) {

            this.urlConnection.setUrl(this.performPlaceholderSubstitution(projectSiteVO));

            this.urlConnection.setSuccessHandler(
                this.urlResponseProcessorBuilder.createProcessor(
                    this.parser,
                    handlers.getSuccess(),
                    handlers.getError()
                )
            );
            this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
            this.urlConnection.setProgressHandler(handlers.getProgress());
            this.urlConnection.setErrorHandler(handlers.getError());

            return this.urlConnection.get();
        }
    };

    return ProjectSite;
});
},
'api/project/ProjectSiteCollection':function(){
define([], function () {
    var ProjectSiteCollection = function (url, urlConnection, urlResponseProcessorBuilder, parser) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;

        this.query = "";
        this.projectSiteVO = null;

        this.constants = {
            URL_PARAM_PLACEHOLDER_PROJECT_STAGE_PK: ':projectStagePK',
            URL_PARAM_SEARCH_QUERY: "search"
        };

        this.createBasicQuery = function() {
            var q = {};

            if (this.query) {
                q[this.constants.URL_PARAM_SEARCH_QUERY] = this.query;
            }

            return q;
        };
    };

    ProjectSiteCollection.prototype.setQuery = function(query) {
        this.query = query;
        return this;
    };

    ProjectSiteCollection.prototype.setProjectSiteVO = function(projectSiteVO) {
        this.projectSiteVO = projectSiteVO;
        return this;
    };

    ProjectSiteCollection.prototype.fetch = function(handlers) {
        if (this.projectSiteVO) {

            this.urlConnection.setUrl(
                this.url.replace(
                    this.constants.URL_PARAM_PLACEHOLDER_PROJECT_STAGE_PK, this.projectSiteVO.getProjectStagePK())
            );

            this.urlConnection.setSuccessHandler(
                this.urlResponseProcessorBuilder.createProcessor(
                    this.parser,
                    handlers.getSuccess(),
                    handlers.getError()
                )
            );

            this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
            this.urlConnection.setProgressHandler(handlers.getProgress());
            this.urlConnection.setErrorHandler(handlers.getError());

            this.urlConnection.setQuery(this.createBasicQuery());

            return this.urlConnection.get();
        }
    };

    return ProjectSiteCollection;
});
},
'api/project-stage/Factory':function(){
define([
    '../parser/Collection',
    './LeadCostCentre',
    './ProjectStageCollection',
    './ProjectStage',
    './Role',
    './RoleCollection',
    'spencer/core/parser/ProjectStageCollection',
    'spencer/core/parser/ProjectStage',
    'spencer/core/parser/Role',
    'spencer/parse/JSONParser'
], function(
    CollectionParser,
    LeadCostCentre,
    ProjectStageCollection,
    ProjectStage,
    Role,
    RoleCollection,
    ProjectStageCollectionParser,
    ProjectStageParser,
    RoleParser,
    JsonParser
) {
    const Factory = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Factory.prototype.getProjectStageCollection = function() {
        return new ProjectStageCollection(
            this.config.getUrl('api_project_stage', 'v2/'),
            this.urlConnectionBuilder.build(),
            this.urlResponseProcessorBuilder,
            new JsonParser(
                new ProjectStageCollectionParser()
            )
        );
    };

    Factory.prototype.getProjectStage = function() {
        return new ProjectStage(
            this.config.getUrl('api_project_stage', 'v2/'),
            this.urlConnectionBuilder.build(),
            this.urlResponseProcessorBuilder,
            new JsonParser(
                new ProjectStageParser()
            )
        );
    };

    Factory.prototype.getRole = function() {
        return new Role(
            this.config.getUrl('api_project_stage_role'),
            this.urlConnectionBuilder.build(),
            new RoleParser(),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getRoleCollection = function() {
        return new RoleCollection(
            this.config.getUrl('api_project_stage_role_collection'),
            this.urlConnectionBuilder.build(),
            new CollectionParser(new RoleParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getLeadCostCentre = function() {
        return new LeadCostCentre(
            this.config.getUrl('api_project_stage_lead_cost_centre'),
            this.urlConnectionBuilder.build()
        );
    };

    return Factory;
});

},
'api/project-stage/LeadCostCentre':function(){
define([], function() {
    const LeadCostCentre = function(url, connection) {
        this.url = url;
        this.connection = connection;
    };

    LeadCostCentre.prototype.get = function(handlers, projectStagePK) {
        this.connection.setUrl(this.url.replace(':projectStagePK', projectStagePK));

        this.connection.setSuccessHandler(handlers.getSuccess());
        this.connection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.connection.setProgressHandler(handlers.getProgress());
        this.connection.setErrorHandler(handlers.getError());
        this.connection.setAbortHandler(handlers.getAbort());

        return this.connection.get();
    };

    return LeadCostCentre;
});
},
'api/project-stage/ProjectStageCollection':function(){
define([
    '@lib/api/project/filter/IncludeInvisibleProjectStages',
    '@lib/api/project/filter/SkipAccessCheck',
    'api/project/filter/IncludeInactive',
    'spencer/core/filter/Pagination',
    'spencer/core/filter/Project',
    'spencer/core/filter/Query'
], function(
    IncludeInvisibleProjectStagesFilter,
    SkipAccessCheckFilter,
    IncludeInactiveFilter,
    PaginationFilter,
    ProjectFilter,
    QueryFilter
) {
    const ProjectStageCollection = function(
        url,
        connection,
        urlResponseProcessorBuilder,
        parser
    )  {
        this.url = url;
        this.connection = connection;
        this.parser = parser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    ProjectStageCollection.prototype.fetch = function(handlers, filters, sortAttribute, sortDirection) {
        this.connection.setUrl(this.url);

        const query = {};

        const includeInvisibleProjectStagesFilter = filters.getFilterByClass(IncludeInvisibleProjectStagesFilter);
        const skipAccessCheckFilter = filters.getFilterByClass(SkipAccessCheckFilter);
        const includeInactiveFilter = filters.getFilterByClass(IncludeInactiveFilter);
        const paginationFilter = filters.getFilterByClass(PaginationFilter);
        const projectFilter = filters.getFilterByClass(ProjectFilter);
        const queryFilter = filters.getFilterByClass(QueryFilter);

        if(paginationFilter) {
            query.limit = parseInt(paginationFilter.getLimit());
            query.offset = parseInt(paginationFilter.getOffset());
        }

        if(queryFilter) {
            query.search = queryFilter.getQuery();
        }

        if (projectFilter) {
            query.projectPK = projectFilter.getProjectPK();
        }

        if (includeInvisibleProjectStagesFilter) {
            query.includeInvisibleProjectStages = 1;
        }

        if (skipAccessCheckFilter) {
            query.skipAccessChecks = 1;
        }

        if(includeInactiveFilter) {
            query.includeInactiveProjects = 1;
        }

        if(sortAttribute) {
            query.sortAttribute = sortAttribute;
        }

        if(sortDirection) {
            query.sortDirection = sortDirection;
        }

        this.connection.setQuery(query);

        this.connection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.connection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.connection.setProgressHandler(handlers.getProgress());
        this.connection.setErrorHandler(handlers.getError());
        this.connection.setAbortHandler(handlers.getAbort());

        return this.connection.get();
    };

    ProjectStageCollection.prototype.get = function(handlers, projectStagePKs) {
        this.connection.setUrl(this.url);

        this.connection.setData({"projectStagePKs": JSON.stringify(projectStagePKs)});

        this.connection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.connection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.connection.setProgressHandler(handlers.getProgress());
        this.connection.setErrorHandler(handlers.getError());
        this.connection.setAbortHandler(handlers.getAbort());

        return this.connection.post();
    };

    return ProjectStageCollection;
});
},
'@lib/api/project/filter/IncludeInvisibleProjectStages':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class IncludeInvisibleProjectStages {
    }
    return IncludeInvisibleProjectStages;
});

},
'@lib/api/project/filter/SkipAccessCheck':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class SkipAccessCheck {
    }
    return SkipAccessCheck;
});

},
'api/project/filter/IncludeInactive':function(){
define([], function() {
    return function() {}
});
},
'spencer/core/filter/Project':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Project {
        constructor(projectPK) {
            this.projectPK = projectPK;
        }
        getProjectPK() {
            return this.projectPK;
        }
    }
    return Project;
});

},
'api/project-stage/ProjectStage':function(){
define([
    'spencer/date-time/Format',
    'spencer/project/project-stage/data/Intelligence',
    'spencer/project/project-stage/data/Lead'
], function(
    DateTimeFormat,
    IntelligenceVO,
    LeadVO
) {
    const URL_PARAM_PROJECT_PK = 'projectPK',
        URL_PARAM_ANTICIPATED_VALUE = 'anticipatedValue',
        URL_PARAM_FOLLOW_UP_DATE = 'followUpDate',
        URL_PARAM_CLIENT_BUDGET = 'clientBudget',
        URL_PARAM_DATE_UPDATED = 'dateUpdated',
        URL_PARAM_NOTES = 'notes',
        URL_PARAM_TENDER_DUE_DATE = 'tenderDueDate',
        URL_ROUTE_INTELLIGENCE = 'intelligence',
        URL_ROUTE_LEAD = 'lead',
        URL_PARAM_PROJECT_TITLE = 'projectTitle',
        URL_PARAM_PROJECT_OWNER_ORGANISATION_PK = 'projectOwnerOrganisationPK',
        URL_PARAM_PROJECT_CLIENT_ORGANISATION_PK = 'projectClientOrganisationPK',
        URL_PARAM_PROJECT_SITE_NAME = 'projectSiteName',
        URL_PARAM_PROJECT_TOWN = 'projectTown',
        URL_PARAM_PROJECT_COUNTY_PK = 'projectCountyPK';

    const ProjectStage = function(
        url,
        connection,
        urlResponseProcessorBuilder,
        parser
    )  {
        this.url = url;
        this.connection = connection;
        this.parser = parser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.dateTimeFormatter = new DateTimeFormat();

        this._createQuery = function(projectStage, project, siteName, siteAddress) {
            let q = {};

            if (projectStage.getProjectPK()) {
                q[URL_PARAM_PROJECT_PK] = projectStage.getProjectPK();
            } else if (project) {
                if (project.getTitle()) {
                    q[URL_PARAM_PROJECT_TITLE] = project.getTitle();
                }

                if (project.getOwnerOrganisation()) {
                    q[URL_PARAM_PROJECT_OWNER_ORGANISATION_PK] = project.getOwnerOrganisation().getOrganisationPK();
                }

                if (project.getClientOrganisation()) {
                    q[URL_PARAM_PROJECT_CLIENT_ORGANISATION_PK] = project.getClientOrganisation().getOrganisationPK();
                }
            }

            if (siteName) {
                q[URL_PARAM_PROJECT_SITE_NAME] = siteName;
            }

            if (siteAddress) {
                if (siteAddress.getTown()) {
                    q[URL_PARAM_PROJECT_TOWN] = siteAddress.getTown();
                }

                if (siteAddress.getCountyPK()) {
                    q[URL_PARAM_PROJECT_COUNTY_PK] = siteAddress.getCountyPK();
                }
            }

            if (projectStage instanceof IntelligenceVO) {
                if (projectStage.getAnticipatedValue()) {
                    q[URL_PARAM_ANTICIPATED_VALUE] = projectStage.getAnticipatedValue();
                }

                if (projectStage.getFollowUpDate()) {
                    q[URL_PARAM_FOLLOW_UP_DATE] = this.dateTimeFormatter.toLocaleISOString(projectStage.getFollowUpDate());
                }
            }

            if (projectStage instanceof LeadVO) {
                if (projectStage.getClientBudget()) {
                    q[URL_PARAM_CLIENT_BUDGET] = projectStage.getClientBudget();
                }

                if (projectStage.getDateUpdated()) {
                    q[URL_PARAM_DATE_UPDATED] = this.dateTimeFormatter.toLocaleISOString(projectStage.getDateUpdated());
                }

                if (projectStage.getNotes()) {
                    q[URL_PARAM_NOTES] = projectStage.getNotes();
                }

                if (projectStage.getTenderDueDate()) {
                    q[URL_PARAM_TENDER_DUE_DATE] = this.dateTimeFormatter.toLocaleISOString(projectStage.getTenderDueDate());
                }
            }

            return q;
        };

        this._createPostUrl = function(projectStageVO) {
            if (projectStageVO instanceof IntelligenceVO) {
                return this.url + URL_ROUTE_INTELLIGENCE;
            }

            if (projectStageVO instanceof LeadVO) {
                return this.url + URL_ROUTE_LEAD;
            }
        }
    };

    ProjectStage.prototype.get = function(handlers, projectStagePK) {
        this.connection.setUrl(this.url + projectStagePK);
        this.connection.setQuery({});

        this.connection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.connection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.connection.setProgressHandler(handlers.getProgress());
        this.connection.setErrorHandler(handlers.getError());
        this.connection.setAbortHandler(handlers.getAbort());

        return this.connection.get();
    };

    ProjectStage.prototype.create = function(handlers, projectStage, project, siteName, siteAddress) {
        this.connection.setUrl(this._createPostUrl(projectStage));
        this.connection.setData(this._createQuery(projectStage, project, siteName, siteAddress));

        this.connection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.connection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.connection.setProgressHandler(handlers.getProgress());
        this.connection.setErrorHandler(handlers.getError());
        this.connection.setAbortHandler(handlers.getAbort());

        return this.connection.post();
    };

    return ProjectStage;
});
},
'spencer/project/project-stage/data/Intelligence':function(){
define([], function() {
    const Intelligence = function() {
        this.projectPK = null;
        this.anticipatedValue = null;
        this.followUpDate = null;
        this.status = null;
        this.leadTeamPK = null;
        this.treeTemplatePK = null;
    };

    Intelligence.prototype.getProjectPK = function() {
        return this.projectPK;
    };

    Intelligence.prototype.setProjectPK = function(projectPK) {
        this.projectPK = projectPK;
        return this;
    };

    Intelligence.prototype.getAnticipatedValue = function() {
        return this.anticipatedValue;
    };

    Intelligence.prototype.setAnticipatedValue = function(anticipatedValue) {
        this.anticipatedValue = anticipatedValue;
        return this;
    };

    Intelligence.prototype.getFollowUpDate = function() {
        return this.followUpDate;
    };

    Intelligence.prototype.setFollowUpDate = function(followUpDate) {
        this.followUpDate = followUpDate;
        return this;
    };

    Intelligence.prototype.getStatus = function() {
        return this.status;
    };

    Intelligence.prototype.setStatus = function(status) {
        this.status = status;
        return this;
    };

    Intelligence.prototype.getLeadTeamPK = function() {
        return this.leadTeamPK;
    }

    Intelligence.prototype.setLeadTeamPK = function (leadTeamPK) {
        this.leadTeamPK = leadTeamPK;
        return this;
    }

    Intelligence.prototype.getTreeTemplatePK = function () {
        return this.treeTemplatePK;
    }

    Intelligence.prototype.setTreeTemplatePK = function (treeTemplatePK) {
        this.treeTemplatePK = treeTemplatePK;
        return this;
    }

    return Intelligence;
});
},
'spencer/project/project-stage/data/Lead':function(){
define([], function() {
    const Lead = function() {
        this.projectPK = null;
        this.clientBudget = null;
        this.notes = null;
        this.dateUpdated = null;
        this.tenderDueDate = null;
        this.status = null;
        this.leadTeamPK = null;
        this.treeTemplatePK = null;
    };

    Lead.prototype.getProjectPK = function() {
        return this.projectPK;
    };

    Lead.prototype.setProjectPK = function(projectPK) {
        this.projectPK = projectPK;
        return this;
    };

    Lead.prototype.getClientBudget = function() {
        return this.clientBudget;
    };

    Lead.prototype.setClientBudget = function(clientBudget) {
        this.clientBudget = clientBudget;
        return this;
    };

    Lead.prototype.getNotes = function() {
        return this.notes;
    };

    Lead.prototype.setNotes = function(notes) {
        this.notes = notes;
        return this;
    };

    Lead.prototype.getDateUpdated = function() {
        return this.dateUpdated;
    };

    Lead.prototype.setDateUpdated = function(dateUpdated) {
        this.dateUpdated = dateUpdated;
        return this;
    };

    Lead.prototype.getTenderDueDate = function() {
        return this.tenderDueDate;
    };

    Lead.prototype.setTenderDueDate = function(tenderDueDate) {
        this.tenderDueDate = tenderDueDate;
        return this;
    };

    Lead.prototype.getStatus = function() {
        return this.status;
    };

    Lead.prototype.setStatus = function(status) {
        this.status = status;
        return this;
    };

    Lead.prototype.getLeadTeamPK = function() {
        return this.leadTeamPK;
    }

    Lead.prototype.setLeadTeamPK = function (leadTeamPK) {
        this.leadTeamPK = leadTeamPK;
        return this;
    }

    Lead.prototype.getTreeTemplatePK = function () {
        return this.treeTemplatePK;
    }

    Lead.prototype.setTreeTemplatePK = function (treeTemplatePK) {
        this.treeTemplatePK = treeTemplatePK;
        return this;
    }

    return Lead;
});
},
'api/project-stage/Role':function(){
define([], function() {
    const Role = function(url, connection, parser, urlResponseProcessorBuilder) {
        this.url = url;
        this.connection = connection;
        this.parser = parser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Role.prototype.get = function(handlers, projectStagePK, rolePK) {
        this.connection.setUrl(this.url.replace(':projectStagePK', projectStagePK).replace(':rolePK', rolePK));

        this.connection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.connection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.connection.setProgressHandler(handlers.getProgress());
        this.connection.setErrorHandler(handlers.getError());
        this.connection.setAbortHandler(handlers.getAbort());

        return this.connection.get();
    };

    return Role;
});
},
'api/project-stage/RoleCollection':function(){
define([], function() {
    const RoleCollection = function(url, urlConnection, collectionParser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = collectionParser;

        this.constants = {
            URL_PARAM_SEARCH_QUERY: 'search'
        };

        this.createBasicQuery = function() {
            const q = {};

            if (this.query) {
                q[this.constants.URL_PARAM_SEARCH_QUERY] = this.query;
            }

            return q;
        };
    };

    RoleCollection.prototype.setQuery = function(query) {
        this.query = query;
    };

    RoleCollection.prototype.fetch = function(handlers, projectStagePK) {
        this.urlConnection.setUrl(this.url.replace(':projectStagePK', projectStagePK));

        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());
        this.urlConnection.setQuery(this.createBasicQuery());

        return this.urlConnection.get();
    };

    return RoleCollection;
});
},
'spencer/core/parser/Role':function(){
define([
    'spencer/core/data/Role'
], function (RoleVO) {
    const Role = function() {};

    Role.prototype.parse = function(item) {
        return new RoleVO()
            .setRolePK(item.rolePK || null)
            .setRole(item.role || null)
            .setDescription(item.description || null);
    };

    return Role;
});
},
'spencer/core/data/Role':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Role {
        constructor() {
            this.rolePK = null;
            this.role = null;
            this.description = null;
        }
        getRolePK() {
            return this.rolePK;
        }
        setRolePK(rolePK) {
            this.rolePK = rolePK;
            return this;
        }
        getRole() {
            return this.role;
        }
        setRole(role) {
            this.role = role;
            return this;
        }
        getDescription() {
            return this.description;
        }
        setDescription(description) {
            this.description = description;
            return this;
        }
    }
    return Role;
});

},
'api/project-stage/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    const Config = function (rootUrl) {
        this.url_root = rootUrl || baseUrl;
        this.base = apiConfig;
        this.base(this.url_root);

        this.api_project_stage = 'project-stage/';
        this.api_project_stage_collection = 'project-stage/';
        this.api_project_stage_delivery = 'project-stage/:projectStagePK/delivery/:date';
        this.api_project_stage_role = 'projects/project-stage/:projectStagePK/role/:rolePK';
        this.api_project_stage_role_collection = 'projects/project-stage/:projectStagePK/role';
        this.api_project_stage_lead_cost_centre = 'projects/project-stage/:projectStagePK/lead-cost-centre';
        this.api_project_stage_timesheet_cost_centre = 'project-stage/:projectStagePK/timesheet-cost-centre';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});
},
'api/role/project-stage/Factory':function(){
define([
    './AccessChecker',
    './RoleChecker',
    './role-checker/DocumentControlAdmin',
    'spencer/core/parser/ProjectStageRoleChecker',
    'spencer/parse/JSONParser'
], function(
    AccessChecker,
    RoleChecker,
    RoleCheckerDocumentControlAdmin,
    CheckerParser,
    JSONParser
) {
    const Factory = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Factory.prototype.getAccessChecker = function() {
        return new AccessChecker(
            this.config.getUrl('api_role_project_stage_access_checker', 'v2/'),
            this.urlConnectionBuilder.build(),
            this.urlResponseProcessorBuilder,
            new JSONParser(
                new CheckerParser
            )
        );
    };

    Factory.prototype.getRoleChecker = function() {
        return new RoleChecker(
            this.config.getUrl('api_role_project_stage_role_checker', 'v2/'),
            this.urlConnectionBuilder.build(),
            this.urlResponseProcessorBuilder,
            new JSONParser(
                new CheckerParser
            )
        );
    };

    Factory.prototype.getDocumentControlAdminChecker = function() {
        return new RoleCheckerDocumentControlAdmin(
            this.config.getUrl('api_role_project_stage_role_checker_document_control_admin', 'v2/'),
            this.urlConnectionBuilder.build(),
            this.urlResponseProcessorBuilder,
            new JSONParser(
                new CheckerParser
            )
        );
    };

    return Factory;
});

},
'api/role/project-stage/AccessChecker':function(){
define([], function() {
    const AccessChecker = function(
        url,
        connection,
        urlResponseProcessorBuilder,
        parser
    )  {
        this.url = url;
        this.connection = connection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    AccessChecker.prototype.get = function(handlers, projectStagePK) {
        this.connection.setUrl(
            this.url.replace(
                ':projectStagePK',
                projectStagePK
            )
        );

        this.connection.setQuery({});

        this.connection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.connection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.connection.setProgressHandler(handlers.getProgress());
        this.connection.setErrorHandler(handlers.getError());
        this.connection.setAbortHandler(handlers.getAbort());

        return this.connection.get();
    };

    return AccessChecker;
});
},
'api/role/project-stage/RoleChecker':function(){
define([], function() {
    const RoleChecker = function(
        url,
        connection,
        urlResponseProcessorBuilder,
        parser
    )  {
        this.url = url;
        this.connection = connection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    RoleChecker.prototype.get = function(handlers, projectStagePK, rolePK) {
        this.connection.setUrl(
            this.url
                .replace(':projectStagePK', projectStagePK)
                .replace(':rolePK', rolePK)
        );

        this.connection.setQuery({});

        this.connection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.connection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.connection.setProgressHandler(handlers.getProgress());
        this.connection.setErrorHandler(handlers.getError());
        this.connection.setAbortHandler(handlers.getAbort());

        return this.connection.get();
    };

    return RoleChecker;
});
},
'api/role/project-stage/role-checker/DocumentControlAdmin':function(){
define([], function() {
    const RoleChecker = function(
        url,
        connection,
        urlResponseProcessorBuilder,
        parser
    )  {
        this.url = url;
        this.connection = connection;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
        this.parser = parser;
    };

    RoleChecker.prototype.get = function(handlers, projectStagePK) {
        this.connection.setUrl(
            this.url
                .replace(':projectStagePK', projectStagePK)
        );

        this.connection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );

        this.connection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.connection.setProgressHandler(handlers.getProgress());
        this.connection.setErrorHandler(handlers.getError());
        this.connection.setAbortHandler(handlers.getAbort());

        return this.connection.get();
    };

    return RoleChecker;
});
},
'spencer/core/parser/ProjectStageRoleChecker':function(){
define([], function () {
    const ProjectStageRoleChecker = function () {};

    ProjectStageRoleChecker.prototype.parse = function(item) {
        return item.hasAccess;
    };

    return ProjectStageRoleChecker;
});
},
'api/role/project-stage/Config':function(){
define([
    '../../Config'
], function(apiConfig) {
    const Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_role_project_stage_access_checker = 'role/project-stage/:projectStagePK/checker';
        this.api_role_project_stage_role_checker = 'role/:rolePK/project-stage/:projectStagePK/checker';
        this.api_role_project_stage_role_checker_document_control_admin = 'role/document-control-admin/project-stage/:projectStagePK/checker';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});
},
'api/system/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    const Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);

        this.api_domain = 'system/domain/';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});

},
'api/system/Factory':function(){
define([
    './DomainCollection'
], function(
    DomainCollection
) {
    const Factory = function(config, urlConnectionBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
    };

    Factory.prototype.getDomainCollection = function() {
        return new DomainCollection(
            this.config.getUrl('api_domain', 'v2/'),
            this.urlConnectionBuilder.build()
        );
    };

    return Factory;
});
},
'api/system/DomainCollection':function(){
define([], function() {
    const DomainCollection = function(url, urlConnection) {
        this.url = url;
        this.urlConnection = urlConnection;

        this.urlConnection.setUrl(this.url);
    };

    DomainCollection.prototype.fetch = function(handlers) {
        this.urlConnection.setSuccessHandler(function(data) {
            handlers.getSuccess()(JSON.parse(data));
        });
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return DomainCollection;
});
},
'api/trade/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    var Config = function () {
        this.base = apiConfig;
        this.base();

        this.api_trade = 'trade/';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});

},
'api/trade/Factory':function(){
define([
    'api/parser/Collection',
    'spencer/core/parser/Trade',
    './Collection',
    './Trade'
], function(
    CollectionParser,
    TradeParser,
    Collection,
    Trade
) {
    var Factory = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Factory.prototype.getCollection = function() {
        return new Collection(
            this.config.getUrl('api_trade'),
            this.urlConnectionBuilder.build(),
            new CollectionParser(new TradeParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getTrade = function() {
        var c = new CollectionParser(new TradeParser());
        c.setIsSingleItemCollection(true);

        return new Trade(
            this.config.getUrl('api_trade'),
            this.urlConnectionBuilder.build(),
            c,
            this.urlResponseProcessorBuilder
        );
    };

    return Factory;
});

},
'spencer/core/parser/Trade':function(){
define([
    '../data/Trade'
], function(TradeVO) {
    var Trade = function() {};

    Trade.prototype.parse = function(item) {
        if (item === undefined) {
            return new TradeVO();
        }

        return (new TradeVO())
            .setTradePK(item.tradePK || null)
            .setName(item.name || null)
            .setOrganisationType(item.organisationType || null)
            .setType(item.type || null);
    };

    return Trade;
});
},
'spencer/core/data/Trade':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Trade {
        constructor() {
            this.tradePK = null;
            this.name = null;
            this.organisationType = null;
            this.type = null;
        }
        getTradePK() {
            return this.tradePK;
        }
        setTradePK(tradePK) {
            this.tradePK = tradePK;
            return this;
        }
        getName() {
            return this.name;
        }
        setName(name) {
            this.name = name;
            return this;
        }
        getOrganisationType() {
            return this.organisationType;
        }
        setOrganisationType(organisationType) {
            this.organisationType = organisationType;
            return this;
        }
        getType() {
            return this.type;
        }
        setType(type) {
            this.type = type;
            return this;
        }
    }
    return Trade;
});

},
'api/trade/Collection':function(){
define([
    './filter/IsActive',
    './filter/NameQuery',
    './filter/OrganisationTypeName',
    'spencer/core/filter/Pagination'
], function (IsActive, FilterNameQuery, FilterOrganisationTypeName, FilterPagination) {
    const Collection = function (url, urlConnection, collectionParser, urlResponseProcessorBuilder) {
        const URL_PARAM_TYPE = 'type';
        const DEFAULT_LIMIT = 10;
        const DEFAULT_OFFSET = 0;
        const URL_PARAM_LIMIT = 'limit';
        const URL_PARAM_OFFSET = 'offset';
        const URL_PARAM_SEARCH = 'search';
        const URL_PARAM_IS_ACTIVE = 'isActive';

        this.urlConnection = urlConnection;
        this.parser = collectionParser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;

        this.urlConnection.setUrl(url);

        this._createBasicQuery = function(filterCollection) {
            const query = {};

            const isActiveFilter = filterCollection.getFilterByClass(IsActive);
            if (isActiveFilter) {
                query[URL_PARAM_IS_ACTIVE] = isActiveFilter.isActive();
            }

            const paginationFilter = filterCollection.getFilterByClass(FilterPagination);
            if (paginationFilter) {
                query[URL_PARAM_LIMIT] = paginationFilter.getLimit();
                query[URL_PARAM_OFFSET] = paginationFilter.getOffset();
            } else {
                query[URL_PARAM_LIMIT] = DEFAULT_LIMIT;
                query[URL_PARAM_OFFSET] = DEFAULT_OFFSET;
            }

            const queryFilter = filterCollection.getFilterByClass(FilterNameQuery);
            if (queryFilter) {
                query[URL_PARAM_SEARCH] = queryFilter.getQuery();
            }

            const organisationTypeNameFilter = filterCollection.getFilterByClass(FilterOrganisationTypeName);
            if (organisationTypeNameFilter) {
                query[URL_PARAM_TYPE] = organisationTypeNameFilter.getOrganisationTypeName();
            }

            return query;
        };
    };

    Collection.prototype.fetch = function (handlers, filterCollection) {
        this.urlConnection.setQuery(this._createBasicQuery(filterCollection));
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return Collection;
});
},
'api/trade/filter/IsActive':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class IsActive {
        constructor() {
            this.active = true;
        }
        isActive() {
            return this.active;
        }
    }
    return IsActive;
});

},
'api/trade/filter/NameQuery':function(){
define([], function() {
    var NameQuery = function(query) {
        this.query = query;
    };

    NameQuery.prototype.getQuery = function() {
        return this.query;
    };

    return NameQuery;
});
},
'api/trade/filter/OrganisationTypeName':function(){
define([], function() {
    const OrganisationTypeName = function(organisationTypeName) {
        this.organisationTypeName = organisationTypeName;
    };

    OrganisationTypeName.prototype.getOrganisationTypeName = function() {
        return this.organisationTypeName;
    };

    return OrganisationTypeName;
});
},
'api/trade/Trade':function(){
define([], function () {
    var Trade = function (url, urlConnection, collectionParser, urlResponseProcessorBuilder) {
        this.url = url;
        this.urlConnection = urlConnection;
        this.parser = collectionParser;
        this.urlResponseProcessorBuilder = urlResponseProcessorBuilder;
    };

    Trade.prototype.get = function (handlers, tradePK) {
        this.urlConnection.setUrl(this.url + tradePK);
        this.urlConnection.setSuccessHandler(
            this.urlResponseProcessorBuilder.createProcessor(
                this.parser,
                handlers.getSuccess(),
                handlers.getError()
            )
        );
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.get();
    };

    return Trade;
});
},
'api/user/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    const Config = function () {
        this.base = apiConfig;
        this.base();

        this.api_user_preference = 'user_preference/';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});

},
'api/user/Factory':function(){
define([
    './Preference'
], function(
    Preference
) {
    const Factory = function(config, urlConnectionBuilder) {
        this.config = config;
        this.urlConnectionBuilder = urlConnectionBuilder;
    };

    Factory.prototype.getPreference = function() {
        return new Preference(
            this.config.getUrl('api_user_preference'),
            this.urlConnectionBuilder.build()
        );
    };

    return Factory;
});

},
'api/user/Preference':function(){
define([], function () {
    const Preference = function (url, urlConnection) {
        this.url = url;
        this.urlConnection = urlConnection;
    };

    Preference.prototype.set = function(handlers, setting, value) {
        this.urlConnection.setUrl(this.url);
        this.urlConnection.setData({
            'id': setting,
            'value': value
        });
        this.urlConnection.setSuccessHandler(handlers.getSuccess());
        this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
        this.urlConnection.setProgressHandler(handlers.getProgress());
        this.urlConnection.setErrorHandler(handlers.getError());

        return this.urlConnection.post();
    };

    return Preference;
});
},
'doccontrol/viewer/config/Stamps':function(){
define([], function() {
    const PATH = baseUrl + 'javascript/doccontrol/viewer/image/stamp/';

    return {
        STAMPS: [
            {'name': 'Check', 'href': PATH + 'check.svg'},
            {'name': 'Approval', 'href': PATH + 'approval.svg'}
        ]
    };
});
},
'doccontrol/viewer/config/Modes':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    const Modes = {
        DRAG: 'drag',
        SELECT: 'select',
        PENCIL: 'pencil',
        HIGHLIGHTER: 'highlighter',
        LINE: 'line',
        ARROW: 'arrow',
        RECTANGLE: 'rectangle',
        ELLIPSE: 'ellipse',
        HEXAGON: 'hexagon',
        POLYGON: 'polygon',
        HIGHLIGHT_REGION: 'highlight-region',
        TEXT: 'text',
        PIN: 'pin'
    };
    return Modes;
});

},
'doccontrol/viewer/dojo/LineWidthPicker':function(){
define([
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/Evented',
    'dijit/_WidgetBase',
    'dojo/text!./template/LineWidthPicker.html',
    'soso/sosox/ejs/_Templated'
], function(
    declare,
    domAttr,
    Evented,
    WidgetBase,
    template,
    Templated
) {
    const LineWidthPicker = function(data, node) {
        const View = declare([WidgetBase, Templated, Evented], {
            templateString: template,
            data: {
                lineWidths: data && data.lineWidths ? data.lineWidths : [1, 2, 3],
                selected: data && data.selected ? data.selected : 1,
            },

            _selectLineWidth: function(e) {
                if (!domAttr.has(e.target, 'disabled')) {
                    this.data.selected = domAttr.get(e.target, 'data-line-width');
                    this.emit('change', this.data.selected);
                    this.render();
                }
            }
        });

        this.view = new View({}, node);
    };

    LineWidthPicker.prototype.get = function() {
        return this.view;
    };

    return LineWidthPicker;
});
},
'doccontrol/viewer/dojo/LineStylePicker':function(){
define([
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/Evented',
    'dijit/_WidgetBase',
    'dojo/text!./template/LineStylePicker.html',
    'soso/sosox/ejs/_Templated'
], function(
    declare,
    domAttr,
    Evented,
    WidgetBase,
    template,
    Templated
) {
    const LineStylePicker = function(config, node) {
        const View = declare([WidgetBase, Templated, Evented], {
            elementCloudItem: null,
            templateString: template,
            data: {
                selected: config,
                cloudEnabled: false
            },

            _selectStyleSolid: function(e) {
                this._selectStyle(e, 'solid');
            },

            _selectStyleDotted: function(e) {
                this._selectStyle(e, 'dotted');
            },

            _selectStyleDashed: function(e) {
                this._selectStyle(e, 'dashed');
            },

            _selectStyleCloud: function(e) {
                if (this.elementCloudItem.hasAttribute('disabled')) return;

                this._selectStyle(e, 'cloud');
            },

            _selectStyle: function(e, style) {
                if (!domAttr.has(e.target, 'disabled')) {
                    this._updateDataProperty(style);
                    this.emit('change', this.data.selected);
                    this.render();
                }
            },

            enableCloud: function() {
                this.data.cloudEnabled = true;
                this.render();
            },

            disableCloud: function() {
                this.data.cloudEnabled = false;

                if (this.data.selected.cloud) {
                    this._updateDataProperty('solid');
                    this.emit('change', this.data.selected);
                }

                this.render();
            },

            _updateDataProperty: function(style) {
                for (const key in this.data.selected) {
                    if (this.data.selected.hasOwnProperty(key)) {
                        key === style ?
                            this.data.selected[key] = true :
                            this.data.selected[key] = false;
                    }
                }
            }
        });

        this.view = new View({}, node);
    };

    LineStylePicker.prototype.get = function() {
        return this.view;
    };

    LineStylePicker.prototype.enableCloud = function() {
        return this.view.enableCloud();
    };

    LineStylePicker.prototype.disableCloud = function() {
        return this.view.disableCloud();
    };

    return LineStylePicker;
});
},
'doccontrol/viewer/dojo/Users':function(){
define([
    './UsersRow',
    './CurrentUserRow',
    'dojo/text!./template/Users.html',
    'dojo/_base/declare',
    'dojo/dom-construct',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated',
    'style-guide/v1/navigation/SideNavigation'
], function(
    UsersRow,
    CurrentUserRow,
    template,
    declare,
    domConstruct,
    _WidgetBase,
    _Templated,
    SideNavigation
) {
    const Users = function (data, node) {
        const View = declare([_WidgetBase, _Templated], {
            templateString: template,
            currentPersonPK: null,
            data: {
                currentUser: null,
                pastContributors: [],
                pastContributorsExpanded: true,
                connectedUsers: [],
                connectedUsersExpanded: true,
            },
            elementConnectedUsersContainer: null,
            elementCurrentUserContainer: null,
            elementPastContributorsContainer: null,

            postCreate: function() {
                this.inherited(arguments);
                this.currentPersonPK = dojoConfig.user.getPerson().getPersonPK();
            },

            setUsers: function(userCollection) {
                this.data.currentUser = null;
                this.data.pastContributors = [];
                this.data.connectedUsers = [];

                userCollection.forEach(function (user) {
                    if (this._isCurrentPerson(user)) {
                        this.data.currentUser = user;
                        return;
                    }

                    if (user.isConnected) {
                        this.data.connectedUsers.push(user);
                    } else {
                        this.data.pastContributors.push(user);
                    }
                }.bind(this));

                this.render();
            },

            disconnected: function() {
                if (this.elementConnectedUsersContainer) {
                    this.elementConnectedUsersContainer.classList.add('hidden');
                }
            },

            connected: function() {
                if (this.elementConnectedUsersContainer) {
                    this.elementConnectedUsersContainer.classList.remove('hidden');
                }
            },

            render: function() {
                this.inherited(arguments);

                if (this.data.currentUser) {
                    new CurrentUserRow(this.data.currentUser, this.elementCurrentUserContainer);
                }

                this.data.connectedUsers.map(function(user) {
                    new UsersRow(user, domConstruct.create('div', {}, this.elementConnectedUsersContainer, 'last'));
                }.bind(this));

                this.data.pastContributors.map(function(user) {
                    if (!this._personIsConnected(user.personPK)) {
                        new UsersRow({
                            data: {
                                person: user
                            }
                        }, domConstruct.create('li', {}, this.elementPastContributorsContainer, 'last'));
                    }
                }.bind(this));

                new SideNavigation({
                    navigation: this.domNode
                });
            },

            _personIsConnected: function(personPK) {
                for (let i = 0; i < this.data.connectedUsers.length; i++) {
                    if (this.data.connectedUsers[i].personPK === personPK) {
                        return true;
                    }
                }
                return false;
            },

            _isCurrentPerson: function(person) {
                return person.personPK === this.currentPersonPK;
            },

            _onConnectedUsersClick: function() {
                this.data.connectedUsersExpanded = !this.data.connectedUsersExpanded;
                this.render();
            },

            _onPastContributorsClick: function() {
                this.data.pastContributorsExpanded = !this.data.pastContributorsExpanded;
                this.render();
            }
        });

        this.view = new View({data: data}, node);
    };

    Users.prototype.setUsers = function(userCollection) {
        this.view.setUsers(userCollection);
    };

    Users.prototype.disconnected = function() {
        this.view.disconnected();
    };

    Users.prototype.connected = function() {
        this.view.connected();
    };

    return Users;
});

},
'doccontrol/viewer/dojo/UsersRow':function(){
define([
    'dijit/_WidgetBase',
    'dojo/text!./template/UsersRow.html',
    'dojo/_base/declare',
    'dojo/topic',
    'soso/sosox/ejs/_Templated',
    'spencer/format/PersonDisplayName',
    '../Topics'
], function(
    _WidgetBase,
    template,
    declare,
    topic,
    _TemplatedMixin,
    PersonFormatter,
    TOPICS
) {
    return function (person, node) {
        const View = declare([_WidgetBase, _TemplatedMixin], {
            templateString: template,

            data: {
                person: person
            },

            postMixInProperties: function() {
                this.inherited(arguments);

                this.setCustomViewHelpers({
                    personFormatter: function(person) {
                        let personFormatter = new PersonFormatter();
                        personFormatter.setJobTitle(person.jobTitle);
                        personFormatter.setDisplayName(person.displayName);
                        return personFormatter.format();
                    }
                });
            },

            _toggleUserAnnotations: function(e) {
                topic.publish(TOPICS.DOCUMENT_VIEWER_ANNOTATION_USER_CHANGE_VISIBILITY, this.data.person.personPK, e.target.checked)
            }
        });

        this.view = new View(person, node);
    };
});

},
'spencer/format/PersonDisplayName':function(){
define([
], function() {
    const PersonDisplayName = function(useOrganisationPreferredName) {
        this.useOrganisationPreferredName = useOrganisationPreferredName;
        this.jobTitle = null;
        this.displayName = null;
        this.organisation = null;
        this.organisationPreferredName = null;
        this.email = null;
        this.categories = null;
    };

    PersonDisplayName.prototype.setJobTitle = function(jobTitle) {
        this.jobTitle = jobTitle;
        return this;
    };

    PersonDisplayName.prototype.setOrganisation = function(organisation) {
        this.organisation = organisation;
        return this;
    };

    PersonDisplayName.prototype.setOrganisationPreferredName = function(name) {
        this.organisationPreferredName = name;
        return this;
    };

    PersonDisplayName.prototype.setDisplayName = function(displayName) {
        this.displayName = displayName;
        return this;
    };

    PersonDisplayName.prototype.setEmail = function(email) {
        this.email = email;
        return this;
    };

    PersonDisplayName.prototype.setCategories = function(categories) {
        this.categories = categories;
        return this;
    };

    PersonDisplayName.prototype.format = function() {
        let displayName = this.displayName;

        if (this.jobTitle) {
            displayName += ' [' + this.jobTitle + ']';
        }

        if (this.useOrganisationPreferredName) {
            if (this.organisationPreferredName) {
                displayName = displayName.concat(' - '.concat(this.organisationPreferredName));
            } else {
                displayName = displayName.concat(' - '.concat(this.organisation));
            }
        } else {
            if (this.organisation) {
                displayName += ' - ' + this.organisation;
            }
        }

        if (this.email) {
            displayName += ' - ' + this.email;
        }

        if (Array.isArray(this.categories)) {
            const category = this.categories.map(category => {
                return category.getName();
            });

            if (category.length > 0) {
                displayName = displayName.concat(' (').concat(category.join(',')).concat(')');
            }
        }

        return displayName;
    };

    PersonDisplayName.prototype.reset = function() {
        this.jobTitle = null;
        this.displayName = null;
        this.organisation = null;
        this.email = null;
    };

    return PersonDisplayName;
});
},
'doccontrol/viewer/dojo/CurrentUserRow':function(){
define([
    'dijit/_WidgetBase',
    'dojo/text!./template/CurrentUserRow.html',
    'dojo/_base/declare',
    'dojo/topic',
    'soso/sosox/ejs/_Templated',
    '../Topics'
], function(
    _WidgetBase,
    template,
    declare,
    topic,
    _TemplatedMixin,
    TOPICS
) {
    return function (person, node) {
        const View = declare([_WidgetBase, _TemplatedMixin], {
            templateString: template,

            data: {
                person: person
            },

            _toggleUserAnnotations: function(e) {
                topic.publish(TOPICS.DOCUMENT_VIEWER_ANNOTATION_USER_CHANGE_VISIBILITY, this.data.person.personPK, e.target.checked)
            },
        });

        this.view = new View(person, node);
    };
});

},
'style-guide/v1/navigation/SideNavigation':function(){
define([
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dijit/_WidgetBase',
    'dojo/Evented',
    'dojo/query',
    'dojo/dom-class',
    'dojo/on',
    'dojo/NodeList-traverse'
], function(declare, lang, WidgetBase, Evented, query, domClass, on) {
    return declare('style-guide.v1.navigation.side-navigation', [WidgetBase, Evented], {
        constants: {
            DRAG_EXPAND_DELAY: 500
        },
        clickCount: 0,
        clickCountTimeout: null,
        timeouts: [],
        pausables: [],
        expandEvents: [],
        dragEnterEvents: [],
        navigation: null,
        activeItemsShouldBeExpanded: true,

        constructor: function(args) {
            this.expandEvents = [];
            this.dragEnterEvents = [];

            if (args.hasOwnProperty('activeItemsShouldBeExpanded')) {
                this.activeItemsShouldBeExpanded = args.activeItemsShouldBeExpanded;
            }
        },

        postCreate: function() {
            this.inherited(arguments);
            this.update();
        },

        update: function(navigation) {
            this.navigation = navigation || this.navigation;
            this._prepareExpandableItems();
            if (this.activeItemsShouldBeExpanded) {
                this._expandActiveItems();
            }
        },

        destroyRecursive: function() {
            this.inherited(arguments);
            this._removeAllEvents();
            this.navigation.innerHTML = '';
            this.navigation = null;
        },

        collapseAll: function() {
            const sideNavigationItems = this._getExpandedItemsWithinScope(this.navigation);
            sideNavigationItems.forEach((item => {
                this._collapseItem(item);
            }));
        },

        _removeAllEvents: function() {
            this.dragEnterEvents.forEach(e => e.remove());
            this.expandEvents.forEach(e => e.remove());
        },

        _expandActiveItems: function() {
            this._getActiveItems().forEach(lang.hitch(this, function(item) {
                this._expandParentSubLists(item);
                this._expandItem(item);
                this._expandItem(this._getItemSubNavigation(item));
            }));
        },

        _expandParentSubLists: function(item) {
            this._getParentSubLists(item).forEach(lang.hitch(this, this._expandParentSubList));
        },

        _getParentSubLists: function(item) {
            return query(item).parents('.sos-side-navigation-sub-menu-container');
        },

        _expandParentSubList: function(subList) {
            domClass.add(subList, 'expanded');

            var precedingNavigationItem = this._getPrecedingNavigationItem(subList);

            if(precedingNavigationItem && !this._isExpanded(precedingNavigationItem)) {
                this._expandItem(precedingNavigationItem);
            }
        },

        _getPrecedingNavigationItem: function(item) {
            return query(item).prev('.expandable, .expanded')[0];
        },

        _prepareExpandableItems: function() {
            this._getExpandableItems().forEach(lang.hitch(this, this._prepareExpandableItem));

            this._addDragEnterEvent();
        },

        _prepareExpandableItem: function(item) {
            if (!domClass.contains(item, 'expanded')) {
                domClass.add(item, 'expandable');
            }

            var cr = this._getExpandClickRegion(item);
            this._addClickExpandEvent(cr);
        },

        _addClickExpandEvent: function(target) {
            if (typeof target !== 'undefined') {
                this.expandEvents.push(on(target, 'click', lang.hitch(this, this._toggleExpanded)));
            }
        },

        _addDragEnterEvent: function() {
            const dragEnterHandle = on(this.navigation, '.sos-side-navigation-expand-click-region:dragenter', function(e) {
                if(this.dragEnterTimeout) {
                    clearTimeout(this.dragEnterTimeout);
                    this.dragEnterTimeout = null;
                }

                let left = false;
                const dragLeaveHandle = on(e.target, 'dragleave, dragend', function() {
                    left = true;
                    this.elementAlreadyExpanded = null;
                    dragLeaveHandle.remove();
                }.bind(this));

                this.dragEnterTimeout = setTimeout(function() {
                    if(this.elementAlreadyExpanded !== e.target && !left) {
                        this._toggleExpanded(e);
                        this.elementAlreadyExpanded = e.target;
                    }

                    this.dragEnterTimeout = null;
                }.bind(this), this.constants.DRAG_EXPAND_DELAY);
            }.bind(this));

            this.dragEnterEvents.push(dragEnterHandle);
        },

        _getExpandClickRegion: function(item) {
            const nodes = query('.sos-side-navigation-expand-click-region', item);

            if (!nodes.length) {
                console.error('Dom element with class sos-side-navigation-expand-click-region missing')
            }

            return nodes[0];
        },

        _toggleExpanded: function(e) {
            e.preventDefault();

            const item = this._findParentNavigationItem(e.target);

            this._toggleSelector(item);
            this._toggleSelector(this._getItemSubNavigation(item));

            if(!this._isExpanded(item)) {
                this._collapseChildren(item);
                this.emit('item-collapsed', item);
            } else {
                this.emit('item-expanded', item);
            }
        },

        _findParentNavigationItem: function(item) {
            return query(item).parents('.sos-side-navigation-item')[0];
        },

        _collapseChildren: function(item) {
            this._getExpandedItemsWithinScope(
                this._getItemSubNavigation(item)
            ).forEach(lang.hitch(this, this._collapseItem));
        },

        _expandItem: function(item) {
            if(item) {
                domClass.replace(item, 'expanded', 'expandable');
            }
        },

        _collapseItem: function(item) {
            domClass.replace(item, 'expandable', 'expanded');
        },

        collapseOthers: function(item) {
            this._getNavigationItems()
                .filter(this._itemIsPlacedBeforeSubNavigation.bind(this))
                .forEach(function(itemToCollapse) {
                    if (itemToCollapse != item) {
                        this._collapseItem(itemToCollapse);
                        this._collapseItem(this._getItemSubNavigation(itemToCollapse));
                    }
                }.bind(this));
        },

        _toggleSelector: function(item) {
            if(item) {
                domClass.replace(
                    item,
                    domClass.contains(item, 'expanded') ? 'expandable' : 'expanded',
                    domClass.contains(item, 'expanded') ? 'expanded' : 'expandable'
                );
            }
        },

        _getNavigationItems: function() {
            return query('.sos-side-navigation-item', this.navigation);
        },

        _getExpandedItemsWithinScope: function(scope) {
            return query('.expanded', scope);
        },

        _getActiveItems: function() {
            return query('.active', this.navigation);
        },

        _getExpandableItems: function() {
            const expandableItems = [];

            this._getNavigationItems().forEach(lang.hitch(this, function(item) {
                if(this._itemIsPlacedBeforeSubNavigation(item)) {
                    return expandableItems.push(item);
                }

                if(this._itemIsExpandableSectionHeader(item)) {
                    return expandableItems.push(item);
                }
            }));

            return expandableItems;
        },

        _itemIsExpandableSectionHeader: function(item) {
            return domClass.contains(item, 'sos-side-navigation-section-header')
                && (domClass.contains(item, 'expanded')
                || domClass.contains(item, 'expandable'));
        },

        _itemIsPlacedBeforeSubNavigation: function(item) {
            return Boolean(this._getItemSubNavigation(item));
        },

        _getItemSubNavigation: function(item) {
            const nextChild = query(item).next()[0];

            if(!nextChild) {
                return false;
            }

            if(domClass.contains(nextChild, 'sos-side-navigation-sub-menu-container')) {
                return nextChild;
            }
        },

        _isExpanded: function(item) {
            return domClass.contains(item, 'expanded');
        },

        _removeEvents: function() {
            this.expandEvents.forEach(this._removeEventHandlers.bind(this));
            this.dragEnterEvents.forEach(this._removeEventHandlers.bind(this));
        },

        _removeEventHandlers: function(event) {
            event.remove();
        },

        destroy: function() {
            this._removeEvents();
            this.inherited(arguments);
        }
    });
});
},
'dojo/NodeList-traverse':function(){
define(["./query", "./_base/lang", "./_base/array"], function(dquery, lang, array){

// module:
//		dojo/NodeList-traverse

/*=====
return function(){
	// summary:
	//		Adds chainable methods to dojo/query() / NodeList instances for traversing the DOM
};
=====*/

var NodeList = dquery.NodeList;

lang.extend(NodeList, {
	_buildArrayFromCallback: function(/*Function*/ callback){
		// summary:
		//		builds a new array of possibly differing size based on the input list.
		//		Since the returned array is likely of different size than the input array,
		//		the array's map function cannot be used.
		var ary = [];
		for(var i = 0; i < this.length; i++){
			var items = callback.call(this[i], this[i], ary);
			if(items){
				ary = ary.concat(items);
			}
		}
		return ary;	//Array
	},

	_getUniqueAsNodeList: function(/*Array*/ nodes){
		// summary:
		//		given a list of nodes, make sure only unique
		//		elements are returned as our NodeList object.
		//		Does not call _stash().
		var ary = [];
		//Using for loop for better speed.
		for(var i = 0, node; node = nodes[i]; i++){
			//Should be a faster way to do this. dojo/query has a private
			//_zip function that may be inspirational, but there are pathways
			//in query that force nozip?
			if(node.nodeType == 1 && array.indexOf(ary, node) == -1){
				ary.push(node);
			}
		}
		return this._wrap(ary, null, this._NodeListCtor);	 // dojo/NodeList
	},

	_getUniqueNodeListWithParent: function(/*Array*/ nodes, /*String*/ query){
		// summary:
		//		gets unique element nodes, filters them further
		//		with an optional query and then calls _stash to track parent NodeList.
		var ary = this._getUniqueAsNodeList(nodes);
		ary = (query ? dquery._filterResult(ary, query) : ary);
		return ary._stash(this);  // dojo/NodeList
	},

	_getRelatedUniqueNodes: function(/*String?*/ query, /*Function*/ callback){
		// summary:
		//		cycles over all the nodes and calls a callback
		//		to collect nodes for a possible inclusion in a result.
		//		The callback will get two args: callback(node, ary),
		//		where ary is the array being used to collect the nodes.
		return this._getUniqueNodeListWithParent(this._buildArrayFromCallback(callback), query);  // dojo/NodeList
	},

	children: function(/*String?*/ query){
		// summary:
		//		Returns all immediate child elements for nodes in this dojo/NodeList.
		//		Optionally takes a query to filter the child elements.
		// description:
		//		.end() can be used on the returned dojo/NodeList to get back to the
		//		original dojo/NodeList.
		// query:
		//		a CSS selector.
		// returns:
		//		all immediate child elements for the nodes in this dojo/NodeList.
		// example:
		//		assume a DOM created by this markup:
		//	|	<div class="container">
		// 	|		<div class="red">Red One</div>
		// 	|		Some Text
		// 	|		<div class="blue">Blue One</div>
		// 	|		<div class="red">Red Two</div>
		// 	|		<div class="blue">Blue Two</div>
		//	|	</div>
		//		Running this code:
		//	|	require(["dojo/query", "dojo/NodeList-traverse"
		//	|	], function(query){
		//	|		query(".container").children();
		//	|	});
		//		returns the four divs that are children of the container div.
		//		Running this code:
		//	|	dojo.query(".container").children(".red");
		//		returns the two divs that have the class "red".
		return this._getRelatedUniqueNodes(query, function(node, ary){
			return lang._toArray(node.childNodes);
		}); // dojo/NodeList
	},

	closest: function(/*String*/ query, /*String|DOMNode?*/ root){
		// summary:
		//		Returns closest parent that matches query, including current node in this
		//		dojo/NodeList if it matches the query.
		// description:
		//		.end() can be used on the returned dojo/NodeList to get back to the
		//		original dojo/NodeList.
		// query:
		//		a CSS selector.
		// root:
		//		If specified, query is relative to "root" rather than document body.
		// returns:
		//		the closest parent that matches the query, including the current
		//		node in this dojo/NodeList if it matches the query.
		// example:
		//		assume a DOM created by this markup:
		//	|	<div class="container">
		//	|		<div class="red">Red One</div>
		//	|		Some Text
		//	|		<div class="blue">Blue One</div>
		//	|		<div class="red">Red Two</div>
		//	|		<div class="blue">Blue Two</div>
		//	|	</div>
		//		Running this code:
		//	|	require(["dojo/query", "dojo/NodeList-traverse"
		//	|	], function(query){
		//	|		query(".red").closest(".container");
		//	|	});
		//		returns the div with class "container".
		return this._getRelatedUniqueNodes(null, function(node, ary){
			do{
				if(dquery._filterResult([node], query, root).length){
					return node;
				}
			}while(node != root && (node = node.parentNode) && node.nodeType == 1);
			return null; //To make rhino strict checking happy.
		}); // dojo/NodeList
	},

	parent: function(/*String?*/ query){
		// summary:
		//		Returns immediate parent elements for nodes in this dojo/NodeList.
		//		Optionally takes a query to filter the parent elements.
		// description:
		//		.end() can be used on the returned dojo/NodeList to get back to the
		//		original dojo/NodeList.
		// query:
		//		a CSS selector.
		// returns:
		//		immediate parent elements for nodes in this dojo/NodeList.
		// example:
		//		assume a DOM created by this markup:
		//	|	<div class="container">
		// 	|		<div class="red">Red One</div>
		// 	|		<div class="blue first"><span class="text">Blue One</span></div>
		// 	|		<div class="red">Red Two</div>
		// 	|		<div class="blue"><span class="text">Blue Two</span></div>
		//	|	</div>
		//		Running this code:
		//	|	require(["dojo/query", "dojo/NodeList-traverse"
		//	|	], function(query){
		//	|		query(".text").parent();
		//	|	});
		//		returns the two divs with class "blue".
		//		Running this code:
		//	|		query(".text").parent(".first");
		//		returns the one div with class "blue" and "first".
		return this._getRelatedUniqueNodes(query, function(node, ary){
			return node.parentNode;
		}); // dojo/NodeList
	},

	parents: function(/*String?*/ query){
		// summary:
		//		Returns all parent elements for nodes in this dojo/NodeList.
		//		Optionally takes a query to filter the child elements.
		// description:
		//		.end() can be used on the returned dojo/NodeList to get back to the
		//		original dojo/NodeList.
		// query:
		//		a CSS selector.
		// returns:
		//		all parent elements for nodes in this dojo/NodeList.
		// example:
		//		assume a DOM created by this markup:
		//	|	<div class="container">
		// 	|		<div class="red">Red One</div>
		// 	|		<div class="blue first"><span class="text">Blue One</span></div>
		// 	|		<div class="red">Red Two</div>
		// 	|		<div class="blue"><span class="text">Blue Two</span></div>
		//	|	</div>
		//		Running this code:
		//	|	require(["dojo/query", "dojo/NodeList-traverse"
		//	|	], function(query){
		//	|		query(".text").parents();
		//	|	});
		//		returns the two divs with class "blue", the div with class "container",
		// 	|	the body element and the html element.
		//		Running this code:
		//	|		query(".text").parents(".container");
		//		returns the one div with class "container".
		return this._getRelatedUniqueNodes(query, function(node, ary){
			var pary = [];
			while(node.parentNode){
				node = node.parentNode;
				pary.push(node);
			}
			return pary;
		}); // dojo/NodeList
	},

	siblings: function(/*String?*/ query){
		// summary:
		//		Returns all sibling elements for nodes in this dojo/NodeList.
		//		Optionally takes a query to filter the sibling elements.
		// description:
		//		.end() can be used on the returned dojo/NodeList to get back to the
		//		original dojo/NodeList.
		// query:
		//		a CSS selector.
		// returns:
		//		all sibling elements for nodes in this dojo/NodeList.
		// example:
		//		assume a DOM created by this markup:
		//	|	<div class="container">
		// 	|		<div class="red">Red One</div>
		// 	|		Some Text
		// 	|		<div class="blue first">Blue One</div>
		// 	|		<div class="red">Red Two</div>
		// 	|		<div class="blue">Blue Two</div>
		//	|	</div>
		//		Running this code:
		//	|	require(["dojo/query", "dojo/NodeList-traverse"
		//	|	], function(query){
		//	|		query(".first").siblings();
		//	|	});
		//		returns the two divs with class "red" and the other div
		// 	|	with class "blue" that does not have "first".
		//		Running this code:
		//	|		query(".first").siblings(".red");
		//		returns the two div with class "red".
		return this._getRelatedUniqueNodes(query, function(node, ary){
			var pary = [];
			var nodes = (node.parentNode && node.parentNode.childNodes);
			for(var i = 0; i < nodes.length; i++){
				if(nodes[i] != node){
					pary.push(nodes[i]);
				}
			}
			return pary;
		}); // dojo/NodeList
	},

	next: function(/*String?*/ query){
		// summary:
		//		Returns the next element for nodes in this dojo/NodeList.
		//		Optionally takes a query to filter the next elements.
		// description:
		//		.end() can be used on the returned dojo/NodeList to get back to the
		//		original dojo/NodeList.
		// query:
		//		a CSS selector.
		// returns:
		//		the next element for nodes in this dojo/NodeList.
		// example:
		//		assume a DOM created by this markup:
		//	|	<div class="container">
		// 	|		<div class="red">Red One</div>
		// 	|		Some Text
		// 	|		<div class="blue first">Blue One</div>
		// 	|		<div class="red">Red Two</div>
		// 	|		<div class="blue last">Blue Two</div>
		//	|	</div>
		//		Running this code:
		//	|	require(["dojo/query", "dojo/NodeList-traverse"
		//	|	], function(query){
		//	|		query(".first").next();
		//	|	});
		//		returns the div with class "red" and has innerHTML of "Red Two".
		//		Running this code:
		//	|	dojo.query(".last").next(".red");
		//		does not return any elements.
		return this._getRelatedUniqueNodes(query, function(node, ary){
			var next = node.nextSibling;
			while(next && next.nodeType != 1){
				next = next.nextSibling;
			}
			return next;
		}); // dojo/NodeList
	},

	nextAll: function(/*String?*/ query){
		// summary:
		//		Returns all sibling elements that come after the nodes in this dojo/NodeList.
		//		Optionally takes a query to filter the sibling elements.
		// description:
		//		.end() can be used on the returned dojo/NodeList to get back to the
		//		original dojo/NodeList.
		// query:
		//		a CSS selector.
		// returns:
		//		all sibling elements that come after the nodes in this dojo/NodeList.
		// example:
		//		assume a DOM created by this markup:
		//	|	<div class="container">
		// 	|		<div class="red">Red One</div>
		// 	|		Some Text
		// 	|		<div class="blue first">Blue One</div>
		// 	|		<div class="red next">Red Two</div>
		// 	|		<div class="blue next">Blue Two</div>
		//	|	</div>
		//		Running this code:
		//	|	require(["dojo/query", "dojo/NodeList-traverse"
		//	|	], function(query){
		//	|		query(".first").nextAll();
		//	|	});
		//		returns the two divs with class of "next".
		//		Running this code:
		//	|		query(".first").nextAll(".red");
		//		returns the one div with class "red" and innerHTML "Red Two".
		return this._getRelatedUniqueNodes(query, function(node, ary){
			var pary = [];
			var next = node;
			while((next = next.nextSibling)){
				if(next.nodeType == 1){
					pary.push(next);
				}
			}
			return pary;
		}); // dojo/NodeList
	},

	prev: function(/*String?*/ query){
		// summary:
		//		Returns the previous element for nodes in this dojo/NodeList.
		//		Optionally takes a query to filter the previous elements.
		// description:
		//		.end() can be used on the returned dojo/NodeList to get back to the
		//		original dojo/NodeList.
		// query:
		//		a CSS selector.
		// returns:
		//		the previous element for nodes in this dojo/NodeList.
		// example:
		//		assume a DOM created by this markup:
		//	|	<div class="container">
		// 	|		<div class="red">Red One</div>
		// 	|		Some Text
		// 	|		<div class="blue first">Blue One</div>
		// 	|		<div class="red">Red Two</div>
		// 	|		<div class="blue">Blue Two</div>
		//	|	</div>
		//		Running this code:
		//	|	require(["dojo/query", "dojo/NodeList-traverse"
		//	|	], function(query){
		//	|		query(".first").prev();
		//	|	});
		//		returns the div with class "red" and has innerHTML of "Red One".
		//		Running this code:
		//	|		query(".first").prev(".blue");
		//		does not return any elements.
		return this._getRelatedUniqueNodes(query, function(node, ary){
			var prev = node.previousSibling;
			while(prev && prev.nodeType != 1){
				prev = prev.previousSibling;
			}
			return prev;
		}); // dojo/NodeList
	},

	prevAll: function(/*String?*/ query){
		// summary:
		//		Returns all sibling elements that come before the nodes in this dojo/NodeList.
		//		Optionally takes a query to filter the sibling elements.
		// description:
		//		The returned nodes will be in reverse DOM order -- the first node in the list will
		//		be the node closest to the original node/NodeList.
		//		.end() can be used on the returned dojo/NodeList to get back to the
		//		original dojo/NodeList.
		// query:
		//		a CSS selector.
		// returns:
		//		all sibling elements that come before the nodes in this dojo/NodeList.
		// example:
		//		assume a DOM created by this markup:
		//	|	<div class="container">
		// 	|		<div class="red prev">Red One</div>
		// 	|		Some Text
		// 	|		<div class="blue prev">Blue One</div>
		// 	|		<div class="red second">Red Two</div>
		// 	|		<div class="blue">Blue Two</div>
		//	|	</div>
		//		Running this code:
		//	|	require(["dojo/query", "dojo/NodeList-traverse"
		//	|	], function(query){
		//	|		query(".second").prevAll();
		//	|	});
		//		returns the two divs with class of "prev".
		//		Running this code:
		//	|		query(".first").prevAll(".red");
		//		returns the one div with class "red prev" and innerHTML "Red One".
		return this._getRelatedUniqueNodes(query, function(node, ary){
			var pary = [];
			var prev = node;
			while((prev = prev.previousSibling)){
				if(prev.nodeType == 1){
					pary.push(prev);
				}
			}
			return pary;
		}); // dojo/NodeList
	},

	andSelf: function(){
		// summary:
		//		Adds the nodes from the previous dojo/NodeList to the current dojo/NodeList.
		// description:
		//		.end() can be used on the returned dojo/NodeList to get back to the
		//		original dojo/NodeList.
		// example:
		//		assume a DOM created by this markup:
		//	|	<div class="container">
		// 	|		<div class="red prev">Red One</div>
		// 	|		Some Text
		// 	|		<div class="blue prev">Blue One</div>
		// 	|		<div class="red second">Red Two</div>
		// 	|		<div class="blue">Blue Two</div>
		//	|	</div>
		//		Running this code:
		//	|	require(["dojo/query", "dojo/NodeList-traverse"
		//	|	], function(query){
		//	|		query(".second").prevAll().andSelf();
		//	|	});
		//		returns the two divs with class of "prev", as well as the div with class "second".
		return this.concat(this._parent);	// dojo/NodeList
	},

	//Alternate methods for the :first/:last/:even/:odd pseudos.
	first: function(){
		// summary:
		//		Returns the first node in this dojo/NodeList as a dojo/NodeList.
		// description:
		//		.end() can be used on the returned dojo/NodeList to get back to the
		//		original dojo/NodeList.
		// returns:
		//		the first node in this dojo/NodeList
		// example:
		//		assume a DOM created by this markup:
		//	|	<div class="container">
		// 	|		<div class="red">Red One</div>
		// 	|		<div class="blue first">Blue One</div>
		// 	|		<div class="red">Red Two</div>
		// 	|		<div class="blue last">Blue Two</div>
		//	|	</div>
		//		Running this code:
		//	|	require(["dojo/query", "dojo/NodeList-traverse"
		//	|	], function(query){
		//	|		query(".blue").first();
		//	|	});
		//		returns the div with class "blue" and "first".
		return this._wrap(((this[0] && [this[0]]) || []), this); // dojo/NodeList
	},

	last: function(){
		// summary:
		//		Returns the last node in this dojo/NodeList as a dojo/NodeList.
		// description:
		//		.end() can be used on the returned dojo/NodeList to get back to the
		//		original dojo/NodeList.
		// returns:
		//		the last node in this dojo/NodeList
		// example:
		//		assume a DOM created by this markup:
		//	|	<div class="container">
		// 	|		<div class="red">Red One</div>
		// 	|		<div class="blue first">Blue One</div>
		// 	|		<div class="red">Red Two</div>
		// 	|		<div class="blue last">Blue Two</div>
		//	|	</div>
		//		Running this code:
		//	|	require(["dojo/query", "dojo/NodeList-traverse"
		//	|	], function(query){
		//	|	query(".blue").last();
		//	|	});
		//		returns the last div with class "blue",
		return this._wrap((this.length ? [this[this.length - 1]] : []), this); // dojo/NodeList
	},

	even: function(){
		// summary:
		//		Returns the even nodes in this dojo/NodeList as a dojo/NodeList.
		// description:
		//		.end() can be used on the returned dojo/NodeList to get back to the
		//		original dojo/NodeList.
		// returns:
		//		the even nodes in this dojo/NodeList
		// example:
		//		assume a DOM created by this markup:
		//	|	<div class="container">
		// 	|		<div class="interior red">Red One</div>
		// 	|		<div class="interior blue">Blue One</div>
		// 	|		<div class="interior red">Red Two</div>
		// 	|		<div class="interior blue">Blue Two</div>
		//	|	</div>
		//		Running this code:
		//	|	require(["dojo/query", "dojo/NodeList-traverse"
		//	|	], function(query){
		//	|		query(".interior").even();
		//	|	});
		//		returns the two divs with class "blue"
		return this.filter(function(item, i){
			return i % 2 != 0;
		}); // dojo/NodeList
	},

	odd: function(){
		// summary:
		//		Returns the odd nodes in this dojo/NodeList as a dojo/NodeList.
		// description:
		//		.end() can be used on the returned dojo/NodeList to get back to the
		//		original dojo/NodeList.
		// returns:
		//		the odd nodes in this dojo/NodeList
		// example:
		//		assume a DOM created by this markup:
		//	|	<div class="container">
		// 	|		<div class="interior red">Red One</div>
		// 	|		<div class="interior blue">Blue One</div>
		// 	|		<div class="interior red">Red Two</div>
		// 	|		<div class="interior blue">Blue Two</div>
		//	|	</div>
		//		Running this code:
		//	|	require(["dojo/query", "dojo/NodeList-traverse"
		//	|	], function(query){
		//	|		query(".interior").odd();
		//	|	});
		//		returns the two divs with class "red"
		return this.filter(function(item, i){
			return i % 2 == 0;
		}); // dojo/NodeList
	}
});

return NodeList;
});

},
'doccontrol/viewer/dojo/Notification':function(){
define([
    'dojo/_base/declare',
    'dijit/_WidgetBase',
    'dijit/_TemplatedMixin',
    'dojo/dom-construct',
    'dojo/text!./template/NotificationContainer.html',
    'dojo/text!./template/notification/InlineFloatingNotification.html',
    'vendor/ejs/ejs'
], function(
    declare,
    WidgetBase,
    Templated,
    domConstruct,
    template,
    notificationTemplate,
    templateRenderer
) {
    const Notification = function(node) {
        const View = declare([WidgetBase, Templated], {
            templateString: template,

            show: function(message, time) {
                this._place({
                    message: message
                }, time ? time : 3600);
            },

            _place: function(data, time) {
                let notification = domConstruct.place(
                    templateRenderer.render(notificationTemplate, data),
                    this.notificationContainer,
                    'last'
                );

                setTimeout(function() {
                    domConstruct.destroy(notification);
                }, time);
            }
        });

        this.view = new View({}, domConstruct.create('div', {}, node, 'only'));
    };

    Notification.prototype.show = function(message, time) {
        this.view.show(message, time);
    };

    return Notification;
});
},
'style-guide/v1/color-picker/LimitedColorPicker':function(){
define([
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/query',
    'dojo/Evented',
    'dojo/on',
    'dijit/_WidgetBase',
    'dojo/text!./template/LimitedColorPicker.html',
    'soso/sosox/ejs/_Templated'
], function(
    declare,
    domAttr,
    domClass,
    query,
    Evented,
    on,
    WidgetBase,
    template,
    Templated
) {
    const ColorPicker = function(data, node) {
        const View = declare([WidgetBase, Templated, Evented], {
            templateString: template,
            data: {
                colors: data && data.colors ? data.colors : ['red', 'green', 'blue'],
                disabled: false,
                selected: data && data.selected ? data.selected : 'red'
            },

            _selectColor: function(e) {
                if (!domAttr.has(e.target, 'disabled')) {
                    this.data.selected = domAttr.get(e.target, 'data-color');
                    this.emit('change', this.data.selected);
                    this.render();
                }
            },

            _enable: function() {
                this.data.disabled = false;
                this.render();
            },

            _disable: function() {
                this.data.disabled = true;
                this.render();
            }
        });

        this.view = new View({}, node);
    };

    ColorPicker.prototype.get = function() {
        return this.view;
    };

    ColorPicker.prototype.enable = function() {
        return this.view._enable();
    };

    ColorPicker.prototype.disable = function() {
        return this.view._disable();
    };

    return ColorPicker;
});
},
'style-guide/v1/tooltip/Tooltip':function(){
define([
    'dijit/_WidgetBase',
    'dojo/_base/declare',
    'dojo/dom-class',
    'dojo/dom-construct',
    'dojo/dom-style',
    'dojo/on',
    'dojo/query',
    'dojo/text!./template/Tooltip.html',
    'soso/sosox/ejs/_Templated'
], function(
    WidgetBase,
    declare,
    domClass,
    domConstruct,
    domStyle,
    on,
    query,
    template,
    Templated
) {
    const ARROW_SIZE = 9;

    const POSITIONS = {
        TOP: 'top',
        LEFT: 'left',
        RIGHT: 'right',
        BOTTOM: 'bottom'
    };

    const MINIMUM_COORDINATE = 5;

    return declare([WidgetBase, Templated], {
        templateString: template,

        target: null,
        position: 'top',

        targetPosition: {},
        tooltipPosition: {},

        scrollableContainer: null,

        hover: false,
        closeToDismiss: false,
        scrollToDismiss: false,

        constructor: function() {
            this.events = [];
            this.data = {content: null};
        },

        postCreate: function() {
            this._placeIntoDom();

            if(!this.closeToDismiss) {
                window.addEventListener('click', this.close.bind(this), true);
                domStyle.set(this.closeIcon, 'display', 'none');
            }

            if(this.closeToDismiss) {
                this.events.push(
                    on(this.closeIcon, 'click', (e) => {
                        e.stopPropagation();
                        this.close();
                    })
                )
            }

            if(this.scrollToDismiss) {
                const eventTarget = this.scrollableContainer || window;
                this.events.push(on(eventTarget, 'scroll', this.close.bind(this)));
            }

            if(this.hover) {
                this.events.push(on(this.target, 'mouseleave', this.close.bind(this)));
            }

            this.targetPosition = this.target.getBoundingClientRect();
            this.tooltipPosition = this.domNode.getBoundingClientRect();
            this._position();
        },

        close: function() {
            if(!this.closeToDismiss) {
                window.removeEventListener('click', this.close.bind(this), true);
            }

            this.events.forEach(function(event) {
                 event.remove();
            });

            domConstruct.destroy(this.domNode);
            this.destroy();
        },

        _placeIntoDom: function() {
            const v1 = query('.sos-v1')[0];
            domConstruct.place(this.domNode, v1, 'last');

            /**
             * If we don't set left and top positions to 0 it's possible
             * that the addition of this element to the sos-v1 tag adds
             * enough height to the page to temporarily add a vertical
             * scrollbar, this then causes issues when trying to calculate
             * where on the page to position it because it accounts for
             * the width of that scrollbar, which ultimately then
             * gets removed when we position the tooltip.
             */
            domStyle.set(this.domNode, 'left', '0');
            domStyle.set(this.domNode, 'top', '0');
        },

        _position: function() {
            if (!this._isPositionedValid()) {
                throw 'Tooltip position is invalid';
            }

            let x, y;

            if(this._isPositionedAbove()) {
                y = this._getYCoordinatePositioningAbove();
                x = this._getXCoordinatePositioningCentrally();
                this._placeArrowBelow(x);

                if(this._wouldDisplayOffScreenTop(y)) {
                    y = this._getYCoordinatePositioningBelow();
                    this._placeArrowAbove(x);
                }
            }

            if(this._isPositionedBelow()) {
                y = this._getYCoordinatePositioningBelow();
                x = this._getXCoordinatePositioningCentrally();
                this._placeArrowAbove(x);

                if(this._wouldDisplayOffScreenBottom(y)) {
                    y = this._getYCoordinatePositioningAbove();
                    this._placeArrowBelow(x);
                }
            }

            if(this._isPositionedLeft()) {
                y = this._getYCoordinatePositioningCentrally();
                x = this._getXCoordinatePositionedLeft();
                this._placeArrowRight(y);

                if(this._wouldDisplayOffScreenLeft(x)) {
                    this._getXCoordinatePositionedRight();
                    this._placeArrowLeft(y);
                }
            }

            if(this._isPositionedRight()) {
                y = this._getYCoordinatePositioningCentrally();
                x = this._getXCoordinatePositionedRight();
                this._placeArrowLeft(y);

                if(this._wouldDisplayOffScreenRight(x)) {
                    x = this._getXCoordinatePositionedLeft();
                    this._placeArrowRight(y);
                }
            }

            y += window.pageYOffset;
            x += window.pageXOffset;

            domStyle.set(this.domNode, 'left', x + 'px');
            domStyle.set(this.domNode, 'top', y + 'px');
        },

        _placeArrowBelow: function(x) {
            const pxAtMiddleOfTarget = this.targetPosition.x
                + (this.targetPosition.width / 2);

            const offset = Math.floor(pxAtMiddleOfTarget - x);

            domStyle.set(this.arrow, 'left', offset + 'px');

            this._setArrowClass(POSITIONS.BOTTOM);
        },

        _placeArrowAbove: function(x) {
            const pxAtMiddleOfTarget = this.targetPosition.x
                + (this.targetPosition.width / 2);

            const offset = Math.floor(pxAtMiddleOfTarget - x);

            domStyle.set(this.arrow, 'left', offset + 'px');

            this._setArrowClass(POSITIONS.TOP);
        },

        _placeArrowLeft: function(y) {
            const pxAtMiddleOfTarget = this.targetPosition.y
                + (this.targetPosition.height / 2);

            const offset = Math.floor(pxAtMiddleOfTarget - y);

            domStyle.set(this.arrow, 'top', offset + 'px');

            this._setArrowClass(POSITIONS.LEFT);
        },

        _placeArrowRight: function(y) {
            const pxAtMiddleOfTarget = this.targetPosition.y
                + (this.targetPosition.height / 2);

            const offset = Math.floor(pxAtMiddleOfTarget - y);

            domStyle.set(this.arrow, 'top', offset + 'px');

            this._setArrowClass(POSITIONS.RIGHT);
        },

        _getYCoordinatePositioningAbove: function() {
            let y = this.targetPosition.y;

            y -= this.tooltipPosition.height;
            y -= ARROW_SIZE;

            return y;
        },

        _getYCoordinatePositioningBelow: function() {
            let y = this.targetPosition.y;

            y += this.targetPosition.height;
            y += ARROW_SIZE;

            return y;
        },

        _getYCoordinatePositioningCentrally: function() {
            let y = this.targetPosition.y;

            const triggerHeight = this.targetPosition.height;
            const tooltipHeight = this.tooltipPosition.height;

            y += (triggerHeight / 2) - (tooltipHeight / 2);

            if(this._wouldDisplayOffScreenTop(y)) {
                y = MINIMUM_COORDINATE;
            }

            if(this._wouldDisplayOffScreenBottom(y)) {
                y = window.innerHeight - this.tooltipPosition.height - MINIMUM_COORDINATE;
            }

            return y;
        },

        _getXCoordinatePositioningCentrally: function() {
            let x = this.targetPosition.x;

            const triggerWidth = this.targetPosition.width;
            const tooltipWidth = this.tooltipPosition.width;

            x += (triggerWidth / 2) - (tooltipWidth / 2);

            if(this._wouldDisplayOffScreenLeft(x)) {
                x = MINIMUM_COORDINATE;
            }

            if(this._wouldDisplayOffScreenRight(x)) {
                x = window.innerWidth - this.tooltipPosition.width - MINIMUM_COORDINATE;
            }

            return x;
        },

        _getXCoordinatePositionedLeft: function() {
            return this.targetPosition.x
                - this.tooltipPosition.width
                - ARROW_SIZE;
        },

        _getXCoordinatePositionedRight: function() {
            return this.targetPosition.x
                + this.targetPosition.width
                + ARROW_SIZE;
        },

        _wouldDisplayOffScreenTop: function(y) {
            return y < MINIMUM_COORDINATE;
        },

        _wouldDisplayOffScreenBottom: function(y) {
            return (y + this.tooltipPosition.height) > (window.innerHeight - MINIMUM_COORDINATE);
        },

        _wouldDisplayOffScreenLeft: function(x) {
            return x < MINIMUM_COORDINATE;
        },

        _wouldDisplayOffScreenRight: function(x) {
            return (x + this.tooltipPosition.width) > (window.innerWidth - MINIMUM_COORDINATE);
        },

        _isPositionedValid: function() {
            return this._isPositionedAbove() ||
                this._isPositionedBelow() ||
                this._isPositionedLeft() ||
                this._isPositionedRight();
        },

        _isPositionedAbove: function() {
            return this.position === POSITIONS.TOP;
        },

        _isPositionedBelow: function() {
            return this.position === POSITIONS.BOTTOM;
        },

        _isPositionedLeft: function() {
            return this.position === POSITIONS.LEFT;
        },

        _isPositionedRight: function() {
            return this.position === POSITIONS.RIGHT;
        },

        _setArrowClass: function(arrowClass) {
            domClass.replace(
                this.arrow,
                arrowClass,
                [
                    POSITIONS.BOTTOM,
                    POSITIONS.TOP,
                    POSITIONS.LEFT,
                    POSITIONS.RIGHT
                ]
            );
        }
    });
});
},
'style-guide/v1/media/capture-camera/CaptureCamera':function(){
define([
    'dijit/_WidgetBase',
    'dojo/_base/declare',
    'soso/sosox/ejs/_Templated',
    'dojo/text!style-guide/v1/media/templates/AddCaptureDialog.html',
    'dojo/on',
    'dojo/topic',
    'dojo/Evented',
    'style-guide/v1/layout/Dialog',
    'style-guide/v1/menus/ContextMenu',
    'style-guide/v1/menus/ContextMenuItem'
], function(
    _WidgetBase,
    declare,
    _Templated,
    template,
    on,
    topic,
    Evented,
    Dialog,
    ContextMenu,
    ContextMenuItem
) {
    const CAMERA_PERMISSION_STATUS_DENIED_ERROR = 'The system is unable to access your camera device. Grant access via your browser settings.';
    const CAMERA_PERMISSION_STATUS_NOT_FOUND_ERROR = 'The system is unable to find your camera device. Grant access via your system settings.'
    const CAMERA_PERMISSION_STATUS_NOT_READABLE_ERROR = 'The system could not start the video source. Check your system/browser settings.'
    const STANDARD_ERROR_MESSAGE = 'Something went wrong, please try again. If the problem persists please contact support.';
    const MEDIA_DEVICE_NOT_ALLOWED_ERROR = 'NotAllowedError';
    const MEDIA_DEVICE_NOT_FOUND_ERROR = 'NotFoundError'
    const MEDIA_DEVICE_NOT_READABLE_ERROR = 'NotReadableError';
    const MEDIA_DEVICE_TYPE = 'videoinput';

    const mediaPermissionErrorObject = {
        [MEDIA_DEVICE_NOT_ALLOWED_ERROR]: CAMERA_PERMISSION_STATUS_DENIED_ERROR,
        [MEDIA_DEVICE_NOT_FOUND_ERROR]: CAMERA_PERMISSION_STATUS_NOT_FOUND_ERROR,
        [MEDIA_DEVICE_NOT_READABLE_ERROR]: CAMERA_PERMISSION_STATUS_NOT_READABLE_ERROR
    }

    return declare([_WidgetBase, Evented, _Templated], {
        templateString: template,
        elementCaptureVideo: null,
        elementCapturedImage: null,
        elementLoadingCaptureFeedContainer: null,
        elementPreviewCaptureContainer: null,
        elementInsertCaptureContainer: null,
        contextMenuItem: null,

        postCreate: function() {
            this._initCaptureDialog();

            this.captureDialog.on('hide', () => {
                this._stopMediaTracks();
            });
        },

        open: function() {
            this._openCaptureDialog();
        },

        close: function() {
            this._closeCaptureDialog();
        },

        _initCaptureDialog: function() {
            this.captureDialog = new Dialog({
                titleString: 'Capture Preview',
                contentNode: this.domNode,
                'class': 'sos-layout-dialog-responsive-footer'
            });
        },

        _openCaptureDialog: async function() {
            try {
                await this._createMediaTrack();
                this.captureDialog.show();
                this.elementLoadingCaptureFeedContainer.hidden = false;
                this.elementPreviewCaptureContainer.hidden = true;
                this.elementInsertCaptureContainer.hidden = true;
                this._createVideoFeed();
            } catch (error) {
                if (mediaPermissionErrorObject.hasOwnProperty(error.name)) {
                    topic.publish('sos-system-notification', mediaPermissionErrorObject[error.name], 'error');
                } else {
                    topic.publish('sos-system-notification', STANDARD_ERROR_MESSAGE, 'error');
                }
                this._closeCaptureDialog();
            }
        },

        _onCaptureSettingMenuClick: async function(e) {
            this.menuVideoDeviceItems = [];

            await this._createChangeDeviceMenuItems();
            this._toggleActiveDevice();

            new ContextMenu({
                'class': 'sos-context-menu sos-context-menu-capture-settings',
                items: this.menuVideoDeviceItems
            }).open(e);
        },

        _onCaptureImageClick: async function() {
            this.elementPreviewCaptureContainer.hidden = true;
            this.elementInsertCaptureContainer.hidden = false;
            const videoStreamCanvas = document.createElement('canvas');
            videoStreamCanvas.width = this.elementCaptureVideo.videoWidth;
            videoStreamCanvas.height = this.elementCaptureVideo.videoHeight;
            videoStreamCanvas.getContext('2d').drawImage(this.elementCaptureVideo, 0, 0, videoStreamCanvas.width, videoStreamCanvas.height);
            this.dataURL = videoStreamCanvas.toDataURL();
            this.elementCapturedImage.src = this.dataURL;
        },

        _onInsertImageButtonClick: async function() {
            this.emit('submit', this.dataURL);
            this._closeCaptureDialog();
        },

        _onRecaptureButtonClick: function() {
            this.elementPreviewCaptureContainer.hidden = false;
            this.elementInsertCaptureContainer.hidden = true;
        },

        _createVideoFeed: function() {
            this.elementCaptureVideo.srcObject = this.stream;
            this.elementCaptureVideo.onloadedmetadata = () => {
                this.elementCaptureVideo.play();
                this.elementLoadingCaptureFeedContainer.hidden = true;
                this.elementPreviewCaptureContainer.hidden = false;
                this._createErrorHandler();
            };
        },

        _createMediaTrack: async function(mediaDevice) {
            this._stopMediaTracks();

            const constraints = {
                video: {deviceId: mediaDevice ? {exact: mediaDevice} : undefined}
            };

            this.stream = await navigator.mediaDevices.getUserMedia(constraints);
        },

        _createErrorHandler: function() {
            this.stream.getTracks().forEach(track => {
                track.onended = () => {
                    topic.publish('sos-system-notification', STANDARD_ERROR_MESSAGE, 'error');
                    this._closeCaptureDialog();
                };
            });
        },

        _createChangeDeviceMenuItems: async function () {
            try {
                (await navigator.mediaDevices.enumerateDevices()).forEach((device) => {
                    if (device.kind === MEDIA_DEVICE_TYPE) {
                        const deviceItem = new ContextMenuItem({
                            data: {
                                icon: 'camera',
                                text: device.label
                            },
                            onClick: async () => {
                                deviceItem.domNode.classList.add('selected-device');
                                this.elementLoadingCaptureFeedContainer.hidden = true;
                                this.elementPreviewCaptureContainer.hidden = false;
                                await this._createMediaTrack(device.deviceId);

                                this.elementLoadingCaptureFeedContainer.hidden = false;
                                this.elementPreviewCaptureContainer.hidden = true;
                                this._createVideoFeed();
                            }
                        });
                        this.menuVideoDeviceItems.push(deviceItem);
                    }
                });
            } catch (error) {
                topic.publish('sos-system-notification', STANDARD_ERROR_MESSAGE, 'error');
            }
        },

        _closeCaptureDialog: function() {
            this.captureDialog.hide();
            this._stopMediaTracks();
        },

        _stopMediaTracks: function() {
            if (this.stream) {
                this.stream.getTracks().forEach((track) => {
                    track.stop();
                });
            }
        },

        _toggleActiveDevice: function () {
            this.menuVideoDeviceItems.forEach((device) => {
                this.stream.getVideoTracks().some(function (track) {
                    if (track.label === device.data.text) {
                        device.domNode.classList.toggle('selected-device');
                    }
                });
            });
        },
    });
});
},
'style-guide/v1/layout/Dialog':function(){
define([
    'dojo/_base/declare',
    'dojo/dom-construct',
    'dojo/dom-style',
    'dojo/Evented',
    'dojo/html',
    'dojo/keys',
    'dojo/on',
    'dojo/query',
    'dijit/_WidgetBase',
    'dijit/_TemplatedMixin',
    'dojo/text!./templates/Dialog.html',
    './_dialogCheckerMixin',
    'dojo/NodeList-dom'
], function(
    declare,
    domConstruct,
    domStyle,
    Evented,
    html,
    keys,
    on,
    query,
    _WidgetBase,
    _Templated,
    template,
    _dialogCheckerMixin
) {
    const CLASSNAME_HIDE_SCROLL_BARS = 'sos-dialog-hide-scroll-bars';

    return declare([_WidgetBase, _Templated, Evented, _dialogCheckerMixin], {
        additionalClass: '',
        contentNode: null,
        elementContent: null,
        elementTitle: null,
        templateString: template,
        titleString: '',
        eventHandlerEscapeKeyPress: null,
        dialogNode: null,
        isHidden: true,

        postCreate: function() {
            this.inherited(arguments);

            this._placeContent();
            this._initOverlayClickEvent();
            this._initEscapeKeyUpEvent();
        },

        show: function() {
            this._placeDialog();

            this.domNode.classList.add('sos-dialog-open');
            query('html').addClass(CLASSNAME_HIDE_SCROLL_BARS);

            this.eventHandlerEscapeKeyPress.resume();
            this.isHidden = false;
        },

        hide: function() {
            if (this.isHidden) {
                return;
            }

            this.isHidden = true;
            this._removeDialog();

            if (!this.areDialogsOpen()) {
                query('html').removeClass(CLASSNAME_HIDE_SCROLL_BARS);
            }

            this.eventHandlerEscapeKeyPress.pause();
        },

        setTitle: function(title) {
            this.titleString = title;
            html.set(this.elementTitle, title);
        },

        _onCloseClick: function(e) {
            e.stopPropagation();
            this.hide();
            this.emit('hide', {});
        },

        _placeDialog: function() {
            this.dialogNode = document.createElement('div');
            this.refNode = document.getElementsByClassName('sos-v1')[0];
            this.refNode.appendChild(this.dialogNode);
            this.dialogNode.appendChild(this.domNode);
        },

        _removeDialog: function() {
            if (this.refNode && this.refNode.contains(this.dialogNode)) {
                this.refNode.removeChild(this.dialogNode);
            }
        },

        _placeContent: function() {
            this.elementContent.appendChild(this.contentNode);
        },

        _initOverlayClickEvent: function() {
            on(this.domNode, 'mousedown', function(e) {
                if(this._isNodeOverlay(e.target)) {
                    this.hide();
                    this.emit('hide', {});
                }
            }.bind(this));
        },

        _isNodeOverlay: function(node) {
            return node.classList.contains('sos-layout-dialog-responsive');
        },

        _initEscapeKeyUpEvent: function() {
            this.eventHandlerEscapeKeyPress = on.pausable(document, 'keyup', function(e) {
                if (e.keyCode === keys.ESCAPE) {
                    this.hide();
                    this.emit('hide', {});
                }
            }.bind(this));

            this.eventHandlerEscapeKeyPress.pause();
        }
    })
});
},
'style-guide/v1/layout/_dialogCheckerMixin':function(){
define([
    'dojo/_base/declare',
    'dojo/query'
], function (
    declare,
    query
) {
    return declare([], {
        areDialogsOpen: function () {
            return query('.sos-layout-dialog.sos-dialog-open, .sos-layout-dialog-responsive.sos-dialog-open').length > 0;
        }
    });
});
},
'style-guide/v1/menus/ContextMenu':function(){
define([
    'dojo/_base/declare',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated',
    'dojo/text!./templates/ContextMenu.html',
    'dojo/dom-class',
    'dojo/dom-style',
    'dojo/on',
    'dojo/query'
], function(
    declare,
    _WidgetBase,
    _Templated,
    template,
    domClass,
    domStyle,
    on,
    query
) {
    const CONTAINER_SELECTOR = '.sos-v1';

    return declare([_WidgetBase, _Templated], {
        templateString: template,
        items: [],
        parent: null,
        closeOnClick: true,

        mouseDownHandler: null,
        scrollHandler: null,

        onClose: function() {},

        postCreate: function() {
            this._placeItems();
            this._removeIconSpaceIfNoItemsHaveIcons();
        },

        setItems: function(items) {
            this.items = items;

            this._placeItems();
            this._removeIconSpaceIfNoItemsHaveIcons();
        },

        hasParent: function() {
            return !!this.parent;
        },

        open: function(e) {
            e.stopPropagation();

            domClass.remove(this.domNode, 'hidden');

            this.items.forEach(function(item) {
                item.closeMenu();
            });

            this.hasParent() ? this._placeAsSubMenu() : this._placeAsPrimaryMenu(e);
        },

        openAsSubMenu: function(refNode) {
            refNode.appendChild(this.domNode);
            this.domNode.classList.add('sub-menu');
            this.domNode.classList.remove('hidden');

            this.items.forEach(function(item) {
                item.closeMenu();
            });

            this._createCloseHandlers();
        },

        close: function() {
            domClass.add(this.domNode, 'hidden');

            this.hasParent() ? this._resetPosition() : this._removeCloseHandler();

            this.onClose();
        },

        getParent: function() {
            return this.parent;
        },

        destroyRecursive: function() {
            this.domNode.remove();
            this.items.forEach(item => item.destroyRecursive());

            this.inherited(arguments);
        },

        _placeItems: function() {
            this.domNode.innerHTML = '';

            this.items.forEach(function(item) {
                item.parent = this;
                item.placeAt(this.domNode);
            }.bind(this));
        },

        _placeAsPrimaryMenu: function(e) {
            const container = query(CONTAINER_SELECTOR).shift();
            this.placeAt(container);

            this._placeAtEventCoordinates(e);

            if(this._isDisplayingOffScreenHorizontally()) {
                this._positionLeftOfCursor(e);
            }

            if(this._isDisplayingOffScreenVertically()) {
                this._placeAtBottomOfScreen();
            }

            this._createCloseHandlers();
        },

        _placeAsSubMenu: function() {
            if(this._isDisplayingOffScreenHorizontally()) {
                this._positionLeftOfParent();
            }

            if(this._isDisplayingOffScreenVertically()) {
                this._moveIntoViewVertically();
            }
        },

        _resetPosition: function() {
            this.parent.set('caretDirection', 'right');
            const container = this.domNode.parentNode;

            domStyle.set(container, 'left', '');
            domStyle.set(container, 'right', '');
            domStyle.set(container, 'margin-top', '');
        },

        _positionLeftOfCursor: function(e) {
            const elementWidth = domStyle.get(this.domNode, 'width');
            domStyle.set(this.domNode, 'left', (e.clientX - 1 - elementWidth) + 'px');
        },

        _positionLeftOfParent: function() {
            const container = this.domNode.parentNode;

            domStyle.set(container, 'left', 'unset');
            domStyle.set(container, 'right', '100%');

            this.parent.set('caretDirection', 'left');
        },

        _createCloseHandlers: function() {
            const _this = this;
            function onClose() {
                _this.close();
                window.removeEventListener('scroll', onClose, true);
            }

            this.mouseDownHandler = on.pausable(document, 'mousedown', () => {
                window.removeEventListener('scroll', onClose, true);
                this.close();
            });

            on(this.domNode, 'mouseleave', this._resumeCloseHandler.bind(this));
            on(this.domNode, 'mouseenter', this._pauseCloseHandler.bind(this));
            on(this.domNode, 'mouseover', this._pauseCloseHandler.bind(this));

            window.addEventListener('scroll', onClose, true);
        },

        _pauseCloseHandler: function() {
            if (!this.closeOnClick) this.mouseDownHandler?.pause();
        },

        _resumeCloseHandler: function() {
            this.mouseDownHandler?.resume();
        },

        _removeCloseHandler: function() {
            this.mouseDownHandler?.remove();
        },

        _isDisplayingOffScreenHorizontally: function() {
            return this._getHorizontalOffset() > document.body.clientWidth;
        },

        _isDisplayingOffScreenVertically: function() {
            return this._getVerticalOffset()  > document.body.clientHeight;
        },

        _getHorizontalOffset: function() {
            return this.domNode.getBoundingClientRect().left + domStyle.get(this.domNode, 'width');
        },

        _getVerticalOffset: function() {
            return this.domNode.getBoundingClientRect().top + domStyle.get(this.domNode, 'height');
        },

        _placeAtEventCoordinates: function(e) {
            domStyle.set(this.domNode, 'top', (e.clientY + 1) + 'px');
            domStyle.set(this.domNode, 'left', (e.clientX + 1) + 'px');
        },

        _placeAtBottomOfScreen: function() {
            const intendedTopOffset = document.body.clientHeight - domStyle.get(
                this.domNode,
                'height'
            );

            domStyle.set(this.domNode, 'top', intendedTopOffset + 'px');
        },

        _moveIntoViewVertically: function() {
            const amountOffScreen = this._getVerticalOffset() - document.body.clientHeight;

            domStyle.set(
                this.domNode.parentNode,
                'margin-top',
                (-1 * amountOffScreen) + 'px'
            );
        },

        _removeIconSpaceIfNoItemsHaveIcons: function() {
            const iconsPresent = this.items.some(function(item) {
                return !!item.data.icon;
            });

            if (iconsPresent) {
                return;
            }

            this.items.forEach(function(item) {
                query('> span:first-of-type', item.domNode).forEach(function(iconContainer) {
                    domStyle.set(iconContainer, 'width', '0');
                });
            });
        }
    });
});
},
'style-guide/v1/menus/ContextMenuItem':function(){
define([
    'dojo/_base/declare',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated',
    'dojo/text!./templates/ContextMenuItem.html',
    'dojo/dom-class',
    'style-guide/v1/tooltip/Tooltip'
], function(
    declare,
    _WidgetBase,
    _Templated,
    template,
    domClass,
    Tooltip
) {
    const EXPANDED_CLASS = 'expanded';
    const CARET_ICON_LEFT = 'sos-icon-caret-left';
    const CARET_ICON_RIGHT = 'sos-icon-caret-right';
    const CARET_ICON_PREFIX = 'sos-icon-caret-';

    return declare([_WidgetBase, _Templated], {
        templateString: template,

        caretNode: null,
        menu: null,
        onClick: null,
        iconContainer: null,
        tooltipText: null,

        buildRendering: function() {
            if (!this.data.hasOwnProperty('icon')) this.data.icon = null;
            if (!this.data.hasOwnProperty('titleText')) this.data.titleText = null;

            this.inherited(arguments);
        },

        postCreate: function() {
            if (this.hasMenu()) {
                this._createMenu();
            }

            if (this.tooltipText) {
                this._createTooltip();
            }
        },

        getTitle: function() {
            return this.data.text;
        },

        setText: function(text) {
            this.data.text = text;
            this.render(this.data);

            return this;
        },

        setIcon: function(icon) {
            this.data.icon = icon;
            this.render(this.data);

            return this;
        },

        hasMenu: function() {
            return !!this.menu;
        },

        getParent: function() {
            return this.parent;
        },

        closeMenu: function() {
            if(this.hasMenu()) {
                this.menu.close();
                domClass.remove(this.domNode, EXPANDED_CLASS);
            }
        },

        removeIcon: function() {
            this.iconContainer.className = '';
        },

        setOnClick: function(callback) {
            this.onClick = callback;
        },

        show: function() {
            this.domNode.classList.remove('hide');
        },

        hide: function() {
            this.domNode.classList.add('hide');
        },

        destroyRecursive: function() {
            this.onClick = null;
            this.inherited(arguments);
        },

        _openMenu: function(e) {
            if(this.hasMenu()) {
                this.menu.open(e);
                domClass.add(this.domNode, EXPANDED_CLASS);
            }
        },

        _onClick: function(e) {
            const heldEvent = this._temporarilyDisableParentEvents();

            if(this.onClick && !domClass.contains(this.domNode, 'disabled')) {
                return this.onClick(e);
            }

            e.stopPropagation();
            this._restoreTemporarilyDisabledParentEvent(heldEvent);
        },

        _createTooltip: function() {
            this.domNode.addEventListener('mouseenter', e => {
                new Tooltip({
                    target: e.target,
                    position: 'bottom',
                    data: {
                        content: this.tooltipText
                    },
                    hover: true
                });
            });
        },

        _temporarilyDisableParentEvents: function() {
            let parentMenu = this.getParent();
            let parentItem = null;
            let held = null;

            if(parentMenu) {
                parentItem = parentMenu.getParent();

                if(parentItem) {
                    held = parentItem.onClick;
                    parentItem.onClick = function() {
                        this.onClick = held;
                    };

                    return held;
                }
            }
        },

        _restoreTemporarilyDisabledParentEvent: function(heldEvent) {
            let parentMenu = this.getParent();
            let parentItem = null;

            if(parentMenu && heldEvent) {
                parentItem = parentMenu.getParent();

                if(parentItem) {
                    parentItem.onClick = heldEvent;
                }
            }
        },

        _createMenu: function() {
            this.menu.parent = this;
            this.menu.placeAt(this.menuNode);
        },

        _onMouseEnter: function(e) {
            if(domClass.contains(this.domNode, 'disabled')) {
                return;
            }

            for (let item in this.parent.items) {
                if (this.parent.items.hasOwnProperty(item)) {
                    this.parent.items[item].closeMenu();
                }
            }

            this._openMenu(e);
        },

        _setDisabledAttr: function(disabled) {
            if (disabled) {
                domClass.add(this.domNode, 'disabled');
            } else {
                domClass.remove(this.domNode, 'disabled');
            }
        },

        _setCaretDirectionAttr: function(direction) {
            domClass.remove(this.caretNode, CARET_ICON_RIGHT);
            domClass.remove(this.caretNode, CARET_ICON_LEFT);

            domClass.add(this.caretNode, CARET_ICON_PREFIX + direction);
        },

        _setIconAttr: function(icon) {
            this.iconContainer.className = 'sos-icon sos-icon-' + icon;
        },

        _setTitleAttr: function(title) {
            this.domNode.title = title;
        }
    });
});
},
'doccontrol/viewer/dojo/AnnotationWorkspace':function(){
define([
    '../Topics',
    'dijit/_WidgetBase',
    'dijit/_TemplatedMixin',
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dojo/_base/window',
    'dojo/date',
    'dojo/dom',
    'dojo/dom-class',
    'dojo/dom-construct',
    'dojo/dom-style',
    'dojo/html',
    'dojo/on',
    'dojo/query',
    'dojo/text!./template/AnnotationWorkspace.html',
    'dojo/text!./template/notification/AnnotationsHaveChanged.html',
    'dojo/text!./template/notification/ConnectionError.html',
    'dojo/text!./template/notification/Disconnected.html',
    'dojo/text!./template/notification/GeneratingAnnotatedDocument.html',
    'dojo/topic',
    'style-guide/v1/notifications/Notification',
    '../fabric/Canvas',
    '../parser/pins/Pin'
], function(
    Topics,
    WidgetBase,
    Templated,
    declare,
    lang,
    win,
    date,
    dom,
    domClass,
    domConstruct,
    domStyle,
    html,
    on,
    query,
    Template,
    AnnotationsHaveChanged,
    ConnectionErrorTemplate,
    DisconnectedTemplate,
    GeneratingAnnotatedDocumentTemplate,
    topic,
    Notification,
    Canvas,
    PinParser
) {
    const AnnotationWorkspace = function(node, scrollableOverlay, workspace, localStorage) {
        const View = declare([WidgetBase, Templated], {
            templateString: Template,
            roomName: null,
            scrollableOverlay: scrollableOverlay,
            workspace: workspace,
            canvas: null,
            documentBodyKeyDownEventHandler: null,
            pageNumber: 1,
            showingAnnotations: false,
            annotationRenderQueue: null,
            pagedAnnotationStack: [],
            noConnectionNode: null,
            connected: false,
            generatingAnnotatedDocumentNotificationNode: null,
            hiddenUsers: [],
            user: null,
            pinParser: null,
            localStorage: localStorage,

            postCreate: function() {
                this.inherited(arguments);

                this.user = this._getUser();
                this.annotationRenderQueue = Promise.resolve();
                this.pinParser = new PinParser();

                this._initialiseCanvas();
                this._subscribe();
            },

            destroy: function() {
                if (this.canvas) {
                    this.canvas.destroy();
                    this.canvas = null;
                }

                if (this.documentBodyKeyDownEventHandler) {
                    this.documentBodyKeyDownEventHandler.remove();
                }

                this.inherited(arguments);
            },

            setMd5: function(md5) {
                this.roomName = md5;

                if (this.connected) {
                    topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_SET_ID, this.roomName);
                } else {
                    topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_CONNECT);
                }
            },

            setAnnotationColor: function(color) {
                this.canvas.setColor(color);
            },

            setAnnotationIsColorFilled: function(isFilled) {
                this.canvas.setIsColorFilled(isFilled);
            },

            setLineStyle: function(lineStyle) {
                this.canvas.setLineStyle(lineStyle);
            },

            setLineWidth: function(width) {
                this.canvas.setLineWidth(width);
            },

            getAnnotationsForImage: function(image) {
                if (!this.connected) {
                    return Promise.reject('Not connected to the annotation server');
                }

                return new Promise(function(resolve) {
                    this.updateCanvas(1, 1, 0, image.naturalHeight, image.naturalWidth).then(function() {
                        resolve(this.canvas.toDataUrl());
                    }.bind(this)).catch(function() {
                        // Viewer closed during annotation rendering process
                    });
                }.bind(this));
            },

            getAnnotationsForPage: function(pageNum, pageRotation, pageHeight, pageWidth) {
                if (!this.connected) {
                    return Promise.reject('Not connected to the annotation server');
                }

                if (this._getAnnotationStackForPage(pageNum).length == 0) {
                    return Promise.resolve();
                }

                const excessiveAnnotationScaleFactor = 3;
                pageHeight *= excessiveAnnotationScaleFactor;
                pageWidth *= excessiveAnnotationScaleFactor;

                return new Promise(function(resolve) {
                    this.updateCanvas(pageNum, excessiveAnnotationScaleFactor, pageRotation, pageHeight, pageWidth).then(function() {
                        resolve(this.canvas.toDataUrl());
                    }.bind(this)).catch(function() {
                        // Viewer closed during annotation rendering process
                    });
                }.bind(this));
            },

            applyAnnotationToPage: function(annotation, pageNumber) {
                this._updateAnnotationInStack(annotation, pageNumber);

                if (this.canvas.isValidType(annotation) &&
                    this.showingAnnotations &&
                    pageNumber === this.pageNumber &&
                    this._isVisibleAnnotation(annotation)
                ) {
                    this._drawAnnotationToCanvas(annotation, pageNumber).catch(function() {
                        // Page change or viewer closed during annotation rendering process
                    });
                }
            },

            modifyAnnotation: function(data) {
                this.applyAnnotationToPage(data.annotation, data.pageNumber);
            },

            deleteAnnotation: function(data) {
                const annotationStack = this._getAnnotationStackForPage(data.pageNumber);
                topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATIONS_CHANGED);

                for (let i = 0; i < annotationStack.length; i++) {
                    if (annotationStack[i].id === data.annotationObjectID) {
                        annotationStack.splice(i, 1);
                        break;
                    }
                }

                if (data.pageNumber === this.pageNumber) {
                    this.canvas.remove(data.annotationObjectID);
                }

                this._updateExistingAnnotationsIcon();

                if (data.user && !this._userHasRemainingAnnotations(data.user)) {
                    topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_USER_REMOVE, data.user);
                }
            },

            _userHasRemainingAnnotations: function(user) {
                for (let i = 0; i < this.pagedAnnotationStack.length; i++) {
                    let annotationStack = this.pagedAnnotationStack[i].annotations;
                    for (let j = 0; j < annotationStack.length; j++) {
                        if (user.personPK === annotationStack[j].user.personPK) {
                            return true;
                        }
                    }
                }
                return false;
            },

            applyPageCollection: function(pageCollection) {
                this.pagedAnnotationStack = pageCollection;

                this._updateExistingAnnotationsIcon();

                if (this.showingAnnotations) {
                    this._showAllAnnotations().catch(function() {
                        // Page change or viewer closed during annotation rendering process
                    });
                }
            },

            _showAllAnnotations: function() {
                this.annotationRenderQueue = this.annotationRenderQueue.catch(function(){
                    // Page change or viewer closed during annotation rendering process
                }).then(function() {
                    this.canvas.clear();
                }.bind(this));

                if (this.noConnectionNode) {
                    domClass.remove(this.noConnectionNode, 'hidden');
                    domClass.add(this.canvas.container, 'canvas-disabled');
                    return Promise.reject();
                }

                const pageNumber = this.pageNumber;
                this.annotationRenderQueue = this.annotationRenderQueue.then(function() {
                    return this._getAnnotationStackForPage(pageNumber).reduce(function(accumulator, annotation) {
                        return accumulator.then(function() {
                            if (this.pageNumber !== pageNumber) {
                                return Promise.reject();
                            }

                            if (this.canvas.isValidType(annotation) && this._isVisibleAnnotation(annotation)) {
                                return this._drawAnnotationToCanvas(annotation, pageNumber);
                            }

                            return Promise.resolve();
                        }.bind(this));
                    }.bind(this), Promise.resolve()).then(function() {
                        if (!this.canvas.isSelectMode()) {
                            this.canvas.disableSelection();
                        }
                    }.bind(this));
                }.bind(this));

                return this.annotationRenderQueue;
            },

            hideAnnotations: function() {
                this.showingAnnotations = false;
                this.canvas.hide();

                if (this.noConnectionNode) {
                    domClass.add(this.noConnectionNode, 'hidden');
                    domClass.remove(this.canvas.container, 'canvas-disabled');
                }
            },

            updateCanvas: function(pageNumber, scale, rotation, height, width) {
                this.pageNumber = pageNumber;

                this.canvas.updateCanvas(scale, rotation, height, width);

                if (this.showingAnnotations) {
                    return this._showAllAnnotations().then(this.canvas.reselect.bind(this.canvas));
                }

                return Promise.resolve();
            },

            showAnnotation: function() {
                this.canvas.show();

                if (!this.showingAnnotations) {
                    this.showingAnnotations = true;
                    this._showAllAnnotations().catch(function() {
                        // Page change or viewer closed during annotation rendering process
                    });
                }
            },

            enterDragMode: function() {
                this.canvas.dragMode();
            },

            enterFreehandMode: function() {
                this.canvas.pencilMode();
            },

            enterHighlightMode: function() {
                this.canvas.highlighterMode();
            },

            enterLineMode: function() {
                this.canvas.lineMode();
            },

            enterEllipseMode: function() {
                this.canvas.ellipseMode();
            },

            enterRectangleMode: function() {
                this.canvas.rectangleMode();
            },

            enterHexagonMode: function() {
                this.canvas.hexagonMode();
            },

            enterPolygonMode: function() {
                this.canvas.polygonMode();
            },

            cancelPendingPolygon: function() {
                this.canvas.cancelPendingPolygon();
            },

            enterHighlightRegionMode: function() {
                this.canvas.highlightRegionMode();
            },

            enterArrowMode: function() {
                this.canvas.arrowMode();
            },

            enterTextMode: function() {
                this.canvas.textMode();
            },

            exitTextMode: function() {
                this.canvas.exitEditing();
                this.canvas.disableTextEditing();
            },

            enterPinMode: function() {
                this.canvas.pinMode();
            },

            applyImageFromURL: async function(url) {
                this.applyImageFile(await fetch(url).then(r => r.blob()));
            },

            applyImageFile: function(file) {
                const reader = new FileReader();

                reader.onload = function(image) {
                    this.canvas.addImage(image.target.result);
                }.bind(this);

                reader.onerror = function() {
                    topic.publish(
                        'sos-system-notification',
                        'Error reading file.',
                        'error',
                        3000
                    );
                }.bind(this);

                reader.readAsDataURL(file);
            },

            _clearAll: function() {
                const confirmMessage = 'Are you sure you want to clear all annotations? ' +
                    'This will also clear all annotations for anyone viewing the document.';
                if (confirm(confirmMessage)) {
                    this.clearAllAnnotations();

                    topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_CLEARED, {
                        room: this.roomName
                    });
                }
            },

            _disableDeleteSelectionButton: function() {
                topic.publish(Topics.DOCUMENT_VIEWER_DISABLE_DELETE_SELECTION);
            },

            _enableDeleteSelectionButton: function() {
                topic.publish(Topics.DOCUMENT_VIEWER_ENABLE_DELETE_SELECTION);
            },

            clearAllAnnotations: function() {
                topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATIONS_CHANGED);
                this.pagedAnnotationStack = [];
                this.canvas.clear();

                topic.publish(Topics.DOCUMENT_VIEWER_EXISTING_ANNOTATIONS_ICON_HIDE);
            },

            _drawAnnotationToCanvas: function(annotation, pageNumber) {
                return new Promise(function(resolve, reject) {
                    if (this.pageNumber == pageNumber) {
                        this.canvas.add(annotation, resolve); // @todo - since fabric can draw multiple annotations at once, maybe refactor this so we don't need a promise chain per page??
                    } else {
                        reject();
                    }
                }.bind(this));
            },

            _getAnnotationStackForPage: function(pageNumber) {
                for (let i = 0; i < this.pagedAnnotationStack.length; i++) {
                    if (this.pagedAnnotationStack[i].pageNumber === pageNumber) {
                        return this.pagedAnnotationStack[i].annotations;
                    }
                }

                this.pagedAnnotationStack.push({
                    pageNumber: pageNumber,
                    annotations: []
                });

                return this._getAnnotationStackForPage(pageNumber);
            },

            _isVisibleAnnotation: function(annotation) {
                return !annotation.hasOwnProperty("user") ? true : this.hiddenUsers.indexOf(annotation.user.personPK) < 0;
            },

            _updateAnnotationInStack: function(annotation, pageNumber) {
                const annotationStack = this._getAnnotationStackForPage(pageNumber);
                topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATIONS_CHANGED);

                for (let i = 0; i < annotationStack.length; i++) {
                    if (annotationStack[i].id === annotation.id) {
                        lang.mixin(annotationStack[i], annotation);
                        return annotationStack[i];
                    }
                }

                annotationStack.push(annotation);
                topic.publish(Topics.DOCUMENT_VIEWER_EXISTING_ANNOTATIONS_ICON_SHOW);

                return annotation;
            },

            _getUser: function() {
                return {
                    personPK: dojoConfig.user.getPerson().getPersonPK(),
                    displayName: dojoConfig.user.getPerson().getDisplayName(),
                    username: dojoConfig.user.getUsername(),
                    jobTitle: dojoConfig.user.getPerson().getJobTitle(),
                    avatar: dojoConfig.user.getProfilePictureURL()
                }
            },

            _subscribe: function() {
                this.own(
                    topic.subscribe(Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DELETE_SELECTION, this.canvas.deleteSelection.bind(this.canvas)),
                    topic.subscribe(Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_CLEAR_ALL, this._clearAll.bind(this)),
                    topic.subscribe(Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_CONNECT_ERROR, this._connectionError.bind(this)),
                    topic.subscribe(Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_DISCONNECTED, this._disconnected.bind(this)),
                    topic.subscribe(Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_CONNECTED, this._connected.bind(this)),
                    topic.subscribe(Topics.DOCUMENT_VIEWER_ANNOTATION_PIN_UPDATED, this._modifyPinAnnotation.bind(this)),
                    topic.subscribe(Topics.DOCUMENT_VIEWER_ANNOTATION_PIN_DELETED, this._deletePinAnnotation.bind(this))
                );
            },

            _connectionError: function() {
                domConstruct.destroy(this.noConnectionNode);

                this.connected = false;
                this.noConnectionNode = domConstruct.place(ConnectionErrorTemplate, this.scrollableOverlay);
                this._initialiseNoConnectionMessage();
            },

            _disconnected: function() {
                this.connected = false;
                this.noConnectionNode = domConstruct.place(DisconnectedTemplate, this.scrollableOverlay);
                this._initialiseNoConnectionMessage();
            },

            _initialiseNoConnectionMessage: function() {
                query('button', this.noConnectionNode).on('click', function() {
                    html.set(this, 'Connecting...');
                    domClass.add(this, 'sos-btn-icon sos-icon-refresh sos-icon-animation-spin-smooth-before');
                    topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_CONNECT);
                });

                if (this.showingAnnotations) {
                    this.canvas.clear();
                    domClass.add(this.canvas.container, 'canvas-disabled');
                    domClass.remove(this.noConnectionNode, 'hidden');
                    topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAG_MODE);
                }
            },

            showGeneratingAnnotatedDocumentMessage: function() {
                if (this.generatingAnnotatedDocumentNotificationNode) {
                    return;
                }

                this.generatingAnnotatedDocumentNotificationNode = domConstruct.place(GeneratingAnnotatedDocumentTemplate, this.scrollableOverlay);

                query('button', this.generatingAnnotatedDocumentNotificationNode).on('click', function() {
                    topic.publish(Topics.DOCUMENT_VIEWER_GENERATE_ANNOTATED_DOCUMENT_CANCEL);
                });

                domClass.add(this.canvas.container, 'canvas-disabled');
                topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_CLICK_DRAG_MODE);
            },

            hideGeneratingAnnotatedDocumentMessage: function() {
                domConstruct.destroy(this.generatingAnnotatedDocumentNotificationNode);
                delete this.generatingAnnotatedDocumentNotificationNode;
                domClass.remove(this.canvas.container, 'canvas-disabled');
            },

            showAnnotationsHaveChangedMessage: function() {
                if (this.annotationsHaveChangedNotificationNode) {
                    return;
                }

                this.annotationsHaveChangedNotificationNode = domConstruct.place(AnnotationsHaveChanged, this.scrollableOverlay);

                query('button', this.annotationsHaveChangedNotificationNode).on('click', () => {
                    this.hideAnnotationsHaveChangedMessage();
                });

                domClass.add(this.canvas.container, 'canvas-disabled');
            },

            hideAnnotationsHaveChangedMessage: function() {
                if (!this.annotationsHaveChangedNotificationNode) return;

                domConstruct.destroy(this.annotationsHaveChangedNotificationNode);
                delete this.annotationsHaveChangedNotificationNode;
                domClass.remove(this.canvas.container, 'canvas-disabled');
            },

            _updateExistingAnnotationsIcon: function() {
                for (let i = 0; i < this.pagedAnnotationStack.length; i++) {
                    if (this.pagedAnnotationStack[i].annotations.length > 0) {
                        topic.publish(Topics.DOCUMENT_VIEWER_EXISTING_ANNOTATIONS_ICON_SHOW);
                        return;
                    }
                }

                topic.publish(Topics.DOCUMENT_VIEWER_EXISTING_ANNOTATIONS_ICON_HIDE);
            },

            _connected: function() {
                this.connected = true;

                if (this.roomName) {
                    topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_SET_ID, this.roomName);
                }

                if (this.noConnectionNode) {
                    domConstruct.destroy(this.noConnectionNode);
                    delete this.noConnectionNode;
                    domClass.remove(this.canvas.container, 'canvas-disabled');
                }
            },

            enterSelectMode: function() {
                this.canvas.selectMode();
            },

            exitSelectMode: function() {
                this._disableDeleteSelectionButton();

                this.canvas.disableSelection();
            },

            exitEditing: function() {
                this.canvas.exitEditing();
            },

            deselectActivePin: function() {
                this.canvas.deselectActivePin();
            },

            showUserAnnotations: function (user) {
                for (let i = 0; i < this.hiddenUsers.length; i++) {
                    if (this.hiddenUsers[i] === user) {
                        this.hiddenUsers.splice(i, 1);
                    }
                }

                this._showAllAnnotations();
            },

            hideUserAnnotations: function (user) {
                this.hiddenUsers.push(user);
                this._showAllAnnotations();
            },

            getPins: function() {
                const pins = [];
                this.pagedAnnotationStack.forEach((pageAnnotations) => {
                    pageAnnotations.annotations.forEach((annotation) => {
                        if (annotation.pin) {
                            pins.push(annotation.pin);
                        }
                    });
                });

                return pins.sort((a, b) => a.reference - b.reference);
            },

            _modifyPinAnnotation: function(id) {
                const annotationStack = this._getAnnotationStackForPage(this.pageNumber);
                topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATIONS_CHANGED);

                for (let i = 0; i < annotationStack.length; i++) {
                    if (annotationStack[i].id !== id) {
                        continue;
                    }

                    topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_MODIFIED, {
                        annotation: annotationStack[i],
                        room: this.roomName,
                        pageNumber: this.pageNumber
                    });
                    return;
                }
            },

            _deletePinAnnotation: function(id) {
                const annotationStack = this._getAnnotationStackForPage(this.pageNumber);

                for (let i = 0; i < annotationStack.length; i++) {
                    if (annotationStack[i].id !== id) {
                        continue;
                    }

                    const annotation = annotationStack[i];

                    this.deleteAnnotation({
                        annotationObjectID: annotation.id,
                        pageNumber: this.pageNumber,
                        user: annotation.user
                    });

                    topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_DELETED, {
                        annotationObjectID: annotation.id,
                        room: this.roomName,
                        pageNumber: this.pageNumber,
                        user: annotation.user
                    });

                    return;
                }
            },

            _getFlattenedAnnotationsArray: function() {
                const flattened = [];

                for (let i = 0; i < this.pagedAnnotationStack.length; i++) {
                    let annotationStack = this.pagedAnnotationStack[i].annotations;
                    for (let j = 0; j < annotationStack.length; j++) {
                        flattened.push(annotationStack[j]);
                    }
                }

                return flattened;
            },

            _initialiseCanvas: function() {
                this.canvas = new Canvas(
                    this.annotationCanvas,
                    this.scrollableOverlay,
                    this.workspace,
                    this._getUser(),
                    this.localStorage,
                    this._getFlattenedAnnotationsArray.bind(this)
                );

                domClass.add(this.canvas.container, 'hidden annotation-canvas-container');

                this.documentBodyKeyDownEventHandler = on(
                    document.body,
                    'keydown',
                    this.canvas.keydownHandler.bind(this.canvas)
                );

                this.canvas.on('annotation:selection:created', this._enableDeleteSelectionButton.bind(this));
                this.canvas.on('annotation:selection:cleared', this._disableDeleteSelectionButton.bind(this));

                this.canvas.on('annotation:selection:deleted', function(annotations) {
                    annotations.forEach(function(annotation) {
                        this.deleteAnnotation({
                            annotationObjectID: annotation.id,
                            pageNumber: this.pageNumber,
                            user: annotation.user
                        });

                        topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_DELETED, {
                            annotationObjectID: annotation.id,
                            room: this.roomName,
                            pageNumber: this.pageNumber,
                            user: annotation.user
                        });
                    }.bind(this));

                    this._updateExistingAnnotationsIcon();
                    this._disableDeleteSelectionButton();
                }.bind(this));

                this.canvas.on('annotation:added', function(annotation) {
                    this._updateAnnotationInStack(annotation, this.pageNumber);

                    topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_SEND, {
                        annotation: annotation,
                        room: this.roomName,
                        pageNumber: this.pageNumber
                    });
                }.bind(this));

                this.canvas.on('annotation:pin:added', function(annotation) {
                    annotation.pin = this.pinParser.parse(annotation);
                    this._updateAnnotationInStack(annotation, this.pageNumber);

                    topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_SEND, {
                        annotation: annotation,
                        room: this.roomName,
                        pageNumber: this.pageNumber
                    });

                    topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_PIN_SELECTED, annotation.pin);
                }.bind(this));

                this.canvas.on('annotation:pin:deselected', function() {
                    topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_PIN_DESELECTED);
                });

                this.canvas.on('annotation:pin:selected', function(annotation) {
                    const annotationStack = this._getAnnotationStackForPage(this.pageNumber);

                    for (let i = 0; i < annotationStack.length; i++) {
                        if (annotationStack[i].id === annotation.id) {
                            topic.publish(
                                Topics.DOCUMENT_VIEWER_ANNOTATION_TOOL_PIN_SELECTED,
                                annotationStack[i].pin
                            );
                            return;
                        }
                    }
                }.bind(this));

                this.canvas.on('annotation:modified', function(annotation) {
                    annotation = this._updateAnnotationInStack(annotation, this.pageNumber);

                    topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_MODIFIED, {
                        annotation: annotation,
                        room: this.roomName,
                        pageNumber: this.pageNumber
                    });
                }.bind(this));

                this.canvas.on('annotation:image:error', function() {
                    topic.publish(
                        'sos-system-notification',
                        'Error loading image',
                        'error',
                        3000
                    );
                });
            }
        });

        this.view = new View({}, domConstruct.create('div', {}, node, 'last'));
    };

    AnnotationWorkspace.prototype.hideAnnotation = function() {
        this.view.hideAnnotations();
    };

    AnnotationWorkspace.prototype.applyAnnotationToPage = function(annotation, pageNumber) {
        this.view.applyAnnotationToPage(annotation, pageNumber);
    };

    AnnotationWorkspace.prototype.applyPageCollection = function(data) {
        this.view.applyPageCollection(data);
    };

    AnnotationWorkspace.prototype.modifyAnnotation = function(data) {
        this.view.modifyAnnotation(data);
    };

    AnnotationWorkspace.prototype.deleteAnnotation = function(data) {
        this.view.deleteAnnotation(data);
    };

    AnnotationWorkspace.prototype.clearAllAnnotations = function() {
        this.view.clearAllAnnotations();
    };

    AnnotationWorkspace.prototype.setMd5 = function(md5) {
        this.view.setMd5(md5);
    };

    AnnotationWorkspace.prototype.setAnnotationColor = function(color) {
        this.view.setAnnotationColor(color);
    };

    AnnotationWorkspace.prototype.setAnnotationIsColorFilled = function(isFilled) {
        this.view.setAnnotationIsColorFilled(isFilled);
    };

    AnnotationWorkspace.prototype.setLineStyle = function(lineStyle) {
        this.view.setLineStyle(lineStyle);
    };

    AnnotationWorkspace.prototype.setLineWidth = function(width) {
        this.view.setLineWidth(width);
    };

    AnnotationWorkspace.prototype.showAnnotation = function() {
        this.view.showAnnotation();
    };

    AnnotationWorkspace.prototype.enterDragMode = function() {
        this.view.enterDragMode();
    };

    AnnotationWorkspace.prototype.enterFreehandMode = function() {
        this.view.enterFreehandMode();
    };

    AnnotationWorkspace.prototype.enterHighlightMode = function() {
        this.view.enterHighlightMode();
    };

    AnnotationWorkspace.prototype.enterLineMode = function() {
        this.view.enterLineMode();
    };

    AnnotationWorkspace.prototype.enterTextMode = function() {
        this.view.enterTextMode();
    };

    AnnotationWorkspace.prototype.exitTextMode = function() {
        this.view.exitTextMode();
    };

    AnnotationWorkspace.prototype.enterPinMode = function() {
        this.view.enterPinMode();
    };

    AnnotationWorkspace.prototype.enterSelectMode = function() {
        this.view.enterSelectMode();
    };
    AnnotationWorkspace.prototype.exitSelectMode = function() {
        this.view.exitSelectMode();
    };

    AnnotationWorkspace.prototype.enterEllipseMode = function() {
        this.view.enterEllipseMode();
    };

    AnnotationWorkspace.prototype.enterRectangleMode = function() {
        this.view.enterRectangleMode();
    };

    AnnotationWorkspace.prototype.enterHexagonMode = function() {
        this.view.enterHexagonMode();
    };

    AnnotationWorkspace.prototype.enterPolygonMode = function() {
        this.view.enterPolygonMode();
    };

    AnnotationWorkspace.prototype.cancelPendingPolygon = function() {
        this.view.cancelPendingPolygon();
    };

    AnnotationWorkspace.prototype.enterHighlightRegionMode = function() {
        this.view.enterHighlightRegionMode();
    };

    AnnotationWorkspace.prototype.enterArrowMode = function() {
        this.view.enterArrowMode();
    };

    AnnotationWorkspace.prototype.exitEditing = function() {
        this.view.exitEditing();
    };

    AnnotationWorkspace.prototype.deselectActivePin = function() {
        this.view.deselectActivePin();
    };

    AnnotationWorkspace.prototype.applyImageFile = function(file) {
        this.view.applyImageFile(file);
    };

    AnnotationWorkspace.prototype.applyImageFromURL = function(imageURL) {
        this.view.applyImageFromURL(imageURL);
    };

    AnnotationWorkspace.prototype.getAnnotationsForImage = function(image) {
        return this.view.getAnnotationsForImage(image);
    };

    AnnotationWorkspace.prototype.getAnnotationsForPage = function(pageNum, scale, rotation, height, width) {
        return this.view.getAnnotationsForPage(pageNum, scale, rotation, height, width);
    };

    AnnotationWorkspace.prototype.showGeneratingAnnotatedDocumentMessage = function() {
        return this.view.showGeneratingAnnotatedDocumentMessage();
    };

    AnnotationWorkspace.prototype.showAnnotationsHaveChangedMessage = function() {
        return this.view.showAnnotationsHaveChangedMessage();
    };

    AnnotationWorkspace.prototype.hideAnnotationsHaveChangedMessage = function() {
        return this.view.hideAnnotationsHaveChangedMessage();
    };

    AnnotationWorkspace.prototype.hideGeneratingAnnotatedDocumentMessage = function() {
        return this.view.hideGeneratingAnnotatedDocumentMessage();
    };

    AnnotationWorkspace.prototype.showUserAnnotations = function(user) {
        this.view.showUserAnnotations(user);
    };

    AnnotationWorkspace.prototype.hideUserAnnotations = function(user) {
        this.view.hideUserAnnotations(user);
    };

    AnnotationWorkspace.prototype.updateCanvas = function(pageNum, scale, rotation, height, width) {
        this.view.updateCanvas(pageNum, scale, rotation, height, width);
    };

    AnnotationWorkspace.prototype.getPins = function() {
        return this.view.getPins();
    };

    AnnotationWorkspace.prototype.destroy = function() {
        this.view.destroyRecursive();
    };

    return AnnotationWorkspace;
});
},
'doccontrol/viewer/fabric/Canvas':function(){
define([
    '../config/Pins',
    'library/Lang',
    'spencer/utility/RandomStringGenerator',
    'vendor/fabric/dist/index'
], function(PIN_CONFIG, Lang, StringGenerator, fabric) {
    const DEFAULT_SELECTION_BORDER_COLOR = 'rgba(102, 153, 255, 0.75)';
    const DEFAULT_SELECTION_BORDER_WIDTH = 1;

    const HIGHLIGHT_ALPHA = '80';
    const HEXAGON_SIDES = 6;

    const CLOUD_LINE_CIRCLE_DIAMETER = 15;
    const CLOUD_LINE_ARCH_ANGLE = 140;

    const PROXIMITY_THRESHOLD = 10;

    const DEFAULT_PIN_COLOR = 'black';
    const PIN_SELECTION_COLOR = '#000000';
    const PIN_SELECTION_BORDER_COLOR = PIN_SELECTION_COLOR;
    const PIN_SELECTION_BORDER_WIDTH = 3;

    const EDITABLE_TARGET_PADDING = 5;
    const DBL_CLICK_DURATION_MS = 500;

    const FONT_SIZE = 20;

    const MODES = {
        DRAG: 'drag',
        SELECT: 'select',
        PENCIL: 'pencil',
        HIGHLIGHTER: 'highlighter',
        LINE: 'line',
        CLOUD: 'cloud',
        ARROW: 'arrow',
        RECTANGLE: 'rectangle',
        ELLIPSE: 'ellipse',
        HEXAGON: 'hexagon',
        POLYGON: 'polygon',
        HIGHLIGHT_REGION: 'highlight-region',
        TEXT: 'text',
        PIN: 'pin'
    };

    const SCROLL_MARGIN = 50;

    const EXPORT_FORMAT = 'png';

    const Canvas = function(canvasNode, scrollableOverlay, workspace, user, localStorage, getAnnotationsCallback) {
        this.scrollableOverlay = scrollableOverlay;
        this.workspace = workspace;
        this.user = user;
        this.localStorage = localStorage;
        this.getAnnotationsCallback = getAnnotationsCallback;
        this.canvasNode = canvasNode;

        this.stringGenerator = new StringGenerator();
        this.cloner = new Lang();

        fabric.Path = class extends fabric.Path {
            toObject() {
                let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

                return super.toObject([...propertiesToInclude, 'id', 'user', 'customGroupType']);
            }
        }

        this.canvas = new fabric.Canvas(canvasNode, {
            uniformScaling: false,
            getPointer: function(event) {
                event || (event = fabric.getFabricWindow().event);
                if (event.changedTouches) {
                    event = event.changedTouches[0];
                }

                const canvasRect = this.canvasNode.getBoundingClientRect();
                return new fabric.Point(
                    event.clientX - canvasRect.left,
                    event.clientY - canvasRect.top
                );
            }.bind(this)
        });

        this.container = this.canvas.wrapperEl;

        class HighlighterBrush extends fabric.PencilBrush {
            constructor(canvas, defaultColor) {
                super(canvas);

                this.opacity = 0.2;
                this.color = defaultColor;
                this.lockAxis = {
                    X: false,
                    y: false
                };
            }

            _captureDrawnLine(pointer) {
                const newX = Math.max(pointer.x, 0);
                const newY = Math.max(pointer.y, 0);

                const lastPoint = this._points[0];

                const width = Math.abs(newX - lastPoint.x);
                const height = Math.abs(newY - lastPoint.y);

                if (!this.lockAxis.x && width > 10) {
                    this.lockAxis.y = true;
                }
                if (!this.lockAxis.y && height > 10) {
                    this.lockAxis.x = true;
                }

                return this._addPoint(new fabric.Point(
                    this.lockAxis.x ? lastPoint.x : (height > width ? lastPoint.x : newX),
                    this.lockAxis.y ? lastPoint.y : (width > height ? lastPoint.y : newY)
                ));
            }

            onMouseMove(pointer, options) {
                if (!this.canvas._isMainEvent(options.e)) {
                    return;
                }
                const hasPointBeenAdded = options.e.shiftKey
                    ? this._captureDrawnLine(pointer)
                    : this._addPoint(new fabric.Point(pointer.x, pointer.y));
                if (hasPointBeenAdded && this._points.length > 1) {
                    if (this.needsFullRender()) {
                        // redraw curve
                        // clear top canvas
                        this.canvas.clearContext(this.canvas.contextTop);
                        this._render();

                    } else {
                        var points = this._points, length = points.length, ctx = this.canvas.contextTop;
                        // draw the curve update
                        this._saveAndTransform(ctx);
                        if (this.oldEnd) {
                            ctx.beginPath();
                            ctx.moveTo(this.oldEnd.x, this.oldEnd.y);
                        }
                        this.oldEnd = this.drawSegment(ctx, points[length - 2], points[length - 1], true);
                        ctx.stroke();
                        ctx.restore();
                    }
                }
            }

            onMouseUp(options) {
                if (!this.canvas._isMainEvent(options.e)) {
                    return true;
                }
                this.oldEnd = undefined;
                this._finalizeAndAddPath();

                this.lockAxis = {
                    x: false,
                    y: false
                };

                return false;
            }
        }

        this._fillObject = function(object, color) {
            if (this._isSolidObject(object)) {
                object.set('fill', color);
            }
        };

        this._colorObject = function(object, color) {
            object.set('stroke', color);

            if (object instanceof fabric.Group) {
                object.forEachObject((groupObject) => this._colorObject(groupObject, color));
            } else if (!!object.fill?.length) {
                this._fillObject(object, color)
            }
        };

        this._setObjectLineWidth = function(object, width) {
            object.set('strokeWidth', width * this.scaleFactor);

            if (object.customGroupType === MODES.CLOUD ||
                object instanceof fabric.Group &&
                !object.customGroupType === MODES.ARROW
            ) {
                object.forEachObject((groupObject) => this._setObjectLineWidth(groupObject, width));
            }
        };

        this._setObjectLineStyle = function(object) {
            object.set('strokeDashArray', this._getStrokeDashArray());

            if (object instanceof fabric.Group && !object.customGroupType === MODES.ARROW) {
                object.forEachObject((groupObject) => this._setObjectLineStyle(groupObject));
            }
        };

        this._isSolidObject = function(object) {
            return object instanceof fabric.Ellipse ||
                object instanceof fabric.Polygon ||
                object instanceof fabric.Rect ||
                object instanceof fabric.Line ||
                object instanceof fabric.Triangle ||
                object instanceof fabric.IText;
        };

        this._isColorableObject = function(object) {
            const objectNotSupported = object.customGroupType === MODES.PIN ||
                object instanceof fabric.Image;

            return !objectNotSupported;
        };

        this._isAdjustableObject = function(object) {
            const objectNotSupported = this._isHighlightRegionObject(object) ||
                object.customGroupType === MODES.PIN ||
                object.customGroupType === MODES.ARROW ||
                object instanceof fabric.IText ||
                object instanceof fabric.Image;

            return !objectNotSupported;
        };

        this._isHighlightRegionObject = function(object) {
            return object instanceof fabric.Rect &&
                this._isTransparentObject(object);
        };

        this._isTransparentObject = function(object) {
            if (object.fill) {
                return object.fill.length === 9;
            }

            if (object.stroke) {
                return object.stroke.length === 9;
            }

            return false;
        };

        this._createHighlightColour = function(hex) {
            return hex + HIGHLIGHT_ALPHA;
        };

        this.pencil = new fabric.PencilBrush(this.canvas);
        this.highlighter = new HighlighterBrush(this.canvas, this._createHighlightColour(this.localStorage.get('COLOR')));

        this.lineWidth = this.localStorage.get('LINE_WIDTH');
        this.color = this.localStorage.get('COLOR');
        this.isColorFilled = this.localStorage.get('COLOR_FILLED');
        this.scaleFactor = 1;
        this.rotation = 0;

        this._setCursorGrab = function() {
            this.scrollableOverlay.style.cursor = 'grab';
        };

        this._setCursorGrabbing = function() {
            this.scrollableOverlay.style.cursor = 'grabbing';
        };

        this._setCursorDefault = function() {
            this.scrollableOverlay.style.cursor = 'default';
        };

        this._setCursorCrosshair = function() {
            this.scrollableOverlay.style.cursor = 'crosshair';
        };

        this._setCursorText = function() {
            this.scrollableOverlay.style.cursor = 'text';
        };

        this._setCursorPin = function() {
            this.scrollableOverlay.style.cursor = 'url(:href), crosshair'.replace(':href', PIN_CONFIG.CURSOR);
        };

        this._getLineWidth = function() {
            return this.lineWidth * this.scaleFactor;
        };

        this._getRegularPolygonPoints = function(sides, width, height) {
            const sweep = 2 * Math.PI / sides;
            const points = [];
            for (let i = 0; i < sides; i++){
                points.push({
                    x: width * Math.sin(i * sweep) / 2,
                    y: height * Math.cos(i * sweep) / 2
                });
            }
            return points;
        };

        this._getStrokeDashArray = function() {
            switch (this.lineStyle) {
                case 'dotted':
                    return [this._getLineWidth(), this._getLineWidth()]
                case 'dashed':
                    return [this._getLineWidth() * 2, this._getLineWidth() * 2]
                default:
                    return null;
            }
        };

        this._convert = function(object) {
            const additionalAttributes = ['id', 'user'];

            if (object.customGroupType) {
                additionalAttributes.push('customGroupType');
            }

            if (object.reference) {
                additionalAttributes.push('reference');
            }

            return object.toObject(additionalAttributes);
        };

        this._normalise = function(object) {
            const clone = this.cloner.clone(object);
            this._rotate(clone, this.rotation, 0);
            this._scale(clone, this.scaleFactor, 1);
            return clone;
        };

        this._transform = function(object) {
            const clone = this.cloner.clone(object);
            this._scale(clone, 1, this.scaleFactor);
            this._rotate(clone, 0, this.rotation);
            return clone;
        };

        this._rotate = function(object, fromRotation, toRotation) {
            if (fromRotation != toRotation) {
                const oldLeft = object.left;
                const oldTop = object.top;

                if (object.customGroupType !== MODES.PIN) {
                    object.angle += (toRotation - fromRotation);
                }

                switch (toRotation) {
                    case 90:
                        object.top = oldLeft;
                        object.left = this.canvas.width - oldTop;
                        return object;

                    case 180:
                        object.left = this.canvas.width - object.left;
                        object.top = this.canvas.height - object.top;
                        return object;

                    case 270:
                        object.top = this.canvas.height - oldLeft;
                        object.left = oldTop;
                        return object;
                }

                switch (fromRotation) {
                    case 90:
                        object.left = oldTop;
                        object.top = this.canvas.width - oldLeft;
                        return object;

                    case 180:
                        object.left = this.canvas.width - oldLeft;
                        object.top = this.canvas.height - oldTop;
                        return object;

                    case 270:
                        object.top = oldLeft;
                        object.left = this.canvas.height - oldTop;
                        return object;
                }
            }

            return object;
        };

        this._scale = function(object, fromScale, toScale) {
            const scaleFactor = toScale / fromScale;

            if (object.customGroupType !== MODES.PIN) {
                object.scaleX *= scaleFactor;
                object.scaleY *= scaleFactor;
            }

            object.left *= scaleFactor;
            object.top *= scaleFactor;

            return object;
        };

        this.deselectActivePin = function() {
            if (this.canvas.getActiveObject() && this.canvas.getActiveObject().customGroupType === MODES.PIN) {
                this._deselectPin(this.canvas.getActiveObject());
                this.canvas.discardActiveObject();
                this.canvas.renderAll();
            }
        };

        this.exitEditing = function() {
            if (this.canvas.getActiveObject() && this.canvas.getActiveObject().isEditing) {
                this.canvas.getActiveObject().exitEditing();
            }
        };

        this._calculateCircleRadius = function(chordLength, sectorAngle) {
            return (chordLength / 2) / Math.sin(sectorAngle / 2);
        };

        this._calculateRotationalOffset = function(start, center, radius, angle) {
            const relativeX = start.x - center.x;
            const relativeY = start.y - center.y;

            const currentAngle = Math.atan2(relativeX, relativeY);
            const newAngle = currentAngle + angle;

            const newRelativeX = radius * Math.cos(newAngle);
            const newRelativeY = radius * Math.sin(newAngle);

            const deltaX = newRelativeX - relativeX;
            const deltaY = newRelativeY - relativeY;

            return { x: deltaX, y: deltaY };
        }

        this.drawCloudLine = function(start, end) {
            const minimumDiameter = CLOUD_LINE_CIRCLE_DIAMETER * this.scaleFactor;
            const sectorAngle = (CLOUD_LINE_ARCH_ANGLE * Math.PI) / 180;

            const distance = Math.hypot(end.x - start.x, end.y - start.y);
            const numberOfArcs = Math.floor(distance / minimumDiameter);
            const lengthPerChord = distance / numberOfArcs;
            const radius = this._calculateCircleRadius(lengthPerChord, sectorAngle);

            const deltaX = (end.x - start.x) / numberOfArcs;
            const deltaY = (end.y - start.y) / numberOfArcs;

            const angle = Math.atan2(end.y - start.y, end.x - start.x);
            const angleInDegrees = fabric.util.radiansToDegrees(angle);

            const heightOfArc = radius - radius * Math.cos(sectorAngle / 2);
            const circleCenter = { x: start.x + radius, y: start.y + radius };
            const arcStart = { x: start.x, y: start.y - heightOfArc }
            const rotationalOffset = this._calculateRotationalOffset(arcStart, circleCenter, radius, angle);

            this.pendingCircles.forEach(object => {
                this.canvas.remove(object);
            });
            this.pendingCircles = [];

            for (let i = 0; i < numberOfArcs; i++) {
                const x = start.x - rotationalOffset.x + i * deltaX;
                const y = start.y - rotationalOffset.y + heightOfArc + i * deltaY;

                const angleDifference = (180 - CLOUD_LINE_ARCH_ANGLE) / 2;
                const circle = new fabric.Circle({
                    left: x,
                    top: y,
                    radius: radius,
                    startAngle: angleInDegrees - 180 + angleDifference,
                    endAngle: angleInDegrees - angleDifference,
                    fill: null,
                    strokeWidth: this.isHighlightRegionMode() ? 0 : this._getLineWidth(),
                    stroke: this.isHighlightRegionMode() ? this._createHighlightColour(this.color) : this.color,
                    strokeLineCap: 'round'
                });

                this.pendingCircles.push(circle);
                this.canvas.add(circle);
            }

            this.canvas.renderAll();
        };

        this._scrollCanvas = function(evt) {
            const scrollableOverlayBoundaries = this.scrollableOverlay.getBoundingClientRect();

            // Down
            if (evt.clientY - 10 >= scrollableOverlayBoundaries.top + this.scrollableOverlay.clientHeight - SCROLL_MARGIN) {
                this.scrollableOverlay.scrollTop += 10;
            }

            // Up
            if (evt.clientY <= scrollableOverlayBoundaries.top + SCROLL_MARGIN) {
                this.scrollableOverlay.scrollTop -= 10;
            }

            // Right
            if (evt.clientX >= scrollableOverlayBoundaries.left + this.scrollableOverlay.clientWidth - SCROLL_MARGIN) {
                this.scrollableOverlay.scrollLeft += 10;
            }

            // Left
            if (evt.clientX <= scrollableOverlayBoundaries.left + SCROLL_MARGIN) {
                this.scrollableOverlay.scrollLeft -= 10;
            }
        };

        this._isBeyondLeftBoundary = function(object) {
            return object.left < 0;
        };

        this._isBeyondRightBoundary = function(object) {
            return object.left + object.width > this.canvas.width;
        };

        this._isBeyondTopBoundary = function(object) {
            return object.top < 0;
        };

        this._isBeyondBottomBoundary = function(object) {
            return object.top + object.height > this.canvas.height;
        };

        this._placeInCanvas = function(object) {
            if (this._isBeyondLeftBoundary(object)) {
                object.set('left', 0);
            }
            if (this._isBeyondRightBoundary(object)) {
                object.set('left', this.canvas.width - object.width);
            }
            if (this._isBeyondTopBoundary(object)) {
                object.set('top', 0);
            }
            if (this._isBeyondBottomBoundary(object)) {
                object.set('top', this.canvas.height - object.height);
            }

            object.setCoords();
        };

        this._getPinCount = function() {
            return this.getAnnotationsCallback()
                .filter(function(annotation) { return annotation.customGroupType === MODES.PIN; })
                .map(function(pin) { return parseInt(pin.reference); })
                .reduce(function(a, b) { return Math.max(a, b); }, 0);
        };

        this._selectPin = function(pin) {
            pin.forEachObject(function(component) {
                component.set('fill', PIN_SELECTION_COLOR);
            });
            pin.set({
                borderColor: PIN_SELECTION_BORDER_COLOR,
                borderScaleFactor: PIN_SELECTION_BORDER_WIDTH,
                lockMovementX: true,
                lockMovementY: true
            });

            this.canvas.renderAll();
        };

        this._deselectPin = function(pin) {
            pin.forEachObject(function(component) {
                component.set('fill', DEFAULT_PIN_COLOR);
            });

            pin.set({
                borderColor: DEFAULT_SELECTION_BORDER_COLOR,
                borderScaleFactor: DEFAULT_SELECTION_BORDER_WIDTH,
                lockMovementX: false,
                lockMovementY: false
            });

            this.canvas.fire('annotation:pin:deselected');
        };

        this._bringPinsToFront = function () {
            this.canvas.getObjects()
                .filter(object => object.customGroupType === MODES.PIN)
                .forEach(pin => this.canvas.bringObjectToFront(pin));
        };

        this._finaliseText = function(object) {
            if (object.text === 'Tap and Type' || object.text === '') {
                this.canvas.remove(object);
                return;
            }

            this.canvas.fire('annotation:added', this._normalise(this._convert(object)));
        };

        this._isInProximity = function(pointA, pointB) {
            return Math.sqrt(Math.pow(pointA.x - pointB.x, 2) + Math.pow(pointA.y - pointB.y, 2)) < PROXIMITY_THRESHOLD;
        };

        this._finaliseCloudPolygon = function(startPoint) {
            this.drawCloudLine(startPoint, this.initialPolygonStart);
            this.pendingObject.push(new fabric.Group(this.pendingCircles, {
                id: this.stringGenerator.generate(),
                user: this.user,
                customGroupType: MODES.CLOUD,
                borderColor: DEFAULT_SELECTION_BORDER_COLOR,
                borderScaleFactor: DEFAULT_SELECTION_BORDER_WIDTH,
                subTargetCheck: true,
                interactive: false,
                selectable: false
            }));
            this.pendingCircles.forEach(object => {
                this.canvas.remove(object);
            });
            this.pendingCircles = [];

            this._finalisePolygon();
        };

        this._finalisePolygon = function() {
            const polygon = new fabric.Group(this.pendingObject, {
                id: this.stringGenerator.generate(),
                user: this.user,
                customGroupType: MODES.POLYGON,
                borderColor: DEFAULT_SELECTION_BORDER_COLOR,
                borderScaleFactor: DEFAULT_SELECTION_BORDER_WIDTH,
                subTargetCheck: true,
                interactive: false,
                selectable: false
            });

            this.canvas.add(polygon);

            this.initialPolygonStart = null;;
            this.pendingObject = undefined;
            this.pendingPolygonSide = null;

            this.canvas.fire('annotation:added', this._normalise(this._convert(polygon)));
        };

        this._processDeselectedArray = function(deselected) {
            if (Array.isArray(deselected)
                && deselected.length == 1
                && deselected[0].customGroupType === MODES.PIN
            ) {
                this._deselectPin(deselected[0]);
                this.canvas.renderAll();
            }
        };

        this._isPinDblClick = function(target) {
            return target
                && target.customGroupType === MODES.PIN
                && target == this.canvas.getActiveObject()
                && Date.now() < this.timeOfLastClick + DBL_CLICK_DURATION_MS;
        };

        this._isInActiveSelection = function(object) {
            return this.canvas.getActiveObject()
                && typeof this.canvas.getActiveObject().contains === 'function'
                && this.canvas.getActiveObject().contains(object);
        };

        this._isSelectedPin = function(object) {
            return object
                && object.customGroupType === MODES.PIN
                && object.borderScaleFactor === PIN_SELECTION_BORDER_WIDTH;
        };

        this._reselectPin = function() {
            this.canvas.getObjects().some(function(object) {
                if (object.id === this.previouslySelectedObject.id) {
                    this.canvas.setActiveObject(object);

                    if (this.previouslySelectedObjectIsSelectedPin) {
                        this._selectPin(object);
                        this.canvas.fire('annotation:pin:selected', this._normalise(this._convert(object)));
                    }
                    return true;
                }
            }.bind(this));

            this.previouslySelectedObject = undefined;
            this.previouslySelectedObjectIsSelectedPin = false;
        };

        this._reselectActiveSelection = function() {
            const objects = this.canvas.getObjects();
            const selection = this.previouslySelectedObject.getObjects().map(function(previouslySelectedObject) {
                for (let i = 0; i < objects.length; i++) {
                    if (previouslySelectedObject.id == objects[i].id) {
                        return objects[i];
                    }
                }
            }).filter(Boolean);

            this.canvas.setActiveObject(new fabric.ActiveSelection(selection, {
                canvas: this.canvas
            }));

            this.previouslySelectedObject = undefined;
            this.previouslySelectedObjectIsSelectedPin = false;
        };

        this._reselectSelectedObject = function() {
            this.canvas.getObjects().some(function(object) {
                if (object.id === this.previouslySelectedObject.id) {
                    this.canvas.setActiveObject(object);
                    return true;
                }
            }.bind(this));

            this.previouslySelectedObject = undefined;
            this.previouslySelectedObjectIsSelectedPin = false;
        };

        this.initialPolygonStart = null;

        this.shouldScrollOnMove = false;
        this.pendingObject = undefined;
        this.pendingPolygonSide = null;
        this.pendingCircles = [];
        this.startPoint = {};
        this.endPoint = {};

        this.canvas.on('mouse:down:before', function(o) {
            if (this.isSelectMode() && this._isPinDblClick(o.target)) {
                const selectedPin = o.target;
                this._selectPin(selectedPin);
                this.canvas.setActiveObject(selectedPin);
                this.canvas.fire('annotation:pin:selected', this._normalise(this._convert(selectedPin)));

                return;
            }

            if (this.isTextMode() && o.target instanceof fabric.IText) {
                this.canvas.setActiveObject(o.target);

                return;
            }
        }.bind(this));

        this.canvas.on('mouse:down', function(o) {
            if (this.isdragMode()) this._setCursorGrabbing();

            this.shouldScrollOnMove = !this.isdragMode() && !this.isTextMode() && !this.isPinMode();

            this.timeOfLastClick = Date.now();

            if (this.canvas.isDrawingMode) {
                return;
            }

            const previousStartPoint = this.startPoint;
            this.startPoint = this.canvas.getPointer(o.e);
            const fill = this.isColorFilled ? this.color : '';

            if (this.isLineMode() && this.isCloudLineStyle()) {
                this.pendingObject = true;
                return;
            }

            if (this.isLineMode()) {
                this.pendingObject = new fabric.Line(
                    [
                        this.startPoint.x,
                        this.startPoint.y,
                        this.startPoint.x,
                        this.startPoint.y
                    ],
                    {
                        id: this.stringGenerator.generate(),
                        user: this.user,
                        strokeWidth: this._getLineWidth(),
                        originX: 'center',
                        originY: 'center',
                        selectable: false,
                        borderColor: DEFAULT_SELECTION_BORDER_COLOR,
                        borderScaleFactor: DEFAULT_SELECTION_BORDER_WIDTH,
                        stroke: this.color,
                        strokeDashArray: this._getStrokeDashArray()
                    }
                );
                this.canvas.add(this.pendingObject);
                return;
            }

            if (this.isArrowMode()) {
                const triangle = new fabric.Triangle({
                    width: this._getLineWidth() * 3,
                    height: this._getLineWidth() * 3,
                    fill: this.color,
                    left: 0,
                    top: 0,
                    originX: 'center',
                    originY: 'center',
                    angle: 0,
                    selectable: false
                });

                const line = new fabric.Line(
                    [
                        this.startPoint.x,
                        this.startPoint.y,
                        this.startPoint.x,
                        this.startPoint.y
                    ],
                    {
                        left: 0,
                        top: 0,
                        strokeDashArray: this._getStrokeDashArray(),
                        strokeWidth: this._getLineWidth(),
                        selectable: false,
                        stroke: this.color,
                        originX: 'center',
                        originY: 'center'
                    }
                );

                this.pendingObject = new fabric.Group([line, triangle], {
                    left: this.startPoint.x,
                    top: this.startPoint.y,
                    id: this.stringGenerator.generate(),
                    user: this.user,
                    customGroupType: MODES.ARROW,
                    selectable: false,
                    borderColor: DEFAULT_SELECTION_BORDER_COLOR,
                    borderScaleFactor: DEFAULT_SELECTION_BORDER_WIDTH,
                    subTargetCheck: true,
                    interactive: false
                });

                this.canvas.add(this.pendingObject);
                return;
            }

            if (this.isRectangleMode() || this.isHighlightRegionMode()) {
                this.pendingObject = new fabric.Rect({
                    id: this.stringGenerator.generate(),
                    user: this.user,
                    left: this.startPoint.x,
                    top: this.startPoint.y,
                    originX: 'left',
                    originY: 'top',
                    width: 1,
                    height: 1,
                    angle: 0,
                    fill: this.isHighlightRegionMode() ? this._createHighlightColour(this.color) : fill,
                    strokeWidth: this.isHighlightRegionMode() ? 0 : this._getLineWidth(),
                    stroke: this.isHighlightRegionMode() ? this._createHighlightColour(this.color) : this.color,
                    transparentCorners: false,
                    selectable: false,
                    borderColor: DEFAULT_SELECTION_BORDER_COLOR,
                    borderScaleFactor: DEFAULT_SELECTION_BORDER_WIDTH,
                    strokeDashArray: this.isColorFilled ? null : this._getStrokeDashArray()
                });

                this.canvas.add(this.pendingObject);
                return;
            }

            if (this.isEllipseMode()) {
                this.pendingObject = new fabric.Ellipse({
                    id: this.stringGenerator.generate(),
                    user: this.user,
                    left: this.startPoint.x,
                    top: this.startPoint.y,
                    strokeWidth: this._getLineWidth(),
                    fill: fill,
                    stroke: this.color,
                    selectable: false,
                    borderColor: DEFAULT_SELECTION_BORDER_COLOR,
                    borderScaleFactor: DEFAULT_SELECTION_BORDER_WIDTH,
                    originX: 'left',
                    originY: 'top',
                    rx: 0,
                    ry: 0,
                    strokeDashArray: this.isColorFilled ? null : this._getStrokeDashArray()
                });

                this.canvas.add(this.pendingObject);
                return;
            }

            if (this.isHexagonMode()) {
                const points = this._getRegularPolygonPoints(HEXAGON_SIDES, 0, 0);

                this.pendingObject = new fabric.Polygon(points, {
                    id: this.stringGenerator.generate(),
                    stroke: this.color,
                    user: this.user,
                    left: this.startPoint.x,
                    top: this.startPoint.y,
                    originX: 'left',
                    originY: 'top',
                    fill: fill,
                    strokeWidth: this._getLineWidth(),
                    strokeLineJoin: 'bevil',
                    selectable: false,
                    borderColor: DEFAULT_SELECTION_BORDER_COLOR,
                    borderScaleFactor: DEFAULT_SELECTION_BORDER_WIDTH,
                    strokeDashArray: this.isColorFilled ? null : this._getStrokeDashArray()
                });

                this.canvas.add(this.pendingObject);
                return;
            }

            if (this.isPolygonMode()) {
                if (!this.initialPolygonStart) {
                    this.pendingObject = [];
                    this.initialPolygonStart = this.startPoint;

                    if (this.isCloudLineStyle()) return;
                }

                if (this.pendingObject.length > 1 && this._isInProximity(this.startPoint, this.initialPolygonStart)) {
                    if (this.isCloudLineStyle()) {
                        this._finaliseCloudPolygon(previousStartPoint);
                    } else {
                        this.pendingPolygonSide.set({ x2: this.initialPolygonStart.x, y2: this.initialPolygonStart.y }).setCoords();
                        this._finalisePolygon();
                    }

                    return;
                }

                if (this.isCloudLineStyle()) {
                    const object = new fabric.Group(this.pendingCircles, {
                        id: this.stringGenerator.generate(),
                        user: this.user,
                        customGroupType: MODES.CLOUD,
                        borderColor: DEFAULT_SELECTION_BORDER_COLOR,
                        borderScaleFactor: DEFAULT_SELECTION_BORDER_WIDTH,
                        subTargetCheck: true,
                        interactive: false,
                        selectable: false
                    });

                    this.pendingObject.push(object);
                    this.pendingCircles.forEach(object => {
                        this.canvas.remove(object);
                    });
                    this.pendingCircles = [];

                    this.canvas.add(object);
                    return;
                }

                this.pendingPolygonSide = new fabric.Line(
                    [
                        this.startPoint.x,
                        this.startPoint.y,
                        this.startPoint.x,
                        this.startPoint.y
                    ],
                    {
                        id: this.stringGenerator.generate(),
                        user: this.user,
                        strokeWidth: this._getLineWidth(),
                        originX: 'center',
                        originY: 'center',
                        selectable: false,
                        borderColor: DEFAULT_SELECTION_BORDER_COLOR,
                        borderScaleFactor: DEFAULT_SELECTION_BORDER_WIDTH,
                        stroke: this.color,
                        strokeDashArray: this._getStrokeDashArray()
                    }
                );

                this.canvas.add(this.pendingPolygonSide);
                this.pendingObject.push(this.pendingPolygonSide);

                return;
            }

            if (this.isTextMode()) {
                if (this.canvas.getActiveObject() instanceof fabric.IText) {
                    return;
                }

                this.pendingObject = new fabric.IText('Tap and Type', {
                    id: this.stringGenerator.generate(),
                    user: this.user,
                    left: this.startPoint.x,
                    top: this.startPoint.y - (FONT_SIZE / 2),
                    isEditing: false,
                    editable: true,
                    selectable: false,
                    padding: EDITABLE_TARGET_PADDING,
                    borderColor: DEFAULT_SELECTION_BORDER_COLOR,
                    borderScaleFactor: DEFAULT_SELECTION_BORDER_WIDTH,
                    fontFamily: 'Arial',
                    fill: this.color,
                    fontSize: FONT_SIZE
                });

                this.canvas.add(this.pendingObject);
                this.canvas.setActiveObject(this.pendingObject);
                this.pendingObject.enterEditing();
                this.pendingObject.selectAll();

                return;
            }

            if (this.isPinMode()) {
                if (o.target && o.target.customGroupType === MODES.PIN) {
                    const selectedPin = o.target;
                    this._selectPin(selectedPin);
                    this.canvas.setActiveObject(selectedPin);
                    this.canvas.fire('annotation:pin:selected', this._normalise(this._convert(selectedPin)));

                    return;
                }

                fabric.loadSVGFromURL(PIN_CONFIG.ICON).then(response => {
                    const pin = fabric.util.groupSVGElements(response.objects);
                    pin.set('fill', DEFAULT_PIN_COLOR);

                    // create text
                    const counter = this._getPinCount() + 1;
                    const text = new fabric.Text(counter.toString(), {
                        left: 22,
                        top: 0,
                        fontSize: 15,
                        fontFamily: 'Verdana',
                        fill: DEFAULT_PIN_COLOR
                    });

                    // add image and text to a group
                    const pinGroup = new fabric.Group([pin, text], {
                        left: this.startPoint.x - (response.options.width / 2),
                        top: this.startPoint.y - response.options.height,
                        id: this.stringGenerator.generate(),
                        user: this.user,
                        reference: counter,
                        customGroupType: MODES.PIN,
                        selectable: true,
                        padding: EDITABLE_TARGET_PADDING,
                        borderColor: DEFAULT_SELECTION_BORDER_COLOR,
                        borderScaleFactor: DEFAULT_SELECTION_BORDER_WIDTH,
                        hasControls: false,
                        subTargetCheck: false,
                        interactive: false
                    });

                    this._placeInCanvas(pinGroup);

                    // add the group to canvas
                    this.canvas.add(pinGroup);
                    this.canvas.setActiveObject(pinGroup);
                    this.canvas.fire('annotation:pin:added', this._normalise(this._convert(pinGroup)));

                    this._selectPin(pinGroup);
                });

                return;
            }
        }.bind(this));

        this.canvas.on('mouse:move', function(o) {
            if (this.shouldScrollOnMove) {
                this._scrollCanvas(o.e.changedTouches ?  o.e.changedTouches[0] : o.e);
            }

            if (!this.pendingObject || this.isTextMode() || this.canvas.isDrawingMode || this.isPinMode()) {
                return;
            }

            const pointer = this.canvas.getPointer(o.e);
            this.endPoint = {
                x: Math.max(pointer.x, 0),
                y: Math.max(pointer.y, 0)
            };

            const dX = Math.abs(this.endPoint.x - this.startPoint.x);
            const dY = Math.abs(this.endPoint.y - this.startPoint.y);

            if (this.isLineMode() && this.isCloudLineStyle()) {
                if (o.e.shiftKey) {
                    const adjustedEnd = {
                        x: dY > dX ? this.startPoint.x : this.endPoint.x,
                        y: dX > dY ? this.startPoint.y : this.endPoint.y
                    };
                    this.drawCloudLine(this.startPoint, adjustedEnd);
                } else {
                    this.drawCloudLine(this.startPoint, this.endPoint);
                }
                return;
            }

            if (this.isPolygonMode()) {
                if (this.isCloudLineStyle()) {
                    this.drawCloudLine(this.startPoint, this.endPoint);
                    return;
                }

                this.pendingPolygonSide.set({ x2: this.endPoint.x, y2: this.endPoint.y }).setCoords();
                this.canvas.renderAll();
                return;
            }

            if (this.isLineMode()) {
                if (o.e.shiftKey) {
                    this.pendingObject.set({
                        x2: dY > dX ? this.startPoint.x : this.endPoint.x,
                        y2: dX > dY ? this.startPoint.y : this.endPoint.y
                    }).setCoords();
                } else {
                    this.pendingObject.set({ x2: this.endPoint.x, y2: this.endPoint.y }).setCoords();
                }

                this.canvas.renderAll();
                return;
            }

            if (this.isArrowMode()) {
                if (o.e.shiftKey) {
                    this.pendingObject.forEachObject(function(component) {
                        if (component.type === 'line') {
                            component.set({
                                x2: dY > dX ? this.startPoint.x : this.endPoint.x,
                                y2: dX > dY ? this.startPoint.y : this.endPoint.y,
                                left: 0,
                                top: 0
                            });

                        } else if (component.type === 'triangle') {
                            let angle = 0;
                            if (dX > dY) {
                                if (this.endPoint.x > this.startPoint.x) {
                                    angle = 90;

                                } else {
                                    angle = 270;
                                }
                            }

                            if (dY > dX && this.endPoint.y > this.startPoint.y) {
                                angle = 180;
                            }

                            component.set({
                                left: dY > dX ? 0 : (this.endPoint.x - this.startPoint.x) / 2,
                                top: dX > dY ? 0 : (this.endPoint.y - this.startPoint.y) / 2,
                                angle: angle
                            });
                        }

                        this.pendingObject.remove(component);
                        this.pendingObject.add(component);

                        this.pendingObject.set({
                            left: Math.min(this.startPoint.x, this.endPoint.x),
                            top: Math.min(this.startPoint.y, this.endPoint.y)
                        }).setCoords();
                    }.bind(this));

                } else {
                    this.pendingObject.forEachObject(function(component) {
                        if (component.type === 'line') {
                            component.set({
                                x2: this.endPoint.x,
                                y2: this.endPoint.y,
                                left: 0,
                                top: 0
                            });

                        } else if (component.type === 'triangle') {
                            component.set({
                                left: (this.endPoint.x - this.startPoint.x) / 2,
                                top: (this.endPoint.y - this.startPoint.y) / 2,
                                angle: (Math.atan2(this.endPoint.y - this.startPoint.y, this.endPoint.x - this.startPoint.x) * 180 / Math.PI) + 90
                            });
                        }

                        this.pendingObject.remove(component);
                        this.pendingObject.add(component);

                        this.pendingObject.set({
                            left: Math.min(this.startPoint.x, this.endPoint.x),
                            top: Math.min(this.startPoint.y, this.endPoint.y)
                        }).setCoords();
                    }.bind(this));
                }

                this.canvas.renderAll();
                return;
            }

            const maxMonoAxisDistance = Math.max(dX, dY);

            if (this.isRectangleMode() || this.isHighlightRegionMode()) {
                if (o.e.shiftKey) {
                    this.pendingObject.set({
                        left: this.startPoint.x - (this.endPoint.x > this.startPoint.x ? 0 : maxMonoAxisDistance),
                        top: this.startPoint.y - (this.endPoint.y > this.startPoint.y ? 0 : maxMonoAxisDistance),
                        width: maxMonoAxisDistance,
                        height: maxMonoAxisDistance
                    }).setCoords();
                } else {
                    this.pendingObject.set({
                        left: Math.min(this.endPoint.x, this.startPoint.x),
                        top: Math.min(this.endPoint.y, this.startPoint.y),
                        width: dX,
                        height: dY
                    }).setCoords();
                }

                this.canvas.renderAll();
                return;
            }

            if (this.isEllipseMode()) {
                if (o.e.shiftKey) {
                    this.pendingObject.set({
                        left: this.startPoint.x - (this.endPoint.x > this.startPoint.x ? 0 : maxMonoAxisDistance),
                        top: this.startPoint.y - (this.endPoint.y > this.startPoint.y ? 0 : maxMonoAxisDistance),
                        rx: maxMonoAxisDistance / 2,
                        ry: maxMonoAxisDistance / 2
                    }).setCoords();
                } else {
                    this.pendingObject.set({
                        left: Math.min(this.endPoint.x, this.startPoint.x),
                        top: Math.min(this.endPoint.y, this.startPoint.y),
                        rx: Math.abs(this.startPoint.x - this.endPoint.x) / 2,
                        ry: Math.abs(this.startPoint.y - this.endPoint.y) / 2
                    }).setCoords();
                }

                this.canvas.renderAll();
                return;
            }

            if (this.isHexagonMode()) {
                if (o.e.shiftKey) {
                    this.pendingObject.set({
                        left: this.startPoint.x - (this.endPoint.x > this.startPoint.x ? 0 : maxMonoAxisDistance),
                        top: this.startPoint.y - (this.endPoint.y > this.startPoint.y ? 0 : maxMonoAxisDistance),
                        points: this._getRegularPolygonPoints(HEXAGON_SIDES, maxMonoAxisDistance, maxMonoAxisDistance),
                        width: maxMonoAxisDistance,
                        height: maxMonoAxisDistance
                    }).setCoords();
                } else {
                    this.pendingObject.set({
                        left: Math.min(this.endPoint.x, this.startPoint.x),
                        top: Math.min(this.endPoint.y, this.startPoint.y),
                        points: this._getRegularPolygonPoints(HEXAGON_SIDES, dX, dY),
                        width: dX,
                        height: dY
                    }).setCoords();
                }

                this.canvas.renderAll();
                return;
            }
        }.bind(this));

        this.canvas.on('mouse:up', function(o) {
            if (this.isdragMode()) this._setCursorGrab();

            if (this.isPolygonMode()) {
                return;
            }

            if (this.isLineMode() && this.isCloudLineStyle()) {
                this.pendingObject = new fabric.Group(this.pendingCircles, {
                    id: this.stringGenerator.generate(),
                    user: this.user,
                    customGroupType: MODES.CLOUD,
                    borderColor: DEFAULT_SELECTION_BORDER_COLOR,
                    borderScaleFactor: DEFAULT_SELECTION_BORDER_WIDTH,
                    subTargetCheck: true,
                    interactive: false,
                    selectable: false
                });

                this.canvas.add(this.pendingObject);
                this.pendingCircles.forEach(object => {
                    this.canvas.remove(object);
                });
                this.pendingCircles = [];
            }

            this.shouldScrollOnMove = false;

            if (!this.isTextMode() && this.pendingObject) {
                this.canvas.fire('annotation:added', this._normalise(this._convert(this.pendingObject)));
                this._bringPinsToFront();
                this.pendingObject = undefined;
            }
        }.bind(this));

        this.canvas.on('mouse:dblclick', function(o) {
            if (this.isPolygonMode()) {
                if (this.isCloudLineStyle()) {
                    this._finaliseCloudPolygon(this.startPoint);
                } else {
                    this.pendingObject.push(new fabric.Line(
                        [
                            this.startPoint.x,
                            this.startPoint.y,
                            this.initialPolygonStart.x,
                            this.initialPolygonStart.y
                        ],
                        {
                            id: this.stringGenerator.generate(),
                            user: this.user,
                            strokeWidth: this._getLineWidth(),
                            originX: 'center',
                            originY: 'center',
                            selectable: false,
                            borderColor: DEFAULT_SELECTION_BORDER_COLOR,
                            borderScaleFactor: DEFAULT_SELECTION_BORDER_WIDTH,
                            stroke: this.color,
                            strokeDashArray: this._getStrokeDashArray()
                        }
                    ));
                    this._finalisePolygon();
                }
            }
        }.bind(this));

        this.canvas.on('path:created', function(o) {
            const path = o.path;
            if (this.canvas.isDrawingMode) {
                path.id = this.stringGenerator.generate();
                path.user = this.user;
                path.selectable = false;
            }
            this.canvas.fire('annotation:added', this._normalise(this._convert(path)));
            this._bringPinsToFront();
        }.bind(this));

        this.canvas.on('text:editing:exited', function(o) {
            if (this.pendingObject) {
                this._finaliseText(o.target)
            } else {
                this.canvas.fire('annotation:modified', this._normalise(this._convert(o.target)));
            }

            this.pendingObject = undefined;
            this._bringPinsToFront();
            this.canvas.discardActiveObject();
            this.canvas.renderAll();
        }.bind(this));

        this.canvas.on('object:rotating', function(o) {
            const selection = o.target;
            if (selection._objects) {
                selection.forEachObject(function(obj) {
                    if (obj.customGroupType === MODES.PIN) {
                        selection.remove(obj);
                        obj.set({
                            angle: 0,
                            flipX: 0,
                            flipY: 0,
                            scaleX: 1,
                            scaleY: 1,
                            skewX: 0,
                            skewY: 0
                        });
                        selection.add(obj);
                    }
                });
            }
        });

        this.canvas.on('object:scaling', function(o) {
            const selection = o.target;
            if (selection._objects) {
                selection.forEachObject(function(obj) {
                    if (obj.customGroupType === MODES.PIN) {
                        selection.remove(obj);
                        obj.set({
                            angle: 0,
                            flipX: 0,
                            flipY: 0,
                            scaleX: 1,
                            scaleY: 1,
                            skewX: 0,
                            skewY: 0
                        });
                        selection.add(obj);
                    }
                });
            }
        });

        this.canvas.on('object:skewing', function(o) {
            const selection = o.target;
            if (selection._objects) {
                selection.forEachObject(function(obj) {
                    if (obj.customGroupType === MODES.PIN) {
                        obj.set({
                            skewX: -selection.skewX,
                            skewY: -selection.skewY
                        });
                    }
                });
            }
        });

        this.canvas.on('object:modified', function(o) {
            if (this.isSelectMode() && this.canvas.getActiveObjects()?.length > 1) {
                const selectionObject = this.canvas.getActiveObject();

                this.canvas.getActiveObjects().forEach(object => {
                    if (object.customGroupType === MODES.PIN) {
                        selectionObject.remove(object);
                        this._placeInCanvas(object);
                        selectionObject.add(object);
                    }

                    selectionObject.remove(object);
                    this.canvas.fire('annotation:modified',  this._normalise(this._convert(object)));
                    selectionObject.add(object);
                });
                return;
            }

            if (o.target.customGroupType === MODES.PIN) {
                this._placeInCanvas(o.target);
            }

            this.canvas.fire('annotation:modified', this._normalise(this._convert(o.target)));
        }.bind(this));

        this.canvas.on('selection:created', function(o) {
            if (o.selected.some(function(selected) { return selected.customGroupType !== MODES.PIN; })) {
                this.fire('annotation:selection:created');
            }
        });

        this.canvas.on('selection:updated', function(o) {
            if (this.canvas.getActiveObjects().some(function(selected) { return selected.customGroupType !== MODES.PIN; })) {
                this.canvas.fire('annotation:selection:created');
            } else {
                this.canvas.fire('annotation:selection:cleared');
            }

            this._processDeselectedArray(o.deselected);
            this._bringPinsToFront();
        }.bind(this));

        this.canvas.on('selection:cleared', function(o) {
            this.canvas.fire('annotation:selection:cleared');

            this._processDeselectedArray(o.deselected);
            this._bringPinsToFront();
        }.bind(this));
    };

    Canvas.prototype.dragMode = function() {
        this.mode = MODES.DRAG;

        this.canvas.isDrawingMode = false;
        this.disableSelection();
        this._setCursorGrab();
    };

    Canvas.prototype.isdragMode = function() {
        return this.mode === MODES.DRAG;
    };

    Canvas.prototype.selectMode = function() {
        this.mode = MODES.SELECT;

        this.canvas.isDrawingMode = false;
        this.enableSelection();
        this._setCursorDefault();
    };

    Canvas.prototype.isSelectMode = function() {
        return this.mode === MODES.SELECT;
    };

    Canvas.prototype.pencilMode = function() {
        this.mode = MODES.PENCIL;

        this.canvas.isDrawingMode = true;
        this.canvas.freeDrawingBrush = this.pencil;
        this.canvas.freeDrawingBrush.color = this.color;
        this.canvas.freeDrawingBrush.width = this._getLineWidth();
        this._setCursorCrosshair();
    };

    Canvas.prototype.isPencilMode = function() {
        return this.mode === MODES.PENCIL;
    };

    Canvas.prototype.highlighterMode = function() {
        this.mode = MODES.HIGHLIGHTER;

        this.canvas.isDrawingMode = true;
        this.canvas.freeDrawingBrush = this.highlighter;
        this.canvas.freeDrawingBrush.color = this._createHighlightColour(this.color);
        this.canvas.freeDrawingBrush.width = this._getLineWidth();
        this._setCursorCrosshair();
    };

    Canvas.prototype.isHighlighterMode = function() {
        return this.mode === MODES.HIGHLIGHTER;
    };

    Canvas.prototype.lineMode = function() {
        this.mode = MODES.LINE;

        this.canvas.isDrawingMode = false;
        this._setCursorCrosshair();
    };

    Canvas.prototype.isLineMode = function() {
        return this.mode === MODES.LINE;
    };

    Canvas.prototype.isCloudLineStyle = function() {
        return this.lineStyle === 'cloud';
    };

    Canvas.prototype.arrowMode = function() {
        this.mode = MODES.ARROW;

        this.canvas.isDrawingMode = false;
        this._setCursorCrosshair();
    };

    Canvas.prototype.isArrowMode = function() {
        return this.mode === MODES.ARROW;
    };

    Canvas.prototype.rectangleMode = function() {
        this.mode = MODES.RECTANGLE;

        this.canvas.isDrawingMode = false;
        this._setCursorCrosshair();
    };

    Canvas.prototype.isRectangleMode = function() {
        return this.mode === MODES.RECTANGLE;
    };

    Canvas.prototype.ellipseMode = function() {
        this.mode = MODES.ELLIPSE;

        this.canvas.isDrawingMode = false;
        this._setCursorCrosshair();
    };

    Canvas.prototype.isEllipseMode = function() {
        return this.mode === MODES.ELLIPSE;
    };

    Canvas.prototype.hexagonMode = function() {
        this.mode = MODES.HEXAGON;

        this.canvas.isDrawingMode = false;
        this._setCursorCrosshair();
    };

    Canvas.prototype.isHexagonMode = function() {
        return this.mode === MODES.HEXAGON;
    };

    Canvas.prototype.polygonMode = function() {
        this.mode = MODES.POLYGON;

        this.canvas.isDrawingMode = false;
        this._setCursorCrosshair();
    };

    Canvas.prototype.cancelPendingPolygon = function() {
        if (Array.isArray(this.pendingObject)) {
            this.pendingObject.forEach(object => {
                this.canvas.remove(object);
            });
        }

        if (Array.isArray(this.pendingCircles)) {
            this.pendingCircles.forEach(object => {
                this.canvas.remove(object);
            });
        }

        if (this.pendingPolygonSide) this.canvas.remove(this.pendingPolygonSide);

        this.initialPolygonStart = null;
        this.pendingObject = undefined;
        this.pendingPolygonSide = null;

        this.canvas.renderAll();
    };

    Canvas.prototype.isPolygonMode = function() {
        return this.mode === MODES.POLYGON;
    };

    Canvas.prototype.highlightRegionMode = function() {
        this.mode = MODES.HIGHLIGHT_REGION;

        this.canvas.isDrawingMode = false;
        this._setCursorCrosshair();
    };

    Canvas.prototype.isHighlightRegionMode = function() {
        return this.mode === MODES.HIGHLIGHT_REGION;
    };

    Canvas.prototype.textMode = function() {
        this.mode = MODES.TEXT;

        this.canvas.isDrawingMode = false;
        this.enableTextEditing();
        this._setCursorText();
    };

    Canvas.prototype.isTextMode = function() {
        return this.mode === MODES.TEXT;
    };

    Canvas.prototype.pinMode = function() {
        this.mode = MODES.PIN;

        this.canvas.isDrawingMode = false;
        this._setCursorPin();
    };

    Canvas.prototype.isPinMode = function() {
        return this.mode === MODES.PIN;
    };

    Canvas.prototype.setLineWidth = function(width) {
        this.lineWidth = width;

        if (this.isSelectMode()) {
            this.canvas.getActiveObjects().forEach(object => {
                if (!this._isAdjustableObject(object)) return;

                this._setObjectLineWidth(object, width);
                this.canvas.fire('object:modified', { target: object });
            });

            this.canvas.renderAll();
        }

       if (this.isPolygonMode()) {
           if (Array.isArray(this.pendingObject)) {
               this.pendingObject.forEach(object => {
                   this._setObjectLineWidth(object, width);
               });
           }

           if (Array.isArray(this.pendingCircles)) {
               this.pendingCircles.forEach(object => {
                   this._setObjectLineWidth(object, width);
               });
           }

           this.canvas.renderAll();
       }

        if (this.canvas.freeDrawingBrush) {
            this.canvas.freeDrawingBrush.width = this._getLineWidth();
        }
    };

    Canvas.prototype.setLineStyle = function(lineStyle) {
        if ([this.lineStyle, lineStyle].includes('cloud')) this.cancelPendingPolygon();

        this.lineStyle = lineStyle;

        if (this.isSelectMode()) {
            this.canvas.getActiveObjects().forEach(object => {
                if (!this._isAdjustableObject(object)) return;

                this._setObjectLineStyle(object);
                this.canvas.fire('object:modified', { target: object });
            });

            this.canvas.renderAll();
        }

        if (this.isPolygonMode() && !this.isCloudLineStyle()) {
            if (Array.isArray(this.pendingObject)) {
                this.pendingObject.forEach(object => {
                    this._setObjectLineStyle(object);
                });
            }

            if (Array.isArray(this.pendingCircles)) {
                this.pendingCircles.forEach(object => {
                    this._setObjectLineStyle(object);
                });
            }

            this.canvas.renderAll();
        }
    };

    Canvas.prototype.setColor = function(color) {
        this.color = color;

        if (this.isSelectMode()) {
            this.canvas.getActiveObjects().forEach(object => {
                if (!this._isColorableObject(object)) return;

                this._colorObject(object, this._isTransparentObject(object) ? this._createHighlightColour(color) : color);
                this.canvas.fire('object:modified', { target: object });
            });

            this.canvas.renderAll();
        }

        if (this.isPolygonMode()) {
            if (Array.isArray(this.pendingObject)) {
                this.pendingObject.forEach(object => {
                    this._colorObject(object, color);
                });
            }

            if (Array.isArray(this.pendingCircles)) {
                this.pendingCircles.forEach(object => {
                    this._colorObject(object, color);
                });
            }

            this.canvas.renderAll();
        }

        if (this.canvas.freeDrawingBrush && this.canvas.freeDrawingBrush === this.pencil) {
            this.canvas.freeDrawingBrush.color = color;
        } else if (this.canvas.freeDrawingBrush && this.canvas.freeDrawingBrush === this.highlighter) {
            this.canvas.freeDrawingBrush.color = this._createHighlightColour(this.color);
        }
    };

    Canvas.prototype.setIsColorFilled = function(isFilled) {
        this.isColorFilled = isFilled;

        if (this.isSelectMode()) {
            this.canvas.getActiveObjects().forEach(object => {
                if (!this._isAdjustableObject(object)) return;

                const color = object.stroke;

                if (isFilled) {
                    this._fillObject(object, color);
                } else {
                    object.set('fill', '');
                }

                this.canvas.fire('object:modified', { target: object });
            });

            this.canvas.renderAll();
        }
    };

    Canvas.prototype.addImage = function(url) {
        fabric.util.loadImage(url).then(loadedImage => {
            if (loadedImage == null) {
                this.canvas.fire('annotation:image:error');
                return;
            }

            const image = new fabric.Image(loadedImage);
            if (image.width > this.canvas.width) {
                image.scaleToWidth(0.75 * this.canvas.width);
            }

            if (image.height > this.canvas.height) {
                image.scaleToHeight(0.75 * this.canvas.height);
            }

            const scrollOffset = 20;

            this.canvas.add(image.set({
                id: this.stringGenerator.generate(),
                user: this.user,
                left: this.scrollableOverlay.scrollLeft + scrollOffset,
                top: this.scrollableOverlay.scrollTop + scrollOffset,
                isEditing: false
            }));
            this.canvas.renderAll();

            this.canvas.fire('annotation:added', this._normalise(this._convert(image)));
            this._bringPinsToFront();
        });
    };

    Canvas.prototype.deleteSelection = function() {
        this.canvas.fire(
            'annotation:selection:deleted',
            this.canvas.getActiveObjects()
                .filter(function(annotation) { return annotation.customGroupType !== MODES.PIN; })
                .map(function(object) { return this._convert(object); }.bind(this))
        );

        this.canvas.discardActiveObject();
    };

    Canvas.prototype.clear = function() {
        this.canvas.clear();
    };

    Canvas.prototype.exitEditing = function() {
        this.canvas.exitEditing();
    };

    Canvas.prototype.updateCanvas = function(scale, rotation, height, width) {
        this.previouslySelectedObject = this.canvas.getActiveObject();
        this.previouslySelectedObjectIsSelectedPin = this._isSelectedPin(this.previouslySelectedObject);

        this.exitEditing();

        this.scaleFactor = scale;
        this.rotation = rotation;

        this.canvas.setHeight(height);
        this.canvas.setWidth(width);
        this.canvas.calcOffset();

        if (this.canvas.freeDrawingBrush) {
            this.canvas.freeDrawingBrush.width = this._getLineWidth();
        }
    };

    Canvas.prototype.reselect = function() {
        if (!this.previouslySelectedObject) {
            return;
        }

        if (this.previouslySelectedObject.customGroupType === MODES.PIN) {
            this._reselectPin();
            return;
        }

        if (this.previouslySelectedObject.type === 'activeSelection') {
            this._reselectActiveSelection();
            return;
        }

        this._reselectSelectedObject();
    };

    Canvas.prototype.show = function() {
        this.container.classList.remove('hidden');
    };

    Canvas.prototype.hide = function() {
        this.container.classList.add('hidden');
        this._setCursorDefault();
        this.clear();
    };

    Canvas.prototype.enableSelection = function() {
        this.canvas.discardActiveObject();
        this.canvas.selection = true;
        this.canvas.forEachObject(function(o) {
            o.set({
                selectable: true,
                editable: true
            });
        });
    };

    Canvas.prototype.disableSelection = function() {
        this.canvas.discardActiveObject();
        this.canvas.forEachObject(function(o) {
            o.set({
                selectable: false,
                editable: false
            });
        });
        this.canvas.selection = false;

        this.canvas.renderAll();
    };

    Canvas.prototype.enableTextEditing = function() {
        this.canvas.forEachObject(function(o) {
            if (o instanceof fabric.IText) {
                o.set('editable', true);
            }
        });
    };

    Canvas.prototype.disableTextEditing = function() {
        this.canvas.forEachObject(function(o) {
            if (o instanceof fabric.IText) {
                o.set('editable', false);
            }
        });
    };

    Canvas.prototype.isValidType = function(object) {
        return object.type
            && ['path', 'i-text', 'itext', 'line', 'rect', 'image', 'ellipse', 'polygon', 'group'].indexOf(object.type.toLowerCase()) !== -1;
    };

    Canvas.prototype.keydownHandler = function(e) {
        if (e.key === 'Backspace'
            && e.target.nodeName != 'INPUT' && e.target.nodeName != 'TEXTAREA' && e.target.nodeName != 'SELECT'
        ) {
            e.preventDefault();
        }

        if (e.key === 'Escape') {
            if (this.isPolygonMode()) this.cancelPendingPolygon();
        }

        if (this.isTextMode()
            || !this.canvas.getActiveObject()
            || this.canvas.getActiveObject().isEditing
            || this.canvas.getActiveObject().customGroupType === MODES.PIN
        ) {
            return;
        }

        if (e.key === 'Delete' || e.key === 'Del' || e.key === 'Backspace') {
            this.deleteSelection();
        }
    };

    Canvas.prototype.add = function(annotation, resolveCallback) {// @todo - since enlivenObjects accepts an array.... could this (and corresponding annotationworkspace) be rewritten so a single call will add all annotations on the page?
        fabric.util.enlivenObjects([this._transform(annotation)]).then(objects => {
            if (objects[0].customGroupType === MODES.PIN) {
                objects[0].set({
                    padding: EDITABLE_TARGET_PADDING,
                    hasControls: false
                });
            }

            if (objects[0] instanceof fabric.IText) {
                objects[0].set('padding', EDITABLE_TARGET_PADDING);
            }

            const existingObjects = this.canvas.getObjects();
            for (let i = 0; i < existingObjects.length; i++) {
                if (existingObjects[i].id !== objects[0].id) {
                    continue;
                }

                const objectInActiveSelection = this._isInActiveSelection(existingObjects[i]);
                const objectIsActiveObject = this.canvas.getActiveObject() == existingObjects[i];
                const objectIsSelectedPin = this._isSelectedPin(existingObjects[i]);

                if (objectInActiveSelection) {
                    this.canvas.getActiveObject().remove(existingObjects[i]);
                }

                this.canvas.remove(existingObjects[i]);
                this.canvas.add(objects[0]);

                if (objectInActiveSelection) {
                    this.canvas.getActiveObject().add(objects[0]);
                }

                if (objectIsActiveObject) {
                    this.canvas.setActiveObject(objects[0]);
                }

                if (objectIsActiveObject && objectIsSelectedPin) {
                    this._selectPin(objects[0]);
                    this.canvas.fire('annotation:pin:selected', this._normalise(this._convert(objects[0])));
                }

                this._bringPinsToFront();
                resolveCallback();
                return;
            }

            this.canvas.add(objects[0]);
            this._bringPinsToFront();
            resolveCallback();
        });
    };

    Canvas.prototype.remove = function(id) {
        this.canvas.getObjects().forEach(function(o) {
            if (o.id === id) {
                if (this._isInActiveSelection(o)) {
                    this.canvas.getActiveObject().remove(o);

                    if (this.canvas.getActiveObject()._objects.length === 1
                        && this.canvas.getActiveObject()._objects[0].customGroupType === MODES.PIN
                    ) {
                        this.canvas.setActiveObject(this.canvas.getActiveObject()._objects[0]);
                    }
                }

                this.canvas.remove(o);
                return;
            }
        }.bind(this));
    };

    Canvas.prototype.toDataUrl = function() {
        return this.canvas.toDataURL(EXPORT_FORMAT);
    };

    Canvas.prototype.on = function(event, callback) {
        this.canvas.on(event, callback);
    };

    Canvas.prototype.destroy = function() {
        if (this.canvas) {
            this.canvas.removeListeners();
            this.canvas.dispose();
            this.pencil = null;
            this.highlighter = null;
            this.canvas = null;
        }

        if (this.pendingObject) {
            this.pendingObject = null;
        }
    };

    return Canvas;
});
},
'doccontrol/viewer/config/Pins':function(){
define([], function() {
    const PATH = baseUrl + 'javascript/doccontrol/viewer/image/pin/';

    return {
        CURSOR: PATH + 'cursor.svg',
        ICON: PATH + 'icon.svg'
    };
});
},
'library/Lang':function(){
define([
    'dojo/_base/lang'
], function(dojoLang) {
    const Lang = function() {
        this._objectsHaveDifferentPropertyLengths = function(objectOne, objectTwo) {
            const objectOneProps = Object.getOwnPropertyNames(objectOne);
            const objectTwoProps = Object.getOwnPropertyNames(objectTwo);

            return objectOneProps.length !== objectTwoProps.length;
        };

        this._objectsHaveEqualValues = function(objectOne, objectTwo) {
            const objectOneProps = Object.getOwnPropertyNames(objectOne);

            for (let i = 0; i < objectOneProps.length; i++) {
                const propName = objectOneProps[i];

                if (objectOne[propName] !== objectTwo[propName]) {
                    return false;
                }
            }

            return true;
        };
    };

    Lang.prototype.isEqual = function(objectOne, objectTwo) {
        if (this._objectsHaveDifferentPropertyLengths(objectOne, objectTwo)) {
            return false;
        }

        return this._objectsHaveEqualValues(objectOne, objectTwo);
    };

    Lang.prototype.clone = function(object) {
        return dojoLang.clone(object);
    };

    return Lang;
});
},
'spencer/utility/RandomStringGenerator':function(){
define([], function(){
    const DEFAULT_LENGTH = 9;
    const POSSIBLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    const RandomStringGenerator = function(length) {
        this.length = length || DEFAULT_LENGTH;
    };

    RandomStringGenerator.prototype.generate = function() {
        let r = '';

        for (let i = 0; i < this.length; i++) {
            r += POSSIBLE.charAt(Math.floor(Math.random() * POSSIBLE.length));
        }

        return r;
    };

    return RandomStringGenerator;
});
},
'vendor/fabric/dist/index':function(){
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.fabric = {}));
})(this, (function (exports) { 'use strict';

  function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }
  function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      r && (o = o.filter(function (r) {
        return Object.getOwnPropertyDescriptor(e, r).enumerable;
      })), t.push.apply(t, o);
    }
    return t;
  }
  function _objectSpread2(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = null != arguments[r] ? arguments[r] : {};
      r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
        _defineProperty(e, r, t[r]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
      });
    }
    return e;
  }
  function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o,
      r,
      i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
  }
  function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
      if (e.indexOf(n) >= 0) continue;
      t[n] = r[n];
    }
    return t;
  }
  function _taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(t)
      }
    }));
  }
  function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r || "default");
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }
  function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }

  class BaseConfiguration {
    constructor() {
      /**
       * Browser-specific constant to adjust CanvasRenderingContext2D.shadowBlur value,
       * which is unitless and not rendered equally across browsers.
       *
       * Values that work quite well (as of October 2017) are:
       * - Chrome: 1.5
       * - Edge: 1.75
       * - Firefox: 0.9
       * - Safari: 0.95
       *
       * @since 2.0.0
       * @type Number
       * @default 1
       */
      _defineProperty(this, "browserShadowBlurConstant", 1);
      /**
       * Pixel per Inch as a default value set to 96. Can be changed for more realistic conversion.
       */
      _defineProperty(this, "DPI", 96);
      /**
       * Device Pixel Ratio
       * @see https://developer.apple.com/library/safari/documentation/AudioVideo/Conceptual/HTML-canvas-guide/SettingUptheCanvas/SettingUptheCanvas.html
       */
      _defineProperty(this, "devicePixelRatio", typeof window !== 'undefined' ? window.devicePixelRatio : 1);
      // eslint-disable-line no-restricted-globals
      /**
       * Pixel limit for cache canvases. 1Mpx , 4Mpx should be fine.
       * @since 1.7.14
       * @type Number
       * @default
       */
      _defineProperty(this, "perfLimitSizeTotal", 2097152);
      /**
       * Pixel limit for cache canvases width or height. IE fixes the maximum at 5000
       * @since 1.7.14
       * @type Number
       * @default
       */
      _defineProperty(this, "maxCacheSideLimit", 4096);
      /**
       * Lowest pixel limit for cache canvases, set at 256PX
       * @since 1.7.14
       * @type Number
       * @default
       */
      _defineProperty(this, "minCacheSideLimit", 256);
      /**
       * When 'true', style information is not retained when copy/pasting text, making
       * pasted text use destination style.
       * Defaults to 'false'.
       * @type Boolean
       * @default
       * @deprecated
       */
      _defineProperty(this, "disableStyleCopyPaste", false);
      /**
       * Enable webgl for filtering picture is available
       * A filtering backend will be initialized, this will both take memory and
       * time since a default 2048x2048 canvas will be created for the gl context
       * @since 2.0.0
       * @type Boolean
       * @default
       */
      _defineProperty(this, "enableGLFiltering", true);
      /**
       * if webgl is enabled and available, textureSize will determine the size
       * of the canvas backend
       *
       * In order to support old hardware set to `2048` to avoid OOM
       *
       * @since 2.0.0
       * @type Number
       * @default
       */
      _defineProperty(this, "textureSize", 4096);
      /**
       * Skip performance testing of setupGLContext and force the use of putImageData that seems to be the one that works best on
       * Chrome + old hardware. if your users are experiencing empty images after filtering you may try to force this to true
       * this has to be set before instantiating the filtering backend ( before filtering the first image )
       * @type Boolean
       * @default false
       */
      _defineProperty(this, "forceGLPutImageData", false);
      /**
       * If disabled boundsOfCurveCache is not used. For apps that make heavy usage of pencil drawing probably disabling it is better
       * With the standard behaviour of fabric to translate all curves in absolute commands and by not subtracting the starting point from
       * the curve is very hard to hit any cache.
       * Enable only if you know why it could be useful.
       * Candidate for removal/simplification
       * @default false
       */
      _defineProperty(this, "cachesBoundsOfCurve", false);
      /**
       * Map of font files
       * Map<fontFamily, pathToFile> of font files
       */
      _defineProperty(this, "fontPaths", {});
      /**
       * Defines the number of fraction digits to use when serializing object values.
       * Used in exporting methods (`toObject`, `toJSON`, `toSVG`)
       * You can use it to increase/decrease precision of such values like left, top, scaleX, scaleY, etc.
       */
      _defineProperty(this, "NUM_FRACTION_DIGITS", 4);
    }
  }
  class Configuration extends BaseConfiguration {
    constructor(config) {
      super();
      this.configure(config);
    }
    configure() {
      let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      Object.assign(this, config);
    }

    /**
     * Map<fontFamily, pathToFile> of font files
     */
    addFonts() {
      let paths = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.fontPaths = _objectSpread2(_objectSpread2({}, this.fontPaths), paths);
    }
    removeFonts() {
      let fontFamilys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      fontFamilys.forEach(fontFamily => {
        delete this.fontPaths[fontFamily];
      });
    }
    clearFonts() {
      this.fontPaths = {};
    }
    restoreDefaults(keys) {
      const defaults = new BaseConfiguration();
      const config = (keys === null || keys === void 0 ? void 0 : keys.reduce((acc, key) => {
        acc[key] = defaults[key];
        return acc;
      }, {})) || defaults;
      this.configure(config);
    }
  }
  const config = new Configuration();

  const log = function (severity) {
    for (var _len = arguments.length, optionalParams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      optionalParams[_key - 1] = arguments[_key];
    }
    return (
      // eslint-disable-next-line no-restricted-syntax
      console[severity]('fabric', ...optionalParams)
    );
  };
  class FabricError extends Error {
    constructor(message, options) {
      super("fabric: ".concat(message), options);
    }
  }
  class SignalAbortedError extends FabricError {
    constructor(context) {
      super("".concat(context, " 'options.signal' is in 'aborted' state"));
    }
  }

  class GLProbe {}

  /**
   * Lazy initialize WebGL constants
   */
  class WebGLProbe extends GLProbe {
    /**
     * Tests if webgl supports certain precision
     * @param {WebGL} Canvas WebGL context to test on
     * @param {GLPrecision} Precision to test can be any of following
     * @returns {Boolean} Whether the user's browser WebGL supports given precision.
     */
    testPrecision(gl, precision) {
      const fragmentSource = "precision ".concat(precision, " float;\nvoid main(){}");
      const fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
      if (!fragmentShader) {
        return false;
      }
      gl.shaderSource(fragmentShader, fragmentSource);
      gl.compileShader(fragmentShader);
      return !!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS);
    }

    /**
     * query browser for WebGL
     */
    queryWebGL(canvas) {
      const gl = canvas.getContext('webgl');
      if (gl) {
        this.maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
        this.GLPrecision = ['highp', 'mediump', 'lowp'].find(precision => this.testPrecision(gl, precision));
        gl.getExtension('WEBGL_lose_context').loseContext();
        log('log', "WebGL: max texture size ".concat(this.maxTextureSize));
      }
    }
    isSupported(textureSize) {
      return !!this.maxTextureSize && this.maxTextureSize >= textureSize;
    }
  }

  /* eslint-disable no-restricted-globals */
  const copyPasteData = {};
  const getEnv$1 = () => {
    return {
      document,
      window,
      isTouchSupported: 'ontouchstart' in window || 'ontouchstart' in document || window && window.navigator && window.navigator.maxTouchPoints > 0,
      WebGLProbe: new WebGLProbe(),
      dispose() {
        // noop
      },
      copyPasteData
    };
  };

  /**
   * This file is consumed by fabric.
   * The `./node` and `./browser` files define the env variable that is used by this module.
   * The `./browser` module is defined to be the default env and doesn't set the env at all.
   * This is done in order to support isomorphic usage for browser and node applications
   * since window and document aren't defined at time of import in SSR, we can't set env so we avoid it by deferring to the default env.
   */

  let env;

  /**
   * Sets the environment variables used by fabric.\
   * This is exposed for special cases, such as configuring a test environment, and should be used with care.
   *
   * **CAUTION**: Must be called before using the package.
   *
   * @example
   * <caption>Passing `window` and `document` objects to fabric (in case they are mocked or something)</caption>
   * import { getEnv, setEnv } from 'fabric';
   * // we want fabric to use the `window` and `document` objects exposed by the environment we are running in.
   * setEnv({ ...getEnv(), window, document });
   * // done with setup, using fabric is now safe
   */
  const setEnv = value => {
    env = value;
  };

  /**
   * In order to support SSR we **MUST** access the browser env only after the window has loaded
   */
  const getEnv = () => env || (env = getEnv$1());
  const getFabricDocument = () => getEnv().document;
  const getFabricWindow = () => getEnv().window;

  /**
   * @returns the config value if defined, fallbacks to the environment value
   */
  const getDevicePixelRatio = () => {
    var _config$devicePixelRa;
    return Math.max((_config$devicePixelRa = config.devicePixelRatio) !== null && _config$devicePixelRa !== void 0 ? _config$devicePixelRa : getFabricWindow().devicePixelRatio, 1);
  };

  class Cache {
    constructor() {
      /**
       * Cache of widths of chars in text rendering.
       */
      _defineProperty(this, "charWidthsCache", {});
      /**
       * This object keeps the results of the boundsOfCurve calculation mapped by the joined arguments necessary to calculate it.
       * It does speed up calculation, if you parse and add always the same paths, but in case of heavy usage of freedrawing
       * you do not get any speed benefit and you get a big object in memory.
       * The object was a private variable before, while now is appended to the lib so that you have access to it and you
       * can eventually clear it.
       * It was an internal variable, is accessible since version 2.3.4
       */
      _defineProperty(this, "boundsOfCurveCache", {});
    }
    /**
     * @return {Object} reference to cache
     */
    getFontCache(_ref) {
      let {
        fontFamily,
        fontStyle,
        fontWeight
      } = _ref;
      fontFamily = fontFamily.toLowerCase();
      if (!this.charWidthsCache[fontFamily]) {
        this.charWidthsCache[fontFamily] = {};
      }
      const fontCache = this.charWidthsCache[fontFamily];
      const cacheKey = "".concat(fontStyle.toLowerCase(), "_").concat((fontWeight + '').toLowerCase());
      if (!fontCache[cacheKey]) {
        fontCache[cacheKey] = {};
      }
      return fontCache[cacheKey];
    }

    /**
     * Clear char widths cache for the given font family or all the cache if no
     * fontFamily is specified.
     * Use it if you know you are loading fonts in a lazy way and you are not waiting
     * for custom fonts to load properly when adding text objects to the canvas.
     * If a text object is added when its own font is not loaded yet, you will get wrong
     * measurement and so wrong bounding boxes.
     * After the font cache is cleared, either change the textObject text content or call
     * initDimensions() to trigger a recalculation
     * @param {String} [fontFamily] font family to clear
     */
    clearFontCache(fontFamily) {
      fontFamily = (fontFamily || '').toLowerCase();
      if (!fontFamily) {
        this.charWidthsCache = {};
      } else if (this.charWidthsCache[fontFamily]) {
        delete this.charWidthsCache[fontFamily];
      }
    }

    /**
     * Given current aspect ratio, determines the max width and height that can
     * respect the total allowed area for the cache.
     * @param {number} ar aspect ratio
     * @return {number[]} Limited dimensions X and Y
     */
    limitDimsByArea(ar) {
      const {
        perfLimitSizeTotal
      } = config;
      const roughWidth = Math.sqrt(perfLimitSizeTotal * ar);
      // we are not returning a point on purpose, to avoid circular dependencies
      // this is an internal utility
      return [Math.floor(roughWidth), Math.floor(perfLimitSizeTotal / roughWidth)];
    }
  }
  const cache = new Cache();

  var version = "6.7.0";

  // use this syntax so babel plugin see this import here
  const VERSION = version;
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  function noop() {}
  const halfPI = Math.PI / 2;
  const twoMathPi = Math.PI * 2;
  const PiBy180 = Math.PI / 180;
  const iMatrix = Object.freeze([1, 0, 0, 1, 0, 0]);
  const DEFAULT_SVG_FONT_SIZE = 16;
  const ALIASING_LIMIT = 2;

  /* "magic number" for bezier approximations of arcs (http://itc.ktu.lt/itc354/Riskus354.pdf) */
  const kRect = 1 - 0.5522847498;
  const CENTER = 'center';
  const LEFT = 'left';
  const TOP = 'top';
  const BOTTOM = 'bottom';
  const RIGHT = 'right';
  const NONE = 'none';
  const reNewline = /\r?\n/;
  const MOVING = 'moving';
  const SCALING = 'scaling';
  const ROTATING = 'rotating';
  const ROTATE = 'rotate';
  const SKEWING = 'skewing';
  const RESIZING = 'resizing';
  const MODIFY_POLY = 'modifyPoly';
  const MODIFY_PATH = 'modifyPath';
  const CHANGED = 'changed';
  const SCALE = 'scale';
  const SCALE_X = 'scaleX';
  const SCALE_Y = 'scaleY';
  const SKEW_X = 'skewX';
  const SKEW_Y = 'skewY';
  const FILL = 'fill';
  const STROKE = 'stroke';
  const MODIFIED = 'modified';

  /*
   * This Map connects the objects type value with their
   * class implementation. It used from any object to understand which are
   * the classes to enlive when requesting a object.type = 'path' for example.
   * Objects uses it for clipPath, Canvas uses it for everything.
   * This is necessary for generic code to run and enlive instances from serialized representation.
   * You can customize which classes get enlived from SVG parsing using this classRegistry.
   * The Registry start empty and gets filled in depending which files you import.
   * If you want to be able to parse arbitrary SVGs or JSON representation of canvases, coming from
   * different sources you will need to import all fabric because you may need all classes.
   */

  const JSON$1 = 'json';
  const SVG = 'svg';
  class ClassRegistry {
    constructor() {
      this[JSON$1] = new Map();
      this[SVG] = new Map();
    }
    has(classType) {
      return this[JSON$1].has(classType);
    }
    getClass(classType) {
      const constructor = this[JSON$1].get(classType);
      if (!constructor) {
        throw new FabricError("No class registered for ".concat(classType));
      }
      return constructor;
    }
    setClass(classConstructor, classType) {
      if (classType) {
        this[JSON$1].set(classType, classConstructor);
      } else {
        this[JSON$1].set(classConstructor.type, classConstructor);
        // legacy
        // @TODO: needs to be removed in fabric 7 or 8
        this[JSON$1].set(classConstructor.type.toLowerCase(), classConstructor);
      }
    }
    getSVGClass(SVGTagName) {
      return this[SVG].get(SVGTagName);
    }
    setSVGClass(classConstructor, SVGTagName) {
      this[SVG].set(SVGTagName !== null && SVGTagName !== void 0 ? SVGTagName : classConstructor.type.toLowerCase(), classConstructor);
    }
  }
  const classRegistry = new ClassRegistry();

  /**
   * Array holding all running animations
   */
  class AnimationRegistry extends Array {
    /**
     * Remove a single animation using an animation context
     * @param {AnimationBase} context
     */
    remove(context) {
      const index = this.indexOf(context);
      index > -1 && this.splice(index, 1);
    }

    /**
     * Cancel all running animations on the next frame
     */
    cancelAll() {
      const animations = this.splice(0);
      animations.forEach(animation => animation.abort());
      return animations;
    }

    /**
     * Cancel all running animations attached to a canvas on the next frame
     * @param {StaticCanvas} canvas
     */
    cancelByCanvas(canvas) {
      if (!canvas) {
        return [];
      }
      const animations = this.filter(animation => {
        var _animation$target;
        return animation.target === canvas || typeof animation.target === 'object' && ((_animation$target = animation.target) === null || _animation$target === void 0 ? void 0 : _animation$target.canvas) === canvas;
      });
      animations.forEach(animation => animation.abort());
      return animations;
    }

    /**
     * Cancel all running animations for target on the next frame
     * @param target
     */
    cancelByTarget(target) {
      if (!target) {
        return [];
      }
      const animations = this.filter(animation => animation.target === target);
      animations.forEach(animation => animation.abort());
      return animations;
    }
  }
  const runningAnimations = new AnimationRegistry();

  /**
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#events}
   * @see {@link http://fabricjs.com/events|Events demo}
   */
  class Observable {
    constructor() {
      _defineProperty(this, "__eventListeners", {});
    }
    /**
     * Observes specified event
     * @alias on
     * @param {string} eventName Event name (eg. 'after:render')
     * @param {EventRegistryObject} handlers key/value pairs (eg. {'after:render': handler, 'selection:cleared': handler})
     * @param {Function} handler Function that receives a notification when an event of the specified type occurs
     * @return {Function} disposer
     */
    on(arg0, handler) {
      if (!this.__eventListeners) {
        this.__eventListeners = {};
      }
      if (typeof arg0 === 'object') {
        // one object with key/value pairs was passed
        Object.entries(arg0).forEach(_ref => {
          let [eventName, handler] = _ref;
          this.on(eventName, handler);
        });
        return () => this.off(arg0);
      } else if (handler) {
        const eventName = arg0;
        if (!this.__eventListeners[eventName]) {
          this.__eventListeners[eventName] = [];
        }
        this.__eventListeners[eventName].push(handler);
        return () => this.off(eventName, handler);
      } else {
        // noop
        return () => false;
      }
    }

    /**
     * Observes specified event **once**
     * @alias once
     * @param {string} eventName Event name (eg. 'after:render')
     * @param {EventRegistryObject} handlers key/value pairs (eg. {'after:render': handler, 'selection:cleared': handler})
     * @param {Function} handler Function that receives a notification when an event of the specified type occurs
     * @return {Function} disposer
     */

    once(arg0, handler) {
      if (typeof arg0 === 'object') {
        // one object with key/value pairs was passed
        const disposers = [];
        Object.entries(arg0).forEach(_ref2 => {
          let [eventName, handler] = _ref2;
          disposers.push(this.once(eventName, handler));
        });
        return () => disposers.forEach(d => d());
      } else if (handler) {
        const disposer = this.on(arg0, function onceHandler() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          handler.call(this, ...args);
          disposer();
        });
        return disposer;
      } else {
        // noop
        return () => false;
      }
    }

    /**
     * @private
     * @param {string} eventName
     * @param {Function} [handler]
     */
    _removeEventListener(eventName, handler) {
      if (!this.__eventListeners[eventName]) {
        return;
      }
      if (handler) {
        const eventListener = this.__eventListeners[eventName];
        const index = eventListener.indexOf(handler);
        index > -1 && eventListener.splice(index, 1);
      } else {
        this.__eventListeners[eventName] = [];
      }
    }

    /**
     * Unsubscribe all event listeners for eventname.
     * Do not use this pattern. You could kill internal fabricJS events.
     * We know we should have protected events for internal flows, but we don't have yet
     * @deprecated
     * @param {string} eventName event name (eg. 'after:render')
     */

    /**
     * unsubscribe an event listener
     * @param {string} eventName event name (eg. 'after:render')
     * @param {TEventCallback} handler event listener to unsubscribe
     */

    /**
     * unsubscribe event listeners
     * @param handlers handlers key/value pairs (eg. {'after:render': handler, 'selection:cleared': handler})
     */

    /**
     * unsubscribe all event listeners
     */

    off(arg0, handler) {
      if (!this.__eventListeners) {
        return;
      }

      // remove all key/value pairs (event name -> event handler)
      if (typeof arg0 === 'undefined') {
        for (const eventName in this.__eventListeners) {
          this._removeEventListener(eventName);
        }
      }
      // one object with key/value pairs was passed
      else if (typeof arg0 === 'object') {
        Object.entries(arg0).forEach(_ref3 => {
          let [eventName, handler] = _ref3;
          this._removeEventListener(eventName, handler);
        });
      } else {
        this._removeEventListener(arg0, handler);
      }
    }

    /**
     * Fires event with an optional options object
     * @param {String} eventName Event name to fire
     * @param {Object} [options] Options object
     */
    fire(eventName, options) {
      var _this$__eventListener;
      if (!this.__eventListeners) {
        return;
      }
      const listenersForEvent = (_this$__eventListener = this.__eventListeners[eventName]) === null || _this$__eventListener === void 0 ? void 0 : _this$__eventListener.concat();
      if (listenersForEvent) {
        for (let i = 0; i < listenersForEvent.length; i++) {
          listenersForEvent[i].call(this, options || {});
        }
      }
    }
  }

  /**
   * Removes value from an array.
   * Presence of value (and its position in an array) is determined via `Array.prototype.indexOf`
   * @param {Array} array
   * @param {*} value
   * @return {Array} original array
   */
  const removeFromArray = (array, value) => {
    const idx = array.indexOf(value);
    if (idx !== -1) {
      array.splice(idx, 1);
    }
    return array;
  };

  /**
   * Calculate the cos of an angle, avoiding returning floats for known results
   * This function is here just to avoid getting 0.999999999999999 when dealing
   * with numbers that are really 1 or 0.
   * @param {TRadian} angle the angle
   * @return {Number} the cosin value for angle.
   */
  const cos = angle => {
    if (angle === 0) {
      return 1;
    }
    const angleSlice = Math.abs(angle) / halfPI;
    switch (angleSlice) {
      case 1:
      case 3:
        return 0;
      case 2:
        return -1;
    }
    return Math.cos(angle);
  };

  /**
   * Calculate the cos of an angle, avoiding returning floats for known results
   * This function is here just to avoid getting 0.999999999999999 when dealing
   * with numbers that are really 1 or 0.
   * @param {TRadian} angle the angle
   * @return {Number} the sin value for angle.
   */
  const sin = angle => {
    if (angle === 0) {
      return 0;
    }
    const angleSlice = angle / halfPI;
    const value = Math.sign(angle);
    switch (angleSlice) {
      case 1:
        return value;
      case 2:
        return 0;
      case 3:
        return -value;
    }
    return Math.sin(angle);
  };

  /**
   * Adaptation of work of Kevin Lindsey(kevin@kevlindev.com)
   */
  class Point {
    constructor() {
      let arg0 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      let y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (typeof arg0 === 'object') {
        this.x = arg0.x;
        this.y = arg0.y;
      } else {
        this.x = arg0;
        this.y = y;
      }
    }

    /**
     * Adds another point to this one and returns another one
     * @param {XY} that
     * @return {Point} new Point instance with added values
     */
    add(that) {
      return new Point(this.x + that.x, this.y + that.y);
    }

    /**
     * Adds another point to this one
     * @param {XY} that
     * @return {Point} thisArg
     * @chainable
     * @deprecated
     */
    addEquals(that) {
      this.x += that.x;
      this.y += that.y;
      return this;
    }

    /**
     * Adds value to this point and returns a new one
     * @param {Number} scalar
     * @return {Point} new Point with added value
     */
    scalarAdd(scalar) {
      return new Point(this.x + scalar, this.y + scalar);
    }

    /**
     * Adds value to this point
     * @param {Number} scalar
     * @return {Point} thisArg
     * @chainable
     * @deprecated
     */
    scalarAddEquals(scalar) {
      this.x += scalar;
      this.y += scalar;
      return this;
    }

    /**
     * Subtracts another point from this point and returns a new one
     * @param {XY} that
     * @return {Point} new Point object with subtracted values
     */
    subtract(that) {
      return new Point(this.x - that.x, this.y - that.y);
    }

    /**
     * Subtracts another point from this point
     * @param {XY} that
     * @return {Point} thisArg
     * @chainable
     * @deprecated
     */
    subtractEquals(that) {
      this.x -= that.x;
      this.y -= that.y;
      return this;
    }

    /**
     * Subtracts value from this point and returns a new one
     * @param {Number} scalar
     * @return {Point}
     */
    scalarSubtract(scalar) {
      return new Point(this.x - scalar, this.y - scalar);
    }

    /**
     * Subtracts value from this point
     * @param {Number} scalar
     * @return {Point} thisArg
     * @chainable
     * @deprecated
     */
    scalarSubtractEquals(scalar) {
      this.x -= scalar;
      this.y -= scalar;
      return this;
    }

    /**
     * Multiplies this point by another value and returns a new one
     * @param {XY} that
     * @return {Point}
     */
    multiply(that) {
      return new Point(this.x * that.x, this.y * that.y);
    }

    /**
     * Multiplies this point by a value and returns a new one
     * @param {Number} scalar
     * @return {Point}
     */
    scalarMultiply(scalar) {
      return new Point(this.x * scalar, this.y * scalar);
    }

    /**
     * Multiplies this point by a value
     * @param {Number} scalar
     * @return {Point} thisArg
     * @chainable
     * @deprecated
     */
    scalarMultiplyEquals(scalar) {
      this.x *= scalar;
      this.y *= scalar;
      return this;
    }

    /**
     * Divides this point by another and returns a new one
     * @param {XY} that
     * @return {Point}
     */
    divide(that) {
      return new Point(this.x / that.x, this.y / that.y);
    }

    /**
     * Divides this point by a value and returns a new one
     * @param {Number} scalar
     * @return {Point}
     */
    scalarDivide(scalar) {
      return new Point(this.x / scalar, this.y / scalar);
    }

    /**
     * Divides this point by a value
     * @param {Number} scalar
     * @return {Point} thisArg
     * @chainable
     * @deprecated
     */
    scalarDivideEquals(scalar) {
      this.x /= scalar;
      this.y /= scalar;
      return this;
    }

    /**
     * Returns true if this point is equal to another one
     * @param {XY} that
     * @return {Boolean}
     */
    eq(that) {
      return this.x === that.x && this.y === that.y;
    }

    /**
     * Returns true if this point is less than another one
     * @param {XY} that
     * @return {Boolean}
     */
    lt(that) {
      return this.x < that.x && this.y < that.y;
    }

    /**
     * Returns true if this point is less than or equal to another one
     * @param {XY} that
     * @return {Boolean}
     */
    lte(that) {
      return this.x <= that.x && this.y <= that.y;
    }

    /**
      * Returns true if this point is greater another one
     * @param {XY} that
     * @return {Boolean}
     */
    gt(that) {
      return this.x > that.x && this.y > that.y;
    }

    /**
     * Returns true if this point is greater than or equal to another one
     * @param {XY} that
     * @return {Boolean}
     */
    gte(that) {
      return this.x >= that.x && this.y >= that.y;
    }

    /**
     * Returns new point which is the result of linear interpolation with this one and another one
     * @param {XY} that
     * @param {Number} t , position of interpolation, between 0 and 1 default 0.5
     * @return {Point}
     */
    lerp(that) {
      let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.5;
      t = Math.max(Math.min(1, t), 0);
      return new Point(this.x + (that.x - this.x) * t, this.y + (that.y - this.y) * t);
    }

    /**
     * Returns distance from this point and another one
     * @param {XY} that
     * @return {Number}
     */
    distanceFrom(that) {
      const dx = this.x - that.x,
        dy = this.y - that.y;
      return Math.sqrt(dx * dx + dy * dy);
    }

    /**
     * Returns the point between this point and another one
     * @param {XY} that
     * @return {Point}
     */
    midPointFrom(that) {
      return this.lerp(that);
    }

    /**
     * Returns a new point which is the min of this and another one
     * @param {XY} that
     * @return {Point}
     */
    min(that) {
      return new Point(Math.min(this.x, that.x), Math.min(this.y, that.y));
    }

    /**
     * Returns a new point which is the max of this and another one
     * @param {XY} that
     * @return {Point}
     */
    max(that) {
      return new Point(Math.max(this.x, that.x), Math.max(this.y, that.y));
    }

    /**
     * Returns string representation of this point
     * @return {String}
     */
    toString() {
      return "".concat(this.x, ",").concat(this.y);
    }

    /**
     * Sets x/y of this point
     * @param {Number} x
     * @param {Number} y
     * @chainable
     */
    setXY(x, y) {
      this.x = x;
      this.y = y;
      return this;
    }

    /**
     * Sets x of this point
     * @param {Number} x
     * @chainable
     */
    setX(x) {
      this.x = x;
      return this;
    }

    /**
     * Sets y of this point
     * @param {Number} y
     * @chainable
     */
    setY(y) {
      this.y = y;
      return this;
    }

    /**
     * Sets x/y of this point from another point
     * @param {XY} that
     * @chainable
     */
    setFromPoint(that) {
      this.x = that.x;
      this.y = that.y;
      return this;
    }

    /**
     * Swaps x/y of this point and another point
     * @param {XY} that
     */
    swap(that) {
      const x = this.x,
        y = this.y;
      this.x = that.x;
      this.y = that.y;
      that.x = x;
      that.y = y;
    }

    /**
     * return a cloned instance of the point
     * @return {Point}
     */
    clone() {
      return new Point(this.x, this.y);
    }

    /**
     * Rotates `point` around `origin` with `radians`
     * @static
     * @memberOf fabric.util
     * @param {XY} origin The origin of the rotation
     * @param {TRadian} radians The radians of the angle for the rotation
     * @return {Point} The new rotated point
     */
    rotate(radians) {
      let origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ZERO;
      // TODO benchmark and verify the add and subtract how much cost
      // and then in case early return if no origin is passed
      const sinus = sin(radians),
        cosinus = cos(radians);
      const p = this.subtract(origin);
      const rotated = new Point(p.x * cosinus - p.y * sinus, p.x * sinus + p.y * cosinus);
      return rotated.add(origin);
    }

    /**
     * Apply transform t to point p
     * @static
     * @memberOf fabric.util
     * @param  {TMat2D} t The transform
     * @param  {Boolean} [ignoreOffset] Indicates that the offset should not be applied
     * @return {Point} The transformed point
     */
    transform(t) {
      let ignoreOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return new Point(t[0] * this.x + t[2] * this.y + (ignoreOffset ? 0 : t[4]), t[1] * this.x + t[3] * this.y + (ignoreOffset ? 0 : t[5]));
    }
  }
  const ZERO = new Point(0, 0);

  const isCollection = fabricObject => {
    return !!fabricObject && Array.isArray(fabricObject._objects);
  };
  function createCollectionMixin(Base) {
    class Collection extends Base {
      constructor() {
        super(...arguments);
        /**
         * @type {FabricObject[]}
         * @TODO needs to end up in the constructor too
         */
        _defineProperty(this, "_objects", []);
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      _onObjectAdded(object) {
        // subclasses should override this method
      }

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      _onObjectRemoved(object) {
        // subclasses should override this method
      }

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      _onStackOrderChanged(object) {
        // subclasses should override this method
      }

      /**
       * Adds objects to collection
       * Objects should be instances of (or inherit from) FabricObject
       * @param {...FabricObject[]} objects to add
       * @returns {number} new array length
       */
      add() {
        for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
          objects[_key] = arguments[_key];
        }
        const size = this._objects.push(...objects);
        objects.forEach(object => this._onObjectAdded(object));
        return size;
      }

      /**
       * Inserts an object into collection at specified index
       * @param {number} index Index to insert object at
       * @param {...FabricObject[]} objects Object(s) to insert
       * @returns {number} new array length
       */
      insertAt(index) {
        for (var _len2 = arguments.length, objects = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          objects[_key2 - 1] = arguments[_key2];
        }
        this._objects.splice(index, 0, ...objects);
        objects.forEach(object => this._onObjectAdded(object));
        return this._objects.length;
      }

      /**
       * Removes objects from a collection, then renders canvas (if `renderOnAddRemove` is not `false`)
       * @private
       * @param {...FabricObject[]} objects objects to remove
       * @returns {FabricObject[]} removed objects
       */
      remove() {
        const array = this._objects,
          removed = [];
        for (var _len3 = arguments.length, objects = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          objects[_key3] = arguments[_key3];
        }
        objects.forEach(object => {
          const index = array.indexOf(object);
          // only call onObjectRemoved if an object was actually removed
          if (index !== -1) {
            array.splice(index, 1);
            removed.push(object);
            this._onObjectRemoved(object);
          }
        });
        return removed;
      }

      /**
       * Executes given function for each object in this group
       * A simple shortcut for getObjects().forEach, before es6 was more complicated,
       * now is just a shortcut.
       * @param {Function} callback
       *                   Callback invoked with current object as first argument,
       *                   index - as second and an array of all objects - as third.
       */
      forEachObject(callback) {
        this.getObjects().forEach((object, index, objects) => callback(object, index, objects));
      }

      /**
       * Returns an array of children objects of this instance
       * @param {...String} [types] When specified, only objects of these types are returned
       * @return {Array}
       */
      getObjects() {
        for (var _len4 = arguments.length, types = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          types[_key4] = arguments[_key4];
        }
        if (types.length === 0) {
          return [...this._objects];
        }
        return this._objects.filter(o => o.isType(...types));
      }

      /**
       * Returns object at specified index
       * @param {Number} index
       * @return {Object} object at index
       */
      item(index) {
        return this._objects[index];
      }

      /**
       * Returns true if collection contains no objects
       * @return {Boolean} true if collection is empty
       */
      isEmpty() {
        return this._objects.length === 0;
      }

      /**
       * Returns a size of a collection (i.e: length of an array containing its objects)
       * @return {Number} Collection size
       */
      size() {
        return this._objects.length;
      }

      /**
       * Returns true if collection contains an object.\
       * **Prefer using {@link FabricObject#isDescendantOf} for performance reasons**
       * instead of `a.contains(b)` use `b.isDescendantOf(a)`
       * @param {Object} object Object to check against
       * @param {Boolean} [deep=false] `true` to check all descendants, `false` to check only `_objects`
       * @return {Boolean} `true` if collection contains an object
       */
      contains(object, deep) {
        if (this._objects.includes(object)) {
          return true;
        } else if (deep) {
          return this._objects.some(obj => obj instanceof Collection && obj.contains(object, true));
        }
        return false;
      }

      /**
       * Returns number representation of a collection complexity
       * @return {Number} complexity
       */
      complexity() {
        return this._objects.reduce((memo, current) => {
          memo += current.complexity ? current.complexity() : 0;
          return memo;
        }, 0);
      }

      /**
       * Moves an object or the objects of a multiple selection
       * to the bottom of the stack of drawn objects
       * @param {fabric.Object} object Object to send to back
       * @returns {boolean} true if change occurred
       */
      sendObjectToBack(object) {
        if (!object || object === this._objects[0]) {
          return false;
        }
        removeFromArray(this._objects, object);
        this._objects.unshift(object);
        this._onStackOrderChanged(object);
        return true;
      }

      /**
       * Moves an object or the objects of a multiple selection
       * to the top of the stack of drawn objects
       * @param {fabric.Object} object Object to send
       * @returns {boolean} true if change occurred
       */
      bringObjectToFront(object) {
        if (!object || object === this._objects[this._objects.length - 1]) {
          return false;
        }
        removeFromArray(this._objects, object);
        this._objects.push(object);
        this._onStackOrderChanged(object);
        return true;
      }

      /**
       * Moves an object or a selection down in stack of drawn objects
       * An optional parameter, `intersecting` allows to move the object in behind
       * the first intersecting object. Where intersection is calculated with
       * bounding box. If no intersection is found, there will not be change in the
       * stack.
       * @param {fabric.Object} object Object to send
       * @param {boolean} [intersecting] If `true`, send object behind next lower intersecting object
       * @returns {boolean} true if change occurred
       */
      sendObjectBackwards(object, intersecting) {
        if (!object) {
          return false;
        }
        const idx = this._objects.indexOf(object);
        if (idx !== 0) {
          // if object is not on the bottom of stack
          const newIdx = this.findNewLowerIndex(object, idx, intersecting);
          removeFromArray(this._objects, object);
          this._objects.splice(newIdx, 0, object);
          this._onStackOrderChanged(object);
          return true;
        }
        return false;
      }

      /**
       * Moves an object or a selection up in stack of drawn objects
       * An optional parameter, intersecting allows to move the object in front
       * of the first intersecting object. Where intersection is calculated with
       * bounding box. If no intersection is found, there will not be change in the
       * stack.
       * @param {fabric.Object} object Object to send
       * @param {boolean} [intersecting] If `true`, send object in front of next upper intersecting object
       * @returns {boolean} true if change occurred
       */
      bringObjectForward(object, intersecting) {
        if (!object) {
          return false;
        }
        const idx = this._objects.indexOf(object);
        if (idx !== this._objects.length - 1) {
          // if object is not on top of stack (last item in an array)
          const newIdx = this.findNewUpperIndex(object, idx, intersecting);
          removeFromArray(this._objects, object);
          this._objects.splice(newIdx, 0, object);
          this._onStackOrderChanged(object);
          return true;
        }
        return false;
      }

      /**
       * Moves an object to specified level in stack of drawn objects
       * @param {fabric.Object} object Object to send
       * @param {number} index Position to move to
       * @returns {boolean} true if change occurred
       */
      moveObjectTo(object, index) {
        if (object === this._objects[index]) {
          return false;
        }
        removeFromArray(this._objects, object);
        this._objects.splice(index, 0, object);
        this._onStackOrderChanged(object);
        return true;
      }
      findNewLowerIndex(object, idx, intersecting) {
        let newIdx;
        if (intersecting) {
          newIdx = idx;
          // traverse down the stack looking for the nearest intersecting object
          for (let i = idx - 1; i >= 0; --i) {
            if (object.isOverlapping(this._objects[i])) {
              newIdx = i;
              break;
            }
          }
        } else {
          newIdx = idx - 1;
        }
        return newIdx;
      }
      findNewUpperIndex(object, idx, intersecting) {
        let newIdx;
        if (intersecting) {
          newIdx = idx;
          // traverse up the stack looking for the nearest intersecting object
          for (let i = idx + 1; i < this._objects.length; ++i) {
            if (object.isOverlapping(this._objects[i])) {
              newIdx = i;
              break;
            }
          }
        } else {
          newIdx = idx + 1;
        }
        return newIdx;
      }

      /**
       * Given a bounding box, return all the objects of the collection that are contained in the bounding box.
       * If `includeIntersecting` is true, return also the objects that intersect the bounding box as well.
       * This is meant to work with selection. Is not a generic method.
       * @param {TBBox} bbox a bounding box in scene coordinates
       * @param {{ includeIntersecting?: boolean }} options an object with includeIntersecting
       * @returns array of objects contained in the bounding box, ordered from top to bottom stacking wise
       */
      collectObjects(_ref) {
        let {
          left,
          top,
          width,
          height
        } = _ref;
        let {
          includeIntersecting = true
        } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const objects = [],
          tl = new Point(left, top),
          br = tl.add(new Point(width, height));

        // we iterate reverse order to collect top first in case of click.
        for (let i = this._objects.length - 1; i >= 0; i--) {
          const object = this._objects[i];
          if (object.selectable && object.visible && (includeIntersecting && object.intersectsWithRect(tl, br) || object.isContainedWithinRect(tl, br) || includeIntersecting && object.containsPoint(tl) || includeIntersecting && object.containsPoint(br))) {
            objects.push(object);
          }
        }
        return objects;
      }
    }

    // https://github.com/microsoft/TypeScript/issues/32080
    return Collection;
  }

  class CommonMethods extends Observable {
    /**
     * Sets object's properties from options, for initialization only
     * @protected
     * @param {Object} [options] Options object
     */
    _setOptions() {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      for (const prop in options) {
        this.set(prop, options[prop]);
      }
    }

    /**
     * @private
     */
    _setObject(obj) {
      for (const prop in obj) {
        this._set(prop, obj[prop]);
      }
    }

    /**
     * Sets property to a given value. When changing position/dimension -related properties (left, top, scale, angle, etc.) `set` does not update position of object's borders/controls. If you need to update those, call `setCoords()`.
     * @param {String|Object} key Property name or object (if object, iterate over the object properties)
     * @param {Object|Function} value Property value (if function, the value is passed into it and its return value is used as a new one)
     */
    set(key, value) {
      if (typeof key === 'object') {
        this._setObject(key);
      } else {
        this._set(key, value);
      }
      return this;
    }
    _set(key, value) {
      this[key] = value;
    }

    /**
     * Toggles specified property from `true` to `false` or from `false` to `true`
     * @param {String} property Property to toggle
     */
    toggle(property) {
      const value = this.get(property);
      if (typeof value === 'boolean') {
        this.set(property, !value);
      }
      return this;
    }

    /**
     * Basic getter
     * @param {String} property Property name
     * @return {*} value of a property
     */
    get(property) {
      return this[property];
    }
  }

  function requestAnimFrame(callback) {
    return getFabricWindow().requestAnimationFrame(callback);
  }
  function cancelAnimFrame(handle) {
    return getFabricWindow().cancelAnimationFrame(handle);
  }

  let id = 0;
  const uid = () => id++;

  /**
   * Creates canvas element
   * @return {CanvasElement} initialized canvas element
   */
  const createCanvasElement = () => {
    const element = getFabricDocument().createElement('canvas');
    if (!element || typeof element.getContext === 'undefined') {
      throw new FabricError('Failed to create `canvas` element');
    }
    return element;
  };

  /**
   * Creates image element (works on client and node)
   * @return {HTMLImageElement} HTML image element
   */
  const createImage = () => getFabricDocument().createElement('img');

  /**
   * Creates a canvas element that is a copy of another and is also painted
   * @param {CanvasElement} canvas to copy size and content of
   * @return {CanvasElement} initialized canvas element
   */
  const copyCanvasElement = canvas => {
    var _newCanvas$getContext;
    const newCanvas = createCanvasElementFor(canvas);
    (_newCanvas$getContext = newCanvas.getContext('2d')) === null || _newCanvas$getContext === void 0 || _newCanvas$getContext.drawImage(canvas, 0, 0);
    return newCanvas;
  };

  /**
   * Creates a canvas element as big as another
   * @param {CanvasElement} canvas to copy size and content of
   * @return {CanvasElement} initialized canvas element
   */
  const createCanvasElementFor = canvas => {
    const newCanvas = createCanvasElement();
    newCanvas.width = canvas.width;
    newCanvas.height = canvas.height;
    return newCanvas;
  };

  /**
   * since 2.6.0 moved from canvas instance to utility.
   * possibly useless
   * @param {CanvasElement} canvasEl to copy size and content of
   * @param {String} format 'jpeg' or 'png', in some browsers 'webp' is ok too
   * @param {number} quality <= 1 and > 0
   * @return {String} data url
   */
  const toDataURL = (canvasEl, format, quality) => canvasEl.toDataURL("image/".concat(format), quality);
  const isHTMLCanvas = canvas => {
    return !!canvas && canvas.getContext !== undefined;
  };
  const toBlob = (canvasEl, format, quality) => new Promise((resolve, _) => {
    canvasEl.toBlob(resolve, "image/".concat(format), quality);
  });

  /**
   * Transforms degrees to radians.
   * @param {TDegree} degrees value in degrees
   * @return {TRadian} value in radians
   */
  const degreesToRadians = degrees => degrees * PiBy180;

  /**
   * Transforms radians to degrees.
   * @param {TRadian} radians value in radians
   * @return {TDegree} value in degrees
   */
  const radiansToDegrees = radians => radians / PiBy180;

  const isIdentityMatrix = mat => mat.every((value, index) => value === iMatrix[index]);

  /**
   * Apply transform t to point p
   * @deprecated use {@link Point#transform}
   * @param  {Point | XY} p The point to transform
   * @param  {Array} t The transform
   * @param  {Boolean} [ignoreOffset] Indicates that the offset should not be applied
   * @return {Point} The transformed point
   */
  const transformPoint = (p, t, ignoreOffset) => new Point(p).transform(t, ignoreOffset);

  /**
   * Invert transformation t
   * @param {Array} t The transform
   * @return {Array} The inverted transform
   */
  const invertTransform = t => {
    const a = 1 / (t[0] * t[3] - t[1] * t[2]),
      r = [a * t[3], -a * t[1], -a * t[2], a * t[0], 0, 0],
      {
        x,
        y
      } = new Point(t[4], t[5]).transform(r, true);
    r[4] = -x;
    r[5] = -y;
    return r;
  };

  /**
   * Multiply matrix A by matrix B to nest transformations
   * @param  {TMat2D} a First transformMatrix
   * @param  {TMat2D} b Second transformMatrix
   * @param  {Boolean} is2x2 flag to multiply matrices as 2x2 matrices
   * @return {TMat2D} The product of the two transform matrices
   */
  const multiplyTransformMatrices = (a, b, is2x2) => [a[0] * b[0] + a[2] * b[1], a[1] * b[0] + a[3] * b[1], a[0] * b[2] + a[2] * b[3], a[1] * b[2] + a[3] * b[3], is2x2 ? 0 : a[0] * b[4] + a[2] * b[5] + a[4], is2x2 ? 0 : a[1] * b[4] + a[3] * b[5] + a[5]];

  /**
   * Multiplies {@link TMat2D} such that a matrix defines the plane for the rest of the matrices **after** it
   *
   * `multiplyTransformMatrixArray([A, B, C, D])` is equivalent to `A(B(C(D)))`
   *
   * @param matrices an array of matrices
   * @param [is2x2] flag to multiply matrices as 2x2 matrices
   * @returns the multiplication product
   */
  const multiplyTransformMatrixArray = (matrices, is2x2) => matrices.reduceRight((product, curr) => curr && product ? multiplyTransformMatrices(curr, product, is2x2) : curr || product, undefined) || iMatrix.concat();
  const calcPlaneRotation = _ref => {
    let [a, b] = _ref;
    return Math.atan2(b, a);
  };

  /**
   * Decomposes standard 2x3 matrix into transform components
   * @param  {TMat2D} a transformMatrix
   * @return {Object} Components of transform
   */
  const qrDecompose = a => {
    const angle = calcPlaneRotation(a),
      denom = Math.pow(a[0], 2) + Math.pow(a[1], 2),
      scaleX = Math.sqrt(denom),
      scaleY = (a[0] * a[3] - a[2] * a[1]) / scaleX,
      skewX = Math.atan2(a[0] * a[2] + a[1] * a[3], denom);
    return {
      angle: radiansToDegrees(angle),
      scaleX,
      scaleY,
      skewX: radiansToDegrees(skewX),
      skewY: 0,
      translateX: a[4] || 0,
      translateY: a[5] || 0
    };
  };

  /**
   * Generate a translation matrix
   *
   * A translation matrix in the form of
   * [ 1 0 x ]
   * [ 0 1 y ]
   * [ 0 0 1 ]
   *
   * See @link https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/transform#translate for more details
   *
   * @param {number} x translation on X axis
   * @param {number} [y] translation on Y axis
   * @returns {TMat2D} matrix
   */
  const createTranslateMatrix = function (x) {
    let y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return [1, 0, 0, 1, x, y];
  };

  /**
   * Generate a rotation matrix around around a point (x,y), defaulting to (0,0)
   *
   * A matrix in the form of
   * [cos(a) -sin(a) -x*cos(a)+y*sin(a)+x]
   * [sin(a)  cos(a) -x*sin(a)-y*cos(a)+y]
   * [0       0      1                 ]
   *
   *
   * @param {TDegree} angle rotation in degrees
   * @param {XY} [pivotPoint] pivot point to rotate around
   * @returns {TMat2D} matrix
   */
  function createRotateMatrix() {
    let {
      angle = 0
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let {
      x = 0,
      y = 0
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const angleRadiant = degreesToRadians(angle),
      cosValue = cos(angleRadiant),
      sinValue = sin(angleRadiant);
    return [cosValue, sinValue, -sinValue, cosValue, x ? x - (cosValue * x - sinValue * y) : 0, y ? y - (sinValue * x + cosValue * y) : 0];
  }

  /**
   * Generate a scale matrix around the point (0,0)
   *
   * A matrix in the form of
   * [x 0 0]
   * [0 y 0]
   * [0 0 1]
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/transform#scale
   *
   * @param {number} x scale on X axis
   * @param {number} [y] scale on Y axis
   * @returns {TMat2D} matrix
   */
  const createScaleMatrix = function (x) {
    let y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
    return [x, 0, 0, y, 0, 0];
  };
  const angleToSkew = angle => Math.tan(degreesToRadians(angle));

  /**
   * Generate a skew matrix for the X axis
   *
   * A matrix in the form of
   * [1 x 0]
   * [0 1 0]
   * [0 0 1]
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/transform#skewx
   *
   * @param {TDegree} skewValue translation on X axis
   * @returns {TMat2D} matrix
   */
  const createSkewXMatrix = skewValue => [1, 0, angleToSkew(skewValue), 1, 0, 0];

  /**
   * Generate a skew matrix for the Y axis
   *
   * A matrix in the form of
   * [1 0 0]
   * [y 1 0]
   * [0 0 1]
   *
   * @link https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/transform#skewy
   *
   * @param {TDegree} skewValue translation on Y axis
   * @returns {TMat2D} matrix
   */
  const createSkewYMatrix = skewValue => [1, angleToSkew(skewValue), 0, 1, 0, 0];

  /**
   * Returns a transform matrix starting from an object of the same kind of
   * the one returned from qrDecompose, useful also if you want to calculate some
   * transformations from an object that is not enlived yet.
   * is called DimensionsTransformMatrix because those properties are the one that influence
   * the size of the resulting box of the object.
   * @param  {Object} options
   * @param  {Number} [options.scaleX]
   * @param  {Number} [options.scaleY]
   * @param  {Boolean} [options.flipX]
   * @param  {Boolean} [options.flipY]
   * @param  {Number} [options.skewX]
   * @param  {Number} [options.skewY]
   * @return {Number[]} transform matrix
   */
  const calcDimensionsMatrix = _ref2 => {
    let {
      scaleX = 1,
      scaleY = 1,
      flipX = false,
      flipY = false,
      skewX = 0,
      skewY = 0
    } = _ref2;
    let matrix = createScaleMatrix(flipX ? -scaleX : scaleX, flipY ? -scaleY : scaleY);
    if (skewX) {
      matrix = multiplyTransformMatrices(matrix, createSkewXMatrix(skewX), true);
    }
    if (skewY) {
      matrix = multiplyTransformMatrices(matrix, createSkewYMatrix(skewY), true);
    }
    return matrix;
  };

  /**
   * Returns a transform matrix starting from an object of the same kind of
   * the one returned from qrDecompose, useful also if you want to calculate some
   * transformations from an object that is not enlived yet
   * Before changing this function look at: src/benchmarks/calcTransformMatrix.mjs
   * @param  {Object} options
   * @param  {Number} [options.angle]
   * @param  {Number} [options.scaleX]
   * @param  {Number} [options.scaleY]
   * @param  {Boolean} [options.flipX]
   * @param  {Boolean} [options.flipY]
   * @param  {Number} [options.skewX]
   * @param  {Number} [options.skewY]
   * @param  {Number} [options.translateX]
   * @param  {Number} [options.translateY]
   * @return {Number[]} transform matrix
   */
  const composeMatrix = options => {
    const {
      translateX = 0,
      translateY = 0,
      angle = 0
    } = options;
    let matrix = createTranslateMatrix(translateX, translateY);
    if (angle) {
      matrix = multiplyTransformMatrices(matrix, createRotateMatrix({
        angle
      }));
    }
    const scaleMatrix = calcDimensionsMatrix(options);
    if (!isIdentityMatrix(scaleMatrix)) {
      matrix = multiplyTransformMatrices(matrix, scaleMatrix);
    }
    return matrix;
  };

  /**
   * Loads image element from given url and resolve it, or catch.
   * @param {String} url URL representing an image
   * @param {LoadImageOptions} [options] image loading options
   * @returns {Promise<HTMLImageElement>} the loaded image.
   */
  const loadImage = function (url) {
    let {
      signal,
      crossOrigin = null
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new Promise(function (resolve, reject) {
      if (signal && signal.aborted) {
        return reject(new SignalAbortedError('loadImage'));
      }
      const img = createImage();
      let abort;
      if (signal) {
        abort = function (err) {
          img.src = '';
          reject(err);
        };
        signal.addEventListener('abort', abort, {
          once: true
        });
      }
      const done = function () {
        img.onload = img.onerror = null;
        abort && (signal === null || signal === void 0 ? void 0 : signal.removeEventListener('abort', abort));
        resolve(img);
      };
      if (!url) {
        done();
        return;
      }
      img.onload = done;
      img.onerror = function () {
        abort && (signal === null || signal === void 0 ? void 0 : signal.removeEventListener('abort', abort));
        reject(new FabricError("Error loading ".concat(img.src)));
      };
      crossOrigin && (img.crossOrigin = crossOrigin);
      img.src = url;
    });
  };
  /**
   * @TODO type this correctly.
   * Creates corresponding fabric instances from their object representations
   * @param {Object[]} objects Objects to enliven
   * @param {EnlivenObjectOptions} [options]
   * @param {(serializedObj: object, instance: FabricObject) => any} [options.reviver] Method for further parsing of object elements,
   * called after each fabric object created.
   * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
   * @returns {Promise<FabricObject[]>}
   */
  const enlivenObjects = function (objects) {
    let {
      signal,
      reviver = noop
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new Promise((resolve, reject) => {
      const instances = [];
      signal && signal.addEventListener('abort', reject, {
        once: true
      });
      Promise.all(objects.map(obj => classRegistry.getClass(obj.type).fromObject(obj, {
        signal
      }).then(fabricInstance => {
        reviver(obj, fabricInstance);
        instances.push(fabricInstance);
        return fabricInstance;
      }))).then(resolve).catch(error => {
        // cleanup
        instances.forEach(instance => {
          instance.dispose && instance.dispose();
        });
        reject(error);
      }).finally(() => {
        signal && signal.removeEventListener('abort', reject);
      });
    });
  };

  /**
   * Creates corresponding fabric instances residing in an object, e.g. `clipPath`
   * @param {Object} object with properties to enlive ( fill, stroke, clipPath, path )
   * @param {object} [options]
   * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
   * @returns {Promise<Record<string, FabricObject | TFiller | null>>} the input object with enlived values
   */
  const enlivenObjectEnlivables = function (serializedObject) {
    let {
      signal
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new Promise((resolve, reject) => {
      const instances = [];
      signal && signal.addEventListener('abort', reject, {
        once: true
      });
      // enlive every possible property
      const promises = Object.values(serializedObject).map(value => {
        if (!value) {
          return value;
        }
        /**
         * clipPath or shadow or gradient or text on a path or a pattern,
         * or the backgroundImage or overlayImage of canvas
         * If we have a type and there is a classe registered for it, we enlive it.
         * If there is no class registered for it we return the value as is
         * */
        if (value.type && classRegistry.has(value.type)) {
          return enlivenObjects([value], {
            signal
          }).then(_ref => {
            let [enlived] = _ref;
            instances.push(enlived);
            return enlived;
          });
        }
        return value;
      });
      const keys = Object.keys(serializedObject);
      Promise.all(promises).then(enlived => {
        return enlived.reduce((acc, instance, index) => {
          acc[keys[index]] = instance;
          return acc;
        }, {});
      }).then(resolve).catch(error => {
        // cleanup
        instances.forEach(instance => {
          instance.dispose && instance.dispose();
        });
        reject(error);
      }).finally(() => {
        signal && signal.removeEventListener('abort', reject);
      });
    });
  };

  /**
   * Populates an object with properties of another object
   * @param {Object} source Source object
   * @param {string[]} properties Properties names to include
   * @returns object populated with the picked keys
   */
  const pick = function (source) {
    let keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return keys.reduce((o, key) => {
      if (key in source) {
        o[key] = source[key];
      }
      return o;
    }, {});
  };
  const pickBy = (source, predicate) => {
    return Object.keys(source).reduce((o, key) => {
      if (predicate(source[key], key, source)) {
        o[key] = source[key];
      }
      return o;
    }, {});
  };

  /**
   * A wrapper around Number#toFixed, which contrary to native method returns number, not string.
   * @param {number|string} number number to operate on
   * @param {number} fractionDigits number of fraction digits to "leave"
   * @return {number}
   */
  const toFixed = (number, fractionDigits) => parseFloat(Number(number).toFixed(fractionDigits));

  /**
   * given an array of 6 number returns something like `"matrix(...numbers)"`
   * @param {TMat2D} transform an array with 6 numbers
   * @return {String} transform matrix for svg
   */
  const matrixToSVG = transform => 'matrix(' + transform.map(value => toFixed(value, config.NUM_FRACTION_DIGITS)).join(' ') + ')';

  const isFiller = filler => {
    return !!filler && filler.toLive !== undefined;
  };
  const isSerializableFiller = filler => {
    return !!filler && typeof filler.toObject === 'function';
  };
  const isPattern = filler => {
    return !!filler && filler.offsetX !== undefined && 'source' in filler;
  };
  const isTextObject = fabricObject => {
    return !!fabricObject && typeof fabricObject._renderText === 'function';
  };
  const isPath = fabricObject => {
    // we could use instanceof but that would mean pulling in Text code for a simple check
    // @todo discuss what to do and how to do
    return !!fabricObject && typeof fabricObject._renderPathCommands === 'function';
  };
  const isActiveSelection = fabricObject => !!fabricObject && 'multiSelectionStacking' in fabricObject;

  /**
   * Returns element scroll offsets
   * @param {HTMLElement} element Element to operate on
   * @return {Object} Object with left/top values
   */
  function getScrollLeftTop(element) {
    const doc = element && getDocumentFromElement(element);
    let left = 0,
      top = 0;
    if (!element || !doc) {
      return {
        left,
        top
      };
    }
    let elementLoop = element;
    const docElement = doc.documentElement,
      body = doc.body || {
        scrollLeft: 0,
        scrollTop: 0
      };
    // While loop checks (and then sets element to) .parentNode OR .host
    //  to account for ShadowDOM. We still want to traverse up out of ShadowDOM,
    //  but the .parentNode of a root ShadowDOM node will always be null, instead
    //  it should be accessed through .host. See http://stackoverflow.com/a/24765528/4383938
    while (elementLoop && (elementLoop.parentNode || elementLoop.host)) {
      elementLoop = elementLoop.parentNode || elementLoop.host;
      if (elementLoop === doc) {
        left = body.scrollLeft || docElement.scrollLeft || 0;
        top = body.scrollTop || docElement.scrollTop || 0;
      } else {
        left += elementLoop.scrollLeft || 0;
        top += elementLoop.scrollTop || 0;
      }
      if (elementLoop.nodeType === 1 && elementLoop.style.position === 'fixed') {
        break;
      }
    }
    return {
      left,
      top
    };
  }
  const getDocumentFromElement = el => el.ownerDocument || null;
  const getWindowFromElement = el => {
    var _el$ownerDocument;
    return ((_el$ownerDocument = el.ownerDocument) === null || _el$ownerDocument === void 0 ? void 0 : _el$ownerDocument.defaultView) || null;
  };

  const setCanvasDimensions = function (el, ctx, _ref) {
    let {
      width,
      height
    } = _ref;
    let retinaScaling = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    el.width = width;
    el.height = height;
    if (retinaScaling > 1) {
      el.setAttribute('width', (width * retinaScaling).toString());
      el.setAttribute('height', (height * retinaScaling).toString());
      ctx.scale(retinaScaling, retinaScaling);
    }
  };
  const setCSSDimensions = (el, _ref2) => {
    let {
      width,
      height
    } = _ref2;
    width && (el.style.width = typeof width === 'number' ? "".concat(width, "px") : width);
    height && (el.style.height = typeof height === 'number' ? "".concat(height, "px") : height);
  };

  /**
   * Returns offset for a given element
   * @param {HTMLElement} element Element to get offset for
   * @return {Object} Object with "left" and "top" properties
   */
  function getElementOffset(element) {
    var _getWindowFromElement;
    const doc = element && getDocumentFromElement(element),
      offset = {
        left: 0,
        top: 0
      };
    if (!doc) {
      return offset;
    }
    const elemStyle = ((_getWindowFromElement = getWindowFromElement(element)) === null || _getWindowFromElement === void 0 ? void 0 : _getWindowFromElement.getComputedStyle(element, null)) || {};
    offset.left += parseInt(elemStyle.borderLeftWidth, 10) || 0;
    offset.top += parseInt(elemStyle.borderTopWidth, 10) || 0;
    offset.left += parseInt(elemStyle.paddingLeft, 10) || 0;
    offset.top += parseInt(elemStyle.paddingTop, 10) || 0;
    let box = {
      left: 0,
      top: 0
    };
    const docElem = doc.documentElement;
    if (typeof element.getBoundingClientRect !== 'undefined') {
      box = element.getBoundingClientRect();
    }
    const scrollLeftTop = getScrollLeftTop(element);
    return {
      left: box.left + scrollLeftTop.left - (docElem.clientLeft || 0) + offset.left,
      top: box.top + scrollLeftTop.top - (docElem.clientTop || 0) + offset.top
    };
  }

  /**
   * Makes element unselectable
   * @param {HTMLElement} element Element to make unselectable
   * @return {HTMLElement} Element that was passed in
   */
  function makeElementUnselectable(element) {
    if (typeof element.onselectstart !== 'undefined') {
      element.onselectstart = () => false;
    }
    element.style.userSelect = NONE;
    return element;
  }

  class StaticCanvasDOMManager {
    constructor(arg0) {
      /**
       * Keeps a copy of the canvas style before setting retina scaling and other potions
       * in order to return it to original state on dispose
       * @type string
       */
      _defineProperty(this, "_originalCanvasStyle", void 0);
      _defineProperty(this, "lower", void 0);
      const el = this.createLowerCanvas(arg0);
      this.lower = {
        el,
        ctx: el.getContext('2d')
      };
    }
    createLowerCanvas(arg0) {
      // canvasEl === 'HTMLCanvasElement' does not work on jsdom/node
      const el = isHTMLCanvas(arg0) ? arg0 : arg0 && getFabricDocument().getElementById(arg0) || createCanvasElement();
      if (el.hasAttribute('data-fabric')) {
        throw new FabricError('Trying to initialize a canvas that has already been initialized. Did you forget to dispose the canvas?');
      }
      this._originalCanvasStyle = el.style.cssText;
      el.setAttribute('data-fabric', 'main');
      el.classList.add('lower-canvas');
      return el;
    }
    cleanupDOM(_ref) {
      let {
        width,
        height
      } = _ref;
      const {
        el
      } = this.lower;
      // restore canvas style and attributes
      el.classList.remove('lower-canvas');
      el.removeAttribute('data-fabric');
      // restore canvas size to original size in case retina scaling was applied
      el.setAttribute('width', "".concat(width));
      el.setAttribute('height', "".concat(height));
      el.style.cssText = this._originalCanvasStyle || '';
      this._originalCanvasStyle = undefined;
    }
    setDimensions(size, retinaScaling) {
      const {
        el,
        ctx
      } = this.lower;
      setCanvasDimensions(el, ctx, size, retinaScaling);
    }
    setCSSDimensions(size) {
      setCSSDimensions(this.lower.el, size);
    }

    /**
     * Calculates canvas element offset relative to the document
     */
    calcOffset() {
      return getElementOffset(this.lower.el);
    }
    dispose() {
      getEnv().dispose(this.lower.el);
      // @ts-expect-error disposing
      delete this.lower;
    }
  }

  const staticCanvasDefaults = {
    backgroundVpt: true,
    backgroundColor: '',
    overlayVpt: true,
    overlayColor: '',
    includeDefaultValues: true,
    svgViewportTransformation: true,
    renderOnAddRemove: true,
    skipOffscreen: true,
    enableRetinaScaling: true,
    imageSmoothingEnabled: true,
    /**
     * @todo move to Canvas
     */
    controlsAboveOverlay: false,
    /**
     * @todo move to Canvas
     */
    allowTouchScrolling: false,
    viewportTransform: [...iMatrix]
  };

  /**
   * Having both options in TCanvasSizeOptions set to true transform the call in a calcOffset
   * Better try to restrict with types to avoid confusion.
   */

  /**
   * Static canvas class
   * @see {@link http://fabricjs.com/static_canvas|StaticCanvas demo}
   * @fires before:render
   * @fires after:render
   * @fires canvas:cleared
   * @fires object:added
   * @fires object:removed
   */
  // TODO: fix `EventSpec` inheritance https://github.com/microsoft/TypeScript/issues/26154#issuecomment-1366616260
  class StaticCanvas extends createCollectionMixin(CommonMethods) {
    // background

    // overlay

    // rendering config

    /**
     * @todo move to Canvas
     */

    /**
     * @todo move to Canvas
     */

    /**
     * The viewport bounding box in scene plane coordinates, see {@link calcViewportBoundaries}
     */

    /**
     * A reference to the canvas actual HTMLCanvasElement.
     * Can be use to read the raw pixels, but never write or manipulate
     * @type HTMLCanvasElement
     */
    get lowerCanvasEl() {
      var _this$elements$lower;
      return (_this$elements$lower = this.elements.lower) === null || _this$elements$lower === void 0 ? void 0 : _this$elements$lower.el;
    }
    get contextContainer() {
      var _this$elements$lower2;
      return (_this$elements$lower2 = this.elements.lower) === null || _this$elements$lower2 === void 0 ? void 0 : _this$elements$lower2.ctx;
    }

    /**
     * If true the Canvas is in the process or has been disposed/destroyed.
     * No more rendering operation will be executed on this canvas.
     * @type boolean
     */

    /**
     * Started the process of disposing but not done yet.
     * WIll likely complete the render cycle already scheduled but stopping adding more.
     * @type boolean
     */

    /**
     * When true control drawing is skipped.
     * This boolean is used to avoid toDataURL to export controls.
     * Usage of this boolean to build up other flows and features is not supported
     * @type Boolean
     * @default false
     */

    // reference to

    static getDefaults() {
      return StaticCanvas.ownDefaults;
    }
    constructor(el) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      super();
      Object.assign(this, this.constructor.getDefaults());
      this.set(options);
      this.initElements(el);
      this._setDimensionsImpl({
        width: this.width || this.elements.lower.el.width || 0,
        height: this.height || this.elements.lower.el.height || 0
      });
      this.skipControlsDrawing = false;
      this.viewportTransform = [...this.viewportTransform];
      this.calcViewportBoundaries();
    }
    initElements(el) {
      this.elements = new StaticCanvasDOMManager(el);
    }
    add() {
      const size = super.add(...arguments);
      arguments.length > 0 && this.renderOnAddRemove && this.requestRenderAll();
      return size;
    }
    insertAt(index) {
      for (var _len = arguments.length, objects = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        objects[_key - 1] = arguments[_key];
      }
      const size = super.insertAt(index, ...objects);
      objects.length > 0 && this.renderOnAddRemove && this.requestRenderAll();
      return size;
    }
    remove() {
      const removed = super.remove(...arguments);
      removed.length > 0 && this.renderOnAddRemove && this.requestRenderAll();
      return removed;
    }
    _onObjectAdded(obj) {
      if (obj.canvas && obj.canvas !== this) {
        log('warn', 'Canvas is trying to add an object that belongs to a different canvas.\n' + 'Resulting to default behavior: removing object from previous canvas and adding to new canvas');
        obj.canvas.remove(obj);
      }
      obj._set('canvas', this);
      obj.setCoords();
      this.fire('object:added', {
        target: obj
      });
      obj.fire('added', {
        target: this
      });
    }
    _onObjectRemoved(obj) {
      obj._set('canvas', undefined);
      this.fire('object:removed', {
        target: obj
      });
      obj.fire('removed', {
        target: this
      });
    }
    _onStackOrderChanged() {
      this.renderOnAddRemove && this.requestRenderAll();
    }

    /**
     * @private
     * @see https://developer.apple.com/library/safari/documentation/AudioVideo/Conceptual/HTML-canvas-guide/SettingUptheCanvas/SettingUptheCanvas.html
     * @return {Number} retinaScaling if applied, otherwise 1;
     */
    getRetinaScaling() {
      return this.enableRetinaScaling ? getDevicePixelRatio() : 1;
    }

    /**
     * Calculates canvas element offset relative to the document
     * This method is also attached as "resize" event handler of window
     */
    calcOffset() {
      return this._offset = this.elements.calcOffset();
    }

    /**
     * Returns canvas width (in px)
     * @return {Number}
     */
    getWidth() {
      return this.width;
    }

    /**
     * Returns canvas height (in px)
     * @return {Number}
     */
    getHeight() {
      return this.height;
    }

    /**
     * Sets width of this canvas instance
     * @param {Number|String} value                         Value to set width to
     * @param {Object}        [options]                     Options object
     * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
     * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
     * @deprecated will be removed in 7.0
     */

    setWidth(value, options) {
      return this.setDimensions({
        width: value
      }, options);
    }

    /**s
     * Sets height of this canvas instance
     * @param {Number|String} value                         Value to set height to
     * @param {Object}        [options]                     Options object
     * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
     * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
     * @deprecated will be removed in 7.0
     */

    setHeight(value, options) {
      return this.setDimensions({
        height: value
      }, options);
    }

    /**
     * Internal use only
     * @protected
     */
    _setDimensionsImpl(dimensions) {
      let {
        cssOnly = false,
        backstoreOnly = false
      } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!cssOnly) {
        const size = _objectSpread2({
          width: this.width,
          height: this.height
        }, dimensions);
        this.elements.setDimensions(size, this.getRetinaScaling());
        this.hasLostContext = true;
        this.width = size.width;
        this.height = size.height;
      }
      if (!backstoreOnly) {
        this.elements.setCSSDimensions(dimensions);
      }
      this.calcOffset();
    }

    /**
     * Sets dimensions (width, height) of this canvas instance. when options.cssOnly flag active you should also supply the unit of measure (px/%/em)
     * @param {Object}        dimensions                    Object with width/height properties
     * @param {Number|String} [dimensions.width]            Width of canvas element
     * @param {Number|String} [dimensions.height]           Height of canvas element
     * @param {Object}        [options]                     Options object
     * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
     * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
     */

    setDimensions(dimensions, options) {
      this._setDimensionsImpl(dimensions, options);
      if (!options || !options.cssOnly) {
        this.requestRenderAll();
      }
    }

    /**
     * Returns canvas zoom level
     * @return {Number}
     */
    getZoom() {
      return this.viewportTransform[0];
    }

    /**
     * Sets viewport transformation of this canvas instance
     * @param {Array} vpt a Canvas 2D API transform matrix
     */
    setViewportTransform(vpt) {
      this.viewportTransform = vpt;
      this.calcViewportBoundaries();
      this.renderOnAddRemove && this.requestRenderAll();
    }

    /**
     * Sets zoom level of this canvas instance, the zoom centered around point
     * meaning that following zoom to point with the same point will have the visual
     * effect of the zoom originating from that point. The point won't move.
     * It has nothing to do with canvas center or visual center of the viewport.
     * @param {Point} point to zoom with respect to
     * @param {Number} value to set zoom to, less than 1 zooms out
     */
    zoomToPoint(point, value) {
      // TODO: just change the scale, preserve other transformations
      const before = point,
        vpt = [...this.viewportTransform];
      const newPoint = transformPoint(point, invertTransform(vpt));
      vpt[0] = value;
      vpt[3] = value;
      const after = transformPoint(newPoint, vpt);
      vpt[4] += before.x - after.x;
      vpt[5] += before.y - after.y;
      this.setViewportTransform(vpt);
    }

    /**
     * Sets zoom level of this canvas instance
     * @param {Number} value to set zoom to, less than 1 zooms out
     */
    setZoom(value) {
      this.zoomToPoint(new Point(0, 0), value);
    }

    /**
     * Pan viewport so as to place point at top left corner of canvas
     * @param {Point} point to move to
     */
    absolutePan(point) {
      const vpt = [...this.viewportTransform];
      vpt[4] = -point.x;
      vpt[5] = -point.y;
      return this.setViewportTransform(vpt);
    }

    /**
     * Pans viewpoint relatively
     * @param {Point} point (position vector) to move by
     */
    relativePan(point) {
      return this.absolutePan(new Point(-point.x - this.viewportTransform[4], -point.y - this.viewportTransform[5]));
    }

    /**
     * Returns &lt;canvas> element corresponding to this instance
     * @return {HTMLCanvasElement}
     */
    getElement() {
      return this.elements.lower.el;
    }

    /**
     * Clears specified context of canvas element
     * @param {CanvasRenderingContext2D} ctx Context to clear
     */
    clearContext(ctx) {
      ctx.clearRect(0, 0, this.width, this.height);
    }

    /**
     * Returns context of canvas where objects are drawn
     * @return {CanvasRenderingContext2D}
     */
    getContext() {
      return this.elements.lower.ctx;
    }

    /**
     * Clears all contexts (background, main, top) of an instance
     */
    clear() {
      this.remove(...this.getObjects());
      this.backgroundImage = undefined;
      this.overlayImage = undefined;
      this.backgroundColor = '';
      this.overlayColor = '';
      this.clearContext(this.getContext());
      this.fire('canvas:cleared');
      this.renderOnAddRemove && this.requestRenderAll();
    }

    /**
     * Renders the canvas
     */
    renderAll() {
      this.cancelRequestedRender();
      if (this.destroyed) {
        return;
      }
      this.renderCanvas(this.getContext(), this._objects);
    }

    /**
     * Function created to be instance bound at initialization
     * used in requestAnimationFrame rendering
     * Let the fabricJS call it. If you call it manually you could have more
     * animationFrame stacking on to of each other
     * for an imperative rendering, use canvas.renderAll
     * @private
     */
    renderAndReset() {
      this.nextRenderHandle = 0;
      this.renderAll();
    }

    /**
     * Append a renderAll request to next animation frame.
     * unless one is already in progress, in that case nothing is done
     * a boolean flag will avoid appending more.
     */
    requestRenderAll() {
      if (!this.nextRenderHandle && !this.disposed && !this.destroyed) {
        this.nextRenderHandle = requestAnimFrame(() => this.renderAndReset());
      }
    }

    /**
     * Calculate the position of the 4 corner of canvas with current viewportTransform.
     * helps to determinate when an object is in the current rendering viewport
     */
    calcViewportBoundaries() {
      const width = this.width,
        height = this.height,
        iVpt = invertTransform(this.viewportTransform),
        a = transformPoint({
          x: 0,
          y: 0
        }, iVpt),
        b = transformPoint({
          x: width,
          y: height
        }, iVpt),
        // we don't support vpt flipping
        // but the code is robust enough to mostly work with flipping
        min = a.min(b),
        max = a.max(b);
      return this.vptCoords = {
        tl: min,
        tr: new Point(max.x, min.y),
        bl: new Point(min.x, max.y),
        br: max
      };
    }
    cancelRequestedRender() {
      if (this.nextRenderHandle) {
        cancelAnimFrame(this.nextRenderHandle);
        this.nextRenderHandle = 0;
      }
    }
    drawControls(_ctx) {
      // Static canvas has no controls
    }

    /**
     * Renders background, objects, overlay and controls.
     * @param {CanvasRenderingContext2D} ctx
     * @param {Array} objects to render
     */
    renderCanvas(ctx, objects) {
      if (this.destroyed) {
        return;
      }
      const v = this.viewportTransform,
        path = this.clipPath;
      this.calcViewportBoundaries();
      this.clearContext(ctx);
      ctx.imageSmoothingEnabled = this.imageSmoothingEnabled;
      // @ts-expect-error node-canvas stuff
      ctx.patternQuality = 'best';
      this.fire('before:render', {
        ctx
      });
      this._renderBackground(ctx);
      ctx.save();
      //apply viewport transform once for all rendering process
      ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
      this._renderObjects(ctx, objects);
      ctx.restore();
      if (!this.controlsAboveOverlay && !this.skipControlsDrawing) {
        this.drawControls(ctx);
      }
      if (path) {
        path._set('canvas', this);
        // needed to setup a couple of variables
        // todo migrate to the newer one
        path.shouldCache();
        path._transformDone = true;
        path.renderCache({
          forClipping: true
        });
        this.drawClipPathOnCanvas(ctx, path);
      }
      this._renderOverlay(ctx);
      if (this.controlsAboveOverlay && !this.skipControlsDrawing) {
        this.drawControls(ctx);
      }
      this.fire('after:render', {
        ctx
      });
      if (this.__cleanupTask) {
        this.__cleanupTask();
        this.__cleanupTask = undefined;
      }
    }

    /**
     * Paint the cached clipPath on the lowerCanvasEl
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    drawClipPathOnCanvas(ctx, clipPath) {
      const v = this.viewportTransform;
      ctx.save();
      ctx.transform(...v);
      // DEBUG: uncomment this line, comment the following
      // ctx.globalAlpha = 0.4;
      ctx.globalCompositeOperation = 'destination-in';
      clipPath.transform(ctx);
      ctx.scale(1 / clipPath.zoomX, 1 / clipPath.zoomY);
      ctx.drawImage(clipPath._cacheCanvas, -clipPath.cacheTranslationX, -clipPath.cacheTranslationY);
      ctx.restore();
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Array} objects to render
     */
    _renderObjects(ctx, objects) {
      for (let i = 0, len = objects.length; i < len; ++i) {
        objects[i] && objects[i].render(ctx);
      }
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {string} property 'background' or 'overlay'
     */
    _renderBackgroundOrOverlay(ctx, property) {
      const fill = this["".concat(property, "Color")],
        object = this["".concat(property, "Image")],
        v = this.viewportTransform,
        needsVpt = this["".concat(property, "Vpt")];
      if (!fill && !object) {
        return;
      }
      const isAFiller = isFiller(fill);
      if (fill) {
        ctx.save();
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(this.width, 0);
        ctx.lineTo(this.width, this.height);
        ctx.lineTo(0, this.height);
        ctx.closePath();
        ctx.fillStyle = isAFiller ? fill.toLive(ctx /* this */) : fill;
        if (needsVpt) {
          ctx.transform(...v);
        }
        if (isAFiller) {
          ctx.transform(1, 0, 0, 1, fill.offsetX || 0, fill.offsetY || 0);
          const m = fill.gradientTransform || fill.patternTransform;
          m && ctx.transform(...m);
        }
        ctx.fill();
        ctx.restore();
      }
      if (object) {
        ctx.save();
        const {
          skipOffscreen
        } = this;
        // if the object doesn't move with the viewport,
        // the offscreen concept does not apply;
        this.skipOffscreen = needsVpt;
        if (needsVpt) {
          ctx.transform(...v);
        }
        object.render(ctx);
        this.skipOffscreen = skipOffscreen;
        ctx.restore();
      }
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderBackground(ctx) {
      this._renderBackgroundOrOverlay(ctx, 'background');
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderOverlay(ctx) {
      this._renderBackgroundOrOverlay(ctx, 'overlay');
    }

    /**
     * Returns coordinates of a center of canvas.
     * Returned value is an object with top and left properties
     * @return {Object} object with "top" and "left" number values
     * @deprecated migrate to `getCenterPoint`
     */
    getCenter() {
      return {
        top: this.height / 2,
        left: this.width / 2
      };
    }

    /**
     * Returns coordinates of a center of canvas.
     * @return {Point}
     */
    getCenterPoint() {
      return new Point(this.width / 2, this.height / 2);
    }

    /**
     * Centers object horizontally in the canvas
     */
    centerObjectH(object) {
      return this._centerObject(object, new Point(this.getCenterPoint().x, object.getCenterPoint().y));
    }

    /**
     * Centers object vertically in the canvas
     * @param {FabricObject} object Object to center vertically
     */
    centerObjectV(object) {
      return this._centerObject(object, new Point(object.getCenterPoint().x, this.getCenterPoint().y));
    }

    /**
     * Centers object vertically and horizontally in the canvas
     * @param {FabricObject} object Object to center vertically and horizontally
     */
    centerObject(object) {
      return this._centerObject(object, this.getCenterPoint());
    }

    /**
     * Centers object vertically and horizontally in the viewport
     * @param {FabricObject} object Object to center vertically and horizontally
     */
    viewportCenterObject(object) {
      return this._centerObject(object, this.getVpCenter());
    }

    /**
     * Centers object horizontally in the viewport, object.top is unchanged
     * @param {FabricObject} object Object to center vertically and horizontally
     */
    viewportCenterObjectH(object) {
      return this._centerObject(object, new Point(this.getVpCenter().x, object.getCenterPoint().y));
    }

    /**
     * Centers object Vertically in the viewport, object.top is unchanged
     * @param {FabricObject} object Object to center vertically and horizontally
     */
    viewportCenterObjectV(object) {
      return this._centerObject(object, new Point(object.getCenterPoint().x, this.getVpCenter().y));
    }

    /**
     * Calculate the point in canvas that correspond to the center of actual viewport.
     * @return {Point} vpCenter, viewport center
     */
    getVpCenter() {
      return transformPoint(this.getCenterPoint(), invertTransform(this.viewportTransform));
    }

    /**
     * @private
     * @param {FabricObject} object Object to center
     * @param {Point} center Center point
     */
    _centerObject(object, center) {
      object.setXY(center, CENTER, CENTER);
      object.setCoords();
      this.renderOnAddRemove && this.requestRenderAll();
    }

    /**
     * Returns dataless JSON representation of canvas
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {String} json string
     */
    toDatalessJSON(propertiesToInclude) {
      return this.toDatalessObject(propertiesToInclude);
    }

    /**
     * Returns object representation of canvas
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject(propertiesToInclude) {
      return this._toObjectMethod('toObject', propertiesToInclude);
    }

    /**
     * Returns Object representation of canvas
     * this alias is provided because if you call JSON.stringify on an instance,
     * the toJSON object will be invoked if it exists.
     * Having a toJSON method means you can do JSON.stringify(myCanvas)
     * @return {Object} JSON compatible object
     * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#serialization}
     * @see {@link http://jsfiddle.net/fabricjs/pec86/|jsFiddle demo}
     * @example <caption>JSON without additional properties</caption>
     * var json = canvas.toJSON();
     * @example <caption>JSON with additional properties included</caption>
     * var json = canvas.toJSON(['lockMovementX', 'lockMovementY', 'lockRotation', 'lockScalingX', 'lockScalingY']);
     * @example <caption>JSON without default values</caption>
     * var json = canvas.toJSON();
     */
    toJSON() {
      return this.toObject();
    }

    /**
     * Returns dataless object representation of canvas
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toDatalessObject(propertiesToInclude) {
      return this._toObjectMethod('toDatalessObject', propertiesToInclude);
    }

    /**
     * @private
     */
    _toObjectMethod(methodName, propertiesToInclude) {
      const clipPath = this.clipPath;
      const clipPathData = clipPath && !clipPath.excludeFromExport ? this._toObject(clipPath, methodName, propertiesToInclude) : null;
      return _objectSpread2(_objectSpread2(_objectSpread2({
        version: VERSION
      }, pick(this, propertiesToInclude)), {}, {
        objects: this._objects.filter(object => !object.excludeFromExport).map(instance => this._toObject(instance, methodName, propertiesToInclude))
      }, this.__serializeBgOverlay(methodName, propertiesToInclude)), clipPathData ? {
        clipPath: clipPathData
      } : null);
    }

    /**
     * @private
     */
    _toObject(instance, methodName, propertiesToInclude) {
      let originalValue;
      if (!this.includeDefaultValues) {
        originalValue = instance.includeDefaultValues;
        instance.includeDefaultValues = false;
      }
      const object = instance[methodName](propertiesToInclude);
      if (!this.includeDefaultValues) {
        instance.includeDefaultValues = !!originalValue;
      }
      return object;
    }

    /**
     * @private
     */
    __serializeBgOverlay(methodName, propertiesToInclude) {
      const data = {},
        bgImage = this.backgroundImage,
        overlayImage = this.overlayImage,
        bgColor = this.backgroundColor,
        overlayColor = this.overlayColor;
      if (isFiller(bgColor)) {
        if (!bgColor.excludeFromExport) {
          data.background = bgColor.toObject(propertiesToInclude);
        }
      } else if (bgColor) {
        data.background = bgColor;
      }
      if (isFiller(overlayColor)) {
        if (!overlayColor.excludeFromExport) {
          data.overlay = overlayColor.toObject(propertiesToInclude);
        }
      } else if (overlayColor) {
        data.overlay = overlayColor;
      }
      if (bgImage && !bgImage.excludeFromExport) {
        data.backgroundImage = this._toObject(bgImage, methodName, propertiesToInclude);
      }
      if (overlayImage && !overlayImage.excludeFromExport) {
        data.overlayImage = this._toObject(overlayImage, methodName, propertiesToInclude);
      }
      return data;
    }

    /* _TO_SVG_START_ */

    /**
     * Returns SVG representation of canvas
     * @function
     * @param {Object} [options] Options object for SVG output
     * @param {Boolean} [options.suppressPreamble=false] If true xml tag is not included
     * @param {Object} [options.viewBox] SVG viewbox object
     * @param {Number} [options.viewBox.x] x-coordinate of viewbox
     * @param {Number} [options.viewBox.y] y-coordinate of viewbox
     * @param {Number} [options.viewBox.width] Width of viewbox
     * @param {Number} [options.viewBox.height] Height of viewbox
     * @param {String} [options.encoding=UTF-8] Encoding of SVG output
     * @param {String} [options.width] desired width of svg with or without units
     * @param {String} [options.height] desired height of svg with or without units
     * @param {Function} [reviver] Method for further parsing of svg elements, called after each fabric object converted into svg representation.
     * @return {String} SVG string
     * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#serialization}
     * @see {@link http://jsfiddle.net/fabricjs/jQ3ZZ/|jsFiddle demo}
     * @example <caption>Normal SVG output</caption>
     * var svg = canvas.toSVG();
     * @example <caption>SVG output without preamble (without &lt;?xml ../>)</caption>
     * var svg = canvas.toSVG({suppressPreamble: true});
     * @example <caption>SVG output with viewBox attribute</caption>
     * var svg = canvas.toSVG({
     *   viewBox: {
     *     x: 100,
     *     y: 100,
     *     width: 200,
     *     height: 300
     *   }
     * });
     * @example <caption>SVG output with different encoding (default: UTF-8)</caption>
     * var svg = canvas.toSVG({encoding: 'ISO-8859-1'});
     * @example <caption>Modify SVG output with reviver function</caption>
     * var svg = canvas.toSVG(null, function(svg) {
     *   return svg.replace('stroke-dasharray: ; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; ', '');
     * });
     */
    toSVG() {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      let reviver = arguments.length > 1 ? arguments[1] : undefined;
      options.reviver = reviver;
      const markup = [];
      this._setSVGPreamble(markup, options);
      this._setSVGHeader(markup, options);
      if (this.clipPath) {
        markup.push("<g clip-path=\"url(#".concat(this.clipPath.clipPathId, ")\" >\n"));
      }
      this._setSVGBgOverlayColor(markup, 'background');
      this._setSVGBgOverlayImage(markup, 'backgroundImage', reviver);
      this._setSVGObjects(markup, reviver);
      if (this.clipPath) {
        markup.push('</g>\n');
      }
      this._setSVGBgOverlayColor(markup, 'overlay');
      this._setSVGBgOverlayImage(markup, 'overlayImage', reviver);
      markup.push('</svg>');
      return markup.join('');
    }

    /**
     * @private
     */
    _setSVGPreamble(markup, options) {
      if (options.suppressPreamble) {
        return;
      }
      markup.push('<?xml version="1.0" encoding="', options.encoding || 'UTF-8', '" standalone="no" ?>\n', '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" ', '"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n');
    }

    /**
     * @private
     */
    _setSVGHeader(markup, options) {
      const width = options.width || "".concat(this.width),
        height = options.height || "".concat(this.height),
        NUM_FRACTION_DIGITS = config.NUM_FRACTION_DIGITS,
        optViewBox = options.viewBox;
      let viewBox;
      if (optViewBox) {
        viewBox = "viewBox=\"".concat(optViewBox.x, " ").concat(optViewBox.y, " ").concat(optViewBox.width, " ").concat(optViewBox.height, "\" ");
      } else if (this.svgViewportTransformation) {
        const vpt = this.viewportTransform;
        viewBox = "viewBox=\"".concat(toFixed(-vpt[4] / vpt[0], NUM_FRACTION_DIGITS), " ").concat(toFixed(-vpt[5] / vpt[3], NUM_FRACTION_DIGITS), " ").concat(toFixed(this.width / vpt[0], NUM_FRACTION_DIGITS), " ").concat(toFixed(this.height / vpt[3], NUM_FRACTION_DIGITS), "\" ");
      } else {
        viewBox = "viewBox=\"0 0 ".concat(this.width, " ").concat(this.height, "\" ");
      }
      markup.push('<svg ', 'xmlns="http://www.w3.org/2000/svg" ', 'xmlns:xlink="http://www.w3.org/1999/xlink" ', 'version="1.1" ', 'width="', width, '" ', 'height="', height, '" ', viewBox, 'xml:space="preserve">\n', '<desc>Created with Fabric.js ', VERSION, '</desc>\n', '<defs>\n', this.createSVGFontFacesMarkup(), this.createSVGRefElementsMarkup(), this.createSVGClipPathMarkup(options), '</defs>\n');
    }
    createSVGClipPathMarkup(options) {
      const clipPath = this.clipPath;
      if (clipPath) {
        clipPath.clipPathId = "CLIPPATH_".concat(uid());
        return "<clipPath id=\"".concat(clipPath.clipPathId, "\" >\n").concat(clipPath.toClipPathSVG(options.reviver), "</clipPath>\n");
      }
      return '';
    }

    /**
     * Creates markup containing SVG referenced elements like patterns, gradients etc.
     * @return {String}
     */
    createSVGRefElementsMarkup() {
      return ['background', 'overlay'].map(prop => {
        const fill = this["".concat(prop, "Color")];
        if (isFiller(fill)) {
          const shouldTransform = this["".concat(prop, "Vpt")],
            vpt = this.viewportTransform,
            object = {
              // otherwise circular dependency
              isType: () => false,
              width: this.width / (shouldTransform ? vpt[0] : 1),
              height: this.height / (shouldTransform ? vpt[3] : 1)
            };
          return fill.toSVG(object, {
            additionalTransform: shouldTransform ? matrixToSVG(vpt) : ''
          });
        }
      }).join('');
    }

    /**
     * Creates markup containing SVG font faces,
     * font URLs for font faces must be collected by developers
     * and are not extracted from the DOM by fabricjs
     * @param {Array} objects Array of fabric objects
     * @return {String}
     */
    createSVGFontFacesMarkup() {
      const objects = [],
        fontList = {},
        fontPaths = config.fontPaths;
      this._objects.forEach(function add(object) {
        objects.push(object);
        if (isCollection(object)) {
          object._objects.forEach(add);
        }
      });
      objects.forEach(obj => {
        if (!isTextObject(obj)) {
          return;
        }
        const {
          styles,
          fontFamily
        } = obj;
        if (fontList[fontFamily] || !fontPaths[fontFamily]) {
          return;
        }
        fontList[fontFamily] = true;
        if (!styles) {
          return;
        }
        Object.values(styles).forEach(styleRow => {
          Object.values(styleRow).forEach(_ref => {
            let {
              fontFamily = ''
            } = _ref;
            if (!fontList[fontFamily] && fontPaths[fontFamily]) {
              fontList[fontFamily] = true;
            }
          });
        });
      });
      const fontListMarkup = Object.keys(fontList).map(fontFamily => "\t\t@font-face {\n\t\t\tfont-family: '".concat(fontFamily, "';\n\t\t\tsrc: url('").concat(fontPaths[fontFamily], "');\n\t\t}\n")).join('');
      if (fontListMarkup) {
        return "\t<style type=\"text/css\"><![CDATA[\n".concat(fontListMarkup, "]]></style>\n");
      }
      return '';
    }

    /**
     * @private
     */
    _setSVGObjects(markup, reviver) {
      this.forEachObject(fabricObject => {
        if (fabricObject.excludeFromExport) {
          return;
        }
        this._setSVGObject(markup, fabricObject, reviver);
      });
    }

    /**
     * This is its own function because the Canvas ( non static ) requires extra code here
     * @private
     */
    _setSVGObject(markup, instance, reviver) {
      markup.push(instance.toSVG(reviver));
    }

    /**
     * @private
     */
    _setSVGBgOverlayImage(markup, property, reviver) {
      const bgOrOverlay = this[property];
      if (bgOrOverlay && !bgOrOverlay.excludeFromExport && bgOrOverlay.toSVG) {
        markup.push(bgOrOverlay.toSVG(reviver));
      }
    }

    /**
     * @TODO this seems to handle patterns but fail at gradients.
     * @private
     */
    _setSVGBgOverlayColor(markup, property) {
      const filler = this["".concat(property, "Color")];
      if (!filler) {
        return;
      }
      if (isFiller(filler)) {
        const repeat = filler.repeat || '',
          finalWidth = this.width,
          finalHeight = this.height,
          shouldInvert = this["".concat(property, "Vpt")],
          additionalTransform = shouldInvert ? matrixToSVG(invertTransform(this.viewportTransform)) : '';
        markup.push("<rect transform=\"".concat(additionalTransform, " translate(").concat(finalWidth / 2, ",").concat(finalHeight / 2, ")\" x=\"").concat(filler.offsetX - finalWidth / 2, "\" y=\"").concat(filler.offsetY - finalHeight / 2, "\" width=\"").concat((repeat === 'repeat-y' || repeat === 'no-repeat') && isPattern(filler) ? filler.source.width : finalWidth, "\" height=\"").concat((repeat === 'repeat-x' || repeat === 'no-repeat') && isPattern(filler) ? filler.source.height : finalHeight, "\" fill=\"url(#SVGID_").concat(filler.id, ")\"></rect>\n"));
      } else {
        markup.push('<rect x="0" y="0" width="100%" height="100%" ', 'fill="', filler, '"', '></rect>\n');
      }
    }
    /* _TO_SVG_END_ */

    /**
     * Populates canvas with data from the specified JSON.
     * JSON format must conform to the one of {@link fabric.Canvas#toJSON}
     *
     * **IMPORTANT**: It is recommended to abort loading tasks before calling this method to prevent race conditions and unnecessary networking
     *
     * @param {String|Object} json JSON string or object
     * @param {Function} [reviver] Method for further parsing of JSON elements, called after each fabric object created.
     * @param {Object} [options] options
     * @param {AbortSignal} [options.signal] see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
     * @return {Promise<Canvas | StaticCanvas>} instance
     * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#deserialization}
     * @see {@link http://jsfiddle.net/fabricjs/fmgXt/|jsFiddle demo}
     * @example <caption>loadFromJSON</caption>
     * canvas.loadFromJSON(json).then((canvas) => canvas.requestRenderAll());
     * @example <caption>loadFromJSON with reviver</caption>
     * canvas.loadFromJSON(json, function(o, object) {
     *   // `o` = json object
     *   // `object` = fabric.Object instance
     *   // ... do some stuff ...
     * }).then((canvas) => {
     *   ... canvas is restored, add your code.
     * });
     *
     */
    loadFromJSON(json, reviver) {
      let {
        signal
      } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (!json) {
        return Promise.reject(new FabricError('`json` is undefined'));
      }

      // parse json if it wasn't already
      const serialized = typeof json === 'string' ? JSON.parse(json) : json;
      const {
        objects = [],
        backgroundImage,
        background,
        overlayImage,
        overlay,
        clipPath
      } = serialized;
      const renderOnAddRemove = this.renderOnAddRemove;
      this.renderOnAddRemove = false;
      return Promise.all([enlivenObjects(objects, {
        reviver,
        signal
      }), enlivenObjectEnlivables({
        backgroundImage,
        backgroundColor: background,
        overlayImage,
        overlayColor: overlay,
        clipPath
      }, {
        signal
      })]).then(_ref2 => {
        let [enlived, enlivedMap] = _ref2;
        this.clear();
        this.add(...enlived);
        this.set(serialized);
        this.set(enlivedMap);
        this.renderOnAddRemove = renderOnAddRemove;
        return this;
      });
    }

    /**
     * Clones canvas instance
     * @param {string[]} [properties] Array of properties to include in the cloned canvas and children
     */
    clone(properties) {
      const data = this.toObject(properties);
      const canvas = this.cloneWithoutData();
      return canvas.loadFromJSON(data);
    }

    /**
     * Clones canvas instance without cloning existing data.
     * This essentially copies canvas dimensions since loadFromJSON does not affect canvas size.
     */
    cloneWithoutData() {
      const el = createCanvasElementFor(this);
      return new this.constructor(el);
    }

    /**
     * Exports canvas element to a dataurl image. Note that when multiplier is used, cropping is scaled appropriately
     * @param {Object} [options] Options object
     * @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
     * @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
     * @param {Number} [options.multiplier=1] Multiplier to scale by, to have consistent
     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 2.0.0
     * @param {(object: fabric.Object) => boolean} [options.filter] Function to filter objects.
     * @return {String} Returns a data: URL containing a representation of the object in the format specified by options.format
     * @see {@link https://jsfiddle.net/xsjua1rd/ demo}
     * @example <caption>Generate jpeg dataURL with lower quality</caption>
     * var dataURL = canvas.toDataURL({
     *   format: 'jpeg',
     *   quality: 0.8
     * });
     * @example <caption>Generate cropped png dataURL (clipping of canvas)</caption>
     * var dataURL = canvas.toDataURL({
     *   format: 'png',
     *   left: 100,
     *   top: 100,
     *   width: 200,
     *   height: 200
     * });
     * @example <caption>Generate double scaled png dataURL</caption>
     * var dataURL = canvas.toDataURL({
     *   format: 'png',
     *   multiplier: 2
     * });
     * @example <caption>Generate dataURL with objects that overlap a specified object</caption>
     * var myObject;
     * var dataURL = canvas.toDataURL({
     *   filter: (object) => object.isContainedWithinObject(myObject) || object.intersectsWithObject(myObject)
     * });
     */
    toDataURL() {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const {
        format = 'png',
        quality = 1,
        multiplier = 1,
        enableRetinaScaling = false
      } = options;
      const finalMultiplier = multiplier * (enableRetinaScaling ? this.getRetinaScaling() : 1);
      return toDataURL(this.toCanvasElement(finalMultiplier, options), format, quality);
    }
    toBlob() {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const {
        format = 'png',
        quality = 1,
        multiplier = 1,
        enableRetinaScaling = false
      } = options;
      const finalMultiplier = multiplier * (enableRetinaScaling ? this.getRetinaScaling() : 1);
      return toBlob(this.toCanvasElement(finalMultiplier, options), format, quality);
    }

    /**
     * Create a new HTMLCanvas element painted with the current canvas content.
     * No need to resize the actual one or repaint it.
     * Will transfer object ownership to a new canvas, paint it, and set everything back.
     * This is an intermediary step used to get to a dataUrl but also it is useful to
     * create quick image copies of a canvas without passing for the dataUrl string
     * @param {Number} [multiplier] a zoom factor.
     * @param {Object} [options] Cropping informations
     * @param {Number} [options.left] Cropping left offset.
     * @param {Number} [options.top] Cropping top offset.
     * @param {Number} [options.width] Cropping width.
     * @param {Number} [options.height] Cropping height.
     * @param {(object: fabric.Object) => boolean} [options.filter] Function to filter objects.
     */
    toCanvasElement() {
      let multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      let {
        width,
        height,
        left,
        top,
        filter
      } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      const scaledWidth = (width || this.width) * multiplier,
        scaledHeight = (height || this.height) * multiplier,
        zoom = this.getZoom(),
        originalWidth = this.width,
        originalHeight = this.height,
        originalSkipControlsDrawing = this.skipControlsDrawing,
        newZoom = zoom * multiplier,
        vp = this.viewportTransform,
        translateX = (vp[4] - (left || 0)) * multiplier,
        translateY = (vp[5] - (top || 0)) * multiplier,
        newVp = [newZoom, 0, 0, newZoom, translateX, translateY],
        originalRetina = this.enableRetinaScaling,
        canvasEl = createCanvasElementFor({
          width: scaledWidth,
          height: scaledHeight
        }),
        objectsToRender = filter ? this._objects.filter(obj => filter(obj)) : this._objects;
      this.enableRetinaScaling = false;
      this.viewportTransform = newVp;
      this.width = scaledWidth;
      this.height = scaledHeight;
      this.skipControlsDrawing = true;
      this.calcViewportBoundaries();
      this.renderCanvas(canvasEl.getContext('2d'), objectsToRender);
      this.viewportTransform = vp;
      this.width = originalWidth;
      this.height = originalHeight;
      this.calcViewportBoundaries();
      this.enableRetinaScaling = originalRetina;
      this.skipControlsDrawing = originalSkipControlsDrawing;
      return canvasEl;
    }

    /**
     * Waits until rendering has settled to destroy the canvas
     * @returns {Promise<boolean>} a promise resolving to `true` once the canvas has been destroyed or to `false` if the canvas has was already destroyed
     * @throws if aborted by a consequent call
     */
    dispose() {
      !this.disposed && this.elements.cleanupDOM({
        width: this.width,
        height: this.height
      });
      runningAnimations.cancelByCanvas(this);
      this.disposed = true;
      return new Promise((resolve, reject) => {
        const task = () => {
          this.destroy();
          resolve(true);
        };
        task.kill = reject;
        if (this.__cleanupTask) {
          this.__cleanupTask.kill('aborted');
        }
        if (this.destroyed) {
          resolve(false);
        } else if (this.nextRenderHandle) {
          this.__cleanupTask = task;
        } else {
          task();
        }
      });
    }

    /**
     * Clears the canvas element, disposes objects and frees resources.
     *
     * Invoked as part of the **async** operation of {@link dispose}.
     *
     * **CAUTION**:
     *
     * This method is **UNSAFE**.
     * You may encounter a race condition using it if there's a requested render.
     * Call this method only if you are sure rendering has settled.
     * Consider using {@link dispose} as it is **SAFE**
     *
     * @private
     */
    destroy() {
      this.destroyed = true;
      this.cancelRequestedRender();
      this.forEachObject(object => object.dispose());
      this._objects = [];
      if (this.backgroundImage) {
        this.backgroundImage.dispose();
      }
      this.backgroundImage = undefined;
      if (this.overlayImage) {
        this.overlayImage.dispose();
      }
      this.overlayImage = undefined;
      this.elements.dispose();
    }

    /**
     * Returns a string representation of an instance
     * @return {String} string representation of an instance
     */
    toString() {
      return "#<Canvas (".concat(this.complexity(), "): { objects: ").concat(this._objects.length, " }>");
    }
  }
  _defineProperty(StaticCanvas, "ownDefaults", staticCanvasDefaults);

  const touchEvents = ['touchstart', 'touchmove', 'touchend'];
  function getTouchInfo(event) {
    const touchProp = event.changedTouches;
    if (touchProp && touchProp[0]) {
      return touchProp[0];
    }
    return event;
  }
  const getPointer = event => {
    const element = event.target,
      scroll = getScrollLeftTop(element),
      _evt = getTouchInfo(event);
    return new Point(_evt.clientX + scroll.left, _evt.clientY + scroll.top);
  };
  const isTouchEvent = event => touchEvents.includes(event.type) || event.pointerType === 'touch';
  const stopEvent = e => {
    e.preventDefault();
    e.stopPropagation();
  };

  /**
   * Calculates bounding box (left, top, width, height) from given `points`
   * @param {XY[]} points
   * @return {Object} Object with left, top, width, height properties
   */
  const makeBoundingBoxFromPoints = points => {
    let left = 0,
      top = 0,
      width = 0,
      height = 0;
    for (let i = 0, len = points.length; i < len; i++) {
      const {
        x,
        y
      } = points[i];
      if (x > width || !i) width = x;
      if (x < left || !i) left = x;
      if (y > height || !i) height = y;
      if (y < top || !i) top = y;
    }
    return {
      left,
      top,
      width: width - left,
      height: height - top
    };
  };

  const _excluded$i = ["translateX", "translateY", "scaleX", "scaleY"];

  /**
   * given an object and a transform, apply the inverse transform to the object,
   * this is equivalent to remove from that object that transformation, so that
   * added in a space with the removed transform, the object will be the same as before.
   * Removing from an object a transform that scale by 2 is like scaling it by 1/2.
   * Removing from an object a transform that rotate by 30deg is like rotating by 30deg
   * in the opposite direction.
   * This util is used to add objects inside transformed groups or nested groups.
   * @param {FabricObject} object the object you want to transform
   * @param {TMat2D} transform the destination transform
   */
  const removeTransformFromObject = (object, transform) => {
    const inverted = invertTransform(transform),
      finalTransform = multiplyTransformMatrices(inverted, object.calcOwnMatrix());
    applyTransformToObject(object, finalTransform);
  };

  /**
   * given an object and a transform, apply the transform to the object.
   * this is equivalent to change the space where the object is drawn.
   * Adding to an object a transform that scale by 2 is like scaling it by 2.
   * This is used when removing an object from an active selection for example.
   * @param {FabricObject} object the object you want to transform
   * @param {Array} transform the destination transform
   */
  const addTransformToObject = (object, transform) => applyTransformToObject(object, multiplyTransformMatrices(transform, object.calcOwnMatrix()));

  /**
   * discard an object transform state and apply the one from the matrix.
   * @param {FabricObject} object the object you want to transform
   * @param {Array} transform the destination transform
   */
  const applyTransformToObject = (object, transform) => {
    const _qrDecompose = qrDecompose(transform),
      {
        translateX,
        translateY,
        scaleX,
        scaleY
      } = _qrDecompose,
      otherOptions = _objectWithoutProperties(_qrDecompose, _excluded$i),
      center = new Point(translateX, translateY);
    object.flipX = false;
    object.flipY = false;
    Object.assign(object, otherOptions);
    object.set({
      scaleX,
      scaleY
    });
    object.setPositionByOrigin(center, CENTER, CENTER);
  };
  /**
   * reset an object transform state to neutral. Top and left are not accounted for
   * @param  {FabricObject} target object to transform
   */
  const resetObjectTransform = target => {
    target.scaleX = 1;
    target.scaleY = 1;
    target.skewX = 0;
    target.skewY = 0;
    target.flipX = false;
    target.flipY = false;
    target.rotate(0);
  };

  /**
   * Extract Object transform values
   * @param  {FabricObject} target object to read from
   * @return {Object} Components of transform
   */
  const saveObjectTransform = target => ({
    scaleX: target.scaleX,
    scaleY: target.scaleY,
    skewX: target.skewX,
    skewY: target.skewY,
    angle: target.angle,
    left: target.left,
    flipX: target.flipX,
    flipY: target.flipY,
    top: target.top
  });

  /**
   * given a width and height, return the size of the bounding box
   * that can contains the box with width/height with applied transform.
   * Use to calculate the boxes around objects for controls.
   * @param {Number} width
   * @param {Number} height
   * @param {TMat2D} t
   * @returns {Point} size
   */
  const sizeAfterTransform = (width, height, t) => {
    const dimX = width / 2,
      dimY = height / 2,
      points = [new Point(-dimX, -dimY), new Point(dimX, -dimY), new Point(-dimX, dimY), new Point(dimX, dimY)].map(p => p.transform(t)),
      bbox = makeBoundingBoxFromPoints(points);
    return new Point(bbox.width, bbox.height);
  };

  /**
   * We are actually looking for the transformation from the destination plane to the source plane (change of basis matrix)\
   * The object will exist on the destination plane and we want it to seem unchanged by it so we invert the destination matrix (`to`) and then apply the source matrix (`from`)
   * @param [from]
   * @param [to]
   * @returns
   */
  const calcPlaneChangeMatrix = function () {
    let from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : iMatrix;
    let to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : iMatrix;
    return multiplyTransformMatrices(invertTransform(to), from);
  };

  /**
   * Sends a point from the source coordinate plane to the destination coordinate plane.\
   * From the canvas/viewer's perspective the point remains unchanged.
   *
   * @example <caption>Send point from canvas plane to group plane</caption>
   * var obj = new Rect({ left: 20, top: 20, width: 60, height: 60, strokeWidth: 0 });
   * var group = new Group([obj], { strokeWidth: 0 });
   * var sentPoint1 = sendPointToPlane(new Point(50, 50), undefined, group.calcTransformMatrix());
   * var sentPoint2 = sendPointToPlane(new Point(50, 50), iMatrix, group.calcTransformMatrix());
   * console.log(sentPoint1, sentPoint2) //  both points print (0,0) which is the center of group
   *
   * @param {Point} point
   * @param {TMat2D} [from] plane matrix containing object. Passing `undefined` is equivalent to passing the identity matrix, which means `point` exists in the canvas coordinate plane.
   * @param {TMat2D} [to] destination plane matrix to contain object. Passing `undefined` means `point` should be sent to the canvas coordinate plane.
   * @returns {Point} transformed point
   */
  const sendPointToPlane = function (point) {
    let from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : iMatrix;
    let to = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : iMatrix;
    return point.transform(calcPlaneChangeMatrix(from, to));
  };

  /**
   * See {@link sendPointToPlane}
   */
  const sendVectorToPlane = function (point) {
    let from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : iMatrix;
    let to = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : iMatrix;
    return point.transform(calcPlaneChangeMatrix(from, to), true);
  };

  /**
   *
   * A util that abstracts applying transform to objects.\
   * Sends `object` to the destination coordinate plane by applying the relevant transformations.\
   * Changes the space/plane where `object` is drawn.\
   * From the canvas/viewer's perspective `object` remains unchanged.
   *
   * @example <caption>Move clip path from one object to another while preserving it's appearance as viewed by canvas/viewer</caption>
   * let obj, obj2;
   * let clipPath = new Circle({ radius: 50 });
   * obj.clipPath = clipPath;
   * // render
   * sendObjectToPlane(clipPath, obj.calcTransformMatrix(), obj2.calcTransformMatrix());
   * obj.clipPath = undefined;
   * obj2.clipPath = clipPath;
   * // render, clipPath now clips obj2 but seems unchanged from the eyes of the viewer
   *
   * @example <caption>Clip an object's clip path with an existing object</caption>
   * let obj, existingObj;
   * let clipPath = new Circle({ radius: 50 });
   * obj.clipPath = clipPath;
   * let transformTo = multiplyTransformMatrices(obj.calcTransformMatrix(), clipPath.calcTransformMatrix());
   * sendObjectToPlane(existingObj, existingObj.group?.calcTransformMatrix(), transformTo);
   * clipPath.clipPath = existingObj;
   *
   * @param {FabricObject} object
   * @param {Matrix} [from] plane matrix containing object. Passing `undefined` is equivalent to passing the identity matrix, which means `object` is a direct child of canvas.
   * @param {Matrix} [to] destination plane matrix to contain object. Passing `undefined` means `object` should be sent to the canvas coordinate plane.
   * @returns {Matrix} the transform matrix that was applied to `object`
   */
  const sendObjectToPlane = (object, from, to) => {
    const t = calcPlaneChangeMatrix(from, to);
    applyTransformToObject(object, multiplyTransformMatrices(t, object.calcOwnMatrix()));
    return t;
  };

  const fireEvent = (eventName, options) => {
    var _target$canvas;
    const {
      transform: {
        target
      }
    } = options;
    (_target$canvas = target.canvas) === null || _target$canvas === void 0 || _target$canvas.fire("object:".concat(eventName), _objectSpread2(_objectSpread2({}, options), {}, {
      target
    }));
    target.fire(eventName, options);
  };

  const originOffset = {
    left: -0.5,
    top: -0.5,
    center: 0,
    bottom: 0.5,
    right: 0.5
  };
  /**
   * Resolves origin value relative to center
   * @private
   * @param {TOriginX | TOriginY} originValue originX / originY
   * @returns number
   */

  const resolveOrigin = originValue => typeof originValue === 'string' ? originOffset[originValue] : originValue - 0.5;

  const NOT_ALLOWED_CURSOR = 'not-allowed';

  /**
   * @param {Boolean} alreadySelected true if target is already selected
   * @param {String} corner a string representing the corner ml, mr, tl ...
   * @param {Event} e Event object
   * @param {FabricObject} [target] inserted back to help overriding. Unused
   */
  const getActionFromCorner = (alreadySelected, corner, e, target) => {
    if (!corner || !alreadySelected) {
      return 'drag';
    }
    const control = target.controls[corner];
    return control.getActionName(e, control, target);
  };

  /**
   * Checks if transform is centered
   * @param {Object} transform transform data
   * @return {Boolean} true if transform is centered
   */
  function isTransformCentered(transform) {
    return resolveOrigin(transform.originX) === resolveOrigin(CENTER) && resolveOrigin(transform.originY) === resolveOrigin(CENTER);
  }
  function invertOrigin(origin) {
    return -resolveOrigin(origin) + 0.5;
  }
  const isLocked = (target, lockingKey) => target[lockingKey];
  const commonEventInfo = (eventData, transform, x, y) => {
    return {
      e: eventData,
      transform,
      pointer: new Point(x, y)
    };
  };

  /**
   * Combine control position and object angle to find the control direction compared
   * to the object center.
   * @param {FabricObject} fabricObject the fabric object for which we are rendering controls
   * @param {Control} control the control class
   * @return {Number} 0 - 7 a quadrant number
   */
  function findCornerQuadrant(fabricObject, control) {
    //  angle is relative to canvas plane
    const angle = fabricObject.getTotalAngle(),
      cornerAngle = angle + radiansToDegrees(Math.atan2(control.y, control.x)) + 360;
    return Math.round(cornerAngle % 360 / 45);
  }

  /**
   * @returns the normalized point (rotated relative to center) in local coordinates
   */
  function normalizePoint(target, point, originX, originY) {
    const center = target.getRelativeCenterPoint(),
      p = typeof originX !== 'undefined' && typeof originY !== 'undefined' ? target.translateToGivenOrigin(center, CENTER, CENTER, originX, originY) : new Point(target.left, target.top),
      p2 = target.angle ? point.rotate(-degreesToRadians(target.angle), center) : point;
    return p2.subtract(p);
  }

  /**
   * Transforms a point to the offset from the given origin
   * @param {Object} transform
   * @param {String} originX
   * @param {String} originY
   * @param {number} x
   * @param {number} y
   * @return {Fabric.Point} the normalized point
   */
  function getLocalPoint(_ref, originX, originY, x, y) {
    var _target$canvas;
    let {
      target,
      corner
    } = _ref;
    const control = target.controls[corner],
      zoom = ((_target$canvas = target.canvas) === null || _target$canvas === void 0 ? void 0 : _target$canvas.getZoom()) || 1,
      padding = target.padding / zoom,
      localPoint = normalizePoint(target, new Point(x, y), originX, originY);
    if (localPoint.x >= padding) {
      localPoint.x -= padding;
    }
    if (localPoint.x <= -padding) {
      localPoint.x += padding;
    }
    if (localPoint.y >= padding) {
      localPoint.y -= padding;
    }
    if (localPoint.y <= padding) {
      localPoint.y += padding;
    }
    localPoint.x -= control.offsetX;
    localPoint.y -= control.offsetY;
    return localPoint;
  }

  /**
   * Action handler
   * @private
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if the translation occurred
   */
  const dragHandler = (eventData, transform, x, y) => {
    const {
        target,
        offsetX,
        offsetY
      } = transform,
      newLeft = x - offsetX,
      newTop = y - offsetY,
      moveX = !isLocked(target, 'lockMovementX') && target.left !== newLeft,
      moveY = !isLocked(target, 'lockMovementY') && target.top !== newTop;
    moveX && target.set(LEFT, newLeft);
    moveY && target.set(TOP, newTop);
    if (moveX || moveY) {
      fireEvent(MOVING, commonEventInfo(eventData, transform, x, y));
    }
    return moveX || moveY;
  };

  /**
   * Map of the 148 color names with HEX code
   * @see: https://www.w3.org/TR/css3-color/#svg-color
   */
  const ColorNameMap = {
    aliceblue: '#F0F8FF',
    antiquewhite: '#FAEBD7',
    aqua: '#0FF',
    aquamarine: '#7FFFD4',
    azure: '#F0FFFF',
    beige: '#F5F5DC',
    bisque: '#FFE4C4',
    black: '#000',
    blanchedalmond: '#FFEBCD',
    blue: '#00F',
    blueviolet: '#8A2BE2',
    brown: '#A52A2A',
    burlywood: '#DEB887',
    cadetblue: '#5F9EA0',
    chartreuse: '#7FFF00',
    chocolate: '#D2691E',
    coral: '#FF7F50',
    cornflowerblue: '#6495ED',
    cornsilk: '#FFF8DC',
    crimson: '#DC143C',
    cyan: '#0FF',
    darkblue: '#00008B',
    darkcyan: '#008B8B',
    darkgoldenrod: '#B8860B',
    darkgray: '#A9A9A9',
    darkgrey: '#A9A9A9',
    darkgreen: '#006400',
    darkkhaki: '#BDB76B',
    darkmagenta: '#8B008B',
    darkolivegreen: '#556B2F',
    darkorange: '#FF8C00',
    darkorchid: '#9932CC',
    darkred: '#8B0000',
    darksalmon: '#E9967A',
    darkseagreen: '#8FBC8F',
    darkslateblue: '#483D8B',
    darkslategray: '#2F4F4F',
    darkslategrey: '#2F4F4F',
    darkturquoise: '#00CED1',
    darkviolet: '#9400D3',
    deeppink: '#FF1493',
    deepskyblue: '#00BFFF',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1E90FF',
    firebrick: '#B22222',
    floralwhite: '#FFFAF0',
    forestgreen: '#228B22',
    fuchsia: '#F0F',
    gainsboro: '#DCDCDC',
    ghostwhite: '#F8F8FF',
    gold: '#FFD700',
    goldenrod: '#DAA520',
    gray: '#808080',
    grey: '#808080',
    green: '#008000',
    greenyellow: '#ADFF2F',
    honeydew: '#F0FFF0',
    hotpink: '#FF69B4',
    indianred: '#CD5C5C',
    indigo: '#4B0082',
    ivory: '#FFFFF0',
    khaki: '#F0E68C',
    lavender: '#E6E6FA',
    lavenderblush: '#FFF0F5',
    lawngreen: '#7CFC00',
    lemonchiffon: '#FFFACD',
    lightblue: '#ADD8E6',
    lightcoral: '#F08080',
    lightcyan: '#E0FFFF',
    lightgoldenrodyellow: '#FAFAD2',
    lightgray: '#D3D3D3',
    lightgrey: '#D3D3D3',
    lightgreen: '#90EE90',
    lightpink: '#FFB6C1',
    lightsalmon: '#FFA07A',
    lightseagreen: '#20B2AA',
    lightskyblue: '#87CEFA',
    lightslategray: '#789',
    lightslategrey: '#789',
    lightsteelblue: '#B0C4DE',
    lightyellow: '#FFFFE0',
    lime: '#0F0',
    limegreen: '#32CD32',
    linen: '#FAF0E6',
    magenta: '#F0F',
    maroon: '#800000',
    mediumaquamarine: '#66CDAA',
    mediumblue: '#0000CD',
    mediumorchid: '#BA55D3',
    mediumpurple: '#9370DB',
    mediumseagreen: '#3CB371',
    mediumslateblue: '#7B68EE',
    mediumspringgreen: '#00FA9A',
    mediumturquoise: '#48D1CC',
    mediumvioletred: '#C71585',
    midnightblue: '#191970',
    mintcream: '#F5FFFA',
    mistyrose: '#FFE4E1',
    moccasin: '#FFE4B5',
    navajowhite: '#FFDEAD',
    navy: '#000080',
    oldlace: '#FDF5E6',
    olive: '#808000',
    olivedrab: '#6B8E23',
    orange: '#FFA500',
    orangered: '#FF4500',
    orchid: '#DA70D6',
    palegoldenrod: '#EEE8AA',
    palegreen: '#98FB98',
    paleturquoise: '#AFEEEE',
    palevioletred: '#DB7093',
    papayawhip: '#FFEFD5',
    peachpuff: '#FFDAB9',
    peru: '#CD853F',
    pink: '#FFC0CB',
    plum: '#DDA0DD',
    powderblue: '#B0E0E6',
    purple: '#800080',
    rebeccapurple: '#639',
    red: '#F00',
    rosybrown: '#BC8F8F',
    royalblue: '#4169E1',
    saddlebrown: '#8B4513',
    salmon: '#FA8072',
    sandybrown: '#F4A460',
    seagreen: '#2E8B57',
    seashell: '#FFF5EE',
    sienna: '#A0522D',
    silver: '#C0C0C0',
    skyblue: '#87CEEB',
    slateblue: '#6A5ACD',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#FFFAFA',
    springgreen: '#00FF7F',
    steelblue: '#4682B4',
    tan: '#D2B48C',
    teal: '#008080',
    thistle: '#D8BFD8',
    tomato: '#FF6347',
    turquoise: '#40E0D0',
    violet: '#EE82EE',
    wheat: '#F5DEB3',
    white: '#FFF',
    whitesmoke: '#F5F5F5',
    yellow: '#FF0',
    yellowgreen: '#9ACD32'
  };

  /**
   * Regex matching color in RGB or RGBA formats (ex: `rgb(0, 0, 0)`, `rgba(255, 100, 10, 0.5)`, `rgba( 255 , 100 , 10 , 0.5 )`, `rgb(1,1,1)`, `rgba(100%, 60%, 10%, 0.5)`)
   * Also matching rgba(r g b / a) as per new specs
   * https://developer.mozilla.org/en-US/docs/Web/CSS/color_value/rgb
   * Formal syntax at the time of writing:
   * <rgb()> =
   *  rgb( [ <percentage> | none ]{3} [ / [ <alpha-value> | none ] ]? )  |
   *  rgb( [ <number> | none ]{3} [ / [ <alpha-value> | none ] ]? )
   * <alpha-value> = <number> | <percentage>
   *
   * For learners this is how you can read this regex
   * Regular expression for matching an rgba or rgb CSS color value
   *
   * /^          # Beginning of the string
   * rgba?       # "rgb" or "rgba"
   * \(\s*       # Opening parenthesis and optional whitespace
   * (\d{0,3}    # 0 to three digits R channel
   *  (?:\.\d+)? # Optional decimal with one or more digits
   * )           # End of capturing group for the first color component
   * %?          # Optional percent sign after the first color component
   * \s*         # Optional whitespace
   * [\s|,]      # Separator between color components can be a space or comma
   * \s*         # Optional whitespace
   * (\d{0,3}    # 0 to three digits G channel
   *  (?:\.\d+)? # Optional decimal with one or more digits
   * )           # End of capturing group for the second color component
   * %?          # Optional percent sign after the second color component
   * \s*         # Optional whitespace
   * [\s|,]      # Separator between color components can be a space or comma
   * \s*         # Optional whitespace
   * (\d{0,3}    # 0 to three digits B channel
   *  (?:\.\d+)? # Optional decimal with one or more digits
   * )           # End of capturing group for the third color component
   * %?          # Optional percent sign after the third color component
   * \s*         # Optional whitespace
   * (?:         # Beginning of non-capturing group for alpha value
   *  \s*        # Optional whitespace
   *  [,/]       # Comma or slash separator for alpha value
   *  \s*        # Optional whitespace
   *  (\d{0,3}   # Zero to three digits
   *    (?:\.\d+)? # Optional decimal with one or more digits
   *  )          # End of capturing group for alpha value
   *  %?         # Optional percent sign after alpha value
   *  \s*        # Optional whitespace
   * )?          # End of non-capturing group for alpha value (optional)
   * \)          # Closing parenthesis
   * $           # End of the string
   *
   * The alpha channel can be in the format 0.4 .7 or 1 or 73%
   *
   * WARNING this regex doesn't fail on off spec colors. it matches everything that could be a color.
   * So the spec does not allow for `rgba(30 , 45%  35, 49%)` but this will work anyways for us
   */
  const reRGBa = () => /^rgba?\(\s*(\d{0,3}(?:\.\d+)?%?)\s*[\s|,]\s*(\d{0,3}(?:\.\d+)?%?)\s*[\s|,]\s*(\d{0,3}(?:\.\d+)?%?)\s*(?:\s*[,/]\s*(\d{0,3}(?:\.\d+)?%?)\s*)?\)$/i;

  /**
   * Regex matching color in HSL or HSLA formats (ex: hsl(0, 0, 0), rgba(255, 100, 10, 0.5), rgba( 255 , 100 , 10 , 0.5 ), rgb(1,1,1), rgba(100%, 60%, 10%, 0.5))
   * Also matching rgba(r g b / a) as per new specs
   * https://developer.mozilla.org/en-US/docs/Web/CSS/color_value/hsl
   * Formal syntax at the time of writing:
   * <hsl()> =
   *   hsl( [ <hue> | none ] [ <percentage> | none ] [ <percentage> | none ] [ / [ <alpha-value> | none ] ]? )
   *
   * <hue> =
   *   <number>  |
   *   <angle>
   *
   * <alpha-value> =
   *   <number>      |
   *   <percentage>
   *
   * For learners this is how you can read this regex
   * Regular expression for matching an hsla or hsl CSS color value
   *
   * /^hsla?\(         // Matches the beginning of the string and the opening parenthesis of "hsl" or "hsla"
   * \s*               // Matches any whitespace characters (space, tab, etc.) zero or more times
   * (\d{0,3}          // Hue: 0 to three digits - start capture in a group
   * (?:\.\d+)?        // Hue: Optional (non capture group) decimal with one or more digits.
   * (?:deg|turn|rad)? // Hue: Optionally include suffix deg or turn or rad
   * )                 // Hue: End capture group
   * \s*               // Matches any whitespace characters zero or more times
   * [\s|,]            // Matches a space, tab or comma
   * \s*               // Matches any whitespace characters zero or more times
   * (\d{0,3}          // Saturation: 0 to three digits - start capture in a group
   * (?:\.\d+)?        // Saturation: Optional decimal with one or more digits in a non-capturing group
   * %?)               // Saturation: match optional % character and end capture group
   * \s*               // Matches any whitespace characters zero or more times
   * [\s|,]            // Matches a space, tab or comma
   * \s*               // Matches any whitespace characters zero or more times
   * (\d{0,3}          // Lightness: 0 to three digits - start capture in a group
   * (?:\.\d+)?        // Lightness: Optional decimal with one or more digits in a non-capturing group
   * %?)                // Lightness: match % character and end capture group
   * \s*               // Matches any whitespace characters zero or more times
   * (?:               // Alpha: Begins a non-capturing group for the alpha value
   *   \s*             // Matches any whitespace characters zero or more times
   *   [,/]            // Matches a comma or forward slash
   *   \s*             // Matches any whitespace characters zero or more times
   *   (\d*(?:\.\d+)?%?) // Matches zero or more digits, optionally followed by a decimal point and one or more digits, followed by an optional percentage sign and captures it in a group
   *   \s*             // Matches any whitespace characters zero or more times
   * )?                // Makes the alpha value group optional
   * \)                // Matches the closing parenthesis
   * $/i               // Matches the end of the string and sets the regular expression to case-insensitive mode
   *
   * WARNING this regex doesn't fail on off spec colors. It matches everything that could be a color.
   * So the spec does not allow `hsl(30 , 45%  35, 49%)` but this will work anyways for us.
   */
  const reHSLa = () => /^hsla?\(\s*([+-]?\d{0,3}(?:\.\d+)?(?:deg|turn|rad)?)\s*[\s|,]\s*(\d{0,3}(?:\.\d+)?%?)\s*[\s|,]\s*(\d{0,3}(?:\.\d+)?%?)\s*(?:\s*[,/]\s*(\d*(?:\.\d+)?%?)\s*)?\)$/i;

  /**
   * Regex matching color in HEX format (ex: #FF5544CC, #FF5555, 010155, aff)
   */
  const reHex = () => /^#?(([0-9a-f]){3,4}|([0-9a-f]{2}){3,4})$/i;

  /**
   * @param {Number} p
   * @param {Number} q
   * @param {Number} t
   * @return {Number}
   */
  const hue2rgb = (p, q, t) => {
    if (t < 0) {
      t += 1;
    }
    if (t > 1) {
      t -= 1;
    }
    if (t < 1 / 6) {
      return p + (q - p) * 6 * t;
    }
    if (t < 1 / 2) {
      return q;
    }
    if (t < 2 / 3) {
      return p + (q - p) * (2 / 3 - t) * 6;
    }
    return p;
  };

  /**
   * Adapted from {@link https://gist.github.com/mjackson/5311256 https://gist.github.com/mjackson}
   * @param {Number} r Red color value
   * @param {Number} g Green color value
   * @param {Number} b Blue color value
   * @param {Number} a Alpha color value pass through
   * @return {TRGBColorSource} Hsl color
   */
  const rgb2Hsl = (r, g, b, a) => {
    r /= 255;
    g /= 255;
    b /= 255;
    const maxValue = Math.max(r, g, b),
      minValue = Math.min(r, g, b);
    let h, s;
    const l = (maxValue + minValue) / 2;
    if (maxValue === minValue) {
      h = s = 0; // achromatic
    } else {
      const d = maxValue - minValue;
      s = l > 0.5 ? d / (2 - maxValue - minValue) : d / (maxValue + minValue);
      switch (maxValue) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }
    return [Math.round(h * 360), Math.round(s * 100), Math.round(l * 100), a];
  };
  const fromAlphaToFloat = function () {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '1';
    return parseFloat(value) / (value.endsWith('%') ? 100 : 1);
  };

  /**
   * Convert a value in the inclusive range [0, 255] to hex
   */
  const hexify = value => Math.min(Math.round(value), 255).toString(16).toUpperCase().padStart(2, '0');

  /**
   * Calculate the grey average value for rgb and pass through alpha
   */
  const greyAverage = _ref => {
    let [r, g, b, a = 1] = _ref;
    const avg = Math.round(r * 0.3 + g * 0.59 + b * 0.11);
    return [avg, avg, avg, a];
  };

  /**
   * @class Color common color operations
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2/#colors colors}
   */
  class Color {
    /**
     *
     * @param {string} [color] optional in hex or rgb(a) or hsl format or from known color list
     */
    constructor(color) {
      _defineProperty(this, "isUnrecognised", false);
      if (!color) {
        // we default to black as canvas does
        this.setSource([0, 0, 0, 1]);
      } else if (color instanceof Color) {
        this.setSource([...color._source]);
      } else if (Array.isArray(color)) {
        const [r, g, b, a = 1] = color;
        this.setSource([r, g, b, a]);
      } else {
        this.setSource(this._tryParsingColor(color));
      }
    }

    /**
     * @private
     * @param {string} [color] Color value to parse
     * @returns {TRGBAColorSource}
     */
    _tryParsingColor(color) {
      color = color.toLowerCase();
      if (color in ColorNameMap) {
        color = ColorNameMap[color];
      }
      return color === 'transparent' ? [255, 255, 255, 0] : Color.sourceFromHex(color) || Color.sourceFromRgb(color) || Color.sourceFromHsl(color) ||
      // color is not recognized
      // we default to black as canvas does
      // eslint-disable-next-line no-constant-binary-expression
      (this.isUnrecognised = true) && [0, 0, 0, 1];
    }

    /**
     * Returns source of this color (where source is an array representation; ex: [200, 200, 100, 1])
     * @return {TRGBAColorSource}
     */
    getSource() {
      return this._source;
    }

    /**
     * Sets source of this color (where source is an array representation; ex: [200, 200, 100, 1])
     * @param {TRGBAColorSource} source
     */
    setSource(source) {
      this._source = source;
    }

    /**
     * Returns color representation in RGB format
     * @return {String} ex: rgb(0-255,0-255,0-255)
     */
    toRgb() {
      const [r, g, b] = this.getSource();
      return "rgb(".concat(r, ",").concat(g, ",").concat(b, ")");
    }

    /**
     * Returns color representation in RGBA format
     * @return {String} ex: rgba(0-255,0-255,0-255,0-1)
     */
    toRgba() {
      return "rgba(".concat(this.getSource().join(','), ")");
    }

    /**
     * Returns color representation in HSL format
     * @return {String} ex: hsl(0-360,0%-100%,0%-100%)
     */
    toHsl() {
      const [h, s, l] = rgb2Hsl(...this.getSource());
      return "hsl(".concat(h, ",").concat(s, "%,").concat(l, "%)");
    }

    /**
     * Returns color representation in HSLA format
     * @return {String} ex: hsla(0-360,0%-100%,0%-100%,0-1)
     */
    toHsla() {
      const [h, s, l, a] = rgb2Hsl(...this.getSource());
      return "hsla(".concat(h, ",").concat(s, "%,").concat(l, "%,").concat(a, ")");
    }

    /**
     * Returns color representation in HEX format
     * @return {String} ex: FF5555
     */
    toHex() {
      const fullHex = this.toHexa();
      return fullHex.slice(0, 6);
    }

    /**
     * Returns color representation in HEXA format
     * @return {String} ex: FF5555CC
     */
    toHexa() {
      const [r, g, b, a] = this.getSource();
      return "".concat(hexify(r)).concat(hexify(g)).concat(hexify(b)).concat(hexify(Math.round(a * 255)));
    }

    /**
     * Gets value of alpha channel for this color
     * @return {Number} 0-1
     */
    getAlpha() {
      return this.getSource()[3];
    }

    /**
     * Sets value of alpha channel for this color
     * @param {Number} alpha Alpha value 0-1
     * @return {Color} thisArg
     */
    setAlpha(alpha) {
      this._source[3] = alpha;
      return this;
    }

    /**
     * Transforms color to its grayscale representation
     * @return {Color} thisArg
     */
    toGrayscale() {
      this.setSource(greyAverage(this.getSource()));
      return this;
    }

    /**
     * Transforms color to its black and white representation
     * @param {Number} threshold
     * @return {Color} thisArg
     */
    toBlackWhite(threshold) {
      const [average,,, a] = greyAverage(this.getSource()),
        bOrW = average < (threshold || 127) ? 0 : 255;
      this.setSource([bOrW, bOrW, bOrW, a]);
      return this;
    }

    /**
     * Overlays color with another color
     * @param {String|Color} otherColor
     * @return {Color} thisArg
     */
    overlayWith(otherColor) {
      if (!(otherColor instanceof Color)) {
        otherColor = new Color(otherColor);
      }
      const source = this.getSource(),
        otherAlpha = 0.5,
        otherSource = otherColor.getSource(),
        [R, G, B] = source.map((value, index) => Math.round(value * (1 - otherAlpha) + otherSource[index] * otherAlpha));
      this.setSource([R, G, B, source[3]]);
      return this;
    }

    /**
     * Returns new color object, when given a color in RGB format
     * @memberOf Color
     * @param {String} color Color value ex: rgb(0-255,0-255,0-255)
     * @return {Color}
     */
    static fromRgb(color) {
      return Color.fromRgba(color);
    }

    /**
     * Returns new color object, when given a color in RGBA format
     * @static
     * @function
     * @memberOf Color
     * @param {String} color
     * @return {Color}
     */
    static fromRgba(color) {
      return new Color(Color.sourceFromRgb(color));
    }

    /**
     * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in RGB or RGBA format
     * @memberOf Color
     * @param {String} color Color value ex: rgb(0-255,0-255,0-255), rgb(0%-100%,0%-100%,0%-100%)
     * @return {TRGBAColorSource | undefined} source
     */
    static sourceFromRgb(color) {
      const match = color.match(reRGBa());
      if (match) {
        const [r, g, b] = match.slice(1, 4).map(value => {
          const parsedValue = parseFloat(value);
          return value.endsWith('%') ? Math.round(parsedValue * 2.55) : parsedValue;
        });
        return [r, g, b, fromAlphaToFloat(match[4])];
      }
    }

    /**
     * Returns new color object, when given a color in HSL format
     * @param {String} color Color value ex: hsl(0-260,0%-100%,0%-100%)
     * @memberOf Color
     * @return {Color}
     */
    static fromHsl(color) {
      return Color.fromHsla(color);
    }

    /**
     * Returns new color object, when given a color in HSLA format
     * @static
     * @function
     * @memberOf Color
     * @param {String} color
     * @return {Color}
     */
    static fromHsla(color) {
      return new Color(Color.sourceFromHsl(color));
    }

    /**
     * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in HSL or HSLA format.
     * Adapted from <a href="https://rawgithub.com/mjijackson/mjijackson.github.com/master/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript.html">https://github.com/mjijackson</a>
     * @memberOf Color
     * @param {String} color Color value ex: hsl(0-360,0%-100%,0%-100%) or hsla(0-360,0%-100%,0%-100%, 0-1)
     * @return {TRGBAColorSource | undefined} source
     * @see http://http://www.w3.org/TR/css3-color/#hsl-color
     */
    static sourceFromHsl(color) {
      const match = color.match(reHSLa());
      if (!match) {
        return;
      }
      const match1degrees = Color.parseAngletoDegrees(match[1]);
      const h = (match1degrees % 360 + 360) % 360 / 360,
        s = parseFloat(match[2]) / 100,
        l = parseFloat(match[3]) / 100;
      let r, g, b;
      if (s === 0) {
        r = g = b = l;
      } else {
        const q = l <= 0.5 ? l * (s + 1) : l + s - l * s,
          p = l * 2 - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
      }
      return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255), fromAlphaToFloat(match[4])];
    }

    /**
     * Returns new color object, when given a color in HEX format
     * @static
     * @memberOf Color
     * @param {String} color Color value ex: FF5555
     * @return {Color}
     */
    static fromHex(color) {
      return new Color(Color.sourceFromHex(color));
    }

    /**
     * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in HEX format
     * @static
     * @memberOf Color
     * @param {String} color ex: FF5555 or FF5544CC (RGBa)
     * @return {TRGBAColorSource | undefined} source
     */
    static sourceFromHex(color) {
      if (color.match(reHex())) {
        const value = color.slice(color.indexOf('#') + 1),
          isShortNotation = value.length <= 4;
        let expandedValue;
        if (isShortNotation) {
          expandedValue = value.split('').map(hex => hex + hex);
        } else {
          expandedValue = value.match(/.{2}/g);
        }
        const [r, g, b, a = 255] = expandedValue.map(hexCouple => parseInt(hexCouple, 16));
        return [r, g, b, a / 255];
      }
    }

    /**
     * Converts a string that could be any angle notation (50deg, 0.5turn, 2rad)
     * into degrees without the 'deg' suffix
     * @static
     * @memberOf Color
     * @param {String} value ex: 0deg, 0.5turn, 2rad
     * @return {Number} number in degrees or NaN if inputs are invalid
     */
    static parseAngletoDegrees(value) {
      const lowercase = value.toLowerCase();
      const numeric = parseFloat(lowercase);
      if (lowercase.includes('rad')) {
        return radiansToDegrees(numeric);
      }
      if (lowercase.includes('turn')) {
        return numeric * 360;
      }

      // Value is probably just a number already in degrees eg '50'
      return numeric;
    }
  }

  /**
   * Returns array of attributes for given svg that fabric parses
   * @param {SVGElementName} type Type of svg element (eg. 'circle')
   * @return {Array} string names of supported attributes
   */
  const getSvgAttributes = type => {
    const commonAttributes = ['instantiated_by_use', 'style', 'id', 'class'];
    switch (type) {
      case 'linearGradient':
        return commonAttributes.concat(['x1', 'y1', 'x2', 'y2', 'gradientUnits', 'gradientTransform']);
      case 'radialGradient':
        return commonAttributes.concat(['gradientUnits', 'gradientTransform', 'cx', 'cy', 'r', 'fx', 'fy', 'fr']);
      case 'stop':
        return commonAttributes.concat(['offset', 'stop-color', 'stop-opacity']);
    }
    return commonAttributes;
  };

  /**
   * Converts from attribute value to pixel value if applicable.
   * Returns converted pixels or original value not converted.
   * @param {string} value number to operate on
   * @param {number} fontSize
   * @return {number}
   */
  const parseUnit = function (value) {
    let fontSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_SVG_FONT_SIZE;
    const unit = /\D{0,2}$/.exec(value),
      number = parseFloat(value);
    const dpi = config.DPI;
    switch (unit === null || unit === void 0 ? void 0 : unit[0]) {
      case 'mm':
        return number * dpi / 25.4;
      case 'cm':
        return number * dpi / 2.54;
      case 'in':
        return number * dpi;
      case 'pt':
        return number * dpi / 72;
      // or * 4 / 3

      case 'pc':
        return number * dpi / 72 * 12;
      // or * 16

      case 'em':
        return number * fontSize;
      default:
        return number;
    }
  };
  // align can be either none or undefined or a combination of mid/max
  const parseAlign = align => {
    //divide align in alignX and alignY
    if (align && align !== NONE) {
      return [align.slice(1, 4), align.slice(5, 8)];
    } else if (align === NONE) {
      return [align, align];
    }
    return ['Mid', 'Mid'];
  };

  /**
   * Parse preserveAspectRatio attribute from element
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/preserveAspectRatio
   * @param {string} attribute to be parsed
   * @return {Object} an object containing align and meetOrSlice attribute
   */
  const parsePreserveAspectRatioAttribute = attribute => {
    const [firstPart, secondPart] = attribute.trim().split(' ');
    const [alignX, alignY] = parseAlign(firstPart);
    return {
      meetOrSlice: secondPart || 'meet',
      alignX,
      alignY
    };
  };

  /**
   * Adobe Illustrator (at least CS5) is unable to render rgba()-based fill values
   * we work around it by "moving" alpha channel into opacity attribute and setting fill's alpha to 1
   * @param prop
   * @param value
   * @param {boolean} inlineStyle The default is inline style, the separator used is ":", The other is "="
   * @returns
   */
  const colorPropToSVG = function (prop, value) {
    let inlineStyle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    let colorValue;
    let opacityValue;
    if (!value) {
      colorValue = 'none';
    } else if (value.toLive) {
      colorValue = "url(#SVGID_".concat(value.id, ")");
    } else {
      const color = new Color(value),
        opacity = color.getAlpha();
      colorValue = color.toRgb();
      if (opacity !== 1) {
        opacityValue = opacity.toString();
      }
    }
    if (inlineStyle) {
      return "".concat(prop, ": ").concat(colorValue, "; ").concat(opacityValue ? "".concat(prop, "-opacity: ").concat(opacityValue, "; ") : '');
    } else {
      return "".concat(prop, "=\"").concat(colorValue, "\" ").concat(opacityValue ? "".concat(prop, "-opacity=\"").concat(opacityValue, "\" ") : '');
    }
  };
  const createSVGRect = function (color, _ref) {
    let {
      left,
      top,
      width,
      height
    } = _ref;
    let precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : config.NUM_FRACTION_DIGITS;
    const svgColor = colorPropToSVG(FILL, color, false);
    const [x, y, w, h] = [left, top, width, height].map(value => toFixed(value, precision));
    return "<rect ".concat(svgColor, " x=\"").concat(x, "\" y=\"").concat(y, "\" width=\"").concat(w, "\" height=\"").concat(h, "\"></rect>");
  };

  class FabricObjectSVGExportMixin {
    /**
     * When an object is being exported as SVG as a clippath, a reference inside the SVG is needed.
     * This reference is a UID in the fabric namespace and is temporary stored here.
     * @type {String}
     */

    /**
     * Returns styles-string for svg-export
     * @param {Boolean} skipShadow a boolean to skip shadow filter output
     * @return {String}
     */
    getSvgStyles(skipShadow) {
      const fillRule = this.fillRule ? this.fillRule : 'nonzero',
        strokeWidth = this.strokeWidth ? this.strokeWidth : '0',
        strokeDashArray = this.strokeDashArray ? this.strokeDashArray.join(' ') : NONE,
        strokeDashOffset = this.strokeDashOffset ? this.strokeDashOffset : '0',
        strokeLineCap = this.strokeLineCap ? this.strokeLineCap : 'butt',
        strokeLineJoin = this.strokeLineJoin ? this.strokeLineJoin : 'miter',
        strokeMiterLimit = this.strokeMiterLimit ? this.strokeMiterLimit : '4',
        opacity = typeof this.opacity !== 'undefined' ? this.opacity : '1',
        visibility = this.visible ? '' : ' visibility: hidden;',
        filter = skipShadow ? '' : this.getSvgFilter(),
        fill = colorPropToSVG(FILL, this.fill),
        stroke = colorPropToSVG(STROKE, this.stroke);
      return [stroke, 'stroke-width: ', strokeWidth, '; ', 'stroke-dasharray: ', strokeDashArray, '; ', 'stroke-linecap: ', strokeLineCap, '; ', 'stroke-dashoffset: ', strokeDashOffset, '; ', 'stroke-linejoin: ', strokeLineJoin, '; ', 'stroke-miterlimit: ', strokeMiterLimit, '; ', fill, 'fill-rule: ', fillRule, '; ', 'opacity: ', opacity, ';', filter, visibility].join('');
    }

    /**
     * Returns filter for svg shadow
     * @return {String}
     */
    getSvgFilter() {
      return this.shadow ? "filter: url(#SVGID_".concat(this.shadow.id, ");") : '';
    }

    /**
     * Returns id attribute for svg output
     * @return {String}
     */
    getSvgCommons() {
      return [this.id ? "id=\"".concat(this.id, "\" ") : '', this.clipPath ? "clip-path=\"url(#".concat(this.clipPath.clipPathId, ")\" ") : ''].join('');
    }

    /**
     * Returns transform-string for svg-export
     * @param {Boolean} use the full transform or the single object one.
     * @return {String}
     */
    getSvgTransform(full) {
      let additionalTransform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      const transform = full ? this.calcTransformMatrix() : this.calcOwnMatrix(),
        svgTransform = "transform=\"".concat(matrixToSVG(transform));
      return "".concat(svgTransform).concat(additionalTransform, "\" ");
    }

    /**
     * Returns svg representation of an instance
     * This function is implemented in each subclass
     * This is just because typescript otherwise cryies all the time
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG(_reviver) {
      return [''];
    }

    /**
     * Returns svg representation of an instance
     * @param {TSVGReviver} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    toSVG(reviver) {
      return this._createBaseSVGMarkup(this._toSVG(reviver), {
        reviver
      });
    }

    /**
     * Returns svg clipPath representation of an instance
     * @param {TSVGReviver} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    toClipPathSVG(reviver) {
      return '\t' + this._createBaseClipPathSVGMarkup(this._toSVG(reviver), {
        reviver
      });
    }

    /**
     * @private
     */
    _createBaseClipPathSVGMarkup(objectMarkup) {
      let {
        reviver,
        additionalTransform = ''
      } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      const commonPieces = [this.getSvgTransform(true, additionalTransform), this.getSvgCommons()].join(''),
        // insert commons in the markup, style and svgCommons
        index = objectMarkup.indexOf('COMMON_PARTS');
      objectMarkup[index] = commonPieces;
      return reviver ? reviver(objectMarkup.join('')) : objectMarkup.join('');
    }

    /**
     * @private
     */
    _createBaseSVGMarkup(objectMarkup) {
      let {
        noStyle,
        reviver,
        withShadow,
        additionalTransform
      } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      const styleInfo = noStyle ? '' : "style=\"".concat(this.getSvgStyles(), "\" "),
        shadowInfo = withShadow ? "style=\"".concat(this.getSvgFilter(), "\" ") : '',
        clipPath = this.clipPath,
        vectorEffect = this.strokeUniform ? 'vector-effect="non-scaling-stroke" ' : '',
        absoluteClipPath = clipPath && clipPath.absolutePositioned,
        stroke = this.stroke,
        fill = this.fill,
        shadow = this.shadow,
        markup = [],
        // insert commons in the markup, style and svgCommons
        index = objectMarkup.indexOf('COMMON_PARTS');
      let clipPathMarkup;
      if (clipPath) {
        clipPath.clipPathId = "CLIPPATH_".concat(uid());
        clipPathMarkup = "<clipPath id=\"".concat(clipPath.clipPathId, "\" >\n").concat(clipPath.toClipPathSVG(reviver), "</clipPath>\n");
      }
      if (absoluteClipPath) {
        markup.push('<g ', shadowInfo, this.getSvgCommons(), ' >\n');
      }
      markup.push('<g ', this.getSvgTransform(false), !absoluteClipPath ? shadowInfo + this.getSvgCommons() : '', ' >\n');
      const commonPieces = [styleInfo, vectorEffect, noStyle ? '' : this.addPaintOrder(), ' ', additionalTransform ? "transform=\"".concat(additionalTransform, "\" ") : ''].join('');
      objectMarkup[index] = commonPieces;
      if (isFiller(fill)) {
        markup.push(fill.toSVG(this));
      }
      if (isFiller(stroke)) {
        markup.push(stroke.toSVG(this));
      }
      if (shadow) {
        markup.push(shadow.toSVG(this));
      }
      if (clipPath) {
        markup.push(clipPathMarkup);
      }
      markup.push(objectMarkup.join(''));
      markup.push('</g>\n');
      absoluteClipPath && markup.push('</g>\n');
      return reviver ? reviver(markup.join('')) : markup.join('');
    }
    addPaintOrder() {
      return this.paintFirst !== FILL ? " paint-order=\"".concat(this.paintFirst, "\" ") : '';
    }
  }

  function getSvgRegex(arr) {
    return new RegExp('^(' + arr.join('|') + ')\\b', 'i');
  }

  const TEXT_DECORATION_THICKNESS = 'textDecorationThickness';
  const fontProperties = ['fontSize', 'fontWeight', 'fontFamily', 'fontStyle'];
  const textDecorationProperties = ['underline', 'overline', 'linethrough'];
  const textLayoutProperties = [...fontProperties, 'lineHeight', 'text', 'charSpacing', 'textAlign', 'styles', 'path', 'pathStartOffset', 'pathSide', 'pathAlign'];
  const additionalProps = [...textLayoutProperties, ...textDecorationProperties, 'textBackgroundColor', 'direction', TEXT_DECORATION_THICKNESS];
  const styleProperties = [...fontProperties, ...textDecorationProperties, STROKE, 'strokeWidth', FILL, 'deltaY', 'textBackgroundColor', TEXT_DECORATION_THICKNESS];

  // @TODO: Many things here are configuration related and shouldn't be on the class nor prototype
  // regexes, list of properties that are not suppose to change by instances, magic consts.
  // this will be a separated effort
  const textDefaultValues = {
    _reNewline: reNewline,
    _reSpacesAndTabs: /[ \t\r]/g,
    _reSpaceAndTab: /[ \t\r]/,
    _reWords: /\S+/g,
    fontSize: 40,
    fontWeight: 'normal',
    fontFamily: 'Times New Roman',
    underline: false,
    overline: false,
    linethrough: false,
    textAlign: LEFT,
    fontStyle: 'normal',
    lineHeight: 1.16,
    textBackgroundColor: '',
    stroke: null,
    shadow: null,
    path: undefined,
    pathStartOffset: 0,
    pathSide: LEFT,
    pathAlign: 'baseline',
    charSpacing: 0,
    deltaY: 0,
    direction: 'ltr',
    CACHE_FONT_SIZE: 400,
    MIN_TEXT_WIDTH: 2,
    // Text magic numbers
    superscript: {
      size: 0.6,
      // fontSize factor
      baseline: -0.35 // baseline-shift factor (upwards)
    },
    subscript: {
      size: 0.6,
      // fontSize factor
      baseline: 0.11 // baseline-shift factor (downwards)
    },
    _fontSizeFraction: 0.222,
    offsets: {
      underline: 0.1,
      linethrough: -0.28167,
      // added 1/30 to original number
      overline: -0.81333 // added 1/15 to original number
    },
    _fontSizeMult: 1.13,
    [TEXT_DECORATION_THICKNESS]: 66.667 // before implementation was 1/15
  };
  const JUSTIFY = 'justify';
  const JUSTIFY_LEFT = 'justify-left';
  const JUSTIFY_RIGHT = 'justify-right';
  const JUSTIFY_CENTER = 'justify-center';

  var _templateObject$1, _templateObject2$1, _templateObject3$1;

  // matches, e.g.: +14.56e-12, etc.
  const reNum = String.raw(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["[-+]?(?:d*.d+|d+.?)(?:[eE][-+]?d+)?"], ["[-+]?(?:\\d*\\.\\d+|\\d+\\.?)(?:[eE][-+]?\\d+)?"])));
  const viewportSeparator = String.raw(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["(?:s*,?s+|s*,s*)"], ["(?:\\s*,?\\s+|\\s*,\\s*)"])));
  const svgNS = 'http://www.w3.org/2000/svg';
  const reFontDeclaration = new RegExp('(normal|italic)?\\s*(normal|small-caps)?\\s*' + '(normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900)?\\s*(' + reNum + '(?:px|cm|mm|em|pt|pc|in)*)(?:\\/(normal|' + reNum + '))?\\s+(.*)');
  const svgValidTagNames = ['path', 'circle', 'polygon', 'polyline', 'ellipse', 'rect', 'line', 'image', 'text'],
    svgViewBoxElements = ['symbol', 'image', 'marker', 'pattern', 'view', 'svg'],
    svgInvalidAncestors = ['pattern', 'defs', 'symbol', 'metadata', 'clipPath', 'mask', 'desc'],
    svgValidParents = ['symbol', 'g', 'a', 'svg', 'clipPath', 'defs'],
    attributesMap = {
      cx: LEFT,
      x: LEFT,
      r: 'radius',
      cy: TOP,
      y: TOP,
      display: 'visible',
      visibility: 'visible',
      transform: 'transformMatrix',
      'fill-opacity': 'fillOpacity',
      'fill-rule': 'fillRule',
      'font-family': 'fontFamily',
      'font-size': 'fontSize',
      'font-style': 'fontStyle',
      'font-weight': 'fontWeight',
      'letter-spacing': 'charSpacing',
      'paint-order': 'paintFirst',
      'stroke-dasharray': 'strokeDashArray',
      'stroke-dashoffset': 'strokeDashOffset',
      'stroke-linecap': 'strokeLineCap',
      'stroke-linejoin': 'strokeLineJoin',
      'stroke-miterlimit': 'strokeMiterLimit',
      'stroke-opacity': 'strokeOpacity',
      'stroke-width': 'strokeWidth',
      'text-decoration': 'textDecoration',
      'text-anchor': 'textAnchor',
      opacity: 'opacity',
      'clip-path': 'clipPath',
      'clip-rule': 'clipRule',
      'vector-effect': 'strokeUniform',
      'image-rendering': 'imageSmoothing',
      'text-decoration-thickness': TEXT_DECORATION_THICKNESS
    },
    fSize = 'font-size',
    cPath = 'clip-path';
  const svgValidTagNamesRegEx = getSvgRegex(svgValidTagNames);
  const svgViewBoxElementsRegEx = getSvgRegex(svgViewBoxElements);
  const svgValidParentsRegEx = getSvgRegex(svgValidParents);

  // http://www.w3.org/TR/SVG/coords.html#ViewBoxAttribute

  const reViewBoxAttrValue = new RegExp(String.raw(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["^s*(", ")", "(", ")", "(", ")", "(", ")s*$"], ["^\\s*(", ")", "(", ")", "(", ")", "(", ")\\s*$"])), reNum, viewportSeparator, reNum, viewportSeparator, reNum, viewportSeparator, reNum));

  const unitVectorX = new Point(1, 0);
  const zero = new Point();

  /**
   * Rotates `vector` with `radians`
   * @param {Point} vector The vector to rotate (x and y)
   * @param {Number} radians The radians of the angle for the rotation
   * @return {Point} The new rotated point
   */
  const rotateVector = (vector, radians) => vector.rotate(radians);

  /**
   * Creates a vector from points represented as a point
   *
   * @param {Point} from
   * @param {Point} to
   * @returns {Point} vector
   */
  const createVector = (from, to) => new Point(to).subtract(from);

  /**
   * return the magnitude of a vector
   * @return {number}
   */
  const magnitude = point => point.distanceFrom(zero);

  /**
   * Calculates the angle between 2 vectors
   * @param {Point} a
   * @param {Point} b
   * @returns the angle in radians from `a` to `b`
   */
  const calcAngleBetweenVectors = (a, b) => Math.atan2(crossProduct(a, b), dotProduct(a, b));

  /**
   * Calculates the angle between the x axis and the vector
   * @param {Point} v
   * @returns the angle in radians of `v`
   */
  const calcVectorRotation = v => calcAngleBetweenVectors(unitVectorX, v);

  /**
   * @param {Point} v
   * @returns {Point} vector representing the unit vector pointing to the direction of `v`
   */
  const getUnitVector = v => v.eq(zero) ? v : v.scalarDivide(magnitude(v));

  /**
   * @param {Point} v
   * @param {Boolean} [counterClockwise] the direction of the orthogonal vector, defaults to `true`
   * @returns {Point} the unit orthogonal vector
   */
  const getOrthonormalVector = function (v) {
    let counterClockwise = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return getUnitVector(new Point(-v.y, v.x).scalarMultiply(counterClockwise ? 1 : -1));
  };

  /**
   * Cross product of two vectors in 2D
   * @param {Point} a
   * @param {Point} b
   * @returns {number} the magnitude of Z vector
   */
  const crossProduct = (a, b) => a.x * b.y - a.y * b.x;

  /**
   * Dot product of two vectors in 2D
   * @param {Point} a
   * @param {Point} b
   * @returns {number}
   */
  const dotProduct = (a, b) => a.x * b.x + a.y * b.y;

  /**
   * Checks if the vector is between two others. It is considered
   * to be inside when the vector to be tested is between the
   * initial vector and the final vector (included) in a counterclockwise direction.
   * @param {Point} t vector to be tested
   * @param {Point} a initial vector
   * @param {Point} b final vector
   * @returns {boolean} true if the vector is among the others
   */
  const isBetweenVectors = (t, a, b) => {
    if (t.eq(a) || t.eq(b)) return true;
    const AxB = crossProduct(a, b),
      AxT = crossProduct(a, t),
      BxT = crossProduct(b, t);
    return AxB >= 0 ? AxT >= 0 && BxT <= 0 : !(AxT <= 0 && BxT >= 0);
  };

  /**
     * Regex matching shadow offsetX, offsetY and blur (ex: "2px 2px 10px rgba(0,0,0,0.2)", "rgb(0,255,0) 2px 2px")
     * - (?:\s|^): This part captures either a whitespace character (\s) or the beginning of a line (^). It's non-capturing (due to (?:...)), meaning it doesn't create a capturing group.
     * - (-?\d+(?:\.\d*)?(?:px)?(?:\s?|$))?: This captures the first component of the shadow, which is the horizontal offset. Breaking it down:
     *   - (-?\d+): Captures an optional minus sign followed by one or more digits (integer part of the number).
     *   - (?:\.\d*)?: Optionally captures a decimal point followed by zero or more digits (decimal part of the number).
     *   - (?:px)?: Optionally captures the "px" unit.
     *   - (?:\s?|$): Captures either an optional whitespace or the end of the line. This whole part is wrapped in a non-capturing group and marked as optional with ?.
     * - (-?\d+(?:\.\d*)?(?:px)?(?:\s?|$))?: Similar to the previous step, this captures the vertical offset.

  (\d+(?:\.\d*)?(?:px)?)?: This captures the blur radius. It's similar to the horizontal offset but without the optional minus sign.

  (?:\s+(-?\d+(?:\.\d*)?(?:px)?(?:\s?|$))?){0,1}: This captures an optional part for the color. It allows for whitespace followed by a component with an optional minus sign, digits, decimal point, and "px" unit.

  (?:$|\s): This captures either the end of the line or a whitespace character. It ensures that the match ends either at the end of the string or with a whitespace character.
     */
  // eslint-disable-next-line max-len

  const shadowOffsetRegex = '(-?\\d+(?:\\.\\d*)?(?:px)?(?:\\s?|$))?';
  const reOffsetsAndBlur = new RegExp('(?:\\s|^)' + shadowOffsetRegex + shadowOffsetRegex + '(' + reNum + '?(?:px)?)?(?:\\s?|$)(?:$|\\s)');
  const shadowDefaultValues = {
    color: 'rgb(0,0,0)',
    blur: 0,
    offsetX: 0,
    offsetY: 0,
    affectStroke: false,
    includeDefaultValues: true,
    nonScaling: false
  };
  class Shadow {
    /**
     * @see {@link http://fabricjs.com/shadows|Shadow demo}
     * @param {Object|String} [options] Options object with any of color, blur, offsetX, offsetY properties or string (e.g. "rgba(0,0,0,0.2) 2px 2px 10px")
     */

    constructor(arg0) {
      const options = typeof arg0 === 'string' ? Shadow.parseShadow(arg0) : arg0;
      Object.assign(this, Shadow.ownDefaults, options);
      this.id = uid();
    }

    /**
     * @param {String} value Shadow value to parse
     * @return {Object} Shadow object with color, offsetX, offsetY and blur
     */
    static parseShadow(value) {
      const shadowStr = value.trim(),
        [, offsetX = 0, offsetY = 0, blur = 0] = (reOffsetsAndBlur.exec(shadowStr) || []).map(value => parseFloat(value) || 0),
        color = (shadowStr.replace(reOffsetsAndBlur, '') || 'rgb(0,0,0)').trim();
      return {
        color,
        offsetX,
        offsetY,
        blur
      };
    }

    /**
     * Returns a string representation of an instance
     * @see http://www.w3.org/TR/css-text-decor-3/#text-shadow
     * @return {String} Returns CSS3 text-shadow declaration
     */
    toString() {
      return [this.offsetX, this.offsetY, this.blur, this.color].join('px ');
    }

    /**
     * Returns SVG representation of a shadow
     * @param {FabricObject} object
     * @return {String} SVG representation of a shadow
     */
    toSVG(object) {
      const offset = rotateVector(new Point(this.offsetX, this.offsetY), degreesToRadians(-object.angle)),
        BLUR_BOX = 20,
        color = new Color(this.color);
      let fBoxX = 40,
        fBoxY = 40;
      if (object.width && object.height) {
        //http://www.w3.org/TR/SVG/filters.html#FilterEffectsRegion
        // we add some extra space to filter box to contain the blur ( 20 )
        fBoxX = toFixed((Math.abs(offset.x) + this.blur) / object.width, config.NUM_FRACTION_DIGITS) * 100 + BLUR_BOX;
        fBoxY = toFixed((Math.abs(offset.y) + this.blur) / object.height, config.NUM_FRACTION_DIGITS) * 100 + BLUR_BOX;
      }
      if (object.flipX) {
        offset.x *= -1;
      }
      if (object.flipY) {
        offset.y *= -1;
      }
      return "<filter id=\"SVGID_".concat(this.id, "\" y=\"-").concat(fBoxY, "%\" height=\"").concat(100 + 2 * fBoxY, "%\" x=\"-").concat(fBoxX, "%\" width=\"").concat(100 + 2 * fBoxX, "%\" >\n\t<feGaussianBlur in=\"SourceAlpha\" stdDeviation=\"").concat(toFixed(this.blur ? this.blur / 2 : 0, config.NUM_FRACTION_DIGITS), "\"></feGaussianBlur>\n\t<feOffset dx=\"").concat(toFixed(offset.x, config.NUM_FRACTION_DIGITS), "\" dy=\"").concat(toFixed(offset.y, config.NUM_FRACTION_DIGITS), "\" result=\"oBlur\" ></feOffset>\n\t<feFlood flood-color=\"").concat(color.toRgb(), "\" flood-opacity=\"").concat(color.getAlpha(), "\"/>\n\t<feComposite in2=\"oBlur\" operator=\"in\" />\n\t<feMerge>\n\t\t<feMergeNode></feMergeNode>\n\t\t<feMergeNode in=\"SourceGraphic\"></feMergeNode>\n\t</feMerge>\n</filter>\n");
    }

    /**
     * Returns object representation of a shadow
     * @return {Object} Object representation of a shadow instance
     */
    toObject() {
      const data = {
        color: this.color,
        blur: this.blur,
        offsetX: this.offsetX,
        offsetY: this.offsetY,
        affectStroke: this.affectStroke,
        nonScaling: this.nonScaling,
        type: this.constructor.type
      };
      const defaults = Shadow.ownDefaults;
      return !this.includeDefaultValues ? pickBy(data, (value, key) => value !== defaults[key]) : data;
    }
    static async fromObject(options) {
      return new this(options);
    }
  }
  /**
   * Shadow color
   * @type String
   * @default
   */
  /**
   * Shadow blur
   * @type Number
   */
  /**
   * Shadow horizontal offset
   * @type Number
   * @default
   */
  /**
   * Shadow vertical offset
   * @type Number
   * @default
   */
  /**
   * Whether the shadow should affect stroke operations
   * @type Boolean
   * @default
   */
  /**
   * Indicates whether toObject should include default values
   * @type Boolean
   * @default
   */
  /**
   * When `false`, the shadow will scale with the object.
   * When `true`, the shadow's offsetX, offsetY, and blur will not be affected by the object's scale.
   * default to false
   * @type Boolean
   * @default
   */
  _defineProperty(Shadow, "ownDefaults", shadowDefaultValues);
  _defineProperty(Shadow, "type", 'shadow');
  classRegistry.setClass(Shadow, 'shadow');

  const capValue = (min, value, max) => Math.max(min, Math.min(value, max));

  const stateProperties = [TOP, LEFT, SCALE_X, SCALE_Y, 'flipX', 'flipY', 'originX', 'originY', 'angle', 'opacity', 'globalCompositeOperation', 'shadow', 'visible', SKEW_X, SKEW_Y];
  const cacheProperties = [FILL, STROKE, 'strokeWidth', 'strokeDashArray', 'width', 'height', 'paintFirst', 'strokeUniform', 'strokeLineCap', 'strokeDashOffset', 'strokeLineJoin', 'strokeMiterLimit', 'backgroundColor', 'clipPath'];
  const fabricObjectDefaultValues = {
    // see composeMatrix() to see order of transforms. First defaults listed based on this
    top: 0,
    left: 0,
    width: 0,
    height: 0,
    angle: 0,
    flipX: false,
    flipY: false,
    scaleX: 1,
    scaleY: 1,
    minScaleLimit: 0,
    skewX: 0,
    skewY: 0,
    originX: LEFT,
    originY: TOP,
    strokeWidth: 1,
    strokeUniform: false,
    padding: 0,
    opacity: 1,
    paintFirst: FILL,
    fill: 'rgb(0,0,0)',
    fillRule: 'nonzero',
    stroke: null,
    strokeDashArray: null,
    strokeDashOffset: 0,
    strokeLineCap: 'butt',
    strokeLineJoin: 'miter',
    strokeMiterLimit: 4,
    globalCompositeOperation: 'source-over',
    backgroundColor: '',
    shadow: null,
    visible: true,
    includeDefaultValues: true,
    excludeFromExport: false,
    objectCaching: true,
    clipPath: undefined,
    inverted: false,
    absolutePositioned: false,
    centeredRotation: true,
    centeredScaling: false,
    dirty: true
  };
  const interactiveObjectDefaultValues = {
    noScaleCache: true,
    lockMovementX: false,
    lockMovementY: false,
    lockRotation: false,
    lockScalingX: false,
    lockScalingY: false,
    lockSkewingX: false,
    lockSkewingY: false,
    lockScalingFlip: false,
    cornerSize: 13,
    touchCornerSize: 24,
    transparentCorners: true,
    cornerColor: 'rgb(178,204,255)',
    cornerStrokeColor: '',
    cornerStyle: 'rect',
    cornerDashArray: null,
    hasControls: true,
    borderColor: 'rgb(178,204,255)',
    borderDashArray: null,
    borderOpacityWhenMoving: 0.4,
    borderScaleFactor: 1,
    hasBorders: true,
    selectionBackgroundColor: '',
    selectable: true,
    evented: true,
    perPixelTargetFind: false,
    activeOn: 'down',
    hoverCursor: null,
    moveCursor: null
  };

  /**
   * Easing functions
   * @see {@link http://gizma.com/easing/ Easing Equations by Robert Penner}
   */

  const normalize = (a, c, p, s) => {
    if (a < Math.abs(c)) {
      a = c;
      s = p / 4;
    } else {
      //handle the 0/0 case:
      if (c === 0 && a === 0) {
        s = p / twoMathPi * Math.asin(1);
      } else {
        s = p / twoMathPi * Math.asin(c / a);
      }
    }
    return {
      a,
      c,
      p,
      s
    };
  };
  const elastic = (a, s, p, t, d) => a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * twoMathPi / p);

  /**
   * Default sinusoidal easing
   */
  const defaultEasing = (t, b, c, d) => -c * Math.cos(t / d * halfPI) + c + b;

  /**
   * Cubic easing in
   */
  const easeInCubic = (t, b, c, d) => c * (t / d) ** 3 + b;

  /**
   * Cubic easing out
   */
  const easeOutCubic = (t, b, c, d) => c * ((t / d - 1) ** 3 + 1) + b;

  /**
   * Cubic easing in and out
   */
  const easeInOutCubic = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) {
      return c / 2 * t ** 3 + b;
    }
    return c / 2 * ((t - 2) ** 3 + 2) + b;
  };

  /**
   * Quartic easing in
   */
  const easeInQuart = (t, b, c, d) => c * (t /= d) * t ** 3 + b;

  /**
   * Quartic easing out
   */
  const easeOutQuart = (t, b, c, d) => -c * ((t = t / d - 1) * t ** 3 - 1) + b;

  /**
   * Quartic easing in and out
   */
  const easeInOutQuart = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) {
      return c / 2 * t ** 4 + b;
    }
    return -c / 2 * ((t -= 2) * t ** 3 - 2) + b;
  };

  /**
   * Quintic easing in
   */
  const easeInQuint = (t, b, c, d) => c * (t / d) ** 5 + b;

  /**
   * Quintic easing out
   */
  const easeOutQuint = (t, b, c, d) => c * ((t / d - 1) ** 5 + 1) + b;

  /**
   * Quintic easing in and out
   */
  const easeInOutQuint = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) {
      return c / 2 * t ** 5 + b;
    }
    return c / 2 * ((t - 2) ** 5 + 2) + b;
  };

  /**
   * Sinusoidal easing in
   */
  const easeInSine = (t, b, c, d) => -c * Math.cos(t / d * halfPI) + c + b;

  /**
   * Sinusoidal easing out
   */
  const easeOutSine = (t, b, c, d) => c * Math.sin(t / d * halfPI) + b;

  /**
   * Sinusoidal easing in and out
   */
  const easeInOutSine = (t, b, c, d) => -c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;

  /**
   * Exponential easing in
   */
  const easeInExpo = (t, b, c, d) => t === 0 ? b : c * 2 ** (10 * (t / d - 1)) + b;

  /**
   * Exponential easing out
   */
  const easeOutExpo = (t, b, c, d) => t === d ? b + c : c * -(2 ** (-10 * t / d) + 1) + b;

  /**
   * Exponential easing in and out
   */
  const easeInOutExpo = (t, b, c, d) => {
    if (t === 0) {
      return b;
    }
    if (t === d) {
      return b + c;
    }
    t /= d / 2;
    if (t < 1) {
      return c / 2 * 2 ** (10 * (t - 1)) + b;
    }
    return c / 2 * -(2 ** (-10 * --t) + 2) + b;
  };

  /**
   * Circular easing in
   */
  const easeInCirc = (t, b, c, d) => -c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;

  /**
   * Circular easing out
   */
  const easeOutCirc = (t, b, c, d) => c * Math.sqrt(1 - (t = t / d - 1) * t) + b;

  /**
   * Circular easing in and out
   */
  const easeInOutCirc = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) {
      return -c / 2 * (Math.sqrt(1 - t ** 2) - 1) + b;
    }
    return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
  };

  /**
   * Elastic easing in
   */
  const easeInElastic = (t, b, c, d) => {
    const s = 1.70158,
      a = c;
    let p = 0;
    if (t === 0) {
      return b;
    }
    t /= d;
    if (t === 1) {
      return b + c;
    }
    if (!p) {
      p = d * 0.3;
    }
    const {
      a: normA,
      s: normS,
      p: normP
    } = normalize(a, c, p, s);
    return -elastic(normA, normS, normP, t, d) + b;
  };

  /**
   * Elastic easing out
   */
  const easeOutElastic = (t, b, c, d) => {
    const s = 1.70158,
      a = c;
    let p = 0;
    if (t === 0) {
      return b;
    }
    t /= d;
    if (t === 1) {
      return b + c;
    }
    if (!p) {
      p = d * 0.3;
    }
    const {
      a: normA,
      s: normS,
      p: normP,
      c: normC
    } = normalize(a, c, p, s);
    return normA * 2 ** (-10 * t) * Math.sin((t * d - normS) * twoMathPi / normP) + normC + b;
  };

  /**
   * Elastic easing in and out
   */
  const easeInOutElastic = (t, b, c, d) => {
    const s = 1.70158,
      a = c;
    let p = 0;
    if (t === 0) {
      return b;
    }
    t /= d / 2;
    if (t === 2) {
      return b + c;
    }
    if (!p) {
      p = d * (0.3 * 1.5);
    }
    const {
      a: normA,
      s: normS,
      p: normP,
      c: normC
    } = normalize(a, c, p, s);
    if (t < 1) {
      return -0.5 * elastic(normA, normS, normP, t, d) + b;
    }
    return normA * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - normS) * twoMathPi / normP) * 0.5 + normC + b;
  };

  /**
   * Backwards easing in
   */
  const easeInBack = function (t, b, c, d) {
    let s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1.70158;
    return c * (t /= d) * t * ((s + 1) * t - s) + b;
  };

  /**
   * Backwards easing out
   */
  const easeOutBack = function (t, b, c, d) {
    let s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1.70158;
    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
  };

  /**
   * Backwards easing in and out
   */
  const easeInOutBack = function (t, b, c, d) {
    let s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1.70158;
    t /= d / 2;
    if (t < 1) {
      return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
    }
    return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
  };

  /**
   * Bouncing easing out
   */
  const easeOutBounce = (t, b, c, d) => {
    if ((t /= d) < 1 / 2.75) {
      return c * (7.5625 * t * t) + b;
    } else if (t < 2 / 2.75) {
      return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
    } else if (t < 2.5 / 2.75) {
      return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
    } else {
      return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
    }
  };

  /**
   * Bouncing easing in
   */
  const easeInBounce = (t, b, c, d) => c - easeOutBounce(d - t, 0, c, d) + b;

  /**
   * Bouncing easing in and out
   */
  const easeInOutBounce = (t, b, c, d) => t < d / 2 ? easeInBounce(t * 2, 0, c, d) * 0.5 + b : easeOutBounce(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;

  /**
   * Quadratic easing in
   */
  const easeInQuad = (t, b, c, d) => c * (t /= d) * t + b;

  /**
   * Quadratic easing out
   */
  const easeOutQuad = (t, b, c, d) => -c * (t /= d) * (t - 2) + b;

  /**
   * Quadratic easing in and out
   */
  const easeInOutQuad = (t, b, c, d) => {
    t /= d / 2;
    if (t < 1) {
      return c / 2 * t ** 2 + b;
    }
    return -c / 2 * (--t * (t - 2) - 1) + b;
  };

  var easing = /*#__PURE__*/Object.freeze({
    __proto__: null,
    defaultEasing: defaultEasing,
    easeInBack: easeInBack,
    easeInBounce: easeInBounce,
    easeInCirc: easeInCirc,
    easeInCubic: easeInCubic,
    easeInElastic: easeInElastic,
    easeInExpo: easeInExpo,
    easeInOutBack: easeInOutBack,
    easeInOutBounce: easeInOutBounce,
    easeInOutCirc: easeInOutCirc,
    easeInOutCubic: easeInOutCubic,
    easeInOutElastic: easeInOutElastic,
    easeInOutExpo: easeInOutExpo,
    easeInOutQuad: easeInOutQuad,
    easeInOutQuart: easeInOutQuart,
    easeInOutQuint: easeInOutQuint,
    easeInOutSine: easeInOutSine,
    easeInQuad: easeInQuad,
    easeInQuart: easeInQuart,
    easeInQuint: easeInQuint,
    easeInSine: easeInSine,
    easeOutBack: easeOutBack,
    easeOutBounce: easeOutBounce,
    easeOutCirc: easeOutCirc,
    easeOutCubic: easeOutCubic,
    easeOutElastic: easeOutElastic,
    easeOutExpo: easeOutExpo,
    easeOutQuad: easeOutQuad,
    easeOutQuart: easeOutQuart,
    easeOutQuint: easeOutQuint,
    easeOutSine: easeOutSine
  });

  const defaultAbort = () => false;
  class AnimationBase {
    /**
     * Current value
     */

    /**
     * Animation start time ms
     */

    constructor(_ref) {
      let {
        startValue,
        byValue,
        duration = 500,
        delay = 0,
        easing = defaultEasing,
        onStart = noop,
        onChange = noop,
        onComplete = noop,
        abort = defaultAbort,
        target
      } = _ref;
      /**
       * Used to register the animation to a target object
       * so that it can be cancelled within the object context
       */
      _defineProperty(this, "_state", 'pending');
      /**
       * Time %, or the ratio of `timeElapsed / duration`
       * @see tick
       */
      _defineProperty(this, "durationProgress", 0);
      /**
       * Value %, or the ratio of `(currentValue - startValue) / (endValue - startValue)`
       */
      _defineProperty(this, "valueProgress", 0);
      this.tick = this.tick.bind(this);
      this.duration = duration;
      this.delay = delay;
      this.easing = easing;
      this._onStart = onStart;
      this._onChange = onChange;
      this._onComplete = onComplete;
      this._abort = abort;
      this.target = target;
      this.startValue = startValue;
      this.byValue = byValue;
      this.value = this.startValue;
      this.endValue = Object.freeze(this.calculate(this.duration).value);
    }
    get state() {
      return this._state;
    }
    isDone() {
      return this._state === 'aborted' || this._state === 'completed';
    }

    /**
     * Calculate the current value based on the easing parameters
     * @param timeElapsed in ms
     * @protected
     */

    start() {
      const firstTick = timestamp => {
        if (this._state !== 'pending') return;
        this.startTime = timestamp || +new Date();
        this._state = 'running';
        this._onStart();
        this.tick(this.startTime);
      };
      this.register();

      // setTimeout(cb, 0) will run cb on the next frame, causing a delay
      // we don't want that
      if (this.delay > 0) {
        setTimeout(() => requestAnimFrame(firstTick), this.delay);
      } else {
        requestAnimFrame(firstTick);
      }
    }
    tick(t) {
      const durationMs = (t || +new Date()) - this.startTime;
      const boundDurationMs = Math.min(durationMs, this.duration);
      this.durationProgress = boundDurationMs / this.duration;
      const {
        value,
        valueProgress
      } = this.calculate(boundDurationMs);
      this.value = Object.freeze(value);
      this.valueProgress = valueProgress;
      if (this._state === 'aborted') {
        return;
      } else if (this._abort(this.value, this.valueProgress, this.durationProgress)) {
        this._state = 'aborted';
        this.unregister();
      } else if (durationMs >= this.duration) {
        this.durationProgress = this.valueProgress = 1;
        this._onChange(this.endValue, this.valueProgress, this.durationProgress);
        this._state = 'completed';
        this._onComplete(this.endValue, this.valueProgress, this.durationProgress);
        this.unregister();
      } else {
        this._onChange(this.value, this.valueProgress, this.durationProgress);
        requestAnimFrame(this.tick);
      }
    }
    register() {
      runningAnimations.push(this);
    }
    unregister() {
      runningAnimations.remove(this);
    }
    abort() {
      this._state = 'aborted';
      this.unregister();
    }
  }

  const _excluded$h = ["startValue", "endValue"];
  class ValueAnimation extends AnimationBase {
    constructor(_ref) {
      let {
          startValue = 0,
          endValue = 100
        } = _ref,
        otherOptions = _objectWithoutProperties(_ref, _excluded$h);
      super(_objectSpread2(_objectSpread2({}, otherOptions), {}, {
        startValue,
        byValue: endValue - startValue
      }));
    }
    calculate(timeElapsed) {
      const value = this.easing(timeElapsed, this.startValue, this.byValue, this.duration);
      return {
        value,
        valueProgress: Math.abs((value - this.startValue) / this.byValue)
      };
    }
  }

  const _excluded$g = ["startValue", "endValue"];
  class ArrayAnimation extends AnimationBase {
    constructor(_ref) {
      let {
          startValue = [0],
          endValue = [100]
        } = _ref,
        options = _objectWithoutProperties(_ref, _excluded$g);
      super(_objectSpread2(_objectSpread2({}, options), {}, {
        startValue,
        byValue: endValue.map((value, i) => value - startValue[i])
      }));
    }
    calculate(timeElapsed) {
      const values = this.startValue.map((value, i) => this.easing(timeElapsed, value, this.byValue[i], this.duration, i));
      return {
        value: values,
        valueProgress: Math.abs((values[0] - this.startValue[0]) / this.byValue[0])
      };
    }
  }

  const _excluded$f = ["startValue", "endValue", "easing", "onChange", "onComplete", "abort"];
  const defaultColorEasing = (timeElapsed, startValue, byValue, duration) => {
    const durationProgress = 1 - Math.cos(timeElapsed / duration * halfPI);
    return startValue + byValue * durationProgress;
  };
  const wrapColorCallback = callback => callback && ((rgba, valueProgress, durationProgress) => callback(new Color(rgba).toRgba(), valueProgress, durationProgress));
  class ColorAnimation extends AnimationBase {
    constructor(_ref) {
      let {
          startValue,
          endValue,
          easing = defaultColorEasing,
          onChange,
          onComplete,
          abort
        } = _ref,
        options = _objectWithoutProperties(_ref, _excluded$f);
      const startColor = new Color(startValue).getSource();
      const endColor = new Color(endValue).getSource();
      super(_objectSpread2(_objectSpread2({}, options), {}, {
        startValue: startColor,
        byValue: endColor.map((value, i) => value - startColor[i]),
        easing,
        onChange: wrapColorCallback(onChange),
        onComplete: wrapColorCallback(onComplete),
        abort: wrapColorCallback(abort)
      }));
    }
    calculate(timeElapsed) {
      const [r, g, b, a] = this.startValue.map((value, i) => this.easing(timeElapsed, value, this.byValue[i], this.duration, i));
      const value = [...[r, g, b].map(Math.round), capValue(0, a, 1)];
      return {
        value,
        valueProgress:
        // to correctly calculate the change ratio we must find a changed value
        value.map((p, i) => this.byValue[i] !== 0 ? Math.abs((p - this.startValue[i]) / this.byValue[i]) : 0).find(p => p !== 0) || 0
      };
    }
  }

  const isArrayAnimation = options => {
    return Array.isArray(options.startValue) || Array.isArray(options.endValue);
  };

  /**
   * Changes value(s) from startValue to endValue within a certain period of time,
   * invoking callbacks as the value(s) change.
   *
   * @example
   * animate({
   *   startValue: 1,
   *   endValue: 0,
   *   onChange: (v) => {
   *     obj.set('opacity', v);
   *     // since we are running in a requested frame we should call `renderAll` and not `requestRenderAll`
   *     canvas.renderAll();
   *   }
   * });
   *
   * @example Using lists:
   * animate({
   *   startValue: [1, 2, 3],
   *   endValue: [2, 4, 6],
   *   onChange: ([x, y, zoom]) => {
   *     canvas.zoomToPoint(new Point(x, y), zoom);
   *     canvas.renderAll();
   *   }
   * });
   *
   */

  function animate(options) {
    const animation = isArrayAnimation(options) ? new ArrayAnimation(options) : new ValueAnimation(options);
    animation.start();
    return animation;
  }
  function animateColor(options) {
    const animation = new ColorAnimation(options);
    animation.start();
    return animation;
  }

  /* Adaptation of work of Kevin Lindsey (kevin@kevlindev.com) */

  class Intersection {
    constructor(status) {
      this.status = status;
      this.points = [];
    }

    /**
     * Used to verify if a point is alredy in the collection
     * @param {Point} point
     * @returns {boolean}
     */
    includes(point) {
      return this.points.some(p => p.eq(point));
    }

    /**
     * Appends points of intersection
     * @param {...Point[]} points
     * @return {Intersection} thisArg
     * @chainable
     */
    append() {
      for (var _len = arguments.length, points = new Array(_len), _key = 0; _key < _len; _key++) {
        points[_key] = arguments[_key];
      }
      this.points = this.points.concat(points.filter(point => {
        return !this.includes(point);
      }));
      return this;
    }

    /**
     * check if point T is on the segment or line defined between A and B
     *
     * @param {Point} T the point we are checking for
     * @param {Point} A one extremity of the segment
     * @param {Point} B the other extremity of the segment
     * @param [infinite] if true checks if `T` is on the line defined by `A` and `B`
     * @returns true if `T` is contained
     */
    static isPointContained(T, A, B) {
      let infinite = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      if (A.eq(B)) {
        // Edge case: the segment is a point, we check for coincidence,
        // infinite param has no meaning because there are infinite lines to consider
        return T.eq(A);
      } else if (A.x === B.x) {
        // Edge case: horizontal line.
        // we first check if T.x has the same value, and then if T.y is contained between A.y and B.y
        return T.x === A.x && (infinite || T.y >= Math.min(A.y, B.y) && T.y <= Math.max(A.y, B.y));
      } else if (A.y === B.y) {
        // Edge case: vertical line.
        // we first check if T.y has the same value, and then if T.x is contained between A.x and B.x
        return T.y === A.y && (infinite || T.x >= Math.min(A.x, B.x) && T.x <= Math.max(A.x, B.x));
      } else {
        // Generic case: sloped line.
        // we check that AT has the same slope as AB
        // for the segment case we need both the vectors to have the same direction and for AT to be lte AB in size
        // for the infinite case we check the absolute value of the slope, since direction is meaningless
        const AB = createVector(A, B);
        const AT = createVector(A, T);
        const s = AT.divide(AB);
        return infinite ? Math.abs(s.x) === Math.abs(s.y) : s.x === s.y && s.x >= 0 && s.x <= 1;
      }
    }

    /**
     * Use the ray casting algorithm to determine if {@link Point} is in the polygon defined by [points]{@link Point}
     * @see https://en.wikipedia.org/wiki/Point_in_polygon
     * @param point
     * @param points polygon points
     * @returns
     */
    static isPointInPolygon(point, points) {
      const other = new Point(point).setX(Math.min(point.x - 1, ...points.map(p => p.x)));
      let hits = 0;
      for (let index = 0; index < points.length; index++) {
        const inter = this.intersectSegmentSegment(
        // polygon side
        points[index], points[(index + 1) % points.length],
        // ray
        point, other);
        if (inter.includes(point)) {
          // point is on the polygon side
          return true;
        }
        hits += Number(inter.status === 'Intersection');
      }
      return hits % 2 === 1;
    }

    /**
     * Checks if a line intersects another
     * @see {@link https://en.wikipedia.org/wiki/Line%E2%80%93line_intersection line intersection}
     * @see {@link https://en.wikipedia.org/wiki/Cramer%27s_rule Cramer's rule}
     * @static
     * @param {Point} a1
     * @param {Point} a2
     * @param {Point} b1
     * @param {Point} b2
     * @param {boolean} [aInfinite=true] check segment intersection by passing `false`
     * @param {boolean} [bInfinite=true] check segment intersection by passing `false`
     * @return {Intersection}
     */
    static intersectLineLine(a1, a2, b1, b2) {
      let aInfinite = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      let bInfinite = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
      const a2xa1x = a2.x - a1.x,
        a2ya1y = a2.y - a1.y,
        b2xb1x = b2.x - b1.x,
        b2yb1y = b2.y - b1.y,
        a1xb1x = a1.x - b1.x,
        a1yb1y = a1.y - b1.y,
        uaT = b2xb1x * a1yb1y - b2yb1y * a1xb1x,
        ubT = a2xa1x * a1yb1y - a2ya1y * a1xb1x,
        uB = b2yb1y * a2xa1x - b2xb1x * a2ya1y;
      if (uB !== 0) {
        const ua = uaT / uB,
          ub = ubT / uB;
        if ((aInfinite || 0 <= ua && ua <= 1) && (bInfinite || 0 <= ub && ub <= 1)) {
          return new Intersection('Intersection').append(new Point(a1.x + ua * a2xa1x, a1.y + ua * a2ya1y));
        } else {
          return new Intersection();
        }
      } else {
        if (uaT === 0 || ubT === 0) {
          const segmentsCoincide = aInfinite || bInfinite || Intersection.isPointContained(a1, b1, b2) || Intersection.isPointContained(a2, b1, b2) || Intersection.isPointContained(b1, a1, a2) || Intersection.isPointContained(b2, a1, a2);
          return new Intersection(segmentsCoincide ? 'Coincident' : undefined);
        } else {
          return new Intersection('Parallel');
        }
      }
    }

    /**
     * Checks if a segment intersects a line
     * @see {@link intersectLineLine} for line intersection
     * @static
     * @param {Point} s1 boundary point of segment
     * @param {Point} s2 other boundary point of segment
     * @param {Point} l1 point on line
     * @param {Point} l2 other point on line
     * @return {Intersection}
     */
    static intersectSegmentLine(s1, s2, l1, l2) {
      return Intersection.intersectLineLine(s1, s2, l1, l2, false, true);
    }

    /**
     * Checks if a segment intersects another
     * @see {@link intersectLineLine} for line intersection
     * @static
     * @param {Point} a1 boundary point of segment
     * @param {Point} a2 other boundary point of segment
     * @param {Point} b1 boundary point of segment
     * @param {Point} b2 other boundary point of segment
     * @return {Intersection}
     */
    static intersectSegmentSegment(a1, a2, b1, b2) {
      return Intersection.intersectLineLine(a1, a2, b1, b2, false, false);
    }

    /**
     * Checks if line intersects polygon
     *
     * @todo account for stroke
     *
     * @static
     * @see {@link intersectSegmentPolygon} for segment intersection
     * @param {Point} a1 point on line
     * @param {Point} a2 other point on line
     * @param {Point[]} points polygon points
     * @param {boolean} [infinite=true] check segment intersection by passing `false`
     * @return {Intersection}
     */
    static intersectLinePolygon(a1, a2, points) {
      let infinite = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      const result = new Intersection();
      const length = points.length;
      for (let i = 0, b1, b2, inter; i < length; i++) {
        b1 = points[i];
        b2 = points[(i + 1) % length];
        inter = Intersection.intersectLineLine(a1, a2, b1, b2, infinite, false);
        if (inter.status === 'Coincident') {
          return inter;
        }
        result.append(...inter.points);
      }
      if (result.points.length > 0) {
        result.status = 'Intersection';
      }
      return result;
    }

    /**
     * Checks if segment intersects polygon
     * @static
     * @see {@link intersectLinePolygon} for line intersection
     * @param {Point} a1 boundary point of segment
     * @param {Point} a2 other boundary point of segment
     * @param {Point[]} points polygon points
     * @return {Intersection}
     */
    static intersectSegmentPolygon(a1, a2, points) {
      return Intersection.intersectLinePolygon(a1, a2, points, false);
    }

    /**
     * Checks if polygon intersects another polygon
     *
     * @todo account for stroke
     *
     * @static
     * @param {Point[]} points1
     * @param {Point[]} points2
     * @return {Intersection}
     */
    static intersectPolygonPolygon(points1, points2) {
      const result = new Intersection(),
        length = points1.length;
      const coincidences = [];
      for (let i = 0; i < length; i++) {
        const a1 = points1[i],
          a2 = points1[(i + 1) % length],
          inter = Intersection.intersectSegmentPolygon(a1, a2, points2);
        if (inter.status === 'Coincident') {
          coincidences.push(inter);
          result.append(a1, a2);
        } else {
          result.append(...inter.points);
        }
      }
      if (coincidences.length > 0 && coincidences.length === points1.length) {
        return new Intersection('Coincident');
      } else if (result.points.length > 0) {
        result.status = 'Intersection';
      }
      return result;
    }

    /**
     * Checks if polygon intersects rectangle
     * @static
     * @see {@link intersectPolygonPolygon} for polygon intersection
     * @param {Point[]} points polygon points
     * @param {Point} r1 top left point of rect
     * @param {Point} r2 bottom right point of rect
     * @return {Intersection}
     */
    static intersectPolygonRectangle(points, r1, r2) {
      const min = r1.min(r2),
        max = r1.max(r2),
        topRight = new Point(max.x, min.y),
        bottomLeft = new Point(min.x, max.y);
      return Intersection.intersectPolygonPolygon(points, [min, topRight, max, bottomLeft]);
    }
  }

  class ObjectGeometry extends CommonMethods {
    // #region Geometry

    /**
     * Describe object's corner position in scene coordinates.
     * The coordinates are derived from the following:
     * left, top, width, height, scaleX, scaleY, skewX, skewY, angle, strokeWidth.
     * The coordinates do not depend on viewport changes.
     * The coordinates get updated with {@link setCoords}.
     * You can calculate them without updating with {@link calcACoords()}
     */

    /**
     * storage cache for object transform matrix
     */

    /**
     * storage cache for object full transform matrix
     */

    /**
     * A Reference of the Canvas where the object is actually added
     * @type StaticCanvas | Canvas;
     * @default undefined
     * @private
     */

    /**
     * @returns {number} x position according to object's {@link FabricObject#originX} property in canvas coordinate plane
     */
    getX() {
      return this.getXY().x;
    }

    /**
     * @param {number} value x position according to object's {@link FabricObject#originX} property in canvas coordinate plane
     */
    setX(value) {
      this.setXY(this.getXY().setX(value));
    }

    /**
     * @returns {number} y position according to object's {@link FabricObject#originY} property in canvas coordinate plane
     */
    getY() {
      return this.getXY().y;
    }

    /**
     * @param {number} value y position according to object's {@link FabricObject#originY} property in canvas coordinate plane
     */
    setY(value) {
      this.setXY(this.getXY().setY(value));
    }

    /**
     * @returns {number} x position according to object's {@link FabricObject#originX} property in parent's coordinate plane\
     * if parent is canvas then this property is identical to {@link getX}
     */
    getRelativeX() {
      return this.left;
    }

    /**
     * @param {number} value x position according to object's {@link FabricObject#originX} property in parent's coordinate plane\
     * if parent is canvas then this method is identical to {@link setX}
     */
    setRelativeX(value) {
      this.left = value;
    }

    /**
     * @returns {number} y position according to object's {@link FabricObject#originY} property in parent's coordinate plane\
     * if parent is canvas then this property is identical to {@link getY}
     */
    getRelativeY() {
      return this.top;
    }

    /**
     * @param {number} value y position according to object's {@link FabricObject#originY} property in parent's coordinate plane\
     * if parent is canvas then this property is identical to {@link setY}
     */
    setRelativeY(value) {
      this.top = value;
    }

    /**
     * @returns {Point} x position according to object's {@link FabricObject#originX} {@link FabricObject#originY} properties in canvas coordinate plane
     */
    getXY() {
      const relativePosition = this.getRelativeXY();
      return this.group ? transformPoint(relativePosition, this.group.calcTransformMatrix()) : relativePosition;
    }

    /**
     * Set an object position to a particular point, the point is intended in absolute ( canvas ) coordinate.
     * You can specify {@link FabricObject#originX} and {@link FabricObject#originY} values,
     * that otherwise are the object's current values.
     * @example <caption>Set object's bottom left corner to point (5,5) on canvas</caption>
     * object.setXY(new Point(5, 5), 'left', 'bottom').
     * @param {Point} point position in scene coordinate plane
     * @param {TOriginX} [originX] Horizontal origin: 'left', 'center' or 'right'
     * @param {TOriginY} [originY] Vertical origin: 'top', 'center' or 'bottom'
     */
    setXY(point, originX, originY) {
      if (this.group) {
        point = transformPoint(point, invertTransform(this.group.calcTransformMatrix()));
      }
      this.setRelativeXY(point, originX, originY);
    }

    /**
     * @returns {Point} x,y position according to object's {@link FabricObject#originX} {@link FabricObject#originY} properties in parent's coordinate plane
     */
    getRelativeXY() {
      return new Point(this.left, this.top);
    }

    /**
     * As {@link setXY}, but in current parent's coordinate plane (the current group if any or the canvas)
     * @param {Point} point position according to object's {@link FabricObject#originX} {@link FabricObject#originY} properties in parent's coordinate plane
     * @param {TOriginX} [originX] Horizontal origin: 'left', 'center' or 'right'
     * @param {TOriginY} [originY] Vertical origin: 'top', 'center' or 'bottom'
     */
    setRelativeXY(point) {
      let originX = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.originX;
      let originY = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.originY;
      this.setPositionByOrigin(point, originX, originY);
    }

    /**
     * @deprecated intermidiate method to be removed, do not use
     */
    isStrokeAccountedForInDimensions() {
      return false;
    }

    /**
     * @return {Point[]} [tl, tr, br, bl] in the scene plane
     */
    getCoords() {
      const {
        tl,
        tr,
        br,
        bl
      } = this.aCoords || (this.aCoords = this.calcACoords());
      const coords = [tl, tr, br, bl];
      if (this.group) {
        const t = this.group.calcTransformMatrix();
        return coords.map(p => transformPoint(p, t));
      }
      return coords;
    }

    /**
     * Checks if object intersects with the scene rect formed by TL and BR
     * In this case the rect is meant aligned with the axis of the canvas.
     * TL is the TOP LEFT point while br is the BOTTOM RIGHT point
     */
    intersectsWithRect(tl, br) {
      const intersection = Intersection.intersectPolygonRectangle(this.getCoords(), tl, br);
      return intersection.status === 'Intersection';
    }

    /**
     * Checks if object intersects with another object
     * @param {Object} other Object to test
     * @return {Boolean} true if object intersects with another object
     */
    intersectsWithObject(other) {
      const intersection = Intersection.intersectPolygonPolygon(this.getCoords(), other.getCoords());
      return intersection.status === 'Intersection' || intersection.status === 'Coincident' || other.isContainedWithinObject(this) || this.isContainedWithinObject(other);
    }

    /**
     * Checks if object is fully contained within area of another object
     * @param {Object} other Object to test
     * @return {Boolean} true if object is fully contained within area of another object
     */
    isContainedWithinObject(other) {
      const points = this.getCoords();
      return points.every(point => other.containsPoint(point));
    }

    /**
     * Checks if object is fully contained within the scene rect formed by TL and BR
     */
    isContainedWithinRect(tl, br) {
      const {
        left,
        top,
        width,
        height
      } = this.getBoundingRect();
      return left >= tl.x && left + width <= br.x && top >= tl.y && top + height <= br.y;
    }
    isOverlapping(other) {
      return this.intersectsWithObject(other) || this.isContainedWithinObject(other) || other.isContainedWithinObject(this);
    }

    /**
     * Checks if point is inside the object
     * @param {Point} point Point to check against
     * @return {Boolean} true if point is inside the object
     */
    containsPoint(point) {
      return Intersection.isPointInPolygon(point, this.getCoords());
    }

    /**
     * Checks if object is contained within the canvas with current viewportTransform
     * the check is done stopping at first point that appears on screen
     * @return {Boolean} true if object is fully or partially contained within canvas
     */
    isOnScreen() {
      if (!this.canvas) {
        return false;
      }
      const {
        tl,
        br
      } = this.canvas.vptCoords;
      const points = this.getCoords();
      // if some point is on screen, the object is on screen.
      if (points.some(point => point.x <= br.x && point.x >= tl.x && point.y <= br.y && point.y >= tl.y)) {
        return true;
      }
      // no points on screen, check intersection with absolute coordinates
      if (this.intersectsWithRect(tl, br)) {
        return true;
      }
      // check if the object is so big that it contains the entire viewport
      return this.containsPoint(tl.midPointFrom(br));
    }

    /**
     * Checks if object is partially contained within the canvas with current viewportTransform
     * @return {Boolean} true if object is partially contained within canvas
     */
    isPartiallyOnScreen() {
      if (!this.canvas) {
        return false;
      }
      const {
        tl,
        br
      } = this.canvas.vptCoords;
      if (this.intersectsWithRect(tl, br)) {
        return true;
      }
      const allPointsAreOutside = this.getCoords().every(point => (point.x >= br.x || point.x <= tl.x) && (point.y >= br.y || point.y <= tl.y));
      // check if the object is so big that it contains the entire viewport
      return allPointsAreOutside && this.containsPoint(tl.midPointFrom(br));
    }

    /**
     * Returns coordinates of object's bounding rectangle (left, top, width, height)
     * the box is intended as aligned to axis of canvas.
     * @return {Object} Object with left, top, width, height properties
     */
    getBoundingRect() {
      return makeBoundingBoxFromPoints(this.getCoords());
    }

    /**
     * Returns width of an object's bounding box counting transformations
     * @todo shouldn't this account for group transform and return the actual size in canvas coordinate plane?
     * @return {Number} width value
     */
    getScaledWidth() {
      return this._getTransformedDimensions().x;
    }

    /**
     * Returns height of an object bounding box counting transformations
     * @todo shouldn't this account for group transform and return the actual size in canvas coordinate plane?
     * @return {Number} height value
     */
    getScaledHeight() {
      return this._getTransformedDimensions().y;
    }

    /**
     * Scales an object (equally by x and y)
     * @param {Number} value Scale factor
     * @return {void}
     */
    scale(value) {
      this._set(SCALE_X, value);
      this._set(SCALE_Y, value);
      this.setCoords();
    }

    /**
     * Scales an object to a given width, with respect to bounding box (scaling by x/y equally)
     * @param {Number} value New width value
     * @return {void}
     */
    scaleToWidth(value) {
      // adjust to bounding rect factor so that rotated shapes would fit as well
      const boundingRectFactor = this.getBoundingRect().width / this.getScaledWidth();
      return this.scale(value / this.width / boundingRectFactor);
    }

    /**
     * Scales an object to a given height, with respect to bounding box (scaling by x/y equally)
     * @param {Number} value New height value
     * @return {void}
     */
    scaleToHeight(value) {
      // adjust to bounding rect factor so that rotated shapes would fit as well
      const boundingRectFactor = this.getBoundingRect().height / this.getScaledHeight();
      return this.scale(value / this.height / boundingRectFactor);
    }
    getCanvasRetinaScaling() {
      var _this$canvas;
      return ((_this$canvas = this.canvas) === null || _this$canvas === void 0 ? void 0 : _this$canvas.getRetinaScaling()) || 1;
    }

    /**
     * Returns the object angle relative to canvas counting also the group property
     * @returns {TDegree}
     */
    getTotalAngle() {
      return this.group ? radiansToDegrees(calcPlaneRotation(this.calcTransformMatrix())) : this.angle;
    }

    /**
     * Retrieves viewportTransform from Object's canvas if available
     * @return {TMat2D}
     */
    getViewportTransform() {
      var _this$canvas2;
      return ((_this$canvas2 = this.canvas) === null || _this$canvas2 === void 0 ? void 0 : _this$canvas2.viewportTransform) || iMatrix.concat();
    }

    /**
     * Calculates the coordinates of the 4 corner of the bbox, in absolute coordinates.
     * those never change with zoom or viewport changes.
     * @return {TCornerPoint}
     */
    calcACoords() {
      const rotateMatrix = createRotateMatrix({
          angle: this.angle
        }),
        {
          x,
          y
        } = this.getRelativeCenterPoint(),
        tMatrix = createTranslateMatrix(x, y),
        finalMatrix = multiplyTransformMatrices(tMatrix, rotateMatrix),
        dim = this._getTransformedDimensions(),
        w = dim.x / 2,
        h = dim.y / 2;
      return {
        // corners
        tl: transformPoint({
          x: -w,
          y: -h
        }, finalMatrix),
        tr: transformPoint({
          x: w,
          y: -h
        }, finalMatrix),
        bl: transformPoint({
          x: -w,
          y: h
        }, finalMatrix),
        br: transformPoint({
          x: w,
          y: h
        }, finalMatrix)
      };
    }

    /**
     * Sets corner and controls position coordinates based on current angle, width and height, left and top.
     * aCoords are used to quickly find an object on the canvas.
     * See {@link https://github.com/fabricjs/fabric.js/wiki/When-to-call-setCoords} and {@link http://fabricjs.com/fabric-gotchas}
     */
    setCoords() {
      this.aCoords = this.calcACoords();
    }
    transformMatrixKey() {
      let skipGroup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      let prefix = [];
      if (!skipGroup && this.group) {
        prefix = this.group.transformMatrixKey(skipGroup);
      }
      prefix.push(this.top, this.left, this.width, this.height, this.scaleX, this.scaleY, this.angle, this.strokeWidth, this.skewX, this.skewY, +this.flipX, +this.flipY, resolveOrigin(this.originX), resolveOrigin(this.originY));
      return prefix;
    }

    /**
     * calculate transform matrix that represents the current transformations from the
     * object's properties.
     * @param {Boolean} [skipGroup] return transform matrix for object not counting parent transformations
     * There are some situation in which this is useful to avoid the fake rotation.
     * @return {TMat2D} transform matrix for the object
     */
    calcTransformMatrix() {
      let skipGroup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      let matrix = this.calcOwnMatrix();
      if (skipGroup || !this.group) {
        return matrix;
      }
      const key = this.transformMatrixKey(skipGroup),
        cache = this.matrixCache;
      if (cache && cache.key.every((x, i) => x === key[i])) {
        return cache.value;
      }
      if (this.group) {
        matrix = multiplyTransformMatrices(this.group.calcTransformMatrix(false), matrix);
      }
      this.matrixCache = {
        key,
        value: matrix
      };
      return matrix;
    }

    /**
     * calculate transform matrix that represents the current transformations from the
     * object's properties, this matrix does not include the group transformation
     * @return {TMat2D} transform matrix for the object
     */
    calcOwnMatrix() {
      const key = this.transformMatrixKey(true),
        cache = this.ownMatrixCache;
      if (cache && cache.key === key) {
        return cache.value;
      }
      const center = this.getRelativeCenterPoint(),
        options = {
          angle: this.angle,
          translateX: center.x,
          translateY: center.y,
          scaleX: this.scaleX,
          scaleY: this.scaleY,
          skewX: this.skewX,
          skewY: this.skewY,
          flipX: this.flipX,
          flipY: this.flipY
        },
        value = composeMatrix(options);
      this.ownMatrixCache = {
        key,
        value
      };
      return value;
    }

    /**
     * Calculate object dimensions from its properties
     * @private
     * @returns {Point} dimensions
     */
    _getNonTransformedDimensions() {
      return new Point(this.width, this.height).scalarAdd(this.strokeWidth);
    }

    /**
     * Calculate object dimensions for controls box, including padding and canvas zoom.
     * and active selection
     * @private
     * @param {object} [options] transform options
     * @returns {Point} dimensions
     */
    _calculateCurrentDimensions(options) {
      return this._getTransformedDimensions(options).transform(this.getViewportTransform(), true).scalarAdd(2 * this.padding);
    }

    // #region Origin

    /**
     * @deprecated please use 'center' as value in new projects
     * */

    /**
     * @deprecated please use 'center' as value in new projects
     * */

    /**
     * Object containing this object.
     * can influence its size and position
     */

    /**
     * Calculate object bounding box dimensions from its properties scale, skew.
     * This bounding box is aligned with object angle and not with canvas axis or screen.
     * @param {Object} [options]
     * @param {Number} [options.scaleX]
     * @param {Number} [options.scaleY]
     * @param {Number} [options.skewX]
     * @param {Number} [options.skewY]
     * @private
     * @returns {Point} dimensions
     */
    _getTransformedDimensions() {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const dimOptions = _objectSpread2({
        // if scaleX or scaleY are negative numbers,
        // this will return dimensions that are negative.
        // and this will break assumptions around the codebase
        scaleX: this.scaleX,
        scaleY: this.scaleY,
        skewX: this.skewX,
        skewY: this.skewY,
        width: this.width,
        height: this.height,
        strokeWidth: this.strokeWidth
      }, options);
      // stroke is applied before/after transformations are applied according to `strokeUniform`
      const strokeWidth = dimOptions.strokeWidth;
      let preScalingStrokeValue = strokeWidth,
        postScalingStrokeValue = 0;
      if (this.strokeUniform) {
        preScalingStrokeValue = 0;
        postScalingStrokeValue = strokeWidth;
      }
      const dimX = dimOptions.width + preScalingStrokeValue,
        dimY = dimOptions.height + preScalingStrokeValue,
        noSkew = dimOptions.skewX === 0 && dimOptions.skewY === 0;
      let finalDimensions;
      if (noSkew) {
        finalDimensions = new Point(dimX * dimOptions.scaleX, dimY * dimOptions.scaleY);
      } else {
        finalDimensions = sizeAfterTransform(dimX, dimY, calcDimensionsMatrix(dimOptions));
      }
      return finalDimensions.scalarAdd(postScalingStrokeValue);
    }

    /**
     * Translates the coordinates from a set of origin to another (based on the object's dimensions)
     * @param {Point} point The point which corresponds to the originX and originY params
     * @param {TOriginX} fromOriginX Horizontal origin: 'left', 'center' or 'right'
     * @param {TOriginY} fromOriginY Vertical origin: 'top', 'center' or 'bottom'
     * @param {TOriginX} toOriginX Horizontal origin: 'left', 'center' or 'right'
     * @param {TOriginY} toOriginY Vertical origin: 'top', 'center' or 'bottom'
     * @return {Point}
     */
    translateToGivenOrigin(point, fromOriginX, fromOriginY, toOriginX, toOriginY) {
      let x = point.x,
        y = point.y;
      const offsetX = resolveOrigin(toOriginX) - resolveOrigin(fromOriginX),
        offsetY = resolveOrigin(toOriginY) - resolveOrigin(fromOriginY);
      if (offsetX || offsetY) {
        const dim = this._getTransformedDimensions();
        x += offsetX * dim.x;
        y += offsetY * dim.y;
      }
      return new Point(x, y);
    }

    /**
     * Translates the coordinates from origin to center coordinates (based on the object's dimensions)
     * @param {Point} point The point which corresponds to the originX and originY params
     * @param {TOriginX} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {TOriginY} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {Point}
     */
    translateToCenterPoint(point, originX, originY) {
      if (originX === CENTER && originY === CENTER) {
        return point;
      }
      const p = this.translateToGivenOrigin(point, originX, originY, CENTER, CENTER);
      if (this.angle) {
        return p.rotate(degreesToRadians(this.angle), point);
      }
      return p;
    }

    /**
     * Translates the coordinates from center to origin coordinates (based on the object's dimensions)
     * @param {Point} center The point which corresponds to center of the object
     * @param {OriginX} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {OriginY} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {Point}
     */
    translateToOriginPoint(center, originX, originY) {
      const p = this.translateToGivenOrigin(center, CENTER, CENTER, originX, originY);
      if (this.angle) {
        return p.rotate(degreesToRadians(this.angle), center);
      }
      return p;
    }

    /**
     * Returns the center coordinates of the object relative to canvas
     * @return {Point}
     */
    getCenterPoint() {
      const relCenter = this.getRelativeCenterPoint();
      return this.group ? transformPoint(relCenter, this.group.calcTransformMatrix()) : relCenter;
    }

    /**
     * Returns the center coordinates of the object relative to it's parent
     * @return {Point}
     */
    getRelativeCenterPoint() {
      return this.translateToCenterPoint(new Point(this.left, this.top), this.originX, this.originY);
    }

    /**
     * Returns the position of the object as if it has a different origin.
     * Take an object that has left, top set to 100, 100 with origin 'left', 'top'.
     * Return the values of left top ( wrapped in a point ) that you would need to keep
     * the same position if origin where different.
     * Alternatively you can use this to also find which point in the parent plane is a specific origin
     * ( where is the bottom right corner of my object? )
     * @param {TOriginX} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {TOriginY} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {Point}
     */
    getPointByOrigin(originX, originY) {
      return this.translateToOriginPoint(this.getRelativeCenterPoint(), originX, originY);
    }

    /**
     * Sets the position of the object taking into consideration the object's origin
     * @param {Point} pos The new position of the object
     * @param {TOriginX} originX Horizontal origin: 'left', 'center' or 'right'
     * @param {TOriginY} originY Vertical origin: 'top', 'center' or 'bottom'
     * @return {void}
     */
    setPositionByOrigin(pos, originX, originY) {
      const center = this.translateToCenterPoint(pos, originX, originY),
        position = this.translateToOriginPoint(center, this.originX, this.originY);
      this.set({
        left: position.x,
        top: position.y
      });
    }

    /**
     * @private
     */
    _getLeftTopCoords() {
      return this.translateToOriginPoint(this.getRelativeCenterPoint(), LEFT, TOP);
    }
  }

  const _excluded$e = ["type"],
    _excluded2$4 = ["extraParam"];
  /**
   * Root object class from which all 2d shape classes inherit from
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#objects}
   *
   * @fires added
   * @fires removed
   *
   * @fires selected
   * @fires deselected
   *
   * @fires rotating
   * @fires scaling
   * @fires moving
   * @fires skewing
   * @fires modified
   *
   * @fires mousedown
   * @fires mouseup
   * @fires mouseover
   * @fires mouseout
   * @fires mousewheel
   * @fires mousedblclick
   *
   * @fires dragover
   * @fires dragenter
   * @fires dragleave
   * @fires drop
   */
  let FabricObject$1 = class FabricObject extends ObjectGeometry {
    static getDefaults() {
      return FabricObject.ownDefaults;
    }

    /**
     * The class type.
     * This is used for serialization and deserialization purposes and internally it can be used
     * to identify classes.
     * When we transform a class in a plain JS object we need a way to recognize which class it was,
     * and the type is the way we do that. It has no other purposes and you should not give one.
     * Hard to reach on instances and please do not use to drive instance's logic (this.constructor.type).
     * To idenfity a class use instanceof class ( instanceof Rect ).
     * We do not do that in fabricJS code because we want to try to have code splitting possible.
     */

    /**
     * Legacy identifier of the class. Prefer using utils like isType or instanceOf
     * Will be removed in fabric 7 or 8.
     * The setter exists to avoid type errors in old code and possibly current deserialization code.
     * DO NOT build new code around this type value
     * @TODO add sustainable warning message
     * @type string
     * @deprecated
     */
    get type() {
      const name = this.constructor.type;
      if (name === 'FabricObject') {
        return 'object';
      }
      return name.toLowerCase();
    }
    set type(value) {
      log('warn', 'Setting type has no effect', value);
    }

    /**
     * Constructor
     * @param {Object} [options] Options object
     */
    constructor(options) {
      super();
      /**
       * Quick access for the _cacheCanvas rendering context
       * This is part of the objectCaching feature
       * since 1.7.0
       * @type boolean
       * @default undefined
       * @private
       */
      _defineProperty(this, "_cacheContext", null);
      Object.assign(this, FabricObject.ownDefaults);
      this.setOptions(options);
    }

    /**
     * Create a the canvas used to keep the cached copy of the object
     * @private
     */
    _createCacheCanvas() {
      this._cacheCanvas = createCanvasElement();
      this._cacheContext = this._cacheCanvas.getContext('2d');
      this._updateCacheCanvas();
      // if canvas gets created, is empty, so dirty.
      this.dirty = true;
    }

    /**
     * Limit the cache dimensions so that X * Y do not cross config.perfLimitSizeTotal
     * and each side do not cross fabric.cacheSideLimit
     * those numbers are configurable so that you can get as much detail as you want
     * making bargain with performances.
     * @param {Object} dims
     * @param {Object} dims.width width of canvas
     * @param {Object} dims.height height of canvas
     * @param {Object} dims.zoomX zoomX zoom value to unscale the canvas before drawing cache
     * @param {Object} dims.zoomY zoomY zoom value to unscale the canvas before drawing cache
     * @return {Object}.width width of canvas
     * @return {Object}.height height of canvas
     * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
     * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
     */
    _limitCacheSize(dims) {
      const width = dims.width,
        height = dims.height,
        max = config.maxCacheSideLimit,
        min = config.minCacheSideLimit;
      if (width <= max && height <= max && width * height <= config.perfLimitSizeTotal) {
        if (width < min) {
          dims.width = min;
        }
        if (height < min) {
          dims.height = min;
        }
        return dims;
      }
      const ar = width / height,
        [limX, limY] = cache.limitDimsByArea(ar),
        x = capValue(min, limX, max),
        y = capValue(min, limY, max);
      if (width > x) {
        dims.zoomX /= width / x;
        dims.width = x;
        dims.capped = true;
      }
      if (height > y) {
        dims.zoomY /= height / y;
        dims.height = y;
        dims.capped = true;
      }
      return dims;
    }

    /**
     * Return the dimension and the zoom level needed to create a cache canvas
     * big enough to host the object to be cached.
     * @private
     * @return {Object}.x width of object to be cached
     * @return {Object}.y height of object to be cached
     * @return {Object}.width width of canvas
     * @return {Object}.height height of canvas
     * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
     * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
     */
    _getCacheCanvasDimensions() {
      const objectScale = this.getTotalObjectScaling(),
        // calculate dimensions without skewing
        dim = this._getTransformedDimensions({
          skewX: 0,
          skewY: 0
        }),
        neededX = dim.x * objectScale.x / this.scaleX,
        neededY = dim.y * objectScale.y / this.scaleY;
      return {
        // for sure this ALIASING_LIMIT is slightly creating problem
        // in situation in which the cache canvas gets an upper limit
        // also objectScale contains already scaleX and scaleY
        width: Math.ceil(neededX + ALIASING_LIMIT),
        height: Math.ceil(neededY + ALIASING_LIMIT),
        zoomX: objectScale.x,
        zoomY: objectScale.y,
        x: neededX,
        y: neededY
      };
    }

    /**
     * Update width and height of the canvas for cache
     * returns true or false if canvas needed resize.
     * @private
     * @return {Boolean} true if the canvas has been resized
     */
    _updateCacheCanvas() {
      const canvas = this._cacheCanvas,
        context = this._cacheContext,
        {
          width,
          height,
          zoomX,
          zoomY,
          x,
          y
        } = this._limitCacheSize(this._getCacheCanvasDimensions()),
        dimensionsChanged = width !== canvas.width || height !== canvas.height,
        zoomChanged = this.zoomX !== zoomX || this.zoomY !== zoomY;
      if (!canvas || !context) {
        return false;
      }
      const shouldRedraw = dimensionsChanged || zoomChanged;
      if (shouldRedraw) {
        if (width !== canvas.width || height !== canvas.height) {
          canvas.width = width;
          canvas.height = height;
        } else {
          context.setTransform(1, 0, 0, 1, 0, 0);
          context.clearRect(0, 0, canvas.width, canvas.height);
        }
        const drawingWidth = x / 2;
        const drawingHeight = y / 2;
        this.cacheTranslationX = Math.round(canvas.width / 2 - drawingWidth) + drawingWidth;
        this.cacheTranslationY = Math.round(canvas.height / 2 - drawingHeight) + drawingHeight;
        context.translate(this.cacheTranslationX, this.cacheTranslationY);
        context.scale(zoomX, zoomY);
        this.zoomX = zoomX;
        this.zoomY = zoomY;
        return true;
      }
      return false;
    }

    /**
     * Sets object's properties from options, for class constructor only.
     * Needs to be overridden for different defaults.
     * @protected
     * @param {Object} [options] Options object
     */
    setOptions() {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this._setOptions(options);
    }

    /**
     * Transforms context when rendering an object
     * @param {CanvasRenderingContext2D} ctx Context
     */
    transform(ctx) {
      const needFullTransform = this.group && !this.group._transformDone || this.group && this.canvas && ctx === this.canvas.contextTop;
      const m = this.calcTransformMatrix(!needFullTransform);
      ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
    }

    /**
     * Return the object scale factor counting also the group scaling
     * @return {Point}
     */
    getObjectScaling() {
      // if the object is a top level one, on the canvas, we go for simple aritmetic
      // otherwise the complex method with angles will return approximations and decimals
      // and will likely kill the cache when not needed
      // https://github.com/fabricjs/fabric.js/issues/7157
      if (!this.group) {
        return new Point(Math.abs(this.scaleX), Math.abs(this.scaleY));
      }
      // if we are inside a group total zoom calculation is complex, we defer to generic matrices
      const options = qrDecompose(this.calcTransformMatrix());
      return new Point(Math.abs(options.scaleX), Math.abs(options.scaleY));
    }

    /**
     * Return the object scale factor counting also the group scaling, zoom and retina
     * @return {Object} object with scaleX and scaleY properties
     */
    getTotalObjectScaling() {
      const scale = this.getObjectScaling();
      if (this.canvas) {
        const zoom = this.canvas.getZoom();
        const retina = this.getCanvasRetinaScaling();
        return scale.scalarMultiply(zoom * retina);
      }
      return scale;
    }

    /**
     * Return the object opacity counting also the group property
     * @return {Number}
     */
    getObjectOpacity() {
      let opacity = this.opacity;
      if (this.group) {
        opacity *= this.group.getObjectOpacity();
      }
      return opacity;
    }

    /**
     * Makes sure the scale is valid and modifies it if necessary
     * @todo: this is a control action issue, not a geometry one
     * @private
     * @param {Number} value, unconstrained
     * @return {Number} constrained value;
     */
    _constrainScale(value) {
      if (Math.abs(value) < this.minScaleLimit) {
        if (value < 0) {
          return -this.minScaleLimit;
        } else {
          return this.minScaleLimit;
        }
      } else if (value === 0) {
        return 0.0001;
      }
      return value;
    }

    /**
     * Handles setting values on the instance and handling internal side effects
     * @protected
     * @param {String} key
     * @param {*} value
     */
    _set(key, value) {
      if (key === SCALE_X || key === SCALE_Y) {
        value = this._constrainScale(value);
      }
      if (key === SCALE_X && value < 0) {
        this.flipX = !this.flipX;
        value *= -1;
      } else if (key === 'scaleY' && value < 0) {
        this.flipY = !this.flipY;
        value *= -1;
        // i don't like this automatic initialization here
      } else if (key === 'shadow' && value && !(value instanceof Shadow)) {
        value = new Shadow(value);
      }
      const isChanged = this[key] !== value;
      this[key] = value;

      // invalidate caches
      if (isChanged && this.constructor.cacheProperties.includes(key)) {
        this.dirty = true;
      }
      // a dirty child makes the parent dirty.
      // but a non dirty child does not make the parent not dirty.
      // the parent could be dirty for some other reason.
      this.parent && (this.dirty || isChanged && this.constructor.stateProperties.includes(key)) && this.parent._set('dirty', true);
      return this;
    }

    /*
     * @private
     * return if the object would be visible in rendering
     * @memberOf FabricObject.prototype
     * @return {Boolean}
     */
    isNotVisible() {
      return this.opacity === 0 || !this.width && !this.height && this.strokeWidth === 0 || !this.visible;
    }

    /**
     * Renders an object on a specified context
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    render(ctx) {
      // do not render if width/height are zeros or object is not visible
      if (this.isNotVisible()) {
        return;
      }
      if (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen()) {
        return;
      }
      ctx.save();
      this._setupCompositeOperation(ctx);
      this.drawSelectionBackground(ctx);
      this.transform(ctx);
      this._setOpacity(ctx);
      this._setShadow(ctx);
      if (this.shouldCache()) {
        this.renderCache();
        this.drawCacheOnCanvas(ctx);
      } else {
        this._removeCacheCanvas();
        this.drawObject(ctx, false, {});
        this.dirty = false;
      }
      ctx.restore();
    }
    drawSelectionBackground(_ctx) {
      /* no op */
    }
    renderCache(options) {
      options = options || {};
      if (!this._cacheCanvas || !this._cacheContext) {
        this._createCacheCanvas();
      }
      if (this.isCacheDirty() && this._cacheContext) {
        const {
          zoomX,
          zoomY,
          cacheTranslationX,
          cacheTranslationY
        } = this;
        const {
          width,
          height
        } = this._cacheCanvas;
        this.drawObject(this._cacheContext, options.forClipping, {
          zoomX,
          zoomY,
          cacheTranslationX,
          cacheTranslationY,
          width,
          height,
          parentClipPaths: []
        });
        this.dirty = false;
      }
    }

    /**
     * Remove cacheCanvas and its dimensions from the objects
     */
    _removeCacheCanvas() {
      this._cacheCanvas = undefined;
      this._cacheContext = null;
    }

    /**
     * return true if the object will draw a stroke
     * Does not consider text styles. This is just a shortcut used at rendering time
     * We want it to be an approximation and be fast.
     * wrote to avoid extra caching, it has to return true when stroke happens,
     * can guess when it will not happen at 100% chance, does not matter if it misses
     * some use case where the stroke is invisible.
     * @since 3.0.0
     * @returns Boolean
     */
    hasStroke() {
      return this.stroke && this.stroke !== 'transparent' && this.strokeWidth !== 0;
    }

    /**
     * return true if the object will draw a fill
     * Does not consider text styles. This is just a shortcut used at rendering time
     * We want it to be an approximation and be fast.
     * wrote to avoid extra caching, it has to return true when fill happens,
     * can guess when it will not happen at 100% chance, does not matter if it misses
     * some use case where the fill is invisible.
     * @since 3.0.0
     * @returns Boolean
     */
    hasFill() {
      return this.fill && this.fill !== 'transparent';
    }

    /**
     * When returns `true`, force the object to have its own cache, even if it is inside a group
     * it may be needed when your object behave in a particular way on the cache and always needs
     * its own isolated canvas to render correctly.
     * Created to be overridden
     * since 1.7.12
     * @returns Boolean
     */
    needsItsOwnCache() {
      // TODO re-evaluate this shadow condition
      if (this.paintFirst === STROKE && this.hasFill() && this.hasStroke() && !!this.shadow) {
        return true;
      }
      if (this.clipPath) {
        return true;
      }
      return false;
    }

    /**
     * Decide if the object should cache or not. Create its own cache level
     * objectCaching is a global flag, wins over everything
     * needsItsOwnCache should be used when the object drawing method requires
     * a cache step.
     * Generally you do not cache objects in groups because the group outside is cached.
     * Read as: cache if is needed, or if the feature is enabled but we are not already caching.
     * @return {Boolean}
     */
    shouldCache() {
      this.ownCaching = this.objectCaching && (!this.parent || !this.parent.isOnACache()) || this.needsItsOwnCache();
      return this.ownCaching;
    }

    /**
     * Check if this object will cast a shadow with an offset.
     * used by Group.shouldCache to know if child has a shadow recursively
     * @return {Boolean}
     * @deprecated
     */
    willDrawShadow() {
      return !!this.shadow && (this.shadow.offsetX !== 0 || this.shadow.offsetY !== 0);
    }

    /**
     * Execute the drawing operation for an object clipPath
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {FabricObject} clipPath
     */
    drawClipPathOnCache(ctx, clipPath, canvasWithClipPath) {
      ctx.save();
      // DEBUG: uncomment this line, comment the following
      // ctx.globalAlpha = 0.4
      if (clipPath.inverted) {
        ctx.globalCompositeOperation = 'destination-out';
      } else {
        ctx.globalCompositeOperation = 'destination-in';
      }
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      ctx.drawImage(canvasWithClipPath, 0, 0);
      ctx.restore();
    }

    /**
     * Execute the drawing operation for an object on a specified context
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {boolean} forClipping apply clipping styles
     * @param {DrawContext} context additional context for rendering
     */
    drawObject(ctx, forClipping, context) {
      const originalFill = this.fill,
        originalStroke = this.stroke;
      if (forClipping) {
        this.fill = 'black';
        this.stroke = '';
        this._setClippingProperties(ctx);
      } else {
        this._renderBackground(ctx);
      }
      this._render(ctx);
      this._drawClipPath(ctx, this.clipPath, context);
      this.fill = originalFill;
      this.stroke = originalStroke;
    }
    createClipPathLayer(clipPath, context) {
      const canvas = createCanvasElementFor(context);
      const ctx = canvas.getContext('2d');
      ctx.translate(context.cacheTranslationX, context.cacheTranslationY);
      ctx.scale(context.zoomX, context.zoomY);
      clipPath._cacheCanvas = canvas;
      context.parentClipPaths.forEach(prevClipPath => {
        prevClipPath.transform(ctx);
      });
      context.parentClipPaths.push(clipPath);
      if (clipPath.absolutePositioned) {
        const m = invertTransform(this.calcTransformMatrix());
        ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
      }
      clipPath.transform(ctx);
      clipPath.drawObject(ctx, true, context);
      return canvas;
    }

    /**
     * Prepare clipPath state and cache and draw it on instance's cache
     * @param {CanvasRenderingContext2D} ctx
     * @param {FabricObject} clipPath
     */
    _drawClipPath(ctx, clipPath, context) {
      if (!clipPath) {
        return;
      }
      // needed to setup _transformDone
      // TODO find a better solution?
      clipPath._transformDone = true;
      const canvas = this.createClipPathLayer(clipPath, context);
      this.drawClipPathOnCache(ctx, clipPath, canvas);
    }

    /**
     * Paint the cached copy of the object on the target context.
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    drawCacheOnCanvas(ctx) {
      ctx.scale(1 / this.zoomX, 1 / this.zoomY);
      ctx.drawImage(this._cacheCanvas, -this.cacheTranslationX, -this.cacheTranslationY);
    }

    /**
     * Check if cache is dirty and if is dirty clear the context.
     * This check has a big side effect, it changes the underlying cache canvas if necessary.
     * Do not call this method on your own to check if the cache is dirty, because if it is,
     * it is also going to wipe the cache. This is badly designed and needs to be fixed.
     * @param {Boolean} skipCanvas skip canvas checks because this object is painted
     * on parent canvas.
     */
    isCacheDirty() {
      let skipCanvas = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.isNotVisible()) {
        return false;
      }
      const canvas = this._cacheCanvas;
      const ctx = this._cacheContext;
      if (canvas && ctx && !skipCanvas && this._updateCacheCanvas()) {
        // in this case the context is already cleared.
        return true;
      } else {
        if (this.dirty || this.clipPath && this.clipPath.absolutePositioned) {
          if (canvas && ctx && !skipCanvas) {
            ctx.save();
            ctx.setTransform(1, 0, 0, 1, 0, 0);
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            ctx.restore();
          }
          return true;
        }
      }
      return false;
    }

    /**
     * Draws a background for the object big as its untransformed dimensions
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderBackground(ctx) {
      if (!this.backgroundColor) {
        return;
      }
      const dim = this._getNonTransformedDimensions();
      ctx.fillStyle = this.backgroundColor;
      ctx.fillRect(-dim.x / 2, -dim.y / 2, dim.x, dim.y);
      // if there is background color no other shadows
      // should be casted
      this._removeShadow(ctx);
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _setOpacity(ctx) {
      if (this.group && !this.group._transformDone) {
        ctx.globalAlpha = this.getObjectOpacity();
      } else {
        ctx.globalAlpha *= this.opacity;
      }
    }
    _setStrokeStyles(ctx, decl) {
      const stroke = decl.stroke;
      if (stroke) {
        ctx.lineWidth = decl.strokeWidth;
        ctx.lineCap = decl.strokeLineCap;
        ctx.lineDashOffset = decl.strokeDashOffset;
        ctx.lineJoin = decl.strokeLineJoin;
        ctx.miterLimit = decl.strokeMiterLimit;
        if (isFiller(stroke)) {
          if (stroke.gradientUnits === 'percentage' || stroke.gradientTransform || stroke.patternTransform) {
            // need to transform gradient in a pattern.
            // this is a slow process. If you are hitting this codepath, and the object
            // is not using caching, you should consider switching it on.
            // we need a canvas as big as the current object caching canvas.
            this._applyPatternForTransformedGradient(ctx, stroke);
          } else {
            // is a simple gradient or pattern
            ctx.strokeStyle = stroke.toLive(ctx);
            this._applyPatternGradientTransform(ctx, stroke);
          }
        } else {
          // is a color
          ctx.strokeStyle = decl.stroke;
        }
      }
    }
    _setFillStyles(ctx, _ref) {
      let {
        fill
      } = _ref;
      if (fill) {
        if (isFiller(fill)) {
          ctx.fillStyle = fill.toLive(ctx);
          this._applyPatternGradientTransform(ctx, fill);
        } else {
          ctx.fillStyle = fill;
        }
      }
    }
    _setClippingProperties(ctx) {
      ctx.globalAlpha = 1;
      ctx.strokeStyle = 'transparent';
      ctx.fillStyle = '#000000';
    }

    /**
     * @private
     * Sets line dash
     * @param {CanvasRenderingContext2D} ctx Context to set the dash line on
     * @param {Array} dashArray array representing dashes
     */
    _setLineDash(ctx, dashArray) {
      if (!dashArray || dashArray.length === 0) {
        return;
      }
      ctx.setLineDash(dashArray);
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _setShadow(ctx) {
      if (!this.shadow) {
        return;
      }
      const shadow = this.shadow,
        canvas = this.canvas,
        retinaScaling = this.getCanvasRetinaScaling(),
        [sx,,, sy] = (canvas === null || canvas === void 0 ? void 0 : canvas.viewportTransform) || iMatrix,
        multX = sx * retinaScaling,
        multY = sy * retinaScaling,
        scaling = shadow.nonScaling ? new Point(1, 1) : this.getObjectScaling();
      ctx.shadowColor = shadow.color;
      ctx.shadowBlur = shadow.blur * config.browserShadowBlurConstant * (multX + multY) * (scaling.x + scaling.y) / 4;
      ctx.shadowOffsetX = shadow.offsetX * multX * scaling.x;
      ctx.shadowOffsetY = shadow.offsetY * multY * scaling.y;
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _removeShadow(ctx) {
      if (!this.shadow) {
        return;
      }
      ctx.shadowColor = '';
      ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {TFiller} filler {@link Pattern} or {@link Gradient}
     */
    _applyPatternGradientTransform(ctx, filler) {
      if (!isFiller(filler)) {
        return {
          offsetX: 0,
          offsetY: 0
        };
      }
      const t = filler.gradientTransform || filler.patternTransform;
      const offsetX = -this.width / 2 + filler.offsetX || 0,
        offsetY = -this.height / 2 + filler.offsetY || 0;
      if (filler.gradientUnits === 'percentage') {
        ctx.transform(this.width, 0, 0, this.height, offsetX, offsetY);
      } else {
        ctx.transform(1, 0, 0, 1, offsetX, offsetY);
      }
      if (t) {
        ctx.transform(t[0], t[1], t[2], t[3], t[4], t[5]);
      }
      return {
        offsetX: offsetX,
        offsetY: offsetY
      };
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderPaintInOrder(ctx) {
      if (this.paintFirst === STROKE) {
        this._renderStroke(ctx);
        this._renderFill(ctx);
      } else {
        this._renderFill(ctx);
        this._renderStroke(ctx);
      }
    }

    /**
     * @private
     * function that actually render something on the context.
     * empty here to allow Obects to work on tests to benchmark fabric functionalites
     * not related to rendering
     * @param {CanvasRenderingContext2D} _ctx Context to render on
     */
    _render(_ctx) {
      // placeholder to be overridden
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderFill(ctx) {
      if (!this.fill) {
        return;
      }
      ctx.save();
      this._setFillStyles(ctx, this);
      if (this.fillRule === 'evenodd') {
        ctx.fill('evenodd');
      } else {
        ctx.fill();
      }
      ctx.restore();
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderStroke(ctx) {
      if (!this.stroke || this.strokeWidth === 0) {
        return;
      }
      if (this.shadow && !this.shadow.affectStroke) {
        this._removeShadow(ctx);
      }
      ctx.save();
      if (this.strokeUniform) {
        const scaling = this.getObjectScaling();
        ctx.scale(1 / scaling.x, 1 / scaling.y);
      }
      this._setLineDash(ctx, this.strokeDashArray);
      this._setStrokeStyles(ctx, this);
      ctx.stroke();
      ctx.restore();
    }

    /**
     * This function try to patch the missing gradientTransform on canvas gradients.
     * transforming a context to transform the gradient, is going to transform the stroke too.
     * we want to transform the gradient but not the stroke operation, so we create
     * a transformed gradient on a pattern and then we use the pattern instead of the gradient.
     * this method has drawbacks: is slow, is in low resolution, needs a patch for when the size
     * is limited.
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Gradient} filler
     */
    _applyPatternForTransformedGradient(ctx, filler) {
      var _pCtx$createPattern;
      const dims = this._limitCacheSize(this._getCacheCanvasDimensions()),
        retinaScaling = this.getCanvasRetinaScaling(),
        width = dims.x / this.scaleX / retinaScaling,
        height = dims.y / this.scaleY / retinaScaling,
        pCanvas = createCanvasElementFor({
          // in case width and height are less than 1px, we have to round up.
          // since the pattern is no-repeat, this is fine
          width: Math.ceil(width),
          height: Math.ceil(height)
        });
      const pCtx = pCanvas.getContext('2d');
      if (!pCtx) {
        return;
      }
      pCtx.beginPath();
      pCtx.moveTo(0, 0);
      pCtx.lineTo(width, 0);
      pCtx.lineTo(width, height);
      pCtx.lineTo(0, height);
      pCtx.closePath();
      pCtx.translate(width / 2, height / 2);
      pCtx.scale(dims.zoomX / this.scaleX / retinaScaling, dims.zoomY / this.scaleY / retinaScaling);
      this._applyPatternGradientTransform(pCtx, filler);
      pCtx.fillStyle = filler.toLive(ctx);
      pCtx.fill();
      ctx.translate(-this.width / 2 - this.strokeWidth / 2, -this.height / 2 - this.strokeWidth / 2);
      ctx.scale(retinaScaling * this.scaleX / dims.zoomX, retinaScaling * this.scaleY / dims.zoomY);
      ctx.strokeStyle = (_pCtx$createPattern = pCtx.createPattern(pCanvas, 'no-repeat')) !== null && _pCtx$createPattern !== void 0 ? _pCtx$createPattern : '';
    }

    /**
     * This function is an helper for svg import. it returns the center of the object in the svg
     * untransformed coordinates
     * @private
     * @return {Point} center point from element coordinates
     */
    _findCenterFromElement() {
      return new Point(this.left + this.width / 2, this.top + this.height / 2);
    }

    /**
     * Clones an instance.
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @returns {Promise<FabricObject>}
     */
    clone(propertiesToInclude) {
      const objectForm = this.toObject(propertiesToInclude);
      return this.constructor.fromObject(objectForm);
    }

    /**
     * Creates an instance of Image out of an object
     * makes use of toCanvasElement.
     * Once this method was based on toDataUrl and loadImage, so it also had a quality
     * and format option. toCanvasElement is faster and produce no loss of quality.
     * If you need to get a real Jpeg or Png from an object, using toDataURL is the right way to do it.
     * toCanvasElement and then toBlob from the obtained canvas is also a good option.
     * @todo fix the export type, it could not be Image but the type that getClass return for 'image'.
     * @param {ObjectToCanvasElementOptions} [options] for clone as image, passed to toDataURL
     * @param {Number} [options.multiplier=1] Multiplier to scale by
     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
     * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
     * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
     * @return {FabricImage} Object cloned as image.
     */
    cloneAsImage(options) {
      const canvasEl = this.toCanvasElement(options);
      // TODO: how to import Image w/o an import cycle?
      const ImageClass = classRegistry.getClass('image');
      return new ImageClass(canvasEl);
    }

    /**
     * Converts an object into a HTMLCanvas element
     * @param {ObjectToCanvasElementOptions} options Options object
     * @param {Number} [options.multiplier=1] Multiplier to scale by
     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
     * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
     * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
     * @param {Boolean} [options.viewportTransform] Account for canvas viewport transform
     * @param {(el?: HTMLCanvasElement) => StaticCanvas} [options.canvasProvider] Create the output canvas
     * @return {HTMLCanvasElement} Returns DOM element <canvas> with the FabricObject
     */
    toCanvasElement() {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const origParams = saveObjectTransform(this),
        originalGroup = this.group,
        originalShadow = this.shadow,
        abs = Math.abs,
        retinaScaling = options.enableRetinaScaling ? getDevicePixelRatio() : 1,
        multiplier = (options.multiplier || 1) * retinaScaling,
        canvasProvider = options.canvasProvider || (el => new StaticCanvas(el, {
          enableRetinaScaling: false,
          renderOnAddRemove: false,
          skipOffscreen: false
        }));
      delete this.group;
      if (options.withoutTransform) {
        resetObjectTransform(this);
      }
      if (options.withoutShadow) {
        this.shadow = null;
      }
      if (options.viewportTransform) {
        sendObjectToPlane(this, this.getViewportTransform());
      }
      this.setCoords();
      const el = createCanvasElement(),
        boundingRect = this.getBoundingRect(),
        shadow = this.shadow,
        shadowOffset = new Point();
      if (shadow) {
        const shadowBlur = shadow.blur;
        const scaling = shadow.nonScaling ? new Point(1, 1) : this.getObjectScaling();
        // consider non scaling shadow.
        shadowOffset.x = 2 * Math.round(abs(shadow.offsetX) + shadowBlur) * abs(scaling.x);
        shadowOffset.y = 2 * Math.round(abs(shadow.offsetY) + shadowBlur) * abs(scaling.y);
      }
      const width = boundingRect.width + shadowOffset.x,
        height = boundingRect.height + shadowOffset.y;
      // if the current width/height is not an integer
      // we need to make it so.
      el.width = Math.ceil(width);
      el.height = Math.ceil(height);
      const canvas = canvasProvider(el);
      if (options.format === 'jpeg') {
        canvas.backgroundColor = '#fff';
      }
      this.setPositionByOrigin(new Point(canvas.width / 2, canvas.height / 2), CENTER, CENTER);
      const originalCanvas = this.canvas;
      // static canvas and canvas have both an array of InteractiveObjects
      // @ts-expect-error this needs to be fixed somehow, or ignored globally
      canvas._objects = [this];
      this.set('canvas', canvas);
      this.setCoords();
      const canvasEl = canvas.toCanvasElement(multiplier || 1, options);
      this.set('canvas', originalCanvas);
      this.shadow = originalShadow;
      if (originalGroup) {
        this.group = originalGroup;
      }
      this.set(origParams);
      this.setCoords();
      // canvas.dispose will call image.dispose that will nullify the elements
      // since this canvas is a simple element for the process, we remove references
      // to objects in this way in order to avoid object trashing.
      canvas._objects = [];
      // since render has settled it is safe to destroy canvas
      canvas.destroy();
      return canvasEl;
    }

    /**
     * Converts an object into a data-url-like string
     * @param {Object} options Options object
     * @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
     * @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
     * @param {Number} [options.multiplier=1] Multiplier to scale by
     * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
     * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
     * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
     * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
     * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
     * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
     * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
     * @return {String} Returns a data: URL containing a representation of the object in the format specified by options.format
     */
    toDataURL() {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return toDataURL(this.toCanvasElement(options), options.format || 'png', options.quality || 1);
    }
    toBlob() {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return toBlob(this.toCanvasElement(options), options.format || 'png', options.quality || 1);
    }

    /**
     * Returns true if any of the specified types is identical to the type of an instance
     * @param {String} type Type to check against
     * @return {Boolean}
     */
    isType() {
      for (var _len = arguments.length, types = new Array(_len), _key = 0; _key < _len; _key++) {
        types[_key] = arguments[_key];
      }
      return types.includes(this.constructor.type) || types.includes(this.type);
    }

    /**
     * Returns complexity of an instance
     * @return {Number} complexity of this instance (is 1 unless subclassed)
     */
    complexity() {
      return 1;
    }

    /**
     * Returns a JSON representation of an instance
     * @return {Object} JSON
     */
    toJSON() {
      // delegate, not alias
      return this.toObject();
    }

    /**
     * Sets "angle" of an instance with centered rotation
     * @param {TDegree} angle Angle value (in degrees)
     */
    rotate(angle) {
      const {
        centeredRotation,
        originX,
        originY
      } = this;
      if (centeredRotation) {
        const {
          x,
          y
        } = this.getRelativeCenterPoint();
        this.originX = CENTER;
        this.originY = CENTER;
        this.left = x;
        this.top = y;
      }
      this.set('angle', angle);
      if (centeredRotation) {
        const {
          x,
          y
        } = this.translateToOriginPoint(this.getRelativeCenterPoint(), originX, originY);
        this.left = x;
        this.top = y;
        this.originX = originX;
        this.originY = originY;
      }
    }

    /**
     * This callback function is called by the parent group of an object every
     * time a non-delegated property changes on the group. It is passed the key
     * and value as parameters. Not adding in this function's signature to avoid
     * Travis build error about unused variables.
     */
    setOnGroup() {
      // implemented by sub-classes, as needed.
    }

    /**
     * Sets canvas globalCompositeOperation for specific object
     * custom composition operation for the particular object can be specified using globalCompositeOperation property
     * @param {CanvasRenderingContext2D} ctx Rendering canvas context
     */
    _setupCompositeOperation(ctx) {
      if (this.globalCompositeOperation) {
        ctx.globalCompositeOperation = this.globalCompositeOperation;
      }
    }

    /**
     * cancel instance's running animations
     * override if necessary to dispose artifacts such as `clipPath`
     */
    dispose() {
      runningAnimations.cancelByTarget(this);
      this.off();
      this._set('canvas', undefined);
      // clear caches
      this._cacheCanvas && getEnv().dispose(this._cacheCanvas);
      this._cacheCanvas = undefined;
      this._cacheContext = null;
    }

    // #region Animation methods
    /**
     * List of properties to consider for animating colors.
     * @type String[]
     */

    /**
     * Animates object's properties
     * @param {Record<string, number | number[] | TColorArg>} animatable map of keys and end values
     * @param {Partial<AnimationOptions<T>>} options
     * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#animation}
     * @return {Record<string, TAnimation<T>>} map of animation contexts
     *
     * As object — multiple properties
     *
     * object.animate({ left: ..., top: ... });
     * object.animate({ left: ..., top: ... }, { duration: ... });
     */
    animate(animatable, options) {
      return Object.entries(animatable).reduce((acc, _ref2) => {
        let [key, endValue] = _ref2;
        acc[key] = this._animate(key, endValue, options);
        return acc;
      }, {});
    }

    /**
     * @private
     * @param {String} key Property to animate
     * @param {String} to Value to animate to
     * @param {Object} [options] Options object
     */
    _animate(key, endValue) {
      let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      const path = key.split('.');
      const propIsColor = this.constructor.colorProperties.includes(path[path.length - 1]);
      const {
        abort,
        startValue,
        onChange,
        onComplete
      } = options;
      const animationOptions = _objectSpread2(_objectSpread2({}, options), {}, {
        target: this,
        // path.reduce... is the current value in case start value isn't provided
        startValue: startValue !== null && startValue !== void 0 ? startValue : path.reduce((deep, key) => deep[key], this),
        endValue,
        abort: abort === null || abort === void 0 ? void 0 : abort.bind(this),
        onChange: (value, valueProgress, durationProgress) => {
          path.reduce((deep, key, index) => {
            if (index === path.length - 1) {
              deep[key] = value;
            }
            return deep[key];
          }, this);
          onChange &&
          // @ts-expect-error generic callback arg0 is wrong
          onChange(value, valueProgress, durationProgress);
        },
        onComplete: (value, valueProgress, durationProgress) => {
          this.setCoords();
          onComplete &&
          // @ts-expect-error generic callback arg0 is wrong
          onComplete(value, valueProgress, durationProgress);
        }
      });
      return propIsColor ? animateColor(animationOptions) : animate(animationOptions);
    }

    // #region Object stacking methods

    /**
     * A reference to the parent of the object
     * Used to keep the original parent ref when the object has been added to an ActiveSelection, hence loosing the `group` ref
     */

    /**
     * Checks if object is descendant of target
     * Should be used instead of {@link Group.contains} or {@link StaticCanvas.contains} for performance reasons
     * @param {TAncestor} target
     * @returns {boolean}
     */
    isDescendantOf(target) {
      const {
        parent,
        group
      } = this;
      return parent === target || group === target ||
      // walk up
      !!parent && parent.isDescendantOf(target) || !!group && group !== parent && group.isDescendantOf(target);
    }

    /**
     * @returns {Ancestors} ancestors (excluding `ActiveSelection`) from bottom to top
     */
    getAncestors() {
      const ancestors = [];
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      let parent = this;
      do {
        parent = parent.parent;
        parent && ancestors.push(parent);
      } while (parent);
      return ancestors;
    }

    /**
     * Compare ancestors
     *
     * @param {StackedObject} other
     * @returns {AncestryComparison} an object that represent the ancestry situation.
     */
    findCommonAncestors(other) {
      if (this === other) {
        return {
          fork: [],
          otherFork: [],
          common: [this, ...this.getAncestors()]
        };
      }
      const ancestors = this.getAncestors();
      const otherAncestors = other.getAncestors();
      //  if `this` has no ancestors and `this` is top ancestor of `other` we must handle the following case
      if (ancestors.length === 0 && otherAncestors.length > 0 && this === otherAncestors[otherAncestors.length - 1]) {
        return {
          fork: [],
          otherFork: [other, ...otherAncestors.slice(0, otherAncestors.length - 1)],
          common: [this]
        };
      }
      //  compare ancestors
      for (let i = 0, ancestor; i < ancestors.length; i++) {
        ancestor = ancestors[i];
        if (ancestor === other) {
          return {
            fork: [this, ...ancestors.slice(0, i)],
            otherFork: [],
            common: ancestors.slice(i)
          };
        }
        for (let j = 0; j < otherAncestors.length; j++) {
          if (this === otherAncestors[j]) {
            return {
              fork: [],
              otherFork: [other, ...otherAncestors.slice(0, j)],
              common: [this, ...ancestors]
            };
          }
          if (ancestor === otherAncestors[j]) {
            return {
              fork: [this, ...ancestors.slice(0, i)],
              otherFork: [other, ...otherAncestors.slice(0, j)],
              common: ancestors.slice(i)
            };
          }
        }
      }
      // nothing shared
      return {
        fork: [this, ...ancestors],
        otherFork: [other, ...otherAncestors],
        common: []
      };
    }

    /**
     *
     * @param {StackedObject} other
     * @returns {boolean}
     */
    hasCommonAncestors(other) {
      const commonAncestors = this.findCommonAncestors(other);
      return commonAncestors && !!commonAncestors.common.length;
    }

    /**
     *
     * @param {FabricObject} other object to compare against
     * @returns {boolean | undefined} if objects do not share a common ancestor or they are strictly equal it is impossible to determine which is in front of the other; in such cases the function returns `undefined`
     */
    isInFrontOf(other) {
      if (this === other) {
        return undefined;
      }
      const ancestorData = this.findCommonAncestors(other);
      if (ancestorData.fork.includes(other)) {
        return true;
      }
      if (ancestorData.otherFork.includes(this)) {
        return false;
      }
      // if there isn't a common ancestor, we take the canvas.
      // if there is no canvas, there is nothing to compare
      const firstCommonAncestor = ancestorData.common[0] || this.canvas;
      if (!firstCommonAncestor) {
        return undefined;
      }
      const headOfFork = ancestorData.fork.pop(),
        headOfOtherFork = ancestorData.otherFork.pop(),
        thisIndex = firstCommonAncestor._objects.indexOf(headOfFork),
        otherIndex = firstCommonAncestor._objects.indexOf(headOfOtherFork);
      return thisIndex > -1 && thisIndex > otherIndex;
    }

    // #region Serialization
    /**
     * Define a list of custom properties that will be serialized when
     * instance.toObject() gets called
     */

    /**
     * Returns an object representation of an instance
     * @param {string[]} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */
    toObject() {
      let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      const propertiesToSerialize = propertiesToInclude.concat(FabricObject.customProperties, this.constructor.customProperties || []);
      let clipPathData;
      const NUM_FRACTION_DIGITS = config.NUM_FRACTION_DIGITS;
      const {
        clipPath,
        fill,
        stroke,
        shadow,
        strokeDashArray,
        left,
        top,
        originX,
        originY,
        width,
        height,
        strokeWidth,
        strokeLineCap,
        strokeDashOffset,
        strokeLineJoin,
        strokeUniform,
        strokeMiterLimit,
        scaleX,
        scaleY,
        angle,
        flipX,
        flipY,
        opacity,
        visible,
        backgroundColor,
        fillRule,
        paintFirst,
        globalCompositeOperation,
        skewX,
        skewY
      } = this;
      if (clipPath && !clipPath.excludeFromExport) {
        clipPathData = clipPath.toObject(propertiesToSerialize.concat('inverted', 'absolutePositioned'));
      }
      const toFixedBound = val => toFixed(val, NUM_FRACTION_DIGITS);
      const object = _objectSpread2(_objectSpread2({}, pick(this, propertiesToSerialize)), {}, {
        type: this.constructor.type,
        version: VERSION,
        originX,
        originY,
        left: toFixedBound(left),
        top: toFixedBound(top),
        width: toFixedBound(width),
        height: toFixedBound(height),
        fill: isSerializableFiller(fill) ? fill.toObject() : fill,
        stroke: isSerializableFiller(stroke) ? stroke.toObject() : stroke,
        strokeWidth: toFixedBound(strokeWidth),
        strokeDashArray: strokeDashArray ? strokeDashArray.concat() : strokeDashArray,
        strokeLineCap,
        strokeDashOffset,
        strokeLineJoin,
        strokeUniform,
        strokeMiterLimit: toFixedBound(strokeMiterLimit),
        scaleX: toFixedBound(scaleX),
        scaleY: toFixedBound(scaleY),
        angle: toFixedBound(angle),
        flipX,
        flipY,
        opacity: toFixedBound(opacity),
        shadow: shadow ? shadow.toObject() : shadow,
        visible,
        backgroundColor,
        fillRule,
        paintFirst,
        globalCompositeOperation,
        skewX: toFixedBound(skewX),
        skewY: toFixedBound(skewY)
      }, clipPathData ? {
        clipPath: clipPathData
      } : null);
      return !this.includeDefaultValues ? this._removeDefaultValues(object) : object;
    }

    /**
     * Returns (dataless) object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */
    toDatalessObject(propertiesToInclude) {
      // will be overwritten by subclasses
      return this.toObject(propertiesToInclude);
    }

    /**
     * @private
     * @param {Object} object
     */
    _removeDefaultValues(object) {
      // getDefaults() ( get from static ownDefaults ) should win over prototype since anyway they get assigned to instance
      // ownDefault vs prototype is swappable only if you change all the fabric objects consistently.
      const defaults = this.constructor.getDefaults();
      const hasStaticDefaultValues = Object.keys(defaults).length > 0;
      const baseValues = hasStaticDefaultValues ? defaults : Object.getPrototypeOf(this);
      return pickBy(object, (value, key) => {
        if (key === LEFT || key === TOP || key === 'type') {
          return true;
        }
        const baseValue = baseValues[key];
        return value !== baseValue &&
        // basically a check for [] === []
        !(Array.isArray(value) && Array.isArray(baseValue) && value.length === 0 && baseValue.length === 0);
      });
    }

    /**
     * Returns a string representation of an instance
     * @return {String}
     */
    toString() {
      return "#<".concat(this.constructor.type, ">");
    }

    /**
     *
     * @param {Function} klass
     * @param {object} object
     * @param {object} [options]
     * @param {string} [options.extraParam] property to pass as first argument to the constructor
     * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
     * @returns {Promise<FabricObject>}
     */
    static _fromObject(_ref3) {
      let serializedObjectOptions = _objectWithoutProperties(_ref3, _excluded$e);
      let _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        {
          extraParam
        } = _ref4,
        options = _objectWithoutProperties(_ref4, _excluded2$4);
      return enlivenObjectEnlivables(serializedObjectOptions, options).then(enlivedObjectOptions => {
        // from the resulting enlived options, extract options.extraParam to arg0
        // to avoid accidental overrides later
        if (extraParam) {
          delete enlivedObjectOptions[extraParam];
          return new this(serializedObjectOptions[extraParam],
          // @ts-expect-error different signature
          enlivedObjectOptions);
        } else {
          return new this(enlivedObjectOptions);
        }
      });
    }

    /**
     *
     * @param {object} object
     * @param {object} [options]
     * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
     * @returns {Promise<FabricObject>}
     */
    static fromObject(object, options) {
      return this._fromObject(object, options);
    }
  };
  /**
   * This list of properties is used to check if the state of an object is changed.
   * This state change now is only used for children of groups to understand if a group
   * needs its cache regenerated during a .set call
   * @type Array
   */
  _defineProperty(FabricObject$1, "stateProperties", stateProperties);
  /**
   * List of properties to consider when checking if cache needs refresh
   * Those properties are checked by
   * calls to Object.set(key, value). If the key is in this list, the object is marked as dirty
   * and refreshed at the next render
   * @type Array
   */
  _defineProperty(FabricObject$1, "cacheProperties", cacheProperties);
  _defineProperty(FabricObject$1, "ownDefaults", fabricObjectDefaultValues);
  _defineProperty(FabricObject$1, "type", 'FabricObject');
  _defineProperty(FabricObject$1, "colorProperties", [FILL, STROKE, 'backgroundColor']);
  _defineProperty(FabricObject$1, "customProperties", []);
  classRegistry.setClass(FabricObject$1);
  classRegistry.setClass(FabricObject$1, 'object');

  /**
   * Wrap an action handler with firing an event if the action is performed
   * @param {TModificationEvents} eventName the event we want to fire
   * @param {TransformActionHandler<T>} actionHandler the function to wrap
   * @param {object} extraEventInfo extra information to pas to the event handler
   * @return {TransformActionHandler<T>} a function with an action handler signature
   */
  const wrapWithFireEvent = (eventName, actionHandler, extraEventInfo) => {
    return (eventData, transform, x, y) => {
      const actionPerformed = actionHandler(eventData, transform, x, y);
      if (actionPerformed) {
        fireEvent(eventName, _objectSpread2(_objectSpread2({}, commonEventInfo(eventData, transform, x, y)), extraEventInfo));
      }
      return actionPerformed;
    };
  };

  /**
   * Wrap an action handler with saving/restoring object position on the transform.
   * this is the code that permits to objects to keep their position while transforming.
   * @param {Function} actionHandler the function to wrap
   * @return {Function} a function with an action handler signature
   */
  function wrapWithFixedAnchor(actionHandler) {
    return (eventData, transform, x, y) => {
      const {
          target,
          originX,
          originY
        } = transform,
        centerPoint = target.getRelativeCenterPoint(),
        constraint = target.translateToOriginPoint(centerPoint, originX, originY),
        actionPerformed = actionHandler(eventData, transform, x, y);
      // flipping requires to change the transform origin, so we read from the mutated transform
      // instead of leveraging the one destructured before
      target.setPositionByOrigin(constraint, transform.originX, transform.originY);
      return actionPerformed;
    };
  }

  /**
   * Action handler to change object's width
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */
  const changeObjectWidth = (eventData, transform, x, y) => {
    const localPoint = getLocalPoint(transform, transform.originX, transform.originY, x, y);
    //  make sure the control changes width ONLY from it's side of target
    if (resolveOrigin(transform.originX) === resolveOrigin(CENTER) || resolveOrigin(transform.originX) === resolveOrigin(RIGHT) && localPoint.x < 0 || resolveOrigin(transform.originX) === resolveOrigin(LEFT) && localPoint.x > 0) {
      const {
          target
        } = transform,
        strokePadding = target.strokeWidth / (target.strokeUniform ? target.scaleX : 1),
        multiplier = isTransformCentered(transform) ? 2 : 1,
        oldWidth = target.width,
        newWidth = Math.abs(localPoint.x * multiplier / target.scaleX) - strokePadding;
      target.set('width', Math.max(newWidth, 1));
      //  check against actual target width in case `newWidth` was rejected
      return oldWidth !== target.width;
    }
    return false;
  };
  const changeWidth = wrapWithFireEvent(RESIZING, wrapWithFixedAnchor(changeObjectWidth));

  /**
   * Render a round control, as per fabric features.
   * This function is written to respect object properties like transparentCorners, cornerSize
   * cornerColor, cornerStrokeColor
   * plus the addition of offsetY and offsetX.
   * @param {CanvasRenderingContext2D} ctx context to render on
   * @param {Number} left x coordinate where the control center should be
   * @param {Number} top y coordinate where the control center should be
   * @param {Object} styleOverride override for FabricObject controls style
   * @param {FabricObject} fabricObject the fabric object for which we are rendering controls
   */
  function renderCircleControl(ctx, left, top, styleOverride, fabricObject) {
    styleOverride = styleOverride || {};
    const xSize = this.sizeX || styleOverride.cornerSize || fabricObject.cornerSize,
      ySize = this.sizeY || styleOverride.cornerSize || fabricObject.cornerSize,
      transparentCorners = typeof styleOverride.transparentCorners !== 'undefined' ? styleOverride.transparentCorners : fabricObject.transparentCorners,
      methodName = transparentCorners ? STROKE : FILL,
      stroke = !transparentCorners && (styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor);
    let myLeft = left,
      myTop = top,
      size;
    ctx.save();
    ctx.fillStyle = styleOverride.cornerColor || fabricObject.cornerColor || '';
    ctx.strokeStyle = styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor || '';
    // TODO: use proper ellipse code.
    if (xSize > ySize) {
      size = xSize;
      ctx.scale(1.0, ySize / xSize);
      myTop = top * xSize / ySize;
    } else if (ySize > xSize) {
      size = ySize;
      ctx.scale(xSize / ySize, 1.0);
      myLeft = left * ySize / xSize;
    } else {
      size = xSize;
    }
    ctx.beginPath();
    ctx.arc(myLeft, myTop, size / 2, 0, twoMathPi, false);
    ctx[methodName]();
    if (stroke) {
      ctx.stroke();
    }
    ctx.restore();
  }

  /**
   * Render a square control, as per fabric features.
   * This function is written to respect object properties like transparentCorners, cornerSize
   * cornerColor, cornerStrokeColor
   * plus the addition of offsetY and offsetX.
   * @param {CanvasRenderingContext2D} ctx context to render on
   * @param {Number} left x coordinate where the control center should be
   * @param {Number} top y coordinate where the control center should be
   * @param {Object} styleOverride override for FabricObject controls style
   * @param {FabricObject} fabricObject the fabric object for which we are rendering controls
   */
  function renderSquareControl(ctx, left, top, styleOverride, fabricObject) {
    styleOverride = styleOverride || {};
    const xSize = this.sizeX || styleOverride.cornerSize || fabricObject.cornerSize,
      ySize = this.sizeY || styleOverride.cornerSize || fabricObject.cornerSize,
      transparentCorners = typeof styleOverride.transparentCorners !== 'undefined' ? styleOverride.transparentCorners : fabricObject.transparentCorners,
      methodName = transparentCorners ? STROKE : FILL,
      stroke = !transparentCorners && (styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor),
      xSizeBy2 = xSize / 2,
      ySizeBy2 = ySize / 2;
    ctx.save();
    ctx.fillStyle = styleOverride.cornerColor || fabricObject.cornerColor || '';
    ctx.strokeStyle = styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor || '';
    ctx.translate(left, top);
    //  angle is relative to canvas plane
    const angle = fabricObject.getTotalAngle();
    ctx.rotate(degreesToRadians(angle));
    // this does not work, and fixed with ( && ) does not make sense.
    // to have real transparent corners we need the controls on upperCanvas
    // transparentCorners || ctx.clearRect(-xSizeBy2, -ySizeBy2, xSize, ySize);
    ctx["".concat(methodName, "Rect")](-xSizeBy2, -ySizeBy2, xSize, ySize);
    if (stroke) {
      ctx.strokeRect(-xSizeBy2, -ySizeBy2, xSize, ySize);
    }
    ctx.restore();
  }

  class Control {
    constructor(options) {
      /**
       * keep track of control visibility.
       * mainly for backward compatibility.
       * if you do not want to see a control, you can remove it
       * from the control set.
       * @type {Boolean}
       * @default true
       */
      _defineProperty(this, "visible", true);
      /**
       * Name of the action that the control will likely execute.
       * This is optional. FabricJS uses to identify what the user is doing for some
       * extra optimizations. If you are writing a custom control and you want to know
       * somewhere else in the code what is going on, you can use this string here.
       * you can also provide a custom getActionName if your control run multiple actions
       * depending on some external state.
       * default to scale since is the most common, used on 4 corners by default
       * @type {String}
       * @default 'scale'
       */
      _defineProperty(this, "actionName", SCALE);
      /**
       * Drawing angle of the control.
       * NOT used for now, but name marked as needed for internal logic
       * example: to reuse the same drawing function for different rotated controls
       * @type {Number}
       * @default 0
       */
      _defineProperty(this, "angle", 0);
      /**
       * Relative position of the control. X
       * 0,0 is the center of the Object, while -0.5 (left) or 0.5 (right) are the extremities
       * of the bounding box.
       * @type {Number}
       * @default 0
       */
      _defineProperty(this, "x", 0);
      /**
       * Relative position of the control. Y
       * 0,0 is the center of the Object, while -0.5 (top) or 0.5 (bottom) are the extremities
       * of the bounding box.
       * @type {Number}
       * @default 0
       */
      _defineProperty(this, "y", 0);
      /**
       * Horizontal offset of the control from the defined position. In pixels
       * Positive offset moves the control to the right, negative to the left.
       * It used when you want to have position of control that does not scale with
       * the bounding box. Example: rotation control is placed at x:0, y: 0.5 on
       * the boundind box, with an offset of 30 pixels vertically. Those 30 pixels will
       * stay 30 pixels no matter how the object is big. Another example is having 2
       * controls in the corner, that stay in the same position when the object scale.
       * of the bounding box.
       * @type {Number}
       * @default 0
       */
      _defineProperty(this, "offsetX", 0);
      /**
       * Vertical offset of the control from the defined position. In pixels
       * Positive offset moves the control to the bottom, negative to the top.
       * @type {Number}
       * @default 0
       */
      _defineProperty(this, "offsetY", 0);
      /**
       * Sets the length of the control. If null, defaults to object's cornerSize.
       * Expects both sizeX and sizeY to be set when set.
       * @type {?Number}
       * @default null
       */
      _defineProperty(this, "sizeX", 0);
      /**
       * Sets the height of the control. If null, defaults to object's cornerSize.
       * Expects both sizeX and sizeY to be set when set.
       * @type {?Number}
       * @default null
       */
      _defineProperty(this, "sizeY", 0);
      /**
       * Sets the length of the touch area of the control. If null, defaults to object's touchCornerSize.
       * Expects both touchSizeX and touchSizeY to be set when set.
       * @type {?Number}
       * @default null
       */
      _defineProperty(this, "touchSizeX", 0);
      /**
       * Sets the height of the touch area of the control. If null, defaults to object's touchCornerSize.
       * Expects both touchSizeX and touchSizeY to be set when set.
       * @type {?Number}
       * @default null
       */
      _defineProperty(this, "touchSizeY", 0);
      /**
       * Css cursor style to display when the control is hovered.
       * if the method `cursorStyleHandler` is provided, this property is ignored.
       * @type {String}
       * @default 'crosshair'
       */
      _defineProperty(this, "cursorStyle", 'crosshair');
      /**
       * If controls has an offsetY or offsetX, draw a line that connects
       * the control to the bounding box
       * @type {Boolean}
       * @default false
       */
      _defineProperty(this, "withConnection", false);
      Object.assign(this, options);
    }

    /**
     * The control actionHandler, provide one to handle action ( control being moved )
     * @param {Event} eventData the native mouse event
     * @param {Transform} transformData properties of the current transform
     * @param {Number} x x position of the cursor
     * @param {Number} y y position of the cursor
     * @return {Boolean} true if the action/event modified the object
     */

    /**
     * The control handler for mouse down, provide one to handle mouse down on control
     * @param {Event} eventData the native mouse event
     * @param {Transform} transformData properties of the current transform
     * @param {Number} x x position of the cursor
     * @param {Number} y y position of the cursor
     * @return {Boolean} true if the action/event modified the object
     */

    /**
     * The control mouseUpHandler, provide one to handle an effect on mouse up.
     * @param {Event} eventData the native mouse event
     * @param {Transform} transformData properties of the current transform
     * @param {Number} x x position of the cursor
     * @param {Number} y y position of the cursor
     * @return {Boolean} true if the action/event modified the object
     */

    shouldActivate(controlKey, fabricObject, pointer, _ref) {
      var _fabricObject$canvas;
      let {
        tl,
        tr,
        br,
        bl
      } = _ref;
      // TODO: locking logic can be handled here instead of in the control handler logic
      return ((_fabricObject$canvas = fabricObject.canvas) === null || _fabricObject$canvas === void 0 ? void 0 : _fabricObject$canvas.getActiveObject()) === fabricObject && fabricObject.isControlVisible(controlKey) && Intersection.isPointInPolygon(pointer, [tl, tr, br, bl]);
    }

    /**
     * Returns control actionHandler
     * @param {Event} eventData the native mouse event
     * @param {FabricObject} fabricObject on which the control is displayed
     * @param {Control} control control for which the action handler is being asked
     * @return {Function} the action handler
     */
    getActionHandler(eventData, fabricObject, control) {
      return this.actionHandler;
    }

    /**
     * Returns control mouseDown handler
     * @param {Event} eventData the native mouse event
     * @param {FabricObject} fabricObject on which the control is displayed
     * @param {Control} control control for which the action handler is being asked
     * @return {Function} the action handler
     */
    getMouseDownHandler(eventData, fabricObject, control) {
      return this.mouseDownHandler;
    }

    /**
     * Returns control mouseUp handler.
     * During actions the fabricObject or the control can be of different obj
     * @param {Event} eventData the native mouse event
     * @param {FabricObject} fabricObject on which the control is displayed
     * @param {Control} control control for which the action handler is being asked
     * @return {Function} the action handler
     */
    getMouseUpHandler(eventData, fabricObject, control) {
      return this.mouseUpHandler;
    }

    /**
     * Returns control cursorStyle for css using cursorStyle. If you need a more elaborate
     * function you can pass one in the constructor
     * the cursorStyle property
     * @param {Event} eventData the native mouse event
     * @param {Control} control the current control ( likely this)
     * @param {FabricObject} object on which the control is displayed
     * @return {String}
     */
    cursorStyleHandler(eventData, control, fabricObject) {
      return control.cursorStyle;
    }

    /**
     * Returns the action name. The basic implementation just return the actionName property.
     * @param {Event} eventData the native mouse event
     * @param {Control} control the current control ( likely this)
     * @param {FabricObject} object on which the control is displayed
     * @return {String}
     */
    getActionName(eventData, control, fabricObject) {
      return control.actionName;
    }

    /**
     * Returns controls visibility
     * @param {FabricObject} object on which the control is displayed
     * @param {String} controlKey key where the control is memorized on the
     * @return {Boolean}
     */
    getVisibility(fabricObject, controlKey) {
      var _fabricObject$_contro, _fabricObject$_contro2;
      return (_fabricObject$_contro = (_fabricObject$_contro2 = fabricObject._controlsVisibility) === null || _fabricObject$_contro2 === void 0 ? void 0 : _fabricObject$_contro2[controlKey]) !== null && _fabricObject$_contro !== void 0 ? _fabricObject$_contro : this.visible;
    }

    /**
     * Sets controls visibility
     * @param {Boolean} visibility for the object
     * @return {Void}
     */
    setVisibility(visibility, name, fabricObject) {
      this.visible = visibility;
    }
    positionHandler(dim, finalMatrix, fabricObject, currentControl) {
      return new Point(this.x * dim.x + this.offsetX, this.y * dim.y + this.offsetY).transform(finalMatrix);
    }

    /**
     * Returns the coords for this control based on object values.
     * @param {Number} objectAngle angle from the fabric object holding the control
     * @param {Number} objectCornerSize cornerSize from the fabric object holding the control (or touchCornerSize if
     *   isTouch is true)
     * @param {Number} centerX x coordinate where the control center should be
     * @param {Number} centerY y coordinate where the control center should be
     * @param {boolean} isTouch true if touch corner, false if normal corner
     */
    calcCornerCoords(angle, objectCornerSize, centerX, centerY, isTouch, fabricObject) {
      const t = multiplyTransformMatrixArray([createTranslateMatrix(centerX, centerY), createRotateMatrix({
        angle
      }), createScaleMatrix((isTouch ? this.touchSizeX : this.sizeX) || objectCornerSize, (isTouch ? this.touchSizeY : this.sizeY) || objectCornerSize)]);
      return {
        tl: new Point(-0.5, -0.5).transform(t),
        tr: new Point(0.5, -0.5).transform(t),
        br: new Point(0.5, 0.5).transform(t),
        bl: new Point(-0.5, 0.5).transform(t)
      };
    }

    /**
     * Render function for the control.
     * When this function runs the context is unscaled. unrotate. Just retina scaled.
     * all the functions will have to translate to the point left,top before starting Drawing
     * if they want to draw a control where the position is detected.
     * left and top are the result of the positionHandler function
     * @param {RenderingContext2D} ctx the context where the control will be drawn
     * @param {Number} left position of the canvas where we are about to render the control.
     * @param {Number} top position of the canvas where we are about to render the control.
     * @param {Object} styleOverride
     * @param {FabricObject} fabricObject the object where the control is about to be rendered
     */
    render(ctx, left, top, styleOverride, fabricObject) {
      styleOverride = styleOverride || {};
      switch (styleOverride.cornerStyle || fabricObject.cornerStyle) {
        case 'circle':
          renderCircleControl.call(this, ctx, left, top, styleOverride, fabricObject);
          break;
        default:
          renderSquareControl.call(this, ctx, left, top, styleOverride, fabricObject);
      }
    }
  }

  /**
   * Find the correct style for the control that is used for rotation.
   * this function is very simple and it just take care of not-allowed or standard cursor
   * @param {Event} eventData the javascript event that is causing the scale
   * @param {Control} control the control that is interested in the action
   * @param {FabricObject} fabricObject the fabric object that is interested in the action
   * @return {String} a valid css string for the cursor
   */
  const rotationStyleHandler = (eventData, control, fabricObject) => {
    if (fabricObject.lockRotation) {
      return NOT_ALLOWED_CURSOR;
    }
    return control.cursorStyle;
  };

  /**
   * Action handler for rotation and snapping, without anchor point.
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   * @private
   */
  const rotateObjectWithSnapping = (eventData, _ref, x, y) => {
    let {
      target,
      ex,
      ey,
      theta,
      originX,
      originY
    } = _ref;
    const pivotPoint = target.translateToOriginPoint(target.getRelativeCenterPoint(), originX, originY);
    if (isLocked(target, 'lockRotation')) {
      return false;
    }
    const lastAngle = Math.atan2(ey - pivotPoint.y, ex - pivotPoint.x),
      curAngle = Math.atan2(y - pivotPoint.y, x - pivotPoint.x);
    let angle = radiansToDegrees(curAngle - lastAngle + theta);
    if (target.snapAngle && target.snapAngle > 0) {
      const snapAngle = target.snapAngle,
        snapThreshold = target.snapThreshold || snapAngle,
        rightAngleLocked = Math.ceil(angle / snapAngle) * snapAngle,
        leftAngleLocked = Math.floor(angle / snapAngle) * snapAngle;
      if (Math.abs(angle - leftAngleLocked) < snapThreshold) {
        angle = leftAngleLocked;
      } else if (Math.abs(angle - rightAngleLocked) < snapThreshold) {
        angle = rightAngleLocked;
      }
    }

    // normalize angle to positive value
    if (angle < 0) {
      angle = 360 + angle;
    }
    angle %= 360;
    const hasRotated = target.angle !== angle;
    // TODO: why aren't we using set?
    target.angle = angle;
    return hasRotated;
  };
  const rotationWithSnapping = wrapWithFireEvent(ROTATING, wrapWithFixedAnchor(rotateObjectWithSnapping));

  /**
   * Inspect event and fabricObject properties to understand if the scaling action
   * @param {Event} eventData from the user action
   * @param {FabricObject} fabricObject the fabric object about to scale
   * @return {Boolean} true if scale is proportional
   */
  function scaleIsProportional(eventData, fabricObject) {
    const canvas = fabricObject.canvas,
      uniformIsToggled = eventData[canvas.uniScaleKey];
    return canvas.uniformScaling && !uniformIsToggled || !canvas.uniformScaling && uniformIsToggled;
  }

  /**
   * Inspect fabricObject to understand if the current scaling action is allowed
   * @param {FabricObject} fabricObject the fabric object about to scale
   * @param {String} by 'x' or 'y' or ''
   * @param {Boolean} scaleProportionally true if we are trying to scale proportionally
   * @return {Boolean} true if scaling is not allowed at current conditions
   */
  function scalingIsForbidden(fabricObject, by, scaleProportionally) {
    const lockX = isLocked(fabricObject, 'lockScalingX'),
      lockY = isLocked(fabricObject, 'lockScalingY');
    if (lockX && lockY) {
      return true;
    }
    if (!by && (lockX || lockY) && scaleProportionally) {
      return true;
    }
    if (lockX && by === 'x') {
      return true;
    }
    if (lockY && by === 'y') {
      return true;
    }
    // code crashes because of a division by 0 if a 0 sized object is scaled
    // forbid to prevent scaling to happen. ISSUE-9475
    const {
      width,
      height,
      strokeWidth
    } = fabricObject;
    if (width === 0 && strokeWidth === 0 && by !== 'y') {
      return true;
    }
    if (height === 0 && strokeWidth === 0 && by !== 'x') {
      return true;
    }
    return false;
  }
  const scaleMap = ['e', 'se', 's', 'sw', 'w', 'nw', 'n', 'ne', 'e'];

  /**
   * return the correct cursor style for the scale action
   * @param {Event} eventData the javascript event that is causing the scale
   * @param {Control} control the control that is interested in the action
   * @param {FabricObject} fabricObject the fabric object that is interested in the action
   * @return {String} a valid css string for the cursor
   */
  const scaleCursorStyleHandler = (eventData, control, fabricObject) => {
    const scaleProportionally = scaleIsProportional(eventData, fabricObject),
      by = control.x !== 0 && control.y === 0 ? 'x' : control.x === 0 && control.y !== 0 ? 'y' : '';
    if (scalingIsForbidden(fabricObject, by, scaleProportionally)) {
      return NOT_ALLOWED_CURSOR;
    }
    const n = findCornerQuadrant(fabricObject, control);
    return "".concat(scaleMap[n], "-resize");
  };

  /**
   * Basic scaling logic, reused with different constrain for scaling X,Y, freely or equally.
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @param {Object} options additional information for scaling
   * @param {String} options.by 'x', 'y', 'equally' or '' to indicate type of scaling
   * @return {Boolean} true if some change happened
   * @private
   */
  function scaleObject(eventData, transform, x, y) {
    let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    const target = transform.target,
      by = options.by,
      scaleProportionally = scaleIsProportional(eventData, target),
      forbidScaling = scalingIsForbidden(target, by, scaleProportionally);
    let newPoint, scaleX, scaleY, dim, signX, signY;
    if (forbidScaling) {
      return false;
    }
    if (transform.gestureScale) {
      scaleX = transform.scaleX * transform.gestureScale;
      scaleY = transform.scaleY * transform.gestureScale;
    } else {
      newPoint = getLocalPoint(transform, transform.originX, transform.originY, x, y);
      // use of sign: We use sign to detect change of direction of an action. sign usually change when
      // we cross the origin point with the mouse. So a scale flip for example. There is an issue when scaling
      // by center and scaling using one middle control ( default: mr, mt, ml, mb), the mouse movement can easily
      // cross many time the origin point and flip the object. so we need a way to filter out the noise.
      // This ternary here should be ok to filter out X scaling when we want Y only and vice versa.
      signX = by !== 'y' ? Math.sign(newPoint.x || transform.signX || 1) : 1;
      signY = by !== 'x' ? Math.sign(newPoint.y || transform.signY || 1) : 1;
      if (!transform.signX) {
        transform.signX = signX;
      }
      if (!transform.signY) {
        transform.signY = signY;
      }
      if (isLocked(target, 'lockScalingFlip') && (transform.signX !== signX || transform.signY !== signY)) {
        return false;
      }
      dim = target._getTransformedDimensions();
      // missing detection of flip and logic to switch the origin
      if (scaleProportionally && !by) {
        // uniform scaling
        const distance = Math.abs(newPoint.x) + Math.abs(newPoint.y),
          {
            original
          } = transform,
          originalDistance = Math.abs(dim.x * original.scaleX / target.scaleX) + Math.abs(dim.y * original.scaleY / target.scaleY),
          scale = distance / originalDistance;
        scaleX = original.scaleX * scale;
        scaleY = original.scaleY * scale;
      } else {
        scaleX = Math.abs(newPoint.x * target.scaleX / dim.x);
        scaleY = Math.abs(newPoint.y * target.scaleY / dim.y);
      }
      // if we are scaling by center, we need to double the scale
      if (isTransformCentered(transform)) {
        scaleX *= 2;
        scaleY *= 2;
      }
      if (transform.signX !== signX && by !== 'y') {
        transform.originX = invertOrigin(transform.originX);
        scaleX *= -1;
        transform.signX = signX;
      }
      if (transform.signY !== signY && by !== 'x') {
        transform.originY = invertOrigin(transform.originY);
        scaleY *= -1;
        transform.signY = signY;
      }
    }
    // minScale is taken care of in the setter.
    const oldScaleX = target.scaleX,
      oldScaleY = target.scaleY;
    if (!by) {
      !isLocked(target, 'lockScalingX') && target.set(SCALE_X, scaleX);
      !isLocked(target, 'lockScalingY') && target.set(SCALE_Y, scaleY);
    } else {
      // forbidden cases already handled on top here.
      by === 'x' && target.set(SCALE_X, scaleX);
      by === 'y' && target.set(SCALE_Y, scaleY);
    }
    return oldScaleX !== target.scaleX || oldScaleY !== target.scaleY;
  }

  /**
   * Generic scaling logic, to scale from corners either equally or freely.
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */
  const scaleObjectFromCorner = (eventData, transform, x, y) => {
    return scaleObject(eventData, transform, x, y);
  };

  /**
   * Scaling logic for the X axis.
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */
  const scaleObjectX = (eventData, transform, x, y) => {
    return scaleObject(eventData, transform, x, y, {
      by: 'x'
    });
  };

  /**
   * Scaling logic for the Y axis.
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */
  const scaleObjectY = (eventData, transform, x, y) => {
    return scaleObject(eventData, transform, x, y, {
      by: 'y'
    });
  };
  const scalingEqually = wrapWithFireEvent(SCALING, wrapWithFixedAnchor(scaleObjectFromCorner));
  const scalingX = wrapWithFireEvent(SCALING, wrapWithFixedAnchor(scaleObjectX));
  const scalingY = wrapWithFireEvent(SCALING, wrapWithFixedAnchor(scaleObjectY));

  const _excluded$d = ["target", "ex", "ey", "skewingSide"];
  const AXIS_KEYS = {
    x: {
      counterAxis: 'y',
      scale: SCALE_X,
      skew: SKEW_X,
      lockSkewing: 'lockSkewingX',
      origin: 'originX',
      flip: 'flipX'
    },
    y: {
      counterAxis: 'x',
      scale: SCALE_Y,
      skew: SKEW_Y,
      lockSkewing: 'lockSkewingY',
      origin: 'originY',
      flip: 'flipY'
    }
  };
  const skewMap = ['ns', 'nesw', 'ew', 'nwse'];

  /**
   * return the correct cursor style for the skew action
   * @param {Event} eventData the javascript event that is causing the scale
   * @param {Control} control the control that is interested in the action
   * @param {FabricObject} fabricObject the fabric object that is interested in the action
   * @return {String} a valid css string for the cursor
   */
  const skewCursorStyleHandler = (eventData, control, fabricObject) => {
    if (control.x !== 0 && isLocked(fabricObject, 'lockSkewingY')) {
      return NOT_ALLOWED_CURSOR;
    }
    if (control.y !== 0 && isLocked(fabricObject, 'lockSkewingX')) {
      return NOT_ALLOWED_CURSOR;
    }
    const n = findCornerQuadrant(fabricObject, control) % 4;
    return "".concat(skewMap[n], "-resize");
  };

  /**
   * Since skewing is applied before scaling, calculations are done in a scaleless plane
   * @see https://github.com/fabricjs/fabric.js/pull/8380
   */
  function skewObject(axis, _ref, pointer) {
    let {
        target,
        ex,
        ey,
        skewingSide
      } = _ref,
      transform = _objectWithoutProperties(_ref, _excluded$d);
    const {
        skew: skewKey
      } = AXIS_KEYS[axis],
      offset = pointer.subtract(new Point(ex, ey)).divide(new Point(target.scaleX, target.scaleY))[axis],
      skewingBefore = target[skewKey],
      skewingStart = transform[skewKey],
      shearingStart = Math.tan(degreesToRadians(skewingStart)),
      // let a, b be the size of target
      // let a' be the value of a after applying skewing
      // then:
      // a' = a + b * skewA => skewA = (a' - a) / b
      // the value b is tricky since skewY is applied before skewX
      b = axis === 'y' ? target._getTransformedDimensions({
        scaleX: 1,
        scaleY: 1,
        // since skewY is applied before skewX, b (=width) is not affected by skewX
        skewX: 0
      }).x : target._getTransformedDimensions({
        scaleX: 1,
        scaleY: 1
      }).y;
    const shearing = 2 * offset * skewingSide /
    // we max out fractions to safeguard from asymptotic behavior
    Math.max(b, 1) +
    // add starting state
    shearingStart;
    const skewing = radiansToDegrees(Math.atan(shearing));
    target.set(skewKey, skewing);
    const changed = skewingBefore !== target[skewKey];
    if (changed && axis === 'y') {
      // we don't want skewing to affect scaleX
      // so we factor it by the inverse skewing diff to make it seem unchanged to the viewer
      const {
          skewX,
          scaleX
        } = target,
        dimBefore = target._getTransformedDimensions({
          skewY: skewingBefore
        }),
        dimAfter = target._getTransformedDimensions(),
        compensationFactor = skewX !== 0 ? dimBefore.x / dimAfter.x : 1;
      compensationFactor !== 1 && target.set(SCALE_X, compensationFactor * scaleX);
    }
    return changed;
  }

  /**
   * Wrapped Action handler for skewing on a given axis, takes care of the
   * skew direction and determines the correct transform origin for the anchor point
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */
  function skewHandler(axis, eventData, transform, x, y) {
    const {
        target
      } = transform,
      {
        counterAxis,
        origin: originKey,
        lockSkewing: lockSkewingKey,
        skew: skewKey,
        flip: flipKey
      } = AXIS_KEYS[axis];
    if (isLocked(target, lockSkewingKey)) {
      return false;
    }
    const {
        origin: counterOriginKey,
        flip: counterFlipKey
      } = AXIS_KEYS[counterAxis],
      counterOriginFactor = resolveOrigin(transform[counterOriginKey]) * (target[counterFlipKey] ? -1 : 1),
      // if the counter origin is top/left (= -0.5) then we are skewing x/y values on the bottom/right side of target respectively.
      // if the counter origin is bottom/right (= 0.5) then we are skewing x/y values on the top/left side of target respectively.
      // skewing direction on the top/left side of target is OPPOSITE to the direction of the movement of the pointer,
      // so we factor skewing direction by this value.
      skewingSide = -Math.sign(counterOriginFactor) * (target[flipKey] ? -1 : 1),
      skewingDirection = (target[skewKey] === 0 &&
      // in case skewing equals 0 we use the pointer offset from target center to determine the direction of skewing
      getLocalPoint(transform, CENTER, CENTER, x, y)[axis] > 0 ||
      // in case target has skewing we use that as the direction
      target[skewKey] > 0 ? 1 : -1) * skewingSide,
      // anchor to the opposite side of the skewing direction
      // normalize value from [-1, 1] to origin value [0, 1]
      origin = -skewingDirection * 0.5 + 0.5;
    const finalHandler = wrapWithFireEvent(SKEWING, wrapWithFixedAnchor((eventData, transform, x, y) => skewObject(axis, transform, new Point(x, y))));
    return finalHandler(eventData, _objectSpread2(_objectSpread2({}, transform), {}, {
      [originKey]: origin,
      skewingSide
    }), x, y);
  }

  /**
   * Wrapped Action handler for skewing on the X axis, takes care of the
   * skew direction and determines the correct transform origin for the anchor point
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */
  const skewHandlerX = (eventData, transform, x, y) => {
    return skewHandler('x', eventData, transform, x, y);
  };

  /**
   * Wrapped Action handler for skewing on the Y axis, takes care of the
   * skew direction and determines the correct transform origin for the anchor point
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */
  const skewHandlerY = (eventData, transform, x, y) => {
    return skewHandler('y', eventData, transform, x, y);
  };

  function isAltAction(eventData, target) {
    return eventData[target.canvas.altActionKey];
  }

  /**
   * Inspect event, control and fabricObject to return the correct action name
   * @param {Event} eventData the javascript event that is causing the scale
   * @param {Control} control the control that is interested in the action
   * @param {FabricObject} fabricObject the fabric object that is interested in the action
   * @return {String} an action name
   */
  const scaleOrSkewActionName = (eventData, control, fabricObject) => {
    const isAlternative = isAltAction(eventData, fabricObject);
    if (control.x === 0) {
      // then is scaleY or skewX
      return isAlternative ? SKEW_X : SCALE_Y;
    }
    if (control.y === 0) {
      // then is scaleY or skewX
      return isAlternative ? SKEW_Y : SCALE_X;
    }
    return '';
  };

  /**
   * Combine skew and scale style handlers to cover fabric standard use case
   * @param {Event} eventData the javascript event that is causing the scale
   * @param {Control} control the control that is interested in the action
   * @param {FabricObject} fabricObject the fabric object that is interested in the action
   * @return {String} a valid css string for the cursor
   */
  const scaleSkewCursorStyleHandler = (eventData, control, fabricObject) => {
    return isAltAction(eventData, fabricObject) ? skewCursorStyleHandler(eventData, control, fabricObject) : scaleCursorStyleHandler(eventData, control, fabricObject);
  };
  /**
   * Composed action handler to either scale X or skew Y
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */
  const scalingXOrSkewingY = (eventData, transform, x, y) => {
    return isAltAction(eventData, transform.target) ? skewHandlerY(eventData, transform, x, y) : scalingX(eventData, transform, x, y);
  };

  /**
   * Composed action handler to either scale Y or skew X
   * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
   * @param {Event} eventData javascript event that is doing the transform
   * @param {Object} transform javascript object containing a series of information around the current transform
   * @param {number} x current mouse x position, canvas normalized
   * @param {number} y current mouse y position, canvas normalized
   * @return {Boolean} true if some change happened
   */
  const scalingYOrSkewingX = (eventData, transform, x, y) => {
    return isAltAction(eventData, transform.target) ? skewHandlerX(eventData, transform, x, y) : scalingY(eventData, transform, x, y);
  };

  // use this function if you want to generate new controls for every instance
  const createObjectDefaultControls = () => ({
    ml: new Control({
      x: -0.5,
      y: 0,
      cursorStyleHandler: scaleSkewCursorStyleHandler,
      actionHandler: scalingXOrSkewingY,
      getActionName: scaleOrSkewActionName
    }),
    mr: new Control({
      x: 0.5,
      y: 0,
      cursorStyleHandler: scaleSkewCursorStyleHandler,
      actionHandler: scalingXOrSkewingY,
      getActionName: scaleOrSkewActionName
    }),
    mb: new Control({
      x: 0,
      y: 0.5,
      cursorStyleHandler: scaleSkewCursorStyleHandler,
      actionHandler: scalingYOrSkewingX,
      getActionName: scaleOrSkewActionName
    }),
    mt: new Control({
      x: 0,
      y: -0.5,
      cursorStyleHandler: scaleSkewCursorStyleHandler,
      actionHandler: scalingYOrSkewingX,
      getActionName: scaleOrSkewActionName
    }),
    tl: new Control({
      x: -0.5,
      y: -0.5,
      cursorStyleHandler: scaleCursorStyleHandler,
      actionHandler: scalingEqually
    }),
    tr: new Control({
      x: 0.5,
      y: -0.5,
      cursorStyleHandler: scaleCursorStyleHandler,
      actionHandler: scalingEqually
    }),
    bl: new Control({
      x: -0.5,
      y: 0.5,
      cursorStyleHandler: scaleCursorStyleHandler,
      actionHandler: scalingEqually
    }),
    br: new Control({
      x: 0.5,
      y: 0.5,
      cursorStyleHandler: scaleCursorStyleHandler,
      actionHandler: scalingEqually
    }),
    mtr: new Control({
      x: 0,
      y: -0.5,
      actionHandler: rotationWithSnapping,
      cursorStyleHandler: rotationStyleHandler,
      offsetY: -40,
      withConnection: true,
      actionName: ROTATE
    })
  });
  const createResizeControls = () => ({
    mr: new Control({
      x: 0.5,
      y: 0,
      actionHandler: changeWidth,
      cursorStyleHandler: scaleSkewCursorStyleHandler,
      actionName: RESIZING
    }),
    ml: new Control({
      x: -0.5,
      y: 0,
      actionHandler: changeWidth,
      cursorStyleHandler: scaleSkewCursorStyleHandler,
      actionName: RESIZING
    })
  });
  const createTextboxDefaultControls = () => _objectSpread2(_objectSpread2({}, createObjectDefaultControls()), createResizeControls());

  class InteractiveFabricObject extends FabricObject$1 {
    static getDefaults() {
      return _objectSpread2(_objectSpread2({}, super.getDefaults()), InteractiveFabricObject.ownDefaults);
    }

    /**
     * Constructor
     * @param {Object} [options] Options object
     */
    constructor(options) {
      super();
      Object.assign(this, this.constructor.createControls(), InteractiveFabricObject.ownDefaults);
      this.setOptions(options);
    }

    /**
     * Creates the default control object.
     * If you prefer to have on instance of controls shared among all objects
     * make this function return an empty object and add controls to the ownDefaults
     * @param {Object} [options] Options object
     */
    static createControls() {
      return {
        controls: createObjectDefaultControls()
      };
    }

    /**
     * Update width and height of the canvas for cache
     * returns true or false if canvas needed resize.
     * @private
     * @return {Boolean} true if the canvas has been resized
     */
    _updateCacheCanvas() {
      const targetCanvas = this.canvas;
      if (this.noScaleCache && targetCanvas && targetCanvas._currentTransform) {
        const transform = targetCanvas._currentTransform,
          target = transform.target,
          action = transform.action;
        if (this === target && action && action.startsWith(SCALE)) {
          return false;
        }
      }
      return super._updateCacheCanvas();
    }
    getActiveControl() {
      const key = this.__corner;
      return key ? {
        key,
        control: this.controls[key],
        coord: this.oCoords[key]
      } : undefined;
    }

    /**
     * Determines which corner is under the mouse cursor, represented by `pointer`.
     * This function is return a corner only if the object is the active one.
     * This is done to avoid selecting corner of non active object and activating transformations
     * rather than drag action. The default behavior of fabricJS is that if you want to transform
     * an object, first you select it to show the control set
     * @private
     * @param {Object} pointer The pointer indicating the mouse position
     * @param {boolean} forTouch indicates if we are looking for interaction area with a touch action
     * @return {String|Boolean} corner code (tl, tr, bl, br, etc.), or 0 if nothing is found.
     */
    findControl(pointer) {
      let forTouch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!this.hasControls || !this.canvas) {
        return undefined;
      }
      this.__corner = undefined;
      const cornerEntries = Object.entries(this.oCoords);
      for (let i = cornerEntries.length - 1; i >= 0; i--) {
        const [key, corner] = cornerEntries[i];
        const control = this.controls[key];
        if (control.shouldActivate(key, this, pointer, forTouch ? corner.touchCorner : corner.corner)) {
          // this.canvas.contextTop.fillRect(pointer.x - 1, pointer.y - 1, 2, 2);
          this.__corner = key;
          return {
            key,
            control,
            coord: this.oCoords[key]
          };
        }
      }
      return undefined;
    }

    /**
     * Calculates the coordinates of the center of each control plus the corners of the control itself
     * This basically just delegates to each control positionHandler
     * WARNING: changing what is passed to positionHandler is a breaking change, since position handler
     * is a public api and should be done just if extremely necessary
     * @return {Record<string, TOCoord>}
     */
    calcOCoords() {
      const vpt = this.getViewportTransform(),
        center = this.getCenterPoint(),
        tMatrix = createTranslateMatrix(center.x, center.y),
        rMatrix = createRotateMatrix({
          angle: this.getTotalAngle() - (!!this.group && this.flipX ? 180 : 0)
        }),
        positionMatrix = multiplyTransformMatrices(tMatrix, rMatrix),
        startMatrix = multiplyTransformMatrices(vpt, positionMatrix),
        finalMatrix = multiplyTransformMatrices(startMatrix, [1 / vpt[0], 0, 0, 1 / vpt[3], 0, 0]),
        transformOptions = this.group ? qrDecompose(this.calcTransformMatrix()) : undefined;
      // decomposing could bring negative scaling and `_calculateCurrentDimensions` can't take it
      if (transformOptions) {
        transformOptions.scaleX = Math.abs(transformOptions.scaleX);
        transformOptions.scaleY = Math.abs(transformOptions.scaleY);
      }
      const dim = this._calculateCurrentDimensions(transformOptions),
        coords = {};
      this.forEachControl((control, key) => {
        const position = control.positionHandler(dim, finalMatrix, this, control);
        // coords[key] are sometimes used as points. Those are points to which we add
        // the property corner and touchCorner from `_calcCornerCoords`.
        // don't remove this assign for an object spread.
        coords[key] = Object.assign(position, this._calcCornerCoords(control, position));
      });

      // debug code
      /*
        const canvas = this.canvas;
        setTimeout(function () {
        if (!canvas) return;
          canvas.contextTop.clearRect(0, 0, 700, 700);
          canvas.contextTop.fillStyle = 'green';
          Object.keys(coords).forEach(function(key) {
            const control = coords[key];
            canvas.contextTop.fillRect(control.x, control.y, 3, 3);
          });
        } 50);
      */
      return coords;
    }

    /**
     * Sets the coordinates that determine the interaction area of each control
     * note: if we would switch to ROUND corner area, all of this would disappear.
     * everything would resolve to a single point and a pythagorean theorem for the distance
     * @todo evaluate simplification of code switching to circle interaction area at runtime
     * @private
     */
    _calcCornerCoords(control, position) {
      const angle = this.getTotalAngle();
      const corner = control.calcCornerCoords(angle, this.cornerSize, position.x, position.y, false, this);
      const touchCorner = control.calcCornerCoords(angle, this.touchCornerSize, position.x, position.y, true, this);
      return {
        corner,
        touchCorner
      };
    }

    /**
     * @override set controls' coordinates as well
     * See {@link https://github.com/fabricjs/fabric.js/wiki/When-to-call-setCoords} and {@link http://fabricjs.com/fabric-gotchas}
     * @return {void}
     */
    setCoords() {
      super.setCoords();
      this.canvas && (this.oCoords = this.calcOCoords());
    }

    /**
     * Calls a function for each control. The function gets called,
     * with the control, the control's key and the object that is calling the iterator
     * @param {Function} fn function to iterate over the controls over
     */
    forEachControl(fn) {
      for (const i in this.controls) {
        fn(this.controls[i], i, this);
      }
    }

    /**
     * Draws a colored layer behind the object, inside its selection borders.
     * Requires public options: padding, selectionBackgroundColor
     * this function is called when the context is transformed
     * has checks to be skipped when the object is on a staticCanvas
     * @todo evaluate if make this disappear in favor of a pre-render hook for objects
     * this was added by Andrea Bogazzi to make possible some feature for work reasons
     * it seemed a good option, now is an edge case
     * @param {CanvasRenderingContext2D} ctx Context to draw on
     */
    drawSelectionBackground(ctx) {
      if (!this.selectionBackgroundColor || this.canvas && this.canvas._activeObject !== this) {
        return;
      }
      ctx.save();
      const center = this.getRelativeCenterPoint(),
        wh = this._calculateCurrentDimensions(),
        vpt = this.getViewportTransform();
      ctx.translate(center.x, center.y);
      ctx.scale(1 / vpt[0], 1 / vpt[3]);
      ctx.rotate(degreesToRadians(this.angle));
      ctx.fillStyle = this.selectionBackgroundColor;
      ctx.fillRect(-wh.x / 2, -wh.y / 2, wh.x, wh.y);
      ctx.restore();
    }

    /**
     * @public override this function in order to customize the drawing of the control box, e.g. rounded corners, different border style.
     * @param {CanvasRenderingContext2D} ctx ctx is rotated and translated so that (0,0) is at object's center
     * @param {Point} size the control box size used
     */
    strokeBorders(ctx, size) {
      ctx.strokeRect(-size.x / 2, -size.y / 2, size.x, size.y);
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to draw on
     * @param {Point} size
     * @param {TStyleOverride} styleOverride object to override the object style
     */
    _drawBorders(ctx, size) {
      let styleOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      const options = _objectSpread2({
        hasControls: this.hasControls,
        borderColor: this.borderColor,
        borderDashArray: this.borderDashArray
      }, styleOverride);
      ctx.save();
      ctx.strokeStyle = options.borderColor;
      this._setLineDash(ctx, options.borderDashArray);
      this.strokeBorders(ctx, size);
      options.hasControls && this.drawControlsConnectingLines(ctx, size);
      ctx.restore();
    }

    /**
     * Renders controls and borders for the object
     * the context here is not transformed
     * @todo move to interactivity
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {TStyleOverride} [styleOverride] properties to override the object style
     */
    _renderControls(ctx) {
      let styleOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      const {
        hasBorders,
        hasControls
      } = this;
      const styleOptions = _objectSpread2({
        hasBorders,
        hasControls
      }, styleOverride);
      const vpt = this.getViewportTransform(),
        shouldDrawBorders = styleOptions.hasBorders,
        shouldDrawControls = styleOptions.hasControls;
      const matrix = multiplyTransformMatrices(vpt, this.calcTransformMatrix());
      const options = qrDecompose(matrix);
      ctx.save();
      ctx.translate(options.translateX, options.translateY);
      ctx.lineWidth = this.borderScaleFactor; // 1 * this.borderScaleFactor;
      // since interactive groups have been introduced, an object could be inside a group and needing controls
      // the following equality check `this.group === this.parent` covers:
      // object without a group ( undefined === undefined )
      // object inside a group
      // excludes object inside a group but multi selected since group and parent will differ in value
      if (this.group === this.parent) {
        ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
      }
      if (this.flipX) {
        options.angle -= 180;
      }
      ctx.rotate(degreesToRadians(this.group ? options.angle : this.angle));
      shouldDrawBorders && this.drawBorders(ctx, options, styleOverride);
      shouldDrawControls && this.drawControls(ctx, styleOverride);
      ctx.restore();
    }

    /**
     * Draws borders of an object's bounding box.
     * Requires public properties: width, height
     * Requires public options: padding, borderColor
     * @param {CanvasRenderingContext2D} ctx Context to draw on
     * @param {object} options object representing current object parameters
     * @param {TStyleOverride} [styleOverride] object to override the object style
     */
    drawBorders(ctx, options, styleOverride) {
      let size;
      if (styleOverride && styleOverride.forActiveSelection || this.group) {
        const bbox = sizeAfterTransform(this.width, this.height, calcDimensionsMatrix(options)),
          stroke = !this.isStrokeAccountedForInDimensions() ? (this.strokeUniform ? new Point().scalarAdd(this.canvas ? this.canvas.getZoom() : 1) :
          // this is extremely confusing. options comes from the upper function
          // and is the qrDecompose of a matrix that takes in account zoom too
          new Point(options.scaleX, options.scaleY)).scalarMultiply(this.strokeWidth) : ZERO;
        size = bbox.add(stroke).scalarAdd(this.borderScaleFactor).scalarAdd(this.padding * 2);
      } else {
        size = this._calculateCurrentDimensions().scalarAdd(this.borderScaleFactor);
      }
      this._drawBorders(ctx, size, styleOverride);
    }

    /**
     * Draws lines from a borders of an object's bounding box to controls that have `withConnection` property set.
     * Requires public properties: width, height
     * Requires public options: padding, borderColor
     * @param {CanvasRenderingContext2D} ctx Context to draw on
     * @param {Point} size object size x = width, y = height
     */
    drawControlsConnectingLines(ctx, size) {
      let shouldStroke = false;
      ctx.beginPath();
      this.forEachControl((control, key) => {
        // in this moment, the ctx is centered on the object.
        // width and height of the above function are the size of the bbox.
        if (control.withConnection && control.getVisibility(this, key)) {
          // reset movement for each control
          shouldStroke = true;
          ctx.moveTo(control.x * size.x, control.y * size.y);
          ctx.lineTo(control.x * size.x + control.offsetX, control.y * size.y + control.offsetY);
        }
      });
      shouldStroke && ctx.stroke();
    }

    /**
     * Draws corners of an object's bounding box.
     * Requires public properties: width, height
     * Requires public options: cornerSize, padding
     * Be aware that since fabric 6.0 this function does not call setCoords anymore.
     * setCoords needs to be called manually if the object of which we are rendering controls
     * is outside the standard selection and transform process.
     * @param {CanvasRenderingContext2D} ctx Context to draw on
     * @param {ControlRenderingStyleOverride} styleOverride object to override the object style
     */
    drawControls(ctx) {
      let styleOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      ctx.save();
      const retinaScaling = this.getCanvasRetinaScaling();
      const {
        cornerStrokeColor,
        cornerDashArray,
        cornerColor
      } = this;
      const options = _objectSpread2({
        cornerStrokeColor,
        cornerDashArray,
        cornerColor
      }, styleOverride);
      ctx.setTransform(retinaScaling, 0, 0, retinaScaling, 0, 0);
      ctx.strokeStyle = ctx.fillStyle = options.cornerColor;
      if (!this.transparentCorners) {
        ctx.strokeStyle = options.cornerStrokeColor;
      }
      this._setLineDash(ctx, options.cornerDashArray);
      this.forEachControl((control, key) => {
        if (control.getVisibility(this, key)) {
          const p = this.oCoords[key];
          control.render(ctx, p.x, p.y, options, this);
        }
      });
      ctx.restore();
    }

    /**
     * Returns true if the specified control is visible, false otherwise.
     * @param {string} controlKey The key of the control. Possible values are usually 'tl', 'tr', 'br', 'bl', 'ml', 'mt', 'mr', 'mb', 'mtr',
     * but since the control api allow for any control name, can be any string.
     * @returns {boolean} true if the specified control is visible, false otherwise
     */
    isControlVisible(controlKey) {
      return this.controls[controlKey] && this.controls[controlKey].getVisibility(this, controlKey);
    }

    /**
     * Sets the visibility of the specified control.
     * please do not use.
     * @param {String} controlKey The key of the control. Possible values are 'tl', 'tr', 'br', 'bl', 'ml', 'mt', 'mr', 'mb', 'mtr'.
     * but since the control api allow for any control name, can be any string.
     * @param {Boolean} visible true to set the specified control visible, false otherwise
     * @todo discuss this overlap of priority here with the team. Andrea Bogazzi for details
     */
    setControlVisible(controlKey, visible) {
      if (!this._controlsVisibility) {
        this._controlsVisibility = {};
      }
      this._controlsVisibility[controlKey] = visible;
    }

    /**
     * Sets the visibility state of object controls, this is just a bulk option for setControlVisible;
     * @param {Record<string, boolean>} [options] with an optional key per control
     * example: {Boolean} [options.bl] true to enable the bottom-left control, false to disable it
     */
    setControlsVisibility() {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      Object.entries(options).forEach(_ref => {
        let [controlKey, visibility] = _ref;
        return this.setControlVisible(controlKey, visibility);
      });
    }

    /**
     * Clears the canvas.contextTop in a specific area that corresponds to the object's bounding box
     * that is in the canvas.contextContainer.
     * This function is used to clear pieces of contextTop where we render ephemeral effects on top of the object.
     * Example: blinking cursor text selection, drag effects.
     * @todo discuss swapping restoreManually with a renderCallback, but think of async issues
     * @param {Boolean} [restoreManually] When true won't restore the context after clear, in order to draw something else.
     * @return {CanvasRenderingContext2D|undefined} canvas.contextTop that is either still transformed
     * with the object transformMatrix, or restored to neutral transform
     */
    clearContextTop(restoreManually) {
      if (!this.canvas) {
        return;
      }
      const ctx = this.canvas.contextTop;
      if (!ctx) {
        return;
      }
      const v = this.canvas.viewportTransform;
      ctx.save();
      ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
      this.transform(ctx);
      // we add 4 pixel, to be sure to do not leave any pixel out
      const width = this.width + 4,
        height = this.height + 4;
      ctx.clearRect(-width / 2, -height / 2, width, height);
      restoreManually || ctx.restore();
      return ctx;
    }

    /**
     * This callback function is called every time _discardActiveObject or _setActiveObject
     * try to to deselect this object. If the function returns true, the process is cancelled
     * @param {Object} [_options] options sent from the upper functions
     * @param {TPointerEvent} [options.e] event if the process is generated by an event
     * @param {FabricObject} [options.object] next object we are setting as active, and reason why
     * this is being deselected
     */
    onDeselect(_options) {
      // implemented by sub-classes, as needed.
      return false;
    }

    /**
     * This callback function is called every time _discardActiveObject or _setActiveObject
     * try to to select this object. If the function returns true, the process is cancelled
     * @param {Object} [_options] options sent from the upper functions
     * @param {Event} [_options.e] event if the process is generated by an event
     */
    onSelect(_options) {
      // implemented by sub-classes, as needed.
      return false;
    }

    /**
     * Override to customize Drag behavior
     * Fired from {@link Canvas#_onMouseMove}
     * @returns true in order for the window to start a drag session
     */
    shouldStartDragging(_e) {
      return false;
    }

    /**
     * Override to customize Drag behavior\
     * Fired once a drag session has started
     * @returns true to handle the drag event
     */
    onDragStart(_e) {
      return false;
    }

    /**
     * Override to customize drag and drop behavior
     * @public
     * @param {DragEvent} _e
     * @returns {boolean} true if the object currently dragged can be dropped on the target
     */
    canDrop(_e) {
      return false;
    }

    /**
     * Override to customize drag and drop behavior
     * render a specific effect when an object is the source of a drag event
     * example: render the selection status for the part of text that is being dragged from a text object
     * @public
     * @param {DragEvent} _e
     */
    renderDragSourceEffect(_e) {
      // for subclasses
    }

    /**
     * Override to customize drag and drop behavior
     * render a specific effect when an object is the target of a drag event
     * used to show that the underly object can receive a drop, or to show how the
     * object will change when dropping. example: show the cursor where the text is about to be dropped
     * @public
     * @param {DragEvent} _e
     */
    renderDropTargetEffect(_e) {
      // for subclasses
    }
  }
  /**
   * The object's controls' position in viewport coordinates
   * Calculated by {@link Control#positionHandler} and {@link Control#calcCornerCoords}, depending on {@link padding}.
   * `corner/touchCorner` describe the 4 points forming the interactive area of the corner.
   * Used to draw and locate controls.
   */
  /**
   * keeps the value of the last hovered corner during mouse move.
   * 0 is no corner, or 'mt', 'ml', 'mtr' etc..
   * It should be private, but there is no harm in using it as
   * a read-only property.
   * this isn't cleaned automatically. Non selected objects may have wrong values
   * @type [string]
   */
  /**
   * a map of control visibility for this object.
   * this was left when controls were introduced to not break the api too much
   * this takes priority over the generic control visibility
   */
  /**
   * holds the controls for the object.
   * controls are added by default_controls.js
   */
  /**
   * internal boolean to signal the code that the object is
   * part of the move action.
   */
  /**
   * A boolean used from the gesture module to keep tracking of a scaling
   * action when there is no scaling transform in place.
   * This is an edge case and is used twice in all codebase.
   * Probably added to keep track of some performance issues
   * @TODO use git blame to investigate why it was added
   * DON'T USE IT. WE WILL TRY TO REMOVE IT
   */
  _defineProperty(InteractiveFabricObject, "ownDefaults", interactiveObjectDefaultValues);

  /***
   * https://www.typescriptlang.org/docs/handbook/mixins.html#alternative-pattern
   */
  function applyMixins(derivedCtor, constructors) {
    constructors.forEach(baseCtor => {
      Object.getOwnPropertyNames(baseCtor.prototype).forEach(name => {
        name !== 'constructor' && Object.defineProperty(derivedCtor.prototype, name, Object.getOwnPropertyDescriptor(baseCtor.prototype, name) || Object.create(null));
      });
    });
    return derivedCtor;
  }

  // TODO somehow we have to make a tree-shakeable import

  // eslint-disable-next-line @typescript-eslint/no-empty-object-type

  // eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
  class FabricObject extends InteractiveFabricObject {}
  applyMixins(FabricObject, [FabricObjectSVGExportMixin]);
  classRegistry.setClass(FabricObject);
  classRegistry.setClass(FabricObject, 'object');

  /**
   * Returns true if context has transparent pixel
   * at specified location (taking tolerance into account)
   * @param {CanvasRenderingContext2D} ctx context
   * @param {Number} x x coordinate in canvasElementCoordinate, not fabric space. integer
   * @param {Number} y y coordinate in canvasElementCoordinate, not fabric space. integer
   * @param {Number} tolerance Tolerance pixels around the point, not alpha tolerance, integer
   * @return {boolean} true if transparent
   */
  const isTransparent = (ctx, x, y, tolerance) => {
    tolerance = Math.round(tolerance);
    const size = tolerance * 2 + 1;
    const {
      data
    } = ctx.getImageData(x - tolerance, y - tolerance, size, size);

    // Split image data - for tolerance > 1, pixelDataSize = 4;
    for (let i = 3; i < data.length; i += 4) {
      const alphaChannel = data[i];
      if (alphaChannel > 0) {
        return false;
      }
    }
    return true;
  };

  /**
   * Rotates `point` around `origin` with `radians`
   * @deprecated use the Point.rotate
   * @param {Point} origin The origin of the rotation
   * @param {Point} origin The origin of the rotation
   * @param {TRadian} radians The radians of the angle for the rotation
   * @return {Point} The new rotated point
   */
  const rotatePoint = (point, origin, radians) => point.rotate(radians, origin);

  const findIndexRight = (array, predicate) => {
    for (let index = array.length - 1; index >= 0; index--) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  };

  /**
   * @see https://github.com/fabricjs/fabric.js/pull/8344
   * @todo consider removing skewing from points before calculating stroke projection,
   * see https://github.com/fabricjs/fabric.js/commit/494a10ee2f8c2278ae9a55b20bf50cf6ee25b064#commitcomment-94751537
   */
  class StrokeProjectionsBase {
    constructor(options) {
      this.options = options;
      this.strokeProjectionMagnitude = this.options.strokeWidth / 2;
      this.scale = new Point(this.options.scaleX, this.options.scaleY);
      this.strokeUniformScalar = this.options.strokeUniform ? new Point(1 / this.options.scaleX, 1 / this.options.scaleY) : new Point(1, 1);
    }

    /**
     * When the stroke is uniform, scaling affects the arrangement of points. So we must take it into account.
     */
    createSideVector(from, to) {
      const v = createVector(from, to);
      return this.options.strokeUniform ? v.multiply(this.scale) : v;
    }
    projectOrthogonally(from, to, magnitude) {
      return this.applySkew(from.add(this.calcOrthogonalProjection(from, to, magnitude)));
    }
    isSkewed() {
      return this.options.skewX !== 0 || this.options.skewY !== 0;
    }
    applySkew(point) {
      const p = new Point(point);
      // skewY must be applied before skewX as this distortion affects skewX calculation
      p.y += p.x * Math.tan(degreesToRadians(this.options.skewY));
      p.x += p.y * Math.tan(degreesToRadians(this.options.skewX));
      return p;
    }
    scaleUnitVector(unitVector, scalar) {
      return unitVector.multiply(this.strokeUniformScalar).scalarMultiply(scalar);
    }
  }

  const zeroVector = new Point();

  /**
   * class in charge of finding projections for each type of line join
   * @see {@link [Closed path projections at #8344](https://github.com/fabricjs/fabric.js/pull/8344#2-closed-path)}
   *
   * - MDN:
   *   - https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/lineJoin
   *   - https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/stroke-linejoin
   * - Spec: https://svgwg.org/svg2-draft/painting.html#StrokeLinejoinProperty
   * - Playground to understand how the line joins works: https://hypertolosana.github.io/efficient-webgl-stroking/index.html
   * - View the calculated projections for each of the control points: https://codesandbox.io/s/project-stroke-points-with-context-to-trace-b8jc4j?file=/src/index.js
   *
   */
  class StrokeLineJoinProjections extends StrokeProjectionsBase {
    static getOrthogonalRotationFactor(vector1, vector2) {
      const angle = vector2 ? calcAngleBetweenVectors(vector1, vector2) : calcVectorRotation(vector1);
      return Math.abs(angle) < halfPI ? -1 : 1;
    }
    constructor(A, B, C, options) {
      super(options);
      /**
       * The point being projected (the angle ∠BAC)
       */
      /**
       * The point before A
       */
      /**
       * The point after A
       */
      /**
       * The AB vector
       */
      _defineProperty(this, "AB", void 0);
      /**
       * The AC vector
       */
      _defineProperty(this, "AC", void 0);
      /**
       * The angle of A (∠BAC)
       */
      _defineProperty(this, "alpha", void 0);
      /**
       * The bisector of A (∠BAC)
       */
      _defineProperty(this, "bisector", void 0);
      this.A = new Point(A);
      this.B = new Point(B);
      this.C = new Point(C);
      this.AB = this.createSideVector(this.A, this.B);
      this.AC = this.createSideVector(this.A, this.C);
      this.alpha = calcAngleBetweenVectors(this.AB, this.AC);
      this.bisector = getUnitVector(
      // if AC is also the zero vector nothing will be projected
      // in that case the next point will handle the projection
      rotateVector(this.AB.eq(zeroVector) ? this.AC : this.AB, this.alpha / 2));
    }
    calcOrthogonalProjection(from, to) {
      let magnitude = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.strokeProjectionMagnitude;
      const vector = this.createSideVector(from, to);
      const orthogonalProjection = getOrthonormalVector(vector);
      const correctSide = StrokeLineJoinProjections.getOrthogonalRotationFactor(orthogonalProjection, this.bisector);
      return this.scaleUnitVector(orthogonalProjection, magnitude * correctSide);
    }

    /**
     * BEVEL
     * Calculation: the projection points are formed by the vector orthogonal to the vertex.
     *
     * @see https://github.com/fabricjs/fabric.js/pull/8344#2-2-bevel
     */
    projectBevel() {
      const projections = [];
      // if `alpha` equals 0 or 2*PI, the projections are the same for `B` and `C`
      (this.alpha % twoMathPi === 0 ? [this.B] : [this.B, this.C]).forEach(to => {
        projections.push(this.projectOrthogonally(this.A, to));
        projections.push(this.projectOrthogonally(this.A, to, -this.strokeProjectionMagnitude));
      });
      return projections;
    }

    /**
     * MITER
     * Calculation: the corner is formed by extending the outer edges of the stroke
     * at the tangents of the path segments until they intersect.
     *
     * @see https://github.com/fabricjs/fabric.js/pull/8344#2-1-miter
     */
    projectMiter() {
      const projections = [],
        alpha = Math.abs(this.alpha),
        hypotUnitScalar = 1 / Math.sin(alpha / 2),
        miterVector = this.scaleUnitVector(this.bisector, -this.strokeProjectionMagnitude * hypotUnitScalar);

      // When two line segments meet at a sharp angle, it is possible for the join to extend,
      // far beyond the thickness of the line stroking the path. The stroke-miterlimit imposes
      // a limit on the extent of the line join.
      // MDN: https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/stroke-miterlimit
      // When the stroke is uniform, scaling changes the arrangement of points, this changes the miter-limit
      const strokeMiterLimit = this.options.strokeUniform ? magnitude(this.scaleUnitVector(this.bisector, this.options.strokeMiterLimit)) : this.options.strokeMiterLimit;
      if (magnitude(miterVector) / this.strokeProjectionMagnitude <= strokeMiterLimit) {
        projections.push(this.applySkew(this.A.add(miterVector)));
      }
      /* when the miter-limit is reached, the stroke line join becomes of type bevel.
        We always need two orthogonal projections which are basically bevel-type projections,
        so regardless of whether the miter-limit was reached or not, we include these projections.
      */
      projections.push(...this.projectBevel());
      return projections;
    }

    /**
     * ROUND (without skew)
     * Calculation: the projections are the two vectors parallel to X and Y axes
     *
     * @see https://github.com/fabricjs/fabric.js/pull/8344#2-3-1-round-without-skew
     */
    projectRoundNoSkew(startCircle, endCircle) {
      const projections = [],
        // correctSide is used to only consider projecting for the outer side
        correctSide = new Point(StrokeLineJoinProjections.getOrthogonalRotationFactor(this.bisector), StrokeLineJoinProjections.getOrthogonalRotationFactor(new Point(this.bisector.y, this.bisector.x))),
        radiusOnAxisX = new Point(1, 0).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar).multiply(correctSide),
        radiusOnAxisY = new Point(0, 1).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar).multiply(correctSide);
      [radiusOnAxisX, radiusOnAxisY].forEach(vector => {
        if (isBetweenVectors(vector, startCircle, endCircle)) {
          projections.push(this.A.add(vector));
        }
      });
      return projections;
    }

    /**
     * ROUND (with skew)
     * Calculation: the projections are the points furthest from the vertex in
     * the direction of the X and Y axes after distortion.
     *
     * @see https://github.com/fabricjs/fabric.js/pull/8344#2-3-2-round-skew
     */
    projectRoundWithSkew(startCircle, endCircle) {
      const projections = [];
      const {
          skewX,
          skewY,
          scaleX,
          scaleY,
          strokeUniform
        } = this.options,
        shearing = new Point(Math.tan(degreesToRadians(skewX)), Math.tan(degreesToRadians(skewY)));
      // The points furthest from the vertex in the direction of the X and Y axes after distortion
      const circleRadius = this.strokeProjectionMagnitude,
        newY = strokeUniform ? circleRadius / scaleY / Math.sqrt(1 / scaleY ** 2 + 1 / scaleX ** 2 * shearing.y ** 2) : circleRadius / Math.sqrt(1 + shearing.y ** 2),
        furthestY = new Point(
        // Safe guard due to floating point precision. In some situations the square root
        // was returning NaN because of a negative number close to zero.
        Math.sqrt(Math.max(circleRadius ** 2 - newY ** 2, 0)), newY),
        newX = strokeUniform ? circleRadius / Math.sqrt(1 + shearing.x ** 2 * (1 / scaleY) ** 2 / (1 / scaleX + 1 / scaleX * shearing.x * shearing.y) ** 2) : circleRadius / Math.sqrt(1 + shearing.x ** 2 / (1 + shearing.x * shearing.y) ** 2),
        furthestX = new Point(newX, Math.sqrt(Math.max(circleRadius ** 2 - newX ** 2, 0)));
      [furthestX, furthestX.scalarMultiply(-1), furthestY, furthestY.scalarMultiply(-1)]
      // We need to skew the vector here as this information is used to check if
      // it is between the start and end of the circle segment
      .map(vector => this.applySkew(strokeUniform ? vector.multiply(this.strokeUniformScalar) : vector)).forEach(vector => {
        if (isBetweenVectors(vector, startCircle, endCircle)) {
          projections.push(this.applySkew(this.A).add(vector));
        }
      });
      return projections;
    }
    projectRound() {
      const projections = [];
      /* Include the start and end points of the circle segment, so that only
        the projections contained within it are included */
      // add the orthogonal projections (start and end points of circle segment)
      projections.push(...this.projectBevel());
      // let's determines which one of the orthogonal projection is the beginning and end of the circle segment.
      // when `alpha` equals 0 or 2*PI, we have a straight line, so the way to find the start/end is different.
      const isStraightLine = this.alpha % twoMathPi === 0,
        // change the origin of the projections to point A
        // so that the cross product calculation is correct
        newOrigin = this.applySkew(this.A),
        proj0 = projections[isStraightLine ? 0 : 2].subtract(newOrigin),
        proj1 = projections[isStraightLine ? 1 : 0].subtract(newOrigin),
        // when `isStraightLine` === true, we compare with the vector opposite AB, otherwise we compare with the bisector.
        comparisonVector = isStraightLine ? this.applySkew(this.AB.scalarMultiply(-1)) : this.applySkew(this.bisector.multiply(this.strokeUniformScalar).scalarMultiply(-1)),
        // the beginning of the circle segment is always to the right of the comparison vector (cross product > 0)
        isProj0Start = crossProduct(proj0, comparisonVector) > 0,
        startCircle = isProj0Start ? proj0 : proj1,
        endCircle = isProj0Start ? proj1 : proj0;
      if (!this.isSkewed()) {
        projections.push(...this.projectRoundNoSkew(startCircle, endCircle));
      } else {
        projections.push(...this.projectRoundWithSkew(startCircle, endCircle));
      }
      return projections;
    }

    /**
     * Project stroke width on points returning projections for each point as follows:
     * - `miter`: 1 point corresponding to the outer boundary. If the miter limit is exceeded, it will be 2 points (becomes bevel)
     * - `bevel`: 2 points corresponding to the bevel possible boundaries, orthogonal to the stroke.
     * - `round`: same as `bevel` when it has no skew, with skew are 4 points.
     */
    projectPoints() {
      switch (this.options.strokeLineJoin) {
        case 'miter':
          return this.projectMiter();
        case 'round':
          return this.projectRound();
        default:
          return this.projectBevel();
      }
    }
    project() {
      return this.projectPoints().map(point => ({
        originPoint: this.A,
        projectedPoint: point,
        angle: this.alpha,
        bisector: this.bisector
      }));
    }
  }

  /**
   * class in charge of finding projections for each type of line cap for start/end of an open path
   * @see {@link [Open path projections at #8344](https://github.com/fabricjs/fabric.js/pull/8344#1-open-path)}
   *
   * Reference:
   * - MDN:
   *   - https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/lineCap
   *   - https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/stroke-linecap
   * - Spec: https://html.spec.whatwg.org/multipage/canvas.html#dom-context-2d-linecap-dev
   * - Playground to understand how the line joins works: https://hypertolosana.github.io/efficient-webgl-stroking/index.html
   * - View the calculated projections for each of the control points: https://codesandbox.io/s/project-stroke-points-with-context-to-trace-b8jc4j?file=/src/index.js
   */
  class StrokeLineCapProjections extends StrokeProjectionsBase {
    /**
     * edge point
     */

    /**
     * point next to edge point
     */

    constructor(A, T, options) {
      super(options);
      this.A = new Point(A);
      this.T = new Point(T);
    }
    calcOrthogonalProjection(from, to) {
      let magnitude = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.strokeProjectionMagnitude;
      const vector = this.createSideVector(from, to);
      return this.scaleUnitVector(getOrthonormalVector(vector), magnitude);
    }

    /**
     * OPEN PATH START/END - Line cap: Butt
     * Calculation: to find the projections, just find the points orthogonal to the stroke
     *
     * @see https://github.com/fabricjs/fabric.js/pull/8344#1-1-butt
     */
    projectButt() {
      return [this.projectOrthogonally(this.A, this.T, this.strokeProjectionMagnitude), this.projectOrthogonally(this.A, this.T, -this.strokeProjectionMagnitude)];
    }

    /**
     * OPEN PATH START/END - Line cap: Round
     * Calculation: same as stroke line join `round`
     *
     * @see https://github.com/fabricjs/fabric.js/pull/8344#1-2-round
     */
    projectRound() {
      const projections = [];
      if (!this.isSkewed() && this.A.eq(this.T)) {
        /* 1 point case without `skew`
          When `strokeUniform` is true, scaling has no effect.
          So we divide by scale, to remove its effect.
        */
        const projection = new Point(1, 1).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar);
        projections.push(this.applySkew(this.A.add(projection)), this.applySkew(this.A.subtract(projection)));
      } else {
        projections.push(...new StrokeLineJoinProjections(this.A, this.T, this.T, this.options).projectRound());
      }
      return projections;
    }

    /**
     * OPEN PATH START/END - Line cap: Square
     * Calculation: project a rectangle of points on the stroke in the opposite direction of the vector `AT`
     *
     * @see https://github.com/fabricjs/fabric.js/pull/8344#1-3-square
     */
    projectSquare() {
      const projections = [];
      if (this.A.eq(this.T)) {
        /* 1 point case without `skew`
          When `strokeUniform` is true, scaling has no effect.
          So we divide by scale, to remove its effect.
        */
        const projection = new Point(1, 1).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar);
        projections.push(this.A.add(projection), this.A.subtract(projection));
      } else {
        const orthogonalProjection = this.calcOrthogonalProjection(this.A, this.T, this.strokeProjectionMagnitude);
        const strokePointingOut = this.scaleUnitVector(getUnitVector(this.createSideVector(this.A, this.T)), -this.strokeProjectionMagnitude);
        const projectedA = this.A.add(strokePointingOut);
        projections.push(projectedA.add(orthogonalProjection), projectedA.subtract(orthogonalProjection));
      }
      return projections.map(p => this.applySkew(p));
    }
    projectPoints() {
      switch (this.options.strokeLineCap) {
        case 'round':
          return this.projectRound();
        case 'square':
          return this.projectSquare();
        default:
          return this.projectButt();
      }
    }
    project() {
      return this.projectPoints().map(point => ({
        originPoint: this.A,
        projectedPoint: point
      }));
    }
  }

  /**
   *
   * Used to calculate object's bounding box
   *
   * @see https://github.com/fabricjs/fabric.js/pull/8344
   *
   */
  const projectStrokeOnPoints = function (points, options) {
    let openPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    const projections = [];
    if (points.length === 0) {
      return projections;
    }

    // first we remove duplicate neighboring points
    const reduced = points.reduce((reduced, point) => {
      if (!reduced[reduced.length - 1].eq(point)) {
        reduced.push(new Point(point));
      }
      return reduced;
    }, [new Point(points[0])]);
    if (reduced.length === 1) {
      openPath = true;
    } else if (!openPath) {
      // remove points from end in case they equal the first point
      // in order to correctly project the first point
      const start = reduced[0];
      const index = findIndexRight(reduced, point => !point.eq(start));
      reduced.splice(index + 1);
    }
    reduced.forEach((A, index, points) => {
      let B, C;
      if (index === 0) {
        C = points[1];
        B = openPath ? A : points[points.length - 1];
      } else if (index === points.length - 1) {
        B = points[index - 1];
        C = openPath ? A : points[0];
      } else {
        B = points[index - 1];
        C = points[index + 1];
      }
      if (openPath && points.length === 1) {
        projections.push(...new StrokeLineCapProjections(A, A, options).project());
      } else if (openPath && (index === 0 || index === points.length - 1)) {
        projections.push(...new StrokeLineCapProjections(A, index === 0 ? C : B, options).project());
      } else {
        projections.push(...new StrokeLineJoinProjections(A, B, C, options).project());
      }
    });
    return projections;
  };

  const cloneStyles = style => {
    const newObj = {};
    Object.keys(style).forEach(key => {
      newObj[key] = {};
      Object.keys(style[key]).forEach(keyInner => {
        newObj[key][keyInner] = _objectSpread2({}, style[key][keyInner]);
      });
    });
    return newObj;
  };

  /**
   * Capitalizes a string
   * @param {String} string String to capitalize
   * @param {Boolean} [firstLetterOnly] If true only first letter is capitalized
   * and other letters stay untouched, if false first letter is capitalized
   * and other letters are converted to lowercase.
   * @return {String} Capitalized version of a string
   */
  const capitalize = function (string) {
    let firstLetterOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return "".concat(string.charAt(0).toUpperCase()).concat(firstLetterOnly ? string.slice(1) : string.slice(1).toLowerCase());
  };

  /**
   * Escapes XML in a string
   * @param {String} string String to escape
   * @return {String} Escaped version of a string
   */
  const escapeXml = string => string.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&apos;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  let segmenter;
  const getSegmenter = () => {
    if (!segmenter) {
      segmenter = 'Intl' in getFabricWindow() && 'Segmenter' in Intl && new Intl.Segmenter(undefined, {
        granularity: 'grapheme'
      });
    }
    return segmenter;
  };

  /**
   * Divide a string in the user perceived single units
   * @param {String} textstring String to escape
   * @return {Array} array containing the graphemes
   */
  const graphemeSplit = textstring => {
    segmenter || getSegmenter();
    if (segmenter) {
      const segments = segmenter.segment(textstring);
      return Array.from(segments).map(_ref => {
        let {
          segment
        } = _ref;
        return segment;
      });
    }

    //Fallback
    return graphemeSplitImpl(textstring);
  };
  const graphemeSplitImpl = textstring => {
    const graphemes = [];
    for (let i = 0, chr; i < textstring.length; i++) {
      if ((chr = getWholeChar(textstring, i)) === false) {
        continue;
      }
      graphemes.push(chr);
    }
    return graphemes;
  };

  // taken from mdn in the charAt doc page.
  const getWholeChar = (str, i) => {
    const code = str.charCodeAt(i);
    if (isNaN(code)) {
      return ''; // Position not found
    }
    if (code < 0xd800 || code > 0xdfff) {
      return str.charAt(i);
    }

    // High surrogate (could change last hex to 0xDB7F to treat high private
    // surrogates as single characters)
    if (0xd800 <= code && code <= 0xdbff) {
      if (str.length <= i + 1) {
        throw 'High surrogate without following low surrogate';
      }
      const next = str.charCodeAt(i + 1);
      if (0xdc00 > next || next > 0xdfff) {
        throw 'High surrogate without following low surrogate';
      }
      return str.charAt(i) + str.charAt(i + 1);
    }
    // Low surrogate (0xDC00 <= code && code <= 0xDFFF)
    if (i === 0) {
      throw 'Low surrogate without preceding high surrogate';
    }
    const prev = str.charCodeAt(i - 1);

    // (could change last hex to 0xDB7F to treat high private
    // surrogates as single characters)
    if (0xd800 > prev || prev > 0xdbff) {
      throw 'Low surrogate without preceding high surrogate';
    }
    // We can pass over low surrogates now as the second component
    // in a pair which we have already processed
    return false;
  };

  var lang_string = /*#__PURE__*/Object.freeze({
    __proto__: null,
    capitalize: capitalize,
    escapeXml: escapeXml,
    graphemeSplit: graphemeSplit
  });

  /**
   * @param {Object} prevStyle first style to compare
   * @param {Object} thisStyle second style to compare
   * @param {boolean} forTextSpans whether to check overline, underline, and line-through properties
   * @return {boolean} true if the style changed
   */
  const hasStyleChanged = function (prevStyle, thisStyle) {
    let forTextSpans = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return prevStyle.fill !== thisStyle.fill || prevStyle.stroke !== thisStyle.stroke || prevStyle.strokeWidth !== thisStyle.strokeWidth || prevStyle.fontSize !== thisStyle.fontSize || prevStyle.fontFamily !== thisStyle.fontFamily || prevStyle.fontWeight !== thisStyle.fontWeight || prevStyle.fontStyle !== thisStyle.fontStyle || prevStyle.textDecorationThickness !== thisStyle.textDecorationThickness || prevStyle.textBackgroundColor !== thisStyle.textBackgroundColor || prevStyle.deltaY !== thisStyle.deltaY || forTextSpans && (prevStyle.overline !== thisStyle.overline || prevStyle.underline !== thisStyle.underline || prevStyle.linethrough !== thisStyle.linethrough);
  };

  /**
   * Returns the array form of a text object's inline styles property with styles grouped in ranges
   * rather than per character. This format is less verbose, and is better suited for storage
   * so it is used in serialization (not during runtime).
   * @param {object} styles per character styles for a text object
   * @param {String} text the text string that the styles are applied to
   * @return {{start: number, end: number, style: object}[]}
   */
  const stylesToArray = (styles, text) => {
    const textLines = text.split('\n'),
      stylesArray = [];
    let charIndex = -1,
      prevStyle = {};
    // clone style structure to prevent mutation
    styles = cloneStyles(styles);

    //loop through each textLine
    for (let i = 0; i < textLines.length; i++) {
      const chars = graphemeSplit(textLines[i]);
      if (!styles[i]) {
        //no styles exist for this line, so add the line's length to the charIndex total and reset prevStyle
        charIndex += chars.length;
        prevStyle = {};
        continue;
      }
      //loop through each character of the current line
      for (let c = 0; c < chars.length; c++) {
        charIndex++;
        const thisStyle = styles[i][c];
        //check if style exists for this character
        if (thisStyle && Object.keys(thisStyle).length > 0) {
          if (hasStyleChanged(prevStyle, thisStyle, true)) {
            stylesArray.push({
              start: charIndex,
              end: charIndex + 1,
              style: thisStyle
            });
          } else {
            //if style is the same as previous character, increase end index
            stylesArray[stylesArray.length - 1].end++;
          }
        }
        prevStyle = thisStyle || {};
      }
    }
    return stylesArray;
  };

  /**
   * Returns the object form of the styles property with styles that are assigned per
   * character rather than grouped by range. This format is more verbose, and is
   * only used during runtime (not for serialization/storage)
   * @param {Array} styles the serialized form of a text object's styles
   * @param {String} text the text string that the styles are applied to
   * @return {Object}
   */
  const stylesFromArray = (styles, text) => {
    if (!Array.isArray(styles)) {
      // clone to prevent mutation
      return cloneStyles(styles);
    }
    const textLines = text.split(reNewline),
      stylesObject = {};
    let charIndex = -1,
      styleIndex = 0;
    //loop through each textLine
    for (let i = 0; i < textLines.length; i++) {
      const chars = graphemeSplit(textLines[i]);

      //loop through each character of the current line
      for (let c = 0; c < chars.length; c++) {
        charIndex++;
        //check if there's a style collection that includes the current character
        if (styles[styleIndex] && styles[styleIndex].start <= charIndex && charIndex < styles[styleIndex].end) {
          //create object for line index if it doesn't exist
          stylesObject[i] = stylesObject[i] || {};
          //assign a style at this character's index
          stylesObject[i][c] = _objectSpread2({}, styles[styleIndex].style);
          //if character is at the end of the current style collection, move to the next
          if (charIndex === styles[styleIndex].end - 1) {
            styleIndex++;
          }
        }
      }
    }
    return stylesObject;
  };

  /**
   * Attributes parsed from all SVG elements
   * @type array
   */
  const SHARED_ATTRIBUTES = ['display', 'transform', FILL, 'fill-opacity', 'fill-rule', 'opacity', STROKE, 'stroke-dasharray', 'stroke-linecap', 'stroke-dashoffset', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke-width', 'id', 'paint-order', 'vector-effect', 'instantiated_by_use', 'clip-path'];

  function selectorMatches(element, selector) {
    const nodeName = element.nodeName;
    const classNames = element.getAttribute('class');
    const id = element.getAttribute('id');
    const azAz = '(?![a-zA-Z\\-]+)';
    let matcher;
    // i check if a selector matches slicing away part from it.
    // if i get empty string i should match
    matcher = new RegExp('^' + nodeName, 'i');
    selector = selector.replace(matcher, '');
    if (id && selector.length) {
      matcher = new RegExp('#' + id + azAz, 'i');
      selector = selector.replace(matcher, '');
    }
    if (classNames && selector.length) {
      const splitClassNames = classNames.split(' ');
      for (let i = splitClassNames.length; i--;) {
        matcher = new RegExp('\\.' + splitClassNames[i] + azAz, 'i');
        selector = selector.replace(matcher, '');
      }
    }
    return selector.length === 0;
  }

  function doesSomeParentMatch(element, selectors) {
    let selector,
      parentMatching = true;
    while (element.parentElement && element.parentElement.nodeType === 1 && selectors.length) {
      if (parentMatching) {
        selector = selectors.pop();
      }
      element = element.parentElement;
      parentMatching = selectorMatches(element, selector);
    }
    return selectors.length === 0;
  }

  /**
   * @private
   */

  function elementMatchesRule(element, selectors) {
    let parentMatching = true;
    // start from rightmost selector.
    const firstMatching = selectorMatches(element, selectors.pop());
    if (firstMatching && selectors.length) {
      parentMatching = doesSomeParentMatch(element, selectors);
    }
    return firstMatching && parentMatching && selectors.length === 0;
  }

  /**
   * @private
   */

  function getGlobalStylesForElement(element) {
    let cssRules = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let styles = {};
    for (const rule in cssRules) {
      if (elementMatchesRule(element, rule.split(' '))) {
        styles = _objectSpread2(_objectSpread2({}, styles), cssRules[rule]);
      }
    }
    return styles;
  }

  const normalizeAttr = attr => {
    var _attributesMap;
    return (_attributesMap = attributesMap[attr]) !== null && _attributesMap !== void 0 ? _attributesMap : attr;
  };

  const regex$1 = new RegExp("(".concat(reNum, ")"), 'gi');
  const cleanupSvgAttribute = attributeValue => attributeValue.replace(regex$1, ' $1 ')
  // replace annoying commas and arbitrary whitespace with single spaces
  .replace(/,/gi, ' ').replace(/\s+/gi, ' ');

  var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

  // == begin transform regexp
  const p$1 = "(".concat(reNum, ")");
  const skewX = String.raw(_templateObject || (_templateObject = _taggedTemplateLiteral(["(skewX)(", ")"], ["(skewX)\\(", "\\)"])), p$1);
  const skewY = String.raw(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["(skewY)(", ")"], ["(skewY)\\(", "\\)"])), p$1);
  const rotate = String.raw(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["(rotate)(", "(?: ", " ", ")?)"], ["(rotate)\\(", "(?: ", " ", ")?\\)"])), p$1, p$1, p$1);
  const scale = String.raw(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["(scale)(", "(?: ", ")?)"], ["(scale)\\(", "(?: ", ")?\\)"])), p$1, p$1);
  const translate = String.raw(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["(translate)(", "(?: ", ")?)"], ["(translate)\\(", "(?: ", ")?\\)"])), p$1, p$1);
  const matrix = String.raw(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["(matrix)(", " ", " ", " ", " ", " ", ")"], ["(matrix)\\(", " ", " ", " ", " ", " ", "\\)"])), p$1, p$1, p$1, p$1, p$1, p$1);
  const transform = "(?:".concat(matrix, "|").concat(translate, "|").concat(rotate, "|").concat(scale, "|").concat(skewX, "|").concat(skewY, ")");
  const transforms = "(?:".concat(transform, "*)");
  const transformList = String.raw(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["^s*(?:", "?)s*$"], ["^\\s*(?:", "?)\\s*$"])), transforms);
  // http://www.w3.org/TR/SVG/coords.html#TransformAttribute
  const reTransformList = new RegExp(transformList);
  const reTransform = new RegExp(transform);
  const reTransformAll = new RegExp(transform, 'g');
  // == end transform regexp

  /**
   * Parses "transform" attribute, returning an array of values
   * @static
   * @function
   * @memberOf fabric
   * @param {String} attributeValue String containing attribute value
   * @return {TTransformMatrix} Array of 6 elements representing transformation matrix
   */
  function parseTransformAttribute(attributeValue) {
    // first we clean the string
    attributeValue = cleanupSvgAttribute(attributeValue)
    // remove spaces around front parentheses
    .replace(/\s*([()])\s*/gi, '$1');

    // start with identity matrix
    const matrices = [];

    // return if no argument was given or
    // an argument does not match transform attribute regexp
    if (!attributeValue || attributeValue && !reTransformList.test(attributeValue)) {
      return [...iMatrix];
    }
    for (const match of attributeValue.matchAll(reTransformAll)) {
      const transformMatch = reTransform.exec(match[0]);
      if (!transformMatch) {
        continue;
      }
      let matrix = iMatrix;
      const matchedParams = transformMatch.filter(m => !!m);
      const [, operation, ...rawArgs] = matchedParams;
      const [arg0, arg1, arg2, arg3, arg4, arg5] = rawArgs.map(arg => parseFloat(arg));
      switch (operation) {
        case 'translate':
          matrix = createTranslateMatrix(arg0, arg1);
          break;
        case ROTATE:
          matrix = createRotateMatrix({
            angle: arg0
          }, {
            x: arg1,
            y: arg2
          });
          break;
        case SCALE:
          matrix = createScaleMatrix(arg0, arg1);
          break;
        case SKEW_X:
          matrix = createSkewXMatrix(arg0);
          break;
        case SKEW_Y:
          matrix = createSkewYMatrix(arg0);
          break;
        case 'matrix':
          matrix = [arg0, arg1, arg2, arg3, arg4, arg5];
          break;
      }

      // snapshot current matrix into matrices array
      matrices.push(matrix);
    }
    return multiplyTransformMatrixArray(matrices);
  }

  function normalizeValue(attr, value, parentAttributes, fontSize) {
    const isArray = Array.isArray(value);
    let parsed;
    let ouputValue = value;
    if ((attr === FILL || attr === STROKE) && value === NONE) {
      ouputValue = '';
    } else if (attr === 'strokeUniform') {
      return value === 'non-scaling-stroke';
    } else if (attr === 'strokeDashArray') {
      if (value === NONE) {
        ouputValue = null;
      } else {
        ouputValue = value.replace(/,/g, ' ').split(/\s+/).map(parseFloat);
      }
    } else if (attr === 'transformMatrix') {
      if (parentAttributes && parentAttributes.transformMatrix) {
        ouputValue = multiplyTransformMatrices(parentAttributes.transformMatrix, parseTransformAttribute(value));
      } else {
        ouputValue = parseTransformAttribute(value);
      }
    } else if (attr === 'visible') {
      ouputValue = value !== NONE && value !== 'hidden';
      // display=none on parent element always takes precedence over child element
      if (parentAttributes && parentAttributes.visible === false) {
        ouputValue = false;
      }
    } else if (attr === 'opacity') {
      ouputValue = parseFloat(value);
      if (parentAttributes && typeof parentAttributes.opacity !== 'undefined') {
        ouputValue *= parentAttributes.opacity;
      }
    } else if (attr === 'textAnchor' /* text-anchor */) {
      ouputValue = value === 'start' ? LEFT : value === 'end' ? RIGHT : CENTER;
    } else if (attr === 'charSpacing' || attr === TEXT_DECORATION_THICKNESS) {
      // parseUnit returns px and we convert it to em
      parsed = parseUnit(value, fontSize) / fontSize * 1000;
    } else if (attr === 'paintFirst') {
      const fillIndex = value.indexOf(FILL);
      const strokeIndex = value.indexOf(STROKE);
      ouputValue = FILL;
      if (fillIndex > -1 && strokeIndex > -1 && strokeIndex < fillIndex) {
        ouputValue = STROKE;
      } else if (fillIndex === -1 && strokeIndex > -1) {
        ouputValue = STROKE;
      }
    } else if (attr === 'href' || attr === 'xlink:href' || attr === 'font' || attr === 'id') {
      return value;
    } else if (attr === 'imageSmoothing') {
      return value === 'optimizeQuality';
    } else {
      parsed = isArray ? value.map(parseUnit) : parseUnit(value, fontSize);
    }
    return !isArray && isNaN(parsed) ? ouputValue : parsed;
  }

  /**
   * Parses a short font declaration, building adding its properties to a style object
   * @static
   * @function
   * @memberOf fabric
   * @param {String} value font declaration
   * @param {Object} oStyle definition
   */
  function parseFontDeclaration(value, oStyle) {
    const match = value.match(reFontDeclaration);
    if (!match) {
      return;
    }
    const fontStyle = match[1],
      // font variant is not used
      // fontVariant = match[2],
      fontWeight = match[3],
      fontSize = match[4],
      lineHeight = match[5],
      fontFamily = match[6];
    if (fontStyle) {
      oStyle.fontStyle = fontStyle;
    }
    if (fontWeight) {
      oStyle.fontWeight = isNaN(parseFloat(fontWeight)) ? fontWeight : parseFloat(fontWeight);
    }
    if (fontSize) {
      oStyle.fontSize = parseUnit(fontSize);
    }
    if (fontFamily) {
      oStyle.fontFamily = fontFamily;
    }
    if (lineHeight) {
      oStyle.lineHeight = lineHeight === 'normal' ? 1 : lineHeight;
    }
  }

  /**
   * Takes a style object and parses it in one that has only defined values
   * and lowercases properties
   * @param style
   * @param oStyle
   */
  function parseStyleObject(style, oStyle) {
    Object.entries(style).forEach(_ref => {
      let [prop, value] = _ref;
      if (value === undefined) {
        return;
      }
      oStyle[prop.toLowerCase()] = value;
    });
  }

  /**
   * Takes a style string and parses it in one that has only defined values
   * and lowercases properties
   * @param style
   * @param oStyle
   */
  function parseStyleString(style, oStyle) {
    style.replace(/;\s*$/, '').split(';').forEach(chunk => {
      if (!chunk) return;
      const [attr, value] = chunk.split(':');
      oStyle[attr.trim().toLowerCase()] = value.trim();
    });
  }

  /**
   * Parses "style" attribute, retuning an object with values
   * @static
   * @memberOf fabric
   * @param {SVGElement} element Element to parse
   * @return {Object} Objects with values parsed from style attribute of an element
   */
  function parseStyleAttribute(element) {
    const oStyle = {},
      style = element.getAttribute('style');
    if (!style) {
      return oStyle;
    }
    if (typeof style === 'string') {
      parseStyleString(style, oStyle);
    } else {
      parseStyleObject(style, oStyle);
    }
    return oStyle;
  }

  const colorAttributesMap = {
    stroke: 'strokeOpacity',
    fill: 'fillOpacity'
  };

  /**
   * @private
   * @param {Object} attributes Array of attributes to parse
   */

  function setStrokeFillOpacity(attributes) {
    const defaults = FabricObject.getDefaults();
    Object.entries(colorAttributesMap).forEach(_ref => {
      let [attr, colorAttr] = _ref;
      if (typeof attributes[colorAttr] === 'undefined' || attributes[attr] === '') {
        return;
      }
      if (typeof attributes[attr] === 'undefined') {
        if (!defaults[attr]) {
          return;
        }
        attributes[attr] = defaults[attr];
      }
      if (attributes[attr].indexOf('url(') === 0) {
        return;
      }
      const color = new Color(attributes[attr]);
      attributes[attr] = color.setAlpha(toFixed(color.getAlpha() * attributes[colorAttr], 2)).toRgba();
    });
    return attributes;
  }

  /**
   * Returns an object of attributes' name/value, given element and an array of attribute names;
   * Parses parent "g" nodes recursively upwards.
   * @param {SVGElement | HTMLElement} element Element to parse
   * @param {Array} attributes Array of attributes to parse
   * @return {Object} object containing parsed attributes' names/values
   */
  function parseAttributes(element, attributes, cssRules) {
    if (!element) {
      return {};
    }
    let parentAttributes = {},
      fontSize,
      parentFontSize = DEFAULT_SVG_FONT_SIZE;

    // if there's a parent container (`g` or `a` or `symbol` node), parse its attributes recursively upwards
    if (element.parentNode && svgValidParentsRegEx.test(element.parentNode.nodeName)) {
      parentAttributes = parseAttributes(element.parentElement, attributes, cssRules);
      if (parentAttributes.fontSize) {
        fontSize = parentFontSize = parseUnit(parentAttributes.fontSize);
      }
    }
    const ownAttributes = _objectSpread2(_objectSpread2(_objectSpread2({}, attributes.reduce((memo, attr) => {
      const value = element.getAttribute(attr);
      if (value) {
        memo[attr] = value;
      }
      return memo;
    }, {})), getGlobalStylesForElement(element, cssRules)), parseStyleAttribute(element));
    if (ownAttributes[cPath]) {
      element.setAttribute(cPath, ownAttributes[cPath]);
    }
    if (ownAttributes[fSize]) {
      // looks like the minimum should be 9px when dealing with ems. this is what looks like in browsers.
      fontSize = parseUnit(ownAttributes[fSize], parentFontSize);
      ownAttributes[fSize] = "".concat(fontSize);
    }

    // this should have its own complex type
    const normalizedStyle = {};
    for (const attr in ownAttributes) {
      const normalizedAttr = normalizeAttr(attr);
      const normalizedValue = normalizeValue(normalizedAttr, ownAttributes[attr], parentAttributes, fontSize);
      normalizedStyle[normalizedAttr] = normalizedValue;
    }
    if (normalizedStyle && normalizedStyle.font) {
      parseFontDeclaration(normalizedStyle.font, normalizedStyle);
    }
    const mergedAttrs = _objectSpread2(_objectSpread2({}, parentAttributes), normalizedStyle);
    return svgValidParentsRegEx.test(element.nodeName) ? mergedAttrs : setStrokeFillOpacity(mergedAttrs);
  }

  const _excluded$c = ["left", "top", "width", "height", "visible"];
  const rectDefaultValues = {
    rx: 0,
    ry: 0
  };
  const RECT_PROPS = ['rx', 'ry'];
  class Rect extends FabricObject {
    static getDefaults() {
      return _objectSpread2(_objectSpread2({}, super.getDefaults()), Rect.ownDefaults);
    }

    /**
     * Constructor
     * @param {Object} [options] Options object
     */
    constructor(options) {
      super();
      Object.assign(this, Rect.ownDefaults);
      this.setOptions(options);
      this._initRxRy();
    }
    /**
     * Initializes rx/ry attributes
     * @private
     */
    _initRxRy() {
      const {
        rx,
        ry
      } = this;
      if (rx && !ry) {
        this.ry = rx;
      } else if (ry && !rx) {
        this.rx = ry;
      }
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render(ctx) {
      const {
        width: w,
        height: h
      } = this;
      const x = -w / 2;
      const y = -h / 2;
      const rx = this.rx ? Math.min(this.rx, w / 2) : 0;
      const ry = this.ry ? Math.min(this.ry, h / 2) : 0;
      const isRounded = rx !== 0 || ry !== 0;
      ctx.beginPath();
      ctx.moveTo(x + rx, y);
      ctx.lineTo(x + w - rx, y);
      isRounded && ctx.bezierCurveTo(x + w - kRect * rx, y, x + w, y + kRect * ry, x + w, y + ry);
      ctx.lineTo(x + w, y + h - ry);
      isRounded && ctx.bezierCurveTo(x + w, y + h - kRect * ry, x + w - kRect * rx, y + h, x + w - rx, y + h);
      ctx.lineTo(x + rx, y + h);
      isRounded && ctx.bezierCurveTo(x + kRect * rx, y + h, x, y + h - kRect * ry, x, y + h - ry);
      ctx.lineTo(x, y + ry);
      isRounded && ctx.bezierCurveTo(x, y + kRect * ry, x + kRect * rx, y, x + rx, y);
      ctx.closePath();
      this._renderPaintInOrder(ctx);
    }

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject() {
      let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return super.toObject([...RECT_PROPS, ...propertiesToInclude]);
    }

    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG() {
      const {
        width,
        height,
        rx,
        ry
      } = this;
      return ['<rect ', 'COMMON_PARTS', "x=\"".concat(-width / 2, "\" y=\"").concat(-height / 2, "\" rx=\"").concat(rx, "\" ry=\"").concat(ry, "\" width=\"").concat(width, "\" height=\"").concat(height, "\" />\n")];
    }

    /**
     * List of attribute names to account for when parsing SVG element (used by `Rect.fromElement`)
     * @static
     * @memberOf Rect
     * @see: http://www.w3.org/TR/SVG/shapes.html#RectElement
     */

    /* _FROM_SVG_START_ */

    /**
     * Returns {@link Rect} instance from an SVG element
     * @static
     * @memberOf Rect
     * @param {HTMLElement} element Element to parse
     * @param {Object} [options] Options object
     */
    static async fromElement(element, options, cssRules) {
      const _parseAttributes = parseAttributes(element, this.ATTRIBUTE_NAMES, cssRules),
        {
          left = 0,
          top = 0,
          width = 0,
          height = 0,
          visible = true
        } = _parseAttributes,
        restOfparsedAttributes = _objectWithoutProperties(_parseAttributes, _excluded$c);
      return new this(_objectSpread2(_objectSpread2(_objectSpread2({}, options), restOfparsedAttributes), {}, {
        left,
        top,
        width,
        height,
        visible: Boolean(visible && width && height)
      }));
    }

    /* _FROM_SVG_END_ */
  }
  /**
   * Horizontal border radius
   * @type Number
   * @default
   */
  /**
   * Vertical border radius
   * @type Number
   * @default
   */
  _defineProperty(Rect, "type", 'Rect');
  _defineProperty(Rect, "cacheProperties", [...cacheProperties, ...RECT_PROPS]);
  _defineProperty(Rect, "ownDefaults", rectDefaultValues);
  _defineProperty(Rect, "ATTRIBUTE_NAMES", [...SHARED_ATTRIBUTES, 'x', 'y', 'rx', 'ry', 'width', 'height']);
  classRegistry.setClass(Rect);
  classRegistry.setSVGClass(Rect);

  const LAYOUT_TYPE_INITIALIZATION = 'initialization';
  const LAYOUT_TYPE_ADDED = 'added';
  const LAYOUT_TYPE_REMOVED = 'removed';
  const LAYOUT_TYPE_IMPERATIVE = 'imperative';
  const LAYOUT_TYPE_OBJECT_MODIFIED = 'object_modified';
  const LAYOUT_TYPE_OBJECT_MODIFYING = 'object_modifying';

  /**
   * @returns 2 points, the tl and br corners of the non rotated bounding box of an object
   * in the {@link group} plane, taking into account objects that {@link group} is their parent
   * but also belong to the active selection.
   */
  const getObjectBounds = (destinationGroup, object) => {
    const {
      strokeUniform,
      strokeWidth,
      width,
      height,
      group: currentGroup
    } = object;
    const t = currentGroup && currentGroup !== destinationGroup ? calcPlaneChangeMatrix(currentGroup.calcTransformMatrix(), destinationGroup.calcTransformMatrix()) : null;
    const objectCenter = t ? object.getRelativeCenterPoint().transform(t) : object.getRelativeCenterPoint();
    const accountForStroke = !object['isStrokeAccountedForInDimensions']();
    const strokeUniformVector = strokeUniform && accountForStroke ? sendVectorToPlane(new Point(strokeWidth, strokeWidth), undefined, destinationGroup.calcTransformMatrix()) : ZERO;
    const scalingStrokeWidth = !strokeUniform && accountForStroke ? strokeWidth : 0;
    const sizeVector = sizeAfterTransform(width + scalingStrokeWidth, height + scalingStrokeWidth, multiplyTransformMatrixArray([t, object.calcOwnMatrix()], true)).add(strokeUniformVector).scalarDivide(2);
    return [objectCenter.subtract(sizeVector), objectCenter.add(sizeVector)];
  };

  /**
   * Exposes a main public method {@link calcLayoutResult} that is used by the `LayoutManager` to perform layout.
   * Returning `undefined` signals the `LayoutManager` to skip the layout.
   *
   * In charge of calculating the bounding box of the passed objects.
   */
  class LayoutStrategy {
    /**
     * Used by the `LayoutManager` to perform layout
     * @TODO/fix: if this method is calcResult, should calc unconditionally.
     * the condition to not calc should be evaluated by the layoutManager.
     * @returns layout result **OR** `undefined` to skip layout
     */
    calcLayoutResult(context, objects) {
      if (this.shouldPerformLayout(context)) {
        return this.calcBoundingBox(objects, context);
      }
    }
    shouldPerformLayout(_ref) {
      let {
        type,
        prevStrategy,
        strategy
      } = _ref;
      return type === LAYOUT_TYPE_INITIALIZATION || type === LAYOUT_TYPE_IMPERATIVE || !!prevStrategy && strategy !== prevStrategy;
    }
    shouldLayoutClipPath(_ref2) {
      let {
        type,
        target: {
          clipPath
        }
      } = _ref2;
      return type !== LAYOUT_TYPE_INITIALIZATION && clipPath && !clipPath.absolutePositioned;
    }
    getInitialSize(context, result) {
      return result.size;
    }

    /**
     * Override this method to customize layout.
     */
    calcBoundingBox(objects, context) {
      const {
        type,
        target
      } = context;
      if (type === LAYOUT_TYPE_IMPERATIVE && context.overrides) {
        return context.overrides;
      }
      if (objects.length === 0) {
        return;
      }
      const {
        left,
        top,
        width,
        height
      } = makeBoundingBoxFromPoints(objects.map(object => getObjectBounds(target, object)).reduce((coords, curr) => coords.concat(curr), []));
      const bboxSize = new Point(width, height);
      const bboxLeftTop = new Point(left, top);
      const bboxCenter = bboxLeftTop.add(bboxSize.scalarDivide(2));
      if (type === LAYOUT_TYPE_INITIALIZATION) {
        const actualSize = this.getInitialSize(context, {
          size: bboxSize,
          center: bboxCenter
        });
        return {
          // in `initialization` we do not account for target's transformation matrix
          center: bboxCenter,
          // TODO: investigate if this is still necessary
          relativeCorrection: new Point(0, 0),
          size: actualSize
        };
      } else {
        //  we send `relativeCenter` up to group's containing plane
        const center = bboxCenter.transform(target.calcOwnMatrix());
        return {
          center,
          size: bboxSize
        };
      }
    }
  }
  /**
   * override by subclass for persistence (TS does not support `static abstract`)
   */
  _defineProperty(LayoutStrategy, "type", 'strategy');

  /**
   * Layout will adjust the bounding box to fit target's objects.
   */
  class FitContentLayout extends LayoutStrategy {
    /**
     * @override layout on all triggers
     * Override at will
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    shouldPerformLayout(context) {
      return true;
    }
  }
  _defineProperty(FitContentLayout, "type", 'fit-content');
  classRegistry.setClass(FitContentLayout);

  const _excluded$b = ["strategy"],
    _excluded2$3 = ["target", "strategy", "bubbles", "prevStrategy"];
  const LAYOUT_MANAGER = 'layoutManager';
  class LayoutManager {
    constructor() {
      let strategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new FitContentLayout();
      _defineProperty(this, "strategy", void 0);
      this.strategy = strategy;
      this._subscriptions = new Map();
    }
    performLayout(context) {
      const strictContext = _objectSpread2(_objectSpread2({
        bubbles: true,
        strategy: this.strategy
      }, context), {}, {
        prevStrategy: this._prevLayoutStrategy,
        stopPropagation() {
          this.bubbles = false;
        }
      });
      this.onBeforeLayout(strictContext);
      const layoutResult = this.getLayoutResult(strictContext);
      if (layoutResult) {
        this.commitLayout(strictContext, layoutResult);
      }
      this.onAfterLayout(strictContext, layoutResult);
      this._prevLayoutStrategy = strictContext.strategy;
    }

    /**
     * Attach handlers for events that we know will invalidate the layout when
     * performed on child objects ( general transforms ).
     * Returns the disposers for later unsubscribing and cleanup
     * @param {FabricObject} object
     * @param {RegistrationContext & Partial<StrictLayoutContext>} context
     * @returns {VoidFunction[]} disposers remove the handlers
     */
    attachHandlers(object, context) {
      const {
        target
      } = context;
      return [MODIFIED, MOVING, RESIZING, ROTATING, SCALING, SKEWING, CHANGED, MODIFY_POLY, MODIFY_PATH].map(key => object.on(key, e => this.performLayout(key === MODIFIED ? {
        type: LAYOUT_TYPE_OBJECT_MODIFIED,
        trigger: key,
        e,
        target
      } : {
        type: LAYOUT_TYPE_OBJECT_MODIFYING,
        trigger: key,
        e,
        target
      })));
    }

    /**
     * Subscribe an object to transform events that will trigger a layout change on the parent
     * This is important only for interactive groups.
     * @param object
     * @param context
     */
    subscribe(object, context) {
      this.unsubscribe(object, context);
      const disposers = this.attachHandlers(object, context);
      this._subscriptions.set(object, disposers);
    }

    /**
     * unsubscribe object layout triggers
     */
    unsubscribe(object, _context) {
      (this._subscriptions.get(object) || []).forEach(d => d());
      this._subscriptions.delete(object);
    }
    unsubscribeTargets(context) {
      context.targets.forEach(object => this.unsubscribe(object, context));
    }
    subscribeTargets(context) {
      context.targets.forEach(object => this.subscribe(object, context));
    }
    onBeforeLayout(context) {
      const {
        target,
        type
      } = context;
      const {
        canvas
      } = target;
      // handle layout triggers subscription
      // @TODO: gate the registration when the group is interactive
      if (type === LAYOUT_TYPE_INITIALIZATION || type === LAYOUT_TYPE_ADDED) {
        this.subscribeTargets(context);
      } else if (type === LAYOUT_TYPE_REMOVED) {
        this.unsubscribeTargets(context);
      }
      // fire layout event (event will fire only for layouts after initialization layout)
      target.fire('layout:before', {
        context
      });
      canvas && canvas.fire('object:layout:before', {
        target,
        context
      });
      if (type === LAYOUT_TYPE_IMPERATIVE && context.deep) {
        const tricklingContext = _objectWithoutProperties(context, _excluded$b);
        // traverse the tree
        target.forEachObject(object => object.layoutManager && object.layoutManager.performLayout(_objectSpread2(_objectSpread2({}, tricklingContext), {}, {
          bubbles: false,
          target: object
        })));
      }
    }
    getLayoutResult(context) {
      const {
        target,
        strategy,
        type
      } = context;
      const result = strategy.calcLayoutResult(context, target.getObjects());
      if (!result) {
        return;
      }
      const prevCenter = type === LAYOUT_TYPE_INITIALIZATION ? new Point() : target.getRelativeCenterPoint();
      const {
        center: nextCenter,
        correction = new Point(),
        relativeCorrection = new Point()
      } = result;
      const offset = prevCenter.subtract(nextCenter).add(correction).transform(
      // in `initialization` we do not account for target's transformation matrix
      type === LAYOUT_TYPE_INITIALIZATION ? iMatrix : invertTransform(target.calcOwnMatrix()), true).add(relativeCorrection);
      return {
        result,
        prevCenter,
        nextCenter,
        offset
      };
    }
    commitLayout(context, layoutResult) {
      const {
        target
      } = context;
      const {
        result: {
          size
        },
        nextCenter
      } = layoutResult;
      // set dimensions
      target.set({
        width: size.x,
        height: size.y
      });
      // layout descendants
      this.layoutObjects(context, layoutResult);
      //  set position
      // in `initialization` we do not account for target's transformation matrix
      if (context.type === LAYOUT_TYPE_INITIALIZATION) {
        var _context$x, _context$y;
        // TODO: what about strokeWidth?
        target.set({
          left: (_context$x = context.x) !== null && _context$x !== void 0 ? _context$x : nextCenter.x + size.x * resolveOrigin(target.originX),
          top: (_context$y = context.y) !== null && _context$y !== void 0 ? _context$y : nextCenter.y + size.y * resolveOrigin(target.originY)
        });
      } else {
        target.setPositionByOrigin(nextCenter, CENTER, CENTER);
        // invalidate
        target.setCoords();
        target.set('dirty', true);
      }
    }
    layoutObjects(context, layoutResult) {
      const {
        target
      } = context;
      //  adjust objects to account for new center
      target.forEachObject(object => {
        object.group === target && this.layoutObject(context, layoutResult, object);
      });
      // adjust clip path to account for new center
      context.strategy.shouldLayoutClipPath(context) && this.layoutObject(context, layoutResult, target.clipPath);
    }

    /**
     * @param {FabricObject} object
     * @param {Point} offset
     */
    layoutObject(context, _ref, object) {
      let {
        offset
      } = _ref;
      // TODO: this is here for cache invalidation.
      // verify if this is necessary since we have explicit
      // cache invalidation at the end of commitLayout
      object.set({
        left: object.left + offset.x,
        top: object.top + offset.y
      });
    }
    onAfterLayout(context, layoutResult) {
      const {
          target,
          strategy,
          bubbles,
          prevStrategy: _
        } = context,
        bubblingContext = _objectWithoutProperties(context, _excluded2$3);
      const {
        canvas
      } = target;

      //  fire layout event (event will fire only for layouts after initialization layout)
      target.fire('layout:after', {
        context,
        result: layoutResult
      });
      canvas && canvas.fire('object:layout:after', {
        context,
        result: layoutResult,
        target
      });

      //  bubble
      const parent = target.parent;
      if (bubbles && parent !== null && parent !== void 0 && parent.layoutManager) {
        //  add target to context#path
        (bubblingContext.path || (bubblingContext.path = [])).push(target);
        //  all parents should invalidate their layout
        parent.layoutManager.performLayout(_objectSpread2(_objectSpread2({}, bubblingContext), {}, {
          target: parent
        }));
      }
      target.set('dirty', true);
    }
    dispose() {
      const {
        _subscriptions
      } = this;
      _subscriptions.forEach(disposers => disposers.forEach(d => d()));
      _subscriptions.clear();
    }
    toObject() {
      return {
        type: LAYOUT_MANAGER,
        strategy: this.strategy.constructor.type
      };
    }
    toJSON() {
      return this.toObject();
    }
  }
  classRegistry.setClass(LayoutManager, LAYOUT_MANAGER);

  const _excluded$a = ["type", "objects", "layoutManager"];
  /**
   * This class handles the specific case of creating a group using {@link Group#fromObject} and is not meant to be used in any other case.
   * We could have used a boolean in the constructor, as we did previously, but we think the boolean
   * would stay in the group's constructor interface and create confusion, therefore it was removed.
   * This layout manager doesn't do anything and therefore keeps the exact layout the group had when {@link Group#toObject} was called.
   */
  class NoopLayoutManager extends LayoutManager {
    performLayout() {}
  }
  const groupDefaultValues = {
    strokeWidth: 0,
    subTargetCheck: false,
    interactive: false
  };

  /**
   * @fires object:added
   * @fires object:removed
   * @fires layout:before
   * @fires layout:after
   */
  class Group extends createCollectionMixin(FabricObject) {
    static getDefaults() {
      return _objectSpread2(_objectSpread2({}, super.getDefaults()), Group.ownDefaults);
    }

    /**
     * Constructor
     *
     * @param {FabricObject[]} [objects] instance objects
     * @param {Object} [options] Options object
     */
    constructor() {
      let objects = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      super();
      /**
       * Used to optimize performance
       * set to `false` if you don't need contained objects to be targets of events
       * @default
       * @type boolean
       */
      /**
       * Used to allow targeting of object inside groups.
       * set to true if you want to select an object inside a group.\
       * **REQUIRES** `subTargetCheck` set to true
       * This will be not removed but slowly replaced with a method setInteractive
       * that will take care of enabling subTargetCheck and necessary object events.
       * There is too much attached to group interactivity to just be evaluated by a
       * boolean in the code
       * @default
       * @deprecated
       * @type boolean
       */
      /**
       * Used internally to optimize performance
       * Once an object is selected, instance is rendered without the selected object.
       * This way instance is cached only once for the entire interaction with the selected object.
       * @private
       */
      _defineProperty(this, "_activeObjects", []);
      _defineProperty(this, "__objectSelectionTracker", void 0);
      _defineProperty(this, "__objectSelectionDisposer", void 0);
      Object.assign(this, Group.ownDefaults);
      this.setOptions(options);
      this.groupInit(objects, options);
    }

    /**
     * Shared code between group and active selection
     * Meant to be used by the constructor.
     */
    groupInit(objects, options) {
      var _options$layoutManage;
      this._objects = [...objects]; // Avoid unwanted mutations of Collection to affect the caller

      this.__objectSelectionTracker = this.__objectSelectionMonitor.bind(this, true);
      this.__objectSelectionDisposer = this.__objectSelectionMonitor.bind(this, false);
      this.forEachObject(object => {
        this.enterGroup(object, false);
      });

      // perform initial layout
      this.layoutManager = (_options$layoutManage = options.layoutManager) !== null && _options$layoutManage !== void 0 ? _options$layoutManage : new LayoutManager();
      this.layoutManager.performLayout({
        type: LAYOUT_TYPE_INITIALIZATION,
        target: this,
        targets: [...objects],
        // @TODO remove this concept from the layout manager.
        // Layout manager will calculate the correct position,
        // group options can override it later.
        x: options.left,
        y: options.top
      });
    }

    /**
     * Checks if object can enter group and logs relevant warnings
     * @private
     * @param {FabricObject} object
     * @returns
     */
    canEnterGroup(object) {
      if (object === this || this.isDescendantOf(object)) {
        //  prevent circular object tree
        log('error', 'Group: circular object trees are not supported, this call has no effect');
        return false;
      } else if (this._objects.indexOf(object) !== -1) {
        // is already in the objects array
        log('error', 'Group: duplicate objects are not supported inside group, this call has no effect');
        return false;
      }
      return true;
    }

    /**
     * Override this method to enhance performance (for groups with a lot of objects).
     * If Overriding, be sure not pass illegal objects to group - it will break your app.
     * @private
     */
    _filterObjectsBeforeEnteringGroup(objects) {
      return objects.filter((object, index, array) => {
        // can enter AND is the first occurrence of the object in the passed args (to prevent adding duplicates)
        return this.canEnterGroup(object) && array.indexOf(object) === index;
      });
    }

    /**
     * Add objects
     * @param {...FabricObject[]} objects
     */
    add() {
      for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
        objects[_key] = arguments[_key];
      }
      const allowedObjects = this._filterObjectsBeforeEnteringGroup(objects);
      const size = super.add(...allowedObjects);
      this._onAfterObjectsChange(LAYOUT_TYPE_ADDED, allowedObjects);
      return size;
    }

    /**
     * Inserts an object into collection at specified index
     * @param {FabricObject[]} objects Object to insert
     * @param {Number} index Index to insert object at
     */
    insertAt(index) {
      for (var _len2 = arguments.length, objects = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        objects[_key2 - 1] = arguments[_key2];
      }
      const allowedObjects = this._filterObjectsBeforeEnteringGroup(objects);
      const size = super.insertAt(index, ...allowedObjects);
      this._onAfterObjectsChange(LAYOUT_TYPE_ADDED, allowedObjects);
      return size;
    }

    /**
     * Remove objects
     * @param {...FabricObject[]} objects
     * @returns {FabricObject[]} removed objects
     */
    remove() {
      const removed = super.remove(...arguments);
      this._onAfterObjectsChange(LAYOUT_TYPE_REMOVED, removed);
      return removed;
    }
    _onObjectAdded(object) {
      this.enterGroup(object, true);
      this.fire('object:added', {
        target: object
      });
      object.fire('added', {
        target: this
      });
    }

    /**
     * @private
     * @param {FabricObject} object
     * @param {boolean} [removeParentTransform] true if object should exit group without applying group's transform to it
     */
    _onObjectRemoved(object, removeParentTransform) {
      this.exitGroup(object, removeParentTransform);
      this.fire('object:removed', {
        target: object
      });
      object.fire('removed', {
        target: this
      });
    }

    /**
     * @private
     * @param {'added'|'removed'} type
     * @param {FabricObject[]} targets
     */
    _onAfterObjectsChange(type, targets) {
      this.layoutManager.performLayout({
        type,
        targets,
        target: this
      });
    }
    _onStackOrderChanged() {
      this._set('dirty', true);
    }

    /**
     * @private
     * @param {string} key
     * @param {*} value
     */
    _set(key, value) {
      const prev = this[key];
      super._set(key, value);
      if (key === 'canvas' && prev !== value) {
        (this._objects || []).forEach(object => {
          object._set(key, value);
        });
      }
      return this;
    }

    /**
     * @private
     */
    _shouldSetNestedCoords() {
      return this.subTargetCheck;
    }

    /**
     * Remove all objects
     * @returns {FabricObject[]} removed objects
     */
    removeAll() {
      this._activeObjects = [];
      return this.remove(...this._objects);
    }

    /**
     * keeps track of the selected objects
     * @private
     */
    __objectSelectionMonitor(selected, _ref) {
      let {
        target: object
      } = _ref;
      const activeObjects = this._activeObjects;
      if (selected) {
        activeObjects.push(object);
        this._set('dirty', true);
      } else if (activeObjects.length > 0) {
        const index = activeObjects.indexOf(object);
        if (index > -1) {
          activeObjects.splice(index, 1);
          this._set('dirty', true);
        }
      }
    }

    /**
     * @private
     * @param {boolean} watch
     * @param {FabricObject} object
     */
    _watchObject(watch, object) {
      //  make sure we listen only once
      watch && this._watchObject(false, object);
      if (watch) {
        object.on('selected', this.__objectSelectionTracker);
        object.on('deselected', this.__objectSelectionDisposer);
      } else {
        object.off('selected', this.__objectSelectionTracker);
        object.off('deselected', this.__objectSelectionDisposer);
      }
    }

    /**
     * @private
     * @param {FabricObject} object
     * @param {boolean} [removeParentTransform] true if object is in canvas coordinate plane
     */
    enterGroup(object, removeParentTransform) {
      object.group && object.group.remove(object);
      object._set('parent', this);
      this._enterGroup(object, removeParentTransform);
    }

    /**
     * @private
     * @param {FabricObject} object
     * @param {boolean} [removeParentTransform] true if object is in canvas coordinate plane
     */
    _enterGroup(object, removeParentTransform) {
      if (removeParentTransform) {
        // can this be converted to utils (sendObjectToPlane)?
        applyTransformToObject(object, multiplyTransformMatrices(invertTransform(this.calcTransformMatrix()), object.calcTransformMatrix()));
      }
      this._shouldSetNestedCoords() && object.setCoords();
      object._set('group', this);
      object._set('canvas', this.canvas);
      this._watchObject(true, object);
      const activeObject = this.canvas && this.canvas.getActiveObject && this.canvas.getActiveObject();
      // if we are adding the activeObject in a group
      if (activeObject && (activeObject === object || object.isDescendantOf(activeObject))) {
        this._activeObjects.push(object);
      }
    }

    /**
     * @private
     * @param {FabricObject} object
     * @param {boolean} [removeParentTransform] true if object should exit group without applying group's transform to it
     */
    exitGroup(object, removeParentTransform) {
      this._exitGroup(object, removeParentTransform);
      object._set('parent', undefined);
      object._set('canvas', undefined);
    }

    /**
     * Executes the inner fabric logic of exiting a group.
     * - Stop watching the object
     * - Remove the object from the optimization map this._activeObjects
     * - unset the group property of the object
     * @protected
     * @param {FabricObject} object
     * @param {boolean} [removeParentTransform] true if object should exit group without applying group's transform to it
     */
    _exitGroup(object, removeParentTransform) {
      object._set('group', undefined);
      if (!removeParentTransform) {
        applyTransformToObject(object, multiplyTransformMatrices(this.calcTransformMatrix(), object.calcTransformMatrix()));
        object.setCoords();
      }
      this._watchObject(false, object);
      const index = this._activeObjects.length > 0 ? this._activeObjects.indexOf(object) : -1;
      if (index > -1) {
        this._activeObjects.splice(index, 1);
      }
    }

    /**
     * Decide if the group should cache or not. Create its own cache level
     * needsItsOwnCache should be used when the object drawing method requires
     * a cache step.
     * Generally you do not cache objects in groups because the group is already cached.
     * @return {Boolean}
     */
    shouldCache() {
      const ownCache = FabricObject.prototype.shouldCache.call(this);
      if (ownCache) {
        for (let i = 0; i < this._objects.length; i++) {
          if (this._objects[i].willDrawShadow()) {
            this.ownCaching = false;
            return false;
          }
        }
      }
      return ownCache;
    }

    /**
     * Check if this object or a child object will cast a shadow
     * @return {Boolean}
     */
    willDrawShadow() {
      if (super.willDrawShadow()) {
        return true;
      }
      for (let i = 0; i < this._objects.length; i++) {
        if (this._objects[i].willDrawShadow()) {
          return true;
        }
      }
      return false;
    }

    /**
     * Check if instance or its group are caching, recursively up
     * @return {Boolean}
     */
    isOnACache() {
      return this.ownCaching || !!this.parent && this.parent.isOnACache();
    }

    /**
     * Execute the drawing operation for an object on a specified context
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    drawObject(ctx, forClipping, context) {
      this._renderBackground(ctx);
      for (let i = 0; i < this._objects.length; i++) {
        var _this$canvas;
        const obj = this._objects[i];
        // TODO: handle rendering edge case somehow
        if ((_this$canvas = this.canvas) !== null && _this$canvas !== void 0 && _this$canvas.preserveObjectStacking && obj.group !== this) {
          ctx.save();
          ctx.transform(...invertTransform(this.calcTransformMatrix()));
          obj.render(ctx);
          ctx.restore();
        } else if (obj.group === this) {
          obj.render(ctx);
        }
      }
      this._drawClipPath(ctx, this.clipPath, context);
    }

    /**
     * @override
     * @return {Boolean}
     */
    setCoords() {
      super.setCoords();
      this._shouldSetNestedCoords() && this.forEachObject(object => object.setCoords());
    }
    triggerLayout() {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.layoutManager.performLayout(_objectSpread2({
        target: this,
        type: LAYOUT_TYPE_IMPERATIVE
      }, options));
    }

    /**
     * Renders instance on a given context
     * @param {CanvasRenderingContext2D} ctx context to render instance on
     */
    render(ctx) {
      this._transformDone = true;
      super.render(ctx);
      this._transformDone = false;
    }

    /**
     *
     * @private
     * @param {'toObject'|'toDatalessObject'} [method]
     * @param {string[]} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @returns {FabricObject[]} serialized objects
     */
    __serializeObjects(method, propertiesToInclude) {
      const _includeDefaultValues = this.includeDefaultValues;
      return this._objects.filter(function (obj) {
        return !obj.excludeFromExport;
      }).map(function (obj) {
        const originalDefaults = obj.includeDefaultValues;
        obj.includeDefaultValues = _includeDefaultValues;
        const data = obj[method || 'toObject'](propertiesToInclude);
        obj.includeDefaultValues = originalDefaults;
        // delete data.version;
        return data;
      });
    }

    /**
     * Returns object representation of an instance
     * @param {string[]} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject() {
      let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      const layoutManager = this.layoutManager.toObject();
      return _objectSpread2(_objectSpread2(_objectSpread2({}, super.toObject(['subTargetCheck', 'interactive', ...propertiesToInclude])), layoutManager.strategy !== 'fit-content' || this.includeDefaultValues ? {
        layoutManager
      } : {}), {}, {
        objects: this.__serializeObjects('toObject', propertiesToInclude)
      });
    }
    toString() {
      return "#<Group: (".concat(this.complexity(), ")>");
    }
    dispose() {
      this.layoutManager.unsubscribeTargets({
        targets: this.getObjects(),
        target: this
      });
      this._activeObjects = [];
      this.forEachObject(object => {
        this._watchObject(false, object);
        object.dispose();
      });
      super.dispose();
    }

    /**
     * @private
     */
    _createSVGBgRect(reviver) {
      if (!this.backgroundColor) {
        return '';
      }
      const fillStroke = Rect.prototype._toSVG.call(this);
      const commons = fillStroke.indexOf('COMMON_PARTS');
      fillStroke[commons] = 'for="group" ';
      const markup = fillStroke.join('');
      return reviver ? reviver(markup) : markup;
    }

    /**
     * Returns svg representation of an instance
     * @param {TSVGReviver} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    _toSVG(reviver) {
      const svgString = ['<g ', 'COMMON_PARTS', ' >\n'];
      const bg = this._createSVGBgRect(reviver);
      bg && svgString.push('\t\t', bg);
      for (let i = 0; i < this._objects.length; i++) {
        svgString.push('\t\t', this._objects[i].toSVG(reviver));
      }
      svgString.push('</g>\n');
      return svgString;
    }

    /**
     * Returns styles-string for svg-export, specific version for group
     * @return {String}
     */
    getSvgStyles() {
      const opacity = typeof this.opacity !== 'undefined' && this.opacity !== 1 ? "opacity: ".concat(this.opacity, ";") : '',
        visibility = this.visible ? '' : ' visibility: hidden;';
      return [opacity, this.getSvgFilter(), visibility].join('');
    }

    /**
     * Returns svg clipPath representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {String} svg representation of an instance
     */
    toClipPathSVG(reviver) {
      const svgString = [];
      const bg = this._createSVGBgRect(reviver);
      bg && svgString.push('\t', bg);
      for (let i = 0; i < this._objects.length; i++) {
        svgString.push('\t', this._objects[i].toClipPathSVG(reviver));
      }
      return this._createBaseClipPathSVGMarkup(svgString, {
        reviver
      });
    }

    /**
     * @todo support loading from svg
     * @private
     * @static
     * @memberOf Group
     * @param {Object} object Object to create a group from
     * @returns {Promise<Group>}
     */
    static fromObject(_ref2, abortable) {
      let {
          type,
          objects = [],
          layoutManager
        } = _ref2,
        options = _objectWithoutProperties(_ref2, _excluded$a);
      return Promise.all([enlivenObjects(objects, abortable), enlivenObjectEnlivables(options, abortable)]).then(_ref3 => {
        let [objects, hydratedOptions] = _ref3;
        const group = new this(objects, _objectSpread2(_objectSpread2(_objectSpread2({}, options), hydratedOptions), {}, {
          layoutManager: new NoopLayoutManager()
        }));
        if (layoutManager) {
          const layoutClass = classRegistry.getClass(layoutManager.type);
          const strategyClass = classRegistry.getClass(layoutManager.strategy);
          group.layoutManager = new layoutClass(new strategyClass());
        } else {
          group.layoutManager = new LayoutManager();
        }
        group.layoutManager.subscribeTargets({
          type: LAYOUT_TYPE_INITIALIZATION,
          target: group,
          targets: group.getObjects()
        });
        group.setCoords();
        return group;
      });
    }
  }
  _defineProperty(Group, "type", 'Group');
  _defineProperty(Group, "ownDefaults", groupDefaultValues);
  classRegistry.setClass(Group);

  /**
   * TODO experiment with different layout manager and svg results ( fixed fit content )
   * Groups SVG elements (usually those retrieved from SVG document)
   * @static
   * @param {FabricObject[]} elements FabricObject(s) parsed from svg, to group
   * @return {FabricObject | Group}
   */
  const groupSVGElements = (elements, options) => {
    if (elements && elements.length === 1) {
      return elements[0];
    }
    return new Group(elements, options);
  };

  /**
   * Finds the scale for the object source to fit inside the object destination,
   * keeping aspect ratio intact.
   * respect the total allowed area for the cache.
   * @param {TSize} source natural unscaled size of the object
   * @param {TSize} destination natural unscaled size of the object
   * @return {Number} scale factor to apply to source to fit into destination
   */
  const findScaleToFit = (source, destination) => Math.min(destination.width / source.width, destination.height / source.height);

  /**
   * Finds the scale for the object source to cover entirely the object destination,
   * keeping aspect ratio intact.
   * respect the total allowed area for the cache.
   * @param {TSize} source natural unscaled size of the object
   * @param {TSize} destination natural unscaled size of the object
   * @return {Number} scale factor to apply to source to cover destination
   */
  const findScaleToCover = (source, destination) => Math.max(destination.width / source.width, destination.height / source.height);

  const commaWsp = "\\s*,?\\s*";

  /**
   * p for param
   * using "bad naming" here because it makes the regex much easier to read
   * p is a number that is preceded by an arbitary number of spaces, maybe 0,
   * a comma or not, and then possibly more spaces or not.
   */
  const p = "".concat(commaWsp, "(").concat(reNum, ")");

  // const reMoveToCommand = `(M) ?(?:${p}${p} ?)+`;

  // const reLineCommand = `(L) ?(?:${p}${p} ?)+`;

  // const reHorizontalLineCommand = `(H) ?(?:${p} ?)+`;

  // const reVerticalLineCommand = `(V) ?(?:${p} ?)+`;

  // const reClosePathCommand = String.raw`(Z)\s*`;

  // const reCubicCurveCommand = `(C) ?(?:${p}${p}${p}${p}${p}${p} ?)+`;

  // const reCubicCurveShortcutCommand = `(S) ?(?:${p}${p}${p}${p} ?)+`;

  // const reQuadraticCurveCommand = `(Q) ?(?:${p}${p}${p}${p} ?)+`;

  // const reQuadraticCurveShortcutCommand = `(T) ?(?:${p}${p} ?)+`;

  const reArcCommandPoints = "".concat(p).concat(p).concat(p).concat(commaWsp, "([01])").concat(commaWsp, "([01])").concat(p).concat(p);
  // const reArcCommand = `(A) ?(?:${reArcCommandPoints} ?)+`;

  // export const rePathCommandGroups =
  //   `(?:(?:${reMoveToCommand})` +
  //   `|(?:${reLineCommand})` +
  //   `|(?:${reHorizontalLineCommand})` +
  //   `|(?:${reVerticalLineCommand})` +
  //   `|(?:${reClosePathCommand})` +
  //   `|(?:${reCubicCurveCommand})` +
  //   `|(?:${reCubicCurveShortcutCommand})` +
  //   `|(?:${reQuadraticCurveCommand})` +
  //   `|(?:${reQuadraticCurveShortcutCommand})` +
  //   `|(?:${reArcCommand}))`;

  const rePathCommand = '[mzlhvcsqta][^mzlhvcsqta]*';

  /**
   * Commands that may be repeated
   */
  const repeatedCommands = {
    m: 'l',
    M: 'L'
  };

  /**
   * Convert an arc of a rotated ellipse to a Bezier Curve
   * @param {TRadian} theta1 start of the arc
   * @param {TRadian} theta2 end of the arc
   * @param cosTh cosine of the angle of rotation
   * @param sinTh sine of the angle of rotation
   * @param rx x-axis radius (before rotation)
   * @param ry y-axis radius (before rotation)
   * @param cx1 center x of the ellipse
   * @param cy1 center y of the ellipse
   * @param mT
   * @param fromX starting point of arc x
   * @param fromY starting point of arc y
   */
  const segmentToBezier = (theta1, theta2, cosTh, sinTh, rx, ry, cx1, cy1, mT, fromX, fromY) => {
    const costh1 = cos(theta1),
      sinth1 = sin(theta1),
      costh2 = cos(theta2),
      sinth2 = sin(theta2),
      toX = cosTh * rx * costh2 - sinTh * ry * sinth2 + cx1,
      toY = sinTh * rx * costh2 + cosTh * ry * sinth2 + cy1,
      cp1X = fromX + mT * (-cosTh * rx * sinth1 - sinTh * ry * costh1),
      cp1Y = fromY + mT * (-sinTh * rx * sinth1 + cosTh * ry * costh1),
      cp2X = toX + mT * (cosTh * rx * sinth2 + sinTh * ry * costh2),
      cp2Y = toY + mT * (sinTh * rx * sinth2 - cosTh * ry * costh2);
    return ['C', cp1X, cp1Y, cp2X, cp2Y, toX, toY];
  };

  /**
   * Adapted from {@link http://dxr.mozilla.org/mozilla-central/source/dom/svg/SVGPathDataParser.cpp}
   * by Andrea Bogazzi code is under MPL. if you don't have a copy of the license you can take it here
   * http://mozilla.org/MPL/2.0/
   * @param toX
   * @param toY
   * @param rx
   * @param ry
   * @param {number} large 0 or 1 flag
   * @param {number} sweep 0 or 1 flag
   * @param rotateX
   */
  const arcToSegments = (toX, toY, rx, ry, large, sweep, rotateX) => {
    if (rx === 0 || ry === 0) {
      return [];
    }
    let fromX = 0,
      fromY = 0,
      root = 0;
    const PI = Math.PI,
      theta = rotateX * PiBy180,
      sinTheta = sin(theta),
      cosTh = cos(theta),
      px = 0.5 * (-cosTh * toX - sinTheta * toY),
      py = 0.5 * (-cosTh * toY + sinTheta * toX),
      rx2 = rx ** 2,
      ry2 = ry ** 2,
      py2 = py ** 2,
      px2 = px ** 2,
      pl = rx2 * ry2 - rx2 * py2 - ry2 * px2;
    let _rx = Math.abs(rx);
    let _ry = Math.abs(ry);
    if (pl < 0) {
      const s = Math.sqrt(1 - pl / (rx2 * ry2));
      _rx *= s;
      _ry *= s;
    } else {
      root = (large === sweep ? -1.0 : 1.0) * Math.sqrt(pl / (rx2 * py2 + ry2 * px2));
    }
    const cx = root * _rx * py / _ry,
      cy = -root * _ry * px / _rx,
      cx1 = cosTh * cx - sinTheta * cy + toX * 0.5,
      cy1 = sinTheta * cx + cosTh * cy + toY * 0.5;
    let mTheta = calcVectorAngle(1, 0, (px - cx) / _rx, (py - cy) / _ry);
    let dtheta = calcVectorAngle((px - cx) / _rx, (py - cy) / _ry, (-px - cx) / _rx, (-py - cy) / _ry);
    if (sweep === 0 && dtheta > 0) {
      dtheta -= 2 * PI;
    } else if (sweep === 1 && dtheta < 0) {
      dtheta += 2 * PI;
    }

    // Convert into cubic bezier segments <= 90deg
    const segments = Math.ceil(Math.abs(dtheta / PI * 2)),
      result = [],
      mDelta = dtheta / segments,
      mT = 8 / 3 * Math.sin(mDelta / 4) * Math.sin(mDelta / 4) / Math.sin(mDelta / 2);
    let th3 = mTheta + mDelta;
    for (let i = 0; i < segments; i++) {
      result[i] = segmentToBezier(mTheta, th3, cosTh, sinTheta, _rx, _ry, cx1, cy1, mT, fromX, fromY);
      fromX = result[i][5];
      fromY = result[i][6];
      mTheta = th3;
      th3 += mDelta;
    }
    return result;
  };

  /**
   * @private
   * Calculate the angle between two vectors
   * @param ux u endpoint x
   * @param uy u endpoint y
   * @param vx v endpoint x
   * @param vy v endpoint y
   */
  const calcVectorAngle = (ux, uy, vx, vy) => {
    const ta = Math.atan2(uy, ux),
      tb = Math.atan2(vy, vx);
    if (tb >= ta) {
      return tb - ta;
    } else {
      return 2 * Math.PI - (ta - tb);
    }
  };

  // functions for the Cubic beizer
  // taken from: https://github.com/konvajs/konva/blob/7.0.5/src/shapes/Path.ts#L350
  const CB1 = t => t ** 3;
  const CB2 = t => 3 * t ** 2 * (1 - t);
  const CB3 = t => 3 * t * (1 - t) ** 2;
  const CB4 = t => (1 - t) ** 3;

  /**
   * Calculate bounding box of a cubic Bezier curve
   * Taken from http://jsbin.com/ivomiq/56/edit (no credits available)
   * TODO: can we normalize this with the starting points set at 0 and then translated the bbox?
   * @param {number} begx starting point
   * @param {number} begy
   * @param {number} cp1x first control point
   * @param {number} cp1y
   * @param {number} cp2x second control point
   * @param {number} cp2y
   * @param {number} endx end of bezier
   * @param {number} endy
   * @return {TRectBounds} the rectangular bounds
   */
  function getBoundsOfCurve(begx, begy, cp1x, cp1y, cp2x, cp2y, endx, endy) {
    let argsString;
    if (config.cachesBoundsOfCurve) {
      // eslint-disable-next-line
      argsString = [...arguments].join();
      if (cache.boundsOfCurveCache[argsString]) {
        return cache.boundsOfCurveCache[argsString];
      }
    }
    const sqrt = Math.sqrt,
      abs = Math.abs,
      tvalues = [],
      bounds = [[0, 0], [0, 0]];
    let b = 6 * begx - 12 * cp1x + 6 * cp2x;
    let a = -3 * begx + 9 * cp1x - 9 * cp2x + 3 * endx;
    let c = 3 * cp1x - 3 * begx;
    for (let i = 0; i < 2; ++i) {
      if (i > 0) {
        b = 6 * begy - 12 * cp1y + 6 * cp2y;
        a = -3 * begy + 9 * cp1y - 9 * cp2y + 3 * endy;
        c = 3 * cp1y - 3 * begy;
      }
      if (abs(a) < 1e-12) {
        if (abs(b) < 1e-12) {
          continue;
        }
        const t = -c / b;
        if (0 < t && t < 1) {
          tvalues.push(t);
        }
        continue;
      }
      const b2ac = b * b - 4 * c * a;
      if (b2ac < 0) {
        continue;
      }
      const sqrtb2ac = sqrt(b2ac);
      const t1 = (-b + sqrtb2ac) / (2 * a);
      if (0 < t1 && t1 < 1) {
        tvalues.push(t1);
      }
      const t2 = (-b - sqrtb2ac) / (2 * a);
      if (0 < t2 && t2 < 1) {
        tvalues.push(t2);
      }
    }
    let j = tvalues.length;
    const jlen = j;
    const iterator = getPointOnCubicBezierIterator(begx, begy, cp1x, cp1y, cp2x, cp2y, endx, endy);
    while (j--) {
      const {
        x,
        y
      } = iterator(tvalues[j]);
      bounds[0][j] = x;
      bounds[1][j] = y;
    }
    bounds[0][jlen] = begx;
    bounds[1][jlen] = begy;
    bounds[0][jlen + 1] = endx;
    bounds[1][jlen + 1] = endy;
    const result = [new Point(Math.min(...bounds[0]), Math.min(...bounds[1])), new Point(Math.max(...bounds[0]), Math.max(...bounds[1]))];
    if (config.cachesBoundsOfCurve) {
      cache.boundsOfCurveCache[argsString] = result;
    }
    return result;
  }

  /**
   * Converts arc to a bunch of cubic Bezier curves
   * @param {number} fx starting point x
   * @param {number} fy starting point y
   * @param {TParsedArcCommand} coords Arc command
   */
  const fromArcToBeziers = (fx, fy, _ref) => {
    let [_, rx, ry, rot, large, sweep, tx, ty] = _ref;
    const segsNorm = arcToSegments(tx - fx, ty - fy, rx, ry, large, sweep, rot);
    for (let i = 0, len = segsNorm.length; i < len; i++) {
      segsNorm[i][1] += fx;
      segsNorm[i][2] += fy;
      segsNorm[i][3] += fx;
      segsNorm[i][4] += fy;
      segsNorm[i][5] += fx;
      segsNorm[i][6] += fy;
    }
    return segsNorm;
  };

  /**
   * This function takes a parsed SVG path and makes it simpler for fabricJS logic.
   * Simplification consist of:
   * - All commands converted to absolute (lowercase to uppercase)
   * - S converted to C
   * - T converted to Q
   * - A converted to C
   * @param {TComplexPathData} path the array of commands of a parsed SVG path for `Path`
   * @return {TSimplePathData} the simplified array of commands of a parsed SVG path for `Path`
   * TODO: figure out how to remove the type assertions in a nice way
   */
  const makePathSimpler = path => {
    // x and y represent the last point of the path, AKA the previous command point.
    // we add them to each relative command to make it an absolute comment.
    // we also swap the v V h H with L, because are easier to transform.
    let x = 0,
      y = 0;
    // x1 and y1 represent the last point of the subpath. the subpath is started with
    // m or M command. When a z or Z command is drawn, x and y need to be resetted to
    // the last x1 and y1.
    let x1 = 0,
      y1 = 0;
    // previous will host the letter of the previous command, to handle S and T.
    // controlX and controlY will host the previous reflected control point
    const destinationPath = [];
    let previous,
      // placeholders
      controlX = 0,
      controlY = 0;
    for (const parsedCommand of path) {
      const current = [...parsedCommand];
      let converted;
      switch (current[0] // first letter
      ) {
        case 'l':
          // lineto, relative
          current[1] += x;
          current[2] += y;
        // falls through
        case 'L':
          x = current[1];
          y = current[2];
          converted = ['L', x, y];
          break;
        case 'h':
          // horizontal lineto, relative
          current[1] += x;
        // falls through
        case 'H':
          x = current[1];
          converted = ['L', x, y];
          break;
        case 'v':
          // vertical lineto, relative
          current[1] += y;
        // falls through
        case 'V':
          y = current[1];
          converted = ['L', x, y];
          break;
        case 'm':
          // moveTo, relative
          current[1] += x;
          current[2] += y;
        // falls through
        case 'M':
          x = current[1];
          y = current[2];
          x1 = current[1];
          y1 = current[2];
          converted = ['M', x, y];
          break;
        case 'c':
          // bezierCurveTo, relative
          current[1] += x;
          current[2] += y;
          current[3] += x;
          current[4] += y;
          current[5] += x;
          current[6] += y;
        // falls through
        case 'C':
          controlX = current[3];
          controlY = current[4];
          x = current[5];
          y = current[6];
          converted = ['C', current[1], current[2], controlX, controlY, x, y];
          break;
        case 's':
          // shorthand cubic bezierCurveTo, relative
          current[1] += x;
          current[2] += y;
          current[3] += x;
          current[4] += y;
        // falls through
        case 'S':
          // would be sScC but since we are swapping sSc for C, we check just that.
          if (previous === 'C') {
            // calculate reflection of previous control points
            controlX = 2 * x - controlX;
            controlY = 2 * y - controlY;
          } else {
            // If there is no previous command or if the previous command was not a C, c, S, or s,
            // the control point is coincident with the current point
            controlX = x;
            controlY = y;
          }
          x = current[3];
          y = current[4];
          converted = ['C', controlX, controlY, current[1], current[2], x, y];
          // converted[3] and converted[4] are NOW the second control point.
          // we keep it for the next reflection.
          controlX = converted[3];
          controlY = converted[4];
          break;
        case 'q':
          // quadraticCurveTo, relative
          current[1] += x;
          current[2] += y;
          current[3] += x;
          current[4] += y;
        // falls through
        case 'Q':
          controlX = current[1];
          controlY = current[2];
          x = current[3];
          y = current[4];
          converted = ['Q', controlX, controlY, x, y];
          break;
        case 't':
          // shorthand quadraticCurveTo, relative
          current[1] += x;
          current[2] += y;
        // falls through
        case 'T':
          if (previous === 'Q') {
            // calculate reflection of previous control point
            controlX = 2 * x - controlX;
            controlY = 2 * y - controlY;
          } else {
            // If there is no previous command or if the previous command was not a Q, q, T or t,
            // assume the control point is coincident with the current point
            controlX = x;
            controlY = y;
          }
          x = current[1];
          y = current[2];
          converted = ['Q', controlX, controlY, x, y];
          break;
        case 'a':
          current[6] += x;
          current[7] += y;
        // falls through
        case 'A':
          fromArcToBeziers(x, y, current).forEach(b => destinationPath.push(b));
          x = current[6];
          y = current[7];
          break;
        case 'z':
        case 'Z':
          x = x1;
          y = y1;
          converted = ['Z'];
          break;
      }
      if (converted) {
        destinationPath.push(converted);
        previous = converted[0];
      } else {
        previous = '';
      }
    }
    return destinationPath;
  };

  // todo verify if we can just use the point class here
  /**
   * Calc length from point x1,y1 to x2,y2
   * @param {number} x1 starting point x
   * @param {number} y1 starting point y
   * @param {number} x2 starting point x
   * @param {number} y2 starting point y
   * @return {number} length of segment
   */
  const calcLineLength = (x1, y1, x2, y2) => Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);

  /**
   * Get an iterator that takes a percentage and returns a point
   * @param {number} begx
   * @param {number} begy
   * @param {number} cp1x
   * @param {number} cp1y
   * @param {number} cp2x
   * @param {number} cp2y
   * @param {number} endx
   * @param {number} endy
   */
  const getPointOnCubicBezierIterator = (begx, begy, cp1x, cp1y, cp2x, cp2y, endx, endy) => pct => {
    const c1 = CB1(pct),
      c2 = CB2(pct),
      c3 = CB3(pct),
      c4 = CB4(pct);
    return new Point(endx * c1 + cp2x * c2 + cp1x * c3 + begx * c4, endy * c1 + cp2y * c2 + cp1y * c3 + begy * c4);
  };
  const QB1 = t => t ** 2;
  const QB2 = t => 2 * t * (1 - t);
  const QB3 = t => (1 - t) ** 2;
  const getTangentCubicIterator = (p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y) => pct => {
    const qb1 = QB1(pct),
      qb2 = QB2(pct),
      qb3 = QB3(pct),
      tangentX = 3 * (qb3 * (p2x - p1x) + qb2 * (p3x - p2x) + qb1 * (p4x - p3x)),
      tangentY = 3 * (qb3 * (p2y - p1y) + qb2 * (p3y - p2y) + qb1 * (p4y - p3y));
    return Math.atan2(tangentY, tangentX);
  };
  const getPointOnQuadraticBezierIterator = (p1x, p1y, p2x, p2y, p3x, p3y) => pct => {
    const c1 = QB1(pct),
      c2 = QB2(pct),
      c3 = QB3(pct);
    return new Point(p3x * c1 + p2x * c2 + p1x * c3, p3y * c1 + p2y * c2 + p1y * c3);
  };
  const getTangentQuadraticIterator = (p1x, p1y, p2x, p2y, p3x, p3y) => pct => {
    const invT = 1 - pct,
      tangentX = 2 * (invT * (p2x - p1x) + pct * (p3x - p2x)),
      tangentY = 2 * (invT * (p2y - p1y) + pct * (p3y - p2y));
    return Math.atan2(tangentY, tangentX);
  };

  // this will run over a path segment (a cubic or quadratic segment) and approximate it
  // with 100 segments. This will good enough to calculate the length of the curve
  const pathIterator = (iterator, x1, y1) => {
    let tempP = new Point(x1, y1),
      tmpLen = 0;
    for (let perc = 1; perc <= 100; perc += 1) {
      const p = iterator(perc / 100);
      tmpLen += calcLineLength(tempP.x, tempP.y, p.x, p.y);
      tempP = p;
    }
    return tmpLen;
  };

  /**
   * Given a pathInfo, and a distance in pixels, find the percentage from 0 to 1
   * that correspond to that pixels run over the path.
   * The percentage will be then used to find the correct point on the canvas for the path.
   * @param {Array} segInfo fabricJS collection of information on a parsed path
   * @param {number} distance from starting point, in pixels.
   * @return {TPointAngle} info object with x and y ( the point on canvas ) and angle, the tangent on that point;
   */
  const findPercentageForDistance = (segInfo, distance) => {
    let perc = 0,
      tmpLen = 0,
      tempP = {
        x: segInfo.x,
        y: segInfo.y
      },
      p = _objectSpread2({}, tempP),
      nextLen,
      nextStep = 0.01,
      lastPerc = 0;
    // nextStep > 0.0001 covers 0.00015625 that 1/64th of 1/100
    // the path
    const iterator = segInfo.iterator,
      angleFinder = segInfo.angleFinder;
    while (tmpLen < distance && nextStep > 0.0001) {
      p = iterator(perc);
      lastPerc = perc;
      nextLen = calcLineLength(tempP.x, tempP.y, p.x, p.y);
      // compare tmpLen each cycle with distance, decide next perc to test.
      if (nextLen + tmpLen > distance) {
        // we discard this step and we make smaller steps.
        perc -= nextStep;
        nextStep /= 2;
      } else {
        tempP = p;
        perc += nextStep;
        tmpLen += nextLen;
      }
    }
    return _objectSpread2(_objectSpread2({}, p), {}, {
      angle: angleFinder(lastPerc)
    });
  };

  /**
   * Run over a parsed and simplified path and extract some information (length of each command and starting point)
   * @param {TSimplePathData} path parsed path commands
   * @return {TPathSegmentInfo[]} path commands information
   */
  const getPathSegmentsInfo = path => {
    let totalLength = 0,
      //x2 and y2 are the coords of segment start
      //x1 and y1 are the coords of the current point
      x1 = 0,
      y1 = 0,
      x2 = 0,
      y2 = 0,
      iterator,
      tempInfo;
    const info = [];
    for (const current of path) {
      const basicInfo = {
        x: x1,
        y: y1,
        command: current[0],
        length: 0
      };
      switch (current[0] //first letter
      ) {
        case 'M':
          tempInfo = basicInfo;
          tempInfo.x = x2 = x1 = current[1];
          tempInfo.y = y2 = y1 = current[2];
          break;
        case 'L':
          tempInfo = basicInfo;
          tempInfo.length = calcLineLength(x1, y1, current[1], current[2]);
          x1 = current[1];
          y1 = current[2];
          break;
        case 'C':
          iterator = getPointOnCubicBezierIterator(x1, y1, current[1], current[2], current[3], current[4], current[5], current[6]);
          tempInfo = basicInfo;
          tempInfo.iterator = iterator;
          tempInfo.angleFinder = getTangentCubicIterator(x1, y1, current[1], current[2], current[3], current[4], current[5], current[6]);
          tempInfo.length = pathIterator(iterator, x1, y1);
          x1 = current[5];
          y1 = current[6];
          break;
        case 'Q':
          iterator = getPointOnQuadraticBezierIterator(x1, y1, current[1], current[2], current[3], current[4]);
          tempInfo = basicInfo;
          tempInfo.iterator = iterator;
          tempInfo.angleFinder = getTangentQuadraticIterator(x1, y1, current[1], current[2], current[3], current[4]);
          tempInfo.length = pathIterator(iterator, x1, y1);
          x1 = current[3];
          y1 = current[4];
          break;
        case 'Z':
          // we add those in order to ease calculations later
          tempInfo = basicInfo;
          tempInfo.destX = x2;
          tempInfo.destY = y2;
          tempInfo.length = calcLineLength(x1, y1, x2, y2);
          x1 = x2;
          y1 = y2;
          break;
      }
      totalLength += tempInfo.length;
      info.push(tempInfo);
    }
    info.push({
      length: totalLength,
      x: x1,
      y: y1
    });
    return info;
  };

  /**
   * Get the point on the path that is distance along the path
   * @param path
   * @param distance
   * @param infos
   */
  const getPointOnPath = function (path, distance) {
    let infos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getPathSegmentsInfo(path);
    let i = 0;
    while (distance - infos[i].length > 0 && i < infos.length - 2) {
      distance -= infos[i].length;
      i++;
    }
    const segInfo = infos[i],
      segPercent = distance / segInfo.length,
      segment = path[i];
    switch (segInfo.command) {
      case 'M':
        return {
          x: segInfo.x,
          y: segInfo.y,
          angle: 0
        };
      case 'Z':
        return _objectSpread2(_objectSpread2({}, new Point(segInfo.x, segInfo.y).lerp(new Point(segInfo.destX, segInfo.destY), segPercent)), {}, {
          angle: Math.atan2(segInfo.destY - segInfo.y, segInfo.destX - segInfo.x)
        });
      case 'L':
        return _objectSpread2(_objectSpread2({}, new Point(segInfo.x, segInfo.y).lerp(new Point(segment[1], segment[2]), segPercent)), {}, {
          angle: Math.atan2(segment[2] - segInfo.y, segment[1] - segInfo.x)
        });
      case 'C':
        return findPercentageForDistance(segInfo, distance);
      case 'Q':
        return findPercentageForDistance(segInfo, distance);
      // throw Error('Invalid command');
    }
  };
  const rePathCmdAll = new RegExp(rePathCommand, 'gi');
  const regExpArcCommandPoints = new RegExp(reArcCommandPoints, 'g');
  const reMyNum = new RegExp(reNum, 'gi');
  const commandLengths = {
    m: 2,
    l: 2,
    h: 1,
    v: 1,
    c: 6,
    s: 4,
    q: 4,
    t: 2,
    a: 7
  };
  /**
   *
   * @param {string} pathString
   * @return {TComplexPathData} An array of SVG path commands
   * @example <caption>Usage</caption>
   * parsePath('M 3 4 Q 3 5 2 1 4 0 Q 9 12 2 1 4 0') === [
   *   ['M', 3, 4],
   *   ['Q', 3, 5, 2, 1, 4, 0],
   *   ['Q', 9, 12, 2, 1, 4, 0],
   * ];
   */
  const parsePath = pathString => {
    var _pathString$match;
    const chain = [];
    const all = (_pathString$match = pathString.match(rePathCmdAll)) !== null && _pathString$match !== void 0 ? _pathString$match : [];
    for (const matchStr of all) {
      // take match string and save the first letter as the command
      const commandLetter = matchStr[0];
      // in case of Z we have very little to do
      if (commandLetter === 'z' || commandLetter === 'Z') {
        chain.push([commandLetter]);
        continue;
      }
      const commandLength = commandLengths[commandLetter.toLowerCase()];
      let paramArr = [];
      if (commandLetter === 'a' || commandLetter === 'A') {
        // the arc command ha some peculariaties that requires a special regex other than numbers
        // it is possible to avoid using a space between the sweep and large arc flags, making them either
        // 00, 01, 10 or 11, making them identical to a plain number for the regex reMyNum
        // reset the regexp
        regExpArcCommandPoints.lastIndex = 0;
        for (let out = null; out = regExpArcCommandPoints.exec(matchStr);) {
          paramArr.push(...out.slice(1));
        }
      } else {
        paramArr = matchStr.match(reMyNum) || [];
      }

      // inspect the length of paramArr, if is longer than commandLength
      // we are dealing with repeated commands
      for (let i = 0; i < paramArr.length; i += commandLength) {
        const newCommand = new Array(commandLength);
        const transformedCommand = repeatedCommands[commandLetter];
        newCommand[0] = i > 0 && transformedCommand ? transformedCommand : commandLetter;
        for (let j = 0; j < commandLength; j++) {
          newCommand[j + 1] = parseFloat(paramArr[i + j]);
        }
        chain.push(newCommand);
      }
    }
    return chain;
  };

  /**
   *
   * Converts points to a smooth SVG path
   * @param {XY[]} points Array of points
   * @param {number} [correction] Apply a correction to the path (usually we use `width / 1000`). If value is undefined 0 is used as the correction value.
   * @return {(string|number)[][]} An array of SVG path commands
   */
  const getSmoothPathFromPoints = function (points) {
    let correction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    let p1 = new Point(points[0]),
      p2 = new Point(points[1]),
      multSignX = 1,
      multSignY = 0;
    const path = [],
      len = points.length,
      manyPoints = len > 2;
    if (manyPoints) {
      multSignX = points[2].x < p2.x ? -1 : points[2].x === p2.x ? 0 : 1;
      multSignY = points[2].y < p2.y ? -1 : points[2].y === p2.y ? 0 : 1;
    }
    path.push(['M', p1.x - multSignX * correction, p1.y - multSignY * correction]);
    let i;
    for (i = 1; i < len; i++) {
      if (!p1.eq(p2)) {
        const midPoint = p1.midPointFrom(p2);
        // p1 is our bezier control point
        // midpoint is our endpoint
        // start point is p(i-1) value.
        path.push(['Q', p1.x, p1.y, midPoint.x, midPoint.y]);
      }
      p1 = points[i];
      if (i + 1 < points.length) {
        p2 = points[i + 1];
      }
    }
    if (manyPoints) {
      multSignX = p1.x > points[i - 2].x ? 1 : p1.x === points[i - 2].x ? 0 : -1;
      multSignY = p1.y > points[i - 2].y ? 1 : p1.y === points[i - 2].y ? 0 : -1;
    }
    path.push(['L', p1.x + multSignX * correction, p1.y + multSignY * correction]);
    return path;
  };

  /**
   * Transform a path by transforming each segment.
   * it has to be a simplified path or it won't work.
   * WARNING: this depends from pathOffset for correct operation
   * @param {TSimplePathData} path fabricJS parsed and simplified path commands
   * @param {TMat2D} transform matrix that represent the transformation
   * @param {Point} [pathOffset] `Path.pathOffset`
   * @returns {TSimplePathData} the transformed path
   */
  const transformPath = (path, transform, pathOffset) => {
    if (pathOffset) {
      transform = multiplyTransformMatrices(transform, [1, 0, 0, 1, -pathOffset.x, -pathOffset.y]);
    }
    return path.map(pathSegment => {
      const newSegment = [...pathSegment];
      for (let i = 1; i < pathSegment.length - 1; i += 2) {
        // TODO: is there a way to get around casting to any?
        const {
          x,
          y
        } = transformPoint({
          x: pathSegment[i],
          y: pathSegment[i + 1]
        }, transform);
        newSegment[i] = x;
        newSegment[i + 1] = y;
      }
      return newSegment;
    });
  };

  /**
   * Returns an array of path commands to create a regular polygon
   * @param {number} numVertexes
   * @param {number} radius
   * @returns {TSimplePathData} An array of SVG path commands
   */
  const getRegularPolygonPath = (numVertexes, radius) => {
    const interiorAngle = Math.PI * 2 / numVertexes;
    // rotationAdjustment rotates the path by 1/2 the interior angle so that the polygon always has a flat side on the bottom
    // This isn't strictly necessary, but it's how we tend to think of and expect polygons to be drawn
    let rotationAdjustment = -halfPI;
    if (numVertexes % 2 === 0) {
      rotationAdjustment += interiorAngle / 2;
    }
    const d = new Array(numVertexes + 1);
    for (let i = 0; i < numVertexes; i++) {
      const rad = i * interiorAngle + rotationAdjustment;
      const {
        x,
        y
      } = new Point(cos(rad), sin(rad)).scalarMultiply(radius);
      d[i] = [i === 0 ? 'M' : 'L', x, y];
    }
    d[numVertexes] = ['Z'];
    return d;
  };

  /**
   * Join path commands to go back to svg format
   * @param {TSimplePathData} pathData fabricJS parsed path commands
   * @param {number} fractionDigits number of fraction digits to "leave"
   * @return {String} joined path 'M 0 0 L 20 30'
   */
  const joinPath = (pathData, fractionDigits) => pathData.map(segment => {
    return segment.map((arg, i) => {
      if (i === 0) return arg;
      return fractionDigits === undefined ? arg : toFixed(arg, fractionDigits);
    }).join(' ');
  }).join(' ');

  // TODO this file needs to go away, cross browser style support is not fabricjs domain.

  /**
   * wrapper for setting element's style
   * @param {HTMLElement} element
   * @param {Object | string} styles
   */
  function setStyle(element, styles) {
    const elementStyle = element.style;
    if (!elementStyle || !styles) {
      return;
    } else if (typeof styles === 'string') {
      elementStyle.cssText += ';' + styles;
    } else {
      Object.entries(styles).forEach(_ref => {
        let [property, value] = _ref;
        return elementStyle.setProperty(property, value);
      });
    }
  }

  /**
   * Merges 2 clip paths into one visually equal clip path
   *
   * **IMPORTANT**:\
   * Does **NOT** clone the arguments, clone them proir if necessary.
   *
   * Creates a wrapper (group) that contains one clip path and is clipped by the other so content is kept where both overlap.
   * Use this method if both the clip paths may have nested clip paths of their own, so assigning one to the other's clip path property is not possible.
   *
   * In order to handle the `inverted` property we follow logic described in the following cases:\
   * **(1)** both clip paths are inverted - the clip paths pass the inverted prop to the wrapper and loose it themselves.\
   * **(2)** one is inverted and the other isn't - the wrapper shouldn't become inverted and the inverted clip path must clip the non inverted one to produce an identical visual effect.\
   * **(3)** both clip paths are not inverted - wrapper and clip paths remain unchanged.
   *
   * @memberOf fabric.util
   * @param {fabric.Object} c1
   * @param {fabric.Object} c2
   * @returns {fabric.Object} merged clip path
   */
  const mergeClipPaths = (c1, c2) => {
    var _b$group;
    let a = c1,
      b = c2;
    if (a.inverted && !b.inverted) {
      //  case (2)
      a = c2;
      b = c1;
    }
    //  `b` becomes `a`'s clip path so we transform `b` to `a` coordinate plane
    sendObjectToPlane(b, (_b$group = b.group) === null || _b$group === void 0 ? void 0 : _b$group.calcTransformMatrix(), a.calcTransformMatrix());
    //  assign the `inverted` prop to the wrapping group
    const inverted = a.inverted && b.inverted;
    if (inverted) {
      //  case (1)
      a.inverted = b.inverted = false;
    }
    return new Group([a], {
      clipPath: b,
      inverted
    });
  };

  /**
   * Returns random number between 2 specified ones.
   * @param {Number} min lower limit
   * @param {Number} max upper limit
   * @return {Number} random value (between min and max)
   */
  const getRandomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

  /**
   * Cross-browser abstraction for sending XMLHttpRequest
   * @deprecated this has to go away, we can use a modern browser method to do the same.
   * @param {String} url URL to send XMLHttpRequest to
   * @param {Object} [options] Options object
   * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
   * @param {Function} options.onComplete Callback to invoke when request is completed
   * @return {XMLHttpRequest} request
   */

  function request(url) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const onComplete = options.onComplete || noop,
      xhr = new (getFabricWindow().XMLHttpRequest)(),
      signal = options.signal,
      abort = function () {
        xhr.abort();
      },
      removeListener = function () {
        signal && signal.removeEventListener('abort', abort);
        xhr.onerror = xhr.ontimeout = noop;
      };
    if (signal && signal.aborted) {
      throw new SignalAbortedError('request');
    } else if (signal) {
      signal.addEventListener('abort', abort, {
        once: true
      });
    }

    /** @ignore */
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        removeListener();
        onComplete(xhr);
        xhr.onreadystatechange = noop;
      }
    };
    xhr.onerror = xhr.ontimeout = removeListener;
    xhr.open('get', url, true);
    xhr.send();
    return xhr;
  }

  /**
   * This function is an helper for svg import. it decompose the transformMatrix
   * and assign properties to object.
   * untransformed coordinates
   * @private
   */
  const _assignTransformMatrixProps = object => {
    if (object.transformMatrix) {
      const {
        scaleX,
        scaleY,
        angle,
        skewX
      } = qrDecompose(object.transformMatrix);
      object.flipX = false;
      object.flipY = false;
      object.set(SCALE_X, scaleX);
      object.set(SCALE_Y, scaleY);
      object.angle = angle;
      object.skewX = skewX;
      object.skewY = 0;
    }
  };

  /**
   * This function is an helper for svg import. it removes the transform matrix
   * and set to object properties that fabricjs can handle
   * @private
   * @param {Object} preserveAspectRatioOptions
   */
  const removeTransformMatrixForSvgParsing = (object, preserveAspectRatioOptions) => {
    let center = object._findCenterFromElement();
    if (object.transformMatrix) {
      _assignTransformMatrixProps(object);
      center = center.transform(object.transformMatrix);
    }
    delete object.transformMatrix;
    if (preserveAspectRatioOptions) {
      object.scaleX *= preserveAspectRatioOptions.scaleX;
      object.scaleY *= preserveAspectRatioOptions.scaleY;
      object.cropX = preserveAspectRatioOptions.cropX;
      object.cropY = preserveAspectRatioOptions.cropY;
      center.x += preserveAspectRatioOptions.offsetLeft;
      center.y += preserveAspectRatioOptions.offsetTop;
      object.width = preserveAspectRatioOptions.width;
      object.height = preserveAspectRatioOptions.height;
    }
    object.setPositionByOrigin(center, CENTER, CENTER);
  };

  var index$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    addTransformToObject: addTransformToObject,
    animate: animate,
    animateColor: animateColor,
    applyTransformToObject: applyTransformToObject,
    calcAngleBetweenVectors: calcAngleBetweenVectors,
    calcDimensionsMatrix: calcDimensionsMatrix,
    calcPlaneChangeMatrix: calcPlaneChangeMatrix,
    calcVectorRotation: calcVectorRotation,
    cancelAnimFrame: cancelAnimFrame,
    capValue: capValue,
    composeMatrix: composeMatrix,
    copyCanvasElement: copyCanvasElement,
    cos: cos,
    createCanvasElement: createCanvasElement,
    createImage: createImage,
    createRotateMatrix: createRotateMatrix,
    createScaleMatrix: createScaleMatrix,
    createSkewXMatrix: createSkewXMatrix,
    createSkewYMatrix: createSkewYMatrix,
    createTranslateMatrix: createTranslateMatrix,
    createVector: createVector,
    crossProduct: crossProduct,
    degreesToRadians: degreesToRadians,
    dotProduct: dotProduct,
    ease: easing,
    enlivenObjectEnlivables: enlivenObjectEnlivables,
    enlivenObjects: enlivenObjects,
    findScaleToCover: findScaleToCover,
    findScaleToFit: findScaleToFit,
    getBoundsOfCurve: getBoundsOfCurve,
    getOrthonormalVector: getOrthonormalVector,
    getPathSegmentsInfo: getPathSegmentsInfo,
    getPointOnPath: getPointOnPath,
    getPointer: getPointer,
    getRandomInt: getRandomInt,
    getRegularPolygonPath: getRegularPolygonPath,
    getSmoothPathFromPoints: getSmoothPathFromPoints,
    getSvgAttributes: getSvgAttributes,
    getUnitVector: getUnitVector,
    groupSVGElements: groupSVGElements,
    hasStyleChanged: hasStyleChanged,
    invertTransform: invertTransform,
    isBetweenVectors: isBetweenVectors,
    isIdentityMatrix: isIdentityMatrix,
    isTouchEvent: isTouchEvent,
    isTransparent: isTransparent,
    joinPath: joinPath,
    loadImage: loadImage,
    magnitude: magnitude,
    makeBoundingBoxFromPoints: makeBoundingBoxFromPoints,
    makePathSimpler: makePathSimpler,
    matrixToSVG: matrixToSVG,
    mergeClipPaths: mergeClipPaths,
    multiplyTransformMatrices: multiplyTransformMatrices,
    multiplyTransformMatrixArray: multiplyTransformMatrixArray,
    parsePath: parsePath,
    parsePreserveAspectRatioAttribute: parsePreserveAspectRatioAttribute,
    parseUnit: parseUnit,
    pick: pick,
    projectStrokeOnPoints: projectStrokeOnPoints,
    qrDecompose: qrDecompose,
    radiansToDegrees: radiansToDegrees,
    removeFromArray: removeFromArray,
    removeTransformFromObject: removeTransformFromObject,
    removeTransformMatrixForSvgParsing: removeTransformMatrixForSvgParsing,
    request: request,
    requestAnimFrame: requestAnimFrame,
    resetObjectTransform: resetObjectTransform,
    rotatePoint: rotatePoint,
    rotateVector: rotateVector,
    saveObjectTransform: saveObjectTransform,
    sendObjectToPlane: sendObjectToPlane,
    sendPointToPlane: sendPointToPlane,
    sendVectorToPlane: sendVectorToPlane,
    setStyle: setStyle,
    sin: sin,
    sizeAfterTransform: sizeAfterTransform,
    string: lang_string,
    stylesFromArray: stylesFromArray,
    stylesToArray: stylesToArray,
    toBlob: toBlob,
    toDataURL: toDataURL,
    toFixed: toFixed,
    transformPath: transformPath,
    transformPoint: transformPoint
  });

  class CanvasDOMManager extends StaticCanvasDOMManager {
    constructor(arg0) {
      let {
        allowTouchScrolling = false,
        containerClass = ''
      } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      super(arg0);
      _defineProperty(this, "upper", void 0);
      _defineProperty(this, "container", void 0);
      const {
        el: lowerCanvasEl
      } = this.lower;
      const upperCanvasEl = this.createUpperCanvas();
      this.upper = {
        el: upperCanvasEl,
        ctx: upperCanvasEl.getContext('2d')
      };
      this.applyCanvasStyle(lowerCanvasEl, {
        allowTouchScrolling
      });
      this.applyCanvasStyle(upperCanvasEl, {
        allowTouchScrolling,
        styles: {
          position: 'absolute',
          left: '0',
          top: '0'
        }
      });
      const container = this.createContainerElement();
      container.classList.add(containerClass);
      if (lowerCanvasEl.parentNode) {
        lowerCanvasEl.parentNode.replaceChild(container, lowerCanvasEl);
      }
      container.append(lowerCanvasEl, upperCanvasEl);
      this.container = container;
    }
    createUpperCanvas() {
      const {
        el: lowerCanvasEl
      } = this.lower;
      const el = createCanvasElement();
      // we assign the same classname of the lowerCanvas
      el.className = lowerCanvasEl.className;
      // but then we remove the lower-canvas specific className
      el.classList.remove('lower-canvas');
      // we add the specific upper-canvas class
      el.classList.add('upper-canvas');
      el.setAttribute('data-fabric', 'top');
      el.style.cssText = lowerCanvasEl.style.cssText;
      el.setAttribute('draggable', 'true');
      return el;
    }
    createContainerElement() {
      const container = getFabricDocument().createElement('div');
      container.setAttribute('data-fabric', 'wrapper');
      setStyle(container, {
        position: 'relative'
      });
      makeElementUnselectable(container);
      return container;
    }

    /**
     * @private
     * @param {HTMLCanvasElement} element canvas element to apply styles on
     */
    applyCanvasStyle(element, options) {
      const {
        styles,
        allowTouchScrolling
      } = options;
      setStyle(element, _objectSpread2(_objectSpread2({}, styles), {}, {
        'touch-action': allowTouchScrolling ? 'manipulation' : NONE
      }));
      makeElementUnselectable(element);
    }
    setDimensions(size, retinaScaling) {
      super.setDimensions(size, retinaScaling);
      const {
        el,
        ctx
      } = this.upper;
      setCanvasDimensions(el, ctx, size, retinaScaling);
    }
    setCSSDimensions(size) {
      super.setCSSDimensions(size);
      setCSSDimensions(this.upper.el, size);
      setCSSDimensions(this.container, size);
    }
    cleanupDOM(size) {
      const container = this.container,
        {
          el: lowerCanvasEl
        } = this.lower,
        {
          el: upperCanvasEl
        } = this.upper;
      super.cleanupDOM(size);
      container.removeChild(upperCanvasEl);
      container.removeChild(lowerCanvasEl);
      if (container.parentNode) {
        container.parentNode.replaceChild(lowerCanvasEl, container);
      }
    }
    dispose() {
      super.dispose();
      getEnv().dispose(this.upper.el);
      // @ts-expect-error disposing
      delete this.upper;
      // @ts-expect-error disposing
      delete this.container;
    }
  }

  const canvasDefaults = {
    uniformScaling: true,
    uniScaleKey: 'shiftKey',
    centeredScaling: false,
    centeredRotation: false,
    centeredKey: 'altKey',
    altActionKey: 'shiftKey',
    selection: true,
    selectionKey: 'shiftKey',
    selectionColor: 'rgba(100, 100, 255, 0.3)',
    selectionDashArray: [],
    selectionBorderColor: 'rgba(255, 255, 255, 0.3)',
    selectionLineWidth: 1,
    selectionFullyContained: false,
    hoverCursor: 'move',
    moveCursor: 'move',
    defaultCursor: 'default',
    freeDrawingCursor: 'crosshair',
    notAllowedCursor: 'not-allowed',
    perPixelTargetFind: false,
    targetFindTolerance: 0,
    skipTargetFind: false,
    stopContextMenu: false,
    fireRightClick: false,
    fireMiddleClick: false,
    enablePointerEvents: false,
    containerClass: 'canvas-container',
    // turn to true for fabric 7.0
    preserveObjectStacking: false
  };

  /**
   * Canvas class
   * @class Canvas
   * @extends StaticCanvas
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#canvas}
   *
   * @fires object:modified at the end of a transform
   * @fires object:rotating while an object is being rotated from the control
   * @fires object:scaling while an object is being scaled by controls
   * @fires object:moving while an object is being dragged
   * @fires object:skewing while an object is being skewed from the controls
   *
   * @fires before:transform before a transform is is started
   * @fires before:selection:cleared
   * @fires selection:cleared
   * @fires selection:updated
   * @fires selection:created
   *
   * @fires path:created after a drawing operation ends and the path is added
   * @fires mouse:down
   * @fires mouse:move
   * @fires mouse:up
   * @fires mouse:down:before  on mouse down, before the inner fabric logic runs
   * @fires mouse:move:before on mouse move, before the inner fabric logic runs
   * @fires mouse:up:before on mouse up, before the inner fabric logic runs
   * @fires mouse:over
   * @fires mouse:out
   * @fires mouse:dblclick whenever a native dbl click event fires on the canvas.
   *
   * @fires dragover
   * @fires dragenter
   * @fires dragleave
   * @fires drag:enter object drag enter
   * @fires drag:leave object drag leave
   * @fires drop:before before drop event. Prepare for the drop event (same native event).
   * @fires drop
   * @fires drop:after after drop event. Run logic on canvas after event has been accepted/declined (same native event).
   * @example
   * let a: fabric.Object, b: fabric.Object;
   * let flag = false;
   * canvas.add(a, b);
   * a.on('drop:before', opt => {
   *  //  we want a to accept the drop even though it's below b in the stack
   *  flag = this.canDrop(opt.e);
   * });
   * b.canDrop = function(e) {
   *  !flag && this.draggableTextDelegate.canDrop(e);
   * }
   * b.on('dragover', opt => b.set('fill', opt.dropTarget === b ? 'pink' : 'black'));
   * a.on('drop', opt => {
   *  opt.e.defaultPrevented  //  drop occurred
   *  opt.didDrop             //  drop occurred on canvas
   *  opt.target              //  drop target
   *  opt.target !== a && a.set('text', 'I lost');
   * });
   * canvas.on('drop:after', opt => {
   *  //  inform user who won
   *  if(!opt.e.defaultPrevented) {
   *    // no winners
   *  }
   *  else if(!opt.didDrop) {
   *    //  my objects didn't win, some other lucky object
   *  }
   *  else {
   *    //  we have a winner it's opt.target!!
   *  }
   * })
   *
   * @fires after:render at the end of the render process, receives the context in the callback
   * @fires before:render at start the render process, receives the context in the callback
   *
   * @fires contextmenu:before
   * @fires contextmenu
   * @example
   * let handler;
   * targets.forEach(target => {
   *   target.on('contextmenu:before', opt => {
   *     //  decide which target should handle the event before canvas hijacks it
   *     if (someCaseHappens && opt.targets.includes(target)) {
   *       handler = target;
   *     }
   *   });
   *   target.on('contextmenu', opt => {
   *     //  do something fantastic
   *   });
   * });
   * canvas.on('contextmenu', opt => {
   *   if (!handler) {
   *     //  no one takes responsibility, it's always left to me
   *     //  let's show them how it's done!
   *   }
   * });
   *
   */
  class SelectableCanvas extends StaticCanvas {
    constructor() {
      super(...arguments);
      // transform config
      // selection config
      // cursors
      // target find config
      /**
       * When true, mouse events on canvas (mousedown/mousemove/mouseup) result in free drawing.
       * After mousedown, mousemove creates a shape,
       * and then mouseup finalizes it and adds an instance of `fabric.Path` onto canvas.
       * @tutorial {@link http://fabricjs.com/fabric-intro-part-4#free_drawing}
       * @type Boolean
       * @default
       */
      // event config
      /**
       * Keep track of the subTargets for Mouse Events, ordered bottom up from innermost nested subTarget
       * @type FabricObject[]
       */
      _defineProperty(this, "targets", []);
      /**
       * hold the list of nested targets hovered
       * @type FabricObject[]
       * @private
       */
      _defineProperty(this, "_hoveredTargets", []);
      /**
       * hold the list of objects to render
       * @type FabricObject[]
       * @private
       */
      _defineProperty(this, "_objectsToRender", void 0);
      /**
       * hold a reference to a data structure that contains information
       * on the current on going transform
       * @type
       * @private
       */
      _defineProperty(this, "_currentTransform", null);
      /**
       * hold a reference to a data structure used to track the selection
       * box on canvas drag
       * on the current on going transform
       * x, y, deltaX and deltaY are in scene plane
       * @type
       * @private
       */
      _defineProperty(this, "_groupSelector", null);
      /**
       * internal flag used to understand if the context top requires a cleanup
       * in case this is true, the contextTop will be cleared at the next render
       * @type boolean
       * @private
       */
      _defineProperty(this, "contextTopDirty", false);
    }
    static getDefaults() {
      return _objectSpread2(_objectSpread2({}, super.getDefaults()), SelectableCanvas.ownDefaults);
    }
    get upperCanvasEl() {
      var _this$elements$upper;
      return (_this$elements$upper = this.elements.upper) === null || _this$elements$upper === void 0 ? void 0 : _this$elements$upper.el;
    }
    get contextTop() {
      var _this$elements$upper2;
      return (_this$elements$upper2 = this.elements.upper) === null || _this$elements$upper2 === void 0 ? void 0 : _this$elements$upper2.ctx;
    }
    get wrapperEl() {
      return this.elements.container;
    }
    initElements(el) {
      this.elements = new CanvasDOMManager(el, {
        allowTouchScrolling: this.allowTouchScrolling,
        containerClass: this.containerClass
      });
      this._createCacheCanvas();
    }

    /**
     * @private
     * @param {FabricObject} obj Object that was added
     */
    _onObjectAdded(obj) {
      this._objectsToRender = undefined;
      super._onObjectAdded(obj);
    }

    /**
     * @private
     * @param {FabricObject} obj Object that was removed
     */
    _onObjectRemoved(obj) {
      this._objectsToRender = undefined;
      // removing active object should fire "selection:cleared" events
      if (obj === this._activeObject) {
        this.fire('before:selection:cleared', {
          deselected: [obj]
        });
        this._discardActiveObject();
        this.fire('selection:cleared', {
          deselected: [obj]
        });
        obj.fire('deselected', {
          target: obj
        });
      }
      if (obj === this._hoveredTarget) {
        this._hoveredTarget = undefined;
        this._hoveredTargets = [];
      }
      super._onObjectRemoved(obj);
    }
    _onStackOrderChanged() {
      this._objectsToRender = undefined;
      super._onStackOrderChanged();
    }

    /**
     * Divides objects in two groups, one to render immediately
     * and one to render as activeGroup.
     * @return {Array} objects to render immediately and pushes the other in the activeGroup.
     */
    _chooseObjectsToRender() {
      const activeObject = this._activeObject;
      return !this.preserveObjectStacking && activeObject ? this._objects.filter(object => !object.group && object !== activeObject).concat(activeObject) : this._objects;
    }

    /**
     * Renders both the top canvas and the secondary container canvas.
     */
    renderAll() {
      this.cancelRequestedRender();
      if (this.destroyed) {
        return;
      }
      if (this.contextTopDirty && !this._groupSelector && !this.isDrawingMode) {
        this.clearContext(this.contextTop);
        this.contextTopDirty = false;
      }
      if (this.hasLostContext) {
        this.renderTopLayer(this.contextTop);
        this.hasLostContext = false;
      }
      !this._objectsToRender && (this._objectsToRender = this._chooseObjectsToRender());
      this.renderCanvas(this.getContext(), this._objectsToRender);
    }

    /**
     * text selection is rendered by the active text instance during the rendering cycle
     */
    renderTopLayer(ctx) {
      ctx.save();
      if (this.isDrawingMode && this._isCurrentlyDrawing) {
        this.freeDrawingBrush && this.freeDrawingBrush._render();
        this.contextTopDirty = true;
      }
      // we render the top context - last object
      if (this.selection && this._groupSelector) {
        this._drawSelection(ctx);
        this.contextTopDirty = true;
      }
      ctx.restore();
    }

    /**
     * Method to render only the top canvas.
     * Also used to render the group selection box.
     * Does not render text selection.
     */
    renderTop() {
      const ctx = this.contextTop;
      this.clearContext(ctx);
      this.renderTopLayer(ctx);
      // todo: how do i know if the after:render is for the top or normal contex?
      this.fire('after:render', {
        ctx
      });
    }

    /**
     * Set the canvas tolerance value for pixel taret find.
     * Use only integer numbers.
     * @private
     */
    setTargetFindTolerance(value) {
      value = Math.round(value);
      this.targetFindTolerance = value;
      const retina = this.getRetinaScaling();
      const size = Math.ceil((value * 2 + 1) * retina);
      this.pixelFindCanvasEl.width = this.pixelFindCanvasEl.height = size;
      this.pixelFindContext.scale(retina, retina);
    }

    /**
     * Returns true if object is transparent at a certain location
     * Clarification: this is `is target transparent at location X or are controls there`
     * @TODO this seems dumb that we treat controls with transparency. we can find controls
     * programmatically without painting them, the cache canvas optimization is always valid
     * @param {FabricObject} target Object to check
     * @param {Number} x Left coordinate in viewport space
     * @param {Number} y Top coordinate in viewport space
     * @return {Boolean}
     */
    isTargetTransparent(target, x, y) {
      const tolerance = this.targetFindTolerance;
      const ctx = this.pixelFindContext;
      this.clearContext(ctx);
      ctx.save();
      ctx.translate(-x + tolerance, -y + tolerance);
      ctx.transform(...this.viewportTransform);
      const selectionBgc = target.selectionBackgroundColor;
      target.selectionBackgroundColor = '';
      target.render(ctx);
      target.selectionBackgroundColor = selectionBgc;
      ctx.restore();
      // our canvas is square, and made around tolerance.
      // so tolerance in this case also represent the center of the canvas.
      const enhancedTolerance = Math.round(tolerance * this.getRetinaScaling());
      return isTransparent(ctx, enhancedTolerance, enhancedTolerance, enhancedTolerance);
    }

    /**
     * takes an event and determines if selection key has been pressed
     * @private
     * @param {TPointerEvent} e Event object
     */
    _isSelectionKeyPressed(e) {
      const sKey = this.selectionKey;
      if (!sKey) {
        return false;
      }
      if (Array.isArray(sKey)) {
        return !!sKey.find(key => !!key && e[key] === true);
      } else {
        return e[sKey];
      }
    }

    /**
     * @private
     * @param {TPointerEvent} e Event object
     * @param {FabricObject} target
     */
    _shouldClearSelection(e, target) {
      const activeObjects = this.getActiveObjects(),
        activeObject = this._activeObject;
      return !!(!target || target && activeObject && activeObjects.length > 1 && activeObjects.indexOf(target) === -1 && activeObject !== target && !this._isSelectionKeyPressed(e) || target && !target.evented || target && !target.selectable && activeObject && activeObject !== target);
    }

    /**
     * This method will take in consideration a modifier key pressed and the control we are
     * about to drag, and try to guess the anchor point ( origin ) of the transormation.
     * This should be really in the realm of controls, and we should remove specific code for legacy
     * embedded actions.
     * @TODO this probably deserve discussion/rediscovery and change/refactor
     * @private
     * @deprecated
     * @param {FabricObject} target
     * @param {string} action
     * @param {boolean} altKey
     * @returns {boolean} true if the transformation should be centered
     */
    _shouldCenterTransform(target, action, modifierKeyPressed) {
      if (!target) {
        return;
      }
      let centerTransform;
      if (action === SCALE || action === SCALE_X || action === SCALE_Y || action === RESIZING) {
        centerTransform = this.centeredScaling || target.centeredScaling;
      } else if (action === ROTATE) {
        centerTransform = this.centeredRotation || target.centeredRotation;
      }
      return centerTransform ? !modifierKeyPressed : modifierKeyPressed;
    }

    /**
     * Given the control clicked, determine the origin of the transform.
     * This is bad because controls can totally have custom names
     * should disappear before release 4.0
     * @private
     * @deprecated
     */
    _getOriginFromCorner(target, controlName) {
      const origin = {
        x: target.originX,
        y: target.originY
      };
      if (!controlName) {
        return origin;
      }

      // is a left control ?
      if (['ml', 'tl', 'bl'].includes(controlName)) {
        origin.x = RIGHT;
        // is a right control ?
      } else if (['mr', 'tr', 'br'].includes(controlName)) {
        origin.x = LEFT;
      }
      // is a top control ?
      if (['tl', 'mt', 'tr'].includes(controlName)) {
        origin.y = BOTTOM;
        // is a bottom control ?
      } else if (['bl', 'mb', 'br'].includes(controlName)) {
        origin.y = TOP;
      }
      return origin;
    }

    /**
     * @private
     * @param {Event} e Event object
     * @param {FabricObject} target
     * @param {boolean} [alreadySelected] pass true to setup the active control
     */
    _setupCurrentTransform(e, target, alreadySelected) {
      var _control$getActionHan;
      const pointer = target.group ?
      // transform pointer to target's containing coordinate plane
      sendPointToPlane(this.getScenePoint(e), undefined, target.group.calcTransformMatrix()) : this.getScenePoint(e);
      const {
          key: corner = '',
          control
        } = target.getActiveControl() || {},
        actionHandler = alreadySelected && control ? (_control$getActionHan = control.getActionHandler(e, target, control)) === null || _control$getActionHan === void 0 ? void 0 : _control$getActionHan.bind(control) : dragHandler,
        action = getActionFromCorner(alreadySelected, corner, e, target),
        altKey = e[this.centeredKey],
        origin = this._shouldCenterTransform(target, action, altKey) ? {
          x: CENTER,
          y: CENTER
        } : this._getOriginFromCorner(target, corner),
        /**
         * relative to target's containing coordinate plane
         * both agree on every point
         **/
        transform = {
          target: target,
          action,
          actionHandler,
          actionPerformed: false,
          corner,
          scaleX: target.scaleX,
          scaleY: target.scaleY,
          skewX: target.skewX,
          skewY: target.skewY,
          offsetX: pointer.x - target.left,
          offsetY: pointer.y - target.top,
          originX: origin.x,
          originY: origin.y,
          ex: pointer.x,
          ey: pointer.y,
          lastX: pointer.x,
          lastY: pointer.y,
          theta: degreesToRadians(target.angle),
          width: target.width,
          height: target.height,
          shiftKey: e.shiftKey,
          altKey,
          original: _objectSpread2(_objectSpread2({}, saveObjectTransform(target)), {}, {
            originX: origin.x,
            originY: origin.y
          })
        };
      this._currentTransform = transform;
      this.fire('before:transform', {
        e,
        transform
      });
    }

    /**
     * Set the cursor type of the canvas element
     * @param {String} value Cursor type of the canvas element.
     * @see http://www.w3.org/TR/css3-ui/#cursor
     */
    setCursor(value) {
      this.upperCanvasEl.style.cursor = value;
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx to draw the selection on
     */
    _drawSelection(ctx) {
      const {
          x,
          y,
          deltaX,
          deltaY
        } = this._groupSelector,
        start = new Point(x, y).transform(this.viewportTransform),
        extent = new Point(x + deltaX, y + deltaY).transform(this.viewportTransform),
        strokeOffset = this.selectionLineWidth / 2;
      let minX = Math.min(start.x, extent.x),
        minY = Math.min(start.y, extent.y),
        maxX = Math.max(start.x, extent.x),
        maxY = Math.max(start.y, extent.y);
      if (this.selectionColor) {
        ctx.fillStyle = this.selectionColor;
        ctx.fillRect(minX, minY, maxX - minX, maxY - minY);
      }
      if (!this.selectionLineWidth || !this.selectionBorderColor) {
        return;
      }
      ctx.lineWidth = this.selectionLineWidth;
      ctx.strokeStyle = this.selectionBorderColor;
      minX += strokeOffset;
      minY += strokeOffset;
      maxX -= strokeOffset;
      maxY -= strokeOffset;
      // selection border
      // @TODO: is _setLineDash still necessary on modern canvas?
      FabricObject.prototype._setLineDash.call(this, ctx, this.selectionDashArray);
      ctx.strokeRect(minX, minY, maxX - minX, maxY - minY);
    }

    /**
     * Method that determines what object we are clicking on
     * 11/09/2018 TODO: would be cool if findTarget could discern between being a full target
     * or the outside part of the corner.
     * @param {Event} e mouse event
     * @return {FabricObject | null} the target found
     */
    findTarget(e) {
      if (this.skipTargetFind) {
        return undefined;
      }
      const pointer = this.getViewportPoint(e),
        activeObject = this._activeObject,
        aObjects = this.getActiveObjects();
      this.targets = [];
      if (activeObject && aObjects.length >= 1) {
        if (activeObject.findControl(pointer, isTouchEvent(e))) {
          // if we hit the corner of the active object, let's return that.
          return activeObject;
        } else if (aObjects.length > 1 &&
        // check pointer is over active selection and possibly perform `subTargetCheck`
        this.searchPossibleTargets([activeObject], pointer)) {
          // active selection does not select sub targets like normal groups
          return activeObject;
        } else if (activeObject === this.searchPossibleTargets([activeObject], pointer)) {
          // active object is not an active selection
          if (!this.preserveObjectStacking) {
            return activeObject;
          } else {
            const subTargets = this.targets;
            this.targets = [];
            const target = this.searchPossibleTargets(this._objects, pointer);
            if (e[this.altSelectionKey] && target && target !== activeObject) {
              // alt selection: select active object even though it is not the top most target
              // restore targets
              this.targets = subTargets;
              return activeObject;
            }
            return target;
          }
        }
      }
      return this.searchPossibleTargets(this._objects, pointer);
    }

    /**
     * Checks if the point is inside the object selection area including padding
     * @param {FabricObject} obj Object to test against
     * @param {Object} [pointer] point in scene coordinates
     * @return {Boolean} true if point is contained within an area of given object
     * @private
     */
    _pointIsInObjectSelectionArea(obj, point) {
      // getCoords will already take care of group de-nesting
      let coords = obj.getCoords();
      const viewportZoom = this.getZoom();
      const padding = obj.padding / viewportZoom;
      if (padding) {
        const [tl, tr, br, bl] = coords;
        // what is the angle of the object?
        // we could use getTotalAngle, but is way easier to look at it
        // from how coords are oriented, since if something went wrong
        // at least we are consistent.
        const angleRadians = Math.atan2(tr.y - tl.y, tr.x - tl.x),
          cosP = cos(angleRadians) * padding,
          sinP = sin(angleRadians) * padding,
          cosPSinP = cosP + sinP,
          cosPMinusSinP = cosP - sinP;
        coords = [new Point(tl.x - cosPMinusSinP, tl.y - cosPSinP), new Point(tr.x + cosPSinP, tr.y - cosPMinusSinP), new Point(br.x + cosPMinusSinP, br.y + cosPSinP), new Point(bl.x - cosPSinP, bl.y + cosPMinusSinP)];
        // in case of padding we calculate the new coords on the fly.
        // otherwise we have to maintain 2 sets of coordinates for everything.
        // we can reiterate on storing them.
        // if this is slow, for now the semplification is large and doesn't impact
        // rendering.
        // the idea behind this is that outside target check we don't need ot know
        // where those coords are
      }
      return Intersection.isPointInPolygon(point, coords);
    }

    /**
     * Checks point is inside the object selection condition. Either area with padding
     * or over pixels if perPixelTargetFind is enabled
     * @param {FabricObject} obj Object to test against
     * @param {Object} [pointer] point from viewport.
     * @return {Boolean} true if point is contained within an area of given object
     * @private
     */
    _checkTarget(obj, pointer) {
      if (obj && obj.visible && obj.evented && this._pointIsInObjectSelectionArea(obj, sendPointToPlane(pointer, undefined, this.viewportTransform))) {
        if ((this.perPixelTargetFind || obj.perPixelTargetFind) && !obj.isEditing) {
          if (!this.isTargetTransparent(obj, pointer.x, pointer.y)) {
            return true;
          }
        } else {
          return true;
        }
      }
      return false;
    }

    /**
     * Internal Function used to search inside objects an object that contains pointer in bounding box or that contains pointerOnCanvas when painted
     * @param {Array} [objects] objects array to look into
     * @param {Object} [pointer] x,y object of point coordinates we want to check.
     * @return {FabricObject} **top most object from given `objects`** that contains pointer
     * @private
     */
    _searchPossibleTargets(objects, pointer) {
      // Cache all targets where their bounding box contains point.
      let i = objects.length;
      // Do not check for currently grouped objects, since we check the parent group itself.
      // until we call this function specifically to search inside the activeGroup
      while (i--) {
        const target = objects[i];
        if (this._checkTarget(target, pointer)) {
          if (isCollection(target) && target.subTargetCheck) {
            const subTarget = this._searchPossibleTargets(target._objects, pointer);
            subTarget && this.targets.push(subTarget);
          }
          return target;
        }
      }
    }

    /**
     * Function used to search inside objects an object that contains pointer in bounding box or that contains pointerOnCanvas when painted
     * @see {@link _searchPossibleTargets}
     * @param {FabricObject[]} [objects] objects array to look into
     * @param {Point} [pointer] coordinates from viewport to check.
     * @return {FabricObject} **top most object on screen** that contains pointer
     */
    searchPossibleTargets(objects, pointer) {
      const target = this._searchPossibleTargets(objects, pointer);

      // if we found something in this.targets, and the group is interactive, return the innermost subTarget
      // that is still interactive
      // TODO: reverify why interactive. the target should be returned always, but selected only
      // if interactive.
      if (target && isCollection(target) && target.interactive && this.targets[0]) {
        /** targets[0] is the innermost nested target, but it could be inside non interactive groups and so not a selection target */
        const targets = this.targets;
        for (let i = targets.length - 1; i > 0; i--) {
          const t = targets[i];
          if (!(isCollection(t) && t.interactive)) {
            // one of the subtargets was not interactive. that is the last subtarget we can return.
            // we can't dig more deep;
            return t;
          }
        }
        return targets[0];
      }
      return target;
    }

    /**
     * @returns point existing in the same plane as the {@link HTMLCanvasElement},
     * `(0, 0)` being the top left corner of the {@link HTMLCanvasElement}.
     * This means that changes to the {@link viewportTransform} do not change the values of the point
     * and it remains unchanged from the viewer's perspective.
     *
     * @example
     * const scenePoint = sendPointToPlane(
     *  this.getViewportPoint(e),
     *  undefined,
     *  canvas.viewportTransform
     * );
     *
     */
    getViewportPoint(e) {
      if (this._pointer) {
        return this._pointer;
      }
      return this.getPointer(e, true);
    }

    /**
     * @returns point existing in the scene (the same plane as the plane {@link FabricObject#getCenterPoint} exists in).
     * This means that changes to the {@link viewportTransform} do not change the values of the point,
     * however, from the viewer's perspective, the point is changed.
     *
     * @example
     * const viewportPoint = sendPointToPlane(
     *  this.getScenePoint(e),
     *  canvas.viewportTransform
     * );
     *
     */
    getScenePoint(e) {
      if (this._absolutePointer) {
        return this._absolutePointer;
      }
      return this.getPointer(e);
    }

    /**
     * Returns pointer relative to canvas.
     *
     * @deprecated This method is deprecated since v6 to protect you from misuse.
     * Use {@link getViewportPoint} or {@link getScenePoint} instead.
     *
     * @param {Event} e
     * @param {Boolean} [fromViewport] whether to return the point from the viewport or in the scene
     * @return {Point}
     */
    getPointer(e) {
      let fromViewport = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      const upperCanvasEl = this.upperCanvasEl,
        bounds = upperCanvasEl.getBoundingClientRect();
      let pointer = getPointer(e),
        boundsWidth = bounds.width || 0,
        boundsHeight = bounds.height || 0;
      if (!boundsWidth || !boundsHeight) {
        if (TOP in bounds && BOTTOM in bounds) {
          boundsHeight = Math.abs(bounds.top - bounds.bottom);
        }
        if (RIGHT in bounds && LEFT in bounds) {
          boundsWidth = Math.abs(bounds.right - bounds.left);
        }
      }
      this.calcOffset();
      pointer.x = pointer.x - this._offset.left;
      pointer.y = pointer.y - this._offset.top;
      if (!fromViewport) {
        pointer = sendPointToPlane(pointer, undefined, this.viewportTransform);
      }
      const retinaScaling = this.getRetinaScaling();
      if (retinaScaling !== 1) {
        pointer.x /= retinaScaling;
        pointer.y /= retinaScaling;
      }

      // If bounds are not available (i.e. not visible), do not apply scale.
      const cssScale = boundsWidth === 0 || boundsHeight === 0 ? new Point(1, 1) : new Point(upperCanvasEl.width / boundsWidth, upperCanvasEl.height / boundsHeight);
      return pointer.multiply(cssScale);
    }

    /**
     * Internal use only
     * @protected
     */
    _setDimensionsImpl(dimensions, options) {
      // @ts-expect-error this method exists in the subclass - should be moved or declared as abstract
      this._resetTransformEventData();
      super._setDimensionsImpl(dimensions, options);
      if (this._isCurrentlyDrawing) {
        this.freeDrawingBrush && this.freeDrawingBrush._setBrushStyles(this.contextTop);
      }
    }
    _createCacheCanvas() {
      this.pixelFindCanvasEl = createCanvasElement();
      this.pixelFindContext = this.pixelFindCanvasEl.getContext('2d', {
        willReadFrequently: true
      });
      this.setTargetFindTolerance(this.targetFindTolerance);
    }

    /**
     * Returns context of top canvas where interactions are drawn
     * @returns {CanvasRenderingContext2D}
     */
    getTopContext() {
      return this.elements.upper.ctx;
    }

    /**
     * Returns context of canvas where object selection is drawn
     * @alias
     * @return {CanvasRenderingContext2D}
     */
    getSelectionContext() {
      return this.elements.upper.ctx;
    }

    /**
     * Returns &lt;canvas> element on which object selection is drawn
     * @return {HTMLCanvasElement}
     */
    getSelectionElement() {
      return this.elements.upper.el;
    }

    /**
     * Returns currently active object
     * @return {FabricObject | null} active object
     */
    getActiveObject() {
      return this._activeObject;
    }

    /**
     * Returns an array with the current selected objects
     * @return {FabricObject[]} active objects array
     */
    getActiveObjects() {
      const active = this._activeObject;
      return isActiveSelection(active) ? active.getObjects() : active ? [active] : [];
    }

    /**
     * @private
     * Compares the old activeObject with the current one and fires correct events
     * @param {FabricObject[]} oldObjects old activeObject
     * @param {TPointerEvent} e mouse event triggering the selection events
     */
    _fireSelectionEvents(oldObjects, e) {
      let somethingChanged = false,
        invalidate = false;
      const objects = this.getActiveObjects(),
        added = [],
        removed = [];
      oldObjects.forEach(target => {
        if (!objects.includes(target)) {
          somethingChanged = true;
          target.fire('deselected', {
            e,
            target
          });
          removed.push(target);
        }
      });
      objects.forEach(target => {
        if (!oldObjects.includes(target)) {
          somethingChanged = true;
          target.fire('selected', {
            e,
            target
          });
          added.push(target);
        }
      });
      if (oldObjects.length > 0 && objects.length > 0) {
        invalidate = true;
        somethingChanged && this.fire('selection:updated', {
          e,
          selected: added,
          deselected: removed
        });
      } else if (objects.length > 0) {
        invalidate = true;
        this.fire('selection:created', {
          e,
          selected: added
        });
      } else if (oldObjects.length > 0) {
        invalidate = true;
        this.fire('selection:cleared', {
          e,
          deselected: removed
        });
      }
      invalidate && (this._objectsToRender = undefined);
    }

    /**
     * Sets given object as the only active object on canvas
     * @param {FabricObject} object Object to set as an active one
     * @param {TPointerEvent} [e] Event (passed along when firing "object:selected")
     * @return {Boolean} true if the object has been selected
     */
    setActiveObject(object, e) {
      // we can't inline this, since _setActiveObject will change what getActiveObjects returns
      const currentActives = this.getActiveObjects();
      const selected = this._setActiveObject(object, e);
      this._fireSelectionEvents(currentActives, e);
      return selected;
    }

    /**
     * This is supposed to be equivalent to setActiveObject but without firing
     * any event. There is commitment to have this stay this way.
     * This is the functional part of setActiveObject.
     * @param {Object} object to set as active
     * @param {Event} [e] Event (passed along when firing "object:selected")
     * @return {Boolean} true if the object has been selected
     */
    _setActiveObject(object, e) {
      const prevActiveObject = this._activeObject;
      if (prevActiveObject === object) {
        return false;
      }
      // after calling this._discardActiveObject, this,_activeObject could be undefined
      if (!this._discardActiveObject(e, object) && this._activeObject) {
        // refused to deselect
        return false;
      }
      if (object.onSelect({
        e
      })) {
        return false;
      }
      this._activeObject = object;
      if (isActiveSelection(object) && prevActiveObject !== object) {
        object.set('canvas', this);
      }
      object.setCoords();
      return true;
    }

    /**
     * This is supposed to be equivalent to discardActiveObject but without firing
     * any selection events ( can still fire object transformation events ). There is commitment to have this stay this way.
     * This is the functional part of discardActiveObject.
     * @param {Event} [e] Event (passed along when firing "object:deselected")
     * @param {Object} object the next object to set as active, reason why we are discarding this
     * @return {Boolean} true if the active object has been discarded
     */
    _discardActiveObject(e, object) {
      const obj = this._activeObject;
      if (obj) {
        // onDeselect return TRUE to cancel selection;
        if (obj.onDeselect({
          e,
          object
        })) {
          return false;
        }
        if (this._currentTransform && this._currentTransform.target === obj) {
          this.endCurrentTransform(e);
        }
        if (isActiveSelection(obj) && obj === this._hoveredTarget) {
          this._hoveredTarget = undefined;
        }
        this._activeObject = undefined;
        return true;
      }
      return false;
    }

    /**
     * Discards currently active object and fire events. If the function is called by fabric
     * as a consequence of a mouse event, the event is passed as a parameter and
     * sent to the fire function for the custom events. When used as a method the
     * e param does not have any application.
     * @param {event} e
     * @return {Boolean} true if the active object has been discarded
     */
    discardActiveObject(e) {
      const currentActives = this.getActiveObjects(),
        activeObject = this.getActiveObject();
      if (currentActives.length) {
        this.fire('before:selection:cleared', {
          e,
          deselected: [activeObject]
        });
      }
      const discarded = this._discardActiveObject(e);
      this._fireSelectionEvents(currentActives, e);
      return discarded;
    }

    /**
     * End the current transform.
     * You don't usually need to call this method unless you are interrupting a user initiated transform
     * because of some other event ( a press of key combination, or something that block the user UX )
     * @param {Event} [e] send the mouse event that generate the finalize down, so it can be used in the event
     */
    endCurrentTransform(e) {
      const transform = this._currentTransform;
      this._finalizeCurrentTransform(e);
      if (transform && transform.target) {
        // this could probably go inside _finalizeCurrentTransform
        transform.target.isMoving = false;
      }
      this._currentTransform = null;
    }

    /**
     * @private
     * @param {Event} e send the mouse event that generate the finalize down, so it can be used in the event
     */
    _finalizeCurrentTransform(e) {
      const transform = this._currentTransform,
        target = transform.target,
        options = {
          e,
          target,
          transform,
          action: transform.action
        };
      if (target._scaling) {
        target._scaling = false;
      }
      target.setCoords();
      if (transform.actionPerformed) {
        this.fire('object:modified', options);
        target.fire(MODIFIED, options);
      }
    }

    /**
     * Sets viewport transformation of this canvas instance
     * @param {Array} vpt a Canvas 2D API transform matrix
     */
    setViewportTransform(vpt) {
      super.setViewportTransform(vpt);
      const activeObject = this._activeObject;
      if (activeObject) {
        activeObject.setCoords();
      }
    }

    /**
     * @override clears active selection ref and interactive canvas elements and contexts
     */
    destroy() {
      // dispose of active selection
      const activeObject = this._activeObject;
      if (isActiveSelection(activeObject)) {
        activeObject.removeAll();
        activeObject.dispose();
      }
      delete this._activeObject;
      super.destroy();

      // free resources

      // pixel find canvas
      // @ts-expect-error disposing
      this.pixelFindContext = null;
      // @ts-expect-error disposing
      this.pixelFindCanvasEl = undefined;
    }

    /**
     * Clears all contexts (background, main, top) of an instance
     */
    clear() {
      // discard active object and fire events
      this.discardActiveObject();
      // make sure we clear the active object in case it refused to be discarded
      this._activeObject = undefined;
      this.clearContext(this.contextTop);
      super.clear();
    }

    /**
     * Draws objects' controls (borders/controls)
     * @param {CanvasRenderingContext2D} ctx Context to render controls on
     */
    drawControls(ctx) {
      const activeObject = this._activeObject;
      if (activeObject) {
        activeObject._renderControls(ctx);
      }
    }

    /**
     * @private
     */
    _toObject(instance, methodName, propertiesToInclude) {
      // If the object is part of the current selection group, it should
      // be transformed appropriately
      // i.e. it should be serialised as it would appear if the selection group
      // were to be destroyed.
      const originalProperties = this._realizeGroupTransformOnObject(instance),
        object = super._toObject(instance, methodName, propertiesToInclude);
      //Undo the damage we did by changing all of its properties
      instance.set(originalProperties);
      return object;
    }

    /**
     * Realizes an object's group transformation on it
     * @private
     * @param {FabricObject} [instance] the object to transform (gets mutated)
     * @returns the original values of instance which were changed
     */
    _realizeGroupTransformOnObject(instance) {
      const {
        group
      } = instance;
      if (group && isActiveSelection(group) && this._activeObject === group) {
        const layoutProps = ['angle', 'flipX', 'flipY', LEFT, SCALE_X, SCALE_Y, SKEW_X, SKEW_Y, TOP];
        const originalValues = pick(instance, layoutProps);
        addTransformToObject(instance, group.calcOwnMatrix());
        return originalValues;
      } else {
        return {};
      }
    }

    /**
     * @private
     */
    _setSVGObject(markup, instance, reviver) {
      // If the object is in a selection group, simulate what would happen to that
      // object when the group is deselected
      const originalProperties = this._realizeGroupTransformOnObject(instance);
      super._setSVGObject(markup, instance, reviver);
      instance.set(originalProperties);
    }
  }
  _defineProperty(SelectableCanvas, "ownDefaults", canvasDefaults);

  /**
   * In charge of synchronizing all interactive text instances of a canvas
   */
  class TextEditingManager {
    constructor(canvas) {
      _defineProperty(this, "targets", []);
      _defineProperty(this, "__disposer", void 0);
      const cb = () => {
        const {
          hiddenTextarea
        } = canvas.getActiveObject() || {};
        hiddenTextarea && hiddenTextarea.focus();
      };
      const el = canvas.upperCanvasEl;
      el.addEventListener('click', cb);
      this.__disposer = () => el.removeEventListener('click', cb);
    }
    exitTextEditing() {
      this.target = undefined;
      this.targets.forEach(target => {
        if (target.isEditing) {
          target.exitEditing();
        }
      });
    }
    add(target) {
      this.targets.push(target);
    }
    remove(target) {
      this.unregister(target);
      removeFromArray(this.targets, target);
    }
    register(target) {
      this.target = target;
    }
    unregister(target) {
      if (target === this.target) {
        this.target = undefined;
      }
    }
    onMouseMove(e) {
      var _this$target;
      ((_this$target = this.target) === null || _this$target === void 0 ? void 0 : _this$target.isEditing) && this.target.updateSelectionOnMouseMove(e);
    }
    clear() {
      this.targets = [];
      this.target = undefined;
    }
    dispose() {
      this.clear();
      this.__disposer();
      // @ts-expect-error disposing
      delete this.__disposer;
    }
  }

  const _excluded$9 = ["target", "oldTarget", "fireCanvas", "e"];
  const addEventOptions = {
    passive: false
  };
  const getEventPoints = (canvas, e) => {
    const viewportPoint = canvas.getViewportPoint(e);
    const scenePoint = canvas.getScenePoint(e);
    return {
      viewportPoint,
      scenePoint,
      pointer: viewportPoint,
      absolutePointer: scenePoint
    };
  };

  // just to be clear, the utils are now deprecated and those are here exactly as minifier helpers
  // because el.addEventListener can't me be minified while a const yes and we use it 47 times in this file.
  // few bytes but why give it away.
  const addListener = function (el) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    return el.addEventListener(...args);
  };
  const removeListener = function (el) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    return el.removeEventListener(...args);
  };
  const syntheticEventConfig = {
    mouse: {
      in: 'over',
      out: 'out',
      targetIn: 'mouseover',
      targetOut: 'mouseout',
      canvasIn: 'mouse:over',
      canvasOut: 'mouse:out'
    },
    drag: {
      in: 'enter',
      out: 'leave',
      targetIn: 'dragenter',
      targetOut: 'dragleave',
      canvasIn: 'drag:enter',
      canvasOut: 'drag:leave'
    }
  };
  class Canvas extends SelectableCanvas {
    constructor(el) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      super(el, options);
      // bind event handlers
      /**
       * Contains the id of the touch event that owns the fabric transform
       * @type Number
       * @private
       */
      /**
       * Holds a reference to a setTimeout timer for event synchronization
       * @type number
       * @private
       */
      /**
       * Holds a reference to an object on the canvas that is receiving the drag over event.
       * @type FabricObject
       * @private
       */
      /**
       * Holds a reference to an object on the canvas from where the drag operation started
       * @type FabricObject
       * @private
       */
      /**
       * Holds a reference to an object on the canvas that is the current drop target
       * May differ from {@link _draggedoverTarget}
       * @todo inspect whether {@link _draggedoverTarget} and {@link _dropTarget} should be merged somehow
       * @type FabricObject
       * @private
       */
      /**
       * a boolean that keeps track of the click state during a cycle of mouse down/up.
       * If a mouse move occurs it becomes false.
       * Is true by default, turns false on mouse move.
       * Used to determine if a mouseUp is a click
       */
      _defineProperty(this, "_isClick", void 0);
      _defineProperty(this, "textEditingManager", new TextEditingManager(this));
      ['_onMouseDown', '_onTouchStart', '_onMouseMove', '_onMouseUp', '_onTouchEnd', '_onResize',
      // '_onGesture',
      // '_onDrag',
      // '_onShake',
      // '_onLongPress',
      // '_onOrientationChange',
      '_onMouseWheel', '_onMouseOut', '_onMouseEnter', '_onContextMenu', '_onClick', '_onDragStart', '_onDragEnd', '_onDragProgress', '_onDragOver', '_onDragEnter', '_onDragLeave', '_onDrop'].forEach(eventHandler => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
        this[eventHandler] = this[eventHandler].bind(this);
      });
      // register event handlers
      this.addOrRemove(addListener, 'add');
    }

    /**
     * return an event prefix pointer or mouse.
     * @private
     */
    _getEventPrefix() {
      return this.enablePointerEvents ? 'pointer' : 'mouse';
    }
    addOrRemove(functor, _eventjsFunctor) {
      const canvasElement = this.upperCanvasEl,
        eventTypePrefix = this._getEventPrefix();
      functor(getWindowFromElement(canvasElement), 'resize', this._onResize);
      functor(canvasElement, eventTypePrefix + 'down', this._onMouseDown);
      functor(canvasElement, "".concat(eventTypePrefix, "move"), this._onMouseMove, addEventOptions);
      functor(canvasElement, "".concat(eventTypePrefix, "out"), this._onMouseOut);
      functor(canvasElement, "".concat(eventTypePrefix, "enter"), this._onMouseEnter);
      functor(canvasElement, 'wheel', this._onMouseWheel);
      functor(canvasElement, 'contextmenu', this._onContextMenu);
      functor(canvasElement, 'click', this._onClick);
      // decide if to remove in fabric 7.0
      functor(canvasElement, 'dblclick', this._onClick);
      functor(canvasElement, 'dragstart', this._onDragStart);
      functor(canvasElement, 'dragend', this._onDragEnd);
      functor(canvasElement, 'dragover', this._onDragOver);
      functor(canvasElement, 'dragenter', this._onDragEnter);
      functor(canvasElement, 'dragleave', this._onDragLeave);
      functor(canvasElement, 'drop', this._onDrop);
      if (!this.enablePointerEvents) {
        functor(canvasElement, 'touchstart', this._onTouchStart, addEventOptions);
      }
      // if (typeof eventjs !== 'undefined' && eventjsFunctor in eventjs) {
      //   eventjs[eventjsFunctor](canvasElement, 'gesture', this._onGesture);
      //   eventjs[eventjsFunctor](canvasElement, 'drag', this._onDrag);
      //   eventjs[eventjsFunctor](
      //     canvasElement,
      //     'orientation',
      //     this._onOrientationChange
      //   );
      //   eventjs[eventjsFunctor](canvasElement, 'shake', this._onShake);
      //   eventjs[eventjsFunctor](canvasElement, 'longpress', this._onLongPress);
      // }
    }

    /**
     * Removes all event listeners, used when disposing the instance
     */
    removeListeners() {
      this.addOrRemove(removeListener, 'remove');
      // if you dispose on a mouseDown, before mouse up, you need to clean document to...
      const eventTypePrefix = this._getEventPrefix();
      const doc = getDocumentFromElement(this.upperCanvasEl);
      removeListener(doc, "".concat(eventTypePrefix, "up"), this._onMouseUp);
      removeListener(doc, 'touchend', this._onTouchEnd, addEventOptions);
      removeListener(doc, "".concat(eventTypePrefix, "move"), this._onMouseMove, addEventOptions);
      removeListener(doc, 'touchmove', this._onMouseMove, addEventOptions);
      clearTimeout(this._willAddMouseDown);
    }

    /**
     * @private
     * @param {Event} [e] Event object fired on wheel event
     */
    _onMouseWheel(e) {
      this.__onMouseWheel(e);
    }

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onMouseOut(e) {
      const target = this._hoveredTarget;
      const shared = _objectSpread2({
        e
      }, getEventPoints(this, e));
      this.fire('mouse:out', _objectSpread2(_objectSpread2({}, shared), {}, {
        target
      }));
      this._hoveredTarget = undefined;
      target && target.fire('mouseout', _objectSpread2({}, shared));
      this._hoveredTargets.forEach(nestedTarget => {
        this.fire('mouse:out', _objectSpread2(_objectSpread2({}, shared), {}, {
          target: nestedTarget
        }));
        nestedTarget && nestedTarget.fire('mouseout', _objectSpread2({}, shared));
      });
      this._hoveredTargets = [];
    }

    /**
     * @private
     * @param {Event} e Event object fired on mouseenter
     */
    _onMouseEnter(e) {
      // This find target and consequent 'mouse:over' is used to
      // clear old instances on hovered target.
      // calling findTarget has the side effect of killing target.__corner.
      // as a short term fix we are not firing this if we are currently transforming.
      // as a long term fix we need to separate the action of finding a target with the
      // side effects we added to it.
      if (!this._currentTransform && !this.findTarget(e)) {
        this.fire('mouse:over', _objectSpread2({
          e
        }, getEventPoints(this, e)));
        this._hoveredTarget = undefined;
        this._hoveredTargets = [];
      }
    }

    /**
     * supports native like text dragging
     * @private
     * @param {DragEvent} e
     */
    _onDragStart(e) {
      this._isClick = false;
      const activeObject = this.getActiveObject();
      if (activeObject && activeObject.onDragStart(e)) {
        this._dragSource = activeObject;
        const options = {
          e,
          target: activeObject
        };
        this.fire('dragstart', options);
        activeObject.fire('dragstart', options);
        addListener(this.upperCanvasEl, 'drag', this._onDragProgress);
        return;
      }
      stopEvent(e);
    }

    /**
     * First we clear top context where the effects are being rendered.
     * Then we render the effects.
     * Doing so will render the correct effect for all cases including an overlap between `source` and `target`.
     * @private
     */
    _renderDragEffects(e, source, target) {
      let dirty = false;
      // clear top context
      const dropTarget = this._dropTarget;
      if (dropTarget && dropTarget !== source && dropTarget !== target) {
        dropTarget.clearContextTop();
        dirty = true;
      }
      source === null || source === void 0 || source.clearContextTop();
      target !== source && (target === null || target === void 0 ? void 0 : target.clearContextTop());
      // render effects
      const ctx = this.contextTop;
      ctx.save();
      ctx.transform(...this.viewportTransform);
      if (source) {
        ctx.save();
        source.transform(ctx);
        source.renderDragSourceEffect(e);
        ctx.restore();
        dirty = true;
      }
      if (target) {
        ctx.save();
        target.transform(ctx);
        target.renderDropTargetEffect(e);
        ctx.restore();
        dirty = true;
      }
      ctx.restore();
      dirty && (this.contextTopDirty = true);
    }

    /**
     * supports native like text dragging
     * https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Drag_operations#finishing_a_drag
     * @private
     * @param {DragEvent} e
     */
    _onDragEnd(e) {
      const didDrop = !!e.dataTransfer && e.dataTransfer.dropEffect !== NONE,
        dropTarget = didDrop ? this._activeObject : undefined,
        options = {
          e,
          target: this._dragSource,
          subTargets: this.targets,
          dragSource: this._dragSource,
          didDrop,
          dropTarget: dropTarget
        };
      removeListener(this.upperCanvasEl, 'drag', this._onDragProgress);
      this.fire('dragend', options);
      this._dragSource && this._dragSource.fire('dragend', options);
      delete this._dragSource;
      // we need to call mouse up synthetically because the browser won't
      this._onMouseUp(e);
    }

    /**
     * fire `drag` event on canvas and drag source
     * @private
     * @param {DragEvent} e
     */
    _onDragProgress(e) {
      const options = {
        e,
        target: this._dragSource,
        dragSource: this._dragSource,
        dropTarget: this._draggedoverTarget
      };
      this.fire('drag', options);
      this._dragSource && this._dragSource.fire('drag', options);
    }

    /**
     * As opposed to {@link findTarget} we want the top most object to be returned w/o the active object cutting in line.
     * Override at will
     */
    findDragTargets(e) {
      this.targets = [];
      const target = this._searchPossibleTargets(this._objects, this.getViewportPoint(e));
      return {
        target,
        targets: [...this.targets]
      };
    }

    /**
     * prevent default to allow drop event to be fired
     * https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Drag_operations#specifying_drop_targets
     * @private
     * @param {DragEvent} [e] Event object fired on Event.js shake
     */
    _onDragOver(e) {
      const eventType = 'dragover';
      const {
        target,
        targets
      } = this.findDragTargets(e);
      const dragSource = this._dragSource;
      const options = {
        e,
        target,
        subTargets: targets,
        dragSource,
        canDrop: false,
        dropTarget: undefined
      };
      let dropTarget;
      //  fire on canvas
      this.fire(eventType, options);
      //  make sure we fire dragenter events before dragover
      //  if dragleave is needed, object will not fire dragover so we don't need to trouble ourselves with it
      this._fireEnterLeaveEvents(target, options);
      if (target) {
        if (target.canDrop(e)) {
          dropTarget = target;
        }
        target.fire(eventType, options);
      }
      //  propagate the event to subtargets
      for (let i = 0; i < targets.length; i++) {
        const subTarget = targets[i];
        // accept event only if previous targets didn't (the accepting target calls `preventDefault` to inform that the event is taken)
        // TODO: verify if those should loop in inverse order then?
        // what is the order of subtargets?
        if (subTarget.canDrop(e)) {
          dropTarget = subTarget;
        }
        subTarget.fire(eventType, options);
      }
      //  render drag effects now that relations between source and target is clear
      this._renderDragEffects(e, dragSource, dropTarget);
      this._dropTarget = dropTarget;
    }

    /**
     * fire `dragleave` on `dragover` targets
     * @private
     * @param {Event} [e] Event object fired on Event.js shake
     */
    _onDragEnter(e) {
      const {
        target,
        targets
      } = this.findDragTargets(e);
      const options = {
        e,
        target,
        subTargets: targets,
        dragSource: this._dragSource
      };
      this.fire('dragenter', options);
      //  fire dragenter on targets
      this._fireEnterLeaveEvents(target, options);
    }

    /**
     * fire `dragleave` on `dragover` targets
     * @private
     * @param {Event} [e] Event object fired on Event.js shake
     */
    _onDragLeave(e) {
      const options = {
        e,
        target: this._draggedoverTarget,
        subTargets: this.targets,
        dragSource: this._dragSource
      };
      this.fire('dragleave', options);

      //  fire dragleave on targets
      this._fireEnterLeaveEvents(undefined, options);
      this._renderDragEffects(e, this._dragSource);
      this._dropTarget = undefined;
      //  clear targets
      this.targets = [];
      this._hoveredTargets = [];
    }

    /**
     * `drop:before` is a an event that allows you to schedule logic
     * before the `drop` event. Prefer `drop` event always, but if you need
     * to run some drop-disabling logic on an event, since there is no way
     * to handle event handlers ordering, use `drop:before`
     * @private
     * @param {Event} e
     */
    _onDrop(e) {
      const {
        target,
        targets
      } = this.findDragTargets(e);
      const options = this._basicEventHandler('drop:before', _objectSpread2({
        e,
        target,
        subTargets: targets,
        dragSource: this._dragSource
      }, getEventPoints(this, e)));
      //  will be set by the drop target
      options.didDrop = false;
      //  will be set by the drop target, used in case options.target refuses the drop
      options.dropTarget = undefined;
      //  fire `drop`
      this._basicEventHandler('drop', options);
      //  inform canvas of the drop
      //  we do this because canvas was unaware of what happened at the time the `drop` event was fired on it
      //  use for side effects
      this.fire('drop:after', options);
    }

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onContextMenu(e) {
      const target = this.findTarget(e),
        subTargets = this.targets || [];
      const options = this._basicEventHandler('contextmenu:before', {
        e,
        target,
        subTargets
      });
      // TODO: this line is silly because the dev can subscribe to the event and prevent it themselves
      this.stopContextMenu && stopEvent(e);
      this._basicEventHandler('contextmenu', options);
      return false;
    }

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onClick(e) {
      const clicks = e.detail;
      if (clicks > 3 || clicks < 2) return;
      this._cacheTransformEventData(e);
      clicks == 2 && e.type === 'dblclick' && this._handleEvent(e, 'dblclick');
      clicks == 3 && this._handleEvent(e, 'tripleclick');
      this._resetTransformEventData();
    }

    /**
     * Return a the id of an event.
     * returns either the pointerId or the identifier or 0 for the mouse event
     * @private
     * @param {Event} evt Event object
     */
    getPointerId(evt) {
      const changedTouches = evt.changedTouches;
      if (changedTouches) {
        return changedTouches[0] && changedTouches[0].identifier;
      }
      if (this.enablePointerEvents) {
        return evt.pointerId;
      }
      return -1;
    }

    /**
     * Determines if an event has the id of the event that is considered main
     * @private
     * @param {evt} event Event object
     */
    _isMainEvent(evt) {
      if (evt.isPrimary === true) {
        return true;
      }
      if (evt.isPrimary === false) {
        return false;
      }
      if (evt.type === 'touchend' && evt.touches.length === 0) {
        return true;
      }
      if (evt.changedTouches) {
        return evt.changedTouches[0].identifier === this.mainTouchId;
      }
      return true;
    }

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onTouchStart(e) {
      // we will prevent scrolling if allowTouchScrolling is not enabled and
      let shouldPreventScrolling = !this.allowTouchScrolling;
      const currentActiveObject = this._activeObject;
      if (this.mainTouchId === undefined) {
        this.mainTouchId = this.getPointerId(e);
      }
      this.__onMouseDown(e);
      // after executing fabric logic for mouse down let's see
      // if we didn't change target or if we are drawing
      // we want to prevent scrolling anyway
      if (this.isDrawingMode || currentActiveObject && this._target === currentActiveObject) {
        shouldPreventScrolling = true;
      }
      // prevent default, will block scrolling from start
      shouldPreventScrolling && e.preventDefault();
      this._resetTransformEventData();
      const canvasElement = this.upperCanvasEl,
        eventTypePrefix = this._getEventPrefix();
      const doc = getDocumentFromElement(canvasElement);
      addListener(doc, 'touchend', this._onTouchEnd, addEventOptions);
      // if we scroll don't register the touch move event
      shouldPreventScrolling && addListener(doc, 'touchmove', this._onMouseMove, addEventOptions);
      // Unbind mousedown to prevent double triggers from touch devices
      removeListener(canvasElement, "".concat(eventTypePrefix, "down"), this._onMouseDown);
    }

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onMouseDown(e) {
      this.__onMouseDown(e);
      this._resetTransformEventData();
      const canvasElement = this.upperCanvasEl,
        eventTypePrefix = this._getEventPrefix();
      removeListener(canvasElement, "".concat(eventTypePrefix, "move"), this._onMouseMove, addEventOptions);
      const doc = getDocumentFromElement(canvasElement);
      addListener(doc, "".concat(eventTypePrefix, "up"), this._onMouseUp);
      addListener(doc, "".concat(eventTypePrefix, "move"), this._onMouseMove, addEventOptions);
    }

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onTouchEnd(e) {
      if (e.touches.length > 0) {
        // if there are still touches stop here
        return;
      }
      this.__onMouseUp(e);
      this._resetTransformEventData();
      delete this.mainTouchId;
      const eventTypePrefix = this._getEventPrefix();
      const doc = getDocumentFromElement(this.upperCanvasEl);
      removeListener(doc, 'touchend', this._onTouchEnd, addEventOptions);
      removeListener(doc, 'touchmove', this._onMouseMove, addEventOptions);
      if (this._willAddMouseDown) {
        clearTimeout(this._willAddMouseDown);
      }
      this._willAddMouseDown = setTimeout(() => {
        // Wait 400ms before rebinding mousedown to prevent double triggers
        // from touch devices
        addListener(this.upperCanvasEl, "".concat(eventTypePrefix, "down"), this._onMouseDown);
        this._willAddMouseDown = 0;
      }, 400);
    }

    /**
     * @private
     * @param {Event} e Event object fired on mouseup
     */
    _onMouseUp(e) {
      this.__onMouseUp(e);
      this._resetTransformEventData();
      const canvasElement = this.upperCanvasEl,
        eventTypePrefix = this._getEventPrefix();
      if (this._isMainEvent(e)) {
        const doc = getDocumentFromElement(this.upperCanvasEl);
        removeListener(doc, "".concat(eventTypePrefix, "up"), this._onMouseUp);
        removeListener(doc, "".concat(eventTypePrefix, "move"), this._onMouseMove, addEventOptions);
        addListener(canvasElement, "".concat(eventTypePrefix, "move"), this._onMouseMove, addEventOptions);
      }
    }

    /**
     * @private
     * @param {Event} e Event object fired on mousemove
     */
    _onMouseMove(e) {
      const activeObject = this.getActiveObject();
      !this.allowTouchScrolling && (!activeObject ||
      // a drag event sequence is started by the active object flagging itself on mousedown / mousedown:before
      // we must not prevent the event's default behavior in order for the window to start dragging
      !activeObject.shouldStartDragging(e)) && e.preventDefault && e.preventDefault();
      this.__onMouseMove(e);
    }

    /**
     * @private
     */
    _onResize() {
      this.calcOffset();
      this._resetTransformEventData();
    }

    /**
     * Decides whether the canvas should be redrawn in mouseup and mousedown events.
     * @private
     * @param {Object} target
     */
    _shouldRender(target) {
      const activeObject = this.getActiveObject();
      // if just one of them is available or if they are both but are different objects
      // this covers: switch of target, from target to no target, selection of target
      // multiSelection with key and mouse
      return !!activeObject !== !!target || activeObject && target && activeObject !== target;
    }

    /**
     * Method that defines the actions when mouse is released on canvas.
     * The method resets the currentTransform parameters, store the image corner
     * position in the image object and render the canvas on top.
     * @private
     * @param {Event} e Event object fired on mouseup
     */
    __onMouseUp(e) {
      var _this$_activeObject;
      this._cacheTransformEventData(e);
      this._handleEvent(e, 'up:before');
      const transform = this._currentTransform;
      const isClick = this._isClick;
      const target = this._target;

      // if right/middle click just fire events and return
      // target undefined will make the _handleEvent search the target
      const {
        button
      } = e;
      if (button) {
        (this.fireMiddleClick && button === 1 || this.fireRightClick && button === 2) && this._handleEvent(e, 'up');
        this._resetTransformEventData();
        return;
      }
      if (this.isDrawingMode && this._isCurrentlyDrawing) {
        this._onMouseUpInDrawingMode(e);
        return;
      }
      if (!this._isMainEvent(e)) {
        return;
      }
      let shouldRender = false;
      if (transform) {
        this._finalizeCurrentTransform(e);
        shouldRender = transform.actionPerformed;
      }
      if (!isClick) {
        const targetWasActive = target === this._activeObject;
        this.handleSelection(e);
        if (!shouldRender) {
          shouldRender = this._shouldRender(target) || !targetWasActive && target === this._activeObject;
        }
      }
      let pointer, corner;
      if (target) {
        const found = target.findControl(this.getViewportPoint(e), isTouchEvent(e));
        const {
          key,
          control
        } = found || {};
        corner = key;
        if (target.selectable && target !== this._activeObject && target.activeOn === 'up') {
          this.setActiveObject(target, e);
          shouldRender = true;
        } else if (control) {
          const mouseUpHandler = control.getMouseUpHandler(e, target, control);
          if (mouseUpHandler) {
            pointer = this.getScenePoint(e);
            mouseUpHandler.call(control, e, transform, pointer.x, pointer.y);
          }
        }
        target.isMoving = false;
      }
      // if we are ending up a transform on a different control or a new object
      // fire the original mouse up from the corner that started the transform
      if (transform && (transform.target !== target || transform.corner !== corner)) {
        const originalControl = transform.target && transform.target.controls[transform.corner],
          originalMouseUpHandler = originalControl && originalControl.getMouseUpHandler(e, transform.target, originalControl);
        pointer = pointer || this.getScenePoint(e);
        originalMouseUpHandler && originalMouseUpHandler.call(originalControl, e, transform, pointer.x, pointer.y);
      }
      this._setCursorFromEvent(e, target);
      this._handleEvent(e, 'up');
      this._groupSelector = null;
      this._currentTransform = null;
      // reset the target information about which corner is selected
      target && (target.__corner = undefined);
      if (shouldRender) {
        this.requestRenderAll();
      } else if (!isClick && !((_this$_activeObject = this._activeObject) !== null && _this$_activeObject !== void 0 && _this$_activeObject.isEditing)) {
        this.renderTop();
      }
    }
    _basicEventHandler(eventType, options) {
      const {
        target,
        subTargets = []
      } = options;
      this.fire(eventType, options);
      target && target.fire(eventType, options);
      for (let i = 0; i < subTargets.length; i++) {
        subTargets[i] !== target && subTargets[i].fire(eventType, options);
      }
      return options;
    }

    /**
     * @private
     * Handle event firing for target and subtargets
     * @param {TPointerEvent} e event from mouse
     * @param {TPointerEventNames} eventType
     */
    _handleEvent(e, eventType, extraData) {
      const target = this._target,
        targets = this.targets || [],
        options = _objectSpread2(_objectSpread2(_objectSpread2({
          e,
          target,
          subTargets: targets
        }, getEventPoints(this, e)), {}, {
          transform: this._currentTransform
        }, eventType === 'up:before' || eventType === 'up' ? {
          isClick: this._isClick,
          currentTarget: this.findTarget(e),
          // set by the preceding `findTarget` call
          currentSubTargets: this.targets
        } : {}), eventType === 'down:before' || eventType === 'down' ? extraData : {});
      this.fire("mouse:".concat(eventType), options);
      // this may be a little be more complicated of what we want to handle
      target && target.fire("mouse".concat(eventType), options);
      for (let i = 0; i < targets.length; i++) {
        targets[i] !== target && targets[i].fire("mouse".concat(eventType), options);
      }
    }

    /**
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    _onMouseDownInDrawingMode(e) {
      this._isCurrentlyDrawing = true;
      if (this.getActiveObject()) {
        this.discardActiveObject(e);
        this.requestRenderAll();
      }
      // TODO: this is a scene point so it should be renamed
      const pointer = this.getScenePoint(e);
      this.freeDrawingBrush && this.freeDrawingBrush.onMouseDown(pointer, {
        e,
        pointer
      });
      this._handleEvent(e, 'down', {
        alreadySelected: false
      });
    }

    /**
     * @private
     * @param {Event} e Event object fired on mousemove
     */
    _onMouseMoveInDrawingMode(e) {
      if (this._isCurrentlyDrawing) {
        const pointer = this.getScenePoint(e);
        this.freeDrawingBrush && this.freeDrawingBrush.onMouseMove(pointer, {
          e,
          // this is an absolute pointer, the naming is wrong
          pointer
        });
      }
      this.setCursor(this.freeDrawingCursor);
      this._handleEvent(e, 'move');
    }

    /**
     * @private
     * @param {Event} e Event object fired on mouseup
     */
    _onMouseUpInDrawingMode(e) {
      const pointer = this.getScenePoint(e);
      if (this.freeDrawingBrush) {
        this._isCurrentlyDrawing = !!this.freeDrawingBrush.onMouseUp({
          e: e,
          // this is an absolute pointer, the naming is wrong
          pointer
        });
      } else {
        this._isCurrentlyDrawing = false;
      }
      this._handleEvent(e, 'up');
    }

    /**
     * Method that defines the actions when mouse is clicked on canvas.
     * The method inits the currentTransform parameters and renders all the
     * canvas so the current image can be placed on the top canvas and the rest
     * in on the container one.
     * @private
     * @param {Event} e Event object fired on mousedown
     */
    __onMouseDown(e) {
      this._isClick = true;
      this._cacheTransformEventData(e);
      this._handleEvent(e, 'down:before');
      let target = this._target;
      let alreadySelected = !!target && target === this._activeObject;
      // if right/middle click just fire events
      const {
        button
      } = e;
      if (button) {
        (this.fireMiddleClick && button === 1 || this.fireRightClick && button === 2) && this._handleEvent(e, 'down', {
          alreadySelected
        });
        this._resetTransformEventData();
        return;
      }
      if (this.isDrawingMode) {
        this._onMouseDownInDrawingMode(e);
        return;
      }
      if (!this._isMainEvent(e)) {
        return;
      }

      // ignore if some object is being transformed at this moment
      if (this._currentTransform) {
        return;
      }
      let shouldRender = this._shouldRender(target);
      let grouped = false;
      if (this.handleMultiSelection(e, target)) {
        // active object might have changed while grouping
        target = this._activeObject;
        grouped = true;
        shouldRender = true;
      } else if (this._shouldClearSelection(e, target)) {
        this.discardActiveObject(e);
      }
      // we start a group selector rectangle if
      // selection is enabled
      // and there is no target, or the following 3 conditions are satisfied:
      // target is not selectable ( otherwise we selected it )
      // target is not editing
      // target is not already selected ( otherwise we drag )
      if (this.selection && (!target || !target.selectable && !target.isEditing && target !== this._activeObject)) {
        const p = this.getScenePoint(e);
        this._groupSelector = {
          x: p.x,
          y: p.y,
          deltaY: 0,
          deltaX: 0
        };
      }

      // check again because things could have changed
      alreadySelected = !!target && target === this._activeObject;
      if (target) {
        if (target.selectable && target.activeOn === 'down') {
          this.setActiveObject(target, e);
        }
        const handle = target.findControl(this.getViewportPoint(e), isTouchEvent(e));
        if (target === this._activeObject && (handle || !grouped)) {
          this._setupCurrentTransform(e, target, alreadySelected);
          const control = handle ? handle.control : undefined,
            pointer = this.getScenePoint(e),
            mouseDownHandler = control && control.getMouseDownHandler(e, target, control);
          mouseDownHandler && mouseDownHandler.call(control, e, this._currentTransform, pointer.x, pointer.y);
        }
      }
      //  we clear `_objectsToRender` in case of a change in order to repopulate it at rendering
      //  run before firing the `down` event to give the dev a chance to populate it themselves
      shouldRender && (this._objectsToRender = undefined);
      this._handleEvent(e, 'down', {
        alreadySelected: alreadySelected
      });
      // we must renderAll so that we update the visuals
      shouldRender && this.requestRenderAll();
    }

    /**
     * reset cache form common information needed during event processing
     * @private
     */
    _resetTransformEventData() {
      this._target = this._pointer = this._absolutePointer = undefined;
    }

    /**
     * Cache common information needed during event processing
     * @private
     * @param {Event} e Event object fired on event
     */
    _cacheTransformEventData(e) {
      // reset in order to avoid stale caching
      this._resetTransformEventData();
      this._pointer = this.getViewportPoint(e);
      this._absolutePointer = sendPointToPlane(this._pointer, undefined, this.viewportTransform);
      this._target = this._currentTransform ? this._currentTransform.target : this.findTarget(e);
    }

    /**
     * Method that defines the actions when mouse is hovering the canvas.
     * The currentTransform parameter will define whether the user is rotating/scaling/translating
     * an image or neither of them (only hovering). A group selection is also possible and would cancel
     * all any other type of action.
     * In case of an image transformation only the top canvas will be rendered.
     * @private
     * @param {Event} e Event object fired on mousemove
     */
    __onMouseMove(e) {
      this._isClick = false;
      this._cacheTransformEventData(e);
      this._handleEvent(e, 'move:before');
      if (this.isDrawingMode) {
        this._onMouseMoveInDrawingMode(e);
        return;
      }
      if (!this._isMainEvent(e)) {
        return;
      }
      const groupSelector = this._groupSelector;

      // We initially clicked in an empty area, so we draw a box for multiple selection
      if (groupSelector) {
        const pointer = this.getScenePoint(e);
        groupSelector.deltaX = pointer.x - groupSelector.x;
        groupSelector.deltaY = pointer.y - groupSelector.y;
        this.renderTop();
      } else if (!this._currentTransform) {
        const target = this.findTarget(e);
        this._setCursorFromEvent(e, target);
        this._fireOverOutEvents(e, target);
      } else {
        this._transformObject(e);
      }
      this.textEditingManager.onMouseMove(e);
      this._handleEvent(e, 'move');
      this._resetTransformEventData();
    }

    /**
     * Manage the mouseout, mouseover events for the fabric object on the canvas
     * @param {Fabric.Object} target the target where the target from the mousemove event
     * @param {Event} e Event object fired on mousemove
     * @private
     */
    _fireOverOutEvents(e, target) {
      const _hoveredTarget = this._hoveredTarget,
        _hoveredTargets = this._hoveredTargets,
        targets = this.targets,
        length = Math.max(_hoveredTargets.length, targets.length);
      this.fireSyntheticInOutEvents('mouse', {
        e,
        target,
        oldTarget: _hoveredTarget,
        fireCanvas: true
      });
      for (let i = 0; i < length; i++) {
        this.fireSyntheticInOutEvents('mouse', {
          e,
          target: targets[i],
          oldTarget: _hoveredTargets[i]
        });
      }
      this._hoveredTarget = target;
      this._hoveredTargets = this.targets.concat();
    }

    /**
     * Manage the dragEnter, dragLeave events for the fabric objects on the canvas
     * @param {Fabric.Object} target the target where the target from the onDrag event
     * @param {Object} data Event object fired on dragover
     * @private
     */
    _fireEnterLeaveEvents(target, data) {
      const draggedoverTarget = this._draggedoverTarget,
        _hoveredTargets = this._hoveredTargets,
        targets = this.targets,
        length = Math.max(_hoveredTargets.length, targets.length);
      this.fireSyntheticInOutEvents('drag', _objectSpread2(_objectSpread2({}, data), {}, {
        target,
        oldTarget: draggedoverTarget,
        fireCanvas: true
      }));
      for (let i = 0; i < length; i++) {
        this.fireSyntheticInOutEvents('drag', _objectSpread2(_objectSpread2({}, data), {}, {
          target: targets[i],
          oldTarget: _hoveredTargets[i]
        }));
      }
      this._draggedoverTarget = target;
    }

    /**
     * Manage the synthetic in/out events for the fabric objects on the canvas
     * @param {Fabric.Object} target the target where the target from the supported events
     * @param {Object} data Event object fired
     * @param {Object} config configuration for the function to work
     * @param {String} config.targetName property on the canvas where the old target is stored
     * @param {String} [config.canvasEvtOut] name of the event to fire at canvas level for out
     * @param {String} config.evtOut name of the event to fire for out
     * @param {String} [config.canvasEvtIn] name of the event to fire at canvas level for in
     * @param {String} config.evtIn name of the event to fire for in
     * @private
     */
    fireSyntheticInOutEvents(type, _ref) {
      let {
          target,
          oldTarget,
          fireCanvas,
          e
        } = _ref,
        data = _objectWithoutProperties(_ref, _excluded$9);
      const {
        targetIn,
        targetOut,
        canvasIn,
        canvasOut
      } = syntheticEventConfig[type];
      const targetChanged = oldTarget !== target;
      if (oldTarget && targetChanged) {
        const outOpt = _objectSpread2(_objectSpread2({}, data), {}, {
          e,
          target: oldTarget,
          nextTarget: target
        }, getEventPoints(this, e));
        fireCanvas && this.fire(canvasOut, outOpt);
        oldTarget.fire(targetOut, outOpt);
      }
      if (target && targetChanged) {
        const inOpt = _objectSpread2(_objectSpread2({}, data), {}, {
          e,
          target,
          previousTarget: oldTarget
        }, getEventPoints(this, e));
        fireCanvas && this.fire(canvasIn, inOpt);
        target.fire(targetIn, inOpt);
      }
    }

    /**
     * Method that defines actions when an Event Mouse Wheel
     * @param {Event} e Event object fired on mouseup
     */
    __onMouseWheel(e) {
      this._cacheTransformEventData(e);
      this._handleEvent(e, 'wheel');
      this._resetTransformEventData();
    }

    /**
     * @private
     * @param {Event} e Event fired on mousemove
     */
    _transformObject(e) {
      const scenePoint = this.getScenePoint(e),
        transform = this._currentTransform,
        target = transform.target,
        //  transform pointer to target's containing coordinate plane
        //  both pointer and object should agree on every point
        localPointer = target.group ? sendPointToPlane(scenePoint, undefined, target.group.calcTransformMatrix()) : scenePoint;
      transform.shiftKey = e.shiftKey;
      transform.altKey = !!this.centeredKey && e[this.centeredKey];
      this._performTransformAction(e, transform, localPointer);
      transform.actionPerformed && this.requestRenderAll();
    }

    /**
     * @private
     */
    _performTransformAction(e, transform, pointer) {
      const {
        action,
        actionHandler,
        target
      } = transform;
      const actionPerformed = !!actionHandler && actionHandler(e, transform, pointer.x, pointer.y);
      actionPerformed && target.setCoords();

      // this object could be created from the function in the control handlers
      if (action === 'drag' && actionPerformed) {
        transform.target.isMoving = true;
        this.setCursor(transform.target.moveCursor || this.moveCursor);
      }
      transform.actionPerformed = transform.actionPerformed || actionPerformed;
    }

    /**
     * Sets the cursor depending on where the canvas is being hovered.
     * Note: very buggy in Opera
     * @param {Event} e Event object
     * @param {Object} target Object that the mouse is hovering, if so.
     */
    _setCursorFromEvent(e, target) {
      if (!target) {
        this.setCursor(this.defaultCursor);
        return;
      }
      let hoverCursor = target.hoverCursor || this.hoverCursor;
      const activeSelection = isActiveSelection(this._activeObject) ? this._activeObject : null,
        // only show proper corner when group selection is not active
        corner = (!activeSelection || target.group !== activeSelection) &&
        // here we call findTargetCorner always with undefined for the touch parameter.
        // we assume that if you are using a cursor you do not need to interact with
        // the bigger touch area.
        target.findControl(this.getViewportPoint(e));
      if (!corner) {
        if (target.subTargetCheck) {
          // hoverCursor should come from top-most subTarget,
          // so we walk the array backwards
          this.targets.concat().reverse().map(_target => {
            hoverCursor = _target.hoverCursor || hoverCursor;
          });
        }
        this.setCursor(hoverCursor);
      } else {
        const control = corner.control;
        this.setCursor(control.cursorStyleHandler(e, control, target));
      }
    }

    /**
     * ## Handles multiple selection
     * - toggles `target` selection (selects/deselects `target` if it isn't/is selected respectively)
     * - sets the active object in case it is not set or in case there is a single active object left under active selection.
     * ---
     * - If the active object is the active selection we add/remove `target` from it
     * - If not, add the active object and `target` to the active selection and make it the active object.
     * @private
     * @param {TPointerEvent} e Event object
     * @param {FabricObject} target target of event to select/deselect
     * @returns true if grouping occurred
     */
    handleMultiSelection(e, target) {
      const activeObject = this._activeObject;
      const isAS = isActiveSelection(activeObject);
      if (
      // check if an active object exists on canvas and if the user is pressing the `selectionKey` while canvas supports multi selection.
      !!activeObject && this._isSelectionKeyPressed(e) && this.selection &&
      // on top of that the user also has to hit a target that is selectable.
      !!target && target.selectable && (
      // group target and active object only if they are different objects
      // else we try to find a subtarget of `ActiveSelection`
      activeObject !== target || isAS) && (
      //  make sure `activeObject` and `target` aren't ancestors of each other in case `activeObject` is not `ActiveSelection`
      // if it is then we want to remove `target` from it
      isAS || !target.isDescendantOf(activeObject) && !activeObject.isDescendantOf(target)) &&
      //  target accepts selection
      !target.onSelect({
        e
      }) &&
      // make sure we are not on top of a control
      !activeObject.getActiveControl()) {
        if (isAS) {
          const prevActiveObjects = activeObject.getObjects();
          if (target === activeObject) {
            const pointer = this.getViewportPoint(e);
            target =
            // first search active objects for a target to remove
            this.searchPossibleTargets(prevActiveObjects, pointer) ||
            //  if not found, search under active selection for a target to add
            // `prevActiveObjects` will be searched but we already know they will not be found
            this.searchPossibleTargets(this._objects, pointer);
            // if nothing is found bail out
            if (!target || !target.selectable) {
              return false;
            }
          }
          if (target.group === activeObject) {
            // `target` is part of active selection => remove it
            activeObject.remove(target);
            this._hoveredTarget = target;
            this._hoveredTargets = [...this.targets];
            // if after removing an object we are left with one only...
            if (activeObject.size() === 1) {
              // activate last remaining object
              // deselecting the active selection will remove the remaining object from it
              this._setActiveObject(activeObject.item(0), e);
            }
          } else {
            // `target` isn't part of active selection => add it
            activeObject.multiSelectAdd(target);
            this._hoveredTarget = activeObject;
            this._hoveredTargets = [...this.targets];
          }
          this._fireSelectionEvents(prevActiveObjects, e);
        } else {
          activeObject.isEditing && activeObject.exitEditing();
          // add the active object and the target to the active selection and set it as the active object
          const klass = classRegistry.getClass('ActiveSelection');
          const newActiveSelection = new klass([], {
            /**
             * it is crucial to pass the canvas ref before calling {@link ActiveSelection#multiSelectAdd}
             * since it uses {@link FabricObject#isInFrontOf} which relies on the canvas ref
             */
            canvas: this
          });
          newActiveSelection.multiSelectAdd(activeObject, target);
          this._hoveredTarget = newActiveSelection;
          // ISSUE 4115: should we consider subTargets here?
          // this._hoveredTargets = [];
          // this._hoveredTargets = this.targets.concat();
          this._setActiveObject(newActiveSelection, e);
          this._fireSelectionEvents([activeObject], e);
        }
        return true;
      }
      return false;
    }

    /**
     * ## Handles selection
     * - selects objects that are contained in (and possibly intersecting) the selection bounding box
     * - sets the active object
     * ---
     * runs on mouse up after a mouse move
     */
    handleSelection(e) {
      if (!this.selection || !this._groupSelector) {
        return false;
      }
      const {
          x,
          y,
          deltaX,
          deltaY
        } = this._groupSelector,
        point1 = new Point(x, y),
        point2 = point1.add(new Point(deltaX, deltaY)),
        tl = point1.min(point2),
        br = point1.max(point2),
        size = br.subtract(tl);
      const collectedObjects = this.collectObjects({
        left: tl.x,
        top: tl.y,
        width: size.x,
        height: size.y
      }, {
        includeIntersecting: !this.selectionFullyContained
      });
      const objects =
      // though this method runs only after mouse move the pointer could do a mouse up on the same position as mouse down
      // should it be handled as is?
      point1.eq(point2) ? collectedObjects[0] ? [collectedObjects[0]] : [] : collectedObjects.length > 1 ? collectedObjects.filter(object => !object.onSelect({
        e
      })).reverse() :
      // `setActiveObject` will call `onSelect(collectedObjects[0])` in this case
      collectedObjects;

      // set active object
      if (objects.length === 1) {
        // set as active object
        this.setActiveObject(objects[0], e);
      } else if (objects.length > 1) {
        // add to active selection and make it the active object
        const klass = classRegistry.getClass('ActiveSelection');
        this.setActiveObject(new klass(objects, {
          canvas: this
        }), e);
      }

      // cleanup
      this._groupSelector = null;
      return true;
    }

    /**
     * @override clear {@link textEditingManager}
     */
    clear() {
      this.textEditingManager.clear();
      super.clear();
    }

    /**
     * @override clear {@link textEditingManager}
     */
    destroy() {
      this.removeListeners();
      this.textEditingManager.dispose();
      super.destroy();
    }
  }

  const linearDefaultCoords = {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0
  };
  const radialDefaultCoords = _objectSpread2(_objectSpread2({}, linearDefaultCoords), {}, {
    r1: 0,
    r2: 0
  });

  /**
   *
   * @param value value to check if NaN
   * @param [valueIfNaN]
   * @returns `fallback` is `value is NaN
   */
  const ifNaN = (value, valueIfNaN) => {
    return isNaN(value) && typeof valueIfNaN === 'number' ? valueIfNaN : value;
  };

  const RE_PERCENT = /^(\d+\.\d+)%|(\d+)%$/;
  function isPercent(value) {
    return value && RE_PERCENT.test(value);
  }

  /**
   *
   * @param value
   * @param valueIfNaN
   * @returns ∈ [0, 1]
   */
  function parsePercent(value, valueIfNaN) {
    const parsed = typeof value === 'number' ? value : typeof value === 'string' ? parseFloat(value) / (isPercent(value) ? 100 : 1) : NaN;
    return capValue(0, ifNaN(parsed, valueIfNaN), 1);
  }

  const RE_KEY_VALUE_PAIRS = /\s*;\s*/;
  const RE_KEY_VALUE = /\s*:\s*/;
  function parseColorStop(el, multiplier) {
    let colorValue, opacity;
    const style = el.getAttribute('style');
    if (style) {
      const keyValuePairs = style.split(RE_KEY_VALUE_PAIRS);
      if (keyValuePairs[keyValuePairs.length - 1] === '') {
        keyValuePairs.pop();
      }
      for (let i = keyValuePairs.length; i--;) {
        const [key, value] = keyValuePairs[i].split(RE_KEY_VALUE).map(s => s.trim());
        if (key === 'stop-color') {
          colorValue = value;
        } else if (key === 'stop-opacity') {
          opacity = value;
        }
      }
    }
    const color = new Color(colorValue || el.getAttribute('stop-color') || 'rgb(0,0,0)');
    return {
      offset: parsePercent(el.getAttribute('offset'), 0),
      color: color.toRgb(),
      opacity: ifNaN(parseFloat(opacity || el.getAttribute('stop-opacity') || ''), 1) * color.getAlpha() * multiplier
    };
  }
  function parseColorStops(el, opacityAttr) {
    const colorStops = [],
      colorStopEls = el.getElementsByTagName('stop'),
      multiplier = parsePercent(opacityAttr, 1);
    for (let i = colorStopEls.length; i--;) {
      colorStops.push(parseColorStop(colorStopEls[i], multiplier));
    }
    return colorStops;
  }

  function parseType(el) {
    return el.nodeName === 'linearGradient' || el.nodeName === 'LINEARGRADIENT' ? 'linear' : 'radial';
  }
  function parseGradientUnits(el) {
    return el.getAttribute('gradientUnits') === 'userSpaceOnUse' ? 'pixels' : 'percentage';
  }

  function convertPercentUnitsToValues(valuesToConvert, _ref) {
    let {
      width,
      height,
      gradientUnits
    } = _ref;
    let finalValue;
    return Object.keys(valuesToConvert).reduce((acc, prop) => {
      const propValue = valuesToConvert[prop];
      if (propValue === 'Infinity') {
        finalValue = 1;
      } else if (propValue === '-Infinity') {
        finalValue = 0;
      } else {
        finalValue = typeof propValue === 'string' ? parseFloat(propValue) : propValue;
        if (typeof propValue === 'string' && isPercent(propValue)) {
          finalValue *= 0.01;
          if (gradientUnits === 'pixels') {
            // then we need to fix those percentages here in svg parsing
            if (prop === 'x1' || prop === 'x2' || prop === 'r2') {
              finalValue *= width;
            }
            if (prop === 'y1' || prop === 'y2') {
              finalValue *= height;
            }
          }
        }
      }
      acc[prop] = finalValue;
      return acc;
    }, {});
  }
  function getValue(el, key) {
    return el.getAttribute(key);
  }
  function parseLinearCoords(el) {
    return {
      x1: getValue(el, 'x1') || 0,
      y1: getValue(el, 'y1') || 0,
      x2: getValue(el, 'x2') || '100%',
      y2: getValue(el, 'y2') || 0
    };
  }
  function parseRadialCoords(el) {
    return {
      x1: getValue(el, 'fx') || getValue(el, 'cx') || '50%',
      y1: getValue(el, 'fy') || getValue(el, 'cy') || '50%',
      r1: 0,
      x2: getValue(el, 'cx') || '50%',
      y2: getValue(el, 'cy') || '50%',
      r2: getValue(el, 'r') || '50%'
    };
  }
  function parseCoords(el, size) {
    return convertPercentUnitsToValues(parseType(el) === 'linear' ? parseLinearCoords(el) : parseRadialCoords(el), _objectSpread2(_objectSpread2({}, size), {}, {
      gradientUnits: parseGradientUnits(el)
    }));
  }

  /**
   * Gradient class
   * @class Gradient
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#gradients}
   */
  class Gradient {
    constructor(options) {
      const {
        type = 'linear',
        gradientUnits = 'pixels',
        coords = {},
        colorStops = [],
        offsetX = 0,
        offsetY = 0,
        gradientTransform,
        id
      } = options || {};
      Object.assign(this, {
        type,
        gradientUnits,
        coords: _objectSpread2(_objectSpread2({}, type === 'radial' ? radialDefaultCoords : linearDefaultCoords), coords),
        colorStops,
        offsetX,
        offsetY,
        gradientTransform,
        id: id ? "".concat(id, "_").concat(uid()) : uid()
      });
    }

    /**
     * Adds another colorStop
     * @param {Record<string, string>} colorStop Object with offset and color
     * @return {Gradient} thisArg
     */
    addColorStop(colorStops) {
      for (const position in colorStops) {
        const color = new Color(colorStops[position]);
        this.colorStops.push({
          offset: parseFloat(position),
          color: color.toRgb(),
          opacity: color.getAlpha()
        });
      }
      return this;
    }

    /**
     * Returns object representation of a gradient
     * @param {string[]} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {object}
     */
    toObject(propertiesToInclude) {
      return _objectSpread2(_objectSpread2({}, pick(this, propertiesToInclude)), {}, {
        type: this.type,
        coords: _objectSpread2({}, this.coords),
        colorStops: this.colorStops.map(colorStop => _objectSpread2({}, colorStop)),
        offsetX: this.offsetX,
        offsetY: this.offsetY,
        gradientUnits: this.gradientUnits,
        gradientTransform: this.gradientTransform ? [...this.gradientTransform] : undefined
      });
    }

    /* _TO_SVG_START_ */
    /**
     * Returns SVG representation of an gradient
     * @param {FabricObject} object Object to create a gradient for
     * @return {String} SVG representation of an gradient (linear/radial)
     */
    toSVG(object) {
      let {
        additionalTransform: preTransform
      } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      const markup = [],
        transform = this.gradientTransform ? this.gradientTransform.concat() : iMatrix.concat(),
        gradientUnits = this.gradientUnits === 'pixels' ? 'userSpaceOnUse' : 'objectBoundingBox';
      // colorStops must be sorted ascending, and guarded against deep mutations
      const colorStops = this.colorStops.map(colorStop => _objectSpread2({}, colorStop)).sort((a, b) => {
        return a.offset - b.offset;
      });
      let offsetX = -this.offsetX,
        offsetY = -this.offsetY;
      if (gradientUnits === 'objectBoundingBox') {
        offsetX /= object.width;
        offsetY /= object.height;
      } else {
        offsetX += object.width / 2;
        offsetY += object.height / 2;
      }
      // todo what about polygon/polyline?
      if (isPath(object) && this.gradientUnits !== 'percentage') {
        offsetX -= object.pathOffset.x;
        offsetY -= object.pathOffset.y;
      }
      transform[4] -= offsetX;
      transform[5] -= offsetY;
      const commonAttributes = ["id=\"SVGID_".concat(this.id, "\""), "gradientUnits=\"".concat(gradientUnits, "\""), "gradientTransform=\"".concat(preTransform ? preTransform + ' ' : '').concat(matrixToSVG(transform), "\""), ''].join(' ');
      if (this.type === 'linear') {
        const {
          x1,
          y1,
          x2,
          y2
        } = this.coords;
        markup.push('<linearGradient ', commonAttributes, ' x1="', x1, '" y1="', y1, '" x2="', x2, '" y2="', y2, '">\n');
      } else if (this.type === 'radial') {
        const {
          x1,
          y1,
          x2,
          y2,
          r1,
          r2
        } = this.coords;
        const needsSwap = r1 > r2;
        // svg radial gradient has just 1 radius. the biggest.
        markup.push('<radialGradient ', commonAttributes, ' cx="', needsSwap ? x1 : x2, '" cy="', needsSwap ? y1 : y2, '" r="', needsSwap ? r1 : r2, '" fx="', needsSwap ? x2 : x1, '" fy="', needsSwap ? y2 : y1, '">\n');
        if (needsSwap) {
          // svg goes from internal to external radius. if radius are inverted, swap color stops.
          colorStops.reverse(); //  mutates array
          colorStops.forEach(colorStop => {
            colorStop.offset = 1 - colorStop.offset;
          });
        }
        const minRadius = Math.min(r1, r2);
        if (minRadius > 0) {
          // i have to shift all colorStops and add new one in 0.
          const maxRadius = Math.max(r1, r2),
            percentageShift = minRadius / maxRadius;
          colorStops.forEach(colorStop => {
            colorStop.offset += percentageShift * (1 - colorStop.offset);
          });
        }
      }
      colorStops.forEach(_ref => {
        let {
          color,
          offset,
          opacity
        } = _ref;
        markup.push('<stop ', 'offset="', offset * 100 + '%', '" style="stop-color:', color, typeof opacity !== 'undefined' ? ';stop-opacity: ' + opacity : ';', '"/>\n');
      });
      markup.push(this.type === 'linear' ? '</linearGradient>' : '</radialGradient>', '\n');
      return markup.join('');
    }
    /* _TO_SVG_END_ */

    /**
     * Returns an instance of CanvasGradient
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @return {CanvasGradient}
     */
    toLive(ctx) {
      const {
        x1,
        y1,
        x2,
        y2,
        r1,
        r2
      } = this.coords;
      const gradient = this.type === 'linear' ? ctx.createLinearGradient(x1, y1, x2, y2) : ctx.createRadialGradient(x1, y1, r1, x2, y2, r2);
      this.colorStops.forEach(_ref2 => {
        let {
          color,
          opacity,
          offset
        } = _ref2;
        gradient.addColorStop(offset, typeof opacity !== 'undefined' ? new Color(color).setAlpha(opacity).toRgba() : color);
      });
      return gradient;
    }
    static async fromObject(options) {
      const {
        colorStops,
        gradientTransform
      } = options;
      return new this(_objectSpread2(_objectSpread2({}, options), {}, {
        colorStops: colorStops ? colorStops.map(colorStop => _objectSpread2({}, colorStop)) : undefined,
        gradientTransform: gradientTransform ? [...gradientTransform] : undefined
      }));
    }

    /* _FROM_SVG_START_ */
    /**
     * Returns {@link Gradient} instance from an SVG element
     * @static
     * @memberOf Gradient
     * @param {SVGGradientElement} el SVG gradient element
     * @param {FabricObject} instance
     * @param {String} opacity A fill-opacity or stroke-opacity attribute to multiply to each stop's opacity.
     * @param {SVGOptions} svgOptions an object containing the size of the SVG in order to parse correctly gradients
     * that uses gradientUnits as 'userSpaceOnUse' and percentages.
     * @return {Gradient} Gradient instance
     * @see http://www.w3.org/TR/SVG/pservers.html#LinearGradientElement
     * @see http://www.w3.org/TR/SVG/pservers.html#RadialGradientElement
     *
     *  @example
     *
     *  <linearGradient id="linearGrad1">
     *    <stop offset="0%" stop-color="white"/>
     *    <stop offset="100%" stop-color="black"/>
     *  </linearGradient>
     *
     *  OR
     *
     *  <linearGradient id="linearGrad2">
     *    <stop offset="0" style="stop-color:rgb(255,255,255)"/>
     *    <stop offset="1" style="stop-color:rgb(0,0,0)"/>
     *  </linearGradient>
     *
     *  OR
     *
     *  <radialGradient id="radialGrad1">
     *    <stop offset="0%" stop-color="white" stop-opacity="1" />
     *    <stop offset="50%" stop-color="black" stop-opacity="0.5" />
     *    <stop offset="100%" stop-color="white" stop-opacity="1" />
     *  </radialGradient>
     *
     *  OR
     *
     *  <radialGradient id="radialGrad2">
     *    <stop offset="0" stop-color="rgb(255,255,255)" />
     *    <stop offset="0.5" stop-color="rgb(0,0,0)" />
     *    <stop offset="1" stop-color="rgb(255,255,255)" />
     *  </radialGradient>
     *
     */
    static fromElement(el, instance, svgOptions) {
      const gradientUnits = parseGradientUnits(el);
      const center = instance._findCenterFromElement();
      return new this(_objectSpread2({
        id: el.getAttribute('id') || undefined,
        type: parseType(el),
        coords: parseCoords(el, {
          width: svgOptions.viewBoxWidth || svgOptions.width,
          height: svgOptions.viewBoxHeight || svgOptions.height
        }),
        colorStops: parseColorStops(el, svgOptions.opacity),
        gradientUnits,
        gradientTransform: parseTransformAttribute(el.getAttribute('gradientTransform') || '')
      }, gradientUnits === 'pixels' ? {
        offsetX: instance.width / 2 - center.x,
        offsetY: instance.height / 2 - center.y
      } : {
        offsetX: 0,
        offsetY: 0
      }));
    }
    /* _FROM_SVG_END_ */
  }
  /**
   * Horizontal offset for aligning gradients coming from SVG when outside pathgroups
   * @type Number
   * @default 0
   */
  /**
   * Vertical offset for aligning gradients coming from SVG when outside pathgroups
   * @type Number
   * @default 0
   */
  /**
   * A transform matrix to apply to the gradient before painting.
   * Imported from svg gradients, is not applied with the current transform in the center.
   * Before this transform is applied, the origin point is at the top left corner of the object
   * plus the addition of offsetY and offsetX.
   * @type Number[]
   * @default null
   */
  /**
   * coordinates units for coords.
   * If `pixels`, the number of coords are in the same unit of width / height.
   * If set as `percentage` the coords are still a number, but 1 means 100% of width
   * for the X and 100% of the height for the y. It can be bigger than 1 and negative.
   * allowed values pixels or percentage.
   * @type GradientUnits
   * @default 'pixels'
   */
  /**
   * Gradient type linear or radial
   * @type GradientType
   * @default 'linear'
   */
  /**
   * Defines how the gradient is located in space and spread
   * @type GradientCoords
   */
  /**
   * Defines how many colors a gradient has and how they are located on the axis
   * defined by coords
   * @type GradientCoords
   */
  /**
   * If true, this object will not be exported during the serialization of a canvas
   * @type boolean
   */
  /**
   * ID used for SVG export functionalities
   * @type number | string
   */
  _defineProperty(Gradient, "type", 'Gradient');
  classRegistry.setClass(Gradient, 'gradient');
  classRegistry.setClass(Gradient, 'linear');
  classRegistry.setClass(Gradient, 'radial');

  const _excluded$8 = ["type", "source", "patternTransform"];

  /**
   * @see {@link http://fabricjs.com/patterns demo}
   * @see {@link http://fabricjs.com/dynamic-patterns demo}
   */
  class Pattern {
    /**
     * Legacy identifier of the class. Prefer using this.constructor.type 'Pattern'
     * or utils like isPattern, or instance of to indentify a pattern in your code.
     * Will be removed in future versiones
     * @TODO add sustainable warning message
     * @type string
     * @deprecated
     */
    get type() {
      return 'pattern';
    }
    set type(value) {
      log('warn', 'Setting type has no effect', value);
    }

    /**
     * @type PatternRepeat
     * @defaults
     */

    /**
     * transform matrix to change the pattern, imported from svgs.
     * @todo verify if using the identity matrix as default makes the rest of the code more easy
     * @type Array
     * @default
     */

    /**
     * The actual pixel source of the pattern
     */

    /**
     * If true, this object will not be exported during the serialization of a canvas
     * @type boolean
     */

    /**
     * ID used for SVG export functionalities
     * @type number
     */

    /**
     * Constructor
     * @param {Object} [options] Options object
     * @param {option.source} [source] the pattern source, eventually empty or a drawable
     */
    constructor(options) {
      _defineProperty(this, "repeat", 'repeat');
      /**
       * Pattern horizontal offset from object's left/top corner
       * @type Number
       * @default
       */
      _defineProperty(this, "offsetX", 0);
      /**
       * Pattern vertical offset from object's left/top corner
       * @type Number
       * @default
       */
      _defineProperty(this, "offsetY", 0);
      /**
       * @type TCrossOrigin
       * @default
       */
      _defineProperty(this, "crossOrigin", '');
      this.id = uid();
      Object.assign(this, options);
    }

    /**
     * @returns true if {@link source} is an <img> element
     */
    isImageSource() {
      return !!this.source && typeof this.source.src === 'string';
    }

    /**
     * @returns true if {@link source} is a <canvas> element
     */
    isCanvasSource() {
      return !!this.source && !!this.source.toDataURL;
    }
    sourceToString() {
      return this.isImageSource() ? this.source.src : this.isCanvasSource() ? this.source.toDataURL() : '';
    }

    /**
     * Returns an instance of CanvasPattern
     * @param {CanvasRenderingContext2D} ctx Context to create pattern
     * @return {CanvasPattern}
     */
    toLive(ctx) {
      if (
      // if the image failed to load, return, and allow rest to continue loading
      !this.source ||
      // if an image
      this.isImageSource() && (!this.source.complete || this.source.naturalWidth === 0 || this.source.naturalHeight === 0)) {
        return null;
      }
      return ctx.createPattern(this.source, this.repeat);
    }

    /**
     * Returns object representation of a pattern
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {object} Object representation of a pattern instance
     */
    toObject() {
      let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      const {
        repeat,
        crossOrigin
      } = this;
      return _objectSpread2(_objectSpread2({}, pick(this, propertiesToInclude)), {}, {
        type: 'pattern',
        source: this.sourceToString(),
        repeat,
        crossOrigin,
        offsetX: toFixed(this.offsetX, config.NUM_FRACTION_DIGITS),
        offsetY: toFixed(this.offsetY, config.NUM_FRACTION_DIGITS),
        patternTransform: this.patternTransform ? [...this.patternTransform] : null
      });
    }

    /* _TO_SVG_START_ */
    /**
     * Returns SVG representation of a pattern
     */
    toSVG(_ref) {
      let {
        width,
        height
      } = _ref;
      const {
          source: patternSource,
          repeat,
          id
        } = this,
        patternOffsetX = ifNaN(this.offsetX / width, 0),
        patternOffsetY = ifNaN(this.offsetY / height, 0),
        patternWidth = repeat === 'repeat-y' || repeat === 'no-repeat' ? 1 + Math.abs(patternOffsetX || 0) : ifNaN(patternSource.width / width, 0),
        patternHeight = repeat === 'repeat-x' || repeat === 'no-repeat' ? 1 + Math.abs(patternOffsetY || 0) : ifNaN(patternSource.height / height, 0);
      return ["<pattern id=\"SVGID_".concat(id, "\" x=\"").concat(patternOffsetX, "\" y=\"").concat(patternOffsetY, "\" width=\"").concat(patternWidth, "\" height=\"").concat(patternHeight, "\">"), "<image x=\"0\" y=\"0\" width=\"".concat(patternSource.width, "\" height=\"").concat(patternSource.height, "\" xlink:href=\"").concat(this.sourceToString(), "\"></image>"), "</pattern>", ''].join('\n');
    }
    /* _TO_SVG_END_ */

    static async fromObject(_ref2, options) {
      let {
          type,
          source,
          patternTransform
        } = _ref2,
        otherOptions = _objectWithoutProperties(_ref2, _excluded$8);
      const img = await loadImage(source, _objectSpread2(_objectSpread2({}, options), {}, {
        crossOrigin: otherOptions.crossOrigin
      }));
      return new this(_objectSpread2(_objectSpread2({}, otherOptions), {}, {
        patternTransform: patternTransform && patternTransform.slice(0),
        source: img
      }));
    }
  }
  _defineProperty(Pattern, "type", 'Pattern');
  classRegistry.setClass(Pattern);
  // kept for compatibility reason
  classRegistry.setClass(Pattern, 'pattern');

  /**
   * @see {@link http://fabricjs.com/freedrawing|Freedrawing demo}
   */
  class BaseBrush {
    /**
     * @todo add type
     */

    constructor(canvas) {
      /**
       * Color of a brush
       * @type String
       * @default
       */
      _defineProperty(this, "color", 'rgb(0, 0, 0)');
      /**
       * Width of a brush, has to be a Number, no string literals
       * @type Number
       * @default
       */
      _defineProperty(this, "width", 1);
      /**
       * Shadow object representing shadow of this shape.
       * <b>Backwards incompatibility note:</b> This property replaces "shadowColor" (String), "shadowOffsetX" (Number),
       * "shadowOffsetY" (Number) and "shadowBlur" (Number) since v1.2.12
       * @type Shadow
       * @default
       */
      _defineProperty(this, "shadow", null);
      /**
       * Line endings style of a brush (one of "butt", "round", "square")
       * @type String
       * @default
       */
      _defineProperty(this, "strokeLineCap", 'round');
      /**
       * Corner style of a brush (one of "bevel", "round", "miter")
       * @type String
       * @default
       */
      _defineProperty(this, "strokeLineJoin", 'round');
      /**
       * Maximum miter length (used for strokeLineJoin = "miter") of a brush's
       * @type Number
       * @default
       */
      _defineProperty(this, "strokeMiterLimit", 10);
      /**
       * Stroke Dash Array.
       * @type Array
       * @default
       */
      _defineProperty(this, "strokeDashArray", null);
      /**
       * When `true`, the free drawing is limited to the whiteboard size. Default to false.
       * @type Boolean
       * @default false
       */
      _defineProperty(this, "limitedToCanvasSize", false);
      this.canvas = canvas;
    }

    /**
     * @returns true if brush should continue blocking interaction
     */

    /**
     * Sets brush styles
     * @private
     * @param {CanvasRenderingContext2D} ctx
     */
    _setBrushStyles(ctx) {
      ctx.strokeStyle = this.color;
      ctx.lineWidth = this.width;
      ctx.lineCap = this.strokeLineCap;
      ctx.miterLimit = this.strokeMiterLimit;
      ctx.lineJoin = this.strokeLineJoin;
      ctx.setLineDash(this.strokeDashArray || []);
    }

    /**
     * Sets the transformation on given context
     * @param {CanvasRenderingContext2D} ctx context to render on
     * @private
     */
    _saveAndTransform(ctx) {
      const v = this.canvas.viewportTransform;
      ctx.save();
      ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
    }
    needsFullRender() {
      const color = new Color(this.color);
      return color.getAlpha() < 1 || !!this.shadow;
    }

    /**
     * Sets brush shadow styles
     * @private
     */
    _setShadow() {
      if (!this.shadow || !this.canvas) {
        return;
      }
      const canvas = this.canvas,
        shadow = this.shadow,
        ctx = canvas.contextTop,
        zoom = canvas.getZoom() * canvas.getRetinaScaling();
      ctx.shadowColor = shadow.color;
      ctx.shadowBlur = shadow.blur * zoom;
      ctx.shadowOffsetX = shadow.offsetX * zoom;
      ctx.shadowOffsetY = shadow.offsetY * zoom;
    }

    /**
     * Removes brush shadow styles
     * @private
     */
    _resetShadow() {
      const ctx = this.canvas.contextTop;
      ctx.shadowColor = '';
      ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
    }

    /**
     * Check is pointer is outside canvas boundaries
     * @param {Object} pointer
     * @private
     */
    _isOutSideCanvas(pointer) {
      return pointer.x < 0 || pointer.x > this.canvas.getWidth() || pointer.y < 0 || pointer.y > this.canvas.getHeight();
    }
  }

  const _excluded$7 = ["path", "left", "top"],
    _excluded2$2 = ["d"];
  class Path extends FabricObject {
    /**
     * Constructor
     * @param {TComplexPathData} path Path data (sequence of coordinates and corresponding "command" tokens)
     * @param {Partial<PathProps>} [options] Options object
     * @return {Path} thisArg
     */
    constructor(path) {
      let _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        {
          path: _,
          left,
          top
        } = _ref,
        options = _objectWithoutProperties(_ref, _excluded$7);
      super();
      Object.assign(this, Path.ownDefaults);
      this.setOptions(options);
      this._setPath(path || [], true);
      typeof left === 'number' && this.set(LEFT, left);
      typeof top === 'number' && this.set(TOP, top);
    }

    /**
     * @private
     * @param {TComplexPathData | string} path Path data (sequence of coordinates and corresponding "command" tokens)
     * @param {boolean} [adjustPosition] pass true to reposition the object according to the bounding box
     * @returns {Point} top left position of the bounding box, useful for complementary positioning
     */
    _setPath(path, adjustPosition) {
      this.path = makePathSimpler(Array.isArray(path) ? path : parsePath(path));
      this.setBoundingBox(adjustPosition);
    }

    /**
     * This function is an helper for svg import. it returns the center of the object in the svg
     * untransformed coordinates, by look at the polyline/polygon points.
     * @private
     * @return {Point} center point from element coordinates
     */
    _findCenterFromElement() {
      const bbox = this._calcBoundsFromPath();
      return new Point(bbox.left + bbox.width / 2, bbox.top + bbox.height / 2);
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx context to render path on
     */
    _renderPathCommands(ctx) {
      const l = -this.pathOffset.x,
        t = -this.pathOffset.y;
      ctx.beginPath();
      for (const command of this.path) {
        switch (command[0] // first letter
        ) {
          case 'L':
            // lineto, absolute
            ctx.lineTo(command[1] + l, command[2] + t);
            break;
          case 'M':
            // moveTo, absolute
            ctx.moveTo(command[1] + l, command[2] + t);
            break;
          case 'C':
            // bezierCurveTo, absolute
            ctx.bezierCurveTo(command[1] + l, command[2] + t, command[3] + l, command[4] + t, command[5] + l, command[6] + t);
            break;
          case 'Q':
            // quadraticCurveTo, absolute
            ctx.quadraticCurveTo(command[1] + l, command[2] + t, command[3] + l, command[4] + t);
            break;
          case 'Z':
            ctx.closePath();
            break;
        }
      }
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx context to render path on
     */
    _render(ctx) {
      this._renderPathCommands(ctx);
      this._renderPaintInOrder(ctx);
    }

    /**
     * Returns string representation of an instance
     * @return {string} string representation of an instance
     */
    toString() {
      return "#<Path (".concat(this.complexity(), "): { \"top\": ").concat(this.top, ", \"left\": ").concat(this.left, " }>");
    }

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject() {
      let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return _objectSpread2(_objectSpread2({}, super.toObject(propertiesToInclude)), {}, {
        path: this.path.map(pathCmd => pathCmd.slice())
      });
    }

    /**
     * Returns dataless object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toDatalessObject() {
      let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      const o = this.toObject(propertiesToInclude);
      if (this.sourcePath) {
        delete o.path;
        o.sourcePath = this.sourcePath;
      }
      return o;
    }

    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG() {
      const path = joinPath(this.path, config.NUM_FRACTION_DIGITS);
      return ['<path ', 'COMMON_PARTS', "d=\"".concat(path, "\" stroke-linecap=\"round\" />\n")];
    }

    /**
     * @private
     * @return the path command's translate transform attribute
     */
    _getOffsetTransform() {
      const digits = config.NUM_FRACTION_DIGITS;
      return " translate(".concat(toFixed(-this.pathOffset.x, digits), ", ").concat(toFixed(-this.pathOffset.y, digits), ")");
    }

    /**
     * Returns svg clipPath representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {string} svg representation of an instance
     */
    toClipPathSVG(reviver) {
      const additionalTransform = this._getOffsetTransform();
      return '\t' + this._createBaseClipPathSVGMarkup(this._toSVG(), {
        reviver,
        additionalTransform: additionalTransform
      });
    }

    /**
     * Returns svg representation of an instance
     * @param {Function} [reviver] Method for further parsing of svg representation.
     * @return {string} svg representation of an instance
     */
    toSVG(reviver) {
      const additionalTransform = this._getOffsetTransform();
      return this._createBaseSVGMarkup(this._toSVG(), {
        reviver,
        additionalTransform: additionalTransform
      });
    }

    /**
     * Returns number representation of an instance complexity
     * @return {number} complexity of this instance
     */
    complexity() {
      return this.path.length;
    }
    setDimensions() {
      this.setBoundingBox();
    }
    setBoundingBox(adjustPosition) {
      const {
        width,
        height,
        pathOffset
      } = this._calcDimensions();
      this.set({
        width,
        height,
        pathOffset
      });
      // using pathOffset because it match the use case.
      // if pathOffset change here we need to use left + width/2 , top + height/2
      adjustPosition && this.setPositionByOrigin(pathOffset, CENTER, CENTER);
    }
    _calcBoundsFromPath() {
      const bounds = [];
      let subpathStartX = 0,
        subpathStartY = 0,
        x = 0,
        // current x
        y = 0; // current y

      for (const command of this.path) {
        // current instruction
        switch (command[0] // first letter
        ) {
          case 'L':
            // lineto, absolute
            x = command[1];
            y = command[2];
            bounds.push({
              x: subpathStartX,
              y: subpathStartY
            }, {
              x,
              y
            });
            break;
          case 'M':
            // moveTo, absolute
            x = command[1];
            y = command[2];
            subpathStartX = x;
            subpathStartY = y;
            break;
          case 'C':
            // bezierCurveTo, absolute
            bounds.push(...getBoundsOfCurve(x, y, command[1], command[2], command[3], command[4], command[5], command[6]));
            x = command[5];
            y = command[6];
            break;
          case 'Q':
            // quadraticCurveTo, absolute
            bounds.push(...getBoundsOfCurve(x, y, command[1], command[2], command[1], command[2], command[3], command[4]));
            x = command[3];
            y = command[4];
            break;
          case 'Z':
            x = subpathStartX;
            y = subpathStartY;
            break;
        }
      }
      return makeBoundingBoxFromPoints(bounds);
    }

    /**
     * @private
     */
    _calcDimensions() {
      const bbox = this._calcBoundsFromPath();
      return _objectSpread2(_objectSpread2({}, bbox), {}, {
        pathOffset: new Point(bbox.left + bbox.width / 2, bbox.top + bbox.height / 2)
      });
    }

    /**
     * List of attribute names to account for when parsing SVG element (used by `Path.fromElement`)
     * @static
     * @memberOf Path
     * @see http://www.w3.org/TR/SVG/paths.html#PathElement
     */

    /**
     * Creates an instance of Path from an object
     * @static
     * @memberOf Path
     * @param {Object} object
     * @returns {Promise<Path>}
     */
    static fromObject(object) {
      return this._fromObject(object, {
        extraParam: 'path'
      });
    }

    /**
     * Creates an instance of Path from an SVG <path> element
     * @static
     * @memberOf Path
     * @param {HTMLElement} element to parse
     * @param {Partial<PathProps>} [options] Options object
     */
    static async fromElement(element, options, cssRules) {
      const _parseAttributes = parseAttributes(element, this.ATTRIBUTE_NAMES, cssRules),
        {
          d
        } = _parseAttributes,
        parsedAttributes = _objectWithoutProperties(_parseAttributes, _excluded2$2);
      return new this(d, _objectSpread2(_objectSpread2(_objectSpread2({}, parsedAttributes), options), {}, {
        // we pass undefined to instruct the constructor to position the object using the bbox
        left: undefined,
        top: undefined
      }));
    }
  }
  /**
   * Array of path points
   * @type Array
   * @default
   */
  _defineProperty(Path, "type", 'Path');
  _defineProperty(Path, "cacheProperties", [...cacheProperties, 'path', 'fillRule']);
  _defineProperty(Path, "ATTRIBUTE_NAMES", [...SHARED_ATTRIBUTES, 'd']);
  classRegistry.setClass(Path);
  classRegistry.setSVGClass(Path);

  /* _FROM_SVG_START_ */

  /**
   * @private
   * @param {TSimplePathData} pathData SVG path commands
   * @returns {boolean}
   */
  function isEmptySVGPath(pathData) {
    return joinPath(pathData) === 'M 0 0 Q 0 0 0 0 L 0 0';
  }
  class PencilBrush extends BaseBrush {
    constructor(canvas) {
      super(canvas);
      /**
       * Discard points that are less than `decimate` pixel distant from each other
       * @type Number
       * @default 0.4
       */
      _defineProperty(this, "decimate", 0.4);
      /**
       * Draws a straight line between last recorded point to current pointer
       * Used for `shift` functionality
       *
       * @type boolean
       * @default false
       */
      _defineProperty(this, "drawStraightLine", false);
      /**
       * The event modifier key that makes the brush draw a straight line.
       * If `null` or 'none' or any other string that is not a modifier key the feature is disabled.
       * @type {ModifierKey | undefined | null}
       */
      _defineProperty(this, "straightLineKey", 'shiftKey');
      this._points = [];
      this._hasStraightLine = false;
    }
    needsFullRender() {
      return super.needsFullRender() || this._hasStraightLine;
    }
    static drawSegment(ctx, p1, p2) {
      const midPoint = p1.midPointFrom(p2);
      ctx.quadraticCurveTo(p1.x, p1.y, midPoint.x, midPoint.y);
      return midPoint;
    }

    /**
     * Invoked on mouse down
     * @param {Point} pointer
     */
    onMouseDown(pointer, _ref) {
      let {
        e
      } = _ref;
      if (!this.canvas._isMainEvent(e)) {
        return;
      }
      this.drawStraightLine = !!this.straightLineKey && e[this.straightLineKey];
      this._prepareForDrawing(pointer);
      // capture coordinates immediately
      // this allows to draw dots (when movement never occurs)
      this._addPoint(pointer);
      this._render();
    }

    /**
     * Invoked on mouse move
     * @param {Point} pointer
     */
    onMouseMove(pointer, _ref2) {
      let {
        e
      } = _ref2;
      if (!this.canvas._isMainEvent(e)) {
        return;
      }
      this.drawStraightLine = !!this.straightLineKey && e[this.straightLineKey];
      if (this.limitedToCanvasSize === true && this._isOutSideCanvas(pointer)) {
        return;
      }
      if (this._addPoint(pointer) && this._points.length > 1) {
        if (this.needsFullRender()) {
          // redraw curve
          // clear top canvas
          this.canvas.clearContext(this.canvas.contextTop);
          this._render();
        } else {
          const points = this._points,
            length = points.length,
            ctx = this.canvas.contextTop;
          // draw the curve update
          this._saveAndTransform(ctx);
          if (this.oldEnd) {
            ctx.beginPath();
            ctx.moveTo(this.oldEnd.x, this.oldEnd.y);
          }
          this.oldEnd = PencilBrush.drawSegment(ctx, points[length - 2], points[length - 1]);
          ctx.stroke();
          ctx.restore();
        }
      }
    }

    /**
     * Invoked on mouse up
     */
    onMouseUp(_ref3) {
      let {
        e
      } = _ref3;
      if (!this.canvas._isMainEvent(e)) {
        return true;
      }
      this.drawStraightLine = false;
      this.oldEnd = undefined;
      this._finalizeAndAddPath();
      return false;
    }

    /**
     * @private
     * @param {Point} pointer Actual mouse position related to the canvas.
     */
    _prepareForDrawing(pointer) {
      this._reset();
      this._addPoint(pointer);
      this.canvas.contextTop.moveTo(pointer.x, pointer.y);
    }

    /**
     * @private
     * @param {Point} point Point to be added to points array
     */
    _addPoint(point) {
      if (this._points.length > 1 && point.eq(this._points[this._points.length - 1])) {
        return false;
      }
      if (this.drawStraightLine && this._points.length > 1) {
        this._hasStraightLine = true;
        this._points.pop();
      }
      this._points.push(point);
      return true;
    }

    /**
     * Clear points array and set contextTop canvas style.
     * @private
     */
    _reset() {
      this._points = [];
      this._setBrushStyles(this.canvas.contextTop);
      this._setShadow();
      this._hasStraightLine = false;
    }

    /**
     * Draw a smooth path on the topCanvas using quadraticCurveTo
     * @private
     * @param {CanvasRenderingContext2D} [ctx]
     */
    _render() {
      let ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.canvas.contextTop;
      let p1 = this._points[0],
        p2 = this._points[1];
      this._saveAndTransform(ctx);
      ctx.beginPath();
      //if we only have 2 points in the path and they are the same
      //it means that the user only clicked the canvas without moving the mouse
      //then we should be drawing a dot. A path isn't drawn between two identical dots
      //that's why we set them apart a bit
      if (this._points.length === 2 && p1.x === p2.x && p1.y === p2.y) {
        const width = this.width / 1000;
        p1.x -= width;
        p2.x += width;
      }
      ctx.moveTo(p1.x, p1.y);
      for (let i = 1; i < this._points.length; i++) {
        // we pick the point between pi + 1 & pi + 2 as the
        // end point and p1 as our control point.
        PencilBrush.drawSegment(ctx, p1, p2);
        p1 = this._points[i];
        p2 = this._points[i + 1];
      }
      // Draw last line as a straight line while
      // we wait for the next point to be able to calculate
      // the bezier control point
      ctx.lineTo(p1.x, p1.y);
      ctx.stroke();
      ctx.restore();
    }

    /**
     * Converts points to SVG path
     * @param {Point[]} points Array of points
     * @return {TSimplePathData} SVG path commands
     */
    convertPointsToSVGPath(points) {
      const correction = this.width / 1000;
      return getSmoothPathFromPoints(points, correction);
    }

    /**
     * Creates a Path object to add on canvas
     * @param {TSimplePathData} pathData Path data
     * @return {Path} Path to add on canvas
     */
    createPath(pathData) {
      const path = new Path(pathData, {
        fill: null,
        stroke: this.color,
        strokeWidth: this.width,
        strokeLineCap: this.strokeLineCap,
        strokeMiterLimit: this.strokeMiterLimit,
        strokeLineJoin: this.strokeLineJoin,
        strokeDashArray: this.strokeDashArray
      });
      if (this.shadow) {
        this.shadow.affectStroke = true;
        path.shadow = new Shadow(this.shadow);
      }
      return path;
    }

    /**
     * Decimate points array with the decimate value
     */
    decimatePoints(points, distance) {
      if (points.length <= 2) {
        return points;
      }
      let lastPoint = points[0],
        cDistance;
      const zoom = this.canvas.getZoom(),
        adjustedDistance = Math.pow(distance / zoom, 2),
        l = points.length - 1,
        newPoints = [lastPoint];
      for (let i = 1; i < l - 1; i++) {
        cDistance = Math.pow(lastPoint.x - points[i].x, 2) + Math.pow(lastPoint.y - points[i].y, 2);
        if (cDistance >= adjustedDistance) {
          lastPoint = points[i];
          newPoints.push(lastPoint);
        }
      }
      // Add the last point from the original line to the end of the array.
      // This ensures decimate doesn't delete the last point on the line, and ensures the line is > 1 point.
      newPoints.push(points[l]);
      return newPoints;
    }

    /**
     * On mouseup after drawing the path on contextTop canvas
     * we use the points captured to create an new Path object
     * and add it to the canvas.
     */
    _finalizeAndAddPath() {
      const ctx = this.canvas.contextTop;
      ctx.closePath();
      if (this.decimate) {
        this._points = this.decimatePoints(this._points, this.decimate);
      }
      const pathData = this.convertPointsToSVGPath(this._points);
      if (isEmptySVGPath(pathData)) {
        // do not create 0 width/height paths, as they are
        // rendered inconsistently across browsers
        // Firefox 4, for example, renders a dot,
        // whereas Chrome 10 renders nothing
        this.canvas.requestRenderAll();
        return;
      }
      const path = this.createPath(pathData);
      this.canvas.clearContext(this.canvas.contextTop);
      this.canvas.fire('before:path:created', {
        path: path
      });
      this.canvas.add(path);
      this.canvas.requestRenderAll();
      path.setCoords();
      this._resetShadow();

      // fire event 'path' created
      this.canvas.fire('path:created', {
        path: path
      });
    }
  }

  const _excluded$6 = ["left", "top", "radius"];
  const CIRCLE_PROPS = ['radius', 'startAngle', 'endAngle', 'counterClockwise'];
  const circleDefaultValues = {
    radius: 0,
    startAngle: 0,
    endAngle: 360,
    counterClockwise: false
  };
  class Circle extends FabricObject {
    static getDefaults() {
      return _objectSpread2(_objectSpread2({}, super.getDefaults()), Circle.ownDefaults);
    }

    /**
     * Constructor
     * @param {Object} [options] Options object
     */
    constructor(options) {
      super();
      Object.assign(this, Circle.ownDefaults);
      this.setOptions(options);
    }

    /**
     * @private
     * @param {String} key
     * @param {*} value
     */
    _set(key, value) {
      super._set(key, value);
      if (key === 'radius') {
        this.setRadius(value);
      }
      return this;
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx context to render on
     */
    _render(ctx) {
      ctx.beginPath();
      ctx.arc(0, 0, this.radius, degreesToRadians(this.startAngle), degreesToRadians(this.endAngle), this.counterClockwise);
      this._renderPaintInOrder(ctx);
    }

    /**
     * Returns horizontal radius of an object (according to how an object is scaled)
     * @return {Number}
     */
    getRadiusX() {
      return this.get('radius') * this.get(SCALE_X);
    }

    /**
     * Returns vertical radius of an object (according to how an object is scaled)
     * @return {Number}
     */
    getRadiusY() {
      return this.get('radius') * this.get(SCALE_Y);
    }

    /**
     * Sets radius of an object (and updates width accordingly)
     */
    setRadius(value) {
      this.radius = value;
      this.set({
        width: value * 2,
        height: value * 2
      });
    }

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject() {
      let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return super.toObject([...CIRCLE_PROPS, ...propertiesToInclude]);
    }

    /* _TO_SVG_START_ */

    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG() {
      const angle = (this.endAngle - this.startAngle) % 360;
      if (angle === 0) {
        return ['<circle ', 'COMMON_PARTS', 'cx="0" cy="0" ', 'r="', "".concat(this.radius), '" />\n'];
      } else {
        const {
          radius
        } = this;
        const start = degreesToRadians(this.startAngle),
          end = degreesToRadians(this.endAngle),
          startX = cos(start) * radius,
          startY = sin(start) * radius,
          endX = cos(end) * radius,
          endY = sin(end) * radius,
          largeFlag = angle > 180 ? 1 : 0,
          sweepFlag = this.counterClockwise ? 0 : 1;
        return ["<path d=\"M ".concat(startX, " ").concat(startY, " A ").concat(radius, " ").concat(radius, " 0 ").concat(largeFlag, " ").concat(sweepFlag, " ").concat(endX, " ").concat(endY, "\" "), 'COMMON_PARTS', ' />\n'];
      }
    }
    /* _TO_SVG_END_ */

    /* _FROM_SVG_START_ */
    /**
     * List of attribute names to account for when parsing SVG element (used by {@link Circle.fromElement})
     * @static
     * @memberOf Circle
     * @see: http://www.w3.org/TR/SVG/shapes.html#CircleElement
     */

    /**
     * Returns {@link Circle} instance from an SVG element
     * @static
     * @memberOf Circle
     * @param {HTMLElement} element Element to parse
     * @param {Object} [options] Partial Circle object to default missing properties on the element.
     * @throws {Error} If value of `r` attribute is missing or invalid
     */
    static async fromElement(element, options, cssRules) {
      const _ref = parseAttributes(element, this.ATTRIBUTE_NAMES, cssRules),
        {
          left = 0,
          top = 0,
          radius = 0
        } = _ref,
        otherParsedAttributes = _objectWithoutProperties(_ref, _excluded$6);

      // this probably requires to be fixed for default origins not being top/left.

      return new this(_objectSpread2(_objectSpread2({}, otherParsedAttributes), {}, {
        radius,
        left: left - radius,
        top: top - radius
      }));
    }

    /* _FROM_SVG_END_ */

    /**
     * @todo how do we declare this??
     */
    static fromObject(object) {
      return super._fromObject(object);
    }
  }
  _defineProperty(Circle, "type", 'Circle');
  _defineProperty(Circle, "cacheProperties", [...cacheProperties, ...CIRCLE_PROPS]);
  _defineProperty(Circle, "ownDefaults", circleDefaultValues);
  _defineProperty(Circle, "ATTRIBUTE_NAMES", ['cx', 'cy', 'r', ...SHARED_ATTRIBUTES]);
  classRegistry.setClass(Circle);
  classRegistry.setSVGClass(Circle);

  class CircleBrush extends BaseBrush {
    constructor(canvas) {
      super(canvas);
      /**
       * Width of a brush
       * @type Number
       * @default
       */
      _defineProperty(this, "width", 10);
      this.points = [];
    }

    /**
     * Invoked inside on mouse down and mouse move
     * @param {Point} pointer
     */
    drawDot(pointer) {
      const point = this.addPoint(pointer),
        ctx = this.canvas.contextTop;
      this._saveAndTransform(ctx);
      this.dot(ctx, point);
      ctx.restore();
    }
    dot(ctx, point) {
      ctx.fillStyle = point.fill;
      ctx.beginPath();
      ctx.arc(point.x, point.y, point.radius, 0, Math.PI * 2, false);
      ctx.closePath();
      ctx.fill();
    }

    /**
     * Invoked on mouse down
     */
    onMouseDown(pointer) {
      this.points = [];
      this.canvas.clearContext(this.canvas.contextTop);
      this._setShadow();
      this.drawDot(pointer);
    }

    /**
     * Render the full state of the brush
     * @private
     */
    _render() {
      const ctx = this.canvas.contextTop,
        points = this.points;
      this._saveAndTransform(ctx);
      for (let i = 0; i < points.length; i++) {
        this.dot(ctx, points[i]);
      }
      ctx.restore();
    }

    /**
     * Invoked on mouse move
     * @param {Point} pointer
     */
    onMouseMove(pointer) {
      if (this.limitedToCanvasSize === true && this._isOutSideCanvas(pointer)) {
        return;
      }
      if (this.needsFullRender()) {
        this.canvas.clearContext(this.canvas.contextTop);
        this.addPoint(pointer);
        this._render();
      } else {
        this.drawDot(pointer);
      }
    }

    /**
     * Invoked on mouse up
     */
    onMouseUp() {
      const originalRenderOnAddRemove = this.canvas.renderOnAddRemove;
      this.canvas.renderOnAddRemove = false;
      const circles = [];
      for (let i = 0; i < this.points.length; i++) {
        const point = this.points[i],
          circle = new Circle({
            radius: point.radius,
            left: point.x,
            top: point.y,
            originX: CENTER,
            originY: CENTER,
            fill: point.fill
          });
        this.shadow && (circle.shadow = new Shadow(this.shadow));
        circles.push(circle);
      }
      const group = new Group(circles, {
        canvas: this.canvas
      });
      this.canvas.fire('before:path:created', {
        path: group
      });
      this.canvas.add(group);
      this.canvas.fire('path:created', {
        path: group
      });
      this.canvas.clearContext(this.canvas.contextTop);
      this._resetShadow();
      this.canvas.renderOnAddRemove = originalRenderOnAddRemove;
      this.canvas.requestRenderAll();
    }

    /**
     * @param {Object} pointer
     * @return {Point} Just added pointer point
     */
    addPoint(_ref) {
      let {
        x,
        y
      } = _ref;
      const pointerPoint = {
        x,
        y,
        radius: getRandomInt(Math.max(0, this.width - 20), this.width + 20) / 2,
        fill: new Color(this.color).setAlpha(getRandomInt(0, 100) / 100).toRgba()
      };
      this.points.push(pointerPoint);
      return pointerPoint;
    }
  }

  /**
   *
   * @param rects
   * @returns
   */
  function getUniqueRects(rects) {
    const uniqueRects = {};
    const uniqueRectsArray = [];
    for (let i = 0, key; i < rects.length; i++) {
      key = "".concat(rects[i].left).concat(rects[i].top);
      if (!uniqueRects[key]) {
        uniqueRects[key] = true;
        uniqueRectsArray.push(rects[i]);
      }
    }
    return uniqueRectsArray;
  }
  class SprayBrush extends BaseBrush {
    /**
     * Constructor
     * @param {Canvas} canvas
     * @return {SprayBrush} Instance of a spray brush
     */
    constructor(canvas) {
      super(canvas);
      /**
       * Width of a spray
       * @type Number
       * @default
       */
      _defineProperty(this, "width", 10);
      /**
       * Density of a spray (number of dots per chunk)
       * @type Number
       * @default
       */
      _defineProperty(this, "density", 20);
      /**
       * Width of spray dots
       * @type Number
       * @default
       */
      _defineProperty(this, "dotWidth", 1);
      /**
       * Width variance of spray dots
       * @type Number
       * @default
       */
      _defineProperty(this, "dotWidthVariance", 1);
      /**
       * Whether opacity of a dot should be random
       * @type Boolean
       * @default
       */
      _defineProperty(this, "randomOpacity", false);
      /**
       * Whether overlapping dots (rectangles) should be removed (for performance reasons)
       * @type Boolean
       * @default
       */
      _defineProperty(this, "optimizeOverlapping", true);
      this.sprayChunks = [];
      this.sprayChunk = [];
    }

    /**
     * Invoked on mouse down
     * @param {Point} pointer
     */
    onMouseDown(pointer) {
      this.sprayChunks = [];
      this.canvas.clearContext(this.canvas.contextTop);
      this._setShadow();
      this.addSprayChunk(pointer);
      this.renderChunck(this.sprayChunk);
    }

    /**
     * Invoked on mouse move
     * @param {Point} pointer
     */
    onMouseMove(pointer) {
      if (this.limitedToCanvasSize === true && this._isOutSideCanvas(pointer)) {
        return;
      }
      this.addSprayChunk(pointer);
      this.renderChunck(this.sprayChunk);
    }

    /**
     * Invoked on mouse up
     */
    onMouseUp() {
      const originalRenderOnAddRemove = this.canvas.renderOnAddRemove;
      this.canvas.renderOnAddRemove = false;
      const rects = [];
      for (let i = 0; i < this.sprayChunks.length; i++) {
        const sprayChunk = this.sprayChunks[i];
        for (let j = 0; j < sprayChunk.length; j++) {
          const chunck = sprayChunk[j];
          const rect = new Rect({
            width: chunck.width,
            height: chunck.width,
            left: chunck.x + 1,
            top: chunck.y + 1,
            originX: CENTER,
            originY: CENTER,
            fill: this.color
          });
          rects.push(rect);
        }
      }
      const group = new Group(this.optimizeOverlapping ? getUniqueRects(rects) : rects, {
        objectCaching: true,
        subTargetCheck: false,
        interactive: false
      });
      this.shadow && group.set('shadow', new Shadow(this.shadow));
      this.canvas.fire('before:path:created', {
        path: group
      });
      this.canvas.add(group);
      this.canvas.fire('path:created', {
        path: group
      });
      this.canvas.clearContext(this.canvas.contextTop);
      this._resetShadow();
      this.canvas.renderOnAddRemove = originalRenderOnAddRemove;
      this.canvas.requestRenderAll();
    }
    renderChunck(sprayChunck) {
      const ctx = this.canvas.contextTop;
      ctx.fillStyle = this.color;
      this._saveAndTransform(ctx);
      for (let i = 0; i < sprayChunck.length; i++) {
        const point = sprayChunck[i];
        ctx.globalAlpha = point.opacity;
        ctx.fillRect(point.x, point.y, point.width, point.width);
      }
      ctx.restore();
    }

    /**
     * Render all spray chunks
     */
    _render() {
      const ctx = this.canvas.contextTop;
      ctx.fillStyle = this.color;
      this._saveAndTransform(ctx);
      for (let i = 0; i < this.sprayChunks.length; i++) {
        this.renderChunck(this.sprayChunks[i]);
      }
      ctx.restore();
    }

    /**
     * @param {Point} pointer
     */
    addSprayChunk(pointer) {
      this.sprayChunk = [];
      const radius = this.width / 2;
      for (let i = 0; i < this.density; i++) {
        this.sprayChunk.push({
          x: getRandomInt(pointer.x - radius, pointer.x + radius),
          y: getRandomInt(pointer.y - radius, pointer.y + radius),
          width: this.dotWidthVariance ? getRandomInt(
          // bottom clamp width to 1
          Math.max(1, this.dotWidth - this.dotWidthVariance), this.dotWidth + this.dotWidthVariance) : this.dotWidth,
          opacity: this.randomOpacity ? getRandomInt(0, 100) / 100 : 1
        });
      }
      this.sprayChunks.push(this.sprayChunk);
    }
  }

  class PatternBrush extends PencilBrush {
    constructor(canvas) {
      super(canvas);
    }
    getPatternSrc() {
      const dotWidth = 20,
        dotDistance = 5,
        patternCanvas = createCanvasElement(),
        patternCtx = patternCanvas.getContext('2d');
      patternCanvas.width = patternCanvas.height = dotWidth + dotDistance;
      if (patternCtx) {
        patternCtx.fillStyle = this.color;
        patternCtx.beginPath();
        patternCtx.arc(dotWidth / 2, dotWidth / 2, dotWidth / 2, 0, Math.PI * 2, false);
        patternCtx.closePath();
        patternCtx.fill();
      }
      return patternCanvas;
    }

    /**
     * Creates "pattern" instance property
     * @param {CanvasRenderingContext2D} ctx
     */
    getPattern(ctx) {
      return ctx.createPattern(this.source || this.getPatternSrc(), 'repeat');
    }

    /**
     * Sets brush styles
     * @param {CanvasRenderingContext2D} ctx
     */
    _setBrushStyles(ctx) {
      super._setBrushStyles(ctx);
      const pattern = this.getPattern(ctx);
      pattern && (ctx.strokeStyle = pattern);
    }

    /**
     * Creates path
     */
    createPath(pathData) {
      const path = super.createPath(pathData),
        topLeft = path._getLeftTopCoords().scalarAdd(path.strokeWidth / 2);
      path.stroke = new Pattern({
        source: this.source || this.getPatternSrc(),
        offsetX: -topLeft.x,
        offsetY: -topLeft.y
      });
      return path;
    }
  }

  const _excluded$5 = ["x1", "y1", "x2", "y2"],
    _excluded2$1 = ["x1", "y1", "x2", "y2"];
  // @TODO this code is terrible and Line should be a special case of polyline.

  const coordProps = ['x1', 'x2', 'y1', 'y2'];
  class Line extends FabricObject {
    /**
     * Constructor
     * @param {Array} [points] Array of points
     * @param {Object} [options] Options object
     * @return {Line} thisArg
     */
    constructor() {
      let [x1, y1, x2, y2] = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [0, 0, 0, 0];
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      super();
      Object.assign(this, Line.ownDefaults);
      this.setOptions(options);
      this.x1 = x1;
      this.x2 = x2;
      this.y1 = y1;
      this.y2 = y2;
      this._setWidthHeight();
      const {
        left,
        top
      } = options;
      typeof left === 'number' && this.set(LEFT, left);
      typeof top === 'number' && this.set(TOP, top);
    }

    /**
     * @private
     * @param {Object} [options] Options
     */
    _setWidthHeight() {
      const {
        x1,
        y1,
        x2,
        y2
      } = this;
      this.width = Math.abs(x2 - x1);
      this.height = Math.abs(y2 - y1);
      const {
        left,
        top,
        width,
        height
      } = makeBoundingBoxFromPoints([{
        x: x1,
        y: y1
      }, {
        x: x2,
        y: y2
      }]);
      const position = new Point(left + width / 2, top + height / 2);
      this.setPositionByOrigin(position, CENTER, CENTER);
    }

    /**
     * @private
     * @param {String} key
     * @param {*} value
     */
    _set(key, value) {
      super._set(key, value);
      if (coordProps.includes(key)) {
        // this doesn't make sense very much, since setting x1 when top or left
        // are already set, is just going to show a strange result since the
        // line will move way more than the developer expect.
        // in fabric5 it worked only when the line didn't have extra transformations,
        // in fabric6 too. With extra transform they behave bad in different ways.
        // This needs probably a good rework or a tutorial if you have to create a dynamic line
        this._setWidthHeight();
      }
      return this;
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render(ctx) {
      ctx.beginPath();
      const p = this.calcLinePoints();
      ctx.moveTo(p.x1, p.y1);
      ctx.lineTo(p.x2, p.y2);
      ctx.lineWidth = this.strokeWidth;

      // TODO: test this
      // make sure setting "fill" changes color of a line
      // (by copying fillStyle to strokeStyle, since line is stroked, not filled)
      const origStrokeStyle = ctx.strokeStyle;
      if (isFiller(this.stroke)) {
        ctx.strokeStyle = this.stroke.toLive(ctx);
      } else {
        var _this$stroke;
        ctx.strokeStyle = (_this$stroke = this.stroke) !== null && _this$stroke !== void 0 ? _this$stroke : ctx.fillStyle;
      }
      this.stroke && this._renderStroke(ctx);
      ctx.strokeStyle = origStrokeStyle;
    }

    /**
     * This function is an helper for svg import. it returns the center of the object in the svg
     * untransformed coordinates
     * @private
     * @return {Point} center point from element coordinates
     */
    _findCenterFromElement() {
      return new Point((this.x1 + this.x2) / 2, (this.y1 + this.y2) / 2);
    }

    /**
     * Returns object representation of an instance
     * @method toObject
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject() {
      let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return _objectSpread2(_objectSpread2({}, super.toObject(propertiesToInclude)), this.calcLinePoints());
    }

    /*
     * Calculate object dimensions from its properties
     * @private
     */
    _getNonTransformedDimensions() {
      const dim = super._getNonTransformedDimensions();
      if (this.strokeLineCap === 'butt') {
        if (this.width === 0) {
          dim.y -= this.strokeWidth;
        }
        if (this.height === 0) {
          dim.x -= this.strokeWidth;
        }
      }
      return dim;
    }

    /**
     * Recalculates line points given width and height
     * Those points are simply placed around the center,
     * This is not useful outside internal render functions and svg output
     * Is not meant to be for the developer.
     * @private
     */
    calcLinePoints() {
      const {
        x1: _x1,
        x2: _x2,
        y1: _y1,
        y2: _y2,
        width,
        height
      } = this;
      const xMult = _x1 <= _x2 ? -1 : 1,
        yMult = _y1 <= _y2 ? -1 : 1,
        x1 = xMult * width / 2,
        y1 = yMult * height / 2,
        x2 = xMult * -width / 2,
        y2 = yMult * -height / 2;
      return {
        x1,
        x2,
        y1,
        y2
      };
    }

    /* _FROM_SVG_START_ */

    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG() {
      const {
        x1,
        x2,
        y1,
        y2
      } = this.calcLinePoints();
      return ['<line ', 'COMMON_PARTS', "x1=\"".concat(x1, "\" y1=\"").concat(y1, "\" x2=\"").concat(x2, "\" y2=\"").concat(y2, "\" />\n")];
    }

    /**
     * List of attribute names to account for when parsing SVG element (used by {@link Line.fromElement})
     * @static
     * @memberOf Line
     * @see http://www.w3.org/TR/SVG/shapes.html#LineElement
     */

    /**
     * Returns Line instance from an SVG element
     * @static
     * @memberOf Line
     * @param {HTMLElement} element Element to parse
     * @param {Object} [options] Options object
     * @param {Function} [callback] callback function invoked after parsing
     */
    static async fromElement(element, options, cssRules) {
      const _parseAttributes = parseAttributes(element, this.ATTRIBUTE_NAMES, cssRules),
        {
          x1 = 0,
          y1 = 0,
          x2 = 0,
          y2 = 0
        } = _parseAttributes,
        parsedAttributes = _objectWithoutProperties(_parseAttributes, _excluded$5);
      return new this([x1, y1, x2, y2], parsedAttributes);
    }

    /* _FROM_SVG_END_ */

    /**
     * Returns Line instance from an object representation
     * @static
     * @memberOf Line
     * @param {Object} object Object to create an instance from
     * @returns {Promise<Line>}
     */
    static fromObject(_ref) {
      let {
          x1,
          y1,
          x2,
          y2
        } = _ref,
        object = _objectWithoutProperties(_ref, _excluded2$1);
      return this._fromObject(_objectSpread2(_objectSpread2({}, object), {}, {
        points: [x1, y1, x2, y2]
      }), {
        extraParam: 'points'
      });
    }
  }
  /**
   * x value or first line edge
   * @type number
   * @default
   */
  /**
   * y value or first line edge
   * @type number
   * @default
   */
  /**
   * x value or second line edge
   * @type number
   * @default
   */
  /**
   * y value or second line edge
   * @type number
   * @default
   */
  _defineProperty(Line, "type", 'Line');
  _defineProperty(Line, "cacheProperties", [...cacheProperties, ...coordProps]);
  _defineProperty(Line, "ATTRIBUTE_NAMES", SHARED_ATTRIBUTES.concat(coordProps));
  classRegistry.setClass(Line);
  classRegistry.setSVGClass(Line);

  const triangleDefaultValues = {
    width: 100,
    height: 100
  };
  class Triangle extends FabricObject {
    static getDefaults() {
      return _objectSpread2(_objectSpread2({}, super.getDefaults()), Triangle.ownDefaults);
    }

    /**
     * Constructor
     * @param {Object} [options] Options object
     */
    constructor(options) {
      super();
      Object.assign(this, Triangle.ownDefaults);
      this.setOptions(options);
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render(ctx) {
      const widthBy2 = this.width / 2,
        heightBy2 = this.height / 2;
      ctx.beginPath();
      ctx.moveTo(-widthBy2, heightBy2);
      ctx.lineTo(0, -heightBy2);
      ctx.lineTo(widthBy2, heightBy2);
      ctx.closePath();
      this._renderPaintInOrder(ctx);
    }

    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG() {
      const widthBy2 = this.width / 2,
        heightBy2 = this.height / 2,
        points = "".concat(-widthBy2, " ").concat(heightBy2, ",0 ").concat(-heightBy2, ",").concat(widthBy2, " ").concat(heightBy2);
      return ['<polygon ', 'COMMON_PARTS', 'points="', points, '" />'];
    }
  }
  _defineProperty(Triangle, "type", 'Triangle');
  _defineProperty(Triangle, "ownDefaults", triangleDefaultValues);
  classRegistry.setClass(Triangle);
  classRegistry.setSVGClass(Triangle);

  const ellipseDefaultValues = {
    rx: 0,
    ry: 0
  };
  const ELLIPSE_PROPS = ['rx', 'ry'];
  class Ellipse extends FabricObject {
    static getDefaults() {
      return _objectSpread2(_objectSpread2({}, super.getDefaults()), Ellipse.ownDefaults);
    }

    /**
     * Constructor
     * @param {Object} [options] Options object
     */
    constructor(options) {
      super();
      Object.assign(this, Ellipse.ownDefaults);
      this.setOptions(options);
    }

    /**
     * @private
     * @param {String} key
     * @param {*} value
     * @return {Ellipse} thisArg
     */
    _set(key, value) {
      super._set(key, value);
      switch (key) {
        case 'rx':
          this.rx = value;
          this.set('width', value * 2);
          break;
        case 'ry':
          this.ry = value;
          this.set('height', value * 2);
          break;
      }
      return this;
    }

    /**
     * Returns horizontal radius of an object (according to how an object is scaled)
     * @return {Number}
     */
    getRx() {
      return this.get('rx') * this.get(SCALE_X);
    }

    /**
     * Returns Vertical radius of an object (according to how an object is scaled)
     * @return {Number}
     */
    getRy() {
      return this.get('ry') * this.get(SCALE_Y);
    }

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject() {
      let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return super.toObject([...ELLIPSE_PROPS, ...propertiesToInclude]);
    }

    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG() {
      return ['<ellipse ', 'COMMON_PARTS', "cx=\"0\" cy=\"0\" rx=\"".concat(this.rx, "\" ry=\"").concat(this.ry, "\" />\n")];
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx context to render on
     */
    _render(ctx) {
      ctx.beginPath();
      ctx.save();
      ctx.transform(1, 0, 0, this.ry / this.rx, 0, 0);
      ctx.arc(0, 0, this.rx, 0, twoMathPi, false);
      ctx.restore();
      this._renderPaintInOrder(ctx);
    }

    /* _FROM_SVG_START_ */

    /**
     * List of attribute names to account for when parsing SVG element (used by {@link Ellipse.fromElement})
     * @static
     * @memberOf Ellipse
     * @see http://www.w3.org/TR/SVG/shapes.html#EllipseElement
     */

    /**
     * Returns {@link Ellipse} instance from an SVG element
     * @static
     * @memberOf Ellipse
     * @param {HTMLElement} element Element to parse
     * @return {Ellipse}
     */
    static async fromElement(element, options, cssRules) {
      const parsedAttributes = parseAttributes(element, this.ATTRIBUTE_NAMES, cssRules);
      parsedAttributes.left = (parsedAttributes.left || 0) - parsedAttributes.rx;
      parsedAttributes.top = (parsedAttributes.top || 0) - parsedAttributes.ry;
      return new this(parsedAttributes);
    }

    /* _FROM_SVG_END_ */
  }
  /**
   * Horizontal radius
   * @type Number
   * @default
   */
  /**
   * Vertical radius
   * @type Number
   * @default
   */
  _defineProperty(Ellipse, "type", 'Ellipse');
  _defineProperty(Ellipse, "cacheProperties", [...cacheProperties, ...ELLIPSE_PROPS]);
  _defineProperty(Ellipse, "ownDefaults", ellipseDefaultValues);
  _defineProperty(Ellipse, "ATTRIBUTE_NAMES", [...SHARED_ATTRIBUTES, 'cx', 'cy', 'rx', 'ry']);
  classRegistry.setClass(Ellipse);
  classRegistry.setSVGClass(Ellipse);

  /**
   * Parses "points" attribute, returning an array of values
   * @static
   * @memberOf fabric
   * @param {String} points points attribute string
   * @return {Array} array of points
   */
  function parsePointsAttribute(points) {
    // points attribute is required and must not be empty
    if (!points) {
      return [];
    }

    // replace commas with whitespace and remove bookending whitespace
    const pointsSplit = points.replace(/,/g, ' ').trim().split(/\s+/);
    const parsedPoints = [];
    for (let i = 0; i < pointsSplit.length; i += 2) {
      parsedPoints.push({
        x: parseFloat(pointsSplit[i]),
        y: parseFloat(pointsSplit[i + 1])
      });
    }

    // odd number of points is an error
    // if (parsedPoints.length % 2 !== 0) {
    //   return null;
    // }
    return parsedPoints;
  }

  const _excluded$4 = ["left", "top"];
  const polylineDefaultValues = {
    /**
     * @deprecated transient option soon to be removed in favor of a different design
     */
    exactBoundingBox: false
  };
  class Polyline extends FabricObject {
    static getDefaults() {
      return _objectSpread2(_objectSpread2({}, super.getDefaults()), Polyline.ownDefaults);
    }

    /**
     * A list of properties that if changed trigger a recalculation of dimensions
     * @todo check if you really need to recalculate for all cases
     */

    /**
     * Constructor
     * @param {Array} points Array of points (where each point is an object with x and y)
     * @param {Object} [options] Options object
     * @return {Polyline} thisArg
     * @example
     * var poly = new Polyline([
     *     { x: 10, y: 10 },
     *     { x: 50, y: 30 },
     *     { x: 40, y: 70 },
     *     { x: 60, y: 50 },
     *     { x: 100, y: 150 },
     *     { x: 40, y: 100 }
     *   ], {
     *   stroke: 'red',
     *   left: 100,
     *   top: 100
     * });
     */
    constructor() {
      let points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      super();
      _defineProperty(this, "strokeDiff", void 0);
      Object.assign(this, Polyline.ownDefaults);
      this.setOptions(options);
      this.points = points;
      const {
        left,
        top
      } = options;
      this.initialized = true;
      this.setBoundingBox(true);
      typeof left === 'number' && this.set(LEFT, left);
      typeof top === 'number' && this.set(TOP, top);
    }
    isOpen() {
      return true;
    }
    _projectStrokeOnPoints(options) {
      return projectStrokeOnPoints(this.points, options, this.isOpen());
    }

    /**
     * Calculate the polygon bounding box
     * @private
     */
    _calcDimensions(options) {
      options = _objectSpread2({
        scaleX: this.scaleX,
        scaleY: this.scaleY,
        skewX: this.skewX,
        skewY: this.skewY,
        strokeLineCap: this.strokeLineCap,
        strokeLineJoin: this.strokeLineJoin,
        strokeMiterLimit: this.strokeMiterLimit,
        strokeUniform: this.strokeUniform,
        strokeWidth: this.strokeWidth
      }, options || {});
      const points = this.exactBoundingBox ? this._projectStrokeOnPoints(options).map(projection => projection.projectedPoint) : this.points;
      if (points.length === 0) {
        return {
          left: 0,
          top: 0,
          width: 0,
          height: 0,
          pathOffset: new Point(),
          strokeOffset: new Point(),
          strokeDiff: new Point()
        };
      }
      const bbox = makeBoundingBoxFromPoints(points),
        // Remove scale effect, since it's applied after
        matrix = calcDimensionsMatrix(_objectSpread2(_objectSpread2({}, options), {}, {
          scaleX: 1,
          scaleY: 1
        })),
        bboxNoStroke = makeBoundingBoxFromPoints(this.points.map(p => transformPoint(p, matrix, true))),
        scale = new Point(this.scaleX, this.scaleY);
      let offsetX = bbox.left + bbox.width / 2,
        offsetY = bbox.top + bbox.height / 2;
      if (this.exactBoundingBox) {
        offsetX = offsetX - offsetY * Math.tan(degreesToRadians(this.skewX));
        // Order of those assignments is important.
        // offsetY relies on offsetX being already changed by the line above
        offsetY = offsetY - offsetX * Math.tan(degreesToRadians(this.skewY));
      }
      return _objectSpread2(_objectSpread2({}, bbox), {}, {
        pathOffset: new Point(offsetX, offsetY),
        strokeOffset: new Point(bboxNoStroke.left, bboxNoStroke.top).subtract(new Point(bbox.left, bbox.top)).multiply(scale),
        strokeDiff: new Point(bbox.width, bbox.height).subtract(new Point(bboxNoStroke.width, bboxNoStroke.height)).multiply(scale)
      });
    }

    /**
     * This function is an helper for svg import. it returns the center of the object in the svg
     * untransformed coordinates, by look at the polyline/polygon points.
     * @private
     * @return {Point} center point from element coordinates
     */
    _findCenterFromElement() {
      const bbox = makeBoundingBoxFromPoints(this.points);
      return new Point(bbox.left + bbox.width / 2, bbox.top + bbox.height / 2);
    }
    setDimensions() {
      this.setBoundingBox();
    }
    setBoundingBox(adjustPosition) {
      const {
        left,
        top,
        width,
        height,
        pathOffset,
        strokeOffset,
        strokeDiff
      } = this._calcDimensions();
      this.set({
        width,
        height,
        pathOffset,
        strokeOffset,
        strokeDiff
      });
      adjustPosition && this.setPositionByOrigin(new Point(left + width / 2, top + height / 2), CENTER, CENTER);
    }

    /**
     * @deprecated intermidiate method to be removed, do not use
     */
    isStrokeAccountedForInDimensions() {
      return this.exactBoundingBox;
    }

    /**
     * @override stroke is taken in account in size
     */
    _getNonTransformedDimensions() {
      return this.exactBoundingBox ?
      // TODO: fix this
      new Point(this.width, this.height) : super._getNonTransformedDimensions();
    }

    /**
     * @override stroke and skewing are taken into account when projecting stroke on points,
     * therefore we don't want the default calculation to account for skewing as well.
     * Though it is possible to pass `width` and `height` in `options`, doing so is very strange, use with discretion.
     *
     * @private
     */
    _getTransformedDimensions() {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (this.exactBoundingBox) {
        let size;
        /* When `strokeUniform = true`, any changes to the properties require recalculating the `width` and `height` because
          the stroke projections are affected.
          When `strokeUniform = false`, we don't need to recalculate for scale transformations, as the effect of scale on
          projections follows a linear function (e.g. scaleX of 2 just multiply width by 2)*/
        if (Object.keys(options).some(key => this.strokeUniform || this.constructor.layoutProperties.includes(key))) {
          var _options$width, _options$height;
          const {
            width,
            height
          } = this._calcDimensions(options);
          size = new Point((_options$width = options.width) !== null && _options$width !== void 0 ? _options$width : width, (_options$height = options.height) !== null && _options$height !== void 0 ? _options$height : height);
        } else {
          var _options$width2, _options$height2;
          size = new Point((_options$width2 = options.width) !== null && _options$width2 !== void 0 ? _options$width2 : this.width, (_options$height2 = options.height) !== null && _options$height2 !== void 0 ? _options$height2 : this.height);
        }
        return size.multiply(new Point(options.scaleX || this.scaleX, options.scaleY || this.scaleY));
      } else {
        return super._getTransformedDimensions(options);
      }
    }

    /**
     * Recalculates dimensions when changing skew and scale
     * @private
     */
    _set(key, value) {
      const changed = this.initialized && this[key] !== value;
      const output = super._set(key, value);
      if (this.exactBoundingBox && changed && ((key === SCALE_X || key === SCALE_Y) && this.strokeUniform && this.constructor.layoutProperties.includes('strokeUniform') || this.constructor.layoutProperties.includes(key))) {
        this.setDimensions();
      }
      return output;
    }

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */
    toObject() {
      let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return _objectSpread2(_objectSpread2({}, super.toObject(propertiesToInclude)), {}, {
        points: this.points.map(_ref => {
          let {
            x,
            y
          } = _ref;
          return {
            x,
            y
          };
        })
      });
    }

    /**
     * Returns svg representation of an instance
     * @return {Array} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG() {
      const points = [],
        diffX = this.pathOffset.x,
        diffY = this.pathOffset.y,
        NUM_FRACTION_DIGITS = config.NUM_FRACTION_DIGITS;
      for (let i = 0, len = this.points.length; i < len; i++) {
        points.push(toFixed(this.points[i].x - diffX, NUM_FRACTION_DIGITS), ',', toFixed(this.points[i].y - diffY, NUM_FRACTION_DIGITS), ' ');
      }
      return ["<".concat(this.constructor.type.toLowerCase(), " "), 'COMMON_PARTS', "points=\"".concat(points.join(''), "\" />\n")];
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render(ctx) {
      const len = this.points.length,
        x = this.pathOffset.x,
        y = this.pathOffset.y;
      if (!len || isNaN(this.points[len - 1].y)) {
        // do not draw if no points or odd points
        // NaN comes from parseFloat of a empty string in parser
        return;
      }
      ctx.beginPath();
      ctx.moveTo(this.points[0].x - x, this.points[0].y - y);
      for (let i = 0; i < len; i++) {
        const point = this.points[i];
        ctx.lineTo(point.x - x, point.y - y);
      }
      !this.isOpen() && ctx.closePath();
      this._renderPaintInOrder(ctx);
    }

    /**
     * Returns complexity of an instance
     * @return {Number} complexity of this instance
     */
    complexity() {
      return this.points.length;
    }

    /* _FROM_SVG_START_ */

    /**
     * List of attribute names to account for when parsing SVG element (used by {@link Polyline.fromElement})
     * @static
     * @memberOf Polyline
     * @see: http://www.w3.org/TR/SVG/shapes.html#PolylineElement
     */

    /**
     * Returns Polyline instance from an SVG element
     * @static
     * @memberOf Polyline
     * @param {HTMLElement} element Element to parser
     * @param {Object} [options] Options object
     */
    static async fromElement(element, options, cssRules) {
      const points = parsePointsAttribute(element.getAttribute('points')),
        _parseAttributes = parseAttributes(element, this.ATTRIBUTE_NAMES, cssRules),
        parsedAttributes = _objectWithoutProperties(_parseAttributes, _excluded$4);
      return new this(points, _objectSpread2(_objectSpread2({}, parsedAttributes), options));
    }

    /* _FROM_SVG_END_ */

    /**
     * Returns Polyline instance from an object representation
     * @static
     * @memberOf Polyline
     * @param {Object} object Object to create an instance from
     * @returns {Promise<Polyline>}
     */
    static fromObject(object) {
      return this._fromObject(object, {
        extraParam: 'points'
      });
    }
  }
  /**
   * Points array
   * @type Array
   * @default
   */
  /**
   * WARNING: Feature in progress
   * Calculate the exact bounding box taking in account strokeWidth on acute angles
   * this will be turned to true by default on fabric 6.0
   * maybe will be left in as an optimization since calculations may be slow
   * @deprecated transient option soon to be removed in favor of a different design
   * @type Boolean
   * @default false
   */
  _defineProperty(Polyline, "ownDefaults", polylineDefaultValues);
  _defineProperty(Polyline, "type", 'Polyline');
  _defineProperty(Polyline, "layoutProperties", [SKEW_X, SKEW_Y, 'strokeLineCap', 'strokeLineJoin', 'strokeMiterLimit', 'strokeWidth', 'strokeUniform', 'points']);
  _defineProperty(Polyline, "cacheProperties", [...cacheProperties, 'points']);
  _defineProperty(Polyline, "ATTRIBUTE_NAMES", [...SHARED_ATTRIBUTES]);
  classRegistry.setClass(Polyline);
  classRegistry.setSVGClass(Polyline);

  class Polygon extends Polyline {
    isOpen() {
      return false;
    }
  }
  _defineProperty(Polygon, "ownDefaults", polylineDefaultValues);
  _defineProperty(Polygon, "type", 'Polygon');
  classRegistry.setClass(Polygon);
  classRegistry.setSVGClass(Polygon);

  class StyledText extends FabricObject {
    /**
     * Returns true if object has no styling or no styling in a line
     * @param {Number} lineIndex , lineIndex is on wrapped lines.
     * @return {Boolean}
     */
    isEmptyStyles(lineIndex) {
      if (!this.styles) {
        return true;
      }
      if (typeof lineIndex !== 'undefined' && !this.styles[lineIndex]) {
        return true;
      }
      const obj = typeof lineIndex === 'undefined' ? this.styles : {
        line: this.styles[lineIndex]
      };
      for (const p1 in obj) {
        for (const p2 in obj[p1]) {
          // eslint-disable-next-line no-unused-vars
          for (const p3 in obj[p1][p2]) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * Returns true if object has a style property or has it ina specified line
     * This function is used to detect if a text will use a particular property or not.
     * @param {String} property to check for
     * @param {Number} lineIndex to check the style on
     * @return {Boolean}
     */
    styleHas(property, lineIndex) {
      if (!this.styles) {
        return false;
      }
      if (typeof lineIndex !== 'undefined' && !this.styles[lineIndex]) {
        return false;
      }
      const obj = typeof lineIndex === 'undefined' ? this.styles : {
        0: this.styles[lineIndex]
      };
      // eslint-disable-next-line
      for (const p1 in obj) {
        // eslint-disable-next-line
        for (const p2 in obj[p1]) {
          if (typeof obj[p1][p2][property] !== 'undefined') {
            return true;
          }
        }
      }
      return false;
    }

    /**
     * Check if characters in a text have a value for a property
     * whose value matches the textbox's value for that property.  If so,
     * the character-level property is deleted.  If the character
     * has no other properties, then it is also deleted.  Finally,
     * if the line containing that character has no other characters
     * then it also is deleted.
     */
    cleanStyle(property) {
      if (!this.styles) {
        return false;
      }
      const obj = this.styles;
      let stylesCount = 0,
        letterCount,
        stylePropertyValue,
        allStyleObjectPropertiesMatch = true,
        graphemeCount = 0;
      for (const p1 in obj) {
        letterCount = 0;
        for (const p2 in obj[p1]) {
          const styleObject = obj[p1][p2] || {},
            stylePropertyHasBeenSet = styleObject[property] !== undefined;
          stylesCount++;
          if (stylePropertyHasBeenSet) {
            if (!stylePropertyValue) {
              stylePropertyValue = styleObject[property];
            } else if (styleObject[property] !== stylePropertyValue) {
              allStyleObjectPropertiesMatch = false;
            }
            if (styleObject[property] === this[property]) {
              delete styleObject[property];
            }
          } else {
            allStyleObjectPropertiesMatch = false;
          }
          if (Object.keys(styleObject).length !== 0) {
            letterCount++;
          } else {
            delete obj[p1][p2];
          }
        }
        if (letterCount === 0) {
          delete obj[p1];
        }
      }
      // if every grapheme has the same style set then
      // delete those styles and set it on the parent
      for (let i = 0; i < this._textLines.length; i++) {
        graphemeCount += this._textLines[i].length;
      }
      if (allStyleObjectPropertiesMatch && stylesCount === graphemeCount) {
        this[property] = stylePropertyValue;
        this.removeStyle(property);
      }
    }

    /**
     * Remove a style property or properties from all individual character styles
     * in a text object.  Deletes the character style object if it contains no other style
     * props.  Deletes a line style object if it contains no other character styles.
     *
     * @param {String} props The property to remove from character styles.
     */
    removeStyle(property) {
      if (!this.styles) {
        return;
      }
      const obj = this.styles;
      let line, lineNum, charNum;
      for (lineNum in obj) {
        line = obj[lineNum];
        for (charNum in line) {
          delete line[charNum][property];
          if (Object.keys(line[charNum]).length === 0) {
            delete line[charNum];
          }
        }
        if (Object.keys(line).length === 0) {
          delete obj[lineNum];
        }
      }
    }
    _extendStyles(index, style) {
      const {
        lineIndex,
        charIndex
      } = this.get2DCursorLocation(index);
      if (!this._getLineStyle(lineIndex)) {
        this._setLineStyle(lineIndex);
      }
      const newStyle = pickBy(_objectSpread2(_objectSpread2({}, this._getStyleDeclaration(lineIndex, charIndex)), style), value => value !== undefined);

      // finally assign to the old position the new style
      this._setStyleDeclaration(lineIndex, charIndex, newStyle);
    }

    /**
     * Gets style of a current selection/cursor (at the start position)
     * @param {Number} startIndex Start index to get styles at
     * @param {Number} endIndex End index to get styles at, if not specified startIndex + 1
     * @param {Boolean} [complete] get full style or not
     * @return {Array} styles an array with one, zero or more Style objects
     */
    getSelectionStyles(startIndex, endIndex, complete) {
      const styles = [];
      for (let i = startIndex; i < (endIndex || startIndex); i++) {
        styles.push(this.getStyleAtPosition(i, complete));
      }
      return styles;
    }

    /**
     * Gets style of a current selection/cursor position
     * @param {Number} position  to get styles at
     * @param {Boolean} [complete] full style if true
     * @return {Object} style Style object at a specified index
     * @private
     */
    getStyleAtPosition(position, complete) {
      const {
        lineIndex,
        charIndex
      } = this.get2DCursorLocation(position);
      return complete ? this.getCompleteStyleDeclaration(lineIndex, charIndex) : this._getStyleDeclaration(lineIndex, charIndex);
    }

    /**
     * Sets style of a current selection, if no selection exist, do not set anything.
     * @param {Object} styles Styles object
     * @param {Number} startIndex Start index to get styles at
     * @param {Number} [endIndex] End index to get styles at, if not specified startIndex + 1
     */
    setSelectionStyles(styles, startIndex, endIndex) {
      for (let i = startIndex; i < (endIndex || startIndex); i++) {
        this._extendStyles(i, styles);
      }
      /* not included in _extendStyles to avoid clearing cache more than once */
      this._forceClearCache = true;
    }

    /**
     * Get a reference, not a clone, to the style object for a given character,
     * if no style is set for a line or char, return a new empty object.
     * This is tricky and confusing because when you get an empty object you can't
     * determine if it is a reference or a new one.
     * @TODO this should always return a reference or always a clone or undefined when necessary.
     * @protected
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @return {TextStyleDeclaration} a style object reference to the existing one or a new empty object when undefined
     */
    _getStyleDeclaration(lineIndex, charIndex) {
      var _lineStyle$charIndex;
      const lineStyle = this.styles && this.styles[lineIndex];
      return lineStyle ? (_lineStyle$charIndex = lineStyle[charIndex]) !== null && _lineStyle$charIndex !== void 0 ? _lineStyle$charIndex : {} : {};
    }

    /**
     * return a new object that contains all the style property for a character
     * the object returned is newly created
     * @param {Number} lineIndex of the line where the character is
     * @param {Number} charIndex position of the character on the line
     * @return {Object} style object
     */
    getCompleteStyleDeclaration(lineIndex, charIndex) {
      return _objectSpread2(_objectSpread2({}, pick(this, this.constructor._styleProperties)), this._getStyleDeclaration(lineIndex, charIndex));
    }

    /**
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @param {Object} style
     * @private
     */
    _setStyleDeclaration(lineIndex, charIndex, style) {
      this.styles[lineIndex][charIndex] = style;
    }

    /**
     *
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @private
     */
    _deleteStyleDeclaration(lineIndex, charIndex) {
      delete this.styles[lineIndex][charIndex];
    }

    /**
     * @param {Number} lineIndex
     * @return {Boolean} if the line exists or not
     * @private
     */
    _getLineStyle(lineIndex) {
      return !!this.styles[lineIndex];
    }

    /**
     * Set the line style to an empty object so that is initialized
     * @param {Number} lineIndex
     * @private
     */
    _setLineStyle(lineIndex) {
      this.styles[lineIndex] = {};
    }
    _deleteLineStyle(lineIndex) {
      delete this.styles[lineIndex];
    }
  }
  _defineProperty(StyledText, "_styleProperties", styleProperties);

  const multipleSpacesRegex = /  +/g;
  const dblQuoteRegex = /"/g;
  function createSVGInlineRect(color, left, top, width, height) {
    return "\t\t".concat(createSVGRect(color, {
      left,
      top,
      width,
      height
    }), "\n");
  }
  class TextSVGExportMixin extends FabricObjectSVGExportMixin {
    _toSVG() {
      const offsets = this._getSVGLeftTopOffsets(),
        textAndBg = this._getSVGTextAndBg(offsets.textTop, offsets.textLeft);
      return this._wrapSVGTextAndBg(textAndBg);
    }
    toSVG(reviver) {
      const textSvg = this._createBaseSVGMarkup(this._toSVG(), {
          reviver,
          noStyle: true,
          withShadow: true
        }),
        path = this.path;
      if (path) {
        return textSvg + path._createBaseSVGMarkup(path._toSVG(), {
          reviver,
          withShadow: true,
          additionalTransform: matrixToSVG(this.calcOwnMatrix())
        });
      }
      return textSvg;
    }
    _getSVGLeftTopOffsets() {
      return {
        textLeft: -this.width / 2,
        textTop: -this.height / 2,
        lineTop: this.getHeightOfLine(0)
      };
    }
    _wrapSVGTextAndBg(_ref) {
      let {
        textBgRects,
        textSpans
      } = _ref;
      const noShadow = true,
        textDecoration = this.getSvgTextDecoration(this);
      return [textBgRects.join(''), '\t\t<text xml:space="preserve" ', "font-family=\"".concat(this.fontFamily.replace(dblQuoteRegex, "'"), "\" "), "font-size=\"".concat(this.fontSize, "\" "), this.fontStyle ? "font-style=\"".concat(this.fontStyle, "\" ") : '', this.fontWeight ? "font-weight=\"".concat(this.fontWeight, "\" ") : '', textDecoration ? "text-decoration=\"".concat(textDecoration, "\" ") : '', this.direction === 'rtl' ? "direction=\"".concat(this.direction, "\" ") : '', 'style="', this.getSvgStyles(noShadow), '"', this.addPaintOrder(), ' >', textSpans.join(''), '</text>\n'];
    }

    /**
     * @private
     * @param {Number} textTopOffset Text top offset
     * @param {Number} textLeftOffset Text left offset
     * @return {Object}
     */
    _getSVGTextAndBg(textTopOffset, textLeftOffset) {
      const textSpans = [],
        textBgRects = [];
      let height = textTopOffset,
        lineOffset;

      // bounding-box background
      this.backgroundColor && textBgRects.push(...createSVGInlineRect(this.backgroundColor, -this.width / 2, -this.height / 2, this.width, this.height));

      // text and text-background
      for (let i = 0, len = this._textLines.length; i < len; i++) {
        lineOffset = this._getLineLeftOffset(i);
        if (this.direction === 'rtl') {
          lineOffset += this.width;
        }
        if (this.textBackgroundColor || this.styleHas('textBackgroundColor', i)) {
          this._setSVGTextLineBg(textBgRects, i, textLeftOffset + lineOffset, height);
        }
        this._setSVGTextLineText(textSpans, i, textLeftOffset + lineOffset, height);
        height += this.getHeightOfLine(i);
      }
      return {
        textSpans,
        textBgRects
      };
    }
    _createTextCharSpan(char, styleDecl, left, top, charBox) {
      const numFractionDigit = config.NUM_FRACTION_DIGITS;
      const styleProps = this.getSvgSpanStyles(styleDecl, char !== char.trim() || !!char.match(multipleSpacesRegex)),
        fillStyles = styleProps ? "style=\"".concat(styleProps, "\"") : '',
        dy = styleDecl.deltaY,
        dySpan = dy ? " dy=\"".concat(toFixed(dy, numFractionDigit), "\" ") : '',
        {
          angle,
          renderLeft,
          renderTop,
          width
        } = charBox;
      let angleAttr = '';
      if (renderLeft !== undefined) {
        const wBy2 = width / 2;
        angle && (angleAttr = " rotate=\"".concat(toFixed(radiansToDegrees(angle), numFractionDigit), "\""));
        const m = createRotateMatrix({
          angle: radiansToDegrees(angle)
        });
        m[4] = renderLeft;
        m[5] = renderTop;
        const renderPoint = new Point(-wBy2, 0).transform(m);
        left = renderPoint.x;
        top = renderPoint.y;
      }
      return "<tspan x=\"".concat(toFixed(left, numFractionDigit), "\" y=\"").concat(toFixed(top, numFractionDigit), "\" ").concat(dySpan).concat(angleAttr).concat(fillStyles, ">").concat(escapeXml(char), "</tspan>");
    }
    _setSVGTextLineText(textSpans, lineIndex, textLeftOffset, textTopOffset) {
      const lineHeight = this.getHeightOfLine(lineIndex),
        isJustify = this.textAlign.includes(JUSTIFY),
        line = this._textLines[lineIndex];
      let actualStyle,
        nextStyle,
        charsToRender = '',
        charBox,
        style,
        boxWidth = 0,
        timeToRender;
      textTopOffset += lineHeight * (1 - this._fontSizeFraction) / this.lineHeight;
      for (let i = 0, len = line.length - 1; i <= len; i++) {
        timeToRender = i === len || this.charSpacing || this.path;
        charsToRender += line[i];
        charBox = this.__charBounds[lineIndex][i];
        if (boxWidth === 0) {
          textLeftOffset += charBox.kernedWidth - charBox.width;
          boxWidth += charBox.width;
        } else {
          boxWidth += charBox.kernedWidth;
        }
        if (isJustify && !timeToRender) {
          if (this._reSpaceAndTab.test(line[i])) {
            timeToRender = true;
          }
        }
        if (!timeToRender) {
          // if we have charSpacing or a path, we render char by char
          actualStyle = actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
          nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
          timeToRender = hasStyleChanged(actualStyle, nextStyle, true);
        }
        if (timeToRender) {
          style = this._getStyleDeclaration(lineIndex, i);
          textSpans.push(this._createTextCharSpan(charsToRender, style, textLeftOffset, textTopOffset, charBox));
          charsToRender = '';
          actualStyle = nextStyle;
          if (this.direction === 'rtl') {
            textLeftOffset -= boxWidth;
          } else {
            textLeftOffset += boxWidth;
          }
          boxWidth = 0;
        }
      }
    }
    _setSVGTextLineBg(textBgRects, i, leftOffset, textTopOffset) {
      const line = this._textLines[i],
        heightOfLine = this.getHeightOfLine(i) / this.lineHeight;
      let boxWidth = 0,
        boxStart = 0,
        currentColor,
        lastColor = this.getValueOfPropertyAt(i, 0, 'textBackgroundColor');
      for (let j = 0; j < line.length; j++) {
        const {
          left,
          width,
          kernedWidth
        } = this.__charBounds[i][j];
        currentColor = this.getValueOfPropertyAt(i, j, 'textBackgroundColor');
        if (currentColor !== lastColor) {
          lastColor && textBgRects.push(...createSVGInlineRect(lastColor, leftOffset + boxStart, textTopOffset, boxWidth, heightOfLine));
          boxStart = left;
          boxWidth = width;
          lastColor = currentColor;
        } else {
          boxWidth += kernedWidth;
        }
      }
      currentColor && textBgRects.push(...createSVGInlineRect(lastColor, leftOffset + boxStart, textTopOffset, boxWidth, heightOfLine));
    }

    /**
     * @deprecated unused
     */
    _getSVGLineTopOffset(lineIndex) {
      let lineTopOffset = 0,
        j;
      for (j = 0; j < lineIndex; j++) {
        lineTopOffset += this.getHeightOfLine(j);
      }
      const lastHeight = this.getHeightOfLine(j);
      return {
        lineTop: lineTopOffset,
        offset: (this._fontSizeMult - this._fontSizeFraction) * lastHeight / (this.lineHeight * this._fontSizeMult)
      };
    }

    /**
     * Returns styles-string for svg-export
     * @param {Boolean} skipShadow a boolean to skip shadow filter output
     * @return {String}
     */
    getSvgStyles(skipShadow) {
      return "".concat(super.getSvgStyles(skipShadow), " text-decoration-thickness: ").concat(toFixed(this.textDecorationThickness * this.getObjectScaling().y / 10, config.NUM_FRACTION_DIGITS), "%; white-space: pre;");
    }

    /**
     * Returns styles-string for svg-export
     * @param {Object} style the object from which to retrieve style properties
     * @param {Boolean} useWhiteSpace a boolean to include an additional attribute in the style.
     * @return {String}
     */
    getSvgSpanStyles(style, useWhiteSpace) {
      const {
        fontFamily,
        strokeWidth,
        stroke,
        fill,
        fontSize,
        fontStyle,
        fontWeight,
        deltaY,
        textDecorationThickness,
        linethrough,
        overline,
        underline
      } = style;
      const textDecoration = this.getSvgTextDecoration({
        underline: underline !== null && underline !== void 0 ? underline : this.underline,
        overline: overline !== null && overline !== void 0 ? overline : this.overline,
        linethrough: linethrough !== null && linethrough !== void 0 ? linethrough : this.linethrough
      });
      const thickness = textDecorationThickness || this.textDecorationThickness;
      return [stroke ? colorPropToSVG(STROKE, stroke) : '', strokeWidth ? "stroke-width: ".concat(strokeWidth, "; ") : '', fontFamily ? "font-family: ".concat(!fontFamily.includes("'") && !fontFamily.includes('"') ? "'".concat(fontFamily, "'") : fontFamily, "; ") : '', fontSize ? "font-size: ".concat(fontSize, "px; ") : '', fontStyle ? "font-style: ".concat(fontStyle, "; ") : '', fontWeight ? "font-weight: ".concat(fontWeight, "; ") : '', textDecoration ? "text-decoration: ".concat(textDecoration, "; text-decoration-thickness: ").concat(toFixed(thickness * this.getObjectScaling().y / 10, config.NUM_FRACTION_DIGITS), "%; ") : '', fill ? colorPropToSVG(FILL, fill) : '', deltaY ? "baseline-shift: ".concat(-deltaY, "; ") : '', useWhiteSpace ? 'white-space: pre; ' : ''].join('');
    }

    /**
     * Returns text-decoration property for svg-export
     * @param {Object} style the object from which to retrieve style properties
     * @return {String}
     */
    getSvgTextDecoration(style) {
      return ['overline', 'underline', 'line-through'].filter(decoration => style[decoration.replace('-', '')]).join(' ');
    }
  }

  const _excluded$3 = ["textAnchor", "textDecoration", "dx", "dy", "top", "left", "fontSize", "strokeWidth"];
  let measuringContext;

  /**
   * Return a context for measurement of text string.
   * if created it gets stored for reuse
   */
  function getMeasuringContext() {
    if (!measuringContext) {
      const canvas = createCanvasElementFor({
        width: 0,
        height: 0
      });
      measuringContext = canvas.getContext('2d');
    }
    return measuringContext;
  }

  /**
   * Measure and return the info of a single grapheme.
   * needs the the info of previous graphemes already filled
   * Override to customize measuring
   */

  // @TODO this is not complete

  /**
   * Text class
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#text}
   */
  class FabricText extends StyledText {
    static getDefaults() {
      return _objectSpread2(_objectSpread2({}, super.getDefaults()), FabricText.ownDefaults);
    }
    constructor(text, options) {
      super();
      /**
       * contains characters bounding boxes
       * This variable is considered to be protected.
       * But for how mixins are implemented right now, we can't leave it private
       * @protected
       */
      _defineProperty(this, "__charBounds", []);
      Object.assign(this, FabricText.ownDefaults);
      this.setOptions(options);
      if (!this.styles) {
        this.styles = {};
      }
      this.text = text;
      this.initialized = true;
      if (this.path) {
        this.setPathInfo();
      }
      this.initDimensions();
      this.setCoords();
    }

    /**
     * If text has a path, it will add the extra information needed
     * for path and text calculations
     */
    setPathInfo() {
      const path = this.path;
      if (path) {
        path.segmentsInfo = getPathSegmentsInfo(path.path);
      }
    }

    /**
     * @private
     * Divides text into lines of text and lines of graphemes.
     */
    _splitText() {
      const newLines = this._splitTextIntoLines(this.text);
      this.textLines = newLines.lines;
      this._textLines = newLines.graphemeLines;
      this._unwrappedTextLines = newLines._unwrappedLines;
      this._text = newLines.graphemeText;
      return newLines;
    }

    /**
     * Initialize or update text dimensions.
     * Updates this.width and this.height with the proper values.
     * Does not return dimensions.
     */
    initDimensions() {
      this._splitText();
      this._clearCache();
      this.dirty = true;
      if (this.path) {
        this.width = this.path.width;
        this.height = this.path.height;
      } else {
        this.width = this.calcTextWidth() || this.cursorWidth || this.MIN_TEXT_WIDTH;
        this.height = this.calcTextHeight();
      }
      if (this.textAlign.includes(JUSTIFY)) {
        // once text is measured we need to make space fatter to make justified text.
        this.enlargeSpaces();
      }
    }

    /**
     * Enlarge space boxes and shift the others
     */
    enlargeSpaces() {
      let diffSpace, currentLineWidth, numberOfSpaces, accumulatedSpace, line, charBound, spaces;
      for (let i = 0, len = this._textLines.length; i < len; i++) {
        if (this.textAlign !== JUSTIFY && (i === len - 1 || this.isEndOfWrapping(i))) {
          continue;
        }
        accumulatedSpace = 0;
        line = this._textLines[i];
        currentLineWidth = this.getLineWidth(i);
        if (currentLineWidth < this.width && (spaces = this.textLines[i].match(this._reSpacesAndTabs))) {
          numberOfSpaces = spaces.length;
          diffSpace = (this.width - currentLineWidth) / numberOfSpaces;
          for (let j = 0; j <= line.length; j++) {
            charBound = this.__charBounds[i][j];
            if (this._reSpaceAndTab.test(line[j])) {
              charBound.width += diffSpace;
              charBound.kernedWidth += diffSpace;
              charBound.left += accumulatedSpace;
              accumulatedSpace += diffSpace;
            } else {
              charBound.left += accumulatedSpace;
            }
          }
        }
      }
    }

    /**
     * Detect if the text line is ended with an hard break
     * text and itext do not have wrapping, return false
     * @return {Boolean}
     */
    isEndOfWrapping(lineIndex) {
      return lineIndex === this._textLines.length - 1;
    }

    /**
     * Detect if a line has a linebreak and so we need to account for it when moving
     * and counting style.
     * It return always 1 for text and Itext. Textbox has its own implementation
     * @return Number
     */

    missingNewlineOffset(_lineIndex) {
      return 1;
    }

    /**
     * Returns 2d representation (lineIndex and charIndex) of cursor
     * @param {Number} selectionStart
     * @param {Boolean} [skipWrapping] consider the location for unwrapped lines. useful to manage styles.
     */
    get2DCursorLocation(selectionStart, skipWrapping) {
      const lines = skipWrapping ? this._unwrappedTextLines : this._textLines;
      let i;
      for (i = 0; i < lines.length; i++) {
        if (selectionStart <= lines[i].length) {
          return {
            lineIndex: i,
            charIndex: selectionStart
          };
        }
        selectionStart -= lines[i].length + this.missingNewlineOffset(i, skipWrapping);
      }
      return {
        lineIndex: i - 1,
        charIndex: lines[i - 1].length < selectionStart ? lines[i - 1].length : selectionStart
      };
    }

    /**
     * Returns string representation of an instance
     * @return {String} String representation of text object
     */
    toString() {
      return "#<Text (".concat(this.complexity(), "): { \"text\": \"").concat(this.text, "\", \"fontFamily\": \"").concat(this.fontFamily, "\" }>");
    }

    /**
     * Return the dimension and the zoom level needed to create a cache canvas
     * big enough to host the object to be cached.
     * @private
     * @param {Object} dim.x width of object to be cached
     * @param {Object} dim.y height of object to be cached
     * @return {Object}.width width of canvas
     * @return {Object}.height height of canvas
     * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
     * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
     */
    _getCacheCanvasDimensions() {
      const dims = super._getCacheCanvasDimensions();
      const fontSize = this.fontSize;
      dims.width += fontSize * dims.zoomX;
      dims.height += fontSize * dims.zoomY;
      return dims;
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render(ctx) {
      const path = this.path;
      path && !path.isNotVisible() && path._render(ctx);
      this._setTextStyles(ctx);
      this._renderTextLinesBackground(ctx);
      this._renderTextDecoration(ctx, 'underline');
      this._renderText(ctx);
      this._renderTextDecoration(ctx, 'overline');
      this._renderTextDecoration(ctx, 'linethrough');
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderText(ctx) {
      if (this.paintFirst === STROKE) {
        this._renderTextStroke(ctx);
        this._renderTextFill(ctx);
      } else {
        this._renderTextFill(ctx);
        this._renderTextStroke(ctx);
      }
    }

    /**
     * Set the font parameter of the context with the object properties or with charStyle
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Object} [charStyle] object with font style properties
     * @param {String} [charStyle.fontFamily] Font Family
     * @param {Number} [charStyle.fontSize] Font size in pixels. ( without px suffix )
     * @param {String} [charStyle.fontWeight] Font weight
     * @param {String} [charStyle.fontStyle] Font style (italic|normal)
     */
    _setTextStyles(ctx, charStyle, forMeasuring) {
      ctx.textBaseline = 'alphabetic';
      if (this.path) {
        switch (this.pathAlign) {
          case CENTER:
            ctx.textBaseline = 'middle';
            break;
          case 'ascender':
            ctx.textBaseline = TOP;
            break;
          case 'descender':
            ctx.textBaseline = BOTTOM;
            break;
        }
      }
      ctx.font = this._getFontDeclaration(charStyle, forMeasuring);
    }

    /**
     * calculate and return the text Width measuring each line.
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @return {Number} Maximum width of Text object
     */
    calcTextWidth() {
      let maxWidth = this.getLineWidth(0);
      for (let i = 1, len = this._textLines.length; i < len; i++) {
        const currentLineWidth = this.getLineWidth(i);
        if (currentLineWidth > maxWidth) {
          maxWidth = currentLineWidth;
        }
      }
      return maxWidth;
    }

    /**
     * @private
     * @param {String} method Method name ("fillText" or "strokeText")
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {String} line Text to render
     * @param {Number} left Left position of text
     * @param {Number} top Top position of text
     * @param {Number} lineIndex Index of a line in a text
     */
    _renderTextLine(method, ctx, line, left, top, lineIndex) {
      this._renderChars(method, ctx, line, left, top, lineIndex);
    }

    /**
     * Renders the text background for lines, taking care of style
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderTextLinesBackground(ctx) {
      if (!this.textBackgroundColor && !this.styleHas('textBackgroundColor')) {
        return;
      }
      const originalFill = ctx.fillStyle,
        leftOffset = this._getLeftOffset();
      let lineTopOffset = this._getTopOffset();
      for (let i = 0, len = this._textLines.length; i < len; i++) {
        const heightOfLine = this.getHeightOfLine(i);
        if (!this.textBackgroundColor && !this.styleHas('textBackgroundColor', i)) {
          lineTopOffset += heightOfLine;
          continue;
        }
        const jlen = this._textLines[i].length;
        const lineLeftOffset = this._getLineLeftOffset(i);
        let boxWidth = 0;
        let boxStart = 0;
        let drawStart;
        let currentColor;
        let lastColor = this.getValueOfPropertyAt(i, 0, 'textBackgroundColor');
        for (let j = 0; j < jlen; j++) {
          // at this point charbox are either standard or full with pathInfo if there is a path.
          const charBox = this.__charBounds[i][j];
          currentColor = this.getValueOfPropertyAt(i, j, 'textBackgroundColor');
          if (this.path) {
            ctx.save();
            ctx.translate(charBox.renderLeft, charBox.renderTop);
            ctx.rotate(charBox.angle);
            ctx.fillStyle = currentColor;
            currentColor && ctx.fillRect(-charBox.width / 2, -heightOfLine / this.lineHeight * (1 - this._fontSizeFraction), charBox.width, heightOfLine / this.lineHeight);
            ctx.restore();
          } else if (currentColor !== lastColor) {
            drawStart = leftOffset + lineLeftOffset + boxStart;
            if (this.direction === 'rtl') {
              drawStart = this.width - drawStart - boxWidth;
            }
            ctx.fillStyle = lastColor;
            lastColor && ctx.fillRect(drawStart, lineTopOffset, boxWidth, heightOfLine / this.lineHeight);
            boxStart = charBox.left;
            boxWidth = charBox.width;
            lastColor = currentColor;
          } else {
            boxWidth += charBox.kernedWidth;
          }
        }
        if (currentColor && !this.path) {
          drawStart = leftOffset + lineLeftOffset + boxStart;
          if (this.direction === 'rtl') {
            drawStart = this.width - drawStart - boxWidth;
          }
          ctx.fillStyle = currentColor;
          ctx.fillRect(drawStart, lineTopOffset, boxWidth, heightOfLine / this.lineHeight);
        }
        lineTopOffset += heightOfLine;
      }
      ctx.fillStyle = originalFill;
      // if there is text background color no
      // other shadows should be casted
      this._removeShadow(ctx);
    }

    /**
     * measure and return the width of a single character.
     * possibly overridden to accommodate different measure logic or
     * to hook some external lib for character measurement
     * @private
     * @param {String} _char, char to be measured
     * @param {Object} charStyle style of char to be measured
     * @param {String} [previousChar] previous char
     * @param {Object} [prevCharStyle] style of previous char
     */
    _measureChar(_char, charStyle, previousChar, prevCharStyle) {
      const fontCache = cache.getFontCache(charStyle),
        fontDeclaration = this._getFontDeclaration(charStyle),
        couple = previousChar + _char,
        stylesAreEqual = previousChar && fontDeclaration === this._getFontDeclaration(prevCharStyle),
        fontMultiplier = charStyle.fontSize / this.CACHE_FONT_SIZE;
      let width, coupleWidth, previousWidth, kernedWidth;
      if (previousChar && fontCache[previousChar] !== undefined) {
        previousWidth = fontCache[previousChar];
      }
      if (fontCache[_char] !== undefined) {
        kernedWidth = width = fontCache[_char];
      }
      if (stylesAreEqual && fontCache[couple] !== undefined) {
        coupleWidth = fontCache[couple];
        kernedWidth = coupleWidth - previousWidth;
      }
      if (width === undefined || previousWidth === undefined || coupleWidth === undefined) {
        const ctx = getMeasuringContext();
        // send a TRUE to specify measuring font size CACHE_FONT_SIZE
        this._setTextStyles(ctx, charStyle, true);
        if (width === undefined) {
          kernedWidth = width = ctx.measureText(_char).width;
          fontCache[_char] = width;
        }
        if (previousWidth === undefined && stylesAreEqual && previousChar) {
          previousWidth = ctx.measureText(previousChar).width;
          fontCache[previousChar] = previousWidth;
        }
        if (stylesAreEqual && coupleWidth === undefined) {
          // we can measure the kerning couple and subtract the width of the previous character
          coupleWidth = ctx.measureText(couple).width;
          fontCache[couple] = coupleWidth;
          // safe to use the non-null since if undefined we defined it before.
          kernedWidth = coupleWidth - previousWidth;
        }
      }
      return {
        width: width * fontMultiplier,
        kernedWidth: kernedWidth * fontMultiplier
      };
    }

    /**
     * Computes height of character at given position
     * @param {Number} line the line index number
     * @param {Number} _char the character index number
     * @return {Number} fontSize of the character
     */
    getHeightOfChar(line, _char) {
      return this.getValueOfPropertyAt(line, _char, 'fontSize');
    }

    /**
     * measure a text line measuring all characters.
     * @param {Number} lineIndex line number
     */
    measureLine(lineIndex) {
      const lineInfo = this._measureLine(lineIndex);
      if (this.charSpacing !== 0) {
        lineInfo.width -= this._getWidthOfCharSpacing();
      }
      if (lineInfo.width < 0) {
        lineInfo.width = 0;
      }
      return lineInfo;
    }

    /**
     * measure every grapheme of a line, populating __charBounds
     * @param {Number} lineIndex
     * @return {Object} object.width total width of characters
     * @return {Object} object.numOfSpaces length of chars that match this._reSpacesAndTabs
     */
    _measureLine(lineIndex) {
      let width = 0,
        prevGrapheme,
        graphemeInfo;
      const reverse = this.pathSide === RIGHT,
        path = this.path,
        line = this._textLines[lineIndex],
        llength = line.length,
        lineBounds = new Array(llength);
      this.__charBounds[lineIndex] = lineBounds;
      for (let i = 0; i < llength; i++) {
        const grapheme = line[i];
        graphemeInfo = this._getGraphemeBox(grapheme, lineIndex, i, prevGrapheme);
        lineBounds[i] = graphemeInfo;
        width += graphemeInfo.kernedWidth;
        prevGrapheme = grapheme;
      }
      // this latest bound box represent the last character of the line
      // to simplify cursor handling in interactive mode.
      lineBounds[llength] = {
        left: graphemeInfo ? graphemeInfo.left + graphemeInfo.width : 0,
        width: 0,
        kernedWidth: 0,
        height: this.fontSize,
        deltaY: 0
      };
      if (path && path.segmentsInfo) {
        let positionInPath = 0;
        const totalPathLength = path.segmentsInfo[path.segmentsInfo.length - 1].length;
        switch (this.textAlign) {
          case LEFT:
            positionInPath = reverse ? totalPathLength - width : 0;
            break;
          case CENTER:
            positionInPath = (totalPathLength - width) / 2;
            break;
          case RIGHT:
            positionInPath = reverse ? 0 : totalPathLength - width;
            break;
          //todo - add support for justify
        }
        positionInPath += this.pathStartOffset * (reverse ? -1 : 1);
        for (let i = reverse ? llength - 1 : 0; reverse ? i >= 0 : i < llength; reverse ? i-- : i++) {
          graphemeInfo = lineBounds[i];
          if (positionInPath > totalPathLength) {
            positionInPath %= totalPathLength;
          } else if (positionInPath < 0) {
            positionInPath += totalPathLength;
          }
          // it would probably much faster to send all the grapheme position for a line
          // and calculate path position/angle at once.
          this._setGraphemeOnPath(positionInPath, graphemeInfo);
          positionInPath += graphemeInfo.kernedWidth;
        }
      }
      return {
        width: width,
        numOfSpaces: 0
      };
    }

    /**
     * Calculate the angle  and the left,top position of the char that follow a path.
     * It appends it to graphemeInfo to be reused later at rendering
     * @private
     * @param {Number} positionInPath to be measured
     * @param {GraphemeBBox} graphemeInfo current grapheme box information
     * @param {Object} startingPoint position of the point
     */
    _setGraphemeOnPath(positionInPath, graphemeInfo) {
      const centerPosition = positionInPath + graphemeInfo.kernedWidth / 2,
        path = this.path;

      // we are at currentPositionOnPath. we want to know what point on the path is.
      const info = getPointOnPath(path.path, centerPosition, path.segmentsInfo);
      graphemeInfo.renderLeft = info.x - path.pathOffset.x;
      graphemeInfo.renderTop = info.y - path.pathOffset.y;
      graphemeInfo.angle = info.angle + (this.pathSide === RIGHT ? Math.PI : 0);
    }

    /**
     *
     * @param {String} grapheme to be measured
     * @param {Number} lineIndex index of the line where the char is
     * @param {Number} charIndex position in the line
     * @param {String} [prevGrapheme] character preceding the one to be measured
     * @returns {GraphemeBBox} grapheme bbox
     */
    _getGraphemeBox(grapheme, lineIndex, charIndex, prevGrapheme, skipLeft) {
      const style = this.getCompleteStyleDeclaration(lineIndex, charIndex),
        prevStyle = prevGrapheme ? this.getCompleteStyleDeclaration(lineIndex, charIndex - 1) : {},
        info = this._measureChar(grapheme, style, prevGrapheme, prevStyle);
      let kernedWidth = info.kernedWidth,
        width = info.width,
        charSpacing;
      if (this.charSpacing !== 0) {
        charSpacing = this._getWidthOfCharSpacing();
        width += charSpacing;
        kernedWidth += charSpacing;
      }
      const box = {
        width,
        left: 0,
        height: style.fontSize,
        kernedWidth,
        deltaY: style.deltaY
      };
      if (charIndex > 0 && !skipLeft) {
        const previousBox = this.__charBounds[lineIndex][charIndex - 1];
        box.left = previousBox.left + previousBox.width + info.kernedWidth - info.width;
      }
      return box;
    }

    /**
     * Calculate height of line at 'lineIndex'
     * @param {Number} lineIndex index of line to calculate
     * @return {Number}
     */
    getHeightOfLine(lineIndex) {
      if (this.__lineHeights[lineIndex]) {
        return this.__lineHeights[lineIndex];
      }

      // char 0 is measured before the line cycle because it needs to char
      // emptylines
      let maxHeight = this.getHeightOfChar(lineIndex, 0);
      for (let i = 1, len = this._textLines[lineIndex].length; i < len; i++) {
        maxHeight = Math.max(this.getHeightOfChar(lineIndex, i), maxHeight);
      }
      return this.__lineHeights[lineIndex] = maxHeight * this.lineHeight * this._fontSizeMult;
    }

    /**
     * Calculate text box height
     */
    calcTextHeight() {
      let lineHeight,
        height = 0;
      for (let i = 0, len = this._textLines.length; i < len; i++) {
        lineHeight = this.getHeightOfLine(i);
        height += i === len - 1 ? lineHeight / this.lineHeight : lineHeight;
      }
      return height;
    }

    /**
     * @private
     * @return {Number} Left offset
     */
    _getLeftOffset() {
      return this.direction === 'ltr' ? -this.width / 2 : this.width / 2;
    }

    /**
     * @private
     * @return {Number} Top offset
     */
    _getTopOffset() {
      return -this.height / 2;
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {String} method Method name ("fillText" or "strokeText")
     */
    _renderTextCommon(ctx, method) {
      ctx.save();
      let lineHeights = 0;
      const left = this._getLeftOffset(),
        top = this._getTopOffset();
      for (let i = 0, len = this._textLines.length; i < len; i++) {
        const heightOfLine = this.getHeightOfLine(i),
          maxHeight = heightOfLine / this.lineHeight,
          leftOffset = this._getLineLeftOffset(i);
        this._renderTextLine(method, ctx, this._textLines[i], left + leftOffset, top + lineHeights + maxHeight, i);
        lineHeights += heightOfLine;
      }
      ctx.restore();
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderTextFill(ctx) {
      if (!this.fill && !this.styleHas(FILL)) {
        return;
      }
      this._renderTextCommon(ctx, 'fillText');
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderTextStroke(ctx) {
      if ((!this.stroke || this.strokeWidth === 0) && this.isEmptyStyles()) {
        return;
      }
      if (this.shadow && !this.shadow.affectStroke) {
        this._removeShadow(ctx);
      }
      ctx.save();
      this._setLineDash(ctx, this.strokeDashArray);
      ctx.beginPath();
      this._renderTextCommon(ctx, 'strokeText');
      ctx.closePath();
      ctx.restore();
    }

    /**
     * @private
     * @param {String} method fillText or strokeText.
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Array} line Content of the line, splitted in an array by grapheme
     * @param {Number} left
     * @param {Number} top
     * @param {Number} lineIndex
     */
    _renderChars(method, ctx, line, left, top, lineIndex) {
      const lineHeight = this.getHeightOfLine(lineIndex),
        isJustify = this.textAlign.includes(JUSTIFY),
        path = this.path,
        shortCut = !isJustify && this.charSpacing === 0 && this.isEmptyStyles(lineIndex) && !path,
        isLtr = this.direction === 'ltr',
        sign = this.direction === 'ltr' ? 1 : -1,
        // this was changed in the PR #7674
        // currentDirection = ctx.canvas.getAttribute('dir');
        currentDirection = ctx.direction;
      let actualStyle,
        nextStyle,
        charsToRender = '',
        charBox,
        boxWidth = 0,
        timeToRender,
        drawingLeft;
      ctx.save();
      if (currentDirection !== this.direction) {
        ctx.canvas.setAttribute('dir', isLtr ? 'ltr' : 'rtl');
        ctx.direction = isLtr ? 'ltr' : 'rtl';
        ctx.textAlign = isLtr ? LEFT : RIGHT;
      }
      top -= lineHeight * this._fontSizeFraction / this.lineHeight;
      if (shortCut) {
        // render all the line in one pass without checking
        // drawingLeft = isLtr ? left : left - this.getLineWidth(lineIndex);
        this._renderChar(method, ctx, lineIndex, 0, line.join(''), left, top);
        ctx.restore();
        return;
      }
      for (let i = 0, len = line.length - 1; i <= len; i++) {
        timeToRender = i === len || this.charSpacing || path;
        charsToRender += line[i];
        charBox = this.__charBounds[lineIndex][i];
        if (boxWidth === 0) {
          left += sign * (charBox.kernedWidth - charBox.width);
          boxWidth += charBox.width;
        } else {
          boxWidth += charBox.kernedWidth;
        }
        if (isJustify && !timeToRender) {
          if (this._reSpaceAndTab.test(line[i])) {
            timeToRender = true;
          }
        }
        if (!timeToRender) {
          // if we have charSpacing, we render char by char
          actualStyle = actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
          nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
          timeToRender = hasStyleChanged(actualStyle, nextStyle, false);
        }
        if (timeToRender) {
          if (path) {
            ctx.save();
            ctx.translate(charBox.renderLeft, charBox.renderTop);
            ctx.rotate(charBox.angle);
            this._renderChar(method, ctx, lineIndex, i, charsToRender, -boxWidth / 2, 0);
            ctx.restore();
          } else {
            drawingLeft = left;
            this._renderChar(method, ctx, lineIndex, i, charsToRender, drawingLeft, top);
          }
          charsToRender = '';
          actualStyle = nextStyle;
          left += sign * boxWidth;
          boxWidth = 0;
        }
      }
      ctx.restore();
    }

    /**
     * This function try to patch the missing gradientTransform on canvas gradients.
     * transforming a context to transform the gradient, is going to transform the stroke too.
     * we want to transform the gradient but not the stroke operation, so we create
     * a transformed gradient on a pattern and then we use the pattern instead of the gradient.
     * this method has drawbacks: is slow, is in low resolution, needs a patch for when the size
     * is limited.
     * @private
     * @param {TFiller} filler a fabric gradient instance
     * @return {CanvasPattern} a pattern to use as fill/stroke style
     */
    _applyPatternGradientTransformText(filler) {
      // TODO: verify compatibility with strokeUniform
      const width = this.width + this.strokeWidth,
        height = this.height + this.strokeWidth,
        pCanvas = createCanvasElementFor({
          width,
          height
        }),
        pCtx = pCanvas.getContext('2d');
      pCanvas.width = width;
      pCanvas.height = height;
      pCtx.beginPath();
      pCtx.moveTo(0, 0);
      pCtx.lineTo(width, 0);
      pCtx.lineTo(width, height);
      pCtx.lineTo(0, height);
      pCtx.closePath();
      pCtx.translate(width / 2, height / 2);
      pCtx.fillStyle = filler.toLive(pCtx);
      this._applyPatternGradientTransform(pCtx, filler);
      pCtx.fill();
      return pCtx.createPattern(pCanvas, 'no-repeat');
    }
    handleFiller(ctx, property, filler) {
      let offsetX, offsetY;
      if (isFiller(filler)) {
        if (filler.gradientUnits === 'percentage' || filler.gradientTransform || filler.patternTransform) {
          // need to transform gradient in a pattern.
          // this is a slow process. If you are hitting this codepath, and the object
          // is not using caching, you should consider switching it on.
          // we need a canvas as big as the current object caching canvas.
          offsetX = -this.width / 2;
          offsetY = -this.height / 2;
          ctx.translate(offsetX, offsetY);
          ctx[property] = this._applyPatternGradientTransformText(filler);
          return {
            offsetX,
            offsetY
          };
        } else {
          // is a simple gradient or pattern
          ctx[property] = filler.toLive(ctx);
          return this._applyPatternGradientTransform(ctx, filler);
        }
      } else {
        // is a color
        ctx[property] = filler;
      }
      return {
        offsetX: 0,
        offsetY: 0
      };
    }

    /**
     * This function prepare the canvas for a stroke style, and stroke and strokeWidth
     * need to be sent in as defined
     * @param {CanvasRenderingContext2D} ctx
     * @param {CompleteTextStyleDeclaration} style with stroke and strokeWidth defined
     * @returns
     */
    _setStrokeStyles(ctx, _ref) {
      let {
        stroke,
        strokeWidth
      } = _ref;
      ctx.lineWidth = strokeWidth;
      ctx.lineCap = this.strokeLineCap;
      ctx.lineDashOffset = this.strokeDashOffset;
      ctx.lineJoin = this.strokeLineJoin;
      ctx.miterLimit = this.strokeMiterLimit;
      return this.handleFiller(ctx, 'strokeStyle', stroke);
    }

    /**
     * This function prepare the canvas for a ill style, and fill
     * need to be sent in as defined
     * @param {CanvasRenderingContext2D} ctx
     * @param {CompleteTextStyleDeclaration} style with ill defined
     * @returns
     */
    _setFillStyles(ctx, _ref2) {
      let {
        fill
      } = _ref2;
      return this.handleFiller(ctx, 'fillStyle', fill);
    }

    /**
     * @private
     * @param {String} method
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @param {String} _char
     * @param {Number} left Left coordinate
     * @param {Number} top Top coordinate
     * @param {Number} lineHeight Height of the line
     */
    _renderChar(method, ctx, lineIndex, charIndex, _char, left, top) {
      const decl = this._getStyleDeclaration(lineIndex, charIndex),
        fullDecl = this.getCompleteStyleDeclaration(lineIndex, charIndex),
        shouldFill = method === 'fillText' && fullDecl.fill,
        shouldStroke = method === 'strokeText' && fullDecl.stroke && fullDecl.strokeWidth;
      if (!shouldStroke && !shouldFill) {
        return;
      }
      ctx.save();
      ctx.font = this._getFontDeclaration(fullDecl);
      if (decl.textBackgroundColor) {
        this._removeShadow(ctx);
      }
      if (decl.deltaY) {
        top += decl.deltaY;
      }
      if (shouldFill) {
        const fillOffsets = this._setFillStyles(ctx, fullDecl);
        ctx.fillText(_char, left - fillOffsets.offsetX, top - fillOffsets.offsetY);
      }
      if (shouldStroke) {
        const strokeOffsets = this._setStrokeStyles(ctx, fullDecl);
        ctx.strokeText(_char, left - strokeOffsets.offsetX, top - strokeOffsets.offsetY);
      }
      ctx.restore();
    }

    /**
     * Turns the character into a 'superior figure' (i.e. 'superscript')
     * @param {Number} start selection start
     * @param {Number} end selection end
     */
    setSuperscript(start, end) {
      this._setScript(start, end, this.superscript);
    }

    /**
     * Turns the character into an 'inferior figure' (i.e. 'subscript')
     * @param {Number} start selection start
     * @param {Number} end selection end
     */
    setSubscript(start, end) {
      this._setScript(start, end, this.subscript);
    }

    /**
     * Applies 'schema' at given position
     * @private
     * @param {Number} start selection start
     * @param {Number} end selection end
     * @param {Number} schema
     */
    _setScript(start, end, schema) {
      const loc = this.get2DCursorLocation(start, true),
        fontSize = this.getValueOfPropertyAt(loc.lineIndex, loc.charIndex, 'fontSize'),
        dy = this.getValueOfPropertyAt(loc.lineIndex, loc.charIndex, 'deltaY'),
        style = {
          fontSize: fontSize * schema.size,
          deltaY: dy + fontSize * schema.baseline
        };
      this.setSelectionStyles(style, start, end);
    }

    /**
     * @private
     * @param {Number} lineIndex index text line
     * @return {Number} Line left offset
     */
    _getLineLeftOffset(lineIndex) {
      const lineWidth = this.getLineWidth(lineIndex),
        lineDiff = this.width - lineWidth,
        textAlign = this.textAlign,
        direction = this.direction,
        isEndOfWrapping = this.isEndOfWrapping(lineIndex);
      let leftOffset = 0;
      if (textAlign === JUSTIFY || textAlign === JUSTIFY_CENTER && !isEndOfWrapping || textAlign === JUSTIFY_RIGHT && !isEndOfWrapping || textAlign === JUSTIFY_LEFT && !isEndOfWrapping) {
        return 0;
      }
      if (textAlign === CENTER) {
        leftOffset = lineDiff / 2;
      }
      if (textAlign === RIGHT) {
        leftOffset = lineDiff;
      }
      if (textAlign === JUSTIFY_CENTER) {
        leftOffset = lineDiff / 2;
      }
      if (textAlign === JUSTIFY_RIGHT) {
        leftOffset = lineDiff;
      }
      if (direction === 'rtl') {
        if (textAlign === RIGHT || textAlign === JUSTIFY || textAlign === JUSTIFY_RIGHT) {
          leftOffset = 0;
        } else if (textAlign === LEFT || textAlign === JUSTIFY_LEFT) {
          leftOffset = -lineDiff;
        } else if (textAlign === CENTER || textAlign === JUSTIFY_CENTER) {
          leftOffset = -lineDiff / 2;
        }
      }
      return leftOffset;
    }

    /**
     * @private
     */
    _clearCache() {
      this._forceClearCache = false;
      this.__lineWidths = [];
      this.__lineHeights = [];
      this.__charBounds = [];
    }

    /**
     * Measure a single line given its index. Used to calculate the initial
     * text bounding box. The values are calculated and stored in __lineWidths cache.
     * @private
     * @param {Number} lineIndex line number
     * @return {Number} Line width
     */
    getLineWidth(lineIndex) {
      if (this.__lineWidths[lineIndex] !== undefined) {
        return this.__lineWidths[lineIndex];
      }
      const {
        width
      } = this.measureLine(lineIndex);
      this.__lineWidths[lineIndex] = width;
      return width;
    }
    _getWidthOfCharSpacing() {
      if (this.charSpacing !== 0) {
        return this.fontSize * this.charSpacing / 1000;
      }
      return 0;
    }

    /**
     * Retrieves the value of property at given character position
     * @param {Number} lineIndex the line number
     * @param {Number} charIndex the character number
     * @param {String} property the property name
     * @returns the value of 'property'
     */
    getValueOfPropertyAt(lineIndex, charIndex, property) {
      var _charStyle$property;
      const charStyle = this._getStyleDeclaration(lineIndex, charIndex);
      return (_charStyle$property = charStyle[property]) !== null && _charStyle$property !== void 0 ? _charStyle$property : this[property];
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _renderTextDecoration(ctx, type) {
      if (!this[type] && !this.styleHas(type)) {
        return;
      }
      let topOffset = this._getTopOffset();
      const leftOffset = this._getLeftOffset(),
        path = this.path,
        charSpacing = this._getWidthOfCharSpacing(),
        offsetAligner = type === 'linethrough' ? 0.5 : type === 'overline' ? 1 : 0,
        offsetY = this.offsets[type];
      for (let i = 0, len = this._textLines.length; i < len; i++) {
        const heightOfLine = this.getHeightOfLine(i);
        if (!this[type] && !this.styleHas(type, i)) {
          topOffset += heightOfLine;
          continue;
        }
        const line = this._textLines[i];
        const maxHeight = heightOfLine / this.lineHeight;
        const lineLeftOffset = this._getLineLeftOffset(i);
        let boxStart = 0;
        let boxWidth = 0;
        let lastDecoration = this.getValueOfPropertyAt(i, 0, type);
        let lastFill = this.getValueOfPropertyAt(i, 0, FILL);
        let lastTickness = this.getValueOfPropertyAt(i, 0, TEXT_DECORATION_THICKNESS);
        let currentDecoration = lastDecoration;
        let currentFill = lastFill;
        let currentTickness = lastTickness;
        const top = topOffset + maxHeight * (1 - this._fontSizeFraction);
        let size = this.getHeightOfChar(i, 0);
        let dy = this.getValueOfPropertyAt(i, 0, 'deltaY');
        for (let j = 0, jlen = line.length; j < jlen; j++) {
          const charBox = this.__charBounds[i][j];
          currentDecoration = this.getValueOfPropertyAt(i, j, type);
          currentFill = this.getValueOfPropertyAt(i, j, FILL);
          currentTickness = this.getValueOfPropertyAt(i, j, TEXT_DECORATION_THICKNESS);
          const currentSize = this.getHeightOfChar(i, j);
          const currentDy = this.getValueOfPropertyAt(i, j, 'deltaY');
          if (path && currentDecoration && currentFill) {
            const finalTickness = this.fontSize * currentTickness / 1000;
            ctx.save();
            // bug? verify lastFill is a valid fill here.
            ctx.fillStyle = lastFill;
            ctx.translate(charBox.renderLeft, charBox.renderTop);
            ctx.rotate(charBox.angle);
            ctx.fillRect(-charBox.kernedWidth / 2, offsetY * currentSize + currentDy - offsetAligner * finalTickness, charBox.kernedWidth, finalTickness);
            ctx.restore();
          } else if ((currentDecoration !== lastDecoration || currentFill !== lastFill || currentSize !== size || currentTickness !== lastTickness || currentDy !== dy) && boxWidth > 0) {
            const finalTickness = this.fontSize * lastTickness / 1000;
            let drawStart = leftOffset + lineLeftOffset + boxStart;
            if (this.direction === 'rtl') {
              drawStart = this.width - drawStart - boxWidth;
            }
            if (lastDecoration && lastFill && lastTickness) {
              // bug? verify lastFill is a valid fill here.
              ctx.fillStyle = lastFill;
              ctx.fillRect(drawStart, top + offsetY * size + dy - offsetAligner * finalTickness, boxWidth, finalTickness);
            }
            boxStart = charBox.left;
            boxWidth = charBox.width;
            lastDecoration = currentDecoration;
            lastTickness = currentTickness;
            lastFill = currentFill;
            size = currentSize;
            dy = currentDy;
          } else {
            boxWidth += charBox.kernedWidth;
          }
        }
        let drawStart = leftOffset + lineLeftOffset + boxStart;
        if (this.direction === 'rtl') {
          drawStart = this.width - drawStart - boxWidth;
        }
        ctx.fillStyle = currentFill;
        const finalTickness = this.fontSize * currentTickness / 1000;
        currentDecoration && currentFill && currentTickness && ctx.fillRect(drawStart, top + offsetY * size + dy - offsetAligner * finalTickness, boxWidth - charSpacing, finalTickness);
        topOffset += heightOfLine;
      }
      // if there is text background color no
      // other shadows should be casted
      this._removeShadow(ctx);
    }

    /**
     * return font declaration string for canvas context
     * @param {Object} [styleObject] object
     * @returns {String} font declaration formatted for canvas context.
     */
    _getFontDeclaration() {
      let {
        fontFamily = this.fontFamily,
        fontStyle = this.fontStyle,
        fontWeight = this.fontWeight,
        fontSize = this.fontSize
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      let forMeasuring = arguments.length > 1 ? arguments[1] : undefined;
      const parsedFontFamily = fontFamily.includes("'") || fontFamily.includes('"') || fontFamily.includes(',') || FabricText.genericFonts.includes(fontFamily.toLowerCase()) ? fontFamily : "\"".concat(fontFamily, "\"");
      return [fontStyle, fontWeight, "".concat(forMeasuring ? this.CACHE_FONT_SIZE : fontSize, "px"), parsedFontFamily].join(' ');
    }

    /**
     * Renders text instance on a specified context
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    render(ctx) {
      if (!this.visible) {
        return;
      }
      if (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen()) {
        return;
      }
      if (this._forceClearCache) {
        this.initDimensions();
      }
      super.render(ctx);
    }

    /**
     * Override this method to customize grapheme splitting
     * @todo the util `graphemeSplit` needs to be injectable in some way.
     * is more comfortable to inject the correct util rather than having to override text
     * in the middle of the prototype chain
     * @param {string} value
     * @returns {string[]} array of graphemes
     */
    graphemeSplit(value) {
      return graphemeSplit(value);
    }

    /**
     * Returns the text as an array of lines.
     * @param {String} text text to split
     * @returns  Lines in the text
     */
    _splitTextIntoLines(text) {
      const lines = text.split(this._reNewline),
        newLines = new Array(lines.length),
        newLine = ['\n'];
      let newText = [];
      for (let i = 0; i < lines.length; i++) {
        newLines[i] = this.graphemeSplit(lines[i]);
        newText = newText.concat(newLines[i], newLine);
      }
      newText.pop();
      return {
        _unwrappedLines: newLines,
        lines: lines,
        graphemeText: newText,
        graphemeLines: newLines
      };
    }

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */
    toObject() {
      let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return _objectSpread2(_objectSpread2({}, super.toObject([...additionalProps, ...propertiesToInclude])), {}, {
        styles: stylesToArray(this.styles, this.text)
      }, this.path ? {
        path: this.path.toObject()
      } : {});
    }
    set(key, value) {
      const {
        textLayoutProperties
      } = this.constructor;
      super.set(key, value);
      let needsDims = false;
      let isAddingPath = false;
      if (typeof key === 'object') {
        for (const _key in key) {
          if (_key === 'path') {
            this.setPathInfo();
          }
          needsDims = needsDims || textLayoutProperties.includes(_key);
          isAddingPath = isAddingPath || _key === 'path';
        }
      } else {
        needsDims = textLayoutProperties.includes(key);
        isAddingPath = key === 'path';
      }
      if (isAddingPath) {
        this.setPathInfo();
      }
      if (needsDims && this.initialized) {
        this.initDimensions();
        this.setCoords();
      }
      return this;
    }

    /**
     * Returns complexity of an instance
     * @return {Number} complexity
     */
    complexity() {
      return 1;
    }

    /**
     * List of generic font families
     * @see https://developer.mozilla.org/en-US/docs/Web/CSS/font-family#generic-name
     */

    /**
     * Returns FabricText instance from an SVG element (<b>not yet implemented</b>)
     * @static
     * @memberOf Text
     * @param {HTMLElement} element Element to parse
     * @param {Object} [options] Options object
     */
    static async fromElement(element, options, cssRules) {
      const parsedAttributes = parseAttributes(element, FabricText.ATTRIBUTE_NAMES, cssRules);
      const _options$parsedAttrib = _objectSpread2(_objectSpread2({}, options), parsedAttributes),
        {
          textAnchor = LEFT,
          textDecoration = '',
          dx = 0,
          dy = 0,
          top = 0,
          left = 0,
          fontSize = DEFAULT_SVG_FONT_SIZE,
          strokeWidth = 1
        } = _options$parsedAttrib,
        restOfOptions = _objectWithoutProperties(_options$parsedAttrib, _excluded$3);
      const textContent = (element.textContent || '').replace(/^\s+|\s+$|\n+/g, '').replace(/\s+/g, ' ');

      // this code here is probably the usual issue for SVG center find
      // this can later looked at again and probably removed.

      const text = new this(textContent, _objectSpread2({
          left: left + dx,
          top: top + dy,
          underline: textDecoration.includes('underline'),
          overline: textDecoration.includes('overline'),
          linethrough: textDecoration.includes('line-through'),
          // we initialize this as 0
          strokeWidth: 0,
          fontSize
        }, restOfOptions)),
        textHeightScaleFactor = text.getScaledHeight() / text.height,
        lineHeightDiff = (text.height + text.strokeWidth) * text.lineHeight - text.height,
        scaledDiff = lineHeightDiff * textHeightScaleFactor,
        textHeight = text.getScaledHeight() + scaledDiff;
      let offX = 0;
      /*
        Adjust positioning:
          x/y attributes in SVG correspond to the bottom-left corner of text bounding box
          fabric output by default at top, left.
      */
      if (textAnchor === CENTER) {
        offX = text.getScaledWidth() / 2;
      }
      if (textAnchor === RIGHT) {
        offX = text.getScaledWidth();
      }
      text.set({
        left: text.left - offX,
        top: text.top - (textHeight - text.fontSize * (0.07 + text._fontSizeFraction)) / text.lineHeight,
        strokeWidth
      });
      return text;
    }

    /* _FROM_SVG_END_ */

    /**
     * Returns FabricText instance from an object representation
     * @param {Object} object plain js Object to create an instance from
     * @returns {Promise<FabricText>}
     */
    static fromObject(object) {
      return this._fromObject(_objectSpread2(_objectSpread2({}, object), {}, {
        styles: stylesFromArray(object.styles || {}, object.text)
      }), {
        extraParam: 'text'
      });
    }
  }
  /**
   * Properties that requires a text layout recalculation when changed
   * @type string[]
   * @protected
   */
  _defineProperty(FabricText, "textLayoutProperties", textLayoutProperties);
  _defineProperty(FabricText, "cacheProperties", [...cacheProperties, ...additionalProps]);
  _defineProperty(FabricText, "ownDefaults", textDefaultValues);
  _defineProperty(FabricText, "type", 'Text');
  _defineProperty(FabricText, "genericFonts", ['serif', 'sans-serif', 'monospace', 'cursive', 'fantasy', 'system-ui', 'ui-serif', 'ui-sans-serif', 'ui-monospace', 'ui-rounded', 'math', 'emoji', 'fangsong']);
  /* _FROM_SVG_START_ */
  /**
   * List of attribute names to account for when parsing SVG element (used by {@link FabricText.fromElement})
   * @static
   * @memberOf Text
   * @see: http://www.w3.org/TR/SVG/text.html#TextElement
   */
  _defineProperty(FabricText, "ATTRIBUTE_NAMES", SHARED_ATTRIBUTES.concat('x', 'y', 'dx', 'dy', 'font-family', 'font-style', 'font-weight', 'font-size', 'letter-spacing', 'text-decoration', 'text-anchor'));
  applyMixins(FabricText, [TextSVGExportMixin]);
  classRegistry.setClass(FabricText);
  classRegistry.setSVGClass(FabricText);

  /**
   * #### Dragging IText/Textbox Lifecycle
   * - {@link start} is called from `mousedown` {@link IText#_mouseDownHandler} and determines if dragging should start by testing {@link isPointerOverSelection}
   * - if true `mousedown` {@link IText#_mouseDownHandler} is blocked to keep selection
   * - if the pointer moves, canvas fires numerous mousemove {@link Canvas#_onMouseMove} that we make sure **aren't** prevented ({@link IText#shouldStartDragging}) in order for the window to start a drag session
   * - once/if the session starts canvas calls {@link onDragStart} on the active object to determine if dragging should occur
   * - canvas fires relevant drag events that are handled by the handlers defined in this scope
   * - {@link end} is called from `mouseup` {@link IText#mouseUpHandler}, blocking IText default click behavior
   * - in case the drag session didn't occur, {@link end} handles a click, since logic to do so was blocked during `mousedown`
   */
  class DraggableTextDelegate {
    constructor(target) {
      _defineProperty(this, "target", void 0);
      _defineProperty(this, "__mouseDownInPlace", false);
      _defineProperty(this, "__dragStartFired", false);
      _defineProperty(this, "__isDraggingOver", false);
      _defineProperty(this, "__dragStartSelection", void 0);
      _defineProperty(this, "__dragImageDisposer", void 0);
      _defineProperty(this, "_dispose", void 0);
      this.target = target;
      const disposers = [this.target.on('dragenter', this.dragEnterHandler.bind(this)), this.target.on('dragover', this.dragOverHandler.bind(this)), this.target.on('dragleave', this.dragLeaveHandler.bind(this)), this.target.on('dragend', this.dragEndHandler.bind(this)), this.target.on('drop', this.dropHandler.bind(this))];
      this._dispose = () => {
        disposers.forEach(d => d());
        this._dispose = undefined;
      };
    }
    isPointerOverSelection(e) {
      const target = this.target;
      const newSelection = target.getSelectionStartFromPointer(e);
      return target.isEditing && newSelection >= target.selectionStart && newSelection <= target.selectionEnd && target.selectionStart < target.selectionEnd;
    }

    /**
     * @public override this method to disable dragging and default to mousedown logic
     */
    start(e) {
      return this.__mouseDownInPlace = this.isPointerOverSelection(e);
    }

    /**
     * @public override this method to disable dragging without discarding selection
     */
    isActive() {
      return this.__mouseDownInPlace;
    }

    /**
     * Ends interaction and sets cursor in case of a click
     * @returns true if was active
     */
    end(e) {
      const active = this.isActive();
      if (active && !this.__dragStartFired) {
        // mousedown has been blocked since `active` is true => cursor has not been set.
        // `__dragStartFired` is false => dragging didn't occur, pointer didn't move and is over selection.
        // meaning this is actually a click, `active` is a false positive.
        this.target.setCursorByClick(e);
        this.target.initDelayedCursor(true);
      }
      this.__mouseDownInPlace = false;
      this.__dragStartFired = false;
      this.__isDraggingOver = false;
      return active;
    }
    getDragStartSelection() {
      return this.__dragStartSelection;
    }

    /**
     * Override to customize the drag image
     * https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage
     */
    setDragImage(e, _ref) {
      var _e$dataTransfer;
      let {
        selectionStart,
        selectionEnd
      } = _ref;
      const target = this.target;
      const canvas = target.canvas;
      const flipFactor = new Point(target.flipX ? -1 : 1, target.flipY ? -1 : 1);
      const boundaries = target._getCursorBoundaries(selectionStart);
      const selectionPosition = new Point(boundaries.left + boundaries.leftOffset, boundaries.top + boundaries.topOffset).multiply(flipFactor);
      const pos = selectionPosition.transform(target.calcTransformMatrix());
      const pointer = canvas.getScenePoint(e);
      const diff = pointer.subtract(pos);
      const retinaScaling = target.getCanvasRetinaScaling();
      const bbox = target.getBoundingRect();
      const correction = pos.subtract(new Point(bbox.left, bbox.top));
      const vpt = canvas.viewportTransform;
      const offset = correction.add(diff).transform(vpt, true);
      //  prepare instance for drag image snapshot by making all non selected text invisible
      const bgc = target.backgroundColor;
      const styles = cloneStyles(target.styles);
      target.backgroundColor = '';
      const styleOverride = {
        stroke: 'transparent',
        fill: 'transparent',
        textBackgroundColor: 'transparent'
      };
      target.setSelectionStyles(styleOverride, 0, selectionStart);
      target.setSelectionStyles(styleOverride, selectionEnd, target.text.length);
      target.dirty = true;
      const dragImage = target.toCanvasElement({
        enableRetinaScaling: canvas.enableRetinaScaling,
        viewportTransform: true
      });
      // restore values
      target.backgroundColor = bgc;
      target.styles = styles;
      target.dirty = true;
      //  position drag image offscreen
      setStyle(dragImage, {
        position: 'fixed',
        left: "".concat(-dragImage.width, "px"),
        border: NONE,
        width: "".concat(dragImage.width / retinaScaling, "px"),
        height: "".concat(dragImage.height / retinaScaling, "px")
      });
      this.__dragImageDisposer && this.__dragImageDisposer();
      this.__dragImageDisposer = () => {
        dragImage.remove();
      };
      getDocumentFromElement(e.target || this.target.hiddenTextarea).body.appendChild(dragImage);
      (_e$dataTransfer = e.dataTransfer) === null || _e$dataTransfer === void 0 || _e$dataTransfer.setDragImage(dragImage, offset.x, offset.y);
    }

    /**
     * @returns {boolean} determines whether {@link target} should/shouldn't become a drag source
     */
    onDragStart(e) {
      this.__dragStartFired = true;
      const target = this.target;
      const active = this.isActive();
      if (active && e.dataTransfer) {
        const selection = this.__dragStartSelection = {
          selectionStart: target.selectionStart,
          selectionEnd: target.selectionEnd
        };
        const value = target._text.slice(selection.selectionStart, selection.selectionEnd).join('');
        const data = _objectSpread2({
          text: target.text,
          value
        }, selection);
        e.dataTransfer.setData('text/plain', value);
        e.dataTransfer.setData('application/fabric', JSON.stringify({
          value: value,
          styles: target.getSelectionStyles(selection.selectionStart, selection.selectionEnd, true)
        }));
        e.dataTransfer.effectAllowed = 'copyMove';
        this.setDragImage(e, data);
      }
      target.abortCursorAnimation();
      return active;
    }

    /**
     * use {@link targetCanDrop} to respect overriding
     * @returns {boolean} determines whether {@link target} should/shouldn't become a drop target
     */
    canDrop(e) {
      if (this.target.editable && !this.target.getActiveControl() && !e.defaultPrevented) {
        if (this.isActive() && this.__dragStartSelection) {
          //  drag source trying to drop over itself
          //  allow dropping only outside of drag start selection
          const index = this.target.getSelectionStartFromPointer(e);
          const dragStartSelection = this.__dragStartSelection;
          return index < dragStartSelection.selectionStart || index > dragStartSelection.selectionEnd;
        }
        return true;
      }
      return false;
    }

    /**
     * in order to respect overriding {@link IText#canDrop} we call that instead of calling {@link canDrop} directly
     */
    targetCanDrop(e) {
      return this.target.canDrop(e);
    }
    dragEnterHandler(_ref2) {
      let {
        e
      } = _ref2;
      const canDrop = this.targetCanDrop(e);
      if (!this.__isDraggingOver && canDrop) {
        this.__isDraggingOver = true;
      }
    }
    dragOverHandler(ev) {
      const {
        e
      } = ev;
      const canDrop = this.targetCanDrop(e);
      if (!this.__isDraggingOver && canDrop) {
        this.__isDraggingOver = true;
      } else if (this.__isDraggingOver && !canDrop) {
        //  drop state has changed
        this.__isDraggingOver = false;
      }
      if (this.__isDraggingOver) {
        //  can be dropped, inform browser
        e.preventDefault();
        //  inform event subscribers
        ev.canDrop = true;
        ev.dropTarget = this.target;
      }
    }
    dragLeaveHandler() {
      if (this.__isDraggingOver || this.isActive()) {
        this.__isDraggingOver = false;
      }
    }

    /**
     * Override the `text/plain | application/fabric` types of {@link DragEvent#dataTransfer}
     * in order to change the drop value or to customize styling respectively, by listening to the `drop:before` event
     * https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Drag_operations#performing_a_drop
     */
    dropHandler(ev) {
      var _e$dataTransfer2;
      const {
        e
      } = ev;
      const didDrop = e.defaultPrevented;
      this.__isDraggingOver = false;
      // inform browser that the drop has been accepted
      e.preventDefault();
      let insert = (_e$dataTransfer2 = e.dataTransfer) === null || _e$dataTransfer2 === void 0 ? void 0 : _e$dataTransfer2.getData('text/plain');
      if (insert && !didDrop) {
        const target = this.target;
        const canvas = target.canvas;
        let insertAt = target.getSelectionStartFromPointer(e);
        const {
          styles
        } = e.dataTransfer.types.includes('application/fabric') ? JSON.parse(e.dataTransfer.getData('application/fabric')) : {};
        const trailing = insert[Math.max(0, insert.length - 1)];
        const selectionStartOffset = 0;
        //  drag and drop in same instance
        if (this.__dragStartSelection) {
          const selectionStart = this.__dragStartSelection.selectionStart;
          const selectionEnd = this.__dragStartSelection.selectionEnd;
          if (insertAt > selectionStart && insertAt <= selectionEnd) {
            insertAt = selectionStart;
          } else if (insertAt > selectionEnd) {
            insertAt -= selectionEnd - selectionStart;
          }
          target.removeChars(selectionStart, selectionEnd);
          // prevent `dragend` from handling event
          delete this.__dragStartSelection;
        }
        //  remove redundant line break
        if (target._reNewline.test(trailing) && (target._reNewline.test(target._text[insertAt]) || insertAt === target._text.length)) {
          insert = insert.trimEnd();
        }
        //  inform subscribers
        ev.didDrop = true;
        ev.dropTarget = target;
        //  finalize
        target.insertChars(insert, styles, insertAt);
        // can this part be moved in an outside event? andrea to check.
        canvas.setActiveObject(target);
        target.enterEditing(e);
        target.selectionStart = Math.min(insertAt + selectionStartOffset, target._text.length);
        target.selectionEnd = Math.min(target.selectionStart + insert.length, target._text.length);
        target.hiddenTextarea.value = target.text;
        target._updateTextarea();
        target.hiddenTextarea.focus();
        target.fire(CHANGED, {
          index: insertAt + selectionStartOffset,
          action: 'drop'
        });
        canvas.fire('text:changed', {
          target
        });
        canvas.contextTopDirty = true;
        canvas.requestRenderAll();
      }
    }

    /**
     * fired only on the drag source after drop (if occurred)
     * handle changes to the drag source in case of a drop on another object or a cancellation
     * https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Drag_operations#finishing_a_drag
     */
    dragEndHandler(_ref3) {
      let {
        e
      } = _ref3;
      if (this.isActive() && this.__dragStartFired) {
        //  once the drop event finishes we check if we need to change the drag source
        //  if the drag source received the drop we bail out since the drop handler has already handled logic
        if (this.__dragStartSelection) {
          var _e$dataTransfer3;
          const target = this.target;
          const canvas = this.target.canvas;
          const {
            selectionStart,
            selectionEnd
          } = this.__dragStartSelection;
          const dropEffect = ((_e$dataTransfer3 = e.dataTransfer) === null || _e$dataTransfer3 === void 0 ? void 0 : _e$dataTransfer3.dropEffect) || NONE;
          if (dropEffect === NONE) {
            // pointer is back over selection
            target.selectionStart = selectionStart;
            target.selectionEnd = selectionEnd;
            target._updateTextarea();
            target.hiddenTextarea.focus();
          } else {
            target.clearContextTop();
            if (dropEffect === 'move') {
              target.removeChars(selectionStart, selectionEnd);
              target.selectionStart = target.selectionEnd = selectionStart;
              target.hiddenTextarea && (target.hiddenTextarea.value = target.text);
              target._updateTextarea();
              target.fire(CHANGED, {
                index: selectionStart,
                action: 'dragend'
              });
              canvas.fire('text:changed', {
                target
              });
              canvas.requestRenderAll();
            }
            target.exitEditing();
          }
        }
      }
      this.__dragImageDisposer && this.__dragImageDisposer();
      delete this.__dragImageDisposer;
      delete this.__dragStartSelection;
      this.__isDraggingOver = false;
    }
    dispose() {
      this._dispose && this._dispose();
    }
  }

  /**
   *  extend this regex to support non english languages
   *
   *  - ` `      Matches a SPACE character (char code 32).
   *  - `\n`     Matches a LINE FEED character (char code 10).
   *  - `\.`     Matches a "." character (char code 46).
   *  - `,`      Matches a "," character (char code 44).
   *  - `;`      Matches a ";" character (char code 59).
   *  - `!`      Matches a "!" character (char code 33).
   *  - `\?`     Matches a "?" character (char code 63).
   *  - `\-`     Matches a "-" character (char code 45).
   */
  // eslint-disable-next-line no-useless-escape
  const reNonWord = /[ \n\.,;!\?\-]/;
  class ITextBehavior extends FabricText {
    constructor() {
      super(...arguments);
      /**
       * Helps determining when the text is in composition, so that the cursor
       * rendering is altered.
       */
      _defineProperty(this, "_currentCursorOpacity", 1);
    }
    /**
     * Keeps track if the IText object was selected before the actual click.
     * This because we want to delay enter editing by a click.
     */
    /**
     * Initializes all the interactive behavior of IText
     */
    initBehavior() {
      this._tick = this._tick.bind(this);
      this._onTickComplete = this._onTickComplete.bind(this);
      this.updateSelectionOnMouseMove = this.updateSelectionOnMouseMove.bind(this);
    }
    onDeselect(options) {
      this.isEditing && this.exitEditing();
      this.selected = false;
      return super.onDeselect(options);
    }

    /**
     * @private
     */
    _animateCursor(_ref) {
      let {
        toValue,
        duration,
        delay,
        onComplete
      } = _ref;
      return animate({
        startValue: this._currentCursorOpacity,
        endValue: toValue,
        duration,
        delay,
        onComplete,
        abort: () => !this.canvas ||
        // we do not want to animate a selection, only cursor
        this.selectionStart !== this.selectionEnd,
        onChange: value => {
          this._currentCursorOpacity = value;
          this.renderCursorOrSelection();
        }
      });
    }

    /**
     * changes the cursor from visible to invisible
     */
    _tick(delay) {
      this._currentTickState = this._animateCursor({
        toValue: 0,
        duration: this.cursorDuration / 2,
        delay: Math.max(delay || 0, 100),
        onComplete: this._onTickComplete
      });
    }

    /**
     * Changes the cursor from invisible to visible
     */
    _onTickComplete() {
      var _this$_currentTickCom;
      (_this$_currentTickCom = this._currentTickCompleteState) === null || _this$_currentTickCom === void 0 || _this$_currentTickCom.abort();
      this._currentTickCompleteState = this._animateCursor({
        toValue: 1,
        duration: this.cursorDuration,
        onComplete: this._tick
      });
    }

    /**
     * Initializes delayed cursor
     */
    initDelayedCursor(restart) {
      this.abortCursorAnimation();
      this._tick(restart ? 0 : this.cursorDelay);
    }

    /**
     * Aborts cursor animation, clears all timeouts and clear textarea context if necessary
     */
    abortCursorAnimation() {
      let shouldClear = false;
      [this._currentTickState, this._currentTickCompleteState].forEach(cursorAnimation => {
        if (cursorAnimation && !cursorAnimation.isDone()) {
          shouldClear = true;
          cursorAnimation.abort();
        }
      });
      this._currentCursorOpacity = 1;

      //  make sure we clear context even if instance is not editing
      if (shouldClear) {
        this.clearContextTop();
      }
    }

    /**
     * Restart tue cursor animation if either is in complete state ( between animations )
     * or if it never started before
     */
    restartCursorIfNeeded() {
      if ([this._currentTickState, this._currentTickCompleteState].some(cursorAnimation => !cursorAnimation || cursorAnimation.isDone())) {
        this.initDelayedCursor();
      }
    }

    /**
     * Selects entire text
     */
    selectAll() {
      this.selectionStart = 0;
      this.selectionEnd = this._text.length;
      this._fireSelectionChanged();
      this._updateTextarea();
      return this;
    }

    /**
     * Selects entire text and updates the visual state
     */
    cmdAll() {
      this.selectAll();
      this.renderCursorOrSelection();
    }

    /**
     * Returns selected text
     * @return {String}
     */
    getSelectedText() {
      return this._text.slice(this.selectionStart, this.selectionEnd).join('');
    }

    /**
     * Find new selection index representing start of current word according to current selection index
     * @param {Number} startFrom Current selection index
     * @return {Number} New selection index
     */
    findWordBoundaryLeft(startFrom) {
      let offset = 0,
        index = startFrom - 1;

      // remove space before cursor first
      if (this._reSpace.test(this._text[index])) {
        while (this._reSpace.test(this._text[index])) {
          offset++;
          index--;
        }
      }
      while (/\S/.test(this._text[index]) && index > -1) {
        offset++;
        index--;
      }
      return startFrom - offset;
    }

    /**
     * Find new selection index representing end of current word according to current selection index
     * @param {Number} startFrom Current selection index
     * @return {Number} New selection index
     */
    findWordBoundaryRight(startFrom) {
      let offset = 0,
        index = startFrom;

      // remove space after cursor first
      if (this._reSpace.test(this._text[index])) {
        while (this._reSpace.test(this._text[index])) {
          offset++;
          index++;
        }
      }
      while (/\S/.test(this._text[index]) && index < this._text.length) {
        offset++;
        index++;
      }
      return startFrom + offset;
    }

    /**
     * Find new selection index representing start of current line according to current selection index
     * @param {Number} startFrom Current selection index
     * @return {Number} New selection index
     */
    findLineBoundaryLeft(startFrom) {
      let offset = 0,
        index = startFrom - 1;
      while (!/\n/.test(this._text[index]) && index > -1) {
        offset++;
        index--;
      }
      return startFrom - offset;
    }

    /**
     * Find new selection index representing end of current line according to current selection index
     * @param {Number} startFrom Current selection index
     * @return {Number} New selection index
     */
    findLineBoundaryRight(startFrom) {
      let offset = 0,
        index = startFrom;
      while (!/\n/.test(this._text[index]) && index < this._text.length) {
        offset++;
        index++;
      }
      return startFrom + offset;
    }

    /**
     * Finds index corresponding to beginning or end of a word
     * @param {Number} selectionStart Index of a character
     * @param {Number} direction 1 or -1
     * @return {Number} Index of the beginning or end of a word
     */
    searchWordBoundary(selectionStart, direction) {
      const text = this._text;
      // if we land on a space we move the cursor backwards
      // if we are searching boundary end we move the cursor backwards ONLY if we don't land on a line break
      let index = selectionStart > 0 && this._reSpace.test(text[selectionStart]) && (direction === -1 || !reNewline.test(text[selectionStart - 1])) ? selectionStart - 1 : selectionStart,
        _char = text[index];
      while (index > 0 && index < text.length && !reNonWord.test(_char)) {
        index += direction;
        _char = text[index];
      }
      if (direction === -1 && reNonWord.test(_char)) {
        index++;
      }
      return index;
    }

    /**
     * Selects the word that contains the char at index selectionStart
     * @param {Number} selectionStart Index of a character
     */
    selectWord(selectionStart) {
      var _selectionStart;
      selectionStart = (_selectionStart = selectionStart) !== null && _selectionStart !== void 0 ? _selectionStart : this.selectionStart;
      // search backwards
      const newSelectionStart = this.searchWordBoundary(selectionStart, -1),
        // search forward
        newSelectionEnd = Math.max(newSelectionStart, this.searchWordBoundary(selectionStart, 1));
      this.selectionStart = newSelectionStart;
      this.selectionEnd = newSelectionEnd;
      this._fireSelectionChanged();
      this._updateTextarea();
      // remove next major, for now it renders twice :(
      this.renderCursorOrSelection();
    }

    /**
     * Selects the line that contains selectionStart
     * @param {Number} selectionStart Index of a character
     */
    selectLine(selectionStart) {
      var _selectionStart2;
      selectionStart = (_selectionStart2 = selectionStart) !== null && _selectionStart2 !== void 0 ? _selectionStart2 : this.selectionStart;
      const newSelectionStart = this.findLineBoundaryLeft(selectionStart),
        newSelectionEnd = this.findLineBoundaryRight(selectionStart);
      this.selectionStart = newSelectionStart;
      this.selectionEnd = newSelectionEnd;
      this._fireSelectionChanged();
      this._updateTextarea();
    }

    /**
     * Enters editing state
     */
    enterEditing(e) {
      if (this.isEditing || !this.editable) {
        return;
      }
      this.enterEditingImpl();
      this.fire('editing:entered', e ? {
        e
      } : undefined);
      this._fireSelectionChanged();
      if (this.canvas) {
        this.canvas.fire('text:editing:entered', {
          target: this,
          e
        });
        this.canvas.requestRenderAll();
      }
    }

    /**
     * runs the actual logic that enter from editing state, see {@link enterEditing}
     */
    enterEditingImpl() {
      if (this.canvas) {
        this.canvas.calcOffset();
        this.canvas.textEditingManager.exitTextEditing();
      }
      this.isEditing = true;
      this.initHiddenTextarea();
      this.hiddenTextarea.focus();
      this.hiddenTextarea.value = this.text;
      this._updateTextarea();
      this._saveEditingProps();
      this._setEditingProps();
      this._textBeforeEdit = this.text;
      this._tick();
    }

    /**
     * called by {@link Canvas#textEditingManager}
     */
    updateSelectionOnMouseMove(e) {
      if (this.getActiveControl()) {
        return;
      }
      const el = this.hiddenTextarea;
      // regain focus
      getDocumentFromElement(el).activeElement !== el && el.focus();
      const newSelectionStart = this.getSelectionStartFromPointer(e),
        currentStart = this.selectionStart,
        currentEnd = this.selectionEnd;
      if ((newSelectionStart !== this.__selectionStartOnMouseDown || currentStart === currentEnd) && (currentStart === newSelectionStart || currentEnd === newSelectionStart)) {
        return;
      }
      if (newSelectionStart > this.__selectionStartOnMouseDown) {
        this.selectionStart = this.__selectionStartOnMouseDown;
        this.selectionEnd = newSelectionStart;
      } else {
        this.selectionStart = newSelectionStart;
        this.selectionEnd = this.__selectionStartOnMouseDown;
      }
      if (this.selectionStart !== currentStart || this.selectionEnd !== currentEnd) {
        this._fireSelectionChanged();
        this._updateTextarea();
        this.renderCursorOrSelection();
      }
    }

    /**
     * @private
     */
    _setEditingProps() {
      this.hoverCursor = 'text';
      if (this.canvas) {
        this.canvas.defaultCursor = this.canvas.moveCursor = 'text';
      }
      this.borderColor = this.editingBorderColor;
      this.hasControls = this.selectable = false;
      this.lockMovementX = this.lockMovementY = true;
    }

    /**
     * convert from textarea to grapheme indexes
     */
    fromStringToGraphemeSelection(start, end, text) {
      const smallerTextStart = text.slice(0, start),
        graphemeStart = this.graphemeSplit(smallerTextStart).length;
      if (start === end) {
        return {
          selectionStart: graphemeStart,
          selectionEnd: graphemeStart
        };
      }
      const smallerTextEnd = text.slice(start, end),
        graphemeEnd = this.graphemeSplit(smallerTextEnd).length;
      return {
        selectionStart: graphemeStart,
        selectionEnd: graphemeStart + graphemeEnd
      };
    }

    /**
     * convert from fabric to textarea values
     */
    fromGraphemeToStringSelection(start, end, graphemes) {
      const smallerTextStart = graphemes.slice(0, start),
        graphemeStart = smallerTextStart.join('').length;
      if (start === end) {
        return {
          selectionStart: graphemeStart,
          selectionEnd: graphemeStart
        };
      }
      const smallerTextEnd = graphemes.slice(start, end),
        graphemeEnd = smallerTextEnd.join('').length;
      return {
        selectionStart: graphemeStart,
        selectionEnd: graphemeStart + graphemeEnd
      };
    }

    /**
     * @private
     */
    _updateTextarea() {
      this.cursorOffsetCache = {};
      if (!this.hiddenTextarea) {
        return;
      }
      if (!this.inCompositionMode) {
        const newSelection = this.fromGraphemeToStringSelection(this.selectionStart, this.selectionEnd, this._text);
        this.hiddenTextarea.selectionStart = newSelection.selectionStart;
        this.hiddenTextarea.selectionEnd = newSelection.selectionEnd;
      }
      this.updateTextareaPosition();
    }

    /**
     * @private
     */
    updateFromTextArea() {
      if (!this.hiddenTextarea) {
        return;
      }
      this.cursorOffsetCache = {};
      const textarea = this.hiddenTextarea;
      this.text = textarea.value;
      this.set('dirty', true);
      this.initDimensions();
      this.setCoords();
      const newSelection = this.fromStringToGraphemeSelection(textarea.selectionStart, textarea.selectionEnd, textarea.value);
      this.selectionEnd = this.selectionStart = newSelection.selectionEnd;
      if (!this.inCompositionMode) {
        this.selectionStart = newSelection.selectionStart;
      }
      this.updateTextareaPosition();
    }

    /**
     * @private
     */
    updateTextareaPosition() {
      if (this.selectionStart === this.selectionEnd) {
        const style = this._calcTextareaPosition();
        this.hiddenTextarea.style.left = style.left;
        this.hiddenTextarea.style.top = style.top;
      }
    }

    /**
     * @private
     * @return {Object} style contains style for hiddenTextarea
     */
    _calcTextareaPosition() {
      if (!this.canvas) {
        return {
          left: '1px',
          top: '1px'
        };
      }
      const desiredPosition = this.inCompositionMode ? this.compositionStart : this.selectionStart,
        boundaries = this._getCursorBoundaries(desiredPosition),
        cursorLocation = this.get2DCursorLocation(desiredPosition),
        lineIndex = cursorLocation.lineIndex,
        charIndex = cursorLocation.charIndex,
        charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, 'fontSize') * this.lineHeight,
        leftOffset = boundaries.leftOffset,
        retinaScaling = this.getCanvasRetinaScaling(),
        upperCanvas = this.canvas.upperCanvasEl,
        upperCanvasWidth = upperCanvas.width / retinaScaling,
        upperCanvasHeight = upperCanvas.height / retinaScaling,
        maxWidth = upperCanvasWidth - charHeight,
        maxHeight = upperCanvasHeight - charHeight;
      const p = new Point(boundaries.left + leftOffset, boundaries.top + boundaries.topOffset + charHeight).transform(this.calcTransformMatrix()).transform(this.canvas.viewportTransform).multiply(new Point(upperCanvas.clientWidth / upperCanvasWidth, upperCanvas.clientHeight / upperCanvasHeight));
      if (p.x < 0) {
        p.x = 0;
      }
      if (p.x > maxWidth) {
        p.x = maxWidth;
      }
      if (p.y < 0) {
        p.y = 0;
      }
      if (p.y > maxHeight) {
        p.y = maxHeight;
      }

      // add canvas offset on document
      p.x += this.canvas._offset.left;
      p.y += this.canvas._offset.top;
      return {
        left: "".concat(p.x, "px"),
        top: "".concat(p.y, "px"),
        fontSize: "".concat(charHeight, "px"),
        charHeight: charHeight
      };
    }

    /**
     * @private
     */
    _saveEditingProps() {
      this._savedProps = {
        hasControls: this.hasControls,
        borderColor: this.borderColor,
        lockMovementX: this.lockMovementX,
        lockMovementY: this.lockMovementY,
        hoverCursor: this.hoverCursor,
        selectable: this.selectable,
        defaultCursor: this.canvas && this.canvas.defaultCursor,
        moveCursor: this.canvas && this.canvas.moveCursor
      };
    }

    /**
     * @private
     */
    _restoreEditingProps() {
      if (!this._savedProps) {
        return;
      }
      this.hoverCursor = this._savedProps.hoverCursor;
      this.hasControls = this._savedProps.hasControls;
      this.borderColor = this._savedProps.borderColor;
      this.selectable = this._savedProps.selectable;
      this.lockMovementX = this._savedProps.lockMovementX;
      this.lockMovementY = this._savedProps.lockMovementY;
      if (this.canvas) {
        this.canvas.defaultCursor = this._savedProps.defaultCursor || this.canvas.defaultCursor;
        this.canvas.moveCursor = this._savedProps.moveCursor || this.canvas.moveCursor;
      }
      delete this._savedProps;
    }

    /**
     * runs the actual logic that exits from editing state, see {@link exitEditing}
     * Please use exitEditingImpl, this function was kept to avoid breaking changes.
     * Will be removed in fabric 7.0
     * @deprecated use "exitEditingImpl"
     */
    _exitEditing() {
      const hiddenTextarea = this.hiddenTextarea;
      this.selected = false;
      this.isEditing = false;
      if (hiddenTextarea) {
        hiddenTextarea.blur && hiddenTextarea.blur();
        hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
      }
      this.hiddenTextarea = null;
      this.abortCursorAnimation();
      this.selectionStart !== this.selectionEnd && this.clearContextTop();
    }

    /**
     * runs the actual logic that exits from editing state, see {@link exitEditing}
     * But it does not fire events
     */
    exitEditingImpl() {
      this._exitEditing();
      this.selectionEnd = this.selectionStart;
      this._restoreEditingProps();
      if (this._forceClearCache) {
        this.initDimensions();
        this.setCoords();
      }
    }

    /**
     * Exits from editing state and fires relevant events
     */
    exitEditing() {
      const isTextChanged = this._textBeforeEdit !== this.text;
      this.exitEditingImpl();
      this.fire('editing:exited');
      isTextChanged && this.fire(MODIFIED);
      if (this.canvas) {
        this.canvas.fire('text:editing:exited', {
          target: this
        });
        // todo: evaluate add an action to this event
        isTextChanged && this.canvas.fire('object:modified', {
          target: this
        });
      }
      return this;
    }

    /**
     * @private
     */
    _removeExtraneousStyles() {
      for (const prop in this.styles) {
        if (!this._textLines[prop]) {
          delete this.styles[prop];
        }
      }
    }

    /**
     * remove and reflow a style block from start to end.
     * @param {Number} start linear start position for removal (included in removal)
     * @param {Number} end linear end position for removal ( excluded from removal )
     */
    removeStyleFromTo(start, end) {
      const {
          lineIndex: lineStart,
          charIndex: charStart
        } = this.get2DCursorLocation(start, true),
        {
          lineIndex: lineEnd,
          charIndex: charEnd
        } = this.get2DCursorLocation(end, true);
      if (lineStart !== lineEnd) {
        // step1 remove the trailing of lineStart
        if (this.styles[lineStart]) {
          for (let i = charStart; i < this._unwrappedTextLines[lineStart].length; i++) {
            delete this.styles[lineStart][i];
          }
        }
        // step2 move the trailing of lineEnd to lineStart if needed
        if (this.styles[lineEnd]) {
          for (let i = charEnd; i < this._unwrappedTextLines[lineEnd].length; i++) {
            const styleObj = this.styles[lineEnd][i];
            if (styleObj) {
              this.styles[lineStart] || (this.styles[lineStart] = {});
              this.styles[lineStart][charStart + i - charEnd] = styleObj;
            }
          }
        }
        // step3 detects lines will be completely removed.
        for (let i = lineStart + 1; i <= lineEnd; i++) {
          delete this.styles[i];
        }
        // step4 shift remaining lines.
        this.shiftLineStyles(lineEnd, lineStart - lineEnd);
      } else {
        // remove and shift left on the same line
        if (this.styles[lineStart]) {
          const styleObj = this.styles[lineStart];
          const diff = charEnd - charStart;
          for (let i = charStart; i < charEnd; i++) {
            delete styleObj[i];
          }
          for (const char in this.styles[lineStart]) {
            const numericChar = parseInt(char, 10);
            if (numericChar >= charEnd) {
              styleObj[numericChar - diff] = styleObj[char];
              delete styleObj[char];
            }
          }
        }
      }
    }

    /**
     * Shifts line styles up or down
     * @param {Number} lineIndex Index of a line
     * @param {Number} offset Can any number?
     */
    shiftLineStyles(lineIndex, offset) {
      const clonedStyles = Object.assign({}, this.styles);
      for (const line in this.styles) {
        const numericLine = parseInt(line, 10);
        if (numericLine > lineIndex) {
          this.styles[numericLine + offset] = clonedStyles[numericLine];
          if (!clonedStyles[numericLine - offset]) {
            delete this.styles[numericLine];
          }
        }
      }
    }

    /**
     * Handle insertion of more consecutive style lines for when one or more
     * newlines gets added to the text. Since current style needs to be shifted
     * first we shift the current style of the number lines needed, then we add
     * new lines from the last to the first.
     * @param {Number} lineIndex Index of a line
     * @param {Number} charIndex Index of a char
     * @param {Number} qty number of lines to add
     * @param {Array} copiedStyle Array of objects styles
     */
    insertNewlineStyleObject(lineIndex, charIndex, qty, copiedStyle) {
      const newLineStyles = {};
      const originalLineLength = this._unwrappedTextLines[lineIndex].length;
      const isEndOfLine = originalLineLength === charIndex;
      let someStyleIsCarryingOver = false;
      qty || (qty = 1);
      this.shiftLineStyles(lineIndex, qty);
      const currentCharStyle = this.styles[lineIndex] ? this.styles[lineIndex][charIndex === 0 ? charIndex : charIndex - 1] : undefined;

      // we clone styles of all chars
      // after cursor onto the current line
      for (const index in this.styles[lineIndex]) {
        const numIndex = parseInt(index, 10);
        if (numIndex >= charIndex) {
          someStyleIsCarryingOver = true;
          newLineStyles[numIndex - charIndex] = this.styles[lineIndex][index];
          // remove lines from the previous line since they're on a new line now
          if (!(isEndOfLine && charIndex === 0)) {
            delete this.styles[lineIndex][index];
          }
        }
      }
      let styleCarriedOver = false;
      if (someStyleIsCarryingOver && !isEndOfLine) {
        // if is end of line, the extra style we copied
        // is probably not something we want
        this.styles[lineIndex + qty] = newLineStyles;
        styleCarriedOver = true;
      }
      if (styleCarriedOver || originalLineLength > charIndex) {
        // skip the last line of since we already prepared it.
        // or contains text without style that we don't want to style
        // just because it changed lines
        qty--;
      }
      // for the all the lines or all the other lines
      // we clone current char style onto the next (otherwise empty) line
      while (qty > 0) {
        if (copiedStyle && copiedStyle[qty - 1]) {
          this.styles[lineIndex + qty] = {
            0: _objectSpread2({}, copiedStyle[qty - 1])
          };
        } else if (currentCharStyle) {
          this.styles[lineIndex + qty] = {
            0: _objectSpread2({}, currentCharStyle)
          };
        } else {
          delete this.styles[lineIndex + qty];
        }
        qty--;
      }
      this._forceClearCache = true;
    }

    /**
     * Inserts style object for a given line/char index
     * @param {Number} lineIndex Index of a line
     * @param {Number} charIndex Index of a char
     * @param {Number} quantity number Style object to insert, if given
     * @param {Array} copiedStyle array of style objects
     */
    insertCharStyleObject(lineIndex, charIndex, quantity, copiedStyle) {
      if (!this.styles) {
        this.styles = {};
      }
      const currentLineStyles = this.styles[lineIndex],
        currentLineStylesCloned = currentLineStyles ? _objectSpread2({}, currentLineStyles) : {};
      quantity || (quantity = 1);
      // shift all char styles by quantity forward
      // 0,1,2,3 -> (charIndex=2) -> 0,1,3,4 -> (insert 2) -> 0,1,2,3,4
      for (const index in currentLineStylesCloned) {
        const numericIndex = parseInt(index, 10);
        if (numericIndex >= charIndex) {
          currentLineStyles[numericIndex + quantity] = currentLineStylesCloned[numericIndex];
          // only delete the style if there was nothing moved there
          if (!currentLineStylesCloned[numericIndex - quantity]) {
            delete currentLineStyles[numericIndex];
          }
        }
      }
      this._forceClearCache = true;
      if (copiedStyle) {
        while (quantity--) {
          if (!Object.keys(copiedStyle[quantity]).length) {
            continue;
          }
          if (!this.styles[lineIndex]) {
            this.styles[lineIndex] = {};
          }
          this.styles[lineIndex][charIndex + quantity] = _objectSpread2({}, copiedStyle[quantity]);
        }
        return;
      }
      if (!currentLineStyles) {
        return;
      }
      const newStyle = currentLineStyles[charIndex ? charIndex - 1 : 1];
      while (newStyle && quantity--) {
        this.styles[lineIndex][charIndex + quantity] = _objectSpread2({}, newStyle);
      }
    }

    /**
     * Inserts style object(s)
     * @param {Array} insertedText Characters at the location where style is inserted
     * @param {Number} start cursor index for inserting style
     * @param {Array} [copiedStyle] array of style objects to insert.
     */
    insertNewStyleBlock(insertedText, start, copiedStyle) {
      const cursorLoc = this.get2DCursorLocation(start, true),
        addedLines = [0];
      let linesLength = 0;
      // get an array of how many char per lines are being added.
      for (let i = 0; i < insertedText.length; i++) {
        if (insertedText[i] === '\n') {
          linesLength++;
          addedLines[linesLength] = 0;
        } else {
          addedLines[linesLength]++;
        }
      }
      // for the first line copy the style from the current char position.
      if (addedLines[0] > 0) {
        this.insertCharStyleObject(cursorLoc.lineIndex, cursorLoc.charIndex, addedLines[0], copiedStyle);
        copiedStyle = copiedStyle && copiedStyle.slice(addedLines[0] + 1);
      }
      linesLength && this.insertNewlineStyleObject(cursorLoc.lineIndex, cursorLoc.charIndex + addedLines[0], linesLength);
      let i;
      for (i = 1; i < linesLength; i++) {
        if (addedLines[i] > 0) {
          this.insertCharStyleObject(cursorLoc.lineIndex + i, 0, addedLines[i], copiedStyle);
        } else if (copiedStyle) {
          // this test is required in order to close #6841
          // when a pasted buffer begins with a newline then
          // this.styles[cursorLoc.lineIndex + i] and copiedStyle[0]
          // may be undefined for some reason
          if (this.styles[cursorLoc.lineIndex + i] && copiedStyle[0]) {
            this.styles[cursorLoc.lineIndex + i][0] = copiedStyle[0];
          }
        }
        copiedStyle = copiedStyle && copiedStyle.slice(addedLines[i] + 1);
      }
      if (addedLines[i] > 0) {
        this.insertCharStyleObject(cursorLoc.lineIndex + i, 0, addedLines[i], copiedStyle);
      }
    }

    /**
     * Removes characters from start/end
     * start/end ar per grapheme position in _text array.
     *
     * @param {Number} start
     * @param {Number} end default to start + 1
     */
    removeChars(start) {
      let end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : start + 1;
      this.removeStyleFromTo(start, end);
      this._text.splice(start, end - start);
      this.text = this._text.join('');
      this.set('dirty', true);
      this.initDimensions();
      this.setCoords();
      this._removeExtraneousStyles();
    }

    /**
     * insert characters at start position, before start position.
     * start  equal 1 it means the text get inserted between actual grapheme 0 and 1
     * if style array is provided, it must be as the same length of text in graphemes
     * if end is provided and is bigger than start, old text is replaced.
     * start/end ar per grapheme position in _text array.
     *
     * @param {String} text text to insert
     * @param {Array} style array of style objects
     * @param {Number} start
     * @param {Number} end default to start + 1
     */
    insertChars(text, style, start) {
      let end = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : start;
      if (end > start) {
        this.removeStyleFromTo(start, end);
      }
      const graphemes = this.graphemeSplit(text);
      this.insertNewStyleBlock(graphemes, start, style);
      this._text = [...this._text.slice(0, start), ...graphemes, ...this._text.slice(end)];
      this.text = this._text.join('');
      this.set('dirty', true);
      this.initDimensions();
      this.setCoords();
      this._removeExtraneousStyles();
    }

    /**
     * Set the selectionStart and selectionEnd according to the new position of cursor
     * mimic the key - mouse navigation when shift is pressed.
     */
    setSelectionStartEndWithShift(start, end, newSelection) {
      if (newSelection <= start) {
        if (end === start) {
          this._selectionDirection = LEFT;
        } else if (this._selectionDirection === RIGHT) {
          this._selectionDirection = LEFT;
          this.selectionEnd = start;
        }
        this.selectionStart = newSelection;
      } else if (newSelection > start && newSelection < end) {
        if (this._selectionDirection === RIGHT) {
          this.selectionEnd = newSelection;
        } else {
          this.selectionStart = newSelection;
        }
      } else {
        // newSelection is > selection start and end
        if (end === start) {
          this._selectionDirection = RIGHT;
        } else if (this._selectionDirection === LEFT) {
          this._selectionDirection = RIGHT;
          this.selectionStart = end;
        }
        this.selectionEnd = newSelection;
      }
    }
  }

  class ITextKeyBehavior extends ITextBehavior {
    /**
     * For functionalities on keyDown
     * Map a special key to a function of the instance/prototype
     * If you need different behavior for ESC or TAB or arrows, you have to change
     * this map setting the name of a function that you build on the IText or
     * your prototype.
     * the map change will affect all Instances unless you need for only some text Instances
     * in that case you have to clone this object and assign your Instance.
     * this.keysMap = Object.assign({}, this.keysMap);
     * The function must be in IText.prototype.myFunction And will receive event as args[0]
     */

    /**
     * For functionalities on keyUp + ctrl || cmd
     */

    /**
     * For functionalities on keyDown + ctrl || cmd
     */

    /**
     * DOM container to append the hiddenTextarea.
     * An alternative to attaching to the document.body.
     * Useful to reduce laggish redraw of the full document.body tree and
     * also with modals event capturing that won't let the textarea take focus.
     * @type HTMLElement
     * @default
     */

    /**
     * Initializes hidden textarea (needed to bring up keyboard in iOS)
     */
    initHiddenTextarea() {
      const doc = this.canvas && getDocumentFromElement(this.canvas.getElement()) || getFabricDocument();
      const textarea = doc.createElement('textarea');
      Object.entries({
        autocapitalize: 'off',
        autocorrect: 'off',
        autocomplete: 'off',
        spellcheck: 'false',
        'data-fabric': 'textarea',
        wrap: 'off'
      }).map(_ref => {
        let [attribute, value] = _ref;
        return textarea.setAttribute(attribute, value);
      });
      const {
        top,
        left,
        fontSize
      } = this._calcTextareaPosition();
      // line-height: 1px; was removed from the style to fix this:
      // https://bugs.chromium.org/p/chromium/issues/detail?id=870966
      textarea.style.cssText = "position: absolute; top: ".concat(top, "; left: ").concat(left, "; z-index: -999; opacity: 0; width: 1px; height: 1px; font-size: 1px; padding-top: ").concat(fontSize, ";");
      (this.hiddenTextareaContainer || doc.body).appendChild(textarea);
      Object.entries({
        blur: 'blur',
        keydown: 'onKeyDown',
        keyup: 'onKeyUp',
        input: 'onInput',
        copy: 'copy',
        cut: 'copy',
        paste: 'paste',
        compositionstart: 'onCompositionStart',
        compositionupdate: 'onCompositionUpdate',
        compositionend: 'onCompositionEnd'
      }).map(_ref2 => {
        let [eventName, handler] = _ref2;
        return textarea.addEventListener(eventName, this[handler].bind(this));
      });
      this.hiddenTextarea = textarea;
    }

    /**
     * Override this method to customize cursor behavior on textbox blur
     */
    blur() {
      this.abortCursorAnimation();
    }

    /**
     * Handles keydown event
     * only used for arrows and combination of modifier keys.
     * @param {KeyboardEvent} e Event object
     */
    onKeyDown(e) {
      if (!this.isEditing) {
        return;
      }
      const keyMap = this.direction === 'rtl' ? this.keysMapRtl : this.keysMap;
      if (e.keyCode in keyMap) {
        this[keyMap[e.keyCode]](e);
      } else if (e.keyCode in this.ctrlKeysMapDown && (e.ctrlKey || e.metaKey)) {
        this[this.ctrlKeysMapDown[e.keyCode]](e);
      } else {
        return;
      }
      e.stopImmediatePropagation();
      e.preventDefault();
      if (e.keyCode >= 33 && e.keyCode <= 40) {
        // if i press an arrow key just update selection
        this.inCompositionMode = false;
        this.clearContextTop();
        this.renderCursorOrSelection();
      } else {
        this.canvas && this.canvas.requestRenderAll();
      }
    }

    /**
     * Handles keyup event
     * We handle KeyUp because ie11 and edge have difficulties copy/pasting
     * if a copy/cut event fired, keyup is dismissed
     * @param {KeyboardEvent} e Event object
     */
    onKeyUp(e) {
      if (!this.isEditing || this._copyDone || this.inCompositionMode) {
        this._copyDone = false;
        return;
      }
      if (e.keyCode in this.ctrlKeysMapUp && (e.ctrlKey || e.metaKey)) {
        this[this.ctrlKeysMapUp[e.keyCode]](e);
      } else {
        return;
      }
      e.stopImmediatePropagation();
      e.preventDefault();
      this.canvas && this.canvas.requestRenderAll();
    }

    /**
     * Handles onInput event
     * @param {Event} e Event object
     */
    onInput(e) {
      const fromPaste = this.fromPaste;
      const {
        value,
        selectionStart,
        selectionEnd
      } = this.hiddenTextarea;
      this.fromPaste = false;
      e && e.stopPropagation();
      if (!this.isEditing) {
        return;
      }
      const updateAndFire = () => {
        this.updateFromTextArea();
        this.fire(CHANGED);
        if (this.canvas) {
          this.canvas.fire('text:changed', {
            target: this
          });
          this.canvas.requestRenderAll();
        }
      };
      if (this.hiddenTextarea.value === '') {
        this.styles = {};
        updateAndFire();
        return;
      }
      // decisions about style changes.
      const nextText = this._splitTextIntoLines(value).graphemeText,
        charCount = this._text.length,
        nextCharCount = nextText.length,
        _selectionStart = this.selectionStart,
        _selectionEnd = this.selectionEnd,
        selection = _selectionStart !== _selectionEnd;
      let copiedStyle,
        removedText,
        charDiff = nextCharCount - charCount,
        removeFrom,
        removeTo;
      const textareaSelection = this.fromStringToGraphemeSelection(selectionStart, selectionEnd, value);
      const backDelete = _selectionStart > textareaSelection.selectionStart;
      if (selection) {
        removedText = this._text.slice(_selectionStart, _selectionEnd);
        charDiff += _selectionEnd - _selectionStart;
      } else if (nextCharCount < charCount) {
        if (backDelete) {
          removedText = this._text.slice(_selectionEnd + charDiff, _selectionEnd);
        } else {
          removedText = this._text.slice(_selectionStart, _selectionStart - charDiff);
        }
      }
      const insertedText = nextText.slice(textareaSelection.selectionEnd - charDiff, textareaSelection.selectionEnd);
      if (removedText && removedText.length) {
        if (insertedText.length) {
          // let's copy some style before deleting.
          // we want to copy the style before the cursor OR the style at the cursor if selection
          // is bigger than 0.
          copiedStyle = this.getSelectionStyles(_selectionStart, _selectionStart + 1, false);
          // now duplicate the style one for each inserted text.
          copiedStyle = insertedText.map(() =>
          // this return an array of references, but that is fine since we are
          // copying the style later.
          copiedStyle[0]);
        }
        if (selection) {
          removeFrom = _selectionStart;
          removeTo = _selectionEnd;
        } else if (backDelete) {
          // detect differences between forwardDelete and backDelete
          removeFrom = _selectionEnd - removedText.length;
          removeTo = _selectionEnd;
        } else {
          removeFrom = _selectionEnd;
          removeTo = _selectionEnd + removedText.length;
        }
        this.removeStyleFromTo(removeFrom, removeTo);
      }
      if (insertedText.length) {
        const {
          copyPasteData
        } = getEnv();
        if (fromPaste && insertedText.join('') === copyPasteData.copiedText && !config.disableStyleCopyPaste) {
          copiedStyle = copyPasteData.copiedTextStyle;
        }
        this.insertNewStyleBlock(insertedText, _selectionStart, copiedStyle);
      }
      updateAndFire();
    }

    /**
     * Composition start
     */
    onCompositionStart() {
      this.inCompositionMode = true;
    }

    /**
     * Composition end
     */
    onCompositionEnd() {
      this.inCompositionMode = false;
    }
    onCompositionUpdate(_ref3) {
      let {
        target
      } = _ref3;
      const {
        selectionStart,
        selectionEnd
      } = target;
      this.compositionStart = selectionStart;
      this.compositionEnd = selectionEnd;
      this.updateTextareaPosition();
    }

    /**
     * Copies selected text
     */
    copy() {
      if (this.selectionStart === this.selectionEnd) {
        //do not cut-copy if no selection
        return;
      }
      const {
        copyPasteData
      } = getEnv();
      copyPasteData.copiedText = this.getSelectedText();
      if (!config.disableStyleCopyPaste) {
        copyPasteData.copiedTextStyle = this.getSelectionStyles(this.selectionStart, this.selectionEnd, true);
      } else {
        copyPasteData.copiedTextStyle = undefined;
      }
      this._copyDone = true;
    }

    /**
     * Pastes text
     */
    paste() {
      this.fromPaste = true;
    }

    /**
     * Finds the width in pixels before the cursor on the same line
     * @private
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @return {Number} widthBeforeCursor width before cursor
     */
    _getWidthBeforeCursor(lineIndex, charIndex) {
      let widthBeforeCursor = this._getLineLeftOffset(lineIndex),
        bound;
      if (charIndex > 0) {
        bound = this.__charBounds[lineIndex][charIndex - 1];
        widthBeforeCursor += bound.left + bound.width;
      }
      return widthBeforeCursor;
    }

    /**
     * Gets start offset of a selection
     * @param {KeyboardEvent} e Event object
     * @param {Boolean} isRight
     * @return {Number}
     */
    getDownCursorOffset(e, isRight) {
      const selectionProp = this._getSelectionForOffset(e, isRight),
        cursorLocation = this.get2DCursorLocation(selectionProp),
        lineIndex = cursorLocation.lineIndex;
      // if on last line, down cursor goes to end of line
      if (lineIndex === this._textLines.length - 1 || e.metaKey || e.keyCode === 34) {
        // move to the end of a text
        return this._text.length - selectionProp;
      }
      const charIndex = cursorLocation.charIndex,
        widthBeforeCursor = this._getWidthBeforeCursor(lineIndex, charIndex),
        indexOnOtherLine = this._getIndexOnLine(lineIndex + 1, widthBeforeCursor),
        textAfterCursor = this._textLines[lineIndex].slice(charIndex);
      return textAfterCursor.length + indexOnOtherLine + 1 + this.missingNewlineOffset(lineIndex);
    }

    /**
     * private
     * Helps finding if the offset should be counted from Start or End
     * @param {KeyboardEvent} e Event object
     * @param {Boolean} isRight
     * @return {Number}
     */
    _getSelectionForOffset(e, isRight) {
      if (e.shiftKey && this.selectionStart !== this.selectionEnd && isRight) {
        return this.selectionEnd;
      } else {
        return this.selectionStart;
      }
    }

    /**
     * @param {KeyboardEvent} e Event object
     * @param {Boolean} isRight
     * @return {Number}
     */
    getUpCursorOffset(e, isRight) {
      const selectionProp = this._getSelectionForOffset(e, isRight),
        cursorLocation = this.get2DCursorLocation(selectionProp),
        lineIndex = cursorLocation.lineIndex;
      if (lineIndex === 0 || e.metaKey || e.keyCode === 33) {
        // if on first line, up cursor goes to start of line
        return -selectionProp;
      }
      const charIndex = cursorLocation.charIndex,
        widthBeforeCursor = this._getWidthBeforeCursor(lineIndex, charIndex),
        indexOnOtherLine = this._getIndexOnLine(lineIndex - 1, widthBeforeCursor),
        textBeforeCursor = this._textLines[lineIndex].slice(0, charIndex),
        missingNewlineOffset = this.missingNewlineOffset(lineIndex - 1);
      // return a negative offset
      return -this._textLines[lineIndex - 1].length + indexOnOtherLine - textBeforeCursor.length + (1 - missingNewlineOffset);
    }

    /**
     * for a given width it founds the matching character.
     * @private
     */
    _getIndexOnLine(lineIndex, width) {
      const line = this._textLines[lineIndex],
        lineLeftOffset = this._getLineLeftOffset(lineIndex);
      let widthOfCharsOnLine = lineLeftOffset,
        indexOnLine = 0,
        charWidth,
        foundMatch;
      for (let j = 0, jlen = line.length; j < jlen; j++) {
        charWidth = this.__charBounds[lineIndex][j].width;
        widthOfCharsOnLine += charWidth;
        if (widthOfCharsOnLine > width) {
          foundMatch = true;
          const leftEdge = widthOfCharsOnLine - charWidth,
            rightEdge = widthOfCharsOnLine,
            offsetFromLeftEdge = Math.abs(leftEdge - width),
            offsetFromRightEdge = Math.abs(rightEdge - width);
          indexOnLine = offsetFromRightEdge < offsetFromLeftEdge ? j : j - 1;
          break;
        }
      }

      // reached end
      if (!foundMatch) {
        indexOnLine = line.length - 1;
      }
      return indexOnLine;
    }

    /**
     * Moves cursor down
     * @param {KeyboardEvent} e Event object
     */
    moveCursorDown(e) {
      if (this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length) {
        return;
      }
      this._moveCursorUpOrDown('Down', e);
    }

    /**
     * Moves cursor up
     * @param {KeyboardEvent} e Event object
     */
    moveCursorUp(e) {
      if (this.selectionStart === 0 && this.selectionEnd === 0) {
        return;
      }
      this._moveCursorUpOrDown('Up', e);
    }

    /**
     * Moves cursor up or down, fires the events
     * @param {String} direction 'Up' or 'Down'
     * @param {KeyboardEvent} e Event object
     */
    _moveCursorUpOrDown(direction, e) {
      const offset = this["get".concat(direction, "CursorOffset")](e, this._selectionDirection === RIGHT);
      if (e.shiftKey) {
        this.moveCursorWithShift(offset);
      } else {
        this.moveCursorWithoutShift(offset);
      }
      if (offset !== 0) {
        const max = this.text.length;
        this.selectionStart = capValue(0, this.selectionStart, max);
        this.selectionEnd = capValue(0, this.selectionEnd, max);
        // TODO fix: abort and init should be an alternative depending
        // on selectionStart/End being equal or different
        this.abortCursorAnimation();
        this.initDelayedCursor();
        this._fireSelectionChanged();
        this._updateTextarea();
      }
    }

    /**
     * Moves cursor with shift
     * @param {Number} offset
     */
    moveCursorWithShift(offset) {
      const newSelection = this._selectionDirection === LEFT ? this.selectionStart + offset : this.selectionEnd + offset;
      this.setSelectionStartEndWithShift(this.selectionStart, this.selectionEnd, newSelection);
      return offset !== 0;
    }

    /**
     * Moves cursor up without shift
     * @param {Number} offset
     */
    moveCursorWithoutShift(offset) {
      if (offset < 0) {
        this.selectionStart += offset;
        this.selectionEnd = this.selectionStart;
      } else {
        this.selectionEnd += offset;
        this.selectionStart = this.selectionEnd;
      }
      return offset !== 0;
    }

    /**
     * Moves cursor left
     * @param {KeyboardEvent} e Event object
     */
    moveCursorLeft(e) {
      if (this.selectionStart === 0 && this.selectionEnd === 0) {
        return;
      }
      this._moveCursorLeftOrRight('Left', e);
    }

    /**
     * @private
     * @return {Boolean} true if a change happened
     *
     * @todo refactor not to use method name composition
     */
    _move(e, prop, direction) {
      let newValue;
      if (e.altKey) {
        newValue = this["findWordBoundary".concat(direction)](this[prop]);
      } else if (e.metaKey || e.keyCode === 35 || e.keyCode === 36) {
        newValue = this["findLineBoundary".concat(direction)](this[prop]);
      } else {
        this[prop] += direction === 'Left' ? -1 : 1;
        return true;
      }
      if (typeof newValue !== 'undefined' && this[prop] !== newValue) {
        this[prop] = newValue;
        return true;
      }
      return false;
    }

    /**
     * @private
     */
    _moveLeft(e, prop) {
      return this._move(e, prop, 'Left');
    }

    /**
     * @private
     */
    _moveRight(e, prop) {
      return this._move(e, prop, 'Right');
    }

    /**
     * Moves cursor left without keeping selection
     * @param {KeyboardEvent} e
     */
    moveCursorLeftWithoutShift(e) {
      let change = true;
      this._selectionDirection = LEFT;

      // only move cursor when there is no selection,
      // otherwise we discard it, and leave cursor on same place
      if (this.selectionEnd === this.selectionStart && this.selectionStart !== 0) {
        change = this._moveLeft(e, 'selectionStart');
      }
      this.selectionEnd = this.selectionStart;
      return change;
    }

    /**
     * Moves cursor left while keeping selection
     * @param {KeyboardEvent} e
     */
    moveCursorLeftWithShift(e) {
      if (this._selectionDirection === RIGHT && this.selectionStart !== this.selectionEnd) {
        return this._moveLeft(e, 'selectionEnd');
      } else if (this.selectionStart !== 0) {
        this._selectionDirection = LEFT;
        return this._moveLeft(e, 'selectionStart');
      }
    }

    /**
     * Moves cursor right
     * @param {KeyboardEvent} e Event object
     */
    moveCursorRight(e) {
      if (this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length) {
        return;
      }
      this._moveCursorLeftOrRight('Right', e);
    }

    /**
     * Moves cursor right or Left, fires event
     * @param {String} direction 'Left', 'Right'
     * @param {KeyboardEvent} e Event object
     */
    _moveCursorLeftOrRight(direction, e) {
      const actionName = "moveCursor".concat(direction).concat(e.shiftKey ? 'WithShift' : 'WithoutShift');
      this._currentCursorOpacity = 1;
      if (this[actionName](e)) {
        // TODO fix: abort and init should be an alternative depending
        // on selectionStart/End being equal or different
        this.abortCursorAnimation();
        this.initDelayedCursor();
        this._fireSelectionChanged();
        this._updateTextarea();
      }
    }

    /**
     * Moves cursor right while keeping selection
     * @param {KeyboardEvent} e
     */
    moveCursorRightWithShift(e) {
      if (this._selectionDirection === LEFT && this.selectionStart !== this.selectionEnd) {
        return this._moveRight(e, 'selectionStart');
      } else if (this.selectionEnd !== this._text.length) {
        this._selectionDirection = RIGHT;
        return this._moveRight(e, 'selectionEnd');
      }
    }

    /**
     * Moves cursor right without keeping selection
     * @param {KeyboardEvent} e Event object
     */
    moveCursorRightWithoutShift(e) {
      let changed = true;
      this._selectionDirection = RIGHT;
      if (this.selectionStart === this.selectionEnd) {
        changed = this._moveRight(e, 'selectionStart');
        this.selectionEnd = this.selectionStart;
      } else {
        this.selectionStart = this.selectionEnd;
      }
      return changed;
    }
  }

  /**
   * `LEFT_CLICK === 0`
   */
  const notALeftClick = e => !!e.button;
  class ITextClickBehavior extends ITextKeyBehavior {
    constructor() {
      super(...arguments);
      _defineProperty(this, "draggableTextDelegate", void 0);
    }
    initBehavior() {
      // Initializes event handlers related to cursor or selection
      this.on('mousedown', this._mouseDownHandler);
      this.on('mouseup', this.mouseUpHandler);
      this.on('mousedblclick', this.doubleClickHandler);
      this.on('mousetripleclick', this.tripleClickHandler);
      this.draggableTextDelegate = new DraggableTextDelegate(this);
      super.initBehavior();
    }

    /**
     * If this method returns true a mouse move operation over a text selection
     * will not prevent the native mouse event allowing the browser to start a drag operation.
     * shouldStartDragging can be read 'do not prevent default for mouse move event'
     * To prevent drag and drop between objects both shouldStartDragging and onDragStart should return false
     * @returns
     */
    shouldStartDragging() {
      return this.draggableTextDelegate.isActive();
    }

    /**
     * @public override this method to control whether instance should/shouldn't become a drag source,
     * @see also {@link DraggableTextDelegate#isActive}
     * To prevent drag and drop between objects both shouldStartDragging and onDragStart should return false
     * @returns {boolean} should handle event
     */
    onDragStart(e) {
      return this.draggableTextDelegate.onDragStart(e);
    }

    /**
     * @public override this method to control whether instance should/shouldn't become a drop target
     */
    canDrop(e) {
      return this.draggableTextDelegate.canDrop(e);
    }

    /**
     * Default handler for double click, select a word
     */
    doubleClickHandler(options) {
      if (!this.isEditing) {
        return;
      }
      this.selectWord(this.getSelectionStartFromPointer(options.e));
      this.renderCursorOrSelection();
    }

    /**
     * Default handler for triple click, select a line
     */
    tripleClickHandler(options) {
      if (!this.isEditing) {
        return;
      }
      this.selectLine(this.getSelectionStartFromPointer(options.e));
      this.renderCursorOrSelection();
    }

    /**
     * Default event handler for the basic functionalities needed on _mouseDown
     * can be overridden to do something different.
     * Scope of this implementation is: find the click position, set selectionStart
     * find selectionEnd, initialize the drawing of either cursor or selection area
     * initializing a mousedDown on a text area will cancel fabricjs knowledge of
     * current compositionMode. It will be set to false.
     */
    _mouseDownHandler(_ref) {
      let {
        e,
        alreadySelected
      } = _ref;
      if (!this.canvas || !this.editable || notALeftClick(e) || this.getActiveControl()) {
        return;
      }
      if (this.draggableTextDelegate.start(e)) {
        return;
      }
      this.canvas.textEditingManager.register(this);
      if (alreadySelected) {
        this.inCompositionMode = false;
        this.setCursorByClick(e);
      }
      if (this.isEditing) {
        this.__selectionStartOnMouseDown = this.selectionStart;
        if (this.selectionStart === this.selectionEnd) {
          this.abortCursorAnimation();
        }
        this.renderCursorOrSelection();
      }
      this.selected || (this.selected = alreadySelected || this.isEditing);
    }

    /**
     * standard handler for mouse up, overridable
     * @private
     */
    mouseUpHandler(_ref2) {
      let {
        e,
        transform
      } = _ref2;
      const didDrag = this.draggableTextDelegate.end(e);
      if (this.canvas) {
        this.canvas.textEditingManager.unregister(this);
        const activeObject = this.canvas._activeObject;
        if (activeObject && activeObject !== this) {
          // avoid running this logic when there is an active object
          // this because is possible with shift click and fast clicks,
          // to rapidly deselect and reselect this object and trigger an enterEdit
          return;
        }
      }
      if (!this.editable || this.group && !this.group.interactive || transform && transform.actionPerformed || notALeftClick(e) || didDrag) {
        return;
      }
      if (this.selected && !this.getActiveControl()) {
        this.enterEditing(e);
        if (this.selectionStart === this.selectionEnd) {
          this.initDelayedCursor(true);
        } else {
          this.renderCursorOrSelection();
        }
      }
    }

    /**
     * Changes cursor location in a text depending on passed pointer (x/y) object
     * @param {TPointerEvent} e Event object
     */
    setCursorByClick(e) {
      const newSelection = this.getSelectionStartFromPointer(e),
        start = this.selectionStart,
        end = this.selectionEnd;
      if (e.shiftKey) {
        this.setSelectionStartEndWithShift(start, end, newSelection);
      } else {
        this.selectionStart = newSelection;
        this.selectionEnd = newSelection;
      }
      if (this.isEditing) {
        this._fireSelectionChanged();
        this._updateTextarea();
      }
    }

    /**
     * Returns index of a character corresponding to where an object was clicked
     * @param {TPointerEvent} e Event object
     * @return {Number} Index of a character
     */
    getSelectionStartFromPointer(e) {
      const mouseOffset = this.canvas.getScenePoint(e).transform(invertTransform(this.calcTransformMatrix())).add(new Point(-this._getLeftOffset(), -this._getTopOffset()));
      let height = 0,
        charIndex = 0,
        lineIndex = 0;
      for (let i = 0; i < this._textLines.length; i++) {
        if (height <= mouseOffset.y) {
          height += this.getHeightOfLine(i);
          lineIndex = i;
          if (i > 0) {
            charIndex += this._textLines[i - 1].length + this.missingNewlineOffset(i - 1);
          }
        } else {
          break;
        }
      }
      const lineLeftOffset = Math.abs(this._getLineLeftOffset(lineIndex));
      let width = lineLeftOffset;
      const charLength = this._textLines[lineIndex].length;
      const chars = this.__charBounds[lineIndex];
      for (let j = 0; j < charLength; j++) {
        // i removed something about flipX here, check.
        const charWidth = chars[j].kernedWidth;
        const widthAfter = width + charWidth;
        if (mouseOffset.x <= widthAfter) {
          // if the pointer is closer to the end of the char we increment charIndex
          // in order to position the cursor after the char
          if (Math.abs(mouseOffset.x - widthAfter) <= Math.abs(mouseOffset.x - width)) {
            charIndex++;
          }
          break;
        }
        width = widthAfter;
        charIndex++;
      }
      return Math.min(
      // if object is horizontally flipped, mirror cursor location from the end
      this.flipX ? charLength - charIndex : charIndex, this._text.length);
    }
  }

  const MOVE_CURSOR_UP = 'moveCursorUp';
  const MOVE_CURSOR_DOWN = 'moveCursorDown';
  const MOVE_CURSOR_LEFT = 'moveCursorLeft';
  const MOVE_CURSOR_RIGHT = 'moveCursorRight';
  const EXIT_EDITING = 'exitEditing';

  // @TODO look into import { Key } from 'ts-key-enum';
  // and transition from keyCode to Key
  // also reduce string duplication
  const keysMap = {
    9: EXIT_EDITING,
    27: EXIT_EDITING,
    33: MOVE_CURSOR_UP,
    34: MOVE_CURSOR_DOWN,
    35: MOVE_CURSOR_RIGHT,
    36: MOVE_CURSOR_LEFT,
    37: MOVE_CURSOR_LEFT,
    38: MOVE_CURSOR_UP,
    39: MOVE_CURSOR_RIGHT,
    40: MOVE_CURSOR_DOWN
  };
  const keysMapRtl = {
    9: EXIT_EDITING,
    27: EXIT_EDITING,
    33: MOVE_CURSOR_UP,
    34: MOVE_CURSOR_DOWN,
    35: MOVE_CURSOR_LEFT,
    36: MOVE_CURSOR_RIGHT,
    37: MOVE_CURSOR_RIGHT,
    38: MOVE_CURSOR_UP,
    39: MOVE_CURSOR_LEFT,
    40: MOVE_CURSOR_DOWN
  };

  /**
   * For functionalities on keyUp + ctrl || cmd
   */
  const ctrlKeysMapUp = {
    67: 'copy',
    // there was a reason this wasn't deleted. for now leave it here
    88: 'cut'
  };

  /**
   * For functionalities on keyDown + ctrl || cmd
   */
  const ctrlKeysMapDown = {
    65: 'cmdAll'
  };

  /**
   * Set the transform of the passed context to the same of a specific Canvas or StaticCanvas.
   * setTransform is used since this utility will RESET the ctx transform to the basic value
   * of retina scaling and viewport transform
   * It is not meant to be added to other transforms, it is used internally to preapre canvases to draw
   * @param ctx
   * @param canvas
   */
  const applyCanvasTransform = (ctx, canvas) => {
    const scale = canvas.getRetinaScaling();
    ctx.setTransform(scale, 0, 0, scale, 0, 0);
    const v = canvas.viewportTransform;
    ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
  };

  // Declare IText protected properties to workaround TS
  const protectedDefaultValues = {
    _selectionDirection: null,
    _reSpace: /\s|\r?\n/,
    inCompositionMode: false
  };
  const iTextDefaultValues = _objectSpread2({
    selectionStart: 0,
    selectionEnd: 0,
    selectionColor: 'rgba(17,119,255,0.3)',
    isEditing: false,
    editable: true,
    editingBorderColor: 'rgba(102,153,255,0.25)',
    cursorWidth: 2,
    cursorColor: '',
    cursorDelay: 1000,
    cursorDuration: 600,
    caching: true,
    hiddenTextareaContainer: null,
    keysMap,
    keysMapRtl,
    ctrlKeysMapDown,
    ctrlKeysMapUp
  }, protectedDefaultValues);

  // @TODO this is not complete

  /**
   * @fires changed
   * @fires selection:changed
   * @fires editing:entered
   * @fires editing:exited
   * @fires dragstart
   * @fires drag drag event firing on the drag source
   * @fires dragend
   * @fires copy
   * @fires cut
   * @fires paste
   *
   * #### Supported key combinations
   * ```
   *   Move cursor:                    left, right, up, down
   *   Select character:               shift + left, shift + right
   *   Select text vertically:         shift + up, shift + down
   *   Move cursor by word:            alt + left, alt + right
   *   Select words:                   shift + alt + left, shift + alt + right
   *   Move cursor to line start/end:  cmd + left, cmd + right or home, end
   *   Select till start/end of line:  cmd + shift + left, cmd + shift + right or shift + home, shift + end
   *   Jump to start/end of text:      cmd + up, cmd + down
   *   Select till start/end of text:  cmd + shift + up, cmd + shift + down or shift + pgUp, shift + pgDown
   *   Delete character:               backspace
   *   Delete word:                    alt + backspace
   *   Delete line:                    cmd + backspace
   *   Forward delete:                 delete
   *   Copy text:                      ctrl/cmd + c
   *   Paste text:                     ctrl/cmd + v
   *   Cut text:                       ctrl/cmd + x
   *   Select entire text:             ctrl/cmd + a
   *   Quit editing                    tab or esc
   * ```
   *
   * #### Supported mouse/touch combination
   * ```
   *   Position cursor:                click/touch
   *   Create selection:               click/touch & drag
   *   Create selection:               click & shift + click
   *   Select word:                    double click
   *   Select line:                    triple click
   * ```
   */
  class IText extends ITextClickBehavior {
    static getDefaults() {
      return _objectSpread2(_objectSpread2({}, super.getDefaults()), IText.ownDefaults);
    }
    get type() {
      const type = super.type;
      // backward compatibility
      return type === 'itext' ? 'i-text' : type;
    }

    /**
     * Constructor
     * @param {String} text Text string
     * @param {Object} [options] Options object
     */
    constructor(text, options) {
      super(text, _objectSpread2(_objectSpread2({}, IText.ownDefaults), options));
      this.initBehavior();
    }

    /**
     * While editing handle differently
     * @private
     * @param {string} key
     * @param {*} value
     */
    _set(key, value) {
      if (this.isEditing && this._savedProps && key in this._savedProps) {
        // @ts-expect-error irritating TS
        this._savedProps[key] = value;
        return this;
      }
      if (key === 'canvas') {
        this.canvas instanceof Canvas && this.canvas.textEditingManager.remove(this);
        value instanceof Canvas && value.textEditingManager.add(this);
      }
      return super._set(key, value);
    }

    /**
     * Sets selection start (left boundary of a selection)
     * @param {Number} index Index to set selection start to
     */
    setSelectionStart(index) {
      index = Math.max(index, 0);
      this._updateAndFire('selectionStart', index);
    }

    /**
     * Sets selection end (right boundary of a selection)
     * @param {Number} index Index to set selection end to
     */
    setSelectionEnd(index) {
      index = Math.min(index, this.text.length);
      this._updateAndFire('selectionEnd', index);
    }

    /**
     * @private
     * @param {String} property 'selectionStart' or 'selectionEnd'
     * @param {Number} index new position of property
     */
    _updateAndFire(property, index) {
      if (this[property] !== index) {
        this._fireSelectionChanged();
        this[property] = index;
      }
      this._updateTextarea();
    }

    /**
     * Fires the even of selection changed
     * @private
     */
    _fireSelectionChanged() {
      this.fire('selection:changed');
      this.canvas && this.canvas.fire('text:selection:changed', {
        target: this
      });
    }

    /**
     * Initialize text dimensions. Render all text on given context
     * or on a offscreen canvas to get the text width with measureText.
     * Updates this.width and this.height with the proper values.
     * Does not return dimensions.
     * @private
     */
    initDimensions() {
      this.isEditing && this.initDelayedCursor();
      super.initDimensions();
    }

    /**
     * Gets style of a current selection/cursor (at the start position)
     * if startIndex or endIndex are not provided, selectionStart or selectionEnd will be used.
     * @param {Number} startIndex Start index to get styles at
     * @param {Number} endIndex End index to get styles at, if not specified selectionEnd or startIndex + 1
     * @param {Boolean} [complete] get full style or not
     * @return {Array} styles an array with one, zero or more Style objects
     */
    getSelectionStyles() {
      let startIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectionStart || 0;
      let endIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selectionEnd;
      let complete = arguments.length > 2 ? arguments[2] : undefined;
      return super.getSelectionStyles(startIndex, endIndex, complete);
    }

    /**
     * Sets style of a current selection, if no selection exist, do not set anything.
     * @param {Object} [styles] Styles object
     * @param {Number} [startIndex] Start index to get styles at
     * @param {Number} [endIndex] End index to get styles at, if not specified selectionEnd or startIndex + 1
     */
    setSelectionStyles(styles) {
      let startIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selectionStart || 0;
      let endIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.selectionEnd;
      return super.setSelectionStyles(styles, startIndex, endIndex);
    }

    /**
     * Returns 2d representation (lineIndex and charIndex) of cursor (or selection start)
     * @param {Number} [selectionStart] Optional index. When not given, current selectionStart is used.
     * @param {Boolean} [skipWrapping] consider the location for unwrapped lines. useful to manage styles.
     */
    get2DCursorLocation() {
      let selectionStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectionStart;
      let skipWrapping = arguments.length > 1 ? arguments[1] : undefined;
      return super.get2DCursorLocation(selectionStart, skipWrapping);
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    render(ctx) {
      super.render(ctx);
      // clear the cursorOffsetCache, so we ensure to calculate once per renderCursor
      // the correct position but not at every cursor animation.
      this.cursorOffsetCache = {};
      this.renderCursorOrSelection();
    }

    /**
     * @override block cursor/selection logic while rendering the exported canvas
     * @todo this workaround should be replaced with a more robust solution
     */
    toCanvasElement(options) {
      const isEditing = this.isEditing;
      this.isEditing = false;
      const canvas = super.toCanvasElement(options);
      this.isEditing = isEditing;
      return canvas;
    }

    /**
     * Renders cursor or selection (depending on what exists)
     * it does on the contextTop. If contextTop is not available, do nothing.
     */
    renderCursorOrSelection() {
      if (!this.isEditing || !this.canvas) {
        return;
      }
      const ctx = this.clearContextTop(true);
      if (!ctx) {
        return;
      }
      const boundaries = this._getCursorBoundaries();
      const ancestors = this.findAncestorsWithClipPath();
      const hasAncestorsWithClipping = ancestors.length > 0;
      let drawingCtx = ctx;
      let drawingCanvas = undefined;
      if (hasAncestorsWithClipping) {
        // we have some clipPath, we need to draw the selection on an intermediate layer.
        drawingCanvas = createCanvasElementFor(ctx.canvas);
        drawingCtx = drawingCanvas.getContext('2d');
        applyCanvasTransform(drawingCtx, this.canvas);
        const m = this.calcTransformMatrix();
        drawingCtx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
      }
      if (this.selectionStart === this.selectionEnd && !this.inCompositionMode) {
        this.renderCursor(drawingCtx, boundaries);
      } else {
        this.renderSelection(drawingCtx, boundaries);
      }
      if (hasAncestorsWithClipping) {
        // we need a neutral context.
        // this won't work for nested clippaths in which a clippath
        // has its own clippath
        for (const ancestor of ancestors) {
          const clipPath = ancestor.clipPath;
          const clippingCanvas = createCanvasElementFor(ctx.canvas);
          const clippingCtx = clippingCanvas.getContext('2d');
          applyCanvasTransform(clippingCtx, this.canvas);
          // position the ctx in the center of the outer ancestor
          if (!clipPath.absolutePositioned) {
            const m = ancestor.calcTransformMatrix();
            clippingCtx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
          }
          clipPath.transform(clippingCtx);
          // we assign an empty drawing context, we don't plan to have this working for nested clippaths for now
          clipPath.drawObject(clippingCtx, true, {});
          this.drawClipPathOnCache(drawingCtx, clipPath, clippingCanvas);
        }
      }
      if (hasAncestorsWithClipping) {
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.drawImage(drawingCanvas, 0, 0);
      }
      this.canvas.contextTopDirty = true;
      ctx.restore();
    }

    /**
     * Finds and returns an array of clip paths that are applied to the parent
     * group(s) of the current FabricObject instance. The object's hierarchy is
     * traversed upwards (from the current object towards the root of the canvas),
     * checking each parent object for the presence of a `clipPath` that is not
     * absolutely positioned.
     */
    findAncestorsWithClipPath() {
      const clipPathAncestors = [];
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      let obj = this;
      while (obj) {
        if (obj.clipPath) {
          clipPathAncestors.push(obj);
        }
        obj = obj.parent;
      }
      return clipPathAncestors;
    }

    /**
     * Returns cursor boundaries (left, top, leftOffset, topOffset)
     * left/top are left/top of entire text box
     * leftOffset/topOffset are offset from that left/top point of a text box
     * @private
     * @param {number} [index] index from start
     * @param {boolean} [skipCaching]
     */
    _getCursorBoundaries() {
      let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectionStart;
      let skipCaching = arguments.length > 1 ? arguments[1] : undefined;
      const left = this._getLeftOffset(),
        top = this._getTopOffset(),
        offsets = this._getCursorBoundariesOffsets(index, skipCaching);
      return {
        left: left,
        top: top,
        leftOffset: offsets.left,
        topOffset: offsets.top
      };
    }

    /**
     * Caches and returns cursor left/top offset relative to instance's center point
     * @private
     * @param {number} index index from start
     * @param {boolean} [skipCaching]
     */
    _getCursorBoundariesOffsets(index, skipCaching) {
      if (skipCaching) {
        return this.__getCursorBoundariesOffsets(index);
      }
      if (this.cursorOffsetCache && 'top' in this.cursorOffsetCache) {
        return this.cursorOffsetCache;
      }
      return this.cursorOffsetCache = this.__getCursorBoundariesOffsets(index);
    }

    /**
     * Calculates cursor left/top offset relative to instance's center point
     * @private
     * @param {number} index index from start
     */
    __getCursorBoundariesOffsets(index) {
      let topOffset = 0,
        leftOffset = 0;
      const {
        charIndex,
        lineIndex
      } = this.get2DCursorLocation(index);
      for (let i = 0; i < lineIndex; i++) {
        topOffset += this.getHeightOfLine(i);
      }
      const lineLeftOffset = this._getLineLeftOffset(lineIndex);
      const bound = this.__charBounds[lineIndex][charIndex];
      bound && (leftOffset = bound.left);
      if (this.charSpacing !== 0 && charIndex === this._textLines[lineIndex].length) {
        leftOffset -= this._getWidthOfCharSpacing();
      }
      const boundaries = {
        top: topOffset,
        left: lineLeftOffset + (leftOffset > 0 ? leftOffset : 0)
      };
      if (this.direction === 'rtl') {
        if (this.textAlign === RIGHT || this.textAlign === JUSTIFY || this.textAlign === JUSTIFY_RIGHT) {
          boundaries.left *= -1;
        } else if (this.textAlign === LEFT || this.textAlign === JUSTIFY_LEFT) {
          boundaries.left = lineLeftOffset - (leftOffset > 0 ? leftOffset : 0);
        } else if (this.textAlign === CENTER || this.textAlign === JUSTIFY_CENTER) {
          boundaries.left = lineLeftOffset - (leftOffset > 0 ? leftOffset : 0);
        }
      }
      return boundaries;
    }

    /**
     * Renders cursor on context Top, outside the animation cycle, on request
     * Used for the drag/drop effect.
     * If contextTop is not available, do nothing.
     */
    renderCursorAt(selectionStart) {
      this._renderCursor(this.canvas.contextTop, this._getCursorBoundaries(selectionStart, true), selectionStart);
    }

    /**
     * Renders cursor
     * @param {Object} boundaries
     * @param {CanvasRenderingContext2D} ctx transformed context to draw on
     */
    renderCursor(ctx, boundaries) {
      this._renderCursor(ctx, boundaries, this.selectionStart);
    }

    /**
     * Return the data needed to render the cursor for given selection start
     * The left,top are relative to the object, while width and height are prescaled
     * to look think with canvas zoom and object scaling,
     * so they depend on canvas and object scaling
     */
    getCursorRenderingData() {
      let selectionStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectionStart;
      let boundaries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._getCursorBoundaries(selectionStart);
      const cursorLocation = this.get2DCursorLocation(selectionStart),
        lineIndex = cursorLocation.lineIndex,
        charIndex = cursorLocation.charIndex > 0 ? cursorLocation.charIndex - 1 : 0,
        charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, 'fontSize'),
        multiplier = this.getObjectScaling().x * this.canvas.getZoom(),
        cursorWidth = this.cursorWidth / multiplier,
        dy = this.getValueOfPropertyAt(lineIndex, charIndex, 'deltaY'),
        topOffset = boundaries.topOffset + (1 - this._fontSizeFraction) * this.getHeightOfLine(lineIndex) / this.lineHeight - charHeight * (1 - this._fontSizeFraction);
      return {
        color: this.cursorColor || this.getValueOfPropertyAt(lineIndex, charIndex, 'fill'),
        opacity: this._currentCursorOpacity,
        left: boundaries.left + boundaries.leftOffset - cursorWidth / 2,
        top: topOffset + boundaries.top + dy,
        width: cursorWidth,
        height: charHeight
      };
    }

    /**
     * Render the cursor at the given selectionStart.
     * @param {CanvasRenderingContext2D} ctx transformed context to draw on
     */
    _renderCursor(ctx, boundaries, selectionStart) {
      const {
        color,
        opacity,
        left,
        top,
        width,
        height
      } = this.getCursorRenderingData(selectionStart, boundaries);
      ctx.fillStyle = color;
      ctx.globalAlpha = opacity;
      ctx.fillRect(left, top, width, height);
    }

    /**
     * Renders text selection
     * @param {Object} boundaries Object with left/top/leftOffset/topOffset
     * @param {CanvasRenderingContext2D} ctx transformed context to draw on
     */
    renderSelection(ctx, boundaries) {
      const selection = {
        selectionStart: this.inCompositionMode ? this.hiddenTextarea.selectionStart : this.selectionStart,
        selectionEnd: this.inCompositionMode ? this.hiddenTextarea.selectionEnd : this.selectionEnd
      };
      this._renderSelection(ctx, selection, boundaries);
    }

    /**
     * Renders drag start text selection
     */
    renderDragSourceEffect() {
      const dragStartSelection = this.draggableTextDelegate.getDragStartSelection();
      this._renderSelection(this.canvas.contextTop, dragStartSelection, this._getCursorBoundaries(dragStartSelection.selectionStart, true));
    }
    renderDropTargetEffect(e) {
      const dragSelection = this.getSelectionStartFromPointer(e);
      this.renderCursorAt(dragSelection);
    }

    /**
     * Renders text selection
     * @private
     * @param {{ selectionStart: number, selectionEnd: number }} selection
     * @param {Object} boundaries Object with left/top/leftOffset/topOffset
     * @param {CanvasRenderingContext2D} ctx transformed context to draw on
     */
    _renderSelection(ctx, selection, boundaries) {
      const selectionStart = selection.selectionStart,
        selectionEnd = selection.selectionEnd,
        isJustify = this.textAlign.includes(JUSTIFY),
        start = this.get2DCursorLocation(selectionStart),
        end = this.get2DCursorLocation(selectionEnd),
        startLine = start.lineIndex,
        endLine = end.lineIndex,
        startChar = start.charIndex < 0 ? 0 : start.charIndex,
        endChar = end.charIndex < 0 ? 0 : end.charIndex;
      for (let i = startLine; i <= endLine; i++) {
        const lineOffset = this._getLineLeftOffset(i) || 0;
        let lineHeight = this.getHeightOfLine(i),
          realLineHeight = 0,
          boxStart = 0,
          boxEnd = 0;
        if (i === startLine) {
          boxStart = this.__charBounds[startLine][startChar].left;
        }
        if (i >= startLine && i < endLine) {
          boxEnd = isJustify && !this.isEndOfWrapping(i) ? this.width : this.getLineWidth(i) || 5; // WTF is this 5?
        } else if (i === endLine) {
          if (endChar === 0) {
            boxEnd = this.__charBounds[endLine][endChar].left;
          } else {
            const charSpacing = this._getWidthOfCharSpacing();
            boxEnd = this.__charBounds[endLine][endChar - 1].left + this.__charBounds[endLine][endChar - 1].width - charSpacing;
          }
        }
        realLineHeight = lineHeight;
        if (this.lineHeight < 1 || i === endLine && this.lineHeight > 1) {
          lineHeight /= this.lineHeight;
        }
        let drawStart = boundaries.left + lineOffset + boxStart,
          drawHeight = lineHeight,
          extraTop = 0;
        const drawWidth = boxEnd - boxStart;
        if (this.inCompositionMode) {
          ctx.fillStyle = this.compositionColor || 'black';
          drawHeight = 1;
          extraTop = lineHeight;
        } else {
          ctx.fillStyle = this.selectionColor;
        }
        if (this.direction === 'rtl') {
          if (this.textAlign === RIGHT || this.textAlign === JUSTIFY || this.textAlign === JUSTIFY_RIGHT) {
            drawStart = this.width - drawStart - drawWidth;
          } else if (this.textAlign === LEFT || this.textAlign === JUSTIFY_LEFT) {
            drawStart = boundaries.left + lineOffset - boxEnd;
          } else if (this.textAlign === CENTER || this.textAlign === JUSTIFY_CENTER) {
            drawStart = boundaries.left + lineOffset - boxEnd;
          }
        }
        ctx.fillRect(drawStart, boundaries.top + boundaries.topOffset + extraTop, drawWidth, drawHeight);
        boundaries.topOffset += realLineHeight;
      }
    }

    /**
     * High level function to know the height of the cursor.
     * the currentChar is the one that precedes the cursor
     * Returns fontSize of char at the current cursor
     * Unused from the library, is for the end user
     * @return {Number} Character font size
     */
    getCurrentCharFontSize() {
      const cp = this._getCurrentCharIndex();
      return this.getValueOfPropertyAt(cp.l, cp.c, 'fontSize');
    }

    /**
     * High level function to know the color of the cursor.
     * the currentChar is the one that precedes the cursor
     * Returns color (fill) of char at the current cursor
     * if the text object has a pattern or gradient for filler, it will return that.
     * Unused by the library, is for the end user
     * @return {String | TFiller} Character color (fill)
     */
    getCurrentCharColor() {
      const cp = this._getCurrentCharIndex();
      return this.getValueOfPropertyAt(cp.l, cp.c, FILL);
    }

    /**
     * Returns the cursor position for the getCurrent.. functions
     * @private
     */
    _getCurrentCharIndex() {
      const cursorPosition = this.get2DCursorLocation(this.selectionStart, true),
        charIndex = cursorPosition.charIndex > 0 ? cursorPosition.charIndex - 1 : 0;
      return {
        l: cursorPosition.lineIndex,
        c: charIndex
      };
    }
    dispose() {
      this.exitEditingImpl();
      this.draggableTextDelegate.dispose();
      super.dispose();
    }
  }
  /**
   * Index where text selection starts (or where cursor is when there is no selection)
   * @type Number
   * @default
   */
  /**
   * Index where text selection ends
   * @type Number
   * @default
   */
  /**
   * Color of text selection
   * @type String
   * @default
   */
  /**
   * Indicates whether text is in editing mode
   * @type Boolean
   * @default
   */
  /**
   * Indicates whether a text can be edited
   * @type Boolean
   * @default
   */
  /**
   * Border color of text object while it's in editing mode
   * @type String
   * @default
   */
  /**
   * Width of cursor (in px)
   * @type Number
   * @default
   */
  /**
   * Color of text cursor color in editing mode.
   * if not set (default) will take color from the text.
   * if set to a color value that fabric can understand, it will
   * be used instead of the color of the text at the current position.
   * @type String
   * @default
   */
  /**
   * Delay between cursor blink (in ms)
   * @type Number
   * @default
   */
  /**
   * Duration of cursor fade in (in ms)
   * @type Number
   * @default
   */
  /**
   * Indicates whether internal text char widths can be cached
   * @type Boolean
   * @default
   */
  _defineProperty(IText, "ownDefaults", iTextDefaultValues);
  _defineProperty(IText, "type", 'IText');
  classRegistry.setClass(IText);
  // legacy
  classRegistry.setClass(IText, 'i-text');

  // @TODO: Many things here are configuration related and shouldn't be on the class nor prototype
  // regexes, list of properties that are not suppose to change by instances, magic consts.
  // this will be a separated effort
  const textboxDefaultValues = {
    minWidth: 20,
    dynamicMinWidth: 2,
    lockScalingFlip: true,
    noScaleCache: false,
    _wordJoiners: /[ \t\r]/,
    splitByGrapheme: false
  };

  // @TODO this is not complete

  /**
   * Textbox class, based on IText, allows the user to resize the text rectangle
   * and wraps lines automatically. Textboxes have their Y scaling locked, the
   * user can only change width. Height is adjusted automatically based on the
   * wrapping of lines.
   */
  class Textbox extends IText {
    static getDefaults() {
      return _objectSpread2(_objectSpread2({}, super.getDefaults()), Textbox.ownDefaults);
    }

    /**
     * Constructor
     * @param {String} text Text string
     * @param {Object} [options] Options object
     */
    constructor(text, options) {
      super(text, _objectSpread2(_objectSpread2({}, Textbox.ownDefaults), options));
    }

    /**
     * Creates the default control object.
     * If you prefer to have on instance of controls shared among all objects
     * make this function return an empty object and add controls to the ownDefaults object
     */
    static createControls() {
      return {
        controls: createTextboxDefaultControls()
      };
    }

    /**
     * Unlike superclass's version of this function, Textbox does not update
     * its width.
     * @private
     * @override
     */
    initDimensions() {
      if (!this.initialized) {
        return;
      }
      this.isEditing && this.initDelayedCursor();
      this._clearCache();
      // clear dynamicMinWidth as it will be different after we re-wrap line
      this.dynamicMinWidth = 0;
      // wrap lines
      this._styleMap = this._generateStyleMap(this._splitText());
      // if after wrapping, the width is smaller than dynamicMinWidth, change the width and re-wrap
      if (this.dynamicMinWidth > this.width) {
        this._set('width', this.dynamicMinWidth);
      }
      if (this.textAlign.includes(JUSTIFY)) {
        // once text is measured we need to make space fatter to make justified text.
        this.enlargeSpaces();
      }
      // clear cache and re-calculate height
      this.height = this.calcTextHeight();
    }

    /**
     * Generate an object that translates the style object so that it is
     * broken up by visual lines (new lines and automatic wrapping).
     * The original text styles object is broken up by actual lines (new lines only),
     * which is only sufficient for Text / IText
     * @private
     */
    _generateStyleMap(textInfo) {
      let realLineCount = 0,
        realLineCharCount = 0,
        charCount = 0;
      const map = {};
      for (let i = 0; i < textInfo.graphemeLines.length; i++) {
        if (textInfo.graphemeText[charCount] === '\n' && i > 0) {
          realLineCharCount = 0;
          charCount++;
          realLineCount++;
        } else if (!this.splitByGrapheme && this._reSpaceAndTab.test(textInfo.graphemeText[charCount]) && i > 0) {
          // this case deals with space's that are removed from end of lines when wrapping
          realLineCharCount++;
          charCount++;
        }
        map[i] = {
          line: realLineCount,
          offset: realLineCharCount
        };
        charCount += textInfo.graphemeLines[i].length;
        realLineCharCount += textInfo.graphemeLines[i].length;
      }
      return map;
    }

    /**
     * Returns true if object has a style property or has it on a specified line
     * @param {Number} lineIndex
     * @return {Boolean}
     */
    styleHas(property, lineIndex) {
      if (this._styleMap && !this.isWrapping) {
        const map = this._styleMap[lineIndex];
        if (map) {
          lineIndex = map.line;
        }
      }
      return super.styleHas(property, lineIndex);
    }

    /**
     * Returns true if object has no styling or no styling in a line
     * @param {Number} lineIndex , lineIndex is on wrapped lines.
     * @return {Boolean}
     */
    isEmptyStyles(lineIndex) {
      if (!this.styles) {
        return true;
      }
      let offset = 0,
        nextLineIndex = lineIndex + 1,
        nextOffset,
        shouldLimit = false;
      const map = this._styleMap[lineIndex],
        mapNextLine = this._styleMap[lineIndex + 1];
      if (map) {
        lineIndex = map.line;
        offset = map.offset;
      }
      if (mapNextLine) {
        nextLineIndex = mapNextLine.line;
        shouldLimit = nextLineIndex === lineIndex;
        nextOffset = mapNextLine.offset;
      }
      const obj = typeof lineIndex === 'undefined' ? this.styles : {
        line: this.styles[lineIndex]
      };
      for (const p1 in obj) {
        for (const p2 in obj[p1]) {
          const p2Number = parseInt(p2, 10);
          if (p2Number >= offset && (!shouldLimit || p2Number < nextOffset)) {
            // eslint-disable-next-line no-unused-vars
            for (const p3 in obj[p1][p2]) {
              return false;
            }
          }
        }
      }
      return true;
    }

    /**
     * @protected
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @return {TextStyleDeclaration} a style object reference to the existing one or a new empty object when undefined
     */
    _getStyleDeclaration(lineIndex, charIndex) {
      if (this._styleMap && !this.isWrapping) {
        const map = this._styleMap[lineIndex];
        if (!map) {
          return {};
        }
        lineIndex = map.line;
        charIndex = map.offset + charIndex;
      }
      return super._getStyleDeclaration(lineIndex, charIndex);
    }

    /**
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @param {Object} style
     * @private
     */
    _setStyleDeclaration(lineIndex, charIndex, style) {
      const map = this._styleMap[lineIndex];
      super._setStyleDeclaration(map.line, map.offset + charIndex, style);
    }

    /**
     * @param {Number} lineIndex
     * @param {Number} charIndex
     * @private
     */
    _deleteStyleDeclaration(lineIndex, charIndex) {
      const map = this._styleMap[lineIndex];
      super._deleteStyleDeclaration(map.line, map.offset + charIndex);
    }

    /**
     * probably broken need a fix
     * Returns the real style line that correspond to the wrapped lineIndex line
     * Used just to verify if the line does exist or not.
     * @param {Number} lineIndex
     * @returns {Boolean} if the line exists or not
     * @private
     */
    _getLineStyle(lineIndex) {
      const map = this._styleMap[lineIndex];
      return !!this.styles[map.line];
    }

    /**
     * Set the line style to an empty object so that is initialized
     * @param {Number} lineIndex
     * @param {Object} style
     * @private
     */
    _setLineStyle(lineIndex) {
      const map = this._styleMap[lineIndex];
      super._setLineStyle(map.line);
    }

    /**
     * Wraps text using the 'width' property of Textbox. First this function
     * splits text on newlines, so we preserve newlines entered by the user.
     * Then it wraps each line using the width of the Textbox by calling
     * _wrapLine().
     * @param {Array} lines The string array of text that is split into lines
     * @param {Number} desiredWidth width you want to wrap to
     * @returns {Array} Array of lines
     */
    _wrapText(lines, desiredWidth) {
      this.isWrapping = true;
      // extract all thewords and the widths to optimally wrap lines.
      const data = this.getGraphemeDataForRender(lines);
      const wrapped = [];
      for (let i = 0; i < data.wordsData.length; i++) {
        wrapped.push(...this._wrapLine(i, desiredWidth, data));
      }
      this.isWrapping = false;
      return wrapped;
    }

    /**
     * For each line of text terminated by an hard line stop,
     * measure each word width and extract the largest word from all.
     * The returned words here are the one that at the end will be rendered.
     * @param {string[]} lines the lines we need to measure
     *
     */
    getGraphemeDataForRender(lines) {
      const splitByGrapheme = this.splitByGrapheme,
        infix = splitByGrapheme ? '' : ' ';
      let largestWordWidth = 0;
      const data = lines.map((line, lineIndex) => {
        let offset = 0;
        const wordsOrGraphemes = splitByGrapheme ? this.graphemeSplit(line) : this.wordSplit(line);
        if (wordsOrGraphemes.length === 0) {
          return [{
            word: [],
            width: 0
          }];
        }
        return wordsOrGraphemes.map(word => {
          // if using splitByGrapheme words are already in graphemes.
          const graphemeArray = splitByGrapheme ? [word] : this.graphemeSplit(word);
          const width = this._measureWord(graphemeArray, lineIndex, offset);
          largestWordWidth = Math.max(width, largestWordWidth);
          offset += graphemeArray.length + infix.length;
          return {
            word: graphemeArray,
            width
          };
        });
      });
      return {
        wordsData: data,
        largestWordWidth
      };
    }

    /**
     * Helper function to measure a string of text, given its lineIndex and charIndex offset
     * It gets called when charBounds are not available yet.
     * Override if necessary
     * Use with {@link Textbox#wordSplit}
     *
     * @param {CanvasRenderingContext2D} ctx
     * @param {String} text
     * @param {number} lineIndex
     * @param {number} charOffset
     * @returns {number}
     */
    _measureWord(word, lineIndex) {
      let charOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      let width = 0,
        prevGrapheme;
      const skipLeft = true;
      for (let i = 0, len = word.length; i < len; i++) {
        const box = this._getGraphemeBox(word[i], lineIndex, i + charOffset, prevGrapheme, skipLeft);
        width += box.kernedWidth;
        prevGrapheme = word[i];
      }
      return width;
    }

    /**
     * Override this method to customize word splitting
     * Use with {@link Textbox#_measureWord}
     * @param {string} value
     * @returns {string[]} array of words
     */
    wordSplit(value) {
      return value.split(this._wordJoiners);
    }

    /**
     * Wraps a line of text using the width of the Textbox as desiredWidth
     * and leveraging the known width o words from GraphemeData
     * @private
     * @param {Number} lineIndex
     * @param {Number} desiredWidth width you want to wrap the line to
     * @param {GraphemeData} graphemeData an object containing all the lines' words width.
     * @param {Number} reservedSpace space to remove from wrapping for custom functionalities
     * @returns {Array} Array of line(s) into which the given text is wrapped
     * to.
     */
    _wrapLine(lineIndex, desiredWidth, _ref) {
      let {
        largestWordWidth,
        wordsData
      } = _ref;
      let reservedSpace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      const additionalSpace = this._getWidthOfCharSpacing(),
        splitByGrapheme = this.splitByGrapheme,
        graphemeLines = [],
        infix = splitByGrapheme ? '' : ' ';
      let lineWidth = 0,
        line = [],
        // spaces in different languages?
        offset = 0,
        infixWidth = 0,
        lineJustStarted = true;
      desiredWidth -= reservedSpace;
      const maxWidth = Math.max(desiredWidth, largestWordWidth, this.dynamicMinWidth);
      // layout words
      const data = wordsData[lineIndex];
      offset = 0;
      let i;
      for (i = 0; i < data.length; i++) {
        const {
          word,
          width: wordWidth
        } = data[i];
        offset += word.length;
        lineWidth += infixWidth + wordWidth - additionalSpace;
        if (lineWidth > maxWidth && !lineJustStarted) {
          graphemeLines.push(line);
          line = [];
          lineWidth = wordWidth;
          lineJustStarted = true;
        } else {
          lineWidth += additionalSpace;
        }
        if (!lineJustStarted && !splitByGrapheme) {
          line.push(infix);
        }
        line = line.concat(word);
        infixWidth = splitByGrapheme ? 0 : this._measureWord([infix], lineIndex, offset);
        offset++;
        lineJustStarted = false;
      }
      i && graphemeLines.push(line);

      // TODO: this code is probably not necessary anymore.
      // it can be moved out of this function since largestWordWidth is now
      // known in advance
      if (largestWordWidth + reservedSpace > this.dynamicMinWidth) {
        this.dynamicMinWidth = largestWordWidth - additionalSpace + reservedSpace;
      }
      return graphemeLines;
    }

    /**
     * Detect if the text line is ended with an hard break
     * text and itext do not have wrapping, return false
     * @param {Number} lineIndex text to split
     * @return {Boolean}
     */
    isEndOfWrapping(lineIndex) {
      if (!this._styleMap[lineIndex + 1]) {
        // is last line, return true;
        return true;
      }
      if (this._styleMap[lineIndex + 1].line !== this._styleMap[lineIndex].line) {
        // this is last line before a line break, return true;
        return true;
      }
      return false;
    }

    /**
     * Detect if a line has a linebreak and so we need to account for it when moving
     * and counting style.
     * This is important only for splitByGrapheme at the end of wrapping.
     * If we are not wrapping the offset is always 1
     * @return Number
     */
    missingNewlineOffset(lineIndex, skipWrapping) {
      if (this.splitByGrapheme && !skipWrapping) {
        return this.isEndOfWrapping(lineIndex) ? 1 : 0;
      }
      return 1;
    }

    /**
     * Gets lines of text to render in the Textbox. This function calculates
     * text wrapping on the fly every time it is called.
     * @param {String} text text to split
     * @returns {Array} Array of lines in the Textbox.
     * @override
     */
    _splitTextIntoLines(text) {
      const newText = super._splitTextIntoLines(text),
        graphemeLines = this._wrapText(newText.lines, this.width),
        lines = new Array(graphemeLines.length);
      for (let i = 0; i < graphemeLines.length; i++) {
        lines[i] = graphemeLines[i].join('');
      }
      newText.lines = lines;
      newText.graphemeLines = graphemeLines;
      return newText;
    }
    getMinWidth() {
      return Math.max(this.minWidth, this.dynamicMinWidth);
    }
    _removeExtraneousStyles() {
      const linesToKeep = new Map();
      for (const prop in this._styleMap) {
        const propNumber = parseInt(prop, 10);
        if (this._textLines[propNumber]) {
          const lineIndex = this._styleMap[prop].line;
          linesToKeep.set("".concat(lineIndex), true);
        }
      }
      for (const prop in this.styles) {
        if (!linesToKeep.has(prop)) {
          delete this.styles[prop];
        }
      }
    }

    /**
     * Returns object representation of an instance
     * @method toObject
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} object representation of an instance
     */
    toObject() {
      let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return super.toObject(['minWidth', 'splitByGrapheme', ...propertiesToInclude]);
    }
  }
  /**
   * Minimum width of textbox, in pixels.
   * @type Number
   * @default
   */
  /**
   * Minimum calculated width of a textbox, in pixels.
   * fixed to 2 so that an empty textbox cannot go to 0
   * and is still selectable without text.
   * @type Number
   * @default
   */
  /**
   * Use this boolean property in order to split strings that have no white space concept.
   * this is a cheap way to help with chinese/japanese
   * @type Boolean
   * @since 2.6.0
   */
  _defineProperty(Textbox, "type", 'Textbox');
  _defineProperty(Textbox, "textLayoutProperties", [...IText.textLayoutProperties, 'width']);
  _defineProperty(Textbox, "ownDefaults", textboxDefaultValues);
  classRegistry.setClass(Textbox);

  /**
   * Layout will adjust the bounding box to match the clip path bounding box.
   */
  class ClipPathLayout extends LayoutStrategy {
    shouldPerformLayout(context) {
      return !!context.target.clipPath && super.shouldPerformLayout(context);
    }
    shouldLayoutClipPath() {
      return false;
    }
    calcLayoutResult(context, objects) {
      const {
        target
      } = context;
      const {
        clipPath,
        group
      } = target;
      if (!clipPath || !this.shouldPerformLayout(context)) {
        return;
      }
      // TODO: remove stroke calculation from this case
      const {
        width,
        height
      } = makeBoundingBoxFromPoints(getObjectBounds(target, clipPath));
      const size = new Point(width, height);
      if (clipPath.absolutePositioned) {
        //  we want the center point to exist in group's containing plane
        const clipPathCenter = sendPointToPlane(clipPath.getRelativeCenterPoint(), undefined, group ? group.calcTransformMatrix() : undefined);
        return {
          center: clipPathCenter,
          size
        };
      } else {
        //  we want the center point to exist in group's containing plane, so we send it upwards
        const clipPathCenter = clipPath.getRelativeCenterPoint().transform(target.calcOwnMatrix(), true);
        if (this.shouldPerformLayout(context)) {
          // the clip path is positioned relative to the group's center which is affected by the bbox
          // so we first calculate the bbox
          const {
            center = new Point(),
            correction = new Point()
          } = this.calcBoundingBox(objects, context) || {};
          return {
            center: center.add(clipPathCenter),
            correction: correction.subtract(clipPathCenter),
            size
          };
        } else {
          return {
            center: target.getRelativeCenterPoint().add(clipPathCenter),
            size
          };
        }
      }
    }
  }
  _defineProperty(ClipPathLayout, "type", 'clip-path');
  classRegistry.setClass(ClipPathLayout);

  /**
   * Layout will keep target's initial size.
   */
  class FixedLayout extends LayoutStrategy {
    /**
     * @override respect target's initial size
     */
    getInitialSize(_ref, _ref2) {
      let {
        target
      } = _ref;
      let {
        size
      } = _ref2;
      return new Point(target.width || size.x, target.height || size.y);
    }
  }
  _defineProperty(FixedLayout, "type", 'fixed');
  classRegistry.setClass(FixedLayout);

  /**
   * Today the LayoutManager class also takes care of subscribing event handlers
   * to update the group layout when the group is interactive and a transform is applied
   * to a child object.
   * The ActiveSelection is never interactive, but it could contain objects from
   * groups that are.
   * The standard LayoutManager would subscribe the children of the activeSelection to
   * perform layout changes to the active selection itself, what we need instead is that
   * the transformation applied to the active selection will trigger changes to the
   * original group of the children ( the one referenced under the parent property )
   * This subclass of the LayoutManager has a single duty to fill the gap of this difference.`
   */
  class ActiveSelectionLayoutManager extends LayoutManager {
    subscribeTargets(context) {
      const activeSelection = context.target;
      const parents = context.targets.reduce((parents, target) => {
        target.parent && parents.add(target.parent);
        return parents;
      }, new Set());
      parents.forEach(parent => {
        parent.layoutManager.subscribeTargets({
          target: parent,
          targets: [activeSelection]
        });
      });
    }

    /**
     * unsubscribe from parent only if all its children were deselected
     */
    unsubscribeTargets(context) {
      const activeSelection = context.target;
      const selectedObjects = activeSelection.getObjects();
      const parents = context.targets.reduce((parents, target) => {
        target.parent && parents.add(target.parent);
        return parents;
      }, new Set());
      parents.forEach(parent => {
        !selectedObjects.some(object => object.parent === parent) && parent.layoutManager.unsubscribeTargets({
          target: parent,
          targets: [activeSelection]
        });
      });
    }
  }

  const activeSelectionDefaultValues = {
    multiSelectionStacking: 'canvas-stacking'
  };

  /**
   * Used by Canvas to manage selection.
   *
   * @example
   * class MyActiveSelection extends ActiveSelection {
   *   ...
   * }
   *
   * // override the default `ActiveSelection` class
   * classRegistry.setClass(MyActiveSelection)
   */
  class ActiveSelection extends Group {
    static getDefaults() {
      return _objectSpread2(_objectSpread2({}, super.getDefaults()), ActiveSelection.ownDefaults);
    }

    /**
     * The ActiveSelection needs to use the ActiveSelectionLayoutManager
     * or selections on interactive groups may be broken
     */

    /**
     * controls how selected objects are added during a multiselection event
     * - `canvas-stacking` adds the selected object to the active selection while respecting canvas object stacking order
     * - `selection-order` adds the selected object to the top of the stack,
     * meaning that the stack is ordered by the order in which objects were selected
     * @default `canvas-stacking`
     */

    constructor() {
      let objects = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      super();
      Object.assign(this, ActiveSelection.ownDefaults);
      this.setOptions(options);
      const {
        left,
        top,
        layoutManager
      } = options;
      this.groupInit(objects, {
        left,
        top,
        layoutManager: layoutManager !== null && layoutManager !== void 0 ? layoutManager : new ActiveSelectionLayoutManager()
      });
    }

    /**
     * @private
     */
    _shouldSetNestedCoords() {
      return true;
    }

    /**
     * @private
     * @override we don't want the selection monitor to be active
     */
    __objectSelectionMonitor() {
      //  noop
    }

    /**
     * Adds objects with respect to {@link multiSelectionStacking}
     * @param targets object to add to selection
     */
    multiSelectAdd() {
      for (var _len = arguments.length, targets = new Array(_len), _key = 0; _key < _len; _key++) {
        targets[_key] = arguments[_key];
      }
      if (this.multiSelectionStacking === 'selection-order') {
        this.add(...targets);
      } else {
        //  respect object stacking as it is on canvas
        //  perf enhancement for large ActiveSelection: consider a binary search of `isInFrontOf`
        targets.forEach(target => {
          const index = this._objects.findIndex(obj => obj.isInFrontOf(target));
          const insertAt = index === -1 ?
          //  `target` is in front of all other objects
          this.size() : index;
          this.insertAt(insertAt, target);
        });
      }
    }

    /**
     * @override block ancestors/descendants of selected objects from being selected to prevent a circular object tree
     */
    canEnterGroup(object) {
      if (this.getObjects().some(o => o.isDescendantOf(object) || object.isDescendantOf(o))) {
        //  prevent circular object tree
        log('error', 'ActiveSelection: circular object trees are not supported, this call has no effect');
        return false;
      }
      return super.canEnterGroup(object);
    }

    /**
     * Change an object so that it can be part of an active selection.
     * this method is called by multiselectAdd from canvas code.
     * @private
     * @param {FabricObject} object
     * @param {boolean} [removeParentTransform] true if object is in canvas coordinate plane
     */
    enterGroup(object, removeParentTransform) {
      // This condition check that the object has currently a group, and the group
      // is also its parent, meaning that is not in an active selection, but is
      // in a normal group.
      if (object.parent && object.parent === object.group) {
        // Disconnect the object from the group functionalities, but keep the ref parent intact
        // for later re-enter
        object.parent._exitGroup(object);
        // in this case the object is probably inside an active selection.
      } else if (object.group && object.parent !== object.group) {
        // in this case group.remove will also clear the old parent reference.
        object.group.remove(object);
      }
      // enter the active selection from a render perspective
      // the object will be in the objects array of both the ActiveSelection and the Group
      // but referenced in the group's _activeObjects so that it won't be rendered twice.
      this._enterGroup(object, removeParentTransform);
    }

    /**
     * we want objects to retain their canvas ref when exiting instance
     * @private
     * @param {FabricObject} object
     * @param {boolean} [removeParentTransform] true if object should exit group without applying group's transform to it
     */
    exitGroup(object, removeParentTransform) {
      this._exitGroup(object, removeParentTransform);
      // return to parent
      object.parent && object.parent._enterGroup(object, true);
    }

    /**
     * @private
     * @param {'added'|'removed'} type
     * @param {FabricObject[]} targets
     */
    _onAfterObjectsChange(type, targets) {
      super._onAfterObjectsChange(type, targets);
      const groups = new Set();
      targets.forEach(object => {
        const {
          parent
        } = object;
        parent && groups.add(parent);
      });
      if (type === LAYOUT_TYPE_REMOVED) {
        //  invalidate groups' layout and mark as dirty
        groups.forEach(group => {
          group._onAfterObjectsChange(LAYOUT_TYPE_ADDED, targets);
        });
      } else {
        //  mark groups as dirty
        groups.forEach(group => {
          group._set('dirty', true);
        });
      }
    }

    /**
     * @override remove all objects
     */
    onDeselect() {
      this.removeAll();
      return false;
    }

    /**
     * Returns string representation of a group
     * @return {String}
     */
    toString() {
      return "#<ActiveSelection: (".concat(this.complexity(), ")>");
    }

    /**
     * Decide if the object should cache or not. The Active selection never caches
     * @return {Boolean}
     */
    shouldCache() {
      return false;
    }

    /**
     * Check if this group or its parent group are caching, recursively up
     * @return {Boolean}
     */
    isOnACache() {
      return false;
    }

    /**
     * Renders controls and borders for the object
     * @param {CanvasRenderingContext2D} ctx Context to render on
     * @param {Object} [styleOverride] properties to override the object style
     * @param {Object} [childrenOverride] properties to override the children overrides
     */
    _renderControls(ctx, styleOverride, childrenOverride) {
      ctx.save();
      ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
      const options = _objectSpread2(_objectSpread2({
        hasControls: false
      }, childrenOverride), {}, {
        forActiveSelection: true
      });
      for (let i = 0; i < this._objects.length; i++) {
        this._objects[i]._renderControls(ctx, options);
      }
      super._renderControls(ctx, styleOverride);
      ctx.restore();
    }
  }
  _defineProperty(ActiveSelection, "type", 'ActiveSelection');
  _defineProperty(ActiveSelection, "ownDefaults", activeSelectionDefaultValues);
  classRegistry.setClass(ActiveSelection);
  classRegistry.setClass(ActiveSelection, 'activeSelection');

  /**
   * Canvas 2D filter backend.
   */

  class Canvas2dFilterBackend {
    constructor() {
      /**
       * Experimental. This object is a sort of repository of help layers used to avoid
       * of recreating them during frequent filtering. If you are previewing a filter with
       * a slider you probably do not want to create help layers every filter step.
       * in this object there will be appended some canvases, created once, resized sometimes
       * cleared never. Clearing is left to the developer.
       **/
      _defineProperty(this, "resources", {});
    }
    /**
     * Apply a set of filters against a source image and draw the filtered output
     * to the provided destination canvas.
     *
     * @param {EnhancedFilter} filters The filter to apply.
     * @param {HTMLImageElement|HTMLCanvasElement} sourceElement The source to be filtered.
     * @param {Number} sourceWidth The width of the source input.
     * @param {Number} sourceHeight The height of the source input.
     * @param {HTMLCanvasElement} targetCanvas The destination for filtered output to be drawn.
     */
    applyFilters(filters, sourceElement, sourceWidth, sourceHeight, targetCanvas) {
      const ctx = targetCanvas.getContext('2d');
      if (!ctx) {
        return;
      }
      ctx.drawImage(sourceElement, 0, 0, sourceWidth, sourceHeight);
      const imageData = ctx.getImageData(0, 0, sourceWidth, sourceHeight);
      const originalImageData = ctx.getImageData(0, 0, sourceWidth, sourceHeight);
      const pipelineState = {
        sourceWidth,
        sourceHeight,
        imageData,
        originalEl: sourceElement,
        originalImageData,
        canvasEl: targetCanvas,
        ctx,
        filterBackend: this
      };
      filters.forEach(filter => {
        filter.applyTo(pipelineState);
      });
      const {
        imageData: imageDataPostFilter
      } = pipelineState;
      if (imageDataPostFilter.width !== sourceWidth || imageDataPostFilter.height !== sourceHeight) {
        targetCanvas.width = imageDataPostFilter.width;
        targetCanvas.height = imageDataPostFilter.height;
      }
      ctx.putImageData(imageDataPostFilter, 0, 0);
      return pipelineState;
    }
  }

  class WebGLFilterBackend {
    constructor() {
      let {
        tileSize = config.textureSize
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      /**
       * Define ...
       **/
      _defineProperty(this, "aPosition", new Float32Array([0, 0, 0, 1, 1, 0, 1, 1]));
      /**
       * Experimental. This object is a sort of repository of help layers used to avoid
       * of recreating them during frequent filtering. If you are previewing a filter with
       * a slider you probably do not want to create help layers every filter step.
       * in this object there will be appended some canvases, created once, resized sometimes
       * cleared never. Clearing is left to the developer.
       **/
      _defineProperty(this, "resources", {});
      this.tileSize = tileSize;
      this.setupGLContext(tileSize, tileSize);
      this.captureGPUInfo();
    }

    /**
     * Setup a WebGL context suitable for filtering, and bind any needed event handlers.
     */
    setupGLContext(width, height) {
      this.dispose();
      this.createWebGLCanvas(width, height);
    }

    /**
     * Create a canvas element and associated WebGL context and attaches them as
     * class properties to the GLFilterBackend class.
     */
    createWebGLCanvas(width, height) {
      const canvas = createCanvasElementFor({
        width,
        height
      });
      const glOptions = {
          alpha: true,
          premultipliedAlpha: false,
          depth: false,
          stencil: false,
          antialias: false
        },
        gl = canvas.getContext('webgl', glOptions);
      if (!gl) {
        return;
      }
      gl.clearColor(0, 0, 0, 0);
      // this canvas can fire webglcontextlost and webglcontextrestored
      this.canvas = canvas;
      this.gl = gl;
    }

    /**
     * Attempts to apply the requested filters to the source provided, drawing the filtered output
     * to the provided target canvas.
     *
     * @param {Array} filters The filters to apply.
     * @param {TexImageSource} source The source to be filtered.
     * @param {Number} width The width of the source input.
     * @param {Number} height The height of the source input.
     * @param {HTMLCanvasElement} targetCanvas The destination for filtered output to be drawn.
     * @param {String|undefined} cacheKey A key used to cache resources related to the source. If
     * omitted, caching will be skipped.
     */
    applyFilters(filters, source, width, height, targetCanvas, cacheKey) {
      const gl = this.gl;
      const ctx = targetCanvas.getContext('2d');
      if (!gl || !ctx) {
        return;
      }
      let cachedTexture;
      if (cacheKey) {
        cachedTexture = this.getCachedTexture(cacheKey, source);
      }
      const pipelineState = {
        originalWidth: source.width || source.naturalWidth || 0,
        originalHeight: source.height || source.naturalHeight || 0,
        sourceWidth: width,
        sourceHeight: height,
        destinationWidth: width,
        destinationHeight: height,
        context: gl,
        sourceTexture: this.createTexture(gl, width, height, !cachedTexture ? source : undefined),
        targetTexture: this.createTexture(gl, width, height),
        originalTexture: cachedTexture || this.createTexture(gl, width, height, !cachedTexture ? source : undefined),
        passes: filters.length,
        webgl: true,
        aPosition: this.aPosition,
        programCache: this.programCache,
        pass: 0,
        filterBackend: this,
        targetCanvas: targetCanvas
      };
      const tempFbo = gl.createFramebuffer();
      gl.bindFramebuffer(gl.FRAMEBUFFER, tempFbo);
      filters.forEach(filter => {
        filter && filter.applyTo(pipelineState);
      });
      resizeCanvasIfNeeded(pipelineState);
      this.copyGLTo2D(gl, pipelineState);
      gl.bindTexture(gl.TEXTURE_2D, null);
      gl.deleteTexture(pipelineState.sourceTexture);
      gl.deleteTexture(pipelineState.targetTexture);
      gl.deleteFramebuffer(tempFbo);
      ctx.setTransform(1, 0, 0, 1, 0, 0);
      return pipelineState;
    }

    /**
     * Detach event listeners, remove references, and clean up caches.
     */
    dispose() {
      if (this.canvas) {
        // we are disposing, we don't care about the fact
        // that the canvas shouldn't be null.
        // @ts-expect-error disposing
        this.canvas = null;
        // @ts-expect-error disposing
        this.gl = null;
      }
      this.clearWebGLCaches();
    }

    /**
     * Wipe out WebGL-related caches.
     */
    clearWebGLCaches() {
      this.programCache = {};
      this.textureCache = {};
    }

    /**
     * Create a WebGL texture object.
     *
     * Accepts specific dimensions to initialize the texture to or a source image.
     *
     * @param {WebGLRenderingContext} gl The GL context to use for creating the texture.
     * @param {number} width The width to initialize the texture at.
     * @param {number} height The height to initialize the texture.
     * @param {TexImageSource} textureImageSource A source for the texture data.
     * @param {number} filter gl.NEAREST default or gl.LINEAR filters for the texture.
     * This filter is very useful for LUTs filters. If you need interpolation use gl.LINEAR
     * @returns {WebGLTexture}
     */
    createTexture(gl, width, height, textureImageSource, filter) {
      const {
        NEAREST,
        TEXTURE_2D,
        RGBA,
        UNSIGNED_BYTE,
        CLAMP_TO_EDGE,
        TEXTURE_MAG_FILTER,
        TEXTURE_MIN_FILTER,
        TEXTURE_WRAP_S,
        TEXTURE_WRAP_T
      } = gl;
      const texture = gl.createTexture();
      gl.bindTexture(TEXTURE_2D, texture);
      gl.texParameteri(TEXTURE_2D, TEXTURE_MAG_FILTER, filter || NEAREST);
      gl.texParameteri(TEXTURE_2D, TEXTURE_MIN_FILTER, filter || NEAREST);
      gl.texParameteri(TEXTURE_2D, TEXTURE_WRAP_S, CLAMP_TO_EDGE);
      gl.texParameteri(TEXTURE_2D, TEXTURE_WRAP_T, CLAMP_TO_EDGE);
      if (textureImageSource) {
        gl.texImage2D(TEXTURE_2D, 0, RGBA, RGBA, UNSIGNED_BYTE, textureImageSource);
      } else {
        gl.texImage2D(TEXTURE_2D, 0, RGBA, width, height, 0, RGBA, UNSIGNED_BYTE, null);
      }
      return texture;
    }

    /**
     * Can be optionally used to get a texture from the cache array
     *
     * If an existing texture is not found, a new texture is created and cached.
     *
     * @param {String} uniqueId A cache key to use to find an existing texture.
     * @param {HTMLImageElement|HTMLCanvasElement} textureImageSource A source to use to create the
     * texture cache entry if one does not already exist.
     */
    getCachedTexture(uniqueId, textureImageSource, filter) {
      const {
        textureCache
      } = this;
      if (textureCache[uniqueId]) {
        return textureCache[uniqueId];
      } else {
        const texture = this.createTexture(this.gl, textureImageSource.width, textureImageSource.height, textureImageSource, filter);
        if (texture) {
          textureCache[uniqueId] = texture;
        }
        return texture;
      }
    }

    /**
     * Clear out cached resources related to a source image that has been
     * filtered previously.
     *
     * @param {String} cacheKey The cache key provided when the source image was filtered.
     */
    evictCachesForKey(cacheKey) {
      if (this.textureCache[cacheKey]) {
        this.gl.deleteTexture(this.textureCache[cacheKey]);
        delete this.textureCache[cacheKey];
      }
    }

    /**
     * Copy an input WebGL canvas on to an output 2D canvas.
     *
     * The WebGL canvas is assumed to be upside down, with the top-left pixel of the
     * desired output image appearing in the bottom-left corner of the WebGL canvas.
     *
     * @param {WebGLRenderingContext} sourceContext The WebGL context to copy from.
     * @param {Object} pipelineState The 2D target canvas to copy on to.
     */
    copyGLTo2D(gl, pipelineState) {
      const glCanvas = gl.canvas,
        targetCanvas = pipelineState.targetCanvas,
        ctx = targetCanvas.getContext('2d');
      if (!ctx) {
        return;
      }
      ctx.translate(0, targetCanvas.height); // move it down again
      ctx.scale(1, -1); // vertical flip
      // where is my image on the big glcanvas?
      const sourceY = glCanvas.height - targetCanvas.height;
      ctx.drawImage(glCanvas, 0, sourceY, targetCanvas.width, targetCanvas.height, 0, 0, targetCanvas.width, targetCanvas.height);
    }

    /**
     * Copy an input WebGL canvas on to an output 2D canvas using 2d canvas' putImageData
     * API. Measurably faster than using ctx.drawImage in Firefox (version 54 on OSX Sierra).
     *
     * @param {WebGLRenderingContext} sourceContext The WebGL context to copy from.
     * @param {HTMLCanvasElement} targetCanvas The 2D target canvas to copy on to.
     * @param {Object} pipelineState The 2D target canvas to copy on to.
     */
    copyGLTo2DPutImageData(gl, pipelineState) {
      const targetCanvas = pipelineState.targetCanvas,
        ctx = targetCanvas.getContext('2d'),
        dWidth = pipelineState.destinationWidth,
        dHeight = pipelineState.destinationHeight,
        numBytes = dWidth * dHeight * 4;
      if (!ctx) {
        return;
      }
      const u8 = new Uint8Array(this.imageBuffer, 0, numBytes);
      const u8Clamped = new Uint8ClampedArray(this.imageBuffer, 0, numBytes);
      gl.readPixels(0, 0, dWidth, dHeight, gl.RGBA, gl.UNSIGNED_BYTE, u8);
      const imgData = new ImageData(u8Clamped, dWidth, dHeight);
      ctx.putImageData(imgData, 0, 0);
    }

    /**
     * Attempt to extract GPU information strings from a WebGL context.
     *
     * Useful information when debugging or blacklisting specific GPUs.
     *
     * @returns {Object} A GPU info object with renderer and vendor strings.
     */
    captureGPUInfo() {
      if (this.gpuInfo) {
        return this.gpuInfo;
      }
      const gl = this.gl,
        gpuInfo = {
          renderer: '',
          vendor: ''
        };
      if (!gl) {
        return gpuInfo;
      }
      const ext = gl.getExtension('WEBGL_debug_renderer_info');
      if (ext) {
        const renderer = gl.getParameter(ext.UNMASKED_RENDERER_WEBGL);
        const vendor = gl.getParameter(ext.UNMASKED_VENDOR_WEBGL);
        if (renderer) {
          gpuInfo.renderer = renderer.toLowerCase();
        }
        if (vendor) {
          gpuInfo.vendor = vendor.toLowerCase();
        }
      }
      this.gpuInfo = gpuInfo;
      return gpuInfo;
    }
  }
  function resizeCanvasIfNeeded(pipelineState) {
    const targetCanvas = pipelineState.targetCanvas,
      width = targetCanvas.width,
      height = targetCanvas.height,
      dWidth = pipelineState.destinationWidth,
      dHeight = pipelineState.destinationHeight;
    if (width !== dWidth || height !== dHeight) {
      targetCanvas.width = dWidth;
      targetCanvas.height = dHeight;
    }
  }

  let filterBackend;

  /**
   * Verifies if it is possible to initialize webgl or fallback on a canvas2d filtering backend
   */
  function initFilterBackend() {
    const {
      WebGLProbe
    } = getEnv();
    WebGLProbe.queryWebGL(createCanvasElement());
    if (config.enableGLFiltering && WebGLProbe.isSupported(config.textureSize)) {
      return new WebGLFilterBackend({
        tileSize: config.textureSize
      });
    } else {
      return new Canvas2dFilterBackend();
    }
  }

  /**
   * Get the current fabricJS filter backend  or initialize one if not available yet
   * @param [strict] pass `true` to create the backend if it wasn't created yet (default behavior),
   * pass `false` to get the backend ref without mutating it
   */
  function getFilterBackend() {
    let strict = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (!filterBackend && strict) {
      filterBackend = initFilterBackend();
    }
    return filterBackend;
  }
  function setFilterBackend(backend) {
    filterBackend = backend;
  }

  const _excluded$2 = ["filters", "resizeFilter", "src", "crossOrigin", "type"];

  // @todo Would be nice to have filtering code not imported directly.

  const imageDefaultValues = {
    strokeWidth: 0,
    srcFromAttribute: false,
    minimumScaleTrigger: 0.5,
    cropX: 0,
    cropY: 0,
    imageSmoothing: true
  };
  const IMAGE_PROPS = ['cropX', 'cropY'];

  /**
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#images}
   */
  class FabricImage extends FabricObject {
    static getDefaults() {
      return _objectSpread2(_objectSpread2({}, super.getDefaults()), FabricImage.ownDefaults);
    }
    /**
     * Constructor
     * Image can be initialized with any canvas drawable or a string.
     * The string should be a url and will be loaded as an image.
     * Canvas and Image element work out of the box, while videos require extra code to work.
     * Please check video element events for seeking.
     * @param {ImageSource | string} element Image element
     * @param {Object} [options] Options object
     */

    constructor(arg0, options) {
      super();
      /**
       * When calling {@link FabricImage.getSrc}, return value from element src with `element.getAttribute('src')`.
       * This allows for relative urls as image src.
       * @since 2.7.0
       * @type Boolean
       * @default false
       */
      /**
       * private
       * contains last value of scaleX to detect
       * if the Image got resized after the last Render
       * @type Number
       */
      _defineProperty(this, "_lastScaleX", 1);
      /**
       * private
       * contains last value of scaleY to detect
       * if the Image got resized after the last Render
       * @type Number
       */
      _defineProperty(this, "_lastScaleY", 1);
      /**
       * private
       * contains last value of scaling applied by the apply filter chain
       * @type Number
       */
      _defineProperty(this, "_filterScalingX", 1);
      /**
       * private
       * contains last value of scaling applied by the apply filter chain
       * @type Number
       */
      _defineProperty(this, "_filterScalingY", 1);
      this.filters = [];
      Object.assign(this, FabricImage.ownDefaults);
      this.setOptions(options);
      this.cacheKey = "texture".concat(uid());
      this.setElement(typeof arg0 === 'string' ? (this.canvas && getDocumentFromElement(this.canvas.getElement()) || getFabricDocument()).getElementById(arg0) : arg0, options);
    }

    /**
     * Returns image element which this instance if based on
     */
    getElement() {
      return this._element;
    }

    /**
     * Sets image element for this instance to a specified one.
     * If filters defined they are applied to new image.
     * You might need to call `canvas.renderAll` and `object.setCoords` after replacing, to render new image and update controls area.
     * @param {HTMLImageElement} element
     * @param {Partial<TSize>} [size] Options object
     */
    setElement(element) {
      var _element$classList;
      let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.removeTexture(this.cacheKey);
      this.removeTexture("".concat(this.cacheKey, "_filtered"));
      this._element = element;
      this._originalElement = element;
      this._setWidthHeight(size);
      (_element$classList = element.classList) === null || _element$classList === void 0 || _element$classList.add(FabricImage.CSS_CANVAS);
      if (this.filters.length !== 0) {
        this.applyFilters();
      }
      // resizeFilters work on the already filtered copy.
      // we need to apply resizeFilters AFTER normal filters.
      // applyResizeFilters is run more often than normal filters
      // and is triggered by user interactions rather than dev code
      if (this.resizeFilter) {
        this.applyResizeFilters();
      }
    }

    /**
     * Delete a single texture if in webgl mode
     */
    removeTexture(key) {
      const backend = getFilterBackend(false);
      if (backend instanceof WebGLFilterBackend) {
        backend.evictCachesForKey(key);
      }
    }

    /**
     * Delete textures, reference to elements and eventually JSDOM cleanup
     */
    dispose() {
      super.dispose();
      this.removeTexture(this.cacheKey);
      this.removeTexture("".concat(this.cacheKey, "_filtered"));
      this._cacheContext = null;
      ['_originalElement', '_element', '_filteredEl', '_cacheCanvas'].forEach(elementKey => {
        const el = this[elementKey];
        el && getEnv().dispose(el);
        // @ts-expect-error disposing
        this[elementKey] = undefined;
      });
    }

    /**
     * Get the crossOrigin value (of the corresponding image element)
     */
    getCrossOrigin() {
      return this._originalElement && (this._originalElement.crossOrigin || null);
    }

    /**
     * Returns original size of an image
     */
    getOriginalSize() {
      const element = this.getElement();
      if (!element) {
        return {
          width: 0,
          height: 0
        };
      }
      return {
        width: element.naturalWidth || element.width,
        height: element.naturalHeight || element.height
      };
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _stroke(ctx) {
      if (!this.stroke || this.strokeWidth === 0) {
        return;
      }
      const w = this.width / 2,
        h = this.height / 2;
      ctx.beginPath();
      ctx.moveTo(-w, -h);
      ctx.lineTo(w, -h);
      ctx.lineTo(w, h);
      ctx.lineTo(-w, h);
      ctx.lineTo(-w, -h);
      ctx.closePath();
    }

    /**
     * Returns object representation of an instance
     * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
     * @return {Object} Object representation of an instance
     */
    toObject() {
      let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      const filters = [];
      this.filters.forEach(filterObj => {
        filterObj && filters.push(filterObj.toObject());
      });
      return _objectSpread2(_objectSpread2({}, super.toObject([...IMAGE_PROPS, ...propertiesToInclude])), {}, {
        src: this.getSrc(),
        crossOrigin: this.getCrossOrigin(),
        filters
      }, this.resizeFilter ? {
        resizeFilter: this.resizeFilter.toObject()
      } : {});
    }

    /**
     * Returns true if an image has crop applied, inspecting values of cropX,cropY,width,height.
     * @return {Boolean}
     */
    hasCrop() {
      return !!this.cropX || !!this.cropY || this.width < this._element.width || this.height < this._element.height;
    }

    /**
     * Returns svg representation of an instance
     * @return {string[]} an array of strings with the specific svg representation
     * of the instance
     */
    _toSVG() {
      const imageMarkup = [],
        element = this._element,
        x = -this.width / 2,
        y = -this.height / 2;
      let svgString = [],
        strokeSvg = [],
        clipPath = '',
        imageRendering = '';
      if (!element) {
        return [];
      }
      if (this.hasCrop()) {
        const clipPathId = uid();
        svgString.push('<clipPath id="imageCrop_' + clipPathId + '">\n', '\t<rect x="' + x + '" y="' + y + '" width="' + this.width + '" height="' + this.height + '" />\n', '</clipPath>\n');
        clipPath = ' clip-path="url(#imageCrop_' + clipPathId + ')" ';
      }
      if (!this.imageSmoothing) {
        imageRendering = ' image-rendering="optimizeSpeed"';
      }
      imageMarkup.push('\t<image ', 'COMMON_PARTS', "xlink:href=\"".concat(this.getSvgSrc(true), "\" x=\"").concat(x - this.cropX, "\" y=\"").concat(y - this.cropY
      // we're essentially moving origin of transformation from top/left corner to the center of the shape
      // by wrapping it in container <g> element with actual transformation, then offsetting object to the top/left
      // so that object's center aligns with container's left/top
      , "\" width=\"").concat(element.width || element.naturalWidth, "\" height=\"").concat(element.height || element.naturalHeight, "\"").concat(imageRendering).concat(clipPath, "></image>\n"));
      if (this.stroke || this.strokeDashArray) {
        const origFill = this.fill;
        this.fill = null;
        strokeSvg = ["\t<rect x=\"".concat(x, "\" y=\"").concat(y, "\" width=\"").concat(this.width, "\" height=\"").concat(this.height, "\" style=\"").concat(this.getSvgStyles(), "\" />\n")];
        this.fill = origFill;
      }
      if (this.paintFirst !== FILL) {
        svgString = svgString.concat(strokeSvg, imageMarkup);
      } else {
        svgString = svgString.concat(imageMarkup, strokeSvg);
      }
      return svgString;
    }

    /**
     * Returns source of an image
     * @param {Boolean} filtered indicates if the src is needed for svg
     * @return {String} Source of an image
     */
    getSrc(filtered) {
      const element = filtered ? this._element : this._originalElement;
      if (element) {
        if (element.toDataURL) {
          return element.toDataURL();
        }
        if (this.srcFromAttribute) {
          return element.getAttribute('src') || '';
        } else {
          return element.src;
        }
      } else {
        return this.src || '';
      }
    }

    /**
     * Alias for getSrc
     * @param filtered
     * @deprecated
     */
    getSvgSrc(filtered) {
      return this.getSrc(filtered);
    }

    /**
     * Loads and sets source of an image\
     * **IMPORTANT**: It is recommended to abort loading tasks before calling this method to prevent race conditions and unnecessary networking
     * @param {String} src Source string (URL)
     * @param {LoadImageOptions} [options] Options object
     */
    setSrc(src) {
      let {
        crossOrigin,
        signal
      } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return loadImage(src, {
        crossOrigin,
        signal
      }).then(img => {
        typeof crossOrigin !== 'undefined' && this.set({
          crossOrigin
        });
        this.setElement(img);
      });
    }

    /**
     * Returns string representation of an instance
     * @return {String} String representation of an instance
     */
    toString() {
      return "#<Image: { src: \"".concat(this.getSrc(), "\" }>");
    }
    applyResizeFilters() {
      const filter = this.resizeFilter,
        minimumScale = this.minimumScaleTrigger,
        objectScale = this.getTotalObjectScaling(),
        scaleX = objectScale.x,
        scaleY = objectScale.y,
        elementToFilter = this._filteredEl || this._originalElement;
      if (this.group) {
        this.set('dirty', true);
      }
      if (!filter || scaleX > minimumScale && scaleY > minimumScale) {
        this._element = elementToFilter;
        this._filterScalingX = 1;
        this._filterScalingY = 1;
        this._lastScaleX = scaleX;
        this._lastScaleY = scaleY;
        return;
      }
      const canvasEl = createCanvasElementFor(elementToFilter),
        {
          width,
          height
        } = elementToFilter;
      this._element = canvasEl;
      this._lastScaleX = filter.scaleX = scaleX;
      this._lastScaleY = filter.scaleY = scaleY;
      getFilterBackend().applyFilters([filter], elementToFilter, width, height, this._element);
      this._filterScalingX = canvasEl.width / this._originalElement.width;
      this._filterScalingY = canvasEl.height / this._originalElement.height;
    }

    /**
     * Applies filters assigned to this image (from "filters" array) or from filter param
     * @method applyFilters
     * @param {Array} filters to be applied
     * @param {Boolean} forResizing specify if the filter operation is a resize operation
     */
    applyFilters() {
      let filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.filters || [];
      filters = filters.filter(filter => filter && !filter.isNeutralState());
      this.set('dirty', true);

      // needs to clear out or WEBGL will not resize correctly
      this.removeTexture("".concat(this.cacheKey, "_filtered"));
      if (filters.length === 0) {
        this._element = this._originalElement;
        // this is unsafe and needs to be rethinkend
        this._filteredEl = undefined;
        this._filterScalingX = 1;
        this._filterScalingY = 1;
        return;
      }
      const imgElement = this._originalElement,
        sourceWidth = imgElement.naturalWidth || imgElement.width,
        sourceHeight = imgElement.naturalHeight || imgElement.height;
      if (this._element === this._originalElement) {
        // if the _element a reference to _originalElement
        // we need to create a new element to host the filtered pixels
        const canvasEl = createCanvasElementFor({
          width: sourceWidth,
          height: sourceHeight
        });
        this._element = canvasEl;
        this._filteredEl = canvasEl;
      } else if (this._filteredEl) {
        // if the _element is it own element,
        // and we also have a _filteredEl, then we clean up _filteredEl
        // and we assign it to _element.
        // in this way we invalidate the eventual old resize filtered element
        this._element = this._filteredEl;
        this._filteredEl.getContext('2d').clearRect(0, 0, sourceWidth, sourceHeight);
        // we also need to resize again at next renderAll, so remove saved _lastScaleX/Y
        this._lastScaleX = 1;
        this._lastScaleY = 1;
      }
      getFilterBackend().applyFilters(filters, this._originalElement, sourceWidth, sourceHeight, this._element, this.cacheKey);
      if (this._originalElement.width !== this._element.width || this._originalElement.height !== this._element.height) {
        this._filterScalingX = this._element.width / this._originalElement.width;
        this._filterScalingY = this._element.height / this._originalElement.height;
      }
    }

    /**
     * @private
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    _render(ctx) {
      ctx.imageSmoothingEnabled = this.imageSmoothing;
      if (this.isMoving !== true && this.resizeFilter && this._needsResize()) {
        this.applyResizeFilters();
      }
      this._stroke(ctx);
      this._renderPaintInOrder(ctx);
    }

    /**
     * Paint the cached copy of the object on the target context.
     * it will set the imageSmoothing for the draw operation
     * @param {CanvasRenderingContext2D} ctx Context to render on
     */
    drawCacheOnCanvas(ctx) {
      ctx.imageSmoothingEnabled = this.imageSmoothing;
      super.drawCacheOnCanvas(ctx);
    }

    /**
     * Decide if the FabricImage should cache or not. Create its own cache level
     * needsItsOwnCache should be used when the object drawing method requires
     * a cache step.
     * Generally you do not cache objects in groups because the group outside is cached.
     * This is the special Image version where we would like to avoid caching where possible.
     * Essentially images do not benefit from caching. They may require caching, and in that
     * case we do it. Also caching an image usually ends in a loss of details.
     * A full performance audit should be done.
     * @return {Boolean}
     */
    shouldCache() {
      return this.needsItsOwnCache();
    }
    _renderFill(ctx) {
      const elementToDraw = this._element;
      if (!elementToDraw) {
        return;
      }
      const scaleX = this._filterScalingX,
        scaleY = this._filterScalingY,
        w = this.width,
        h = this.height,
        // crop values cannot be lesser than 0.
        cropX = Math.max(this.cropX, 0),
        cropY = Math.max(this.cropY, 0),
        elWidth = elementToDraw.naturalWidth || elementToDraw.width,
        elHeight = elementToDraw.naturalHeight || elementToDraw.height,
        sX = cropX * scaleX,
        sY = cropY * scaleY,
        // the width height cannot exceed element width/height, starting from the crop offset.
        sW = Math.min(w * scaleX, elWidth - sX),
        sH = Math.min(h * scaleY, elHeight - sY),
        x = -w / 2,
        y = -h / 2,
        maxDestW = Math.min(w, elWidth / scaleX - cropX),
        maxDestH = Math.min(h, elHeight / scaleY - cropY);
      elementToDraw && ctx.drawImage(elementToDraw, sX, sY, sW, sH, x, y, maxDestW, maxDestH);
    }

    /**
     * needed to check if image needs resize
     * @private
     */
    _needsResize() {
      const scale = this.getTotalObjectScaling();
      return scale.x !== this._lastScaleX || scale.y !== this._lastScaleY;
    }

    /**
     * @private
     * @deprecated unused
     */
    _resetWidthHeight() {
      this.set(this.getOriginalSize());
    }

    /**
     * @private
     * Set the width and the height of the image object, using the element or the
     * options.
     */
    _setWidthHeight() {
      let {
        width,
        height
      } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      const size = this.getOriginalSize();
      this.width = width || size.width;
      this.height = height || size.height;
    }

    /**
     * Calculate offset for center and scale factor for the image in order to respect
     * the preserveAspectRatio attribute
     * @private
     */
    parsePreserveAspectRatioAttribute() {
      const pAR = parsePreserveAspectRatioAttribute(this.preserveAspectRatio || ''),
        pWidth = this.width,
        pHeight = this.height,
        parsedAttributes = {
          width: pWidth,
          height: pHeight
        };
      let rWidth = this._element.width,
        rHeight = this._element.height,
        scaleX = 1,
        scaleY = 1,
        offsetLeft = 0,
        offsetTop = 0,
        cropX = 0,
        cropY = 0,
        offset;
      if (pAR && (pAR.alignX !== NONE || pAR.alignY !== NONE)) {
        if (pAR.meetOrSlice === 'meet') {
          scaleX = scaleY = findScaleToFit(this._element, parsedAttributes);
          offset = (pWidth - rWidth * scaleX) / 2;
          if (pAR.alignX === 'Min') {
            offsetLeft = -offset;
          }
          if (pAR.alignX === 'Max') {
            offsetLeft = offset;
          }
          offset = (pHeight - rHeight * scaleY) / 2;
          if (pAR.alignY === 'Min') {
            offsetTop = -offset;
          }
          if (pAR.alignY === 'Max') {
            offsetTop = offset;
          }
        }
        if (pAR.meetOrSlice === 'slice') {
          scaleX = scaleY = findScaleToCover(this._element, parsedAttributes);
          offset = rWidth - pWidth / scaleX;
          if (pAR.alignX === 'Mid') {
            cropX = offset / 2;
          }
          if (pAR.alignX === 'Max') {
            cropX = offset;
          }
          offset = rHeight - pHeight / scaleY;
          if (pAR.alignY === 'Mid') {
            cropY = offset / 2;
          }
          if (pAR.alignY === 'Max') {
            cropY = offset;
          }
          rWidth = pWidth / scaleX;
          rHeight = pHeight / scaleY;
        }
      } else {
        scaleX = pWidth / rWidth;
        scaleY = pHeight / rHeight;
      }
      return {
        width: rWidth,
        height: rHeight,
        scaleX,
        scaleY,
        offsetLeft,
        offsetTop,
        cropX,
        cropY
      };
    }

    /**
     * Default CSS class name for canvas
     * Will be removed from fabric 7
     * @static
     * @deprecated
     * @type String
     * @default
     */

    /**
     * Creates an instance of FabricImage from its object representation
     * @static
     * @param {Object} object Object to create an instance from
     * @param {object} [options] Options object
     * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
     * @returns {Promise<FabricImage>}
     */
    static fromObject(_ref, options) {
      let {
          filters: f,
          resizeFilter: rf,
          src,
          crossOrigin,
          type
        } = _ref,
        object = _objectWithoutProperties(_ref, _excluded$2);
      return Promise.all([loadImage(src, _objectSpread2(_objectSpread2({}, options), {}, {
        crossOrigin
      })), f && enlivenObjects(f, options),
      // TODO: redundant - handled by enlivenObjectEnlivables
      rf && enlivenObjects([rf], options), enlivenObjectEnlivables(object, options)]).then(_ref2 => {
        let [el, filters = [], [resizeFilter] = [], hydratedProps = {}] = _ref2;
        return new this(el, _objectSpread2(_objectSpread2({}, object), {}, {
          // TODO: this creates a difference between image creation and restoring from JSON
          src,
          filters,
          resizeFilter
        }, hydratedProps));
      });
    }

    /**
     * Creates an instance of Image from an URL string
     * @static
     * @param {String} url URL to create an image from
     * @param {LoadImageOptions} [options] Options object
     * @returns {Promise<FabricImage>}
     */
    static fromURL(url) {
      let {
        crossOrigin = null,
        signal
      } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      let imageOptions = arguments.length > 2 ? arguments[2] : undefined;
      return loadImage(url, {
        crossOrigin,
        signal
      }).then(img => new this(img, imageOptions));
    }

    /**
     * Returns {@link FabricImage} instance from an SVG element
     * @static
     * @param {HTMLElement} element Element to parse
     * @param {Object} [options] Options object
     * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
     * @param {Function} callback Callback to execute when Image object is created
     */
    static async fromElement(element) {
      let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      let cssRules = arguments.length > 2 ? arguments[2] : undefined;
      const parsedAttributes = parseAttributes(element, this.ATTRIBUTE_NAMES, cssRules);
      return this.fromURL(parsedAttributes['xlink:href'] || parsedAttributes['href'], options, parsedAttributes).catch(err => {
        log('log', 'Unable to parse Image', err);
        return null;
      });
    }
  }
  _defineProperty(FabricImage, "type", 'Image');
  _defineProperty(FabricImage, "cacheProperties", [...cacheProperties, ...IMAGE_PROPS]);
  _defineProperty(FabricImage, "ownDefaults", imageDefaultValues);
  _defineProperty(FabricImage, "CSS_CANVAS", 'canvas-img');
  /**
   * List of attribute names to account for when parsing SVG element (used by {@link FabricImage.fromElement})
   * @static
   * @see {@link http://www.w3.org/TR/SVG/struct.html#ImageElement}
   */
  _defineProperty(FabricImage, "ATTRIBUTE_NAMES", [...SHARED_ATTRIBUTES, 'x', 'y', 'width', 'height', 'preserveAspectRatio', 'xlink:href', 'href', 'crossOrigin', 'image-rendering']);
  classRegistry.setClass(FabricImage);
  classRegistry.setSVGClass(FabricImage);

  /**
   * Add a <g> element that envelop all child elements and makes the viewbox transformMatrix descend on all elements
   */
  function applyViewboxTransform(element) {
    if (!svgViewBoxElementsRegEx.test(element.nodeName)) {
      return {};
    }
    const viewBoxAttr = element.getAttribute('viewBox');
    let scaleX = 1;
    let scaleY = 1;
    let minX = 0;
    let minY = 0;
    let matrix;
    let el;
    const widthAttr = element.getAttribute('width');
    const heightAttr = element.getAttribute('height');
    const x = element.getAttribute('x') || 0;
    const y = element.getAttribute('y') || 0;
    const goodViewbox = viewBoxAttr && reViewBoxAttrValue.test(viewBoxAttr);
    const missingViewBox = !goodViewbox;
    const missingDimAttr = !widthAttr || !heightAttr || widthAttr === '100%' || heightAttr === '100%';
    let translateMatrix = '';
    let widthDiff = 0;
    let heightDiff = 0;
    if (missingViewBox) {
      if ((x || y) && element.parentNode && element.parentNode.nodeName !== '#document') {
        translateMatrix = ' translate(' + parseUnit(x || '0') + ' ' + parseUnit(y || '0') + ') ';
        matrix = (element.getAttribute('transform') || '') + translateMatrix;
        element.setAttribute('transform', matrix);
        element.removeAttribute('x');
        element.removeAttribute('y');
      }
    }
    if (missingViewBox && missingDimAttr) {
      return {
        width: 0,
        height: 0
      };
    }
    const parsedDim = {
      width: 0,
      height: 0
    };
    if (missingViewBox) {
      parsedDim.width = parseUnit(widthAttr);
      parsedDim.height = parseUnit(heightAttr);
      // set a transform for elements that have x y and are inner(only) SVGs
      return parsedDim;
    }
    const pasedViewBox = viewBoxAttr.match(reViewBoxAttrValue);
    minX = -parseFloat(pasedViewBox[1]);
    minY = -parseFloat(pasedViewBox[2]);
    const viewBoxWidth = parseFloat(pasedViewBox[3]);
    const viewBoxHeight = parseFloat(pasedViewBox[4]);
    parsedDim.minX = minX;
    parsedDim.minY = minY;
    parsedDim.viewBoxWidth = viewBoxWidth;
    parsedDim.viewBoxHeight = viewBoxHeight;
    if (!missingDimAttr) {
      parsedDim.width = parseUnit(widthAttr);
      parsedDim.height = parseUnit(heightAttr);
      scaleX = parsedDim.width / viewBoxWidth;
      scaleY = parsedDim.height / viewBoxHeight;
    } else {
      parsedDim.width = viewBoxWidth;
      parsedDim.height = viewBoxHeight;
    }

    // default is to preserve aspect ratio
    const preserveAspectRatio = parsePreserveAspectRatioAttribute(element.getAttribute('preserveAspectRatio') || '');
    if (preserveAspectRatio.alignX !== NONE) {
      //translate all container for the effect of Mid, Min, Max
      if (preserveAspectRatio.meetOrSlice === 'meet') {
        scaleY = scaleX = scaleX > scaleY ? scaleY : scaleX;
        // calculate additional translation to move the viewbox
      }
      if (preserveAspectRatio.meetOrSlice === 'slice') {
        scaleY = scaleX = scaleX > scaleY ? scaleX : scaleY;
        // calculate additional translation to move the viewbox
      }
      widthDiff = parsedDim.width - viewBoxWidth * scaleX;
      heightDiff = parsedDim.height - viewBoxHeight * scaleX;
      if (preserveAspectRatio.alignX === 'Mid') {
        widthDiff /= 2;
      }
      if (preserveAspectRatio.alignY === 'Mid') {
        heightDiff /= 2;
      }
      if (preserveAspectRatio.alignX === 'Min') {
        widthDiff = 0;
      }
      if (preserveAspectRatio.alignY === 'Min') {
        heightDiff = 0;
      }
    }
    if (scaleX === 1 && scaleY === 1 && minX === 0 && minY === 0 && x === 0 && y === 0) {
      return parsedDim;
    }
    if ((x || y) && element.parentNode.nodeName !== '#document') {
      translateMatrix = ' translate(' + parseUnit(x || '0') + ' ' + parseUnit(y || '0') + ') ';
    }
    matrix = translateMatrix + ' matrix(' + scaleX + ' 0' + ' 0 ' + scaleY + ' ' + (minX * scaleX + widthDiff) + ' ' + (minY * scaleY + heightDiff) + ') ';
    // seems unused.
    // parsedDim.viewboxTransform = parseTransformAttribute(matrix);
    if (element.nodeName === 'svg') {
      el = element.ownerDocument.createElementNS(svgNS, 'g');
      // element.firstChild != null
      while (element.firstChild) {
        el.appendChild(element.firstChild);
      }
      element.appendChild(el);
    } else {
      el = element;
      el.removeAttribute('x');
      el.removeAttribute('y');
      matrix = el.getAttribute('transform') + matrix;
    }
    el.setAttribute('transform', matrix);
    return parsedDim;
  }

  const getTagName = node => node.tagName.replace('svg:', '');

  const svgInvalidAncestorsRegEx = getSvgRegex(svgInvalidAncestors);
  function hasInvalidAncestor(element) {
    let _element = element;
    while (_element && (_element = _element.parentElement)) {
      if (_element && _element.nodeName && svgInvalidAncestorsRegEx.test(getTagName(_element)) && !_element.getAttribute('instantiated_by_use')) {
        return true;
      }
    }
    return false;
  }

  function getMultipleNodes(doc, nodeNames) {
    let nodeName,
      nodeArray = [],
      nodeList,
      i,
      len;
    for (i = 0, len = nodeNames.length; i < len; i++) {
      nodeName = nodeNames[i];
      nodeList = doc.getElementsByTagNameNS('http://www.w3.org/2000/svg', nodeName);
      nodeArray = nodeArray.concat(Array.from(nodeList));
    }
    return nodeArray;
  }

  function parseUseDirectives(doc) {
    const nodelist = getMultipleNodes(doc, ['use', 'svg:use']);
    const skipAttributes = ['x', 'y', 'xlink:href', 'href', 'transform'];
    for (const useElement of nodelist) {
      const useAttributes = useElement.attributes;
      const useAttrMap = {};
      for (const attr of useAttributes) {
        attr.value && (useAttrMap[attr.name] = attr.value);
      }
      const xlink = (useAttrMap['xlink:href'] || useAttrMap.href || '').slice(1);
      if (xlink === '') {
        return;
      }
      const referencedElement = doc.getElementById(xlink);
      if (referencedElement === null) {
        // if we can't find the target of the xlink, consider this use tag bad, similar to no xlink
        return;
      }
      let clonedOriginal = referencedElement.cloneNode(true);
      const originalAttributes = clonedOriginal.attributes;
      const originalAttrMap = {};
      for (const attr of originalAttributes) {
        attr.value && (originalAttrMap[attr.name] = attr.value);
      }

      // Transform attribute needs to be merged in a particular way
      const {
        x = 0,
        y = 0,
        transform = ''
      } = useAttrMap;
      const currentTrans = "".concat(transform, " ").concat(originalAttrMap.transform || '', " translate(").concat(x, ", ").concat(y, ")");
      applyViewboxTransform(clonedOriginal);
      if (/^svg$/i.test(clonedOriginal.nodeName)) {
        // if is an SVG, create a group and apply all the attributes on top of it
        const el3 = clonedOriginal.ownerDocument.createElementNS(svgNS, 'g');
        Object.entries(originalAttrMap).forEach(_ref => {
          let [name, value] = _ref;
          return el3.setAttributeNS(svgNS, name, value);
        });
        el3.append(...clonedOriginal.childNodes);
        clonedOriginal = el3;
      }
      for (const attr of useAttributes) {
        if (!attr) {
          continue;
        }
        const {
          name,
          value
        } = attr;
        if (skipAttributes.includes(name)) {
          continue;
        }
        if (name === 'style') {
          // when use has a style, merge the two styles, with the ref being priority (not use)
          // priority is by feature. an attribute for fill on the original element
          // will overwrite the fill in style or attribute for tha use
          const styleRecord = {};
          parseStyleString(value, styleRecord);
          // cleanup styleRecord from attributes of original
          Object.entries(originalAttrMap).forEach(_ref2 => {
            let [name, value] = _ref2;
            styleRecord[name] = value;
          });
          // now we can put in the style of the original that will overwrite the original attributes
          parseStyleString(originalAttrMap.style || '', styleRecord);
          const mergedStyles = Object.entries(styleRecord).map(entry => entry.join(':')).join(';');
          clonedOriginal.setAttribute(name, mergedStyles);
        } else {
          // set the attribute from use element only if the original does not have it already
          !originalAttrMap[name] && clonedOriginal.setAttribute(name, value);
        }
      }
      clonedOriginal.setAttribute('transform', currentTrans);
      clonedOriginal.setAttribute('instantiated_by_use', '1');
      clonedOriginal.removeAttribute('id');
      useElement.parentNode.replaceChild(clonedOriginal, useElement);
    }
  }

  const gradientsAttrs = ['gradientTransform', 'x1', 'x2', 'y1', 'y2', 'gradientUnits', 'cx', 'cy', 'r', 'fx', 'fy'];
  const xlinkAttr = 'xlink:href';
  function recursivelyParseGradientsXlink(doc, gradient) {
    var _gradient$getAttribut;
    const xLink = ((_gradient$getAttribut = gradient.getAttribute(xlinkAttr)) === null || _gradient$getAttribut === void 0 ? void 0 : _gradient$getAttribut.slice(1)) || '',
      referencedGradient = doc.getElementById(xLink);
    if (referencedGradient && referencedGradient.getAttribute(xlinkAttr)) {
      recursivelyParseGradientsXlink(doc, referencedGradient);
    }
    if (referencedGradient) {
      gradientsAttrs.forEach(attr => {
        const value = referencedGradient.getAttribute(attr);
        if (!gradient.hasAttribute(attr) && value) {
          gradient.setAttribute(attr, value);
        }
      });
      if (!gradient.children.length) {
        const referenceClone = referencedGradient.cloneNode(true);
        while (referenceClone.firstChild) {
          gradient.appendChild(referenceClone.firstChild);
        }
      }
    }
    gradient.removeAttribute(xlinkAttr);
  }

  const tagArray = ['linearGradient', 'radialGradient', 'svg:linearGradient', 'svg:radialGradient'];

  /**
   * Parses an SVG document, returning all of the gradient declarations found in it
   * @param {SVGDocument} doc SVG document to parse
   * @return {Object} Gradient definitions; key corresponds to element id, value -- to gradient definition element
   */
  function getGradientDefs(doc) {
    const elList = getMultipleNodes(doc, tagArray);
    const gradientDefs = {};
    let j = elList.length;
    while (j--) {
      const el = elList[j];
      if (el.getAttribute('xlink:href')) {
        recursivelyParseGradientsXlink(doc, el);
      }
      const id = el.getAttribute('id');
      if (id) {
        gradientDefs[id] = el;
      }
    }
    return gradientDefs;
  }

  /**
   * Returns CSS rules for a given SVG document
   * @param {HTMLElement} doc SVG document to parse
   * @return {Object} CSS rules of this document
   */
  function getCSSRules(doc) {
    const styles = doc.getElementsByTagName('style');
    let i;
    let len;
    const allRules = {};

    // very crude parsing of style contents
    for (i = 0, len = styles.length; i < len; i++) {
      const styleContents = (styles[i].textContent || '').replace(
      // remove comments
      /\/\*[\s\S]*?\*\//g, '');
      if (styleContents.trim() === '') {
        continue;
      }
      // recovers all the rule in this form `body { style code... }`
      // rules = styleContents.match(/[^{]*\{[\s\S]*?\}/g);
      styleContents.split('}')
      // remove empty rules and remove everything if we didn't split in at least 2 pieces
      .filter((rule, index, array) => array.length > 1 && rule.trim())
      // at this point we have hopefully an array of rules `body { style code... `
      .forEach(rule => {
        // if there is more than one opening bracket and the rule starts with '@', it is likely
        // a nested at-rule like @media, @supports, @scope, etc. Ignore these as the code below
        // can not handle it.
        if ((rule.match(/{/g) || []).length > 1 && rule.trim().startsWith('@')) {
          return;
        }
        const match = rule.split('{'),
          ruleObj = {},
          declaration = match[1].trim(),
          propertyValuePairs = declaration.split(';').filter(function (pair) {
            return pair.trim();
          });
        for (i = 0, len = propertyValuePairs.length; i < len; i++) {
          const pair = propertyValuePairs[i].split(':'),
            property = pair[0].trim(),
            value = pair[1].trim();
          ruleObj[property] = value;
        }
        rule = match[0].trim();
        rule.split(',').forEach(_rule => {
          _rule = _rule.replace(/^svg/i, '').trim();
          if (_rule === '') {
            return;
          }
          allRules[_rule] = _objectSpread2(_objectSpread2({}, allRules[_rule] || {}), ruleObj);
        });
      });
    }
    return allRules;
  }

  const findTag = el => classRegistry.getSVGClass(getTagName(el).toLowerCase());
  class ElementsParser {
    constructor(elements, options, reviver, doc, clipPaths) {
      this.elements = elements;
      this.options = options;
      this.reviver = reviver;
      this.regexUrl = /^url\(['"]?#([^'"]+)['"]?\)/g;
      this.doc = doc;
      this.clipPaths = clipPaths;
      this.gradientDefs = getGradientDefs(doc);
      this.cssRules = getCSSRules(doc);
    }
    parse() {
      return Promise.all(this.elements.map(element => this.createObject(element)));
    }
    async createObject(el) {
      const klass = findTag(el);
      if (klass) {
        const obj = await klass.fromElement(el, this.options, this.cssRules);
        this.resolveGradient(obj, el, FILL);
        this.resolveGradient(obj, el, STROKE);
        if (obj instanceof FabricImage && obj._originalElement) {
          removeTransformMatrixForSvgParsing(obj, obj.parsePreserveAspectRatioAttribute());
        } else {
          removeTransformMatrixForSvgParsing(obj);
        }
        await this.resolveClipPath(obj, el);
        this.reviver && this.reviver(el, obj);
        return obj;
      }
      return null;
    }
    extractPropertyDefinition(obj, property, storage) {
      const value = obj[property],
        regex = this.regexUrl;
      if (!regex.test(value)) {
        return undefined;
      }
      // verify: can we remove the 'g' flag? and remove lastIndex changes?
      regex.lastIndex = 0;
      // we passed the regex test, so we know is not null;
      const id = regex.exec(value)[1];
      regex.lastIndex = 0;
      // @todo fix this
      return storage[id];
    }
    resolveGradient(obj, el, property) {
      const gradientDef = this.extractPropertyDefinition(obj, property, this.gradientDefs);
      if (gradientDef) {
        const opacityAttr = el.getAttribute(property + '-opacity');
        const gradient = Gradient.fromElement(gradientDef, obj, _objectSpread2(_objectSpread2({}, this.options), {}, {
          opacity: opacityAttr
        }));
        obj.set(property, gradient);
      }
    }

    // TODO: resolveClipPath could be run once per clippath with minor work per object.
    // is a refactor that i m not sure is worth on this code
    async resolveClipPath(obj, usingElement, exactOwner) {
      const clipPathElements = this.extractPropertyDefinition(obj, 'clipPath', this.clipPaths);
      if (clipPathElements) {
        const objTransformInv = invertTransform(obj.calcTransformMatrix());
        const clipPathTag = clipPathElements[0].parentElement;
        let clipPathOwner = usingElement;
        while (!exactOwner && clipPathOwner.parentElement && clipPathOwner.getAttribute('clip-path') !== obj.clipPath) {
          clipPathOwner = clipPathOwner.parentElement;
        }
        // move the clipPath tag as sibling to the real element that is using it
        clipPathOwner.parentElement.appendChild(clipPathTag);

        // this multiplication order could be opposite.
        // but i don't have an svg to test it
        // at the first SVG that has a transform on both places and is misplaced
        // try to invert this multiplication order
        const finalTransform = parseTransformAttribute("".concat(clipPathOwner.getAttribute('transform') || '', " ").concat(clipPathTag.getAttribute('originalTransform') || ''));
        clipPathTag.setAttribute('transform', "matrix(".concat(finalTransform.join(','), ")"));
        const container = await Promise.all(clipPathElements.map(clipPathElement => {
          return findTag(clipPathElement).fromElement(clipPathElement, this.options, this.cssRules).then(enlivedClippath => {
            removeTransformMatrixForSvgParsing(enlivedClippath);
            enlivedClippath.fillRule = enlivedClippath.clipRule;
            delete enlivedClippath.clipRule;
            return enlivedClippath;
          });
        }));
        const clipPath = container.length === 1 ? container[0] : new Group(container);
        const gTransform = multiplyTransformMatrices(objTransformInv, clipPath.calcTransformMatrix());
        if (clipPath.clipPath) {
          await this.resolveClipPath(clipPath, clipPathOwner,
          // this is tricky.
          // it tries to differentiate from when clipPaths are inherited by outside groups
          // or when are really clipPaths referencing other clipPaths
          clipPathTag.getAttribute('clip-path') ? clipPathOwner : undefined);
        }
        const {
          scaleX,
          scaleY,
          angle,
          skewX,
          translateX,
          translateY
        } = qrDecompose(gTransform);
        clipPath.set({
          flipX: false,
          flipY: false
        });
        clipPath.set({
          scaleX,
          scaleY,
          angle,
          skewX,
          skewY: 0
        });
        clipPath.setPositionByOrigin(new Point(translateX, translateY), CENTER, CENTER);
        obj.clipPath = clipPath;
      } else {
        // if clip-path does not resolve to any element, delete the property.
        delete obj.clipPath;
        return;
      }
    }
  }

  const isValidSvgTag = el => svgValidTagNamesRegEx.test(getTagName(el));
  const createEmptyResponse = () => ({
    objects: [],
    elements: [],
    options: {},
    allElements: []
  });

  /**
   * Parses an SVG document, converts it to an array of corresponding fabric.* instances and passes them to a callback
   * @static
   * @function
   * @memberOf fabric
   * @param {HTMLElement} doc SVG document to parse
   * @param {TSvgParsedCallback} callback Invoked when the parsing is done, with null if parsing wasn't possible with the list of svg nodes.
   * @param {TSvgReviverCallback} [reviver] Extra callback for further parsing of SVG elements, called after each fabric object has been created.
   * Takes as input the original svg element and the generated `FabricObject` as arguments. Used to inspect extra properties not parsed by fabric,
   * or extra custom manipulation
   * @param {Object} [options] Object containing options for parsing
   * @param {String} [options.crossOrigin] crossOrigin setting to use for external resources
   * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
   * @return {SVGParsingOutput}
   * {@link SVGParsingOutput} also receives `allElements` array as the last argument. This is the full list of svg nodes available in the document.
   * You may want to use it if you are trying to regroup the objects as they were originally grouped in the SVG. ( This was the reason why it was added )
   */
  async function parseSVGDocument(doc, reviver) {
    let {
      crossOrigin,
      signal
    } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (signal && signal.aborted) {
      log('log', new SignalAbortedError('parseSVGDocument'));
      // this is an unhappy path, we dont care about speed
      return createEmptyResponse();
    }
    const documentElement = doc.documentElement;
    parseUseDirectives(doc);
    const descendants = Array.from(documentElement.getElementsByTagName('*')),
      options = _objectSpread2(_objectSpread2({}, applyViewboxTransform(documentElement)), {}, {
        crossOrigin,
        signal
      });
    const elements = descendants.filter(el => {
      applyViewboxTransform(el);
      return isValidSvgTag(el) && !hasInvalidAncestor(el); // http://www.w3.org/TR/SVG/struct.html#DefsElement
    });
    if (!elements || elements && !elements.length) {
      return _objectSpread2(_objectSpread2({}, createEmptyResponse()), {}, {
        options,
        allElements: descendants
      });
    }
    const localClipPaths = {};
    descendants.filter(el => getTagName(el) === 'clipPath').forEach(el => {
      el.setAttribute('originalTransform', el.getAttribute('transform') || '');
      const id = el.getAttribute('id');
      localClipPaths[id] = Array.from(el.getElementsByTagName('*')).filter(el => isValidSvgTag(el));
    });

    // Precedence of rules:   style > class > attribute
    const elementParser = new ElementsParser(elements, options, reviver, doc, localClipPaths);
    const instances = await elementParser.parse();
    return {
      objects: instances,
      elements,
      options,
      allElements: descendants
    };
  }

  /**
   * Takes string corresponding to an SVG document, and parses it into a set of fabric objects
   * @memberOf fabric
   * @param {String} string representing the svg
   * @param {TSvgParsedCallback} callback Invoked when the parsing is done, with null if parsing wasn't possible with the list of svg nodes.
   * {@link TSvgParsedCallback} also receives `allElements` array as the last argument. This is the full list of svg nodes available in the document.
   * You may want to use it if you are trying to regroup the objects as they were originally grouped in the SVG. ( This was the reason why it was added )
   * @param {TSvgReviverCallback} [reviver] Extra callback for further parsing of SVG elements, called after each fabric object has been created.
   * Takes as input the original svg element and the generated `FabricObject` as arguments. Used to inspect extra properties not parsed by fabric,
   * or extra custom manipulation
   * @param {Object} [options] Object containing options for parsing
   * @param {String} [options.crossOrigin] crossOrigin setting to use for external resources
   * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
   */
  function loadSVGFromString(string, reviver, options) {
    const parser = new (getFabricWindow().DOMParser)(),
      // should we use `image/svg+xml` here?
      doc = parser.parseFromString(string.trim(), 'text/xml');
    return parseSVGDocument(doc, reviver, options);
  }

  /**
   * Takes url corresponding to an SVG document, and parses it into a set of fabric objects.
   * Note that SVG is fetched via XMLHttpRequest, so it needs to conform to SOP (Same Origin Policy)
   * @memberOf fabric
   * @param {string} url where the SVG is
   * @param {TSvgParsedCallback} callback Invoked when the parsing is done, with null if parsing wasn't possible with the list of svg nodes.
   * {@link TSvgParsedCallback} also receives `allElements` array as the last argument. This is the full list of svg nodes available in the document.
   * You may want to use it if you are trying to regroup the objects as they were originally grouped in the SVG. ( This was the reason why it was added )
   * @param {TSvgReviverCallback} [reviver] Extra callback for further parsing of SVG elements, called after each fabric object has been created.
   * Takes as input the original svg element and the generated `FabricObject` as arguments. Used to inspect extra properties not parsed by fabric,
   * or extra custom manipulation
   * @param {Object} [options] Object containing options for parsing
   * @param {String} [options.crossOrigin] crossOrigin setting to use for external resources
   * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
   */
  function loadSVGFromURL(url, reviver) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    // need to handle error properly
    return new Promise((resolve, reject) => {
      const onComplete = r => {
        const xml = r.responseXML;
        if (xml) {
          resolve(xml);
        }
        reject();
      };
      request(url.replace(/^\n\s*/, '').trim(), {
        onComplete,
        signal: options.signal
      });
    }).then(parsedDoc => parseSVGDocument(parsedDoc, reviver, options)).catch(() => {
      // this is an unhappy path, we dont care about speed
      return createEmptyResponse();
    });
  }

  const ACTION_NAME$1 = MODIFY_POLY;
  /**
   * This function locates the controls.
   * It'll be used both for drawing and for interaction.
   */
  const createPolyPositionHandler = pointIndex => {
    return function (dim, finalMatrix, polyObject) {
      const {
        points,
        pathOffset
      } = polyObject;
      return new Point(points[pointIndex]).subtract(pathOffset).transform(multiplyTransformMatrices(polyObject.getViewportTransform(), polyObject.calcTransformMatrix()));
    };
  };

  /**
   * This function defines what the control does.
   * It'll be called on every mouse move after a control has been clicked and is being dragged.
   * The function receives as argument the mouse event, the current transform object
   * and the current position in canvas coordinate `transform.target` is a reference to the
   * current object being transformed.
   */
  const polyActionHandler = (eventData, transform, x, y) => {
    const {
      target,
      pointIndex
    } = transform;
    const poly = target;
    const mouseLocalPosition = sendPointToPlane(new Point(x, y), undefined, poly.calcOwnMatrix());
    poly.points[pointIndex] = mouseLocalPosition.add(poly.pathOffset);
    poly.setDimensions();
    poly.set('dirty', true);
    return true;
  };

  /**
   * Keep the polygon in the same position when we change its `width`/`height`/`top`/`left`.
   */
  const factoryPolyActionHandler = (pointIndex, fn) => {
    return function (eventData, transform, x, y) {
      const poly = transform.target,
        anchorPoint = new Point(poly.points[(pointIndex > 0 ? pointIndex : poly.points.length) - 1]),
        anchorPointInParentPlane = anchorPoint.subtract(poly.pathOffset).transform(poly.calcOwnMatrix()),
        actionPerformed = fn(eventData, _objectSpread2(_objectSpread2({}, transform), {}, {
          pointIndex
        }), x, y);
      const newAnchorPointInParentPlane = anchorPoint.subtract(poly.pathOffset).transform(poly.calcOwnMatrix());
      const diff = newAnchorPointInParentPlane.subtract(anchorPointInParentPlane);
      poly.left -= diff.x;
      poly.top -= diff.y;
      return actionPerformed;
    };
  };
  const createPolyActionHandler = pointIndex => wrapWithFireEvent(ACTION_NAME$1, factoryPolyActionHandler(pointIndex, polyActionHandler));
  function createPolyControls(arg0) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const controls = {};
    for (let idx = 0; idx < (typeof arg0 === 'number' ? arg0 : arg0.points.length); idx++) {
      controls["p".concat(idx)] = new Control(_objectSpread2({
        actionName: ACTION_NAME$1,
        positionHandler: createPolyPositionHandler(idx),
        actionHandler: createPolyActionHandler(idx)
      }, options));
    }
    return controls;
  }

  const ACTION_NAME = 'modifyPath';
  const calcPathPointPosition = (pathObject, commandIndex, pointIndex) => {
    const {
      path,
      pathOffset
    } = pathObject;
    const command = path[commandIndex];
    return new Point(command[pointIndex] - pathOffset.x, command[pointIndex + 1] - pathOffset.y).transform(multiplyTransformMatrices(pathObject.getViewportTransform(), pathObject.calcTransformMatrix()));
  };
  const movePathPoint = (pathObject, x, y, commandIndex, pointIndex) => {
    const {
      path,
      pathOffset
    } = pathObject;
    const anchorCommand = path[(commandIndex > 0 ? commandIndex : path.length) - 1];
    const anchorPoint = new Point(anchorCommand[pointIndex], anchorCommand[pointIndex + 1]);
    const anchorPointInParentPlane = anchorPoint.subtract(pathOffset).transform(pathObject.calcOwnMatrix());
    const mouseLocalPosition = sendPointToPlane(new Point(x, y), undefined, pathObject.calcOwnMatrix());
    path[commandIndex][pointIndex] = mouseLocalPosition.x + pathOffset.x;
    path[commandIndex][pointIndex + 1] = mouseLocalPosition.y + pathOffset.y;
    pathObject.setDimensions();
    const newAnchorPointInParentPlane = anchorPoint.subtract(pathObject.pathOffset).transform(pathObject.calcOwnMatrix());
    const diff = newAnchorPointInParentPlane.subtract(anchorPointInParentPlane);
    pathObject.left -= diff.x;
    pathObject.top -= diff.y;
    pathObject.set('dirty', true);
    return true;
  };

  /**
   * This function locates the controls.
   * It'll be used both for drawing and for interaction.
   */
  function pathPositionHandler(dim, finalMatrix, pathObject) {
    const {
      commandIndex,
      pointIndex
    } = this;
    return calcPathPointPosition(pathObject, commandIndex, pointIndex);
  }

  /**
   * This function defines what the control does.
   * It'll be called on every mouse move after a control has been clicked and is being dragged.
   * The function receives as argument the mouse event, the current transform object
   * and the current position in canvas coordinate `transform.target` is a reference to the
   * current object being transformed.
   */
  function pathActionHandler(eventData, transform, x, y) {
    const {
      target
    } = transform;
    const {
      commandIndex,
      pointIndex
    } = this;
    const actionPerformed = movePathPoint(target, x, y, commandIndex, pointIndex);
    {
      fireEvent(this.actionName, _objectSpread2(_objectSpread2({}, commonEventInfo(eventData, transform, x, y)), {}, {
        commandIndex,
        pointIndex
      }));
    }
    return actionPerformed;
  }
  const indexFromPrevCommand = previousCommandType => previousCommandType === 'C' ? 5 : previousCommandType === 'Q' ? 3 : 1;
  class PathPointControl extends Control {
    constructor(options) {
      super(options);
    }
    render(ctx, left, top, styleOverride, fabricObject) {
      const overrides = _objectSpread2(_objectSpread2({}, styleOverride), {}, {
        cornerColor: this.controlFill,
        cornerStrokeColor: this.controlStroke,
        transparentCorners: !this.controlFill
      });
      super.render(ctx, left, top, overrides, fabricObject);
    }
  }
  class PathControlPointControl extends PathPointControl {
    constructor(options) {
      super(options);
    }
    render(ctx, left, top, styleOverride, fabricObject) {
      const {
        path
      } = fabricObject;
      const {
        commandIndex,
        pointIndex,
        connectToCommandIndex,
        connectToPointIndex
      } = this;
      ctx.save();
      ctx.strokeStyle = this.controlStroke;
      if (this.connectionDashArray) {
        ctx.setLineDash(this.connectionDashArray);
      }
      const [commandType] = path[commandIndex];
      const point = calcPathPointPosition(fabricObject, connectToCommandIndex, connectToPointIndex);
      if (commandType === 'Q') {
        // one control point connects to 2 points
        const point2 = calcPathPointPosition(fabricObject, commandIndex, pointIndex + 2);
        ctx.moveTo(point2.x, point2.y);
        ctx.lineTo(left, top);
      } else {
        ctx.moveTo(left, top);
      }
      ctx.lineTo(point.x, point.y);
      ctx.stroke();
      ctx.restore();
      super.render(ctx, left, top, styleOverride, fabricObject);
    }
  }
  const createControl = (commandIndexPos, pointIndexPos, isControlPoint, options, connectToCommandIndex, connectToPointIndex) => new (isControlPoint ? PathControlPointControl : PathPointControl)(_objectSpread2(_objectSpread2({
    commandIndex: commandIndexPos,
    pointIndex: pointIndexPos,
    actionName: ACTION_NAME,
    positionHandler: pathPositionHandler,
    actionHandler: pathActionHandler,
    connectToCommandIndex,
    connectToPointIndex
  }, options), isControlPoint ? options.controlPointStyle : options.pointStyle));
  function createPathControls(path) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const controls = {};
    let previousCommandType = 'M';
    path.path.forEach((command, commandIndex) => {
      const commandType = command[0];
      if (commandType !== 'Z') {
        controls["c_".concat(commandIndex, "_").concat(commandType)] = createControl(commandIndex, command.length - 2, false, options);
      }
      switch (commandType) {
        case 'C':
          controls["c_".concat(commandIndex, "_C_CP_1")] = createControl(commandIndex, 1, true, options, commandIndex - 1, indexFromPrevCommand(previousCommandType));
          controls["c_".concat(commandIndex, "_C_CP_2")] = createControl(commandIndex, 3, true, options, commandIndex, 5);
          break;
        case 'Q':
          controls["c_".concat(commandIndex, "_Q_CP_1")] = createControl(commandIndex, 1, true, options, commandIndex, 3);
          break;
      }
      previousCommandType = commandType;
    });
    return controls;
  }

  var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    changeWidth: changeWidth,
    createObjectDefaultControls: createObjectDefaultControls,
    createPathControls: createPathControls,
    createPolyActionHandler: createPolyActionHandler,
    createPolyControls: createPolyControls,
    createPolyPositionHandler: createPolyPositionHandler,
    createResizeControls: createResizeControls,
    createTextboxDefaultControls: createTextboxDefaultControls,
    dragHandler: dragHandler,
    factoryPolyActionHandler: factoryPolyActionHandler,
    getLocalPoint: getLocalPoint,
    polyActionHandler: polyActionHandler,
    renderCircleControl: renderCircleControl,
    renderSquareControl: renderSquareControl,
    rotationStyleHandler: rotationStyleHandler,
    rotationWithSnapping: rotationWithSnapping,
    scaleCursorStyleHandler: scaleCursorStyleHandler,
    scaleOrSkewActionName: scaleOrSkewActionName,
    scaleSkewCursorStyleHandler: scaleSkewCursorStyleHandler,
    scalingEqually: scalingEqually,
    scalingX: scalingX,
    scalingXOrSkewingY: scalingXOrSkewingY,
    scalingY: scalingY,
    scalingYOrSkewingX: scalingYOrSkewingX,
    skewCursorStyleHandler: skewCursorStyleHandler,
    skewHandlerX: skewHandlerX,
    skewHandlerY: skewHandlerY,
    wrapWithFireEvent: wrapWithFireEvent,
    wrapWithFixedAnchor: wrapWithFixedAnchor
  });

  const isWebGLPipelineState = options => {
    return options.webgl !== undefined;
  };

  /**
   * Pick a method to copy data from GL context to 2d canvas.  In some browsers using
   * drawImage should be faster, but is also bugged for a small combination of old hardware
   * and drivers.
   * putImageData is faster than drawImage for that specific operation.
   */
  const isPutImageFaster = (width, height) => {
    const targetCanvas = createCanvasElementFor({
      width,
      height
    });
    const sourceCanvas = createCanvasElement();
    const gl = sourceCanvas.getContext('webgl');
    // eslint-disable-next-line no-undef
    const imageBuffer = new ArrayBuffer(width * height * 4);
    const testContext = {
      imageBuffer: imageBuffer
    };
    const testPipelineState = {
      destinationWidth: width,
      destinationHeight: height,
      targetCanvas: targetCanvas
    };
    let startTime;
    startTime = getFabricWindow().performance.now();
    WebGLFilterBackend.prototype.copyGLTo2D.call(testContext, gl, testPipelineState);
    const drawImageTime = getFabricWindow().performance.now() - startTime;
    startTime = getFabricWindow().performance.now();
    WebGLFilterBackend.prototype.copyGLTo2DPutImageData.call(testContext, gl, testPipelineState);
    const putImageDataTime = getFabricWindow().performance.now() - startTime;
    return drawImageTime > putImageDataTime;
  };

  const highPsourceCode = "precision highp float";
  const identityFragmentShader = "\n    ".concat(highPsourceCode, ";\n    varying vec2 vTexCoord;\n    uniform sampler2D uTexture;\n    void main() {\n      gl_FragColor = texture2D(uTexture, vTexCoord);\n    }");
  const vertexSource$1 = "\n    attribute vec2 aPosition;\n    varying vec2 vTexCoord;\n    void main() {\n      vTexCoord = aPosition;\n      gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);\n    }";

  const _excluded$1 = ["type"],
    _excluded2 = ["type"];
  const regex = new RegExp(highPsourceCode, 'g');
  class BaseFilter {
    /**
     * Filter type
     * @param {String} type
     * @default
     */
    get type() {
      return this.constructor.type;
    }

    /**
     * The class type. Used to identify which class this is.
     * This is used for serialization purposes and internally it can be used
     * to identify classes. As a developer you could use `instance of Class`
     * but to avoid importing all the code and blocking tree shaking we try
     * to avoid doing that.
     */

    /**
     * Constructor
     * @param {Object} [options] Options object
     */
    constructor() {
      let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        options = _objectWithoutProperties(_ref, _excluded$1);
      Object.assign(this, this.constructor.defaults, options);
    }
    getFragmentSource() {
      return identityFragmentShader;
    }
    getVertexSource() {
      return vertexSource$1;
    }

    /**
     * Compile this filter's shader program.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context to use for shader compilation.
     * @param {String} fragmentSource fragmentShader source for compilation
     * @param {String} vertexSource vertexShader source for compilation
     */
    createProgram(gl) {
      let fragmentSource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getFragmentSource();
      let vertexSource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.getVertexSource();
      const {
        WebGLProbe: {
          GLPrecision = 'highp'
        }
      } = getEnv();
      if (GLPrecision !== 'highp') {
        fragmentSource = fragmentSource.replace(regex, highPsourceCode.replace('highp', GLPrecision));
      }
      const vertexShader = gl.createShader(gl.VERTEX_SHADER);
      const fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
      const program = gl.createProgram();
      if (!vertexShader || !fragmentShader || !program) {
        throw new FabricError('Vertex, fragment shader or program creation error');
      }
      gl.shaderSource(vertexShader, vertexSource);
      gl.compileShader(vertexShader);
      if (!gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS)) {
        throw new FabricError("Vertex shader compile error for ".concat(this.type, ": ").concat(gl.getShaderInfoLog(vertexShader)));
      }
      gl.shaderSource(fragmentShader, fragmentSource);
      gl.compileShader(fragmentShader);
      if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) {
        throw new FabricError("Fragment shader compile error for ".concat(this.type, ": ").concat(gl.getShaderInfoLog(fragmentShader)));
      }
      gl.attachShader(program, vertexShader);
      gl.attachShader(program, fragmentShader);
      gl.linkProgram(program);
      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
        throw new FabricError("Shader link error for \"".concat(this.type, "\" ").concat(gl.getProgramInfoLog(program)));
      }
      const uniformLocations = this.getUniformLocations(gl, program) || {};
      uniformLocations.uStepW = gl.getUniformLocation(program, 'uStepW');
      uniformLocations.uStepH = gl.getUniformLocation(program, 'uStepH');
      return {
        program,
        attributeLocations: this.getAttributeLocations(gl, program),
        uniformLocations
      };
    }

    /**
     * Return a map of attribute names to WebGLAttributeLocation objects.
     *
     * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
     * @param {WebGLShaderProgram} program The shader program from which to take attribute locations.
     * @returns {Object} A map of attribute names to attribute locations.
     */
    getAttributeLocations(gl, program) {
      return {
        aPosition: gl.getAttribLocation(program, 'aPosition')
      };
    }

    /**
     * Return a map of uniform names to WebGLUniformLocation objects.
     *
     * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
     * @param {WebGLShaderProgram} program The shader program from which to take uniform locations.
     * @returns {Object} A map of uniform names to uniform locations.
     */
    getUniformLocations(gl, program) {
      const locations = this.constructor.uniformLocations;
      const uniformLocations = {};
      for (let i = 0; i < locations.length; i++) {
        uniformLocations[locations[i]] = gl.getUniformLocation(program, locations[i]);
      }
      return uniformLocations;
    }

    /**
     * Send attribute data from this filter to its shader program on the GPU.
     *
     * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
     * @param {Object} attributeLocations A map of shader attribute names to their locations.
     */
    sendAttributeData(gl, attributeLocations, aPositionData) {
      const attributeLocation = attributeLocations.aPosition;
      const buffer = gl.createBuffer();
      gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
      gl.enableVertexAttribArray(attributeLocation);
      gl.vertexAttribPointer(attributeLocation, 2, gl.FLOAT, false, 0, 0);
      gl.bufferData(gl.ARRAY_BUFFER, aPositionData, gl.STATIC_DRAW);
    }
    _setupFrameBuffer(options) {
      const gl = options.context;
      if (options.passes > 1) {
        const width = options.destinationWidth;
        const height = options.destinationHeight;
        if (options.sourceWidth !== width || options.sourceHeight !== height) {
          gl.deleteTexture(options.targetTexture);
          options.targetTexture = options.filterBackend.createTexture(gl, width, height);
        }
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, options.targetTexture, 0);
      } else {
        // draw last filter on canvas and not to framebuffer.
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        gl.finish();
      }
    }
    _swapTextures(options) {
      options.passes--;
      options.pass++;
      const temp = options.targetTexture;
      options.targetTexture = options.sourceTexture;
      options.sourceTexture = temp;
    }

    /**
     * Generic isNeutral implementation for one parameter based filters.
     * Used only in image applyFilters to discard filters that will not have an effect
     * on the image
     * Other filters may need their own version ( ColorMatrix, HueRotation, gamma, ComposedFilter )
     * @param {Object} options
     **/
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isNeutralState(options) {
      return false;
    }

    /**
     * Apply this filter to the input image data provided.
     *
     * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
     *
     * @param {Object} options
     * @param {Number} options.passes The number of filters remaining to be executed
     * @param {Boolean} options.webgl Whether to use webgl to render the filter.
     * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
     * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */
    applyTo(options) {
      if (isWebGLPipelineState(options)) {
        this._setupFrameBuffer(options);
        this.applyToWebGL(options);
        this._swapTextures(options);
      } else {
        this.applyTo2d(options);
      }
    }
    applyTo2d(_options) {
      // override by subclass
    }

    /**
     * Returns a string that represent the current selected shader code for the filter.
     * Used to force recompilation when parameters change or to retrieve the shader from cache
     * @type string
     **/
    getCacheKey() {
      return this.type;
    }

    /**
     * Retrieves the cached shader.
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     * @return {WebGLProgram} the compiled program shader
     */
    retrieveShader(options) {
      const key = this.getCacheKey();
      if (!options.programCache[key]) {
        options.programCache[key] = this.createProgram(options.context);
      }
      return options.programCache[key];
    }

    /**
     * Apply this filter using webgl.
     *
     * @param {Object} options
     * @param {Number} options.passes The number of filters remaining to be executed
     * @param {Boolean} options.webgl Whether to use webgl to render the filter.
     * @param {WebGLTexture} options.originalTexture The texture of the original input image.
     * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
     * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */
    applyToWebGL(options) {
      const gl = options.context;
      const shader = this.retrieveShader(options);
      if (options.pass === 0 && options.originalTexture) {
        gl.bindTexture(gl.TEXTURE_2D, options.originalTexture);
      } else {
        gl.bindTexture(gl.TEXTURE_2D, options.sourceTexture);
      }
      gl.useProgram(shader.program);
      this.sendAttributeData(gl, shader.attributeLocations, options.aPosition);
      gl.uniform1f(shader.uniformLocations.uStepW, 1 / options.sourceWidth);
      gl.uniform1f(shader.uniformLocations.uStepH, 1 / options.sourceHeight);
      this.sendUniformData(gl, shader.uniformLocations);
      gl.viewport(0, 0, options.destinationWidth, options.destinationHeight);
      gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    }
    bindAdditionalTexture(gl, texture, textureUnit) {
      gl.activeTexture(textureUnit);
      gl.bindTexture(gl.TEXTURE_2D, texture);
      // reset active texture to 0 as usual
      gl.activeTexture(gl.TEXTURE0);
    }
    unbindAdditionalTexture(gl, textureUnit) {
      gl.activeTexture(textureUnit);
      gl.bindTexture(gl.TEXTURE_2D, null);
      gl.activeTexture(gl.TEXTURE0);
    }

    /**
     * Send uniform data from this filter to its shader program on the GPU.
     *
     * Intended to be overridden by subclasses.
     *
     * @param {WebGLRenderingContext} _gl The canvas context used to compile the shader program.
     * @param {Object} _uniformLocations A map of shader uniform names to their locations.
     */
    sendUniformData(_gl, _uniformLocations) {
      // override by subclass
    }

    /**
     * If needed by a 2d filter, this functions can create an helper canvas to be used
     * remember that options.targetCanvas is available for use till end of chain.
     */
    createHelpLayer(options) {
      if (!options.helpLayer) {
        const {
          sourceWidth,
          sourceHeight
        } = options;
        const helpLayer = createCanvasElementFor({
          width: sourceWidth,
          height: sourceHeight
        });
        options.helpLayer = helpLayer;
      }
    }

    /**
     * Returns object representation of an instance
     * It will automatically export the default values of a filter,
     * stored in the static defaults property.
     * @return {Object} Object representation of an instance
     */
    toObject() {
      const defaultKeys = Object.keys(this.constructor.defaults || {});
      return _objectSpread2({
        type: this.type
      }, defaultKeys.reduce((acc, key) => {
        acc[key] = this[key];
        return acc;
      }, {}));
    }

    /**
     * Returns a JSON representation of an instance
     * @return {Object} JSON
     */
    toJSON() {
      // delegate, not alias
      return this.toObject();
    }
    static async fromObject(_ref2, _options) {
      let filterOptions = _objectWithoutProperties(_ref2, _excluded2);
      return new this(filterOptions);
    }
  }
  _defineProperty(BaseFilter, "type", 'BaseFilter');
  /**
   * Contains the uniform locations for the fragment shader.
   * uStepW and uStepH are handled by the BaseFilter, each filter class
   * needs to specify all the one that are needed
   */
  _defineProperty(BaseFilter, "uniformLocations", []);

  const blendColorFragmentSource = {
    multiply: 'gl_FragColor.rgb *= uColor.rgb;\n',
    screen: 'gl_FragColor.rgb = 1.0 - (1.0 - gl_FragColor.rgb) * (1.0 - uColor.rgb);\n',
    add: 'gl_FragColor.rgb += uColor.rgb;\n',
    difference: 'gl_FragColor.rgb = abs(gl_FragColor.rgb - uColor.rgb);\n',
    subtract: 'gl_FragColor.rgb -= uColor.rgb;\n',
    lighten: 'gl_FragColor.rgb = max(gl_FragColor.rgb, uColor.rgb);\n',
    darken: 'gl_FragColor.rgb = min(gl_FragColor.rgb, uColor.rgb);\n',
    exclusion: 'gl_FragColor.rgb += uColor.rgb - 2.0 * (uColor.rgb * gl_FragColor.rgb);\n',
    overlay: "\n    if (uColor.r < 0.5) {\n      gl_FragColor.r *= 2.0 * uColor.r;\n    } else {\n      gl_FragColor.r = 1.0 - 2.0 * (1.0 - gl_FragColor.r) * (1.0 - uColor.r);\n    }\n    if (uColor.g < 0.5) {\n      gl_FragColor.g *= 2.0 * uColor.g;\n    } else {\n      gl_FragColor.g = 1.0 - 2.0 * (1.0 - gl_FragColor.g) * (1.0 - uColor.g);\n    }\n    if (uColor.b < 0.5) {\n      gl_FragColor.b *= 2.0 * uColor.b;\n    } else {\n      gl_FragColor.b = 1.0 - 2.0 * (1.0 - gl_FragColor.b) * (1.0 - uColor.b);\n    }\n    ",
    tint: "\n    gl_FragColor.rgb *= (1.0 - uColor.a);\n    gl_FragColor.rgb += uColor.rgb;\n    "
  };

  const blendColorDefaultValues = {
    color: '#F95C63',
    mode: 'multiply',
    alpha: 1
  };

  /**
   * Color Blend filter class
   * @example
   * const filter = new BlendColor({
   *  color: '#000',
   *  mode: 'multiply'
   * });
   *
   * const filter = new BlendImage({
   *  image: fabricImageObject,
   *  mode: 'multiply'
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */
  class BlendColor extends BaseFilter {
    getCacheKey() {
      return "".concat(this.type, "_").concat(this.mode);
    }
    getFragmentSource() {
      return "\n      precision highp float;\n      uniform sampler2D uTexture;\n      uniform vec4 uColor;\n      varying vec2 vTexCoord;\n      void main() {\n        vec4 color = texture2D(uTexture, vTexCoord);\n        gl_FragColor = color;\n        if (color.a > 0.0) {\n          ".concat(blendColorFragmentSource[this.mode], "\n        }\n      }\n      ");
    }

    /**
     * Apply the Blend operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */
    applyTo2d(_ref) {
      let {
        imageData: {
          data
        }
      } = _ref;
      const source = new Color(this.color).getSource();
      const alpha = this.alpha;
      const tr = source[0] * alpha;
      const tg = source[1] * alpha;
      const tb = source[2] * alpha;
      const alpha1 = 1 - alpha;
      for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];
        let oR, oG, oB;
        switch (this.mode) {
          case 'multiply':
            oR = r * tr / 255;
            oG = g * tg / 255;
            oB = b * tb / 255;
            break;
          case 'screen':
            oR = 255 - (255 - r) * (255 - tr) / 255;
            oG = 255 - (255 - g) * (255 - tg) / 255;
            oB = 255 - (255 - b) * (255 - tb) / 255;
            break;
          case 'add':
            oR = r + tr;
            oG = g + tg;
            oB = b + tb;
            break;
          case 'difference':
            oR = Math.abs(r - tr);
            oG = Math.abs(g - tg);
            oB = Math.abs(b - tb);
            break;
          case 'subtract':
            oR = r - tr;
            oG = g - tg;
            oB = b - tb;
            break;
          case 'darken':
            oR = Math.min(r, tr);
            oG = Math.min(g, tg);
            oB = Math.min(b, tb);
            break;
          case 'lighten':
            oR = Math.max(r, tr);
            oG = Math.max(g, tg);
            oB = Math.max(b, tb);
            break;
          case 'overlay':
            oR = tr < 128 ? 2 * r * tr / 255 : 255 - 2 * (255 - r) * (255 - tr) / 255;
            oG = tg < 128 ? 2 * g * tg / 255 : 255 - 2 * (255 - g) * (255 - tg) / 255;
            oB = tb < 128 ? 2 * b * tb / 255 : 255 - 2 * (255 - b) * (255 - tb) / 255;
            break;
          case 'exclusion':
            oR = tr + r - 2 * tr * r / 255;
            oG = tg + g - 2 * tg * g / 255;
            oB = tb + b - 2 * tb * b / 255;
            break;
          case 'tint':
            oR = tr + r * alpha1;
            oG = tg + g * alpha1;
            oB = tb + b * alpha1;
        }
        data[i] = oR;
        data[i + 1] = oG;
        data[i + 2] = oB;
      }
    }

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData(gl, uniformLocations) {
      const source = new Color(this.color).getSource();
      source[0] = this.alpha * source[0] / 255;
      source[1] = this.alpha * source[1] / 255;
      source[2] = this.alpha * source[2] / 255;
      source[3] = this.alpha;
      gl.uniform4fv(uniformLocations.uColor, source);
    }
  }
  /**
   * Color to make the blend operation with. default to a reddish color since black or white
   * gives always strong result.
   * @type String
   * @default
   **/
  /**
   * Blend mode for the filter: one of multiply, add, difference, screen, subtract,
   * darken, lighten, overlay, exclusion, tint.
   * @type String
   * @default
   **/
  /**
   * alpha value. represent the strength of the blend color operation.
   * @type Number
   * @default
   **/
  _defineProperty(BlendColor, "defaults", blendColorDefaultValues);
  _defineProperty(BlendColor, "type", 'BlendColor');
  _defineProperty(BlendColor, "uniformLocations", ['uColor']);
  classRegistry.setClass(BlendColor);

  const fragmentSource$c = {
    multiply: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform sampler2D uImage;\n    uniform vec4 uColor;\n    varying vec2 vTexCoord;\n    varying vec2 vTexCoord2;\n    void main() {\n      vec4 color = texture2D(uTexture, vTexCoord);\n      vec4 color2 = texture2D(uImage, vTexCoord2);\n      color.rgba *= color2.rgba;\n      gl_FragColor = color;\n    }\n    ",
    mask: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform sampler2D uImage;\n    uniform vec4 uColor;\n    varying vec2 vTexCoord;\n    varying vec2 vTexCoord2;\n    void main() {\n      vec4 color = texture2D(uTexture, vTexCoord);\n      vec4 color2 = texture2D(uImage, vTexCoord2);\n      color.a = color2.a;\n      gl_FragColor = color;\n    }\n    "
  };
  const vertexSource = "\n    attribute vec2 aPosition;\n    varying vec2 vTexCoord;\n    varying vec2 vTexCoord2;\n    uniform mat3 uTransformMatrix;\n    void main() {\n      vTexCoord = aPosition;\n      vTexCoord2 = (uTransformMatrix * vec3(aPosition, 1.0)).xy;\n      gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);\n    }\n    ";

  const _excluded = ["type", "image"];
  const blendImageDefaultValues = {
    mode: 'multiply',
    alpha: 1
  };

  /**
   * Image Blend filter class
   * @example
   * const filter = new filters.BlendColor({
   *  color: '#000',
   *  mode: 'multiply'
   * });
   *
   * const filter = new BlendImage({
   *  image: fabricImageObject,
   *  mode: 'multiply'
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */
  class BlendImage extends BaseFilter {
    getCacheKey() {
      return "".concat(this.type, "_").concat(this.mode);
    }
    getFragmentSource() {
      return fragmentSource$c[this.mode];
    }
    getVertexSource() {
      return vertexSource;
    }
    applyToWebGL(options) {
      const gl = options.context,
        texture = this.createTexture(options.filterBackend, this.image);
      this.bindAdditionalTexture(gl, texture, gl.TEXTURE1);
      super.applyToWebGL(options);
      this.unbindAdditionalTexture(gl, gl.TEXTURE1);
    }
    createTexture(backend, image) {
      return backend.getCachedTexture(image.cacheKey, image.getElement());
    }

    /**
     * Calculate a transformMatrix to adapt the image to blend over
     * @param {Object} options
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */
    calculateMatrix() {
      const image = this.image,
        {
          width,
          height
        } = image.getElement();
      return [1 / image.scaleX, 0, 0, 0, 1 / image.scaleY, 0, -image.left / width, -image.top / height, 1];
    }

    /**
     * Apply the Blend operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */
    applyTo2d(_ref) {
      let {
        imageData: {
          data,
          width,
          height
        },
        filterBackend: {
          resources
        }
      } = _ref;
      const image = this.image;
      if (!resources.blendImage) {
        resources.blendImage = createCanvasElement();
      }
      const canvas1 = resources.blendImage;
      const context = canvas1.getContext('2d');
      if (canvas1.width !== width || canvas1.height !== height) {
        canvas1.width = width;
        canvas1.height = height;
      } else {
        context.clearRect(0, 0, width, height);
      }
      context.setTransform(image.scaleX, 0, 0, image.scaleY, image.left, image.top);
      context.drawImage(image.getElement(), 0, 0, width, height);
      const blendData = context.getImageData(0, 0, width, height).data;
      for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];
        const a = data[i + 3];
        const tr = blendData[i];
        const tg = blendData[i + 1];
        const tb = blendData[i + 2];
        const ta = blendData[i + 3];
        switch (this.mode) {
          case 'multiply':
            data[i] = r * tr / 255;
            data[i + 1] = g * tg / 255;
            data[i + 2] = b * tb / 255;
            data[i + 3] = a * ta / 255;
            break;
          case 'mask':
            data[i + 3] = ta;
            break;
        }
      }
    }

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData(gl, uniformLocations) {
      const matrix = this.calculateMatrix();
      gl.uniform1i(uniformLocations.uImage, 1); // texture unit 1.
      gl.uniformMatrix3fv(uniformLocations.uTransformMatrix, false, matrix);
    }

    /**
     * Returns object representation of an instance
     * TODO: Handle the possibility of missing image better.
     * As of now a BlendImage filter without image can't be used with fromObject
     * @return {Object} Object representation of an instance
     */
    toObject() {
      return _objectSpread2(_objectSpread2({}, super.toObject()), {}, {
        image: this.image && this.image.toObject()
      });
    }

    /**
     * Create filter instance from an object representation
     * @static
     * @param {object} object Object to create an instance from
     * @param {object} [options]
     * @param {AbortSignal} [options.signal] handle aborting image loading, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
     * @returns {Promise<BlendImage>}
     */
    static async fromObject(_ref2, options) {
      let {
          type,
          image
        } = _ref2,
        filterOptions = _objectWithoutProperties(_ref2, _excluded);
      return FabricImage.fromObject(image, options).then(enlivedImage => new this(_objectSpread2(_objectSpread2({}, filterOptions), {}, {
        image: enlivedImage
      })));
    }
  }
  /**
   * Image to make the blend operation with.
   **/
  /**
   * Blend mode for the filter: either 'multiply' or 'mask'. 'multiply' will
   * multiply the values of each channel (R, G, B, and A) of the filter image by
   * their corresponding values in the base image. 'mask' will only look at the
   * alpha channel of the filter image, and apply those values to the base
   * image's alpha channel.
   * @type String
   * @default
   **/
  /**
   * alpha value. represent the strength of the blend image operation.
   * not implemented.
   **/
  _defineProperty(BlendImage, "type", 'BlendImage');
  _defineProperty(BlendImage, "defaults", blendImageDefaultValues);
  _defineProperty(BlendImage, "uniformLocations", ['uTransformMatrix', 'uImage']);
  classRegistry.setClass(BlendImage);

  const fragmentSource$b = "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform vec2 uDelta;\n    varying vec2 vTexCoord;\n    const float nSamples = 15.0;\n    vec3 v3offset = vec3(12.9898, 78.233, 151.7182);\n    float random(vec3 scale) {\n      /* use the fragment position for a different seed per-pixel */\n      return fract(sin(dot(gl_FragCoord.xyz, scale)) * 43758.5453);\n    }\n    void main() {\n      vec4 color = vec4(0.0);\n      float totalC = 0.0;\n      float totalA = 0.0;\n      float offset = random(v3offset);\n      for (float t = -nSamples; t <= nSamples; t++) {\n        float percent = (t + offset - 0.5) / nSamples;\n        vec4 sample = texture2D(uTexture, vTexCoord + uDelta * percent);\n        float weight = 1.0 - abs(percent);\n        float alpha = weight * sample.a;\n        color.rgb += sample.rgb * alpha;\n        color.a += alpha;\n        totalA += weight;\n        totalC += alpha;\n      }\n      gl_FragColor.rgb = color.rgb / totalC;\n      gl_FragColor.a = color.a / totalA;\n    }\n  ";

  const blurDefaultValues = {
    blur: 0
  };

  /**
   * Blur filter class
   * @example
   * const filter = new Blur({
   *   blur: 0.5
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */
  class Blur extends BaseFilter {
    getFragmentSource() {
      return fragmentSource$b;
    }
    applyTo(options) {
      if (isWebGLPipelineState(options)) {
        // this aspectRatio is used to give the same blur to vertical and horizontal
        this.aspectRatio = options.sourceWidth / options.sourceHeight;
        options.passes++;
        this._setupFrameBuffer(options);
        this.horizontal = true;
        this.applyToWebGL(options);
        this._swapTextures(options);
        this._setupFrameBuffer(options);
        this.horizontal = false;
        this.applyToWebGL(options);
        this._swapTextures(options);
      } else {
        this.applyTo2d(options);
      }
    }
    applyTo2d(_ref) {
      let {
        imageData: {
          data,
          width,
          height
        }
      } = _ref;
      // this code mimic the shader for output consistency
      // it samples 31 pixels across the image over a distance that depends from the blur value.
      this.aspectRatio = width / height;
      this.horizontal = true;
      let blurValue = this.getBlurValue() * width;
      const imageData = new Uint8ClampedArray(data);
      const samples = 15;
      const bytesInRow = 4 * width;
      for (let i = 0; i < data.length; i += 4) {
        let r = 0.0,
          g = 0.0,
          b = 0.0,
          a = 0.0,
          totalA = 0;
        const minIRow = i - i % bytesInRow;
        const maxIRow = minIRow + bytesInRow;
        // for now let's keep noise out of the way
        // let pixelOffset = 0;
        // const offset = Math.random() * 3;
        // if (offset > 2) {
        //   pixelOffset = 4;
        // } else if (offset < 1) {
        //   pixelOffset = -4;
        // }
        for (let j = -samples + 1; j < samples; j++) {
          const percent = j / samples;
          const distance = Math.floor(blurValue * percent) * 4;
          const weight = 1 - Math.abs(percent);
          let sampledPixel = i + distance; // + pixelOffset;
          // try to implement edge mirroring
          if (sampledPixel < minIRow) {
            sampledPixel = minIRow;
          } else if (sampledPixel > maxIRow) {
            sampledPixel = maxIRow;
          }
          const localAlpha = data[sampledPixel + 3] * weight;
          r += data[sampledPixel] * localAlpha;
          g += data[sampledPixel + 1] * localAlpha;
          b += data[sampledPixel + 2] * localAlpha;
          a += localAlpha;
          totalA += weight;
        }
        imageData[i] = r / a;
        imageData[i + 1] = g / a;
        imageData[i + 2] = b / a;
        imageData[i + 3] = a / totalA;
      }
      this.horizontal = false;
      blurValue = this.getBlurValue() * height;
      for (let i = 0; i < imageData.length; i += 4) {
        let r = 0.0,
          g = 0.0,
          b = 0.0,
          a = 0.0,
          totalA = 0;
        const minIRow = i % bytesInRow;
        const maxIRow = imageData.length - bytesInRow + minIRow;
        // for now let's keep noise out of the way
        // let pixelOffset = 0;
        // const offset = Math.random() * 3;
        // if (offset > 2) {
        //   pixelOffset = bytesInRow;
        // } else if (offset < 1) {
        //   pixelOffset = -bytesInRow;
        // }
        for (let j = -samples + 1; j < samples; j++) {
          const percent = j / samples;
          const distance = Math.floor(blurValue * percent) * bytesInRow;
          const weight = 1 - Math.abs(percent);
          let sampledPixel = i + distance; // + pixelOffset;
          // try to implement edge mirroring
          if (sampledPixel < minIRow) {
            sampledPixel = minIRow;
          } else if (sampledPixel > maxIRow) {
            sampledPixel = maxIRow;
          }
          const localAlpha = imageData[sampledPixel + 3] * weight;
          r += imageData[sampledPixel] * localAlpha;
          g += imageData[sampledPixel + 1] * localAlpha;
          b += imageData[sampledPixel + 2] * localAlpha;
          a += localAlpha;
          totalA += weight;
        }
        data[i] = r / a;
        data[i + 1] = g / a;
        data[i + 2] = b / a;
        data[i + 3] = a / totalA;
      }
    }

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData(gl, uniformLocations) {
      const delta = this.chooseRightDelta();
      gl.uniform2fv(uniformLocations.uDelta, delta);
    }
    isNeutralState() {
      return this.blur === 0;
    }
    getBlurValue() {
      let blurScale = 1;
      const {
        horizontal,
        aspectRatio
      } = this;
      if (horizontal) {
        if (aspectRatio > 1) {
          // image is wide, i want to shrink radius horizontal
          blurScale = 1 / aspectRatio;
        }
      } else {
        if (aspectRatio < 1) {
          // image is tall, i want to shrink radius vertical
          blurScale = aspectRatio;
        }
      }
      return blurScale * this.blur * 0.12;
    }

    /**
     * choose right value of image percentage to blur with
     * @returns {Array} a numeric array with delta values
     */
    chooseRightDelta() {
      const blur = this.getBlurValue();
      return this.horizontal ? [blur, 0] : [0, blur];
    }
  }
  /**
   * blur value, in percentage of image dimensions.
   * specific to keep the image blur constant at different resolutions
   * range between 0 and 1.
   * @type Number
   * @default
   */
  _defineProperty(Blur, "type", 'Blur');
  _defineProperty(Blur, "defaults", blurDefaultValues);
  _defineProperty(Blur, "uniformLocations", ['uDelta']);
  classRegistry.setClass(Blur);

  const fragmentSource$a = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  uniform float uBrightness;\n  varying vec2 vTexCoord;\n  void main() {\n    vec4 color = texture2D(uTexture, vTexCoord);\n    color.rgb += uBrightness;\n    gl_FragColor = color;\n  }\n";

  const brightnessDefaultValues = {
    brightness: 0
  };

  /**
   * Brightness filter class
   * @example
   * const filter = new Brightness({
   *   brightness: 0.05
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */
  class Brightness extends BaseFilter {
    getFragmentSource() {
      return fragmentSource$a;
    }

    /**
     * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */
    applyTo2d(_ref) {
      let {
        imageData: {
          data
        }
      } = _ref;
      const brightness = Math.round(this.brightness * 255);
      for (let i = 0; i < data.length; i += 4) {
        data[i] += brightness;
        data[i + 1] += brightness;
        data[i + 2] += brightness;
      }
    }
    isNeutralState() {
      return this.brightness === 0;
    }

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData(gl, uniformLocations) {
      gl.uniform1f(uniformLocations.uBrightness, this.brightness);
    }
  }
  /**
   * Brightness value, from -1 to 1.
   * translated to -255 to 255 for 2d
   * 0.0039215686 is the part of 1 that get translated to 1 in 2d
   * @param {Number} brightness
   * @default
   */
  _defineProperty(Brightness, "type", 'Brightness');
  _defineProperty(Brightness, "defaults", brightnessDefaultValues);
  _defineProperty(Brightness, "uniformLocations", ['uBrightness']);
  classRegistry.setClass(Brightness);

  const fragmentSource$9 = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  varying vec2 vTexCoord;\n  uniform mat4 uColorMatrix;\n  uniform vec4 uConstants;\n  void main() {\n    vec4 color = texture2D(uTexture, vTexCoord);\n    color *= uColorMatrix;\n    color += uConstants;\n    gl_FragColor = color;\n  }";

  const colorMatrixDefaultValues = {
    matrix: [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0],
    colorsOnly: true
  };

  /**
     * Color Matrix filter class
     * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
     * @see {@Link http://phoboslab.org/log/2013/11/fast-image-filters-with-webgl demo}
     * @example <caption>Kodachrome filter</caption>
     * const filter = new ColorMatrix({
     *  matrix: [
         1.1285582396593525, -0.3967382283601348, -0.03992559172921793, 0, 63.72958762196502,
         -0.16404339962244616, 1.0835251566291304, -0.05498805115633132, 0, 24.732407896706203,
         -0.16786010706155763, -0.5603416277695248, 1.6014850761964943, 0, 35.62982807460946,
         0, 0, 0, 1, 0
        ]
     * });
     * object.filters.push(filter);
     * object.applyFilters();
     */
  class ColorMatrix extends BaseFilter {
    getFragmentSource() {
      return fragmentSource$9;
    }

    /**
     * Apply the ColorMatrix operation to a Uint8Array representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8Array to be filtered.
     */
    applyTo2d(options) {
      const imageData = options.imageData,
        data = imageData.data,
        m = this.matrix,
        colorsOnly = this.colorsOnly;
      for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];
        data[i] = r * m[0] + g * m[1] + b * m[2] + m[4] * 255;
        data[i + 1] = r * m[5] + g * m[6] + b * m[7] + m[9] * 255;
        data[i + 2] = r * m[10] + g * m[11] + b * m[12] + m[14] * 255;
        if (!colorsOnly) {
          const a = data[i + 3];
          data[i] += a * m[3];
          data[i + 1] += a * m[8];
          data[i + 2] += a * m[13];
          data[i + 3] = r * m[15] + g * m[16] + b * m[17] + a * m[18] + m[19] * 255;
        }
      }
    }

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData(gl, uniformLocations) {
      const m = this.matrix,
        matrix = [m[0], m[1], m[2], m[3], m[5], m[6], m[7], m[8], m[10], m[11], m[12], m[13], m[15], m[16], m[17], m[18]],
        constants = [m[4], m[9], m[14], m[19]];
      gl.uniformMatrix4fv(uniformLocations.uColorMatrix, false, matrix);
      gl.uniform4fv(uniformLocations.uConstants, constants);
    }
    toObject() {
      return _objectSpread2(_objectSpread2({}, super.toObject()), {}, {
        matrix: [...this.matrix]
      });
    }
  }
  /**
   * Colormatrix for pixels.
   * array of 20 floats. Numbers in positions 4, 9, 14, 19 loose meaning
   * outside the -1, 1 range.
   * 0.0039215686 is the part of 1 that get translated to 1 in 2d
   * @param {Array} matrix array of 20 numbers.
   * @default
   */
  /**
   * Lock the colormatrix on the color part, skipping alpha, mainly for non webgl scenario
   * to save some calculation
   * @type Boolean
   * @default true
   */
  _defineProperty(ColorMatrix, "type", 'ColorMatrix');
  _defineProperty(ColorMatrix, "defaults", colorMatrixDefaultValues);
  _defineProperty(ColorMatrix, "uniformLocations", ['uColorMatrix', 'uConstants']);
  classRegistry.setClass(ColorMatrix);

  function createColorMatrixFilter(key, matrix) {
    var _Class;
    const newClass = (_Class = class newClass extends ColorMatrix {
      toObject() {
        return {
          type: this.type,
          colorsOnly: this.colorsOnly
        };
      }
    }, _defineProperty(_Class, "type", key), _defineProperty(_Class, "defaults", {
      colorsOnly: false,
      matrix
    }), _Class);
    classRegistry.setClass(newClass, key);
    return newClass;
  }
  const Brownie = createColorMatrixFilter('Brownie', [0.5997, 0.34553, -0.27082, 0, 0.186, -0.0377, 0.86095, 0.15059, 0, -0.1449, 0.24113, -0.07441, 0.44972, 0, -0.02965, 0, 0, 0, 1, 0]);
  const Vintage = createColorMatrixFilter('Vintage', [0.62793, 0.32021, -0.03965, 0, 0.03784, 0.02578, 0.64411, 0.03259, 0, 0.02926, 0.0466, -0.08512, 0.52416, 0, 0.02023, 0, 0, 0, 1, 0]);
  const Kodachrome = createColorMatrixFilter('Kodachrome', [1.12855, -0.39673, -0.03992, 0, 0.24991, -0.16404, 1.08352, -0.05498, 0, 0.09698, -0.16786, -0.56034, 1.60148, 0, 0.13972, 0, 0, 0, 1, 0]);
  const Technicolor = createColorMatrixFilter('Technicolor', [1.91252, -0.85453, -0.09155, 0, 0.04624, -0.30878, 1.76589, -0.10601, 0, -0.27589, -0.2311, -0.75018, 1.84759, 0, 0.12137, 0, 0, 0, 1, 0]);
  const Polaroid = createColorMatrixFilter('Polaroid', [1.438, -0.062, -0.062, 0, 0, -0.122, 1.378, -0.122, 0, 0, -0.016, -0.016, 1.483, 0, 0, 0, 0, 0, 1, 0]);
  const Sepia = createColorMatrixFilter('Sepia', [0.393, 0.769, 0.189, 0, 0, 0.349, 0.686, 0.168, 0, 0, 0.272, 0.534, 0.131, 0, 0, 0, 0, 0, 1, 0]);
  const BlackWhite = createColorMatrixFilter('BlackWhite', [1.5, 1.5, 1.5, 0, -1, 1.5, 1.5, 1.5, 0, -1, 1.5, 1.5, 1.5, 0, -1, 0, 0, 0, 1, 0]);

  /**
   * A container class that knows how to apply a sequence of filters to an input image.
   */
  class Composed extends BaseFilter {
    constructor() {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      super(options);
      this.subFilters = options.subFilters || [];
    }

    /**
     * Apply this container's filters to the input image provided.
     *
     * @param {Object} options
     * @param {Number} options.passes The number of filters remaining to be applied.
     */
    applyTo(options) {
      if (isWebGLPipelineState(options)) {
        options.passes += this.subFilters.length - 1;
      }
      this.subFilters.forEach(filter => {
        filter.applyTo(options);
      });
    }

    /**
     * Serialize this filter into JSON.
     * @returns {Object} A JSON representation of this filter.
     */
    toObject() {
      return {
        type: this.type,
        subFilters: this.subFilters.map(filter => filter.toObject())
      };
    }
    isNeutralState() {
      return !this.subFilters.some(filter => !filter.isNeutralState());
    }

    /**
     * Deserialize a JSON definition of a ComposedFilter into a concrete instance.
     * @static
     * @param {oject} object Object to create an instance from
     * @param {object} [options]
     * @param {AbortSignal} [options.signal] handle aborting `BlendImage` filter loading, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
     * @returns {Promise<Composed>}
     */
    static fromObject(object, options) {
      return Promise.all((object.subFilters || []).map(filter => classRegistry.getClass(filter.type).fromObject(filter, options))).then(enlivedFilters => new this({
        subFilters: enlivedFilters
      }));
    }
  }
  /**
   * A non sparse array of filters to apply
   */
  _defineProperty(Composed, "type", 'Composed');
  classRegistry.setClass(Composed);

  const fragmentSource$8 = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  uniform float uContrast;\n  varying vec2 vTexCoord;\n  void main() {\n    vec4 color = texture2D(uTexture, vTexCoord);\n    float contrastF = 1.015 * (uContrast + 1.0) / (1.0 * (1.015 - uContrast));\n    color.rgb = contrastF * (color.rgb - 0.5) + 0.5;\n    gl_FragColor = color;\n  }";

  const contrastDefaultValues = {
    contrast: 0
  };

  /**
   * Contrast filter class
   * @example
   * const filter = new Contrast({
   *   contrast: 0.25
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */
  class Contrast extends BaseFilter {
    getFragmentSource() {
      return fragmentSource$8;
    }
    isNeutralState() {
      return this.contrast === 0;
    }

    /**
     * Apply the Contrast operation to a Uint8Array representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8Array to be filtered.
     */
    applyTo2d(_ref) {
      let {
        imageData: {
          data
        }
      } = _ref;
      const contrast = Math.floor(this.contrast * 255),
        contrastF = 259 * (contrast + 255) / (255 * (259 - contrast));
      for (let i = 0; i < data.length; i += 4) {
        data[i] = contrastF * (data[i] - 128) + 128;
        data[i + 1] = contrastF * (data[i + 1] - 128) + 128;
        data[i + 2] = contrastF * (data[i + 2] - 128) + 128;
      }
    }

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData(gl, uniformLocations) {
      gl.uniform1f(uniformLocations.uContrast, this.contrast);
    }
  }
  /**
   * contrast value, range from -1 to 1.
   * @param {Number} contrast
   * @default 0
   */
  _defineProperty(Contrast, "type", 'Contrast');
  _defineProperty(Contrast, "defaults", contrastDefaultValues);
  _defineProperty(Contrast, "uniformLocations", ['uContrast']);
  classRegistry.setClass(Contrast);

  const fragmentSource$7 = {
    Convolute_3_1: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform float uMatrix[9];\n    uniform float uStepW;\n    uniform float uStepH;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = vec4(0, 0, 0, 0);\n      for (float h = 0.0; h < 3.0; h+=1.0) {\n        for (float w = 0.0; w < 3.0; w+=1.0) {\n          vec2 matrixPos = vec2(uStepW * (w - 1), uStepH * (h - 1));\n          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 3.0 + w)];\n        }\n      }\n      gl_FragColor = color;\n    }\n    ",
    Convolute_3_0: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform float uMatrix[9];\n    uniform float uStepW;\n    uniform float uStepH;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = vec4(0, 0, 0, 1);\n      for (float h = 0.0; h < 3.0; h+=1.0) {\n        for (float w = 0.0; w < 3.0; w+=1.0) {\n          vec2 matrixPos = vec2(uStepW * (w - 1.0), uStepH * (h - 1.0));\n          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 3.0 + w)];\n        }\n      }\n      float alpha = texture2D(uTexture, vTexCoord).a;\n      gl_FragColor = color;\n      gl_FragColor.a = alpha;\n    }\n    ",
    Convolute_5_1: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform float uMatrix[25];\n    uniform float uStepW;\n    uniform float uStepH;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = vec4(0, 0, 0, 0);\n      for (float h = 0.0; h < 5.0; h+=1.0) {\n        for (float w = 0.0; w < 5.0; w+=1.0) {\n          vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));\n          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 5.0 + w)];\n        }\n      }\n      gl_FragColor = color;\n    }\n    ",
    Convolute_5_0: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform float uMatrix[25];\n    uniform float uStepW;\n    uniform float uStepH;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = vec4(0, 0, 0, 1);\n      for (float h = 0.0; h < 5.0; h+=1.0) {\n        for (float w = 0.0; w < 5.0; w+=1.0) {\n          vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));\n          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 5.0 + w)];\n        }\n      }\n      float alpha = texture2D(uTexture, vTexCoord).a;\n      gl_FragColor = color;\n      gl_FragColor.a = alpha;\n    }\n    ",
    Convolute_7_1: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform float uMatrix[49];\n    uniform float uStepW;\n    uniform float uStepH;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = vec4(0, 0, 0, 0);\n      for (float h = 0.0; h < 7.0; h+=1.0) {\n        for (float w = 0.0; w < 7.0; w+=1.0) {\n          vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));\n          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 7.0 + w)];\n        }\n      }\n      gl_FragColor = color;\n    }\n    ",
    Convolute_7_0: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform float uMatrix[49];\n    uniform float uStepW;\n    uniform float uStepH;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = vec4(0, 0, 0, 1);\n      for (float h = 0.0; h < 7.0; h+=1.0) {\n        for (float w = 0.0; w < 7.0; w+=1.0) {\n          vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));\n          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 7.0 + w)];\n        }\n      }\n      float alpha = texture2D(uTexture, vTexCoord).a;\n      gl_FragColor = color;\n      gl_FragColor.a = alpha;\n    }\n    ",
    Convolute_9_1: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform float uMatrix[81];\n    uniform float uStepW;\n    uniform float uStepH;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = vec4(0, 0, 0, 0);\n      for (float h = 0.0; h < 9.0; h+=1.0) {\n        for (float w = 0.0; w < 9.0; w+=1.0) {\n          vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));\n          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 9.0 + w)];\n        }\n      }\n      gl_FragColor = color;\n    }\n    ",
    Convolute_9_0: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform float uMatrix[81];\n    uniform float uStepW;\n    uniform float uStepH;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = vec4(0, 0, 0, 1);\n      for (float h = 0.0; h < 9.0; h+=1.0) {\n        for (float w = 0.0; w < 9.0; w+=1.0) {\n          vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));\n          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 9.0 + w)];\n        }\n      }\n      float alpha = texture2D(uTexture, vTexCoord).a;\n      gl_FragColor = color;\n      gl_FragColor.a = alpha;\n    }\n    "
  };

  const convoluteDefaultValues = {
    opaque: false,
    matrix: [0, 0, 0, 0, 1, 0, 0, 0, 0]
  };

  /**
   * Adapted from <a href="http://www.html5rocks.com/en/tutorials/canvas/imagefilters/">html5rocks article</a>
   * @example <caption>Sharpen filter</caption>
   * const filter = new Convolute({
   *   matrix: [ 0, -1,  0,
   *            -1,  5, -1,
   *             0, -1,  0 ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   * @example <caption>Blur filter</caption>
   * const filter = new Convolute({
   *   matrix: [ 1/9, 1/9, 1/9,
   *             1/9, 1/9, 1/9,
   *             1/9, 1/9, 1/9 ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   * @example <caption>Emboss filter</caption>
   * const filter = new Convolute({
   *   matrix: [ 1,   1,  1,
   *             1, 0.7, -1,
   *            -1,  -1, -1 ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   * @example <caption>Emboss filter with opaqueness</caption>
   * const filter = new Convolute({
   *   opaque: true,
   *   matrix: [ 1,   1,  1,
   *             1, 0.7, -1,
   *            -1,  -1, -1 ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */
  class Convolute extends BaseFilter {
    getCacheKey() {
      return "".concat(this.type, "_").concat(Math.sqrt(this.matrix.length), "_").concat(this.opaque ? 1 : 0);
    }
    getFragmentSource() {
      return fragmentSource$7[this.getCacheKey()];
    }

    /**
     * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */
    applyTo2d(options) {
      const imageData = options.imageData,
        data = imageData.data,
        weights = this.matrix,
        side = Math.round(Math.sqrt(weights.length)),
        halfSide = Math.floor(side / 2),
        sw = imageData.width,
        sh = imageData.height,
        output = options.ctx.createImageData(sw, sh),
        dst = output.data,
        // go through the destination image pixels
        alphaFac = this.opaque ? 1 : 0;
      let r, g, b, a, dstOff, scx, scy, srcOff, wt, x, y, cx, cy;
      for (y = 0; y < sh; y++) {
        for (x = 0; x < sw; x++) {
          dstOff = (y * sw + x) * 4;
          // calculate the weighed sum of the source image pixels that
          // fall under the convolution matrix
          r = 0;
          g = 0;
          b = 0;
          a = 0;
          for (cy = 0; cy < side; cy++) {
            for (cx = 0; cx < side; cx++) {
              scy = y + cy - halfSide;
              scx = x + cx - halfSide;

              // eslint-disable-next-line max-depth
              if (scy < 0 || scy >= sh || scx < 0 || scx >= sw) {
                continue;
              }
              srcOff = (scy * sw + scx) * 4;
              wt = weights[cy * side + cx];
              r += data[srcOff] * wt;
              g += data[srcOff + 1] * wt;
              b += data[srcOff + 2] * wt;
              // eslint-disable-next-line max-depth
              if (!alphaFac) {
                a += data[srcOff + 3] * wt;
              }
            }
          }
          dst[dstOff] = r;
          dst[dstOff + 1] = g;
          dst[dstOff + 2] = b;
          if (!alphaFac) {
            dst[dstOff + 3] = a;
          } else {
            dst[dstOff + 3] = data[dstOff + 3];
          }
        }
      }
      options.imageData = output;
    }

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData(gl, uniformLocations) {
      gl.uniform1fv(uniformLocations.uMatrix, this.matrix);
    }

    /**
     * Returns object representation of an instance
     * @return {Object} Object representation of an instance
     */
    toObject() {
      return _objectSpread2(_objectSpread2({}, super.toObject()), {}, {
        opaque: this.opaque,
        matrix: [...this.matrix]
      });
    }
  }
  /*
   * Opaque value (true/false)
   */
  /*
   * matrix for the filter, max 9x9
   */
  _defineProperty(Convolute, "type", 'Convolute');
  _defineProperty(Convolute, "defaults", convoluteDefaultValues);
  _defineProperty(Convolute, "uniformLocations", ['uMatrix', 'uOpaque', 'uHalfSize', 'uSize']);
  classRegistry.setClass(Convolute);

  const fragmentSource$6 = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  uniform vec3 uGamma;\n  varying vec2 vTexCoord;\n  void main() {\n    vec4 color = texture2D(uTexture, vTexCoord);\n    vec3 correction = (1.0 / uGamma);\n    color.r = pow(color.r, correction.r);\n    color.g = pow(color.g, correction.g);\n    color.b = pow(color.b, correction.b);\n    gl_FragColor = color;\n    gl_FragColor.rgb *= color.a;\n  }\n";

  const GAMMA = 'Gamma';
  const gammaDefaultValues = {
    gamma: [1, 1, 1]
  };

  /**
   * Gamma filter class
   * @example
   * const filter = new Gamma({
   *   gamma: [1, 0.5, 2.1]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */
  class Gamma extends BaseFilter {
    getFragmentSource() {
      return fragmentSource$6;
    }
    constructor() {
      let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      super(options);
      this.gamma = options.gamma || this.constructor.defaults.gamma.concat();
    }

    /**
     * Apply the Gamma operation to a Uint8Array representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8Array to be filtered.
     */
    applyTo2d(_ref) {
      let {
        imageData: {
          data
        }
      } = _ref;
      const gamma = this.gamma,
        rInv = 1 / gamma[0],
        gInv = 1 / gamma[1],
        bInv = 1 / gamma[2];
      if (!this.rgbValues) {
        this.rgbValues = {
          r: new Uint8Array(256),
          g: new Uint8Array(256),
          b: new Uint8Array(256)
        };
      }

      // This is an optimization - pre-compute a look-up table for each color channel
      // instead of performing these pow calls for each pixel in the image.
      const rgb = this.rgbValues;
      for (let i = 0; i < 256; i++) {
        rgb.r[i] = Math.pow(i / 255, rInv) * 255;
        rgb.g[i] = Math.pow(i / 255, gInv) * 255;
        rgb.b[i] = Math.pow(i / 255, bInv) * 255;
      }
      for (let i = 0; i < data.length; i += 4) {
        data[i] = rgb.r[data[i]];
        data[i + 1] = rgb.g[data[i + 1]];
        data[i + 2] = rgb.b[data[i + 2]];
      }
    }

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData(gl, uniformLocations) {
      gl.uniform3fv(uniformLocations.uGamma, this.gamma);
    }
    isNeutralState() {
      const {
        gamma
      } = this;
      return gamma[0] === 1 && gamma[1] === 1 && gamma[2] === 1;
    }
    toObject() {
      return {
        type: GAMMA,
        gamma: this.gamma.concat()
      };
    }
  }
  /**
   * Gamma array value, from 0.01 to 2.2.
   * @param {Array} gamma
   * @default
   */
  _defineProperty(Gamma, "type", GAMMA);
  _defineProperty(Gamma, "defaults", gammaDefaultValues);
  _defineProperty(Gamma, "uniformLocations", ['uGamma']);
  classRegistry.setClass(Gamma);

  const fragmentSource$5 = {
    average: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = texture2D(uTexture, vTexCoord);\n      float average = (color.r + color.b + color.g) / 3.0;\n      gl_FragColor = vec4(average, average, average, color.a);\n    }\n    ",
    lightness: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform int uMode;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 col = texture2D(uTexture, vTexCoord);\n      float average = (max(max(col.r, col.g),col.b) + min(min(col.r, col.g),col.b)) / 2.0;\n      gl_FragColor = vec4(average, average, average, col.a);\n    }\n    ",
    luminosity: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform int uMode;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 col = texture2D(uTexture, vTexCoord);\n      float average = 0.21 * col.r + 0.72 * col.g + 0.07 * col.b;\n      gl_FragColor = vec4(average, average, average, col.a);\n    }\n    "
  };

  const grayscaleDefaultValues = {
    mode: 'average'
  };

  /**
   * Grayscale image filter class
   * @example
   * const filter = new Grayscale();
   * object.filters.push(filter);
   * object.applyFilters();
   */
  class Grayscale extends BaseFilter {
    /**
     * Apply the Grayscale operation to a Uint8Array representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8Array to be filtered.
     */
    applyTo2d(_ref) {
      let {
        imageData: {
          data
        }
      } = _ref;
      for (let i = 0, value; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];
        switch (this.mode) {
          case 'average':
            value = (r + g + b) / 3;
            break;
          case 'lightness':
            value = (Math.min(r, g, b) + Math.max(r, g, b)) / 2;
            break;
          case 'luminosity':
            value = 0.21 * r + 0.72 * g + 0.07 * b;
            break;
        }
        data[i + 2] = data[i + 1] = data[i] = value;
      }
    }
    getCacheKey() {
      return "".concat(this.type, "_").concat(this.mode);
    }
    getFragmentSource() {
      return fragmentSource$5[this.mode];
    }

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData(gl, uniformLocations) {
      const mode = 1;
      gl.uniform1i(uniformLocations.uMode, mode);
    }

    /**
     * Grayscale filter isNeutralState implementation
     * The filter is never neutral
     * on the image
     **/
    isNeutralState() {
      return false;
    }
  }
  _defineProperty(Grayscale, "type", 'Grayscale');
  _defineProperty(Grayscale, "defaults", grayscaleDefaultValues);
  _defineProperty(Grayscale, "uniformLocations", ['uMode']);
  classRegistry.setClass(Grayscale);

  const hueRotationDefaultValues = _objectSpread2(_objectSpread2({}, colorMatrixDefaultValues), {}, {
    rotation: 0
  });

  /**
   * HueRotation filter class
   * @example
   * const filter = new HueRotation({
   *   rotation: -0.5
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */
  class HueRotation extends ColorMatrix {
    calculateMatrix() {
      const rad = this.rotation * Math.PI,
        cosine = cos(rad),
        sine = sin(rad),
        aThird = 1 / 3,
        aThirdSqtSin = Math.sqrt(aThird) * sine,
        OneMinusCos = 1 - cosine;
      this.matrix = [cosine + OneMinusCos / 3, aThird * OneMinusCos - aThirdSqtSin, aThird * OneMinusCos + aThirdSqtSin, 0, 0, aThird * OneMinusCos + aThirdSqtSin, cosine + aThird * OneMinusCos, aThird * OneMinusCos - aThirdSqtSin, 0, 0, aThird * OneMinusCos - aThirdSqtSin, aThird * OneMinusCos + aThirdSqtSin, cosine + aThird * OneMinusCos, 0, 0, 0, 0, 0, 1, 0];
    }
    isNeutralState() {
      return this.rotation === 0;
    }
    applyTo(options) {
      this.calculateMatrix();
      super.applyTo(options);
    }
    toObject() {
      return {
        type: this.type,
        rotation: this.rotation
      };
    }
  }
  /**
   * HueRotation value, from -1 to 1.
   */
  _defineProperty(HueRotation, "type", 'HueRotation');
  _defineProperty(HueRotation, "defaults", hueRotationDefaultValues);
  classRegistry.setClass(HueRotation);

  const fragmentSource$4 = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  uniform int uInvert;\n  uniform int uAlpha;\n  varying vec2 vTexCoord;\n  void main() {\n    vec4 color = texture2D(uTexture, vTexCoord);\n    if (uInvert == 1) {\n      if (uAlpha == 1) {\n        gl_FragColor = vec4(1.0 - color.r,1.0 -color.g,1.0 -color.b,1.0 -color.a);\n      } else {\n        gl_FragColor = vec4(1.0 - color.r,1.0 -color.g,1.0 -color.b,color.a);\n      }\n    } else {\n      gl_FragColor = color;\n    }\n  }\n";

  const invertDefaultValues = {
    alpha: false,
    invert: true
  };

  /**
   * @example
   * const filter = new Invert();
   * object.filters.push(filter);
   * object.applyFilters(canvas.renderAll.bind(canvas));
   */
  class Invert extends BaseFilter {
    /**
     * Apply the Invert operation to a Uint8Array representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8Array to be filtered.
     */
    applyTo2d(_ref) {
      let {
        imageData: {
          data
        }
      } = _ref;
      for (let i = 0; i < data.length; i += 4) {
        data[i] = 255 - data[i];
        data[i + 1] = 255 - data[i + 1];
        data[i + 2] = 255 - data[i + 2];
        if (this.alpha) {
          data[i + 3] = 255 - data[i + 3];
        }
      }
    }
    getFragmentSource() {
      return fragmentSource$4;
    }

    /**
     * Invert filter isNeutralState implementation
     * Used only in image applyFilters to discard filters that will not have an effect
     * on the image
     * @param {Object} options
     **/
    isNeutralState() {
      return !this.invert;
    }

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData(gl, uniformLocations) {
      gl.uniform1i(uniformLocations.uInvert, Number(this.invert));
      gl.uniform1i(uniformLocations.uAlpha, Number(this.alpha));
    }
  }
  /**
   * Invert also alpha.
   * @param {Boolean} alpha
   * @default
   **/
  /**
   * Filter invert. if false, does nothing
   * @param {Boolean} invert
   * @default
   */
  _defineProperty(Invert, "type", 'Invert');
  _defineProperty(Invert, "defaults", invertDefaultValues);
  _defineProperty(Invert, "uniformLocations", ['uInvert', 'uAlpha']);
  classRegistry.setClass(Invert);

  const fragmentSource$3 = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  uniform float uStepH;\n  uniform float uNoise;\n  uniform float uSeed;\n  varying vec2 vTexCoord;\n  float rand(vec2 co, float seed, float vScale) {\n    return fract(sin(dot(co.xy * vScale ,vec2(12.9898 , 78.233))) * 43758.5453 * (seed + 0.01) / 2.0);\n  }\n  void main() {\n    vec4 color = texture2D(uTexture, vTexCoord);\n    color.rgb += (0.5 - rand(vTexCoord, uSeed, 0.1 / uStepH)) * uNoise;\n    gl_FragColor = color;\n  }\n";

  const noiseDefaultValues = {
    noise: 0
  };

  /**
   * Noise filter class
   * @example
   * const filter = new Noise({
   *   noise: 700
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */
  class Noise extends BaseFilter {
    getFragmentSource() {
      return fragmentSource$3;
    }

    /**
     * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */
    applyTo2d(_ref) {
      let {
        imageData: {
          data
        }
      } = _ref;
      const noise = this.noise;
      for (let i = 0; i < data.length; i += 4) {
        const rand = (0.5 - Math.random()) * noise;
        data[i] += rand;
        data[i + 1] += rand;
        data[i + 2] += rand;
      }
    }

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData(gl, uniformLocations) {
      gl.uniform1f(uniformLocations.uNoise, this.noise / 255);
      gl.uniform1f(uniformLocations.uSeed, Math.random());
    }
    isNeutralState() {
      return this.noise === 0;
    }
  }
  /**
   * Noise value, from
   * @param {Number} noise
   * @default
   */
  _defineProperty(Noise, "type", 'Noise');
  _defineProperty(Noise, "defaults", noiseDefaultValues);
  _defineProperty(Noise, "uniformLocations", ['uNoise', 'uSeed']);
  classRegistry.setClass(Noise);

  const fragmentSource$2 = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  uniform float uBlocksize;\n  uniform float uStepW;\n  uniform float uStepH;\n  varying vec2 vTexCoord;\n  void main() {\n    float blockW = uBlocksize * uStepW;\n    float blockH = uBlocksize * uStepH;\n    int posX = int(vTexCoord.x / blockW);\n    int posY = int(vTexCoord.y / blockH);\n    float fposX = float(posX);\n    float fposY = float(posY);\n    vec2 squareCoords = vec2(fposX * blockW, fposY * blockH);\n    vec4 color = texture2D(uTexture, squareCoords);\n    gl_FragColor = color;\n  }\n";

  const pixelateDefaultValues = {
    blocksize: 4
  };

  /**
   * Pixelate filter class
   * @example
   * const filter = new Pixelate({
   *   blocksize: 8
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */
  class Pixelate extends BaseFilter {
    /**
     * Apply the Pixelate operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */
    applyTo2d(_ref) {
      let {
        imageData: {
          data,
          width,
          height
        }
      } = _ref;
      for (let i = 0; i < height; i += this.blocksize) {
        for (let j = 0; j < width; j += this.blocksize) {
          const index = i * 4 * width + j * 4;
          const r = data[index];
          const g = data[index + 1];
          const b = data[index + 2];
          const a = data[index + 3];
          for (let _i = i; _i < Math.min(i + this.blocksize, height); _i++) {
            for (let _j = j; _j < Math.min(j + this.blocksize, width); _j++) {
              const index = _i * 4 * width + _j * 4;
              data[index] = r;
              data[index + 1] = g;
              data[index + 2] = b;
              data[index + 3] = a;
            }
          }
        }
      }
    }

    /**
     * Indicate when the filter is not gonna apply changes to the image
     **/
    isNeutralState() {
      return this.blocksize === 1;
    }
    getFragmentSource() {
      return fragmentSource$2;
    }

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData(gl, uniformLocations) {
      gl.uniform1f(uniformLocations.uBlocksize, this.blocksize);
    }
  }
  _defineProperty(Pixelate, "type", 'Pixelate');
  _defineProperty(Pixelate, "defaults", pixelateDefaultValues);
  _defineProperty(Pixelate, "uniformLocations", ['uBlocksize']);
  classRegistry.setClass(Pixelate);

  const fragmentShader = "\nprecision highp float;\nuniform sampler2D uTexture;\nuniform vec4 uLow;\nuniform vec4 uHigh;\nvarying vec2 vTexCoord;\nvoid main() {\n  gl_FragColor = texture2D(uTexture, vTexCoord);\n  if(all(greaterThan(gl_FragColor.rgb,uLow.rgb)) && all(greaterThan(uHigh.rgb,gl_FragColor.rgb))) {\n    gl_FragColor.a = 0.0;\n  }\n}\n";

  const removeColorDefaultValues = {
    color: '#FFFFFF',
    distance: 0.02,
    useAlpha: false
  };

  /**
   * Remove white filter class
   * @example
   * const filter = new RemoveColor({
   *   threshold: 0.2,
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   * canvas.renderAll();
   */
  class RemoveColor extends BaseFilter {
    getFragmentSource() {
      return fragmentShader;
    }

    /**
     * Applies filter to canvas element
     * @param {Object} canvasEl Canvas element to apply filter to
     */
    applyTo2d(_ref) {
      let {
        imageData: {
          data
        }
      } = _ref;
      const distance = this.distance * 255,
        source = new Color(this.color).getSource(),
        lowC = [source[0] - distance, source[1] - distance, source[2] - distance],
        highC = [source[0] + distance, source[1] + distance, source[2] + distance];
      for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];
        if (r > lowC[0] && g > lowC[1] && b > lowC[2] && r < highC[0] && g < highC[1] && b < highC[2]) {
          data[i + 3] = 0;
        }
      }
    }

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData(gl, uniformLocations) {
      const source = new Color(this.color).getSource(),
        distance = this.distance,
        lowC = [0 + source[0] / 255 - distance, 0 + source[1] / 255 - distance, 0 + source[2] / 255 - distance, 1],
        highC = [source[0] / 255 + distance, source[1] / 255 + distance, source[2] / 255 + distance, 1];
      gl.uniform4fv(uniformLocations.uLow, lowC);
      gl.uniform4fv(uniformLocations.uHigh, highC);
    }
  }
  /**
   * Color to remove, in any format understood by {@link Color}.
   * @param {String} type
   * @default
   */
  /**
   * distance to actual color, as value up or down from each r,g,b
   * between 0 and 1
   **/
  /**
   * For color to remove inside distance, use alpha channel for a smoother deletion
   * NOT IMPLEMENTED YET
   **/
  _defineProperty(RemoveColor, "type", 'RemoveColor');
  _defineProperty(RemoveColor, "defaults", removeColorDefaultValues);
  _defineProperty(RemoveColor, "uniformLocations", ['uLow', 'uHigh']);
  classRegistry.setClass(RemoveColor);

  const resizeDefaultValues = {
    resizeType: 'hermite',
    scaleX: 1,
    scaleY: 1,
    lanczosLobes: 3
  };
  /**
   * Resize image filter class
   * @example
   * const filter = new Resize();
   * object.filters.push(filter);
   * object.applyFilters(canvas.renderAll.bind(canvas));
   */
  class Resize extends BaseFilter {
    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData(gl, uniformLocations) {
      gl.uniform2fv(uniformLocations.uDelta, this.horizontal ? [1 / this.width, 0] : [0, 1 / this.height]);
      gl.uniform1fv(uniformLocations.uTaps, this.taps);
    }
    getFilterWindow() {
      const scale = this.tempScale;
      return Math.ceil(this.lanczosLobes / scale);
    }
    getCacheKey() {
      const filterWindow = this.getFilterWindow();
      return "".concat(this.type, "_").concat(filterWindow);
    }
    getFragmentSource() {
      const filterWindow = this.getFilterWindow();
      return this.generateShader(filterWindow);
    }
    getTaps() {
      const lobeFunction = this.lanczosCreate(this.lanczosLobes),
        scale = this.tempScale,
        filterWindow = this.getFilterWindow(),
        taps = new Array(filterWindow);
      for (let i = 1; i <= filterWindow; i++) {
        taps[i - 1] = lobeFunction(i * scale);
      }
      return taps;
    }

    /**
     * Generate vertex and shader sources from the necessary steps numbers
     * @param {Number} filterWindow
     */
    generateShader(filterWindow) {
      const offsets = new Array(filterWindow);
      for (let i = 1; i <= filterWindow; i++) {
        offsets[i - 1] = "".concat(i, ".0 * uDelta");
      }
      return "\n      precision highp float;\n      uniform sampler2D uTexture;\n      uniform vec2 uDelta;\n      varying vec2 vTexCoord;\n      uniform float uTaps[".concat(filterWindow, "];\n      void main() {\n        vec4 color = texture2D(uTexture, vTexCoord);\n        float sum = 1.0;\n        ").concat(offsets.map((offset, i) => "\n              color += texture2D(uTexture, vTexCoord + ".concat(offset, ") * uTaps[").concat(i, "] + texture2D(uTexture, vTexCoord - ").concat(offset, ") * uTaps[").concat(i, "];\n              sum += 2.0 * uTaps[").concat(i, "];\n            ")).join('\n'), "\n        gl_FragColor = color / sum;\n      }\n    ");
    }
    applyToForWebgl(options) {
      options.passes++;
      this.width = options.sourceWidth;
      this.horizontal = true;
      this.dW = Math.round(this.width * this.scaleX);
      this.dH = options.sourceHeight;
      this.tempScale = this.dW / this.width;
      this.taps = this.getTaps();
      options.destinationWidth = this.dW;
      super.applyTo(options);
      options.sourceWidth = options.destinationWidth;
      this.height = options.sourceHeight;
      this.horizontal = false;
      this.dH = Math.round(this.height * this.scaleY);
      this.tempScale = this.dH / this.height;
      this.taps = this.getTaps();
      options.destinationHeight = this.dH;
      super.applyTo(options);
      options.sourceHeight = options.destinationHeight;
    }

    /**
     * Apply the resize filter to the image
     * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
     *
     * @param {Object} options
     * @param {Number} options.passes The number of filters remaining to be executed
     * @param {Boolean} options.webgl Whether to use webgl to render the filter.
     * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
     * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
     * @param {WebGLRenderingContext} options.context The GL context used for rendering.
     * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
     */
    applyTo(options) {
      if (isWebGLPipelineState(options)) {
        this.applyToForWebgl(options);
      } else {
        this.applyTo2d(options);
      }
    }
    isNeutralState() {
      return this.scaleX === 1 && this.scaleY === 1;
    }
    lanczosCreate(lobes) {
      return x => {
        if (x >= lobes || x <= -lobes) {
          return 0.0;
        }
        if (x < 1.1920929e-7 && x > -1.1920929e-7) {
          return 1.0;
        }
        x *= Math.PI;
        const xx = x / lobes;
        return Math.sin(x) / x * Math.sin(xx) / xx;
      };
    }
    applyTo2d(options) {
      const imageData = options.imageData,
        scaleX = this.scaleX,
        scaleY = this.scaleY;
      this.rcpScaleX = 1 / scaleX;
      this.rcpScaleY = 1 / scaleY;
      const oW = imageData.width;
      const oH = imageData.height;
      const dW = Math.round(oW * scaleX);
      const dH = Math.round(oH * scaleY);
      let newData;
      if (this.resizeType === 'sliceHack') {
        newData = this.sliceByTwo(options, oW, oH, dW, dH);
      } else if (this.resizeType === 'hermite') {
        newData = this.hermiteFastResize(options, oW, oH, dW, dH);
      } else if (this.resizeType === 'bilinear') {
        newData = this.bilinearFiltering(options, oW, oH, dW, dH);
      } else if (this.resizeType === 'lanczos') {
        newData = this.lanczosResize(options, oW, oH, dW, dH);
      } else {
        // this should never trigger, is here just for safety net.
        newData = new ImageData(dW, dH);
      }
      options.imageData = newData;
    }

    /**
     * Filter sliceByTwo
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} oW Original Width
     * @param {Number} oH Original Height
     * @param {Number} dW Destination Width
     * @param {Number} dH Destination Height
     * @returns {ImageData}
     */
    sliceByTwo(options, oW, oH, dW, dH) {
      const imageData = options.imageData;
      const mult = 0.5;
      let doneW = false;
      let doneH = false;
      let stepW = oW * mult;
      let stepH = oH * mult;
      const resources = options.filterBackend.resources;
      let sX = 0;
      let sY = 0;
      const dX = oW;
      let dY = 0;
      if (!resources.sliceByTwo) {
        resources.sliceByTwo = createCanvasElement();
      }
      const tmpCanvas = resources.sliceByTwo;
      if (tmpCanvas.width < oW * 1.5 || tmpCanvas.height < oH) {
        tmpCanvas.width = oW * 1.5;
        tmpCanvas.height = oH;
      }
      const ctx = tmpCanvas.getContext('2d');
      ctx.clearRect(0, 0, oW * 1.5, oH);
      ctx.putImageData(imageData, 0, 0);
      dW = Math.floor(dW);
      dH = Math.floor(dH);
      while (!doneW || !doneH) {
        oW = stepW;
        oH = stepH;
        if (dW < Math.floor(stepW * mult)) {
          stepW = Math.floor(stepW * mult);
        } else {
          stepW = dW;
          doneW = true;
        }
        if (dH < Math.floor(stepH * mult)) {
          stepH = Math.floor(stepH * mult);
        } else {
          stepH = dH;
          doneH = true;
        }
        ctx.drawImage(tmpCanvas, sX, sY, oW, oH, dX, dY, stepW, stepH);
        sX = dX;
        sY = dY;
        dY += stepH;
      }
      return ctx.getImageData(sX, sY, dW, dH);
    }

    /**
     * Filter lanczosResize
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} oW Original Width
     * @param {Number} oH Original Height
     * @param {Number} dW Destination Width
     * @param {Number} dH Destination Height
     * @returns {ImageData}
     */
    lanczosResize(options, oW, oH, dW, dH) {
      function process(u) {
        let v, i, weight, idx, a, red, green, blue, alpha, fX, fY;
        center.x = (u + 0.5) * ratioX;
        icenter.x = Math.floor(center.x);
        for (v = 0; v < dH; v++) {
          center.y = (v + 0.5) * ratioY;
          icenter.y = Math.floor(center.y);
          a = 0;
          red = 0;
          green = 0;
          blue = 0;
          alpha = 0;
          for (i = icenter.x - range2X; i <= icenter.x + range2X; i++) {
            if (i < 0 || i >= oW) {
              continue;
            }
            fX = Math.floor(1000 * Math.abs(i - center.x));
            if (!cacheLanc[fX]) {
              cacheLanc[fX] = {};
            }
            for (let j = icenter.y - range2Y; j <= icenter.y + range2Y; j++) {
              if (j < 0 || j >= oH) {
                continue;
              }
              fY = Math.floor(1000 * Math.abs(j - center.y));
              if (!cacheLanc[fX][fY]) {
                cacheLanc[fX][fY] = lanczos(Math.sqrt(Math.pow(fX * rcpRatioX, 2) + Math.pow(fY * rcpRatioY, 2)) / 1000);
              }
              weight = cacheLanc[fX][fY];
              if (weight > 0) {
                idx = (j * oW + i) * 4;
                a += weight;
                red += weight * srcData[idx];
                green += weight * srcData[idx + 1];
                blue += weight * srcData[idx + 2];
                alpha += weight * srcData[idx + 3];
              }
            }
          }
          idx = (v * dW + u) * 4;
          destData[idx] = red / a;
          destData[idx + 1] = green / a;
          destData[idx + 2] = blue / a;
          destData[idx + 3] = alpha / a;
        }
        if (++u < dW) {
          return process(u);
        } else {
          return destImg;
        }
      }
      const srcData = options.imageData.data,
        destImg = options.ctx.createImageData(dW, dH),
        destData = destImg.data,
        lanczos = this.lanczosCreate(this.lanczosLobes),
        ratioX = this.rcpScaleX,
        ratioY = this.rcpScaleY,
        rcpRatioX = 2 / this.rcpScaleX,
        rcpRatioY = 2 / this.rcpScaleY,
        range2X = Math.ceil(ratioX * this.lanczosLobes / 2),
        range2Y = Math.ceil(ratioY * this.lanczosLobes / 2),
        cacheLanc = {},
        center = {
          x: 0,
          y: 0
        },
        icenter = {
          x: 0,
          y: 0
        };
      return process(0);
    }

    /**
     * bilinearFiltering
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} oW Original Width
     * @param {Number} oH Original Height
     * @param {Number} dW Destination Width
     * @param {Number} dH Destination Height
     * @returns {ImageData}
     */
    bilinearFiltering(options, oW, oH, dW, dH) {
      let a;
      let b;
      let c;
      let d;
      let x;
      let y;
      let i;
      let j;
      let xDiff;
      let yDiff;
      let chnl;
      let color;
      let offset = 0;
      let origPix;
      const ratioX = this.rcpScaleX;
      const ratioY = this.rcpScaleY;
      const w4 = 4 * (oW - 1);
      const img = options.imageData;
      const pixels = img.data;
      const destImage = options.ctx.createImageData(dW, dH);
      const destPixels = destImage.data;
      for (i = 0; i < dH; i++) {
        for (j = 0; j < dW; j++) {
          x = Math.floor(ratioX * j);
          y = Math.floor(ratioY * i);
          xDiff = ratioX * j - x;
          yDiff = ratioY * i - y;
          origPix = 4 * (y * oW + x);
          for (chnl = 0; chnl < 4; chnl++) {
            a = pixels[origPix + chnl];
            b = pixels[origPix + 4 + chnl];
            c = pixels[origPix + w4 + chnl];
            d = pixels[origPix + w4 + 4 + chnl];
            color = a * (1 - xDiff) * (1 - yDiff) + b * xDiff * (1 - yDiff) + c * yDiff * (1 - xDiff) + d * xDiff * yDiff;
            destPixels[offset++] = color;
          }
        }
      }
      return destImage;
    }

    /**
     * hermiteFastResize
     * @param {Object} canvasEl Canvas element to apply filter to
     * @param {Number} oW Original Width
     * @param {Number} oH Original Height
     * @param {Number} dW Destination Width
     * @param {Number} dH Destination Height
     * @returns {ImageData}
     */
    hermiteFastResize(options, oW, oH, dW, dH) {
      const ratioW = this.rcpScaleX,
        ratioH = this.rcpScaleY,
        ratioWHalf = Math.ceil(ratioW / 2),
        ratioHHalf = Math.ceil(ratioH / 2),
        img = options.imageData,
        data = img.data,
        img2 = options.ctx.createImageData(dW, dH),
        data2 = img2.data;
      for (let j = 0; j < dH; j++) {
        for (let i = 0; i < dW; i++) {
          const x2 = (i + j * dW) * 4;
          let weight = 0;
          let weights = 0;
          let weightsAlpha = 0;
          let gxR = 0;
          let gxG = 0;
          let gxB = 0;
          let gxA = 0;
          const centerY = (j + 0.5) * ratioH;
          for (let yy = Math.floor(j * ratioH); yy < (j + 1) * ratioH; yy++) {
            const dy = Math.abs(centerY - (yy + 0.5)) / ratioHHalf,
              centerX = (i + 0.5) * ratioW,
              w0 = dy * dy;
            for (let xx = Math.floor(i * ratioW); xx < (i + 1) * ratioW; xx++) {
              let dx = Math.abs(centerX - (xx + 0.5)) / ratioWHalf;
              const w = Math.sqrt(w0 + dx * dx);
              /* eslint-disable max-depth */
              if (w > 1 && w < -1) {
                continue;
              }
              //hermite filter
              weight = 2 * w * w * w - 3 * w * w + 1;
              if (weight > 0) {
                dx = 4 * (xx + yy * oW);
                //alpha
                gxA += weight * data[dx + 3];
                weightsAlpha += weight;
                //colors
                if (data[dx + 3] < 255) {
                  weight = weight * data[dx + 3] / 250;
                }
                gxR += weight * data[dx];
                gxG += weight * data[dx + 1];
                gxB += weight * data[dx + 2];
                weights += weight;
              }
              /* eslint-enable max-depth */
            }
          }
          data2[x2] = gxR / weights;
          data2[x2 + 1] = gxG / weights;
          data2[x2 + 2] = gxB / weights;
          data2[x2 + 3] = gxA / weightsAlpha;
        }
      }
      return img2;
    }
  }
  /**
   * Resize type
   * for webgl resizeType is just lanczos, for canvas2d can be:
   * bilinear, hermite, sliceHack, lanczos.
   * @default
   */
  /**
   * Scale factor for resizing, x axis
   * @param {Number} scaleX
   * @default
   */
  /**
   * Scale factor for resizing, y axis
   * @param {Number} scaleY
   * @default
   */
  /**
   * LanczosLobes parameter for lanczos filter, valid for resizeType lanczos
   * @param {Number} lanczosLobes
   * @default
   */
  _defineProperty(Resize, "type", 'Resize');
  _defineProperty(Resize, "defaults", resizeDefaultValues);
  _defineProperty(Resize, "uniformLocations", ['uDelta', 'uTaps']);
  classRegistry.setClass(Resize);

  const fragmentSource$1 = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  uniform float uSaturation;\n  varying vec2 vTexCoord;\n  void main() {\n    vec4 color = texture2D(uTexture, vTexCoord);\n    float rgMax = max(color.r, color.g);\n    float rgbMax = max(rgMax, color.b);\n    color.r += rgbMax != color.r ? (rgbMax - color.r) * uSaturation : 0.00;\n    color.g += rgbMax != color.g ? (rgbMax - color.g) * uSaturation : 0.00;\n    color.b += rgbMax != color.b ? (rgbMax - color.b) * uSaturation : 0.00;\n    gl_FragColor = color;\n  }\n";

  const saturationDefaultValues = {
    saturation: 0
  };

  /**
   * Saturate filter class
   * @example
   * const filter = new Saturation({
   *   saturation: 1
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */
  class Saturation extends BaseFilter {
    getFragmentSource() {
      return fragmentSource$1;
    }

    /**
     * Apply the Saturation operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */
    applyTo2d(_ref) {
      let {
        imageData: {
          data
        }
      } = _ref;
      const adjust = -this.saturation;
      for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];
        const max = Math.max(r, g, b);
        data[i] += max !== r ? (max - r) * adjust : 0;
        data[i + 1] += max !== g ? (max - g) * adjust : 0;
        data[i + 2] += max !== b ? (max - b) * adjust : 0;
      }
    }

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData(gl, uniformLocations) {
      gl.uniform1f(uniformLocations.uSaturation, -this.saturation);
    }
    isNeutralState() {
      return this.saturation === 0;
    }
  }
  /**
   * Saturation value, from -1 to 1.
   * Increases/decreases the color saturation.
   * A value of 0 has no effect.
   *
   * @param {Number} saturation
   * @default
   */
  _defineProperty(Saturation, "type", 'Saturation');
  _defineProperty(Saturation, "defaults", saturationDefaultValues);
  _defineProperty(Saturation, "uniformLocations", ['uSaturation']);
  classRegistry.setClass(Saturation);

  const fragmentSource = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  uniform float uVibrance;\n  varying vec2 vTexCoord;\n  void main() {\n    vec4 color = texture2D(uTexture, vTexCoord);\n    float max = max(color.r, max(color.g, color.b));\n    float avg = (color.r + color.g + color.b) / 3.0;\n    float amt = (abs(max - avg) * 2.0) * uVibrance;\n    color.r += max != color.r ? (max - color.r) * amt : 0.00;\n    color.g += max != color.g ? (max - color.g) * amt : 0.00;\n    color.b += max != color.b ? (max - color.b) * amt : 0.00;\n    gl_FragColor = color;\n  }\n";

  const vibranceDefaultValues = {
    vibrance: 0
  };

  /**
   * Vibrance filter class
   * @example
   * const filter = new Vibrance({
   *   vibrance: 1
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */
  class Vibrance extends BaseFilter {
    getFragmentSource() {
      return fragmentSource;
    }

    /**
     * Apply the Vibrance operation to a Uint8ClampedArray representing the pixels of an image.
     *
     * @param {Object} options
     * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
     */
    applyTo2d(_ref) {
      let {
        imageData: {
          data
        }
      } = _ref;
      const adjust = -this.vibrance;
      for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];
        const max = Math.max(r, g, b);
        const avg = (r + g + b) / 3;
        const amt = Math.abs(max - avg) * 2 / 255 * adjust;
        data[i] += max !== r ? (max - r) * amt : 0;
        data[i + 1] += max !== g ? (max - g) * amt : 0;
        data[i + 2] += max !== b ? (max - b) * amt : 0;
      }
    }

    /**
     * Send data from this filter to its shader program's uniforms.
     *
     * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
     * @param {TWebGLUniformLocationMap} uniformLocations A map of string uniform names to WebGLUniformLocation objects
     */
    sendUniformData(gl, uniformLocations) {
      gl.uniform1f(uniformLocations.uVibrance, -this.vibrance);
    }
    isNeutralState() {
      return this.vibrance === 0;
    }
  }
  /**
   * Vibrance value, from -1 to 1.
   * Increases/decreases the saturation of more muted colors with less effect on saturated colors.
   * A value of 0 has no effect.
   *
   * @param {Number} vibrance
   * @default
   */
  _defineProperty(Vibrance, "type", 'Vibrance');
  _defineProperty(Vibrance, "defaults", vibranceDefaultValues);
  _defineProperty(Vibrance, "uniformLocations", ['uVibrance']);
  classRegistry.setClass(Vibrance);

  var filters = /*#__PURE__*/Object.freeze({
    __proto__: null,
    BaseFilter: BaseFilter,
    BlackWhite: BlackWhite,
    BlendColor: BlendColor,
    BlendImage: BlendImage,
    Blur: Blur,
    Brightness: Brightness,
    Brownie: Brownie,
    ColorMatrix: ColorMatrix,
    Composed: Composed,
    Contrast: Contrast,
    Convolute: Convolute,
    Gamma: Gamma,
    Grayscale: Grayscale,
    HueRotation: HueRotation,
    Invert: Invert,
    Kodachrome: Kodachrome,
    Noise: Noise,
    Pixelate: Pixelate,
    Polaroid: Polaroid,
    RemoveColor: RemoveColor,
    Resize: Resize,
    Saturation: Saturation,
    Sepia: Sepia,
    Technicolor: Technicolor,
    Vibrance: Vibrance,
    Vintage: Vintage
  });

  exports.ActiveSelection = ActiveSelection;
  exports.BaseBrush = BaseBrush;
  exports.BaseFabricObject = FabricObject$1;
  exports.Canvas = Canvas;
  exports.Canvas2dFilterBackend = Canvas2dFilterBackend;
  exports.CanvasDOMManager = CanvasDOMManager;
  exports.Circle = Circle;
  exports.CircleBrush = CircleBrush;
  exports.ClipPathLayout = ClipPathLayout;
  exports.Color = Color;
  exports.Control = Control;
  exports.Ellipse = Ellipse;
  exports.FabricImage = FabricImage;
  exports.FabricObject = FabricObject;
  exports.FabricText = FabricText;
  exports.FitContentLayout = FitContentLayout;
  exports.FixedLayout = FixedLayout;
  exports.Gradient = Gradient;
  exports.Group = Group;
  exports.IText = IText;
  exports.Image = FabricImage;
  exports.InteractiveFabricObject = InteractiveFabricObject;
  exports.Intersection = Intersection;
  exports.LayoutManager = LayoutManager;
  exports.LayoutStrategy = LayoutStrategy;
  exports.Line = Line;
  exports.Object = FabricObject;
  exports.Observable = Observable;
  exports.Path = Path;
  exports.Pattern = Pattern;
  exports.PatternBrush = PatternBrush;
  exports.PencilBrush = PencilBrush;
  exports.Point = Point;
  exports.Polygon = Polygon;
  exports.Polyline = Polyline;
  exports.Rect = Rect;
  exports.Shadow = Shadow;
  exports.SprayBrush = SprayBrush;
  exports.StaticCanvas = StaticCanvas;
  exports.StaticCanvasDOMManager = StaticCanvasDOMManager;
  exports.Text = FabricText;
  exports.Textbox = Textbox;
  exports.Triangle = Triangle;
  exports.WebGLFilterBackend = WebGLFilterBackend;
  exports.cache = cache;
  exports.classRegistry = classRegistry;
  exports.config = config;
  exports.controlsUtils = index;
  exports.createCollectionMixin = createCollectionMixin;
  exports.filters = filters;
  exports.getCSSRules = getCSSRules;
  exports.getEnv = getEnv;
  exports.getFabricDocument = getFabricDocument;
  exports.getFabricWindow = getFabricWindow;
  exports.getFilterBackend = getFilterBackend;
  exports.iMatrix = iMatrix;
  exports.initFilterBackend = initFilterBackend;
  exports.isPutImageFaster = isPutImageFaster;
  exports.isWebGLPipelineState = isWebGLPipelineState;
  exports.loadSVGFromString = loadSVGFromString;
  exports.loadSVGFromURL = loadSVGFromURL;
  exports.parseAttributes = parseAttributes;
  exports.parseFontDeclaration = parseFontDeclaration;
  exports.parsePointsAttribute = parsePointsAttribute;
  exports.parseSVGDocument = parseSVGDocument;
  exports.parseStyleAttribute = parseStyleAttribute;
  exports.parseTransformAttribute = parseTransformAttribute;
  exports.runningAnimations = runningAnimations;
  exports.setEnv = setEnv;
  exports.setFilterBackend = setFilterBackend;
  exports.util = index$1;
  exports.version = VERSION;

}));
//# sourceMappingURL=index.js.map

},
'doccontrol/viewer/dojo/CorrespondenceViewer':function(){
define([
    '../Topics',
    'api/Factory',
    './ViewerDialog',
    './ViewInformation',
    'dijit/_WidgetBase',
    'dijit/form/NumberTextBox',
    'doc-control/tree/RegistrationLocationFormatter',
    'doccontrol/correspondence/KeywordParser',
    'doccontrol/correspondence/dojo/MailKeywordNavigator',
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/dom-construct',
    'dojo/on',
    'dojo/topic',
    'dojo/text!./template/CorrespondenceViewer.html',
    'soso/sosox/ejs/_Templated',
    'spencer/encoding/Template',
    'spencer/utility/NodeStyle',
    'style-guide/v1/file-tray/FileTraySingleton'
], function(
    Topics,
    ApiFactory,
    Dialog,
    ViewInformationWidget,
    WidgetBase,
    NumberTextBox,
    RegistrationLocationFormatter,
    KeywordParser,
    MailKeywordNavigator,
    declare,
    lang,
    domAttr,
    domClass,
    domConstruct,
    on,
    topic,
    Template,
    Templated,
    TemplateEncoder,
    nodeStyle,
    FileTraySingleton
){
    const CorrespondenceViewer = function(routeContainer, dataManager) {
        const View = declare([WidgetBase, Templated], {
            routeContainer: routeContainer,
            dataManager: dataManager,
            popup: null,
            keywordParser: null,
            templateEncoder: null,
            widgetsInTemplate: true,
            templateString: Template,
            showRevisionSidebar: false,

            fileType: null,
            message: null,
            viewerInformationWidget: null,
            navigationBarShowing: false,

            keywordSearch: null,

            data: {
                correspondence: null,
                registrationLocations: []
            },

            elementCancel: null,

            constructor: function() {
                this.setCustomViewHelpers({
                    formatLocation: function(location) {
                        return (new RegistrationLocationFormatter()).format(location);
                    },
                    revisionDownloadUrl: (id) => {
                        return this.routeContainer.get('downloadRevision', {id: id});
                    },
                    temporaryDocumentDownloadUrl: (id) => {
                        return this.routeContainer.get('downloadTemporaryDocument', {id: id});
                    },
                    linkPersonUrl: (tempDocumentPK, emailPK) => {
                        return this.routeContainer.get('addAttachmentToRegistrationBasket', {
                            emailPK: emailPK,
                            tempDocumentPK: tempDocumentPK
                        });
                    },
                    viewPrintableEmailUrl: (id) => {
                        return this.routeContainer.get('viewRevision', {id: id}, null, {pdf: 1});
                    }
                });

                this.templateEncoder = new TemplateEncoder();
            },

            setFileType: function(fileType) {
                this.fileType = fileType;
            },

            getInformation: function() {
                return this.viewerInformationWidget;
            },

            hideLoadingRevisionDetails: function() {
                if (this.popup) {
                    domClass.remove(this.popup.fileTitle, 'file-title-loading');
                }
            },

            hideLoadingCorrespondence: function() {
                if (this.popup) {
                    domClass.add(this.loadingContainer, 'hidden');
                    domClass.remove(this.messageContainer, 'hidden');
                }
            },

            showErrorMessage: function() {
                if (this.popup) {
                    domClass.add(this.loading, 'hidden');
                    domClass.remove(this.errorMessage, 'hidden');
                }
            },

            showUnauthorisedMessage: function() {
                this.viewerInformationWidget?.showUnauthorisedMessage();

                if (this.popup) {
                    domClass.add(this.loading, 'hidden');
                    domClass.remove(this.unauthorisedMessage, 'hidden');
                }
            },

            showDeletedMessage: function() {
                if (this.popup) {
                    domClass.add(this.loading, 'hidden');
                    domClass.remove(this.deletedMessage, 'hidden');
                }
            },

            setCorrespondence: function(correspondence) {
                if (this.popup) {
                    correspondence.setFrom(this.templateEncoder.encode(correspondence.getFrom()));
                    correspondence.setTo(this.templateEncoder.encode(correspondence.getTo()));
                    correspondence.setCC(this.templateEncoder.encode(correspondence.getCC()));
                    correspondence.setSubject(this.templateEncoder.encode(correspondence.getSubject()));

                    if (this.hasKeywords()) {
                        correspondence.setContents(this.findKeywordsInContents(correspondence.getContents()));
                        correspondence.setFrom(this.findKeywordsInContents(correspondence.getFrom()));
                        correspondence.setTo(this.findKeywordsInContents(correspondence.getTo()));
                        correspondence.setCC(this.findKeywordsInContents(correspondence.getCC()));
                        correspondence.setSubject(this.findKeywordsInContents(correspondence.getSubject()));
                    }

                    this.data.correspondence = correspondence;

                    this.render();
                }
            },

            setRegistrationLocations: function(registrationLocations) {
                if (this.popup) {
                    this.data.registrationLocations = registrationLocations;
                    this.render();
                    this.hideLoadingCorrespondence();
                }
            },

            setKeywordSearch: function(keywordSearch) {
                if (!keywordSearch) {
                    this.keywordSearch = null;
                    return;
                }

                this.keywordParser = new KeywordParser(domConstruct, new nodeStyle());

                keywordSearch = this.keywordParser.splitKeywords(keywordSearch[0]);

                this.keywordSearch = {};
                for (let i = 0; i < keywordSearch.length; i++) {
                    this.keywordSearch[keywordSearch[i]] = this.generateKeywordColor();
                }
            },

            hasKeywords: function() {
                return this.keywordSearch !== null;
            },

            findKeywordsInContents: function(contents) {
                contents = contents || '';
                for (let key in this.keywordSearch) {
                    if (this.keywordSearch.hasOwnProperty(key) && key !== '') {
                        contents = this.keywordParser.parseContents(
                            contents,
                            key,
                            this.keywordSearch[key]
                        );
                    }
                }

                return contents;
            },

            generateKeywordColor: function() {
                const r = Math.floor(Math.random() * 110) + 120;
                const g = Math.floor(Math.random() * 110) + 120;
                const b = Math.floor(Math.random() * 110) + 120;

                return 'rgb(' + r + ',' + g + ',' + b + ')';
            },

            postCreate: function() {
                this.viewerInformationWidget = new ViewInformationWidget(
                    this.routeContainer,
                    this.informationContainer,
                    this.dataManager
                );

                this.popup = new Dialog({content: this.domNode});
                on(this.popup, 'hide', function() {
                    topic.publish(Topics.DOCUMENT_VIEWER_HIDE);
                }.bind(this));

                this.own(topic.subscribe(Topics.DOCUMENT_VIEWER_HIDE, this._destroyDialog.bind(this)));

                this.inherited(arguments);
            },

            render: function() {
                const informationShowing = this.viewerInformationWidget && this.viewerInformationWidget.isShowing();

                this.inherited(arguments);

                if (this.viewerInformationWidget) {
                    this.viewerInformationWidget.placeAt(this.informationContainer);

                    if (informationShowing) {
                        this.viewerInformationWidget.show();
                    }
                }

                if (this.navigationBarShowing) {
                    domClass.add(this.domNode, 'navigation-showing');
                }

                if (this.hasKeywords()) {
                    const mkn = new MailKeywordNavigator({
                        scope: this.correspondenceBody,
                        terms: this.keywordSearch,
                        scrollContainer: this.scrollContainer,
                        navigatorStyle: {
                            'position': 'absolute', 'right': '40px', 'top': '20px',
                            'color': '#999999', 'backgroundColor': '#EEEEEE',
                            'padding': '10px', 'fontSize': '2em', 'border': '1px solid  #CCCCCC'
                        }
                    });
                    mkn.load();
                }
            },

            show: function() {
                this.popup.show();

                this.inherited(arguments);
            },

            showInline: function() {
                this.popup.showInline();
            },

            hideInline: function() {
                this.popup.hideInline();
            },

            setWidth: function(percentage) {
                this.popup?.setWidth(percentage);
            },

            unsetWidth: function() {
                this.popup?.unsetWidth();
            },

            enableStandalone: function() {
                if (this.popup) this.popup.set('closable', false);
                if (this.elementCancel) this.elementCancel.classList.add('display-none');
            },

            showNavigation: function() {
                this.navigationBarShowing = true;
                domClass.add(this.popup.domNode, 'navigation-showing');
            },

            viewDocument: function(evt) {
                evt.preventDefault();
                topic.publish(Topics.DOCUMENT_VIEWER_VIEW, {
                    revisionPK: domAttr.get(evt.target, 'data-revision-pk'),
                    temporaryDocumentPK: domAttr.get(evt.target, 'data-temporary-document-pk'),
                    href: domAttr.get(evt.target, 'href'),
                    fileType: domAttr.get(evt.target, 'data-file-type'),
                    md5: domAttr.get(evt.target, 'data-md5')
                });
            },

            _onAddAttachmentsToCurrentBasketClick: function() {
                return this._getCorrespondenceAttachments().forEach(attachment => {
                    FileTraySingleton.get().addItem(attachment.md5);
                });
            },

            _onDownloadAllAsZipClick: function() {
                window.open(
                    this.routeContainer.get('downloadAttachmentsZip', null, null, {
                        md5: this._getCorrespondenceAttachments().map((attachment) => attachment.md5)
                    }),
                    '_blank'
                );
            },

            _destroyDialog: function() {
                domConstruct.destroy(this.popup.domNode);
                this.destroyRecursive();
                this.popup.destroyRecursive();
                delete this.popup;
            },

            _onCancelClick: function() {
                topic.publish(Topics.DOCUMENT_VIEWER_HIDE);
            },

            _getCorrespondenceAttachments() {
                return this.data.correspondence.revisions.concat(
                    this.data.correspondence.temporaryDocuments
                );
            }
        });

        this.view = new View();
    };

    CorrespondenceViewer.prototype.setFileType = function(fileType) {
        this.view.setFileType(fileType);
    };

    CorrespondenceViewer.prototype.getInformation = function() {
        return this.view.getInformation();
    };

    CorrespondenceViewer.prototype.hideLoadingCorrespondence = function() {
        this.view.hideLoadingCorrespondence();
    };

    CorrespondenceViewer.prototype.setCorrespondence = function(correspondence) {
        this.view.setCorrespondence(correspondence);
    };

    CorrespondenceViewer.prototype.setRegistrationLocations = function(registrationLocations) {
        this.view.setRegistrationLocations(registrationLocations);
    };

    CorrespondenceViewer.prototype.setKeywordSearch = function(keywordSearch) {
        this.view.setKeywordSearch(keywordSearch);
    };

    CorrespondenceViewer.prototype.show = function() {
        this.view.show();
    };

    CorrespondenceViewer.prototype.showNavigation = function() {
        this.view.showNavigation();
    };

    CorrespondenceViewer.prototype.showErrorMessage = function() {
        this.view.showErrorMessage();
    };

    CorrespondenceViewer.prototype.showUnauthorisedMessage = function() {
        this.view.showUnauthorisedMessage();
    };

    CorrespondenceViewer.prototype.showAbortMessage = function() {};

    CorrespondenceViewer.prototype.showDeletedMessage = function() {
        this.view.showDeletedMessage();
    };

    CorrespondenceViewer.prototype.showInline = function() {
        this.view.showInline();
    };

    CorrespondenceViewer.prototype.hideInline = function() {
        this.view.hideInline();
    };

    CorrespondenceViewer.prototype.setWidth = function(percentage) {
        this.view.setWidth(percentage);
    };

    CorrespondenceViewer.prototype.unsetWidth = function() {
        this.view.unsetWidth();
    };

    CorrespondenceViewer.prototype.enableStandalone = function() {
        this.view.enableStandalone();
    };

    CorrespondenceViewer.prototype.showRevisionSidebar = function() {
        this.view.showRevisionSidebar = true;
    };

    CorrespondenceViewer.prototype.supportsRevisionSidebar = function() {
        return this.view.showRevisionSidebar;
    };

    CorrespondenceViewer.prototype.destroy = function() {
        return this.view.destroyRecursive();
    };

    return CorrespondenceViewer;
});

},
'doccontrol/viewer/dojo/ViewerDialog':function(){
define([
    'dojo/dom-construct',
    'dojo/Evented',
    'dojo/keys',
    'dojo/on',
    'dojo/_base/declare',
    'dojo/_base/window',
    'dojo/text!./template/ViewerDialog.html',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated',
    './_inlineMixin',
    './_resizeMixin'
], function(
    domConstruct,
    Evented,
    keys,
    on,
    declare,
    win,
    template,
    _WidgetBase,
    Templated,
    _inlineMixin,
    _resizeMixin
) {
    return declare([_WidgetBase, _inlineMixin, _resizeMixin, Templated, Evented], {
        content: null,
        closable: true,
        elementCloseButton: null,
        elementContentContainer: null,
        keyupHandler: null,
        templateString: template,

        postscript: function(params) {
            this.create(params, domConstruct.create('div', {}, win.body(), 'last'));

            this.keyupHandler = on(document, 'keyup', function(e) {
                if (!this.closable || this.domNode.hidden || e.keyCode !== keys.ESCAPE) return;

                this.hide();
            }.bind(this));
        },

        buildRendering: function() {
            this.inherited(arguments);

            this._configureCloseButtonState();
        },

        render: function() {
            this.inherited(arguments);

            this._configureCloseButtonState();
        },

        destroy: function () {
            this.keyupHandler?.remove();

            this.inherited(arguments);
        },

        show: function() {
            this.domNode.hidden = false;

            this.emit('show');
        },

        hide: function() {
            this.domNode.hidden = true;

            this.emit('hide');
        },

        _onCloseClick: function() {
            if (!this.closable) return;

            this.hide();
        },

        _setClosableAttr: function(closable) {
            this.closable = closable;

            this._configureCloseButtonState();
        },

        _setContentAttr: function(content) {
            this.content = content;

            if (this.content) {
                domConstruct.place(this.content, this.elementContentContainer, 'first');
            }
        },

        _configureCloseButtonState: function() {
            this.elementCloseButton.hidden = !this.closable;
        }
    });
});
},
'doccontrol/viewer/dojo/_inlineMixin':function(){
define([
    'dojo/_base/declare'
], function (
    declare
) {
    return declare([], {
        WIDTH_SPECIFIER_CLASS_PREFIX: 'width-',

        showInline: function() {
            this.domNode.classList.add('document-viewer-inline');
        },

        hideInline: function () {
            this.domNode.classList.remove('document-viewer-inline');
            this.unsetWidth();
        },

        setWidth: function(percentage) {
            this.showInline();
            this.domNode.classList.add(`${this.WIDTH_SPECIFIER_CLASS_PREFIX}${percentage}`);
        },

        unsetWidth: function() {
            this.domNode.classList.forEach(className => {
                if (className.startsWith(this.WIDTH_SPECIFIER_CLASS_PREFIX)) this.domNode.classList.remove(className);
            });
        },
    });
});
},
'doccontrol/viewer/dojo/_resizeMixin':function(){
define([
    'dojo/_base/declare',
    'dojo/dom-geometry',
    'dojo/dom-style',
    'dojo/window',
    'dijit/_WidgetBase'
], function (
    declare,
    domGeom,
    domStyle,
    win,
    _WidgetBase
) {
    return declare([_WidgetBase], {
        _position: function () {
            domStyle.set(this.domNode, {
                top: '0',
                position: 'fixed'
            });

            this._recenter();
        },

        resize: function () {
            domStyle.set(this.domNode, 'height', (win.getBox().h) + 'px');
            this._position();
        },

        _recenter: function () {
            let left = Math.floor((win.getBox().w - domGeom.position(this.domNode).w) / 2);
            if (left < 0) left = 0;
            
            domStyle.set(this.domNode, {
                left: left + 'px'
            });
        }
    });
});
},
'doccontrol/viewer/dojo/ViewInformation':function(){
define([
    '../Topics',
    './information/AddNoteDialog',
    './information/Chronological',
    './information/RevisionHistoryTable',
    '../config/InformationPanes',
    'dojo/dom-construct',
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/topic',
    'dojo/query',
    'doc-control/tree/RegistrationLocationFormatter',
    'spencer/contact/format/Contact',
    'spencer/format/Megabytes',
    'spencer/format/MimeType',
    'spencer/format/PersonDisplayName',
    'dojo/text!./template/ViewInformation.html',
    'dijit/_WidgetBase',
    'dijit/TitlePane',
    'soso/sosox/ejs/_Templated',
    'soso/sosox/ejs/Helpers'
], function(
    TOPICS,
    AddNoteDialog,
    ChronologicalView,
    RevisionHistoryTable,
    INFORMATION_PANES,
    domConstruct,
    declare,
    domAttr,
    domClass,
    topic,
    query,
    RegistrationLocationFormatter,
    ContactFormatter,
    MegaBytesFormatter,
    MimeTypeFormatter,
    PersonFormatter,
    template,
    _WidgetBase,
    TitlePane,
    _Templated,
    Helpers
) {
    const ViewInformation = function(routeContainer, node, dataManager) {
        const View = declare([_WidgetBase, _Templated], {
            routeContainer: routeContainer,
            parentNode: node,
            dataManager: dataManager,
            templateString: template,
            chronologicalView: null,
            chronologicalViewNode: null,
            revisionHistoryTable: null,
            data: {
                latestRevision: null,
                latestRevisionIsPrivate: false,
                userHasAccess: true,
                revision: null,
                softLinks: null,
                softLinkEvents: null,
                linkedRevisionTreeNodeCollection: null,
                transmittalCollection: null,
                documentRevisionCollection: null,
                moveCollection: null,
                noteCollection: null,
                metaDataCollection: null,
                accessLogs: null,
                informationPanes: INFORMATION_PANES
            },
            informationLoaded: false,
            titlePanes: [],
            openPane: null,
            addNoteDialog: null,

            destroyRecursive: function() {
                this.inherited(arguments);

                this.titlePanes.forEach(tp => {
                    tp.destroyRecursive();
                });
            },

            postMixInProperties: function() {
                this.inherited(arguments);

                const contactsFormatter = new ContactFormatter();
                const megabytesFormatter = new MegaBytesFormatter();
                const mimeTypeFormatter = new MimeTypeFormatter();
                const viewHelper = new Helpers();

                this.setCustomViewHelpers({
                    megabytesFormatter: megabytesFormatter.format.bind(megabytesFormatter),
                    mimeTypeFormatter: mimeTypeFormatter.format.bind(mimeTypeFormatter),
                    personFormatter: function(person) {
                        if (!person) {
                            return '-';
                        }

                        const personFormatter = new PersonFormatter();
                        personFormatter.setJobTitle(person.getJobTitle());
                        personFormatter.setDisplayName(person.getDisplayName());
                        return personFormatter.format();
                    },
                    contactFormatter: contactsFormatter.format.bind(contactsFormatter),
                    dateFormatter: function(date) {
                        return date.toLocaleDateString('en-GB') + ' '
                            + date.toLocaleTimeString('en-GB', {
                                hour12: false,
                                hour: 'numeric',
                                minute: 'numeric'
                            });
                    },
                    locationFormatter: function(location) {
                        return (new RegistrationLocationFormatter()).format(location);
                    },
                    revisionDownloadUrl: (id) => {
                        return this.routeContainer.get('downloadRevision', {id: id});
                    },
                    overviewDocumentUrl: (revisionPK) => this.routeContainer.get('overviewDocumentUrl', {revisionPK: revisionPK}),
                    noteFormatter: function(note) {
                        note = note.replace(/</g, '&lt;').replace(/>/g, '&gt;');
                        return viewHelper.nl2br(note);
                    }
                });
            },

            render: function() {
                let clonedTitlePanes = this.titlePanes;

                this.inherited(arguments);
                this.titlePanes = [];

                query('.sos-accordion-pane', this.domNode).forEach(function(node) {
                    const nodeTitle = domAttr.get(node, 'data-title');

                    this.titlePanes.push(
                        new TitlePane({
                            title: nodeTitle,
                            open: (
                                this.openPane === nodeTitle ||
                                clonedTitlePanes.length && clonedTitlePanes.find(tp => tp.open && tp.title === nodeTitle)
                            )
                        }, node)
                    );
                }.bind(this));

                this.openPane = null;

                this.addNoteDialog = new AddNoteDialog(this.addNoteDialogNode);
                this.addNoteDialog.setRevision(this.data.revision);
                this.addNoteDialog.on('note-added', (e) => {
                    this.data.noteCollection.push(e.note);
                    this.render();
                    this.setInformationLoaded();
                });

                domClass.add(this.loadingContainer, 'hidden');
                domClass.remove(this.tableView, 'hidden');
                domClass.remove(this.informationHeader, 'hidden');

                (new RevisionHistoryTable(
                    this.data.documentRevisionCollection,
                    this.data.revision,
                    this.routeContainer,
                    this.dataManager,
                )).placeAt(this.revisionHistoryTableNode);

                if (this.informationLoaded) {
                    this.setInformationLoaded();
                }
            },

            viewDocument: function(evt) {
                evt.preventDefault();
                topic.publish(TOPICS.DOCUMENT_VIEWER_VIEW, {
                    revisionPK: domAttr.get(evt.target, 'data-revision-pk'),
                    href: domAttr.get(evt.target, 'href'),
                    fileType: domAttr.get(evt.target, 'data-file-type'),
                    md5: domAttr.get(evt.target, 'data-md5')
                });
            },

            isShowing: function() {
                return !domClass.contains(this.parentNode, 'hidden');
            },

            show: function() {
                domClass.remove(this.parentNode, 'hidden');
            },

            hide: function() {
                domClass.add(this.parentNode, 'hidden');
            },

            setRevision: function(revision) {
                this.data.revision = revision;
                this.render();
            },

            setSoftLinkCollection: function(softLinks) {
                this.data.softLinks = softLinks;
                this.render();
            },

            setSoftLinkEventCollection: function(softLinkEvents) {
                this.data.softLinkEvents = softLinkEvents;
                this.render();
            },

            setLinkedRevisionTreeNodeCollection: function(linkedRevisionTreeNodeCollection) {
                this.data.linkedRevisionTreeNodeCollection = linkedRevisionTreeNodeCollection;
                this.render();
            },

            setTransmittalCollection: function(transmittalCollection) {
                this.data.transmittalCollection = transmittalCollection;
                this.render();
            },

            setMoveCollection: function(moveCollection) {
                this.data.moveCollection = moveCollection;
                this.render();
            },

            setNoteCollection: function(noteCollection) {
                this.data.noteCollection = noteCollection;
                this.render();
            },

            setMetaDataCollection: function(metaDataCollection) {
                this.data.metaDataCollection = metaDataCollection;
                this.render();
            },

            setDocumentRevisionCollection: function(documentRevisionCollection) {
                this.data.latestRevision = documentRevisionCollection.find((r) => r.isLatest());
                this.data.latestRevisionIsPrivate = documentRevisionCollection.some((r) => r.isLatest() && r.isMarkedAsPrivate());
                this.data.documentRevisionCollection = documentRevisionCollection;

                if (
                    !this.data.latestRevision ||
                    this.data.latestRevision.getRevisionPK() !== this.data.revision.getRevisionPK()
                ) {
                    topic.publish(TOPICS.DOCUMENT_VIEWER_INFORMATION_NOTIFICATION_ICON_SHOW);
                }

                this.render();
            },

            setAccessLogs: function(accessLogs) {
                this.data.accessLogs = accessLogs;
                this.render();
            },

            setInformationLoaded: function() {
                this.informationLoaded = true;

                this.chronologicalView = new ChronologicalView(this.chronologicalViewNode, this.routeContainer)
                    .setDocumentRevisionCollection(this.data.documentRevisionCollection)
                    .setCurrentlyViewingRevision(this.data.revision)
                    .setEvents(this._generateChronologicalEventsArray());
            },

            expandPane: function(pane) {
                if (this.titlePanes.length) {
                    this.titlePanes.forEach(tp => {
                        if (pane === tp.title) {
                            tp.set('open', true);
                            this.render();
                        }
                    });

                    this.openPane = null;
                } else {
                    this.openPane = pane;
                }
            },

            showUnauthorisedMessage: function() {
                this.data.userHasAccess = false;
                this.render();
            },

            _showAddNoteDialog: function() {
                this.addNoteDialog.show();
            },

            _onViewChange: function(e) {
                if (e.target.value === 'standard') {
                    this._showStandardView();
                    return;
                }

                this._showChronologicalView();
            },

            _onExpandAllClick: function() {
                if (this._isStandardView()) {
                    this.titlePanes.forEach(titlePane => {
                        titlePane.set('open', true);
                    });
                    return;
                }

                this.chronologicalView.expand();
            },

            _onCollapseAllClick: function() {
                if (this._isStandardView()) {
                    this.titlePanes.forEach(titlePane => {
                        titlePane.set('open', false);
                    });
                    return;
                }

                this.chronologicalView.collapse();
            },

            _showStandardView: function() {
                domClass.remove(this.tableView, 'hidden');
                domClass.add(this.chronologicalViewNode, 'hidden');
            },

            _isStandardView: function() {
                return !domClass.contains(this.tableView, 'hidden');
            },

            _showChronologicalView: function() {
                domClass.remove(this.chronologicalViewNode, 'hidden');
                domClass.add(this.tableView, 'hidden');
            },

            _generateChronologicalEventsArray: function() {
                const events = [];
                events.push(
                    this.data.softLinkEvents,
                    this.data.linkedRevisionTreeNodeCollection,
                    this.data.transmittalCollection,
                    this.data.documentRevisionCollection,
                    this.data.moveCollection,
                    this.data.accessLogs,
                    this.data.noteCollection
                );

                return events.flat();
            }
        });

        this.view = new View({}, domConstruct.create('div', {}, node, 'last'));
    };

    ViewInformation.prototype.destroyRecursive = function() {
        this.view.destroyRecursive();
    };

    ViewInformation.prototype.isShowing = function() {
        return this.view.isShowing();
    };

    ViewInformation.prototype.show = function() {
        this.view.show();
    };

    ViewInformation.prototype.hide = function() {
        this.view.hide();
    };

    ViewInformation.prototype.placeAt = function(node) {
        this.view.placeAt(node);
        this.view.parentNode = node;
    };

    ViewInformation.prototype.setRevision = function(revision) {
        this.view.setRevision(revision);
        return this;
    };

    ViewInformation.prototype.setSoftLinkCollection = function(softLinkCollection) {
        this.view.setSoftLinkCollection(softLinkCollection);
    };

    ViewInformation.prototype.setSoftLinkEventCollection = function(softLinkEventCollection) {
        this.view.setSoftLinkEventCollection(softLinkEventCollection);
    };

    ViewInformation.prototype.setLinkedRevisionTreeNodeCollection = function(linkedRevisionTreeNodeCollection) {
        this.view.setLinkedRevisionTreeNodeCollection(linkedRevisionTreeNodeCollection);
    };

    ViewInformation.prototype.setTransmittalCollection = function(transmittalCollection) {
        this.view.setTransmittalCollection(transmittalCollection);
    };

    ViewInformation.prototype.setMoveCollection = function(moveCollection) {
        this.view.setMoveCollection(moveCollection);
    };

    ViewInformation.prototype.setNoteCollection = function(noteCollection) {
        this.view.setNoteCollection(noteCollection);
    };

    ViewInformation.prototype.setMetaDataCollection = function(metaDataCollection) {
        this.view.setMetaDataCollection(metaDataCollection);
    };

    ViewInformation.prototype.setDocumentRevisionCollection = function(documentRevisionCollection) {
        this.view.setDocumentRevisionCollection(documentRevisionCollection);
    };

    ViewInformation.prototype.setAccessLogs = function(accessLogs) {
        this.view.setAccessLogs(accessLogs);
    };

    ViewInformation.prototype.setInformationLoaded = function() {
        this.view.setInformationLoaded();
    };

    ViewInformation.prototype.expandPane = function(pane) {
        this.view.expandPane(pane);
    };

    ViewInformation.prototype.showUnauthorisedMessage = function() {
        this.view.showUnauthorisedMessage();
    };

    return ViewInformation;
});
},
'doccontrol/viewer/dojo/information/AddNoteDialog':function(){
define([
    'api/doccontrol/Config',
    'api/doccontrol/data/Note',
    'api/doccontrol/Factory',
    'dijit/_WidgetBase',
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/dom-construct',
    'dojo/text!./template/AddNoteDialog.html',
    'dojo/topic',
    'library/request/data/Handlers',
    'library/request/dojo/URLConnectionProcessorBuilder',
    'library/request/helper/DefaultUnauthorisedCallback',
    'library/request/URLConnectionBuilder',
    'library/request/URLResponseProcessorBuilder',
    'soso/dijit/form/ValidationTextarea',
    'soso/sosox/ejs/_Templated',
    'style-guide/v1/layout/Dialog'
], function(
    DocControlConfig,
    NoteVO,
    DocControlFactory,
    _WidgetBase,
    declare,
    domAttr,
    domConstruct,
    template,
    topic,
    HandlersVO,
    URLConnectionProcessorBuilder,
    DefaultUnauthorisedCallback,
    URLConnectionBuilder,
    URLResponseProcessorBuilder,
    ValidationTextArea,
    _Templated,
    Dialog
) {
    const ADD_NOTE_DIALOG_TITLE = 'Add a note';
    const ADD_NOTE_NOTIFICATION_UID = 'add-note-notification';

    return class AddNoteDialog {
        constructor(node) {
            const view = this._getView();
            this.view = new view({}, domConstruct.create('div', {}, node, 'only'));
            this.view.startup();
        }

        setRevision(revision) {
            this.view.setRevision(revision);
            return this;
        }

        show() {
            this.view.show();
            return this;
        }

        hide() {
            this.view.hide();
            return this;
        }

        on(event, callback) {
            this.view.on(event, callback);
            return this;
        }

        _getView() {
            return declare([_WidgetBase, _Templated], {
                templateString: template,
                revision: null,
                model: null,
                dialog: null,
                noteContent: null,

                postCreate: function() {
                    this.dialog = new Dialog({
                        className: 'sos-layout-dialog-responsive sos-layout-dialog-responsive-footer',
                        content: this.domNode,
                        contentNode: this.domNode,
                        titleString: ADD_NOTE_DIALOG_TITLE,
                        draggable: false
                    });

                    this.noteContent = new ValidationTextArea({
                        'class': 'note-content-textarea-container',
                        'required': true
                    }, this.noteContentNode);

                    this._createDocControlBuilder();
                },

                show: function() {
                    this._reset();
                    this.dialog.show();
                },

                hide: function() {
                    this._reset();
                    this.dialog.hide();
                },

                setRevision: function(revision) {
                    this.revision = revision;
                },

                _reset: function() {
                    domAttr.remove(this.submitNode, 'disabled');
                    this.noteContent.set('disabled', false);
                    this.noteContent.set('value', '');
                },

                _saveNote: function() {
                    this.noteContent._hasBeenBlurred = true;
                    if (!this.noteContent.validate()) {
                        topic.publish(
                            'sos-system-notification',
                            'Unable to save note. Notes cannot be empty.',
                            'error',
                            3000
                        )
                        return;
                    }

                    domAttr.set(this.submitNode, 'disabled', 'disabled');
                    this.noteContent.set('disabled', true);

                    topic.publish(
                        'sos-system-notification-progress',
                        'Saving note...',
                        ADD_NOTE_NOTIFICATION_UID
                    );

                    this.model.add(new HandlersVO(
                        function success(newNote) {
                            topic.publish(
                                'sos-system-notification-progress-complete',
                                ADD_NOTE_NOTIFICATION_UID,
                                'Note saved successfully.',
                                'success',
                                3000
                            );

                            this.dialog.hide();

                            this.emit('note-added', { note: newNote });
                        }.bind(this),
                        function progress() {},
                        DefaultUnauthorisedCallback,
                        function error(e) {
                            topic.publish(
                                'sos-system-notification-progress-complete',
                                ADD_NOTE_NOTIFICATION_UID,
                                'There was an error while saving your note. Please contact support.',
                                'error',
                                3000
                            );

                            domAttr.remove(this.submitNode, 'disabled');
                            this.noteContent.set('disabled', false);
                        }.bind(this)
                    ), new NoteVO().setDocumentPK(this.revision.getDocumentPK()).setNote(this.noteContent.get('value')))
                },

                _createDocControlBuilder: function() {
                    this.model = new DocControlFactory(
                        new DocControlConfig(),
                        new URLConnectionBuilder(
                            new URLConnectionProcessorBuilder()
                        ),
                        new URLResponseProcessorBuilder()
                    ).getNote();
                }
            });
        }
    }
});
},
'soso/dijit/form/ValidationTextarea':function(){
/**
 * If changes are made then run
 * http://[sos root]/javascript/node_modules/intern/client.html?config=tests/intern&suites=tests/unit/soso/dijit/all
 */
define([
    'dojo/_base/declare',
    'dijit/form/Textarea',
    'dijit/form/ValidationTextBox',
    'dojo/dom-class',
    'dojo/dom-attr',
    'dojo/html',
    'dojo/text!./templates/ValidationTextarea.html'
], function(declare, Textarea, ValidationTextBox, domClass, domAttr, html, template) {
    return declare('soso.dijit.form.ValidationTextarea', [Textarea, ValidationTextBox], {
        templateString: template,
        baseClass: '',

        // Match not-whitepsace or whitespace.
        // Default pattern for ValidationTextBox is .* which does not match new line characters
        pattern: "[\\S\\s]*",

        intermediateChanges: true,
        required: false,
        trim: true,

        postCreate: function() {
            this.inherited(arguments);
            // Prevent native "required" functionality in certain browsers (firefox)
            domAttr.remove(this.textbox, 'required');
        },

        // Method to call validation procedure (accessed externally)
        validate: function() {
            var valid = this.inherited(arguments, [/*isFocused = */false]);

            if (valid) {
                this._resetValidation();

            } else if (this._hasBeenBlurred) {
                domClass.add(this.textbox, "dijitTextareaError");
                domClass.toggle(this.domNode, "sos-form-textarea-validation-error", this._isSosFormTextareaValidation());
            }

            return valid;
        },

        displayMessage: function(/*String*/ message) {
            if (this._isSosFormTextareaValidation()) {
                html.set(this.validationPrompt, message);

            } else {
                this.inherited(arguments);
            }
        },

        _isSosFormTextareaValidation: function() {
            return domClass.contains(this.domNode, 'sos-form-textarea-validation');
        },

        // Method to reset all validation errors for the field
        _resetValidation: function() {
            domClass.remove(this.textbox, "dijitTextAreaError");
            domClass.remove(this.textbox, "dijitTextareaError");
            domClass.remove(this.domNode, "sos-form-textarea-validation-error");
        },

        // Method to reset field's value and validation status
        reset: function() {
            this.inherited(arguments);
            this._resetValidation();
        },

        // Method to set regex pattern to validate that widget contains pattern
        _setContainsPatternAttr: function(pattern) {
            this.pattern = "[\\S\\s]*" + pattern + "[\\S\\s]*";
        }
    });
});

},
'dijit/form/Textarea':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/dom-style", // domStyle.set
	"./_ExpandingTextAreaMixin",
	"./SimpleTextarea"
], function(declare, domStyle, _ExpandingTextAreaMixin, SimpleTextarea){

	// module:
	//		dijit/form/Textarea

	return declare("dijit.form.Textarea", [SimpleTextarea, _ExpandingTextAreaMixin], {
		// summary:
		//		A textarea widget that adjusts it's height according to the amount of data.
		//
		// description:
		//		A textarea that dynamically expands/contracts (changing it's height) as
		//		the user types, to display all the text without requiring a scroll bar.
		//
		//		Takes nearly all the parameters (name, value, etc.) that a vanilla textarea takes.
		//		Rows is not supported since this widget adjusts the height.


		// TODO: for 2.0, rename this to ExpandingTextArea, and rename SimpleTextarea to TextArea

		baseClass: "dijitTextBox dijitTextArea dijitExpandingTextArea",

		// Override SimpleTextArea.cols to default to width:100%, for backward compatibility
		cols: "",

		buildRendering: function(){
			this.inherited(arguments);

			// tweak textarea style to reduce browser differences
			domStyle.set(this.textbox, { overflowY: 'hidden', overflowX: 'auto', boxSizing: 'border-box', MsBoxSizing: 'border-box', WebkitBoxSizing: 'border-box', MozBoxSizing: 'border-box' });
		}
	});
});

},
'dijit/form/_ExpandingTextAreaMixin':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/dom-construct", // domConstruct.create
	"dojo/has",
	"dojo/_base/lang", // lang.hitch
	"dojo/on",
	"dojo/_base/window", // win.body
	"../Viewport"
], function(declare, domConstruct, has, lang, on, win, Viewport){

	// module:
	//		dijit/form/_ExpandingTextAreaMixin

	// feature detection, true for mozilla and webkit
	has.add("textarea-needs-help-shrinking", function(){
		var body = win.body(),	// note: if multiple documents exist, doesn't matter which one we use
			te = domConstruct.create('textarea', {
			rows:"5",
			cols:"20",
			value: ' ',
			style: {zoom:1, fontSize:"12px", height:"96px", overflow:'hidden', visibility:'hidden', position:'absolute', border:"5px solid white", margin:"0", padding:"0", boxSizing: 'border-box', MsBoxSizing: 'border-box', WebkitBoxSizing: 'border-box', MozBoxSizing: 'border-box' }
		}, body, "last");
		var needsHelpShrinking = te.scrollHeight >= te.clientHeight;
		body.removeChild(te);
		return needsHelpShrinking;
	});

	return declare("dijit.form._ExpandingTextAreaMixin", null, {
		// summary:
		//		Mixin for textarea widgets to add auto-expanding capability

		_setValueAttr: function(){
			this.inherited(arguments);
			this.resize();
		},

		postCreate: function(){
			this.inherited(arguments);
			var textarea = this.textbox;
			textarea.style.overflowY = "hidden";
			this.own(on(textarea, "focus, resize", lang.hitch(this, "_resizeLater")));
		},

		startup: function(){ 
			this.inherited(arguments);
			this.own(Viewport.on("resize", lang.hitch(this, "_resizeLater")));
			this._resizeLater();
		},

		_onInput: function(e){
			this.inherited(arguments);
			this.resize();
		},

		_estimateHeight: function(){
			// summary:
			//		Approximate the height when the textarea is invisible with the number of lines in the text.
			//		Fails when someone calls setValue with a long wrapping line, but the layout fixes itself when the user clicks inside so . . .
			//		In IE, the resize event is supposed to fire when the textarea becomes visible again and that will correct the size automatically.
			//
			var textarea = this.textbox;
			// #rows = #newlines+1
			textarea.rows = (textarea.value.match(/\n/g) || []).length + 1;
		},

		_resizeLater: function(){
			this.defer("resize");
		},

		resize: function(){
			// summary:
			//		Resizes the textarea vertically (should be called after a style/value change)

			var textarea = this.textbox;

			function textareaScrollHeight(){
				var empty = false;
				if(textarea.value === ''){
					textarea.value = ' ';
					empty = true;
				}
				var sh = textarea.scrollHeight;
				if(empty){ textarea.value = ''; }
				return sh;
			}

			if(textarea.style.overflowY == "hidden"){ textarea.scrollTop = 0; }
			if(this.busyResizing){ return; }
			this.busyResizing = true;
			if(textareaScrollHeight() || textarea.offsetHeight){
				var newH = textareaScrollHeight() + Math.max(textarea.offsetHeight - textarea.clientHeight, 0);
				var newHpx = newH + "px";
				if(newHpx != textarea.style.height){
					textarea.style.height = newHpx;
					textarea.rows = 1; // rows can act like a minHeight if not cleared
				}
				if(has("textarea-needs-help-shrinking")){
					var	origScrollHeight = textareaScrollHeight(),
						newScrollHeight = origScrollHeight,
						origMinHeight = textarea.style.minHeight,
						decrement = 4, // not too fast, not too slow
						thisScrollHeight,
						origScrollTop = textarea.scrollTop;
					textarea.style.minHeight = newHpx; // maintain current height
					textarea.style.height = "auto"; // allow scrollHeight to change
					while(newH > 0){
						textarea.style.minHeight = Math.max(newH - decrement, 4) + "px";
						thisScrollHeight = textareaScrollHeight();
						var change = newScrollHeight - thisScrollHeight;
						newH -= change;
						if(change < decrement){
							break; // scrollHeight didn't shrink
						}
						newScrollHeight = thisScrollHeight;
						decrement <<= 1;
					}
					textarea.style.height = newH + "px";
					textarea.style.minHeight = origMinHeight;
					textarea.scrollTop = origScrollTop;
				}
				textarea.style.overflowY = textareaScrollHeight() > textarea.clientHeight ? "auto" : "hidden";
				if(textarea.style.overflowY == "hidden"){ textarea.scrollTop = 0; }
			}else{
				// hidden content of unknown size
				this._estimateHeight();
			}
			this.busyResizing = false;
		}
	});
});

},
'dijit/form/SimpleTextarea':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/dom-class", // domClass.add
	"dojo/sniff", // has("ie") has("opera")
	"./TextBox"
], function(declare, domClass, has, TextBox){

	// module:
	//		dijit/form/SimpleTextarea

	return declare("dijit.form.SimpleTextarea", TextBox, {
		// summary:
		//		A simple textarea that degrades, and responds to
		//		minimal LayoutContainer usage, and works with dijit/form/Form.
		//		Doesn't automatically size according to input, like Textarea.
		//
		// example:
		//	|	<textarea data-dojo-type="dijit/form/SimpleTextarea" name="foo" value="bar" rows=30 cols=40></textarea>
		//
		// example:
		//	|	new SimpleTextarea({ rows:20, cols:30 }, "foo");

		baseClass: "dijitTextBox dijitTextArea",

		// rows: Number
		//		The number of rows of text.
		rows: "3",

		// rows: Number
		//		The number of characters per line.
		cols: "20",

		templateString: "<textarea ${!nameAttrSetting} data-dojo-attach-point='focusNode,containerNode,textbox' autocomplete='off'></textarea>",

		postMixInProperties: function(){
			// Copy value from srcNodeRef, unless user specified a value explicitly (or there is no srcNodeRef)
			// TODO: parser will handle this in 2.0
			if(!this.value && this.srcNodeRef){
				this.value = this.srcNodeRef.value;
			}
			this.inherited(arguments);
		},

		buildRendering: function(){
			this.inherited(arguments);
			if(has("ie") && this.cols){ // attribute selectors is not supported in IE6
				domClass.add(this.textbox, "dijitTextAreaCols");
			}
		},

		filter: function(/*String*/ value){
			// Override TextBox.filter to deal with newlines... specifically (IIRC) this is for IE which writes newlines
			// as \r\n instead of just \n
			if(value){
				value = value.replace(/\r/g, "");
			}
			return this.inherited(arguments);
		},

		_onInput: function(/*Event?*/ e){
			// Override TextBox._onInput() to enforce maxLength restriction
			if(this.maxLength){
				var maxLength = parseInt(this.maxLength);
				var value = this.textbox.value.replace(/\r/g, '');
				var overflow = value.length - maxLength;
				if(overflow > 0){
					var textarea = this.textbox;
					if(textarea.selectionStart){
						var pos = textarea.selectionStart;
						var cr = 0;
						if(has("opera")){
							cr = (this.textbox.value.substring(0, pos).match(/\r/g) || []).length;
						}
						this.textbox.value = value.substring(0, pos - overflow - cr) + value.substring(pos - cr);
						textarea.setSelectionRange(pos - overflow, pos - overflow);
					}else if(this.ownerDocument.selection){ //IE
						textarea.focus();
						var range = this.ownerDocument.selection.createRange();
						// delete overflow characters
						range.moveStart("character", -overflow);
						range.text = '';
						// show cursor
						range.select();
					}
				}
			}
			this.inherited(arguments);
		}
	});
});

},
'dijit/form/TextBox':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/dom-construct", // domConstruct.create
	"dojo/dom-style", // domStyle.getComputedStyle
	"dojo/_base/kernel", // kernel.deprecated
	"dojo/_base/lang", // lang.hitch
	"dojo/on",
	"dojo/sniff", // has("ie") has("mozilla")
	"./_FormValueWidget",
	"./_TextBoxMixin",
	"dojo/text!./templates/TextBox.html",
	"../main"	// to export dijit._setSelectionRange, remove in 2.0
], function(declare, domConstruct, domStyle, kernel, lang, on, has,
			_FormValueWidget, _TextBoxMixin, template, dijit){

	// module:
	//		dijit/form/TextBox

	var TextBox = declare("dijit.form.TextBox" + (has("dojo-bidi") ? "_NoBidi" : ""), [_FormValueWidget, _TextBoxMixin], {
		// summary:
		//		A base class for textbox form inputs

		templateString: template,
		_singleNodeTemplate: '<input class="dijit dijitReset dijitLeft dijitInputField" data-dojo-attach-point="textbox,focusNode" autocomplete="off" type="${type}" ${!nameAttrSetting} />',

		_buttonInputDisabled: has("ie") ? "disabled" : "", // allows IE to disallow focus, but Firefox cannot be disabled for mousedown events

		baseClass: "dijitTextBox",

		postMixInProperties: function(){
			var type = this.type.toLowerCase();
			if(this.templateString && this.templateString.toLowerCase() == "input" || ((type == "hidden" || type == "file") && this.templateString == this.constructor.prototype.templateString)){
				this.templateString = this._singleNodeTemplate;
			}
			this.inherited(arguments);
		},

		postCreate: function(){
			this.inherited(arguments);

			if(has("ie") < 9){
				// IE INPUT tag fontFamily has to be set directly using STYLE
				// the defer gives IE a chance to render the TextBox and to deal with font inheritance
				this.defer(function(){
					try{
						var s = domStyle.getComputedStyle(this.domNode); // can throw an exception if widget is immediately destroyed
						if(s){
							var ff = s.fontFamily;
							if(ff){
								var inputs = this.domNode.getElementsByTagName("INPUT");
								if(inputs){
									for(var i=0; i < inputs.length; i++){
										inputs[i].style.fontFamily = ff;
									}
								}
							}
						}
					}catch(e){/*when used in a Dialog, and this is called before the dialog is
					 shown, s.fontFamily would trigger "Invalid Argument" error.*/}
				});
			}
		},

		_setPlaceHolderAttr: function(v){
			this._set("placeHolder", v);
			if(!this._phspan){
				this._attachPoints.push('_phspan');
				this._phspan = domConstruct.create('span', {
					// dijitInputField class gives placeHolder same padding as the input field
					// parent node already has dijitInputField class but it doesn't affect this <span>
					// since it's position: absolute.
					className: 'dijitPlaceHolder dijitInputField'
				}, this.textbox, 'after');
				this.own(
					on(this._phspan, "mousedown", function(evt){ evt.preventDefault(); }),
					on(this._phspan, "touchend, pointerup, MSPointerUp", lang.hitch(this, function(){
						// If the user clicks placeholder rather than the <input>, need programmatic focus.  Normally this
						// is done in _FormWidgetMixin._onFocus() but after [30663] it's done on a delay, which is ineffective.
						this.focus();
					}))
				);
			}
			this._phspan.innerHTML="";
			this._phspan.appendChild(this._phspan.ownerDocument.createTextNode(v));
			this._updatePlaceHolder();
		},

		_onInput: function(/*Event*/ evt){
			// summary:
			//		Called AFTER the input event has happened
			//		See if the placeHolder text should be removed or added while editing.
			this.inherited(arguments);
			this._updatePlaceHolder();
		},

		_updatePlaceHolder: function(){
			if(this._phspan){
				this._phspan.style.display = (this.placeHolder && !this.textbox.value) ? "" : "none";
			}
		},

		_setValueAttr: function(value, /*Boolean?*/ priorityChange, /*String?*/ formattedValue){
			this.inherited(arguments);
			this._updatePlaceHolder();
		},

		getDisplayedValue: function(){
			// summary:
			//		Deprecated.  Use get('displayedValue') instead.
			// tags:
			//		deprecated
			kernel.deprecated(this.declaredClass+"::getDisplayedValue() is deprecated. Use get('displayedValue') instead.", "", "2.0");
			return this.get('displayedValue');
		},

		setDisplayedValue: function(/*String*/ value){
			// summary:
			//		Deprecated.  Use set('displayedValue', ...) instead.
			// tags:
			//		deprecated
			kernel.deprecated(this.declaredClass+"::setDisplayedValue() is deprecated. Use set('displayedValue', ...) instead.", "", "2.0");
			this.set('displayedValue', value);
		},

		_onBlur: function(e){
			if(this.disabled){ return; }
			this.inherited(arguments);
			this._updatePlaceHolder();

			if(has("mozilla")){
				if(this.selectOnClick){
					// clear selection so that the next mouse click doesn't reselect
					this.textbox.selectionStart = this.textbox.selectionEnd = undefined;
				}
			}
		},

		_onFocus: function(/*String*/ by){
			if(this.disabled || this.readOnly){ return; }
			this.inherited(arguments);
			this._updatePlaceHolder();
		}
	});

	if(has("ie") < 9){
		TextBox.prototype._isTextSelected = function(){
			var range = this.ownerDocument.selection.createRange();
			var parent = range.parentElement();
			return parent == this.textbox && range.text.length > 0;
		};

		// Overrides definition of _setSelectionRange from _TextBoxMixin (TODO: move to _TextBoxMixin.js?)
		dijit._setSelectionRange = _TextBoxMixin._setSelectionRange = function(/*DomNode*/ element, /*Number?*/ start, /*Number?*/ stop){
			if(element.createTextRange){
				var r = element.createTextRange();
				r.collapse(true);
				r.moveStart("character", -99999); // move to 0
				r.moveStart("character", start); // delta from 0 is the correct position
				r.moveEnd("character", stop-start);
				r.select();
			}
		}
	}

	if(has("dojo-bidi")){
		TextBox = declare("dijit.form.TextBox", TextBox, {
			_setPlaceHolderAttr: function(v){
				this.inherited(arguments);
				this.applyTextDir(this._phspan);
			}
		});
	}

	return TextBox;
});

},
'dijit/form/_FormValueWidget':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/sniff", // has("ie")
	"./_FormWidget",
	"./_FormValueMixin"
], function(declare, has, _FormWidget, _FormValueMixin){

	// module:
	//		dijit/form/_FormValueWidget

	return declare("dijit.form._FormValueWidget", [_FormWidget, _FormValueMixin], {
		// summary:
		//		Base class for widgets corresponding to native HTML elements such as `<input>` or `<select>`
		//		that have user changeable values.
		// description:
		//		Each _FormValueWidget represents a single input value, and has a (possibly hidden) `<input>` element,
		//		to which it serializes it's input value, so that form submission (either normal submission or via FormBind?)
		//		works as expected.

		// Don't attempt to mixin the 'type', 'name' attributes here programatically -- they must be declared
		// directly in the template as read by the parser in order to function. IE is known to specifically
		// require the 'name' attribute at element creation time.  See #8484, #8660.

		_layoutHackIE7: function(){
			// summary:
			//		Work around table sizing bugs on IE7 by forcing redraw

			if(has("ie") == 7){ // fix IE7 layout bug when the widget is scrolled out of sight
				var domNode = this.domNode;
				var parent = domNode.parentNode;
				var pingNode = domNode.firstChild || domNode; // target node most unlikely to have a custom filter
				var origFilter = pingNode.style.filter; // save custom filter, most likely nothing
				var _this = this;
				while(parent && parent.clientHeight == 0){ // search for parents that haven't rendered yet
					(function ping(){
						var disconnectHandle = _this.connect(parent, "onscroll",
							function(){
								_this.disconnect(disconnectHandle); // only call once
								pingNode.style.filter = (new Date()).getMilliseconds(); // set to anything that's unique
								_this.defer(function(){
									pingNode.style.filter = origFilter;
								}); // restore custom filter, if any
							}
						);
					})();
					parent = parent.parentNode;
				}
			}
		}
	});
});

},
'dijit/form/_FormWidget':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/sniff", // has("dijit-legacy-requires"), has("msapp")
	"dojo/_base/kernel", // kernel.deprecated
	"dojo/ready",
	"../_Widget",
	"../_CssStateMixin",
	"../_TemplatedMixin",
	"./_FormWidgetMixin"
], function(declare, has, kernel, ready, _Widget, _CssStateMixin, _TemplatedMixin, _FormWidgetMixin){

	// module:
	//		dijit/form/_FormWidget

	// Back compat w/1.6, remove for 2.0
	if(has("dijit-legacy-requires")){
		ready(0, function(){
			var requires = ["dijit/form/_FormValueWidget"];
			require(requires);	// use indirection so modules not rolled into a build
		});
	}

	return declare("dijit.form._FormWidget", [_Widget, _TemplatedMixin, _CssStateMixin, _FormWidgetMixin], {
		// summary:
		//		Base class for widgets corresponding to native HTML elements such as `<checkbox>` or `<button>`,
		//		which can be children of a `<form>` node or a `dijit/form/Form` widget.
		//
		// description:
		//		Represents a single HTML element.
		//		All these widgets should have these attributes just like native HTML input elements.
		//		You can set them during widget construction or afterwards, via `dijit/_WidgetBase.set()`.
		//
		//		They also share some common methods.

		setDisabled: function(/*Boolean*/ disabled){
			// summary:
			//		Deprecated.  Use set('disabled', ...) instead.
			kernel.deprecated("setDisabled(" + disabled + ") is deprecated. Use set('disabled'," + disabled + ") instead.", "", "2.0");
			this.set('disabled', disabled);
		},

		setValue: function(/*String*/ value){
			// summary:
			//		Deprecated.  Use set('value', ...) instead.
			kernel.deprecated("dijit.form._FormWidget:setValue(" + value + ") is deprecated.  Use set('value'," + value + ") instead.", "", "2.0");
			this.set('value', value);
		},

		getValue: function(){
			// summary:
			//		Deprecated.  Use get('value') instead.
			kernel.deprecated(this.declaredClass + "::getValue() is deprecated. Use get('value') instead.", "", "2.0");
			return this.get('value');
		},

		postMixInProperties: function(){
			// Setup name=foo string to be referenced from the template (but only if a name has been specified).
			// Unfortunately we can't use _setNameAttr to set the name in IE due to IE limitations, see #8484, #8660.
			// But when IE6 and IE7 are desupported, then we probably don't need this anymore, so should remove it in 2.0.
			// Also, don't do this for Windows 8 Store Apps because it causes a security exception (see #16452).
			// Regarding escaping, see heading "Attribute values" in
			// http://www.w3.org/TR/REC-html40/appendix/notes.html#h-B.3.2
			this.nameAttrSetting = (this.name && !has("msapp")) ? ('name="' + this.name.replace(/"/g, "&quot;") + '"') : '';
			this.inherited(arguments);
		}
	});
});

},
'dijit/_CssStateMixin':function(){
define([
	"dojo/_base/array", // array.forEach array.map
	"dojo/_base/declare", // declare
	"dojo/dom", // dom.isDescendant()
	"dojo/dom-class", // domClass.toggle
	"dojo/has",
	"dojo/_base/lang", // lang.hitch
	"dojo/on",
	"dojo/domReady",
	"dojo/touch",
	"dojo/_base/window", // win.body
	"./a11yclick",
	"./registry"
], function(array, declare, dom, domClass, has, lang, on, domReady, touch, win, a11yclick, registry){

	// module:
	//		dijit/_CssStateMixin

	var CssStateMixin = declare("dijit._CssStateMixin", [], {
		// summary:
		//		Mixin for widgets to set CSS classes on the widget DOM nodes depending on hover/mouse press/focus
		//		state changes, and also higher-level state changes such becoming disabled or selected.
		//
		// description:
		//		By mixing this class into your widget, and setting the this.baseClass attribute, it will automatically
		//		maintain CSS classes on the widget root node (this.domNode) depending on hover,
		//		active, focus, etc. state.   Ex: with a baseClass of dijitButton, it will apply the classes
		//		dijitButtonHovered and dijitButtonActive, as the user moves the mouse over the widget and clicks it.
		//
		//		It also sets CSS like dijitButtonDisabled based on widget semantic state.
		//
		//		By setting the cssStateNodes attribute, a widget can also track events on subnodes (like buttons
		//		within the widget).

		/*=====
		 // cssStateNodes: [protected] Object
		 //		Subclasses may define a cssStateNodes property that lists sub-nodes within the widget that
		 //		need CSS classes applied on mouse hover/press and focus.
		 //
		 //		Each entry in this optional hash is a an attach-point name (like "upArrowButton") mapped to a CSS class name
		 //		(like "dijitUpArrowButton"). Example:
		 //	|		{
		 //	|			"upArrowButton": "dijitUpArrowButton",
		 //	|			"downArrowButton": "dijitDownArrowButton"
		 //	|		}
		 //		The above will set the CSS class dijitUpArrowButton to the this.upArrowButton DOMNode when it
		 //		is hovered, etc.
		 cssStateNodes: {},
		 =====*/

		// hovering: [readonly] Boolean
		//		True if cursor is over this widget
		hovering: false,

		// active: [readonly] Boolean
		//		True if mouse was pressed while over this widget, and hasn't been released yet
		active: false,

		_applyAttributes: function(){
			// This code would typically be in postCreate(), but putting in _applyAttributes() for
			// performance: so the class changes happen before DOM is inserted into the document.
			// Change back to postCreate() in 2.0.  See #11635.

			this.inherited(arguments);

			// Monitoring changes to disabled, readonly, etc. state, and update CSS class of root node
			array.forEach(["disabled", "readOnly", "checked", "selected", "focused", "state", "hovering", "active", "_opened"], function(attr){
				this.watch(attr, lang.hitch(this, "_setStateClass"));
			}, this);

			// Track hover and active mouse events on widget root node, plus possibly on subnodes
			for(var ap in this.cssStateNodes || {}){
				this._trackMouseState(this[ap], this.cssStateNodes[ap]);
			}
			this._trackMouseState(this.domNode, this.baseClass);

			// Set state initially; there's probably no hover/active/focus state but widget might be
			// disabled/readonly/checked/selected so we want to set CSS classes for those conditions.
			this._setStateClass();
		},

		_cssMouseEvent: function(/*Event*/ event){
			// summary:
			//		Handler for CSS event on this.domNode. Sets hovering and active properties depending on mouse state,
			//		which triggers _setStateClass() to set appropriate CSS classes for this.domNode.

			if(!this.disabled){
				switch(event.type){
					case "mouseover":
					case "MSPointerOver":
					case "pointerover":
						this._set("hovering", true);
						this._set("active", this._mouseDown);
						break;
					case "mouseout":
					case "MSPointerOut":
					case "pointerout":
						this._set("hovering", false);
						this._set("active", false);
						break;
					case "mousedown":
					case "touchstart":
					case "MSPointerDown":
					case "pointerdown":
					case "keydown":
						this._set("active", true);
						break;
					case "mouseup":
					case "dojotouchend":
					case "MSPointerUp":
					case "pointerup":
					case "keyup":
						this._set("active", false);
						break;
				}
			}
		},

		_setStateClass: function(){
			// summary:
			//		Update the visual state of the widget by setting the css classes on this.domNode
			//		(or this.stateNode if defined) by combining this.baseClass with
			//		various suffixes that represent the current widget state(s).
			//
			// description:
			//		In the case where a widget has multiple
			//		states, it sets the class based on all possible
			//		combinations.  For example, an invalid form widget that is being hovered
			//		will be "dijitInput dijitInputInvalid dijitInputHover dijitInputInvalidHover".
			//
			//		The widget may have one or more of the following states, determined
			//		by this.state, this.checked, this.valid, and this.selected:
			//
			//		- Error - ValidationTextBox sets this.state to "Error" if the current input value is invalid
			//		- Incomplete - ValidationTextBox sets this.state to "Incomplete" if the current input value is not finished yet
			//		- Checked - ex: a checkmark or a ToggleButton in a checked state, will have this.checked==true
			//		- Selected - ex: currently selected tab will have this.selected==true
			//
			//		In addition, it may have one or more of the following states,
			//		based on this.disabled and flags set in _onMouse (this.active, this.hovering) and from focus manager (this.focused):
			//
			//		- Disabled	- if the widget is disabled
			//		- Active		- if the mouse (or space/enter key?) is being pressed down
			//		- Focused		- if the widget has focus
			//		- Hover		- if the mouse is over the widget

			// Compute new set of classes
			var newStateClasses = this.baseClass.split(" ");

			function multiply(modifier){
				newStateClasses = newStateClasses.concat(array.map(newStateClasses, function(c){
					return c + modifier;
				}), "dijit" + modifier);
			}

			if(!this.isLeftToRight()){
				// For RTL mode we need to set an addition class like dijitTextBoxRtl.
				multiply("Rtl");
			}

			var checkedState = this.checked == "mixed" ? "Mixed" : (this.checked ? "Checked" : "");
			if(this.checked){
				multiply(checkedState);
			}
			if(this.state){
				multiply(this.state);
			}
			if(this.selected){
				multiply("Selected");
			}
			if(this._opened){
				multiply("Opened");
			}

			if(this.disabled){
				multiply("Disabled");
			}else if(this.readOnly){
				multiply("ReadOnly");
			}else{
				if(this.active){
					multiply("Active");
				}else if(this.hovering){
					multiply("Hover");
				}
			}

			if(this.focused){
				multiply("Focused");
			}

			// Remove old state classes and add new ones.
			// For performance concerns we only write into domNode.className once.
			var tn = this.stateNode || this.domNode,
				classHash = {};	// set of all classes (state and otherwise) for node

			array.forEach(tn.className.split(" "), function(c){
				classHash[c] = true;
			});

			if("_stateClasses" in this){
				array.forEach(this._stateClasses, function(c){
					delete classHash[c];
				});
			}

			array.forEach(newStateClasses, function(c){
				classHash[c] = true;
			});

			var newClasses = [];
			for(var c in classHash){
				newClasses.push(c);
			}
			tn.className = newClasses.join(" ");

			this._stateClasses = newStateClasses;
		},

		_subnodeCssMouseEvent: function(node, clazz, evt){
			// summary:
			//		Handler for hover/active mouse event on widget's subnode
			if(this.disabled || this.readOnly){
				return;
			}

			function hover(isHovering){
				domClass.toggle(node, clazz + "Hover", isHovering);
			}

			function active(isActive){
				domClass.toggle(node, clazz + "Active", isActive);
			}

			function focused(isFocused){
				domClass.toggle(node, clazz + "Focused", isFocused);
			}

			switch(evt.type){
				case "mouseover":
				case "MSPointerOver":
				case "pointerover":
					hover(true);
					break;
				case "mouseout":
				case "MSPointerOut":
				case "pointerout":
					hover(false);
					active(false);
					break;
				case "mousedown":
				case "touchstart":
				case "MSPointerDown":
				case "pointerdown":
				case "keydown":
					active(true);
					break;
				case "mouseup":
				case "MSPointerUp":
				case "pointerup":
				case "dojotouchend":
				case "keyup":
					active(false);
					break;
				case "focus":
				case "focusin":
					focused(true);
					break;
				case "blur":
				case "focusout":
					focused(false);
					break;
			}
		},

		_trackMouseState: function(/*DomNode*/ node, /*String*/ clazz){
			// summary:
			//		Track mouse/focus events on specified node and set CSS class on that node to indicate
			//		current state.   Usually not called directly, but via cssStateNodes attribute.
			// description:
			//		Given class=foo, will set the following CSS class on the node
			//
			//		- fooActive: if the user is currently pressing down the mouse button while over the node
			//		- fooHover: if the user is hovering the mouse over the node, but not pressing down a button
			//		- fooFocus: if the node is focused
			//
			//		Note that it won't set any classes if the widget is disabled.
			// node: DomNode
			//		Should be a sub-node of the widget, not the top node (this.domNode), since the top node
			//		is handled specially and automatically just by mixing in this class.
			// clazz: String
			//		CSS class name (ex: dijitSliderUpArrow)

			// Flag for listener code below to call this._cssMouseEvent() or this._subnodeCssMouseEvent()
			// when node is hovered/active
			node._cssState = clazz;
		}
	});

	domReady(function(){
		// Document level listener to catch hover etc. events on widget root nodes and subnodes.
		// Note that when the mouse is moved quickly, a single onmouseenter event could signal that multiple widgets
		// have been hovered or unhovered (try test_Accordion.html)

		function pointerHandler(evt, target, relatedTarget){
			// Handler for mouseover, mouseout, a11yclick.press and a11click.release events

			// Poor man's event propagation.  Don't propagate event to ancestors of evt.relatedTarget,
			// to avoid processing mouseout events moving from a widget's domNode to a descendant node;
			// such events shouldn't be interpreted as a mouseleave on the widget.
			if(relatedTarget && dom.isDescendant(relatedTarget, target)){
				return;
			}

			for(var node = target; node && node != relatedTarget; node = node.parentNode){
				// Process any nodes with _cssState property.   They are generally widget root nodes,
				// but could also be sub-nodes within a widget
				if(node._cssState){
					var widget = registry.getEnclosingWidget(node);
					if(widget){
						if(node == widget.domNode){
							// event on the widget's root node
							widget._cssMouseEvent(evt);
						}else{
							// event on widget's sub-node
							widget._subnodeCssMouseEvent(node, node._cssState, evt);
						}
					}
				}
			}
		}

		var body = win.body(), activeNode;

		// Handle pointer related events (i.e. mouse or touch)
		on(body, touch.over, function(evt){
			// Using touch.over rather than mouseover mainly to ignore phantom mouse events on iOS.
			pointerHandler(evt, evt.target, evt.relatedTarget);
		});
		on(body, touch.out, function(evt){
			// Using touch.out rather than mouseout mainly to ignore phantom mouse events on iOS.
			pointerHandler(evt, evt.target, evt.relatedTarget);
		});
		on(body, a11yclick.press, function(evt){
			// Save the a11yclick.press target to reference when the a11yclick.release comes.
			activeNode = evt.target;
			pointerHandler(evt, activeNode)
		});
		on(body, a11yclick.release, function(evt){
			// The release event could come on a separate node than the press event, if for example user slid finger.
			// Reference activeNode to reset the state of the node that got state set in the a11yclick.press handler.
			pointerHandler(evt, activeNode);
			activeNode = null;
		});

		// Track focus events on widget sub-nodes that have been registered via _trackMouseState().
		// However, don't track focus events on the widget root nodes, because focus is tracked via the
		// focus manager (and it's not really tracking focus, but rather tracking that focus is on one of the widget's
		// nodes or a subwidget's node or a popup node, etc.)
		// Remove for 2.0 (if focus CSS needed, just use :focus pseudo-selector).
		on(body, "focusin, focusout", function(evt){
			var node = evt.target;
			if(node._cssState && !node.getAttribute("widgetId")){
				var widget = registry.getEnclosingWidget(node);
				if(widget){
					widget._subnodeCssMouseEvent(node, node._cssState, evt);
				}
			}
		});
	});

	return CssStateMixin;
});

},
'dijit/form/_FormWidgetMixin':function(){
define([
	"dojo/_base/array", // array.forEach
	"dojo/_base/declare", // declare
	"dojo/dom-attr", // domAttr.set
	"dojo/dom-style", // domStyle.get
	"dojo/_base/lang", // lang.hitch lang.isArray
	"dojo/mouse", // mouse.isLeft
	"dojo/on",
	"dojo/sniff", // has("webkit")
	"dojo/window", // winUtils.scrollIntoView
	"../a11y"    // a11y.hasDefaultTabStop
], function(array, declare, domAttr, domStyle, lang, mouse, on, has, winUtils, a11y){

	// module:
	//		dijit/form/_FormWidgetMixin

	return declare("dijit.form._FormWidgetMixin", null, {
		// summary:
		//		Mixin for widgets corresponding to native HTML elements such as `<checkbox>` or `<button>`,
		//		which can be children of a `<form>` node or a `dijit/form/Form` widget.
		//
		// description:
		//		Represents a single HTML element.
		//		All these widgets should have these attributes just like native HTML input elements.
		//		You can set them during widget construction or afterwards, via `dijit/_WidgetBase.set()`.
		//
		//		They also share some common methods.

		// name: [const] String
		//		Name used when submitting form; same as "name" attribute or plain HTML elements
		name: "",

		// alt: String
		//		Corresponds to the native HTML `<input>` element's attribute.
		alt: "",

		// value: String
		//		Corresponds to the native HTML `<input>` element's attribute.
		value: "",

		// type: [const] String
		//		Corresponds to the native HTML `<input>` element's attribute.
		type: "text",

		// type: String
		//		Apply aria-label in markup to the widget's focusNode
		"aria-label": "focusNode",

		// tabIndex: String
		//		Order fields are traversed when user hits the tab key
		tabIndex: "0",
		_setTabIndexAttr: "focusNode", // force copy even when tabIndex default value, needed since Button is <span>

		// disabled: Boolean
		//		Should this widget respond to user input?
		//		In markup, this is specified as "disabled='disabled'", or just "disabled".
		disabled: false,

		// intermediateChanges: Boolean
		//		Fires onChange for each value change or only on demand
		intermediateChanges: false,

		// scrollOnFocus: Boolean
		//		On focus, should this widget scroll into view?
		scrollOnFocus: true,

		// Override _WidgetBase mapping id to this.domNode, needs to be on focusNode so <label> etc.
		// works with screen reader
		_setIdAttr: "focusNode",

		_setDisabledAttr: function(/*Boolean*/ value){
			this._set("disabled", value);

			// Set disabled property if focusNode is an <input>, but aria-disabled attribute if focusNode is a <span>.
			// Can't use "disabled" in this.focusNode as a test because on IE, that's true for all nodes.
			if(/^(button|input|select|textarea|optgroup|option|fieldset)$/i.test(this.focusNode.tagName)){
				domAttr.set(this.focusNode, 'disabled', value);
				// IE has a Caret Browsing mode (hit F7 to activate) where disabled textboxes can be modified
				// textboxes marked readonly if disabled to avoid this issue.
				if (has('trident') && 'readOnly' in this) {
					domAttr.set(this.focusNode, 'readonly', value || this.readOnly);
				}
			}else{
				this.focusNode.setAttribute("aria-disabled", value ? "true" : "false");
			}

			// And also set disabled on the hidden <input> node
			if(this.valueNode){
				domAttr.set(this.valueNode, 'disabled', value);
			}

			if(value){
				// reset these, because after the domNode is disabled, we can no longer receive
				// mouse related events, see #4200
				this._set("hovering", false);
				this._set("active", false);

				// clear tab stop(s) on this widget's focusable node(s)  (ComboBox has two focusable nodes)
				var attachPointNames = "tabIndex" in this.attributeMap ? this.attributeMap.tabIndex :
					("_setTabIndexAttr" in this) ? this._setTabIndexAttr : "focusNode";
				array.forEach(lang.isArray(attachPointNames) ? attachPointNames : [attachPointNames], function(attachPointName){
					var node = this[attachPointName];
					// complex code because tabIndex=-1 on a <div> doesn't work on FF
					if(has("webkit") || a11y.hasDefaultTabStop(node)){    // see #11064 about webkit bug
						node.setAttribute('tabIndex', "-1");
					}else{
						node.removeAttribute('tabIndex');
					}
				}, this);
			}else{
				if(this.tabIndex != ""){
					this.set('tabIndex', this.tabIndex);
				}
			}
		},

		_onFocus: function(/*String*/ by){
			// If user clicks on the widget, even if the mouse is released outside of it,
			// this widget's focusNode should get focus (to mimic native browser behavior).
			// Browsers often need help to make sure the focus via mouse actually gets to the focusNode.
			// TODO: consider removing all of this for 2.0 or sooner, see #16622 etc.
			if(by == "mouse" && this.isFocusable()){
				// IE exhibits strange scrolling behavior when refocusing a node so only do it when !focused.
				var focusHandle = this.own(on(this.focusNode, "focus", function(){
					mouseUpHandle.remove();
					focusHandle.remove();
				}))[0];
				// Set a global event to handle mouseup, so it fires properly
				// even if the cursor leaves this.domNode before the mouse up event.
				var event = has("pointer-events") ? "pointerup" : has("MSPointer") ? "MSPointerUp" :
					has("touch-events") ? "touchend, mouseup" :		// seems like overkill but see #16622, #16725
					"mouseup";
				var mouseUpHandle = this.own(on(this.ownerDocumentBody, event, lang.hitch(this, function(evt){
					mouseUpHandle.remove();
					focusHandle.remove();
					// if here, then the mousedown did not focus the focusNode as the default action
					if(this.focused){
						if(evt.type == "touchend"){
							this.defer("focus"); // native focus hasn't occurred yet
						}else{
							this.focus(); // native focus already occurred on mousedown
						}
					}
				})))[0];
			}
			if(this.scrollOnFocus){
				this.defer(function(){
					winUtils.scrollIntoView(this.domNode);
				}); // without defer, the input caret position can change on mouse click
			}
			this.inherited(arguments);
		},

		isFocusable: function(){
			// summary:
			//		Tells if this widget is focusable or not.  Used internally by dijit.
			// tags:
			//		protected
			return !this.disabled && this.focusNode && (domStyle.get(this.domNode, "display") != "none");
		},

		focus: function(){
			// summary:
			//		Put focus on this widget
			if(!this.disabled && this.focusNode.focus){
				try{
					this.focusNode.focus();
				}catch(e){
				}
				/*squelch errors from hidden nodes*/
			}
		},

		compare: function(/*anything*/ val1, /*anything*/ val2){
			// summary:
			//		Compare 2 values (as returned by get('value') for this widget).
			// tags:
			//		protected
			if(typeof val1 == "number" && typeof val2 == "number"){
				return (isNaN(val1) && isNaN(val2)) ? 0 : val1 - val2;
			}else if(val1 > val2){
				return 1;
			}else if(val1 < val2){
				return -1;
			}else{
				return 0;
			}
		},

		onChange: function(/*===== newValue =====*/){
			// summary:
			//		Callback when this widget's value is changed.
			// tags:
			//		callback
		},

		// _onChangeActive: [private] Boolean
		//		Indicates that changes to the value should call onChange() callback.
		//		This is false during widget initialization, to avoid calling onChange()
		//		when the initial value is set.
		_onChangeActive: false,

		_handleOnChange: function(/*anything*/ newValue, /*Boolean?*/ priorityChange){
			// summary:
			//		Called when the value of the widget is set.  Calls onChange() if appropriate
			// newValue:
			//		the new value
			// priorityChange:
			//		For a slider, for example, dragging the slider is priorityChange==false,
			//		but on mouse up, it's priorityChange==true.  If intermediateChanges==false,
			//		onChange is only called form priorityChange=true events.
			// tags:
			//		private
			if(this._lastValueReported == undefined && (priorityChange === null || !this._onChangeActive)){
				// this block executes not for a change, but during initialization,
				// and is used to store away the original value (or for ToggleButton, the original checked state)
				this._resetValue = this._lastValueReported = newValue;
			}
			this._pendingOnChange = this._pendingOnChange
				|| (typeof newValue != typeof this._lastValueReported)
				|| (this.compare(newValue, this._lastValueReported) != 0);
			if((this.intermediateChanges || priorityChange || priorityChange === undefined) && this._pendingOnChange){
				this._lastValueReported = newValue;
				this._pendingOnChange = false;
				if(this._onChangeActive){
					if(this._onChangeHandle){
						this._onChangeHandle.remove();
					}
					// defer allows hidden value processing to run and
					// also the onChange handler can safely adjust focus, etc
					this._onChangeHandle = this.defer(
						function(){
							this._onChangeHandle = null;
							this.onChange(newValue);
						}); // try to collapse multiple onChange's fired faster than can be processed
				}
			}
		},

		create: function(){
			// Overrides _Widget.create()
			this.inherited(arguments);
			this._onChangeActive = true;
		},

		destroy: function(){
			if(this._onChangeHandle){ // destroy called before last onChange has fired
				this._onChangeHandle.remove();
				this.onChange(this._lastValueReported);
			}
			this.inherited(arguments);
		}
	});
});

},
'dijit/form/_FormValueMixin':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/dom-attr", // domAttr.set
	"dojo/keys", // keys.ESCAPE
	"dojo/_base/lang",
	"dojo/on",
	"dojo/sniff", // has("webkit")
	"./_FormWidgetMixin"
], function(declare, domAttr, keys, lang, on, has, _FormWidgetMixin){

	// module:
	//		dijit/form/_FormValueMixin

	return declare("dijit.form._FormValueMixin", _FormWidgetMixin, {
		// summary:
		//		Mixin for widgets corresponding to native HTML elements such as `<input>` or `<select>`
		//		that have user changeable values.
		// description:
		//		Each _FormValueMixin represents a single input value, and has a (possibly hidden) `<input>` element,
		//		to which it serializes it's input value, so that form submission (either normal submission or via FormBind?)
		//		works as expected.

		// readOnly: Boolean
		//		Should this widget respond to user input?
		//		In markup, this is specified as "readOnly".
		//		Similar to disabled except readOnly form values are submitted.
		readOnly: false,

		_setReadOnlyAttr: function(/*Boolean*/ value){
			// IE has a Caret Browsing mode (hit F7 to activate) where disabled textboxes can be modified
			// focusNode enforced readonly if currently disabled to avoid this issue.
			if (has('trident') && 'disabled' in this) {
				domAttr.set(this.focusNode, 'readOnly', value || this.disabled);
			} else {
				domAttr.set(this.focusNode, 'readOnly', value);
			}
			this._set("readOnly", value);
		},

		postCreate: function(){
			this.inherited(arguments);

			// Update our reset value if it hasn't yet been set (because this.set()
			// is only called when there *is* a value)
			if(this._resetValue === undefined){
				this._lastValueReported = this._resetValue = this.value;
			}
		},

		_setValueAttr: function(/*anything*/ newValue, /*Boolean?*/ priorityChange){
			// summary:
			//		Hook so set('value', value) works.
			// description:
			//		Sets the value of the widget.
			//		If the value has changed, then fire onChange event, unless priorityChange
			//		is specified as null (or false?)
			this._handleOnChange(newValue, priorityChange);
		},

		_handleOnChange: function(/*anything*/ newValue, /*Boolean?*/ priorityChange){
			// summary:
			//		Called when the value of the widget has changed.  Saves the new value in this.value,
			//		and calls onChange() if appropriate.   See _FormWidget._handleOnChange() for details.
			this._set("value", newValue);
			this.inherited(arguments);
		},

		undo: function(){
			// summary:
			//		Restore the value to the last value passed to onChange
			this._setValueAttr(this._lastValueReported, false);
		},

		reset: function(){
			// summary:
			//		Reset the widget's value to what it was at initialization time
			this._hasBeenBlurred = false;
			this._setValueAttr(this._resetValue, true);
		}
	});
});

},
'dijit/form/_TextBoxMixin':function(){
define([
	"dojo/_base/array", // array.forEach
	"dojo/_base/declare", // declare
	"dojo/dom", // dom.byId
	"dojo/sniff",	// has("ie"), has("dojo-bidi")
	"dojo/keys", // keys.ALT keys.CAPS_LOCK keys.CTRL keys.META keys.SHIFT
	"dojo/_base/lang", // lang.mixin
	"dojo/on", // on
	"../main"    // for exporting dijit._setSelectionRange, dijit.selectInputText
], function(array, declare, dom, has, keys, lang, on, dijit){

	// module:
	//		dijit/form/_TextBoxMixin

	var _TextBoxMixin = declare("dijit.form._TextBoxMixin" + (has("dojo-bidi") ? "_NoBidi" : ""), null, {
		// summary:
		//		A mixin for textbox form input widgets

		// trim: Boolean
		//		Removes leading and trailing whitespace if true.  Default is false.
		trim: false,

		// uppercase: Boolean
		//		Converts all characters to uppercase if true.  Default is false.
		uppercase: false,

		// lowercase: Boolean
		//		Converts all characters to lowercase if true.  Default is false.
		lowercase: false,

		// propercase: Boolean
		//		Converts the first character of each word to uppercase if true.
		propercase: false,

		// maxLength: String
		//		HTML INPUT tag maxLength declaration.
		maxLength: "",

		// selectOnClick: [const] Boolean
		//		If true, all text will be selected when focused with mouse
		selectOnClick: false,

		// placeHolder: String
		//		Defines a hint to help users fill out the input field (as defined in HTML 5).
		//		This should only contain plain text (no html markup).
		placeHolder: "",

		_getValueAttr: function(){
			// summary:
			//		Hook so get('value') works as we like.
			// description:
			//		For `dijit/form/TextBox` this basically returns the value of the `<input>`.
			//
			//		For `dijit/form/MappedTextBox` subclasses, which have both
			//		a "displayed value" and a separate "submit value",
			//		This treats the "displayed value" as the master value, computing the
			//		submit value from it via this.parse().
			return this.parse(this.get('displayedValue'), this.constraints);
		},

		_setValueAttr: function(value, /*Boolean?*/ priorityChange, /*String?*/ formattedValue){
			// summary:
			//		Hook so set('value', ...) works.
			//
			// description:
			//		Sets the value of the widget to "value" which can be of
			//		any type as determined by the widget.
			//
			// value:
			//		The visual element value is also set to a corresponding,
			//		but not necessarily the same, value.
			//
			// formattedValue:
			//		If specified, used to set the visual element value,
			//		otherwise a computed visual value is used.
			//
			// priorityChange:
			//		If true, an onChange event is fired immediately instead of
			//		waiting for the next blur event.

			var filteredValue;
			if(value !== undefined){
				// TODO: this is calling filter() on both the display value and the actual value.
				// I added a comment to the filter() definition about this, but it should be changed.
				filteredValue = this.filter(value);
				if(typeof formattedValue != "string"){
					if(filteredValue !== null && ((typeof filteredValue != "number") || !isNaN(filteredValue))){
						formattedValue = this.filter(this.format(filteredValue, this.constraints));
					}else{
						formattedValue = '';
					}
					// Ensure the filtered value does not change after being formatted. See track #17955.
					//
					// This check is only applied when the formatted value is not specified by the caller in order to allow the 
					// behavior to be overriden. This is needed whenever value synonyms cannot be determined using parse/compare. For
					// example, dijit/form/FilteringSelect determines the formatted value asynchronously and applies it using a 
					// callback to this method.
					//
					// TODO: Should developers be warned that they broke the round trip on format?
					if (this.compare(filteredValue, this.filter(this.parse(formattedValue, this.constraints))) != 0){
						formattedValue = null;
					}
				}
			}
			if(formattedValue != null /* and !undefined */ && ((typeof formattedValue) != "number" || !isNaN(formattedValue)) && this.textbox.value != formattedValue){
				this.textbox.value = formattedValue;
				this._set("displayedValue", this.get("displayedValue"));
			}

			this.inherited(arguments, [filteredValue, priorityChange]);
		},

		// displayedValue: String
		//		For subclasses like ComboBox where the displayed value
		//		(ex: Kentucky) and the serialized value (ex: KY) are different,
		//		this represents the displayed value.
		//
		//		Setting 'displayedValue' through set('displayedValue', ...)
		//		updates 'value', and vice-versa.  Otherwise 'value' is updated
		//		from 'displayedValue' periodically, like onBlur etc.
		//
		//		TODO: move declaration to MappedTextBox?
		//		Problem is that ComboBox references displayedValue,
		//		for benefit of FilteringSelect.
		displayedValue: "",

		_getDisplayedValueAttr: function(){
			// summary:
			//		Hook so get('displayedValue') works.
			// description:
			//		Returns the displayed value (what the user sees on the screen),
			//		after filtering (ie, trimming spaces etc.).
			//
			//		For some subclasses of TextBox (like ComboBox), the displayed value
			//		is different from the serialized value that's actually
			//		sent to the server (see `dijit/form/ValidationTextBox.serialize()`)

			// TODO: maybe we should update this.displayedValue on every keystroke so that we don't need
			// this method
			// TODO: this isn't really the displayed value when the user is typing
			return this.filter(this.textbox.value);
		},

		_setDisplayedValueAttr: function(/*String*/ value){
			// summary:
			//		Hook so set('displayedValue', ...) works.
			// description:
			//		Sets the value of the visual element to the string "value".
			//		The widget value is also set to a corresponding,
			//		but not necessarily the same, value.

			if(value == null /* or undefined */){
				value = ''
			}
			else if(typeof value != "string"){
				value = String(value)
			}

			this.textbox.value = value;

			// sets the serialized value to something corresponding to specified displayedValue
			// (if possible), and also updates the textbox.value, for example converting "123"
			// to "123.00"
			this._setValueAttr(this.get('value'), undefined);

			this._set("displayedValue", this.get('displayedValue'));
		},

		format: function(value /*=====, constraints =====*/){
			// summary:
			//		Replaceable function to convert a value to a properly formatted string.
			// value: String
			// constraints: Object
			// tags:
			//		protected extension
			return value == null /* or undefined */ ? "" : (value.toString ? value.toString() : value);
		},

		parse: function(value /*=====, constraints =====*/){
			// summary:
			//		Replaceable function to convert a formatted string to a value
			// value: String
			// constraints: Object
			// tags:
			//		protected extension

			return value;	// String
		},

		_refreshState: function(){
			// summary:
			//		After the user types some characters, etc., this method is
			//		called to check the field for validity etc.  The base method
			//		in `dijit/form/TextBox` does nothing, but subclasses override.
			// tags:
			//		protected
		},

		 onInput: function(/*Event*/ /*===== evt =====*/){
			 // summary:
			 //		Connect to this function to receive notifications of various user data-input events.
			 //		Return false to cancel the event and prevent it from being processed.
			 //		Note that although for historical reasons this method is called `onInput()`, it doesn't
			 //		correspond to the standard DOM "input" event, because it occurs before the input has been processed.
			 // event:
			 //		keydown | keypress | cut | paste | compositionend
			 // tags:
			 //		callback
		 },

		_onInput: function(/*Event*/ evt){
			// summary:
			//		Called AFTER the input event has happened and this.textbox.value has new value.

			this._lastInputEventValue = this.textbox.value;

			// For Combobox, this needs to be called w/the keydown/keypress event that was passed to onInput().
			// As a backup, use the "input" event itself.
			this._processInput(this._lastInputProducingEvent || evt);
			delete this._lastInputProducingEvent;

			if(this.intermediateChanges){
				this._handleOnChange(this.get('value'), false);
			}
		},

		_processInput: function(/*Event*/ /*===== evt =====*/){
			// summary:
			//		Default action handler for user input events.
			//		Called after the "input" event (i.e. after this.textbox.value has been updated),
			//		but `evt` is the keydown/keypress/etc. event that triggered the "input" event.
			// tags:
			//		protected

			this._refreshState();

			// In case someone is watch()'ing for changes to displayedValue
			this._set("displayedValue", this.get("displayedValue"));
		},

		postCreate: function(){
			// setting the value here is needed since value="" in the template causes "undefined"
			// and setting in the DOM (instead of the JS object) helps with form reset actions
			this.textbox.setAttribute("value", this.textbox.value); // DOM and JS values should be the same

			this.inherited(arguments);

			// normalize input events to reduce spurious event processing
			//	keydown: do not forward modifier keys
			//		       set charOrCode to numeric keycode
			//	keypress: do not forward numeric charOrCode keys (already sent through onkeydown)
			//	paste, cut, compositionend: set charOrCode to 229 (IME)
			function handleEvent(e){
				var charOrCode;

				// Filter out keydown events that will be followed by keypress events.  Note that chrome/android
				// w/word suggestion has keydown/229 events on typing with no corresponding keypress events.
				if(e.type == "keydown" && e.keyCode != 229){
					charOrCode = e.keyCode;
					switch(charOrCode){ // ignore state keys
						case keys.SHIFT:
						case keys.ALT:
						case keys.CTRL:
						case keys.META:
						case keys.CAPS_LOCK:
						case keys.NUM_LOCK:
						case keys.SCROLL_LOCK:
							return;
					}
					if(!e.ctrlKey && !e.metaKey && !e.altKey){ // no modifiers
						switch(charOrCode){ // ignore location keys
							case keys.NUMPAD_0:
							case keys.NUMPAD_1:
							case keys.NUMPAD_2:
							case keys.NUMPAD_3:
							case keys.NUMPAD_4:
							case keys.NUMPAD_5:
							case keys.NUMPAD_6:
							case keys.NUMPAD_7:
							case keys.NUMPAD_8:
							case keys.NUMPAD_9:
							case keys.NUMPAD_MULTIPLY:
							case keys.NUMPAD_PLUS:
							case keys.NUMPAD_ENTER:
							case keys.NUMPAD_MINUS:
							case keys.NUMPAD_PERIOD:
							case keys.NUMPAD_DIVIDE:
								return;
						}
						if((charOrCode >= 65 && charOrCode <= 90) || (charOrCode >= 48 && charOrCode <= 57) || charOrCode == keys.SPACE){
							return; // keypress will handle simple non-modified printable keys
						}
						var named = false;
						for(var i in keys){
							if(keys[i] === e.keyCode){
								named = true;
								break;
							}
						}
						if(!named){
							return;
						} // only allow named ones through
					}
				}

				charOrCode = e.charCode >= 32 ? String.fromCharCode(e.charCode) : e.charCode;
				if(!charOrCode){
					charOrCode = (e.keyCode >= 65 && e.keyCode <= 90) || (e.keyCode >= 48 && e.keyCode <= 57) || e.keyCode == keys.SPACE ? String.fromCharCode(e.keyCode) : e.keyCode;
				}
				if(!charOrCode){
					charOrCode = 229; // IME
				}
				if(e.type == "keypress"){
					if(typeof charOrCode != "string"){
						return;
					}
					if((charOrCode >= 'a' && charOrCode <= 'z') || (charOrCode >= 'A' && charOrCode <= 'Z') || (charOrCode >= '0' && charOrCode <= '9') || (charOrCode === ' ')){
						if(e.ctrlKey || e.metaKey || e.altKey){
							return;
						} // can only be stopped reliably in keydown
					}
				}

				// create fake event to set charOrCode and to know if preventDefault() was called
				var faux = { faux: true }, attr;
				for(attr in e){
					if(!/^(layer[XY]|returnValue|keyLocation)$/.test(attr)){ // prevent WebKit warnings
						var v = e[attr];
						if(typeof v != "function" && typeof v != "undefined"){
							faux[attr] = v;
						}
					}
				}
				lang.mixin(faux, {
					charOrCode: charOrCode,
					_wasConsumed: false,
					preventDefault: function(){
						faux._wasConsumed = true;
						e.preventDefault();
					},
					stopPropagation: function(){
						e.stopPropagation();
					}
				});

				this._lastInputProducingEvent = faux;

				// Give web page author a chance to consume the event.  Note that onInput() may be called multiple times
				// for same keystroke: once for keypress event and once for input event.
				//console.log(faux.type + ', charOrCode = (' + (typeof charOrCode) + ') ' + charOrCode + ', ctrl ' + !!faux.ctrlKey + ', alt ' + !!faux.altKey + ', meta ' + !!faux.metaKey + ', shift ' + !!faux.shiftKey);
				if(this.onInput(faux) === false){ // return false means stop
					faux.preventDefault();
					faux.stopPropagation();
				}
				if(faux._wasConsumed){
					return;
				} // if preventDefault was called

				// IE8 doesn't emit the "input" event at all, and IE9 doesn't emit it for backspace, delete, cut, etc.
				// Since the code below (and perhaps user code) depends on that event, emit it synthetically.
				// See http://benalpert.com/2013/06/18/a-near-perfect-oninput-shim-for-ie-8-and-9.html.
				if(has("ie") <= 9){
					switch(e.keyCode){
					case keys.TAB:
					case keys.ESCAPE:
					case keys.DOWN_ARROW:
					case keys.UP_ARROW:
					case keys.LEFT_ARROW:
					case keys.RIGHT_ARROW:
						// These keys may alter the <input>'s value indirectly, but we don't want to emit an "input"
						// event.  For example, the up/down arrows in TimeTextBox or ComboBox will cause the next
						// dropdown item's value to be copied to the <input>.
						break;
					default:
						if(e.keyCode == keys.ENTER && this.textbox.tagName.toLowerCase() != "textarea"){
							break;
						}
						this.defer(function(){
							if(this.textbox.value !== this._lastInputEventValue){
								on.emit(this.textbox, "input", {bubbles: true});
							}
						});
					}
				}
			}
			this.own(
				on(this.textbox, "keydown, keypress, paste, cut, compositionend", lang.hitch(this, handleEvent)),
				on(this.textbox, "input", lang.hitch(this, "_onInput")),

				// Allow keypress to bubble to this.domNode, so that TextBox.on("keypress", ...) works,
				// but prevent it from further propagating, so that typing into a TextBox inside a Toolbar doesn't
				// trigger the Toolbar's letter key navigation.
				on(this.domNode, "keypress", function(e){ e.stopPropagation(); })
			);
		},

		_blankValue: '', // if the textbox is blank, what value should be reported
		filter: function(val){
			// summary:
			//		Auto-corrections (such as trimming) that are applied to textbox
			//		value on blur or form submit.
			// description:
			//		For MappedTextBox subclasses, this is called twice
			//
			//		- once with the display value
			//		- once the value as set/returned by set('value', ...)
			//
			//		and get('value'), ex: a Number for NumberTextBox.
			//
			//		In the latter case it does corrections like converting null to NaN.  In
			//		the former case the NumberTextBox.filter() method calls this.inherited()
			//		to execute standard trimming code in TextBox.filter().
			//
			//		TODO: break this into two methods in 2.0
			//
			// tags:
			//		protected extension
			if(val === null){
				return this._blankValue;
			}
			if(typeof val != "string"){
				return val;
			}
			if(this.trim){
				val = lang.trim(val);
			}
			if(this.uppercase){
				val = val.toUpperCase();
			}
			if(this.lowercase){
				val = val.toLowerCase();
			}
			if(this.propercase){
				val = val.replace(/[^\s]+/g, function(word){
					return word.substring(0, 1).toUpperCase() + word.substring(1);
				});
			}
			return val;
		},

		_setBlurValue: function(){
			// Format the displayed value, for example (for NumberTextBox) convert 1.4 to 1.400,
			// or (for CurrencyTextBox) 2.50 to $2.50

			this._setValueAttr(this.get('value'), true);
		},

		_onBlur: function(e){
			if(this.disabled){
				return;
			}
			this._setBlurValue();
			this.inherited(arguments);
		},

		_isTextSelected: function(){
			return this.textbox.selectionStart != this.textbox.selectionEnd;
		},

		_onFocus: function(/*String*/ by){
			if(this.disabled || this.readOnly){
				return;
			}

			// Select all text on focus via click if nothing already selected.
			// Since mouse-up will clear the selection, need to defer selection until after mouse-up.
			// Don't do anything on focus by tabbing into the widget since there's no associated mouse-up event.
			if(this.selectOnClick && by == "mouse"){
				// Use on.once() to only select all text on first click only; otherwise users would have no way to clear
				// the selection.
				this._selectOnClickHandle = on.once(this.domNode, "mouseup, touchend", lang.hitch(this, function(evt){
					// Check if the user selected some text manually (mouse-down, mouse-move, mouse-up)
					// and if not, then select all the text
					if(!this._isTextSelected()){
						_TextBoxMixin.selectInputText(this.textbox);
					}
				}));
				this.own(this._selectOnClickHandle);

				// in case the mouseup never comes
				this.defer(function(){
					if(this._selectOnClickHandle){
						this._selectOnClickHandle.remove();
						this._selectOnClickHandle = null;
					}
				}, 500); // if mouseup not received soon, then treat it as some gesture
			}
			// call this.inherited() before refreshState(), since this.inherited() will possibly scroll the viewport
			// (to scroll the TextBox into view), which will affect how _refreshState() positions the tooltip
			this.inherited(arguments);

			this._refreshState();
		},

		reset: function(){
			// Overrides `dijit/_FormWidget/reset()`.
			// Additionally resets the displayed textbox value to ''
			this.textbox.value = '';
			this.inherited(arguments);
		}
	});

	if(has("dojo-bidi")){
		_TextBoxMixin = declare("dijit.form._TextBoxMixin", _TextBoxMixin, {
			_setValueAttr: function(){
				this.inherited(arguments);
				this.applyTextDir(this.focusNode);
			},
			_setDisplayedValueAttr: function(){
				this.inherited(arguments);
				this.applyTextDir(this.focusNode);
			},
			_onInput: function(){
				this.applyTextDir(this.focusNode);
				this.inherited(arguments);
			}
		});
	}

	_TextBoxMixin._setSelectionRange = dijit._setSelectionRange = function(/*DomNode*/ element, /*Number?*/ start, /*Number?*/ stop){
		if(element.setSelectionRange){
			element.setSelectionRange(start, stop);
		}
	};

	_TextBoxMixin.selectInputText = dijit.selectInputText = function(/*DomNode*/ element, /*Number?*/ start, /*Number?*/ stop){
		// summary:
		//		Select text in the input element argument, from start (default 0), to stop (default end).

		// TODO: use functions in _editor/selection.js?
		element = dom.byId(element);
		if(isNaN(start)){
			start = 0;
		}
		if(isNaN(stop)){
			stop = element.value ? element.value.length : 0;
		}
		try{
			element.focus();
			_TextBoxMixin._setSelectionRange(element, start, stop);
		}catch(e){ /* squelch random errors (esp. on IE) from unexpected focus changes or DOM nodes being hidden */
		}
	};

	return _TextBoxMixin;
});

},
'dijit/form/ValidationTextBox':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/_base/kernel", // kernel.deprecated
	"dojo/_base/lang",
	"dojo/i18n", // i18n.getLocalization
	"./TextBox",
	"../Tooltip",
	"dojo/text!./templates/ValidationTextBox.html",
	"dojo/i18n!./nls/validate"
], function(declare, kernel, lang, i18n, TextBox, Tooltip, template){

	// module:
	//		dijit/form/ValidationTextBox


	var ValidationTextBox = declare("dijit.form.ValidationTextBox", TextBox, {
		// summary:
		//		Base class for textbox widgets with the ability to validate content of various types and provide user feedback.

		templateString: template,

		// required: Boolean
		//		User is required to enter data into this field.
		required: false,

		// promptMessage: String
		//		If defined, display this hint string immediately on focus to the textbox, if empty.
		//		Also displays if the textbox value is Incomplete (not yet valid but will be with additional input).
		//		Think of this like a tooltip that tells the user what to do, not an error message
		//		that tells the user what they've done wrong.
		//
		//		Message disappears when user starts typing.
		promptMessage: "",

		// invalidMessage: String
		//		The message to display if value is invalid.
		//		The translated string value is read from the message file by default.
		//		Set to "" to use the promptMessage instead.
		invalidMessage: "$_unset_$",

		// missingMessage: String
		//		The message to display if value is empty and the field is required.
		//		The translated string value is read from the message file by default.
		//		Set to "" to use the invalidMessage instead.
		missingMessage: "$_unset_$",

		// message: String
		//		Currently error/prompt message.
		//		When using the default tooltip implementation, this will only be
		//		displayed when the field is focused.
		message: "",

		// constraints: ValidationTextBox.__Constraints
		//		Despite the name, this parameter specifies both constraints on the input as well as
		//		formatting options.  See `dijit/form/ValidationTextBox.__Constraints` for details.
		constraints:{},

		// pattern: [extension protected] String|Function(constraints) returning a string.
		//		This defines the regular expression used to validate the input.
		//		Do not add leading ^ or $ characters since the widget adds these.
		//		A function may be used to generate a valid pattern when dependent on constraints or other runtime factors.
		//		set('pattern', String|Function).
		pattern: ".*",

		// regExp: Deprecated [extension protected] String.  Use "pattern" instead.
		regExp: "",

		regExpGen: function(/*__Constraints*/ /*===== constraints =====*/){
			// summary:
			//		Deprecated.  Use set('pattern', Function) instead.
		},

		// state: [readonly] String
		//		Shows current state (ie, validation result) of input (""=Normal, Incomplete, or Error)
		state: "",

		// tooltipPosition: String[]
		//		See description of `dijit/Tooltip.defaultPosition` for details on this parameter.
		tooltipPosition: [],

		_deprecateRegExp: function(attr, value){
			if(value != ValidationTextBox.prototype[attr]){
				kernel.deprecated("ValidationTextBox id="+this.id+", set('" + attr + "', ...) is deprecated.  Use set('pattern', ...) instead.", "", "2.0");
				this.set('pattern', value);
			}
		},
		_setRegExpGenAttr: function(/*Function*/ newFcn){
			this._deprecateRegExp("regExpGen", newFcn);
			this._set("regExpGen", this._computeRegexp); // backward compat with this.regExpGen(this.constraints)
		},
		_setRegExpAttr: function(/*String*/ value){
			this._deprecateRegExp("regExp", value);
		},

		_setValueAttr: function(){
			// summary:
			//		Hook so set('value', ...) works.
			this.inherited(arguments);
			this._refreshState();
		},

		validator: function(/*anything*/ value, /*__Constraints*/ constraints){
			// summary:
			//		Overridable function used to validate the text input against the regular expression.
			// tags:
			//		protected
			return (new RegExp("^(?:" + this._computeRegexp(constraints) + ")"+(this.required?"":"?")+"$")).test(value) &&
				(!this.required || !this._isEmpty(value)) &&
				(this._isEmpty(value) || this.parse(value, constraints) !== undefined); // Boolean
		},

		_isValidSubset: function(){
			// summary:
			//		Returns true if the value is either already valid or could be made valid by appending characters.
			//		This is used for validation while the user [may be] still typing.
			return this.textbox.value.search(this._partialre) == 0;
		},

		isValid: function(/*Boolean*/ /*===== isFocused =====*/){
			// summary:
			//		Tests if value is valid.
			//		Can override with your own routine in a subclass.
			// tags:
			//		protected
			return this.validator(this.textbox.value, this.get('constraints'));
		},

		_isEmpty: function(value){
			// summary:
			//		Checks for whitespace
			return (this.trim ? /^\s*$/ : /^$/).test(value); // Boolean
		},

		getErrorMessage: function(/*Boolean*/ /*===== isFocused =====*/){
			// summary:
			//		Return an error message to show if appropriate
			// tags:
			//		protected
			var invalid = this.invalidMessage == "$_unset_$" ? this.messages.invalidMessage :
				!this.invalidMessage ? this.promptMessage : this.invalidMessage;
			var missing = this.missingMessage == "$_unset_$" ? this.messages.missingMessage :
				!this.missingMessage ? invalid : this.missingMessage;
			return (this.required && this._isEmpty(this.textbox.value)) ? missing : invalid; // String
		},

		getPromptMessage: function(/*Boolean*/ /*===== isFocused =====*/){
			// summary:
			//		Return a hint message to show when widget is first focused
			// tags:
			//		protected
			return this.promptMessage; // String
		},

		_maskValidSubsetError: true,
		validate: function(/*Boolean*/ isFocused){
			// summary:
			//		Called by oninit, onblur, and onkeypress.
			// description:
			//		Show missing or invalid messages if appropriate, and highlight textbox field.
			// tags:
			//		protected
			var message = "";
			var isValid = this.disabled || this.isValid(isFocused);
			if(isValid){ this._maskValidSubsetError = true; }
			var isEmpty = this._isEmpty(this.textbox.value);
			var isValidSubset = !isValid && isFocused && this._isValidSubset();
			this._set("state", isValid ? "" : (((((!this._hasBeenBlurred || isFocused) && isEmpty) || isValidSubset) && (this._maskValidSubsetError || (isValidSubset && !this._hasBeenBlurred && isFocused))) ? "Incomplete" : "Error"));
			this.focusNode.setAttribute("aria-invalid", this.state == "Error" ? "true" : "false");

			if(this.state == "Error"){
				this._maskValidSubsetError = isFocused && isValidSubset; // we want the error to show up after a blur and refocus
				message = this.getErrorMessage(isFocused);
			}else if(this.state == "Incomplete"){
				message = this.getPromptMessage(isFocused); // show the prompt whenever the value is not yet complete
				this._maskValidSubsetError = !this._hasBeenBlurred || isFocused; // no Incomplete warnings while focused
			}else if(isEmpty){
				message = this.getPromptMessage(isFocused); // show the prompt whenever there's no error and no text
			}
			this.set("message", message);

			return isValid;
		},

		displayMessage: function(/*String*/ message){
			// summary:
			//		Overridable method to display validation errors/hints.
			//		By default uses a tooltip.
			// tags:
			//		extension
			if(message && this.focused){
				Tooltip.show(message, this.domNode, this.tooltipPosition, !this.isLeftToRight());
			}else{
				Tooltip.hide(this.domNode);
			}
		},

		_refreshState: function(){
			// Overrides TextBox._refreshState()
			if(this._created){ // should instead be this._started but that would require all programmatic ValidationTextBox instantiations to call startup()
				this.validate(this.focused);
			}
			this.inherited(arguments);
		},

		//////////// INITIALIZATION METHODS ///////////////////////////////////////

		constructor: function(params /*===== , srcNodeRef =====*/){
			// summary:
			//		Create the widget.
			// params: Object|null
			//		Hash of initialization parameters for widget, including scalar values (like title, duration etc.)
			//		and functions, typically callbacks like onClick.
			//		The hash can contain any of the widget's properties, excluding read-only properties.
			// srcNodeRef: DOMNode|String?
			//		If a srcNodeRef (DOM node) is specified, replace srcNodeRef with my generated DOM tree.

			this.constraints = lang.clone(this.constraints);
			this.baseClass += ' dijitValidationTextBox';
		},

		startup: function(){
			this.inherited(arguments);
			this._refreshState(); // after all _set* methods have run
		},

		_setConstraintsAttr: function(/*__Constraints*/ constraints){
			if(!constraints.locale && this.lang){
				constraints.locale = this.lang;
			}
			this._set("constraints", constraints);
			this._refreshState();
		},

		_setPatternAttr: function(/*String|Function*/ pattern){
			this._set("pattern", pattern); // don't set on INPUT to avoid native HTML5 validation
			this._refreshState();
		},

		_computeRegexp: function(/*__Constraints*/ constraints){
			// summary:
			//		Hook to get the current regExp and to compute the partial validation RE.

			var p = this.pattern;
			if(typeof p == "function"){
				p = p.call(this, constraints);
			}
			if(p != this._lastRegExp){
				var partialre = "";
				this._lastRegExp = p;
				// parse the regexp and produce a new regexp that matches valid subsets
				// if the regexp is .* then there's no use in matching subsets since everything is valid
				if(p != ".*"){
					p.replace(/\\.|\[\]|\[.*?[^\\]{1}\]|\{.*?\}|\(\?[=:!]|./g,
					function(re){
						switch(re.charAt(0)){
							case '{':
							case '+':
							case '?':
							case '*':
							case '^':
							case '$':
							case '|':
							case '(':
								partialre += re;
								break;
							case ")":
								partialre += "|$)";
								break;
							 default:
								partialre += "(?:"+re+"|$)";
								break;
						}
					});
				}
				try{ // this is needed for now since the above regexp parsing needs more test verification
					"".search(partialre);
				}catch(e){ // should never be here unless the original RE is bad or the parsing is bad
					partialre = this.pattern;
					console.warn('RegExp error in ' + this.declaredClass + ': ' + this.pattern);
				} // should never be here unless the original RE is bad or the parsing is bad
				this._partialre = "^(?:" + partialre + ")$";
			}
			return p;
		},

		postMixInProperties: function(){
			this.inherited(arguments);
			this.messages = i18n.getLocalization("dijit.form", "validate", this.lang);
			this._setConstraintsAttr(this.constraints); // this needs to happen now (and later) due to codependency on _set*Attr calls attachPoints
		},

		_setDisabledAttr: function(/*Boolean*/ value){
			this.inherited(arguments);	// call FormValueWidget._setDisabledAttr()
			this._refreshState();
		},

		_setRequiredAttr: function(/*Boolean*/ value){
			this._set("required", value);
			this.focusNode.setAttribute("aria-required", value);
			this._refreshState();
		},

		_setMessageAttr: function(/*String*/ message){
			this._set("message", message);
			this.displayMessage(message);
		},

		reset:function(){
			// Overrides dijit/form/TextBox.reset() by also
			// hiding errors about partial matches
			this._maskValidSubsetError = true;
			this.inherited(arguments);
		},

		_onBlur: function(){
			// the message still exists but for back-compat, and to erase the tooltip
			// (if the message is being displayed as a tooltip), call displayMessage('')
			this.displayMessage('');

			this.inherited(arguments);
		},

		destroy: function(){
			Tooltip.hide(this.domNode);	// in case tooltip show when ValidationTextBox (or enclosing Dialog) destroyed
			this.inherited(arguments);
		}
	});

	/*=====
	 ValidationTextBox.__Constraints = {
		 // locale: String
		 //		locale used for validation, picks up value from this widget's lang attribute
		 // _flags_: anything
		 //		various flags passed to pattern function
	 };
	 =====*/

	return ValidationTextBox;
});

},
'dijit/Tooltip':function(){
define([
	"dojo/_base/array", // array.forEach array.indexOf array.map
	"dojo/_base/declare", // declare
	"dojo/_base/fx", // fx.fadeIn fx.fadeOut
	"dojo/dom", // dom.byId
	"dojo/dom-class", // domClass.add
	"dojo/dom-geometry", // domGeometry.position
	"dojo/dom-style", // domStyle.set, domStyle.get
	"dojo/_base/lang", // lang.hitch lang.isArrayLike
	"dojo/mouse",
	"dojo/on",
	"dojo/sniff", // has("ie"), has("trident")
	"./_base/manager",	// manager.defaultDuration
	"./place",
	"./_Widget",
	"./_TemplatedMixin",
	"./BackgroundIframe",
	"dojo/text!./templates/Tooltip.html",
	"./main"		// sets dijit.showTooltip etc. for back-compat
], function(array, declare, fx, dom, domClass, domGeometry, domStyle, lang, mouse, on, has,
			manager, place, _Widget, _TemplatedMixin, BackgroundIframe, template, dijit){

	// module:
	//		dijit/Tooltip


	// TODO: Tooltip should really share more positioning code with TooltipDialog, like:
	//		- the orient() method
	//		- the connector positioning code in show()
	//		- the dijitTooltip[Dialog] class
	//
	// The problem is that Tooltip's implementation supplies it's own <iframe> and interacts directly
	// with dijit/place, rather than going through dijit/popup like TooltipDialog and other popups (ex: Menu).

	var MasterTooltip = declare("dijit._MasterTooltip", [_Widget, _TemplatedMixin], {
		// summary:
		//		Internal widget that holds the actual tooltip markup,
		//		which occurs once per page.
		//		Called by Tooltip widgets which are just containers to hold
		//		the markup
		// tags:
		//		protected

		// duration: Integer
		//		Milliseconds to fade in/fade out
		duration: manager.defaultDuration,

		templateString: template,

		postCreate: function(){
			this.ownerDocumentBody.appendChild(this.domNode);

			this.bgIframe = new BackgroundIframe(this.domNode);

			// Setup fade-in and fade-out functions.
			this.fadeIn = fx.fadeIn({ node: this.domNode, duration: this.duration, onEnd: lang.hitch(this, "_onShow") });
			this.fadeOut = fx.fadeOut({ node: this.domNode, duration: this.duration, onEnd: lang.hitch(this, "_onHide") });
		},

		show: function(innerHTML, aroundNode, position, rtl, textDir, onMouseEnter, onMouseLeave){
			// summary:
			//		Display tooltip w/specified contents to right of specified node
			//		(To left if there's no space on the right, or if rtl == true)
			// innerHTML: String
			//		Contents of the tooltip
			// aroundNode: DomNode|dijit/place.__Rectangle
			//		Specifies that tooltip should be next to this node / area
			// position: String[]?
			//		List of positions to try to position tooltip (ex: ["right", "above"])
			// rtl: Boolean?
			//		Corresponds to `WidgetBase.dir` attribute, where false means "ltr" and true
			//		means "rtl"; specifies GUI direction, not text direction.
			// textDir: String?
			//		Corresponds to `WidgetBase.textdir` attribute; specifies direction of text.
			// onMouseEnter: Function?
			//		Callback function for mouse enter on tooltip
			// onMouseLeave: Function?
			//		Callback function for mouse leave on tooltip

			if(this.aroundNode && this.aroundNode === aroundNode && this.containerNode.innerHTML == innerHTML){
				return;
			}

			if(this.fadeOut.status() == "playing"){
				// previous tooltip is being hidden; wait until the hide completes then show new one
				this._onDeck=arguments;
				return;
			}
			this.containerNode.innerHTML=innerHTML;

			if(textDir){
				this.set("textDir", textDir);
			}

			this.containerNode.align = rtl? "right" : "left"; //fix the text alignment

			var pos = place.around(this.domNode, aroundNode,
				position && position.length ? position : Tooltip.defaultPosition, !rtl, lang.hitch(this, "orient"));

			// Position the tooltip connector for middle alignment.
			// This could not have been done in orient() since the tooltip wasn't positioned at that time.
			var aroundNodeCoords = pos.aroundNodePos;
			if(pos.corner.charAt(0) == 'M' && pos.aroundCorner.charAt(0) == 'M'){
				this.connectorNode.style.top = aroundNodeCoords.y + ((aroundNodeCoords.h - this.connectorNode.offsetHeight) >> 1) - pos.y + "px";
				this.connectorNode.style.left = "";
			}else if(pos.corner.charAt(1) == 'M' && pos.aroundCorner.charAt(1) == 'M'){
				this.connectorNode.style.left = aroundNodeCoords.x + ((aroundNodeCoords.w - this.connectorNode.offsetWidth) >> 1) - pos.x + "px";
			}else{
				// Not *-centered, but just above/below/after/before
				this.connectorNode.style.left = "";
				this.connectorNode.style.top = "";
			}

			// show it
			domStyle.set(this.domNode, "opacity", 0);
			this.fadeIn.play();
			this.isShowingNow = true;
			this.aroundNode = aroundNode;

			this.onMouseEnter = onMouseEnter || noop;
			this.onMouseLeave = onMouseLeave || noop;
		},

		orient: function(/*DomNode*/ node, /*String*/ aroundCorner, /*String*/ tooltipCorner, /*Object*/ spaceAvailable, /*Object*/ aroundNodeCoords){
			// summary:
			//		Private function to set CSS for tooltip node based on which position it's in.
			//		This is called by the dijit popup code.   It will also reduce the tooltip's
			//		width to whatever width is available
			// tags:
			//		protected

			this.connectorNode.style.top = ""; //reset to default

			var heightAvailable = spaceAvailable.h,
				widthAvailable = spaceAvailable.w;

			node.className = "dijitTooltip " +
				{
					"MR-ML": "dijitTooltipRight",
					"ML-MR": "dijitTooltipLeft",
					"TM-BM": "dijitTooltipAbove",
					"BM-TM": "dijitTooltipBelow",
					"BL-TL": "dijitTooltipBelow dijitTooltipABLeft",
					"TL-BL": "dijitTooltipAbove dijitTooltipABLeft",
					"BR-TR": "dijitTooltipBelow dijitTooltipABRight",
					"TR-BR": "dijitTooltipAbove dijitTooltipABRight",
					"BR-BL": "dijitTooltipRight",
					"BL-BR": "dijitTooltipLeft"
				}[aroundCorner + "-" + tooltipCorner];

			// reset width; it may have been set by orient() on a previous tooltip show()
			this.domNode.style.width = "auto";

			// Reduce tooltip's width to the amount of width available, so that it doesn't overflow screen.
			// Note that sometimes widthAvailable is negative, but we guard against setting style.width to a
			// negative number since that causes an exception on IE.
			var size = domGeometry.position(this.domNode);
			if(has("ie") || has("trident")){
				// workaround strange IE bug where setting width to offsetWidth causes words to wrap
				size.w += 2;
			}

			var width = Math.min((Math.max(widthAvailable,1)), size.w);

			domGeometry.setMarginBox(this.domNode, {w: width});

			// Reposition the tooltip connector.
			if(tooltipCorner.charAt(0) == 'B' && aroundCorner.charAt(0) == 'B'){
				var bb = domGeometry.position(node);
				var tooltipConnectorHeight = this.connectorNode.offsetHeight;
				if(bb.h > heightAvailable){
					// The tooltip starts at the top of the page and will extend past the aroundNode
					var aroundNodePlacement = heightAvailable - ((aroundNodeCoords.h + tooltipConnectorHeight) >> 1);
					this.connectorNode.style.top = aroundNodePlacement + "px";
					this.connectorNode.style.bottom = "";
				}else{
					// Align center of connector with center of aroundNode, except don't let bottom
					// of connector extend below bottom of tooltip content, or top of connector
					// extend past top of tooltip content
					this.connectorNode.style.bottom = Math.min(
						Math.max(aroundNodeCoords.h/2 - tooltipConnectorHeight/2, 0),
						bb.h - tooltipConnectorHeight) + "px";
					this.connectorNode.style.top = "";
				}
			}else{
				// reset the tooltip back to the defaults
				this.connectorNode.style.top = "";
				this.connectorNode.style.bottom = "";
			}

			return Math.max(0, size.w - widthAvailable);
		},

		_onShow: function(){
			// summary:
			//		Called at end of fade-in operation
			// tags:
			//		protected
			if(has("ie")){
				// the arrow won't show up on a node w/an opacity filter
				this.domNode.style.filter="";
			}
		},

		hide: function(aroundNode){
			// summary:
			//		Hide the tooltip

			if(this._onDeck && this._onDeck[1] == aroundNode){
				// this hide request is for a show() that hasn't even started yet;
				// just cancel the pending show()
				this._onDeck=null;
			}else if(this.aroundNode === aroundNode){
				// this hide request is for the currently displayed tooltip
				this.fadeIn.stop();
				this.isShowingNow = false;
				this.aroundNode = null;
				this.fadeOut.play();
			}else{
				// just ignore the call, it's for a tooltip that has already been erased
			}

			this.onMouseEnter = this.onMouseLeave = noop;
		},

		_onHide: function(){
			// summary:
			//		Called at end of fade-out operation
			// tags:
			//		protected

			this.domNode.style.cssText="";	// to position offscreen again
			this.containerNode.innerHTML="";
			if(this._onDeck){
				// a show request has been queued up; do it now
				this.show.apply(this, this._onDeck);
				this._onDeck=null;
			}
		}
	});

	if(has("dojo-bidi")){
		MasterTooltip.extend({
			_setAutoTextDir: function(/*Object*/node){
				// summary:
				//		Resolve "auto" text direction for children nodes
				// tags:
				//		private

				this.applyTextDir(node);
				array.forEach(node.children, function(child){ this._setAutoTextDir(child); }, this);
			},

			_setTextDirAttr: function(/*String*/ textDir){
				// summary:
				//		Setter for textDir.
				// description:
				//		Users shouldn't call this function; they should be calling
				//		set('textDir', value)
				// tags:
				//		private

				this._set("textDir", textDir);

				if (textDir == "auto"){
					this._setAutoTextDir(this.containerNode);
				}else{
					this.containerNode.dir = this.textDir;
				}
			}
		});
	}

	dijit.showTooltip = function(innerHTML, aroundNode, position, rtl, textDir, onMouseEnter, onMouseLeave){
		// summary:
		//		Static method to display tooltip w/specified contents in specified position.
		//		See description of dijit/Tooltip.defaultPosition for details on position parameter.
		//		If position is not specified then dijit/Tooltip.defaultPosition is used.
		// innerHTML: String
		//		Contents of the tooltip
		// aroundNode: place.__Rectangle
		//		Specifies that tooltip should be next to this node / area
		// position: String[]?
		//		List of positions to try to position tooltip (ex: ["right", "above"])
		// rtl: Boolean?
		//		Corresponds to `WidgetBase.dir` attribute, where false means "ltr" and true
		//		means "rtl"; specifies GUI direction, not text direction.
		// textDir: String?
		//		Corresponds to `WidgetBase.textdir` attribute; specifies direction of text.
		// onMouseEnter: Function?
		//		Callback function for mouse over on tooltip
		// onMouseLeave: Function?
		//		Callback function for mouse leave on tooltip

		// After/before don't work, but for back-compat convert them to the working after-centered, before-centered.
		// Possibly remove this in 2.0.   Alternately, get before/after to work.
		if(position){
			position = array.map(position, function(val){
				return {after: "after-centered", before: "before-centered"}[val] || val;
			});
		}

		if(!Tooltip._masterTT){ dijit._masterTT = Tooltip._masterTT = new MasterTooltip(); }
		return Tooltip._masterTT.show(innerHTML, aroundNode, position, rtl, textDir, onMouseEnter, onMouseLeave);
	};

	dijit.hideTooltip = function(aroundNode){
		// summary:
		//		Static method to hide the tooltip displayed via showTooltip()
		return Tooltip._masterTT && Tooltip._masterTT.hide(aroundNode);
	};

	// Possible states for a tooltip, see Tooltip.state property for definitions
	var DORMANT = "DORMANT",
		SHOW_TIMER = "SHOW TIMER",
		SHOWING = "SHOWING",
		HIDE_TIMER = "HIDE TIMER";

	function noop(){}

	var Tooltip = declare("dijit.Tooltip", _Widget, {
		// summary:
		//		Pops up a tooltip (a help message) when you hover over a node.
		//		Also provides static show() and hide() methods that can be used without instantiating a dijit/Tooltip.

		// label: String
		//		HTML to display in the tooltip.
		//		Specified as innerHTML when creating the widget from markup.
		label: "",

		// showDelay: Integer
		//		Number of milliseconds to wait after hovering over/focusing on the object, before
		//		the tooltip is displayed.
		showDelay: 400,

		// hideDelay: Integer
		//		Number of milliseconds to wait after unhovering the object, before
		//		the tooltip is hidden.  Note that blurring an object hides the tooltip immediately.
		hideDelay: 400,

		// connectId: String|String[]|DomNode|DomNode[]
		//		Id of domNode(s) to attach the tooltip to.
		//		When user hovers over specified dom node(s), the tooltip will appear.
		connectId: [],

		// position: String[]
		//		See description of `dijit/Tooltip.defaultPosition` for details on position parameter.
		position: [],

		// selector: String?
		//		CSS expression to apply this Tooltip to descendants of connectIds, rather than to
		//		the nodes specified by connectIds themselves.    Useful for applying a Tooltip to
		//		a range of rows in a table, tree, etc.   Use in conjunction with getContent() parameter.
		//		Ex: connectId: myTable, selector: "tr", getContent: function(node){ return ...; }
		//
		//		The application must require() an appropriate level of dojo/query to handle the selector.
		selector: "",

		// TODO: in 2.0 remove support for multiple connectIds.   selector gives the same effect.
		// So, change connectId to a "", remove addTarget()/removeTarget(), etc.

		_setConnectIdAttr: function(/*String|String[]|DomNode|DomNode[]*/ newId){
			// summary:
			//		Connect to specified node(s)

			// Remove connections to old nodes (if there are any)
			array.forEach(this._connections || [], function(nested){
				array.forEach(nested, function(handle){ handle.remove(); });
			}, this);

			// Make array of id's to connect to, excluding entries for nodes that don't exist yet, see startup()
			this._connectIds = array.filter(lang.isArrayLike(newId) ? newId : (newId ? [newId] : []),
					function(id){ return dom.byId(id, this.ownerDocument); }, this);

			// Make connections
			this._connections = array.map(this._connectIds, function(id){
				var node = dom.byId(id, this.ownerDocument),
					selector = this.selector,
					delegatedEvent = selector ?
						function(eventType){ return on.selector(selector, eventType); } :
						function(eventType){ return eventType; },
					self = this;
				return [
					on(node, delegatedEvent(mouse.enter), function(){
						self._onHover(this);
					}),
					on(node, delegatedEvent("focusin"), function(){
						self._onHover(this);
					}),
					on(node, delegatedEvent(mouse.leave), lang.hitch(self, "_onUnHover")),
					on(node, delegatedEvent("focusout"), lang.hitch(self, "set", "state", DORMANT))
				];
			}, this);

			this._set("connectId", newId);
		},

		addTarget: function(/*DomNode|String*/ node){
			// summary:
			//		Attach tooltip to specified node if it's not already connected

			// TODO: remove in 2.0 and just use set("connectId", ...) interface

			var id = node.id || node;
			if(array.indexOf(this._connectIds, id) == -1){
				this.set("connectId", this._connectIds.concat(id));
			}
		},

		removeTarget: function(/*DomNode|String*/ node){
			// summary:
			//		Detach tooltip from specified node

			// TODO: remove in 2.0 and just use set("connectId", ...) interface

			var id = node.id || node,	// map from DOMNode back to plain id string
				idx = array.indexOf(this._connectIds, id);
			if(idx >= 0){
				// remove id (modifies original this._connectIds but that's OK in this case)
				this._connectIds.splice(idx, 1);
				this.set("connectId", this._connectIds);
			}
		},

		buildRendering: function(){
			this.inherited(arguments);
			domClass.add(this.domNode,"dijitTooltipData");
		},

		startup: function(){
			this.inherited(arguments);

			// If this tooltip was created in a template, or for some other reason the specified connectId[s]
			// didn't exist during the widget's initialization, then connect now.
			var ids = this.connectId;
			array.forEach(lang.isArrayLike(ids) ? ids : [ids], this.addTarget, this);
		},

		getContent: function(/*DomNode*/ node){
			// summary:
			//		User overridable function that return the text to display in the tooltip.
			// tags:
			//		extension
			return this.label || this.domNode.innerHTML;
		},

		// state: [private readonly] String
		//		One of:
		//
		//		- DORMANT: tooltip not SHOWING
		//		- SHOW TIMER: tooltip not SHOWING but timer set to show it
		//		- SHOWING: tooltip displayed
		//		- HIDE TIMER: tooltip displayed, but timer set to hide it
		state: DORMANT,
		_setStateAttr: function(val){
			if(this.state == val ||
				(val == SHOW_TIMER && this.state == SHOWING) ||
				(val == HIDE_TIMER && this.state == DORMANT)){
				return;
			}

			if(this._hideTimer){
				this._hideTimer.remove();
				delete this._hideTimer;
			}
			if(this._showTimer){
				this._showTimer.remove();
				delete this._showTimer;
			}

			switch(val){
				case DORMANT:
					if(this._connectNode){
						Tooltip.hide(this._connectNode);
						delete this._connectNode;
						this.onHide();
					}
					break;
				case SHOW_TIMER:	 // set timer to show tooltip
					// should only get here from a DORMANT state, i.e. tooltip can't be already SHOWING
					if(this.state != SHOWING){
						this._showTimer = this.defer(function(){ this.set("state", SHOWING); }, this.showDelay);
					}
					break;
				case SHOWING:		// show tooltip and clear timers
					var content = this.getContent(this._connectNode);
					if(!content){
						this.set("state", DORMANT);
						return;
					}

					// Show tooltip and setup callbacks for mouseenter/mouseleave of tooltip itself
					Tooltip.show(content, this._connectNode, this.position, !this.isLeftToRight(), this.textDir,
						lang.hitch(this, "set", "state", SHOWING), lang.hitch(this, "set", "state", HIDE_TIMER));

					this.onShow(this._connectNode, this.position);
					break;
				case HIDE_TIMER:	// set timer set to hide tooltip
					this._hideTimer = this.defer(function(){ this.set("state", DORMANT); }, this.hideDelay);
					break;
			}

			this._set("state", val);
		},

		_onHover: function(/*DomNode*/ target){
			// summary:
			//		Despite the name of this method, it actually handles both hover and focus
			//		events on the target node, setting a timer to show the tooltip.
			// tags:
			//		private

			if(this._connectNode && target != this._connectNode){
				// Tooltip is displaying for another node
				this.set("state", DORMANT);
			}
			this._connectNode = target;		// _connectNode means "tooltip currently displayed for this node"

			this.set("state", SHOW_TIMER);	// no-op if show-timer already set, or if already showing
		},

		_onUnHover: function(/*DomNode*/ target){
			// summary:
			//		Handles mouseleave event on the target node, hiding the tooltip.
			// tags:
			//		private

			this.set("state", HIDE_TIMER);		// no-op if already dormant, or if hide-timer already set
		},

		// open() and close() aren't used anymore, except from the _BidiSupport/misc/Tooltip test.
		// Should probably remove for 2.0, but leaving for now.
		open: function(/*DomNode*/ target){
			// summary:
			//		Display the tooltip; usually not called directly.
			// tags:
			//		private

			this.set("state", DORMANT);
			this._connectNode = target;		// _connectNode means "tooltip currently displayed for this node"
			this.set("state", SHOWING);
		},

		close: function(){
			// summary:
			//		Hide the tooltip or cancel timer for show of tooltip
			// tags:
			//		private

			this.set("state", DORMANT);
		},

		onShow: function(/*===== target, position =====*/){
			// summary:
			//		Called when the tooltip is shown
			// tags:
			//		callback
		},

		onHide: function(){
			// summary:
			//		Called when the tooltip is hidden
			// tags:
			//		callback
		},

		destroy: function(){
			this.set("state", DORMANT);

			// Remove connections manually since they aren't registered to be removed by _WidgetBase
			array.forEach(this._connections || [], function(nested){
				array.forEach(nested, function(handle){ handle.remove(); });
			}, this);

			this.inherited(arguments);
		}
	});

	Tooltip._MasterTooltip = MasterTooltip;		// for monkey patching
	Tooltip.show = dijit.showTooltip;		// export function through module return value
	Tooltip.hide = dijit.hideTooltip;		// export function through module return value

	Tooltip.defaultPosition = ["after-centered", "before-centered"];

	/*=====
	lang.mixin(Tooltip, {
		 // defaultPosition: String[]
		 //		This variable controls the position of tooltips, if the position is not specified to
		 //		the Tooltip widget or *TextBox widget itself.  It's an array of strings with the values
		 //		possible for `dijit/place.around()`.   The recommended values are:
		 //
		 //		- before-centered: centers tooltip to the left of the anchor node/widget, or to the right
		 //		  in the case of RTL scripts like Hebrew and Arabic
		 //		- after-centered: centers tooltip to the right of the anchor node/widget, or to the left
		 //		  in the case of RTL scripts like Hebrew and Arabic
		 //		- above-centered: tooltip is centered above anchor node
		 //		- below-centered: tooltip is centered above anchor node
		 //
		 //		The list is positions is tried, in order, until a position is found where the tooltip fits
		 //		within the viewport.
		 //
		 //		Be careful setting this parameter.  A value of "above-centered" may work fine until the user scrolls
		 //		the screen so that there's no room above the target node.   Nodes with drop downs, like
		 //		DropDownButton or FilteringSelect, are especially problematic, in that you need to be sure
		 //		that the drop down and tooltip don't overlap, even when the viewport is scrolled so that there
		 //		is only room below (or above) the target node, but not both.
	 });
	=====*/
	return Tooltip;
});

},
'dijit/_base/manager':function(){
define([
	"dojo/_base/array",
	"dojo/_base/config", // defaultDuration
	"dojo/_base/lang",
	"../registry",
	"../main"	// for setting exports to dijit namespace
], function(array, config, lang, registry, dijit){

	// module:
	//		dijit/_base/manager

	var exports = {
		// summary:
		//		Deprecated.  Shim to methods on registry, plus a few other declarations.
		//		New code should access dijit/registry directly when possible.
	};

	array.forEach(["byId", "getUniqueId", "findWidgets", "_destroyAll", "byNode", "getEnclosingWidget"], function(name){
		exports[name] = registry[name];
	});

	 lang.mixin(exports, {
		 // defaultDuration: Integer
		 //		The default fx.animation speed (in ms) to use for all Dijit
		 //		transitional fx.animations, unless otherwise specified
		 //		on a per-instance basis. Defaults to 200, overrided by
		 //		`djConfig.defaultDuration`
		 defaultDuration: config["defaultDuration"] || 200
	 });

	lang.mixin(dijit, exports);

	/*===== return exports; =====*/
	return dijit;	// for back compat :-(
});

},
'doccontrol/viewer/dojo/information/Chronological':function(){
define([
    './AccessLogEventRow',
    './MoveEventRow',
    './NoteEventRow',
    './RevisionHistoryEventRow',
    './SoftLinkEventRow',
    './TransmittalEventRow',
    'api/doccontrol/data/AccessLog',
    'api/doccontrol/data/Move',
    'api/doccontrol/data/Note',
    'api/doccontrol/data/Revision',
    'api/doccontrol/data/SoftLinkEvent',
    'dijit/_WidgetBase',
    'dijit/form/CheckBox',
    'dijit/TitlePane',
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/dom-construct',
    'dojo/text!./template/Chronological.html',
    'dojo/query',
    'soso/sosox/ejs/_Templated',
    'spencer/doc-control/data/Transmittal'
], function(
    AccessLogEventRow,
    MoveEventRow,
    NoteEventRow,
    RevisionHistoryEventRow,
    SoftLinkEventRow,
    TransmittalEventRow,
    AccessLogEvent,
    MoveEvent,
    NoteEvent,
    Revision,
    SoftLinkEvent,
    _WidgetBase,
    Checkbox,
    TitlePane,
    declare,
    domAttr,
    domClass,
    domConstruct,
    template,
    query,
    _Templated,
    TransmittalEvent
) {
    return class Chronological {
        constructor(node, routeContainer) {
            const view = this._getView(routeContainer);
            this.view = new view({}, domConstruct.create('div', {}, node, 'only'));
        }

        setDocumentRevisionCollection(documentRevisionCollection) {
            this.view.setDocumentRevisionCollection(documentRevisionCollection);
            return this;
        }

        setCurrentlyViewingRevision(revision) {
            this.view.setCurrentlyViewingRevision(revision);
            return this;
        }

        setEvents(events) {
            this.view.setEvents(events);
            return this;
        }

        expand() {
            this.view.events.forEach((e) => e.expand());
        }

        collapse() {
            this.view.events.forEach((e) => e.collapse());
        }

        _getView(routeContainer) {
            return declare([_WidgetBase, _Templated], {
                routeContainer: routeContainer,
                templateString: template,
                documentRevisionCollection: [],
                currentlyViewingRevision: null,
                events: [],
                toggleCheckboxes: [],

                setDocumentRevisionCollection: function(documentRevisionCollection) {
                    this.documentRevisionCollection = documentRevisionCollection;
                },

                setCurrentlyViewingRevision: function(revision) {
                    this.currentlyViewingRevision = revision;
                },

                setEvents: function(events) {
                    events = events.sort((a, b) => this._getDate(b) - this._getDate(a));

                    events.forEach((event) => {
                        let node = domConstruct.create('div', {}, this.eventContainer, 'last');

                        if (event instanceof TransmittalEvent) {
                            this.events.push(new TransmittalEventRow(event, this.routeContainer, node));
                            return;
                        }

                        if (event instanceof SoftLinkEvent) {
                            this.events.push(new SoftLinkEventRow(event, node));
                            return;
                        }

                        if (event instanceof MoveEvent) {
                            this.events.push(new MoveEventRow(event, node));
                            return;
                        }

                        if (event instanceof NoteEvent) {
                            this.events.push(new NoteEventRow(event, node));
                            return;
                        }

                        if (event instanceof AccessLogEvent) {
                            this.events.push(new AccessLogEventRow(event, node));
                            return;
                        }

                        if (event instanceof Revision) {
                            this.events.push(
                                new RevisionHistoryEventRow(
                                    event,
                                    this.currentlyViewingRevision,
                                    this.routeContainer,
                                    this.documentRevisionCollection,
                                    node
                                )
                            );
                            return;
                        }
                    });

                    this._setupSettings();
                },

                _setupSettings: function() {
                    this._initToggleCheckbox('ACCESS_LOG', this.displayAccessLogs);
                    this._initToggleCheckbox('SOFT_LINK', this.displaySoftLinks);
                    this._initToggleCheckbox('MOVE', this.displayMoves);
                    this._initToggleCheckbox('NOTE', this.displayNotes);
                    this._initToggleCheckbox('TRANSMITTAL', this.displayTransmittals);
                    this._initToggleCheckbox('REVISION_HISTORY', this.displayRevisionHistory);
                },

                _initToggleCheckbox: function(event, node) {
                    const cb = new Checkbox({
                        checked: true,
                        onChange: (enabled) => this._toggleEventHidden(event, !enabled)
                    }, node);
                    cb.startup();

                    this.toggleCheckboxes.push(cb);
                },

                _toggleEventHidden: function(event, hidden) {
                    query('[data-event-type="'+event+'"]', this.domNode).forEach((event) => domClass.toggle(event, 'hidden', hidden));

                    const noneChecked = !this.toggleCheckboxes.some((cb) => cb.checked);
                    const noneDisplayed = ![...query('[data-event-type]', this.domNode)].some((event) => !domClass.contains(event, 'hidden'));

                    domClass.toggle(this.emptyState, 'sos-empty-state-show', noneChecked || noneDisplayed);
                },

                _getDate: function(vo) {
                    if (vo instanceof TransmittalEvent) {
                        return vo.getDateTransmitted();
                    }

                    if (vo instanceof SoftLinkEvent) {
                        return vo.getDateCreated();
                    }

                    if (vo instanceof MoveEvent || vo instanceof NoteEvent) {
                        return vo.getTimeCreated();
                    }

                    if (vo instanceof AccessLogEvent) {
                        return vo.getDate();
                    }

                    if (vo instanceof Revision) {
                        return vo.getDateUploaded();
                    }
                }
            });
        }
    }
});
},
'doccontrol/viewer/dojo/information/AccessLogEventRow':function(){
define([
    'dijit/_WidgetBase',
    'dojo/_base/declare',
    'dojo/text!./template/AccessLogEventRow.html',
    'soso/sosox/ejs/_Templated'
], function(
    _WidgetBase,
    declare,
    template,
    _Templated
) {
    const ICON_VIEW = '<span class="sos-icon sos-icon-eye"></span>';
    const ICON_DOWNLOAD = '<span class="sos-icon sos-icon-download"></span>';
    const DESCRIPTION_FORMAT = ':type by :person on :time';
    const EVENT_TYPE = 'ACCESS_LOG';

    return class AccessLogEventRow {
        constructor(event, node) {
            const view = this._getView(event);
            this.view = new view({}, node);
        }

        expand() {}

        collapse() {}

        _getView(event) {
            return declare([_WidgetBase, _Templated], {
                templateString: template,
                event: event,

                postMixInProperties: function postMixInProperties() {
                    this.inherited(postMixInProperties, arguments);

                    this.setCustomViewHelpers({
                        formatDescription: this._formatDescription.bind(this),
                        getEventType: () => EVENT_TYPE
                    });
                },

                _formatDescription: function() {
                    return (this.event.getType() === 'view' ? ICON_VIEW : ICON_DOWNLOAD) + DESCRIPTION_FORMAT
                        .replace(':type', this.event.getType() === 'view' ? 'Viewed' : 'Downloaded')
                        .replace(':person', this.event.getPerson().getDisplayName())
                        .replace(':time', this._formatDate(this.event.getDate()));
                },

                _formatDate: function(date) {
                    return date.toLocaleDateString('en-GB') + ' at ' + date.toLocaleTimeString('en-GB');
                }
            });
        }
    }
});
},
'doccontrol/viewer/dojo/information/MoveEventRow':function(){
define([
    'dijit/_WidgetBase',
    'dojo/_base/declare',
    'dojo/text!./template/EventRow.html',
    'soso/dijit/TitlePane',
    'soso/sosox/ejs/_Templated'
], function(
    _WidgetBase,
    declare,
    template,
    TitlePane,
    _Templated
) {
    const ICON = '<span class="sos-icon sos-icon-arrow-right"></span>';
    const TITLE_FORMAT = 'Moved by :person on :time';
    const EVENT_TYPE = 'MOVE';

    return class MoveEventRow {
        constructor(event, node) {
            const view = this._getView(event);
            this.view = new view({}, node);
        }

        expand() {
            this.view.titlePane.expand();
        }

        collapse() {
            this.view.titlePane.collapse();
        }

        _getView(event) {
            return declare([_WidgetBase, _Templated], {
                templateString: template,
                titlePane: null,
                event: event,

                postMixInProperties: function postMixInProperties() {
                    this.inherited(postMixInProperties, arguments);

                    this.setCustomViewHelpers({
                        formatDescription: this._formatDescription.bind(this),
                        getEventType: () => EVENT_TYPE
                    });
                },

                postCreate: function() {
                    this.titlePane = new TitlePane({
                        title: this._formatTitle(),
                        open: false
                    }, this.accordion);
                },

                _formatTitle: function() {
                    return ICON + TITLE_FORMAT
                        .replace(':person', this.event.getPerson().getDisplayName())
                        .replace(':time', this._formatDate(this.event.getTimeCreated()));
                },

                _formatDescription: function() {
                    return this.event.getDestination();
                },

                _formatDate: function(date) {
                    return date.toLocaleDateString('en-GB') + ' at ' + date.toLocaleTimeString('en-GB');
                }
            });
        }
    }
});
},
'soso/dijit/TitlePane':function(){
define([
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dojo/fx',
    'dijit/TitlePane'
], function(declare, lang, fxUtils, TitlePane) {
    return declare('soso.dijit.TitlePane', [TitlePane], {
        animate: true,

        onOpen: null,
        onClose: null,

        _wipeIn: null,
        _wipeOut: null,

        postCreate: function(){
            this.inherited(arguments);

            // Override wipe animations, so we can trigger onOpen/onClose once
            // the animations have completed.

            var hideNode = this.hideNode, wipeNode = this.wipeNode;
            this._wipeIn = fxUtils.wipeIn({
                node: wipeNode,
                duration: this.animate ? this.duration : 0,
                beforeBegin: function(){
                    hideNode.style.display = "";
                },
                onEnd: lang.hitch(this, function(){
                    if (this.onOpen) {
                        this.onOpen();
                    }
                })
            });
            this._wipeOut = fxUtils.wipeOut({
                node: wipeNode,
                duration: this.animate ? this.duration : 0,
                onEnd: lang.hitch(this, function(){
                    hideNode.style.display = "none";

                    if (this.onClose) {
                        this.onClose();
                    }
                })
            });
        },

        expand: function() {
            if(!this.isOpen()) {
                this.toggle();
            }
        },

        collapse: function() {
            if(this.isOpen()) {
                this.toggle();
            }
        },

        isOpen: function() {
            return this.open;
        },

        setOnOpen: function (onOpen) {
            this.onOpen = onOpen;
        },

        setOnClose: function (onClose) {
            this.onClose = onClose;
        }
    });
});
},
'dojo/fx':function(){
define([
	"./_base/lang",
	"./Evented",
	"./_base/kernel",
	"./_base/array",
	"./aspect",
	"./_base/fx",
	"./dom",
	"./dom-style",
	"./dom-geometry",
	"./ready",
	"require" // for context sensitive loading of Toggler
], function(lang, Evented, dojo, arrayUtil, aspect, baseFx, dom, domStyle, geom, ready, require){

	// module:
	//		dojo/fx

	// For back-compat, remove in 2.0.
	if(!dojo.isAsync){
		ready(0, function(){
			var requires = ["./fx/Toggler"];
			require(requires);	// use indirection so modules not rolled into a build
		});
	}

	var coreFx = dojo.fx = {
		// summary:
		//		Effects library on top of Base animations
	};

	var _baseObj = {
			_fire: function(evt, args){
				if(this[evt]){
					this[evt].apply(this, args||[]);
				}
				return this;
			}
		};

	var _chain = function(animations){
		this._index = -1;
		this._animations = animations||[];
		this._current = this._onAnimateCtx = this._onEndCtx = null;

		this.duration = 0;
		arrayUtil.forEach(this._animations, function(a){
			if(a){
				if(typeof a.duration != "undefined"){
	        		this.duration += a.duration;
				}
				if(a.delay){
					this.duration += a.delay;
				}
			}
		}, this);
	};
	_chain.prototype = new Evented();
	lang.extend(_chain, {
		_onAnimate: function(){
			this._fire("onAnimate", arguments);
		},
		_onEnd: function(){
			this._onAnimateCtx.remove();
			this._onEndCtx.remove();
			this._onAnimateCtx = this._onEndCtx = null;
			if(this._index + 1 == this._animations.length){
				this._fire("onEnd");
			}else{
				// switch animations
				this._current = this._animations[++this._index];
				this._onAnimateCtx = aspect.after(this._current, "onAnimate", lang.hitch(this, "_onAnimate"), true);
				this._onEndCtx = aspect.after(this._current, "onEnd", lang.hitch(this, "_onEnd"), true);
				this._current.play(0, true);
			}
		},
		play: function(/*int?*/ delay, /*Boolean?*/ gotoStart){
			if(!this._current){ this._current = this._animations[this._index = 0]; }
			if(!gotoStart && this._current.status() == "playing"){ return this; }
			var beforeBegin = aspect.after(this._current, "beforeBegin", lang.hitch(this, function(){
					this._fire("beforeBegin");
				}), true),
				onBegin = aspect.after(this._current, "onBegin", lang.hitch(this, function(arg){
					this._fire("onBegin", arguments);
				}), true),
				onPlay = aspect.after(this._current, "onPlay", lang.hitch(this, function(arg){
					this._fire("onPlay", arguments);
					beforeBegin.remove();
					onBegin.remove();
					onPlay.remove();
				}));
			if(this._onAnimateCtx){
				this._onAnimateCtx.remove();
			}
			this._onAnimateCtx = aspect.after(this._current, "onAnimate", lang.hitch(this, "_onAnimate"), true);
			if(this._onEndCtx){
				this._onEndCtx.remove();
			}
			this._onEndCtx = aspect.after(this._current, "onEnd", lang.hitch(this, "_onEnd"), true);
			this._current.play.apply(this._current, arguments);
			return this;
		},
		pause: function(){
			if(this._current){
				var e = aspect.after(this._current, "onPause", lang.hitch(this, function(arg){
						this._fire("onPause", arguments);
						e.remove();
					}), true);
				this._current.pause();
			}
			return this;
		},
		gotoPercent: function(/*Decimal*/percent, /*Boolean?*/ andPlay){
			this.pause();
			var offset = this.duration * percent;
			this._current = null;

			arrayUtil.some(this._animations, function(a, index){
				if(offset <= a.duration){
					this._current = a;
					this._index = index;
					return true;
				}
				offset -= a.duration;
				return false;
			}, this);
			if(this._current){
				this._current.gotoPercent(offset / this._current.duration);
			}
			if (andPlay) { this.play(); }
			return this;
		},
		stop: function(/*boolean?*/ gotoEnd){
			if(this._current){
				if(gotoEnd){
					for(; this._index + 1 < this._animations.length; ++this._index){
						this._animations[this._index].stop(true);
					}
					this._current = this._animations[this._index];
				}
				var e = aspect.after(this._current, "onStop", lang.hitch(this, function(arg){
						this._fire("onStop", arguments);
						e.remove();
					}), true);
				this._current.stop();
			}
			return this;
		},
		status: function(){
			return this._current ? this._current.status() : "stopped";
		},
		destroy: function(){
			this.stop();
			if(this._onAnimateCtx){ this._onAnimateCtx.remove(); }
			if(this._onEndCtx){ this._onEndCtx.remove(); }
		}
	});
	lang.extend(_chain, _baseObj);

	coreFx.chain = function(/*dojo/_base/fx.Animation[]*/ animations){
		// summary:
		//		Chain a list of `dojo/_base/fx.Animation`s to run in sequence
		//
		// description:
		//		Return a `dojo/_base/fx.Animation` which will play all passed
		//		`dojo/_base/fx.Animation` instances in sequence, firing its own
		//		synthesized events simulating a single animation. (eg:
		//		onEnd of this animation means the end of the chain,
		//		not the individual animations within)
		//
		// example:
		//	Once `node` is faded out, fade in `otherNode`
		//	|	require(["dojo/fx"], function(fx){
		//	|		fx.chain([
		//	|			fx.fadeIn({ node:node }),
		//	|			fx.fadeOut({ node:otherNode })
		//	|		]).play();
		//	|	});
		//
		return new _chain(lang.isArray(animations) ? animations : Array.prototype.slice.call(animations, 0)); // dojo/_base/fx.Animation
	};

	var _combine = function(animations){
		this._animations = animations||[];
		this._connects = [];
		this._finished = 0;

		this.duration = 0;
		arrayUtil.forEach(animations, function(a){
			var duration = a.duration;
			if(a.delay){ duration += a.delay; }
			if(this.duration < duration){ this.duration = duration; }
			this._connects.push(aspect.after(a, "onEnd", lang.hitch(this, "_onEnd"), true));
		}, this);

		this._pseudoAnimation = new baseFx.Animation({curve: [0, 1], duration: this.duration});
		var self = this;
		arrayUtil.forEach(["beforeBegin", "onBegin", "onPlay", "onAnimate", "onPause", "onStop", "onEnd"],
			function(evt){
				self._connects.push(aspect.after(self._pseudoAnimation, evt,
					function(){ self._fire(evt, arguments); },
				true));
			}
		);
	};
	lang.extend(_combine, {
		_doAction: function(action, args){
			arrayUtil.forEach(this._animations, function(a){
				a[action].apply(a, args);
			});
			return this;
		},
		_onEnd: function(){
			if(++this._finished > this._animations.length){
				this._fire("onEnd");
			}
		},
		_call: function(action, args){
			var t = this._pseudoAnimation;
			t[action].apply(t, args);
		},
		play: function(/*int?*/ delay, /*Boolean?*/ gotoStart){
			this._finished = 0;
			this._doAction("play", arguments);
			this._call("play", arguments);
			return this;
		},
		pause: function(){
			this._doAction("pause", arguments);
			this._call("pause", arguments);
			return this;
		},
		gotoPercent: function(/*Decimal*/percent, /*Boolean?*/ andPlay){
			var ms = this.duration * percent;
			arrayUtil.forEach(this._animations, function(a){
				a.gotoPercent(a.duration < ms ? 1 : (ms / a.duration), andPlay);
			});
			this._call("gotoPercent", arguments);
			return this;
		},
		stop: function(/*boolean?*/ gotoEnd){
			this._doAction("stop", arguments);
			this._call("stop", arguments);
			return this;
		},
		status: function(){
			return this._pseudoAnimation.status();
		},
		destroy: function(){
			this.stop();
			arrayUtil.forEach(this._connects, function(handle){
				handle.remove();
			});
		}
	});
	lang.extend(_combine, _baseObj);

	coreFx.combine = function(/*dojo/_base/fx.Animation[]*/ animations){
		// summary:
		//		Combine a list of `dojo/_base/fx.Animation`s to run in parallel
		//
		// description:
		//		Combine an array of `dojo/_base/fx.Animation`s or N
		//		`dojo/_base/fx.Animation`s  to run in parallel, providing
		//		a new `dojo/_base/fx.Animation` instance encompassing each
		//		animation, firing standard animation events.
		//
		// example:
		//	Fade out `node` while fading in `otherNode` simultaneously
		//	|	require(["dojo/fx"], function(fx){
		//	|		fx.combine([
		//	|			fx.fadeIn({ node:node }),
		//	|			fx.fadeOut({ node:otherNode })
		//	|		]).play();
		//	|	});
		//
		// example:
		//	When the longest animation ends, execute a function:
		//	|	require(["dojo/fx"], function(fx){
		//	|		var anim = fx.combine([
		//	|			fx.fadeIn({ node: n, duration:700 }),
		//	|			fx.fadeOut({ node: otherNode, duration: 300 })
		//	|		]);
		//	|		aspect.after(anim, "onEnd", function(){
		//	|			// overall animation is done.
		//	|		}, true);
		//	|		anim.play(); // play the animation
		//	|	});
		//
		return new _combine(lang.isArray(animations) ? animations : Array.prototype.slice.call(animations, 0)); // dojo/_base/fx.Animation
	};

	coreFx.wipeIn = function(/*Object*/ args){
		// summary:
		//		Expand a node to it's natural height.
		//
		// description:
		//		Returns an animation that will expand the
		//		node defined in 'args' object from it's current height to
		//		it's natural height (with no scrollbar).
		//		Node must have no margin/border/padding.
		//
		// args: Object
		//		A hash-map of standard `dojo/_base/fx.Animation` constructor properties
		//		(such as easing: node: duration: and so on)
		//
		// example:
		//	|	require(["dojo/fx"], function(fx){
		//	|		fx.wipeIn({
		//	|			node:"someId"
		//	|		}).play()
		//	|	});

		var node = args.node = dom.byId(args.node), s = node.style, o;

		var anim = baseFx.animateProperty(lang.mixin({
			properties: {
				height: {
					// wrapped in functions so we wait till the last second to query (in case value has changed)
					start: function(){
						// start at current [computed] height, but use 1px rather than 0
						// because 0 causes IE to display the whole panel
						o = s.overflow;
						s.overflow = "hidden";
						if(s.visibility == "hidden" || s.display == "none"){
							s.height = "1px";
							s.display = "";
							s.visibility = "";
							return 1;
						}else{
							var height = domStyle.get(node, "height");
							return Math.max(height, 1);
						}
					},
					end: function(){
						return node.scrollHeight;
					}
				}
			}
		}, args));

		var fini = function(){
			s.height = "auto";
			s.overflow = o;
		};
		aspect.after(anim, "onStop", fini, true);
		aspect.after(anim, "onEnd", fini, true);

		return anim; // dojo/_base/fx.Animation
	};

	coreFx.wipeOut = function(/*Object*/ args){
		// summary:
		//		Shrink a node to nothing and hide it.
		//
		// description:
		//		Returns an animation that will shrink node defined in "args"
		//		from it's current height to 1px, and then hide it.
		//
		// args: Object
		//		A hash-map of standard `dojo/_base/fx.Animation` constructor properties
		//		(such as easing: node: duration: and so on)
		//
		// example:
		//	|	require(["dojo/fx"], function(fx){
		//	|		fx.wipeOut({ node:"someId" }).play()
		//	|	});

		var node = args.node = dom.byId(args.node), s = node.style, o;

		var anim = baseFx.animateProperty(lang.mixin({
			properties: {
				height: {
					end: 1 // 0 causes IE to display the whole panel
				}
			}
		}, args));

		aspect.after(anim, "beforeBegin", function(){
			o = s.overflow;
			s.overflow = "hidden";
			s.display = "";
		}, true);
		var fini = function(){
			s.overflow = o;
			s.height = "auto";
			s.display = "none";
		};
		aspect.after(anim, "onStop", fini, true);
		aspect.after(anim, "onEnd", fini, true);

		return anim; // dojo/_base/fx.Animation
	};

	coreFx.slideTo = function(/*Object*/ args){
		// summary:
		//		Slide a node to a new top/left position
		//
		// description:
		//		Returns an animation that will slide "node"
		//		defined in args Object from its current position to
		//		the position defined by (args.left, args.top).
		//
		// args: Object
		//		A hash-map of standard `dojo/_base/fx.Animation` constructor properties
		//		(such as easing: node: duration: and so on). Special args members
		//		are `top` and `left`, which indicate the new position to slide to.
		//
		// example:
		//	|	.slideTo({ node: node, left:"40", top:"50", units:"px" }).play()

		var node = args.node = dom.byId(args.node),
			top = null, left = null;

		var init = (function(n){
			return function(){
				var cs = domStyle.getComputedStyle(n);
				var pos = cs.position;
				top = (pos == 'absolute' ? n.offsetTop : parseInt(cs.top) || 0);
				left = (pos == 'absolute' ? n.offsetLeft : parseInt(cs.left) || 0);
				if(pos != 'absolute' && pos != 'relative'){
					var ret = geom.position(n, true);
					top = ret.y;
					left = ret.x;
					n.style.position="absolute";
					n.style.top=top+"px";
					n.style.left=left+"px";
				}
			};
		})(node);
		init();

		var anim = baseFx.animateProperty(lang.mixin({
			properties: {
				top: args.top || 0,
				left: args.left || 0
			}
		}, args));
		aspect.after(anim, "beforeBegin", init, true);

		return anim; // dojo/_base/fx.Animation
	};

	return coreFx;
});

},
'dijit/TitlePane':function(){
define([
	"dojo/_base/array", // array.forEach
	"dojo/_base/declare", // declare
	"dojo/dom", // dom.setSelectable
	"dojo/dom-attr", // domAttr.set or get domAttr.remove
	"dojo/dom-class", // domClass.replace
	"dojo/dom-geometry", // domGeometry.setMarginBox domGeometry.getMarginBox
	"dojo/fx", // fxUtils.wipeIn fxUtils.wipeOut
	"dojo/has",
	"dojo/_base/kernel", // kernel.deprecated
	"dojo/keys", // keys.DOWN_ARROW keys.ENTER
	"./_CssStateMixin",
	"./_TemplatedMixin",
	"./layout/ContentPane",
	"dojo/text!./templates/TitlePane.html",
	"./_base/manager",    // defaultDuration
	"./a11yclick"	// template uses ondijitclick
], function(array, declare, dom, domAttr, domClass, domGeometry, fxUtils, has, kernel, keys,
			_CssStateMixin, _TemplatedMixin, ContentPane, template, manager){

	// module:
	//		dijit/TitlePane

	var TitlePane = declare("dijit.TitlePane", [ContentPane, _TemplatedMixin, _CssStateMixin], {
		// summary:
		//		A pane with a title on top, that can be expanded or collapsed.
		//
		// description:
		//		An accessible container with a title Heading, and a content
		//		section that slides open and closed. TitlePane is an extension to
		//		`dijit/layout/ContentPane`, providing all the useful content-control aspects from it.
		//
		// example:
		//	|	// load a TitlePane from remote file:
		//	|	var foo = new dijit.TitlePane({ href: "foobar.html", title:"Title" });
		//	|	foo.startup();
		//
		// example:
		//	|	<!-- markup href example: -->
		//	|	<div data-dojo-type="dijit/TitlePane" data-dojo-props="href: 'foobar.html', title: 'Title'"></div>
		//
		// example:
		//	|	<!-- markup with inline data -->
		//	|	<div data-dojo-type="dijit/TitlePane" title="Title">
		//	|		<p>I am content</p>
		//	|	</div>

		// title: String
		//		Title of the pane
		title: "",
		_setTitleAttr: { node: "titleNode", type: "innerHTML" }, // override default where title becomes a hover tooltip

		// open: Boolean
		//		Whether pane is opened or closed.
		open: true,

		// toggleable: Boolean
		//		Whether pane can be opened or closed by clicking the title bar.
		toggleable: true,

		// tabIndex: String
		//		Tabindex setting for the title (so users can tab to the title then
		//		use space/enter to open/close the title pane)
		tabIndex: "0",

		// duration: Integer
		//		Time in milliseconds to fade in/fade out
		duration: manager.defaultDuration,

		// baseClass: [protected] String
		//		The root className to be placed on this widget's domNode.
		baseClass: "dijitTitlePane",

		templateString: template,

		// doLayout: [protected] Boolean
		//		Don't change this parameter from the default value.
		//		This ContentPane parameter doesn't make sense for TitlePane, since TitlePane
		//		is never a child of a layout container, nor should TitlePane try to control
		//		the size of an inner widget.
		doLayout: false,

		// Tooltip is defined in _WidgetBase but we need to handle the mapping to DOM here
		_setTooltipAttr: {node: "focusNode", type: "attribute", attribute: "title"}, // focusNode spans the entire width, titleNode doesn't

		buildRendering: function(){
			this.inherited(arguments);
			dom.setSelectable(this.titleNode, false);
		},

		postCreate: function(){
			this.inherited(arguments);

			// Hover and focus effect on title bar, except for non-toggleable TitlePanes
			// This should really be controlled from _setToggleableAttr() but _CssStateMixin
			// doesn't provide a way to disconnect a previous _trackMouseState() call
			if(this.toggleable){
				this._trackMouseState(this.titleBarNode, this.baseClass + "Title");
			}

			// setup open/close animations
			var hideNode = this.hideNode, wipeNode = this.wipeNode;
			this._wipeIn = fxUtils.wipeIn({
				node: wipeNode,
				duration: this.duration,
				beforeBegin: function(){
					hideNode.style.display = "";
				}
			});
			this._wipeOut = fxUtils.wipeOut({
				node: wipeNode,
				duration: this.duration,
				onEnd: function(){
					hideNode.style.display = "none";
				}
			});
		},

		_setOpenAttr: function(/*Boolean*/ open, /*Boolean*/ animate){
			// summary:
			//		Hook to make set("open", boolean) control the open/closed state of the pane.
			// open: Boolean
			//		True if you want to open the pane, false if you want to close it.

			array.forEach([this._wipeIn, this._wipeOut], function(animation){
				if(animation && animation.status() == "playing"){
					animation.stop();
				}
			});

			if(animate){
				var anim = this[open ? "_wipeIn" : "_wipeOut"];
				anim.play();
			}else{
				this.hideNode.style.display = this.wipeNode.style.display = open ? "" : "none";
			}

			// load content (if this is the first time we are opening the TitlePane
			// and content is specified as an href, or href was set when hidden)
			if(this._started){
				if(open){
					this._onShow();
				}else{
					this.onHide();
				}
			}

			this.containerNode.setAttribute("aria-hidden", open ? "false" : "true");
			this.focusNode.setAttribute("aria-pressed", open ? "true" : "false");

			this._set("open", open);

			this._setCss();
		},

		_setToggleableAttr: function(/*Boolean*/ canToggle){
			// summary:
			//		Hook to make set("toggleable", boolean) work.
			// canToggle: Boolean
			//		True to allow user to open/close pane by clicking title bar.

			this.focusNode.setAttribute("role", canToggle ? "button" : "heading");
			if(canToggle){
				this.focusNode.setAttribute("aria-controls", this.id + "_pane");
				this.focusNode.setAttribute("tabIndex", this.tabIndex);
				this.focusNode.setAttribute("aria-pressed", this.open);
			}else{
				domAttr.remove(this.focusNode, "aria-controls");
				domAttr.remove(this.focusNode, "tabIndex");
				domAttr.remove(this.focusNode, "aria-pressed");
			}

			this._set("toggleable", canToggle);

			this._setCss();
		},

		_setContentAttr: function(/*String|DomNode|Nodelist*/ content){
			// summary:
			//		Hook to make set("content", ...) work.
			//		Typically called when an href is loaded.  Our job is to make the animation smooth.

			if(!this.open || !this._wipeOut || this._wipeOut.status() == "playing"){
				// we are currently *closing* the pane (or the pane is closed), so just let that continue
				this.inherited(arguments);
			}else{
				if(this._wipeIn && this._wipeIn.status() == "playing"){
					this._wipeIn.stop();
				}

				// freeze container at current height so that adding new content doesn't make it jump
				domGeometry.setMarginBox(this.wipeNode, { h: domGeometry.getMarginBox(this.wipeNode).h });

				// add the new content (erasing the old content, if any)
				this.inherited(arguments);

				// call _wipeIn.play() to animate from current height to new height
				if(this._wipeIn){
					this._wipeIn.play();
				}else{
					this.hideNode.style.display = "";
				}
			}
		},

		toggle: function(){
			// summary:
			//		Switches between opened and closed state
			// tags:
			//		private

			this._setOpenAttr(!this.open, true);
		},

		_setCss: function(){
			// summary:
			//		Set the open/close css state for the TitlePane
			// tags:
			//		private

			var node = this.titleBarNode || this.focusNode;
			var oldCls = this._titleBarClass;
			this._titleBarClass = this.baseClass + "Title" + (this.toggleable ? "" : "Fixed") + (this.open ? "Open" : "Closed");
			domClass.replace(node, this._titleBarClass, oldCls || "");

			// Back compat, remove for 2.0
			domClass.replace(node, this._titleBarClass.replace("TitlePaneTitle", ""), (oldCls || "").replace("TitlePaneTitle", ""));

			this.arrowNodeInner.innerHTML = this.open ? "-" : "+";
		},

		_onTitleKey: function(/*Event*/ e){
			// summary:
			//		Handler for when user hits a key
			// tags:
			//		private

			if(e.keyCode == keys.DOWN_ARROW && this.open){
				this.containerNode.focus();
				e.preventDefault();
			}
		},

		_onTitleClick: function(){
			// summary:
			//		Handler when user clicks the title bar
			// tags:
			//		private
			if(this.toggleable){
				this.toggle();
			}
		},

		setTitle: function(/*String*/ title){
			// summary:
			//		Deprecated.  Use set('title', ...) instead.
			// tags:
			//		deprecated
			kernel.deprecated("dijit.TitlePane.setTitle() is deprecated.  Use set('title', ...) instead.", "", "2.0");
			this.set("title", title);
		}
	});

	if(has("dojo-bidi")){
		TitlePane.extend({
			_setTitleAttr: function(/*String*/ title){
				// Override default where title becomes a hover tooltip
				this._set("title", title);
				this.titleNode.innerHTML = title;
				this.applyTextDir(this.titleNode);
			},

			_setTooltipAttr: function(/*String*/ tooltip){
				this._set("tooltip", tooltip);
				if(this.textDir){
					tooltip = this.enforceTextDirWithUcc(null, tooltip);
				}
				domAttr.set(this.focusNode, "title", tooltip);			// focusNode spans the entire width, titleNode doesn't
			},

			_setTextDirAttr: function(textDir){
				if(this._created && this.textDir != textDir){
					this._set("textDir", textDir);
					this.set("title", this.title);
					this.set("tooltip", this.tooltip);
				}
			}
		});
	}

	return TitlePane;
});

},
'doccontrol/viewer/dojo/information/NoteEventRow':function(){
define([
    'dijit/_WidgetBase',
    'dojo/_base/declare',
    'dojo/text!./template/EventRow.html',
    'soso/dijit/TitlePane',
    'soso/sosox/ejs/_Templated'
], function(
    _WidgetBase,
    declare,
    template,
    TitlePane,
    _Templated
) {
    const ICON = '<span class="sos-icon sos-icon-pencil"></span>';
    const TITLE_FORMAT = 'Note added by :person on :time';
    const EVENT_TYPE = 'NOTE';

    return class NoteEventRow {
        constructor(event, node) {
            const view = this._getView(event);
            this.view = new view({}, node);
        }

        expand() {
            this.view.titlePane.expand();
        }

        collapse() {
            this.view.titlePane.collapse();
        }

        _getView(event) {
            return declare([_WidgetBase, _Templated], {
                templateString: template,
                titlePane: null,
                event: event,

                postMixInProperties: function postMixInProperties() {
                    this.inherited(postMixInProperties, arguments);

                    this.setCustomViewHelpers({
                        formatDescription: this._formatDescription.bind(this),
                        getEventType: () => EVENT_TYPE
                    });
                },

                postCreate: function() {
                    this.titlePane = new TitlePane({
                        title: this._formatTitle(),
                        open: false
                    }, this.accordion);
                },

                _formatTitle: function() {
                    return ICON + TITLE_FORMAT
                        .replace(':person', this.event.getPerson().getDisplayName())
                        .replace(':time', this._formatDate(this.event.getTimeCreated()));
                },

                _formatDescription: function() {
                    return this.event.getNote();
                },

                _formatDate: function(date) {
                    return date.toLocaleDateString('en-GB') + ' at ' + date.toLocaleTimeString('en-GB');
                }
            });
        }
    }
});
},
'doccontrol/viewer/dojo/information/RevisionHistoryEventRow':function(){
define([
    '../../Topics',
    'dijit/_WidgetBase',
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/text!./template/RevisionHistoryEventRow.html',
    'dojo/topic',
    'soso/dijit/TitlePane',
    'soso/sosox/ejs/_Templated',
    'spencer/format/Megabytes',
    'spencer/format/MimeType',
    'spencer/format/PersonDisplayName',
    'style-guide/v1/icons/FileTypeToIconClass',
    'style-guide/v1/icons/FileTypeToColourClass'
], function(
    TOPICS,
    _WidgetBase,
    declare,
    domAttr,
    template,
    topic,
    TitlePane,
    _Templated,
    MegaBytesFormatter,
    MimeTypeFormatter,
    PersonFormatter,
    FileTypeToIconClass,
    FileTypeToColourClass
) {
    const ICON = '<span class="sos-icon sos-icon-upload"></span>';
    const TITLE_FORMAT = ':action by :person on :time';
    const EVENT_TYPE = 'REVISION_HISTORY';

    return class RevisionHistoryEventRow {
        constructor(event, currentlyViewingRevision, routeContainer, revisionCollection, node) {
            const view = this._getView(event, currentlyViewingRevision, routeContainer, revisionCollection);
            this.view = new view({}, node);
        }

        expand() {
            this.view.titlePane.expand();
        }

        collapse() {
            this.view.titlePane.collapse();
        }

        _getView(event, currentlyViewingRevision, routeContainer, revisionCollection) {
            return declare([_WidgetBase, _Templated], {
                routeContainer: routeContainer,
                templateString: template,
                titlePane: null,
                event: event,
                data: {
                    currentlyViewingRevision: currentlyViewingRevision,
                    revision: event,
                    documentRevisionCollection: revisionCollection
                },

                postMixInProperties: function postMixInProperties() {
                    this.inherited(postMixInProperties, arguments);

                    const megabytesFormatter = new MegaBytesFormatter();
                    const mimeTypeFormatter = new MimeTypeFormatter();
                    const fileTypeToIconClass = new FileTypeToIconClass();
                    const fileTypeToColourClass = new FileTypeToColourClass();

                    this.setCustomViewHelpers({
                        getEventType: () => EVENT_TYPE,
                        dateFormatter: (date, includeTime = false) => {
                            return date.toLocaleDateString('en-GB') +
                                (
                                    includeTime ?
                                        ' ' +
                                        date.toLocaleTimeString('en-GB', {
                                            hour12: false,
                                            hour: 'numeric',
                                            minute: 'numeric'
                                        }) :
                                        ''
                                );
                        },
                        historyActionFormatter: this._formatHistoryAction.bind(this),
                        personFormatter: function(person) {
                            if (!person) {
                                return '-';
                            }

                            const personFormatter = new PersonFormatter();
                            personFormatter.setJobTitle(person.getJobTitle());
                            personFormatter.setDisplayName(person.getDisplayName());
                            return personFormatter.format();
                        },
                        originatorFormatter: function(revision) {
                            const PRETEXT = 'on behalf of ';

                            if (revision.getPersonSender() && revision.getPersonSender().getPersonPK()) {
                                if (revision.getPersonUploader() && revision.getPersonUploader().getPersonPK() === revision.getPersonSender().getPersonPK()) {
                                    return;
                                }

                                const personFormatter = new PersonFormatter();
                                personFormatter.setJobTitle(revision.getPersonSender().getJobTitle());
                                personFormatter.setDisplayName(revision.getPersonSender().getDisplayName());

                                return PRETEXT + personFormatter.format() + ' - ' + revision.getOrganisationFrom().getName();
                            }

                            if (revision.getOrganisationFrom() && revision.getOrganisationFrom().getOrganisationPK()) {
                                return PRETEXT + revision.getOrganisationFrom().getName();
                            }
                        },
                        megabytesFormatter: megabytesFormatter.format.bind(megabytesFormatter),
                        mimeTypeFormatter: mimeTypeFormatter.format.bind(mimeTypeFormatter),
                        fileTypeIcon: (mimeType) => {
                            const icon = fileTypeToIconClass.getClass(mimeType);
                            const colour = fileTypeToColourClass.getClass(mimeType);
                            return icon + ' ' + (colour ? colour + '-foreground' : '');
                        },
                        revisionDownloadUrl: (id) => {
                            return this.routeContainer.get('downloadRevision', {id: id});
                        }
                    });
                },

                postCreate: function() {
                    this.titlePane = new TitlePane({
                        title: this._formatTitle(),
                        open: false
                    }, this.accordion);
                },

                viewDocument: function(e) {
                    e.preventDefault();
                    topic.publish(TOPICS.DOCUMENT_VIEWER_VIEW, {
                        revisionPK: domAttr.get(e.target, 'data-revision-pk'),
                        href: domAttr.get(e.target, 'href'),
                        fileType: domAttr.get(e.target, 'data-file-type'),
                        md5: domAttr.get(e.target, 'data-md5')
                    });
                },

                _formatTitle: function() {
                    return ICON + TITLE_FORMAT
                        .replace(':action', this._formatHistoryAction(this.data.revision))
                        .replace(':person', this._formatOriginator(this.event))
                        .replace(':time', this._formatDate(this.event.getDateUploaded()));
                },

                _formatDate: function(date) {
                    return date.toLocaleDateString('en-GB') + ' at ' + date.toLocaleTimeString('en-GB');
                },

                _formatHistoryAction: function(revision) {
                    return this._isUpload(revision) ? 'Uploaded' : (this._isUpdate(revision) ? 'Updated' : 'Revised')
                },

                _isEarliest: function(revision, revisionCollection) {
                    const revisionPKs = revisionCollection.map(function(revision) { return revision.getRevisionPK(); });
                    return revision.getRevisionPK() == Math.min.apply(Math, revisionPKs);
                },

                _isUpload: function(revision) {
                    return this._isEarliest(revision, this.data.documentRevisionCollection);
                },

                _isUpdate: function(revision) {
                    const revisionCollection = this.data.documentRevisionCollection.filter((revision) => this.data.revision.getMd5() === revision.getMd5(), revision);

                    return !this._isEarliest(revision, revisionCollection);
                },

                _formatOriginator: function(revision) {
                    if (!revision.getPersonUploader()) {
                        return '-';
                    }

                    return revision.getPersonUploader().getDisplayName();
                }
            });
        }
    }
});
},
'spencer/format/Megabytes':function(){
define([
    'spencer/parse/BytesToMegabytes'
], function(BytesToMegabytes) {
    const Megabytes = function() {};

    Megabytes.prototype.format = function(bytes) {
        const megabytes = (new BytesToMegabytes()).convert(bytes);

        if (megabytes === 0) {
            return '<0.01MB';
        }

        return megabytes + 'MB';
    };

    return Megabytes;
});

},
'spencer/parse/BytesToMegabytes':function(){
define([
], function() {
    const BytesToMegabytes = function() {
    };

    BytesToMegabytes.prototype.convert = function(bytes, binary = false) {
        return Math.round(this.bytesToMegabytes(bytes, binary) * 100) / 100;
    };

    BytesToMegabytes.prototype.bytesToMegabytes = function(bytes, binary = false) {
        return bytes / (binary ? 1048576 : 1000000);
    };

    return BytesToMegabytes;
});

},
'spencer/format/MimeType':function(){
define([
], function() {
    const MimeType = function() {};

    MimeType.prototype.format = function(mimeType) {
        if (!mimeType) {
            return '';
        }

        const fileType = mimeType.split('/');
        const type = fileType[0];
        const subtype = fileType[1];

        if (type === 'application') {
            if (subtype === 'pdf') {
                return 'pdf';
            }

            if (
                this.endsWith(subtype, 'excel') ||
                this.endsWith(subtype, 'sheet') ||
                this.endsWith(subtype, 'numbers') ||
                this.endsWith(subtype, 'spreadsheet-template') ||
                this.endsWith(subtype, 'spreadsheet-flat-xml') ||
                this.endsWith(subtype, 'sheet.macroenabled.12')
            ) {
                return 'spreadsheet';
            }

            if (
                this.endsWith(subtype, 'word') ||
                this.endsWith(subtype, 'document') ||
                this.endsWith(subtype, 'pages') ||
                this.endsWith(subtype, 'text') ||
                this.endsWith(subtype, 'text-template') ||
                this.endsWith(subtype, 'text-flat-xml') ||
                this.endsWith(subtype, 'document.macroenabled.12')
            ) {
                return 'doc';
            }

            if (
                this.endsWith(subtype, 'powerpoint') ||
                this.endsWith(subtype, 'key') ||
                this.endsWith(subtype, 'slideshow') ||
                this.endsWith(subtype, 'presentation') ||
                this.endsWith(subtype, 'presentation-template') ||
                this.endsWith(subtype, 'presentation-flat-xml') ||
                this.endsWith(subtype, 'presentation.macroenabled.12')
            ) {
                return 'powerpoint';
            }

            if (
                this.endsWith(subtype, 'zip') ||
                this.endsWith(subtype, 'compressed') ||
                this.endsWith(subtype, 'tar')
            ) {
                return 'archive';
            }
        }

        if (type === 'video') {
            return 'video';
        }

        if (type === 'image') {
            return 'image';
        }

        if (type === 'audio') {
            return 'audio';
        }

        if (type === 'text') {
            if (subtype === 'plain') {
                return 'text';
            }

            if (subtype === 'csv') {
                return 'spreadsheet'
            }

            return 'code';
        }

        if (type === 'message' && subtype === 'rfc822') {
            return 'email';
        }

        return '';
    };

    MimeType.prototype.endsWith = function(string, suffix) {
        if (!string) {
            return false;
        }

        return string.indexOf(suffix, string.length - suffix.length) !== -1;
    };

    return MimeType;
});
},
'style-guide/v1/icons/FileTypeToIconClass':function(){
define(["require", "exports", "@app/utility/icon/FileTypeToIconClass"], function (require, exports, FileTypeToIconClassTS) {
    "use strict";
    class FileTypeToIconClass {
        getClass(type, subtype) {
            return FileTypeToIconClassTS.getClass(type, subtype);
        }
    }
    return FileTypeToIconClass;
});

},
'@app/utility/icon/FileTypeToIconClass':function(){
define(["require", "exports", "./Config"], function (require, exports, CONFIG) {
    "use strict";
    class FileTypeToIconClass {
        static getClass(type, subtype) {
            if (!subtype && type) {
                const fileType = type.split('/');
                type = fileType[0];
                subtype = fileType[1];
            }
            subtype = FileTypeToIconClass.ensureSubTypeDoesNotContainType(subtype);
            const result = CONFIG.mapping.find((mapping) => (!mapping.type || mapping.type === type) &&
                (!mapping.subtype || mapping.subtype.some(st => st === subtype)));
            if (result)
                return result.icon;
            return CONFIG.prefix;
        }
        static ensureSubTypeDoesNotContainType(subtype) {
            if (subtype?.indexOf('/') > 0) {
                return subtype.split('/')[1];
            }
            return subtype;
        }
    }
    return FileTypeToIconClass;
});

},
'@app/utility/icon/Config':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    const ICON_CLASS_PREFIX = 'sos-icon-file';
    return {
        prefix: 'sos-icon-file',
        mapping: [
            {
                type: 'application',
                subtype: [
                    'compressed',
                    'tar',
                    'x-gtar',
                    'x-gzip',
                    'x-zip',
                    'x-zip-compressed',
                    'zip'
                ],
                icon: ICON_CLASS_PREFIX + '-archive'
            },
            {
                type: 'application',
                subtype: [
                    'document',
                    'document.macroenabled.12',
                    'msword',
                    'pages',
                    'text',
                    'text-flat-xml',
                    'text-template',
                    'vnd.oasis.opendocument.text',
                    'vnd.oasis.opendocument.text-flat-xml',
                    'vnd.oasis.opendocument.text-template',
                    'vnd.openxmlformats-officedocument.wordprocessingml.document',
                    'word',
                    'x-iwork-pages-sffpages'
                ],
                icon: ICON_CLASS_PREFIX + '-doc'
            },
            {
                type: 'application',
                subtype: [
                    'pdf'
                ],
                icon: ICON_CLASS_PREFIX + '-pdf'
            },
            {
                type: 'application',
                subtype: [
                    'key',
                    'ms-powerpoint',
                    'powerpoint',
                    'presentation',
                    'presentation-flat-xml',
                    'presentation-template',
                    'presentation.macroenabled.12',
                    'slideshow',
                    'vnd.ms-powerpoint',
                    'vnd.oasis.opendocument.presentation',
                    'vnd.oasis.opendocument.presentation-flat-xml',
                    'vnd.oasis.opendocument.presentation-template',
                    'vnd.openxmlformats-officedocument.presentationml.presentation',
                    'x-iwork-keynote-sffkey'
                ],
                icon: ICON_CLASS_PREFIX + '-powerpoint'
            },
            {
                type: 'application',
                subtype: [
                    'excel',
                    'ms-excel',
                    'numbers',
                    'sheet',
                    'sheet.macroenabled.12',
                    'spreadsheet',
                    'spreadsheet-flat-xml',
                    'spreadsheet-template',
                    'vnd.ms-excel.sheet.macroenabled.12',
                    'vnd.oasis.opendocument.spreadsheet',
                    'vnd.oasis.opendocument.spreadsheet-flat-xml',
                    'vnd.oasis.opendocument.spreadsheet-template',
                    'vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    'x-iwork-numbers-sffnumbers'
                ],
                icon: ICON_CLASS_PREFIX + '-spreadsheet'
            },
            {
                type: 'video',
                icon: ICON_CLASS_PREFIX + '-video'
            },
            {
                type: 'image',
                icon: ICON_CLASS_PREFIX + '-image'
            },
            {
                type: 'audio',
                icon: ICON_CLASS_PREFIX + '-audio'
            },
            {
                type: 'text',
                subtype: ['plain'],
                icon: ICON_CLASS_PREFIX + '-text'
            },
            {
                type: 'text',
                subtype: ['csv'],
                icon: ICON_CLASS_PREFIX + '-spreadsheet'
            },
            {
                type: 'text',
                icon: ICON_CLASS_PREFIX + '-code'
            },
            {
                type: 'message',
                icon: ICON_CLASS_PREFIX + '-email'
            },
            {
                icon: ICON_CLASS_PREFIX
            }
        ]
    };
});

},
'style-guide/v1/icons/FileTypeToColourClass':function(){
define([
    'dojo/_base/declare'
], function(declare) {
    return declare('style-guide.v1.icons.filetypetocolourclass', [], {
        COLOUR_CLASS_PREFIX: 'sos-colour-file',

        getClass: function(type, subtype) {
            if (arguments.length === 1 && type) {
                const fileType = type.split('/');
                type = fileType[0];
                subtype = fileType[1];
            }

            if (type === 'application') {
                if (subtype === 'pdf') {
                    return this.COLOUR_CLASS_PREFIX + '-pdf';
                }

                if (
                    this.endsWith(subtype, 'excel') ||
                    this.endsWith(subtype, 'sheet') ||
                    this.endsWith(subtype, 'numbers') ||
                    this.endsWith(subtype, 'spreadsheet-template') ||
                    this.endsWith(subtype, 'spreadsheet-flat-xml') ||
                    this.endsWith(subtype, 'sheet.macroenabled.12')
                ) {
                    return this.COLOUR_CLASS_PREFIX + '-spreadsheet';
                }

                if (
                    this.endsWith(subtype, 'word') ||
                    this.endsWith(subtype, 'document') ||
                    this.endsWith(subtype, 'pages') ||
                    this.endsWith(subtype, 'text') ||
                    this.endsWith(subtype, 'text-template') ||
                    this.endsWith(subtype, 'text-flat-xml') ||
                    this.endsWith(subtype, 'document.macroenabled.12')
                ) {
                    return this.COLOUR_CLASS_PREFIX + '-doc';
                }

                if (
                    this.endsWith(subtype, 'powerpoint') ||
                    this.endsWith(subtype, 'key') ||
                    this.endsWith(subtype, 'slideshow') ||
                    this.endsWith(subtype, 'presentation') ||
                    this.endsWith(subtype, 'presentation-template') ||
                    this.endsWith(subtype, 'presentation-flat-xml') ||
                    this.endsWith(subtype, 'presentation.macroenabled.12')
                ) {
                    return this.COLOUR_CLASS_PREFIX + '-powerpoint';
                }

                if (
                    this.endsWith(subtype, 'zip') ||
                    this.endsWith(subtype, 'compressed') ||
                    this.endsWith(subtype, 'tar')
                ) {
                    return this.COLOUR_CLASS_PREFIX + '-archive';
                }
            }

            if (type === 'video') {
                return this.COLOUR_CLASS_PREFIX + '-video';
            }

            if (type === 'image') {
                return this.COLOUR_CLASS_PREFIX + '-image';
            }

            if (type === 'audio') {
                return this.COLOUR_CLASS_PREFIX + '-audio';
            }

            if (type === 'text') {
                if (subtype === 'plain') {
                    return this.COLOUR_CLASS_PREFIX + '-text';
                }

                if (this.endsWith(subtype, 'csv')) {
                    return this.COLOUR_CLASS_PREFIX + '-spreadsheet'
                }

                return this.COLOUR_CLASS_PREFIX + '-code';
            }

            return this.COLOUR_CLASS_PREFIX;
        },

        isDefault: function(colourClass) {
            return colourClass === this.COLOUR_CLASS_PREFIX;
        },

        endsWith: function(string, suffix) {
            if (!string) {
                return false;
            }

            return string.indexOf(suffix, string.length - suffix.length) !== -1;
        }
    })
});

},
'doccontrol/viewer/dojo/information/SoftLinkEventRow':function(){
define([
    'dijit/_WidgetBase',
    'dojo/_base/declare',
    'dojo/text!./template/EventRow.html',
    'soso/dijit/TitlePane',
    'soso/sosox/ejs/_Templated'
], function(
    _WidgetBase,
    declare,
    template,
    TitlePane,
    _Templated
) {
    const ICON = '<span class="sos-icon sos-icon-files-copy"></span>';
    const TITLE_FORMAT = 'Soft linked by :person on :time';
    const DESCRIPTION_FORMAT = 'Soft link created in :location';
    const EVENT_TYPE = 'SOFT_LINK';

    return class SoftLinkEventRow {
        constructor(event, node) {
            const view = this._getView(event);
            this.view = new view({}, node);
        }

        expand() {
            this.view.titlePane.expand();
        }

        collapse() {
            this.view.titlePane.collapse();
        }

        _getView(event) {
            return declare([_WidgetBase, _Templated], {
                templateString: template,
                titlePane: null,
                event: event,

                postMixInProperties: function postMixInProperties() {
                    this.inherited(postMixInProperties, arguments);

                    this.setCustomViewHelpers({
                        formatDescription: this._formatDescription.bind(this),
                        getEventType: () => EVENT_TYPE
                    });
                },

                postCreate: function() {
                    this.titlePane = new TitlePane({
                        title: this._formatTitle(),
                        open: false
                    }, this.accordion);
                },

                _formatTitle: function() {
                    return ICON + TITLE_FORMAT
                        .replace(':person', this.event.getPerson().getDisplayName())
                        .replace(':time', this._formatDate(this.event.getDateCreated()));
                },

                _formatDescription: function() {
                    return DESCRIPTION_FORMAT
                        .replace(':location', this.event.getDescription());
                },

                _formatDate: function(date) {
                    return date.toLocaleDateString('en-GB') + ' at ' + date.toLocaleTimeString('en-GB');
                }
            });
        }
    }
});
},
'doccontrol/viewer/dojo/information/TransmittalEventRow':function(){
define([
    '../../Topics',
    'dijit/_WidgetBase',
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/text!./template/TransmittalEventRow.html',
    'dojo/topic',
    'soso/dijit/TitlePane',
    'soso/sosox/ejs/_Templated',
    'spencer/contact/format/Contact'
], function(
    TOPICS,
    _WidgetBase,
    declare,
    domAttr,
    template,
    topic,
    TitlePane,
    _Templated,
    ContactFormatter
) {
    const ICON = '<span class="sos-icon sos-icon-envelope"></span>';
    const TITLE_FORMAT = 'Distributed by :person on :time';
    const EVENT_TYPE = 'TRANSMITTAL';

    return class TransmittalEventRow {
        constructor(event, routeContainer, node) {
            const view = this._getView(event, routeContainer);
            this.view = new view({}, node);
        }

        expand() {
            this.view.titlePane.expand();
        }

        collapse() {
            this.view.titlePane.collapse();
        }

        _getView(event, routeContainer) {
            return declare([_WidgetBase, _Templated], {
                routeContainer: routeContainer,
                templateString: template,
                titlePane: null,
                event: event,
                data: {
                    transmittal: event
                },

                postMixInProperties: function postMixInProperties() {
                    this.inherited(postMixInProperties, arguments);

                    const contactFormatter = new ContactFormatter();

                    this.setCustomViewHelpers({
                        getEventType: () => EVENT_TYPE,
                        contactFormatter: contactFormatter.format.bind(contactFormatter),
                        dateFormatter: (date) => {
                            return date.toLocaleDateString('en-GB') + ' '
                                + date.toLocaleTimeString('en-GB', {
                                    hour12: false,
                                    hour: 'numeric',
                                    minute: 'numeric'
                                });
                        },
                        revisionDownloadUrl: (id) => {
                            return this.routeContainer.get('downloadRevision', {id: id});
                        },
                        overviewDocumentUrl: (revisionPK) => this.routeContainer.get('overviewDocumentUrl', {revisionPK: revisionPK})
                    });
                },

                postCreate: function() {
                    this.titlePane = new TitlePane({
                        title: this._formatTitle(),
                        open: false
                    }, this.accordion);
                },

                viewDocument: function(e) {
                    e.preventDefault();
                    topic.publish(TOPICS.DOCUMENT_VIEWER_VIEW, {
                        revisionPK: domAttr.get(e.target, 'data-revision-pk'),
                        href: domAttr.get(e.target, 'href'),
                        fileType: domAttr.get(e.target, 'data-file-type'),
                        md5: domAttr.get(e.target, 'data-md5')
                    });
                },

                _formatTitle: function() {
                    return ICON + TITLE_FORMAT
                        .replace(':person', this.event.getSender().getName())
                        .replace(':time', this._formatDate(this.event.getDateTransmitted()));
                },

                _formatDate: function(date) {
                    return date.toLocaleDateString('en-GB') + ' at ' + date.toLocaleTimeString('en-GB');
                }
            });
        }
    }
});
},
'spencer/contact/format/Contact':function(){
define([], function() {
    const Contact = function() {};

    Contact.prototype.format = function(contact, supressJobTitle) {
        if (contact.isBranchOffice()) {
            return contact.getOrganisation() + ' - ' + contact.getEmail();
        }

        if (contact.isExternal()) {
            if (!contact.getJobTitle()) {
                return contact.getPreferredName() + ' - ' + contact.getOrganisation();
            }

            return contact.getPreferredName() + ' [' + contact.getJobTitle() + '] - ' + contact.getOrganisation();
        }

        if (!contact.getPreferredName() && !contact.getJobTitle()) {
            return contact.getEmail();
        }

        if (contact.getPreferredName() && supressJobTitle) {
            return contact.getPreferredName();
        }

        return contact.getPreferredName() + ' [' + contact.getJobTitle() + ']';
    };

    return Contact;
});

},
'dijit/form/CheckBox':function(){
define([
	"require",
	"dojo/_base/declare", // declare
	"dojo/dom-attr", // domAttr.set
	"dojo/has",		// has("dijit-legacy-requires")
	"dojo/query", // query
	"dojo/ready",
	"./ToggleButton",
	"./_CheckBoxMixin",
	"dojo/text!./templates/CheckBox.html",
	"dojo/NodeList-dom", // NodeList.addClass/removeClass
	"../a11yclick"	// template uses ondijitclick
], function(require, declare, domAttr, has, query, ready, ToggleButton, _CheckBoxMixin, template){

	// module:
	//		dijit/form/CheckBox

	// Back compat w/1.6, remove for 2.0
	if(has("dijit-legacy-requires")){
		ready(0, function(){
			var requires = ["dijit/form/RadioButton"];
			require(requires);	// use indirection so modules not rolled into a build
		});
	}

	return declare("dijit.form.CheckBox", [ToggleButton, _CheckBoxMixin], {
		// summary:
		//		Same as an HTML checkbox, but with fancy styling.
		//
		// description:
		//		User interacts with real html inputs.
		//		On onclick (which occurs by mouse click, space-bar, or
		//		using the arrow keys to switch the selected radio button),
		//		we update the state of the checkbox/radio.
		//
		//		There are two modes:
		//
		//		1. High contrast mode
		//		2. Normal mode
		//
		//		In case 1, the regular html inputs are shown and used by the user.
		//		In case 2, the regular html inputs are invisible but still used by
		//		the user. They are turned quasi-invisible and overlay the background-image.

		templateString: template,

		baseClass: "dijitCheckBox",

		_setValueAttr: function(/*String|Boolean*/ newValue, /*Boolean*/ priorityChange){
			// summary:
			//		Handler for value= attribute to constructor, and also calls to
			//		set('value', val).
			// description:
			//		During initialization, just saves as attribute to the `<input type=checkbox>`.
			//
			//		After initialization,
			//		when passed a boolean, controls whether or not the CheckBox is checked.
			//		If passed a string, changes the value attribute of the CheckBox (the one
			//		specified as "value" when the CheckBox was constructed
			//		(ex: `<input data-dojo-type="dijit/CheckBox" value="chicken">`).
			//
			//		`widget.set('value', string)` will check the checkbox and change the value to the
			//		specified string.
			//
			//		`widget.set('value', boolean)` will change the checked state.

			if(typeof newValue == "string"){
				this.inherited(arguments);
				newValue = true;
			}
			if(this._created){
				this.set('checked', newValue, priorityChange);
			}
		},
		_getValueAttr: function(){
			// summary:
			//		Hook so get('value') works.
			// description:
			//		If the CheckBox is checked, returns the value attribute.
			//		Otherwise returns false.
			return this.checked && this._get("value");
		},

		// Override behavior from Button, since we don't have an iconNode or valueNode
		_setIconClassAttr: null,
		_setNameAttr: "focusNode",

		postMixInProperties: function(){
			this.inherited(arguments);

			// Need to set initial checked state via node.setAttribute so that form submit works
			// and IE8 radio button tab order is preserved.
			// domAttr.set(node, "checked", bool) doesn't work on IE until node has been attached
			// to <body>, see #8666
			this.checkedAttrSetting = "";
		},

		 _fillContent: function(){
			// Override Button::_fillContent() since it doesn't make sense for CheckBox,
			// since CheckBox doesn't even have a container
		},

		_onFocus: function(){
			if(this.id){
				query("label[for='"+this.id+"']").addClass("dijitFocusedLabel");
			}
			this.inherited(arguments);
		},

		_onBlur: function(){
			if(this.id){
				query("label[for='"+this.id+"']").removeClass("dijitFocusedLabel");
			}
			this.inherited(arguments);
		}
	});
});

},
'dijit/form/ToggleButton':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/_base/kernel", // kernel.deprecated
	"./Button",
	"./_ToggleButtonMixin"
], function(declare, kernel, Button, _ToggleButtonMixin){

	// module:
	//		dijit/form/ToggleButton


	return declare("dijit.form.ToggleButton", [Button, _ToggleButtonMixin], {
		// summary:
		//		A templated button widget that can be in two states (checked or not).
		//		Can be base class for things like tabs or checkbox or radio buttons.

		baseClass: "dijitToggleButton",

		setChecked: function(/*Boolean*/ checked){
			// summary:
			//		Deprecated.  Use set('checked', true/false) instead.
			kernel.deprecated("setChecked("+checked+") is deprecated. Use set('checked',"+checked+") instead.", "", "2.0");
			this.set('checked', checked);
		}
	});
});

},
'dijit/form/Button':function(){
define([
	"require",
	"dojo/_base/declare", // declare
	"dojo/dom-class", // domClass.toggle
	"dojo/has", // has("dijit-legacy-requires")
	"dojo/_base/kernel", // kernel.deprecated
	"dojo/_base/lang", // lang.trim
	"dojo/ready",
	"./_FormWidget",
	"./_ButtonMixin",
	"dojo/text!./templates/Button.html",
	"../a11yclick"	// template uses ondijitclick
], function(require, declare, domClass, has, kernel, lang, ready, _FormWidget, _ButtonMixin, template){

	// module:
	//		dijit/form/Button

	// Back compat w/1.6, remove for 2.0
	if(has("dijit-legacy-requires")){
		ready(0, function(){
			var requires = ["dijit/form/DropDownButton", "dijit/form/ComboButton", "dijit/form/ToggleButton"];
			require(requires);	// use indirection so modules not rolled into a build
		});
	}

	var Button = declare("dijit.form.Button" + (has("dojo-bidi") ? "_NoBidi" : ""), [_FormWidget, _ButtonMixin], {
		// summary:
		//		Basically the same thing as a normal HTML button, but with special styling.
		// description:
		//		Buttons can display a label, an icon, or both.
		//		A label should always be specified (through innerHTML) or the label
		//		attribute.  It can be hidden via showLabel=false.
		// example:
		// |	<button data-dojo-type="dijit/form/Button" onClick="...">Hello world</button>
		//
		// example:
		// |	var button1 = new Button({label: "hello world", onClick: foo});
		// |	dojo.body().appendChild(button1.domNode);

		// showLabel: Boolean
		//		Set this to true to hide the label text and display only the icon.
		//		(If showLabel=false then iconClass must be specified.)
		//		Especially useful for toolbars.
		//		If showLabel=true, the label will become the title (a.k.a. tooltip/hint) of the icon.
		//
		//		The exception case is for computers in high-contrast mode, where the label
		//		will still be displayed, since the icon doesn't appear.
		showLabel: true,

		// iconClass: String
		//		Class to apply to DOMNode in button to make it display an icon
		iconClass: "dijitNoIcon",
		_setIconClassAttr: { node: "iconNode", type: "class" },

		baseClass: "dijitButton",

		templateString: template,

		// Map widget attributes to DOMNode attributes.
		_setValueAttr: "valueNode",
		_setNameAttr: function(name){
			// avoid breaking existing subclasses where valueNode undefined.  Perhaps in 2.0 require it to be defined?
			if(this.valueNode){
				this.valueNode.setAttribute("name", name);
			}
		},

		postCreate: function(){
			this.inherited(arguments);
			this._setLabelFromContainer();
		},

		_setLabelFromContainer: function(){
			if(this.containerNode && !this.label){
				// When markup was set as srcNodeRef.innerHTML, copy it to this.label, in case someone tries to
				// reference that variable.  Alternately, could have a _getLabelAttr() method to return
				// this.containerNode.innerHTML.
				this.label = lang.trim(this.containerNode.innerHTML);
				this.onLabelSet();		// set this.titleNode.title etc. according to label
			}
		},

		_setShowLabelAttr: function(val){
			if(this.containerNode){
				domClass.toggle(this.containerNode, "dijitDisplayNone", !val);
			}
			this._set("showLabel", val);
		},

		setLabel: function(/*String*/ content){
			// summary:
			//		Deprecated.  Use set('label', ...) instead.
			kernel.deprecated("dijit.form.Button.setLabel() is deprecated.  Use set('label', ...) instead.", "", "2.0");
			this.set("label", content);
		},

		onLabelSet: function(){
			this.inherited(arguments);
			if(!this.showLabel && !("title" in this.params)){
				this.titleNode.title = lang.trim(this.containerNode.innerText || this.containerNode.textContent || '');
			}
		}
	});

	if(has("dojo-bidi")){
		Button = declare("dijit.form.Button", Button, {
			onLabelSet: function(){
				this.inherited(arguments);
				if(this.titleNode.title){
					this.applyTextDir(this.titleNode, this.titleNode.title);
				}
			},

			_setTextDirAttr: function(/*String*/ textDir){
				if(this._created && this.textDir != textDir){
					this._set("textDir", textDir);
					this._setLabelAttr(this.label); // call applyTextDir on both focusNode and titleNode
				}
			}
		});
	}

	return Button;
});

},
'dijit/form/_ButtonMixin':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/dom", // dom.setSelectable
	"dojo/has",
	"../registry"        // registry.byNode
], function(declare, dom, has, registry){

	// module:
	//		dijit/form/_ButtonMixin

	var ButtonMixin = declare("dijit.form._ButtonMixin" + (has("dojo-bidi") ? "_NoBidi" : ""), null, {
		// summary:
		//		A mixin to add a thin standard API wrapper to a normal HTML button
		// description:
		//		A label should always be specified (through innerHTML) or the label attribute.
		//
		//		Attach points:
		//
		//		- focusNode (required): this node receives focus
		//		- valueNode (optional): this node's value gets submitted with FORM elements
		//		- containerNode (optional): this node gets the innerHTML assignment for label
		// example:
		// |	<button data-dojo-type="dijit/form/Button" onClick="...">Hello world</button>
		// example:
		// |	var button1 = new Button({label: "hello world", onClick: foo});
		// |	dojo.body().appendChild(button1.domNode);

		// label: HTML String
		//		Content to display in button.
		label: "",

		// type: [const] String
		//		Type of button (submit, reset, button, checkbox, radio)
		type: "button",

		__onClick: function(/*Event*/ e){
			// summary:
			//		Internal function to divert the real click onto the hidden INPUT that has a native default action associated with it
			// type:
			//		private
			e.stopPropagation();
			e.preventDefault();
			if(!this.disabled){
				// cannot use on.emit since button default actions won't occur
				this.valueNode.click(e);
			}
			return false;
		},

		_onClick: function(/*Event*/ e){
			// summary:
			//		Internal function to handle click actions
			if(this.disabled){
				e.stopPropagation();
				e.preventDefault();
				return false;
			}
			if(this.onClick(e) === false){
				e.preventDefault();
			}
			var cancelled = e.defaultPrevented;

			// Signal Form/Dialog to submit/close.  For 2.0, consider removing this code and instead making the Form/Dialog
			// listen for bubbled click events where evt.target.type == "submit" && !evt.defaultPrevented.
			if(!cancelled && this.type == "submit" && !(this.valueNode || this.focusNode).form){
				for(var node = this.domNode; node.parentNode; node = node.parentNode){
					var widget = registry.byNode(node);
					if(widget && typeof widget._onSubmit == "function"){
						widget._onSubmit(e);
						e.preventDefault(); // action has already occurred
						cancelled = true;
						break;
					}
				}
			}

			return !cancelled;
		},

		postCreate: function(){
			this.inherited(arguments);
			dom.setSelectable(this.focusNode, false);
		},

		onClick: function(/*Event*/ /*===== e =====*/){
			// summary:
			//		Callback for when button is clicked.
			//		If type="submit", return true to perform submit, or false to cancel it.
			// type:
			//		callback
			return true;		// Boolean
		},

		_setLabelAttr: function(/*String*/ content){
			// summary:
			//		Hook for set('label', ...) to work.
			// description:
			//		Set the label (text) of the button; takes an HTML string.
			this._set("label", content);
			var labelNode = this.containerNode || this.focusNode;
			labelNode.innerHTML = content;
			this.onLabelSet();
		},

		onLabelSet: function(){
		}
	});

	if(has("dojo-bidi")){
		ButtonMixin = declare("dijit.form._ButtonMixin", ButtonMixin, {
			onLabelSet: function(){
				this.inherited(arguments);
				var labelNode = this.containerNode || this.focusNode;
				this.applyTextDir(labelNode);
			}
		});
	}

	return ButtonMixin;
});

},
'dijit/form/_ToggleButtonMixin':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/dom-attr" // domAttr.set
], function(declare, domAttr){

	// module:
	//		dijit/form/_ToggleButtonMixin

	return declare("dijit.form._ToggleButtonMixin", null, {
		// summary:
		//		A mixin to provide functionality to allow a button that can be in two states (checked or not).

		// checked: Boolean
		//		Corresponds to the native HTML `<input>` element's attribute.
		//		In markup, specified as "checked='checked'" or just "checked".
		//		True if the button is depressed, or the checkbox is checked,
		//		or the radio button is selected, etc.
		checked: false,

		// aria-pressed for toggle buttons, and aria-checked for checkboxes
		_aria_attr: "aria-pressed",

		_onClick: function(/*Event*/ evt){
			var original = this.checked;
			this._set('checked', !original); // partially set the toggled value, assuming the toggle will work, so it can be overridden in the onclick handler
			var ret = this.inherited(arguments); // the user could reset the value here
			this.set('checked', ret ? this.checked : original); // officially set the toggled or user value, or reset it back
			return ret;
		},

		_setCheckedAttr: function(/*Boolean*/ value, /*Boolean?*/ priorityChange){
			this._set("checked", value);
			var node = this.focusNode || this.domNode;
			if(this._created){ // IE is not ready to handle checked attribute (affects tab order)
				// needlessly setting "checked" upsets IE's tab order
				if(domAttr.get(node, "checked") != !!value){
					domAttr.set(node, "checked", !!value); // "mixed" -> true
				}
			}
			node.setAttribute(this._aria_attr, String(value)); // aria values should be strings
			this._handleOnChange(value, priorityChange);
		},

		postCreate: function(){ // use postCreate instead of startup so users forgetting to call startup are OK
			this.inherited(arguments);
			var node = this.focusNode || this.domNode;
			if(this.checked){
				// need this here instead of on the template so IE8 tab order works
				node.setAttribute('checked', 'checked');
			}

			// Update our reset value if it hasn't yet been set (because this.set()
			// is only called when there *is* a value)
			if(this._resetValue === undefined){
				this._lastValueReported = this._resetValue = this.checked;
			}
		},

		reset: function(){
			// summary:
			//		Reset the widget's value to what it was at initialization time

			this._hasBeenBlurred = false;

			// set checked state to original setting
			this.set('checked', this.params.checked || false);
		}
	});
});

},
'dijit/form/_CheckBoxMixin':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/dom-attr" // domAttr.set
], function(declare, domAttr){

	// module:
	//		dijit/form/_CheckBoxMixin

	return declare("dijit.form._CheckBoxMixin", null, {
		// summary:
		//		Mixin to provide widget functionality corresponding to an HTML checkbox
		//
		// description:
		//		User interacts with real html inputs.
		//		On onclick (which occurs by mouse click, space-bar, or
		//		using the arrow keys to switch the selected radio button),
		//		we update the state of the checkbox/radio.
		//

		// type: [private] String
		//		type attribute on `<input>` node.
		//		Overrides `dijit/form/Button.type`.  Users should not change this value.
		type: "checkbox",

		// value: String
		//		As an initialization parameter, equivalent to value field on normal checkbox
		//		(if checked, the value is passed as the value when form is submitted).
		value: "on",

		// readOnly: Boolean
		//		Should this widget respond to user input?
		//		In markup, this is specified as "readOnly".
		//		Similar to disabled except readOnly form values are submitted.
		readOnly: false,

		// aria-pressed for toggle buttons, and aria-checked for checkboxes
		_aria_attr: "aria-checked",

		_setReadOnlyAttr: function(/*Boolean*/ value){
			this._set("readOnly", value);
			domAttr.set(this.focusNode, 'readOnly', value);
		},

		// Override dijit/form/Button._setLabelAttr() since we don't even have a containerNode.
		// Normally users won't try to set label, except when CheckBox or RadioButton is the child of a dojox/layout/TabContainer
		_setLabelAttr: undefined,

		_getSubmitValue: function(/*String*/ value){
			return (value == null || value === "") ? "on" : value;
		},

		_setValueAttr: function(newValue){
			newValue = this._getSubmitValue(newValue);	// "on" to match browser native behavior when value unspecified
			this._set("value", newValue);
			domAttr.set(this.focusNode, "value", newValue);
		},

		reset: function(){
			this.inherited(arguments);
			// Handle unlikely event that the <input type=checkbox> value attribute has changed
			this._set("value", this._getSubmitValue(this.params.value));
			domAttr.set(this.focusNode, 'value', this.value);
		},

		_onClick: function(/*Event*/ e){
			// summary:
			//		Internal function to handle click actions - need to check
			//		readOnly, since button no longer does that check.
			if(this.readOnly){
				e.stopPropagation();
				e.preventDefault();
				return false;
			}
			return this.inherited(arguments);
		}
	});
});

},
'doccontrol/viewer/dojo/information/RevisionHistoryTable':function(){
/// <amd-dependency path="api/doccontrol/document/tree/Config" name="TreeFactoryConfig" />
/// <amd-dependency path="api/doccontrol/document/tree/Factory" name="TreeFactory" />
/// <amd-dependency path="doccontrol/viewer/Topics" name="TOPICS" />
/// <amd-dependency path="dojo/text!./template/RevisionHistoryTable.html" name="template" />
/// <amd-dependency path="library/request/URLConnectionBuilder" name="URLConnectionBuilder" />
/// <amd-dependency path="library/request/URLResponseProcessorBuilder" name="URLResponseProcessorBuilder" />
/// <amd-dependency path="library/request/dojo/URLConnectionProcessorBuilder" name="URLConnectionProcessorBuilder" />
/// <amd-dependency path="soso/sosox/ejs/_Templated" name="_Templated" />
/// <amd-dependency path="spencer/data-manager/core/context/Group/IsMemberOf" name="IsMemberOf" />
/// <amd-dependency path="spencer/data-manager/core/definition/Actions" name="ACTIONS" />
/// <amd-dependency path="spencer/data-manager/data/Request" name="RequestData" />
/// <amd-dependency path="spencer/format/Megabytes" name="MegaBytesFormatter" />
/// <amd-dependency path="spencer/format/MimeType" name="MimeTypeFormatter" />
/// <amd-dependency path="spencer/format/PersonDisplayName" name="PersonFormatter" />
define(["require", "exports", "api/doccontrol/document/tree/Config", "api/doccontrol/document/tree/Factory", "doccontrol/viewer/Topics", "dojo/text!./template/RevisionHistoryTable.html", "library/request/URLConnectionBuilder", "library/request/URLResponseProcessorBuilder", "library/request/dojo/URLConnectionProcessorBuilder", "soso/sosox/ejs/_Templated", "spencer/data-manager/core/context/Group/IsMemberOf", "spencer/data-manager/core/definition/Actions", "spencer/data-manager/data/Request", "spencer/format/Megabytes", "spencer/format/MimeType", "spencer/format/PersonDisplayName", "dojo/Evented", "style-guide/v1/icons/FileTypeToColourClass", "style-guide/v1/icons/FileTypeToIconClass", "@lib/group/GroupList", "@lib/request/data/Handlers", "project-listing/config/ListingType", "style-guide/v1/doc-control/project-node-select/multi-node-select/NodeTypes", "spencer/format/ProjectStageTitle", "doc-control/config/Regex", "@lib/doc-control/data/Revision", "dijit/_WidgetBase", "dojo/_base/declare", "dojo/dom-attr", "dojo/topic"], function (require, exports, TreeFactoryConfig, TreeFactory, TOPICS, template, URLConnectionBuilder, URLResponseProcessorBuilder, URLConnectionProcessorBuilder, _Templated, IsMemberOf, ACTIONS, RequestData, MegaBytesFormatter, MimeTypeFormatter, PersonFormatter, Evented, FileTypeToColourClass, FileTypeToIconClass, GROUP_LIST, Handlers, LISTING_TYPE, NODE_TYPES, ProjectStageTitleFormatter, REGEX, RevisionVO, _WidgetBase, dojoDeclare, domAttr, topic) {
    "use strict";
    const ROUTE_OVERVIEW_LISTING = 'overviewListing';
    class RevisionHistoryTable {
        constructor(documentRevisionCollection, currentlyViewingRevision, routeContainer, dataManager, currentUserIsDocControlAdmin) {
            const view = RevisionHistoryTable.getView();
            this.view = new view({
                data: {
                    documentRevisionCollection: documentRevisionCollection,
                    currentlyViewingRevision: currentlyViewingRevision,
                    currentUserIsDocControlAdmin: currentUserIsDocControlAdmin,
                    location: {
                        href: null,
                        projectStagePK: null,
                        projectStageTitle: null,
                        projectStageTreeViewPK: null,
                        name: null,
                        isRevisionable: false
                    },
                    revisionNumberPattern: REGEX.REVISION_NUMBER_VALIDATION.source
                },
                routeContainer: routeContainer,
                dataManager: dataManager
            });
        }
        placeAt(attachPoint) {
            const node = document.createElement('div');
            attachPoint.appendChild(node);
            return this.view.placeAt(node);
        }
        static getView() {
            return dojoDeclare([_WidgetBase, _Templated, Evented], {
                templateString: template,
                routeContainer: null,
                dataManager: null,
                constants: {
                    SAVING_REVISION_DETAILS_NOTIFICATION_UID: 'saving-revision-details',
                    ERROR_INVALID_REVISION_NUMBER: 'One of the provided revision numbers is empty or contains invalid characters. Revision numbers can only contain alphanumeric (a-Z / 0-9) characters, dashes (-) and full stops (.).',
                    ERROR_DUPLICATE_REVISION_NUMBER: 'All revision numbers must be unique.',
                    ERROR_GENERIC: 'There was an error while saving the revision details. Please contact support.'
                },
                latestRevisionRadioButtonsContainers: [],
                latestRevisionRadioButtons: [],
                staticRevisionNumbers: [],
                revisionNumberTextBoxContainers: [],
                revisionNumberTextBoxes: [],
                data: {
                    documentRevisionCollection: [],
                    currentlyViewingRevision: null,
                    latestRevision: null,
                    currentUserIsDocControlAdmin: false,
                    location: {
                        href: null,
                        projectStagePK: null,
                        projectStageTitle: null,
                        projectStageTreeViewPK: null,
                        name: null,
                        isRevisionable: false
                    }
                },
                postCreate: function () {
                    this._gatherFunctionalNodes();
                    this._isDocControlAdmin();
                    this._determineRevisionable();
                },
                _isDocControlAdmin: async function () {
                    this.data.currentUserIsDocControlAdmin = await this.dataManager.request(new RequestData(ACTIONS.GROUP_IS_MEMBER_OF, new IsMemberOf(GROUP_LIST['Document Control Administrator']))).getPromise();
                    this.render();
                },
                _determineRevisionable: async function () {
                    await new Promise((resolve) => {
                        new TreeFactory(new TreeFactoryConfig(), new URLConnectionBuilder(new URLConnectionProcessorBuilder()), new URLResponseProcessorBuilder()).getNode().get(new Handlers((location) => {
                            if (location) {
                                this.data.location.href = this.routeContainer.get(ROUTE_OVERVIEW_LISTING, {
                                    'listingType': LISTING_TYPE[location.getType().toLowerCase()] || LISTING_TYPE['other'],
                                    'projectStagePK': location.getProjectStagePK(),
                                    'projectStageTreeViewPK': location.getProjectStageTreeViewPK()
                                });
                                this.data.location.projectStagePK = location.getProjectStageTreeViewPK();
                                this.data.location.projectStageTitle = (new ProjectStageTitleFormatter())
                                    .setStageNumber(location.getProjectStage().getStageNumber())
                                    .setTitle(location.getProjectStage().getTitle())
                                    .format();
                                this.data.location.projectStageTreeViewPK = location.getProjectStageTreeViewPK();
                                this.data.location.name = location.getName();
                                this.data.location.isRevisionable = [NODE_TYPES.REVISIONABLE.toLowerCase(), NODE_TYPES.DRAWING.toLowerCase()].indexOf(location.getType().toLowerCase()) !== -1;
                                this.render();
                            }
                            resolve();
                        }, (e) => {
                            console.error(e);
                            resolve();
                        }), this.data.currentlyViewingRevision.getDocumentPK());
                    });
                },
                postMixInProperties: function () {
                    this.inherited(this.postMixInProperties, arguments);
                    const megabytesFormatter = new MegaBytesFormatter();
                    const mimeTypeFormatter = new MimeTypeFormatter();
                    const fileTypeToIconClass = new FileTypeToIconClass();
                    const fileTypeToColourClass = new FileTypeToColourClass();
                    const isEarliest = (revision, revisionCollection) => {
                        return revision.getRevisionPK() == Math.min.apply(Math, revisionCollection.map(r => r.getRevisionPK()));
                    };
                    const isUpload = (revision) => isEarliest(revision, this.data.documentRevisionCollection);
                    const isUpdate = (revision) => {
                        return !isEarliest(revision, this.data.documentRevisionCollection.filter(r => this.data.currentlyViewingRevision.getMd5() == r.getMd5(), revision));
                    };
                    this.setCustomViewHelpers({
                        revisionDownloadUrl: (id) => this.routeContainer.get('downloadRevision', { id: id }),
                        historyActionFormatter: function (revision) {
                            if (isUpload(revision)) {
                                return '<span class="sos-icon sos-revision-history-uploaded">Uploaded</span>';
                            }
                            if (isUpdate(revision)) {
                                return '<span class="sos-icon sos-revision-history-updated">Updated</span>';
                            }
                            return '<span class="sos-icon sos-revision-history-revised">Revised</span>';
                        },
                        personFormatter: function (person) {
                            if (!person) {
                                return '-';
                            }
                            const personFormatter = new PersonFormatter();
                            personFormatter.setJobTitle(person.getJobTitle());
                            personFormatter.setDisplayName(person.getDisplayName());
                            return personFormatter.format();
                        },
                        originatorFormatter: function (revision) {
                            const PRETEXT = 'on behalf of ';
                            if (revision.getPersonSender() && revision.getPersonSender().getPersonPK()) {
                                if (revision.getPersonUploader() && revision.getPersonUploader().getPersonPK() === revision.getPersonSender().getPersonPK()) {
                                    return;
                                }
                                const personFormatter = new PersonFormatter();
                                personFormatter.setJobTitle(revision.getPersonSender().getJobTitle());
                                personFormatter.setDisplayName(revision.getPersonSender().getDisplayName());
                                return PRETEXT + personFormatter.format() + ' - ' + revision.getOrganisationFrom().getName();
                            }
                            if (revision.getOrganisationFrom() && revision.getOrganisationFrom().getOrganisationPK()) {
                                return PRETEXT + revision.getOrganisationFrom().getName();
                            }
                        },
                        dateFormatter: function (date, includeTime = false) {
                            return date.toLocaleDateString('en-GB') +
                                (includeTime ? ' ' + date.toLocaleTimeString('en-GB', {
                                    hour12: false,
                                    hour: 'numeric',
                                    minute: 'numeric'
                                }) : '');
                        },
                        formatRevisionTitle: (revision) => {
                            let title = revision.getTitle();
                            if (revision.isLatest())
                                title += ' [Latest Revision]';
                            if (this.data.currentlyViewingRevision && this.data.currentlyViewingRevision.getRevisionPK() === revision.getRevisionPK()) {
                                title += ' [Currently Viewing]';
                            }
                            return title;
                        },
                        megabytesFormatter: megabytesFormatter.format.bind(megabytesFormatter),
                        mimeTypeFormatter: mimeTypeFormatter.format.bind(mimeTypeFormatter),
                        fileTypeIcon: (mimeType) => {
                            const icon = fileTypeToIconClass.getClass(mimeType);
                            const colour = fileTypeToColourClass.getClass(mimeType);
                            return icon + ' ' + (colour ? colour + '-foreground' : '');
                        }
                    });
                },
                render: function () {
                    this.inherited(this.render, arguments);
                    this._gatherFunctionalNodes();
                },
                _enableEditForm: function () {
                    this.latestRevisionRadioButtonsContainers.forEach(div => div.classList.remove('display-none'));
                    this.editRevisionNumbersButton.classList.add('hidden');
                    this.editingStateButtons.classList.remove('hidden');
                    this.staticRevisionNumbers.forEach(rn => rn.classList.add('hidden'));
                    this.revisionNumberTextBoxContainers.forEach(rn => rn.classList.remove('hidden'));
                },
                _disableEditForm: function () {
                    this.render();
                },
                _saveRevisionNumbersClick: async function () {
                    if (!this.data.currentUserIsDocControlAdmin)
                        return;
                    topic.publish('sos-system-notification-progress', 'Saving updated revision details...', this.constants.SAVING_REVISION_DETAILS_NOTIFICATION_UID);
                    if (this.data.location.isRevisionable && !this._revisionNumbersAreValid()) {
                        topic.publish('sos-system-notification-progress-complete', this.constants.SAVING_REVISION_DETAILS_NOTIFICATION_UID, this.constants.ERROR_INVALID_REVISION_NUMBER, 'error', 10000);
                        return;
                    }
                    if (this.data.location.isRevisionable && !this._allRevisionNumbersAreUnique()) {
                        topic.publish('sos-system-notification-progress-complete', this.constants.SAVING_REVISION_DETAILS_NOTIFICATION_UID, this.constants.ERROR_DUPLICATE_REVISION_NUMBER, 'error', 10000);
                        return;
                    }
                    this.editingStateButtons.querySelectorAll('button')
                        .forEach((b) => b.disabled = true);
                    this.domNode.querySelectorAll('.dynamic-revision-text-box')
                        .forEach((b) => b.disabled = true);
                    const enabledLatestRevisionRadioButtons = [...this.domNode.querySelectorAll('.latest-revision-radio-button:not([disabled])')];
                    enabledLatestRevisionRadioButtons.forEach((r) => r.disabled = true);
                    try {
                        const latestRevisionPK = this._getSelectedLatestRevisionPK();
                        const newRevisionNumbers = this._getNewRevisionNumbers();
                        const promises = [];
                        promises.push(await this.dataManager.request(new RequestData(ACTIONS.DOCUMENT_REVISION_SET_LATEST, {
                            documentPK: this._getDocumentPK(),
                            revisionPK: latestRevisionPK
                        })).getPromise());
                        if (this.data.location.isRevisionable) {
                            promises.push(await this.dataManager.request(new RequestData(ACTIONS.DOCUMENT_REVISION_NUMBER, {
                                documentPK: this._getDocumentPK(),
                                revisionCollection: newRevisionNumbers
                            })).getPromise());
                        }
                        Promise.all(promises).then((r) => {
                            topic.publish('sos-system-notification-progress-complete', this.constants.SAVING_REVISION_DETAILS_NOTIFICATION_UID, 'Revision details updated successfully.', 'success', 3000);
                            this._updateRevisionData(latestRevisionPK, newRevisionNumbers);
                            this._disableEditForm();
                            topic.publish('revision-meta-data/updated');
                        });
                    }
                    catch (e) {
                        topic.publish('sos-system-notification-progress-complete', this.constants.SAVING_REVISION_DETAILS_NOTIFICATION_UID, e.description ? e.description : this.constants.ERROR_GENERIC, 'error', 10000);
                        this.editingStateButtons.querySelectorAll('button')
                            .forEach((b) => b.disabled = false);
                        this.domNode.querySelectorAll('.dynamic-revision-text-box')
                            .forEach((b) => b.disabled = false);
                        enabledLatestRevisionRadioButtons.forEach((r) => r.disabled = false);
                    }
                },
                _revisionNumbersAreValid: function () {
                    return this.revisionNumberTextBoxes.every((box) => box.checkValidity());
                },
                _allRevisionNumbersAreUnique: function () {
                    const uniqueValues = new Set(this.revisionNumberTextBoxes.map((box) => box.value));
                    return uniqueValues.size === this.revisionNumberTextBoxes.length;
                },
                _getDocumentPK: function () {
                    return this.data.documentRevisionCollection.find(r => r.isLatest()).getDocumentPK();
                },
                _getSelectedLatestRevisionPK: function () {
                    let selectedRadioValue = null;
                    this.latestRevisionRadioButtons.some(rad => {
                        if (rad.checked) {
                            selectedRadioValue = rad.value;
                            return true;
                        }
                    });
                    return selectedRadioValue;
                },
                _getNewRevisionNumbers: function () {
                    const r = [];
                    this.revisionNumberTextBoxes.forEach(box => {
                        const md5 = box.dataset['md5'];
                        this.data.documentRevisionCollection.filter((r) => r.getMd5() === md5)
                            .forEach((revision) => {
                            r.push(new RevisionVO(revision.getRevisionPK(), revision.getMd5(), revision.getTitle(), revision.getFileType()).setRevisionNumber(box.value));
                        });
                    });
                    return r;
                },
                _updateRevisionData: function (latestRevisionPK, newRevisionNumbers) {
                    this.data.documentRevisionCollection.forEach((r) => {
                        if (r.getRevisionPK() == latestRevisionPK) {
                            r.markAsLatest();
                        }
                        else {
                            r.unmarkAsLatest();
                        }
                        const newRevision = newRevisionNumbers.find(nr => nr.getRevisionPK() == r.getRevisionPK());
                        if (newRevision) {
                            r.setRevisionNumber(newRevision.getRevisionNumber());
                        }
                    });
                },
                _gatherFunctionalNodes: function () {
                    this.latestRevisionRadioButtonsContainers = [...this.domNode.querySelectorAll('.latest-revision-radio-button-container')];
                    this.latestRevisionRadioButtons = [...this.domNode.querySelectorAll('.latest-revision-radio-button')];
                    this.staticRevisionNumbers = [...this.domNode.querySelectorAll('.revision-number-static')];
                    this.revisionNumberTextBoxContainers = [...this.domNode.querySelectorAll('.dynamic-revision-text-box-container')];
                    this.revisionNumberTextBoxes = [...this.domNode.querySelectorAll('.dynamic-revision-text-box')];
                },
                _viewDocument: function (e) {
                    e.preventDefault();
                    topic.publish(TOPICS.DOCUMENT_VIEWER_VIEW, {
                        revisionPK: domAttr.get(e.target, 'data-revision-pk'),
                        href: domAttr.get(e.target, 'href'),
                        fileType: domAttr.get(e.target, 'data-file-type'),
                        md5: domAttr.get(e.target, 'data-md5')
                    });
                }
            });
        }
    }
    return RevisionHistoryTable;
});

},
'spencer/data-manager/core/context/Group/IsMemberOf':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class IsMemberOf {
        constructor(uid) {
            this.uid = uid;
        }
        getUid() {
            return this.uid;
        }
        isValid() {
            return !!this.uid;
        }
    }
    return IsMemberOf;
});

},
'spencer/data-manager/core/definition/Actions':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    return {
        ADDRESS_COUNTRY: 'address-country',
        ADDRESS_COUNTY: 'address-county',
        CLIENT_CONTACT_REPORT_ORGANISATION_COLLECTION: 'client-contact-report-organisation-collection',
        CLIENT_CONTACT_REPORT_PERSON_CONTACTED: 'client-contact_report_person_contacted_collection',
        CLIENT_CONTACT_REPORT_PERSON_CONTACTED_BY: 'client-contact_report_person_contacted_by_collection',
        CLIENT_CONTACT_REPORT_PROJECT_STAGE: 'client-contact-report-project-stage-collection',
        CLIENT_SELECTED_FROM_COLLECTION: 'client-selected-from-collection',
        CONTACT: 'contact',
        CONTACT_COLLECTION: 'contact-collection',
        CONTRACT_CONDITION_COLLECTION: 'contract-condition-collection',
        CONTRACT_TYPE_COLLECTION: 'contract-type-collection',
        CREATE_BUDGET_STAGE: 'create-budget-stage',
        CREATE_CONTRACT_STAGE: 'create-contract-stage',
        CREATE_DOCUMENT_FAVOURITE: 'favourite-document-create',
        CREATE_GENERAL_STAGE: 'create-general-stage',
        CREATE_INTELLIGENCE_STAGE: 'create-intelligence-stage',
        CREATE_LEAD_STAGE: 'create-lead-stage',
        CREATE_PREQUAL_STAGE: 'create-prequal-stage',
        CREATE_PROJECT: 'create-project',
        CREATE_PROJECT_SITE: 'create-project-site',
        CREATE_TENDER_OFFER_STAGE: 'create-tender-offer-stage',
        CREATE_TENDER_STAGE: 'create-tender-stage',
        DOCUMENT_REGISTER: 'temporary_document_register',
        DOCUMENT_BULK_REGISTER: 'document-bulk-register',
        DOCUMENT_LATEST: 'document-latest',
        DOCUMENT_LOCATION: 'document-location',
        DOCUMENT_MERGE: 'document-merge',
        DOCUMENT_REVISION_SET_LATEST: 'document-revision-set-latest',
        DOCUMENT_REVISION_SEARCH: 'document-revision-search',
        DOCUMENT_REVISION_NUMBER: 'document-revision-number',
        DOCUMENT_UPLOAD: 'document-upload',
        EDIT_PROJECT: 'edit-project',
        EDIT_PROJECT_SITE: 'edit-project-site',
        EMAIL_REGISTRATION_DETAILS: 'email-registration-details',
        FAVOURITE_DOCUMENT_GET: 'favourite-document-get',
        FILE_PREVIEW: 'file-preview',
        FILE_UPLOAD: 'file-upload',
        GROUP_COLLECTION: 'group-collection',
        GROUP_IS_MEMBER_OF: 'group-is-member-of',
        GROUP_MEMBER_COLLECTION: 'group-member-collection',
        LEAD_TEAM: 'lead-team',
        LEAD_TEAM_COLLECTION: 'lead-team-collection',
        MY_GROUP_COLLECTION: 'my-group-collection',
        MY_GROUP_MEMBER_COLLECTION: 'my-group-member-collection',
        ORGANISATION_BRANCH_OFFICE_COLLECTION: 'organisation-branch-office-collection',
        ORGANISATION_COLLECTION: 'organisation-collection',
        ORGANISATION_INTRANET_OWNER_COLLECTION: 'organisation-intranet-owner-collection',
        ORGANISATION_PERSON_COLLECTION: 'organisation-person-collection',
        PERSON: 'person',
        PERSON_SELF: 'person-self',
        PROJECT: 'project',
        PROJECT_COLLECTION: 'project-collection',
        PROJECT_SITE_COLLECTION: 'project-site-collection',
        PROJECT_SITE_DOCUMENT_COLLECTION: 'project-site-document-collection',
        PROJECT_SITE_DOCUMENT_DELETE: 'project-site-document-delete',
        PROJECT_STAGE: 'project-stage',
        PROJECT_STAGE_BUDGET: 'project-stage-budget',
        PROJECT_STAGE_BUDGET_STATUS_COLLECTION: 'project-stage-budget-status-collection',
        PROJECT_STAGE_COLLECTION: 'project-stage-collection',
        PROJECT_STAGE_CONTRACT: 'project-stage-contract',
        PROJECT_STAGE_INTELLIGENCE: 'project-stage-intelligence',
        PROJECT_STAGE_LEAD: 'project-stage-lead',
        PROJECT_STAGE_MEMBER_COLLECTION: 'project-stage-member-collection',
        PROJECT_STAGE_NODE: 'project-stage-node',
        PROJECT_STAGE_NUMBER_RANGE_COLLECTION: 'project-stage-number-range-collection',
        PROJECT_STAGE_PREQUAL: 'project-stage-prequal',
        PROJECT_STAGE_PREQUAL_FOR_COLLECTION: 'project-stage-prequal-for-collection',
        PROJECT_STAGE_TENDER: 'project-stage-tender',
        PROJECT_STAGE_TENDER_OFFER: 'project-stage-tender-offer',
        PROJECT_STAGE_TYPE_COLLECTION: 'project-stage-type-collection',
        PROJECT_TENDER_TYPE_COLLECTION: 'project-tender-type-collection',
        REMOVE_DOCUMENT_FAVOURITE: 'favourite-document-remove',
        REVISION: 'revision',
        SAVE_BUDGET_STAGE: 'save-budget-stage',
        SAVE_CONTRACT_STAGE: 'save-contract-stage',
        SAVE_ESTIMATED_PROJECT_DATES: 'save-estimated-project-dates',
        SAVE_INTELLIGENCE_STAGE: 'save-intelligence-stage',
        SAVE_LEAD_STAGE: 'save-lead-stage',
        SAVE_PREQUAL_STAGE: 'save-prequal-stage',
        SAVE_TENDER_OFFER_STAGE: 'save-tender-offer-stage',
        SAVE_TENDER_STAGE: 'save-tender-stage',
        TEAM_COLLECTION: 'team-collection',
        TREE: 'tree',
        TREE_STRUCTURE: 'tree-structure',
        TREE_TEMPLATE_COLLECTION: 'tree-template-collection'
    };
});

},
'spencer/data-manager/data/Request':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Request {
        constructor(action, context = {}, forceRefresh = false) {
            this.action = action;
            this.context = context;
            this.forceRefresh = forceRefresh;
        }
        getAction() {
            return this.action;
        }
        getContext() {
            return this.context;
        }
        shouldForceRefresh() {
            return this.forceRefresh;
        }
    }
    return Request;
});

},
'@lib/group/GroupList':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    return {
        'Commercial Admin': 'COMMERCIAL_ADMIN',
        'Document Control Administrator': 'DOC_CONTROL_ADMIN'
    };
});

},
'project-listing/config/ListingType':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    return {
        'correspondence': 'correspondence',
        'other': 'document-listing',
        'drawing': 'drawing-listing',
        'folder': 'folder-listing',
        'mixed': 'mixed-listing',
        'multi': 'multi-node',
        'revisionable': 'revisionable-listing',
        'virtual': 'correspondence'
    };
});

},
'style-guide/v1/doc-control/project-node-select/multi-node-select/NodeTypes':function(){
define(["require", "exports", "@lib/doc-control/tree/config/NodeTypes"], function (require, exports, NODE_TYPES) {
    "use strict";
    return NODE_TYPES;
});

},
'@lib/doc-control/tree/config/NodeTypes':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    return {
        CORRESPONDENCE: 'Correspondence',
        DRAWING: 'Drawing',
        FOLDER: 'Folder',
        FUNCTION: 'Function',
        HIDDEN: 'Hidden',
        MODULE: 'Module',
        OTHER: 'Other',
        REVISABLE: ['Drawing', 'Revisionable'],
        REVISIONABLE: 'Revisionable',
        TEMPLATE: 'Template',
        TEMPLATE_ORG: 'TemplateOrg',
        VIRTUAL: 'Virtual'
    };
});

},
'doc-control/config/Regex':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    return {
        OCR_TEMPLATE_REFERENCE_VALIDATION: '^[a-z0-9-_(). ]+$',
        REFERENCE_VALIDATION: '^[a-zA-Z0-9-.]+$',
        REVISION_NUMBER_VALIDATION: /^-$|^[1-9a-zA-Z][0-9a-zA-Z.]*$|^0+[1-9a-zA-Z.][0-9a-zA-Z.]*$/
    };
});

},
'doccontrol/viewer/config/InformationPanes':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    const InformationPanes = {
        DOCUMENT_HISTORY: 'Document History'
    };
    return InformationPanes;
});

},
'doc-control/tree/RegistrationLocationFormatter':function(){
define([], function() {
    var RegistrationLocationFormatter = function() {
        this.location = '';
    };

    RegistrationLocationFormatter.prototype.format = function(nodeVO) {
        const projectStage = nodeVO.getProjectStage();
        if (projectStage.getStageNumber() && projectStage.getStageNumber() !== 'General') {
            this.location += projectStage.getStageNumber() + ' - ';
        }
        this.location += projectStage.getTitle();
        this.formatChildren(nodeVO.getChildren());

        return this.location;
    };

    RegistrationLocationFormatter.prototype.formatChildren = function(nodeChildren) {
        for (var i in nodeChildren) {
            if (nodeChildren.hasOwnProperty(i)) {
                var node = nodeChildren[i];
                this.location += ' - ' + node.getName();

                if (node.getChildren()) {
                    this.formatChildren(node.getChildren());
                }
            }
        }
    };

    return RegistrationLocationFormatter;
});
},
'dijit/form/NumberTextBox':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/_base/lang", // lang.hitch lang.mixin
	"dojo/i18n", // i18n.normalizeLocale, i18n.getLocalization
	"dojo/string", // string.rep
	"dojo/number", // number._realNumberRegexp number.format number.parse number.regexp
	"./RangeBoundTextBox"
], function(declare, lang, i18n, string, number, RangeBoundTextBox){

	// module:
	//		dijit/form/NumberTextBox

	// A private helper function to determine decimal information
	// Returns an object with "sep" and "places" properties
	var getDecimalInfo = function(constraints){
		var constraints = constraints || {},
			bundle = i18n.getLocalization("dojo.cldr", "number", i18n.normalizeLocale(constraints.locale)),
			pattern = constraints.pattern ? constraints.pattern : bundle[(constraints.type || "decimal")+"Format"];

		// The number of places in the constraint can be specified in several ways,
		// the resolution order is:
		//
		// 1. If constraints.places is a number, use that
		// 2. If constraints.places is a string, which specifies a range, use the range max (e.g. 0,4)
		// 3. If a pattern is specified, use the implicit number of places in the pattern.
		// 4. If neither constraints.pattern or constraints.places is specified, use the locale default pattern
		var places;
		if(typeof constraints.places == "number"){
			places = constraints.places;
		}else if(typeof constraints.places === "string" && constraints.places.length > 0){
			places = constraints.places.replace(/.*,/, "");
		}else{
			places = (pattern.indexOf(".") != -1 ? pattern.split(".")[1].replace(/[^#0]/g, "").length : 0);
		}

		return { sep: bundle.decimal, places: places };
	};

	var NumberTextBoxMixin = declare("dijit.form.NumberTextBoxMixin", null, {
		// summary:
		//		A mixin for all number textboxes
		// tags:
		//		protected

		// Override ValidationTextBox.pattern.... we use a reg-ex generating function rather
		// than a straight regexp to deal with locale (plus formatting options too?)
		pattern: function(constraints){
			// if focused, accept either currency data or NumberTextBox format
			return '(' + (this.focused && this.editOptions ? this._regExpGenerator(lang.delegate(constraints, this.editOptions)) + '|' : '')
				+ this._regExpGenerator(constraints) + ')';
		},

		/*=====
		// constraints: NumberTextBox.__Constraints
		//		Despite the name, this parameter specifies both constraints on the input
		//		(including minimum/maximum allowed values) as well as
		//		formatting options like places (the number of digits to display after
		//		the decimal point).
		constraints: {},
		======*/

		// value: Number
		//		The value of this NumberTextBox as a Javascript Number (i.e., not a String).
		//		If the displayed value is blank, the value is NaN, and if the user types in
		//		an gibberish value (like "hello world"), the value is undefined
		//		(i.e. get('value') returns undefined).
		//
		//		Symmetrically, set('value', NaN) will clear the displayed value,
		//		whereas set('value', undefined) will have no effect.
		value: NaN,

		// editOptions: [protected] Object
		//		Properties to mix into constraints when the value is being edited.
		//		This is here because we edit the number in the format "12345", which is
		//		different than the display value (ex: "12,345")
		editOptions: { pattern: '#.######' },

		/*=====
		_formatter: function(value, options){
			// summary:
			//		_formatter() is called by format().  It's the base routine for formatting a number,
			//		as a string, for example converting 12345 into "12,345".
			// value: Number
			//		The number to be converted into a string.
			// options: number.__FormatOptions?
			//		Formatting options
			// tags:
			//		protected extension

			return "12345";		// String
		},
		 =====*/
		_formatter: number.format,

		/*=====
		_regExpGenerator: function(constraints){
			// summary:
			//		Generate a localized regular expression as a string, according to constraints.
			// constraints: number.__ParseOptions
			//		Formatting options
			// tags:
			//		protected

			return "(\d*).(\d*)";	// string
		},
		=====*/
		_regExpGenerator: number.regexp,

		// _decimalInfo: Object
		// summary:
		//		An object containing decimal related properties relevant to this TextBox.
		// tags:
		//		private
		_decimalInfo: getDecimalInfo(),

		postMixInProperties: function(){
			this.inherited(arguments);
			this._set("type", "text"); // in case type="number" was specified which messes up parse/format
		},

		_setConstraintsAttr: function(/*Object*/ constraints){
			var places = typeof constraints.places == "number"? constraints.places : 0;
			if(places){ places++; } // decimal rounding errors take away another digit of precision
			if(typeof constraints.max != "number"){
				constraints.max = 9 * Math.pow(10, 15-places);
			}
			if(typeof constraints.min != "number"){
				constraints.min = -9 * Math.pow(10, 15-places);
			}
			this.inherited(arguments, [ constraints ]);
			if(this.focusNode && this.focusNode.value && !isNaN(this.value)){
				this.set('value', this.value);
			}
			// Capture decimal information based on the constraint locale and pattern.
			this._decimalInfo = getDecimalInfo(constraints);
		},

		_onFocus: function(/*String*/ by){
			if(this.disabled || this.readOnly){ return; }
			var val = this.get('value');
			if(typeof val == "number" && !isNaN(val)){
				var formattedValue = this.format(val, this.constraints);
				if(formattedValue !== undefined){
					this.textbox.value = formattedValue;
					// when NumberTextBox or descendants (i.e. CurrencyTextBox) format textbox.value when focused
					// all browsers except Chrome will select textbox contents when tabbed to by keyboard
					// force selection if not focused by mouse
					if (by !== "mouse") {
						this.textbox.select();
					}
				}
			}
			this.inherited(arguments);
		},

		format: function(/*Number*/ value, /*number.__FormatOptions*/ constraints){
			// summary:
			//		Formats the value as a Number, according to constraints.
			// tags:
			//		protected

			var formattedValue = String(value);
			if(typeof value != "number"){ return formattedValue; }
			if(isNaN(value)){ return ""; }
			// check for exponential notation that dojo/number.format() chokes on
			if(!("rangeCheck" in this && this.rangeCheck(value, constraints)) && constraints.exponent !== false && /\de[-+]?\d/i.test(formattedValue)){
				return formattedValue;
			}
			if(this.editOptions && this.focused){
				constraints = lang.mixin({}, constraints, this.editOptions);
			}
			return this._formatter(value, constraints);
		},

		/*=====
		_parser: function(value, constraints){
			// summary:
			//		Parses the string value as a Number, according to constraints.
			// value: String
			//		String representing a number
			// constraints: number.__ParseOptions
			//		Formatting options
			// tags:
			//		protected

			return 123.45;		// Number
		},
		=====*/
		_parser: number.parse,

		parse: function(/*String*/ value, /*number.__FormatOptions*/ constraints){
			// summary:
			//		Replaceable function to convert a formatted string to a number value
			// tags:
			//		protected extension
			var parserOptions = lang.mixin({}, constraints, (this.editOptions && this.focused) ? this.editOptions : {})
			if(this.focused && parserOptions.places != null /* or undefined */){
				var places = parserOptions.places;
				var maxPlaces = typeof places === "number" ? places : Number(places.split(",").pop()); // handle number and range
				parserOptions.places = "0," + maxPlaces;
			}
			var v = this._parser(value, parserOptions);
			if(this.editOptions && this.focused && isNaN(v)){
				v = this._parser(value, constraints); // parse w/o editOptions: not technically needed but is nice for the user
			}
			return v;
		},

		_getDisplayedValueAttr: function(){
			var v = this.inherited(arguments);
			return isNaN(v) ? this.textbox.value : v;
		},

		filter: function(/*Number*/ value){
			// summary:
			//		This is called with both the display value (string), and the actual value (a number).
			//		When called with the actual value it does corrections so that '' etc. are represented as NaN.
			//		Otherwise it dispatches to the superclass's filter() method.
			//
			//		See `dijit/form/TextBox.filter()` for more details.
			if(value == null  /* or undefined */ || typeof value == "string" && value ==''){
				return NaN;
			}else if(typeof value == "number" && !isNaN(value) && value != 0){
				value = number.round(value, this._decimalInfo.places);
			}
			return this.inherited(arguments, [value]);
		},

		serialize: function(/*Number*/ value, /*Object?*/ options){
			// summary:
			//		Convert value (a Number) into a canonical string (ie, how the number literal is written in javascript/java/C/etc.)
			// tags:
			//		protected
			return (typeof value != "number" || isNaN(value)) ? '' : this.inherited(arguments);
		},

		_setBlurValue: function(){
			var val = lang.hitch(lang.delegate(this, { focused: true }), "get")('value'); // parse with editOptions
			this._setValueAttr(val, true);
		},

		_setValueAttr: function(/*Number*/ value, /*Boolean?*/ priorityChange, /*String?*/ formattedValue){
			// summary:
			//		Hook so set('value', ...) works.
			if(value !== undefined && formattedValue === undefined){
				formattedValue = String(value);
				if(typeof value == "number"){
					if(isNaN(value)){ formattedValue = '' }
					// check for exponential notation that number.format chokes on
					else if(("rangeCheck" in this && this.rangeCheck(value, this.constraints)) || this.constraints.exponent === false || !/\de[-+]?\d/i.test(formattedValue)){
						formattedValue = undefined; // lets format compute a real string value
					}
				}else if(!value){ // 0 processed in if branch above, ''|null|undefined flows through here
					formattedValue = '';
					value = NaN;
				}else{ // non-numeric values
					value = undefined;
				}
			}
			this.inherited(arguments, [value, priorityChange, formattedValue]);
		},

		_getValueAttr: function(){
			// summary:
			//		Hook so get('value') works.
			//		Returns Number, NaN for '', or undefined for unparseable text
			var v = this.inherited(arguments); // returns Number for all values accepted by parse() or NaN for all other displayed values

			// If the displayed value of the textbox is gibberish (ex: "hello world"), this.inherited() above
			// returns NaN; this if() branch converts the return value to undefined.
			// Returning undefined prevents user text from being overwritten when doing _setValueAttr(_getValueAttr()).
			// A blank displayed value is still returned as NaN.
			if(isNaN(v) && this.textbox.value !== ''){
				if(this.constraints.exponent !== false && /\de[-+]?\d/i.test(this.textbox.value) && (new RegExp("^"+number._realNumberRegexp(lang.delegate(this.constraints))+"$").test(this.textbox.value))){	// check for exponential notation that parse() rejected (erroneously?)
					var n = Number(this.textbox.value);
					return isNaN(n) ? undefined : n; // return exponential Number or undefined for random text (may not be possible to do with the above RegExp check)
				}else{
					return undefined; // gibberish
				}
			}else{
				return v; // Number or NaN for ''
			}
		},

		isValid: function(/*Boolean*/ isFocused){
			// Overrides dijit/form/RangeBoundTextBox.isValid() to check that the editing-mode value is valid since
			// it may not be formatted according to the regExp validation rules
			if(!this.focused || this._isEmpty(this.textbox.value)){
				return this.inherited(arguments);
			}else{
				var v = this.get('value');
				if(!isNaN(v) && this.rangeCheck(v, this.constraints)){
					if(this.constraints.exponent !== false && /\de[-+]?\d/i.test(this.textbox.value)){ // exponential, parse doesn't like it
						return true; // valid exponential number in range
					}else{
						return this.inherited(arguments);
					}
				}else{
					return false;
				}
			}
		},

		_isValidSubset: function(){
			// Overrides dijit/form/ValidationTextBox._isValidSubset()
			//
			// The inherited method only checks that the computed regex pattern is valid, which doesn't
			// take into account that numbers are a special case. Specifically:
			//
			//  (1) An arbitrary amount of leading or trailing zero's can be ignored.
			//  (2) Since numeric input always occurs in the order of most significant to least significant
			//      digits, the maximum and minimum possible values for partially inputted numbers can easily
			//      be determined by using the number of remaining digit spaces available.
			//
			// For example, if an input has a maxLength of 5, and a min value of greater than 100, then the subset
			// is invalid if there are 3 leading 0s. It remains valid for the first two.
			//
			// Another example is if the min value is 1.1. Once a value of 1.0 is entered, no additional trailing digits
			// could possibly satisify the min requirement.
			//
			// See ticket #17923
			var hasMinConstraint = (typeof this.constraints.min == "number"),
				hasMaxConstraint = (typeof this.constraints.max == "number"),
				curVal = this.get('value');

			// If there is no parsable number, or there are no min or max bounds, then we can safely
			// skip all remaining checks
			if(isNaN(curVal) || (!hasMinConstraint && !hasMaxConstraint)){
				return this.inherited(arguments);
			}

			// This block picks apart the values in the text box to be used later to compute the min and max possible
			// values based on the current value and the remaining available digits.
			//
			// Warning: The use of a "num|0" expression, can be confusing. See the link below
			// for an explanation.
			//
			// http://stackoverflow.com/questions/12125421/why-does-a-shift-by-0-truncate-the-decimal
			var integerDigits = curVal|0,
				valNegative = curVal < 0,
				// Check if the current number has a decimal based on its locale
				hasDecimal = this.textbox.value.indexOf(this._decimalInfo.sep) != -1,
				// Determine the max digits based on the textbox length. If no length is
				// specified, chose a huge number to account for crazy formatting.
				maxDigits = this.maxLength || 20,
				// Determine the remaining digits, based on the max digits
				remainingDigitsCount = maxDigits - this.textbox.value.length,
				// avoid approximation issues by capturing the decimal portion of the value as the user-entered string
				fractionalDigitStr = hasDecimal ? this.textbox.value.split(this._decimalInfo.sep)[1].replace(/[^0-9]/g, "") : "";

			// Create a normalized value string in the form of #.###
			var normalizedValueStr = hasDecimal ? integerDigits+"."+fractionalDigitStr : integerDigits+"";

			// The min and max values for the field can be determined using the following
			// logic:
			//
			//  If the number is positive:
			//      min value = the current value
			//      max value = the current value with 9s appended for all remaining possible digits
			//  else
			//      min value = the current value with 9s appended for all remaining possible digits
			//      max value = the current value
			//
			var ninePaddingStr = string.rep("9", remainingDigitsCount),
			    minPossibleValue = curVal,
			    maxPossibleValue = curVal;
			if (valNegative){
				minPossibleValue = Number(normalizedValueStr+ninePaddingStr);
			} else{
				maxPossibleValue = Number(normalizedValueStr+ninePaddingStr);
			}

			return !((hasMinConstraint && maxPossibleValue < this.constraints.min)
					|| (hasMaxConstraint && minPossibleValue > this.constraints.max));
		}
	});

	var NumberTextBox = declare("dijit.form.NumberTextBox", [RangeBoundTextBox, NumberTextBoxMixin], {
		// summary:
		//		A TextBox for entering numbers, with formatting and range checking
		// description:
		//		NumberTextBox is a textbox for entering and displaying numbers, supporting
		//		the following main features:
		//
		//		1. Enforce minimum/maximum allowed values (as well as enforcing that the user types
		//			a number rather than a random string)
		//		2. NLS support (altering roles of comma and dot as "thousands-separator" and "decimal-point"
		//			depending on locale).
		//		3. Separate modes for editing the value and displaying it, specifically that
		//			the thousands separator character (typically comma) disappears when editing
		//			but reappears after the field is blurred.
		//		4. Formatting and constraints regarding the number of places (digits after the decimal point)
		//			allowed on input, and number of places displayed when blurred (see `constraints` parameter).

		baseClass: "dijitTextBox dijitNumberTextBox"
	});

	NumberTextBox.Mixin = NumberTextBoxMixin;	// for monkey patching

	/*=====
	 NumberTextBox.__Constraints = declare([RangeBoundTextBox.__Constraints, number.__FormatOptions, number.__ParseOptions], {
		 // summary:
		 //		Specifies both the rules on valid/invalid values (minimum, maximum,
		 //		number of required decimal places), and also formatting options for
		 //		displaying the value when the field is not focused.
		 // example:
		 //		Minimum/maximum:
		 //		To specify a field between 0 and 120:
		 //	|		{min:0,max:120}
		 //		To specify a field that must be an integer:
		 //	|		{fractional:false}
		 //		To specify a field where 0 to 3 decimal places are allowed on input:
		 //	|		{places:'0,3'}
	 });
	 =====*/

	return NumberTextBox;
});

},
'dijit/form/RangeBoundTextBox':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/i18n", // i18n.getLocalization
	"./MappedTextBox",
	"dojo/i18n!./nls/validate"
], function(declare, i18n, MappedTextBox){

	// module:
	//		dijit/form/RangeBoundTextBox


	var RangeBoundTextBox = declare("dijit.form.RangeBoundTextBox", MappedTextBox, {
		// summary:
		//		Base class for textbox form widgets which defines a range of valid values.

		// rangeMessage: String
		//		The message to display if value is out-of-range
		rangeMessage: "",

		/*=====
		// constraints: RangeBoundTextBox.__Constraints
		constraints: {},
		======*/

		rangeCheck: function(/*Number*/ primitive, /*dijit/form/RangeBoundTextBox.__Constraints*/ constraints){
			// summary:
			//		Overridable function used to validate the range of the numeric input value.
			// tags:
			//		protected
			return	("min" in constraints? (this.compare(primitive,constraints.min) >= 0) : true) &&
				("max" in constraints? (this.compare(primitive,constraints.max) <= 0) : true); // Boolean
		},

		isInRange: function(/*Boolean*/ /*===== isFocused =====*/){
			// summary:
			//		Tests if the value is in the min/max range specified in constraints
			// tags:
			//		protected
			return this.rangeCheck(this.get('value'), this.constraints);
		},

		_isDefinitelyOutOfRange: function(){
			// summary:
			//		Returns true if the value is out of range and will remain
			//		out of range even if the user types more characters
			var val = this.get('value');
			if(val == null){ return false; } // not yet valid enough to compare to
			var outOfRange = false;
			if("min" in this.constraints){
				var min = this.constraints.min;
				outOfRange = this.compare(val, ((typeof min == "number") && min >= 0 && val != 0) ? 0 : min) < 0;
			}
			if(!outOfRange && ("max" in this.constraints)){
				var max = this.constraints.max;
				outOfRange = this.compare(val, ((typeof max != "number") || max > 0) ? max : 0) > 0;
			}
			return outOfRange;
		},

		_isValidSubset: function(){
			// summary:
			//		Overrides `dijit/form/ValidationTextBox._isValidSubset()`.
			//		Returns true if the input is syntactically valid, and either within
			//		range or could be made in range by more typing.
			return this.inherited(arguments) && !this._isDefinitelyOutOfRange();
		},

		isValid: function(/*Boolean*/ isFocused){
			// Overrides dijit/form/ValidationTextBox.isValid() to check that the value is also in range.
			return this.inherited(arguments) &&
				((this._isEmpty(this.textbox.value) && !this.required) || this.isInRange(isFocused)); // Boolean
		},

		getErrorMessage: function(/*Boolean*/ isFocused){
			// Overrides dijit/form/ValidationTextBox.getErrorMessage() to print "out of range" message if appropriate
			var v = this.get('value');
			if(v != null /* and !undefined */ && v !== '' && (typeof v != "number" || !isNaN(v)) && !this.isInRange(isFocused)){ // don't check isInRange w/o a real value
				return this.rangeMessage; // String
			}
			return this.inherited(arguments);
		},

		postMixInProperties: function(){
			this.inherited(arguments);
			if(!this.rangeMessage){
				this.messages = i18n.getLocalization("dijit.form", "validate", this.lang);
				this.rangeMessage = this.messages.rangeMessage;
			}
		}
	});
	/*=====
	RangeBoundTextBox.__Constraints = declare(null, {
		// min: Number
		//		Minimum signed value.  Default is -Infinity
		// max: Number
		//		Maximum signed value.  Default is +Infinity
	});
	=====*/
	return RangeBoundTextBox;
});

},
'dijit/form/MappedTextBox':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/sniff", // has("msapp")
	"dojo/dom-construct", // domConstruct.place
	"./ValidationTextBox"
], function(declare, has, domConstruct, ValidationTextBox){

	// module:
	//		dijit/form/MappedTextBox

	return declare("dijit.form.MappedTextBox", ValidationTextBox, {
		// summary:
		//		A dijit/form/ValidationTextBox subclass which provides a base class for widgets that have
		//		a visible formatted display value, and a serializable
		//		value in a hidden input field which is actually sent to the server.
		// description:
		//		The visible display may
		//		be locale-dependent and interactive.  The value sent to the server is stored in a hidden
		//		input field which uses the `name` attribute declared by the original widget.  That value sent
		//		to the server is defined by the dijit/form/MappedTextBox.serialize() method and is typically
		//		locale-neutral.
		// tags:
		//		protected

		postMixInProperties: function(){
			this.inherited(arguments);

			// We want the name attribute to go to the hidden <input>, not the displayed <input>,
			// so override _FormWidget.postMixInProperties() setting of nameAttrSetting for IE.
			this.nameAttrSetting = "";
		},

		// Remap name attribute to be mapped to hidden node created in buildRendering(), rather than this.focusNode
		_setNameAttr: "valueNode",

		serialize: function(val /*=====, options =====*/){
			// summary:
			//		Overridable function used to convert the get('value') result to a canonical
			//		(non-localized) string.  For example, will print dates in ISO format, and
			//		numbers the same way as they are represented in javascript.
			// val: anything
			// options: Object?
			// tags:
			//		protected extension
			return val.toString ? val.toString() : ""; // String
		},

		toString: function(){
			// summary:
			//		Returns widget as a printable string using the widget's value
			// tags:
			//		protected
			var val = this.filter(this.get('value')); // call filter in case value is nonstring and filter has been customized
			return val != null ? (typeof val == "string" ? val : this.serialize(val, this.constraints)) : ""; // String
		},

		validate: function(){
			// Overrides `dijit/form/TextBox.validate`
			this.valueNode.value = this.toString();
			return this.inherited(arguments);
		},

		buildRendering: function(){
			// Overrides `dijit/_TemplatedMixin/buildRendering`

			this.inherited(arguments);

			// Create a hidden <input> node with the serialized value used for submit
			// (as opposed to the displayed value).
			// Passing in name as markup rather than relying on _setNameAttr custom setter above
			// to make query(input[name=...]) work on IE. (see #8660).
			// But not doing that for Windows 8 Store apps because it causes a security exception (see #16452).
			this.valueNode = domConstruct.place("<input type='hidden'" +
				((this.name && !has("msapp")) ? ' name="' + this.name.replace(/"/g, "&quot;") + '"' : "") + "/>",
				this.textbox, "after");
		},

		reset: function(){
			// Overrides `dijit/form/ValidationTextBox.reset` to
			// reset the hidden textbox value to ''
			this.valueNode.value = '';
			this.inherited(arguments);
		}
	});
});

},
'doccontrol/correspondence/KeywordParser':function(){
define(['./Expressions'], function(Expressions) {
    const KeywordParser = function(nodeGenerator, nodeStyle) {
        this.nodeGenerator = nodeGenerator;
        this.nodeStyle = nodeStyle;
        this.expressions = new Expressions();

        this._parseWildcardedWords = function(contents, searchTerm, colour) {
            searchTerm = searchTerm.replace(/[*]/g, '');

            const keywordNode = this.nodeGenerator.create('span', {
                'innerHTML': '$1',
                'data-term': searchTerm + '*'
            });

            return this._replaceKeywords(contents, this.expressions.getWildcardExpression(searchTerm), keywordNode, colour);
        };

        this._parseKeywords = function(contents, searchTerm, colour) {
            let containsAsterisk = false;
            if (searchTerm[searchTerm.length -1] === '*') {
                containsAsterisk = true;
            }

            searchTerm = this.expressions.getKeywordEscapingExpression(searchTerm.replace(/[*]/g, ''));

            const keywordNode = this.nodeGenerator.create('span', {
                'innerHTML': '$1',
                'data-term': (containsAsterisk ? searchTerm + '*' : searchTerm).replace(/\\/g, '')
            });

            return this._replaceKeywords(contents, this.expressions.getKeywordExpression(searchTerm), keywordNode, colour);
        };

        this._replaceKeywords = function(contents, regex, keywordNode, colour) {
            keywordNode = this.nodeStyle.set(keywordNode, 'background', colour);
            keywordNode = this.nodeStyle.set(keywordNode, 'padding', '1px');

            return contents.replace(regex, keywordNode.outerHTML);
        };

        this._sortKeywords = function (keywords) {
            const REGEX_SPACES = /\w+/g;

            return keywords.sort(function (a, b) {
                return b.match(REGEX_SPACES).length - a.match(REGEX_SPACES).length
            });
        }
    };

    KeywordParser.prototype.splitKeywords = function(keywords) {
        keywords = this._sortKeywords(keywords.split(this.expressions.getSplitExpression()).filter(Boolean));

        for (let i in keywords) {
            //Check if multiple asterisks have been passed through, if true, just replace them with the one.
            if (keywords[i].indexOf('*') >= 0) {
                keywords[i] = keywords[i].replace(/[*]/g, '') + '*';
            }
        }

        return keywords;
    };

    KeywordParser.prototype.parseContents = function(contents, searchTerm, colour) {
        if (searchTerm[searchTerm.length -1] === '*') {
            return this._parseWildcardedWords(
                this._parseKeywords(contents, searchTerm, colour),
                searchTerm,
                colour
            );
        }

        return this._parseKeywords(contents, searchTerm, colour);
    };

    return KeywordParser;
});
},
'doccontrol/correspondence/Expressions':function(){
define([], function() {
    const Expressions = function() {};

    Expressions.prototype.getSplitExpression = function() {
        return /\s*\"([^\"]+)\"\s*|\s+/gm;
    };

    Expressions.prototype.getWildcardExpression = function(term) {
        return new RegExp('\\b(' + term + '[\\w-\']+(?![^<>]*>))\\b', 'gi');
    };

    Expressions.prototype.getKeywordEscapingExpression = function(term) {
        return term.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    };

    Expressions.prototype.getKeywordExpression = function(term) {
        return new RegExp('\\b(' + term + '(?![^<>]*>))\\b', 'gi');
    };

    return Expressions;
});
},
'doccontrol/correspondence/dojo/MailKeywordNavigator':function(){
define([
    "dojo/_base/declare",
    "dojo/_base/fx",
    "dojo/_base/window",
    "dojo/dom-construct",
    "dojo/dom-style",
    "dojo/query"
], function(declare, fx, baseWindow, domConstruct, domStyle, query) {
    return declare("doccontrol.correspondence.dojo.MailKeywordNavigator", null, {
        constructor: function (/*object*/ params) {
            for (var i in params) {
                this[i] = params[i];
            }
        },
        navigatorStyle: {
            'position': 'fixed', 'right': '5px', 'top': '5px',
            'color': '#999999', 'backgroundColor': '#EEEEEE',
            'padding': '10px', 'fontSize': '2em', 'border': '1px solid  #CCCCCC'
        },
        scrollContainer: null,
        scope: baseWindow.body(),
        terms: [],
        load: function () {
            var thisScope = this.scope;
            // Destroy keywords box if already exists (keywords box can only already exist in Correspondence widget)
            if (thisScope != baseWindow.body()) {
                query('.keywordNavigator', thisScope.parentNode).forEach(domConstruct.destroy);
            }
            // Create keywords box to display all matching keywords
            var div = domConstruct.create('div', {
                'class': 'keywordNavigator',
                innerHTML: "Keywords",
                style: this.navigatorStyle
            }, thisScope, (thisScope == baseWindow.body() ? null : 'before'));

            var termsCounter = [];

            // Loop through all terms returned from highlighter view helper
            for (var i in this.terms) {
                // Ensure i is a term and not a generic object attribute
                if (this.terms.hasOwnProperty(i)) {
                    var terms = query('[data-term="' + i + '"]', thisScope);
                    var termOccur = terms.length;
                    // If the term occurs in the email, include it in the keywords box
                    if (termOccur > 0) {

                        var colour = domStyle.get(terms[0], 'backgroundColor');
                        termsCounter[i] = [colour, -1, termOccur];
                        var innerDiv = domConstruct.create('div', {style: {'margin': '10px'}}, div);
                        // Create "go to previous" link
                        domConstruct.create('a', {
                            style: {margin: "5px"},
                            innerHTML: '&lt;&lt;',
                            'name': i,
                            // When link is clicked, it reduces the value used as a key to obtain the relevant term's
                            // location within the email (from nodeList returned by query)
                            onclick: function (evt) {
                                // Reduce array key
                                termsCounter[evt.target.name][1]--;

                                // If key is less than zero (array index out of bounds),
                                // ask if we should start searching backwards from the end of the array
                                if (termsCounter[evt.target.name][1] < 0) {
                                    termsCounter[evt.target.name][1] = termsCounter[evt.target.name][2] - 1;
                                    window.status = "Beginning of email reached - continuing search from end";
                                } else {
                                    window.status = "";
                                }

                                // Get node
                                var found = query('[data-term="' +  evt.target.name + '"]')[termsCounter[evt.target.name][1]];
                                // Scroll node into view
                                this._scrollIntoView(found);
                                // Animate node to futher highlight which keyword has been found
                                fx.animateProperty({
                                    node: found,
                                    duration: 500,
                                    properties: {
                                        fontSize: {start: 100, end: 150, units: "%"}
                                    },
                                    onEnd: function () {
                                        fx.animateProperty({
                                            duration: 500,
                                            node: found,
                                            properties: {
                                                fontSize: {start: 150, end: 100, units: "%"}
                                            }
                                        }).play();
                                    }
                                }).play();
                            }.bind(this)
                        }, innerDiv);

                        // Display term (highlighted in corresponding colour)
                        domConstruct.create('span', {
                            style: {'color': 'black', 'background': colour},
                            // Set innerHTML as htmlentities(i)
                            innerHTML: String(i).replace(/&/g, '&amp;')
                                .replace(/</g, '&lt;')
                                .replace(/>/g, '&gt;')
                                .replace(/"/g, '&quot;')
                        }, innerDiv);
                        // Create "go to next" link
                        domConstruct.create('a', {
                            style: {margin: "5px"},
                            innerHTML: '&gt;&gt;',
                            'name': i,
                            // When link is clicked, it reduces the value used as a key to obtain the relevant term's
                            // location within the email (from nodeList returned by query)
                            onclick: function (evt) {
                                // Increase array key
                                termsCounter[evt.target.name][1]++;

                                // If key is equal to occurences of term (array index out of bounds),
                                // ask if we should start searching from the beginning of the array
                                if (termsCounter[evt.target.name][1] == termsCounter[evt.target.name][2]) {
                                    termsCounter[evt.target.name][1] = 0;
                                    window.status = "End of email reached - continuing search from beginning";
                                } else {
                                    window.status = "";
                                }
                                // Get node
                                var found = query('[data-term="' + evt.target.name + '"]')[termsCounter[evt.target.name][1]];
                                // Scroll node into view
                                this._scrollIntoView(found);
                                // Animate node to futher highlight which keyword has been found
                                fx.animateProperty({
                                    node: found,
                                    duration: 500,
                                    properties: {
                                        fontSize: {start: 100, end: 150, units: "%"}
                                    },
                                    onEnd: function () {
                                        fx.animateProperty({
                                            duration: 500,
                                            node: found,
                                            properties: {
                                                fontSize: {start: 150, end: 100, units: "%"}
                                            }
                                        }).play();
                                    }
                                }).play();
                            }.bind(this)
                        }, innerDiv);
                    }
                }
            }
            // Return reference to newly created div for further processing (determining keyword navigator's height, etc.)
            return div;
        },

        _scrollIntoView: function(node) {
            if (!this.scrollContainer) {
                node.scrollIntoView();
                return;
            }

            const topPos = node.offsetTop;
            this.scrollContainer.scrollTop = topPos - 10;
        }
    });
});
},
'spencer/utility/NodeStyle':function(){
define([
    'dojo/dom-style'
], function(
    domStyle
) {
    const NodeStyle = function() {};

    NodeStyle.prototype.set = function(node, styleName, value) {
        domStyle.set(node, styleName, value);
        return node;
    };

    return NodeStyle;
});

},
'style-guide/v1/file-tray/FileTraySingleton':function(){
define([
    './Bar',
    './Interface'
], function(
    Bar,
    Interface
) {
    return {
        widget: null,

        initialise: function(properties, node) {
            if (!this.widget) {
                this.widget = new Bar(properties, node);
            }
        },

        get: function() {
            if (!this.widget) {
                console.error('File tray not initialised');
            }

            return new Interface(this.widget);
        }
    };
});
},
'style-guide/v1/file-tray/Bar':function(){
define([
    'api/Factory',
    'dojo/cookie',
    'dojo/dom-class',
    'dojo/dom-style',
    'dojo/html',
    'dojo/on',
    'dojo/query',
    'dojo/_base/declare',
    'dojo/_base/fx',
    'dojo/text!./template/Bar.html',
    'dijit/_WidgetBase',
    '@lib/api/doc-control/document/data/Basket',
    'soso/sosox/ejs/_Templated',
    'style-guide/v1/notifications/Notification',
    'style-guide/v1/drag-and-drop/CursorSingleton',
    './config/BroadcastChannel',
    './BasketSidebar',
    './Current',
    './DataTransferHelper',
    './SavedBasket',
    './SplitBasket',
    './dialog/BasketSelectDialog',
    './dialog/CollaboratorsDialog',
    './dialog/RenameBasketDialog',
    './dialog/SaveBasketDialog',
    'vendor/localforage/dist/localforage',
    '@lib/request/data/Handlers',
    '@lib/spencer/notification/constants/EventTypes',
    '@lib/spencer/notification/constants/Systems',
    '@lib/spencer/notification/SubscriberSingleton'
], function(
    APIFactory,
    cookie,
    domClass,
    domStyle,
    html,
    on,
    query,
    declare,
    fx,
    template,
    _WidgetBase,
    BasketVO,
    _Templated,
    Notification,
    DragCursorSingleton,
    BroadcastChannelConfig,
    BasketSidebar,
    CurrentFileTray,
    DataTransferHelper,
    SavedBasket,
    SplitBasket,
    BasketSelectDialog,
    CollaboratorsDialog,
    RenameBasketDialog,
    SaveBasketDialog,
    localForage,
    Handlers,
    SpencerNotificationEventTypes,
    SpencerNotificationSystems,
    SpencerNotificationSubscriberSingleton
) {
    const DRAG_CURSOR_ACTION_ADD_TO_BASKET = 'add-to-basket';
    const DRAG_CURSOR_CLASS = '.sos-drag-and-drop-cursor .drag-cursor-action-icon';
    const SPLIT_BASKET_RECALL_CURRENT_BASKET_ID = 'current-basket';
    const SYSTEM_EVENT_REFRESH_DELAY = 2000;
    const SYSTEM_EVENT_VALID_EVENTS = [
        SpencerNotificationEventTypes.Updated,
        SpencerNotificationEventTypes.CollaboratorAdded,
        SpencerNotificationEventTypes.CollaboratorRemoved
    ];

    return declare('style-guide.v1.file-tray.bar', [_WidgetBase, _Templated], {
        animationFrameId: null,
        apiDocumentFactory: null,
        buttonOpenClose: null,
        constants: {
            COOKIE_HEIGHT: 'SOS_FILE_TRAY_HEIGHT',
            DRAG_NOT_ENTERED: 0,
            DRAG_THRESHOLD: 100,
            TOP_MARGIN: 100,
            MINIMUM_HEIGHT: 300
        },
        containerAddingItem: null,
        containerItemCount: null,
        currentPerson: null,
        data: {},
        dataTransferHelper: null,
        documentViewer: null,
        dragEnterCounter: 0,
        elementDragImage: null,
        elementBasketSidebar: null,
        elementMainView: null,
        elementSavedBasketView: null,
        elementSplitBasketView: null,
        hasBeenOpened: false,
        notification: null,
        items: [],
        uploadingFileIDs: [],
        itemsBeingAddedCount: 0,
        isOpenOnDragEnter: false,
        modelFileTray: null,
        modelFileTrayItem: null,
        modelFileTrayItemCollection: null,
        routeContainer: null,
        splitBasketId: null,
        systemEventTimeout: null,
        templateString: template,
        trackedClientY: 0,
        widgetCurrentFiletray: null,
        widgetBasketSidebar: null,
        widgetRenameBasketDialog: null,
        widgetSavedBasket: null,
        widgetSplitBasket: null,
        widgetSaveBasketDialog: null,
        widgetBasketSelectDialog: null,
        widgetCollaboratorsDialog: null,

        postCreate: function() {
            this.inherited(arguments);

            this.dataTransferHelper = new DataTransferHelper();

            DragCursorSingleton.initialise();
            this._initEvents();
            this._initNotification();
            this._initModels();
            this._initBasketDialogs();
            this._initBasketSidebar();
            this._initBroadcastChannelListener();
            this._initSystemEventSubscription();
            this._initSavedBasket();
            this._initSplitBasket();
            this._initMainView();
            this._initView();
        },

        close: function() {
            fx.animateProperty({
                node: this.domNode,
                properties: {
                    height: 0
                },
                onEnd: () => {
                    this._resize(this._getStoredHeight());
                    domClass.remove(this.domNode, 'open');
                }
            }).play();
        },

        open: function() {
            domClass.add(this.domNode, 'open');

            if (!this.hasBeenOpened) {
                this.hasBeenOpened = true;

                this._fetchSavedBasketCollection();
            }
        },

        getContextButtonContainer: function() {
            return this.widgetCurrentFiletray.getContextButtonContainer();
        },

        getBasketSideBar: function () {
            return this.widgetBasketSidebar;
        },

        addItem: function(md5) {
            this.widgetCurrentFiletray.addItem(md5);
        },

        getItems: function() {
            return this.widgetCurrentFiletray.getItems();
        },

        getSelectedItems: function() {
            return this.widgetCurrentFiletray.getSelectedItems();
        },

        refreshItem: function (md5) {
            this.widgetCurrentFiletray.refreshItem(md5);
        },

        _initEvents: function() {
            on(document, 'dragover', (e) => this.trackedClientY = e.clientY);

            on(window, 'resize', () => {
                const maxHeight = this._calculateMaxHeight();

                if (
                    domStyle.get(this.domNode, 'height') > maxHeight &&
                    maxHeight > this.constants.MINIMUM_HEIGHT
                ) {
                    this._resize(maxHeight);
                }
            });
        },

        _initNotification: function() {
            this.notification = new Notification(
                'style-guide/v1/file-tray/template/notification/',
                {
                    ADD_ITEM_ERROR: 'AddItemError.html',
                    ADD_ITEM_PROGRESS: 'AddItemProgress.html',
                    ADD_ITEM_SUCCESS: 'AddItemSuccess.html',
                    DELETING_BASKET_ERROR: 'DeletingBasketError.html',
                    DELETING_BASKET_PROGRESS: 'DeletingBasketProgress.html',
                    DELETING_BASKET_SUCCESS: 'DeletingBasketSuccess.html',
                    EMPTY_FILE_TRAY_ERROR: 'EmptyFileTrayError.html',
                    FAILED_TO_REFRESH_FILE_TRAY_ERROR: 'FailedToRefreshFileTrayError.html',
                    FAILED_TO_UPLOAD_FILE_ERROR: 'FailedToUploadFile.html',
                    FILE_TOO_LARGE_ERROR: 'FileTooLargeError.html',
                    REMOVE_ITEM_ERROR: 'RemoveItemError.html',
                    REMOVING_BASKET_ERROR: 'RemovingBasketError.html',
                    REMOVING_BASKET_PROGRESS: 'RemovingBasketProgress.html',
                    REMOVING_BASKET_SUCCESS: 'RemovingBasketSuccess.html',
                    SAVING_BASKET_ERROR: 'SavingBasketError.html',
                    SAVING_BASKET_PROGRESS: 'SavingBasketProgress.html',
                    SAVING_BASKET_SUCCESS: 'SavingBasketSuccess.html',
                    SPLIT_BASKET_UNKNOWN_ERROR: 'SplitBasketUnknownError.html',
                    UNSUPPORTED_FILE_ERROR: 'UnsupportedFileError.html',
                    UPDATING_COLLABORATORS_ERROR: 'UpdatingCollaboratorsError.html',
                    UPDATING_COLLABORATORS_PROGRESS: 'UpdatingCollaboratorsProgress.html',
                    UPDATING_COLLABORATORS_SUCCESS: 'UpdatingCollaboratorsSuccess.html'
                }
            );
        },

        _initModels: function() {
            const apiFactory = new APIFactory();
            const ftf = apiFactory.getFileTrayFactory();
            this.apiDocumentFactory = apiFactory.getDocControlDocumentFactory();

            this.modelFileTray = ftf.getFileTray();
            this.modelFileTrayItem = ftf.getItem();
            this.modelFileTrayItemCollection = ftf.getItemCollection();
        },

        openBasket: function (basket) {
            this.widgetBasketSidebar.openBasket(basket);
        },

        _initBasketSidebar: function() {
            this.widgetBasketSidebar = new BasketSidebar({}, this.elementBasketSidebar);
            this.widgetBasketSidebar.on('basket-current', () => {
                this.widgetSavedBasket.hide();
                this.widgetSplitBasket.hide();
                this.widgetCurrentFiletray.show();
            });
            this.widgetBasketSidebar.on('basket-open', (e) => {
                this.widgetCurrentFiletray.hide();
                this.widgetSplitBasket.hide();
                this.widgetSavedBasket.show();
                this.widgetSavedBasket.setBasket(e.basket);
            });
        },

        _initBasketDialogs: function() {
            this.widgetBasketSelectDialog = new BasketSelectDialog({});

            this.widgetSaveBasketDialog = new SaveBasketDialog({
                apiDocumentFactory: this.apiDocumentFactory,
                notification: this.notification
            });

            this.widgetSaveBasketDialog.on('save', () => {
                this._refreshSavedBasketsOnBroadcastChannel();
            });
        },

        _initBroadcastChannelListener: function() {
            const bc = new BroadcastChannel(BroadcastChannelConfig.CHANNEL.SAVED);
            bc.onmessage = (event) => {
                if (event.data === BroadcastChannelConfig.MESSAGE.REFRESH) {
                    this._fetchSavedBasketCollection();
                }
            };
        },

        _initSystemEventSubscription: function() {
            SpencerNotificationSubscriberSingleton.get().subscribe((event) => {
                if (
                    event.system !== SpencerNotificationSystems.Basket ||
                    !SYSTEM_EVENT_VALID_EVENTS.includes(event.event)
                ) {
                    return;
                }

                if (this.systemEventTimeout) return;

                this.systemEventTimeout = setTimeout(() => {
                    this.systemEventTimeout = null;

                    this._refreshSavedBasketsOnBroadcastChannel();
                }, SYSTEM_EVENT_REFRESH_DELAY);
            });
        },

        _initRenameBasketDialog: function() {
            this.widgetRenameBasketDialog = new RenameBasketDialog({
                modelBasket: this.apiDocumentFactory.getBasket(),
                notification: this.notification
            });

            this.widgetRenameBasketDialog.on('save', () => {
                this._refreshSavedBasketsOnBroadcastChannel();
            });
        },

        _initSavedBasket: function() {
            this._initRenameBasketDialog();

            this.widgetSavedBasket = new SavedBasket({
                routeContainer: this.routeContainer,
                currentPerson: this.currentPerson,
                documentViewer: this.documentViewer,
                widgetRenameBasketDialog: this.widgetRenameBasketDialog,
                notification: this.notification
            }, this.elementSavedBasketView);

            this.widgetSavedBasket.on('delete', () => {
                this.widgetBasketSidebar.selectCurrent();
                this.widgetSavedBasket.hide();
                this.widgetCurrentFiletray.show();

                this._refreshSavedBasketsOnBroadcastChannel();
            });
            this.widgetSavedBasket.on('save', this._refreshSavedBasketsOnBroadcastChannel.bind(this));
            this.widgetSavedBasket.on('add-to-current', (data) => {
                this.widgetCurrentFiletray.addItem(data.md5);
            });
            this.widgetSavedBasket.on('split', (basketId, basketName, revisions) => {
                this.splitBasketId = null;
                this.widgetSavedBasket.hide();
                this.widgetSplitBasket.show(basketName, revisions);
                this.splitBasketId = basketId;
                this._recallSplitBasket();
            });
            this.widgetSavedBasket.on('collaborate', (basketId, collaborators, isOwner = true) => {
                if (this.widgetCollaboratorsDialog) {
                    this.widgetCollaboratorsDialog.destroy();
                }

                this.widgetCollaboratorsDialog = new CollaboratorsDialog({
                    readOnly: !isOwner
                });
                this.widgetCollaboratorsDialog.on('save', (added, removed) => {
                    const uid = this.notification.progress('UPDATING_COLLABORATORS_PROGRESS', {});

                    this.widgetCollaboratorsDialog.hide();

                    const promises = [];
                    if (added.length) {
                        promises.push(
                            new Promise((resolve, reject) => {
                                this.apiDocumentFactory.getBasketCollaborator().add(
                                    basketId, added, new Handlers(resolve, reject)
                                );
                            })
                        );
                    }

                    if (removed.length) {
                        promises.push(
                            new Promise((resolve, reject) => {
                                this.apiDocumentFactory.getBasketCollaborator().remove(
                                    basketId, removed, new Handlers(resolve, reject)
                                );
                            })
                        );
                    }

                    Promise.all(promises).then(() => {
                        this._refreshSavedBasketsOnBroadcastChannel();
                        this.notification.success('UPDATING_COLLABORATORS_SUCCESS', {}, uid);
                    }, () => this.notification.error('UPDATING_COLLABORATORS_ERROR', {}, uid));
                });
                this.widgetCollaboratorsDialog.setCollaborators(collaborators);
                this.widgetCollaboratorsDialog.show();
            });
        },

        _initSplitBasket: function() {
            this.widgetSplitBasket = new SplitBasket({}, this.elementSplitBasketView);

            on(this.widgetSplitBasket, 'close', () => {
                this.widgetCurrentFiletray.show();
                this.widgetSplitBasket.hide();
            });
            on(this.widgetSplitBasket, 'change', (baskets) => {
                localForage.setItem(this._splitBasketStorageKeyGenerator(this.splitBasketId), JSON.stringify(baskets));
            });
            on(this.widgetSplitBasket, 'submit', (baskets, collaborators) => {
                this.widgetSplitBasket.showProcessingMessage();

                Promise.all(
                    baskets.map(
                        (basket) => this._createBasket(
                            basket.name,
                            basket.revisions.map((r) => r.getRevisionPK()),
                            collaborators
                        )
                    )
                ).then(
                    () => {
                        localForage.removeItem(this._splitBasketStorageKeyGenerator(this.splitBasketId));
                        this.widgetSplitBasket.showSuccessMessage();
                        this._refreshSavedBasketsOnBroadcastChannel();
                    },
                    () => {
                        this.notification.error('SPLIT_BASKET_UNKNOWN_ERROR', {});
                        this.widgetSplitBasket.showTable();
                    }
                );
            });
        },

        _createBasket: function(name, revisionPKs, collaborators) {
            return new Promise((resolve, reject) => {
                this.apiDocumentFactory.getBasket().save(
                    new BasketVO(null, name),
                    new Handlers(
                        (basket) => this.apiDocumentFactory.getBasketRevisionCollection().save(
                            new Handlers(() => {
                                if (collaborators.length) {
                                    this.apiDocumentFactory.getBasketCollaborator().add(
                                        basket.getId(),
                                        collaborators,
                                        new Handlers(resolve, reject)
                                    );
                                    return;
                                }

                                resolve();
                            }, reject),
                            basket.getId(),
                            revisionPKs
                        ),
                        reject
                    )
                );
            });
        },

        _initMainView: function() {
            this.widgetCurrentFiletray = new CurrentFileTray({
                items: this.items,
                routeContainer: this.routeContainer,
                data: {
                    basketUrl: this.basketUrl
                },
                documentViewer: this.documentViewer,
                notification: this.notification,
                widgetSaveBasketDialog: this.widgetSaveBasketDialog,
                modelFileTray: this.modelFileTray,
                modelFileTrayItem: this.modelFileTrayItem,
                modelFileTrayItemCollection: this.modelFileTrayItemCollection
            }, this.elementMainView);

            this.widgetCurrentFiletray.on('adding-item', () => {
                this.itemsBeingAddedCount++;
                this._showAddingItem();
            });
            this.widgetCurrentFiletray.on('adding-item-complete', () => {
                this.itemsBeingAddedCount--;
                this._hideAddingItem();
            });
            this.widgetCurrentFiletray.on('item-count', data => this._setItemCount(data.count));
            this.widgetCurrentFiletray.on('drop', () => {
                if (!this.isOpenOnDragEnter) {
                    this.close();
                }

                this.isOpenOnDragEnter = false;
                this.dragEnterCounter = 0;
            });
            this.widgetCurrentFiletray.on('add-to-existing-basket', (data) => {
                this.widgetBasketSelectDialog.show((basketPK) => {
                    const uid = this.notification.progress('ADD_ITEM_PROGRESS', {});
                    const onError = () => this.notification.error('ADD_ITEM_ERROR', {}, uid);

                    this.apiDocumentFactory.getBasketRevisionCollection().fetch(
                        new Handlers((revisionCollection) => {
                            this.apiDocumentFactory.getBasketRevisionCollection().save(
                                new Handlers(() => {
                                    this.notification.success('ADD_ITEM_SUCCESS', {}, uid);
                                    this._refreshSavedBasketsOnBroadcastChannel();
                                }, onError),
                                basketPK,
                                [...new Set(revisionCollection.map(r => r.getRevisionPK()).concat(data.revisionPKs))]
                            )
                        }, onError),
                        basketPK
                    );
                });
            });
            this.widgetCurrentFiletray.on('upload-started', (data) => {
                this.uploadingFileIDs.push(data.id);
                this._showAddingItem();
                this.widgetBasketSidebar.startUpload(data.id, data.file.name, data.cancel);
            });
            this.widgetCurrentFiletray.on('upload-progress', (data) => {
                this.widgetBasketSidebar.updateUpload(data.id, data.loaded, data.total);
            });
            this.widgetCurrentFiletray.on('upload-complete', (data) => {
                this.uploadingFileIDs.splice(this.uploadingFileIDs.indexOf(data.id), 1);
                this._hideAddingItem();
                this.widgetBasketSidebar.completeUpload(data.id);
            });
            this.widgetCurrentFiletray.on('upload-error', (data) => {
                this.uploadingFileIDs.splice(this.uploadingFileIDs.indexOf(data.id), 1);
                this._hideAddingItem();
                this.widgetBasketSidebar.errorUpload(data.id);
            });
            this.widgetCurrentFiletray.on('upload-cancel', (data) => {
                this.uploadingFileIDs.splice(this.uploadingFileIDs.indexOf(data.id), 1);
                this._hideAddingItem();
            });
            this.widgetCurrentFiletray.on('split', (basketName, revisions) => {
                this.splitBasketId = null;
                this.widgetCurrentFiletray.hide();
                this.widgetSavedBasket.hide();
                this.widgetSplitBasket.show(basketName, revisions);
                this.splitBasketId = SPLIT_BASKET_RECALL_CURRENT_BASKET_ID;
                this._recallSplitBasket();
            });
            this.widgetCurrentFiletray.on('close', () => this.close());
        },

        _recallSplitBasket: function() {
            localForage.getItem(this._splitBasketStorageKeyGenerator(this.splitBasketId), (err, value) => {
                if (err && !!value) return;

                let basket = null;
                try {
                    basket = JSON.parse(value);
                } catch {
                    console.error('Failed to parse saved split basket');
                }

                if (!basket) return;

                basket.forEach((basket) => {
                    this.widgetSplitBasket.addBasket(basket.name, basket.revisions.map((r) => r.md5));
                });
            });
        },

        _splitBasketStorageKeyGenerator: function(basketId) {
            return 'SPLIT_DOCUMENT_' + basketId;
        },

        _initView: function() {
            this._setItemCount(this.widgetCurrentFiletray.getItems().length);
            this._resize(this._getStoredHeight());
        },

        _fetchSavedBasketCollection: function() {
            return new Promise((resolve, reject) => {
                this.widgetBasketSidebar.showLoadingState();

                this.apiDocumentFactory.getBasketCollection().fetch(
                    new Handlers(
                        (baskets) => {
                            this.widgetBasketSidebar.populate(baskets);
                            this.widgetBasketSelectDialog.setBasketCollection(baskets);
                            this._updateSavedBasketViewOrExit(baskets);

                            resolve();
                        },
                        () => {
                            this.widgetBasketSidebar.showErrorState();
                            reject();
                        }
                    )
                );
            });
        },

        _updateSavedBasketViewOrExit: function(baskets) {
            const displayedBasket = this.widgetSavedBasket.getBasket();
            if (!displayedBasket || this.widgetSavedBasket.isHidden()) return;

            const updatedBasket = baskets.find((b) => b.getId() === displayedBasket.getId());
            if (updatedBasket) {
                this.widgetSavedBasket.setBasket(updatedBasket);
                return;
            }

            this.widgetSavedBasket.hide();
            this.widgetCurrentFiletray.show();
        },

        _getStoredHeight: function() {
            const storedHeight = cookie(this.constants.COOKIE_HEIGHT);
            if (storedHeight && storedHeight > this.constants.MINIMUM_HEIGHT) {
                const maxHeight = this._calculateMaxHeight();

                return storedHeight > maxHeight ? maxHeight : storedHeight;
            }

            return this.constants.MINIMUM_HEIGHT;
        },

        _onDragEnter: function(e) {
            e.preventDefault();

            if (!this._isValidDropEvent(e)) {
                return;
            }

            query(DRAG_CURSOR_CLASS).forEach(function(node) {
                domClass.add(node, DRAG_CURSOR_ACTION_ADD_TO_BASKET);
            });

            if (this.dragEnterCounter === this.constants.DRAG_NOT_ENTERED) {
                this.isOpenOnDragEnter = this._isOpen();
            }

            this.dragEnterCounter++;

            if (!this.isOpenOnDragEnter) {
                this.open();

                this._resize(this.constants.MINIMUM_HEIGHT);
            }
        },

        _onDragLeave: function(e) {
            if (!this._isValidDropEvent(e)) {
                return;
            }

            if (!this._isChild(e.relatedTarget, this.container)) {
                query(DRAG_CURSOR_CLASS).forEach(function (node) {
                    domClass.remove(node, DRAG_CURSOR_ACTION_ADD_TO_BASKET);
                }.bind(this));
            }

            this.dragEnterCounter--;

            if (!this.isOpenOnDragEnter && this.dragEnterCounter === this.constants.DRAG_NOT_ENTERED) {
                this.close();
            }
        },

        _isChild: function(potentialChild, parent) {
            while(potentialChild) {
                if (potentialChild === parent) {
                    return true;
                }
                potentialChild = potentialChild.parentNode;
            }
        },

        _onButtonClick: function() {
            if (domClass.contains(this.domNode, 'open')) {
                this.close();
            } else {
                this.open();
            }
        },

        _onDragStart: function(e) {
            if (!domClass.contains(this.domNode, 'open')) {
                domClass.add(this.domNode, 'open');
                domStyle.set(this.domNode, 'height', '0px');
            }

            domClass.add(this.domNode, 'dragging');

            this._setFireFoxDataTransferRequirement(e.dataTransfer);
            e.dataTransfer.setDragImage(this.elementDragImage, 5, 5);
            e.dataTransfer.dropEffect = 'none';
            e.dataTransfer.effectAllowed = 'none';
        },

        _onDrag: function(e) {
            // e.clientY is not available on FireFox
            const clientY = e.clientY || this.trackedClientY;

            if (clientY && clientY > this.constants.DRAG_THRESHOLD) {
                const newHeight = this._calculateHeight(clientY);
                if (newHeight && newHeight > this.constants.MINIMUM_HEIGHT) {
                    this._resize(newHeight);
                }
            }
        },

        _onDragEnd: function() {
            domClass.remove(this.domNode, 'dragging');

            cookie(this.constants.COOKIE_HEIGHT, domStyle.get(this.domNode, 'height'));
        },

        _isValidDropEvent: function(e) {
            return this.dataTransferHelper.isValidDropEvent(e);
        },

        _setFireFoxDataTransferRequirement: function(dataTransfer) {
            dataTransfer.setData('text', 'no value');
        },

        _calculateMaxHeight: function() {
            return window.innerHeight - this.constants.TOP_MARGIN;
        },

        _calculateHeight: function(mouseYPosition) {
            let adjustment = domStyle.get(this.buttonOpenClose, 'height') / 2;

            return (window.innerHeight - mouseYPosition - adjustment);
        },

        _resize: function(newHeight) {
            window.cancelAnimationFrame(this.animationFrameId);

            this.animationFrameId = window.requestAnimationFrame(function() {
                domStyle.set(this.domNode, 'height', newHeight + 'px');
            }.bind(this));
        },

        _isOpen: function() {
            return domClass.contains(this.domNode, 'open');
        },

        _setItemCount: function(count) {
            this.widgetBasketSidebar.setCurrentBasketCount(count);

            if (!count) {
                html.set(this.containerItemCount, 'No documents in your Current Basket');
                return;
            }

            html.set(this.containerItemCount, count + ' document' + (count > 1 ? 's' : '') + ' in Current Basket');
        },

        _showAddingItem: function() {
            this._setAddingItemText();

            domClass.add(this.containerItemCount, 'hide');
            domClass.remove(this.containerAddingItem, 'hide');
        },

        _hideAddingItem: function() {
            this._setAddingItemText();

            if (this.itemsBeingAddedCount >= 1 || this.uploadingFileIDs.length >= 1) {
                return;
            }

            domClass.remove(this.containerItemCount, 'hide');
            domClass.add(this.containerAddingItem, 'hide');
        },

        _setAddingItemText: function() {
            let text = '';
            if (this.uploadingFileIDs.length > 0) {
                text += 'Uploading and adding'
            } else {
                text += 'Adding';
            }

            html.set(this.containerAddingItem, text + ' item' + (this.itemsBeingAddedCount > 1 || this.uploadingFileIDs.length > 1 ? 's' : '') + '...');
        },

        _refreshSavedBasketsOnBroadcastChannel() {
            const bc = new BroadcastChannel(BroadcastChannelConfig.CHANNEL.SAVED);
            bc.postMessage(BroadcastChannelConfig.MESSAGE.REFRESH);
            bc.close();
        }
    });
});


},
'dojo/cookie':function(){
define(["./_base/kernel", "./regexp"], function(dojo, regexp){

// module:
//		dojo/cookie

/*=====
var __cookieProps = {
	// expires: Date|String|Number?
	//		If a number, the number of days from today at which the cookie
	//		will expire. If a date, the date past which the cookie will expire.
	//		If expires is in the past, the cookie will be deleted.
	//		If expires is omitted or is 0, the cookie will expire when the browser closes.
	// path: String?
	//		The path to use for the cookie.
	// domain: String?
	//		The domain to use for the cookie.
	// secure: Boolean?
	//		Whether to only send the cookie on secure connections
};
=====*/


dojo.cookie = function(/*String*/name, /*String?*/ value, /*__cookieProps?*/ props){
	// summary:
	//		Get or set a cookie.
	// description:
	//		If one argument is passed, returns the value of the cookie
	//		For two or more arguments, acts as a setter.
	// name:
	//		Name of the cookie
	// value:
	//		Value for the cookie
	// props:
	//		Properties for the cookie
	// example:
	//		set a cookie with the JSON-serialized contents of an object which
	//		will expire 5 days from now:
	//	|	require(["dojo/cookie", "dojo/json"], function(cookie, json){
	//	|		cookie("configObj", json.stringify(config, {expires: 5 }));
	//	|	});
	//
	// example:
	//		de-serialize a cookie back into a JavaScript object:
	//	|	require(["dojo/cookie", "dojo/json"], function(cookie, json){
	//	|		config = json.parse(cookie("configObj"));
	//	|	});
	//
	// example:
	//		delete a cookie:
	//	|	require(["dojo/cookie"], function(cookie){
	//	|		cookie("configObj", null, {expires: -1});
	//	|	});
	var c = document.cookie, ret;
	if(arguments.length == 1){
		var matches = c.match(new RegExp("(?:^|; )" + regexp.escapeString(name) + "=([^;]*)"));
		ret = matches ? decodeURIComponent(matches[1]) : undefined; 
	}else{
		props = props || {};
// FIXME: expires=0 seems to disappear right away, not on close? (FF3)  Change docs?
		var exp = props.expires;
		if(typeof exp == "number"){
			var d = new Date();
			d.setTime(d.getTime() + exp*24*60*60*1000);
			exp = props.expires = d;
		}
		if(exp && exp.toUTCString){ props.expires = exp.toUTCString(); }

		value = encodeURIComponent(value);
		var updatedCookie = name + "=" + value, propName;
		for(propName in props){
			updatedCookie += "; " + propName;
			var propValue = props[propName];
			if(propValue !== true){ updatedCookie += "=" + propValue; }
		}
		document.cookie = updatedCookie;
	}
	return ret; // String|undefined
};

dojo.cookie.isSupported = function(){
	// summary:
	//		Use to determine if the current browser supports cookies or not.
	//
	//		Returns true if user allows cookies.
	//		Returns false if user doesn't allow cookies.

	if(!("cookieEnabled" in navigator)){
		this("__djCookieTest__", "CookiesAllowed");
		navigator.cookieEnabled = this("__djCookieTest__") == "CookiesAllowed";
		if(navigator.cookieEnabled){
			this("__djCookieTest__", "", {expires: -1});
		}
	}
	return navigator.cookieEnabled;
};

return dojo.cookie;
});

},
'style-guide/v1/drag-and-drop/CursorSingleton':function(){
define([
    './Cursor'
], function(Cursor) {
    return {
        instance: null,

        initialise: function() {
            if (!this.instance) this.instance = new Cursor();
        },

        get: function() {
            this.initialise();

            return this.instance;
        }
    }
});
},
'style-guide/v1/drag-and-drop/Cursor':function(){
define([
    'dojo/_base/declare',
    'dijit/_WidgetBase',
    'dojo/dom-construct',
    'dojo/query',
    'dojo/text!./template/Cursor.html',
    'soso/sosox/ejs/_Templated'
], function(
    declare,
    _WidgetBase,
    domConstruct,
    query,
    template,
    _Templated
) {
    return declare('style-guide.v1.drag-and-drop.cursor', [_WidgetBase, _Templated], {
        data: {
            classString: '',
            isMultiple: false,
            text: '',
            documentClass: null
        },
        DRAG_CURSOR_OFFSET_X: 7,
        DRAG_CURSOR_OFFSET_Y: 24,
        templateString: template,

        postCreate: function() {
            domConstruct.place(this.domNode, domConstruct.create('div', {}, query('.sos-v1')[0]))
        },

        setIconClass: function(classString) {
            this.data.classString = classString;

            this.render();
        },

        setText: function(text) {
            this.data.text = text;

            this.render();
        },

        setDocumentClass: function(documentClass) {
            this.data.documentClass = documentClass;

            this.render();
        },

        getDragImage: function() {
            return this.domNode;
        },

        getOffsetX: function() {
            return this.DRAG_CURSOR_OFFSET_X;
        },

        getOffsetY: function() {
            return this.DRAG_CURSOR_OFFSET_Y;
        },

        multipleItems: function() {
            this.data.isMultiple = true;

            this.render();
        },

        singleItem: function() {
            this.data.isMultiple = false;

            this.render();
        }
    });
});


},
'style-guide/v1/file-tray/BasketSidebar':function(){
define([
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/Evented',
    'dojo/html',
    'dojo/text!./template/BasketSidebar.html',
    'dojo/query',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated',
    'style-guide/v1/layout/DialogConfirm',
], function(
    declare,
    domAttr,
    domClass,
    _Evented,
    html,
    template,
    query,
    _WidgetBase,
    _Templated,
    DialogConfirm
) {
    return declare([_WidgetBase, _Templated, _Evented], {
        MILLISECONDS_UNTIL_COMPLETED_UPLOAD_IS_REMOVED: 2000,

        templateString: template,
        activeId: null,
        data: {
            currentBasketCount: 0,
            error: false,
            loading: true,
            baskets: [],
            savedBasketsExpanded: true,
            uploadingFiles: [],
            uploadingFilesExpanded: false
        },
        scrollPosition: 0,

        openBasket: function(basket) {
            this.activeId = basket.getId();
            this._markChildActive(basket.getId());

            this.emit('basket-open', {
                basket: basket
            });
        },

        showErrorState: function() {
            this.data.loading = false;
            this.data.error = true;
            this.render();
        },

        showLoadingState: function() {
            this.data.loading = true;
            this.data.error = false;
            this.render();
        },

        populate: function(basketCollection) {
            this.reset();

            this.data.baskets = basketCollection;
            this.data.loading = false;
            this.render();
        },

        reset: function() {
            this.data.error = false;
            this.data.loading = true;
            this.data.baskets = [];
            this.render();
        },

        render: function() {
            this.scrollPosition = this.domNode.scrollTop;

            this.inherited(arguments);

            this.domNode.scrollTop = this.scrollPosition;

            if (!this.loading && !this.error) {
                this.activeId ? this._markChildActive(this.activeId) : this.selectCurrent();
            }
        },

        selectCurrent: function() {
            domClass.add(this.current, 'active');

            this.activeId = null;
            this._markChildrenInactive();
        },

        setCurrentBasketCount: function(count) {
            this.data.currentBasketCount = count;

            this.render();
        },

        startUpload: function(id, name, cancel) {
            this.data.uploadingFilesExpanded = true;

            this.data.uploadingFiles.push({
                id: id,
                name: name,
                progress: 0,
                error: false,
                cancel: cancel
            });

            this.render();
        },

        updateUpload: function(id, loaded, total) {
            const index = this._findUploadingFile(id);
            if (index < 0) return;

            const progress = Math.round((loaded / total) * 100);
            this.data.uploadingFiles[index].progress = progress;
            this._updateUploadProgress(id, progress);
        },

        completeUpload: function(id) {
            const index = this._findUploadingFile(id);
            if (index < 0) return;

            this.data.uploadingFiles[index].progress = 100;
            this._updateUploadProgress(id, 100);

            setTimeout(() => {
                const index = this._findUploadingFile(id);
                if (index < 0) return;
                this.data.uploadingFiles.splice(index, 1);
                this.render();
            }, this.MILLISECONDS_UNTIL_COMPLETED_UPLOAD_IS_REMOVED);
        },

        errorUpload: function(id) {
            const index = this._findUploadingFile(id);
            if (index < 0) return;

            this.data.uploadingFiles[index].error = true;

            this.render();
        },

        _findUploadingFile: function(id) {
            return this.data.uploadingFiles.findIndex((file) => file.id === id);
        },

        _onSidebarItemCurrentClick: function() {
            this.selectCurrent();
            this.emit('basket-current');
        },

        _onSidebarItemSavedBasketsClick: function(e) {
            this.data.savedBasketsExpanded = !this.data.savedBasketsExpanded;

            this.render();
        },

        _onSidebarItemUploadingFilesClick: function(e) {
            this.data.uploadingFilesExpanded = !this.data.uploadingFilesExpanded;

            this.render();
        },

        _onSidebarItemSavedBasketClick: function(e) {
            const id = parseInt(domAttr.get(e.currentTarget, 'data-id'));

            this.activeId = id;
            this._markChildActive(id);

            this.emit('basket-open', {
                basket: this.data.baskets.find((b) => b.getId() === id)
            });
        },

        _onSidebarItemUploadingFileClick: function(e) {
            const index = this._findUploadingFile(domAttr.get(e.target, 'data-id'));
            if (index < 0) return;

            this.confirmDialog?.destroy();
            this.confirmDialog = new DialogConfirm({
                confirmIcon: 'close',
                confirmText: 'Cancel Upload',
                isNegativeAction: true,
                message: 'Cancel upload of ' + this.data.uploadingFiles[index].name + '?',
                title: 'Cancel Upload'
            });

            this.confirmDialog.on('submit', (confirmed) => {
                if (!confirmed) return;

                this.data.uploadingFiles[index].cancel();
                this.data.uploadingFiles.splice(index, 1);
                this.render();
            });

            this.confirmDialog.show();
        },

        _markChildActive: function(id) {
            const basketNode = query(`.file-tray-sidebar-item[data-id="${this.activeId}"]`, this.childContainer)[0];

            if (!basketNode) return;

            domClass.remove(this.current, 'active');
            this._markChildrenInactive();
            domClass.add(basketNode, 'active');
        },

        _markChildrenInactive: function() {
            this.childContainer.childNodes.forEach((child) => {
                domClass.remove(child, 'active');
            });
        },

        _updateUploadProgress: function(id, uploadProgress) {
            const elements = query(`span[data-id-upload-progress="${id}"]`, this.domNode);

            if (!elements || !elements.length) {
                return;
            }

            html.set(elements[0], uploadProgress);
        }
    });
});


},
'style-guide/v1/layout/DialogConfirm':function(){
define([
    'dijit/_WidgetBase',
    'dojo/_base/declare',
    'dojo/Evented',
    'dojo/text!./templates/DialogConfirm.html',
    'soso/sosox/ejs/_Templated',
    'style-guide/v1/layout/Dialog'
], function(
    _WidgetBase,
    declare,
    _Evented,
    template,
    _TemplatedMixin,
    Dialog
) {
    return declare([_WidgetBase, _TemplatedMixin, _Evented], {
        confirmIcon: null,
        confirmText: null,
        data: {
            confirmIcon: null,
            confirmText: null,
            isNegativeAction: null,
            message: null
        },
        dialog: null,
        isNegativeAction: true,
        message: null,
        title: null,
        templateString: template,

        postMixInProperties: function() {
            this.data.confirmIcon = this.confirmIcon;
            this.data.confirmText = this.confirmText;
            this.data.isNegativeAction = this.isNegativeAction;
            this.data.message = this.message;

            this.inherited(arguments);
        },

        postCreate: function() {
            this.inherited(arguments);

            this.dialog = new Dialog({
                contentNode: this.domNode,
                titleString: this.title ?? 'Confirm'
            });
        },

        show: function() {
            this.dialog.show();
        },

        _onCloseClick: function() {
            this.dialog.hide();
            this.emit('submit', false);
        },

        _onConfirmClick: function() {
            this.dialog.hide();
            this.emit('submit', true);
        }
    });
});
},
'style-guide/v1/file-tray/Current':function(){
define([
    'api/Factory',
    'doccontrol/extraction/bulk/Form',
    'dojo/cookie',
    'dojo/dom-attr',
    'dojo/dom-class',
    "dojo/Evented",
    'dojo/html',
    'dojo/store/Memory',
    'dojo/on',
    'dojo/topic',
    'dojo/_base/config',
    'dojo/_base/declare',
    'dojo/text!./template/Current.html',
    'dijit/_WidgetBase',
    'email/dojo/helper/ComposeHash',
    'library/request/data/Form',
    'library/request/data/Handlers',
    'library/request/helper/DefaultUnauthorisedCallback',
    'soso/sosox/ejs/_Templated',
    'spencer/doc-control/data/Revision',
    'spencer/parse/BytesToMegabytes',
    'spencer/utility/RandomStringGenerator',
    'style-guide/v1/doc-control/document/bulk-soft-link/FormPaneWrapper',
    'style-guide/v1/doc-control/document/soft-link/FormPaneWrapper',
    './ContextButtonContainer',
    './DataTransferHelper',
    './ItemCollection',
    './config/BroadcastChannel'
], function(
    APIFactory,
    ExtractionForm,
    cookie,
    domAttr,
    domClass,
    _Evented,
    html,
    Store,
    on,
    topic,
    config,
    declare,
    template,
    _WidgetBase,
    ComposeHash,
    FormData,
    HandlersData,
    DefaultUnauthorisedCallback,
    _Templated,
    Revision,
    BytesToMegabytes,
    RandomStringGenerator,
    BulkSoftLinkFormPane,
    SoftLinkFormPane,
    ContextButtonContainer,
    DataTransferHelper,
    ItemCollection,
    BroadcastChannelConfig
) {
    return declare([_WidgetBase, _Templated, _Evented], {
        templateString: template,
        buttonActionSelectedDocuments: null,
        buttonAddToExistingBasket: null,
        buttonBulkExtract: null,
        buttonBulkExtractDocuments: null,
        buttonBulkSoftLinkDocuments: null,
        buttonCardView: null,
        buttonDownloadCSV: null,
        buttonDownloadZip: null,
        buttonSaveBasket: null,
        buttonSplitBasket: null,
        buttonEmptyFileTray: null,
        buttonRefresh: null,
        buttonSaveSelectedAsNewBasket: null,
        buttonTableView: null,
        constants: {
            API_ERROR_FILE_DELETED: 'file_deleted',
            API_ERROR_UNSUPPORTED_FILE: 'unsupported_file',
            COOKIE_DISPLAY_MODE: 'SOS_FILE_TRAY_DISPLAY_MODE',
            TYPE_REVISION: 'revision',
            TYPE_TEMPORARY_DOCUMENT: 'temporary-document',
            UPLOAD_FORM_ID: 'fileTrayFileUploadForm',
            UPLOAD_FORM_FILE_KEY: 'uploadedFiles[]',
        },
        containerContextButtons: null,
        containerItemCollection: null,
        data: {},
        dataTransferHelper: null,
        elementBodyControls: null,
        elementBodyItems: null,
        elementEmptyState: null,
        inputFile: null,
        items: [],
        itemStore: null,
        modelFile: null,
        modelFileTrayItem: null,
        modelFileTrayItemCollection: null,
        notification: null,
        routeContainer: null,
        textFieldFilter: null,
        widgetBulkSoftLink: null,
        widgetSaveBasketDialog: null,
        widgetSoftLink: null,
        widgetContextButtonContainer: null,
        widgetItemCollection: null,

        postCreate: function() {
            this.dataTransferHelper = new DataTransferHelper();

            this._initStore();
            this._initContextButtonContainer();
            this._initItemCollection();
            this._initView();
            this._initBroadcastChannelListener();
        },

        show: function() {
            domClass.remove(this.domNode, 'hidden');

            this._initView();
        },

        hide: function() {
            domClass.add(this.domNode, 'hidden');
        },

        _initStore: function() {
            this.itemStore = new Store({data: this.items, idProperty: 'id'});
        },

        _initContextButtonContainer: function() {
            this.widgetContextButtonContainer = new ContextButtonContainer({}, this.containerContextButtons);
        },

        _initItemCollection: function() {
            const items = this.itemStore.query();
            this.widgetItemCollection = new ItemCollection({
                items: items,
                itemTotal: items.length,
                closeFileTray: () => {
                    this.emit('close');
                },
                routeContainer: this.routeContainer,
                documentViewer: this.documentViewer
            }, this.containerItemCollection);

            on(this.widgetItemCollection, 'remove', (id) => {
                const removedItem = this.itemStore.get(id);
                this.itemStore.remove(id);
                this._displayItems();

                const onError = () => {
                    this.itemStore.add(removedItem);
                    this._displayItems();

                    this.notification.error('REMOVE_ITEM_ERROR');
                };

                const onSuccess = () => {
                    this._refreshBasketOnBroadcastChannel();
                };

                this.modelFileTrayItem.remove(
                    new HandlersData(
                        onSuccess,
                        function() {},
                        DefaultUnauthorisedCallback,
                        onError,
                        onError,
                        function() {}
                    ),
                    id
                );
            });

            on(this.widgetItemCollection, 'selection-change', function(selectedItems) {
                this.widgetContextButtonContainer.setSelectedItemCount(selectedItems.length);

                if (selectedItems.length) {
                    domAttr.remove(this.buttonActionSelectedDocuments, 'disabled');

                    if (selectedItems.some((item) => item.getType() === this.constants.TYPE_TEMPORARY_DOCUMENT)) {
                        domAttr.remove(this.buttonBulkExtractDocuments, 'disabled');
                        domAttr.set(this.buttonBulkSoftLinkDocuments, 'disabled', 'disabled');
                    } else {
                        domAttr.set(this.buttonBulkExtractDocuments, 'disabled', 'disabled');
                    }

                    if (selectedItems.some((item) => item.getType() === this.constants.TYPE_REVISION)) {
                        domAttr.remove(this.buttonAddToExistingBasket, 'disabled');
                        domAttr.remove(this.buttonBulkSoftLinkDocuments, 'disabled');
                        domAttr.remove(this.buttonSaveSelectedAsNewBasket, 'disabled');
                    } else {
                        domAttr.set(this.buttonAddToExistingBasket, 'disabled', 'disabled');
                        domAttr.set(this.buttonBulkSoftLinkDocuments, 'disabled', 'disabled');
                        domAttr.set(this.buttonSaveSelectedAsNewBasket, 'disabled', 'disabled');
                    }

                    if (selectedItems.every((item) => item.getData().isDeleted)) {
                        domAttr.set(this.buttonDownloadZip, 'disabled', 'disabled');
                    } else {
                        domAttr.remove(this.buttonDownloadZip, 'disabled');
                    }

                } else {
                    this._disableActionSelectedDocumentsDropdown();
                }

            }.bind(this));
        },

        _initView: function() {
            const items = this.itemStore.query();
            if (items.length) this._hideEmptyState();
            domAttr.set(this.buttonDownloadCSV, 'disabled', !items.length);
            domAttr.set(this.buttonEmptyFileTray, 'disabled', !items.length);
            domAttr.set(this.textFieldFilter, 'disabled', !items.length);

            this._determineSplitBasketButtonState();
            this._determineSaveBasketButtonState();

            const storedDisplayMode = cookie(this.constants.COOKIE_DISPLAY_MODE);
            if (storedDisplayMode === this.widgetItemCollection.constants.DISPLAY_MODE_CARD) {
                this._showCardView();
            } else if (storedDisplayMode === this.widgetItemCollection.constants.DISPLAY_MODE_TABLE) {
                this._showTableView();
            }
        },

        _initBroadcastChannelListener: function() {
            const bc = new BroadcastChannel(BroadcastChannelConfig.CHANNEL.CURRENT);
            bc.onmessage = (event) => {
                if (event.data === BroadcastChannelConfig.MESSAGE.REFRESH) {
                    this._onRefreshClick();
                }
            };
        },

        getContextButtonContainer: function() {
            return this.widgetContextButtonContainer;
        },

        getItems: function() {
            return this.itemStore.query();
        },

        getSelectedItems: function() {
            return this.widgetItemCollection.getSelectedItems();
        },

        refreshItem: function (md5) {
            this.itemStore.query(function (element) {
                if (element.data.md5 === md5) {
                    this._onRefreshClick();
                }
            }.bind(this));
        },

        addItem: function(md5) {
            if (!md5) {
                return;
            }

            this.emit('adding-item');

            this.modelFileTrayItem.add(
                new HandlersData(
                    function(item) {
                        this._removeItemByMd5(item);
                        this.itemStore.add(item);

                        this._displayItems();

                        this.emit('adding-item-complete');
                        this._refreshBasketOnBroadcastChannel();
                    }.bind(this),
                    function() {},
                    DefaultUnauthorisedCallback,
                    this._onAddItemError.bind(this),
                    this._onAddItemError.bind(this),
                    function() {}
                ),
                md5
            )
        },

        _refreshBasketOnBroadcastChannel() {
            this.emit('adding-item-complete');
            const bc = new BroadcastChannel(BroadcastChannelConfig.CHANNEL.CURRENT);
            bc.postMessage(BroadcastChannelConfig.MESSAGE.REFRESH);
            bc.close();
        },

        _determineSplitBasketButtonState() {
            domAttr.set(
                this.buttonSplitBasket,
                'disabled',
                !this.itemStore.query(item => item.type === 'revision').length
            );
        },

        _determineSaveBasketButtonState() {
            domAttr.set(
                this.buttonSaveBasket,
                'disabled',
                !this.itemStore.query(item => item.type === 'revision').length
            );
        },

        _bulkExtract: function() {
            new ExtractionForm(
                this.getSelectedItems()
                    .filter((item) => item.getType() === this.constants.TYPE_TEMPORARY_DOCUMENT)
                    .map((item) => item.getData().md5)
            ).setNewTabMode().submit();
        },

        _bulkSoftLink: function() {
            this.emit('close');

            const revisions = this.getSelectedItems()
                .filter((item) => item.getType() === this.constants.TYPE_REVISION)
                .map(
                    (item) => new Revision()
                        .setDocumentPK(item.getData().documentPK)
                        .setRevisionPK(item.getData().revisionPK)
                        .setMd5(item.getData().md5)
                        .setRealName(item.getData().fileName)
                        .setTitle(item.getData().title)
                        .setFileSize(item.getData().fileSize)
                        .setFileType(item.getData().fileType)
                );

            if (revisions.length === 1) {
                this._initSoftLink();
                this.widgetSoftLink.open();
                this.widgetSoftLink.setDocumentPK(revisions[0].getDocumentPK());
                this.widgetSoftLink.reload();
                return;
            }

            this._initBulkSoftLink();
            this.widgetBulkSoftLink.reset();
            this.widgetBulkSoftLink.setRevisions(revisions);
            this.widgetBulkSoftLink.open();
        },

        _initBulkSoftLink: function() {
            if (this.widgetBulkSoftLink) return;

            this.widgetBulkSoftLink = new BulkSoftLinkFormPane();
        },

        _initSoftLink: function() {
            if (this.widgetSoftLink) return;

            this.widgetSoftLink = new SoftLinkFormPane();
        },

        _downloadZip: function() {
            window.open(
                this.routeContainer.get('zipDownload', null, null, {
                    md5: this.getSelectedItems().map((item) => item.getData().md5)
                }),
                '_blank'
            );
        },

        _downloadZipOfPdfs: function() {
            window.open(
                this.routeContainer.get('zipDownload', null, null, {
                    md5: this.getSelectedItems().map((item) => item.getData().md5),
                    converted: true
                }),
                '_blank'
            );
        },

        _emailSelected: function () {
            const revisionPKs = this.getSelectedItems().filter((item) => item.data.type === 'revision').map((item) => item.data.revisionPK);
            const tempDocPKs = this.getSelectedItems().filter((item) => item.data.type === 'temporary-document').map((item) => item.data.temporaryDocumentPK);

            window.open(
                this.routeContainer.get(
                    'emailSelected'
                ) + new ComposeHash().get({revisionPK: revisionPKs, temporaryDocumentPK: tempDocPKs})
            );
        },

        _onDownloadCSVClick: function() {
            window.open(
                this.routeContainer.get('csvDownload'),
                '_blank'
            );
        },

        _onSplitBasketClick: function() {
            this.emit(
                'split',
                'Current Basket',
                Array.from(
                    this.itemStore.query().filter((item) => item.getType() === this.constants.TYPE_REVISION)
                        .map(
                            (item) => new Revision()
                                .setRevisionPK(item.getData().revisionPK)
                                .setMd5(item.getData().md5)
                                .setTitle(item.getData().title)
                                .setFileSize(item.getData().fileSize)
                                .setFileType(item.getData().fileType)
                        )
                )
            );
        },

        _onSaveBasketClick: function() {
            this.widgetSaveBasketDialog.show(
                this.getItems()
                    .filter((item) => item.data.type === 'revision')
                    .map((item) => item.data.revisionPK)
            );
        },

        _saveSelectedAsNewBasketClick: function () {
            this.widgetSaveBasketDialog.show(
                this.getSelectedItems()
                    .filter((item) => item.data.type === 'revision')
                    .map((item) => item.data.revisionPK)
            );
        },

        _addToExistingBasketClick: function () {
            const revisionPKs = this.getSelectedItems()
                .filter((item) => item.data.type === 'revision')
                .map((item) => item.data.revisionPK);

            this.emit('add-to-existing-basket', {revisionPKs: revisionPKs});
        },

        _onAddItemError: function(error, description) {
            this.emit('adding-item-complete');

            if (error === this.constants.API_ERROR_UNSUPPORTED_FILE) {
                this.notification.error('UNSUPPORTED_FILE_ERROR', {});
            } else if (error === this.constants.API_ERROR_FILE_DELETED) {
                topic.publish(
                    'sos-system-notification',
                    description,
                    'error',
                    0
                );
            }
        },

        _removeItemByMd5: function(item) {
            this.itemStore.query((element) => {
                if (element && element.data.md5 === item.getData().md5) {
                    this.itemStore.remove(element.id);
                }
            });
        },

        _onFilterInput: function() {
            this._displayItems();
        },

        _onBulkExtractClick: function() {
            let documentsToExtract = [];
            this.getSelectedItems().forEach(function (item) {
                if (item.getType() === this.constants.TYPE_TEMPORARY_DOCUMENT) {
                    documentsToExtract.push(item.getData().md5);
                }
            }.bind(this));

            new ExtractionForm(documentsToExtract).submit();
        },

        _onEmptyFileTrayClick: function() {
            const removedItems = this.itemStore.query();
            this.itemStore.setData([]);
            this.itemsBeingAddedCount = 0;
            this._displayItems();
            this._disableActionSelectedDocumentsDropdown();

            let onError = () => {
                this.itemStore.setData(removedItems);
                this._displayItems();

                this.notification.error('EMPTY_FILE_TRAY_ERROR');
            };

            const onSuccess = () => {
                this._refreshBasketOnBroadcastChannel();
            }

            this.modelFileTray.removeAllItems(
                new HandlersData(
                    onSuccess,
                    function() {},
                    DefaultUnauthorisedCallback,
                    onError,
                    onError,
                    function() {}
                )
            );
        },

        _onRefreshClick: function() {
            this._showRefreshing();

            let onError = () => {
                this._hideRefreshing();

                this.notification.error('FAILED_TO_REFRESH_FILE_TRAY_ERROR');
            };

            this.modelFileTrayItemCollection.fetch(
                new HandlersData(
                    function success(items) {
                        this._hideRefreshing();

                        this.itemStore.setData(items);

                        this._displayItems();
                    }.bind(this),
                    function() {},
                    DefaultUnauthorisedCallback,
                    onError,
                    onError,
                    function() {}
                )
            );
        },

        _onUploadFileClick: function() {
            this.inputFile.click();
        },

        _onInputFileChange: function(e) {
            if (!e || !e.target || e.target.files.length === 0) {
                return;
            }

            this._uploadFiles(e.target.files);
        },

        _onCardViewClick: function() {
            cookie(this.constants.COOKIE_DISPLAY_MODE, this.widgetItemCollection.constants.DISPLAY_MODE_CARD);

            this._showCardView();
        },

        _onTableViewClick: function() {
            cookie(this.constants.COOKIE_DISPLAY_MODE, this.widgetItemCollection.constants.DISPLAY_MODE_TABLE);

            this._showTableView();
        },

        _onSelectAllClick: function() {
            this.widgetItemCollection.selectAll();
        },

        _onSelectNoneClick: function() {
            this.widgetItemCollection.selectNone();
        },

        _showCardView: function() {
            this.widgetItemCollection.setDisplayMode(this.widgetItemCollection.constants.DISPLAY_MODE_CARD);

            domClass.add(this.buttonCardView, 'hide');
            domClass.remove(this.buttonTableView, 'hide');
        },

        _showTableView: function() {
            this.widgetItemCollection.setDisplayMode(this.widgetItemCollection.constants.DISPLAY_MODE_TABLE);

            domClass.remove(this.buttonCardView, 'hide');
            domClass.add(this.buttonTableView, 'hide');
        },

        _displayItems: function() {
            const filterValue = domAttr.get(this.textFieldFilter, 'value').toLowerCase();

            let query = null;
            if (filterValue) {
                query = (item) => {
                    if (!this._isFilteringSupported(item)) {
                        return false;
                    }

                    return this._getItemFilterProperty(item).toLowerCase().indexOf(filterValue) >= 0;
                };
            }

            let total = this.itemStore.query().length;
            let items = this.itemStore.query(query);

            this.widgetItemCollection.setItemTotal(total);
            this.widgetItemCollection.setItems(items);

            domAttr.set(this.buttonDownloadCSV, 'disabled', !total);
            domAttr.set(this.buttonEmptyFileTray, 'disabled', !total);
            domAttr.set(this.textFieldFilter, 'disabled', !total);
            if (total) {
                this._hideEmptyState();
            } else {
                this._showEmptyState();
            }

            this._determineSplitBasketButtonState();
            this._determineSaveBasketButtonState();

            this.emit('item-count', {count: total});
        },

        _isFilteringSupported: function(item) {
            return item.getType() === this.constants.TYPE_REVISION ||
                item.getType() === this.constants.TYPE_TEMPORARY_DOCUMENT;
        },

        _getItemFilterProperty: function(item) {
            if (
                item.getType() === this.constants.TYPE_REVISION ||
                item.getType() === this.constants.TYPE_TEMPORARY_DOCUMENT
            ) {
                return item.getData().fileName;
            }

            console.error('Unsupported file tray item type: ' + item.getType());
        },

        _hideEmptyState: function() {
            this.widgetContextButtonContainer.show();
            domClass.remove(this.elementEmptyState, 'sos-empty-state-show');
            domClass.remove(this.elementBodyControls, 'hide');
        },

        _showEmptyState: function() {
            this.widgetContextButtonContainer.hide();
            domClass.add(this.elementEmptyState, 'sos-empty-state-show');
            domClass.add(this.elementBodyControls, 'hide');
        },

        _hideRefreshing: function() {
            domClass.remove(this.buttonRefresh, 'sos-icon-animation-spin-smooth-before');
            domAttr.set(this.buttonRefresh, 'disabled', false);
            html.set(this.buttonRefresh, 'Refresh');
        },

        _showRefreshing: function() {
            domClass.add(this.buttonRefresh, 'sos-icon-animation-spin-smooth-before');
            domAttr.set(this.buttonRefresh, 'disabled', true);
            html.set(this.buttonRefresh, 'Refreshing');
        },

        _onBodyDragOver: function(e) {
            e.preventDefault();

            if (!this._isValidDropEvent(e)) {
                return;
            }

            domClass.add(this.elementBodyItems, 'highlight');
        },

        _onBodyDragLeave: function(e) {
            e.preventDefault();

            domClass.remove(this.elementBodyItems, 'highlight');
        },

        _onBodyDrop: function(e) {
            e.preventDefault();

            domClass.remove(this.elementBodyItems, 'highlight');

            if (!this._isValidDropEvent(e)) {
                return;
            }

            this.emit('drop');

            this.dragEnterCounter = 0;

            if (e.dataTransfer.files.length) {
                this._uploadFiles(e.dataTransfer.files);
                return;
            }

            if (!this.dataTransferHelper.isValid(e.dataTransfer)) {
                this.notification.error('ADD_ITEM_ERROR', {});
                return;
            }

            let data = this.dataTransferHelper.parse(e.dataTransfer);

            if (data.length) {
                for (let i = 0; i < data.length; i++) {
                    this.addItem(data[i]['md5']);
                }
            } else {
                this.addItem(data['md5']);
            }
        },

        _isValidDropEvent: function(e) {
            return this.dataTransferHelper.isValidDropEvent(e);
        },

        _disableActionSelectedDocumentsDropdown: function() {
            domAttr.set(this.buttonActionSelectedDocuments, 'disabled', 'disabled');
        },

        _uploadFiles: function(files) {
            for(let file of files) {
                if (file.size >= config.uploadMaxFilesize) {
                    this._showFileSizeError(file);
                    continue;
                }

                this._uploadFile(file);
            }
        },

        _showFileSizeError: function(file) {
            this.notification.error(
                'FILE_TOO_LARGE_ERROR',
                {
                    fileName: file.name,
                    uploadLimitMegabytes: (new BytesToMegabytes()).convert(config.uploadMaxFilesize, true)
                }
            );
        },

        _uploadFile: function(file) {
            const id = (new RandomStringGenerator()).generate() + '_file-tray-upload';

            const onError = function() {
                this.emit('upload-error', {id: id});
                this.notification.error('FAILED_TO_UPLOAD_FILE_ERROR');
            }.bind(this);

            const p = this._getTemporaryFileUploader().upload(
                new HandlersData(
                    function(temporaryFileResults) {
                        this.emit('upload-complete', {id: id});

                        if (temporaryFileResults.length === 0) {
                            return;
                        }

                        if (!temporaryFileResults[0].getRevisionPK()) {
                            this._getTemporaryDocumentCreator().create(
                                new HandlersData(
                                    function() {
                                        this.addItem(temporaryFileResults[0].getMD5());
                                    }.bind(this),
                                    function (loaded, total) {},
                                    onError,
                                    onError,
                                    onError
                                ),
                                [temporaryFileResults[0].getKey()]
                            );
                            return;
                        }

                        this.addItem(temporaryFileResults[0].getMD5());
                    }.bind(this),
                    function(loaded, total) {
                        this.emit('upload-progress', {id: id, loaded: loaded, total: total});
                    }.bind(this),
                    onError,
                    onError,
                    onError
                ),
                (new FormData()).setId(this.constants.UPLOAD_FORM_ID)
                    .setFiles([file])
                    .setFileKey(this.constants.UPLOAD_FORM_FILE_KEY)
            );

            this.emit('upload-started', {id: id, file: file, cancel: () => {
                this.emit('upload-cancel', {id: id});
                p.cancel();
            }});
        },

        _getTemporaryFileUploader: function () {
            return (new APIFactory()).getFileFactory().getTemporaryUploader();
        },

        _getTemporaryDocumentCreator: function() {
            return (new APIFactory()).getDocControlDocumentFactory().getTemporaryDocumentCreator();
        }
    });
});
},
'doccontrol/extraction/bulk/Form':function(){
define([], function() {
    const EXTRACTION_ROUTE = '/doc-control/extraction';

    return class Form {
        constructor(md5Collection) {
            this.md5Collection = md5Collection;
            this.newTabMode = false;
        }

        setNewTabMode() {
            this.newTabMode = true;
            return this;
        }

        submit() {
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = EXTRACTION_ROUTE;

            if (this.newTabMode) {
                form.target = '_blank';
            }

            for (let i = 0; i < this.md5Collection.length; i++) {
                const field = document.createElement('input');
                field.type = 'hidden';
                field.name = 'md5[]';
                field.value = this.md5Collection[i];

                form.appendChild(field);
            }

            document.body.appendChild(form);

            form.submit();
        }
    }
});
},
'dojo/store/Memory':function(){
define(["../_base/declare", "./util/QueryResults", "./util/SimpleQueryEngine" /*=====, "./api/Store" =====*/],
function(declare, QueryResults, SimpleQueryEngine /*=====, Store =====*/){

// module:
//		dojo/store/Memory

// No base class, but for purposes of documentation, the base class is dojo/store/api/Store
var base = null;
/*===== base = Store; =====*/

return declare("dojo.store.Memory", base, {
	// summary:
	//		This is a basic in-memory object store. It implements dojo/store/api/Store.
	constructor: function(options){
		// summary:
		//		Creates a memory object store.
		// options: dojo/store/Memory
		//		This provides any configuration information that will be mixed into the store.
		//		This should generally include the data property to provide the starting set of data.
		for(var i in options){
			this[i] = options[i];
		}
		this.setData(this.data || []);
	},
	// data: Array
	//		The array of all the objects in the memory store
	data:null,

	// idProperty: String
	//		Indicates the property to use as the identity property. The values of this
	//		property should be unique.
	idProperty: "id",

	// index: Object
	//		An index of data indices into the data array by id
	index:null,

	// queryEngine: Function
	//		Defines the query engine to use for querying the data store
	queryEngine: SimpleQueryEngine,
	get: function(id){
		// summary:
		//		Retrieves an object by its identity
		// id: Number
		//		The identity to use to lookup the object
		// returns: Object
		//		The object in the store that matches the given id.
		return this.data[this.index[id]];
	},
	getIdentity: function(object){
		// summary:
		//		Returns an object's identity
		// object: Object
		//		The object to get the identity from
		// returns: Number
		return object[this.idProperty];
	},
	put: function(object, options){
		// summary:
		//		Stores an object
		// object: Object
		//		The object to store.
		// options: dojo/store/api/Store.PutDirectives?
		//		Additional metadata for storing the data.  Includes an "id"
		//		property if a specific id is to be used.
		// returns: Number
		var data = this.data;
		var index = this.index;
		var idProperty = this.idProperty;
		var id = object[idProperty] = (options && "id" in options) ?
			options.id : idProperty in object ? object[idProperty] : Math.random();
		var defaultDestination = data.length;
		var newIndex;
		var previousIndex;
		var eventType = id in index ? "update" : "add";

		if(eventType === "update"){
			if(options && options.overwrite === false){
				throw new Error("Object already exists");
			}
			else{
				previousIndex = index[id];
				defaultDestination = previousIndex;
			}
		}

		if(options && "before" in options){
			if(options.before == null){
				newIndex = data.length;
				if(eventType === "update"){
					--newIndex;
				}
			}
			else{
				newIndex = index[this.getIdentity(options.before)];
				// Account for the removed item
				if(previousIndex < newIndex){
					--newIndex;
				}
			}
		}
		else{
			newIndex = defaultDestination;
		}

		if(newIndex === previousIndex){
			data[newIndex] = object;
		}
		else{
			if(previousIndex !== undefined){
				data.splice(previousIndex, 1);
			}
			data.splice(newIndex, 0, object);
			this._rebuildIndex(previousIndex === undefined ? newIndex : Math.min(previousIndex, newIndex));
		}

		return id;
	},
	add: function(object, options){
		// summary:
		//		Creates an object, throws an error if the object already exists
		// object: Object
		//		The object to store.
		// options: dojo/store/api/Store.PutDirectives?
		//		Additional metadata for storing the data.  Includes an "id"
		//		property if a specific id is to be used.
		// returns: Number
		(options = options || {}).overwrite = false;
		// call put with overwrite being false
		return this.put(object, options);
	},
	remove: function(id){
		// summary:
		//		Deletes an object by its identity
		// id: Number
		//		The identity to use to delete the object
		// returns: Boolean
		//		Returns true if an object was removed, falsy (undefined) if no object matched the id
		var index = this.index;
		var data = this.data;
		if(id in index){
			data.splice(index[id], 1);
			this.index = {};
			this._rebuildIndex();
			return true;
		}
	},
	query: function(query, options){
		// summary:
		//		Queries the store for objects.
		// query: Object
		//		The query to use for retrieving objects from the store.
		// options: dojo/store/api/Store.QueryOptions?
		//		The optional arguments to apply to the resultset.
		// returns: dojo/store/api/Store.QueryResults
		//		The results of the query, extended with iterative methods.
		//
		// example:
		//		Given the following store:
		//
		// 	|	var store = new Memory({
		// 	|		data: [
		// 	|			{id: 1, name: "one", prime: false },
		//	|			{id: 2, name: "two", even: true, prime: true},
		//	|			{id: 3, name: "three", prime: true},
		//	|			{id: 4, name: "four", even: true, prime: false},
		//	|			{id: 5, name: "five", prime: true}
		//	|		]
		//	|	});
		//
		//	...find all items where "prime" is true:
		//
		//	|	var results = store.query({ prime: true });
		//
		//	...or find all items where "even" is true:
		//
		//	|	var results = store.query({ even: true });
		return QueryResults(this.queryEngine(query, options)(this.data));
	},
	setData: function(data){
		// summary:
		//		Sets the given data as the source for this store, and indexes it
		// data: Object[]
		//		An array of objects to use as the source of data.
		if(data.items){
			// just for convenience with the data format IFRS expects
			this.idProperty = data.identifier || this.idProperty;
			data = this.data = data.items;
		}else{
			this.data = data;
		}
		this.index = {};
		this._rebuildIndex();
	},
	_rebuildIndex: function(startIndex){
		var data = this.data;
		var dataLength = data.length;
		var i;

		startIndex = startIndex || 0;

		for(i = startIndex; i < dataLength; i++){
			this.index[data[i][this.idProperty]] = i;
		}
	}
});

});

},
'dojo/store/util/QueryResults':function(){
define(["../../_base/array", "../../_base/lang", "../../when"
], function(array, lang, when){

// module:
//		dojo/store/util/QueryResults

var QueryResults = function(results){
	// summary:
	//		A function that wraps the results of a store query with additional
	//		methods.
	// description:
	//		QueryResults is a basic wrapper that allows for array-like iteration
	//		over any kind of returned data from a query.  While the simplest store
	//		will return a plain array of data, other stores may return deferreds or
	//		promises; this wrapper makes sure that *all* results can be treated
	//		the same.
	//
	//		Additional methods include `forEach`, `filter` and `map`.
	// results: Array|dojo/promise/Promise
	//		The result set as an array, or a promise for an array.
	// returns:
	//		An array-like object that can be used for iterating over.
	// example:
	//		Query a store and iterate over the results.
	//
	//	|	store.query({ prime: true }).forEach(function(item){
	//	|		//	do something
	//	|	});

	if(!results){
		return results;
	}

	var isPromise = !!results.then;
	// if it is a promise it may be frozen
	if(isPromise){
		results = lang.delegate(results);
	}
	function addIterativeMethod(method){
		// Always add the iterative methods so a QueryResults is
		// returned whether the environment is ES3 or ES5
		results[method] = function(){
			var args = arguments;
			var result = when(results, function(results){
				Array.prototype.unshift.call(args, results);
				return QueryResults(array[method].apply(array, args));
			});
			// forEach should only return the result of when()
			// when we're wrapping a promise
			if(method !== "forEach" || isPromise){
				return result;
			}
		};
	}

	addIterativeMethod("forEach");
	addIterativeMethod("filter");
	addIterativeMethod("map");
	if(results.total == null){
		results.total = when(results, function(results){
			return results.length;
		});
	}
	return results; // Object
};

lang.setObject("dojo.store.util.QueryResults", QueryResults);

return QueryResults;

});

},
'dojo/store/util/SimpleQueryEngine':function(){
define(["../../_base/array" /*=====, "../api/Store" =====*/], function(arrayUtil /*=====, Store =====*/){

// module:
//		dojo/store/util/SimpleQueryEngine

return function(query, options){
	// summary:
	//		Simple query engine that matches using filter functions, named filter
	//		functions or objects by name-value on a query object hash
	//
	// description:
	//		The SimpleQueryEngine provides a way of getting a QueryResults through
	//		the use of a simple object hash as a filter.  The hash will be used to
	//		match properties on data objects with the corresponding value given. In
	//		other words, only exact matches will be returned.
	//
	//		This function can be used as a template for more complex query engines;
	//		for example, an engine can be created that accepts an object hash that
	//		contains filtering functions, or a string that gets evaluated, etc.
	//
	//		When creating a new dojo.store, simply set the store's queryEngine
	//		field as a reference to this function.
	//
	// query: Object
	//		An object hash with fields that may match fields of items in the store.
	//		Values in the hash will be compared by normal == operator, but regular expressions
	//		or any object that provides a test() method are also supported and can be
	//		used to match strings by more complex expressions
	//		(and then the regex's or object's test() method will be used to match values).
	//
	// options: dojo/store/api/Store.QueryOptions?
	//		An object that contains optional information such as sort, start, and count.
	//
	// returns: Function
	//		A function that caches the passed query under the field "matches".  See any
	//		of the "query" methods on dojo.stores.
	//
	// example:
	//		Define a store with a reference to this engine, and set up a query method.
	//
	//	|	var myStore = function(options){
	//	|		//	...more properties here
	//	|		this.queryEngine = SimpleQueryEngine;
	//	|		//	define our query method
	//	|		this.query = function(query, options){
	//	|			return QueryResults(this.queryEngine(query, options)(this.data));
	//	|		};
	//	|	};

	// create our matching query function
	switch(typeof query){
		default:
			throw new Error("Can not query with a " + typeof query);
		case "object": case "undefined":
			var queryObject = query;
			query = function(object){
				for(var key in queryObject){
					var required = queryObject[key];
					if(required && required.test){
						// an object can provide a test method, which makes it work with regex
						if(!required.test(object[key], object)){
							return false;
						}
					}else if(required != object[key]){
						return false;
					}
				}
				return true;
			};
			break;
		case "string":
			// named query
			if(!this[query]){
				throw new Error("No filter function " + query + " was found in store");
			}
			query = this[query];
			// fall through
		case "function":
			// fall through
	}
	function execute(array){
		// execute the whole query, first we filter
		var results = arrayUtil.filter(array, query);
		// next we sort
		var sortSet = options && options.sort;
		if(sortSet){
			results.sort(typeof sortSet == "function" ? sortSet : function(a, b){
				for(var sort, i=0; sort = sortSet[i]; i++){
					var aValue = a[sort.attribute];
					var bValue = b[sort.attribute];
					// valueOf enables proper comparison of dates
					aValue = aValue != null ? aValue.valueOf() : aValue;
					bValue = bValue != null ? bValue.valueOf() : bValue;
					if (aValue != bValue){
						return !!sort.descending == (aValue == null || aValue > bValue) ? -1 : 1;
					}
				}
				return 0;
			});
		}
		// now we paginate
		if(options && (options.start || options.count)){
			var total = results.length;
			results = results.slice(options.start || 0, (options.start || 0) + (options.count || Infinity));
			results.total = total;
		}
		return results;
	}
	execute.matches = query;
	return execute;
};

});

},
'email/dojo/helper/ComposeHash':function(){
define([
    'email/config/Routes',
    'email/helper/HashRouteGeneratorSingleton',
    '@app/url/helper/ParamStringGenerator'
], function(
    ROUTES,
    HashRouteGeneratorSingleton,
    ParamStringGenerator
) {
    const ComposeHash = function(routePrefix) {
        if (routePrefix) {
            HashRouteGeneratorSingleton.setRoutePrefix(routePrefix);
        }
        this.hashRouteGenerator = HashRouteGeneratorSingleton.get();
        this.paramStringGenerator = new ParamStringGenerator();
    };

    ComposeHash.prototype.get = function(params) {
        return this.hashRouteGenerator.generate(ROUTES.COMPOSE) + this.paramStringGenerator.generate(params);
    };

    return ComposeHash;
});
},
'email/config/Routes':function(){
define([], function() {
    return {
        COMPOSE: 'compose',
        COMPOSE_DATA: 'compose\/(.+)',
        ERROR: 'error',
        ERROR_CUSTOM: 'error/:errorType',
        FOLDER_CUSTOM: 'folder/:folderId',
        FOLDER_CUSTOM_PAGE: 'folder/:folderId/page/:page',
        FOLDER_CUSTOM_SORT: 'folder/:folderId/page/:page/sort-column/:sortColumn/sort-desc/:sortDesc/filter/:filter',
        FOLDER_DRAFTS: 'drafts',
        FOLDER_DRAFTS_PAGE: 'drafts/page/:page',
        FOLDER_DRAFTS_SORT: 'drafts/page/:page/sort-column/:sortColumn/sort-desc/:sortDesc/filter/:filter',
        FOLDER_INBOX: 'inbox',
        FOLDER_INBOX_PAGE: 'inbox/page/:page',
        FOLDER_INBOX_SORT: 'inbox/page/:page/sort-column/:sortColumn/sort-desc/:sortDesc/filter/:filter',
        FOLDER_SENT: 'sent',
        FOLDER_SENT_PAGE: 'sent/page/:page',
        FOLDER_SENT_SORT: 'sent/page/:page/sort-column/:sortColumn/sort-desc/:sortDesc/filter/:filter',
        FOLDER_TRASH: 'trash',
        FOLDER_TRASH_PAGE: 'trash/page/:page',
        FOLDER_TRASH_SORT: 'trash/page/:page/sort-column/:sortColumn/sort-desc/:sortDesc/filter/:filter',
        MESSAGE: 'folder/:folderId/message/:messageId',
        MESSAGE_ACTION_FORWARD: 'folder/:folderId/message/:messageId/forward',
        MESSAGE_ACTION_FORWARD_INSECURE_CONTENT: 'folder/:folderId/message/:messageId/forward-with-insecure-content',
        MESSAGE_ACTION_REPLY: 'folder/:folderId/message/:messageId/reply',
        MESSAGE_ACTION_REPLY_EXCLUDED: 'folder/:folderId/message/:messageId/reply/*exclude',
        MESSAGE_ACTION_REPLY_INSECURE_CONTENT: 'folder/:folderId/message/:messageId/reply-with-insecure-content',
        MESSAGE_ACTION_REPLY_INSECURE_CONTENT_EXCLUDED: 'folder/:folderId/message/:messageId/reply-with-insecure-content/*exclude',
        MESSAGE_ACTION_REPLY_ALL: 'folder/:folderId/message/:messageId/reply-all',
        MESSAGE_ACTION_REPLY_ALL_EXCLUDED: 'folder/:folderId/message/:messageId/reply-all/*exclude',
        MESSAGE_ACTION_REPLY_ALL_INSECURE_CONTENT: 'folder/:folderId/message/:messageId/reply-all-with-insecure-content',
        MESSAGE_ACTION_REPLY_ALL_INSECURE_CONTENT_EXCLUDED: 'folder/:folderId/message/:messageId/reply-all-with-insecure-content/*exclude',
        MESSAGE_DRAFTS: 'drafts/message/:uid',
        MESSAGE_EMPTY: 'folder/:folderId/message-empty',
        MESSAGE_INBOX: 'inbox/message/:messageId',
        MESSAGE_INBOX_ACTION_FORWARD: 'inbox/message/:messageId/forward',
        MESSAGE_INBOX_ACTION_FORWARD_INSECURE_CONTENT: 'inbox/message/:messageId/forward-with-insecure-content',
        MESSAGE_INBOX_ACTION_REPLY: 'inbox/message/:messageId/reply',
        MESSAGE_INBOX_ACTION_REPLY_EXCLUDED: 'inbox/message/:messageId/reply/*exclude',
        MESSAGE_INBOX_ACTION_REPLY_INSECURE_CONTENT: 'inbox/message/:messageId/reply-with-insecure-content',
        MESSAGE_INBOX_ACTION_REPLY_INSECURE_CONTENT_EXCLUDED: 'inbox/message/:messageId/reply-with-insecure-content/*exclude',
        MESSAGE_INBOX_ACTION_REPLY_ALL: 'inbox/message/:messageId/reply-all',
        MESSAGE_INBOX_ACTION_REPLY_ALL_EXCLUDED: 'inbox/message/:messageId/reply-all/*exclude',
        MESSAGE_INBOX_ACTION_REPLY_ALL_INSECURE_CONTENT: 'inbox/message/:messageId/reply-all-with-insecure-content',
        MESSAGE_INBOX_ACTION_REPLY_ALL_INSECURE_CONTENT_EXCLUDED: 'inbox/message/:messageId/reply-all-with-insecure-content/*exclude',
        MESSAGE_INBOX_THREAD: 'inbox/message/:messageId/thread',
        MESSAGE_READ_ONLY: 'folder/:folderId/message/:messageId/date/:date/mailbox/:mailbox/read-only',
        MESSAGE_SEARCH_RESULT: 'folder/:folderId/message/:messageId/date/:date/mailbox/:mailbox',
        MESSAGE_SENT: 'sent/message/:messageId',
        MESSAGE_SENT_ACTION_FORWARD: 'sent/message/:messageId/forward',
        MESSAGE_SENT_ACTION_FORWARD_INSECURE_CONTENT: 'sent/message/:messageId/forward-with-insecure-content',
        MESSAGE_SENT_ACTION_REPLY: 'sent/message/:messageId/reply',
        MESSAGE_SENT_ACTION_REPLY_EXCLUDED: 'sent/message/:messageId/reply/*exclude',
        MESSAGE_SENT_ACTION_REPLY_INSECURE_CONTENT: 'sent/message/:messageId/reply-with-insecure-content',
        MESSAGE_SENT_ACTION_REPLY_INSECURE_CONTENT_EXCLUDED: 'sent/message/:messageId/reply-with-insecure-content/*exclude',
        MESSAGE_SENT_ACTION_REPLY_ALL: 'sent/message/:messageId/reply-all',
        MESSAGE_SENT_ACTION_REPLY_ALL_EXCLUDED: 'sent/message/:messageId/reply-all/*exclude',
        MESSAGE_SENT_ACTION_REPLY_ALL_INSECURE_CONTENT: 'sent/message/:messageId/reply-all-with-insecure-content',
        MESSAGE_SENT_ACTION_REPLY_ALL_INSECURE_CONTENT_EXCLUDED: 'sent/message/:messageId/reply-all-with-insecure-content/*exclude',
        MESSAGE_THREAD: 'folder/:folderId/message/:messageId/thread',
        MESSAGE_TRASH: 'trash/message/:messageId',
        MESSAGE_TRASH_ACTION_FORWARD: 'trash/message/:messageId/forward',
        MESSAGE_TRASH_ACTION_FORWARD_INSECURE_CONTENT: 'trash/message/:messageId/forward-with-insecure-content',
        MESSAGE_TRASH_ACTION_REPLY: 'trash/message/:messageId/reply',
        MESSAGE_TRASH_ACTION_REPLY_EXCLUDED: 'trash/message/:messageId/reply/*exclude',
        MESSAGE_TRASH_ACTION_REPLY_INSECURE_CONTENT: 'trash/message/:messageId/reply-with-insecure-content',
        MESSAGE_TRASH_ACTION_REPLY_INSECURE_CONTENT_EXCLUDED: 'trash/message/:messageId/reply-with-insecure-content/*exclude',
        MESSAGE_TRASH_ACTION_REPLY_ALL: 'trash/message/:messageId/reply-all',
        MESSAGE_TRASH_ACTION_REPLY_ALL_EXCLUDED: 'trash/message/:messageId/reply-all/*exclude',
        MESSAGE_TRASH_ACTION_REPLY_ALL_INSECURE_CONTENT: 'trash/message/:messageId/reply-all-with-insecure-content',
        MESSAGE_TRASH_ACTION_REPLY_ALL_INSECURE_CONTENT_EXCLUDED: 'trash/message/:messageId/reply-all-with-insecure-content/*exclude',
        SEARCH: 'search',
        SEARCH_ADVANCED: 'search-advanced',
        SEARCH_QUERY: 'search\/(.+)',
        SETTINGS_MAIL_FILTERS: 'settings/mail-filters',
        SETTINGS_OUT_OF_OFFICE: 'settings/out-of-office'
    };
});
},
'email/helper/HashRouteGeneratorSingleton':function(){
define([
    './HashRouteGenerator'
], function(
    HashRouteGenerator
) {
    return {
        routePrefix: '',
        hashRouteGenerator: null,

        setRoutePrefix: function(routePrefix) {
            if (routePrefix !== this.routePrefix) {
                this.hashRouteGenerator = null;
            }

            this.routePrefix = routePrefix;
            return this;
        },

        get: function() {
            if (!this.hashRouteGenerator) {
                this.hashRouteGenerator = new HashRouteGenerator(this.routePrefix);
            }

            return this.hashRouteGenerator;
        }
    };
});
},
'email/helper/HashRouteGenerator':function(){
define([
    'spencer/utility/HashRouteGenerator'
], function(SpencerHashRouteGenerator) {
    const HashRouteGenerator = function(routePrefix) {
        this.spencerHashRouteGenerator = new SpencerHashRouteGenerator();
        this.routePrefix = routePrefix ? (routePrefix + (routePrefix.endsWith('/') ? '' : '/')) : '';
    };

    HashRouteGenerator.prototype.generate = function(route, params) {
        return this.spencerHashRouteGenerator.generate(this.routePrefix + route, params);
    };

    return HashRouteGenerator;
});
},
'spencer/utility/HashRouteGenerator':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class HashRouteGenerator {
        constructor() {
            this.ROUTE_PREFIX = '#';
            this.PARAM_PREFIX = ':';
        }
        generate(route, params) {
            for (let paramName in params) {
                if (params.hasOwnProperty(paramName)) {
                    const routeParamName = this.generateRouteParamFromParamName(paramName);
                    if (this.routeHasParam(route, routeParamName)) {
                        route = this.replaceRouteParamWithValue(route, routeParamName, params[paramName]);
                    }
                    else {
                        this.throwParamError(route, paramName);
                    }
                }
            }
            return this.ROUTE_PREFIX + route;
        }
        generateRouteParamFromParamName(paramName) {
            return this.PARAM_PREFIX + paramName;
        }
        routeHasParam(route, routeParam) {
            return route.indexOf(routeParam) !== -1;
        }
        replaceRouteParamWithValue(route, routeParam, value) {
            return route.replace(routeParam, encodeURIComponent(value));
        }
        throwParamError(route, paramName) {
            throw new Error('Route "' + route + '" does not contain parameter "' + paramName + '"');
        }
    }
    return HashRouteGenerator;
});

},
'library/request/data/Form':function(){
define([], function() {
    const Form = function() {
        this.id = null;
        this.files = [];
        this.fileKey = null;
    };
    
    Form.prototype.getId = function() {
        return this.id;
    };
    
    Form.prototype.setId = function(id) {
        this.id = id;
        return this;
    };

    Form.prototype.setFiles = function(files) {
        this.files = files;
        return this;
    };

    Form.prototype.getFiles = function() {
        return this.files;
    };

    Form.prototype.setFileKey = function(fileKey) {
        this.fileKey = fileKey;
        return this;
    };

    Form.prototype.getFileKey = function() {
        return this.fileKey;
    };
    
    return Form;
});

},
'style-guide/v1/doc-control/document/bulk-soft-link/FormPaneWrapper':function(){
define(["require", "exports", "api/doccontrol/Config", "api/doccontrol/document/Config", "api/doccontrol/document/Factory", "api/doccontrol/Factory", "style-guide/v1/doc-control/document/bulk-soft-link/FormPane", "library/request/URLConnectionBuilder", "library/request/dojo/URLConnectionProcessorBuilder", "library/request/URLResponseProcessorBuilder"], function (require, exports, DocControlConfig, DocControlDocumentConfig, DocControlDocumentFactory, DocControlFactory, BulkSoftLinkFormPane, URLConnectionBuilder, URLConnectionProcessorBuilder, URLResponseProcessorBuilder) {
    "use strict";
    class FormPaneWrapper {
        constructor() {
            this.widget = new BulkSoftLinkFormPane(this.getDocControlFactory().getTree(), this.getDocControlDocumentFactory().getSoftLink());
        }
        reset() {
            this.widget.reset();
        }
        setRevisions(revisions) {
            this.widget.setRevisions(revisions);
        }
        open() {
            this.widget.open();
        }
        setProjectStage(projectStage) {
            this.widget.setProjectStage(projectStage);
        }
        setNode(node) {
            this.widget.setNode(node);
        }
        getUrlConnectionBuilder() {
            if (!this.urlConnectionBuilder) {
                this.urlConnectionBuilder = new URLConnectionBuilder(new URLConnectionProcessorBuilder());
            }
            return this.urlConnectionBuilder;
        }
        ;
        getUrlResponseProcessorBuilder() {
            if (!this.urlResponseProcessorBuilder) {
                this.urlResponseProcessorBuilder = new URLResponseProcessorBuilder();
            }
            return this.urlResponseProcessorBuilder;
        }
        ;
        getDocControlFactory() {
            return new DocControlFactory(new DocControlConfig(), this.getUrlConnectionBuilder(), this.getUrlResponseProcessorBuilder());
        }
        ;
        getDocControlDocumentFactory() {
            return new DocControlDocumentFactory(new DocControlDocumentConfig(), this.getUrlConnectionBuilder(), this.getUrlResponseProcessorBuilder());
        }
        ;
    }
    return FormPaneWrapper;
});

},
'style-guide/v1/doc-control/document/bulk-soft-link/FormPane':function(){
define([
    'dojo/_base/declare',
    'style-guide/v1/layout/FormPane',
    './Form'
], function(
    declare,
    FormPaneWidget,
    Form
) {
    const FormPane = function(
        tree,
        softLink
    ) {
        this.view = new (declare(FormPaneWidget, {
            icon: 'sos-icon-files-copy',
            title: 'Soft Link Documents',
            width: 90,
            form: null,

            close: function() {
                this.inherited(arguments);

                this.form?.reset();
            },

            resetForm: function() {
                this.form?.reset();
            },

            setRevisions: function(revisions) {
                this._initForm();
                this.form.setRevisions(revisions);
                return this;
            },

            setProjectStage: function(projectStage) {
                this._initForm();
                this.form.setProjectStage(projectStage);
                return this;
            },

            setNode: function(node) {
                this._initForm();
                this.form.setNode(node);
                return this;
            },

            _initForm: function() {
                if (this.form) return;

                this.form = new Form(
                    tree,
                    softLink
                );
                this.form.setOnSubmit(() => this.close());
                this.set('content', this.form.view.domNode);
            }
        }));
    };

    FormPane.prototype.reset = function() {
        this.view.resetForm();
        return this;
    };

    FormPane.prototype.open = function() {
        this.view.open();
        return this;
    };

    FormPane.prototype.setRevisions = function(revisions) {
        this.view.setRevisions(revisions);
        return this;
    };

    FormPane.prototype.setProjectStage = function(projectStage) {
        this.view.setProjectStage(projectStage);
        return this;
    };

    FormPane.prototype.setNode = function(node) {
        this.view.setNode(node);
        return this;
    };

    return FormPane;
});
},
'style-guide/v1/layout/FormPane':function(){
define([
    'dojo/_base/fx',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/dom-construct',
    'dojo/dom-style',
    'dojo/html',
    'dojo/keys',
    'dojo/on',
    'dojo/query',
    'dojo/_base/declare',
    'dojo/_base/window',
    'soso/sosox/ejs/_Templated',
    'dojo/text!./templates/FormPane.html',
    './StackPane'
], function(
    baseFX,
    domAttr,
    domClass,
    domConstruct,
    domStyle,
    html,
    KEYS,
    on,
    query,
    declare,
    win,
    _Templated,
    template,
    StackPane
) {
    const DEFAULT_WIDTH = 40,
        PANEL_Z_INDEX = 2000;

    return declare('style-guide.v1.layout.form-pane', [StackPane, _Templated], {
        additionalClass: '',
        constants: {
            EMIT_CLOSE: 'close'
        },
        elementClose: null,
        elementTitle: null,
        elementTitleLink: null,
        eventEscapeKey: null,
        icon: null,
        data: {
            additionalClass: '',
            icon: null
        },
        formPaneContent: null,
        onOpenCompleteHandler: null,
        parentForm: null,
        title: null,
        width: null,
        zIndex: PANEL_Z_INDEX,

        templateString: template,

        postMixInProperties: function () {
            this.inherited(arguments);

            if (this.parentForm) {
                this.parentNode = this.parentForm.domNode;
            }

            this.data.additionalClass = this.additionalClass;
            this.data.icon = this.icon;
        },

        postCreate: function() {
            this.inherited(arguments);

            this._initCloseElementEvent();

            if (this.title) {
                this.setTitle(this.title);
            }

            this._initPanePositioning();
        },

        open: function() {
            this.inherited(arguments);

            this.resumePausables();

            if (this.parentForm) {
                this.parentForm.pausePausables();
            }

            this.reset();
            this._moveOnscreen();
            this.onOpen();
        },

        onOpen: function() {},

        onOpenComplete: function() {},

        close: function() {
            this.inherited(arguments);

            this.pausePausables();

            this.emit(this.constants.EMIT_CLOSE);

            if (this.parentForm) {
                this.parentForm.resumePausables();
            }

            this._moveOffscreen();
        },

        canClose: function() {
            return true;
        },

        onClose: function() {},

        resumePausables: function() {
            this.eventEscapeKey.resume();
        },

        pausePausables: function() {
            this.eventEscapeKey.pause();
        },

        setTitle: function(title) {
            html.set(this.elementTitle, title);

            this._removeRootNodeTitleAttrSetByDojo();
        },

        setTitleLink: function(titleLinkText, onClickCallback, titleLinkClass) {
            html.set(this.elementTitleLink, titleLinkText);

            if (typeof onClickCallback == 'function') {
                on(this.elementTitleLink, 'click', onClickCallback);
            }

            if (titleLinkClass) {
                domClass.add(this.elementTitleLink, titleLinkClass);
            }
        },

        reset: function() {
            this.contentNode.scrollTop = 0;
        },

        resetWidth: function() {
            this.width = DEFAULT_WIDTH;

            domStyle.set(this.formPaneContent, 'width', this.width + "%");
            domStyle.set(this.domNode, 'z-index', this.zIndex.toString());

            this._moveOffscreen();
        },

        destroyRecursive: function() {
            this.inherited(arguments);
            if (this.domNode) {
                this.domNode.remove();
                this.domNode.innerHTML = '';
                this.domNode = null;
            }
        },

        _placeStackPane: function() {
            if (domClass.contains(this.parentNode, 'sos-form-pane')) {
                return domConstruct.place(this.domNode, this.parentNode);
            }

            const container = query('.sos-v1.sos-form-pane-container')[0];

            if (container) {
                return domConstruct.place(this.domNode, container);
            }

            domConstruct.place(this.domNode, domConstruct.create('div', {
                'class': 'sos-v1 sos-form-pane-container'
            }, this.parentNode));
        },

        _removeRootNodeTitleAttrSetByDojo: function() {
            domAttr.remove(this.domNode, 'title');
        },

        _makeSubForm: function() {
            domClass.add(this.domNode, 'sos-form-pane-sub-form');
        },

        _initCloseElementEvent: function() {
            on(this.elementClose, 'click', () => {
                if (!this.canClose()) {
                    return;
                }

                this._callOnCloseOnTransitionEnd();
                this.close();
            });

            on(this.domNode, 'mousedown', function(e) {
                if(this._isNodeOverlay(e.target) && this.canClose()) {
                    this._callOnCloseOnTransitionEnd();
                    this.close();
                }
            }.bind(this));

            this.eventEscapeKey = on.pausable(document, 'keyup', function(e) {
                if (KEYS.ESCAPE === e.keyCode && this.canClose()) {
                    this._callOnCloseOnTransitionEnd();
                    this.close();
                }
            }.bind(this));
            this.eventEscapeKey.pause();
        },

        _callOnOpenCompleteOnTransitionEnd: function() {
            this.onOpenCompleteHandler = on.once(this.formPaneContent, 'transitionend', this.onOpenComplete.bind(this));
        },

        _callOnCloseOnTransitionEnd: function() {
            on.once(this.formPaneContent, 'transitionend', this.onClose.bind(this));
        },

        _initPanePositioning: function() {
            if (!this.width)  {
                if (this.parentForm) {
                    this.width = this.parentForm.width - 10;
                    this._makeSubForm();
                } else {
                    this.width = DEFAULT_WIDTH;
                }
            }

            if (this.parentForm) {
                this.zIndex = this.parentForm.zIndex + 10;
            }

            let width = this.width;
            if(!this.width.toString().endsWith('px')) {
                if(!this.width.toString().endsWith('%')) {
                    width = width + '%';
                }
            }

            domStyle.set(this.formPaneContent, 'width', width);
            domStyle.set(this.domNode, 'z-index', this.zIndex.toString());

            this._moveOffscreen();
        },

        _moveOnscreen: function() {
            domStyle.set(
                this.formPaneContent,
                'margin-right',
                ''
            );

            this._callOnOpenCompleteOnTransitionEnd();
        },

        _moveOffscreen: function() {
            domStyle.set(
                this.formPaneContent,
                'margin-right',
                '-' + this.formPaneContent.style.width
            );
        },

        _isNodeOverlay: function(node) {
            return this.domNode === node;
        }
    });
});


},
'style-guide/v1/layout/StackPane':function(){
define([
    'dojo/dom-class',
    'dojo/dom-construct',
    'dojo/dom-geometry',
    'dojo/dom-style',
    'dojo/Evented',
    'dojo/html',
    'dojo/on',
    'dojo/query',
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dojo/_base/window',
    'dijit/_WidgetBase',
    'dijit/_Templated',
    'dojo/text!./templates/StackPane.html'
], function(
    domClass,
    domConstruct,
    domGeometry,
    domStyle,
    Evented,
    html,
    on,
    query,
    declare,
    lang,
    win,
    _WidgetBase,
    _Templated,
    template
) {
    const MOVE_PANE_DELAY = 250;

    return declare('style-guide.v1.layout.stack-pane', [_WidgetBase, _Templated, Evented], {
        templateString: template,
        headerElement: null,
        inlineElement: null,
        parentNode: win.body(),
        stackPaneElement: null,
        windowResizeEvent: null,
        windowScrollEvent: null,
        mutationObserver: null,
        originalLeftOffset: null,
        timeoutMovePane: null,

        postCreate: function() {
            this.inherited(arguments);

            this._initWindowResizeEvent();
            this._initWindowScrollEvent();
            this._initMutationObserver();
            this._placeStackPane();

            if (this.inlineElement) {
                this._prepareInlineElementEvents();
            }
        },

        open: function() {
            this.updateHeaderOffset();

            query('html').addClass('sos-stack-pane-hide-vertical-scroll-bar');
            domClass.remove(this.domNode, 'disable-animation');
            domClass.add(this.domNode, 'open');

            if (this.windowResizeEvent) {
                this.windowResizeEvent.resume();
            }

            if (this.windowScrollEvent) {
                this.windowScrollEvent.resume();
            }
        },

        updateHeaderOffset: function() {
            if (this.headerElement) {
                this._configureHeaderOffset()
            }
        },

        close: function() {
            if (this.isOpen()) {
                domClass.remove(this.domNode, 'open');

                if (!this._areOtherPanesStillOpen()) {
                    query('html').removeClass('sos-stack-pane-hide-vertical-scroll-bar');
                }

                if (this.windowResizeEvent) {
                    this.windowResizeEvent.pause();
                }
                if (this.windowScrollEvent) {
                    this.windowScrollEvent.pause();
                }
            }
        },

        isOpen: function() {
            return domClass.contains(this.domNode, 'open');
        },

        showLoadingState: function () {
            this.set('content', this.loadingState);
        },

        _areOtherPanesStillOpen: function() {
            return query('.sos-stack-pane.open, .sos-form-pane.open').length > 0;
        },

        _placeStackPane: function() {
            domConstruct.place(this.domNode, domConstruct.create('div', {}, this.parentNode));
        },

        _prepareInlineElementEvents: function() {
            on(this.inlineElement, 'mouseenter, dragenter', this._movePaneInlineToElement.bind(this));
            on(this.inlineElement, 'mouseleave', this._resetPanePosition.bind(this));
            on(this.contentNode, 'mouseenter, dragenter', this._resetPanePosition.bind(this));
        },

        _movePaneInlineToElement: function(e) {
            this._clearTimeout();

            this.timeoutMovePane = setTimeout(function() {
                this.emit('slide-out');

                domClass.add(this.domNode, 'inline');
                domStyle.set(
                    this.contentNode,
                    'left',
                    this._calculateInlineElementLeftOffset(e.target) + 'px'
                );
            }.bind(this), MOVE_PANE_DELAY);
        },

        _calculateInlineElementLeftOffset: function(element) {
            return domStyle.get(element.style ? element : element.parentNode, 'left') + element.offsetWidth;
        },

        _resetPanePosition: function() {
            this._clearTimeout();

            this.emit('slide-in');

            domClass.remove(this.domNode, 'inline');
            domStyle.set(this.contentNode, 'left', '');
        },

        _clearTimeout: function() {
            if (this.timeoutMovePane) {
                clearTimeout(this.timeoutMovePane);
            }
        },

        _initWindowResizeEvent: function() {
            this.windowResizeEvent = on.pausable(window, 'resize', lang.hitch(this, function() {
                this._configureHeaderOffset();
            }));
            this.windowResizeEvent.pause();
        },

        _initWindowScrollEvent: function() {
            this.windowScrollEvent = on.pausable(window, 'scroll', lang.hitch(this, function() {
                this._configureHeaderOffset();
            }));
            this.windowScrollEvent.pause();
        },

        _initMutationObserver: function() {
            if (this.headerElement) {
                var config = {
                    attributes: true,
                    subtree: true
                };

                this.mutationObserver = new MutationObserver(() => {
                    this._configureHeaderOffset()
                });

                this.mutationObserver.observe(this.headerElement, config);
            }
        },

        _configureHeaderOffset: function() {
            if (!this.headerElement ) {
                return;
            }

            domStyle.set(this.domNode, 'top', this._calculateHeaderOffset(this.headerElement) + 'px');
        },

        _calculateHeaderOffset: function(headerElement) {
            const p = domGeometry.position(headerElement);
            return p.h + p.y;
        },

        _setContentAttr: function(content) {
            html.set(this.contentNode, content);
        }
    });
});
},
'style-guide/v1/doc-control/document/bulk-soft-link/Form':function(){
define([
    'dijit/_WidgetBase',
    'dojo/_base/declare',
    'dojo/Evented',
    'dojo/on',
    'dojo/topic',
    'dojo/text!./template/Form.html',
    'library/request/data/Handlers',
    'soso/sosox/ejs/_Templated',
    './LocationFormPane',
    './Table'
], function(
    _WidgetBase,
    declare,
    Evented,
    on,
    topic,
    template,
    Handlers,
    _Templated,
    LocationFormPane,
    Table
) {
    const PROGRESS_NOTIFICATION_UID = 'bulk-soft-link-progress-notification';

    const Form = function(
        tree,
        softLink
    ) {
        this.view = new (declare([_WidgetBase, _Templated, Evented], {
            elementRemoveSelectedButton: null,
            elementSetSelectedLocationButton: null,
            elementSubmitButton: null,
            elementTable: null,
            requests: {},
            selectedNode: null,
            selectedProjectStage: null,
            templateString: template,
            widgetTable: null,

            reset: function() {
                this.elementSubmitButton.disabled = true;
                this.elementRemoveSelectedButton.disabled = true;
                this.elementSetSelectedLocationButton.disabled = true;
                this.selectedProjectStage = null;
                this.selectedNode = null;
                Object.entries(this.requests).forEach((r) => r[1].cancel());
                this.requests = {};
                this.widgetTable?.reset();
            },

            setRevisions: function(revisions) {
                this._initTable();
                this.widgetTable.setDocuments(
                    revisions.map((revision) => {
                        return {
                            documentPK: revision.getDocumentPK(),
                            realName: revision.getRealName(),
                            title: revision.getTitle(),
                            type: revision.getFileType()
                        };
                    })
                );
                this.widgetTable.setDisabled(false);

                this.elementSubmitButton.disabled = true;
                this.elementRemoveSelectedButton.disabled = true;
                this.elementSetSelectedLocationButton.disabled = true;

                if (this.selectedProjectStage && this.selectedNode) {
                    this.widgetTable.getDocuments()
                        .forEach((d) => this._setNodeOnRevision(
                            d.documentPK, this.selectedProjectStage, this.selectedNode
                        ));
                }
            },

            setProjectStage: function(projectStage) {
                this.selectedProjectStage = projectStage;
            },

            setNode: function(node) {
                this.selectedNode = node;
            },

            _initTable: function() {
                if (this.widgetTable) return;

                this.widgetTable = new Table({}, this.elementTable);
                on(this.widgetTable, 'select-location', (documentPK) => {
                    this._initLocationFormPane();

                    const document = this.widgetTable.getDocument(documentPK);
                    if (document.projectStagePK || this.selectedProjectStage) {
                        this.widgetLocationFormPane.setProjectStagePK(
                            document.projectStagePK ?? this.selectedProjectStage.getProjectStagePK()
                        );
                    }
                    if (document.projectStageTreeViewPK || this.selectedNode) {
                        this.widgetLocationFormPane.setProjectStageTreeViewPK(
                            document.projectStageTreeViewPK ?? this.selectedNode.getProjectStageTreeViewPK()
                        );
                    }
                    this.widgetLocationFormPane.setOnSubmit(
                        (projectStage, node) => this._setNodeOnRevision(documentPK, projectStage, node)
                    );
                    this.widgetLocationFormPane.open();
                });
                on(this.widgetTable, 'change', () => {
                    const disabled = this.widgetTable.getSelectedDocumentPKs().length === 0;
                    this.elementRemoveSelectedButton.disabled = disabled;
                    this.elementSetSelectedLocationButton.disabled = disabled;
                    this._updateSubmitButtonState();
                });
                on(this.widgetTable, 'remove', (documentPK) => {
                    this.requests[documentPK]?.cancel();
                    delete this.requests[documentPK];
                    this._updateSubmitButtonState();
                });
            },

            _initLocationFormPane: function() {
                if (this.widgetLocationFormPane) return;

                this.widgetLocationFormPane = new LocationFormPane(tree);
            },

            _onSetSelectedLocationClick: function() {
                this._initLocationFormPane();

                if (this.selectedProjectStage) {
                    this.widgetLocationFormPane.setProjectStagePK(
                        this.selectedProjectStage.getProjectStagePK()
                    );
                }
                if (this.selectedNode) {
                    this.widgetLocationFormPane.setProjectStageTreeViewPK(
                        this.selectedNode.getProjectStageTreeViewPK()
                    );
                }
                this.widgetLocationFormPane.setOnSubmit(
                    (projectStage, node) => this.widgetTable.getSelectedDocumentPKs()
                        .forEach((documentPK) => this._setNodeOnRevision(documentPK, projectStage, node))
                );
                this.widgetLocationFormPane.open();
            },

            _updateSubmitButtonState: function() {
                const d = this.widgetTable.getDocuments();
                this.elementSubmitButton.disabled = d.length === 0 || !d.every((document) => document.isValid);
            },

            _setNodeOnRevision: function(documentPK, projectStage, node) {
                this.widgetTable.setLocation(documentPK, projectStage, node);

                this._createSoftLink(this.widgetTable.getDocument(documentPK), true)
                    .finally(this._updateSubmitButtonState.bind(this));
            },

            _createSoftLinks: function() {
                this.elementSubmitButton.disabled = true;
                this.widgetTable.setDisabled(true);

                const documents = this.widgetTable.getDocuments();

                let complete = 0;
                topic.publish(
                    'sos-system-notification-progress',
                    'Creating ' + documents.length + ' soft links...',
                    PROGRESS_NOTIFICATION_UID
                );

                const promises = [];
                documents.forEach((document) => {
                    const p = this._createSoftLink(document);
                    p.then(() => {
                        complete++;

                        topic.publish(
                            'sos-system-notification-progress-update',
                            PROGRESS_NOTIFICATION_UID,
                            Math.round(50 * (1 - (complete / documents.length)))
                        );
                    });
                    promises.push(p);
                });

                Promise.all(promises).then(() => {
                    topic.publish(
                        'sos-system-notification-progress-complete',
                        PROGRESS_NOTIFICATION_UID,
                        'Successfully created ' + promises.length + ' soft links.',
                        'success',
                        5000
                    );

                    this.emit('submit');
                }, () => {
                    topic.publish(
                        'sos-system-notification-progress-complete',
                        PROGRESS_NOTIFICATION_UID,
                        'Something went wrong. Please contact support.',
                        'error',
                        0
                    );

                    this.widgetTable.setDisabled(false);
                    this.elementSubmitButton.disabled = false;
                });
            },

            _createSoftLink: function(document, dryRun = false) {
                this.widgetTable.markAsVerifying(document.documentPK);
                return new Promise((resolve, reject) => {
                    this.requests[document.documentPK]?.cancel();
                    this.requests[document.documentPK] = softLink.create(
                        new Handlers(
                            () => {
                                this.widgetTable.markAsVerified(document.documentPK);
                                resolve();
                            },
                            () => {},
                            (error, description) => {
                                this.widgetTable.markAsFailed(document.documentPK, description);
                                reject();
                            },
                            (error, description) => {
                                this.widgetTable.markAsFailed(document.documentPK, description);
                                reject();
                            }
                        ),
                        document.documentPK,
                        document.projectStagePK,
                        document.projectStageTreeViewPK,
                        dryRun,
                        {documentTitle: document.title}
                    );
                });
            },

            _onRemoveSelectedClick: function() {
                this.widgetTable.getSelectedDocumentPKs()
                    .forEach((documentPK) => this.widgetTable.removeDocument(documentPK));
            },

            _onSubmitClick: function() {
                this._createSoftLinks();
            }
        }));
    };

    Form.prototype.reset = function() {
        this.view.reset();
        return this;
    };

    Form.prototype.setRevisions = function(revisions) {
        this.view.setRevisions(revisions);
        return this;
    };

    Form.prototype.setProjectStage = function(projectStage) {
        this.view.setProjectStage(projectStage);
        return this;
    };

    Form.prototype.setNode = function(node) {
        this.view.setNode(node);
        return this;
    };

    Form.prototype.setOnSubmit = function(onSubmit) {
        on(this.view, 'submit', onSubmit);
        return this;
    };

    return Form;
});
},
'style-guide/v1/doc-control/document/bulk-soft-link/LocationFormPane':function(){
define([
    'dojo/_base/declare',
    'style-guide/v1/layout/FormPane',
    './LocationForm'
], function(
    declare,
    FormPaneWidget,
    LocationForm
) {
    const FormPane = function(tree) {
        this.view = new (declare(FormPaneWidget, {
            icon: 'sos-icon-folder-open',
            title: 'Set Location',
            form: null,
            onSubmit: null,

            open: function() {
                this.inherited(arguments);

                this._initForm();
            },

            setProjectStagePK: function(projectStagePK) {
                this._initForm();
                this.form.setProjectStagePK(projectStagePK);
                return this;
            },

            setProjectStageTreeViewPK: function(projectStageTreeViewPK) {
                this._initForm();
                this.form.setProjectStageTreeViewPK(projectStageTreeViewPK);
                return this;
            },

            setOnSubmit: function(onSubmit) {
                this.onSubmit = onSubmit;
                return this;
            },

            _initForm: function() {
                if (this.form) return;

                this.form = new LocationForm(tree);
                this.form.setOnSubmit((projectStage, node) => {
                    this.close();
                    this.onSubmit?.(projectStage, node);
                });
                this.set('content', this.form.view.domNode);
            }
        }));
    };

    FormPane.prototype.open = function() {
        this.view.open();
        return this;
    };

    FormPane.prototype.setProjectStagePK = function(projectStagePK) {
        this.view.setProjectStagePK(projectStagePK);
        return this;
    };

    FormPane.prototype.setProjectStageTreeViewPK = function(projectStageTreeViewPK) {
        this.view.setProjectStageTreeViewPK(projectStageTreeViewPK);
        return this;
    };

    FormPane.prototype.setOnSubmit = function(onSubmit) {
        this.view.setOnSubmit(onSubmit);
        return this;
    };

    return FormPane;
});
},
'style-guide/v1/doc-control/document/bulk-soft-link/LocationForm':function(){
define([
    'api/project/filter/ExcludeInvisible',
    'dijit/_WidgetBase',
    'dojo/_base/declare',
    'dojo/Evented',
    'dojo/on',
    'dojo/text!./template/LocationForm.html',
    'dojo/topic',
    'library/PromiseFactory',
    'library/request/data/Handlers',
    'spencer/core/filter/Collection',
    'soso/dijit/form/api/project/StageFilteringSelect',
    'soso/sosox/ejs/_Templated',
    'style-guide/v1/doc-control/project-node-select/FilteringNodeSelect'
], function(
    ExcludeInvisibleFilter,
    _WidgetBase,
    declare,
    Evented,
    on,
    template,
    topic,
    PromiseFactory,
    Handlers,
    FilterCollection,
    ProjectStageFilteringSelect,
    _Templated,
    FilteringNodeSelect
) {
    const Form = function(tree) {
        this.view = new (declare([_WidgetBase, _Templated, Evented], {
            defaultProjectStageTreeViewPK: null,
            elementInactiveProjectStageWarning: null,
            elementNodeSelect: null,
            elementNodeSelectContainer: null,
            elementProjectStage: null,
            elementSubmitButton: null,
            elementUnauthorisedProjectStageError: null,
            selectedNode: null,
            selectedProjectStage: null,
            templateString: template,
            widgetNodeSelect: null,
            widgetProjectStageFilteringSelect: null,

            postCreate: function() {
                this.inherited(arguments);

                this._initProjectStageFilteringSelect();
            },

            setProjectStagePK: function(projectStagePK) {
                this.widgetProjectStageFilteringSelect.set('value', projectStagePK);
            },

            setProjectStageTreeViewPK: function(projectStageTreeViewPK) {
                this.defaultProjectStageTreeViewPK = projectStageTreeViewPK;

                this._initNodeSelect();
                this.widgetNodeSelect.set('projectStageTreeViewPK', this.defaultProjectStageTreeViewPK);
            },

            _initProjectStageFilteringSelect: function() {
                if (this.widgetProjectStageFilteringSelect) return;

                this.widgetProjectStageFilteringSelect = new ProjectStageFilteringSelect({
                    autoComplete: false,
                    queryExpr: '*${0}*',
                    'class': 'sos-form-filtering-select m-0 width-100',
                    placeholder: 'Select project or general stage...',
                    onChangeCallBack: this._onProjectStageSelect.bind(this),
                    filters: new FilterCollection().addFilter(new ExcludeInvisibleFilter())
                }, this.elementProjectStage);
            },

            _initNodeSelect: function() {
                if (this.widgetNodeSelect) return;

                this.widgetNodeSelect = new FilteringNodeSelect({
                    onNodeSelect: (node) => {
                        this.selectedNode = node;

                        this._updateSubmitButtonState();
                    }
                }, this.elementNodeSelect);
            },

            _loadTree: function(projectStagePK) {
                tree.get(
                    new Handlers(
                        (tree) => {
                            this.elementNodeSelectContainer.classList.remove('display-none');
                            this.elementUnauthorisedProjectStageError.classList.add('display-none');

                            this._initNodeSelect();
                            this.widgetNodeSelect.setNodeCollection(tree.getChildren());
                            this.widgetNodeSelect.set(
                                'projectStageTreeViewPK',
                                this.selectedNode?.getProjectStageTreeViewPK() ?? this.defaultProjectStageTreeViewPK
                            );
                        },
                        () => {},
                        () => {
                            this.elementNodeSelectContainer.classList.add('display-none');
                            this.elementUnauthorisedProjectStageError.classList.remove('display-none');
                        },
                        () => {
                            this.elementNodeSelectContainer.classList.add('display-none');

                            topic.publish(
                                'sos-system-notification',
                                'Sorry, something went wrong. Please try again or contact support.',
                                'error'
                            );
                        }
                    ),
                    projectStagePK
                );
            },

            _updateSubmitButtonState: function() {
                this.elementSubmitButton.disabled = !this.selectedNode;
            },

            _onProjectStageSelect: function(projectStage) {
                this.selectedProjectStage = projectStage;

                if (!projectStage) {
                    this.selectedNode = null;
                    this._updateSubmitButtonState();
                    this.elementNodeSelectContainer.classList.add('display-none');
                    return;
                }

                this.elementInactiveProjectStageWarning.classList.toggle('display-none', projectStage.getIsActive());

                this._loadTree(this.selectedProjectStage.getProjectStagePK());
            },

            _onSubmitClick: function() {
                this.emit('submit', this.selectedProjectStage, this.selectedNode);
            }
        }));
    };

    Form.prototype.setProjectStagePK = function(projectStagePK) {
        this.view.setProjectStagePK(projectStagePK);
        return this;
    };

    Form.prototype.setProjectStageTreeViewPK = function(projectStageTreeViewPK) {
        this.view.setProjectStageTreeViewPK(projectStageTreeViewPK);
        return this;
    };

    Form.prototype.setOnSubmit = function(onSubmit) {
        on(this.view, 'submit', onSubmit);
        return this;
    };

    return Form;
});
},
'library/PromiseFactory':function(){
define(["require", "exports", "library/DojoPromiseWrapper"], function (require, exports, PromiseWrapper) {
    "use strict";
    class PromiseFactory {
        get() {
            return new PromiseWrapper();
        }
    }
    return PromiseFactory;
});

},
'library/DojoPromiseWrapper':function(){
define(["require", "exports", "dojo/Deferred", "dojo/promise/all"], function (require, exports, Deferred, all) {
    "use strict";
    class DojoPromiseWrapper {
        constructor() {
            this.deferred = new Deferred();
        }
        resolve(value) {
            this.deferred.resolve(value);
        }
        reject(reason) {
            this.deferred.reject(reason);
        }
        cancel(reason) {
            this.deferred.cancel(reason);
        }
        then(onFulfilled, onRejected) {
            return this.deferred.then(onFulfilled, onRejected);
        }
        isFulfilled() {
            return this.deferred.isFulfilled();
        }
        isResolved() {
            return this.deferred.isResolved();
        }
        all(promises) {
            return all(promises);
        }
        get promise() {
            return this.deferred.promise;
        }
    }
    return DojoPromiseWrapper;
});

},
'spencer/core/filter/Collection':function(){
define([], function() {
    /** Deprecated - use @lib/spencer/core/filter/Collection */
    const Collection = function() {
        this.filters = [];
    };

    Collection.prototype.addFilter = function(filter) {
        this.filters.push(filter);
        return this;
    };

    Collection.prototype.clone = function() {
        const clone =  new Collection();
        this.filters.forEach(filter => clone.addFilter(filter));

        return clone;
    };

    Collection.prototype.getFilters = function() {
        return this.filters;
    };

    Collection.prototype.hasFilterForClass = function(constructor) {
        for (let i in this.filters) {
            if (this.filters.hasOwnProperty(i)) {
                if (this.filters[i] instanceof constructor) {
                    return true;
                }
            }
        }

        return false;
    };

    Collection.prototype.getFilterByClass = function(constructor) {
        for (let i in this.filters) {
            if (this.filters.hasOwnProperty(i)) {
                if (this.filters[i] instanceof constructor) {
                    return this.filters[i];
                }
            }
        }

        return null;
    };

    Collection.prototype.getFiltersByClass = function(constructor) {
        return this.filters.filter(function(filter) {
            if(filter instanceof constructor) {
                return filter;
            }
        });
    };

    Collection.prototype.removeFilterByClass = function(constructor) {
        this.filters = this.filters.filter(function(filter) {
            if (!(filter instanceof constructor)) {
                return filter;
            }
        });

        return this;
    };

    return Collection;
});
},
'soso/dijit/form/api/project/StageFilteringSelect':function(){
define([
    'dojo/_base/declare',
    'dojo/on',
    'soso/dijit/form/FilteringSelect',
    './StageTitleFormatter',
    './StoreFactory'
], function(
    declare,
    on,
    FilteringSelect,
    Formatter,
    StoreFactory
) {
    return declare('soso.dijit.form.api.project.StageFilteringSelect', [FilteringSelect], {
        projectStagePK: null,
        storeFactory: null,
        labelFunction: null,
        queryExpr: '*${0}*',
        searchAttr: null,
        store: null,
        onChangeCallBack: null,
        filters: null,

        postMixInProperties: function() {
            this.pageSize = parseInt(this.pageSize) || 10;
            this.labelFunc = this.labelFunction || this._formatProjectStageTitle.bind(this) || this.labelFunc;
            this.useLabelFunctionForItem = true;

            this.storeFactory = new StoreFactory();

            if (!this.store) {
                this._createStore();
            }

            this.searchAttr = this.searchAttr || this.store.searchAttr;

            this.inherited(arguments);
        },

        postCreate: function() {
            this.inherited(arguments);

            on(this, 'change', function() {
                if (typeof this.onChangeCallBack === 'function') {
                    this.onChangeCallBack(this.get('item'));
                }
            }.bind(this));
        },

        setProjectStageVO: function (projectStageVO, triggerOnChange) {
            this.set('item', projectStageVO, triggerOnChange);
        },

        _createStore: function () {
            this.set('store', this._createProjectStageStore());
        },

        _formatProjectStageTitle: function (item) {
            if (!item) {
                return '';
            }

            return (new Formatter()).format(item);
        },

        _createProjectStageStore: function () {
            return this.storeFactory.get(this.filters);
        },

        _setFiltersAttr: function(filters) {
            this.filters = filters;
            this._createStore();
        }
    });
});
},
'soso/dijit/form/FilteringSelect':function(){
define([
    "dojo/aspect",
    "dojo/_base/declare",
    "dojo/_base/lang",
    "dojo/dom-attr",
    "dojo/when",
    "dijit/form/FilteringSelect",
    "./_ComboBoxMenuDeletable",
    "./_ShortQueryMixin"
], function(
    aspect,
    declare,
    lang,
    domAttr,
    when,
    FilteringSelect,
    _ComboBoxMenuDeletable,
    _ShortQueryMixin
) {
    // module:
    //      soso/dijit/form/FilteringSelect
    // summary:
    //      An extension of `dijit/form/FilteringSelect`. Changes the behaviour
    //      when only one result is returned from a query, improves how
    //      clearing a search string functions by passing a range header,
    //      delay querying when search string is shorter than a set length and
    //      allow options to be deletable

    return declare("soso.dijit.form.FilteringSelect", [FilteringSelect, _ShortQueryMixin], {
        // Flag to determine if options can be deleted from the filter
        deletable: false,

        // Flag to determine whether or not to use the labelFunc when setting the item
        useLabelFunctionForItem: false,

        // Use a custom menu to show deletable options
        dropDownClass: _ComboBoxMenuDeletable,

        postCreate: function() {
            this.inherited(arguments);

            if (this.useLabelFunctionForItem) {
                aspect.before(this, '_autoCompleteText', function () {
                    var item = this.get('item');

                    if (item) {
                        return [this.labelFunc(item)];
                    }
                });
            }
        },

        _getMenuLabelFromItem: function (item) {
            // summary:
            //      If options are deletable modify the displayed label

            var label = this.inherited(arguments);

            if (this.deletable) {
                label.html = true;
                label.label += ' <a class="deleteButton" data-id="' + item[this.store.idProperty] + '">[x]</a>';
            }

            return label;
        },

        _deleteOption: function(node) {
            // summary:
            //      Overwritable function to delete an option from the store

            if (confirm('Delete option?')) {
                this.store.remove(domAttr.get(node, 'data-id'));
                this.reset();
                this.closeDropDown();
            }
        },

        _callbackSetLabel: function(
                        /*Array*/ result,
                        /*Object*/ query,
                        /*Object*/ options,
                        /*Boolean?*/ priorityChange){
            // summary:
            //      Callback from dojo.store after lookup of user entered value finishes

            // Horrendous hack coming up! If we return an array containing one result from the db, we're probably trying to
            // just fetch that one result (are we? Who knows!). But _setValueAttr isn't expecting an array back from the db
            // so whacks the result in an array. Gonna have to undo that here I think. Why not in _setValueAttr you ask?
            // 'Cos that'd mean messing about making sure inheritance worked correctly. No such worries here in this
            // completely overwritten function!
            if (lang.isArray(result[0]) && result[0].length == 1) {
                result = result[0];
            } else

            // setValue does a synchronous lookup,
            // so it calls _callbackSetLabel directly,
            // and so does not pass dataObject
            // still need to test against _lastQuery in case it came too late
            if((query && query[this.searchAttr] !== this._lastQuery) || (!query && result.length && this.store.getIdentity(result[0]) != this._lastQuery)){
                return;
            }
            /**
             * The only change here is the following line of code. Basically, if you've queried and had more than one result returned
             * the current situation sees the top result selected. That doesn't seem right to me; either select the result you want
             * specifically or you aren't selecting a result at all. Especially in cases where a value is not required. If a query is
             * performed and then the query string is deleted (i.e. none of the results returned are what's wanted so don't select a
             * result), that scenario would see a result chosen and there being no way of not choosing a result, despite a value not
             * being required. The change below sees a result only automatically chosen in situations where there is only one possible
             * result for the query.
             */
            if (result.length != 1) {
                //#3268: don't modify display value on bad input
                //#3285: change CSS to indicate error
                this.set("value", '', priorityChange || (priorityChange === undefined && !this.focused), this.textbox.value, null);
            } else if (typeof query == 'undefined' || (!query.name || query.name != '')) {
                this.set('item', result[0], priorityChange);
            } else {
                this.set('item', null, priorityChange);
            }
        },

        _setDisplayedValueAttr: function(/*String*/ label, /*Boolean?*/ priorityChange) {
            // summary:
            //      Hook so set('displayedValue', label) works.
            // description:
            //      Sets textbox to display label. Also performs reverse lookup
            //      to set the hidden value.  label should corresponding to item.searchAttr.

            if(label == null){ label = ''; }

            // This is called at initialization along with every custom setter.
            // Usually (or always?) the call can be ignored.   If it needs to be
            // processed then at least make sure that the XHR request doesn't trigger an onChange()
            // event, even if it returns after creation has finished
            if(!this._created){
                if(!("displayedValue" in this.params)){
                    return;
                }
                priorityChange = false;
            }

            // Do a reverse lookup to map the specified displayedValue to the hidden value.
            // Note that if there's a custom labelFunc() this code
            if(this.store){
                this.closeDropDown();
                var query = lang.clone(this.query); // #6196: populate query with user-specifics

                // Generate query
                var qs = this._getDisplayQueryString(label), q;
                if(this.store._oldAPI){
                    // remove this branch for 2.0
                    q = qs;
                }else{
                    // Query on searchAttr is a regex for benefit of dojo/store/Memory,
                    // but with a toString() method to help dojo/store/JsonRest.
                    // Search string like "Co*" converted to regex like /^Co.*$/i.
                    q = this._patternToRegExp(qs);
                    q.toString = function(){ return qs; };
                }
                this._lastQuery = query[this.searchAttr] = q;

                // If the label is not valid, the callback will never set it,
                // so the last valid value will get the warning textbox.   Set the
                // textbox value now so that the impending warning will make
                // sense to the user
                this.textbox.value = label;
                this._lastDisplayedValue = label;
                this._set("displayedValue", label);	// for watch("displayedValue") notification
                var _this = this;

                /**
                 * So you want to attempt to retrieve an item based upon the displayed value?
                 * This function's useful for that, given that that is what it does. It's less
                 * useful when you want to clear the input in order to not display a result.
                 * As soon as focus is lost on the FilteringSelect, this function gets hit and
                 * whatever is present in the input field goes off to the server to find an item.
                 * If you've cleared the input, an empty string gets sent and all results are
                 * returned because no range header is sent (with the start and count options
                 * not being set). The following attempts to rememdy that and I can't see why it
                 * would cause a problem.
                 */
                var options = {
                    ignoreCase: this.ignoreCase,
                    deep: true,
                    start: 0,
                    count: this.pageSize
                };
                lang.mixin(options, this.fetchProperties);
                this._fetchHandle = this.store.query(query, options);
                when(this._fetchHandle, function(result){
                    _this._fetchHandle = null;
                    _this._callbackSetLabel(result || [], query, options, priorityChange);
                }, function(err){
                    _this._fetchHandle = null;
                    if(!_this._cancelingQuery){	// don't treat canceled query as an error
                        console.error('dijit.form.FilteringSelect: ' + err.toString());
                    }
                });
            }
        },

        _setItemAttr: function(/*item*/ item, /*Boolean?*/ priorityChange, /*String?*/ displayedValue) {
            this.inherited(arguments);

            if (this.useLabelFunctionForItem) {
                this.textbox.value = this.labelFunc(item);
            }
        }
    });
});
},
'dijit/form/FilteringSelect':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/_base/lang", // lang.mixin
	"dojo/when",
	"./MappedTextBox",
	"./ComboBoxMixin"
], function(declare, lang, when, MappedTextBox, ComboBoxMixin){

	// module:
	//		dijit/form/FilteringSelect

	return declare("dijit.form.FilteringSelect", [MappedTextBox, ComboBoxMixin], {
		// summary:
		//		An enhanced version of the HTML SELECT tag, populated dynamically
		//
		// description:
		//		An enhanced version of the HTML SELECT tag, populated dynamically. It works
		//		very nicely with very large data sets because it can load and page data as needed.
		//		It also resembles ComboBox, but does not allow values outside of the provided ones.
		//		If OPTION tags are used as the data provider via markup, then the
		//		OPTION tag's child text node is used as the displayed value when selected
		//		while the OPTION tag's value attribute is used as the widget value on form submit.
		//		To set the default value when using OPTION tags, specify the selected
		//		attribute on 1 of the child OPTION tags.
		//
		//		Similar features:
		//
		//		- There is a drop down list of possible values.
		//		- You can only enter a value from the drop down list.  (You can't
		//			enter an arbitrary value.)
		//		- The value submitted with the form is the hidden value (ex: CA),
		//			not the displayed value a.k.a. label (ex: California)
		//
		//		Enhancements over plain HTML version:
		//
		//		- If you type in some text then it will filter down the list of
		//			possible values in the drop down list.
		//		- List can be specified either as a static list or via a javascript
		//			function (that can get the list from a server)

		// required: Boolean
		//		True (default) if user is required to enter a value into this field.
		required: true,

		_lastDisplayedValue: "",

		_isValidSubset: function(){
			return this._opened;
		},

		isValid: function(){
			// Overrides ValidationTextBox.isValid()
			return !!this.item || (!this.required && this.get('displayedValue') == ""); // #5974
		},

		_refreshState: function(){
			if(!this.searchTimer){ // state will be refreshed after results are returned
				this.inherited(arguments);
			}
		},

		_callbackSetLabel: function(
						/*Array*/ result,
						/*Object*/ query,
						/*Object*/ options,
						/*Boolean?*/ priorityChange){
			// summary:
			//		Callback from dojo.store after lookup of user entered value finishes

			// setValue does a synchronous lookup,
			// so it calls _callbackSetLabel directly,
			// and so does not pass dataObject
			// still need to test against _lastQuery in case it came too late
			if((query && query[this.searchAttr] !== this._lastQuery) || (!query && result.length && this.store.getIdentity(result[0]) != this._lastQuery)){
				return;
			}
			if(!result.length){
				//#3268: don't modify display value on bad input
				//#3285: change CSS to indicate error
				this.set("value", '', priorityChange || (priorityChange === undefined && !this.focused), this.textbox.value, null);
			}else{
				this.set('item', result[0], priorityChange);
			}
		},

		_openResultList: function(/*Object*/ results, /*Object*/ query, /*Object*/ options){
			// Callback when a data store query completes.
			// Overrides ComboBox._openResultList()

			// #3285: tap into search callback to see if user's query resembles a match
			if(query[this.searchAttr] !== this._lastQuery){
				return;
			}
			this.inherited(arguments);

			if(this.item === undefined){ // item == undefined for keyboard search
				// If the search returned no items that means that the user typed
				// in something invalid (and they can't make it valid by typing more characters),
				// so flag the FilteringSelect as being in an invalid state
				this.validate(true);
			}
		},

		_getValueAttr: function(){
			// summary:
			//		Hook for get('value') to work.

			// don't get the textbox value but rather the previously set hidden value.
			// Use this.valueNode.value which isn't always set for other MappedTextBox widgets until blur
			return this.valueNode.value;
		},

		_getValueField: function(){
			// Overrides ComboBox._getValueField()
			return "value";
		},

		_setValueAttr: function(/*String*/ value, /*Boolean?*/ priorityChange, /*String?*/ displayedValue, /*item?*/ item){
			// summary:
			//		Hook so set('value', value) works.
			// description:
			//		Sets the value of the select.
			//		Also sets the label to the corresponding value by reverse lookup.
			if(!this._onChangeActive){ priorityChange = null; }

			if(item === undefined){
				if(value === null || value === ''){
					value = '';
					if(!lang.isString(displayedValue)){
						this._setDisplayedValueAttr(displayedValue||'', priorityChange);
						return;
					}
				}

				var self = this;
				this._lastQuery = value;
				when(this.store.get(value), function(item){
					self._callbackSetLabel(item? [item] : [], undefined, undefined, priorityChange);
				});
			}else{
				this.valueNode.value = value;
				this.inherited(arguments, [value, priorityChange, displayedValue, item]);
			}
		},

		_setItemAttr: function(/*item*/ item, /*Boolean?*/ priorityChange, /*String?*/ displayedValue){
			// summary:
			//		Set the displayed valued in the input box, and the hidden value
			//		that gets submitted, based on a dojo.data store item.
			// description:
			//		Users shouldn't call this function; they should be calling
			//		set('item', value)
			// tags:
			//		private
			this.inherited(arguments);
			this._lastDisplayedValue = this.textbox.value;
		},

		_getDisplayQueryString: function(/*String*/ text){
			return text.replace(/([\\\*\?])/g, "\\$1");
		},

		_setDisplayedValueAttr: function(/*String*/ label, /*Boolean?*/ priorityChange){
			// summary:
			//		Hook so set('displayedValue', label) works.
			// description:
			//		Sets textbox to display label. Also performs reverse lookup
			//		to set the hidden value.  label should corresponding to item.searchAttr.

			if(label == null){ label = ''; }

			// This is called at initialization along with every custom setter.
			// Usually (or always?) the call can be ignored.   If it needs to be
			// processed then at least make sure that the XHR request doesn't trigger an onChange()
			// event, even if it returns after creation has finished
			if(!this._created){
				if(!("displayedValue" in this.params)){
					return;
				}
				priorityChange = false;
			}

			// Do a reverse lookup to map the specified displayedValue to the hidden value.
			// Note that if there's a custom labelFunc() this code
			if(this.store){
				this.closeDropDown();
				var query = lang.clone(this.query); // #6196: populate query with user-specifics

				// Generate query
				var qs = this._getDisplayQueryString(label), q;
				if(this.store._oldAPI){
					// remove this branch for 2.0
					q = qs;
				}else{
					// Query on searchAttr is a regex for benefit of dojo/store/Memory,
					// but with a toString() method to help dojo/store/JsonRest.
					// Search string like "Co*" converted to regex like /^Co.*$/i.
					q = this._patternToRegExp(qs);
					q.toString = function(){ return qs; };
				}
				this._lastQuery = query[this.searchAttr] = q;

				// If the label is not valid, the callback will never set it,
				// so the last valid value will get the warning textbox.   Set the
				// textbox value now so that the impending warning will make
				// sense to the user
				this.textbox.value = label;
				this._lastDisplayedValue = label;
				this._set("displayedValue", label);	// for watch("displayedValue") notification
				var _this = this;
				var options = {
					queryOptions: {
						ignoreCase: this.ignoreCase,
						deep: true
					}
				};
				lang.mixin(options, this.fetchProperties);
				this._fetchHandle = this.store.query(query, options);
				when(this._fetchHandle, function(result){
					_this._fetchHandle = null;
					_this._callbackSetLabel(result || [], query, options, priorityChange);
				}, function(err){
					_this._fetchHandle = null;
					if(!_this._cancelingQuery){	// don't treat canceled query as an error
						console.error('dijit.form.FilteringSelect: ' + err.toString());
					}
				});
			}
		},

		undo: function(){
			this.set('displayedValue', this._lastDisplayedValue);
		}
	});
});

},
'dijit/form/ComboBoxMixin':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/Deferred",
	"dojo/_base/kernel", // kernel.deprecated
	"dojo/_base/lang", // lang.mixin
	"dojo/store/util/QueryResults",
	"./_AutoCompleterMixin",
	"./_ComboBoxMenu",
	"../_HasDropDown",
	"dojo/text!./templates/DropDownBox.html"
], function(declare, Deferred, kernel, lang, QueryResults, _AutoCompleterMixin, _ComboBoxMenu, _HasDropDown, template){


	// module:
	//		dijit/form/ComboBoxMixin

	return declare("dijit.form.ComboBoxMixin", [_HasDropDown, _AutoCompleterMixin], {
		// summary:
		//		Provides main functionality of ComboBox widget

		// dropDownClass: [protected extension] Function String
		//		Dropdown widget class used to select a date/time.
		//		Subclasses should specify this.
		dropDownClass: _ComboBoxMenu,

		// hasDownArrow: Boolean
		//		Set this textbox to have a down arrow button, to display the drop down list.
		//		Defaults to true.
		hasDownArrow: true,

		templateString: template,

		baseClass: "dijitTextBox dijitComboBox",

		/*=====
		// store: [const] dojo/store/api/Store|dojo/data/api/Read
		//		Reference to data provider object used by this ComboBox.
		//
		//		Should be dojo/store/api/Store, but dojo/data/api/Read supported
		//		for backwards compatibility.
		store: null,
		=====*/

		// Set classes like dijitDownArrowButtonHover depending on
		// mouse action over button node
		cssStateNodes: {
			"_buttonNode": "dijitDownArrowButton"
		},

		_setHasDownArrowAttr: function(/*Boolean*/ val){
			this._set("hasDownArrow", val);
			this._buttonNode.style.display = val ? "" : "none";
		},

		_showResultList: function(){
			// hide the tooltip
			this.displayMessage("");
			this.inherited(arguments);
		},

		_setStoreAttr: function(store){
			// For backwards-compatibility, accept dojo.data store in addition to dojo/store/api/Store.  Remove in 2.0.
			if(!store.get){
				lang.mixin(store, {
					_oldAPI: true,
					get: function(id){
						// summary:
						//		Retrieves an object by it's identity. This will trigger a fetchItemByIdentity.
						//		Like dojo/store/DataStore.get() except returns native item.
						var deferred = new Deferred();
						this.fetchItemByIdentity({
							identity: id,
							onItem: function(object){
								deferred.resolve(object);
							},
							onError: function(error){
								deferred.reject(error);
							}
						});
						return deferred.promise;
					},
					query: function(query, options){
						// summary:
						//		Queries the store for objects.   Like dojo/store/DataStore.query()
						//		except returned Deferred contains array of native items.
						var deferred = new Deferred(function(){ fetchHandle.abort && fetchHandle.abort(); });
						deferred.total = new Deferred();
						var fetchHandle = this.fetch(lang.mixin({
							query: query,
							onBegin: function(count){
								deferred.total.resolve(count);
							},
							onComplete: function(results){
								deferred.resolve(results);
							},
							onError: function(error){
								deferred.reject(error);
							}
						}, options));
						return QueryResults(deferred);
					}
				});
			}
			this._set("store", store);
		},

		postMixInProperties: function(){
			// Since _setValueAttr() depends on this.store, _setStoreAttr() needs to execute first.
			// Unfortunately, without special code, it ends up executing second.
			var store = this.params.store || this.store;
			if(store){
				this._setStoreAttr(store);
			}

			this.inherited(arguments);

			// User may try to access this.store.getValue() etc.  in a custom labelFunc() function.
			// It's not available with the new data store for handling inline <option> tags, so add it.
			if(!this.params.store && this.store && !this.store._oldAPI){
				var clazz = this.declaredClass;
				lang.mixin(this.store, {
					getValue: function(item, attr){
						kernel.deprecated(clazz + ".store.getValue(item, attr) is deprecated for builtin store.  Use item.attr directly", "", "2.0");
						return item[attr];
					},
					getLabel: function(item){
						kernel.deprecated(clazz + ".store.getLabel(item) is deprecated for builtin store.  Use item.label directly", "", "2.0");
						return item.name;
					},
					fetch: function(args){
						kernel.deprecated(clazz + ".store.fetch() is deprecated for builtin store.", "Use store.query()", "2.0");
						var shim = ["dojo/data/ObjectStore"];	// indirection so it doesn't get rolled into a build
						require(shim, lang.hitch(this, function(ObjectStore){
							new ObjectStore({objectStore: this}).fetch(args);
						}));
					}
				});
			}
		},

		buildRendering: function(){
			this.inherited(arguments);

			this.focusNode.setAttribute("aria-autocomplete", this.autoComplete ? "both" : "list");
		}
	});
});

},
'dijit/form/_AutoCompleterMixin':function(){
define([
	"dojo/aspect",
	"dojo/_base/declare", // declare
	"dojo/dom-attr", // domAttr.get
	"dojo/keys",
	"dojo/_base/lang", // lang.clone lang.hitch
	"dojo/query", // query
	"dojo/regexp", // regexp.escapeString
	"dojo/sniff", // has("ie")
	"./DataList",
	"./_TextBoxMixin", // defines _TextBoxMixin.selectInputText
	"./_SearchMixin"
], function(aspect, declare, domAttr, keys, lang, query, regexp, has, DataList, _TextBoxMixin, SearchMixin){

	// module:
	//		dijit/form/_AutoCompleterMixin

	var AutoCompleterMixin = declare("dijit.form._AutoCompleterMixin", SearchMixin, {
		// summary:
		//		A mixin that implements the base functionality for `dijit/form/ComboBox`/`dijit/form/FilteringSelect`
		// description:
		//		All widgets that mix in dijit/form/_AutoCompleterMixin must extend `dijit/form/_FormValueWidget`.
		// tags:
		//		protected

		// item: Object
		//		This is the item returned by the dojo/store/api/Store implementation that
		//		provides the data for this ComboBox, it's the currently selected item.
		item: null,

		// autoComplete: Boolean
		//		If user types in a partial string, and then tab out of the `<input>` box,
		//		automatically copy the first entry displayed in the drop down list to
		//		the `<input>` field
		autoComplete: true,

		// highlightMatch: String
		//		One of: "first", "all" or "none".
		//
		//		If the ComboBox/FilteringSelect opens with the search results and the searched
		//		string can be found, it will be highlighted.  If set to "all"
		//		then will probably want to change `queryExpr` parameter to '*${0}*'
		//
		//		Highlighting is only performed when `labelType` is "text", so as to not
		//		interfere with any HTML markup an HTML label might contain.
		highlightMatch: "first",

		// labelAttr: String?
		//		The entries in the drop down list come from this attribute in the
		//		dojo.data items.
		//		If not specified, the searchAttr attribute is used instead.
		labelAttr: "",

		// labelType: String
		//		Specifies how to interpret the labelAttr in the data store items.
		//		Can be "html" or "text".
		labelType: "text",

		// Flags to _HasDropDown to limit height of drop down to make it fit in viewport
		maxHeight: -1,

		// For backwards compatibility let onClick events propagate, even clicks on the down arrow button
		_stopClickEvents: false,

		_getCaretPos: function(/*DomNode*/ element){
			// khtml 3.5.2 has selection* methods as does webkit nightlies from 2005-06-22
			var pos = 0;
			if(typeof(element.selectionStart) == "number"){
				// FIXME: this is totally borked on Moz < 1.3. Any recourse?
				pos = element.selectionStart;
			}else if(has("ie")){
				// in the case of a mouse click in a popup being handled,
				// then the document.selection is not the textarea, but the popup
				// var r = document.selection.createRange();
				// hack to get IE 6 to play nice. What a POS browser.
				var tr = element.ownerDocument.selection.createRange().duplicate();
				var ntr = element.createTextRange();
				tr.move("character", 0);
				ntr.move("character", 0);
				try{
					// If control doesn't have focus, you get an exception.
					// Seems to happen on reverse-tab, but can also happen on tab (seems to be a race condition - only happens sometimes).
					// There appears to be no workaround for this - googled for quite a while.
					ntr.setEndPoint("EndToEnd", tr);
					pos = String(ntr.text).replace(/\r/g, "").length;
				}catch(e){
					// If focus has shifted, 0 is fine for caret pos.
				}
			}
			return pos;
		},

		_setCaretPos: function(/*DomNode*/ element, /*Number*/ location){
			location = parseInt(location);
			_TextBoxMixin.selectInputText(element, location, location);
		},

		_setDisabledAttr: function(/*Boolean*/ value){
			// Additional code to set disabled state of ComboBox node.
			// Overrides _FormValueWidget._setDisabledAttr() or ValidationTextBox._setDisabledAttr().
			this.inherited(arguments);
			this.domNode.setAttribute("aria-disabled", value ? "true" : "false");
		},

		_onKey: function(/*Event*/ evt){
			// summary:
			//		Handles keyboard events

			if(evt.charCode >= 32){
				return;
			} // alphanumeric reserved for searching

			var key = evt.charCode || evt.keyCode;

			// except for cutting/pasting case - ctrl + x/v
			if(key == keys.ALT || key == keys.CTRL || key == keys.META || key == keys.SHIFT){
				return; // throw out spurious events
			}

			var pw = this.dropDown;
			var highlighted = null;
			this._abortQuery();

			// _HasDropDown will do some of the work:
			//
			//	1. when drop down is not yet shown:
			//		- if user presses the down arrow key, call loadDropDown()
			//	2. when drop down is already displayed:
			//		- on ESC key, call closeDropDown()
			//		- otherwise, call dropDown.handleKey() to process the keystroke
			this.inherited(arguments);

			if(evt.altKey || evt.ctrlKey || evt.metaKey){
				return;
			} // don't process keys with modifiers  - but we want shift+TAB

			if(this._opened){
				highlighted = pw.getHighlightedOption();
			}
			switch(key){
				case keys.PAGE_DOWN:
				case keys.DOWN_ARROW:
				case keys.PAGE_UP:
				case keys.UP_ARROW:
					// Keystroke caused ComboBox_menu to move to a different item.
					// Copy new item to <input> box.
					if(this._opened){
						this._announceOption(highlighted);
					}
					evt.stopPropagation();
					evt.preventDefault();
					break;

				case keys.ENTER:
					// prevent submitting form if user presses enter. Also
					// prevent accepting the value if either Next or Previous
					// are selected
					if(highlighted){
						// only stop event on prev/next
						if(highlighted == pw.nextButton){
							this._nextSearch(1);
							// prevent submit
							evt.stopPropagation();
							evt.preventDefault();
							break;
						}else if(highlighted == pw.previousButton){
							this._nextSearch(-1);
							// prevent submit
							evt.stopPropagation();
							evt.preventDefault();
							break;
						}
						// prevent submit if ENTER was to choose an item
						evt.stopPropagation();
						evt.preventDefault();
					}else{
						// Update 'value' (ex: KY) according to currently displayed text
						this._setBlurValue(); // set value if needed
						this._setCaretPos(this.focusNode, this.focusNode.value.length); // move cursor to end and cancel highlighting
					}
				// fall through

				case keys.TAB:
					var newvalue = this.get('displayedValue');
					//	if the user had More Choices selected fall into the
					//	_onBlur handler
					if(pw && (newvalue == pw._messages["previousMessage"] || newvalue == pw._messages["nextMessage"])){
						break;
					}
					if(highlighted){
						this._selectOption(highlighted);
					}
				// fall through

				case keys.ESCAPE:
					if(this._opened){
						this._lastQuery = null; // in case results come back later
						this.closeDropDown();
					}
					break;
			}
		},

		_autoCompleteText: function(/*String*/ text){
			// summary:
			//		Fill in the textbox with the first item from the drop down
			//		list, and highlight the characters that were
			//		auto-completed. For example, if user typed "CA" and the
			//		drop down list appeared, the textbox would be changed to
			//		"California" and "ifornia" would be highlighted.

			var fn = this.focusNode;

			// IE7: clear selection so next highlight works all the time
			_TextBoxMixin.selectInputText(fn, fn.value.length);
			// does text autoComplete the value in the textbox?
			var caseFilter = this.ignoreCase ? 'toLowerCase' : 'substr';
			if(text[caseFilter](0).indexOf(this.focusNode.value[caseFilter](0)) == 0){
				var cpos = this.autoComplete ? this._getCaretPos(fn) : fn.value.length;
				// only try to extend if we added the last character at the end of the input
				if((cpos + 1) > fn.value.length){
					// only add to input node as we would overwrite Capitalisation of chars
					// actually, that is ok
					fn.value = text;//.substr(cpos);
					// visually highlight the autocompleted characters
					_TextBoxMixin.selectInputText(fn, cpos);
				}
			}else{
				// text does not autoComplete; replace the whole value and highlight
				fn.value = text;
				_TextBoxMixin.selectInputText(fn);
			}
		},

		_openResultList: function(/*Object*/ results, /*Object*/ query, /*Object*/ options){
			// summary:
			//		Callback when a search completes.
			// description:
			//		1. generates drop-down list and calls _showResultList() to display it
			//		2. if this result list is from user pressing "more choices"/"previous choices"
			//			then tell screen reader to announce new option
			var wasSelected = this.dropDown.getHighlightedOption();
			this.dropDown.clearResultList();
			if(!results.length && options.start == 0){ // if no results and not just the previous choices button
				this.closeDropDown();
				return;
			}
			this._nextSearch = this.dropDown.onPage = lang.hitch(this, function(direction){
				results.nextPage(direction !== -1);
				this.focus();
			});

			// Fill in the textbox with the first item from the drop down list,
			// and highlight the characters that were auto-completed. For
			// example, if user typed "CA" and the drop down list appeared, the
			// textbox would be changed to "California" and "ifornia" would be
			// highlighted.

			this.dropDown.createOptions(
				results,
				options,
				lang.hitch(this, "_getMenuLabelFromItem")
			);

			// show our list (only if we have content, else nothing)
			this._showResultList();

			// #4091:
			//		tell the screen reader that the paging callback finished by
			//		shouting the next choice
			if("direction" in options){
				if(options.direction){
					this.dropDown.highlightFirstOption();
				}else if(!options.direction){
					this.dropDown.highlightLastOption();
				}
				if(wasSelected){
					this._announceOption(this.dropDown.getHighlightedOption());
				}
			}else if(this.autoComplete && !this._prev_key_backspace
				// when the user clicks the arrow button to show the full list,
				// startSearch looks for "*".
				// it does not make sense to autocomplete
				// if they are just previewing the options available.
				&& !/^[*]+$/.test(query[this.searchAttr].toString())){
				this._announceOption(this.dropDown.containerNode.firstChild.nextSibling); // 1st real item
			}
		},

		_showResultList: function(){
			// summary:
			//		Display the drop down if not already displayed, or if it is displayed, then
			//		reposition it if necessary (reposition may be necessary if drop down's height changed).
			this.closeDropDown(true);
			this.openDropDown();
			this.domNode.setAttribute("aria-expanded", "true");
		},

		loadDropDown: function(/*Function*/ /*===== callback =====*/){
			// Overrides _HasDropDown.loadDropDown().
			// This is called when user has pressed button icon or pressed the down arrow key
			// to open the drop down.
			this._startSearchAll();
		},

		isLoaded: function(){
			// signal to _HasDropDown that it needs to call loadDropDown() to load the
			// drop down asynchronously before displaying it
			return false;
		},

		closeDropDown: function(){
			// Overrides _HasDropDown.closeDropDown().  Closes the drop down (assuming that it's open).
			// This method is the callback when the user types ESC or clicking
			// the button icon while the drop down is open.  It's also called by other code.
			this._abortQuery();
			if(this._opened){
				this.inherited(arguments);
				this.domNode.setAttribute("aria-expanded", "false");
			}
		},

		_setBlurValue: function(){
			// if the user clicks away from the textbox OR tabs away, set the
			// value to the textbox value
			// #4617:
			//		if value is now more choices or previous choices, revert
			//		the value
			var newvalue = this.get('displayedValue');
			var pw = this.dropDown;
			if(pw && (newvalue == pw._messages["previousMessage"] || newvalue == pw._messages["nextMessage"])){
				this._setValueAttr(this._lastValueReported, true);
			}else if(typeof this.item == "undefined"){
				// Update 'value' (ex: KY) according to currently displayed text
				this.item = null;
				this.set('displayedValue', newvalue);
			}else{
				if(this.value != this._lastValueReported){
					this._handleOnChange(this.value, true);
				}
				this._refreshState();
			}
			// Remove aria-activedescendant since it may not be removed if they select with arrows then blur with mouse
			this.focusNode.removeAttribute("aria-activedescendant");
		},

		_setItemAttr: function(/*item*/ item, /*Boolean?*/ priorityChange, /*String?*/ displayedValue){
			// summary:
			//		Set the displayed valued in the input box, and the hidden value
			//		that gets submitted, based on a dojo.data store item.
			// description:
			//		Users shouldn't call this function; they should be calling
			//		set('item', value)
			// tags:
			//		private
			var value = '';
			if(item){
				if(!displayedValue){
					displayedValue = this.store._oldAPI ? // remove getValue() for 2.0 (old dojo.data API)
						this.store.getValue(item, this.searchAttr) : item[this.searchAttr];
				}
				value = this._getValueField() != this.searchAttr ? this.store.getIdentity(item) : displayedValue;
			}
			this.set('value', value, priorityChange, displayedValue, item);
		},

		_announceOption: function(/*Node*/ node){
			// summary:
			//		a11y code that puts the highlighted option in the textbox.
			//		This way screen readers will know what is happening in the
			//		menu.

			if(!node){
				return;
			}
			// pull the text value from the item attached to the DOM node
			var newValue;
			if(node == this.dropDown.nextButton ||
				node == this.dropDown.previousButton){
				newValue = node.innerHTML;
				this.item = undefined;
				this.value = '';
			}else{
				var item = this.dropDown.items[node.getAttribute("item")];
				newValue = (this.store._oldAPI ? // remove getValue() for 2.0 (old dojo.data API)
					this.store.getValue(item, this.searchAttr) : item[this.searchAttr]).toString();
				this.set('item', item, false, newValue);
			}
			// get the text that the user manually entered (cut off autocompleted text)
			this.focusNode.value = this.focusNode.value.substring(0, this._lastInput.length);
			// set up ARIA activedescendant
			this.focusNode.setAttribute("aria-activedescendant", domAttr.get(node, "id"));
			// autocomplete the rest of the option to announce change
			this._autoCompleteText(newValue);
		},

		_selectOption: function(/*DomNode*/ target){
			// summary:
			//		Menu callback function, called when an item in the menu is selected.
			this.closeDropDown();
			if(target){
				this._announceOption(target);
			}
			this._setCaretPos(this.focusNode, this.focusNode.value.length);
			this._handleOnChange(this.value, true);
			// Remove aria-activedescendant since the drop down is no loner visible
			// after closeDropDown() but _announceOption() adds it back in
			this.focusNode.removeAttribute("aria-activedescendant");
		},

		_startSearchAll: function(){
			this._startSearch('');
		},

		_startSearchFromInput: function(){
			this.item = undefined; // undefined means item needs to be set
			this.inherited(arguments);
		},

		_startSearch: function(/*String*/ key){
			// summary:
			//		Starts a search for elements matching key (key=="" means to return all items),
			//		and calls _openResultList() when the search completes, to display the results.
			if(!this.dropDown){
				var popupId = this.id + "_popup",
					dropDownConstructor = lang.isString(this.dropDownClass) ?
						lang.getObject(this.dropDownClass, false) : this.dropDownClass;
				this.dropDown = new dropDownConstructor({
					onChange: lang.hitch(this, this._selectOption),
					id: popupId,
					dir: this.dir,
					textDir: this.textDir
				});
			}
			this._lastInput = key; // Store exactly what was entered by the user.
			this.inherited(arguments);
		},

		_getValueField: function(){
			// summary:
			//		Helper for postMixInProperties() to set this.value based on data inlined into the markup.
			//		Returns the attribute name in the item (in dijit/form/_ComboBoxDataStore) to use as the value.
			return this.searchAttr;
		},

		//////////// INITIALIZATION METHODS ///////////////////////////////////////

		postMixInProperties: function(){
			this.inherited(arguments);
			if(!this.store && this.srcNodeRef){
				var srcNodeRef = this.srcNodeRef;
				// if user didn't specify store, then assume there are option tags
				this.store = new DataList({}, srcNodeRef);

				// if there is no value set and there is an option list, set
				// the value to the first value to be consistent with native Select
				// Firefox and Safari set value
				// IE6 and Opera set selectedIndex, which is automatically set
				// by the selected attribute of an option tag
				// IE6 does not set value, Opera sets value = selectedIndex
				if(!("value" in this.params)){
					var item = (this.item = this.store.fetchSelectedItem());
					if(item){
						var valueField = this._getValueField();
						// remove getValue() for 2.0 (old dojo.data API)
						this.value = this.store._oldAPI ? this.store.getValue(item, valueField) : item[valueField];
					}
				}
			}
		},

		postCreate: function(){
			// summary:
			//		Subclasses must call this method from their postCreate() methods
			// tags:
			//		protected

			// find any associated label element and add to ComboBox node.
			var label = query('label[for="' + this.id + '"]');
			if(label.length){
				if(!label[0].id){
					label[0].id = this.id + "_label";
				}
				this.domNode.setAttribute("aria-labelledby", label[0].id);

			}
			this.inherited(arguments);
			aspect.after(this, "onSearch", lang.hitch(this, "_openResultList"), true);
		},

		_getMenuLabelFromItem: function(/*Item*/ item){
			var label = this.labelFunc(item, this.store),
				labelType = this.labelType;
			// If labelType is not "text" we don't want to screw any markup ot whatever.
			if(this.highlightMatch != "none" && this.labelType == "text" && this._lastInput){
				label = this.doHighlight(label, this._lastInput);
				labelType = "html";
			}
			return {html: labelType == "html", label: label};
		},

		doHighlight: function(/*String*/ label, /*String*/ find){
			// summary:
			//		Highlights the string entered by the user in the menu.  By default this
			//		highlights the first occurrence found. Override this method
			//		to implement your custom highlighting.
			// tags:
			//		protected

			var
			// Add (g)lobal modifier when this.highlightMatch == "all" and (i)gnorecase when this.ignoreCase == true
				modifiers = (this.ignoreCase ? "i" : "") + (this.highlightMatch == "all" ? "g" : ""),
				i = this.queryExpr.indexOf("${0}");
			find = regexp.escapeString(find); // escape regexp special chars
			//If < appears in label, and user presses t, we don't want to highlight the t in the escaped "&lt;"
			//first find out every occurrences of "find", wrap each occurrence in a pair of "\uFFFF" characters (which
			//should not appear in any string). then html escape the whole string, and replace '\uFFFF" with the
			//HTML highlight markup.
			return this._escapeHtml(label.replace(
				new RegExp((i == 0 ? "^" : "") + "(" + find + ")" + (i == (this.queryExpr.length - 4) ? "$" : ""), modifiers),
				'\uFFFF$1\uFFFF')).replace(
				/\uFFFF([^\uFFFF]+)\uFFFF/g, '<span class="dijitComboBoxHighlightMatch">$1</span>'
			); // returns String, (almost) valid HTML (entities encoded)
		},

		_escapeHtml: function(/*String*/ str){
			// TODO Should become dojo.html.entities(), when exists use instead
			// summary:
			//		Adds escape sequences for special characters in XML: `&<>"'`
			str = String(str).replace(/&/gm, "&amp;").replace(/</gm, "&lt;")
				.replace(/>/gm, "&gt;").replace(/"/gm, "&quot;"); //balance"
			return str; // string
		},

		reset: function(){
			// Overrides the _FormWidget.reset().
			// Additionally reset the .item (to clean up).
			this.item = null;
			this.inherited(arguments);
		},

		labelFunc: function(item, store){
			// summary:
			//		Computes the label to display based on the dojo.data store item.
			// item: Object
			//		The item from the store
			// store: dojo/store/api/Store
			//		The store.
			// returns:
			//		The label that the ComboBox should display
			// tags:
			//		private

			// Use toString() because XMLStore returns an XMLItem whereas this
			// method is expected to return a String (#9354).
			// Remove getValue() for 2.0 (old dojo.data API)
			return (store._oldAPI ? store.getValue(item, this.labelAttr || this.searchAttr) :
				item[this.labelAttr || this.searchAttr]).toString(); // String
		},

		_setValueAttr: function(/*String*/ value, /*Boolean?*/ priorityChange, /*String?*/ displayedValue, /*item?*/ item){
			// summary:
			//		Hook so set('value', value) works.
			// description:
			//		Sets the value of the select.
			this._set("item", item || null); // value not looked up in store
			if(value == null /* or undefined */){
				value = '';
			} // null translates to blank
			this.inherited(arguments);
		}
	});

	if(has("dojo-bidi")){
		AutoCompleterMixin.extend({
			_setTextDirAttr: function(/*String*/ textDir){
				// summary:
				//		Setter for textDir, needed for the dropDown's textDir update.
				// description:
				//		Users shouldn't call this function; they should be calling
				//		set('textDir', value)
				// tags:
				//		private
				this.inherited(arguments);
				// update the drop down also (_ComboBoxMenuMixin)
				if(this.dropDown){
					this.dropDown._set("textDir", textDir);
				}
			}
		});
	}

	return AutoCompleterMixin;
});

},
'dijit/form/DataList':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/dom", // dom.byId
	"dojo/_base/lang", // lang.trim
	"dojo/query", // query
	"dojo/store/Memory",
	"../registry"	// registry.add registry.remove
], function(declare, dom, lang, query, MemoryStore, registry){

	// module:
	//		dijit/form/DataList

	function toItem(/*DOMNode*/ option){
		// summary:
		//		Convert `<option>` node to hash
		return {
			id: option.value,
			value: option.value,
			name: lang.trim(option.innerText || option.textContent || '')
		};
	}

	return declare("dijit.form.DataList", MemoryStore, {
		// summary:
		//		Inefficient but small data store specialized for inlined data via OPTION tags
		//
		// description:
		//		Provides a store for inlined data like:
		//
		//	|	<datalist>
		//	|		<option value="AL">Alabama</option>
		//	|		...

		constructor: function(params, srcNodeRef){
			// summary:
			//		Create the widget.
			// params: Object|null
			//		Hash of initialization parameters for widget, including scalar values (like title, duration etc.)
			//		and functions, typically callbacks like onClick.
			//		The hash can contain any of the widget's properties, excluding read-only properties.
			// srcNodeRef: DOMNode|String
			//		Attach widget to this DOM node.

			// store pointer to original DOM tree
			this.domNode = dom.byId(srcNodeRef);

			lang.mixin(this, params);
			if(this.id){
				registry.add(this); // add to registry so it can be easily found by id
			}
			this.domNode.style.display = "none";

			this.inherited(arguments, [{
				data: query("option", this.domNode).map(toItem)
			}]);
		},

		destroy: function(){
			registry.remove(this.id);
		},

		fetchSelectedItem: function(){
			// summary:
			//		Get the option marked as selected, like `<option selected>`.
			//		Not part of dojo.data API.
			var option = query("> option[selected]", this.domNode)[0] || query("> option", this.domNode)[0];
			return option && toItem(option);
		}
	});
});

},
'dijit/form/_SearchMixin':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/keys", // keys
	"dojo/_base/lang", // lang.clone lang.hitch
	"dojo/query", // query
	"dojo/string", // string.substitute
	"dojo/when",
	"../registry"	// registry.byId
], function(declare, keys, lang, query, string, when, registry){

	// module:
	//		dijit/form/_SearchMixin


	return declare("dijit.form._SearchMixin", null, {
		// summary:
		//		A mixin that implements the base functionality to search a store based upon user-entered text such as
		//		with `dijit/form/ComboBox` or `dijit/form/FilteringSelect`
		// tags:
		//		protected

		// pageSize: Integer
		//		Argument to data provider.
		//		Specifies maximum number of search results to return per query
		pageSize: Infinity,

		// store: [const] dojo/store/api/Store
		//		Reference to data provider object used by this ComboBox.
		//		The store must accept an object hash of properties for its query. See `query` and `queryExpr` for details.
		store: null,

		// fetchProperties: Object
		//		Mixin to the store's fetch.
		//		For example, to set the sort order of the ComboBox menu, pass:
		//	|	{ sort: [{attribute:"name",descending: true}] }
		//		To override the default queryOptions so that deep=false, do:
		//	|	{ queryOptions: {ignoreCase: true, deep: false} }
		fetchProperties:{},

		// query: Object
		//		A query that can be passed to `store` to initially filter the items.
		//		ComboBox overwrites any reference to the `searchAttr` and sets it to the `queryExpr` with the user's input substituted.
		query: {},

		// list: [const] String
		//		Alternate to specifying a store.  Id of a dijit/form/DataList widget.
		list: "",
		_setListAttr: function(list){
			// Avoid having list applied to the DOM node, since it has native meaning in modern browsers
			this._set("list", list);
		},

		// searchDelay: Integer
		//		Delay in milliseconds between when user types something and we start
		//		searching based on that value
		searchDelay: 200,

		// searchAttr: String
		//		Search for items in the data store where this attribute (in the item)
		//		matches what the user typed
		searchAttr: "name",

		// queryExpr: String
		//		This specifies what query is sent to the data store,
		//		based on what the user has typed.  Changing this expression will modify
		//		whether the results are only exact matches, a "starting with" match,
		//		etc.
		//		`${0}` will be substituted for the user text.
		//		`*` is used for wildcards.
		//		`${0}*` means "starts with", `*${0}*` means "contains", `${0}` means "is"
		queryExpr: "${0}*",

		// ignoreCase: Boolean
		//		Set true if the query should ignore case when matching possible items
		ignoreCase: true,

		_patternToRegExp: function(pattern){
			// summary:
			//		Helper function to convert a simple pattern to a regular expression for matching.
			// description:
			//		Returns a regular expression object that conforms to the defined conversion rules.
			//		For example:
			//
			//		- ca*   -> /^ca.*$/
			//		- *ca*  -> /^.*ca.*$/
			//		- *c\*a*  -> /^.*c\*a.*$/
			//		- *c\*a?*  -> /^.*c\*a..*$/
			//
			//		and so on.
			// pattern: string
			//		A simple matching pattern to convert that follows basic rules:
			//
			//		- * Means match anything, so ca* means match anything starting with ca
			//		- ? Means match single character.  So, b?b will match to bob and bab, and so on.
			//		- \ is an escape character.  So for example, \* means do not treat * as a match, but literal character *.
			//
			//		To use a \ as a character in the string, it must be escaped.  So in the pattern it should be
			//		represented by \\ to be treated as an ordinary \ character instead of an escape.

			return new RegExp("^" + pattern.replace(/(\\.)|(\*)|(\?)|\W/g, function(str, literal, star, question){
				return star ? ".*" : question ? "." : literal ? literal : "\\" + str;
			}) + "$", this.ignoreCase ? "mi" : "m");
		},

		_abortQuery: function(){
			// stop in-progress query
			if(this.searchTimer){
				this.searchTimer = this.searchTimer.remove();
			}
			if(this._queryDeferHandle){
				this._queryDeferHandle = this._queryDeferHandle.remove();
			}
			if(this._fetchHandle){
				if(this._fetchHandle.abort){
					this._cancelingQuery = true;
					this._fetchHandle.abort();
					this._cancelingQuery = false;
				}
				if(this._fetchHandle.cancel){
					this._cancelingQuery = true;
					this._fetchHandle.cancel();
					this._cancelingQuery = false;
				}
				this._fetchHandle = null;
			}
		},

		_processInput: function(/*Event*/ evt){
			// summary:
			//		Handles input (keyboard/paste) events
			if(this.disabled || this.readOnly){ return; }
			var key = evt.charOrCode;

			this._prev_key_backspace = false;

			if (key === keys.DELETE || key === keys.BACKSPACE) {
				this._prev_key_backspace = true;
				this._maskValidSubsetError = true;
			}

			// need to wait a tad before start search so that the event
			// bubbles through DOM and we have value visible
			if(!this.store){
				this.onSearch();
			}else{
				this.searchTimer = this.defer("_startSearchFromInput", 1);
			}
		},

		onSearch: function(/*===== results, query, options =====*/){
			// summary:
			//		Callback when a search completes.
			//
			// results: Object
			//		An array of items from the originating _SearchMixin's store.
			//
			// query: Object
			//		A copy of the originating _SearchMixin's query property.
			//
			// options: Object
			//		The additional parameters sent to the originating _SearchMixin's store, including: start, count, queryOptions.
			//
			// tags:
			//		callback
		},

		_startSearchFromInput: function(){
			this._startSearch(this.focusNode.value);
		},

		_startSearch: function(/*String*/ text){
			// summary:
			//		Starts a search for elements matching text (text=="" means to return all items),
			//		and calls onSearch(...) when the search completes, to display the results.

			this._abortQuery();
			var
				_this = this,
				// Setup parameters to be passed to store.query().
				// Create a new query to prevent accidentally querying for a hidden
				// value from FilteringSelect's keyField
				query = lang.clone(this.query), // #5970
				options = {
					start: 0,
					count: this.pageSize,
					queryOptions: {		// remove for 2.0
						ignoreCase: this.ignoreCase,
						deep: true
					}
				},
				qs = string.substitute(this.queryExpr, [text.replace(/([\\\*\?])/g, "\\$1")]),
				q,
				startQuery = function(){
					var resPromise = _this._fetchHandle = _this.store.query(query, options);
					if(_this.disabled || _this.readOnly || (q !== _this._lastQuery)){
						return;
					} // avoid getting unwanted notify
					when(resPromise, function(res){
						_this._fetchHandle = null;
						if(!_this.disabled && !_this.readOnly && (q === _this._lastQuery)){ // avoid getting unwanted notify
							when(resPromise.total, function(total){
								res.total = total;
								var pageSize = _this.pageSize;
								if(isNaN(pageSize) || pageSize > res.total){ pageSize = res.total; }
								// Setup method to fetching the next page of results
								res.nextPage = function(direction){
									//	tell callback the direction of the paging so the screen
									//	reader knows which menu option to shout
									options.direction = direction = direction !== false;
									options.count = pageSize;
									if(direction){
										options.start += res.length;
										if(options.start >= res.total){
											options.count = 0;
										}
									}else{
										options.start -= pageSize;
										if(options.start < 0){
											options.count = Math.max(pageSize + options.start, 0);
											options.start = 0;
										}
									}
									if(options.count <= 0){
										res.length = 0;
										_this.onSearch(res, query, options);
									}else{
										startQuery();
									}
								};
								_this.onSearch(res, query, options);
							});
						}
					}, function(err){
						_this._fetchHandle = null;
						if(!_this._cancelingQuery){	// don't treat canceled query as an error
							console.error(_this.declaredClass + ' ' + err.toString());
						}
					});
				};

			lang.mixin(options, this.fetchProperties);

			// Generate query
			if(this.store._oldAPI){
				// remove this branch for 2.0
				q = qs;
			}else{
				// Query on searchAttr is a regex for benefit of dojo/store/Memory,
				// but with a toString() method to help dojo/store/JsonRest.
				// Search string like "Co*" converted to regex like /^Co.*$/i.
				q = this._patternToRegExp(qs);
				q.toString = function(){ return qs; };
			}

			// set _lastQuery, *then* start the timeout
			// otherwise, if the user types and the last query returns before the timeout,
			// _lastQuery won't be set and their input gets rewritten
			this._lastQuery = query[this.searchAttr] = q;
			this._queryDeferHandle = this.defer(startQuery, this.searchDelay);
		},

		//////////// INITIALIZATION METHODS ///////////////////////////////////////

		constructor: function(){
			this.query={};
			this.fetchProperties={};
		},

		postMixInProperties: function(){
			if(!this.store){
				var list = this.list;
				if(list){
					this.store = registry.byId(list);
				}
			}
			this.inherited(arguments);
		}
	});
});

},
'dijit/form/_ComboBoxMenu':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/dom-class", // domClass.add domClass.remove
	"dojo/dom-style", // domStyle.get
	"dojo/keys", // keys.DOWN_ARROW keys.PAGE_DOWN keys.PAGE_UP keys.UP_ARROW
	"../_WidgetBase",
	"../_TemplatedMixin",
	"./_ComboBoxMenuMixin",
	"./_ListMouseMixin"
], function(declare, domClass, domStyle, keys,
			_WidgetBase, _TemplatedMixin, _ComboBoxMenuMixin, _ListMouseMixin){


	// module:
	//		dijit/form/_ComboBoxMenu

	return declare("dijit.form._ComboBoxMenu",[_WidgetBase, _TemplatedMixin, _ListMouseMixin, _ComboBoxMenuMixin], {
		// summary:
		//		Focus-less menu for internal use in `dijit/form/ComboBox`
		//		Abstract methods that must be defined externally:
		//
		//		- onChange: item was explicitly chosen (mousedown somewhere on the menu and mouseup somewhere on the menu)
		//		- onPage: next(1) or previous(-1) button pressed
		// tags:
		//		private

		// TODO for 2.0 or earlier: stop putting stuff inside this.containerNode.   Switch to using this.domNode
		// or a different attach point.    See _TemplatedMixin::searchContainerNode.
		templateString: "<div class='dijitReset dijitMenu' data-dojo-attach-point='containerNode' style='overflow: auto; overflow-x: hidden;' role='listbox'>"
				+"<div class='dijitMenuItem dijitMenuPreviousButton' data-dojo-attach-point='previousButton' role='option'></div>"
				+"<div class='dijitMenuItem dijitMenuNextButton' data-dojo-attach-point='nextButton' role='option'></div>"
				+"</div>",

		baseClass: "dijitComboBoxMenu",

		postCreate: function(){
			this.inherited(arguments);
			if(!this.isLeftToRight()){
				domClass.add(this.previousButton, "dijitMenuItemRtl");
				domClass.add(this.nextButton, "dijitMenuItemRtl");
			}
			this.containerNode.setAttribute("role","listbox");
		},

		_createMenuItem: function(){
			// note: not using domConstruct.create() because need to specify document
			var item = this.ownerDocument.createElement("div");
			item.className = "dijitReset dijitMenuItem" +(this.isLeftToRight() ? "" : " dijitMenuItemRtl");
			item.setAttribute("role", "option");
			return item;
		},

		onHover: function(/*DomNode*/ node){
			// summary:
			//		Add hover CSS
			domClass.add(node, "dijitMenuItemHover");
		},

		onUnhover: function(/*DomNode*/ node){
			// summary:
			//		Remove hover CSS
			domClass.remove(node, "dijitMenuItemHover");
		},

		onSelect: function(/*DomNode*/ node){
			// summary:
			//		Add selected CSS
			domClass.add(node, "dijitMenuItemSelected");
		},

		onDeselect: function(/*DomNode*/ node){
			// summary:
			//		Remove selected CSS
			domClass.remove(node, "dijitMenuItemSelected");
		},

		_page: function(/*Boolean*/ up){
			// summary:
			//		Handles page-up and page-down keypresses

			var scrollamount = 0;
			var oldscroll = this.domNode.scrollTop;
			var height = domStyle.get(this.domNode, "height");
			// if no item is highlighted, highlight the first option
			if(!this.getHighlightedOption()){
				this.selectNextNode();
			}
			while(scrollamount<height){
				var highlighted_option = this.getHighlightedOption();
				if(up){
					// stop at option 1
					if(!highlighted_option.previousSibling ||
						highlighted_option.previousSibling.style.display == "none"){
						break;
					}
					this.selectPreviousNode();
				}else{
					// stop at last option
					if(!highlighted_option.nextSibling ||
						highlighted_option.nextSibling.style.display == "none"){
						break;
					}
					this.selectNextNode();
				}
				// going backwards
				var newscroll = this.domNode.scrollTop;
				scrollamount += (newscroll-oldscroll)*(up ? -1:1);
				oldscroll = newscroll;
			}
		},

		handleKey: function(evt){
			// summary:
			//		Handle keystroke event forwarded from ComboBox, returning false if it's
			//		a keystroke I recognize and process, true otherwise.
			switch(evt.keyCode){
				case keys.DOWN_ARROW:
					this.selectNextNode();
					return false;
				case keys.PAGE_DOWN:
					this._page(false);
					return false;
				case keys.UP_ARROW:
					this.selectPreviousNode();
					return false;
				case keys.PAGE_UP:
					this._page(true);
					return false;
				default:
					return true;
			}
		}
	});
});

},
'dijit/form/_ComboBoxMenuMixin':function(){
define([
	"dojo/_base/array", // array.forEach
	"dojo/_base/declare", // declare
	"dojo/dom-attr", // domAttr.set
	"dojo/has",
	"dojo/i18n", // i18n.getLocalization
	"dojo/i18n!./nls/ComboBox"
], function(array, declare, domAttr, has, i18n){

	// module:
	//		dijit/form/_ComboBoxMenuMixin

	var ComboBoxMenuMixin = declare("dijit.form._ComboBoxMenuMixin" + (has("dojo-bidi") ? "_NoBidi" : ""), null, {
		// summary:
		//		Focus-less menu for internal use in `dijit/form/ComboBox`
		// tags:
		//		private

		// _messages: Object
		//		Holds "next" and "previous" text for paging buttons on drop down
		_messages: null,

		postMixInProperties: function(){
			this.inherited(arguments);
			this._messages = i18n.getLocalization("dijit.form", "ComboBox", this.lang);
		},

		buildRendering: function(){
			this.inherited(arguments);

			// fill in template with i18n messages
			this.previousButton.innerHTML = this._messages["previousMessage"];
			this.nextButton.innerHTML = this._messages["nextMessage"];
		},

		_setValueAttr: function(/*Object*/ value){
			this._set("value", value);
			this.onChange(value);
		},

		onClick: function(/*DomNode*/ node){
			if(node == this.previousButton){
				this._setSelectedAttr(null);
				this.onPage(-1);
			}else if(node == this.nextButton){
				this._setSelectedAttr(null);
				this.onPage(1);
			}else{
				this.onChange(node);
			}
		},

		// stubs
		onChange: function(/*Number*/ /*===== direction =====*/){
			// summary:
			//		Notifies ComboBox/FilteringSelect that user selected an option.
			// tags:
			//		callback
		},

		onPage: function(/*Number*/ /*===== direction =====*/){
			// summary:
			//		Notifies ComboBox/FilteringSelect that user clicked to advance to next/previous page.
			// tags:
			//		callback
		},

		onClose: function(){
			// summary:
			//		Callback from dijit.popup code to this widget, notifying it that it closed
			// tags:
			//		private
			this._setSelectedAttr(null);
		},

		_createOption: function(/*Object*/ item, labelFunc){
			// summary:
			//		Creates an option to appear on the popup menu subclassed by
			//		`dijit/form/FilteringSelect`.

			var menuitem = this._createMenuItem();
			var labelObject = labelFunc(item);
			if(labelObject.html){
				menuitem.innerHTML = labelObject.label;
			}else{
				menuitem.appendChild(
					menuitem.ownerDocument.createTextNode(labelObject.label)
				);
			}
			// #3250: in blank options, assign a normal height
			if(menuitem.innerHTML == ""){
				menuitem.innerHTML = "&#160;";	// &nbsp;
			}

			return menuitem;
		},

		createOptions: function(results, options, labelFunc){
			// summary:
			//		Fills in the items in the drop down list
			// results:
			//		Array of items
			// options:
			//		The options to the query function of the store
			//
			// labelFunc:
			//		Function to produce a label in the drop down list from a dojo.data item

			this.items = results;

			// display "Previous . . ." button
			this.previousButton.style.display = (options.start == 0) ? "none" : "";
			domAttr.set(this.previousButton, "id", this.id + "_prev");
			// create options using _createOption function defined by parent
			// ComboBox (or FilteringSelect) class
			// #2309:
			//		iterate over cache nondestructively
			array.forEach(results, function(item, i){
				var menuitem = this._createOption(item, labelFunc);
				menuitem.setAttribute("item", i);	// index to this.items; use indirection to avoid mem leak
				domAttr.set(menuitem, "id", this.id + i);
				this.nextButton.parentNode.insertBefore(menuitem, this.nextButton);
			}, this);
			// display "Next . . ." button
			var displayMore = false;
			// Try to determine if we should show 'more'...
			if(results.total && !results.total.then && results.total != -1){
				if((options.start + options.count) < results.total){
					displayMore = true;
				}else if((options.start + options.count) > results.total && options.count == results.length){
					// Weird return from a data store, where a start + count > maxOptions
					// implies maxOptions isn't really valid and we have to go into faking it.
					// And more or less assume more if count == results.length
					displayMore = true;
				}
			}else if(options.count == results.length){
				//Don't know the size, so we do the best we can based off count alone.
				//So, if we have an exact match to count, assume more.
				displayMore = true;
			}

			this.nextButton.style.display = displayMore ? "" : "none";
			domAttr.set(this.nextButton, "id", this.id + "_next");
		},

		clearResultList: function(){
			// summary:
			//		Clears the entries in the drop down list, but of course keeps the previous and next buttons.
			var container = this.containerNode;
			while(container.childNodes.length > 2){
				container.removeChild(container.childNodes[container.childNodes.length - 2]);
			}
			this._setSelectedAttr(null);
		},

		highlightFirstOption: function(){
			// summary:
			//		Highlight the first real item in the list (not Previous Choices).
			this.selectFirstNode();
		},

		highlightLastOption: function(){
			// summary:
			//		Highlight the last real item in the list (not More Choices).
			this.selectLastNode();
		},

		selectFirstNode: function(){
			this.inherited(arguments);
			if(this.getHighlightedOption() == this.previousButton){
				this.selectNextNode();
			}
		},

		selectLastNode: function(){
			this.inherited(arguments);
			if(this.getHighlightedOption() == this.nextButton){
				this.selectPreviousNode();
			}
		},

		getHighlightedOption: function(){
			return this.selected;
		}
	});

	if(has("dojo-bidi")){
		ComboBoxMenuMixin = declare("dijit.form._ComboBoxMenuMixin", ComboBoxMenuMixin, {
			_createOption: function(){
				var menuitem = this.inherited(arguments);

				// update menuitem.dir if BidiSupport was required
				this.applyTextDir(menuitem);

				return menuitem;
			}
		});
	}

	return ComboBoxMenuMixin;
});

},
'dijit/form/_ListMouseMixin':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/on",
	"dojo/touch",
	"./_ListBase"
], function(declare, on, touch, _ListBase){

	// module:
	//		dijit/form/_ListMouseMixin

	return declare("dijit.form._ListMouseMixin", _ListBase, {
		// summary:
		//		A mixin to handle mouse or touch events for a focus-less menu
		//		Abstract methods that must be defined externally:
		//
		//		- onClick: item was chosen (mousedown somewhere on the menu and mouseup somewhere on the menu)
		// tags:
		//		private

		postCreate: function(){
			this.inherited(arguments);

			// Add flag to use normalized click handling from dojo/touch
			this.domNode.dojoClick = true;

			this._listConnect("click", "_onClick");
			this._listConnect("mousedown", "_onMouseDown");
			this._listConnect("mouseup", "_onMouseUp");
			this._listConnect("mouseover", "_onMouseOver");
			this._listConnect("mouseout", "_onMouseOut");
		},

		_onClick: function(/*Event*/ evt, /*DomNode*/ target){
			this._setSelectedAttr(target, false);
			if(this._deferredClick){
				this._deferredClick.remove();
			}
			this._deferredClick = this.defer(function(){
				this._deferredClick = null;
				this.onClick(target);
			});
		},

		_onMouseDown: function(/*Event*/ evt, /*DomNode*/ target){
			if(this._hoveredNode){
				this.onUnhover(this._hoveredNode);
				this._hoveredNode = null;
			}
			this._isDragging = true;
			this._setSelectedAttr(target, false);
		},

		_onMouseUp: function(/*Event*/ evt, /*DomNode*/ target){
			this._isDragging = false;
			var selectedNode = this.selected;
			var hoveredNode = this._hoveredNode;
			if(selectedNode && target == selectedNode){
				this.defer(function(){
					this._onClick(evt, selectedNode);
				});
			}else if(hoveredNode){ // drag to select
				this.defer(function(){
					this._onClick(evt, hoveredNode);
				});
			}
		},

		_onMouseOut: function(/*Event*/ evt, /*DomNode*/ target){
			if(this._hoveredNode){
				this.onUnhover(this._hoveredNode);
				this._hoveredNode = null;
			}
			if(this._isDragging){
				this._cancelDrag = (new Date()).getTime() + 1000; // cancel in 1 second if no _onMouseOver fires
			}
		},

		_onMouseOver: function(/*Event*/ evt, /*DomNode*/ target){
			if(this._cancelDrag){
				var time = (new Date()).getTime();
				if(time > this._cancelDrag){
					this._isDragging = false;
				}
				this._cancelDrag = null;
			}
			this._hoveredNode = target;
			this.onHover(target);
			if(this._isDragging){
				this._setSelectedAttr(target, false);
			}
		}
	});
});

},
'dijit/form/_ListBase':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/on",
	"dojo/window" // winUtils.scrollIntoView
], function(declare, on, winUtils){

	// module:
	//		dijit/form/_ListBase

	return declare("dijit.form._ListBase", null, {
		// summary:
		//		Focus-less menu to handle UI events consistently.
		//		Abstract methods that must be defined externally:
		//
		//		- onSelect: item is active (mousedown but not yet mouseup, or keyboard arrow selected but no Enter)
		//		- onDeselect:  cancels onSelect
		// tags:
		//		private

		// selected: DOMNode
		//		currently selected node
		selected: null,

		_listConnect: function(/*String|Function*/ eventType, /*String*/ callbackFuncName){
			// summary:
			//		Connects 'containerNode' to specified method of this object
			//		and automatically registers for 'disconnect' on widget destroy.
			// description:
			//		Provide widget-specific analog to 'connect'.
			//		The callback function is called with the normal event object,
			//		but also a second parameter is passed that indicates which list item
			//		actually received the event.
			// returns:
			//		A handle that can be passed to `disconnect` in order to disconnect
			//		before the widget is destroyed.
			// tags:
			//		private

			var self = this;
			return self.own(on(self.containerNode,
				on.selector(
					function(eventTarget, selector, target){
						return eventTarget.parentNode == target;
					},
					eventType
				),
				function(evt){
					self[callbackFuncName](evt, this);
				}
			));
		},

		selectFirstNode: function(){
			// summary:
			//		Select the first displayed item in the list.
			var first = this.containerNode.firstChild;
			while(first && first.style.display == "none"){
				first = first.nextSibling;
			}
			this._setSelectedAttr(first, true);
		},

		selectLastNode: function(){
			// summary:
			//		Select the last displayed item in the list
			var last = this.containerNode.lastChild;
			while(last && last.style.display == "none"){
				last = last.previousSibling;
			}
			this._setSelectedAttr(last, true);
		},

		selectNextNode: function(){
			// summary:
			//		Select the item just below the current selection.
			//		If nothing selected, select first node.
			var selectedNode = this.selected;
			if(!selectedNode){
				this.selectFirstNode();
			}else{
				var next = selectedNode.nextSibling;
				while(next && next.style.display == "none"){
					next = next.nextSibling;
				}
				if(!next){
					this.selectFirstNode();
				}else{
					this._setSelectedAttr(next, true);
				}
			}
		},

		selectPreviousNode: function(){
			// summary:
			//		Select the item just above the current selection.
			//		If nothing selected, select last node (if
			//		you select Previous and try to keep scrolling up the list).
			var selectedNode = this.selected;
			if(!selectedNode){
				this.selectLastNode();
			}else{
				var prev = selectedNode.previousSibling;
				while(prev && prev.style.display == "none"){
					prev = prev.previousSibling;
				}
				if(!prev){
					this.selectLastNode();
				}else{
					this._setSelectedAttr(prev, true);
				}
			}
		},

		_setSelectedAttr: function(/*DomNode*/ node, /*Boolean*/ scroll){
			// summary:
			//		Does the actual select.
			// node:
			//		The option to select
			// scroll:
			//		If necessary, scroll node into view.  Set to false for mouse/touch to
			//		avoid jumping problems on mobile/RTL, see https://bugs.dojotoolkit.org/ticket/17739.
			if(this.selected != node){
				var selectedNode = this.selected;
				if(selectedNode){
					this.onDeselect(selectedNode);
				}
				if(node){
					if(scroll){
						winUtils.scrollIntoView(node);
					}
					this.onSelect(node);
				}
				this._set("selected", node);
			}else if(node){
				this.onSelect(node);
			}
		}
	});
});

},
'dijit/_HasDropDown':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/_base/Deferred",
	"dojo/dom", // dom.isDescendant
	"dojo/dom-attr", // domAttr.set
	"dojo/dom-class", // domClass.add domClass.contains domClass.remove
	"dojo/dom-geometry", // domGeometry.marginBox domGeometry.position
	"dojo/dom-style", // domStyle.set
	"dojo/has", // has("touch")
	"dojo/keys", // keys.DOWN_ARROW keys.ENTER keys.ESCAPE
	"dojo/_base/lang", // lang.hitch lang.isFunction
	"dojo/on",
	"dojo/touch",
	"./registry", // registry.byNode()
	"./focus",
	"./popup",
	"./_FocusMixin"
], function(declare, Deferred, dom, domAttr, domClass, domGeometry, domStyle, has, keys, lang, on, touch,
			registry, focus, popup, _FocusMixin){


	// module:
	//		dijit/_HasDropDown

	return declare("dijit._HasDropDown", _FocusMixin, {
		// summary:
		//		Mixin for widgets that need drop down ability.

		// _buttonNode: [protected] DomNode
		//		The button/icon/node to click to display the drop down.
		//		Can be set via a data-dojo-attach-point assignment.
		//		If missing, then either focusNode or domNode (if focusNode is also missing) will be used.
		_buttonNode: null,

		// _arrowWrapperNode: [protected] DomNode
		//		Will set CSS class dijitUpArrow, dijitDownArrow, dijitRightArrow etc. on this node depending
		//		on where the drop down is set to be positioned.
		//		Can be set via a data-dojo-attach-point assignment.
		//		If missing, then _buttonNode will be used.
		_arrowWrapperNode: null,

		// _popupStateNode: [protected] DomNode
		//		The node to set the aria-expanded class on.
		//		Also sets popupActive class but that will be removed in 2.0.
		//		Can be set via a data-dojo-attach-point assignment.
		//		If missing, then focusNode or _buttonNode (if focusNode is missing) will be used.
		_popupStateNode: null,

		// _aroundNode: [protected] DomNode
		//		The node to display the popup around.
		//		Can be set via a data-dojo-attach-point assignment.
		//		If missing, then domNode will be used.
		_aroundNode: null,

		// dropDown: [protected] Widget
		//		The widget to display as a popup.  This widget *must* be
		//		defined before the startup function is called.
		dropDown: null,

		// autoWidth: [protected] Boolean
		//		Set to true to make the drop down at least as wide as this
		//		widget.  Set to false if the drop down should just be its
		//		default width.
		autoWidth: true,

		// forceWidth: [protected] Boolean
		//		Set to true to make the drop down exactly as wide as this
		//		widget.  Overrides autoWidth.
		forceWidth: false,

		// maxHeight: [protected] Integer
		//		The max height for our dropdown.
		//		Any dropdown taller than this will have scrollbars.
		//		Set to 0 for no max height, or -1 to limit height to available space in viewport
		maxHeight: -1,

		// dropDownPosition: [const] String[]
		//		This variable controls the position of the drop down.
		//		It's an array of strings with the following values:
		//
		//		- before: places drop down to the left of the target node/widget, or to the right in
		//		  the case of RTL scripts like Hebrew and Arabic
		//		- after: places drop down to the right of the target node/widget, or to the left in
		//		  the case of RTL scripts like Hebrew and Arabic
		//		- above: drop down goes above target node
		//		- below: drop down goes below target node
		//
		//		The list is positions is tried, in order, until a position is found where the drop down fits
		//		within the viewport.
		//
		dropDownPosition: ["below", "above"],

		// _stopClickEvents: Boolean
		//		When set to false, the click events will not be stopped, in
		//		case you want to use them in your subclass
		_stopClickEvents: true,

		_onDropDownMouseDown: function(/*Event*/ e){
			// summary:
			//		Callback when the user mousedown/touchstart on the arrow icon.

			if(this.disabled || this.readOnly){
				return;
			}

			// Prevent default to stop things like text selection, but don't stop propagation, so that:
			//		1. TimeTextBox etc. can focus the <input> on mousedown
			//		2. dropDownButtonActive class applied by _CssStateMixin (on button depress)
			//		3. user defined onMouseDown handler fires
			//
			// Also, don't call preventDefault() on MSPointerDown event (on IE10) because that prevents the button
			// from getting focus, and then the focus manager doesn't know what's going on (#17262)
			if(e.type != "MSPointerDown"){
				e.preventDefault();
			}

			this.own(on.once(this.ownerDocument, touch.release, lang.hitch(this, "_onDropDownMouseUp")));

			this.toggleDropDown();
		},

		_onDropDownMouseUp: function(/*Event?*/ e){
			// summary:
			//		Callback on mouseup/touchend after mousedown/touchstart on the arrow icon.
			//		Note that this function is called regardless of what node the event occurred on (but only after
			//		a mousedown/touchstart on the arrow).
			//
			//		If the drop down is a simple menu and the cursor is over the menu, we execute it, otherwise, we focus our
			//		drop down widget.  If the event is missing, then we are not
			//		a mouseup event.
			//
			//		This is useful for the common mouse movement pattern
			//		with native browser `<select>` nodes:
			//
			//		1. mouse down on the select node (probably on the arrow)
			//		2. move mouse to a menu item while holding down the mouse button
			//		3. mouse up.  this selects the menu item as though the user had clicked it.

			var dropDown = this.dropDown, overMenu = false;

			if(e && this._opened){
				// This code deals with the corner-case when the drop down covers the original widget,
				// because it's so large.  In that case mouse-up shouldn't select a value from the menu.
				// Find out if our target is somewhere in our dropdown widget,
				// but not over our _buttonNode (the clickable node)
				var c = domGeometry.position(this._buttonNode, true);
				if(!(e.pageX >= c.x && e.pageX <= c.x + c.w) || !(e.pageY >= c.y && e.pageY <= c.y + c.h)){
					var t = e.target;
					while(t && !overMenu){
						if(domClass.contains(t, "dijitPopup")){
							overMenu = true;
						}else{
							t = t.parentNode;
						}
					}
					if(overMenu){
						t = e.target;
						if(dropDown.onItemClick){
							var menuItem;
							while(t && !(menuItem = registry.byNode(t))){
								t = t.parentNode;
							}
							if(menuItem && menuItem.onClick && menuItem.getParent){
								menuItem.getParent().onItemClick(menuItem, e);
							}
						}
						return;
					}
				}
			}
			if(this._opened){
				// Focus the dropdown widget unless it's a menu (in which case autoFocus is set to false).
				// Even if it's a menu, we need to focus it if this is a fake mouse event caused by the user typing
				// SPACE/ENTER while using JAWS.  Jaws converts the SPACE/ENTER key into mousedown/mouseup events.
				// If this.hovering is false then it's presumably actually a keyboard event.
				if(dropDown.focus && (dropDown.autoFocus !== false || (e.type == "mouseup" && !this.hovering))){
					// Do it on a delay so that we don't steal back focus from the dropdown.
					this._focusDropDownTimer = this.defer(function(){
						dropDown.focus();
						delete this._focusDropDownTimer;
					});
				}
			}else{
				// The drop down arrow icon probably can't receive focus, but widget itself should get focus.
				// defer() needed to make it work on IE (test DateTextBox)
				if(this.focus){
					this.defer("focus");
				}
			}
		},

		_onDropDownClick: function(/*Event*/ e){
			// The drop down was already opened on mousedown/keydown; just need to stop the event
			if(this._stopClickEvents){
				e.stopPropagation();
				e.preventDefault();
			}
		},

		buildRendering: function(){
			this.inherited(arguments);

			this._buttonNode = this._buttonNode || this.focusNode || this.domNode;
			this._popupStateNode = this._popupStateNode || this.focusNode || this._buttonNode;

			// Add a class to the "dijitDownArrowButton" type class to _buttonNode so theme can set direction of arrow
			// based on where drop down will normally appear
			var defaultPos = {
				"after": this.isLeftToRight() ? "Right" : "Left",
				"before": this.isLeftToRight() ? "Left" : "Right",
				"above": "Up",
				"below": "Down",
				"left": "Left",
				"right": "Right"
			}[this.dropDownPosition[0]] || this.dropDownPosition[0] || "Down";
			domClass.add(this._arrowWrapperNode || this._buttonNode, "dijit" + defaultPos + "ArrowButton");
		},

		postCreate: function(){
			// summary:
			//		set up nodes and connect our mouse and keyboard events

			this.inherited(arguments);

			var keyboardEventNode = this.focusNode || this.domNode;
			this.own(
				on(this._buttonNode, touch.press, lang.hitch(this, "_onDropDownMouseDown")),
				on(this._buttonNode, "click", lang.hitch(this, "_onDropDownClick")),
				on(keyboardEventNode, "keydown", lang.hitch(this, "_onKey")),
				on(keyboardEventNode, "keyup", lang.hitch(this, "_onKeyUp"))
			);
		},

		destroy: function(){
			// If dropdown is open, close it, to avoid leaving dijit/focus in a strange state.
			// Put focus back on me to avoid the focused node getting destroyed, which flummoxes IE.
			if(this._opened){
				this.closeDropDown(true);
			}

			if(this.dropDown){
				// Destroy the drop down, unless it's already been destroyed.  This can happen because
				// the drop down is a direct child of <body> even though it's logically my child.
				if(!this.dropDown._destroyed){
					this.dropDown.destroyRecursive();
				}
				delete this.dropDown;
			}
			this.inherited(arguments);
		},

		_onKey: function(/*Event*/ e){
			// summary:
			//		Callback when the user presses a key while focused on the button node

			if(this.disabled || this.readOnly){
				return;
			}
			var d = this.dropDown, target = e.target;
			if(d && this._opened && d.handleKey){
				if(d.handleKey(e) === false){
					/* false return code means that the drop down handled the key */
					e.stopPropagation();
					e.preventDefault();
					return;
				}
			}
			if(d && this._opened && e.keyCode == keys.ESCAPE){
				this.closeDropDown();
				e.stopPropagation();
				e.preventDefault();
			}else if(!this._opened &&
				(e.keyCode == keys.DOWN_ARROW ||
					// ignore unmodified SPACE if _KeyNavMixin has active searching in progress
					( (e.keyCode == keys.ENTER || (e.keyCode == keys.SPACE && (!this._searchTimer || (e.ctrlKey || e.altKey || e.metaKey)))) &&
						//ignore enter and space if the event is for a text input
						((target.tagName || "").toLowerCase() !== 'input' ||
							(target.type && target.type.toLowerCase() !== 'text'))))){
				// Toggle the drop down, but wait until keyup so that the drop down doesn't
				// get a stray keyup event, or in the case of key-repeat (because user held
				// down key for too long), stray keydown events
				this._toggleOnKeyUp = true;
				e.stopPropagation();
				e.preventDefault();
			}
		},

		_onKeyUp: function(){
			if(this._toggleOnKeyUp){
				delete this._toggleOnKeyUp;
				this.toggleDropDown();
				var d = this.dropDown;	// drop down may not exist until toggleDropDown() call
				if(d && d.focus){
					this.defer(lang.hitch(d, "focus"), 1);
				}
			}
		},

		_onBlur: function(){
			// summary:
			//		Called magically when focus has shifted away from this widget and it's dropdown

			// Close dropdown but don't focus my <input>.  User may have focused somewhere else (ex: clicked another
			// input), and even if they just clicked a blank area of the screen, focusing my <input> will unwantedly
			// popup the keyboard on mobile.
			this.closeDropDown(false);

			this.inherited(arguments);
		},

		isLoaded: function(){
			// summary:
			//		Returns true if the dropdown exists and it's data is loaded.  This can
			//		be overridden in order to force a call to loadDropDown().
			// tags:
			//		protected

			return true;
		},

		loadDropDown: function(/*Function*/ loadCallback){
			// summary:
			//		Creates the drop down if it doesn't exist, loads the data
			//		if there's an href and it hasn't been loaded yet, and then calls
			//		the given callback.
			// tags:
			//		protected

			// TODO: for 2.0, change API to return a Deferred, instead of calling loadCallback?
			loadCallback();
		},

		loadAndOpenDropDown: function(){
			// summary:
			//		Creates the drop down if it doesn't exist, loads the data
			//		if there's an href and it hasn't been loaded yet, and
			//		then opens the drop down.  This is basically a callback when the
			//		user presses the down arrow button to open the drop down.
			// returns: Deferred
			//		Deferred for the drop down widget that
			//		fires when drop down is created and loaded
			// tags:
			//		protected
			var d = new Deferred(),
				afterLoad = lang.hitch(this, function(){
					this.openDropDown();
					d.resolve(this.dropDown);
				});
			if(!this.isLoaded()){
				this.loadDropDown(afterLoad);
			}else{
				afterLoad();
			}
			return d;
		},

		toggleDropDown: function(){
			// summary:
			//		Callback when the user presses the down arrow button or presses
			//		the down arrow key to open/close the drop down.
			//		Toggle the drop-down widget; if it is up, close it, if not, open it
			// tags:
			//		protected

			if(this.disabled || this.readOnly){
				return;
			}
			if(!this._opened){
				this.loadAndOpenDropDown();
			}else{
				this.closeDropDown(true);	// refocus button to avoid hiding node w/focus
			}
		},

		openDropDown: function(){
			// summary:
			//		Opens the dropdown for this widget.   To be called only when this.dropDown
			//		has been created and is ready to display (ie, it's data is loaded).
			// returns:
			//		return value of dijit/popup.open()
			// tags:
			//		protected

			var dropDown = this.dropDown,
				ddNode = dropDown.domNode,
				aroundNode = this._aroundNode || this.domNode,
				self = this;

			var retVal = popup.open({
				parent: this,
				popup: dropDown,
				around: aroundNode,
				orient: this.dropDownPosition,
				maxHeight: this.maxHeight,
				onExecute: function(){
					self.closeDropDown(true);
				},
				onCancel: function(){
					self.closeDropDown(true);
				},
				onClose: function(){
					domAttr.set(self._popupStateNode, "popupActive", false);
					domClass.remove(self._popupStateNode, "dijitHasDropDownOpen");
					self._set("_opened", false);	// use set() because _CssStateMixin is watching
				}
			});

			// Set width of drop down if necessary, so that dropdown width + width of scrollbar (from popup wrapper)
			// matches width of aroundNode
			if(this.forceWidth || (this.autoWidth && aroundNode.offsetWidth > dropDown._popupWrapper.offsetWidth)){
				var widthAdjust = aroundNode.offsetWidth - dropDown._popupWrapper.offsetWidth;
				var resizeArgs = {
					w: dropDown.domNode.offsetWidth + widthAdjust
				};
				this._origStyle = ddNode.style.cssText;
				if(lang.isFunction(dropDown.resize)){
					dropDown.resize(resizeArgs);
				}else{
					domGeometry.setMarginBox(ddNode, resizeArgs);
				}

				// If dropdown is right-aligned then compensate for width change by changing horizontal position
				if(retVal.corner[1] == "R"){
					dropDown._popupWrapper.style.left =
						(dropDown._popupWrapper.style.left.replace("px", "") - widthAdjust) + "px";
				}
			}

			domAttr.set(this._popupStateNode, "popupActive", "true");
			domClass.add(this._popupStateNode, "dijitHasDropDownOpen");
			this._set("_opened", true);	// use set() because _CssStateMixin is watching

			this._popupStateNode.setAttribute("aria-expanded", "true");
			this._popupStateNode.setAttribute("aria-owns", dropDown.id);

			// Set aria-labelledby on dropdown if it's not already set to something more meaningful
			if(ddNode.getAttribute("role") !== "presentation" && !ddNode.getAttribute("aria-labelledby")){
				ddNode.setAttribute("aria-labelledby", this.id);
			}

			return retVal;
		},

		closeDropDown: function(/*Boolean*/ focus){
			// summary:
			//		Closes the drop down on this widget
			// focus:
			//		If true, refocuses the button widget
			// tags:
			//		protected

			if(this._focusDropDownTimer){
				this._focusDropDownTimer.remove();
				delete this._focusDropDownTimer;
			}

			if(this._opened){
				this._popupStateNode.setAttribute("aria-expanded", "false");
				if(focus && this.focus){
					this.focus();
				}
				popup.close(this.dropDown);
				this._opened = false;
			}

			if(this._origStyle){
				this.dropDown.domNode.style.cssText = this._origStyle;
				delete this._origStyle;
			}
		}
	});
});

},
'soso/dijit/form/_ComboBoxMenuDeletable':function(){
define([
    "dojo/_base/declare",
    "dojo/dom-class",
    "dijit/form/_ComboBoxMenu"
], function(declare, domClass, _ComboBoxMenu) {
    return declare("soso.dijit.form._ComboBoxMenuDeletable", [_ComboBoxMenu], {
        _onClick: function(/*Event*/ evt, /*DomNode*/ target){
            this._setSelectedAttr(target);
            if(this._deferredClick){
                this._deferredClick.remove();
            }
            this._deferredClick = this.defer(function(){
                this._deferredClick = null;
                this.onClick(target, evt);
            });
        },

        onClick: function(/*DomNode*/ node, evt){
            if (node == this.previousButton) {
                this._setSelectedAttr(null);
                this.onPage(-1);
            } else if (node == this.nextButton) {
                this._setSelectedAttr(null);
                this.onPage(1);
            } else if (domClass.contains(evt.target, "deleteButton")) {
                this._setSelectedAttr(null);
                this.onDelete(evt.target);
            } else {
                this.onChange(node);
            }
        },

        onDelete: function() {
            // summary:
            //		Notifies ComboBox/FilteringSelect that user deleted an option.
            // tags:
            //		callback
        }
    })
})
},
'soso/dijit/form/_ShortQueryMixin':function(){
define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "dojo/string",
    "dojo/when"
], function(declare, lang, string, when) {
    return declare("soso.dijit.form._ShortQueryMixin", null, {
        // Set this to > 0 if you want to force a minimum length of query before a search is triggered
        minQueryLength: 0,

        // Set this to > 0 to delay searches by shortQueryDelay for shorter search terms
        shortQueryLength: 0,

        // Delay applied to shortQueryLength searches
        shortQueryDelay: 1000,

        _startSearch: function(/*String*/ text){
            // summary:
            //      Starts a search for elements matching text (text=="" means to return all items),
            //      and calls onSearch(...) when the search completes, to display the results.

            // Only continue if the entered text meets the minimum query length
            if (this.minQueryLength && lang.trim(text).length < this.minQueryLength) {
                if (this.dropDown && this._opened) {
                    this.closeDropDown();
                }
                return;
            }

            //
            // _AutoCompleterMixin extension start
            //
            if(!this.dropDown){
                var popupId = this.id + "_popup",
                    dropDownConstructor = lang.isString(this.dropDownClass) ?
                        lang.getObject(this.dropDownClass, false) : this.dropDownClass;
                this.dropDown = new dropDownConstructor({
                    onChange: lang.hitch(this, this._selectOption),
                    // This doesn't belong here, but I can't think of a better place to put it
                    onDelete: lang.hitch(this, this._deleteOption),
                    id: popupId,
                    dir: this.dir,
                    textDir: this.textDir
                });
            }
            this._lastInput = text; // Store exactly what was entered by the user.
            //
            // _AutoCompleterMixin extension end
            //

            //
            // _SearchMixin start
            //
            this._abortQuery();
            var
                _this = this,
                // Setup parameters to be passed to store.query().
                // Create a new query to prevent accidentally querying for a hidden
                // value from FilteringSelect's keyField
                query = lang.clone(this.query), // #5970
                options = {
                    start: 0,
                    count: this.pageSize,
                    queryOptions: {		// remove for 2.0
                        ignoreCase: this.ignoreCase,
                        deep: true
                    }
                },
                qs = string.substitute(this.queryExpr, [text.replace(/([\\\*\?])/g, "\\$1")]),
                q,
                startQuery = function(){
                    var resPromise = _this._fetchHandle = _this.store.query(query, options);
                    if(_this.disabled || _this.readOnly || (q !== _this._lastQuery)){
                        return;
                    } // avoid getting unwanted notify
                    when(resPromise, function(res){
                        _this._fetchHandle = null;
                        if(!_this.disabled && !_this.readOnly && (q === _this._lastQuery)){ // avoid unwanted notify
                            when(resPromise.total, function(total){
                                res.total = total;
                                var pageSize = _this.pageSize;
                                if(isNaN(pageSize) || pageSize > res.total){ pageSize = res.total; }
                                // Setup method to fetching the next page of results
                                res.nextPage = function(direction){
                                    //	tell callback the direction of the paging so the screen
                                    //	reader knows which menu option to shout
                                    options.direction = direction = direction !== false;
                                    options.count = pageSize;
                                    if(direction){
                                        options.start += res.length;
                                        if(options.start >= res.total){
                                            options.count = 0;
                                        }
                                    }else{
                                        options.start -= pageSize;
                                        if(options.start < 0){
                                            options.count = Math.max(pageSize + options.start, 0);
                                            options.start = 0;
                                        }
                                    }
                                    if(options.count <= 0){
                                        res.length = 0;
                                        _this.onSearch(res, query, options);
                                    }else{
                                        startQuery();
                                    }
                                };
                                _this.onSearch(res, query, options);
                            });
                        }
                    }, function(err){
                        _this._fetchHandle = null;
                        if(!_this._cancelingQuery){	// don't treat canceled query as an error
                            console.error(_this.declaredClass + ' ' + err.toString());
                        }
                    });
                };

            lang.mixin(options, this.fetchProperties);

            // Generate query
            if(this.store._oldAPI){
                // remove this branch for 2.0
                q = qs;
            }else{
                // Query on searchAttr is a regex for benefit of dojo/store/Memory,
                // but with a toString() method to help dojo/store/JsonRest.
                // Search string like "Co*" converted to regex like /^Co.*$/i.
                q = this._patternToRegExp(qs);
                q.toString = function(){ return qs; };
            }

            // set _lastQuery, *then* start the timeout
            // otherwise, if the user types and the last query returns before the timeout,
            // _lastQuery won't be set and their input gets rewritten
            this._lastQuery = query[this.searchAttr] = q;
            // Delay search by searchDelay if string is >= than shortQueryLength. Otherwise use shortQueryDelay.
            this._queryDeferHandle = this.defer(
                startQuery,
                (this._lastQuery.toString().replace(/^\*|\*$/g, '').length >= this.shortQueryLength) ?
                    this.searchDelay :
                    this.shortQueryDelay
            );
            //
            // _SearchMixin end
            //
        }
    });
});
},
'soso/dijit/form/api/project/StageTitleFormatter':function(){
define([
    'dojo/_base/declare',
    'spencer/format/ProjectStageTitle'
], function(
    declare,
    ProjectStageTitleFormatter
) {
    return declare([], {
        format: function (item) {
            const projectStageTitleFormatter = new ProjectStageTitleFormatter();

            projectStageTitleFormatter.setStageNumber(item.getStageNumber());
            projectStageTitleFormatter.setTitle(item.getTitle());

            return projectStageTitleFormatter.format();
        }
    });
});
},
'soso/dijit/form/api/project/StoreFactory':function(){
define([
    'dojo/_base/declare',
    'soso/dojo/store/JsonRestApi',
    'api/project/data/ProjectStage',
    'api/project/parser/ProjectStage',
    'library/request/data/Handlers',
    'library/request/helper/DefaultUnauthorisedCallback',
    './StageTitleFormatter',
    './ModelFactory'
], function(
    declare,
    JsonRestApi,
    ProjectStageVO,
    ProjectStageParser,
    HandlersVO,
    DefaultUnauthorisedCallback,
    Formatter,
    ModelFactory
) {
    return declare([], {
        projectModel: null,
        projectCollectionModel: null,
        filters: null,

        constructor: function() {
            const builder = new ModelFactory();
            this.projectModel = builder.getModel();
            this.projectCollectionModel = builder.getModelCollection();
        },

        get: function(filters) {
            this.filters = filters || null;
            return this._createProjectStore();
        },

        _createProjectStore: function() {
            return new JsonRestApi({
                idProperty: 'projectStagePK',
                searchAttr: 'title',
                resultParser: new ProjectStageParser(),
                getModel: this.projectModel,
                getFunction: 'get',
                getFunctionArgsCreator: function(id) {
                    const psvo = new ProjectStageVO;
                    psvo.setProjectStagePK(id);

                    return [
                        this._createHandlersVO(),
                        psvo
                    ]
                }.bind(this),
                queryModel: this.projectCollectionModel,
                queryFunction: 'fetch',
                queryFunctionArgs: [
                    this._createHandlersVO(),
                    this.filters
                ]
            });
        },

        _createHandlersVO: function() {
            return new HandlersVO(
                null,
                null,
                DefaultUnauthorisedCallback,
                function(error, description) {
                    console.log(error);
                    console.log(description);
                }
            )
        }
    });
});

},
'soso/dojo/store/JsonRestApi':function(){
define([
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dojo/store/util/QueryResults',
    'dojo/when',
    'api/parser/Collection',
    'library/request/data/Handlers',
    'spencer/parse/JSONParser'
], function(declare, lang, QueryResults, when, CollectionParser, HandlersVO, JSONParser) {
    return declare('soso.dojo.store.JsonRestApi', null, {
        idProperty: null,

        searchAttr: 'query',

        getModel: null,
        getFunction: null,
        // function (id) { ... }
        getFunctionArgsCreator: null,

        queryModel: null,
        queryFunction: null,
        queryFunctionArgs: [],
        // function (query) { ... }
        queryFunctionArgsCreator: null,

        resultParser: null,

        collectionParser: null,

        constructor: function(params) {
            declare.safeMixin(this, params);

            if (!this.queryFunctionArgsCreator && !(this.queryFunctionArgs[0] instanceof HandlersVO)) {
                console.error('First parameter in the queryFunction must be instance of library/request/data/Handlers');
            }
        },
        
        getIdentity: function(object) {
            return object[this.idProperty];
        },

        get: function(id) {
            if (this.getModel && this.getFunction && this.getFunctionArgsCreator) {
                var getArgs = this.getFunctionArgsCreator(id),
                    _this = this;

                var successHandler = getArgs[0].getSuccess();
                var errorHandler = getArgs[0].getError();

                var results = this.getModel[this.getFunction].apply(this.getModel, getArgs).getPromise();

                results = results.then(function (results) {
                    // Don't pass an individual parser to the CollectionParser
                    // as we just want to return the item in raw object form
                    const parser = _this._getResultParser();
                    try {
                        var parsedResults = parser.parse(results);

                        if (typeof successHandler === 'function') {
                            successHandler(parsedResults);
                        }

                        return parsedResults;
                    } catch (error) {
                        errorHandler(error.getError(), error.getDescription());
                    }
                });

                // Don't like this, but as results will be a promise I'm not sure there's
                // much else that can be done. Taken from dojo/store/util/QueryResults

                var isPromise = !!results.then;
                // if it is a promise it may be frozen
                if (isPromise) {
                    results = lang.delegate(results);
                }

                return QueryResults(results);
            }
        },

        getValue: function(item, attr) {
            return item[attr];
        },

        setQueryModelOffset: function (options) {
            if (options.start >= 0) {
                if (typeof this.queryModel.setOffset ===  'function') {
                    this.queryModel.setOffset(options.start);
                }
            }
        },

        setQueryModelLimit: function (options) {
            if (options.count >= 0) {
                if (typeof this.queryModel.setLimit === 'function') {
                    this.queryModel.setLimit(options.count);
                }
            }
        },

        setQueryModelQuery: function(query) {
            if (query && typeof this.queryModel.setQuery === 'function') {
                this.queryModel.setQuery(this._getSearchAttrValueFromQuery(query));
            }
        },

        stripWildcards: function (string) {
            if (string.charAt(string.length - 1) === '*') {
                string = string.substr(0, string.length - 1);
            }

            if (string.charAt(0) === '*') {
                string = string.substr(1);
            }

            return string;
        },

        query: function(query, options) {
            options = options || {};

            this.setQueryModelOffset(options);
            
            this.setQueryModelLimit(options);

            this.setQueryModelQuery(query);

            var queryFunctionArgs = this.queryFunctionArgs;
            if (this.queryFunctionArgsCreator) {
                queryFunctionArgs = this.queryFunctionArgsCreator(this._getSearchAttrValueFromQuery(query), options);
            }

            var successHandler = queryFunctionArgs[0].getSuccess();
            var errorHandler = queryFunctionArgs[0].getError();

            var results = this.queryModel[this.queryFunction].apply(this.queryModel, queryFunctionArgs).getPromise();

            results = results.then(function(results) {
                try {
                    var parsedResults = this._getParsedResults(results);

                    if (typeof successHandler === 'function') {
                        successHandler(parsedResults);
                    }

                    return parsedResults;
                } catch(error) {
                    errorHandler(error.getError(), error.getDescription());
                }
            }.bind(this));

            // Don't like this, but as results will be a promise I'm not sure there's
            // much else that can be done. Taken from dojo/store/util/QueryResults
            
            var isPromise = !!results.then;
            // if it is a promise it may be frozen
            if (isPromise){
                results = lang.delegate(results);
            }

            // As collections returned via the v1 API do not have a total
            // (for the total number of results that would be return without
            // a limit/offset/query being applied) this cheats a bit.
            // If the length of the array of results is equal to the page size
            // it most likely means that we've returned a full page and there's
            // probably another page to come. So increment the total to force a
            // new page. Obviously this logic falls down when the total is actually
            // exactly divisible by the page size and we reach the last page.
            results.total = when(results, function(results) {
                var total = options.start + results.length;

                if (results.length === options.count) {
                    total++;
                }

                return total;
            });

            return QueryResults(results);
        },

        _getParsedResults: function(results) {
            return this._getCollectionParser().parse(results);
        },

        _getResultParser: function() {
            if (this.resultParser instanceof JSONParser) {
                return this.resultParser;
            }

            const collectionParser = this._getCollectionParser();
            if (collectionParser instanceof CollectionParser) {
                return collectionParser.setIsSingleItemCollection(true);
            }

            return new JSONParser(this.resultParser);
        },

        _getCollectionParser: function() {
            if (this.collectionParser !== null) {
                return this.collectionParser;
            } else {
                return new CollectionParser(this.resultParser);
            }
        },

        _getSearchAttrValueFromQuery: function(query) {
            if (typeof query === 'object' && query[this.searchAttr]) {
                return this.stripWildcards(query[this.searchAttr].toString());
            }

            if (query) {
                return this.stripWildcards(query.toString());
            }

            return '';
        }
    });
});

},
'soso/dijit/form/api/project/ModelFactory':function(){
define([
    'dojo/_base/declare',
    'api/project/Factory',
    'api/project/Config',
    'library/request/dojo/URLConnectionProcessorBuilder',
    'library/request/URLConnectionBuilder',
    'library/request/URLResponseProcessorBuilder'
], function(
    declare,
    ProjectFactory,
    ProjectConfig,
    URLConnectionProcessorBuilder,
    URLConnectionBuilder,
    URLResponseProcessorBuilder
) {
    return declare([], {
        projectFactory: null,

        constructor: function() {
            this.projectFactory = this._createProjectFactory();
        },

        getModel: function() {
            return this.projectFactory.getProjectStage();
        },

        getModelCollection: function() {
            return this.projectFactory.getProjectStageCollection();
        },

        _createProjectFactory: function () {
            return new ProjectFactory(
                new ProjectConfig(),
                new URLConnectionBuilder(
                    new URLConnectionProcessorBuilder()
                ),
                new URLResponseProcessorBuilder()
            );
        }
    });
});

},
'style-guide/v1/doc-control/project-node-select/FilteringNodeSelect':function(){
define([
    'style-guide/v1/Base',
    'dojo/_base/declare',
    'dojo/keys',
    'dojo/on',
    'dojo/text!./template/FilteringNodeSelect.html',
    'soso/sosox/ejs/_Templated',
    './NodeListing'
], function(
    Base,
    declare,
    KEYS,
    on,
    template,
    _Templated,
    NodeListing
) {
    return declare([Base, _Templated], {
        filterInput: null,
        nodeListingContainer: null,
        nodeListingWidget: null,
        nodeListingWrapper: null,
        onNodeSelect: null,
        nodeCollection: [],

        templateString: template,

        postCreate: function() {
            this.inherited(arguments);

            this._initNodeListingWidget();
        },

        allowFunctionNodeSelection: function() {
            this.nodeListingWidget.allowFunctionNodeSelection();
            return this;
        },

        highlightNode: function(projectStageTreeViewPK) {
            this.nodeListingWidget.highlightNode(projectStageTreeViewPK);
        },

        setNodeCollection: function(nodeCollection) {
            this._reset();
            
            this.nodeCollection = this._collectionToArray(nodeCollection);
            this.nodeListingWidget.setNodeCollection(this.nodeCollection);
        },

        showLoading: function(message) {
            this.loadingNode.classList.remove('hidden');
            if (message) this.loadingMessage.innerHTML = message;
        },

        hideLoading: function() {
            this.loadingNode.classList.add('hidden');
        },

        reset: function() {
            this._reset();
        },

        highlight: function(node) {
            if (node.getParent()) {
                const order = this._createExpandOrder([], node).reverse();
                order.forEach(function(node) {
                    if (node.getName() !== 'VIRTUAL ROOT NODE') {
                        if (node.getParent()) {
                            this.nodeListingWidget._expandNode(parseInt(node.getParent().getProjectStageTreeViewPK()));
                        }

                        this.nodeListingWidget.render();
                    }
                }.bind(this));
            }

            this.nodeListingWidget.highlightNode(node.getProjectStageTreeViewPK());
            this.onNodeSelect(node);
        },

        scrollToSelected: function() {
            this.nodeListingWidget.scrollToNode();
        },

        _reset: function() {
            this.nodeCollection = [];
            this.selectedNode = null;
            this.nodeListingWidget.reset();
            this.hideLoading();
            this._resetFilter();
        },

        _selectNode(node) {
            if (this.onNodeSelect) {
                this.onNodeSelect(node);
            }
        },

        _createExpandOrder: function (order, node) {
            order.push(node);
            if (node.getParent()) {
                this._createExpandOrder(order, node.getParent());
            }
            return order;
        },

        unhighlight: function() {
            this.nodeListingWidget._unhighlightAllNodes();
        },

        _initNodeListingWidget: function() {
            this.nodeListingWidget = new NodeListing({}, this.nodeListingContainer);

            on(this.nodeListingWidget, 'selected', function(node) {
                this.selectedNode = node;

                this._selectNode(node);
            }.bind(this));

            on(this.nodeListingWidget, 'nodeSelect', function(node) {
                this.selectedNode = node;

                this._selectNode(node);
            }.bind(this));

            on(this.nodeListingWidget, 'nodeFound', function(node) {
                this.selectedNode = node;

                this._selectNode(node);
            }.bind(this));
        },

        _resetFilter: function() {
            this.filterInput.value = '';
            this.nodeListingWidget.setNodeCollection(this.nodeCollection);
        },

        _searchChildren: function(nodeCollection, query) {
            let matched = [];
            nodeCollection.forEach(function(node) {
                if (node.getName().match(new RegExp(".*" + this._escapeRegExp(query) + ".*", 'i'))) {
                    matched.push(node);
                } else if (node.getChildren()) {
                    let recursive = this._searchChildren(node.getChildren(), query);
                    if (recursive.length) {
                        recursive.forEach(function(node) {
                            matched.push(node);
                        }.bind(this));
                    }
                }
            }.bind(this));

            return matched;
        },

        _escapeRegExp: function(string) {
            return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        },

        _collectionToArray: function(queryResult) {
            let array = [];
            queryResult.forEach(function(item) {
                array.push(item);
            });
            return array;
        },

        _onFilterInputKeyUp: function(e) {
            this.nodeListingWidget.setNodeCollection(this._searchChildren(this.nodeCollection, e.target.value));
        },

        _getSelectedNodeAttr: function() {
            return this.selectedNode;
        },

        _setProjectStageTreeViewPKAttr: function(projectStageTreeViewPK) {
            this.selectedNode = null;
            this.nodeListingWidget.set('selectedProjectStageTreeViewPK', projectStageTreeViewPK);
        }
    });
});
},
'style-guide/v1/Base':function(){
define([
    'dojo/dom-class',
    'dojo/_base/declare',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated'
], function(
    domClass,
    declare,
    _WidgetBase,
    _Templated
) {
    return declare([_WidgetBase, _Templated], {
        data: {
            isHidden: true
        },

        render: function() {
            this.data.isHidden = domClass.contains(this.domNode, 'hide');

            this.inherited(arguments);
        },

        show: function() {
            domClass.remove(this.domNode, 'hide');
        },

        hide: function() {
            domClass.add(this.domNode, 'hide');
        }
    });
});
},
'style-guide/v1/doc-control/project-node-select/NodeListing':function(){
define([
    '@lib/spencer/format/NodePath',
    '@lib/doc-control/tree/config/NodeTypes',
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/Evented',
    'dojo/html',
    'dojo/query',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated',
    'dojo/text!./template/NodeListing.html'
], function(
    NodePathFormatter,
    NODE_TYPES,
    declare,
    domAttr,
    domClass,
    Evented,
    html,
    query,
    _WidgetBase,
    _Templated,
    template
) {
    const INCREMENT_MULTIPLIER = 15,
          ROOT_NODE_ID = 'root',
          VIRTUAL_ROOT_NODE = 'VIRTUAL ROOT NODE';

    const NO_SELECTED_NODE_TEXT = 'none';

    return declare([_WidgetBase, _Templated, Evented], {
        data: {
            menuItems: [],
            noSelectedNodeText: NO_SELECTED_NODE_TEXT
        },
        expandedNodes: [],
        folderTemplateNestedNodeSelectionAllowed: false,
        functionNodeSelectionAllowed: false,
        nodeCollection: [],
        nodeListing: null,
        scrollToNodeContainer: null,
        selectedNodeText: null,
        selectedProjectStageTreeViewPK: null,
        selectedNode: null,
        selectedProjectStageTreeViewTitle: null,
        templateString: template,

        constructor: function() {
            this.nodeCollection = [];
        },

        render: function() {
            const scrollOffset = this.nodeListing ? this.nodeListing.scrollTop : 0;

            this.inherited(arguments);

            if (this.nodeListing) {
                this.nodeListing.scrollTop = scrollOffset;
            }

            this._highlightNode(this.selectedProjectStageTreeViewPK, false);
        },

        reset: function() {
            this.data = {
                menuItems: [],
                noSelectedNodeText: NO_SELECTED_NODE_TEXT
            };
            this.expandedNodes = [];
            this.selectedProjectStageTreeViewPK = null;
        },

        allowFunctionNodeSelection: function() {
            this.functionNodeSelectionAllowed = true;
            return this;
        },

        allowNodeNestedInFolderTemplateSelection: function() {
            this.folderTemplateNestedNodeSelectionAllowed = true;
            return this;
        },

        highlightNode: function(projectStageTreeViewPK) {
            this._highlightNode(projectStageTreeViewPK, this.selectedProjectStageTreeViewPK !== projectStageTreeViewPK);
        },

        setNodeCollection: function(nodeCollection) {
            this.nodeCollection = nodeCollection;

            this._generateAndRenderMenuItems();
        },

        scrollToNode: function() {
            this.nodeCollection.forEach(function(node) {
                if (this._nodeContainsProjectStageTreeViewPK(node, this.selectedProjectStageTreeViewPK)) {
                    this._expandNodePath(node, this.selectedProjectStageTreeViewPK);
                    this._generateAndRenderMenuItems();
                }
            }.bind(this));

            const nodes = query('li[data-dom-node-tree-view-pk="' + this.selectedProjectStageTreeViewPK + '"]', this.nodeListing);
            if (nodes.length > 0) {
                const node = nodes[0];
                this.nodeListing.scrollTop = node.offsetTop;
            }
        },

        _generateAndRenderMenuItems: function() {
            this.data.menuItems = [];
            this.nodeCollection.forEach(function(node) {
                if (this._isVisibleType(node.getType()) && node.getName() !== VIRTUAL_ROOT_NODE) {
                    let parentNode = node.getParent();
                    if (
                        parentNode.getProjectStageTreeViewPK() !== ROOT_NODE_ID &&
                        !this._nodeExists(parentNode.getProjectStageTreeViewPK()) &&
                        !parentNode.isRootNode()
                    ) {
                        this._addParentItem(parentNode);
                    }

                    this.data.menuItems.push(this._makeMenuItem(node));
                }
            }.bind(this));

            for(let i in this.expandedNodes) {
                this._expandNode(this.expandedNodes[i]);
            }

            this.render();

            if (this.nodeListing) {
                this.nodeListing.scrollTop = 0;
            }
        },

        _getSelectedNode: function() {
            if (!this.selectedProjectStageTreeViewPK) {
                this.selectedNode = null;
                return null;
            }

            if (!this.selectedNode || this.selectedNode.getProjectStageTreeViewPK() != this.selectedProjectStageTreeViewPK) {
                this.selectedNode = null;

                this.nodeCollection.some(node => {
                    const found = this._getNodeForProjectStageTreeViewPK(node, this.selectedProjectStageTreeViewPK);
                    if (found) {
                        this.selectedNode = found;
                        return true;
                    }
                });
            }

            return this.selectedNode;
        },

        _getNodeForProjectStageTreeViewPK: function(node, projectStageTreeViewPK) {
            if (parseInt(node.getProjectStageTreeViewPK()) === parseInt(projectStageTreeViewPK)
                && this._isVisibleType(node.getType())
            ) {
                return node;
            }

            const children = node.getChildren();
            for (let i = 0; i < children.length; i++) {
                if (!this._isVisibleType(children[i].getType())) continue;

                const child = this._getNodeForProjectStageTreeViewPK(children[i], projectStageTreeViewPK);
                if (child) return child;
            }

            return null;
        },

        _nodeContainsProjectStageTreeViewPK: function(node, targetProjectStageTreeViewPK) {
            if (node.getProjectStageTreeViewPK() === parseInt(targetProjectStageTreeViewPK)
                && this._isVisibleType(node.getType())
            ) {
                return true;
            }

            const children = node.getChildren();
            for (let i = 0; i < children.length; i++) {
                if (!this._isVisibleType(children[i].getType())) continue;

                if (this._nodeContainsProjectStageTreeViewPK(children[i], targetProjectStageTreeViewPK)) {
                    return true;
                }
            }

            return false;
        },

        _expandNodePath: function(node, targetProjectStageTreeViewPK) {
            if (!this.expandedNodes.includes(node.getProjectStageTreeViewPK())) {
                this.expandedNodes.push(node.getProjectStageTreeViewPK());
            }

            const children = node.getChildren();
            for (let i = 0; i < children.length; i++) {
                if (this._nodeContainsProjectStageTreeViewPK(children[i], targetProjectStageTreeViewPK)) {
                    this._expandNodePath(children[i], targetProjectStageTreeViewPK);
                }
            }
        },

        _addParentItem: function(node) {
            let parentNode = node.getParent();
            if (parentNode &&
                parentNode.getName() !== VIRTUAL_ROOT_NODE &&
                parentNode.getProjectStageTreeViewPK() !== ROOT_NODE_ID &&
                !this._nodeExists(parentNode.getProjectStageTreeViewPK())
            ) {
                this._addParentItem(parentNode);
            }

            this.data.menuItems.push(this._makeMenuItem(node));
        },

        _expandParentMenuItems: function(node) {
            let parentNode = node.getParent();
            if (parentNode) {
                this._expandParentMenuItems(parentNode);
            }

            this.expandedNodes.push(node.getProjectStageTreeViewPK());
        },

        _nodeExists: function(treeViewPK) {
            for (let i in this.data.menuItems) {
                if (this.data.menuItems.hasOwnProperty(i)) {
                    if  (this.data.menuItems[i].treeViewPK === treeViewPK) {
                        return true;
                    }
                }
            }
            return false;
        },

        _makeMenuItem: function(node) {
            return {
                'treeViewPK': node.getProjectStageTreeViewPK(),
                'name': node.getName(),
                'type': node.getType(),
                'icon': this._getIcon(node.getType()),
                'isDisabled': !node.isActive(),
                'isSelectable': this._isSelectableType(node.getType()) && node.isActive(),
                'children' : this._containsVisibleTypeNodes(node.getChildren()) ? node.getChildren() : [],
                'parent' : node.getParent(),
                'expanded' : false,
                'increment' : this._getIncrementValue(node)
            };
        },

        _highlightNode: function(projectStageTreeViewPK, scroll) {
            this._unhighlightAllNodes();
            this.selectedProjectStageTreeViewPK = projectStageTreeViewPK;

            if (!this.selectedProjectStageTreeViewPK) {
                this.selectedNode = null;
                if (this.selectedNodeText) html.set(this.selectedNodeText, NO_SELECTED_NODE_TEXT);
                return;
            }

            if (
                this.scrollToNodeContainer &&
                this.nodeCollection.some((node) => this._nodeContainsProjectStageTreeViewPK(node, this.selectedProjectStageTreeViewPK))
            ) {
                domClass.remove(this.scrollToNodeContainer, 'hide');
            }

            const nodes = query('li[data-dom-node-tree-view-pk="' + this.selectedProjectStageTreeViewPK + '"]', this.nodeListing);
            if (nodes.length > 0) {
                const node = nodes[0];

                domClass.add(node, 'filtering-node-select-highlight');

                if (scroll) {
                    this.nodeListing.scrollTop = node.offsetTop;
                }

                this.selectedProjectStageTreeViewTitle = NodePathFormatter.nodeToString(this._getSelectedNode());

                this.emit('highlighted');
            } else {
                this.scrollToNode();
            }

            if (this.selectedNodeText) {
                html.set(this.selectedNodeText, this.selectedProjectStageTreeViewTitle || NO_SELECTED_NODE_TEXT);
            }
        },

        _unhighlightAllNodes: function() {
            const nodes = query('li.filtering-node-select-highlight', this.nodeListing);
            for (let i = 0; i < nodes.length; i++) {
                domClass.remove(nodes[i], 'filtering-node-select-highlight');
            }
        },

        _containsVisibleTypeNodes: function(nodes) {
            for (let j = 0; j < nodes.length; j++) {
                if (this._isVisibleType(nodes[j].type)) {
                    return true;
                }
            }

            return false;
        },

        _isVisibleType: function(type) {
            const hiddenTypes = [NODE_TYPES.HIDDEN, NODE_TYPES.MODULE];

            if (!this.functionNodeSelectionAllowed) {
                hiddenTypes.push(NODE_TYPES.FUNCTION);
            }

            if (!this.folderTemplateNestedNodeSelectionAllowed) {
                hiddenTypes.push(NODE_TYPES.TEMPLATE);
                hiddenTypes.push(NODE_TYPES.TEMPLATE_ORG);
            }

            return type && !hiddenTypes.includes(type);
        },

        _isSelectableType: function(type) {
            const nonSelectableTypes = [
                NODE_TYPES.TEMPLATE,
                NODE_TYPES.TEMPLATE_ORG,
                NODE_TYPES.FOLDER
            ];

            if (!this.functionNodeSelectionAllowed) {
                nonSelectableTypes.push(NODE_TYPES.FUNCTION);
            }

            return !nonSelectableTypes.includes(type);
        },

        _getIcon: function(type) {
            switch (type) {
                case NODE_TYPES.DRAWING:
                    return 'sos-icon-pencil-paper';
                case NODE_TYPES.FOLDER:
                    return 'sos-icon-folder';
                case NODE_TYPES.REVISIONABLE:
                    return 'sos-icon-files-copy';
                case NODE_TYPES.CORRESPONDENCE:
                    return 'sos-icon-envelope';
                case NODE_TYPES.OTHER:
                    return 'sos-icon-file';
                case NODE_TYPES.FUNCTION:
                    return 'sos-icon-doc-control-function';
                case NODE_TYPES.TEMPLATE_ORG:
                    return 'sos-icon-doc-control-templateorg';
                default:
                    return 'sos-icon-file';
            }
        },

        _onNodeClick: function(e) {
            this._selectNode('selected', e.target);
        },

        _selectNode: function(event, element) {
            const selectedProjectStageTreeViewPK = parseInt(domAttr.get(element, 'data-node-tree-view-pk'));

            this._highlightNode(selectedProjectStageTreeViewPK, false);

            this.emit(event, this._getSelectedNode());
        },

        _onExpandNodeClick: function(e) {
            let treeViewPK = parseInt(domAttr.get(e.target, 'data-node-tree-view-pk'));

            if (domAttr.get(e.target, 'data-node-expanded') === "true") {
                this.expandedNodes = this.expandedNodes.filter(pk => pk !== treeViewPK);
                this._collapseNode(treeViewPK);
            } else {
                this.expandedNodes.push(treeViewPK);
                this._expandNode(treeViewPK);
            }

            this.render();
        },

        _onScrollToNodeClick: function() {
            this.scrollToNode();
        },

        _getIncrementValue: function(node) {
            let subNode = true;
            let increment = 0;

            while (subNode) {
                if (
                    !node ||
                    (node.parent && (node.parent.getProjectStageTreeViewPK() === ROOT_NODE_ID || node.parent.isRootNode()))
                ) {
                    subNode = false;
                } else {
                    node = node.parent;
                    increment++;
                }
            }

            return (increment * INCREMENT_MULTIPLIER) + 'px';
        },

        _collapseNode: function(treeViewPK) {
            for (let i in this.data.menuItems) {
                if (this.data.menuItems.hasOwnProperty(i)) {
                    if (this.data.menuItems[i].treeViewPK === treeViewPK) {
                        this.data.menuItems[i].expanded = false;

                        this._collapseChildren(treeViewPK);
                        this.render();
                        return;
                    }
                }
            }
        },

        _collapseChildren: function(treeViewPK) {
            let childTreeViewPKs = [];
            for (let i = this.data.menuItems.length - 1; i >= 0; i--) {
                if (this.data.menuItems[i].parent.getProjectStageTreeViewPK() === treeViewPK) {
                    childTreeViewPKs.push(this.data.menuItems[i].treeViewPK);
                    this.data.menuItems.splice(i, 1);
                }
            }

            if (childTreeViewPKs.length) {
                childTreeViewPKs.forEach(function(childTreeViewPK) {
                    this._collapseChildren(childTreeViewPK);
                }.bind(this));
            }
        },

        _expandNode: function(treeViewPK) {
            for (let i in this.data.menuItems) {
                if (this.data.menuItems.hasOwnProperty(i)) {
                    if (this.data.menuItems[i].treeViewPK === treeViewPK) {
                        if (this.data.menuItems[i].expanded) return;

                        this.data.menuItems[i].expanded = true;

                        const menuItems = [];
                        for (let j = 0; j < this.data.menuItems[i].children.length; j++) {
                            if (this._isVisibleType(this.data.menuItems[i].children[j].type)) {
                                menuItems.push(this._makeMenuItem(this.data.menuItems[i].children[j]));
                            }
                        }

                        this.data.menuItems.splice.apply(this.data.menuItems, [parseInt(i) + 1, 0].concat(menuItems));
                        return;
                    }
                }
            }
        },

        _setSelectedProjectStageTreeViewPKAttr: function(projectStageTreeViewPK) {
            this.selectedNode = null;
            this.selectedProjectStageTreeViewPK = projectStageTreeViewPK;

            const found = this._getSelectedNode();
            if (!found || !found.isActive() || !this._isSelectableType(found.getType())) {
                this._unhighlightAllNodes();
                this.selectedProjectStageTreeViewPK = null;
                return;
            }

            this.emit('nodeFound', found);

            this.selectedNode = found;

            let hierarchy = [];
            let parent = found.getParent();

            while (parent) {
                if (parent.isRootNode()) {
                    break;
                }
                hierarchy.unshift(parent);
                parent = parent.getParent();
            }

            hierarchy.forEach((node) => this._expandNode(node.getProjectStageTreeViewPK()));
            this.render();

            const nodes = query('li[data-dom-node-tree-view-pk="' + projectStageTreeViewPK + '"]', this.nodeListing);
            if (nodes.length > 0) {
                this._highlightNode(
                    domAttr.get(query('> a', nodes[0])[0], 'data-node-tree-view-pk'),
                    true
                );
            }
        }
    });
});
},
'style-guide/v1/doc-control/document/bulk-soft-link/Table':function(){
define([
    'dijit/_WidgetBase',
    'dojo/_base/declare',
    'dojo/Evented',
    'dojo/text!./template/Table.html',
    'soso/sosox/ejs/_Templated',
    'spencer/format/ProjectStageTitle',
    'style-guide/v1/icons/FileToIconClass',
    'style-guide/v1/icons/FileTypeToColourClass',
    '@lib/spencer/format/NodePath'
], function(
    _WidgetBase,
    declare,
    Evented,
    template,
    _Templated,
    ProjectStageTitleFormatter,
    FileToIconClass,
    FileTypeToColourClass,
    NodePathFormatter
) {
    const TEXT_VERIFIED = 'Verified';

    return declare([_WidgetBase, _Templated, Evented], {
        data: {documents: []},
        elementMasterCheckbox: null,
        templateString: template,

        reset: function() {
            this.data.documents = [];
            this.render();
        },

        setDisabled: function(disabled) {
            this.domNode.querySelectorAll('a, input').forEach((a) => a.disabled = disabled);
        },

        setDocuments: function(documents) {
            this.data.documents = documents;
            this.data.documents.forEach((d) => {
               d.iconClass = (new FileToIconClass()).getClass({type: d.type});
               d.colourClass = (new FileTypeToColourClass()).getClass(d.type);
            });
            this.render();
        },

        getDocuments: function() {
            return Array.from(this.domNode.querySelectorAll('tr[data-document-pk]'))
                .map((row)=> this._rowToDocument(row));
        },

        getDocument: function(documentPK) {
            return this._rowToDocument(
                this.domNode.querySelector('tr[data-document-pk="' + documentPK + '"]')
            );
        },

        getSelectedDocumentPKs: function() {
            return Array.from(this.domNode.querySelectorAll('input[data-document-pk]:checked'))
                .map((c) => parseInt(c.dataset.documentPk));
        },

        setLocation: function(documentPK, projectStage, node) {
            const elementRow = this.domNode.querySelector('tr[data-document-pk="' + documentPK + '"]');
            if (!elementRow) return;

            const elementLocationCell = elementRow.querySelector('td.location');
            const formatted = (new ProjectStageTitleFormatter()).setStageNumber(projectStage.getStageNumber())
                .setTitle(projectStage.getTitle())
                .format() + ' / ' + NodePathFormatter.nodeToString(node);
            elementLocationCell.dataset.projectStagePk = projectStage.getProjectStagePK();
            elementLocationCell.dataset.projectStageTreeViewPk = node.getProjectStageTreeViewPK();
            elementLocationCell.title = formatted;

            const elementLocationText = elementRow.querySelector('td.location span.location-text');
            elementLocationText.innerText = formatted;

            elementRow.querySelector('.edit-button')?.classList.remove('display-none');
            elementRow.querySelector('.set-button')?.classList.add('display-none');
        },

        markAsVerifying: function(documentPK) {
            this._showRowState(
                documentPK,
                ['sos-icon-refresh', 'sos-icon-animation-spin-smooth-before'],
                'Verifying...'
            );
        },

        markAsVerified: function(documentPK) {
            this._showRowState(
                documentPK,
                ['sos-icon-check', 'sos-colours-success-foreground'],
                TEXT_VERIFIED
            );
        },

        markAsFailed: function(documentPK, description) {
            this._showRowState(
                documentPK,
                ['sos-icon-close', 'sos-colours-error-foreground'],
                'Failed - ' + description
            );
        },

        removeDocument: function(documentPK) {
            this.domNode.querySelector('tr[data-document-pk="' + documentPK + '"]')?.remove();
            this.data.documents = this.data.documents.filter((document) => document.documentPK !== documentPK);
            this._updateMasterCheckboxState();

            if (!this.domNode.querySelectorAll('tr[data-document-pk]').length) {
                this.render();
            }

            this.emit('change');
        },

        render: function() {
            const checkedDocumentPKs = this.getSelectedDocumentPKs();

            this.inherited(arguments);

            checkedDocumentPKs.forEach(
                (documentPK) => this.domNode.querySelector('tr[data-document-pk="' + documentPK + '"]')
                    ?.setAttribute('checked', true)
            );
            this._updateMasterCheckboxState();
        },

        _showRowState: function(documentPK, icons, description) {
            const elementCell = this.domNode.querySelector('tr[data-document-pk="' + documentPK + '"] td.validation');
            if (!elementCell) return;

            const iconCell = 'span.sos-icon';
            elementCell.querySelector(iconCell).className = 'sos-icon';
            elementCell.querySelector(iconCell).classList.add(...icons);

            elementCell.querySelector('span.description').innerText = description;
        },

        _rowToDocument: function(rowElement) {
            const locationElement = rowElement.querySelector('td.location');

            return {
                documentPK: parseInt(rowElement.dataset.documentPk),
                projectStagePK: locationElement?.dataset.projectStagePk,
                projectStageTreeViewPK: locationElement?.dataset.projectStageTreeViewPk,
                title: rowElement.querySelector('td.title input[type=text]')?.value ??
                    rowElement.querySelector('td.title input[type=hidden]')?.value,
                isValid: rowElement.querySelector('td.validation span.description')?.innerText === TEXT_VERIFIED
            };
        },

        _onSelectLocationClick: function(e) {
            this.emit('select-location', parseInt(e.currentTarget.dataset.documentPk));
        },

        _onCheckboxChange: function() {
            this._updateMasterCheckboxState();
            this.emit('change');
        },

        _onMasterCheckboxChange: function(e) {
            this.domNode.querySelectorAll('input[type="checkbox"][data-document-pk]')
                .forEach((c) => c.checked = e.currentTarget.checked);
            this.emit('change');
        },

        _onRemoveClick: function(e) {
            const documentPK = parseInt(e.currentTarget.dataset.documentPk);
            this.removeDocument(documentPK);
            this.emit('remove', documentPK);
            this.emit('change');
        },

        _updateMasterCheckboxState: function() {
            const checkboxes = Array.from(this.domNode.querySelectorAll('input[data-document-pk]'));
            this.elementMasterCheckbox.checked = checkboxes.length && checkboxes.every((c) => c.checked);
        }
    });
});
},
'style-guide/v1/icons/FileToIconClass':function(){
define([
    'dojo/_base/declare',
    './FileTypeToIconClass'
], function(declare, FileTypeToIconClass) {
    /*
     * Takes in a dom file (from a file input for example) and
     * based on file type and file extension returns the appropriate
     * icon CSS class.
     */
    return declare('style-guide.v1.icons.filetoiconclass', [], {
        ICON_CLASS_PREFIX: 'sos-icon-file',

        getClass: function(file) {
            if (file && this._hasFileType(file)) {
                let fileType = file.type ? file.type.split('/') : null;

                if (!fileType) {
                    fileType = file.fileType ? file.fileType.split('/') : null;
                }

                if (typeof file.getFileType === 'function') {
                    fileType = file.getFileType() ? file.getFileType().split('/') : null;
                }

                if (fileType) {
                    const result = (new FileTypeToIconClass()).getClass(fileType[0], fileType[1]);

                    if (result !== this.ICON_CLASS_PREFIX) {
                        return result;
                    }
                }
            }

            if (file && file.name) {
                const fileExtension = file.name.split('.').pop().toLowerCase();
                
                if (fileExtension === 'pdf') {
                    return this.ICON_CLASS_PREFIX + '-pdf';
                }

                if (fileExtension === 'key') {
                    return this.ICON_CLASS_PREFIX + '-powerpoint';
                }

                if (fileExtension === 'eml') {
                    return this.ICON_CLASS_PREFIX + '-email';
                }
            }

            return this.ICON_CLASS_PREFIX;
        },

        _hasFileType: function (file) {
            if ('type' in file) {
                return true;
            }

            if ('fileType' in file) {
                return true;
            }

            if (typeof file.getFileType === 'function' && file.getFileType() !== null) {
                return true;
            }

            return false;
        }
    })
});

},
'style-guide/v1/doc-control/document/soft-link/FormPaneWrapper':function(){
define(["require", "exports", "api/doccontrol/Config", "api/doccontrol/document/Config", "api/doccontrol/document/Factory", "api/doccontrol/document/revision/Config", "api/doccontrol/document/revision/Factory", "api/doccontrol/document/tree/Config", "api/doccontrol/document/tree/Factory", "api/doccontrol/Factory", "api/doccontrol/tree/node/Config", "api/doccontrol/tree/node/Factory", "api/project-stage/Config", "api/project-stage/Factory", "style-guide/v1/doc-control/document/soft-link/FormPane", "library/request/URLConnectionBuilder", "library/request/dojo/URLConnectionProcessorBuilder", "library/request/URLResponseProcessorBuilder"], function (require, exports, DocControlConfig, DocControlDocumentConfig, DocControlDocumentFactory, DocControlDocumentRevisionConfig, DocControlDocumentRevisionFactory, DocControlDocumentTreeConfig, DocControlDocumentTreeFactory, DocControlFactory, DocControlTreeNodeConfig, DocControlTreeNodeFactory, ProjectStageConfig, ProjectStageFactory, SoftLinkFormPane, URLConnectionBuilder, URLConnectionProcessorBuilder, URLResponseProcessorBuilder) {
    "use strict";
    class FormPaneWrapper {
        constructor(documentViewer = null) {
            this.widget = new SoftLinkFormPane(this.getDocControlDocumentRevisionFactory().getLatest(), this.getDocControlDocumentTreeFactory().getNode(), this.getDocControlTreeNodeFactory().getPath(), this.getProjectStageFactory().getProjectStage(), this.getDocControlFactory().getTree(), this.getDocControlDocumentFactory().getSoftLink(), documentViewer);
        }
        setDocumentPK(documentPK) {
            this.widget.setDocumentPK(documentPK);
        }
        open() {
            this.widget.open();
        }
        close() {
            this.widget.close();
        }
        reload() {
            this.widget.reload();
        }
        setProjectStage(projectStage) {
            this.widget.setProjectStage(projectStage);
        }
        setNode(node) {
            this.widget.setNode(node);
        }
        setViewRevisionCallback(viewRevisionCallback) {
            this.widget.setViewRevisionCallback(viewRevisionCallback);
        }
        getUrlConnectionBuilder() {
            if (!this.urlConnectionBuilder) {
                this.urlConnectionBuilder = new URLConnectionBuilder(new URLConnectionProcessorBuilder());
            }
            return this.urlConnectionBuilder;
        }
        ;
        getUrlResponseProcessorBuilder() {
            if (!this.urlResponseProcessorBuilder) {
                this.urlResponseProcessorBuilder = new URLResponseProcessorBuilder();
            }
            return this.urlResponseProcessorBuilder;
        }
        ;
        getDocControlTreeNodeFactory() {
            if (!this.documentControlTreeNodeFactory) {
                this.documentControlTreeNodeFactory = new DocControlTreeNodeFactory(new DocControlTreeNodeConfig(), this.getUrlConnectionBuilder(), this.getUrlResponseProcessorBuilder());
            }
            return this.documentControlTreeNodeFactory;
        }
        ;
        getDocControlDocumentRevisionFactory() {
            return new DocControlDocumentRevisionFactory(new DocControlDocumentRevisionConfig(), this.getUrlConnectionBuilder(), this.getUrlResponseProcessorBuilder());
        }
        ;
        getDocControlDocumentTreeFactory() {
            return new DocControlDocumentTreeFactory(new DocControlDocumentTreeConfig(), this.getUrlConnectionBuilder(), this.getUrlResponseProcessorBuilder());
        }
        ;
        getProjectStageFactory() {
            return new ProjectStageFactory(new ProjectStageConfig(), this.getUrlConnectionBuilder(), this.getUrlResponseProcessorBuilder());
        }
        ;
        getDocControlFactory() {
            return new DocControlFactory(new DocControlConfig(), this.urlConnectionBuilder, this.urlResponseProcessorBuilder);
        }
        ;
        getDocControlDocumentFactory() {
            return new DocControlDocumentFactory(new DocControlDocumentConfig(), this.getUrlConnectionBuilder(), this.getUrlResponseProcessorBuilder());
        }
        ;
    }
    return FormPaneWrapper;
});

},
'style-guide/v1/doc-control/document/soft-link/FormPane':function(){
define([
    'dojo/_base/declare',
    'style-guide/v1/layout/FormPane',
    'style-guide/v1/doc-control/document/soft-link/Form',
    '@lib/request/data/Handlers'
], function(
    declare,
    FormPaneWidget,
    Form,
    Handlers
) {
    const FormPane = function(
        latestRevisionForDocument,
        nodeForDocument,
        nodePath,
        projectStage,
        tree,
        softLink,
        documentViewer
    ) {
        this.view = new (declare(FormPaneWidget, {
            icon: 'sos-icon-files-copy',
            title: 'Soft Link Document',
            'class': 'soft-link-document-form-pane',
            width: 40,
            form: null,
            documentViewer: documentViewer,
            latestRevisionCanceller: null,

            postCreate: function() {
                this.form = new Form(
                    latestRevisionForDocument,
                    nodeForDocument,
                    nodePath,
                    projectStage,
                    tree,
                    softLink,
                    this.close.bind(this)
                );

                this.form.setLocationClickCallback(() => {
                    this.close();
                })

                this.inherited(arguments);
            },

            setDocumentPK: function(documentPK) {
                if (this.latestRevisionCanceller) this.latestRevisionCanceller.cancel();

                this.latestRevisionCanceller = latestRevisionForDocument.get(
                    new Handlers(
                        revision => {
                            if (this.onOpenCompleteHandler) this.onOpenCompleteHandler.remove();
                            if (this.documentViewer) this.documentViewer.openInline(revision.getMd5());
                        },
                        () => {}
                    ),
                    documentPK
                );

                this.form.setDocumentPK(documentPK);
                return this;
            },

            open: function() {
                this.set('content', this.form.view.domNode);
                this.inherited(arguments);
                return this;
            },

            close: function() {
                this.set('content', '');
                this.inherited(arguments);

                if (this.form) this.form.cancel();
                if (this.latestRevisionCanceller) this.latestRevisionCanceller.cancel();
                if (this.documentViewer) this.documentViewer.close();

                return this;
            },

            reload: function() {
                this.form.reload();
                return this;
            },

            setProjectStage: function(projectStage) {
                this.form.setProjectStage(projectStage);
                return this;
            },

            setNode: function(node) {
                this.form.setNode(node);
                return this;
            },

            setViewRevisionCallback: function(viewRevisionCallback) {
                this.form.setViewRevisionCallback(viewRevisionCallback);
                return this;
            },

            onOpenComplete: function() {
                if (this.documentViewer) {
                    this.documentViewer.initInline();
                    this.documentViewer.showInitialiser(() => {
                        if (this.latestRevisionCanceller) this.latestRevisionCanceller.cancel();
                    });
                }
            }
        }));
    };

    FormPane.prototype.setDocumentPK = function(documentPK) {
        this.view.setDocumentPK(documentPK);
        return this;
    };

    FormPane.prototype.open = function() {
        this.view.open();
        return this;
    };

    FormPane.prototype.close = function() {
        this.view.close();
        return this;
    };

    FormPane.prototype.reload = function() {
        this.view.reload();
        return this;
    };

    FormPane.prototype.setProjectStage = function(projectStage) {
        this.view.setProjectStage(projectStage);
        return this;
    };

    FormPane.prototype.setNode = function(node) {
        this.view.setNode(node);
        return this;
    };

    FormPane.prototype.setViewRevisionCallback = function(viewRevisionCallback) {
        this.view.setViewRevisionCallback(viewRevisionCallback);
        return this;
    };

    return FormPane;
});
},
'style-guide/v1/doc-control/document/soft-link/Form':function(){
define([
    'api/project/filter/ExcludeInvisible',
    'dijit/_WidgetBase',
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/text!./template/Form.html',
    'dojo/text!style-guide/v1/layout/templates/DocumentCard.html',
    'dojo/topic',
    'library/PromiseFactory',
    'library/request/data/Handlers',
    'spencer/core/filter/Collection',
    'soso/dijit/form/api/project/StageFilteringSelect',
    'soso/sosox/ejs/_Templated',
    'soso/sosox/ejs/Helpers',
    'style-guide/v1/doc-control/document/soft-link/DocumentCard',
    'style-guide/v1/doc-control/project-node-select/FilteringNodeSelect',
    'style-guide/v1/layout/parser/DocumentCard'
], function(
    ExcludeInvisibleFilter,
    _WidgetBase,
    declare,
    domAttr,
    domClass,
    template,
    DocumentCardTemplate,
    topic,
    PromiseFactory,
    Handlers,
    FilterCollection,
    ProjectStageFilteringSelect,
    _Templated,
    Helpers,
    DocumentCard,
    FilteringNodeSelect,
    DocumentCardParser
) {
    const Form = function(
        latestRevisionForDocument,
        nodeForDocument,
        nodePath,
        projectStage,
        tree,
        softLink,
        closeFormPane
    ) {
        this.view = new (declare([_WidgetBase, _Templated], {
            currentNode: null,
            documentCard: null,
            documentCardContainer: null,
            documentPK: null,
            md5: null,
            errorContainer: null,
            filteringNodeSelect: null,
            inactiveProjectStageWarningContainer: null,
            path: null,
            projectStage: null,
            projectStageFilteringSelect: null,
            projectStageFilteringSelectWidget: null,
            projectStagePromise: null,
            promiseFactory: null,
            revision: null,
            targetNode: null,
            targetProjectStage: null,
            templateString: template,
            titleField: null,
            titleFieldContainer: null,
            unauthorisedProjectStageError: null,

            latestRevisionCanceller: null,
            nodeForDocumentCanceller: null,
            nodePathCanceller: null,
            projectStageCanceller: null,

            locationClick: null,
            viewRevision: null,

            postCreate: function() {
                this.cardParser = new DocumentCardParser(DocumentCardTemplate);
                this.promiseFactory = new PromiseFactory();
            },

            cancel: function() {
                this._cancelPreviousRequests();
            },
            
            setDocumentPK: function(documentPK) {
                this.documentPK = documentPK;
                return this;
            },

            setMd5: function(md5) {
                this.md5 = md5;
                return this;
            },

            reload: function() {
                this.reset();
                this.render();
                this.projectStagePromise = this.promiseFactory.get();

                this.latestRevisionCanceller = latestRevisionForDocument.get(
                    new Handlers(
                        function success(revision) {
                            this.revision = revision;

                            this.nodeForDocumentCanceller = nodeForDocument.get(
                                new Handlers(
                                    function success(node) {
                                        this.currentNode = node;

                                        this.nodePathCanceller = nodePath.get(
                                            new Handlers(
                                                function success(path) {
                                                    this.path = path;

                                                    this.projectStageCanceller = projectStage.get(
                                                        new Handlers(
                                                            function success(projectStage) {
                                                                this.projectStage = projectStage;

                                                                this._populateForm();
                                                                this.projectStagePromise.resolve();
                                                            }.bind(this)
                                                        ),
                                                        node.getProjectStagePK()
                                                    )
                                                }.bind(this),
                                                function() {},
                                                this._showNotPermittedError.bind(this),
                                                this._showGenericError.bind(this)
                                            ),
                                            node,
                                            false
                                        )
                                    }.bind(this),
                                    function() {},
                                    this._showNotPermittedError.bind(this),
                                    this._showGenericError.bind(this)
                                ),
                                this.documentPK
                            )
                        }.bind(this),
                        function() {},
                        this._showNotPermittedError.bind(this),
                        this._showGenericError.bind(this)
                    ),
                    this.documentPK
                );
            },

            reset: function() {
                this._cancelPreviousRequests();

                if (this.filteringNodeSelect) {
                    this.filteringNodeSelect.destroyRecursive();
                    this.filteringNodeSelect = null;
                }

                if (this.projectStageFilteringSelectWidget) {
                    this.projectStageFilteringSelectWidget.destroyRecursive();
                    this.projectStageFilteringSelectWidget = null;
                }

                if (this.documentCard) {
                    this.documentCard.destroyRecursive();
                    this.documentCard = null;
                }

                this.md5 = null;
            },

            setLocationClickCallback: function(locationClickCallback) {
                this.locationClick = locationClickCallback;
                return this;
            },

            setViewRevisionCallback: function(viewRevisionCallback) {
                this.viewRevision = viewRevisionCallback;
                return this;
            },

            setProjectStage: function(projectStage) {
                this.projectStagePromise.then(function() {
                    this.projectStage = projectStage;
                    this.projectStageFilteringSelectWidget.set('value', projectStage.getProjectStagePK());
                }.bind(this));
            },

            setNode: function(node) {
                const formLoadedObserver = new MutationObserver(function() {
                    if (this.filteringNodeSelect && this.domNode.contains(this.filteringNodeSelect.domNode)) {
                        this.filteringNodeSelect.set(
                            'projectStageTreeViewPK',
                            node.getProjectStageTreeViewPK?.() || node.projectStageTreeViewPK || node.treeViewPK
                        );
                        formLoadedObserver.disconnect();
                    }
                }.bind(this));

                this.projectStagePromise.then(function() {
                    formLoadedObserver.observe(this.domNode, {attributes: false, childList: true, characterData: false, subtree:true});
                }.bind(this));
            },

            _showNotPermittedError: function() {
                this._show(this.notPermittedErrorContainer);
                this._hide(this.loadingState);
            },

            _showGenericError: function() {
                topic.publish(
                    'sos-system-notification',
                    'Something went wrong. Please contact support.',
                    'error'
                );
            },

            _populateForm: function() {
                this._createDocumentCard();
                this._createProjectStageFilteringSelect();
                this._createFilteringNodeSelect();

                this._hide(this.loadingState);
                this._show(this.documentCardContainer);
                this._show(this.projectStageFilteringSelectContainer);
                this._show(this.submitButton);
            },

            _createDocumentCard: function() {
                if (this.documentCard) {
                    return;
                }

                const card = this.cardParser.parse(this.revision)
                    .setShowRegistrationInfo(true)
                    .setProjectStage(
                        (new Helpers())
                            .projectStageDisplayName(this.projectStage)
                    )
                    .setNodeName(this.path)
                    .setMd5(this.revision.getMd5())
                    .setIsRootNode(true);

                if (this.locationClick) card.setLocationClickCallbackName('locationClick');
                if (this.viewRevision) card.setViewClickCallbackName('viewClick');

                const documentCardData = {
                    data: {
                        card: card
                    }
                };

                if (this.locationClick)documentCardData.locationClick = this.locationClick;
                if (this.viewRevision) documentCardData.viewClick = this.viewRevision;

                this.documentCard = new DocumentCard(documentCardData).placeAt(this.documentCardContainer);
            },

            _createProjectStageFilteringSelect: function() {
                this.projectStageFilteringSelectWidget = new ProjectStageFilteringSelect({
                    autoComplete: false,
                    queryExpr: '*${0}*',
                    'class': 'sos-form-filtering-select',
                    placeholder: 'Select project or general stage...',
                    onChangeCallBack: this._onProjectStageSelect.bind(this),
                    filters: new FilterCollection().addFilter(new ExcludeInvisibleFilter())
                }, this.projectStageFilteringSelect);

                this.projectStageFilteringSelectWidget.set('value', this.projectStage.getProjectStagePK());
            },

            _onProjectStageSelect: function(projectStage) {
                this._resetFormState();

                if (!projectStage) {
                    this._hide(this.filteringNodeSelectContainer);
                    this._hide(this.unauthorisedProjectStageError);
                    return;
                }

                this.targetProjectStage = projectStage;

                this._loadTree();
            },

            _loadTree: function() {
                tree.get(
                    new Handlers(
                        function success(tree) {
                            this._show(this.filteringNodeSelectContainer);
                            this._hide(this.unauthorisedProjectStageError);

                            if (!this.targetProjectStage.getIsActive()) {
                                this._show(this.inactiveProjectStageWarningContainer);
                            }

                            this.filteringNodeSelect.setNodeCollection(tree.getChildren());
                        }.bind(this),
                        function() {},
                        function unauthorised() {
                            this._hide(this.filteringNodeSelectContainer);
                            this._show(this.unauthorisedProjectStageError);
                        }.bind(this),
                        function error() {
                            this._hide(this.filteringNodeSelectContainer);
                            this._show(this.unauthorisedProjectStageError);
                        }.bind(this)
                    ),
                    this.targetProjectStage.getProjectStagePK()
                );
            },

            _createFilteringNodeSelect: function() {
                if (this.filteringNodeSelect) {
                    return;
                }

                this.filteringNodeSelect = new FilteringNodeSelect({
                    onNodeSelect: function(node) {
                        this.targetNode = node;

                        this._resetFormState();
                        this._show(this.titleFieldContainer);

                        this._issueDryRun();
                        if (!this.targetProjectStage.getIsActive()) {
                            this._show(this.inactiveProjectStageWarningContainer);
                        }
                    }.bind(this)
                }).placeAt(this.filteringNodeSelectContainer);
            },

            _submit: function() {
                const query = { documentTitle: this.titleField.value.trim() };
                if (this.md5) query.md5 = this.md5;

                softLink.create(
                    new Handlers(
                        function success() {
                            this._hide(this.errorContainer);
                            this._disableSubmit();
                            closeFormPane();
                            topic.publish(
                                'sos-system-notification',
                                'The document was successfully soft-linked. Changes may take a few seconds to apply. If they do not show after an hour please contact support.',
                                'success',
                                5000
                            );
                        }.bind(this),
                        function () {},
                        function unauthorised(error, description) {
                            this._disableSubmit();
                            this._setError(description);
                        }.bind(this),
                        function error(error, description) {
                            this._disableSubmit();
                            this._setError(description);
                        }.bind(this)
                    ),
                    this.documentPK,
                    this.targetProjectStage.getProjectStagePK(),
                    this.targetNode.getProjectStageTreeViewPK(),
                    false,
                    query
                );
            },

            _issueDryRun: function() {
                const query = { documentTitle: this.titleField.value.trim() };
                if (this.md5) query.md5 = this.md5;

                softLink.create(
                    new Handlers(
                        function success() {
                            this._hide(this.errorContainer);
                            this._enableSubmit();
                        }.bind(this),
                        function () {},
                        function unauthorised(error, description) {
                            this._disableSubmit();
                            this._setError(description);
                        }.bind(this),
                        function error(error, description) {
                            this._disableSubmit();
                            this._setError(description);
                        }.bind(this)
                    ),
                    this.documentPK,
                    this.targetProjectStage.getProjectStagePK(),
                    this.targetNode.getProjectStageTreeViewPK(),
                    true,
                    query
                );
            },

            _resetFormState: function() {
                this._hide(this.errorContainer);
                this._hide(this.inactiveProjectStageWarningContainer);
                this._hide(this.titleFieldContainer);

                this._disableSubmit();
            },

            _setError: function(error) {
                this._show(this.errorContainer);
                this.errorSpan.innerHTML = error;
            },

            _show: function(element) {
                domClass.remove(element, 'hide');
            },

            _hide: function(element) {
                domClass.add(element, 'hide');
            },

            _enableSubmit: function() {
                domAttr.remove(this.submitButton, 'disabled');
            },

            _disableSubmit: function() {
                domAttr.set(this.submitButton, 'disabled', 'disabled');
            },

            _cancelPreviousRequests: function() {
                this.latestRevisionCanceller && this.latestRevisionCanceller.cancel();
                this.nodeForDocumentCanceller && this.nodeForDocumentCanceller.cancel();
                this.nodePathCanceller && this.nodePathCanceller.cancel();
                this.projectStageCanceller && this.projectStageCanceller.cancel();
            }
        }));
    };

    Form.prototype.cancel = function() {
        this.view.cancel();
        return this;
    };

    Form.prototype.setDocumentPK = function(documentPK) {
        this.view.setDocumentPK(documentPK);
        return this;
    };

    Form.prototype.setMd5 = function(md5) {
        this.view.setMd5(md5);
        return this;
    };

    Form.prototype.reload = function() {
        this.view.reload();
        return this;
    };

    Form.prototype.setProjectStage = function(projectStage) {
        this.view.setProjectStage(projectStage);
        return this;
    };

    Form.prototype.setNode = function(node) {
        this.view.setNode(node);
        return this;
    };

    Form.prototype.setLocationClickCallback = function(locationClickCallback) {
        this.view.setLocationClickCallback(locationClickCallback);
        return this;
    };

    Form.prototype.setViewRevisionCallback = function(viewRevisionCallback) {
        this.view.setViewRevisionCallback(viewRevisionCallback);
        return this;
    };

    Form.prototype.placeAt = function(node) {
        this.view.placeAt(node);
    };

    return Form;
});
},
'style-guide/v1/doc-control/document/soft-link/DocumentCard':function(){
define([
    'dojo/_base/declare',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated',
    'dojo/text!./template/DocumentCard.html'
], function(
    declare,
    WidgetBase,
    Templated,
    template
) {
    return declare([WidgetBase, Templated], {
        templateString: template,

        data: {},

        viewClick: function() {}
    });
});
},
'style-guide/v1/layout/parser/DocumentCard':function(){
define([
    '../data/DocumentCard',
    'api/person/parser/Person',
    'spencer/format/Filesize',
    'spencer/parse/FilenameToExtension',
    'style-guide/v1/icons/FileTypeToColourClass',
    'style-guide/v1/icons/FileTypeToIconClass'
], function(
    DocumentCardVO,
    PersonParser,
    FilesizeFormatter,
    FilenameToExtension,
    FileTypeToColourClass,
    FileTypeToIconClass
) {
    const FILE_NAME_EXTENSION_SEPARATOR = '.';

    const DocumentCard = function(template) {
        this.template = template;

        this.personParser = new PersonParser();
        this.filesizeFormatter = new FilesizeFormatter();
        this.filenameToExtension = new FilenameToExtension();
        this.fileTypeToColourClass = new FileTypeToColourClass();
        this.fileTypeToIconClass = new FileTypeToIconClass();

        this._stringEndsWith = function(search, string) {
            return string.substring(string.length - search.length, string.length) === search;
        };
    };

    DocumentCard.prototype.parse = function(item) {
        const dcvo = new DocumentCardVO();
        dcvo.setTemplate(this.template);

        dcvo.setRevisionPK(item.revisionPK || null);
        dcvo.setTemporaryDocumentPK(item.temporaryDocumentPK || null);
        dcvo.setMd5(item.md5 || null);

        const type = item.subType ? item.type + '/' + item.subType : (item.fileType || item.type || null);
        dcvo.setFileType(type);
        dcvo.setFileTypeColourClass(this.fileTypeToColourClass.getClass(type));
        dcvo.setFileTypeIconClass(this.fileTypeToIconClass.getClass(type));
        dcvo.setExtension(this.filenameToExtension.parse(item.realName || item.name || null));
        dcvo.setFileSize(this.filesizeFormatter.format(item.fileSize || item.size || 0));
        if (item.markedAsPrivate) {
            dcvo.markAsPrivate();
        }
        if (item.isDeleted) {
            dcvo.markAsDeleted();
        }
        dcvo.setTitle(item.title || item.name || null);
        dcvo.setPersonUploader(item.personUploader ? this.personParser.parse(item.personUploader) : null);
        dcvo.setDateUploaded(item.dateUploaded ? new Date(item.dateUploaded) : null);
        if (dcvo.getTitle() && dcvo.getExtension()) {
            let downloadName = dcvo.getTitle();
            if (!this._stringEndsWith(dcvo.getExtension().toLowerCase(), downloadName.toLowerCase())) {
                downloadName += FILE_NAME_EXTENSION_SEPARATOR + dcvo.getExtension().toLowerCase();
            }
            dcvo.setDownloadName(downloadName);
        }

        return dcvo;
    };

    return DocumentCard;
});
},
'style-guide/v1/layout/data/DocumentCard':function(){
define([], function() {
    const DocumentCard = function() {
        // Card layout
        this.template = null;
        this.compactCard = false;

        // Document identifiers
        this.revisionPK = null;
        this.temporaryDocumentPK = null;
        this.md5 = null;

        // Document Metadata
        this.fileSize = null;
        this.fileType = null;
        this.fileTypeColourClass = null;
        this.fileTypeIconClass = null;
        this.extension = null;

        // Document Details
        this.markedAsPrivate = false;
        this.markedAsDeleted = false;
        this.title = null;
        this.revisionNumber = null;
        this.personUploader = null;
        this.projectStage = null;
        this.nodeName = null;
        this.isRootNodeAttr = false;
        this.showRegistrationInfo = null;
        this.dateUploaded = null;
        this.statusDescription = null;

        // Document Actions
        this.downloadLink = null;
        this.downloadName = null;
        this.downloadClickCallbackName = null;
        this.registerClickCallBackName = null;
        this.uploadToDocControlClickCallBackName = null;
        this.viewClickCallBackName = null;
        this.selectClickCallBackName = null;
        this.removeClickCallBackName = null;
    };

    DocumentCard.prototype.getTemplate = function() {
        return this.template;
    };

    DocumentCard.prototype.setTemplate = function(template) {
        this.template = template;
    };

    DocumentCard.prototype.isCompact = function() {
        return this.compactCard;
    };

    DocumentCard.prototype.compact = function() {
        this.compactCard = true;
        return this;
    };

    DocumentCard.prototype.getRevisionPK = function() {
        return this.revisionPK;
    };

    DocumentCard.prototype.setRevisionPK = function(revisionPK) {
        this.revisionPK = revisionPK;
    };

    DocumentCard.prototype.getTemporaryDocumentPK = function() {
        return this.temporaryDocumentPK;
    };

    DocumentCard.prototype.setTemporaryDocumentPK = function(temporaryDocumentPK) {
        this.temporaryDocumentPK = temporaryDocumentPK;
    };

    DocumentCard.prototype.getMd5 = function() {
        return this.md5;
    };

    DocumentCard.prototype.setMd5 = function(md5) {
        this.md5 = md5;
        return this;
    };

    DocumentCard.prototype.getFileSize = function() {
        return this.fileSize;
    };

    DocumentCard.prototype.setFileSize = function(fileSize) {
        this.fileSize = fileSize;
    };

    DocumentCard.prototype.getFileType = function() {
        return this.fileType;
    };

    DocumentCard.prototype.setFileType = function(fileType) {
        this.fileType = fileType;
    };

    DocumentCard.prototype.getFileTypeColourClass = function() {
        return this.fileTypeColourClass;
    };

    DocumentCard.prototype.setFileTypeColourClass = function(fileTypeColourClass) {
        this.fileTypeColourClass = fileTypeColourClass;
    };

    DocumentCard.prototype.getFileTypeIconClass = function() {
        return this.fileTypeIconClass;
    };

    DocumentCard.prototype.setFileTypeIconClass = function(fileTypeIconClass) {
        this.fileTypeIconClass = fileTypeIconClass;
    };

    DocumentCard.prototype.getExtension = function() {
        return this.extension;
    };

    DocumentCard.prototype.setExtension = function(extension) {
        this.extension = extension;
    };

    DocumentCard.prototype.isMarkedAsPrivate = function() {
        return this.markedAsPrivate;
    };

    DocumentCard.prototype.markAsPrivate = function() {
        this.markedAsPrivate = true;
    };

    DocumentCard.prototype.isDeleted = function () {
        return this.markedAsDeleted;
    }

    DocumentCard.prototype.markAsDeleted = function () {
        this.markedAsDeleted = true;
    }

    DocumentCard.prototype.getTitle = function() {
        return this.title;
    };

    DocumentCard.prototype.setTitle = function(title) {
        this.title = title;
    };

    DocumentCard.prototype.getRevisionNumber = function() {
        return this.revisionNumber;
    };

    DocumentCard.prototype.setRevisionNumber = function(revisionNumber) {
        this.revisionNumber = revisionNumber;
        return this;
    };

    DocumentCard.prototype.getPersonUploader = function() {
        return this.personUploader;
    };

    DocumentCard.prototype.setPersonUploader = function(personUploader) {
        this.personUploader = personUploader;
    };

    DocumentCard.prototype.getProjectStage = function() {
        return this.projectStage;
    };

    DocumentCard.prototype.setProjectStage = function(projectStage) {
        this.projectStage = projectStage;
        return this;
    };

    DocumentCard.prototype.getNodeName = function() {
        return this.nodeName;
    };

    DocumentCard.prototype.setNodeName = function(nodeName) {
        this.nodeName = nodeName;
        return this;
    };

    DocumentCard.prototype.isRootNode = function() {
        return this.isRootNodeAttr;
    };

    DocumentCard.prototype.setIsRootNode = function(isRootNode) {
        this.isRootNodeAttr = isRootNode;
        return this;
    };

    DocumentCard.prototype.getShowRegistrationInfo = function() {
        return this.showRegistrationInfo;
    };

    DocumentCard.prototype.setShowRegistrationInfo = function(showRegistrationInfo) {
        this.showRegistrationInfo = showRegistrationInfo;
        return this;
    };

    DocumentCard.prototype.getDateUploaded = function() {
        return this.dateUploaded;
    };

    DocumentCard.prototype.setDateUploaded = function(dateUploaded) {
        this.dateUploaded = dateUploaded;
    };

    DocumentCard.prototype.getDownloadLink = function() {
        return this.downloadLink;
    };

    DocumentCard.prototype.setDownloadLink = function(downloadLink) {
        this.downloadLink = downloadLink;
        return this;
    };

    DocumentCard.prototype.getDownloadName = function() {
        return this.downloadName;
    };

    DocumentCard.prototype.setDownloadName = function(downloadName) {
        this.downloadName = downloadName;
        return this;
    };

    DocumentCard.prototype.getDownloadClickCallbackName = function() {
        return this.downloadClickCallbackName;
    };

    DocumentCard.prototype.setDownloadClickCallbackName = function(callbackName) {
        this.downloadClickCallbackName = callbackName;
        return this;
    };

    DocumentCard.prototype.getRegisterClickCallbackName = function() {
        return this.registerClickCallBackName;
    };

    DocumentCard.prototype.setRegisterClickCallbackName = function(callbackName) {
        this.registerClickCallBackName = callbackName;
        return this;
    };

    DocumentCard.prototype.getUploadToDocControlClickCallbackName = function() {
        return this.uploadToDocControlClickCallBackName;
    };

    DocumentCard.prototype.setUploadToDocControlClickCallbackName = function(callbackName) {
        this.uploadToDocControlClickCallBackName = callbackName;
        return this;
    };

    DocumentCard.prototype.getViewClickCallbackName = function() {
        return this.viewClickCallBackName;
    };

    DocumentCard.prototype.setViewClickCallbackName = function(callbackName) {
        this.viewClickCallBackName = callbackName;
        return this;
    };

    DocumentCard.prototype.getLocationClickCallbackName = function() {
        return this.locationClickCallbackName;
    };

    DocumentCard.prototype.setLocationClickCallbackName = function(callbackName) {
        this.locationClickCallbackName = callbackName;
        return this;
    };

    DocumentCard.prototype.getSelectClickCallbackName = function() {
        return this.selectClickCallBackName;
    };

    DocumentCard.prototype.setSelectClickCallbackName = function(callbackName) {
        this.selectClickCallBackName = callbackName;
        return this;
    };

    DocumentCard.prototype.getRemoveClickCallbackName = function() {
        return this.removeClickCallBackName;
    };

    DocumentCard.prototype.setRemoveClickCallbackName = function(callbackName) {
        this.removeClickCallBackName = callbackName;
        return this;
    };

    DocumentCard.prototype.setStatusDescription = function(statusDescription) {
        this.statusDescription = statusDescription;
        return this;
    };

    DocumentCard.prototype.getStatusDescription = function() {
        return this.statusDescription;
    };

    return DocumentCard;
});
},
'spencer/format/Filesize':function(){
define([], function() {
    const ONE_MB_IN_BYTES = 1000000;
    const ONE_KB_IN_BYTES = 1000;

    const Filesize = function() {};

    Filesize.prototype.format = function(bytes, precision) {
        bytes = parseFloat(bytes);
        if (isNaN(bytes)) {
            return '';
        }

        precision = parseInt(precision);
        if (isNaN(precision)) {
            precision = 1;
        }

        const MB = (bytes / ONE_MB_IN_BYTES).toFixed(precision);
        if (MB >= 1) {
            return MB + 'MB';
        }

        const KB = (bytes / ONE_KB_IN_BYTES).toFixed(precision);
        if (KB >= 1) {
            return KB + 'KB';
        }

        return bytes + 'B';
    };

    return Filesize;
});

},
'spencer/parse/FilenameToExtension':function(){
define([
], function() {
    const FilenameToExtension = function() {};

    FilenameToExtension.prototype.parse = function(filename) {
        if (!filename) {
            return '';
        }

        const filenameWithoutPath = filename.split(/[\\/]/).pop();
        const pos = filenameWithoutPath.lastIndexOf(".");

        if (pos < 1) {
            return '';
        }

        return filenameWithoutPath.slice(pos + 1);
    };

    return FilenameToExtension;
});

},
'style-guide/v1/file-tray/ContextButtonContainer':function(){
define([
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/_base/declare',
    'dojo/text!./template/ContextButtonContainer.html',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated',
    './ContextButton'
], function(
    domAttr,
    domClass,
    declare,
    template,
    _WidgetBase,
    _Templated
) {
    return declare('style-guide.v1.file-tray.context-button-container', [_WidgetBase, _Templated], {
        data: {
            buttons: [],
            contextName: '',
            selectedItemCount: 0
        },
        templateString: template,

        show: function() {
            domClass.remove(this.domNode, 'hide');
        },

        hide: function() {
            domClass.add(this.domNode, 'hide');
        },

        setSelectedItemCount: function(count) {
            this.data.selectedItemCount = count;

            this.render();
        },

        setContext: function(contextName, contextButtons) {
            this.data.buttons = contextButtons;
            this.data.contextName = contextName;
            this.render();
        },

        clearContext: function() {
            this.data.buttons = [];
            this.data.contextName = '';
            this.render();
        },

        _onButtonClick: function(e) {
            if (!domAttr.has(e.target, 'data-index')) {
                return;
            }

            var index = parseInt(domAttr.get(e.target, 'data-index'));

            this.data.buttons[index].getOnClick().call();
        }
    });
});


},
'style-guide/v1/file-tray/ContextButton':function(){
define([], function () {
    var ContextButton = function (data) {
        this.label = data.label || '';
        this.iconClass = data.iconClass || '';
        this.onClick = data.onClick || null;
        this.title = data.title || '';
        this.requiresSelectedFiles = data.requiresSelectedFiles || false;
    };

    ContextButton.prototype.getLabel = function() {
        return this.label;
    };

    ContextButton.prototype.getIconClass = function() {
        return this.iconClass;
    };

    ContextButton.prototype.getOnClick = function() {
        return this.onClick;
    };

    ContextButton.prototype.getTitle = function() {
        return this.title;
    };

    ContextButton.prototype.doesRequireSelectedFiles = function() {
        return this.requiresSelectedFiles;
    };

    return ContextButton;
});
},
'style-guide/v1/file-tray/DataTransferHelper':function(){
define([
    'dojo/json'
], function(
    json
) {
    const DATA_TRANSFER_FORMAT_DOCUMENT_REVISION = 'document/revision';
    const DATA_TRANSFER_FORMAT_TEXT = 'text';

    const DataTransferHelper = function() {
        this.constants = {
            DATA_KEY: 'text',
            DATA_PROPERTY_VALUE: 'value',
            DATA_PROPERTY_MD5: 'md5',
            DATA_TRANSFER_EFFECT_ALL: 'all',
            DATA_TRANSFER_EFFECT_LINK: 'link',
            DATA_TRANSFER_EFFECT_UNINITIALIZED: 'uninitialized',
            DEFAULT_DROP_EFFECT: 'link',
            DEFAULT_EFFECT_ALLOWED: 'link'
        };
        this.md5s = [];

        this._md5sToItemArray = function() {
            let r = [];
            for(let i = 0; i < this.md5s.length; i++) {
                r.push({md5: this.md5s[i]});
            }
            return r;
        };

        this._determineDataTransferFormat = function(dataTransfer) {
            if (dataTransfer.getData(DATA_TRANSFER_FORMAT_DOCUMENT_REVISION)) {
                return DATA_TRANSFER_FORMAT_DOCUMENT_REVISION
            } else {
                return DATA_TRANSFER_FORMAT_TEXT
            }
        };

        this._doesDataHaveValueProperty = function(data) {
            return typeof data[this.constants.DATA_PROPERTY_VALUE] !== 'undefined';
        }
    };

    DataTransferHelper.prototype.addMd5 = function(md5) {
        this.md5s.push(md5);
        return this;
    };

    DataTransferHelper.prototype.prepare = function(dataTransfer) {
        dataTransfer.dropEffect = this.constants.DEFAULT_DROP_EFFECT;
        dataTransfer.effectAllowed = this.constants.DEFAULT_EFFECT_ALLOWED;
        dataTransfer.setData(this.constants.DATA_KEY, json.stringify(
            this._md5sToItemArray()
        ));

        return dataTransfer;
    };

    DataTransferHelper.prototype.isValidDropEvent = function(e) {
        return e.dataTransfer &&
            (
                e.dataTransfer.effectAllowed === this.constants.DATA_TRANSFER_EFFECT_ALL ||
                e.dataTransfer.effectAllowed === this.constants.DATA_TRANSFER_EFFECT_LINK ||
                e.dataTransfer.effectAllowed === this.constants.DATA_TRANSFER_EFFECT_UNINITIALIZED
            );
    };

    DataTransferHelper.prototype.isValid = function(dataTransfer) {
        let data = [];
        try {
            data = json.parse(dataTransfer.getData(this._determineDataTransferFormat(dataTransfer)));
        } catch (error) {
            return false;
        }

        if (data.length === 0) {
            return false;
        }

        for(let i = 0; i < data.length; i++) {
            if (!data[i]['md5']) {
                return false;
            }
        }

        return true;
    };

    DataTransferHelper.prototype.parse = function(dataTransfer) {
        if (!this.isValid(dataTransfer)) {
            return [];
        }

        let data = json.parse(dataTransfer.getData(this._determineDataTransferFormat(dataTransfer)));

        if (this._doesDataHaveValueProperty(data)) {
            return json.parse(data[this.constants.DATA_PROPERTY_VALUE]);
        }

        return data;
    };

    return DataTransferHelper;
});

},
'style-guide/v1/file-tray/ItemCollection':function(){
define([
    'doccontrol/viewer/helper/DocumentCollectionNavigator',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/Evented',
    'dojo/html',
    'dojo/json',
    'dojo/on',
    'dojo/query',
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dojo/text!./template/ItemCollection.html',
    'dojo/text!./template/card/Revision.html',
    'dojo/text!./template/card/TemporaryDocument.html',
    'dojo/text!./template/table-row/Revision.html',
    'dojo/text!./template/table-row/TemporaryDocument.html',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated',
    'style-guide/v1/drag-and-drop/CursorSingleton',
    './template-data/Revision',
    './template-data/TemporaryDocument'
], function(
    DocumentCollectionNavigator,
    domAttr,
    domClass,
    Evented,
    html,
    json,
    on,
    query,
    declare,
    lang,
    template,
    templateRevisionCard,
    templateTemporaryDocumentCard,
    templateRevisionTableRow,
    templateTemporaryDocumentTableRow,
    _WidgetBase,
    _Templated,
    DragAndDropCursorSingleton,
    RevisionTemplateData,
    TemporaryDocumentTemplateData
) {
    return declare('style-guide.v1.file-tray.item-collection', [_WidgetBase, _Templated, Evented], {
        constants: {
            DISPLAY_MODE_CARD: 'card',
            DISPLAY_MODE_TABLE: 'table',
            DATA_TRANSFER_KEY: 'fileTrayItems',
            TYPE_REVISION: 'revision',
            TYPE_TEMPORARY_DOCUMENT: 'temporary-document'
        },
        data: {
            displayMode: 'card',
            items: [],
            itemsTotal: 0,
            hasRegisteredItems: false,
            hasUnregisteredItems: false
        },
        dragAndDropCursor: null,
        elementDragAndDropCursor: null,
        elementItemContainer: null,
        items: [],
        itemTotal: 0,
        routeContainer: null,
        documentViewer: null,
        selectedItemIds: [],
        templateData: {},
        templateString: template,

        postMixInProperties: function() {
            this.inherited(arguments);

            this.templateData = {
                'revision': new RevisionTemplateData(this.routeContainer),
                'temporary-document': new TemporaryDocumentTemplateData(this.routeContainer)
            };
        },

        buildRendering: function() {
            this._applyItemsToData();

            this.inherited(arguments);
        },

        postCreate: function() {
            this.dragAndDropCursor = DragAndDropCursorSingleton.get();
        },

        setItems: function(items) {
            this.items = items;

            this._applyItemsToData();

            this.render();
        },

        setItemTotal: function(itemTotal) {
            this.itemTotal = itemTotal;

            this._applyItemsToData();

            this.render();
        },

        setDisplayMode: function(displayMode) {
            if (!this._isSupportedDisplayMode(displayMode)) {
                console.error('Invalid display mode: ' + displayMode);
                return;
            }

            this.data.displayMode = displayMode;

            this.render();
        },

        selectAll: function() {
            this._checkCheckboxes(true);
        },

        selectNone: function() {
            this._checkCheckboxes(false);
        },

        getSelectedItems: function() {
            return this._getItemsForIds(this._getSelectedIDs());
        },

        closeFileTray: function() {},

        _isSupportedDisplayMode: function(displayMode) {
            return displayMode === this.constants.DISPLAY_MODE_CARD ||
                displayMode === this.constants.DISPLAY_MODE_TABLE;
        },

        _onDragStart: function(e) {
            e.stopPropagation();
            this.closeFileTray();

            let ids = [];
            const count = this._countSelectedItems();
            if (this._isSelectedItem(domAttr.get(e.target, 'data-id')) && count > 1) {
                ids = this._getSelectedIDs();

                this.dragAndDropCursor.multipleItems();
                this.dragAndDropCursor.setIconClass('sos-icon-file');
                this.dragAndDropCursor.setText(count + ' files');
            } else {
                if (domAttr.get(e.target, 'data-id').toLowerCase().indexOf('revision') >= 0) {
                    this.dragAndDropCursor.setDocumentClass('revision');
                } else {
                    this.dragAndDropCursor.setDocumentClass('');
                }

                ids.push(domAttr.get(e.target, 'data-id'));

                this.dragAndDropCursor.singleItem();
                this.dragAndDropCursor.setIconClass(domAttr.get(e.target, 'data-icon-class'));
                this.dragAndDropCursor.setText(domAttr.get(e.target, 'data-file-name'));
            }

            e.dataTransfer.setData('text', json.stringify(this._generateDataTransferText(ids)));

            e.dataTransfer.setDragImage(
                this.dragAndDropCursor.domNode,
                this.dragAndDropCursor.DRAG_CURSOR_OFFSET_X,
                this.dragAndDropCursor.DRAG_CURSOR_OFFSET_Y
            );
        },

        _onRemoveClick: function(e) {
            var id = domAttr.get(e.target, 'data-id');

            if (id) {
                this.emit('remove', id);
            }

            this._selectionChange();
        },

        _applyItemsToData: function() {
            this.data.items = [];
            this.data.itemTotal = this.itemTotal;
            this.data.hasRegisteredItems = false;
            this.data.hasUnregisteredItems = false;

            for(let i = 0; i < this.items.length; i++) {
                if (!this._verifyTypeIsSupported(this.items[i].getType())) {
                    continue;
                }

                let item = this._convertItemToDisplayItem(this.items[i]);

                this.data.items.push(item);

                if (item.isRegistered) {
                    this.data.hasRegisteredItems = true;
                } else {
                    this.data.hasUnregisteredItems = true;
                }
            }
        },

        _verifyTypeIsSupported: function(type) {
            if (!type) {
                console.error('File tray item has no type');
                return false;
            }

            if (!this.templateData.hasOwnProperty(type)) {
                console.error('Unsupported file tray item type: ' + type);
                return false;
            }

            return true;
        },

        _convertItemToDisplayItem: function(item) {
            return {
                'templateCard': this._getTemplateCardForType(item.getType()),
                'templateTableRow': this._getTemplateTableRowForType(item.getType()),
                'data': this._prepareTemplateData(item),
                'isRegistered': this._itemIsRegisteredType(item.getType())
            };
        },

        _getTemplateCardForType: function(type) {
            if (type === this.constants.TYPE_REVISION) {
                return templateRevisionCard;
            }

            if (type === this.constants.TYPE_TEMPORARY_DOCUMENT) {
                return templateTemporaryDocumentCard;
            }

            return '';
        },

        _getTemplateTableRowForType: function(type) {
            if (type === this.constants.TYPE_REVISION) {
                return templateRevisionTableRow;
            }

            if (type === this.constants.TYPE_TEMPORARY_DOCUMENT) {
                return templateTemporaryDocumentTableRow;
            }

            return '';
        },

        _prepareTemplateData: function(item) {
            var td = this.templateData[item.getType()].prepare(item);

            td.selected = this.selectedItemIds.indexOf(item.getId()) >= 0;

            return td;
        },

        _itemIsRegisteredType: function(type) {
            return type === this.constants.TYPE_REVISION;
        },

        _onCheckboxChange: function(e) {
            this._selectItem(domAttr.get(e.target, 'data-id'), e.target.checked);

            this._selectionChange();
        },

        _onViewClick: function(e) {
            const item = this._getItemForId(e.target.closest('[data-id]').getAttribute('data-id')).getData();
            const documentCollectionNavigator = (new DocumentCollectionNavigator()).setDocumentCollection(
                this._getOrderedItemsData(),
                (md5) => {
                    if (item.hasOwnProperty('revisionPK')) {
                        return this.routeContainer.get('revisionDownload', { revisionId: item.revisionPK });
                    }

                    return this.routeContainer.get(
                        'temporaryDocumentDownload',
                        { temporaryDocumentId: item.temporaryDocumentPK }
                    );
                }
            );

            this.documentViewer.setDocumentCollection(documentCollectionNavigator.getReferences());
            this.documentViewer.setActiveIndex(
                documentCollectionNavigator.getActiveIndex(
                    item.hasOwnProperty('revisionPK') ? { revisionPK: item.revisionPK } : { md5: item.md5 }
                )
            );

            this.documentViewer.execute();
        },

        _onViewDetailsClick: function(e) {
            this.documentViewer.initInformation();
            this._onViewClick(e);
        },

        _checkCheckboxes: function(checked) {
            query('input[type=checkbox]', this.elementItemContainer).forEach(function(checkbox) {
                checkbox.checked = checked;

                this._selectItem(domAttr.get(checkbox, 'data-id'), checked);
            }.bind(this));

            this._selectionChange();
        },

        _selectItem: function(id, selected) {
            if (!id) {
                return;
            }

            var q = this._createItemQuery(id);
            if (!q) {
                return;
            }

            query(q, this.elementItemContainer).forEach(function(card) {
                if (selected) {
                    domClass.add(card, 'sos-file-tray-bar-body-item-selected');
                } else {
                    domClass.remove(card, 'sos-file-tray-bar-body-item-selected');
                }
            }.bind(this));

            if (selected) {
                this.selectedItemIds.push(id);
            } else {
                this.selectedItemIds.splice(this.selectedItemIds.indexOf(id), 1);
            }
        },

        _createItemQuery: function(id) {
            if (this.data.displayMode === this.constants.DISPLAY_MODE_CARD) {
                return 'div.sos-file-tray-bar-body-item[data-id="' + id + '"]';
            } else if (this.data.displayMode === this.constants.DISPLAY_MODE_TABLE) {
                return 'tr[data-id="' + id + '"]';
            }

            return '';
        },

        _isSelectedItem: function(id) {
            return query('input[data-id="' + id + '"]:checked', this.elementItemContainer).length > 0;
        },

        _countSelectedItems: function() {
            return query('input[type=checkbox]:checked', this.elementItemContainer).length;
        },

        _getSelectedIDs: function() {
            var ids = [];
            query('input[type=checkbox]:checked', this.elementItemContainer).forEach(function(checkbox) {
                ids.push(domAttr.get(checkbox, 'data-id'));
            }.bind(this));
            return ids;
        },

        _getItemsForIds: function(ids) {
            var data = [];
            for(var i = 0; i < ids.length; i++) {
                var item = this._getItemForId(ids[i]);

                if (item) {
                    data.push(item);
                }
            }
            return data;
        },

        _getOrderedItemsData: function() {
            const itemsData = this.items.map(item => item.getData());

            if (this.data.displayMode === this.constants.DISPLAY_MODE_CARD) {
                return itemsData;
            }

            return itemsData.filter(data => data.hasOwnProperty('revisionPK'))
                .concat(itemsData.filter(data => data.hasOwnProperty('temporaryDocumentPK')));
        },

        _generateDataTransferText: function(ids) {
            var data = [];
            for(var i = 0; i < ids.length; i++) {
                var item = this._getItemForId(ids[i]);

                if (item.getType() === this.constants.TYPE_REVISION) {
                    this.dragAndDropCursor.setDocumentClass(this.constants.TYPE_REVISION)
                }

                if (item) {
                    data.push(item);
                }
            }
            return {key: this.constants.DATA_TRANSFER_KEY, value: json.stringify(this._getItemsForIds(ids))};
        },

        _getItemForId: function(id) {
            for(var i = 0; i < this.items.length; i++) {
                if (this.items[i].getId() == id) {
                    return this.items[i];
                }
            }

            return null;
        },

        _selectionChange: function() {
            this.emit('selection-change', this._getItemsForIds(this._getSelectedIDs()));
        }
    });
});


},
'doccontrol/viewer/helper/DocumentCollectionNavigator':function(){
define(['../data/DocumentReference'], function(DocumentReferenceVO) {
    const DocumentCollectionNavigator = function() {
        this.documentCollection = [];
    };

    DocumentCollectionNavigator.prototype.getReferences = function() {
        return this.documentCollection;
    };

    DocumentCollectionNavigator.prototype.setDocumentCollection = function(documentCollection, hrefGenerator) {
        this.documentCollection = [];

        for (let i in documentCollection) {
            if (documentCollection.hasOwnProperty(i)) {
                if (documentCollection[i].revisionPK) {
                    this.documentCollection.push(
                        (new DocumentReferenceVO()).setRevisionPK(documentCollection[i].revisionPK)
                            .setHref(hrefGenerator(documentCollection[i].revisionPK))
                    );
                } else if (documentCollection[i].md5) {
                    this.documentCollection.push(
                        (new DocumentReferenceVO()).setMd5(documentCollection[i].md5)
                            .setHref(hrefGenerator(documentCollection[i].md5))
                    );
                }
            }
        }

        return this;
    };

    DocumentCollectionNavigator.prototype.getActiveIndex = function(query) {
        for (let i = 0; i < this.documentCollection.length; i++) {
            if (query['revisionPK'] && this.documentCollection[i].getRevisionPK() === query.revisionPK) {
                return i;
            }

            if (query['md5'] && this.documentCollection[i].getMd5() === query.md5) {
                return i;
            }
        }
    };

    return DocumentCollectionNavigator;
});
},
'doccontrol/viewer/data/DocumentReference':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class DocumentReference {
        constructor() {
            this.md5 = null;
            this.revisionPK = null;
            this.temporaryDocumentPK = null;
            this.href = null;
        }
        setMd5(md5) {
            this.md5 = md5;
            return this;
        }
        getMd5() {
            return this.md5;
        }
        setRevisionPK(revisionPK) {
            this.revisionPK = revisionPK;
            return this;
        }
        getRevisionPK() {
            return this.revisionPK;
        }
        setTemporaryDocumentPK(temporaryDocumentPK) {
            this.temporaryDocumentPK = temporaryDocumentPK;
            return this;
        }
        getTemporaryDocumentPK() {
            return this.temporaryDocumentPK;
        }
        ;
        setHref(href) {
            this.href = href;
            return this;
        }
        getHref() {
            return this.href;
        }
    }
    return DocumentReference;
});

},
'style-guide/v1/file-tray/template-data/Revision':function(){
define([
    'spencer/format/Filesize',
    'spencer/parse/FilenameToExtension',
    'style-guide/v1/icons/FileTypeToColourClass',
    'style-guide/v1/icons/FileTypeToIconClass'
], function(
    FileSize,
    FilenameToExtension,
    FileTypeToColourClass,
    FileTypeToIconClass
) {
    const Revision = function(routeContainer) {
        this.filesize = new FileSize();
        this.filenameToExtension = new FilenameToExtension();
        this.fileTypeToColourClass = new FileTypeToColourClass();
        this.fileTypeToIconClass = new FileTypeToIconClass();
        this.routeContainer = routeContainer;
    };

    Revision.prototype.prepare = function(item) {
        const data = item.getData();

        const colourClass = this.fileTypeToColourClass.getClass(data.fileType);
        return {
            'id': item.getId(),
            'colourClass': colourClass,
            'isDefaultColourClass': this.fileTypeToColourClass.isDefault(colourClass),
            'documentPK': data.documentPK,
            'fileExtension': this.filenameToExtension.parse(data.fileName).toUpperCase(),
            'fileName': data.fileName,
            'fileSize': this.filesize.format(data.fileSize),
            'iconClass': this.fileTypeToIconClass.getClass(data.fileType),
            'reference': data.reference,
            'revisionNumber': data.revisionNumber,
            'revisionPK': data.revisionPK,
            'title': data.title,
            'isPrivate': data.isPrivate && typeof data.isPrivate !== 'function' || data.markedAsPrivate,
            'isDeleted': data.isDeleted && typeof data.isDeleted !== 'function' || data.markedAsDeleted,
            'downloadUrl': this.routeContainer.get('revisionDownload', { revisionId: data.revisionPK })
        };
    };

    return Revision;
});
},
'style-guide/v1/file-tray/template-data/TemporaryDocument':function(){
define([
    'spencer/format/Filesize',
    'spencer/parse/FilenameToExtension',
    'style-guide/v1/icons/FileTypeToColourClass',
    'style-guide/v1/icons/FileTypeToIconClass'
], function(
    FileSize,
    FilenameToExtension,
    FileTypeToColourClass,
    FileTypeToIconClass
) {
    const TemporaryDocument = function(routeContainer) {
        this.filesize = new FileSize();
        this.filenameToExtension = new FilenameToExtension();
        this.fileTypeToColourClass = new FileTypeToColourClass();
        this.fileTypeToIconClass = new FileTypeToIconClass();
        this.routeContainer = routeContainer;
    };

    TemporaryDocument.prototype.prepare = function(item) {
        const data = item.getData();

        const colourClass = this.fileTypeToColourClass.getClass(data.fileType);
        return {
            'id': item.getId(),
            'colourClass': colourClass,
            'isDefaultColourClass': this.fileTypeToColourClass.isDefault(colourClass),
            'fileExtension': this.filenameToExtension.parse(data.fileName).toUpperCase(),
            'fileName': data.fileName,
            'fileSize': this.filesize.format(data.fileSize),
            'iconClass': this.fileTypeToIconClass.getClass(data.fileType),
            'temporaryDocumentPK': data.temporaryDocumentPK,
            'md5': data.md5,
            'downloadUrl': this.routeContainer.get(
                'temporaryDocumentDownload',
                { temporaryDocumentId: data.temporaryDocumentPK }
            )
        };
    };

    return TemporaryDocument;
});
},
'style-guide/v1/file-tray/SavedBasket':function(){
define([
    './ItemCollection',
    'api/doccontrol/document/Config',
    'api/doccontrol/document/Factory',
    'dojo/_base/declare',
    'dojo/cookie',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/Evented',
    'dojo/html',
    'dojo/text!./template/SavedBasket.html',
    'dijit/_WidgetBase',
    'email/dojo/helper/ComposeHash',
    'library/request/helper/DefaultUnauthorisedCallback',
    'library/request/URLConnectionBuilder',
    'library/request/URLResponseProcessorBuilder',
    'library/request/dojo/URLConnectionProcessorBuilder',
    'soso/sosox/ejs/_Templated',
    'spencer/file-tray/parser/ItemCollection',
    'style-guide/v1/layout/DialogConfirm',
    '@lib/request/data/Handlers'
], function(
    ItemCollection,
    DocumentFactoryConfig,
    DocumentFactory,
    declare,
    cookie,
    domAttr,
    domClass,
    _Evented,
    html,
    template,
    _WidgetBase,
    ComposeHash,
    DefaultUnauthorisedCallback,
    URLConnectionBuilder,
    URLResponseProcessorBuilder,
    URLConnectionProcessorBuilder,
    _Templated,
    FileTrayItemCollection,
    DialogConfirm,
    Handlers
) {
    const DELETE_BASKET_MESSAGE = 'Are you sure you want to delete this saved basket?';
    const DELETE_BASKET_TITLE = 'Delete Saved Basket';
    const REMOVE_ITEM_MESSAGE_SINGLE = 'Are you sure you want to remove this item from your basket?';
    const REMOVE_ITEM_MESSAGE_MULTIPLE = 'You\'re about to remove :d items from your basket. Do you want to continue?';
    const REMOVE_ITEM_TITLE = 'Remove Item';
    const REMOVE_BASKET_MESSAGE = 'Are you sure you want to remove yourself from this collaborative basket?';
    const REMOVE_BASKET_TITLE = 'Remove Collaborative Basket';

    return declare([_WidgetBase, _Templated, _Evented], {
        basketName: null,
        buttonCardView: null,
        buttonRemoveSelected: null,
        buttonTableView: null,
        basketModel: null,
        collectionRequest: null,
        confirmDialog: null,
        constants: {
            COOKIE_DISPLAY_MODE: 'SOS_FILE_TRAY_DISPLAY_MODE'
        },
        currentPerson: null,
        data: {
            basket: null,
            error: false,
            loading: true,
            isOwner: false
        },
        notification: null,
        modelBasketRevisionCollection: null,
        revisionCollection: [],
        routeContainer: null,
        templateString: template,
        widgetItemCollection: null,
        widgetRenameBasketDialog: null,

        postCreate: function() {
            const documentFactory = new DocumentFactory(
                new DocumentFactoryConfig(),
                new URLConnectionBuilder(
                    new URLConnectionProcessorBuilder()
                ),
                new URLResponseProcessorBuilder()
            );

            this.modelBasketRevisionCollection = documentFactory.getBasketRevisionCollection();
            this.basketModel = documentFactory.getBasket();

            this._initItemCollection();
        },

        render: function() {
            const isHidden = this.isHidden();

            this.inherited(arguments);

            this._initItemCollection();

            if (!isHidden) {
                domClass.remove(this.domNode, 'hidden');
            }
        },

        getBasket: function() {
            return this.data.basket;
        },

        setBasket: function(basket) {
            this.modelBasketRevisionCollection.cancel();

            this.data.basket = basket;
            this.data.isOwner = this._isOwner();
            this.data.loading = true;
            this.data.error = false;

            this.render();

            const onError = () => {
                this.data.loading = false;
                this.data.error = true;
                this.render();
            };

            this.collectionRequest = this.modelBasketRevisionCollection.fetch(
                new Handlers((revisionCollection) => {
                    this.data.loading = false;

                    this.render();

                    const p = new FileTrayItemCollection();

                    this.revisionCollection = revisionCollection;

                    this.widgetItemCollection.setItemTotal(revisionCollection.length);
                    this.widgetItemCollection.setItems(
                        p.parse(revisionCollection.map(r => {
                            r.id = r.getRevisionPK();
                            r.type = 'revision';
                            return r;
                        }))
                    );

                    const storedDisplayMode = cookie(this.constants.COOKIE_DISPLAY_MODE);
                    if (storedDisplayMode === this.widgetItemCollection.constants.DISPLAY_MODE_CARD) {
                        this._showCardView();
                    } else {
                        this._showTableView();
                    }
                }, onError).setForbidden(onError),
                basket.getId()
            );
        },

        isHidden: function() {
            return domClass.contains(this.domNode, 'hidden');
        },

        show: function() {
            domClass.remove(this.domNode, 'hidden');
        },

        hide: function() {
            domClass.add(this.domNode, 'hidden');
        },

        _initItemCollection: function() {
            this.widgetItemCollection = new ItemCollection({
                items: [],
                itemTotal: 0,
                closeFileTray: () => this.emit('close'),
                routeContainer: this.routeContainer,
                documentViewer: this.documentViewer
            }, this.itemCollection);

            const selectionReliantButtons = [
                this.buttonAttachToEmail,
                this.buttonAddToBasket,
                this.buttonRemoveSelected
            ];

            this.widgetItemCollection.on('selection-change', (selectedItems) => {
               selectionReliantButtons.forEach((button) => {
                   if (selectedItems.length) {
                       domAttr.remove(button, 'disabled');
                   } else {
                       domAttr.set(button, 'disabled', 'disabled');
                   }
               })
            });

            this.widgetItemCollection.on('remove', (revisionPK) => {
                this._removeItems([parseInt(revisionPK)]);
            });
        },

        _onRemoveSelectedClick: function() {
            const revisionPKs = this.widgetItemCollection.getSelectedItems().map((item) => item.data.revisionPK);

            this._removeItems(revisionPKs);
        },

        _removeItems(revisionPKs) {
            const allItems = this.widgetItemCollection.get('items');
            const filteredItems = allItems.filter(item => !revisionPKs.includes(item.data.revisionPK));

            if (filteredItems.length === 0) {
                this._onDeleteClick();
                return;
            }

            const suffix = (revisionPKs.length > 1 ? 's' : '');
            this.confirmDialog?.destroy();
            this.confirmDialog = new DialogConfirm({
                confirmIcon: 'trash',
                confirmText: REMOVE_ITEM_TITLE + suffix,
                isNegativeAction: true,
                message: revisionPKs.length === 1 ? REMOVE_ITEM_MESSAGE_SINGLE :
                    REMOVE_ITEM_MESSAGE_MULTIPLE.replace(':d', revisionPKs.length),
                title: REMOVE_ITEM_TITLE + suffix
            });

            this.confirmDialog.on('submit', (confirmed) => {
                if (!confirmed) return;

                this.widgetItemCollection.setItemTotal(filteredItems.length);
                this.widgetItemCollection.setItems(filteredItems);

                const uid = this.notification.progress('SAVING_BASKET_PROGRESS', {});

                domAttr.set(this.buttonRemoveSelected, 'disabled', 'disabled');

                const onError = () => {
                    domAttr.remove(this.buttonRemoveSelected, 'disabled');
                    this.notification.error('REMOVE_ITEM_ERROR', {}, uid);
                    this.widgetItemCollection.setItemTotal(allItems.length);
                    this.widgetItemCollection.setItems(allItems);
                };

                this.collectionRequest = this.modelBasketRevisionCollection.save(
                    new Handlers(() => {
                        this.revisionCollection = this.revisionCollection.filter(
                            (r) => !revisionPKs.includes(r.getRevisionPK())
                        );
                        domAttr.remove(this.buttonRemoveSelected, 'disabled');
                        this.notification.success('SAVING_BASKET_SUCCESS', {}, uid);
                        this.widgetItemCollection.selectNone();

                        this.emit('save');
                    }, onError).setForbidden(onError),
                    this.data.basket.getId(),
                    filteredItems.map((item) => item.data.revisionPK)
                );
            });

            this.confirmDialog.show();
        },

        _onSelectAllClick: function() {
            this.widgetItemCollection.selectAll();
        },

        _onSelectNoneClick: function() {
            this.widgetItemCollection.selectNone();
        },

        _onCollaborateClick: function() {
            this.emit(
                'collaborate',
                this.data.basket.getId(), this.data.basket.getCollaborators(), this.data.isOwner
            );
        },

        _onDownloadCSVClick: function() {
            window.open(
                this.routeContainer.get(
                    'csvDownloadSavedBasket',
                    {basketPK: this.data.basket.getId()}
                ),
                '_blank'
            );
        },

        _onSplitBasketClick: function() {
            this.emit('split', this.data.basket.getId(), this.data.basket.getName(), this.revisionCollection);
        },

        _onDeleteClick: function() {
            const isOwner = this._isOwner();

            this.confirmDialog?.destroy();
            this.confirmDialog = new DialogConfirm({
                confirmIcon: isOwner ? 'trash' : 'close',
                confirmText: (isOwner ? 'Delete' : 'Remove') + ' Basket',
                isNegativeAction: true,
                message: isOwner ? DELETE_BASKET_MESSAGE : REMOVE_BASKET_MESSAGE,
                title: isOwner ? DELETE_BASKET_TITLE : REMOVE_BASKET_TITLE
            });

            this.confirmDialog.on('submit', (confirmed) => {
                if (!confirmed) return;

                const uid = this.notification.progress(isOwner ? 'DELETING_BASKET_PROGRESS' : 'REMOVING_BASKET_PROGRESS', {});
                const onError = () => {
                    this.notification.error(isOwner ? 'DELETING_BASKET_ERROR' : 'REMOVING_BASKET_ERROR', {}, uid)
                };

                domAttr.set(this.deleteButton, 'disabled', 'disabled');

                this.basketModel.delete(
                    this.data.basket,
                    new Handlers(() => {
                        this.emit('delete');
                        this.notification.success(isOwner ? 'DELETING_BASKET_SUCCESS' : 'REMOVING_BASKET_SUCCESS', {}, uid);
                    }, onError).setForbidden(onError)
                );
            });

            this.confirmDialog.show();
        },

        _onRenameClick: function() {
            this.widgetRenameBasketDialog.show(this.data.basket);
            this.widgetRenameBasketDialog.on('save', (data) => {
                this.data.basket = data.basket;
                html.set(this.basketName, data.basket.name);
            });
        },

        _addAllToCurrentBasketClick: function() {
            this.revisionCollection.map((item) => item.md5).forEach((md5) => {
                this.emit('add-to-current', {md5: md5});
            });
        },

        _addToCurrentBasketClick: function() {
            this.widgetItemCollection.getSelectedItems().map((item) => item.data.md5).forEach((md5) => {
                this.emit('add-to-current', {md5: md5});
            });
        },

        _attachToEmailClick: function() {
            const revisionPKs = this.widgetItemCollection.getSelectedItems().map((item) => item.data.revisionPK);

            window.open(
                this.routeContainer.get(
                    'emailSelected'
                ) + new ComposeHash().get({revisionPK: revisionPKs})
            );
        },

        _onCardViewClick: function() {
            cookie(this.constants.COOKIE_DISPLAY_MODE, this.widgetItemCollection.constants.DISPLAY_MODE_CARD);

            this._showCardView();
        },

        _onTableViewClick: function() {
            cookie(this.constants.COOKIE_DISPLAY_MODE, this.widgetItemCollection.constants.DISPLAY_MODE_TABLE);

            this._showTableView();
        },

        _showCardView: function() {
            this.widgetItemCollection.setDisplayMode(this.widgetItemCollection.constants.DISPLAY_MODE_CARD);

            domClass.add(this.buttonCardView, 'hide');
            domClass.remove(this.buttonTableView, 'hide');
        },

        _showTableView: function() {
            this.widgetItemCollection.setDisplayMode(this.widgetItemCollection.constants.DISPLAY_MODE_TABLE);

            domClass.remove(this.buttonCardView, 'hide');
            domClass.add(this.buttonTableView, 'hide');
        },

        _isOwner: function() {
            return this.data.basket &&
                this.currentPerson &&
                this.data.basket.getOwner().getPersonPK() === this.currentPerson.getPersonPK();
        }
    });
});


},
'spencer/file-tray/parser/ItemCollection':function(){
define([
    './Item'
], function(ItemParser) {
    var ItemCollection = function() {
        this.itemParser = new ItemParser();
    };

    ItemCollection.prototype.parse = function(itemCollection) {
        var r = [];

        if (!itemCollection || !itemCollection.length) {
            return r;
        }

        for(var i = 0; i < itemCollection.length; i++) {
            r.push(this.itemParser.parse(itemCollection[i]));
        }

        return r;
    };

    return ItemCollection;
});
},
'style-guide/v1/file-tray/SplitBasket':function(){
define([
    'dojo/_base/declare',
    'dojo/Evented',
    'dojo/keys',
    'dojo/on',
    'dojo/text!./template/SplitBasket.html',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated',
    'style-guide/v1/layout/Dialog',
    './dialog/CollaboratorsDialog',
    './SplitBasketTable',
    './SplitBasketAddMultipleBaskets'
], function(
    declare,
    _Evented,
    dojoKeys,
    on,
    template,
    _WidgetBase,
    _Templated,
    Dialog,
    CollaboratorsDialog,
    SplitBasketTable,
    SplitBasketAddMultipleBaskets
) {
    return declare([_WidgetBase, _Templated, _Evented], {
        elementAddBasketButton: null,
        elementAddMultipleBasketsButton: null,
        elementBasketName: null,
        elementBasketNameText: null,
        elementBasketPrefixText: null,
        elementCollaboratorsButton: null,
        elementDeleteAllBasketsButton: null,
        elementFilterText: null,
        elementProcessingMessageContainer: null,
        elementSuccessMessageContainer: null,
        elementSplitBasketButton: null,
        elementSummary: null,
        elementTable: null,
        elementTableContainer: null,
        templateString: template,
        widgetAddMultipleBasketsDialog: null,
        widgetAddMultipleBasketsForm: null,
        widgetCollaboratorsDialog: null,
        widgetTable: null,

        postCreate: function() {
            this.inherited(arguments);

            this.widgetTable = new SplitBasketTable({}, this.elementTable);
            on(this.widgetTable, 'change', (baskets) => {
                this._updateButtonStates(baskets);
                this._updateSummaryText(baskets, this.widgetCollaboratorsDialog?.getCollaboratorsAdded() ?? []);

                this.emit('change', baskets);
            });

            this.widgetAddMultipleBasketsForm = new SplitBasketAddMultipleBaskets();
            this.widgetAddMultipleBasketsDialog = new Dialog({
                additionalClass: 'min-height-0',
                titleString: 'Add Multiple Baskets',
                contentNode: this.widgetAddMultipleBasketsForm.domNode
            });
            on(this.widgetAddMultipleBasketsForm, 'cancel', () => {
                this.widgetAddMultipleBasketsDialog.hide();
            });
            on(this.widgetAddMultipleBasketsForm, 'submit', (basketNames) => {
                basketNames.forEach((name) => this.widgetTable.addBasket(name));
                this.widgetAddMultipleBasketsDialog.hide();
                this.widgetAddMultipleBasketsForm.reset();
            });
        },

        show: function(basketName, revisions) {
            this.showTable();
            this.elementBasketPrefixText.value = '';
            this.elementFilterText.value = '';
            this.elementBasketName.innerText = basketName;
            this.widgetTable.reset(revisions);
            this.widgetCollaboratorsDialog?.reset();
            this.domNode.classList.remove('display-none');
            this.elementBasketNameText.focus();
            this._updateSummaryText([], []);
        },

        hide: function() {
            this.domNode.classList.add('display-none');
        },

        showProcessingMessage: function() {
            this._disableForm();
            this.elementProcessingMessageContainer.classList.remove('display-none');
            this.elementSuccessMessageContainer.classList.add('display-none');
            this.elementTableContainer.classList.add('display-none');
        },

        showSuccessMessage: function() {
            this._disableForm();
            this.elementProcessingMessageContainer.classList.add('display-none');
            this.elementSuccessMessageContainer.classList.remove('display-none');
            this.elementTableContainer.classList.add('display-none');
        },

        showTable: function() {
            this._enableForm();
            this.elementProcessingMessageContainer.classList.add('display-none');
            this.elementSuccessMessageContainer.classList.add('display-none');
            this.elementTableContainer.classList.remove('display-none');
        },

        addBasket: function(basketName, md5s) {
            this.widgetTable.addBasket(basketName, md5s);
        },

        _enableForm: function() {
            this.elementAddBasketButton.disabled = false;
            this.elementAddMultipleBasketsButton.disabled = false;
            this.elementBasketPrefixText.disabled = false;
            this.elementBasketNameText.disabled = false;
            this.elementCollaboratorsButton.disabled = false;
            this.elementFilterText.disabled = false;
            this._updateButtonStates(this.widgetTable.getBaskets());
        },

        _disableForm: function() {
            this.elementAddBasketButton.disabled = true;
            this.elementAddMultipleBasketsButton.disabled = true;
            this.elementBasketPrefixText.disabled = true;
            this.elementBasketNameText.disabled = true;
            this.elementCollaboratorsButton.disabled = true;
            this.elementFilterText.disabled = true;
            this._updateButtonStates([], true);
        },

        _updateButtonStates: function(baskets, forceDisable = false) {
            this.elementDeleteAllBasketsButton.disabled = forceDisable || baskets.length === 0;
            this.elementSplitBasketButton.disabled = forceDisable || !this._areBasketsValid(baskets);
        },

        _addBasket: function() {
            if (this.elementBasketNameText.value) {
                this.widgetTable.addBasket(this.elementBasketNameText.value);

                this.elementBasketNameText.value = '';
            }
        },

        _updateSummaryText: function(baskets, collaborators) {
            let text = collaborators.length ?
                collaborators.length + ' collaborator' + (collaborators.length > 1 ? 's' : '') + ', ' :
                '';

            text += baskets.length + ' basket' + (baskets.length === 1 ? '' : 's') + ' created';
            if (baskets.length) {
                const emptyCount = baskets.filter((b) => b.revisions.length === 0).length;
                if (emptyCount) text += ' (' + emptyCount + (emptyCount === 1 ? ' is' : ' are') + ' empty)'
            }

            this.elementSummary.innerText = text;
        },

        _areBasketsValid: function(baskets) {
            return baskets.length && !baskets.filter((b) => b.revisions.length === 0).length;
        },

        _submitBaskets: function() {
            const baskets = this.widgetTable.getBaskets();
            if (this._areBasketsValid(baskets)) {
                this.emit(
                    'submit',
                    baskets,
                    this.widgetCollaboratorsDialog?.getCollaboratorsAdded() ?? []
                );
            }
        },

        _onAddBasketClick: function() {
            this._addBasket();
        },

        _onAddMultipleBasketsClick: function () {
            this.widgetAddMultipleBasketsDialog.show();
            this.widgetAddMultipleBasketsForm.focus();
        },

        _onDeleteAllBasketsClick: function() {
            this.widgetTable.deleteBaskets();
        },

        _onBasketNameKeyUp: function(e) {
            if (e.keyCode === dojoKeys.ENTER) {
                this._addBasket();
            }

            this.elementAddBasketButton.disabled = !this.elementBasketNameText.value;
        },

        _onBasketPrefixKeyUp: function() {
            this.widgetTable.setBasketPrefix(this.elementBasketPrefixText.value);
        },

        _onFilterInput: function() {
            this.widgetTable.setFilter(this.elementFilterText.value);
        },

        _onReturnClick: function() {
            this.emit('close');
        },

        _onCollaboratorsClick: function() {
            if (!this.widgetCollaboratorsDialog) {
                this.widgetCollaboratorsDialog = new CollaboratorsDialog({
                    required: false,
                    saveButtonText: 'Set Collaborators'
                });
                this.widgetCollaboratorsDialog.on('save', (added) => {
                    this.widgetCollaboratorsDialog.hide();

                    this._updateSummaryText(this.widgetTable.getBaskets(), added);
                });
            }

            this.widgetCollaboratorsDialog.show();
        },

        _onSplitBasketClick: function() {
            this._submitBaskets();
        }
    });
});


},
'style-guide/v1/file-tray/dialog/CollaboratorsDialog':function(){
define([
    'dijit/_WidgetBase',
    'dojo/_base/declare',
    'dojo/Evented',
    'dojo/text!./template/CollaboratorsDialog.html',
    'soso/sosox/ejs/_Templated',
    'style-guide/v1/layout/Dialog',
    './CollaboratorsForm'
], function(
    _WidgetBase,
    declare,
    _Evented,
    template,
    _TemplatedMixin,
    Dialog,
    CollaboratorsForm
) {
    return declare([_WidgetBase, _TemplatedMixin, _Evented], {
        closeButton: null,
        dialog: null,
        formNode: null,
        form: null,
        readOnly: false,
        required: true,
        saveButton: null,
        saveButtonText: 'Save Collaborators',
        templateString: template,

        postCreate: function() {
            this.inherited(arguments);

            this.dialog = new Dialog({
                contentNode: this.domNode,
                titleString: (this.readOnly ? 'View' : 'Manage') + ' Collaborators'
            });

            this.form = new CollaboratorsForm({
                readOnly: this.readOnly
            }, this.formNode);
            this.form.on('change', this._onChange.bind(this));

            if (!this.required) {
                this.saveButton.removeAttribute('disabled');
            }
            this.closeButton.innerText = this.readOnly ? 'Close' : 'Cancel';
            this.saveButton.classList.toggle('display-none', this.readOnly);
            this.saveButton.innerText = this.saveButtonText;
        },

        reset: function() {
            this.form.reset();
            this.closeButton.removeAttribute('disabled');
            this.saveButton.setAttribute('disabled', 'disabled');
        },

        getCollaboratorsAdded: function() {
            return this.form.getCollaboratorsAdded();
        },

        setCollaborators: function(collaborators) {
            this.form.setCollaborators(collaborators);
        },

        show: function() {
            this.dialog.show();
            this.form.focus();
        },

        hide: function() {
            this.dialog.hide();
        },

        _onChange: function(added, removed) {
            if (!this.required || added.length || removed.length) {
                this.saveButton.removeAttribute('disabled');
                return;
            }

            this.saveButton.setAttribute('disabled', 'disabled');
        },

        _onCloseClick: function() {
            this.dialog.hide();
        },

        _onSaveClick: function() {
            this.emit('save', this.form.getCollaboratorsAdded(), this.form.getCollaboratorsRemoved());
        }
    });
});
},
'style-guide/v1/file-tray/dialog/CollaboratorsForm':function(){
define([
    'dijit/_WidgetBase',
    'dojo/_base/declare',
    'dojo/Evented',
    'dojo/text!./template/CollaboratorsForm.html',
    'soso/dijit/form/api/PeopleFilteringSelect',
    'soso/sosox/ejs/_Templated',
    './CollaboratorsTable'
], function(
    _WidgetBase,
    declare,
    _Evented,
    template,
    PeopleFilteringSelect,
    _TemplatedMixin,
    CollaboratorsTable
) {
    return declare([_WidgetBase, _TemplatedMixin, _Evented], {
        collaboratorsAdded: [],
        collaboratorsRemoved: [],
        collaboratorsTable: null,
        collaboratorsTableNode: null,
        helpTextNode: null,
        initialCollaborators: [],
        personSelect: null,
        personSelectNode: null,
        readOnly: false,
        templateString: template,

        postCreate: function() {
            this.inherited(arguments);

            this.collaboratorsTable = new CollaboratorsTable({
                data: {
                    collaborators: []
                },
                readOnly: this.readOnly
            }, this.collaboratorsTableNode);

            if (this.readOnly) {
                this.helpTextNode.classList.add('display-none');
                return;
            }

            this.personSelect = new PeopleFilteringSelect(
                {
                    autoComplete: false,
                    required: false,
                    placeholder: 'Select person...',
                    'class': 'sos-form-filtering-select box-sizing-border-box width-100 mx-0 mt-0 mb-12',
                    onChange: this._onPersonSelected.bind(this)
                },
                this.personSelectNode
            );

            this.collaboratorsTable.on('remove', (personPK) => {
                if (!this._personAlreadyAdded(personPK)) {
                    this.collaboratorsAdded = this.collaboratorsAdded.filter(
                        (addedPersonPK) => addedPersonPK !== personPK
                    );
                } else {
                    this.collaboratorsRemoved.push(personPK);
                }

                this._onChange();
            });
        },

        focus: function() {
            this.personSelect?.focus();
        },

        reset: function() {
            this.initialCollaborators = [];
            this.collaboratorsAdded = [];
            this.collaboratorsRemoved = [];
            this.collaboratorsTable.reset();
        },

        setCollaborators: function(collaborators) {
            this.reset();

            collaborators.forEach(
                (c) => this.collaboratorsTable.addCollaborator(c.getPersonPK(), c.getDisplayName())
            );
            this.initialCollaborators = collaborators.map((c) => c.getPersonPK());
        },

        getCollaboratorsAdded: function() {
            return this.collaboratorsAdded;
        },

        getCollaboratorsRemoved: function() {
            return this.collaboratorsRemoved;
        },

        _onChange: function() {
            this.emit('change', this.collaboratorsAdded, this.collaboratorsRemoved);
        },

        _onPersonSelected: function() {
            const person = this.personSelect.get('item');

            if (!person) return;

            const personPK = person.getPersonPK();
            if (this._personAlreadyAdded(personPK)) {
                this.collaboratorsRemoved = this.collaboratorsRemoved.filter(
                    (addedPersonPK) => addedPersonPK !== personPK
                );
            } else {
                this.collaboratorsAdded.push(personPK);
            }

            this.collaboratorsTable.addCollaborator(person.getPersonPK(), person.getDisplayName());
            this._onChange();

            this.personSelect.reset();
        },

        _personAlreadyAdded: function(personPK) {
            return this.initialCollaborators.some((initPersonPK) => initPersonPK === personPK);
        }
    });
});
},
'soso/dijit/form/api/PeopleFilteringSelect':function(){
define([
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dojo/on',
    'soso/dojo/store/JsonRestApi',
    'soso/dijit/form/FilteringSelect',
    'api/person/Factory',
    'api/person/Config',
    'api/person/PersonTypesQuery',
    'spencer/core/data/Person',
    'spencer/core/parser/Person',
    'library/request/URLConnectionBuilder',
    'library/request/URLResponseProcessorBuilder',
    'library/request/data/Handlers',
    'library/request/dojo/URLConnectionProcessorBuilder',
    'library/request/helper/DefaultUnauthorisedCallback',
    'spencer/format/PersonDisplayName'
], function(
    declare,
    lang,
    on,
    JsonRestApi,
    FilteringSelect,
    Builder,
    Config,
    PersonTypes,
    PersonVO,
    Parser,
    URLConnectionBuilder,
    URLResponseProcessorBuilder,
    HandlersVO,
    URLConnectionProcessorBuilder,
    DefaultUnauthorisedCallback,
    PersonDisplayName
) {
    return declare('soso.dijit.form.api.PeopleFilteringSelect', [FilteringSelect], {
        DEFAULT_PAGE_SIZE: 10,
        DEFAULT_QUERY_EXPR: '*${0}*',
        DEFAULT_FILTER_FIELD: 'name',

        labelFunction: null,
        pageSize: null,
        onChangeCallBack: null,
        builder: null,
        personPK: null,
        personType: null,
        includeLabour: null,
        includeInactive: null,
        searchAttr: null,
        store: null,
        useLabelFunctionForItem: true,
        queryExpr: null,
        filterField: null,

        postMixInProperties: function() {
            this.pageSize = parseInt(this.pageSize) || this.DEFAULT_PAGE_SIZE;
            this.labelFunc = this.labelFunction || lang.hitch(this, '_formatPerson');
            this.useLabelFunctionForItem = true;
            this.queryExpr = this.queryExpr || this.DEFAULT_QUERY_EXPR;
            this.filterField = this.filterField || this.DEFAULT_FILTER_FIELD;

            this._createBuilder();
            if (!this.store) {
                this._createStore();
            }

            this.searchAttr = this.searchAttr || this.store.searchAttr;

            this.inherited(arguments);
        },

        postCreate: function() {
            this.inherited(arguments);

            on(this, 'change', lang.hitch(this, function() {
                if (typeof this.onChangeCallBack === 'function') {
                    this.onChangeCallBack(this.get('item'));
                }
            }));
        },

        setPersonVO: function (personVO, triggerOnChange) {
            this.set('item', personVO, triggerOnChange);
        },

        _createBuilder: function() {
            this.builder = new Builder(
                new Config(),
                new URLConnectionBuilder(
                    new URLConnectionProcessorBuilder()
                ),
                new URLResponseProcessorBuilder()
            );
        },

        _createStore: function () {
            this.set('store', this._createPeopleStore());
        },

        _formatPerson: function(item) {
            if (!item) {
                return '';
            }

            return (new PersonDisplayName())
                .setDisplayName(item.displayName)
                .setJobTitle(item.jobTitle)
                .setOrganisation(item.organisation)
                .format();
        },

        _createHandlersVO: function () {
            return new HandlersVO(
                null,
                null,
                DefaultUnauthorisedCallback,
                function (error, description) {
                    console.log(error);
                    console.log(description);
                }
            );
        },

        _createPeopleStore: function () {
            const pvo = new PersonVO();
            pvo.setPersonPK(this.personPK);

            const peopleCollection = this.builder.getPeopleCollection();
            peopleCollection.setFilterField(this.filterField);

            if (this.personType) {
                peopleCollection.setPersonType(this.personType);
            }

            if (this.includeLabour !== null) {
                peopleCollection.setIncludeLabour(this.includeLabour);
            }

            if (this.includeInactive !== null) {
                peopleCollection.setIncludeInactive(this.includeInactive);
            }

            return new JsonRestApi({
                idProperty: 'personPK',
                searchAttr: 'displayName',
                resultParser: new Parser(),
                getModel: this.builder.getPerson(),
                getFunction: 'get',
                getFunctionArgsCreator: lang.hitch(this, function (id) {
                    const pvo = new PersonVO;
                    pvo.setPersonPK(id);

                    return [
                        this._createHandlersVO(),
                        pvo
                    ];
                }),
                queryModel: peopleCollection,
                queryFunction: 'fetch',
                queryFunctionArgs: [
                    this._createHandlersVO(),
                    pvo
                ]
            });
        }
    });
});
},
'api/person/PersonTypesQuery':function(){
define(["require", "exports", "@lib/api/person/PersonType"], function (require, exports, PersonTypesQuery) {
    "use strict";
    return PersonTypesQuery;
});

},
'@lib/api/person/PersonType':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    return {
        EMPLOYEE: 1,
        FREELANCER: 2,
        EMPLOYEE_AND_FREELANCER: 3,
        EXTERNAL: 4
    };
});

},
'style-guide/v1/file-tray/dialog/CollaboratorsTable':function(){
define([
    'dijit/_WidgetBase',
    'dojo/_base/declare',
    'dojo/Evented',
    'dojo/text!./template/CollaboratorsTable.html',
    'soso/sosox/ejs/_Templated'
], function(
    _WidgetBase,
    declare,
    _Evented,
    template,
    _TemplatedMixin
) {
    return declare([_WidgetBase, _TemplatedMixin, _Evented], {
        data: {
            collaborators: [],
            readOnly: false
        },
        readOnly: false,
        templateString: template,

        postMixInProperties: function() {
            this.data.readOnly = this.readOnly;
        },

        reset: function() {
            this.data.collaborators = [];
            this.data.readOnly = this.readOnly;
            this.render();
        },

        addCollaborator: function(personPK, displayName) {
            this.data.collaborators.push({
                'personPK': personPK,
                'displayName': displayName
            });
            this._sort(this.data.collaborators);
            this.render();
        },

        _onRemoveClick: function(e) {
            const personPK = parseInt(e.currentTarget.dataset.personPk);

            this.data.collaborators = this.data.collaborators.filter((c) => c.personPK !== personPK);
            this.render();

            this.emit('remove', personPK);
        },

        _sort: function(collaborators) {
            collaborators.sort((a, b) => a.displayName.localeCompare(b.displayName));
        }
    });
});
},
'style-guide/v1/file-tray/SplitBasketTable':function(){
define([
    'dojo/_base/declare',
    'dojo/Evented',
    'dojo/query',
    'dojo/on',
    'dojo/text!./template/SplitBasketTable.html',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated',
    'style-guide/v1/icons/FileTypeToIconClass',
    'style-guide/v1/icons/FileTypeToColourClass',
    'style-guide/v1/layout/Dialog',
    './SplitBasketRename'
], function(
    declare,
    _Evented,
    query,
    on,
    template,
    _WidgetBase,
    _Templated,
    FileTypeToIconClass,
    FileTypeToColourClass,
    Dialog,
    SplitBasketRename
) {
    return declare([_WidgetBase, _Templated, _Evented], {
        widgetBasketRenameDialog: null,
        widgetBasketRenameForm: null,
        data: {
            baskets: [],
            basketPrefix: '',
            revisions: [],
            shownRevisionPKs: []
        },
        renameSubmitHandler: null,
        revisions: [],
        templateString: template,

        postCreate: function() {
            this.inherited(arguments);

            this.widgetBasketRenameForm = new SplitBasketRename();
            this.widgetBasketRenameDialog = new Dialog({
                additionalClass: 'min-height-0',
                titleString: 'Rename Basket',
                contentNode: this.widgetBasketRenameForm.domNode
            });
            on(this.widgetBasketRenameForm, 'cancel', () => {
                this.widgetBasketRenameDialog.hide();
            });
        },

        postMixInProperties: function() {
            this.inherited(arguments);

            const fileTypeToIconClass = new FileTypeToIconClass();
            const fileTypeToColourClass = new FileTypeToColourClass();
            this.setCustomViewHelpers({
                fileTypeToColourClass: (fileType) => {
                    const r = fileTypeToColourClass.getClass(fileType);
                    return fileTypeToColourClass.isDefault(r) ? '' : r + '-foreground';
                },
                fileTypeToIconClass: (fileType) => {
                    return fileTypeToIconClass.getClass(fileType);
                }
            });
        },

        reset: function(revisions) {
            this.data.baskets = [];
            this.data.basketPrefix = '';
            this.revisions = revisions;
            this.data.revisions = revisions;
            this.data.shownRevisionPKs = revisions.map((r) => r.getRevisionPK());
            this.render();
            this._emitChange();
        },

        setBasketPrefix: function(basketPrefix) {
            this.data.basketPrefix = basketPrefix;
            this.data.baskets = this._getBaskets(false);
            this.render();
            this._emitChange();
        },

        setFilter: function(filter) {
            this.data.shownRevisionPKs = this.revisions.filter(
                (r) => r.getTitle().toLowerCase().indexOf(filter.toLowerCase()) >= 0
            ).map((r) => r.getRevisionPK());
            this.data.baskets = this._getBaskets(false);
            this.render();
        },

        getBaskets: function() {
            return this._getBaskets(true);
        },

        addBasket: function(basketName, md5s) {
            this.data.baskets = this._getBaskets(false);
            this.data.baskets.push(this._createBasketData(basketName, []));
            this.render();
            if (md5s) {
                this._getAllCheckboxesForBasket(this.data.baskets.length - 1)
                    .forEach((c) => c.checked = md5s.indexOf(c.dataset.md5) >= 0);
                this.data.baskets = this._getBaskets(false);
                this.render();
            }
            this._emitChange();
        },

        deleteBaskets: function() {
            this.data.baskets = [];
            this.render();
            this._emitChange();
        },

        _getBaskets: function(withPrefix = false) {
            return Array.from(query('span[data-basket-id]', this.domNode).map((span, index) => {
                const selectedMd5s = Array.from(this._getAllCheckboxesForBasket(index))
                    .filter((checkbox) => checkbox.checked)
                    .map((checkbox) => checkbox.dataset.md5);
                return this._createBasketData(
                    (withPrefix ? this.data.basketPrefix : '') + span.innerText,
                    this.revisions.filter((r) => selectedMd5s.indexOf(r.getMd5()) >= 0)
                );
            }));
        },

        _getAllCheckboxesForBasket: function(id, ignoreHidden = false) {
            return query((ignoreHidden ? 'tr:not(.display-none) ' : '') + 'input[type="checkbox"][data-id="' + id + '"]', this.domNode);
        },

        _getAllCheckboxesForRevision: function(md5, ignoreHidden = false) {
            return query((ignoreHidden ? 'tr:not(.display-none) ' : '') + 'input[type="checkbox"][data-md5="' + md5 + '"]', this.domNode);
        },

        _onBasketSelectAllClick: function(e) {
            this._getAllCheckboxesForBasket(parseInt(e.currentTarget.dataset.id), true).forEach((c) => c.checked = true);
            this._onCheckboxChange();
        },

        _onBasketSelectNoneClick: function(e) {
            this._getAllCheckboxesForBasket(parseInt(e.currentTarget.dataset.id), true).forEach((c) => c.checked = false);
            this._onCheckboxChange();
        },

        _onRevisionSelectAllClick: function(e) {
            this._getAllCheckboxesForRevision(e.currentTarget.dataset.md5, true).forEach((c) => c.checked = true);
            this._onCheckboxChange();
        },

        _onRevisionSelectNoneClick: function(e) {
            this._getAllCheckboxesForRevision(e.currentTarget.dataset.md5, true).forEach((c) => c.checked = false);
            this._onCheckboxChange();
        },

        _onCheckboxChange: function() {
            this.data.baskets = this._getBaskets(false);
            this.render();
            this._emitChange();
        },

        _onRenameClick: function(e) {
            const basketId = parseInt(e.currentTarget.dataset.id);
            const basketNameSpan = query('span[data-basket-id="' + basketId + '"]', this.domNode)[0];
            this.widgetBasketRenameForm.reset();
            this.widgetBasketRenameForm.setBasketName(basketNameSpan.innerText);
            if (this.renameSubmitHandler) this.renameSubmitHandler.remove();
            this.renameSubmitHandler = on(this.widgetBasketRenameForm, 'submit', (name) => {
                basketNameSpan.innerText = name;
                this.data.baskets = this._getBaskets(false);
                this.render();
                this.widgetBasketRenameDialog.hide();
                this._emitChange();
            });
            this.widgetBasketRenameDialog.show();
            this.widgetBasketRenameForm.focus();
        },

        _onRemoveClick: function(e) {
            this.data.baskets = this._getBaskets(false);
            this.data.baskets.splice(parseInt(e.currentTarget.dataset.id), 1);
            this.render();

            this._emitChange();
        },

        _emitChange: function() {
            this.emit('change', this._getBaskets(true));
        },

        _createBasketData: function(name, revisions) {
            return {
                name: name,
                revisions: revisions
            };
        }
    });
});


},
'style-guide/v1/file-tray/SplitBasketRename':function(){
define([
    'dojo/_base/declare',
    'dojo/Evented',
    'dojo/keys',
    'dojo/text!./template/SplitBasketRename.html',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated'
], function(
    declare,
    _Evented,
    dojoKeys,
    template,
    _WidgetBase,
    _Templated
) {
    return declare([_WidgetBase, _Templated, _Evented], {
        elementBasketName: null,
        elementRenameButton: null,
        templateString: template,

        reset: function() {
            this.render();
        },

        focus: function() {
            this.elementBasketName.focus();
        },

        setBasketName: function(basketName) {
            this.elementBasketName.value = basketName;
            this._updateRenameButtonDisabledState();
        },

        _onBasketNameInput: function() {
            this._updateRenameButtonDisabledState();
        },

        _onBasketNameKeyUp: function(e) {
            if (this.elementBasketName.value?.trim() && e.keyCode === dojoKeys.ENTER) {
                this.emit('submit', this.elementBasketName.value?.trim());
            }
        },

        _onRenameClick: function() {
            this.emit('submit', this.elementBasketName.value?.trim());
        },

        _onCancelClick: function() {
            this.emit('cancel');
        },

        _updateRenameButtonDisabledState: function() {
            this.elementRenameButton.disabled = !this.elementBasketName.value?.trim();
        }
    });
});


},
'style-guide/v1/file-tray/SplitBasketAddMultipleBaskets':function(){
define([
    'dojo/_base/declare',
    'dojo/Evented',
    'dojo/text!./template/SplitBasketAddMultipleBaskets.html',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated'
], function(
    declare,
    _Evented,
    template,
    _WidgetBase,
    _Templated
) {
    const CHARACTER_COMMA = ',';
    const NEWLINE_THRESHOLD = 1;
    const REGEX_NEWLINE = /\r\n|\r|\n/;

    return declare([_WidgetBase, _Templated, _Evented], {
        elementBasketNames: null,
        elementAddBasketsButton: null,
        templateString: template,

        reset: function() {
            this.render();
        },

        focus: function() {
            this.elementBasketNames.focus();
        },

        _onBasketNamesInput: function() {
            this._updateRenameButtonDisabledState();
        },

        _onAddBasketsClick: function() {
            this.emit('submit', this._splitText(this.elementBasketNames.value?.trim()));
        },

        _onCancelClick: function() {
            this.emit('cancel');
        },

        _updateRenameButtonDisabledState: function() {
            this.elementAddBasketsButton.disabled = !this.elementBasketNames.value?.trim();
        },

        _splitText: function(text) {
            if (!text) return [];

            if (this._shouldUseNewLines(text)) {
                return this._filterStringArray(this._splitOnNewLines(text));
            }

            return this._filterStringArray(this._splitOnCommas(text));
        },

        _shouldUseNewLines: function(text) {
            return this._countNewLines(text.trim()) > NEWLINE_THRESHOLD;
        },

        _countNewLines: function(text) {
            return this._splitOnNewLines(text).length;
        },

        _splitOnCommas: function(text) {
            return text.split(CHARACTER_COMMA);
        },

        _splitOnNewLines: function(text) {
            return text.split(REGEX_NEWLINE);
        },

        _filterStringArray: function(strings) {
            return strings.filter((s) => !!s).map((s) => s.trim());
        }
    });
});


},
'style-guide/v1/file-tray/dialog/BasketSelectDialog':function(){
define([
    'dijit/_WidgetBase',
    'dijit/form/FilteringSelect',
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/store/Memory',
    'dojo/text!./template/BasketSelectDialog.html',
    'soso/sosox/ejs/_Templated',
    'style-guide/v1/layout/Dialog'
], function(
    _WidgetBase,
    FilteringSelect,
    declare,
    domAttr,
    Memory,
    template,
    _TemplatedMixin,
    Dialog
) {
    return declare([_WidgetBase, _TemplatedMixin], {
        templateString: template,
        basketSelect: null,
        basketStore: null,
        dialog: null,
        selectButton: null,
        onSelect: function() {},

        postCreate: function() {
            this.inherited(arguments);

            this.dialog = new Dialog({
                contentNode: this.domNode,
                titleString: 'Add to Existing Basket'
            });

            this.basketStore = new Memory({
                data: [],
                idProperty: 'id',
                labelProperty: 'name'
            });

            this.basketSelect = new FilteringSelect({
                'class': 'sos-form-filtering-select width-100 m-0',
                placeholder: 'Select saved basket...',
                store: this.basketStore,
                searchAttr: 'name',
                onChange: () => {
                    if (!this.basketSelect.isValid()) {
                        domAttr.set(this.selectButton, 'disabled', 'disabled');
                    } else {
                        domAttr.remove(this.selectButton, 'disabled');
                    }
                }
            }, this.selectNode);
        },

        setBasketCollection: function(basketCollection) {
            this.basketStore.setData(basketCollection);
        },

        show: function(onSelect) {
            this.onSelect = onSelect || this.onSelect;
            this.dialog.show();
        },

        _onCloseClick: function() {
            this.dialog.hide();
        },

        _onSelectClick: function() {
            this.dialog.hide();
            this.onSelect(this.basketSelect.get('value'));
        }
    });
});
},
'style-guide/v1/file-tray/dialog/RenameBasketDialog':function(){
define([
    'dojo/_base/declare',
    'dojo/dom-attr',
    'soso/sosox/ejs/_Templated',
    '@lib/api/doc-control/document/data/Basket',
    '@lib/request/data/Handlers',
    './NameBasketDialog'
], function(
    declare,
    domAttr,
    Dialog,
    BasketVO,
    Handlers,
    NameBasketDialog
) {
    return declare([NameBasketDialog], {
        modelBasket: null,
        notification: null,
        basket: null,

        postCreate: function() {
            this.inherited(arguments);

            this.dialog.setTitle('Rename Basket');
            this.saveButton.innerText = 'Rename Basket';
        },

        show: function(basket) {
            this.basket = basket;

            this.inherited(arguments);

            this.nameInput.set('value', basket.getName());
        },

        _onSaveClick: function() {
            if (!this._validate()) {
                return;
            }

            this.basket.setName(this.nameInput.get('value'));

            const uid = this.notification.progress('SAVING_BASKET_PROGRESS', {});
            const onError = () => {
                this.notification.error('SAVING_BASKET_ERROR', {}, uid);
                this.reset();
            };

            this.nameInput.set('disabled', true);
            domAttr.set(this.closeButton, 'disabled', 'disabled');
            domAttr.set(this.saveButton, 'disabled', 'disabled');

            this.modelBasket.update(this.basket, new Handlers(() => {
                this.notification.success('SAVING_BASKET_SUCCESS', {}, uid);
                this.dialog.hide();

                this.emit('save', {basket: this.basket});
            }, onError));
        }
    });
});
},
'style-guide/v1/file-tray/dialog/NameBasketDialog':function(){
define([
    'dijit/_WidgetBase',
    'dijit/form/ValidationTextBox',
    'dojo/_base/declare',
    'dojo/Evented',
    'dojo/keys',
    'dojo/text!./template/NameBasketDialog.html',
    'soso/sosox/ejs/_Templated',
    'style-guide/v1/layout/Dialog'
], function(
    _WidgetBase,
    ValidationTextBox,
    declare,
    _Evented,
    dojoKeys,
    template,
    _TemplatedMixin,
    Dialog
) {
    return declare([_WidgetBase, _TemplatedMixin, _Evented], {
        addCollaboratorsButton: null,
        addCollaboratorsContainerNode: null,
        closeButton: null,
        collaboratorsContainerNode: null,
        collaboratorsFormContainerNode: null,
        collaboratorsFormNode: null,
        collaboratorsNode: null,
        dialog: null,
        nameInput: null,
        nameInputNode: null,
        saveButton: null,
        templateString: template,

        postCreate: function() {
            this.inherited(arguments);

            this.dialog = new Dialog({
                contentNode: this.domNode,
                titleString: 'Basket'
            });

            this.nameInput = new ValidationTextBox({
                'class': 'sos-form-textfield m-0 mt-6 width-100 sos-form-textfield-validation',
                invalidMessage: 'A name is required',
                tooltipPosition: ['below'],
                required: true,
                validator: (value) => value && value.trim() !== '',
                onKeyUp: (e) => {
                    this._configureSaveButtonState();

                    if (e.keyCode !== dojoKeys.ENTER) return;

                    this._onSaveClick();
                },
                onChange: this._configureSaveButtonState.bind(this)
            }, this.nameInputNode);
        },

        reset: function() {
            this.nameInput.reset();
            this.nameInput.set('disabled', false);
            this.closeButton.removeAttribute('disabled');
            this.saveButton.setAttribute('disabled', 'disabled');
        },

        show: function() {
            this.reset();
            this.dialog.show();
            this.nameInput.focus();
        },

        _validate: function() {
            this.nameInput._hasBeenBlurred = true;
            return this.nameInput.validate();
        },

        _configureSaveButtonState: function() {
            this._validate() ? this.saveButton.removeAttribute('disabled') : this.saveButton.setAttribute('disabled', 'disabled');
        },

        _onCloseClick: function() {
            this.dialog.hide();
        },

        _onSaveClick: function() {}
    });
});
},
'style-guide/v1/file-tray/dialog/SaveBasketDialog':function(){
define([
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/on',
    'soso/sosox/ejs/_Templated',
    '@lib/api/doc-control/document/data/Basket',
    '@lib/request/data/Handlers',
    './CollaboratorsForm',
    './NameBasketDialog'
], function(
    declare,
    domAttr,
    on,
    Dialog,
    BasketVO,
    Handlers,
    CollaboratorsForm,
    NameBasketDialog
) {
    return declare([NameBasketDialog], {
        apiDocumentFactory: null,
        collaboratorsForm: null,
        notification: null,
        revisionCollection: [],

        postCreate: function() {
            this.inherited(arguments);

            this.dialog.setTitle('Save Basket');

            this.collaboratorsContainerNode.classList.remove('display-none');
            on(this.addCollaboratorsButton, 'click', () => {
                this.collaboratorsForm = new CollaboratorsForm({
                    'class': 'mt-12'
                }, this.collaboratorsFormNode);

                this.addCollaboratorsContainerNode.classList.add('display-none');
                this.collaboratorsFormContainerNode.classList.remove('display-none');

                this.collaboratorsForm.focus();
            });
        },

        show: function(revisionCollection) {
            this.revisionCollection = revisionCollection;

            this.inherited(arguments);
        },

        _onSaveClick: function() {
            if (!this._validate()) {
                return;
            }

            const uid = this.notification.progress('SAVING_BASKET_PROGRESS', {});
            const onError = () => {
                this.notification.error('SAVING_BASKET_ERROR', {}, uid);
                this.reset();
            };

            this.nameInput.set('disabled', true);
            domAttr.set(this.closeButton, 'disabled', 'disabled');
            domAttr.set(this.saveButton, 'disabled', 'disabled');

            const addedCollaborators = this.collaboratorsForm?.getCollaboratorsAdded() ?? [];

            const h = new Handlers(
                (basket) => {
                    this.apiDocumentFactory.getBasketRevisionCollection().save(
                        new Handlers(
                            () => {
                                if (addedCollaborators.length) {
                                    this.apiDocumentFactory.getBasketCollaborator().add(
                                        basket.getId(),
                                        addedCollaborators,
                                        new Handlers(() => this._onSaveSuccess(uid), onError)
                                    );
                                    return;
                                }

                                this._onSaveSuccess(uid);
                            },
                            onError
                        ),
                        basket.getId(),
                        this.revisionCollection
                    )
                },
                onError
            );

            this.apiDocumentFactory.getBasket().save(new BasketVO(null, this.nameInput.get('value')), h);
        },

        _onSaveSuccess: function(notificationUid) {
            this.notification.success('SAVING_BASKET_SUCCESS', {}, notificationUid);
            this.collaboratorsForm?.reset();
            this.dialog.hide();

            this.emit('save');
        }
    });
});
},
'@lib/spencer/notification/constants/EventTypes':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    var EventTypes;
    (function (EventTypes) {
        EventTypes["Updated"] = "updated";
        EventTypes["CollaboratorAdded"] = "collaborator-added";
        EventTypes["CollaboratorRemoved"] = "collaborator-removed";
        EventTypes["NewMessage"] = "new-message";
    })(EventTypes || (EventTypes = {}));
    return EventTypes;
});

},
'@lib/spencer/notification/constants/Systems':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    var Systems;
    (function (Systems) {
        Systems["Basket"] = "basket";
        Systems["Email"] = "email";
    })(Systems || (Systems = {}));
    return Systems;
});

},
'@lib/spencer/notification/SubscriberSingleton':function(){
define(["require", "exports", "@lib/spencer/notification/Subscriber"], function (require, exports, Subscriber_1) {
    "use strict";
    class SubscriberSingleton {
        static init(defaultSubscribers) {
            SubscriberSingleton.subscriber = new Subscriber_1.default(defaultSubscribers);
        }
        static get() {
            if (!SubscriberSingleton.subscriber)
                throw 'Notification system not initialised';
            return this.subscriber;
        }
    }
    return SubscriberSingleton;
});

},
'@lib/spencer/notification/Subscriber':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    class Subscriber {
        constructor(subscribers) {
            this.subscribers = subscribers;
        }
        subscribe(onNotification) {
            this.subscribers.push(onNotification);
        }
        getSubscribers() {
            return this.subscribers;
        }
    }
    exports.default = Subscriber;
});

},
'style-guide/v1/file-tray/Interface':function(){
define([], function() {
    let Interface = function(widget) {
        this.widget = widget;
    };

    Interface.prototype.open = function() {
        this.widget.open();
    };

    Interface.prototype.openBasket = function (basket) {
        this.widget.openBasket(basket);
    }

    Interface.prototype.close = function() {
        this.widget.close();
    };

    Interface.prototype.addItem = function(md5) {
        this.widget.addItem(md5);
    };

    Interface.prototype.getItems = function() {
        return this.widget.getItems();
    };

    Interface.prototype.getSelectedItems = function() {
        return this.widget.getSelectedItems();
    };

    Interface.prototype.setContextButtons = function(contextName, buttonArray) {
        this.widget.getContextButtonContainer().setContext(contextName, buttonArray);
    };

    Interface.prototype.clearContextButtons = function() {
        this.widget.getContextButtonContainer().clearContext();
    };

    Interface.prototype.refreshItem = function (md5) {
        this.widget.refreshItem(md5)
    };

    return Interface;
});
},
'doccontrol/viewer/dojo/FileTypeTile':function(){
define([
    'dojo/_base/declare',
    'dojo/_base/lang',
    'style-guide/v1/icons/FileTypeToIconClass',
    'style-guide/v1/icons/FileTypeToColourClass',
    'spencer/format/Megabytes',
    'spencer/format/MimeType',
    'dojo/text!./template/FileTypeTile.html',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated'
], function(
    declare,
    lang,
    FileTypeToIconClass,
    FileTypeToColourClass,
    MegaBytesFormatter,
    MimeTypeFormatter,
    template,
    _WidgetBase,
    _Templated
) {
    return declare([_WidgetBase, _Templated], {
        templateString: template,
        data: {
            'fileType': null,
            'fileSize': null
        },

        postMixInProperties: function() {
            this.inherited(arguments);

            var fileTypeToIconClass = new FileTypeToIconClass();
            var fileTypeToColourClass = new FileTypeToColourClass();
            var megabytesFormatter = new MegaBytesFormatter();
            var mimeTypeFormatter = new MimeTypeFormatter();

            this.setCustomViewHelpers({
                fileTypeToColourClass: lang.hitch(fileTypeToColourClass, fileTypeToColourClass.getClass),
                fileTypeToIconClass: lang.hitch(fileTypeToIconClass, fileTypeToIconClass.getClass),
                megabytesFormatter: lang.hitch(megabytesFormatter, megabytesFormatter.format),
                mimeTypeFormatter: lang.hitch(mimeTypeFormatter, mimeTypeFormatter.format)
            });
        }
    });
});
},
'doccontrol/viewer/dojo/MediaViewer':function(){
define([
    '../Topics',
    './ViewerDialog',
    './MediaViewerBody',
    './ViewInformation',
    'dijit/_WidgetBase',
    'dijit/_TemplatedMixin',
    'dijit/form/NumberTextBox',
    'dojo/_base/declare',
    'dojo/dom-class',
    'dojo/dom-construct',
    'dojo/on',
    'dojo/topic',
    'dojo/text!./template/MediaViewer.html'
], function(
    Topics,
    Dialog,
    MediaViewerBody,
    ViewInformationWidget,
    WidgetBase,
    Templated,
    NumberTextBox,
    declare,
    domClass,
    domConstruct,
    on,
    topic,
    Template
){
    const MediaViewer = function(routeContainer, dataManager) {
        const View = declare([WidgetBase, Templated], {
            routeContainer: routeContainer,
            dataManager: dataManager,
            popup: null,
            body: null,
            inline: false,
            widgetsInTemplate: true,
            templateString: Template,
            showRevisionSidebar: false,

            viewerInformationWidget: null,
            fileType: null,
            reloadHref: null,

            constants: {
                LONG_LOAD_MESSAGE_TIMEOUT: 15
            },

            elementCancel: null,
            longLoadMessage: null,
            longLoadMessageTimer: null,

            setDataUrl: function(dataUrl) {
                this.hideLoading();
                this.body = new MediaViewerBody({
                    'data': {
                        'mediaType': this.getMediaType(),
                        'fileType': this.fileType,
                        'href': dataUrl
                    },
                    onSuccess: this.hideLoadingContainer.bind(this)
                }, domConstruct.create('div', {}, this.bodyContainer, 'only'));
            },

            hideLoading: function() {
                this.abortLongLoadMessageTimer();

                domClass.add(this.loading, 'hidden');
            },

            hideLoadingContainer: function() {
                domClass.add(this.loadingContainer, 'hidden');
            },

            setFileType: function(fileType) {
                this.fileType = fileType;
            },

            showBlacklistedMessage: function() {
                this.body.showBlacklistedMessage();
            },

            getInformation: function() {
                return this.viewerInformationWidget;
            },

            showErrorMessage: function() {
                domClass.remove(this.errorMessage, 'hidden');
                this.hideLoading();
            },

            showDeletedMessage: function() {
                domClass.remove(this.deletedMessage, 'hidden');
                this.hideLoading();
            },

            showUnauthorisedMessage: function() {
                this.viewerInformationWidget?.showUnauthorisedMessage();

                domClass.remove(this.unauthorisedMessage, 'hidden');
                this.hideLoading();
            },

            showAbortMessage: function() {
                domClass.remove(this.abortMessage, 'hidden');
                this.hideLoading();
                domClass.add(this.contentContainer, 'hidden');
            },

            startLongLoadMessageTimer: function() {
                this.abortLongLoadMessageTimer();

                this.longLoadMessageTimer = setTimeout(function() {
                    if (this.inline || !this.longLoadMessage) return;

                    domClass.remove(this.longLoadMessage, 'hidden');
                }.bind(this), this.constants.LONG_LOAD_MESSAGE_TIMEOUT * 1000);
            },

            abortLongLoadMessageTimer: function() {
                clearTimeout(this.longLoadMessageTimer);
            },

            postCreate: function() {
                this.popup = new Dialog({content: this.domNode});
                on(this.popup, 'hide', function() {
                    topic.publish(Topics.DOCUMENT_VIEWER_HIDE);
                }.bind(this));

                this.own(topic.subscribe(Topics.DOCUMENT_VIEWER_HIDE, this._destroyDialog.bind(this)));

                this.viewerInformationWidget = new ViewInformationWidget(
                    this.routeContainer,
                    this.informationContainer,
                    this.dataManager
                );

                this.inherited(arguments);
            },

            getMediaType: function() {
                const fileType = this.fileType.split('/');
                return fileType[0];
            },

            show: function() {
                this.popup.show();

                this.inherited(arguments);
            },

            showInline: function() {
                this.inline = true;
                this.popup.showInline();
            },

            hideInline: function() {
                this.inline = false;
                this.popup.hideInline();
            },

            setWidth: function(percentage) {
                this.popup?.setWidth(percentage);
            },

            unsetWidth: function() {
                this.popup?.unsetWidth();
            },

            enableStandalone: function() {
                if (this.popup) this.popup.set('closable', false);
                if (this.elementCancel) this.elementCancel.classList.add('display-none');
            },

            showNavigation: function() {
                domClass.add(this.popup.domNode, 'navigation-showing');
            },

            setReloadHref: function(href) {
                this.reloadHref = href;
            },

            _reload: function() {
                domClass.add(this.abortMessage, 'hidden');
                domClass.add(this.longLoadMessage, 'hidden');

                domClass.remove(this.loading, 'hidden');
                domClass.remove(this.contentContainer, 'hidden');
                topic.publish(Topics.DOCUMENT_VIEWER_RELOAD_MEDIA, this.reloadHref, this.revision);
            },

            _destroyDialog: function() {
                domConstruct.destroy(this.popup.domNode);
                this.destroyRecursive();
                this.popup.destroyRecursive();
                delete this.popup;
            },

            _onCancelClick: function() {
                topic.publish(Topics.DOCUMENT_VIEWER_HIDE);
            }
        });

        this.view = new View();
    };

    MediaViewer.prototype.setFileType = function(fileType) {
        this.view.setFileType(fileType);
    };

    MediaViewer.prototype.getInformation = function() {
        return this.view.getInformation();
    };

    MediaViewer.prototype.showBlacklistedMessage = function() {
        this.view.showBlacklistedMessage();
    };

    MediaViewer.prototype.show = function() {
        this.view.show();
    };

    MediaViewer.prototype.setDataUrl = function(dataUrl) {
        this.view.setDataUrl(dataUrl);
    };

    MediaViewer.prototype.showNavigation = function() {
        this.view.showNavigation();
    };

    MediaViewer.prototype.showErrorMessage = function() {
        this.view.showErrorMessage();
    };

    MediaViewer.prototype.showDeletedMessage = function() {
        this.view.showDeletedMessage();
    };

    MediaViewer.prototype.showUnauthorisedMessage = function() {
        this.view.showUnauthorisedMessage();
    };

    MediaViewer.prototype.showAbortMessage = function() {
        this.view.showAbortMessage();
    };

    MediaViewer.prototype.startLongLoadMessageTimer = function() {
        this.view.startLongLoadMessageTimer();
    };

    MediaViewer.prototype.setReloadHref = function(href) {
        this.view.setReloadHref(href);
    };

    MediaViewer.prototype.showInline = function() {
        this.view.showInline();
    };

    MediaViewer.prototype.hideInline = function() {
        this.view.hideInline();
    };

    MediaViewer.prototype.setWidth = function(percentage) {
        this.view.setWidth(percentage);
    };

    MediaViewer.prototype.unsetWidth = function() {
        this.view.unsetWidth();
    };

    MediaViewer.prototype.enableStandalone = function() {
        this.view.enableStandalone();
    };

    MediaViewer.prototype.showRevisionSidebar = function() {
        this.view.showRevisionSidebar = true;
    };

    MediaViewer.prototype.supportsRevisionSidebar = function() {
        return this.view.showRevisionSidebar;
    };

    MediaViewer.prototype.destroy = function() {
        this.view.destroyRecursive();
    };

    return MediaViewer;
});
},
'doccontrol/viewer/dojo/MediaViewerBody':function(){
define([
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dojo/on',
    'dojo/dom-class',
    'dojo/text!./template/MediaViewerBody.html',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated'
], function(
    declare,
    lang,
    on,
    domClass,
    template,
    _WidgetBase,
    _Templated
) {
    return declare([_WidgetBase, _Templated], {
        templateString: template,
        data: {
            'fileType': null,
            'mediaType': null,
            'href': null
        },

        onSuccess: null,

        postCreate: function() {
            on(this.src, 'error', lang.hitch(this, function(e) {
                domClass.remove(this.errorMessage, 'hidden');
                domClass.add(this.mediaContainer, 'hidden');
            }));

            if (typeof this.onSuccess === 'function') {
                this.media.oncanplay = this.onSuccess;
            }
        },

        showBlacklistedMessage: function() {
            domClass.add(this.errorMessage, 'hidden');
            domClass.remove(this.mediaContainer, 'hidden');
        }
    });
});
},
'doccontrol/viewer/dojo/DialogToolbar':function(){
define([
    'doccontrol/viewer/data/DocumentReference',
    'doccontrol/viewer/dojo/FavouriteDialog',
    'dojo/_base/declare',
    'dojo/dom-class',
    'dojo/dom-construct',
    'dojo/dom',
    'dojo/Evented',
    'dojo/sniff',
    'dojo/touch',
    'dojo/topic',
    'dojo/text!./template/DialogToolbar.html',
    'dojo/query',
    'dijit/_WidgetBase',
    'dijit/form/NumberTextBox',
    'soso/sosox/ejs/_Templated',
    'spencer/data-manager/core/definition/Actions',
    'spencer/data-manager/data/Request',
    '../FileTypeViewable',
    '../Topics',
    './FileTypeTile'
], function(
    DocumentReference,
    FavouriteDialog,
    declare,
    domClass,
    domConstruct,
    dom,
    Evented,
    has,
    touch,
    topic,
    Template,
    query,
    WidgetBase,
    NumberTextBox,
    Templated,
    ACTIONS,
    RequestData,
    FileTypeViewable,
    TOPICS,
    FileTypeTile
) {
    const DialogToolbar = function(routeContainer, node, dataManager, localStorage) {
        const MESSAGE_TYPE_CORRESPONDENCE = 'message/rfc822';

        const View = declare([WidgetBase, Templated, Evented], {
            localStorage: localStorage,
            routeContainer: routeContainer,
            dataManager: dataManager,
            data: {
                name: null,
                titleLoading: true,
                fileType: null,
                fileSize: null,
                deleted: null,
                documentPK: null,
                hasAnnotations: false,
                hasNotification: false,
                isExportableToPDF: false,
                supportsInformation: false,
                markedAsPrivate: false,
                supportsOcr: false,
                supportsAnnotations: false,
                isIntranetOwner: dojoConfig.isIntranetOwner,
                annotationsEnabled: false,
                isFavourite: false,
                revisionPK: null
            },

            href: null,
            annotationOptionsEnabled: false,
            downloadEnabled: true,
            shareEnabled: true,
            printEnabled: true,
            informationEnabled: true,
            exportableToPDF: false,
            ocrEnabled: false,
            tempDocumentPK: null,
            md5: null,
            fileTypeViewable: null,
            showingInformation: false,
            templateString: Template,
            favouritePK: null,

            annotationOptions: null,
            download: null,
            downloadAnnotatedButton: null,
            downloadButtonNode: null,
            downloadDropDownNode: null,
            existingAnnotationsIcon: null,
            favouriteButtonNode: null,
            favouriteContainerNode: null,
            favouriteSpanNode: null,
            fileTitle: null,
            fileTypeContainer: null,
            information: null,
            informationNotificationIcon: null,
            ocr: null,
            printMenu: null,
            registerAnnotationsButton: null,
            registerDropdownNode: null,
            registerFileButton: null,
            reviseAnnotationsButton: null,
            shareLinkButtonNode: null,
            shareMenu: null,

            postMixInProperties: function() {
                this.inherited(arguments);

                this.fileTypeViewable = new FileTypeViewable();
            },

            setHref: function(href) {
                this.href = href;
            },

            async setRevision(revision) {
                this.data.revisionPK = revision.getRevisionPK();
                this.data.markedAsPrivate = revision.isMarkedAsPrivate();
                this.data.name = revision.getTitle();
                topic.publish(TOPICS.DOCUMENT_VIEWER_TITLE, revision.getTitle());
                this.data.fileType = revision.getFileType();
                this.data.fileSize = revision.getFileSize();
                this.data.deleted = revision.isDeleted();
                this.data.documentPK = revision.getDocumentPK();
                this.md5 = revision.getMd5();

                await this._setFavouriteProperties();

                this.render();
            },

            render: function() {
                if (this.isExportableToPDF()) {
                    this.data.isExportableToPDF = true;
                }

                this.inherited(arguments);

                if (this.existingAnnotationsIcon) {
                    if (this.data.hasAnnotations) {
                        domClass.remove(this.existingAnnotationsIcon, 'hidden');
                    } else {
                        domClass.add(this.existingAnnotationsIcon, 'hidden');
                    }
                }

                this.fileTitle.textContent = this.data.name;
                new FileTypeTile({data: this.data}, this.fileTypeContainer);

                touch.press(this.shareMenu, function(e) {
                    if (!domClass.contains(e.target, 'dropdown-header') ||
                        e.pointerType !== 'touch' ||
                        domClass.contains(this.shareMenu, 'disabled'))
                    {
                        return;
                    }

                    if (!domClass.contains(this.shareMenu, 'button-dropdown-open')) {
                        this._closeDropdowns();
                        domClass.add(this.shareMenu, 'button-dropdown-open');
                    } else {
                        this._closeDropdowns();
                    }
                }.bind(this));

                if (this.downloadDropDownNode) {
                    touch.press(this.downloadDropDownNode, function (e) {
                        if (domClass.contains(this.downloadDropDownNode, 'disabled')) {
                            return;
                        }

                        if (e.pointerType === 'mouse' && domClass.contains(e.target, 'dropdown-header')) {
                            if (this.data.supportsAnnotations && this.data.annotationsEnabled) {
                                this.downloadAnnotations(e);
                                return;
                            }

                            this.downloadFile(e);
                            return;
                        }

                        if (!domClass.contains(e.target, 'dropdown-header') || e.pointerType !== 'touch') {
                            return;
                        }

                        if (!domClass.contains(this.downloadDropDownNode, 'button-dropdown-open')) {
                            this._closeDropdowns();
                            domClass.add(this.downloadDropDownNode, 'button-dropdown-open');
                        } else {
                            this._closeDropdowns();
                        }
                    }.bind(this));
                }

                this._determineToolbarStatus();
                this._determineAnnotationExportVisibility();
                this._determineFavouriteButtonVisibility();
                this._determineRegistrationVisibility();
                this._determineShareLinkState();
                this.determineInformationShowing();
            },

            setTemporaryDocument: function(temporaryDocument) {
                this.tempDocumentPK = temporaryDocument.getTemporaryDocumentPK();
                this.data.name = temporaryDocument.getName();
                topic.publish(TOPICS.DOCUMENT_VIEWER_TITLE, temporaryDocument.getName());
                this.data.fileType = temporaryDocument.getType() + '/' + temporaryDocument.getSubType();
                this.data.fileSize = temporaryDocument.getSize();
                this.data.deleted = false;
                this.md5 = temporaryDocument.getMd5();

                this.render();
            },

            supportsInformation: function() {
                this.data.supportsInformation = true;
            },

            supportsAnnotations: function() {
                this.data.supportsAnnotations = true;
            },

            supportsOcr: function() {
                if (!(has('ie') || has('trident') || has('edge'))) {
                    this.data.supportsOcr = true;
                }
            },

            hideTitleLoading: function() {
                this.data.titleLoading = false;
            },

            hideExistingAnnotationsIcon: function() {
                this.data.hasAnnotations = false;

                if (this.existingAnnotationsIcon) {
                    domClass.add(this.existingAnnotationsIcon, 'hidden');
                }
            },

            showExistingAnnotationsIcon: function() {
                this.data.hasAnnotations = true;

                if (this.existingAnnotationsIcon) {
                    domClass.remove(this.existingAnnotationsIcon, 'hidden');
                }
            },

            isExportableToPDF: function() {
                const noneExportableTypes = [
                    'application/pdf',
                    'video',
                    'audio',
                    'image'
                ];

                return this.fileTypeViewable.isViewable(this.data.fileType)
                    && !noneExportableTypes.some(function(v) { return this.data.fileType.indexOf(v) >= 0; }.bind(this));
            },

            determineInformationShowing: function() {
                if (this.showingInformation && this.information) {
                    domClass.add(this.information, 'selected');
                }
            },

            downloadAnnotations: function(e) {
                e.stopImmediatePropagation();

                if (!this.downloadEnabled) {
                    return;
                }

                domClass.add(this.annotationOptions, 'selected');

                topic.publish(TOPICS.DOCUMENT_VIEWER_DOWNLOAD_WITH_ANNOTATIONS);

                this._closeDropdowns();
            },

            downloadFile: function(e) {
                e.stopImmediatePropagation();

                if (!this.downloadEnabled) {
                    return;
                }

                window.open(this.href, '_blank');

                topic.publish(TOPICS.DOCUMENT_VIEWER_DOWNLOAD);

                this._closeDropdowns();
            },

            downloadPDF: function(e) {
                e.stopImmediatePropagation();

                if (!this.downloadEnabled) {
                    return;
                }

                window.open(this.href + '?pdf', '_blank');

                topic.publish(TOPICS.DOCUMENT_VIEWER_DOWNLOAD);

                this._closeDropdowns();
            },

            onRegisterAnnotatedClick: function() {
                if (domClass.contains(this.registerAnnotationsButton, 'disabled')) return;

                topic.publish(TOPICS.DOCUMENT_VIEWER_REGISTER_ANNOTATED);

                this._closeDropdowns();
            },

            onRegisterFileClick: function(e) {
                if (domClass.contains(this.registerFileButton, 'disabled')) return;

                topic.publish(TOPICS.DOCUMENT_VIEWER_REGISTER, {
                    md5: this.md5,
                    name: this.data.name
                });

                this._closeDropdowns();
            },

            onReviseAnnotatedClick: function() {
                if (domClass.contains(this.reviseAnnotationsButton, 'disabled')) return;

                topic.publish(TOPICS.DOCUMENT_VIEWER_REVISE_ANNOTATED, this.data);

                this._closeDropdowns();
            },

            printFile: function(e) {
                e.stopImmediatePropagation();

                if (!this.printEnabled) {
                    return;
                }

                if (this._documentIsPrintableCorrespondenceType()) {
                    window.open(
                        this.data.revisionPK
                            ? this.routeContainer.get('printableEmailRevision', {id: this.data.revisionPK})
                            : this.routeContainer.get('printableEmailTemporaryDocument', {id: this.tempDocumentPK})
                    );
                    return;
                }

                if (this.data.annotationsEnabled) {
                    topic.publish(TOPICS.DOCUMENT_VIEWER_DOWNLOAD_WITH_ANNOTATIONS_IN_BROWSER);
                    return;
                }

                if (this.data.revisionPK) {
                    window.open(this.routeContainer.get('viewRevision', {id: this.data.revisionPK}, null, this._documentIsPrintableCorrespondenceType() ? {pdf: 1} : null));
                } else if (this.tempDocumentPK) {
                    window.open(this.routeContainer.get('viewTemporaryDocument', {id: this.tempDocumentPK}, null, this._documentIsPrintableCorrespondenceType() ? {pdf: 1} : null));
                }
            },

            showInformationNotificationIcon: function() {
                this.data.hasNotification = true;
                domClass.remove(this.informationNotificationIcon, 'hidden');
            },

            toggleInformation: function() {
                if (!this.informationEnabled) {
                    return;
                }

                topic.publish(TOPICS.DOCUMENT_VIEWER_TOGGLE_INFORMATION);
            },

            favouriteFile: function(e) {
                e.stopImmediatePropagation();
                const spanNode = this.favouriteSpanNode;

                if (this.favouritePK === null) {
                    this._disableFavouriteButton();
                    const dialog = new FavouriteDialog(this.dataManager, this.routeContainer);
                    dialog.on('close', e => {
                        this._enableFavouriteButton();
                    })
                    dialog.open(this.data.documentPK, this.data.revisionPK, this.data.name);
                    dialog.on('favouritedSuccess', async () => {
                        spanNode.classList.remove('sos-icon-empty-star');
                        spanNode.classList.add('sos-icon-star');
                        spanNode.innerHTML = 'Unfavourite';
                        const response = await this._sendFavouriteDocumentRequest();

                        this.favouritePK = response['favouritePK'];
                    });
                    return;
                }
                this._removeDocumentFavourite();
                this.favouritePK = null;
                topic.publish(
                    'sos-system-notification',
                    'Favourite removed successfully.',
                    'success',
                    2000
                );
                spanNode.classList.remove('sos-icon-star');
                spanNode.classList.add('sos-icon-empty-star');
                spanNode.innerHTML = 'Favourite';
            },

            toggleOcr: function() {
                if (!domClass.contains(this.ocr, 'disabled')) {
                    topic.publish(TOPICS.DOCUMENT_VIEWER_OCR);
                }
            },

            toggleAnnotationOptions: function() {
                if (!domClass.contains(this.annotationOptions, 'disabled')) {
                    topic.publish(TOPICS.DOCUMENT_VIEWER_SHOW_ANNOTATION_OPTIONS, this.localStorage.get('MODE'));
                    topic.publish(TOPICS.DOCUMENT_VIEWER_HIDE_INFORMATION);
                }
            },

            enableAnnotationOptions: function() {
                this.annotationOptionsEnabled = true;

                if (this.annotationOptions) {
                    domClass.remove(this.annotationOptions, 'disabled');
                }
            },

            enableOcr: function() {
                this.ocrEnabled = true;

                if (this.ocr) {
                    domClass.remove(this.ocr, 'disabled');
                }
            },

            disableAnnotationOptions: function() {
                this.annotationOptionsEnabled = false;
                if (this.annotationOptions) {
                    domClass.add(this.annotationOptions, 'disabled');
                }
            },

            disableInformation: function() {
                this.informationEnabled = false;
                domClass.add(this.information, 'disabled');
            },

            disableDownload: function() {
                this.downloadEnabled = false;
                domClass.add(this.downloadDropDownNode, 'disabled');
            },

            disableShare: function () {
                this.shareEnabled = false;
                domClass.add(this.shareMenu, 'disabled');
            },

            disablePrint: function () {
                this.printEnabled = false;
                domClass.add(this.printMenu, 'disabled')
            },

            disableOcr: function() {
                this.ocrEnabled = false;
                if (this.ocr) {
                    domClass.add(this.ocr, 'disabled');
                }
            },

            setInformationSelected: function() {
                this.unselectMenus();
                if (this.ocr) {
                    domClass.remove(this.ocr, 'selected');
                }

                this.showingInformation = true;
                if (!this.information) {
                    return;
                }

                domClass.add(this.information, 'selected');
            },

            toggleOcrSelected: function() {
                if (!domClass.contains(this.ocr, 'selected')) {
                    this.showingInformation = false;
                    if (this.information) {
                        domClass.remove(this.information, 'selected');
                    }

                    if (this.annotationOptions) {
                        domClass.remove(this.annotationOptions, 'selected');
                    }
                    domClass.add(this.ocr, 'selected');

                } else {
                    domClass.remove(this.ocr, 'selected');
                }
            },

            setAnnotationsSelected: function() {
                this.unselectMenus();
                if (this.ocr) {
                    domClass.remove(this.ocr, 'selected');
                }

                domClass.add(this.annotationOptions, 'selected');
            },

            unselectMenus: function() {
                this.showingInformation = false;
                if (this.information) {
                    domClass.remove(this.information, 'selected');
                }

                if (this.annotationOptions) {
                    domClass.remove(this.annotationOptions, 'selected');
                }
            },

            setAnnotationsEnabled: function() {
                this.data.annotationsEnabled = true;

                this._determineAnnotationExportVisibility();
                this._determineRegistrationVisibility();
            },

            setAnnotationsDisabled: function() {
                this.data.annotationsEnabled = false;

                this._determineAnnotationExportVisibility();
                this._determineRegistrationVisibility();
            },

            _determineAnnotationExportVisibility: function() {
                if (!this.downloadAnnotatedButton) {
                    return;
                }

                if (this.data.annotationsEnabled && this.data.supportsAnnotations) {
                    domClass.remove(this.downloadAnnotatedButton, 'hidden');
                } else {
                    domClass.add(this.downloadAnnotatedButton, 'hidden');
                }
            },

            _determineRegistrationVisibility: function() {
                if (!this.data.revisionPK || this.data.supportsAnnotations && this.data.annotationsEnabled) {
                    this.registerDropdownNode.removeAttribute('hidden');
                    this.data.revisionPK ?
                        domClass.add(this.registerFileButton, 'disabled') :
                        domClass.remove(this.registerFileButton, 'disabled');

                    if (this.data.supportsAnnotations && this.data.annotationsEnabled) {
                        domClass.remove(this.registerAnnotationsButton, 'disabled');
                        if (this.data.revisionPK) domClass.remove(this.reviseAnnotationsButton, 'disabled');
                    } else {
                        domClass.add(this.registerAnnotationsButton, 'disabled');
                        domClass.add(this.reviseAnnotationsButton, 'disabled');
                    }

                    return;
                }

                this.registerDropdownNode.setAttribute('hidden', 'hidden');
            },

            _documentIsPrintableCorrespondenceType: function() {
                return this.data.fileType === MESSAGE_TYPE_CORRESPONDENCE;
            },

            _closeDropdowns: function() {
                query('.button-dropdown-open').removeClass('button-dropdown-open');
            },

            _determineToolbarStatus: function() {
                if (this.data.deleted) {
                    this.disableDownload();
                    this.disableShare();
                    this.disablePrint();
                    return;
                }

                if (this.ocrEnabled &&
                    this.ocr &&
                    domClass.contains(this.ocr, 'disabled')
                ) {
                    this.enableOcr();
                }

                if (
                    this.annotationOptionsEnabled &&
                    this.annotationOptions &&
                    domClass.contains(this.annotationOptions, 'disabled')
                ) {
                    this.enableAnnotationOptions();
                }
            },

            async _setFavouriteProperties() {
                let response = await this._sendFavouriteDocumentRequest();

                if (response !== null) {
                    this.favouritePK = response['favouritePK'];
                    this.data.isFavourite = true;
                    return
                }

                this.data.isFavourite = false;
            },

            _shareViaLink: async function() {
                await navigator.clipboard.writeText(
                    window.location.protocol +
                    '//' +
                    window.location.host +
                    this.routeContainer.get('docControlFileView', {md5: this.md5})
                );

                topic.publish(
                    'sos-system-notification',
                    'Link copied to clipboard.',
                    'success',
                    2000
                );
            },

            _shareToEmailClick: function() {
                topic.publish(TOPICS.DOCUMENT_VIEWER_SHARE_TO_EMAIL, this._createDocumentReference());

                this._closeDropdowns();
            },

            _shareAnnotatedExportToEmailClick: function() {
                topic.publish(TOPICS.DOCUMENT_VIEWER_SHARE_ANNOTATED_TO_EMAIL);

                this._closeDropdowns();
            },

            _addToBasket: function() {
                topic.publish(TOPICS.DOCUMENT_VIEWER_ADD_TO_BASKET, this.md5, this.data.name);

                this._closeDropdowns();
            },

            _createDocumentReference: function() {
                let documentReference = new DocumentReference();
                if (this.data.revisionPK) {
                    return documentReference.setRevisionPK(this.data.revisionPK);
                }

                if (this.tempDocumentPK) {
                    return documentReference.setTemporaryDocumentPK(this.tempDocumentPK);
                }
            },

            _getFileIconClass: function() {},

            _sendFavouriteDocumentRequest: function() {
                return this.dataManager.request(
                    new RequestData(
                        ACTIONS.FAVOURITE_DOCUMENT_GET,
                        {
                            'documentPK': this.data.documentPK
                        }
                    )
                ).getPromise();
            },

            _removeDocumentFavourite: function() {
                return this.dataManager.request(
                    new RequestData(
                        ACTIONS.REMOVE_DOCUMENT_FAVOURITE,
                        {
                            'favouritePK': this.favouritePK
                        }
                    )
                ).getPromise();
            },

            _determineFavouriteButtonVisibility: function() {
                if (this.data.documentPK === null || this.data.revisionPK === null) {
                    return;
                }

                this._enableFavouriteButton();
            },

            _disableFavouriteButton: function() {
                this.favouriteContainerNode.classList.add('disabled');
                this.favouriteButtonNode.classList.add('disabled');
                this.favouriteButtonNode.disabled = true;
            },

            _enableFavouriteButton: function() {
                this.favouriteContainerNode.classList.remove('disabled');
                this.favouriteButtonNode.classList.remove('disabled');
                this.favouriteButtonNode.disabled = false;
            },

            _determineShareLinkState: function() {
                if (this.md5) {
                    this.shareLinkButtonNode.classList.remove('disabled');
                    return;
                }

                this.shareLinkButtonNode.classList.add('disabled');
            }
        });

        this.view = new View({}, domConstruct.create('div', {}, node, 'only'));
    };

    DialogToolbar.prototype.setHref = function(href) {
        this.view.setHref(href);
    };

    DialogToolbar.prototype.setRevision = function(revision) {
        this.view.setRevision(revision);
        return this;
    };

    DialogToolbar.prototype.setTemporaryDocument = function(temporaryDocument) {
        this.view.setTemporaryDocument(temporaryDocument);
        return this;
    };

    DialogToolbar.prototype.supportsInformation = function() {
        this.view.supportsInformation();
        return this;
    };

    DialogToolbar.prototype.supportsAnnotations = function() {
        this.view.supportsAnnotations();
        return this;
    };

    DialogToolbar.prototype.supportsOcr = function() {
        this.view.supportsOcr();
        return this;
    };

    DialogToolbar.prototype.hideTitleLoading = function() {
        this.view.hideTitleLoading();
        return this;
    };

    DialogToolbar.prototype.hideExistingAnnotationsIcon = function() {
        this.view.hideExistingAnnotationsIcon();
    };

    DialogToolbar.prototype.showExistingAnnotationsIcon = function() {
        this.view.showExistingAnnotationsIcon();
    };

    DialogToolbar.prototype.determineInformationShowing = function() {
        this.view.determineInformationShowing();
        return this;
    };

    DialogToolbar.prototype.showInformationNotificationIcon = function() {
        this.view.showInformationNotificationIcon();
    };

    DialogToolbar.prototype.enableAnnotationOptions = function() {
        this.view.enableAnnotationOptions();
        return this;
    };

    DialogToolbar.prototype.disableAnnotationOptions = function() {
        this.view.disableAnnotationOptions();
        return this;
    };

    DialogToolbar.prototype.enableOcr = function() {
        this.view.enableOcr();
        return this;
    };

    DialogToolbar.prototype.disableOcr = function() {
        this.view.disableOcr();
        return this;
    };

    DialogToolbar.prototype.disableToolbar = function() {
        this.view.disableToolbar();
    };

    DialogToolbar.prototype.disableInformation = function() {
        this.view.disableInformation();
        return this;
    };

    DialogToolbar.prototype.disableDownload = function() {
        this.view.disableDownload();
        return this;
    };

    DialogToolbar.prototype.setInformationSelected = function() {
        this.view.setInformationSelected();
    };

    DialogToolbar.prototype.toggleOcrSelected = function() {
        this.view.toggleOcrSelected();
    };

    DialogToolbar.prototype.setAnnotationsSelected = function() {
        this.view.setAnnotationsSelected();
    };

    DialogToolbar.prototype.unselectMenus = function() {
        this.view.unselectMenus();
    };

    DialogToolbar.prototype.setAnnotationsEnabled = function() {
        this.view.setAnnotationsEnabled();
    };

    DialogToolbar.prototype.setAnnotationsDisabled = function() {
        this.view.setAnnotationsDisabled();
    };

    DialogToolbar.prototype.destroy = function() {
        this.view.destroyRecursive();
    };

    return DialogToolbar;
});
},
'doccontrol/viewer/dojo/FavouriteDialog':function(){
/// <amd-dependency path="style-guide/v1/favourites/AddFavouriteDialog" name="AddFavouriteDialog"/>
define(["require", "exports", "style-guide/v1/favourites/AddFavouriteDialog", "dojo/_base/declare", "dijit/_WidgetBase", "spencer/data-manager/core/definition/Actions", "spencer/data-manager/data/Request", "dojo/topic", "dojo/Evented"], function (require, exports, AddFavouriteDialog, declare, _WidgetBase, ACTIONS, RequestData, topic, Evented) {
    "use strict";
    class FavouriteDialog {
        constructor(dataManager, routeContainer) {
            this.dataManager = dataManager;
            this.routeContainer = routeContainer;
            const view = this.getView();
            this.view = new view({
                dataManager: this.dataManager,
                routeContainer: this.routeContainer
            });
        }
        open(documentPK, revisionPK, name) {
            this.view.open(documentPK, revisionPK, name);
        }
        on(event, handler) {
            this.view.on(event, handler);
        }
        getView() {
            return declare([_WidgetBase, Evented], {
                addFavouriteDialog: null,
                dataManager: null,
                errorResponseHandler: null,
                notification: null,
                routeContainer: null,
                documentPK: null,
                revisionPK: null,
                postCreate: function () {
                    this._initDialog();
                },
                _initDialog: function () {
                    this.addFavouriteDialog = new AddFavouriteDialog({
                        _addFavourite: async () => {
                            const name = this.addFavouriteDialog.getFavouriteName();
                            if (name) {
                                this.addFavouriteDialog.close();
                                await this.dataManager.request(new RequestData(ACTIONS.CREATE_DOCUMENT_FAVOURITE, {
                                    'documentPK': this.documentPK,
                                    'revisionPK': this.revisionPK,
                                    'name': name,
                                    'url': this.routeContainer.get('downloadRevision', {
                                        id: this.revisionPK
                                    })
                                })).getPromise();
                                topic.publish('sos-system-notification', 'Favourite added successfully.', 'success', 2000);
                                this.emit('favouritedSuccess');
                            }
                        }
                    });
                    this.addFavouriteDialog.on('close', e => {
                        this.emit('close', {});
                    });
                },
                open: function (documentPK, revisionPK, name) {
                    this.documentPK = documentPK;
                    this.revisionPK = revisionPK;
                    if (name) {
                        this.addFavouriteDialog.setFavouriteName(name);
                    }
                    this.addFavouriteDialog.open();
                }
            });
        }
    }
    return FavouriteDialog;
});

},
'style-guide/v1/favourites/AddFavouriteDialog':function(){
define([
    'dojo/Evented',
    'dojo/_base/declare',
    'dojo/text!style-guide/v1/favourites/templates/AddFavouriteDialog.html',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated',
    'style-guide/v1/layout/Dialog'
], function(
    Evented,
    declare,
    template,
    _WidgetBase,
    _Templated,
    Dialog
){
    const FORM_PANE_TITLE = 'Add Favourite';

    return declare([_WidgetBase, _Templated, Evented], {
        dialog: null,
        templateString: template,
        title: null,

        addButton: null,
        addFavouriteInput: null,
        cancelButton: null,

        postCreate: function() {
            this._initDialog();

            this.dialog.on('hide', function() {
                this.addFavouriteInput.value = '';
                this.emit('close', {});
            }.bind(this));
        },

        open: function() {
            setTimeout(function () {
                this.addFavouriteInput.focus();
            }.bind(this), 0);
            this.dialog.show();
        },

        close: function() {
            this.dialog.hide();
            this.emit('close', {});
            this.addFavouriteInput.value = '';
        },

        getFavouriteName: function() {
            return this.addFavouriteInput.value;
        },

        setFavouriteName: function(name) {
            this.addFavouriteInput.value = name;
        },

        loading: function () {
            this.addFavouriteInput.setAttribute('disabled', 'disabled');
            this.cancelButton.setAttribute('disabled', 'disabled');
            this.addButton.setAttribute('disabled', 'disabled');
        },

        loaded: function () {
            this.addFavouriteInput.removeAttribute('disabled');
            this.cancelButton.removeAttribute('disabled');
            this.addButton.removeAttribute('disabled');
        },

        destroyRecursive: function() {
            this._addFavourite = null;
            this.inherited(arguments);
        },

        _initDialog: function() {
            this.dialog = new Dialog({
                titleString: this.title ? this.title : FORM_PANE_TITLE,
                contentNode: this.domNode,
                'class': 'sos-layout-dialog-responsive-footer favourite-document-dialog'
            })
        },

        _addFavourite: function() {}
    });
});
},
'doccontrol/viewer/FileTypeViewable':function(){
define([], function() {
    const BLACKLIST = {
        'application': [
            'vnd.microsoft.portable-executable',
            'vnd.ms-excel.sheet.macroenabled.12',
            'x-msdownload',
            'exe',
            'x-exe',
            'dos-exe',
            'x-winexe',
            'msdos-windows',
            'x-msdos-program',
            'bat',
            'x-bat',
            'bin',
            'binary',
            'acad',
            'x-acad',
            'autocad_dwg',
            'dwg',
            'x-dwg',
            'x-autocad',
            'xer',
            'vnd.ms-cab-compressed',
            'gzip',
            'x-7z-compressed',
            'x-bzip2',
            'x-compress',
            'x-compressed',
            'x-gtar',
            'x-gzip',
            'x-iwork-pages-sffpages',
            'x-rar-compressed',
            'x-tar',
            'x-xz',
            'x-zip-compressed',
            'zip'
        ],
        'binary': [
            'octet-stream'
        ],
        'image': [
            'vnd.dwg',
            'x-dwg',
            'x-vnd.dgn',
            'vnd.adobe.photoshop'
        ],
        'drawing': ['dwg'],
        'multipart': ['x-zip'],
        'vms': ['exe'],
        'text': [
            'css',
            'calendar'
        ],
        'file': []
    };

    const TYPE_WHITELIST = [
        'text'
    ];

    const FileTypeViewable = function() {};

    FileTypeViewable.prototype.isViewable = function(type, subtype) {
        if (arguments.length === 1 && type) {
            let fileType = type.split('/');
            type = fileType[0].toLowerCase();
            if (fileType[1]) {
                subtype = fileType[1].toLowerCase();
            }
        } else {
            type = type.toLowerCase();
            subtype = subtype.toLowerCase();
        }

        if (!subtype) {
            return TYPE_WHITELIST.indexOf(type) !== -1 || !BLACKLIST[type];
        }

        return BLACKLIST[type] ? BLACKLIST[type].indexOf(subtype) < 0 : true;
    };

    return FileTypeViewable;
});

},
'doccontrol/viewer/dojo/NavigationBar':function(){
define([
    '../Topics',
    'api/doccontrol/Config',
    'api/doccontrol/Factory',
    'dojo/dom-construct',
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/topic',
    'dojo/text!./template/NavigationBar.html',
    'dijit/_WidgetBase',
    'library/request/data/Handlers',
    'library/request/dojo/URLConnectionProcessorBuilder',
    'library/request/helper/DefaultUnauthorisedCallback',
    'library/request/URLConnectionBuilder',
    'library/request/URLResponseProcessorBuilder',
    'soso/sosox/ejs/_Templated',
    'spencer/doc-control/data/Revision'
], function(
    TOPICS,
    DocControlConfig,
    DocControlFactory,
    domConstruct,
    declare,
    domAttr,
    domClass,
    topic,
    template,
    _WidgetBase,
    HandlersVO,
    URLConnectionProcessorBuilder,
    DefaultUnauthorisedCallback,
    URLConnectionBuilder,
    URLResponseProcessorBuilder,
    _Templated,
    RevisionVO
) {
    const NavigationBar = function(node) {
        const View = declare([_WidgetBase, _Templated], {
            docControlBuilder: null,
            templateString: template,

            postCreate: function() {
                this._createDocControlBuilder();
            },

            setNextDocument: function(documentInfo) {
                domClass.remove(this.nextLink, 'hidden');

                if (documentInfo.getRevisionPK()) {
                    const Revision = this.docControlBuilder.getRevision();
                    Revision.get(
                        new HandlersVO(
                            function(revision) {
                                domAttr.set(this.nextLabel, "innerHTML", revision.getTitle());
                            }.bind(this),
                            function(result) {},
                            DefaultUnauthorisedCallback,
                            function(result) {},
                            function(result) {}
                        ), (new RevisionVO()).setRevisionPK(documentInfo.getRevisionPK())
                    )
                } else if (documentInfo.getMd5()) {
                    const documentDetails = this.docControlBuilder.getDocumentDetails();
                    documentDetails.get(
                        new HandlersVO(
                            function(details) {
                                domAttr.set(this.nextLabel, "innerHTML", details.getTitle());
                            }.bind(this),
                            function(result) {},
                            DefaultUnauthorisedCallback,
                            function(result) {},
                            function(result) {}
                        ), documentInfo.getMd5()
                    )
                }
            },

            setPreviousDocument: function(documentInfo) {
                domClass.remove(this.previousLink, 'hidden');

                if (documentInfo.getRevisionPK()) {
                    const Revision = this.docControlBuilder.getRevision();
                    Revision.get(
                        new HandlersVO(
                            function(revision) {
                                domAttr.set(this.previousLabel, "innerHTML", revision.getTitle());
                            }.bind(this),
                            function(result) {},
                            DefaultUnauthorisedCallback,
                            function(result) {},
                            function(result) {}
                        ), (new RevisionVO()).setRevisionPK(documentInfo.getRevisionPK())
                    )
                } else if (documentInfo.getMd5()) {
                    const documentDetails = this.docControlBuilder.getDocumentDetails();
                    documentDetails.get(
                        new HandlersVO(
                            function(details) {
                                domAttr.set(this.previousLabel, "innerHTML", details.getTitle());
                            }.bind(this),
                            function(result) {},
                            DefaultUnauthorisedCallback,
                            function(result) {},
                            function(result) {}
                        ), documentInfo.getMd5()
                    )
                }
            },

            _navigatePrevious: function() {
                topic.publish(TOPICS.DOCUMENT_VIEWER_NAVIGATE_PREVIOUS);
            },

            _navigateNext: function() {
                topic.publish(TOPICS.DOCUMENT_VIEWER_NAVIGATE_NEXT);
            },

            show: function() {
                domClass.remove(this.domNode, 'hidden');
            },

            hide: function() {
                domClass.add(this.domNode, 'hidden');
            },

            _createDocControlBuilder: function() {
                this.docControlBuilder = new DocControlFactory(
                    new DocControlConfig(),
                    new URLConnectionBuilder(
                        new URLConnectionProcessorBuilder()
                    ),
                    new URLResponseProcessorBuilder()
                );
            }
        });

        this.view = new View({}, domConstruct.create('div', {}, node, 'first'));
    };

    NavigationBar.prototype.setPreviousDocument = function(documentInfo) {
        this.view.setPreviousDocument(documentInfo);
    };

    NavigationBar.prototype.setNextDocument = function(documentInfo) {
        this.view.setNextDocument(documentInfo);
    };

    NavigationBar.prototype.hide = function() {
        this.view.hide();
    };

    NavigationBar.prototype.show = function() {
        this.view.show();
    };

    NavigationBar.prototype.destroy = function() {
        this.view.destroyRecursive();
    };

    return NavigationBar;
});
},
'doccontrol/viewer/dojo/pin/Sidebar':function(){
define([
    'dijit/_WidgetBase',
    'dijit/TitlePane',
    'doccontrol/viewer/data/pins/Comment',
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/dom-construct',
    'dojo/on',
    'dojo/topic',
    'dojo/text!./template/Sidebar.html',
    'soso/sosox/ejs/_Templated',
    'spencer/utility/RandomStringGenerator',
    'style-guide/v1/doc-control/attachment/Attachments',
    'style-guide/v1/doc-control/attachment/AttachmentSelectionMethod',
    './Comment',
    '../../Topics'
], function(
    WidgetBase,
    TitlePane,
    CommentVO,
    declare,
    domAttr,
    domClass,
    domConstruct,
    on,
    topic,
    Template,
    Templated,
    StringGenerator,
    Attachments,
    AttachmentSelectionMethods,
    PinSidebarComment,
    TOPICS
) {
    const PinSidebar = function(routeContainer, node) {
        const ATTACHMENTS_ACCORDION_TITLE = 'Attachments (%d)';
        const DELETE_PIN_CONFIRMATION = 'Are you sure you want to delete this pin?\n\nAny comments and attachments will be lost and cannot be recovered.';
        const ATTACHMENT_ADD_FAILED = "Your file(s) could not be attached to the pin as you are no longer connected to the server.<br />" +
            "Please reconnect to the server and select these files again to attach them to this pin.";
        const AUDIO_RECORDING_ADD_FAILED = "Your audio recording could not be attached to the pin as you are no longer connected to the server.<br /><br />" +
            "Your audio recording has been added to your registration basket. You can download your audio " +
            "recording by clicking <a class=\"sos-notification-link\" href=\":downloadLink\">here</a>.";

        const View = declare([WidgetBase, Templated], {
            templateString: Template,
            routeContainer: routeContainer,
            commentThreadNode: null,
            textInputNode: null,
            pinTitleNode: null,
            personFactory: null,

            pin: null,
            commentWidgets: [],
            attachmentsWidget: null,
            attachmentsAccordion: null,

            postCreate: function() {
                this.inherited(arguments);

                this.stringGenerator = new StringGenerator();

                on(this.textInputNode, 'keydown', function(e) {
                    if (e.key === 'Enter' && !e.shiftKey) {
                        e.stopPropagation();
                        e.preventDefault();

                        this._comment();
                    }
                }.bind(this));

                this._initialiseAttachmentsWidget();
            },

            show: function(pin) {
                const numExistingComments = this.isShowing(pin.id) ? this.pin.getComments().length : 0;
                const initialDistanceFromBottom = this._getScrollDistanceFromBottom();

                this._clear();

                this.pin = pin;

                this.pinTitleNode.innerHTML = "Pin #" + this.pin.getReference();

                this.pin.getComments().forEach(this._displayComment.bind(this));
                domAttr.remove(this.deleteBtn, 'disabled');
                domClass.remove(this.emptyState, 'sos-empty-state-show');
                domAttr.remove(this.textInputNode, 'disabled');
                domAttr.remove(this.commentBtn, 'disabled');

                domClass.remove(this.attachmentsAccordionNode, 'hidden');
                this.attachmentsWidget.set(this.pin.getAttachments());

                domClass.remove(this.domNode, 'hidden');

                this._updateAttachmentsAccordionTitle();

                if (numExistingComments && pin.getComments().length > numExistingComments) {
                    if (initialDistanceFromBottom < 50) {
                        this._scrollToBottom();
                    } else {
                        domClass.remove(this.newCommentNotification, 'hidden');
                    }
                }
            },

            hide: function() {
                domClass.add(this.domNode, 'hidden');
            },

            isOpen: function() {
                return !domClass.contains(this.domNode, 'hidden');
            },

            isShowing: function(id) {
                return this.isOpen() && this.pin && this.pin.getId() == id;
            },

            reset: function() {
                this.pin = null;

                this.pinTitleNode.innerHTML = 'No Pin Selected';

                this.textInputNode.value = '';

                domClass.add(this.attachmentsAccordionNode, 'hidden');
                domAttr.set(this.deleteBtn, 'disabled', 'disabled');
                domAttr.set(this.textInputNode, 'disabled', 'disabled');
                domAttr.set(this.commentBtn, 'disabled', 'disabled');

                domClass.add(this.emptyState, 'sos-empty-state-show');

                this._clear();
            },

            _clear: function() {
                this.commentWidgets.forEach(function(commentWidget) {
                    commentWidget.destroy();
                });
                this.commentWidgets = [];

                this.attachmentsWidget.reset();
            },

            _close: function() {
                 topic.publish(TOPICS.DOCUMENT_VIEWER_ANNOTATION_TOOL_PIN_SIDEBAR_CLOSE);
                 this.hide();
            },

            _delete: function () {
                if (confirm(DELETE_PIN_CONFIRMATION)) {
                    topic.publish(TOPICS.DOCUMENT_VIEWER_ANNOTATION_PIN_DELETED, this.pin.id);
                    this._close();

                }
            },

            _comment: function () {
                if (this.textInputNode.value.trim()) {
                    this._displayComment(this._createComment()).scrollIntoView();

                    this.textInputNode.value = '';
                }
            },

            _displayComment: function(comment) {
                const commentWidget = new PinSidebarComment(this.commentThreadNode, comment);

                this.commentWidgets.push(commentWidget);

                return commentWidget;
            },

            _createComment: function () {
                const currentPerson = dojoConfig.user.getPerson();

                const comment = (new CommentVO()).setCommentId(this.stringGenerator.generate())
                    .setPersonPK(currentPerson.getPersonPK())
                    .setDisplayName(currentPerson.getDisplayName())
                    .setTime(new Date())
                    .setText(this.textInputNode.value);

                this.pin.addComment(comment);

                topic.publish(TOPICS.DOCUMENT_VIEWER_ANNOTATION_PIN_UPDATED, this.pin.id);

                return comment;
            },

            _initialiseAttachmentsWidget: function() {
                this.attachmentsAccordion = new TitlePane({
                    open: true
                }, this.attachmentsContainer);

                this.attachmentsWidget = new Attachments(this.attachmentsNode);

                this.attachmentsWidget.on('attached', function(data) {
                    if (!this.pin) {
                        if (data.selectionType === AttachmentSelectionMethods.AUDIO_RECORDING) {
                            topic.publish(
                                'sos-system-notification',
                                AUDIO_RECORDING_ADD_FAILED.replace(':downloadLink', this.routeContainer.get('downloadTemporaryDocument', {id: data.files[0].getMd5()})),
                                'error'
                            );
                            return;
                        }

                        topic.publish('sos-system-notification', ATTACHMENT_ADD_FAILED, 'error');
                        return;
                    }

                    data.files.forEach(this.pin.addAttachment.bind(this.pin));
                    topic.publish(TOPICS.DOCUMENT_VIEWER_ANNOTATION_PIN_UPDATED, this.pin.id);

                    this._updateAttachmentsAccordionTitle();
                }.bind(this));

                this.attachmentsWidget.on('removed', function(data) {
                    data.files.forEach(function(file) {
                        this.pin.removeAttachmentByMd5(file.getMd5());

                        this._updateAttachmentsAccordionTitle();
                    }.bind(this));
                    topic.publish(TOPICS.DOCUMENT_VIEWER_ANNOTATION_PIN_UPDATED, this.pin.id);
                }.bind(this));
            },

            _onScroll: function(e) {
                if (this._getScrollDistanceFromBottom() < 100) {
                    domClass.add(this.newCommentNotification, 'hidden');
                }
            },

            _getScrollDistanceFromBottom: function() {
                return this.scrollContainer.scrollHeight - (this.scrollContainer.scrollTop + this.scrollContainer.clientHeight);
            },

            _scrollToBottom: function() {
                this.scrollContainer.scrollTop = this.scrollContainer.scrollHeight;
            },

            _updateAttachmentsAccordionTitle: function() {
                this.attachmentsAccordion.set('title', ATTACHMENTS_ACCORDION_TITLE.replace('%d', this.pin.getAttachments().length));
            }
        });

        this.view = new View({}, node);
    };

    PinSidebar.prototype.hide = function() {
        this.view.hide();
    };

    PinSidebar.prototype.show = function(pin) {
        this.view.show(pin);
    };

    PinSidebar.prototype.isOpen = function() {
        return this.view.isOpen();
    };

    PinSidebar.prototype.isShowing = function(id) {
        return this.view.isShowing(id);
    };

    PinSidebar.prototype.reset = function() {
        return this.view.reset();
    };

    PinSidebar.prototype.destroy = function() {
        return this.view.destroyRecursive();
    };

    return PinSidebar;
});
},
'style-guide/v1/doc-control/attachment/Attachments':function(){
define([
    './Row',
    './AttachmentSelectionMethod',
    '../audio-record/dojo/DialogButton',
    '../FileUpload',
    'dijit/_WidgetBase',
    'doc-control/config/Topics',
    'api/doccontrol/Builder',
    'api/file/Builder',
    'doccontrol/file-upload/model/Uploader',
    'dojo/_base/declare',
    'dojo/dom-construct',
    'dojo/text!./templates/Attachments.html',
    'library/DojoTopicWrapper',
    'library/request/data/Form',
    'library/request/data/Handlers',
    'soso/sosox/ejs/_Templated',
    'style-guide/v1/forms/DocumentSelector',
    'style-guide/v1/media/capture-camera/CaptureCamera'
], function(
    Row,
    AttachmentSelectionMethods,
    AudioRecorder,
    FileUploadInitialiser,
    _WidgetBase,
    DOC_CONTROL_TOPICS,
    DocControlBuilder,
    FileBuilder,
    UploaderModel,
    declare,
    domConstruct,
    template,
    TopicSubscriber,
    FormVO,
    Handlers,
    _TemplatedMixin,
    DocumentSelector,
    CaptureCamera
) {
    const Attachments = function(node) {
        const CAPTURE_OUTPUT_FORMAT = 'image/png';
        const ANNOTATION_UPLOAD_PROGRESS_NOTIFICATION_ID = 'ANNOTATION_UPLOAD_NOTIFICATION_:id';

        const View = declare([_WidgetBase, _TemplatedMixin], {
            data: { formID: null },
            files: [],
            rows: [],
            templateString: template,
            uploadModel: null,

            constructor: function() {
                this.inherited(arguments);

                this.topicSubscriber = new TopicSubscriber();
                this.reset();
            },

            postCreate: function() {
                this.inherited(arguments);
                this._initialiseUploadModel();
                this._initialiseDocumentSelector();
                this._initialiseUploader();
                this._initialiseAudioUploader();
                this._initialiseCaptureCamera();
            },

            setFiles: function(files) {
                this.files = [];
                files.forEach(this._add.bind(this));
            },

            reset: function() {
                this.files = [];
                this.rows.forEach(function(row) {
                    row.destroy();
                });
                this.rows = [];
            },

            getFiles: function() {
                return this.files;
            },

            postMixInProperties: function() {
                this.data.formID = 'form_' + this.id;
            },

            _initialiseUploadModel: function() {
                this.uploadModel = new UploaderModel(
                    new DocControlBuilder().getDocControlFactory(),
                    new FileBuilder().getFileFactory()
                );
            },

            _initialiseDocumentSelector: function() {
                new DocumentSelector({}, this.selectorNode);

                this.own(
                    this.topicSubscriber.subscribe(
                        DOC_CONTROL_TOPICS.DOCUMENT_SELECTOR_DOCUMENTS_SELECTED,
                        function(attached) {
                            this.emit('attached', { files: attached.revisionCollection.filter(this._add.bind(this)), selectionType: AttachmentSelectionMethods.DOCUMENT_SELECTOR });
                        }.bind(this)
                    )
                );
            },

            _initialiseUploader: function() {
                FileUploadInitialiser.setOnUploadCallback(function(files) {
                    this.emit('attached', { files: files.filter(this._add.bind(this)), selectionType: AttachmentSelectionMethods.UPLOAD });
                }.bind(this)).init(this.uploadNode);
            },

            _initialiseAudioUploader: function() {
                new AudioRecorder({
                    'class': 'sos-btn-icon sos-icon-microphone',
                    onUploadCallback: function(file) {
                        if (this._add(file)) {
                            this.emit('attached', { files: [file], selectionType: AttachmentSelectionMethods.AUDIO_RECORDING });
                        }
                    }.bind(this)
                }, this.audioRecorderNode);
            },

            _upload: function(file) {
                return new Promise(function(resolve, reject) {
                    this.request = this.uploadModel.upload(
                        this._generateUploadHandlers(resolve, reject),
                        new FormVO()
                            .setId(this.data.formID)
                            .setFiles([file])
                            .setFileKey('uploadedFiles')
                    );
                }.bind(this));
            },

            _generateUploadHandlers: function(resolve, reject) {
                return new Handlers(
                    function(results) {
                        const key = results[0].getKey();
                        key ? resolve(key) : reject();
                    },
                    function progress() {},
                    reject,
                    reject,
                    reject
                )
            },

            _fetchDocumentFromFileKey: function(key) {
                return new Promise(function(resolve, reject) {
                    this.request = this.uploadModel.fetchDocumentsFromFileKeys(this._generateDocumentCollectionHandlers(resolve, reject), [key]);
                }.bind(this));
            },

            _generateDocumentCollectionHandlers: function(resolve, reject) {
                return new Handlers(
                    function(results) {
                        const document = results[0];
                        if (!document['revisionPK']) {
                            this._makeTemporaryDocumentPublic(document.md5)
                                .then(function() {
                                    resolve(document)
                                })
                                .catch(reject);

                        } else {
                            resolve(document);
                        }
                    }.bind(this),
                    function progress() {},
                    reject,
                    reject,
                    reject
                );
            },

            _makeTemporaryDocumentPublic: function(md5) {
                return new Promise(function(resolve, reject) {
                    this.request = this.uploadModel.makeTemporaryDocumentPublic(
                        new Handlers(
                            resolve,
                            function progress() {},
                            reject,
                            reject
                        ),
                        md5
                    );
                }.bind(this));
            },

            _initialiseCaptureCamera: function() {
                const captureCameraDialog = new CaptureCamera();

                this.openCaptureDialogBtn.addEventListener('click', () => {
                    captureCameraDialog.open();
                });

                captureCameraDialog.on('submit', async (capturedImage) => {
                    const capturedFile = await fetch(capturedImage)
                        .then(r => r.blob())
                        .then(blobFile => new File(
                            [blobFile],
                            'capture_:id.png'.replace(':id', new Date().toISOString()),
                            {
                                type: CAPTURE_OUTPUT_FORMAT,
                                lastModified: Date.now()
                            }
                        ));

                    this._publishUploadProgressNotification(AttachmentSelectionMethods.CAPTURE_CAMERA);

                    this._upload(capturedFile)
                        .then(this._fetchDocumentFromFileKey.bind(this))
                        .then((capturedTemporaryFile) => {
                            if (this._add(capturedTemporaryFile)) {
                                this.emit('attached', { files: [capturedTemporaryFile], selectionType: AttachmentSelectionMethods.CAPTURE_CAMERA });
                                this._publishUploadSuccessNotification(AttachmentSelectionMethods.CAPTURE_CAMERA);
                            }
                        })
                        .catch(function() {
                            this._publishUploadErrorNotification(AttachmentSelectionMethods.CAPTURE_CAMERA);
                        }.bind(this));
                    });
            },

            _clear: function() {
                this.emit('removed', { files: this.files });
                this.reset();
            },

            _add: function(file) {
                if (this._getFileIndex(file.getMd5()) !== -1) {
                    return false;
                }

                this.files.push(file);

                const row = new Row(file, domConstruct.create('tr', {}, this.tbodyNode));
                row.on('removed', function(data) {
                    this._removeByMd5(data.file.getMd5());
                    this.emit('removed', { files: [data.file] });
                }.bind(this));

                this.rows.push(row);

                return true;
            },

            _removeByMd5: function(md5) {
                this.files.splice(this._getFileIndex(md5), 1);
            },

            _getFileIndex: function(md5) {
                return this.files.findIndex(function(file) {
                    return file.getMd5() === md5;
                });
            },

            _publishUploadSuccessNotification: function(selectionType) {
                this.topicSubscriber.publish(
                    'sos-system-notification-progress-complete',
                    ANNOTATION_UPLOAD_PROGRESS_NOTIFICATION_ID.replace(':id', selectionType),
                    'Uploaded %s attachment.'.replace('%s', selectionType),
                    'success',
                    5000
                );
            },

            _publishUploadProgressNotification: function(selectionType) {
                this.topicSubscriber.publish(
                    'sos-system-notification-progress',
                    'Uploading %s attachment...'.replace('%s', selectionType),
                    ANNOTATION_UPLOAD_PROGRESS_NOTIFICATION_ID.replace(':id', selectionType)
                );
            },

            _publishUploadErrorNotification: function(selectionType, uid) {
                this.topicSubscriber.publish(
                    'sos-system-notification-progress-complete',
                    ANNOTATION_UPLOAD_PROGRESS_NOTIFICATION_ID.replace(':id', selectionType),
                    'Failed to upload %s attachment. Please try again.'.replace('%s', selectionType),
                    'error',
                    5000
                );
            }
        });

        this.view = new View({
            className: 'sos-doc-control-attachments'
        }, node);
        this.view.startup();
    };

    Attachments.prototype.set = function(files) {
        this.view.setFiles(files);
    };

    Attachments.prototype.reset = function() {
        this.view.reset();
    };

    Attachments.prototype.get = function() {
        return this.view.getFiles();
    };

    Attachments.prototype.on = function(event, callback) {
        return this.view.on(event, callback);
    };

    return Attachments;
});
},
'style-guide/v1/doc-control/attachment/Row':function(){
define([
    "dijit/_WidgetBase",
    "dojo/_base/declare",
    "dojo/dom-construct",
    "dojo/text!./templates/Row.html",
    "soso/sosox/ejs/_Templated",
    "spencer/doc-control/format/url/DocumentViewer",
    "style-guide/v1/icons/FileTypeToIconClass"
], function(
    _WidgetBase,
    declare,
    domConstruct,
    template,
    _TemplatedMixin,
    DocumentViewerUrlFormatter,
    FileTypeToIconClass
) {
    const Row = function(file, node) {
        const documentViewerUrlFormatter = new DocumentViewerUrlFormatter(baseUrl);

        const View = declare([_WidgetBase, _TemplatedMixin], {
            templateString: template,

            data: { file: file },

            postMixInProperties: function() {
                this.inherited(arguments);

                const fileTypeToIconClass = new FileTypeToIconClass();
                this.setCustomViewHelpers({
                    fileTypeToIconClass: fileTypeToIconClass.getClass.bind(fileTypeToIconClass),
                    getAttachmentName: function(file) {
                        return typeof file.getTitle === 'function' ? file.getTitle() : file.getName();
                    },
                    generateDocumentViewerUrl: documentViewerUrlFormatter.format.bind(documentViewerUrlFormatter)
                });
            },

            destroy: function() {
                this.inherited(arguments);
                domConstruct.destroy(this.domNode);
            },

            _remove: function() {
                this.emit('removed', { bubbles: false, file: this.data.file });
                this.destroy();
            }
        });

        this.view = new View(file, node);
        this.view.startup();
    };

    Row.prototype.destroy = function() {
        this.view.destroy();
    };

    Row.prototype.on = function(event, callback) {
        this.view.on(event, callback);
    };

    return Row;
});
},
'spencer/doc-control/format/url/DocumentViewer':function(){
define([
], function() {
    const DocumentViewer = function(baseUrl) {
        this.documentViewerUrl = baseUrl + 'doc-control/file/view/:md5';
    };

    DocumentViewer.prototype.format = function(md5) {
        return this.documentViewerUrl.replace(':md5', md5);
    };

    return DocumentViewer;
});
},
'style-guide/v1/doc-control/attachment/AttachmentSelectionMethod':function(){
define([], function() {
    return {
        AUDIO_RECORDING: 'audio',
        DOCUMENT_SELECTOR: 'selector',
        UPLOAD: 'upload',
        CAPTURE_CAMERA: 'camera'
    };
});
},
'style-guide/v1/doc-control/audio-record/dojo/DialogButton':function(){
define([
    'dojo/_base/declare',
    'dojo/text!./templates/DialogButton.html',
    'dijit/_WidgetBase',
    './Dialog',
    'soso/sosox/ejs/_Templated'
], function(declare, template, _WidgetBase, Dialog, _TemplatedMixin) {
    return declare([_WidgetBase, _TemplatedMixin], {
        templateString: template,
        dialog: null,
        onUploadCallback: null,

        postCreate: function() {
            this.inherited(arguments);

            this.dialog = new Dialog({
                onUploadCallback: this.onUploadCallback
            });
        },

        _setDisabledAttr: function(disabled) {
            if (disabled || disabled === undefined) {
                this.domNode.setAttribute('disabled', '');
                return;
            }

            this.domNode.removeAttribute('disabled');
        },

        _onOpenClick: function() {
            this.dialog.show();
        }
    });
});
},
'style-guide/v1/doc-control/audio-record/dojo/Dialog':function(){
define([
    'dijit/_WidgetBase',
    'dojo/_base/declare',
    'dojo/text!./templates/Dialog.html',
    'soso/sosox/ejs/_Templated',
    'style-guide/v1/doc-control/audio-record/Recorder',
    'style-guide/v1/layout/Dialog'
], function(
    _WidgetBase,
    declare,
    template,
    _TemplatedMixin,
    Recorder,
    Dialog
) {
    const RecorderDialog = declare([Dialog], {
        recorder: null,
        hide: function() {
            if (this.recorder.isUploading()) {
                alert('You cannot close this dialog whilst uploading.\nYou can either cancel the upload or wait for it to finish.');
                return;
            }

            this.inherited(arguments);
        }
    });

    return declare([_WidgetBase, _TemplatedMixin], {
        templateString: template,
        dialog: null,
        recorder: null,
        onUploadCallback: null,

        postCreate: function() {
            this.inherited(arguments);

            this.dialog = new RecorderDialog({
                additionalClass: 'sos-doc-control-audio-recorder',
                contentNode: this.recorderNode,
                titleString: 'Record Audio',
                recorder: null
            });

            this.recorder = new Recorder(
                this.recorderNode,
                function(result) {
                    if (typeof this.onUploadCallback === 'function') {
                        this.onUploadCallback(result);
                    }

                    this.recorder.reset();

                    this.dialog.hide();
                }.bind(this)
            );

            this.dialog.set('recorder', this.recorder);

            this.dialog.on('hide', this.recorder.cleanup.bind(this.recorder));

            this.recorder.on('hide', () => {
                this.dialog.hide();
            });
        },

        show: function() {
            this.dialog.show();
        }
    });
});
},
'style-guide/v1/doc-control/audio-record/Recorder':function(){
define([
    './Events',
    './dojo/Recorder',
    './state-machine/Factory',
    './state-machine/States'
], function (
    EVENTS,
    Widget,
    StateMachineFactory,
    STATES
) {
    const Recorder = function(node, /* optional */onUploadCallback) {
        this.uploadPromise = null;
        this.recording = false;

        this.widget = new Widget(node, onUploadCallback);

        const stateMachineFactory = new StateMachineFactory(this.widget);

        this.stateMachine = stateMachineFactory.getStateMachine();

        this.widget.on(EVENTS.RECORD, async function() {
            try {
                await this.stateMachine.record();
            } catch (e) {
                console.error(e); // Permission dismissed/denied
                this.stateMachine.accessDenied();
            }
        }.bind(this));

        this.widget.on(EVENTS.STOP, async function() {
            try {
                await this.stateMachine.stop();
            } catch (e) {
                console.error(e); // Problem creating mp3
                this.stateMachine.recordingError();
            }
        }.bind(this));

        this.widget.on(EVENTS.PLAY, this.stateMachine.play.bind(this.stateMachine));

        this.widget.on(EVENTS.PAUSE, this.stateMachine.pause.bind(this.stateMachine));

        this.widget.on(EVENTS.UPLOAD, this.stateMachine.upload.bind(this.stateMachine));

        this.widget.on(EVENTS.UPLOAD_FINISHED, this.stateMachine.uploadFinished.bind(this.stateMachine));

        this.widget.on(EVENTS.RESET, this.stateMachine.reset.bind(this.stateMachine));

        this.widget.on(EVENTS.CANCEL, this.stateMachine.cancel.bind(this.stateMachine));
    };

    Recorder.prototype.on = function(event, callback) {
        this.widget.on(event, callback);
    };

    Recorder.prototype.cleanup = function() {
        if (this.stateMachine.getCurrentState() === STATES.RECORDING) {
            this.stateMachine.stop();
            return;
        }

        if (this.stateMachine.getCurrentState() === STATES.PLAYING) {
            this.stateMachine.pause();
            return;
        }
    };

    Recorder.prototype.reset = function() {
        this.stateMachine.reset();
    };

    Recorder.prototype.isUploading = function() {
        return this.stateMachine.getCurrentState() === STATES.UPLOADING;
    };

    return Recorder;
});

},
'style-guide/v1/doc-control/audio-record/Events':function(){
define([], function() {
    return {
        RECORD: 'record',
        STOP: 'stop',
        PLAY: 'play',
        PAUSE: 'pause',
        UPLOAD: 'upload',
        UPLOAD_FINISHED: 'upload-finished',
        RESET: 'reset',
        CANCEL: 'cancel'
    };
});
},
'style-guide/v1/doc-control/audio-record/dojo/Recorder':function(){
define([
    '../Events',
    'api/doccontrol/Builder',
    'api/file/Builder',
    'doccontrol/file-upload/model/Uploader',
    'dijit/_WidgetBase',
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/dom-construct',
    'dojo/query',
    'dojo/text!./templates/Recorder.html',
    'dojo/throttle',
    'dojo/topic',
    'library/request/data/Form',
    'library/request/data/Handlers',
    'soso/sosox/ejs/_Templated',
    'spencer/date-time/StopWatch',
    'MicToMp3',
    'library/media/polyfill/GetUserMedia'
], function(
    EVENTS,
    DocControlBuilder,
    FileBuilder,
    UploaderModel,
    _WidgetBase,
    declare,
    domAttr,
    domClass,
    domConstruct,
    query,
    template,
    throttle,
    topic,
    FormVO,
    Handlers,
    _TemplatedMixin,
    StopWatch,
    MicrophoneRecorder
) {
    const Recorder = function(node, onUploadCallback) {
        this.DELAY = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) ? 2200 : 300;

        this.onUploadCallback = onUploadCallback;

        this.recorder = new MicrophoneRecorder({
            bitRate: 128,
            startRecordingAt: this.DELAY
        });

        this.uploadModel = new UploaderModel(
            new DocControlBuilder().getDocControlFactory(),
            new FileBuilder().getFileFactory()
        );

        this.audioFile = null;
        this.request = null;

        this._upload = function() {
            return new Promise(function(resolve, reject) {
                this.request = this.uploadModel.upload(
                    this._generateUploadHandlers(resolve, reject),
                    new FormVO()
                        .setId(this.view.data.formID)
                        .setFiles([this.audioFile])
                        .setFileKey('uploadedFiles')
                );
            }.bind(this));
        };

        this._generateUploadHandlers = function(resolve, reject) {
            return new Handlers(
                function(results) {
                    const key = results[0].getKey();
                    key ? resolve(key) : reject();
                },
                function progress() {},
                reject,
                reject,
                reject
            )
        };

        this._fetchDocumentFromFileKey = function(key) {
            return new Promise(function(resolve, reject) {
                this.request = this.uploadModel.fetchDocumentsFromFileKeys(this._generateDocumentCollectionHandlers(resolve, reject), [key]);
            }.bind(this));
        };

        this._generateDocumentCollectionHandlers = function(resolve, reject) {
            return new Handlers(
                function(results) {
                    const document = results[0];
                    if (!document['revisionPK']) {
                        this._makeTemporaryDocumentPublic(document.md5)
                            .then(function() {
                                resolve(document)
                            })
                            .catch(reject);

                    } else {
                        resolve(document);
                    }
                }.bind(this),
                function progress() {},
                reject,
                reject,
                reject
            );
        };

        this._makeTemporaryDocumentPublic = function(md5) {
            return new Promise(function(resolve, reject) {
                this.request = this.uploadModel.makeTemporaryDocumentPublic(
                    new Handlers(
                        resolve,
                        function progress() {},
                        reject,
                        reject
                    ),
                    md5
                );
            }.bind(this));
        };

        this._publishUploadSuccessNotification = function() {
            topic.publish(
                'sos-system-notification',
                'Audio recording uploaded.',
                'success',
                5000
            );
        };

        this._publishUploadErrorNotification = function() {
            topic.publish(
                'sos-system-notification',
                'Failed to upload audio. Please try again.',
                'error',
                5000
            );
        };

        const View = declare([_WidgetBase, _TemplatedMixin], {
            templateString: template,
            data: { formID: null },
            recorder: null,
            stopwatch: null,
            mp3: null,
            uploadPromise: null,

            constants: {
                instructions: {
                    initial: 'Click record button to start recording.',
                    accessing: 'Accessing your microphone...',
                    accessDenied: 'The system is unable to access your audio device. Grant access via your browser settings.',
                    recording: 'Recording...',
                    recorded: 'Recording complete.',
                    recordingError: 'Something went wrong when attempting to record your audio.<br />Please try again and if the problem persists, contact support for assistance.',
                    uploading: 'Uploading...'
                }
            },

            postMixInProperties: function() {
                this.inherited(arguments);
                this.data.formID = 'form_'  + this.id;
            },

            postCreate: function() {
                this.inherited(arguments);
                this.instructions.innerHTML = this.constants.instructions.initial;

                this.stopwatch = new StopWatch(domConstruct.create('div', null, this.durationNode, 'only'));
            },

            createAudioElement: function(audioFile) {
                this.audio = document.createElement('audio');
                this.audio.controls = true;
                this.audio.src = URL.createObjectURL(audioFile);
                URL.revokeObjectURL(audioFile);
                this.audio.hidden = true;
                this.buttonContainer.appendChild(this.audio);

                this.audio.addEventListener('timeupdate', throttle(
                    function() {
                        if (!this.audio.paused) {
                            this.stopwatch.setStartTime(this.audio.currentTime);
                        }
                    }.bind(this),
                    500
                ));

                this.audio.addEventListener('ended', function() {
                    this.emit(EVENTS.PAUSE);
                }.bind(this));
            },

            reset: function() {
                this.instructions.innerHTML = this.constants.instructions.initial;
                this.stopwatch.reset();
                this._resetButtons();

                if (this.audio) {
                    this.buttonContainer.removeChild(this.audio);
                    this.audio = null;
                }

                domClass.add(this.cancelUploadBtn, 'hidden');
                domClass.add(this.pauseBtn, 'hidden');
                domClass.add(this.pauseIcon, 'hidden');
                domClass.add(this.playBtn, 'hidden');
                domClass.add(this.playIcon, 'hidden');
                domClass.add(this.resetBtn, 'hidden');
                domClass.add(this.stopBtn, 'hidden');
                domClass.add(this.uploadBtn, 'hidden');
                domClass.add(this.waitingIcon, 'hidden');

                domClass.remove(this.cancelBtn, 'hidden')
                domClass.remove(this.recordBtn, 'hidden');
                domClass.remove(this.recordIcon, 'hidden');
            },

            accessDenied: function() {
                topic.publish(
                    'sos-system-notification',
                    this.constants.instructions.accessDenied,
                    'error',
                    5000
                );
            },

            _record: function() {
                this.emit(EVENTS.RECORD);
            },

            waiting: function() {
                this.instructions.innerHTML = this.constants.instructions.accessing;
                domClass.add(this.recordBtn, 'hidden');
                domClass.add(this.recordIcon, 'hidden');
                domClass.remove(this.instructions, ['sos-alert-warning', 'sos-alert-error']);
                domClass.remove(this.waitingIcon, 'hidden');
            },

            recording: function() {
                this.instructions.innerHTML = this.constants.instructions.recording;
                this.stopwatch.start();
                domClass.add(this.waitingIcon, 'hidden');
                domClass.remove(this.stopBtn, 'hidden');
                domClass.remove(this.stopIcon, 'hidden');
            },

            recordingError: function() {
                this.instructions.innerHTML = this.constants.instructions.recordingError;
                domClass.add(this.instructions, 'sos-alert-error');
                domClass.add(this.playBtn, 'hidden');
                domClass.add(this.playIcon, 'hidden');
                this.stopwatch.reset();
                domClass.remove(this.recordBtn, 'hidden');
                domClass.remove(this.recordIcon, 'hidden');
            },

            _stop: function() {
                this.emit(EVENTS.STOP);
            },

            recorded: function() {
                this.instructions.innerHTML = this.constants.instructions.recorded;
                this.stopwatch.stop();
                domClass.add(this.cancelBtn, 'hidden');
                domClass.add(this.cancelUploadBtn, 'hidden');
                domClass.add(this.pauseBtn, 'hidden');
                domClass.add(this.pauseIcon, 'hidden');
                domClass.add(this.stopBtn, 'hidden');
                domClass.add(this.stopIcon, 'hidden');
                domClass.add(this.waitingIcon, 'hidden');

                domClass.remove(this.durationNode, 'hidden');
                domClass.remove(this.playBtn, 'hidden');
                domClass.remove(this.playIcon, 'hidden');
                domClass.remove(this.resetBtn, 'hidden');
                domClass.remove(this.uploadBtn, 'hidden');
            },

            _play: function() {
                this.emit(EVENTS.PLAY);
            },

            playing: function() {
                domClass.add(this.playBtn, 'hidden');
                domClass.add(this.playIcon, 'hidden');

                domClass.remove(this.pauseBtn, 'hidden');
                domClass.remove(this.pauseIcon, 'hidden');
            },

            play: function() {
                this.audio && this.audio.play();
            },

            _pause: function() {
                this.emit(EVENTS.PAUSE);
            },

            pause: function() { // @todo - _pause, pause and paused may be subject to refactoring
                this.audio && this.audio.pause();
            },

            paused: function() {
                domClass.add(this.pauseBtn, 'hidden');
                domClass.add(this.pauseIcon, 'hidden');

                domClass.remove(this.playBtn, 'hidden');
                domClass.remove(this.playIcon, 'hidden');
            },

            uploading: function() {
                this.instructions.innerHTML = this.constants.instructions.uploading;
                domAttr.set(this.uploadBtn, 'disabled', 'disabled');
                domClass.replace(
                    this.uploadBtn,
                    ['sos-icon-animation-spin-smooth-before', 'sos-icon-loading'],
                    'sos-icon-cloud-upload'
                );
                domClass.add(this.pauseBtn, 'hidden');
                domClass.add(this.pauseIcon, 'hidden');
                domClass.add(this.playBtn, 'hidden');
                domClass.add(this.playIcon, 'hidden');
                domClass.add(this.resetBtn, 'hidden');

                domClass.remove(this.cancelUploadBtn, 'hidden');
                domClass.remove(this.waitingIcon, 'hidden');
            },

            uploaded: function() {
                this._resetButtons();
            },

            _reset: function() {
                this.emit(EVENTS.RESET);
            },

            _cancel: function() {
                this.emit('hide', {});
            },

            _cancelUpload: function() {
                this.emit(EVENTS.CANCEL);
            },

            _resetButtons: function() {
                domAttr.remove(this.uploadBtn, 'disabled');
                domClass.replace(
                    this.uploadBtn,
                    'sos-icon-cloud-upload',
                    ['sos-icon-animation-spin-smooth-before', 'sos-icon-loading']
                );

                domClass.remove(this.resetBtn, 'hidden');
                domClass.add(this.cancelUploadBtn, 'hidden');
            },

            _upload: function() {
                this.emit(EVENTS.UPLOAD);
            }
        });

        this.view = new View({}, node);
        this.view.startup();
    };

    Recorder.prototype.on = function(event, callback) {
        this.view.on(event, callback);
    };

    Recorder.prototype.accessDenied = function() {
        this.view.reset();
        this.view.accessDenied();
    };

    Recorder.prototype.reset = function() {
        this.view.reset();
    };

    Recorder.prototype.waiting = function() {
        this.view.waiting();
    };

    Recorder.prototype.recording = function() {
        this.view.recording();
    };

    Recorder.prototype.recorded = function() {
        this.view.recorded();
    };

    Recorder.prototype.playing = function() {
        this.view.playing();
    };

    Recorder.prototype.play = function() {
        this.view.play();
    };

    Recorder.prototype.paused = function() {
        this.view.paused();
    };

    Recorder.prototype.pause = function() {
        this.view.pause();
    };

    Recorder.prototype.uploading = function() {
        this.view.uploading();
    };

    Recorder.prototype.uploaded = function() {
        this.view.uploaded();
    };

    Recorder.prototype.startRecording = function() {
        this.view.waiting();

        return this.recorder.start().then(function() {
            return new Promise(function (resolve, reject) { setTimeout(resolve, this.DELAY); }.bind(this));
        }.bind(this));
    };

    Recorder.prototype.stopRecording = function() {
        this.recorder.stop();
    };

    Recorder.prototype.recordingError = function() {
        this.view.recordingError();
    };

    Recorder.prototype.createAudio = function() {
        return this.recorder.getMp3().then(function(result) {
            const buffer = result[0];
            const blob = result[1];

            this.audioFile = new File(
                buffer,
                'recorded-audio_:id.mp3'.replace(':id', new Date().toISOString()),
                {
                    type: blob.type,
                    lastModified: Date.now()
                }
            );

            this.view.createAudioElement(this.audioFile);
        }.bind(this));
    };

    Recorder.prototype.upload = function() {
        this.view.uploading();

        this._upload()
            .then(this._fetchDocumentFromFileKey.bind(this))
            .then(function(document) {
                this.view.emit(EVENTS.UPLOAD_FINISHED);

                if (typeof this.onUploadCallback == 'function') {
                    this.onUploadCallback(document);
                }

                this._publishUploadSuccessNotification();
            }.bind(this))
            .catch(function() {
                this.view.emit(EVENTS.UPLOAD_FINISHED);

                this._publishUploadErrorNotification();
            }.bind(this));
    };

    Recorder.prototype.cancelUpload = function() {
        if (this.request) {
            this.request.cancel();
        }
    };

    return Recorder;
});
},
'api/doccontrol/Builder':function(){
define([
    './Config',
    './Factory',
    'library/request/URLConnectionBuilder',
    'library/request/URLResponseProcessorBuilder',
    'library/request/dojo/URLConnectionProcessorBuilder',
], function(
    Config,
    Factory,
    URLConnectionBuilder,
    URLResponseProcessorBuilder,
    URLConnectionProcessorBuilder
) {
    const Builder = function() {
        this.urlConnectionBuilder = new URLConnectionBuilder(
            new URLConnectionProcessorBuilder()
        );

        this.urlResponseProcessorBuilder = new URLResponseProcessorBuilder();
    };

    Builder.prototype.getDocControlFactory = function() {
        return new Factory(
            new Config(),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    return Builder;
});

},
'api/file/Builder':function(){
define([
    './Config',
    './Factory',
    'library/request/URLConnectionBuilder',
    'library/request/URLResponseProcessorBuilder',
    'library/request/dojo/URLConnectionProcessorBuilder',
], function(
    Config,
    Factory,
    URLConnectionBuilder,
    URLResponseProcessorBuilder,
    URLConnectionProcessorBuilder
) {
    const Builder = function() {
        this.urlConnectionBuilder = new URLConnectionBuilder(
            new URLConnectionProcessorBuilder()
        );

        this.urlResponseProcessorBuilder = new URLResponseProcessorBuilder();
    };

    Builder.prototype.getFileFactory = function() {
        return new Factory(
            new Config(),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    return Builder;
});

},
'doccontrol/file-upload/model/Uploader':function(){
define([], function() {
    const Uploader = function (docControlFactory, fileFactory) {
        this.documentCollection = docControlFactory.getDocumentCollection();
        this.temporaryDocumentAccess = docControlFactory.getTemporaryDocumentAccess();
        this.temporaryUploader = fileFactory.getTemporaryUploader();
    };

    Uploader.prototype.fetchDocumentsFromFileKeys = function(handlers, fileKeys) {
        this.documentCollection.setFileKeys(fileKeys);
        return this.documentCollection.create(handlers);
    };

    Uploader.prototype.upload = function(handlers, formVO) {
        return this.temporaryUploader.upload(handlers, formVO);
    };

    Uploader.prototype.makeTemporaryDocumentPublic = function(handlers, md5) {
        return this.temporaryDocumentAccess.makePublic(handlers, md5);
    };

    return Uploader;
});
},
'dojo/throttle':function(){
define([], function(){
	// module:
	//		dojo/throttle
	// summary:
	//		This module provide a throttler

	return function(cb, wait){
		// summary:
		//		Create a function that will only execute once per `wait` periods.
		// description:
		//		Create a function that will only execute once per `wait` periods
		//		from last execution when called repeatedly. Useful for preventing excessive
		//		calculations in rapidly firing events, such as window.resize, node.mousemove
		//		and so on.
		// cb: Function
		//		The callback to fire.
		// wait: Integer
		//		time to delay before allowing cb to call again.
		var canrun = true;
		return function(){
			if(!canrun){
				return;
			}
			canrun = false;
			cb.apply(this, arguments);
			setTimeout(function(){
				canrun = true;
			}, wait);
		};
	};
});

},
'spencer/date-time/StopWatch':function(){
define([
    './Format',
    'dojo/_base/declare',
    'dijit/_WidgetBase',
    'dijit/_TemplatedMixin'
], function(Formatter, declare, _WidgetBase, _TemplatedMixin) {
    const MILLISECONDS_IN_A_SECOND = 1000;
    const DEFAULT_REFRESH_INTERVAL_S = 1;

    const formatter = new Formatter();

    const StopWatch = function(node, refreshIntervalSeconds) {
        const View = declare([_WidgetBase, _TemplatedMixin], {
            templateString: '<span>00:00</span>',

            REFRESH_INTERVAL_S: DEFAULT_REFRESH_INTERVAL_S,
            secondsElapsed: 0,
            intervalID: null,

            start: function() {
                this.stop();
                this._setInterval();
            },

            stop: function() {
                if (this.intervalID) {
                    clearInterval(this.intervalID);
                    this.intervalID = null;
                }
            },

            reset: function() {
                this.stop();
                this.secondsElapsed = 0;
                this._render();
            },

            setStartTime: function(seconds) {
                this.secondsElapsed = Math.round(seconds);
                this._render();
                return this;
            },

            _render: function() {
                try {
                    this.domNode.textContent = formatter.secondsToHMS(this.secondsElapsed);
                } catch (error) {
                    this.stop();
                    this.domNode.textContent = '--:--:--';
                }
            },

            _setInterval: function() {
                if (this.intervalID) {
                    return;
                }

                this.intervalID = setInterval(
                    this._increment.bind(this),
                    this.REFRESH_INTERVAL_S * MILLISECONDS_IN_A_SECOND
                );
            },

            _increment: function() {
                this.secondsElapsed += this.REFRESH_INTERVAL_S;
                this._render();
            }
        });

        this.view = new View({
            REFRESH_INTERVAL_S: refreshIntervalSeconds || DEFAULT_REFRESH_INTERVAL_S
        }, node);
        this.view.startup();
    };

    StopWatch.prototype.start = function() {
        this.view.start();
    };

    StopWatch.prototype.stop = function() {
        this.view.stop();
    };

    StopWatch.prototype.reset = function() {
        this.view.reset();
    };

    StopWatch.prototype.setStartTime = function(seconds) {
        this.view.setStartTime(seconds);
        return this;
    };

    return StopWatch;
});
},
'vendor/mic-recorder-to-mp3/dist/index':function(){
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.MicRecorder = factory());
}(this, (function () {

function new_byte$1(count) {
    return new Int8Array(count);
}

function new_short(count) {
    return new Int16Array(count);
}

function new_int$1(count) {
    return new Int32Array(count);
}

function new_float$1(count) {
    return new Float32Array(count);
}

function new_double$1(count) {
    return new Float64Array(count);
}

function new_float_n$1(args) {
    if (args.length == 1) {
        return new_float$1(args[0]);
    }
    var sz = args[0];
    args = args.slice(1);
    var A = [];
    for (var i = 0; i < sz; i++) {
        A.push(new_float_n$1(args));
    }
    return A;
}
function new_int_n$1(args) {
    if (args.length == 1) {
        return new_int$1(args[0]);
    }
    var sz = args[0];
    args = args.slice(1);
    var A = [];
    for (var i = 0; i < sz; i++) {
        A.push(new_int_n$1(args));
    }
    return A;
}

function new_short_n(args) {
    if (args.length == 1) {
        return new_short(args[0]);
    }
    var sz = args[0];
    args = args.slice(1);
    var A = [];
    for (var i = 0; i < sz; i++) {
        A.push(new_short_n(args));
    }
    return A;
}

function new_array_n$1(args) {
    if (args.length == 1) {
        return new Array(args[0]);
    }
    var sz = args[0];
    args = args.slice(1);
    var A = [];
    for (var i = 0; i < sz; i++) {
        A.push(new_array_n$1(args));
    }
    return A;
}


var Arrays$1 = {};

Arrays$1.fill = function (a, fromIndex, toIndex, val) {
    if (arguments.length == 2) {
        for (var i = 0; i < a.length; i++) {
            a[i] = arguments[1];
        }
    } else {
        for (var i = fromIndex; i < toIndex; i++) {
            a[i] = val;
        }
    }
};

var System$1 = {};

System$1.arraycopy = function (src, srcPos, dest, destPos, length) {
    var srcEnd = srcPos + length;
    while (srcPos < srcEnd)
        dest[destPos++] = src[srcPos++];
};


var Util$1 = {};
Util$1.SQRT2 = 1.41421356237309504880;
Util$1.FAST_LOG10 = function (x) {
    return Math.log10(x);
};

Util$1.FAST_LOG10_X = function (x, y) {
    return Math.log10(x) * y;
};

function ShortBlock$1(ordinal) {
    this.ordinal = ordinal;
}
/**
 * LAME may use them, even different block types for L/R.
 */
ShortBlock$1.short_block_allowed = new ShortBlock$1(0);
/**
 * LAME may use them, but always same block types in L/R.
 */
ShortBlock$1.short_block_coupled = new ShortBlock$1(1);
/**
 * LAME will not use short blocks, long blocks only.
 */
ShortBlock$1.short_block_dispensed = new ShortBlock$1(2);
/**
 * LAME will not use long blocks, short blocks only.
 */
ShortBlock$1.short_block_forced = new ShortBlock$1(3);

var Float$1 = {};
Float$1.MAX_VALUE = 3.4028235e+38;

function VbrMode$1(ordinal) {
    this.ordinal = ordinal;
}
VbrMode$1.vbr_off = new VbrMode$1(0);
VbrMode$1.vbr_mt = new VbrMode$1(1);
VbrMode$1.vbr_rh = new VbrMode$1(2);
VbrMode$1.vbr_abr = new VbrMode$1(3);
VbrMode$1.vbr_mtrh = new VbrMode$1(4);
VbrMode$1.vbr_default = VbrMode$1.vbr_mtrh;

var assert$1 = function (x) {
    //console.assert(x);
};

var common = {
    "System": System$1,
    "VbrMode": VbrMode$1,
    "Float": Float$1,
    "ShortBlock": ShortBlock$1,
    "Util": Util$1,
    "Arrays": Arrays$1,
    "new_array_n": new_array_n$1,
    "new_byte": new_byte$1,
    "new_double": new_double$1,
    "new_float": new_float$1,
    "new_float_n": new_float_n$1,
    "new_int": new_int$1,
    "new_int_n": new_int_n$1,
    "new_short": new_short,
    "new_short_n": new_short_n,
    "assert": assert$1
};

/*
 *      MP3 window subband -> subband filtering -> mdct routine
 *
 *      Copyright (c) 1999-2000 Takehiro Tominaga
 *
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Library General Public License for more details.
 *
 * You should have received a copy of the GNU Library General Public
 * License along with this library; if not, write to the
 * Free Software Foundation, Inc., 59 Temple Place - Suite 330,
 * Boston, MA 02111-1307, USA.
 */
/*
 *         Special Thanks to Patrick De Smet for your advices.
 */

/* $Id: NewMDCT.java,v 1.11 2011/05/24 20:48:06 kenchis Exp $ */

//package mp3;

//import java.util.Arrays;

var System$6 = common.System;
var Util$6 = common.Util;
var Arrays$6 = common.Arrays;
var new_float$6 = common.new_float;
function NewMDCT() {

	var enwindow = [
			-4.77e-07 * 0.740951125354959 / 2.384e-06,
			1.03951e-04 * 0.740951125354959 / 2.384e-06,
			9.53674e-04 * 0.740951125354959 / 2.384e-06,
			2.841473e-03 * 0.740951125354959 / 2.384e-06,
			3.5758972e-02 * 0.740951125354959 / 2.384e-06,
			3.401756e-03 * 0.740951125354959 / 2.384e-06,
			9.83715e-04 * 0.740951125354959 / 2.384e-06,
			9.9182e-05 * 0.740951125354959 / 2.384e-06, /* 15 */
			1.2398e-05 * 0.740951125354959 / 2.384e-06,
			1.91212e-04 * 0.740951125354959 / 2.384e-06,
			2.283096e-03 * 0.740951125354959 / 2.384e-06,
			1.6994476e-02 * 0.740951125354959 / 2.384e-06,
			-1.8756866e-02 * 0.740951125354959 / 2.384e-06,
			-2.630711e-03 * 0.740951125354959 / 2.384e-06,
			-2.47478e-04 * 0.740951125354959 / 2.384e-06,
			-1.4782e-05 * 0.740951125354959 / 2.384e-06,
			9.063471690191471e-01, 1.960342806591213e-01,

			-4.77e-07 * 0.773010453362737 / 2.384e-06,
			1.05858e-04 * 0.773010453362737 / 2.384e-06,
			9.30786e-04 * 0.773010453362737 / 2.384e-06,
			2.521515e-03 * 0.773010453362737 / 2.384e-06,
			3.5694122e-02 * 0.773010453362737 / 2.384e-06,
			3.643036e-03 * 0.773010453362737 / 2.384e-06,
			9.91821e-04 * 0.773010453362737 / 2.384e-06,
			9.6321e-05 * 0.773010453362737 / 2.384e-06, /* 14 */
			1.1444e-05 * 0.773010453362737 / 2.384e-06,
			1.65462e-04 * 0.773010453362737 / 2.384e-06,
			2.110004e-03 * 0.773010453362737 / 2.384e-06,
			1.6112804e-02 * 0.773010453362737 / 2.384e-06,
			-1.9634247e-02 * 0.773010453362737 / 2.384e-06,
			-2.803326e-03 * 0.773010453362737 / 2.384e-06,
			-2.77042e-04 * 0.773010453362737 / 2.384e-06,
			-1.6689e-05 * 0.773010453362737 / 2.384e-06,
			8.206787908286602e-01, 3.901806440322567e-01,

			-4.77e-07 * 0.803207531480645 / 2.384e-06,
			1.07288e-04 * 0.803207531480645 / 2.384e-06,
			9.02653e-04 * 0.803207531480645 / 2.384e-06,
			2.174854e-03 * 0.803207531480645 / 2.384e-06,
			3.5586357e-02 * 0.803207531480645 / 2.384e-06,
			3.858566e-03 * 0.803207531480645 / 2.384e-06,
			9.95159e-04 * 0.803207531480645 / 2.384e-06,
			9.3460e-05 * 0.803207531480645 / 2.384e-06, /* 13 */
			1.0014e-05 * 0.803207531480645 / 2.384e-06,
			1.40190e-04 * 0.803207531480645 / 2.384e-06,
			1.937389e-03 * 0.803207531480645 / 2.384e-06,
			1.5233517e-02 * 0.803207531480645 / 2.384e-06,
			-2.0506859e-02 * 0.803207531480645 / 2.384e-06,
			-2.974033e-03 * 0.803207531480645 / 2.384e-06,
			-3.07560e-04 * 0.803207531480645 / 2.384e-06,
			-1.8120e-05 * 0.803207531480645 / 2.384e-06,
			7.416505462720353e-01, 5.805693545089249e-01,

			-4.77e-07 * 0.831469612302545 / 2.384e-06,
			1.08242e-04 * 0.831469612302545 / 2.384e-06,
			8.68797e-04 * 0.831469612302545 / 2.384e-06,
			1.800537e-03 * 0.831469612302545 / 2.384e-06,
			3.5435200e-02 * 0.831469612302545 / 2.384e-06,
			4.049301e-03 * 0.831469612302545 / 2.384e-06,
			9.94205e-04 * 0.831469612302545 / 2.384e-06,
			9.0599e-05 * 0.831469612302545 / 2.384e-06, /* 12 */
			9.060e-06 * 0.831469612302545 / 2.384e-06,
			1.16348e-04 * 0.831469612302545 / 2.384e-06,
			1.766682e-03 * 0.831469612302545 / 2.384e-06,
			1.4358521e-02 * 0.831469612302545 / 2.384e-06,
			-2.1372318e-02 * 0.831469612302545 / 2.384e-06,
			-3.14188e-03 * 0.831469612302545 / 2.384e-06,
			-3.39031e-04 * 0.831469612302545 / 2.384e-06,
			-1.9550e-05 * 0.831469612302545 / 2.384e-06,
			6.681786379192989e-01, 7.653668647301797e-01,

			-4.77e-07 * 0.857728610000272 / 2.384e-06,
			1.08719e-04 * 0.857728610000272 / 2.384e-06,
			8.29220e-04 * 0.857728610000272 / 2.384e-06,
			1.399517e-03 * 0.857728610000272 / 2.384e-06,
			3.5242081e-02 * 0.857728610000272 / 2.384e-06,
			4.215240e-03 * 0.857728610000272 / 2.384e-06,
			9.89437e-04 * 0.857728610000272 / 2.384e-06,
			8.7261e-05 * 0.857728610000272 / 2.384e-06, /* 11 */
			8.106e-06 * 0.857728610000272 / 2.384e-06,
			9.3937e-05 * 0.857728610000272 / 2.384e-06,
			1.597881e-03 * 0.857728610000272 / 2.384e-06,
			1.3489246e-02 * 0.857728610000272 / 2.384e-06,
			-2.2228718e-02 * 0.857728610000272 / 2.384e-06,
			-3.306866e-03 * 0.857728610000272 / 2.384e-06,
			-3.71456e-04 * 0.857728610000272 / 2.384e-06,
			-2.1458e-05 * 0.857728610000272 / 2.384e-06,
			5.993769336819237e-01, 9.427934736519954e-01,

			-4.77e-07 * 0.881921264348355 / 2.384e-06,
			1.08719e-04 * 0.881921264348355 / 2.384e-06,
			7.8392e-04 * 0.881921264348355 / 2.384e-06,
			9.71317e-04 * 0.881921264348355 / 2.384e-06,
			3.5007000e-02 * 0.881921264348355 / 2.384e-06,
			4.357815e-03 * 0.881921264348355 / 2.384e-06,
			9.80854e-04 * 0.881921264348355 / 2.384e-06,
			8.3923e-05 * 0.881921264348355 / 2.384e-06, /* 10 */
			7.629e-06 * 0.881921264348355 / 2.384e-06,
			7.2956e-05 * 0.881921264348355 / 2.384e-06,
			1.432419e-03 * 0.881921264348355 / 2.384e-06,
			1.2627602e-02 * 0.881921264348355 / 2.384e-06,
			-2.3074150e-02 * 0.881921264348355 / 2.384e-06,
			-3.467083e-03 * 0.881921264348355 / 2.384e-06,
			-4.04358e-04 * 0.881921264348355 / 2.384e-06,
			-2.3365e-05 * 0.881921264348355 / 2.384e-06,
			5.345111359507916e-01, 1.111140466039205e+00,

			-9.54e-07 * 0.903989293123443 / 2.384e-06,
			1.08242e-04 * 0.903989293123443 / 2.384e-06,
			7.31945e-04 * 0.903989293123443 / 2.384e-06,
			5.15938e-04 * 0.903989293123443 / 2.384e-06,
			3.4730434e-02 * 0.903989293123443 / 2.384e-06,
			4.477024e-03 * 0.903989293123443 / 2.384e-06,
			9.68933e-04 * 0.903989293123443 / 2.384e-06,
			8.0585e-05 * 0.903989293123443 / 2.384e-06, /* 9 */
			6.676e-06 * 0.903989293123443 / 2.384e-06,
			5.2929e-05 * 0.903989293123443 / 2.384e-06,
			1.269817e-03 * 0.903989293123443 / 2.384e-06,
			1.1775017e-02 * 0.903989293123443 / 2.384e-06,
			-2.3907185e-02 * 0.903989293123443 / 2.384e-06,
			-3.622532e-03 * 0.903989293123443 / 2.384e-06,
			-4.38213e-04 * 0.903989293123443 / 2.384e-06,
			-2.5272e-05 * 0.903989293123443 / 2.384e-06,
			4.729647758913199e-01, 1.268786568327291e+00,

			-9.54e-07 * 0.92387953251128675613 / 2.384e-06,
			1.06812e-04 * 0.92387953251128675613 / 2.384e-06,
			6.74248e-04 * 0.92387953251128675613 / 2.384e-06,
			3.3379e-05 * 0.92387953251128675613 / 2.384e-06,
			3.4412861e-02 * 0.92387953251128675613 / 2.384e-06,
			4.573822e-03 * 0.92387953251128675613 / 2.384e-06,
			9.54151e-04 * 0.92387953251128675613 / 2.384e-06,
			7.6771e-05 * 0.92387953251128675613 / 2.384e-06,
			6.199e-06 * 0.92387953251128675613 / 2.384e-06,
			3.4332e-05 * 0.92387953251128675613 / 2.384e-06,
			1.111031e-03 * 0.92387953251128675613 / 2.384e-06,
			1.0933399e-02 * 0.92387953251128675613 / 2.384e-06,
			-2.4725437e-02 * 0.92387953251128675613 / 2.384e-06,
			-3.771782e-03 * 0.92387953251128675613 / 2.384e-06,
			-4.72546e-04 * 0.92387953251128675613 / 2.384e-06,
			-2.7657e-05 * 0.92387953251128675613 / 2.384e-06,
			4.1421356237309504879e-01, /* tan(PI/8) */
			1.414213562373095e+00,

			-9.54e-07 * 0.941544065183021 / 2.384e-06,
			1.05381e-04 * 0.941544065183021 / 2.384e-06,
			6.10352e-04 * 0.941544065183021 / 2.384e-06,
			-4.75883e-04 * 0.941544065183021 / 2.384e-06,
			3.4055710e-02 * 0.941544065183021 / 2.384e-06,
			4.649162e-03 * 0.941544065183021 / 2.384e-06,
			9.35555e-04 * 0.941544065183021 / 2.384e-06,
			7.3433e-05 * 0.941544065183021 / 2.384e-06, /* 7 */
			5.245e-06 * 0.941544065183021 / 2.384e-06,
			1.7166e-05 * 0.941544065183021 / 2.384e-06,
			9.56535e-04 * 0.941544065183021 / 2.384e-06,
			1.0103703e-02 * 0.941544065183021 / 2.384e-06,
			-2.5527000e-02 * 0.941544065183021 / 2.384e-06,
			-3.914356e-03 * 0.941544065183021 / 2.384e-06,
			-5.07355e-04 * 0.941544065183021 / 2.384e-06,
			-3.0041e-05 * 0.941544065183021 / 2.384e-06,
			3.578057213145241e-01, 1.546020906725474e+00,

			-9.54e-07 * 0.956940335732209 / 2.384e-06,
			1.02520e-04 * 0.956940335732209 / 2.384e-06,
			5.39303e-04 * 0.956940335732209 / 2.384e-06,
			-1.011848e-03 * 0.956940335732209 / 2.384e-06,
			3.3659935e-02 * 0.956940335732209 / 2.384e-06,
			4.703045e-03 * 0.956940335732209 / 2.384e-06,
			9.15051e-04 * 0.956940335732209 / 2.384e-06,
			7.0095e-05 * 0.956940335732209 / 2.384e-06, /* 6 */
			4.768e-06 * 0.956940335732209 / 2.384e-06,
			9.54e-07 * 0.956940335732209 / 2.384e-06,
			8.06808e-04 * 0.956940335732209 / 2.384e-06,
			9.287834e-03 * 0.956940335732209 / 2.384e-06,
			-2.6310921e-02 * 0.956940335732209 / 2.384e-06,
			-4.048824e-03 * 0.956940335732209 / 2.384e-06,
			-5.42164e-04 * 0.956940335732209 / 2.384e-06,
			-3.2425e-05 * 0.956940335732209 / 2.384e-06,
			3.033466836073424e-01, 1.662939224605090e+00,

			-1.431e-06 * 0.970031253194544 / 2.384e-06,
			9.9182e-05 * 0.970031253194544 / 2.384e-06,
			4.62532e-04 * 0.970031253194544 / 2.384e-06,
			-1.573563e-03 * 0.970031253194544 / 2.384e-06,
			3.3225536e-02 * 0.970031253194544 / 2.384e-06,
			4.737377e-03 * 0.970031253194544 / 2.384e-06,
			8.91685e-04 * 0.970031253194544 / 2.384e-06,
			6.6280e-05 * 0.970031253194544 / 2.384e-06, /* 5 */
			4.292e-06 * 0.970031253194544 / 2.384e-06,
			-1.3828e-05 * 0.970031253194544 / 2.384e-06,
			6.61850e-04 * 0.970031253194544 / 2.384e-06,
			8.487225e-03 * 0.970031253194544 / 2.384e-06,
			-2.7073860e-02 * 0.970031253194544 / 2.384e-06,
			-4.174709e-03 * 0.970031253194544 / 2.384e-06,
			-5.76973e-04 * 0.970031253194544 / 2.384e-06,
			-3.4809e-05 * 0.970031253194544 / 2.384e-06,
			2.504869601913055e-01, 1.763842528696710e+00,

			-1.431e-06 * 0.98078528040323 / 2.384e-06,
			9.5367e-05 * 0.98078528040323 / 2.384e-06,
			3.78609e-04 * 0.98078528040323 / 2.384e-06,
			-2.161503e-03 * 0.98078528040323 / 2.384e-06,
			3.2754898e-02 * 0.98078528040323 / 2.384e-06,
			4.752159e-03 * 0.98078528040323 / 2.384e-06,
			8.66413e-04 * 0.98078528040323 / 2.384e-06,
			6.2943e-05 * 0.98078528040323 / 2.384e-06, /* 4 */
			3.815e-06 * 0.98078528040323 / 2.384e-06,
			-2.718e-05 * 0.98078528040323 / 2.384e-06,
			5.22137e-04 * 0.98078528040323 / 2.384e-06,
			7.703304e-03 * 0.98078528040323 / 2.384e-06,
			-2.7815342e-02 * 0.98078528040323 / 2.384e-06,
			-4.290581e-03 * 0.98078528040323 / 2.384e-06,
			-6.11782e-04 * 0.98078528040323 / 2.384e-06,
			-3.7670e-05 * 0.98078528040323 / 2.384e-06,
			1.989123673796580e-01, 1.847759065022573e+00,

			-1.907e-06 * 0.989176509964781 / 2.384e-06,
			9.0122e-05 * 0.989176509964781 / 2.384e-06,
			2.88486e-04 * 0.989176509964781 / 2.384e-06,
			-2.774239e-03 * 0.989176509964781 / 2.384e-06,
			3.2248020e-02 * 0.989176509964781 / 2.384e-06,
			4.748821e-03 * 0.989176509964781 / 2.384e-06,
			8.38757e-04 * 0.989176509964781 / 2.384e-06,
			5.9605e-05 * 0.989176509964781 / 2.384e-06, /* 3 */
			3.338e-06 * 0.989176509964781 / 2.384e-06,
			-3.9577e-05 * 0.989176509964781 / 2.384e-06,
			3.88145e-04 * 0.989176509964781 / 2.384e-06,
			6.937027e-03 * 0.989176509964781 / 2.384e-06,
			-2.8532982e-02 * 0.989176509964781 / 2.384e-06,
			-4.395962e-03 * 0.989176509964781 / 2.384e-06,
			-6.46591e-04 * 0.989176509964781 / 2.384e-06,
			-4.0531e-05 * 0.989176509964781 / 2.384e-06,
			1.483359875383474e-01, 1.913880671464418e+00,

			-1.907e-06 * 0.995184726672197 / 2.384e-06,
			8.4400e-05 * 0.995184726672197 / 2.384e-06,
			1.91689e-04 * 0.995184726672197 / 2.384e-06,
			-3.411293e-03 * 0.995184726672197 / 2.384e-06,
			3.1706810e-02 * 0.995184726672197 / 2.384e-06,
			4.728317e-03 * 0.995184726672197 / 2.384e-06,
			8.09669e-04 * 0.995184726672197 / 2.384e-06,
			5.579e-05 * 0.995184726672197 / 2.384e-06,
			3.338e-06 * 0.995184726672197 / 2.384e-06,
			-5.0545e-05 * 0.995184726672197 / 2.384e-06,
			2.59876e-04 * 0.995184726672197 / 2.384e-06,
			6.189346e-03 * 0.995184726672197 / 2.384e-06,
			-2.9224873e-02 * 0.995184726672197 / 2.384e-06,
			-4.489899e-03 * 0.995184726672197 / 2.384e-06,
			-6.80923e-04 * 0.995184726672197 / 2.384e-06,
			-4.3392e-05 * 0.995184726672197 / 2.384e-06,
			9.849140335716425e-02, 1.961570560806461e+00,

			-2.384e-06 * 0.998795456205172 / 2.384e-06,
			7.7724e-05 * 0.998795456205172 / 2.384e-06,
			8.8215e-05 * 0.998795456205172 / 2.384e-06,
			-4.072189e-03 * 0.998795456205172 / 2.384e-06,
			3.1132698e-02 * 0.998795456205172 / 2.384e-06,
			4.691124e-03 * 0.998795456205172 / 2.384e-06,
			7.79152e-04 * 0.998795456205172 / 2.384e-06,
			5.2929e-05 * 0.998795456205172 / 2.384e-06,
			2.861e-06 * 0.998795456205172 / 2.384e-06,
			-6.0558e-05 * 0.998795456205172 / 2.384e-06,
			1.37329e-04 * 0.998795456205172 / 2.384e-06,
			5.462170e-03 * 0.998795456205172 / 2.384e-06,
			-2.9890060e-02 * 0.998795456205172 / 2.384e-06,
			-4.570484e-03 * 0.998795456205172 / 2.384e-06,
			-7.14302e-04 * 0.998795456205172 / 2.384e-06,
			-4.6253e-05 * 0.998795456205172 / 2.384e-06,
			4.912684976946725e-02, 1.990369453344394e+00,

			3.5780907e-02 * Util$6.SQRT2 * 0.5 / 2.384e-06,
			1.7876148e-02 * Util$6.SQRT2 * 0.5 / 2.384e-06,
			3.134727e-03 * Util$6.SQRT2 * 0.5 / 2.384e-06,
			2.457142e-03 * Util$6.SQRT2 * 0.5 / 2.384e-06,
			9.71317e-04 * Util$6.SQRT2 * 0.5 / 2.384e-06,
			2.18868e-04 * Util$6.SQRT2 * 0.5 / 2.384e-06,
			1.01566e-04 * Util$6.SQRT2 * 0.5 / 2.384e-06,
			1.3828e-05 * Util$6.SQRT2 * 0.5 / 2.384e-06,

			3.0526638e-02 / 2.384e-06, 4.638195e-03 / 2.384e-06,
			7.47204e-04 / 2.384e-06, 4.9591e-05 / 2.384e-06,
			4.756451e-03 / 2.384e-06, 2.1458e-05 / 2.384e-06,
			-6.9618e-05 / 2.384e-06, /* 2.384e-06/2.384e-06 */
	];

	var NS = 12;
	var NL = 36;

	var win = [
	    [
	     2.382191739347913e-13,
	     6.423305872147834e-13,
	     9.400849094049688e-13,
	     1.122435026096556e-12,
	     1.183840321267481e-12,
	     1.122435026096556e-12,
	     9.400849094049690e-13,
	     6.423305872147839e-13,
	     2.382191739347918e-13,

	     5.456116108943412e-12,
	     4.878985199565852e-12,
	     4.240448995017367e-12,
	     3.559909094758252e-12,
	     2.858043359288075e-12,
	     2.156177623817898e-12,
	     1.475637723558783e-12,
	     8.371015190102974e-13,
	     2.599706096327376e-13,

	     -5.456116108943412e-12,
	     -4.878985199565852e-12,
	     -4.240448995017367e-12,
	     -3.559909094758252e-12,
	     -2.858043359288076e-12,
	     -2.156177623817898e-12,
	     -1.475637723558783e-12,
	     -8.371015190102975e-13,
	     -2.599706096327376e-13,

	     -2.382191739347923e-13,
	     -6.423305872147843e-13,
	     -9.400849094049696e-13,
	     -1.122435026096556e-12,
	     -1.183840321267481e-12,
	     -1.122435026096556e-12,
	     -9.400849094049694e-13,
	     -6.423305872147840e-13,
	     -2.382191739347918e-13,
	     ],
	    [
	     2.382191739347913e-13,
	     6.423305872147834e-13,
	     9.400849094049688e-13,
	     1.122435026096556e-12,
	     1.183840321267481e-12,
	     1.122435026096556e-12,
	     9.400849094049688e-13,
	     6.423305872147841e-13,
	     2.382191739347918e-13,

	     5.456116108943413e-12,
	     4.878985199565852e-12,
	     4.240448995017367e-12,
	     3.559909094758253e-12,
	     2.858043359288075e-12,
	     2.156177623817898e-12,
	     1.475637723558782e-12,
	     8.371015190102975e-13,
	     2.599706096327376e-13,

	     -5.461314069809755e-12,
	     -4.921085770524055e-12,
	     -4.343405037091838e-12,
	     -3.732668368707687e-12,
	     -3.093523840190885e-12,
	     -2.430835727329465e-12,
	     -1.734679010007751e-12,
	     -9.748253656609281e-13,
	     -2.797435120168326e-13,

	     0.000000000000000e+00,
	     0.000000000000000e+00,
	     0.000000000000000e+00,
	     0.000000000000000e+00,
	     0.000000000000000e+00,
	     0.000000000000000e+00,
	     -2.283748241799531e-13,
	     -4.037858874020686e-13,
	     -2.146547464825323e-13,
	     ],
	    [
	     1.316524975873958e-01, /* win[SHORT_TYPE] */
	     4.142135623730950e-01,
	     7.673269879789602e-01,

	     1.091308501069271e+00, /* tantab_l */
	     1.303225372841206e+00,
	     1.569685577117490e+00,
	     1.920982126971166e+00,
	     2.414213562373094e+00,
	     3.171594802363212e+00,
	     4.510708503662055e+00,
	     7.595754112725146e+00,
	     2.290376554843115e+01,

	     0.98480775301220802032, /* cx */
	     0.64278760968653936292,
	     0.34202014332566882393,
	     0.93969262078590842791,
	     -0.17364817766693030343,
	     -0.76604444311897790243,
	     0.86602540378443870761,
	     0.500000000000000e+00,

	     -5.144957554275265e-01, /* ca */
	     -4.717319685649723e-01,
	     -3.133774542039019e-01,
	     -1.819131996109812e-01,
	     -9.457419252642064e-02,
	     -4.096558288530405e-02,
	     -1.419856857247115e-02,
	     -3.699974673760037e-03,

	     8.574929257125442e-01, /* cs */
	     8.817419973177052e-01,
	     9.496286491027329e-01,
	     9.833145924917901e-01,
	     9.955178160675857e-01,
	     9.991605581781475e-01,
	     9.998991952444470e-01,
	     9.999931550702802e-01,
	     ],
	    [
	     0.000000000000000e+00,
	     0.000000000000000e+00,
	     0.000000000000000e+00,
	     0.000000000000000e+00,
	     0.000000000000000e+00,
	     0.000000000000000e+00,
	     2.283748241799531e-13,
	     4.037858874020686e-13,
	     2.146547464825323e-13,

	     5.461314069809755e-12,
	     4.921085770524055e-12,
	     4.343405037091838e-12,
	     3.732668368707687e-12,
	     3.093523840190885e-12,
	     2.430835727329466e-12,
	     1.734679010007751e-12,
	     9.748253656609281e-13,
	     2.797435120168326e-13,

	     -5.456116108943413e-12,
	     -4.878985199565852e-12,
	     -4.240448995017367e-12,
	     -3.559909094758253e-12,
	     -2.858043359288075e-12,
	     -2.156177623817898e-12,
	     -1.475637723558782e-12,
	     -8.371015190102975e-13,
	     -2.599706096327376e-13,

	     -2.382191739347913e-13,
	     -6.423305872147834e-13,
	     -9.400849094049688e-13,
	     -1.122435026096556e-12,
	     -1.183840321267481e-12,
	     -1.122435026096556e-12,
	     -9.400849094049688e-13,
	     -6.423305872147841e-13,
	     -2.382191739347918e-13,
	     ]
	];

	var tantab_l = win[Encoder_1.SHORT_TYPE];
	var cx = win[Encoder_1.SHORT_TYPE];
	var ca = win[Encoder_1.SHORT_TYPE];
	var cs = win[Encoder_1.SHORT_TYPE];

	/**
	 * new IDCT routine written by Takehiro TOMINAGA
	 *
	 * PURPOSE: Overlapping window on PCM samples<BR>
	 *
	 * SEMANTICS:<BR>
	 * 32 16-bit pcm samples are scaled to fractional 2's complement and
	 * concatenated to the end of the window buffer #x#. The updated window
	 * buffer #x# is then windowed by the analysis window #c# to produce the
	 * windowed sample #z#
	 */
	var order = [
	    0, 1, 16, 17, 8, 9, 24, 25, 4, 5, 20, 21, 12, 13, 28, 29,
	    2, 3, 18, 19, 10, 11, 26, 27, 6, 7, 22, 23, 14, 15, 30, 31
	];

	/**
	 * returns sum_j=0^31 a[j]*cos(PI*j*(k+1/2)/32), 0<=k<32
	 */
	function window_subband(x1, x1Pos, a) {
		var wp = 10;

		var x2 = x1Pos + 238 - 14 - 286;

		for (var i = -15; i < 0; i++) {
			var w, s, t;

			w = enwindow[wp + -10];
			s = x1[x2 + -224] * w;
			t = x1[x1Pos + 224] * w;
			w = enwindow[wp + -9];
			s += x1[x2 + -160] * w;
			t += x1[x1Pos + 160] * w;
			w = enwindow[wp + -8];
			s += x1[x2 + -96] * w;
			t += x1[x1Pos + 96] * w;
			w = enwindow[wp + -7];
			s += x1[x2 + -32] * w;
			t += x1[x1Pos + 32] * w;
			w = enwindow[wp + -6];
			s += x1[x2 + 32] * w;
			t += x1[x1Pos + -32] * w;
			w = enwindow[wp + -5];
			s += x1[x2 + 96] * w;
			t += x1[x1Pos + -96] * w;
			w = enwindow[wp + -4];
			s += x1[x2 + 160] * w;
			t += x1[x1Pos + -160] * w;
			w = enwindow[wp + -3];
			s += x1[x2 + 224] * w;
			t += x1[x1Pos + -224] * w;

			w = enwindow[wp + -2];
			s += x1[x1Pos + -256] * w;
			t -= x1[x2 + 256] * w;
			w = enwindow[wp + -1];
			s += x1[x1Pos + -192] * w;
			t -= x1[x2 + 192] * w;
			w = enwindow[wp + 0];
			s += x1[x1Pos + -128] * w;
			t -= x1[x2 + 128] * w;
			w = enwindow[wp + 1];
			s += x1[x1Pos + -64] * w;
			t -= x1[x2 + 64] * w;
			w = enwindow[wp + 2];
			s += x1[x1Pos + 0] * w;
			t -= x1[x2 + 0] * w;
			w = enwindow[wp + 3];
			s += x1[x1Pos + 64] * w;
			t -= x1[x2 + -64] * w;
			w = enwindow[wp + 4];
			s += x1[x1Pos + 128] * w;
			t -= x1[x2 + -128] * w;
			w = enwindow[wp + 5];
			s += x1[x1Pos + 192] * w;
			t -= x1[x2 + -192] * w;

			/*
			 * this multiplyer could be removed, but it needs more 256 FLOAT
			 * data. thinking about the data cache performance, I think we
			 * should not use such a huge table. tt 2000/Oct/25
			 */
			s *= enwindow[wp + 6];
			w = t - s;
			a[30 + i * 2] = t + s;
			a[31 + i * 2] = enwindow[wp + 7] * w;
			wp += 18;
			x1Pos--;
			x2++;
		}
		{
			var s, t, u, v;
			t = x1[x1Pos + -16] * enwindow[wp + -10];
			s = x1[x1Pos + -32] * enwindow[wp + -2];
			t += (x1[x1Pos + -48] - x1[x1Pos + 16]) * enwindow[wp + -9];
			s += x1[x1Pos + -96] * enwindow[wp + -1];
			t += (x1[x1Pos + -80] + x1[x1Pos + 48]) * enwindow[wp + -8];
			s += x1[x1Pos + -160] * enwindow[wp + 0];
			t += (x1[x1Pos + -112] - x1[x1Pos + 80]) * enwindow[wp + -7];
			s += x1[x1Pos + -224] * enwindow[wp + 1];
			t += (x1[x1Pos + -144] + x1[x1Pos + 112]) * enwindow[wp + -6];
			s -= x1[x1Pos + 32] * enwindow[wp + 2];
			t += (x1[x1Pos + -176] - x1[x1Pos + 144]) * enwindow[wp + -5];
			s -= x1[x1Pos + 96] * enwindow[wp + 3];
			t += (x1[x1Pos + -208] + x1[x1Pos + 176]) * enwindow[wp + -4];
			s -= x1[x1Pos + 160] * enwindow[wp + 4];
			t += (x1[x1Pos + -240] - x1[x1Pos + 208]) * enwindow[wp + -3];
			s -= x1[x1Pos + 224];

			u = s - t;
			v = s + t;

			t = a[14];
			s = a[15] - t;

			a[31] = v + t; /* A0 */
			a[30] = u + s; /* A1 */
			a[15] = u - s; /* A2 */
			a[14] = v - t; /* A3 */
		}
		{
			var xr;
			xr = a[28] - a[0];
			a[0] += a[28];
			a[28] = xr * enwindow[wp + -2 * 18 + 7];
			xr = a[29] - a[1];
			a[1] += a[29];
			a[29] = xr * enwindow[wp + -2 * 18 + 7];

			xr = a[26] - a[2];
			a[2] += a[26];
			a[26] = xr * enwindow[wp + -4 * 18 + 7];
			xr = a[27] - a[3];
			a[3] += a[27];
			a[27] = xr * enwindow[wp + -4 * 18 + 7];

			xr = a[24] - a[4];
			a[4] += a[24];
			a[24] = xr * enwindow[wp + -6 * 18 + 7];
			xr = a[25] - a[5];
			a[5] += a[25];
			a[25] = xr * enwindow[wp + -6 * 18 + 7];

			xr = a[22] - a[6];
			a[6] += a[22];
			a[22] = xr * Util$6.SQRT2;
			xr = a[23] - a[7];
			a[7] += a[23];
			a[23] = xr * Util$6.SQRT2 - a[7];
			a[7] -= a[6];
			a[22] -= a[7];
			a[23] -= a[22];

			xr = a[6];
			a[6] = a[31] - xr;
			a[31] = a[31] + xr;
			xr = a[7];
			a[7] = a[30] - xr;
			a[30] = a[30] + xr;
			xr = a[22];
			a[22] = a[15] - xr;
			a[15] = a[15] + xr;
			xr = a[23];
			a[23] = a[14] - xr;
			a[14] = a[14] + xr;

			xr = a[20] - a[8];
			a[8] += a[20];
			a[20] = xr * enwindow[wp + -10 * 18 + 7];
			xr = a[21] - a[9];
			a[9] += a[21];
			a[21] = xr * enwindow[wp + -10 * 18 + 7];

			xr = a[18] - a[10];
			a[10] += a[18];
			a[18] = xr * enwindow[wp + -12 * 18 + 7];
			xr = a[19] - a[11];
			a[11] += a[19];
			a[19] = xr * enwindow[wp + -12 * 18 + 7];

			xr = a[16] - a[12];
			a[12] += a[16];
			a[16] = xr * enwindow[wp + -14 * 18 + 7];
			xr = a[17] - a[13];
			a[13] += a[17];
			a[17] = xr * enwindow[wp + -14 * 18 + 7];

			xr = -a[20] + a[24];
			a[20] += a[24];
			a[24] = xr * enwindow[wp + -12 * 18 + 7];
			xr = -a[21] + a[25];
			a[21] += a[25];
			a[25] = xr * enwindow[wp + -12 * 18 + 7];

			xr = a[4] - a[8];
			a[4] += a[8];
			a[8] = xr * enwindow[wp + -12 * 18 + 7];
			xr = a[5] - a[9];
			a[5] += a[9];
			a[9] = xr * enwindow[wp + -12 * 18 + 7];

			xr = a[0] - a[12];
			a[0] += a[12];
			a[12] = xr * enwindow[wp + -4 * 18 + 7];
			xr = a[1] - a[13];
			a[1] += a[13];
			a[13] = xr * enwindow[wp + -4 * 18 + 7];
			xr = a[16] - a[28];
			a[16] += a[28];
			a[28] = xr * enwindow[wp + -4 * 18 + 7];
			xr = -a[17] + a[29];
			a[17] += a[29];
			a[29] = xr * enwindow[wp + -4 * 18 + 7];

			xr = Util$6.SQRT2 * (a[2] - a[10]);
			a[2] += a[10];
			a[10] = xr;
			xr = Util$6.SQRT2 * (a[3] - a[11]);
			a[3] += a[11];
			a[11] = xr;
			xr = Util$6.SQRT2 * (-a[18] + a[26]);
			a[18] += a[26];
			a[26] = xr - a[18];
			xr = Util$6.SQRT2 * (-a[19] + a[27]);
			a[19] += a[27];
			a[27] = xr - a[19];

			xr = a[2];
			a[19] -= a[3];
			a[3] -= xr;
			a[2] = a[31] - xr;
			a[31] += xr;
			xr = a[3];
			a[11] -= a[19];
			a[18] -= xr;
			a[3] = a[30] - xr;
			a[30] += xr;
			xr = a[18];
			a[27] -= a[11];
			a[19] -= xr;
			a[18] = a[15] - xr;
			a[15] += xr;

			xr = a[19];
			a[10] -= xr;
			a[19] = a[14] - xr;
			a[14] += xr;
			xr = a[10];
			a[11] -= xr;
			a[10] = a[23] - xr;
			a[23] += xr;
			xr = a[11];
			a[26] -= xr;
			a[11] = a[22] - xr;
			a[22] += xr;
			xr = a[26];
			a[27] -= xr;
			a[26] = a[7] - xr;
			a[7] += xr;

			xr = a[27];
			a[27] = a[6] - xr;
			a[6] += xr;

			xr = Util$6.SQRT2 * (a[0] - a[4]);
			a[0] += a[4];
			a[4] = xr;
			xr = Util$6.SQRT2 * (a[1] - a[5]);
			a[1] += a[5];
			a[5] = xr;
			xr = Util$6.SQRT2 * (a[16] - a[20]);
			a[16] += a[20];
			a[20] = xr;
			xr = Util$6.SQRT2 * (a[17] - a[21]);
			a[17] += a[21];
			a[21] = xr;

			xr = -Util$6.SQRT2 * (a[8] - a[12]);
			a[8] += a[12];
			a[12] = xr - a[8];
			xr = -Util$6.SQRT2 * (a[9] - a[13]);
			a[9] += a[13];
			a[13] = xr - a[9];
			xr = -Util$6.SQRT2 * (a[25] - a[29]);
			a[25] += a[29];
			a[29] = xr - a[25];
			xr = -Util$6.SQRT2 * (a[24] + a[28]);
			a[24] -= a[28];
			a[28] = xr - a[24];

			xr = a[24] - a[16];
			a[24] = xr;
			xr = a[20] - xr;
			a[20] = xr;
			xr = a[28] - xr;
			a[28] = xr;

			xr = a[25] - a[17];
			a[25] = xr;
			xr = a[21] - xr;
			a[21] = xr;
			xr = a[29] - xr;
			a[29] = xr;

			xr = a[17] - a[1];
			a[17] = xr;
			xr = a[9] - xr;
			a[9] = xr;
			xr = a[25] - xr;
			a[25] = xr;
			xr = a[5] - xr;
			a[5] = xr;
			xr = a[21] - xr;
			a[21] = xr;
			xr = a[13] - xr;
			a[13] = xr;
			xr = a[29] - xr;
			a[29] = xr;

			xr = a[1] - a[0];
			a[1] = xr;
			xr = a[16] - xr;
			a[16] = xr;
			xr = a[17] - xr;
			a[17] = xr;
			xr = a[8] - xr;
			a[8] = xr;
			xr = a[9] - xr;
			a[9] = xr;
			xr = a[24] - xr;
			a[24] = xr;
			xr = a[25] - xr;
			a[25] = xr;
			xr = a[4] - xr;
			a[4] = xr;
			xr = a[5] - xr;
			a[5] = xr;
			xr = a[20] - xr;
			a[20] = xr;
			xr = a[21] - xr;
			a[21] = xr;
			xr = a[12] - xr;
			a[12] = xr;
			xr = a[13] - xr;
			a[13] = xr;
			xr = a[28] - xr;
			a[28] = xr;
			xr = a[29] - xr;
			a[29] = xr;

			xr = a[0];
			a[0] += a[31];
			a[31] -= xr;
			xr = a[1];
			a[1] += a[30];
			a[30] -= xr;
			xr = a[16];
			a[16] += a[15];
			a[15] -= xr;
			xr = a[17];
			a[17] += a[14];
			a[14] -= xr;
			xr = a[8];
			a[8] += a[23];
			a[23] -= xr;
			xr = a[9];
			a[9] += a[22];
			a[22] -= xr;
			xr = a[24];
			a[24] += a[7];
			a[7] -= xr;
			xr = a[25];
			a[25] += a[6];
			a[6] -= xr;
			xr = a[4];
			a[4] += a[27];
			a[27] -= xr;
			xr = a[5];
			a[5] += a[26];
			a[26] -= xr;
			xr = a[20];
			a[20] += a[11];
			a[11] -= xr;
			xr = a[21];
			a[21] += a[10];
			a[10] -= xr;
			xr = a[12];
			a[12] += a[19];
			a[19] -= xr;
			xr = a[13];
			a[13] += a[18];
			a[18] -= xr;
			xr = a[28];
			a[28] += a[3];
			a[3] -= xr;
			xr = a[29];
			a[29] += a[2];
			a[2] -= xr;
		}
	}

	/**
	 * Function: Calculation of the MDCT In the case of long blocks (type 0,1,3)
	 * there are 36 coefficents in the time domain and 18 in the frequency
	 * domain.<BR>
	 * In the case of short blocks (type 2) there are 3 transformations with
	 * short length. This leads to 12 coefficents in the time and 6 in the
	 * frequency domain. In this case the results are stored side by side in the
	 * vector out[].
	 *
	 * New layer3
	 */
	function mdct_short(inout, inoutPos) {
		for (var l = 0; l < 3; l++) {
			var tc0, tc1, tc2, ts0, ts1, ts2;

			ts0 = inout[inoutPos + 2 * 3] * win[Encoder_1.SHORT_TYPE][0]
					- inout[inoutPos + 5 * 3];
			tc0 = inout[inoutPos + 0 * 3] * win[Encoder_1.SHORT_TYPE][2]
					- inout[inoutPos + 3 * 3];
			tc1 = ts0 + tc0;
			tc2 = ts0 - tc0;

			ts0 = inout[inoutPos + 5 * 3] * win[Encoder_1.SHORT_TYPE][0]
					+ inout[inoutPos + 2 * 3];
			tc0 = inout[inoutPos + 3 * 3] * win[Encoder_1.SHORT_TYPE][2]
					+ inout[inoutPos + 0 * 3];
			ts1 = ts0 + tc0;
			ts2 = -ts0 + tc0;

			tc0 = (inout[inoutPos + 1 * 3] * win[Encoder_1.SHORT_TYPE][1] - inout[inoutPos + 4 * 3]) * 2.069978111953089e-11;
			/*
			 * tritab_s [ 1 ]
			 */
			ts0 = (inout[inoutPos + 4 * 3] * win[Encoder_1.SHORT_TYPE][1] + inout[inoutPos + 1 * 3]) * 2.069978111953089e-11;
			/*
			 * tritab_s [ 1 ]
			 */
			inout[inoutPos + 3 * 0] = tc1 * 1.907525191737280e-11 + tc0;
			/*
			 * tritab_s[ 2 ]
			 */
			inout[inoutPos + 3 * 5] = -ts1 * 1.907525191737280e-11 + ts0;
			/*
			 * tritab_s[0 ]
			 */
			tc2 = tc2 * 0.86602540378443870761 * 1.907525191737281e-11;
			/*
			 * tritab_s[ 2]
			 */
			ts1 = ts1 * 0.5 * 1.907525191737281e-11 + ts0;
			inout[inoutPos + 3 * 1] = tc2 - ts1;
			inout[inoutPos + 3 * 2] = tc2 + ts1;

			tc1 = tc1 * 0.5 * 1.907525191737281e-11 - tc0;
			ts2 = ts2 * 0.86602540378443870761 * 1.907525191737281e-11;
			/*
			 * tritab_s[ 0]
			 */
			inout[inoutPos + 3 * 3] = tc1 + ts2;
			inout[inoutPos + 3 * 4] = tc1 - ts2;

			inoutPos++;
		}
	}

	function mdct_long(out, outPos, _in) {
		var ct, st;
		{
			var tc1, tc2, tc3, tc4, ts5, ts6, ts7, ts8;
			/* 1,2, 5,6, 9,10, 13,14, 17 */
			tc1 = _in[17] - _in[9];
			tc3 = _in[15] - _in[11];
			tc4 = _in[14] - _in[12];
			ts5 = _in[0] + _in[8];
			ts6 = _in[1] + _in[7];
			ts7 = _in[2] + _in[6];
			ts8 = _in[3] + _in[5];

			out[outPos + 17] = (ts5 + ts7 - ts8) - (ts6 - _in[4]);
			st = (ts5 + ts7 - ts8) * cx[12 + 7] + (ts6 - _in[4]);
			ct = (tc1 - tc3 - tc4) * cx[12 + 6];
			out[outPos + 5] = ct + st;
			out[outPos + 6] = ct - st;

			tc2 = (_in[16] - _in[10]) * cx[12 + 6];
			ts6 = ts6 * cx[12 + 7] + _in[4];
			ct = tc1 * cx[12 + 0] + tc2 + tc3 * cx[12 + 1] + tc4 * cx[12 + 2];
			st = -ts5 * cx[12 + 4] + ts6 - ts7 * cx[12 + 5] + ts8 * cx[12 + 3];
			out[outPos + 1] = ct + st;
			out[outPos + 2] = ct - st;

			ct = tc1 * cx[12 + 1] - tc2 - tc3 * cx[12 + 2] + tc4 * cx[12 + 0];
			st = -ts5 * cx[12 + 5] + ts6 - ts7 * cx[12 + 3] + ts8 * cx[12 + 4];
			out[outPos + 9] = ct + st;
			out[outPos + 10] = ct - st;

			ct = tc1 * cx[12 + 2] - tc2 + tc3 * cx[12 + 0] - tc4 * cx[12 + 1];
			st = ts5 * cx[12 + 3] - ts6 + ts7 * cx[12 + 4] - ts8 * cx[12 + 5];
			out[outPos + 13] = ct + st;
			out[outPos + 14] = ct - st;
		}
		{
			var ts1, ts2, ts3, ts4, tc5, tc6, tc7, tc8;

			ts1 = _in[8] - _in[0];
			ts3 = _in[6] - _in[2];
			ts4 = _in[5] - _in[3];
			tc5 = _in[17] + _in[9];
			tc6 = _in[16] + _in[10];
			tc7 = _in[15] + _in[11];
			tc8 = _in[14] + _in[12];

			out[outPos + 0] = (tc5 + tc7 + tc8) + (tc6 + _in[13]);
			ct = (tc5 + tc7 + tc8) * cx[12 + 7] - (tc6 + _in[13]);
			st = (ts1 - ts3 + ts4) * cx[12 + 6];
			out[outPos + 11] = ct + st;
			out[outPos + 12] = ct - st;

			ts2 = (_in[7] - _in[1]) * cx[12 + 6];
			tc6 = _in[13] - tc6 * cx[12 + 7];
			ct = tc5 * cx[12 + 3] - tc6 + tc7 * cx[12 + 4] + tc8 * cx[12 + 5];
			st = ts1 * cx[12 + 2] + ts2 + ts3 * cx[12 + 0] + ts4 * cx[12 + 1];
			out[outPos + 3] = ct + st;
			out[outPos + 4] = ct - st;

			ct = -tc5 * cx[12 + 5] + tc6 - tc7 * cx[12 + 3] - tc8 * cx[12 + 4];
			st = ts1 * cx[12 + 1] + ts2 - ts3 * cx[12 + 2] - ts4 * cx[12 + 0];
			out[outPos + 7] = ct + st;
			out[outPos + 8] = ct - st;

			ct = -tc5 * cx[12 + 4] + tc6 - tc7 * cx[12 + 5] - tc8 * cx[12 + 3];
			st = ts1 * cx[12 + 0] - ts2 + ts3 * cx[12 + 1] - ts4 * cx[12 + 2];
			out[outPos + 15] = ct + st;
			out[outPos + 16] = ct - st;
		}
	}

	this.mdct_sub48 = function(gfc, w0, w1) {
		var wk = w0;
		var wkPos = 286;
		/* thinking cache performance, ch->gr loop is better than gr->ch loop */
		for (var ch = 0; ch < gfc.channels_out; ch++) {
			for (var gr = 0; gr < gfc.mode_gr; gr++) {
				var band;
				var gi = (gfc.l3_side.tt[gr][ch]);
				var mdct_enc = gi.xr;
				var mdct_encPos = 0;
				var samp = gfc.sb_sample[ch][1 - gr];
				var sampPos = 0;

				for (var k = 0; k < 18 / 2; k++) {
					window_subband(wk, wkPos, samp[sampPos]);
					window_subband(wk, wkPos + 32, samp[sampPos + 1]);
					sampPos += 2;
					wkPos += 64;
					/*
					 * Compensate for inversion in the analysis filter
					 */
					for (band = 1; band < 32; band += 2) {
						samp[sampPos - 1][band] *= -1;
					}
				}

				/*
				 * Perform imdct of 18 previous subband samples + 18 current
				 * subband samples
				 */
				for (band = 0; band < 32; band++, mdct_encPos += 18) {
					var type = gi.block_type;
					var band0 = gfc.sb_sample[ch][gr];
					var band1 = gfc.sb_sample[ch][1 - gr];
					if (gi.mixed_block_flag != 0 && band < 2)
						type = 0;
					if (gfc.amp_filter[band] < 1e-12) {
						Arrays$6.fill(mdct_enc, mdct_encPos + 0,
								mdct_encPos + 18, 0);
					} else {
						if (gfc.amp_filter[band] < 1.0) {
							for (var k = 0; k < 18; k++)
								band1[k][order[band]] *= gfc.amp_filter[band];
						}
						if (type == Encoder_1.SHORT_TYPE) {
							for (var k = -NS / 4; k < 0; k++) {
								var w = win[Encoder_1.SHORT_TYPE][k + 3];
								mdct_enc[mdct_encPos + k * 3 + 9] = band0[9 + k][order[band]]
										* w - band0[8 - k][order[band]];
								mdct_enc[mdct_encPos + k * 3 + 18] = band0[14 - k][order[band]]
										* w + band0[15 + k][order[band]];
								mdct_enc[mdct_encPos + k * 3 + 10] = band0[15 + k][order[band]]
										* w - band0[14 - k][order[band]];
								mdct_enc[mdct_encPos + k * 3 + 19] = band1[2 - k][order[band]]
										* w + band1[3 + k][order[band]];
								mdct_enc[mdct_encPos + k * 3 + 11] = band1[3 + k][order[band]]
										* w - band1[2 - k][order[band]];
								mdct_enc[mdct_encPos + k * 3 + 20] = band1[8 - k][order[band]]
										* w + band1[9 + k][order[band]];
							}
							mdct_short(mdct_enc, mdct_encPos);
						} else {
							var work = new_float$6(18);
							for (var k = -NL / 4; k < 0; k++) {
								var a, b;
								a = win[type][k + 27]
										* band1[k + 9][order[band]]
										+ win[type][k + 36]
										* band1[8 - k][order[band]];
								b = win[type][k + 9]
										* band0[k + 9][order[band]]
										- win[type][k + 18]
										* band0[8 - k][order[band]];
								work[k + 9] = a - b * tantab_l[3 + k + 9];
								work[k + 18] = a * tantab_l[3 + k + 9] + b;
							}

							mdct_long(mdct_enc, mdct_encPos, work);
						}
					}
					/*
					 * Perform aliasing reduction butterfly
					 */
					if (type != Encoder_1.SHORT_TYPE && band != 0) {
						for (var k = 7; k >= 0; --k) {
							var bu, bd;
							bu = mdct_enc[mdct_encPos + k] * ca[20 + k]
									+ mdct_enc[mdct_encPos + -1 - k]
									* cs[28 + k];
							bd = mdct_enc[mdct_encPos + k] * cs[28 + k]
									- mdct_enc[mdct_encPos + -1 - k]
									* ca[20 + k];

							mdct_enc[mdct_encPos + -1 - k] = bu;
							mdct_enc[mdct_encPos + k] = bd;
						}
					}
				}
			}
			wk = w1;
			wkPos = 286;
			if (gfc.mode_gr == 1) {
				for (var i = 0; i < 18; i++) {
					System$6.arraycopy(gfc.sb_sample[ch][1][i], 0,
							gfc.sb_sample[ch][0][i], 0, 32);
				}
			}
		}
	};
}

var NewMDCT_1 = NewMDCT;

var System$7 = common.System;
var new_float$7 = common.new_float;
var new_float_n$7 = common.new_float_n;
function III_psy_xmin() {
    this.l = new_float$7(Encoder_1.SBMAX_l);
    this.s = new_float_n$7([Encoder_1.SBMAX_s, 3]);

    var self = this;
    this.assign = function (iii_psy_xmin) {
        System$7.arraycopy(iii_psy_xmin.l, 0, self.l, 0, Encoder_1.SBMAX_l);
        for (var i = 0; i < Encoder_1.SBMAX_s; i++) {
            for (var j = 0; j < 3; j++) {
                self.s[i][j] = iii_psy_xmin.s[i][j];
            }
        }
    };
}

var III_psy_xmin_1 = III_psy_xmin;

//package mp3;



function III_psy_ratio() {
	this.thm = new III_psy_xmin_1();
	this.en = new III_psy_xmin_1();
}

var III_psy_ratio_1 = III_psy_ratio;

var System$5 = common.System;
var VbrMode$5 = common.VbrMode;
var new_array_n$5 = common.new_array_n;
var new_float$5 = common.new_float;
var new_float_n$5 = common.new_float_n;
var new_int$5 = common.new_int;
var assert$5 = common.assert;

/**
 * ENCDELAY The encoder delay.
 *
 * Minimum allowed is MDCTDELAY (see below)
 *
 * The first 96 samples will be attenuated, so using a value less than 96
 * will result in corrupt data for the first 96-ENCDELAY samples.
 *
 * suggested: 576 set to 1160 to sync with FhG.
 */
Encoder$2.ENCDELAY = 576;
/**
 * make sure there is at least one complete frame after the last frame
 * containing real data
 *
 * Using a value of 288 would be sufficient for a a very sophisticated
 * decoder that can decode granule-by-granule instead of frame by frame. But
 * lets not assume this, and assume the decoder will not decode frame N
 * unless it also has data for frame N+1
 */
Encoder$2.POSTDELAY = 1152;

/**
 * delay of the MDCT used in mdct.c original ISO routines had a delay of
 * 528! Takehiro's routines:
 */
Encoder$2.MDCTDELAY = 48;
Encoder$2.FFTOFFSET = (224 + Encoder$2.MDCTDELAY);

/**
 * Most decoders, including the one we use, have a delay of 528 samples.
 */
Encoder$2.DECDELAY = 528;

/**
 * number of subbands
 */
Encoder$2.SBLIMIT = 32;

/**
 * parition bands bands
 */
Encoder$2.CBANDS = 64;

/**
 * number of critical bands/scale factor bands where masking is computed
 */
Encoder$2.SBPSY_l = 21;
Encoder$2.SBPSY_s = 12;

/**
 * total number of scalefactor bands encoded
 */
Encoder$2.SBMAX_l = 22;
Encoder$2.SBMAX_s = 13;
Encoder$2.PSFB21 = 6;
Encoder$2.PSFB12 = 6;

/**
 * FFT sizes
 */
Encoder$2.BLKSIZE = 1024;
Encoder$2.HBLKSIZE = (Encoder$2.BLKSIZE / 2 + 1);
Encoder$2.BLKSIZE_s = 256;
Encoder$2.HBLKSIZE_s = (Encoder$2.BLKSIZE_s / 2 + 1);

Encoder$2.NORM_TYPE = 0;
Encoder$2.START_TYPE = 1;
Encoder$2.SHORT_TYPE = 2;
Encoder$2.STOP_TYPE = 3;

/**
 * <PRE>
 * Mode Extention:
 * When we are in stereo mode, there are 4 possible methods to store these
 * two channels. The stereo modes -m? are using a subset of them.
 *
 *  -ms: MPG_MD_LR_LR
 *  -mj: MPG_MD_LR_LR and MPG_MD_MS_LR
 *  -mf: MPG_MD_MS_LR
 *  -mi: all
 * </PRE>
 */
Encoder$2.MPG_MD_LR_LR = 0;
Encoder$2.MPG_MD_LR_I = 1;
Encoder$2.MPG_MD_MS_LR = 2;
Encoder$2.MPG_MD_MS_I = 3;

Encoder$2.fircoef = [-0.0207887 * 5, -0.0378413 * 5,
    -0.0432472 * 5, -0.031183 * 5, 7.79609e-18 * 5, 0.0467745 * 5,
    0.10091 * 5, 0.151365 * 5, 0.187098 * 5];

function Encoder$2() {
    var NewMDCT = NewMDCT_1;
    var III_psy_ratio = III_psy_ratio_1;

    var FFTOFFSET = Encoder$2.FFTOFFSET;
    var MPG_MD_MS_LR = Encoder$2.MPG_MD_MS_LR;
    //BitStream bs;
    //PsyModel psy;
    //VBRTag vbr;
    //QuantizePVT qupvt;
    var bs = null;
    this.psy = null;
    var psy = null;
    var vbr = null;
    var qupvt = null;

    //public final void setModules(BitStream bs, PsyModel psy, QuantizePVT qupvt,
    //    VBRTag vbr) {
    this.setModules = function (_bs, _psy, _qupvt, _vbr) {
        bs = _bs;
        this.psy = _psy;
        psy = _psy;
        vbr = _vbr;
        qupvt = _qupvt;
    };

    var newMDCT = new NewMDCT();

    /***********************************************************************
     *
     * encoder and decoder delays
     *
     ***********************************************************************/

    /**
     * <PRE>
     * layer III enc->dec delay:  1056 (1057?)   (observed)
     * layer  II enc->dec delay:   480  (481?)   (observed)
     *
     * polyphase 256-16             (dec or enc)        = 240
     * mdct      256+32  (9*32)     (dec or enc)        = 288
     * total:    512+16
     *
     * My guess is that delay of polyphase filterbank is actualy 240.5
     * (there are technical reasons for this, see postings in mp3encoder).
     * So total Encode+Decode delay = ENCDELAY + 528 + 1
     * </PRE>
     */


    /**
     * auto-adjust of ATH, useful for low volume Gabriel Bouvigne 3 feb 2001
     *
     * modifies some values in gfp.internal_flags.ATH (gfc.ATH)
     */
//private void adjust_ATH(final LameInternalFlags gfc) {
    function adjust_ATH(gfc) {
        var gr2_max, max_pow;

        if (gfc.ATH.useAdjust == 0) {
            gfc.ATH.adjust = 1.0;
            /* no adjustment */
            return;
        }

        /* jd - 2001 mar 12, 27, jun 30 */
        /* loudness based on equal loudness curve; */
        /* use granule with maximum combined loudness */
        max_pow = gfc.loudness_sq[0][0];
        gr2_max = gfc.loudness_sq[1][0];
        if (gfc.channels_out == 2) {
            max_pow += gfc.loudness_sq[0][1];
            gr2_max += gfc.loudness_sq[1][1];
        } else {
            max_pow += max_pow;
            gr2_max += gr2_max;
        }
        if (gfc.mode_gr == 2) {
            max_pow = Math.max(max_pow, gr2_max);
        }
        max_pow *= 0.5;
        /* max_pow approaches 1.0 for full band noise */

        /* jd - 2001 mar 31, jun 30 */
        /* user tuning of ATH adjustment region */
        max_pow *= gfc.ATH.aaSensitivityP;

        /*
         * adjust ATH depending on range of maximum value
         */

        /* jd - 2001 feb27, mar12,20, jun30, jul22 */
        /* continuous curves based on approximation */
        /* to GB's original values. */
        /* For an increase in approximate loudness, */
        /* set ATH adjust to adjust_limit immediately */
        /* after a delay of one frame. */
        /* For a loudness decrease, reduce ATH adjust */
        /* towards adjust_limit gradually. */
        /* max_pow is a loudness squared or a power. */
        if (max_pow > 0.03125) { /* ((1 - 0.000625)/ 31.98) from curve below */
            if (gfc.ATH.adjust >= 1.0) {
                gfc.ATH.adjust = 1.0;
            } else {
                /* preceding frame has lower ATH adjust; */
                /* ascend only to the preceding adjust_limit */
                /* in case there is leading low volume */
                if (gfc.ATH.adjust < gfc.ATH.adjustLimit) {
                    gfc.ATH.adjust = gfc.ATH.adjustLimit;
                }
            }
            gfc.ATH.adjustLimit = 1.0;
        } else { /* adjustment curve */
            /* about 32 dB maximum adjust (0.000625) */
            var adj_lim_new = 31.98 * max_pow + 0.000625;
            if (gfc.ATH.adjust >= adj_lim_new) { /* descend gradually */
                gfc.ATH.adjust *= adj_lim_new * 0.075 + 0.925;
                if (gfc.ATH.adjust < adj_lim_new) { /* stop descent */
                    gfc.ATH.adjust = adj_lim_new;
                }
            } else { /* ascend */
                if (gfc.ATH.adjustLimit >= adj_lim_new) {
                    gfc.ATH.adjust = adj_lim_new;
                } else {
                    /* preceding frame has lower ATH adjust; */
                    /* ascend only to the preceding adjust_limit */
                    if (gfc.ATH.adjust < gfc.ATH.adjustLimit) {
                        gfc.ATH.adjust = gfc.ATH.adjustLimit;
                    }
                }
            }
            gfc.ATH.adjustLimit = adj_lim_new;
        }
    }

    /**
     * <PRE>
     *  some simple statistics
     *
     *  bitrate index 0: free bitrate . not allowed in VBR mode
     *  : bitrates, kbps depending on MPEG version
     *  bitrate index 15: forbidden
     *
     *  mode_ext:
     *  0:  LR
     *  1:  LR-i
     *  2:  MS
     *  3:  MS-i
     * </PRE>
     */
    function updateStats(gfc) {
        var gr, ch;
        assert$5(0 <= gfc.bitrate_index && gfc.bitrate_index < 16);
        assert$5(0 <= gfc.mode_ext && gfc.mode_ext < 4);

        /* count bitrate indices */
        gfc.bitrate_stereoMode_Hist[gfc.bitrate_index][4]++;
        gfc.bitrate_stereoMode_Hist[15][4]++;

        /* count 'em for every mode extension in case of 2 channel encoding */
        if (gfc.channels_out == 2) {
            gfc.bitrate_stereoMode_Hist[gfc.bitrate_index][gfc.mode_ext]++;
            gfc.bitrate_stereoMode_Hist[15][gfc.mode_ext]++;
        }
        for (gr = 0; gr < gfc.mode_gr; ++gr) {
            for (ch = 0; ch < gfc.channels_out; ++ch) {
                var bt = gfc.l3_side.tt[gr][ch].block_type | 0;
                if (gfc.l3_side.tt[gr][ch].mixed_block_flag != 0)
                    bt = 4;
                gfc.bitrate_blockType_Hist[gfc.bitrate_index][bt]++;
                gfc.bitrate_blockType_Hist[gfc.bitrate_index][5]++;
                gfc.bitrate_blockType_Hist[15][bt]++;
                gfc.bitrate_blockType_Hist[15][5]++;
            }
        }
    }

    function lame_encode_frame_init(gfp, inbuf) {
        var gfc = gfp.internal_flags;

        var ch, gr;

        if (gfc.lame_encode_frame_init == 0) {
            /* prime the MDCT/polyphase filterbank with a short block */
            var i, j;
            var primebuff0 = new_float$5(286 + 1152 + 576);
            var primebuff1 = new_float$5(286 + 1152 + 576);
            gfc.lame_encode_frame_init = 1;
            for (i = 0, j = 0; i < 286 + 576 * (1 + gfc.mode_gr); ++i) {
                if (i < 576 * gfc.mode_gr) {
                    primebuff0[i] = 0;
                    if (gfc.channels_out == 2)
                        primebuff1[i] = 0;
                } else {
                    primebuff0[i] = inbuf[0][j];
                    if (gfc.channels_out == 2)
                        primebuff1[i] = inbuf[1][j];
                    ++j;
                }
            }
            /* polyphase filtering / mdct */
            for (gr = 0; gr < gfc.mode_gr; gr++) {
                for (ch = 0; ch < gfc.channels_out; ch++) {
                    gfc.l3_side.tt[gr][ch].block_type = Encoder$2.SHORT_TYPE;
                }
            }
            newMDCT.mdct_sub48(gfc, primebuff0, primebuff1);

            /* check FFT will not use a negative starting offset */
            assert$5(576 >= Encoder$2.FFTOFFSET);
            /* check if we have enough data for FFT */
            assert$5(gfc.mf_size >= (Encoder$2.BLKSIZE + gfp.framesize - Encoder$2.FFTOFFSET));
            /* check if we have enough data for polyphase filterbank */
            assert$5(gfc.mf_size >= (512 + gfp.framesize - 32));
        }

    }

    /**
     * <PRE>
     * encodeframe()           Layer 3
     *
     * encode a single frame
     *
     *
     *    lame_encode_frame()
     *
     *
     *                           gr 0            gr 1
     *    inbuf:           |--------------|--------------|--------------|
     *
     *
     *    Polyphase (18 windows, each shifted 32)
     *    gr 0:
     *    window1          <----512---.
     *    window18                 <----512---.
     *
     *    gr 1:
     *    window1                         <----512---.
     *    window18                                <----512---.
     *
     *
     *
     *    MDCT output:  |--------------|--------------|--------------|
     *
     *    FFT's                    <---------1024---------.
     *                                             <---------1024-------.
     *
     *
     *
     *        inbuf = buffer of PCM data size=MP3 framesize
     *        encoder acts on inbuf[ch][0], but output is delayed by MDCTDELAY
     *        so the MDCT coefficints are from inbuf[ch][-MDCTDELAY]
     *
     *        psy-model FFT has a 1 granule delay, so we feed it data for the
     *        next granule.
     *        FFT is centered over granule:  224+576+224
     *        So FFT starts at:   576-224-MDCTDELAY
     *
     *        MPEG2:  FFT ends at:  BLKSIZE+576-224-MDCTDELAY      (1328)
     *        MPEG1:  FFT ends at:  BLKSIZE+2*576-224-MDCTDELAY    (1904)
     *
     *        MPEG2:  polyphase first window:  [0..511]
     *                          18th window:   [544..1055]          (1056)
     *        MPEG1:            36th window:   [1120..1631]         (1632)
     *                data needed:  512+framesize-32
     *
     *        A close look newmdct.c shows that the polyphase filterbank
     *        only uses data from [0..510] for each window.  Perhaps because the window
     *        used by the filterbank is zero for the last point, so Takehiro's
     *        code doesn't bother to compute with it.
     *
     *        FFT starts at 576-224-MDCTDELAY (304)  = 576-FFTOFFSET
     *
     * </PRE>
     */


    this.lame_encode_mp3_frame = function (gfp, inbuf_l, inbuf_r, mp3buf, mp3bufPos, mp3buf_size) {
        var mp3count;
        var masking_LR = new_array_n$5([2, 2]);
        /*
         * LR masking &
         * energy
         */
        masking_LR[0][0] = new III_psy_ratio();
        masking_LR[0][1] = new III_psy_ratio();
        masking_LR[1][0] = new III_psy_ratio();
        masking_LR[1][1] = new III_psy_ratio();
        var masking_MS = new_array_n$5([2, 2]);
        /* MS masking & energy */
        masking_MS[0][0] = new III_psy_ratio();
        masking_MS[0][1] = new III_psy_ratio();
        masking_MS[1][0] = new III_psy_ratio();
        masking_MS[1][1] = new III_psy_ratio();
        //III_psy_ratio masking[][];
        var masking;
        /* pointer to selected maskings */
        var inbuf = [null, null];
        var gfc = gfp.internal_flags;

        var tot_ener = new_float_n$5([2, 4]);
        var ms_ener_ratio = [.5, .5];
        var pe = [[0., 0.], [0., 0.]];
        var pe_MS = [[0., 0.], [0., 0.]];

//float[][] pe_use;
        var pe_use;

        var ch, gr;

        inbuf[0] = inbuf_l;
        inbuf[1] = inbuf_r;

        if (gfc.lame_encode_frame_init == 0) {
            /* first run? */
            lame_encode_frame_init(gfp, inbuf);

        }

        /********************** padding *****************************/
        /**
         * <PRE>
         * padding method as described in
         * "MPEG-Layer3 / Bitstream Syntax and Decoding"
         * by Martin Sieler, Ralph Sperschneider
         *
         * note: there is no padding for the very first frame
         *
         * Robert Hegemann 2000-06-22
         * </PRE>
         */
        gfc.padding = 0;
        if ((gfc.slot_lag -= gfc.frac_SpF) < 0) {
            gfc.slot_lag += gfp.out_samplerate;
            gfc.padding = 1;
        }

        /****************************************
         * Stage 1: psychoacoustic model *
         ****************************************/

        if (gfc.psymodel != 0) {
            /*
             * psychoacoustic model psy model has a 1 granule (576) delay that
             * we must compensate for (mt 6/99).
             */
            var ret;
            var bufp = [null, null];
            /* address of beginning of left & right granule */
            var bufpPos = 0;
            /* address of beginning of left & right granule */
            var blocktype = new_int$5(2);

            for (gr = 0; gr < gfc.mode_gr; gr++) {

                for (ch = 0; ch < gfc.channels_out; ch++) {
                    bufp[ch] = inbuf[ch];
                    bufpPos = 576 + gr * 576 - Encoder$2.FFTOFFSET;
                }
                if (gfp.VBR == VbrMode$5.vbr_mtrh || gfp.VBR == VbrMode$5.vbr_mt) {
                    ret = psy.L3psycho_anal_vbr(gfp, bufp, bufpPos, gr,
                        masking_LR, masking_MS, pe[gr], pe_MS[gr],
                        tot_ener[gr], blocktype);
                } else {
                    ret = psy.L3psycho_anal_ns(gfp, bufp, bufpPos, gr,
                        masking_LR, masking_MS, pe[gr], pe_MS[gr],
                        tot_ener[gr], blocktype);
                }
                if (ret != 0)
                    return -4;

                if (gfp.mode == MPEGMode.JOINT_STEREO) {
                    ms_ener_ratio[gr] = tot_ener[gr][2] + tot_ener[gr][3];
                    if (ms_ener_ratio[gr] > 0)
                        ms_ener_ratio[gr] = tot_ener[gr][3] / ms_ener_ratio[gr];
                }

                /* block type flags */
                for (ch = 0; ch < gfc.channels_out; ch++) {
                    var cod_info = gfc.l3_side.tt[gr][ch];
                    cod_info.block_type = blocktype[ch];
                    cod_info.mixed_block_flag = 0;
                }
            }
        } else {
            /* no psy model */
            for (gr = 0; gr < gfc.mode_gr; gr++)
                for (ch = 0; ch < gfc.channels_out; ch++) {
                    gfc.l3_side.tt[gr][ch].block_type = Encoder$2.NORM_TYPE;
                    gfc.l3_side.tt[gr][ch].mixed_block_flag = 0;
                    pe_MS[gr][ch] = pe[gr][ch] = 700;
                }
        }

        /* auto-adjust of ATH, useful for low volume */
        adjust_ATH(gfc);

        /****************************************
         * Stage 2: MDCT *
         ****************************************/

        /* polyphase filtering / mdct */
        newMDCT.mdct_sub48(gfc, inbuf[0], inbuf[1]);

        /****************************************
         * Stage 3: MS/LR decision *
         ****************************************/

        /* Here will be selected MS or LR coding of the 2 stereo channels */
        gfc.mode_ext = Encoder$2.MPG_MD_LR_LR;

        if (gfp.force_ms) {
            gfc.mode_ext = Encoder$2.MPG_MD_MS_LR;
        } else if (gfp.mode == MPEGMode.JOINT_STEREO) {
            /*
             * ms_ratio = is scaled, for historical reasons, to look like a
             * ratio of side_channel / total. 0 = signal is 100% mono .5 = L & R
             * uncorrelated
             */

            /**
             * <PRE>
             * [0] and [1] are the results for the two granules in MPEG-1,
             * in MPEG-2 it's only a faked averaging of the same value
             * _prev is the value of the last granule of the previous frame
             * _next is the value of the first granule of the next frame
             * </PRE>
             */

            var sum_pe_MS = 0.;
            var sum_pe_LR = 0.;
            for (gr = 0; gr < gfc.mode_gr; gr++) {
                for (ch = 0; ch < gfc.channels_out; ch++) {
                    sum_pe_MS += pe_MS[gr][ch];
                    sum_pe_LR += pe[gr][ch];
                }
            }

            /* based on PE: M/S coding would not use much more bits than L/R */
            if (sum_pe_MS <= 1.00 * sum_pe_LR) {

                var gi0 = gfc.l3_side.tt[0];
                var gi1 = gfc.l3_side.tt[gfc.mode_gr - 1];

                if (gi0[0].block_type == gi0[1].block_type
                    && gi1[0].block_type == gi1[1].block_type) {

                    gfc.mode_ext = Encoder$2.MPG_MD_MS_LR;
                }
            }
        }

        /* bit and noise allocation */
        if (gfc.mode_ext == MPG_MD_MS_LR) {
            masking = masking_MS;
            /* use MS masking */
            pe_use = pe_MS;
        } else {
            masking = masking_LR;
            /* use LR masking */
            pe_use = pe;
        }

        /* copy data for MP3 frame analyzer */
        if (gfp.analysis && gfc.pinfo != null) {
            for (gr = 0; gr < gfc.mode_gr; gr++) {
                for (ch = 0; ch < gfc.channels_out; ch++) {
                    gfc.pinfo.ms_ratio[gr] = gfc.ms_ratio[gr];
                    gfc.pinfo.ms_ener_ratio[gr] = ms_ener_ratio[gr];
                    gfc.pinfo.blocktype[gr][ch] = gfc.l3_side.tt[gr][ch].block_type;
                    gfc.pinfo.pe[gr][ch] = pe_use[gr][ch];
                    System$5.arraycopy(gfc.l3_side.tt[gr][ch].xr, 0,
                        gfc.pinfo.xr[gr][ch], 0, 576);
                    /*
                     * in psymodel, LR and MS data was stored in pinfo. switch
                     * to MS data:
                     */
                    if (gfc.mode_ext == MPG_MD_MS_LR) {
                        gfc.pinfo.ers[gr][ch] = gfc.pinfo.ers[gr][ch + 2];
                        System$5.arraycopy(gfc.pinfo.energy[gr][ch + 2], 0,
                            gfc.pinfo.energy[gr][ch], 0,
                            gfc.pinfo.energy[gr][ch].length);
                    }
                }
            }
        }

        /****************************************
         * Stage 4: quantization loop *
         ****************************************/

        if (gfp.VBR == VbrMode$5.vbr_off || gfp.VBR == VbrMode$5.vbr_abr) {

            var i;
            var f;

            for (i = 0; i < 18; i++)
                gfc.nsPsy.pefirbuf[i] = gfc.nsPsy.pefirbuf[i + 1];

            f = 0.0;
            for (gr = 0; gr < gfc.mode_gr; gr++)
                for (ch = 0; ch < gfc.channels_out; ch++)
                    f += pe_use[gr][ch];
            gfc.nsPsy.pefirbuf[18] = f;

            f = gfc.nsPsy.pefirbuf[9];
            for (i = 0; i < 9; i++)
                f += (gfc.nsPsy.pefirbuf[i] + gfc.nsPsy.pefirbuf[18 - i])
                    * Encoder$2.fircoef[i];

            f = (670 * 5 * gfc.mode_gr * gfc.channels_out) / f;
            for (gr = 0; gr < gfc.mode_gr; gr++) {
                for (ch = 0; ch < gfc.channels_out; ch++) {
                    pe_use[gr][ch] *= f;
                }
            }
        }
        gfc.iteration_loop.iteration_loop(gfp, pe_use, ms_ener_ratio, masking);

        /****************************************
         * Stage 5: bitstream formatting *
         ****************************************/

        /* write the frame to the bitstream */
        bs.format_bitstream(gfp);

        /* copy mp3 bit buffer into array */
        mp3count = bs.copy_buffer(gfc, mp3buf, mp3bufPos, mp3buf_size, 1);

        if (gfp.bWriteVbrTag)
            vbr.addVbrFrame(gfp);

        if (gfp.analysis && gfc.pinfo != null) {
            for (ch = 0; ch < gfc.channels_out; ch++) {
                var j;
                for (j = 0; j < FFTOFFSET; j++)
                    gfc.pinfo.pcmdata[ch][j] = gfc.pinfo.pcmdata[ch][j
                    + gfp.framesize];
                for (j = FFTOFFSET; j < 1600; j++) {
                    gfc.pinfo.pcmdata[ch][j] = inbuf[ch][j - FFTOFFSET];
                }
            }
            qupvt.set_frame_pinfo(gfp, masking);
        }

        updateStats(gfc);

        return mp3count;
    };
}


var Encoder_1 = Encoder$2;

var Util$4 = common.Util;
var new_float$4 = common.new_float;
function FFT() {

    var window = new_float$4(Encoder_1.BLKSIZE);
    var window_s = new_float$4(Encoder_1.BLKSIZE_s / 2);

    var costab = [
        9.238795325112867e-01, 3.826834323650898e-01,
        9.951847266721969e-01, 9.801714032956060e-02,
        9.996988186962042e-01, 2.454122852291229e-02,
        9.999811752826011e-01, 6.135884649154475e-03
    ];

    function fht(fz, fzPos, n) {
        var tri = 0;
        var k4;
        var fi;
        var gi;

        n <<= 1;
        /* to get BLKSIZE, because of 3DNow! ASM routine */
        var fn = fzPos + n;
        k4 = 4;
        do {
            var s1, c1;
            var i, k1, k2, k3, kx;
            kx = k4 >> 1;
            k1 = k4;
            k2 = k4 << 1;
            k3 = k2 + k1;
            k4 = k2 << 1;
            fi = fzPos;
            gi = fi + kx;
            do {
                var f0, f1, f2, f3;
                f1 = fz[fi + 0] - fz[fi + k1];
                f0 = fz[fi + 0] + fz[fi + k1];
                f3 = fz[fi + k2] - fz[fi + k3];
                f2 = fz[fi + k2] + fz[fi + k3];
                fz[fi + k2] = f0 - f2;
                fz[fi + 0] = f0 + f2;
                fz[fi + k3] = f1 - f3;
                fz[fi + k1] = f1 + f3;
                f1 = fz[gi + 0] - fz[gi + k1];
                f0 = fz[gi + 0] + fz[gi + k1];
                f3 = (Util$4.SQRT2 * fz[gi + k3]);
                f2 = (Util$4.SQRT2 * fz[gi + k2]);
                fz[gi + k2] = f0 - f2;
                fz[gi + 0] = f0 + f2;
                fz[gi + k3] = f1 - f3;
                fz[gi + k1] = f1 + f3;
                gi += k4;
                fi += k4;
            } while (fi < fn);
            c1 = costab[tri + 0];
            s1 = costab[tri + 1];
            for (i = 1; i < kx; i++) {
                var c2, s2;
                c2 = 1 - (2 * s1) * s1;
                s2 = (2 * s1) * c1;
                fi = fzPos + i;
                gi = fzPos + k1 - i;
                do {
                    var a, b, g0, f0, f1, g1, f2, g2, f3, g3;
                    b = s2 * fz[fi + k1] - c2 * fz[gi + k1];
                    a = c2 * fz[fi + k1] + s2 * fz[gi + k1];
                    f1 = fz[fi + 0] - a;
                    f0 = fz[fi + 0] + a;
                    g1 = fz[gi + 0] - b;
                    g0 = fz[gi + 0] + b;
                    b = s2 * fz[fi + k3] - c2 * fz[gi + k3];
                    a = c2 * fz[fi + k3] + s2 * fz[gi + k3];
                    f3 = fz[fi + k2] - a;
                    f2 = fz[fi + k2] + a;
                    g3 = fz[gi + k2] - b;
                    g2 = fz[gi + k2] + b;
                    b = s1 * f2 - c1 * g3;
                    a = c1 * f2 + s1 * g3;
                    fz[fi + k2] = f0 - a;
                    fz[fi + 0] = f0 + a;
                    fz[gi + k3] = g1 - b;
                    fz[gi + k1] = g1 + b;
                    b = c1 * g2 - s1 * f3;
                    a = s1 * g2 + c1 * f3;
                    fz[gi + k2] = g0 - a;
                    fz[gi + 0] = g0 + a;
                    fz[fi + k3] = f1 - b;
                    fz[fi + k1] = f1 + b;
                    gi += k4;
                    fi += k4;
                } while (fi < fn);
                c2 = c1;
                c1 = c2 * costab[tri + 0] - s1 * costab[tri + 1];
                s1 = c2 * costab[tri + 1] + s1 * costab[tri + 0];
            }
            tri += 2;
        } while (k4 < n);
    }

    var rv_tbl = [0x00, 0x80, 0x40,
        0xc0, 0x20, 0xa0, 0x60, 0xe0, 0x10,
        0x90, 0x50, 0xd0, 0x30, 0xb0, 0x70,
        0xf0, 0x08, 0x88, 0x48, 0xc8, 0x28,
        0xa8, 0x68, 0xe8, 0x18, 0x98, 0x58,
        0xd8, 0x38, 0xb8, 0x78, 0xf8, 0x04,
        0x84, 0x44, 0xc4, 0x24, 0xa4, 0x64,
        0xe4, 0x14, 0x94, 0x54, 0xd4, 0x34,
        0xb4, 0x74, 0xf4, 0x0c, 0x8c, 0x4c,
        0xcc, 0x2c, 0xac, 0x6c, 0xec, 0x1c,
        0x9c, 0x5c, 0xdc, 0x3c, 0xbc, 0x7c,
        0xfc, 0x02, 0x82, 0x42, 0xc2, 0x22,
        0xa2, 0x62, 0xe2, 0x12, 0x92, 0x52,
        0xd2, 0x32, 0xb2, 0x72, 0xf2, 0x0a,
        0x8a, 0x4a, 0xca, 0x2a, 0xaa, 0x6a,
        0xea, 0x1a, 0x9a, 0x5a, 0xda, 0x3a,
        0xba, 0x7a, 0xfa, 0x06, 0x86, 0x46,
        0xc6, 0x26, 0xa6, 0x66, 0xe6, 0x16,
        0x96, 0x56, 0xd6, 0x36, 0xb6, 0x76,
        0xf6, 0x0e, 0x8e, 0x4e, 0xce, 0x2e,
        0xae, 0x6e, 0xee, 0x1e, 0x9e, 0x5e,
        0xde, 0x3e, 0xbe, 0x7e, 0xfe];

    this.fft_short = function (gfc, x_real, chn, buffer, bufPos) {
        for (var b = 0; b < 3; b++) {
            var x = Encoder_1.BLKSIZE_s / 2;
            var k = 0xffff & ((576 / 3) * (b + 1));
            var j = Encoder_1.BLKSIZE_s / 8 - 1;
            do {
                var f0, f1, f2, f3, w;
                var i = rv_tbl[j << 2] & 0xff;

                f0 = window_s[i] * buffer[chn][bufPos + i + k];
                w = window_s[0x7f - i] * buffer[chn][bufPos + i + k + 0x80];
                f1 = f0 - w;
                f0 = f0 + w;
                f2 = window_s[i + 0x40] * buffer[chn][bufPos + i + k + 0x40];
                w = window_s[0x3f - i] * buffer[chn][bufPos + i + k + 0xc0];
                f3 = f2 - w;
                f2 = f2 + w;

                x -= 4;
                x_real[b][x + 0] = f0 + f2;
                x_real[b][x + 2] = f0 - f2;
                x_real[b][x + 1] = f1 + f3;
                x_real[b][x + 3] = f1 - f3;

                f0 = window_s[i + 0x01] * buffer[chn][bufPos + i + k + 0x01];
                w = window_s[0x7e - i] * buffer[chn][bufPos + i + k + 0x81];
                f1 = f0 - w;
                f0 = f0 + w;
                f2 = window_s[i + 0x41] * buffer[chn][bufPos + i + k + 0x41];
                w = window_s[0x3e - i] * buffer[chn][bufPos + i + k + 0xc1];
                f3 = f2 - w;
                f2 = f2 + w;

                x_real[b][x + Encoder_1.BLKSIZE_s / 2 + 0] = f0 + f2;
                x_real[b][x + Encoder_1.BLKSIZE_s / 2 + 2] = f0 - f2;
                x_real[b][x + Encoder_1.BLKSIZE_s / 2 + 1] = f1 + f3;
                x_real[b][x + Encoder_1.BLKSIZE_s / 2 + 3] = f1 - f3;
            } while (--j >= 0);

            fht(x_real[b], x, Encoder_1.BLKSIZE_s / 2);
            /* BLKSIZE_s/2 because of 3DNow! ASM routine */
            /* BLKSIZE/2 because of 3DNow! ASM routine */
        }
    };

    this.fft_long = function (gfc, y, chn, buffer, bufPos) {
        var jj = Encoder_1.BLKSIZE / 8 - 1;
        var x = Encoder_1.BLKSIZE / 2;

        do {
            var f0, f1, f2, f3, w;
            var i = rv_tbl[jj] & 0xff;
            f0 = window[i] * buffer[chn][bufPos + i];
            w = window[i + 0x200] * buffer[chn][bufPos + i + 0x200];
            f1 = f0 - w;
            f0 = f0 + w;
            f2 = window[i + 0x100] * buffer[chn][bufPos + i + 0x100];
            w = window[i + 0x300] * buffer[chn][bufPos + i + 0x300];
            f3 = f2 - w;
            f2 = f2 + w;

            x -= 4;
            y[x + 0] = f0 + f2;
            y[x + 2] = f0 - f2;
            y[x + 1] = f1 + f3;
            y[x + 3] = f1 - f3;

            f0 = window[i + 0x001] * buffer[chn][bufPos + i + 0x001];
            w = window[i + 0x201] * buffer[chn][bufPos + i + 0x201];
            f1 = f0 - w;
            f0 = f0 + w;
            f2 = window[i + 0x101] * buffer[chn][bufPos + i + 0x101];
            w = window[i + 0x301] * buffer[chn][bufPos + i + 0x301];
            f3 = f2 - w;
            f2 = f2 + w;

            y[x + Encoder_1.BLKSIZE / 2 + 0] = f0 + f2;
            y[x + Encoder_1.BLKSIZE / 2 + 2] = f0 - f2;
            y[x + Encoder_1.BLKSIZE / 2 + 1] = f1 + f3;
            y[x + Encoder_1.BLKSIZE / 2 + 3] = f1 - f3;
        } while (--jj >= 0);

        fht(y, x, Encoder_1.BLKSIZE / 2);
        /* BLKSIZE/2 because of 3DNow! ASM routine */
    };

    this.init_fft = function (gfc) {
        /* The type of window used here will make no real difference, but */
        /*
         * in the interest of merging nspsytune stuff - switch to blackman
         * window
         */
        for (var i = 0; i < Encoder_1.BLKSIZE; i++)
            /* blackman window */
            window[i] = (0.42 - 0.5 * Math.cos(2 * Math.PI * (i + .5)
                / Encoder_1.BLKSIZE) + 0.08 * Math.cos(4 * Math.PI * (i + .5)
                / Encoder_1.BLKSIZE));

        for (var i = 0; i < Encoder_1.BLKSIZE_s / 2; i++)
            window_s[i] = (0.5 * (1.0 - Math.cos(2.0 * Math.PI
                * (i + 0.5) / Encoder_1.BLKSIZE_s)));

    };

}

var FFT_1 = FFT;

var VbrMode$3 = common.VbrMode;
var Float$3 = common.Float;
var ShortBlock$3 = common.ShortBlock;
var Util$3 = common.Util;
var Arrays$3 = common.Arrays;
var new_float$3 = common.new_float;
var new_float_n$3 = common.new_float_n;
var new_int$3 = common.new_int;
var assert$3 = common.assert;




function PsyModel() {

    var fft = new FFT_1();

    var LOG10 = 2.30258509299404568402;

    var rpelev = 2;
    var rpelev2 = 16;
    var rpelev_s = 2;
    var rpelev2_s = 16;

    /* size of each partition band, in barks: */
    var DELBARK = .34;

    /* tuned for output level (sensitive to energy scale) */
    var VO_SCALE = (1. / (14752 * 14752) / (Encoder_1.BLKSIZE / 2));

    var temporalmask_sustain_sec = 0.01;

    var NS_PREECHO_ATT0 = 0.8;
    var NS_PREECHO_ATT1 = 0.6;
    var NS_PREECHO_ATT2 = 0.3;

    var NS_MSFIX = 3.5;

    var NSATTACKTHRE = 4.4;
    var NSATTACKTHRE_S = 25;

    var NSFIRLEN = 21;

    /* size of each partition band, in barks: */
    var LN_TO_LOG10 = 0.2302585093;

    function NON_LINEAR_SCALE_ENERGY(x) {
        return x;
    }

    /**
     * <PRE>
     *       L3psycho_anal.  Compute psycho acoustics.
     *
     *       Data returned to the calling program must be delayed by one
     *       granule.
     *
     *       This is done in two places.
     *       If we do not need to know the blocktype, the copying
     *       can be done here at the top of the program: we copy the data for
     *       the last granule (computed during the last call) before it is
     *       overwritten with the new data.  It looks like this:
     *
     *       0. static psymodel_data
     *       1. calling_program_data = psymodel_data
     *       2. compute psymodel_data
     *
     *       For data which needs to know the blocktype, the copying must be
     *       done at the end of this loop, and the old values must be saved:
     *
     *       0. static psymodel_data_old
     *       1. compute psymodel_data
     *       2. compute possible block type of this granule
     *       3. compute final block type of previous granule based on #2.
     *       4. calling_program_data = psymodel_data_old
     *       5. psymodel_data_old = psymodel_data
     *     psycho_loudness_approx
     *       jd - 2001 mar 12
     *    in:  energy   - BLKSIZE/2 elements of frequency magnitudes ^ 2
     *         gfp      - uses out_samplerate, ATHtype (also needed for ATHformula)
     *    returns: loudness^2 approximation, a positive value roughly tuned for a value
     *             of 1.0 for signals near clipping.
     *    notes:   When calibrated, feeding this function binary white noise at sample
     *             values +32767 or -32768 should return values that approach 3.
     *             ATHformula is used to approximate an equal loudness curve.
     *    future:  Data indicates that the shape of the equal loudness curve varies
     *             with intensity.  This function might be improved by using an equal
     *             loudness curve shaped for typical playback levels (instead of the
     *             ATH, that is shaped for the threshold).  A flexible realization might
     *             simply bend the existing ATH curve to achieve the desired shape.
     *             However, the potential gain may not be enough to justify an effort.
     * </PRE>
     */
    function psycho_loudness_approx(energy, gfc) {
        var loudness_power = 0.0;
        /* apply weights to power in freq. bands */
        for (var i = 0; i < Encoder_1.BLKSIZE / 2; ++i)
            loudness_power += energy[i] * gfc.ATH.eql_w[i];
        loudness_power *= VO_SCALE;

        return loudness_power;
    }

    function compute_ffts(gfp, fftenergy, fftenergy_s, wsamp_l, wsamp_lPos, wsamp_s, wsamp_sPos, gr_out, chn, buffer, bufPos) {
        var gfc = gfp.internal_flags;
        if (chn < 2) {
            fft.fft_long(gfc, wsamp_l[wsamp_lPos], chn, buffer, bufPos);
            fft.fft_short(gfc, wsamp_s[wsamp_sPos], chn, buffer, bufPos);
        }
        /* FFT data for mid and side channel is derived from L & R */
        else if (chn == 2) {
            for (var j = Encoder_1.BLKSIZE - 1; j >= 0; --j) {
                var l = wsamp_l[wsamp_lPos + 0][j];
                var r = wsamp_l[wsamp_lPos + 1][j];
                wsamp_l[wsamp_lPos + 0][j] = (l + r) * Util$3.SQRT2 * 0.5;
                wsamp_l[wsamp_lPos + 1][j] = (l - r) * Util$3.SQRT2 * 0.5;
            }
            for (var b = 2; b >= 0; --b) {
                for (var j = Encoder_1.BLKSIZE_s - 1; j >= 0; --j) {
                    var l = wsamp_s[wsamp_sPos + 0][b][j];
                    var r = wsamp_s[wsamp_sPos + 1][b][j];
                    wsamp_s[wsamp_sPos + 0][b][j] = (l + r) * Util$3.SQRT2 * 0.5;
                    wsamp_s[wsamp_sPos + 1][b][j] = (l - r) * Util$3.SQRT2 * 0.5;
                }
            }
        }

        /*********************************************************************
         * compute energies
         *********************************************************************/
        fftenergy[0] = NON_LINEAR_SCALE_ENERGY(wsamp_l[wsamp_lPos + 0][0]);
        fftenergy[0] *= fftenergy[0];

        for (var j = Encoder_1.BLKSIZE / 2 - 1; j >= 0; --j) {
            var re = (wsamp_l[wsamp_lPos + 0])[Encoder_1.BLKSIZE / 2 - j];
            var im = (wsamp_l[wsamp_lPos + 0])[Encoder_1.BLKSIZE / 2 + j];
            fftenergy[Encoder_1.BLKSIZE / 2 - j] = NON_LINEAR_SCALE_ENERGY((re
                * re + im * im) * 0.5);
        }
        for (var b = 2; b >= 0; --b) {
            fftenergy_s[b][0] = (wsamp_s[wsamp_sPos + 0])[b][0];
            fftenergy_s[b][0] *= fftenergy_s[b][0];
            for (var j = Encoder_1.BLKSIZE_s / 2 - 1; j >= 0; --j) {
                var re = (wsamp_s[wsamp_sPos + 0])[b][Encoder_1.BLKSIZE_s
                / 2 - j];
                var im = (wsamp_s[wsamp_sPos + 0])[b][Encoder_1.BLKSIZE_s
                / 2 + j];
                fftenergy_s[b][Encoder_1.BLKSIZE_s / 2 - j] = NON_LINEAR_SCALE_ENERGY((re
                    * re + im * im) * 0.5);
            }
        }
        /* total energy */
        {
            var totalenergy = 0.0;
            for (var j = 11; j < Encoder_1.HBLKSIZE; j++)
                totalenergy += fftenergy[j];

            gfc.tot_ener[chn] = totalenergy;
        }

        if (gfp.analysis) {
            for (var j = 0; j < Encoder_1.HBLKSIZE; j++) {
                gfc.pinfo.energy[gr_out][chn][j] = gfc.pinfo.energy_save[chn][j];
                gfc.pinfo.energy_save[chn][j] = fftenergy[j];
            }
            gfc.pinfo.pe[gr_out][chn] = gfc.pe[chn];
        }

        /*********************************************************************
         * compute loudness approximation (used for ATH auto-level adjustment)
         *********************************************************************/
        if (gfp.athaa_loudapprox == 2 && chn < 2) {
            // no loudness for mid/side ch
            gfc.loudness_sq[gr_out][chn] = gfc.loudness_sq_save[chn];
            gfc.loudness_sq_save[chn] = psycho_loudness_approx(fftenergy, gfc);
        }
    }

    /* mask_add optimization */
    /* init the limit values used to avoid computing log in mask_add when it is not necessary */

    /**
     * <PRE>
     *  For example, with i = 10*log10(m2/m1)/10*16         (= log10(m2/m1)*16)
     *
     * abs(i)>8 is equivalent (as i is an integer) to
     * abs(i)>=9
     * i>=9 || i<=-9
     * equivalent to (as i is the biggest integer smaller than log10(m2/m1)*16
     * or the smallest integer bigger than log10(m2/m1)*16 depending on the sign of log10(m2/m1)*16)
     * log10(m2/m1)>=9/16 || log10(m2/m1)<=-9/16
     * exp10 is strictly increasing thus this is equivalent to
     * m2/m1 >= 10^(9/16) || m2/m1<=10^(-9/16) which are comparisons to constants
     * </PRE>
     */

    /**
     * as in if(i>8)
     */
    var I1LIMIT = 8;
    /**
     * as in if(i>24) . changed 23
     */
    var I2LIMIT = 23;
    /**
     * as in if(m<15)
     */
    var MLIMIT = 15;

    var ma_max_i1;
    var ma_max_i2;
    var ma_max_m;

    /**
     * This is the masking table:<BR>
     * According to tonality, values are going from 0dB (TMN) to 9.3dB (NMT).<BR>
     * After additive masking computation, 8dB are added, so final values are
     * going from 8dB to 17.3dB
     *
     * pow(10, -0.0..-0.6)
     */
    var tab = [1.0, 0.79433, 0.63096, 0.63096,
        0.63096, 0.63096, 0.63096, 0.25119, 0.11749];

    function init_mask_add_max_values() {
        ma_max_i1 = Math.pow(10, (I1LIMIT + 1) / 16.0);
        ma_max_i2 = Math.pow(10, (I2LIMIT + 1) / 16.0);
        ma_max_m = Math.pow(10, (MLIMIT) / 10.0);
    }

    var table1 = [3.3246 * 3.3246,
        3.23837 * 3.23837, 3.15437 * 3.15437, 3.00412 * 3.00412,
        2.86103 * 2.86103, 2.65407 * 2.65407, 2.46209 * 2.46209,
        2.284 * 2.284, 2.11879 * 2.11879, 1.96552 * 1.96552,
        1.82335 * 1.82335, 1.69146 * 1.69146, 1.56911 * 1.56911,
        1.46658 * 1.46658, 1.37074 * 1.37074, 1.31036 * 1.31036,
        1.25264 * 1.25264, 1.20648 * 1.20648, 1.16203 * 1.16203,
        1.12765 * 1.12765, 1.09428 * 1.09428, 1.0659 * 1.0659,
        1.03826 * 1.03826, 1.01895 * 1.01895, 1];

    var table2 = [1.33352 * 1.33352,
        1.35879 * 1.35879, 1.38454 * 1.38454, 1.39497 * 1.39497,
        1.40548 * 1.40548, 1.3537 * 1.3537, 1.30382 * 1.30382,
        1.22321 * 1.22321, 1.14758 * 1.14758, 1];

    var table3 = [2.35364 * 2.35364,
        2.29259 * 2.29259, 2.23313 * 2.23313, 2.12675 * 2.12675,
        2.02545 * 2.02545, 1.87894 * 1.87894, 1.74303 * 1.74303,
        1.61695 * 1.61695, 1.49999 * 1.49999, 1.39148 * 1.39148,
        1.29083 * 1.29083, 1.19746 * 1.19746, 1.11084 * 1.11084,
        1.03826 * 1.03826];

    /**
     * addition of simultaneous masking Naoki Shibata 2000/7
     */
    function mask_add(m1, m2, kk, b, gfc, shortblock) {
        var ratio;

        if (m2 > m1) {
            if (m2 < (m1 * ma_max_i2))
                ratio = m2 / m1;
            else
                return (m1 + m2);
        } else {
            if (m1 >= (m2 * ma_max_i2))
                return (m1 + m2);
            ratio = m1 / m2;
        }

        /* Should always be true, just checking */
        assert$3(m1 >= 0);
        assert$3(m2 >= 0);

        m1 += m2;
        //if (((long)(b + 3) & 0xffffffff) <= 3 + 3) {
        if ((b + 3) <= 3 + 3) {
            /* approximately, 1 bark = 3 partitions */
            /* 65% of the cases */
            /* originally 'if(i > 8)' */
            if (ratio >= ma_max_i1) {
                /* 43% of the total */
                return m1;
            }

            /* 22% of the total */
            var i = 0 | (Util$3.FAST_LOG10_X(ratio, 16.0));
            return m1 * table2[i];
        }

        /**
         * <PRE>
         * m<15 equ log10((m1+m2)/gfc.ATH.cb[k])<1.5
         * equ (m1+m2)/gfc.ATH.cb[k]<10^1.5
         * equ (m1+m2)<10^1.5 * gfc.ATH.cb[k]
         * </PRE>
         */
        var i = 0 | Util$3.FAST_LOG10_X(ratio, 16.0);
        if (shortblock != 0) {
            m2 = gfc.ATH.cb_s[kk] * gfc.ATH.adjust;
        } else {
            m2 = gfc.ATH.cb_l[kk] * gfc.ATH.adjust;
        }
        assert$3(m2 >= 0);
        if (m1 < ma_max_m * m2) {
            /* 3% of the total */
            /* Originally if (m > 0) { */
            if (m1 > m2) {
                var f, r;

                f = 1.0;
                if (i <= 13)
                    f = table3[i];

                r = Util$3.FAST_LOG10_X(m1 / m2, 10.0 / 15.0);
                return m1 * ((table1[i] - f) * r + f);
            }

            if (i > 13)
                return m1;

            return m1 * table3[i];
        }

        /* 10% of total */
        return m1 * table1[i];
    }

    var table2_ = [1.33352 * 1.33352,
        1.35879 * 1.35879, 1.38454 * 1.38454, 1.39497 * 1.39497,
        1.40548 * 1.40548, 1.3537 * 1.3537, 1.30382 * 1.30382,
        1.22321 * 1.22321, 1.14758 * 1.14758, 1];

    /**
     * addition of simultaneous masking Naoki Shibata 2000/7
     */
    function vbrpsy_mask_add(m1, m2, b) {
        var ratio;

        if (m1 < 0) {
            m1 = 0;
        }
        if (m2 < 0) {
            m2 = 0;
        }
        if (m1 <= 0) {
            return m2;
        }
        if (m2 <= 0) {
            return m1;
        }
        if (m2 > m1) {
            ratio = m2 / m1;
        } else {
            ratio = m1 / m2;
        }
        if (-2 <= b && b <= 2) {
            /* approximately, 1 bark = 3 partitions */
            /* originally 'if(i > 8)' */
            if (ratio >= ma_max_i1) {
                return m1 + m2;
            } else {
                var i = 0 | (Util$3.FAST_LOG10_X(ratio, 16.0));
                return (m1 + m2) * table2_[i];
            }
        }
        if (ratio < ma_max_i2) {
            return m1 + m2;
        }
        if (m1 < m2) {
            m1 = m2;
        }
        return m1;
    }

    /**
     * compute interchannel masking effects
     */
    function calc_interchannel_masking(gfp, ratio) {
        var gfc = gfp.internal_flags;
        if (gfc.channels_out > 1) {
            for (var sb = 0; sb < Encoder_1.SBMAX_l; sb++) {
                var l = gfc.thm[0].l[sb];
                var r = gfc.thm[1].l[sb];
                gfc.thm[0].l[sb] += r * ratio;
                gfc.thm[1].l[sb] += l * ratio;
            }
            for (var sb = 0; sb < Encoder_1.SBMAX_s; sb++) {
                for (var sblock = 0; sblock < 3; sblock++) {
                    var l = gfc.thm[0].s[sb][sblock];
                    var r = gfc.thm[1].s[sb][sblock];
                    gfc.thm[0].s[sb][sblock] += r * ratio;
                    gfc.thm[1].s[sb][sblock] += l * ratio;
                }
            }
        }
    }

    /**
     * compute M/S thresholds from Johnston & Ferreira 1992 ICASSP paper
     */
    function msfix1(gfc) {
        for (var sb = 0; sb < Encoder_1.SBMAX_l; sb++) {
            /* use this fix if L & R masking differs by 2db or less */
            /* if db = 10*log10(x2/x1) < 2 */
            /* if (x2 < 1.58*x1) { */
            if (gfc.thm[0].l[sb] > 1.58 * gfc.thm[1].l[sb]
                || gfc.thm[1].l[sb] > 1.58 * gfc.thm[0].l[sb])
                continue;
            var mld = gfc.mld_l[sb] * gfc.en[3].l[sb];
            var rmid = Math.max(gfc.thm[2].l[sb],
                Math.min(gfc.thm[3].l[sb], mld));

            mld = gfc.mld_l[sb] * gfc.en[2].l[sb];
            var rside = Math.max(gfc.thm[3].l[sb],
                Math.min(gfc.thm[2].l[sb], mld));
            gfc.thm[2].l[sb] = rmid;
            gfc.thm[3].l[sb] = rside;
        }

        for (var sb = 0; sb < Encoder_1.SBMAX_s; sb++) {
            for (var sblock = 0; sblock < 3; sblock++) {
                if (gfc.thm[0].s[sb][sblock] > 1.58 * gfc.thm[1].s[sb][sblock]
                    || gfc.thm[1].s[sb][sblock] > 1.58 * gfc.thm[0].s[sb][sblock])
                    continue;
                var mld = gfc.mld_s[sb] * gfc.en[3].s[sb][sblock];
                var rmid = Math.max(gfc.thm[2].s[sb][sblock],
                    Math.min(gfc.thm[3].s[sb][sblock], mld));

                mld = gfc.mld_s[sb] * gfc.en[2].s[sb][sblock];
                var rside = Math.max(gfc.thm[3].s[sb][sblock],
                    Math.min(gfc.thm[2].s[sb][sblock], mld));

                gfc.thm[2].s[sb][sblock] = rmid;
                gfc.thm[3].s[sb][sblock] = rside;
            }
        }
    }

    /**
     * Adjust M/S maskings if user set "msfix"
     *
     * Naoki Shibata 2000
     */
    function ns_msfix(gfc, msfix, athadjust) {
        var msfix2 = msfix;
        var athlower = Math.pow(10, athadjust);

        msfix *= 2.0;
        msfix2 *= 2.0;
        for (var sb = 0; sb < Encoder_1.SBMAX_l; sb++) {
            var thmLR, thmM, thmS, ath;
            ath = (gfc.ATH.cb_l[gfc.bm_l[sb]]) * athlower;
            thmLR = Math.min(Math.max(gfc.thm[0].l[sb], ath),
                Math.max(gfc.thm[1].l[sb], ath));
            thmM = Math.max(gfc.thm[2].l[sb], ath);
            thmS = Math.max(gfc.thm[3].l[sb], ath);
            if (thmLR * msfix < thmM + thmS) {
                var f = thmLR * msfix2 / (thmM + thmS);
                thmM *= f;
                thmS *= f;
                assert$3(thmM + thmS > 0);
            }
            gfc.thm[2].l[sb] = Math.min(thmM, gfc.thm[2].l[sb]);
            gfc.thm[3].l[sb] = Math.min(thmS, gfc.thm[3].l[sb]);
        }

        athlower *= ( Encoder_1.BLKSIZE_s / Encoder_1.BLKSIZE);
        for (var sb = 0; sb < Encoder_1.SBMAX_s; sb++) {
            for (var sblock = 0; sblock < 3; sblock++) {
                var thmLR, thmM, thmS, ath;
                ath = (gfc.ATH.cb_s[gfc.bm_s[sb]]) * athlower;
                thmLR = Math.min(Math.max(gfc.thm[0].s[sb][sblock], ath),
                    Math.max(gfc.thm[1].s[sb][sblock], ath));
                thmM = Math.max(gfc.thm[2].s[sb][sblock], ath);
                thmS = Math.max(gfc.thm[3].s[sb][sblock], ath);

                if (thmLR * msfix < thmM + thmS) {
                    var f = thmLR * msfix / (thmM + thmS);
                    thmM *= f;
                    thmS *= f;
                    assert$3(thmM + thmS > 0);
                }
                gfc.thm[2].s[sb][sblock] = Math.min(gfc.thm[2].s[sb][sblock],
                    thmM);
                gfc.thm[3].s[sb][sblock] = Math.min(gfc.thm[3].s[sb][sblock],
                    thmS);
            }
        }
    }

    /**
     * short block threshold calculation (part 2)
     *
     * partition band bo_s[sfb] is at the transition from scalefactor band sfb
     * to the next one sfb+1; enn and thmm have to be split between them
     */
    function convert_partition2scalefac_s(gfc, eb, thr, chn, sblock) {
        var sb, b;
        var enn = 0.0;
        var thmm = 0.0;
        for (sb = b = 0; sb < Encoder_1.SBMAX_s; ++b, ++sb) {
            var bo_s_sb = gfc.bo_s[sb];
            var npart_s = gfc.npart_s;
            var b_lim = bo_s_sb < npart_s ? bo_s_sb : npart_s;
            while (b < b_lim) {
                assert$3(eb[b] >= 0);
                // iff failed, it may indicate some index error elsewhere
                assert$3(thr[b] >= 0);
                enn += eb[b];
                thmm += thr[b];
                b++;
            }
            gfc.en[chn].s[sb][sblock] = enn;
            gfc.thm[chn].s[sb][sblock] = thmm;

            if (b >= npart_s) {
                ++sb;
                break;
            }
            assert$3(eb[b] >= 0);
            // iff failed, it may indicate some index error elsewhere
            assert$3(thr[b] >= 0);
            {
                /* at transition sfb . sfb+1 */
                var w_curr = gfc.PSY.bo_s_weight[sb];
                var w_next = 1.0 - w_curr;
                enn = w_curr * eb[b];
                thmm = w_curr * thr[b];
                gfc.en[chn].s[sb][sblock] += enn;
                gfc.thm[chn].s[sb][sblock] += thmm;
                enn = w_next * eb[b];
                thmm = w_next * thr[b];
            }
        }
        /* zero initialize the rest */
        for (; sb < Encoder_1.SBMAX_s; ++sb) {
            gfc.en[chn].s[sb][sblock] = 0;
            gfc.thm[chn].s[sb][sblock] = 0;
        }
    }

    /**
     * longblock threshold calculation (part 2)
     */
    function convert_partition2scalefac_l(gfc, eb, thr, chn) {
        var sb, b;
        var enn = 0.0;
        var thmm = 0.0;
        for (sb = b = 0; sb < Encoder_1.SBMAX_l; ++b, ++sb) {
            var bo_l_sb = gfc.bo_l[sb];
            var npart_l = gfc.npart_l;
            var b_lim = bo_l_sb < npart_l ? bo_l_sb : npart_l;
            while (b < b_lim) {
                assert$3(eb[b] >= 0);
                // iff failed, it may indicate some index error elsewhere
                assert$3(thr[b] >= 0);
                enn += eb[b];
                thmm += thr[b];
                b++;
            }
            gfc.en[chn].l[sb] = enn;
            gfc.thm[chn].l[sb] = thmm;

            if (b >= npart_l) {
                ++sb;
                break;
            }
            assert$3(eb[b] >= 0);
            assert$3(thr[b] >= 0);
            {
                /* at transition sfb . sfb+1 */
                var w_curr = gfc.PSY.bo_l_weight[sb];
                var w_next = 1.0 - w_curr;
                enn = w_curr * eb[b];
                thmm = w_curr * thr[b];
                gfc.en[chn].l[sb] += enn;
                gfc.thm[chn].l[sb] += thmm;
                enn = w_next * eb[b];
                thmm = w_next * thr[b];
            }
        }
        /* zero initialize the rest */
        for (; sb < Encoder_1.SBMAX_l; ++sb) {
            gfc.en[chn].l[sb] = 0;
            gfc.thm[chn].l[sb] = 0;
        }
    }

    function compute_masking_s(gfp, fftenergy_s, eb, thr, chn, sblock) {
        var gfc = gfp.internal_flags;
        var j, b;

        for (b = j = 0; b < gfc.npart_s; ++b) {
            var ebb = 0, m = 0;
            var n = gfc.numlines_s[b];
            for (var i = 0; i < n; ++i, ++j) {
                var el = fftenergy_s[sblock][j];
                ebb += el;
                if (m < el)
                    m = el;
            }
            eb[b] = ebb;
        }
        assert$3(b == gfc.npart_s);
        assert$3(j == 129);
        for (j = b = 0; b < gfc.npart_s; b++) {
            var kk = gfc.s3ind_s[b][0];
            var ecb = gfc.s3_ss[j++] * eb[kk];
            ++kk;
            while (kk <= gfc.s3ind_s[b][1]) {
                ecb += gfc.s3_ss[j] * eb[kk];
                ++j;
                ++kk;
            }

            { /* limit calculated threshold by previous granule */
                var x = rpelev_s * gfc.nb_s1[chn][b];
                thr[b] = Math.min(ecb, x);
            }
            if (gfc.blocktype_old[chn & 1] == Encoder_1.SHORT_TYPE) {
                /* limit calculated threshold by even older granule */
                var x = rpelev2_s * gfc.nb_s2[chn][b];
                var y = thr[b];
                thr[b] = Math.min(x, y);
            }

            gfc.nb_s2[chn][b] = gfc.nb_s1[chn][b];
            gfc.nb_s1[chn][b] = ecb;
            assert$3(thr[b] >= 0);
        }
        for (; b <= Encoder_1.CBANDS; ++b) {
            eb[b] = 0;
            thr[b] = 0;
        }
    }

    function block_type_set(gfp, uselongblock, blocktype_d, blocktype) {
        var gfc = gfp.internal_flags;

        if (gfp.short_blocks == ShortBlock$3.short_block_coupled
                /* force both channels to use the same block type */
                /* this is necessary if the frame is to be encoded in ms_stereo. */
                /* But even without ms_stereo, FhG does this */
            && !(uselongblock[0] != 0 && uselongblock[1] != 0))
            uselongblock[0] = uselongblock[1] = 0;

        /*
         * update the blocktype of the previous granule, since it depends on
         * what happend in this granule
         */
        for (var chn = 0; chn < gfc.channels_out; chn++) {
            blocktype[chn] = Encoder_1.NORM_TYPE;
            /* disable short blocks */
            if (gfp.short_blocks == ShortBlock$3.short_block_dispensed)
                uselongblock[chn] = 1;
            if (gfp.short_blocks == ShortBlock$3.short_block_forced)
                uselongblock[chn] = 0;

            if (uselongblock[chn] != 0) {
                /* no attack : use long blocks */
                assert$3(gfc.blocktype_old[chn] != Encoder_1.START_TYPE);
                if (gfc.blocktype_old[chn] == Encoder_1.SHORT_TYPE)
                    blocktype[chn] = Encoder_1.STOP_TYPE;
            } else {
                /* attack : use short blocks */
                blocktype[chn] = Encoder_1.SHORT_TYPE;
                if (gfc.blocktype_old[chn] == Encoder_1.NORM_TYPE) {
                    gfc.blocktype_old[chn] = Encoder_1.START_TYPE;
                }
                if (gfc.blocktype_old[chn] == Encoder_1.STOP_TYPE)
                    gfc.blocktype_old[chn] = Encoder_1.SHORT_TYPE;
            }

            blocktype_d[chn] = gfc.blocktype_old[chn];
            // value returned to calling program
            gfc.blocktype_old[chn] = blocktype[chn];
            // save for next call to l3psy_anal
        }
    }

    function NS_INTERP(x, y, r) {
        /* was pow((x),(r))*pow((y),1-(r)) */
        if (r >= 1.0) {
            /* 99.7% of the time */
            return x;
        }
        if (r <= 0.0)
            return y;
        if (y > 0.0) {
            /* rest of the time */
            return (Math.pow(x / y, r) * y);
        }
        /* never happens */
        return 0.0;
    }

    /**
     * these values are tuned only for 44.1kHz...
     */
    var regcoef_s = [11.8, 13.6, 17.2, 32, 46.5,
        51.3, 57.5, 67.1, 71.5, 84.6, 97.6, 130,
        /* 255.8 */
    ];

    function pecalc_s(mr, masking_lower) {
        var pe_s = 1236.28 / 4;
        for (var sb = 0; sb < Encoder_1.SBMAX_s - 1; sb++) {
            for (var sblock = 0; sblock < 3; sblock++) {
                var thm = mr.thm.s[sb][sblock];
                assert$3(sb < regcoef_s.length);
                if (thm > 0.0) {
                    var x = thm * masking_lower;
                    var en = mr.en.s[sb][sblock];
                    if (en > x) {
                        if (en > x * 1e10) {
                            pe_s += regcoef_s[sb] * (10.0 * LOG10);
                        } else {
                            assert$3(x > 0);
                            pe_s += regcoef_s[sb] * Util$3.FAST_LOG10(en / x);
                        }
                    }
                }
            }
        }

        return pe_s;
    }

    /**
     * these values are tuned only for 44.1kHz...
     */
    var regcoef_l = [6.8, 5.8, 5.8, 6.4, 6.5, 9.9,
        12.1, 14.4, 15, 18.9, 21.6, 26.9, 34.2, 40.2, 46.8, 56.5,
        60.7, 73.9, 85.7, 93.4, 126.1,
        /* 241.3 */
    ];

    function pecalc_l(mr, masking_lower) {
        var pe_l = 1124.23 / 4;
        for (var sb = 0; sb < Encoder_1.SBMAX_l - 1; sb++) {
            var thm = mr.thm.l[sb];
            assert$3(sb < regcoef_l.length);
            if (thm > 0.0) {
                var x = thm * masking_lower;
                var en = mr.en.l[sb];
                if (en > x) {
                    if (en > x * 1e10) {
                        pe_l += regcoef_l[sb] * (10.0 * LOG10);
                    } else {
                        assert$3(x > 0);
                        pe_l += regcoef_l[sb] * Util$3.FAST_LOG10(en / x);
                    }
                }
            }
        }
        return pe_l;
    }

    function calc_energy(gfc, fftenergy, eb, max, avg) {
        var b, j;

        for (b = j = 0; b < gfc.npart_l; ++b) {
            var ebb = 0, m = 0;
            var i;
            for (i = 0; i < gfc.numlines_l[b]; ++i, ++j) {
                var el = fftenergy[j];
                assert$3(el >= 0);
                ebb += el;
                if (m < el)
                    m = el;
            }
            eb[b] = ebb;
            max[b] = m;
            avg[b] = ebb * gfc.rnumlines_l[b];
            assert$3(gfc.rnumlines_l[b] >= 0);
            assert$3(ebb >= 0);
            assert$3(eb[b] >= 0);
            assert$3(max[b] >= 0);
            assert$3(avg[b] >= 0);
        }
    }

    function calc_mask_index_l(gfc, max, avg, mask_idx) {
        var last_tab_entry = tab.length - 1;
        var b = 0;
        var a = avg[b] + avg[b + 1];
        assert$3(a >= 0);
        if (a > 0.0) {
            var m = max[b];
            if (m < max[b + 1])
                m = max[b + 1];
            assert$3((gfc.numlines_l[b] + gfc.numlines_l[b + 1] - 1) > 0);
            a = 20.0 * (m * 2.0 - a)
                / (a * (gfc.numlines_l[b] + gfc.numlines_l[b + 1] - 1));
            var k = 0 | a;
            if (k > last_tab_entry)
                k = last_tab_entry;
            mask_idx[b] = k;
        } else {
            mask_idx[b] = 0;
        }

        for (b = 1; b < gfc.npart_l - 1; b++) {
            a = avg[b - 1] + avg[b] + avg[b + 1];
            assert$3(a >= 0);
            if (a > 0.0) {
                var m = max[b - 1];
                if (m < max[b])
                    m = max[b];
                if (m < max[b + 1])
                    m = max[b + 1];
                assert$3((gfc.numlines_l[b - 1] + gfc.numlines_l[b] + gfc.numlines_l[b + 1] - 1) > 0);
                a = 20.0
                    * (m * 3.0 - a)
                    / (a * (gfc.numlines_l[b - 1] + gfc.numlines_l[b]
                    + gfc.numlines_l[b + 1] - 1));
                var k = 0 | a;
                if (k > last_tab_entry)
                    k = last_tab_entry;
                mask_idx[b] = k;
            } else {
                mask_idx[b] = 0;
            }
        }
        assert$3(b > 0);
        assert$3(b == gfc.npart_l - 1);

        a = avg[b - 1] + avg[b];
        assert$3(a >= 0);
        if (a > 0.0) {
            var m = max[b - 1];
            if (m < max[b])
                m = max[b];
            assert$3((gfc.numlines_l[b - 1] + gfc.numlines_l[b] - 1) > 0);
            a = 20.0 * (m * 2.0 - a)
                / (a * (gfc.numlines_l[b - 1] + gfc.numlines_l[b] - 1));
            var k = 0 | a;
            if (k > last_tab_entry)
                k = last_tab_entry;
            mask_idx[b] = k;
        } else {
            mask_idx[b] = 0;
        }
        assert$3(b == (gfc.npart_l - 1));
    }

    var fircoef = [
        -8.65163e-18 * 2, -0.00851586 * 2, -6.74764e-18 * 2, 0.0209036 * 2,
        -3.36639e-17 * 2, -0.0438162 * 2, -1.54175e-17 * 2, 0.0931738 * 2,
        -5.52212e-17 * 2, -0.313819 * 2
    ];

    this.L3psycho_anal_ns = function (gfp, buffer, bufPos, gr_out, masking_ratio, masking_MS_ratio, percep_entropy, percep_MS_entropy, energy, blocktype_d) {
        /*
         * to get a good cache performance, one has to think about the sequence,
         * in which the variables are used.
         */
        var gfc = gfp.internal_flags;

        /* fft and energy calculation */
        var wsamp_L = new_float_n$3([2, Encoder_1.BLKSIZE]);
        var wsamp_S = new_float_n$3([2, 3, Encoder_1.BLKSIZE_s]);

        /* convolution */
        var eb_l = new_float$3(Encoder_1.CBANDS + 1);
        var eb_s = new_float$3(Encoder_1.CBANDS + 1);
        var thr = new_float$3(Encoder_1.CBANDS + 2);

        /* block type */
        var blocktype = new_int$3(2), uselongblock = new_int$3(2);

        /* usual variables like loop indices, etc.. */
        var numchn, chn;
        var b, i, j, k;
        var sb, sblock;

        /* variables used for --nspsytune */
        var ns_hpfsmpl = new_float_n$3([2, 576]);
        var pcfact;
        var mask_idx_l = new_int$3(Encoder_1.CBANDS + 2), mask_idx_s = new_int$3(Encoder_1.CBANDS + 2);

        Arrays$3.fill(mask_idx_s, 0);

        numchn = gfc.channels_out;
        /* chn=2 and 3 = Mid and Side channels */
        if (gfp.mode == MPEGMode.JOINT_STEREO)
            numchn = 4;

        if (gfp.VBR == VbrMode$3.vbr_off)
            pcfact = gfc.ResvMax == 0 ? 0 : ( gfc.ResvSize)
            / gfc.ResvMax * 0.5;
        else if (gfp.VBR == VbrMode$3.vbr_rh || gfp.VBR == VbrMode$3.vbr_mtrh
            || gfp.VBR == VbrMode$3.vbr_mt) {
            pcfact = 0.6;
        } else
            pcfact = 1.0;

        /**********************************************************************
         * Apply HPF of fs/4 to the input signal. This is used for attack
         * detection / handling.
         **********************************************************************/
        /* Don't copy the input buffer into a temporary buffer */
        /* unroll the loop 2 times */
        for (chn = 0; chn < gfc.channels_out; chn++) {
            /* apply high pass filter of fs/4 */
            var firbuf = buffer[chn];
            var firbufPos = bufPos + 576 - 350 - NSFIRLEN + 192;
            assert$3(fircoef.length == ((NSFIRLEN - 1) / 2));
            for (i = 0; i < 576; i++) {
                var sum1, sum2;
                sum1 = firbuf[firbufPos + i + 10];
                sum2 = 0.0;
                for (j = 0; j < ((NSFIRLEN - 1) / 2) - 1; j += 2) {
                    sum1 += fircoef[j]
                        * (firbuf[firbufPos + i + j] + firbuf[firbufPos + i
                        + NSFIRLEN - j]);
                    sum2 += fircoef[j + 1]
                        * (firbuf[firbufPos + i + j + 1] + firbuf[firbufPos
                        + i + NSFIRLEN - j - 1]);
                }
                ns_hpfsmpl[chn][i] = sum1 + sum2;
            }
            masking_ratio[gr_out][chn].en.assign(gfc.en[chn]);
            masking_ratio[gr_out][chn].thm.assign(gfc.thm[chn]);
            if (numchn > 2) {
                /* MS maskings */
                /* percep_MS_entropy [chn-2] = gfc . pe [chn]; */
                masking_MS_ratio[gr_out][chn].en.assign(gfc.en[chn + 2]);
                masking_MS_ratio[gr_out][chn].thm.assign(gfc.thm[chn + 2]);
            }
        }

        for (chn = 0; chn < numchn; chn++) {
            var wsamp_l;
            var wsamp_s;
            var en_subshort = new_float$3(12);
            var en_short = [0, 0, 0, 0];
            var attack_intensity = new_float$3(12);
            var ns_uselongblock = 1;
            var attackThreshold;
            var max = new_float$3(Encoder_1.CBANDS), avg = new_float$3(Encoder_1.CBANDS);
            var ns_attacks = [0, 0, 0, 0];
            var fftenergy = new_float$3(Encoder_1.HBLKSIZE);
            var fftenergy_s = new_float_n$3([3, Encoder_1.HBLKSIZE_s]);

            /*
             * rh 20040301: the following loops do access one off the limits so
             * I increase the array dimensions by one and initialize the
             * accessed values to zero
             */
            assert$3(gfc.npart_s <= Encoder_1.CBANDS);
            assert$3(gfc.npart_l <= Encoder_1.CBANDS);

            /***************************************************************
             * determine the block type (window type)
             ***************************************************************/
            /* calculate energies of each sub-shortblocks */
            for (i = 0; i < 3; i++) {
                en_subshort[i] = gfc.nsPsy.last_en_subshort[chn][i + 6];
                assert$3(gfc.nsPsy.last_en_subshort[chn][i + 4] > 0);
                attack_intensity[i] = en_subshort[i]
                    / gfc.nsPsy.last_en_subshort[chn][i + 4];
                en_short[0] += en_subshort[i];
            }

            if (chn == 2) {
                for (i = 0; i < 576; i++) {
                    var l, r;
                    l = ns_hpfsmpl[0][i];
                    r = ns_hpfsmpl[1][i];
                    ns_hpfsmpl[0][i] = l + r;
                    ns_hpfsmpl[1][i] = l - r;
                }
            }
            {
                var pf = ns_hpfsmpl[chn & 1];
                var pfPos = 0;
                for (i = 0; i < 9; i++) {
                    var pfe = pfPos + 576 / 9;
                    var p = 1.;
                    for (; pfPos < pfe; pfPos++)
                        if (p < Math.abs(pf[pfPos]))
                            p = Math.abs(pf[pfPos]);

                    gfc.nsPsy.last_en_subshort[chn][i] = en_subshort[i + 3] = p;
                    en_short[1 + i / 3] += p;
                    if (p > en_subshort[i + 3 - 2]) {
                        assert$3(en_subshort[i + 3 - 2] > 0);
                        p = p / en_subshort[i + 3 - 2];
                    } else if (en_subshort[i + 3 - 2] > p * 10.0) {
                        assert$3(p > 0);
                        p = en_subshort[i + 3 - 2] / (p * 10.0);
                    } else
                        p = 0.0;
                    attack_intensity[i + 3] = p;
                }
            }

            if (gfp.analysis) {
                var x = attack_intensity[0];
                for (i = 1; i < 12; i++)
                    if (x < attack_intensity[i])
                        x = attack_intensity[i];
                gfc.pinfo.ers[gr_out][chn] = gfc.pinfo.ers_save[chn];
                gfc.pinfo.ers_save[chn] = x;
            }

            /* compare energies between sub-shortblocks */
            attackThreshold = (chn == 3) ? gfc.nsPsy.attackthre_s
                : gfc.nsPsy.attackthre;
            for (i = 0; i < 12; i++)
                if (0 == ns_attacks[i / 3]
                    && attack_intensity[i] > attackThreshold)
                    ns_attacks[i / 3] = (i % 3) + 1;

            /*
             * should have energy change between short blocks, in order to avoid
             * periodic signals
             */
            for (i = 1; i < 4; i++) {
                var ratio;
                if (en_short[i - 1] > en_short[i]) {
                    assert$3(en_short[i] > 0);
                    ratio = en_short[i - 1] / en_short[i];
                } else {
                    assert$3(en_short[i - 1] > 0);
                    ratio = en_short[i] / en_short[i - 1];
                }
                if (ratio < 1.7) {
                    ns_attacks[i] = 0;
                    if (i == 1)
                        ns_attacks[0] = 0;
                }
            }

            if (ns_attacks[0] != 0 && gfc.nsPsy.lastAttacks[chn] != 0)
                ns_attacks[0] = 0;

            if (gfc.nsPsy.lastAttacks[chn] == 3
                || (ns_attacks[0] + ns_attacks[1] + ns_attacks[2] + ns_attacks[3]) != 0) {
                ns_uselongblock = 0;

                if (ns_attacks[1] != 0 && ns_attacks[0] != 0)
                    ns_attacks[1] = 0;
                if (ns_attacks[2] != 0 && ns_attacks[1] != 0)
                    ns_attacks[2] = 0;
                if (ns_attacks[3] != 0 && ns_attacks[2] != 0)
                    ns_attacks[3] = 0;
            }

            if (chn < 2) {
                uselongblock[chn] = ns_uselongblock;
            } else {
                if (ns_uselongblock == 0) {
                    uselongblock[0] = uselongblock[1] = 0;
                }
            }

            /*
             * there is a one granule delay. Copy maskings computed last call
             * into masking_ratio to return to calling program.
             */
            energy[chn] = gfc.tot_ener[chn];

            /*********************************************************************
             * compute FFTs
             *********************************************************************/
            wsamp_s = wsamp_S;
            wsamp_l = wsamp_L;
            compute_ffts(gfp, fftenergy, fftenergy_s, wsamp_l, (chn & 1),
                wsamp_s, (chn & 1), gr_out, chn, buffer, bufPos);

            /*********************************************************************
             * Calculate the energy and the tonality of each partition.
             *********************************************************************/
            calc_energy(gfc, fftenergy, eb_l, max, avg);
            calc_mask_index_l(gfc, max, avg, mask_idx_l);
            /* compute masking thresholds for short blocks */
            for (sblock = 0; sblock < 3; sblock++) {
                var enn, thmm;
                compute_masking_s(gfp, fftenergy_s, eb_s, thr, chn, sblock);
                convert_partition2scalefac_s(gfc, eb_s, thr, chn, sblock);
                /**** short block pre-echo control ****/
                for (sb = 0; sb < Encoder_1.SBMAX_s; sb++) {
                    thmm = gfc.thm[chn].s[sb][sblock];

                    thmm *= NS_PREECHO_ATT0;
                    if (ns_attacks[sblock] >= 2 || ns_attacks[sblock + 1] == 1) {
                        var idx = (sblock != 0) ? sblock - 1 : 2;
                        var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm,
                            NS_PREECHO_ATT1 * pcfact);
                        thmm = Math.min(thmm, p);
                    }

                    if (ns_attacks[sblock] == 1) {
                        var idx = (sblock != 0) ? sblock - 1 : 2;
                        var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm,
                            NS_PREECHO_ATT2 * pcfact);
                        thmm = Math.min(thmm, p);
                    } else if ((sblock != 0 && ns_attacks[sblock - 1] == 3)
                        || (sblock == 0 && gfc.nsPsy.lastAttacks[chn] == 3)) {
                        var idx = (sblock != 2) ? sblock + 1 : 0;
                        var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm,
                            NS_PREECHO_ATT2 * pcfact);
                        thmm = Math.min(thmm, p);
                    }

                    /* pulse like signal detection for fatboy.wav and so on */
                    enn = en_subshort[sblock * 3 + 3]
                        + en_subshort[sblock * 3 + 4]
                        + en_subshort[sblock * 3 + 5];
                    if (en_subshort[sblock * 3 + 5] * 6 < enn) {
                        thmm *= 0.5;
                        if (en_subshort[sblock * 3 + 4] * 6 < enn)
                            thmm *= 0.5;
                    }

                    gfc.thm[chn].s[sb][sblock] = thmm;
                }
            }
            gfc.nsPsy.lastAttacks[chn] = ns_attacks[2];

            /*********************************************************************
             * convolve the partitioned energy and unpredictability with the
             * spreading function, s3_l[b][k]
             ********************************************************************/
            k = 0;
            {
                for (b = 0; b < gfc.npart_l; b++) {
                    /*
                     * convolve the partitioned energy with the spreading
                     * function
                     */
                    var kk = gfc.s3ind[b][0];
                    var eb2 = eb_l[kk] * tab[mask_idx_l[kk]];
                    var ecb = gfc.s3_ll[k++] * eb2;
                    while (++kk <= gfc.s3ind[b][1]) {
                        eb2 = eb_l[kk] * tab[mask_idx_l[kk]];
                        ecb = mask_add(ecb, gfc.s3_ll[k++] * eb2, kk, kk - b,
                            gfc, 0);
                    }
                    ecb *= 0.158489319246111;
                    /* pow(10,-0.8) */

                    /**** long block pre-echo control ****/
                    /**
                     * <PRE>
                     * dont use long block pre-echo control if previous granule was
                     * a short block.  This is to avoid the situation:
                     * frame0:  quiet (very low masking)
                     * frame1:  surge  (triggers short blocks)
                     * frame2:  regular frame.  looks like pre-echo when compared to
                     *          frame0, but all pre-echo was in frame1.
                     * </PRE>
                     */
                    /*
                     * chn=0,1 L and R channels
                     *
                     * chn=2,3 S and M channels.
                     */

                    if (gfc.blocktype_old[chn & 1] == Encoder_1.SHORT_TYPE)
                        thr[b] = ecb;
                    else
                        thr[b] = NS_INTERP(
                            Math.min(ecb, Math.min(rpelev
                                * gfc.nb_1[chn][b], rpelev2
                                * gfc.nb_2[chn][b])), ecb, pcfact);

                    gfc.nb_2[chn][b] = gfc.nb_1[chn][b];
                    gfc.nb_1[chn][b] = ecb;
                }
            }
            for (; b <= Encoder_1.CBANDS; ++b) {
                eb_l[b] = 0;
                thr[b] = 0;
            }
            /* compute masking thresholds for long blocks */
            convert_partition2scalefac_l(gfc, eb_l, thr, chn);
        }
        /* end loop over chn */

        if (gfp.mode == MPEGMode.STEREO || gfp.mode == MPEGMode.JOINT_STEREO) {
            if (gfp.interChRatio > 0.0) {
                calc_interchannel_masking(gfp, gfp.interChRatio);
            }
        }

        if (gfp.mode == MPEGMode.JOINT_STEREO) {
            var msfix;
            msfix1(gfc);
            msfix = gfp.msfix;
            if (Math.abs(msfix) > 0.0)
                ns_msfix(gfc, msfix, gfp.ATHlower * gfc.ATH.adjust);
        }

        /***************************************************************
         * determine final block type
         ***************************************************************/
        block_type_set(gfp, uselongblock, blocktype_d, blocktype);

        /*********************************************************************
         * compute the value of PE to return ... no delay and advance
         *********************************************************************/
        for (chn = 0; chn < numchn; chn++) {
            var ppe;
            var ppePos = 0;
            var type;
            var mr;

            if (chn > 1) {
                ppe = percep_MS_entropy;
                ppePos = -2;
                type = Encoder_1.NORM_TYPE;
                if (blocktype_d[0] == Encoder_1.SHORT_TYPE
                    || blocktype_d[1] == Encoder_1.SHORT_TYPE)
                    type = Encoder_1.SHORT_TYPE;
                mr = masking_MS_ratio[gr_out][chn - 2];
            } else {
                ppe = percep_entropy;
                ppePos = 0;
                type = blocktype_d[chn];
                mr = masking_ratio[gr_out][chn];
            }

            if (type == Encoder_1.SHORT_TYPE)
                ppe[ppePos + chn] = pecalc_s(mr, gfc.masking_lower);
            else
                ppe[ppePos + chn] = pecalc_l(mr, gfc.masking_lower);

            if (gfp.analysis)
                gfc.pinfo.pe[gr_out][chn] = ppe[ppePos + chn];

        }
        return 0;
    };

    function vbrpsy_compute_fft_l(gfp, buffer, bufPos, chn, gr_out, fftenergy, wsamp_l, wsamp_lPos) {
        var gfc = gfp.internal_flags;
        if (chn < 2) {
            fft.fft_long(gfc, wsamp_l[wsamp_lPos], chn, buffer, bufPos);
        } else if (chn == 2) {
            /* FFT data for mid and side channel is derived from L & R */
            for (var j = Encoder_1.BLKSIZE - 1; j >= 0; --j) {
                var l = wsamp_l[wsamp_lPos + 0][j];
                var r = wsamp_l[wsamp_lPos + 1][j];
                wsamp_l[wsamp_lPos + 0][j] = (l + r) * Util$3.SQRT2 * 0.5;
                wsamp_l[wsamp_lPos + 1][j] = (l - r) * Util$3.SQRT2 * 0.5;
            }
        }

        /*********************************************************************
         * compute energies
         *********************************************************************/
        fftenergy[0] = NON_LINEAR_SCALE_ENERGY(wsamp_l[wsamp_lPos + 0][0]);
        fftenergy[0] *= fftenergy[0];

        for (var j = Encoder_1.BLKSIZE / 2 - 1; j >= 0; --j) {
            var re = wsamp_l[wsamp_lPos + 0][Encoder_1.BLKSIZE / 2 - j];
            var im = wsamp_l[wsamp_lPos + 0][Encoder_1.BLKSIZE / 2 + j];
            fftenergy[Encoder_1.BLKSIZE / 2 - j] = NON_LINEAR_SCALE_ENERGY((re
                * re + im * im) * 0.5);
        }
        /* total energy */
        {
            var totalenergy = 0.0;
            for (var j = 11; j < Encoder_1.HBLKSIZE; j++)
                totalenergy += fftenergy[j];

            gfc.tot_ener[chn] = totalenergy;
        }

        if (gfp.analysis) {
            for (var j = 0; j < Encoder_1.HBLKSIZE; j++) {
                gfc.pinfo.energy[gr_out][chn][j] = gfc.pinfo.energy_save[chn][j];
                gfc.pinfo.energy_save[chn][j] = fftenergy[j];
            }
            gfc.pinfo.pe[gr_out][chn] = gfc.pe[chn];
        }
    }

    function vbrpsy_compute_fft_s(gfp, buffer, bufPos, chn, sblock, fftenergy_s, wsamp_s, wsamp_sPos) {
        var gfc = gfp.internal_flags;

        if (sblock == 0 && chn < 2) {
            fft.fft_short(gfc, wsamp_s[wsamp_sPos], chn, buffer, bufPos);
        }
        if (chn == 2) {
            /* FFT data for mid and side channel is derived from L & R */
            for (var j = Encoder_1.BLKSIZE_s - 1; j >= 0; --j) {
                var l = wsamp_s[wsamp_sPos + 0][sblock][j];
                var r = wsamp_s[wsamp_sPos + 1][sblock][j];
                wsamp_s[wsamp_sPos + 0][sblock][j] = (l + r) * Util$3.SQRT2 * 0.5;
                wsamp_s[wsamp_sPos + 1][sblock][j] = (l - r) * Util$3.SQRT2 * 0.5;
            }
        }

        /*********************************************************************
         * compute energies
         *********************************************************************/
        fftenergy_s[sblock][0] = wsamp_s[wsamp_sPos + 0][sblock][0];
        fftenergy_s[sblock][0] *= fftenergy_s[sblock][0];
        for (var j = Encoder_1.BLKSIZE_s / 2 - 1; j >= 0; --j) {
            var re = wsamp_s[wsamp_sPos + 0][sblock][Encoder_1.BLKSIZE_s / 2 - j];
            var im = wsamp_s[wsamp_sPos + 0][sblock][Encoder_1.BLKSIZE_s / 2 + j];
            fftenergy_s[sblock][Encoder_1.BLKSIZE_s / 2 - j] = NON_LINEAR_SCALE_ENERGY((re
                * re + im * im) * 0.5);
        }
    }

    /**
     * compute loudness approximation (used for ATH auto-level adjustment)
     */
    function vbrpsy_compute_loudness_approximation_l(gfp, gr_out, chn, fftenergy) {
        var gfc = gfp.internal_flags;
        if (gfp.athaa_loudapprox == 2 && chn < 2) {
            // no loudness for mid/side ch
            gfc.loudness_sq[gr_out][chn] = gfc.loudness_sq_save[chn];
            gfc.loudness_sq_save[chn] = psycho_loudness_approx(fftenergy, gfc);
        }
    }

    var fircoef_ = [-8.65163e-18 * 2,
        -0.00851586 * 2, -6.74764e-18 * 2, 0.0209036 * 2,
        -3.36639e-17 * 2, -0.0438162 * 2, -1.54175e-17 * 2,
        0.0931738 * 2, -5.52212e-17 * 2, -0.313819 * 2];

    /**
     * Apply HPF of fs/4 to the input signal. This is used for attack detection
     * / handling.
     */
    function vbrpsy_attack_detection(gfp, buffer, bufPos, gr_out, masking_ratio, masking_MS_ratio, energy, sub_short_factor, ns_attacks, uselongblock) {
        var ns_hpfsmpl = new_float_n$3([2, 576]);
        var gfc = gfp.internal_flags;
        var n_chn_out = gfc.channels_out;
        /* chn=2 and 3 = Mid and Side channels */
        var n_chn_psy = (gfp.mode == MPEGMode.JOINT_STEREO) ? 4 : n_chn_out;
        /* Don't copy the input buffer into a temporary buffer */
        /* unroll the loop 2 times */
        for (var chn = 0; chn < n_chn_out; chn++) {
            /* apply high pass filter of fs/4 */
            firbuf = buffer[chn];
            var firbufPos = bufPos + 576 - 350 - NSFIRLEN + 192;
            assert$3(fircoef_.length == ((NSFIRLEN - 1) / 2));
            for (var i = 0; i < 576; i++) {
                var sum1, sum2;
                sum1 = firbuf[firbufPos + i + 10];
                sum2 = 0.0;
                for (var j = 0; j < ((NSFIRLEN - 1) / 2) - 1; j += 2) {
                    sum1 += fircoef_[j]
                        * (firbuf[firbufPos + i + j] + firbuf[firbufPos + i
                        + NSFIRLEN - j]);
                    sum2 += fircoef_[j + 1]
                        * (firbuf[firbufPos + i + j + 1] + firbuf[firbufPos
                        + i + NSFIRLEN - j - 1]);
                }
                ns_hpfsmpl[chn][i] = sum1 + sum2;
            }
            masking_ratio[gr_out][chn].en.assign(gfc.en[chn]);
            masking_ratio[gr_out][chn].thm.assign(gfc.thm[chn]);
            if (n_chn_psy > 2) {
                /* MS maskings */
                /* percep_MS_entropy [chn-2] = gfc . pe [chn]; */
                masking_MS_ratio[gr_out][chn].en.assign(gfc.en[chn + 2]);
                masking_MS_ratio[gr_out][chn].thm.assign(gfc.thm[chn + 2]);
            }
        }
        for (var chn = 0; chn < n_chn_psy; chn++) {
            var attack_intensity = new_float$3(12);
            var en_subshort = new_float$3(12);
            var en_short = [0, 0, 0, 0];
            var pf = ns_hpfsmpl[chn & 1];
            var pfPos = 0;
            var attackThreshold = (chn == 3) ? gfc.nsPsy.attackthre_s
                : gfc.nsPsy.attackthre;
            var ns_uselongblock = 1;

            if (chn == 2) {
                for (var i = 0, j = 576; j > 0; ++i, --j) {
                    var l = ns_hpfsmpl[0][i];
                    var r = ns_hpfsmpl[1][i];
                    ns_hpfsmpl[0][i] = l + r;
                    ns_hpfsmpl[1][i] = l - r;
                }
            }
            /***************************************************************
             * determine the block type (window type)
             ***************************************************************/
            /* calculate energies of each sub-shortblocks */
            for (var i = 0; i < 3; i++) {
                en_subshort[i] = gfc.nsPsy.last_en_subshort[chn][i + 6];
                assert$3(gfc.nsPsy.last_en_subshort[chn][i + 4] > 0);
                attack_intensity[i] = en_subshort[i]
                    / gfc.nsPsy.last_en_subshort[chn][i + 4];
                en_short[0] += en_subshort[i];
            }

            for (var i = 0; i < 9; i++) {
                var pfe = pfPos + 576 / 9;
                var p = 1.;
                for (; pfPos < pfe; pfPos++)
                    if (p < Math.abs(pf[pfPos]))
                        p = Math.abs(pf[pfPos]);

                gfc.nsPsy.last_en_subshort[chn][i] = en_subshort[i + 3] = p;
                en_short[1 + i / 3] += p;
                if (p > en_subshort[i + 3 - 2]) {
                    assert$3(en_subshort[i + 3 - 2] > 0);
                    p = p / en_subshort[i + 3 - 2];
                } else if (en_subshort[i + 3 - 2] > p * 10.0) {
                    assert$3(p > 0);
                    p = en_subshort[i + 3 - 2] / (p * 10.0);
                } else {
                    p = 0.0;
                }
                attack_intensity[i + 3] = p;
            }
            /* pulse like signal detection for fatboy.wav and so on */
            for (var i = 0; i < 3; ++i) {
                var enn = en_subshort[i * 3 + 3]
                    + en_subshort[i * 3 + 4] + en_subshort[i * 3 + 5];
                var factor = 1.;
                if (en_subshort[i * 3 + 5] * 6 < enn) {
                    factor *= 0.5;
                    if (en_subshort[i * 3 + 4] * 6 < enn) {
                        factor *= 0.5;
                    }
                }
                sub_short_factor[chn][i] = factor;
            }

            if (gfp.analysis) {
                var x = attack_intensity[0];
                for (var i = 1; i < 12; i++) {
                    if (x < attack_intensity[i]) {
                        x = attack_intensity[i];
                    }
                }
                gfc.pinfo.ers[gr_out][chn] = gfc.pinfo.ers_save[chn];
                gfc.pinfo.ers_save[chn] = x;
            }

            /* compare energies between sub-shortblocks */
            for (var i = 0; i < 12; i++) {
                if (0 == ns_attacks[chn][i / 3]
                    && attack_intensity[i] > attackThreshold) {
                    ns_attacks[chn][i / 3] = (i % 3) + 1;
                }
            }

            /*
             * should have energy change between short blocks, in order to avoid
             * periodic signals
             */
            /* Good samples to show the effect are Trumpet test songs */
            /*
             * GB: tuned (1) to avoid too many short blocks for test sample
             * TRUMPET
             */
            /*
             * RH: tuned (2) to let enough short blocks through for test sample
             * FSOL and SNAPS
             */
            for (var i = 1; i < 4; i++) {
                var u = en_short[i - 1];
                var v = en_short[i];
                var m = Math.max(u, v);
                if (m < 40000) { /* (2) */
                    if (u < 1.7 * v && v < 1.7 * u) { /* (1) */
                        if (i == 1 && ns_attacks[chn][0] <= ns_attacks[chn][i]) {
                            ns_attacks[chn][0] = 0;
                        }
                        ns_attacks[chn][i] = 0;
                    }
                }
            }

            if (ns_attacks[chn][0] <= gfc.nsPsy.lastAttacks[chn]) {
                ns_attacks[chn][0] = 0;
            }

            if (gfc.nsPsy.lastAttacks[chn] == 3
                || (ns_attacks[chn][0] + ns_attacks[chn][1]
                + ns_attacks[chn][2] + ns_attacks[chn][3]) != 0) {
                ns_uselongblock = 0;

                if (ns_attacks[chn][1] != 0 && ns_attacks[chn][0] != 0) {
                    ns_attacks[chn][1] = 0;
                }
                if (ns_attacks[chn][2] != 0 && ns_attacks[chn][1] != 0) {
                    ns_attacks[chn][2] = 0;
                }
                if (ns_attacks[chn][3] != 0 && ns_attacks[chn][2] != 0) {
                    ns_attacks[chn][3] = 0;
                }
            }
            if (chn < 2) {
                uselongblock[chn] = ns_uselongblock;
            } else {
                if (ns_uselongblock == 0) {
                    uselongblock[0] = uselongblock[1] = 0;
                }
            }

            /*
             * there is a one granule delay. Copy maskings computed last call
             * into masking_ratio to return to calling program.
             */
            energy[chn] = gfc.tot_ener[chn];
        }
    }

    function vbrpsy_skip_masking_s(gfc, chn, sblock) {
        if (sblock == 0) {
            for (var b = 0; b < gfc.npart_s; b++) {
                gfc.nb_s2[chn][b] = gfc.nb_s1[chn][b];
                gfc.nb_s1[chn][b] = 0;
            }
        }
    }

    function vbrpsy_skip_masking_l(gfc, chn) {
        for (var b = 0; b < gfc.npart_l; b++) {
            gfc.nb_2[chn][b] = gfc.nb_1[chn][b];
            gfc.nb_1[chn][b] = 0;
        }
    }

    function psyvbr_calc_mask_index_s(gfc, max, avg, mask_idx) {
        var last_tab_entry = tab.length - 1;
        var b = 0;
        var a = avg[b] + avg[b + 1];
        assert$3(a >= 0);
        if (a > 0.0) {
            var m = max[b];
            if (m < max[b + 1])
                m = max[b + 1];
            assert$3((gfc.numlines_s[b] + gfc.numlines_s[b + 1] - 1) > 0);
            a = 20.0 * (m * 2.0 - a)
                / (a * (gfc.numlines_s[b] + gfc.numlines_s[b + 1] - 1));
            var k = 0 | a;
            if (k > last_tab_entry)
                k = last_tab_entry;
            mask_idx[b] = k;
        } else {
            mask_idx[b] = 0;
        }

        for (b = 1; b < gfc.npart_s - 1; b++) {
            a = avg[b - 1] + avg[b] + avg[b + 1];
            assert$3(b + 1 < gfc.npart_s);
            assert$3(a >= 0);
            if (a > 0.0) {
                var m = max[b - 1];
                if (m < max[b])
                    m = max[b];
                if (m < max[b + 1])
                    m = max[b + 1];
                assert$3((gfc.numlines_s[b - 1] + gfc.numlines_s[b] + gfc.numlines_s[b + 1] - 1) > 0);
                a = 20.0
                    * (m * 3.0 - a)
                    / (a * (gfc.numlines_s[b - 1] + gfc.numlines_s[b]
                    + gfc.numlines_s[b + 1] - 1));
                var k = 0 | a;
                if (k > last_tab_entry)
                    k = last_tab_entry;
                mask_idx[b] = k;
            } else {
                mask_idx[b] = 0;
            }
        }
        assert$3(b > 0);
        assert$3(b == gfc.npart_s - 1);

        a = avg[b - 1] + avg[b];
        assert$3(a >= 0);
        if (a > 0.0) {
            var m = max[b - 1];
            if (m < max[b])
                m = max[b];
            assert$3((gfc.numlines_s[b - 1] + gfc.numlines_s[b] - 1) > 0);
            a = 20.0 * (m * 2.0 - a)
                / (a * (gfc.numlines_s[b - 1] + gfc.numlines_s[b] - 1));
            var k = 0 | a;
            if (k > last_tab_entry)
                k = last_tab_entry;
            mask_idx[b] = k;
        } else {
            mask_idx[b] = 0;
        }
        assert$3(b == (gfc.npart_s - 1));
    }

    function vbrpsy_compute_masking_s(gfp, fftenergy_s, eb, thr, chn, sblock) {
        var gfc = gfp.internal_flags;
        var max = new float[Encoder_1.CBANDS], avg = new_float$3(Encoder_1.CBANDS);
        var i, j, b;
        var mask_idx_s = new int[Encoder_1.CBANDS];

        for (b = j = 0; b < gfc.npart_s; ++b) {
            var ebb = 0, m = 0;
            var n = gfc.numlines_s[b];
            for (i = 0; i < n; ++i, ++j) {
                var el = fftenergy_s[sblock][j];
                ebb += el;
                if (m < el)
                    m = el;
            }
            eb[b] = ebb;
            assert$3(ebb >= 0);
            max[b] = m;
            assert$3(n > 0);
            avg[b] = ebb / n;
            assert$3(avg[b] >= 0);
        }
        assert$3(b == gfc.npart_s);
        assert$3(j == 129);
        for (; b < Encoder_1.CBANDS; ++b) {
            max[b] = 0;
            avg[b] = 0;
        }
        psyvbr_calc_mask_index_s(gfc, max, avg, mask_idx_s);
        for (j = b = 0; b < gfc.npart_s; b++) {
            var kk = gfc.s3ind_s[b][0];
            var last = gfc.s3ind_s[b][1];
            var dd, dd_n;
            var x, ecb, avg_mask;
            dd = mask_idx_s[kk];
            dd_n = 1;
            ecb = gfc.s3_ss[j] * eb[kk] * tab[mask_idx_s[kk]];
            ++j;
            ++kk;
            while (kk <= last) {
                dd += mask_idx_s[kk];
                dd_n += 1;
                x = gfc.s3_ss[j] * eb[kk] * tab[mask_idx_s[kk]];
                ecb = vbrpsy_mask_add(ecb, x, kk - b);
                ++j;
                ++kk;
            }
            dd = (1 + 2 * dd) / (2 * dd_n);
            avg_mask = tab[dd] * 0.5;
            ecb *= avg_mask;
            thr[b] = ecb;
            gfc.nb_s2[chn][b] = gfc.nb_s1[chn][b];
            gfc.nb_s1[chn][b] = ecb;
            {
                /*
                 * if THR exceeds EB, the quantization routines will take the
                 * difference from other bands. in case of strong tonal samples
                 * (tonaltest.wav) this leads to heavy distortions. that's why
                 * we limit THR here.
                 */
                x = max[b];
                x *= gfc.minval_s[b];
                x *= avg_mask;
                if (thr[b] > x) {
                    thr[b] = x;
                }
            }
            if (gfc.masking_lower > 1) {
                thr[b] *= gfc.masking_lower;
            }
            if (thr[b] > eb[b]) {
                thr[b] = eb[b];
            }
            if (gfc.masking_lower < 1) {
                thr[b] *= gfc.masking_lower;
            }

            assert$3(thr[b] >= 0);
        }
        for (; b < Encoder_1.CBANDS; ++b) {
            eb[b] = 0;
            thr[b] = 0;
        }
    }

    function vbrpsy_compute_masking_l(gfc, fftenergy, eb_l, thr, chn) {
        var max = new_float$3(Encoder_1.CBANDS), avg = new_float$3(Encoder_1.CBANDS);
        var mask_idx_l = new_int$3(Encoder_1.CBANDS + 2);
        var b;

        /*********************************************************************
         * Calculate the energy and the tonality of each partition.
         *********************************************************************/
        calc_energy(gfc, fftenergy, eb_l, max, avg);
        calc_mask_index_l(gfc, max, avg, mask_idx_l);

        /*********************************************************************
         * convolve the partitioned energy and unpredictability with the
         * spreading function, s3_l[b][k]
         ********************************************************************/
        var k = 0;
        for (b = 0; b < gfc.npart_l; b++) {
            var x, ecb, avg_mask, t;
            /* convolve the partitioned energy with the spreading function */
            var kk = gfc.s3ind[b][0];
            var last = gfc.s3ind[b][1];
            var dd = 0, dd_n = 0;
            dd = mask_idx_l[kk];
            dd_n += 1;
            ecb = gfc.s3_ll[k] * eb_l[kk] * tab[mask_idx_l[kk]];
            ++k;
            ++kk;
            while (kk <= last) {
                dd += mask_idx_l[kk];
                dd_n += 1;
                x = gfc.s3_ll[k] * eb_l[kk] * tab[mask_idx_l[kk]];
                t = vbrpsy_mask_add(ecb, x, kk - b);
                ecb = t;
                ++k;
                ++kk;
            }
            dd = (1 + 2 * dd) / (2 * dd_n);
            avg_mask = tab[dd] * 0.5;
            ecb *= avg_mask;

            /**** long block pre-echo control ****/
            /**
             * <PRE>
             * dont use long block pre-echo control if previous granule was
             * a short block.  This is to avoid the situation:
             * frame0:  quiet (very low masking)
             * frame1:  surge  (triggers short blocks)
             * frame2:  regular frame.  looks like pre-echo when compared to
             *          frame0, but all pre-echo was in frame1.
             * </PRE>
             */
            /*
             * chn=0,1 L and R channels chn=2,3 S and M channels.
             */
            if (gfc.blocktype_old[chn & 0x01] == Encoder_1.SHORT_TYPE) {
                var ecb_limit = rpelev * gfc.nb_1[chn][b];
                if (ecb_limit > 0) {
                    thr[b] = Math.min(ecb, ecb_limit);
                } else {
                    /**
                     * <PRE>
                     * Robert 071209:
                     * Because we don't calculate long block psy when we know a granule
                     * should be of short blocks, we don't have any clue how the granule
                     * before would have looked like as a long block. So we have to guess
                     * a little bit for this END_TYPE block.
                     * Most of the time we get away with this sloppyness. (fingers crossed :)
                     * The speed increase is worth it.
                     * </PRE>
                     */
                    thr[b] = Math.min(ecb, eb_l[b] * NS_PREECHO_ATT2);
                }
            } else {
                var ecb_limit_2 = rpelev2 * gfc.nb_2[chn][b];
                var ecb_limit_1 = rpelev * gfc.nb_1[chn][b];
                var ecb_limit;
                if (ecb_limit_2 <= 0) {
                    ecb_limit_2 = ecb;
                }
                if (ecb_limit_1 <= 0) {
                    ecb_limit_1 = ecb;
                }
                if (gfc.blocktype_old[chn & 0x01] == Encoder_1.NORM_TYPE) {
                    ecb_limit = Math.min(ecb_limit_1, ecb_limit_2);
                } else {
                    ecb_limit = ecb_limit_1;
                }
                thr[b] = Math.min(ecb, ecb_limit);
            }
            gfc.nb_2[chn][b] = gfc.nb_1[chn][b];
            gfc.nb_1[chn][b] = ecb;
            {
                /*
                 * if THR exceeds EB, the quantization routines will take the
                 * difference from other bands. in case of strong tonal samples
                 * (tonaltest.wav) this leads to heavy distortions. that's why
                 * we limit THR here.
                 */
                x = max[b];
                x *= gfc.minval_l[b];
                x *= avg_mask;
                if (thr[b] > x) {
                    thr[b] = x;
                }
            }
            if (gfc.masking_lower > 1) {
                thr[b] *= gfc.masking_lower;
            }
            if (thr[b] > eb_l[b]) {
                thr[b] = eb_l[b];
            }
            if (gfc.masking_lower < 1) {
                thr[b] *= gfc.masking_lower;
            }
            assert$3(thr[b] >= 0);
        }
        for (; b < Encoder_1.CBANDS; ++b) {
            eb_l[b] = 0;
            thr[b] = 0;
        }
    }

    function vbrpsy_compute_block_type(gfp, uselongblock) {
        var gfc = gfp.internal_flags;

        if (gfp.short_blocks == ShortBlock$3.short_block_coupled
                /* force both channels to use the same block type */
                /* this is necessary if the frame is to be encoded in ms_stereo. */
                /* But even without ms_stereo, FhG does this */
            && !(uselongblock[0] != 0 && uselongblock[1] != 0))
            uselongblock[0] = uselongblock[1] = 0;

        for (var chn = 0; chn < gfc.channels_out; chn++) {
            /* disable short blocks */
            if (gfp.short_blocks == ShortBlock$3.short_block_dispensed) {
                uselongblock[chn] = 1;
            }
            if (gfp.short_blocks == ShortBlock$3.short_block_forced) {
                uselongblock[chn] = 0;
            }
        }
    }

    function vbrpsy_apply_block_type(gfp, uselongblock, blocktype_d) {
        var gfc = gfp.internal_flags;

        /*
         * update the blocktype of the previous granule, since it depends on
         * what happend in this granule
         */
        for (var chn = 0; chn < gfc.channels_out; chn++) {
            var blocktype = Encoder_1.NORM_TYPE;
            /* disable short blocks */

            if (uselongblock[chn] != 0) {
                /* no attack : use long blocks */
                assert$3(gfc.blocktype_old[chn] != Encoder_1.START_TYPE);
                if (gfc.blocktype_old[chn] == Encoder_1.SHORT_TYPE)
                    blocktype = Encoder_1.STOP_TYPE;
            } else {
                /* attack : use short blocks */
                blocktype = Encoder_1.SHORT_TYPE;
                if (gfc.blocktype_old[chn] == Encoder_1.NORM_TYPE) {
                    gfc.blocktype_old[chn] = Encoder_1.START_TYPE;
                }
                if (gfc.blocktype_old[chn] == Encoder_1.STOP_TYPE)
                    gfc.blocktype_old[chn] = Encoder_1.SHORT_TYPE;
            }

            blocktype_d[chn] = gfc.blocktype_old[chn];
            // value returned to calling program
            gfc.blocktype_old[chn] = blocktype;
            // save for next call to l3psy_anal
        }
    }

    /**
     * compute M/S thresholds from Johnston & Ferreira 1992 ICASSP paper
     */
    function vbrpsy_compute_MS_thresholds(eb, thr, cb_mld, ath_cb, athadjust, msfix, n) {
        var msfix2 = msfix * 2;
        var athlower = msfix > 0 ? Math.pow(10, athadjust) : 1;
        var rside, rmid;
        for (var b = 0; b < n; ++b) {
            var ebM = eb[2][b];
            var ebS = eb[3][b];
            var thmL = thr[0][b];
            var thmR = thr[1][b];
            var thmM = thr[2][b];
            var thmS = thr[3][b];

            /* use this fix if L & R masking differs by 2db or less */
            if (thmL <= 1.58 * thmR && thmR <= 1.58 * thmL) {
                var mld_m = cb_mld[b] * ebS;
                var mld_s = cb_mld[b] * ebM;
                rmid = Math.max(thmM, Math.min(thmS, mld_m));
                rside = Math.max(thmS, Math.min(thmM, mld_s));
            } else {
                rmid = thmM;
                rside = thmS;
            }
            if (msfix > 0) {
                /***************************************************************/
                /* Adjust M/S maskings if user set "msfix" */
                /***************************************************************/
                /* Naoki Shibata 2000 */
                var thmLR, thmMS;
                var ath = ath_cb[b] * athlower;
                thmLR = Math.min(Math.max(thmL, ath), Math.max(thmR, ath));
                thmM = Math.max(rmid, ath);
                thmS = Math.max(rside, ath);
                thmMS = thmM + thmS;
                if (thmMS > 0 && (thmLR * msfix2) < thmMS) {
                    var f = thmLR * msfix2 / thmMS;
                    thmM *= f;
                    thmS *= f;
                    assert$3(thmMS > 0);
                }
                rmid = Math.min(thmM, rmid);
                rside = Math.min(thmS, rside);
            }
            if (rmid > ebM) {
                rmid = ebM;
            }
            if (rside > ebS) {
                rside = ebS;
            }
            thr[2][b] = rmid;
            thr[3][b] = rside;
        }
    }

    this.L3psycho_anal_vbr = function (gfp, buffer, bufPos, gr_out, masking_ratio, masking_MS_ratio, percep_entropy, percep_MS_entropy, energy, blocktype_d) {
        var gfc = gfp.internal_flags;

        /* fft and energy calculation */
        var wsamp_l;
        var wsamp_s;
        var fftenergy = new_float$3(Encoder_1.HBLKSIZE);
        var fftenergy_s = new_float_n$3([3, Encoder_1.HBLKSIZE_s]);
        var wsamp_L = new_float_n$3([2, Encoder_1.BLKSIZE]);
        var wsamp_S = new_float_n$3([2, 3, Encoder_1.BLKSIZE_s]);
        var eb = new_float_n$3([4, Encoder_1.CBANDS]), thr = new_float_n$3([4, Encoder_1.CBANDS]);
        var sub_short_factor = new_float_n$3([4, 3]);
        var pcfact = 0.6;

        /* block type */
        var ns_attacks = [[0, 0, 0, 0], [0, 0, 0, 0], [0, 0, 0, 0],
            [0, 0, 0, 0]];
        var uselongblock = new_int$3(2);

        /* usual variables like loop indices, etc.. */

        /* chn=2 and 3 = Mid and Side channels */
        var n_chn_psy = (gfp.mode == MPEGMode.JOINT_STEREO) ? 4
            : gfc.channels_out;

        vbrpsy_attack_detection(gfp, buffer, bufPos, gr_out, masking_ratio,
            masking_MS_ratio, energy, sub_short_factor, ns_attacks,
            uselongblock);

        vbrpsy_compute_block_type(gfp, uselongblock);

        /* LONG BLOCK CASE */
        {
            for (var chn = 0; chn < n_chn_psy; chn++) {
                var ch01 = chn & 0x01;
                wsamp_l = wsamp_L;
                vbrpsy_compute_fft_l(gfp, buffer, bufPos, chn, gr_out,
                    fftenergy, wsamp_l, ch01);

                vbrpsy_compute_loudness_approximation_l(gfp, gr_out, chn,
                    fftenergy);

                if (uselongblock[ch01] != 0) {
                    vbrpsy_compute_masking_l(gfc, fftenergy, eb[chn], thr[chn],
                        chn);
                } else {
                    vbrpsy_skip_masking_l(gfc, chn);
                }
            }
            if ((uselongblock[0] + uselongblock[1]) == 2) {
                /* M/S channel */
                if (gfp.mode == MPEGMode.JOINT_STEREO) {
                    vbrpsy_compute_MS_thresholds(eb, thr, gfc.mld_cb_l,
                        gfc.ATH.cb_l, gfp.ATHlower * gfc.ATH.adjust,
                        gfp.msfix, gfc.npart_l);
                }
            }
            /* TODO: apply adaptive ATH masking here ?? */
            for (var chn = 0; chn < n_chn_psy; chn++) {
                var ch01 = chn & 0x01;
                if (uselongblock[ch01] != 0) {
                    convert_partition2scalefac_l(gfc, eb[chn], thr[chn], chn);
                }
            }
        }

        /* SHORT BLOCKS CASE */
        {
            for (var sblock = 0; sblock < 3; sblock++) {
                for (var chn = 0; chn < n_chn_psy; ++chn) {
                    var ch01 = chn & 0x01;

                    if (uselongblock[ch01] != 0) {
                        vbrpsy_skip_masking_s(gfc, chn, sblock);
                    } else {
                        /* compute masking thresholds for short blocks */
                        wsamp_s = wsamp_S;
                        vbrpsy_compute_fft_s(gfp, buffer, bufPos, chn, sblock,
                            fftenergy_s, wsamp_s, ch01);
                        vbrpsy_compute_masking_s(gfp, fftenergy_s, eb[chn],
                            thr[chn], chn, sblock);
                    }
                }
                if ((uselongblock[0] + uselongblock[1]) == 0) {
                    /* M/S channel */
                    if (gfp.mode == MPEGMode.JOINT_STEREO) {
                        vbrpsy_compute_MS_thresholds(eb, thr, gfc.mld_cb_s,
                            gfc.ATH.cb_s, gfp.ATHlower * gfc.ATH.adjust,
                            gfp.msfix, gfc.npart_s);
                    }
                    /* L/R channel */
                }
                /* TODO: apply adaptive ATH masking here ?? */
                for (var chn = 0; chn < n_chn_psy; ++chn) {
                    var ch01 = chn & 0x01;
                    if (0 == uselongblock[ch01]) {
                        convert_partition2scalefac_s(gfc, eb[chn], thr[chn],
                            chn, sblock);
                    }
                }
            }

            /**** short block pre-echo control ****/
            for (var chn = 0; chn < n_chn_psy; chn++) {
                var ch01 = chn & 0x01;

                if (uselongblock[ch01] != 0) {
                    continue;
                }
                for (var sb = 0; sb < Encoder_1.SBMAX_s; sb++) {
                    var new_thmm = new_float$3(3);
                    for (var sblock = 0; sblock < 3; sblock++) {
                        var thmm = gfc.thm[chn].s[sb][sblock];
                        thmm *= NS_PREECHO_ATT0;

                        if (ns_attacks[chn][sblock] >= 2
                            || ns_attacks[chn][sblock + 1] == 1) {
                            var idx = (sblock != 0) ? sblock - 1 : 2;
                            var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm,
                                NS_PREECHO_ATT1 * pcfact);
                            thmm = Math.min(thmm, p);
                        } else if (ns_attacks[chn][sblock] == 1) {
                            var idx = (sblock != 0) ? sblock - 1 : 2;
                            var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm,
                                NS_PREECHO_ATT2 * pcfact);
                            thmm = Math.min(thmm, p);
                        } else if ((sblock != 0 && ns_attacks[chn][sblock - 1] == 3)
                            || (sblock == 0 && gfc.nsPsy.lastAttacks[chn] == 3)) {
                            var idx = (sblock != 2) ? sblock + 1 : 0;
                            var p = NS_INTERP(gfc.thm[chn].s[sb][idx], thmm,
                                NS_PREECHO_ATT2 * pcfact);
                            thmm = Math.min(thmm, p);
                        }

                        /* pulse like signal detection for fatboy.wav and so on */
                        thmm *= sub_short_factor[chn][sblock];

                        new_thmm[sblock] = thmm;
                    }
                    for (var sblock = 0; sblock < 3; sblock++) {
                        gfc.thm[chn].s[sb][sblock] = new_thmm[sblock];
                    }
                }
            }
        }
        for (var chn = 0; chn < n_chn_psy; chn++) {
            gfc.nsPsy.lastAttacks[chn] = ns_attacks[chn][2];
        }

        /***************************************************************
         * determine final block type
         ***************************************************************/
        vbrpsy_apply_block_type(gfp, uselongblock, blocktype_d);

        /*********************************************************************
         * compute the value of PE to return ... no delay and advance
         *********************************************************************/
        for (var chn = 0; chn < n_chn_psy; chn++) {
            var ppe;
            var ppePos;
            var type;
            var mr;

            if (chn > 1) {
                ppe = percep_MS_entropy;
                ppePos = -2;
                type = Encoder_1.NORM_TYPE;
                if (blocktype_d[0] == Encoder_1.SHORT_TYPE
                    || blocktype_d[1] == Encoder_1.SHORT_TYPE)
                    type = Encoder_1.SHORT_TYPE;
                mr = masking_MS_ratio[gr_out][chn - 2];
            } else {
                ppe = percep_entropy;
                ppePos = 0;
                type = blocktype_d[chn];
                mr = masking_ratio[gr_out][chn];
            }

            if (type == Encoder_1.SHORT_TYPE) {
                ppe[ppePos + chn] = pecalc_s(mr, gfc.masking_lower);
            } else {
                ppe[ppePos + chn] = pecalc_l(mr, gfc.masking_lower);
            }

            if (gfp.analysis) {
                gfc.pinfo.pe[gr_out][chn] = ppe[ppePos + chn];
            }
        }
        return 0;
    };

    function s3_func_x(bark, hf_slope) {
        var tempx = bark, tempy;

        if (tempx >= 0) {
            tempy = -tempx * 27;
        } else {
            tempy = tempx * hf_slope;
        }
        if (tempy <= -72.0) {
            return 0;
        }
        return Math.exp(tempy * LN_TO_LOG10);
    }

    function norm_s3_func_x(hf_slope) {
        var lim_a = 0, lim_b = 0;
        {
            var x = 0, l, h;
            for (x = 0; s3_func_x(x, hf_slope) > 1e-20; x -= 1)
                ;
            l = x;
            h = 0;
            while (Math.abs(h - l) > 1e-12) {
                x = (h + l) / 2;
                if (s3_func_x(x, hf_slope) > 0) {
                    h = x;
                } else {
                    l = x;
                }
            }
            lim_a = l;
        }
        {
            var x = 0, l, h;
            for (x = 0; s3_func_x(x, hf_slope) > 1e-20; x += 1)
                ;
            l = 0;
            h = x;
            while (Math.abs(h - l) > 1e-12) {
                x = (h + l) / 2;
                if (s3_func_x(x, hf_slope) > 0) {
                    l = x;
                } else {
                    h = x;
                }
            }
            lim_b = h;
        }
        {
            var sum = 0;
            var m = 1000;
            var i;
            for (i = 0; i <= m; ++i) {
                var x = lim_a + i * (lim_b - lim_a) / m;
                var y = s3_func_x(x, hf_slope);
                sum += y;
            }
            {
                var norm = (m + 1) / (sum * (lim_b - lim_a));
                /* printf( "norm = %lf\n",norm); */
                return norm;
            }
        }
    }

    /**
     *   The spreading function.  Values returned in units of energy
     */
    function s3_func(bark) {
        var tempx, x, tempy, temp;
        tempx = bark;
        if (tempx >= 0)
            tempx *= 3;
        else
            tempx *= 1.5;

        if (tempx >= 0.5 && tempx <= 2.5) {
            temp = tempx - 0.5;
            x = 8.0 * (temp * temp - 2.0 * temp);
        } else
            x = 0.0;
        tempx += 0.474;
        tempy = 15.811389 + 7.5 * tempx - 17.5
            * Math.sqrt(1.0 + tempx * tempx);

        if (tempy <= -60.0)
            return 0.0;

        tempx = Math.exp((x + tempy) * LN_TO_LOG10);

        /**
         * <PRE>
         * Normalization.  The spreading function should be normalized so that:
         * +inf
         * /
         * |  s3 [ bark ]  d(bark)   =  1
         * /
         * -inf
         * </PRE>
         */
        tempx /= .6609193;
        return tempx;
    }

    /**
     * see for example "Zwicker: Psychoakustik, 1982; ISBN 3-540-11401-7
     */
    function freq2bark(freq) {
        /* input: freq in hz output: barks */
        if (freq < 0)
            freq = 0;
        freq = freq * 0.001;
        return 13.0 * Math.atan(.76 * freq) + 3.5
            * Math.atan(freq * freq / (7.5 * 7.5));
    }

    function init_numline(numlines, bo, bm, bval, bval_width, mld, bo_w, sfreq, blksize, scalepos, deltafreq, sbmax) {
        var b_frq = new_float$3(Encoder_1.CBANDS + 1);
        var sample_freq_frac = sfreq / (sbmax > 15 ? 2 * 576 : 2 * 192);
        var partition = new_int$3(Encoder_1.HBLKSIZE);
        var i;
        sfreq /= blksize;
        var j = 0;
        var ni = 0;
        /* compute numlines, the number of spectral lines in each partition band */
        /* each partition band should be about DELBARK wide. */
        for (i = 0; i < Encoder_1.CBANDS; i++) {
            var bark1;
            var j2;
            bark1 = freq2bark(sfreq * j);

            b_frq[i] = sfreq * j;

            for (j2 = j; freq2bark(sfreq * j2) - bark1 < DELBARK
            && j2 <= blksize / 2; j2++)
                ;

            numlines[i] = j2 - j;
            ni = i + 1;

            while (j < j2) {
                assert$3(j < Encoder_1.HBLKSIZE);
                partition[j++] = i;
            }
            if (j > blksize / 2) {
                j = blksize / 2;
                ++i;
                break;
            }
        }
        assert$3(i < Encoder_1.CBANDS);
        b_frq[i] = sfreq * j;

        for (var sfb = 0; sfb < sbmax; sfb++) {
            var i1, i2, start, end;
            var arg;
            start = scalepos[sfb];
            end = scalepos[sfb + 1];

            i1 = 0 | Math.floor(.5 + deltafreq * (start - .5));
            if (i1 < 0)
                i1 = 0;
            i2 = 0 | Math.floor(.5 + deltafreq * (end - .5));

            if (i2 > blksize / 2)
                i2 = blksize / 2;

            bm[sfb] = (partition[i1] + partition[i2]) / 2;
            bo[sfb] = partition[i2];
            var f_tmp = sample_freq_frac * end;
            /*
             * calculate how much of this band belongs to current scalefactor
             * band
             */
            bo_w[sfb] = (f_tmp - b_frq[bo[sfb]])
                / (b_frq[bo[sfb] + 1] - b_frq[bo[sfb]]);
            if (bo_w[sfb] < 0) {
                bo_w[sfb] = 0;
            } else {
                if (bo_w[sfb] > 1) {
                    bo_w[sfb] = 1;
                }
            }
            /* setup stereo demasking thresholds */
            /* formula reverse enginerred from plot in paper */
            arg = freq2bark(sfreq * scalepos[sfb] * deltafreq);
            arg = ( Math.min(arg, 15.5) / 15.5);

            mld[sfb] = Math.pow(10.0,
                1.25 * (1 - Math.cos(Math.PI * arg)) - 2.5);
        }

        /* compute bark values of each critical band */
        j = 0;
        for (var k = 0; k < ni; k++) {
            var w = numlines[k];
            var bark1, bark2;

            bark1 = freq2bark(sfreq * (j));
            bark2 = freq2bark(sfreq * (j + w - 1));
            bval[k] = .5 * (bark1 + bark2);

            bark1 = freq2bark(sfreq * (j - .5));
            bark2 = freq2bark(sfreq * (j + w - .5));
            bval_width[k] = bark2 - bark1;
            j += w;
        }

        return ni;
    }

    function init_s3_values(s3ind, npart, bval, bval_width, norm, use_old_s3) {
        var s3 = new_float_n$3([Encoder_1.CBANDS, Encoder_1.CBANDS]);
        /*
         * The s3 array is not linear in the bark scale.
         *
         * bval[x] should be used to get the bark value.
         */
        var j;
        var numberOfNoneZero = 0;

        /**
         * <PRE>
         * s[i][j], the value of the spreading function,
         * centered at band j (masker), for band i (maskee)
         *
         * i.e.: sum over j to spread into signal barkval=i
         * NOTE: i and j are used opposite as in the ISO docs
         * </PRE>
         */
        if (use_old_s3) {
            for (var i = 0; i < npart; i++) {
                for (j = 0; j < npart; j++) {
                    var v = s3_func(bval[i] - bval[j]) * bval_width[j];
                    s3[i][j] = v * norm[i];
                }
            }
        } else {
            for (j = 0; j < npart; j++) {
                var hf_slope = 15 + Math.min(21 / bval[j], 12);
                var s3_x_norm = norm_s3_func_x(hf_slope);
                for (var i = 0; i < npart; i++) {
                    var v = s3_x_norm
                        * s3_func_x(bval[i] - bval[j], hf_slope)
                        * bval_width[j];
                    s3[i][j] = v * norm[i];
                }
            }
        }
        for (var i = 0; i < npart; i++) {
            for (j = 0; j < npart; j++) {
                if (s3[i][j] > 0.0)
                    break;
            }
            s3ind[i][0] = j;

            for (j = npart - 1; j > 0; j--) {
                if (s3[i][j] > 0.0)
                    break;
            }
            s3ind[i][1] = j;
            numberOfNoneZero += (s3ind[i][1] - s3ind[i][0] + 1);
        }

        var p = new_float$3(numberOfNoneZero);
        var k = 0;
        for (var i = 0; i < npart; i++)
            for (j = s3ind[i][0]; j <= s3ind[i][1]; j++)
                p[k++] = s3[i][j];

        return p;
    }

    function stereo_demask(f) {
        /* setup stereo demasking thresholds */
        /* formula reverse enginerred from plot in paper */
        var arg = freq2bark(f);
        arg = (Math.min(arg, 15.5) / 15.5);

        return Math.pow(10.0,
            1.25 * (1 - Math.cos(Math.PI * arg)) - 2.5);
    }

    /**
     * NOTE: the bitrate reduction from the inter-channel masking effect is low
     * compared to the chance of getting annyoing artefacts. L3psycho_anal_vbr
     * does not use this feature. (Robert 071216)
     */
    this.psymodel_init = function (gfp) {
        var gfc = gfp.internal_flags;
        var i;
        var useOldS3 = true;
        var bvl_a = 13, bvl_b = 24;
        var snr_l_a = 0, snr_l_b = 0;
        var snr_s_a = -8.25, snr_s_b = -4.5;
        var bval = new_float$3(Encoder_1.CBANDS);
        var bval_width = new_float$3(Encoder_1.CBANDS);
        var norm = new_float$3(Encoder_1.CBANDS);
        var sfreq = gfp.out_samplerate;

        switch (gfp.experimentalZ) {
            default:
            case 0:
                useOldS3 = true;
                break;
            case 1:
                useOldS3 = (gfp.VBR == VbrMode$3.vbr_mtrh || gfp.VBR == VbrMode$3.vbr_mt) ? false
                    : true;
                break;
            case 2:
                useOldS3 = false;
                break;
            case 3:
                bvl_a = 8;
                snr_l_a = -1.75;
                snr_l_b = -0.0125;
                snr_s_a = -8.25;
                snr_s_b = -2.25;
                break;
        }
        gfc.ms_ener_ratio_old = .25;
        gfc.blocktype_old[0] = gfc.blocktype_old[1] = Encoder_1.NORM_TYPE;
        // the vbr header is long blocks

        for (i = 0; i < 4; ++i) {
            for (var j = 0; j < Encoder_1.CBANDS; ++j) {
                gfc.nb_1[i][j] = 1e20;
                gfc.nb_2[i][j] = 1e20;
                gfc.nb_s1[i][j] = gfc.nb_s2[i][j] = 1.0;
            }
            for (var sb = 0; sb < Encoder_1.SBMAX_l; sb++) {
                gfc.en[i].l[sb] = 1e20;
                gfc.thm[i].l[sb] = 1e20;
            }
            for (var j = 0; j < 3; ++j) {
                for (var sb = 0; sb < Encoder_1.SBMAX_s; sb++) {
                    gfc.en[i].s[sb][j] = 1e20;
                    gfc.thm[i].s[sb][j] = 1e20;
                }
                gfc.nsPsy.lastAttacks[i] = 0;
            }
            for (var j = 0; j < 9; j++)
                gfc.nsPsy.last_en_subshort[i][j] = 10.;
        }

        /* init. for loudness approx. -jd 2001 mar 27 */
        gfc.loudness_sq_save[0] = gfc.loudness_sq_save[1] = 0.0;

        /*************************************************************************
         * now compute the psychoacoustic model specific constants
         ************************************************************************/
        /* compute numlines, bo, bm, bval, bval_width, mld */

        gfc.npart_l = init_numline(gfc.numlines_l, gfc.bo_l, gfc.bm_l, bval,
            bval_width, gfc.mld_l, gfc.PSY.bo_l_weight, sfreq,
            Encoder_1.BLKSIZE, gfc.scalefac_band.l, Encoder_1.BLKSIZE
            / (2.0 * 576), Encoder_1.SBMAX_l);
        assert$3(gfc.npart_l < Encoder_1.CBANDS);
        /* compute the spreading function */
        for (i = 0; i < gfc.npart_l; i++) {
            var snr = snr_l_a;
            if (bval[i] >= bvl_a) {
                snr = snr_l_b * (bval[i] - bvl_a) / (bvl_b - bvl_a) + snr_l_a
                    * (bvl_b - bval[i]) / (bvl_b - bvl_a);
            }
            norm[i] = Math.pow(10.0, snr / 10.0);
            if (gfc.numlines_l[i] > 0) {
                gfc.rnumlines_l[i] = 1.0 / gfc.numlines_l[i];
            } else {
                gfc.rnumlines_l[i] = 0;
            }
        }
        gfc.s3_ll = init_s3_values(gfc.s3ind, gfc.npart_l, bval, bval_width,
            norm, useOldS3);

        /* compute long block specific values, ATH and MINVAL */
        var j = 0;
        for (i = 0; i < gfc.npart_l; i++) {
            var x;

            /* ATH */
            x = Float$3.MAX_VALUE;
            for (var k = 0; k < gfc.numlines_l[i]; k++, j++) {
                var freq = sfreq * j / (1000.0 * Encoder_1.BLKSIZE);
                var level;
                /*
                 * ATH below 100 Hz constant, not further climbing
                 */
                level = this.ATHformula(freq * 1000, gfp) - 20;
                // scale to FFT units; returned value is in dB
                level = Math.pow(10., 0.1 * level);
                // convert from dB . energy
                level *= gfc.numlines_l[i];
                if (x > level)
                    x = level;
            }
            gfc.ATH.cb_l[i] = x;

            /*
             * MINVAL. For low freq, the strength of the masking is limited by
             * minval this is an ISO MPEG1 thing, dont know if it is really
             * needed
             */
            /*
             * FIXME: it does work to reduce low-freq problems in S53-Wind-Sax
             * and lead-voice samples, but introduces some 3 kbps bit bloat too.
             * TODO: Further refinement of the shape of this hack.
             */
            x = -20 + bval[i] * 20 / 10;
            if (x > 6) {
                x = 100;
            }
            if (x < -15) {
                x = -15;
            }
            x -= 8.;
            gfc.minval_l[i] = (Math.pow(10.0, x / 10.) * gfc.numlines_l[i]);
        }

        /************************************************************************
         * do the same things for short blocks
         ************************************************************************/
        gfc.npart_s = init_numline(gfc.numlines_s, gfc.bo_s, gfc.bm_s, bval,
            bval_width, gfc.mld_s, gfc.PSY.bo_s_weight, sfreq,
            Encoder_1.BLKSIZE_s, gfc.scalefac_band.s, Encoder_1.BLKSIZE_s
            / (2.0 * 192), Encoder_1.SBMAX_s);
        assert$3(gfc.npart_s < Encoder_1.CBANDS);

        /* SNR formula. short block is normalized by SNR. is it still right ? */
        j = 0;
        for (i = 0; i < gfc.npart_s; i++) {
            var x;
            var snr = snr_s_a;
            if (bval[i] >= bvl_a) {
                snr = snr_s_b * (bval[i] - bvl_a) / (bvl_b - bvl_a) + snr_s_a
                    * (bvl_b - bval[i]) / (bvl_b - bvl_a);
            }
            norm[i] = Math.pow(10.0, snr / 10.0);

            /* ATH */
            x = Float$3.MAX_VALUE;
            for (var k = 0; k < gfc.numlines_s[i]; k++, j++) {
                var freq = sfreq * j / (1000.0 * Encoder_1.BLKSIZE_s);
                var level;
                /* freq = Min(.1,freq); */
                /*
                 * ATH below 100 Hz constant, not
                 * further climbing
                 */
                level = this.ATHformula(freq * 1000, gfp) - 20;
                // scale to FFT units; returned value is in dB
                level = Math.pow(10., 0.1 * level);
                // convert from dB . energy
                level *= gfc.numlines_s[i];
                if (x > level)
                    x = level;
            }
            gfc.ATH.cb_s[i] = x;

            /*
             * MINVAL. For low freq, the strength of the masking is limited by
             * minval this is an ISO MPEG1 thing, dont know if it is really
             * needed
             */
            x = (-7.0 + bval[i] * 7.0 / 12.0);
            if (bval[i] > 12) {
                x *= 1 + Math.log(1 + x) * 3.1;
            }
            if (bval[i] < 12) {
                x *= 1 + Math.log(1 - x) * 2.3;
            }
            if (x < -15) {
                x = -15;
            }
            x -= 8;
            gfc.minval_s[i] = Math.pow(10.0, x / 10)
                * gfc.numlines_s[i];
        }

        gfc.s3_ss = init_s3_values(gfc.s3ind_s, gfc.npart_s, bval, bval_width,
            norm, useOldS3);

        init_mask_add_max_values();
        fft.init_fft(gfc);

        /* setup temporal masking */
        gfc.decay = Math.exp(-1.0 * LOG10
            / (temporalmask_sustain_sec * sfreq / 192.0));

        {
            var msfix;
            msfix = NS_MSFIX;
            if ((gfp.exp_nspsytune & 2) != 0)
                msfix = 1.0;
            if (Math.abs(gfp.msfix) > 0.0)
                msfix = gfp.msfix;
            gfp.msfix = msfix;

            /*
             * spread only from npart_l bands. Normally, we use the spreading
             * function to convolve from npart_l down to npart_l bands
             */
            for (var b = 0; b < gfc.npart_l; b++)
                if (gfc.s3ind[b][1] > gfc.npart_l - 1)
                    gfc.s3ind[b][1] = gfc.npart_l - 1;
        }

        /*
         * prepare for ATH auto adjustment: we want to decrease the ATH by 12 dB
         * per second
         */
        var frame_duration = (576. * gfc.mode_gr / sfreq);
        gfc.ATH.decay = Math.pow(10., -12. / 10. * frame_duration);
        gfc.ATH.adjust = 0.01;
        /* minimum, for leading low loudness */
        gfc.ATH.adjustLimit = 1.0;
        /* on lead, allow adjust up to maximum */

        assert$3(gfc.bo_l[Encoder_1.SBMAX_l - 1] <= gfc.npart_l);
        assert$3(gfc.bo_s[Encoder_1.SBMAX_s - 1] <= gfc.npart_s);

        if (gfp.ATHtype != -1) {
            /* compute equal loudness weights (eql_w) */
            var freq;
            var freq_inc = gfp.out_samplerate
                / (Encoder_1.BLKSIZE);
            var eql_balance = 0.0;
            freq = 0.0;
            for (i = 0; i < Encoder_1.BLKSIZE / 2; ++i) {
                /* convert ATH dB to relative power (not dB) */
                /* to determine eql_w */
                freq += freq_inc;
                gfc.ATH.eql_w[i] = 1. / Math.pow(10, this.ATHformula(freq, gfp) / 10);
                eql_balance += gfc.ATH.eql_w[i];
            }
            eql_balance = 1.0 / eql_balance;
            for (i = Encoder_1.BLKSIZE / 2; --i >= 0;) { /* scale weights */
                gfc.ATH.eql_w[i] *= eql_balance;
            }
        }
        {
            for (var b = j = 0; b < gfc.npart_s; ++b) {
                for (i = 0; i < gfc.numlines_s[b]; ++i) {
                    ++j;
                }
            }
            assert$3(j == 129);
            for (var b = j = 0; b < gfc.npart_l; ++b) {
                for (i = 0; i < gfc.numlines_l[b]; ++i) {
                    ++j;
                }
            }
            assert$3(j == 513);
        }
        j = 0;
        for (i = 0; i < gfc.npart_l; i++) {
            var freq = sfreq * (j + gfc.numlines_l[i] / 2) / (1.0 * Encoder_1.BLKSIZE);
            gfc.mld_cb_l[i] = stereo_demask(freq);
            j += gfc.numlines_l[i];
        }
        for (; i < Encoder_1.CBANDS; ++i) {
            gfc.mld_cb_l[i] = 1;
        }
        j = 0;
        for (i = 0; i < gfc.npart_s; i++) {
            var freq = sfreq * (j + gfc.numlines_s[i] / 2) / (1.0 * Encoder_1.BLKSIZE_s);
            gfc.mld_cb_s[i] = stereo_demask(freq);
            j += gfc.numlines_s[i];
        }
        for (; i < Encoder_1.CBANDS; ++i) {
            gfc.mld_cb_s[i] = 1;
        }
        return 0;
    };

    /**
     * Those ATH formulas are returning their minimum value for input = -1
     */
    function ATHformula_GB(f, value) {
        /**
         * <PRE>
         *  from Painter & Spanias
         *           modified by Gabriel Bouvigne to better fit the reality
         *           ath =    3.640 * pow(f,-0.8)
         *           - 6.800 * exp(-0.6*pow(f-3.4,2.0))
         *           + 6.000 * exp(-0.15*pow(f-8.7,2.0))
         *           + 0.6* 0.001 * pow(f,4.0);
         *
         *
         *           In the past LAME was using the Painter &Spanias formula.
         *           But we had some recurrent problems with HF content.
         *           We measured real ATH values, and found the older formula
         *           to be inaccurate in the higher part. So we made this new
         *           formula and this solved most of HF problematic test cases.
         *           The tradeoff is that in VBR mode it increases a lot the
         *           bitrate.
         * </PRE>
         */

        /*
         * This curve can be adjusted according to the VBR scale: it adjusts
         * from something close to Painter & Spanias on V9 up to Bouvigne's
         * formula for V0. This way the VBR bitrate is more balanced according
         * to the -V value.
         */

        // the following Hack allows to ask for the lowest value
        if (f < -.3)
            f = 3410;

        // convert to khz
        f /= 1000;
        f = Math.max(0.1, f);
        var ath = 3.640 * Math.pow(f, -0.8) - 6.800
            * Math.exp(-0.6 * Math.pow(f - 3.4, 2.0)) + 6.000
            * Math.exp(-0.15 * Math.pow(f - 8.7, 2.0))
            + (0.6 + 0.04 * value) * 0.001 * Math.pow(f, 4.0);
        return ath;
    }

    this.ATHformula = function (f, gfp) {
        var ath;
        switch (gfp.ATHtype) {
            case 0:
                ath = ATHformula_GB(f, 9);
                break;
            case 1:
                // over sensitive, should probably be removed
                ath = ATHformula_GB(f, -1);
                break;
            case 2:
                ath = ATHformula_GB(f, 0);
                break;
            case 3:
                // modification of GB formula by Roel
                ath = ATHformula_GB(f, 1) + 6;
                break;
            case 4:
                ath = ATHformula_GB(f, gfp.ATHcurve);
                break;
            default:
                ath = ATHformula_GB(f, 0);
                break;
        }
        return ath;
    };

}

var PsyModel_1 = PsyModel;

//package mp3;

/* MPEG modes */
function MPEGMode$1(ordinal) {
    var _ordinal = ordinal;
    this.ordinal = function () {
        return _ordinal;
    };
}

MPEGMode$1.STEREO = new MPEGMode$1(0);
MPEGMode$1.JOINT_STEREO = new MPEGMode$1(1);
MPEGMode$1.DUAL_CHANNEL = new MPEGMode$1(2);
MPEGMode$1.MONO = new MPEGMode$1(3);
MPEGMode$1.NOT_SET = new MPEGMode$1(4);

var MPEGMode_1 = MPEGMode$1;

function LameGlobalFlags() {

    this.class_id = 0;

    /* input description */

    /**
     * number of samples. default=-1
     */
    this.num_samples = 0;
    /**
     * input number of channels. default=2
     */
    this.num_channels = 0;
    /**
     * input_samp_rate in Hz. default=44.1 kHz
     */
    this.in_samplerate = 0;
    /**
     * output_samp_rate. default: LAME picks best value at least not used for
     * MP3 decoding: Remember 44.1 kHz MP3s and AC97
     */
    this.out_samplerate = 0;
    /**
     * scale input by this amount before encoding at least not used for MP3
     * decoding
     */
    this.scale = 0.;
    /**
     * scale input of channel 0 (left) by this amount before encoding
     */
    this.scale_left = 0.;
    /**
     * scale input of channel 1 (right) by this amount before encoding
     */
    this.scale_right = 0.;

    /* general control params */
    /**
     * collect data for a MP3 frame analyzer?
     */
    this.analysis = false;
    /**
     * add Xing VBR tag?
     */
    this.bWriteVbrTag = false;

    /**
     * use lame/mpglib to convert mp3 to wav
     */
    this.decode_only = false;
    /**
     * quality setting 0=best, 9=worst default=5
     */
    this.quality = 0;
    /**
     * see enum default = LAME picks best value
     */
    this.mode = MPEGMode_1.STEREO;
    /**
     * force M/S mode. requires mode=1
     */
    this.force_ms = false;
    /**
     * use free format? default=0
     */
    this.free_format = false;
    /**
     * find the RG value? default=0
     */
    this.findReplayGain = false;
    /**
     * decode on the fly? default=0
     */
    this.decode_on_the_fly = false;
    /**
     * 1 (default) writes ID3 tags, 0 not
     */
    this.write_id3tag_automatic = false;

    /*
     * set either brate>0 or compression_ratio>0, LAME will compute the value of
     * the variable not set. Default is compression_ratio = 11.025
     */
    /**
     * bitrate
     */
    this.brate = 0;
    /**
     * sizeof(wav file)/sizeof(mp3 file)
     */
    this.compression_ratio = 0.;

    /* frame params */
    /**
     * mark as copyright. default=0
     */
    this.copyright = 0;
    /**
     * mark as original. default=1
     */
    this.original = 0;
    /**
     * the MP3 'private extension' bit. Meaningless
     */
    this.extension = 0;
    /**
     * Input PCM is emphased PCM (for instance from one of the rarely emphased
     * CDs), it is STRONGLY not recommended to use this, because psycho does not
     * take it into account, and last but not least many decoders don't care
     * about these bits
     */
    this.emphasis = 0;
    /**
     * use 2 bytes per frame for a CRC checksum. default=0
     */
    this.error_protection = 0;
    /**
     * enforce ISO spec as much as possible
     */
    this.strict_ISO = false;

    /**
     * use bit reservoir?
     */
    this.disable_reservoir = false;

    /* quantization/noise shaping */
    this.quant_comp = 0;
    this.quant_comp_short = 0;
    this.experimentalY = false;
    this.experimentalZ = 0;
    this.exp_nspsytune = 0;

    this.preset = 0;

    /* VBR control */
    this.VBR = null;
    /**
     * Range [0,...,1[
     */
    this.VBR_q_frac = 0.;
    /**
     * Range [0,...,9]
     */
    this.VBR_q = 0;
    this.VBR_mean_bitrate_kbps = 0;
    this.VBR_min_bitrate_kbps = 0;
    this.VBR_max_bitrate_kbps = 0;
    /**
     * strictly enforce VBR_min_bitrate normaly, it will be violated for analog
     * silence
     */
    this.VBR_hard_min = 0;

    /* resampling and filtering */

    /**
     * freq in Hz. 0=lame choses. -1=no filter
     */
    this.lowpassfreq = 0;
    /**
     * freq in Hz. 0=lame choses. -1=no filter
     */
    this.highpassfreq = 0;
    /**
     * freq width of filter, in Hz (default=15%)
     */
    this.lowpasswidth = 0;
    /**
     * freq width of filter, in Hz (default=15%)
     */
    this.highpasswidth = 0;

    /*
     * psycho acoustics and other arguments which you should not change unless
     * you know what you are doing
     */

    this.maskingadjust = 0.;
    this.maskingadjust_short = 0.;
    /**
     * only use ATH
     */
    this.ATHonly = false;
    /**
     * only use ATH for short blocks
     */
    this.ATHshort = false;
    /**
     * disable ATH
     */
    this.noATH = false;
    /**
     * select ATH formula
     */
    this.ATHtype = 0;
    /**
     * change ATH formula 4 shape
     */
    this.ATHcurve = 0.;
    /**
     * lower ATH by this many db
     */
    this.ATHlower = 0.;
    /**
     * select ATH auto-adjust scheme
     */
    this.athaa_type = 0;
    /**
     * select ATH auto-adjust loudness calc
     */
    this.athaa_loudapprox = 0;
    /**
     * dB, tune active region of auto-level
     */
    this.athaa_sensitivity = 0.;
    this.short_blocks = null;
    /**
     * use temporal masking effect
     */
    this.useTemporal = false;
    this.interChRatio = 0.;
    /**
     * Naoki's adjustment of Mid/Side maskings
     */
    this.msfix = 0.;

    /**
     * 0 off, 1 on
     */
    this.tune = false;
    /**
     * used to pass values for debugging and stuff
     */
    this.tune_value_a = 0.;

    /************************************************************************/
    /* internal variables, do not set... */
    /* provided because they may be of use to calling application */
    /************************************************************************/

    /**
     * 0=MPEG-2/2.5 1=MPEG-1
     */
    this.version = 0;
    this.encoder_delay = 0;
    /**
     * number of samples of padding appended to input
     */
    this.encoder_padding = 0;
    this.framesize = 0;
    /**
     * number of frames encoded
     */
    this.frameNum = 0;
    /**
     * is this struct owned by calling program or lame?
     */
    this.lame_allocated_gfp = 0;
    /**************************************************************************/
    /* more internal variables are stored in this structure: */
    /**************************************************************************/
    this.internal_flags = null;
}

var LameGlobalFlags_1 = LameGlobalFlags;

var L3Side$1 = {};


	/**
	 * max scalefactor band, max(SBMAX_l, SBMAX_s*3, (SBMAX_s-3)*3+8)
	 */
L3Side$1.SFBMAX = (Encoder_1.SBMAX_s * 3);

var L3Side_1 = L3Side$1;

var new_float$10 = common.new_float;
var new_int$10 = common.new_int;
function GrInfo() {
    //float xr[] = new float[576];
    this.xr = new_float$10(576);
    //int l3_enc[] = new int[576];
    this.l3_enc = new_int$10(576);
    //int scalefac[] = new int[L3Side.SFBMAX];
    this.scalefac = new_int$10(L3Side_1.SFBMAX);
    this.xrpow_max = 0.;

    this.part2_3_length = 0;
    this.big_values = 0;
    this.count1 = 0;
    this.global_gain = 0;
    this.scalefac_compress = 0;
    this.block_type = 0;
    this.mixed_block_flag = 0;
    this.table_select = new_int$10(3);
    this.subblock_gain = new_int$10(3 + 1);
    this.region0_count = 0;
    this.region1_count = 0;
    this.preflag = 0;
    this.scalefac_scale = 0;
    this.count1table_select = 0;

    this.part2_length = 0;
    this.sfb_lmax = 0;
    this.sfb_smin = 0;
    this.psy_lmax = 0;
    this.sfbmax = 0;
    this.psymax = 0;
    this.sfbdivide = 0;
    this.width = new_int$10(L3Side_1.SFBMAX);
    this.window = new_int$10(L3Side_1.SFBMAX);
    this.count1bits = 0;
    /**
     * added for LSF
     */
    this.sfb_partition_table = null;
    this.slen = new_int$10(4);

    this.max_nonzero_coeff = 0;

    var self = this;
    function clone_int(array) {
        return new Int32Array(array);
    }
    function clone_float(array) {
        return new Float32Array(array);
    }
    this.assign = function (other) {
        self.xr = clone_float(other.xr); //.slice(0); //clone();
        self.l3_enc = clone_int(other.l3_enc); //.slice(0); //clone();
        self.scalefac = clone_int(other.scalefac);//.slice(0); //clone();
        self.xrpow_max = other.xrpow_max;

        self.part2_3_length = other.part2_3_length;
        self.big_values = other.big_values;
        self.count1 = other.count1;
        self.global_gain = other.global_gain;
        self.scalefac_compress = other.scalefac_compress;
        self.block_type = other.block_type;
        self.mixed_block_flag = other.mixed_block_flag;
        self.table_select = clone_int(other.table_select);//.slice(0); //clone();
        self.subblock_gain = clone_int(other.subblock_gain); //.slice(0); //.clone();
        self.region0_count = other.region0_count;
        self.region1_count = other.region1_count;
        self.preflag = other.preflag;
        self.scalefac_scale = other.scalefac_scale;
        self.count1table_select = other.count1table_select;

        self.part2_length = other.part2_length;
        self.sfb_lmax = other.sfb_lmax;
        self.sfb_smin = other.sfb_smin;
        self.psy_lmax = other.psy_lmax;
        self.sfbmax = other.sfbmax;
        self.psymax = other.psymax;
        self.sfbdivide = other.sfbdivide;
        self.width = clone_int(other.width); //.slice(0); //.clone();
        self.window = clone_int(other.window); //.slice(0); //.clone();
        self.count1bits = other.count1bits;

        self.sfb_partition_table = other.sfb_partition_table.slice(0); //.clone();
        self.slen = clone_int(other.slen); //.slice(0); //.clone();
        self.max_nonzero_coeff = other.max_nonzero_coeff;
    };
}

var GrInfo_1 = GrInfo;

var new_int$9 = common.new_int;
function IIISideInfo() {
    this.tt = [[null, null], [null, null]];
    this.main_data_begin = 0;
    this.private_bits = 0;
    this.resvDrain_pre = 0;
    this.resvDrain_post = 0;
    this.scfsi = [new_int$9(4), new_int$9(4)];

    for (var gr = 0; gr < 2; gr++) {
        for (var ch = 0; ch < 2; ch++) {
            this.tt[gr][ch] = new GrInfo_1();
        }
    }
}

var IIISideInfo_1 = IIISideInfo;

//package mp3;

/**
 * Layer III side information.
 *
 * @author Ken
 *
 */


var System$11 = common.System;
var new_int$11 = common.new_int;
function ScaleFac(arrL, arrS, arr21, arr12) {

    this.l = new_int$11(1 + Encoder_1.SBMAX_l);
    this.s = new_int$11(1 + Encoder_1.SBMAX_s);
    this.psfb21 = new_int$11(1 + Encoder_1.PSFB21);
    this.psfb12 = new_int$11(1 + Encoder_1.PSFB12);
    var l = this.l;
    var s = this.s;

    if (arguments.length == 4) {
        //public ScaleFac(final int[] arrL, final int[] arrS, final int[] arr21,
        //    final int[] arr12) {
        this.arrL = arguments[0];
        this.arrS = arguments[1];
        this.arr21 = arguments[2];
        this.arr12 = arguments[3];

        System$11.arraycopy(this.arrL, 0, l, 0, Math.min(this.arrL.length, this.l.length));
        System$11.arraycopy(this.arrS, 0, s, 0, Math.min(this.arrS.length, this.s.length));
        System$11.arraycopy(this.arr21, 0, this.psfb21, 0, Math.min(this.arr21.length, this.psfb21.length));
        System$11.arraycopy(this.arr12, 0, this.psfb12, 0, Math.min(this.arr12.length, this.psfb12.length));
    }
}

var ScaleFac_1 = ScaleFac;

var new_float$12 = common.new_float;
var new_float_n$12 = common.new_float_n;
var new_int$12 = common.new_int;
//package mp3;

/**
 * Variables used for --nspsytune
 *
 * @author Ken
 *
 */
function NsPsy() {
    this.last_en_subshort = new_float_n$12([4, 9]);
    this.lastAttacks = new_int$12(4);
    this.pefirbuf = new_float$12(19);
    this.longfact = new_float$12(Encoder_1.SBMAX_l);
    this.shortfact = new_float$12(Encoder_1.SBMAX_s);

    /**
     * short block tuning
     */
    this.attackthre = 0.;
    this.attackthre_s = 0.;
}

var NsPsy_1 = NsPsy;

//package mp3;

function VBRSeekInfo() {
    /**
     * What we have seen so far.
     */
    this.sum = 0;
    /**
     * How many frames we have seen in this chunk.
     */
    this.seen = 0;
    /**
     * How many frames we want to collect into one chunk.
     */
    this.want = 0;
    /**
     * Actual position in our bag.
     */
    this.pos = 0;
    /**
     * Size of our bag.
     */
    this.size = 0;
    /**
     * Pointer to our bag.
     */
    this.bag = null;
    this.nVbrNumFrames = 0;
    this.nBytesWritten = 0;
    /* VBR tag data */
    this.TotalFrameSize = 0;
}

var VBRSeekInfo_1 = VBRSeekInfo;

var new_byte$8 = common.new_byte;
var new_double$8 = common.new_double;
var new_float$8 = common.new_float;
var new_float_n$8 = common.new_float_n;
var new_int$8 = common.new_int;
var new_int_n$8 = common.new_int_n;
LameInternalFlags$1.MFSIZE = (3 * 1152 + Encoder_1.ENCDELAY - Encoder_1.MDCTDELAY);
LameInternalFlags$1.MAX_HEADER_BUF = 256;
LameInternalFlags$1.MAX_BITS_PER_CHANNEL = 4095;
LameInternalFlags$1.MAX_BITS_PER_GRANULE = 7680;
LameInternalFlags$1.BPC = 320;

function LameInternalFlags$1() {
    var MAX_HEADER_LEN = 40;


    /********************************************************************
     * internal variables NOT set by calling program, and should not be *
     * modified by the calling program *
     ********************************************************************/

    /**
     * Some remarks to the Class_ID field: The Class ID is an Identifier for a
     * pointer to this struct. It is very unlikely that a pointer to
     * lame_global_flags has the same 32 bits in it's structure (large and other
     * special properties, for instance prime).
     *
     * To test that the structure is right and initialized, use: if ( gfc .
     * Class_ID == LAME_ID ) ... Other remark: If you set a flag to 0 for uninit
     * data and 1 for init data, the right test should be "if (flag == 1)" and
     * NOT "if (flag)". Unintended modification of this element will be
     * otherwise misinterpreted as an init.
     */
    this.Class_ID = 0;

    this.lame_encode_frame_init = 0;
    this.iteration_init_init = 0;
    this.fill_buffer_resample_init = 0;

    //public float mfbuf[][] = new float[2][MFSIZE];
    this.mfbuf = new_float_n$8([2, LameInternalFlags$1.MFSIZE]);

    /**
     * granules per frame
     */
    this.mode_gr = 0;
    /**
     * number of channels in the input data stream (PCM or decoded PCM)
     */
    this.channels_in = 0;
    /**
     * number of channels in the output data stream (not used for decoding)
     */
    this.channels_out = 0;
    /**
     * input_samp_rate/output_samp_rate
     */
        //public double resample_ratio;
    this.resample_ratio = 0.;

    this.mf_samples_to_encode = 0;
    this.mf_size = 0;
    /**
     * min bitrate index
     */
    this.VBR_min_bitrate = 0;
    /**
     * max bitrate index
     */
    this.VBR_max_bitrate = 0;
    this.bitrate_index = 0;
    this.samplerate_index = 0;
    this.mode_ext = 0;

    /* lowpass and highpass filter control */
    /**
     * normalized frequency bounds of passband
     */
    this.lowpass1 = 0.;
    this.lowpass2 = 0.;
    /**
     * normalized frequency bounds of passband
     */
    this.highpass1 = 0.;
    this.highpass2 = 0.;

    /**
     * 0 = none 1 = ISO AAC model 2 = allow scalefac_select=1
     */
    this.noise_shaping = 0;

    /**
     * 0 = ISO model: amplify all distorted bands<BR>
     * 1 = amplify within 50% of max (on db scale)<BR>
     * 2 = amplify only most distorted band<BR>
     * 3 = method 1 and refine with method 2<BR>
     */
    this.noise_shaping_amp = 0;
    /**
     * 0 = no substep<BR>
     * 1 = use substep shaping at last step(VBR only)<BR>
     * (not implemented yet)<BR>
     * 2 = use substep inside loop<BR>
     * 3 = use substep inside loop and last step<BR>
     */
    this.substep_shaping = 0;

    /**
     * 1 = gpsycho. 0 = none
     */
    this.psymodel = 0;
    /**
     * 0 = stop at over=0, all scalefacs amplified or<BR>
     * a scalefac has reached max value<BR>
     * 1 = stop when all scalefacs amplified or a scalefac has reached max value<BR>
     * 2 = stop when all scalefacs amplified
     */
    this.noise_shaping_stop = 0;

    /**
     * 0 = no, 1 = yes
     */
    this.subblock_gain = 0;
    /**
     * 0 = no. 1=outside loop 2=inside loop(slow)
     */
    this.use_best_huffman = 0;

    /**
     * 0 = stop early after 0 distortion found. 1 = full search
     */
    this.full_outer_loop = 0;

    //public IIISideInfo l3_side = new IIISideInfo();
    this.l3_side = new IIISideInfo_1();
    this.ms_ratio = new_float$8(2);

    /* used for padding */
    /**
     * padding for the current frame?
     */
    this.padding = 0;
    this.frac_SpF = 0;
    this.slot_lag = 0;

    /**
     * optional ID3 tags
     */
        //public ID3TagSpec tag_spec;
    this.tag_spec = null;
    this.nMusicCRC = 0;

    /* variables used by Quantize */
    //public int OldValue[] = new int[2];
    this.OldValue = new_int$8(2);
    //public int CurrentStep[] = new int[2];
    this.CurrentStep = new_int$8(2);

    this.masking_lower = 0.;
    //public int bv_scf[] = new int[576];
    this.bv_scf = new_int$8(576);
    //public int pseudohalf[] = new int[L3Side.SFBMAX];
    this.pseudohalf = new_int$8(L3Side_1.SFBMAX);

    /**
     * will be set in lame_init_params
     */
    this.sfb21_extra = false;

    /* BPC = maximum number of filter convolution windows to precompute */
    //public float[][] inbuf_old = new float[2][];
    this.inbuf_old = new Array(2);
    //public float[][] blackfilt = new float[2 * BPC + 1][];
    this.blackfilt = new Array(2 * LameInternalFlags$1.BPC + 1);
    //public double itime[] = new double[2];
    this.itime = new_double$8(2);
    this.sideinfo_len = 0;

    /* variables for newmdct.c */
    //public float sb_sample[][][][] = new float[2][2][18][Encoder.SBLIMIT];
    this.sb_sample = new_float_n$8([2, 2, 18, Encoder_1.SBLIMIT]);
    this.amp_filter = new_float$8(32);

    /* variables for BitStream */

    /**
     * <PRE>
     * mpeg1: buffer=511 bytes  smallest frame: 96-38(sideinfo)=58
     * max number of frames in reservoir:  8
     * mpeg2: buffer=255 bytes.  smallest frame: 24-23bytes=1
     * with VBR, if you are encoding all silence, it is possible to
     * have 8kbs/24khz frames with 1byte of data each, which means we need
     * to buffer up to 255 headers!
     * </PRE>
     */
    /**
     * also, max_header_buf has to be a power of two
     */
    /**
     * max size of header is 38
     */

    function Header() {
        this.write_timing = 0;
        this.ptr = 0;
        //public byte buf[] = new byte[MAX_HEADER_LEN];
        this.buf = new_byte$8(MAX_HEADER_LEN);
    }

    this.header = new Array(LameInternalFlags$1.MAX_HEADER_BUF);

    this.h_ptr = 0;
    this.w_ptr = 0;
    this.ancillary_flag = 0;

    /* variables for Reservoir */
    /**
     * in bits
     */
    this.ResvSize = 0;
    /**
     * in bits
     */
    this.ResvMax = 0;

    //public ScaleFac scalefac_band = new ScaleFac();
    this.scalefac_band = new ScaleFac_1();

    /* daa from PsyModel */
    /* The static variables "r", "phi_sav", "new", "old" and "oldest" have */
    /* to be remembered for the unpredictability measure. For "r" and */
    /* "phi_sav", the first index from the left is the channel select and */
    /* the second index is the "age" of the data. */
    this.minval_l = new_float$8(Encoder_1.CBANDS);
    this.minval_s = new_float$8(Encoder_1.CBANDS);
    this.nb_1 = new_float_n$8([4, Encoder_1.CBANDS]);
    this.nb_2 = new_float_n$8([4, Encoder_1.CBANDS]);
    this.nb_s1 = new_float_n$8([4, Encoder_1.CBANDS]);
    this.nb_s2 = new_float_n$8([4, Encoder_1.CBANDS]);
    this.s3_ss = null;
    this.s3_ll = null;
    this.decay = 0.;

    //public III_psy_xmin[] thm = new III_psy_xmin[4];
    //public III_psy_xmin[] en = new III_psy_xmin[4];
    this.thm = new Array(4);
    this.en = new Array(4);

    /**
     * fft and energy calculation
     */
    this.tot_ener = new_float$8(4);

    /* loudness calculation (for adaptive threshold of hearing) */
    /**
     * loudness^2 approx. per granule and channel
     */
    this.loudness_sq = new_float_n$8([2, 2]);
    /**
     * account for granule delay of L3psycho_anal
     */
    this.loudness_sq_save = new_float$8(2);

    /**
     * Scale Factor Bands
     */
    this.mld_l = new_float$8(Encoder_1.SBMAX_l);
    this.mld_s = new_float$8(Encoder_1.SBMAX_s);
    this.bm_l = new_int$8(Encoder_1.SBMAX_l);
    this.bo_l = new_int$8(Encoder_1.SBMAX_l);
    this.bm_s = new_int$8(Encoder_1.SBMAX_s);
    this.bo_s = new_int$8(Encoder_1.SBMAX_s);
    this.npart_l = 0;
    this.npart_s = 0;

    this.s3ind = new_int_n$8([Encoder_1.CBANDS, 2]);
    this.s3ind_s = new_int_n$8([Encoder_1.CBANDS, 2]);

    this.numlines_s = new_int$8(Encoder_1.CBANDS);
    this.numlines_l = new_int$8(Encoder_1.CBANDS);
    this.rnumlines_l = new_float$8(Encoder_1.CBANDS);
    this.mld_cb_l = new_float$8(Encoder_1.CBANDS);
    this.mld_cb_s = new_float$8(Encoder_1.CBANDS);
    this.numlines_s_num1 = 0;
    this.numlines_l_num1 = 0;

    /* ratios */
    this.pe = new_float$8(4);
    this.ms_ratio_s_old = 0.;
    this.ms_ratio_l_old = 0.;
    this.ms_ener_ratio_old = 0.;

    /**
     * block type
     */
    this.blocktype_old = new_int$8(2);

    /**
     * variables used for --nspsytune
     */
    this.nsPsy = new NsPsy_1();

    /**
     * used for Xing VBR header
     */
    this.VBR_seek_table = new VBRSeekInfo_1();

    /**
     * all ATH related stuff
     */
        //public ATH ATH;
    this.ATH = null;

    this.PSY = null;

    this.nogap_total = 0;
    this.nogap_current = 0;

    /* ReplayGain */
    this.decode_on_the_fly = true;
    this.findReplayGain = true;
    this.findPeakSample = true;
    this.PeakSample = 0.;
    this.RadioGain = 0;
    this.AudiophileGain = 0;
    //public ReplayGain rgdata;
    this.rgdata = null;

    /**
     * gain change required for preventing clipping
     */
    this.noclipGainChange = 0;
    /**
     * user-specified scale factor required for preventing clipping
     */
    this.noclipScale = 0.;

    /* simple statistics */
    this.bitrate_stereoMode_Hist = new_int_n$8([16, 4 + 1]);
    /**
     * norm/start/short/stop/mixed(short)/sum
     */
    this.bitrate_blockType_Hist = new_int_n$8([16, 4 + 1 + 1]);

    //public PlottingData pinfo;
    //public MPGLib.mpstr_tag hip;
    this.pinfo = null;
    this.hip = null;

    this.in_buffer_nsamples = 0;
    //public float[] in_buffer_0;
    //public float[] in_buffer_1;
    this.in_buffer_0 = null;
    this.in_buffer_1 = null;

    //public IIterationLoop iteration_loop;
    this.iteration_loop = null;

    for (var i = 0; i < this.en.length; i++) {
        this.en[i] = new III_psy_xmin_1();
    }
    for (var i = 0; i < this.thm.length; i++) {
        this.thm[i] = new III_psy_xmin_1();
    }
    for (var i = 0; i < this.header.length; i++) {
        this.header[i] = new Header();
    }

}

var LameInternalFlags_1 = LameInternalFlags$1;

var new_float$13 = common.new_float;
/**
 * ATH related stuff, if something new ATH related has to be added, please plug
 * it here into the ATH.
 */
function ATH() {
    /**
     * Method for the auto adjustment.
     */
    this.useAdjust = 0;
    /**
     * factor for tuning the (sample power) point below which adaptive threshold
     * of hearing adjustment occurs
     */
    this.aaSensitivityP = 0.;
    /**
     * Lowering based on peak volume, 1 = no lowering.
     */
    this.adjust = 0.;
    /**
     * Limit for dynamic ATH adjust.
     */
    this.adjustLimit = 0.;
    /**
     * Determined to lower x dB each second.
     */
    this.decay = 0.;
    /**
     * Lowest ATH value.
     */
    this.floor = 0.;
    /**
     * ATH for sfbs in long blocks.
     */
    this.l = new_float$13(Encoder_1.SBMAX_l);
    /**
     * ATH for sfbs in short blocks.
     */
    this.s = new_float$13(Encoder_1.SBMAX_s);
    /**
     * ATH for partitioned sfb21 in long blocks.
     */
    this.psfb21 = new_float$13(Encoder_1.PSFB21);
    /**
     * ATH for partitioned sfb12 in short blocks.
     */
    this.psfb12 = new_float$13(Encoder_1.PSFB12);
    /**
     * ATH for long block convolution bands.
     */
    this.cb_l = new_float$13(Encoder_1.CBANDS);
    /**
     * ATH for short block convolution bands.
     */
    this.cb_s = new_float$13(Encoder_1.CBANDS);
    /**
     * Equal loudness weights (based on ATH).
     */
    this.eql_w = new_float$13(Encoder_1.BLKSIZE / 2);
}

var ATH_1 = ATH;

/*
 *  ReplayGainAnalysis - analyzes input samples and give the recommended dB change
 *  Copyright (C) 2001 David Robinson and Glen Sawyer
 *  Improvements and optimizations added by Frank Klemm, and by Marcel Muller 
 *
 *  This library is free software; you can redistribute it and/or
 *  modify it under the terms of the GNU Lesser General Public
 *  License as published by the Free Software Foundation; either
 *  version 2.1 of the License, or (at your option) any later version.
 *
 *  This library is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 *  Lesser General Public License for more details.
 *
 *  You should have received a copy of the GNU Lesser General Public
 *  License along with this library; if not, write to the Free Software
 *  Foundation, Inc., 59 Temple Place, Suite 330, Boston, MA  02111-1307  USA
 *
 *  concept and filter values by David Robinson (David@Robinson.org)
 *    -- blame him if you think the idea is flawed
 *  original coding by Glen Sawyer (mp3gain@hotmail.com)
 *    -- blame him if you think this runs too slowly, or the coding is otherwise flawed
 *
 *  lots of code improvements by Frank Klemm ( http://www.uni-jena.de/~pfk/mpp/ )
 *    -- credit him for all the _good_ programming ;)
 *
 *
 *  For an explanation of the concepts and the basic algorithms involved, go to:
 *    http://www.replaygain.org/
 */

/*
 *  Here's the deal. Call
 *
 *    InitGainAnalysis ( long samplefreq );
 *
 *  to initialize everything. Call
 *
 *    AnalyzeSamples ( var Float_t*  left_samples,
 *                     var Float_t*  right_samples,
 *                     size_t          num_samples,
 *                     int             num_channels );
 *
 *  as many times as you want, with as many or as few samples as you want.
 *  If mono, pass the sample buffer in through left_samples, leave
 *  right_samples NULL, and make sure num_channels = 1.
 *
 *    GetTitleGain()
 *
 *  will return the recommended dB level change for all samples analyzed
 *  SINCE THE LAST TIME you called GetTitleGain() OR InitGainAnalysis().
 *
 *    GetAlbumGain()
 *
 *  will return the recommended dB level change for all samples analyzed
 *  since InitGainAnalysis() was called and finalized with GetTitleGain().
 *
 *  Pseudo-code to process an album:
 *
 *    Float_t       l_samples [4096];
 *    Float_t       r_samples [4096];
 *    size_t        num_samples;
 *    unsigned int  num_songs;
 *    unsigned int  i;
 *
 *    InitGainAnalysis ( 44100 );
 *    for ( i = 1; i <= num_songs; i++ ) {
 *        while ( ( num_samples = getSongSamples ( song[i], left_samples, right_samples ) ) > 0 )
 *            AnalyzeSamples ( left_samples, right_samples, num_samples, 2 );
 *        fprintf ("Recommended dB change for song %2d: %+6.2 dB\n", i, GetTitleGain() );
 *    }
 *    fprintf ("Recommended dB change for whole album: %+6.2 dB\n", GetAlbumGain() );
 */

/*
 *  So here's the main source of potential code confusion:
 *
 *  The filters applied to the incoming samples are IIR filters,
 *  meaning they rely on up to <filter order> number of previous samples
 *  AND up to <filter order> number of previous filtered samples.
 *
 *  I set up the AnalyzeSamples routine to minimize memory usage and interface
 *  complexity. The speed isn't compromised too much (I don't think), but the
 *  internal complexity is higher than it should be for such a relatively
 *  simple routine.
 *
 *  Optimization/clarity suggestions are welcome.
 */

var System$15 = common.System;
var Arrays$15 = common.Arrays;
/**
 * Table entries per dB
 */
GainAnalysis$1.STEPS_per_dB = 100.;
/**
 * Table entries for 0...MAX_dB (normal max. values are 70...80 dB)
 */
GainAnalysis$1.MAX_dB = 120.;
GainAnalysis$1.GAIN_NOT_ENOUGH_SAMPLES = -24601;
GainAnalysis$1.GAIN_ANALYSIS_ERROR = 0;
GainAnalysis$1.GAIN_ANALYSIS_OK = 1;
GainAnalysis$1.INIT_GAIN_ANALYSIS_ERROR = 0;
GainAnalysis$1.INIT_GAIN_ANALYSIS_OK = 1;

GainAnalysis$1.YULE_ORDER = 10;
GainAnalysis$1.MAX_ORDER = GainAnalysis$1.YULE_ORDER;

GainAnalysis$1.MAX_SAMP_FREQ = 48000;
GainAnalysis$1.RMS_WINDOW_TIME_NUMERATOR = 1;
GainAnalysis$1.RMS_WINDOW_TIME_DENOMINATOR = 20;
GainAnalysis$1.MAX_SAMPLES_PER_WINDOW = ((GainAnalysis$1.MAX_SAMP_FREQ * GainAnalysis$1.RMS_WINDOW_TIME_NUMERATOR) / GainAnalysis$1.RMS_WINDOW_TIME_DENOMINATOR + 1);

function GainAnalysis$1() {
    /**
     * calibration value for 89dB
     */
    var PINK_REF = 64.82;

    var YULE_ORDER = GainAnalysis$1.YULE_ORDER;
    /**
     * percentile which is louder than the proposed level
     */
    var RMS_PERCENTILE = 0.95;
    /**
     * maximum allowed sample frequency [Hz]
     */
    var MAX_SAMP_FREQ = GainAnalysis$1.MAX_SAMP_FREQ;
    var RMS_WINDOW_TIME_NUMERATOR = GainAnalysis$1.RMS_WINDOW_TIME_NUMERATOR;
    /**
     * numerator / denominator = time slice size [s]
     */
    var RMS_WINDOW_TIME_DENOMINATOR = GainAnalysis$1.RMS_WINDOW_TIME_DENOMINATOR;
    /**
     * max. Samples per Time slice
     */
    var MAX_SAMPLES_PER_WINDOW = GainAnalysis$1.MAX_SAMPLES_PER_WINDOW;


    var ABYule = [
        [0.03857599435200, -3.84664617118067, -0.02160367184185,
            7.81501653005538, -0.00123395316851, -11.34170355132042,
            -0.00009291677959, 13.05504219327545, -0.01655260341619,
            -12.28759895145294, 0.02161526843274, 9.48293806319790,
            -0.02074045215285, -5.87257861775999, 0.00594298065125,
            2.75465861874613, 0.00306428023191, -0.86984376593551,
            0.00012025322027, 0.13919314567432, 0.00288463683916],
        [0.05418656406430, -3.47845948550071, -0.02911007808948,
            6.36317777566148, -0.00848709379851, -8.54751527471874,
            -0.00851165645469, 9.47693607801280, -0.00834990904936,
            -8.81498681370155, 0.02245293253339, 6.85401540936998,
            -0.02596338512915, -4.39470996079559, 0.01624864962975,
            2.19611684890774, -0.00240879051584, -0.75104302451432,
            0.00674613682247, 0.13149317958808, -0.00187763777362],
        [0.15457299681924, -2.37898834973084, -0.09331049056315,
            2.84868151156327, -0.06247880153653, -2.64577170229825,
            0.02163541888798, 2.23697657451713, -0.05588393329856,
            -1.67148153367602, 0.04781476674921, 1.00595954808547,
            0.00222312597743, -0.45953458054983, 0.03174092540049,
            0.16378164858596, -0.01390589421898, -0.05032077717131,
            0.00651420667831, 0.02347897407020, -0.00881362733839],
        [0.30296907319327, -1.61273165137247, -0.22613988682123,
            1.07977492259970, -0.08587323730772, -0.25656257754070,
            0.03282930172664, -0.16276719120440, -0.00915702933434,
            -0.22638893773906, -0.02364141202522, 0.39120800788284,
            -0.00584456039913, -0.22138138954925, 0.06276101321749,
            0.04500235387352, -0.00000828086748, 0.02005851806501,
            0.00205861885564, 0.00302439095741, -0.02950134983287],
        [0.33642304856132, -1.49858979367799, -0.25572241425570,
            0.87350271418188, -0.11828570177555, 0.12205022308084,
            0.11921148675203, -0.80774944671438, -0.07834489609479,
            0.47854794562326, -0.00469977914380, -0.12453458140019,
            -0.00589500224440, -0.04067510197014, 0.05724228140351,
            0.08333755284107, 0.00832043980773, -0.04237348025746,
            -0.01635381384540, 0.02977207319925, -0.01760176568150],
        [0.44915256608450, -0.62820619233671, -0.14351757464547,
            0.29661783706366, -0.22784394429749, -0.37256372942400,
            -0.01419140100551, 0.00213767857124, 0.04078262797139,
            -0.42029820170918, -0.12398163381748, 0.22199650564824,
            0.04097565135648, 0.00613424350682, 0.10478503600251,
            0.06747620744683, -0.01863887810927, 0.05784820375801,
            -0.03193428438915, 0.03222754072173, 0.00541907748707],
        [0.56619470757641, -1.04800335126349, -0.75464456939302,
            0.29156311971249, 0.16242137742230, -0.26806001042947,
            0.16744243493672, 0.00819999645858, -0.18901604199609,
            0.45054734505008, 0.30931782841830, -0.33032403314006,
            -0.27562961986224, 0.06739368333110, 0.00647310677246,
            -0.04784254229033, 0.08647503780351, 0.01639907836189,
            -0.03788984554840, 0.01807364323573, -0.00588215443421],
        [0.58100494960553, -0.51035327095184, -0.53174909058578,
            -0.31863563325245, -0.14289799034253, -0.20256413484477,
            0.17520704835522, 0.14728154134330, 0.02377945217615,
            0.38952639978999, 0.15558449135573, -0.23313271880868,
            -0.25344790059353, -0.05246019024463, 0.01628462406333,
            -0.02505961724053, 0.06920467763959, 0.02442357316099,
            -0.03721611395801, 0.01818801111503, -0.00749618797172],
        [0.53648789255105, -0.25049871956020, -0.42163034350696,
            -0.43193942311114, -0.00275953611929, -0.03424681017675,
            0.04267842219415, -0.04678328784242, -0.10214864179676,
            0.26408300200955, 0.14590772289388, 0.15113130533216,
            -0.02459864859345, -0.17556493366449, -0.11202315195388,
            -0.18823009262115, -0.04060034127000, 0.05477720428674,
            0.04788665548180, 0.04704409688120, -0.02217936801134]];

    var ABButter = [
        [0.98621192462708, -1.97223372919527, -1.97242384925416,
            0.97261396931306, 0.98621192462708],
        [0.98500175787242, -1.96977855582618, -1.97000351574484,
            0.97022847566350, 0.98500175787242],
        [0.97938932735214, -1.95835380975398, -1.95877865470428,
            0.95920349965459, 0.97938932735214],
        [0.97531843204928, -1.95002759149878, -1.95063686409857,
            0.95124613669835, 0.97531843204928],
        [0.97316523498161, -1.94561023566527, -1.94633046996323,
            0.94705070426118, 0.97316523498161],
        [0.96454515552826, -1.92783286977036, -1.92909031105652,
            0.93034775234268, 0.96454515552826],
        [0.96009142950541, -1.91858953033784, -1.92018285901082,
            0.92177618768381, 0.96009142950541],
        [0.95856916599601, -1.91542108074780, -1.91713833199203,
            0.91885558323625, 0.95856916599601],
        [0.94597685600279, -1.88903307939452, -1.89195371200558,
            0.89487434461664, 0.94597685600279]];


    /**
     * When calling this procedure, make sure that ip[-order] and op[-order]
     * point to real data
     */
    //private void filterYule(final float[] input, int inputPos, float[] output,
    //int outputPos, int nSamples, final float[] kernel) {
    function filterYule(input, inputPos, output, outputPos, nSamples, kernel) {

        while ((nSamples--) != 0) {
            /* 1e-10 is a hack to avoid slowdown because of denormals */
            output[outputPos] = 1e-10 + input[inputPos + 0] * kernel[0]
                - output[outputPos - 1] * kernel[1] + input[inputPos - 1]
                * kernel[2] - output[outputPos - 2] * kernel[3]
                + input[inputPos - 2] * kernel[4] - output[outputPos - 3]
                * kernel[5] + input[inputPos - 3] * kernel[6]
                - output[outputPos - 4] * kernel[7] + input[inputPos - 4]
                * kernel[8] - output[outputPos - 5] * kernel[9]
                + input[inputPos - 5] * kernel[10] - output[outputPos - 6]
                * kernel[11] + input[inputPos - 6] * kernel[12]
                - output[outputPos - 7] * kernel[13] + input[inputPos - 7]
                * kernel[14] - output[outputPos - 8] * kernel[15]
                + input[inputPos - 8] * kernel[16] - output[outputPos - 9]
                * kernel[17] + input[inputPos - 9] * kernel[18]
                - output[outputPos - 10] * kernel[19]
                + input[inputPos - 10] * kernel[20];
            ++outputPos;
            ++inputPos;
        }
    }

//private void filterButter(final float[] input, int inputPos,
//    float[] output, int outputPos, int nSamples, final float[] kernel) {
    function filterButter(input, inputPos, output, outputPos, nSamples, kernel) {

        while ((nSamples--) != 0) {
            output[outputPos] = input[inputPos + 0] * kernel[0]
                - output[outputPos - 1] * kernel[1] + input[inputPos - 1]
                * kernel[2] - output[outputPos - 2] * kernel[3]
                + input[inputPos - 2] * kernel[4];
            ++outputPos;
            ++inputPos;
        }
    }

    /**
     * @return INIT_GAIN_ANALYSIS_OK if successful, INIT_GAIN_ANALYSIS_ERROR if
     *         not
     */
    function ResetSampleFrequency(rgData, samplefreq) {
        /* zero out initial values */
        for (var i = 0; i < MAX_ORDER; i++)
            rgData.linprebuf[i] = rgData.lstepbuf[i] = rgData.loutbuf[i] = rgData.rinprebuf[i] = rgData.rstepbuf[i] = rgData.routbuf[i] = 0.;

        switch (0 | (samplefreq)) {
            case 48000:
                rgData.reqindex = 0;
                break;
            case 44100:
                rgData.reqindex = 1;
                break;
            case 32000:
                rgData.reqindex = 2;
                break;
            case 24000:
                rgData.reqindex = 3;
                break;
            case 22050:
                rgData.reqindex = 4;
                break;
            case 16000:
                rgData.reqindex = 5;
                break;
            case 12000:
                rgData.reqindex = 6;
                break;
            case 11025:
                rgData.reqindex = 7;
                break;
            case 8000:
                rgData.reqindex = 8;
                break;
            default:
                return INIT_GAIN_ANALYSIS_ERROR;
        }

        rgData.sampleWindow = 0 | ((samplefreq * RMS_WINDOW_TIME_NUMERATOR
            + RMS_WINDOW_TIME_DENOMINATOR - 1) / RMS_WINDOW_TIME_DENOMINATOR);

        rgData.lsum = 0.;
        rgData.rsum = 0.;
        rgData.totsamp = 0;

        Arrays$15.ill(rgData.A, 0);

        return INIT_GAIN_ANALYSIS_OK;
    }

    this.InitGainAnalysis = function (rgData, samplefreq) {
        if (ResetSampleFrequency(rgData, samplefreq) != INIT_GAIN_ANALYSIS_OK) {
            return INIT_GAIN_ANALYSIS_ERROR;
        }

        rgData.linpre = MAX_ORDER;
        rgData.rinpre = MAX_ORDER;
        rgData.lstep = MAX_ORDER;
        rgData.rstep = MAX_ORDER;
        rgData.lout = MAX_ORDER;
        rgData.rout = MAX_ORDER;

        Arrays$15.fill(rgData.B, 0);

        return INIT_GAIN_ANALYSIS_OK;
    };

    /**
     * square
     */
    function fsqr(d) {
        return d * d;
    }

    this.AnalyzeSamples = function (rgData, left_samples, left_samplesPos, right_samples, right_samplesPos, num_samples,
                                    num_channels) {
        var curleft;
        var curleftBase;
        var curright;
        var currightBase;
        var batchsamples;
        var cursamples;
        var cursamplepos;

        if (num_samples == 0)
            return GAIN_ANALYSIS_OK;

        cursamplepos = 0;
        batchsamples = num_samples;

        switch (num_channels) {
            case 1:
                right_samples = left_samples;
                right_samplesPos = left_samplesPos;
                break;
            case 2:
                break;
            default:
                return GAIN_ANALYSIS_ERROR;
        }

        if (num_samples < MAX_ORDER) {
            System$15.arraycopy(left_samples, left_samplesPos, rgData.linprebuf,
                MAX_ORDER, num_samples);
            System$15.arraycopy(right_samples, right_samplesPos, rgData.rinprebuf,
                MAX_ORDER, num_samples);
        } else {
            System$15.arraycopy(left_samples, left_samplesPos, rgData.linprebuf,
                MAX_ORDER, MAX_ORDER);
            System$15.arraycopy(right_samples, right_samplesPos, rgData.rinprebuf,
                MAX_ORDER, MAX_ORDER);
        }

        while (batchsamples > 0) {
            cursamples = batchsamples > rgData.sampleWindow - rgData.totsamp ? rgData.sampleWindow
            - rgData.totsamp
                : batchsamples;
            if (cursamplepos < MAX_ORDER) {
                curleft = rgData.linpre + cursamplepos;
                curleftBase = rgData.linprebuf;
                curright = rgData.rinpre + cursamplepos;
                currightBase = rgData.rinprebuf;
                if (cursamples > MAX_ORDER - cursamplepos)
                    cursamples = MAX_ORDER - cursamplepos;
            } else {
                curleft = left_samplesPos + cursamplepos;
                curleftBase = left_samples;
                curright = right_samplesPos + cursamplepos;
                currightBase = right_samples;
            }

            filterYule(curleftBase, curleft, rgData.lstepbuf, rgData.lstep
                + rgData.totsamp, cursamples, ABYule[rgData.reqindex]);
            filterYule(currightBase, curright, rgData.rstepbuf, rgData.rstep
                + rgData.totsamp, cursamples, ABYule[rgData.reqindex]);

            filterButter(rgData.lstepbuf, rgData.lstep + rgData.totsamp,
                rgData.loutbuf, rgData.lout + rgData.totsamp, cursamples,
                ABButter[rgData.reqindex]);
            filterButter(rgData.rstepbuf, rgData.rstep + rgData.totsamp,
                rgData.routbuf, rgData.rout + rgData.totsamp, cursamples,
                ABButter[rgData.reqindex]);

            curleft = rgData.lout + rgData.totsamp;
            /* Get the squared values */
            curleftBase = rgData.loutbuf;
            curright = rgData.rout + rgData.totsamp;
            currightBase = rgData.routbuf;

            var i = cursamples % 8;
            while ((i--) != 0) {
                rgData.lsum += fsqr(curleftBase[curleft++]);
                rgData.rsum += fsqr(currightBase[curright++]);
            }
            i = cursamples / 8;
            while ((i--) != 0) {
                rgData.lsum += fsqr(curleftBase[curleft + 0])
                    + fsqr(curleftBase[curleft + 1])
                    + fsqr(curleftBase[curleft + 2])
                    + fsqr(curleftBase[curleft + 3])
                    + fsqr(curleftBase[curleft + 4])
                    + fsqr(curleftBase[curleft + 5])
                    + fsqr(curleftBase[curleft + 6])
                    + fsqr(curleftBase[curleft + 7]);
                curleft += 8;
                rgData.rsum += fsqr(currightBase[curright + 0])
                    + fsqr(currightBase[curright + 1])
                    + fsqr(currightBase[curright + 2])
                    + fsqr(currightBase[curright + 3])
                    + fsqr(currightBase[curright + 4])
                    + fsqr(currightBase[curright + 5])
                    + fsqr(currightBase[curright + 6])
                    + fsqr(currightBase[curright + 7]);
                curright += 8;
            }

            batchsamples -= cursamples;
            cursamplepos += cursamples;
            rgData.totsamp += cursamples;
            if (rgData.totsamp == rgData.sampleWindow) {
                /* Get the Root Mean Square (RMS) for this set of samples */
                var val = GainAnalysis$1.STEPS_per_dB
                    * 10.
                    * Math.log10((rgData.lsum + rgData.rsum)
                        / rgData.totsamp * 0.5 + 1.e-37);
                var ival = (val <= 0) ? 0 : 0 | val;
                if (ival >= rgData.A.length)
                    ival = rgData.A.length - 1;
                rgData.A[ival]++;
                rgData.lsum = rgData.rsum = 0.;

                System$15.arraycopy(rgData.loutbuf, rgData.totsamp,
                    rgData.loutbuf, 0, MAX_ORDER);
                System$15.arraycopy(rgData.routbuf, rgData.totsamp,
                    rgData.routbuf, 0, MAX_ORDER);
                System$15.arraycopy(rgData.lstepbuf, rgData.totsamp,
                    rgData.lstepbuf, 0, MAX_ORDER);
                System$15.arraycopy(rgData.rstepbuf, rgData.totsamp,
                    rgData.rstepbuf, 0, MAX_ORDER);
                rgData.totsamp = 0;
            }
            if (rgData.totsamp > rgData.sampleWindow) {
                /*
                 * somehow I really screwed up: Error in programming! Contact
                 * author about totsamp > sampleWindow
                 */
                return GAIN_ANALYSIS_ERROR;
            }
        }
        if (num_samples < MAX_ORDER) {
            System$15.arraycopy(rgData.linprebuf, num_samples, rgData.linprebuf,
                0, MAX_ORDER - num_samples);
            System$15.arraycopy(rgData.rinprebuf, num_samples, rgData.rinprebuf,
                0, MAX_ORDER - num_samples);
            System$15.arraycopy(left_samples, left_samplesPos, rgData.linprebuf,
                MAX_ORDER - num_samples, num_samples);
            System$15.arraycopy(right_samples, right_samplesPos, rgData.rinprebuf,
                MAX_ORDER - num_samples, num_samples);
        } else {
            System$15.arraycopy(left_samples, left_samplesPos + num_samples
                - MAX_ORDER, rgData.linprebuf, 0, MAX_ORDER);
            System$15.arraycopy(right_samples, right_samplesPos + num_samples
                - MAX_ORDER, rgData.rinprebuf, 0, MAX_ORDER);
        }

        return GAIN_ANALYSIS_OK;
    };

    function analyzeResult(Array, len) {
        var i;

        var elems = 0;
        for (i = 0; i < len; i++)
            elems += Array[i];
        if (elems == 0)
            return GAIN_NOT_ENOUGH_SAMPLES;

        var upper = 0 | Math.ceil(elems * (1. - RMS_PERCENTILE));
        for (i = len; i-- > 0;) {
            if ((upper -= Array[i]) <= 0)
                break;
        }

        //return (float) ((float) PINK_REF - (float) i / (float) STEPS_per_dB);
        return (PINK_REF - i / GainAnalysis$1.STEPS_per_dB);
    }

    this.GetTitleGain = function (rgData) {
        var retval = analyzeResult(rgData.A, rgData.A.length);

        for (var i = 0; i < rgData.A.length; i++) {
            rgData.B[i] += rgData.A[i];
            rgData.A[i] = 0;
        }

        for (var i = 0; i < MAX_ORDER; i++)
            rgData.linprebuf[i] = rgData.lstepbuf[i] = rgData.loutbuf[i] = rgData.rinprebuf[i] = rgData.rstepbuf[i] = rgData.routbuf[i] = 0.;

        rgData.totsamp = 0;
        rgData.lsum = rgData.rsum = 0.;
        return retval;
    };

}

var GainAnalysis_1 = GainAnalysis$1;

var new_float$14 = common.new_float;
var new_int$14 = common.new_int;
function ReplayGain() {
    this.linprebuf = new_float$14(GainAnalysis_1.MAX_ORDER * 2);
    /**
     * left input samples, with pre-buffer
     */
    this.linpre = 0;
    this.lstepbuf = new_float$14(GainAnalysis_1.MAX_SAMPLES_PER_WINDOW + GainAnalysis_1.MAX_ORDER);
    /**
     * left "first step" (i.e. post first filter) samples
     */
    this.lstep = 0;
    this.loutbuf = new_float$14(GainAnalysis_1.MAX_SAMPLES_PER_WINDOW + GainAnalysis_1.MAX_ORDER);
    /**
     * left "out" (i.e. post second filter) samples
     */
    this.lout = 0;
    this.rinprebuf = new_float$14(GainAnalysis_1.MAX_ORDER * 2);
    /**
     * right input samples ...
     */
    this.rinpre = 0;
    this.rstepbuf = new_float$14(GainAnalysis_1.MAX_SAMPLES_PER_WINDOW + GainAnalysis_1.MAX_ORDER);
    this.rstep = 0;
    this.routbuf = new_float$14(GainAnalysis_1.MAX_SAMPLES_PER_WINDOW + GainAnalysis_1.MAX_ORDER);
    this.rout = 0;
    /**
     * number of samples required to reach number of milliseconds required
     * for RMS window
     */
    this.sampleWindow = 0;
    this.totsamp = 0;
    this.lsum = 0.;
    this.rsum = 0.;
    this.freqindex = 0;
    this.first = 0;
    this.A = new_int$14(0 | (GainAnalysis_1.STEPS_per_dB * GainAnalysis_1.MAX_dB));
    this.B = new_int$14(0 | (GainAnalysis_1.STEPS_per_dB * GainAnalysis_1.MAX_dB));

}

var ReplayGain_1 = ReplayGain;

function MeanBits$1(meanBits) {
    this.bits = meanBits;
}

var MeanBits_1 = MeanBits$1;

var new_float$16 = common.new_float;
var new_int$16 = common.new_int;
var assert$16 = common.assert;






function CBRNewIterationLoop(_quantize)  {
    var quantize = _quantize;
    this.quantize = quantize;
	this.iteration_loop = function(gfp, pe, ms_ener_ratio, ratio) {
		var gfc = gfp.internal_flags;
        var l3_xmin = new_float$16(L3Side_1.SFBMAX);
		var xrpow = new_float$16(576);
		var targ_bits = new_int$16(2);
		var mean_bits = 0, max_bits;
		var l3_side = gfc.l3_side;

		var mb = new MeanBits_1(mean_bits);
		this.quantize.rv.ResvFrameBegin(gfp, mb);
		mean_bits = mb.bits;

		/* quantize! */
		for (var gr = 0; gr < gfc.mode_gr; gr++) {

			/*
			 * calculate needed bits
			 */
			max_bits = this.quantize.qupvt.on_pe(gfp, pe, targ_bits, mean_bits,
					gr, gr);

			if (gfc.mode_ext == Encoder_1.MPG_MD_MS_LR) {
				this.quantize.ms_convert(gfc.l3_side, gr);
				this.quantize.qupvt.reduce_side(targ_bits, ms_ener_ratio[gr],
						mean_bits, max_bits);
			}

			for (var ch = 0; ch < gfc.channels_out; ch++) {
				var adjust, masking_lower_db;
				var cod_info = l3_side.tt[gr][ch];

				if (cod_info.block_type != Encoder_1.SHORT_TYPE) {
					// NORM, START or STOP type
					adjust = 0;
					masking_lower_db = gfc.PSY.mask_adjust - adjust;
				} else {
					adjust = 0;
					masking_lower_db = gfc.PSY.mask_adjust_short - adjust;
				}
				gfc.masking_lower =  Math.pow(10.0,
						masking_lower_db * 0.1);

				/*
				 * init_outer_loop sets up cod_info, scalefac and xrpow
				 */
				this.quantize.init_outer_loop(gfc, cod_info);
				if (this.quantize.init_xrpow(gfc, cod_info, xrpow)) {
					/*
					 * xr contains energy we will have to encode calculate the
					 * masking abilities find some good quantization in
					 * outer_loop
					 */
					this.quantize.qupvt.calc_xmin(gfp, ratio[gr][ch], cod_info,
							l3_xmin);
					this.quantize.outer_loop(gfp, cod_info, l3_xmin, xrpow, ch,
							targ_bits[ch]);
				}

				this.quantize.iteration_finish_one(gfc, gr, ch);
				assert$16 (cod_info.part2_3_length <= LameInternalFlags_1.MAX_BITS_PER_CHANNEL);
				assert$16 (cod_info.part2_3_length <= targ_bits[ch]);
			} /* for ch */
		} /* for gr */

		this.quantize.rv.ResvFrameEnd(gfc, mean_bits);
	};
}
var CBRNewIterationLoop_1 = CBRNewIterationLoop;

function HuffCodeTab(len, max, tab, hl) {
    this.xlen = len;
    this.linmax = max;
    this.table = tab;
    this.hlen = hl;
}

var Tables$1 = {};


Tables$1.t1HB = [
    1, 1,
    1, 0
];

Tables$1.t2HB = [
    1, 2, 1,
    3, 1, 1,
    3, 2, 0
];

Tables$1.t3HB = [
    3, 2, 1,
    1, 1, 1,
    3, 2, 0
];

Tables$1.t5HB = [
    1, 2, 6, 5,
    3, 1, 4, 4,
    7, 5, 7, 1,
    6, 1, 1, 0
];

Tables$1.t6HB = [
    7, 3, 5, 1,
    6, 2, 3, 2,
    5, 4, 4, 1,
    3, 3, 2, 0
];

Tables$1.t7HB = [
    1, 2, 10, 19, 16, 10,
    3, 3, 7, 10, 5, 3,
    11, 4, 13, 17, 8, 4,
    12, 11, 18, 15, 11, 2,
    7, 6, 9, 14, 3, 1,
    6, 4, 5, 3, 2, 0
];

Tables$1.t8HB = [
    3, 4, 6, 18, 12, 5,
    5, 1, 2, 16, 9, 3,
    7, 3, 5, 14, 7, 3,
    19, 17, 15, 13, 10, 4,
    13, 5, 8, 11, 5, 1,
    12, 4, 4, 1, 1, 0
];

Tables$1.t9HB = [
    7, 5, 9, 14, 15, 7,
    6, 4, 5, 5, 6, 7,
    7, 6, 8, 8, 8, 5,
    15, 6, 9, 10, 5, 1,
    11, 7, 9, 6, 4, 1,
    14, 4, 6, 2, 6, 0
];

Tables$1.t10HB = [
    1, 2, 10, 23, 35, 30, 12, 17,
    3, 3, 8, 12, 18, 21, 12, 7,
    11, 9, 15, 21, 32, 40, 19, 6,
    14, 13, 22, 34, 46, 23, 18, 7,
    20, 19, 33, 47, 27, 22, 9, 3,
    31, 22, 41, 26, 21, 20, 5, 3,
    14, 13, 10, 11, 16, 6, 5, 1,
    9, 8, 7, 8, 4, 4, 2, 0
];

Tables$1.t11HB = [
    3, 4, 10, 24, 34, 33, 21, 15,
    5, 3, 4, 10, 32, 17, 11, 10,
    11, 7, 13, 18, 30, 31, 20, 5,
    25, 11, 19, 59, 27, 18, 12, 5,
    35, 33, 31, 58, 30, 16, 7, 5,
    28, 26, 32, 19, 17, 15, 8, 14,
    14, 12, 9, 13, 14, 9, 4, 1,
    11, 4, 6, 6, 6, 3, 2, 0
];

Tables$1.t12HB = [
    9, 6, 16, 33, 41, 39, 38, 26,
    7, 5, 6, 9, 23, 16, 26, 11,
    17, 7, 11, 14, 21, 30, 10, 7,
    17, 10, 15, 12, 18, 28, 14, 5,
    32, 13, 22, 19, 18, 16, 9, 5,
    40, 17, 31, 29, 17, 13, 4, 2,
    27, 12, 11, 15, 10, 7, 4, 1,
    27, 12, 8, 12, 6, 3, 1, 0
];

Tables$1.t13HB = [
    1, 5, 14, 21, 34, 51, 46, 71, 42, 52, 68, 52, 67, 44, 43, 19,
    3, 4, 12, 19, 31, 26, 44, 33, 31, 24, 32, 24, 31, 35, 22, 14,
    15, 13, 23, 36, 59, 49, 77, 65, 29, 40, 30, 40, 27, 33, 42, 16,
    22, 20, 37, 61, 56, 79, 73, 64, 43, 76, 56, 37, 26, 31, 25, 14,
    35, 16, 60, 57, 97, 75, 114, 91, 54, 73, 55, 41, 48, 53, 23, 24,
    58, 27, 50, 96, 76, 70, 93, 84, 77, 58, 79, 29, 74, 49, 41, 17,
    47, 45, 78, 74, 115, 94, 90, 79, 69, 83, 71, 50, 59, 38, 36, 15,
    72, 34, 56, 95, 92, 85, 91, 90, 86, 73, 77, 65, 51, 44, 43, 42,
    43, 20, 30, 44, 55, 78, 72, 87, 78, 61, 46, 54, 37, 30, 20, 16,
    53, 25, 41, 37, 44, 59, 54, 81, 66, 76, 57, 54, 37, 18, 39, 11,
    35, 33, 31, 57, 42, 82, 72, 80, 47, 58, 55, 21, 22, 26, 38, 22,
    53, 25, 23, 38, 70, 60, 51, 36, 55, 26, 34, 23, 27, 14, 9, 7,
    34, 32, 28, 39, 49, 75, 30, 52, 48, 40, 52, 28, 18, 17, 9, 5,
    45, 21, 34, 64, 56, 50, 49, 45, 31, 19, 12, 15, 10, 7, 6, 3,
    48, 23, 20, 39, 36, 35, 53, 21, 16, 23, 13, 10, 6, 1, 4, 2,
    16, 15, 17, 27, 25, 20, 29, 11, 17, 12, 16, 8, 1, 1, 0, 1
];

Tables$1.t15HB = [
    7, 12, 18, 53, 47, 76, 124, 108, 89, 123, 108, 119, 107, 81, 122, 63,
    13, 5, 16, 27, 46, 36, 61, 51, 42, 70, 52, 83, 65, 41, 59, 36,
    19, 17, 15, 24, 41, 34, 59, 48, 40, 64, 50, 78, 62, 80, 56, 33,
    29, 28, 25, 43, 39, 63, 55, 93, 76, 59, 93, 72, 54, 75, 50, 29,
    52, 22, 42, 40, 67, 57, 95, 79, 72, 57, 89, 69, 49, 66, 46, 27,
    77, 37, 35, 66, 58, 52, 91, 74, 62, 48, 79, 63, 90, 62, 40, 38,
    125, 32, 60, 56, 50, 92, 78, 65, 55, 87, 71, 51, 73, 51, 70, 30,
    109, 53, 49, 94, 88, 75, 66, 122, 91, 73, 56, 42, 64, 44, 21, 25,
    90, 43, 41, 77, 73, 63, 56, 92, 77, 66, 47, 67, 48, 53, 36, 20,
    71, 34, 67, 60, 58, 49, 88, 76, 67, 106, 71, 54, 38, 39, 23, 15,
    109, 53, 51, 47, 90, 82, 58, 57, 48, 72, 57, 41, 23, 27, 62, 9,
    86, 42, 40, 37, 70, 64, 52, 43, 70, 55, 42, 25, 29, 18, 11, 11,
    118, 68, 30, 55, 50, 46, 74, 65, 49, 39, 24, 16, 22, 13, 14, 7,
    91, 44, 39, 38, 34, 63, 52, 45, 31, 52, 28, 19, 14, 8, 9, 3,
    123, 60, 58, 53, 47, 43, 32, 22, 37, 24, 17, 12, 15, 10, 2, 1,
    71, 37, 34, 30, 28, 20, 17, 26, 21, 16, 10, 6, 8, 6, 2, 0
];

Tables$1.t16HB = [
    1, 5, 14, 44, 74, 63, 110, 93, 172, 149, 138, 242, 225, 195, 376, 17,
    3, 4, 12, 20, 35, 62, 53, 47, 83, 75, 68, 119, 201, 107, 207, 9,
    15, 13, 23, 38, 67, 58, 103, 90, 161, 72, 127, 117, 110, 209, 206, 16,
    45, 21, 39, 69, 64, 114, 99, 87, 158, 140, 252, 212, 199, 387, 365, 26,
    75, 36, 68, 65, 115, 101, 179, 164, 155, 264, 246, 226, 395, 382, 362, 9,
    66, 30, 59, 56, 102, 185, 173, 265, 142, 253, 232, 400, 388, 378, 445, 16,
    111, 54, 52, 100, 184, 178, 160, 133, 257, 244, 228, 217, 385, 366, 715, 10,
    98, 48, 91, 88, 165, 157, 148, 261, 248, 407, 397, 372, 380, 889, 884, 8,
    85, 84, 81, 159, 156, 143, 260, 249, 427, 401, 392, 383, 727, 713, 708, 7,
    154, 76, 73, 141, 131, 256, 245, 426, 406, 394, 384, 735, 359, 710, 352, 11,
    139, 129, 67, 125, 247, 233, 229, 219, 393, 743, 737, 720, 885, 882, 439, 4,
    243, 120, 118, 115, 227, 223, 396, 746, 742, 736, 721, 712, 706, 223, 436, 6,
    202, 224, 222, 218, 216, 389, 386, 381, 364, 888, 443, 707, 440, 437, 1728, 4,
    747, 211, 210, 208, 370, 379, 734, 723, 714, 1735, 883, 877, 876, 3459, 865, 2,
    377, 369, 102, 187, 726, 722, 358, 711, 709, 866, 1734, 871, 3458, 870, 434, 0,
    12, 10, 7, 11, 10, 17, 11, 9, 13, 12, 10, 7, 5, 3, 1, 3
];

Tables$1.t24HB = [
    15, 13, 46, 80, 146, 262, 248, 434, 426, 669, 653, 649, 621, 517, 1032, 88,
    14, 12, 21, 38, 71, 130, 122, 216, 209, 198, 327, 345, 319, 297, 279, 42,
    47, 22, 41, 74, 68, 128, 120, 221, 207, 194, 182, 340, 315, 295, 541, 18,
    81, 39, 75, 70, 134, 125, 116, 220, 204, 190, 178, 325, 311, 293, 271, 16,
    147, 72, 69, 135, 127, 118, 112, 210, 200, 188, 352, 323, 306, 285, 540, 14,
    263, 66, 129, 126, 119, 114, 214, 202, 192, 180, 341, 317, 301, 281, 262, 12,
    249, 123, 121, 117, 113, 215, 206, 195, 185, 347, 330, 308, 291, 272, 520, 10,
    435, 115, 111, 109, 211, 203, 196, 187, 353, 332, 313, 298, 283, 531, 381, 17,
    427, 212, 208, 205, 201, 193, 186, 177, 169, 320, 303, 286, 268, 514, 377, 16,
    335, 199, 197, 191, 189, 181, 174, 333, 321, 305, 289, 275, 521, 379, 371, 11,
    668, 184, 183, 179, 175, 344, 331, 314, 304, 290, 277, 530, 383, 373, 366, 10,
    652, 346, 171, 168, 164, 318, 309, 299, 287, 276, 263, 513, 375, 368, 362, 6,
    648, 322, 316, 312, 307, 302, 292, 284, 269, 261, 512, 376, 370, 364, 359, 4,
    620, 300, 296, 294, 288, 282, 273, 266, 515, 380, 374, 369, 365, 361, 357, 2,
    1033, 280, 278, 274, 267, 264, 259, 382, 378, 372, 367, 363, 360, 358, 356, 0,
    43, 20, 19, 17, 15, 13, 11, 9, 7, 6, 4, 7, 5, 3, 1, 3
];

Tables$1.t32HB = [
    1 << 0, 5 << 1, 4 << 1, 5 << 2, 6 << 1, 5 << 2, 4 << 2, 4 << 3,
    7 << 1, 3 << 2, 6 << 2, 0 << 3, 7 << 2, 2 << 3, 3 << 3, 1 << 4
];

Tables$1.t33HB = [
    15 << 0, 14 << 1, 13 << 1, 12 << 2, 11 << 1, 10 << 2, 9 << 2, 8 << 3,
    7 << 1, 6 << 2, 5 << 2, 4 << 3, 3 << 2, 2 << 3, 1 << 3, 0 << 4
];

Tables$1.t1l = [
    1, 4,
    3, 5
];

Tables$1.t2l = [
    1, 4, 7,
    4, 5, 7,
    6, 7, 8
];

Tables$1.t3l = [
    2, 3, 7,
    4, 4, 7,
    6, 7, 8
];

Tables$1.t5l = [
    1, 4, 7, 8,
    4, 5, 8, 9,
    7, 8, 9, 10,
    8, 8, 9, 10
];

Tables$1.t6l = [
    3, 4, 6, 8,
    4, 4, 6, 7,
    5, 6, 7, 8,
    7, 7, 8, 9
];

Tables$1.t7l = [
    1, 4, 7, 9, 9, 10,
    4, 6, 8, 9, 9, 10,
    7, 7, 9, 10, 10, 11,
    8, 9, 10, 11, 11, 11,
    8, 9, 10, 11, 11, 12,
    9, 10, 11, 12, 12, 12
];

Tables$1.t8l = [
    2, 4, 7, 9, 9, 10,
    4, 4, 6, 10, 10, 10,
    7, 6, 8, 10, 10, 11,
    9, 10, 10, 11, 11, 12,
    9, 9, 10, 11, 12, 12,
    10, 10, 11, 11, 13, 13
];

Tables$1.t9l = [
    3, 4, 6, 7, 9, 10,
    4, 5, 6, 7, 8, 10,
    5, 6, 7, 8, 9, 10,
    7, 7, 8, 9, 9, 10,
    8, 8, 9, 9, 10, 11,
    9, 9, 10, 10, 11, 11
];

Tables$1.t10l = [
    1, 4, 7, 9, 10, 10, 10, 11,
    4, 6, 8, 9, 10, 11, 10, 10,
    7, 8, 9, 10, 11, 12, 11, 11,
    8, 9, 10, 11, 12, 12, 11, 12,
    9, 10, 11, 12, 12, 12, 12, 12,
    10, 11, 12, 12, 13, 13, 12, 13,
    9, 10, 11, 12, 12, 12, 13, 13,
    10, 10, 11, 12, 12, 13, 13, 13
];

Tables$1.t11l = [
    2, 4, 6, 8, 9, 10, 9, 10,
    4, 5, 6, 8, 10, 10, 9, 10,
    6, 7, 8, 9, 10, 11, 10, 10,
    8, 8, 9, 11, 10, 12, 10, 11,
    9, 10, 10, 11, 11, 12, 11, 12,
    9, 10, 11, 12, 12, 13, 12, 13,
    9, 9, 9, 10, 11, 12, 12, 12,
    9, 9, 10, 11, 12, 12, 12, 12
];

Tables$1.t12l = [
    4, 4, 6, 8, 9, 10, 10, 10,
    4, 5, 6, 7, 9, 9, 10, 10,
    6, 6, 7, 8, 9, 10, 9, 10,
    7, 7, 8, 8, 9, 10, 10, 10,
    8, 8, 9, 9, 10, 10, 10, 11,
    9, 9, 10, 10, 10, 11, 10, 11,
    9, 9, 9, 10, 10, 11, 11, 12,
    10, 10, 10, 11, 11, 11, 11, 12
];

Tables$1.t13l = [
    1, 5, 7, 8, 9, 10, 10, 11, 10, 11, 12, 12, 13, 13, 14, 14,
    4, 6, 8, 9, 10, 10, 11, 11, 11, 11, 12, 12, 13, 14, 14, 14,
    7, 8, 9, 10, 11, 11, 12, 12, 11, 12, 12, 13, 13, 14, 15, 15,
    8, 9, 10, 11, 11, 12, 12, 12, 12, 13, 13, 13, 13, 14, 15, 15,
    9, 9, 11, 11, 12, 12, 13, 13, 12, 13, 13, 14, 14, 15, 15, 16,
    10, 10, 11, 12, 12, 12, 13, 13, 13, 13, 14, 13, 15, 15, 16, 16,
    10, 11, 12, 12, 13, 13, 13, 13, 13, 14, 14, 14, 15, 15, 16, 16,
    11, 11, 12, 13, 13, 13, 14, 14, 14, 14, 15, 15, 15, 16, 18, 18,
    10, 10, 11, 12, 12, 13, 13, 14, 14, 14, 14, 15, 15, 16, 17, 17,
    11, 11, 12, 12, 13, 13, 13, 15, 14, 15, 15, 16, 16, 16, 18, 17,
    11, 12, 12, 13, 13, 14, 14, 15, 14, 15, 16, 15, 16, 17, 18, 19,
    12, 12, 12, 13, 14, 14, 14, 14, 15, 15, 15, 16, 17, 17, 17, 18,
    12, 13, 13, 14, 14, 15, 14, 15, 16, 16, 17, 17, 17, 18, 18, 18,
    13, 13, 14, 15, 15, 15, 16, 16, 16, 16, 16, 17, 18, 17, 18, 18,
    14, 14, 14, 15, 15, 15, 17, 16, 16, 19, 17, 17, 17, 19, 18, 18,
    13, 14, 15, 16, 16, 16, 17, 16, 17, 17, 18, 18, 21, 20, 21, 18
];

Tables$1.t15l = [
    3, 5, 6, 8, 8, 9, 10, 10, 10, 11, 11, 12, 12, 12, 13, 14,
    5, 5, 7, 8, 9, 9, 10, 10, 10, 11, 11, 12, 12, 12, 13, 13,
    6, 7, 7, 8, 9, 9, 10, 10, 10, 11, 11, 12, 12, 13, 13, 13,
    7, 8, 8, 9, 9, 10, 10, 11, 11, 11, 12, 12, 12, 13, 13, 13,
    8, 8, 9, 9, 10, 10, 11, 11, 11, 11, 12, 12, 12, 13, 13, 13,
    9, 9, 9, 10, 10, 10, 11, 11, 11, 11, 12, 12, 13, 13, 13, 14,
    10, 9, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 13, 13, 14, 14,
    10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 13, 13, 14,
    10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 13, 13, 14, 14, 14,
    10, 10, 11, 11, 11, 11, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14,
    11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 13, 13, 13, 14, 15, 14,
    11, 11, 11, 11, 12, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 15,
    12, 12, 11, 12, 12, 12, 13, 13, 13, 13, 13, 13, 14, 14, 15, 15,
    12, 12, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 14, 14, 15, 15,
    13, 13, 13, 13, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 14, 15,
    13, 13, 13, 13, 13, 13, 13, 14, 14, 14, 14, 14, 15, 15, 15, 15
];

Tables$1.t16_5l = [
    1, 5, 7, 9, 10, 10, 11, 11, 12, 12, 12, 13, 13, 13, 14, 11,
    4, 6, 8, 9, 10, 11, 11, 11, 12, 12, 12, 13, 14, 13, 14, 11,
    7, 8, 9, 10, 11, 11, 12, 12, 13, 12, 13, 13, 13, 14, 14, 12,
    9, 9, 10, 11, 11, 12, 12, 12, 13, 13, 14, 14, 14, 15, 15, 13,
    10, 10, 11, 11, 12, 12, 13, 13, 13, 14, 14, 14, 15, 15, 15, 12,
    10, 10, 11, 11, 12, 13, 13, 14, 13, 14, 14, 15, 15, 15, 16, 13,
    11, 11, 11, 12, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 16, 13,
    11, 11, 12, 12, 13, 13, 13, 14, 14, 15, 15, 15, 15, 17, 17, 13,
    11, 12, 12, 13, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 13,
    12, 12, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 15, 16, 15, 14,
    12, 13, 12, 13, 14, 14, 14, 14, 15, 16, 16, 16, 17, 17, 16, 13,
    13, 13, 13, 13, 14, 14, 15, 16, 16, 16, 16, 16, 16, 15, 16, 14,
    13, 14, 14, 14, 14, 15, 15, 15, 15, 17, 16, 16, 16, 16, 18, 14,
    15, 14, 14, 14, 15, 15, 16, 16, 16, 18, 17, 17, 17, 19, 17, 14,
    14, 15, 13, 14, 16, 16, 15, 16, 16, 17, 18, 17, 19, 17, 16, 14,
    11, 11, 11, 12, 12, 13, 13, 13, 14, 14, 14, 14, 14, 14, 14, 12
];

Tables$1.t16l = [
    1, 5, 7, 9, 10, 10, 11, 11, 12, 12, 12, 13, 13, 13, 14, 10,
    4, 6, 8, 9, 10, 11, 11, 11, 12, 12, 12, 13, 14, 13, 14, 10,
    7, 8, 9, 10, 11, 11, 12, 12, 13, 12, 13, 13, 13, 14, 14, 11,
    9, 9, 10, 11, 11, 12, 12, 12, 13, 13, 14, 14, 14, 15, 15, 12,
    10, 10, 11, 11, 12, 12, 13, 13, 13, 14, 14, 14, 15, 15, 15, 11,
    10, 10, 11, 11, 12, 13, 13, 14, 13, 14, 14, 15, 15, 15, 16, 12,
    11, 11, 11, 12, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 16, 12,
    11, 11, 12, 12, 13, 13, 13, 14, 14, 15, 15, 15, 15, 17, 17, 12,
    11, 12, 12, 13, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 12,
    12, 12, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 15, 16, 15, 13,
    12, 13, 12, 13, 14, 14, 14, 14, 15, 16, 16, 16, 17, 17, 16, 12,
    13, 13, 13, 13, 14, 14, 15, 16, 16, 16, 16, 16, 16, 15, 16, 13,
    13, 14, 14, 14, 14, 15, 15, 15, 15, 17, 16, 16, 16, 16, 18, 13,
    15, 14, 14, 14, 15, 15, 16, 16, 16, 18, 17, 17, 17, 19, 17, 13,
    14, 15, 13, 14, 16, 16, 15, 16, 16, 17, 18, 17, 19, 17, 16, 13,
    10, 10, 10, 11, 11, 12, 12, 12, 13, 13, 13, 13, 13, 13, 13, 10
];

Tables$1.t24l = [
    4, 5, 7, 8, 9, 10, 10, 11, 11, 12, 12, 12, 12, 12, 13, 10,
    5, 6, 7, 8, 9, 10, 10, 11, 11, 11, 12, 12, 12, 12, 12, 10,
    7, 7, 8, 9, 9, 10, 10, 11, 11, 11, 11, 12, 12, 12, 13, 9,
    8, 8, 9, 9, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 9,
    9, 9, 9, 10, 10, 10, 10, 11, 11, 11, 12, 12, 12, 12, 13, 9,
    10, 9, 10, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 12, 9,
    10, 10, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 9,
    11, 10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 13, 10,
    11, 11, 11, 11, 11, 11, 11, 11, 11, 12, 12, 12, 12, 13, 13, 10,
    11, 11, 11, 11, 11, 11, 11, 12, 12, 12, 12, 12, 13, 13, 13, 10,
    12, 11, 11, 11, 11, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 10,
    12, 12, 11, 11, 11, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 10,
    12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 13, 10,
    12, 12, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 13, 13, 13, 10,
    13, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 13, 13, 13, 13, 10,
    9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 9, 10, 10, 10, 10, 6
];

Tables$1.t32l = [
    1 + 0, 4 + 1, 4 + 1, 5 + 2, 4 + 1, 6 + 2, 5 + 2, 6 + 3,
    4 + 1, 5 + 2, 5 + 2, 6 + 3, 5 + 2, 6 + 3, 6 + 3, 6 + 4
];

Tables$1.t33l = [
    4 + 0, 4 + 1, 4 + 1, 4 + 2, 4 + 1, 4 + 2, 4 + 2, 4 + 3,
    4 + 1, 4 + 2, 4 + 2, 4 + 3, 4 + 2, 4 + 3, 4 + 3, 4 + 4
];

Tables$1.ht = [
    /* xlen, linmax, table, hlen */
    new HuffCodeTab(0, 0, null, null),
    new HuffCodeTab(2, 0, Tables$1.t1HB, Tables$1.t1l),
    new HuffCodeTab(3, 0, Tables$1.t2HB, Tables$1.t2l),
    new HuffCodeTab(3, 0, Tables$1.t3HB, Tables$1.t3l),
    new HuffCodeTab(0, 0, null, null), /* Apparently not used */
    new HuffCodeTab(4, 0, Tables$1.t5HB, Tables$1.t5l),
    new HuffCodeTab(4, 0, Tables$1.t6HB, Tables$1.t6l),
    new HuffCodeTab(6, 0, Tables$1.t7HB, Tables$1.t7l),
    new HuffCodeTab(6, 0, Tables$1.t8HB, Tables$1.t8l),
    new HuffCodeTab(6, 0, Tables$1.t9HB, Tables$1.t9l),
    new HuffCodeTab(8, 0, Tables$1.t10HB, Tables$1.t10l),
    new HuffCodeTab(8, 0, Tables$1.t11HB, Tables$1.t11l),
    new HuffCodeTab(8, 0, Tables$1.t12HB, Tables$1.t12l),
    new HuffCodeTab(16, 0, Tables$1.t13HB, Tables$1.t13l),
    new HuffCodeTab(0, 0, null, Tables$1.t16_5l), /* Apparently not used */
    new HuffCodeTab(16, 0, Tables$1.t15HB, Tables$1.t15l),

    new HuffCodeTab(1, 1, Tables$1.t16HB, Tables$1.t16l),
    new HuffCodeTab(2, 3, Tables$1.t16HB, Tables$1.t16l),
    new HuffCodeTab(3, 7, Tables$1.t16HB, Tables$1.t16l),
    new HuffCodeTab(4, 15, Tables$1.t16HB, Tables$1.t16l),
    new HuffCodeTab(6, 63, Tables$1.t16HB, Tables$1.t16l),
    new HuffCodeTab(8, 255, Tables$1.t16HB, Tables$1.t16l),
    new HuffCodeTab(10, 1023, Tables$1.t16HB, Tables$1.t16l),
    new HuffCodeTab(13, 8191, Tables$1.t16HB, Tables$1.t16l),

    new HuffCodeTab(4, 15, Tables$1.t24HB, Tables$1.t24l),
    new HuffCodeTab(5, 31, Tables$1.t24HB, Tables$1.t24l),
    new HuffCodeTab(6, 63, Tables$1.t24HB, Tables$1.t24l),
    new HuffCodeTab(7, 127, Tables$1.t24HB, Tables$1.t24l),
    new HuffCodeTab(8, 255, Tables$1.t24HB, Tables$1.t24l),
    new HuffCodeTab(9, 511, Tables$1.t24HB, Tables$1.t24l),
    new HuffCodeTab(11, 2047, Tables$1.t24HB, Tables$1.t24l),
    new HuffCodeTab(13, 8191, Tables$1.t24HB, Tables$1.t24l),

    new HuffCodeTab(0, 0, Tables$1.t32HB, Tables$1.t32l),
    new HuffCodeTab(0, 0, Tables$1.t33HB, Tables$1.t33l),
];

/**
 * <CODE>
 *  for (i = 0; i < 16*16; i++) [
 *      largetbl[i] = ((ht[16].hlen[i]) << 16) + ht[24].hlen[i];
 *  ]
 * </CODE>
 *
 */
Tables$1.largetbl = [
    0x010004, 0x050005, 0x070007, 0x090008, 0x0a0009, 0x0a000a, 0x0b000a, 0x0b000b,
    0x0c000b, 0x0c000c, 0x0c000c, 0x0d000c, 0x0d000c, 0x0d000c, 0x0e000d, 0x0a000a,
    0x040005, 0x060006, 0x080007, 0x090008, 0x0a0009, 0x0b000a, 0x0b000a, 0x0b000b,
    0x0c000b, 0x0c000b, 0x0c000c, 0x0d000c, 0x0e000c, 0x0d000c, 0x0e000c, 0x0a000a,
    0x070007, 0x080007, 0x090008, 0x0a0009, 0x0b0009, 0x0b000a, 0x0c000a, 0x0c000b,
    0x0d000b, 0x0c000b, 0x0d000b, 0x0d000c, 0x0d000c, 0x0e000c, 0x0e000d, 0x0b0009,
    0x090008, 0x090008, 0x0a0009, 0x0b0009, 0x0b000a, 0x0c000a, 0x0c000a, 0x0c000b,
    0x0d000b, 0x0d000b, 0x0e000b, 0x0e000c, 0x0e000c, 0x0f000c, 0x0f000c, 0x0c0009,
    0x0a0009, 0x0a0009, 0x0b0009, 0x0b000a, 0x0c000a, 0x0c000a, 0x0d000a, 0x0d000b,
    0x0d000b, 0x0e000b, 0x0e000c, 0x0e000c, 0x0f000c, 0x0f000c, 0x0f000d, 0x0b0009,
    0x0a000a, 0x0a0009, 0x0b000a, 0x0b000a, 0x0c000a, 0x0d000a, 0x0d000b, 0x0e000b,
    0x0d000b, 0x0e000b, 0x0e000c, 0x0f000c, 0x0f000c, 0x0f000c, 0x10000c, 0x0c0009,
    0x0b000a, 0x0b000a, 0x0b000a, 0x0c000a, 0x0d000a, 0x0d000b, 0x0d000b, 0x0d000b,
    0x0e000b, 0x0e000c, 0x0e000c, 0x0e000c, 0x0f000c, 0x0f000c, 0x10000d, 0x0c0009,
    0x0b000b, 0x0b000a, 0x0c000a, 0x0c000a, 0x0d000b, 0x0d000b, 0x0d000b, 0x0e000b,
    0x0e000c, 0x0f000c, 0x0f000c, 0x0f000c, 0x0f000c, 0x11000d, 0x11000d, 0x0c000a,
    0x0b000b, 0x0c000b, 0x0c000b, 0x0d000b, 0x0d000b, 0x0d000b, 0x0e000b, 0x0e000b,
    0x0f000b, 0x0f000c, 0x0f000c, 0x0f000c, 0x10000c, 0x10000d, 0x10000d, 0x0c000a,
    0x0c000b, 0x0c000b, 0x0c000b, 0x0d000b, 0x0d000b, 0x0e000b, 0x0e000b, 0x0f000c,
    0x0f000c, 0x0f000c, 0x0f000c, 0x10000c, 0x0f000d, 0x10000d, 0x0f000d, 0x0d000a,
    0x0c000c, 0x0d000b, 0x0c000b, 0x0d000b, 0x0e000b, 0x0e000c, 0x0e000c, 0x0e000c,
    0x0f000c, 0x10000c, 0x10000c, 0x10000d, 0x11000d, 0x11000d, 0x10000d, 0x0c000a,
    0x0d000c, 0x0d000c, 0x0d000b, 0x0d000b, 0x0e000b, 0x0e000c, 0x0f000c, 0x10000c,
    0x10000c, 0x10000c, 0x10000c, 0x10000d, 0x10000d, 0x0f000d, 0x10000d, 0x0d000a,
    0x0d000c, 0x0e000c, 0x0e000c, 0x0e000c, 0x0e000c, 0x0f000c, 0x0f000c, 0x0f000c,
    0x0f000c, 0x11000c, 0x10000d, 0x10000d, 0x10000d, 0x10000d, 0x12000d, 0x0d000a,
    0x0f000c, 0x0e000c, 0x0e000c, 0x0e000c, 0x0f000c, 0x0f000c, 0x10000c, 0x10000c,
    0x10000d, 0x12000d, 0x11000d, 0x11000d, 0x11000d, 0x13000d, 0x11000d, 0x0d000a,
    0x0e000d, 0x0f000c, 0x0d000c, 0x0e000c, 0x10000c, 0x10000c, 0x0f000c, 0x10000d,
    0x10000d, 0x11000d, 0x12000d, 0x11000d, 0x13000d, 0x11000d, 0x10000d, 0x0d000a,
    0x0a0009, 0x0a0009, 0x0a0009, 0x0b0009, 0x0b0009, 0x0c0009, 0x0c0009, 0x0c0009,
    0x0d0009, 0x0d0009, 0x0d0009, 0x0d000a, 0x0d000a, 0x0d000a, 0x0d000a, 0x0a0006
];
/**
 * <CODE>
 *  for (i = 0; i < 3*3; i++) [
 *      table23[i] = ((ht[2].hlen[i]) << 16) + ht[3].hlen[i];
 *  ]
 * </CODE>
 *
 */
Tables$1.table23 = [
    0x010002, 0x040003, 0x070007,
    0x040004, 0x050004, 0x070007,
    0x060006, 0x070007, 0x080008
];

/**
 * <CODE>
 *  for (i = 0; i < 4*4; i++) [
 *       table56[i] = ((ht[5].hlen[i]) << 16) + ht[6].hlen[i];
 *   ]
 * </CODE>
 *
 */
Tables$1.table56 = [
    0x010003, 0x040004, 0x070006, 0x080008, 0x040004, 0x050004, 0x080006, 0x090007,
    0x070005, 0x080006, 0x090007, 0x0a0008, 0x080007, 0x080007, 0x090008, 0x0a0009
];

Tables$1.bitrate_table = [
    [0, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160, -1], /* MPEG 2 */
    [0, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, -1], /* MPEG 1 */
    [0, 8, 16, 24, 32, 40, 48, 56, 64, -1, -1, -1, -1, -1, -1, -1], /* MPEG 2.5 */
];

/**
 * MPEG 2, MPEG 1, MPEG 2.5.
 */
Tables$1.samplerate_table = [
    [22050, 24000, 16000, -1],
    [44100, 48000, 32000, -1],
    [11025, 12000, 8000, -1],
];

/**
 * This is the scfsi_band table from 2.4.2.7 of the IS.
 */
Tables$1.scfsi_band = [0, 6, 11, 16, 21];

var Tables_1 = Tables$1;

var VbrMode$19 = common.VbrMode;
var Float$19 = common.Float;
var Util$19 = common.Util;
var new_float$19 = common.new_float;
var new_int$19 = common.new_int;
var assert$19 = common.assert;





QuantizePVT$1.Q_MAX = (256 + 1);
QuantizePVT$1.Q_MAX2 = 116;
QuantizePVT$1.LARGE_BITS = 100000;
QuantizePVT$1.IXMAX_VAL = 8206;

function QuantizePVT$1() {

    var tak = null;
    var rv = null;
    var psy = null;

    this.setModules = function (_tk, _rv, _psy) {
        tak = _tk;
        rv = _rv;
        psy = _psy;
    };

    function POW20(x) {
        assert$19(0 <= (x + QuantizePVT$1.Q_MAX2) && x < QuantizePVT$1.Q_MAX);
        return pow20[x + QuantizePVT$1.Q_MAX2];
    }

    this.IPOW20 = function (x) {
        assert$19(0 <= x && x < QuantizePVT$1.Q_MAX);
        return ipow20[x];
    };

    /**
     * smallest such that 1.0+DBL_EPSILON != 1.0
     */
    var DBL_EPSILON = 2.2204460492503131e-016;

    /**
     * ix always <= 8191+15. see count_bits()
     */
    var IXMAX_VAL = QuantizePVT$1.IXMAX_VAL;

    var PRECALC_SIZE = (IXMAX_VAL + 2);

    var Q_MAX = QuantizePVT$1.Q_MAX;


    /**
     * <CODE>
     * minimum possible number of
     * -cod_info.global_gain + ((scalefac[] + (cod_info.preflag ? pretab[sfb] : 0))
     * << (cod_info.scalefac_scale + 1)) + cod_info.subblock_gain[cod_info.window[sfb]] * 8;
     *
     * for long block, 0+((15+3)<<2) = 18*4 = 72
     * for short block, 0+(15<<2)+7*8 = 15*4+56 = 116
     * </CODE>
     */
    var Q_MAX2 = QuantizePVT$1.Q_MAX2;

    var LARGE_BITS = QuantizePVT$1.LARGE_BITS;


    /**
     * Assuming dynamic range=96dB, this value should be 92
     */
    var NSATHSCALE = 100;

    /**
     * The following table is used to implement the scalefactor partitioning for
     * MPEG2 as described in section 2.4.3.2 of the IS. The indexing corresponds
     * to the way the tables are presented in the IS:
     *
     * [table_number][row_in_table][column of nr_of_sfb]
     */
    this.nr_of_sfb_block = [
        [[6, 5, 5, 5], [9, 9, 9, 9], [6, 9, 9, 9]],
        [[6, 5, 7, 3], [9, 9, 12, 6], [6, 9, 12, 6]],
        [[11, 10, 0, 0], [18, 18, 0, 0], [15, 18, 0, 0]],
        [[7, 7, 7, 0], [12, 12, 12, 0], [6, 15, 12, 0]],
        [[6, 6, 6, 3], [12, 9, 9, 6], [6, 12, 9, 6]],
        [[8, 8, 5, 0], [15, 12, 9, 0], [6, 18, 9, 0]]];

    /**
     * Table B.6: layer3 preemphasis
     */
    var pretab = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1,
        2, 2, 3, 3, 3, 2, 0];
    this.pretab = pretab;

    /**
     * Here are MPEG1 Table B.8 and MPEG2 Table B.1 -- Layer III scalefactor
     * bands. <BR>
     * Index into this using a method such as:<BR>
     * idx = fr_ps.header.sampling_frequency + (fr_ps.header.version * 3)
     */
    this.sfBandIndex = [
        // Table B.2.b: 22.05 kHz
        new ScaleFac_1([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 116, 140, 168, 200, 238, 284, 336, 396, 464,
                522, 576],
            [0, 4, 8, 12, 18, 24, 32, 42, 56, 74, 100, 132, 174, 192]
            , [0, 0, 0, 0, 0, 0, 0] //  sfb21 pseudo sub bands
            , [0, 0, 0, 0, 0, 0, 0] //  sfb12 pseudo sub bands
        ),
        /* Table B.2.c: 24 kHz */ /* docs: 332. mpg123(broken): 330 */
        new ScaleFac_1([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 114, 136, 162, 194, 232, 278, 332, 394, 464,
                540, 576],
            [0, 4, 8, 12, 18, 26, 36, 48, 62, 80, 104, 136, 180, 192]
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */
        ),
        /* Table B.2.a: 16 kHz */
        new ScaleFac_1([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 116, 140, 168, 200, 238, 284, 336, 396, 464,
                522, 576],
            [0, 4, 8, 12, 18, 26, 36, 48, 62, 80, 104, 134, 174, 192]
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */
        ),
        /* Table B.8.b: 44.1 kHz */
        new ScaleFac_1([0, 4, 8, 12, 16, 20, 24, 30, 36, 44, 52, 62, 74, 90, 110, 134, 162, 196, 238, 288, 342, 418,
                576],
            [0, 4, 8, 12, 16, 22, 30, 40, 52, 66, 84, 106, 136, 192]
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */
        ),
        /* Table B.8.c: 48 kHz */
        new ScaleFac_1([0, 4, 8, 12, 16, 20, 24, 30, 36, 42, 50, 60, 72, 88, 106, 128, 156, 190, 230, 276, 330, 384,
                576],
            [0, 4, 8, 12, 16, 22, 28, 38, 50, 64, 80, 100, 126, 192]
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */
        ),
        /* Table B.8.a: 32 kHz */
        new ScaleFac_1([0, 4, 8, 12, 16, 20, 24, 30, 36, 44, 54, 66, 82, 102, 126, 156, 194, 240, 296, 364, 448, 550,
                576],
            [0, 4, 8, 12, 16, 22, 30, 42, 58, 78, 104, 138, 180, 192]
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */
        ),
        /* MPEG-2.5 11.025 kHz */
        new ScaleFac_1([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 116, 140, 168, 200, 238, 284, 336, 396, 464,
                522, 576],
            [0 / 3, 12 / 3, 24 / 3, 36 / 3, 54 / 3, 78 / 3, 108 / 3, 144 / 3, 186 / 3, 240 / 3, 312 / 3,
                402 / 3, 522 / 3, 576 / 3]
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */
        ),
        /* MPEG-2.5 12 kHz */
        new ScaleFac_1([0, 6, 12, 18, 24, 30, 36, 44, 54, 66, 80, 96, 116, 140, 168, 200, 238, 284, 336, 396, 464,
                522, 576],
            [0 / 3, 12 / 3, 24 / 3, 36 / 3, 54 / 3, 78 / 3, 108 / 3, 144 / 3, 186 / 3, 240 / 3, 312 / 3,
                402 / 3, 522 / 3, 576 / 3]
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */
        ),
        /* MPEG-2.5 8 kHz */
        new ScaleFac_1([0, 12, 24, 36, 48, 60, 72, 88, 108, 132, 160, 192, 232, 280, 336, 400, 476, 566, 568, 570,
                572, 574, 576],
            [0 / 3, 24 / 3, 48 / 3, 72 / 3, 108 / 3, 156 / 3, 216 / 3, 288 / 3, 372 / 3, 480 / 3, 486 / 3,
                492 / 3, 498 / 3, 576 / 3]
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb21 pseudo sub bands */
            , [0, 0, 0, 0, 0, 0, 0] /*  sfb12 pseudo sub bands */
        )
    ];

    var pow20 = new_float$19(Q_MAX + Q_MAX2 + 1);
    var ipow20 = new_float$19(Q_MAX);
    var pow43 = new_float$19(PRECALC_SIZE);

    var adj43 = new_float$19(PRECALC_SIZE);
    this.adj43 = adj43;

    /**
     * <PRE>
     * compute the ATH for each scalefactor band cd range: 0..96db
     *
     * Input: 3.3kHz signal 32767 amplitude (3.3kHz is where ATH is smallest =
     * -5db) longblocks: sfb=12 en0/bw=-11db max_en0 = 1.3db shortblocks: sfb=5
     * -9db 0db
     *
     * Input: 1 1 1 1 1 1 1 -1 -1 -1 -1 -1 -1 -1 (repeated) longblocks: amp=1
     * sfb=12 en0/bw=-103 db max_en0 = -92db amp=32767 sfb=12 -12 db -1.4db
     *
     * Input: 1 1 1 1 1 1 1 -1 -1 -1 -1 -1 -1 -1 (repeated) shortblocks: amp=1
     * sfb=5 en0/bw= -99 -86 amp=32767 sfb=5 -9 db 4db
     *
     *
     * MAX energy of largest wave at 3.3kHz = 1db AVE energy of largest wave at
     * 3.3kHz = -11db Let's take AVE: -11db = maximum signal in sfb=12. Dynamic
     * range of CD: 96db. Therefor energy of smallest audible wave in sfb=12 =
     * -11 - 96 = -107db = ATH at 3.3kHz.
     *
     * ATH formula for this wave: -5db. To adjust to LAME scaling, we need ATH =
     * ATH_formula - 103 (db) ATH = ATH * 2.5e-10 (ener)
     * </PRE>
     */
    function ATHmdct(gfp, f) {
        var ath = psy.ATHformula(f, gfp);

        ath -= NSATHSCALE;

        /* modify the MDCT scaling for the ATH and convert to energy */
        ath = Math.pow(10.0, ath / 10.0 + gfp.ATHlower);
        return ath;
    }

    function compute_ath(gfp) {
        var ATH_l = gfp.internal_flags.ATH.l;
        var ATH_psfb21 = gfp.internal_flags.ATH.psfb21;
        var ATH_s = gfp.internal_flags.ATH.s;
        var ATH_psfb12 = gfp.internal_flags.ATH.psfb12;
        var gfc = gfp.internal_flags;
        var samp_freq = gfp.out_samplerate;

        for (var sfb = 0; sfb < Encoder_1.SBMAX_l; sfb++) {
            var start = gfc.scalefac_band.l[sfb];
            var end = gfc.scalefac_band.l[sfb + 1];
            ATH_l[sfb] = Float$19.MAX_VALUE;
            for (var i = start; i < end; i++) {
                var freq = i * samp_freq / (2 * 576);
                var ATH_f = ATHmdct(gfp, freq);
                /* freq in kHz */
                ATH_l[sfb] = Math.min(ATH_l[sfb], ATH_f);
            }
        }

        for (var sfb = 0; sfb < Encoder_1.PSFB21; sfb++) {
            var start = gfc.scalefac_band.psfb21[sfb];
            var end = gfc.scalefac_band.psfb21[sfb + 1];
            ATH_psfb21[sfb] = Float$19.MAX_VALUE;
            for (var i = start; i < end; i++) {
                var freq = i * samp_freq / (2 * 576);
                var ATH_f = ATHmdct(gfp, freq);
                /* freq in kHz */
                ATH_psfb21[sfb] = Math.min(ATH_psfb21[sfb], ATH_f);
            }
        }

        for (var sfb = 0; sfb < Encoder_1.SBMAX_s; sfb++) {
            var start = gfc.scalefac_band.s[sfb];
            var end = gfc.scalefac_band.s[sfb + 1];
            ATH_s[sfb] = Float$19.MAX_VALUE;
            for (var i = start; i < end; i++) {
                var freq = i * samp_freq / (2 * 192);
                var ATH_f = ATHmdct(gfp, freq);
                /* freq in kHz */
                ATH_s[sfb] = Math.min(ATH_s[sfb], ATH_f);
            }
            ATH_s[sfb] *= (gfc.scalefac_band.s[sfb + 1] - gfc.scalefac_band.s[sfb]);
        }

        for (var sfb = 0; sfb < Encoder_1.PSFB12; sfb++) {
            var start = gfc.scalefac_band.psfb12[sfb];
            var end = gfc.scalefac_band.psfb12[sfb + 1];
            ATH_psfb12[sfb] = Float$19.MAX_VALUE;
            for (var i = start; i < end; i++) {
                var freq = i * samp_freq / (2 * 192);
                var ATH_f = ATHmdct(gfp, freq);
                /* freq in kHz */
                ATH_psfb12[sfb] = Math.min(ATH_psfb12[sfb], ATH_f);
            }
            /* not sure about the following */
            ATH_psfb12[sfb] *= (gfc.scalefac_band.s[13] - gfc.scalefac_band.s[12]);
        }

        /*
         * no-ATH mode: reduce ATH to -200 dB
         */
        if (gfp.noATH) {
            for (var sfb = 0; sfb < Encoder_1.SBMAX_l; sfb++) {
                ATH_l[sfb] = 1E-20;
            }
            for (var sfb = 0; sfb < Encoder_1.PSFB21; sfb++) {
                ATH_psfb21[sfb] = 1E-20;
            }
            for (var sfb = 0; sfb < Encoder_1.SBMAX_s; sfb++) {
                ATH_s[sfb] = 1E-20;
            }
            for (var sfb = 0; sfb < Encoder_1.PSFB12; sfb++) {
                ATH_psfb12[sfb] = 1E-20;
            }
        }

        /*
         * work in progress, don't rely on it too much
         */
        gfc.ATH.floor = 10. * Math.log10(ATHmdct(gfp, -1.));
    }

    /**
     * initialization for iteration_loop
     */
    this.iteration_init = function (gfp) {
        var gfc = gfp.internal_flags;
        var l3_side = gfc.l3_side;
        var i;

        if (gfc.iteration_init_init == 0) {
            gfc.iteration_init_init = 1;

            l3_side.main_data_begin = 0;
            compute_ath(gfp);

            pow43[0] = 0.0;
            for (i = 1; i < PRECALC_SIZE; i++)
                pow43[i] = Math.pow(i, 4.0 / 3.0);

            for (i = 0; i < PRECALC_SIZE - 1; i++)
                adj43[i] = ((i + 1) - Math.pow(
                    0.5 * (pow43[i] + pow43[i + 1]), 0.75));
            adj43[i] = 0.5;

            for (i = 0; i < Q_MAX; i++)
                ipow20[i] = Math.pow(2.0, (i - 210) * -0.1875);
            for (i = 0; i <= Q_MAX + Q_MAX2; i++)
                pow20[i] = Math.pow(2.0, (i - 210 - Q_MAX2) * 0.25);

            tak.huffman_init(gfc);

            {
                var bass, alto, treble, sfb21;

                i = (gfp.exp_nspsytune >> 2) & 63;
                if (i >= 32)
                    i -= 64;
                bass = Math.pow(10, i / 4.0 / 10.0);

                i = (gfp.exp_nspsytune >> 8) & 63;
                if (i >= 32)
                    i -= 64;
                alto = Math.pow(10, i / 4.0 / 10.0);

                i = (gfp.exp_nspsytune >> 14) & 63;
                if (i >= 32)
                    i -= 64;
                treble = Math.pow(10, i / 4.0 / 10.0);

                /*
                 * to be compatible with Naoki's original code, the next 6 bits
                 * define only the amount of changing treble for sfb21
                 */
                i = (gfp.exp_nspsytune >> 20) & 63;
                if (i >= 32)
                    i -= 64;
                sfb21 = treble * Math.pow(10, i / 4.0 / 10.0);
                for (i = 0; i < Encoder_1.SBMAX_l; i++) {
                    var f;
                    if (i <= 6)
                        f = bass;
                    else if (i <= 13)
                        f = alto;
                    else if (i <= 20)
                        f = treble;
                    else
                        f = sfb21;

                    gfc.nsPsy.longfact[i] = f;
                }
                for (i = 0; i < Encoder_1.SBMAX_s; i++) {
                    var f;
                    if (i <= 5)
                        f = bass;
                    else if (i <= 10)
                        f = alto;
                    else if (i <= 11)
                        f = treble;
                    else
                        f = sfb21;

                    gfc.nsPsy.shortfact[i] = f;
                }
            }
        }
    };

    /**
     * allocate bits among 2 channels based on PE<BR>
     * mt 6/99<BR>
     * bugfixes rh 8/01: often allocated more than the allowed 4095 bits
     */
    this.on_pe = function (gfp, pe,
                           targ_bits, mean_bits, gr, cbr) {
        var gfc = gfp.internal_flags;
        var tbits = 0, bits;
        var add_bits = new_int$19(2);
        var ch;

        /* allocate targ_bits for granule */
        var mb = new MeanBits_1(tbits);
        var extra_bits = rv.ResvMaxBits(gfp, mean_bits, mb, cbr);
        tbits = mb.bits;
        /* maximum allowed bits for this granule */
        var max_bits = tbits + extra_bits;
        if (max_bits > LameInternalFlags_1.MAX_BITS_PER_GRANULE) {
            // hard limit per granule
            max_bits = LameInternalFlags_1.MAX_BITS_PER_GRANULE;
        }
        for (bits = 0, ch = 0; ch < gfc.channels_out; ++ch) {
            /******************************************************************
             * allocate bits for each channel
             ******************************************************************/
            targ_bits[ch] = Math.min(LameInternalFlags_1.MAX_BITS_PER_CHANNEL,
                tbits / gfc.channels_out);

            add_bits[ch] = 0 | (targ_bits[ch] * pe[gr][ch] / 700.0 - targ_bits[ch]);

            /* at most increase bits by 1.5*average */
            if (add_bits[ch] > mean_bits * 3 / 4)
                add_bits[ch] = mean_bits * 3 / 4;
            if (add_bits[ch] < 0)
                add_bits[ch] = 0;

            if (add_bits[ch] + targ_bits[ch] > LameInternalFlags_1.MAX_BITS_PER_CHANNEL)
                add_bits[ch] = Math.max(0,
                    LameInternalFlags_1.MAX_BITS_PER_CHANNEL - targ_bits[ch]);

            bits += add_bits[ch];
        }
        if (bits > extra_bits) {
            for (ch = 0; ch < gfc.channels_out; ++ch) {
                add_bits[ch] = extra_bits * add_bits[ch] / bits;
            }
        }

        for (ch = 0; ch < gfc.channels_out; ++ch) {
            targ_bits[ch] += add_bits[ch];
            extra_bits -= add_bits[ch];
        }

        for (bits = 0, ch = 0; ch < gfc.channels_out; ++ch) {
            bits += targ_bits[ch];
        }
        if (bits > LameInternalFlags_1.MAX_BITS_PER_GRANULE) {
            var sum = 0;
            for (ch = 0; ch < gfc.channels_out; ++ch) {
                targ_bits[ch] *= LameInternalFlags_1.MAX_BITS_PER_GRANULE;
                targ_bits[ch] /= bits;
                sum += targ_bits[ch];
            }
            assert$19(sum <= LameInternalFlags_1.MAX_BITS_PER_GRANULE);
        }

        return max_bits;
    };

    this.reduce_side = function (targ_bits, ms_ener_ratio, mean_bits, max_bits) {
        assert$19(max_bits <= LameInternalFlags_1.MAX_BITS_PER_GRANULE);
        assert$19(targ_bits[0] + targ_bits[1] <= LameInternalFlags_1.MAX_BITS_PER_GRANULE);

        /*
         * ms_ener_ratio = 0: allocate 66/33 mid/side fac=.33 ms_ener_ratio =.5:
         * allocate 50/50 mid/side fac= 0
         */
        /* 75/25 split is fac=.5 */
        var fac = .33 * (.5 - ms_ener_ratio) / .5;
        if (fac < 0)
            fac = 0;
        if (fac > .5)
            fac = .5;

        /* number of bits to move from side channel to mid channel */
        /* move_bits = fac*targ_bits[1]; */
        var move_bits = 0 | (fac * .5 * (targ_bits[0] + targ_bits[1]));

        if (move_bits > LameInternalFlags_1.MAX_BITS_PER_CHANNEL - targ_bits[0]) {
            move_bits = LameInternalFlags_1.MAX_BITS_PER_CHANNEL - targ_bits[0];
        }
        if (move_bits < 0)
            move_bits = 0;

        if (targ_bits[1] >= 125) {
            /* dont reduce side channel below 125 bits */
            if (targ_bits[1] - move_bits > 125) {

                /* if mid channel already has 2x more than average, dont bother */
                /* mean_bits = bits per granule (for both channels) */
                if (targ_bits[0] < mean_bits)
                    targ_bits[0] += move_bits;
                targ_bits[1] -= move_bits;
            } else {
                targ_bits[0] += targ_bits[1] - 125;
                targ_bits[1] = 125;
            }
        }

        move_bits = targ_bits[0] + targ_bits[1];
        if (move_bits > max_bits) {
            targ_bits[0] = (max_bits * targ_bits[0]) / move_bits;
            targ_bits[1] = (max_bits * targ_bits[1]) / move_bits;
        }
        assert$19(targ_bits[0] <= LameInternalFlags_1.MAX_BITS_PER_CHANNEL);
        assert$19(targ_bits[1] <= LameInternalFlags_1.MAX_BITS_PER_CHANNEL);
        assert$19(targ_bits[0] + targ_bits[1] <= LameInternalFlags_1.MAX_BITS_PER_GRANULE);
    };

    /**
     *  Robert Hegemann 2001-04-27:
     *  this adjusts the ATH, keeping the original noise floor
     *  affects the higher frequencies more than the lower ones
     */
    this.athAdjust = function (a, x, athFloor) {
        /*
         * work in progress
         */
        var o = 90.30873362;
        var p = 94.82444863;
        var u = Util$19.FAST_LOG10_X(x, 10.0);
        var v = a * a;
        var w = 0.0;
        u -= athFloor;
        /* undo scaling */
        if (v > 1E-20)
            w = 1. + Util$19.FAST_LOG10_X(v, 10.0 / o);
        if (w < 0)
            w = 0.;
        u *= w;
        u += athFloor + o - p;
        /* redo scaling */

        return Math.pow(10., 0.1 * u);
    };

    /**
     * Calculate the allowed distortion for each scalefactor band, as determined
     * by the psychoacoustic model. xmin(sb) = ratio(sb) * en(sb) / bw(sb)
     *
     * returns number of sfb's with energy > ATH
     */
    this.calc_xmin = function (gfp, ratio, cod_info, pxmin) {
        var pxminPos = 0;
        var gfc = gfp.internal_flags;
        var gsfb, j = 0, ath_over = 0;
        var ATH = gfc.ATH;
        var xr = cod_info.xr;
        var enable_athaa_fix = (gfp.VBR == VbrMode$19.vbr_mtrh) ? 1 : 0;
        var masking_lower = gfc.masking_lower;

        if (gfp.VBR == VbrMode$19.vbr_mtrh || gfp.VBR == VbrMode$19.vbr_mt) {
            /* was already done in PSY-Model */
            masking_lower = 1.0;
        }

        for (gsfb = 0; gsfb < cod_info.psy_lmax; gsfb++) {
            var en0, xmin;
            var rh1, rh2;
            var width, l;

            if (gfp.VBR == VbrMode$19.vbr_rh || gfp.VBR == VbrMode$19.vbr_mtrh)
                xmin = athAdjust(ATH.adjust, ATH.l[gsfb], ATH.floor);
            else
                xmin = ATH.adjust * ATH.l[gsfb];

            width = cod_info.width[gsfb];
            rh1 = xmin / width;
            rh2 = DBL_EPSILON;
            l = width >> 1;
            en0 = 0.0;
            do {
                var xa, xb;
                xa = xr[j] * xr[j];
                en0 += xa;
                rh2 += (xa < rh1) ? xa : rh1;
                j++;
                xb = xr[j] * xr[j];
                en0 += xb;
                rh2 += (xb < rh1) ? xb : rh1;
                j++;
            } while (--l > 0);
            if (en0 > xmin)
                ath_over++;

            if (gsfb == Encoder_1.SBPSY_l) {
                var x = xmin * gfc.nsPsy.longfact[gsfb];
                if (rh2 < x) {
                    rh2 = x;
                }
            }
            if (enable_athaa_fix != 0) {
                xmin = rh2;
            }
            if (!gfp.ATHonly) {
                var e = ratio.en.l[gsfb];
                if (e > 0.0) {
                    var x;
                    x = en0 * ratio.thm.l[gsfb] * masking_lower / e;
                    if (enable_athaa_fix != 0)
                        x *= gfc.nsPsy.longfact[gsfb];
                    if (xmin < x)
                        xmin = x;
                }
            }
            if (enable_athaa_fix != 0)
                pxmin[pxminPos++] = xmin;
            else
                pxmin[pxminPos++] = xmin * gfc.nsPsy.longfact[gsfb];
        }
        /* end of long block loop */

        /* use this function to determine the highest non-zero coeff */
        var max_nonzero = 575;
        if (cod_info.block_type != Encoder_1.SHORT_TYPE) {
            // NORM, START or STOP type, but not SHORT
            var k = 576;
            while (k-- != 0 && BitStream.EQ(xr[k], 0)) {
                max_nonzero = k;
            }
        }
        cod_info.max_nonzero_coeff = max_nonzero;

        for (var sfb = cod_info.sfb_smin; gsfb < cod_info.psymax; sfb++, gsfb += 3) {
            var width, b;
            var tmpATH;
            if (gfp.VBR == VbrMode$19.vbr_rh || gfp.VBR == VbrMode$19.vbr_mtrh)
                tmpATH = athAdjust(ATH.adjust, ATH.s[sfb], ATH.floor);
            else
                tmpATH = ATH.adjust * ATH.s[sfb];

            width = cod_info.width[gsfb];
            for (b = 0; b < 3; b++) {
                var en0 = 0.0, xmin;
                var rh1, rh2;
                var l = width >> 1;

                rh1 = tmpATH / width;
                rh2 = DBL_EPSILON;
                do {
                    var xa, xb;
                    xa = xr[j] * xr[j];
                    en0 += xa;
                    rh2 += (xa < rh1) ? xa : rh1;
                    j++;
                    xb = xr[j] * xr[j];
                    en0 += xb;
                    rh2 += (xb < rh1) ? xb : rh1;
                    j++;
                } while (--l > 0);
                if (en0 > tmpATH)
                    ath_over++;
                if (sfb == Encoder_1.SBPSY_s) {
                    var x = tmpATH * gfc.nsPsy.shortfact[sfb];
                    if (rh2 < x) {
                        rh2 = x;
                    }
                }
                if (enable_athaa_fix != 0)
                    xmin = rh2;
                else
                    xmin = tmpATH;

                if (!gfp.ATHonly && !gfp.ATHshort) {
                    var e = ratio.en.s[sfb][b];
                    if (e > 0.0) {
                        var x;
                        x = en0 * ratio.thm.s[sfb][b] * masking_lower / e;
                        if (enable_athaa_fix != 0)
                            x *= gfc.nsPsy.shortfact[sfb];
                        if (xmin < x)
                            xmin = x;
                    }
                }
                if (enable_athaa_fix != 0)
                    pxmin[pxminPos++] = xmin;
                else
                    pxmin[pxminPos++] = xmin * gfc.nsPsy.shortfact[sfb];
            }
            /* b */
            if (gfp.useTemporal) {
                if (pxmin[pxminPos - 3] > pxmin[pxminPos - 3 + 1])
                    pxmin[pxminPos - 3 + 1] += (pxmin[pxminPos - 3] - pxmin[pxminPos - 3 + 1])
                        * gfc.decay;
                if (pxmin[pxminPos - 3 + 1] > pxmin[pxminPos - 3 + 2])
                    pxmin[pxminPos - 3 + 2] += (pxmin[pxminPos - 3 + 1] - pxmin[pxminPos - 3 + 2])
                        * gfc.decay;
            }
        }
        /* end of short block sfb loop */

        return ath_over;
    };

    function StartLine(j) {
        this.s = j;
    }

    this.calc_noise_core = function (cod_info, startline, l, step) {
        var noise = 0;
        var j = startline.s;
        var ix = cod_info.l3_enc;

        if (j > cod_info.count1) {
            while ((l--) != 0) {
                var temp;
                temp = cod_info.xr[j];
                j++;
                noise += temp * temp;
                temp = cod_info.xr[j];
                j++;
                noise += temp * temp;
            }
        } else if (j > cod_info.big_values) {
            var ix01 = new_float$19(2);
            ix01[0] = 0;
            ix01[1] = step;
            while ((l--) != 0) {
                var temp;
                temp = Math.abs(cod_info.xr[j]) - ix01[ix[j]];
                j++;
                noise += temp * temp;
                temp = Math.abs(cod_info.xr[j]) - ix01[ix[j]];
                j++;
                noise += temp * temp;
            }
        } else {
            while ((l--) != 0) {
                var temp;
                temp = Math.abs(cod_info.xr[j]) - pow43[ix[j]] * step;
                j++;
                noise += temp * temp;
                temp = Math.abs(cod_info.xr[j]) - pow43[ix[j]] * step;
                j++;
                noise += temp * temp;
            }
        }

        startline.s = j;
        return noise;
    };

    /**
     * <PRE>
     * -oo dB  =>  -1.00
     * - 6 dB  =>  -0.97
     * - 3 dB  =>  -0.80
     * - 2 dB  =>  -0.64
     * - 1 dB  =>  -0.38
     *   0 dB  =>   0.00
     * + 1 dB  =>  +0.49
     * + 2 dB  =>  +1.06
     * + 3 dB  =>  +1.68
     * + 6 dB  =>  +3.69
     * +10 dB  =>  +6.45
     * </PRE>
     */
    this.calc_noise = function (cod_info, l3_xmin, distort, res, prev_noise) {
        var distortPos = 0;
        var l3_xminPos = 0;
        var sfb, l, over = 0;
        var over_noise_db = 0;
        /* 0 dB relative to masking */
        var tot_noise_db = 0;
        /* -200 dB relative to masking */
        var max_noise = -20.0;
        var j = 0;
        var scalefac = cod_info.scalefac;
        var scalefacPos = 0;

        res.over_SSD = 0;

        for (sfb = 0; sfb < cod_info.psymax; sfb++) {
            var s = cod_info.global_gain
                - (((scalefac[scalefacPos++]) + (cod_info.preflag != 0 ? pretab[sfb]
                    : 0)) << (cod_info.scalefac_scale + 1))
                - cod_info.subblock_gain[cod_info.window[sfb]] * 8;
            var noise = 0.0;

            if (prev_noise != null && (prev_noise.step[sfb] == s)) {

                /* use previously computed values */
                noise = prev_noise.noise[sfb];
                j += cod_info.width[sfb];
                distort[distortPos++] = noise / l3_xmin[l3_xminPos++];

                noise = prev_noise.noise_log[sfb];

            } else {
                var step = POW20(s);
                l = cod_info.width[sfb] >> 1;

                if ((j + cod_info.width[sfb]) > cod_info.max_nonzero_coeff) {
                    var usefullsize;
                    usefullsize = cod_info.max_nonzero_coeff - j + 1;

                    if (usefullsize > 0)
                        l = usefullsize >> 1;
                    else
                        l = 0;
                }

                var sl = new StartLine(j);
                noise = this.calc_noise_core(cod_info, sl, l, step);
                j = sl.s;

                if (prev_noise != null) {
                    /* save noise values */
                    prev_noise.step[sfb] = s;
                    prev_noise.noise[sfb] = noise;
                }

                noise = distort[distortPos++] = noise / l3_xmin[l3_xminPos++];

                /* multiplying here is adding in dB, but can overflow */
                noise = Util$19.FAST_LOG10(Math.max(noise, 1E-20));

                if (prev_noise != null) {
                    /* save noise values */
                    prev_noise.noise_log[sfb] = noise;
                }
            }

            if (prev_noise != null) {
                /* save noise values */
                prev_noise.global_gain = cod_info.global_gain;
            }

            tot_noise_db += noise;

            if (noise > 0.0) {
                var tmp;

                tmp = Math.max(0 | (noise * 10 + .5), 1);
                res.over_SSD += tmp * tmp;

                over++;
                /* multiplying here is adding in dB -but can overflow */
                /* over_noise *= noise; */
                over_noise_db += noise;
            }
            max_noise = Math.max(max_noise, noise);

        }

        res.over_count = over;
        res.tot_noise = tot_noise_db;
        res.over_noise = over_noise_db;
        res.max_noise = max_noise;

        return over;
    };

    /**
     * updates plotting data
     *
     * Mark Taylor 2000-??-??
     *
     * Robert Hegemann: moved noise/distortion calc into it
     */
    this.set_pinfo = function (gfp, cod_info, ratio, gr, ch) {
        var gfc = gfp.internal_flags;
        var sfb, sfb2;
        var l;
        var en0, en1;
        var ifqstep = (cod_info.scalefac_scale == 0) ? .5 : 1.0;
        var scalefac = cod_info.scalefac;

        var l3_xmin = new_float$19(L3Side.SFBMAX);
        var xfsf = new_float$19(L3Side.SFBMAX);
        var noise = new CalcNoiseResult();

        calc_xmin(gfp, ratio, cod_info, l3_xmin);
        calc_noise(cod_info, l3_xmin, xfsf, noise, null);

        var j = 0;
        sfb2 = cod_info.sfb_lmax;
        if (cod_info.block_type != Encoder_1.SHORT_TYPE
            && 0 == cod_info.mixed_block_flag)
            sfb2 = 22;
        for (sfb = 0; sfb < sfb2; sfb++) {
            var start = gfc.scalefac_band.l[sfb];
            var end = gfc.scalefac_band.l[sfb + 1];
            var bw = end - start;
            for (en0 = 0.0; j < end; j++)
                en0 += cod_info.xr[j] * cod_info.xr[j];
            en0 /= bw;
            /* convert to MDCT units */
            /* scaling so it shows up on FFT plot */
            en1 = 1e15;
            gfc.pinfo.en[gr][ch][sfb] = en1 * en0;
            gfc.pinfo.xfsf[gr][ch][sfb] = en1 * l3_xmin[sfb] * xfsf[sfb] / bw;

            if (ratio.en.l[sfb] > 0 && !gfp.ATHonly)
                en0 = en0 / ratio.en.l[sfb];
            else
                en0 = 0.0;

            gfc.pinfo.thr[gr][ch][sfb] = en1
                * Math.max(en0 * ratio.thm.l[sfb], gfc.ATH.l[sfb]);

            /* there is no scalefactor bands >= SBPSY_l */
            gfc.pinfo.LAMEsfb[gr][ch][sfb] = 0;
            if (cod_info.preflag != 0 && sfb >= 11)
                gfc.pinfo.LAMEsfb[gr][ch][sfb] = -ifqstep * pretab[sfb];

            if (sfb < Encoder_1.SBPSY_l) {
                /* scfsi should be decoded by caller side */
                assert$19(scalefac[sfb] >= 0);
                gfc.pinfo.LAMEsfb[gr][ch][sfb] -= ifqstep * scalefac[sfb];
            }
        }
        /* for sfb */

        if (cod_info.block_type == Encoder_1.SHORT_TYPE) {
            sfb2 = sfb;
            for (sfb = cod_info.sfb_smin; sfb < Encoder_1.SBMAX_s; sfb++) {
                var start = gfc.scalefac_band.s[sfb];
                var end = gfc.scalefac_band.s[sfb + 1];
                var bw = end - start;
                for (var i = 0; i < 3; i++) {
                    for (en0 = 0.0, l = start; l < end; l++) {
                        en0 += cod_info.xr[j] * cod_info.xr[j];
                        j++;
                    }
                    en0 = Math.max(en0 / bw, 1e-20);
                    /* convert to MDCT units */
                    /* scaling so it shows up on FFT plot */
                    en1 = 1e15;

                    gfc.pinfo.en_s[gr][ch][3 * sfb + i] = en1 * en0;
                    gfc.pinfo.xfsf_s[gr][ch][3 * sfb + i] = en1 * l3_xmin[sfb2]
                        * xfsf[sfb2] / bw;
                    if (ratio.en.s[sfb][i] > 0)
                        en0 = en0 / ratio.en.s[sfb][i];
                    else
                        en0 = 0.0;
                    if (gfp.ATHonly || gfp.ATHshort)
                        en0 = 0;

                    gfc.pinfo.thr_s[gr][ch][3 * sfb + i] = en1
                        * Math.max(en0 * ratio.thm.s[sfb][i],
                            gfc.ATH.s[sfb]);

                    /* there is no scalefactor bands >= SBPSY_s */
                    gfc.pinfo.LAMEsfb_s[gr][ch][3 * sfb + i] = -2.0
                        * cod_info.subblock_gain[i];
                    if (sfb < Encoder_1.SBPSY_s) {
                        gfc.pinfo.LAMEsfb_s[gr][ch][3 * sfb + i] -= ifqstep
                            * scalefac[sfb2];
                    }
                    sfb2++;
                }
            }
        }
        /* block type short */
        gfc.pinfo.LAMEqss[gr][ch] = cod_info.global_gain;
        gfc.pinfo.LAMEmainbits[gr][ch] = cod_info.part2_3_length
            + cod_info.part2_length;
        gfc.pinfo.LAMEsfbits[gr][ch] = cod_info.part2_length;

        gfc.pinfo.over[gr][ch] = noise.over_count;
        gfc.pinfo.max_noise[gr][ch] = noise.max_noise * 10.0;
        gfc.pinfo.over_noise[gr][ch] = noise.over_noise * 10.0;
        gfc.pinfo.tot_noise[gr][ch] = noise.tot_noise * 10.0;
        gfc.pinfo.over_SSD[gr][ch] = noise.over_SSD;
    };

    /**
     * updates plotting data for a whole frame
     *
     * Robert Hegemann 2000-10-21
     */
    

}

var QuantizePVT_1 = QuantizePVT$1;

/*
 *	MP3 huffman table selecting and bit counting
 *
 *	Copyright (c) 1999-2005 Takehiro TOMINAGA
 *	Copyright (c) 2002-2005 Gabriel Bouvigne
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.	 See the GNU
 * Library General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the
 * Free Software Foundation, Inc., 59 Temple Place - Suite 330,
 * Boston, MA 02111-1307, USA.
 */

/* $Id: Takehiro.java,v 1.26 2011/05/24 20:48:06 kenchis Exp $ */

//package mp3;

//import java.util.Arrays;

var System$18 = common.System;
var Arrays$18 = common.Arrays;
var new_int$18 = common.new_int;
var assert$18 = common.assert;







function Takehiro$1() {

    var qupvt = null;
    this.qupvt = null;

    this.setModules = function (_qupvt) {
        this.qupvt = _qupvt;
        qupvt = _qupvt;
    };

    function Bits(b) {
        this.bits = 0 | b;
    }

    var subdv_table = [[0, 0], /* 0 bands */
        [0, 0], /* 1 bands */
        [0, 0], /* 2 bands */
        [0, 0], /* 3 bands */
        [0, 0], /* 4 bands */
        [0, 1], /* 5 bands */
        [1, 1], /* 6 bands */
        [1, 1], /* 7 bands */
        [1, 2], /* 8 bands */
        [2, 2], /* 9 bands */
        [2, 3], /* 10 bands */
        [2, 3], /* 11 bands */
        [3, 4], /* 12 bands */
        [3, 4], /* 13 bands */
        [3, 4], /* 14 bands */
        [4, 5], /* 15 bands */
        [4, 5], /* 16 bands */
        [4, 6], /* 17 bands */
        [5, 6], /* 18 bands */
        [5, 6], /* 19 bands */
        [5, 7], /* 20 bands */
        [6, 7], /* 21 bands */
        [6, 7], /* 22 bands */
    ];

    /**
     * nonlinear quantization of xr More accurate formula than the ISO formula.
     * Takes into account the fact that we are quantizing xr . ix, but we want
     * ix^4/3 to be as close as possible to x^4/3. (taking the nearest int would
     * mean ix is as close as possible to xr, which is different.)
     *
     * From Segher Boessenkool <segher@eastsite.nl> 11/1999
     *
     * 09/2000: ASM code removed in favor of IEEE754 hack by Takehiro Tominaga.
     * If you need the ASM code, check CVS circa Aug 2000.
     *
     * 01/2004: Optimizations by Gabriel Bouvigne
     */
    function quantize_lines_xrpow_01(l, istep, xr, xrPos, ix, ixPos) {
        var compareval0 = (1.0 - 0.4054) / istep;

        assert$18(l > 0);
        l = l >> 1;
        while ((l--) != 0) {
            ix[ixPos++] = (compareval0 > xr[xrPos++]) ? 0 : 1;
            ix[ixPos++] = (compareval0 > xr[xrPos++]) ? 0 : 1;
        }
    }

    /**
     * XRPOW_FTOI is a macro to convert floats to ints.<BR>
     * if XRPOW_FTOI(x) = nearest_int(x), then QUANTFAC(x)=adj43asm[x]<BR>
     * ROUNDFAC= -0.0946<BR>
     *
     * if XRPOW_FTOI(x) = floor(x), then QUANTFAC(x)=asj43[x]<BR>
     * ROUNDFAC=0.4054<BR>
     *
     * Note: using floor() or 0| is extremely slow. On machines where the
     * TAKEHIRO_IEEE754_HACK code above does not work, it is worthwile to write
     * some ASM for XRPOW_FTOI().
     */
    function quantize_lines_xrpow(l, istep, xr, xrPos, ix, ixPos) {
        assert$18(l > 0);

        l = l >> 1;
        var remaining = l % 2;
        l = l >> 1;
        while (l-- != 0) {
            var x0, x1, x2, x3;
            var rx0, rx1, rx2, rx3;

            x0 = xr[xrPos++] * istep;
            x1 = xr[xrPos++] * istep;
            rx0 = 0 | x0;
            x2 = xr[xrPos++] * istep;
            rx1 = 0 | x1;
            x3 = xr[xrPos++] * istep;
            rx2 = 0 | x2;
            x0 += qupvt.adj43[rx0];
            rx3 = 0 | x3;
            x1 += qupvt.adj43[rx1];
            ix[ixPos++] = 0 | x0;
            x2 += qupvt.adj43[rx2];
            ix[ixPos++] = 0 | x1;
            x3 += qupvt.adj43[rx3];
            ix[ixPos++] = 0 | x2;
            ix[ixPos++] = 0 | x3;
        }
        if (remaining != 0) {
            var x0, x1;
            var rx0, rx1;

            x0 = xr[xrPos++] * istep;
            x1 = xr[xrPos++] * istep;
            rx0 = 0 | x0;
            rx1 = 0 | x1;
            x0 += qupvt.adj43[rx0];
            x1 += qupvt.adj43[rx1];
            ix[ixPos++] = 0 | x0;
            ix[ixPos++] = 0 | x1;
        }
    }

    /**
     * Quantization function This function will select which lines to quantize
     * and call the proper quantization function
     */
    function quantize_xrpow(xp, pi, istep, codInfo, prevNoise) {
        /* quantize on xr^(3/4) instead of xr */
        var sfb;
        var sfbmax;
        var j = 0;
        var prev_data_use;
        var accumulate = 0;
        var accumulate01 = 0;
        var xpPos = 0;
        var iData = pi;
        var iDataPos = 0;
        var acc_iData = iData;
        var acc_iDataPos = 0;
        var acc_xp = xp;
        var acc_xpPos = 0;

        /*
         * Reusing previously computed data does not seems to work if global
         * gain is changed. Finding why it behaves this way would allow to use a
         * cache of previously computed values (let's 10 cached values per sfb)
         * that would probably provide a noticeable speedup
         */
        prev_data_use = (prevNoise != null && (codInfo.global_gain == prevNoise.global_gain));

        if (codInfo.block_type == Encoder_1.SHORT_TYPE)
            sfbmax = 38;
        else
            sfbmax = 21;

        for (sfb = 0; sfb <= sfbmax; sfb++) {
            var step = -1;

            if (prev_data_use || codInfo.block_type == Encoder_1.NORM_TYPE) {
                step = codInfo.global_gain
                    - ((codInfo.scalefac[sfb] + (codInfo.preflag != 0 ? qupvt.pretab[sfb]
                        : 0)) << (codInfo.scalefac_scale + 1))
                    - codInfo.subblock_gain[codInfo.window[sfb]] * 8;
            }
            assert$18(codInfo.width[sfb] >= 0);
            if (prev_data_use && (prevNoise.step[sfb] == step)) {
                /*
                 * do not recompute this part, but compute accumulated lines
                 */
                if (accumulate != 0) {
                    quantize_lines_xrpow(accumulate, istep, acc_xp, acc_xpPos,
                        acc_iData, acc_iDataPos);
                    accumulate = 0;
                }
                if (accumulate01 != 0) {
                    quantize_lines_xrpow_01(accumulate01, istep, acc_xp,
                        acc_xpPos, acc_iData, acc_iDataPos);
                    accumulate01 = 0;
                }
            } else { /* should compute this part */
                var l = codInfo.width[sfb];

                if ((j + codInfo.width[sfb]) > codInfo.max_nonzero_coeff) {
                    /* do not compute upper zero part */
                    var usefullsize;
                    usefullsize = codInfo.max_nonzero_coeff - j + 1;
                    Arrays$18.fill(pi, codInfo.max_nonzero_coeff, 576, 0);
                    l = usefullsize;

                    if (l < 0) {
                        l = 0;
                    }

                    /* no need to compute higher sfb values */
                    sfb = sfbmax + 1;
                }

                /* accumulate lines to quantize */
                if (0 == accumulate && 0 == accumulate01) {
                    acc_iData = iData;
                    acc_iDataPos = iDataPos;
                    acc_xp = xp;
                    acc_xpPos = xpPos;
                }
                if (prevNoise != null && prevNoise.sfb_count1 > 0
                    && sfb >= prevNoise.sfb_count1
                    && prevNoise.step[sfb] > 0
                    && step >= prevNoise.step[sfb]) {

                    if (accumulate != 0) {
                        quantize_lines_xrpow(accumulate, istep, acc_xp,
                            acc_xpPos, acc_iData, acc_iDataPos);
                        accumulate = 0;
                        acc_iData = iData;
                        acc_iDataPos = iDataPos;
                        acc_xp = xp;
                        acc_xpPos = xpPos;
                    }
                    accumulate01 += l;
                } else {
                    if (accumulate01 != 0) {
                        quantize_lines_xrpow_01(accumulate01, istep, acc_xp,
                            acc_xpPos, acc_iData, acc_iDataPos);
                        accumulate01 = 0;
                        acc_iData = iData;
                        acc_iDataPos = iDataPos;
                        acc_xp = xp;
                        acc_xpPos = xpPos;
                    }
                    accumulate += l;
                }

                if (l <= 0) {
                    /*
                     * rh: 20040215 may happen due to "prev_data_use"
                     * optimization
                     */
                    if (accumulate01 != 0) {
                        quantize_lines_xrpow_01(accumulate01, istep, acc_xp,
                            acc_xpPos, acc_iData, acc_iDataPos);
                        accumulate01 = 0;
                    }
                    if (accumulate != 0) {
                        quantize_lines_xrpow(accumulate, istep, acc_xp,
                            acc_xpPos, acc_iData, acc_iDataPos);
                        accumulate = 0;
                    }

                    break;
                    /* ends for-loop */
                }
            }
            if (sfb <= sfbmax) {
                iDataPos += codInfo.width[sfb];
                xpPos += codInfo.width[sfb];
                j += codInfo.width[sfb];
            }
        }
        if (accumulate != 0) { /* last data part */
            quantize_lines_xrpow(accumulate, istep, acc_xp, acc_xpPos,
                acc_iData, acc_iDataPos);
            accumulate = 0;
        }
        if (accumulate01 != 0) { /* last data part */
            quantize_lines_xrpow_01(accumulate01, istep, acc_xp, acc_xpPos,
                acc_iData, acc_iDataPos);
            accumulate01 = 0;
        }

    }

    /**
     * ix_max
     */
    function ix_max(ix, ixPos, endPos) {
        var max1 = 0, max2 = 0;

        do {
            var x1 = ix[ixPos++];
            var x2 = ix[ixPos++];
            if (max1 < x1)
                max1 = x1;

            if (max2 < x2)
                max2 = x2;
        } while (ixPos < endPos);
        if (max1 < max2)
            max1 = max2;
        return max1;
    }

    function count_bit_ESC(ix, ixPos, end, t1, t2, s) {
        /* ESC-table is used */
        var linbits = Tables_1.ht[t1].xlen * 65536 + Tables_1.ht[t2].xlen;
        var sum = 0, sum2;

        do {
            var x = ix[ixPos++];
            var y = ix[ixPos++];

            if (x != 0) {
                if (x > 14) {
                    x = 15;
                    sum += linbits;
                }
                x *= 16;
            }

            if (y != 0) {
                if (y > 14) {
                    y = 15;
                    sum += linbits;
                }
                x += y;
            }

            sum += Tables_1.largetbl[x];
        } while (ixPos < end);

        sum2 = sum & 0xffff;
        sum >>= 16;

        if (sum > sum2) {
            sum = sum2;
            t1 = t2;
        }

        s.bits += sum;
        return t1;
    }

    function count_bit_noESC(ix, ixPos, end, s) {
        /* No ESC-words */
        var sum1 = 0;
        var hlen1 = Tables_1.ht[1].hlen;

        do {
            var x = ix[ixPos + 0] * 2 + ix[ixPos + 1];
            ixPos += 2;
            sum1 += hlen1[x];
        } while (ixPos < end);

        s.bits += sum1;
        return 1;
    }

    function count_bit_noESC_from2(ix, ixPos, end, t1, s) {
        /* No ESC-words */
        var sum = 0, sum2;
        var xlen = Tables_1.ht[t1].xlen;
        var hlen;
        if (t1 == 2)
            hlen = Tables_1.table23;
        else
            hlen = Tables_1.table56;

        do {
            var x = ix[ixPos + 0] * xlen + ix[ixPos + 1];
            ixPos += 2;
            sum += hlen[x];
        } while (ixPos < end);

        sum2 = sum & 0xffff;
        sum >>= 16;

        if (sum > sum2) {
            sum = sum2;
            t1++;
        }

        s.bits += sum;
        return t1;
    }

    function count_bit_noESC_from3(ix, ixPos, end, t1, s) {
        /* No ESC-words */
        var sum1 = 0;
        var sum2 = 0;
        var sum3 = 0;
        var xlen = Tables_1.ht[t1].xlen;
        var hlen1 = Tables_1.ht[t1].hlen;
        var hlen2 = Tables_1.ht[t1 + 1].hlen;
        var hlen3 = Tables_1.ht[t1 + 2].hlen;

        do {
            var x = ix[ixPos + 0] * xlen + ix[ixPos + 1];
            ixPos += 2;
            sum1 += hlen1[x];
            sum2 += hlen2[x];
            sum3 += hlen3[x];
        } while (ixPos < end);
        var t = t1;
        if (sum1 > sum2) {
            sum1 = sum2;
            t++;
        }
        if (sum1 > sum3) {
            sum1 = sum3;
            t = t1 + 2;
        }
        s.bits += sum1;

        return t;
    }

    /*************************************************************************/
    /* choose table */
    /*************************************************************************/

    var huf_tbl_noESC = [1, 2, 5, 7, 7, 10, 10, 13, 13,
        13, 13, 13, 13, 13, 13];

    /**
     * Choose the Huffman table that will encode ix[begin..end] with the fewest
     * bits.
     *
     * Note: This code contains knowledge about the sizes and characteristics of
     * the Huffman tables as defined in the IS (Table B.7), and will not work
     * with any arbitrary tables.
     */
    function choose_table(ix, ixPos, endPos, s) {
        var max = ix_max(ix, ixPos, endPos);

        switch (max) {
            case 0:
                return max;

            case 1:
                return count_bit_noESC(ix, ixPos, endPos, s);

            case 2:
            case 3:
                return count_bit_noESC_from2(ix, ixPos, endPos,
                    huf_tbl_noESC[max - 1], s);

            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
            case 10:
            case 11:
            case 12:
            case 13:
            case 14:
            case 15:
                return count_bit_noESC_from3(ix, ixPos, endPos,
                    huf_tbl_noESC[max - 1], s);

            default:
                /* try tables with linbits */
                if (max > QuantizePVT_1.IXMAX_VAL) {
                    s.bits = QuantizePVT_1.LARGE_BITS;
                    return -1;
                }
                max -= 15;
                var choice2;
                for (choice2 = 24; choice2 < 32; choice2++) {
                    if (Tables_1.ht[choice2].linmax >= max) {
                        break;
                    }
                }
                var choice;
                for (choice = choice2 - 8; choice < 24; choice++) {
                    if (Tables_1.ht[choice].linmax >= max) {
                        break;
                    }
                }
                return count_bit_ESC(ix, ixPos, endPos, choice, choice2, s);
        }
    }

    /**
     * count_bit
     */
    this.noquant_count_bits = function (gfc, gi, prev_noise) {
        var ix = gi.l3_enc;
        var i = Math.min(576, ((gi.max_nonzero_coeff + 2) >> 1) << 1);

        if (prev_noise != null)
            prev_noise.sfb_count1 = 0;

        /* Determine count1 region */
        for (; i > 1; i -= 2)
            if ((ix[i - 1] | ix[i - 2]) != 0)
                break;
        gi.count1 = i;

        /* Determines the number of bits to encode the quadruples. */
        var a1 = 0;
        var a2 = 0;
        for (; i > 3; i -= 4) {
            var p;
            /* hack to check if all values <= 1 */
            //throw "TODO: HACK         if ((((long) ix[i - 1] | (long) ix[i - 2] | (long) ix[i - 3] | (long) ix[i - 4]) & 0xffffffffL) > 1L        "
            //if (true) {
            if (((ix[i - 1] | ix[i - 2] | ix[i - 3] | ix[i - 4]) & 0x7fffffff) > 1) {
                break;
            }
            p = ((ix[i - 4] * 2 + ix[i - 3]) * 2 + ix[i - 2]) * 2 + ix[i - 1];
            a1 += Tables_1.t32l[p];
            a2 += Tables_1.t33l[p];
        }
        var bits = a1;
        gi.count1table_select = 0;
        if (a1 > a2) {
            bits = a2;
            gi.count1table_select = 1;
        }

        gi.count1bits = bits;
        gi.big_values = i;
        if (i == 0)
            return bits;

        if (gi.block_type == Encoder_1.SHORT_TYPE) {
            a1 = 3 * gfc.scalefac_band.s[3];
            if (a1 > gi.big_values)
                a1 = gi.big_values;
            a2 = gi.big_values;

        } else if (gi.block_type == Encoder_1.NORM_TYPE) {
            assert$18(i <= 576);
            /* bv_scf has 576 entries (0..575) */
            a1 = gi.region0_count = gfc.bv_scf[i - 2];
            a2 = gi.region1_count = gfc.bv_scf[i - 1];

            assert$18(a1 + a2 + 2 < Encoder_1.SBPSY_l);
            a2 = gfc.scalefac_band.l[a1 + a2 + 2];
            a1 = gfc.scalefac_band.l[a1 + 1];
            if (a2 < i) {
                var bi = new Bits(bits);
                gi.table_select[2] = choose_table(ix, a2, i, bi);
                bits = bi.bits;
            }
        } else {
            gi.region0_count = 7;
            /* gi.region1_count = SBPSY_l - 7 - 1; */
            gi.region1_count = Encoder_1.SBMAX_l - 1 - 7 - 1;
            a1 = gfc.scalefac_band.l[7 + 1];
            a2 = i;
            if (a1 > a2) {
                a1 = a2;
            }
        }

        /* have to allow for the case when bigvalues < region0 < region1 */
        /* (and region0, region1 are ignored) */
        a1 = Math.min(a1, i);
        a2 = Math.min(a2, i);

        assert$18(a1 >= 0);
        assert$18(a2 >= 0);

        /* Count the number of bits necessary to code the bigvalues region. */
        if (0 < a1) {
            var bi = new Bits(bits);
            gi.table_select[0] = choose_table(ix, 0, a1, bi);
            bits = bi.bits;
        }
        if (a1 < a2) {
            var bi = new Bits(bits);
            gi.table_select[1] = choose_table(ix, a1, a2, bi);
            bits = bi.bits;
        }
        if (gfc.use_best_huffman == 2) {
            gi.part2_3_length = bits;
            best_huffman_divide(gfc, gi);
            bits = gi.part2_3_length;
        }

        if (prev_noise != null) {
            if (gi.block_type == Encoder_1.NORM_TYPE) {
                var sfb = 0;
                while (gfc.scalefac_band.l[sfb] < gi.big_values) {
                    sfb++;
                }
                prev_noise.sfb_count1 = sfb;
            }
        }

        return bits;
    };

    this.count_bits = function (gfc, xr, gi, prev_noise) {
        var ix = gi.l3_enc;

        /* since quantize_xrpow uses table lookup, we need to check this first: */
        var w = (QuantizePVT_1.IXMAX_VAL) / qupvt.IPOW20(gi.global_gain);

        if (gi.xrpow_max > w)
            return QuantizePVT_1.LARGE_BITS;

        quantize_xrpow(xr, ix, qupvt.IPOW20(gi.global_gain), gi, prev_noise);

        if ((gfc.substep_shaping & 2) != 0) {
            var j = 0;
            /* 0.634521682242439 = 0.5946*2**(.5*0.1875) */
            var gain = gi.global_gain + gi.scalefac_scale;
            var roundfac = 0.634521682242439 / qupvt.IPOW20(gain);
            for (var sfb = 0; sfb < gi.sfbmax; sfb++) {
                var width = gi.width[sfb];
                assert$18(width >= 0);
                if (0 == gfc.pseudohalf[sfb]) {
                    j += width;
                } else {
                    var k;
                    for (k = j, j += width; k < j; ++k) {
                        ix[k] = (xr[k] >= roundfac) ? ix[k] : 0;
                    }
                }
            }
        }
        return this.noquant_count_bits(gfc, gi, prev_noise);
    };

    /**
     * re-calculate the best scalefac_compress using scfsi the saved bits are
     * kept in the bit reservoir.
     */
    function recalc_divide_init(gfc, cod_info, ix, r01_bits, r01_div, r0_tbl, r1_tbl) {
        var bigv = cod_info.big_values;

        for (var r0 = 0; r0 <= 7 + 15; r0++) {
            r01_bits[r0] = QuantizePVT_1.LARGE_BITS;
        }

        for (var r0 = 0; r0 < 16; r0++) {
            var a1 = gfc.scalefac_band.l[r0 + 1];
            if (a1 >= bigv)
                break;
            var r0bits = 0;
            var bi = new Bits(r0bits);
            var r0t = choose_table(ix, 0, a1, bi);
            r0bits = bi.bits;

            for (var r1 = 0; r1 < 8; r1++) {
                var a2 = gfc.scalefac_band.l[r0 + r1 + 2];
                if (a2 >= bigv)
                    break;
                var bits = r0bits;
                bi = new Bits(bits);
                var r1t = choose_table(ix, a1, a2, bi);
                bits = bi.bits;
                if (r01_bits[r0 + r1] > bits) {
                    r01_bits[r0 + r1] = bits;
                    r01_div[r0 + r1] = r0;
                    r0_tbl[r0 + r1] = r0t;
                    r1_tbl[r0 + r1] = r1t;
                }
            }
        }
    }

    function recalc_divide_sub(gfc, cod_info2, gi, ix, r01_bits, r01_div, r0_tbl, r1_tbl) {
        var bigv = cod_info2.big_values;

        for (var r2 = 2; r2 < Encoder_1.SBMAX_l + 1; r2++) {
            var a2 = gfc.scalefac_band.l[r2];
            if (a2 >= bigv)
                break;
            var bits = r01_bits[r2 - 2] + cod_info2.count1bits;
            if (gi.part2_3_length <= bits)
                break;

            var bi = new Bits(bits);
            var r2t = choose_table(ix, a2, bigv, bi);
            bits = bi.bits;
            if (gi.part2_3_length <= bits)
                continue;

            gi.assign(cod_info2);
            gi.part2_3_length = bits;
            gi.region0_count = r01_div[r2 - 2];
            gi.region1_count = r2 - 2 - r01_div[r2 - 2];
            gi.table_select[0] = r0_tbl[r2 - 2];
            gi.table_select[1] = r1_tbl[r2 - 2];
            gi.table_select[2] = r2t;
        }
    }

    this.best_huffman_divide = function (gfc, gi) {
        var cod_info2 = new GrInfo_1();
        var ix = gi.l3_enc;
        var r01_bits = new_int$18(7 + 15 + 1);
        var r01_div = new_int$18(7 + 15 + 1);
        var r0_tbl = new_int$18(7 + 15 + 1);
        var r1_tbl = new_int$18(7 + 15 + 1);

        /* SHORT BLOCK stuff fails for MPEG2 */
        if (gi.block_type == Encoder_1.SHORT_TYPE && gfc.mode_gr == 1)
            return;

        cod_info2.assign(gi);
        if (gi.block_type == Encoder_1.NORM_TYPE) {
            recalc_divide_init(gfc, gi, ix, r01_bits, r01_div, r0_tbl, r1_tbl);
            recalc_divide_sub(gfc, cod_info2, gi, ix, r01_bits, r01_div,
                r0_tbl, r1_tbl);
        }
        var i = cod_info2.big_values;
        if (i == 0 || (ix[i - 2] | ix[i - 1]) > 1)
            return;

        i = gi.count1 + 2;
        if (i > 576)
            return;

        /* Determines the number of bits to encode the quadruples. */
        cod_info2.assign(gi);
        cod_info2.count1 = i;
        var a1 = 0;
        var a2 = 0;

        assert$18(i <= 576);

        for (; i > cod_info2.big_values; i -= 4) {
            var p = ((ix[i - 4] * 2 + ix[i - 3]) * 2 + ix[i - 2]) * 2
                + ix[i - 1];
            a1 += Tables_1.t32l[p];
            a2 += Tables_1.t33l[p];
        }
        cod_info2.big_values = i;

        cod_info2.count1table_select = 0;
        if (a1 > a2) {
            a1 = a2;
            cod_info2.count1table_select = 1;
        }

        cod_info2.count1bits = a1;

        if (cod_info2.block_type == Encoder_1.NORM_TYPE)
            recalc_divide_sub(gfc, cod_info2, gi, ix, r01_bits, r01_div,
                r0_tbl, r1_tbl);
        else {
            /* Count the number of bits necessary to code the bigvalues region. */
            cod_info2.part2_3_length = a1;
            a1 = gfc.scalefac_band.l[7 + 1];
            if (a1 > i) {
                a1 = i;
            }
            if (a1 > 0) {
                var bi = new Bits(cod_info2.part2_3_length);
                cod_info2.table_select[0] = choose_table(ix, 0, a1, bi);
                cod_info2.part2_3_length = bi.bits;
            }
            if (i > a1) {
                var bi = new Bits(cod_info2.part2_3_length);
                cod_info2.table_select[1] = choose_table(ix, a1, i, bi);
                cod_info2.part2_3_length = bi.bits;
            }
            if (gi.part2_3_length > cod_info2.part2_3_length)
                gi.assign(cod_info2);
        }
    };

    var slen1_n = [1, 1, 1, 1, 8, 2, 2, 2, 4, 4, 4, 8, 8, 8, 16, 16];
    var slen2_n = [1, 2, 4, 8, 1, 2, 4, 8, 2, 4, 8, 2, 4, 8, 4, 8];
    var slen1_tab = [0, 0, 0, 0, 3, 1, 1, 1, 2, 2, 2, 3, 3, 3, 4, 4];
    var slen2_tab = [0, 1, 2, 3, 0, 1, 2, 3, 1, 2, 3, 1, 2, 3, 2, 3];
    Takehiro$1.slen1_tab = slen1_tab;
    Takehiro$1.slen2_tab = slen2_tab;

    function scfsi_calc(ch, l3_side) {
        var sfb;
        var gi = l3_side.tt[1][ch];
        var g0 = l3_side.tt[0][ch];

        for (var i = 0; i < Tables_1.scfsi_band.length - 1; i++) {
            for (sfb = Tables_1.scfsi_band[i]; sfb < Tables_1.scfsi_band[i + 1]; sfb++) {
                if (g0.scalefac[sfb] != gi.scalefac[sfb]
                    && gi.scalefac[sfb] >= 0)
                    break;
            }
            if (sfb == Tables_1.scfsi_band[i + 1]) {
                for (sfb = Tables_1.scfsi_band[i]; sfb < Tables_1.scfsi_band[i + 1]; sfb++) {
                    gi.scalefac[sfb] = -1;
                }
                l3_side.scfsi[ch][i] = 1;
            }
        }
        var s1 = 0;
        var c1 = 0;
        for (sfb = 0; sfb < 11; sfb++) {
            if (gi.scalefac[sfb] == -1)
                continue;
            c1++;
            if (s1 < gi.scalefac[sfb])
                s1 = gi.scalefac[sfb];
        }
        var s2 = 0;
        var c2 = 0;
        for (; sfb < Encoder_1.SBPSY_l; sfb++) {
            if (gi.scalefac[sfb] == -1)
                continue;
            c2++;
            if (s2 < gi.scalefac[sfb])
                s2 = gi.scalefac[sfb];
        }

        for (var i = 0; i < 16; i++) {
            if (s1 < slen1_n[i] && s2 < slen2_n[i]) {
                var c = slen1_tab[i] * c1 + slen2_tab[i] * c2;
                if (gi.part2_length > c) {
                    gi.part2_length = c;
                    gi.scalefac_compress = i;
                }
            }
        }
    }

    /**
     * Find the optimal way to store the scalefactors. Only call this routine
     * after final scalefactors have been chosen and the channel/granule will
     * not be re-encoded.
     */
    this.best_scalefac_store = function (gfc, gr, ch, l3_side) {
        /* use scalefac_scale if we can */
        var gi = l3_side.tt[gr][ch];
        var sfb, i, j, l;
        var recalc = 0;

        /*
         * remove scalefacs from bands with ix=0. This idea comes from the AAC
         * ISO docs. added mt 3/00
         */
        /* check if l3_enc=0 */
        j = 0;
        for (sfb = 0; sfb < gi.sfbmax; sfb++) {
            var width = gi.width[sfb];
            assert$18(width >= 0);
            j += width;
            for (l = -width; l < 0; l++) {
                if (gi.l3_enc[l + j] != 0)
                    break;
            }
            if (l == 0)
                gi.scalefac[sfb] = recalc = -2;
            /* anything goes. */
            /*
             * only best_scalefac_store and calc_scfsi know--and only they
             * should know--about the magic number -2.
             */
        }

        if (0 == gi.scalefac_scale && 0 == gi.preflag) {
            var s = 0;
            for (sfb = 0; sfb < gi.sfbmax; sfb++)
                if (gi.scalefac[sfb] > 0)
                    s |= gi.scalefac[sfb];

            if (0 == (s & 1) && s != 0) {
                for (sfb = 0; sfb < gi.sfbmax; sfb++)
                    if (gi.scalefac[sfb] > 0)
                        gi.scalefac[sfb] >>= 1;

                gi.scalefac_scale = recalc = 1;
            }
        }

        if (0 == gi.preflag && gi.block_type != Encoder_1.SHORT_TYPE
            && gfc.mode_gr == 2) {
            for (sfb = 11; sfb < Encoder_1.SBPSY_l; sfb++)
                if (gi.scalefac[sfb] < qupvt.pretab[sfb]
                    && gi.scalefac[sfb] != -2)
                    break;
            if (sfb == Encoder_1.SBPSY_l) {
                for (sfb = 11; sfb < Encoder_1.SBPSY_l; sfb++)
                    if (gi.scalefac[sfb] > 0)
                        gi.scalefac[sfb] -= qupvt.pretab[sfb];

                gi.preflag = recalc = 1;
            }
        }

        for (i = 0; i < 4; i++)
            l3_side.scfsi[ch][i] = 0;

        if (gfc.mode_gr == 2 && gr == 1
            && l3_side.tt[0][ch].block_type != Encoder_1.SHORT_TYPE
            && l3_side.tt[1][ch].block_type != Encoder_1.SHORT_TYPE) {
            scfsi_calc(ch, l3_side);
            recalc = 0;
        }
        for (sfb = 0; sfb < gi.sfbmax; sfb++) {
            if (gi.scalefac[sfb] == -2) {
                gi.scalefac[sfb] = 0;
                /* if anything goes, then 0 is a good choice */
            }
        }
        if (recalc != 0) {
            if (gfc.mode_gr == 2) {
                this.scale_bitcount(gi);
            } else {
                this.scale_bitcount_lsf(gfc, gi);
            }
        }
    };

    function all_scalefactors_not_negative(scalefac, n) {
        for (var i = 0; i < n; ++i) {
            if (scalefac[i] < 0)
                return false;
        }
        return true;
    }

    /**
     * number of bits used to encode scalefacs.
     *
     * 18*slen1_tab[i] + 18*slen2_tab[i]
     */
    var scale_short = [0, 18, 36, 54, 54, 36, 54, 72,
        54, 72, 90, 72, 90, 108, 108, 126];

    /**
     * number of bits used to encode scalefacs.
     *
     * 17*slen1_tab[i] + 18*slen2_tab[i]
     */
    var scale_mixed = [0, 18, 36, 54, 51, 35, 53, 71,
        52, 70, 88, 69, 87, 105, 104, 122];

    /**
     * number of bits used to encode scalefacs.
     *
     * 11*slen1_tab[i] + 10*slen2_tab[i]
     */
    var scale_long = [0, 10, 20, 30, 33, 21, 31, 41, 32, 42,
        52, 43, 53, 63, 64, 74];

    /**
     * Also calculates the number of bits necessary to code the scalefactors.
     */
    this.scale_bitcount = function (cod_info) {
        var k, sfb, max_slen1 = 0, max_slen2 = 0;

        /* maximum values */
        var tab;
        var scalefac = cod_info.scalefac;

        assert$18(all_scalefactors_not_negative(scalefac, cod_info.sfbmax));

        if (cod_info.block_type == Encoder_1.SHORT_TYPE) {
            tab = scale_short;
            if (cod_info.mixed_block_flag != 0)
                tab = scale_mixed;
        } else { /* block_type == 1,2,or 3 */
            tab = scale_long;
            if (0 == cod_info.preflag) {
                for (sfb = 11; sfb < Encoder_1.SBPSY_l; sfb++)
                    if (scalefac[sfb] < qupvt.pretab[sfb])
                        break;

                if (sfb == Encoder_1.SBPSY_l) {
                    cod_info.preflag = 1;
                    for (sfb = 11; sfb < Encoder_1.SBPSY_l; sfb++)
                        scalefac[sfb] -= qupvt.pretab[sfb];
                }
            }
        }

        for (sfb = 0; sfb < cod_info.sfbdivide; sfb++)
            if (max_slen1 < scalefac[sfb])
                max_slen1 = scalefac[sfb];

        for (; sfb < cod_info.sfbmax; sfb++)
            if (max_slen2 < scalefac[sfb])
                max_slen2 = scalefac[sfb];

        /*
         * from Takehiro TOMINAGA <tominaga@isoternet.org> 10/99 loop over *all*
         * posible values of scalefac_compress to find the one which uses the
         * smallest number of bits. ISO would stop at first valid index
         */
        cod_info.part2_length = QuantizePVT_1.LARGE_BITS;
        for (k = 0; k < 16; k++) {
            if (max_slen1 < slen1_n[k] && max_slen2 < slen2_n[k]
                && cod_info.part2_length > tab[k]) {
                cod_info.part2_length = tab[k];
                cod_info.scalefac_compress = k;
            }
        }
        return cod_info.part2_length == QuantizePVT_1.LARGE_BITS;
    };

    /**
     * table of largest scalefactor values for MPEG2
     */
    var max_range_sfac_tab = [[15, 15, 7, 7],
        [15, 15, 7, 0], [7, 3, 0, 0], [15, 31, 31, 0],
        [7, 7, 7, 0], [3, 3, 0, 0]];

    /**
     * Also counts the number of bits to encode the scalefacs but for MPEG 2
     * Lower sampling frequencies (24, 22.05 and 16 kHz.)
     *
     * This is reverse-engineered from section 2.4.3.2 of the MPEG2 IS,
     * "Audio Decoding Layer III"
     */
    this.scale_bitcount_lsf = function (gfc, cod_info) {
        var table_number, row_in_table, partition, nr_sfb, window;
        var over;
        var i, sfb;
        var max_sfac = new_int$18(4);
//var partition_table;
        var scalefac = cod_info.scalefac;

        /*
         * Set partition table. Note that should try to use table one, but do
         * not yet...
         */
        if (cod_info.preflag != 0)
            table_number = 2;
        else
            table_number = 0;

        for (i = 0; i < 4; i++)
            max_sfac[i] = 0;

        if (cod_info.block_type == Encoder_1.SHORT_TYPE) {
            row_in_table = 1;
            var partition_table = qupvt.nr_of_sfb_block[table_number][row_in_table];
            for (sfb = 0, partition = 0; partition < 4; partition++) {
                nr_sfb = partition_table[partition] / 3;
                for (i = 0; i < nr_sfb; i++, sfb++)
                    for (window = 0; window < 3; window++)
                        if (scalefac[sfb * 3 + window] > max_sfac[partition])
                            max_sfac[partition] = scalefac[sfb * 3 + window];
            }
        } else {
            row_in_table = 0;
            var partition_table = qupvt.nr_of_sfb_block[table_number][row_in_table];
            for (sfb = 0, partition = 0; partition < 4; partition++) {
                nr_sfb = partition_table[partition];
                for (i = 0; i < nr_sfb; i++, sfb++)
                    if (scalefac[sfb] > max_sfac[partition])
                        max_sfac[partition] = scalefac[sfb];
            }
        }

        for (over = false, partition = 0; partition < 4; partition++) {
            if (max_sfac[partition] > max_range_sfac_tab[table_number][partition])
                over = true;
        }
        if (!over) {
            var slen1, slen2, slen3, slen4;

            cod_info.sfb_partition_table = qupvt.nr_of_sfb_block[table_number][row_in_table];
            for (partition = 0; partition < 4; partition++)
                cod_info.slen[partition] = log2tab[max_sfac[partition]];

            /* set scalefac_compress */
            slen1 = cod_info.slen[0];
            slen2 = cod_info.slen[1];
            slen3 = cod_info.slen[2];
            slen4 = cod_info.slen[3];

            switch (table_number) {
                case 0:
                    cod_info.scalefac_compress = (((slen1 * 5) + slen2) << 4)
                        + (slen3 << 2) + slen4;
                    break;

                case 1:
                    cod_info.scalefac_compress = 400 + (((slen1 * 5) + slen2) << 2)
                        + slen3;
                    break;

                case 2:
                    cod_info.scalefac_compress = 500 + (slen1 * 3) + slen2;
                    break;

                default:
                    System$18.err.printf("intensity stereo not implemented yet\n");
                    break;
            }
        }
        if (!over) {
            assert$18(cod_info.sfb_partition_table != null);
            cod_info.part2_length = 0;
            for (partition = 0; partition < 4; partition++)
                cod_info.part2_length += cod_info.slen[partition]
                    * cod_info.sfb_partition_table[partition];
        }
        return over;
    };

    /*
     * Since no bands have been over-amplified, we can set scalefac_compress and
     * slen[] for the formatter
     */
    var log2tab = [0, 1, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4,
        4, 4, 4, 4];

    this.huffman_init = function (gfc) {
        for (var i = 2; i <= 576; i += 2) {
            var scfb_anz = 0, bv_index;
            while (gfc.scalefac_band.l[++scfb_anz] < i)
                ;

            bv_index = subdv_table[scfb_anz][0]; // .region0_count
            while (gfc.scalefac_band.l[bv_index + 1] > i)
                bv_index--;

            if (bv_index < 0) {
                /*
                 * this is an indication that everything is going to be encoded
                 * as region0: bigvalues < region0 < region1 so lets set
                 * region0, region1 to some value larger than bigvalues
                 */
                bv_index = subdv_table[scfb_anz][0]; // .region0_count
            }

            gfc.bv_scf[i - 2] = bv_index;

            bv_index = subdv_table[scfb_anz][1]; // .region1_count
            while (gfc.scalefac_band.l[bv_index + gfc.bv_scf[i - 2] + 2] > i)
                bv_index--;

            if (bv_index < 0) {
                bv_index = subdv_table[scfb_anz][1]; // .region1_count
            }

            gfc.bv_scf[i - 1] = bv_index;
        }
    };
}

var Takehiro_1 = Takehiro$1;

var System$17 = common.System;
var Arrays$17 = common.Arrays;
var new_byte$17 = common.new_byte;
var new_float_n$17 = common.new_float_n;
var new_int$17 = common.new_int;
var assert$17 = common.assert;






BitStream$1.EQ = function (a, b) {
    return (Math.abs(a) > Math.abs(b)) ? (Math.abs((a) - (b)) <= (Math
        .abs(a) * 1e-6))
        : (Math.abs((a) - (b)) <= (Math.abs(b) * 1e-6));
};

BitStream$1.NEQ = function (a, b) {
    return !BitStream$1.EQ(a, b);
};

function BitStream$1() {
    var self = this;
    var CRC16_POLYNOMIAL = 0x8005;

    /*
     * we work with ints, so when doing bit manipulation, we limit ourselves to
     * MAX_LENGTH-2 just to be on the safe side
     */
    var MAX_LENGTH = 32;

    //GainAnalysis ga;
    //MPGLib mpg;
    //Version ver;
    //VBRTag vbr;
    var ga = null;
    var mpg = null;
    var ver = null;
    var vbr = null;

    //public final void setModules(GainAnalysis ga, MPGLib mpg, Version ver,
    //	VBRTag vbr) {

    this.setModules = function (_ga, _mpg, _ver, _vbr) {
        ga = _ga;
        mpg = _mpg;
        ver = _ver;
        vbr = _vbr;
    };

    /**
     * Bit stream buffer.
     */
    //private byte[] buf;
    var buf = null;
    /**
     * Bit counter of bit stream.
     */
    var totbit = 0;
    /**
     * Pointer to top byte in buffer.
     */
    var bufByteIdx = 0;
    /**
     * Pointer to top bit of top byte in buffer.
     */
    var bufBitIdx = 0;

    /**
     * compute bitsperframe and mean_bits for a layer III frame
     */
    this.getframebits = function (gfp) {
        var gfc = gfp.internal_flags;
        var bit_rate;

        /* get bitrate in kbps [?] */
        if (gfc.bitrate_index != 0)
            bit_rate = Tables_1.bitrate_table[gfp.version][gfc.bitrate_index];
        else
            bit_rate = gfp.brate;
        assert$17(8 <= bit_rate && bit_rate <= 640);

        /* main encoding routine toggles padding on and off */
        /* one Layer3 Slot consists of 8 bits */
        var bytes = 0 | (gfp.version + 1) * 72000 * bit_rate / gfp.out_samplerate + gfc.padding;
        return 8 * bytes;
    };

    function putheader_bits(gfc) {
        System$17.arraycopy(gfc.header[gfc.w_ptr].buf, 0, buf, bufByteIdx, gfc.sideinfo_len);
        bufByteIdx += gfc.sideinfo_len;
        totbit += gfc.sideinfo_len * 8;
        gfc.w_ptr = (gfc.w_ptr + 1) & (LameInternalFlags_1.MAX_HEADER_BUF - 1);
    }

    /**
     * write j bits into the bit stream
     */
    function putbits2(gfc, val, j) {
        assert$17(j < MAX_LENGTH - 2);

        while (j > 0) {
            var k;
            if (bufBitIdx == 0) {
                bufBitIdx = 8;
                bufByteIdx++;
                assert$17(bufByteIdx < Lame.LAME_MAXMP3BUFFER);
                assert$17(gfc.header[gfc.w_ptr].write_timing >= totbit);
                if (gfc.header[gfc.w_ptr].write_timing == totbit) {
                    putheader_bits(gfc);
                }
                buf[bufByteIdx] = 0;
            }

            k = Math.min(j, bufBitIdx);
            j -= k;

            bufBitIdx -= k;

            assert$17(j < MAX_LENGTH);
            /* 32 too large on 32 bit machines */
            assert$17(bufBitIdx < MAX_LENGTH);

            buf[bufByteIdx] |= ((val >> j) << bufBitIdx);
            totbit += k;
        }
    }

    /**
     * write j bits into the bit stream, ignoring frame headers
     */
    function putbits_noheaders(gfc, val, j) {
        assert$17(j < MAX_LENGTH - 2);

        while (j > 0) {
            var k;
            if (bufBitIdx == 0) {
                bufBitIdx = 8;
                bufByteIdx++;
                assert$17(bufByteIdx < Lame.LAME_MAXMP3BUFFER);
                buf[bufByteIdx] = 0;
            }

            k = Math.min(j, bufBitIdx);
            j -= k;

            bufBitIdx -= k;

            assert$17(j < MAX_LENGTH);
            /* 32 too large on 32 bit machines */
            assert$17(bufBitIdx < MAX_LENGTH);

            buf[bufByteIdx] |= ((val >> j) << bufBitIdx);
            totbit += k;
        }
    }

    /**
     * Some combinations of bitrate, Fs, and stereo make it impossible to stuff
     * out a frame using just main_data, due to the limited number of bits to
     * indicate main_data_length. In these situations, we put stuffing bits into
     * the ancillary data...
     */
    function drain_into_ancillary(gfp, remainingBits) {
        var gfc = gfp.internal_flags;
        var i;
        assert$17(remainingBits >= 0);

        if (remainingBits >= 8) {
            putbits2(gfc, 0x4c, 8);
            remainingBits -= 8;
        }
        if (remainingBits >= 8) {
            putbits2(gfc, 0x41, 8);
            remainingBits -= 8;
        }
        if (remainingBits >= 8) {
            putbits2(gfc, 0x4d, 8);
            remainingBits -= 8;
        }
        if (remainingBits >= 8) {
            putbits2(gfc, 0x45, 8);
            remainingBits -= 8;
        }

        if (remainingBits >= 32) {
            var version = ver.getLameShortVersion();
            if (remainingBits >= 32)
                for (i = 0; i < version.length && remainingBits >= 8; ++i) {
                    remainingBits -= 8;
                    putbits2(gfc, version.charAt(i), 8);
                }
        }

        for (; remainingBits >= 1; remainingBits -= 1) {
            putbits2(gfc, gfc.ancillary_flag, 1);
            gfc.ancillary_flag ^= (!gfp.disable_reservoir ? 1 : 0);
        }

        assert$17(remainingBits == 0);

    }

    /**
     * write N bits into the header
     */
    function writeheader(gfc, val, j) {
        var ptr = gfc.header[gfc.h_ptr].ptr;

        while (j > 0) {
            var k = Math.min(j, 8 - (ptr & 7));
            j -= k;
            assert$17(j < MAX_LENGTH);
            /* >> 32 too large for 32 bit machines */

            gfc.header[gfc.h_ptr].buf[ptr >> 3] |= ((val >> j)) << (8 - (ptr & 7) - k);
            ptr += k;
        }
        gfc.header[gfc.h_ptr].ptr = ptr;
    }

    function CRC_update(value, crc) {
        value <<= 8;
        for (var i = 0; i < 8; i++) {
            value <<= 1;
            crc <<= 1;

            if ((((crc ^ value) & 0x10000) != 0))
                crc ^= CRC16_POLYNOMIAL;
        }
        return crc;
    }

    this.CRC_writeheader = function (gfc, header) {
        var crc = 0xffff;
        /* (jo) init crc16 for error_protection */

        crc = CRC_update(header[2] & 0xff, crc);
        crc = CRC_update(header[3] & 0xff, crc);
        for (var i = 6; i < gfc.sideinfo_len; i++) {
            crc = CRC_update(header[i] & 0xff, crc);
        }

        header[4] = (byte)(crc >> 8);
        header[5] = (byte)(crc & 255);
    };

    function encodeSideInfo2(gfp, bitsPerFrame) {
        var gfc = gfp.internal_flags;
        var l3_side;
        var gr, ch;

        l3_side = gfc.l3_side;
        gfc.header[gfc.h_ptr].ptr = 0;
        Arrays$17.fill(gfc.header[gfc.h_ptr].buf, 0, gfc.sideinfo_len, 0);
        if (gfp.out_samplerate < 16000)
            writeheader(gfc, 0xffe, 12);
        else
            writeheader(gfc, 0xfff, 12);
        writeheader(gfc, (gfp.version), 1);
        writeheader(gfc, 4 - 3, 2);
        writeheader(gfc, (!gfp.error_protection ? 1 : 0), 1);
        writeheader(gfc, (gfc.bitrate_index), 4);
        writeheader(gfc, (gfc.samplerate_index), 2);
        writeheader(gfc, (gfc.padding), 1);
        writeheader(gfc, (gfp.extension), 1);
        writeheader(gfc, (gfp.mode.ordinal()), 2);
        writeheader(gfc, (gfc.mode_ext), 2);
        writeheader(gfc, (gfp.copyright), 1);
        writeheader(gfc, (gfp.original), 1);
        writeheader(gfc, (gfp.emphasis), 2);
        if (gfp.error_protection) {
            writeheader(gfc, 0, 16);
            /* dummy */
        }

        if (gfp.version == 1) {
            /* MPEG1 */
            assert$17(l3_side.main_data_begin >= 0);
            writeheader(gfc, (l3_side.main_data_begin), 9);

            if (gfc.channels_out == 2)
                writeheader(gfc, l3_side.private_bits, 3);
            else
                writeheader(gfc, l3_side.private_bits, 5);

            for (ch = 0; ch < gfc.channels_out; ch++) {
                var band;
                for (band = 0; band < 4; band++) {
                    writeheader(gfc, l3_side.scfsi[ch][band], 1);
                }
            }

            for (gr = 0; gr < 2; gr++) {
                for (ch = 0; ch < gfc.channels_out; ch++) {
                    var gi = l3_side.tt[gr][ch];
                    writeheader(gfc, gi.part2_3_length + gi.part2_length, 12);
                    writeheader(gfc, gi.big_values / 2, 9);
                    writeheader(gfc, gi.global_gain, 8);
                    writeheader(gfc, gi.scalefac_compress, 4);

                    if (gi.block_type != Encoder_1.NORM_TYPE) {
                        writeheader(gfc, 1, 1);
                        /* window_switching_flag */
                        writeheader(gfc, gi.block_type, 2);
                        writeheader(gfc, gi.mixed_block_flag, 1);

                        if (gi.table_select[0] == 14)
                            gi.table_select[0] = 16;
                        writeheader(gfc, gi.table_select[0], 5);
                        if (gi.table_select[1] == 14)
                            gi.table_select[1] = 16;
                        writeheader(gfc, gi.table_select[1], 5);

                        writeheader(gfc, gi.subblock_gain[0], 3);
                        writeheader(gfc, gi.subblock_gain[1], 3);
                        writeheader(gfc, gi.subblock_gain[2], 3);
                    } else {
                        writeheader(gfc, 0, 1);
                        /* window_switching_flag */
                        if (gi.table_select[0] == 14)
                            gi.table_select[0] = 16;
                        writeheader(gfc, gi.table_select[0], 5);
                        if (gi.table_select[1] == 14)
                            gi.table_select[1] = 16;
                        writeheader(gfc, gi.table_select[1], 5);
                        if (gi.table_select[2] == 14)
                            gi.table_select[2] = 16;
                        writeheader(gfc, gi.table_select[2], 5);

                        assert$17(0 <= gi.region0_count && gi.region0_count < 16);
                        assert$17(0 <= gi.region1_count && gi.region1_count < 8);
                        writeheader(gfc, gi.region0_count, 4);
                        writeheader(gfc, gi.region1_count, 3);
                    }
                    writeheader(gfc, gi.preflag, 1);
                    writeheader(gfc, gi.scalefac_scale, 1);
                    writeheader(gfc, gi.count1table_select, 1);
                }
            }
        } else {
            /* MPEG2 */
            assert$17(l3_side.main_data_begin >= 0);
            writeheader(gfc, (l3_side.main_data_begin), 8);
            writeheader(gfc, l3_side.private_bits, gfc.channels_out);

            gr = 0;
            for (ch = 0; ch < gfc.channels_out; ch++) {
                var gi = l3_side.tt[gr][ch];
                writeheader(gfc, gi.part2_3_length + gi.part2_length, 12);
                writeheader(gfc, gi.big_values / 2, 9);
                writeheader(gfc, gi.global_gain, 8);
                writeheader(gfc, gi.scalefac_compress, 9);

                if (gi.block_type != Encoder_1.NORM_TYPE) {
                    writeheader(gfc, 1, 1);
                    /* window_switching_flag */
                    writeheader(gfc, gi.block_type, 2);
                    writeheader(gfc, gi.mixed_block_flag, 1);

                    if (gi.table_select[0] == 14)
                        gi.table_select[0] = 16;
                    writeheader(gfc, gi.table_select[0], 5);
                    if (gi.table_select[1] == 14)
                        gi.table_select[1] = 16;
                    writeheader(gfc, gi.table_select[1], 5);

                    writeheader(gfc, gi.subblock_gain[0], 3);
                    writeheader(gfc, gi.subblock_gain[1], 3);
                    writeheader(gfc, gi.subblock_gain[2], 3);
                } else {
                    writeheader(gfc, 0, 1);
                    /* window_switching_flag */
                    if (gi.table_select[0] == 14)
                        gi.table_select[0] = 16;
                    writeheader(gfc, gi.table_select[0], 5);
                    if (gi.table_select[1] == 14)
                        gi.table_select[1] = 16;
                    writeheader(gfc, gi.table_select[1], 5);
                    if (gi.table_select[2] == 14)
                        gi.table_select[2] = 16;
                    writeheader(gfc, gi.table_select[2], 5);

                    assert$17(0 <= gi.region0_count && gi.region0_count < 16);
                    assert$17(0 <= gi.region1_count && gi.region1_count < 8);
                    writeheader(gfc, gi.region0_count, 4);
                    writeheader(gfc, gi.region1_count, 3);
                }

                writeheader(gfc, gi.scalefac_scale, 1);
                writeheader(gfc, gi.count1table_select, 1);
            }
        }

        if (gfp.error_protection) {
            /* (jo) error_protection: add crc16 information to header */
            CRC_writeheader(gfc, gfc.header[gfc.h_ptr].buf);
        }

        {
            var old = gfc.h_ptr;
            assert$17(gfc.header[old].ptr == gfc.sideinfo_len * 8);

            gfc.h_ptr = (old + 1) & (LameInternalFlags_1.MAX_HEADER_BUF - 1);
            gfc.header[gfc.h_ptr].write_timing = gfc.header[old].write_timing
                + bitsPerFrame;

            if (gfc.h_ptr == gfc.w_ptr) {
                /* yikes! we are out of header buffer space */
                System$17.err
                    .println("Error: MAX_HEADER_BUF too small in bitstream.c \n");
            }

        }
    }

    function huffman_coder_count1(gfc, gi) {
        /* Write count1 area */
        var h = Tables_1.ht[gi.count1table_select + 32];
        var i, bits = 0;

        var ix = gi.big_values;
        var xr = gi.big_values;
        assert$17(gi.count1table_select < 2);

        for (i = (gi.count1 - gi.big_values) / 4; i > 0; --i) {
            var huffbits = 0;
            var p = 0, v;

            v = gi.l3_enc[ix + 0];
            if (v != 0) {
                p += 8;
                if (gi.xr[xr + 0] < 0)
                    huffbits++;
                assert$17(v <= 1);
            }

            v = gi.l3_enc[ix + 1];
            if (v != 0) {
                p += 4;
                huffbits *= 2;
                if (gi.xr[xr + 1] < 0)
                    huffbits++;
                assert$17(v <= 1);
            }

            v = gi.l3_enc[ix + 2];
            if (v != 0) {
                p += 2;
                huffbits *= 2;
                if (gi.xr[xr + 2] < 0)
                    huffbits++;
                assert$17(v <= 1);
            }

            v = gi.l3_enc[ix + 3];
            if (v != 0) {
                p++;
                huffbits *= 2;
                if (gi.xr[xr + 3] < 0)
                    huffbits++;
                assert$17(v <= 1);
            }

            ix += 4;
            xr += 4;
            putbits2(gfc, huffbits + h.table[p], h.hlen[p]);
            bits += h.hlen[p];
        }
        return bits;
    }

    /**
     * Implements the pseudocode of page 98 of the IS
     */
    function Huffmancode(gfc, tableindex, start, end, gi) {
        var h = Tables_1.ht[tableindex];
        var bits = 0;

        assert$17(tableindex < 32);
        if (0 == tableindex)
            return bits;

        for (var i = start; i < end; i += 2) {
            var cbits = 0;
            var xbits = 0;
            var linbits = h.xlen;
            var xlen = h.xlen;
            var ext = 0;
            var x1 = gi.l3_enc[i];
            var x2 = gi.l3_enc[i + 1];

            if (x1 != 0) {
                if (gi.xr[i] < 0)
                    ext++;
                cbits--;
            }

            if (tableindex > 15) {
                /* use ESC-words */
                if (x1 > 14) {
                    var linbits_x1 = x1 - 15;
                    assert$17(linbits_x1 <= h.linmax);
                    ext |= linbits_x1 << 1;
                    xbits = linbits;
                    x1 = 15;
                }

                if (x2 > 14) {
                    var linbits_x2 = x2 - 15;
                    assert$17(linbits_x2 <= h.linmax);
                    ext <<= linbits;
                    ext |= linbits_x2;
                    xbits += linbits;
                    x2 = 15;
                }
                xlen = 16;
            }

            if (x2 != 0) {
                ext <<= 1;
                if (gi.xr[i + 1] < 0)
                    ext++;
                cbits--;
            }

            assert$17((x1 | x2) < 16);

            x1 = x1 * xlen + x2;
            xbits -= cbits;
            cbits += h.hlen[x1];

            assert$17(cbits <= MAX_LENGTH);
            assert$17(xbits <= MAX_LENGTH);

            putbits2(gfc, h.table[x1], cbits);
            putbits2(gfc, ext, xbits);
            bits += cbits + xbits;
        }
        return bits;
    }

    /**
     * Note the discussion of huffmancodebits() on pages 28 and 29 of the IS, as
     * well as the definitions of the side information on pages 26 and 27.
     */
    function ShortHuffmancodebits(gfc, gi) {
        var region1Start = 3 * gfc.scalefac_band.s[3];
        if (region1Start > gi.big_values)
            region1Start = gi.big_values;

        /* short blocks do not have a region2 */
        var bits = Huffmancode(gfc, gi.table_select[0], 0, region1Start, gi);
        bits += Huffmancode(gfc, gi.table_select[1], region1Start,
            gi.big_values, gi);
        return bits;
    }

    function LongHuffmancodebits(gfc, gi) {
        var bigvalues, bits;
        var region1Start, region2Start;

        bigvalues = gi.big_values;
        assert$17(0 <= bigvalues && bigvalues <= 576);

        var i = gi.region0_count + 1;
        assert$17(0 <= i);
        assert$17(i < gfc.scalefac_band.l.length);
        region1Start = gfc.scalefac_band.l[i];
        i += gi.region1_count + 1;
        assert$17(0 <= i);
        assert$17(i < gfc.scalefac_band.l.length);
        region2Start = gfc.scalefac_band.l[i];

        if (region1Start > bigvalues)
            region1Start = bigvalues;

        if (region2Start > bigvalues)
            region2Start = bigvalues;

        bits = Huffmancode(gfc, gi.table_select[0], 0, region1Start, gi);
        bits += Huffmancode(gfc, gi.table_select[1], region1Start,
            region2Start, gi);
        bits += Huffmancode(gfc, gi.table_select[2], region2Start, bigvalues,
            gi);
        return bits;
    }

    function writeMainData(gfp) {
        var gr, ch, sfb, data_bits, tot_bits = 0;
        var gfc = gfp.internal_flags;
        var l3_side = gfc.l3_side;

        if (gfp.version == 1) {
            /* MPEG 1 */
            for (gr = 0; gr < 2; gr++) {
                for (ch = 0; ch < gfc.channels_out; ch++) {
                    var gi = l3_side.tt[gr][ch];
                    var slen1 = Takehiro_1.slen1_tab[gi.scalefac_compress];
                    var slen2 = Takehiro_1.slen2_tab[gi.scalefac_compress];
                    data_bits = 0;
                    for (sfb = 0; sfb < gi.sfbdivide; sfb++) {
                        if (gi.scalefac[sfb] == -1)
                            continue;
                        /* scfsi is used */
                        putbits2(gfc, gi.scalefac[sfb], slen1);
                        data_bits += slen1;
                    }
                    for (; sfb < gi.sfbmax; sfb++) {
                        if (gi.scalefac[sfb] == -1)
                            continue;
                        /* scfsi is used */
                        putbits2(gfc, gi.scalefac[sfb], slen2);
                        data_bits += slen2;
                    }
                    assert$17(data_bits == gi.part2_length);

                    if (gi.block_type == Encoder_1.SHORT_TYPE) {
                        data_bits += ShortHuffmancodebits(gfc, gi);
                    } else {
                        data_bits += LongHuffmancodebits(gfc, gi);
                    }
                    data_bits += huffman_coder_count1(gfc, gi);
                    /* does bitcount in quantize.c agree with actual bit count? */
                    assert$17(data_bits == gi.part2_3_length + gi.part2_length);
                    tot_bits += data_bits;
                }
                /* for ch */
            }
            /* for gr */
        } else {
            /* MPEG 2 */
            gr = 0;
            for (ch = 0; ch < gfc.channels_out; ch++) {
                var gi = l3_side.tt[gr][ch];
                var i, sfb_partition, scale_bits = 0;
                assert$17(gi.sfb_partition_table != null);
                data_bits = 0;
                sfb = 0;
                sfb_partition = 0;

                if (gi.block_type == Encoder_1.SHORT_TYPE) {
                    for (; sfb_partition < 4; sfb_partition++) {
                        var sfbs = gi.sfb_partition_table[sfb_partition] / 3;
                        var slen = gi.slen[sfb_partition];
                        for (i = 0; i < sfbs; i++, sfb++) {
                            putbits2(gfc,
                                Math.max(gi.scalefac[sfb * 3 + 0], 0), slen);
                            putbits2(gfc,
                                Math.max(gi.scalefac[sfb * 3 + 1], 0), slen);
                            putbits2(gfc,
                                Math.max(gi.scalefac[sfb * 3 + 2], 0), slen);
                            scale_bits += 3 * slen;
                        }
                    }
                    data_bits += ShortHuffmancodebits(gfc, gi);
                } else {
                    for (; sfb_partition < 4; sfb_partition++) {
                        var sfbs = gi.sfb_partition_table[sfb_partition];
                        var slen = gi.slen[sfb_partition];
                        for (i = 0; i < sfbs; i++, sfb++) {
                            putbits2(gfc, Math.max(gi.scalefac[sfb], 0), slen);
                            scale_bits += slen;
                        }
                    }
                    data_bits += LongHuffmancodebits(gfc, gi);
                }
                data_bits += huffman_coder_count1(gfc, gi);
                /* does bitcount in quantize.c agree with actual bit count? */
                assert$17(data_bits == gi.part2_3_length);
                assert$17(scale_bits == gi.part2_length);
                tot_bits += scale_bits + data_bits;
            }
            /* for ch */
        }
        /* for gf */
        return tot_bits;
    }

    /* main_data */

    function TotalBytes() {
        this.total = 0;
    }

    /*
     * compute the number of bits required to flush all mp3 frames currently in
     * the buffer. This should be the same as the reservoir size. Only call this
     * routine between frames - i.e. only after all headers and data have been
     * added to the buffer by format_bitstream().
     *
     * Also compute total_bits_output = size of mp3 buffer (including frame
     * headers which may not have yet been send to the mp3 buffer) + number of
     * bits needed to flush all mp3 frames.
     *
     * total_bytes_output is the size of the mp3 output buffer if
     * lame_encode_flush_nogap() was called right now.
     */
    function compute_flushbits(gfp, total_bytes_output) {
        var gfc = gfp.internal_flags;
        var flushbits, remaining_headers;
        var bitsPerFrame;
        var last_ptr, first_ptr;
        first_ptr = gfc.w_ptr;
        /* first header to add to bitstream */
        last_ptr = gfc.h_ptr - 1;
        /* last header to add to bitstream */
        if (last_ptr == -1)
            last_ptr = LameInternalFlags_1.MAX_HEADER_BUF - 1;

        /* add this many bits to bitstream so we can flush all headers */
        flushbits = gfc.header[last_ptr].write_timing - totbit;
        total_bytes_output.total = flushbits;

        if (flushbits >= 0) {
            /* if flushbits >= 0, some headers have not yet been written */
            /* reduce flushbits by the size of the headers */
            remaining_headers = 1 + last_ptr - first_ptr;
            if (last_ptr < first_ptr)
                remaining_headers = 1 + last_ptr - first_ptr
                    + LameInternalFlags_1.MAX_HEADER_BUF;
            flushbits -= remaining_headers * 8 * gfc.sideinfo_len;
        }

        /*
         * finally, add some bits so that the last frame is complete these bits
         * are not necessary to decode the last frame, but some decoders will
         * ignore last frame if these bits are missing
         */
        bitsPerFrame = self.getframebits(gfp);
        flushbits += bitsPerFrame;
        total_bytes_output.total += bitsPerFrame;
        /* round up: */
        if ((total_bytes_output.total % 8) != 0)
            total_bytes_output.total = 1 + (total_bytes_output.total / 8);
        else
            total_bytes_output.total = (total_bytes_output.total / 8);
        total_bytes_output.total += bufByteIdx + 1;

        if (flushbits < 0) {
            System$17.err.println("strange error flushing buffer ... \n");
        }
        return flushbits;
    }

    this.flush_bitstream = function (gfp) {
        var gfc = gfp.internal_flags;
        var l3_side;
        var flushbits;
        var last_ptr = gfc.h_ptr - 1;
        /* last header to add to bitstream */
        if (last_ptr == -1)
            last_ptr = LameInternalFlags_1.MAX_HEADER_BUF - 1;
        l3_side = gfc.l3_side;

        if ((flushbits = compute_flushbits(gfp, new TotalBytes())) < 0)
            return;
        drain_into_ancillary(gfp, flushbits);

        /* check that the 100% of the last frame has been written to bitstream */
        assert$17(gfc.header[last_ptr].write_timing + this.getframebits(gfp) == totbit);

        /*
         * we have padded out all frames with ancillary data, which is the same
         * as filling the bitreservoir with ancillary data, so :
         */
        gfc.ResvSize = 0;
        l3_side.main_data_begin = 0;

        /* save the ReplayGain value */
        if (gfc.findReplayGain) {
            var RadioGain = ga.GetTitleGain(gfc.rgdata);
            assert$17(NEQ(RadioGain, GainAnalysis.GAIN_NOT_ENOUGH_SAMPLES));
            gfc.RadioGain = Math.floor(RadioGain * 10.0 + 0.5) | 0;
            /* round to nearest */
        }

        /* find the gain and scale change required for no clipping */
        if (gfc.findPeakSample) {
            gfc.noclipGainChange = Math.ceil(Math
                        .log10(gfc.PeakSample / 32767.0) * 20.0 * 10.0) | 0;
            /* round up */

            if (gfc.noclipGainChange > 0) {
                /* clipping occurs */
                if (EQ(gfp.scale, 1.0) || EQ(gfp.scale, 0.0))
                    gfc.noclipScale = (Math
                        .floor((32767.0 / gfc.PeakSample) * 100.0) / 100.0);
                /* round down */
                else {
                    /*
                     * the user specified his own scaling factor. We could
                     * suggest the scaling factor of
                     * (32767.0/gfp.PeakSample)*(gfp.scale) but it's usually
                     * very inaccurate. So we'd rather not advice him on the
                     * scaling factor.
                     */
                    gfc.noclipScale = -1;
                }
            } else
            /* no clipping */
                gfc.noclipScale = -1;
        }
    };

    this.add_dummy_byte = function (gfp, val, n) {
        var gfc = gfp.internal_flags;
        var i;

        while (n-- > 0) {
            putbits_noheaders(gfc, val, 8);

            for (i = 0; i < LameInternalFlags_1.MAX_HEADER_BUF; ++i)
                gfc.header[i].write_timing += 8;
        }
    };

    /**
     * This is called after a frame of audio has been quantized and coded. It
     * will write the encoded audio to the bitstream. Note that from a layer3
     * encoder's perspective the bit stream is primarily a series of main_data()
     * blocks, with header and side information inserted at the proper locations
     * to maintain framing. (See Figure A.7 in the IS).
     */
    this.format_bitstream = function (gfp) {
        var gfc = gfp.internal_flags;
        var l3_side;
        l3_side = gfc.l3_side;

        var bitsPerFrame = this.getframebits(gfp);
        drain_into_ancillary(gfp, l3_side.resvDrain_pre);

        encodeSideInfo2(gfp, bitsPerFrame);
        var bits = 8 * gfc.sideinfo_len;
        bits += writeMainData(gfp);
        drain_into_ancillary(gfp, l3_side.resvDrain_post);
        bits += l3_side.resvDrain_post;

        l3_side.main_data_begin += (bitsPerFrame - bits) / 8;

        /*
         * compare number of bits needed to clear all buffered mp3 frames with
         * what we think the resvsize is:
         */
        if (compute_flushbits(gfp, new TotalBytes()) != gfc.ResvSize) {
            System$17.err.println("Internal buffer inconsistency. flushbits <> ResvSize");
        }

        /*
         * compare main_data_begin for the next frame with what we think the
         * resvsize is:
         */
        if ((l3_side.main_data_begin * 8) != gfc.ResvSize) {
            System$17.err.printf("bit reservoir error: \n"
                + "l3_side.main_data_begin: %d \n"
                + "Resvoir size:             %d \n"
                + "resv drain (post)         %d \n"
                + "resv drain (pre)          %d \n"
                + "header and sideinfo:      %d \n"
                + "data bits:                %d \n"
                + "total bits:               %d (remainder: %d) \n"
                + "bitsperframe:             %d \n",
                8 * l3_side.main_data_begin, gfc.ResvSize,
                l3_side.resvDrain_post, l3_side.resvDrain_pre,
                8 * gfc.sideinfo_len, bits - l3_side.resvDrain_post - 8
                * gfc.sideinfo_len, bits, bits % 8, bitsPerFrame);

            System$17.err.println("This is a fatal error.  It has several possible causes:");
            System$17.err.println("90%%  LAME compiled with buggy version of gcc using advanced optimizations");
            System$17.err.println(" 9%%  Your system is overclocked");
            System$17.err.println(" 1%%  bug in LAME encoding library");

            gfc.ResvSize = l3_side.main_data_begin * 8;
        }
        //;
        assert$17(totbit % 8 == 0);

        if (totbit > 1000000000) {
            /*
             * to avoid totbit overflow, (at 8h encoding at 128kbs) lets reset
             * bit counter
             */
            var i;
            for (i = 0; i < LameInternalFlags_1.MAX_HEADER_BUF; ++i)
                gfc.header[i].write_timing -= totbit;
            totbit = 0;
        }

        return 0;
    };

    /**
     * <PRE>
     * copy data out of the internal MP3 bit buffer into a user supplied
     *       unsigned char buffer.
     *
     *       mp3data=0      indicates data in buffer is an id3tags and VBR tags
     *       mp3data=1      data is real mp3 frame data.
     * </PRE>
     */
    this.copy_buffer = function (gfc, buffer, bufferPos, size, mp3data) {
        var minimum = bufByteIdx + 1;
        if (minimum <= 0)
            return 0;
        if (size != 0 && minimum > size) {
            /* buffer is too small */
            return -1;
        }
        System$17.arraycopy(buf, 0, buffer, bufferPos, minimum);
        bufByteIdx = -1;
        bufBitIdx = 0;

        if (mp3data != 0) {
            var crc = new_int$17(1);
            crc[0] = gfc.nMusicCRC;
            vbr.updateMusicCRC(crc, buffer, bufferPos, minimum);
            gfc.nMusicCRC = crc[0];

            /**
             * sum number of bytes belonging to the mp3 stream this info will be
             * written into the Xing/LAME header for seeking
             */
            if (minimum > 0) {
                gfc.VBR_seek_table.nBytesWritten += minimum;
            }

            if (gfc.decode_on_the_fly) { /* decode the frame */
                var pcm_buf = new_float_n$17([2, 1152]);
                var mp3_in = minimum;
                var samples_out = -1;
                var i;

                /* re-synthesis to pcm. Repeat until we get a samples_out=0 */
                while (samples_out != 0) {

                    samples_out = mpg.hip_decode1_unclipped(gfc.hip, buffer,
                        bufferPos, mp3_in, pcm_buf[0], pcm_buf[1]);
                    /*
                     * samples_out = 0: need more data to decode samples_out =
                     * -1: error. Lets assume 0 pcm output samples_out = number
                     * of samples output
                     */

                    /*
                     * set the lenght of the mp3 input buffer to zero, so that
                     * in the next iteration of the loop we will be querying
                     * mpglib about buffered data
                     */
                    mp3_in = 0;

                    if (samples_out == -1) {
                        /*
                         * error decoding. Not fatal, but might screw up the
                         * ReplayGain tag. What should we do? Ignore for now
                         */
                        samples_out = 0;
                    }
                    if (samples_out > 0) {
                        /* process the PCM data */

                        /*
                         * this should not be possible, and indicates we have
                         * overflown the pcm_buf buffer
                         */
                        assert$17(samples_out <= 1152);

                        if (gfc.findPeakSample) {
                            for (i = 0; i < samples_out; i++) {
                                if (pcm_buf[0][i] > gfc.PeakSample)
                                    gfc.PeakSample = pcm_buf[0][i];
                                else if (-pcm_buf[0][i] > gfc.PeakSample)
                                    gfc.PeakSample = -pcm_buf[0][i];
                            }
                            if (gfc.channels_out > 1)
                                for (i = 0; i < samples_out; i++) {
                                    if (pcm_buf[1][i] > gfc.PeakSample)
                                        gfc.PeakSample = pcm_buf[1][i];
                                    else if (-pcm_buf[1][i] > gfc.PeakSample)
                                        gfc.PeakSample = -pcm_buf[1][i];
                                }
                        }

                        if (gfc.findReplayGain)
                            if (ga.AnalyzeSamples(gfc.rgdata, pcm_buf[0], 0,
                                    pcm_buf[1], 0, samples_out,
                                    gfc.channels_out) == GainAnalysis.GAIN_ANALYSIS_ERROR)
                                return -6;

                    }
                    /* if (samples_out>0) */
                }
                /* while (samples_out!=0) */
            }
            /* if (gfc.decode_on_the_fly) */

        }
        /* if (mp3data) */
        return minimum;
    };

    this.init_bit_stream_w = function (gfc) {
        buf = new_byte$17(Lame.LAME_MAXMP3BUFFER);

        gfc.h_ptr = gfc.w_ptr = 0;
        gfc.header[gfc.h_ptr].write_timing = 0;
        bufByteIdx = -1;
        bufBitIdx = 0;
        totbit = 0;
    };

    // From machine.h


}

var BitStream_1 = BitStream$1;

var System$2 = common.System;
var VbrMode$2 = common.VbrMode;
var ShortBlock$2 = common.ShortBlock;
var new_float$2 = common.new_float;
var new_int_n$2 = common.new_int_n;
var new_short_n$1 = common.new_short_n;
var assert$2 = common.assert;











function Lame$1() {
    var self = this;
    var LAME_MAXALBUMART = (128 * 1024);

    Lame$1.V9 = 410;
    Lame$1.V8 = 420;
    Lame$1.V7 = 430;
    Lame$1.V6 = 440;
    Lame$1.V5 = 450;
    Lame$1.V4 = 460;
    Lame$1.V3 = 470;
    Lame$1.V2 = 480;
    Lame$1.V1 = 490;
    Lame$1.V0 = 500;

    /* still there for compatibility */

    Lame$1.R3MIX = 1000;
    Lame$1.STANDARD = 1001;
    Lame$1.EXTREME = 1002;
    Lame$1.INSANE = 1003;
    Lame$1.STANDARD_FAST = 1004;
    Lame$1.EXTREME_FAST = 1005;
    Lame$1.MEDIUM = 1006;
    Lame$1.MEDIUM_FAST = 1007;

    /**
     * maximum size of mp3buffer needed if you encode at most 1152 samples for
     * each call to lame_encode_buffer. see lame_encode_buffer() below
     * (LAME_MAXMP3BUFFER is now obsolete)
     */
    var LAME_MAXMP3BUFFER = (16384 + LAME_MAXALBUMART);
    Lame$1.LAME_MAXMP3BUFFER = LAME_MAXMP3BUFFER;

    var ga;
    var bs;
    var p;
    var qupvt;
    var qu;
    var psy = new PsyModel_1();
    var vbr;
    var ver;
    var id3;
    var mpglib;
    this.enc = new Encoder_1();

    this.setModules = function (_ga, _bs, _p, _qupvt, _qu, _vbr, _ver, _id3, _mpglib) {
        ga = _ga;
        bs = _bs;
        p = _p;
        qupvt = _qupvt;
        qu = _qu;
        vbr = _vbr;
        ver = _ver;
        id3 = _id3;
        mpglib = _mpglib;
        this.enc.setModules(bs, psy, qupvt, vbr);
    };

    /**
     * PSY Model related stuff
     */
    function PSY() {
        /**
         * The dbQ stuff.
         */
        this.mask_adjust = 0.;
        /**
         * The dbQ stuff.
         */
        this.mask_adjust_short = 0.;
        /* at transition from one scalefactor band to next */
        /**
         * Band weight long scalefactor bands.
         */
        this.bo_l_weight = new_float$2(Encoder_1.SBMAX_l);
        /**
         * Band weight short scalefactor bands.
         */
        this.bo_s_weight = new_float$2(Encoder_1.SBMAX_s);
    }

    function LowPassHighPass() {
        this.lowerlimit = 0.;
    }

    function BandPass(bitrate, lPass) {
        this.lowpass = lPass;
    }

    var LAME_ID = 0xFFF88E3B;

    function lame_init_old(gfp) {
        var gfc;

        gfp.class_id = LAME_ID;

        gfc = gfp.internal_flags = new LameInternalFlags_1();

        /* Global flags. set defaults here for non-zero values */
        /* see lame.h for description */
        /*
         * set integer values to -1 to mean that LAME will compute the best
         * value, UNLESS the calling program as set it (and the value is no
         * longer -1)
         */

        gfp.mode = MPEGMode.NOT_SET;
        gfp.original = 1;
        gfp.in_samplerate = 44100;
        gfp.num_channels = 2;
        gfp.num_samples = -1;

        gfp.bWriteVbrTag = true;
        gfp.quality = -1;
        gfp.short_blocks = null;
        gfc.subblock_gain = -1;

        gfp.lowpassfreq = 0;
        gfp.highpassfreq = 0;
        gfp.lowpasswidth = -1;
        gfp.highpasswidth = -1;

        gfp.VBR = VbrMode$2.vbr_off;
        gfp.VBR_q = 4;
        gfp.ATHcurve = -1;
        gfp.VBR_mean_bitrate_kbps = 128;
        gfp.VBR_min_bitrate_kbps = 0;
        gfp.VBR_max_bitrate_kbps = 0;
        gfp.VBR_hard_min = 0;
        gfc.VBR_min_bitrate = 1;
        /* not 0 ????? */
        gfc.VBR_max_bitrate = 13;
        /* not 14 ????? */

        gfp.quant_comp = -1;
        gfp.quant_comp_short = -1;

        gfp.msfix = -1;

        gfc.resample_ratio = 1;

        gfc.OldValue[0] = 180;
        gfc.OldValue[1] = 180;
        gfc.CurrentStep[0] = 4;
        gfc.CurrentStep[1] = 4;
        gfc.masking_lower = 1;
        gfc.nsPsy.attackthre = -1;
        gfc.nsPsy.attackthre_s = -1;

        gfp.scale = -1;

        gfp.athaa_type = -1;
        gfp.ATHtype = -1;
        /* default = -1 = set in lame_init_params */
        gfp.athaa_loudapprox = -1;
        /* 1 = flat loudness approx. (total energy) */
        /* 2 = equal loudness curve */
        gfp.athaa_sensitivity = 0.0;
        /* no offset */
        gfp.useTemporal = null;
        gfp.interChRatio = -1;

        /*
         * The reason for int mf_samples_to_encode = ENCDELAY + POSTDELAY;
         * ENCDELAY = internal encoder delay. And then we have to add
         * POSTDELAY=288 because of the 50% MDCT overlap. A 576 MDCT granule
         * decodes to 1152 samples. To synthesize the 576 samples centered under
         * this granule we need the previous granule for the first 288 samples
         * (no problem), and the next granule for the next 288 samples (not
         * possible if this is last granule). So we need to pad with 288 samples
         * to make sure we can encode the 576 samples we are interested in.
         */
        gfc.mf_samples_to_encode = Encoder_1.ENCDELAY + Encoder_1.POSTDELAY;
        gfp.encoder_padding = 0;
        gfc.mf_size = Encoder_1.ENCDELAY - Encoder_1.MDCTDELAY;
        /*
         * we pad input with this many 0's
         */

        gfp.findReplayGain = false;
        gfp.decode_on_the_fly = false;

        gfc.decode_on_the_fly = false;
        gfc.findReplayGain = false;
        gfc.findPeakSample = false;

        gfc.RadioGain = 0;
        gfc.AudiophileGain = 0;
        gfc.noclipGainChange = 0;
        gfc.noclipScale = -1.0;

        gfp.preset = 0;

        gfp.write_id3tag_automatic = true;
        return 0;
    }

    this.lame_init = function () {
        var gfp = new LameGlobalFlags_1();

        var ret = lame_init_old(gfp);
        if (ret != 0) {
            return null;
        }

        gfp.lame_allocated_gfp = 1;
        return gfp;
    };

    function filter_coef(x) {
        if (x > 1.0)
            return 0.0;
        if (x <= 0.0)
            return 1.0;

        return Math.cos(Math.PI / 2 * x);
    }

    this.nearestBitrateFullIndex = function (bitrate) {
        /* borrowed from DM abr presets */

        var full_bitrate_table = [8, 16, 24, 32, 40, 48, 56, 64, 80,
            96, 112, 128, 160, 192, 224, 256, 320];

        var lower_range = 0, lower_range_kbps = 0, upper_range = 0, upper_range_kbps = 0;

        /* We assume specified bitrate will be 320kbps */
        upper_range_kbps = full_bitrate_table[16];
        upper_range = 16;
        lower_range_kbps = full_bitrate_table[16];
        lower_range = 16;

        /*
         * Determine which significant bitrates the value specified falls
         * between, if loop ends without breaking then we were correct above
         * that the value was 320
         */
        for (var b = 0; b < 16; b++) {
            if ((Math.max(bitrate, full_bitrate_table[b + 1])) != bitrate) {
                upper_range_kbps = full_bitrate_table[b + 1];
                upper_range = b + 1;
                lower_range_kbps = full_bitrate_table[b];
                lower_range = (b);
                break;
                /* We found upper range */
            }
        }

        /* Determine which range the value specified is closer to */
        if ((upper_range_kbps - bitrate) > (bitrate - lower_range_kbps)) {
            return lower_range;
        }
        return upper_range;
    };

    function optimum_samplefreq(lowpassfreq, input_samplefreq) {
        /*
         * Rules:
         *
         * - if possible, sfb21 should NOT be used
         */
        var suggested_samplefreq = 44100;

        if (input_samplefreq >= 48000)
            suggested_samplefreq = 48000;
        else if (input_samplefreq >= 44100)
            suggested_samplefreq = 44100;
        else if (input_samplefreq >= 32000)
            suggested_samplefreq = 32000;
        else if (input_samplefreq >= 24000)
            suggested_samplefreq = 24000;
        else if (input_samplefreq >= 22050)
            suggested_samplefreq = 22050;
        else if (input_samplefreq >= 16000)
            suggested_samplefreq = 16000;
        else if (input_samplefreq >= 12000)
            suggested_samplefreq = 12000;
        else if (input_samplefreq >= 11025)
            suggested_samplefreq = 11025;
        else if (input_samplefreq >= 8000)
            suggested_samplefreq = 8000;

        if (lowpassfreq == -1)
            return suggested_samplefreq;

        if (lowpassfreq <= 15960)
            suggested_samplefreq = 44100;
        if (lowpassfreq <= 15250)
            suggested_samplefreq = 32000;
        if (lowpassfreq <= 11220)
            suggested_samplefreq = 24000;
        if (lowpassfreq <= 9970)
            suggested_samplefreq = 22050;
        if (lowpassfreq <= 7230)
            suggested_samplefreq = 16000;
        if (lowpassfreq <= 5420)
            suggested_samplefreq = 12000;
        if (lowpassfreq <= 4510)
            suggested_samplefreq = 11025;
        if (lowpassfreq <= 3970)
            suggested_samplefreq = 8000;

        if (input_samplefreq < suggested_samplefreq) {
            /*
             * choose a valid MPEG sample frequency above the input sample
             * frequency to avoid SFB21/12 bitrate bloat rh 061115
             */
            if (input_samplefreq > 44100) {
                return 48000;
            }
            if (input_samplefreq > 32000) {
                return 44100;
            }
            if (input_samplefreq > 24000) {
                return 32000;
            }
            if (input_samplefreq > 22050) {
                return 24000;
            }
            if (input_samplefreq > 16000) {
                return 22050;
            }
            if (input_samplefreq > 12000) {
                return 16000;
            }
            if (input_samplefreq > 11025) {
                return 12000;
            }
            if (input_samplefreq > 8000) {
                return 11025;
            }
            return 8000;
        }
        return suggested_samplefreq;
    }

    /**
     * convert samp freq in Hz to index
     */
    function SmpFrqIndex(sample_freq, gpf) {
        switch (sample_freq) {
            case 44100:
                gpf.version = 1;
                return 0;
            case 48000:
                gpf.version = 1;
                return 1;
            case 32000:
                gpf.version = 1;
                return 2;
            case 22050:
                gpf.version = 0;
                return 0;
            case 24000:
                gpf.version = 0;
                return 1;
            case 16000:
                gpf.version = 0;
                return 2;
            case 11025:
                gpf.version = 0;
                return 0;
            case 12000:
                gpf.version = 0;
                return 1;
            case 8000:
                gpf.version = 0;
                return 2;
            default:
                gpf.version = 0;
                return -1;
        }
    }

    /**
     * @param bRate
     *            legal rates from 8 to 320
     */
    function FindNearestBitrate(bRate, version, samplerate) {
        /* MPEG-1 or MPEG-2 LSF */
        if (samplerate < 16000)
            version = 2;

        var bitrate = Tables_1.bitrate_table[version][1];

        for (var i = 2; i <= 14; i++) {
            if (Tables_1.bitrate_table[version][i] > 0) {
                if (Math.abs(Tables_1.bitrate_table[version][i] - bRate) < Math
                        .abs(bitrate - bRate))
                    bitrate = Tables_1.bitrate_table[version][i];
            }
        }
        return bitrate;
    }

    /**
     * @param bRate
     *            legal rates from 32 to 448 kbps
     * @param version
     *            MPEG-1 or MPEG-2/2.5 LSF
     */
    function BitrateIndex(bRate, version, samplerate) {
        /* convert bitrate in kbps to index */
        if (samplerate < 16000)
            version = 2;
        for (var i = 0; i <= 14; i++) {
            if (Tables_1.bitrate_table[version][i] > 0) {
                if (Tables_1.bitrate_table[version][i] == bRate) {
                    return i;
                }
            }
        }
        return -1;
    }

    function optimum_bandwidth(lh, bitrate) {
        /**
         * <PRE>
         *  Input:
         *      bitrate     total bitrate in kbps
         *
         *   Output:
         *      lowerlimit: best lowpass frequency limit for input filter in Hz
         *      upperlimit: best highpass frequency limit for input filter in Hz
         * </PRE>
         */
        var freq_map = [new BandPass(8, 2000),
            new BandPass(16, 3700), new BandPass(24, 3900),
            new BandPass(32, 5500), new BandPass(40, 7000),
            new BandPass(48, 7500), new BandPass(56, 10000),
            new BandPass(64, 11000), new BandPass(80, 13500),
            new BandPass(96, 15100), new BandPass(112, 15600),
            new BandPass(128, 17000), new BandPass(160, 17500),
            new BandPass(192, 18600), new BandPass(224, 19400),
            new BandPass(256, 19700), new BandPass(320, 20500)];

        var table_index = self.nearestBitrateFullIndex(bitrate);
        lh.lowerlimit = freq_map[table_index].lowpass;
    }

    function lame_init_params_ppflt(gfp) {
        var gfc = gfp.internal_flags;
        /***************************************************************/
        /* compute info needed for polyphase filter (filter type==0, default) */
        /***************************************************************/

        var lowpass_band = 32;
        var highpass_band = -1;

        if (gfc.lowpass1 > 0) {
            var minband = 999;
            for (var band = 0; band <= 31; band++) {
                var freq = (band / 31.0);
                /* this band and above will be zeroed: */
                if (freq >= gfc.lowpass2) {
                    lowpass_band = Math.min(lowpass_band, band);
                }
                if (gfc.lowpass1 < freq && freq < gfc.lowpass2) {
                    minband = Math.min(minband, band);
                }
            }

            /*
             * compute the *actual* transition band implemented by the polyphase
             * filter
             */
            if (minband == 999) {
                gfc.lowpass1 = (lowpass_band - .75) / 31.0;
            } else {
                gfc.lowpass1 = (minband - .75) / 31.0;
            }
            gfc.lowpass2 = lowpass_band / 31.0;
        }

        /*
         * make sure highpass filter is within 90% of what the effective
         * highpass frequency will be
         */
        if (gfc.highpass2 > 0) {
            if (gfc.highpass2 < .9 * (.75 / 31.0)) {
                gfc.highpass1 = 0;
                gfc.highpass2 = 0;
                System$2.err.println("Warning: highpass filter disabled.  "
                    + "highpass frequency too small\n");
            }
        }

        if (gfc.highpass2 > 0) {
            var maxband = -1;
            for (var band = 0; band <= 31; band++) {
                var freq = band / 31.0;
                /* this band and below will be zereod */
                if (freq <= gfc.highpass1) {
                    highpass_band = Math.max(highpass_band, band);
                }
                if (gfc.highpass1 < freq && freq < gfc.highpass2) {
                    maxband = Math.max(maxband, band);
                }
            }
            /*
             * compute the *actual* transition band implemented by the polyphase
             * filter
             */
            gfc.highpass1 = highpass_band / 31.0;
            if (maxband == -1) {
                gfc.highpass2 = (highpass_band + .75) / 31.0;
            } else {
                gfc.highpass2 = (maxband + .75) / 31.0;
            }
        }

        for (var band = 0; band < 32; band++) {
            var fc1, fc2;
            var freq = band / 31.0;
            if (gfc.highpass2 > gfc.highpass1) {
                fc1 = filter_coef((gfc.highpass2 - freq)
                    / (gfc.highpass2 - gfc.highpass1 + 1e-20));
            } else {
                fc1 = 1.0;
            }
            if (gfc.lowpass2 > gfc.lowpass1) {
                fc2 = filter_coef((freq - gfc.lowpass1)
                    / (gfc.lowpass2 - gfc.lowpass1 + 1e-20));
            } else {
                fc2 = 1.0;
            }
            gfc.amp_filter[band] = (fc1 * fc2);
        }
    }

    function lame_init_qval(gfp) {
        var gfc = gfp.internal_flags;

        switch (gfp.quality) {
            default:
            case 9: /* no psymodel, no noise shaping */
                gfc.psymodel = 0;
                gfc.noise_shaping = 0;
                gfc.noise_shaping_amp = 0;
                gfc.noise_shaping_stop = 0;
                gfc.use_best_huffman = 0;
                gfc.full_outer_loop = 0;
                break;

            case 8:
                gfp.quality = 7;
            //$FALL-THROUGH$
            case 7:
                /*
                 * use psymodel (for short block and m/s switching), but no noise
                 * shapping
                 */
                gfc.psymodel = 1;
                gfc.noise_shaping = 0;
                gfc.noise_shaping_amp = 0;
                gfc.noise_shaping_stop = 0;
                gfc.use_best_huffman = 0;
                gfc.full_outer_loop = 0;
                break;

            case 6:
                gfc.psymodel = 1;
                if (gfc.noise_shaping == 0)
                    gfc.noise_shaping = 1;
                gfc.noise_shaping_amp = 0;
                gfc.noise_shaping_stop = 0;
                if (gfc.subblock_gain == -1)
                    gfc.subblock_gain = 1;
                gfc.use_best_huffman = 0;
                gfc.full_outer_loop = 0;
                break;

            case 5:
                gfc.psymodel = 1;
                if (gfc.noise_shaping == 0)
                    gfc.noise_shaping = 1;
                gfc.noise_shaping_amp = 0;
                gfc.noise_shaping_stop = 0;
                if (gfc.subblock_gain == -1)
                    gfc.subblock_gain = 1;
                gfc.use_best_huffman = 0;
                gfc.full_outer_loop = 0;
                break;

            case 4:
                gfc.psymodel = 1;
                if (gfc.noise_shaping == 0)
                    gfc.noise_shaping = 1;
                gfc.noise_shaping_amp = 0;
                gfc.noise_shaping_stop = 0;
                if (gfc.subblock_gain == -1)
                    gfc.subblock_gain = 1;
                gfc.use_best_huffman = 1;
                gfc.full_outer_loop = 0;
                break;

            case 3:
                gfc.psymodel = 1;
                if (gfc.noise_shaping == 0)
                    gfc.noise_shaping = 1;
                gfc.noise_shaping_amp = 1;
                gfc.noise_shaping_stop = 1;
                if (gfc.subblock_gain == -1)
                    gfc.subblock_gain = 1;
                gfc.use_best_huffman = 1;
                gfc.full_outer_loop = 0;
                break;

            case 2:
                gfc.psymodel = 1;
                if (gfc.noise_shaping == 0)
                    gfc.noise_shaping = 1;
                if (gfc.substep_shaping == 0)
                    gfc.substep_shaping = 2;
                gfc.noise_shaping_amp = 1;
                gfc.noise_shaping_stop = 1;
                if (gfc.subblock_gain == -1)
                    gfc.subblock_gain = 1;
                gfc.use_best_huffman = 1;
                /* inner loop */
                gfc.full_outer_loop = 0;
                break;

            case 1:
                gfc.psymodel = 1;
                if (gfc.noise_shaping == 0)
                    gfc.noise_shaping = 1;
                if (gfc.substep_shaping == 0)
                    gfc.substep_shaping = 2;
                gfc.noise_shaping_amp = 2;
                gfc.noise_shaping_stop = 1;
                if (gfc.subblock_gain == -1)
                    gfc.subblock_gain = 1;
                gfc.use_best_huffman = 1;
                gfc.full_outer_loop = 0;
                break;

            case 0:
                gfc.psymodel = 1;
                if (gfc.noise_shaping == 0)
                    gfc.noise_shaping = 1;
                if (gfc.substep_shaping == 0)
                    gfc.substep_shaping = 2;
                gfc.noise_shaping_amp = 2;
                gfc.noise_shaping_stop = 1;
                if (gfc.subblock_gain == -1)
                    gfc.subblock_gain = 1;
                gfc.use_best_huffman = 1;
                /*
                 * type 2 disabled because of it slowness, in favor of full outer
                 * loop search
                 */
                gfc.full_outer_loop = 0;
                /*
                 * full outer loop search disabled because of audible distortions it
                 * may generate rh 060629
                 */
                break;
        }

    }

    function lame_init_bitstream(gfp) {
        var gfc = gfp.internal_flags;
        gfp.frameNum = 0;

        if (gfp.write_id3tag_automatic) {
            id3.id3tag_write_v2(gfp);
        }
        /* initialize histogram data optionally used by frontend */

        gfc.bitrate_stereoMode_Hist = new_int_n$2([16, 4 + 1]);
        gfc.bitrate_blockType_Hist = new_int_n$2([16, 4 + 1 + 1]);

        gfc.PeakSample = 0.0;

        /* Write initial VBR Header to bitstream and init VBR data */
        if (gfp.bWriteVbrTag)
            vbr.InitVbrTag(gfp);
    }

    /********************************************************************
     * initialize internal params based on data in gf (globalflags struct filled
     * in by calling program)
     *
     * OUTLINE:
     *
     * We first have some complex code to determine bitrate, output samplerate
     * and mode. It is complicated by the fact that we allow the user to set
     * some or all of these parameters, and need to determine best possible
     * values for the rest of them:
     *
     * 1. set some CPU related flags 2. check if we are mono.mono, stereo.mono
     * or stereo.stereo 3. compute bitrate and output samplerate: user may have
     * set compression ratio user may have set a bitrate user may have set a
     * output samplerate 4. set some options which depend on output samplerate
     * 5. compute the actual compression ratio 6. set mode based on compression
     * ratio
     *
     * The remaining code is much simpler - it just sets options based on the
     * mode & compression ratio:
     *
     * set allow_diff_short based on mode select lowpass filter based on
     * compression ratio & mode set the bitrate index, and min/max bitrates for
     * VBR modes disable VBR tag if it is not appropriate initialize the
     * bitstream initialize scalefac_band data set sideinfo_len (based on
     * channels, CRC, out_samplerate) write an id3v2 tag into the bitstream
     * write VBR tag into the bitstream set mpeg1/2 flag estimate the number of
     * frames (based on a lot of data)
     *
     * now we set more flags: nspsytune: see code VBR modes see code CBR/ABR see
     * code
     *
     * Finally, we set the algorithm flags based on the gfp.quality value
     * lame_init_qval(gfp);
     *
     ********************************************************************/
    this.lame_init_params = function (gfp) {
        var gfc = gfp.internal_flags;

        gfc.Class_ID = 0;
        if (gfc.ATH == null)
            gfc.ATH = new ATH_1();
        if (gfc.PSY == null)
            gfc.PSY = new PSY();
        if (gfc.rgdata == null)
            gfc.rgdata = new ReplayGain_1();

        gfc.channels_in = gfp.num_channels;
        if (gfc.channels_in == 1)
            gfp.mode = MPEGMode.MONO;
        gfc.channels_out = (gfp.mode == MPEGMode.MONO) ? 1 : 2;
        gfc.mode_ext = Encoder_1.MPG_MD_MS_LR;
        if (gfp.mode == MPEGMode.MONO)
            gfp.force_ms = false;
        /*
         * don't allow forced mid/side stereo for mono output
         */

        if (gfp.VBR == VbrMode$2.vbr_off && gfp.VBR_mean_bitrate_kbps != 128
            && gfp.brate == 0)
            gfp.brate = gfp.VBR_mean_bitrate_kbps;

        if (gfp.VBR == VbrMode$2.vbr_off || gfp.VBR == VbrMode$2.vbr_mtrh
            || gfp.VBR == VbrMode$2.vbr_mt) {
            /* these modes can handle free format condition */
        } else {
            gfp.free_format = false;
            /* mode can't be mixed with free format */
        }

        if (gfp.VBR == VbrMode$2.vbr_off && gfp.brate == 0) {
            /* no bitrate or compression ratio specified, use 11.025 */
            if (BitStream_1.EQ(gfp.compression_ratio, 0))
                gfp.compression_ratio = 11.025;
            /*
             * rate to compress a CD down to exactly 128000 bps
             */
        }

        /* find bitrate if user specify a compression ratio */
        if (gfp.VBR == VbrMode$2.vbr_off && gfp.compression_ratio > 0) {

            if (gfp.out_samplerate == 0)
                gfp.out_samplerate = map2MP3Frequency((int)(0.97 * gfp.in_samplerate));
            /*
             * round up with a margin of 3 %
             */

            /*
             * choose a bitrate for the output samplerate which achieves
             * specified compression ratio
             */
            gfp.brate = 0 | (gfp.out_samplerate * 16 * gfc.channels_out / (1.e3 * gfp.compression_ratio));

            /* we need the version for the bitrate table look up */
            gfc.samplerate_index = SmpFrqIndex(gfp.out_samplerate, gfp);

            if (!gfp.free_format) /*
             * for non Free Format find the nearest allowed
             * bitrate
             */
                gfp.brate = FindNearestBitrate(gfp.brate, gfp.version,
                    gfp.out_samplerate);
        }

        if (gfp.out_samplerate != 0) {
            if (gfp.out_samplerate < 16000) {
                gfp.VBR_mean_bitrate_kbps = Math.max(gfp.VBR_mean_bitrate_kbps,
                    8);
                gfp.VBR_mean_bitrate_kbps = Math.min(gfp.VBR_mean_bitrate_kbps,
                    64);
            } else if (gfp.out_samplerate < 32000) {
                gfp.VBR_mean_bitrate_kbps = Math.max(gfp.VBR_mean_bitrate_kbps,
                    8);
                gfp.VBR_mean_bitrate_kbps = Math.min(gfp.VBR_mean_bitrate_kbps,
                    160);
            } else {
                gfp.VBR_mean_bitrate_kbps = Math.max(gfp.VBR_mean_bitrate_kbps,
                    32);
                gfp.VBR_mean_bitrate_kbps = Math.min(gfp.VBR_mean_bitrate_kbps,
                    320);
            }
        }

        /****************************************************************/
        /* if a filter has not been enabled, see if we should add one: */
        /****************************************************************/
        if (gfp.lowpassfreq == 0) {
            var lowpass = 16000.;

            switch (gfp.VBR) {
                case VbrMode$2.vbr_off:
                {
                    var lh = new LowPassHighPass();
                    optimum_bandwidth(lh, gfp.brate);
                    lowpass = lh.lowerlimit;
                    break;
                }
                case VbrMode$2.vbr_abr:
                {
                    var lh = new LowPassHighPass();
                    optimum_bandwidth(lh, gfp.VBR_mean_bitrate_kbps);
                    lowpass = lh.lowerlimit;
                    break;
                }
                case VbrMode$2.vbr_rh:
                {
                    var x = [19500, 19000, 18600, 18000, 17500, 16000,
                        15600, 14900, 12500, 10000, 3950];
                    if (0 <= gfp.VBR_q && gfp.VBR_q <= 9) {
                        var a = x[gfp.VBR_q], b = x[gfp.VBR_q + 1], m = gfp.VBR_q_frac;
                        lowpass = linear_int(a, b, m);
                    } else {
                        lowpass = 19500;
                    }
                    break;
                }
                default:
                {
                    var x = [19500, 19000, 18500, 18000, 17500, 16500,
                        15500, 14500, 12500, 9500, 3950];
                    if (0 <= gfp.VBR_q && gfp.VBR_q <= 9) {
                        var a = x[gfp.VBR_q], b = x[gfp.VBR_q + 1], m = gfp.VBR_q_frac;
                        lowpass = linear_int(a, b, m);
                    } else {
                        lowpass = 19500;
                    }
                }
            }
            if (gfp.mode == MPEGMode.MONO
                && (gfp.VBR == VbrMode$2.vbr_off || gfp.VBR == VbrMode$2.vbr_abr))
                lowpass *= 1.5;

            gfp.lowpassfreq = lowpass | 0;
        }

        if (gfp.out_samplerate == 0) {
            if (2 * gfp.lowpassfreq > gfp.in_samplerate) {
                gfp.lowpassfreq = gfp.in_samplerate / 2;
            }
            gfp.out_samplerate = optimum_samplefreq(gfp.lowpassfreq | 0,
                gfp.in_samplerate);
        }

        gfp.lowpassfreq = Math.min(20500, gfp.lowpassfreq);
        gfp.lowpassfreq = Math.min(gfp.out_samplerate / 2, gfp.lowpassfreq);

        if (gfp.VBR == VbrMode$2.vbr_off) {
            gfp.compression_ratio = gfp.out_samplerate * 16 * gfc.channels_out
                / (1.e3 * gfp.brate);
        }
        if (gfp.VBR == VbrMode$2.vbr_abr) {
            gfp.compression_ratio = gfp.out_samplerate * 16 * gfc.channels_out
                / (1.e3 * gfp.VBR_mean_bitrate_kbps);
        }

        /*
         * do not compute ReplayGain values and do not find the peak sample if
         * we can't store them
         */
        if (!gfp.bWriteVbrTag) {
            gfp.findReplayGain = false;
            gfp.decode_on_the_fly = false;
            gfc.findPeakSample = false;
        }
        gfc.findReplayGain = gfp.findReplayGain;
        gfc.decode_on_the_fly = gfp.decode_on_the_fly;

        if (gfc.decode_on_the_fly)
            gfc.findPeakSample = true;

        if (gfc.findReplayGain) {
            if (ga.InitGainAnalysis(gfc.rgdata, gfp.out_samplerate) == GainAnalysis.INIT_GAIN_ANALYSIS_ERROR) {
                gfp.internal_flags = null;
                return -6;
            }
        }

        if (gfc.decode_on_the_fly && !gfp.decode_only) {
            if (gfc.hip != null) {
                mpglib.hip_decode_exit(gfc.hip);
            }
            gfc.hip = mpglib.hip_decode_init();
        }

        gfc.mode_gr = gfp.out_samplerate <= 24000 ? 1 : 2;
        /*
         * Number of granules per frame
         */
        gfp.framesize = 576 * gfc.mode_gr;
        gfp.encoder_delay = Encoder_1.ENCDELAY;

        gfc.resample_ratio = gfp.in_samplerate / gfp.out_samplerate;

        /**
         * <PRE>
         *  sample freq       bitrate     compression ratio
         *     [kHz]      [kbps/channel]   for 16 bit input
         *     44.1            56               12.6
         *     44.1            64               11.025
         *     44.1            80                8.82
         *     22.05           24               14.7
         *     22.05           32               11.025
         *     22.05           40                8.82
         *     16              16               16.0
         *     16              24               10.667
         * </PRE>
         */
        /**
         * <PRE>
         *  For VBR, take a guess at the compression_ratio.
         *  For example:
         *
         *    VBR_q    compression     like
         *     -        4.4         320 kbps/44 kHz
         *   0...1      5.5         256 kbps/44 kHz
         *     2        7.3         192 kbps/44 kHz
         *     4        8.8         160 kbps/44 kHz
         *     6       11           128 kbps/44 kHz
         *     9       14.7          96 kbps
         *
         *  for lower bitrates, downsample with --resample
         * </PRE>
         */
        switch (gfp.VBR) {
            case VbrMode$2.vbr_mt:
            case VbrMode$2.vbr_rh:
            case VbrMode$2.vbr_mtrh:
            {
                /* numbers are a bit strange, but they determine the lowpass value */
                var cmp = [5.7, 6.5, 7.3, 8.2, 10, 11.9, 13, 14,
                    15, 16.5];
                gfp.compression_ratio = cmp[gfp.VBR_q];
            }
                break;
            case VbrMode$2.vbr_abr:
                gfp.compression_ratio = gfp.out_samplerate * 16 * gfc.channels_out
                    / (1.e3 * gfp.VBR_mean_bitrate_kbps);
                break;
            default:
                gfp.compression_ratio = gfp.out_samplerate * 16 * gfc.channels_out
                    / (1.e3 * gfp.brate);
                break;
        }

        /*
         * mode = -1 (not set by user) or mode = MONO (because of only 1 input
         * channel). If mode has not been set, then select J-STEREO
         */
        if (gfp.mode == MPEGMode.NOT_SET) {
            gfp.mode = MPEGMode.JOINT_STEREO;
        }

        /* apply user driven high pass filter */
        if (gfp.highpassfreq > 0) {
            gfc.highpass1 = 2. * gfp.highpassfreq;

            if (gfp.highpasswidth >= 0)
                gfc.highpass2 = 2. * (gfp.highpassfreq + gfp.highpasswidth);
            else
            /* 0% above on default */
                gfc.highpass2 = (1 + 0.00) * 2. * gfp.highpassfreq;

            gfc.highpass1 /= gfp.out_samplerate;
            gfc.highpass2 /= gfp.out_samplerate;
        } else {
            gfc.highpass1 = 0;
            gfc.highpass2 = 0;
        }
        /* apply user driven low pass filter */
        if (gfp.lowpassfreq > 0) {
            gfc.lowpass2 = 2. * gfp.lowpassfreq;
            if (gfp.lowpasswidth >= 0) {
                gfc.lowpass1 = 2. * (gfp.lowpassfreq - gfp.lowpasswidth);
                if (gfc.lowpass1 < 0) /* has to be >= 0 */
                    gfc.lowpass1 = 0;
            } else { /* 0% below on default */
                gfc.lowpass1 = (1 - 0.00) * 2. * gfp.lowpassfreq;
            }
            gfc.lowpass1 /= gfp.out_samplerate;
            gfc.lowpass2 /= gfp.out_samplerate;
        } else {
            gfc.lowpass1 = 0;
            gfc.lowpass2 = 0;
        }

        /**********************************************************************/
        /* compute info needed for polyphase filter (filter type==0, default) */
        /**********************************************************************/
        lame_init_params_ppflt(gfp);
        /*******************************************************
         * samplerate and bitrate index
         *******************************************************/
        gfc.samplerate_index = SmpFrqIndex(gfp.out_samplerate, gfp);
        if (gfc.samplerate_index < 0) {
            gfp.internal_flags = null;
            return -1;
        }

        if (gfp.VBR == VbrMode$2.vbr_off) {
            if (gfp.free_format) {
                gfc.bitrate_index = 0;
            } else {
                gfp.brate = FindNearestBitrate(gfp.brate, gfp.version,
                    gfp.out_samplerate);
                gfc.bitrate_index = BitrateIndex(gfp.brate, gfp.version,
                    gfp.out_samplerate);
                if (gfc.bitrate_index <= 0) {
                    gfp.internal_flags = null;
                    return -1;
                }
            }
        } else {
            gfc.bitrate_index = 1;
        }

        /* for CBR, we will write an "info" tag. */

        if (gfp.analysis)
            gfp.bWriteVbrTag = false;

        /* some file options not allowed if output is: not specified or stdout */
        if (gfc.pinfo != null)
            gfp.bWriteVbrTag = false;
        /* disable Xing VBR tag */

        bs.init_bit_stream_w(gfc);

        var j = gfc.samplerate_index + (3 * gfp.version) + 6
            * (gfp.out_samplerate < 16000 ? 1 : 0);
        for (var i = 0; i < Encoder_1.SBMAX_l + 1; i++)
            gfc.scalefac_band.l[i] = qupvt.sfBandIndex[j].l[i];

        for (var i = 0; i < Encoder_1.PSFB21 + 1; i++) {
            var size = (gfc.scalefac_band.l[22] - gfc.scalefac_band.l[21])
                / Encoder_1.PSFB21;
            var start = gfc.scalefac_band.l[21] + i * size;
            gfc.scalefac_band.psfb21[i] = start;
        }
        gfc.scalefac_band.psfb21[Encoder_1.PSFB21] = 576;

        for (var i = 0; i < Encoder_1.SBMAX_s + 1; i++)
            gfc.scalefac_band.s[i] = qupvt.sfBandIndex[j].s[i];

        for (var i = 0; i < Encoder_1.PSFB12 + 1; i++) {
            var size = (gfc.scalefac_band.s[13] - gfc.scalefac_band.s[12])
                / Encoder_1.PSFB12;
            var start = gfc.scalefac_band.s[12] + i * size;
            gfc.scalefac_band.psfb12[i] = start;
        }
        gfc.scalefac_band.psfb12[Encoder_1.PSFB12] = 192;
        /* determine the mean bitrate for main data */
        if (gfp.version == 1) /* MPEG 1 */
            gfc.sideinfo_len = (gfc.channels_out == 1) ? 4 + 17 : 4 + 32;
        else
        /* MPEG 2 */
            gfc.sideinfo_len = (gfc.channels_out == 1) ? 4 + 9 : 4 + 17;

        if (gfp.error_protection)
            gfc.sideinfo_len += 2;

        lame_init_bitstream(gfp);

        gfc.Class_ID = LAME_ID;

        {
            var k;

            for (k = 0; k < 19; k++)
                gfc.nsPsy.pefirbuf[k] = 700 * gfc.mode_gr * gfc.channels_out;

            if (gfp.ATHtype == -1)
                gfp.ATHtype = 4;
        }
        assert$2(gfp.VBR_q <= 9);
        assert$2(gfp.VBR_q >= 0);

        switch (gfp.VBR) {

            case VbrMode$2.vbr_mt:
                gfp.VBR = VbrMode$2.vbr_mtrh;
            //$FALL-THROUGH$
            case VbrMode$2.vbr_mtrh:
            {
                if (gfp.useTemporal == null) {
                    gfp.useTemporal = false;
                    /* off by default for this VBR mode */
                }

                p.apply_preset(gfp, 500 - (gfp.VBR_q * 10), 0);
                /**
                 * <PRE>
                 *   The newer VBR code supports only a limited
                 *     subset of quality levels:
                 *     9-5=5 are the same, uses x^3/4 quantization
                 *   4-0=0 are the same  5 plus best huffman divide code
                 * </PRE>
                 */
                if (gfp.quality < 0)
                    gfp.quality = LAME_DEFAULT_QUALITY;
                if (gfp.quality < 5)
                    gfp.quality = 0;
                if (gfp.quality > 5)
                    gfp.quality = 5;

                gfc.PSY.mask_adjust = gfp.maskingadjust;
                gfc.PSY.mask_adjust_short = gfp.maskingadjust_short;

                /*
                 * sfb21 extra only with MPEG-1 at higher sampling rates
                 */
                if (gfp.experimentalY)
                    gfc.sfb21_extra = false;
                else
                    gfc.sfb21_extra = (gfp.out_samplerate > 44000);

                gfc.iteration_loop = new VBRNewIterationLoop(qu);
                break;

            }
            case VbrMode$2.vbr_rh:
            {

                p.apply_preset(gfp, 500 - (gfp.VBR_q * 10), 0);

                gfc.PSY.mask_adjust = gfp.maskingadjust;
                gfc.PSY.mask_adjust_short = gfp.maskingadjust_short;

                /*
                 * sfb21 extra only with MPEG-1 at higher sampling rates
                 */
                if (gfp.experimentalY)
                    gfc.sfb21_extra = false;
                else
                    gfc.sfb21_extra = (gfp.out_samplerate > 44000);

                /*
                 * VBR needs at least the output of GPSYCHO, so we have to garantee
                 * that by setting a minimum quality level, actually level 6 does
                 * it. down to level 6
                 */
                if (gfp.quality > 6)
                    gfp.quality = 6;

                if (gfp.quality < 0)
                    gfp.quality = LAME_DEFAULT_QUALITY;

                gfc.iteration_loop = new VBROldIterationLoop(qu);
                break;
            }

            default: /* cbr/abr */
            {
                var vbrmode;

                /*
                 * no sfb21 extra with CBR code
                 */
                gfc.sfb21_extra = false;

                if (gfp.quality < 0)
                    gfp.quality = LAME_DEFAULT_QUALITY;

                vbrmode = gfp.VBR;
                if (vbrmode == VbrMode$2.vbr_off)
                    gfp.VBR_mean_bitrate_kbps = gfp.brate;
                /* second, set parameters depending on bitrate */
                p.apply_preset(gfp, gfp.VBR_mean_bitrate_kbps, 0);
                gfp.VBR = vbrmode;

                gfc.PSY.mask_adjust = gfp.maskingadjust;
                gfc.PSY.mask_adjust_short = gfp.maskingadjust_short;

                if (vbrmode == VbrMode$2.vbr_off) {
                    gfc.iteration_loop = new CBRNewIterationLoop_1(qu);
                } else {
                    gfc.iteration_loop = new ABRIterationLoop(qu);
                }
                break;
            }
        }
        assert$2(gfp.scale >= 0);
        /* initialize default values common for all modes */

        if (gfp.VBR != VbrMode$2.vbr_off) { /* choose a min/max bitrate for VBR */
            /* if the user didn't specify VBR_max_bitrate: */
            gfc.VBR_min_bitrate = 1;
            /*
             * default: allow 8 kbps (MPEG-2) or 32 kbps (MPEG-1)
             */
            gfc.VBR_max_bitrate = 14;
            /*
             * default: allow 160 kbps (MPEG-2) or 320 kbps (MPEG-1)
             */
            if (gfp.out_samplerate < 16000)
                gfc.VBR_max_bitrate = 8;
            /* default: allow 64 kbps (MPEG-2.5) */
            if (gfp.VBR_min_bitrate_kbps != 0) {
                gfp.VBR_min_bitrate_kbps = FindNearestBitrate(
                    gfp.VBR_min_bitrate_kbps, gfp.version,
                    gfp.out_samplerate);
                gfc.VBR_min_bitrate = BitrateIndex(gfp.VBR_min_bitrate_kbps,
                    gfp.version, gfp.out_samplerate);
                if (gfc.VBR_min_bitrate < 0)
                    return -1;
            }
            if (gfp.VBR_max_bitrate_kbps != 0) {
                gfp.VBR_max_bitrate_kbps = FindNearestBitrate(
                    gfp.VBR_max_bitrate_kbps, gfp.version,
                    gfp.out_samplerate);
                gfc.VBR_max_bitrate = BitrateIndex(gfp.VBR_max_bitrate_kbps,
                    gfp.version, gfp.out_samplerate);
                if (gfc.VBR_max_bitrate < 0)
                    return -1;
            }
            gfp.VBR_min_bitrate_kbps = Tables_1.bitrate_table[gfp.version][gfc.VBR_min_bitrate];
            gfp.VBR_max_bitrate_kbps = Tables_1.bitrate_table[gfp.version][gfc.VBR_max_bitrate];
            gfp.VBR_mean_bitrate_kbps = Math.min(
                Tables_1.bitrate_table[gfp.version][gfc.VBR_max_bitrate],
                gfp.VBR_mean_bitrate_kbps);
            gfp.VBR_mean_bitrate_kbps = Math.max(
                Tables_1.bitrate_table[gfp.version][gfc.VBR_min_bitrate],
                gfp.VBR_mean_bitrate_kbps);
        }

        /* just another daily changing developer switch */
        if (gfp.tune) {
            gfc.PSY.mask_adjust += gfp.tune_value_a;
            gfc.PSY.mask_adjust_short += gfp.tune_value_a;
        }

        /* initialize internal qval settings */
        lame_init_qval(gfp);
        assert$2(gfp.scale >= 0);
        /*
         * automatic ATH adjustment on
         */
        if (gfp.athaa_type < 0)
            gfc.ATH.useAdjust = 3;
        else
            gfc.ATH.useAdjust = gfp.athaa_type;

        /* initialize internal adaptive ATH settings -jd */
        gfc.ATH.aaSensitivityP = Math.pow(10.0, gfp.athaa_sensitivity
            / -10.0);

        if (gfp.short_blocks == null) {
            gfp.short_blocks = ShortBlock$2.short_block_allowed;
        }

        /*
         * Note Jan/2003: Many hardware decoders cannot handle short blocks in
         * regular stereo mode unless they are coupled (same type in both
         * channels) it is a rare event (1 frame per min. or so) that LAME would
         * use uncoupled short blocks, so lets turn them off until we decide how
         * to handle this. No other encoders allow uncoupled short blocks, even
         * though it is in the standard.
         */
        /*
         * rh 20040217: coupling makes no sense for mono and dual-mono streams
         */
        if (gfp.short_blocks == ShortBlock$2.short_block_allowed
            && (gfp.mode == MPEGMode.JOINT_STEREO || gfp.mode == MPEGMode.STEREO)) {
            gfp.short_blocks = ShortBlock$2.short_block_coupled;
        }

        if (gfp.quant_comp < 0)
            gfp.quant_comp = 1;
        if (gfp.quant_comp_short < 0)
            gfp.quant_comp_short = 0;

        if (gfp.msfix < 0)
            gfp.msfix = 0;

        /* select psychoacoustic model */
        gfp.exp_nspsytune = gfp.exp_nspsytune | 1;

        if (gfp.internal_flags.nsPsy.attackthre < 0)
            gfp.internal_flags.nsPsy.attackthre = PsyModel_1.NSATTACKTHRE;
        if (gfp.internal_flags.nsPsy.attackthre_s < 0)
            gfp.internal_flags.nsPsy.attackthre_s = PsyModel_1.NSATTACKTHRE_S;

        assert$2(gfp.scale >= 0);

        if (gfp.scale < 0)
            gfp.scale = 1;

        if (gfp.ATHtype < 0)
            gfp.ATHtype = 4;

        if (gfp.ATHcurve < 0)
            gfp.ATHcurve = 4;

        if (gfp.athaa_loudapprox < 0)
            gfp.athaa_loudapprox = 2;

        if (gfp.interChRatio < 0)
            gfp.interChRatio = 0;

        if (gfp.useTemporal == null)
            gfp.useTemporal = true;
        /* on by default */

        /*
         * padding method as described in
         * "MPEG-Layer3 / Bitstream Syntax and Decoding" by Martin Sieler, Ralph
         * Sperschneider
         *
         * note: there is no padding for the very first frame
         *
         * Robert Hegemann 2000-06-22
         */
        gfc.slot_lag = gfc.frac_SpF = 0;
        if (gfp.VBR == VbrMode$2.vbr_off)
            gfc.slot_lag = gfc.frac_SpF = (((gfp.version + 1) * 72000 * gfp.brate) % gfp.out_samplerate) | 0;

        qupvt.iteration_init(gfp);
        psy.psymodel_init(gfp);
        assert$2(gfp.scale >= 0);
        return 0;
    };

    function update_inbuffer_size(gfc, nsamples) {
        if (gfc.in_buffer_0 == null || gfc.in_buffer_nsamples < nsamples) {
            gfc.in_buffer_0 = new_float$2(nsamples);
            gfc.in_buffer_1 = new_float$2(nsamples);
            gfc.in_buffer_nsamples = nsamples;
        }
    }

    this.lame_encode_flush = function (gfp, mp3buffer, mp3bufferPos, mp3buffer_size) {
        var gfc = gfp.internal_flags;
        var buffer = new_short_n$1([2, 1152]);
        var imp3 = 0, mp3count, mp3buffer_size_remaining;

        /*
         * we always add POSTDELAY=288 padding to make sure granule with real
         * data can be complety decoded (because of 50% overlap with next
         * granule
         */
        var end_padding;
        var frames_left;
        var samples_to_encode = gfc.mf_samples_to_encode - Encoder_1.POSTDELAY;
        var mf_needed = calcNeeded(gfp);

        /* Was flush already called? */
        if (gfc.mf_samples_to_encode < 1) {
            return 0;
        }
        mp3count = 0;

        if (gfp.in_samplerate != gfp.out_samplerate) {
            /*
             * delay due to resampling; needs to be fixed, if resampling code
             * gets changed
             */
            samples_to_encode += 16. * gfp.out_samplerate / gfp.in_samplerate;
        }
        end_padding = gfp.framesize - (samples_to_encode % gfp.framesize);
        if (end_padding < 576)
            end_padding += gfp.framesize;
        gfp.encoder_padding = end_padding;

        frames_left = (samples_to_encode + end_padding) / gfp.framesize;

        /*
         * send in a frame of 0 padding until all internal sample buffers are
         * flushed
         */
        while (frames_left > 0 && imp3 >= 0) {
            var bunch = mf_needed - gfc.mf_size;
            var frame_num = gfp.frameNum;

            bunch *= gfp.in_samplerate;
            bunch /= gfp.out_samplerate;
            if (bunch > 1152)
                bunch = 1152;
            if (bunch < 1)
                bunch = 1;

            mp3buffer_size_remaining = mp3buffer_size - mp3count;

            /* if user specifed buffer size = 0, dont check size */
            if (mp3buffer_size == 0)
                mp3buffer_size_remaining = 0;

            imp3 = this.lame_encode_buffer(gfp, buffer[0], buffer[1], bunch,
                mp3buffer, mp3bufferPos, mp3buffer_size_remaining);

            mp3bufferPos += imp3;
            mp3count += imp3;
            frames_left -= (frame_num != gfp.frameNum) ? 1 : 0;
        }
        /*
         * Set gfc.mf_samples_to_encode to 0, so we may detect and break loops
         * calling it more than once in a row.
         */
        gfc.mf_samples_to_encode = 0;

        if (imp3 < 0) {
            /* some type of fatal error */
            return imp3;
        }

        mp3buffer_size_remaining = mp3buffer_size - mp3count;
        /* if user specifed buffer size = 0, dont check size */
        if (mp3buffer_size == 0)
            mp3buffer_size_remaining = 0;

        /* mp3 related stuff. bit buffer might still contain some mp3 data */
        bs.flush_bitstream(gfp);
        imp3 = bs.copy_buffer(gfc, mp3buffer, mp3bufferPos,
            mp3buffer_size_remaining, 1);
        if (imp3 < 0) {
            /* some type of fatal error */
            return imp3;
        }
        mp3bufferPos += imp3;
        mp3count += imp3;
        mp3buffer_size_remaining = mp3buffer_size - mp3count;
        /* if user specifed buffer size = 0, dont check size */
        if (mp3buffer_size == 0)
            mp3buffer_size_remaining = 0;

        if (gfp.write_id3tag_automatic) {
            /* write a id3 tag to the bitstream */
            id3.id3tag_write_v1(gfp);

            imp3 = bs.copy_buffer(gfc, mp3buffer, mp3bufferPos,
                mp3buffer_size_remaining, 0);

            if (imp3 < 0) {
                return imp3;
            }
            mp3count += imp3;
        }
        return mp3count;
    };

    this.lame_encode_buffer = function (gfp, buffer_l, buffer_r, nsamples, mp3buf, mp3bufPos, mp3buf_size) {
        var gfc = gfp.internal_flags;
        var in_buffer = [null, null];

        if (gfc.Class_ID != LAME_ID)
            return -3;

        if (nsamples == 0)
            return 0;

        update_inbuffer_size(gfc, nsamples);

        in_buffer[0] = gfc.in_buffer_0;
        in_buffer[1] = gfc.in_buffer_1;

        /* make a copy of input buffer, changing type to sample_t */
        for (var i = 0; i < nsamples; i++) {
            in_buffer[0][i] = buffer_l[i];
            if (gfc.channels_in > 1)
                in_buffer[1][i] = buffer_r[i];
        }

        return lame_encode_buffer_sample(gfp, in_buffer[0], in_buffer[1],
            nsamples, mp3buf, mp3bufPos, mp3buf_size);
    };

    function calcNeeded(gfp) {
        var mf_needed = Encoder_1.BLKSIZE + gfp.framesize - Encoder_1.FFTOFFSET;
        /*
         * amount needed for FFT
         */
        mf_needed = Math.max(mf_needed, 512 + gfp.framesize - 32);
        assert$2(LameInternalFlags_1.MFSIZE >= mf_needed);

        return mf_needed;
    }

    function lame_encode_buffer_sample(gfp, buffer_l, buffer_r, nsamples, mp3buf, mp3bufPos, mp3buf_size) {
        var gfc = gfp.internal_flags;
        var mp3size = 0, ret, i, ch, mf_needed;
        var mp3out;
        var mfbuf = [null, null];
        var in_buffer = [null, null];

        if (gfc.Class_ID != LAME_ID)
            return -3;

        if (nsamples == 0)
            return 0;

        /* copy out any tags that may have been written into bitstream */
        mp3out = bs.copy_buffer(gfc, mp3buf, mp3bufPos, mp3buf_size, 0);
        if (mp3out < 0)
            return mp3out;
        /* not enough buffer space */
        mp3bufPos += mp3out;
        mp3size += mp3out;

        in_buffer[0] = buffer_l;
        in_buffer[1] = buffer_r;

        /* Apply user defined re-scaling */

        /* user selected scaling of the samples */
        if (BitStream_1.NEQ(gfp.scale, 0) && BitStream_1.NEQ(gfp.scale, 1.0)) {
            for (i = 0; i < nsamples; ++i) {
                in_buffer[0][i] *= gfp.scale;
                if (gfc.channels_out == 2)
                    in_buffer[1][i] *= gfp.scale;
            }
        }

        /* user selected scaling of the channel 0 (left) samples */
        if (BitStream_1.NEQ(gfp.scale_left, 0)
            && BitStream_1.NEQ(gfp.scale_left, 1.0)) {
            for (i = 0; i < nsamples; ++i) {
                in_buffer[0][i] *= gfp.scale_left;
            }
        }

        /* user selected scaling of the channel 1 (right) samples */
        if (BitStream_1.NEQ(gfp.scale_right, 0)
            && BitStream_1.NEQ(gfp.scale_right, 1.0)) {
            for (i = 0; i < nsamples; ++i) {
                in_buffer[1][i] *= gfp.scale_right;
            }
        }

        /* Downsample to Mono if 2 channels in and 1 channel out */
        if (gfp.num_channels == 2 && gfc.channels_out == 1) {
            for (i = 0; i < nsamples; ++i) {
                in_buffer[0][i] = 0.5 * ( in_buffer[0][i] + in_buffer[1][i]);
                in_buffer[1][i] = 0.0;
            }
        }

        mf_needed = calcNeeded(gfp);

        mfbuf[0] = gfc.mfbuf[0];
        mfbuf[1] = gfc.mfbuf[1];

        var in_bufferPos = 0;
        while (nsamples > 0) {
            var in_buffer_ptr = [null, null];
            var n_in = 0;
            /* number of input samples processed with fill_buffer */
            var n_out = 0;
            /* number of samples output with fill_buffer */
            /* n_in <> n_out if we are resampling */

            in_buffer_ptr[0] = in_buffer[0];
            in_buffer_ptr[1] = in_buffer[1];
            /* copy in new samples into mfbuf, with resampling */
            var inOut = new InOut();
            fill_buffer(gfp, mfbuf, in_buffer_ptr, in_bufferPos, nsamples,
                inOut);
            n_in = inOut.n_in;
            n_out = inOut.n_out;

            /* compute ReplayGain of resampled input if requested */
            if (gfc.findReplayGain && !gfc.decode_on_the_fly)
                if (ga.AnalyzeSamples(gfc.rgdata, mfbuf[0], gfc.mf_size,
                        mfbuf[1], gfc.mf_size, n_out, gfc.channels_out) == GainAnalysis.GAIN_ANALYSIS_ERROR)
                    return -6;

            /* update in_buffer counters */
            nsamples -= n_in;
            in_bufferPos += n_in;
            if (gfc.channels_out == 2)
                ;// in_bufferPos += n_in;

            /* update mfbuf[] counters */
            gfc.mf_size += n_out;
            assert$2(gfc.mf_size <= LameInternalFlags_1.MFSIZE);

            /*
             * lame_encode_flush may have set gfc.mf_sample_to_encode to 0 so we
             * have to reinitialize it here when that happened.
             */
            if (gfc.mf_samples_to_encode < 1) {
                gfc.mf_samples_to_encode = Encoder_1.ENCDELAY + Encoder_1.POSTDELAY;
            }
            gfc.mf_samples_to_encode += n_out;

            if (gfc.mf_size >= mf_needed) {
                /* encode the frame. */
                /* mp3buf = pointer to current location in buffer */
                /* mp3buf_size = size of original mp3 output buffer */
                /* = 0 if we should not worry about the */
                /* buffer size because calling program is */
                /* to lazy to compute it */
                /* mp3size = size of data written to buffer so far */
                /* mp3buf_size-mp3size = amount of space avalable */

                var buf_size = mp3buf_size - mp3size;
                if (mp3buf_size == 0)
                    buf_size = 0;

                ret = lame_encode_frame(gfp, mfbuf[0], mfbuf[1], mp3buf,
                    mp3bufPos, buf_size);

                if (ret < 0)
                    return ret;
                mp3bufPos += ret;
                mp3size += ret;

                /* shift out old samples */
                gfc.mf_size -= gfp.framesize;
                gfc.mf_samples_to_encode -= gfp.framesize;
                for (ch = 0; ch < gfc.channels_out; ch++)
                    for (i = 0; i < gfc.mf_size; i++)
                        mfbuf[ch][i] = mfbuf[ch][i + gfp.framesize];
            }
        }
        assert$2(nsamples == 0);

        return mp3size;
    }

    function lame_encode_frame(gfp, inbuf_l, inbuf_r, mp3buf, mp3bufPos, mp3buf_size) {
        var ret = self.enc.lame_encode_mp3_frame(gfp, inbuf_l, inbuf_r, mp3buf,
            mp3bufPos, mp3buf_size);
        gfp.frameNum++;
        return ret;
    }

    function InOut() {
        this.n_in = 0;
        this.n_out = 0;
    }


    function NumUsed() {
        this.num_used = 0;
    }

    /**
     * Greatest common divisor.
     * <p>
     * Joint work of Euclid and M. Hendry
     */
    function gcd(i, j) {
        return j != 0 ? gcd(j, i % j) : i;
    }

    /**
     * Resampling via FIR filter, blackman window.
     */
    function blackman(x, fcn, l) {
        /*
         * This algorithm from: SIGNAL PROCESSING ALGORITHMS IN FORTRAN AND C
         * S.D. Stearns and R.A. David, Prentice-Hall, 1992
         */
        var wcn = (Math.PI * fcn);

        x /= l;
        if (x < 0)
            x = 0;
        if (x > 1)
            x = 1;
        var x2 = x - .5;

        var bkwn = 0.42 - 0.5 * Math.cos(2 * x * Math.PI) + 0.08 * Math.cos(4 * x * Math.PI);
        if (Math.abs(x2) < 1e-9)
            return (wcn / Math.PI);
        else
            return (bkwn * Math.sin(l * wcn * x2) / (Math.PI * l * x2));
    }

    function fill_buffer_resample(gfp, outbuf, outbufPos, desired_len, inbuf, in_bufferPos, len, num_used, ch) {
        var gfc = gfp.internal_flags;
        var i, j = 0, k;
        /* number of convolution functions to pre-compute */
        var bpc = gfp.out_samplerate
            / gcd(gfp.out_samplerate, gfp.in_samplerate);
        if (bpc > LameInternalFlags_1.BPC)
            bpc = LameInternalFlags_1.BPC;

        var intratio = (Math.abs(gfc.resample_ratio
            - Math.floor(.5 + gfc.resample_ratio)) < .0001) ? 1 : 0;
        var fcn = 1.00 / gfc.resample_ratio;
        if (fcn > 1.00)
            fcn = 1.00;
        var filter_l = 31;
        if (0 == filter_l % 2)
            --filter_l;
        /* must be odd */
        filter_l += intratio;
        /* unless resample_ratio=int, it must be even */

        var BLACKSIZE = filter_l + 1;
        /* size of data needed for FIR */

        if (gfc.fill_buffer_resample_init == 0) {
            gfc.inbuf_old[0] = new_float$2(BLACKSIZE);
            gfc.inbuf_old[1] = new_float$2(BLACKSIZE);
            for (i = 0; i <= 2 * bpc; ++i)
                gfc.blackfilt[i] = new_float$2(BLACKSIZE);

            gfc.itime[0] = 0;
            gfc.itime[1] = 0;

            /* precompute blackman filter coefficients */
            for (j = 0; j <= 2 * bpc; j++) {
                var sum = 0.;
                var offset = (j - bpc) / (2. * bpc);
                for (i = 0; i <= filter_l; i++)
                    sum += gfc.blackfilt[j][i] = blackman(i - offset, fcn,
                        filter_l);
                for (i = 0; i <= filter_l; i++)
                    gfc.blackfilt[j][i] /= sum;
            }
            gfc.fill_buffer_resample_init = 1;
        }

        var inbuf_old = gfc.inbuf_old[ch];

        /* time of j'th element in inbuf = itime + j/ifreq; */
        /* time of k'th element in outbuf = j/ofreq */
        for (k = 0; k < desired_len; k++) {
            var time0;
            var joff;

            time0 = k * gfc.resample_ratio;
            /* time of k'th output sample */
            j = 0 | Math.floor(time0 - gfc.itime[ch]);

            /* check if we need more input data */
            if ((filter_l + j - filter_l / 2) >= len)
                break;

            /* blackman filter. by default, window centered at j+.5(filter_l%2) */
            /* but we want a window centered at time0. */
            var offset = (time0 - gfc.itime[ch] - (j + .5 * (filter_l % 2)));
            assert$2(Math.abs(offset) <= .501);

            /* find the closest precomputed window for this offset: */
            joff = 0 | Math.floor((offset * 2 * bpc) + bpc + .5);
            var xvalue = 0.;
            for (i = 0; i <= filter_l; ++i) {
                var j2 = i + j - filter_l / 2;
                var y;
                assert$2(j2 < len);
                assert$2(j2 + BLACKSIZE >= 0);
                y = (j2 < 0) ? inbuf_old[BLACKSIZE + j2] : inbuf[in_bufferPos
                + j2];
                xvalue += y * gfc.blackfilt[joff][i];
            }
            outbuf[outbufPos + k] = xvalue;
        }

        /* k = number of samples added to outbuf */
        /* last k sample used data from [j-filter_l/2,j+filter_l-filter_l/2] */

        /* how many samples of input data were used: */
        num_used.num_used = Math.min(len, filter_l + j - filter_l / 2);

        /*
         * adjust our input time counter. Incriment by the number of samples
         * used, then normalize so that next output sample is at time 0, next
         * input buffer is at time itime[ch]
         */
        gfc.itime[ch] += num_used.num_used - k * gfc.resample_ratio;

        /* save the last BLACKSIZE samples into the inbuf_old buffer */
        if (num_used.num_used >= BLACKSIZE) {
            for (i = 0; i < BLACKSIZE; i++)
                inbuf_old[i] = inbuf[in_bufferPos + num_used.num_used + i
                - BLACKSIZE];
        } else {
            /* shift in num_used.num_used samples into inbuf_old */
            var n_shift = BLACKSIZE - num_used.num_used;
            /*
             * number of samples to
             * shift
             */

            /*
             * shift n_shift samples by num_used.num_used, to make room for the
             * num_used new samples
             */
            for (i = 0; i < n_shift; ++i)
                inbuf_old[i] = inbuf_old[i + num_used.num_used];

            /* shift in the num_used.num_used samples */
            for (j = 0; i < BLACKSIZE; ++i, ++j)
                inbuf_old[i] = inbuf[in_bufferPos + j];

            assert$2(j == num_used.num_used);
        }
        return k;
        /* return the number samples created at the new samplerate */
    }

    function fill_buffer(gfp, mfbuf, in_buffer, in_bufferPos, nsamples, io) {
        var gfc = gfp.internal_flags;

        /* copy in new samples into mfbuf, with resampling if necessary */
        if ((gfc.resample_ratio < .9999) || (gfc.resample_ratio > 1.0001)) {
            for (var ch = 0; ch < gfc.channels_out; ch++) {
                var numUsed = new NumUsed();
                io.n_out = fill_buffer_resample(gfp, mfbuf[ch], gfc.mf_size,
                    gfp.framesize, in_buffer[ch], in_bufferPos, nsamples,
                    numUsed, ch);
                io.n_in = numUsed.num_used;
            }
        } else {
            io.n_out = Math.min(gfp.framesize, nsamples);
            io.n_in = io.n_out;
            for (var i = 0; i < io.n_out; ++i) {
                mfbuf[0][gfc.mf_size + i] = in_buffer[0][in_bufferPos + i];
                if (gfc.channels_out == 2)
                    mfbuf[1][gfc.mf_size + i] = in_buffer[1][in_bufferPos + i];
            }
        }
    }

}

var Lame_1 = Lame$1;

var VbrMode$20 = common.VbrMode;
function Presets$1() {
    function VBRPresets(qual, comp, compS,
                        y, shThreshold, shThresholdS,
                        adj, adjShort, lower,
                        curve, sens, inter,
                        joint, mod, fix) {
        this.vbr_q = qual;
        this.quant_comp = comp;
        this.quant_comp_s = compS;
        this.expY = y;
        this.st_lrm = shThreshold;
        this.st_s = shThresholdS;
        this.masking_adj = adj;
        this.masking_adj_short = adjShort;
        this.ath_lower = lower;
        this.ath_curve = curve;
        this.ath_sensitivity = sens;
        this.interch = inter;
        this.safejoint = joint;
        this.sfb21mod = mod;
        this.msfix = fix;
    }

    function ABRPresets(kbps, comp, compS,
                        joint, fix, shThreshold,
                        shThresholdS, bass, sc,
                        mask, lower, curve,
                        interCh, sfScale) {
        this.quant_comp = comp;
        this.quant_comp_s = compS;
        this.safejoint = joint;
        this.nsmsfix = fix;
        this.st_lrm = shThreshold;
        this.st_s = shThresholdS;
        this.nsbass = bass;
        this.scale = sc;
        this.masking_adj = mask;
        this.ath_lower = lower;
        this.ath_curve = curve;
        this.interch = interCh;
        this.sfscale = sfScale;
    }

    var lame;

    this.setModules = function (_lame) {
        lame = _lame;
    };

    /**
     * <PRE>
     * Switch mappings for VBR mode VBR_RH
     *             vbr_q  qcomp_l  qcomp_s  expY  st_lrm   st_s  mask adj_l  adj_s  ath_lower  ath_curve  ath_sens  interChR  safejoint sfb21mod  msfix
     * </PRE>
     */
    var vbr_old_switch_map = [
        new VBRPresets(0, 9, 9, 0, 5.20, 125.0, -4.2, -6.3, 4.8, 1, 0, 0, 2, 21, 0.97),
        new VBRPresets(1, 9, 9, 0, 5.30, 125.0, -3.6, -5.6, 4.5, 1.5, 0, 0, 2, 21, 1.35),
        new VBRPresets(2, 9, 9, 0, 5.60, 125.0, -2.2, -3.5, 2.8, 2, 0, 0, 2, 21, 1.49),
        new VBRPresets(3, 9, 9, 1, 5.80, 130.0, -1.8, -2.8, 2.6, 3, -4, 0, 2, 20, 1.64),
        new VBRPresets(4, 9, 9, 1, 6.00, 135.0, -0.7, -1.1, 1.1, 3.5, -8, 0, 2, 0, 1.79),
        new VBRPresets(5, 9, 9, 1, 6.40, 140.0, 0.5, 0.4, -7.5, 4, -12, 0.0002, 0, 0, 1.95),
        new VBRPresets(6, 9, 9, 1, 6.60, 145.0, 0.67, 0.65, -14.7, 6.5, -19, 0.0004, 0, 0, 2.30),
        new VBRPresets(7, 9, 9, 1, 6.60, 145.0, 0.8, 0.75, -19.7, 8, -22, 0.0006, 0, 0, 2.70),
        new VBRPresets(8, 9, 9, 1, 6.60, 145.0, 1.2, 1.15, -27.5, 10, -23, 0.0007, 0, 0, 0),
        new VBRPresets(9, 9, 9, 1, 6.60, 145.0, 1.6, 1.6, -36, 11, -25, 0.0008, 0, 0, 0),
        new VBRPresets(10, 9, 9, 1, 6.60, 145.0, 2.0, 2.0, -36, 12, -25, 0.0008, 0, 0, 0)
    ];

    /**
     * <PRE>
     *                 vbr_q  qcomp_l  qcomp_s  expY  st_lrm   st_s  mask adj_l  adj_s  ath_lower  ath_curve  ath_sens  interChR  safejoint sfb21mod  msfix
     * </PRE>
     */
    var vbr_psy_switch_map = [
        new VBRPresets(0, 9, 9, 0, 4.20, 25.0, -7.0, -4.0, 7.5, 1, 0, 0, 2, 26, 0.97),
        new VBRPresets(1, 9, 9, 0, 4.20, 25.0, -5.6, -3.6, 4.5, 1.5, 0, 0, 2, 21, 1.35),
        new VBRPresets(2, 9, 9, 0, 4.20, 25.0, -4.4, -1.8, 2, 2, 0, 0, 2, 18, 1.49),
        new VBRPresets(3, 9, 9, 1, 4.20, 25.0, -3.4, -1.25, 1.1, 3, -4, 0, 2, 15, 1.64),
        new VBRPresets(4, 9, 9, 1, 4.20, 25.0, -2.2, 0.1, 0, 3.5, -8, 0, 2, 0, 1.79),
        new VBRPresets(5, 9, 9, 1, 4.20, 25.0, -1.0, 1.65, -7.7, 4, -12, 0.0002, 0, 0, 1.95),
        new VBRPresets(6, 9, 9, 1, 4.20, 25.0, -0.0, 2.47, -7.7, 6.5, -19, 0.0004, 0, 0, 2),
        new VBRPresets(7, 9, 9, 1, 4.20, 25.0, 0.5, 2.0, -14.5, 8, -22, 0.0006, 0, 0, 2),
        new VBRPresets(8, 9, 9, 1, 4.20, 25.0, 1.0, 2.4, -22.0, 10, -23, 0.0007, 0, 0, 2),
        new VBRPresets(9, 9, 9, 1, 4.20, 25.0, 1.5, 2.95, -30.0, 11, -25, 0.0008, 0, 0, 2),
        new VBRPresets(10, 9, 9, 1, 4.20, 25.0, 2.0, 2.95, -36.0, 12, -30, 0.0008, 0, 0, 2)
    ];

    function apply_vbr_preset(gfp, a, enforce) {
        var vbr_preset = gfp.VBR == VbrMode$20.vbr_rh ? vbr_old_switch_map
            : vbr_psy_switch_map;

        var x = gfp.VBR_q_frac;
        var p = vbr_preset[a];
        var q = vbr_preset[a + 1];
        var set = p;

        // NOOP(vbr_q);
        // NOOP(quant_comp);
        // NOOP(quant_comp_s);
        // NOOP(expY);
        p.st_lrm = p.st_lrm + x * (q.st_lrm - p.st_lrm);
        // LERP(st_lrm);
        p.st_s = p.st_s + x * (q.st_s - p.st_s);
        // LERP(st_s);
        p.masking_adj = p.masking_adj + x * (q.masking_adj - p.masking_adj);
        // LERP(masking_adj);
        p.masking_adj_short = p.masking_adj_short + x
            * (q.masking_adj_short - p.masking_adj_short);
        // LERP(masking_adj_short);
        p.ath_lower = p.ath_lower + x * (q.ath_lower - p.ath_lower);
        // LERP(ath_lower);
        p.ath_curve = p.ath_curve + x * (q.ath_curve - p.ath_curve);
        // LERP(ath_curve);
        p.ath_sensitivity = p.ath_sensitivity + x
            * (q.ath_sensitivity - p.ath_sensitivity);
        // LERP(ath_sensitivity);
        p.interch = p.interch + x * (q.interch - p.interch);
        // LERP(interch);
        // NOOP(safejoint);
        // NOOP(sfb21mod);
        p.msfix = p.msfix + x * (q.msfix - p.msfix);
        // LERP(msfix);

        lame_set_VBR_q(gfp, set.vbr_q);

        if (enforce != 0)
            gfp.quant_comp = set.quant_comp;
        else if (!(Math.abs(gfp.quant_comp - -1) > 0))
            gfp.quant_comp = set.quant_comp;
        // SET_OPTION(quant_comp, set.quant_comp, -1);
        if (enforce != 0)
            gfp.quant_comp_short = set.quant_comp_s;
        else if (!(Math.abs(gfp.quant_comp_short - -1) > 0))
            gfp.quant_comp_short = set.quant_comp_s;
        // SET_OPTION(quant_comp_short, set.quant_comp_s, -1);
        if (set.expY != 0) {
            gfp.experimentalY = set.expY != 0;
        }
        if (enforce != 0)
            gfp.internal_flags.nsPsy.attackthre = set.st_lrm;
        else if (!(Math.abs(gfp.internal_flags.nsPsy.attackthre - -1) > 0))
            gfp.internal_flags.nsPsy.attackthre = set.st_lrm;
        // SET_OPTION(short_threshold_lrm, set.st_lrm, -1);
        if (enforce != 0)
            gfp.internal_flags.nsPsy.attackthre_s = set.st_s;
        else if (!(Math.abs(gfp.internal_flags.nsPsy.attackthre_s - -1) > 0))
            gfp.internal_flags.nsPsy.attackthre_s = set.st_s;
        // SET_OPTION(short_threshold_s, set.st_s, -1);
        if (enforce != 0)
            gfp.maskingadjust = set.masking_adj;
        else if (!(Math.abs(gfp.maskingadjust - 0) > 0))
            gfp.maskingadjust = set.masking_adj;
        // SET_OPTION(maskingadjust, set.masking_adj, 0);
        if (enforce != 0)
            gfp.maskingadjust_short = set.masking_adj_short;
        else if (!(Math.abs(gfp.maskingadjust_short - 0) > 0))
            gfp.maskingadjust_short = set.masking_adj_short;
        // SET_OPTION(maskingadjust_short, set.masking_adj_short, 0);
        if (enforce != 0)
            gfp.ATHlower = -set.ath_lower / 10.0;
        else if (!(Math.abs((-gfp.ATHlower * 10.0) - 0) > 0))
            gfp.ATHlower = -set.ath_lower / 10.0;
        // SET_OPTION(ATHlower, set.ath_lower, 0);
        if (enforce != 0)
            gfp.ATHcurve = set.ath_curve;
        else if (!(Math.abs(gfp.ATHcurve - -1) > 0))
            gfp.ATHcurve = set.ath_curve;
        // SET_OPTION(ATHcurve, set.ath_curve, -1);
        if (enforce != 0)
            gfp.athaa_sensitivity = set.ath_sensitivity;
        else if (!(Math.abs(gfp.athaa_sensitivity - -1) > 0))
            gfp.athaa_sensitivity = set.ath_sensitivity;
        // SET_OPTION(athaa_sensitivity, set.ath_sensitivity, 0);
        if (set.interch > 0) {
            if (enforce != 0)
                gfp.interChRatio = set.interch;
            else if (!(Math.abs(gfp.interChRatio - -1) > 0))
                gfp.interChRatio = set.interch;
            // SET_OPTION(interChRatio, set.interch, -1);
        }

        /* parameters for which there is no proper set/get interface */
        if (set.safejoint > 0) {
            gfp.exp_nspsytune = gfp.exp_nspsytune | set.safejoint;
        }
        if (set.sfb21mod > 0) {
            gfp.exp_nspsytune = gfp.exp_nspsytune | (set.sfb21mod << 20);
        }
        if (enforce != 0)
            gfp.msfix = set.msfix;
        else if (!(Math.abs(gfp.msfix - -1) > 0))
            gfp.msfix = set.msfix;
        // SET_OPTION(msfix, set.msfix, -1);

        if (enforce == 0) {
            gfp.VBR_q = a;
            gfp.VBR_q_frac = x;
        }
    }

    /**
     * <PRE>
     *  Switch mappings for ABR mode
     *
     *              kbps  quant q_s safejoint nsmsfix st_lrm  st_s  ns-bass scale   msk ath_lwr ath_curve  interch , sfscale
     * </PRE>
     */
    var abr_switch_map = [
        new ABRPresets(8, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, -30.0, 11, 0.0012, 1), /*   8, impossible to use in stereo */
        new ABRPresets(16, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, -25.0, 11, 0.0010, 1), /*  16 */
        new ABRPresets(24, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, -20.0, 11, 0.0010, 1), /*  24 */
        new ABRPresets(32, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, -15.0, 11, 0.0010, 1), /*  32 */
        new ABRPresets(40, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, -10.0, 11, 0.0009, 1), /*  40 */
        new ABRPresets(48, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, -10.0, 11, 0.0009, 1), /*  48 */
        new ABRPresets(56, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, -6.0, 11, 0.0008, 1), /*  56 */
        new ABRPresets(64, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, -2.0, 11, 0.0008, 1), /*  64 */
        new ABRPresets(80, 9, 9, 0, 0, 6.60, 145, 0, 0.95, 0, .0, 8, 0.0007, 1), /*  80 */
        new ABRPresets(96, 9, 9, 0, 2.50, 6.60, 145, 0, 0.95, 0, 1.0, 5.5, 0.0006, 1), /*  96 */
        new ABRPresets(112, 9, 9, 0, 2.25, 6.60, 145, 0, 0.95, 0, 2.0, 4.5, 0.0005, 1), /* 112 */
        new ABRPresets(128, 9, 9, 0, 1.95, 6.40, 140, 0, 0.95, 0, 3.0, 4, 0.0002, 1), /* 128 */
        new ABRPresets(160, 9, 9, 1, 1.79, 6.00, 135, 0, 0.95, -2, 5.0, 3.5, 0, 1), /* 160 */
        new ABRPresets(192, 9, 9, 1, 1.49, 5.60, 125, 0, 0.97, -4, 7.0, 3, 0, 0), /* 192 */
        new ABRPresets(224, 9, 9, 1, 1.25, 5.20, 125, 0, 0.98, -6, 9.0, 2, 0, 0), /* 224 */
        new ABRPresets(256, 9, 9, 1, 0.97, 5.20, 125, 0, 1.00, -8, 10.0, 1, 0, 0), /* 256 */
        new ABRPresets(320, 9, 9, 1, 0.90, 5.20, 125, 0, 1.00, -10, 12.0, 0, 0, 0)  /* 320 */
    ];

    function apply_abr_preset(gfp, preset, enforce) {
        /* Variables for the ABR stuff */
        var actual_bitrate = preset;

        var r = lame.nearestBitrateFullIndex(preset);

        gfp.VBR = VbrMode$20.vbr_abr;
        gfp.VBR_mean_bitrate_kbps = actual_bitrate;
        gfp.VBR_mean_bitrate_kbps = Math.min(gfp.VBR_mean_bitrate_kbps, 320);
        gfp.VBR_mean_bitrate_kbps = Math.max(gfp.VBR_mean_bitrate_kbps, 8);
        gfp.brate = gfp.VBR_mean_bitrate_kbps;
        if (gfp.VBR_mean_bitrate_kbps > 320) {
            gfp.disable_reservoir = true;
        }

        /* parameters for which there is no proper set/get interface */
        if (abr_switch_map[r].safejoint > 0)
            gfp.exp_nspsytune = gfp.exp_nspsytune | 2;
        /* safejoint */

        if (abr_switch_map[r].sfscale > 0) {
            gfp.internal_flags.noise_shaping = 2;
        }
        /* ns-bass tweaks */
        if (Math.abs(abr_switch_map[r].nsbass) > 0) {
            var k = (int)(abr_switch_map[r].nsbass * 4);
            if (k < 0)
                k += 64;
            gfp.exp_nspsytune = gfp.exp_nspsytune | (k << 2);
        }

        if (enforce != 0)
            gfp.quant_comp = abr_switch_map[r].quant_comp;
        else if (!(Math.abs(gfp.quant_comp - -1) > 0))
            gfp.quant_comp = abr_switch_map[r].quant_comp;
        // SET_OPTION(quant_comp, abr_switch_map[r].quant_comp, -1);
        if (enforce != 0)
            gfp.quant_comp_short = abr_switch_map[r].quant_comp_s;
        else if (!(Math.abs(gfp.quant_comp_short - -1) > 0))
            gfp.quant_comp_short = abr_switch_map[r].quant_comp_s;
        // SET_OPTION(quant_comp_short, abr_switch_map[r].quant_comp_s, -1);

        if (enforce != 0)
            gfp.msfix = abr_switch_map[r].nsmsfix;
        else if (!(Math.abs(gfp.msfix - -1) > 0))
            gfp.msfix = abr_switch_map[r].nsmsfix;
        // SET_OPTION(msfix, abr_switch_map[r].nsmsfix, -1);

        if (enforce != 0)
            gfp.internal_flags.nsPsy.attackthre = abr_switch_map[r].st_lrm;
        else if (!(Math.abs(gfp.internal_flags.nsPsy.attackthre - -1) > 0))
            gfp.internal_flags.nsPsy.attackthre = abr_switch_map[r].st_lrm;
        // SET_OPTION(short_threshold_lrm, abr_switch_map[r].st_lrm, -1);
        if (enforce != 0)
            gfp.internal_flags.nsPsy.attackthre_s = abr_switch_map[r].st_s;
        else if (!(Math.abs(gfp.internal_flags.nsPsy.attackthre_s - -1) > 0))
            gfp.internal_flags.nsPsy.attackthre_s = abr_switch_map[r].st_s;
        // SET_OPTION(short_threshold_s, abr_switch_map[r].st_s, -1);

        /*
         * ABR seems to have big problems with clipping, especially at low
         * bitrates
         */
        /*
         * so we compensate for that here by using a scale value depending on
         * bitrate
         */
        if (enforce != 0)
            gfp.scale = abr_switch_map[r].scale;
        else if (!(Math.abs(gfp.scale - -1) > 0))
            gfp.scale = abr_switch_map[r].scale;
        // SET_OPTION(scale, abr_switch_map[r].scale, -1);

        if (enforce != 0)
            gfp.maskingadjust = abr_switch_map[r].masking_adj;
        else if (!(Math.abs(gfp.maskingadjust - 0) > 0))
            gfp.maskingadjust = abr_switch_map[r].masking_adj;
        // SET_OPTION(maskingadjust, abr_switch_map[r].masking_adj, 0);
        if (abr_switch_map[r].masking_adj > 0) {
            if (enforce != 0)
                gfp.maskingadjust_short = (abr_switch_map[r].masking_adj * .9);
            else if (!(Math.abs(gfp.maskingadjust_short - 0) > 0))
                gfp.maskingadjust_short = (abr_switch_map[r].masking_adj * .9);
            // SET_OPTION(maskingadjust_short, abr_switch_map[r].masking_adj *
            // .9, 0);
        } else {
            if (enforce != 0)
                gfp.maskingadjust_short = (abr_switch_map[r].masking_adj * 1.1);
            else if (!(Math.abs(gfp.maskingadjust_short - 0) > 0))
                gfp.maskingadjust_short = (abr_switch_map[r].masking_adj * 1.1);
            // SET_OPTION(maskingadjust_short, abr_switch_map[r].masking_adj *
            // 1.1, 0);
        }

        if (enforce != 0)
            gfp.ATHlower = -abr_switch_map[r].ath_lower / 10.;
        else if (!(Math.abs((-gfp.ATHlower * 10.) - 0) > 0))
            gfp.ATHlower = -abr_switch_map[r].ath_lower / 10.;
        // SET_OPTION(ATHlower, abr_switch_map[r].ath_lower, 0);
        if (enforce != 0)
            gfp.ATHcurve = abr_switch_map[r].ath_curve;
        else if (!(Math.abs(gfp.ATHcurve - -1) > 0))
            gfp.ATHcurve = abr_switch_map[r].ath_curve;
        // SET_OPTION(ATHcurve, abr_switch_map[r].ath_curve, -1);

        if (enforce != 0)
            gfp.interChRatio = abr_switch_map[r].interch;
        else if (!(Math.abs(gfp.interChRatio - -1) > 0))
            gfp.interChRatio = abr_switch_map[r].interch;
        // SET_OPTION(interChRatio, abr_switch_map[r].interch, -1);

        return preset;
    }

    this.apply_preset = function(gfp, preset, enforce) {
        /* translate legacy presets */
        switch (preset) {
            case Lame.R3MIX:
            {
                preset = Lame.V3;
                gfp.VBR = VbrMode$20.vbr_mtrh;
                break;
            }
            case Lame.MEDIUM:
            {
                preset = Lame.V4;
                gfp.VBR = VbrMode$20.vbr_rh;
                break;
            }
            case Lame.MEDIUM_FAST:
            {
                preset = Lame.V4;
                gfp.VBR = VbrMode$20.vbr_mtrh;
                break;
            }
            case Lame.STANDARD:
            {
                preset = Lame.V2;
                gfp.VBR = VbrMode$20.vbr_rh;
                break;
            }
            case Lame.STANDARD_FAST:
            {
                preset = Lame.V2;
                gfp.VBR = VbrMode$20.vbr_mtrh;
                break;
            }
            case Lame.EXTREME:
            {
                preset = Lame.V0;
                gfp.VBR = VbrMode$20.vbr_rh;
                break;
            }
            case Lame.EXTREME_FAST:
            {
                preset = Lame.V0;
                gfp.VBR = VbrMode$20.vbr_mtrh;
                break;
            }
            case Lame.INSANE:
            {
                preset = 320;
                gfp.preset = preset;
                apply_abr_preset(gfp, preset, enforce);
                gfp.VBR = VbrMode$20.vbr_off;
                return preset;
            }
        }

        gfp.preset = preset;
        {
            switch (preset) {
                case Lame.V9:
                    apply_vbr_preset(gfp, 9, enforce);
                    return preset;
                case Lame.V8:
                    apply_vbr_preset(gfp, 8, enforce);
                    return preset;
                case Lame.V7:
                    apply_vbr_preset(gfp, 7, enforce);
                    return preset;
                case Lame.V6:
                    apply_vbr_preset(gfp, 6, enforce);
                    return preset;
                case Lame.V5:
                    apply_vbr_preset(gfp, 5, enforce);
                    return preset;
                case Lame.V4:
                    apply_vbr_preset(gfp, 4, enforce);
                    return preset;
                case Lame.V3:
                    apply_vbr_preset(gfp, 3, enforce);
                    return preset;
                case Lame.V2:
                    apply_vbr_preset(gfp, 2, enforce);
                    return preset;
                case Lame.V1:
                    apply_vbr_preset(gfp, 1, enforce);
                    return preset;
                case Lame.V0:
                    apply_vbr_preset(gfp, 0, enforce);
                    return preset;
                default:
                    break;
            }
        }
        if (8 <= preset && preset <= 320) {
            return apply_abr_preset(gfp, preset, enforce);
        }

        /* no corresponding preset found */
        gfp.preset = 0;
        return preset;
    };

    // Rest from getset.c:

    /**
     * VBR quality level.<BR>
     * 0 = highest<BR>
     * 9 = lowest
     */
    function lame_set_VBR_q(gfp, VBR_q) {
        var ret = 0;

        if (0 > VBR_q) {
            /* Unknown VBR quality level! */
            ret = -1;
            VBR_q = 0;
        }
        if (9 < VBR_q) {
            ret = -1;
            VBR_q = 9;
        }

        gfp.VBR_q = VBR_q;
        gfp.VBR_q_frac = 0;
        return ret;
    }

}

var Presets_1 = Presets$1;

function VBRQuantize() {
    var qupvt;
    var tak;

    this.setModules = function (_qupvt, _tk) {
        qupvt = _qupvt;
        tak = _tk;
    };
    //TODO

}

var VBRQuantize_1 = VBRQuantize;

//package mp3;

function CalcNoiseResult$1() {
    /**
     * sum of quantization noise > masking
     */
    this.over_noise = 0.;
    /**
     * sum of all quantization noise
     */
    this.tot_noise = 0.;
    /**
     * max quantization noise
     */
    this.max_noise = 0.;
    /**
     * number of quantization noise > masking
     */
    this.over_count = 0;
    /**
     * SSD-like cost of distorted bands
     */
    this.over_SSD = 0;
    this.bits = 0;
}

var CalcNoiseResult_1 = CalcNoiseResult$1;

var new_float$22 = common.new_float;
var new_int$22 = common.new_int;
function CalcNoiseData() {
    this.global_gain = 0;
    this.sfb_count1 = 0;
    this.step = new_int$22(39);
    this.noise = new_float$22(39);
    this.noise_log = new_float$22(39);
}

var CalcNoiseData_1 = CalcNoiseData;

/*
 * MP3 quantization
 *
 *      Copyright (c) 1999-2000 Mark Taylor
 *      Copyright (c) 1999-2003 Takehiro Tominaga
 *      Copyright (c) 2000-2007 Robert Hegemann
 *      Copyright (c) 2001-2005 Gabriel Bouvigne
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.     See the GNU
 * Library General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the
 * Free Software Foundation, Inc., 59 Temple Place - Suite 330,
 * Boston, MA 02111-1307, USA.
 */

/* $Id: Quantize.java,v 1.24 2011/05/24 20:48:06 kenchis Exp $ */

//package mp3;

//import java.util.Arrays;

var System$21 = common.System;
var VbrMode$21 = common.VbrMode;
var Util$21 = common.Util;
var Arrays$21 = common.Arrays;
var new_float$21 = common.new_float;
var assert$21 = common.assert;








function Quantize$1() {
    var bs;
    this.rv = null;
    var rv;
    this.qupvt = null;
    var qupvt;

    var vbr = new VBRQuantize_1();
    var tk;

    this.setModules = function (_bs, _rv, _qupvt, _tk) {
        bs = _bs;
        rv = _rv;
        this.rv = _rv;
        qupvt = _qupvt;
        this.qupvt = _qupvt;
        tk = _tk;
        vbr.setModules(qupvt, tk);
    };

    /**
     * convert from L/R <. Mid/Side
     */
    this.ms_convert = function (l3_side, gr) {
        for (var i = 0; i < 576; ++i) {
            var l = l3_side.tt[gr][0].xr[i];
            var r = l3_side.tt[gr][1].xr[i];
            l3_side.tt[gr][0].xr[i] = (l + r) * (Util$21.SQRT2 * 0.5);
            l3_side.tt[gr][1].xr[i] = (l - r) * (Util$21.SQRT2 * 0.5);
        }
    };

    /**
     * mt 6/99
     *
     * initializes cod_info, scalefac and xrpow
     *
     * returns 0 if all energies in xr are zero, else 1
     */
    function init_xrpow_core(cod_info, xrpow, upper, sum) {
        sum = 0;
        for (var i = 0; i <= upper; ++i) {
            var tmp = Math.abs(cod_info.xr[i]);
            sum += tmp;
            xrpow[i] = Math.sqrt(tmp * Math.sqrt(tmp));

            if (xrpow[i] > cod_info.xrpow_max)
                cod_info.xrpow_max = xrpow[i];
        }
        return sum;
    }

    this.init_xrpow = function (gfc, cod_info, xrpow) {
        var sum = 0;
        var upper = 0 | cod_info.max_nonzero_coeff;

        assert$21(xrpow != null);
        cod_info.xrpow_max = 0;

        /*
         * check if there is some energy we have to quantize and calculate xrpow
         * matching our fresh scalefactors
         */
        assert$21(0 <= upper && upper <= 575);

        Arrays$21.fill(xrpow, upper, 576, 0);

        sum = init_xrpow_core(cod_info, xrpow, upper, sum);

        /*
         * return 1 if we have something to quantize, else 0
         */
        if (sum > 1E-20) {
            var j = 0;
            if ((gfc.substep_shaping & 2) != 0)
                j = 1;

            for (var i = 0; i < cod_info.psymax; i++)
                gfc.pseudohalf[i] = j;

            return true;
        }

        Arrays$21.fill(cod_info.l3_enc, 0, 576, 0);
        return false;
    };

    /**
     * Gabriel Bouvigne feb/apr 2003<BR>
     * Analog silence detection in partitionned sfb21 or sfb12 for short blocks
     *
     * From top to bottom of sfb, changes to 0 coeffs which are below ath. It
     * stops on the first coeff higher than ath.
     */
    function psfb21_analogsilence(gfc, cod_info) {
        var ath = gfc.ATH;
        var xr = cod_info.xr;

        if (cod_info.block_type != Encoder_1.SHORT_TYPE) {
            /* NORM, START or STOP type, but not SHORT blocks */
            var stop = false;
            for (var gsfb = Encoder_1.PSFB21 - 1; gsfb >= 0 && !stop; gsfb--) {
                var start = gfc.scalefac_band.psfb21[gsfb];
                var end = gfc.scalefac_band.psfb21[gsfb + 1];
                var ath21 = qupvt.athAdjust(ath.adjust, ath.psfb21[gsfb],
                    ath.floor);

                if (gfc.nsPsy.longfact[21] > 1e-12)
                    ath21 *= gfc.nsPsy.longfact[21];

                for (var j = end - 1; j >= start; j--) {
                    if (Math.abs(xr[j]) < ath21)
                        xr[j] = 0;
                    else {
                        stop = true;
                        break;
                    }
                }
            }
        } else {
            /* note: short blocks coeffs are reordered */
            for (var block = 0; block < 3; block++) {
                var stop = false;
                for (var gsfb = Encoder_1.PSFB12 - 1; gsfb >= 0 && !stop; gsfb--) {
                    var start = gfc.scalefac_band.s[12]
                        * 3
                        + (gfc.scalefac_band.s[13] - gfc.scalefac_band.s[12])
                        * block
                        + (gfc.scalefac_band.psfb12[gsfb] - gfc.scalefac_band.psfb12[0]);
                    var end = start
                        + (gfc.scalefac_band.psfb12[gsfb + 1] - gfc.scalefac_band.psfb12[gsfb]);
                    var ath12 = qupvt.athAdjust(ath.adjust, ath.psfb12[gsfb],
                        ath.floor);

                    if (gfc.nsPsy.shortfact[12] > 1e-12)
                        ath12 *= gfc.nsPsy.shortfact[12];

                    for (var j = end - 1; j >= start; j--) {
                        if (Math.abs(xr[j]) < ath12)
                            xr[j] = 0;
                        else {
                            stop = true;
                            break;
                        }
                    }
                }
            }
        }

    }

    this.init_outer_loop = function (gfc, cod_info) {
        /*
         * initialize fresh cod_info
         */
        cod_info.part2_3_length = 0;
        cod_info.big_values = 0;
        cod_info.count1 = 0;
        cod_info.global_gain = 210;
        cod_info.scalefac_compress = 0;
        /* mixed_block_flag, block_type was set in psymodel.c */
        cod_info.table_select[0] = 0;
        cod_info.table_select[1] = 0;
        cod_info.table_select[2] = 0;
        cod_info.subblock_gain[0] = 0;
        cod_info.subblock_gain[1] = 0;
        cod_info.subblock_gain[2] = 0;
        cod_info.subblock_gain[3] = 0;
        /* this one is always 0 */
        cod_info.region0_count = 0;
        cod_info.region1_count = 0;
        cod_info.preflag = 0;
        cod_info.scalefac_scale = 0;
        cod_info.count1table_select = 0;
        cod_info.part2_length = 0;
        cod_info.sfb_lmax = Encoder_1.SBPSY_l;
        cod_info.sfb_smin = Encoder_1.SBPSY_s;
        cod_info.psy_lmax = gfc.sfb21_extra ? Encoder_1.SBMAX_l : Encoder_1.SBPSY_l;
        cod_info.psymax = cod_info.psy_lmax;
        cod_info.sfbmax = cod_info.sfb_lmax;
        cod_info.sfbdivide = 11;
        for (var sfb = 0; sfb < Encoder_1.SBMAX_l; sfb++) {
            cod_info.width[sfb] = gfc.scalefac_band.l[sfb + 1]
                - gfc.scalefac_band.l[sfb];
            /* which is always 0. */
            cod_info.window[sfb] = 3;
        }
        if (cod_info.block_type == Encoder_1.SHORT_TYPE) {
            var ixwork = new_float$21(576);

            cod_info.sfb_smin = 0;
            cod_info.sfb_lmax = 0;
            if (cod_info.mixed_block_flag != 0) {
                /*
                 * MPEG-1: sfbs 0-7 long block, 3-12 short blocks MPEG-2(.5):
                 * sfbs 0-5 long block, 3-12 short blocks
                 */
                cod_info.sfb_smin = 3;
                cod_info.sfb_lmax = gfc.mode_gr * 2 + 4;
            }
            cod_info.psymax = cod_info.sfb_lmax
                + 3
                * ((gfc.sfb21_extra ? Encoder_1.SBMAX_s : Encoder_1.SBPSY_s) - cod_info.sfb_smin);
            cod_info.sfbmax = cod_info.sfb_lmax + 3
                * (Encoder_1.SBPSY_s - cod_info.sfb_smin);
            cod_info.sfbdivide = cod_info.sfbmax - 18;
            cod_info.psy_lmax = cod_info.sfb_lmax;
            /* re-order the short blocks, for more efficient encoding below */
            /* By Takehiro TOMINAGA */
            /*
             * Within each scalefactor band, data is given for successive time
             * windows, beginning with window 0 and ending with window 2. Within
             * each window, the quantized values are then arranged in order of
             * increasing frequency...
             */
            var ix = gfc.scalefac_band.l[cod_info.sfb_lmax];
            System$21.arraycopy(cod_info.xr, 0, ixwork, 0, 576);
            for (var sfb = cod_info.sfb_smin; sfb < Encoder_1.SBMAX_s; sfb++) {
                var start = gfc.scalefac_band.s[sfb];
                var end = gfc.scalefac_band.s[sfb + 1];
                for (var window = 0; window < 3; window++) {
                    for (var l = start; l < end; l++) {
                        cod_info.xr[ix++] = ixwork[3 * l + window];
                    }
                }
            }

            var j = cod_info.sfb_lmax;
            for (var sfb = cod_info.sfb_smin; sfb < Encoder_1.SBMAX_s; sfb++) {
                cod_info.width[j] = cod_info.width[j + 1] = cod_info.width[j + 2] = gfc.scalefac_band.s[sfb + 1]
                    - gfc.scalefac_band.s[sfb];
                cod_info.window[j] = 0;
                cod_info.window[j + 1] = 1;
                cod_info.window[j + 2] = 2;
                j += 3;
            }
        }

        cod_info.count1bits = 0;
        cod_info.sfb_partition_table = qupvt.nr_of_sfb_block[0][0];
        cod_info.slen[0] = 0;
        cod_info.slen[1] = 0;
        cod_info.slen[2] = 0;
        cod_info.slen[3] = 0;

        cod_info.max_nonzero_coeff = 575;

        /*
         * fresh scalefactors are all zero
         */
        Arrays$21.fill(cod_info.scalefac, 0);

        psfb21_analogsilence(gfc, cod_info);
    };

    function BinSearchDirection(ordinal) {
        this.ordinal = ordinal;
    }

    BinSearchDirection.BINSEARCH_NONE = new BinSearchDirection(0);
    BinSearchDirection.BINSEARCH_UP = new BinSearchDirection(1);
    BinSearchDirection.BINSEARCH_DOWN = new BinSearchDirection(2);

    /**
     * author/date??
     *
     * binary step size search used by outer_loop to get a quantizer step size
     * to start with
     */
    function bin_search_StepSize(gfc, cod_info, desired_rate, ch, xrpow) {
        var nBits;
        var CurrentStep = gfc.CurrentStep[ch];
        var flagGoneOver = false;
        var start = gfc.OldValue[ch];
        var Direction = BinSearchDirection.BINSEARCH_NONE;
        cod_info.global_gain = start;
        desired_rate -= cod_info.part2_length;

        assert$21(CurrentStep != 0);
        for (; ;) {
            var step;
            nBits = tk.count_bits(gfc, xrpow, cod_info, null);

            if (CurrentStep == 1 || nBits == desired_rate)
                break;
            /* nothing to adjust anymore */

            if (nBits > desired_rate) {
                /* increase Quantize_StepSize */
                if (Direction == BinSearchDirection.BINSEARCH_DOWN)
                    flagGoneOver = true;

                if (flagGoneOver)
                    CurrentStep /= 2;
                Direction = BinSearchDirection.BINSEARCH_UP;
                step = CurrentStep;
            } else {
                /* decrease Quantize_StepSize */
                if (Direction == BinSearchDirection.BINSEARCH_UP)
                    flagGoneOver = true;

                if (flagGoneOver)
                    CurrentStep /= 2;
                Direction = BinSearchDirection.BINSEARCH_DOWN;
                step = -CurrentStep;
            }
            cod_info.global_gain += step;
            if (cod_info.global_gain < 0) {
                cod_info.global_gain = 0;
                flagGoneOver = true;
            }
            if (cod_info.global_gain > 255) {
                cod_info.global_gain = 255;
                flagGoneOver = true;
            }
        }

        assert$21(cod_info.global_gain >= 0);
        assert$21(cod_info.global_gain < 256);

        while (nBits > desired_rate && cod_info.global_gain < 255) {
            cod_info.global_gain++;
            nBits = tk.count_bits(gfc, xrpow, cod_info, null);
        }
        gfc.CurrentStep[ch] = (start - cod_info.global_gain >= 4) ? 4 : 2;
        gfc.OldValue[ch] = cod_info.global_gain;
        cod_info.part2_3_length = nBits;
        return nBits;
    }

    this.trancate_smallspectrums = function (gfc, gi, l3_xmin, work) {
        var distort = new_float$21(L3Side_1.SFBMAX);

        if ((0 == (gfc.substep_shaping & 4) && gi.block_type == Encoder_1.SHORT_TYPE)
            || (gfc.substep_shaping & 0x80) != 0)
            return;
        qupvt.calc_noise(gi, l3_xmin, distort, new CalcNoiseResult_1(), null);
        for (var j = 0; j < 576; j++) {
            var xr = 0.0;
            if (gi.l3_enc[j] != 0)
                xr = Math.abs(gi.xr[j]);
            work[j] = xr;
        }

        var j = 0;
        var sfb = 8;
        if (gi.block_type == Encoder_1.SHORT_TYPE)
            sfb = 6;
        do {
            var allowedNoise, trancateThreshold;
            var nsame, start;

            var width = gi.width[sfb];
            j += width;
            if (distort[sfb] >= 1.0)
                continue;

            Arrays$21.sort(work, j - width, width);
            if (BitStream.EQ(work[j - 1], 0.0))
                continue;
            /* all zero sfb */

            allowedNoise = (1.0 - distort[sfb]) * l3_xmin[sfb];
            trancateThreshold = 0.0;
            start = 0;
            do {
                var noise;
                for (nsame = 1; start + nsame < width; nsame++)
                    if (BitStream.NEQ(work[start + j - width], work[start + j
                        + nsame - width]))
                        break;

                noise = work[start + j - width] * work[start + j - width]
                    * nsame;
                if (allowedNoise < noise) {
                    if (start != 0)
                        trancateThreshold = work[start + j - width - 1];
                    break;
                }
                allowedNoise -= noise;
                start += nsame;
            } while (start < width);
            if (BitStream.EQ(trancateThreshold, 0.0))
                continue;

            do {
                if (Math.abs(gi.xr[j - width]) <= trancateThreshold)
                    gi.l3_enc[j - width] = 0;
            } while (--width > 0);
        } while (++sfb < gi.psymax);

        gi.part2_3_length = tk.noquant_count_bits(gfc, gi, null);
    };

    /**
     * author/date??
     *
     * Function: Returns zero if there is a scalefac which has not been
     * amplified. Otherwise it returns one.
     */
    function loop_break(cod_info) {
        for (var sfb = 0; sfb < cod_info.sfbmax; sfb++)
            if (cod_info.scalefac[sfb]
                + cod_info.subblock_gain[cod_info.window[sfb]] == 0)
                return false;

        return true;
    }

    /* mt 5/99: Function: Improved calc_noise for a single channel */

    function penalties(noise) {
        return Util$21.FAST_LOG10((0.368 + 0.632 * noise * noise * noise));
    }

    /**
     * author/date??
     *
     * several different codes to decide which quantization is better
     */
    function get_klemm_noise(distort, gi) {
        var klemm_noise = 1E-37;
        for (var sfb = 0; sfb < gi.psymax; sfb++)
            klemm_noise += penalties(distort[sfb]);

        return Math.max(1e-20, klemm_noise);
    }

    function quant_compare(quant_comp, best, calc, gi, distort) {
        /**
         * noise is given in decibels (dB) relative to masking thesholds.<BR>
         *
         * over_noise: ??? (the previous comment is fully wrong)<BR>
         * tot_noise: ??? (the previous comment is fully wrong)<BR>
         * max_noise: max quantization noise
         */
        var better;

        switch (quant_comp) {
            default:
            case 9:
            {
                if (best.over_count > 0) {
                    /* there are distorted sfb */
                    better = calc.over_SSD <= best.over_SSD;
                    if (calc.over_SSD == best.over_SSD)
                        better = calc.bits < best.bits;
                } else {
                    /* no distorted sfb */
                    better = ((calc.max_noise < 0) && ((calc.max_noise * 10 + calc.bits) <= (best.max_noise * 10 + best.bits)));
                }
                break;
            }

            case 0:
                better = calc.over_count < best.over_count
                    || (calc.over_count == best.over_count && calc.over_noise < best.over_noise)
                    || (calc.over_count == best.over_count
                    && BitStream.EQ(calc.over_noise, best.over_noise) && calc.tot_noise < best.tot_noise);
                break;

            case 8:
                calc.max_noise = get_klemm_noise(distort, gi);
            //$FALL-THROUGH$
            case 1:
                better = calc.max_noise < best.max_noise;
                break;
            case 2:
                better = calc.tot_noise < best.tot_noise;
                break;
            case 3:
                better = (calc.tot_noise < best.tot_noise)
                    && (calc.max_noise < best.max_noise);
                break;
            case 4:
                better = (calc.max_noise <= 0.0 && best.max_noise > 0.2)
                    || (calc.max_noise <= 0.0 && best.max_noise < 0.0
                    && best.max_noise > calc.max_noise - 0.2 && calc.tot_noise < best.tot_noise)
                    || (calc.max_noise <= 0.0 && best.max_noise > 0.0
                    && best.max_noise > calc.max_noise - 0.2 && calc.tot_noise < best.tot_noise
                    + best.over_noise)
                    || (calc.max_noise > 0.0 && best.max_noise > -0.05
                    && best.max_noise > calc.max_noise - 0.1 && calc.tot_noise
                    + calc.over_noise < best.tot_noise
                    + best.over_noise)
                    || (calc.max_noise > 0.0 && best.max_noise > -0.1
                    && best.max_noise > calc.max_noise - 0.15 && calc.tot_noise
                    + calc.over_noise + calc.over_noise < best.tot_noise
                    + best.over_noise + best.over_noise);
                break;
            case 5:
                better = calc.over_noise < best.over_noise
                    || (BitStream.EQ(calc.over_noise, best.over_noise) && calc.tot_noise < best.tot_noise);
                break;
            case 6:
                better = calc.over_noise < best.over_noise
                    || (BitStream.EQ(calc.over_noise, best.over_noise) && (calc.max_noise < best.max_noise || (BitStream
                        .EQ(calc.max_noise, best.max_noise) && calc.tot_noise <= best.tot_noise)));
                break;
            case 7:
                better = calc.over_count < best.over_count
                    || calc.over_noise < best.over_noise;
                break;
        }

        if (best.over_count == 0) {
            /*
             * If no distorted bands, only use this quantization if it is
             * better, and if it uses less bits. Unfortunately, part2_3_length
             * is sometimes a poor estimator of the final size at low bitrates.
             */
            better = better && calc.bits < best.bits;
        }

        return better;
    }

    /**
     * author/date??
     *
     * <PRE>
     *  Amplify the scalefactor bands that violate the masking threshold.
     *  See ISO 11172-3 Section C.1.5.4.3.5
     *
     *  distort[] = noise/masking
     *  distort[] > 1   ==> noise is not masked
     *  distort[] < 1   ==> noise is masked
     *  max_dist = maximum value of distort[]
     *
     *  Three algorithms:
     *  noise_shaping_amp
     *        0             Amplify all bands with distort[]>1.
     *
     *        1             Amplify all bands with distort[] >= max_dist^(.5);
     *                     ( 50% in the db scale)
     *
     *        2             Amplify first band with distort[] >= max_dist;
     *
     *
     *  For algorithms 0 and 1, if max_dist < 1, then amplify all bands
     *  with distort[] >= .95*max_dist.  This is to make sure we always
     *  amplify at least one band.
     * </PRE>
     */
    function amp_scalefac_bands(gfp, cod_info, distort, xrpow, bRefine) {
        var gfc = gfp.internal_flags;
        var ifqstep34;

        if (cod_info.scalefac_scale == 0) {
            ifqstep34 = 1.29683955465100964055;
            /* 2**(.75*.5) */
        } else {
            ifqstep34 = 1.68179283050742922612;
            /* 2**(.75*1) */
        }

        /* compute maximum value of distort[] */
        var trigger = 0;
        for (var sfb = 0; sfb < cod_info.sfbmax; sfb++) {
            if (trigger < distort[sfb])
                trigger = distort[sfb];
        }

        var noise_shaping_amp = gfc.noise_shaping_amp;
        if (noise_shaping_amp == 3) {
            if (bRefine)
                noise_shaping_amp = 2;
            else
                noise_shaping_amp = 1;
        }
        switch (noise_shaping_amp) {
            case 2:
                /* amplify exactly 1 band */
                break;

            case 1:
                /* amplify bands within 50% of max (on db scale) */
                if (trigger > 1.0)
                    trigger = Math.pow(trigger, .5);
                else
                    trigger *= .95;
                break;

            case 0:
            default:
                /* ISO algorithm. amplify all bands with distort>1 */
                if (trigger > 1.0)
                    trigger = 1.0;
                else
                    trigger *= .95;
                break;
        }

        var j = 0;
        for (var sfb = 0; sfb < cod_info.sfbmax; sfb++) {
            var width = cod_info.width[sfb];
            var l;
            j += width;
            if (distort[sfb] < trigger)
                continue;

            if ((gfc.substep_shaping & 2) != 0) {
                gfc.pseudohalf[sfb] = (0 == gfc.pseudohalf[sfb]) ? 1 : 0;
                if (0 == gfc.pseudohalf[sfb] && gfc.noise_shaping_amp == 2)
                    return;
            }
            cod_info.scalefac[sfb]++;
            for (l = -width; l < 0; l++) {
                xrpow[j + l] *= ifqstep34;
                if (xrpow[j + l] > cod_info.xrpow_max)
                    cod_info.xrpow_max = xrpow[j + l];
            }

            if (gfc.noise_shaping_amp == 2)
                return;
        }
    }

    /**
     * Takehiro Tominaga 2000-xx-xx
     *
     * turns on scalefac scale and adjusts scalefactors
     */
    function inc_scalefac_scale(cod_info, xrpow) {
        var ifqstep34 = 1.29683955465100964055;

        var j = 0;
        for (var sfb = 0; sfb < cod_info.sfbmax; sfb++) {
            var width = cod_info.width[sfb];
            var s = cod_info.scalefac[sfb];
            if (cod_info.preflag != 0)
                s += qupvt.pretab[sfb];
            j += width;
            if ((s & 1) != 0) {
                s++;
                for (var l = -width; l < 0; l++) {
                    xrpow[j + l] *= ifqstep34;
                    if (xrpow[j + l] > cod_info.xrpow_max)
                        cod_info.xrpow_max = xrpow[j + l];
                }
            }
            cod_info.scalefac[sfb] = s >> 1;
        }
        cod_info.preflag = 0;
        cod_info.scalefac_scale = 1;
    }

    /**
     * Takehiro Tominaga 2000-xx-xx
     *
     * increases the subblock gain and adjusts scalefactors
     */
    function inc_subblock_gain(gfc, cod_info, xrpow) {
        var sfb;
        var scalefac = cod_info.scalefac;

        /* subbloc_gain can't do anything in the long block region */
        for (sfb = 0; sfb < cod_info.sfb_lmax; sfb++) {
            if (scalefac[sfb] >= 16)
                return true;
        }

        for (var window = 0; window < 3; window++) {
            var s1 = 0;
            var s2 = 0;

            for (sfb = cod_info.sfb_lmax + window; sfb < cod_info.sfbdivide; sfb += 3) {
                if (s1 < scalefac[sfb])
                    s1 = scalefac[sfb];
            }
            for (; sfb < cod_info.sfbmax; sfb += 3) {
                if (s2 < scalefac[sfb])
                    s2 = scalefac[sfb];
            }

            if (s1 < 16 && s2 < 8)
                continue;

            if (cod_info.subblock_gain[window] >= 7)
                return true;

            /*
             * even though there is no scalefactor for sfb12 subblock gain
             * affects upper frequencies too, that's why we have to go up to
             * SBMAX_s
             */
            cod_info.subblock_gain[window]++;
            var j = gfc.scalefac_band.l[cod_info.sfb_lmax];
            for (sfb = cod_info.sfb_lmax + window; sfb < cod_info.sfbmax; sfb += 3) {
                var amp;
                var width = cod_info.width[sfb];
                var s = scalefac[sfb];
                assert$21(s >= 0);
                s = s - (4 >> cod_info.scalefac_scale);
                if (s >= 0) {
                    scalefac[sfb] = s;
                    j += width * 3;
                    continue;
                }

                scalefac[sfb] = 0;
                {
                    var gain = 210 + (s << (cod_info.scalefac_scale + 1));
                    amp = qupvt.IPOW20(gain);
                }
                j += width * (window + 1);
                for (var l = -width; l < 0; l++) {
                    xrpow[j + l] *= amp;
                    if (xrpow[j + l] > cod_info.xrpow_max)
                        cod_info.xrpow_max = xrpow[j + l];
                }
                j += width * (3 - window - 1);
            }

            {
                var amp = qupvt.IPOW20(202);
                j += cod_info.width[sfb] * (window + 1);
                for (var l = -cod_info.width[sfb]; l < 0; l++) {
                    xrpow[j + l] *= amp;
                    if (xrpow[j + l] > cod_info.xrpow_max)
                        cod_info.xrpow_max = xrpow[j + l];
                }
            }
        }
        return false;
    }

    /**
     * <PRE>
     *  Takehiro Tominaga /date??
     *  Robert Hegemann 2000-09-06: made a function of it
     *
     *  amplifies scalefactor bands,
     *   - if all are already amplified returns 0
     *   - if some bands are amplified too much:
     *      * try to increase scalefac_scale
     *      * if already scalefac_scale was set
     *          try on short blocks to increase subblock gain
     * </PRE>
     */
    function balance_noise(gfp, cod_info, distort, xrpow, bRefine) {
        var gfc = gfp.internal_flags;

        amp_scalefac_bands(gfp, cod_info, distort, xrpow, bRefine);

        /*
         * check to make sure we have not amplified too much loop_break returns
         * 0 if there is an unamplified scalefac scale_bitcount returns 0 if no
         * scalefactors are too large
         */

        var status = loop_break(cod_info);

        if (status)
            return false;
        /* all bands amplified */

        /*
         * not all scalefactors have been amplified. so these scalefacs are
         * possibly valid. encode them:
         */
        if (gfc.mode_gr == 2)
            status = tk.scale_bitcount(cod_info);
        else
            status = tk.scale_bitcount_lsf(gfc, cod_info);

        if (!status)
            return true;
        /* amplified some bands not exceeding limits */

        /*
         * some scalefactors are too large. lets try setting scalefac_scale=1
         */
        if (gfc.noise_shaping > 1) {
            Arrays$21.fill(gfc.pseudohalf, 0);
            if (0 == cod_info.scalefac_scale) {
                inc_scalefac_scale(cod_info, xrpow);
                status = false;
            } else {
                if (cod_info.block_type == Encoder_1.SHORT_TYPE
                    && gfc.subblock_gain > 0) {
                    status = (inc_subblock_gain(gfc, cod_info, xrpow) || loop_break(cod_info));
                }
            }
        }

        if (!status) {
            if (gfc.mode_gr == 2)
                status = tk.scale_bitcount(cod_info);
            else
                status = tk.scale_bitcount_lsf(gfc, cod_info);
        }
        return !status;
    }

    /**
     * <PRE>
     *  Function: The outer iteration loop controls the masking conditions
     *  of all scalefactorbands. It computes the best scalefac and
     *  global gain. This module calls the inner iteration loop
     *
     *  mt 5/99 completely rewritten to allow for bit reservoir control,
     *  mid/side channels with L/R or mid/side masking thresholds,
     *  and chooses best quantization instead of last quantization when
     *  no distortion free quantization can be found.
     *
     *  added VBR support mt 5/99
     *
     *  some code shuffle rh 9/00
     * </PRE>
     *
     * @param l3_xmin
     *            allowed distortion
     * @param xrpow
     *            coloured magnitudes of spectral
     * @param targ_bits
     *            maximum allowed bits
     */
    this.outer_loop = function (gfp, cod_info, l3_xmin, xrpow, ch, targ_bits) {
        var gfc = gfp.internal_flags;
        var cod_info_w = new GrInfo_1();
        var save_xrpow = new_float$21(576);
        var distort = new_float$21(L3Side_1.SFBMAX);
        var best_noise_info = new CalcNoiseResult_1();
        var better;
        var prev_noise = new CalcNoiseData_1();
        var best_part2_3_length = 9999999;
        var bEndOfSearch = false;
        var bRefine = false;
        var best_ggain_pass1 = 0;

        bin_search_StepSize(gfc, cod_info, targ_bits, ch, xrpow);

        if (0 == gfc.noise_shaping)
        /* fast mode, no noise shaping, we are ready */
            return 100;
        /* default noise_info.over_count */

        /* compute the distortion in this quantization */
        /* coefficients and thresholds both l/r (or both mid/side) */
        qupvt.calc_noise(cod_info, l3_xmin, distort, best_noise_info,
            prev_noise);
        best_noise_info.bits = cod_info.part2_3_length;

        cod_info_w.assign(cod_info);
        var age = 0;
        System$21.arraycopy(xrpow, 0, save_xrpow, 0, 576);

        while (!bEndOfSearch) {
            /* BEGIN MAIN LOOP */
            do {
                var noise_info = new CalcNoiseResult_1();
                var search_limit;
                var maxggain = 255;

                /*
                 * When quantization with no distorted bands is found, allow up
                 * to X new unsuccesful tries in serial. This gives us more
                 * possibilities for different quant_compare modes. Much more
                 * than 3 makes not a big difference, it is only slower.
                 */

                if ((gfc.substep_shaping & 2) != 0) {
                    search_limit = 20;
                } else {
                    search_limit = 3;
                }

                /*
                 * Check if the last scalefactor band is distorted. in VBR mode
                 * we can't get rid of the distortion, so quit now and VBR mode
                 * will try again with more bits. (makes a 10% speed increase,
                 * the files I tested were binary identical, 2000/05/20 Robert
                 * Hegemann) distort[] > 1 means noise > allowed noise
                 */
                if (gfc.sfb21_extra) {
                    if (distort[cod_info_w.sfbmax] > 1.0)
                        break;
                    if (cod_info_w.block_type == Encoder_1.SHORT_TYPE
                        && (distort[cod_info_w.sfbmax + 1] > 1.0 || distort[cod_info_w.sfbmax + 2] > 1.0))
                        break;
                }

                /* try a new scalefactor conbination on cod_info_w */
                if (!balance_noise(gfp, cod_info_w, distort, xrpow, bRefine))
                    break;
                if (cod_info_w.scalefac_scale != 0)
                    maxggain = 254;

                /*
                 * inner_loop starts with the initial quantization step computed
                 * above and slowly increases until the bits < huff_bits. Thus
                 * it is important not to start with too large of an inital
                 * quantization step. Too small is ok, but inner_loop will take
                 * longer
                 */
                var huff_bits = targ_bits - cod_info_w.part2_length;
                if (huff_bits <= 0)
                    break;

                /*
                 * increase quantizer stepsize until needed bits are below
                 * maximum
                 */
                while ((cod_info_w.part2_3_length = tk.count_bits(gfc, xrpow,
                    cod_info_w, prev_noise)) > huff_bits
                && cod_info_w.global_gain <= maxggain)
                    cod_info_w.global_gain++;

                if (cod_info_w.global_gain > maxggain)
                    break;

                if (best_noise_info.over_count == 0) {

                    while ((cod_info_w.part2_3_length = tk.count_bits(gfc,
                        xrpow, cod_info_w, prev_noise)) > best_part2_3_length
                    && cod_info_w.global_gain <= maxggain)
                        cod_info_w.global_gain++;

                    if (cod_info_w.global_gain > maxggain)
                        break;
                }

                /* compute the distortion in this quantization */
                qupvt.calc_noise(cod_info_w, l3_xmin, distort, noise_info,
                    prev_noise);
                noise_info.bits = cod_info_w.part2_3_length;

                /*
                 * check if this quantization is better than our saved
                 * quantization
                 */
                if (cod_info.block_type != Encoder_1.SHORT_TYPE) {
                    // NORM, START or STOP type
                    better = gfp.quant_comp;
                } else
                    better = gfp.quant_comp_short;

                better = quant_compare(better, best_noise_info, noise_info,
                    cod_info_w, distort) ? 1 : 0;

                /* save data so we can restore this quantization later */
                if (better != 0) {
                    best_part2_3_length = cod_info.part2_3_length;
                    best_noise_info = noise_info;
                    cod_info.assign(cod_info_w);
                    age = 0;
                    /* save data so we can restore this quantization later */
                    /* store for later reuse */
                    System$21.arraycopy(xrpow, 0, save_xrpow, 0, 576);
                } else {
                    /* early stop? */
                    if (gfc.full_outer_loop == 0) {
                        if (++age > search_limit
                            && best_noise_info.over_count == 0)
                            break;
                        if ((gfc.noise_shaping_amp == 3) && bRefine && age > 30)
                            break;
                        if ((gfc.noise_shaping_amp == 3)
                            && bRefine
                            && (cod_info_w.global_gain - best_ggain_pass1) > 15)
                            break;
                    }
                }
            } while ((cod_info_w.global_gain + cod_info_w.scalefac_scale) < 255);

            if (gfc.noise_shaping_amp == 3) {
                if (!bRefine) {
                    /* refine search */
                    cod_info_w.assign(cod_info);
                    System$21.arraycopy(save_xrpow, 0, xrpow, 0, 576);
                    age = 0;
                    best_ggain_pass1 = cod_info_w.global_gain;

                    bRefine = true;
                } else {
                    /* search already refined, stop */
                    bEndOfSearch = true;
                }

            } else {
                bEndOfSearch = true;
            }
        }

        assert$21((cod_info.global_gain + cod_info.scalefac_scale) <= 255);
        /*
         * finish up
         */
        if (gfp.VBR == VbrMode$21.vbr_rh || gfp.VBR == VbrMode$21.vbr_mtrh)
        /* restore for reuse on next try */
            System$21.arraycopy(save_xrpow, 0, xrpow, 0, 576);
        /*
         * do the 'substep shaping'
         */
        else if ((gfc.substep_shaping & 1) != 0)
            trancate_smallspectrums(gfc, cod_info, l3_xmin, xrpow);

        return best_noise_info.over_count;
    };

    /**
     * Robert Hegemann 2000-09-06
     *
     * update reservoir status after FINAL quantization/bitrate
     */
    this.iteration_finish_one = function (gfc, gr, ch) {
        var l3_side = gfc.l3_side;
        var cod_info = l3_side.tt[gr][ch];

        /*
         * try some better scalefac storage
         */
        tk.best_scalefac_store(gfc, gr, ch, l3_side);

        /*
         * best huffman_divide may save some bits too
         */
        if (gfc.use_best_huffman == 1)
            tk.best_huffman_divide(gfc, cod_info);

        /*
         * update reservoir status after FINAL quantization/bitrate
         */
        rv.ResvAdjust(gfc, cod_info);
    };

    /**
     *
     * 2000-09-04 Robert Hegemann
     *
     * @param l3_xmin
     *            allowed distortion of the scalefactor
     * @param xrpow
     *            coloured magnitudes of spectral values
     */
    this.VBR_encode_granule = function (gfp, cod_info, l3_xmin, xrpow, ch, min_bits, max_bits) {
        var gfc = gfp.internal_flags;
        var bst_cod_info = new GrInfo_1();
        var bst_xrpow = new_float$21(576);
        var Max_bits = max_bits;
        var real_bits = max_bits + 1;
        var this_bits = (max_bits + min_bits) / 2;
        var dbits, over, found = 0;
        var sfb21_extra = gfc.sfb21_extra;

        assert$21(Max_bits <= LameInternalFlags.MAX_BITS_PER_CHANNEL);
        Arrays$21.fill(bst_cod_info.l3_enc, 0);

        /*
         * search within round about 40 bits of optimal
         */
        do {
            assert$21(this_bits >= min_bits);
            assert$21(this_bits <= max_bits);
            assert$21(min_bits <= max_bits);

            if (this_bits > Max_bits - 42)
                gfc.sfb21_extra = false;
            else
                gfc.sfb21_extra = sfb21_extra;

            over = outer_loop(gfp, cod_info, l3_xmin, xrpow, ch, this_bits);

            /*
             * is quantization as good as we are looking for ? in this case: is
             * no scalefactor band distorted?
             */
            if (over <= 0) {
                found = 1;
                /*
                 * now we know it can be done with "real_bits" and maybe we can
                 * skip some iterations
                 */
                real_bits = cod_info.part2_3_length;

                /*
                 * store best quantization so far
                 */
                bst_cod_info.assign(cod_info);
                System$21.arraycopy(xrpow, 0, bst_xrpow, 0, 576);

                /*
                 * try with fewer bits
                 */
                max_bits = real_bits - 32;
                dbits = max_bits - min_bits;
                this_bits = (max_bits + min_bits) / 2;
            } else {
                /*
                 * try with more bits
                 */
                min_bits = this_bits + 32;
                dbits = max_bits - min_bits;
                this_bits = (max_bits + min_bits) / 2;

                if (found != 0) {
                    found = 2;
                    /*
                     * start again with best quantization so far
                     */
                    cod_info.assign(bst_cod_info);
                    System$21.arraycopy(bst_xrpow, 0, xrpow, 0, 576);
                }
            }
        } while (dbits > 12);

        gfc.sfb21_extra = sfb21_extra;

        /*
         * found=0 => nothing found, use last one found=1 => we just found the
         * best and left the loop found=2 => we restored a good one and have now
         * l3_enc to restore too
         */
        if (found == 2) {
            System$21.arraycopy(bst_cod_info.l3_enc, 0, cod_info.l3_enc, 0, 576);
        }
        assert$21(cod_info.part2_3_length <= Max_bits);
    };

    /**
     * Robert Hegemann 2000-09-05
     *
     * calculates * how many bits are available for analog silent granules * how
     * many bits to use for the lowest allowed bitrate * how many bits each
     * bitrate would provide
     */
    this.get_framebits = function (gfp, frameBits) {
        var gfc = gfp.internal_flags;

        /*
         * always use at least this many bits per granule per channel unless we
         * detect analog silence, see below
         */
        gfc.bitrate_index = gfc.VBR_min_bitrate;
        var bitsPerFrame = bs.getframebits(gfp);

        /*
         * bits for analog silence
         */
        gfc.bitrate_index = 1;
        bitsPerFrame = bs.getframebits(gfp);

        for (var i = 1; i <= gfc.VBR_max_bitrate; i++) {
            gfc.bitrate_index = i;
            var mb = new MeanBits(bitsPerFrame);
            frameBits[i] = rv.ResvFrameBegin(gfp, mb);
            bitsPerFrame = mb.bits;
        }
    };

    /* RH: this one needs to be overhauled sometime */

    /**
     * <PRE>
     *  2000-09-04 Robert Hegemann
     *
     *  * converts LR to MS coding when necessary
     *  * calculates allowed/adjusted quantization noise amounts
     *  * detects analog silent frames
     *
     *  some remarks:
     *  - lower masking depending on Quality setting
     *  - quality control together with adjusted ATH MDCT scaling
     *    on lower quality setting allocate more noise from
     *    ATH masking, and on higher quality setting allocate
     *    less noise from ATH masking.
     *  - experiments show that going more than 2dB over GPSYCHO's
     *    limits ends up in very annoying artefacts
     * </PRE>
     */
    this.VBR_old_prepare = function (gfp, pe, ms_ener_ratio, ratio, l3_xmin, frameBits, min_bits,
                                     max_bits, bands) {
        var gfc = gfp.internal_flags;

        var masking_lower_db, adjust = 0.0;
        var analog_silence = 1;
        var bits = 0;

        gfc.bitrate_index = gfc.VBR_max_bitrate;
        var avg = rv.ResvFrameBegin(gfp, new MeanBits(0)) / gfc.mode_gr;

        get_framebits(gfp, frameBits);

        for (var gr = 0; gr < gfc.mode_gr; gr++) {
            var mxb = qupvt.on_pe(gfp, pe, max_bits[gr], avg, gr, 0);
            if (gfc.mode_ext == Encoder_1.MPG_MD_MS_LR) {
                ms_convert(gfc.l3_side, gr);
                qupvt.reduce_side(max_bits[gr], ms_ener_ratio[gr], avg, mxb);
            }
            for (var ch = 0; ch < gfc.channels_out; ++ch) {
                var cod_info = gfc.l3_side.tt[gr][ch];

                if (cod_info.block_type != Encoder_1.SHORT_TYPE) {
                    // NORM, START or STOP type
                    adjust = 1.28 / (1 + Math
                            .exp(3.5 - pe[gr][ch] / 300.)) - 0.05;
                    masking_lower_db = gfc.PSY.mask_adjust - adjust;
                } else {
                    adjust = 2.56 / (1 + Math
                            .exp(3.5 - pe[gr][ch] / 300.)) - 0.14;
                    masking_lower_db = gfc.PSY.mask_adjust_short - adjust;
                }
                gfc.masking_lower = Math.pow(10.0,
                    masking_lower_db * 0.1);

                init_outer_loop(gfc, cod_info);
                bands[gr][ch] = qupvt.calc_xmin(gfp, ratio[gr][ch], cod_info,
                    l3_xmin[gr][ch]);
                if (bands[gr][ch] != 0)
                    analog_silence = 0;

                min_bits[gr][ch] = 126;

                bits += max_bits[gr][ch];
            }
        }
        for (var gr = 0; gr < gfc.mode_gr; gr++) {
            for (var ch = 0; ch < gfc.channels_out; ch++) {
                if (bits > frameBits[gfc.VBR_max_bitrate]) {
                    max_bits[gr][ch] *= frameBits[gfc.VBR_max_bitrate];
                    max_bits[gr][ch] /= bits;
                }
                if (min_bits[gr][ch] > max_bits[gr][ch])
                    min_bits[gr][ch] = max_bits[gr][ch];

            }
            /* for ch */
        }
        /* for gr */

        return analog_silence;
    };

    this.bitpressure_strategy = function (gfc, l3_xmin, min_bits, max_bits) {
        for (var gr = 0; gr < gfc.mode_gr; gr++) {
            for (var ch = 0; ch < gfc.channels_out; ch++) {
                var gi = gfc.l3_side.tt[gr][ch];
                var pxmin = l3_xmin[gr][ch];
                var pxminPos = 0;
                for (var sfb = 0; sfb < gi.psy_lmax; sfb++)
                    pxmin[pxminPos++] *= 1. + .029 * sfb * sfb
                        / Encoder_1.SBMAX_l / Encoder_1.SBMAX_l;

                if (gi.block_type == Encoder_1.SHORT_TYPE) {
                    for (var sfb = gi.sfb_smin; sfb < Encoder_1.SBMAX_s; sfb++) {
                        pxmin[pxminPos++] *= 1. + .029 * sfb * sfb
                            / Encoder_1.SBMAX_s / Encoder_1.SBMAX_s;
                        pxmin[pxminPos++] *= 1. + .029 * sfb * sfb
                            / Encoder_1.SBMAX_s / Encoder_1.SBMAX_s;
                        pxmin[pxminPos++] *= 1. + .029 * sfb * sfb
                            / Encoder_1.SBMAX_s / Encoder_1.SBMAX_s;
                    }
                }
                max_bits[gr][ch] = 0 | Math.max(min_bits[gr][ch],
                        0.9 * max_bits[gr][ch]);
            }
        }
    };

    this.VBR_new_prepare = function (gfp, pe, ratio, l3_xmin, frameBits, max_bits) {
        var gfc = gfp.internal_flags;

        var analog_silence = 1;
        var avg = 0, bits = 0;
        var maximum_framebits;

        if (!gfp.free_format) {
            gfc.bitrate_index = gfc.VBR_max_bitrate;

            var mb = new MeanBits(avg);
            rv.ResvFrameBegin(gfp, mb);
            avg = mb.bits;

            get_framebits(gfp, frameBits);
            maximum_framebits = frameBits[gfc.VBR_max_bitrate];
        } else {
            gfc.bitrate_index = 0;
            var mb = new MeanBits(avg);
            maximum_framebits = rv.ResvFrameBegin(gfp, mb);
            avg = mb.bits;
            frameBits[0] = maximum_framebits;
        }

        for (var gr = 0; gr < gfc.mode_gr; gr++) {
            qupvt.on_pe(gfp, pe, max_bits[gr], avg, gr, 0);
            if (gfc.mode_ext == Encoder_1.MPG_MD_MS_LR) {
                ms_convert(gfc.l3_side, gr);
            }
            for (var ch = 0; ch < gfc.channels_out; ++ch) {
                var cod_info = gfc.l3_side.tt[gr][ch];

                gfc.masking_lower = Math.pow(10.0,
                    gfc.PSY.mask_adjust * 0.1);

                init_outer_loop(gfc, cod_info);
                if (0 != qupvt.calc_xmin(gfp, ratio[gr][ch], cod_info,
                        l3_xmin[gr][ch]))
                    analog_silence = 0;

                bits += max_bits[gr][ch];
            }
        }
        for (var gr = 0; gr < gfc.mode_gr; gr++) {
            for (var ch = 0; ch < gfc.channels_out; ch++) {
                if (bits > maximum_framebits) {
                    max_bits[gr][ch] *= maximum_framebits;
                    max_bits[gr][ch] /= bits;
                }

            }
            /* for ch */
        }
        /* for gr */

        return analog_silence;
    };

    /**
     * calculates target bits for ABR encoding
     *
     * mt 2000/05/31
     */
    this.calc_target_bits = function (gfp, pe, ms_ener_ratio, targ_bits, analog_silence_bits, max_frame_bits) {
        var gfc = gfp.internal_flags;
        var l3_side = gfc.l3_side;
        var res_factor;
        var gr, ch, totbits, mean_bits = 0;

        gfc.bitrate_index = gfc.VBR_max_bitrate;
        var mb = new MeanBits(mean_bits);
        max_frame_bits[0] = rv.ResvFrameBegin(gfp, mb);
        mean_bits = mb.bits;

        gfc.bitrate_index = 1;
        mean_bits = bs.getframebits(gfp) - gfc.sideinfo_len * 8;
        analog_silence_bits[0] = mean_bits / (gfc.mode_gr * gfc.channels_out);

        mean_bits = gfp.VBR_mean_bitrate_kbps * gfp.framesize * 1000;
        if ((gfc.substep_shaping & 1) != 0)
            mean_bits *= 1.09;
        mean_bits /= gfp.out_samplerate;
        mean_bits -= gfc.sideinfo_len * 8;
        mean_bits /= (gfc.mode_gr * gfc.channels_out);

        /**
         * <PRE>
         *           res_factor is the percentage of the target bitrate that should
         *           be used on average.  the remaining bits are added to the
         *           bitreservoir and used for difficult to encode frames.
         *
         *           Since we are tracking the average bitrate, we should adjust
         *           res_factor "on the fly", increasing it if the average bitrate
         *           is greater than the requested bitrate, and decreasing it
         *           otherwise.  Reasonable ranges are from .9 to 1.0
         *
         *           Until we get the above suggestion working, we use the following
         *           tuning:
         *           compression ratio    res_factor
         *           5.5  (256kbps)         1.0      no need for bitreservoir
         *           11   (128kbps)         .93      7% held for reservoir
         *
         *           with linear interpolation for other values.
         * </PRE>
         */
        res_factor = .93 + .07 * (11.0 - gfp.compression_ratio)
            / (11.0 - 5.5);
        if (res_factor < .90)
            res_factor = .90;
        if (res_factor > 1.00)
            res_factor = 1.00;

        for (gr = 0; gr < gfc.mode_gr; gr++) {
            var sum = 0;
            for (ch = 0; ch < gfc.channels_out; ch++) {
                targ_bits[gr][ch] = (int)(res_factor * mean_bits);

                if (pe[gr][ch] > 700) {
                    var add_bits = (int)((pe[gr][ch] - 700) / 1.4);

                    var cod_info = l3_side.tt[gr][ch];
                    targ_bits[gr][ch] = (int)(res_factor * mean_bits);

                    /* short blocks use a little extra, no matter what the pe */
                    if (cod_info.block_type == Encoder_1.SHORT_TYPE) {
                        if (add_bits < mean_bits / 2)
                            add_bits = mean_bits / 2;
                    }
                    /* at most increase bits by 1.5*average */
                    if (add_bits > mean_bits * 3 / 2)
                        add_bits = mean_bits * 3 / 2;
                    else if (add_bits < 0)
                        add_bits = 0;

                    targ_bits[gr][ch] += add_bits;
                }
                if (targ_bits[gr][ch] > LameInternalFlags.MAX_BITS_PER_CHANNEL) {
                    targ_bits[gr][ch] = LameInternalFlags.MAX_BITS_PER_CHANNEL;
                }
                sum += targ_bits[gr][ch];
            }
            /* for ch */
            if (sum > LameInternalFlags.MAX_BITS_PER_GRANULE) {
                for (ch = 0; ch < gfc.channels_out; ++ch) {
                    targ_bits[gr][ch] *= LameInternalFlags.MAX_BITS_PER_GRANULE;
                    targ_bits[gr][ch] /= sum;
                }
            }
        }
        /* for gr */

        if (gfc.mode_ext == Encoder_1.MPG_MD_MS_LR)
            for (gr = 0; gr < gfc.mode_gr; gr++) {
                qupvt.reduce_side(targ_bits[gr], ms_ener_ratio[gr], mean_bits
                    * gfc.channels_out,
                    LameInternalFlags.MAX_BITS_PER_GRANULE);
            }

        /*
         * sum target bits
         */
        totbits = 0;
        for (gr = 0; gr < gfc.mode_gr; gr++) {
            for (ch = 0; ch < gfc.channels_out; ch++) {
                if (targ_bits[gr][ch] > LameInternalFlags.MAX_BITS_PER_CHANNEL)
                    targ_bits[gr][ch] = LameInternalFlags.MAX_BITS_PER_CHANNEL;
                totbits += targ_bits[gr][ch];
            }
        }

        /*
         * repartion target bits if needed
         */
        if (totbits > max_frame_bits[0]) {
            for (gr = 0; gr < gfc.mode_gr; gr++) {
                for (ch = 0; ch < gfc.channels_out; ch++) {
                    targ_bits[gr][ch] *= max_frame_bits[0];
                    targ_bits[gr][ch] /= totbits;
                }
            }
        }
    };

}

var Quantize_1 = Quantize$1;

/*
 *      bit reservoir source file
 *
 *      Copyright (c) 1999-2000 Mark Taylor
 *
 * This library is free software; you can redistribute it and/or
 * modify it under the terms of the GNU Lesser General Public
 * License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * This library is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU
 * Library General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public
 * License along with this library; if not, write to the
 * Free Software Foundation, Inc., 59 Temple Place - Suite 330,
 * Boston, MA 02111-1307, USA.
 */

/* $Id: Reservoir.java,v 1.9 2011/05/24 20:48:06 kenchis Exp $ */

//package mp3;

/**
 * ResvFrameBegin:<BR>
 * Called (repeatedly) at the beginning of a frame. Updates the maximum size of
 * the reservoir, and checks to make sure main_data_begin was set properly by
 * the formatter<BR>
 * Background information:
 * 
 * This is the original text from the ISO standard. Because of sooo many bugs
 * and irritations correcting comments are added in brackets []. A '^W' means
 * you should remove the last word.
 * 
 * <PRE>
 *  1. The following rule can be used to calculate the maximum
 *     number of bits used for one granule [^W frame]:<BR>
 *     At the highest possible bitrate of Layer III (320 kbps
 *     per stereo signal [^W^W^W], 48 kHz) the frames must be of
 *     [^W^W^W are designed to have] constant length, i.e.
 *     one buffer [^W^W the frame] length is:<BR>
 * 
 *         320 kbps * 1152/48 kHz = 7680 bit = 960 byte
 * 
 *     This value is used as the maximum buffer per channel [^W^W] at
 *     lower bitrates [than 320 kbps]. At 64 kbps mono or 128 kbps
 *     stereo the main granule length is 64 kbps * 576/48 kHz = 768 bit
 *     [per granule and channel] at 48 kHz sampling frequency.
 *     This means that there is a maximum deviation (short time buffer
 *     [= reservoir]) of 7680 - 2*2*768 = 4608 bits is allowed at 64 kbps.
 *     The actual deviation is equal to the number of bytes [with the
 *     meaning of octets] denoted by the main_data_end offset pointer.
 *     The actual maximum deviation is (2^9-1)*8 bit = 4088 bits
 *     [for MPEG-1 and (2^8-1)*8 bit for MPEG-2, both are hard limits].
 *     ... The xchange of buffer bits between the left and right channel
 *     is allowed without restrictions [exception: dual channel].
 *     Because of the [constructed] constraint on the buffer size
 *     main_data_end is always set to 0 in the case of bit_rate_index==14,
 *     i.e. data rate 320 kbps per stereo signal [^W^W^W]. In this case
 *     all data are allocated between adjacent header [^W sync] words
 *     [, i.e. there is no buffering at all].
 * </PRE>
 */


var assert$23 = common.assert;

function Reservoir$1() {
	var bs;

	this.setModules  = function(_bs) {
		bs = _bs;
	};

	this.ResvFrameBegin = function(gfp, mean_bits) {
		var gfc = gfp.internal_flags;
		var maxmp3buf;
		var l3_side = gfc.l3_side;

		var frameLength = bs.getframebits(gfp);
		mean_bits.bits = (frameLength - gfc.sideinfo_len * 8) / gfc.mode_gr;

		/**
		 * <PRE>
		 *  Meaning of the variables:
		 *      resvLimit: (0, 8, ..., 8*255 (MPEG-2), 8*511 (MPEG-1))
		 *          Number of bits can be stored in previous frame(s) due to
		 *          counter size constaints
		 *      maxmp3buf: ( ??? ... 8*1951 (MPEG-1 and 2), 8*2047 (MPEG-2.5))
		 *          Number of bits allowed to encode one frame (you can take 8*511 bit
		 *          from the bit reservoir and at most 8*1440 bit from the current
		 *          frame (320 kbps, 32 kHz), so 8*1951 bit is the largest possible
		 *          value for MPEG-1 and -2)
		 * 
		 *          maximum allowed granule/channel size times 4 = 8*2047 bits.,
		 *          so this is the absolute maximum supported by the format.
		 * 
		 * 
		 *      fullFrameBits:  maximum number of bits available for encoding
		 *                      the current frame.
		 * 
		 *      mean_bits:      target number of bits per granule.
		 * 
		 *      frameLength:
		 * 
		 *      gfc.ResvMax:   maximum allowed reservoir
		 * 
		 *      gfc.ResvSize:  current reservoir size
		 * 
		 *      l3_side.resvDrain_pre:
		 *         ancillary data to be added to previous frame:
		 *         (only usefull in VBR modes if it is possible to have
		 *         maxmp3buf < fullFrameBits)).  Currently disabled,
		 *         see #define NEW_DRAIN
		 *         2010-02-13: RH now enabled, it seems to be needed for CBR too,
		 *                     as there exists one example, where the FhG decoder
		 *                     can't decode a -b320 CBR file anymore.
		 * 
		 *      l3_side.resvDrain_post:
		 *         ancillary data to be added to this frame:
		 * 
		 * </PRE>
		 */

		/* main_data_begin has 9 bits in MPEG-1, 8 bits MPEG-2 */
		var resvLimit = (8 * 256) * gfc.mode_gr - 8;

		/*
		 * maximum allowed frame size. dont use more than this number of bits,
		 * even if the frame has the space for them:
		 */
		if (gfp.brate > 320) {
			/* in freeformat the buffer is constant */
			maxmp3buf = 8 * ((int) ((gfp.brate * 1000)
					/ (gfp.out_samplerate / 1152) / 8 + .5));
		} else {
			/*
			 * all mp3 decoders should have enough buffer to handle this value:
			 * size of a 320kbps 32kHz frame
			 */
			maxmp3buf = 8 * 1440;

			/*
			 * Bouvigne suggests this more lax interpretation of the ISO doc
			 * instead of using 8*960.
			 */

			if (gfp.strict_ISO) {
				maxmp3buf = 8 * ((int) (320000 / (gfp.out_samplerate / 1152) / 8 + .5));
			}
		}

		gfc.ResvMax = maxmp3buf - frameLength;
		if (gfc.ResvMax > resvLimit)
			gfc.ResvMax = resvLimit;
		if (gfc.ResvMax < 0 || gfp.disable_reservoir)
			gfc.ResvMax = 0;

		var fullFrameBits = mean_bits.bits * gfc.mode_gr
				+ Math.min(gfc.ResvSize, gfc.ResvMax);

		if (fullFrameBits > maxmp3buf)
			fullFrameBits = maxmp3buf;

		assert$23 (0 == gfc.ResvMax % 8);
		assert$23 (gfc.ResvMax >= 0);

		l3_side.resvDrain_pre = 0;

		// frame analyzer code
		if (gfc.pinfo != null) {
			/*
			 * expected bits per channel per granule [is this also right for
			 * mono/stereo, MPEG-1/2 ?]
			 */
			gfc.pinfo.mean_bits = mean_bits.bits / 2;
			gfc.pinfo.resvsize = gfc.ResvSize;
		}

		return fullFrameBits;
	};

	/**
	 * returns targ_bits: target number of bits to use for 1 granule<BR>
	 * extra_bits: amount extra available from reservoir<BR>
	 * Mark Taylor 4/99
	 */
	this.ResvMaxBits = function(gfp, mean_bits, targ_bits, cbr) {
		var gfc = gfp.internal_flags;
		var add_bits;
        var ResvSize = gfc.ResvSize, ResvMax = gfc.ResvMax;

		/* compensate the saved bits used in the 1st granule */
		if (cbr != 0)
			ResvSize += mean_bits;

		if ((gfc.substep_shaping & 1) != 0)
			ResvMax *= 0.9;

		targ_bits.bits = mean_bits;

		/* extra bits if the reservoir is almost full */
		if (ResvSize * 10 > ResvMax * 9) {
			add_bits = ResvSize - (ResvMax * 9) / 10;
			targ_bits.bits += add_bits;
			gfc.substep_shaping |= 0x80;
		} else {
			add_bits = 0;
			gfc.substep_shaping &= 0x7f;
			/*
			 * build up reservoir. this builds the reservoir a little slower
			 * than FhG. It could simple be mean_bits/15, but this was rigged to
			 * always produce 100 (the old value) at 128kbs
			 */
			if (!gfp.disable_reservoir && 0 == (gfc.substep_shaping & 1))
				targ_bits.bits -= .1 * mean_bits;
		}

		/* amount from the reservoir we are allowed to use. ISO says 6/10 */
		var extra_bits = (ResvSize < (gfc.ResvMax * 6) / 10 ? ResvSize
				: (gfc.ResvMax * 6) / 10);
		extra_bits -= add_bits;

		if (extra_bits < 0)
			extra_bits = 0;
		return extra_bits;
	};

	/**
	 * Called after a granule's bit allocation. Readjusts the size of the
	 * reservoir to reflect the granule's usage.
	 */
	this.ResvAdjust = function(gfc, gi) {
		gfc.ResvSize -= gi.part2_3_length + gi.part2_length;
	};

	/**
	 * Called after all granules in a frame have been allocated. Makes sure that
	 * the reservoir size is within limits, possibly by adding stuffing bits.
	 */
	this.ResvFrameEnd = function(gfc, mean_bits) {
		var over_bits;
		var l3_side = gfc.l3_side;

		gfc.ResvSize += mean_bits * gfc.mode_gr;
		var stuffingBits = 0;
		l3_side.resvDrain_post = 0;
		l3_side.resvDrain_pre = 0;

		/* we must be byte aligned */
		if ((over_bits = gfc.ResvSize % 8) != 0)
			stuffingBits += over_bits;

		over_bits = (gfc.ResvSize - stuffingBits) - gfc.ResvMax;
		if (over_bits > 0) {
			assert$23 (0 == over_bits % 8);
			assert$23 (over_bits >= 0);
			stuffingBits += over_bits;
		}

		/*
		 * NOTE: enabling the NEW_DRAIN code fixes some problems with FhG
		 * decoder shipped with MS Windows operating systems. Using this, it is
		 * even possible to use Gabriel's lax buffer consideration again, which
		 * assumes, any decoder should have a buffer large enough for a 320 kbps
		 * frame at 32 kHz sample rate.
		 * 
		 * old drain code: lame -b320 BlackBird.wav --. does not play with
		 * GraphEdit.exe using FhG decoder V1.5 Build 50
		 * 
		 * new drain code: lame -b320 BlackBird.wav --. plays fine with
		 * GraphEdit.exe using FhG decoder V1.5 Build 50
		 * 
		 * Robert Hegemann, 2010-02-13.
		 */
		/*
		 * drain as many bits as possible into previous frame ancillary data In
		 * particular, in VBR mode ResvMax may have changed, and we have to make
		 * sure main_data_begin does not create a reservoir bigger than ResvMax
		 * mt 4/00
		 */
		{
			var mdb_bytes = Math.min(l3_side.main_data_begin * 8, stuffingBits) / 8;
			l3_side.resvDrain_pre += 8 * mdb_bytes;
			stuffingBits -= 8 * mdb_bytes;
			gfc.ResvSize -= 8 * mdb_bytes;
			l3_side.main_data_begin -= mdb_bytes;
		}
		/* drain the rest into this frames ancillary data */
		l3_side.resvDrain_post += stuffingBits;
		gfc.ResvSize -= stuffingBits;
	};
}

var Reservoir_1 = Reservoir$1;

function Version() {

    /**
     * URL for the LAME website.
     */
    var LAME_URL = "http://www.mp3dev.org/";

    /**
     * Major version number.
     */
    var LAME_MAJOR_VERSION = 3;
    /**
     * Minor version number.
     */
    var LAME_MINOR_VERSION = 98;
    /**
     * Patch level.
     */
    var LAME_PATCH_VERSION = 4;

    /**
     * Major version number.
     */
    var PSY_MAJOR_VERSION = 0;
    /**
     * Minor version number.
     */
    var PSY_MINOR_VERSION = 93;

    /**
     * A string which describes the version of LAME.
     *
     * @return string which describes the version of LAME
     */
    this.getLameVersion = function () {
        // primary to write screen reports
        return (LAME_MAJOR_VERSION + "." + LAME_MINOR_VERSION + "." + LAME_PATCH_VERSION);
    };

    /**
     * The short version of the LAME version string.
     *
     * @return short version of the LAME version string
     */
    this.getLameShortVersion = function () {
        // Adding date and time to version string makes it harder for output
        // validation
        return (LAME_MAJOR_VERSION + "." + LAME_MINOR_VERSION + "." + LAME_PATCH_VERSION);
    };

    /**
     * The shortest version of the LAME version string.
     *
     * @return shortest version of the LAME version string
     */
    this.getLameVeryShortVersion = function () {
        // Adding date and time to version string makes it harder for output
        return ("LAME" + LAME_MAJOR_VERSION + "." + LAME_MINOR_VERSION + "r");
    };

    /**
     * String which describes the version of GPSYCHO
     *
     * @return string which describes the version of GPSYCHO
     */
    this.getPsyVersion = function () {
        return (PSY_MAJOR_VERSION + "." + PSY_MINOR_VERSION);
    };

    /**
     * String which is a URL for the LAME website.
     *
     * @return string which is a URL for the LAME website
     */
    this.getLameUrl = function () {
        return LAME_URL;
    };

    /**
     * Quite useless for a java version, however we are compatible ;-)
     *
     * @return "32bits"
     */
    this.getLameOsBitness = function () {
        return "32bits";
    };

}

var Version_1 = Version;

var System$22 = common.System;
var VbrMode$22 = common.VbrMode;
var ShortBlock$22 = common.ShortBlock;
var Arrays$22 = common.Arrays;
var new_byte$22 = common.new_byte;
var assert$24 = common.assert;

/**
 * A Vbr header may be present in the ancillary data field of the first frame of
 * an mp3 bitstream<BR>
 * The Vbr header (optionally) contains
 * <UL>
 * <LI>frames total number of audio frames in the bitstream
 * <LI>bytes total number of bytes in the bitstream
 * <LI>toc table of contents
 * </UL>
 *
 * toc (table of contents) gives seek points for random access.<BR>
 * The ith entry determines the seek point for i-percent duration.<BR>
 * seek point in bytes = (toc[i]/256.0) * total_bitstream_bytes<BR>
 * e.g. half duration seek point = (toc[50]/256.0) * total_bitstream_bytes
 */
VBRTag.NUMTOCENTRIES = 100;
VBRTag.MAXFRAMESIZE = 2880;

function VBRTag() {

    var lame;
    var bs;
    var v;

    this.setModules = function (_lame, _bs, _v) {
        lame = _lame;
        bs = _bs;
        v = _v;
    };

    var FRAMES_FLAG = 0x0001;
    var BYTES_FLAG = 0x0002;
    var TOC_FLAG = 0x0004;
    var VBR_SCALE_FLAG = 0x0008;

    var NUMTOCENTRIES = VBRTag.NUMTOCENTRIES;

    /**
     * (0xB40) the max freeformat 640 32kHz framesize.
     */
    var MAXFRAMESIZE = VBRTag.MAXFRAMESIZE;

    /**
     * <PRE>
     *    4 bytes for Header Tag
     *    4 bytes for Header Flags
     *  100 bytes for entry (toc)
     *    4 bytes for frame size
     *    4 bytes for stream size
     *    4 bytes for VBR scale. a VBR quality indicator: 0=best 100=worst
     *   20 bytes for LAME tag.  for example, "LAME3.12 (beta 6)"
     * ___________
     *  140 bytes
     * </PRE>
     */
    var VBRHEADERSIZE = (NUMTOCENTRIES + 4 + 4 + 4 + 4 + 4);

    var LAMEHEADERSIZE = (VBRHEADERSIZE + 9 + 1 + 1 + 8
    + 1 + 1 + 3 + 1 + 1 + 2 + 4 + 2 + 2);

    /**
     * The size of the Xing header MPEG-1, bit rate in kbps.
     */
    var XING_BITRATE1 = 128;
    /**
     * The size of the Xing header MPEG-2, bit rate in kbps.
     */
    var XING_BITRATE2 = 64;
    /**
     * The size of the Xing header MPEG-2.5, bit rate in kbps.
     */
    var XING_BITRATE25 = 32;

    /**
     * ISO-8859-1 charset for byte to string operations.
     */
    var ISO_8859_1 = null; //Charset.forName("ISO-8859-1");

    /**
     * VBR header magic string.
     */
    var VBRTag0 = "Xing";
    /**
     * VBR header magic string (VBR == VBRMode.vbr_off).
     */
    var VBRTag1 = "Info";

    /**
     * Lookup table for fast CRC-16 computation. Uses the polynomial
     * x^16+x^15+x^2+1
     */
    var crc16Lookup = [0x0000, 0xC0C1, 0xC181, 0x0140,
        0xC301, 0x03C0, 0x0280, 0xC241, 0xC601, 0x06C0, 0x0780, 0xC741,
        0x0500, 0xC5C1, 0xC481, 0x0440, 0xCC01, 0x0CC0, 0x0D80, 0xCD41,
        0x0F00, 0xCFC1, 0xCE81, 0x0E40, 0x0A00, 0xCAC1, 0xCB81, 0x0B40,
        0xC901, 0x09C0, 0x0880, 0xC841, 0xD801, 0x18C0, 0x1980, 0xD941,
        0x1B00, 0xDBC1, 0xDA81, 0x1A40, 0x1E00, 0xDEC1, 0xDF81, 0x1F40,
        0xDD01, 0x1DC0, 0x1C80, 0xDC41, 0x1400, 0xD4C1, 0xD581, 0x1540,
        0xD701, 0x17C0, 0x1680, 0xD641, 0xD201, 0x12C0, 0x1380, 0xD341,
        0x1100, 0xD1C1, 0xD081, 0x1040, 0xF001, 0x30C0, 0x3180, 0xF141,
        0x3300, 0xF3C1, 0xF281, 0x3240, 0x3600, 0xF6C1, 0xF781, 0x3740,
        0xF501, 0x35C0, 0x3480, 0xF441, 0x3C00, 0xFCC1, 0xFD81, 0x3D40,
        0xFF01, 0x3FC0, 0x3E80, 0xFE41, 0xFA01, 0x3AC0, 0x3B80, 0xFB41,
        0x3900, 0xF9C1, 0xF881, 0x3840, 0x2800, 0xE8C1, 0xE981, 0x2940,
        0xEB01, 0x2BC0, 0x2A80, 0xEA41, 0xEE01, 0x2EC0, 0x2F80, 0xEF41,
        0x2D00, 0xEDC1, 0xEC81, 0x2C40, 0xE401, 0x24C0, 0x2580, 0xE541,
        0x2700, 0xE7C1, 0xE681, 0x2640, 0x2200, 0xE2C1, 0xE381, 0x2340,
        0xE101, 0x21C0, 0x2080, 0xE041, 0xA001, 0x60C0, 0x6180, 0xA141,
        0x6300, 0xA3C1, 0xA281, 0x6240, 0x6600, 0xA6C1, 0xA781, 0x6740,
        0xA501, 0x65C0, 0x6480, 0xA441, 0x6C00, 0xACC1, 0xAD81, 0x6D40,
        0xAF01, 0x6FC0, 0x6E80, 0xAE41, 0xAA01, 0x6AC0, 0x6B80, 0xAB41,
        0x6900, 0xA9C1, 0xA881, 0x6840, 0x7800, 0xB8C1, 0xB981, 0x7940,
        0xBB01, 0x7BC0, 0x7A80, 0xBA41, 0xBE01, 0x7EC0, 0x7F80, 0xBF41,
        0x7D00, 0xBDC1, 0xBC81, 0x7C40, 0xB401, 0x74C0, 0x7580, 0xB541,
        0x7700, 0xB7C1, 0xB681, 0x7640, 0x7200, 0xB2C1, 0xB381, 0x7340,
        0xB101, 0x71C0, 0x7080, 0xB041, 0x5000, 0x90C1, 0x9181, 0x5140,
        0x9301, 0x53C0, 0x5280, 0x9241, 0x9601, 0x56C0, 0x5780, 0x9741,
        0x5500, 0x95C1, 0x9481, 0x5440, 0x9C01, 0x5CC0, 0x5D80, 0x9D41,
        0x5F00, 0x9FC1, 0x9E81, 0x5E40, 0x5A00, 0x9AC1, 0x9B81, 0x5B40,
        0x9901, 0x59C0, 0x5880, 0x9841, 0x8801, 0x48C0, 0x4980, 0x8941,
        0x4B00, 0x8BC1, 0x8A81, 0x4A40, 0x4E00, 0x8EC1, 0x8F81, 0x4F40,
        0x8D01, 0x4DC0, 0x4C80, 0x8C41, 0x4400, 0x84C1, 0x8581, 0x4540,
        0x8701, 0x47C0, 0x4680, 0x8641, 0x8201, 0x42C0, 0x4380, 0x8341,
        0x4100, 0x81C1, 0x8081, 0x4040];

    /***********************************************************************
     * Robert Hegemann 2001-01-17
     ***********************************************************************/

    function addVbr(v, bitrate) {
        v.nVbrNumFrames++;
        v.sum += bitrate;
        v.seen++;

        if (v.seen < v.want) {
            return;
        }

        if (v.pos < v.size) {
            v.bag[v.pos] = v.sum;
            v.pos++;
            v.seen = 0;
        }
        if (v.pos == v.size) {
            for (var i = 1; i < v.size; i += 2) {
                v.bag[i / 2] = v.bag[i];
            }
            v.want *= 2;
            v.pos /= 2;
        }
    }

    function xingSeekTable(v, t) {
        if (v.pos <= 0)
            return;

        for (var i = 1; i < NUMTOCENTRIES; ++i) {
            var j = i / NUMTOCENTRIES, act, sum;
            var indx = 0 | (Math.floor(j * v.pos));
            if (indx > v.pos - 1)
                indx = v.pos - 1;
            act = v.bag[indx];
            sum = v.sum;
            var seek_point = 0 | (256. * act / sum);
            if (seek_point > 255)
                seek_point = 255;
            t[i] = 0xff & seek_point;
        }
    }

    /**
     * Add VBR entry, used to fill the VBR TOC entries.
     *
     * @param gfp
     *            global flags
     */
    this.addVbrFrame = function (gfp) {
        var gfc = gfp.internal_flags;
        var kbps = Tables.bitrate_table[gfp.version][gfc.bitrate_index];
        assert$24(gfc.VBR_seek_table.bag != null);
        addVbr(gfc.VBR_seek_table, kbps);
    };

    /**
     * Read big endian integer (4-bytes) from header.
     *
     * @param buf
     *            header containing the integer
     * @param bufPos
     *            offset into the header
     * @return extracted integer
     */
    function extractInteger(buf, bufPos) {
        var x = buf[bufPos + 0] & 0xff;
        x <<= 8;
        x |= buf[bufPos + 1] & 0xff;
        x <<= 8;
        x |= buf[bufPos + 2] & 0xff;
        x <<= 8;
        x |= buf[bufPos + 3] & 0xff;
        return x;
    }

    /**
     * Write big endian integer (4-bytes) in the header.
     *
     * @param buf
     *            header to write the integer into
     * @param bufPos
     *            offset into the header
     * @param value
     *            integer value to write
     */
    function createInteger(buf, bufPos, value) {
        buf[bufPos + 0] = 0xff & ((value >> 24) & 0xff);
        buf[bufPos + 1] = 0xff & ((value >> 16) & 0xff);
        buf[bufPos + 2] = 0xff & ((value >> 8) & 0xff);
        buf[bufPos + 3] = 0xff & (value & 0xff);
    }

    /**
     * Write big endian short (2-bytes) in the header.
     *
     * @param buf
     *            header to write the integer into
     * @param bufPos
     *            offset into the header
     * @param value
     *            integer value to write
     */
    function createShort(buf, bufPos, value) {
        buf[bufPos + 0] = 0xff & ((value >> 8) & 0xff);
        buf[bufPos + 1] = 0xff & (value & 0xff);
    }

    /**
     * Check for magic strings (Xing/Info).
     *
     * @param buf
     *            header to check
     * @param bufPos
     *            header offset to check
     * @return magic string found
     */
    function isVbrTag(buf, bufPos) {
        return new String(buf, bufPos, VBRTag0.length(), ISO_8859_1)
                .equals(VBRTag0)
            || new String(buf, bufPos, VBRTag1.length(), ISO_8859_1)
                .equals(VBRTag1);
    }

    function shiftInBitsValue(x, n, v) {
        return 0xff & ((x << n) | (v & ~(-1 << n)));
    }

    /**
     * Construct the MP3 header using the settings of the global flags.
     *
     * <img src="1000px-Mp3filestructure.svg.png">
     *
     * @param gfp
     *            global flags
     * @param buffer
     *            header
     */
    function setLameTagFrameHeader(gfp, buffer) {
        var gfc = gfp.internal_flags;

        // MP3 Sync Word
        buffer[0] = shiftInBitsValue(buffer[0], 8, 0xff);

        buffer[1] = shiftInBitsValue(buffer[1], 3, 7);
        buffer[1] = shiftInBitsValue(buffer[1], 1,
            (gfp.out_samplerate < 16000) ? 0 : 1);
        // Version
        buffer[1] = shiftInBitsValue(buffer[1], 1, gfp.version);
        // 01 == Layer 3
        buffer[1] = shiftInBitsValue(buffer[1], 2, 4 - 3);
        // Error protection
        buffer[1] = shiftInBitsValue(buffer[1], 1, (!gfp.error_protection) ? 1
            : 0);

        // Bit rate
        buffer[2] = shiftInBitsValue(buffer[2], 4, gfc.bitrate_index);
        // Frequency
        buffer[2] = shiftInBitsValue(buffer[2], 2, gfc.samplerate_index);
        // Pad. Bit
        buffer[2] = shiftInBitsValue(buffer[2], 1, 0);
        // Priv. Bit
        buffer[2] = shiftInBitsValue(buffer[2], 1, gfp.extension);

        // Mode
        buffer[3] = shiftInBitsValue(buffer[3], 2, gfp.mode.ordinal());
        // Mode extension (Used with Joint Stereo)
        buffer[3] = shiftInBitsValue(buffer[3], 2, gfc.mode_ext);
        // Copy
        buffer[3] = shiftInBitsValue(buffer[3], 1, gfp.copyright);
        // Original
        buffer[3] = shiftInBitsValue(buffer[3], 1, gfp.original);
        // Emphasis
        buffer[3] = shiftInBitsValue(buffer[3], 2, gfp.emphasis);

        /* the default VBR header. 48 kbps layer III, no padding, no crc */
        /* but sampling freq, mode and copyright/copy protection taken */
        /* from first valid frame */
        buffer[0] = 0xff;
        var abyte = 0xff & (buffer[1] & 0xf1);
        var bitrate;
        if (1 == gfp.version) {
            bitrate = XING_BITRATE1;
        } else {
            if (gfp.out_samplerate < 16000)
                bitrate = XING_BITRATE25;
            else
                bitrate = XING_BITRATE2;
        }

        if (gfp.VBR == VbrMode$22.vbr_off)
            bitrate = gfp.brate;

        var bbyte;
        if (gfp.free_format)
            bbyte = 0x00;
        else
            bbyte = 0xff & (16 * lame.BitrateIndex(bitrate, gfp.version,
                    gfp.out_samplerate));

        /*
         * Use as much of the info from the real frames in the Xing header:
         * samplerate, channels, crc, etc...
         */
        if (gfp.version == 1) {
            /* MPEG1 */
            buffer[1] = 0xff & (abyte | 0x0a);
            /* was 0x0b; */
            abyte = 0xff & (buffer[2] & 0x0d);
            /* AF keep also private bit */
            buffer[2] = 0xff & (bbyte | abyte);
            /* 64kbs MPEG1 frame */
        } else {
            /* MPEG2 */
            buffer[1] = 0xff & (abyte | 0x02);
            /* was 0x03; */
            abyte = 0xff & (buffer[2] & 0x0d);
            /* AF keep also private bit */
            buffer[2] = 0xff & (bbyte | abyte);
            /* 64kbs MPEG2 frame */
        }
    }

    /**
     * Get VBR tag information
     *
     * @param buf
     *            header to analyze
     * @param bufPos
     *            offset into the header
     * @return VBR tag data
     */
    this.getVbrTag = function (buf) {
        var pTagData = new VBRTagData();
        var bufPos = 0;

        /* get Vbr header data */
        pTagData.flags = 0;

        /* get selected MPEG header data */
        var hId = (buf[bufPos + 1] >> 3) & 1;
        var hSrIndex = (buf[bufPos + 2] >> 2) & 3;
        var hMode = (buf[bufPos + 3] >> 6) & 3;
        var hBitrate = ((buf[bufPos + 2] >> 4) & 0xf);
        hBitrate = Tables.bitrate_table[hId][hBitrate];

        /* check for FFE syncword */
        if ((buf[bufPos + 1] >> 4) == 0xE)
            pTagData.samprate = Tables.samplerate_table[2][hSrIndex];
        else
            pTagData.samprate = Tables.samplerate_table[hId][hSrIndex];

        /* determine offset of header */
        if (hId != 0) {
            /* mpeg1 */
            if (hMode != 3)
                bufPos += (32 + 4);
            else
                bufPos += (17 + 4);
        } else {
            /* mpeg2 */
            if (hMode != 3)
                bufPos += (17 + 4);
            else
                bufPos += (9 + 4);
        }

        if (!isVbrTag(buf, bufPos))
            return null;

        bufPos += 4;

        pTagData.hId = hId;

        /* get flags */
        var head_flags = pTagData.flags = extractInteger(buf, bufPos);
        bufPos += 4;

        if ((head_flags & FRAMES_FLAG) != 0) {
            pTagData.frames = extractInteger(buf, bufPos);
            bufPos += 4;
        }

        if ((head_flags & BYTES_FLAG) != 0) {
            pTagData.bytes = extractInteger(buf, bufPos);
            bufPos += 4;
        }

        if ((head_flags & TOC_FLAG) != 0) {
            if (pTagData.toc != null) {
                for (var i = 0; i < NUMTOCENTRIES; i++)
                    pTagData.toc[i] = buf[bufPos + i];
            }
            bufPos += NUMTOCENTRIES;
        }

        pTagData.vbrScale = -1;

        if ((head_flags & VBR_SCALE_FLAG) != 0) {
            pTagData.vbrScale = extractInteger(buf, bufPos);
            bufPos += 4;
        }

        pTagData.headersize = ((hId + 1) * 72000 * hBitrate)
            / pTagData.samprate;

        bufPos += 21;
        var encDelay = buf[bufPos + 0] << 4;
        encDelay += buf[bufPos + 1] >> 4;
        var encPadding = (buf[bufPos + 1] & 0x0F) << 8;
        encPadding += buf[bufPos + 2] & 0xff;
        /* check for reasonable values (this may be an old Xing header, */
        /* not a INFO tag) */
        if (encDelay < 0 || encDelay > 3000)
            encDelay = -1;
        if (encPadding < 0 || encPadding > 3000)
            encPadding = -1;

        pTagData.encDelay = encDelay;
        pTagData.encPadding = encPadding;

        /* success */
        return pTagData;
    };

    /**
     * Initializes the header
     *
     * @param gfp
     *            global flags
     */
    this.InitVbrTag = function (gfp) {
        var gfc = gfp.internal_flags;

        /**
         * <PRE>
         * Xing VBR pretends to be a 48kbs layer III frame.  (at 44.1kHz).
         * (at 48kHz they use 56kbs since 48kbs frame not big enough for
         * table of contents)
         * let's always embed Xing header inside a 64kbs layer III frame.
         * this gives us enough room for a LAME version string too.
         * size determined by sampling frequency (MPEG1)
         * 32kHz:    216 bytes@48kbs    288bytes@ 64kbs
         * 44.1kHz:  156 bytes          208bytes@64kbs     (+1 if padding = 1)
         * 48kHz:    144 bytes          192
         *
         * MPEG 2 values are the same since the framesize and samplerate
         * are each reduced by a factor of 2.
         * </PRE>
         */
        var kbps_header;
        if (1 == gfp.version) {
            kbps_header = XING_BITRATE1;
        } else {
            if (gfp.out_samplerate < 16000)
                kbps_header = XING_BITRATE25;
            else
                kbps_header = XING_BITRATE2;
        }

        if (gfp.VBR == VbrMode$22.vbr_off)
            kbps_header = gfp.brate;

        // make sure LAME Header fits into Frame
        var totalFrameSize = ((gfp.version + 1) * 72000 * kbps_header)
            / gfp.out_samplerate;
        var headerSize = (gfc.sideinfo_len + LAMEHEADERSIZE);
        gfc.VBR_seek_table.TotalFrameSize = totalFrameSize;
        if (totalFrameSize < headerSize || totalFrameSize > MAXFRAMESIZE) {
            /* disable tag, it wont fit */
            gfp.bWriteVbrTag = false;
            return;
        }

        gfc.VBR_seek_table.nVbrNumFrames = 0;
        gfc.VBR_seek_table.nBytesWritten = 0;
        gfc.VBR_seek_table.sum = 0;

        gfc.VBR_seek_table.seen = 0;
        gfc.VBR_seek_table.want = 1;
        gfc.VBR_seek_table.pos = 0;

        if (gfc.VBR_seek_table.bag == null) {
            gfc.VBR_seek_table.bag = new int[400];
            gfc.VBR_seek_table.size = 400;
        }

        // write dummy VBR tag of all 0's into bitstream
        var buffer = new_byte$22(MAXFRAMESIZE);

        setLameTagFrameHeader(gfp, buffer);
        var n = gfc.VBR_seek_table.TotalFrameSize;
        for (var i = 0; i < n; ++i) {
            bs.add_dummy_byte(gfp, buffer[i] & 0xff, 1);
        }
    };

    /**
     * Fast CRC-16 computation (uses table crc16Lookup).
     *
     * @param value
     * @param crc
     * @return
     */
    function crcUpdateLookup(value, crc) {
        var tmp = crc ^ value;
        crc = (crc >> 8) ^ crc16Lookup[tmp & 0xff];
        return crc;
    }

    this.updateMusicCRC = function (crc, buffer, bufferPos, size) {
        for (var i = 0; i < size; ++i)
            crc[0] = crcUpdateLookup(buffer[bufferPos + i], crc[0]);
    };

    /**
     * Write LAME info: mini version + info on various switches used (Jonathan
     * Dee 2001/08/31).
     *
     * @param gfp
     *            global flags
     * @param musicLength
     *            music length
     * @param streamBuffer
     *            pointer to output buffer
     * @param streamBufferPos
     *            offset into the output buffer
     * @param crc
     *            computation of CRC-16 of Lame Tag so far (starting at frame
     *            sync)
     * @return number of bytes written to the stream
     */
    function putLameVBR(gfp, musicLength, streamBuffer, streamBufferPos, crc) {
        var gfc = gfp.internal_flags;
        var bytesWritten = 0;

        /* encoder delay */
        var encDelay = gfp.encoder_delay;
        /* encoder padding */
        var encPadding = gfp.encoder_padding;

        /* recall: gfp.VBR_q is for example set by the switch -V */
        /* gfp.quality by -q, -h, -f, etc */
        var quality = (100 - 10 * gfp.VBR_q - gfp.quality);

        var version = v.getLameVeryShortVersion();
        var vbr;
        var revision = 0x00;
        var revMethod;
        // numbering different in vbr_mode vs. Lame tag
        var vbrTypeTranslator = [1, 5, 3, 2, 4, 0, 3];
        var lowpass = 0 | (((gfp.lowpassfreq / 100.0) + .5) > 255 ? 255
                : (gfp.lowpassfreq / 100.0) + .5);
        var peakSignalAmplitude = 0;
        var radioReplayGain = 0;
        var audiophileReplayGain = 0;
        var noiseShaping = gfp.internal_flags.noise_shaping;
        var stereoMode = 0;
        var nonOptimal = 0;
        var sourceFreq = 0;
        var misc = 0;
        var musicCRC = 0;

        // psy model type: Gpsycho or NsPsytune
        var expNPsyTune = (gfp.exp_nspsytune & 1) != 0;
        var safeJoint = (gfp.exp_nspsytune & 2) != 0;
        var noGapMore = false;
        var noGapPrevious = false;
        var noGapCount = gfp.internal_flags.nogap_total;
        var noGapCurr = gfp.internal_flags.nogap_current;

        // 4 bits
        var athType = gfp.ATHtype;
        var flags = 0;

        // vbr modes
        var abrBitrate;
        switch (gfp.VBR) {
            case vbr_abr:
                abrBitrate = gfp.VBR_mean_bitrate_kbps;
                break;
            case vbr_off:
                abrBitrate = gfp.brate;
                break;
            default:
                abrBitrate = gfp.VBR_min_bitrate_kbps;
        }

        // revision and vbr method
        if (gfp.VBR.ordinal() < vbrTypeTranslator.length)
            vbr = vbrTypeTranslator[gfp.VBR.ordinal()];
        else
            vbr = 0x00; // unknown

        revMethod = 0x10 * revision + vbr;

        // ReplayGain
        if (gfc.findReplayGain) {
            if (gfc.RadioGain > 0x1FE)
                gfc.RadioGain = 0x1FE;
            if (gfc.RadioGain < -0x1FE)
                gfc.RadioGain = -0x1FE;

            // set name code
            radioReplayGain = 0x2000;
            // set originator code to `determined automatically'
            radioReplayGain |= 0xC00;

            if (gfc.RadioGain >= 0) {
                // set gain adjustment
                radioReplayGain |= gfc.RadioGain;
            } else {
                // set the sign bit
                radioReplayGain |= 0x200;
                // set gain adjustment
                radioReplayGain |= -gfc.RadioGain;
            }
        }

        // peak sample
        if (gfc.findPeakSample)
            peakSignalAmplitude = Math
                .abs(0 | ((( gfc.PeakSample) / 32767.0) * Math.pow(2, 23) + .5));

        // nogap
        if (noGapCount != -1) {
            if (noGapCurr > 0)
                noGapPrevious = true;

            if (noGapCurr < noGapCount - 1)
                noGapMore = true;
        }

        // flags
        flags = athType + ((expNPsyTune ? 1 : 0) << 4)
            + ((safeJoint ? 1 : 0) << 5) + ((noGapMore ? 1 : 0) << 6)
            + ((noGapPrevious ? 1 : 0) << 7);

        if (quality < 0)
            quality = 0;

        // stereo mode field (Intensity stereo is not implemented)
        switch (gfp.mode) {
            case MONO:
                stereoMode = 0;
                break;
            case STEREO:
                stereoMode = 1;
                break;
            case DUAL_CHANNEL:
                stereoMode = 2;
                break;
            case JOINT_STEREO:
                if (gfp.force_ms)
                    stereoMode = 4;
                else
                    stereoMode = 3;
                break;
            case NOT_SET:
            //$FALL-THROUGH$
            default:
                stereoMode = 7;
                break;
        }

        if (gfp.in_samplerate <= 32000)
            sourceFreq = 0x00;
        else if (gfp.in_samplerate == 48000)
            sourceFreq = 0x02;
        else if (gfp.in_samplerate > 48000)
            sourceFreq = 0x03;
        else {
            // default is 44100Hz
            sourceFreq = 0x01;
        }

        // Check if the user overrided the default LAME behavior with some
        // nasty options
        if (gfp.short_blocks == ShortBlock$22.short_block_forced
            || gfp.short_blocks == ShortBlock$22.short_block_dispensed
            || ((gfp.lowpassfreq == -1) && (gfp.highpassfreq == -1)) || /* "-k" */
            (gfp.scale_left < gfp.scale_right)
            || (gfp.scale_left > gfp.scale_right)
            || (gfp.disable_reservoir && gfp.brate < 320) || gfp.noATH
            || gfp.ATHonly || (athType == 0) || gfp.in_samplerate <= 32000)
            nonOptimal = 1;

        misc = noiseShaping + (stereoMode << 2) + (nonOptimal << 5)
            + (sourceFreq << 6);

        musicCRC = gfc.nMusicCRC;

        // Write all this information into the stream

        createInteger(streamBuffer, streamBufferPos + bytesWritten, quality);
        bytesWritten += 4;

        for (var j = 0; j < 9; j++) {
            streamBuffer[streamBufferPos + bytesWritten + j] = 0xff & version .charAt(j);
        }
        bytesWritten += 9;

        streamBuffer[streamBufferPos + bytesWritten] = 0xff & revMethod;
        bytesWritten++;

        streamBuffer[streamBufferPos + bytesWritten] = 0xff & lowpass;
        bytesWritten++;

        createInteger(streamBuffer, streamBufferPos + bytesWritten,
            peakSignalAmplitude);
        bytesWritten += 4;

        createShort(streamBuffer, streamBufferPos + bytesWritten,
            radioReplayGain);
        bytesWritten += 2;

        createShort(streamBuffer, streamBufferPos + bytesWritten,
            audiophileReplayGain);
        bytesWritten += 2;

        streamBuffer[streamBufferPos + bytesWritten] = 0xff & flags;
        bytesWritten++;

        if (abrBitrate >= 255)
            streamBuffer[streamBufferPos + bytesWritten] = 0xFF;
        else
            streamBuffer[streamBufferPos + bytesWritten] = 0xff & abrBitrate;
        bytesWritten++;

        streamBuffer[streamBufferPos + bytesWritten] = 0xff & (encDelay >> 4);
        streamBuffer[streamBufferPos + bytesWritten + 1] = 0xff & ((encDelay << 4) + (encPadding >> 8));
        streamBuffer[streamBufferPos + bytesWritten + 2] = 0xff & encPadding;

        bytesWritten += 3;

        streamBuffer[streamBufferPos + bytesWritten] = 0xff & misc;
        bytesWritten++;

        // unused in rev0
        streamBuffer[streamBufferPos + bytesWritten++] = 0;

        createShort(streamBuffer, streamBufferPos + bytesWritten, gfp.preset);
        bytesWritten += 2;

        createInteger(streamBuffer, streamBufferPos + bytesWritten, musicLength);
        bytesWritten += 4;

        createShort(streamBuffer, streamBufferPos + bytesWritten, musicCRC);
        bytesWritten += 2;

        // Calculate tag CRC.... must be done here, since it includes previous
        // information

        for (var i = 0; i < bytesWritten; i++)
            crc = crcUpdateLookup(streamBuffer[streamBufferPos + i], crc);

        createShort(streamBuffer, streamBufferPos + bytesWritten, crc);
        bytesWritten += 2;

        return bytesWritten;
    }

    function skipId3v2(fpStream) {
        // seek to the beginning of the stream
        fpStream.seek(0);
        // read 10 bytes in case there's an ID3 version 2 header here
        var id3v2Header = new_byte$22(10);
        fpStream.readFully(id3v2Header);
        /* does the stream begin with the ID3 version 2 file identifier? */
        var id3v2TagSize;
        if (!new String(id3v2Header, "ISO-8859-1").startsWith("ID3")) {
            /*
             * the tag size (minus the 10-byte header) is encoded into four
             * bytes where the most significant bit is clear in each byte
             */
            id3v2TagSize = (((id3v2Header[6] & 0x7f) << 21)
                | ((id3v2Header[7] & 0x7f) << 14)
                | ((id3v2Header[8] & 0x7f) << 7) | (id3v2Header[9] & 0x7f))
                + id3v2Header.length;
        } else {
            /* no ID3 version 2 tag in this stream */
            id3v2TagSize = 0;
        }
        return id3v2TagSize;
    }

    this.getLameTagFrame = function (gfp, buffer) {
        var gfc = gfp.internal_flags;

        if (!gfp.bWriteVbrTag) {
            return 0;
        }
        if (gfc.Class_ID != Lame.LAME_ID) {
            return 0;
        }
        if (gfc.VBR_seek_table.pos <= 0) {
            return 0;
        }
        if (buffer.length < gfc.VBR_seek_table.TotalFrameSize) {
            return gfc.VBR_seek_table.TotalFrameSize;
        }

        Arrays$22.fill(buffer, 0, gfc.VBR_seek_table.TotalFrameSize, 0);

        // 4 bytes frame header
        setLameTagFrameHeader(gfp, buffer);

        // Create TOC entries
        var toc = new_byte$22(NUMTOCENTRIES);

        if (gfp.free_format) {
            for (var i = 1; i < NUMTOCENTRIES; ++i)
                toc[i] = 0xff & (255 * i / 100);
        } else {
            xingSeekTable(gfc.VBR_seek_table, toc);
        }

        // Start writing the tag after the zero frame
        var streamIndex = gfc.sideinfo_len;
        /**
         * Note: Xing header specifies that Xing data goes in the ancillary data
         * with NO ERROR PROTECTION. If error protecton in enabled, the Xing
         * data still starts at the same offset, and now it is in sideinfo data
         * block, and thus will not decode correctly by non-Xing tag aware
         * players
         */
        if (gfp.error_protection)
            streamIndex -= 2;

        // Put Vbr tag
        if (gfp.VBR == VbrMode$22.vbr_off) {
            buffer[streamIndex++] = 0xff & VBRTag1.charAt(0);
            buffer[streamIndex++] = 0xff & VBRTag1.charAt(1);
            buffer[streamIndex++] = 0xff & VBRTag1.charAt(2);
            buffer[streamIndex++] = 0xff & VBRTag1.charAt(3);

        } else {
            buffer[streamIndex++] = 0xff & VBRTag0.charAt(0);
            buffer[streamIndex++] = 0xff & VBRTag0.charAt(1);
            buffer[streamIndex++] = 0xff & VBRTag0.charAt(2);
            buffer[streamIndex++] = 0xff & VBRTag0.charAt(3);
        }

        // Put header flags
        createInteger(buffer, streamIndex, FRAMES_FLAG + BYTES_FLAG + TOC_FLAG
            + VBR_SCALE_FLAG);
        streamIndex += 4;

        // Put Total Number of frames
        createInteger(buffer, streamIndex, gfc.VBR_seek_table.nVbrNumFrames);
        streamIndex += 4;

        // Put total audio stream size, including Xing/LAME Header
        var streamSize = (gfc.VBR_seek_table.nBytesWritten + gfc.VBR_seek_table.TotalFrameSize);
        createInteger(buffer, streamIndex, 0 | streamSize);
        streamIndex += 4;

        /* Put TOC */
        System$22.arraycopy(toc, 0, buffer, streamIndex, toc.length);
        streamIndex += toc.length;

        if (gfp.error_protection) {
            // (jo) error_protection: add crc16 information to header
            bs.CRC_writeheader(gfc, buffer);
        }

        // work out CRC so far: initially crc = 0
        var crc = 0x00;
        for (var i = 0; i < streamIndex; i++)
            crc = crcUpdateLookup(buffer[i], crc);
        // Put LAME VBR info
        streamIndex += putLameVBR(gfp, streamSize, buffer, streamIndex, crc);

        return gfc.VBR_seek_table.TotalFrameSize;
    };

    /**
     * Write final VBR tag to the file.
     *
     * @param gfp
     *            global flags
     * @param stream
     *            stream to add the VBR tag to
     * @return 0 (OK), -1 else
     * @throws IOException
     *             I/O error
     */
    this.putVbrTag = function (gfp, stream) {
        var gfc = gfp.internal_flags;

        if (gfc.VBR_seek_table.pos <= 0)
            return -1;

        // Seek to end of file
        stream.seek(stream.length());

        // Get file size, abort if file has zero length.
        if (stream.length() == 0)
            return -1;

        // The VBR tag may NOT be located at the beginning of the stream. If an
        // ID3 version 2 tag was added, then it must be skipped to write the VBR
        // tag data.
        var id3v2TagSize = skipId3v2(stream);

        // Seek to the beginning of the stream
        stream.seek(id3v2TagSize);

        var buffer = new_byte$22(MAXFRAMESIZE);
        var bytes = getLameTagFrame(gfp, buffer);
        if (bytes > buffer.length) {
            return -1;
        }

        if (bytes < 1) {
            return 0;
        }

        // Put it all to disk again
        stream.write(buffer, 0, bytes);
        // success
        return 0;
    };

}

var VBRTag_1 = VBRTag;

var new_byte = common.new_byte;
var assert = common.assert;

Lame = Lame_1;
Presets = Presets_1;
GainAnalysis = GainAnalysis_1;
QuantizePVT = QuantizePVT_1;
Quantize = Quantize_1;
Takehiro = Takehiro_1;
Reservoir = Reservoir_1;
MPEGMode = MPEGMode_1;
BitStream = BitStream_1;




function GetAudio() {
    var parse;
    var mpg;

    this.setModules = function (parse2, mpg2) {
        parse = parse2;
        mpg = mpg2;
    };
}


function Parse() {
    var ver;
    var id3;
    var pre;

    this.setModules = function (ver2, id32, pre2) {
        ver = ver2;
        id3 = id32;
        pre = pre2;
    };
}

function MPGLib() {
}

function ID3Tag() {
    var bits;
    var ver;

    this.setModules = function (_bits, _ver) {
        bits = _bits;
        ver = _ver;
    };
}

function Mp3Encoder(channels, samplerate, kbps) {
    if (arguments.length != 3) {
        console.error('WARN: Mp3Encoder(channels, samplerate, kbps) not specified');
        channels = 1;
        samplerate = 44100;
        kbps = 128;
    }
    var lame = new Lame();
    var gaud = new GetAudio();
    var ga = new GainAnalysis();
    var bs = new BitStream();
    var p = new Presets();
    var qupvt = new QuantizePVT();
    var qu = new Quantize();
    var vbr = new VBRTag_1();
    var ver = new Version_1();
    var id3 = new ID3Tag();
    var rv = new Reservoir();
    var tak = new Takehiro();
    var parse = new Parse();
    var mpg = new MPGLib();

    lame.setModules(ga, bs, p, qupvt, qu, vbr, ver, id3, mpg);
    bs.setModules(ga, mpg, ver, vbr);
    id3.setModules(bs, ver);
    p.setModules(lame);
    qu.setModules(bs, rv, qupvt, tak);
    qupvt.setModules(tak, rv, lame.enc.psy);
    rv.setModules(bs);
    tak.setModules(qupvt);
    vbr.setModules(lame, bs, ver);
    gaud.setModules(parse, mpg);
    parse.setModules(ver, id3, p);

    var gfp = lame.lame_init();

    gfp.num_channels = channels;
    gfp.in_samplerate = samplerate;
    gfp.brate = kbps;
    gfp.mode = MPEGMode.STEREO;
    gfp.quality = 3;
    gfp.bWriteVbrTag = false;
    gfp.disable_reservoir = true;
    gfp.write_id3tag_automatic = false;

    var retcode = lame.lame_init_params(gfp);
    assert(0 == retcode);
    var maxSamples = 1152;
    var mp3buf_size = 0 | (1.25 * maxSamples + 7200);
    var mp3buf = new_byte(mp3buf_size);

    this.encodeBuffer = function (left, right) {
        if (channels == 1) {
            right = left;
        }
        assert(left.length == right.length);
        if (left.length > maxSamples) {
            maxSamples = left.length;
            mp3buf_size = 0 | (1.25 * maxSamples + 7200);
            mp3buf = new_byte(mp3buf_size);
        }

        var _sz = lame.lame_encode_buffer(gfp, left, right, left.length, mp3buf, 0, mp3buf_size);
        return new Int8Array(mp3buf.subarray(0, _sz));
    };

    this.flush = function () {
        var _sz = lame.lame_encode_flush(gfp, mp3buf, 0, mp3buf_size);
        return new Int8Array(mp3buf.subarray(0, _sz));
    };
}

function WavHeader() {
    this.dataOffset = 0;
    this.dataLen = 0;
    this.channels = 0;
    this.sampleRate = 0;
}

function fourccToInt(fourcc) {
    return fourcc.charCodeAt(0) << 24 | fourcc.charCodeAt(1) << 16 | fourcc.charCodeAt(2) << 8 | fourcc.charCodeAt(3);
}

WavHeader.RIFF = fourccToInt("RIFF");
WavHeader.WAVE = fourccToInt("WAVE");
WavHeader.fmt_ = fourccToInt("fmt ");
WavHeader.data = fourccToInt("data");

WavHeader.readHeader = function (dataView) {
    var w = new WavHeader();

    var header = dataView.getUint32(0, false);
    if (WavHeader.RIFF != header) {
        return;
    }
    var fileLen = dataView.getUint32(4, true);
    if (WavHeader.WAVE != dataView.getUint32(8, false)) {
        return;
    }
    if (WavHeader.fmt_ != dataView.getUint32(12, false)) {
        return;
    }
    var fmtLen = dataView.getUint32(16, true);
    var pos = 16 + 4;
    switch (fmtLen) {
        case 16:
        case 18:
            w.channels = dataView.getUint16(pos + 2, true);
            w.sampleRate = dataView.getUint32(pos + 4, true);
            break;
        default:
            throw 'extended fmt chunk not implemented';
    }
    pos += fmtLen;
    var data = WavHeader.data;
    var len = 0;
    while (data != header) {
        header = dataView.getUint32(pos, false);
        len = dataView.getUint32(pos + 4, true);
        if (data == header) {
            break;
        }
        pos += (len + 8);
    }
    w.dataLen = len;
    w.dataOffset = pos + 8;
    return w;
};

var Mp3Encoder_1 = Mp3Encoder;

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var Encoder = function () {
  function Encoder(config) {
    classCallCheck(this, Encoder);

    this.config = {
      sampleRate: 44100,
      bitRate: 128
    };

    Object.assign(this.config, config);

    this.mp3Encoder = new Mp3Encoder_1(1, this.config.sampleRate, this.config.bitRate);

    // Audio is processed by frames of 1152 samples per audio channel
    // http://lame.sourceforge.net/tech-FAQ.txt
    this.maxSamples = 1152;

    this.samplesMono = null;
    this.clearBuffer();
  }

  /**
   * Clear active buffer
   */


  createClass(Encoder, [{
    key: 'clearBuffer',
    value: function clearBuffer() {
      this.dataBuffer = [];
    }

    /**
     * Append new audio buffer to current active buffer
     * @param {Buffer} buffer
     */

  }, {
    key: 'appendToBuffer',
    value: function appendToBuffer(buffer) {
      this.dataBuffer.push(new Int8Array(buffer));
    }

    /**
     * Float current data to 16 bits PCM
     * @param {Float32Array} input
     * @param {Int16Array} output
     */

  }, {
    key: 'floatTo16BitPCM',
    value: function floatTo16BitPCM(input, output) {
      for (var i = 0; i < input.length; i++) {
        var s = Math.max(-1, Math.min(1, input[i]));
        output[i] = s < 0 ? s * 0x8000 : s * 0x7FFF;
      }
    }

    /**
     * Convert buffer to proper format
     * @param {Array} arrayBuffer
     */

  }, {
    key: 'convertBuffer',
    value: function convertBuffer(arrayBuffer) {
      var data = new Float32Array(arrayBuffer);
      var out = new Int16Array(arrayBuffer.length);
      this.floatTo16BitPCM(data, out);

      return out;
    }

    /**
     * Encode and append current buffer to dataBuffer
     * @param {Array} arrayBuffer
     */

  }, {
    key: 'encode',
    value: function encode(arrayBuffer) {
      this.samplesMono = this.convertBuffer(arrayBuffer);
      var remaining = this.samplesMono.length;

      for (var i = 0; remaining >= 0; i += this.maxSamples) {
        var left = this.samplesMono.subarray(i, i + this.maxSamples);
        var mp3buffer = this.mp3Encoder.encodeBuffer(left);
        this.appendToBuffer(mp3buffer);
        remaining -= this.maxSamples;
      }
    }

    /**
     * Return full dataBuffer
     */

  }, {
    key: 'finish',
    value: function finish() {
      this.appendToBuffer(this.mp3Encoder.flush());

      return this.dataBuffer;
    }
  }]);
  return Encoder;
}();

var MicRecorder = function () {
  function MicRecorder(config) {
    classCallCheck(this, MicRecorder);

    this.config = {
      // 128 or 160 kbit/s – mid-range bitrate quality
      bitRate: 128,

      // There is a known issue with some macOS machines, where the recording
      // will sometimes have a loud 'pop' or 'pop-click' sound. This flag
      // prevents getting audio from the microphone a few milliseconds after
      // the begining of the recording. It also helps to remove the mouse
      // "click" sound from the output mp3 file.
      startRecordingAt: 300,
      deviceId: null
    };

    this.activeStream = null;
    this.context = null;
    this.microphone = null;
    this.processor = null;
    this.startTime = 0;

    Object.assign(this.config, config);
  }

  /**
   * Starts to listen for the microphone sound
   * @param {MediaStream} stream
   */


  createClass(MicRecorder, [{
    key: 'addMicrophoneListener',
    value: function addMicrophoneListener(stream) {
      var _this = this;

      this.activeStream = stream;

      // This prevents the weird noise once you start listening to the microphone
      this.timerToStart = setTimeout(function () {
        delete _this.timerToStart;
      }, this.config.startRecordingAt);

      // Set up Web Audio API to process data from the media stream (microphone).
      this.microphone = this.context.createMediaStreamSource(stream);

      // Settings a bufferSize of 0 instructs the browser to choose the best bufferSize
      this.processor = this.context.createScriptProcessor(0, 1, 1);

      // Add all buffers from LAME into an array.
      this.processor.onaudioprocess = function (event) {
        if (_this.timerToStart) {
          return;
        }

        // Send microphone data to LAME for MP3 encoding while recording.
        _this.lameEncoder.encode(event.inputBuffer.getChannelData(0));
      };

      // Begin retrieving microphone data.
      this.microphone.connect(this.processor);
      this.processor.connect(this.context.destination);
    }
  }, {
    key: 'stop',


    /**
     * Disconnect microphone, processor and remove activeStream
     */
    value: function stop() {
      if (this.processor && this.microphone) {
        // Clean up the Web Audio API resources.
        this.microphone.disconnect();
        this.processor.disconnect();

        // If all references using this.context are destroyed, context is closed
        // automatically. DOMException is fired when trying to close again
        if (this.context && this.context.state !== 'closed') {
          this.context.close();
        }

        this.processor.onaudioprocess = null;

        // Stop all audio tracks. Also, removes recording icon from chrome tab
        this.activeStream.getAudioTracks().forEach(function (track) {
          return track.stop();
        });
      }

      return this;
    }
  }, {
    key: 'start',


    /**
     * Requests access to the microphone and start recording
     * @return Promise
     */
    value: function start() {
      var _this2 = this;

      var AudioContext = window.AudioContext || window.webkitAudioContext;
      this.context = new AudioContext();
      this.config.sampleRate = this.context.sampleRate;
      this.lameEncoder = new Encoder(this.config);

      var audio = this.config.deviceId ? { deviceId: { exact: this.config.deviceId } } : true;

      return new Promise(function (resolve, reject) {
        navigator.mediaDevices.getUserMedia({ audio: audio }).then(function (stream) {
          _this2.addMicrophoneListener(stream);
          resolve(stream);
        }).catch(function (err) {
          reject(err);
        });
      });
    }
  }, {
    key: 'getMp3',


    /**
     * Return Mp3 Buffer and Blob with type mp3
     * @return {Promise}
     */
    value: function getMp3() {
      var _this3 = this;

      var finalBuffer = this.lameEncoder.finish();

      return new Promise(function (resolve, reject) {
        if (finalBuffer.length === 0) {
          reject(new Error('No buffer to send'));
        } else {
          resolve([finalBuffer, new Blob(finalBuffer, { type: 'audio/mp3' })]);
          _this3.lameEncoder.clearBuffer();
        }
      });
    }
  }]);
  return MicRecorder;
}();

return MicRecorder;

})));
//# sourceMappingURL=index.js.map

},
'library/media/polyfill/GetUserMedia':function(){
// wrapped by build app
define(["dojo","dijit","dojox"], function(dojo,dijit,dojox){
// Older browsers might not implement mediaDevices at all, so we set an empty object first
if (navigator.mediaDevices === undefined) {
    navigator.mediaDevices = {};
}

// Some browsers partially implement mediaDevices. We can't just assign an object
// with getUserMedia as it would overwrite existing properties.
// Here, we will just add the getUserMedia property if it's missing.
if (navigator.mediaDevices.getUserMedia === undefined) {
    navigator.mediaDevices.getUserMedia = function(constraints) {

        // First get ahold of the legacy getUserMedia, if present
        const getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

        // Some browsers just don't implement it - return a rejected promise with an error
        // to keep a consistent interface
        if (!getUserMedia) {
            return Promise.reject(new Error('getUserMedia is not implemented in this browser'));
        }

        // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
        return new Promise(function(resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject);
        });
    }
}
});

},
'style-guide/v1/doc-control/audio-record/state-machine/Factory':function(){
define([
    './JavascriptStateMachine',
    './JavascriptStateMachineConfig',
    './States',
    './Transitions'
], function(
    StateMachine,
    StateMachineConfig,
    STATES,
    TRANSITIONS
) {
    const Factory = function(widget) {
        this.widget = widget;
    };

    Factory.prototype.getStateMachine = function() {
        return new StateMachine(
            new StateMachineConfig(
                STATES,
                TRANSITIONS,
                this.widget
            )
        );
    };

    return Factory;
});
},
'style-guide/v1/doc-control/audio-record/state-machine/JavascriptStateMachine':function(){
define([
    'vendor/javascript-state-machine/dist/state-machine'
], function(
    StateMachine
) {
    const JavascriptStateMachine = function(config) {
        this.base = StateMachine;
        this.base(config);
    };

    JavascriptStateMachine.prototype = Object.create(StateMachine.prototype);

    JavascriptStateMachine.prototype.getCurrentState = function() {
        return this.state;
    };

    return JavascriptStateMachine;
});
},
'vendor/javascript-state-machine/dist/state-machine':function(){
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("StateMachine", [], factory);
	else if(typeof exports === 'object')
		exports["StateMachine"] = factory();
	else
		root["StateMachine"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(target, sources) {
  var n, source, key;
  for(n = 1 ; n < arguments.length ; n++) {
    source = arguments[n];
    for(key in source) {
      if (source.hasOwnProperty(key))
        target[key] = source[key];
    }
  }
  return target;
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//-------------------------------------------------------------------------------------------------

var mixin = __webpack_require__(0);

//-------------------------------------------------------------------------------------------------

module.exports = {

  build: function(target, config) {
    var n, max, plugin, plugins = config.plugins;
    for(n = 0, max = plugins.length ; n < max ; n++) {
      plugin = plugins[n];
      if (plugin.methods)
        mixin(target, plugin.methods);
      if (plugin.properties)
        Object.defineProperties(target, plugin.properties);
    }
  },

  hook: function(fsm, name, additional) {
    var n, max, method, plugin,
        plugins = fsm.config.plugins,
        args    = [fsm.context];

    if (additional)
      args = args.concat(additional)

    for(n = 0, max = plugins.length ; n < max ; n++) {
      plugin = plugins[n]
      method = plugins[n][name]
      if (method)
        method.apply(plugin, args);
    }
  }

}

//-------------------------------------------------------------------------------------------------


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//-------------------------------------------------------------------------------------------------

function camelize(label) {

  if (label.length === 0)
    return label;

  var n, result, word, words = label.split(/[_-]/);

  // single word with first character already lowercase, return untouched
  if ((words.length === 1) && (words[0][0].toLowerCase() === words[0][0]))
    return label;

  result = words[0].toLowerCase();
  for(n = 1 ; n < words.length ; n++) {
    result = result + words[n].charAt(0).toUpperCase() + words[n].substring(1).toLowerCase();
  }

  return result;
}

//-------------------------------------------------------------------------------------------------

camelize.prepended = function(prepend, label) {
  label = camelize(label);
  return prepend + label[0].toUpperCase() + label.substring(1);
}

//-------------------------------------------------------------------------------------------------

module.exports = camelize;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//-------------------------------------------------------------------------------------------------

var mixin    = __webpack_require__(0),
    camelize = __webpack_require__(2);

//-------------------------------------------------------------------------------------------------

function Config(options, StateMachine) {

  options = options || {};

  this.options     = options; // preserving original options can be useful (e.g visualize plugin)
  this.defaults    = StateMachine.defaults;
  this.states      = [];
  this.transitions = [];
  this.map         = {};
  this.lifecycle   = this.configureLifecycle();
  this.init        = this.configureInitTransition(options.init);
  this.data        = this.configureData(options.data);
  this.methods     = this.configureMethods(options.methods);

  this.map[this.defaults.wildcard] = {};

  this.configureTransitions(options.transitions || []);

  this.plugins = this.configurePlugins(options.plugins, StateMachine.plugin);

}

//-------------------------------------------------------------------------------------------------

mixin(Config.prototype, {

  addState: function(name) {
    if (!this.map[name]) {
      this.states.push(name);
      this.addStateLifecycleNames(name);
      this.map[name] = {};
    }
  },

  addStateLifecycleNames: function(name) {
    this.lifecycle.onEnter[name] = camelize.prepended('onEnter', name);
    this.lifecycle.onLeave[name] = camelize.prepended('onLeave', name);
    this.lifecycle.on[name]      = camelize.prepended('on',      name);
  },

  addTransition: function(name) {
    if (this.transitions.indexOf(name) < 0) {
      this.transitions.push(name);
      this.addTransitionLifecycleNames(name);
    }
  },

  addTransitionLifecycleNames: function(name) {
    this.lifecycle.onBefore[name] = camelize.prepended('onBefore', name);
    this.lifecycle.onAfter[name]  = camelize.prepended('onAfter',  name);
    this.lifecycle.on[name]       = camelize.prepended('on',       name);
  },

  mapTransition: function(transition) {
    var name = transition.name,
        from = transition.from,
        to   = transition.to;
    this.addState(from);
    if (typeof to !== 'function')
      this.addState(to);
    this.addTransition(name);
    this.map[from][name] = transition;
    return transition;
  },

  configureLifecycle: function() {
    return {
      onBefore: { transition: 'onBeforeTransition' },
      onAfter:  { transition: 'onAfterTransition'  },
      onEnter:  { state:      'onEnterState'       },
      onLeave:  { state:      'onLeaveState'       },
      on:       { transition: 'onTransition'       }
    };
  },

  configureInitTransition: function(init) {
    if (typeof init === 'string') {
      return this.mapTransition(mixin({}, this.defaults.init, { to: init, active: true }));
    }
    else if (typeof init === 'object') {
      return this.mapTransition(mixin({}, this.defaults.init, init, { active: true }));
    }
    else {
      this.addState(this.defaults.init.from);
      return this.defaults.init;
    }
  },

  configureData: function(data) {
    if (typeof data === 'function')
      return data;
    else if (typeof data === 'object')
      return function() { return data; }
    else
      return function() { return {};  }
  },

  configureMethods: function(methods) {
    return methods || {};
  },

  configurePlugins: function(plugins, builtin) {
    plugins = plugins || [];
    var n, max, plugin;
    for(n = 0, max = plugins.length ; n < max ; n++) {
      plugin = plugins[n];
      if (typeof plugin === 'function')
        plugins[n] = plugin = plugin()
      if (plugin.configure)
        plugin.configure(this);
    }
    return plugins
  },

  configureTransitions: function(transitions) {
    var i, n, transition, from, to, wildcard = this.defaults.wildcard;
    for(n = 0 ; n < transitions.length ; n++) {
      transition = transitions[n];
      from  = Array.isArray(transition.from) ? transition.from : [transition.from || wildcard]
      to    = transition.to || wildcard;
      for(i = 0 ; i < from.length ; i++) {
        this.mapTransition({ name: transition.name, from: from[i], to: to });
      }
    }
  },

  transitionFor: function(state, transition) {
    var wildcard = this.defaults.wildcard;
    return this.map[state][transition] ||
           this.map[wildcard][transition];
  },

  transitionsFor: function(state) {
    var wildcard = this.defaults.wildcard;
    return Object.keys(this.map[state]).concat(Object.keys(this.map[wildcard]));
  },

  allStates: function() {
    return this.states;
  },

  allTransitions: function() {
    return this.transitions;
  }

});

//-------------------------------------------------------------------------------------------------

module.exports = Config;

//-------------------------------------------------------------------------------------------------


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


var mixin      = __webpack_require__(0),
    Exception  = __webpack_require__(6),
    plugin     = __webpack_require__(1),
    UNOBSERVED = [ null, [] ];

//-------------------------------------------------------------------------------------------------

function JSM(context, config) {
  this.context   = context;
  this.config    = config;
  this.state     = config.init.from;
  this.observers = [context];
}

//-------------------------------------------------------------------------------------------------

mixin(JSM.prototype, {

  init: function(args) {
    mixin(this.context, this.config.data.apply(this.context, args));
    plugin.hook(this, 'init');
    if (this.config.init.active)
      return this.fire(this.config.init.name, []);
  },

  is: function(state) {
    return Array.isArray(state) ? (state.indexOf(this.state) >= 0) : (this.state === state);
  },

  isPending: function() {
    return this.pending;
  },

  can: function(transition) {
    return !this.isPending() && !!this.seek(transition);
  },

  cannot: function(transition) {
    return !this.can(transition);
  },

  allStates: function() {
    return this.config.allStates();
  },

  allTransitions: function() {
    return this.config.allTransitions();
  },

  transitions: function() {
    return this.config.transitionsFor(this.state);
  },

  seek: function(transition, args) {
    var wildcard = this.config.defaults.wildcard,
        entry    = this.config.transitionFor(this.state, transition),
        to       = entry && entry.to;
    if (typeof to === 'function')
      return to.apply(this.context, args);
    else if (to === wildcard)
      return this.state
    else
      return to
  },

  fire: function(transition, args) {
    return this.transit(transition, this.state, this.seek(transition, args), args);
  },

  transit: function(transition, from, to, args) {

    var lifecycle = this.config.lifecycle,
        changed   = this.config.options.observeUnchangedState || (from !== to);

    if (!to)
      return this.context.onInvalidTransition(transition, from, to);

    if (this.isPending())
      return this.context.onPendingTransition(transition, from, to);

    this.config.addState(to);  // might need to add this state if it's unknown (e.g. conditional transition or goto)

    this.beginTransit();

    args.unshift({             // this context will be passed to each lifecycle event observer
      transition: transition,
      from:       from,
      to:         to,
      fsm:        this.context
    });

    return this.observeEvents([
                this.observersForEvent(lifecycle.onBefore.transition),
                this.observersForEvent(lifecycle.onBefore[transition]),
      changed ? this.observersForEvent(lifecycle.onLeave.state) : UNOBSERVED,
      changed ? this.observersForEvent(lifecycle.onLeave[from]) : UNOBSERVED,
                this.observersForEvent(lifecycle.on.transition),
      changed ? [ 'doTransit', [ this ] ]                       : UNOBSERVED,
      changed ? this.observersForEvent(lifecycle.onEnter.state) : UNOBSERVED,
      changed ? this.observersForEvent(lifecycle.onEnter[to])   : UNOBSERVED,
      changed ? this.observersForEvent(lifecycle.on[to])        : UNOBSERVED,
                this.observersForEvent(lifecycle.onAfter.transition),
                this.observersForEvent(lifecycle.onAfter[transition]),
                this.observersForEvent(lifecycle.on[transition])
    ], args);
  },

  beginTransit: function()          { this.pending = true;                 },
  endTransit:   function(result)    { this.pending = false; return result; },
  failTransit:  function(result)    { this.pending = false; throw result;  },
  doTransit:    function(lifecycle) { this.state = lifecycle.to;           },

  observe: function(args) {
    if (args.length === 2) {
      var observer = {};
      observer[args[0]] = args[1];
      this.observers.push(observer);
    }
    else {
      this.observers.push(args[0]);
    }
  },

  observersForEvent: function(event) { // TODO: this could be cached
    var n = 0, max = this.observers.length, observer, result = [];
    for( ; n < max ; n++) {
      observer = this.observers[n];
      if (observer[event])
        result.push(observer);
    }
    return [ event, result, true ]
  },

  observeEvents: function(events, args, previousEvent, previousResult) {
    if (events.length === 0) {
      return this.endTransit(previousResult === undefined ? true : previousResult);
    }

    var event     = events[0][0],
        observers = events[0][1],
        pluggable = events[0][2];

    args[0].event = event;
    if (event && pluggable && event !== previousEvent)
      plugin.hook(this, 'lifecycle', args);

    if (observers.length === 0) {
      events.shift();
      return this.observeEvents(events, args, event, previousResult);
    }
    else {
      var observer = observers.shift(),
          result = observer[event].apply(observer, args);
      if (result && typeof result.then === 'function') {
        return result.then(this.observeEvents.bind(this, events, args, event))
                     .catch(this.failTransit.bind(this))
      }
      else if (result === false) {
        return this.endTransit(false);
      }
      else {
        return this.observeEvents(events, args, event, result);
      }
    }
  },

  onInvalidTransition: function(transition, from, to) {
    throw new Exception("transition is invalid in current state", transition, from, to, this.state);
  },

  onPendingTransition: function(transition, from, to) {
    throw new Exception("transition is invalid while previous transition is still in progress", transition, from, to, this.state);
  }

});

//-------------------------------------------------------------------------------------------------

module.exports = JSM;

//-------------------------------------------------------------------------------------------------


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//-----------------------------------------------------------------------------------------------

var mixin    = __webpack_require__(0),
    camelize = __webpack_require__(2),
    plugin   = __webpack_require__(1),
    Config   = __webpack_require__(3),
    JSM      = __webpack_require__(4);

//-----------------------------------------------------------------------------------------------

var PublicMethods = {
  is:                  function(state)       { return this._fsm.is(state)                                     },
  can:                 function(transition)  { return this._fsm.can(transition)                               },
  cannot:              function(transition)  { return this._fsm.cannot(transition)                            },
  observe:             function()            { return this._fsm.observe(arguments)                            },
  transitions:         function()            { return this._fsm.transitions()                                 },
  allTransitions:      function()            { return this._fsm.allTransitions()                              },
  allStates:           function()            { return this._fsm.allStates()                                   },
  onInvalidTransition: function(t, from, to) { return this._fsm.onInvalidTransition(t, from, to)              },
  onPendingTransition: function(t, from, to) { return this._fsm.onPendingTransition(t, from, to)              },
}

var PublicProperties = {
  state: {
    configurable: false,
    enumerable:   true,
    get: function() {
      return this._fsm.state;
    },
    set: function(state) {
      throw Error('use transitions to change state')
    }
  }
}

//-----------------------------------------------------------------------------------------------

function StateMachine(options) {
  return apply(this || {}, options);
}

function factory() {
  var cstor, options;
  if (typeof arguments[0] === 'function') {
    cstor   = arguments[0];
    options = arguments[1] || {};
  }
  else {
    cstor   = function() { this._fsm.apply(this, arguments) };
    options = arguments[0] || {};
  }
  var config = new Config(options, StateMachine);
  build(cstor.prototype, config);
  cstor.prototype._fsm.config = config; // convenience access to shared config without needing an instance
  return cstor;
}

//-------------------------------------------------------------------------------------------------

function apply(instance, options) {
  var config = new Config(options, StateMachine);
  build(instance, config);
  instance._fsm();
  return instance;
}

function build(target, config) {
  if ((typeof target !== 'object') || Array.isArray(target))
    throw Error('StateMachine can only be applied to objects');
  plugin.build(target, config);
  Object.defineProperties(target, PublicProperties);
  mixin(target, PublicMethods);
  mixin(target, config.methods);
  config.allTransitions().forEach(function(transition) {
    target[camelize(transition)] = function() {
      return this._fsm.fire(transition, [].slice.call(arguments))
    }
  });
  target._fsm = function() {
    this._fsm = new JSM(this, config);
    this._fsm.init(arguments);
  }
}

//-----------------------------------------------------------------------------------------------

StateMachine.version  = '3.0.1';
StateMachine.factory  = factory;
StateMachine.apply    = apply;
StateMachine.defaults = {
  wildcard: '*',
  init: {
    name: 'init',
    from: 'none'
  }
}

//===============================================================================================

module.exports = StateMachine;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function(message, transition, from, to, current) {
  this.message    = message;
  this.transition = transition;
  this.from       = from;
  this.to         = to;
  this.current    = current;
}


/***/ })
/******/ ]);
});
},
'style-guide/v1/doc-control/audio-record/state-machine/JavascriptStateMachineConfig':function(){
define([], function() {
    const JavascriptStateMachineConfig = function(
        STATES,
        TRANSITIONS,
        widget
    ) {
        this.init = STATES.INITIAL;

        this.transitions = [
            {
                name: TRANSITIONS.RECORD,
                from: [STATES.INITIAL, STATES.ACCESS_NOT_GRANTED, STATES.ERROR_RECORDING],
                to: STATES.RECORDING
            },
            { name: TRANSITIONS.ACCESS_DENIED, from: '*', to: STATES.ACCESS_NOT_GRANTED },
            { name: TRANSITIONS.STOP, from: STATES.RECORDING, to: STATES.RECORDED },
            { name: TRANSITIONS.RECORDING_ERROR, from: STATES.RECORDED, to: STATES.ERROR_RECORDING },
            { name: TRANSITIONS.PLAY, from: STATES.RECORDED, to: STATES.PLAYING },
            { name: TRANSITIONS.PAUSE, from: STATES.PLAYING, to: STATES.RECORDED },
            { name: TRANSITIONS.UPLOAD, from: [STATES.PLAYING, STATES.RECORDED], to: STATES.UPLOADING },
            { name: TRANSITIONS.UPLOAD_FINISHED, from: STATES.UPLOADING, to: STATES.RECORDED },
            { name: TRANSITIONS.RESET, from: '*', to: STATES.INITIAL },
            { name: TRANSITIONS.CANCEL, from: STATES.UPLOADING, to: STATES.RECORDED }
        ];

        this.methods = {};

        this.methods['onAccessDenied'] = widget.accessDenied.bind(widget);
        this.methods['onBeforeRecord'] = widget.startRecording.bind(widget);
        this.methods['onStop'] = widget.createAudio.bind(widget);
        this.methods['onPlay'] = widget.play.bind(widget);
        this.methods['onCancel'] = widget.cancelUpload.bind(widget);

        this.methods['onEnterInitial'] = widget.reset.bind(widget);
        this.methods['onEnterRecording'] = widget.recording.bind(widget);
        this.methods['onLeaveRecording'] = widget.stopRecording.bind(widget);
        this.methods['onEnterRecorded'] = widget.recorded.bind(widget);
        this.methods['onEnterErrorRecording'] = widget.recordingError.bind(widget);
        this.methods['onEnterPlaying'] = widget.playing.bind(widget);
        this.methods['onLeavePlaying'] = widget.pause.bind(widget);
        this.methods['onEnterUploading'] = widget.upload.bind(widget);
        this.methods['onLeaveUploading'] = widget.uploaded.bind(widget);
    };

    return JavascriptStateMachineConfig;
});
},
'style-guide/v1/doc-control/audio-record/state-machine/States':function(){
define([], function() {
    return {
        INITIAL: 'initial',
        ACCESS_NOT_GRANTED: 'access-not-granted',
        RECORDING: 'recording',
        ERROR_RECORDING: 'error-recording',
        RECORDED: 'recorded',
        PLAYING: 'playing',
        UPLOADING: 'uploading'
    };
});
},
'style-guide/v1/doc-control/audio-record/state-machine/Transitions':function(){
define([], function() {
    return {
        RECORD: 'record',
        RECORDING_ERROR: 'recording-error',
        ACCESS_DENIED: 'access-denied',
        STOP: 'stop',
        PLAY: 'play',
        PAUSE: 'pause',
        UPLOAD: 'upload',
        UPLOAD_FINISHED: 'upload-finished',
        RESET: 'reset',
        CANCEL: 'cancel'
    };
});
},
'style-guide/v1/doc-control/FileUpload':function(){
define([
    'api/doccontrol/Builder',
    'api/file/Builder',
    'doccontrol/file-upload/model/Uploader',
    './file-upload/dojo/Uploader'
], function (
    DocControlBuilder,
    FileBuilder,
    UploaderModel,
    Uploader
) {
    return {
        uploader: null,
        onUploadCallback: null,

        setOnUploadCallback: function(onUploadCallback) {
            this.onUploadCallback = onUploadCallback;
            return this;
        },

        init: function(node) {
            this.uploader = new Uploader(this.onUploadCallback, this._getUploaderModel(), node);
        },

        _getUploaderModel: function() {
            return new UploaderModel(
                new DocControlBuilder().getDocControlFactory(),
                new FileBuilder().getFileFactory()
            );
        }
    };
});

},
'style-guide/v1/doc-control/file-upload/dojo/Uploader':function(){
define([
    'dijit/_WidgetBase',
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/on',
    'dojo/text!./templates/Uploader.html',
    'dojo/topic',
    'library/request/data/Form',
    'library/request/data/Handlers',
    'soso/sosox/ejs/_Templated'
], function(
    _WidgetBase,
    declare,
    domAttr,
    domClass,
    on,
    template,
    topic,
    FormVO,
    Handlers,
    _TemplatedMixin
) {
    return function(onUploadCallback, uploaderModel, node) {
        const View = declare([_WidgetBase, _TemplatedMixin], {
            templateString: template,
            onUploadCallback: onUploadCallback,
            uploaderModel: uploaderModel,
            filesSelected: 0,
            filesUploaded: 0,
            filesFailedToUpload: 0,
            constants: {
                NOTIFICATION_ERROR_UPLOAD: 'Failed to upload %d file%s. Please try again.',
                NOTIFICATION_PROGRESS_UPLOAD: 'Uploading :selected file%s...',
                NOTIFICATION_SUCCESS_UPLOAD: 'Uploaded :uploaded file%s.',
                FORM_ID: 'fileUploadForm',
                FILE_KEY: 'uploadedFiles'
            },

            postCreate: function() {
                on(this.uploadHTMLNode, 'change', this._beginUpload.bind(this));
            },

            selectFile: function(e) {
                this.uploadHTMLNode.click();
            },

            _beginUpload: function(e) {
                const files = e.target.files;

                if (files.length <= 0) {
                    return;
                }

                this.filesSelected = files.length;
                this.filesUploaded = 0;
                this.filesFailedToUpload = 0;

                this._publishProgressNotification();
                domAttr.set(this.uploadButton, 'disabled', 'disabled');

                const filePromises = [];
                for (let i = 0; i < files.length; i++) {
                    filePromises.push(
                        new Promise(function (resolve, reject) {
                            this.uploaderModel.upload(
                                this._generateUploadHandlers(resolve, reject),
                                new FormVO()
                                    .setId(this.constants.FORM_ID)
                                    .setFiles([files[i]])
                                    .setFileKey(this.constants.FILE_KEY)
                            )
                        }.bind(this)).catch(this._addToFilesFailedToUpload.bind(this))
                    )
                }

                Promise.all(filePromises).then(function(fileKeys) {
                    this.uploaderModel.fetchDocumentsFromFileKeys(this._generateDocumentCollectionHandlers(), fileKeys);
                }.bind(this));
            },

            _generateUploadHandlers: function(resolve, reject) {
                return new Handlers(
                    function(results) {
                        this.filesUploaded++;

                        const key = results[0].getKey();
                        key ? resolve(key) : reject();
                    }.bind(this),
                    function progress() {},
                    reject,
                    function error() {
                        reject();
                        this._publishErrorNotification();
                    },
                    reject
                )
            },

            _generateDocumentCollectionHandlers: function() {
                return new Handlers(
                    function(results) {
                        const document = results[0];

                        new Promise(function(resolve, reject) {
                            if (!document['revisionPK']) {
                                this._makeTemporaryDocumentPublic(document.md5).then(resolve);
                            } else {
                                resolve();
                            }
                        }.bind(this)).then(function() {
                            if (typeof this.onUploadCallback == 'function') {
                                this.onUploadCallback(results);
                            }
                            this._publishSuccessNotification();
                            domAttr.remove(this.uploadButton, 'disabled');

                        }.bind(this)).catch(this._publishErrorNotification.bind(this));
                    }.bind(this),
                    null,
                    this._publishErrorNotification.bind(this),
                    this._publishErrorNotification.bind(this),
                    this._publishErrorNotification.bind(this)
                );
            },

            _makeTemporaryDocumentPublic: function(md5) {
                return new Promise(function(resolve, reject) {
                    this.uploaderModel.makeTemporaryDocumentPublic(
                        new Handlers(
                            resolve,
                            function progress() {},
                            reject,
                            reject
                        ),
                        md5
                    );
                }.bind(this));
            },

            _addToFilesFailedToUpload: function() {
                this.filesFailedToUpload++;
            },

            _publishErrorNotification: function() {
                topic.publish(
                    'sos-system-notification',
                    'Failed to upload %d file%s. Please try again.'
                        .replace('%d', this.filesFailedToUpload)
                        .replace('%s', this.filesFailedToUpload > 1 ? 's' : ''),
                    'error',
                    5000
                );
            },

            _publishProgressNotification: function() {
                topic.publish(
                    'sos-system-notification',
                    this.constants.NOTIFICATION_PROGRESS_UPLOAD
                        .replace(':selected', this.filesSelected)
                        .replace('%s', this.filesSelected > 1 ? 's' : ''),
                    'progress',
                    7000
                );
            },

            _publishSuccessNotification: function() {
                topic.publish(
                    'sos-system-notification',
                    this.constants.NOTIFICATION_SUCCESS_UPLOAD
                        .replace(':uploaded', this.filesUploaded)
                        .replace('%s', this.filesSelected > 1 ? 's' : ''),
                    'success',
                    5000
                );
            },
        });

        this.view = new View({
            className: 'sos-doc-control-file-upload-btn'
        }, node);
    };
});
},
'doc-control/config/Topics':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    return {
        DOCUMENT_SELECTOR_CONFIRM: '/doc-control/document-selector/confirm',
        DOCUMENT_SELECTOR_DOCUMENTS_SELECTED: '/doc-control/document-selector/documents/selected',
        FILE_BROWSER_NODE_SELECTED: '/doc-control/file-browser/node/selected',
        FILE_BROWSER_PROJECT_STAGE_SELECTED: '/doc-control/file-browser/project-stage/selected',
        FILE_BROWSER_REVISION_SELECTED: '/doc-control/file-browser/revision/selected'
    };
});

},
'library/DojoTopicWrapper':function(){
define([
    "dojo/topic"
], function(dojoTopic) {
    var DojoTopicWrapper = function() {
    };

    DojoTopicWrapper.prototype.publish = function(topic /* all additional arguments will be received by listeners */) {
        dojoTopic.publish.apply(dojoTopic, arguments);
    };

    DojoTopicWrapper.prototype.subscribe = function(topic, callback) {
        return dojoTopic.subscribe(topic, callback);
    };

    return DojoTopicWrapper;
});
},
'style-guide/v1/forms/DocumentSelector':function(){
define([
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/on',
    'dojo/text!./templates/DocumentSelector.html',
    'dijit/_WidgetBase',
    'doc-control/document-selector/Initialiser',
    'soso/sosox/ejs/_Templated'
], function(declare, domAttr, on, template, _WidgetBase, DocumentSelectorInitialiser, _TemplatedMixin) {
    return declare([_WidgetBase, _TemplatedMixin], {
        templateString: template,
        documentSelectorContainer: null,
        openButton: null,

        postCreate: function() {
            this.inherited(arguments);

            DocumentSelectorInitialiser.setNode(this.documentSelectorContainer);
        },

        _setDisabledAttr: function(disabled) {
            domAttr.set(this.openButton, 'disabled', disabled);
        },

        _onOpenClick: function() {
            DocumentSelectorInitialiser.execute();
        }
    });
});
},
'doc-control/document-selector/Initialiser':function(){
define([
    'dojo/_base/lang',
    'library/DojoTopicWrapper',
    './Controller',
    './TopicSubscriber',
    './dojo/Container',
    '../file-browser/Initialiser'
], function(
    lang,
    TopicWrapper,
    Controller,
    TopicSubscriber,
    WidgetContainer,
    FileBrowserInitialiser
) {
    return {
        node: null,
        initialised: false,
        documentSelectorWidget: null,
        isSingleDocumentMode: false,

        setNode: function(node) {
            this.node = node;
        },

        execute: function() {
            if (!this.initialised) {
                var widgetContainer = new WidgetContainer();
                widgetContainer.setDocumentSelectorContainerNode(this.node);

                this.documentSelectorWidget = widgetContainer.get('document-selector');

                FileBrowserInitialiser.setNode(this.documentSelectorWidget.getDocumentSelectorFileBrowserNode());
                FileBrowserInitialiser.execute();

                var controller = new Controller(
                    widgetContainer,
                    new TopicWrapper()
                );

                var topicSubscriber = new TopicSubscriber(
                    new TopicWrapper(),
                    controller
                );

                topicSubscriber.startup();

                if (this.isSingleDocumentMode) {
                    this.documentSelectorWidget.setSingleDocumentMode();
                }

                this.initialised = true;
            }

            this.documentSelectorWidget.show();
        },

        hide: function() {
            this.documentSelectorWidget.hide();
        },

        onHide: function(callback) {
            return this.documentSelectorWidget.onHide(callback);
        },

        reset: function() {
            FileBrowserInitialiser.reset();
        },

        initSingleDocumentMode: function() {
            this.isSingleDocumentMode = true;
            if (this.initialised) {
                this.documentSelectorWidget.setSingleDocumentMode();
            }
        }
    };
});
},
'doc-control/document-selector/Controller':function(){
define([
    '../config/Topics'
], function(
    TOPICS
) {
    var Controller = function(widgetContainer, pubsub) {
        this.documentSelectorWidget = widgetContainer.get('document-selector');
        this.selectedDocumentsWidget = widgetContainer.get('selected-documents');
        this.pubsub = pubsub;
    };

    Controller.prototype.addSelectedRevision = function(revision) {
        this.selectedDocumentsWidget.addRevision(revision);
    };

    Controller.prototype.selectDocuments = function(revisionCollection) {
        this.pubsub.publish(TOPICS.DOCUMENT_SELECTOR_DOCUMENTS_SELECTED, {
            revisionCollection: revisionCollection
        });

        this.selectedDocumentsWidget.clear();

        this.documentSelectorWidget.hide();
    };

    return Controller;
});
},
'doc-control/document-selector/TopicSubscriber':function(){
define([
    '../config/Topics'
], function(
    TOPICS
) {
    var TopicSubscriber = function(topicWrapper, delegate) {
        this.topicWrapper = topicWrapper;
        this.delegate = delegate;
    };

    TopicSubscriber.prototype.startup = function() {
        this.topicWrapper.subscribe(
            TOPICS.FILE_BROWSER_REVISION_SELECTED,
            function(revision) {
                this.delegate.addSelectedRevision(revision);
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            TOPICS.DOCUMENT_SELECTOR_CONFIRM,
            function(revisionCollection) {
                this.delegate.selectDocuments(revisionCollection);
            }.bind(this)
        );
    };

    return TopicSubscriber;
});
},
'doc-control/document-selector/dojo/Container':function(){
define([
    './DocumentSelector',
    './SelectedDocuments'
], function(
    DocumentSelector,
    SelectedDocuments
) {
    var Container = function() {
        this.documentSelectorContainerNode = null;
        this.selectedDocumentsContainerNode = null;

        this.constants = {
            DOM_ID: {
                DOCUMENT_SELECTOR_CONTAINER: 'documentSelectorContainer',
                SELECTED_DOCUMENTS: 'documentSelectorSelectedDocumentsContainer'
            },
            DOCUMENT_SELECTOR: 'document-selector',
            SELECTED_DOCUMENTS: 'selected-documents'
        };

        this.widgetDocumentSelector = null;
        this.widgetSelectedDocuments = null;

        var _getWidgetDocumentSelector = function() {
            if (!this.widgetDocumentSelector) {
                this.widgetDocumentSelector = new DocumentSelector(
                    this.documentSelectorContainerNode || this.constants.DOM_ID.DOCUMENT_SELECTOR_CONTAINER,
                    this
                );
            }

            return this.widgetDocumentSelector;
        };

        var _getWidgetSelectedDocuments = function() {
            if (!this.widgetSelectedDocuments) {
                this.widgetSelectedDocuments = new SelectedDocuments(
                    this.selectedDocumentsContainerNode || this.constants.DOM_ID.SELECTED_DOCUMENTS
                );
            }

            return this.widgetSelectedDocuments;
        };

        this.supportedWidgets = {};
        this.supportedWidgets[this.constants.DOCUMENT_SELECTOR] = _getWidgetDocumentSelector.bind(this);
        this.supportedWidgets[this.constants.SELECTED_DOCUMENTS] = _getWidgetSelectedDocuments.bind(this);
    };

    Container.prototype.setDocumentSelectorContainerNode = function(node) {
        this.documentSelectorContainerNode = node;
    };

    Container.prototype.setSelectedDocumentsContainerNode = function(node) {
        this.selectedDocumentsContainerNode = node;
    };

    Container.prototype.has = function(name) {
        return this.supportedWidgets[name] !== undefined;
    };

    Container.prototype.get = function(name) {
        if (!this.has(name)) {
            throw new Error('No widget exists named "' + name + '"');
        }

        return this.supportedWidgets[name]();
    };

    return Container;
});
},
'doc-control/document-selector/dojo/DocumentSelector':function(){
define([
    'dojo/_base/declare',
    'dojo/dom-class',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated',
    'style-guide/v1/layout/Dialog',
    'dojo/text!./template/DocumentSelector.html'
], function(
    declare,
    domClass,
    _WidgetBase,
    _Templated,
    Dialog,
    template
) {
    const DOCUMENT_BROWSER_TITLE_SINGLE = 'Select Document';
    const DOCUMENT_BROWSER_TITLE_MULTIPLE = DOCUMENT_BROWSER_TITLE_SINGLE + 's';

    var DocumentSelector = function(node, widgetContainer) {
        this.isSingleDocumentMode = false;

        const Content = declare([_WidgetBase, _Templated], {
            templateString: template,
            documentSelectorSelectedDocumentsContainer: null,

            postCreate: function() {
                // Create new Select Documents instance
                widgetContainer.setSelectedDocumentsContainerNode(this.documentSelectorSelectedDocumentsContainer);
                widgetContainer.get('selected-documents');
            },

            getDocumentSelectorFileBrowserNode: function() {
                return this.documentSelectorFileBrowserContainer;
            },

            setSingleDocumentMode: function() {
                domClass.add(this.dialogFooter, 'display-none');
            }
        });

        this.content = new Content({}, node);
        this.view = new Dialog({
            titleString: DOCUMENT_BROWSER_TITLE_MULTIPLE,
            contentNode: this.content.domNode,
            'class': 'sos-dialog-document-selector'
        });
    };

    DocumentSelector.prototype.show = function() {
        this.view.show();
    };

    DocumentSelector.prototype.hide = function() {
        this.view.hide();
        this.view.emit('hide', {});
    };

    DocumentSelector.prototype.onHide = function(callback) {
        return this.view.on('hide', callback);
    };

    DocumentSelector.prototype.setSingleDocumentMode = function() {
        this.isSingleDocumentMode = true;
        this.view.setTitle(DOCUMENT_BROWSER_TITLE_SINGLE);
        this.content.setSingleDocumentMode();
    };

    DocumentSelector.prototype.getDocumentSelectorFileBrowserNode = function() {
        return this.content.getDocumentSelectorFileBrowserNode();
    };

    return DocumentSelector;
});
},
'doc-control/document-selector/dojo/SelectedDocuments':function(){
define([
    'dojo/_base/array',
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/dom-construct',
    'dojo/text!./template/SelectedDocuments.html',
    'dojo/topic',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated',
    '../../config/Topics',
    './SelectedDocumentRow',
], function(
    array,
    declare,
    lang,
    domAttr,
    domClass,
    domConstruct,
    template,
    topic,
    _WidgetBase,
    _Templated,
    TOPICS,
    SelectedDocumentRow
) {
    const SelectedDocuments = function(node) {
        const View = declare([_WidgetBase, _Templated], {
            templateString: template,
            elementDocumentsSelectedCount: null,
            elementShowHideButton: null,
            elementConfirmSelectionButton: null,
            elementSelectedDocuments: null,
            elementTableBody: null,
            revisionCollection: [],

            data: {
                rowCollection: []
            },

            postMixInProperties: function() {
                this.inherited(arguments);

                this.setCustomViewHelpers({
                    disableAttachButton: lang.hitch(this, function() {
                        return this.revisionCollection.length === 0;
                    })
                });
            },

            clear: function() {
                this.revisionCollection = [];

                this.data.rowCollection.forEach(function(row) {
                    row.destroy();
                });
                this.data.rowCollection = [];

                this._updateInterface();
            },

            addRevision: function(revision) {
                if (this.revisionCollection.indexOf(revision) === -1) {
                    this.revisionCollection.push(revision);

                    const row = new SelectedDocumentRow(
                        { revision: revision },
                        domConstruct.create('tr', {}, this.elementTableBody, 'last')
                    );

                    row.on('remove', this._removeRevision.bind(this));

                    this.data.rowCollection.push(row);

                    this._updateInterface();
                }
            },

            _updateInterface: function() {
                this.elementDocumentsSelectedCount.innerHTML = '%d Document%s Selected'
                    .replace('%d', this.revisionCollection.length)
                    .replace('%s', this.revisionCollection.length === 1 ? '' : 's');

                if (this.revisionCollection.length > 0) {
                    domAttr.remove(this.elementShowHideButton, 'disabled');
                    domAttr.remove(this.elementConfirmSelectionButton, 'disabled');
                } else {
                    if (!domClass.contains(this.elementSelectedDocuments, 'display-none')) {
                        this._toggleShowSelected();
                    }

                    domAttr.set(this.elementShowHideButton, 'disabled', 'disabled');
                    domAttr.set(this.elementConfirmSelectionButton, 'disabled', 'disabled');
                }
            },

            _removeRevision: function(data) {
                const revisionPK = data.revisionPK;

                array.some(this.revisionCollection, function(revision, i) {
                    if (revision.getRevisionPK() == revisionPK) {
                        this.revisionCollection.splice(i, 1);

                        this.data.rowCollection[i].destroy();
                        this.data.rowCollection.splice(i, 1);

                        this._updateInterface();

                        return true;
                    }
                }, this);
            },

            _confirmSelection: function(evt) {
                evt.preventDefault();

                topic.publish(TOPICS.DOCUMENT_SELECTOR_CONFIRM, this.revisionCollection);
            },

            _toggleShowSelected: function() {
                domClass.toggle(this.elementSelectedDocuments, 'display-none');

                this.elementShowHideButton.innerHTML = (domClass.contains(this.elementSelectedDocuments, 'display-none') ? 'Show' : 'Hide') + ' Selected Documents';
            }
        });

        this.view = new View({}, node);
    };

    SelectedDocuments.prototype.addRevision = function(revision) {
        this.view.addRevision(revision);
    };

    SelectedDocuments.prototype.clear = function() {
        this.view.clear();
    };

    return SelectedDocuments;
});
},
'doc-control/document-selector/dojo/SelectedDocumentRow':function(){
define([
    'dojo/_base/declare',
    'dojo/dom-construct',
    'dojo/text!./template/SelectedDocumentRow.html',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated',
    'spencer/doc-control/revision/format/UploadedBy',
    'style-guide/v1/icons/FileTypeToColourClass',
    'style-guide/v1/icons/FileTypeToIconClass',
    '@lib/utility/DateFormat'
], function(
    declare,
    domConstruct,
    template,
    _WidgetBase,
    _Templated,
    UploadedByFormatter,
    FileTypeToColourClass,
    FileTypeToIconClass,
    DateFormat
) {
    const SelectedDocumentTableRow = function(data, node) {
        const View = declare([_WidgetBase, _Templated], {
            templateString: template,
            data: data,

            postMixInProperties: function() {
                this.inherited(arguments);

                const fileTypeToIconClass = new FileTypeToIconClass();
                const fileTypeToColourClass = new FileTypeToColourClass();

                this.setCustomViewHelpers({
                    fileIconClass: (fileType) => {
                        return fileTypeToIconClass.getClass(fileType) + ' '
                            + fileTypeToColourClass.getClass(fileType) + '-foreground';

                    },
                    dateFormatter: function(date) {
                        if (!date) return '';
                        return DateFormat.toShortDateTime(date);
                    },
                    uploadedByFormatter: UploadedByFormatter.format
                });
            },

            destroy: function() {
                this.inherited(arguments);

                domConstruct.destroy(this.domNode);
            },

            _removeRevision: function() {
                this.emit('remove', { revisionPK: this.data.revision.getRevisionPK() });
            }
        });

        this.view = new View(data, node);
        this.view.startup();
    };

    SelectedDocumentTableRow.prototype.on = function(event, callback) {
        this.view.on(event, callback);
    };

    SelectedDocumentTableRow.prototype.destroy = function() {
        this.view.destroy();
    };

    return SelectedDocumentTableRow;
});
},
'spencer/doc-control/revision/format/UploadedBy':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    return {
        format(revision) {
            if (revision.getOrganisationFrom()) {
                const organisationFrom = revision.getOrganisationFrom().getPreferredName?.() ?? revision.getOrganisationFrom().getName?.();
                if (organisationFrom)
                    return organisationFrom;
            }
            return revision.getPersonUploader()?.getDisplayName?.() ?? '';
        }
    };
});

},
'@lib/utility/DateFormat':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class DateFormat {
        static toDDMMYYYY(date) {
            const options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            };
            return date.toLocaleString('en-GB', options);
        }
        static toShortDateTime(date) {
            return new Intl.DateTimeFormat('en-GB', { dateStyle: 'short' }).format(date)
                + ' ' + new Intl.DateTimeFormat('en-GB', { timeStyle: 'short' }).format(date);
        }
    }
    return DateFormat;
});

},
'doc-control/file-browser/Initialiser':function(){
define([
    'dojo/_base/lang',
    'dojo/dom',
    'api/doccontrol/Config',
    'api/doccontrol/Factory',
    'api/project/Config',
    'api/project/Factory',
    'library/DojoTopicWrapper',
    'library/request/dojo/URLConnectionProcessorBuilder',
    'library/request/URLConnectionBuilder',
    'library/request/URLResponseProcessorBuilder',
    './Controller',
    './TopicSubscriber',
    './dojo/FileBrowser',
    './model/FileBrowser'
], function(
    lang,
    dom,
    DocControlConfig,
    DocControlFactory,
    ProjectConfig,
    ProjectFactory,
    TopicWrapper,
    URLConnectionProcessorBuilder,
    URLConnectionBuilder,
    URLResponseProcessorBuilder,
    Controller,
    TopicSubscriber,
    FileBrowserWidget,
    FileBrowserModel
) {
    return {
        fileBrowserWidget: null,
        node: null,

        setNode: function(node) {
            this.node = node;
        },

        execute: function() {
            var docControlBuilder = new DocControlFactory(
                new DocControlConfig(),
                new URLConnectionBuilder(
                    new URLConnectionProcessorBuilder()
                ),
                new URLResponseProcessorBuilder()
            );

            var projectBuilder = new ProjectFactory(
                new ProjectConfig(),
                new URLConnectionBuilder(
                    new URLConnectionProcessorBuilder()
                ),
                new URLResponseProcessorBuilder()
            );

            var fileBrowserModel = new FileBrowserModel(docControlBuilder, projectBuilder);

            this.fileBrowserWidget = new FileBrowserWidget(this.node);

            var controller = new Controller(fileBrowserModel, this.fileBrowserWidget);

            var topicSubscriber = new TopicSubscriber(
                new TopicWrapper(),
                controller
            );

            topicSubscriber.startup();

            controller.fetchMyProjectCollection();
        },

        reset: function() {
            this.fileBrowserWidget?.reset();
        }
    };
});
},
'doc-control/file-browser/Controller':function(){
define([
    'spencer/core/filter/Collection',
    'library/request/data/Handlers'
], function(
    FilterCollection,
    HandlersVO
) {
    var Controller = function(fileBrowserModel, fileBrowserWidget) {
        this.fileBrowserModel = fileBrowserModel;
        this.fileBrowserWidget = fileBrowserWidget;
    };

    Controller.prototype.fetchMyProjectCollection = function() {
        var errorCallback = function() {
            this.fileBrowserWidget.hideLoading();
        }.bind(this);

        this.fileBrowserWidget.showLoading();

        this.fileBrowserModel.fetchMyProjectCollection(
            new HandlersVO(
                function(myProjectCollection) {
                    this.fileBrowserWidget.hideLoading();

                    this.fileBrowserWidget.setMyProjectCollection(myProjectCollection);
                }.bind(this),
                function() {},
                errorCallback,
                errorCallback,
                errorCallback
            )
        );
    };

    Controller.prototype.selectProjectStage = function(projectStage) {
        var errorCallback = function() {
            this.fileBrowserWidget.hideLoading();
        }.bind(this);

        var handlers = new HandlersVO(
            function(tree) {
                this.fileBrowserWidget.hideLoading();

                this.fileBrowserWidget.setTree(tree);
            }.bind(this),
            function() {},
            errorCallback,
            errorCallback,
            errorCallback
        );

        this.fileBrowserWidget.showLoading();

        this.fileBrowserModel.getTree(handlers, projectStage.getProjectStagePK(), true);
    };

    Controller.prototype.selectNode = function(node) {
        var errorCallback = function() {
            this.fileBrowserWidget.hideRevisionCollectionLoading();
        }.bind(this);

        var handlers = new HandlersVO(
            function(revisionCollection) {
                this.fileBrowserWidget.hideRevisionCollectionLoading();

                this.fileBrowserWidget.setRevisionCollection(revisionCollection);
            }.bind(this),
            function() {},
            errorCallback,
            errorCallback,
            errorCallback
        );

        this.fileBrowserWidget.setSelectedNode(node);

        this.fileBrowserWidget.showRevisionCollectionLoading();

        var filterCollection = new FilterCollection();
        filterCollection.addFilter(node);

        this.fileBrowserModel.fetchRevisionCollection(handlers, filterCollection);
    };

    return Controller;
});
},
'doc-control/file-browser/TopicSubscriber':function(){
define([
    '../config/Topics'
], function(
    TOPICS
) {
    var TopicSubscriber = function(topicWrapper, delegate) {
        this.topicWrapper = topicWrapper;
        this.delegate = delegate;
    };

    TopicSubscriber.prototype.startup = function() {
        this.topicWrapper.subscribe(
            TOPICS.FILE_BROWSER_PROJECT_STAGE_SELECTED,
            function(projectStage) {
                this.delegate.selectProjectStage(projectStage);
            }.bind(this)
        );

        this.topicWrapper.subscribe(
            TOPICS.FILE_BROWSER_NODE_SELECTED,
            function(node) {
                this.delegate.selectNode(node);
            }.bind(this)
        );
    };

    return TopicSubscriber;
});
},
'doc-control/file-browser/dojo/FileBrowser':function(){
define([
    'dojo/on',
    'dojo/topic',
    'style-guide/v1/doc-control/FileBrowser',
    '../../config/Topics'
], function(
    on,
    topic,
    FileBrowserWidget,
    TOPICS
) {
    var FileBrowser = function(node) {
        this.view = new FileBrowserWidget({}, node);

        on(this.view, 'revisionSelected', function(revision) {
            topic.publish(TOPICS.FILE_BROWSER_REVISION_SELECTED, revision);
        });

        on(this.view, 'nodeSelected', function(node) {
            topic.publish(TOPICS.FILE_BROWSER_NODE_SELECTED, node);
        });

        on(this.view, 'projectStageSelected', function(projectStage) {
            topic.publish(TOPICS.FILE_BROWSER_PROJECT_STAGE_SELECTED, projectStage);
        });
    };

    FileBrowser.prototype.setMyProjectCollection = function(myProjectCollection) {
        this.view.setMyProjectCollection(myProjectCollection);
    };

    FileBrowser.prototype.setTree = function(tree) {
        this.view.setTree(tree);
    };

    FileBrowser.prototype.setSelectedNode = function(node) {
        this.view.setSelectedNode(node);
    };

    FileBrowser.prototype.setRevisionCollection = function(revisionCollection) {
        this.view.setRevisionCollection(revisionCollection);
    };

    FileBrowser.prototype.showLoading = function() {
        this.view.showLoading();
    };

    FileBrowser.prototype.hideLoading = function() {
        this.view.hideLoading();
    };

    FileBrowser.prototype.showRevisionCollectionLoading = function() {
        this.view.showRevisionCollectionLoading();
    };

    FileBrowser.prototype.hideRevisionCollectionLoading = function() {
        this.view.hideRevisionCollectionLoading();
    };

    FileBrowser.prototype.reset = function() {
        this.view.reset();
    };

    return FileBrowser;
});
},
'style-guide/v1/doc-control/FileBrowser':function(){
define([
    '@lib/doc-control/tree/config/NodeTypes',
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dojo/dom-attr',
    'dojo/dom-style',
    'dojo/dom-construct',
    'dojo/Evented',
    'dijit/form/TextBox',
    'dojo/on',
    'dijit/_WidgetBase',
    'soso/dijit/form/api/project/StageFilteringSelect',
    'soso/sosox/ejs/_Templated',
    'spencer/doc-control/revision/format/UploadedBy',
    'style-guide/v1/icons/FileTypeToColourClass',
    'style-guide/v1/icons/FileTypeToIconClass',
    'style-guide/v1/navigation/ProjectTileContainer',
    'dojo/text!./template/FileBrowser.html',
    'dojo/text!./template/RevisionContainer.html',
    '@lib/utility/DateFormat'
], function(
    NodeTypes,
    declare,
    lang,
    domAttr,
    domStyle,
    domConstruct,
    Evented,
    TextBox,
    on,
    _WidgetBase,
    ProjectStageFilteringSelect,
    _Templated,
    UploadedByFormatter,
    FileTypeToColourClass,
    FileTypeToIconClass,
    ProjectTileContainer,
    template,
    templateRevisionContainer,
    DateFormat
) {
    var RevisionView = declare([_WidgetBase, _Templated, Evented], {
        templateString: templateRevisionContainer,

        data: {
            revisionCollection: [],
            selectedNode: null,
            showLoading: false
        },

        revisionCollection: [],
        searchQuery: null,

        postMixInProperties: function() {
            this.inherited(arguments);

            const fileTypeToIconClass = new FileTypeToIconClass();
            const fileTypeToColourClass = new FileTypeToColourClass();

            this.setCustomViewHelpers({
                fileIconClass: (fileType) => {
                    return fileTypeToIconClass.getClass(fileType) + ' '
                         + fileTypeToColourClass.getClass(fileType) + '-foreground';
                },
                formatDate: (date) => {
                    if (!date) return '';
                    return DateFormat.toShortDateTime(date);
                },
                formatUploadedBy: UploadedByFormatter.format,
                isRevisable: (node) => {
                    return node?.getType() == NodeTypes.DRAWING || node?.getType() == NodeTypes.REVISIONABLE;
                },
                isDrawing: (node) => {
                    return node?.getType() == NodeTypes.DRAWING;
                },
                shouldDisplayRevisionTable: (node) => {
                    return node?.getType() == NodeTypes.CORRESPONDENCE
                        || node?.getType() == NodeTypes.DRAWING
                        || node?.getType() == NodeTypes.OTHER
                        || node?.getType() == NodeTypes.REVISIONABLE;
                }
            });
        },

        setRevisionCollection: function(revisionCollection) {
            this.revisionCollection = revisionCollection;

            this.renderRevisionTable();
        },

        setSelectedNode: function(node) {
            this.data.selectedNode = node;
        },

        showLoading: function() {
            this.data.showLoading = true;
            this.render();
        },

        hideLoading: function() {
            this.data.showLoading = false;
            this.render();
        },

        place: function(node) {
            domConstruct.place(this.domNode, node, 'replace');
        },

        selectRevision: function(evt) {
            var revisionPK = domAttr.get(evt.currentTarget, 'data-revision-id');

            this.revisionCollection.some((revision) => {
                if (revision.getRevisionPK() == revisionPK) {
                    this.emit('revisionSelected', revision);
                    return true;
                }
            });
        },

        setSearchQuery: function(query) {
            this.searchQuery = query.toLowerCase().trim();

            this.renderRevisionTable();
        },

        renderRevisionTable: function() {
            if (!this.searchQuery) {
                this.data.revisionCollection = this.revisionCollection;
            } else {
                this.data.revisionCollection = this.revisionCollection.filter((revision) => {
                    const reference = revision.getReference()?.toLowerCase().trim() || '';
                    return revision.getTitle().toLowerCase().trim().indexOf(this.searchQuery) !== -1
                        || UploadedByFormatter.format(revision).toLowerCase().trim().indexOf(this.searchQuery) !== -1
                        || reference.indexOf(this.searchQuery) !== -1;
                });
            }
            this.render();
        }
    });

    return declare([_WidgetBase, _Templated, Evented], {
        templateString: template,

        data: {
            myProjectCollection: [],
            selectedProjectStage: null,
            tree: null,
            selectedNode: null,
            parentNode: null,
            nodeBreadcrumb: [],
            showLoading: false
        },

        projectTileContainerNode: null,
        projectTileContainer: null,

        revisionContainer: null,
        revisionView: null,

        searchQuery: null,

        postMixInProperties: function() {
            this.inherited(arguments);
            this.setCustomViewHelpers({
                summarise: (string) => {
                    if (typeof string != 'String' || string.length < 30) return string;

                    return string.substring(0, 15) + '...' + string.substring(string.length - 15);
                }
            });
        },

        postCreate: function() {
            this.revisionView = new RevisionView({}, this.revisionContainer);

            on(this.revisionView, 'revisionSelected', lang.hitch(this, function(revision) {
                this.emit('revisionSelected', revision);
            }));

            this._createInputs();
        },

        render: function() {
            this.inherited(arguments);

            this._createInputs();

            if (this.projectTileContainerNode) {
                this.projectTileContainer = new ProjectTileContainer({
                    projectCollection: this.data.myProjectCollection
                }, this.projectTileContainerNode);
                on(this.projectTileContainer, 'selected', (projectStagePK) => this.selectProjectStage(projectStagePK));
            }

            if (this.revisionContainer) {
                this.revisionView.place(this.revisionContainer);
            }
        },

        setMyProjectCollection: function(myProjectCollection) {
            this.data.myProjectCollection = myProjectCollection;

            this.setTree(null);
        },

        setTree: function(tree) {
            this.data.tree = tree;
            this.setSelectedNode(tree);
        },

        setSelectedNode: function(selectedNode) {
            this.data.selectedNode = selectedNode;

            if (selectedNode) {
                this.data.nodeBreadcrumb = this._generateNodeBreadcrumb(selectedNode, []);
                this.setRevisionCollection([]);
            } else {
                this.data.nodeBreadcrumb = [];
                this.render();
            }
        },

        setRevisionCollection: function(revisionCollection) {
            this.render();

            domStyle.set(this.documentFilterContainer, 'display', revisionCollection.length > 0 ? 'flex' : 'none');

            this.revisionView.setSelectedNode(this.data.selectedNode);
            this.revisionView.setRevisionCollection(revisionCollection);
        },

        _clickProjectStage: function(evt) {
            evt.preventDefault();
            this.selectProjectStage(domAttr.get(evt.currentTarget, 'data-id'));
        },

        selectProjectStage: function(projectStagePK) {
            if (this._isSelectedProjectStage(projectStagePK)) {
                this._loadProjectStage(this.data.selectedProjectStage);
            } else {
                this.data.myProjectCollection.some((projectStage) => {
                    if (projectStage.getProjectStagePK() == projectStagePK) {
                        this._loadProjectStage(projectStage);
                        return true;
                    }
                });
            }
        },

        showLoading: function() {
            this.data.showLoading = true;
            this.render();
        },

        hideLoading: function() {
            this.data.showLoading = false;
            this.render();
        },

        showRevisionCollectionLoading: function() {
            this.revisionView.showLoading();
        },

        hideRevisionCollectionLoading: function() {
            this.revisionView.hideLoading();
        },

        place: function(node) {
            domConstruct.place(this.domNode, node, 'replace');
        },

        openChild: function(evt) {
            evt.preventDefault();

            var id = domAttr.get(evt.currentTarget, 'data-id');

            this._selectNodeFromCollection(this.data.selectedNode.getChildren(), id);
        },

        openBreadcrumbNode: function(evt) {
            evt.preventDefault();

            var id = domAttr.get(evt.currentTarget, 'data-id');

            this._selectNodeFromCollection(this.data.nodeBreadcrumb, id);
        },

        openDocControl: function(evt) {
            evt.preventDefault();

            this._resetListings();
        },

        reset: function() {
            this.searchQuery = null;
            this._resetListings();
        },

        _resetListings: function() {
            this.data.selectedProjectStage = null;
            this.setSelectedNode(null);
        },

        _createInputs: function() {
            this.projectStageFilter = new ProjectStageFilteringSelect({
                searchAttr: 'title',
                autoComplete: false,
                required: false,
                placeHolder: 'Search for a project stage...',
                'class': 'sos-form-filtering-select width-50 mx-12 my-6',
                onChangeCallBack: lang.hitch(this, function(psvo) {
                    this._loadProjectStage(psvo);
                })
            }, domConstruct.create('div', {}, this.projectStageFilterInput));

            new TextBox({
                'class': 'sos-form-textfield sos-form-textfield-s m-0',
                value: this.searchQuery,
                onKeyUp: function(e) {
                    this.searchQuery = e.target.value;
                    this.revisionView.setSearchQuery(this.searchQuery);
                }.bind(this)
            }, this.documentFilterNode);
        },

        _selectNodeFromCollection: function(nodeCollection, id) {
            nodeCollection.some((node) => {
                if (node.getProjectStageTreeViewPK() == id) {
                    this.emit('nodeSelected', node);
                    return true;
                }
            });
        },

        _generateNodeBreadcrumb: function(node, breadcrumb) {
            if (node.getParent()) {
                breadcrumb = this._generateNodeBreadcrumb(node.getParent(), breadcrumb);
            }

            breadcrumb.push(node);

            return breadcrumb;
        },

        _isSelectedProjectStage: function(projectStagePK) {
            return this.data.selectedProjectStage && this.data.selectedProjectStage.getProjectStagePK() == projectStagePK;
        },

        _loadProjectStage: function(projectStage) {
            if (this._isSelectedProjectStage(projectStage.getProjectStagePK())) {
                this.setSelectedNode(this.data.nodeBreadcrumb[0]);
            } else {
                this.data.selectedProjectStage = projectStage;

                this.emit('projectStageSelected', projectStage);
            }
        }
    });
});
},
'style-guide/v1/navigation/ProjectTileContainer':function(){
define([
    'dojo/_base/declare',
    'dojo/_base/fx',
    'dojo/_base/lang',
    'dojo/dom-attr',
    'dojo/dom-geometry',
    'dojo/dom-style',
    'dojo/Evented',
    'dojo/fx/easing',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated',
    'dojo/text!./templates/ProjectTileContainer.html'
], function(
    declare,
    fx,
    lang,
    domAttr,
    domGeometry,
    domStyle,
    Evented,
    easing,
    _WidgetBase,
    _Templated,
    template
) {
    return declare([_WidgetBase, _Templated, Evented], {
        animation: null,
        compactMode: false,
        isDisabled: false,
        data: {
            compactMode: false,
            disabled: false,
            projectCollection: [
                {
                    projectStagePK: null,
                    stageNumber: '',
                    title: ''
                }
            ]
        },
        projectCollection: null,
        templateString: template,

        nextButton: null,
        mask: null,
        subject: null,
        previousButton: null,

        buildRendering: function() {
            this.data.compactMode = this.compactMode;
            this.data.projectCollection = this.projectCollection;

            this.inherited(arguments);

            this._initWidgetSizeMonitor();
        },

        destroyRecursive: function() {
            this.inherited(arguments);
            this.domNode.innerHTML = '';
            this.domNode = null;
        },

        setMyProjectsCollection: function(myProjects) {
            this.data.projectCollection = myProjects;
            this.render();
        },

        reset: function() {
            if (this.subject) {
                domStyle.set(this.subject, 'left', '0px');
            }
        },

        _setDisabledAttr: function(disabled) {
            this.data.disabled = disabled;

            this.render();
        },

        _initWidgetSizeMonitor: function() {
            // Calculating dimensions pre-render is not possible.
            // Using a timeout to monitor the changes instead.
            setTimeout(lang.hitch(this, this._monitorWidgetSize), 100);
        },

        _monitorWidgetSize: function() {
            if (this.mask && this.subject) {
                var maskWidth = domGeometry.position(this.mask).w;
                var subjectWidth = domGeometry.position(this.subject).w;
                var subjectLeft = domStyle.get(this.subject, 'left');

                this.previousButton.disabled = this.data.disabled || maskWidth > subjectWidth || subjectLeft === 0;
                this.nextButton.disabled = this.data.disabled || maskWidth > subjectWidth || subjectLeft === this._calculateLastPageScrollOffset();
            }

            this._initWidgetSizeMonitor();
        },

        _onNextButtonClick: function() {
            this._nextPage();
        },

        _onProjectStageSelected: function(e) {
            if (!this.isDisabled) {
                this.emit('selected', domAttr.get(e.target, 'data-project-stage-pk'));
            }
        },

        _onPreviousButtonClick: function() {
            this._previousPage();
        },

        _nextPage: function() {
            var maskWidth = this._getMaskWidth();
            var lastPageScrollOffset = this._calculateLastPageScrollOffset();

            var scrollOffset = this._getScrollOffset() - maskWidth;
            if (scrollOffset <= lastPageScrollOffset) {
                scrollOffset = lastPageScrollOffset;
            }

            this._scroll(scrollOffset);
        },

        _previousPage: function() {
            if (this._getScrollOffset() < 0) {
                var scrollOffset = this._calculatePreviousPageScrollOffset();
                if (scrollOffset > 0) {
                    scrollOffset = 0;
                }

                this._scroll(scrollOffset);
            }
        },

        _getMaskWidth: function() {
            return domGeometry.position(this.mask).w;
        },

        _getScrollSize: function() {
            return domGeometry.position(this.subject).w;
        },

        _getScrollOffset: function() {
            return domStyle.get(this.subject, 'left');
        },

        _calculatePreviousPageScrollOffset: function() {
            return this._getScrollOffset() + this._getMaskWidth();
        },

        _calculateLastPageScrollOffset: function() {
            var scrollSize = this._getScrollSize();
            var maskWidth = this._getMaskWidth();

            if (maskWidth > scrollSize) {
                return 0;
            }

            return -(scrollSize - maskWidth);
        },

        _scroll: function(scrollOffset) {
            if (!this.animation || this.animation.status() !== 'playing') {
                this.animation = fx.animateProperty({
                    easing: easing.quadIn,
                    node: this.subject,
                    properties: {
                        left: scrollOffset
                    }
                });
                this.animation.play();
            }
        }
    });
});

},
'dojo/fx/easing':function(){
define(["../_base/lang"], function(lang){

// module:
//		dojo/fx/easing

var easingFuncs = {
	// summary:
	//		Collection of easing functions to use beyond the default
	//		`dojo._defaultEasing` function.
	// description:
	//		Easing functions are used to manipulate the iteration through
	//		an `dojo.Animation`s _Line. _Line being the properties of an Animation,
	//		and the easing function progresses through that Line determining
	//		how quickly (or slowly) it should go. Or more accurately: modify
	//		the value of the _Line based on the percentage of animation completed.
	//
	//		All functions follow a simple naming convention of "ease type" + "when".
	//		If the name of the function ends in Out, the easing described appears
	//		towards the end of the animation. "In" means during the beginning,
	//		and InOut means both ranges of the Animation will applied, both
	//		beginning and end.
	//
	//		One does not call the easing function directly, it must be passed to
	//		the `easing` property of an animation.
	// example:
	//	|	dojo.require("dojo.fx.easing");
	//	|	var anim = dojo.fadeOut({
	//	|		node: 'node',
	//	|		duration: 2000,
	//	|		//	note there is no ()
	//	|		easing: dojo.fx.easing.quadIn
	//	|	}).play();
	//

	linear: function(/* Decimal? */n){
		// summary:
		//		A linear easing function
		return n;
	},

	quadIn: function(/* Decimal? */n){
		return Math.pow(n, 2);
	},

	quadOut: function(/* Decimal? */n){
		return n * (n - 2) * -1;
	},

	quadInOut: function(/* Decimal? */n){
		n = n * 2;
		if(n < 1){ return Math.pow(n, 2) / 2; }
		return -1 * ((--n) * (n - 2) - 1) / 2;
	},

	cubicIn: function(/* Decimal? */n){
		return Math.pow(n, 3);
	},

	cubicOut: function(/* Decimal? */n){
		return Math.pow(n - 1, 3) + 1;
	},

	cubicInOut: function(/* Decimal? */n){
		n = n * 2;
		if(n < 1){ return Math.pow(n, 3) / 2; }
		n -= 2;
		return (Math.pow(n, 3) + 2) / 2;
	},

	quartIn: function(/* Decimal? */n){
		return Math.pow(n, 4);
	},

	quartOut: function(/* Decimal? */n){
		return -1 * (Math.pow(n - 1, 4) - 1);
	},

	quartInOut: function(/* Decimal? */n){
		n = n * 2;
		if(n < 1){ return Math.pow(n, 4) / 2; }
		n -= 2;
		return -1 / 2 * (Math.pow(n, 4) - 2);
	},

	quintIn: function(/* Decimal? */n){
		return Math.pow(n, 5);
	},

	quintOut: function(/* Decimal? */n){
		return Math.pow(n - 1, 5) + 1;
	},

	quintInOut: function(/* Decimal? */n){
		n = n * 2;
		if(n < 1){ return Math.pow(n, 5) / 2; }
		n -= 2;
		return (Math.pow(n, 5) + 2) / 2;
	},

	sineIn: function(/* Decimal? */n){
		return -1 * Math.cos(n * (Math.PI / 2)) + 1;
	},

	sineOut: function(/* Decimal? */n){
		return Math.sin(n * (Math.PI / 2));
	},

	sineInOut: function(/* Decimal? */n){
		return -1 * (Math.cos(Math.PI * n) - 1) / 2;
	},

	expoIn: function(/* Decimal? */n){
		return (n == 0) ? 0 : Math.pow(2, 10 * (n - 1));
	},

	expoOut: function(/* Decimal? */n){
		return (n == 1) ? 1 : (-1 * Math.pow(2, -10 * n) + 1);
	},

	expoInOut: function(/* Decimal? */n){
		if(n == 0){ return 0; }
		if(n == 1){ return 1; }
		n = n * 2;
		if(n < 1){ return Math.pow(2, 10 * (n - 1)) / 2; }
		--n;
		return (-1 * Math.pow(2, -10 * n) + 2) / 2;
	},

	circIn: function(/* Decimal? */n){
		return -1 * (Math.sqrt(1 - Math.pow(n, 2)) - 1);
	},

	circOut: function(/* Decimal? */n){
		n = n - 1;
		return Math.sqrt(1 - Math.pow(n, 2));
	},

	circInOut: function(/* Decimal? */n){
		n = n * 2;
		if(n < 1){ return -1 / 2 * (Math.sqrt(1 - Math.pow(n, 2)) - 1); }
		n -= 2;
		return 1 / 2 * (Math.sqrt(1 - Math.pow(n, 2)) + 1);
	},

	backIn: function(/* Decimal? */n){
		// summary:
		//		An easing function that starts away from the target,
		//		and quickly accelerates towards the end value.
		//
		//		Use caution when the easing will cause values to become
		//		negative as some properties cannot be set to negative values.
		var s = 1.70158;
		return Math.pow(n, 2) * ((s + 1) * n - s);
	},

	backOut: function(/* Decimal? */n){
		// summary:
		//		An easing function that pops past the range briefly, and slowly comes back.
		// description:
		//		An easing function that pops past the range briefly, and slowly comes back.
		//
		//		Use caution when the easing will cause values to become negative as some
		//		properties cannot be set to negative values.

		n = n - 1;
		var s = 1.70158;
		return Math.pow(n, 2) * ((s + 1) * n + s) + 1;
	},

	backInOut: function(/* Decimal? */n){
		// summary:
		//		An easing function combining the effects of `backIn` and `backOut`
		// description:
		//		An easing function combining the effects of `backIn` and `backOut`.
		//		Use caution when the easing will cause values to become negative
		//		as some properties cannot be set to negative values.
		var s = 1.70158 * 1.525;
		n = n * 2;
		if(n < 1){ return (Math.pow(n, 2) * ((s + 1) * n - s)) / 2; }
		n-=2;
		return (Math.pow(n, 2) * ((s + 1) * n + s) + 2) / 2;
	},

	elasticIn: function(/* Decimal? */n){
		// summary:
		//		An easing function the elastically snaps from the start value
		// description:
		//		An easing function the elastically snaps from the start value
		//
		//		Use caution when the elasticity will cause values to become negative
		//		as some properties cannot be set to negative values.
		if(n == 0 || n == 1){ return n; }
		var p = .3;
		var s = p / 4;
		n = n - 1;
		return -1 * Math.pow(2, 10 * n) * Math.sin((n - s) * (2 * Math.PI) / p);
	},

	elasticOut: function(/* Decimal? */n){
		// summary:
		//		An easing function that elasticly snaps around the target value,
		//		near the end of the Animation
		// description:
		//		An easing function that elasticly snaps around the target value,
		//		near the end of the Animation
		//
		//		Use caution when the elasticity will cause values to become
		//		negative as some properties cannot be set to negative values.
		if(n==0 || n == 1){ return n; }
		var p = .3;
		var s = p / 4;
		return Math.pow(2, -10 * n) * Math.sin((n - s) * (2 * Math.PI) / p) + 1;
	},

	elasticInOut: function(/* Decimal? */n){
		// summary:
		//		An easing function that elasticly snaps around the value, near
		//		the beginning and end of the Animation.
		// description:
		//		An easing function that elasticly snaps around the value, near
		//		the beginning and end of the Animation.
		//
		//		Use caution when the elasticity will cause values to become
		//		negative as some properties cannot be set to negative values.
		if(n == 0) return 0;
		n = n * 2;
		if(n == 2) return 1;
		var p = .3 * 1.5;
		var s = p / 4;
		if(n < 1){
			n -= 1;
			return -.5 * (Math.pow(2, 10 * n) * Math.sin((n - s) * (2 * Math.PI) / p));
		}
		n -= 1;
		return .5 * (Math.pow(2, -10 * n) * Math.sin((n - s) * (2 * Math.PI) / p)) + 1;
	},

	bounceIn: function(/* Decimal? */n){
		// summary:
		//		An easing function that 'bounces' near the beginning of an Animation
		return (1 - easingFuncs.bounceOut(1 - n)); // Decimal
	},

	bounceOut: function(/* Decimal? */n){
		// summary:
		//		An easing function that 'bounces' near the end of an Animation
		var s = 7.5625;
		var p = 2.75;
		var l;
		if(n < (1 / p)){
			l = s * Math.pow(n, 2);
		}else if(n < (2 / p)){
			n -= (1.5 / p);
			l = s * Math.pow(n, 2) + .75;
		}else if(n < (2.5 / p)){
			n -= (2.25 / p);
			l = s * Math.pow(n, 2) + .9375;
		}else{
			n -= (2.625 / p);
			l = s * Math.pow(n, 2) + .984375;
		}
		return l;
	},

	bounceInOut: function(/* Decimal? */n){
		// summary:
		//		An easing function that 'bounces' at the beginning and end of the Animation
		if(n < 0.5){ return easingFuncs.bounceIn(n * 2) / 2; }
		return (easingFuncs.bounceOut(n * 2 - 1) / 2) + 0.5; // Decimal
	}
};

lang.setObject("dojo.fx.easing", easingFuncs);

return easingFuncs;
});

},
'doc-control/file-browser/model/FileBrowser':function(){
define([
    'api/doccontrol/filter/IncludeDocumentCount',
    'api/doccontrol/filter/ShowOnlyNodesContainingDocuments',
    'spencer/core/filter/Collection',
    '@lib/doc-control/tree/data/Node'
], function(
    FilterIncludeDocumentCount,
    FilterShowOnlyNodesContainingDocuments,
    FilterCollection,
    NodeVO
) {
    var FileBrowser = function(docControlBuilder, projectBuilder) {
        this.tree = docControlBuilder.getTree();

        this.treeNodeRevisionCollection = docControlBuilder.getTreeNodeRevisionCollection();
        this.myProjectCollection = projectBuilder.getMyProjectCollection();
    };

    FileBrowser.prototype.fetchMyProjectCollection = function(handlers) {
        this.myProjectCollection.fetch(handlers);
    };

    FileBrowser.prototype.getTree = function(handlers, projectStagePK) {
        let fc = new FilterCollection();
        fc.addFilter(new FilterIncludeDocumentCount());
        fc.addFilter(new FilterShowOnlyNodesContainingDocuments());
        this.tree.get(handlers, projectStagePK, fc);
    };

    FileBrowser.prototype.fetchRevisionCollection = function(handlers, filterCollection) {
        var node = filterCollection.getFilterByClass(NodeVO);

        var childrenDocumentCount = 0;

        var children = node.getChildren();
        if (children) {
            for (var i in children) {
                if (children.hasOwnProperty(i)) {
                    childrenDocumentCount += parseInt(children[i].getDocumentCount());
                }
            }
        }

        if (node.getDocumentCount() > childrenDocumentCount) {
            this.treeNodeRevisionCollection.fetch(handlers, filterCollection);
        } else {
            handlers.getSuccess()([]);
        }
    };

    return FileBrowser;
});
},
'doccontrol/viewer/dojo/pin/Comment':function(){
define([
    'dojo/_base/declare',
    'dojo/dom-class',
    'dojo/dom-construct',
    'dijit/_WidgetBase',
    'dojo/text!./template/Comment.html',
    'soso/sosox/ejs/Helpers',
    'soso/sosox/ejs/_Templated',
    'spencer/date-time/RelativeTime'
], function(
    declare,
    domClass,
    domConstruct,
    WidgetBase,
    Template,
    Helpers,
    Templated,
    RelativeTime
) {
    const Comment = function(node, comment) {
        const View = declare([WidgetBase, Templated], {
            templateString: Template,
            data: {
                comment: comment
            },
            displayNameNode: null,
            relativeTime: null,

            postMixInProperties: function() {
                this.inherited(arguments);

                this.setCustomViewHelpers({
                    formatComment: function(string) {
                        string = string.replace(/</g, '&lt;').replace(/>/g, '&gt;');
                        return new Helpers().nl2br(string);
                    }
                });
            },

            postCreate: function () {
                const relativeTime = new RelativeTime({}, this.relativeTime);
                relativeTime.start(comment.getTime());
                relativeTime.includeActualTimeTooltip();
            },

            destroy: function() {
                this.inherited(arguments);
                domConstruct.destroy(this.domNode);
            }
        });

        this.view = new View({}, domConstruct.create('div', {}, node, 'last'));
    };

    Comment.prototype.destroy = function() {
        this.view.destroy();
    };

    Comment.prototype.scrollIntoView = function() {
        return this.view.domNode.scrollIntoView();
    };

    return Comment;
});
},
'spencer/date-time/RelativeTime':function(){
define([
    'dojo/date/locale',
    'dojo/html',
    'dojo/on',
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated',
    'dojo/text!./templates/RelativeTime.html',
    'style-guide/v1/tooltip/Tooltip',
    './TimeAgo'
], function(
    locale,
    html,
    on,
    declare,
    lang,
    _WidgetBase,
    _TemplatedMixin,
    template,
    Tooltip,
    TimeAgo
) {
    return declare('spencer.date-time.relative-time', [_WidgetBase, _TemplatedMixin], {
        REFRESH_INTERVAL: 30000,

        MINUTES_IN_AN_HOUR: 60,
        MINUTES_IN_A_DAY: 60 * 24,

        uppercaseFirstLetter: false,
        excludeTime: false,
        minutesAgoOnly: false,
        includeTooltip: false,
        prefix: null,
        startAtMinute: 0,

        templateString: template,
        data: {
            prefix: null,
            text: null
        },

        dateTime: null,
        timeout: null,

        postMixInProperties: function() {
            this.data.prefix = this.prefix;

            this.inherited(arguments);
        },

        start: function(dateTime) {
            this.dateTime = dateTime;

            this._beginLastUpdatedUpdate();
            this.show();
        },

        stop: function() {
            this._endLastUpdatedUpdate();
        },

        includeActualTimeTooltip: function () {
            this.includeTooltip = true;
            this.render();
        },

        render: function () {
            this.inherited(arguments);

            if (this.includeTooltip) {
                const timestamp = this._getTooltipTimestamp();

                on(this.domNode, 'mouseenter', function (e) {
                    new Tooltip({
                        target: e.target,
                        position: 'top',
                        data: {
                            content: timestamp
                        },
                        hover: true
                    });
                })
            }
        },

        show: function() {
            this.domNode.classList.remove('hide');
        },

        hide: function() {
            this.domNode.classList.add('hide');
        },

        _beginLastUpdatedUpdate: function() {
            this.data.text = this._generateData();

            this.render();

            this.timeout = setTimeout(
                lang.hitch(this, this._beginLastUpdatedUpdate),
                this.REFRESH_INTERVAL
            );
        },

        _endLastUpdatedUpdate: function() {
            if (this.timeout) {
                clearTimeout(this.timeout);
            }
        },

        _generateData: function() {
            const timeAgo = new TimeAgo(new Date());
            const numberDaysAgo = timeAgo.getDaysAgo(this.dateTime);
            const numberMinutesAgo = timeAgo.getMinutesAgo(this.dateTime);

            let result = '';
            if (numberMinutesAgo >= this.startAtMinute) {
                if (this.minutesAgoOnly || (!this.excludeTime && numberDaysAgo === 0 && (numberMinutesAgo < this.MINUTES_IN_AN_HOUR && numberMinutesAgo > -this.MINUTES_IN_AN_HOUR))) {
                    result = this._getMinutesAgo(numberMinutesAgo);
                } else if (!this.excludeTime && numberMinutesAgo <= this.MINUTES_IN_A_DAY && numberMinutesAgo >= -this.MINUTES_IN_A_DAY) {
                    result = this._getHoursAgo(numberMinutesAgo);
                } else {
                    result = this._getDaysAgo(numberDaysAgo);

                    if (!this.excludeTime) {
                        result += ' at ' + this._getTime();
                    }
                }

                if (this.uppercaseFirstLetter) {
                    return this._capitalizeFirstLetter(result);
                }
            }

            return result;
        },

        _getMinutesAgo: function(numberMinutesAgo) {
            if (numberMinutesAgo < 0) {
                return 'in ' + -numberMinutesAgo + ' minutes';
            } else if (numberMinutesAgo === 0) {
                return 'less than a minute ago';
            } else if (numberMinutesAgo === 1) {
                return '1 minute ago';
            }

            if (numberMinutesAgo > this.MINUTES_IN_AN_HOUR) {
                return 'over an hour ago';
            }

            return numberMinutesAgo + ' minutes ago';
        },

        _getHoursAgo: function(numberMinutesAgo) {
            const minutes = numberMinutesAgo % this.MINUTES_IN_AN_HOUR;
            const hours = (numberMinutesAgo - minutes) / this.MINUTES_IN_AN_HOUR;

            let result = hours +
                ' hour' +
                (hours === 1 ? '' : 's');

            if (minutes) {
                result += ' and ' +
                    minutes +
                    ' minute' +
                    (minutes === 1 ? '' : 's');
            }

            return result + ' ago';
        },

        _getDaysAgo: function(daysAgo) {
            if (daysAgo < -7 || daysAgo > 7) {
                return this._getOnDate();
            }

            switch(daysAgo) {
                case -1:
                    return 'tomorrow';
                case 0:
                    return 'today';
                case 1:
                    return 'yesterday';
            }

            if (daysAgo < 0) {
                return this._getThisDayName();
            }

            return this._formatDaysAgo(daysAgo);
        },

        _getTime: function() {
            return locale.format(this.dateTime, {
                selector: 'time',
                timePattern: 'H:mma'
            });
        },

        _getOnDate: function() {
            return 'on ' + locale.format(this.dateTime, {
                selector: 'date',
                datePattern: 'd/M/yyy'
            })
        },

        _getThisDayName: function() {
            return 'this ' + locale.format(this.dateTime, {
                    selector: 'date',
                    datePattern: 'EEEE'
                });
        },

        _getTooltipTimestamp: function () {
            return locale.format(this.dateTime, {
                selector: 'date',
                datePattern: 'dd/MM/yyy HH:mm'
            });
        },

        _formatDaysAgo: function(daysAgo) {
            return daysAgo + ' days ago';
        },

        _capitalizeFirstLetter: function (string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    })
});
},
'spencer/date-time/TimeAgo':function(){
define([
], function() {
    var TimeAgo = function(currentDateTime) {
        this.currentDateTime = currentDateTime;

        this.constants = {
            ONE_DAY_IN_MILLISECONDS: 24 * 60 * 60 * 1000,
            ONE_MINUTE_IN_MILLISECONDS: 60 * 1000,
            ONE_SECOND_IN_MILLISECONDS: 1000,
            SECONDS_IN_A_MINUTE: 60
        };

        this.calculateDifference = function(dateTime, unit) {
            return Math.round(
                (this.currentDateTime.getTime() - dateTime.getTime()) / unit
            );
        };

        this.calculateDayDifference = function(dateTime) {
            return this.calculateDifference(dateTime, this.constants.ONE_DAY_IN_MILLISECONDS);
        };

        this.calculateMinuteDifference = function(dateTime) {
            return this.calculateDifference(dateTime, this.constants.ONE_MINUTE_IN_MILLISECONDS);
        };

        this.calculateSecondDifference = function(dateTime) {
            return this.calculateDifference(dateTime, this.constants.ONE_SECOND_IN_MILLISECONDS);
        };
    };

    TimeAgo.prototype.getDaysAgo = function(dateTime) {
        return this.calculateDayDifference(dateTime);
    };

    TimeAgo.prototype.getMinutesAgo = function(dateTime) {
        if (Math.abs(this.calculateSecondDifference(dateTime)) < this.constants.SECONDS_IN_A_MINUTE) {
            return 0;
        }

        return this.calculateMinuteDifference(dateTime);
    };

    return TimeAgo;
});
},
'doccontrol/viewer/dojo/RevisionHistorySidebar':function(){
define([
    '../Topics',
    'dijit/_WidgetBase',
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/text!./template/RevisionHistorySidebar.html',
    'dojo/topic',
    'soso/sosox/ejs/_Templated',
    'spencer/format/PersonDisplayName'
], function(
    Topics,
    WidgetBase,
    declare,
    domAttr,
    Template,
    topic,
    Templated,
    PersonDisplayNameFormatter
) {
    const RevisionHistorySidebar = function(routeContainer, node) {
        const View = declare([WidgetBase, Templated], {
            templateString: Template,
            routeContainer: routeContainer,
            data: {
                revisionCollection: [],
                currentRevision: null
            },
            postMixInProperties: function() {
                this.inherited(arguments);

                this.setCustomViewHelpers({
                    formatDate: (date) => date.toLocaleDateString('en-GB') + ' ' + date.toLocaleTimeString('en-GB'),
                    formatPerson: function(person) {
                        const personDisplayNameFormatter = new PersonDisplayNameFormatter();
                        return personDisplayNameFormatter.setDisplayName(person.getDisplayName())
                            .setJobTitle(person.getJobTitle())
                            .format();
                    },
                    revisionDownloadUrl: (id) => {
                        return this.routeContainer.get('downloadRevision', {id: id});
                    }
                });
            },

            setRevisionCollection: function(revisionCollection) {
                this.data.revisionCollection = revisionCollection;
            },

            setCurrentRevision: function(currentRevision) {
                this.data.currentRevision = currentRevision;
            },

            reload: function() {
                this.render();
            },

            viewDocument: function(e) {
                e.preventDefault();
                const dataNode = e.target.closest('a');
                topic.publish(Topics.DOCUMENT_VIEWER_VIEW_WITH_REVISION_HISTORY, {
                    revisionPK: domAttr.get(dataNode, 'data-revision-pk'),
                    href: domAttr.get(dataNode, 'href'),
                    fileType: domAttr.get(dataNode, 'data-file-type'),
                    md5: domAttr.get(dataNode, 'data-md5')
                });
            }
        });

        this.view = new View({}, node);
    };

    RevisionHistorySidebar.prototype.setRevisionCollection = function(revisionCollection) {
        this.view.setRevisionCollection(revisionCollection);
        return this;
    };

    RevisionHistorySidebar.prototype.setCurrentRevision = function(currentRevision) {
        this.view.setCurrentRevision(currentRevision);
        return this;
    };

    RevisionHistorySidebar.prototype.reload = function() {
        this.view.reload();
        return this;
    };

    RevisionHistorySidebar.prototype.destroy = function() {
        this.view.destroyRecursive();
    };

    return RevisionHistorySidebar;
});
},
'doccontrol/viewer/dojo/Viewer':function(){
define([
    './_scalingMixin',
    './SignatureNotification',
    './ViewerDialog',
    '../Topics',
    './ViewInformation',
    'dijit/_WidgetBase',
    'dijit/_TemplatedMixin',
    'dijit/form/NumberTextBox',
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dojo/Deferred',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/dom-construct',
    'dojo/dom-style',
    'dojo/html',
    'dojo/keys',
    'dojo/on',
    'dojo/query',
    'dojo/sniff',
    'dojo/topic',
    'dojo/text!./template/ViewerDialogBody.html',
    'pdf/Viewer'
], function(
    _scalingMixin,
    SignatureNotification,
    Dialog,
    Topics,
    ViewInformationWidget,
    WidgetBase,
    Templated,
    NumberTextBox,
    declare,
    lang,
    Deferred,
    domAttr,
    domClass,
    domConstruct,
    domStyle,
    html,
    keys,
    on,
    query,
    has,
    topic,
    Template,
    pdfViewer
){
    const Viewer = function(routeContainer, dataManager) {
        const View = declare([WidgetBase, _scalingMixin, Templated], {
            routeContainer: routeContainer,
            dataManager: dataManager,
            annotationWorkspace: null,
            popup: null,
            megabytesFormatter: null,
            viewerInformationWidget: null,
            ocrDialog: null,
            ocrContainer: null,
            inline: false,
            widgetsInTemplate: true,
            signatureNotification: null,
            templateString: Template,
            showRevisionSidebar: false,
            eventHandles: [],

            reloadHref: null,
            revisionPK: null,
            revision: null,
            temporaryDocument: null,

            /** @var PDFDocumentProxy */
            pdfDocument: null,
            image: null,
            imageDataUrl: null,
            imageCanvas: null,
            canvasContext: null,
            isImageType: false,
            pageNum: 1,
            pageRendering: false,
            pageNumPending: null,
            scale: null,
            rotate: 0,
            scaleDirection: 'page',
            number: null,
            scrolling: false,
            viewport: null,
            totalPages: 0,

            dragMode: false,

            constants: {
                CURSOR_SCROLL: 'drag',
                SCALE_DIRECTION_WIDTH: 'width',
                SCALE_DIRECTION_PAGE: 'page',
                SCALE_INTERVAL: 0.2,
                ROTATE_DEGREES: 90,
                MIN_ZOOM: 1,
                LONG_LOAD_MESSAGE_TIMEOUT: 15
            },

            elementCancel: null,
            longLoadMessage: null,
            longLoadMessageTimer: null,

            destroyRecursive: function() {
                if (this.contentContainer) {
                    this.contentContainer.innerHTML = '';
                    this.contentContainer = null;
                }

                this.inherited(arguments);

                this.eventHandles.forEach(eh => eh.remove());
                this.eventHandles = [];

                if (this.viewerInformationWidget) {
                    this.viewerInformationWidget.destroyRecursive();
                    this.viewerInformationWidget = null;
                }

                if (this.annotationWorkspace) {
                    this.annotationWorkspace.destroy();
                    this.annotationWorkspace.domNode = null;
                    this.annotationWorkspace = null;
                }

                this.templateString = null;
            },

            hideLoading: function() {
                this.abortLongLoadMessageTimer();

                if (this.popup) {
                    domClass.add(this.loading, 'hidden');
                }
            },

            hideRendering: function() {
                if (this.popup) {
                    domClass.add(this.loadingContainer, 'hidden');
                    domClass.add(this.rendering, 'hidden');
                }
            },

            showRendering: function() {
                if (this.popup) {
                    domClass.add(this.loadingContainer, 'hidden');
                    domClass.remove(this.rendering, 'hidden');
                }
            },

            hideInformation: function() {
                domClass.add(this.informationContainer, 'hidden');
                domClass.remove(this.navigationFooter, 'hidden');
                domClass.remove(this.contentContainer, 'hidden');
                this.scrollContainer.scrollTop = 0;
            },

            hideDocument: function() {
                domClass.add(this.documentNode, 'hidden');
                domClass.add(this.contentContainer, 'invisible');
            },

            showDocument: function() {
                domClass.remove(this.documentNode, 'hidden');
                domClass.remove(this.contentContainer, 'invisible');
            },

            _reload: function() {
                domClass.add(this.abortMessage, 'hidden');
                domClass.add(this.longLoadMessage, 'hidden');

                domClass.remove(this.loading, 'hidden');
                topic.publish(Topics.DOCUMENT_VIEWER_RELOAD_DOCUMENT, this.reloadHref, this.revision);
            },

            showPasswordForm: function(prompt) {
                if (this.popup) {
                    if (this.passwordPromise) {
                        domClass.add(this.passwordInputValidationContainer, 'sos-form-textfield-validation-error');
                        html.set(this.passwordPrompt, prompt);
                    }

                    domClass.add(this.loading, 'hidden');
                    domClass.remove(this.passwordForm, 'hidden');
                    this.passwordInput.value = '';
                    this.passwordInput.focus();

                    return this.passwordPromise = new Deferred();
                }
            },

            _setPassword: function() {
                this.passwordPromise.resolve(this.passwordInput.value);
            },

            showErrorMessage: function() {
                if (this.popup) {
                    domClass.remove(this.errorMessage, 'hidden');
                }
            },

            showUnauthorisedMessage: function() {
                this.viewerInformationWidget?.showUnauthorisedMessage();

                if (this.popup) {
                    domClass.remove(this.unauthorisedMessage, 'hidden');
                }
            },

            showAbortMessage: function() {
                if (
                    this.popup && domClass.contains(this.errorMessage, 'hidden')
                    && !(this.imageDataUrl || this.pdfDocument)
                ) {
                    domClass.remove(this.abortMessage, 'hidden');
                }
            },

            showBlacklistedMessage: function() {
                this.hideLoading();
                domClass.add(this.rendering, 'hidden');
                domClass.remove(this.loadingContainer, 'hidden');

                this.showErrorMessage();
            },

            showDeletedMessage: function() {
                domClass.add(this.loading, 'hidden');

                if (this.popup) {
                    domClass.remove(this.deletedMessage, 'hidden');
                }
            },

            startLongLoadMessageTimer: function() {
                this.abortLongLoadMessageTimer();

                this.longLoadMessageTimer = setTimeout(function() {
                    if (this.inline || !this.longLoadMessage) return;

                    domClass.remove(this.longLoadMessage, 'hidden');
                }.bind(this), this.constants.LONG_LOAD_MESSAGE_TIMEOUT * 1000);
            },

            abortLongLoadMessageTimer: function() {
                clearTimeout(this.longLoadMessageTimer);
            },

            getScrollableOverlay: function() {
                return this.scrollContainer;
            },

            setReloadHref: function(reloadHref) {
                this.reloadHref = reloadHref;
            },

            getWorkspace: function() {
                return this.documentWorkspace;
            },

            setImageDataUrl: function(dataUrl) {
                topic.publish(Topics.DOCUMENT_VIEWER_ENABLE_TOOLBARS);
                this.showViewOptionsToolbar();

                this.imageDataUrl = dataUrl;
                this.renderPage();
            },

            getImage: function() {
                return this.image;
            },

            viewAsImage: function() {
                this.isImageType = true;
            },

            isImage: function() {
                return this.isImageType;
            },

            setPdfDocument: function(pdfDocument) {
                topic.publish(Topics.DOCUMENT_VIEWER_ENABLE_TOOLBARS);
                if (this.popup) {
                    this.pdfDocument = pdfDocument;
                    this.pageCount.textContent = this.pdfDocument.numPages;
                    this.totalPages = parseInt(this.pdfDocument.numPages);

                    this.showViewOptionsToolbar();

                    this.createInputs();

                    this.renderPage(this.pageNum);

                    this._determineFooterState();

                    this._determineNavigationButtonStates();
                }
            },

            getInformation: function() {
                return this.viewerInformationWidget;
            },

            getDocumentDetails: function() {
                return this.revision || this.temporaryDocument;
            },

            setRevisionPK: function(revisionPK) {
                this.revisionPK = revisionPK;
            },

            setRevision: function(revision) {
                this.revision = revision;
                this.viewerInformationWidget.setRevision(revision);
            },

            setTemporaryDocument: function(temporaryDocument) {
                this.temporaryDocument = temporaryDocument;
            },

            postCreate: function() {
                this.popup = new Dialog({content: this.domNode});
                on(this.popup, 'hide', function() {
                    topic.publish(Topics.DOCUMENT_VIEWER_HIDE);
                });

                this.viewerInformationWidget = new ViewInformationWidget(
                    this.routeContainer,
                    this.informationContainer,
                    this.dataManager
                );

                if (!(has('ie') || has('trident') || has('edge'))) {
                    require(['ocr/dojo/Dialog'], function(ocr) {
                        this.ocrDialog = ocr;
                    }.bind(this));
                }

                this.inherited(arguments);
            },

            createEvents: function() {
                this.own(
                    on(window, 'resize', function() {
                        this.automargin();
                    }.bind(this)),

                    on(this.passwordInput, 'keyup', function(e) {
                        if (e.keyCode === keys.ENTER) {
                            e.preventDefault();
                            this._setPassword();
                        }
                    }.bind(this))
                );
            },

            createInputs: function() {
                this.number = new NumberTextBox({
                    'class': 'sos-form-textfield sos-form-textfield-s sos-form-textfield-validation sos-form-textfield-validation-s',
                    intermediateChanges: true,
                    style: 'min-width: 4em; width: 6em',
                    constraints: {min: 1, max: this.totalPages},
                    value: 1
                }, this.numberInput);

                this.eventHandles.push(
                    on(this.number, 'keyup', lang.hitch(this, function(key) {
                        if (key.key === 'Enter') {
                            this._setPage(this.number.get('value'));
                        }
                    })),
                    on(this.number, 'blur', lang.hitch(this, function() {
                        this._setPage(this.number.get('value'));
                    }))
                );
            },

            createScrollEvents: function() {
                var click = false, touch = false;
                var lastClientX;
                var lastClientY;

                this.scrollContainer.addEventListener('touchstart', function (evt) {
                    touch = true;
                    lastClientX = evt.touches[0].clientX;
                    lastClientY = evt.touches[0].clientY;
                });
                this.scrollContainer.addEventListener('mousedown', function (evt) {
                    if (touch) {
                        return;
                    }

                    if (this.dragMode) {
                        click = true;
                        lastClientX = evt.clientX;
                        lastClientY = evt.clientY;

                        evt.preventDefault();
                    }
                }.bind(this));

                this.scrollContainer.addEventListener('touchend', function(evt) {
                    touch = false;
                });
                this.scrollContainer.addEventListener('mouseup', function(evt) {
                    click = false;
                });

                this.scrollContainer.addEventListener('touchmove', function(evt) {
                    if (touch && this._dragToScroll()) {
                        this.scrollContainer.scrollLeft += (lastClientX - evt.changedTouches[0].clientX);
                        lastClientX = evt.changedTouches[0].clientX;
                        this.scrollContainer.scrollTop += (lastClientY - evt.changedTouches[0].clientY);
                        lastClientY = evt.changedTouches[0].clientY;
                    }
                }.bind(this));
                this.scrollContainer.addEventListener('mousemove', function(evt) {
                    if (click && this.dragMode) {
                        this.scrollContainer.scrollLeft += (lastClientX - evt.clientX);
                        lastClientX = evt.clientX;
                        this.scrollContainer.scrollTop += (lastClientY - evt.clientY);
                        lastClientY = evt.clientY;
                    }
                }.bind(this));
            },

            _inOcrMode: function() {
                return domClass.contains(this.documentWorkspace, 'ocr-source-container');
            },

            _inAnnotationMode: function() {
                return domClass.contains(this.popup.domNode, 'annotations-toolbar-showing');
            },

            _dragToScroll: function() {
                return this.dragMode
                    || !(this._inOcrMode() || this._inAnnotationMode());
            },

            _determineFooterState: function () {
                domClass.toggle(this.popup.domNode, 'multipage', this.totalPages > 1);
            },

            showViewOptionsToolbar: function() {
                domClass.add(this.popup.domNode, 'view-options-toolbar-showing');
                this.automargin();
            },

            hideViewOptionsToolbar: function() {
                domClass.remove(this.popup.domNode, 'view-options-toolbar-showing');
                this.automargin();
            },

            showAnnotationsToolbar: function() {
                domClass.add(this.popup.domNode, 'annotations-toolbar-showing');
                this.automargin();
            },

            hideAnnotationsToolbar: function() {
                domClass.remove(this.popup.domNode, 'annotations-toolbar-showing');
                this.automargin();
            },

            showNavigation: function() {
                domClass.add(this.popup.domNode, 'navigation-showing');
            },

            disableDragMode: function() {
                this.dragMode = false;
            },

            enableDragMode: function() {
                this.dragMode = true;
                if (this.scrollContainer) {
                    domStyle.set(this.scrollContainer, 'cursor', this.constants.CURSOR_SCROLL);
                }
            },

            automargin: function(height) {
                if (height == undefined) { // window resize
                    if (this.isImage()) {
                        height = this.image ? this.image.height * this.scale : 0;
                    } else {
                        height = this.viewport ? this.viewport.height : 0;
                    }
                }

                domStyle.set(
                    this.documentWorkspace,
                    'margin-top',
                    Math.max(0, Math.floor((this._getScrollContainerContentHeight() - height) / 2)) + 'px'
                );
            },

            /**
             * Get page info from document, resize/rotate canvas accordingly, and render page.
             * @param num Page number.
             */
            renderPage: function(num) {
                if (this.popup) {
                    this.hideDocument();
                    this.showRendering();

                    this.pageRendering = true;

                    if (this.isImage()) {
                        this._renderImage();
                    } else {
                        this._renderPdf(num);
                    }
                }
            },

            _renderImage: function() {
                this.image = new Image();
                this.image.src = this.imageDataUrl;

                this.image.onerror = function() {
                    this.hideDocument();
                    this.showBlacklistedMessage();

                    topic.publish(Topics.DOCUMENT_VIEWER_DISABLE_VIEWER_TOOLBARS);
                }.bind(this);

                this.image.onload = function() {
                    if (!this.scaleDirection) {
                        this.scaleDirection = this.constants.SCALE_DIRECTION_PAGE;
                    }

                    if (!this.scale) {
                        this.scale = this._getCalculatedScale(this.image.naturalWidth, this.image.naturalHeight);
                    }

                    let width = this.rotate % 180 !== 0 ? this.image.naturalHeight * this.scale : this.image.naturalWidth * this.scale;
                    let height = this.rotate % 180 !== 0 ? this.image.naturalWidth * this.scale : this.image.naturalHeight * this.scale;

                    this.imageCanvas = domConstruct.create('canvas', {}, this.documentNode, 'only');
                    this.imageCanvas.width = width;
                    this.imageCanvas.height = height;

                    this.canvasContext = this.imageCanvas.getContext('2d');
                    this.canvasContext.fillStyle = "white";
                    this.canvasContext.fillRect(0, 0, width, height);
                    this.canvasContext.translate(width / 2, height / 2);
                    this.canvasContext.rotate(this.rotate * Math.PI / 180);
                    this.canvasContext.drawImage(
                        this.image,
                        -this.image.naturalWidth * this.scale / 2,
                        -this.image.naturalHeight * this.scale / 2,
                        this.image.naturalWidth * this.scale,
                        this.image.naturalHeight * this.scale
                    );

                    topic.publish(Topics.DOCUMENT_VIEWER_ZOOM_VALUE, this._precisionFloor((this.scale * 100), 2));
                    topic.publish(Topics.DOCUMENT_VIEWER_PAGE_DATA_CHANGE, {
                        scale: this.scale,
                        height: height,
                        width: width,
                        rotation: this.rotate,
                        pageNum: 1
                    });

                    domStyle.set(this.documentWorkspace, {
                        height: Math.floor(height) + 'px',
                        width: Math.floor(width) + 'px'
                    });

                    this.automargin(height);

                    this.hideRendering();
                    this.showDocument();

                    if (this.ocrContainer) {
                        this.ocrContainer.setSource(query('canvas', this.documentNode)[0]);
                    }
                    this.pageRendering = false;
                }.bind(this);
            },

            _getSignatureNotification: function() {
                if (!this.signatureNotification) {
                    this.signatureNotification = new SignatureNotification(
                        this.reloadHref,
                        domConstruct.create('div', {}, this.contentContainer, 'last')
                    );
                }

                return this.signatureNotification;
            },

            _renderPdf: function(num) {
                // Using promise to fetch the page
                this.pdfDocument.getPage(num).then(lang.hitch(this, function (page) {
                    page.getAnnotations().then(function(annotations) {
                        if (annotations.some(function(annotation) { return annotation.fieldType === 'Sig'; })) {
                            this._getSignatureNotification().setPageNumber(num).show();
                        } else {
                            this._getSignatureNotification().hide();
                        }
                    }.bind(this));

                    var rotate = (page.rotate + this.rotate) % 360;

                    if (!this.scale) {
                        var originalSize = page.getViewport({ scale: 1, rotation: rotate });
                        this.scale = this._getCalculatedScale(originalSize.width, originalSize.height);
                    }

                    topic.publish(Topics.DOCUMENT_VIEWER_ZOOM_VALUE, this._precisionFloor((this.scale * 100), 2));

                    this.viewport = page.getViewport({ scale: this.scale, rotation: rotate });

                    domStyle.set(this.documentWorkspace, {
                        height: Math.floor(this.viewport.height) + 'px',
                        width: Math.floor(this.viewport.width) + 'px'
                    });

                    this.automargin(this.viewport.height);
                    domConstruct.empty(this.documentNode);

                    const view = new pdfViewer(this.documentNode);
                    view.view(page, this.scale, this.rotate).then(function(canvas) {
                        if (this.popup) {
                            this.pageRendering = false;
                            this.hideRendering();
                            this.showDocument();
                            if (this.pageNumPending !== null) {
                                // New page rendering is pending
                                this.renderPage(this.pageNumPending);
                                this.pageNumPending = null;

                            } else {
                                topic.publish(Topics.DOCUMENT_VIEWER_PAGE_DATA_CHANGE, {
                                    scale: this.scale,
                                    height: this.viewport.height,
                                    width: this.viewport.width,
                                    rotation: rotate,
                                    pageNum: num
                                });

                                if (this.ocrContainer) {
                                    this.ocrContainer.setSource(canvas);
                                }
                            }
                        }
                    }.bind(this));
                }));
            },

            getAllPages: function() {
                return new Promise(function(resolve, reject) {
                    const pages = [];

                    const pageNumbers = [];
                    for (let pageNumber = 1; pageNumber <= this.totalPages; pageNumber++) {
                        pageNumbers.push(pageNumber);
                    }

                    pageNumbers.reduce(function(accumulator, pageNumber) {
                        return accumulator.then(function() {
                            return this.pdfDocument.getPage(pageNumber).then(function(page) {
                                pages.push({
                                    pageRotate: page.rotate,
                                    pageHeight: page.view[page.rotate % 180 == 0 ? 3 : 2],
                                    pageWidth: page.view[page.rotate % 180 == 0 ? 2 : 3]
                                });
                            }.bind(this));
                        }.bind(this));
                    }.bind(this), Promise.resolve()).then(function() {
                        resolve(pages);
                    });
                }.bind(this));
            },

            show: function() {
                this.popup.show();

                this.createEvents();
                this.createScrollEvents();

                this._initSubscriptions();

                this.inherited(arguments);
            },

            /**
             * If another page rendering in progress, waits until the rendering is
             * finised. Otherwise, executes rendering immediately.
             */
            queueRenderPage: function(num) {
                if (this.pageRendering) {
                    this.pageNumPending = num;
                } else {
                    this.renderPage(num);
                }
            },

            exitOcrMode: function() {
                domClass.remove(this.documentWorkspace, 'ocr-source-container');
            },

            ocr: function() {
                if (this.ocrDialog !== null) {
                    if (domClass.contains(this.documentWorkspace, 'ocr-source-container')) {
                        this.exitOcrMode();
                        return;
                    }

                    domClass.add(this.documentWorkspace, 'ocr-source-container');

                    if (!this.ocrContainer) {
                        this.ocrContainer = new this.ocrDialog(query('canvas', this.documentNode)[0]);
                    }
                }
            },

            showInline: function() {
                this.inline = true;
                if (this.popup) this.popup.showInline();
            },

            hideInline: function() {
                this.inline = false;
                if (this.popup) this.popup.hideInline();
            },

            setWidth: function(percentage) {
                this.popup?.setWidth(percentage);
            },

            unsetWidth: function() {
                this.popup?.unsetWidth();
            },

            enableStandalone: function() {
                if (this.popup) this.popup.set('closable', false);
                if (this.elementCancel) this.elementCancel.classList.add('display-none');
            },

            setAnnotationWorkspace: function(annotationWorkspace) {
                this.annotationWorkspace = annotationWorkspace;
            },

            _initSubscriptions: function() {
                this.own(
                    topic.subscribe(Topics.DOCUMENT_VIEWER_ZOOM_IN, lang.hitch(this, '_zoomIn')),
                    topic.subscribe(Topics.DOCUMENT_VIEWER_ZOOM_OUT, lang.hitch(this, '_zoomOut')),
                    topic.subscribe(Topics.DOCUMENT_VIEWER_FIT_WIDTH, lang.hitch(this, '_fitWidth')),
                    topic.subscribe(Topics.DOCUMENT_VIEWER_FIT_PAGE, lang.hitch(this, '_fitPage')),
                    topic.subscribe(Topics.DOCUMENT_VIEWER_ROTATE_CLOCKWISE, lang.hitch(this, '_rotateClockwise')),
                    topic.subscribe(Topics.DOCUMENT_VIEWER_ZOOM_SPECIFIC, lang.hitch(this, '_setZoom')),
                    topic.subscribe(Topics.DOCUMENT_VIEWER_HIDE, lang.hitch(this, '_destroyDialog'))
                );
            },

            _setZoom: function(value) {
                if (value >= this.constants.MIN_ZOOM) {
                    this.scale = value / 100;
                    this.queueRenderPage(this.pageNum);
                }
            },

            _setPage: function(value) {
                this.annotationWorkspace.exitTextMode();

                if (
                    Number.isInteger(value) &&
                    this.pageNum !== value &&
                    (value >= 1 && value <= this.totalPages)
                ) {
                    this.pageNum = value;
                    this.number.set('value', this.pageNum, false);
                    this.queueRenderPage(value);
                    this._determineNavigationButtonStates();

                    this.scrollContainer.scrollTop = 0;
                }
            },

            _next: function() {
                if (this.pdfDocument) {
                    this._setPage(this.pageNum + 1);
                }
            },

            _previous: function() {
                if (this.pdfDocument) {
                    this._setPage(this.pageNum - 1);
                }
            },

            _fitWidth: function() {
                this.scale = null;
                this.scaleDirection = this.constants.SCALE_DIRECTION_WIDTH;
                this.queueRenderPage(this.pageNum);
            },

            _fitPage: function() {
                this.scale = null;
                this.scaleDirection = this.constants.SCALE_DIRECTION_PAGE;
                this.queueRenderPage(this.pageNum);
            },

            _zoomIn: function() {
                this.scale += this.constants.SCALE_INTERVAL;

                topic.publish(Topics.DOCUMENT_VIEWER_ZOOM_VALUE, this._precisionFloor((this.scale * 100), 2));
                this.queueRenderPage(this.pageNum);
            },

            _zoomOut: function() {
                if (this.scale <= this.constants.SCALE_INTERVAL) {
                    return;
                }

                this.scale -= this.constants.SCALE_INTERVAL;

                topic.publish(Topics.DOCUMENT_VIEWER_ZOOM_VALUE, this._precisionFloor((this.scale * 100), 2));
                this.queueRenderPage(this.pageNum);
            },

            _rotateClockwise: function() {
                this.rotate = (this.rotate + this.constants.ROTATE_DEGREES) % 360;
                this.queueRenderPage(this.pageNum);
            },

            _determineNavigationButtonStates: function() {
                this._setNextButtonState();
                this._setPreviousButtonState();
            },

            _setNextButtonState: function() {
                domAttr.set(this.nextButton, 'disabled', this.pageNum === this.totalPages);
            },

            _setPreviousButtonState: function() {
                domAttr.set(this.previousButton, 'disabled', this.pageNum === 1);
            },

            _precisionFloor: function(number, precision) {
                var factor = Math.pow(10, precision);
                return Math.floor(number * factor) / factor;
            },

            _destroyDialog: function() {
                domConstruct.destroy(this.popup.domNode);
                if (this.annotationWorkspace) {
                    this.annotationWorkspace.destroy();
                }
                this.destroyRecursive();
                this.popup.destroyRecursive();
                this.popup.domNode = null;
                this.popup = null;

                if (this.passwordPromise) {
                    this.passwordPromise.cancel();
                    this.passwordPromise = null;
                    delete this.passwordPromise;
                }

                if (this.ocrContainer) {
                    this.ocrContainer.destroy();
                }
            },

            _onCancelClick: function() {
                topic.publish(Topics.DOCUMENT_VIEWER_HIDE);
            }
        });

        this.view = new View();
    };

    Viewer.prototype.destroyRecursive = function() {
        this.view.destroyRecursive();
        this.view = null;
    };

    Viewer.prototype.enableDragMode = function() {
        this.view.enableDragMode();
    };

    Viewer.prototype.disableDragMode = function() {
        this.view.disableDragMode();
    };

    Viewer.prototype.setReloadHref = function(reloadHref) {
        this.view.setReloadHref(reloadHref);
    };

    Viewer.prototype.setPdfDocument = function(pdfDocument) {
        this.view.setPdfDocument(pdfDocument);
    };

    Viewer.prototype.getInformation = function() {
        return this.view.getInformation();
    };

    Viewer.prototype.setDataUrl = function(dataUrl) {
        this.view.setImageDataUrl(dataUrl);
        this.view.hideLoading();
    };

    Viewer.prototype.getImage = function() {
        return this.view.getImage();
    };

    Viewer.prototype.viewAsImage = function() {
        this.view.viewAsImage();
    };

    Viewer.prototype.isImage = function() {
        return this.view.isImage();
    };

    Viewer.prototype.setRevision = function(revision) {
        this.view.setRevision(revision);
    };

    Viewer.prototype.setTemporaryDocument = function(temporaryDocument) {
        this.view.setTemporaryDocument(temporaryDocument);
    };

    Viewer.prototype.getDocumentDetails = function() {
        return this.view.getDocumentDetails();
    };

    Viewer.prototype.showErrorMessage = function() {
        this.view.showErrorMessage();
        this.view.hideLoading();
    };

    Viewer.prototype.showAbortMessage = function() {
        this.view.showAbortMessage();
        this.view.hideLoading();
    };

    Viewer.prototype.showUnauthorisedMessage = function() {
        this.view.showUnauthorisedMessage();
        this.view.hideLoading();
    };

    Viewer.prototype.setRevisionPK = function(revisionPK){
      this.view.setRevisionPK(revisionPK);
    };

    Viewer.prototype.showBlacklistedMessage = function() {
        this.view.showBlacklistedMessage();
    };

    Viewer.prototype.showDeletedMessage = function() {
        this.view.showDeletedMessage();
    };

    Viewer.prototype.startLongLoadMessageTimer = function() {
        this.view.startLongLoadMessageTimer();
    };

    Viewer.prototype.show = function() {
        this.view.show();
    };

    Viewer.prototype.showDocument = function() {
        this.view.showDocument();
    };

    Viewer.prototype.hide = function() {
        this.view.hideDocument();
    };

    Viewer.prototype.hideInformation = function() {
        this.view.hideInformation();
        this.view.showDocument();
    };

    Viewer.prototype.getScrollableOverlay = function(){
        return this.view.getScrollableOverlay();
    };

    Viewer.prototype.getWorkspace = function(){
        return this.view.getWorkspace();
    };

    Viewer.prototype.showViewOptionsToolbar = function() {
        this.view.showViewOptionsToolbar();
    };

    Viewer.prototype.hideViewOptionsToolbar = function() {
        this.view.hideViewOptionsToolbar();
    };

    Viewer.prototype.showAnnotationsToolbar = function() {
        this.view.showAnnotationsToolbar();
    };

    Viewer.prototype.hideAnnotationsToolbar = function() {
        this.view.hideAnnotationsToolbar();
    };

    Viewer.prototype.showPasswordForm = function(prompt) {
        return this.view.showPasswordForm(prompt);
    };

    Viewer.prototype.showNavigation = function() {
        this.view.showNavigation();
    };

    Viewer.prototype.ocr = function() {
        this.view.ocr();
    };

    Viewer.prototype.exitOcrMode = function() {
        this.view.exitOcrMode();
    };

    Viewer.prototype.getAllPages = function() {
        return this.view.getAllPages();
    };

    Viewer.prototype.renderCurrentPage = function() {
        this.view.renderPage(this.view.pageNum);
    };

    Viewer.prototype.showInline = function() {
        this.view.showInline();
    };

    Viewer.prototype.hideInline = function() {
        this.view.hideInline();
    };

    Viewer.prototype.setWidth = function(percentage) {
        this.view.setWidth(percentage);
    };

    Viewer.prototype.unsetWidth = function() {
        this.view.unsetWidth();
    };

    Viewer.prototype.enableStandalone = function() {
        this.view.enableStandalone();
    };

    Viewer.prototype.showRevisionSidebar = function() {
        this.view.showRevisionSidebar = true;
    };

    Viewer.prototype.setAnnotationWorkspace = function(annotationWorkspace) {
        this.view.setAnnotationWorkspace(annotationWorkspace);
    };

    Viewer.prototype.supportsRevisionSidebar = function() {
        return this.view.showRevisionSidebar;
    };

    return Viewer;
});

},
'doccontrol/viewer/dojo/_scalingMixin':function(){
define([
    'dojo/_base/declare',
    'dojo/dom-style'
], function (
    declare,
    domStyle
) {
    return declare([], {
        scaleDirection: null,
        constants: {
            SCALE_DIRECTION_WIDTH: 'width',
            SCALE_DIRECTION_PAGE: 'page'
        },

        _precisionFloor: function(number, precision) {
            const factor = Math.pow(10, precision);
            return Math.floor(number * factor) / factor;
        },

        _getScrollContainerContentWidth: function() {
            domStyle.set(this.scrollContainer, 'overflow-y', 'scroll');
            const width = this.scrollContainer.clientWidth;
            domStyle.set(this.scrollContainer, 'overflow-y', '');

            return width;
        },

        _calculateWidthScale: function(documentWidth, documentHeight) {
            let widthScale = this._precisionFloor(this.scrollContainer.offsetWidth / documentWidth, 4);

            if ((widthScale * documentHeight) > this.scrollContainer.offsetHeight) {
                widthScale = this._precisionFloor(this._getScrollContainerContentWidth() / documentWidth, 4);
            }

            return widthScale;
        },

        _getScrollContainerContentHeight: function() {
            domStyle.set(this.scrollContainer, 'overflow-x', 'scroll');
            const height = this.scrollContainer.clientHeight;
            domStyle.set(this.scrollContainer, 'overflow-x', '');

            return height;
        },

        _calculateHeightScale: function(documentWidth, documentHeight) {
            let heightScale = this._precisionFloor(this.scrollContainer.offsetHeight / documentHeight, 4);

            if ((heightScale * documentWidth) > this.scrollContainer.offsetWidth) {
                heightScale = this._precisionFloor(this._getScrollContainerContentHeight() / documentHeight, 4);
            }

            return heightScale;
        },

        _getCalculatedScale: function(documentWidth, documentHeight) {
            const widthScale = this._calculateWidthScale(documentWidth, documentHeight);

            if (this.scaleDirection === this.constants.SCALE_DIRECTION_WIDTH) {
                return widthScale;
            }

            return Math.min(widthScale, this._calculateHeightScale(documentWidth, documentHeight));
        }
    });
});
},
'doccontrol/viewer/dojo/SignatureNotification':function(){
define([
    '../Topics',
    'dijit/_TemplatedMixin',
    'dojo/_base/declare',
    'dojo/text!./template/SignatureNotification.html',
    'dojo/topic',
    'style-guide/v1/alerts/Dismissable'
], function(
    TOPICS,
    Templated,
    declare,
    template,
    topic,
    Dismissable
) {
    const Notification = function(downloadUrl, node) {
        const View = declare([Dismissable, Templated], {
            templateString: template,
            pageNumber: null,
            pagesDismissed: [],

            show: function() {
                if (this.pagesDismissed.indexOf(this.pageNumber) === -1) {
                    this.inherited(arguments);
                }
            },

            setPageNumber: function(pageNumber) {
                this.pageNumber = pageNumber;
            },

            download: function() {
                this.hide();

                this._manuallyDismiss();

                window.open(downloadUrl, '_blank');

                topic.publish(TOPICS.DOCUMENT_VIEWER_DOWNLOAD);
            },

            _manuallyDismiss: function () {
                this.pagesDismissed.push(this.pageNumber);
            }
        });

        this.view = new View({}, node);
        this.view.startup();
    };

    Notification.prototype.setPageNumber = function(pageNumber) {
        this.view.setPageNumber(pageNumber);
        return this;
    };

    Notification.prototype.show = function() {
        this.view.show();
    };

    Notification.prototype.hide = function() {
        this.view.hide();
    };

    return Notification;
});
},
'style-guide/v1/alerts/Dismissable':function(){
define([
    'dojo/_base/array',
    'dojo/_base/declare',
    'dojo/_base/fx',
    'dojo/_base/lang',
    'dojo/dom-construct',
    'dojo/dom-style',
    'dojo/Evented',
    'dojo/query',
    'dijit/_WidgetBase'
], function(
    array,
    declare,
    fx,
    lang,
    domConstruct,
    domStyle,
    Evented,
    query,
    WidgetBase
) {
    return declare('style-guide.v1.alerts.Dismissable', [WidgetBase, Evented], {
        postCreate: function() {
            query('.sos-alert-dismiss-btn', this.domNode).on('click', this.hide.bind(this));
        },

        hide: function() {
            fx.fadeOut({
                node: this.domNode,
                onEnd: lang.hitch(this, function() {
                    domStyle.set(this.domNode, 'display', 'none');

                    this.emit('dismiss');
                })
            }).play();
        },

        show: function() {
            domStyle.set(this.domNode, 'display', 'block');

            fx.fadeIn({
                node: this.domNode
            }).play();
        }
    });
});

},
'pdf/Viewer':function(){
define([
    'pdfjs-dist/build/pdf',
    './viewer/AnnotationLayerFactory'
], function(pdfjs, AnnotationLayerFactory) {
    const Viewer = function(node) {
        this.node = node;
        // pdf_viewer's require logic doesn't play nicely with ours, so bypass by placing pdfjs in global window object
        window["pdfjs-dist/build/pdf"] = pdfjs;

        this.loaded = new Promise(function(resolve, reject) {
            require(['pdfjs-dist/web/pdf_viewer'], function(pdfjsViewer) {
                resolve(pdfjsViewer);
            }.bind(this));
        }.bind(this));
    };

    Viewer.prototype.view = function(/** PDFPageProxy **/ page, scale, rotate) {
        // PDFPageView scales pdf to 150% of requested scale!
        scale *= 0.75;

        return this.loaded.then(function(viewer) {
            const pdfPageView = new viewer.PDFPageView({
                container: this.node,
                id: page.pageNumber,
                scale: scale,
                defaultViewport: page.getViewport({ scale: scale, rotation: rotate }),
                annotationLayerFactory: new AnnotationLayerFactory(viewer),
                eventBus: new viewer.EventBus()
            });

            // PDFPageView doesn't cater for rotation on instantiation.
            if (rotate != 0) {
                pdfPageView.update({ rotation: rotate });
            }

            // Associate PDFPageProxy with pdfPageView
            pdfPageView.setPdfPage(page);

            // Draw PDFPageProxy and return canvas in promise resolution
            return pdfPageView.draw()
                .then(function() {
                    return pdfPageView.canvas;
                });
        }.bind(this));
    };

    return Viewer;
});


},
'vendor/pdfjs-dist/legacy/build/pdf':function(){
/**
 * @licstart The following is the entire license notice for the
 * JavaScript code in this page
 *
 * Copyright 2023 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * JavaScript code in this page
 */

(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = root.pdfjsLib = factory();
	else if(typeof define === 'function' && define.amd)
		define("pdfjs-dist/build/pdf", [], () => { return (root.pdfjsLib = factory()); });
	else if(typeof exports === 'object')
		exports["pdfjs-dist/build/pdf"] = root.pdfjsLib = factory();
	else
		root["pdfjs-dist/build/pdf"] = root.pdfjsLib = factory();
})(globalThis, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ([
/* 0 */,
/* 1 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.VerbosityLevel = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.RenderingIntentFlag = exports.PromiseCapability = exports.PermissionFlag = exports.PasswordResponses = exports.PasswordException = exports.PageActionEventType = exports.OPS = exports.MissingPDFException = exports.MAX_IMAGE_SIZE_TO_CACHE = exports.LINE_FACTOR = exports.LINE_DESCENT_FACTOR = exports.InvalidPDFException = exports.ImageKind = exports.IDENTITY_MATRIX = exports.FormatError = exports.FeatureTest = exports.FONT_IDENTITY_MATRIX = exports.DocumentActionEventType = exports.CMapCompressionType = exports.BaseException = exports.BASELINE_FACTOR = exports.AnnotationType = exports.AnnotationReplyType = exports.AnnotationPrefix = exports.AnnotationMode = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationEditorType = exports.AnnotationEditorPrefix = exports.AnnotationEditorParamsType = exports.AnnotationBorderStyleType = exports.AnnotationActionEventType = exports.AbortException = void 0;
exports.assert = assert;
exports.bytesToString = bytesToString;
exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
exports.getModificationDate = getModificationDate;
exports.getUuid = getUuid;
exports.getVerbosityLevel = getVerbosityLevel;
exports.info = info;
exports.isArrayBuffer = isArrayBuffer;
exports.isArrayEqual = isArrayEqual;
exports.isNodeJS = void 0;
exports.normalizeUnicode = normalizeUnicode;
exports.objectFromMap = objectFromMap;
exports.objectSize = objectSize;
exports.setVerbosityLevel = setVerbosityLevel;
exports.shadow = shadow;
exports.string32 = string32;
exports.stringToBytes = stringToBytes;
exports.stringToPDFString = stringToPDFString;
exports.stringToUTF8String = stringToUTF8String;
exports.unreachable = unreachable;
exports.utf8StringToString = utf8StringToString;
exports.warn = warn;
__w_pdfjs_require__(2);
__w_pdfjs_require__(84);
__w_pdfjs_require__(86);
__w_pdfjs_require__(87);
__w_pdfjs_require__(89);
__w_pdfjs_require__(93);
__w_pdfjs_require__(101);
__w_pdfjs_require__(102);
__w_pdfjs_require__(105);
__w_pdfjs_require__(107);
__w_pdfjs_require__(109);
__w_pdfjs_require__(113);
__w_pdfjs_require__(116);
__w_pdfjs_require__(123);
const isNodeJS = typeof process === "object" && process + "" === "[object process]" && !process.versions.nw && !(process.versions.electron && process.type && process.type !== "browser");
exports.isNodeJS = isNodeJS;
const IDENTITY_MATRIX = [1, 0, 0, 1, 0, 0];
exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
const FONT_IDENTITY_MATRIX = [0.001, 0, 0, 0.001, 0, 0];
exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
const MAX_IMAGE_SIZE_TO_CACHE = 10e6;
exports.MAX_IMAGE_SIZE_TO_CACHE = MAX_IMAGE_SIZE_TO_CACHE;
const LINE_FACTOR = 1.35;
exports.LINE_FACTOR = LINE_FACTOR;
const LINE_DESCENT_FACTOR = 0.35;
exports.LINE_DESCENT_FACTOR = LINE_DESCENT_FACTOR;
const BASELINE_FACTOR = LINE_DESCENT_FACTOR / LINE_FACTOR;
exports.BASELINE_FACTOR = BASELINE_FACTOR;
const RenderingIntentFlag = {
  ANY: 0x01,
  DISPLAY: 0x02,
  PRINT: 0x04,
  SAVE: 0x08,
  ANNOTATIONS_FORMS: 0x10,
  ANNOTATIONS_STORAGE: 0x20,
  ANNOTATIONS_DISABLE: 0x40,
  OPLIST: 0x100
};
exports.RenderingIntentFlag = RenderingIntentFlag;
const AnnotationMode = {
  DISABLE: 0,
  ENABLE: 1,
  ENABLE_FORMS: 2,
  ENABLE_STORAGE: 3
};
exports.AnnotationMode = AnnotationMode;
const AnnotationEditorPrefix = "pdfjs_internal_editor_";
exports.AnnotationEditorPrefix = AnnotationEditorPrefix;
const AnnotationEditorType = {
  DISABLE: -1,
  NONE: 0,
  FREETEXT: 3,
  STAMP: 13,
  INK: 15
};
exports.AnnotationEditorType = AnnotationEditorType;
const AnnotationEditorParamsType = {
  RESIZE: 1,
  CREATE: 2,
  FREETEXT_SIZE: 11,
  FREETEXT_COLOR: 12,
  FREETEXT_OPACITY: 13,
  INK_COLOR: 21,
  INK_THICKNESS: 22,
  INK_OPACITY: 23
};
exports.AnnotationEditorParamsType = AnnotationEditorParamsType;
const PermissionFlag = {
  PRINT: 0x04,
  MODIFY_CONTENTS: 0x08,
  COPY: 0x10,
  MODIFY_ANNOTATIONS: 0x20,
  FILL_INTERACTIVE_FORMS: 0x100,
  COPY_FOR_ACCESSIBILITY: 0x200,
  ASSEMBLE: 0x400,
  PRINT_HIGH_QUALITY: 0x800
};
exports.PermissionFlag = PermissionFlag;
const TextRenderingMode = {
  FILL: 0,
  STROKE: 1,
  FILL_STROKE: 2,
  INVISIBLE: 3,
  FILL_ADD_TO_PATH: 4,
  STROKE_ADD_TO_PATH: 5,
  FILL_STROKE_ADD_TO_PATH: 6,
  ADD_TO_PATH: 7,
  FILL_STROKE_MASK: 3,
  ADD_TO_PATH_FLAG: 4
};
exports.TextRenderingMode = TextRenderingMode;
const ImageKind = {
  GRAYSCALE_1BPP: 1,
  RGB_24BPP: 2,
  RGBA_32BPP: 3
};
exports.ImageKind = ImageKind;
const AnnotationType = {
  TEXT: 1,
  LINK: 2,
  FREETEXT: 3,
  LINE: 4,
  SQUARE: 5,
  CIRCLE: 6,
  POLYGON: 7,
  POLYLINE: 8,
  HIGHLIGHT: 9,
  UNDERLINE: 10,
  SQUIGGLY: 11,
  STRIKEOUT: 12,
  STAMP: 13,
  CARET: 14,
  INK: 15,
  POPUP: 16,
  FILEATTACHMENT: 17,
  SOUND: 18,
  MOVIE: 19,
  WIDGET: 20,
  SCREEN: 21,
  PRINTERMARK: 22,
  TRAPNET: 23,
  WATERMARK: 24,
  THREED: 25,
  REDACT: 26
};
exports.AnnotationType = AnnotationType;
const AnnotationReplyType = {
  GROUP: "Group",
  REPLY: "R"
};
exports.AnnotationReplyType = AnnotationReplyType;
const AnnotationFlag = {
  INVISIBLE: 0x01,
  HIDDEN: 0x02,
  PRINT: 0x04,
  NOZOOM: 0x08,
  NOROTATE: 0x10,
  NOVIEW: 0x20,
  READONLY: 0x40,
  LOCKED: 0x80,
  TOGGLENOVIEW: 0x100,
  LOCKEDCONTENTS: 0x200
};
exports.AnnotationFlag = AnnotationFlag;
const AnnotationFieldFlag = {
  READONLY: 0x0000001,
  REQUIRED: 0x0000002,
  NOEXPORT: 0x0000004,
  MULTILINE: 0x0001000,
  PASSWORD: 0x0002000,
  NOTOGGLETOOFF: 0x0004000,
  RADIO: 0x0008000,
  PUSHBUTTON: 0x0010000,
  COMBO: 0x0020000,
  EDIT: 0x0040000,
  SORT: 0x0080000,
  FILESELECT: 0x0100000,
  MULTISELECT: 0x0200000,
  DONOTSPELLCHECK: 0x0400000,
  DONOTSCROLL: 0x0800000,
  COMB: 0x1000000,
  RICHTEXT: 0x2000000,
  RADIOSINUNISON: 0x2000000,
  COMMITONSELCHANGE: 0x4000000
};
exports.AnnotationFieldFlag = AnnotationFieldFlag;
const AnnotationBorderStyleType = {
  SOLID: 1,
  DASHED: 2,
  BEVELED: 3,
  INSET: 4,
  UNDERLINE: 5
};
exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
const AnnotationActionEventType = {
  E: "Mouse Enter",
  X: "Mouse Exit",
  D: "Mouse Down",
  U: "Mouse Up",
  Fo: "Focus",
  Bl: "Blur",
  PO: "PageOpen",
  PC: "PageClose",
  PV: "PageVisible",
  PI: "PageInvisible",
  K: "Keystroke",
  F: "Format",
  V: "Validate",
  C: "Calculate"
};
exports.AnnotationActionEventType = AnnotationActionEventType;
const DocumentActionEventType = {
  WC: "WillClose",
  WS: "WillSave",
  DS: "DidSave",
  WP: "WillPrint",
  DP: "DidPrint"
};
exports.DocumentActionEventType = DocumentActionEventType;
const PageActionEventType = {
  O: "PageOpen",
  C: "PageClose"
};
exports.PageActionEventType = PageActionEventType;
const VerbosityLevel = {
  ERRORS: 0,
  WARNINGS: 1,
  INFOS: 5
};
exports.VerbosityLevel = VerbosityLevel;
const CMapCompressionType = {
  NONE: 0,
  BINARY: 1
};
exports.CMapCompressionType = CMapCompressionType;
const OPS = {
  dependency: 1,
  setLineWidth: 2,
  setLineCap: 3,
  setLineJoin: 4,
  setMiterLimit: 5,
  setDash: 6,
  setRenderingIntent: 7,
  setFlatness: 8,
  setGState: 9,
  save: 10,
  restore: 11,
  transform: 12,
  moveTo: 13,
  lineTo: 14,
  curveTo: 15,
  curveTo2: 16,
  curveTo3: 17,
  closePath: 18,
  rectangle: 19,
  stroke: 20,
  closeStroke: 21,
  fill: 22,
  eoFill: 23,
  fillStroke: 24,
  eoFillStroke: 25,
  closeFillStroke: 26,
  closeEOFillStroke: 27,
  endPath: 28,
  clip: 29,
  eoClip: 30,
  beginText: 31,
  endText: 32,
  setCharSpacing: 33,
  setWordSpacing: 34,
  setHScale: 35,
  setLeading: 36,
  setFont: 37,
  setTextRenderingMode: 38,
  setTextRise: 39,
  moveText: 40,
  setLeadingMoveText: 41,
  setTextMatrix: 42,
  nextLine: 43,
  showText: 44,
  showSpacedText: 45,
  nextLineShowText: 46,
  nextLineSetSpacingShowText: 47,
  setCharWidth: 48,
  setCharWidthAndBounds: 49,
  setStrokeColorSpace: 50,
  setFillColorSpace: 51,
  setStrokeColor: 52,
  setStrokeColorN: 53,
  setFillColor: 54,
  setFillColorN: 55,
  setStrokeGray: 56,
  setFillGray: 57,
  setStrokeRGBColor: 58,
  setFillRGBColor: 59,
  setStrokeCMYKColor: 60,
  setFillCMYKColor: 61,
  shadingFill: 62,
  beginInlineImage: 63,
  beginImageData: 64,
  endInlineImage: 65,
  paintXObject: 66,
  markPoint: 67,
  markPointProps: 68,
  beginMarkedContent: 69,
  beginMarkedContentProps: 70,
  endMarkedContent: 71,
  beginCompat: 72,
  endCompat: 73,
  paintFormXObjectBegin: 74,
  paintFormXObjectEnd: 75,
  beginGroup: 76,
  endGroup: 77,
  beginAnnotation: 80,
  endAnnotation: 81,
  paintImageMaskXObject: 83,
  paintImageMaskXObjectGroup: 84,
  paintImageXObject: 85,
  paintInlineImageXObject: 86,
  paintInlineImageXObjectGroup: 87,
  paintImageXObjectRepeat: 88,
  paintImageMaskXObjectRepeat: 89,
  paintSolidColorImageMask: 90,
  constructPath: 91
};
exports.OPS = OPS;
const PasswordResponses = {
  NEED_PASSWORD: 1,
  INCORRECT_PASSWORD: 2
};
exports.PasswordResponses = PasswordResponses;
let verbosity = VerbosityLevel.WARNINGS;
function setVerbosityLevel(level) {
  if (Number.isInteger(level)) {
    verbosity = level;
  }
}
function getVerbosityLevel() {
  return verbosity;
}
function info(msg) {
  if (verbosity >= VerbosityLevel.INFOS) {
    console.log(`Info: ${msg}`);
  }
}
function warn(msg) {
  if (verbosity >= VerbosityLevel.WARNINGS) {
    console.log(`Warning: ${msg}`);
  }
}
function unreachable(msg) {
  throw new Error(msg);
}
function assert(cond, msg) {
  if (!cond) {
    unreachable(msg);
  }
}
function _isValidProtocol(url) {
  switch (url?.protocol) {
    case "http:":
    case "https:":
    case "ftp:":
    case "mailto:":
    case "tel:":
      return true;
    default:
      return false;
  }
}
function createValidAbsoluteUrl(url) {
  let baseUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (!url) {
    return null;
  }
  try {
    if (options && typeof url === "string") {
      if (options.addDefaultProtocol && url.startsWith("www.")) {
        const dots = url.match(/\./g);
        if (dots?.length >= 2) {
          url = `http://${url}`;
        }
      }
      if (options.tryConvertEncoding) {
        try {
          url = stringToUTF8String(url);
        } catch {}
      }
    }
    const absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
    if (_isValidProtocol(absoluteUrl)) {
      return absoluteUrl;
    }
  } catch {}
  return null;
}
function shadow(obj, prop, value) {
  let nonSerializable = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  Object.defineProperty(obj, prop, {
    value,
    enumerable: !nonSerializable,
    configurable: true,
    writable: false
  });
  return value;
}
const BaseException = function BaseExceptionClosure() {
  function BaseException(message, name) {
    if (this.constructor === BaseException) {
      unreachable("Cannot initialize BaseException.");
    }
    this.message = message;
    this.name = name;
  }
  BaseException.prototype = new Error();
  BaseException.constructor = BaseException;
  return BaseException;
}();
exports.BaseException = BaseException;
class PasswordException extends BaseException {
  constructor(msg, code) {
    super(msg, "PasswordException");
    this.code = code;
  }
}
exports.PasswordException = PasswordException;
class UnknownErrorException extends BaseException {
  constructor(msg, details) {
    super(msg, "UnknownErrorException");
    this.details = details;
  }
}
exports.UnknownErrorException = UnknownErrorException;
class InvalidPDFException extends BaseException {
  constructor(msg) {
    super(msg, "InvalidPDFException");
  }
}
exports.InvalidPDFException = InvalidPDFException;
class MissingPDFException extends BaseException {
  constructor(msg) {
    super(msg, "MissingPDFException");
  }
}
exports.MissingPDFException = MissingPDFException;
class UnexpectedResponseException extends BaseException {
  constructor(msg, status) {
    super(msg, "UnexpectedResponseException");
    this.status = status;
  }
}
exports.UnexpectedResponseException = UnexpectedResponseException;
class FormatError extends BaseException {
  constructor(msg) {
    super(msg, "FormatError");
  }
}
exports.FormatError = FormatError;
class AbortException extends BaseException {
  constructor(msg) {
    super(msg, "AbortException");
  }
}
exports.AbortException = AbortException;
function bytesToString(bytes) {
  if (typeof bytes !== "object" || bytes?.length === undefined) {
    unreachable("Invalid argument for bytesToString");
  }
  const length = bytes.length;
  const MAX_ARGUMENT_COUNT = 8192;
  if (length < MAX_ARGUMENT_COUNT) {
    return String.fromCharCode.apply(null, bytes);
  }
  const strBuf = [];
  for (let i = 0; i < length; i += MAX_ARGUMENT_COUNT) {
    const chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
    const chunk = bytes.subarray(i, chunkEnd);
    strBuf.push(String.fromCharCode.apply(null, chunk));
  }
  return strBuf.join("");
}
function stringToBytes(str) {
  if (typeof str !== "string") {
    unreachable("Invalid argument for stringToBytes");
  }
  const length = str.length;
  const bytes = new Uint8Array(length);
  for (let i = 0; i < length; ++i) {
    bytes[i] = str.charCodeAt(i) & 0xff;
  }
  return bytes;
}
function string32(value) {
  return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
}
function objectSize(obj) {
  return Object.keys(obj).length;
}
function objectFromMap(map) {
  const obj = Object.create(null);
  for (const [key, value] of map) {
    obj[key] = value;
  }
  return obj;
}
function isLittleEndian() {
  const buffer8 = new Uint8Array(4);
  buffer8[0] = 1;
  const view32 = new Uint32Array(buffer8.buffer, 0, 1);
  return view32[0] === 1;
}
function isEvalSupported() {
  try {
    new Function("");
    return true;
  } catch {
    return false;
  }
}
class FeatureTest {
  static get isLittleEndian() {
    return shadow(this, "isLittleEndian", isLittleEndian());
  }
  static get isEvalSupported() {
    return shadow(this, "isEvalSupported", isEvalSupported());
  }
  static get isOffscreenCanvasSupported() {
    return shadow(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas !== "undefined");
  }
  static get platform() {
    if (typeof navigator === "undefined") {
      return shadow(this, "platform", {
        isWin: false,
        isMac: false
      });
    }
    return shadow(this, "platform", {
      isWin: navigator.platform.includes("Win"),
      isMac: navigator.platform.includes("Mac")
    });
  }
  static get isCSSRoundSupported() {
    return shadow(this, "isCSSRoundSupported", globalThis.CSS?.supports?.("width: round(1.5px, 1px)"));
  }
}
exports.FeatureTest = FeatureTest;
const hexNumbers = [...Array(256).keys()].map(n => n.toString(16).padStart(2, "0"));
class Util {
  static makeHexColor(r, g, b) {
    return `#${hexNumbers[r]}${hexNumbers[g]}${hexNumbers[b]}`;
  }
  static scaleMinMax(transform, minMax) {
    let temp;
    if (transform[0]) {
      if (transform[0] < 0) {
        temp = minMax[0];
        minMax[0] = minMax[1];
        minMax[1] = temp;
      }
      minMax[0] *= transform[0];
      minMax[1] *= transform[0];
      if (transform[3] < 0) {
        temp = minMax[2];
        minMax[2] = minMax[3];
        minMax[3] = temp;
      }
      minMax[2] *= transform[3];
      minMax[3] *= transform[3];
    } else {
      temp = minMax[0];
      minMax[0] = minMax[2];
      minMax[2] = temp;
      temp = minMax[1];
      minMax[1] = minMax[3];
      minMax[3] = temp;
      if (transform[1] < 0) {
        temp = minMax[2];
        minMax[2] = minMax[3];
        minMax[3] = temp;
      }
      minMax[2] *= transform[1];
      minMax[3] *= transform[1];
      if (transform[2] < 0) {
        temp = minMax[0];
        minMax[0] = minMax[1];
        minMax[1] = temp;
      }
      minMax[0] *= transform[2];
      minMax[1] *= transform[2];
    }
    minMax[0] += transform[4];
    minMax[1] += transform[4];
    minMax[2] += transform[5];
    minMax[3] += transform[5];
  }
  static transform(m1, m2) {
    return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
  }
  static applyTransform(p, m) {
    const xt = p[0] * m[0] + p[1] * m[2] + m[4];
    const yt = p[0] * m[1] + p[1] * m[3] + m[5];
    return [xt, yt];
  }
  static applyInverseTransform(p, m) {
    const d = m[0] * m[3] - m[1] * m[2];
    const xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
    const yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
    return [xt, yt];
  }
  static getAxialAlignedBoundingBox(r, m) {
    const p1 = this.applyTransform(r, m);
    const p2 = this.applyTransform(r.slice(2, 4), m);
    const p3 = this.applyTransform([r[0], r[3]], m);
    const p4 = this.applyTransform([r[2], r[1]], m);
    return [Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1])];
  }
  static inverseTransform(m) {
    const d = m[0] * m[3] - m[1] * m[2];
    return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[4] * m[3]) / d, (m[4] * m[1] - m[5] * m[0]) / d];
  }
  static singularValueDecompose2dScale(m) {
    const transpose = [m[0], m[2], m[1], m[3]];
    const a = m[0] * transpose[0] + m[1] * transpose[2];
    const b = m[0] * transpose[1] + m[1] * transpose[3];
    const c = m[2] * transpose[0] + m[3] * transpose[2];
    const d = m[2] * transpose[1] + m[3] * transpose[3];
    const first = (a + d) / 2;
    const second = Math.sqrt((a + d) ** 2 - 4 * (a * d - c * b)) / 2;
    const sx = first + second || 1;
    const sy = first - second || 1;
    return [Math.sqrt(sx), Math.sqrt(sy)];
  }
  static normalizeRect(rect) {
    const r = rect.slice(0);
    if (rect[0] > rect[2]) {
      r[0] = rect[2];
      r[2] = rect[0];
    }
    if (rect[1] > rect[3]) {
      r[1] = rect[3];
      r[3] = rect[1];
    }
    return r;
  }
  static intersect(rect1, rect2) {
    const xLow = Math.max(Math.min(rect1[0], rect1[2]), Math.min(rect2[0], rect2[2]));
    const xHigh = Math.min(Math.max(rect1[0], rect1[2]), Math.max(rect2[0], rect2[2]));
    if (xLow > xHigh) {
      return null;
    }
    const yLow = Math.max(Math.min(rect1[1], rect1[3]), Math.min(rect2[1], rect2[3]));
    const yHigh = Math.min(Math.max(rect1[1], rect1[3]), Math.max(rect2[1], rect2[3]));
    if (yLow > yHigh) {
      return null;
    }
    return [xLow, yLow, xHigh, yHigh];
  }
  static bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3) {
    const tvalues = [],
      bounds = [[], []];
    let a, b, c, t, t1, t2, b2ac, sqrtb2ac;
    for (let i = 0; i < 2; ++i) {
      if (i === 0) {
        b = 6 * x0 - 12 * x1 + 6 * x2;
        a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
        c = 3 * x1 - 3 * x0;
      } else {
        b = 6 * y0 - 12 * y1 + 6 * y2;
        a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
        c = 3 * y1 - 3 * y0;
      }
      if (Math.abs(a) < 1e-12) {
        if (Math.abs(b) < 1e-12) {
          continue;
        }
        t = -c / b;
        if (0 < t && t < 1) {
          tvalues.push(t);
        }
        continue;
      }
      b2ac = b * b - 4 * c * a;
      sqrtb2ac = Math.sqrt(b2ac);
      if (b2ac < 0) {
        continue;
      }
      t1 = (-b + sqrtb2ac) / (2 * a);
      if (0 < t1 && t1 < 1) {
        tvalues.push(t1);
      }
      t2 = (-b - sqrtb2ac) / (2 * a);
      if (0 < t2 && t2 < 1) {
        tvalues.push(t2);
      }
    }
    let j = tvalues.length,
      mt;
    const jlen = j;
    while (j--) {
      t = tvalues[j];
      mt = 1 - t;
      bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
      bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
    }
    bounds[0][jlen] = x0;
    bounds[1][jlen] = y0;
    bounds[0][jlen + 1] = x3;
    bounds[1][jlen + 1] = y3;
    bounds[0].length = bounds[1].length = jlen + 2;
    return [Math.min(...bounds[0]), Math.min(...bounds[1]), Math.max(...bounds[0]), Math.max(...bounds[1])];
  }
}
exports.Util = Util;
const PDFStringTranslateTable = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2d8, 0x2c7, 0x2c6, 0x2d9, 0x2dd, 0x2db, 0x2da, 0x2dc, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2022, 0x2020, 0x2021, 0x2026, 0x2014, 0x2013, 0x192, 0x2044, 0x2039, 0x203a, 0x2212, 0x2030, 0x201e, 0x201c, 0x201d, 0x2018, 0x2019, 0x201a, 0x2122, 0xfb01, 0xfb02, 0x141, 0x152, 0x160, 0x178, 0x17d, 0x131, 0x142, 0x153, 0x161, 0x17e, 0, 0x20ac];
function stringToPDFString(str) {
  if (str[0] >= "\xEF") {
    let encoding;
    if (str[0] === "\xFE" && str[1] === "\xFF") {
      encoding = "utf-16be";
    } else if (str[0] === "\xFF" && str[1] === "\xFE") {
      encoding = "utf-16le";
    } else if (str[0] === "\xEF" && str[1] === "\xBB" && str[2] === "\xBF") {
      encoding = "utf-8";
    }
    if (encoding) {
      try {
        const decoder = new TextDecoder(encoding, {
          fatal: true
        });
        const buffer = stringToBytes(str);
        return decoder.decode(buffer);
      } catch (ex) {
        warn(`stringToPDFString: "${ex}".`);
      }
    }
  }
  const strBuf = [];
  for (let i = 0, ii = str.length; i < ii; i++) {
    const code = PDFStringTranslateTable[str.charCodeAt(i)];
    strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
  }
  return strBuf.join("");
}
function stringToUTF8String(str) {
  return decodeURIComponent(escape(str));
}
function utf8StringToString(str) {
  return unescape(encodeURIComponent(str));
}
function isArrayBuffer(v) {
  return typeof v === "object" && v?.byteLength !== undefined;
}
function isArrayEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false;
  }
  for (let i = 0, ii = arr1.length; i < ii; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }
  return true;
}
function getModificationDate() {
  let date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  const buffer = [date.getUTCFullYear().toString(), (date.getUTCMonth() + 1).toString().padStart(2, "0"), date.getUTCDate().toString().padStart(2, "0"), date.getUTCHours().toString().padStart(2, "0"), date.getUTCMinutes().toString().padStart(2, "0"), date.getUTCSeconds().toString().padStart(2, "0")];
  return buffer.join("");
}
class PromiseCapability {
  #settled = false;
  constructor() {
    this.promise = new Promise((resolve, reject) => {
      this.resolve = data => {
        this.#settled = true;
        resolve(data);
      };
      this.reject = reason => {
        this.#settled = true;
        reject(reason);
      };
    });
  }
  get settled() {
    return this.#settled;
  }
}
exports.PromiseCapability = PromiseCapability;
let NormalizeRegex = null;
let NormalizationMap = null;
function normalizeUnicode(str) {
  if (!NormalizeRegex) {
    NormalizeRegex = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu;
    NormalizationMap = new Map([["ﬅ", "ſt"]]);
  }
  return str.replaceAll(NormalizeRegex, (_, p1, p2) => {
    return p1 ? p1.normalize("NFKC") : NormalizationMap.get(p2);
  });
}
function getUuid() {
  if (typeof crypto !== "undefined" && typeof crypto?.randomUUID === "function") {
    return crypto.randomUUID();
  }
  const buf = new Uint8Array(32);
  if (typeof crypto !== "undefined" && typeof crypto?.getRandomValues === "function") {
    crypto.getRandomValues(buf);
  } else {
    for (let i = 0; i < 32; i++) {
      buf[i] = Math.floor(Math.random() * 255);
    }
  }
  return bytesToString(buf);
}
const AnnotationPrefix = "pdfjs_internal_id_";
exports.AnnotationPrefix = AnnotationPrefix;

/***/ }),
/* 2 */
/***/ ((__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__) => {


var $ = __w_pdfjs_require__(3);
var global = __w_pdfjs_require__(4);
var apply = __w_pdfjs_require__(69);
var wrapErrorConstructorWithCause = __w_pdfjs_require__(70);
var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = global[WEB_ASSEMBLY];
var FORCED = Error('e', { cause: 7 }).cause !== 7;
var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
 var O = {};
 O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED);
 $({
  global: true,
  constructor: true,
  arity: 1,
  forced: FORCED
 }, O);
};
var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
 if (WebAssembly && WebAssembly[ERROR_NAME]) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED);
  $({
   target: WEB_ASSEMBLY,
   stat: true,
   constructor: true,
   arity: 1,
   forced: FORCED
  }, O);
 }
};
exportGlobalErrorCauseWrapper('Error', function (init) {
 return function Error(message) {
  return apply(init, this, arguments);
 };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
 return function EvalError(message) {
  return apply(init, this, arguments);
 };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
 return function RangeError(message) {
  return apply(init, this, arguments);
 };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
 return function ReferenceError(message) {
  return apply(init, this, arguments);
 };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
 return function SyntaxError(message) {
  return apply(init, this, arguments);
 };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
 return function TypeError(message) {
  return apply(init, this, arguments);
 };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
 return function URIError(message) {
  return apply(init, this, arguments);
 };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
 return function CompileError(message) {
  return apply(init, this, arguments);
 };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
 return function LinkError(message) {
  return apply(init, this, arguments);
 };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
 return function RuntimeError(message) {
  return apply(init, this, arguments);
 };
});

/***/ }),
/* 3 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var global = __w_pdfjs_require__(4);
var getOwnPropertyDescriptor = (__w_pdfjs_require__(5).f);
var createNonEnumerableProperty = __w_pdfjs_require__(44);
var defineBuiltIn = __w_pdfjs_require__(48);
var defineGlobalProperty = __w_pdfjs_require__(38);
var copyConstructorProperties = __w_pdfjs_require__(56);
var isForced = __w_pdfjs_require__(68);
module.exports = function (options, source) {
 var TARGET = options.target;
 var GLOBAL = options.global;
 var STATIC = options.stat;
 var FORCED, target, key, targetProperty, sourceProperty, descriptor;
 if (GLOBAL) {
  target = global;
 } else if (STATIC) {
  target = global[TARGET] || defineGlobalProperty(TARGET, {});
 } else {
  target = (global[TARGET] || {}).prototype;
 }
 if (target)
  for (key in source) {
   sourceProperty = source[key];
   if (options.dontCallGetSet) {
    descriptor = getOwnPropertyDescriptor(target, key);
    targetProperty = descriptor && descriptor.value;
   } else
    targetProperty = target[key];
   FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
   if (!FORCED && targetProperty !== undefined) {
    if (typeof sourceProperty == typeof targetProperty)
     continue;
    copyConstructorProperties(sourceProperty, targetProperty);
   }
   if (options.sham || targetProperty && targetProperty.sham) {
    createNonEnumerableProperty(sourceProperty, 'sham', true);
   }
   defineBuiltIn(target, key, sourceProperty, options);
  }
};

/***/ }),
/* 4 */
/***/ (function(module) {


var check = function (it) {
 return it && it.Math === Math && it;
};
module.exports = check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) || check(typeof self == 'object' && self) || check(typeof global == 'object' && global) || (function () {
 return this;
}()) || this || Function('return this')();

/***/ }),
/* 5 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {


var DESCRIPTORS = __w_pdfjs_require__(6);
var call = __w_pdfjs_require__(8);
var propertyIsEnumerableModule = __w_pdfjs_require__(10);
var createPropertyDescriptor = __w_pdfjs_require__(11);
var toIndexedObject = __w_pdfjs_require__(12);
var toPropertyKey = __w_pdfjs_require__(18);
var hasOwn = __w_pdfjs_require__(39);
var IE8_DOM_DEFINE = __w_pdfjs_require__(42);
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
 O = toIndexedObject(O);
 P = toPropertyKey(P);
 if (IE8_DOM_DEFINE)
  try {
   return $getOwnPropertyDescriptor(O, P);
  } catch (error) {
  }
 if (hasOwn(O, P))
  return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};

/***/ }),
/* 6 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var fails = __w_pdfjs_require__(7);
module.exports = !fails(function () {
 return Object.defineProperty({}, 1, {
  get: function () {
   return 7;
  }
 })[1] !== 7;
});

/***/ }),
/* 7 */
/***/ ((module) => {


module.exports = function (exec) {
 try {
  return !!exec();
 } catch (error) {
  return true;
 }
};

/***/ }),
/* 8 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var NATIVE_BIND = __w_pdfjs_require__(9);
var call = Function.prototype.call;
module.exports = NATIVE_BIND ? call.bind(call) : function () {
 return call.apply(call, arguments);
};

/***/ }),
/* 9 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var fails = __w_pdfjs_require__(7);
module.exports = !fails(function () {
 var test = function () {
 }.bind();
 return typeof test != 'function' || test.hasOwnProperty('prototype');
});

/***/ }),
/* 10 */
/***/ ((__unused_webpack_module, exports) => {


var $propertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
 var descriptor = getOwnPropertyDescriptor(this, V);
 return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

/***/ }),
/* 11 */
/***/ ((module) => {


module.exports = function (bitmap, value) {
 return {
  enumerable: !(bitmap & 1),
  configurable: !(bitmap & 2),
  writable: !(bitmap & 4),
  value: value
 };
};

/***/ }),
/* 12 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var IndexedObject = __w_pdfjs_require__(13);
var requireObjectCoercible = __w_pdfjs_require__(16);
module.exports = function (it) {
 return IndexedObject(requireObjectCoercible(it));
};

/***/ }),
/* 13 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var uncurryThis = __w_pdfjs_require__(14);
var fails = __w_pdfjs_require__(7);
var classof = __w_pdfjs_require__(15);
var $Object = Object;
var split = uncurryThis(''.split);
module.exports = fails(function () {
 return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
 return classof(it) === 'String' ? split(it, '') : $Object(it);
} : $Object;

/***/ }),
/* 14 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var NATIVE_BIND = __w_pdfjs_require__(9);
var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);
module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
 return function () {
  return call.apply(fn, arguments);
 };
};

/***/ }),
/* 15 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var uncurryThis = __w_pdfjs_require__(14);
var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);
module.exports = function (it) {
 return stringSlice(toString(it), 8, -1);
};

/***/ }),
/* 16 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var isNullOrUndefined = __w_pdfjs_require__(17);
var $TypeError = TypeError;
module.exports = function (it) {
 if (isNullOrUndefined(it))
  throw $TypeError("Can't call method on " + it);
 return it;
};

/***/ }),
/* 17 */
/***/ ((module) => {


module.exports = function (it) {
 return it === null || it === undefined;
};

/***/ }),
/* 18 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var toPrimitive = __w_pdfjs_require__(19);
var isSymbol = __w_pdfjs_require__(23);
module.exports = function (argument) {
 var key = toPrimitive(argument, 'string');
 return isSymbol(key) ? key : key + '';
};

/***/ }),
/* 19 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var call = __w_pdfjs_require__(8);
var isObject = __w_pdfjs_require__(20);
var isSymbol = __w_pdfjs_require__(23);
var getMethod = __w_pdfjs_require__(30);
var ordinaryToPrimitive = __w_pdfjs_require__(33);
var wellKnownSymbol = __w_pdfjs_require__(34);
var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
module.exports = function (input, pref) {
 if (!isObject(input) || isSymbol(input))
  return input;
 var exoticToPrim = getMethod(input, TO_PRIMITIVE);
 var result;
 if (exoticToPrim) {
  if (pref === undefined)
   pref = 'default';
  result = call(exoticToPrim, input, pref);
  if (!isObject(result) || isSymbol(result))
   return result;
  throw $TypeError("Can't convert object to primitive value");
 }
 if (pref === undefined)
  pref = 'number';
 return ordinaryToPrimitive(input, pref);
};

/***/ }),
/* 20 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var isCallable = __w_pdfjs_require__(21);
var $documentAll = __w_pdfjs_require__(22);
var documentAll = $documentAll.all;
module.exports = $documentAll.IS_HTMLDDA ? function (it) {
 return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
 return typeof it == 'object' ? it !== null : isCallable(it);
};

/***/ }),
/* 21 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var $documentAll = __w_pdfjs_require__(22);
var documentAll = $documentAll.all;
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
 return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
 return typeof argument == 'function';
};

/***/ }),
/* 22 */
/***/ ((module) => {


var documentAll = typeof document == 'object' && document.all;
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;
module.exports = {
 all: documentAll,
 IS_HTMLDDA: IS_HTMLDDA
};

/***/ }),
/* 23 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var getBuiltIn = __w_pdfjs_require__(24);
var isCallable = __w_pdfjs_require__(21);
var isPrototypeOf = __w_pdfjs_require__(25);
var USE_SYMBOL_AS_UID = __w_pdfjs_require__(26);
var $Object = Object;
module.exports = USE_SYMBOL_AS_UID ? function (it) {
 return typeof it == 'symbol';
} : function (it) {
 var $Symbol = getBuiltIn('Symbol');
 return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};

/***/ }),
/* 24 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var global = __w_pdfjs_require__(4);
var isCallable = __w_pdfjs_require__(21);
var aFunction = function (argument) {
 return isCallable(argument) ? argument : undefined;
};
module.exports = function (namespace, method) {
 return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};

/***/ }),
/* 25 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var uncurryThis = __w_pdfjs_require__(14);
module.exports = uncurryThis({}.isPrototypeOf);

/***/ }),
/* 26 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var NATIVE_SYMBOL = __w_pdfjs_require__(27);
module.exports = NATIVE_SYMBOL && !Symbol.sham && typeof Symbol.iterator == 'symbol';

/***/ }),
/* 27 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var V8_VERSION = __w_pdfjs_require__(28);
var fails = __w_pdfjs_require__(7);
var global = __w_pdfjs_require__(4);
var $String = global.String;
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
 var symbol = Symbol('symbol detection');
 return !$String(symbol) || !(Object(symbol) instanceof Symbol) || !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});

/***/ }),
/* 28 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var global = __w_pdfjs_require__(4);
var userAgent = __w_pdfjs_require__(29);
var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;
if (v8) {
 match = v8.split('.');
 version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}
if (!version && userAgent) {
 match = userAgent.match(/Edge\/(\d+)/);
 if (!match || match[1] >= 74) {
  match = userAgent.match(/Chrome\/(\d+)/);
  if (match)
   version = +match[1];
 }
}
module.exports = version;

/***/ }),
/* 29 */
/***/ ((module) => {


module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';

/***/ }),
/* 30 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var aCallable = __w_pdfjs_require__(31);
var isNullOrUndefined = __w_pdfjs_require__(17);
module.exports = function (V, P) {
 var func = V[P];
 return isNullOrUndefined(func) ? undefined : aCallable(func);
};

/***/ }),
/* 31 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var isCallable = __w_pdfjs_require__(21);
var tryToString = __w_pdfjs_require__(32);
var $TypeError = TypeError;
module.exports = function (argument) {
 if (isCallable(argument))
  return argument;
 throw $TypeError(tryToString(argument) + ' is not a function');
};

/***/ }),
/* 32 */
/***/ ((module) => {


var $String = String;
module.exports = function (argument) {
 try {
  return $String(argument);
 } catch (error) {
  return 'Object';
 }
};

/***/ }),
/* 33 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var call = __w_pdfjs_require__(8);
var isCallable = __w_pdfjs_require__(21);
var isObject = __w_pdfjs_require__(20);
var $TypeError = TypeError;
module.exports = function (input, pref) {
 var fn, val;
 if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input)))
  return val;
 if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input)))
  return val;
 if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input)))
  return val;
 throw $TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 34 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var global = __w_pdfjs_require__(4);
var shared = __w_pdfjs_require__(35);
var hasOwn = __w_pdfjs_require__(39);
var uid = __w_pdfjs_require__(41);
var NATIVE_SYMBOL = __w_pdfjs_require__(27);
var USE_SYMBOL_AS_UID = __w_pdfjs_require__(26);
var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;
module.exports = function (name) {
 if (!hasOwn(WellKnownSymbolsStore, name)) {
  WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name) ? Symbol[name] : createWellKnownSymbol('Symbol.' + name);
 }
 return WellKnownSymbolsStore[name];
};

/***/ }),
/* 35 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var IS_PURE = __w_pdfjs_require__(36);
var store = __w_pdfjs_require__(37);
(module.exports = function (key, value) {
 return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
 version: '3.32.2',
 mode: IS_PURE ? 'pure' : 'global',
 copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
 license: 'https://github.com/zloirock/core-js/blob/v3.32.2/LICENSE',
 source: 'https://github.com/zloirock/core-js'
});

/***/ }),
/* 36 */
/***/ ((module) => {


module.exports = false;

/***/ }),
/* 37 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var global = __w_pdfjs_require__(4);
var defineGlobalProperty = __w_pdfjs_require__(38);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});
module.exports = store;

/***/ }),
/* 38 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var global = __w_pdfjs_require__(4);
var defineProperty = Object.defineProperty;
module.exports = function (key, value) {
 try {
  defineProperty(global, key, {
   value: value,
   configurable: true,
   writable: true
  });
 } catch (error) {
  global[key] = value;
 }
 return value;
};

/***/ }),
/* 39 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var uncurryThis = __w_pdfjs_require__(14);
var toObject = __w_pdfjs_require__(40);
var hasOwnProperty = uncurryThis({}.hasOwnProperty);
module.exports = Object.hasOwn || function hasOwn(it, key) {
 return hasOwnProperty(toObject(it), key);
};

/***/ }),
/* 40 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var requireObjectCoercible = __w_pdfjs_require__(16);
var $Object = Object;
module.exports = function (argument) {
 return $Object(requireObjectCoercible(argument));
};

/***/ }),
/* 41 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var uncurryThis = __w_pdfjs_require__(14);
var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);
module.exports = function (key) {
 return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};

/***/ }),
/* 42 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var DESCRIPTORS = __w_pdfjs_require__(6);
var fails = __w_pdfjs_require__(7);
var createElement = __w_pdfjs_require__(43);
module.exports = !DESCRIPTORS && !fails(function () {
 return Object.defineProperty(createElement('div'), 'a', {
  get: function () {
   return 7;
  }
 }).a !== 7;
});

/***/ }),
/* 43 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var global = __w_pdfjs_require__(4);
var isObject = __w_pdfjs_require__(20);
var document = global.document;
var EXISTS = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
 return EXISTS ? document.createElement(it) : {};
};

/***/ }),
/* 44 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var DESCRIPTORS = __w_pdfjs_require__(6);
var definePropertyModule = __w_pdfjs_require__(45);
var createPropertyDescriptor = __w_pdfjs_require__(11);
module.exports = DESCRIPTORS ? function (object, key, value) {
 return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
 object[key] = value;
 return object;
};

/***/ }),
/* 45 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {


var DESCRIPTORS = __w_pdfjs_require__(6);
var IE8_DOM_DEFINE = __w_pdfjs_require__(42);
var V8_PROTOTYPE_DEFINE_BUG = __w_pdfjs_require__(46);
var anObject = __w_pdfjs_require__(47);
var toPropertyKey = __w_pdfjs_require__(18);
var $TypeError = TypeError;
var $defineProperty = Object.defineProperty;
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
 anObject(O);
 P = toPropertyKey(P);
 anObject(Attributes);
 if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
  var current = $getOwnPropertyDescriptor(O, P);
  if (current && current[WRITABLE]) {
   O[P] = Attributes.value;
   Attributes = {
    configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
    enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
    writable: false
   };
  }
 }
 return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
 anObject(O);
 P = toPropertyKey(P);
 anObject(Attributes);
 if (IE8_DOM_DEFINE)
  try {
   return $defineProperty(O, P, Attributes);
  } catch (error) {
  }
 if ('get' in Attributes || 'set' in Attributes)
  throw $TypeError('Accessors not supported');
 if ('value' in Attributes)
  O[P] = Attributes.value;
 return O;
};

/***/ }),
/* 46 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var DESCRIPTORS = __w_pdfjs_require__(6);
var fails = __w_pdfjs_require__(7);
module.exports = DESCRIPTORS && fails(function () {
 return Object.defineProperty(function () {
 }, 'prototype', {
  value: 42,
  writable: false
 }).prototype !== 42;
});

/***/ }),
/* 47 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var isObject = __w_pdfjs_require__(20);
var $String = String;
var $TypeError = TypeError;
module.exports = function (argument) {
 if (isObject(argument))
  return argument;
 throw $TypeError($String(argument) + ' is not an object');
};

/***/ }),
/* 48 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var isCallable = __w_pdfjs_require__(21);
var definePropertyModule = __w_pdfjs_require__(45);
var makeBuiltIn = __w_pdfjs_require__(49);
var defineGlobalProperty = __w_pdfjs_require__(38);
module.exports = function (O, key, value, options) {
 if (!options)
  options = {};
 var simple = options.enumerable;
 var name = options.name !== undefined ? options.name : key;
 if (isCallable(value))
  makeBuiltIn(value, name, options);
 if (options.global) {
  if (simple)
   O[key] = value;
  else
   defineGlobalProperty(key, value);
 } else {
  try {
   if (!options.unsafe)
    delete O[key];
   else if (O[key])
    simple = true;
  } catch (error) {
  }
  if (simple)
   O[key] = value;
  else
   definePropertyModule.f(O, key, {
    value: value,
    enumerable: false,
    configurable: !options.nonConfigurable,
    writable: !options.nonWritable
   });
 }
 return O;
};

/***/ }),
/* 49 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var uncurryThis = __w_pdfjs_require__(14);
var fails = __w_pdfjs_require__(7);
var isCallable = __w_pdfjs_require__(21);
var hasOwn = __w_pdfjs_require__(39);
var DESCRIPTORS = __w_pdfjs_require__(6);
var CONFIGURABLE_FUNCTION_NAME = (__w_pdfjs_require__(50).CONFIGURABLE);
var inspectSource = __w_pdfjs_require__(51);
var InternalStateModule = __w_pdfjs_require__(52);
var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);
var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
 return defineProperty(function () {
 }, 'length', { value: 8 }).length !== 8;
});
var TEMPLATE = String(String).split('String');
var makeBuiltIn = module.exports = function (value, name, options) {
 if (stringSlice($String(name), 0, 7) === 'Symbol(') {
  name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
 }
 if (options && options.getter)
  name = 'get ' + name;
 if (options && options.setter)
  name = 'set ' + name;
 if (!hasOwn(value, 'name') || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
  if (DESCRIPTORS)
   defineProperty(value, 'name', {
    value: name,
    configurable: true
   });
  else
   value.name = name;
 }
 if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
  defineProperty(value, 'length', { value: options.arity });
 }
 try {
  if (options && hasOwn(options, 'constructor') && options.constructor) {
   if (DESCRIPTORS)
    defineProperty(value, 'prototype', { writable: false });
  } else if (value.prototype)
   value.prototype = undefined;
 } catch (error) {
 }
 var state = enforceInternalState(value);
 if (!hasOwn(state, 'source')) {
  state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
 }
 return value;
};
Function.prototype.toString = makeBuiltIn(function toString() {
 return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');

/***/ }),
/* 50 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var DESCRIPTORS = __w_pdfjs_require__(6);
var hasOwn = __w_pdfjs_require__(39);
var FunctionPrototype = Function.prototype;
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;
var EXISTS = hasOwn(FunctionPrototype, 'name');
var PROPER = EXISTS && function something() {
}.name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable);
module.exports = {
 EXISTS: EXISTS,
 PROPER: PROPER,
 CONFIGURABLE: CONFIGURABLE
};

/***/ }),
/* 51 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var uncurryThis = __w_pdfjs_require__(14);
var isCallable = __w_pdfjs_require__(21);
var store = __w_pdfjs_require__(37);
var functionToString = uncurryThis(Function.toString);
if (!isCallable(store.inspectSource)) {
 store.inspectSource = function (it) {
  return functionToString(it);
 };
}
module.exports = store.inspectSource;

/***/ }),
/* 52 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var NATIVE_WEAK_MAP = __w_pdfjs_require__(53);
var global = __w_pdfjs_require__(4);
var isObject = __w_pdfjs_require__(20);
var createNonEnumerableProperty = __w_pdfjs_require__(44);
var hasOwn = __w_pdfjs_require__(39);
var shared = __w_pdfjs_require__(37);
var sharedKey = __w_pdfjs_require__(54);
var hiddenKeys = __w_pdfjs_require__(55);
var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;
var enforce = function (it) {
 return has(it) ? get(it) : set(it, {});
};
var getterFor = function (TYPE) {
 return function (it) {
  var state;
  if (!isObject(it) || (state = get(it)).type !== TYPE) {
   throw TypeError('Incompatible receiver, ' + TYPE + ' required');
  }
  return state;
 };
};
if (NATIVE_WEAK_MAP || shared.state) {
 var store = shared.state || (shared.state = new WeakMap());
 store.get = store.get;
 store.has = store.has;
 store.set = store.set;
 set = function (it, metadata) {
  if (store.has(it))
   throw TypeError(OBJECT_ALREADY_INITIALIZED);
  metadata.facade = it;
  store.set(it, metadata);
  return metadata;
 };
 get = function (it) {
  return store.get(it) || {};
 };
 has = function (it) {
  return store.has(it);
 };
} else {
 var STATE = sharedKey('state');
 hiddenKeys[STATE] = true;
 set = function (it, metadata) {
  if (hasOwn(it, STATE))
   throw TypeError(OBJECT_ALREADY_INITIALIZED);
  metadata.facade = it;
  createNonEnumerableProperty(it, STATE, metadata);
  return metadata;
 };
 get = function (it) {
  return hasOwn(it, STATE) ? it[STATE] : {};
 };
 has = function (it) {
  return hasOwn(it, STATE);
 };
}
module.exports = {
 set: set,
 get: get,
 has: has,
 enforce: enforce,
 getterFor: getterFor
};

/***/ }),
/* 53 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var global = __w_pdfjs_require__(4);
var isCallable = __w_pdfjs_require__(21);
var WeakMap = global.WeakMap;
module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));

/***/ }),
/* 54 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var shared = __w_pdfjs_require__(35);
var uid = __w_pdfjs_require__(41);
var keys = shared('keys');
module.exports = function (key) {
 return keys[key] || (keys[key] = uid(key));
};

/***/ }),
/* 55 */
/***/ ((module) => {


module.exports = {};

/***/ }),
/* 56 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var hasOwn = __w_pdfjs_require__(39);
var ownKeys = __w_pdfjs_require__(57);
var getOwnPropertyDescriptorModule = __w_pdfjs_require__(5);
var definePropertyModule = __w_pdfjs_require__(45);
module.exports = function (target, source, exceptions) {
 var keys = ownKeys(source);
 var defineProperty = definePropertyModule.f;
 var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
 for (var i = 0; i < keys.length; i++) {
  var key = keys[i];
  if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
   defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
 }
};

/***/ }),
/* 57 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var getBuiltIn = __w_pdfjs_require__(24);
var uncurryThis = __w_pdfjs_require__(14);
var getOwnPropertyNamesModule = __w_pdfjs_require__(58);
var getOwnPropertySymbolsModule = __w_pdfjs_require__(67);
var anObject = __w_pdfjs_require__(47);
var concat = uncurryThis([].concat);
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
 var keys = getOwnPropertyNamesModule.f(anObject(it));
 var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
 return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};

/***/ }),
/* 58 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {


var internalObjectKeys = __w_pdfjs_require__(59);
var enumBugKeys = __w_pdfjs_require__(66);
var hiddenKeys = enumBugKeys.concat('length', 'prototype');
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
 return internalObjectKeys(O, hiddenKeys);
};

/***/ }),
/* 59 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var uncurryThis = __w_pdfjs_require__(14);
var hasOwn = __w_pdfjs_require__(39);
var toIndexedObject = __w_pdfjs_require__(12);
var indexOf = (__w_pdfjs_require__(60).indexOf);
var hiddenKeys = __w_pdfjs_require__(55);
var push = uncurryThis([].push);
module.exports = function (object, names) {
 var O = toIndexedObject(object);
 var i = 0;
 var result = [];
 var key;
 for (key in O)
  !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
 while (names.length > i)
  if (hasOwn(O, key = names[i++])) {
   ~indexOf(result, key) || push(result, key);
  }
 return result;
};

/***/ }),
/* 60 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var toIndexedObject = __w_pdfjs_require__(12);
var toAbsoluteIndex = __w_pdfjs_require__(61);
var lengthOfArrayLike = __w_pdfjs_require__(64);
var createMethod = function (IS_INCLUDES) {
 return function ($this, el, fromIndex) {
  var O = toIndexedObject($this);
  var length = lengthOfArrayLike(O);
  var index = toAbsoluteIndex(fromIndex, length);
  var value;
  if (IS_INCLUDES && el !== el)
   while (length > index) {
    value = O[index++];
    if (value !== value)
     return true;
   }
  else
   for (; length > index; index++) {
    if ((IS_INCLUDES || index in O) && O[index] === el)
     return IS_INCLUDES || index || 0;
   }
  return !IS_INCLUDES && -1;
 };
};
module.exports = {
 includes: createMethod(true),
 indexOf: createMethod(false)
};

/***/ }),
/* 61 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var toIntegerOrInfinity = __w_pdfjs_require__(62);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
 var integer = toIntegerOrInfinity(index);
 return integer < 0 ? max(integer + length, 0) : min(integer, length);
};

/***/ }),
/* 62 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var trunc = __w_pdfjs_require__(63);
module.exports = function (argument) {
 var number = +argument;
 return number !== number || number === 0 ? 0 : trunc(number);
};

/***/ }),
/* 63 */
/***/ ((module) => {


var ceil = Math.ceil;
var floor = Math.floor;
module.exports = Math.trunc || function trunc(x) {
 var n = +x;
 return (n > 0 ? floor : ceil)(n);
};

/***/ }),
/* 64 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var toLength = __w_pdfjs_require__(65);
module.exports = function (obj) {
 return toLength(obj.length);
};

/***/ }),
/* 65 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var toIntegerOrInfinity = __w_pdfjs_require__(62);
var min = Math.min;
module.exports = function (argument) {
 return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0;
};

/***/ }),
/* 66 */
/***/ ((module) => {


module.exports = [
 'constructor',
 'hasOwnProperty',
 'isPrototypeOf',
 'propertyIsEnumerable',
 'toLocaleString',
 'toString',
 'valueOf'
];

/***/ }),
/* 67 */
/***/ ((__unused_webpack_module, exports) => {


exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 68 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var fails = __w_pdfjs_require__(7);
var isCallable = __w_pdfjs_require__(21);
var replacement = /#|\.prototype\./;
var isForced = function (feature, detection) {
 var value = data[normalize(feature)];
 return value === POLYFILL ? true : value === NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
};
var normalize = isForced.normalize = function (string) {
 return String(string).replace(replacement, '.').toLowerCase();
};
var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';
module.exports = isForced;

/***/ }),
/* 69 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var NATIVE_BIND = __w_pdfjs_require__(9);
var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
 return call.apply(apply, arguments);
});

/***/ }),
/* 70 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var getBuiltIn = __w_pdfjs_require__(24);
var hasOwn = __w_pdfjs_require__(39);
var createNonEnumerableProperty = __w_pdfjs_require__(44);
var isPrototypeOf = __w_pdfjs_require__(25);
var setPrototypeOf = __w_pdfjs_require__(71);
var copyConstructorProperties = __w_pdfjs_require__(56);
var proxyAccessor = __w_pdfjs_require__(74);
var inheritIfRequired = __w_pdfjs_require__(75);
var normalizeStringArgument = __w_pdfjs_require__(76);
var installErrorCause = __w_pdfjs_require__(80);
var installErrorStack = __w_pdfjs_require__(81);
var DESCRIPTORS = __w_pdfjs_require__(6);
var IS_PURE = __w_pdfjs_require__(36);
module.exports = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
 var STACK_TRACE_LIMIT = 'stackTraceLimit';
 var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
 var path = FULL_NAME.split('.');
 var ERROR_NAME = path[path.length - 1];
 var OriginalError = getBuiltIn.apply(null, path);
 if (!OriginalError)
  return;
 var OriginalErrorPrototype = OriginalError.prototype;
 if (!IS_PURE && hasOwn(OriginalErrorPrototype, 'cause'))
  delete OriginalErrorPrototype.cause;
 if (!FORCED)
  return OriginalError;
 var BaseError = getBuiltIn('Error');
 var WrappedError = wrapper(function (a, b) {
  var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
  var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
  if (message !== undefined)
   createNonEnumerableProperty(result, 'message', message);
  installErrorStack(result, WrappedError, result.stack, 2);
  if (this && isPrototypeOf(OriginalErrorPrototype, this))
   inheritIfRequired(result, this, WrappedError);
  if (arguments.length > OPTIONS_POSITION)
   installErrorCause(result, arguments[OPTIONS_POSITION]);
  return result;
 });
 WrappedError.prototype = OriginalErrorPrototype;
 if (ERROR_NAME !== 'Error') {
  if (setPrototypeOf)
   setPrototypeOf(WrappedError, BaseError);
  else
   copyConstructorProperties(WrappedError, BaseError, { name: true });
 } else if (DESCRIPTORS && STACK_TRACE_LIMIT in OriginalError) {
  proxyAccessor(WrappedError, OriginalError, STACK_TRACE_LIMIT);
  proxyAccessor(WrappedError, OriginalError, 'prepareStackTrace');
 }
 copyConstructorProperties(WrappedError, OriginalError);
 if (!IS_PURE)
  try {
   if (OriginalErrorPrototype.name !== ERROR_NAME) {
    createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
   }
   OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) {
  }
 return WrappedError;
};

/***/ }),
/* 71 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var uncurryThisAccessor = __w_pdfjs_require__(72);
var anObject = __w_pdfjs_require__(47);
var aPossiblePrototype = __w_pdfjs_require__(73);
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? (function () {
 var CORRECT_SETTER = false;
 var test = {};
 var setter;
 try {
  setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
  setter(test, []);
  CORRECT_SETTER = test instanceof Array;
 } catch (error) {
 }
 return function setPrototypeOf(O, proto) {
  anObject(O);
  aPossiblePrototype(proto);
  if (CORRECT_SETTER)
   setter(O, proto);
  else
   O.__proto__ = proto;
  return O;
 };
}()) : undefined);

/***/ }),
/* 72 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var uncurryThis = __w_pdfjs_require__(14);
var aCallable = __w_pdfjs_require__(31);
module.exports = function (object, key, method) {
 try {
  return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
 } catch (error) {
 }
};

/***/ }),
/* 73 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var isCallable = __w_pdfjs_require__(21);
var $String = String;
var $TypeError = TypeError;
module.exports = function (argument) {
 if (typeof argument == 'object' || isCallable(argument))
  return argument;
 throw $TypeError("Can't set " + $String(argument) + ' as a prototype');
};

/***/ }),
/* 74 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var defineProperty = (__w_pdfjs_require__(45).f);
module.exports = function (Target, Source, key) {
 key in Target || defineProperty(Target, key, {
  configurable: true,
  get: function () {
   return Source[key];
  },
  set: function (it) {
   Source[key] = it;
  }
 });
};

/***/ }),
/* 75 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var isCallable = __w_pdfjs_require__(21);
var isObject = __w_pdfjs_require__(20);
var setPrototypeOf = __w_pdfjs_require__(71);
module.exports = function ($this, dummy, Wrapper) {
 var NewTarget, NewTargetPrototype;
 if (setPrototypeOf && isCallable(NewTarget = dummy.constructor) && NewTarget !== Wrapper && isObject(NewTargetPrototype = NewTarget.prototype) && NewTargetPrototype !== Wrapper.prototype)
  setPrototypeOf($this, NewTargetPrototype);
 return $this;
};

/***/ }),
/* 76 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var toString = __w_pdfjs_require__(77);
module.exports = function (argument, $default) {
 return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};

/***/ }),
/* 77 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var classof = __w_pdfjs_require__(78);
var $String = String;
module.exports = function (argument) {
 if (classof(argument) === 'Symbol')
  throw TypeError('Cannot convert a Symbol value to a string');
 return $String(argument);
};

/***/ }),
/* 78 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var TO_STRING_TAG_SUPPORT = __w_pdfjs_require__(79);
var isCallable = __w_pdfjs_require__(21);
var classofRaw = __w_pdfjs_require__(15);
var wellKnownSymbol = __w_pdfjs_require__(34);
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;
var CORRECT_ARGUMENTS = classofRaw((function () {
 return arguments;
}())) === 'Arguments';
var tryGet = function (it, key) {
 try {
  return it[key];
 } catch (error) {
 }
};
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
 var O, tag, result;
 return it === undefined ? 'Undefined' : it === null ? 'Null' : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag : CORRECT_ARGUMENTS ? classofRaw(O) : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};

/***/ }),
/* 79 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var wellKnownSymbol = __w_pdfjs_require__(34);
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};
test[TO_STRING_TAG] = 'z';
module.exports = String(test) === '[object z]';

/***/ }),
/* 80 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var isObject = __w_pdfjs_require__(20);
var createNonEnumerableProperty = __w_pdfjs_require__(44);
module.exports = function (O, options) {
 if (isObject(options) && 'cause' in options) {
  createNonEnumerableProperty(O, 'cause', options.cause);
 }
};

/***/ }),
/* 81 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var createNonEnumerableProperty = __w_pdfjs_require__(44);
var clearErrorStack = __w_pdfjs_require__(82);
var ERROR_STACK_INSTALLABLE = __w_pdfjs_require__(83);
var captureStackTrace = Error.captureStackTrace;
module.exports = function (error, C, stack, dropEntries) {
 if (ERROR_STACK_INSTALLABLE) {
  if (captureStackTrace)
   captureStackTrace(error, C);
  else
   createNonEnumerableProperty(error, 'stack', clearErrorStack(stack, dropEntries));
 }
};

/***/ }),
/* 82 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var uncurryThis = __w_pdfjs_require__(14);
var $Error = Error;
var replace = uncurryThis(''.replace);
var TEST = function (arg) {
 return String($Error(arg).stack);
}('zxcasd');
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);
module.exports = function (stack, dropEntries) {
 if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
  while (dropEntries--)
   stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
 }
 return stack;
};

/***/ }),
/* 83 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var fails = __w_pdfjs_require__(7);
var createPropertyDescriptor = __w_pdfjs_require__(11);
module.exports = !fails(function () {
 var error = Error('a');
 if (!('stack' in error))
  return true;
 Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
 return error.stack !== 7;
});

/***/ }),
/* 84 */
/***/ ((__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__) => {


var defineBuiltIn = __w_pdfjs_require__(48);
var uncurryThis = __w_pdfjs_require__(14);
var toString = __w_pdfjs_require__(77);
var validateArgumentsLength = __w_pdfjs_require__(85);
var $URLSearchParams = URLSearchParams;
var URLSearchParamsPrototype = $URLSearchParams.prototype;
var append = uncurryThis(URLSearchParamsPrototype.append);
var $delete = uncurryThis(URLSearchParamsPrototype['delete']);
var forEach = uncurryThis(URLSearchParamsPrototype.forEach);
var push = uncurryThis([].push);
var params = new $URLSearchParams('a=1&a=2&b=3');
params['delete']('a', 1);
params['delete']('b', undefined);
if (params + '' !== 'a=2') {
 defineBuiltIn(URLSearchParamsPrototype, 'delete', function (name) {
  var length = arguments.length;
  var $value = length < 2 ? undefined : arguments[1];
  if (length && $value === undefined)
   return $delete(this, name);
  var entries = [];
  forEach(this, function (v, k) {
   push(entries, {
    key: k,
    value: v
   });
  });
  validateArgumentsLength(length, 1);
  var key = toString(name);
  var value = toString($value);
  var index = 0;
  var dindex = 0;
  var found = false;
  var entriesLength = entries.length;
  var entry;
  while (index < entriesLength) {
   entry = entries[index++];
   if (found || entry.key === key) {
    found = true;
    $delete(this, entry.key);
   } else
    dindex++;
  }
  while (dindex < entriesLength) {
   entry = entries[dindex++];
   if (!(entry.key === key && entry.value === value))
    append(this, entry.key, entry.value);
  }
 }, {
  enumerable: true,
  unsafe: true
 });
}

/***/ }),
/* 85 */
/***/ ((module) => {


var $TypeError = TypeError;
module.exports = function (passed, required) {
 if (passed < required)
  throw $TypeError('Not enough arguments');
 return passed;
};

/***/ }),
/* 86 */
/***/ ((__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__) => {


var defineBuiltIn = __w_pdfjs_require__(48);
var uncurryThis = __w_pdfjs_require__(14);
var toString = __w_pdfjs_require__(77);
var validateArgumentsLength = __w_pdfjs_require__(85);
var $URLSearchParams = URLSearchParams;
var URLSearchParamsPrototype = $URLSearchParams.prototype;
var getAll = uncurryThis(URLSearchParamsPrototype.getAll);
var $has = uncurryThis(URLSearchParamsPrototype.has);
var params = new $URLSearchParams('a=1');
if (params.has('a', 2) || !params.has('a', undefined)) {
 defineBuiltIn(URLSearchParamsPrototype, 'has', function has(name) {
  var length = arguments.length;
  var $value = length < 2 ? undefined : arguments[1];
  if (length && $value === undefined)
   return $has(this, name);
  var values = getAll(this, name);
  validateArgumentsLength(length, 1);
  var value = toString($value);
  var index = 0;
  while (index < values.length) {
   if (values[index++] === value)
    return true;
  }
  return false;
 }, {
  enumerable: true,
  unsafe: true
 });
}

/***/ }),
/* 87 */
/***/ ((__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__) => {


var DESCRIPTORS = __w_pdfjs_require__(6);
var uncurryThis = __w_pdfjs_require__(14);
var defineBuiltInAccessor = __w_pdfjs_require__(88);
var URLSearchParamsPrototype = URLSearchParams.prototype;
var forEach = uncurryThis(URLSearchParamsPrototype.forEach);
if (DESCRIPTORS && !('size' in URLSearchParamsPrototype)) {
 defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
  get: function size() {
   var count = 0;
   forEach(this, function () {
    count++;
   });
   return count;
  },
  configurable: true,
  enumerable: true
 });
}

/***/ }),
/* 88 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var makeBuiltIn = __w_pdfjs_require__(49);
var defineProperty = __w_pdfjs_require__(45);
module.exports = function (target, name, descriptor) {
 if (descriptor.get)
  makeBuiltIn(descriptor.get, name, { getter: true });
 if (descriptor.set)
  makeBuiltIn(descriptor.set, name, { setter: true });
 return defineProperty.f(target, name, descriptor);
};

/***/ }),
/* 89 */
/***/ ((__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__) => {


var $ = __w_pdfjs_require__(3);
var toObject = __w_pdfjs_require__(40);
var lengthOfArrayLike = __w_pdfjs_require__(64);
var setArrayLength = __w_pdfjs_require__(90);
var doesNotExceedSafeInteger = __w_pdfjs_require__(92);
var fails = __w_pdfjs_require__(7);
var INCORRECT_TO_LENGTH = fails(function () {
 return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});
var properErrorOnNonWritableLength = function () {
 try {
  Object.defineProperty([], 'length', { writable: false }).push();
 } catch (error) {
  return error instanceof TypeError;
 }
};
var FORCED = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();
$({
 target: 'Array',
 proto: true,
 arity: 1,
 forced: FORCED
}, {
 push: function push(item) {
  var O = toObject(this);
  var len = lengthOfArrayLike(O);
  var argCount = arguments.length;
  doesNotExceedSafeInteger(len + argCount);
  for (var i = 0; i < argCount; i++) {
   O[len] = arguments[i];
   len++;
  }
  setArrayLength(O, len);
  return len;
 }
});

/***/ }),
/* 90 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var DESCRIPTORS = __w_pdfjs_require__(6);
var isArray = __w_pdfjs_require__(91);
var $TypeError = TypeError;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !(function () {
 if (this !== undefined)
  return true;
 try {
  Object.defineProperty([], 'length', { writable: false }).length = 1;
 } catch (error) {
  return error instanceof TypeError;
 }
}());
module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
 if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
  throw $TypeError('Cannot set read only .length');
 }
 return O.length = length;
} : function (O, length) {
 return O.length = length;
};

/***/ }),
/* 91 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var classof = __w_pdfjs_require__(15);
module.exports = Array.isArray || function isArray(argument) {
 return classof(argument) === 'Array';
};

/***/ }),
/* 92 */
/***/ ((module) => {


var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
module.exports = function (it) {
 if (it > MAX_SAFE_INTEGER)
  throw $TypeError('Maximum allowed index exceeded');
 return it;
};

/***/ }),
/* 93 */
/***/ ((__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__) => {


var ArrayBufferViewCore = __w_pdfjs_require__(94);
var $findLast = (__w_pdfjs_require__(98).findLast);
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
exportTypedArrayMethod('findLast', function findLast(predicate) {
 return $findLast(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});

/***/ }),
/* 94 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var NATIVE_ARRAY_BUFFER = __w_pdfjs_require__(95);
var DESCRIPTORS = __w_pdfjs_require__(6);
var global = __w_pdfjs_require__(4);
var isCallable = __w_pdfjs_require__(21);
var isObject = __w_pdfjs_require__(20);
var hasOwn = __w_pdfjs_require__(39);
var classof = __w_pdfjs_require__(78);
var tryToString = __w_pdfjs_require__(32);
var createNonEnumerableProperty = __w_pdfjs_require__(44);
var defineBuiltIn = __w_pdfjs_require__(48);
var defineBuiltInAccessor = __w_pdfjs_require__(88);
var isPrototypeOf = __w_pdfjs_require__(25);
var getPrototypeOf = __w_pdfjs_require__(96);
var setPrototypeOf = __w_pdfjs_require__(71);
var wellKnownSymbol = __w_pdfjs_require__(34);
var uid = __w_pdfjs_require__(41);
var InternalStateModule = __w_pdfjs_require__(52);
var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var Uint8ClampedArray = global.Uint8ClampedArray;
var Uint8ClampedArrayPrototype = Uint8ClampedArray && Uint8ClampedArray.prototype;
var TypedArray = Int8Array && getPrototypeOf(Int8Array);
var TypedArrayPrototype = Int8ArrayPrototype && getPrototypeOf(Int8ArrayPrototype);
var ObjectPrototype = Object.prototype;
var TypeError = global.TypeError;
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var TYPED_ARRAY_TAG = uid('TYPED_ARRAY_TAG');
var TYPED_ARRAY_CONSTRUCTOR = 'TypedArrayConstructor';
var NATIVE_ARRAY_BUFFER_VIEWS = NATIVE_ARRAY_BUFFER && !!setPrototypeOf && classof(global.opera) !== 'Opera';
var TYPED_ARRAY_TAG_REQUIRED = false;
var NAME, Constructor, Prototype;
var TypedArrayConstructorsList = {
 Int8Array: 1,
 Uint8Array: 1,
 Uint8ClampedArray: 1,
 Int16Array: 2,
 Uint16Array: 2,
 Int32Array: 4,
 Uint32Array: 4,
 Float32Array: 4,
 Float64Array: 8
};
var BigIntArrayConstructorsList = {
 BigInt64Array: 8,
 BigUint64Array: 8
};
var isView = function isView(it) {
 if (!isObject(it))
  return false;
 var klass = classof(it);
 return klass === 'DataView' || hasOwn(TypedArrayConstructorsList, klass) || hasOwn(BigIntArrayConstructorsList, klass);
};
var getTypedArrayConstructor = function (it) {
 var proto = getPrototypeOf(it);
 if (!isObject(proto))
  return;
 var state = getInternalState(proto);
 return state && hasOwn(state, TYPED_ARRAY_CONSTRUCTOR) ? state[TYPED_ARRAY_CONSTRUCTOR] : getTypedArrayConstructor(proto);
};
var isTypedArray = function (it) {
 if (!isObject(it))
  return false;
 var klass = classof(it);
 return hasOwn(TypedArrayConstructorsList, klass) || hasOwn(BigIntArrayConstructorsList, klass);
};
var aTypedArray = function (it) {
 if (isTypedArray(it))
  return it;
 throw TypeError('Target is not a typed array');
};
var aTypedArrayConstructor = function (C) {
 if (isCallable(C) && (!setPrototypeOf || isPrototypeOf(TypedArray, C)))
  return C;
 throw TypeError(tryToString(C) + ' is not a typed array constructor');
};
var exportTypedArrayMethod = function (KEY, property, forced, options) {
 if (!DESCRIPTORS)
  return;
 if (forced)
  for (var ARRAY in TypedArrayConstructorsList) {
   var TypedArrayConstructor = global[ARRAY];
   if (TypedArrayConstructor && hasOwn(TypedArrayConstructor.prototype, KEY))
    try {
     delete TypedArrayConstructor.prototype[KEY];
    } catch (error) {
     try {
      TypedArrayConstructor.prototype[KEY] = property;
     } catch (error2) {
     }
    }
  }
 if (!TypedArrayPrototype[KEY] || forced) {
  defineBuiltIn(TypedArrayPrototype, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && Int8ArrayPrototype[KEY] || property, options);
 }
};
var exportTypedArrayStaticMethod = function (KEY, property, forced) {
 var ARRAY, TypedArrayConstructor;
 if (!DESCRIPTORS)
  return;
 if (setPrototypeOf) {
  if (forced)
   for (ARRAY in TypedArrayConstructorsList) {
    TypedArrayConstructor = global[ARRAY];
    if (TypedArrayConstructor && hasOwn(TypedArrayConstructor, KEY))
     try {
      delete TypedArrayConstructor[KEY];
     } catch (error) {
     }
   }
  if (!TypedArray[KEY] || forced) {
   try {
    return defineBuiltIn(TypedArray, KEY, forced ? property : NATIVE_ARRAY_BUFFER_VIEWS && TypedArray[KEY] || property);
   } catch (error) {
   }
  } else
   return;
 }
 for (ARRAY in TypedArrayConstructorsList) {
  TypedArrayConstructor = global[ARRAY];
  if (TypedArrayConstructor && (!TypedArrayConstructor[KEY] || forced)) {
   defineBuiltIn(TypedArrayConstructor, KEY, property);
  }
 }
};
for (NAME in TypedArrayConstructorsList) {
 Constructor = global[NAME];
 Prototype = Constructor && Constructor.prototype;
 if (Prototype)
  enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
 else
  NATIVE_ARRAY_BUFFER_VIEWS = false;
}
for (NAME in BigIntArrayConstructorsList) {
 Constructor = global[NAME];
 Prototype = Constructor && Constructor.prototype;
 if (Prototype)
  enforceInternalState(Prototype)[TYPED_ARRAY_CONSTRUCTOR] = Constructor;
}
if (!NATIVE_ARRAY_BUFFER_VIEWS || !isCallable(TypedArray) || TypedArray === Function.prototype) {
 TypedArray = function TypedArray() {
  throw TypeError('Incorrect invocation');
 };
 if (NATIVE_ARRAY_BUFFER_VIEWS)
  for (NAME in TypedArrayConstructorsList) {
   if (global[NAME])
    setPrototypeOf(global[NAME], TypedArray);
  }
}
if (!NATIVE_ARRAY_BUFFER_VIEWS || !TypedArrayPrototype || TypedArrayPrototype === ObjectPrototype) {
 TypedArrayPrototype = TypedArray.prototype;
 if (NATIVE_ARRAY_BUFFER_VIEWS)
  for (NAME in TypedArrayConstructorsList) {
   if (global[NAME])
    setPrototypeOf(global[NAME].prototype, TypedArrayPrototype);
  }
}
if (NATIVE_ARRAY_BUFFER_VIEWS && getPrototypeOf(Uint8ClampedArrayPrototype) !== TypedArrayPrototype) {
 setPrototypeOf(Uint8ClampedArrayPrototype, TypedArrayPrototype);
}
if (DESCRIPTORS && !hasOwn(TypedArrayPrototype, TO_STRING_TAG)) {
 TYPED_ARRAY_TAG_REQUIRED = true;
 defineBuiltInAccessor(TypedArrayPrototype, TO_STRING_TAG, {
  configurable: true,
  get: function () {
   return isObject(this) ? this[TYPED_ARRAY_TAG] : undefined;
  }
 });
 for (NAME in TypedArrayConstructorsList)
  if (global[NAME]) {
   createNonEnumerableProperty(global[NAME], TYPED_ARRAY_TAG, NAME);
  }
}
module.exports = {
 NATIVE_ARRAY_BUFFER_VIEWS: NATIVE_ARRAY_BUFFER_VIEWS,
 TYPED_ARRAY_TAG: TYPED_ARRAY_TAG_REQUIRED && TYPED_ARRAY_TAG,
 aTypedArray: aTypedArray,
 aTypedArrayConstructor: aTypedArrayConstructor,
 exportTypedArrayMethod: exportTypedArrayMethod,
 exportTypedArrayStaticMethod: exportTypedArrayStaticMethod,
 getTypedArrayConstructor: getTypedArrayConstructor,
 isView: isView,
 isTypedArray: isTypedArray,
 TypedArray: TypedArray,
 TypedArrayPrototype: TypedArrayPrototype
};

/***/ }),
/* 95 */
/***/ ((module) => {


module.exports = typeof ArrayBuffer != 'undefined' && typeof DataView != 'undefined';

/***/ }),
/* 96 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var hasOwn = __w_pdfjs_require__(39);
var isCallable = __w_pdfjs_require__(21);
var toObject = __w_pdfjs_require__(40);
var sharedKey = __w_pdfjs_require__(54);
var CORRECT_PROTOTYPE_GETTER = __w_pdfjs_require__(97);
var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
 var object = toObject(O);
 if (hasOwn(object, IE_PROTO))
  return object[IE_PROTO];
 var constructor = object.constructor;
 if (isCallable(constructor) && object instanceof constructor) {
  return constructor.prototype;
 }
 return object instanceof $Object ? ObjectPrototype : null;
};

/***/ }),
/* 97 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var fails = __w_pdfjs_require__(7);
module.exports = !fails(function () {
 function F() {
 }
 F.prototype.constructor = null;
 return Object.getPrototypeOf(new F()) !== F.prototype;
});

/***/ }),
/* 98 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var bind = __w_pdfjs_require__(99);
var IndexedObject = __w_pdfjs_require__(13);
var toObject = __w_pdfjs_require__(40);
var lengthOfArrayLike = __w_pdfjs_require__(64);
var createMethod = function (TYPE) {
 var IS_FIND_LAST_INDEX = TYPE === 1;
 return function ($this, callbackfn, that) {
  var O = toObject($this);
  var self = IndexedObject(O);
  var boundFunction = bind(callbackfn, that);
  var index = lengthOfArrayLike(self);
  var value, result;
  while (index-- > 0) {
   value = self[index];
   result = boundFunction(value, index, O);
   if (result)
    switch (TYPE) {
    case 0:
     return value;
    case 1:
     return index;
    }
  }
  return IS_FIND_LAST_INDEX ? -1 : undefined;
 };
};
module.exports = {
 findLast: createMethod(0),
 findLastIndex: createMethod(1)
};

/***/ }),
/* 99 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var uncurryThis = __w_pdfjs_require__(100);
var aCallable = __w_pdfjs_require__(31);
var NATIVE_BIND = __w_pdfjs_require__(9);
var bind = uncurryThis(uncurryThis.bind);
module.exports = function (fn, that) {
 aCallable(fn);
 return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function () {
  return fn.apply(that, arguments);
 };
};

/***/ }),
/* 100 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var classofRaw = __w_pdfjs_require__(15);
var uncurryThis = __w_pdfjs_require__(14);
module.exports = function (fn) {
 if (classofRaw(fn) === 'Function')
  return uncurryThis(fn);
};

/***/ }),
/* 101 */
/***/ ((__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__) => {


var ArrayBufferViewCore = __w_pdfjs_require__(94);
var $findLastIndex = (__w_pdfjs_require__(98).findLastIndex);
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
exportTypedArrayMethod('findLastIndex', function findLastIndex(predicate) {
 return $findLastIndex(aTypedArray(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
});

/***/ }),
/* 102 */
/***/ ((__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__) => {


var global = __w_pdfjs_require__(4);
var call = __w_pdfjs_require__(8);
var ArrayBufferViewCore = __w_pdfjs_require__(94);
var lengthOfArrayLike = __w_pdfjs_require__(64);
var toOffset = __w_pdfjs_require__(103);
var toIndexedObject = __w_pdfjs_require__(40);
var fails = __w_pdfjs_require__(7);
var RangeError = global.RangeError;
var Int8Array = global.Int8Array;
var Int8ArrayPrototype = Int8Array && Int8Array.prototype;
var $set = Int8ArrayPrototype && Int8ArrayPrototype.set;
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS = !fails(function () {
 var array = new Uint8ClampedArray(2);
 call($set, array, {
  length: 1,
  0: 3
 }, 1);
 return array[1] !== 3;
});
var TO_OBJECT_BUG = WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS && ArrayBufferViewCore.NATIVE_ARRAY_BUFFER_VIEWS && fails(function () {
 var array = new Int8Array(2);
 array.set(1);
 array.set('2', 1);
 return array[0] !== 0 || array[1] !== 2;
});
exportTypedArrayMethod('set', function set(arrayLike) {
 aTypedArray(this);
 var offset = toOffset(arguments.length > 1 ? arguments[1] : undefined, 1);
 var src = toIndexedObject(arrayLike);
 if (WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS)
  return call($set, this, src, offset);
 var length = this.length;
 var len = lengthOfArrayLike(src);
 var index = 0;
 if (len + offset > length)
  throw RangeError('Wrong length');
 while (index < len)
  this[offset + index] = src[index++];
}, !WORKS_WITH_OBJECTS_AND_GENERIC_ON_TYPED_ARRAYS || TO_OBJECT_BUG);

/***/ }),
/* 103 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var toPositiveInteger = __w_pdfjs_require__(104);
var $RangeError = RangeError;
module.exports = function (it, BYTES) {
 var offset = toPositiveInteger(it);
 if (offset % BYTES)
  throw $RangeError('Wrong offset');
 return offset;
};

/***/ }),
/* 104 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var toIntegerOrInfinity = __w_pdfjs_require__(62);
var $RangeError = RangeError;
module.exports = function (it) {
 var result = toIntegerOrInfinity(it);
 if (result < 0)
  throw $RangeError("The argument can't be less than 0");
 return result;
};

/***/ }),
/* 105 */
/***/ ((__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__) => {


var arrayToReversed = __w_pdfjs_require__(106);
var ArrayBufferViewCore = __w_pdfjs_require__(94);
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
exportTypedArrayMethod('toReversed', function toReversed() {
 return arrayToReversed(aTypedArray(this), getTypedArrayConstructor(this));
});

/***/ }),
/* 106 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var lengthOfArrayLike = __w_pdfjs_require__(64);
module.exports = function (O, C) {
 var len = lengthOfArrayLike(O);
 var A = new C(len);
 var k = 0;
 for (; k < len; k++)
  A[k] = O[len - k - 1];
 return A;
};

/***/ }),
/* 107 */
/***/ ((__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__) => {


var ArrayBufferViewCore = __w_pdfjs_require__(94);
var uncurryThis = __w_pdfjs_require__(14);
var aCallable = __w_pdfjs_require__(31);
var arrayFromConstructorAndList = __w_pdfjs_require__(108);
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var sort = uncurryThis(ArrayBufferViewCore.TypedArrayPrototype.sort);
exportTypedArrayMethod('toSorted', function toSorted(compareFn) {
 if (compareFn !== undefined)
  aCallable(compareFn);
 var O = aTypedArray(this);
 var A = arrayFromConstructorAndList(getTypedArrayConstructor(O), O);
 return sort(A, compareFn);
});

/***/ }),
/* 108 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var lengthOfArrayLike = __w_pdfjs_require__(64);
module.exports = function (Constructor, list) {
 var index = 0;
 var length = lengthOfArrayLike(list);
 var result = new Constructor(length);
 while (length > index)
  result[index] = list[index++];
 return result;
};

/***/ }),
/* 109 */
/***/ ((__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__) => {


var arrayWith = __w_pdfjs_require__(110);
var ArrayBufferViewCore = __w_pdfjs_require__(94);
var isBigIntArray = __w_pdfjs_require__(111);
var toIntegerOrInfinity = __w_pdfjs_require__(62);
var toBigInt = __w_pdfjs_require__(112);
var aTypedArray = ArrayBufferViewCore.aTypedArray;
var getTypedArrayConstructor = ArrayBufferViewCore.getTypedArrayConstructor;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod;
var PROPER_ORDER = !!(function () {
 try {
  new Int8Array(1)['with'](2, {
   valueOf: function () {
    throw 8;
   }
  });
 } catch (error) {
  return error === 8;
 }
}());
exportTypedArrayMethod('with', {
 'with': function (index, value) {
  var O = aTypedArray(this);
  var relativeIndex = toIntegerOrInfinity(index);
  var actualValue = isBigIntArray(O) ? toBigInt(value) : +value;
  return arrayWith(O, getTypedArrayConstructor(O), relativeIndex, actualValue);
 }
}['with'], !PROPER_ORDER);

/***/ }),
/* 110 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var lengthOfArrayLike = __w_pdfjs_require__(64);
var toIntegerOrInfinity = __w_pdfjs_require__(62);
var $RangeError = RangeError;
module.exports = function (O, C, index, value) {
 var len = lengthOfArrayLike(O);
 var relativeIndex = toIntegerOrInfinity(index);
 var actualIndex = relativeIndex < 0 ? len + relativeIndex : relativeIndex;
 if (actualIndex >= len || actualIndex < 0)
  throw $RangeError('Incorrect index');
 var A = new C(len);
 var k = 0;
 for (; k < len; k++)
  A[k] = k === actualIndex ? value : O[k];
 return A;
};

/***/ }),
/* 111 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var classof = __w_pdfjs_require__(78);
module.exports = function (it) {
 var klass = classof(it);
 return klass === 'BigInt64Array' || klass === 'BigUint64Array';
};

/***/ }),
/* 112 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var toPrimitive = __w_pdfjs_require__(19);
var $TypeError = TypeError;
module.exports = function (argument) {
 var prim = toPrimitive(argument, 'number');
 if (typeof prim == 'number')
  throw $TypeError("Can't convert number to bigint");
 return BigInt(prim);
};

/***/ }),
/* 113 */
/***/ ((__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__) => {


var DESCRIPTORS = __w_pdfjs_require__(6);
var defineBuiltInAccessor = __w_pdfjs_require__(88);
var isDetached = __w_pdfjs_require__(114);
var ArrayBufferPrototype = ArrayBuffer.prototype;
if (DESCRIPTORS && !('detached' in ArrayBufferPrototype)) {
 defineBuiltInAccessor(ArrayBufferPrototype, 'detached', {
  configurable: true,
  get: function detached() {
   return isDetached(this);
  }
 });
}

/***/ }),
/* 114 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var uncurryThis = __w_pdfjs_require__(14);
var arrayBufferByteLength = __w_pdfjs_require__(115);
var slice = uncurryThis(ArrayBuffer.prototype.slice);
module.exports = function (O) {
 if (arrayBufferByteLength(O) !== 0)
  return false;
 try {
  slice(O, 0, 0);
  return false;
 } catch (error) {
  return true;
 }
};

/***/ }),
/* 115 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var uncurryThisAccessor = __w_pdfjs_require__(72);
var classof = __w_pdfjs_require__(15);
var $TypeError = TypeError;
module.exports = uncurryThisAccessor(ArrayBuffer.prototype, 'byteLength', 'get') || function (O) {
 if (classof(O) !== 'ArrayBuffer')
  throw $TypeError('ArrayBuffer expected');
 return O.byteLength;
};

/***/ }),
/* 116 */
/***/ ((__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__) => {


var $ = __w_pdfjs_require__(3);
var $transfer = __w_pdfjs_require__(117);
if ($transfer)
 $({
  target: 'ArrayBuffer',
  proto: true
 }, {
  transfer: function transfer() {
   return $transfer(this, arguments.length ? arguments[0] : undefined, true);
  }
 });

/***/ }),
/* 117 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var global = __w_pdfjs_require__(4);
var uncurryThis = __w_pdfjs_require__(14);
var uncurryThisAccessor = __w_pdfjs_require__(72);
var toIndex = __w_pdfjs_require__(118);
var isDetached = __w_pdfjs_require__(114);
var arrayBufferByteLength = __w_pdfjs_require__(115);
var PROPER_TRANSFER = __w_pdfjs_require__(119);
var TypeError = global.TypeError;
var structuredClone = global.structuredClone;
var ArrayBuffer = global.ArrayBuffer;
var DataView = global.DataView;
var min = Math.min;
var ArrayBufferPrototype = ArrayBuffer.prototype;
var DataViewPrototype = DataView.prototype;
var slice = uncurryThis(ArrayBufferPrototype.slice);
var isResizable = uncurryThisAccessor(ArrayBufferPrototype, 'resizable', 'get');
var maxByteLength = uncurryThisAccessor(ArrayBufferPrototype, 'maxByteLength', 'get');
var getInt8 = uncurryThis(DataViewPrototype.getInt8);
var setInt8 = uncurryThis(DataViewPrototype.setInt8);
module.exports = PROPER_TRANSFER && function (arrayBuffer, newLength, preserveResizability) {
 var byteLength = arrayBufferByteLength(arrayBuffer);
 var newByteLength = newLength === undefined ? byteLength : toIndex(newLength);
 var fixedLength = !isResizable || !isResizable(arrayBuffer);
 if (isDetached(arrayBuffer))
  throw TypeError('ArrayBuffer is detached');
 var newBuffer = structuredClone(arrayBuffer, { transfer: [arrayBuffer] });
 if (byteLength === newByteLength && (preserveResizability || fixedLength))
  return newBuffer;
 if (byteLength >= newByteLength && (!preserveResizability || fixedLength))
  return slice(newBuffer, 0, newByteLength);
 var options = preserveResizability && !fixedLength && maxByteLength ? { maxByteLength: maxByteLength(newBuffer) } : undefined;
 var newNewBuffer = new ArrayBuffer(newByteLength, options);
 var a = new DataView(newBuffer);
 var b = new DataView(newNewBuffer);
 var copyLength = min(newByteLength, byteLength);
 for (var i = 0; i < copyLength; i++)
  setInt8(b, i, getInt8(a, i));
 return newNewBuffer;
};

/***/ }),
/* 118 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var toIntegerOrInfinity = __w_pdfjs_require__(62);
var toLength = __w_pdfjs_require__(65);
var $RangeError = RangeError;
module.exports = function (it) {
 if (it === undefined)
  return 0;
 var number = toIntegerOrInfinity(it);
 var length = toLength(number);
 if (number !== length)
  throw $RangeError('Wrong length or index');
 return length;
};

/***/ }),
/* 119 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var global = __w_pdfjs_require__(4);
var fails = __w_pdfjs_require__(7);
var V8 = __w_pdfjs_require__(28);
var IS_BROWSER = __w_pdfjs_require__(120);
var IS_DENO = __w_pdfjs_require__(121);
var IS_NODE = __w_pdfjs_require__(122);
var structuredClone = global.structuredClone;
module.exports = !!structuredClone && !fails(function () {
 if (IS_DENO && V8 > 92 || IS_NODE && V8 > 94 || IS_BROWSER && V8 > 97)
  return false;
 var buffer = new ArrayBuffer(8);
 var clone = structuredClone(buffer, { transfer: [buffer] });
 return buffer.byteLength !== 0 || clone.byteLength !== 8;
});

/***/ }),
/* 120 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var IS_DENO = __w_pdfjs_require__(121);
var IS_NODE = __w_pdfjs_require__(122);
module.exports = !IS_DENO && !IS_NODE && typeof window == 'object' && typeof document == 'object';

/***/ }),
/* 121 */
/***/ ((module) => {


module.exports = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';

/***/ }),
/* 122 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var global = __w_pdfjs_require__(4);
var classof = __w_pdfjs_require__(15);
module.exports = classof(global.process) === 'process';

/***/ }),
/* 123 */
/***/ ((__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__) => {


var $ = __w_pdfjs_require__(3);
var $transfer = __w_pdfjs_require__(117);
if ($transfer)
 $({
  target: 'ArrayBuffer',
  proto: true
 }, {
  transferToFixedLength: function transferToFixedLength() {
   return $transfer(this, arguments.length ? arguments[0] : undefined, false);
  }
 });

/***/ }),
/* 124 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.RenderTask = exports.PDFWorkerUtil = exports.PDFWorker = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFDocumentLoadingTask = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.DefaultStandardFontDataFactory = exports.DefaultFilterFactory = exports.DefaultCanvasFactory = exports.DefaultCMapReaderFactory = void 0;
Object.defineProperty(exports, "SVGGraphics", ({
  enumerable: true,
  get: function () {
    return _displaySvg.SVGGraphics;
  }
}));
exports.build = void 0;
exports.getDocument = getDocument;
exports.version = void 0;
__w_pdfjs_require__(84);
__w_pdfjs_require__(86);
__w_pdfjs_require__(87);
__w_pdfjs_require__(2);
__w_pdfjs_require__(93);
__w_pdfjs_require__(101);
__w_pdfjs_require__(102);
__w_pdfjs_require__(105);
__w_pdfjs_require__(107);
__w_pdfjs_require__(109);
__w_pdfjs_require__(113);
__w_pdfjs_require__(116);
__w_pdfjs_require__(123);
__w_pdfjs_require__(89);
__w_pdfjs_require__(125);
__w_pdfjs_require__(136);
__w_pdfjs_require__(138);
__w_pdfjs_require__(141);
__w_pdfjs_require__(143);
__w_pdfjs_require__(145);
__w_pdfjs_require__(147);
__w_pdfjs_require__(149);
__w_pdfjs_require__(152);
var _util = __w_pdfjs_require__(1);
var _annotation_storage = __w_pdfjs_require__(163);
var _display_utils = __w_pdfjs_require__(168);
var _font_loader = __w_pdfjs_require__(171);
var _displayNode_utils = __w_pdfjs_require__(172);
var _canvas = __w_pdfjs_require__(173);
var _worker_options = __w_pdfjs_require__(176);
var _message_handler = __w_pdfjs_require__(177);
var _metadata = __w_pdfjs_require__(178);
var _optional_content_config = __w_pdfjs_require__(179);
var _transport_stream = __w_pdfjs_require__(180);
var _displayFetch_stream = __w_pdfjs_require__(181);
var _displayNetwork = __w_pdfjs_require__(184);
var _displayNode_stream = __w_pdfjs_require__(185);
var _displaySvg = __w_pdfjs_require__(186);
var _xfa_text = __w_pdfjs_require__(194);
const DEFAULT_RANGE_CHUNK_SIZE = 65536;
const RENDERING_CANCELLED_TIMEOUT = 100;
const DELAYED_CLEANUP_TIMEOUT = 5000;
const DefaultCanvasFactory = _util.isNodeJS ? _displayNode_utils.NodeCanvasFactory : _display_utils.DOMCanvasFactory;
exports.DefaultCanvasFactory = DefaultCanvasFactory;
const DefaultCMapReaderFactory = _util.isNodeJS ? _displayNode_utils.NodeCMapReaderFactory : _display_utils.DOMCMapReaderFactory;
exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory;
const DefaultFilterFactory = _util.isNodeJS ? _displayNode_utils.NodeFilterFactory : _display_utils.DOMFilterFactory;
exports.DefaultFilterFactory = DefaultFilterFactory;
const DefaultStandardFontDataFactory = _util.isNodeJS ? _displayNode_utils.NodeStandardFontDataFactory : _display_utils.DOMStandardFontDataFactory;
exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory;
function getDocument(src) {
  if (typeof src === "string" || src instanceof URL) {
    src = {
      url: src
    };
  } else if ((0, _util.isArrayBuffer)(src)) {
    src = {
      data: src
    };
  }
  if (typeof src !== "object") {
    throw new Error("Invalid parameter in getDocument, need parameter object.");
  }
  if (!src.url && !src.data && !src.range) {
    throw new Error("Invalid parameter object: need either .data, .range or .url");
  }
  const task = new PDFDocumentLoadingTask();
  const {
    docId
  } = task;
  const url = src.url ? getUrlProp(src.url) : null;
  const data = src.data ? getDataProp(src.data) : null;
  const httpHeaders = src.httpHeaders || null;
  const withCredentials = src.withCredentials === true;
  const password = src.password ?? null;
  const rangeTransport = src.range instanceof PDFDataRangeTransport ? src.range : null;
  const rangeChunkSize = Number.isInteger(src.rangeChunkSize) && src.rangeChunkSize > 0 ? src.rangeChunkSize : DEFAULT_RANGE_CHUNK_SIZE;
  let worker = src.worker instanceof PDFWorker ? src.worker : null;
  const verbosity = src.verbosity;
  const docBaseUrl = typeof src.docBaseUrl === "string" && !(0, _display_utils.isDataScheme)(src.docBaseUrl) ? src.docBaseUrl : null;
  const cMapUrl = typeof src.cMapUrl === "string" ? src.cMapUrl : null;
  const cMapPacked = src.cMapPacked !== false;
  const CMapReaderFactory = src.CMapReaderFactory || DefaultCMapReaderFactory;
  const standardFontDataUrl = typeof src.standardFontDataUrl === "string" ? src.standardFontDataUrl : null;
  const StandardFontDataFactory = src.StandardFontDataFactory || DefaultStandardFontDataFactory;
  const ignoreErrors = src.stopAtErrors !== true;
  const maxImageSize = Number.isInteger(src.maxImageSize) && src.maxImageSize > -1 ? src.maxImageSize : -1;
  const isEvalSupported = src.isEvalSupported !== false;
  const isOffscreenCanvasSupported = typeof src.isOffscreenCanvasSupported === "boolean" ? src.isOffscreenCanvasSupported : !_util.isNodeJS;
  const canvasMaxAreaInBytes = Number.isInteger(src.canvasMaxAreaInBytes) ? src.canvasMaxAreaInBytes : -1;
  const disableFontFace = typeof src.disableFontFace === "boolean" ? src.disableFontFace : _util.isNodeJS;
  const fontExtraProperties = src.fontExtraProperties === true;
  const enableXfa = src.enableXfa === true;
  const ownerDocument = src.ownerDocument || globalThis.document;
  const disableRange = src.disableRange === true;
  const disableStream = src.disableStream === true;
  const disableAutoFetch = src.disableAutoFetch === true;
  const pdfBug = src.pdfBug === true;
  const length = rangeTransport ? rangeTransport.length : src.length ?? NaN;
  const useSystemFonts = typeof src.useSystemFonts === "boolean" ? src.useSystemFonts : !_util.isNodeJS && !disableFontFace;
  const useWorkerFetch = typeof src.useWorkerFetch === "boolean" ? src.useWorkerFetch : CMapReaderFactory === _display_utils.DOMCMapReaderFactory && StandardFontDataFactory === _display_utils.DOMStandardFontDataFactory && cMapUrl && standardFontDataUrl && (0, _display_utils.isValidFetchUrl)(cMapUrl, document.baseURI) && (0, _display_utils.isValidFetchUrl)(standardFontDataUrl, document.baseURI);
  const canvasFactory = src.canvasFactory || new DefaultCanvasFactory({
    ownerDocument
  });
  const filterFactory = src.filterFactory || new DefaultFilterFactory({
    docId,
    ownerDocument
  });
  const styleElement = null;
  (0, _util.setVerbosityLevel)(verbosity);
  const transportFactory = {
    canvasFactory,
    filterFactory
  };
  if (!useWorkerFetch) {
    transportFactory.cMapReaderFactory = new CMapReaderFactory({
      baseUrl: cMapUrl,
      isCompressed: cMapPacked
    });
    transportFactory.standardFontDataFactory = new StandardFontDataFactory({
      baseUrl: standardFontDataUrl
    });
  }
  if (!worker) {
    const workerParams = {
      verbosity,
      port: _worker_options.GlobalWorkerOptions.workerPort
    };
    worker = workerParams.port ? PDFWorker.fromPort(workerParams) : new PDFWorker(workerParams);
    task._worker = worker;
  }
  const fetchDocParams = {
    docId,
    apiVersion: '3.11.174',
    data,
    password,
    disableAutoFetch,
    rangeChunkSize,
    length,
    docBaseUrl,
    enableXfa,
    evaluatorOptions: {
      maxImageSize,
      disableFontFace,
      ignoreErrors,
      isEvalSupported,
      isOffscreenCanvasSupported,
      canvasMaxAreaInBytes,
      fontExtraProperties,
      useSystemFonts,
      cMapUrl: useWorkerFetch ? cMapUrl : null,
      standardFontDataUrl: useWorkerFetch ? standardFontDataUrl : null
    }
  };
  const transportParams = {
    ignoreErrors,
    isEvalSupported,
    disableFontFace,
    fontExtraProperties,
    enableXfa,
    ownerDocument,
    disableAutoFetch,
    pdfBug,
    styleElement
  };
  worker.promise.then(function () {
    if (task.destroyed) {
      throw new Error("Loading aborted");
    }
    const workerIdPromise = _fetchDocument(worker, fetchDocParams);
    const networkStreamPromise = new Promise(function (resolve) {
      let networkStream;
      if (rangeTransport) {
        networkStream = new _transport_stream.PDFDataTransportStream({
          length,
          initialData: rangeTransport.initialData,
          progressiveDone: rangeTransport.progressiveDone,
          contentDispositionFilename: rangeTransport.contentDispositionFilename,
          disableRange,
          disableStream
        }, rangeTransport);
      } else if (!data) {
        const createPDFNetworkStream = params => {
          if (_util.isNodeJS) {
            return new _displayNode_stream.PDFNodeStream(params);
          }
          return (0, _display_utils.isValidFetchUrl)(params.url) ? new _displayFetch_stream.PDFFetchStream(params) : new _displayNetwork.PDFNetworkStream(params);
        };
        networkStream = createPDFNetworkStream({
          url,
          length,
          httpHeaders,
          withCredentials,
          rangeChunkSize,
          disableRange,
          disableStream
        });
      }
      resolve(networkStream);
    });
    return Promise.all([workerIdPromise, networkStreamPromise]).then(function (_ref) {
      let [workerId, networkStream] = _ref;
      if (task.destroyed) {
        throw new Error("Loading aborted");
      }
      const messageHandler = new _message_handler.MessageHandler(docId, workerId, worker.port);
      const transport = new WorkerTransport(messageHandler, task, networkStream, transportParams, transportFactory);
      task._transport = transport;
      messageHandler.send("Ready", null);
    });
  }).catch(task._capability.reject);
  return task;
}
async function _fetchDocument(worker, source) {
  if (worker.destroyed) {
    throw new Error("Worker was destroyed");
  }
  const workerId = await worker.messageHandler.sendWithPromise("GetDocRequest", source, source.data ? [source.data.buffer] : null);
  if (worker.destroyed) {
    throw new Error("Worker was destroyed");
  }
  return workerId;
}
function getUrlProp(val) {
  if (val instanceof URL) {
    return val.href;
  }
  try {
    return new URL(val, window.location).href;
  } catch {
    if (_util.isNodeJS && typeof val === "string") {
      return val;
    }
  }
  throw new Error("Invalid PDF url data: " + "either string or URL-object is expected in the url property.");
}
function getDataProp(val) {
  if (_util.isNodeJS && typeof Buffer !== "undefined" && val instanceof Buffer) {
    throw new Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
  }
  if (val instanceof Uint8Array && val.byteLength === val.buffer.byteLength) {
    return val;
  }
  if (typeof val === "string") {
    return (0, _util.stringToBytes)(val);
  }
  if (typeof val === "object" && !isNaN(val?.length) || (0, _util.isArrayBuffer)(val)) {
    return new Uint8Array(val);
  }
  throw new Error("Invalid PDF binary data: either TypedArray, " + "string, or array-like object is expected in the data property.");
}
class PDFDocumentLoadingTask {
  static #docId = 0;
  constructor() {
    this._capability = new _util.PromiseCapability();
    this._transport = null;
    this._worker = null;
    this.docId = `d${PDFDocumentLoadingTask.#docId++}`;
    this.destroyed = false;
    this.onPassword = null;
    this.onProgress = null;
  }
  get promise() {
    return this._capability.promise;
  }
  async destroy() {
    this.destroyed = true;
    try {
      if (this._worker?.port) {
        this._worker._pendingDestroy = true;
      }
      await this._transport?.destroy();
    } catch (ex) {
      if (this._worker?.port) {
        delete this._worker._pendingDestroy;
      }
      throw ex;
    }
    this._transport = null;
    if (this._worker) {
      this._worker.destroy();
      this._worker = null;
    }
  }
}
exports.PDFDocumentLoadingTask = PDFDocumentLoadingTask;
class PDFDataRangeTransport {
  constructor(length, initialData) {
    let progressiveDone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let contentDispositionFilename = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    this.length = length;
    this.initialData = initialData;
    this.progressiveDone = progressiveDone;
    this.contentDispositionFilename = contentDispositionFilename;
    this._rangeListeners = [];
    this._progressListeners = [];
    this._progressiveReadListeners = [];
    this._progressiveDoneListeners = [];
    this._readyCapability = new _util.PromiseCapability();
  }
  addRangeListener(listener) {
    this._rangeListeners.push(listener);
  }
  addProgressListener(listener) {
    this._progressListeners.push(listener);
  }
  addProgressiveReadListener(listener) {
    this._progressiveReadListeners.push(listener);
  }
  addProgressiveDoneListener(listener) {
    this._progressiveDoneListeners.push(listener);
  }
  onDataRange(begin, chunk) {
    for (const listener of this._rangeListeners) {
      listener(begin, chunk);
    }
  }
  onDataProgress(loaded, total) {
    this._readyCapability.promise.then(() => {
      for (const listener of this._progressListeners) {
        listener(loaded, total);
      }
    });
  }
  onDataProgressiveRead(chunk) {
    this._readyCapability.promise.then(() => {
      for (const listener of this._progressiveReadListeners) {
        listener(chunk);
      }
    });
  }
  onDataProgressiveDone() {
    this._readyCapability.promise.then(() => {
      for (const listener of this._progressiveDoneListeners) {
        listener();
      }
    });
  }
  transportReady() {
    this._readyCapability.resolve();
  }
  requestDataRange(begin, end) {
    (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
  }
  abort() {}
}
exports.PDFDataRangeTransport = PDFDataRangeTransport;
class PDFDocumentProxy {
  constructor(pdfInfo, transport) {
    this._pdfInfo = pdfInfo;
    this._transport = transport;
    Object.defineProperty(this, "getJavaScript", {
      value: () => {
        (0, _display_utils.deprecated)("`PDFDocumentProxy.getJavaScript`, " + "please use `PDFDocumentProxy.getJSActions` instead.");
        return this.getJSActions().then(js => {
          if (!js) {
            return js;
          }
          const jsArr = [];
          for (const name in js) {
            jsArr.push(...js[name]);
          }
          return jsArr;
        });
      }
    });
  }
  get annotationStorage() {
    return this._transport.annotationStorage;
  }
  get filterFactory() {
    return this._transport.filterFactory;
  }
  get numPages() {
    return this._pdfInfo.numPages;
  }
  get fingerprints() {
    return this._pdfInfo.fingerprints;
  }
  get isPureXfa() {
    return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
  }
  get allXfaHtml() {
    return this._transport._htmlForXfa;
  }
  getPage(pageNumber) {
    return this._transport.getPage(pageNumber);
  }
  getPageIndex(ref) {
    return this._transport.getPageIndex(ref);
  }
  getDestinations() {
    return this._transport.getDestinations();
  }
  getDestination(id) {
    return this._transport.getDestination(id);
  }
  getPageLabels() {
    return this._transport.getPageLabels();
  }
  getPageLayout() {
    return this._transport.getPageLayout();
  }
  getPageMode() {
    return this._transport.getPageMode();
  }
  getViewerPreferences() {
    return this._transport.getViewerPreferences();
  }
  getOpenAction() {
    return this._transport.getOpenAction();
  }
  getAttachments() {
    return this._transport.getAttachments();
  }
  getJSActions() {
    return this._transport.getDocJSActions();
  }
  getOutline() {
    return this._transport.getOutline();
  }
  getOptionalContentConfig() {
    return this._transport.getOptionalContentConfig();
  }
  getPermissions() {
    return this._transport.getPermissions();
  }
  getMetadata() {
    return this._transport.getMetadata();
  }
  getMarkInfo() {
    return this._transport.getMarkInfo();
  }
  getData() {
    return this._transport.getData();
  }
  saveDocument() {
    return this._transport.saveDocument();
  }
  getDownloadInfo() {
    return this._transport.downloadInfoCapability.promise;
  }
  cleanup() {
    let keepLoadedFonts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return this._transport.startCleanup(keepLoadedFonts || this.isPureXfa);
  }
  destroy() {
    return this.loadingTask.destroy();
  }
  get loadingParams() {
    return this._transport.loadingParams;
  }
  get loadingTask() {
    return this._transport.loadingTask;
  }
  getFieldObjects() {
    return this._transport.getFieldObjects();
  }
  hasJSActions() {
    return this._transport.hasJSActions();
  }
  getCalculationOrderIds() {
    return this._transport.getCalculationOrderIds();
  }
}
exports.PDFDocumentProxy = PDFDocumentProxy;
class PDFPageProxy {
  #delayedCleanupTimeout = null;
  #pendingCleanup = false;
  constructor(pageIndex, pageInfo, transport) {
    let pdfBug = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    this._pageIndex = pageIndex;
    this._pageInfo = pageInfo;
    this._transport = transport;
    this._stats = pdfBug ? new _display_utils.StatTimer() : null;
    this._pdfBug = pdfBug;
    this.commonObjs = transport.commonObjs;
    this.objs = new PDFObjects();
    this._maybeCleanupAfterRender = false;
    this._intentStates = new Map();
    this.destroyed = false;
  }
  get pageNumber() {
    return this._pageIndex + 1;
  }
  get rotate() {
    return this._pageInfo.rotate;
  }
  get ref() {
    return this._pageInfo.ref;
  }
  get userUnit() {
    return this._pageInfo.userUnit;
  }
  get view() {
    return this._pageInfo.view;
  }
  getViewport() {
    let {
      scale,
      rotation = this.rotate,
      offsetX = 0,
      offsetY = 0,
      dontFlip = false
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new _display_utils.PageViewport({
      viewBox: this.view,
      scale,
      rotation,
      offsetX,
      offsetY,
      dontFlip
    });
  }
  getAnnotations() {
    let {
      intent = "display"
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const intentArgs = this._transport.getRenderingIntent(intent);
    return this._transport.getAnnotations(this._pageIndex, intentArgs.renderingIntent);
  }
  getJSActions() {
    return this._transport.getPageJSActions(this._pageIndex);
  }
  get filterFactory() {
    return this._transport.filterFactory;
  }
  get isPureXfa() {
    return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
  }
  async getXfa() {
    return this._transport._htmlForXfa?.children[this._pageIndex] || null;
  }
  render(_ref2) {
    let {
      canvasContext,
      viewport,
      intent = "display",
      annotationMode = _util.AnnotationMode.ENABLE,
      transform = null,
      background = null,
      optionalContentConfigPromise = null,
      annotationCanvasMap = null,
      pageColors = null,
      printAnnotationStorage = null
    } = _ref2;
    this._stats?.time("Overall");
    const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage);
    this.#pendingCleanup = false;
    this.#abortDelayedCleanup();
    if (!optionalContentConfigPromise) {
      optionalContentConfigPromise = this._transport.getOptionalContentConfig();
    }
    let intentState = this._intentStates.get(intentArgs.cacheKey);
    if (!intentState) {
      intentState = Object.create(null);
      this._intentStates.set(intentArgs.cacheKey, intentState);
    }
    if (intentState.streamReaderCancelTimeout) {
      clearTimeout(intentState.streamReaderCancelTimeout);
      intentState.streamReaderCancelTimeout = null;
    }
    const intentPrint = !!(intentArgs.renderingIntent & _util.RenderingIntentFlag.PRINT);
    if (!intentState.displayReadyCapability) {
      intentState.displayReadyCapability = new _util.PromiseCapability();
      intentState.operatorList = {
        fnArray: [],
        argsArray: [],
        lastChunk: false,
        separateAnnots: null
      };
      this._stats?.time("Page Request");
      this._pumpOperatorList(intentArgs);
    }
    const complete = error => {
      intentState.renderTasks.delete(internalRenderTask);
      if (this._maybeCleanupAfterRender || intentPrint) {
        this.#pendingCleanup = true;
      }
      this.#tryCleanup(!intentPrint);
      if (error) {
        internalRenderTask.capability.reject(error);
        this._abortOperatorList({
          intentState,
          reason: error instanceof Error ? error : new Error(error)
        });
      } else {
        internalRenderTask.capability.resolve();
      }
      this._stats?.timeEnd("Rendering");
      this._stats?.timeEnd("Overall");
    };
    const internalRenderTask = new InternalRenderTask({
      callback: complete,
      params: {
        canvasContext,
        viewport,
        transform,
        background
      },
      objs: this.objs,
      commonObjs: this.commonObjs,
      annotationCanvasMap,
      operatorList: intentState.operatorList,
      pageIndex: this._pageIndex,
      canvasFactory: this._transport.canvasFactory,
      filterFactory: this._transport.filterFactory,
      useRequestAnimationFrame: !intentPrint,
      pdfBug: this._pdfBug,
      pageColors
    });
    (intentState.renderTasks ||= new Set()).add(internalRenderTask);
    const renderTask = internalRenderTask.task;
    Promise.all([intentState.displayReadyCapability.promise, optionalContentConfigPromise]).then(_ref3 => {
      let [transparency, optionalContentConfig] = _ref3;
      if (this.destroyed) {
        complete();
        return;
      }
      this._stats?.time("Rendering");
      internalRenderTask.initializeGraphics({
        transparency,
        optionalContentConfig
      });
      internalRenderTask.operatorListChanged();
    }).catch(complete);
    return renderTask;
  }
  getOperatorList() {
    let {
      intent = "display",
      annotationMode = _util.AnnotationMode.ENABLE,
      printAnnotationStorage = null
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    function operatorListChanged() {
      if (intentState.operatorList.lastChunk) {
        intentState.opListReadCapability.resolve(intentState.operatorList);
        intentState.renderTasks.delete(opListTask);
      }
    }
    const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage, true);
    let intentState = this._intentStates.get(intentArgs.cacheKey);
    if (!intentState) {
      intentState = Object.create(null);
      this._intentStates.set(intentArgs.cacheKey, intentState);
    }
    let opListTask;
    if (!intentState.opListReadCapability) {
      opListTask = Object.create(null);
      opListTask.operatorListChanged = operatorListChanged;
      intentState.opListReadCapability = new _util.PromiseCapability();
      (intentState.renderTasks ||= new Set()).add(opListTask);
      intentState.operatorList = {
        fnArray: [],
        argsArray: [],
        lastChunk: false,
        separateAnnots: null
      };
      this._stats?.time("Page Request");
      this._pumpOperatorList(intentArgs);
    }
    return intentState.opListReadCapability.promise;
  }
  streamTextContent() {
    let {
      includeMarkedContent = false,
      disableNormalization = false
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const TEXT_CONTENT_CHUNK_SIZE = 100;
    return this._transport.messageHandler.sendWithStream("GetTextContent", {
      pageIndex: this._pageIndex,
      includeMarkedContent: includeMarkedContent === true,
      disableNormalization: disableNormalization === true
    }, {
      highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
      size(textContent) {
        return textContent.items.length;
      }
    });
  }
  getTextContent() {
    let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (this._transport._htmlForXfa) {
      return this.getXfa().then(xfa => {
        return _xfa_text.XfaText.textContent(xfa);
      });
    }
    const readableStream = this.streamTextContent(params);
    return new Promise(function (resolve, reject) {
      function pump() {
        reader.read().then(function (_ref4) {
          let {
            value,
            done
          } = _ref4;
          if (done) {
            resolve(textContent);
            return;
          }
          Object.assign(textContent.styles, value.styles);
          textContent.items.push(...value.items);
          pump();
        }, reject);
      }
      const reader = readableStream.getReader();
      const textContent = {
        items: [],
        styles: Object.create(null)
      };
      pump();
    });
  }
  getStructTree() {
    return this._transport.getStructTree(this._pageIndex);
  }
  _destroy() {
    this.destroyed = true;
    const waitOn = [];
    for (const intentState of this._intentStates.values()) {
      this._abortOperatorList({
        intentState,
        reason: new Error("Page was destroyed."),
        force: true
      });
      if (intentState.opListReadCapability) {
        continue;
      }
      for (const internalRenderTask of intentState.renderTasks) {
        waitOn.push(internalRenderTask.completed);
        internalRenderTask.cancel();
      }
    }
    this.objs.clear();
    this.#pendingCleanup = false;
    this.#abortDelayedCleanup();
    return Promise.all(waitOn);
  }
  cleanup() {
    let resetStats = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    this.#pendingCleanup = true;
    const success = this.#tryCleanup(false);
    if (resetStats && success) {
      this._stats &&= new _display_utils.StatTimer();
    }
    return success;
  }
  #tryCleanup() {
    let delayed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    this.#abortDelayedCleanup();
    if (!this.#pendingCleanup || this.destroyed) {
      return false;
    }
    if (delayed) {
      this.#delayedCleanupTimeout = setTimeout(() => {
        this.#delayedCleanupTimeout = null;
        this.#tryCleanup(false);
      }, DELAYED_CLEANUP_TIMEOUT);
      return false;
    }
    for (const {
      renderTasks,
      operatorList
    } of this._intentStates.values()) {
      if (renderTasks.size > 0 || !operatorList.lastChunk) {
        return false;
      }
    }
    this._intentStates.clear();
    this.objs.clear();
    this.#pendingCleanup = false;
    return true;
  }
  #abortDelayedCleanup() {
    if (this.#delayedCleanupTimeout) {
      clearTimeout(this.#delayedCleanupTimeout);
      this.#delayedCleanupTimeout = null;
    }
  }
  _startRenderPage(transparency, cacheKey) {
    const intentState = this._intentStates.get(cacheKey);
    if (!intentState) {
      return;
    }
    this._stats?.timeEnd("Page Request");
    intentState.displayReadyCapability?.resolve(transparency);
  }
  _renderPageChunk(operatorListChunk, intentState) {
    for (let i = 0, ii = operatorListChunk.length; i < ii; i++) {
      intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
      intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
    }
    intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
    intentState.operatorList.separateAnnots = operatorListChunk.separateAnnots;
    for (const internalRenderTask of intentState.renderTasks) {
      internalRenderTask.operatorListChanged();
    }
    if (operatorListChunk.lastChunk) {
      this.#tryCleanup(true);
    }
  }
  _pumpOperatorList(_ref5) {
    let {
      renderingIntent,
      cacheKey,
      annotationStorageSerializable
    } = _ref5;
    const {
      map,
      transfers
    } = annotationStorageSerializable;
    const readableStream = this._transport.messageHandler.sendWithStream("GetOperatorList", {
      pageIndex: this._pageIndex,
      intent: renderingIntent,
      cacheKey,
      annotationStorage: map
    }, transfers);
    const reader = readableStream.getReader();
    const intentState = this._intentStates.get(cacheKey);
    intentState.streamReader = reader;
    const pump = () => {
      reader.read().then(_ref6 => {
        let {
          value,
          done
        } = _ref6;
        if (done) {
          intentState.streamReader = null;
          return;
        }
        if (this._transport.destroyed) {
          return;
        }
        this._renderPageChunk(value, intentState);
        pump();
      }, reason => {
        intentState.streamReader = null;
        if (this._transport.destroyed) {
          return;
        }
        if (intentState.operatorList) {
          intentState.operatorList.lastChunk = true;
          for (const internalRenderTask of intentState.renderTasks) {
            internalRenderTask.operatorListChanged();
          }
          this.#tryCleanup(true);
        }
        if (intentState.displayReadyCapability) {
          intentState.displayReadyCapability.reject(reason);
        } else if (intentState.opListReadCapability) {
          intentState.opListReadCapability.reject(reason);
        } else {
          throw reason;
        }
      });
    };
    pump();
  }
  _abortOperatorList(_ref7) {
    let {
      intentState,
      reason,
      force = false
    } = _ref7;
    if (!intentState.streamReader) {
      return;
    }
    if (intentState.streamReaderCancelTimeout) {
      clearTimeout(intentState.streamReaderCancelTimeout);
      intentState.streamReaderCancelTimeout = null;
    }
    if (!force) {
      if (intentState.renderTasks.size > 0) {
        return;
      }
      if (reason instanceof _display_utils.RenderingCancelledException) {
        let delay = RENDERING_CANCELLED_TIMEOUT;
        if (reason.extraDelay > 0 && reason.extraDelay < 1000) {
          delay += reason.extraDelay;
        }
        intentState.streamReaderCancelTimeout = setTimeout(() => {
          intentState.streamReaderCancelTimeout = null;
          this._abortOperatorList({
            intentState,
            reason,
            force: true
          });
        }, delay);
        return;
      }
    }
    intentState.streamReader.cancel(new _util.AbortException(reason.message)).catch(() => {});
    intentState.streamReader = null;
    if (this._transport.destroyed) {
      return;
    }
    for (const [curCacheKey, curIntentState] of this._intentStates) {
      if (curIntentState === intentState) {
        this._intentStates.delete(curCacheKey);
        break;
      }
    }
    this.cleanup();
  }
  get stats() {
    return this._stats;
  }
}
exports.PDFPageProxy = PDFPageProxy;
class LoopbackPort {
  #listeners = new Set();
  #deferred = Promise.resolve();
  postMessage(obj, transfer) {
    const event = {
      data: structuredClone(obj, null)
    };
    this.#deferred.then(() => {
      for (const listener of this.#listeners) {
        listener.call(this, event);
      }
    });
  }
  addEventListener(name, listener) {
    this.#listeners.add(listener);
  }
  removeEventListener(name, listener) {
    this.#listeners.delete(listener);
  }
  terminate() {
    this.#listeners.clear();
  }
}
exports.LoopbackPort = LoopbackPort;
const PDFWorkerUtil = {
  isWorkerDisabled: false,
  fallbackWorkerSrc: null,
  fakeWorkerId: 0
};
exports.PDFWorkerUtil = PDFWorkerUtil;
{
  if (_util.isNodeJS && typeof require === "function") {
    PDFWorkerUtil.isWorkerDisabled = true;
    PDFWorkerUtil.fallbackWorkerSrc = "./pdf.worker.js";
  } else if (typeof document === "object") {
    const pdfjsFilePath = document?.currentScript?.src;
    if (pdfjsFilePath) {
      PDFWorkerUtil.fallbackWorkerSrc = pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2");
    }
  }
  PDFWorkerUtil.isSameOrigin = function (baseUrl, otherUrl) {
    let base;
    try {
      base = new URL(baseUrl);
      if (!base.origin || base.origin === "null") {
        return false;
      }
    } catch {
      return false;
    }
    const other = new URL(otherUrl, base);
    return base.origin === other.origin;
  };
  PDFWorkerUtil.createCDNWrapper = function (url) {
    const wrapper = `importScripts("${url}");`;
    return URL.createObjectURL(new Blob([wrapper]));
  };
}
class PDFWorker {
  static #workerPorts;
  constructor() {
    let {
      name = null,
      port = null,
      verbosity = (0, _util.getVerbosityLevel)()
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.name = name;
    this.destroyed = false;
    this.verbosity = verbosity;
    this._readyCapability = new _util.PromiseCapability();
    this._port = null;
    this._webWorker = null;
    this._messageHandler = null;
    if (port) {
      if (PDFWorker.#workerPorts?.has(port)) {
        throw new Error("Cannot use more than one PDFWorker per port.");
      }
      (PDFWorker.#workerPorts ||= new WeakMap()).set(port, this);
      this._initializeFromPort(port);
      return;
    }
    this._initialize();
  }
  get promise() {
    return this._readyCapability.promise;
  }
  get port() {
    return this._port;
  }
  get messageHandler() {
    return this._messageHandler;
  }
  _initializeFromPort(port) {
    this._port = port;
    this._messageHandler = new _message_handler.MessageHandler("main", "worker", port);
    this._messageHandler.on("ready", function () {});
    this._readyCapability.resolve();
    this._messageHandler.send("configure", {
      verbosity: this.verbosity
    });
  }
  _initialize() {
    if (!PDFWorkerUtil.isWorkerDisabled && !PDFWorker._mainThreadWorkerMessageHandler) {
      let {
        workerSrc
      } = PDFWorker;
      try {
        if (!PDFWorkerUtil.isSameOrigin(window.location.href, workerSrc)) {
          workerSrc = PDFWorkerUtil.createCDNWrapper(new URL(workerSrc, window.location).href);
        }
        const worker = new Worker(workerSrc);
        const messageHandler = new _message_handler.MessageHandler("main", "worker", worker);
        const terminateEarly = () => {
          worker.removeEventListener("error", onWorkerError);
          messageHandler.destroy();
          worker.terminate();
          if (this.destroyed) {
            this._readyCapability.reject(new Error("Worker was destroyed"));
          } else {
            this._setupFakeWorker();
          }
        };
        const onWorkerError = () => {
          if (!this._webWorker) {
            terminateEarly();
          }
        };
        worker.addEventListener("error", onWorkerError);
        messageHandler.on("test", data => {
          worker.removeEventListener("error", onWorkerError);
          if (this.destroyed) {
            terminateEarly();
            return;
          }
          if (data) {
            this._messageHandler = messageHandler;
            this._port = worker;
            this._webWorker = worker;
            this._readyCapability.resolve();
            messageHandler.send("configure", {
              verbosity: this.verbosity
            });
          } else {
            this._setupFakeWorker();
            messageHandler.destroy();
            worker.terminate();
          }
        });
        messageHandler.on("ready", data => {
          worker.removeEventListener("error", onWorkerError);
          if (this.destroyed) {
            terminateEarly();
            return;
          }
          try {
            sendTest();
          } catch {
            this._setupFakeWorker();
          }
        });
        const sendTest = () => {
          const testObj = new Uint8Array();
          messageHandler.send("test", testObj, [testObj.buffer]);
        };
        sendTest();
        return;
      } catch {
        (0, _util.info)("The worker has been disabled.");
      }
    }
    this._setupFakeWorker();
  }
  _setupFakeWorker() {
    if (!PDFWorkerUtil.isWorkerDisabled) {
      (0, _util.warn)("Setting up fake worker.");
      PDFWorkerUtil.isWorkerDisabled = true;
    }
    PDFWorker._setupFakeWorkerGlobal.then(WorkerMessageHandler => {
      if (this.destroyed) {
        this._readyCapability.reject(new Error("Worker was destroyed"));
        return;
      }
      const port = new LoopbackPort();
      this._port = port;
      const id = `fake${PDFWorkerUtil.fakeWorkerId++}`;
      const workerHandler = new _message_handler.MessageHandler(id + "_worker", id, port);
      WorkerMessageHandler.setup(workerHandler, port);
      const messageHandler = new _message_handler.MessageHandler(id, id + "_worker", port);
      this._messageHandler = messageHandler;
      this._readyCapability.resolve();
      messageHandler.send("configure", {
        verbosity: this.verbosity
      });
    }).catch(reason => {
      this._readyCapability.reject(new Error(`Setting up fake worker failed: "${reason.message}".`));
    });
  }
  destroy() {
    this.destroyed = true;
    if (this._webWorker) {
      this._webWorker.terminate();
      this._webWorker = null;
    }
    PDFWorker.#workerPorts?.delete(this._port);
    this._port = null;
    if (this._messageHandler) {
      this._messageHandler.destroy();
      this._messageHandler = null;
    }
  }
  static fromPort(params) {
    if (!params?.port) {
      throw new Error("PDFWorker.fromPort - invalid method signature.");
    }
    const cachedPort = this.#workerPorts?.get(params.port);
    if (cachedPort) {
      if (cachedPort._pendingDestroy) {
        throw new Error("PDFWorker.fromPort - the worker is being destroyed.\n" + "Please remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
      }
      return cachedPort;
    }
    return new PDFWorker(params);
  }
  static get workerSrc() {
    if (_worker_options.GlobalWorkerOptions.workerSrc) {
      return _worker_options.GlobalWorkerOptions.workerSrc;
    }
    if (PDFWorkerUtil.fallbackWorkerSrc !== null) {
      if (!_util.isNodeJS) {
        (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.');
      }
      return PDFWorkerUtil.fallbackWorkerSrc;
    }
    throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
  }
  static get _mainThreadWorkerMessageHandler() {
    try {
      return globalThis.pdfjsWorker?.WorkerMessageHandler || null;
    } catch {
      return null;
    }
  }
  static get _setupFakeWorkerGlobal() {
    const loader = async () => {
      const mainWorkerMessageHandler = this._mainThreadWorkerMessageHandler;
      if (mainWorkerMessageHandler) {
        return mainWorkerMessageHandler;
      }
      if (_util.isNodeJS && typeof require === "function") {
        const worker = eval("require")(this.workerSrc);
        return worker.WorkerMessageHandler;
      }
      await (0, _display_utils.loadScript)(this.workerSrc);
      return window.pdfjsWorker.WorkerMessageHandler;
    };
    return (0, _util.shadow)(this, "_setupFakeWorkerGlobal", loader());
  }
}
exports.PDFWorker = PDFWorker;
class WorkerTransport {
  #methodPromises = new Map();
  #pageCache = new Map();
  #pagePromises = new Map();
  #passwordCapability = null;
  constructor(messageHandler, loadingTask, networkStream, params, factory) {
    this.messageHandler = messageHandler;
    this.loadingTask = loadingTask;
    this.commonObjs = new PDFObjects();
    this.fontLoader = new _font_loader.FontLoader({
      ownerDocument: params.ownerDocument,
      styleElement: params.styleElement
    });
    this._params = params;
    this.canvasFactory = factory.canvasFactory;
    this.filterFactory = factory.filterFactory;
    this.cMapReaderFactory = factory.cMapReaderFactory;
    this.standardFontDataFactory = factory.standardFontDataFactory;
    this.destroyed = false;
    this.destroyCapability = null;
    this._networkStream = networkStream;
    this._fullReader = null;
    this._lastProgress = null;
    this.downloadInfoCapability = new _util.PromiseCapability();
    this.setupMessageHandler();
  }
  #cacheSimpleMethod(name) {
    let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const cachedPromise = this.#methodPromises.get(name);
    if (cachedPromise) {
      return cachedPromise;
    }
    const promise = this.messageHandler.sendWithPromise(name, data);
    this.#methodPromises.set(name, promise);
    return promise;
  }
  get annotationStorage() {
    return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
  }
  getRenderingIntent(intent) {
    let annotationMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _util.AnnotationMode.ENABLE;
    let printAnnotationStorage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    let isOpList = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    let renderingIntent = _util.RenderingIntentFlag.DISPLAY;
    let annotationStorageSerializable = _annotation_storage.SerializableEmpty;
    switch (intent) {
      case "any":
        renderingIntent = _util.RenderingIntentFlag.ANY;
        break;
      case "display":
        break;
      case "print":
        renderingIntent = _util.RenderingIntentFlag.PRINT;
        break;
      default:
        (0, _util.warn)(`getRenderingIntent - invalid intent: ${intent}`);
    }
    switch (annotationMode) {
      case _util.AnnotationMode.DISABLE:
        renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_DISABLE;
        break;
      case _util.AnnotationMode.ENABLE:
        break;
      case _util.AnnotationMode.ENABLE_FORMS:
        renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_FORMS;
        break;
      case _util.AnnotationMode.ENABLE_STORAGE:
        renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_STORAGE;
        const annotationStorage = renderingIntent & _util.RenderingIntentFlag.PRINT && printAnnotationStorage instanceof _annotation_storage.PrintAnnotationStorage ? printAnnotationStorage : this.annotationStorage;
        annotationStorageSerializable = annotationStorage.serializable;
        break;
      default:
        (0, _util.warn)(`getRenderingIntent - invalid annotationMode: ${annotationMode}`);
    }
    if (isOpList) {
      renderingIntent += _util.RenderingIntentFlag.OPLIST;
    }
    return {
      renderingIntent,
      cacheKey: `${renderingIntent}_${annotationStorageSerializable.hash}`,
      annotationStorageSerializable
    };
  }
  destroy() {
    if (this.destroyCapability) {
      return this.destroyCapability.promise;
    }
    this.destroyed = true;
    this.destroyCapability = new _util.PromiseCapability();
    this.#passwordCapability?.reject(new Error("Worker was destroyed during onPassword callback"));
    const waitOn = [];
    for (const page of this.#pageCache.values()) {
      waitOn.push(page._destroy());
    }
    this.#pageCache.clear();
    this.#pagePromises.clear();
    if (this.hasOwnProperty("annotationStorage")) {
      this.annotationStorage.resetModified();
    }
    const terminated = this.messageHandler.sendWithPromise("Terminate", null);
    waitOn.push(terminated);
    Promise.all(waitOn).then(() => {
      this.commonObjs.clear();
      this.fontLoader.clear();
      this.#methodPromises.clear();
      this.filterFactory.destroy();
      this._networkStream?.cancelAllRequests(new _util.AbortException("Worker was terminated."));
      if (this.messageHandler) {
        this.messageHandler.destroy();
        this.messageHandler = null;
      }
      this.destroyCapability.resolve();
    }, this.destroyCapability.reject);
    return this.destroyCapability.promise;
  }
  setupMessageHandler() {
    const {
      messageHandler,
      loadingTask
    } = this;
    messageHandler.on("GetReader", (data, sink) => {
      (0, _util.assert)(this._networkStream, "GetReader - no `IPDFStream` instance available.");
      this._fullReader = this._networkStream.getFullReader();
      this._fullReader.onProgress = evt => {
        this._lastProgress = {
          loaded: evt.loaded,
          total: evt.total
        };
      };
      sink.onPull = () => {
        this._fullReader.read().then(function (_ref8) {
          let {
            value,
            done
          } = _ref8;
          if (done) {
            sink.close();
            return;
          }
          (0, _util.assert)(value instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer.");
          sink.enqueue(new Uint8Array(value), 1, [value]);
        }).catch(reason => {
          sink.error(reason);
        });
      };
      sink.onCancel = reason => {
        this._fullReader.cancel(reason);
        sink.ready.catch(readyReason => {
          if (this.destroyed) {
            return;
          }
          throw readyReason;
        });
      };
    });
    messageHandler.on("ReaderHeadersReady", data => {
      const headersCapability = new _util.PromiseCapability();
      const fullReader = this._fullReader;
      fullReader.headersReady.then(() => {
        if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
          if (this._lastProgress) {
            loadingTask.onProgress?.(this._lastProgress);
          }
          fullReader.onProgress = evt => {
            loadingTask.onProgress?.({
              loaded: evt.loaded,
              total: evt.total
            });
          };
        }
        headersCapability.resolve({
          isStreamingSupported: fullReader.isStreamingSupported,
          isRangeSupported: fullReader.isRangeSupported,
          contentLength: fullReader.contentLength
        });
      }, headersCapability.reject);
      return headersCapability.promise;
    });
    messageHandler.on("GetRangeReader", (data, sink) => {
      (0, _util.assert)(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
      const rangeReader = this._networkStream.getRangeReader(data.begin, data.end);
      if (!rangeReader) {
        sink.close();
        return;
      }
      sink.onPull = () => {
        rangeReader.read().then(function (_ref9) {
          let {
            value,
            done
          } = _ref9;
          if (done) {
            sink.close();
            return;
          }
          (0, _util.assert)(value instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer.");
          sink.enqueue(new Uint8Array(value), 1, [value]);
        }).catch(reason => {
          sink.error(reason);
        });
      };
      sink.onCancel = reason => {
        rangeReader.cancel(reason);
        sink.ready.catch(readyReason => {
          if (this.destroyed) {
            return;
          }
          throw readyReason;
        });
      };
    });
    messageHandler.on("GetDoc", _ref10 => {
      let {
        pdfInfo
      } = _ref10;
      this._numPages = pdfInfo.numPages;
      this._htmlForXfa = pdfInfo.htmlForXfa;
      delete pdfInfo.htmlForXfa;
      loadingTask._capability.resolve(new PDFDocumentProxy(pdfInfo, this));
    });
    messageHandler.on("DocException", function (ex) {
      let reason;
      switch (ex.name) {
        case "PasswordException":
          reason = new _util.PasswordException(ex.message, ex.code);
          break;
        case "InvalidPDFException":
          reason = new _util.InvalidPDFException(ex.message);
          break;
        case "MissingPDFException":
          reason = new _util.MissingPDFException(ex.message);
          break;
        case "UnexpectedResponseException":
          reason = new _util.UnexpectedResponseException(ex.message, ex.status);
          break;
        case "UnknownErrorException":
          reason = new _util.UnknownErrorException(ex.message, ex.details);
          break;
        default:
          (0, _util.unreachable)("DocException - expected a valid Error.");
      }
      loadingTask._capability.reject(reason);
    });
    messageHandler.on("PasswordRequest", exception => {
      this.#passwordCapability = new _util.PromiseCapability();
      if (loadingTask.onPassword) {
        const updatePassword = password => {
          if (password instanceof Error) {
            this.#passwordCapability.reject(password);
          } else {
            this.#passwordCapability.resolve({
              password
            });
          }
        };
        try {
          loadingTask.onPassword(updatePassword, exception.code);
        } catch (ex) {
          this.#passwordCapability.reject(ex);
        }
      } else {
        this.#passwordCapability.reject(new _util.PasswordException(exception.message, exception.code));
      }
      return this.#passwordCapability.promise;
    });
    messageHandler.on("DataLoaded", data => {
      loadingTask.onProgress?.({
        loaded: data.length,
        total: data.length
      });
      this.downloadInfoCapability.resolve(data);
    });
    messageHandler.on("StartRenderPage", data => {
      if (this.destroyed) {
        return;
      }
      const page = this.#pageCache.get(data.pageIndex);
      page._startRenderPage(data.transparency, data.cacheKey);
    });
    messageHandler.on("commonobj", _ref11 => {
      let [id, type, exportedData] = _ref11;
      if (this.destroyed) {
        return;
      }
      if (this.commonObjs.has(id)) {
        return;
      }
      switch (type) {
        case "Font":
          const params = this._params;
          if ("error" in exportedData) {
            const exportedError = exportedData.error;
            (0, _util.warn)(`Error during font loading: ${exportedError}`);
            this.commonObjs.resolve(id, exportedError);
            break;
          }
          const inspectFont = params.pdfBug && globalThis.FontInspector?.enabled ? (font, url) => globalThis.FontInspector.fontAdded(font, url) : null;
          const font = new _font_loader.FontFaceObject(exportedData, {
            isEvalSupported: params.isEvalSupported,
            disableFontFace: params.disableFontFace,
            ignoreErrors: params.ignoreErrors,
            inspectFont
          });
          this.fontLoader.bind(font).catch(reason => {
            return messageHandler.sendWithPromise("FontFallback", {
              id
            });
          }).finally(() => {
            if (!params.fontExtraProperties && font.data) {
              font.data = null;
            }
            this.commonObjs.resolve(id, font);
          });
          break;
        case "FontPath":
        case "Image":
        case "Pattern":
          this.commonObjs.resolve(id, exportedData);
          break;
        default:
          throw new Error(`Got unknown common object type ${type}`);
      }
    });
    messageHandler.on("obj", _ref12 => {
      let [id, pageIndex, type, imageData] = _ref12;
      if (this.destroyed) {
        return;
      }
      const pageProxy = this.#pageCache.get(pageIndex);
      if (pageProxy.objs.has(id)) {
        return;
      }
      switch (type) {
        case "Image":
          pageProxy.objs.resolve(id, imageData);
          if (imageData) {
            let length;
            if (imageData.bitmap) {
              const {
                width,
                height
              } = imageData;
              length = width * height * 4;
            } else {
              length = imageData.data?.length || 0;
            }
            if (length > _util.MAX_IMAGE_SIZE_TO_CACHE) {
              pageProxy._maybeCleanupAfterRender = true;
            }
          }
          break;
        case "Pattern":
          pageProxy.objs.resolve(id, imageData);
          break;
        default:
          throw new Error(`Got unknown object type ${type}`);
      }
    });
    messageHandler.on("DocProgress", data => {
      if (this.destroyed) {
        return;
      }
      loadingTask.onProgress?.({
        loaded: data.loaded,
        total: data.total
      });
    });
    messageHandler.on("FetchBuiltInCMap", data => {
      if (this.destroyed) {
        return Promise.reject(new Error("Worker was destroyed."));
      }
      if (!this.cMapReaderFactory) {
        return Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."));
      }
      return this.cMapReaderFactory.fetch(data);
    });
    messageHandler.on("FetchStandardFontData", data => {
      if (this.destroyed) {
        return Promise.reject(new Error("Worker was destroyed."));
      }
      if (!this.standardFontDataFactory) {
        return Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter."));
      }
      return this.standardFontDataFactory.fetch(data);
    });
  }
  getData() {
    return this.messageHandler.sendWithPromise("GetData", null);
  }
  saveDocument() {
    if (this.annotationStorage.size <= 0) {
      (0, _util.warn)("saveDocument called while `annotationStorage` is empty, " + "please use the getData-method instead.");
    }
    const {
      map,
      transfers
    } = this.annotationStorage.serializable;
    return this.messageHandler.sendWithPromise("SaveDocument", {
      isPureXfa: !!this._htmlForXfa,
      numPages: this._numPages,
      annotationStorage: map,
      filename: this._fullReader?.filename ?? null
    }, transfers).finally(() => {
      this.annotationStorage.resetModified();
    });
  }
  getPage(pageNumber) {
    if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this._numPages) {
      return Promise.reject(new Error("Invalid page request."));
    }
    const pageIndex = pageNumber - 1,
      cachedPromise = this.#pagePromises.get(pageIndex);
    if (cachedPromise) {
      return cachedPromise;
    }
    const promise = this.messageHandler.sendWithPromise("GetPage", {
      pageIndex
    }).then(pageInfo => {
      if (this.destroyed) {
        throw new Error("Transport destroyed");
      }
      const page = new PDFPageProxy(pageIndex, pageInfo, this, this._params.pdfBug);
      this.#pageCache.set(pageIndex, page);
      return page;
    });
    this.#pagePromises.set(pageIndex, promise);
    return promise;
  }
  getPageIndex(ref) {
    if (typeof ref !== "object" || ref === null || !Number.isInteger(ref.num) || ref.num < 0 || !Number.isInteger(ref.gen) || ref.gen < 0) {
      return Promise.reject(new Error("Invalid pageIndex request."));
    }
    return this.messageHandler.sendWithPromise("GetPageIndex", {
      num: ref.num,
      gen: ref.gen
    });
  }
  getAnnotations(pageIndex, intent) {
    return this.messageHandler.sendWithPromise("GetAnnotations", {
      pageIndex,
      intent
    });
  }
  getFieldObjects() {
    return this.#cacheSimpleMethod("GetFieldObjects");
  }
  hasJSActions() {
    return this.#cacheSimpleMethod("HasJSActions");
  }
  getCalculationOrderIds() {
    return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
  }
  getDestinations() {
    return this.messageHandler.sendWithPromise("GetDestinations", null);
  }
  getDestination(id) {
    if (typeof id !== "string") {
      return Promise.reject(new Error("Invalid destination request."));
    }
    return this.messageHandler.sendWithPromise("GetDestination", {
      id
    });
  }
  getPageLabels() {
    return this.messageHandler.sendWithPromise("GetPageLabels", null);
  }
  getPageLayout() {
    return this.messageHandler.sendWithPromise("GetPageLayout", null);
  }
  getPageMode() {
    return this.messageHandler.sendWithPromise("GetPageMode", null);
  }
  getViewerPreferences() {
    return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
  }
  getOpenAction() {
    return this.messageHandler.sendWithPromise("GetOpenAction", null);
  }
  getAttachments() {
    return this.messageHandler.sendWithPromise("GetAttachments", null);
  }
  getDocJSActions() {
    return this.#cacheSimpleMethod("GetDocJSActions");
  }
  getPageJSActions(pageIndex) {
    return this.messageHandler.sendWithPromise("GetPageJSActions", {
      pageIndex
    });
  }
  getStructTree(pageIndex) {
    return this.messageHandler.sendWithPromise("GetStructTree", {
      pageIndex
    });
  }
  getOutline() {
    return this.messageHandler.sendWithPromise("GetOutline", null);
  }
  getOptionalContentConfig() {
    return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then(results => {
      return new _optional_content_config.OptionalContentConfig(results);
    });
  }
  getPermissions() {
    return this.messageHandler.sendWithPromise("GetPermissions", null);
  }
  getMetadata() {
    const name = "GetMetadata",
      cachedPromise = this.#methodPromises.get(name);
    if (cachedPromise) {
      return cachedPromise;
    }
    const promise = this.messageHandler.sendWithPromise(name, null).then(results => {
      return {
        info: results[0],
        metadata: results[1] ? new _metadata.Metadata(results[1]) : null,
        contentDispositionFilename: this._fullReader?.filename ?? null,
        contentLength: this._fullReader?.contentLength ?? null
      };
    });
    this.#methodPromises.set(name, promise);
    return promise;
  }
  getMarkInfo() {
    return this.messageHandler.sendWithPromise("GetMarkInfo", null);
  }
  async startCleanup() {
    let keepLoadedFonts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (this.destroyed) {
      return;
    }
    await this.messageHandler.sendWithPromise("Cleanup", null);
    for (const page of this.#pageCache.values()) {
      const cleanupSuccessful = page.cleanup();
      if (!cleanupSuccessful) {
        throw new Error(`startCleanup: Page ${page.pageNumber} is currently rendering.`);
      }
    }
    this.commonObjs.clear();
    if (!keepLoadedFonts) {
      this.fontLoader.clear();
    }
    this.#methodPromises.clear();
    this.filterFactory.destroy(true);
  }
  get loadingParams() {
    const {
      disableAutoFetch,
      enableXfa
    } = this._params;
    return (0, _util.shadow)(this, "loadingParams", {
      disableAutoFetch,
      enableXfa
    });
  }
}
class PDFObjects {
  #objs = Object.create(null);
  #ensureObj(objId) {
    return this.#objs[objId] ||= {
      capability: new _util.PromiseCapability(),
      data: null
    };
  }
  get(objId) {
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (callback) {
      const obj = this.#ensureObj(objId);
      obj.capability.promise.then(() => callback(obj.data));
      return null;
    }
    const obj = this.#objs[objId];
    if (!obj?.capability.settled) {
      throw new Error(`Requesting object that isn't resolved yet ${objId}.`);
    }
    return obj.data;
  }
  has(objId) {
    const obj = this.#objs[objId];
    return obj?.capability.settled || false;
  }
  resolve(objId) {
    let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const obj = this.#ensureObj(objId);
    obj.data = data;
    obj.capability.resolve();
  }
  clear() {
    for (const objId in this.#objs) {
      const {
        data
      } = this.#objs[objId];
      data?.bitmap?.close();
    }
    this.#objs = Object.create(null);
  }
}
class RenderTask {
  #internalRenderTask = null;
  constructor(internalRenderTask) {
    this.#internalRenderTask = internalRenderTask;
    this.onContinue = null;
  }
  get promise() {
    return this.#internalRenderTask.capability.promise;
  }
  cancel() {
    let extraDelay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    this.#internalRenderTask.cancel(null, extraDelay);
  }
  get separateAnnots() {
    const {
      separateAnnots
    } = this.#internalRenderTask.operatorList;
    if (!separateAnnots) {
      return false;
    }
    const {
      annotationCanvasMap
    } = this.#internalRenderTask;
    return separateAnnots.form || separateAnnots.canvas && annotationCanvasMap?.size > 0;
  }
}
exports.RenderTask = RenderTask;
class InternalRenderTask {
  static #canvasInUse = new WeakSet();
  constructor(_ref13) {
    let {
      callback,
      params,
      objs,
      commonObjs,
      annotationCanvasMap,
      operatorList,
      pageIndex,
      canvasFactory,
      filterFactory,
      useRequestAnimationFrame = false,
      pdfBug = false,
      pageColors = null
    } = _ref13;
    this.callback = callback;
    this.params = params;
    this.objs = objs;
    this.commonObjs = commonObjs;
    this.annotationCanvasMap = annotationCanvasMap;
    this.operatorListIdx = null;
    this.operatorList = operatorList;
    this._pageIndex = pageIndex;
    this.canvasFactory = canvasFactory;
    this.filterFactory = filterFactory;
    this._pdfBug = pdfBug;
    this.pageColors = pageColors;
    this.running = false;
    this.graphicsReadyCallback = null;
    this.graphicsReady = false;
    this._useRequestAnimationFrame = useRequestAnimationFrame === true && typeof window !== "undefined";
    this.cancelled = false;
    this.capability = new _util.PromiseCapability();
    this.task = new RenderTask(this);
    this._cancelBound = this.cancel.bind(this);
    this._continueBound = this._continue.bind(this);
    this._scheduleNextBound = this._scheduleNext.bind(this);
    this._nextBound = this._next.bind(this);
    this._canvas = params.canvasContext.canvas;
  }
  get completed() {
    return this.capability.promise.catch(function () {});
  }
  initializeGraphics(_ref14) {
    let {
      transparency = false,
      optionalContentConfig
    } = _ref14;
    if (this.cancelled) {
      return;
    }
    if (this._canvas) {
      if (InternalRenderTask.#canvasInUse.has(this._canvas)) {
        throw new Error("Cannot use the same canvas during multiple render() operations. " + "Use different canvas or ensure previous operations were " + "cancelled or completed.");
      }
      InternalRenderTask.#canvasInUse.add(this._canvas);
    }
    if (this._pdfBug && globalThis.StepperManager?.enabled) {
      this.stepper = globalThis.StepperManager.create(this._pageIndex);
      this.stepper.init(this.operatorList);
      this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
    }
    const {
      canvasContext,
      viewport,
      transform,
      background
    } = this.params;
    this.gfx = new _canvas.CanvasGraphics(canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
      optionalContentConfig
    }, this.annotationCanvasMap, this.pageColors);
    this.gfx.beginDrawing({
      transform,
      viewport,
      transparency,
      background
    });
    this.operatorListIdx = 0;
    this.graphicsReady = true;
    this.graphicsReadyCallback?.();
  }
  cancel() {
    let error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let extraDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    this.running = false;
    this.cancelled = true;
    this.gfx?.endDrawing();
    InternalRenderTask.#canvasInUse.delete(this._canvas);
    this.callback(error || new _display_utils.RenderingCancelledException(`Rendering cancelled, page ${this._pageIndex + 1}`, extraDelay));
  }
  operatorListChanged() {
    if (!this.graphicsReady) {
      this.graphicsReadyCallback ||= this._continueBound;
      return;
    }
    this.stepper?.updateOperatorList(this.operatorList);
    if (this.running) {
      return;
    }
    this._continue();
  }
  _continue() {
    this.running = true;
    if (this.cancelled) {
      return;
    }
    if (this.task.onContinue) {
      this.task.onContinue(this._scheduleNextBound);
    } else {
      this._scheduleNext();
    }
  }
  _scheduleNext() {
    if (this._useRequestAnimationFrame) {
      window.requestAnimationFrame(() => {
        this._nextBound().catch(this._cancelBound);
      });
    } else {
      Promise.resolve().then(this._nextBound).catch(this._cancelBound);
    }
  }
  async _next() {
    if (this.cancelled) {
      return;
    }
    this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
    if (this.operatorListIdx === this.operatorList.argsArray.length) {
      this.running = false;
      if (this.operatorList.lastChunk) {
        this.gfx.endDrawing();
        InternalRenderTask.#canvasInUse.delete(this._canvas);
        this.callback();
      }
    }
  }
}
const version = '3.11.174';
exports.version = version;
const build = 'ce8716743';
exports.build = build;

/***/ }),
/* 125 */
/***/ ((__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__) => {


var $ = __w_pdfjs_require__(3);
var difference = __w_pdfjs_require__(126);
var setMethodAcceptSetLike = __w_pdfjs_require__(135);
$({
 target: 'Set',
 proto: true,
 real: true,
 forced: !setMethodAcceptSetLike('difference')
}, { difference: difference });

/***/ }),
/* 126 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var aSet = __w_pdfjs_require__(127);
var SetHelpers = __w_pdfjs_require__(128);
var clone = __w_pdfjs_require__(129);
var size = __w_pdfjs_require__(132);
var getSetRecord = __w_pdfjs_require__(133);
var iterateSet = __w_pdfjs_require__(130);
var iterateSimple = __w_pdfjs_require__(131);
var has = SetHelpers.has;
var remove = SetHelpers.remove;
module.exports = function difference(other) {
 var O = aSet(this);
 var otherRec = getSetRecord(other);
 var result = clone(O);
 if (size(O) <= otherRec.size)
  iterateSet(O, function (e) {
   if (otherRec.includes(e))
    remove(result, e);
  });
 else
  iterateSimple(otherRec.getIterator(), function (e) {
   if (has(O, e))
    remove(result, e);
  });
 return result;
};

/***/ }),
/* 127 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var has = (__w_pdfjs_require__(128).has);
module.exports = function (it) {
 has(it);
 return it;
};

/***/ }),
/* 128 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var uncurryThis = __w_pdfjs_require__(14);
var SetPrototype = Set.prototype;
module.exports = {
 Set: Set,
 add: uncurryThis(SetPrototype.add),
 has: uncurryThis(SetPrototype.has),
 remove: uncurryThis(SetPrototype['delete']),
 proto: SetPrototype
};

/***/ }),
/* 129 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var SetHelpers = __w_pdfjs_require__(128);
var iterate = __w_pdfjs_require__(130);
var Set = SetHelpers.Set;
var add = SetHelpers.add;
module.exports = function (set) {
 var result = new Set();
 iterate(set, function (it) {
  add(result, it);
 });
 return result;
};

/***/ }),
/* 130 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var uncurryThis = __w_pdfjs_require__(14);
var iterateSimple = __w_pdfjs_require__(131);
var SetHelpers = __w_pdfjs_require__(128);
var Set = SetHelpers.Set;
var SetPrototype = SetHelpers.proto;
var forEach = uncurryThis(SetPrototype.forEach);
var keys = uncurryThis(SetPrototype.keys);
var next = keys(new Set()).next;
module.exports = function (set, fn, interruptible) {
 return interruptible ? iterateSimple({
  iterator: keys(set),
  next: next
 }, fn) : forEach(set, fn);
};

/***/ }),
/* 131 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var call = __w_pdfjs_require__(8);
module.exports = function (record, fn, ITERATOR_INSTEAD_OF_RECORD) {
 var iterator = ITERATOR_INSTEAD_OF_RECORD ? record : record.iterator;
 var next = record.next;
 var step, result;
 while (!(step = call(next, iterator)).done) {
  result = fn(step.value);
  if (result !== undefined)
   return result;
 }
};

/***/ }),
/* 132 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var uncurryThisAccessor = __w_pdfjs_require__(72);
var SetHelpers = __w_pdfjs_require__(128);
module.exports = uncurryThisAccessor(SetHelpers.proto, 'size', 'get') || function (set) {
 return set.size;
};

/***/ }),
/* 133 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var aCallable = __w_pdfjs_require__(31);
var anObject = __w_pdfjs_require__(47);
var call = __w_pdfjs_require__(8);
var toIntegerOrInfinity = __w_pdfjs_require__(62);
var getIteratorDirect = __w_pdfjs_require__(134);
var INVALID_SIZE = 'Invalid size';
var $RangeError = RangeError;
var $TypeError = TypeError;
var max = Math.max;
var SetRecord = function (set, size, has, keys) {
 this.set = set;
 this.size = size;
 this.has = has;
 this.keys = keys;
};
SetRecord.prototype = {
 getIterator: function () {
  return getIteratorDirect(anObject(call(this.keys, this.set)));
 },
 includes: function (it) {
  return call(this.has, this.set, it);
 }
};
module.exports = function (obj) {
 anObject(obj);
 var numSize = +obj.size;
 if (numSize !== numSize)
  throw $TypeError(INVALID_SIZE);
 var intSize = toIntegerOrInfinity(numSize);
 if (intSize < 0)
  throw $RangeError(INVALID_SIZE);
 return new SetRecord(obj, max(intSize, 0), aCallable(obj.has), aCallable(obj.keys));
};

/***/ }),
/* 134 */
/***/ ((module) => {


module.exports = function (obj) {
 return {
  iterator: obj,
  next: obj.next,
  done: false
 };
};

/***/ }),
/* 135 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var getBuiltIn = __w_pdfjs_require__(24);
var createSetLike = function (size) {
 return {
  size: size,
  has: function () {
   return false;
  },
  keys: function () {
   return {
    next: function () {
     return { done: true };
    }
   };
  }
 };
};
module.exports = function (name) {
 var Set = getBuiltIn('Set');
 try {
  new Set()[name](createSetLike(0));
  try {
   new Set()[name](createSetLike(-1));
   return false;
  } catch (error2) {
   return true;
  }
 } catch (error) {
  return false;
 }
};

/***/ }),
/* 136 */
/***/ ((__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__) => {


var $ = __w_pdfjs_require__(3);
var fails = __w_pdfjs_require__(7);
var intersection = __w_pdfjs_require__(137);
var setMethodAcceptSetLike = __w_pdfjs_require__(135);
var INCORRECT = !setMethodAcceptSetLike('intersection') || fails(function () {
 return Array.from(new Set([
  1,
  2,
  3
 ]).intersection(new Set([
  3,
  2
 ]))) !== '3,2';
});
$({
 target: 'Set',
 proto: true,
 real: true,
 forced: INCORRECT
}, { intersection: intersection });

/***/ }),
/* 137 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var aSet = __w_pdfjs_require__(127);
var SetHelpers = __w_pdfjs_require__(128);
var size = __w_pdfjs_require__(132);
var getSetRecord = __w_pdfjs_require__(133);
var iterateSet = __w_pdfjs_require__(130);
var iterateSimple = __w_pdfjs_require__(131);
var Set = SetHelpers.Set;
var add = SetHelpers.add;
var has = SetHelpers.has;
module.exports = function intersection(other) {
 var O = aSet(this);
 var otherRec = getSetRecord(other);
 var result = new Set();
 if (size(O) > otherRec.size) {
  iterateSimple(otherRec.getIterator(), function (e) {
   if (has(O, e))
    add(result, e);
  });
 } else {
  iterateSet(O, function (e) {
   if (otherRec.includes(e))
    add(result, e);
  });
 }
 return result;
};

/***/ }),
/* 138 */
/***/ ((__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__) => {


var $ = __w_pdfjs_require__(3);
var isDisjointFrom = __w_pdfjs_require__(139);
var setMethodAcceptSetLike = __w_pdfjs_require__(135);
$({
 target: 'Set',
 proto: true,
 real: true,
 forced: !setMethodAcceptSetLike('isDisjointFrom')
}, { isDisjointFrom: isDisjointFrom });

/***/ }),
/* 139 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var aSet = __w_pdfjs_require__(127);
var has = (__w_pdfjs_require__(128).has);
var size = __w_pdfjs_require__(132);
var getSetRecord = __w_pdfjs_require__(133);
var iterateSet = __w_pdfjs_require__(130);
var iterateSimple = __w_pdfjs_require__(131);
var iteratorClose = __w_pdfjs_require__(140);
module.exports = function isDisjointFrom(other) {
 var O = aSet(this);
 var otherRec = getSetRecord(other);
 if (size(O) <= otherRec.size)
  return iterateSet(O, function (e) {
   if (otherRec.includes(e))
    return false;
  }, true) !== false;
 var iterator = otherRec.getIterator();
 return iterateSimple(iterator, function (e) {
  if (has(O, e))
   return iteratorClose(iterator, 'normal', false);
 }) !== false;
};

/***/ }),
/* 140 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var call = __w_pdfjs_require__(8);
var anObject = __w_pdfjs_require__(47);
var getMethod = __w_pdfjs_require__(30);
module.exports = function (iterator, kind, value) {
 var innerResult, innerError;
 anObject(iterator);
 try {
  innerResult = getMethod(iterator, 'return');
  if (!innerResult) {
   if (kind === 'throw')
    throw value;
   return value;
  }
  innerResult = call(innerResult, iterator);
 } catch (error) {
  innerError = true;
  innerResult = error;
 }
 if (kind === 'throw')
  throw value;
 if (innerError)
  throw innerResult;
 anObject(innerResult);
 return value;
};

/***/ }),
/* 141 */
/***/ ((__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__) => {


var $ = __w_pdfjs_require__(3);
var isSubsetOf = __w_pdfjs_require__(142);
var setMethodAcceptSetLike = __w_pdfjs_require__(135);
$({
 target: 'Set',
 proto: true,
 real: true,
 forced: !setMethodAcceptSetLike('isSubsetOf')
}, { isSubsetOf: isSubsetOf });

/***/ }),
/* 142 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var aSet = __w_pdfjs_require__(127);
var size = __w_pdfjs_require__(132);
var iterate = __w_pdfjs_require__(130);
var getSetRecord = __w_pdfjs_require__(133);
module.exports = function isSubsetOf(other) {
 var O = aSet(this);
 var otherRec = getSetRecord(other);
 if (size(O) > otherRec.size)
  return false;
 return iterate(O, function (e) {
  if (!otherRec.includes(e))
   return false;
 }, true) !== false;
};

/***/ }),
/* 143 */
/***/ ((__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__) => {


var $ = __w_pdfjs_require__(3);
var isSupersetOf = __w_pdfjs_require__(144);
var setMethodAcceptSetLike = __w_pdfjs_require__(135);
$({
 target: 'Set',
 proto: true,
 real: true,
 forced: !setMethodAcceptSetLike('isSupersetOf')
}, { isSupersetOf: isSupersetOf });

/***/ }),
/* 144 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var aSet = __w_pdfjs_require__(127);
var has = (__w_pdfjs_require__(128).has);
var size = __w_pdfjs_require__(132);
var getSetRecord = __w_pdfjs_require__(133);
var iterateSimple = __w_pdfjs_require__(131);
var iteratorClose = __w_pdfjs_require__(140);
module.exports = function isSupersetOf(other) {
 var O = aSet(this);
 var otherRec = getSetRecord(other);
 if (size(O) < otherRec.size)
  return false;
 var iterator = otherRec.getIterator();
 return iterateSimple(iterator, function (e) {
  if (!has(O, e))
   return iteratorClose(iterator, 'normal', false);
 }) !== false;
};

/***/ }),
/* 145 */
/***/ ((__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__) => {


var $ = __w_pdfjs_require__(3);
var symmetricDifference = __w_pdfjs_require__(146);
var setMethodAcceptSetLike = __w_pdfjs_require__(135);
$({
 target: 'Set',
 proto: true,
 real: true,
 forced: !setMethodAcceptSetLike('symmetricDifference')
}, { symmetricDifference: symmetricDifference });

/***/ }),
/* 146 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var aSet = __w_pdfjs_require__(127);
var SetHelpers = __w_pdfjs_require__(128);
var clone = __w_pdfjs_require__(129);
var getSetRecord = __w_pdfjs_require__(133);
var iterateSimple = __w_pdfjs_require__(131);
var add = SetHelpers.add;
var has = SetHelpers.has;
var remove = SetHelpers.remove;
module.exports = function symmetricDifference(other) {
 var O = aSet(this);
 var keysIter = getSetRecord(other).getIterator();
 var result = clone(O);
 iterateSimple(keysIter, function (e) {
  if (has(O, e))
   remove(result, e);
  else
   add(result, e);
 });
 return result;
};

/***/ }),
/* 147 */
/***/ ((__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__) => {


var $ = __w_pdfjs_require__(3);
var union = __w_pdfjs_require__(148);
var setMethodAcceptSetLike = __w_pdfjs_require__(135);
$({
 target: 'Set',
 proto: true,
 real: true,
 forced: !setMethodAcceptSetLike('union')
}, { union: union });

/***/ }),
/* 148 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var aSet = __w_pdfjs_require__(127);
var add = (__w_pdfjs_require__(128).add);
var clone = __w_pdfjs_require__(129);
var getSetRecord = __w_pdfjs_require__(133);
var iterateSimple = __w_pdfjs_require__(131);
module.exports = function union(other) {
 var O = aSet(this);
 var keysIter = getSetRecord(other).getIterator();
 var result = clone(O);
 iterateSimple(keysIter, function (it) {
  add(result, it);
 });
 return result;
};

/***/ }),
/* 149 */
/***/ ((__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__) => {


var $ = __w_pdfjs_require__(3);
var global = __w_pdfjs_require__(4);
var getBuiltIn = __w_pdfjs_require__(24);
var createPropertyDescriptor = __w_pdfjs_require__(11);
var defineProperty = (__w_pdfjs_require__(45).f);
var hasOwn = __w_pdfjs_require__(39);
var anInstance = __w_pdfjs_require__(150);
var inheritIfRequired = __w_pdfjs_require__(75);
var normalizeStringArgument = __w_pdfjs_require__(76);
var DOMExceptionConstants = __w_pdfjs_require__(151);
var clearErrorStack = __w_pdfjs_require__(82);
var DESCRIPTORS = __w_pdfjs_require__(6);
var IS_PURE = __w_pdfjs_require__(36);
var DOM_EXCEPTION = 'DOMException';
var Error = getBuiltIn('Error');
var NativeDOMException = getBuiltIn(DOM_EXCEPTION);
var $DOMException = function DOMException() {
 anInstance(this, DOMExceptionPrototype);
 var argumentsLength = arguments.length;
 var message = normalizeStringArgument(argumentsLength < 1 ? undefined : arguments[0]);
 var name = normalizeStringArgument(argumentsLength < 2 ? undefined : arguments[1], 'Error');
 var that = new NativeDOMException(message, name);
 var error = Error(message);
 error.name = DOM_EXCEPTION;
 defineProperty(that, 'stack', createPropertyDescriptor(1, clearErrorStack(error.stack, 1)));
 inheritIfRequired(that, this, $DOMException);
 return that;
};
var DOMExceptionPrototype = $DOMException.prototype = NativeDOMException.prototype;
var ERROR_HAS_STACK = 'stack' in Error(DOM_EXCEPTION);
var DOM_EXCEPTION_HAS_STACK = 'stack' in new NativeDOMException(1, 2);
var descriptor = NativeDOMException && DESCRIPTORS && Object.getOwnPropertyDescriptor(global, DOM_EXCEPTION);
var BUGGY_DESCRIPTOR = !!descriptor && !(descriptor.writable && descriptor.configurable);
var FORCED_CONSTRUCTOR = ERROR_HAS_STACK && !BUGGY_DESCRIPTOR && !DOM_EXCEPTION_HAS_STACK;
$({
 global: true,
 constructor: true,
 forced: IS_PURE || FORCED_CONSTRUCTOR
}, { DOMException: FORCED_CONSTRUCTOR ? $DOMException : NativeDOMException });
var PolyfilledDOMException = getBuiltIn(DOM_EXCEPTION);
var PolyfilledDOMExceptionPrototype = PolyfilledDOMException.prototype;
if (PolyfilledDOMExceptionPrototype.constructor !== PolyfilledDOMException) {
 if (!IS_PURE) {
  defineProperty(PolyfilledDOMExceptionPrototype, 'constructor', createPropertyDescriptor(1, PolyfilledDOMException));
 }
 for (var key in DOMExceptionConstants)
  if (hasOwn(DOMExceptionConstants, key)) {
   var constant = DOMExceptionConstants[key];
   var constantName = constant.s;
   if (!hasOwn(PolyfilledDOMException, constantName)) {
    defineProperty(PolyfilledDOMException, constantName, createPropertyDescriptor(6, constant.c));
   }
  }
}

/***/ }),
/* 150 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var isPrototypeOf = __w_pdfjs_require__(25);
var $TypeError = TypeError;
module.exports = function (it, Prototype) {
 if (isPrototypeOf(Prototype, it))
  return it;
 throw $TypeError('Incorrect invocation');
};

/***/ }),
/* 151 */
/***/ ((module) => {


module.exports = {
 IndexSizeError: {
  s: 'INDEX_SIZE_ERR',
  c: 1,
  m: 1
 },
 DOMStringSizeError: {
  s: 'DOMSTRING_SIZE_ERR',
  c: 2,
  m: 0
 },
 HierarchyRequestError: {
  s: 'HIERARCHY_REQUEST_ERR',
  c: 3,
  m: 1
 },
 WrongDocumentError: {
  s: 'WRONG_DOCUMENT_ERR',
  c: 4,
  m: 1
 },
 InvalidCharacterError: {
  s: 'INVALID_CHARACTER_ERR',
  c: 5,
  m: 1
 },
 NoDataAllowedError: {
  s: 'NO_DATA_ALLOWED_ERR',
  c: 6,
  m: 0
 },
 NoModificationAllowedError: {
  s: 'NO_MODIFICATION_ALLOWED_ERR',
  c: 7,
  m: 1
 },
 NotFoundError: {
  s: 'NOT_FOUND_ERR',
  c: 8,
  m: 1
 },
 NotSupportedError: {
  s: 'NOT_SUPPORTED_ERR',
  c: 9,
  m: 1
 },
 InUseAttributeError: {
  s: 'INUSE_ATTRIBUTE_ERR',
  c: 10,
  m: 1
 },
 InvalidStateError: {
  s: 'INVALID_STATE_ERR',
  c: 11,
  m: 1
 },
 SyntaxError: {
  s: 'SYNTAX_ERR',
  c: 12,
  m: 1
 },
 InvalidModificationError: {
  s: 'INVALID_MODIFICATION_ERR',
  c: 13,
  m: 1
 },
 NamespaceError: {
  s: 'NAMESPACE_ERR',
  c: 14,
  m: 1
 },
 InvalidAccessError: {
  s: 'INVALID_ACCESS_ERR',
  c: 15,
  m: 1
 },
 ValidationError: {
  s: 'VALIDATION_ERR',
  c: 16,
  m: 0
 },
 TypeMismatchError: {
  s: 'TYPE_MISMATCH_ERR',
  c: 17,
  m: 1
 },
 SecurityError: {
  s: 'SECURITY_ERR',
  c: 18,
  m: 1
 },
 NetworkError: {
  s: 'NETWORK_ERR',
  c: 19,
  m: 1
 },
 AbortError: {
  s: 'ABORT_ERR',
  c: 20,
  m: 1
 },
 URLMismatchError: {
  s: 'URL_MISMATCH_ERR',
  c: 21,
  m: 1
 },
 QuotaExceededError: {
  s: 'QUOTA_EXCEEDED_ERR',
  c: 22,
  m: 1
 },
 TimeoutError: {
  s: 'TIMEOUT_ERR',
  c: 23,
  m: 1
 },
 InvalidNodeTypeError: {
  s: 'INVALID_NODE_TYPE_ERR',
  c: 24,
  m: 1
 },
 DataCloneError: {
  s: 'DATA_CLONE_ERR',
  c: 25,
  m: 1
 }
};

/***/ }),
/* 152 */
/***/ ((__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__) => {


var IS_PURE = __w_pdfjs_require__(36);
var $ = __w_pdfjs_require__(3);
var global = __w_pdfjs_require__(4);
var getBuiltin = __w_pdfjs_require__(24);
var uncurryThis = __w_pdfjs_require__(14);
var fails = __w_pdfjs_require__(7);
var uid = __w_pdfjs_require__(41);
var isCallable = __w_pdfjs_require__(21);
var isConstructor = __w_pdfjs_require__(153);
var isNullOrUndefined = __w_pdfjs_require__(17);
var isObject = __w_pdfjs_require__(20);
var isSymbol = __w_pdfjs_require__(23);
var iterate = __w_pdfjs_require__(154);
var anObject = __w_pdfjs_require__(47);
var classof = __w_pdfjs_require__(78);
var hasOwn = __w_pdfjs_require__(39);
var createProperty = __w_pdfjs_require__(159);
var createNonEnumerableProperty = __w_pdfjs_require__(44);
var lengthOfArrayLike = __w_pdfjs_require__(64);
var validateArgumentsLength = __w_pdfjs_require__(85);
var getRegExpFlags = __w_pdfjs_require__(160);
var MapHelpers = __w_pdfjs_require__(162);
var SetHelpers = __w_pdfjs_require__(128);
var ERROR_STACK_INSTALLABLE = __w_pdfjs_require__(83);
var PROPER_TRANSFER = __w_pdfjs_require__(119);
var Object = global.Object;
var Array = global.Array;
var Date = global.Date;
var Error = global.Error;
var EvalError = global.EvalError;
var RangeError = global.RangeError;
var ReferenceError = global.ReferenceError;
var SyntaxError = global.SyntaxError;
var TypeError = global.TypeError;
var URIError = global.URIError;
var PerformanceMark = global.PerformanceMark;
var WebAssembly = global.WebAssembly;
var CompileError = WebAssembly && WebAssembly.CompileError || Error;
var LinkError = WebAssembly && WebAssembly.LinkError || Error;
var RuntimeError = WebAssembly && WebAssembly.RuntimeError || Error;
var DOMException = getBuiltin('DOMException');
var Map = MapHelpers.Map;
var mapHas = MapHelpers.has;
var mapGet = MapHelpers.get;
var mapSet = MapHelpers.set;
var Set = SetHelpers.Set;
var setAdd = SetHelpers.add;
var objectKeys = getBuiltin('Object', 'keys');
var push = uncurryThis([].push);
var thisBooleanValue = uncurryThis(true.valueOf);
var thisNumberValue = uncurryThis(1.0.valueOf);
var thisStringValue = uncurryThis(''.valueOf);
var thisTimeValue = uncurryThis(Date.prototype.getTime);
var PERFORMANCE_MARK = uid('structuredClone');
var DATA_CLONE_ERROR = 'DataCloneError';
var TRANSFERRING = 'Transferring';
var checkBasicSemantic = function (structuredCloneImplementation) {
 return !fails(function () {
  var set1 = new global.Set([7]);
  var set2 = structuredCloneImplementation(set1);
  var number = structuredCloneImplementation(Object(7));
  return set2 === set1 || !set2.has(7) || typeof number != 'object' || +number !== 7;
 }) && structuredCloneImplementation;
};
var checkErrorsCloning = function (structuredCloneImplementation, $Error) {
 return !fails(function () {
  var error = new $Error();
  var test = structuredCloneImplementation({
   a: error,
   b: error
  });
  return !(test && test.a === test.b && test.a instanceof $Error && test.a.stack === error.stack);
 });
};
var checkNewErrorsCloningSemantic = function (structuredCloneImplementation) {
 return !fails(function () {
  var test = structuredCloneImplementation(new global.AggregateError([1], PERFORMANCE_MARK, { cause: 3 }));
  return test.name !== 'AggregateError' || test.errors[0] !== 1 || test.message !== PERFORMANCE_MARK || test.cause !== 3;
 });
};
var nativeStructuredClone = global.structuredClone;
var FORCED_REPLACEMENT = IS_PURE || !checkErrorsCloning(nativeStructuredClone, Error) || !checkErrorsCloning(nativeStructuredClone, DOMException) || !checkNewErrorsCloningSemantic(nativeStructuredClone);
var structuredCloneFromMark = !nativeStructuredClone && checkBasicSemantic(function (value) {
 return new PerformanceMark(PERFORMANCE_MARK, { detail: value }).detail;
});
var nativeRestrictedStructuredClone = checkBasicSemantic(nativeStructuredClone) || structuredCloneFromMark;
var throwUncloneable = function (type) {
 throw new DOMException('Uncloneable type: ' + type, DATA_CLONE_ERROR);
};
var throwUnpolyfillable = function (type, action) {
 throw new DOMException((action || 'Cloning') + ' of ' + type + ' cannot be properly polyfilled in this engine', DATA_CLONE_ERROR);
};
var tryNativeRestrictedStructuredClone = function (value, type) {
 if (!nativeRestrictedStructuredClone)
  throwUnpolyfillable(type);
 return nativeRestrictedStructuredClone(value);
};
var createDataTransfer = function () {
 var dataTransfer;
 try {
  dataTransfer = new global.DataTransfer();
 } catch (error) {
  try {
   dataTransfer = new global.ClipboardEvent('').clipboardData;
  } catch (error2) {
  }
 }
 return dataTransfer && dataTransfer.items && dataTransfer.files ? dataTransfer : null;
};
var cloneBuffer = function (value, map, $type) {
 if (mapHas(map, value))
  return mapGet(map, value);
 var type = $type || classof(value);
 var clone, length, options, source, target, i;
 if (type === 'SharedArrayBuffer') {
  if (nativeRestrictedStructuredClone)
   clone = nativeRestrictedStructuredClone(value);
  else
   clone = value;
 } else {
  var DataView = global.DataView;
  if (!DataView && typeof value.slice != 'function')
   throwUnpolyfillable('ArrayBuffer');
  try {
   if (typeof value.slice == 'function' && !value.resizable) {
    clone = value.slice(0);
   } else {
    length = value.byteLength;
    options = 'maxByteLength' in value ? { maxByteLength: value.maxByteLength } : undefined;
    clone = new ArrayBuffer(length, options);
    source = new DataView(value);
    target = new DataView(clone);
    for (i = 0; i < length; i++) {
     target.setUint8(i, source.getUint8(i));
    }
   }
  } catch (error) {
   throw new DOMException('ArrayBuffer is detached', DATA_CLONE_ERROR);
  }
 }
 mapSet(map, value, clone);
 return clone;
};
var cloneView = function (value, type, offset, length, map) {
 var C = global[type];
 if (!isObject(C))
  throwUnpolyfillable(type);
 return new C(cloneBuffer(value.buffer, map), offset, length);
};
var Placeholder = function (object, type, metadata) {
 this.object = object;
 this.type = type;
 this.metadata = metadata;
};
var structuredCloneInternal = function (value, map, transferredBuffers) {
 if (isSymbol(value))
  throwUncloneable('Symbol');
 if (!isObject(value))
  return value;
 if (map) {
  if (mapHas(map, value))
   return mapGet(map, value);
 } else
  map = new Map();
 var type = classof(value);
 var C, name, cloned, dataTransfer, i, length, keys, key;
 switch (type) {
 case 'Array':
  cloned = Array(lengthOfArrayLike(value));
  break;
 case 'Object':
  cloned = {};
  break;
 case 'Map':
  cloned = new Map();
  break;
 case 'Set':
  cloned = new Set();
  break;
 case 'RegExp':
  cloned = new RegExp(value.source, getRegExpFlags(value));
  break;
 case 'Error':
  name = value.name;
  switch (name) {
  case 'AggregateError':
   cloned = getBuiltin('AggregateError')([]);
   break;
  case 'EvalError':
   cloned = EvalError();
   break;
  case 'RangeError':
   cloned = RangeError();
   break;
  case 'ReferenceError':
   cloned = ReferenceError();
   break;
  case 'SyntaxError':
   cloned = SyntaxError();
   break;
  case 'TypeError':
   cloned = TypeError();
   break;
  case 'URIError':
   cloned = URIError();
   break;
  case 'CompileError':
   cloned = CompileError();
   break;
  case 'LinkError':
   cloned = LinkError();
   break;
  case 'RuntimeError':
   cloned = RuntimeError();
   break;
  default:
   cloned = Error();
  }
  break;
 case 'DOMException':
  cloned = new DOMException(value.message, value.name);
  break;
 case 'ArrayBuffer':
 case 'SharedArrayBuffer':
  cloned = transferredBuffers ? new Placeholder(value, type) : cloneBuffer(value, map, type);
  break;
 case 'DataView':
 case 'Int8Array':
 case 'Uint8Array':
 case 'Uint8ClampedArray':
 case 'Int16Array':
 case 'Uint16Array':
 case 'Int32Array':
 case 'Uint32Array':
 case 'Float16Array':
 case 'Float32Array':
 case 'Float64Array':
 case 'BigInt64Array':
 case 'BigUint64Array':
  length = type === 'DataView' ? value.byteLength : value.length;
  cloned = transferredBuffers ? new Placeholder(value, type, {
   offset: value.byteOffset,
   length: length
  }) : cloneView(value, type, value.byteOffset, length, map);
  break;
 case 'DOMQuad':
  try {
   cloned = new DOMQuad(structuredCloneInternal(value.p1, map, transferredBuffers), structuredCloneInternal(value.p2, map, transferredBuffers), structuredCloneInternal(value.p3, map, transferredBuffers), structuredCloneInternal(value.p4, map, transferredBuffers));
  } catch (error) {
   cloned = tryNativeRestrictedStructuredClone(value, type);
  }
  break;
 case 'File':
  if (nativeRestrictedStructuredClone)
   try {
    cloned = nativeRestrictedStructuredClone(value);
    if (classof(cloned) !== type)
     cloned = undefined;
   } catch (error) {
   }
  if (!cloned)
   try {
    cloned = new File([value], value.name, value);
   } catch (error) {
   }
  if (!cloned)
   throwUnpolyfillable(type);
  break;
 case 'FileList':
  dataTransfer = createDataTransfer();
  if (dataTransfer) {
   for (i = 0, length = lengthOfArrayLike(value); i < length; i++) {
    dataTransfer.items.add(structuredCloneInternal(value[i], map, transferredBuffers));
   }
   cloned = dataTransfer.files;
  } else
   cloned = tryNativeRestrictedStructuredClone(value, type);
  break;
 case 'ImageData':
  try {
   cloned = new ImageData(structuredCloneInternal(value.data, map, transferredBuffers), value.width, value.height, { colorSpace: value.colorSpace });
  } catch (error) {
   cloned = tryNativeRestrictedStructuredClone(value, type);
  }
  break;
 default:
  if (nativeRestrictedStructuredClone) {
   cloned = nativeRestrictedStructuredClone(value);
  } else
   switch (type) {
   case 'BigInt':
    cloned = Object(value.valueOf());
    break;
   case 'Boolean':
    cloned = Object(thisBooleanValue(value));
    break;
   case 'Number':
    cloned = Object(thisNumberValue(value));
    break;
   case 'String':
    cloned = Object(thisStringValue(value));
    break;
   case 'Date':
    cloned = new Date(thisTimeValue(value));
    break;
   case 'Blob':
    try {
     cloned = value.slice(0, value.size, value.type);
    } catch (error) {
     throwUnpolyfillable(type);
    }
    break;
   case 'DOMPoint':
   case 'DOMPointReadOnly':
    C = global[type];
    try {
     cloned = C.fromPoint ? C.fromPoint(value) : new C(value.x, value.y, value.z, value.w);
    } catch (error) {
     throwUnpolyfillable(type);
    }
    break;
   case 'DOMRect':
   case 'DOMRectReadOnly':
    C = global[type];
    try {
     cloned = C.fromRect ? C.fromRect(value) : new C(value.x, value.y, value.width, value.height);
    } catch (error) {
     throwUnpolyfillable(type);
    }
    break;
   case 'DOMMatrix':
   case 'DOMMatrixReadOnly':
    C = global[type];
    try {
     cloned = C.fromMatrix ? C.fromMatrix(value) : new C(value);
    } catch (error) {
     throwUnpolyfillable(type);
    }
    break;
   case 'AudioData':
   case 'VideoFrame':
    if (!isCallable(value.clone))
     throwUnpolyfillable(type);
    try {
     cloned = value.clone();
    } catch (error) {
     throwUncloneable(type);
    }
    break;
   case 'CropTarget':
   case 'CryptoKey':
   case 'FileSystemDirectoryHandle':
   case 'FileSystemFileHandle':
   case 'FileSystemHandle':
   case 'GPUCompilationInfo':
   case 'GPUCompilationMessage':
   case 'ImageBitmap':
   case 'RTCCertificate':
   case 'WebAssembly.Module':
    throwUnpolyfillable(type);
   default:
    throwUncloneable(type);
   }
 }
 mapSet(map, value, cloned);
 switch (type) {
 case 'Array':
 case 'Object':
  keys = objectKeys(value);
  for (i = 0, length = lengthOfArrayLike(keys); i < length; i++) {
   key = keys[i];
   createProperty(cloned, key, structuredCloneInternal(value[key], map, transferredBuffers));
  }
  break;
 case 'Map':
  value.forEach(function (v, k) {
   mapSet(cloned, structuredCloneInternal(k, map, transferredBuffers), structuredCloneInternal(v, map, transferredBuffers));
  });
  break;
 case 'Set':
  value.forEach(function (v) {
   setAdd(cloned, structuredCloneInternal(v, map, transferredBuffers));
  });
  break;
 case 'Error':
  createNonEnumerableProperty(cloned, 'message', structuredCloneInternal(value.message, map, transferredBuffers));
  if (hasOwn(value, 'cause')) {
   createNonEnumerableProperty(cloned, 'cause', structuredCloneInternal(value.cause, map, transferredBuffers));
  }
  if (name === 'AggregateError') {
   cloned.errors = structuredCloneInternal(value.errors, map, transferredBuffers);
  }
 case 'DOMException':
  if (ERROR_STACK_INSTALLABLE) {
   createNonEnumerableProperty(cloned, 'stack', structuredCloneInternal(value.stack, map, transferredBuffers));
  }
 }
 return cloned;
};
var replacePlaceholders = function (value, map) {
 if (!isObject(value))
  return value;
 if (mapHas(map, value))
  return mapGet(map, value);
 var type, object, metadata, i, length, keys, key, replacement;
 if (value instanceof Placeholder) {
  type = value.type;
  object = value.object;
  switch (type) {
  case 'ArrayBuffer':
  case 'SharedArrayBuffer':
   replacement = cloneBuffer(object, map, type);
   break;
  case 'DataView':
  case 'Int8Array':
  case 'Uint8Array':
  case 'Uint8ClampedArray':
  case 'Int16Array':
  case 'Uint16Array':
  case 'Int32Array':
  case 'Uint32Array':
  case 'Float16Array':
  case 'Float32Array':
  case 'Float64Array':
  case 'BigInt64Array':
  case 'BigUint64Array':
   metadata = value.metadata;
   replacement = cloneView(object, type, metadata.offset, metadata.length, map);
  }
 } else
  switch (classof(value)) {
  case 'Array':
  case 'Object':
   keys = objectKeys(value);
   for (i = 0, length = lengthOfArrayLike(keys); i < length; i++) {
    key = keys[i];
    value[key] = replacePlaceholders(value[key], map);
   }
   break;
  case 'Map':
   replacement = new Map();
   value.forEach(function (v, k) {
    mapSet(replacement, replacePlaceholders(k, map), replacePlaceholders(v, map));
   });
   break;
  case 'Set':
   replacement = new Set();
   value.forEach(function (v) {
    setAdd(replacement, replacePlaceholders(v, map));
   });
   break;
  case 'Error':
   value.message = replacePlaceholders(value.message, map);
   if (hasOwn(value, 'cause')) {
    value.cause = replacePlaceholders(value.cause, map);
   }
   if (value.name === 'AggregateError') {
    value.errors = replacePlaceholders(value.errors, map);
   }
  case 'DOMException':
   if (ERROR_STACK_INSTALLABLE) {
    value.stack = replacePlaceholders(value.stack, map);
   }
  }
 mapSet(map, value, replacement || value);
 return replacement || value;
};
var tryToTransfer = function (rawTransfer, map) {
 if (!isObject(rawTransfer))
  throw TypeError('Transfer option cannot be converted to a sequence');
 var transfer = [];
 iterate(rawTransfer, function (value) {
  push(transfer, anObject(value));
 });
 var i = 0;
 var length = lengthOfArrayLike(transfer);
 var buffers = [];
 var value, type, C, transferred, canvas, context;
 while (i < length) {
  value = transfer[i++];
  type = classof(value);
  if (type === 'ArrayBuffer') {
   push(buffers, value);
   continue;
  }
  if (mapHas(map, value))
   throw new DOMException('Duplicate transferable', DATA_CLONE_ERROR);
  if (PROPER_TRANSFER) {
   transferred = nativeStructuredClone(value, { transfer: [value] });
  } else
   switch (type) {
   case 'ImageBitmap':
    C = global.OffscreenCanvas;
    if (!isConstructor(C))
     throwUnpolyfillable(type, TRANSFERRING);
    try {
     canvas = new C(value.width, value.height);
     context = canvas.getContext('bitmaprenderer');
     context.transferFromImageBitmap(value);
     transferred = canvas.transferToImageBitmap();
    } catch (error) {
    }
    break;
   case 'AudioData':
   case 'VideoFrame':
    if (!isCallable(value.clone) || !isCallable(value.close))
     throwUnpolyfillable(type, TRANSFERRING);
    try {
     transferred = value.clone();
     value.close();
    } catch (error) {
    }
    break;
   case 'MediaSourceHandle':
   case 'MessagePort':
   case 'OffscreenCanvas':
   case 'ReadableStream':
   case 'TransformStream':
   case 'WritableStream':
    throwUnpolyfillable(type, TRANSFERRING);
   }
  if (transferred === undefined)
   throw new DOMException('This object cannot be transferred: ' + type, DATA_CLONE_ERROR);
  mapSet(map, value, transferred);
 }
 return buffers;
};
var tryToTransferBuffers = function (transfer, map) {
 var i = 0;
 var length = lengthOfArrayLike(transfer);
 var value, transferred;
 while (i < length) {
  value = transfer[i++];
  if (mapHas(map, value))
   throw new DOMException('Duplicate transferable', DATA_CLONE_ERROR);
  if (PROPER_TRANSFER) {
   transferred = nativeStructuredClone(value, { transfer: [value] });
  } else {
   if (!isCallable(value.transfer))
    throwUnpolyfillable('ArrayBuffer', TRANSFERRING);
   transferred = value.transfer();
  }
  mapSet(map, value, transferred);
 }
};
$({
 global: true,
 enumerable: true,
 sham: !PROPER_TRANSFER,
 forced: FORCED_REPLACEMENT
}, {
 structuredClone: function structuredClone(value) {
  var options = validateArgumentsLength(arguments.length, 1) > 1 && !isNullOrUndefined(arguments[1]) ? anObject(arguments[1]) : undefined;
  var transfer = options ? options.transfer : undefined;
  var transferredBuffers = false;
  var map, buffers;
  if (transfer !== undefined) {
   map = new Map();
   buffers = tryToTransfer(transfer, map);
   transferredBuffers = !!lengthOfArrayLike(buffers);
  }
  var clone = structuredCloneInternal(value, map, transferredBuffers);
  if (transferredBuffers) {
   map = new Map();
   tryToTransferBuffers(transfer, map);
   clone = replacePlaceholders(clone, map);
  }
  return clone;
 }
});

/***/ }),
/* 153 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var uncurryThis = __w_pdfjs_require__(14);
var fails = __w_pdfjs_require__(7);
var isCallable = __w_pdfjs_require__(21);
var classof = __w_pdfjs_require__(78);
var getBuiltIn = __w_pdfjs_require__(24);
var inspectSource = __w_pdfjs_require__(51);
var noop = function () {
};
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);
var isConstructorModern = function isConstructor(argument) {
 if (!isCallable(argument))
  return false;
 try {
  construct(noop, empty, argument);
  return true;
 } catch (error) {
  return false;
 }
};
var isConstructorLegacy = function isConstructor(argument) {
 if (!isCallable(argument))
  return false;
 switch (classof(argument)) {
 case 'AsyncFunction':
 case 'GeneratorFunction':
 case 'AsyncGeneratorFunction':
  return false;
 }
 try {
  return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
 } catch (error) {
  return true;
 }
};
isConstructorLegacy.sham = true;
module.exports = !construct || fails(function () {
 var called;
 return isConstructorModern(isConstructorModern.call) || !isConstructorModern(Object) || !isConstructorModern(function () {
  called = true;
 }) || called;
}) ? isConstructorLegacy : isConstructorModern;

/***/ }),
/* 154 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var bind = __w_pdfjs_require__(99);
var call = __w_pdfjs_require__(8);
var anObject = __w_pdfjs_require__(47);
var tryToString = __w_pdfjs_require__(32);
var isArrayIteratorMethod = __w_pdfjs_require__(155);
var lengthOfArrayLike = __w_pdfjs_require__(64);
var isPrototypeOf = __w_pdfjs_require__(25);
var getIterator = __w_pdfjs_require__(157);
var getIteratorMethod = __w_pdfjs_require__(158);
var iteratorClose = __w_pdfjs_require__(140);
var $TypeError = TypeError;
var Result = function (stopped, result) {
 this.stopped = stopped;
 this.result = result;
};
var ResultPrototype = Result.prototype;
module.exports = function (iterable, unboundFunction, options) {
 var that = options && options.that;
 var AS_ENTRIES = !!(options && options.AS_ENTRIES);
 var IS_RECORD = !!(options && options.IS_RECORD);
 var IS_ITERATOR = !!(options && options.IS_ITERATOR);
 var INTERRUPTED = !!(options && options.INTERRUPTED);
 var fn = bind(unboundFunction, that);
 var iterator, iterFn, index, length, result, next, step;
 var stop = function (condition) {
  if (iterator)
   iteratorClose(iterator, 'normal', condition);
  return new Result(true, condition);
 };
 var callFn = function (value) {
  if (AS_ENTRIES) {
   anObject(value);
   return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
  }
  return INTERRUPTED ? fn(value, stop) : fn(value);
 };
 if (IS_RECORD) {
  iterator = iterable.iterator;
 } else if (IS_ITERATOR) {
  iterator = iterable;
 } else {
  iterFn = getIteratorMethod(iterable);
  if (!iterFn)
   throw $TypeError(tryToString(iterable) + ' is not iterable');
  if (isArrayIteratorMethod(iterFn)) {
   for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
    result = callFn(iterable[index]);
    if (result && isPrototypeOf(ResultPrototype, result))
     return result;
   }
   return new Result(false);
  }
  iterator = getIterator(iterable, iterFn);
 }
 next = IS_RECORD ? iterable.next : iterator.next;
 while (!(step = call(next, iterator)).done) {
  try {
   result = callFn(step.value);
  } catch (error) {
   iteratorClose(iterator, 'throw', error);
  }
  if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result))
   return result;
 }
 return new Result(false);
};

/***/ }),
/* 155 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var wellKnownSymbol = __w_pdfjs_require__(34);
var Iterators = __w_pdfjs_require__(156);
var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;
module.exports = function (it) {
 return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};

/***/ }),
/* 156 */
/***/ ((module) => {


module.exports = {};

/***/ }),
/* 157 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var call = __w_pdfjs_require__(8);
var aCallable = __w_pdfjs_require__(31);
var anObject = __w_pdfjs_require__(47);
var tryToString = __w_pdfjs_require__(32);
var getIteratorMethod = __w_pdfjs_require__(158);
var $TypeError = TypeError;
module.exports = function (argument, usingIterator) {
 var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
 if (aCallable(iteratorMethod))
  return anObject(call(iteratorMethod, argument));
 throw $TypeError(tryToString(argument) + ' is not iterable');
};

/***/ }),
/* 158 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var classof = __w_pdfjs_require__(78);
var getMethod = __w_pdfjs_require__(30);
var isNullOrUndefined = __w_pdfjs_require__(17);
var Iterators = __w_pdfjs_require__(156);
var wellKnownSymbol = __w_pdfjs_require__(34);
var ITERATOR = wellKnownSymbol('iterator');
module.exports = function (it) {
 if (!isNullOrUndefined(it))
  return getMethod(it, ITERATOR) || getMethod(it, '@@iterator') || Iterators[classof(it)];
};

/***/ }),
/* 159 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var toPropertyKey = __w_pdfjs_require__(18);
var definePropertyModule = __w_pdfjs_require__(45);
var createPropertyDescriptor = __w_pdfjs_require__(11);
module.exports = function (object, key, value) {
 var propertyKey = toPropertyKey(key);
 if (propertyKey in object)
  definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
 else
  object[propertyKey] = value;
};

/***/ }),
/* 160 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var call = __w_pdfjs_require__(8);
var hasOwn = __w_pdfjs_require__(39);
var isPrototypeOf = __w_pdfjs_require__(25);
var regExpFlags = __w_pdfjs_require__(161);
var RegExpPrototype = RegExp.prototype;
module.exports = function (R) {
 var flags = R.flags;
 return flags === undefined && !('flags' in RegExpPrototype) && !hasOwn(R, 'flags') && isPrototypeOf(RegExpPrototype, R) ? call(regExpFlags, R) : flags;
};

/***/ }),
/* 161 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var anObject = __w_pdfjs_require__(47);
module.exports = function () {
 var that = anObject(this);
 var result = '';
 if (that.hasIndices)
  result += 'd';
 if (that.global)
  result += 'g';
 if (that.ignoreCase)
  result += 'i';
 if (that.multiline)
  result += 'm';
 if (that.dotAll)
  result += 's';
 if (that.unicode)
  result += 'u';
 if (that.unicodeSets)
  result += 'v';
 if (that.sticky)
  result += 'y';
 return result;
};

/***/ }),
/* 162 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var uncurryThis = __w_pdfjs_require__(14);
var MapPrototype = Map.prototype;
module.exports = {
 Map: Map,
 set: uncurryThis(MapPrototype.set),
 get: uncurryThis(MapPrototype.get),
 has: uncurryThis(MapPrototype.has),
 remove: uncurryThis(MapPrototype['delete']),
 proto: MapPrototype
};

/***/ }),
/* 163 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.SerializableEmpty = exports.PrintAnnotationStorage = exports.AnnotationStorage = void 0;
__w_pdfjs_require__(89);
__w_pdfjs_require__(149);
__w_pdfjs_require__(152);
var _util = __w_pdfjs_require__(1);
var _editor = __w_pdfjs_require__(164);
var _murmurhash = __w_pdfjs_require__(170);
const SerializableEmpty = Object.freeze({
  map: null,
  hash: "",
  transfers: undefined
});
exports.SerializableEmpty = SerializableEmpty;
class AnnotationStorage {
  #modified = false;
  #storage = new Map();
  constructor() {
    this.onSetModified = null;
    this.onResetModified = null;
    this.onAnnotationEditor = null;
  }
  getValue(key, defaultValue) {
    const value = this.#storage.get(key);
    if (value === undefined) {
      return defaultValue;
    }
    return Object.assign(defaultValue, value);
  }
  getRawValue(key) {
    return this.#storage.get(key);
  }
  remove(key) {
    this.#storage.delete(key);
    if (this.#storage.size === 0) {
      this.resetModified();
    }
    if (typeof this.onAnnotationEditor === "function") {
      for (const value of this.#storage.values()) {
        if (value instanceof _editor.AnnotationEditor) {
          return;
        }
      }
      this.onAnnotationEditor(null);
    }
  }
  setValue(key, value) {
    const obj = this.#storage.get(key);
    let modified = false;
    if (obj !== undefined) {
      for (const [entry, val] of Object.entries(value)) {
        if (obj[entry] !== val) {
          modified = true;
          obj[entry] = val;
        }
      }
    } else {
      modified = true;
      this.#storage.set(key, value);
    }
    if (modified) {
      this.#setModified();
    }
    if (value instanceof _editor.AnnotationEditor && typeof this.onAnnotationEditor === "function") {
      this.onAnnotationEditor(value.constructor._type);
    }
  }
  has(key) {
    return this.#storage.has(key);
  }
  getAll() {
    return this.#storage.size > 0 ? (0, _util.objectFromMap)(this.#storage) : null;
  }
  setAll(obj) {
    for (const [key, val] of Object.entries(obj)) {
      this.setValue(key, val);
    }
  }
  get size() {
    return this.#storage.size;
  }
  #setModified() {
    if (!this.#modified) {
      this.#modified = true;
      if (typeof this.onSetModified === "function") {
        this.onSetModified();
      }
    }
  }
  resetModified() {
    if (this.#modified) {
      this.#modified = false;
      if (typeof this.onResetModified === "function") {
        this.onResetModified();
      }
    }
  }
  get print() {
    return new PrintAnnotationStorage(this);
  }
  get serializable() {
    if (this.#storage.size === 0) {
      return SerializableEmpty;
    }
    const map = new Map(),
      hash = new _murmurhash.MurmurHash3_64(),
      transfers = [];
    const context = Object.create(null);
    let hasBitmap = false;
    for (const [key, val] of this.#storage) {
      const serialized = val instanceof _editor.AnnotationEditor ? val.serialize(false, context) : val;
      if (serialized) {
        map.set(key, serialized);
        hash.update(`${key}:${JSON.stringify(serialized)}`);
        hasBitmap ||= !!serialized.bitmap;
      }
    }
    if (hasBitmap) {
      for (const value of map.values()) {
        if (value.bitmap) {
          transfers.push(value.bitmap);
        }
      }
    }
    return map.size > 0 ? {
      map,
      hash: hash.hexdigest(),
      transfers
    } : SerializableEmpty;
  }
}
exports.AnnotationStorage = AnnotationStorage;
class PrintAnnotationStorage extends AnnotationStorage {
  #serializable;
  constructor(parent) {
    super();
    const {
      map,
      hash,
      transfers
    } = parent.serializable;
    const clone = structuredClone(map, null);
    this.#serializable = {
      map: clone,
      hash,
      transfers
    };
  }
  get print() {
    (0, _util.unreachable)("Should not call PrintAnnotationStorage.print");
  }
  get serializable() {
    return this.#serializable;
  }
}
exports.PrintAnnotationStorage = PrintAnnotationStorage;

/***/ }),
/* 164 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AnnotationEditor = void 0;
__w_pdfjs_require__(89);
__w_pdfjs_require__(2);
var _tools = __w_pdfjs_require__(165);
var _util = __w_pdfjs_require__(1);
var _display_utils = __w_pdfjs_require__(168);
class AnnotationEditor {
  #altText = "";
  #altTextDecorative = false;
  #altTextButton = null;
  #altTextTooltip = null;
  #altTextTooltipTimeout = null;
  #keepAspectRatio = false;
  #resizersDiv = null;
  #boundFocusin = this.focusin.bind(this);
  #boundFocusout = this.focusout.bind(this);
  #hasBeenClicked = false;
  #isEditing = false;
  #isInEditMode = false;
  _initialOptions = Object.create(null);
  _uiManager = null;
  _focusEventsAllowed = true;
  _l10nPromise = null;
  #isDraggable = false;
  #zIndex = AnnotationEditor._zIndex++;
  static _borderLineWidth = -1;
  static _colorManager = new _tools.ColorManager();
  static _zIndex = 1;
  static SMALL_EDITOR_SIZE = 0;
  constructor(parameters) {
    if (this.constructor === AnnotationEditor) {
      (0, _util.unreachable)("Cannot initialize AnnotationEditor.");
    }
    this.parent = parameters.parent;
    this.id = parameters.id;
    this.width = this.height = null;
    this.pageIndex = parameters.parent.pageIndex;
    this.name = parameters.name;
    this.div = null;
    this._uiManager = parameters.uiManager;
    this.annotationElementId = null;
    this._willKeepAspectRatio = false;
    this._initialOptions.isCentered = parameters.isCentered;
    this._structTreeParentId = null;
    const {
      rotation,
      rawDims: {
        pageWidth,
        pageHeight,
        pageX,
        pageY
      }
    } = this.parent.viewport;
    this.rotation = rotation;
    this.pageRotation = (360 + rotation - this._uiManager.viewParameters.rotation) % 360;
    this.pageDimensions = [pageWidth, pageHeight];
    this.pageTranslation = [pageX, pageY];
    const [width, height] = this.parentDimensions;
    this.x = parameters.x / width;
    this.y = parameters.y / height;
    this.isAttachedToDOM = false;
    this.deleted = false;
  }
  get editorType() {
    return Object.getPrototypeOf(this).constructor._type;
  }
  static get _defaultLineColor() {
    return (0, _util.shadow)(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
  }
  static deleteAnnotationElement(editor) {
    const fakeEditor = new FakeEditor({
      id: editor.parent.getNextId(),
      parent: editor.parent,
      uiManager: editor._uiManager
    });
    fakeEditor.annotationElementId = editor.annotationElementId;
    fakeEditor.deleted = true;
    fakeEditor._uiManager.addToAnnotationStorage(fakeEditor);
  }
  static initialize(l10n) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    AnnotationEditor._l10nPromise ||= new Map(["editor_alt_text_button_label", "editor_alt_text_edit_button_label", "editor_alt_text_decorative_tooltip"].map(str => [str, l10n.get(str)]));
    if (options?.strings) {
      for (const str of options.strings) {
        AnnotationEditor._l10nPromise.set(str, l10n.get(str));
      }
    }
    if (AnnotationEditor._borderLineWidth !== -1) {
      return;
    }
    const style = getComputedStyle(document.documentElement);
    AnnotationEditor._borderLineWidth = parseFloat(style.getPropertyValue("--outline-width")) || 0;
  }
  static updateDefaultParams(_type, _value) {}
  static get defaultPropertiesToUpdate() {
    return [];
  }
  static isHandlingMimeForPasting(mime) {
    return false;
  }
  static paste(item, parent) {
    (0, _util.unreachable)("Not implemented");
  }
  get propertiesToUpdate() {
    return [];
  }
  get _isDraggable() {
    return this.#isDraggable;
  }
  set _isDraggable(value) {
    this.#isDraggable = value;
    this.div?.classList.toggle("draggable", value);
  }
  center() {
    const [pageWidth, pageHeight] = this.pageDimensions;
    switch (this.parentRotation) {
      case 90:
        this.x -= this.height * pageHeight / (pageWidth * 2);
        this.y += this.width * pageWidth / (pageHeight * 2);
        break;
      case 180:
        this.x += this.width / 2;
        this.y += this.height / 2;
        break;
      case 270:
        this.x += this.height * pageHeight / (pageWidth * 2);
        this.y -= this.width * pageWidth / (pageHeight * 2);
        break;
      default:
        this.x -= this.width / 2;
        this.y -= this.height / 2;
        break;
    }
    this.fixAndSetPosition();
  }
  addCommands(params) {
    this._uiManager.addCommands(params);
  }
  get currentLayer() {
    return this._uiManager.currentLayer;
  }
  setInBackground() {
    this.div.style.zIndex = 0;
  }
  setInForeground() {
    this.div.style.zIndex = this.#zIndex;
  }
  setParent(parent) {
    if (parent !== null) {
      this.pageIndex = parent.pageIndex;
      this.pageDimensions = parent.pageDimensions;
    }
    this.parent = parent;
  }
  focusin(event) {
    if (!this._focusEventsAllowed) {
      return;
    }
    if (!this.#hasBeenClicked) {
      this.parent.setSelected(this);
    } else {
      this.#hasBeenClicked = false;
    }
  }
  focusout(event) {
    if (!this._focusEventsAllowed) {
      return;
    }
    if (!this.isAttachedToDOM) {
      return;
    }
    const target = event.relatedTarget;
    if (target?.closest(`#${this.id}`)) {
      return;
    }
    event.preventDefault();
    if (!this.parent?.isMultipleSelection) {
      this.commitOrRemove();
    }
  }
  commitOrRemove() {
    if (this.isEmpty()) {
      this.remove();
    } else {
      this.commit();
    }
  }
  commit() {
    this.addToAnnotationStorage();
  }
  addToAnnotationStorage() {
    this._uiManager.addToAnnotationStorage(this);
  }
  setAt(x, y, tx, ty) {
    const [width, height] = this.parentDimensions;
    [tx, ty] = this.screenToPageTranslation(tx, ty);
    this.x = (x + tx) / width;
    this.y = (y + ty) / height;
    this.fixAndSetPosition();
  }
  #translate(_ref, x, y) {
    let [width, height] = _ref;
    [x, y] = this.screenToPageTranslation(x, y);
    this.x += x / width;
    this.y += y / height;
    this.fixAndSetPosition();
  }
  translate(x, y) {
    this.#translate(this.parentDimensions, x, y);
  }
  translateInPage(x, y) {
    this.#translate(this.pageDimensions, x, y);
    this.div.scrollIntoView({
      block: "nearest"
    });
  }
  drag(tx, ty) {
    const [parentWidth, parentHeight] = this.parentDimensions;
    this.x += tx / parentWidth;
    this.y += ty / parentHeight;
    if (this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
      const {
        x,
        y
      } = this.div.getBoundingClientRect();
      if (this.parent.findNewParent(this, x, y)) {
        this.x -= Math.floor(this.x);
        this.y -= Math.floor(this.y);
      }
    }
    let {
      x,
      y
    } = this;
    const [bx, by] = this.#getBaseTranslation();
    x += bx;
    y += by;
    this.div.style.left = `${(100 * x).toFixed(2)}%`;
    this.div.style.top = `${(100 * y).toFixed(2)}%`;
    this.div.scrollIntoView({
      block: "nearest"
    });
  }
  #getBaseTranslation() {
    const [parentWidth, parentHeight] = this.parentDimensions;
    const {
      _borderLineWidth
    } = AnnotationEditor;
    const x = _borderLineWidth / parentWidth;
    const y = _borderLineWidth / parentHeight;
    switch (this.rotation) {
      case 90:
        return [-x, y];
      case 180:
        return [x, y];
      case 270:
        return [x, -y];
      default:
        return [-x, -y];
    }
  }
  fixAndSetPosition() {
    const [pageWidth, pageHeight] = this.pageDimensions;
    let {
      x,
      y,
      width,
      height
    } = this;
    width *= pageWidth;
    height *= pageHeight;
    x *= pageWidth;
    y *= pageHeight;
    switch (this.rotation) {
      case 0:
        x = Math.max(0, Math.min(pageWidth - width, x));
        y = Math.max(0, Math.min(pageHeight - height, y));
        break;
      case 90:
        x = Math.max(0, Math.min(pageWidth - height, x));
        y = Math.min(pageHeight, Math.max(width, y));
        break;
      case 180:
        x = Math.min(pageWidth, Math.max(width, x));
        y = Math.min(pageHeight, Math.max(height, y));
        break;
      case 270:
        x = Math.min(pageWidth, Math.max(height, x));
        y = Math.max(0, Math.min(pageHeight - width, y));
        break;
    }
    this.x = x /= pageWidth;
    this.y = y /= pageHeight;
    const [bx, by] = this.#getBaseTranslation();
    x += bx;
    y += by;
    const {
      style
    } = this.div;
    style.left = `${(100 * x).toFixed(2)}%`;
    style.top = `${(100 * y).toFixed(2)}%`;
    this.moveInDOM();
  }
  static #rotatePoint(x, y, angle) {
    switch (angle) {
      case 90:
        return [y, -x];
      case 180:
        return [-x, -y];
      case 270:
        return [-y, x];
      default:
        return [x, y];
    }
  }
  screenToPageTranslation(x, y) {
    return AnnotationEditor.#rotatePoint(x, y, this.parentRotation);
  }
  pageTranslationToScreen(x, y) {
    return AnnotationEditor.#rotatePoint(x, y, 360 - this.parentRotation);
  }
  #getRotationMatrix(rotation) {
    switch (rotation) {
      case 90:
        {
          const [pageWidth, pageHeight] = this.pageDimensions;
          return [0, -pageWidth / pageHeight, pageHeight / pageWidth, 0];
        }
      case 180:
        return [-1, 0, 0, -1];
      case 270:
        {
          const [pageWidth, pageHeight] = this.pageDimensions;
          return [0, pageWidth / pageHeight, -pageHeight / pageWidth, 0];
        }
      default:
        return [1, 0, 0, 1];
    }
  }
  get parentScale() {
    return this._uiManager.viewParameters.realScale;
  }
  get parentRotation() {
    return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
  }
  get parentDimensions() {
    const {
      parentScale,
      pageDimensions: [pageWidth, pageHeight]
    } = this;
    const scaledWidth = pageWidth * parentScale;
    const scaledHeight = pageHeight * parentScale;
    return _util.FeatureTest.isCSSRoundSupported ? [Math.round(scaledWidth), Math.round(scaledHeight)] : [scaledWidth, scaledHeight];
  }
  setDims(width, height) {
    const [parentWidth, parentHeight] = this.parentDimensions;
    this.div.style.width = `${(100 * width / parentWidth).toFixed(2)}%`;
    if (!this.#keepAspectRatio) {
      this.div.style.height = `${(100 * height / parentHeight).toFixed(2)}%`;
    }
    this.#altTextButton?.classList.toggle("small", width < AnnotationEditor.SMALL_EDITOR_SIZE || height < AnnotationEditor.SMALL_EDITOR_SIZE);
  }
  fixDims() {
    const {
      style
    } = this.div;
    const {
      height,
      width
    } = style;
    const widthPercent = width.endsWith("%");
    const heightPercent = !this.#keepAspectRatio && height.endsWith("%");
    if (widthPercent && heightPercent) {
      return;
    }
    const [parentWidth, parentHeight] = this.parentDimensions;
    if (!widthPercent) {
      style.width = `${(100 * parseFloat(width) / parentWidth).toFixed(2)}%`;
    }
    if (!this.#keepAspectRatio && !heightPercent) {
      style.height = `${(100 * parseFloat(height) / parentHeight).toFixed(2)}%`;
    }
  }
  getInitialTranslation() {
    return [0, 0];
  }
  #createResizers() {
    if (this.#resizersDiv) {
      return;
    }
    this.#resizersDiv = document.createElement("div");
    this.#resizersDiv.classList.add("resizers");
    const classes = ["topLeft", "topRight", "bottomRight", "bottomLeft"];
    if (!this._willKeepAspectRatio) {
      classes.push("topMiddle", "middleRight", "bottomMiddle", "middleLeft");
    }
    for (const name of classes) {
      const div = document.createElement("div");
      this.#resizersDiv.append(div);
      div.classList.add("resizer", name);
      div.addEventListener("pointerdown", this.#resizerPointerdown.bind(this, name));
      div.addEventListener("contextmenu", _display_utils.noContextMenu);
    }
    this.div.prepend(this.#resizersDiv);
  }
  #resizerPointerdown(name, event) {
    event.preventDefault();
    const {
      isMac
    } = _util.FeatureTest.platform;
    if (event.button !== 0 || event.ctrlKey && isMac) {
      return;
    }
    const boundResizerPointermove = this.#resizerPointermove.bind(this, name);
    const savedDraggable = this._isDraggable;
    this._isDraggable = false;
    const pointerMoveOptions = {
      passive: true,
      capture: true
    };
    window.addEventListener("pointermove", boundResizerPointermove, pointerMoveOptions);
    const savedX = this.x;
    const savedY = this.y;
    const savedWidth = this.width;
    const savedHeight = this.height;
    const savedParentCursor = this.parent.div.style.cursor;
    const savedCursor = this.div.style.cursor;
    this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(event.target).cursor;
    const pointerUpCallback = () => {
      this._isDraggable = savedDraggable;
      window.removeEventListener("pointerup", pointerUpCallback);
      window.removeEventListener("blur", pointerUpCallback);
      window.removeEventListener("pointermove", boundResizerPointermove, pointerMoveOptions);
      this.parent.div.style.cursor = savedParentCursor;
      this.div.style.cursor = savedCursor;
      const newX = this.x;
      const newY = this.y;
      const newWidth = this.width;
      const newHeight = this.height;
      if (newX === savedX && newY === savedY && newWidth === savedWidth && newHeight === savedHeight) {
        return;
      }
      this.addCommands({
        cmd: () => {
          this.width = newWidth;
          this.height = newHeight;
          this.x = newX;
          this.y = newY;
          const [parentWidth, parentHeight] = this.parentDimensions;
          this.setDims(parentWidth * newWidth, parentHeight * newHeight);
          this.fixAndSetPosition();
        },
        undo: () => {
          this.width = savedWidth;
          this.height = savedHeight;
          this.x = savedX;
          this.y = savedY;
          const [parentWidth, parentHeight] = this.parentDimensions;
          this.setDims(parentWidth * savedWidth, parentHeight * savedHeight);
          this.fixAndSetPosition();
        },
        mustExec: true
      });
    };
    window.addEventListener("pointerup", pointerUpCallback);
    window.addEventListener("blur", pointerUpCallback);
  }
  #resizerPointermove(name, event) {
    const [parentWidth, parentHeight] = this.parentDimensions;
    const savedX = this.x;
    const savedY = this.y;
    const savedWidth = this.width;
    const savedHeight = this.height;
    const minWidth = AnnotationEditor.MIN_SIZE / parentWidth;
    const minHeight = AnnotationEditor.MIN_SIZE / parentHeight;
    const round = x => Math.round(x * 10000) / 10000;
    const rotationMatrix = this.#getRotationMatrix(this.rotation);
    const transf = (x, y) => [rotationMatrix[0] * x + rotationMatrix[2] * y, rotationMatrix[1] * x + rotationMatrix[3] * y];
    const invRotationMatrix = this.#getRotationMatrix(360 - this.rotation);
    const invTransf = (x, y) => [invRotationMatrix[0] * x + invRotationMatrix[2] * y, invRotationMatrix[1] * x + invRotationMatrix[3] * y];
    let getPoint;
    let getOpposite;
    let isDiagonal = false;
    let isHorizontal = false;
    switch (name) {
      case "topLeft":
        isDiagonal = true;
        getPoint = (w, h) => [0, 0];
        getOpposite = (w, h) => [w, h];
        break;
      case "topMiddle":
        getPoint = (w, h) => [w / 2, 0];
        getOpposite = (w, h) => [w / 2, h];
        break;
      case "topRight":
        isDiagonal = true;
        getPoint = (w, h) => [w, 0];
        getOpposite = (w, h) => [0, h];
        break;
      case "middleRight":
        isHorizontal = true;
        getPoint = (w, h) => [w, h / 2];
        getOpposite = (w, h) => [0, h / 2];
        break;
      case "bottomRight":
        isDiagonal = true;
        getPoint = (w, h) => [w, h];
        getOpposite = (w, h) => [0, 0];
        break;
      case "bottomMiddle":
        getPoint = (w, h) => [w / 2, h];
        getOpposite = (w, h) => [w / 2, 0];
        break;
      case "bottomLeft":
        isDiagonal = true;
        getPoint = (w, h) => [0, h];
        getOpposite = (w, h) => [w, 0];
        break;
      case "middleLeft":
        isHorizontal = true;
        getPoint = (w, h) => [0, h / 2];
        getOpposite = (w, h) => [w, h / 2];
        break;
    }
    const point = getPoint(savedWidth, savedHeight);
    const oppositePoint = getOpposite(savedWidth, savedHeight);
    let transfOppositePoint = transf(...oppositePoint);
    const oppositeX = round(savedX + transfOppositePoint[0]);
    const oppositeY = round(savedY + transfOppositePoint[1]);
    let ratioX = 1;
    let ratioY = 1;
    let [deltaX, deltaY] = this.screenToPageTranslation(event.movementX, event.movementY);
    [deltaX, deltaY] = invTransf(deltaX / parentWidth, deltaY / parentHeight);
    if (isDiagonal) {
      const oldDiag = Math.hypot(savedWidth, savedHeight);
      ratioX = ratioY = Math.max(Math.min(Math.hypot(oppositePoint[0] - point[0] - deltaX, oppositePoint[1] - point[1] - deltaY) / oldDiag, 1 / savedWidth, 1 / savedHeight), minWidth / savedWidth, minHeight / savedHeight);
    } else if (isHorizontal) {
      ratioX = Math.max(minWidth, Math.min(1, Math.abs(oppositePoint[0] - point[0] - deltaX))) / savedWidth;
    } else {
      ratioY = Math.max(minHeight, Math.min(1, Math.abs(oppositePoint[1] - point[1] - deltaY))) / savedHeight;
    }
    const newWidth = round(savedWidth * ratioX);
    const newHeight = round(savedHeight * ratioY);
    transfOppositePoint = transf(...getOpposite(newWidth, newHeight));
    const newX = oppositeX - transfOppositePoint[0];
    const newY = oppositeY - transfOppositePoint[1];
    this.width = newWidth;
    this.height = newHeight;
    this.x = newX;
    this.y = newY;
    this.setDims(parentWidth * newWidth, parentHeight * newHeight);
    this.fixAndSetPosition();
  }
  async addAltTextButton() {
    if (this.#altTextButton) {
      return;
    }
    const altText = this.#altTextButton = document.createElement("button");
    altText.className = "altText";
    const msg = await AnnotationEditor._l10nPromise.get("editor_alt_text_button_label");
    altText.textContent = msg;
    altText.setAttribute("aria-label", msg);
    altText.tabIndex = "0";
    altText.addEventListener("contextmenu", _display_utils.noContextMenu);
    altText.addEventListener("pointerdown", event => event.stopPropagation());
    altText.addEventListener("click", event => {
      event.preventDefault();
      this._uiManager.editAltText(this);
    }, {
      capture: true
    });
    altText.addEventListener("keydown", event => {
      if (event.target === altText && event.key === "Enter") {
        event.preventDefault();
        this._uiManager.editAltText(this);
      }
    });
    this.#setAltTextButtonState();
    this.div.append(altText);
    if (!AnnotationEditor.SMALL_EDITOR_SIZE) {
      const PERCENT = 40;
      AnnotationEditor.SMALL_EDITOR_SIZE = Math.min(128, Math.round(altText.getBoundingClientRect().width * (1 + PERCENT / 100)));
    }
  }
  async #setAltTextButtonState() {
    const button = this.#altTextButton;
    if (!button) {
      return;
    }
    if (!this.#altText && !this.#altTextDecorative) {
      button.classList.remove("done");
      this.#altTextTooltip?.remove();
      return;
    }
    AnnotationEditor._l10nPromise.get("editor_alt_text_edit_button_label").then(msg => {
      button.setAttribute("aria-label", msg);
    });
    let tooltip = this.#altTextTooltip;
    if (!tooltip) {
      this.#altTextTooltip = tooltip = document.createElement("span");
      tooltip.className = "tooltip";
      tooltip.setAttribute("role", "tooltip");
      const id = tooltip.id = `alt-text-tooltip-${this.id}`;
      button.setAttribute("aria-describedby", id);
      const DELAY_TO_SHOW_TOOLTIP = 100;
      button.addEventListener("mouseenter", () => {
        this.#altTextTooltipTimeout = setTimeout(() => {
          this.#altTextTooltipTimeout = null;
          this.#altTextTooltip.classList.add("show");
          this._uiManager._eventBus.dispatch("reporttelemetry", {
            source: this,
            details: {
              type: "editing",
              subtype: this.editorType,
              data: {
                action: "alt_text_tooltip"
              }
            }
          });
        }, DELAY_TO_SHOW_TOOLTIP);
      });
      button.addEventListener("mouseleave", () => {
        clearTimeout(this.#altTextTooltipTimeout);
        this.#altTextTooltipTimeout = null;
        this.#altTextTooltip?.classList.remove("show");
      });
    }
    button.classList.add("done");
    tooltip.innerText = this.#altTextDecorative ? await AnnotationEditor._l10nPromise.get("editor_alt_text_decorative_tooltip") : this.#altText;
    if (!tooltip.parentNode) {
      button.append(tooltip);
    }
  }
  getClientDimensions() {
    return this.div.getBoundingClientRect();
  }
  get altTextData() {
    return {
      altText: this.#altText,
      decorative: this.#altTextDecorative
    };
  }
  set altTextData(_ref2) {
    let {
      altText,
      decorative
    } = _ref2;
    if (this.#altText === altText && this.#altTextDecorative === decorative) {
      return;
    }
    this.#altText = altText;
    this.#altTextDecorative = decorative;
    this.#setAltTextButtonState();
  }
  render() {
    this.div = document.createElement("div");
    this.div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360);
    this.div.className = this.name;
    this.div.setAttribute("id", this.id);
    this.div.setAttribute("tabIndex", 0);
    this.setInForeground();
    this.div.addEventListener("focusin", this.#boundFocusin);
    this.div.addEventListener("focusout", this.#boundFocusout);
    const [parentWidth, parentHeight] = this.parentDimensions;
    if (this.parentRotation % 180 !== 0) {
      this.div.style.maxWidth = `${(100 * parentHeight / parentWidth).toFixed(2)}%`;
      this.div.style.maxHeight = `${(100 * parentWidth / parentHeight).toFixed(2)}%`;
    }
    const [tx, ty] = this.getInitialTranslation();
    this.translate(tx, ty);
    (0, _tools.bindEvents)(this, this.div, ["pointerdown"]);
    return this.div;
  }
  pointerdown(event) {
    const {
      isMac
    } = _util.FeatureTest.platform;
    if (event.button !== 0 || event.ctrlKey && isMac) {
      event.preventDefault();
      return;
    }
    this.#hasBeenClicked = true;
    this.#setUpDragSession(event);
  }
  #setUpDragSession(event) {
    if (!this._isDraggable) {
      return;
    }
    const isSelected = this._uiManager.isSelected(this);
    this._uiManager.setUpDragSession();
    let pointerMoveOptions, pointerMoveCallback;
    if (isSelected) {
      pointerMoveOptions = {
        passive: true,
        capture: true
      };
      pointerMoveCallback = e => {
        const [tx, ty] = this.screenToPageTranslation(e.movementX, e.movementY);
        this._uiManager.dragSelectedEditors(tx, ty);
      };
      window.addEventListener("pointermove", pointerMoveCallback, pointerMoveOptions);
    }
    const pointerUpCallback = () => {
      window.removeEventListener("pointerup", pointerUpCallback);
      window.removeEventListener("blur", pointerUpCallback);
      if (isSelected) {
        window.removeEventListener("pointermove", pointerMoveCallback, pointerMoveOptions);
      }
      this.#hasBeenClicked = false;
      if (!this._uiManager.endDragSession()) {
        const {
          isMac
        } = _util.FeatureTest.platform;
        if (event.ctrlKey && !isMac || event.shiftKey || event.metaKey && isMac) {
          this.parent.toggleSelected(this);
        } else {
          this.parent.setSelected(this);
        }
      }
    };
    window.addEventListener("pointerup", pointerUpCallback);
    window.addEventListener("blur", pointerUpCallback);
  }
  moveInDOM() {
    this.parent?.moveEditorInDOM(this);
  }
  _setParentAndPosition(parent, x, y) {
    parent.changeParent(this);
    this.x = x;
    this.y = y;
    this.fixAndSetPosition();
  }
  getRect(tx, ty) {
    const scale = this.parentScale;
    const [pageWidth, pageHeight] = this.pageDimensions;
    const [pageX, pageY] = this.pageTranslation;
    const shiftX = tx / scale;
    const shiftY = ty / scale;
    const x = this.x * pageWidth;
    const y = this.y * pageHeight;
    const width = this.width * pageWidth;
    const height = this.height * pageHeight;
    switch (this.rotation) {
      case 0:
        return [x + shiftX + pageX, pageHeight - y - shiftY - height + pageY, x + shiftX + width + pageX, pageHeight - y - shiftY + pageY];
      case 90:
        return [x + shiftY + pageX, pageHeight - y + shiftX + pageY, x + shiftY + height + pageX, pageHeight - y + shiftX + width + pageY];
      case 180:
        return [x - shiftX - width + pageX, pageHeight - y + shiftY + pageY, x - shiftX + pageX, pageHeight - y + shiftY + height + pageY];
      case 270:
        return [x - shiftY - height + pageX, pageHeight - y - shiftX - width + pageY, x - shiftY + pageX, pageHeight - y - shiftX + pageY];
      default:
        throw new Error("Invalid rotation");
    }
  }
  getRectInCurrentCoords(rect, pageHeight) {
    const [x1, y1, x2, y2] = rect;
    const width = x2 - x1;
    const height = y2 - y1;
    switch (this.rotation) {
      case 0:
        return [x1, pageHeight - y2, width, height];
      case 90:
        return [x1, pageHeight - y1, height, width];
      case 180:
        return [x2, pageHeight - y1, width, height];
      case 270:
        return [x2, pageHeight - y2, height, width];
      default:
        throw new Error("Invalid rotation");
    }
  }
  onceAdded() {}
  isEmpty() {
    return false;
  }
  enableEditMode() {
    this.#isInEditMode = true;
  }
  disableEditMode() {
    this.#isInEditMode = false;
  }
  isInEditMode() {
    return this.#isInEditMode;
  }
  shouldGetKeyboardEvents() {
    return false;
  }
  needsToBeRebuilt() {
    return this.div && !this.isAttachedToDOM;
  }
  rebuild() {
    this.div?.addEventListener("focusin", this.#boundFocusin);
    this.div?.addEventListener("focusout", this.#boundFocusout);
  }
  serialize() {
    let isForCopying = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    (0, _util.unreachable)("An editor must be serializable");
  }
  static deserialize(data, parent, uiManager) {
    const editor = new this.prototype.constructor({
      parent,
      id: parent.getNextId(),
      uiManager
    });
    editor.rotation = data.rotation;
    const [pageWidth, pageHeight] = editor.pageDimensions;
    const [x, y, width, height] = editor.getRectInCurrentCoords(data.rect, pageHeight);
    editor.x = x / pageWidth;
    editor.y = y / pageHeight;
    editor.width = width / pageWidth;
    editor.height = height / pageHeight;
    return editor;
  }
  remove() {
    this.div.removeEventListener("focusin", this.#boundFocusin);
    this.div.removeEventListener("focusout", this.#boundFocusout);
    if (!this.isEmpty()) {
      this.commit();
    }
    if (this.parent) {
      this.parent.remove(this);
    } else {
      this._uiManager.removeEditor(this);
    }
    this.#altTextButton?.remove();
    this.#altTextButton = null;
    this.#altTextTooltip = null;
  }
  get isResizable() {
    return false;
  }
  makeResizable() {
    if (this.isResizable) {
      this.#createResizers();
      this.#resizersDiv.classList.remove("hidden");
    }
  }
  select() {
    this.makeResizable();
    this.div?.classList.add("selectedEditor");
  }
  unselect() {
    this.#resizersDiv?.classList.add("hidden");
    this.div?.classList.remove("selectedEditor");
    if (this.div?.contains(document.activeElement)) {
      this._uiManager.currentLayer.div.focus();
    }
  }
  updateParams(type, value) {}
  disableEditing() {
    if (this.#altTextButton) {
      this.#altTextButton.hidden = true;
    }
  }
  enableEditing() {
    if (this.#altTextButton) {
      this.#altTextButton.hidden = false;
    }
  }
  enterInEditMode() {}
  get contentDiv() {
    return this.div;
  }
  get isEditing() {
    return this.#isEditing;
  }
  set isEditing(value) {
    this.#isEditing = value;
    if (!this.parent) {
      return;
    }
    if (value) {
      this.parent.setSelected(this);
      this.parent.setActiveEditor(this);
    } else {
      this.parent.setActiveEditor(null);
    }
  }
  setAspectRatio(width, height) {
    this.#keepAspectRatio = true;
    const aspectRatio = width / height;
    const {
      style
    } = this.div;
    style.aspectRatio = aspectRatio;
    style.height = "auto";
  }
  static get MIN_SIZE() {
    return 16;
  }
}
exports.AnnotationEditor = AnnotationEditor;
class FakeEditor extends AnnotationEditor {
  constructor(params) {
    super(params);
    this.annotationElementId = params.annotationElementId;
    this.deleted = true;
  }
  serialize() {
    return {
      id: this.annotationElementId,
      deleted: true,
      pageIndex: this.pageIndex
    };
  }
}

/***/ }),
/* 165 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.KeyboardManager = exports.CommandManager = exports.ColorManager = exports.AnnotationEditorUIManager = void 0;
exports.bindEvents = bindEvents;
exports.opacityToHex = opacityToHex;
__w_pdfjs_require__(93);
__w_pdfjs_require__(101);
__w_pdfjs_require__(102);
__w_pdfjs_require__(105);
__w_pdfjs_require__(107);
__w_pdfjs_require__(109);
__w_pdfjs_require__(113);
__w_pdfjs_require__(116);
__w_pdfjs_require__(123);
__w_pdfjs_require__(2);
__w_pdfjs_require__(89);
__w_pdfjs_require__(125);
__w_pdfjs_require__(136);
__w_pdfjs_require__(138);
__w_pdfjs_require__(141);
__w_pdfjs_require__(143);
__w_pdfjs_require__(145);
__w_pdfjs_require__(147);
__w_pdfjs_require__(166);
var _util = __w_pdfjs_require__(1);
var _display_utils = __w_pdfjs_require__(168);
function bindEvents(obj, element, names) {
  for (const name of names) {
    element.addEventListener(name, obj[name].bind(obj));
  }
}
function opacityToHex(opacity) {
  return Math.round(Math.min(255, Math.max(1, 255 * opacity))).toString(16).padStart(2, "0");
}
class IdManager {
  #id = 0;
  getId() {
    return `${_util.AnnotationEditorPrefix}${this.#id++}`;
  }
}
class ImageManager {
  #baseId = (0, _util.getUuid)();
  #id = 0;
  #cache = null;
  static get _isSVGFittingCanvas() {
    const svg = `data:image/svg+xml;charset=UTF-8,<svg viewBox="0 0 1 1" width="1" height="1" xmlns="http://www.w3.org/2000/svg"><rect width="1" height="1" style="fill:red;"/></svg>`;
    const canvas = new OffscreenCanvas(1, 3);
    const ctx = canvas.getContext("2d");
    const image = new Image();
    image.src = svg;
    const promise = image.decode().then(() => {
      ctx.drawImage(image, 0, 0, 1, 1, 0, 0, 1, 3);
      return new Uint32Array(ctx.getImageData(0, 0, 1, 1).data.buffer)[0] === 0;
    });
    return (0, _util.shadow)(this, "_isSVGFittingCanvas", promise);
  }
  async #get(key, rawData) {
    this.#cache ||= new Map();
    let data = this.#cache.get(key);
    if (data === null) {
      return null;
    }
    if (data?.bitmap) {
      data.refCounter += 1;
      return data;
    }
    try {
      data ||= {
        bitmap: null,
        id: `image_${this.#baseId}_${this.#id++}`,
        refCounter: 0,
        isSvg: false
      };
      let image;
      if (typeof rawData === "string") {
        data.url = rawData;
        const response = await fetch(rawData);
        if (!response.ok) {
          throw new Error(response.statusText);
        }
        image = await response.blob();
      } else {
        image = data.file = rawData;
      }
      if (image.type === "image/svg+xml") {
        const mustRemoveAspectRatioPromise = ImageManager._isSVGFittingCanvas;
        const fileReader = new FileReader();
        const imageElement = new Image();
        const imagePromise = new Promise((resolve, reject) => {
          imageElement.onload = () => {
            data.bitmap = imageElement;
            data.isSvg = true;
            resolve();
          };
          fileReader.onload = async () => {
            const url = data.svgUrl = fileReader.result;
            imageElement.src = (await mustRemoveAspectRatioPromise) ? `${url}#svgView(preserveAspectRatio(none))` : url;
          };
          imageElement.onerror = fileReader.onerror = reject;
        });
        fileReader.readAsDataURL(image);
        await imagePromise;
      } else {
        data.bitmap = await createImageBitmap(image);
      }
      data.refCounter = 1;
    } catch (e) {
      console.error(e);
      data = null;
    }
    this.#cache.set(key, data);
    if (data) {
      this.#cache.set(data.id, data);
    }
    return data;
  }
  async getFromFile(file) {
    const {
      lastModified,
      name,
      size,
      type
    } = file;
    return this.#get(`${lastModified}_${name}_${size}_${type}`, file);
  }
  async getFromUrl(url) {
    return this.#get(url, url);
  }
  async getFromId(id) {
    this.#cache ||= new Map();
    const data = this.#cache.get(id);
    if (!data) {
      return null;
    }
    if (data.bitmap) {
      data.refCounter += 1;
      return data;
    }
    if (data.file) {
      return this.getFromFile(data.file);
    }
    return this.getFromUrl(data.url);
  }
  getSvgUrl(id) {
    const data = this.#cache.get(id);
    if (!data?.isSvg) {
      return null;
    }
    return data.svgUrl;
  }
  deleteId(id) {
    this.#cache ||= new Map();
    const data = this.#cache.get(id);
    if (!data) {
      return;
    }
    data.refCounter -= 1;
    if (data.refCounter !== 0) {
      return;
    }
    data.bitmap = null;
  }
  isValidId(id) {
    return id.startsWith(`image_${this.#baseId}_`);
  }
}
class CommandManager {
  #commands = [];
  #locked = false;
  #maxSize;
  #position = -1;
  constructor() {
    let maxSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 128;
    this.#maxSize = maxSize;
  }
  add(_ref) {
    let {
      cmd,
      undo,
      mustExec,
      type = NaN,
      overwriteIfSameType = false,
      keepUndo = false
    } = _ref;
    if (mustExec) {
      cmd();
    }
    if (this.#locked) {
      return;
    }
    const save = {
      cmd,
      undo,
      type
    };
    if (this.#position === -1) {
      if (this.#commands.length > 0) {
        this.#commands.length = 0;
      }
      this.#position = 0;
      this.#commands.push(save);
      return;
    }
    if (overwriteIfSameType && this.#commands[this.#position].type === type) {
      if (keepUndo) {
        save.undo = this.#commands[this.#position].undo;
      }
      this.#commands[this.#position] = save;
      return;
    }
    const next = this.#position + 1;
    if (next === this.#maxSize) {
      this.#commands.splice(0, 1);
    } else {
      this.#position = next;
      if (next < this.#commands.length) {
        this.#commands.splice(next);
      }
    }
    this.#commands.push(save);
  }
  undo() {
    if (this.#position === -1) {
      return;
    }
    this.#locked = true;
    this.#commands[this.#position].undo();
    this.#locked = false;
    this.#position -= 1;
  }
  redo() {
    if (this.#position < this.#commands.length - 1) {
      this.#position += 1;
      this.#locked = true;
      this.#commands[this.#position].cmd();
      this.#locked = false;
    }
  }
  hasSomethingToUndo() {
    return this.#position !== -1;
  }
  hasSomethingToRedo() {
    return this.#position < this.#commands.length - 1;
  }
  destroy() {
    this.#commands = null;
  }
}
exports.CommandManager = CommandManager;
class KeyboardManager {
  constructor(callbacks) {
    this.buffer = [];
    this.callbacks = new Map();
    this.allKeys = new Set();
    const {
      isMac
    } = _util.FeatureTest.platform;
    for (const [keys, callback, options = {}] of callbacks) {
      for (const key of keys) {
        const isMacKey = key.startsWith("mac+");
        if (isMac && isMacKey) {
          this.callbacks.set(key.slice(4), {
            callback,
            options
          });
          this.allKeys.add(key.split("+").at(-1));
        } else if (!isMac && !isMacKey) {
          this.callbacks.set(key, {
            callback,
            options
          });
          this.allKeys.add(key.split("+").at(-1));
        }
      }
    }
  }
  #serialize(event) {
    if (event.altKey) {
      this.buffer.push("alt");
    }
    if (event.ctrlKey) {
      this.buffer.push("ctrl");
    }
    if (event.metaKey) {
      this.buffer.push("meta");
    }
    if (event.shiftKey) {
      this.buffer.push("shift");
    }
    this.buffer.push(event.key);
    const str = this.buffer.join("+");
    this.buffer.length = 0;
    return str;
  }
  exec(self, event) {
    if (!this.allKeys.has(event.key)) {
      return;
    }
    const info = this.callbacks.get(this.#serialize(event));
    if (!info) {
      return;
    }
    const {
      callback,
      options: {
        bubbles = false,
        args = [],
        checker = null
      }
    } = info;
    if (checker && !checker(self, event)) {
      return;
    }
    callback.bind(self, ...args)();
    if (!bubbles) {
      event.stopPropagation();
      event.preventDefault();
    }
  }
}
exports.KeyboardManager = KeyboardManager;
class ColorManager {
  static _colorsMapping = new Map([["CanvasText", [0, 0, 0]], ["Canvas", [255, 255, 255]]]);
  get _colors() {
    const colors = new Map([["CanvasText", null], ["Canvas", null]]);
    (0, _display_utils.getColorValues)(colors);
    return (0, _util.shadow)(this, "_colors", colors);
  }
  convert(color) {
    const rgb = (0, _display_utils.getRGB)(color);
    if (!window.matchMedia("(forced-colors: active)").matches) {
      return rgb;
    }
    for (const [name, RGB] of this._colors) {
      if (RGB.every((x, i) => x === rgb[i])) {
        return ColorManager._colorsMapping.get(name);
      }
    }
    return rgb;
  }
  getHexCode(name) {
    const rgb = this._colors.get(name);
    if (!rgb) {
      return name;
    }
    return _util.Util.makeHexColor(...rgb);
  }
}
exports.ColorManager = ColorManager;
class AnnotationEditorUIManager {
  #activeEditor = null;
  #allEditors = new Map();
  #allLayers = new Map();
  #altTextManager = null;
  #annotationStorage = null;
  #commandManager = new CommandManager();
  #currentPageIndex = 0;
  #deletedAnnotationsElementIds = new Set();
  #draggingEditors = null;
  #editorTypes = null;
  #editorsToRescale = new Set();
  #filterFactory = null;
  #idManager = new IdManager();
  #isEnabled = false;
  #isWaiting = false;
  #lastActiveElement = null;
  #mode = _util.AnnotationEditorType.NONE;
  #selectedEditors = new Set();
  #pageColors = null;
  #boundBlur = this.blur.bind(this);
  #boundFocus = this.focus.bind(this);
  #boundCopy = this.copy.bind(this);
  #boundCut = this.cut.bind(this);
  #boundPaste = this.paste.bind(this);
  #boundKeydown = this.keydown.bind(this);
  #boundOnEditingAction = this.onEditingAction.bind(this);
  #boundOnPageChanging = this.onPageChanging.bind(this);
  #boundOnScaleChanging = this.onScaleChanging.bind(this);
  #boundOnRotationChanging = this.onRotationChanging.bind(this);
  #previousStates = {
    isEditing: false,
    isEmpty: true,
    hasSomethingToUndo: false,
    hasSomethingToRedo: false,
    hasSelectedEditor: false
  };
  #translation = [0, 0];
  #translationTimeoutId = null;
  #container = null;
  #viewer = null;
  static TRANSLATE_SMALL = 1;
  static TRANSLATE_BIG = 10;
  static get _keyboardManager() {
    const proto = AnnotationEditorUIManager.prototype;
    const arrowChecker = self => {
      const {
        activeElement
      } = document;
      return activeElement && self.#container.contains(activeElement) && self.hasSomethingToControl();
    };
    const small = this.TRANSLATE_SMALL;
    const big = this.TRANSLATE_BIG;
    return (0, _util.shadow)(this, "_keyboardManager", new KeyboardManager([[["ctrl+a", "mac+meta+a"], proto.selectAll], [["ctrl+z", "mac+meta+z"], proto.undo], [["ctrl+y", "ctrl+shift+z", "mac+meta+shift+z", "ctrl+shift+Z", "mac+meta+shift+Z"], proto.redo], [["Backspace", "alt+Backspace", "ctrl+Backspace", "shift+Backspace", "mac+Backspace", "mac+alt+Backspace", "mac+ctrl+Backspace", "Delete", "ctrl+Delete", "shift+Delete", "mac+Delete"], proto.delete], [["Escape", "mac+Escape"], proto.unselectAll], [["ArrowLeft", "mac+ArrowLeft"], proto.translateSelectedEditors, {
      args: [-small, 0],
      checker: arrowChecker
    }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], proto.translateSelectedEditors, {
      args: [-big, 0],
      checker: arrowChecker
    }], [["ArrowRight", "mac+ArrowRight"], proto.translateSelectedEditors, {
      args: [small, 0],
      checker: arrowChecker
    }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], proto.translateSelectedEditors, {
      args: [big, 0],
      checker: arrowChecker
    }], [["ArrowUp", "mac+ArrowUp"], proto.translateSelectedEditors, {
      args: [0, -small],
      checker: arrowChecker
    }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], proto.translateSelectedEditors, {
      args: [0, -big],
      checker: arrowChecker
    }], [["ArrowDown", "mac+ArrowDown"], proto.translateSelectedEditors, {
      args: [0, small],
      checker: arrowChecker
    }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], proto.translateSelectedEditors, {
      args: [0, big],
      checker: arrowChecker
    }]]));
  }
  constructor(container, viewer, altTextManager, eventBus, pdfDocument, pageColors) {
    this.#container = container;
    this.#viewer = viewer;
    this.#altTextManager = altTextManager;
    this._eventBus = eventBus;
    this._eventBus._on("editingaction", this.#boundOnEditingAction);
    this._eventBus._on("pagechanging", this.#boundOnPageChanging);
    this._eventBus._on("scalechanging", this.#boundOnScaleChanging);
    this._eventBus._on("rotationchanging", this.#boundOnRotationChanging);
    this.#annotationStorage = pdfDocument.annotationStorage;
    this.#filterFactory = pdfDocument.filterFactory;
    this.#pageColors = pageColors;
    this.viewParameters = {
      realScale: _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS,
      rotation: 0
    };
  }
  destroy() {
    this.#removeKeyboardManager();
    this.#removeFocusManager();
    this._eventBus._off("editingaction", this.#boundOnEditingAction);
    this._eventBus._off("pagechanging", this.#boundOnPageChanging);
    this._eventBus._off("scalechanging", this.#boundOnScaleChanging);
    this._eventBus._off("rotationchanging", this.#boundOnRotationChanging);
    for (const layer of this.#allLayers.values()) {
      layer.destroy();
    }
    this.#allLayers.clear();
    this.#allEditors.clear();
    this.#editorsToRescale.clear();
    this.#activeEditor = null;
    this.#selectedEditors.clear();
    this.#commandManager.destroy();
    this.#altTextManager.destroy();
  }
  get hcmFilter() {
    return (0, _util.shadow)(this, "hcmFilter", this.#pageColors ? this.#filterFactory.addHCMFilter(this.#pageColors.foreground, this.#pageColors.background) : "none");
  }
  get direction() {
    return (0, _util.shadow)(this, "direction", getComputedStyle(this.#container).direction);
  }
  editAltText(editor) {
    this.#altTextManager?.editAltText(this, editor);
  }
  onPageChanging(_ref2) {
    let {
      pageNumber
    } = _ref2;
    this.#currentPageIndex = pageNumber - 1;
  }
  focusMainContainer() {
    this.#container.focus();
  }
  findParent(x, y) {
    for (const layer of this.#allLayers.values()) {
      const {
        x: layerX,
        y: layerY,
        width,
        height
      } = layer.div.getBoundingClientRect();
      if (x >= layerX && x <= layerX + width && y >= layerY && y <= layerY + height) {
        return layer;
      }
    }
    return null;
  }
  disableUserSelect() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    this.#viewer.classList.toggle("noUserSelect", value);
  }
  addShouldRescale(editor) {
    this.#editorsToRescale.add(editor);
  }
  removeShouldRescale(editor) {
    this.#editorsToRescale.delete(editor);
  }
  onScaleChanging(_ref3) {
    let {
      scale
    } = _ref3;
    this.commitOrRemove();
    this.viewParameters.realScale = scale * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS;
    for (const editor of this.#editorsToRescale) {
      editor.onScaleChanging();
    }
  }
  onRotationChanging(_ref4) {
    let {
      pagesRotation
    } = _ref4;
    this.commitOrRemove();
    this.viewParameters.rotation = pagesRotation;
  }
  addToAnnotationStorage(editor) {
    if (!editor.isEmpty() && this.#annotationStorage && !this.#annotationStorage.has(editor.id)) {
      this.#annotationStorage.setValue(editor.id, editor);
    }
  }
  #addFocusManager() {
    window.addEventListener("focus", this.#boundFocus);
    window.addEventListener("blur", this.#boundBlur);
  }
  #removeFocusManager() {
    window.removeEventListener("focus", this.#boundFocus);
    window.removeEventListener("blur", this.#boundBlur);
  }
  blur() {
    if (!this.hasSelection) {
      return;
    }
    const {
      activeElement
    } = document;
    for (const editor of this.#selectedEditors) {
      if (editor.div.contains(activeElement)) {
        this.#lastActiveElement = [editor, activeElement];
        editor._focusEventsAllowed = false;
        break;
      }
    }
  }
  focus() {
    if (!this.#lastActiveElement) {
      return;
    }
    const [lastEditor, lastActiveElement] = this.#lastActiveElement;
    this.#lastActiveElement = null;
    lastActiveElement.addEventListener("focusin", () => {
      lastEditor._focusEventsAllowed = true;
    }, {
      once: true
    });
    lastActiveElement.focus();
  }
  #addKeyboardManager() {
    window.addEventListener("keydown", this.#boundKeydown, {
      capture: true
    });
  }
  #removeKeyboardManager() {
    window.removeEventListener("keydown", this.#boundKeydown, {
      capture: true
    });
  }
  #addCopyPasteListeners() {
    document.addEventListener("copy", this.#boundCopy);
    document.addEventListener("cut", this.#boundCut);
    document.addEventListener("paste", this.#boundPaste);
  }
  #removeCopyPasteListeners() {
    document.removeEventListener("copy", this.#boundCopy);
    document.removeEventListener("cut", this.#boundCut);
    document.removeEventListener("paste", this.#boundPaste);
  }
  addEditListeners() {
    this.#addKeyboardManager();
    this.#addCopyPasteListeners();
  }
  removeEditListeners() {
    this.#removeKeyboardManager();
    this.#removeCopyPasteListeners();
  }
  copy(event) {
    event.preventDefault();
    this.#activeEditor?.commitOrRemove();
    if (!this.hasSelection) {
      return;
    }
    const editors = [];
    for (const editor of this.#selectedEditors) {
      const serialized = editor.serialize(true);
      if (serialized) {
        editors.push(serialized);
      }
    }
    if (editors.length === 0) {
      return;
    }
    event.clipboardData.setData("application/pdfjs", JSON.stringify(editors));
  }
  cut(event) {
    this.copy(event);
    this.delete();
  }
  paste(event) {
    event.preventDefault();
    const {
      clipboardData
    } = event;
    for (const item of clipboardData.items) {
      for (const editorType of this.#editorTypes) {
        if (editorType.isHandlingMimeForPasting(item.type)) {
          editorType.paste(item, this.currentLayer);
          return;
        }
      }
    }
    let data = clipboardData.getData("application/pdfjs");
    if (!data) {
      return;
    }
    try {
      data = JSON.parse(data);
    } catch (ex) {
      (0, _util.warn)(`paste: "${ex.message}".`);
      return;
    }
    if (!Array.isArray(data)) {
      return;
    }
    this.unselectAll();
    const layer = this.currentLayer;
    try {
      const newEditors = [];
      for (const editor of data) {
        const deserializedEditor = layer.deserialize(editor);
        if (!deserializedEditor) {
          return;
        }
        newEditors.push(deserializedEditor);
      }
      const cmd = () => {
        for (const editor of newEditors) {
          this.#addEditorToLayer(editor);
        }
        this.#selectEditors(newEditors);
      };
      const undo = () => {
        for (const editor of newEditors) {
          editor.remove();
        }
      };
      this.addCommands({
        cmd,
        undo,
        mustExec: true
      });
    } catch (ex) {
      (0, _util.warn)(`paste: "${ex.message}".`);
    }
  }
  keydown(event) {
    if (!this.getActive()?.shouldGetKeyboardEvents()) {
      AnnotationEditorUIManager._keyboardManager.exec(this, event);
    }
  }
  onEditingAction(details) {
    if (["undo", "redo", "delete", "selectAll"].includes(details.name)) {
      this[details.name]();
    }
  }
  #dispatchUpdateStates(details) {
    const hasChanged = Object.entries(details).some(_ref5 => {
      let [key, value] = _ref5;
      return this.#previousStates[key] !== value;
    });
    if (hasChanged) {
      this._eventBus.dispatch("annotationeditorstateschanged", {
        source: this,
        details: Object.assign(this.#previousStates, details)
      });
    }
  }
  #dispatchUpdateUI(details) {
    this._eventBus.dispatch("annotationeditorparamschanged", {
      source: this,
      details
    });
  }
  setEditingState(isEditing) {
    if (isEditing) {
      this.#addFocusManager();
      this.#addKeyboardManager();
      this.#addCopyPasteListeners();
      this.#dispatchUpdateStates({
        isEditing: this.#mode !== _util.AnnotationEditorType.NONE,
        isEmpty: this.#isEmpty(),
        hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
        hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
        hasSelectedEditor: false
      });
    } else {
      this.#removeFocusManager();
      this.#removeKeyboardManager();
      this.#removeCopyPasteListeners();
      this.#dispatchUpdateStates({
        isEditing: false
      });
      this.disableUserSelect(false);
    }
  }
  registerEditorTypes(types) {
    if (this.#editorTypes) {
      return;
    }
    this.#editorTypes = types;
    for (const editorType of this.#editorTypes) {
      this.#dispatchUpdateUI(editorType.defaultPropertiesToUpdate);
    }
  }
  getId() {
    return this.#idManager.getId();
  }
  get currentLayer() {
    return this.#allLayers.get(this.#currentPageIndex);
  }
  getLayer(pageIndex) {
    return this.#allLayers.get(pageIndex);
  }
  get currentPageIndex() {
    return this.#currentPageIndex;
  }
  addLayer(layer) {
    this.#allLayers.set(layer.pageIndex, layer);
    if (this.#isEnabled) {
      layer.enable();
    } else {
      layer.disable();
    }
  }
  removeLayer(layer) {
    this.#allLayers.delete(layer.pageIndex);
  }
  updateMode(mode) {
    let editId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (this.#mode === mode) {
      return;
    }
    this.#mode = mode;
    if (mode === _util.AnnotationEditorType.NONE) {
      this.setEditingState(false);
      this.#disableAll();
      return;
    }
    this.setEditingState(true);
    this.#enableAll();
    this.unselectAll();
    for (const layer of this.#allLayers.values()) {
      layer.updateMode(mode);
    }
    if (!editId) {
      return;
    }
    for (const editor of this.#allEditors.values()) {
      if (editor.annotationElementId === editId) {
        this.setSelected(editor);
        editor.enterInEditMode();
        break;
      }
    }
  }
  updateToolbar(mode) {
    if (mode === this.#mode) {
      return;
    }
    this._eventBus.dispatch("switchannotationeditormode", {
      source: this,
      mode
    });
  }
  updateParams(type, value) {
    if (!this.#editorTypes) {
      return;
    }
    if (type === _util.AnnotationEditorParamsType.CREATE) {
      this.currentLayer.addNewEditor(type);
      return;
    }
    for (const editor of this.#selectedEditors) {
      editor.updateParams(type, value);
    }
    for (const editorType of this.#editorTypes) {
      editorType.updateDefaultParams(type, value);
    }
  }
  enableWaiting() {
    let mustWait = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (this.#isWaiting === mustWait) {
      return;
    }
    this.#isWaiting = mustWait;
    for (const layer of this.#allLayers.values()) {
      if (mustWait) {
        layer.disableClick();
      } else {
        layer.enableClick();
      }
      layer.div.classList.toggle("waiting", mustWait);
    }
  }
  #enableAll() {
    if (!this.#isEnabled) {
      this.#isEnabled = true;
      for (const layer of this.#allLayers.values()) {
        layer.enable();
      }
    }
  }
  #disableAll() {
    this.unselectAll();
    if (this.#isEnabled) {
      this.#isEnabled = false;
      for (const layer of this.#allLayers.values()) {
        layer.disable();
      }
    }
  }
  getEditors(pageIndex) {
    const editors = [];
    for (const editor of this.#allEditors.values()) {
      if (editor.pageIndex === pageIndex) {
        editors.push(editor);
      }
    }
    return editors;
  }
  getEditor(id) {
    return this.#allEditors.get(id);
  }
  addEditor(editor) {
    this.#allEditors.set(editor.id, editor);
  }
  removeEditor(editor) {
    this.#allEditors.delete(editor.id);
    this.unselect(editor);
    if (!editor.annotationElementId || !this.#deletedAnnotationsElementIds.has(editor.annotationElementId)) {
      this.#annotationStorage?.remove(editor.id);
    }
  }
  addDeletedAnnotationElement(editor) {
    this.#deletedAnnotationsElementIds.add(editor.annotationElementId);
    editor.deleted = true;
  }
  isDeletedAnnotationElement(annotationElementId) {
    return this.#deletedAnnotationsElementIds.has(annotationElementId);
  }
  removeDeletedAnnotationElement(editor) {
    this.#deletedAnnotationsElementIds.delete(editor.annotationElementId);
    editor.deleted = false;
  }
  #addEditorToLayer(editor) {
    const layer = this.#allLayers.get(editor.pageIndex);
    if (layer) {
      layer.addOrRebuild(editor);
    } else {
      this.addEditor(editor);
    }
  }
  setActiveEditor(editor) {
    if (this.#activeEditor === editor) {
      return;
    }
    this.#activeEditor = editor;
    if (editor) {
      this.#dispatchUpdateUI(editor.propertiesToUpdate);
    }
  }
  toggleSelected(editor) {
    if (this.#selectedEditors.has(editor)) {
      this.#selectedEditors.delete(editor);
      editor.unselect();
      this.#dispatchUpdateStates({
        hasSelectedEditor: this.hasSelection
      });
      return;
    }
    this.#selectedEditors.add(editor);
    editor.select();
    this.#dispatchUpdateUI(editor.propertiesToUpdate);
    this.#dispatchUpdateStates({
      hasSelectedEditor: true
    });
  }
  setSelected(editor) {
    for (const ed of this.#selectedEditors) {
      if (ed !== editor) {
        ed.unselect();
      }
    }
    this.#selectedEditors.clear();
    this.#selectedEditors.add(editor);
    editor.select();
    this.#dispatchUpdateUI(editor.propertiesToUpdate);
    this.#dispatchUpdateStates({
      hasSelectedEditor: true
    });
  }
  isSelected(editor) {
    return this.#selectedEditors.has(editor);
  }
  unselect(editor) {
    editor.unselect();
    this.#selectedEditors.delete(editor);
    this.#dispatchUpdateStates({
      hasSelectedEditor: this.hasSelection
    });
  }
  get hasSelection() {
    return this.#selectedEditors.size !== 0;
  }
  undo() {
    this.#commandManager.undo();
    this.#dispatchUpdateStates({
      hasSomethingToUndo: this.#commandManager.hasSomethingToUndo(),
      hasSomethingToRedo: true,
      isEmpty: this.#isEmpty()
    });
  }
  redo() {
    this.#commandManager.redo();
    this.#dispatchUpdateStates({
      hasSomethingToUndo: true,
      hasSomethingToRedo: this.#commandManager.hasSomethingToRedo(),
      isEmpty: this.#isEmpty()
    });
  }
  addCommands(params) {
    this.#commandManager.add(params);
    this.#dispatchUpdateStates({
      hasSomethingToUndo: true,
      hasSomethingToRedo: false,
      isEmpty: this.#isEmpty()
    });
  }
  #isEmpty() {
    if (this.#allEditors.size === 0) {
      return true;
    }
    if (this.#allEditors.size === 1) {
      for (const editor of this.#allEditors.values()) {
        return editor.isEmpty();
      }
    }
    return false;
  }
  delete() {
    this.commitOrRemove();
    if (!this.hasSelection) {
      return;
    }
    const editors = [...this.#selectedEditors];
    const cmd = () => {
      for (const editor of editors) {
        editor.remove();
      }
    };
    const undo = () => {
      for (const editor of editors) {
        this.#addEditorToLayer(editor);
      }
    };
    this.addCommands({
      cmd,
      undo,
      mustExec: true
    });
  }
  commitOrRemove() {
    this.#activeEditor?.commitOrRemove();
  }
  hasSomethingToControl() {
    return this.#activeEditor || this.hasSelection;
  }
  #selectEditors(editors) {
    this.#selectedEditors.clear();
    for (const editor of editors) {
      if (editor.isEmpty()) {
        continue;
      }
      this.#selectedEditors.add(editor);
      editor.select();
    }
    this.#dispatchUpdateStates({
      hasSelectedEditor: true
    });
  }
  selectAll() {
    for (const editor of this.#selectedEditors) {
      editor.commit();
    }
    this.#selectEditors(this.#allEditors.values());
  }
  unselectAll() {
    if (this.#activeEditor) {
      this.#activeEditor.commitOrRemove();
      return;
    }
    if (!this.hasSelection) {
      return;
    }
    for (const editor of this.#selectedEditors) {
      editor.unselect();
    }
    this.#selectedEditors.clear();
    this.#dispatchUpdateStates({
      hasSelectedEditor: false
    });
  }
  translateSelectedEditors(x, y) {
    let noCommit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!noCommit) {
      this.commitOrRemove();
    }
    if (!this.hasSelection) {
      return;
    }
    this.#translation[0] += x;
    this.#translation[1] += y;
    const [totalX, totalY] = this.#translation;
    const editors = [...this.#selectedEditors];
    const TIME_TO_WAIT = 1000;
    if (this.#translationTimeoutId) {
      clearTimeout(this.#translationTimeoutId);
    }
    this.#translationTimeoutId = setTimeout(() => {
      this.#translationTimeoutId = null;
      this.#translation[0] = this.#translation[1] = 0;
      this.addCommands({
        cmd: () => {
          for (const editor of editors) {
            if (this.#allEditors.has(editor.id)) {
              editor.translateInPage(totalX, totalY);
            }
          }
        },
        undo: () => {
          for (const editor of editors) {
            if (this.#allEditors.has(editor.id)) {
              editor.translateInPage(-totalX, -totalY);
            }
          }
        },
        mustExec: false
      });
    }, TIME_TO_WAIT);
    for (const editor of editors) {
      editor.translateInPage(x, y);
    }
  }
  setUpDragSession() {
    if (!this.hasSelection) {
      return;
    }
    this.disableUserSelect(true);
    this.#draggingEditors = new Map();
    for (const editor of this.#selectedEditors) {
      this.#draggingEditors.set(editor, {
        savedX: editor.x,
        savedY: editor.y,
        savedPageIndex: editor.pageIndex,
        newX: 0,
        newY: 0,
        newPageIndex: -1
      });
    }
  }
  endDragSession() {
    if (!this.#draggingEditors) {
      return false;
    }
    this.disableUserSelect(false);
    const map = this.#draggingEditors;
    this.#draggingEditors = null;
    let mustBeAddedInUndoStack = false;
    for (const [{
      x,
      y,
      pageIndex
    }, value] of map) {
      value.newX = x;
      value.newY = y;
      value.newPageIndex = pageIndex;
      mustBeAddedInUndoStack ||= x !== value.savedX || y !== value.savedY || pageIndex !== value.savedPageIndex;
    }
    if (!mustBeAddedInUndoStack) {
      return false;
    }
    const move = (editor, x, y, pageIndex) => {
      if (this.#allEditors.has(editor.id)) {
        const parent = this.#allLayers.get(pageIndex);
        if (parent) {
          editor._setParentAndPosition(parent, x, y);
        } else {
          editor.pageIndex = pageIndex;
          editor.x = x;
          editor.y = y;
        }
      }
    };
    this.addCommands({
      cmd: () => {
        for (const [editor, {
          newX,
          newY,
          newPageIndex
        }] of map) {
          move(editor, newX, newY, newPageIndex);
        }
      },
      undo: () => {
        for (const [editor, {
          savedX,
          savedY,
          savedPageIndex
        }] of map) {
          move(editor, savedX, savedY, savedPageIndex);
        }
      },
      mustExec: true
    });
    return true;
  }
  dragSelectedEditors(tx, ty) {
    if (!this.#draggingEditors) {
      return;
    }
    for (const editor of this.#draggingEditors.keys()) {
      editor.drag(tx, ty);
    }
  }
  rebuild(editor) {
    if (editor.parent === null) {
      const parent = this.getLayer(editor.pageIndex);
      if (parent) {
        parent.changeParent(editor);
        parent.addOrRebuild(editor);
      } else {
        this.addEditor(editor);
        this.addToAnnotationStorage(editor);
        editor.rebuild();
      }
    } else {
      editor.parent.addOrRebuild(editor);
    }
  }
  isActive(editor) {
    return this.#activeEditor === editor;
  }
  getActive() {
    return this.#activeEditor;
  }
  getMode() {
    return this.#mode;
  }
  get imageManager() {
    return (0, _util.shadow)(this, "imageManager", new ImageManager());
  }
}
exports.AnnotationEditorUIManager = AnnotationEditorUIManager;

/***/ }),
/* 166 */
/***/ ((__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__) => {


var $ = __w_pdfjs_require__(3);
var DESCRIPTORS = __w_pdfjs_require__(6);
var global = __w_pdfjs_require__(4);
var getBuiltIn = __w_pdfjs_require__(24);
var uncurryThis = __w_pdfjs_require__(14);
var call = __w_pdfjs_require__(8);
var isCallable = __w_pdfjs_require__(21);
var isObject = __w_pdfjs_require__(20);
var isArray = __w_pdfjs_require__(91);
var hasOwn = __w_pdfjs_require__(39);
var toString = __w_pdfjs_require__(77);
var lengthOfArrayLike = __w_pdfjs_require__(64);
var createProperty = __w_pdfjs_require__(159);
var fails = __w_pdfjs_require__(7);
var parseJSONString = __w_pdfjs_require__(167);
var NATIVE_SYMBOL = __w_pdfjs_require__(27);
var JSON = global.JSON;
var Number = global.Number;
var SyntaxError = global.SyntaxError;
var nativeParse = JSON && JSON.parse;
var enumerableOwnProperties = getBuiltIn('Object', 'keys');
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var at = uncurryThis(''.charAt);
var slice = uncurryThis(''.slice);
var exec = uncurryThis(/./.exec);
var push = uncurryThis([].push);
var IS_DIGIT = /^\d$/;
var IS_NON_ZERO_DIGIT = /^[1-9]$/;
var IS_NUMBER_START = /^(?:-|\d)$/;
var IS_WHITESPACE = /^[\t\n\r ]$/;
var PRIMITIVE = 0;
var OBJECT = 1;
var $parse = function (source, reviver) {
 source = toString(source);
 var context = new Context(source, 0, '');
 var root = context.parse();
 var value = root.value;
 var endIndex = context.skip(IS_WHITESPACE, root.end);
 if (endIndex < source.length) {
  throw SyntaxError('Unexpected extra character: "' + at(source, endIndex) + '" after the parsed data at: ' + endIndex);
 }
 return isCallable(reviver) ? internalize({ '': value }, '', reviver, root) : value;
};
var internalize = function (holder, name, reviver, node) {
 var val = holder[name];
 var unmodified = node && val === node.value;
 var context = unmodified && typeof node.source == 'string' ? { source: node.source } : {};
 var elementRecordsLen, keys, len, i, P;
 if (isObject(val)) {
  var nodeIsArray = isArray(val);
  var nodes = unmodified ? node.nodes : nodeIsArray ? [] : {};
  if (nodeIsArray) {
   elementRecordsLen = nodes.length;
   len = lengthOfArrayLike(val);
   for (i = 0; i < len; i++) {
    internalizeProperty(val, i, internalize(val, '' + i, reviver, i < elementRecordsLen ? nodes[i] : undefined));
   }
  } else {
   keys = enumerableOwnProperties(val);
   len = lengthOfArrayLike(keys);
   for (i = 0; i < len; i++) {
    P = keys[i];
    internalizeProperty(val, P, internalize(val, P, reviver, hasOwn(nodes, P) ? nodes[P] : undefined));
   }
  }
 }
 return call(reviver, holder, name, val, context);
};
var internalizeProperty = function (object, key, value) {
 if (DESCRIPTORS) {
  var descriptor = getOwnPropertyDescriptor(object, key);
  if (descriptor && !descriptor.configurable)
   return;
 }
 if (value === undefined)
  delete object[key];
 else
  createProperty(object, key, value);
};
var Node = function (value, end, source, nodes) {
 this.value = value;
 this.end = end;
 this.source = source;
 this.nodes = nodes;
};
var Context = function (source, index) {
 this.source = source;
 this.index = index;
};
Context.prototype = {
 fork: function (nextIndex) {
  return new Context(this.source, nextIndex);
 },
 parse: function () {
  var source = this.source;
  var i = this.skip(IS_WHITESPACE, this.index);
  var fork = this.fork(i);
  var chr = at(source, i);
  if (exec(IS_NUMBER_START, chr))
   return fork.number();
  switch (chr) {
  case '{':
   return fork.object();
  case '[':
   return fork.array();
  case '"':
   return fork.string();
  case 't':
   return fork.keyword(true);
  case 'f':
   return fork.keyword(false);
  case 'n':
   return fork.keyword(null);
  }
  throw SyntaxError('Unexpected character: "' + chr + '" at: ' + i);
 },
 node: function (type, value, start, end, nodes) {
  return new Node(value, end, type ? null : slice(this.source, start, end), nodes);
 },
 object: function () {
  var source = this.source;
  var i = this.index + 1;
  var expectKeypair = false;
  var object = {};
  var nodes = {};
  while (i < source.length) {
   i = this.until([
    '"',
    '}'
   ], i);
   if (at(source, i) === '}' && !expectKeypair) {
    i++;
    break;
   }
   var result = this.fork(i).string();
   var key = result.value;
   i = result.end;
   i = this.until([':'], i) + 1;
   i = this.skip(IS_WHITESPACE, i);
   result = this.fork(i).parse();
   createProperty(nodes, key, result);
   createProperty(object, key, result.value);
   i = this.until([
    ',',
    '}'
   ], result.end);
   var chr = at(source, i);
   if (chr === ',') {
    expectKeypair = true;
    i++;
   } else if (chr === '}') {
    i++;
    break;
   }
  }
  return this.node(OBJECT, object, this.index, i, nodes);
 },
 array: function () {
  var source = this.source;
  var i = this.index + 1;
  var expectElement = false;
  var array = [];
  var nodes = [];
  while (i < source.length) {
   i = this.skip(IS_WHITESPACE, i);
   if (at(source, i) === ']' && !expectElement) {
    i++;
    break;
   }
   var result = this.fork(i).parse();
   push(nodes, result);
   push(array, result.value);
   i = this.until([
    ',',
    ']'
   ], result.end);
   if (at(source, i) === ',') {
    expectElement = true;
    i++;
   } else if (at(source, i) === ']') {
    i++;
    break;
   }
  }
  return this.node(OBJECT, array, this.index, i, nodes);
 },
 string: function () {
  var index = this.index;
  var parsed = parseJSONString(this.source, this.index + 1);
  return this.node(PRIMITIVE, parsed.value, index, parsed.end);
 },
 number: function () {
  var source = this.source;
  var startIndex = this.index;
  var i = startIndex;
  if (at(source, i) === '-')
   i++;
  if (at(source, i) === '0')
   i++;
  else if (exec(IS_NON_ZERO_DIGIT, at(source, i)))
   i = this.skip(IS_DIGIT, ++i);
  else
   throw SyntaxError('Failed to parse number at: ' + i);
  if (at(source, i) === '.')
   i = this.skip(IS_DIGIT, ++i);
  if (at(source, i) === 'e' || at(source, i) === 'E') {
   i++;
   if (at(source, i) === '+' || at(source, i) === '-')
    i++;
   var exponentStartIndex = i;
   i = this.skip(IS_DIGIT, i);
   if (exponentStartIndex === i)
    throw SyntaxError("Failed to parse number's exponent value at: " + i);
  }
  return this.node(PRIMITIVE, Number(slice(source, startIndex, i)), startIndex, i);
 },
 keyword: function (value) {
  var keyword = '' + value;
  var index = this.index;
  var endIndex = index + keyword.length;
  if (slice(this.source, index, endIndex) !== keyword)
   throw SyntaxError('Failed to parse value at: ' + index);
  return this.node(PRIMITIVE, value, index, endIndex);
 },
 skip: function (regex, i) {
  var source = this.source;
  for (; i < source.length; i++)
   if (!exec(regex, at(source, i)))
    break;
  return i;
 },
 until: function (array, i) {
  i = this.skip(IS_WHITESPACE, i);
  var chr = at(this.source, i);
  for (var j = 0; j < array.length; j++)
   if (array[j] === chr)
    return i;
  throw SyntaxError('Unexpected character: "' + chr + '" at: ' + i);
 }
};
var NO_SOURCE_SUPPORT = fails(function () {
 var unsafeInt = '9007199254740993';
 var source;
 nativeParse(unsafeInt, function (key, value, context) {
  source = context.source;
 });
 return source !== unsafeInt;
});
var PROPER_BASE_PARSE = NATIVE_SYMBOL && !fails(function () {
 return 1 / nativeParse('-0 \t') !== -Infinity;
});
$({
 target: 'JSON',
 stat: true,
 forced: NO_SOURCE_SUPPORT
}, {
 parse: function parse(text, reviver) {
  return PROPER_BASE_PARSE && !isCallable(reviver) ? nativeParse(text) : $parse(text, reviver);
 }
});

/***/ }),
/* 167 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var uncurryThis = __w_pdfjs_require__(14);
var hasOwn = __w_pdfjs_require__(39);
var $SyntaxError = SyntaxError;
var $parseInt = parseInt;
var fromCharCode = String.fromCharCode;
var at = uncurryThis(''.charAt);
var slice = uncurryThis(''.slice);
var exec = uncurryThis(/./.exec);
var codePoints = {
 '\\"': '"',
 '\\\\': '\\',
 '\\/': '/',
 '\\b': '\b',
 '\\f': '\f',
 '\\n': '\n',
 '\\r': '\r',
 '\\t': '\t'
};
var IS_4_HEX_DIGITS = /^[\da-f]{4}$/i;
var IS_C0_CONTROL_CODE = /^[\u0000-\u001F]$/;
module.exports = function (source, i) {
 var unterminated = true;
 var value = '';
 while (i < source.length) {
  var chr = at(source, i);
  if (chr === '\\') {
   var twoChars = slice(source, i, i + 2);
   if (hasOwn(codePoints, twoChars)) {
    value += codePoints[twoChars];
    i += 2;
   } else if (twoChars === '\\u') {
    i += 2;
    var fourHexDigits = slice(source, i, i + 4);
    if (!exec(IS_4_HEX_DIGITS, fourHexDigits))
     throw $SyntaxError('Bad Unicode escape at: ' + i);
    value += fromCharCode($parseInt(fourHexDigits, 16));
    i += 4;
   } else
    throw $SyntaxError('Unknown escape sequence: "' + twoChars + '"');
  } else if (chr === '"') {
   unterminated = false;
   i++;
   break;
  } else {
   if (exec(IS_C0_CONTROL_CODE, chr))
    throw $SyntaxError('Bad control character in string literal at: ' + i);
   value += chr;
   i++;
  }
 }
 if (unterminated)
  throw $SyntaxError('Unterminated string at: ' + i);
 return {
  value: value,
  end: i
 };
};

/***/ }),
/* 168 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.StatTimer = exports.RenderingCancelledException = exports.PixelsPerInch = exports.PageViewport = exports.PDFDateString = exports.DOMStandardFontDataFactory = exports.DOMSVGFactory = exports.DOMFilterFactory = exports.DOMCanvasFactory = exports.DOMCMapReaderFactory = void 0;
exports.deprecated = deprecated;
exports.getColorValues = getColorValues;
exports.getCurrentTransform = getCurrentTransform;
exports.getCurrentTransformInverse = getCurrentTransformInverse;
exports.getFilenameFromUrl = getFilenameFromUrl;
exports.getPdfFilenameFromUrl = getPdfFilenameFromUrl;
exports.getRGB = getRGB;
exports.getXfaPageViewport = getXfaPageViewport;
exports.isDataScheme = isDataScheme;
exports.isPdfFile = isPdfFile;
exports.isValidFetchUrl = isValidFetchUrl;
exports.loadScript = loadScript;
exports.noContextMenu = noContextMenu;
exports.setLayerDimensions = setLayerDimensions;
__w_pdfjs_require__(2);
__w_pdfjs_require__(93);
__w_pdfjs_require__(101);
__w_pdfjs_require__(102);
__w_pdfjs_require__(105);
__w_pdfjs_require__(107);
__w_pdfjs_require__(109);
__w_pdfjs_require__(113);
__w_pdfjs_require__(116);
__w_pdfjs_require__(123);
__w_pdfjs_require__(89);
__w_pdfjs_require__(84);
__w_pdfjs_require__(86);
__w_pdfjs_require__(87);
var _base_factory = __w_pdfjs_require__(169);
var _util = __w_pdfjs_require__(1);
const SVG_NS = "http://www.w3.org/2000/svg";
class PixelsPerInch {
  static CSS = 96.0;
  static PDF = 72.0;
  static PDF_TO_CSS_UNITS = this.CSS / this.PDF;
}
exports.PixelsPerInch = PixelsPerInch;
class DOMFilterFactory extends _base_factory.BaseFilterFactory {
  #_cache;
  #_defs;
  #docId;
  #document;
  #hcmFilter;
  #hcmKey;
  #hcmUrl;
  #hcmHighlightFilter;
  #hcmHighlightKey;
  #hcmHighlightUrl;
  #id = 0;
  constructor() {
    let {
      docId,
      ownerDocument = globalThis.document
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super();
    this.#docId = docId;
    this.#document = ownerDocument;
  }
  get #cache() {
    return this.#_cache ||= new Map();
  }
  get #defs() {
    if (!this.#_defs) {
      const div = this.#document.createElement("div");
      const {
        style
      } = div;
      style.visibility = "hidden";
      style.contain = "strict";
      style.width = style.height = 0;
      style.position = "absolute";
      style.top = style.left = 0;
      style.zIndex = -1;
      const svg = this.#document.createElementNS(SVG_NS, "svg");
      svg.setAttribute("width", 0);
      svg.setAttribute("height", 0);
      this.#_defs = this.#document.createElementNS(SVG_NS, "defs");
      div.append(svg);
      svg.append(this.#_defs);
      this.#document.body.append(div);
    }
    return this.#_defs;
  }
  addFilter(maps) {
    if (!maps) {
      return "none";
    }
    let value = this.#cache.get(maps);
    if (value) {
      return value;
    }
    let tableR, tableG, tableB, key;
    if (maps.length === 1) {
      const mapR = maps[0];
      const buffer = new Array(256);
      for (let i = 0; i < 256; i++) {
        buffer[i] = mapR[i] / 255;
      }
      key = tableR = tableG = tableB = buffer.join(",");
    } else {
      const [mapR, mapG, mapB] = maps;
      const bufferR = new Array(256);
      const bufferG = new Array(256);
      const bufferB = new Array(256);
      for (let i = 0; i < 256; i++) {
        bufferR[i] = mapR[i] / 255;
        bufferG[i] = mapG[i] / 255;
        bufferB[i] = mapB[i] / 255;
      }
      tableR = bufferR.join(",");
      tableG = bufferG.join(",");
      tableB = bufferB.join(",");
      key = `${tableR}${tableG}${tableB}`;
    }
    value = this.#cache.get(key);
    if (value) {
      this.#cache.set(maps, value);
      return value;
    }
    const id = `g_${this.#docId}_transfer_map_${this.#id++}`;
    const url = `url(#${id})`;
    this.#cache.set(maps, url);
    this.#cache.set(key, url);
    const filter = this.#createFilter(id);
    this.#addTransferMapConversion(tableR, tableG, tableB, filter);
    return url;
  }
  addHCMFilter(fgColor, bgColor) {
    const key = `${fgColor}-${bgColor}`;
    if (this.#hcmKey === key) {
      return this.#hcmUrl;
    }
    this.#hcmKey = key;
    this.#hcmUrl = "none";
    this.#hcmFilter?.remove();
    if (!fgColor || !bgColor) {
      return this.#hcmUrl;
    }
    const fgRGB = this.#getRGB(fgColor);
    fgColor = _util.Util.makeHexColor(...fgRGB);
    const bgRGB = this.#getRGB(bgColor);
    bgColor = _util.Util.makeHexColor(...bgRGB);
    this.#defs.style.color = "";
    if (fgColor === "#000000" && bgColor === "#ffffff" || fgColor === bgColor) {
      return this.#hcmUrl;
    }
    const map = new Array(256);
    for (let i = 0; i <= 255; i++) {
      const x = i / 255;
      map[i] = x <= 0.03928 ? x / 12.92 : ((x + 0.055) / 1.055) ** 2.4;
    }
    const table = map.join(",");
    const id = `g_${this.#docId}_hcm_filter`;
    const filter = this.#hcmHighlightFilter = this.#createFilter(id);
    this.#addTransferMapConversion(table, table, table, filter);
    this.#addGrayConversion(filter);
    const getSteps = (c, n) => {
      const start = fgRGB[c] / 255;
      const end = bgRGB[c] / 255;
      const arr = new Array(n + 1);
      for (let i = 0; i <= n; i++) {
        arr[i] = start + i / n * (end - start);
      }
      return arr.join(",");
    };
    this.#addTransferMapConversion(getSteps(0, 5), getSteps(1, 5), getSteps(2, 5), filter);
    this.#hcmUrl = `url(#${id})`;
    return this.#hcmUrl;
  }
  addHighlightHCMFilter(fgColor, bgColor, newFgColor, newBgColor) {
    const key = `${fgColor}-${bgColor}-${newFgColor}-${newBgColor}`;
    if (this.#hcmHighlightKey === key) {
      return this.#hcmHighlightUrl;
    }
    this.#hcmHighlightKey = key;
    this.#hcmHighlightUrl = "none";
    this.#hcmHighlightFilter?.remove();
    if (!fgColor || !bgColor) {
      return this.#hcmHighlightUrl;
    }
    const [fgRGB, bgRGB] = [fgColor, bgColor].map(this.#getRGB.bind(this));
    let fgGray = Math.round(0.2126 * fgRGB[0] + 0.7152 * fgRGB[1] + 0.0722 * fgRGB[2]);
    let bgGray = Math.round(0.2126 * bgRGB[0] + 0.7152 * bgRGB[1] + 0.0722 * bgRGB[2]);
    let [newFgRGB, newBgRGB] = [newFgColor, newBgColor].map(this.#getRGB.bind(this));
    if (bgGray < fgGray) {
      [fgGray, bgGray, newFgRGB, newBgRGB] = [bgGray, fgGray, newBgRGB, newFgRGB];
    }
    this.#defs.style.color = "";
    const getSteps = (fg, bg, n) => {
      const arr = new Array(256);
      const step = (bgGray - fgGray) / n;
      const newStart = fg / 255;
      const newStep = (bg - fg) / (255 * n);
      let prev = 0;
      for (let i = 0; i <= n; i++) {
        const k = Math.round(fgGray + i * step);
        const value = newStart + i * newStep;
        for (let j = prev; j <= k; j++) {
          arr[j] = value;
        }
        prev = k + 1;
      }
      for (let i = prev; i < 256; i++) {
        arr[i] = arr[prev - 1];
      }
      return arr.join(",");
    };
    const id = `g_${this.#docId}_hcm_highlight_filter`;
    const filter = this.#hcmHighlightFilter = this.#createFilter(id);
    this.#addGrayConversion(filter);
    this.#addTransferMapConversion(getSteps(newFgRGB[0], newBgRGB[0], 5), getSteps(newFgRGB[1], newBgRGB[1], 5), getSteps(newFgRGB[2], newBgRGB[2], 5), filter);
    this.#hcmHighlightUrl = `url(#${id})`;
    return this.#hcmHighlightUrl;
  }
  destroy() {
    let keepHCM = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (keepHCM && (this.#hcmUrl || this.#hcmHighlightUrl)) {
      return;
    }
    if (this.#_defs) {
      this.#_defs.parentNode.parentNode.remove();
      this.#_defs = null;
    }
    if (this.#_cache) {
      this.#_cache.clear();
      this.#_cache = null;
    }
    this.#id = 0;
  }
  #addGrayConversion(filter) {
    const feColorMatrix = this.#document.createElementNS(SVG_NS, "feColorMatrix");
    feColorMatrix.setAttribute("type", "matrix");
    feColorMatrix.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0");
    filter.append(feColorMatrix);
  }
  #createFilter(id) {
    const filter = this.#document.createElementNS(SVG_NS, "filter");
    filter.setAttribute("color-interpolation-filters", "sRGB");
    filter.setAttribute("id", id);
    this.#defs.append(filter);
    return filter;
  }
  #appendFeFunc(feComponentTransfer, func, table) {
    const feFunc = this.#document.createElementNS(SVG_NS, func);
    feFunc.setAttribute("type", "discrete");
    feFunc.setAttribute("tableValues", table);
    feComponentTransfer.append(feFunc);
  }
  #addTransferMapConversion(rTable, gTable, bTable, filter) {
    const feComponentTransfer = this.#document.createElementNS(SVG_NS, "feComponentTransfer");
    filter.append(feComponentTransfer);
    this.#appendFeFunc(feComponentTransfer, "feFuncR", rTable);
    this.#appendFeFunc(feComponentTransfer, "feFuncG", gTable);
    this.#appendFeFunc(feComponentTransfer, "feFuncB", bTable);
  }
  #getRGB(color) {
    this.#defs.style.color = color;
    return getRGB(getComputedStyle(this.#defs).getPropertyValue("color"));
  }
}
exports.DOMFilterFactory = DOMFilterFactory;
class DOMCanvasFactory extends _base_factory.BaseCanvasFactory {
  constructor() {
    let {
      ownerDocument = globalThis.document
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    super();
    this._document = ownerDocument;
  }
  _createCanvas(width, height) {
    const canvas = this._document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    return canvas;
  }
}
exports.DOMCanvasFactory = DOMCanvasFactory;
async function fetchData(url) {
  let asTypedArray = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (isValidFetchUrl(url, document.baseURI)) {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(response.statusText);
    }
    return asTypedArray ? new Uint8Array(await response.arrayBuffer()) : (0, _util.stringToBytes)(await response.text());
  }
  return new Promise((resolve, reject) => {
    const request = new XMLHttpRequest();
    request.open("GET", url, true);
    if (asTypedArray) {
      request.responseType = "arraybuffer";
    }
    request.onreadystatechange = () => {
      if (request.readyState !== XMLHttpRequest.DONE) {
        return;
      }
      if (request.status === 200 || request.status === 0) {
        let data;
        if (asTypedArray && request.response) {
          data = new Uint8Array(request.response);
        } else if (!asTypedArray && request.responseText) {
          data = (0, _util.stringToBytes)(request.responseText);
        }
        if (data) {
          resolve(data);
          return;
        }
      }
      reject(new Error(request.statusText));
    };
    request.send(null);
  });
}
class DOMCMapReaderFactory extends _base_factory.BaseCMapReaderFactory {
  _fetchData(url, compressionType) {
    return fetchData(url, this.isCompressed).then(data => {
      return {
        cMapData: data,
        compressionType
      };
    });
  }
}
exports.DOMCMapReaderFactory = DOMCMapReaderFactory;
class DOMStandardFontDataFactory extends _base_factory.BaseStandardFontDataFactory {
  _fetchData(url) {
    return fetchData(url, true);
  }
}
exports.DOMStandardFontDataFactory = DOMStandardFontDataFactory;
class DOMSVGFactory extends _base_factory.BaseSVGFactory {
  _createSVG(type) {
    return document.createElementNS(SVG_NS, type);
  }
}
exports.DOMSVGFactory = DOMSVGFactory;
class PageViewport {
  constructor(_ref) {
    let {
      viewBox,
      scale,
      rotation,
      offsetX = 0,
      offsetY = 0,
      dontFlip = false
    } = _ref;
    this.viewBox = viewBox;
    this.scale = scale;
    this.rotation = rotation;
    this.offsetX = offsetX;
    this.offsetY = offsetY;
    const centerX = (viewBox[2] + viewBox[0]) / 2;
    const centerY = (viewBox[3] + viewBox[1]) / 2;
    let rotateA, rotateB, rotateC, rotateD;
    rotation %= 360;
    if (rotation < 0) {
      rotation += 360;
    }
    switch (rotation) {
      case 180:
        rotateA = -1;
        rotateB = 0;
        rotateC = 0;
        rotateD = 1;
        break;
      case 90:
        rotateA = 0;
        rotateB = 1;
        rotateC = 1;
        rotateD = 0;
        break;
      case 270:
        rotateA = 0;
        rotateB = -1;
        rotateC = -1;
        rotateD = 0;
        break;
      case 0:
        rotateA = 1;
        rotateB = 0;
        rotateC = 0;
        rotateD = -1;
        break;
      default:
        throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
    }
    if (dontFlip) {
      rotateC = -rotateC;
      rotateD = -rotateD;
    }
    let offsetCanvasX, offsetCanvasY;
    let width, height;
    if (rotateA === 0) {
      offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
      offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
      width = (viewBox[3] - viewBox[1]) * scale;
      height = (viewBox[2] - viewBox[0]) * scale;
    } else {
      offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
      offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
      width = (viewBox[2] - viewBox[0]) * scale;
      height = (viewBox[3] - viewBox[1]) * scale;
    }
    this.transform = [rotateA * scale, rotateB * scale, rotateC * scale, rotateD * scale, offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY, offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY];
    this.width = width;
    this.height = height;
  }
  get rawDims() {
    const {
      viewBox
    } = this;
    return (0, _util.shadow)(this, "rawDims", {
      pageWidth: viewBox[2] - viewBox[0],
      pageHeight: viewBox[3] - viewBox[1],
      pageX: viewBox[0],
      pageY: viewBox[1]
    });
  }
  clone() {
    let {
      scale = this.scale,
      rotation = this.rotation,
      offsetX = this.offsetX,
      offsetY = this.offsetY,
      dontFlip = false
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new PageViewport({
      viewBox: this.viewBox.slice(),
      scale,
      rotation,
      offsetX,
      offsetY,
      dontFlip
    });
  }
  convertToViewportPoint(x, y) {
    return _util.Util.applyTransform([x, y], this.transform);
  }
  convertToViewportRectangle(rect) {
    const topLeft = _util.Util.applyTransform([rect[0], rect[1]], this.transform);
    const bottomRight = _util.Util.applyTransform([rect[2], rect[3]], this.transform);
    return [topLeft[0], topLeft[1], bottomRight[0], bottomRight[1]];
  }
  convertToPdfPoint(x, y) {
    return _util.Util.applyInverseTransform([x, y], this.transform);
  }
}
exports.PageViewport = PageViewport;
class RenderingCancelledException extends _util.BaseException {
  constructor(msg) {
    let extraDelay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    super(msg, "RenderingCancelledException");
    this.extraDelay = extraDelay;
  }
}
exports.RenderingCancelledException = RenderingCancelledException;
function isDataScheme(url) {
  const ii = url.length;
  let i = 0;
  while (i < ii && url[i].trim() === "") {
    i++;
  }
  return url.substring(i, i + 5).toLowerCase() === "data:";
}
function isPdfFile(filename) {
  return typeof filename === "string" && /\.pdf$/i.test(filename);
}
function getFilenameFromUrl(url) {
  let onlyStripPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!onlyStripPath) {
    [url] = url.split(/[#?]/, 1);
  }
  return url.substring(url.lastIndexOf("/") + 1);
}
function getPdfFilenameFromUrl(url) {
  let defaultFilename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "document.pdf";
  if (typeof url !== "string") {
    return defaultFilename;
  }
  if (isDataScheme(url)) {
    (0, _util.warn)('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
    return defaultFilename;
  }
  const reURI = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
  const reFilename = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
  const splitURI = reURI.exec(url);
  let suggestedFilename = reFilename.exec(splitURI[1]) || reFilename.exec(splitURI[2]) || reFilename.exec(splitURI[3]);
  if (suggestedFilename) {
    suggestedFilename = suggestedFilename[0];
    if (suggestedFilename.includes("%")) {
      try {
        suggestedFilename = reFilename.exec(decodeURIComponent(suggestedFilename))[0];
      } catch {}
    }
  }
  return suggestedFilename || defaultFilename;
}
class StatTimer {
  started = Object.create(null);
  times = [];
  time(name) {
    if (name in this.started) {
      (0, _util.warn)(`Timer is already running for ${name}`);
    }
    this.started[name] = Date.now();
  }
  timeEnd(name) {
    if (!(name in this.started)) {
      (0, _util.warn)(`Timer has not been started for ${name}`);
    }
    this.times.push({
      name,
      start: this.started[name],
      end: Date.now()
    });
    delete this.started[name];
  }
  toString() {
    const outBuf = [];
    let longest = 0;
    for (const {
      name
    } of this.times) {
      longest = Math.max(name.length, longest);
    }
    for (const {
      name,
      start,
      end
    } of this.times) {
      outBuf.push(`${name.padEnd(longest)} ${end - start}ms\n`);
    }
    return outBuf.join("");
  }
}
exports.StatTimer = StatTimer;
function isValidFetchUrl(url, baseUrl) {
  try {
    const {
      protocol
    } = baseUrl ? new URL(url, baseUrl) : new URL(url);
    return protocol === "http:" || protocol === "https:";
  } catch {
    return false;
  }
}
function noContextMenu(e) {
  e.preventDefault();
}
function loadScript(src) {
  let removeScriptElement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = function (evt) {
      if (removeScriptElement) {
        script.remove();
      }
      resolve(evt);
    };
    script.onerror = function () {
      reject(new Error(`Cannot load script at: ${script.src}`));
    };
    (document.head || document.documentElement).append(script);
  });
}
function deprecated(details) {
  console.log("Deprecated API usage: " + details);
}
let pdfDateStringRegex;
class PDFDateString {
  static toDateObject(input) {
    if (!input || typeof input !== "string") {
      return null;
    }
    pdfDateStringRegex ||= new RegExp("^D:" + "(\\d{4})" + "(\\d{2})?" + "(\\d{2})?" + "(\\d{2})?" + "(\\d{2})?" + "(\\d{2})?" + "([Z|+|-])?" + "(\\d{2})?" + "'?" + "(\\d{2})?" + "'?");
    const matches = pdfDateStringRegex.exec(input);
    if (!matches) {
      return null;
    }
    const year = parseInt(matches[1], 10);
    let month = parseInt(matches[2], 10);
    month = month >= 1 && month <= 12 ? month - 1 : 0;
    let day = parseInt(matches[3], 10);
    day = day >= 1 && day <= 31 ? day : 1;
    let hour = parseInt(matches[4], 10);
    hour = hour >= 0 && hour <= 23 ? hour : 0;
    let minute = parseInt(matches[5], 10);
    minute = minute >= 0 && minute <= 59 ? minute : 0;
    let second = parseInt(matches[6], 10);
    second = second >= 0 && second <= 59 ? second : 0;
    const universalTimeRelation = matches[7] || "Z";
    let offsetHour = parseInt(matches[8], 10);
    offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0;
    let offsetMinute = parseInt(matches[9], 10) || 0;
    offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0;
    if (universalTimeRelation === "-") {
      hour += offsetHour;
      minute += offsetMinute;
    } else if (universalTimeRelation === "+") {
      hour -= offsetHour;
      minute -= offsetMinute;
    }
    return new Date(Date.UTC(year, month, day, hour, minute, second));
  }
}
exports.PDFDateString = PDFDateString;
function getXfaPageViewport(xfaPage, _ref2) {
  let {
    scale = 1,
    rotation = 0
  } = _ref2;
  const {
    width,
    height
  } = xfaPage.attributes.style;
  const viewBox = [0, 0, parseInt(width), parseInt(height)];
  return new PageViewport({
    viewBox,
    scale,
    rotation
  });
}
function getRGB(color) {
  if (color.startsWith("#")) {
    const colorRGB = parseInt(color.slice(1), 16);
    return [(colorRGB & 0xff0000) >> 16, (colorRGB & 0x00ff00) >> 8, colorRGB & 0x0000ff];
  }
  if (color.startsWith("rgb(")) {
    return color.slice(4, -1).split(",").map(x => parseInt(x));
  }
  if (color.startsWith("rgba(")) {
    return color.slice(5, -1).split(",").map(x => parseInt(x)).slice(0, 3);
  }
  (0, _util.warn)(`Not a valid color format: "${color}"`);
  return [0, 0, 0];
}
function getColorValues(colors) {
  const span = document.createElement("span");
  span.style.visibility = "hidden";
  document.body.append(span);
  for (const name of colors.keys()) {
    span.style.color = name;
    const computedColor = window.getComputedStyle(span).color;
    colors.set(name, getRGB(computedColor));
  }
  span.remove();
}
function getCurrentTransform(ctx) {
  const {
    a,
    b,
    c,
    d,
    e,
    f
  } = ctx.getTransform();
  return [a, b, c, d, e, f];
}
function getCurrentTransformInverse(ctx) {
  const {
    a,
    b,
    c,
    d,
    e,
    f
  } = ctx.getTransform().invertSelf();
  return [a, b, c, d, e, f];
}
function setLayerDimensions(div, viewport) {
  let mustFlip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  let mustRotate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  if (viewport instanceof PageViewport) {
    const {
      pageWidth,
      pageHeight
    } = viewport.rawDims;
    const {
      style
    } = div;
    const useRound = _util.FeatureTest.isCSSRoundSupported;
    const w = `var(--scale-factor) * ${pageWidth}px`,
      h = `var(--scale-factor) * ${pageHeight}px`;
    const widthStr = useRound ? `round(${w}, 1px)` : `calc(${w})`,
      heightStr = useRound ? `round(${h}, 1px)` : `calc(${h})`;
    if (!mustFlip || viewport.rotation % 180 === 0) {
      style.width = widthStr;
      style.height = heightStr;
    } else {
      style.width = heightStr;
      style.height = widthStr;
    }
  }
  if (mustRotate) {
    div.setAttribute("data-main-rotation", viewport.rotation);
  }
}

/***/ }),
/* 169 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.BaseStandardFontDataFactory = exports.BaseSVGFactory = exports.BaseFilterFactory = exports.BaseCanvasFactory = exports.BaseCMapReaderFactory = void 0;
__w_pdfjs_require__(2);
var _util = __w_pdfjs_require__(1);
class BaseFilterFactory {
  constructor() {
    if (this.constructor === BaseFilterFactory) {
      (0, _util.unreachable)("Cannot initialize BaseFilterFactory.");
    }
  }
  addFilter(maps) {
    return "none";
  }
  addHCMFilter(fgColor, bgColor) {
    return "none";
  }
  addHighlightHCMFilter(fgColor, bgColor, newFgColor, newBgColor) {
    return "none";
  }
  destroy() {
    let keepHCM = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  }
}
exports.BaseFilterFactory = BaseFilterFactory;
class BaseCanvasFactory {
  constructor() {
    if (this.constructor === BaseCanvasFactory) {
      (0, _util.unreachable)("Cannot initialize BaseCanvasFactory.");
    }
  }
  create(width, height) {
    if (width <= 0 || height <= 0) {
      throw new Error("Invalid canvas size");
    }
    const canvas = this._createCanvas(width, height);
    return {
      canvas,
      context: canvas.getContext("2d")
    };
  }
  reset(canvasAndContext, width, height) {
    if (!canvasAndContext.canvas) {
      throw new Error("Canvas is not specified");
    }
    if (width <= 0 || height <= 0) {
      throw new Error("Invalid canvas size");
    }
    canvasAndContext.canvas.width = width;
    canvasAndContext.canvas.height = height;
  }
  destroy(canvasAndContext) {
    if (!canvasAndContext.canvas) {
      throw new Error("Canvas is not specified");
    }
    canvasAndContext.canvas.width = 0;
    canvasAndContext.canvas.height = 0;
    canvasAndContext.canvas = null;
    canvasAndContext.context = null;
  }
  _createCanvas(width, height) {
    (0, _util.unreachable)("Abstract method `_createCanvas` called.");
  }
}
exports.BaseCanvasFactory = BaseCanvasFactory;
class BaseCMapReaderFactory {
  constructor(_ref) {
    let {
      baseUrl = null,
      isCompressed = true
    } = _ref;
    if (this.constructor === BaseCMapReaderFactory) {
      (0, _util.unreachable)("Cannot initialize BaseCMapReaderFactory.");
    }
    this.baseUrl = baseUrl;
    this.isCompressed = isCompressed;
  }
  async fetch(_ref2) {
    let {
      name
    } = _ref2;
    if (!this.baseUrl) {
      throw new Error('The CMap "baseUrl" parameter must be specified, ensure that ' + 'the "cMapUrl" and "cMapPacked" API parameters are provided.');
    }
    if (!name) {
      throw new Error("CMap name must be specified.");
    }
    const url = this.baseUrl + name + (this.isCompressed ? ".bcmap" : "");
    const compressionType = this.isCompressed ? _util.CMapCompressionType.BINARY : _util.CMapCompressionType.NONE;
    return this._fetchData(url, compressionType).catch(reason => {
      throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${url}`);
    });
  }
  _fetchData(url, compressionType) {
    (0, _util.unreachable)("Abstract method `_fetchData` called.");
  }
}
exports.BaseCMapReaderFactory = BaseCMapReaderFactory;
class BaseStandardFontDataFactory {
  constructor(_ref3) {
    let {
      baseUrl = null
    } = _ref3;
    if (this.constructor === BaseStandardFontDataFactory) {
      (0, _util.unreachable)("Cannot initialize BaseStandardFontDataFactory.");
    }
    this.baseUrl = baseUrl;
  }
  async fetch(_ref4) {
    let {
      filename
    } = _ref4;
    if (!this.baseUrl) {
      throw new Error('The standard font "baseUrl" parameter must be specified, ensure that ' + 'the "standardFontDataUrl" API parameter is provided.');
    }
    if (!filename) {
      throw new Error("Font filename must be specified.");
    }
    const url = `${this.baseUrl}${filename}`;
    return this._fetchData(url).catch(reason => {
      throw new Error(`Unable to load font data at: ${url}`);
    });
  }
  _fetchData(url) {
    (0, _util.unreachable)("Abstract method `_fetchData` called.");
  }
}
exports.BaseStandardFontDataFactory = BaseStandardFontDataFactory;
class BaseSVGFactory {
  constructor() {
    if (this.constructor === BaseSVGFactory) {
      (0, _util.unreachable)("Cannot initialize BaseSVGFactory.");
    }
  }
  create(width, height) {
    let skipDimensions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (width <= 0 || height <= 0) {
      throw new Error("Invalid SVG dimensions");
    }
    const svg = this._createSVG("svg:svg");
    svg.setAttribute("version", "1.1");
    if (!skipDimensions) {
      svg.setAttribute("width", `${width}px`);
      svg.setAttribute("height", `${height}px`);
    }
    svg.setAttribute("preserveAspectRatio", "none");
    svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
    return svg;
  }
  createElement(type) {
    if (typeof type !== "string") {
      throw new Error("Invalid SVG element type");
    }
    return this._createSVG(type);
  }
  _createSVG(type) {
    (0, _util.unreachable)("Abstract method `_createSVG` called.");
  }
}
exports.BaseSVGFactory = BaseSVGFactory;

/***/ }),
/* 170 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.MurmurHash3_64 = void 0;
__w_pdfjs_require__(93);
__w_pdfjs_require__(101);
__w_pdfjs_require__(102);
__w_pdfjs_require__(105);
__w_pdfjs_require__(107);
__w_pdfjs_require__(109);
__w_pdfjs_require__(113);
__w_pdfjs_require__(116);
__w_pdfjs_require__(123);
__w_pdfjs_require__(2);
var _util = __w_pdfjs_require__(1);
const SEED = 0xc3d2e1f0;
const MASK_HIGH = 0xffff0000;
const MASK_LOW = 0xffff;
class MurmurHash3_64 {
  constructor(seed) {
    this.h1 = seed ? seed & 0xffffffff : SEED;
    this.h2 = seed ? seed & 0xffffffff : SEED;
  }
  update(input) {
    let data, length;
    if (typeof input === "string") {
      data = new Uint8Array(input.length * 2);
      length = 0;
      for (let i = 0, ii = input.length; i < ii; i++) {
        const code = input.charCodeAt(i);
        if (code <= 0xff) {
          data[length++] = code;
        } else {
          data[length++] = code >>> 8;
          data[length++] = code & 0xff;
        }
      }
    } else if ((0, _util.isArrayBuffer)(input)) {
      data = input.slice();
      length = data.byteLength;
    } else {
      throw new Error("Wrong data format in MurmurHash3_64_update. " + "Input must be a string or array.");
    }
    const blockCounts = length >> 2;
    const tailLength = length - blockCounts * 4;
    const dataUint32 = new Uint32Array(data.buffer, 0, blockCounts);
    let k1 = 0,
      k2 = 0;
    let h1 = this.h1,
      h2 = this.h2;
    const C1 = 0xcc9e2d51,
      C2 = 0x1b873593;
    const C1_LOW = C1 & MASK_LOW,
      C2_LOW = C2 & MASK_LOW;
    for (let i = 0; i < blockCounts; i++) {
      if (i & 1) {
        k1 = dataUint32[i];
        k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
        k1 = k1 << 15 | k1 >>> 17;
        k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
        h1 ^= k1;
        h1 = h1 << 13 | h1 >>> 19;
        h1 = h1 * 5 + 0xe6546b64;
      } else {
        k2 = dataUint32[i];
        k2 = k2 * C1 & MASK_HIGH | k2 * C1_LOW & MASK_LOW;
        k2 = k2 << 15 | k2 >>> 17;
        k2 = k2 * C2 & MASK_HIGH | k2 * C2_LOW & MASK_LOW;
        h2 ^= k2;
        h2 = h2 << 13 | h2 >>> 19;
        h2 = h2 * 5 + 0xe6546b64;
      }
    }
    k1 = 0;
    switch (tailLength) {
      case 3:
        k1 ^= data[blockCounts * 4 + 2] << 16;
      case 2:
        k1 ^= data[blockCounts * 4 + 1] << 8;
      case 1:
        k1 ^= data[blockCounts * 4];
        k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
        k1 = k1 << 15 | k1 >>> 17;
        k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
        if (blockCounts & 1) {
          h1 ^= k1;
        } else {
          h2 ^= k1;
        }
    }
    this.h1 = h1;
    this.h2 = h2;
  }
  hexdigest() {
    let h1 = this.h1,
      h2 = this.h2;
    h1 ^= h2 >>> 1;
    h1 = h1 * 0xed558ccd & MASK_HIGH | h1 * 0x8ccd & MASK_LOW;
    h2 = h2 * 0xff51afd7 & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xafd7ed55 & MASK_HIGH) >>> 16;
    h1 ^= h2 >>> 1;
    h1 = h1 * 0x1a85ec53 & MASK_HIGH | h1 * 0xec53 & MASK_LOW;
    h2 = h2 * 0xc4ceb9fe & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xb9fe1a85 & MASK_HIGH) >>> 16;
    h1 ^= h2 >>> 1;
    return (h1 >>> 0).toString(16).padStart(8, "0") + (h2 >>> 0).toString(16).padStart(8, "0");
  }
}
exports.MurmurHash3_64 = MurmurHash3_64;

/***/ }),
/* 171 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.FontLoader = exports.FontFaceObject = void 0;
__w_pdfjs_require__(125);
__w_pdfjs_require__(136);
__w_pdfjs_require__(138);
__w_pdfjs_require__(141);
__w_pdfjs_require__(143);
__w_pdfjs_require__(145);
__w_pdfjs_require__(147);
__w_pdfjs_require__(89);
__w_pdfjs_require__(149);
var _util = __w_pdfjs_require__(1);
class FontLoader {
  #systemFonts = new Set();
  constructor(_ref) {
    let {
      ownerDocument = globalThis.document,
      styleElement = null
    } = _ref;
    this._document = ownerDocument;
    this.nativeFontFaces = new Set();
    this.styleElement = null;
    this.loadingRequests = [];
    this.loadTestFontId = 0;
  }
  addNativeFontFace(nativeFontFace) {
    this.nativeFontFaces.add(nativeFontFace);
    this._document.fonts.add(nativeFontFace);
  }
  removeNativeFontFace(nativeFontFace) {
    this.nativeFontFaces.delete(nativeFontFace);
    this._document.fonts.delete(nativeFontFace);
  }
  insertRule(rule) {
    if (!this.styleElement) {
      this.styleElement = this._document.createElement("style");
      this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement);
    }
    const styleSheet = this.styleElement.sheet;
    styleSheet.insertRule(rule, styleSheet.cssRules.length);
  }
  clear() {
    for (const nativeFontFace of this.nativeFontFaces) {
      this._document.fonts.delete(nativeFontFace);
    }
    this.nativeFontFaces.clear();
    this.#systemFonts.clear();
    if (this.styleElement) {
      this.styleElement.remove();
      this.styleElement = null;
    }
  }
  async loadSystemFont(info) {
    if (!info || this.#systemFonts.has(info.loadedName)) {
      return;
    }
    (0, _util.assert)(!this.disableFontFace, "loadSystemFont shouldn't be called when `disableFontFace` is set.");
    if (this.isFontLoadingAPISupported) {
      const {
        loadedName,
        src,
        style
      } = info;
      const fontFace = new FontFace(loadedName, src, style);
      this.addNativeFontFace(fontFace);
      try {
        await fontFace.load();
        this.#systemFonts.add(loadedName);
      } catch {
        (0, _util.warn)(`Cannot load system font: ${info.baseFontName}, installing it could help to improve PDF rendering.`);
        this.removeNativeFontFace(fontFace);
      }
      return;
    }
    (0, _util.unreachable)("Not implemented: loadSystemFont without the Font Loading API.");
  }
  async bind(font) {
    if (font.attached || font.missingFile && !font.systemFontInfo) {
      return;
    }
    font.attached = true;
    if (font.systemFontInfo) {
      await this.loadSystemFont(font.systemFontInfo);
      return;
    }
    if (this.isFontLoadingAPISupported) {
      const nativeFontFace = font.createNativeFontFace();
      if (nativeFontFace) {
        this.addNativeFontFace(nativeFontFace);
        try {
          await nativeFontFace.loaded;
        } catch (ex) {
          (0, _util.warn)(`Failed to load font '${nativeFontFace.family}': '${ex}'.`);
          font.disableFontFace = true;
          throw ex;
        }
      }
      return;
    }
    const rule = font.createFontFaceRule();
    if (rule) {
      this.insertRule(rule);
      if (this.isSyncFontLoadingSupported) {
        return;
      }
      await new Promise(resolve => {
        const request = this._queueLoadingCallback(resolve);
        this._prepareFontLoadEvent(font, request);
      });
    }
  }
  get isFontLoadingAPISupported() {
    const hasFonts = !!this._document?.fonts;
    return (0, _util.shadow)(this, "isFontLoadingAPISupported", hasFonts);
  }
  get isSyncFontLoadingSupported() {
    let supported = false;
    if (_util.isNodeJS) {
      supported = true;
    } else if (typeof navigator !== "undefined" && /Mozilla\/5.0.*?rv:\d+.*? Gecko/.test(navigator.userAgent)) {
      supported = true;
    }
    return (0, _util.shadow)(this, "isSyncFontLoadingSupported", supported);
  }
  _queueLoadingCallback(callback) {
    function completeRequest() {
      (0, _util.assert)(!request.done, "completeRequest() cannot be called twice.");
      request.done = true;
      while (loadingRequests.length > 0 && loadingRequests[0].done) {
        const otherRequest = loadingRequests.shift();
        setTimeout(otherRequest.callback, 0);
      }
    }
    const {
      loadingRequests
    } = this;
    const request = {
      done: false,
      complete: completeRequest,
      callback
    };
    loadingRequests.push(request);
    return request;
  }
  get _loadTestFont() {
    const testFont = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQA" + "FQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAA" + "ALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgA" + "AAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1" + "AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD" + "6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACM" + "AooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4D" + "IP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAA" + "AAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUA" + "AQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgAB" + "AAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABY" + "AAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAA" + "AC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAA" + "AAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQAC" + "AQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3" + "Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTj" + "FQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
    return (0, _util.shadow)(this, "_loadTestFont", testFont);
  }
  _prepareFontLoadEvent(font, request) {
    function int32(data, offset) {
      return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
    }
    function spliceString(s, offset, remove, insert) {
      const chunk1 = s.substring(0, offset);
      const chunk2 = s.substring(offset + remove);
      return chunk1 + insert + chunk2;
    }
    let i, ii;
    const canvas = this._document.createElement("canvas");
    canvas.width = 1;
    canvas.height = 1;
    const ctx = canvas.getContext("2d");
    let called = 0;
    function isFontReady(name, callback) {
      if (++called > 30) {
        (0, _util.warn)("Load test font never loaded.");
        callback();
        return;
      }
      ctx.font = "30px " + name;
      ctx.fillText(".", 0, 20);
      const imageData = ctx.getImageData(0, 0, 1, 1);
      if (imageData.data[3] > 0) {
        callback();
        return;
      }
      setTimeout(isFontReady.bind(null, name, callback));
    }
    const loadTestFontId = `lt${Date.now()}${this.loadTestFontId++}`;
    let data = this._loadTestFont;
    const COMMENT_OFFSET = 976;
    data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
    const CFF_CHECKSUM_OFFSET = 16;
    const XXXX_VALUE = 0x58585858;
    let checksum = int32(data, CFF_CHECKSUM_OFFSET);
    for (i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4) {
      checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
    }
    if (i < loadTestFontId.length) {
      checksum = checksum - XXXX_VALUE + int32(loadTestFontId + "XXX", i) | 0;
    }
    data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, (0, _util.string32)(checksum));
    const url = `url(data:font/opentype;base64,${btoa(data)});`;
    const rule = `@font-face {font-family:"${loadTestFontId}";src:${url}}`;
    this.insertRule(rule);
    const div = this._document.createElement("div");
    div.style.visibility = "hidden";
    div.style.width = div.style.height = "10px";
    div.style.position = "absolute";
    div.style.top = div.style.left = "0px";
    for (const name of [font.loadedName, loadTestFontId]) {
      const span = this._document.createElement("span");
      span.textContent = "Hi";
      span.style.fontFamily = name;
      div.append(span);
    }
    this._document.body.append(div);
    isFontReady(loadTestFontId, () => {
      div.remove();
      request.complete();
    });
  }
}
exports.FontLoader = FontLoader;
class FontFaceObject {
  constructor(translatedData, _ref2) {
    let {
      isEvalSupported = true,
      disableFontFace = false,
      ignoreErrors = false,
      inspectFont = null
    } = _ref2;
    this.compiledGlyphs = Object.create(null);
    for (const i in translatedData) {
      this[i] = translatedData[i];
    }
    this.isEvalSupported = isEvalSupported !== false;
    this.disableFontFace = disableFontFace === true;
    this.ignoreErrors = ignoreErrors === true;
    this._inspectFont = inspectFont;
  }
  createNativeFontFace() {
    if (!this.data || this.disableFontFace) {
      return null;
    }
    let nativeFontFace;
    if (!this.cssFontInfo) {
      nativeFontFace = new FontFace(this.loadedName, this.data, {});
    } else {
      const css = {
        weight: this.cssFontInfo.fontWeight
      };
      if (this.cssFontInfo.italicAngle) {
        css.style = `oblique ${this.cssFontInfo.italicAngle}deg`;
      }
      nativeFontFace = new FontFace(this.cssFontInfo.fontFamily, this.data, css);
    }
    this._inspectFont?.(this);
    return nativeFontFace;
  }
  createFontFaceRule() {
    if (!this.data || this.disableFontFace) {
      return null;
    }
    const data = (0, _util.bytesToString)(this.data);
    const url = `url(data:${this.mimetype};base64,${btoa(data)});`;
    let rule;
    if (!this.cssFontInfo) {
      rule = `@font-face {font-family:"${this.loadedName}";src:${url}}`;
    } else {
      let css = `font-weight: ${this.cssFontInfo.fontWeight};`;
      if (this.cssFontInfo.italicAngle) {
        css += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`;
      }
      rule = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${css}src:${url}}`;
    }
    this._inspectFont?.(this, url);
    return rule;
  }
  getPathGenerator(objs, character) {
    if (this.compiledGlyphs[character] !== undefined) {
      return this.compiledGlyphs[character];
    }
    let cmds;
    try {
      cmds = objs.get(this.loadedName + "_path_" + character);
    } catch (ex) {
      if (!this.ignoreErrors) {
        throw ex;
      }
      (0, _util.warn)(`getPathGenerator - ignoring character: "${ex}".`);
      return this.compiledGlyphs[character] = function (c, size) {};
    }
    if (this.isEvalSupported && _util.FeatureTest.isEvalSupported) {
      const jsBuf = [];
      for (const current of cmds) {
        const args = current.args !== undefined ? current.args.join(",") : "";
        jsBuf.push("c.", current.cmd, "(", args, ");\n");
      }
      return this.compiledGlyphs[character] = new Function("c", "size", jsBuf.join(""));
    }
    return this.compiledGlyphs[character] = function (c, size) {
      for (const current of cmds) {
        if (current.cmd === "scale") {
          current.args = [size, -size];
        }
        c[current.cmd].apply(c, current.args);
      }
    };
  }
}
exports.FontFaceObject = FontFaceObject;

/***/ }),
/* 172 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.NodeStandardFontDataFactory = exports.NodeFilterFactory = exports.NodeCanvasFactory = exports.NodeCMapReaderFactory = void 0;
__w_pdfjs_require__(2);
__w_pdfjs_require__(93);
__w_pdfjs_require__(101);
__w_pdfjs_require__(102);
__w_pdfjs_require__(105);
__w_pdfjs_require__(107);
__w_pdfjs_require__(109);
__w_pdfjs_require__(113);
__w_pdfjs_require__(116);
__w_pdfjs_require__(123);
var _base_factory = __w_pdfjs_require__(169);
var _util = __w_pdfjs_require__(1);
;
{
  (function checkDOMMatrix() {
    if (globalThis.DOMMatrix || !_util.isNodeJS) {
      return;
    }
    try {
      globalThis.DOMMatrix = require("canvas").DOMMatrix;
    } catch (ex) {
      (0, _util.warn)(`Cannot polyfill \`DOMMatrix\`, rendering may be broken: "${ex}".`);
    }
  })();
  (function checkPath2D() {
    if (globalThis.Path2D || !_util.isNodeJS) {
      return;
    }
    try {
      const {
        CanvasRenderingContext2D
      } = require("canvas");
      const {
        polyfillPath2D
      } = require("path2d-polyfill");
      globalThis.CanvasRenderingContext2D = CanvasRenderingContext2D;
      polyfillPath2D(globalThis);
    } catch (ex) {
      (0, _util.warn)(`Cannot polyfill \`Path2D\`, rendering may be broken: "${ex}".`);
    }
  })();
}
const fetchData = function (url) {
  return new Promise((resolve, reject) => {
    const fs = require("fs");
    fs.readFile(url, (error, data) => {
      if (error || !data) {
        reject(new Error(error));
        return;
      }
      resolve(new Uint8Array(data));
    });
  });
};
class NodeFilterFactory extends _base_factory.BaseFilterFactory {}
exports.NodeFilterFactory = NodeFilterFactory;
class NodeCanvasFactory extends _base_factory.BaseCanvasFactory {
  _createCanvas(width, height) {
    const Canvas = require("canvas");
    return Canvas.createCanvas(width, height);
  }
}
exports.NodeCanvasFactory = NodeCanvasFactory;
class NodeCMapReaderFactory extends _base_factory.BaseCMapReaderFactory {
  _fetchData(url, compressionType) {
    return fetchData(url).then(data => {
      return {
        cMapData: data,
        compressionType
      };
    });
  }
}
exports.NodeCMapReaderFactory = NodeCMapReaderFactory;
class NodeStandardFontDataFactory extends _base_factory.BaseStandardFontDataFactory {
  _fetchData(url) {
    return fetchData(url);
  }
}
exports.NodeStandardFontDataFactory = NodeStandardFontDataFactory;

/***/ }),
/* 173 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.CanvasGraphics = void 0;
__w_pdfjs_require__(2);
__w_pdfjs_require__(93);
__w_pdfjs_require__(101);
__w_pdfjs_require__(102);
__w_pdfjs_require__(105);
__w_pdfjs_require__(107);
__w_pdfjs_require__(109);
__w_pdfjs_require__(113);
__w_pdfjs_require__(116);
__w_pdfjs_require__(123);
__w_pdfjs_require__(89);
var _util = __w_pdfjs_require__(1);
var _display_utils = __w_pdfjs_require__(168);
var _pattern_helper = __w_pdfjs_require__(174);
var _image_utils = __w_pdfjs_require__(175);
const MIN_FONT_SIZE = 16;
const MAX_FONT_SIZE = 100;
const MAX_GROUP_SIZE = 4096;
const EXECUTION_TIME = 15;
const EXECUTION_STEPS = 10;
const MAX_SIZE_TO_COMPILE = 1000;
const FULL_CHUNK_HEIGHT = 16;
function mirrorContextOperations(ctx, destCtx) {
  if (ctx._removeMirroring) {
    throw new Error("Context is already forwarding operations.");
  }
  ctx.__originalSave = ctx.save;
  ctx.__originalRestore = ctx.restore;
  ctx.__originalRotate = ctx.rotate;
  ctx.__originalScale = ctx.scale;
  ctx.__originalTranslate = ctx.translate;
  ctx.__originalTransform = ctx.transform;
  ctx.__originalSetTransform = ctx.setTransform;
  ctx.__originalResetTransform = ctx.resetTransform;
  ctx.__originalClip = ctx.clip;
  ctx.__originalMoveTo = ctx.moveTo;
  ctx.__originalLineTo = ctx.lineTo;
  ctx.__originalBezierCurveTo = ctx.bezierCurveTo;
  ctx.__originalRect = ctx.rect;
  ctx.__originalClosePath = ctx.closePath;
  ctx.__originalBeginPath = ctx.beginPath;
  ctx._removeMirroring = () => {
    ctx.save = ctx.__originalSave;
    ctx.restore = ctx.__originalRestore;
    ctx.rotate = ctx.__originalRotate;
    ctx.scale = ctx.__originalScale;
    ctx.translate = ctx.__originalTranslate;
    ctx.transform = ctx.__originalTransform;
    ctx.setTransform = ctx.__originalSetTransform;
    ctx.resetTransform = ctx.__originalResetTransform;
    ctx.clip = ctx.__originalClip;
    ctx.moveTo = ctx.__originalMoveTo;
    ctx.lineTo = ctx.__originalLineTo;
    ctx.bezierCurveTo = ctx.__originalBezierCurveTo;
    ctx.rect = ctx.__originalRect;
    ctx.closePath = ctx.__originalClosePath;
    ctx.beginPath = ctx.__originalBeginPath;
    delete ctx._removeMirroring;
  };
  ctx.save = function ctxSave() {
    destCtx.save();
    this.__originalSave();
  };
  ctx.restore = function ctxRestore() {
    destCtx.restore();
    this.__originalRestore();
  };
  ctx.translate = function ctxTranslate(x, y) {
    destCtx.translate(x, y);
    this.__originalTranslate(x, y);
  };
  ctx.scale = function ctxScale(x, y) {
    destCtx.scale(x, y);
    this.__originalScale(x, y);
  };
  ctx.transform = function ctxTransform(a, b, c, d, e, f) {
    destCtx.transform(a, b, c, d, e, f);
    this.__originalTransform(a, b, c, d, e, f);
  };
  ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
    destCtx.setTransform(a, b, c, d, e, f);
    this.__originalSetTransform(a, b, c, d, e, f);
  };
  ctx.resetTransform = function ctxResetTransform() {
    destCtx.resetTransform();
    this.__originalResetTransform();
  };
  ctx.rotate = function ctxRotate(angle) {
    destCtx.rotate(angle);
    this.__originalRotate(angle);
  };
  ctx.clip = function ctxRotate(rule) {
    destCtx.clip(rule);
    this.__originalClip(rule);
  };
  ctx.moveTo = function (x, y) {
    destCtx.moveTo(x, y);
    this.__originalMoveTo(x, y);
  };
  ctx.lineTo = function (x, y) {
    destCtx.lineTo(x, y);
    this.__originalLineTo(x, y);
  };
  ctx.bezierCurveTo = function (cp1x, cp1y, cp2x, cp2y, x, y) {
    destCtx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
    this.__originalBezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
  };
  ctx.rect = function (x, y, width, height) {
    destCtx.rect(x, y, width, height);
    this.__originalRect(x, y, width, height);
  };
  ctx.closePath = function () {
    destCtx.closePath();
    this.__originalClosePath();
  };
  ctx.beginPath = function () {
    destCtx.beginPath();
    this.__originalBeginPath();
  };
}
class CachedCanvases {
  constructor(canvasFactory) {
    this.canvasFactory = canvasFactory;
    this.cache = Object.create(null);
  }
  getCanvas(id, width, height) {
    let canvasEntry;
    if (this.cache[id] !== undefined) {
      canvasEntry = this.cache[id];
      this.canvasFactory.reset(canvasEntry, width, height);
    } else {
      canvasEntry = this.canvasFactory.create(width, height);
      this.cache[id] = canvasEntry;
    }
    return canvasEntry;
  }
  delete(id) {
    delete this.cache[id];
  }
  clear() {
    for (const id in this.cache) {
      const canvasEntry = this.cache[id];
      this.canvasFactory.destroy(canvasEntry);
      delete this.cache[id];
    }
  }
}
function drawImageAtIntegerCoords(ctx, srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH) {
  const [a, b, c, d, tx, ty] = (0, _display_utils.getCurrentTransform)(ctx);
  if (b === 0 && c === 0) {
    const tlX = destX * a + tx;
    const rTlX = Math.round(tlX);
    const tlY = destY * d + ty;
    const rTlY = Math.round(tlY);
    const brX = (destX + destW) * a + tx;
    const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
    const brY = (destY + destH) * d + ty;
    const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
    ctx.setTransform(Math.sign(a), 0, 0, Math.sign(d), rTlX, rTlY);
    ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rWidth, rHeight);
    ctx.setTransform(a, b, c, d, tx, ty);
    return [rWidth, rHeight];
  }
  if (a === 0 && d === 0) {
    const tlX = destY * c + tx;
    const rTlX = Math.round(tlX);
    const tlY = destX * b + ty;
    const rTlY = Math.round(tlY);
    const brX = (destY + destH) * c + tx;
    const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
    const brY = (destX + destW) * b + ty;
    const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
    ctx.setTransform(0, Math.sign(b), Math.sign(c), 0, rTlX, rTlY);
    ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rHeight, rWidth);
    ctx.setTransform(a, b, c, d, tx, ty);
    return [rHeight, rWidth];
  }
  ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH);
  const scaleX = Math.hypot(a, b);
  const scaleY = Math.hypot(c, d);
  return [scaleX * destW, scaleY * destH];
}
function compileType3Glyph(imgData) {
  const {
    width,
    height
  } = imgData;
  if (width > MAX_SIZE_TO_COMPILE || height > MAX_SIZE_TO_COMPILE) {
    return null;
  }
  const POINT_TO_PROCESS_LIMIT = 1000;
  const POINT_TYPES = new Uint8Array([0, 2, 4, 0, 1, 0, 5, 4, 8, 10, 0, 8, 0, 2, 1, 0]);
  const width1 = width + 1;
  let points = new Uint8Array(width1 * (height + 1));
  let i, j, j0;
  const lineSize = width + 7 & ~7;
  let data = new Uint8Array(lineSize * height),
    pos = 0;
  for (const elem of imgData.data) {
    let mask = 128;
    while (mask > 0) {
      data[pos++] = elem & mask ? 0 : 255;
      mask >>= 1;
    }
  }
  let count = 0;
  pos = 0;
  if (data[pos] !== 0) {
    points[0] = 1;
    ++count;
  }
  for (j = 1; j < width; j++) {
    if (data[pos] !== data[pos + 1]) {
      points[j] = data[pos] ? 2 : 1;
      ++count;
    }
    pos++;
  }
  if (data[pos] !== 0) {
    points[j] = 2;
    ++count;
  }
  for (i = 1; i < height; i++) {
    pos = i * lineSize;
    j0 = i * width1;
    if (data[pos - lineSize] !== data[pos]) {
      points[j0] = data[pos] ? 1 : 8;
      ++count;
    }
    let sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);
    for (j = 1; j < width; j++) {
      sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);
      if (POINT_TYPES[sum]) {
        points[j0 + j] = POINT_TYPES[sum];
        ++count;
      }
      pos++;
    }
    if (data[pos - lineSize] !== data[pos]) {
      points[j0 + j] = data[pos] ? 2 : 4;
      ++count;
    }
    if (count > POINT_TO_PROCESS_LIMIT) {
      return null;
    }
  }
  pos = lineSize * (height - 1);
  j0 = i * width1;
  if (data[pos] !== 0) {
    points[j0] = 8;
    ++count;
  }
  for (j = 1; j < width; j++) {
    if (data[pos] !== data[pos + 1]) {
      points[j0 + j] = data[pos] ? 4 : 8;
      ++count;
    }
    pos++;
  }
  if (data[pos] !== 0) {
    points[j0 + j] = 4;
    ++count;
  }
  if (count > POINT_TO_PROCESS_LIMIT) {
    return null;
  }
  const steps = new Int32Array([0, width1, -1, 0, -width1, 0, 0, 0, 1]);
  const path = new Path2D();
  for (i = 0; count && i <= height; i++) {
    let p = i * width1;
    const end = p + width;
    while (p < end && !points[p]) {
      p++;
    }
    if (p === end) {
      continue;
    }
    path.moveTo(p % width1, i);
    const p0 = p;
    let type = points[p];
    do {
      const step = steps[type];
      do {
        p += step;
      } while (!points[p]);
      const pp = points[p];
      if (pp !== 5 && pp !== 10) {
        type = pp;
        points[p] = 0;
      } else {
        type = pp & 0x33 * type >> 4;
        points[p] &= type >> 2 | type << 2;
      }
      path.lineTo(p % width1, p / width1 | 0);
      if (!points[p]) {
        --count;
      }
    } while (p0 !== p);
    --i;
  }
  data = null;
  points = null;
  const drawOutline = function (c) {
    c.save();
    c.scale(1 / width, -1 / height);
    c.translate(0, -height);
    c.fill(path);
    c.beginPath();
    c.restore();
  };
  return drawOutline;
}
class CanvasExtraState {
  constructor(width, height) {
    this.alphaIsShape = false;
    this.fontSize = 0;
    this.fontSizeScale = 1;
    this.textMatrix = _util.IDENTITY_MATRIX;
    this.textMatrixScale = 1;
    this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
    this.leading = 0;
    this.x = 0;
    this.y = 0;
    this.lineX = 0;
    this.lineY = 0;
    this.charSpacing = 0;
    this.wordSpacing = 0;
    this.textHScale = 1;
    this.textRenderingMode = _util.TextRenderingMode.FILL;
    this.textRise = 0;
    this.fillColor = "#000000";
    this.strokeColor = "#000000";
    this.patternFill = false;
    this.fillAlpha = 1;
    this.strokeAlpha = 1;
    this.lineWidth = 1;
    this.activeSMask = null;
    this.transferMaps = "none";
    this.startNewPathAndClipBox([0, 0, width, height]);
  }
  clone() {
    const clone = Object.create(this);
    clone.clipBox = this.clipBox.slice();
    return clone;
  }
  setCurrentPoint(x, y) {
    this.x = x;
    this.y = y;
  }
  updatePathMinMax(transform, x, y) {
    [x, y] = _util.Util.applyTransform([x, y], transform);
    this.minX = Math.min(this.minX, x);
    this.minY = Math.min(this.minY, y);
    this.maxX = Math.max(this.maxX, x);
    this.maxY = Math.max(this.maxY, y);
  }
  updateRectMinMax(transform, rect) {
    const p1 = _util.Util.applyTransform(rect, transform);
    const p2 = _util.Util.applyTransform(rect.slice(2), transform);
    this.minX = Math.min(this.minX, p1[0], p2[0]);
    this.minY = Math.min(this.minY, p1[1], p2[1]);
    this.maxX = Math.max(this.maxX, p1[0], p2[0]);
    this.maxY = Math.max(this.maxY, p1[1], p2[1]);
  }
  updateScalingPathMinMax(transform, minMax) {
    _util.Util.scaleMinMax(transform, minMax);
    this.minX = Math.min(this.minX, minMax[0]);
    this.maxX = Math.max(this.maxX, minMax[1]);
    this.minY = Math.min(this.minY, minMax[2]);
    this.maxY = Math.max(this.maxY, minMax[3]);
  }
  updateCurvePathMinMax(transform, x0, y0, x1, y1, x2, y2, x3, y3, minMax) {
    const box = _util.Util.bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3);
    if (minMax) {
      minMax[0] = Math.min(minMax[0], box[0], box[2]);
      minMax[1] = Math.max(minMax[1], box[0], box[2]);
      minMax[2] = Math.min(minMax[2], box[1], box[3]);
      minMax[3] = Math.max(minMax[3], box[1], box[3]);
      return;
    }
    this.updateRectMinMax(transform, box);
  }
  getPathBoundingBox() {
    let pathType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _pattern_helper.PathType.FILL;
    let transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const box = [this.minX, this.minY, this.maxX, this.maxY];
    if (pathType === _pattern_helper.PathType.STROKE) {
      if (!transform) {
        (0, _util.unreachable)("Stroke bounding box must include transform.");
      }
      const scale = _util.Util.singularValueDecompose2dScale(transform);
      const xStrokePad = scale[0] * this.lineWidth / 2;
      const yStrokePad = scale[1] * this.lineWidth / 2;
      box[0] -= xStrokePad;
      box[1] -= yStrokePad;
      box[2] += xStrokePad;
      box[3] += yStrokePad;
    }
    return box;
  }
  updateClipFromPath() {
    const intersect = _util.Util.intersect(this.clipBox, this.getPathBoundingBox());
    this.startNewPathAndClipBox(intersect || [0, 0, 0, 0]);
  }
  isEmptyClip() {
    return this.minX === Infinity;
  }
  startNewPathAndClipBox(box) {
    this.clipBox = box;
    this.minX = Infinity;
    this.minY = Infinity;
    this.maxX = 0;
    this.maxY = 0;
  }
  getClippedPathBoundingBox() {
    let pathType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _pattern_helper.PathType.FILL;
    let transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return _util.Util.intersect(this.clipBox, this.getPathBoundingBox(pathType, transform));
  }
}
function putBinaryImageData(ctx, imgData) {
  if (typeof ImageData !== "undefined" && imgData instanceof ImageData) {
    ctx.putImageData(imgData, 0, 0);
    return;
  }
  const height = imgData.height,
    width = imgData.width;
  const partialChunkHeight = height % FULL_CHUNK_HEIGHT;
  const fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
  const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
  const chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
  let srcPos = 0,
    destPos;
  const src = imgData.data;
  const dest = chunkImgData.data;
  let i, j, thisChunkHeight, elemsInThisChunk;
  if (imgData.kind === _util.ImageKind.GRAYSCALE_1BPP) {
    const srcLength = src.byteLength;
    const dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
    const dest32DataLength = dest32.length;
    const fullSrcDiff = width + 7 >> 3;
    const white = 0xffffffff;
    const black = _util.FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
    for (i = 0; i < totalChunks; i++) {
      thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
      destPos = 0;
      for (j = 0; j < thisChunkHeight; j++) {
        const srcDiff = srcLength - srcPos;
        let k = 0;
        const kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
        const kEndUnrolled = kEnd & ~7;
        let mask = 0;
        let srcByte = 0;
        for (; k < kEndUnrolled; k += 8) {
          srcByte = src[srcPos++];
          dest32[destPos++] = srcByte & 128 ? white : black;
          dest32[destPos++] = srcByte & 64 ? white : black;
          dest32[destPos++] = srcByte & 32 ? white : black;
          dest32[destPos++] = srcByte & 16 ? white : black;
          dest32[destPos++] = srcByte & 8 ? white : black;
          dest32[destPos++] = srcByte & 4 ? white : black;
          dest32[destPos++] = srcByte & 2 ? white : black;
          dest32[destPos++] = srcByte & 1 ? white : black;
        }
        for (; k < kEnd; k++) {
          if (mask === 0) {
            srcByte = src[srcPos++];
            mask = 128;
          }
          dest32[destPos++] = srcByte & mask ? white : black;
          mask >>= 1;
        }
      }
      while (destPos < dest32DataLength) {
        dest32[destPos++] = 0;
      }
      ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
    }
  } else if (imgData.kind === _util.ImageKind.RGBA_32BPP) {
    j = 0;
    elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
    for (i = 0; i < fullChunks; i++) {
      dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
      srcPos += elemsInThisChunk;
      ctx.putImageData(chunkImgData, 0, j);
      j += FULL_CHUNK_HEIGHT;
    }
    if (i < totalChunks) {
      elemsInThisChunk = width * partialChunkHeight * 4;
      dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
      ctx.putImageData(chunkImgData, 0, j);
    }
  } else if (imgData.kind === _util.ImageKind.RGB_24BPP) {
    thisChunkHeight = FULL_CHUNK_HEIGHT;
    elemsInThisChunk = width * thisChunkHeight;
    for (i = 0; i < totalChunks; i++) {
      if (i >= fullChunks) {
        thisChunkHeight = partialChunkHeight;
        elemsInThisChunk = width * thisChunkHeight;
      }
      destPos = 0;
      for (j = elemsInThisChunk; j--;) {
        dest[destPos++] = src[srcPos++];
        dest[destPos++] = src[srcPos++];
        dest[destPos++] = src[srcPos++];
        dest[destPos++] = 255;
      }
      ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
    }
  } else {
    throw new Error(`bad image kind: ${imgData.kind}`);
  }
}
function putBinaryImageMask(ctx, imgData) {
  if (imgData.bitmap) {
    ctx.drawImage(imgData.bitmap, 0, 0);
    return;
  }
  const height = imgData.height,
    width = imgData.width;
  const partialChunkHeight = height % FULL_CHUNK_HEIGHT;
  const fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
  const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
  const chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
  let srcPos = 0;
  const src = imgData.data;
  const dest = chunkImgData.data;
  for (let i = 0; i < totalChunks; i++) {
    const thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
    ({
      srcPos
    } = (0, _image_utils.convertBlackAndWhiteToRGBA)({
      src,
      srcPos,
      dest,
      width,
      height: thisChunkHeight,
      nonBlackColor: 0
    }));
    ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
  }
}
function copyCtxState(sourceCtx, destCtx) {
  const properties = ["strokeStyle", "fillStyle", "fillRule", "globalAlpha", "lineWidth", "lineCap", "lineJoin", "miterLimit", "globalCompositeOperation", "font", "filter"];
  for (const property of properties) {
    if (sourceCtx[property] !== undefined) {
      destCtx[property] = sourceCtx[property];
    }
  }
  if (sourceCtx.setLineDash !== undefined) {
    destCtx.setLineDash(sourceCtx.getLineDash());
    destCtx.lineDashOffset = sourceCtx.lineDashOffset;
  }
}
function resetCtxToDefault(ctx) {
  ctx.strokeStyle = ctx.fillStyle = "#000000";
  ctx.fillRule = "nonzero";
  ctx.globalAlpha = 1;
  ctx.lineWidth = 1;
  ctx.lineCap = "butt";
  ctx.lineJoin = "miter";
  ctx.miterLimit = 10;
  ctx.globalCompositeOperation = "source-over";
  ctx.font = "10px sans-serif";
  if (ctx.setLineDash !== undefined) {
    ctx.setLineDash([]);
    ctx.lineDashOffset = 0;
  }
  if (!_util.isNodeJS) {
    const {
      filter
    } = ctx;
    if (filter !== "none" && filter !== "") {
      ctx.filter = "none";
    }
  }
}
function composeSMaskBackdrop(bytes, r0, g0, b0) {
  const length = bytes.length;
  for (let i = 3; i < length; i += 4) {
    const alpha = bytes[i];
    if (alpha === 0) {
      bytes[i - 3] = r0;
      bytes[i - 2] = g0;
      bytes[i - 1] = b0;
    } else if (alpha < 255) {
      const alpha_ = 255 - alpha;
      bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
      bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
      bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
    }
  }
}
function composeSMaskAlpha(maskData, layerData, transferMap) {
  const length = maskData.length;
  const scale = 1 / 255;
  for (let i = 3; i < length; i += 4) {
    const alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
    layerData[i] = layerData[i] * alpha * scale | 0;
  }
}
function composeSMaskLuminosity(maskData, layerData, transferMap) {
  const length = maskData.length;
  for (let i = 3; i < length; i += 4) {
    const y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
    layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
  }
}
function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap, layerOffsetX, layerOffsetY, maskOffsetX, maskOffsetY) {
  const hasBackdrop = !!backdrop;
  const r0 = hasBackdrop ? backdrop[0] : 0;
  const g0 = hasBackdrop ? backdrop[1] : 0;
  const b0 = hasBackdrop ? backdrop[2] : 0;
  const composeFn = subtype === "Luminosity" ? composeSMaskLuminosity : composeSMaskAlpha;
  const PIXELS_TO_PROCESS = 1048576;
  const chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));
  for (let row = 0; row < height; row += chunkSize) {
    const chunkHeight = Math.min(chunkSize, height - row);
    const maskData = maskCtx.getImageData(layerOffsetX - maskOffsetX, row + (layerOffsetY - maskOffsetY), width, chunkHeight);
    const layerData = layerCtx.getImageData(layerOffsetX, row + layerOffsetY, width, chunkHeight);
    if (hasBackdrop) {
      composeSMaskBackdrop(maskData.data, r0, g0, b0);
    }
    composeFn(maskData.data, layerData.data, transferMap);
    layerCtx.putImageData(layerData, layerOffsetX, row + layerOffsetY);
  }
}
function composeSMask(ctx, smask, layerCtx, layerBox) {
  const layerOffsetX = layerBox[0];
  const layerOffsetY = layerBox[1];
  const layerWidth = layerBox[2] - layerOffsetX;
  const layerHeight = layerBox[3] - layerOffsetY;
  if (layerWidth === 0 || layerHeight === 0) {
    return;
  }
  genericComposeSMask(smask.context, layerCtx, layerWidth, layerHeight, smask.subtype, smask.backdrop, smask.transferMap, layerOffsetX, layerOffsetY, smask.offsetX, smask.offsetY);
  ctx.save();
  ctx.globalAlpha = 1;
  ctx.globalCompositeOperation = "source-over";
  ctx.setTransform(1, 0, 0, 1, 0, 0);
  ctx.drawImage(layerCtx.canvas, 0, 0);
  ctx.restore();
}
function getImageSmoothingEnabled(transform, interpolate) {
  const scale = _util.Util.singularValueDecompose2dScale(transform);
  scale[0] = Math.fround(scale[0]);
  scale[1] = Math.fround(scale[1]);
  const actualScale = Math.fround((globalThis.devicePixelRatio || 1) * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
  if (interpolate !== undefined) {
    return interpolate;
  } else if (scale[0] <= actualScale || scale[1] <= actualScale) {
    return true;
  }
  return false;
}
const LINE_CAP_STYLES = ["butt", "round", "square"];
const LINE_JOIN_STYLES = ["miter", "round", "bevel"];
const NORMAL_CLIP = {};
const EO_CLIP = {};
class CanvasGraphics {
  constructor(canvasCtx, commonObjs, objs, canvasFactory, filterFactory, _ref, annotationCanvasMap, pageColors) {
    let {
      optionalContentConfig,
      markedContentStack = null
    } = _ref;
    this.ctx = canvasCtx;
    this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
    this.stateStack = [];
    this.pendingClip = null;
    this.pendingEOFill = false;
    this.res = null;
    this.xobjs = null;
    this.commonObjs = commonObjs;
    this.objs = objs;
    this.canvasFactory = canvasFactory;
    this.filterFactory = filterFactory;
    this.groupStack = [];
    this.processingType3 = null;
    this.baseTransform = null;
    this.baseTransformStack = [];
    this.groupLevel = 0;
    this.smaskStack = [];
    this.smaskCounter = 0;
    this.tempSMask = null;
    this.suspendedCtx = null;
    this.contentVisible = true;
    this.markedContentStack = markedContentStack || [];
    this.optionalContentConfig = optionalContentConfig;
    this.cachedCanvases = new CachedCanvases(this.canvasFactory);
    this.cachedPatterns = new Map();
    this.annotationCanvasMap = annotationCanvasMap;
    this.viewportScale = 1;
    this.outputScaleX = 1;
    this.outputScaleY = 1;
    this.pageColors = pageColors;
    this._cachedScaleForStroking = [-1, 0];
    this._cachedGetSinglePixelWidth = null;
    this._cachedBitmapsMap = new Map();
  }
  getObject(data) {
    let fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (typeof data === "string") {
      return data.startsWith("g_") ? this.commonObjs.get(data) : this.objs.get(data);
    }
    return fallback;
  }
  beginDrawing(_ref2) {
    let {
      transform,
      viewport,
      transparency = false,
      background = null
    } = _ref2;
    const width = this.ctx.canvas.width;
    const height = this.ctx.canvas.height;
    const savedFillStyle = this.ctx.fillStyle;
    this.ctx.fillStyle = background || "#ffffff";
    this.ctx.fillRect(0, 0, width, height);
    this.ctx.fillStyle = savedFillStyle;
    if (transparency) {
      const transparentCanvas = this.cachedCanvases.getCanvas("transparent", width, height);
      this.compositeCtx = this.ctx;
      this.transparentCanvas = transparentCanvas.canvas;
      this.ctx = transparentCanvas.context;
      this.ctx.save();
      this.ctx.transform(...(0, _display_utils.getCurrentTransform)(this.compositeCtx));
    }
    this.ctx.save();
    resetCtxToDefault(this.ctx);
    if (transform) {
      this.ctx.transform(...transform);
      this.outputScaleX = transform[0];
      this.outputScaleY = transform[0];
    }
    this.ctx.transform(...viewport.transform);
    this.viewportScale = viewport.scale;
    this.baseTransform = (0, _display_utils.getCurrentTransform)(this.ctx);
  }
  executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
    const argsArray = operatorList.argsArray;
    const fnArray = operatorList.fnArray;
    let i = executionStartIdx || 0;
    const argsArrayLen = argsArray.length;
    if (argsArrayLen === i) {
      return i;
    }
    const chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === "function";
    const endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
    let steps = 0;
    const commonObjs = this.commonObjs;
    const objs = this.objs;
    let fnId;
    while (true) {
      if (stepper !== undefined && i === stepper.nextBreakPoint) {
        stepper.breakIt(i, continueCallback);
        return i;
      }
      fnId = fnArray[i];
      if (fnId !== _util.OPS.dependency) {
        this[fnId].apply(this, argsArray[i]);
      } else {
        for (const depObjId of argsArray[i]) {
          const objsPool = depObjId.startsWith("g_") ? commonObjs : objs;
          if (!objsPool.has(depObjId)) {
            objsPool.get(depObjId, continueCallback);
            return i;
          }
        }
      }
      i++;
      if (i === argsArrayLen) {
        return i;
      }
      if (chunkOperations && ++steps > EXECUTION_STEPS) {
        if (Date.now() > endTime) {
          continueCallback();
          return i;
        }
        steps = 0;
      }
    }
  }
  #restoreInitialState() {
    while (this.stateStack.length || this.inSMaskMode) {
      this.restore();
    }
    this.ctx.restore();
    if (this.transparentCanvas) {
      this.ctx = this.compositeCtx;
      this.ctx.save();
      this.ctx.setTransform(1, 0, 0, 1, 0, 0);
      this.ctx.drawImage(this.transparentCanvas, 0, 0);
      this.ctx.restore();
      this.transparentCanvas = null;
    }
  }
  endDrawing() {
    this.#restoreInitialState();
    this.cachedCanvases.clear();
    this.cachedPatterns.clear();
    for (const cache of this._cachedBitmapsMap.values()) {
      for (const canvas of cache.values()) {
        if (typeof HTMLCanvasElement !== "undefined" && canvas instanceof HTMLCanvasElement) {
          canvas.width = canvas.height = 0;
        }
      }
      cache.clear();
    }
    this._cachedBitmapsMap.clear();
    this.#drawFilter();
  }
  #drawFilter() {
    if (this.pageColors) {
      const hcmFilterId = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
      if (hcmFilterId !== "none") {
        const savedFilter = this.ctx.filter;
        this.ctx.filter = hcmFilterId;
        this.ctx.drawImage(this.ctx.canvas, 0, 0);
        this.ctx.filter = savedFilter;
      }
    }
  }
  _scaleImage(img, inverseTransform) {
    const width = img.width;
    const height = img.height;
    let widthScale = Math.max(Math.hypot(inverseTransform[0], inverseTransform[1]), 1);
    let heightScale = Math.max(Math.hypot(inverseTransform[2], inverseTransform[3]), 1);
    let paintWidth = width,
      paintHeight = height;
    let tmpCanvasId = "prescale1";
    let tmpCanvas, tmpCtx;
    while (widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1) {
      let newWidth = paintWidth,
        newHeight = paintHeight;
      if (widthScale > 2 && paintWidth > 1) {
        newWidth = paintWidth >= 16384 ? Math.floor(paintWidth / 2) - 1 || 1 : Math.ceil(paintWidth / 2);
        widthScale /= paintWidth / newWidth;
      }
      if (heightScale > 2 && paintHeight > 1) {
        newHeight = paintHeight >= 16384 ? Math.floor(paintHeight / 2) - 1 || 1 : Math.ceil(paintHeight) / 2;
        heightScale /= paintHeight / newHeight;
      }
      tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
      tmpCtx = tmpCanvas.context;
      tmpCtx.clearRect(0, 0, newWidth, newHeight);
      tmpCtx.drawImage(img, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
      img = tmpCanvas.canvas;
      paintWidth = newWidth;
      paintHeight = newHeight;
      tmpCanvasId = tmpCanvasId === "prescale1" ? "prescale2" : "prescale1";
    }
    return {
      img,
      paintWidth,
      paintHeight
    };
  }
  _createMaskCanvas(img) {
    const ctx = this.ctx;
    const {
      width,
      height
    } = img;
    const fillColor = this.current.fillColor;
    const isPatternFill = this.current.patternFill;
    const currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
    let cache, cacheKey, scaled, maskCanvas;
    if ((img.bitmap || img.data) && img.count > 1) {
      const mainKey = img.bitmap || img.data.buffer;
      cacheKey = JSON.stringify(isPatternFill ? currentTransform : [currentTransform.slice(0, 4), fillColor]);
      cache = this._cachedBitmapsMap.get(mainKey);
      if (!cache) {
        cache = new Map();
        this._cachedBitmapsMap.set(mainKey, cache);
      }
      const cachedImage = cache.get(cacheKey);
      if (cachedImage && !isPatternFill) {
        const offsetX = Math.round(Math.min(currentTransform[0], currentTransform[2]) + currentTransform[4]);
        const offsetY = Math.round(Math.min(currentTransform[1], currentTransform[3]) + currentTransform[5]);
        return {
          canvas: cachedImage,
          offsetX,
          offsetY
        };
      }
      scaled = cachedImage;
    }
    if (!scaled) {
      maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
      putBinaryImageMask(maskCanvas.context, img);
    }
    let maskToCanvas = _util.Util.transform(currentTransform, [1 / width, 0, 0, -1 / height, 0, 0]);
    maskToCanvas = _util.Util.transform(maskToCanvas, [1, 0, 0, 1, 0, -height]);
    const cord1 = _util.Util.applyTransform([0, 0], maskToCanvas);
    const cord2 = _util.Util.applyTransform([width, height], maskToCanvas);
    const rect = _util.Util.normalizeRect([cord1[0], cord1[1], cord2[0], cord2[1]]);
    const drawnWidth = Math.round(rect[2] - rect[0]) || 1;
    const drawnHeight = Math.round(rect[3] - rect[1]) || 1;
    const fillCanvas = this.cachedCanvases.getCanvas("fillCanvas", drawnWidth, drawnHeight);
    const fillCtx = fillCanvas.context;
    const offsetX = Math.min(cord1[0], cord2[0]);
    const offsetY = Math.min(cord1[1], cord2[1]);
    fillCtx.translate(-offsetX, -offsetY);
    fillCtx.transform(...maskToCanvas);
    if (!scaled) {
      scaled = this._scaleImage(maskCanvas.canvas, (0, _display_utils.getCurrentTransformInverse)(fillCtx));
      scaled = scaled.img;
      if (cache && isPatternFill) {
        cache.set(cacheKey, scaled);
      }
    }
    fillCtx.imageSmoothingEnabled = getImageSmoothingEnabled((0, _display_utils.getCurrentTransform)(fillCtx), img.interpolate);
    drawImageAtIntegerCoords(fillCtx, scaled, 0, 0, scaled.width, scaled.height, 0, 0, width, height);
    fillCtx.globalCompositeOperation = "source-in";
    const inverse = _util.Util.transform((0, _display_utils.getCurrentTransformInverse)(fillCtx), [1, 0, 0, 1, -offsetX, -offsetY]);
    fillCtx.fillStyle = isPatternFill ? fillColor.getPattern(ctx, this, inverse, _pattern_helper.PathType.FILL) : fillColor;
    fillCtx.fillRect(0, 0, width, height);
    if (cache && !isPatternFill) {
      this.cachedCanvases.delete("fillCanvas");
      cache.set(cacheKey, fillCanvas.canvas);
    }
    return {
      canvas: fillCanvas.canvas,
      offsetX: Math.round(offsetX),
      offsetY: Math.round(offsetY)
    };
  }
  setLineWidth(width) {
    if (width !== this.current.lineWidth) {
      this._cachedScaleForStroking[0] = -1;
    }
    this.current.lineWidth = width;
    this.ctx.lineWidth = width;
  }
  setLineCap(style) {
    this.ctx.lineCap = LINE_CAP_STYLES[style];
  }
  setLineJoin(style) {
    this.ctx.lineJoin = LINE_JOIN_STYLES[style];
  }
  setMiterLimit(limit) {
    this.ctx.miterLimit = limit;
  }
  setDash(dashArray, dashPhase) {
    const ctx = this.ctx;
    if (ctx.setLineDash !== undefined) {
      ctx.setLineDash(dashArray);
      ctx.lineDashOffset = dashPhase;
    }
  }
  setRenderingIntent(intent) {}
  setFlatness(flatness) {}
  setGState(states) {
    for (const [key, value] of states) {
      switch (key) {
        case "LW":
          this.setLineWidth(value);
          break;
        case "LC":
          this.setLineCap(value);
          break;
        case "LJ":
          this.setLineJoin(value);
          break;
        case "ML":
          this.setMiterLimit(value);
          break;
        case "D":
          this.setDash(value[0], value[1]);
          break;
        case "RI":
          this.setRenderingIntent(value);
          break;
        case "FL":
          this.setFlatness(value);
          break;
        case "Font":
          this.setFont(value[0], value[1]);
          break;
        case "CA":
          this.current.strokeAlpha = value;
          break;
        case "ca":
          this.current.fillAlpha = value;
          this.ctx.globalAlpha = value;
          break;
        case "BM":
          this.ctx.globalCompositeOperation = value;
          break;
        case "SMask":
          this.current.activeSMask = value ? this.tempSMask : null;
          this.tempSMask = null;
          this.checkSMaskState();
          break;
        case "TR":
          this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(value);
          break;
      }
    }
  }
  get inSMaskMode() {
    return !!this.suspendedCtx;
  }
  checkSMaskState() {
    const inSMaskMode = this.inSMaskMode;
    if (this.current.activeSMask && !inSMaskMode) {
      this.beginSMaskMode();
    } else if (!this.current.activeSMask && inSMaskMode) {
      this.endSMaskMode();
    }
  }
  beginSMaskMode() {
    if (this.inSMaskMode) {
      throw new Error("beginSMaskMode called while already in smask mode");
    }
    const drawnWidth = this.ctx.canvas.width;
    const drawnHeight = this.ctx.canvas.height;
    const cacheId = "smaskGroupAt" + this.groupLevel;
    const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
    this.suspendedCtx = this.ctx;
    this.ctx = scratchCanvas.context;
    const ctx = this.ctx;
    ctx.setTransform(...(0, _display_utils.getCurrentTransform)(this.suspendedCtx));
    copyCtxState(this.suspendedCtx, ctx);
    mirrorContextOperations(ctx, this.suspendedCtx);
    this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
  }
  endSMaskMode() {
    if (!this.inSMaskMode) {
      throw new Error("endSMaskMode called while not in smask mode");
    }
    this.ctx._removeMirroring();
    copyCtxState(this.ctx, this.suspendedCtx);
    this.ctx = this.suspendedCtx;
    this.suspendedCtx = null;
  }
  compose(dirtyBox) {
    if (!this.current.activeSMask) {
      return;
    }
    if (!dirtyBox) {
      dirtyBox = [0, 0, this.ctx.canvas.width, this.ctx.canvas.height];
    } else {
      dirtyBox[0] = Math.floor(dirtyBox[0]);
      dirtyBox[1] = Math.floor(dirtyBox[1]);
      dirtyBox[2] = Math.ceil(dirtyBox[2]);
      dirtyBox[3] = Math.ceil(dirtyBox[3]);
    }
    const smask = this.current.activeSMask;
    const suspendedCtx = this.suspendedCtx;
    composeSMask(suspendedCtx, smask, this.ctx, dirtyBox);
    this.ctx.save();
    this.ctx.setTransform(1, 0, 0, 1, 0, 0);
    this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
    this.ctx.restore();
  }
  save() {
    if (this.inSMaskMode) {
      copyCtxState(this.ctx, this.suspendedCtx);
      this.suspendedCtx.save();
    } else {
      this.ctx.save();
    }
    const old = this.current;
    this.stateStack.push(old);
    this.current = old.clone();
  }
  restore() {
    if (this.stateStack.length === 0 && this.inSMaskMode) {
      this.endSMaskMode();
    }
    if (this.stateStack.length !== 0) {
      this.current = this.stateStack.pop();
      if (this.inSMaskMode) {
        this.suspendedCtx.restore();
        copyCtxState(this.suspendedCtx, this.ctx);
      } else {
        this.ctx.restore();
      }
      this.checkSMaskState();
      this.pendingClip = null;
      this._cachedScaleForStroking[0] = -1;
      this._cachedGetSinglePixelWidth = null;
    }
  }
  transform(a, b, c, d, e, f) {
    this.ctx.transform(a, b, c, d, e, f);
    this._cachedScaleForStroking[0] = -1;
    this._cachedGetSinglePixelWidth = null;
  }
  constructPath(ops, args, minMax) {
    const ctx = this.ctx;
    const current = this.current;
    let x = current.x,
      y = current.y;
    let startX, startY;
    const currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
    const isScalingMatrix = currentTransform[0] === 0 && currentTransform[3] === 0 || currentTransform[1] === 0 && currentTransform[2] === 0;
    const minMaxForBezier = isScalingMatrix ? minMax.slice(0) : null;
    for (let i = 0, j = 0, ii = ops.length; i < ii; i++) {
      switch (ops[i] | 0) {
        case _util.OPS.rectangle:
          x = args[j++];
          y = args[j++];
          const width = args[j++];
          const height = args[j++];
          const xw = x + width;
          const yh = y + height;
          ctx.moveTo(x, y);
          if (width === 0 || height === 0) {
            ctx.lineTo(xw, yh);
          } else {
            ctx.lineTo(xw, y);
            ctx.lineTo(xw, yh);
            ctx.lineTo(x, yh);
          }
          if (!isScalingMatrix) {
            current.updateRectMinMax(currentTransform, [x, y, xw, yh]);
          }
          ctx.closePath();
          break;
        case _util.OPS.moveTo:
          x = args[j++];
          y = args[j++];
          ctx.moveTo(x, y);
          if (!isScalingMatrix) {
            current.updatePathMinMax(currentTransform, x, y);
          }
          break;
        case _util.OPS.lineTo:
          x = args[j++];
          y = args[j++];
          ctx.lineTo(x, y);
          if (!isScalingMatrix) {
            current.updatePathMinMax(currentTransform, x, y);
          }
          break;
        case _util.OPS.curveTo:
          startX = x;
          startY = y;
          x = args[j + 4];
          y = args[j + 5];
          ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
          current.updateCurvePathMinMax(currentTransform, startX, startY, args[j], args[j + 1], args[j + 2], args[j + 3], x, y, minMaxForBezier);
          j += 6;
          break;
        case _util.OPS.curveTo2:
          startX = x;
          startY = y;
          ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
          current.updateCurvePathMinMax(currentTransform, startX, startY, x, y, args[j], args[j + 1], args[j + 2], args[j + 3], minMaxForBezier);
          x = args[j + 2];
          y = args[j + 3];
          j += 4;
          break;
        case _util.OPS.curveTo3:
          startX = x;
          startY = y;
          x = args[j + 2];
          y = args[j + 3];
          ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
          current.updateCurvePathMinMax(currentTransform, startX, startY, args[j], args[j + 1], x, y, x, y, minMaxForBezier);
          j += 4;
          break;
        case _util.OPS.closePath:
          ctx.closePath();
          break;
      }
    }
    if (isScalingMatrix) {
      current.updateScalingPathMinMax(currentTransform, minMaxForBezier);
    }
    current.setCurrentPoint(x, y);
  }
  closePath() {
    this.ctx.closePath();
  }
  stroke() {
    let consumePath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    const ctx = this.ctx;
    const strokeColor = this.current.strokeColor;
    ctx.globalAlpha = this.current.strokeAlpha;
    if (this.contentVisible) {
      if (typeof strokeColor === "object" && strokeColor?.getPattern) {
        ctx.save();
        ctx.strokeStyle = strokeColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.STROKE);
        this.rescaleAndStroke(false);
        ctx.restore();
      } else {
        this.rescaleAndStroke(true);
      }
    }
    if (consumePath) {
      this.consumePath(this.current.getClippedPathBoundingBox());
    }
    ctx.globalAlpha = this.current.fillAlpha;
  }
  closeStroke() {
    this.closePath();
    this.stroke();
  }
  fill() {
    let consumePath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    const ctx = this.ctx;
    const fillColor = this.current.fillColor;
    const isPatternFill = this.current.patternFill;
    let needRestore = false;
    if (isPatternFill) {
      ctx.save();
      ctx.fillStyle = fillColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL);
      needRestore = true;
    }
    const intersect = this.current.getClippedPathBoundingBox();
    if (this.contentVisible && intersect !== null) {
      if (this.pendingEOFill) {
        ctx.fill("evenodd");
        this.pendingEOFill = false;
      } else {
        ctx.fill();
      }
    }
    if (needRestore) {
      ctx.restore();
    }
    if (consumePath) {
      this.consumePath(intersect);
    }
  }
  eoFill() {
    this.pendingEOFill = true;
    this.fill();
  }
  fillStroke() {
    this.fill(false);
    this.stroke(false);
    this.consumePath();
  }
  eoFillStroke() {
    this.pendingEOFill = true;
    this.fillStroke();
  }
  closeFillStroke() {
    this.closePath();
    this.fillStroke();
  }
  closeEOFillStroke() {
    this.pendingEOFill = true;
    this.closePath();
    this.fillStroke();
  }
  endPath() {
    this.consumePath();
  }
  clip() {
    this.pendingClip = NORMAL_CLIP;
  }
  eoClip() {
    this.pendingClip = EO_CLIP;
  }
  beginText() {
    this.current.textMatrix = _util.IDENTITY_MATRIX;
    this.current.textMatrixScale = 1;
    this.current.x = this.current.lineX = 0;
    this.current.y = this.current.lineY = 0;
  }
  endText() {
    const paths = this.pendingTextPaths;
    const ctx = this.ctx;
    if (paths === undefined) {
      ctx.beginPath();
      return;
    }
    ctx.save();
    ctx.beginPath();
    for (const path of paths) {
      ctx.setTransform(...path.transform);
      ctx.translate(path.x, path.y);
      path.addToPath(ctx, path.fontSize);
    }
    ctx.restore();
    ctx.clip();
    ctx.beginPath();
    delete this.pendingTextPaths;
  }
  setCharSpacing(spacing) {
    this.current.charSpacing = spacing;
  }
  setWordSpacing(spacing) {
    this.current.wordSpacing = spacing;
  }
  setHScale(scale) {
    this.current.textHScale = scale / 100;
  }
  setLeading(leading) {
    this.current.leading = -leading;
  }
  setFont(fontRefName, size) {
    const fontObj = this.commonObjs.get(fontRefName);
    const current = this.current;
    if (!fontObj) {
      throw new Error(`Can't find font for ${fontRefName}`);
    }
    current.fontMatrix = fontObj.fontMatrix || _util.FONT_IDENTITY_MATRIX;
    if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) {
      (0, _util.warn)("Invalid font matrix for font " + fontRefName);
    }
    if (size < 0) {
      size = -size;
      current.fontDirection = -1;
    } else {
      current.fontDirection = 1;
    }
    this.current.font = fontObj;
    this.current.fontSize = size;
    if (fontObj.isType3Font) {
      return;
    }
    const name = fontObj.loadedName || "sans-serif";
    const typeface = fontObj.systemFontInfo?.css || `"${name}", ${fontObj.fallbackName}`;
    let bold = "normal";
    if (fontObj.black) {
      bold = "900";
    } else if (fontObj.bold) {
      bold = "bold";
    }
    const italic = fontObj.italic ? "italic" : "normal";
    let browserFontSize = size;
    if (size < MIN_FONT_SIZE) {
      browserFontSize = MIN_FONT_SIZE;
    } else if (size > MAX_FONT_SIZE) {
      browserFontSize = MAX_FONT_SIZE;
    }
    this.current.fontSizeScale = size / browserFontSize;
    this.ctx.font = `${italic} ${bold} ${browserFontSize}px ${typeface}`;
  }
  setTextRenderingMode(mode) {
    this.current.textRenderingMode = mode;
  }
  setTextRise(rise) {
    this.current.textRise = rise;
  }
  moveText(x, y) {
    this.current.x = this.current.lineX += x;
    this.current.y = this.current.lineY += y;
  }
  setLeadingMoveText(x, y) {
    this.setLeading(-y);
    this.moveText(x, y);
  }
  setTextMatrix(a, b, c, d, e, f) {
    this.current.textMatrix = [a, b, c, d, e, f];
    this.current.textMatrixScale = Math.hypot(a, b);
    this.current.x = this.current.lineX = 0;
    this.current.y = this.current.lineY = 0;
  }
  nextLine() {
    this.moveText(0, this.current.leading);
  }
  paintChar(character, x, y, patternTransform) {
    const ctx = this.ctx;
    const current = this.current;
    const font = current.font;
    const textRenderingMode = current.textRenderingMode;
    const fontSize = current.fontSize / current.fontSizeScale;
    const fillStrokeMode = textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
    const isAddToPathSet = !!(textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
    const patternFill = current.patternFill && !font.missingFile;
    let addToPath;
    if (font.disableFontFace || isAddToPathSet || patternFill) {
      addToPath = font.getPathGenerator(this.commonObjs, character);
    }
    if (font.disableFontFace || patternFill) {
      ctx.save();
      ctx.translate(x, y);
      ctx.beginPath();
      addToPath(ctx, fontSize);
      if (patternTransform) {
        ctx.setTransform(...patternTransform);
      }
      if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
        ctx.fill();
      }
      if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
        ctx.stroke();
      }
      ctx.restore();
    } else {
      if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
        ctx.fillText(character, x, y);
      }
      if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
        ctx.strokeText(character, x, y);
      }
    }
    if (isAddToPathSet) {
      const paths = this.pendingTextPaths ||= [];
      paths.push({
        transform: (0, _display_utils.getCurrentTransform)(ctx),
        x,
        y,
        fontSize,
        addToPath
      });
    }
  }
  get isFontSubpixelAAEnabled() {
    const {
      context: ctx
    } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
    ctx.scale(1.5, 1);
    ctx.fillText("I", 0, 10);
    const data = ctx.getImageData(0, 0, 10, 10).data;
    let enabled = false;
    for (let i = 3; i < data.length; i += 4) {
      if (data[i] > 0 && data[i] < 255) {
        enabled = true;
        break;
      }
    }
    return (0, _util.shadow)(this, "isFontSubpixelAAEnabled", enabled);
  }
  showText(glyphs) {
    const current = this.current;
    const font = current.font;
    if (font.isType3Font) {
      return this.showType3Text(glyphs);
    }
    const fontSize = current.fontSize;
    if (fontSize === 0) {
      return undefined;
    }
    const ctx = this.ctx;
    const fontSizeScale = current.fontSizeScale;
    const charSpacing = current.charSpacing;
    const wordSpacing = current.wordSpacing;
    const fontDirection = current.fontDirection;
    const textHScale = current.textHScale * fontDirection;
    const glyphsLength = glyphs.length;
    const vertical = font.vertical;
    const spacingDir = vertical ? 1 : -1;
    const defaultVMetrics = font.defaultVMetrics;
    const widthAdvanceScale = fontSize * current.fontMatrix[0];
    const simpleFillText = current.textRenderingMode === _util.TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
    ctx.save();
    ctx.transform(...current.textMatrix);
    ctx.translate(current.x, current.y + current.textRise);
    if (fontDirection > 0) {
      ctx.scale(textHScale, -1);
    } else {
      ctx.scale(textHScale, 1);
    }
    let patternTransform;
    if (current.patternFill) {
      ctx.save();
      const pattern = current.fillColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL);
      patternTransform = (0, _display_utils.getCurrentTransform)(ctx);
      ctx.restore();
      ctx.fillStyle = pattern;
    }
    let lineWidth = current.lineWidth;
    const scale = current.textMatrixScale;
    if (scale === 0 || lineWidth === 0) {
      const fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
      if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
        lineWidth = this.getSinglePixelWidth();
      }
    } else {
      lineWidth /= scale;
    }
    if (fontSizeScale !== 1.0) {
      ctx.scale(fontSizeScale, fontSizeScale);
      lineWidth /= fontSizeScale;
    }
    ctx.lineWidth = lineWidth;
    if (font.isInvalidPDFjsFont) {
      const chars = [];
      let width = 0;
      for (const glyph of glyphs) {
        chars.push(glyph.unicode);
        width += glyph.width;
      }
      ctx.fillText(chars.join(""), 0, 0);
      current.x += width * widthAdvanceScale * textHScale;
      ctx.restore();
      this.compose();
      return undefined;
    }
    let x = 0,
      i;
    for (i = 0; i < glyphsLength; ++i) {
      const glyph = glyphs[i];
      if (typeof glyph === "number") {
        x += spacingDir * glyph * fontSize / 1000;
        continue;
      }
      let restoreNeeded = false;
      const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
      const character = glyph.fontChar;
      const accent = glyph.accent;
      let scaledX, scaledY;
      let width = glyph.width;
      if (vertical) {
        const vmetric = glyph.vmetric || defaultVMetrics;
        const vx = -(glyph.vmetric ? vmetric[1] : width * 0.5) * widthAdvanceScale;
        const vy = vmetric[2] * widthAdvanceScale;
        width = vmetric ? -vmetric[0] : width;
        scaledX = vx / fontSizeScale;
        scaledY = (x + vy) / fontSizeScale;
      } else {
        scaledX = x / fontSizeScale;
        scaledY = 0;
      }
      if (font.remeasure && width > 0) {
        const measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;
        if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
          const characterScaleX = width / measuredWidth;
          restoreNeeded = true;
          ctx.save();
          ctx.scale(characterScaleX, 1);
          scaledX /= characterScaleX;
        } else if (width !== measuredWidth) {
          scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
        }
      }
      if (this.contentVisible && (glyph.isInFont || font.missingFile)) {
        if (simpleFillText && !accent) {
          ctx.fillText(character, scaledX, scaledY);
        } else {
          this.paintChar(character, scaledX, scaledY, patternTransform);
          if (accent) {
            const scaledAccentX = scaledX + fontSize * accent.offset.x / fontSizeScale;
            const scaledAccentY = scaledY - fontSize * accent.offset.y / fontSizeScale;
            this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY, patternTransform);
          }
        }
      }
      const charWidth = vertical ? width * widthAdvanceScale - spacing * fontDirection : width * widthAdvanceScale + spacing * fontDirection;
      x += charWidth;
      if (restoreNeeded) {
        ctx.restore();
      }
    }
    if (vertical) {
      current.y -= x;
    } else {
      current.x += x * textHScale;
    }
    ctx.restore();
    this.compose();
    return undefined;
  }
  showType3Text(glyphs) {
    const ctx = this.ctx;
    const current = this.current;
    const font = current.font;
    const fontSize = current.fontSize;
    const fontDirection = current.fontDirection;
    const spacingDir = font.vertical ? 1 : -1;
    const charSpacing = current.charSpacing;
    const wordSpacing = current.wordSpacing;
    const textHScale = current.textHScale * fontDirection;
    const fontMatrix = current.fontMatrix || _util.FONT_IDENTITY_MATRIX;
    const glyphsLength = glyphs.length;
    const isTextInvisible = current.textRenderingMode === _util.TextRenderingMode.INVISIBLE;
    let i, glyph, width, spacingLength;
    if (isTextInvisible || fontSize === 0) {
      return;
    }
    this._cachedScaleForStroking[0] = -1;
    this._cachedGetSinglePixelWidth = null;
    ctx.save();
    ctx.transform(...current.textMatrix);
    ctx.translate(current.x, current.y);
    ctx.scale(textHScale, fontDirection);
    for (i = 0; i < glyphsLength; ++i) {
      glyph = glyphs[i];
      if (typeof glyph === "number") {
        spacingLength = spacingDir * glyph * fontSize / 1000;
        this.ctx.translate(spacingLength, 0);
        current.x += spacingLength * textHScale;
        continue;
      }
      const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
      const operatorList = font.charProcOperatorList[glyph.operatorListId];
      if (!operatorList) {
        (0, _util.warn)(`Type3 character "${glyph.operatorListId}" is not available.`);
        continue;
      }
      if (this.contentVisible) {
        this.processingType3 = glyph;
        this.save();
        ctx.scale(fontSize, fontSize);
        ctx.transform(...fontMatrix);
        this.executeOperatorList(operatorList);
        this.restore();
      }
      const transformed = _util.Util.applyTransform([glyph.width, 0], fontMatrix);
      width = transformed[0] * fontSize + spacing;
      ctx.translate(width, 0);
      current.x += width * textHScale;
    }
    ctx.restore();
    this.processingType3 = null;
  }
  setCharWidth(xWidth, yWidth) {}
  setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
    this.ctx.rect(llx, lly, urx - llx, ury - lly);
    this.ctx.clip();
    this.endPath();
  }
  getColorN_Pattern(IR) {
    let pattern;
    if (IR[0] === "TilingPattern") {
      const color = IR[1];
      const baseTransform = this.baseTransform || (0, _display_utils.getCurrentTransform)(this.ctx);
      const canvasGraphicsFactory = {
        createCanvasGraphics: ctx => {
          return new CanvasGraphics(ctx, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
            optionalContentConfig: this.optionalContentConfig,
            markedContentStack: this.markedContentStack
          });
        }
      };
      pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
    } else {
      pattern = this._getPattern(IR[1], IR[2]);
    }
    return pattern;
  }
  setStrokeColorN() {
    this.current.strokeColor = this.getColorN_Pattern(arguments);
  }
  setFillColorN() {
    this.current.fillColor = this.getColorN_Pattern(arguments);
    this.current.patternFill = true;
  }
  setStrokeRGBColor(r, g, b) {
    const color = _util.Util.makeHexColor(r, g, b);
    this.ctx.strokeStyle = color;
    this.current.strokeColor = color;
  }
  setFillRGBColor(r, g, b) {
    const color = _util.Util.makeHexColor(r, g, b);
    this.ctx.fillStyle = color;
    this.current.fillColor = color;
    this.current.patternFill = false;
  }
  _getPattern(objId) {
    let matrix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    let pattern;
    if (this.cachedPatterns.has(objId)) {
      pattern = this.cachedPatterns.get(objId);
    } else {
      pattern = (0, _pattern_helper.getShadingPattern)(this.getObject(objId));
      this.cachedPatterns.set(objId, pattern);
    }
    if (matrix) {
      pattern.matrix = matrix;
    }
    return pattern;
  }
  shadingFill(objId) {
    if (!this.contentVisible) {
      return;
    }
    const ctx = this.ctx;
    this.save();
    const pattern = this._getPattern(objId);
    ctx.fillStyle = pattern.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.SHADING);
    const inv = (0, _display_utils.getCurrentTransformInverse)(ctx);
    if (inv) {
      const {
        width,
        height
      } = ctx.canvas;
      const [x0, y0, x1, y1] = _util.Util.getAxialAlignedBoundingBox([0, 0, width, height], inv);
      this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
    } else {
      this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
    }
    this.compose(this.current.getClippedPathBoundingBox());
    this.restore();
  }
  beginInlineImage() {
    (0, _util.unreachable)("Should not call beginInlineImage");
  }
  beginImageData() {
    (0, _util.unreachable)("Should not call beginImageData");
  }
  paintFormXObjectBegin(matrix, bbox) {
    if (!this.contentVisible) {
      return;
    }
    this.save();
    this.baseTransformStack.push(this.baseTransform);
    if (Array.isArray(matrix) && matrix.length === 6) {
      this.transform(...matrix);
    }
    this.baseTransform = (0, _display_utils.getCurrentTransform)(this.ctx);
    if (bbox) {
      const width = bbox[2] - bbox[0];
      const height = bbox[3] - bbox[1];
      this.ctx.rect(bbox[0], bbox[1], width, height);
      this.current.updateRectMinMax((0, _display_utils.getCurrentTransform)(this.ctx), bbox);
      this.clip();
      this.endPath();
    }
  }
  paintFormXObjectEnd() {
    if (!this.contentVisible) {
      return;
    }
    this.restore();
    this.baseTransform = this.baseTransformStack.pop();
  }
  beginGroup(group) {
    if (!this.contentVisible) {
      return;
    }
    this.save();
    if (this.inSMaskMode) {
      this.endSMaskMode();
      this.current.activeSMask = null;
    }
    const currentCtx = this.ctx;
    if (!group.isolated) {
      (0, _util.info)("TODO: Support non-isolated groups.");
    }
    if (group.knockout) {
      (0, _util.warn)("Knockout groups not supported.");
    }
    const currentTransform = (0, _display_utils.getCurrentTransform)(currentCtx);
    if (group.matrix) {
      currentCtx.transform(...group.matrix);
    }
    if (!group.bbox) {
      throw new Error("Bounding box is required.");
    }
    let bounds = _util.Util.getAxialAlignedBoundingBox(group.bbox, (0, _display_utils.getCurrentTransform)(currentCtx));
    const canvasBounds = [0, 0, currentCtx.canvas.width, currentCtx.canvas.height];
    bounds = _util.Util.intersect(bounds, canvasBounds) || [0, 0, 0, 0];
    const offsetX = Math.floor(bounds[0]);
    const offsetY = Math.floor(bounds[1]);
    let drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
    let drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
    let scaleX = 1,
      scaleY = 1;
    if (drawnWidth > MAX_GROUP_SIZE) {
      scaleX = drawnWidth / MAX_GROUP_SIZE;
      drawnWidth = MAX_GROUP_SIZE;
    }
    if (drawnHeight > MAX_GROUP_SIZE) {
      scaleY = drawnHeight / MAX_GROUP_SIZE;
      drawnHeight = MAX_GROUP_SIZE;
    }
    this.current.startNewPathAndClipBox([0, 0, drawnWidth, drawnHeight]);
    let cacheId = "groupAt" + this.groupLevel;
    if (group.smask) {
      cacheId += "_smask_" + this.smaskCounter++ % 2;
    }
    const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
    const groupCtx = scratchCanvas.context;
    groupCtx.scale(1 / scaleX, 1 / scaleY);
    groupCtx.translate(-offsetX, -offsetY);
    groupCtx.transform(...currentTransform);
    if (group.smask) {
      this.smaskStack.push({
        canvas: scratchCanvas.canvas,
        context: groupCtx,
        offsetX,
        offsetY,
        scaleX,
        scaleY,
        subtype: group.smask.subtype,
        backdrop: group.smask.backdrop,
        transferMap: group.smask.transferMap || null,
        startTransformInverse: null
      });
    } else {
      currentCtx.setTransform(1, 0, 0, 1, 0, 0);
      currentCtx.translate(offsetX, offsetY);
      currentCtx.scale(scaleX, scaleY);
      currentCtx.save();
    }
    copyCtxState(currentCtx, groupCtx);
    this.ctx = groupCtx;
    this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
    this.groupStack.push(currentCtx);
    this.groupLevel++;
  }
  endGroup(group) {
    if (!this.contentVisible) {
      return;
    }
    this.groupLevel--;
    const groupCtx = this.ctx;
    const ctx = this.groupStack.pop();
    this.ctx = ctx;
    this.ctx.imageSmoothingEnabled = false;
    if (group.smask) {
      this.tempSMask = this.smaskStack.pop();
      this.restore();
    } else {
      this.ctx.restore();
      const currentMtx = (0, _display_utils.getCurrentTransform)(this.ctx);
      this.restore();
      this.ctx.save();
      this.ctx.setTransform(...currentMtx);
      const dirtyBox = _util.Util.getAxialAlignedBoundingBox([0, 0, groupCtx.canvas.width, groupCtx.canvas.height], currentMtx);
      this.ctx.drawImage(groupCtx.canvas, 0, 0);
      this.ctx.restore();
      this.compose(dirtyBox);
    }
  }
  beginAnnotation(id, rect, transform, matrix, hasOwnCanvas) {
    this.#restoreInitialState();
    resetCtxToDefault(this.ctx);
    this.ctx.save();
    this.save();
    if (this.baseTransform) {
      this.ctx.setTransform(...this.baseTransform);
    }
    if (Array.isArray(rect) && rect.length === 4) {
      const width = rect[2] - rect[0];
      const height = rect[3] - rect[1];
      if (hasOwnCanvas && this.annotationCanvasMap) {
        transform = transform.slice();
        transform[4] -= rect[0];
        transform[5] -= rect[1];
        rect = rect.slice();
        rect[0] = rect[1] = 0;
        rect[2] = width;
        rect[3] = height;
        const [scaleX, scaleY] = _util.Util.singularValueDecompose2dScale((0, _display_utils.getCurrentTransform)(this.ctx));
        const {
          viewportScale
        } = this;
        const canvasWidth = Math.ceil(width * this.outputScaleX * viewportScale);
        const canvasHeight = Math.ceil(height * this.outputScaleY * viewportScale);
        this.annotationCanvas = this.canvasFactory.create(canvasWidth, canvasHeight);
        const {
          canvas,
          context
        } = this.annotationCanvas;
        this.annotationCanvasMap.set(id, canvas);
        this.annotationCanvas.savedCtx = this.ctx;
        this.ctx = context;
        this.ctx.save();
        this.ctx.setTransform(scaleX, 0, 0, -scaleY, 0, height * scaleY);
        resetCtxToDefault(this.ctx);
      } else {
        resetCtxToDefault(this.ctx);
        this.ctx.rect(rect[0], rect[1], width, height);
        this.ctx.clip();
        this.endPath();
      }
    }
    this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
    this.transform(...transform);
    this.transform(...matrix);
  }
  endAnnotation() {
    if (this.annotationCanvas) {
      this.ctx.restore();
      this.#drawFilter();
      this.ctx = this.annotationCanvas.savedCtx;
      delete this.annotationCanvas.savedCtx;
      delete this.annotationCanvas;
    }
  }
  paintImageMaskXObject(img) {
    if (!this.contentVisible) {
      return;
    }
    const count = img.count;
    img = this.getObject(img.data, img);
    img.count = count;
    const ctx = this.ctx;
    const glyph = this.processingType3;
    if (glyph) {
      if (glyph.compiled === undefined) {
        glyph.compiled = compileType3Glyph(img);
      }
      if (glyph.compiled) {
        glyph.compiled(ctx);
        return;
      }
    }
    const mask = this._createMaskCanvas(img);
    const maskCanvas = mask.canvas;
    ctx.save();
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.drawImage(maskCanvas, mask.offsetX, mask.offsetY);
    ctx.restore();
    this.compose();
  }
  paintImageMaskXObjectRepeat(img, scaleX) {
    let skewX = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    let skewY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    let scaleY = arguments.length > 4 ? arguments[4] : undefined;
    let positions = arguments.length > 5 ? arguments[5] : undefined;
    if (!this.contentVisible) {
      return;
    }
    img = this.getObject(img.data, img);
    const ctx = this.ctx;
    ctx.save();
    const currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
    ctx.transform(scaleX, skewX, skewY, scaleY, 0, 0);
    const mask = this._createMaskCanvas(img);
    ctx.setTransform(1, 0, 0, 1, mask.offsetX - currentTransform[4], mask.offsetY - currentTransform[5]);
    for (let i = 0, ii = positions.length; i < ii; i += 2) {
      const trans = _util.Util.transform(currentTransform, [scaleX, skewX, skewY, scaleY, positions[i], positions[i + 1]]);
      const [x, y] = _util.Util.applyTransform([0, 0], trans);
      ctx.drawImage(mask.canvas, x, y);
    }
    ctx.restore();
    this.compose();
  }
  paintImageMaskXObjectGroup(images) {
    if (!this.contentVisible) {
      return;
    }
    const ctx = this.ctx;
    const fillColor = this.current.fillColor;
    const isPatternFill = this.current.patternFill;
    for (const image of images) {
      const {
        data,
        width,
        height,
        transform
      } = image;
      const maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
      const maskCtx = maskCanvas.context;
      maskCtx.save();
      const img = this.getObject(data, image);
      putBinaryImageMask(maskCtx, img);
      maskCtx.globalCompositeOperation = "source-in";
      maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL) : fillColor;
      maskCtx.fillRect(0, 0, width, height);
      maskCtx.restore();
      ctx.save();
      ctx.transform(...transform);
      ctx.scale(1, -1);
      drawImageAtIntegerCoords(ctx, maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
      ctx.restore();
    }
    this.compose();
  }
  paintImageXObject(objId) {
    if (!this.contentVisible) {
      return;
    }
    const imgData = this.getObject(objId);
    if (!imgData) {
      (0, _util.warn)("Dependent image isn't ready yet");
      return;
    }
    this.paintInlineImageXObject(imgData);
  }
  paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
    if (!this.contentVisible) {
      return;
    }
    const imgData = this.getObject(objId);
    if (!imgData) {
      (0, _util.warn)("Dependent image isn't ready yet");
      return;
    }
    const width = imgData.width;
    const height = imgData.height;
    const map = [];
    for (let i = 0, ii = positions.length; i < ii; i += 2) {
      map.push({
        transform: [scaleX, 0, 0, scaleY, positions[i], positions[i + 1]],
        x: 0,
        y: 0,
        w: width,
        h: height
      });
    }
    this.paintInlineImageXObjectGroup(imgData, map);
  }
  applyTransferMapsToCanvas(ctx) {
    if (this.current.transferMaps !== "none") {
      ctx.filter = this.current.transferMaps;
      ctx.drawImage(ctx.canvas, 0, 0);
      ctx.filter = "none";
    }
    return ctx.canvas;
  }
  applyTransferMapsToBitmap(imgData) {
    if (this.current.transferMaps === "none") {
      return imgData.bitmap;
    }
    const {
      bitmap,
      width,
      height
    } = imgData;
    const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
    const tmpCtx = tmpCanvas.context;
    tmpCtx.filter = this.current.transferMaps;
    tmpCtx.drawImage(bitmap, 0, 0);
    tmpCtx.filter = "none";
    return tmpCanvas.canvas;
  }
  paintInlineImageXObject(imgData) {
    if (!this.contentVisible) {
      return;
    }
    const width = imgData.width;
    const height = imgData.height;
    const ctx = this.ctx;
    this.save();
    if (!_util.isNodeJS) {
      const {
        filter
      } = ctx;
      if (filter !== "none" && filter !== "") {
        ctx.filter = "none";
      }
    }
    ctx.scale(1 / width, -1 / height);
    let imgToPaint;
    if (imgData.bitmap) {
      imgToPaint = this.applyTransferMapsToBitmap(imgData);
    } else if (typeof HTMLElement === "function" && imgData instanceof HTMLElement || !imgData.data) {
      imgToPaint = imgData;
    } else {
      const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
      const tmpCtx = tmpCanvas.context;
      putBinaryImageData(tmpCtx, imgData);
      imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
    }
    const scaled = this._scaleImage(imgToPaint, (0, _display_utils.getCurrentTransformInverse)(ctx));
    ctx.imageSmoothingEnabled = getImageSmoothingEnabled((0, _display_utils.getCurrentTransform)(ctx), imgData.interpolate);
    drawImageAtIntegerCoords(ctx, scaled.img, 0, 0, scaled.paintWidth, scaled.paintHeight, 0, -height, width, height);
    this.compose();
    this.restore();
  }
  paintInlineImageXObjectGroup(imgData, map) {
    if (!this.contentVisible) {
      return;
    }
    const ctx = this.ctx;
    let imgToPaint;
    if (imgData.bitmap) {
      imgToPaint = imgData.bitmap;
    } else {
      const w = imgData.width;
      const h = imgData.height;
      const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", w, h);
      const tmpCtx = tmpCanvas.context;
      putBinaryImageData(tmpCtx, imgData);
      imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
    }
    for (const entry of map) {
      ctx.save();
      ctx.transform(...entry.transform);
      ctx.scale(1, -1);
      drawImageAtIntegerCoords(ctx, imgToPaint, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
      ctx.restore();
    }
    this.compose();
  }
  paintSolidColorImageMask() {
    if (!this.contentVisible) {
      return;
    }
    this.ctx.fillRect(0, 0, 1, 1);
    this.compose();
  }
  markPoint(tag) {}
  markPointProps(tag, properties) {}
  beginMarkedContent(tag) {
    this.markedContentStack.push({
      visible: true
    });
  }
  beginMarkedContentProps(tag, properties) {
    if (tag === "OC") {
      this.markedContentStack.push({
        visible: this.optionalContentConfig.isVisible(properties)
      });
    } else {
      this.markedContentStack.push({
        visible: true
      });
    }
    this.contentVisible = this.isContentVisible();
  }
  endMarkedContent() {
    this.markedContentStack.pop();
    this.contentVisible = this.isContentVisible();
  }
  beginCompat() {}
  endCompat() {}
  consumePath(clipBox) {
    const isEmpty = this.current.isEmptyClip();
    if (this.pendingClip) {
      this.current.updateClipFromPath();
    }
    if (!this.pendingClip) {
      this.compose(clipBox);
    }
    const ctx = this.ctx;
    if (this.pendingClip) {
      if (!isEmpty) {
        if (this.pendingClip === EO_CLIP) {
          ctx.clip("evenodd");
        } else {
          ctx.clip();
        }
      }
      this.pendingClip = null;
    }
    this.current.startNewPathAndClipBox(this.current.clipBox);
    ctx.beginPath();
  }
  getSinglePixelWidth() {
    if (!this._cachedGetSinglePixelWidth) {
      const m = (0, _display_utils.getCurrentTransform)(this.ctx);
      if (m[1] === 0 && m[2] === 0) {
        this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(m[0]), Math.abs(m[3]));
      } else {
        const absDet = Math.abs(m[0] * m[3] - m[2] * m[1]);
        const normX = Math.hypot(m[0], m[2]);
        const normY = Math.hypot(m[1], m[3]);
        this._cachedGetSinglePixelWidth = Math.max(normX, normY) / absDet;
      }
    }
    return this._cachedGetSinglePixelWidth;
  }
  getScaleForStroking() {
    if (this._cachedScaleForStroking[0] === -1) {
      const {
        lineWidth
      } = this.current;
      const {
        a,
        b,
        c,
        d
      } = this.ctx.getTransform();
      let scaleX, scaleY;
      if (b === 0 && c === 0) {
        const normX = Math.abs(a);
        const normY = Math.abs(d);
        if (normX === normY) {
          if (lineWidth === 0) {
            scaleX = scaleY = 1 / normX;
          } else {
            const scaledLineWidth = normX * lineWidth;
            scaleX = scaleY = scaledLineWidth < 1 ? 1 / scaledLineWidth : 1;
          }
        } else if (lineWidth === 0) {
          scaleX = 1 / normX;
          scaleY = 1 / normY;
        } else {
          const scaledXLineWidth = normX * lineWidth;
          const scaledYLineWidth = normY * lineWidth;
          scaleX = scaledXLineWidth < 1 ? 1 / scaledXLineWidth : 1;
          scaleY = scaledYLineWidth < 1 ? 1 / scaledYLineWidth : 1;
        }
      } else {
        const absDet = Math.abs(a * d - b * c);
        const normX = Math.hypot(a, b);
        const normY = Math.hypot(c, d);
        if (lineWidth === 0) {
          scaleX = normY / absDet;
          scaleY = normX / absDet;
        } else {
          const baseArea = lineWidth * absDet;
          scaleX = normY > baseArea ? normY / baseArea : 1;
          scaleY = normX > baseArea ? normX / baseArea : 1;
        }
      }
      this._cachedScaleForStroking[0] = scaleX;
      this._cachedScaleForStroking[1] = scaleY;
    }
    return this._cachedScaleForStroking;
  }
  rescaleAndStroke(saveRestore) {
    const {
      ctx
    } = this;
    const {
      lineWidth
    } = this.current;
    const [scaleX, scaleY] = this.getScaleForStroking();
    ctx.lineWidth = lineWidth || 1;
    if (scaleX === 1 && scaleY === 1) {
      ctx.stroke();
      return;
    }
    const dashes = ctx.getLineDash();
    if (saveRestore) {
      ctx.save();
    }
    ctx.scale(scaleX, scaleY);
    if (dashes.length > 0) {
      const scale = Math.max(scaleX, scaleY);
      ctx.setLineDash(dashes.map(x => x / scale));
      ctx.lineDashOffset /= scale;
    }
    ctx.stroke();
    if (saveRestore) {
      ctx.restore();
    }
  }
  isContentVisible() {
    for (let i = this.markedContentStack.length - 1; i >= 0; i--) {
      if (!this.markedContentStack[i].visible) {
        return false;
      }
    }
    return true;
  }
}
exports.CanvasGraphics = CanvasGraphics;
for (const op in _util.OPS) {
  if (CanvasGraphics.prototype[op] !== undefined) {
    CanvasGraphics.prototype[_util.OPS[op]] = CanvasGraphics.prototype[op];
  }
}

/***/ }),
/* 174 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TilingPattern = exports.PathType = void 0;
exports.getShadingPattern = getShadingPattern;
__w_pdfjs_require__(2);
var _util = __w_pdfjs_require__(1);
var _display_utils = __w_pdfjs_require__(168);
const PathType = {
  FILL: "Fill",
  STROKE: "Stroke",
  SHADING: "Shading"
};
exports.PathType = PathType;
function applyBoundingBox(ctx, bbox) {
  if (!bbox) {
    return;
  }
  const width = bbox[2] - bbox[0];
  const height = bbox[3] - bbox[1];
  const region = new Path2D();
  region.rect(bbox[0], bbox[1], width, height);
  ctx.clip(region);
}
class BaseShadingPattern {
  constructor() {
    if (this.constructor === BaseShadingPattern) {
      (0, _util.unreachable)("Cannot initialize BaseShadingPattern.");
    }
  }
  getPattern() {
    (0, _util.unreachable)("Abstract method `getPattern` called.");
  }
}
class RadialAxialShadingPattern extends BaseShadingPattern {
  constructor(IR) {
    super();
    this._type = IR[1];
    this._bbox = IR[2];
    this._colorStops = IR[3];
    this._p0 = IR[4];
    this._p1 = IR[5];
    this._r0 = IR[6];
    this._r1 = IR[7];
    this.matrix = null;
  }
  _createGradient(ctx) {
    let grad;
    if (this._type === "axial") {
      grad = ctx.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]);
    } else if (this._type === "radial") {
      grad = ctx.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1);
    }
    for (const colorStop of this._colorStops) {
      grad.addColorStop(colorStop[0], colorStop[1]);
    }
    return grad;
  }
  getPattern(ctx, owner, inverse, pathType) {
    let pattern;
    if (pathType === PathType.STROKE || pathType === PathType.FILL) {
      const ownerBBox = owner.current.getClippedPathBoundingBox(pathType, (0, _display_utils.getCurrentTransform)(ctx)) || [0, 0, 0, 0];
      const width = Math.ceil(ownerBBox[2] - ownerBBox[0]) || 1;
      const height = Math.ceil(ownerBBox[3] - ownerBBox[1]) || 1;
      const tmpCanvas = owner.cachedCanvases.getCanvas("pattern", width, height, true);
      const tmpCtx = tmpCanvas.context;
      tmpCtx.clearRect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
      tmpCtx.beginPath();
      tmpCtx.rect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
      tmpCtx.translate(-ownerBBox[0], -ownerBBox[1]);
      inverse = _util.Util.transform(inverse, [1, 0, 0, 1, ownerBBox[0], ownerBBox[1]]);
      tmpCtx.transform(...owner.baseTransform);
      if (this.matrix) {
        tmpCtx.transform(...this.matrix);
      }
      applyBoundingBox(tmpCtx, this._bbox);
      tmpCtx.fillStyle = this._createGradient(tmpCtx);
      tmpCtx.fill();
      pattern = ctx.createPattern(tmpCanvas.canvas, "no-repeat");
      const domMatrix = new DOMMatrix(inverse);
      pattern.setTransform(domMatrix);
    } else {
      applyBoundingBox(ctx, this._bbox);
      pattern = this._createGradient(ctx);
    }
    return pattern;
  }
}
function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
  const coords = context.coords,
    colors = context.colors;
  const bytes = data.data,
    rowSize = data.width * 4;
  let tmp;
  if (coords[p1 + 1] > coords[p2 + 1]) {
    tmp = p1;
    p1 = p2;
    p2 = tmp;
    tmp = c1;
    c1 = c2;
    c2 = tmp;
  }
  if (coords[p2 + 1] > coords[p3 + 1]) {
    tmp = p2;
    p2 = p3;
    p3 = tmp;
    tmp = c2;
    c2 = c3;
    c3 = tmp;
  }
  if (coords[p1 + 1] > coords[p2 + 1]) {
    tmp = p1;
    p1 = p2;
    p2 = tmp;
    tmp = c1;
    c1 = c2;
    c2 = tmp;
  }
  const x1 = (coords[p1] + context.offsetX) * context.scaleX;
  const y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
  const x2 = (coords[p2] + context.offsetX) * context.scaleX;
  const y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
  const x3 = (coords[p3] + context.offsetX) * context.scaleX;
  const y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
  if (y1 >= y3) {
    return;
  }
  const c1r = colors[c1],
    c1g = colors[c1 + 1],
    c1b = colors[c1 + 2];
  const c2r = colors[c2],
    c2g = colors[c2 + 1],
    c2b = colors[c2 + 2];
  const c3r = colors[c3],
    c3g = colors[c3 + 1],
    c3b = colors[c3 + 2];
  const minY = Math.round(y1),
    maxY = Math.round(y3);
  let xa, car, cag, cab;
  let xb, cbr, cbg, cbb;
  for (let y = minY; y <= maxY; y++) {
    if (y < y2) {
      const k = y < y1 ? 0 : (y1 - y) / (y1 - y2);
      xa = x1 - (x1 - x2) * k;
      car = c1r - (c1r - c2r) * k;
      cag = c1g - (c1g - c2g) * k;
      cab = c1b - (c1b - c2b) * k;
    } else {
      let k;
      if (y > y3) {
        k = 1;
      } else if (y2 === y3) {
        k = 0;
      } else {
        k = (y2 - y) / (y2 - y3);
      }
      xa = x2 - (x2 - x3) * k;
      car = c2r - (c2r - c3r) * k;
      cag = c2g - (c2g - c3g) * k;
      cab = c2b - (c2b - c3b) * k;
    }
    let k;
    if (y < y1) {
      k = 0;
    } else if (y > y3) {
      k = 1;
    } else {
      k = (y1 - y) / (y1 - y3);
    }
    xb = x1 - (x1 - x3) * k;
    cbr = c1r - (c1r - c3r) * k;
    cbg = c1g - (c1g - c3g) * k;
    cbb = c1b - (c1b - c3b) * k;
    const x1_ = Math.round(Math.min(xa, xb));
    const x2_ = Math.round(Math.max(xa, xb));
    let j = rowSize * y + x1_ * 4;
    for (let x = x1_; x <= x2_; x++) {
      k = (xa - x) / (xa - xb);
      if (k < 0) {
        k = 0;
      } else if (k > 1) {
        k = 1;
      }
      bytes[j++] = car - (car - cbr) * k | 0;
      bytes[j++] = cag - (cag - cbg) * k | 0;
      bytes[j++] = cab - (cab - cbb) * k | 0;
      bytes[j++] = 255;
    }
  }
}
function drawFigure(data, figure, context) {
  const ps = figure.coords;
  const cs = figure.colors;
  let i, ii;
  switch (figure.type) {
    case "lattice":
      const verticesPerRow = figure.verticesPerRow;
      const rows = Math.floor(ps.length / verticesPerRow) - 1;
      const cols = verticesPerRow - 1;
      for (i = 0; i < rows; i++) {
        let q = i * verticesPerRow;
        for (let j = 0; j < cols; j++, q++) {
          drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
          drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
        }
      }
      break;
    case "triangles":
      for (i = 0, ii = ps.length; i < ii; i += 3) {
        drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
      }
      break;
    default:
      throw new Error("illegal figure");
  }
}
class MeshShadingPattern extends BaseShadingPattern {
  constructor(IR) {
    super();
    this._coords = IR[2];
    this._colors = IR[3];
    this._figures = IR[4];
    this._bounds = IR[5];
    this._bbox = IR[7];
    this._background = IR[8];
    this.matrix = null;
  }
  _createMeshCanvas(combinedScale, backgroundColor, cachedCanvases) {
    const EXPECTED_SCALE = 1.1;
    const MAX_PATTERN_SIZE = 3000;
    const BORDER_SIZE = 2;
    const offsetX = Math.floor(this._bounds[0]);
    const offsetY = Math.floor(this._bounds[1]);
    const boundsWidth = Math.ceil(this._bounds[2]) - offsetX;
    const boundsHeight = Math.ceil(this._bounds[3]) - offsetY;
    const width = Math.min(Math.ceil(Math.abs(boundsWidth * combinedScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
    const height = Math.min(Math.ceil(Math.abs(boundsHeight * combinedScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
    const scaleX = boundsWidth / width;
    const scaleY = boundsHeight / height;
    const context = {
      coords: this._coords,
      colors: this._colors,
      offsetX: -offsetX,
      offsetY: -offsetY,
      scaleX: 1 / scaleX,
      scaleY: 1 / scaleY
    };
    const paddedWidth = width + BORDER_SIZE * 2;
    const paddedHeight = height + BORDER_SIZE * 2;
    const tmpCanvas = cachedCanvases.getCanvas("mesh", paddedWidth, paddedHeight, false);
    const tmpCtx = tmpCanvas.context;
    const data = tmpCtx.createImageData(width, height);
    if (backgroundColor) {
      const bytes = data.data;
      for (let i = 0, ii = bytes.length; i < ii; i += 4) {
        bytes[i] = backgroundColor[0];
        bytes[i + 1] = backgroundColor[1];
        bytes[i + 2] = backgroundColor[2];
        bytes[i + 3] = 255;
      }
    }
    for (const figure of this._figures) {
      drawFigure(data, figure, context);
    }
    tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
    const canvas = tmpCanvas.canvas;
    return {
      canvas,
      offsetX: offsetX - BORDER_SIZE * scaleX,
      offsetY: offsetY - BORDER_SIZE * scaleY,
      scaleX,
      scaleY
    };
  }
  getPattern(ctx, owner, inverse, pathType) {
    applyBoundingBox(ctx, this._bbox);
    let scale;
    if (pathType === PathType.SHADING) {
      scale = _util.Util.singularValueDecompose2dScale((0, _display_utils.getCurrentTransform)(ctx));
    } else {
      scale = _util.Util.singularValueDecompose2dScale(owner.baseTransform);
      if (this.matrix) {
        const matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
        scale = [scale[0] * matrixScale[0], scale[1] * matrixScale[1]];
      }
    }
    const temporaryPatternCanvas = this._createMeshCanvas(scale, pathType === PathType.SHADING ? null : this._background, owner.cachedCanvases);
    if (pathType !== PathType.SHADING) {
      ctx.setTransform(...owner.baseTransform);
      if (this.matrix) {
        ctx.transform(...this.matrix);
      }
    }
    ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
    ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
    return ctx.createPattern(temporaryPatternCanvas.canvas, "no-repeat");
  }
}
class DummyShadingPattern extends BaseShadingPattern {
  getPattern() {
    return "hotpink";
  }
}
function getShadingPattern(IR) {
  switch (IR[0]) {
    case "RadialAxial":
      return new RadialAxialShadingPattern(IR);
    case "Mesh":
      return new MeshShadingPattern(IR);
    case "Dummy":
      return new DummyShadingPattern();
  }
  throw new Error(`Unknown IR type: ${IR[0]}`);
}
const PaintType = {
  COLORED: 1,
  UNCOLORED: 2
};
class TilingPattern {
  static MAX_PATTERN_SIZE = 3000;
  constructor(IR, color, ctx, canvasGraphicsFactory, baseTransform) {
    this.operatorList = IR[2];
    this.matrix = IR[3] || [1, 0, 0, 1, 0, 0];
    this.bbox = IR[4];
    this.xstep = IR[5];
    this.ystep = IR[6];
    this.paintType = IR[7];
    this.tilingType = IR[8];
    this.color = color;
    this.ctx = ctx;
    this.canvasGraphicsFactory = canvasGraphicsFactory;
    this.baseTransform = baseTransform;
  }
  createPatternCanvas(owner) {
    const operatorList = this.operatorList;
    const bbox = this.bbox;
    const xstep = this.xstep;
    const ystep = this.ystep;
    const paintType = this.paintType;
    const tilingType = this.tilingType;
    const color = this.color;
    const canvasGraphicsFactory = this.canvasGraphicsFactory;
    (0, _util.info)("TilingType: " + tilingType);
    const x0 = bbox[0],
      y0 = bbox[1],
      x1 = bbox[2],
      y1 = bbox[3];
    const matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
    const curMatrixScale = _util.Util.singularValueDecompose2dScale(this.baseTransform);
    const combinedScale = [matrixScale[0] * curMatrixScale[0], matrixScale[1] * curMatrixScale[1]];
    const dimx = this.getSizeAndScale(xstep, this.ctx.canvas.width, combinedScale[0]);
    const dimy = this.getSizeAndScale(ystep, this.ctx.canvas.height, combinedScale[1]);
    const tmpCanvas = owner.cachedCanvases.getCanvas("pattern", dimx.size, dimy.size, true);
    const tmpCtx = tmpCanvas.context;
    const graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
    graphics.groupLevel = owner.groupLevel;
    this.setFillAndStrokeStyleToContext(graphics, paintType, color);
    let adjustedX0 = x0;
    let adjustedY0 = y0;
    let adjustedX1 = x1;
    let adjustedY1 = y1;
    if (x0 < 0) {
      adjustedX0 = 0;
      adjustedX1 += Math.abs(x0);
    }
    if (y0 < 0) {
      adjustedY0 = 0;
      adjustedY1 += Math.abs(y0);
    }
    tmpCtx.translate(-(dimx.scale * adjustedX0), -(dimy.scale * adjustedY0));
    graphics.transform(dimx.scale, 0, 0, dimy.scale, 0, 0);
    tmpCtx.save();
    this.clipBbox(graphics, adjustedX0, adjustedY0, adjustedX1, adjustedY1);
    graphics.baseTransform = (0, _display_utils.getCurrentTransform)(graphics.ctx);
    graphics.executeOperatorList(operatorList);
    graphics.endDrawing();
    return {
      canvas: tmpCanvas.canvas,
      scaleX: dimx.scale,
      scaleY: dimy.scale,
      offsetX: adjustedX0,
      offsetY: adjustedY0
    };
  }
  getSizeAndScale(step, realOutputSize, scale) {
    step = Math.abs(step);
    const maxSize = Math.max(TilingPattern.MAX_PATTERN_SIZE, realOutputSize);
    let size = Math.ceil(step * scale);
    if (size >= maxSize) {
      size = maxSize;
    } else {
      scale = size / step;
    }
    return {
      scale,
      size
    };
  }
  clipBbox(graphics, x0, y0, x1, y1) {
    const bboxWidth = x1 - x0;
    const bboxHeight = y1 - y0;
    graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
    graphics.current.updateRectMinMax((0, _display_utils.getCurrentTransform)(graphics.ctx), [x0, y0, x1, y1]);
    graphics.clip();
    graphics.endPath();
  }
  setFillAndStrokeStyleToContext(graphics, paintType, color) {
    const context = graphics.ctx,
      current = graphics.current;
    switch (paintType) {
      case PaintType.COLORED:
        const ctx = this.ctx;
        context.fillStyle = ctx.fillStyle;
        context.strokeStyle = ctx.strokeStyle;
        current.fillColor = ctx.fillStyle;
        current.strokeColor = ctx.strokeStyle;
        break;
      case PaintType.UNCOLORED:
        const cssColor = _util.Util.makeHexColor(color[0], color[1], color[2]);
        context.fillStyle = cssColor;
        context.strokeStyle = cssColor;
        current.fillColor = cssColor;
        current.strokeColor = cssColor;
        break;
      default:
        throw new _util.FormatError(`Unsupported paint type: ${paintType}`);
    }
  }
  getPattern(ctx, owner, inverse, pathType) {
    let matrix = inverse;
    if (pathType !== PathType.SHADING) {
      matrix = _util.Util.transform(matrix, owner.baseTransform);
      if (this.matrix) {
        matrix = _util.Util.transform(matrix, this.matrix);
      }
    }
    const temporaryPatternCanvas = this.createPatternCanvas(owner);
    let domMatrix = new DOMMatrix(matrix);
    domMatrix = domMatrix.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
    domMatrix = domMatrix.scale(1 / temporaryPatternCanvas.scaleX, 1 / temporaryPatternCanvas.scaleY);
    const pattern = ctx.createPattern(temporaryPatternCanvas.canvas, "repeat");
    pattern.setTransform(domMatrix);
    return pattern;
  }
}
exports.TilingPattern = TilingPattern;

/***/ }),
/* 175 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.convertBlackAndWhiteToRGBA = convertBlackAndWhiteToRGBA;
exports.convertToRGBA = convertToRGBA;
exports.grayToRGBA = grayToRGBA;
__w_pdfjs_require__(93);
__w_pdfjs_require__(101);
__w_pdfjs_require__(102);
__w_pdfjs_require__(105);
__w_pdfjs_require__(107);
__w_pdfjs_require__(109);
__w_pdfjs_require__(113);
__w_pdfjs_require__(116);
__w_pdfjs_require__(123);
var _util = __w_pdfjs_require__(1);
function convertToRGBA(params) {
  switch (params.kind) {
    case _util.ImageKind.GRAYSCALE_1BPP:
      return convertBlackAndWhiteToRGBA(params);
    case _util.ImageKind.RGB_24BPP:
      return convertRGBToRGBA(params);
  }
  return null;
}
function convertBlackAndWhiteToRGBA(_ref) {
  let {
    src,
    srcPos = 0,
    dest,
    width,
    height,
    nonBlackColor = 0xffffffff,
    inverseDecode = false
  } = _ref;
  const black = _util.FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
  const [zeroMapping, oneMapping] = inverseDecode ? [nonBlackColor, black] : [black, nonBlackColor];
  const widthInSource = width >> 3;
  const widthRemainder = width & 7;
  const srcLength = src.length;
  dest = new Uint32Array(dest.buffer);
  let destPos = 0;
  for (let i = 0; i < height; i++) {
    for (const max = srcPos + widthInSource; srcPos < max; srcPos++) {
      const elem = srcPos < srcLength ? src[srcPos] : 255;
      dest[destPos++] = elem & 0b10000000 ? oneMapping : zeroMapping;
      dest[destPos++] = elem & 0b1000000 ? oneMapping : zeroMapping;
      dest[destPos++] = elem & 0b100000 ? oneMapping : zeroMapping;
      dest[destPos++] = elem & 0b10000 ? oneMapping : zeroMapping;
      dest[destPos++] = elem & 0b1000 ? oneMapping : zeroMapping;
      dest[destPos++] = elem & 0b100 ? oneMapping : zeroMapping;
      dest[destPos++] = elem & 0b10 ? oneMapping : zeroMapping;
      dest[destPos++] = elem & 0b1 ? oneMapping : zeroMapping;
    }
    if (widthRemainder === 0) {
      continue;
    }
    const elem = srcPos < srcLength ? src[srcPos++] : 255;
    for (let j = 0; j < widthRemainder; j++) {
      dest[destPos++] = elem & 1 << 7 - j ? oneMapping : zeroMapping;
    }
  }
  return {
    srcPos,
    destPos
  };
}
function convertRGBToRGBA(_ref2) {
  let {
    src,
    srcPos = 0,
    dest,
    destPos = 0,
    width,
    height
  } = _ref2;
  let i = 0;
  const len32 = src.length >> 2;
  const src32 = new Uint32Array(src.buffer, srcPos, len32);
  if (_util.FeatureTest.isLittleEndian) {
    for (; i < len32 - 2; i += 3, destPos += 4) {
      const s1 = src32[i];
      const s2 = src32[i + 1];
      const s3 = src32[i + 2];
      dest[destPos] = s1 | 0xff000000;
      dest[destPos + 1] = s1 >>> 24 | s2 << 8 | 0xff000000;
      dest[destPos + 2] = s2 >>> 16 | s3 << 16 | 0xff000000;
      dest[destPos + 3] = s3 >>> 8 | 0xff000000;
    }
    for (let j = i * 4, jj = src.length; j < jj; j += 3) {
      dest[destPos++] = src[j] | src[j + 1] << 8 | src[j + 2] << 16 | 0xff000000;
    }
  } else {
    for (; i < len32 - 2; i += 3, destPos += 4) {
      const s1 = src32[i];
      const s2 = src32[i + 1];
      const s3 = src32[i + 2];
      dest[destPos] = s1 | 0xff;
      dest[destPos + 1] = s1 << 24 | s2 >>> 8 | 0xff;
      dest[destPos + 2] = s2 << 16 | s3 >>> 16 | 0xff;
      dest[destPos + 3] = s3 << 8 | 0xff;
    }
    for (let j = i * 4, jj = src.length; j < jj; j += 3) {
      dest[destPos++] = src[j] << 24 | src[j + 1] << 16 | src[j + 2] << 8 | 0xff;
    }
  }
  return {
    srcPos,
    destPos
  };
}
function grayToRGBA(src, dest) {
  if (_util.FeatureTest.isLittleEndian) {
    for (let i = 0, ii = src.length; i < ii; i++) {
      dest[i] = src[i] * 0x10101 | 0xff000000;
    }
  } else {
    for (let i = 0, ii = src.length; i < ii; i++) {
      dest[i] = src[i] * 0x1010100 | 0x000000ff;
    }
  }
}

/***/ }),
/* 176 */
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.GlobalWorkerOptions = void 0;
const GlobalWorkerOptions = Object.create(null);
exports.GlobalWorkerOptions = GlobalWorkerOptions;
GlobalWorkerOptions.workerPort = null;
GlobalWorkerOptions.workerSrc = "";

/***/ }),
/* 177 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.MessageHandler = void 0;
__w_pdfjs_require__(2);
var _util = __w_pdfjs_require__(1);
const CallbackKind = {
  UNKNOWN: 0,
  DATA: 1,
  ERROR: 2
};
const StreamKind = {
  UNKNOWN: 0,
  CANCEL: 1,
  CANCEL_COMPLETE: 2,
  CLOSE: 3,
  ENQUEUE: 4,
  ERROR: 5,
  PULL: 6,
  PULL_COMPLETE: 7,
  START_COMPLETE: 8
};
function wrapReason(reason) {
  if (!(reason instanceof Error || typeof reason === "object" && reason !== null)) {
    (0, _util.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
  }
  switch (reason.name) {
    case "AbortException":
      return new _util.AbortException(reason.message);
    case "MissingPDFException":
      return new _util.MissingPDFException(reason.message);
    case "PasswordException":
      return new _util.PasswordException(reason.message, reason.code);
    case "UnexpectedResponseException":
      return new _util.UnexpectedResponseException(reason.message, reason.status);
    case "UnknownErrorException":
      return new _util.UnknownErrorException(reason.message, reason.details);
    default:
      return new _util.UnknownErrorException(reason.message, reason.toString());
  }
}
class MessageHandler {
  constructor(sourceName, targetName, comObj) {
    this.sourceName = sourceName;
    this.targetName = targetName;
    this.comObj = comObj;
    this.callbackId = 1;
    this.streamId = 1;
    this.streamSinks = Object.create(null);
    this.streamControllers = Object.create(null);
    this.callbackCapabilities = Object.create(null);
    this.actionHandler = Object.create(null);
    this._onComObjOnMessage = event => {
      const data = event.data;
      if (data.targetName !== this.sourceName) {
        return;
      }
      if (data.stream) {
        this.#processStreamMessage(data);
        return;
      }
      if (data.callback) {
        const callbackId = data.callbackId;
        const capability = this.callbackCapabilities[callbackId];
        if (!capability) {
          throw new Error(`Cannot resolve callback ${callbackId}`);
        }
        delete this.callbackCapabilities[callbackId];
        if (data.callback === CallbackKind.DATA) {
          capability.resolve(data.data);
        } else if (data.callback === CallbackKind.ERROR) {
          capability.reject(wrapReason(data.reason));
        } else {
          throw new Error("Unexpected callback case");
        }
        return;
      }
      const action = this.actionHandler[data.action];
      if (!action) {
        throw new Error(`Unknown action from worker: ${data.action}`);
      }
      if (data.callbackId) {
        const cbSourceName = this.sourceName;
        const cbTargetName = data.sourceName;
        new Promise(function (resolve) {
          resolve(action(data.data));
        }).then(function (result) {
          comObj.postMessage({
            sourceName: cbSourceName,
            targetName: cbTargetName,
            callback: CallbackKind.DATA,
            callbackId: data.callbackId,
            data: result
          });
        }, function (reason) {
          comObj.postMessage({
            sourceName: cbSourceName,
            targetName: cbTargetName,
            callback: CallbackKind.ERROR,
            callbackId: data.callbackId,
            reason: wrapReason(reason)
          });
        });
        return;
      }
      if (data.streamId) {
        this.#createStreamSink(data);
        return;
      }
      action(data.data);
    };
    comObj.addEventListener("message", this._onComObjOnMessage);
  }
  on(actionName, handler) {
    const ah = this.actionHandler;
    if (ah[actionName]) {
      throw new Error(`There is already an actionName called "${actionName}"`);
    }
    ah[actionName] = handler;
  }
  send(actionName, data, transfers) {
    this.comObj.postMessage({
      sourceName: this.sourceName,
      targetName: this.targetName,
      action: actionName,
      data
    }, transfers);
  }
  sendWithPromise(actionName, data, transfers) {
    const callbackId = this.callbackId++;
    const capability = new _util.PromiseCapability();
    this.callbackCapabilities[callbackId] = capability;
    try {
      this.comObj.postMessage({
        sourceName: this.sourceName,
        targetName: this.targetName,
        action: actionName,
        callbackId,
        data
      }, transfers);
    } catch (ex) {
      capability.reject(ex);
    }
    return capability.promise;
  }
  sendWithStream(actionName, data, queueingStrategy, transfers) {
    const streamId = this.streamId++,
      sourceName = this.sourceName,
      targetName = this.targetName,
      comObj = this.comObj;
    return new ReadableStream({
      start: controller => {
        const startCapability = new _util.PromiseCapability();
        this.streamControllers[streamId] = {
          controller,
          startCall: startCapability,
          pullCall: null,
          cancelCall: null,
          isClosed: false
        };
        comObj.postMessage({
          sourceName,
          targetName,
          action: actionName,
          streamId,
          data,
          desiredSize: controller.desiredSize
        }, transfers);
        return startCapability.promise;
      },
      pull: controller => {
        const pullCapability = new _util.PromiseCapability();
        this.streamControllers[streamId].pullCall = pullCapability;
        comObj.postMessage({
          sourceName,
          targetName,
          stream: StreamKind.PULL,
          streamId,
          desiredSize: controller.desiredSize
        });
        return pullCapability.promise;
      },
      cancel: reason => {
        (0, _util.assert)(reason instanceof Error, "cancel must have a valid reason");
        const cancelCapability = new _util.PromiseCapability();
        this.streamControllers[streamId].cancelCall = cancelCapability;
        this.streamControllers[streamId].isClosed = true;
        comObj.postMessage({
          sourceName,
          targetName,
          stream: StreamKind.CANCEL,
          streamId,
          reason: wrapReason(reason)
        });
        return cancelCapability.promise;
      }
    }, queueingStrategy);
  }
  #createStreamSink(data) {
    const streamId = data.streamId,
      sourceName = this.sourceName,
      targetName = data.sourceName,
      comObj = this.comObj;
    const self = this,
      action = this.actionHandler[data.action];
    const streamSink = {
      enqueue(chunk) {
        let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
        let transfers = arguments.length > 2 ? arguments[2] : undefined;
        if (this.isCancelled) {
          return;
        }
        const lastDesiredSize = this.desiredSize;
        this.desiredSize -= size;
        if (lastDesiredSize > 0 && this.desiredSize <= 0) {
          this.sinkCapability = new _util.PromiseCapability();
          this.ready = this.sinkCapability.promise;
        }
        comObj.postMessage({
          sourceName,
          targetName,
          stream: StreamKind.ENQUEUE,
          streamId,
          chunk
        }, transfers);
      },
      close() {
        if (this.isCancelled) {
          return;
        }
        this.isCancelled = true;
        comObj.postMessage({
          sourceName,
          targetName,
          stream: StreamKind.CLOSE,
          streamId
        });
        delete self.streamSinks[streamId];
      },
      error(reason) {
        (0, _util.assert)(reason instanceof Error, "error must have a valid reason");
        if (this.isCancelled) {
          return;
        }
        this.isCancelled = true;
        comObj.postMessage({
          sourceName,
          targetName,
          stream: StreamKind.ERROR,
          streamId,
          reason: wrapReason(reason)
        });
      },
      sinkCapability: new _util.PromiseCapability(),
      onPull: null,
      onCancel: null,
      isCancelled: false,
      desiredSize: data.desiredSize,
      ready: null
    };
    streamSink.sinkCapability.resolve();
    streamSink.ready = streamSink.sinkCapability.promise;
    this.streamSinks[streamId] = streamSink;
    new Promise(function (resolve) {
      resolve(action(data.data, streamSink));
    }).then(function () {
      comObj.postMessage({
        sourceName,
        targetName,
        stream: StreamKind.START_COMPLETE,
        streamId,
        success: true
      });
    }, function (reason) {
      comObj.postMessage({
        sourceName,
        targetName,
        stream: StreamKind.START_COMPLETE,
        streamId,
        reason: wrapReason(reason)
      });
    });
  }
  #processStreamMessage(data) {
    const streamId = data.streamId,
      sourceName = this.sourceName,
      targetName = data.sourceName,
      comObj = this.comObj;
    const streamController = this.streamControllers[streamId],
      streamSink = this.streamSinks[streamId];
    switch (data.stream) {
      case StreamKind.START_COMPLETE:
        if (data.success) {
          streamController.startCall.resolve();
        } else {
          streamController.startCall.reject(wrapReason(data.reason));
        }
        break;
      case StreamKind.PULL_COMPLETE:
        if (data.success) {
          streamController.pullCall.resolve();
        } else {
          streamController.pullCall.reject(wrapReason(data.reason));
        }
        break;
      case StreamKind.PULL:
        if (!streamSink) {
          comObj.postMessage({
            sourceName,
            targetName,
            stream: StreamKind.PULL_COMPLETE,
            streamId,
            success: true
          });
          break;
        }
        if (streamSink.desiredSize <= 0 && data.desiredSize > 0) {
          streamSink.sinkCapability.resolve();
        }
        streamSink.desiredSize = data.desiredSize;
        new Promise(function (resolve) {
          resolve(streamSink.onPull?.());
        }).then(function () {
          comObj.postMessage({
            sourceName,
            targetName,
            stream: StreamKind.PULL_COMPLETE,
            streamId,
            success: true
          });
        }, function (reason) {
          comObj.postMessage({
            sourceName,
            targetName,
            stream: StreamKind.PULL_COMPLETE,
            streamId,
            reason: wrapReason(reason)
          });
        });
        break;
      case StreamKind.ENQUEUE:
        (0, _util.assert)(streamController, "enqueue should have stream controller");
        if (streamController.isClosed) {
          break;
        }
        streamController.controller.enqueue(data.chunk);
        break;
      case StreamKind.CLOSE:
        (0, _util.assert)(streamController, "close should have stream controller");
        if (streamController.isClosed) {
          break;
        }
        streamController.isClosed = true;
        streamController.controller.close();
        this.#deleteStreamController(streamController, streamId);
        break;
      case StreamKind.ERROR:
        (0, _util.assert)(streamController, "error should have stream controller");
        streamController.controller.error(wrapReason(data.reason));
        this.#deleteStreamController(streamController, streamId);
        break;
      case StreamKind.CANCEL_COMPLETE:
        if (data.success) {
          streamController.cancelCall.resolve();
        } else {
          streamController.cancelCall.reject(wrapReason(data.reason));
        }
        this.#deleteStreamController(streamController, streamId);
        break;
      case StreamKind.CANCEL:
        if (!streamSink) {
          break;
        }
        new Promise(function (resolve) {
          resolve(streamSink.onCancel?.(wrapReason(data.reason)));
        }).then(function () {
          comObj.postMessage({
            sourceName,
            targetName,
            stream: StreamKind.CANCEL_COMPLETE,
            streamId,
            success: true
          });
        }, function (reason) {
          comObj.postMessage({
            sourceName,
            targetName,
            stream: StreamKind.CANCEL_COMPLETE,
            streamId,
            reason: wrapReason(reason)
          });
        });
        streamSink.sinkCapability.reject(wrapReason(data.reason));
        streamSink.isCancelled = true;
        delete this.streamSinks[streamId];
        break;
      default:
        throw new Error("Unexpected stream case");
    }
  }
  async #deleteStreamController(streamController, streamId) {
    await Promise.allSettled([streamController.startCall?.promise, streamController.pullCall?.promise, streamController.cancelCall?.promise]);
    delete this.streamControllers[streamId];
  }
  destroy() {
    this.comObj.removeEventListener("message", this._onComObjOnMessage);
  }
}
exports.MessageHandler = MessageHandler;

/***/ }),
/* 178 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.Metadata = void 0;
var _util = __w_pdfjs_require__(1);
class Metadata {
  #metadataMap;
  #data;
  constructor(_ref) {
    let {
      parsedData,
      rawData
    } = _ref;
    this.#metadataMap = parsedData;
    this.#data = rawData;
  }
  getRaw() {
    return this.#data;
  }
  get(name) {
    return this.#metadataMap.get(name) ?? null;
  }
  getAll() {
    return (0, _util.objectFromMap)(this.#metadataMap);
  }
  has(name) {
    return this.#metadataMap.has(name);
  }
}
exports.Metadata = Metadata;

/***/ }),
/* 179 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.OptionalContentConfig = void 0;
var _util = __w_pdfjs_require__(1);
var _murmurhash = __w_pdfjs_require__(170);
const INTERNAL = Symbol("INTERNAL");
class OptionalContentGroup {
  #visible = true;
  constructor(name, intent) {
    this.name = name;
    this.intent = intent;
  }
  get visible() {
    return this.#visible;
  }
  _setVisible(internal, visible) {
    if (internal !== INTERNAL) {
      (0, _util.unreachable)("Internal method `_setVisible` called.");
    }
    this.#visible = visible;
  }
}
class OptionalContentConfig {
  #cachedGetHash = null;
  #groups = new Map();
  #initialHash = null;
  #order = null;
  constructor(data) {
    this.name = null;
    this.creator = null;
    if (data === null) {
      return;
    }
    this.name = data.name;
    this.creator = data.creator;
    this.#order = data.order;
    for (const group of data.groups) {
      this.#groups.set(group.id, new OptionalContentGroup(group.name, group.intent));
    }
    if (data.baseState === "OFF") {
      for (const group of this.#groups.values()) {
        group._setVisible(INTERNAL, false);
      }
    }
    for (const on of data.on) {
      this.#groups.get(on)._setVisible(INTERNAL, true);
    }
    for (const off of data.off) {
      this.#groups.get(off)._setVisible(INTERNAL, false);
    }
    this.#initialHash = this.getHash();
  }
  #evaluateVisibilityExpression(array) {
    const length = array.length;
    if (length < 2) {
      return true;
    }
    const operator = array[0];
    for (let i = 1; i < length; i++) {
      const element = array[i];
      let state;
      if (Array.isArray(element)) {
        state = this.#evaluateVisibilityExpression(element);
      } else if (this.#groups.has(element)) {
        state = this.#groups.get(element).visible;
      } else {
        (0, _util.warn)(`Optional content group not found: ${element}`);
        return true;
      }
      switch (operator) {
        case "And":
          if (!state) {
            return false;
          }
          break;
        case "Or":
          if (state) {
            return true;
          }
          break;
        case "Not":
          return !state;
        default:
          return true;
      }
    }
    return operator === "And";
  }
  isVisible(group) {
    if (this.#groups.size === 0) {
      return true;
    }
    if (!group) {
      (0, _util.warn)("Optional content group not defined.");
      return true;
    }
    if (group.type === "OCG") {
      if (!this.#groups.has(group.id)) {
        (0, _util.warn)(`Optional content group not found: ${group.id}`);
        return true;
      }
      return this.#groups.get(group.id).visible;
    } else if (group.type === "OCMD") {
      if (group.expression) {
        return this.#evaluateVisibilityExpression(group.expression);
      }
      if (!group.policy || group.policy === "AnyOn") {
        for (const id of group.ids) {
          if (!this.#groups.has(id)) {
            (0, _util.warn)(`Optional content group not found: ${id}`);
            return true;
          }
          if (this.#groups.get(id).visible) {
            return true;
          }
        }
        return false;
      } else if (group.policy === "AllOn") {
        for (const id of group.ids) {
          if (!this.#groups.has(id)) {
            (0, _util.warn)(`Optional content group not found: ${id}`);
            return true;
          }
          if (!this.#groups.get(id).visible) {
            return false;
          }
        }
        return true;
      } else if (group.policy === "AnyOff") {
        for (const id of group.ids) {
          if (!this.#groups.has(id)) {
            (0, _util.warn)(`Optional content group not found: ${id}`);
            return true;
          }
          if (!this.#groups.get(id).visible) {
            return true;
          }
        }
        return false;
      } else if (group.policy === "AllOff") {
        for (const id of group.ids) {
          if (!this.#groups.has(id)) {
            (0, _util.warn)(`Optional content group not found: ${id}`);
            return true;
          }
          if (this.#groups.get(id).visible) {
            return false;
          }
        }
        return true;
      }
      (0, _util.warn)(`Unknown optional content policy ${group.policy}.`);
      return true;
    }
    (0, _util.warn)(`Unknown group type ${group.type}.`);
    return true;
  }
  setVisibility(id) {
    let visible = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (!this.#groups.has(id)) {
      (0, _util.warn)(`Optional content group not found: ${id}`);
      return;
    }
    this.#groups.get(id)._setVisible(INTERNAL, !!visible);
    this.#cachedGetHash = null;
  }
  get hasInitialVisibility() {
    return this.#initialHash === null || this.getHash() === this.#initialHash;
  }
  getOrder() {
    if (!this.#groups.size) {
      return null;
    }
    if (this.#order) {
      return this.#order.slice();
    }
    return [...this.#groups.keys()];
  }
  getGroups() {
    return this.#groups.size > 0 ? (0, _util.objectFromMap)(this.#groups) : null;
  }
  getGroup(id) {
    return this.#groups.get(id) || null;
  }
  getHash() {
    if (this.#cachedGetHash !== null) {
      return this.#cachedGetHash;
    }
    const hash = new _murmurhash.MurmurHash3_64();
    for (const [id, group] of this.#groups) {
      hash.update(`${id}:${group.visible}`);
    }
    return this.#cachedGetHash = hash.hexdigest();
  }
}
exports.OptionalContentConfig = OptionalContentConfig;

/***/ }),
/* 180 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.PDFDataTransportStream = void 0;
__w_pdfjs_require__(93);
__w_pdfjs_require__(101);
__w_pdfjs_require__(102);
__w_pdfjs_require__(105);
__w_pdfjs_require__(107);
__w_pdfjs_require__(109);
__w_pdfjs_require__(113);
__w_pdfjs_require__(116);
__w_pdfjs_require__(123);
__w_pdfjs_require__(89);
var _util = __w_pdfjs_require__(1);
var _display_utils = __w_pdfjs_require__(168);
class PDFDataTransportStream {
  constructor(_ref, pdfDataRangeTransport) {
    let {
      length,
      initialData,
      progressiveDone = false,
      contentDispositionFilename = null,
      disableRange = false,
      disableStream = false
    } = _ref;
    (0, _util.assert)(pdfDataRangeTransport, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
    this._queuedChunks = [];
    this._progressiveDone = progressiveDone;
    this._contentDispositionFilename = contentDispositionFilename;
    if (initialData?.length > 0) {
      const buffer = initialData instanceof Uint8Array && initialData.byteLength === initialData.buffer.byteLength ? initialData.buffer : new Uint8Array(initialData).buffer;
      this._queuedChunks.push(buffer);
    }
    this._pdfDataRangeTransport = pdfDataRangeTransport;
    this._isStreamingSupported = !disableStream;
    this._isRangeSupported = !disableRange;
    this._contentLength = length;
    this._fullRequestReader = null;
    this._rangeReaders = [];
    this._pdfDataRangeTransport.addRangeListener((begin, chunk) => {
      this._onReceiveData({
        begin,
        chunk
      });
    });
    this._pdfDataRangeTransport.addProgressListener((loaded, total) => {
      this._onProgress({
        loaded,
        total
      });
    });
    this._pdfDataRangeTransport.addProgressiveReadListener(chunk => {
      this._onReceiveData({
        chunk
      });
    });
    this._pdfDataRangeTransport.addProgressiveDoneListener(() => {
      this._onProgressiveDone();
    });
    this._pdfDataRangeTransport.transportReady();
  }
  _onReceiveData(_ref2) {
    let {
      begin,
      chunk
    } = _ref2;
    const buffer = chunk instanceof Uint8Array && chunk.byteLength === chunk.buffer.byteLength ? chunk.buffer : new Uint8Array(chunk).buffer;
    if (begin === undefined) {
      if (this._fullRequestReader) {
        this._fullRequestReader._enqueue(buffer);
      } else {
        this._queuedChunks.push(buffer);
      }
    } else {
      const found = this._rangeReaders.some(function (rangeReader) {
        if (rangeReader._begin !== begin) {
          return false;
        }
        rangeReader._enqueue(buffer);
        return true;
      });
      (0, _util.assert)(found, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
    }
  }
  get _progressiveDataLength() {
    return this._fullRequestReader?._loaded ?? 0;
  }
  _onProgress(evt) {
    if (evt.total === undefined) {
      this._rangeReaders[0]?.onProgress?.({
        loaded: evt.loaded
      });
    } else {
      this._fullRequestReader?.onProgress?.({
        loaded: evt.loaded,
        total: evt.total
      });
    }
  }
  _onProgressiveDone() {
    this._fullRequestReader?.progressiveDone();
    this._progressiveDone = true;
  }
  _removeRangeReader(reader) {
    const i = this._rangeReaders.indexOf(reader);
    if (i >= 0) {
      this._rangeReaders.splice(i, 1);
    }
  }
  getFullReader() {
    (0, _util.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
    const queuedChunks = this._queuedChunks;
    this._queuedChunks = null;
    return new PDFDataTransportStreamReader(this, queuedChunks, this._progressiveDone, this._contentDispositionFilename);
  }
  getRangeReader(begin, end) {
    if (end <= this._progressiveDataLength) {
      return null;
    }
    const reader = new PDFDataTransportStreamRangeReader(this, begin, end);
    this._pdfDataRangeTransport.requestDataRange(begin, end);
    this._rangeReaders.push(reader);
    return reader;
  }
  cancelAllRequests(reason) {
    this._fullRequestReader?.cancel(reason);
    for (const reader of this._rangeReaders.slice(0)) {
      reader.cancel(reason);
    }
    this._pdfDataRangeTransport.abort();
  }
}
exports.PDFDataTransportStream = PDFDataTransportStream;
class PDFDataTransportStreamReader {
  constructor(stream, queuedChunks) {
    let progressiveDone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    let contentDispositionFilename = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    this._stream = stream;
    this._done = progressiveDone || false;
    this._filename = (0, _display_utils.isPdfFile)(contentDispositionFilename) ? contentDispositionFilename : null;
    this._queuedChunks = queuedChunks || [];
    this._loaded = 0;
    for (const chunk of this._queuedChunks) {
      this._loaded += chunk.byteLength;
    }
    this._requests = [];
    this._headersReady = Promise.resolve();
    stream._fullRequestReader = this;
    this.onProgress = null;
  }
  _enqueue(chunk) {
    if (this._done) {
      return;
    }
    if (this._requests.length > 0) {
      const requestCapability = this._requests.shift();
      requestCapability.resolve({
        value: chunk,
        done: false
      });
    } else {
      this._queuedChunks.push(chunk);
    }
    this._loaded += chunk.byteLength;
  }
  get headersReady() {
    return this._headersReady;
  }
  get filename() {
    return this._filename;
  }
  get isRangeSupported() {
    return this._stream._isRangeSupported;
  }
  get isStreamingSupported() {
    return this._stream._isStreamingSupported;
  }
  get contentLength() {
    return this._stream._contentLength;
  }
  async read() {
    if (this._queuedChunks.length > 0) {
      const chunk = this._queuedChunks.shift();
      return {
        value: chunk,
        done: false
      };
    }
    if (this._done) {
      return {
        value: undefined,
        done: true
      };
    }
    const requestCapability = new _util.PromiseCapability();
    this._requests.push(requestCapability);
    return requestCapability.promise;
  }
  cancel(reason) {
    this._done = true;
    for (const requestCapability of this._requests) {
      requestCapability.resolve({
        value: undefined,
        done: true
      });
    }
    this._requests.length = 0;
  }
  progressiveDone() {
    if (this._done) {
      return;
    }
    this._done = true;
  }
}
class PDFDataTransportStreamRangeReader {
  constructor(stream, begin, end) {
    this._stream = stream;
    this._begin = begin;
    this._end = end;
    this._queuedChunk = null;
    this._requests = [];
    this._done = false;
    this.onProgress = null;
  }
  _enqueue(chunk) {
    if (this._done) {
      return;
    }
    if (this._requests.length === 0) {
      this._queuedChunk = chunk;
    } else {
      const requestsCapability = this._requests.shift();
      requestsCapability.resolve({
        value: chunk,
        done: false
      });
      for (const requestCapability of this._requests) {
        requestCapability.resolve({
          value: undefined,
          done: true
        });
      }
      this._requests.length = 0;
    }
    this._done = true;
    this._stream._removeRangeReader(this);
  }
  get isStreamingSupported() {
    return false;
  }
  async read() {
    if (this._queuedChunk) {
      const chunk = this._queuedChunk;
      this._queuedChunk = null;
      return {
        value: chunk,
        done: false
      };
    }
    if (this._done) {
      return {
        value: undefined,
        done: true
      };
    }
    const requestCapability = new _util.PromiseCapability();
    this._requests.push(requestCapability);
    return requestCapability.promise;
  }
  cancel(reason) {
    this._done = true;
    for (const requestCapability of this._requests) {
      requestCapability.resolve({
        value: undefined,
        done: true
      });
    }
    this._requests.length = 0;
    this._stream._removeRangeReader(this);
  }
}

/***/ }),
/* 181 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.PDFFetchStream = void 0;
__w_pdfjs_require__(93);
__w_pdfjs_require__(101);
__w_pdfjs_require__(102);
__w_pdfjs_require__(105);
__w_pdfjs_require__(107);
__w_pdfjs_require__(109);
__w_pdfjs_require__(113);
__w_pdfjs_require__(116);
__w_pdfjs_require__(123);
__w_pdfjs_require__(89);
var _util = __w_pdfjs_require__(1);
var _network_utils = __w_pdfjs_require__(182);
;
function createFetchOptions(headers, withCredentials, abortController) {
  return {
    method: "GET",
    headers,
    signal: abortController.signal,
    mode: "cors",
    credentials: withCredentials ? "include" : "same-origin",
    redirect: "follow"
  };
}
function createHeaders(httpHeaders) {
  const headers = new Headers();
  for (const property in httpHeaders) {
    const value = httpHeaders[property];
    if (value === undefined) {
      continue;
    }
    headers.append(property, value);
  }
  return headers;
}
function getArrayBuffer(val) {
  if (val instanceof Uint8Array) {
    return val.buffer;
  }
  if (val instanceof ArrayBuffer) {
    return val;
  }
  (0, _util.warn)(`getArrayBuffer - unexpected data format: ${val}`);
  return new Uint8Array(val).buffer;
}
class PDFFetchStream {
  constructor(source) {
    this.source = source;
    this.isHttp = /^https?:/i.test(source.url);
    this.httpHeaders = this.isHttp && source.httpHeaders || {};
    this._fullRequestReader = null;
    this._rangeRequestReaders = [];
  }
  get _progressiveDataLength() {
    return this._fullRequestReader?._loaded ?? 0;
  }
  getFullReader() {
    (0, _util.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once.");
    this._fullRequestReader = new PDFFetchStreamReader(this);
    return this._fullRequestReader;
  }
  getRangeReader(begin, end) {
    if (end <= this._progressiveDataLength) {
      return null;
    }
    const reader = new PDFFetchStreamRangeReader(this, begin, end);
    this._rangeRequestReaders.push(reader);
    return reader;
  }
  cancelAllRequests(reason) {
    this._fullRequestReader?.cancel(reason);
    for (const reader of this._rangeRequestReaders.slice(0)) {
      reader.cancel(reason);
    }
  }
}
exports.PDFFetchStream = PDFFetchStream;
class PDFFetchStreamReader {
  constructor(stream) {
    this._stream = stream;
    this._reader = null;
    this._loaded = 0;
    this._filename = null;
    const source = stream.source;
    this._withCredentials = source.withCredentials || false;
    this._contentLength = source.length;
    this._headersCapability = new _util.PromiseCapability();
    this._disableRange = source.disableRange || false;
    this._rangeChunkSize = source.rangeChunkSize;
    if (!this._rangeChunkSize && !this._disableRange) {
      this._disableRange = true;
    }
    this._abortController = new AbortController();
    this._isStreamingSupported = !source.disableStream;
    this._isRangeSupported = !source.disableRange;
    this._headers = createHeaders(this._stream.httpHeaders);
    const url = source.url;
    fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then(response => {
      if (!(0, _network_utils.validateResponseStatus)(response.status)) {
        throw (0, _network_utils.createResponseStatusError)(response.status, url);
      }
      this._reader = response.body.getReader();
      this._headersCapability.resolve();
      const getResponseHeader = name => {
        return response.headers.get(name);
      };
      const {
        allowRangeRequests,
        suggestedLength
      } = (0, _network_utils.validateRangeRequestCapabilities)({
        getResponseHeader,
        isHttp: this._stream.isHttp,
        rangeChunkSize: this._rangeChunkSize,
        disableRange: this._disableRange
      });
      this._isRangeSupported = allowRangeRequests;
      this._contentLength = suggestedLength || this._contentLength;
      this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
      if (!this._isStreamingSupported && this._isRangeSupported) {
        this.cancel(new _util.AbortException("Streaming is disabled."));
      }
    }).catch(this._headersCapability.reject);
    this.onProgress = null;
  }
  get headersReady() {
    return this._headersCapability.promise;
  }
  get filename() {
    return this._filename;
  }
  get contentLength() {
    return this._contentLength;
  }
  get isRangeSupported() {
    return this._isRangeSupported;
  }
  get isStreamingSupported() {
    return this._isStreamingSupported;
  }
  async read() {
    await this._headersCapability.promise;
    const {
      value,
      done
    } = await this._reader.read();
    if (done) {
      return {
        value,
        done
      };
    }
    this._loaded += value.byteLength;
    this.onProgress?.({
      loaded: this._loaded,
      total: this._contentLength
    });
    return {
      value: getArrayBuffer(value),
      done: false
    };
  }
  cancel(reason) {
    this._reader?.cancel(reason);
    this._abortController.abort();
  }
}
class PDFFetchStreamRangeReader {
  constructor(stream, begin, end) {
    this._stream = stream;
    this._reader = null;
    this._loaded = 0;
    const source = stream.source;
    this._withCredentials = source.withCredentials || false;
    this._readCapability = new _util.PromiseCapability();
    this._isStreamingSupported = !source.disableStream;
    this._abortController = new AbortController();
    this._headers = createHeaders(this._stream.httpHeaders);
    this._headers.append("Range", `bytes=${begin}-${end - 1}`);
    const url = source.url;
    fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then(response => {
      if (!(0, _network_utils.validateResponseStatus)(response.status)) {
        throw (0, _network_utils.createResponseStatusError)(response.status, url);
      }
      this._readCapability.resolve();
      this._reader = response.body.getReader();
    }).catch(this._readCapability.reject);
    this.onProgress = null;
  }
  get isStreamingSupported() {
    return this._isStreamingSupported;
  }
  async read() {
    await this._readCapability.promise;
    const {
      value,
      done
    } = await this._reader.read();
    if (done) {
      return {
        value,
        done
      };
    }
    this._loaded += value.byteLength;
    this.onProgress?.({
      loaded: this._loaded
    });
    return {
      value: getArrayBuffer(value),
      done: false
    };
  }
  cancel(reason) {
    this._reader?.cancel(reason);
    this._abortController.abort();
  }
}

/***/ }),
/* 182 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.createResponseStatusError = createResponseStatusError;
exports.extractFilenameFromHeader = extractFilenameFromHeader;
exports.validateRangeRequestCapabilities = validateRangeRequestCapabilities;
exports.validateResponseStatus = validateResponseStatus;
var _util = __w_pdfjs_require__(1);
var _content_disposition = __w_pdfjs_require__(183);
var _display_utils = __w_pdfjs_require__(168);
function validateRangeRequestCapabilities(_ref) {
  let {
    getResponseHeader,
    isHttp,
    rangeChunkSize,
    disableRange
  } = _ref;
  const returnValues = {
    allowRangeRequests: false,
    suggestedLength: undefined
  };
  const length = parseInt(getResponseHeader("Content-Length"), 10);
  if (!Number.isInteger(length)) {
    return returnValues;
  }
  returnValues.suggestedLength = length;
  if (length <= 2 * rangeChunkSize) {
    return returnValues;
  }
  if (disableRange || !isHttp) {
    return returnValues;
  }
  if (getResponseHeader("Accept-Ranges") !== "bytes") {
    return returnValues;
  }
  const contentEncoding = getResponseHeader("Content-Encoding") || "identity";
  if (contentEncoding !== "identity") {
    return returnValues;
  }
  returnValues.allowRangeRequests = true;
  return returnValues;
}
function extractFilenameFromHeader(getResponseHeader) {
  const contentDisposition = getResponseHeader("Content-Disposition");
  if (contentDisposition) {
    let filename = (0, _content_disposition.getFilenameFromContentDispositionHeader)(contentDisposition);
    if (filename.includes("%")) {
      try {
        filename = decodeURIComponent(filename);
      } catch {}
    }
    if ((0, _display_utils.isPdfFile)(filename)) {
      return filename;
    }
  }
  return null;
}
function createResponseStatusError(status, url) {
  if (status === 404 || status === 0 && url.startsWith("file:")) {
    return new _util.MissingPDFException('Missing PDF "' + url + '".');
  }
  return new _util.UnexpectedResponseException(`Unexpected server response (${status}) while retrieving PDF "${url}".`, status);
}
function validateResponseStatus(status) {
  return status === 200 || status === 206;
}

/***/ }),
/* 183 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getFilenameFromContentDispositionHeader = getFilenameFromContentDispositionHeader;
__w_pdfjs_require__(89);
__w_pdfjs_require__(149);
var _util = __w_pdfjs_require__(1);
function getFilenameFromContentDispositionHeader(contentDisposition) {
  let needsEncodingFixup = true;
  let tmp = toParamRegExp("filename\\*", "i").exec(contentDisposition);
  if (tmp) {
    tmp = tmp[1];
    let filename = rfc2616unquote(tmp);
    filename = unescape(filename);
    filename = rfc5987decode(filename);
    filename = rfc2047decode(filename);
    return fixupEncoding(filename);
  }
  tmp = rfc2231getparam(contentDisposition);
  if (tmp) {
    const filename = rfc2047decode(tmp);
    return fixupEncoding(filename);
  }
  tmp = toParamRegExp("filename", "i").exec(contentDisposition);
  if (tmp) {
    tmp = tmp[1];
    let filename = rfc2616unquote(tmp);
    filename = rfc2047decode(filename);
    return fixupEncoding(filename);
  }
  function toParamRegExp(attributePattern, flags) {
    return new RegExp("(?:^|;)\\s*" + attributePattern + "\\s*=\\s*" + "(" + '[^";\\s][^;\\s]*' + "|" + '"(?:[^"\\\\]|\\\\"?)+"?' + ")", flags);
  }
  function textdecode(encoding, value) {
    if (encoding) {
      if (!/^[\x00-\xFF]+$/.test(value)) {
        return value;
      }
      try {
        const decoder = new TextDecoder(encoding, {
          fatal: true
        });
        const buffer = (0, _util.stringToBytes)(value);
        value = decoder.decode(buffer);
        needsEncodingFixup = false;
      } catch {}
    }
    return value;
  }
  function fixupEncoding(value) {
    if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
      value = textdecode("utf-8", value);
      if (needsEncodingFixup) {
        value = textdecode("iso-8859-1", value);
      }
    }
    return value;
  }
  function rfc2231getparam(contentDispositionStr) {
    const matches = [];
    let match;
    const iter = toParamRegExp("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
    while ((match = iter.exec(contentDispositionStr)) !== null) {
      let [, n, quot, part] = match;
      n = parseInt(n, 10);
      if (n in matches) {
        if (n === 0) {
          break;
        }
        continue;
      }
      matches[n] = [quot, part];
    }
    const parts = [];
    for (let n = 0; n < matches.length; ++n) {
      if (!(n in matches)) {
        break;
      }
      let [quot, part] = matches[n];
      part = rfc2616unquote(part);
      if (quot) {
        part = unescape(part);
        if (n === 0) {
          part = rfc5987decode(part);
        }
      }
      parts.push(part);
    }
    return parts.join("");
  }
  function rfc2616unquote(value) {
    if (value.startsWith('"')) {
      const parts = value.slice(1).split('\\"');
      for (let i = 0; i < parts.length; ++i) {
        const quotindex = parts[i].indexOf('"');
        if (quotindex !== -1) {
          parts[i] = parts[i].slice(0, quotindex);
          parts.length = i + 1;
        }
        parts[i] = parts[i].replaceAll(/\\(.)/g, "$1");
      }
      value = parts.join('"');
    }
    return value;
  }
  function rfc5987decode(extvalue) {
    const encodingend = extvalue.indexOf("'");
    if (encodingend === -1) {
      return extvalue;
    }
    const encoding = extvalue.slice(0, encodingend);
    const langvalue = extvalue.slice(encodingend + 1);
    const value = langvalue.replace(/^[^']*'/, "");
    return textdecode(encoding, value);
  }
  function rfc2047decode(value) {
    if (!value.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value)) {
      return value;
    }
    return value.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function (matches, charset, encoding, text) {
      if (encoding === "q" || encoding === "Q") {
        text = text.replaceAll("_", " ");
        text = text.replaceAll(/=([0-9a-fA-F]{2})/g, function (match, hex) {
          return String.fromCharCode(parseInt(hex, 16));
        });
        return textdecode(charset, text);
      }
      try {
        text = atob(text);
      } catch {}
      return textdecode(charset, text);
    });
  }
  return "";
}

/***/ }),
/* 184 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.PDFNetworkStream = void 0;
__w_pdfjs_require__(89);
var _util = __w_pdfjs_require__(1);
var _network_utils = __w_pdfjs_require__(182);
;
const OK_RESPONSE = 200;
const PARTIAL_CONTENT_RESPONSE = 206;
function getArrayBuffer(xhr) {
  const data = xhr.response;
  if (typeof data !== "string") {
    return data;
  }
  return (0, _util.stringToBytes)(data).buffer;
}
class NetworkManager {
  constructor(url) {
    let args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.url = url;
    this.isHttp = /^https?:/i.test(url);
    this.httpHeaders = this.isHttp && args.httpHeaders || Object.create(null);
    this.withCredentials = args.withCredentials || false;
    this.currXhrId = 0;
    this.pendingRequests = Object.create(null);
  }
  requestRange(begin, end, listeners) {
    const args = {
      begin,
      end
    };
    for (const prop in listeners) {
      args[prop] = listeners[prop];
    }
    return this.request(args);
  }
  requestFull(listeners) {
    return this.request(listeners);
  }
  request(args) {
    const xhr = new XMLHttpRequest();
    const xhrId = this.currXhrId++;
    const pendingRequest = this.pendingRequests[xhrId] = {
      xhr
    };
    xhr.open("GET", this.url);
    xhr.withCredentials = this.withCredentials;
    for (const property in this.httpHeaders) {
      const value = this.httpHeaders[property];
      if (value === undefined) {
        continue;
      }
      xhr.setRequestHeader(property, value);
    }
    if (this.isHttp && "begin" in args && "end" in args) {
      xhr.setRequestHeader("Range", `bytes=${args.begin}-${args.end - 1}`);
      pendingRequest.expectedStatus = PARTIAL_CONTENT_RESPONSE;
    } else {
      pendingRequest.expectedStatus = OK_RESPONSE;
    }
    xhr.responseType = "arraybuffer";
    if (args.onError) {
      xhr.onerror = function (evt) {
        args.onError(xhr.status);
      };
    }
    xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
    xhr.onprogress = this.onProgress.bind(this, xhrId);
    pendingRequest.onHeadersReceived = args.onHeadersReceived;
    pendingRequest.onDone = args.onDone;
    pendingRequest.onError = args.onError;
    pendingRequest.onProgress = args.onProgress;
    xhr.send(null);
    return xhrId;
  }
  onProgress(xhrId, evt) {
    const pendingRequest = this.pendingRequests[xhrId];
    if (!pendingRequest) {
      return;
    }
    pendingRequest.onProgress?.(evt);
  }
  onStateChange(xhrId, evt) {
    const pendingRequest = this.pendingRequests[xhrId];
    if (!pendingRequest) {
      return;
    }
    const xhr = pendingRequest.xhr;
    if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
      pendingRequest.onHeadersReceived();
      delete pendingRequest.onHeadersReceived;
    }
    if (xhr.readyState !== 4) {
      return;
    }
    if (!(xhrId in this.pendingRequests)) {
      return;
    }
    delete this.pendingRequests[xhrId];
    if (xhr.status === 0 && this.isHttp) {
      pendingRequest.onError?.(xhr.status);
      return;
    }
    const xhrStatus = xhr.status || OK_RESPONSE;
    const ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
    if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
      pendingRequest.onError?.(xhr.status);
      return;
    }
    const chunk = getArrayBuffer(xhr);
    if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
      const rangeHeader = xhr.getResponseHeader("Content-Range");
      const matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
      pendingRequest.onDone({
        begin: parseInt(matches[1], 10),
        chunk
      });
    } else if (chunk) {
      pendingRequest.onDone({
        begin: 0,
        chunk
      });
    } else {
      pendingRequest.onError?.(xhr.status);
    }
  }
  getRequestXhr(xhrId) {
    return this.pendingRequests[xhrId].xhr;
  }
  isPendingRequest(xhrId) {
    return xhrId in this.pendingRequests;
  }
  abortRequest(xhrId) {
    const xhr = this.pendingRequests[xhrId].xhr;
    delete this.pendingRequests[xhrId];
    xhr.abort();
  }
}
class PDFNetworkStream {
  constructor(source) {
    this._source = source;
    this._manager = new NetworkManager(source.url, {
      httpHeaders: source.httpHeaders,
      withCredentials: source.withCredentials
    });
    this._rangeChunkSize = source.rangeChunkSize;
    this._fullRequestReader = null;
    this._rangeRequestReaders = [];
  }
  _onRangeRequestReaderClosed(reader) {
    const i = this._rangeRequestReaders.indexOf(reader);
    if (i >= 0) {
      this._rangeRequestReaders.splice(i, 1);
    }
  }
  getFullReader() {
    (0, _util.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once.");
    this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._source);
    return this._fullRequestReader;
  }
  getRangeReader(begin, end) {
    const reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
    reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
    this._rangeRequestReaders.push(reader);
    return reader;
  }
  cancelAllRequests(reason) {
    this._fullRequestReader?.cancel(reason);
    for (const reader of this._rangeRequestReaders.slice(0)) {
      reader.cancel(reason);
    }
  }
}
exports.PDFNetworkStream = PDFNetworkStream;
class PDFNetworkStreamFullRequestReader {
  constructor(manager, source) {
    this._manager = manager;
    const args = {
      onHeadersReceived: this._onHeadersReceived.bind(this),
      onDone: this._onDone.bind(this),
      onError: this._onError.bind(this),
      onProgress: this._onProgress.bind(this)
    };
    this._url = source.url;
    this._fullRequestId = manager.requestFull(args);
    this._headersReceivedCapability = new _util.PromiseCapability();
    this._disableRange = source.disableRange || false;
    this._contentLength = source.length;
    this._rangeChunkSize = source.rangeChunkSize;
    if (!this._rangeChunkSize && !this._disableRange) {
      this._disableRange = true;
    }
    this._isStreamingSupported = false;
    this._isRangeSupported = false;
    this._cachedChunks = [];
    this._requests = [];
    this._done = false;
    this._storedError = undefined;
    this._filename = null;
    this.onProgress = null;
  }
  _onHeadersReceived() {
    const fullRequestXhrId = this._fullRequestId;
    const fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
    const getResponseHeader = name => {
      return fullRequestXhr.getResponseHeader(name);
    };
    const {
      allowRangeRequests,
      suggestedLength
    } = (0, _network_utils.validateRangeRequestCapabilities)({
      getResponseHeader,
      isHttp: this._manager.isHttp,
      rangeChunkSize: this._rangeChunkSize,
      disableRange: this._disableRange
    });
    if (allowRangeRequests) {
      this._isRangeSupported = true;
    }
    this._contentLength = suggestedLength || this._contentLength;
    this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
    if (this._isRangeSupported) {
      this._manager.abortRequest(fullRequestXhrId);
    }
    this._headersReceivedCapability.resolve();
  }
  _onDone(data) {
    if (data) {
      if (this._requests.length > 0) {
        const requestCapability = this._requests.shift();
        requestCapability.resolve({
          value: data.chunk,
          done: false
        });
      } else {
        this._cachedChunks.push(data.chunk);
      }
    }
    this._done = true;
    if (this._cachedChunks.length > 0) {
      return;
    }
    for (const requestCapability of this._requests) {
      requestCapability.resolve({
        value: undefined,
        done: true
      });
    }
    this._requests.length = 0;
  }
  _onError(status) {
    this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
    this._headersReceivedCapability.reject(this._storedError);
    for (const requestCapability of this._requests) {
      requestCapability.reject(this._storedError);
    }
    this._requests.length = 0;
    this._cachedChunks.length = 0;
  }
  _onProgress(evt) {
    this.onProgress?.({
      loaded: evt.loaded,
      total: evt.lengthComputable ? evt.total : this._contentLength
    });
  }
  get filename() {
    return this._filename;
  }
  get isRangeSupported() {
    return this._isRangeSupported;
  }
  get isStreamingSupported() {
    return this._isStreamingSupported;
  }
  get contentLength() {
    return this._contentLength;
  }
  get headersReady() {
    return this._headersReceivedCapability.promise;
  }
  async read() {
    if (this._storedError) {
      throw this._storedError;
    }
    if (this._cachedChunks.length > 0) {
      const chunk = this._cachedChunks.shift();
      return {
        value: chunk,
        done: false
      };
    }
    if (this._done) {
      return {
        value: undefined,
        done: true
      };
    }
    const requestCapability = new _util.PromiseCapability();
    this._requests.push(requestCapability);
    return requestCapability.promise;
  }
  cancel(reason) {
    this._done = true;
    this._headersReceivedCapability.reject(reason);
    for (const requestCapability of this._requests) {
      requestCapability.resolve({
        value: undefined,
        done: true
      });
    }
    this._requests.length = 0;
    if (this._manager.isPendingRequest(this._fullRequestId)) {
      this._manager.abortRequest(this._fullRequestId);
    }
    this._fullRequestReader = null;
  }
}
class PDFNetworkStreamRangeRequestReader {
  constructor(manager, begin, end) {
    this._manager = manager;
    const args = {
      onDone: this._onDone.bind(this),
      onError: this._onError.bind(this),
      onProgress: this._onProgress.bind(this)
    };
    this._url = manager.url;
    this._requestId = manager.requestRange(begin, end, args);
    this._requests = [];
    this._queuedChunk = null;
    this._done = false;
    this._storedError = undefined;
    this.onProgress = null;
    this.onClosed = null;
  }
  _close() {
    this.onClosed?.(this);
  }
  _onDone(data) {
    const chunk = data.chunk;
    if (this._requests.length > 0) {
      const requestCapability = this._requests.shift();
      requestCapability.resolve({
        value: chunk,
        done: false
      });
    } else {
      this._queuedChunk = chunk;
    }
    this._done = true;
    for (const requestCapability of this._requests) {
      requestCapability.resolve({
        value: undefined,
        done: true
      });
    }
    this._requests.length = 0;
    this._close();
  }
  _onError(status) {
    this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
    for (const requestCapability of this._requests) {
      requestCapability.reject(this._storedError);
    }
    this._requests.length = 0;
    this._queuedChunk = null;
  }
  _onProgress(evt) {
    if (!this.isStreamingSupported) {
      this.onProgress?.({
        loaded: evt.loaded
      });
    }
  }
  get isStreamingSupported() {
    return false;
  }
  async read() {
    if (this._storedError) {
      throw this._storedError;
    }
    if (this._queuedChunk !== null) {
      const chunk = this._queuedChunk;
      this._queuedChunk = null;
      return {
        value: chunk,
        done: false
      };
    }
    if (this._done) {
      return {
        value: undefined,
        done: true
      };
    }
    const requestCapability = new _util.PromiseCapability();
    this._requests.push(requestCapability);
    return requestCapability.promise;
  }
  cancel(reason) {
    this._done = true;
    for (const requestCapability of this._requests) {
      requestCapability.resolve({
        value: undefined,
        done: true
      });
    }
    this._requests.length = 0;
    if (this._manager.isPendingRequest(this._requestId)) {
      this._manager.abortRequest(this._requestId);
    }
    this._close();
  }
}

/***/ }),
/* 185 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.PDFNodeStream = void 0;
__w_pdfjs_require__(89);
__w_pdfjs_require__(93);
__w_pdfjs_require__(101);
__w_pdfjs_require__(102);
__w_pdfjs_require__(105);
__w_pdfjs_require__(107);
__w_pdfjs_require__(109);
__w_pdfjs_require__(113);
__w_pdfjs_require__(116);
__w_pdfjs_require__(123);
var _util = __w_pdfjs_require__(1);
var _network_utils = __w_pdfjs_require__(182);
;
const fileUriRegex = /^file:\/\/\/[a-zA-Z]:\//;
function parseUrl(sourceUrl) {
  const url = require("url");
  const parsedUrl = url.parse(sourceUrl);
  if (parsedUrl.protocol === "file:" || parsedUrl.host) {
    return parsedUrl;
  }
  if (/^[a-z]:[/\\]/i.test(sourceUrl)) {
    return url.parse(`file:///${sourceUrl}`);
  }
  if (!parsedUrl.host) {
    parsedUrl.protocol = "file:";
  }
  return parsedUrl;
}
class PDFNodeStream {
  constructor(source) {
    this.source = source;
    this.url = parseUrl(source.url);
    this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:";
    this.isFsUrl = this.url.protocol === "file:";
    this.httpHeaders = this.isHttp && source.httpHeaders || {};
    this._fullRequestReader = null;
    this._rangeRequestReaders = [];
  }
  get _progressiveDataLength() {
    return this._fullRequestReader?._loaded ?? 0;
  }
  getFullReader() {
    (0, _util.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once.");
    this._fullRequestReader = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this);
    return this._fullRequestReader;
  }
  getRangeReader(start, end) {
    if (end <= this._progressiveDataLength) {
      return null;
    }
    const rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start, end) : new PDFNodeStreamRangeReader(this, start, end);
    this._rangeRequestReaders.push(rangeReader);
    return rangeReader;
  }
  cancelAllRequests(reason) {
    this._fullRequestReader?.cancel(reason);
    for (const reader of this._rangeRequestReaders.slice(0)) {
      reader.cancel(reason);
    }
  }
}
exports.PDFNodeStream = PDFNodeStream;
class BaseFullReader {
  constructor(stream) {
    this._url = stream.url;
    this._done = false;
    this._storedError = null;
    this.onProgress = null;
    const source = stream.source;
    this._contentLength = source.length;
    this._loaded = 0;
    this._filename = null;
    this._disableRange = source.disableRange || false;
    this._rangeChunkSize = source.rangeChunkSize;
    if (!this._rangeChunkSize && !this._disableRange) {
      this._disableRange = true;
    }
    this._isStreamingSupported = !source.disableStream;
    this._isRangeSupported = !source.disableRange;
    this._readableStream = null;
    this._readCapability = new _util.PromiseCapability();
    this._headersCapability = new _util.PromiseCapability();
  }
  get headersReady() {
    return this._headersCapability.promise;
  }
  get filename() {
    return this._filename;
  }
  get contentLength() {
    return this._contentLength;
  }
  get isRangeSupported() {
    return this._isRangeSupported;
  }
  get isStreamingSupported() {
    return this._isStreamingSupported;
  }
  async read() {
    await this._readCapability.promise;
    if (this._done) {
      return {
        value: undefined,
        done: true
      };
    }
    if (this._storedError) {
      throw this._storedError;
    }
    const chunk = this._readableStream.read();
    if (chunk === null) {
      this._readCapability = new _util.PromiseCapability();
      return this.read();
    }
    this._loaded += chunk.length;
    this.onProgress?.({
      loaded: this._loaded,
      total: this._contentLength
    });
    const buffer = new Uint8Array(chunk).buffer;
    return {
      value: buffer,
      done: false
    };
  }
  cancel(reason) {
    if (!this._readableStream) {
      this._error(reason);
      return;
    }
    this._readableStream.destroy(reason);
  }
  _error(reason) {
    this._storedError = reason;
    this._readCapability.resolve();
  }
  _setReadableStream(readableStream) {
    this._readableStream = readableStream;
    readableStream.on("readable", () => {
      this._readCapability.resolve();
    });
    readableStream.on("end", () => {
      readableStream.destroy();
      this._done = true;
      this._readCapability.resolve();
    });
    readableStream.on("error", reason => {
      this._error(reason);
    });
    if (!this._isStreamingSupported && this._isRangeSupported) {
      this._error(new _util.AbortException("streaming is disabled"));
    }
    if (this._storedError) {
      this._readableStream.destroy(this._storedError);
    }
  }
}
class BaseRangeReader {
  constructor(stream) {
    this._url = stream.url;
    this._done = false;
    this._storedError = null;
    this.onProgress = null;
    this._loaded = 0;
    this._readableStream = null;
    this._readCapability = new _util.PromiseCapability();
    const source = stream.source;
    this._isStreamingSupported = !source.disableStream;
  }
  get isStreamingSupported() {
    return this._isStreamingSupported;
  }
  async read() {
    await this._readCapability.promise;
    if (this._done) {
      return {
        value: undefined,
        done: true
      };
    }
    if (this._storedError) {
      throw this._storedError;
    }
    const chunk = this._readableStream.read();
    if (chunk === null) {
      this._readCapability = new _util.PromiseCapability();
      return this.read();
    }
    this._loaded += chunk.length;
    this.onProgress?.({
      loaded: this._loaded
    });
    const buffer = new Uint8Array(chunk).buffer;
    return {
      value: buffer,
      done: false
    };
  }
  cancel(reason) {
    if (!this._readableStream) {
      this._error(reason);
      return;
    }
    this._readableStream.destroy(reason);
  }
  _error(reason) {
    this._storedError = reason;
    this._readCapability.resolve();
  }
  _setReadableStream(readableStream) {
    this._readableStream = readableStream;
    readableStream.on("readable", () => {
      this._readCapability.resolve();
    });
    readableStream.on("end", () => {
      readableStream.destroy();
      this._done = true;
      this._readCapability.resolve();
    });
    readableStream.on("error", reason => {
      this._error(reason);
    });
    if (this._storedError) {
      this._readableStream.destroy(this._storedError);
    }
  }
}
function createRequestOptions(parsedUrl, headers) {
  return {
    protocol: parsedUrl.protocol,
    auth: parsedUrl.auth,
    host: parsedUrl.hostname,
    port: parsedUrl.port,
    path: parsedUrl.path,
    method: "GET",
    headers
  };
}
class PDFNodeStreamFullReader extends BaseFullReader {
  constructor(stream) {
    super(stream);
    const handleResponse = response => {
      if (response.statusCode === 404) {
        const error = new _util.MissingPDFException(`Missing PDF "${this._url}".`);
        this._storedError = error;
        this._headersCapability.reject(error);
        return;
      }
      this._headersCapability.resolve();
      this._setReadableStream(response);
      const getResponseHeader = name => {
        return this._readableStream.headers[name.toLowerCase()];
      };
      const {
        allowRangeRequests,
        suggestedLength
      } = (0, _network_utils.validateRangeRequestCapabilities)({
        getResponseHeader,
        isHttp: stream.isHttp,
        rangeChunkSize: this._rangeChunkSize,
        disableRange: this._disableRange
      });
      this._isRangeSupported = allowRangeRequests;
      this._contentLength = suggestedLength || this._contentLength;
      this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
    };
    this._request = null;
    if (this._url.protocol === "http:") {
      const http = require("http");
      this._request = http.request(createRequestOptions(this._url, stream.httpHeaders), handleResponse);
    } else {
      const https = require("https");
      this._request = https.request(createRequestOptions(this._url, stream.httpHeaders), handleResponse);
    }
    this._request.on("error", reason => {
      this._storedError = reason;
      this._headersCapability.reject(reason);
    });
    this._request.end();
  }
}
class PDFNodeStreamRangeReader extends BaseRangeReader {
  constructor(stream, start, end) {
    super(stream);
    this._httpHeaders = {};
    for (const property in stream.httpHeaders) {
      const value = stream.httpHeaders[property];
      if (value === undefined) {
        continue;
      }
      this._httpHeaders[property] = value;
    }
    this._httpHeaders.Range = `bytes=${start}-${end - 1}`;
    const handleResponse = response => {
      if (response.statusCode === 404) {
        const error = new _util.MissingPDFException(`Missing PDF "${this._url}".`);
        this._storedError = error;
        return;
      }
      this._setReadableStream(response);
    };
    this._request = null;
    if (this._url.protocol === "http:") {
      const http = require("http");
      this._request = http.request(createRequestOptions(this._url, this._httpHeaders), handleResponse);
    } else {
      const https = require("https");
      this._request = https.request(createRequestOptions(this._url, this._httpHeaders), handleResponse);
    }
    this._request.on("error", reason => {
      this._storedError = reason;
    });
    this._request.end();
  }
}
class PDFNodeStreamFsFullReader extends BaseFullReader {
  constructor(stream) {
    super(stream);
    let path = decodeURIComponent(this._url.path);
    if (fileUriRegex.test(this._url.href)) {
      path = path.replace(/^\//, "");
    }
    const fs = require("fs");
    fs.lstat(path, (error, stat) => {
      if (error) {
        if (error.code === "ENOENT") {
          error = new _util.MissingPDFException(`Missing PDF "${path}".`);
        }
        this._storedError = error;
        this._headersCapability.reject(error);
        return;
      }
      this._contentLength = stat.size;
      this._setReadableStream(fs.createReadStream(path));
      this._headersCapability.resolve();
    });
  }
}
class PDFNodeStreamFsRangeReader extends BaseRangeReader {
  constructor(stream, start, end) {
    super(stream);
    let path = decodeURIComponent(this._url.path);
    if (fileUriRegex.test(this._url.href)) {
      path = path.replace(/^\//, "");
    }
    const fs = require("fs");
    this._setReadableStream(fs.createReadStream(path, {
      start,
      end: end - 1
    }));
  }
}

/***/ }),
/* 186 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.SVGGraphics = void 0;
__w_pdfjs_require__(84);
__w_pdfjs_require__(86);
__w_pdfjs_require__(87);
__w_pdfjs_require__(93);
__w_pdfjs_require__(101);
__w_pdfjs_require__(102);
__w_pdfjs_require__(105);
__w_pdfjs_require__(107);
__w_pdfjs_require__(109);
__w_pdfjs_require__(113);
__w_pdfjs_require__(116);
__w_pdfjs_require__(123);
__w_pdfjs_require__(2);
__w_pdfjs_require__(89);
__w_pdfjs_require__(187);
var _display_utils = __w_pdfjs_require__(168);
var _util = __w_pdfjs_require__(1);
;
const SVG_DEFAULTS = {
  fontStyle: "normal",
  fontWeight: "normal",
  fillColor: "#000000"
};
const XML_NS = "http://www.w3.org/XML/1998/namespace";
const XLINK_NS = "http://www.w3.org/1999/xlink";
const LINE_CAP_STYLES = ["butt", "round", "square"];
const LINE_JOIN_STYLES = ["miter", "round", "bevel"];
const createObjectURL = function (data) {
  let contentType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  let forceDataSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (URL.createObjectURL && typeof Blob !== "undefined" && !forceDataSchema) {
    return URL.createObjectURL(new Blob([data], {
      type: contentType
    }));
  }
  const digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  let buffer = `data:${contentType};base64,`;
  for (let i = 0, ii = data.length; i < ii; i += 3) {
    const b1 = data[i] & 0xff;
    const b2 = data[i + 1] & 0xff;
    const b3 = data[i + 2] & 0xff;
    const d1 = b1 >> 2,
      d2 = (b1 & 3) << 4 | b2 >> 4;
    const d3 = i + 1 < ii ? (b2 & 0xf) << 2 | b3 >> 6 : 64;
    const d4 = i + 2 < ii ? b3 & 0x3f : 64;
    buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
  }
  return buffer;
};
const convertImgDataToPng = function () {
  const PNG_HEADER = new Uint8Array([0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a]);
  const CHUNK_WRAPPER_SIZE = 12;
  const crcTable = new Int32Array(256);
  for (let i = 0; i < 256; i++) {
    let c = i;
    for (let h = 0; h < 8; h++) {
      c = c & 1 ? 0xedb88320 ^ c >> 1 & 0x7fffffff : c >> 1 & 0x7fffffff;
    }
    crcTable[i] = c;
  }
  function crc32(data, start, end) {
    let crc = -1;
    for (let i = start; i < end; i++) {
      const a = (crc ^ data[i]) & 0xff;
      const b = crcTable[a];
      crc = crc >>> 8 ^ b;
    }
    return crc ^ -1;
  }
  function writePngChunk(type, body, data, offset) {
    let p = offset;
    const len = body.length;
    data[p] = len >> 24 & 0xff;
    data[p + 1] = len >> 16 & 0xff;
    data[p + 2] = len >> 8 & 0xff;
    data[p + 3] = len & 0xff;
    p += 4;
    data[p] = type.charCodeAt(0) & 0xff;
    data[p + 1] = type.charCodeAt(1) & 0xff;
    data[p + 2] = type.charCodeAt(2) & 0xff;
    data[p + 3] = type.charCodeAt(3) & 0xff;
    p += 4;
    data.set(body, p);
    p += body.length;
    const crc = crc32(data, offset + 4, p);
    data[p] = crc >> 24 & 0xff;
    data[p + 1] = crc >> 16 & 0xff;
    data[p + 2] = crc >> 8 & 0xff;
    data[p + 3] = crc & 0xff;
  }
  function adler32(data, start, end) {
    let a = 1;
    let b = 0;
    for (let i = start; i < end; ++i) {
      a = (a + (data[i] & 0xff)) % 65521;
      b = (b + a) % 65521;
    }
    return b << 16 | a;
  }
  function deflateSync(literals) {
    if (!_util.isNodeJS) {
      return deflateSyncUncompressed(literals);
    }
    try {
      const input = parseInt(process.versions.node) >= 8 ? literals : Buffer.from(literals);
      const output = require("zlib").deflateSync(input, {
        level: 9
      });
      return output instanceof Uint8Array ? output : new Uint8Array(output);
    } catch (e) {
      (0, _util.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + e);
    }
    return deflateSyncUncompressed(literals);
  }
  function deflateSyncUncompressed(literals) {
    let len = literals.length;
    const maxBlockLength = 0xffff;
    const deflateBlocks = Math.ceil(len / maxBlockLength);
    const idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
    let pi = 0;
    idat[pi++] = 0x78;
    idat[pi++] = 0x9c;
    let pos = 0;
    while (len > maxBlockLength) {
      idat[pi++] = 0x00;
      idat[pi++] = 0xff;
      idat[pi++] = 0xff;
      idat[pi++] = 0x00;
      idat[pi++] = 0x00;
      idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
      pi += maxBlockLength;
      pos += maxBlockLength;
      len -= maxBlockLength;
    }
    idat[pi++] = 0x01;
    idat[pi++] = len & 0xff;
    idat[pi++] = len >> 8 & 0xff;
    idat[pi++] = ~len & 0xffff & 0xff;
    idat[pi++] = (~len & 0xffff) >> 8 & 0xff;
    idat.set(literals.subarray(pos), pi);
    pi += literals.length - pos;
    const adler = adler32(literals, 0, literals.length);
    idat[pi++] = adler >> 24 & 0xff;
    idat[pi++] = adler >> 16 & 0xff;
    idat[pi++] = adler >> 8 & 0xff;
    idat[pi++] = adler & 0xff;
    return idat;
  }
  function encode(imgData, kind, forceDataSchema, isMask) {
    const width = imgData.width;
    const height = imgData.height;
    let bitDepth, colorType, lineSize;
    const bytes = imgData.data;
    switch (kind) {
      case _util.ImageKind.GRAYSCALE_1BPP:
        colorType = 0;
        bitDepth = 1;
        lineSize = width + 7 >> 3;
        break;
      case _util.ImageKind.RGB_24BPP:
        colorType = 2;
        bitDepth = 8;
        lineSize = width * 3;
        break;
      case _util.ImageKind.RGBA_32BPP:
        colorType = 6;
        bitDepth = 8;
        lineSize = width * 4;
        break;
      default:
        throw new Error("invalid format");
    }
    const literals = new Uint8Array((1 + lineSize) * height);
    let offsetLiterals = 0,
      offsetBytes = 0;
    for (let y = 0; y < height; ++y) {
      literals[offsetLiterals++] = 0;
      literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
      offsetBytes += lineSize;
      offsetLiterals += lineSize;
    }
    if (kind === _util.ImageKind.GRAYSCALE_1BPP && isMask) {
      offsetLiterals = 0;
      for (let y = 0; y < height; y++) {
        offsetLiterals++;
        for (let i = 0; i < lineSize; i++) {
          literals[offsetLiterals++] ^= 0xff;
        }
      }
    }
    const ihdr = new Uint8Array([width >> 24 & 0xff, width >> 16 & 0xff, width >> 8 & 0xff, width & 0xff, height >> 24 & 0xff, height >> 16 & 0xff, height >> 8 & 0xff, height & 0xff, bitDepth, colorType, 0x00, 0x00, 0x00]);
    const idat = deflateSync(literals);
    const pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
    const data = new Uint8Array(pngLength);
    let offset = 0;
    data.set(PNG_HEADER, offset);
    offset += PNG_HEADER.length;
    writePngChunk("IHDR", ihdr, data, offset);
    offset += CHUNK_WRAPPER_SIZE + ihdr.length;
    writePngChunk("IDATA", idat, data, offset);
    offset += CHUNK_WRAPPER_SIZE + idat.length;
    writePngChunk("IEND", new Uint8Array(0), data, offset);
    return createObjectURL(data, "image/png", forceDataSchema);
  }
  return function convertImgDataToPng(imgData, forceDataSchema, isMask) {
    const kind = imgData.kind === undefined ? _util.ImageKind.GRAYSCALE_1BPP : imgData.kind;
    return encode(imgData, kind, forceDataSchema, isMask);
  };
}();
class SVGExtraState {
  constructor() {
    this.fontSizeScale = 1;
    this.fontWeight = SVG_DEFAULTS.fontWeight;
    this.fontSize = 0;
    this.textMatrix = _util.IDENTITY_MATRIX;
    this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
    this.leading = 0;
    this.textRenderingMode = _util.TextRenderingMode.FILL;
    this.textMatrixScale = 1;
    this.x = 0;
    this.y = 0;
    this.lineX = 0;
    this.lineY = 0;
    this.charSpacing = 0;
    this.wordSpacing = 0;
    this.textHScale = 1;
    this.textRise = 0;
    this.fillColor = SVG_DEFAULTS.fillColor;
    this.strokeColor = "#000000";
    this.fillAlpha = 1;
    this.strokeAlpha = 1;
    this.lineWidth = 1;
    this.lineJoin = "";
    this.lineCap = "";
    this.miterLimit = 0;
    this.dashArray = [];
    this.dashPhase = 0;
    this.dependencies = [];
    this.activeClipUrl = null;
    this.clipGroup = null;
    this.maskId = "";
  }
  clone() {
    return Object.create(this);
  }
  setCurrentPoint(x, y) {
    this.x = x;
    this.y = y;
  }
}
function opListToTree(opList) {
  let opTree = [];
  const tmp = [];
  for (const opListElement of opList) {
    if (opListElement.fn === "save") {
      opTree.push({
        fnId: 92,
        fn: "group",
        items: []
      });
      tmp.push(opTree);
      opTree = opTree.at(-1).items;
      continue;
    }
    if (opListElement.fn === "restore") {
      opTree = tmp.pop();
    } else {
      opTree.push(opListElement);
    }
  }
  return opTree;
}
function pf(value) {
  if (Number.isInteger(value)) {
    return value.toString();
  }
  const s = value.toFixed(10);
  let i = s.length - 1;
  if (s[i] !== "0") {
    return s;
  }
  do {
    i--;
  } while (s[i] === "0");
  return s.substring(0, s[i] === "." ? i : i + 1);
}
function pm(m) {
  if (m[4] === 0 && m[5] === 0) {
    if (m[1] === 0 && m[2] === 0) {
      if (m[0] === 1 && m[3] === 1) {
        return "";
      }
      return `scale(${pf(m[0])} ${pf(m[3])})`;
    }
    if (m[0] === m[3] && m[1] === -m[2]) {
      const a = Math.acos(m[0]) * 180 / Math.PI;
      return `rotate(${pf(a)})`;
    }
  } else if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) {
    return `translate(${pf(m[4])} ${pf(m[5])})`;
  }
  return `matrix(${pf(m[0])} ${pf(m[1])} ${pf(m[2])} ${pf(m[3])} ${pf(m[4])} ` + `${pf(m[5])})`;
}
let clipCount = 0;
let maskCount = 0;
let shadingCount = 0;
class SVGGraphics {
  constructor(commonObjs, objs) {
    let forceDataSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    (0, _display_utils.deprecated)("The SVG back-end is no longer maintained and *may* be removed in the future.");
    this.svgFactory = new _display_utils.DOMSVGFactory();
    this.current = new SVGExtraState();
    this.transformMatrix = _util.IDENTITY_MATRIX;
    this.transformStack = [];
    this.extraStack = [];
    this.commonObjs = commonObjs;
    this.objs = objs;
    this.pendingClip = null;
    this.pendingEOFill = false;
    this.embedFonts = false;
    this.embeddedFonts = Object.create(null);
    this.cssStyle = null;
    this.forceDataSchema = !!forceDataSchema;
    this._operatorIdMapping = [];
    for (const op in _util.OPS) {
      this._operatorIdMapping[_util.OPS[op]] = op;
    }
  }
  getObject(data) {
    let fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (typeof data === "string") {
      return data.startsWith("g_") ? this.commonObjs.get(data) : this.objs.get(data);
    }
    return fallback;
  }
  save() {
    this.transformStack.push(this.transformMatrix);
    const old = this.current;
    this.extraStack.push(old);
    this.current = old.clone();
  }
  restore() {
    this.transformMatrix = this.transformStack.pop();
    this.current = this.extraStack.pop();
    this.pendingClip = null;
    this.tgrp = null;
  }
  group(items) {
    this.save();
    this.executeOpTree(items);
    this.restore();
  }
  loadDependencies(operatorList) {
    const fnArray = operatorList.fnArray;
    const argsArray = operatorList.argsArray;
    for (let i = 0, ii = fnArray.length; i < ii; i++) {
      if (fnArray[i] !== _util.OPS.dependency) {
        continue;
      }
      for (const obj of argsArray[i]) {
        const objsPool = obj.startsWith("g_") ? this.commonObjs : this.objs;
        const promise = new Promise(resolve => {
          objsPool.get(obj, resolve);
        });
        this.current.dependencies.push(promise);
      }
    }
    return Promise.all(this.current.dependencies);
  }
  transform(a, b, c, d, e, f) {
    const transformMatrix = [a, b, c, d, e, f];
    this.transformMatrix = _util.Util.transform(this.transformMatrix, transformMatrix);
    this.tgrp = null;
  }
  getSVG(operatorList, viewport) {
    this.viewport = viewport;
    const svgElement = this._initialize(viewport);
    return this.loadDependencies(operatorList).then(() => {
      this.transformMatrix = _util.IDENTITY_MATRIX;
      this.executeOpTree(this.convertOpList(operatorList));
      return svgElement;
    });
  }
  convertOpList(operatorList) {
    const operatorIdMapping = this._operatorIdMapping;
    const argsArray = operatorList.argsArray;
    const fnArray = operatorList.fnArray;
    const opList = [];
    for (let i = 0, ii = fnArray.length; i < ii; i++) {
      const fnId = fnArray[i];
      opList.push({
        fnId,
        fn: operatorIdMapping[fnId],
        args: argsArray[i]
      });
    }
    return opListToTree(opList);
  }
  executeOpTree(opTree) {
    for (const opTreeElement of opTree) {
      const fn = opTreeElement.fn;
      const fnId = opTreeElement.fnId;
      const args = opTreeElement.args;
      switch (fnId | 0) {
        case _util.OPS.beginText:
          this.beginText();
          break;
        case _util.OPS.dependency:
          break;
        case _util.OPS.setLeading:
          this.setLeading(args);
          break;
        case _util.OPS.setLeadingMoveText:
          this.setLeadingMoveText(args[0], args[1]);
          break;
        case _util.OPS.setFont:
          this.setFont(args);
          break;
        case _util.OPS.showText:
          this.showText(args[0]);
          break;
        case _util.OPS.showSpacedText:
          this.showText(args[0]);
          break;
        case _util.OPS.endText:
          this.endText();
          break;
        case _util.OPS.moveText:
          this.moveText(args[0], args[1]);
          break;
        case _util.OPS.setCharSpacing:
          this.setCharSpacing(args[0]);
          break;
        case _util.OPS.setWordSpacing:
          this.setWordSpacing(args[0]);
          break;
        case _util.OPS.setHScale:
          this.setHScale(args[0]);
          break;
        case _util.OPS.setTextMatrix:
          this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
          break;
        case _util.OPS.setTextRise:
          this.setTextRise(args[0]);
          break;
        case _util.OPS.setTextRenderingMode:
          this.setTextRenderingMode(args[0]);
          break;
        case _util.OPS.setLineWidth:
          this.setLineWidth(args[0]);
          break;
        case _util.OPS.setLineJoin:
          this.setLineJoin(args[0]);
          break;
        case _util.OPS.setLineCap:
          this.setLineCap(args[0]);
          break;
        case _util.OPS.setMiterLimit:
          this.setMiterLimit(args[0]);
          break;
        case _util.OPS.setFillRGBColor:
          this.setFillRGBColor(args[0], args[1], args[2]);
          break;
        case _util.OPS.setStrokeRGBColor:
          this.setStrokeRGBColor(args[0], args[1], args[2]);
          break;
        case _util.OPS.setStrokeColorN:
          this.setStrokeColorN(args);
          break;
        case _util.OPS.setFillColorN:
          this.setFillColorN(args);
          break;
        case _util.OPS.shadingFill:
          this.shadingFill(args[0]);
          break;
        case _util.OPS.setDash:
          this.setDash(args[0], args[1]);
          break;
        case _util.OPS.setRenderingIntent:
          this.setRenderingIntent(args[0]);
          break;
        case _util.OPS.setFlatness:
          this.setFlatness(args[0]);
          break;
        case _util.OPS.setGState:
          this.setGState(args[0]);
          break;
        case _util.OPS.fill:
          this.fill();
          break;
        case _util.OPS.eoFill:
          this.eoFill();
          break;
        case _util.OPS.stroke:
          this.stroke();
          break;
        case _util.OPS.fillStroke:
          this.fillStroke();
          break;
        case _util.OPS.eoFillStroke:
          this.eoFillStroke();
          break;
        case _util.OPS.clip:
          this.clip("nonzero");
          break;
        case _util.OPS.eoClip:
          this.clip("evenodd");
          break;
        case _util.OPS.paintSolidColorImageMask:
          this.paintSolidColorImageMask();
          break;
        case _util.OPS.paintImageXObject:
          this.paintImageXObject(args[0]);
          break;
        case _util.OPS.paintInlineImageXObject:
          this.paintInlineImageXObject(args[0]);
          break;
        case _util.OPS.paintImageMaskXObject:
          this.paintImageMaskXObject(args[0]);
          break;
        case _util.OPS.paintFormXObjectBegin:
          this.paintFormXObjectBegin(args[0], args[1]);
          break;
        case _util.OPS.paintFormXObjectEnd:
          this.paintFormXObjectEnd();
          break;
        case _util.OPS.closePath:
          this.closePath();
          break;
        case _util.OPS.closeStroke:
          this.closeStroke();
          break;
        case _util.OPS.closeFillStroke:
          this.closeFillStroke();
          break;
        case _util.OPS.closeEOFillStroke:
          this.closeEOFillStroke();
          break;
        case _util.OPS.nextLine:
          this.nextLine();
          break;
        case _util.OPS.transform:
          this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
          break;
        case _util.OPS.constructPath:
          this.constructPath(args[0], args[1]);
          break;
        case _util.OPS.endPath:
          this.endPath();
          break;
        case 92:
          this.group(opTreeElement.items);
          break;
        default:
          (0, _util.warn)(`Unimplemented operator ${fn}`);
          break;
      }
    }
  }
  setWordSpacing(wordSpacing) {
    this.current.wordSpacing = wordSpacing;
  }
  setCharSpacing(charSpacing) {
    this.current.charSpacing = charSpacing;
  }
  nextLine() {
    this.moveText(0, this.current.leading);
  }
  setTextMatrix(a, b, c, d, e, f) {
    const current = this.current;
    current.textMatrix = current.lineMatrix = [a, b, c, d, e, f];
    current.textMatrixScale = Math.hypot(a, b);
    current.x = current.lineX = 0;
    current.y = current.lineY = 0;
    current.xcoords = [];
    current.ycoords = [];
    current.tspan = this.svgFactory.createElement("svg:tspan");
    current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
    current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
    current.tspan.setAttributeNS(null, "y", pf(-current.y));
    current.txtElement = this.svgFactory.createElement("svg:text");
    current.txtElement.append(current.tspan);
  }
  beginText() {
    const current = this.current;
    current.x = current.lineX = 0;
    current.y = current.lineY = 0;
    current.textMatrix = _util.IDENTITY_MATRIX;
    current.lineMatrix = _util.IDENTITY_MATRIX;
    current.textMatrixScale = 1;
    current.tspan = this.svgFactory.createElement("svg:tspan");
    current.txtElement = this.svgFactory.createElement("svg:text");
    current.txtgrp = this.svgFactory.createElement("svg:g");
    current.xcoords = [];
    current.ycoords = [];
  }
  moveText(x, y) {
    const current = this.current;
    current.x = current.lineX += x;
    current.y = current.lineY += y;
    current.xcoords = [];
    current.ycoords = [];
    current.tspan = this.svgFactory.createElement("svg:tspan");
    current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
    current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
    current.tspan.setAttributeNS(null, "y", pf(-current.y));
  }
  showText(glyphs) {
    const current = this.current;
    const font = current.font;
    const fontSize = current.fontSize;
    if (fontSize === 0) {
      return;
    }
    const fontSizeScale = current.fontSizeScale;
    const charSpacing = current.charSpacing;
    const wordSpacing = current.wordSpacing;
    const fontDirection = current.fontDirection;
    const textHScale = current.textHScale * fontDirection;
    const vertical = font.vertical;
    const spacingDir = vertical ? 1 : -1;
    const defaultVMetrics = font.defaultVMetrics;
    const widthAdvanceScale = fontSize * current.fontMatrix[0];
    let x = 0;
    for (const glyph of glyphs) {
      if (glyph === null) {
        x += fontDirection * wordSpacing;
        continue;
      } else if (typeof glyph === "number") {
        x += spacingDir * glyph * fontSize / 1000;
        continue;
      }
      const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
      const character = glyph.fontChar;
      let scaledX, scaledY;
      let width = glyph.width;
      if (vertical) {
        let vx;
        const vmetric = glyph.vmetric || defaultVMetrics;
        vx = glyph.vmetric ? vmetric[1] : width * 0.5;
        vx = -vx * widthAdvanceScale;
        const vy = vmetric[2] * widthAdvanceScale;
        width = vmetric ? -vmetric[0] : width;
        scaledX = vx / fontSizeScale;
        scaledY = (x + vy) / fontSizeScale;
      } else {
        scaledX = x / fontSizeScale;
        scaledY = 0;
      }
      if (glyph.isInFont || font.missingFile) {
        current.xcoords.push(current.x + scaledX);
        if (vertical) {
          current.ycoords.push(-current.y + scaledY);
        }
        current.tspan.textContent += character;
      } else {}
      const charWidth = vertical ? width * widthAdvanceScale - spacing * fontDirection : width * widthAdvanceScale + spacing * fontDirection;
      x += charWidth;
    }
    current.tspan.setAttributeNS(null, "x", current.xcoords.map(pf).join(" "));
    if (vertical) {
      current.tspan.setAttributeNS(null, "y", current.ycoords.map(pf).join(" "));
    } else {
      current.tspan.setAttributeNS(null, "y", pf(-current.y));
    }
    if (vertical) {
      current.y -= x;
    } else {
      current.x += x * textHScale;
    }
    current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
    current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
    if (current.fontStyle !== SVG_DEFAULTS.fontStyle) {
      current.tspan.setAttributeNS(null, "font-style", current.fontStyle);
    }
    if (current.fontWeight !== SVG_DEFAULTS.fontWeight) {
      current.tspan.setAttributeNS(null, "font-weight", current.fontWeight);
    }
    const fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
    if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
      if (current.fillColor !== SVG_DEFAULTS.fillColor) {
        current.tspan.setAttributeNS(null, "fill", current.fillColor);
      }
      if (current.fillAlpha < 1) {
        current.tspan.setAttributeNS(null, "fill-opacity", current.fillAlpha);
      }
    } else if (current.textRenderingMode === _util.TextRenderingMode.ADD_TO_PATH) {
      current.tspan.setAttributeNS(null, "fill", "transparent");
    } else {
      current.tspan.setAttributeNS(null, "fill", "none");
    }
    if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
      const lineWidthScale = 1 / (current.textMatrixScale || 1);
      this._setStrokeAttributes(current.tspan, lineWidthScale);
    }
    let textMatrix = current.textMatrix;
    if (current.textRise !== 0) {
      textMatrix = textMatrix.slice();
      textMatrix[5] += current.textRise;
    }
    current.txtElement.setAttributeNS(null, "transform", `${pm(textMatrix)} scale(${pf(textHScale)}, -1)`);
    current.txtElement.setAttributeNS(XML_NS, "xml:space", "preserve");
    current.txtElement.append(current.tspan);
    current.txtgrp.append(current.txtElement);
    this._ensureTransformGroup().append(current.txtElement);
  }
  setLeadingMoveText(x, y) {
    this.setLeading(-y);
    this.moveText(x, y);
  }
  addFontStyle(fontObj) {
    if (!fontObj.data) {
      throw new Error("addFontStyle: No font data available, " + 'ensure that the "fontExtraProperties" API parameter is set.');
    }
    if (!this.cssStyle) {
      this.cssStyle = this.svgFactory.createElement("svg:style");
      this.cssStyle.setAttributeNS(null, "type", "text/css");
      this.defs.append(this.cssStyle);
    }
    const url = createObjectURL(fontObj.data, fontObj.mimetype, this.forceDataSchema);
    this.cssStyle.textContent += `@font-face { font-family: "${fontObj.loadedName}";` + ` src: url(${url}); }\n`;
  }
  setFont(details) {
    const current = this.current;
    const fontObj = this.commonObjs.get(details[0]);
    let size = details[1];
    current.font = fontObj;
    if (this.embedFonts && !fontObj.missingFile && !this.embeddedFonts[fontObj.loadedName]) {
      this.addFontStyle(fontObj);
      this.embeddedFonts[fontObj.loadedName] = fontObj;
    }
    current.fontMatrix = fontObj.fontMatrix || _util.FONT_IDENTITY_MATRIX;
    let bold = "normal";
    if (fontObj.black) {
      bold = "900";
    } else if (fontObj.bold) {
      bold = "bold";
    }
    const italic = fontObj.italic ? "italic" : "normal";
    if (size < 0) {
      size = -size;
      current.fontDirection = -1;
    } else {
      current.fontDirection = 1;
    }
    current.fontSize = size;
    current.fontFamily = fontObj.loadedName;
    current.fontWeight = bold;
    current.fontStyle = italic;
    current.tspan = this.svgFactory.createElement("svg:tspan");
    current.tspan.setAttributeNS(null, "y", pf(-current.y));
    current.xcoords = [];
    current.ycoords = [];
  }
  endText() {
    const current = this.current;
    if (current.textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG && current.txtElement?.hasChildNodes()) {
      current.element = current.txtElement;
      this.clip("nonzero");
      this.endPath();
    }
  }
  setLineWidth(width) {
    if (width > 0) {
      this.current.lineWidth = width;
    }
  }
  setLineCap(style) {
    this.current.lineCap = LINE_CAP_STYLES[style];
  }
  setLineJoin(style) {
    this.current.lineJoin = LINE_JOIN_STYLES[style];
  }
  setMiterLimit(limit) {
    this.current.miterLimit = limit;
  }
  setStrokeAlpha(strokeAlpha) {
    this.current.strokeAlpha = strokeAlpha;
  }
  setStrokeRGBColor(r, g, b) {
    this.current.strokeColor = _util.Util.makeHexColor(r, g, b);
  }
  setFillAlpha(fillAlpha) {
    this.current.fillAlpha = fillAlpha;
  }
  setFillRGBColor(r, g, b) {
    this.current.fillColor = _util.Util.makeHexColor(r, g, b);
    this.current.tspan = this.svgFactory.createElement("svg:tspan");
    this.current.xcoords = [];
    this.current.ycoords = [];
  }
  setStrokeColorN(args) {
    this.current.strokeColor = this._makeColorN_Pattern(args);
  }
  setFillColorN(args) {
    this.current.fillColor = this._makeColorN_Pattern(args);
  }
  shadingFill(args) {
    const {
      width,
      height
    } = this.viewport;
    const inv = _util.Util.inverseTransform(this.transformMatrix);
    const [x0, y0, x1, y1] = _util.Util.getAxialAlignedBoundingBox([0, 0, width, height], inv);
    const rect = this.svgFactory.createElement("svg:rect");
    rect.setAttributeNS(null, "x", x0);
    rect.setAttributeNS(null, "y", y0);
    rect.setAttributeNS(null, "width", x1 - x0);
    rect.setAttributeNS(null, "height", y1 - y0);
    rect.setAttributeNS(null, "fill", this._makeShadingPattern(args));
    if (this.current.fillAlpha < 1) {
      rect.setAttributeNS(null, "fill-opacity", this.current.fillAlpha);
    }
    this._ensureTransformGroup().append(rect);
  }
  _makeColorN_Pattern(args) {
    if (args[0] === "TilingPattern") {
      return this._makeTilingPattern(args);
    }
    return this._makeShadingPattern(args);
  }
  _makeTilingPattern(args) {
    const color = args[1];
    const operatorList = args[2];
    const matrix = args[3] || _util.IDENTITY_MATRIX;
    const [x0, y0, x1, y1] = args[4];
    const xstep = args[5];
    const ystep = args[6];
    const paintType = args[7];
    const tilingId = `shading${shadingCount++}`;
    const [tx0, ty0, tx1, ty1] = _util.Util.normalizeRect([..._util.Util.applyTransform([x0, y0], matrix), ..._util.Util.applyTransform([x1, y1], matrix)]);
    const [xscale, yscale] = _util.Util.singularValueDecompose2dScale(matrix);
    const txstep = xstep * xscale;
    const tystep = ystep * yscale;
    const tiling = this.svgFactory.createElement("svg:pattern");
    tiling.setAttributeNS(null, "id", tilingId);
    tiling.setAttributeNS(null, "patternUnits", "userSpaceOnUse");
    tiling.setAttributeNS(null, "width", txstep);
    tiling.setAttributeNS(null, "height", tystep);
    tiling.setAttributeNS(null, "x", `${tx0}`);
    tiling.setAttributeNS(null, "y", `${ty0}`);
    const svg = this.svg;
    const transformMatrix = this.transformMatrix;
    const fillColor = this.current.fillColor;
    const strokeColor = this.current.strokeColor;
    const bbox = this.svgFactory.create(tx1 - tx0, ty1 - ty0);
    this.svg = bbox;
    this.transformMatrix = matrix;
    if (paintType === 2) {
      const cssColor = _util.Util.makeHexColor(...color);
      this.current.fillColor = cssColor;
      this.current.strokeColor = cssColor;
    }
    this.executeOpTree(this.convertOpList(operatorList));
    this.svg = svg;
    this.transformMatrix = transformMatrix;
    this.current.fillColor = fillColor;
    this.current.strokeColor = strokeColor;
    tiling.append(bbox.childNodes[0]);
    this.defs.append(tiling);
    return `url(#${tilingId})`;
  }
  _makeShadingPattern(args) {
    if (typeof args === "string") {
      args = this.objs.get(args);
    }
    switch (args[0]) {
      case "RadialAxial":
        const shadingId = `shading${shadingCount++}`;
        const colorStops = args[3];
        let gradient;
        switch (args[1]) {
          case "axial":
            const point0 = args[4];
            const point1 = args[5];
            gradient = this.svgFactory.createElement("svg:linearGradient");
            gradient.setAttributeNS(null, "id", shadingId);
            gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
            gradient.setAttributeNS(null, "x1", point0[0]);
            gradient.setAttributeNS(null, "y1", point0[1]);
            gradient.setAttributeNS(null, "x2", point1[0]);
            gradient.setAttributeNS(null, "y2", point1[1]);
            break;
          case "radial":
            const focalPoint = args[4];
            const circlePoint = args[5];
            const focalRadius = args[6];
            const circleRadius = args[7];
            gradient = this.svgFactory.createElement("svg:radialGradient");
            gradient.setAttributeNS(null, "id", shadingId);
            gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
            gradient.setAttributeNS(null, "cx", circlePoint[0]);
            gradient.setAttributeNS(null, "cy", circlePoint[1]);
            gradient.setAttributeNS(null, "r", circleRadius);
            gradient.setAttributeNS(null, "fx", focalPoint[0]);
            gradient.setAttributeNS(null, "fy", focalPoint[1]);
            gradient.setAttributeNS(null, "fr", focalRadius);
            break;
          default:
            throw new Error(`Unknown RadialAxial type: ${args[1]}`);
        }
        for (const colorStop of colorStops) {
          const stop = this.svgFactory.createElement("svg:stop");
          stop.setAttributeNS(null, "offset", colorStop[0]);
          stop.setAttributeNS(null, "stop-color", colorStop[1]);
          gradient.append(stop);
        }
        this.defs.append(gradient);
        return `url(#${shadingId})`;
      case "Mesh":
        (0, _util.warn)("Unimplemented pattern Mesh");
        return null;
      case "Dummy":
        return "hotpink";
      default:
        throw new Error(`Unknown IR type: ${args[0]}`);
    }
  }
  setDash(dashArray, dashPhase) {
    this.current.dashArray = dashArray;
    this.current.dashPhase = dashPhase;
  }
  constructPath(ops, args) {
    const current = this.current;
    let x = current.x,
      y = current.y;
    let d = [];
    let j = 0;
    for (const op of ops) {
      switch (op | 0) {
        case _util.OPS.rectangle:
          x = args[j++];
          y = args[j++];
          const width = args[j++];
          const height = args[j++];
          const xw = x + width;
          const yh = y + height;
          d.push("M", pf(x), pf(y), "L", pf(xw), pf(y), "L", pf(xw), pf(yh), "L", pf(x), pf(yh), "Z");
          break;
        case _util.OPS.moveTo:
          x = args[j++];
          y = args[j++];
          d.push("M", pf(x), pf(y));
          break;
        case _util.OPS.lineTo:
          x = args[j++];
          y = args[j++];
          d.push("L", pf(x), pf(y));
          break;
        case _util.OPS.curveTo:
          x = args[j + 4];
          y = args[j + 5];
          d.push("C", pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
          j += 6;
          break;
        case _util.OPS.curveTo2:
          d.push("C", pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
          x = args[j + 2];
          y = args[j + 3];
          j += 4;
          break;
        case _util.OPS.curveTo3:
          x = args[j + 2];
          y = args[j + 3];
          d.push("C", pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
          j += 4;
          break;
        case _util.OPS.closePath:
          d.push("Z");
          break;
      }
    }
    d = d.join(" ");
    if (current.path && ops.length > 0 && ops[0] !== _util.OPS.rectangle && ops[0] !== _util.OPS.moveTo) {
      d = current.path.getAttributeNS(null, "d") + d;
    } else {
      current.path = this.svgFactory.createElement("svg:path");
      this._ensureTransformGroup().append(current.path);
    }
    current.path.setAttributeNS(null, "d", d);
    current.path.setAttributeNS(null, "fill", "none");
    current.element = current.path;
    current.setCurrentPoint(x, y);
  }
  endPath() {
    const current = this.current;
    current.path = null;
    if (!this.pendingClip) {
      return;
    }
    if (!current.element) {
      this.pendingClip = null;
      return;
    }
    const clipId = `clippath${clipCount++}`;
    const clipPath = this.svgFactory.createElement("svg:clipPath");
    clipPath.setAttributeNS(null, "id", clipId);
    clipPath.setAttributeNS(null, "transform", pm(this.transformMatrix));
    const clipElement = current.element.cloneNode(true);
    if (this.pendingClip === "evenodd") {
      clipElement.setAttributeNS(null, "clip-rule", "evenodd");
    } else {
      clipElement.setAttributeNS(null, "clip-rule", "nonzero");
    }
    this.pendingClip = null;
    clipPath.append(clipElement);
    this.defs.append(clipPath);
    if (current.activeClipUrl) {
      current.clipGroup = null;
      for (const prev of this.extraStack) {
        prev.clipGroup = null;
      }
      clipPath.setAttributeNS(null, "clip-path", current.activeClipUrl);
    }
    current.activeClipUrl = `url(#${clipId})`;
    this.tgrp = null;
  }
  clip(type) {
    this.pendingClip = type;
  }
  closePath() {
    const current = this.current;
    if (current.path) {
      const d = `${current.path.getAttributeNS(null, "d")}Z`;
      current.path.setAttributeNS(null, "d", d);
    }
  }
  setLeading(leading) {
    this.current.leading = -leading;
  }
  setTextRise(textRise) {
    this.current.textRise = textRise;
  }
  setTextRenderingMode(textRenderingMode) {
    this.current.textRenderingMode = textRenderingMode;
  }
  setHScale(scale) {
    this.current.textHScale = scale / 100;
  }
  setRenderingIntent(intent) {}
  setFlatness(flatness) {}
  setGState(states) {
    for (const [key, value] of states) {
      switch (key) {
        case "LW":
          this.setLineWidth(value);
          break;
        case "LC":
          this.setLineCap(value);
          break;
        case "LJ":
          this.setLineJoin(value);
          break;
        case "ML":
          this.setMiterLimit(value);
          break;
        case "D":
          this.setDash(value[0], value[1]);
          break;
        case "RI":
          this.setRenderingIntent(value);
          break;
        case "FL":
          this.setFlatness(value);
          break;
        case "Font":
          this.setFont(value);
          break;
        case "CA":
          this.setStrokeAlpha(value);
          break;
        case "ca":
          this.setFillAlpha(value);
          break;
        default:
          (0, _util.warn)(`Unimplemented graphic state operator ${key}`);
          break;
      }
    }
  }
  fill() {
    const current = this.current;
    if (current.element) {
      current.element.setAttributeNS(null, "fill", current.fillColor);
      current.element.setAttributeNS(null, "fill-opacity", current.fillAlpha);
      this.endPath();
    }
  }
  stroke() {
    const current = this.current;
    if (current.element) {
      this._setStrokeAttributes(current.element);
      current.element.setAttributeNS(null, "fill", "none");
      this.endPath();
    }
  }
  _setStrokeAttributes(element) {
    let lineWidthScale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    const current = this.current;
    let dashArray = current.dashArray;
    if (lineWidthScale !== 1 && dashArray.length > 0) {
      dashArray = dashArray.map(function (value) {
        return lineWidthScale * value;
      });
    }
    element.setAttributeNS(null, "stroke", current.strokeColor);
    element.setAttributeNS(null, "stroke-opacity", current.strokeAlpha);
    element.setAttributeNS(null, "stroke-miterlimit", pf(current.miterLimit));
    element.setAttributeNS(null, "stroke-linecap", current.lineCap);
    element.setAttributeNS(null, "stroke-linejoin", current.lineJoin);
    element.setAttributeNS(null, "stroke-width", pf(lineWidthScale * current.lineWidth) + "px");
    element.setAttributeNS(null, "stroke-dasharray", dashArray.map(pf).join(" "));
    element.setAttributeNS(null, "stroke-dashoffset", pf(lineWidthScale * current.dashPhase) + "px");
  }
  eoFill() {
    this.current.element?.setAttributeNS(null, "fill-rule", "evenodd");
    this.fill();
  }
  fillStroke() {
    this.stroke();
    this.fill();
  }
  eoFillStroke() {
    this.current.element?.setAttributeNS(null, "fill-rule", "evenodd");
    this.fillStroke();
  }
  closeStroke() {
    this.closePath();
    this.stroke();
  }
  closeFillStroke() {
    this.closePath();
    this.fillStroke();
  }
  closeEOFillStroke() {
    this.closePath();
    this.eoFillStroke();
  }
  paintSolidColorImageMask() {
    const rect = this.svgFactory.createElement("svg:rect");
    rect.setAttributeNS(null, "x", "0");
    rect.setAttributeNS(null, "y", "0");
    rect.setAttributeNS(null, "width", "1px");
    rect.setAttributeNS(null, "height", "1px");
    rect.setAttributeNS(null, "fill", this.current.fillColor);
    this._ensureTransformGroup().append(rect);
  }
  paintImageXObject(objId) {
    const imgData = this.getObject(objId);
    if (!imgData) {
      (0, _util.warn)(`Dependent image with object ID ${objId} is not ready yet`);
      return;
    }
    this.paintInlineImageXObject(imgData);
  }
  paintInlineImageXObject(imgData, mask) {
    const width = imgData.width;
    const height = imgData.height;
    const imgSrc = convertImgDataToPng(imgData, this.forceDataSchema, !!mask);
    const cliprect = this.svgFactory.createElement("svg:rect");
    cliprect.setAttributeNS(null, "x", "0");
    cliprect.setAttributeNS(null, "y", "0");
    cliprect.setAttributeNS(null, "width", pf(width));
    cliprect.setAttributeNS(null, "height", pf(height));
    this.current.element = cliprect;
    this.clip("nonzero");
    const imgEl = this.svgFactory.createElement("svg:image");
    imgEl.setAttributeNS(XLINK_NS, "xlink:href", imgSrc);
    imgEl.setAttributeNS(null, "x", "0");
    imgEl.setAttributeNS(null, "y", pf(-height));
    imgEl.setAttributeNS(null, "width", pf(width) + "px");
    imgEl.setAttributeNS(null, "height", pf(height) + "px");
    imgEl.setAttributeNS(null, "transform", `scale(${pf(1 / width)} ${pf(-1 / height)})`);
    if (mask) {
      mask.append(imgEl);
    } else {
      this._ensureTransformGroup().append(imgEl);
    }
  }
  paintImageMaskXObject(img) {
    const imgData = this.getObject(img.data, img);
    if (imgData.bitmap) {
      (0, _util.warn)("paintImageMaskXObject: ImageBitmap support is not implemented, " + "ensure that the `isOffscreenCanvasSupported` API parameter is disabled.");
      return;
    }
    const current = this.current;
    const width = imgData.width;
    const height = imgData.height;
    const fillColor = current.fillColor;
    current.maskId = `mask${maskCount++}`;
    const mask = this.svgFactory.createElement("svg:mask");
    mask.setAttributeNS(null, "id", current.maskId);
    const rect = this.svgFactory.createElement("svg:rect");
    rect.setAttributeNS(null, "x", "0");
    rect.setAttributeNS(null, "y", "0");
    rect.setAttributeNS(null, "width", pf(width));
    rect.setAttributeNS(null, "height", pf(height));
    rect.setAttributeNS(null, "fill", fillColor);
    rect.setAttributeNS(null, "mask", `url(#${current.maskId})`);
    this.defs.append(mask);
    this._ensureTransformGroup().append(rect);
    this.paintInlineImageXObject(imgData, mask);
  }
  paintFormXObjectBegin(matrix, bbox) {
    if (Array.isArray(matrix) && matrix.length === 6) {
      this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
    }
    if (bbox) {
      const width = bbox[2] - bbox[0];
      const height = bbox[3] - bbox[1];
      const cliprect = this.svgFactory.createElement("svg:rect");
      cliprect.setAttributeNS(null, "x", bbox[0]);
      cliprect.setAttributeNS(null, "y", bbox[1]);
      cliprect.setAttributeNS(null, "width", pf(width));
      cliprect.setAttributeNS(null, "height", pf(height));
      this.current.element = cliprect;
      this.clip("nonzero");
      this.endPath();
    }
  }
  paintFormXObjectEnd() {}
  _initialize(viewport) {
    const svg = this.svgFactory.create(viewport.width, viewport.height);
    const definitions = this.svgFactory.createElement("svg:defs");
    svg.append(definitions);
    this.defs = definitions;
    const rootGroup = this.svgFactory.createElement("svg:g");
    rootGroup.setAttributeNS(null, "transform", pm(viewport.transform));
    svg.append(rootGroup);
    this.svg = rootGroup;
    return svg;
  }
  _ensureClipGroup() {
    if (!this.current.clipGroup) {
      const clipGroup = this.svgFactory.createElement("svg:g");
      clipGroup.setAttributeNS(null, "clip-path", this.current.activeClipUrl);
      this.svg.append(clipGroup);
      this.current.clipGroup = clipGroup;
    }
    return this.current.clipGroup;
  }
  _ensureTransformGroup() {
    if (!this.tgrp) {
      this.tgrp = this.svgFactory.createElement("svg:g");
      this.tgrp.setAttributeNS(null, "transform", pm(this.transformMatrix));
      if (this.current.activeClipUrl) {
        this._ensureClipGroup().append(this.tgrp);
      } else {
        this.svg.append(this.tgrp);
      }
    }
    return this.tgrp;
  }
}
exports.SVGGraphics = SVGGraphics;

/***/ }),
/* 187 */
/***/ ((__unused_webpack_module, __unused_webpack_exports, __w_pdfjs_require__) => {


var $ = __w_pdfjs_require__(3);
var $group = __w_pdfjs_require__(188);
var addToUnscopables = __w_pdfjs_require__(193);
$({
 target: 'Array',
 proto: true
}, {
 group: function group(callbackfn) {
  var thisArg = arguments.length > 1 ? arguments[1] : undefined;
  return $group(this, callbackfn, thisArg);
 }
});
addToUnscopables('group');

/***/ }),
/* 188 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var bind = __w_pdfjs_require__(99);
var uncurryThis = __w_pdfjs_require__(14);
var IndexedObject = __w_pdfjs_require__(13);
var toObject = __w_pdfjs_require__(40);
var toPropertyKey = __w_pdfjs_require__(18);
var lengthOfArrayLike = __w_pdfjs_require__(64);
var objectCreate = __w_pdfjs_require__(189);
var arrayFromConstructorAndList = __w_pdfjs_require__(108);
var $Array = Array;
var push = uncurryThis([].push);
module.exports = function ($this, callbackfn, that, specificConstructor) {
 var O = toObject($this);
 var self = IndexedObject(O);
 var boundFunction = bind(callbackfn, that);
 var target = objectCreate(null);
 var length = lengthOfArrayLike(self);
 var index = 0;
 var Constructor, key, value;
 for (; length > index; index++) {
  value = self[index];
  key = toPropertyKey(boundFunction(value, index, O));
  if (key in target)
   push(target[key], value);
  else
   target[key] = [value];
 }
 if (specificConstructor) {
  Constructor = specificConstructor(O);
  if (Constructor !== $Array) {
   for (key in target)
    target[key] = arrayFromConstructorAndList(Constructor, target[key]);
  }
 }
 return target;
};

/***/ }),
/* 189 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var anObject = __w_pdfjs_require__(47);
var definePropertiesModule = __w_pdfjs_require__(190);
var enumBugKeys = __w_pdfjs_require__(66);
var hiddenKeys = __w_pdfjs_require__(55);
var html = __w_pdfjs_require__(192);
var documentCreateElement = __w_pdfjs_require__(43);
var sharedKey = __w_pdfjs_require__(54);
var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');
var EmptyConstructor = function () {
};
var scriptTag = function (content) {
 return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};
var NullProtoObjectViaActiveX = function (activeXDocument) {
 activeXDocument.write(scriptTag(''));
 activeXDocument.close();
 var temp = activeXDocument.parentWindow.Object;
 activeXDocument = null;
 return temp;
};
var NullProtoObjectViaIFrame = function () {
 var iframe = documentCreateElement('iframe');
 var JS = 'java' + SCRIPT + ':';
 var iframeDocument;
 iframe.style.display = 'none';
 html.appendChild(iframe);
 iframe.src = String(JS);
 iframeDocument = iframe.contentWindow.document;
 iframeDocument.open();
 iframeDocument.write(scriptTag('document.F=Object'));
 iframeDocument.close();
 return iframeDocument.F;
};
var activeXDocument;
var NullProtoObject = function () {
 try {
  activeXDocument = new ActiveXObject('htmlfile');
 } catch (error) {
 }
 NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument);
 var length = enumBugKeys.length;
 while (length--)
  delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
 return NullProtoObject();
};
hiddenKeys[IE_PROTO] = true;
module.exports = Object.create || function create(O, Properties) {
 var result;
 if (O !== null) {
  EmptyConstructor[PROTOTYPE] = anObject(O);
  result = new EmptyConstructor();
  EmptyConstructor[PROTOTYPE] = null;
  result[IE_PROTO] = O;
 } else
  result = NullProtoObject();
 return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};

/***/ }),
/* 190 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {


var DESCRIPTORS = __w_pdfjs_require__(6);
var V8_PROTOTYPE_DEFINE_BUG = __w_pdfjs_require__(46);
var definePropertyModule = __w_pdfjs_require__(45);
var anObject = __w_pdfjs_require__(47);
var toIndexedObject = __w_pdfjs_require__(12);
var objectKeys = __w_pdfjs_require__(191);
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
 anObject(O);
 var props = toIndexedObject(Properties);
 var keys = objectKeys(Properties);
 var length = keys.length;
 var index = 0;
 var key;
 while (length > index)
  definePropertyModule.f(O, key = keys[index++], props[key]);
 return O;
};

/***/ }),
/* 191 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var internalObjectKeys = __w_pdfjs_require__(59);
var enumBugKeys = __w_pdfjs_require__(66);
module.exports = Object.keys || function keys(O) {
 return internalObjectKeys(O, enumBugKeys);
};

/***/ }),
/* 192 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var getBuiltIn = __w_pdfjs_require__(24);
module.exports = getBuiltIn('document', 'documentElement');

/***/ }),
/* 193 */
/***/ ((module, __unused_webpack_exports, __w_pdfjs_require__) => {


var wellKnownSymbol = __w_pdfjs_require__(34);
var create = __w_pdfjs_require__(189);
var defineProperty = (__w_pdfjs_require__(45).f);
var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;
if (ArrayPrototype[UNSCOPABLES] === undefined) {
 defineProperty(ArrayPrototype, UNSCOPABLES, {
  configurable: true,
  value: create(null)
 });
}
module.exports = function (key) {
 ArrayPrototype[UNSCOPABLES][key] = true;
};

/***/ }),
/* 194 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.XfaText = void 0;
__w_pdfjs_require__(89);
class XfaText {
  static textContent(xfa) {
    const items = [];
    const output = {
      items,
      styles: Object.create(null)
    };
    function walk(node) {
      if (!node) {
        return;
      }
      let str = null;
      const name = node.name;
      if (name === "#text") {
        str = node.value;
      } else if (!XfaText.shouldBuildText(name)) {
        return;
      } else if (node?.attributes?.textContent) {
        str = node.attributes.textContent;
      } else if (node.value) {
        str = node.value;
      }
      if (str !== null) {
        items.push({
          str
        });
      }
      if (!node.children) {
        return;
      }
      for (const child of node.children) {
        walk(child);
      }
    }
    walk(xfa);
    return output;
  }
  static shouldBuildText(name) {
    return !(name === "textarea" || name === "input" || name === "option" || name === "select");
  }
}
exports.XfaText = XfaText;

/***/ }),
/* 195 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.TextLayerRenderTask = void 0;
exports.renderTextLayer = renderTextLayer;
exports.updateTextLayer = updateTextLayer;
__w_pdfjs_require__(89);
__w_pdfjs_require__(2);
var _util = __w_pdfjs_require__(1);
var _display_utils = __w_pdfjs_require__(168);
const MAX_TEXT_DIVS_TO_RENDER = 100000;
const DEFAULT_FONT_SIZE = 30;
const DEFAULT_FONT_ASCENT = 0.8;
const ascentCache = new Map();
function getCtx(size, isOffscreenCanvasSupported) {
  let ctx;
  if (isOffscreenCanvasSupported && _util.FeatureTest.isOffscreenCanvasSupported) {
    ctx = new OffscreenCanvas(size, size).getContext("2d", {
      alpha: false
    });
  } else {
    const canvas = document.createElement("canvas");
    canvas.width = canvas.height = size;
    ctx = canvas.getContext("2d", {
      alpha: false
    });
  }
  return ctx;
}
function getAscent(fontFamily, isOffscreenCanvasSupported) {
  const cachedAscent = ascentCache.get(fontFamily);
  if (cachedAscent) {
    return cachedAscent;
  }
  const ctx = getCtx(DEFAULT_FONT_SIZE, isOffscreenCanvasSupported);
  ctx.font = `${DEFAULT_FONT_SIZE}px ${fontFamily}`;
  const metrics = ctx.measureText("");
  let ascent = metrics.fontBoundingBoxAscent;
  let descent = Math.abs(metrics.fontBoundingBoxDescent);
  if (ascent) {
    const ratio = ascent / (ascent + descent);
    ascentCache.set(fontFamily, ratio);
    ctx.canvas.width = ctx.canvas.height = 0;
    return ratio;
  }
  ctx.strokeStyle = "red";
  ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
  ctx.strokeText("g", 0, 0);
  let pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
  descent = 0;
  for (let i = pixels.length - 1 - 3; i >= 0; i -= 4) {
    if (pixels[i] > 0) {
      descent = Math.ceil(i / 4 / DEFAULT_FONT_SIZE);
      break;
    }
  }
  ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
  ctx.strokeText("A", 0, DEFAULT_FONT_SIZE);
  pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
  ascent = 0;
  for (let i = 0, ii = pixels.length; i < ii; i += 4) {
    if (pixels[i] > 0) {
      ascent = DEFAULT_FONT_SIZE - Math.floor(i / 4 / DEFAULT_FONT_SIZE);
      break;
    }
  }
  ctx.canvas.width = ctx.canvas.height = 0;
  if (ascent) {
    const ratio = ascent / (ascent + descent);
    ascentCache.set(fontFamily, ratio);
    return ratio;
  }
  ascentCache.set(fontFamily, DEFAULT_FONT_ASCENT);
  return DEFAULT_FONT_ASCENT;
}
function appendText(task, geom, styles) {
  const textDiv = document.createElement("span");
  const textDivProperties = {
    angle: 0,
    canvasWidth: 0,
    hasText: geom.str !== "",
    hasEOL: geom.hasEOL,
    fontSize: 0
  };
  task._textDivs.push(textDiv);
  const tx = _util.Util.transform(task._transform, geom.transform);
  let angle = Math.atan2(tx[1], tx[0]);
  const style = styles[geom.fontName];
  if (style.vertical) {
    angle += Math.PI / 2;
  }
  const fontHeight = Math.hypot(tx[2], tx[3]);
  const fontAscent = fontHeight * getAscent(style.fontFamily, task._isOffscreenCanvasSupported);
  let left, top;
  if (angle === 0) {
    left = tx[4];
    top = tx[5] - fontAscent;
  } else {
    left = tx[4] + fontAscent * Math.sin(angle);
    top = tx[5] - fontAscent * Math.cos(angle);
  }
  const scaleFactorStr = "calc(var(--scale-factor)*";
  const divStyle = textDiv.style;
  if (task._container === task._rootContainer) {
    divStyle.left = `${(100 * left / task._pageWidth).toFixed(2)}%`;
    divStyle.top = `${(100 * top / task._pageHeight).toFixed(2)}%`;
  } else {
    divStyle.left = `${scaleFactorStr}${left.toFixed(2)}px)`;
    divStyle.top = `${scaleFactorStr}${top.toFixed(2)}px)`;
  }
  divStyle.fontSize = `${scaleFactorStr}${fontHeight.toFixed(2)}px)`;
  divStyle.fontFamily = style.fontFamily;
  textDivProperties.fontSize = fontHeight;
  textDiv.setAttribute("role", "presentation");
  textDiv.textContent = geom.str;
  textDiv.dir = geom.dir;
  if (task._fontInspectorEnabled) {
    textDiv.dataset.fontName = geom.fontName;
  }
  if (angle !== 0) {
    textDivProperties.angle = angle * (180 / Math.PI);
  }
  let shouldScaleText = false;
  if (geom.str.length > 1) {
    shouldScaleText = true;
  } else if (geom.str !== " " && geom.transform[0] !== geom.transform[3]) {
    const absScaleX = Math.abs(geom.transform[0]),
      absScaleY = Math.abs(geom.transform[3]);
    if (absScaleX !== absScaleY && Math.max(absScaleX, absScaleY) / Math.min(absScaleX, absScaleY) > 1.5) {
      shouldScaleText = true;
    }
  }
  if (shouldScaleText) {
    textDivProperties.canvasWidth = style.vertical ? geom.height : geom.width;
  }
  task._textDivProperties.set(textDiv, textDivProperties);
  if (task._isReadableStream) {
    task._layoutText(textDiv);
  }
}
function layout(params) {
  const {
    div,
    scale,
    properties,
    ctx,
    prevFontSize,
    prevFontFamily
  } = params;
  const {
    style
  } = div;
  let transform = "";
  if (properties.canvasWidth !== 0 && properties.hasText) {
    const {
      fontFamily
    } = style;
    const {
      canvasWidth,
      fontSize
    } = properties;
    if (prevFontSize !== fontSize || prevFontFamily !== fontFamily) {
      ctx.font = `${fontSize * scale}px ${fontFamily}`;
      params.prevFontSize = fontSize;
      params.prevFontFamily = fontFamily;
    }
    const {
      width
    } = ctx.measureText(div.textContent);
    if (width > 0) {
      transform = `scaleX(${canvasWidth * scale / width})`;
    }
  }
  if (properties.angle !== 0) {
    transform = `rotate(${properties.angle}deg) ${transform}`;
  }
  if (transform.length > 0) {
    style.transform = transform;
  }
}
function render(task) {
  if (task._canceled) {
    return;
  }
  const textDivs = task._textDivs;
  const capability = task._capability;
  const textDivsLength = textDivs.length;
  if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
    capability.resolve();
    return;
  }
  if (!task._isReadableStream) {
    for (const textDiv of textDivs) {
      task._layoutText(textDiv);
    }
  }
  capability.resolve();
}
class TextLayerRenderTask {
  constructor(_ref) {
    let {
      textContentSource,
      container,
      viewport,
      textDivs,
      textDivProperties,
      textContentItemsStr,
      isOffscreenCanvasSupported
    } = _ref;
    this._textContentSource = textContentSource;
    this._isReadableStream = textContentSource instanceof ReadableStream;
    this._container = this._rootContainer = container;
    this._textDivs = textDivs || [];
    this._textContentItemsStr = textContentItemsStr || [];
    this._isOffscreenCanvasSupported = isOffscreenCanvasSupported;
    this._fontInspectorEnabled = !!globalThis.FontInspector?.enabled;
    this._reader = null;
    this._textDivProperties = textDivProperties || new WeakMap();
    this._canceled = false;
    this._capability = new _util.PromiseCapability();
    this._layoutTextParams = {
      prevFontSize: null,
      prevFontFamily: null,
      div: null,
      scale: viewport.scale * (globalThis.devicePixelRatio || 1),
      properties: null,
      ctx: getCtx(0, isOffscreenCanvasSupported)
    };
    const {
      pageWidth,
      pageHeight,
      pageX,
      pageY
    } = viewport.rawDims;
    this._transform = [1, 0, 0, -1, -pageX, pageY + pageHeight];
    this._pageWidth = pageWidth;
    this._pageHeight = pageHeight;
    (0, _display_utils.setLayerDimensions)(container, viewport);
    this._capability.promise.finally(() => {
      this._layoutTextParams = null;
    }).catch(() => {});
  }
  get promise() {
    return this._capability.promise;
  }
  cancel() {
    this._canceled = true;
    if (this._reader) {
      this._reader.cancel(new _util.AbortException("TextLayer task cancelled.")).catch(() => {});
      this._reader = null;
    }
    this._capability.reject(new _util.AbortException("TextLayer task cancelled."));
  }
  _processItems(items, styleCache) {
    for (const item of items) {
      if (item.str === undefined) {
        if (item.type === "beginMarkedContentProps" || item.type === "beginMarkedContent") {
          const parent = this._container;
          this._container = document.createElement("span");
          this._container.classList.add("markedContent");
          if (item.id !== null) {
            this._container.setAttribute("id", `${item.id}`);
          }
          parent.append(this._container);
        } else if (item.type === "endMarkedContent") {
          this._container = this._container.parentNode;
        }
        continue;
      }
      this._textContentItemsStr.push(item.str);
      appendText(this, item, styleCache);
    }
  }
  _layoutText(textDiv) {
    const textDivProperties = this._layoutTextParams.properties = this._textDivProperties.get(textDiv);
    this._layoutTextParams.div = textDiv;
    layout(this._layoutTextParams);
    if (textDivProperties.hasText) {
      this._container.append(textDiv);
    }
    if (textDivProperties.hasEOL) {
      const br = document.createElement("br");
      br.setAttribute("role", "presentation");
      this._container.append(br);
    }
  }
  _render() {
    const capability = new _util.PromiseCapability();
    let styleCache = Object.create(null);
    if (this._isReadableStream) {
      const pump = () => {
        this._reader.read().then(_ref2 => {
          let {
            value,
            done
          } = _ref2;
          if (done) {
            capability.resolve();
            return;
          }
          Object.assign(styleCache, value.styles);
          this._processItems(value.items, styleCache);
          pump();
        }, capability.reject);
      };
      this._reader = this._textContentSource.getReader();
      pump();
    } else if (this._textContentSource) {
      const {
        items,
        styles
      } = this._textContentSource;
      this._processItems(items, styles);
      capability.resolve();
    } else {
      throw new Error('No "textContentSource" parameter specified.');
    }
    capability.promise.then(() => {
      styleCache = null;
      render(this);
    }, this._capability.reject);
  }
}
exports.TextLayerRenderTask = TextLayerRenderTask;
function renderTextLayer(params) {
  if (!params.textContentSource && (params.textContent || params.textContentStream)) {
    (0, _display_utils.deprecated)("The TextLayerRender `textContent`/`textContentStream` parameters " + "will be removed in the future, please use `textContentSource` instead.");
    params.textContentSource = params.textContent || params.textContentStream;
  }
  const {
    container,
    viewport
  } = params;
  const style = getComputedStyle(container);
  const visibility = style.getPropertyValue("visibility");
  const scaleFactor = parseFloat(style.getPropertyValue("--scale-factor"));
  if (visibility === "visible" && (!scaleFactor || Math.abs(scaleFactor - viewport.scale) > 1e-5)) {
    console.error("The `--scale-factor` CSS-variable must be set, " + "to the same value as `viewport.scale`, " + "either on the `container`-element itself or higher up in the DOM.");
  }
  const task = new TextLayerRenderTask(params);
  task._render();
  return task;
}
function updateTextLayer(_ref3) {
  let {
    container,
    viewport,
    textDivs,
    textDivProperties,
    isOffscreenCanvasSupported,
    mustRotate = true,
    mustRescale = true
  } = _ref3;
  if (mustRotate) {
    (0, _display_utils.setLayerDimensions)(container, {
      rotation: viewport.rotation
    });
  }
  if (mustRescale) {
    const ctx = getCtx(0, isOffscreenCanvasSupported);
    const scale = viewport.scale * (globalThis.devicePixelRatio || 1);
    const params = {
      prevFontSize: null,
      prevFontFamily: null,
      div: null,
      scale,
      properties: null,
      ctx
    };
    for (const div of textDivs) {
      params.properties = textDivProperties.get(div);
      params.div = div;
      layout(params);
    }
  }
}

/***/ }),
/* 196 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AnnotationEditorLayer = void 0;
__w_pdfjs_require__(125);
__w_pdfjs_require__(136);
__w_pdfjs_require__(138);
__w_pdfjs_require__(141);
__w_pdfjs_require__(143);
__w_pdfjs_require__(145);
__w_pdfjs_require__(147);
var _util = __w_pdfjs_require__(1);
var _editor = __w_pdfjs_require__(164);
var _freetext = __w_pdfjs_require__(197);
var _ink = __w_pdfjs_require__(202);
var _display_utils = __w_pdfjs_require__(168);
var _stamp = __w_pdfjs_require__(203);
class AnnotationEditorLayer {
  #accessibilityManager;
  #allowClick = false;
  #annotationLayer = null;
  #boundPointerup = this.pointerup.bind(this);
  #boundPointerdown = this.pointerdown.bind(this);
  #editors = new Map();
  #hadPointerDown = false;
  #isCleaningUp = false;
  #isDisabling = false;
  #uiManager;
  static _initialized = false;
  constructor(_ref) {
    let {
      uiManager,
      pageIndex,
      div,
      accessibilityManager,
      annotationLayer,
      viewport,
      l10n
    } = _ref;
    const editorTypes = [_freetext.FreeTextEditor, _ink.InkEditor, _stamp.StampEditor];
    if (!AnnotationEditorLayer._initialized) {
      AnnotationEditorLayer._initialized = true;
      for (const editorType of editorTypes) {
        editorType.initialize(l10n);
      }
    }
    uiManager.registerEditorTypes(editorTypes);
    this.#uiManager = uiManager;
    this.pageIndex = pageIndex;
    this.div = div;
    this.#accessibilityManager = accessibilityManager;
    this.#annotationLayer = annotationLayer;
    this.viewport = viewport;
    this.#uiManager.addLayer(this);
  }
  get isEmpty() {
    return this.#editors.size === 0;
  }
  updateToolbar(mode) {
    this.#uiManager.updateToolbar(mode);
  }
  updateMode() {
    let mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.#uiManager.getMode();
    this.#cleanup();
    if (mode === _util.AnnotationEditorType.INK) {
      this.addInkEditorIfNeeded(false);
      this.disableClick();
    } else {
      this.enableClick();
    }
    if (mode !== _util.AnnotationEditorType.NONE) {
      this.div.classList.toggle("freeTextEditing", mode === _util.AnnotationEditorType.FREETEXT);
      this.div.classList.toggle("inkEditing", mode === _util.AnnotationEditorType.INK);
      this.div.classList.toggle("stampEditing", mode === _util.AnnotationEditorType.STAMP);
      this.div.hidden = false;
    }
  }
  addInkEditorIfNeeded(isCommitting) {
    if (!isCommitting && this.#uiManager.getMode() !== _util.AnnotationEditorType.INK) {
      return;
    }
    if (!isCommitting) {
      for (const editor of this.#editors.values()) {
        if (editor.isEmpty()) {
          editor.setInBackground();
          return;
        }
      }
    }
    const editor = this.#createAndAddNewEditor({
      offsetX: 0,
      offsetY: 0
    }, false);
    editor.setInBackground();
  }
  setEditingState(isEditing) {
    this.#uiManager.setEditingState(isEditing);
  }
  addCommands(params) {
    this.#uiManager.addCommands(params);
  }
  enable() {
    this.div.style.pointerEvents = "auto";
    const annotationElementIds = new Set();
    for (const editor of this.#editors.values()) {
      editor.enableEditing();
      if (editor.annotationElementId) {
        annotationElementIds.add(editor.annotationElementId);
      }
    }
    if (!this.#annotationLayer) {
      return;
    }
    const editables = this.#annotationLayer.getEditableAnnotations();
    for (const editable of editables) {
      editable.hide();
      if (this.#uiManager.isDeletedAnnotationElement(editable.data.id)) {
        continue;
      }
      if (annotationElementIds.has(editable.data.id)) {
        continue;
      }
      const editor = this.deserialize(editable);
      if (!editor) {
        continue;
      }
      this.addOrRebuild(editor);
      editor.enableEditing();
    }
  }
  disable() {
    this.#isDisabling = true;
    this.div.style.pointerEvents = "none";
    const hiddenAnnotationIds = new Set();
    for (const editor of this.#editors.values()) {
      editor.disableEditing();
      if (!editor.annotationElementId || editor.serialize() !== null) {
        hiddenAnnotationIds.add(editor.annotationElementId);
        continue;
      }
      this.getEditableAnnotation(editor.annotationElementId)?.show();
      editor.remove();
    }
    if (this.#annotationLayer) {
      const editables = this.#annotationLayer.getEditableAnnotations();
      for (const editable of editables) {
        const {
          id
        } = editable.data;
        if (hiddenAnnotationIds.has(id) || this.#uiManager.isDeletedAnnotationElement(id)) {
          continue;
        }
        editable.show();
      }
    }
    this.#cleanup();
    if (this.isEmpty) {
      this.div.hidden = true;
    }
    this.#isDisabling = false;
  }
  getEditableAnnotation(id) {
    return this.#annotationLayer?.getEditableAnnotation(id) || null;
  }
  setActiveEditor(editor) {
    const currentActive = this.#uiManager.getActive();
    if (currentActive === editor) {
      return;
    }
    this.#uiManager.setActiveEditor(editor);
  }
  enableClick() {
    this.div.addEventListener("pointerdown", this.#boundPointerdown);
    this.div.addEventListener("pointerup", this.#boundPointerup);
  }
  disableClick() {
    this.div.removeEventListener("pointerdown", this.#boundPointerdown);
    this.div.removeEventListener("pointerup", this.#boundPointerup);
  }
  attach(editor) {
    this.#editors.set(editor.id, editor);
    const {
      annotationElementId
    } = editor;
    if (annotationElementId && this.#uiManager.isDeletedAnnotationElement(annotationElementId)) {
      this.#uiManager.removeDeletedAnnotationElement(editor);
    }
  }
  detach(editor) {
    this.#editors.delete(editor.id);
    this.#accessibilityManager?.removePointerInTextLayer(editor.contentDiv);
    if (!this.#isDisabling && editor.annotationElementId) {
      this.#uiManager.addDeletedAnnotationElement(editor);
    }
  }
  remove(editor) {
    this.detach(editor);
    this.#uiManager.removeEditor(editor);
    if (editor.div.contains(document.activeElement)) {
      setTimeout(() => {
        this.#uiManager.focusMainContainer();
      }, 0);
    }
    editor.div.remove();
    editor.isAttachedToDOM = false;
    if (!this.#isCleaningUp) {
      this.addInkEditorIfNeeded(false);
    }
  }
  changeParent(editor) {
    if (editor.parent === this) {
      return;
    }
    if (editor.annotationElementId) {
      this.#uiManager.addDeletedAnnotationElement(editor.annotationElementId);
      _editor.AnnotationEditor.deleteAnnotationElement(editor);
      editor.annotationElementId = null;
    }
    this.attach(editor);
    editor.parent?.detach(editor);
    editor.setParent(this);
    if (editor.div && editor.isAttachedToDOM) {
      editor.div.remove();
      this.div.append(editor.div);
    }
  }
  add(editor) {
    this.changeParent(editor);
    this.#uiManager.addEditor(editor);
    this.attach(editor);
    if (!editor.isAttachedToDOM) {
      const div = editor.render();
      this.div.append(div);
      editor.isAttachedToDOM = true;
    }
    editor.fixAndSetPosition();
    editor.onceAdded();
    this.#uiManager.addToAnnotationStorage(editor);
  }
  moveEditorInDOM(editor) {
    if (!editor.isAttachedToDOM) {
      return;
    }
    const {
      activeElement
    } = document;
    if (editor.div.contains(activeElement)) {
      editor._focusEventsAllowed = false;
      setTimeout(() => {
        if (!editor.div.contains(document.activeElement)) {
          editor.div.addEventListener("focusin", () => {
            editor._focusEventsAllowed = true;
          }, {
            once: true
          });
          activeElement.focus();
        } else {
          editor._focusEventsAllowed = true;
        }
      }, 0);
    }
    editor._structTreeParentId = this.#accessibilityManager?.moveElementInDOM(this.div, editor.div, editor.contentDiv, true);
  }
  addOrRebuild(editor) {
    if (editor.needsToBeRebuilt()) {
      editor.rebuild();
    } else {
      this.add(editor);
    }
  }
  addUndoableEditor(editor) {
    const cmd = () => editor._uiManager.rebuild(editor);
    const undo = () => {
      editor.remove();
    };
    this.addCommands({
      cmd,
      undo,
      mustExec: false
    });
  }
  getNextId() {
    return this.#uiManager.getId();
  }
  #createNewEditor(params) {
    switch (this.#uiManager.getMode()) {
      case _util.AnnotationEditorType.FREETEXT:
        return new _freetext.FreeTextEditor(params);
      case _util.AnnotationEditorType.INK:
        return new _ink.InkEditor(params);
      case _util.AnnotationEditorType.STAMP:
        return new _stamp.StampEditor(params);
    }
    return null;
  }
  pasteEditor(mode, params) {
    this.#uiManager.updateToolbar(mode);
    this.#uiManager.updateMode(mode);
    const {
      offsetX,
      offsetY
    } = this.#getCenterPoint();
    const id = this.getNextId();
    const editor = this.#createNewEditor({
      parent: this,
      id,
      x: offsetX,
      y: offsetY,
      uiManager: this.#uiManager,
      isCentered: true,
      ...params
    });
    if (editor) {
      this.add(editor);
    }
  }
  deserialize(data) {
    switch (data.annotationType ?? data.annotationEditorType) {
      case _util.AnnotationEditorType.FREETEXT:
        return _freetext.FreeTextEditor.deserialize(data, this, this.#uiManager);
      case _util.AnnotationEditorType.INK:
        return _ink.InkEditor.deserialize(data, this, this.#uiManager);
      case _util.AnnotationEditorType.STAMP:
        return _stamp.StampEditor.deserialize(data, this, this.#uiManager);
    }
    return null;
  }
  #createAndAddNewEditor(event, isCentered) {
    const id = this.getNextId();
    const editor = this.#createNewEditor({
      parent: this,
      id,
      x: event.offsetX,
      y: event.offsetY,
      uiManager: this.#uiManager,
      isCentered
    });
    if (editor) {
      this.add(editor);
    }
    return editor;
  }
  #getCenterPoint() {
    const {
      x,
      y,
      width,
      height
    } = this.div.getBoundingClientRect();
    const tlX = Math.max(0, x);
    const tlY = Math.max(0, y);
    const brX = Math.min(window.innerWidth, x + width);
    const brY = Math.min(window.innerHeight, y + height);
    const centerX = (tlX + brX) / 2 - x;
    const centerY = (tlY + brY) / 2 - y;
    const [offsetX, offsetY] = this.viewport.rotation % 180 === 0 ? [centerX, centerY] : [centerY, centerX];
    return {
      offsetX,
      offsetY
    };
  }
  addNewEditor() {
    this.#createAndAddNewEditor(this.#getCenterPoint(), true);
  }
  setSelected(editor) {
    this.#uiManager.setSelected(editor);
  }
  toggleSelected(editor) {
    this.#uiManager.toggleSelected(editor);
  }
  isSelected(editor) {
    return this.#uiManager.isSelected(editor);
  }
  unselect(editor) {
    this.#uiManager.unselect(editor);
  }
  pointerup(event) {
    const {
      isMac
    } = _util.FeatureTest.platform;
    if (event.button !== 0 || event.ctrlKey && isMac) {
      return;
    }
    if (event.target !== this.div) {
      return;
    }
    if (!this.#hadPointerDown) {
      return;
    }
    this.#hadPointerDown = false;
    if (!this.#allowClick) {
      this.#allowClick = true;
      return;
    }
    if (this.#uiManager.getMode() === _util.AnnotationEditorType.STAMP) {
      this.#uiManager.unselectAll();
      return;
    }
    this.#createAndAddNewEditor(event, false);
  }
  pointerdown(event) {
    if (this.#hadPointerDown) {
      this.#hadPointerDown = false;
      return;
    }
    const {
      isMac
    } = _util.FeatureTest.platform;
    if (event.button !== 0 || event.ctrlKey && isMac) {
      return;
    }
    if (event.target !== this.div) {
      return;
    }
    this.#hadPointerDown = true;
    const editor = this.#uiManager.getActive();
    this.#allowClick = !editor || editor.isEmpty();
  }
  findNewParent(editor, x, y) {
    const layer = this.#uiManager.findParent(x, y);
    if (layer === null || layer === this) {
      return false;
    }
    layer.changeParent(editor);
    return true;
  }
  destroy() {
    if (this.#uiManager.getActive()?.parent === this) {
      this.#uiManager.commitOrRemove();
      this.#uiManager.setActiveEditor(null);
    }
    for (const editor of this.#editors.values()) {
      this.#accessibilityManager?.removePointerInTextLayer(editor.contentDiv);
      editor.setParent(null);
      editor.isAttachedToDOM = false;
      editor.div.remove();
    }
    this.div = null;
    this.#editors.clear();
    this.#uiManager.removeLayer(this);
  }
  #cleanup() {
    this.#isCleaningUp = true;
    for (const editor of this.#editors.values()) {
      if (editor.isEmpty()) {
        editor.remove();
      }
    }
    this.#isCleaningUp = false;
  }
  render(_ref2) {
    let {
      viewport
    } = _ref2;
    this.viewport = viewport;
    (0, _display_utils.setLayerDimensions)(this.div, viewport);
    for (const editor of this.#uiManager.getEditors(this.pageIndex)) {
      this.add(editor);
    }
    this.updateMode();
  }
  update(_ref3) {
    let {
      viewport
    } = _ref3;
    this.#uiManager.commitOrRemove();
    this.viewport = viewport;
    (0, _display_utils.setLayerDimensions)(this.div, {
      rotation: viewport.rotation
    });
    this.updateMode();
  }
  get pageDimensions() {
    const {
      pageWidth,
      pageHeight
    } = this.viewport.rawDims;
    return [pageWidth, pageHeight];
  }
}
exports.AnnotationEditorLayer = AnnotationEditorLayer;

/***/ }),
/* 197 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.FreeTextEditor = void 0;
__w_pdfjs_require__(89);
var _util = __w_pdfjs_require__(1);
var _tools = __w_pdfjs_require__(165);
var _editor = __w_pdfjs_require__(164);
var _annotation_layer = __w_pdfjs_require__(198);
class FreeTextEditor extends _editor.AnnotationEditor {
  #boundEditorDivBlur = this.editorDivBlur.bind(this);
  #boundEditorDivFocus = this.editorDivFocus.bind(this);
  #boundEditorDivInput = this.editorDivInput.bind(this);
  #boundEditorDivKeydown = this.editorDivKeydown.bind(this);
  #color;
  #content = "";
  #editorDivId = `${this.id}-editor`;
  #fontSize;
  #initialData = null;
  static _freeTextDefaultContent = "";
  static _internalPadding = 0;
  static _defaultColor = null;
  static _defaultFontSize = 10;
  static get _keyboardManager() {
    const proto = FreeTextEditor.prototype;
    const arrowChecker = self => self.isEmpty();
    const small = _tools.AnnotationEditorUIManager.TRANSLATE_SMALL;
    const big = _tools.AnnotationEditorUIManager.TRANSLATE_BIG;
    return (0, _util.shadow)(this, "_keyboardManager", new _tools.KeyboardManager([[["ctrl+s", "mac+meta+s", "ctrl+p", "mac+meta+p"], proto.commitOrRemove, {
      bubbles: true
    }], [["ctrl+Enter", "mac+meta+Enter", "Escape", "mac+Escape"], proto.commitOrRemove], [["ArrowLeft", "mac+ArrowLeft"], proto._translateEmpty, {
      args: [-small, 0],
      checker: arrowChecker
    }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], proto._translateEmpty, {
      args: [-big, 0],
      checker: arrowChecker
    }], [["ArrowRight", "mac+ArrowRight"], proto._translateEmpty, {
      args: [small, 0],
      checker: arrowChecker
    }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], proto._translateEmpty, {
      args: [big, 0],
      checker: arrowChecker
    }], [["ArrowUp", "mac+ArrowUp"], proto._translateEmpty, {
      args: [0, -small],
      checker: arrowChecker
    }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], proto._translateEmpty, {
      args: [0, -big],
      checker: arrowChecker
    }], [["ArrowDown", "mac+ArrowDown"], proto._translateEmpty, {
      args: [0, small],
      checker: arrowChecker
    }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], proto._translateEmpty, {
      args: [0, big],
      checker: arrowChecker
    }]]));
  }
  static _type = "freetext";
  constructor(params) {
    super({
      ...params,
      name: "freeTextEditor"
    });
    this.#color = params.color || FreeTextEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor;
    this.#fontSize = params.fontSize || FreeTextEditor._defaultFontSize;
  }
  static initialize(l10n) {
    _editor.AnnotationEditor.initialize(l10n, {
      strings: ["free_text2_default_content", "editor_free_text2_aria_label"]
    });
    const style = getComputedStyle(document.documentElement);
    this._internalPadding = parseFloat(style.getPropertyValue("--freetext-padding"));
  }
  static updateDefaultParams(type, value) {
    switch (type) {
      case _util.AnnotationEditorParamsType.FREETEXT_SIZE:
        FreeTextEditor._defaultFontSize = value;
        break;
      case _util.AnnotationEditorParamsType.FREETEXT_COLOR:
        FreeTextEditor._defaultColor = value;
        break;
    }
  }
  updateParams(type, value) {
    switch (type) {
      case _util.AnnotationEditorParamsType.FREETEXT_SIZE:
        this.#updateFontSize(value);
        break;
      case _util.AnnotationEditorParamsType.FREETEXT_COLOR:
        this.#updateColor(value);
        break;
    }
  }
  static get defaultPropertiesToUpdate() {
    return [[_util.AnnotationEditorParamsType.FREETEXT_SIZE, FreeTextEditor._defaultFontSize], [_util.AnnotationEditorParamsType.FREETEXT_COLOR, FreeTextEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor]];
  }
  get propertiesToUpdate() {
    return [[_util.AnnotationEditorParamsType.FREETEXT_SIZE, this.#fontSize], [_util.AnnotationEditorParamsType.FREETEXT_COLOR, this.#color]];
  }
  #updateFontSize(fontSize) {
    const setFontsize = size => {
      this.editorDiv.style.fontSize = `calc(${size}px * var(--scale-factor))`;
      this.translate(0, -(size - this.#fontSize) * this.parentScale);
      this.#fontSize = size;
      this.#setEditorDimensions();
    };
    const savedFontsize = this.#fontSize;
    this.addCommands({
      cmd: () => {
        setFontsize(fontSize);
      },
      undo: () => {
        setFontsize(savedFontsize);
      },
      mustExec: true,
      type: _util.AnnotationEditorParamsType.FREETEXT_SIZE,
      overwriteIfSameType: true,
      keepUndo: true
    });
  }
  #updateColor(color) {
    const savedColor = this.#color;
    this.addCommands({
      cmd: () => {
        this.#color = this.editorDiv.style.color = color;
      },
      undo: () => {
        this.#color = this.editorDiv.style.color = savedColor;
      },
      mustExec: true,
      type: _util.AnnotationEditorParamsType.FREETEXT_COLOR,
      overwriteIfSameType: true,
      keepUndo: true
    });
  }
  _translateEmpty(x, y) {
    this._uiManager.translateSelectedEditors(x, y, true);
  }
  getInitialTranslation() {
    const scale = this.parentScale;
    return [-FreeTextEditor._internalPadding * scale, -(FreeTextEditor._internalPadding + this.#fontSize) * scale];
  }
  rebuild() {
    if (!this.parent) {
      return;
    }
    super.rebuild();
    if (this.div === null) {
      return;
    }
    if (!this.isAttachedToDOM) {
      this.parent.add(this);
    }
  }
  enableEditMode() {
    if (this.isInEditMode()) {
      return;
    }
    this.parent.setEditingState(false);
    this.parent.updateToolbar(_util.AnnotationEditorType.FREETEXT);
    super.enableEditMode();
    this.overlayDiv.classList.remove("enabled");
    this.editorDiv.contentEditable = true;
    this._isDraggable = false;
    this.div.removeAttribute("aria-activedescendant");
    this.editorDiv.addEventListener("keydown", this.#boundEditorDivKeydown);
    this.editorDiv.addEventListener("focus", this.#boundEditorDivFocus);
    this.editorDiv.addEventListener("blur", this.#boundEditorDivBlur);
    this.editorDiv.addEventListener("input", this.#boundEditorDivInput);
  }
  disableEditMode() {
    if (!this.isInEditMode()) {
      return;
    }
    this.parent.setEditingState(true);
    super.disableEditMode();
    this.overlayDiv.classList.add("enabled");
    this.editorDiv.contentEditable = false;
    this.div.setAttribute("aria-activedescendant", this.#editorDivId);
    this._isDraggable = true;
    this.editorDiv.removeEventListener("keydown", this.#boundEditorDivKeydown);
    this.editorDiv.removeEventListener("focus", this.#boundEditorDivFocus);
    this.editorDiv.removeEventListener("blur", this.#boundEditorDivBlur);
    this.editorDiv.removeEventListener("input", this.#boundEditorDivInput);
    this.div.focus({
      preventScroll: true
    });
    this.isEditing = false;
    this.parent.div.classList.add("freeTextEditing");
  }
  focusin(event) {
    if (!this._focusEventsAllowed) {
      return;
    }
    super.focusin(event);
    if (event.target !== this.editorDiv) {
      this.editorDiv.focus();
    }
  }
  onceAdded() {
    if (this.width) {
      this.#cheatInitialRect();
      return;
    }
    this.enableEditMode();
    this.editorDiv.focus();
    if (this._initialOptions?.isCentered) {
      this.center();
    }
    this._initialOptions = null;
  }
  isEmpty() {
    return !this.editorDiv || this.editorDiv.innerText.trim() === "";
  }
  remove() {
    this.isEditing = false;
    if (this.parent) {
      this.parent.setEditingState(true);
      this.parent.div.classList.add("freeTextEditing");
    }
    super.remove();
  }
  #extractText() {
    const divs = this.editorDiv.getElementsByTagName("div");
    if (divs.length === 0) {
      return this.editorDiv.innerText;
    }
    const buffer = [];
    for (const div of divs) {
      buffer.push(div.innerText.replace(/\r\n?|\n/, ""));
    }
    return buffer.join("\n");
  }
  #setEditorDimensions() {
    const [parentWidth, parentHeight] = this.parentDimensions;
    let rect;
    if (this.isAttachedToDOM) {
      rect = this.div.getBoundingClientRect();
    } else {
      const {
        currentLayer,
        div
      } = this;
      const savedDisplay = div.style.display;
      div.style.display = "hidden";
      currentLayer.div.append(this.div);
      rect = div.getBoundingClientRect();
      div.remove();
      div.style.display = savedDisplay;
    }
    if (this.rotation % 180 === this.parentRotation % 180) {
      this.width = rect.width / parentWidth;
      this.height = rect.height / parentHeight;
    } else {
      this.width = rect.height / parentWidth;
      this.height = rect.width / parentHeight;
    }
    this.fixAndSetPosition();
  }
  commit() {
    if (!this.isInEditMode()) {
      return;
    }
    super.commit();
    this.disableEditMode();
    const savedText = this.#content;
    const newText = this.#content = this.#extractText().trimEnd();
    if (savedText === newText) {
      return;
    }
    const setText = text => {
      this.#content = text;
      if (!text) {
        this.remove();
        return;
      }
      this.#setContent();
      this._uiManager.rebuild(this);
      this.#setEditorDimensions();
    };
    this.addCommands({
      cmd: () => {
        setText(newText);
      },
      undo: () => {
        setText(savedText);
      },
      mustExec: false
    });
    this.#setEditorDimensions();
  }
  shouldGetKeyboardEvents() {
    return this.isInEditMode();
  }
  enterInEditMode() {
    this.enableEditMode();
    this.editorDiv.focus();
  }
  dblclick(event) {
    this.enterInEditMode();
  }
  keydown(event) {
    if (event.target === this.div && event.key === "Enter") {
      this.enterInEditMode();
      event.preventDefault();
    }
  }
  editorDivKeydown(event) {
    FreeTextEditor._keyboardManager.exec(this, event);
  }
  editorDivFocus(event) {
    this.isEditing = true;
  }
  editorDivBlur(event) {
    this.isEditing = false;
  }
  editorDivInput(event) {
    this.parent.div.classList.toggle("freeTextEditing", this.isEmpty());
  }
  disableEditing() {
    this.editorDiv.setAttribute("role", "comment");
    this.editorDiv.removeAttribute("aria-multiline");
  }
  enableEditing() {
    this.editorDiv.setAttribute("role", "textbox");
    this.editorDiv.setAttribute("aria-multiline", true);
  }
  render() {
    if (this.div) {
      return this.div;
    }
    let baseX, baseY;
    if (this.width) {
      baseX = this.x;
      baseY = this.y;
    }
    super.render();
    this.editorDiv = document.createElement("div");
    this.editorDiv.className = "internal";
    this.editorDiv.setAttribute("id", this.#editorDivId);
    this.enableEditing();
    _editor.AnnotationEditor._l10nPromise.get("editor_free_text2_aria_label").then(msg => this.editorDiv?.setAttribute("aria-label", msg));
    _editor.AnnotationEditor._l10nPromise.get("free_text2_default_content").then(msg => this.editorDiv?.setAttribute("default-content", msg));
    this.editorDiv.contentEditable = true;
    const {
      style
    } = this.editorDiv;
    style.fontSize = `calc(${this.#fontSize}px * var(--scale-factor))`;
    style.color = this.#color;
    this.div.append(this.editorDiv);
    this.overlayDiv = document.createElement("div");
    this.overlayDiv.classList.add("overlay", "enabled");
    this.div.append(this.overlayDiv);
    (0, _tools.bindEvents)(this, this.div, ["dblclick", "keydown"]);
    if (this.width) {
      const [parentWidth, parentHeight] = this.parentDimensions;
      if (this.annotationElementId) {
        const {
          position
        } = this.#initialData;
        let [tx, ty] = this.getInitialTranslation();
        [tx, ty] = this.pageTranslationToScreen(tx, ty);
        const [pageWidth, pageHeight] = this.pageDimensions;
        const [pageX, pageY] = this.pageTranslation;
        let posX, posY;
        switch (this.rotation) {
          case 0:
            posX = baseX + (position[0] - pageX) / pageWidth;
            posY = baseY + this.height - (position[1] - pageY) / pageHeight;
            break;
          case 90:
            posX = baseX + (position[0] - pageX) / pageWidth;
            posY = baseY - (position[1] - pageY) / pageHeight;
            [tx, ty] = [ty, -tx];
            break;
          case 180:
            posX = baseX - this.width + (position[0] - pageX) / pageWidth;
            posY = baseY - (position[1] - pageY) / pageHeight;
            [tx, ty] = [-tx, -ty];
            break;
          case 270:
            posX = baseX + (position[0] - pageX - this.height * pageHeight) / pageWidth;
            posY = baseY + (position[1] - pageY - this.width * pageWidth) / pageHeight;
            [tx, ty] = [-ty, tx];
            break;
        }
        this.setAt(posX * parentWidth, posY * parentHeight, tx, ty);
      } else {
        this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
      }
      this.#setContent();
      this._isDraggable = true;
      this.editorDiv.contentEditable = false;
    } else {
      this._isDraggable = false;
      this.editorDiv.contentEditable = true;
    }
    return this.div;
  }
  #setContent() {
    this.editorDiv.replaceChildren();
    if (!this.#content) {
      return;
    }
    for (const line of this.#content.split("\n")) {
      const div = document.createElement("div");
      div.append(line ? document.createTextNode(line) : document.createElement("br"));
      this.editorDiv.append(div);
    }
  }
  get contentDiv() {
    return this.editorDiv;
  }
  static deserialize(data, parent, uiManager) {
    let initialData = null;
    if (data instanceof _annotation_layer.FreeTextAnnotationElement) {
      const {
        data: {
          defaultAppearanceData: {
            fontSize,
            fontColor
          },
          rect,
          rotation,
          id
        },
        textContent,
        textPosition,
        parent: {
          page: {
            pageNumber
          }
        }
      } = data;
      if (!textContent || textContent.length === 0) {
        return null;
      }
      initialData = data = {
        annotationType: _util.AnnotationEditorType.FREETEXT,
        color: Array.from(fontColor),
        fontSize,
        value: textContent.join("\n"),
        position: textPosition,
        pageIndex: pageNumber - 1,
        rect,
        rotation,
        id,
        deleted: false
      };
    }
    const editor = super.deserialize(data, parent, uiManager);
    editor.#fontSize = data.fontSize;
    editor.#color = _util.Util.makeHexColor(...data.color);
    editor.#content = data.value;
    editor.annotationElementId = data.id || null;
    editor.#initialData = initialData;
    return editor;
  }
  serialize() {
    let isForCopying = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (this.isEmpty()) {
      return null;
    }
    if (this.deleted) {
      return {
        pageIndex: this.pageIndex,
        id: this.annotationElementId,
        deleted: true
      };
    }
    const padding = FreeTextEditor._internalPadding * this.parentScale;
    const rect = this.getRect(padding, padding);
    const color = _editor.AnnotationEditor._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : this.#color);
    const serialized = {
      annotationType: _util.AnnotationEditorType.FREETEXT,
      color,
      fontSize: this.#fontSize,
      value: this.#content,
      pageIndex: this.pageIndex,
      rect,
      rotation: this.rotation,
      structTreeParentId: this._structTreeParentId
    };
    if (isForCopying) {
      return serialized;
    }
    if (this.annotationElementId && !this.#hasElementChanged(serialized)) {
      return null;
    }
    serialized.id = this.annotationElementId;
    return serialized;
  }
  #hasElementChanged(serialized) {
    const {
      value,
      fontSize,
      color,
      rect,
      pageIndex
    } = this.#initialData;
    return serialized.value !== value || serialized.fontSize !== fontSize || serialized.rect.some((x, i) => Math.abs(x - rect[i]) >= 1) || serialized.color.some((c, i) => c !== color[i]) || serialized.pageIndex !== pageIndex;
  }
  #cheatInitialRect() {
    let delayed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (!this.annotationElementId) {
      return;
    }
    this.#setEditorDimensions();
    if (!delayed && (this.width === 0 || this.height === 0)) {
      setTimeout(() => this.#cheatInitialRect(true), 0);
      return;
    }
    const padding = FreeTextEditor._internalPadding * this.parentScale;
    this.#initialData.rect = this.getRect(padding, padding);
  }
}
exports.FreeTextEditor = FreeTextEditor;

/***/ }),
/* 198 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.StampAnnotationElement = exports.InkAnnotationElement = exports.FreeTextAnnotationElement = exports.AnnotationLayer = void 0;
__w_pdfjs_require__(89);
__w_pdfjs_require__(125);
__w_pdfjs_require__(136);
__w_pdfjs_require__(138);
__w_pdfjs_require__(141);
__w_pdfjs_require__(143);
__w_pdfjs_require__(145);
__w_pdfjs_require__(147);
var _util = __w_pdfjs_require__(1);
var _display_utils = __w_pdfjs_require__(168);
var _annotation_storage = __w_pdfjs_require__(163);
var _scripting_utils = __w_pdfjs_require__(199);
var _displayL10n_utils = __w_pdfjs_require__(200);
var _xfa_layer = __w_pdfjs_require__(201);
const DEFAULT_TAB_INDEX = 1000;
const DEFAULT_FONT_SIZE = 9;
const GetElementsByNameSet = new WeakSet();
function getRectDims(rect) {
  return {
    width: rect[2] - rect[0],
    height: rect[3] - rect[1]
  };
}
class AnnotationElementFactory {
  static create(parameters) {
    const subtype = parameters.data.annotationType;
    switch (subtype) {
      case _util.AnnotationType.LINK:
        return new LinkAnnotationElement(parameters);
      case _util.AnnotationType.TEXT:
        return new TextAnnotationElement(parameters);
      case _util.AnnotationType.WIDGET:
        const fieldType = parameters.data.fieldType;
        switch (fieldType) {
          case "Tx":
            return new TextWidgetAnnotationElement(parameters);
          case "Btn":
            if (parameters.data.radioButton) {
              return new RadioButtonWidgetAnnotationElement(parameters);
            } else if (parameters.data.checkBox) {
              return new CheckboxWidgetAnnotationElement(parameters);
            }
            return new PushButtonWidgetAnnotationElement(parameters);
          case "Ch":
            return new ChoiceWidgetAnnotationElement(parameters);
          case "Sig":
            return new SignatureWidgetAnnotationElement(parameters);
        }
        return new WidgetAnnotationElement(parameters);
      case _util.AnnotationType.POPUP:
        return new PopupAnnotationElement(parameters);
      case _util.AnnotationType.FREETEXT:
        return new FreeTextAnnotationElement(parameters);
      case _util.AnnotationType.LINE:
        return new LineAnnotationElement(parameters);
      case _util.AnnotationType.SQUARE:
        return new SquareAnnotationElement(parameters);
      case _util.AnnotationType.CIRCLE:
        return new CircleAnnotationElement(parameters);
      case _util.AnnotationType.POLYLINE:
        return new PolylineAnnotationElement(parameters);
      case _util.AnnotationType.CARET:
        return new CaretAnnotationElement(parameters);
      case _util.AnnotationType.INK:
        return new InkAnnotationElement(parameters);
      case _util.AnnotationType.POLYGON:
        return new PolygonAnnotationElement(parameters);
      case _util.AnnotationType.HIGHLIGHT:
        return new HighlightAnnotationElement(parameters);
      case _util.AnnotationType.UNDERLINE:
        return new UnderlineAnnotationElement(parameters);
      case _util.AnnotationType.SQUIGGLY:
        return new SquigglyAnnotationElement(parameters);
      case _util.AnnotationType.STRIKEOUT:
        return new StrikeOutAnnotationElement(parameters);
      case _util.AnnotationType.STAMP:
        return new StampAnnotationElement(parameters);
      case _util.AnnotationType.FILEATTACHMENT:
        return new FileAttachmentAnnotationElement(parameters);
      default:
        return new AnnotationElement(parameters);
    }
  }
}
class AnnotationElement {
  #hasBorder = false;
  constructor(parameters) {
    let {
      isRenderable = false,
      ignoreBorder = false,
      createQuadrilaterals = false
    } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.isRenderable = isRenderable;
    this.data = parameters.data;
    this.layer = parameters.layer;
    this.linkService = parameters.linkService;
    this.downloadManager = parameters.downloadManager;
    this.imageResourcesPath = parameters.imageResourcesPath;
    this.renderForms = parameters.renderForms;
    this.svgFactory = parameters.svgFactory;
    this.annotationStorage = parameters.annotationStorage;
    this.enableScripting = parameters.enableScripting;
    this.hasJSActions = parameters.hasJSActions;
    this._fieldObjects = parameters.fieldObjects;
    this.parent = parameters.parent;
    if (isRenderable) {
      this.container = this._createContainer(ignoreBorder);
    }
    if (createQuadrilaterals) {
      this._createQuadrilaterals();
    }
  }
  static _hasPopupData(_ref) {
    let {
      titleObj,
      contentsObj,
      richText
    } = _ref;
    return !!(titleObj?.str || contentsObj?.str || richText?.str);
  }
  get hasPopupData() {
    return AnnotationElement._hasPopupData(this.data);
  }
  _createContainer(ignoreBorder) {
    const {
      data,
      parent: {
        page,
        viewport
      }
    } = this;
    const container = document.createElement("section");
    container.setAttribute("data-annotation-id", data.id);
    if (!(this instanceof WidgetAnnotationElement)) {
      container.tabIndex = DEFAULT_TAB_INDEX;
    }
    container.style.zIndex = this.parent.zIndex++;
    if (this.data.popupRef) {
      container.setAttribute("aria-haspopup", "dialog");
    }
    if (data.noRotate) {
      container.classList.add("norotate");
    }
    const {
      pageWidth,
      pageHeight,
      pageX,
      pageY
    } = viewport.rawDims;
    if (!data.rect || this instanceof PopupAnnotationElement) {
      const {
        rotation
      } = data;
      if (!data.hasOwnCanvas && rotation !== 0) {
        this.setRotation(rotation, container);
      }
      return container;
    }
    const {
      width,
      height
    } = getRectDims(data.rect);
    const rect = _util.Util.normalizeRect([data.rect[0], page.view[3] - data.rect[1] + page.view[1], data.rect[2], page.view[3] - data.rect[3] + page.view[1]]);
    if (!ignoreBorder && data.borderStyle.width > 0) {
      container.style.borderWidth = `${data.borderStyle.width}px`;
      const horizontalRadius = data.borderStyle.horizontalCornerRadius;
      const verticalRadius = data.borderStyle.verticalCornerRadius;
      if (horizontalRadius > 0 || verticalRadius > 0) {
        const radius = `calc(${horizontalRadius}px * var(--scale-factor)) / calc(${verticalRadius}px * var(--scale-factor))`;
        container.style.borderRadius = radius;
      } else if (this instanceof RadioButtonWidgetAnnotationElement) {
        const radius = `calc(${width}px * var(--scale-factor)) / calc(${height}px * var(--scale-factor))`;
        container.style.borderRadius = radius;
      }
      switch (data.borderStyle.style) {
        case _util.AnnotationBorderStyleType.SOLID:
          container.style.borderStyle = "solid";
          break;
        case _util.AnnotationBorderStyleType.DASHED:
          container.style.borderStyle = "dashed";
          break;
        case _util.AnnotationBorderStyleType.BEVELED:
          (0, _util.warn)("Unimplemented border style: beveled");
          break;
        case _util.AnnotationBorderStyleType.INSET:
          (0, _util.warn)("Unimplemented border style: inset");
          break;
        case _util.AnnotationBorderStyleType.UNDERLINE:
          container.style.borderBottomStyle = "solid";
          break;
        default:
          break;
      }
      const borderColor = data.borderColor || null;
      if (borderColor) {
        this.#hasBorder = true;
        container.style.borderColor = _util.Util.makeHexColor(borderColor[0] | 0, borderColor[1] | 0, borderColor[2] | 0);
      } else {
        container.style.borderWidth = 0;
      }
    }
    container.style.left = `${100 * (rect[0] - pageX) / pageWidth}%`;
    container.style.top = `${100 * (rect[1] - pageY) / pageHeight}%`;
    const {
      rotation
    } = data;
    if (data.hasOwnCanvas || rotation === 0) {
      container.style.width = `${100 * width / pageWidth}%`;
      container.style.height = `${100 * height / pageHeight}%`;
    } else {
      this.setRotation(rotation, container);
    }
    return container;
  }
  setRotation(angle) {
    let container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.container;
    if (!this.data.rect) {
      return;
    }
    const {
      pageWidth,
      pageHeight
    } = this.parent.viewport.rawDims;
    const {
      width,
      height
    } = getRectDims(this.data.rect);
    let elementWidth, elementHeight;
    if (angle % 180 === 0) {
      elementWidth = 100 * width / pageWidth;
      elementHeight = 100 * height / pageHeight;
    } else {
      elementWidth = 100 * height / pageWidth;
      elementHeight = 100 * width / pageHeight;
    }
    container.style.width = `${elementWidth}%`;
    container.style.height = `${elementHeight}%`;
    container.setAttribute("data-main-rotation", (360 - angle) % 360);
  }
  get _commonActions() {
    const setColor = (jsName, styleName, event) => {
      const color = event.detail[jsName];
      const colorType = color[0];
      const colorArray = color.slice(1);
      event.target.style[styleName] = _scripting_utils.ColorConverters[`${colorType}_HTML`](colorArray);
      this.annotationStorage.setValue(this.data.id, {
        [styleName]: _scripting_utils.ColorConverters[`${colorType}_rgb`](colorArray)
      });
    };
    return (0, _util.shadow)(this, "_commonActions", {
      display: event => {
        const {
          display
        } = event.detail;
        const hidden = display % 2 === 1;
        this.container.style.visibility = hidden ? "hidden" : "visible";
        this.annotationStorage.setValue(this.data.id, {
          noView: hidden,
          noPrint: display === 1 || display === 2
        });
      },
      print: event => {
        this.annotationStorage.setValue(this.data.id, {
          noPrint: !event.detail.print
        });
      },
      hidden: event => {
        const {
          hidden
        } = event.detail;
        this.container.style.visibility = hidden ? "hidden" : "visible";
        this.annotationStorage.setValue(this.data.id, {
          noPrint: hidden,
          noView: hidden
        });
      },
      focus: event => {
        setTimeout(() => event.target.focus({
          preventScroll: false
        }), 0);
      },
      userName: event => {
        event.target.title = event.detail.userName;
      },
      readonly: event => {
        event.target.disabled = event.detail.readonly;
      },
      required: event => {
        this._setRequired(event.target, event.detail.required);
      },
      bgColor: event => {
        setColor("bgColor", "backgroundColor", event);
      },
      fillColor: event => {
        setColor("fillColor", "backgroundColor", event);
      },
      fgColor: event => {
        setColor("fgColor", "color", event);
      },
      textColor: event => {
        setColor("textColor", "color", event);
      },
      borderColor: event => {
        setColor("borderColor", "borderColor", event);
      },
      strokeColor: event => {
        setColor("strokeColor", "borderColor", event);
      },
      rotation: event => {
        const angle = event.detail.rotation;
        this.setRotation(angle);
        this.annotationStorage.setValue(this.data.id, {
          rotation: angle
        });
      }
    });
  }
  _dispatchEventFromSandbox(actions, jsEvent) {
    const commonActions = this._commonActions;
    for (const name of Object.keys(jsEvent.detail)) {
      const action = actions[name] || commonActions[name];
      action?.(jsEvent);
    }
  }
  _setDefaultPropertiesFromJS(element) {
    if (!this.enableScripting) {
      return;
    }
    const storedData = this.annotationStorage.getRawValue(this.data.id);
    if (!storedData) {
      return;
    }
    const commonActions = this._commonActions;
    for (const [actionName, detail] of Object.entries(storedData)) {
      const action = commonActions[actionName];
      if (action) {
        const eventProxy = {
          detail: {
            [actionName]: detail
          },
          target: element
        };
        action(eventProxy);
        delete storedData[actionName];
      }
    }
  }
  _createQuadrilaterals() {
    if (!this.container) {
      return;
    }
    const {
      quadPoints
    } = this.data;
    if (!quadPoints) {
      return;
    }
    const [rectBlX, rectBlY, rectTrX, rectTrY] = this.data.rect;
    if (quadPoints.length === 1) {
      const [, {
        x: trX,
        y: trY
      }, {
        x: blX,
        y: blY
      }] = quadPoints[0];
      if (rectTrX === trX && rectTrY === trY && rectBlX === blX && rectBlY === blY) {
        return;
      }
    }
    const {
      style
    } = this.container;
    let svgBuffer;
    if (this.#hasBorder) {
      const {
        borderColor,
        borderWidth
      } = style;
      style.borderWidth = 0;
      svgBuffer = ["url('data:image/svg+xml;utf8,", `<svg xmlns="http://www.w3.org/2000/svg"`, ` preserveAspectRatio="none" viewBox="0 0 1 1">`, `<g fill="transparent" stroke="${borderColor}" stroke-width="${borderWidth}">`];
      this.container.classList.add("hasBorder");
    }
    const width = rectTrX - rectBlX;
    const height = rectTrY - rectBlY;
    const {
      svgFactory
    } = this;
    const svg = svgFactory.createElement("svg");
    svg.classList.add("quadrilateralsContainer");
    svg.setAttribute("width", 0);
    svg.setAttribute("height", 0);
    const defs = svgFactory.createElement("defs");
    svg.append(defs);
    const clipPath = svgFactory.createElement("clipPath");
    const id = `clippath_${this.data.id}`;
    clipPath.setAttribute("id", id);
    clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
    defs.append(clipPath);
    for (const [, {
      x: trX,
      y: trY
    }, {
      x: blX,
      y: blY
    }] of quadPoints) {
      const rect = svgFactory.createElement("rect");
      const x = (blX - rectBlX) / width;
      const y = (rectTrY - trY) / height;
      const rectWidth = (trX - blX) / width;
      const rectHeight = (trY - blY) / height;
      rect.setAttribute("x", x);
      rect.setAttribute("y", y);
      rect.setAttribute("width", rectWidth);
      rect.setAttribute("height", rectHeight);
      clipPath.append(rect);
      svgBuffer?.push(`<rect vector-effect="non-scaling-stroke" x="${x}" y="${y}" width="${rectWidth}" height="${rectHeight}"/>`);
    }
    if (this.#hasBorder) {
      svgBuffer.push(`</g></svg>')`);
      style.backgroundImage = svgBuffer.join("");
    }
    this.container.append(svg);
    this.container.style.clipPath = `url(#${id})`;
  }
  _createPopup() {
    const {
      container,
      data
    } = this;
    container.setAttribute("aria-haspopup", "dialog");
    const popup = new PopupAnnotationElement({
      data: {
        color: data.color,
        titleObj: data.titleObj,
        modificationDate: data.modificationDate,
        contentsObj: data.contentsObj,
        richText: data.richText,
        parentRect: data.rect,
        borderStyle: 0,
        id: `popup_${data.id}`,
        rotation: data.rotation
      },
      parent: this.parent,
      elements: [this]
    });
    this.parent.div.append(popup.render());
  }
  render() {
    (0, _util.unreachable)("Abstract method `AnnotationElement.render` called");
  }
  _getElementsByName(name) {
    let skipId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    const fields = [];
    if (this._fieldObjects) {
      const fieldObj = this._fieldObjects[name];
      if (fieldObj) {
        for (const {
          page,
          id,
          exportValues
        } of fieldObj) {
          if (page === -1) {
            continue;
          }
          if (id === skipId) {
            continue;
          }
          const exportValue = typeof exportValues === "string" ? exportValues : null;
          const domElement = document.querySelector(`[data-element-id="${id}"]`);
          if (domElement && !GetElementsByNameSet.has(domElement)) {
            (0, _util.warn)(`_getElementsByName - element not allowed: ${id}`);
            continue;
          }
          fields.push({
            id,
            exportValue,
            domElement
          });
        }
      }
      return fields;
    }
    for (const domElement of document.getElementsByName(name)) {
      const {
        exportValue
      } = domElement;
      const id = domElement.getAttribute("data-element-id");
      if (id === skipId) {
        continue;
      }
      if (!GetElementsByNameSet.has(domElement)) {
        continue;
      }
      fields.push({
        id,
        exportValue,
        domElement
      });
    }
    return fields;
  }
  show() {
    if (this.container) {
      this.container.hidden = false;
    }
    this.popup?.maybeShow();
  }
  hide() {
    if (this.container) {
      this.container.hidden = true;
    }
    this.popup?.forceHide();
  }
  getElementsToTriggerPopup() {
    return this.container;
  }
  addHighlightArea() {
    const triggers = this.getElementsToTriggerPopup();
    if (Array.isArray(triggers)) {
      for (const element of triggers) {
        element.classList.add("highlightArea");
      }
    } else {
      triggers.classList.add("highlightArea");
    }
  }
  _editOnDoubleClick() {
    const {
      annotationEditorType: mode,
      data: {
        id: editId
      }
    } = this;
    this.container.addEventListener("dblclick", () => {
      this.linkService.eventBus?.dispatch("switchannotationeditormode", {
        source: this,
        mode,
        editId
      });
    });
  }
}
class LinkAnnotationElement extends AnnotationElement {
  constructor(parameters) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    super(parameters, {
      isRenderable: true,
      ignoreBorder: !!options?.ignoreBorder,
      createQuadrilaterals: true
    });
    this.isTooltipOnly = parameters.data.isTooltipOnly;
  }
  render() {
    const {
      data,
      linkService
    } = this;
    const link = document.createElement("a");
    link.setAttribute("data-element-id", data.id);
    let isBound = false;
    if (data.url) {
      linkService.addLinkAttributes(link, data.url, data.newWindow);
      isBound = true;
    } else if (data.action) {
      this._bindNamedAction(link, data.action);
      isBound = true;
    } else if (data.attachment) {
      this._bindAttachment(link, data.attachment);
      isBound = true;
    } else if (data.setOCGState) {
      this.#bindSetOCGState(link, data.setOCGState);
      isBound = true;
    } else if (data.dest) {
      this._bindLink(link, data.dest);
      isBound = true;
    } else {
      if (data.actions && (data.actions.Action || data.actions["Mouse Up"] || data.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions) {
        this._bindJSAction(link, data);
        isBound = true;
      }
      if (data.resetForm) {
        this._bindResetFormAction(link, data.resetForm);
        isBound = true;
      } else if (this.isTooltipOnly && !isBound) {
        this._bindLink(link, "");
        isBound = true;
      }
    }
    this.container.classList.add("linkAnnotation");
    if (isBound) {
      this.container.append(link);
    }
    return this.container;
  }
  #setInternalLink() {
    this.container.setAttribute("data-internal-link", "");
  }
  _bindLink(link, destination) {
    link.href = this.linkService.getDestinationHash(destination);
    link.onclick = () => {
      if (destination) {
        this.linkService.goToDestination(destination);
      }
      return false;
    };
    if (destination || destination === "") {
      this.#setInternalLink();
    }
  }
  _bindNamedAction(link, action) {
    link.href = this.linkService.getAnchorUrl("");
    link.onclick = () => {
      this.linkService.executeNamedAction(action);
      return false;
    };
    this.#setInternalLink();
  }
  _bindAttachment(link, attachment) {
    link.href = this.linkService.getAnchorUrl("");
    link.onclick = () => {
      this.downloadManager?.openOrDownloadData(this.container, attachment.content, attachment.filename);
      return false;
    };
    this.#setInternalLink();
  }
  #bindSetOCGState(link, action) {
    link.href = this.linkService.getAnchorUrl("");
    link.onclick = () => {
      this.linkService.executeSetOCGState(action);
      return false;
    };
    this.#setInternalLink();
  }
  _bindJSAction(link, data) {
    link.href = this.linkService.getAnchorUrl("");
    const map = new Map([["Action", "onclick"], ["Mouse Up", "onmouseup"], ["Mouse Down", "onmousedown"]]);
    for (const name of Object.keys(data.actions)) {
      const jsName = map.get(name);
      if (!jsName) {
        continue;
      }
      link[jsName] = () => {
        this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
          source: this,
          detail: {
            id: data.id,
            name
          }
        });
        return false;
      };
    }
    if (!link.onclick) {
      link.onclick = () => false;
    }
    this.#setInternalLink();
  }
  _bindResetFormAction(link, resetForm) {
    const otherClickAction = link.onclick;
    if (!otherClickAction) {
      link.href = this.linkService.getAnchorUrl("");
    }
    this.#setInternalLink();
    if (!this._fieldObjects) {
      (0, _util.warn)(`_bindResetFormAction - "resetForm" action not supported, ` + "ensure that the `fieldObjects` parameter is provided.");
      if (!otherClickAction) {
        link.onclick = () => false;
      }
      return;
    }
    link.onclick = () => {
      otherClickAction?.();
      const {
        fields: resetFormFields,
        refs: resetFormRefs,
        include
      } = resetForm;
      const allFields = [];
      if (resetFormFields.length !== 0 || resetFormRefs.length !== 0) {
        const fieldIds = new Set(resetFormRefs);
        for (const fieldName of resetFormFields) {
          const fields = this._fieldObjects[fieldName] || [];
          for (const {
            id
          } of fields) {
            fieldIds.add(id);
          }
        }
        for (const fields of Object.values(this._fieldObjects)) {
          for (const field of fields) {
            if (fieldIds.has(field.id) === include) {
              allFields.push(field);
            }
          }
        }
      } else {
        for (const fields of Object.values(this._fieldObjects)) {
          allFields.push(...fields);
        }
      }
      const storage = this.annotationStorage;
      const allIds = [];
      for (const field of allFields) {
        const {
          id
        } = field;
        allIds.push(id);
        switch (field.type) {
          case "text":
            {
              const value = field.defaultValue || "";
              storage.setValue(id, {
                value
              });
              break;
            }
          case "checkbox":
          case "radiobutton":
            {
              const value = field.defaultValue === field.exportValues;
              storage.setValue(id, {
                value
              });
              break;
            }
          case "combobox":
          case "listbox":
            {
              const value = field.defaultValue || "";
              storage.setValue(id, {
                value
              });
              break;
            }
          default:
            continue;
        }
        const domElement = document.querySelector(`[data-element-id="${id}"]`);
        if (!domElement) {
          continue;
        } else if (!GetElementsByNameSet.has(domElement)) {
          (0, _util.warn)(`_bindResetFormAction - element not allowed: ${id}`);
          continue;
        }
        domElement.dispatchEvent(new Event("resetform"));
      }
      if (this.enableScripting) {
        this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
          source: this,
          detail: {
            id: "app",
            ids: allIds,
            name: "ResetForm"
          }
        });
      }
      return false;
    };
  }
}
class TextAnnotationElement extends AnnotationElement {
  constructor(parameters) {
    super(parameters, {
      isRenderable: true
    });
  }
  render() {
    this.container.classList.add("textAnnotation");
    const image = document.createElement("img");
    image.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
    image.alt = "[{{type}} Annotation]";
    image.dataset.l10nId = "text_annotation_type";
    image.dataset.l10nArgs = JSON.stringify({
      type: this.data.name
    });
    if (!this.data.popupRef && this.hasPopupData) {
      this._createPopup();
    }
    this.container.append(image);
    return this.container;
  }
}
class WidgetAnnotationElement extends AnnotationElement {
  render() {
    if (this.data.alternativeText) {
      this.container.title = this.data.alternativeText;
    }
    return this.container;
  }
  showElementAndHideCanvas(element) {
    if (this.data.hasOwnCanvas) {
      if (element.previousSibling?.nodeName === "CANVAS") {
        element.previousSibling.hidden = true;
      }
      element.hidden = false;
    }
  }
  _getKeyModifier(event) {
    const {
      isWin,
      isMac
    } = _util.FeatureTest.platform;
    return isWin && event.ctrlKey || isMac && event.metaKey;
  }
  _setEventListener(element, elementData, baseName, eventName, valueGetter) {
    if (baseName.includes("mouse")) {
      element.addEventListener(baseName, event => {
        this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
          source: this,
          detail: {
            id: this.data.id,
            name: eventName,
            value: valueGetter(event),
            shift: event.shiftKey,
            modifier: this._getKeyModifier(event)
          }
        });
      });
    } else {
      element.addEventListener(baseName, event => {
        if (baseName === "blur") {
          if (!elementData.focused || !event.relatedTarget) {
            return;
          }
          elementData.focused = false;
        } else if (baseName === "focus") {
          if (elementData.focused) {
            return;
          }
          elementData.focused = true;
        }
        if (!valueGetter) {
          return;
        }
        this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
          source: this,
          detail: {
            id: this.data.id,
            name: eventName,
            value: valueGetter(event)
          }
        });
      });
    }
  }
  _setEventListeners(element, elementData, names, getter) {
    for (const [baseName, eventName] of names) {
      if (eventName === "Action" || this.data.actions?.[eventName]) {
        if (eventName === "Focus" || eventName === "Blur") {
          elementData ||= {
            focused: false
          };
        }
        this._setEventListener(element, elementData, baseName, eventName, getter);
        if (eventName === "Focus" && !this.data.actions?.Blur) {
          this._setEventListener(element, elementData, "blur", "Blur", null);
        } else if (eventName === "Blur" && !this.data.actions?.Focus) {
          this._setEventListener(element, elementData, "focus", "Focus", null);
        }
      }
    }
  }
  _setBackgroundColor(element) {
    const color = this.data.backgroundColor || null;
    element.style.backgroundColor = color === null ? "transparent" : _util.Util.makeHexColor(color[0], color[1], color[2]);
  }
  _setTextStyle(element) {
    const TEXT_ALIGNMENT = ["left", "center", "right"];
    const {
      fontColor
    } = this.data.defaultAppearanceData;
    const fontSize = this.data.defaultAppearanceData.fontSize || DEFAULT_FONT_SIZE;
    const style = element.style;
    let computedFontSize;
    const BORDER_SIZE = 2;
    const roundToOneDecimal = x => Math.round(10 * x) / 10;
    if (this.data.multiLine) {
      const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
      const numberOfLines = Math.round(height / (_util.LINE_FACTOR * fontSize)) || 1;
      const lineHeight = height / numberOfLines;
      computedFontSize = Math.min(fontSize, roundToOneDecimal(lineHeight / _util.LINE_FACTOR));
    } else {
      const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
      computedFontSize = Math.min(fontSize, roundToOneDecimal(height / _util.LINE_FACTOR));
    }
    style.fontSize = `calc(${computedFontSize}px * var(--scale-factor))`;
    style.color = _util.Util.makeHexColor(fontColor[0], fontColor[1], fontColor[2]);
    if (this.data.textAlignment !== null) {
      style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
    }
  }
  _setRequired(element, isRequired) {
    if (isRequired) {
      element.setAttribute("required", true);
    } else {
      element.removeAttribute("required");
    }
    element.setAttribute("aria-required", isRequired);
  }
}
class TextWidgetAnnotationElement extends WidgetAnnotationElement {
  constructor(parameters) {
    const isRenderable = parameters.renderForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
    super(parameters, {
      isRenderable
    });
  }
  setPropertyOnSiblings(base, key, value, keyInStorage) {
    const storage = this.annotationStorage;
    for (const element of this._getElementsByName(base.name, base.id)) {
      if (element.domElement) {
        element.domElement[key] = value;
      }
      storage.setValue(element.id, {
        [keyInStorage]: value
      });
    }
  }
  render() {
    const storage = this.annotationStorage;
    const id = this.data.id;
    this.container.classList.add("textWidgetAnnotation");
    let element = null;
    if (this.renderForms) {
      const storedData = storage.getValue(id, {
        value: this.data.fieldValue
      });
      let textContent = storedData.value || "";
      const maxLen = storage.getValue(id, {
        charLimit: this.data.maxLen
      }).charLimit;
      if (maxLen && textContent.length > maxLen) {
        textContent = textContent.slice(0, maxLen);
      }
      let fieldFormattedValues = storedData.formattedValue || this.data.textContent?.join("\n") || null;
      if (fieldFormattedValues && this.data.comb) {
        fieldFormattedValues = fieldFormattedValues.replaceAll(/\s+/g, "");
      }
      const elementData = {
        userValue: textContent,
        formattedValue: fieldFormattedValues,
        lastCommittedValue: null,
        commitKey: 1,
        focused: false
      };
      if (this.data.multiLine) {
        element = document.createElement("textarea");
        element.textContent = fieldFormattedValues ?? textContent;
        if (this.data.doNotScroll) {
          element.style.overflowY = "hidden";
        }
      } else {
        element = document.createElement("input");
        element.type = "text";
        element.setAttribute("value", fieldFormattedValues ?? textContent);
        if (this.data.doNotScroll) {
          element.style.overflowX = "hidden";
        }
      }
      if (this.data.hasOwnCanvas) {
        element.hidden = true;
      }
      GetElementsByNameSet.add(element);
      element.setAttribute("data-element-id", id);
      element.disabled = this.data.readOnly;
      element.name = this.data.fieldName;
      element.tabIndex = DEFAULT_TAB_INDEX;
      this._setRequired(element, this.data.required);
      if (maxLen) {
        element.maxLength = maxLen;
      }
      element.addEventListener("input", event => {
        storage.setValue(id, {
          value: event.target.value
        });
        this.setPropertyOnSiblings(element, "value", event.target.value, "value");
        elementData.formattedValue = null;
      });
      element.addEventListener("resetform", event => {
        const defaultValue = this.data.defaultFieldValue ?? "";
        element.value = elementData.userValue = defaultValue;
        elementData.formattedValue = null;
      });
      let blurListener = event => {
        const {
          formattedValue
        } = elementData;
        if (formattedValue !== null && formattedValue !== undefined) {
          event.target.value = formattedValue;
        }
        event.target.scrollLeft = 0;
      };
      if (this.enableScripting && this.hasJSActions) {
        element.addEventListener("focus", event => {
          if (elementData.focused) {
            return;
          }
          const {
            target
          } = event;
          if (elementData.userValue) {
            target.value = elementData.userValue;
          }
          elementData.lastCommittedValue = target.value;
          elementData.commitKey = 1;
          elementData.focused = true;
        });
        element.addEventListener("updatefromsandbox", jsEvent => {
          this.showElementAndHideCanvas(jsEvent.target);
          const actions = {
            value(event) {
              elementData.userValue = event.detail.value ?? "";
              storage.setValue(id, {
                value: elementData.userValue.toString()
              });
              event.target.value = elementData.userValue;
            },
            formattedValue(event) {
              const {
                formattedValue
              } = event.detail;
              elementData.formattedValue = formattedValue;
              if (formattedValue !== null && formattedValue !== undefined && event.target !== document.activeElement) {
                event.target.value = formattedValue;
              }
              storage.setValue(id, {
                formattedValue
              });
            },
            selRange(event) {
              event.target.setSelectionRange(...event.detail.selRange);
            },
            charLimit: event => {
              const {
                charLimit
              } = event.detail;
              const {
                target
              } = event;
              if (charLimit === 0) {
                target.removeAttribute("maxLength");
                return;
              }
              target.setAttribute("maxLength", charLimit);
              let value = elementData.userValue;
              if (!value || value.length <= charLimit) {
                return;
              }
              value = value.slice(0, charLimit);
              target.value = elementData.userValue = value;
              storage.setValue(id, {
                value
              });
              this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
                source: this,
                detail: {
                  id,
                  name: "Keystroke",
                  value,
                  willCommit: true,
                  commitKey: 1,
                  selStart: target.selectionStart,
                  selEnd: target.selectionEnd
                }
              });
            }
          };
          this._dispatchEventFromSandbox(actions, jsEvent);
        });
        element.addEventListener("keydown", event => {
          elementData.commitKey = 1;
          let commitKey = -1;
          if (event.key === "Escape") {
            commitKey = 0;
          } else if (event.key === "Enter" && !this.data.multiLine) {
            commitKey = 2;
          } else if (event.key === "Tab") {
            elementData.commitKey = 3;
          }
          if (commitKey === -1) {
            return;
          }
          const {
            value
          } = event.target;
          if (elementData.lastCommittedValue === value) {
            return;
          }
          elementData.lastCommittedValue = value;
          elementData.userValue = value;
          this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
            source: this,
            detail: {
              id,
              name: "Keystroke",
              value,
              willCommit: true,
              commitKey,
              selStart: event.target.selectionStart,
              selEnd: event.target.selectionEnd
            }
          });
        });
        const _blurListener = blurListener;
        blurListener = null;
        element.addEventListener("blur", event => {
          if (!elementData.focused || !event.relatedTarget) {
            return;
          }
          elementData.focused = false;
          const {
            value
          } = event.target;
          elementData.userValue = value;
          if (elementData.lastCommittedValue !== value) {
            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
              source: this,
              detail: {
                id,
                name: "Keystroke",
                value,
                willCommit: true,
                commitKey: elementData.commitKey,
                selStart: event.target.selectionStart,
                selEnd: event.target.selectionEnd
              }
            });
          }
          _blurListener(event);
        });
        if (this.data.actions?.Keystroke) {
          element.addEventListener("beforeinput", event => {
            elementData.lastCommittedValue = null;
            const {
              data,
              target
            } = event;
            const {
              value,
              selectionStart,
              selectionEnd
            } = target;
            let selStart = selectionStart,
              selEnd = selectionEnd;
            switch (event.inputType) {
              case "deleteWordBackward":
                {
                  const match = value.substring(0, selectionStart).match(/\w*[^\w]*$/);
                  if (match) {
                    selStart -= match[0].length;
                  }
                  break;
                }
              case "deleteWordForward":
                {
                  const match = value.substring(selectionStart).match(/^[^\w]*\w*/);
                  if (match) {
                    selEnd += match[0].length;
                  }
                  break;
                }
              case "deleteContentBackward":
                if (selectionStart === selectionEnd) {
                  selStart -= 1;
                }
                break;
              case "deleteContentForward":
                if (selectionStart === selectionEnd) {
                  selEnd += 1;
                }
                break;
            }
            event.preventDefault();
            this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
              source: this,
              detail: {
                id,
                name: "Keystroke",
                value,
                change: data || "",
                willCommit: false,
                selStart,
                selEnd
              }
            });
          });
        }
        this._setEventListeners(element, elementData, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], event => event.target.value);
      }
      if (blurListener) {
        element.addEventListener("blur", blurListener);
      }
      if (this.data.comb) {
        const fieldWidth = this.data.rect[2] - this.data.rect[0];
        const combWidth = fieldWidth / maxLen;
        element.classList.add("comb");
        element.style.letterSpacing = `calc(${combWidth}px * var(--scale-factor) - 1ch)`;
      }
    } else {
      element = document.createElement("div");
      element.textContent = this.data.fieldValue;
      element.style.verticalAlign = "middle";
      element.style.display = "table-cell";
    }
    this._setTextStyle(element);
    this._setBackgroundColor(element);
    this._setDefaultPropertiesFromJS(element);
    this.container.append(element);
    return this.container;
  }
}
class SignatureWidgetAnnotationElement extends WidgetAnnotationElement {
  constructor(parameters) {
    super(parameters, {
      isRenderable: !!parameters.data.hasOwnCanvas
    });
  }
}
class CheckboxWidgetAnnotationElement extends WidgetAnnotationElement {
  constructor(parameters) {
    super(parameters, {
      isRenderable: parameters.renderForms
    });
  }
  render() {
    const storage = this.annotationStorage;
    const data = this.data;
    const id = data.id;
    let value = storage.getValue(id, {
      value: data.exportValue === data.fieldValue
    }).value;
    if (typeof value === "string") {
      value = value !== "Off";
      storage.setValue(id, {
        value
      });
    }
    this.container.classList.add("buttonWidgetAnnotation", "checkBox");
    const element = document.createElement("input");
    GetElementsByNameSet.add(element);
    element.setAttribute("data-element-id", id);
    element.disabled = data.readOnly;
    this._setRequired(element, this.data.required);
    element.type = "checkbox";
    element.name = data.fieldName;
    if (value) {
      element.setAttribute("checked", true);
    }
    element.setAttribute("exportValue", data.exportValue);
    element.tabIndex = DEFAULT_TAB_INDEX;
    element.addEventListener("change", event => {
      const {
        name,
        checked
      } = event.target;
      for (const checkbox of this._getElementsByName(name, id)) {
        const curChecked = checked && checkbox.exportValue === data.exportValue;
        if (checkbox.domElement) {
          checkbox.domElement.checked = curChecked;
        }
        storage.setValue(checkbox.id, {
          value: curChecked
        });
      }
      storage.setValue(id, {
        value: checked
      });
    });
    element.addEventListener("resetform", event => {
      const defaultValue = data.defaultFieldValue || "Off";
      event.target.checked = defaultValue === data.exportValue;
    });
    if (this.enableScripting && this.hasJSActions) {
      element.addEventListener("updatefromsandbox", jsEvent => {
        const actions = {
          value(event) {
            event.target.checked = event.detail.value !== "Off";
            storage.setValue(id, {
              value: event.target.checked
            });
          }
        };
        this._dispatchEventFromSandbox(actions, jsEvent);
      });
      this._setEventListeners(element, null, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], event => event.target.checked);
    }
    this._setBackgroundColor(element);
    this._setDefaultPropertiesFromJS(element);
    this.container.append(element);
    return this.container;
  }
}
class RadioButtonWidgetAnnotationElement extends WidgetAnnotationElement {
  constructor(parameters) {
    super(parameters, {
      isRenderable: parameters.renderForms
    });
  }
  render() {
    this.container.classList.add("buttonWidgetAnnotation", "radioButton");
    const storage = this.annotationStorage;
    const data = this.data;
    const id = data.id;
    let value = storage.getValue(id, {
      value: data.fieldValue === data.buttonValue
    }).value;
    if (typeof value === "string") {
      value = value !== data.buttonValue;
      storage.setValue(id, {
        value
      });
    }
    const element = document.createElement("input");
    GetElementsByNameSet.add(element);
    element.setAttribute("data-element-id", id);
    element.disabled = data.readOnly;
    this._setRequired(element, this.data.required);
    element.type = "radio";
    element.name = data.fieldName;
    if (value) {
      element.setAttribute("checked", true);
    }
    element.tabIndex = DEFAULT_TAB_INDEX;
    element.addEventListener("change", event => {
      const {
        name,
        checked
      } = event.target;
      for (const radio of this._getElementsByName(name, id)) {
        storage.setValue(radio.id, {
          value: false
        });
      }
      storage.setValue(id, {
        value: checked
      });
    });
    element.addEventListener("resetform", event => {
      const defaultValue = data.defaultFieldValue;
      event.target.checked = defaultValue !== null && defaultValue !== undefined && defaultValue === data.buttonValue;
    });
    if (this.enableScripting && this.hasJSActions) {
      const pdfButtonValue = data.buttonValue;
      element.addEventListener("updatefromsandbox", jsEvent => {
        const actions = {
          value: event => {
            const checked = pdfButtonValue === event.detail.value;
            for (const radio of this._getElementsByName(event.target.name)) {
              const curChecked = checked && radio.id === id;
              if (radio.domElement) {
                radio.domElement.checked = curChecked;
              }
              storage.setValue(radio.id, {
                value: curChecked
              });
            }
          }
        };
        this._dispatchEventFromSandbox(actions, jsEvent);
      });
      this._setEventListeners(element, null, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], event => event.target.checked);
    }
    this._setBackgroundColor(element);
    this._setDefaultPropertiesFromJS(element);
    this.container.append(element);
    return this.container;
  }
}
class PushButtonWidgetAnnotationElement extends LinkAnnotationElement {
  constructor(parameters) {
    super(parameters, {
      ignoreBorder: parameters.data.hasAppearance
    });
  }
  render() {
    const container = super.render();
    container.classList.add("buttonWidgetAnnotation", "pushButton");
    if (this.data.alternativeText) {
      container.title = this.data.alternativeText;
    }
    const linkElement = container.lastChild;
    if (this.enableScripting && this.hasJSActions && linkElement) {
      this._setDefaultPropertiesFromJS(linkElement);
      linkElement.addEventListener("updatefromsandbox", jsEvent => {
        this._dispatchEventFromSandbox({}, jsEvent);
      });
    }
    return container;
  }
}
class ChoiceWidgetAnnotationElement extends WidgetAnnotationElement {
  constructor(parameters) {
    super(parameters, {
      isRenderable: parameters.renderForms
    });
  }
  render() {
    this.container.classList.add("choiceWidgetAnnotation");
    const storage = this.annotationStorage;
    const id = this.data.id;
    const storedData = storage.getValue(id, {
      value: this.data.fieldValue
    });
    const selectElement = document.createElement("select");
    GetElementsByNameSet.add(selectElement);
    selectElement.setAttribute("data-element-id", id);
    selectElement.disabled = this.data.readOnly;
    this._setRequired(selectElement, this.data.required);
    selectElement.name = this.data.fieldName;
    selectElement.tabIndex = DEFAULT_TAB_INDEX;
    let addAnEmptyEntry = this.data.combo && this.data.options.length > 0;
    if (!this.data.combo) {
      selectElement.size = this.data.options.length;
      if (this.data.multiSelect) {
        selectElement.multiple = true;
      }
    }
    selectElement.addEventListener("resetform", event => {
      const defaultValue = this.data.defaultFieldValue;
      for (const option of selectElement.options) {
        option.selected = option.value === defaultValue;
      }
    });
    for (const option of this.data.options) {
      const optionElement = document.createElement("option");
      optionElement.textContent = option.displayValue;
      optionElement.value = option.exportValue;
      if (storedData.value.includes(option.exportValue)) {
        optionElement.setAttribute("selected", true);
        addAnEmptyEntry = false;
      }
      selectElement.append(optionElement);
    }
    let removeEmptyEntry = null;
    if (addAnEmptyEntry) {
      const noneOptionElement = document.createElement("option");
      noneOptionElement.value = " ";
      noneOptionElement.setAttribute("hidden", true);
      noneOptionElement.setAttribute("selected", true);
      selectElement.prepend(noneOptionElement);
      removeEmptyEntry = () => {
        noneOptionElement.remove();
        selectElement.removeEventListener("input", removeEmptyEntry);
        removeEmptyEntry = null;
      };
      selectElement.addEventListener("input", removeEmptyEntry);
    }
    const getValue = isExport => {
      const name = isExport ? "value" : "textContent";
      const {
        options,
        multiple
      } = selectElement;
      if (!multiple) {
        return options.selectedIndex === -1 ? null : options[options.selectedIndex][name];
      }
      return Array.prototype.filter.call(options, option => option.selected).map(option => option[name]);
    };
    let selectedValues = getValue(false);
    const getItems = event => {
      const options = event.target.options;
      return Array.prototype.map.call(options, option => {
        return {
          displayValue: option.textContent,
          exportValue: option.value
        };
      });
    };
    if (this.enableScripting && this.hasJSActions) {
      selectElement.addEventListener("updatefromsandbox", jsEvent => {
        const actions = {
          value(event) {
            removeEmptyEntry?.();
            const value = event.detail.value;
            const values = new Set(Array.isArray(value) ? value : [value]);
            for (const option of selectElement.options) {
              option.selected = values.has(option.value);
            }
            storage.setValue(id, {
              value: getValue(true)
            });
            selectedValues = getValue(false);
          },
          multipleSelection(event) {
            selectElement.multiple = true;
          },
          remove(event) {
            const options = selectElement.options;
            const index = event.detail.remove;
            options[index].selected = false;
            selectElement.remove(index);
            if (options.length > 0) {
              const i = Array.prototype.findIndex.call(options, option => option.selected);
              if (i === -1) {
                options[0].selected = true;
              }
            }
            storage.setValue(id, {
              value: getValue(true),
              items: getItems(event)
            });
            selectedValues = getValue(false);
          },
          clear(event) {
            while (selectElement.length !== 0) {
              selectElement.remove(0);
            }
            storage.setValue(id, {
              value: null,
              items: []
            });
            selectedValues = getValue(false);
          },
          insert(event) {
            const {
              index,
              displayValue,
              exportValue
            } = event.detail.insert;
            const selectChild = selectElement.children[index];
            const optionElement = document.createElement("option");
            optionElement.textContent = displayValue;
            optionElement.value = exportValue;
            if (selectChild) {
              selectChild.before(optionElement);
            } else {
              selectElement.append(optionElement);
            }
            storage.setValue(id, {
              value: getValue(true),
              items: getItems(event)
            });
            selectedValues = getValue(false);
          },
          items(event) {
            const {
              items
            } = event.detail;
            while (selectElement.length !== 0) {
              selectElement.remove(0);
            }
            for (const item of items) {
              const {
                displayValue,
                exportValue
              } = item;
              const optionElement = document.createElement("option");
              optionElement.textContent = displayValue;
              optionElement.value = exportValue;
              selectElement.append(optionElement);
            }
            if (selectElement.options.length > 0) {
              selectElement.options[0].selected = true;
            }
            storage.setValue(id, {
              value: getValue(true),
              items: getItems(event)
            });
            selectedValues = getValue(false);
          },
          indices(event) {
            const indices = new Set(event.detail.indices);
            for (const option of event.target.options) {
              option.selected = indices.has(option.index);
            }
            storage.setValue(id, {
              value: getValue(true)
            });
            selectedValues = getValue(false);
          },
          editable(event) {
            event.target.disabled = !event.detail.editable;
          }
        };
        this._dispatchEventFromSandbox(actions, jsEvent);
      });
      selectElement.addEventListener("input", event => {
        const exportValue = getValue(true);
        storage.setValue(id, {
          value: exportValue
        });
        event.preventDefault();
        this.linkService.eventBus?.dispatch("dispatcheventinsandbox", {
          source: this,
          detail: {
            id,
            name: "Keystroke",
            value: selectedValues,
            changeEx: exportValue,
            willCommit: false,
            commitKey: 1,
            keyDown: false
          }
        });
      });
      this._setEventListeners(selectElement, null, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"], ["input", "Action"], ["input", "Validate"]], event => event.target.value);
    } else {
      selectElement.addEventListener("input", function (event) {
        storage.setValue(id, {
          value: getValue(true)
        });
      });
    }
    if (this.data.combo) {
      this._setTextStyle(selectElement);
    } else {}
    this._setBackgroundColor(selectElement);
    this._setDefaultPropertiesFromJS(selectElement);
    this.container.append(selectElement);
    return this.container;
  }
}
class PopupAnnotationElement extends AnnotationElement {
  constructor(parameters) {
    const {
      data,
      elements
    } = parameters;
    super(parameters, {
      isRenderable: AnnotationElement._hasPopupData(data)
    });
    this.elements = elements;
  }
  render() {
    this.container.classList.add("popupAnnotation");
    const popup = new PopupElement({
      container: this.container,
      color: this.data.color,
      titleObj: this.data.titleObj,
      modificationDate: this.data.modificationDate,
      contentsObj: this.data.contentsObj,
      richText: this.data.richText,
      rect: this.data.rect,
      parentRect: this.data.parentRect || null,
      parent: this.parent,
      elements: this.elements,
      open: this.data.open
    });
    const elementIds = [];
    for (const element of this.elements) {
      element.popup = popup;
      elementIds.push(element.data.id);
      element.addHighlightArea();
    }
    this.container.setAttribute("aria-controls", elementIds.map(id => `${_util.AnnotationPrefix}${id}`).join(","));
    return this.container;
  }
}
class PopupElement {
  #dateTimePromise = null;
  #boundKeyDown = this.#keyDown.bind(this);
  #boundHide = this.#hide.bind(this);
  #boundShow = this.#show.bind(this);
  #boundToggle = this.#toggle.bind(this);
  #color = null;
  #container = null;
  #contentsObj = null;
  #elements = null;
  #parent = null;
  #parentRect = null;
  #pinned = false;
  #popup = null;
  #rect = null;
  #richText = null;
  #titleObj = null;
  #wasVisible = false;
  constructor(_ref2) {
    let {
      container,
      color,
      elements,
      titleObj,
      modificationDate,
      contentsObj,
      richText,
      parent,
      rect,
      parentRect,
      open
    } = _ref2;
    this.#container = container;
    this.#titleObj = titleObj;
    this.#contentsObj = contentsObj;
    this.#richText = richText;
    this.#parent = parent;
    this.#color = color;
    this.#rect = rect;
    this.#parentRect = parentRect;
    this.#elements = elements;
    const dateObject = _display_utils.PDFDateString.toDateObject(modificationDate);
    if (dateObject) {
      this.#dateTimePromise = parent.l10n.get("annotation_date_string", {
        date: dateObject.toLocaleDateString(),
        time: dateObject.toLocaleTimeString()
      });
    }
    this.trigger = elements.flatMap(e => e.getElementsToTriggerPopup());
    for (const element of this.trigger) {
      element.addEventListener("click", this.#boundToggle);
      element.addEventListener("mouseenter", this.#boundShow);
      element.addEventListener("mouseleave", this.#boundHide);
      element.classList.add("popupTriggerArea");
    }
    for (const element of elements) {
      element.container?.addEventListener("keydown", this.#boundKeyDown);
    }
    this.#container.hidden = true;
    if (open) {
      this.#toggle();
    }
  }
  render() {
    if (this.#popup) {
      return;
    }
    const {
      page: {
        view
      },
      viewport: {
        rawDims: {
          pageWidth,
          pageHeight,
          pageX,
          pageY
        }
      }
    } = this.#parent;
    const popup = this.#popup = document.createElement("div");
    popup.className = "popup";
    if (this.#color) {
      const baseColor = popup.style.outlineColor = _util.Util.makeHexColor(...this.#color);
      if (CSS.supports("background-color", "color-mix(in srgb, red 30%, white)")) {
        popup.style.backgroundColor = `color-mix(in srgb, ${baseColor} 30%, white)`;
      } else {
        const BACKGROUND_ENLIGHT = 0.7;
        popup.style.backgroundColor = _util.Util.makeHexColor(...this.#color.map(c => Math.floor(BACKGROUND_ENLIGHT * (255 - c) + c)));
      }
    }
    const header = document.createElement("span");
    header.className = "header";
    const title = document.createElement("h1");
    header.append(title);
    ({
      dir: title.dir,
      str: title.textContent
    } = this.#titleObj);
    popup.append(header);
    if (this.#dateTimePromise) {
      const modificationDate = document.createElement("span");
      modificationDate.classList.add("popupDate");
      this.#dateTimePromise.then(localized => {
        modificationDate.textContent = localized;
      });
      header.append(modificationDate);
    }
    const contentsObj = this.#contentsObj;
    const richText = this.#richText;
    if (richText?.str && (!contentsObj?.str || contentsObj.str === richText.str)) {
      _xfa_layer.XfaLayer.render({
        xfaHtml: richText.html,
        intent: "richText",
        div: popup
      });
      popup.lastChild.classList.add("richText", "popupContent");
    } else {
      const contents = this._formatContents(contentsObj);
      popup.append(contents);
    }
    let useParentRect = !!this.#parentRect;
    let rect = useParentRect ? this.#parentRect : this.#rect;
    for (const element of this.#elements) {
      if (!rect || _util.Util.intersect(element.data.rect, rect) !== null) {
        rect = element.data.rect;
        useParentRect = true;
        break;
      }
    }
    const normalizedRect = _util.Util.normalizeRect([rect[0], view[3] - rect[1] + view[1], rect[2], view[3] - rect[3] + view[1]]);
    const HORIZONTAL_SPACE_AFTER_ANNOTATION = 5;
    const parentWidth = useParentRect ? rect[2] - rect[0] + HORIZONTAL_SPACE_AFTER_ANNOTATION : 0;
    const popupLeft = normalizedRect[0] + parentWidth;
    const popupTop = normalizedRect[1];
    const {
      style
    } = this.#container;
    style.left = `${100 * (popupLeft - pageX) / pageWidth}%`;
    style.top = `${100 * (popupTop - pageY) / pageHeight}%`;
    this.#container.append(popup);
  }
  _formatContents(_ref3) {
    let {
      str,
      dir
    } = _ref3;
    const p = document.createElement("p");
    p.classList.add("popupContent");
    p.dir = dir;
    const lines = str.split(/(?:\r\n?|\n)/);
    for (let i = 0, ii = lines.length; i < ii; ++i) {
      const line = lines[i];
      p.append(document.createTextNode(line));
      if (i < ii - 1) {
        p.append(document.createElement("br"));
      }
    }
    return p;
  }
  #keyDown(event) {
    if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) {
      return;
    }
    if (event.key === "Enter" || event.key === "Escape" && this.#pinned) {
      this.#toggle();
    }
  }
  #toggle() {
    this.#pinned = !this.#pinned;
    if (this.#pinned) {
      this.#show();
      this.#container.addEventListener("click", this.#boundToggle);
      this.#container.addEventListener("keydown", this.#boundKeyDown);
    } else {
      this.#hide();
      this.#container.removeEventListener("click", this.#boundToggle);
      this.#container.removeEventListener("keydown", this.#boundKeyDown);
    }
  }
  #show() {
    if (!this.#popup) {
      this.render();
    }
    if (!this.isVisible) {
      this.#container.hidden = false;
      this.#container.style.zIndex = parseInt(this.#container.style.zIndex) + 1000;
    } else if (this.#pinned) {
      this.#container.classList.add("focused");
    }
  }
  #hide() {
    this.#container.classList.remove("focused");
    if (this.#pinned || !this.isVisible) {
      return;
    }
    this.#container.hidden = true;
    this.#container.style.zIndex = parseInt(this.#container.style.zIndex) - 1000;
  }
  forceHide() {
    this.#wasVisible = this.isVisible;
    if (!this.#wasVisible) {
      return;
    }
    this.#container.hidden = true;
  }
  maybeShow() {
    if (!this.#wasVisible) {
      return;
    }
    this.#wasVisible = false;
    this.#container.hidden = false;
  }
  get isVisible() {
    return this.#container.hidden === false;
  }
}
class FreeTextAnnotationElement extends AnnotationElement {
  constructor(parameters) {
    super(parameters, {
      isRenderable: true,
      ignoreBorder: true
    });
    this.textContent = parameters.data.textContent;
    this.textPosition = parameters.data.textPosition;
    this.annotationEditorType = _util.AnnotationEditorType.FREETEXT;
  }
  render() {
    this.container.classList.add("freeTextAnnotation");
    if (this.textContent) {
      const content = document.createElement("div");
      content.classList.add("annotationTextContent");
      content.setAttribute("role", "comment");
      for (const line of this.textContent) {
        const lineSpan = document.createElement("span");
        lineSpan.textContent = line;
        content.append(lineSpan);
      }
      this.container.append(content);
    }
    if (!this.data.popupRef && this.hasPopupData) {
      this._createPopup();
    }
    this._editOnDoubleClick();
    return this.container;
  }
}
exports.FreeTextAnnotationElement = FreeTextAnnotationElement;
class LineAnnotationElement extends AnnotationElement {
  #line = null;
  constructor(parameters) {
    super(parameters, {
      isRenderable: true,
      ignoreBorder: true
    });
  }
  render() {
    this.container.classList.add("lineAnnotation");
    const data = this.data;
    const {
      width,
      height
    } = getRectDims(data.rect);
    const svg = this.svgFactory.create(width, height, true);
    const line = this.#line = this.svgFactory.createElement("svg:line");
    line.setAttribute("x1", data.rect[2] - data.lineCoordinates[0]);
    line.setAttribute("y1", data.rect[3] - data.lineCoordinates[1]);
    line.setAttribute("x2", data.rect[2] - data.lineCoordinates[2]);
    line.setAttribute("y2", data.rect[3] - data.lineCoordinates[3]);
    line.setAttribute("stroke-width", data.borderStyle.width || 1);
    line.setAttribute("stroke", "transparent");
    line.setAttribute("fill", "transparent");
    svg.append(line);
    this.container.append(svg);
    if (!data.popupRef && this.hasPopupData) {
      this._createPopup();
    }
    return this.container;
  }
  getElementsToTriggerPopup() {
    return this.#line;
  }
  addHighlightArea() {
    this.container.classList.add("highlightArea");
  }
}
class SquareAnnotationElement extends AnnotationElement {
  #square = null;
  constructor(parameters) {
    super(parameters, {
      isRenderable: true,
      ignoreBorder: true
    });
  }
  render() {
    this.container.classList.add("squareAnnotation");
    const data = this.data;
    const {
      width,
      height
    } = getRectDims(data.rect);
    const svg = this.svgFactory.create(width, height, true);
    const borderWidth = data.borderStyle.width;
    const square = this.#square = this.svgFactory.createElement("svg:rect");
    square.setAttribute("x", borderWidth / 2);
    square.setAttribute("y", borderWidth / 2);
    square.setAttribute("width", width - borderWidth);
    square.setAttribute("height", height - borderWidth);
    square.setAttribute("stroke-width", borderWidth || 1);
    square.setAttribute("stroke", "transparent");
    square.setAttribute("fill", "transparent");
    svg.append(square);
    this.container.append(svg);
    if (!data.popupRef && this.hasPopupData) {
      this._createPopup();
    }
    return this.container;
  }
  getElementsToTriggerPopup() {
    return this.#square;
  }
  addHighlightArea() {
    this.container.classList.add("highlightArea");
  }
}
class CircleAnnotationElement extends AnnotationElement {
  #circle = null;
  constructor(parameters) {
    super(parameters, {
      isRenderable: true,
      ignoreBorder: true
    });
  }
  render() {
    this.container.classList.add("circleAnnotation");
    const data = this.data;
    const {
      width,
      height
    } = getRectDims(data.rect);
    const svg = this.svgFactory.create(width, height, true);
    const borderWidth = data.borderStyle.width;
    const circle = this.#circle = this.svgFactory.createElement("svg:ellipse");
    circle.setAttribute("cx", width / 2);
    circle.setAttribute("cy", height / 2);
    circle.setAttribute("rx", width / 2 - borderWidth / 2);
    circle.setAttribute("ry", height / 2 - borderWidth / 2);
    circle.setAttribute("stroke-width", borderWidth || 1);
    circle.setAttribute("stroke", "transparent");
    circle.setAttribute("fill", "transparent");
    svg.append(circle);
    this.container.append(svg);
    if (!data.popupRef && this.hasPopupData) {
      this._createPopup();
    }
    return this.container;
  }
  getElementsToTriggerPopup() {
    return this.#circle;
  }
  addHighlightArea() {
    this.container.classList.add("highlightArea");
  }
}
class PolylineAnnotationElement extends AnnotationElement {
  #polyline = null;
  constructor(parameters) {
    super(parameters, {
      isRenderable: true,
      ignoreBorder: true
    });
    this.containerClassName = "polylineAnnotation";
    this.svgElementName = "svg:polyline";
  }
  render() {
    this.container.classList.add(this.containerClassName);
    const data = this.data;
    const {
      width,
      height
    } = getRectDims(data.rect);
    const svg = this.svgFactory.create(width, height, true);
    let points = [];
    for (const coordinate of data.vertices) {
      const x = coordinate.x - data.rect[0];
      const y = data.rect[3] - coordinate.y;
      points.push(x + "," + y);
    }
    points = points.join(" ");
    const polyline = this.#polyline = this.svgFactory.createElement(this.svgElementName);
    polyline.setAttribute("points", points);
    polyline.setAttribute("stroke-width", data.borderStyle.width || 1);
    polyline.setAttribute("stroke", "transparent");
    polyline.setAttribute("fill", "transparent");
    svg.append(polyline);
    this.container.append(svg);
    if (!data.popupRef && this.hasPopupData) {
      this._createPopup();
    }
    return this.container;
  }
  getElementsToTriggerPopup() {
    return this.#polyline;
  }
  addHighlightArea() {
    this.container.classList.add("highlightArea");
  }
}
class PolygonAnnotationElement extends PolylineAnnotationElement {
  constructor(parameters) {
    super(parameters);
    this.containerClassName = "polygonAnnotation";
    this.svgElementName = "svg:polygon";
  }
}
class CaretAnnotationElement extends AnnotationElement {
  constructor(parameters) {
    super(parameters, {
      isRenderable: true,
      ignoreBorder: true
    });
  }
  render() {
    this.container.classList.add("caretAnnotation");
    if (!this.data.popupRef && this.hasPopupData) {
      this._createPopup();
    }
    return this.container;
  }
}
class InkAnnotationElement extends AnnotationElement {
  #polylines = [];
  constructor(parameters) {
    super(parameters, {
      isRenderable: true,
      ignoreBorder: true
    });
    this.containerClassName = "inkAnnotation";
    this.svgElementName = "svg:polyline";
    this.annotationEditorType = _util.AnnotationEditorType.INK;
  }
  render() {
    this.container.classList.add(this.containerClassName);
    const data = this.data;
    const {
      width,
      height
    } = getRectDims(data.rect);
    const svg = this.svgFactory.create(width, height, true);
    for (const inkList of data.inkLists) {
      let points = [];
      for (const coordinate of inkList) {
        const x = coordinate.x - data.rect[0];
        const y = data.rect[3] - coordinate.y;
        points.push(`${x},${y}`);
      }
      points = points.join(" ");
      const polyline = this.svgFactory.createElement(this.svgElementName);
      this.#polylines.push(polyline);
      polyline.setAttribute("points", points);
      polyline.setAttribute("stroke-width", data.borderStyle.width || 1);
      polyline.setAttribute("stroke", "transparent");
      polyline.setAttribute("fill", "transparent");
      if (!data.popupRef && this.hasPopupData) {
        this._createPopup();
      }
      svg.append(polyline);
    }
    this.container.append(svg);
    return this.container;
  }
  getElementsToTriggerPopup() {
    return this.#polylines;
  }
  addHighlightArea() {
    this.container.classList.add("highlightArea");
  }
}
exports.InkAnnotationElement = InkAnnotationElement;
class HighlightAnnotationElement extends AnnotationElement {
  constructor(parameters) {
    super(parameters, {
      isRenderable: true,
      ignoreBorder: true,
      createQuadrilaterals: true
    });
  }
  render() {
    if (!this.data.popupRef && this.hasPopupData) {
      this._createPopup();
    }
    this.container.classList.add("highlightAnnotation");
    return this.container;
  }
}
class UnderlineAnnotationElement extends AnnotationElement {
  constructor(parameters) {
    super(parameters, {
      isRenderable: true,
      ignoreBorder: true,
      createQuadrilaterals: true
    });
  }
  render() {
    if (!this.data.popupRef && this.hasPopupData) {
      this._createPopup();
    }
    this.container.classList.add("underlineAnnotation");
    return this.container;
  }
}
class SquigglyAnnotationElement extends AnnotationElement {
  constructor(parameters) {
    super(parameters, {
      isRenderable: true,
      ignoreBorder: true,
      createQuadrilaterals: true
    });
  }
  render() {
    if (!this.data.popupRef && this.hasPopupData) {
      this._createPopup();
    }
    this.container.classList.add("squigglyAnnotation");
    return this.container;
  }
}
class StrikeOutAnnotationElement extends AnnotationElement {
  constructor(parameters) {
    super(parameters, {
      isRenderable: true,
      ignoreBorder: true,
      createQuadrilaterals: true
    });
  }
  render() {
    if (!this.data.popupRef && this.hasPopupData) {
      this._createPopup();
    }
    this.container.classList.add("strikeoutAnnotation");
    return this.container;
  }
}
class StampAnnotationElement extends AnnotationElement {
  constructor(parameters) {
    super(parameters, {
      isRenderable: true,
      ignoreBorder: true
    });
  }
  render() {
    this.container.classList.add("stampAnnotation");
    if (!this.data.popupRef && this.hasPopupData) {
      this._createPopup();
    }
    return this.container;
  }
}
exports.StampAnnotationElement = StampAnnotationElement;
class FileAttachmentAnnotationElement extends AnnotationElement {
  #trigger = null;
  constructor(parameters) {
    super(parameters, {
      isRenderable: true
    });
    const {
      filename,
      content
    } = this.data.file;
    this.filename = (0, _display_utils.getFilenameFromUrl)(filename, true);
    this.content = content;
    this.linkService.eventBus?.dispatch("fileattachmentannotation", {
      source: this,
      filename,
      content
    });
  }
  render() {
    this.container.classList.add("fileAttachmentAnnotation");
    const {
      container,
      data
    } = this;
    let trigger;
    if (data.hasAppearance || data.fillAlpha === 0) {
      trigger = document.createElement("div");
    } else {
      trigger = document.createElement("img");
      trigger.src = `${this.imageResourcesPath}annotation-${/paperclip/i.test(data.name) ? "paperclip" : "pushpin"}.svg`;
      if (data.fillAlpha && data.fillAlpha < 1) {
        trigger.style = `filter: opacity(${Math.round(data.fillAlpha * 100)}%);`;
      }
    }
    trigger.addEventListener("dblclick", this.#download.bind(this));
    this.#trigger = trigger;
    const {
      isMac
    } = _util.FeatureTest.platform;
    container.addEventListener("keydown", evt => {
      if (evt.key === "Enter" && (isMac ? evt.metaKey : evt.ctrlKey)) {
        this.#download();
      }
    });
    if (!data.popupRef && this.hasPopupData) {
      this._createPopup();
    } else {
      trigger.classList.add("popupTriggerArea");
    }
    container.append(trigger);
    return container;
  }
  getElementsToTriggerPopup() {
    return this.#trigger;
  }
  addHighlightArea() {
    this.container.classList.add("highlightArea");
  }
  #download() {
    this.downloadManager?.openOrDownloadData(this.container, this.content, this.filename);
  }
}
class AnnotationLayer {
  #accessibilityManager = null;
  #annotationCanvasMap = null;
  #editableAnnotations = new Map();
  constructor(_ref4) {
    let {
      div,
      accessibilityManager,
      annotationCanvasMap,
      l10n,
      page,
      viewport
    } = _ref4;
    this.div = div;
    this.#accessibilityManager = accessibilityManager;
    this.#annotationCanvasMap = annotationCanvasMap;
    this.l10n = l10n;
    this.page = page;
    this.viewport = viewport;
    this.zIndex = 0;
    this.l10n ||= _displayL10n_utils.NullL10n;
  }
  #appendElement(element, id) {
    const contentElement = element.firstChild || element;
    contentElement.id = `${_util.AnnotationPrefix}${id}`;
    this.div.append(element);
    this.#accessibilityManager?.moveElementInDOM(this.div, element, contentElement, false);
  }
  async render(params) {
    const {
      annotations
    } = params;
    const layer = this.div;
    (0, _display_utils.setLayerDimensions)(layer, this.viewport);
    const popupToElements = new Map();
    const elementParams = {
      data: null,
      layer,
      linkService: params.linkService,
      downloadManager: params.downloadManager,
      imageResourcesPath: params.imageResourcesPath || "",
      renderForms: params.renderForms !== false,
      svgFactory: new _display_utils.DOMSVGFactory(),
      annotationStorage: params.annotationStorage || new _annotation_storage.AnnotationStorage(),
      enableScripting: params.enableScripting === true,
      hasJSActions: params.hasJSActions,
      fieldObjects: params.fieldObjects,
      parent: this,
      elements: null
    };
    for (const data of annotations) {
      if (data.noHTML) {
        continue;
      }
      const isPopupAnnotation = data.annotationType === _util.AnnotationType.POPUP;
      if (!isPopupAnnotation) {
        const {
          width,
          height
        } = getRectDims(data.rect);
        if (width <= 0 || height <= 0) {
          continue;
        }
      } else {
        const elements = popupToElements.get(data.id);
        if (!elements) {
          continue;
        }
        elementParams.elements = elements;
      }
      elementParams.data = data;
      const element = AnnotationElementFactory.create(elementParams);
      if (!element.isRenderable) {
        continue;
      }
      if (!isPopupAnnotation && data.popupRef) {
        const elements = popupToElements.get(data.popupRef);
        if (!elements) {
          popupToElements.set(data.popupRef, [element]);
        } else {
          elements.push(element);
        }
      }
      if (element.annotationEditorType > 0) {
        this.#editableAnnotations.set(element.data.id, element);
      }
      const rendered = element.render();
      if (data.hidden) {
        rendered.style.visibility = "hidden";
      }
      this.#appendElement(rendered, data.id);
    }
    this.#setAnnotationCanvasMap();
    await this.l10n.translate(layer);
  }
  update(_ref5) {
    let {
      viewport
    } = _ref5;
    const layer = this.div;
    this.viewport = viewport;
    (0, _display_utils.setLayerDimensions)(layer, {
      rotation: viewport.rotation
    });
    this.#setAnnotationCanvasMap();
    layer.hidden = false;
  }
  #setAnnotationCanvasMap() {
    if (!this.#annotationCanvasMap) {
      return;
    }
    const layer = this.div;
    for (const [id, canvas] of this.#annotationCanvasMap) {
      const element = layer.querySelector(`[data-annotation-id="${id}"]`);
      if (!element) {
        continue;
      }
      const {
        firstChild
      } = element;
      if (!firstChild) {
        element.append(canvas);
      } else if (firstChild.nodeName === "CANVAS") {
        firstChild.replaceWith(canvas);
      } else {
        firstChild.before(canvas);
      }
    }
    this.#annotationCanvasMap.clear();
  }
  getEditableAnnotations() {
    return Array.from(this.#editableAnnotations.values());
  }
  getEditableAnnotation(id) {
    return this.#editableAnnotations.get(id);
  }
}
exports.AnnotationLayer = AnnotationLayer;

/***/ }),
/* 199 */
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.ColorConverters = void 0;
function makeColorComp(n) {
  return Math.floor(Math.max(0, Math.min(1, n)) * 255).toString(16).padStart(2, "0");
}
function scaleAndClamp(x) {
  return Math.max(0, Math.min(255, 255 * x));
}
class ColorConverters {
  static CMYK_G(_ref) {
    let [c, y, m, k] = _ref;
    return ["G", 1 - Math.min(1, 0.3 * c + 0.59 * m + 0.11 * y + k)];
  }
  static G_CMYK(_ref2) {
    let [g] = _ref2;
    return ["CMYK", 0, 0, 0, 1 - g];
  }
  static G_RGB(_ref3) {
    let [g] = _ref3;
    return ["RGB", g, g, g];
  }
  static G_rgb(_ref4) {
    let [g] = _ref4;
    g = scaleAndClamp(g);
    return [g, g, g];
  }
  static G_HTML(_ref5) {
    let [g] = _ref5;
    const G = makeColorComp(g);
    return `#${G}${G}${G}`;
  }
  static RGB_G(_ref6) {
    let [r, g, b] = _ref6;
    return ["G", 0.3 * r + 0.59 * g + 0.11 * b];
  }
  static RGB_rgb(color) {
    return color.map(scaleAndClamp);
  }
  static RGB_HTML(color) {
    return `#${color.map(makeColorComp).join("")}`;
  }
  static T_HTML() {
    return "#00000000";
  }
  static T_rgb() {
    return [null];
  }
  static CMYK_RGB(_ref7) {
    let [c, y, m, k] = _ref7;
    return ["RGB", 1 - Math.min(1, c + k), 1 - Math.min(1, m + k), 1 - Math.min(1, y + k)];
  }
  static CMYK_rgb(_ref8) {
    let [c, y, m, k] = _ref8;
    return [scaleAndClamp(1 - Math.min(1, c + k)), scaleAndClamp(1 - Math.min(1, m + k)), scaleAndClamp(1 - Math.min(1, y + k))];
  }
  static CMYK_HTML(components) {
    const rgb = this.CMYK_RGB(components).slice(1);
    return this.RGB_HTML(rgb);
  }
  static RGB_CMYK(_ref9) {
    let [r, g, b] = _ref9;
    const c = 1 - r;
    const m = 1 - g;
    const y = 1 - b;
    const k = Math.min(c, m, y);
    return ["CMYK", c, m, y, k];
  }
}
exports.ColorConverters = ColorConverters;

/***/ }),
/* 200 */
/***/ ((__unused_webpack_module, exports) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.NullL10n = void 0;
exports.getL10nFallback = getL10nFallback;
const DEFAULT_L10N_STRINGS = {
  of_pages: "of {{pagesCount}}",
  page_of_pages: "({{pageNumber}} of {{pagesCount}})",
  document_properties_kb: "{{size_kb}} KB ({{size_b}} bytes)",
  document_properties_mb: "{{size_mb}} MB ({{size_b}} bytes)",
  document_properties_date_string: "{{date}}, {{time}}",
  document_properties_page_size_unit_inches: "in",
  document_properties_page_size_unit_millimeters: "mm",
  document_properties_page_size_orientation_portrait: "portrait",
  document_properties_page_size_orientation_landscape: "landscape",
  document_properties_page_size_name_a3: "A3",
  document_properties_page_size_name_a4: "A4",
  document_properties_page_size_name_letter: "Letter",
  document_properties_page_size_name_legal: "Legal",
  document_properties_page_size_dimension_string: "{{width}} × {{height}} {{unit}} ({{orientation}})",
  document_properties_page_size_dimension_name_string: "{{width}} × {{height}} {{unit}} ({{name}}, {{orientation}})",
  document_properties_linearized_yes: "Yes",
  document_properties_linearized_no: "No",
  additional_layers: "Additional Layers",
  page_landmark: "Page {{page}}",
  thumb_page_title: "Page {{page}}",
  thumb_page_canvas: "Thumbnail of Page {{page}}",
  find_reached_top: "Reached top of document, continued from bottom",
  find_reached_bottom: "Reached end of document, continued from top",
  "find_match_count[one]": "{{current}} of {{total}} match",
  "find_match_count[other]": "{{current}} of {{total}} matches",
  "find_match_count_limit[one]": "More than {{limit}} match",
  "find_match_count_limit[other]": "More than {{limit}} matches",
  find_not_found: "Phrase not found",
  page_scale_width: "Page Width",
  page_scale_fit: "Page Fit",
  page_scale_auto: "Automatic Zoom",
  page_scale_actual: "Actual Size",
  page_scale_percent: "{{scale}}%",
  loading_error: "An error occurred while loading the PDF.",
  invalid_file_error: "Invalid or corrupted PDF file.",
  missing_file_error: "Missing PDF file.",
  unexpected_response_error: "Unexpected server response.",
  rendering_error: "An error occurred while rendering the page.",
  annotation_date_string: "{{date}}, {{time}}",
  printing_not_supported: "Warning: Printing is not fully supported by this browser.",
  printing_not_ready: "Warning: The PDF is not fully loaded for printing.",
  web_fonts_disabled: "Web fonts are disabled: unable to use embedded PDF fonts.",
  free_text2_default_content: "Start typing…",
  editor_free_text2_aria_label: "Text Editor",
  editor_ink2_aria_label: "Draw Editor",
  editor_ink_canvas_aria_label: "User-created image",
  editor_alt_text_button_label: "Alt text",
  editor_alt_text_edit_button_label: "Edit alt text",
  editor_alt_text_decorative_tooltip: "Marked as decorative"
};
{
  DEFAULT_L10N_STRINGS.print_progress_percent = "{{progress}}%";
}
function getL10nFallback(key, args) {
  switch (key) {
    case "find_match_count":
      key = `find_match_count[${args.total === 1 ? "one" : "other"}]`;
      break;
    case "find_match_count_limit":
      key = `find_match_count_limit[${args.limit === 1 ? "one" : "other"}]`;
      break;
  }
  return DEFAULT_L10N_STRINGS[key] || "";
}
function formatL10nValue(text, args) {
  if (!args) {
    return text;
  }
  return text.replaceAll(/\{\{\s*(\w+)\s*\}\}/g, (all, name) => {
    return name in args ? args[name] : "{{" + name + "}}";
  });
}
const NullL10n = {
  async getLanguage() {
    return "en-us";
  },
  async getDirection() {
    return "ltr";
  },
  async get(key) {
    let args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    let fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getL10nFallback(key, args);
    return formatL10nValue(fallback, args);
  },
  async translate(element) {}
};
exports.NullL10n = NullL10n;

/***/ }),
/* 201 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.XfaLayer = void 0;
__w_pdfjs_require__(89);
var _xfa_text = __w_pdfjs_require__(194);
class XfaLayer {
  static setupStorage(html, id, element, storage, intent) {
    const storedData = storage.getValue(id, {
      value: null
    });
    switch (element.name) {
      case "textarea":
        if (storedData.value !== null) {
          html.textContent = storedData.value;
        }
        if (intent === "print") {
          break;
        }
        html.addEventListener("input", event => {
          storage.setValue(id, {
            value: event.target.value
          });
        });
        break;
      case "input":
        if (element.attributes.type === "radio" || element.attributes.type === "checkbox") {
          if (storedData.value === element.attributes.xfaOn) {
            html.setAttribute("checked", true);
          } else if (storedData.value === element.attributes.xfaOff) {
            html.removeAttribute("checked");
          }
          if (intent === "print") {
            break;
          }
          html.addEventListener("change", event => {
            storage.setValue(id, {
              value: event.target.checked ? event.target.getAttribute("xfaOn") : event.target.getAttribute("xfaOff")
            });
          });
        } else {
          if (storedData.value !== null) {
            html.setAttribute("value", storedData.value);
          }
          if (intent === "print") {
            break;
          }
          html.addEventListener("input", event => {
            storage.setValue(id, {
              value: event.target.value
            });
          });
        }
        break;
      case "select":
        if (storedData.value !== null) {
          html.setAttribute("value", storedData.value);
          for (const option of element.children) {
            if (option.attributes.value === storedData.value) {
              option.attributes.selected = true;
            } else if (option.attributes.hasOwnProperty("selected")) {
              delete option.attributes.selected;
            }
          }
        }
        html.addEventListener("input", event => {
          const options = event.target.options;
          const value = options.selectedIndex === -1 ? "" : options[options.selectedIndex].value;
          storage.setValue(id, {
            value
          });
        });
        break;
    }
  }
  static setAttributes(_ref) {
    let {
      html,
      element,
      storage = null,
      intent,
      linkService
    } = _ref;
    const {
      attributes
    } = element;
    const isHTMLAnchorElement = html instanceof HTMLAnchorElement;
    if (attributes.type === "radio") {
      attributes.name = `${attributes.name}-${intent}`;
    }
    for (const [key, value] of Object.entries(attributes)) {
      if (value === null || value === undefined) {
        continue;
      }
      switch (key) {
        case "class":
          if (value.length) {
            html.setAttribute(key, value.join(" "));
          }
          break;
        case "dataId":
          break;
        case "id":
          html.setAttribute("data-element-id", value);
          break;
        case "style":
          Object.assign(html.style, value);
          break;
        case "textContent":
          html.textContent = value;
          break;
        default:
          if (!isHTMLAnchorElement || key !== "href" && key !== "newWindow") {
            html.setAttribute(key, value);
          }
      }
    }
    if (isHTMLAnchorElement) {
      linkService.addLinkAttributes(html, attributes.href, attributes.newWindow);
    }
    if (storage && attributes.dataId) {
      this.setupStorage(html, attributes.dataId, element, storage);
    }
  }
  static render(parameters) {
    const storage = parameters.annotationStorage;
    const linkService = parameters.linkService;
    const root = parameters.xfaHtml;
    const intent = parameters.intent || "display";
    const rootHtml = document.createElement(root.name);
    if (root.attributes) {
      this.setAttributes({
        html: rootHtml,
        element: root,
        intent,
        linkService
      });
    }
    const stack = [[root, -1, rootHtml]];
    const rootDiv = parameters.div;
    rootDiv.append(rootHtml);
    if (parameters.viewport) {
      const transform = `matrix(${parameters.viewport.transform.join(",")})`;
      rootDiv.style.transform = transform;
    }
    if (intent !== "richText") {
      rootDiv.setAttribute("class", "xfaLayer xfaFont");
    }
    const textDivs = [];
    while (stack.length > 0) {
      const [parent, i, html] = stack.at(-1);
      if (i + 1 === parent.children.length) {
        stack.pop();
        continue;
      }
      const child = parent.children[++stack.at(-1)[1]];
      if (child === null) {
        continue;
      }
      const {
        name
      } = child;
      if (name === "#text") {
        const node = document.createTextNode(child.value);
        textDivs.push(node);
        html.append(node);
        continue;
      }
      const childHtml = child?.attributes?.xmlns ? document.createElementNS(child.attributes.xmlns, name) : document.createElement(name);
      html.append(childHtml);
      if (child.attributes) {
        this.setAttributes({
          html: childHtml,
          element: child,
          storage,
          intent,
          linkService
        });
      }
      if (child.children && child.children.length > 0) {
        stack.push([child, -1, childHtml]);
      } else if (child.value) {
        const node = document.createTextNode(child.value);
        if (_xfa_text.XfaText.shouldBuildText(name)) {
          textDivs.push(node);
        }
        childHtml.append(node);
      }
    }
    for (const el of rootDiv.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea")) {
      el.setAttribute("readOnly", true);
    }
    return {
      textDivs
    };
  }
  static update(parameters) {
    const transform = `matrix(${parameters.viewport.transform.join(",")})`;
    parameters.div.style.transform = transform;
    parameters.div.hidden = false;
  }
}
exports.XfaLayer = XfaLayer;

/***/ }),
/* 202 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.InkEditor = void 0;
__w_pdfjs_require__(89);
__w_pdfjs_require__(2);
var _util = __w_pdfjs_require__(1);
var _editor = __w_pdfjs_require__(164);
var _annotation_layer = __w_pdfjs_require__(198);
var _display_utils = __w_pdfjs_require__(168);
var _tools = __w_pdfjs_require__(165);
class InkEditor extends _editor.AnnotationEditor {
  #baseHeight = 0;
  #baseWidth = 0;
  #boundCanvasPointermove = this.canvasPointermove.bind(this);
  #boundCanvasPointerleave = this.canvasPointerleave.bind(this);
  #boundCanvasPointerup = this.canvasPointerup.bind(this);
  #boundCanvasPointerdown = this.canvasPointerdown.bind(this);
  #currentPath2D = new Path2D();
  #disableEditing = false;
  #hasSomethingToDraw = false;
  #isCanvasInitialized = false;
  #observer = null;
  #realWidth = 0;
  #realHeight = 0;
  #requestFrameCallback = null;
  static _defaultColor = null;
  static _defaultOpacity = 1;
  static _defaultThickness = 1;
  static _type = "ink";
  constructor(params) {
    super({
      ...params,
      name: "inkEditor"
    });
    this.color = params.color || null;
    this.thickness = params.thickness || null;
    this.opacity = params.opacity || null;
    this.paths = [];
    this.bezierPath2D = [];
    this.allRawPaths = [];
    this.currentPath = [];
    this.scaleFactor = 1;
    this.translationX = this.translationY = 0;
    this.x = 0;
    this.y = 0;
    this._willKeepAspectRatio = true;
  }
  static initialize(l10n) {
    _editor.AnnotationEditor.initialize(l10n, {
      strings: ["editor_ink_canvas_aria_label", "editor_ink2_aria_label"]
    });
  }
  static updateDefaultParams(type, value) {
    switch (type) {
      case _util.AnnotationEditorParamsType.INK_THICKNESS:
        InkEditor._defaultThickness = value;
        break;
      case _util.AnnotationEditorParamsType.INK_COLOR:
        InkEditor._defaultColor = value;
        break;
      case _util.AnnotationEditorParamsType.INK_OPACITY:
        InkEditor._defaultOpacity = value / 100;
        break;
    }
  }
  updateParams(type, value) {
    switch (type) {
      case _util.AnnotationEditorParamsType.INK_THICKNESS:
        this.#updateThickness(value);
        break;
      case _util.AnnotationEditorParamsType.INK_COLOR:
        this.#updateColor(value);
        break;
      case _util.AnnotationEditorParamsType.INK_OPACITY:
        this.#updateOpacity(value);
        break;
    }
  }
  static get defaultPropertiesToUpdate() {
    return [[_util.AnnotationEditorParamsType.INK_THICKNESS, InkEditor._defaultThickness], [_util.AnnotationEditorParamsType.INK_COLOR, InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor], [_util.AnnotationEditorParamsType.INK_OPACITY, Math.round(InkEditor._defaultOpacity * 100)]];
  }
  get propertiesToUpdate() {
    return [[_util.AnnotationEditorParamsType.INK_THICKNESS, this.thickness || InkEditor._defaultThickness], [_util.AnnotationEditorParamsType.INK_COLOR, this.color || InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor], [_util.AnnotationEditorParamsType.INK_OPACITY, Math.round(100 * (this.opacity ?? InkEditor._defaultOpacity))]];
  }
  #updateThickness(thickness) {
    const savedThickness = this.thickness;
    this.addCommands({
      cmd: () => {
        this.thickness = thickness;
        this.#fitToContent();
      },
      undo: () => {
        this.thickness = savedThickness;
        this.#fitToContent();
      },
      mustExec: true,
      type: _util.AnnotationEditorParamsType.INK_THICKNESS,
      overwriteIfSameType: true,
      keepUndo: true
    });
  }
  #updateColor(color) {
    const savedColor = this.color;
    this.addCommands({
      cmd: () => {
        this.color = color;
        this.#redraw();
      },
      undo: () => {
        this.color = savedColor;
        this.#redraw();
      },
      mustExec: true,
      type: _util.AnnotationEditorParamsType.INK_COLOR,
      overwriteIfSameType: true,
      keepUndo: true
    });
  }
  #updateOpacity(opacity) {
    opacity /= 100;
    const savedOpacity = this.opacity;
    this.addCommands({
      cmd: () => {
        this.opacity = opacity;
        this.#redraw();
      },
      undo: () => {
        this.opacity = savedOpacity;
        this.#redraw();
      },
      mustExec: true,
      type: _util.AnnotationEditorParamsType.INK_OPACITY,
      overwriteIfSameType: true,
      keepUndo: true
    });
  }
  rebuild() {
    if (!this.parent) {
      return;
    }
    super.rebuild();
    if (this.div === null) {
      return;
    }
    if (!this.canvas) {
      this.#createCanvas();
      this.#createObserver();
    }
    if (!this.isAttachedToDOM) {
      this.parent.add(this);
      this.#setCanvasDims();
    }
    this.#fitToContent();
  }
  remove() {
    if (this.canvas === null) {
      return;
    }
    if (!this.isEmpty()) {
      this.commit();
    }
    this.canvas.width = this.canvas.height = 0;
    this.canvas.remove();
    this.canvas = null;
    this.#observer.disconnect();
    this.#observer = null;
    super.remove();
  }
  setParent(parent) {
    if (!this.parent && parent) {
      this._uiManager.removeShouldRescale(this);
    } else if (this.parent && parent === null) {
      this._uiManager.addShouldRescale(this);
    }
    super.setParent(parent);
  }
  onScaleChanging() {
    const [parentWidth, parentHeight] = this.parentDimensions;
    const width = this.width * parentWidth;
    const height = this.height * parentHeight;
    this.setDimensions(width, height);
  }
  enableEditMode() {
    if (this.#disableEditing || this.canvas === null) {
      return;
    }
    super.enableEditMode();
    this._isDraggable = false;
    this.canvas.addEventListener("pointerdown", this.#boundCanvasPointerdown);
  }
  disableEditMode() {
    if (!this.isInEditMode() || this.canvas === null) {
      return;
    }
    super.disableEditMode();
    this._isDraggable = !this.isEmpty();
    this.div.classList.remove("editing");
    this.canvas.removeEventListener("pointerdown", this.#boundCanvasPointerdown);
  }
  onceAdded() {
    this._isDraggable = !this.isEmpty();
  }
  isEmpty() {
    return this.paths.length === 0 || this.paths.length === 1 && this.paths[0].length === 0;
  }
  #getInitialBBox() {
    const {
      parentRotation,
      parentDimensions: [width, height]
    } = this;
    switch (parentRotation) {
      case 90:
        return [0, height, height, width];
      case 180:
        return [width, height, width, height];
      case 270:
        return [width, 0, height, width];
      default:
        return [0, 0, width, height];
    }
  }
  #setStroke() {
    const {
      ctx,
      color,
      opacity,
      thickness,
      parentScale,
      scaleFactor
    } = this;
    ctx.lineWidth = thickness * parentScale / scaleFactor;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.miterLimit = 10;
    ctx.strokeStyle = `${color}${(0, _tools.opacityToHex)(opacity)}`;
  }
  #startDrawing(x, y) {
    this.canvas.addEventListener("contextmenu", _display_utils.noContextMenu);
    this.canvas.addEventListener("pointerleave", this.#boundCanvasPointerleave);
    this.canvas.addEventListener("pointermove", this.#boundCanvasPointermove);
    this.canvas.addEventListener("pointerup", this.#boundCanvasPointerup);
    this.canvas.removeEventListener("pointerdown", this.#boundCanvasPointerdown);
    this.isEditing = true;
    if (!this.#isCanvasInitialized) {
      this.#isCanvasInitialized = true;
      this.#setCanvasDims();
      this.thickness ||= InkEditor._defaultThickness;
      this.color ||= InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor;
      this.opacity ??= InkEditor._defaultOpacity;
    }
    this.currentPath.push([x, y]);
    this.#hasSomethingToDraw = false;
    this.#setStroke();
    this.#requestFrameCallback = () => {
      this.#drawPoints();
      if (this.#requestFrameCallback) {
        window.requestAnimationFrame(this.#requestFrameCallback);
      }
    };
    window.requestAnimationFrame(this.#requestFrameCallback);
  }
  #draw(x, y) {
    const [lastX, lastY] = this.currentPath.at(-1);
    if (this.currentPath.length > 1 && x === lastX && y === lastY) {
      return;
    }
    const currentPath = this.currentPath;
    let path2D = this.#currentPath2D;
    currentPath.push([x, y]);
    this.#hasSomethingToDraw = true;
    if (currentPath.length <= 2) {
      path2D.moveTo(...currentPath[0]);
      path2D.lineTo(x, y);
      return;
    }
    if (currentPath.length === 3) {
      this.#currentPath2D = path2D = new Path2D();
      path2D.moveTo(...currentPath[0]);
    }
    this.#makeBezierCurve(path2D, ...currentPath.at(-3), ...currentPath.at(-2), x, y);
  }
  #endPath() {
    if (this.currentPath.length === 0) {
      return;
    }
    const lastPoint = this.currentPath.at(-1);
    this.#currentPath2D.lineTo(...lastPoint);
  }
  #stopDrawing(x, y) {
    this.#requestFrameCallback = null;
    x = Math.min(Math.max(x, 0), this.canvas.width);
    y = Math.min(Math.max(y, 0), this.canvas.height);
    this.#draw(x, y);
    this.#endPath();
    let bezier;
    if (this.currentPath.length !== 1) {
      bezier = this.#generateBezierPoints();
    } else {
      const xy = [x, y];
      bezier = [[xy, xy.slice(), xy.slice(), xy]];
    }
    const path2D = this.#currentPath2D;
    const currentPath = this.currentPath;
    this.currentPath = [];
    this.#currentPath2D = new Path2D();
    const cmd = () => {
      this.allRawPaths.push(currentPath);
      this.paths.push(bezier);
      this.bezierPath2D.push(path2D);
      this.rebuild();
    };
    const undo = () => {
      this.allRawPaths.pop();
      this.paths.pop();
      this.bezierPath2D.pop();
      if (this.paths.length === 0) {
        this.remove();
      } else {
        if (!this.canvas) {
          this.#createCanvas();
          this.#createObserver();
        }
        this.#fitToContent();
      }
    };
    this.addCommands({
      cmd,
      undo,
      mustExec: true
    });
  }
  #drawPoints() {
    if (!this.#hasSomethingToDraw) {
      return;
    }
    this.#hasSomethingToDraw = false;
    const thickness = Math.ceil(this.thickness * this.parentScale);
    const lastPoints = this.currentPath.slice(-3);
    const x = lastPoints.map(xy => xy[0]);
    const y = lastPoints.map(xy => xy[1]);
    const xMin = Math.min(...x) - thickness;
    const xMax = Math.max(...x) + thickness;
    const yMin = Math.min(...y) - thickness;
    const yMax = Math.max(...y) + thickness;
    const {
      ctx
    } = this;
    ctx.save();
    ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
    for (const path of this.bezierPath2D) {
      ctx.stroke(path);
    }
    ctx.stroke(this.#currentPath2D);
    ctx.restore();
  }
  #makeBezierCurve(path2D, x0, y0, x1, y1, x2, y2) {
    const prevX = (x0 + x1) / 2;
    const prevY = (y0 + y1) / 2;
    const x3 = (x1 + x2) / 2;
    const y3 = (y1 + y2) / 2;
    path2D.bezierCurveTo(prevX + 2 * (x1 - prevX) / 3, prevY + 2 * (y1 - prevY) / 3, x3 + 2 * (x1 - x3) / 3, y3 + 2 * (y1 - y3) / 3, x3, y3);
  }
  #generateBezierPoints() {
    const path = this.currentPath;
    if (path.length <= 2) {
      return [[path[0], path[0], path.at(-1), path.at(-1)]];
    }
    const bezierPoints = [];
    let i;
    let [x0, y0] = path[0];
    for (i = 1; i < path.length - 2; i++) {
      const [x1, y1] = path[i];
      const [x2, y2] = path[i + 1];
      const x3 = (x1 + x2) / 2;
      const y3 = (y1 + y2) / 2;
      const control1 = [x0 + 2 * (x1 - x0) / 3, y0 + 2 * (y1 - y0) / 3];
      const control2 = [x3 + 2 * (x1 - x3) / 3, y3 + 2 * (y1 - y3) / 3];
      bezierPoints.push([[x0, y0], control1, control2, [x3, y3]]);
      [x0, y0] = [x3, y3];
    }
    const [x1, y1] = path[i];
    const [x2, y2] = path[i + 1];
    const control1 = [x0 + 2 * (x1 - x0) / 3, y0 + 2 * (y1 - y0) / 3];
    const control2 = [x2 + 2 * (x1 - x2) / 3, y2 + 2 * (y1 - y2) / 3];
    bezierPoints.push([[x0, y0], control1, control2, [x2, y2]]);
    return bezierPoints;
  }
  #redraw() {
    if (this.isEmpty()) {
      this.#updateTransform();
      return;
    }
    this.#setStroke();
    const {
      canvas,
      ctx
    } = this;
    ctx.setTransform(1, 0, 0, 1, 0, 0);
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    this.#updateTransform();
    for (const path of this.bezierPath2D) {
      ctx.stroke(path);
    }
  }
  commit() {
    if (this.#disableEditing) {
      return;
    }
    super.commit();
    this.isEditing = false;
    this.disableEditMode();
    this.setInForeground();
    this.#disableEditing = true;
    this.div.classList.add("disabled");
    this.#fitToContent(true);
    this.makeResizable();
    this.parent.addInkEditorIfNeeded(true);
    this.moveInDOM();
    this.div.focus({
      preventScroll: true
    });
  }
  focusin(event) {
    if (!this._focusEventsAllowed) {
      return;
    }
    super.focusin(event);
    this.enableEditMode();
  }
  canvasPointerdown(event) {
    if (event.button !== 0 || !this.isInEditMode() || this.#disableEditing) {
      return;
    }
    this.setInForeground();
    event.preventDefault();
    if (event.type !== "mouse") {
      this.div.focus();
    }
    this.#startDrawing(event.offsetX, event.offsetY);
  }
  canvasPointermove(event) {
    event.preventDefault();
    this.#draw(event.offsetX, event.offsetY);
  }
  canvasPointerup(event) {
    event.preventDefault();
    this.#endDrawing(event);
  }
  canvasPointerleave(event) {
    this.#endDrawing(event);
  }
  #endDrawing(event) {
    this.canvas.removeEventListener("pointerleave", this.#boundCanvasPointerleave);
    this.canvas.removeEventListener("pointermove", this.#boundCanvasPointermove);
    this.canvas.removeEventListener("pointerup", this.#boundCanvasPointerup);
    this.canvas.addEventListener("pointerdown", this.#boundCanvasPointerdown);
    setTimeout(() => {
      this.canvas.removeEventListener("contextmenu", _display_utils.noContextMenu);
    }, 10);
    this.#stopDrawing(event.offsetX, event.offsetY);
    this.addToAnnotationStorage();
    this.setInBackground();
  }
  #createCanvas() {
    this.canvas = document.createElement("canvas");
    this.canvas.width = this.canvas.height = 0;
    this.canvas.className = "inkEditorCanvas";
    _editor.AnnotationEditor._l10nPromise.get("editor_ink_canvas_aria_label").then(msg => this.canvas?.setAttribute("aria-label", msg));
    this.div.append(this.canvas);
    this.ctx = this.canvas.getContext("2d");
  }
  #createObserver() {
    this.#observer = new ResizeObserver(entries => {
      const rect = entries[0].contentRect;
      if (rect.width && rect.height) {
        this.setDimensions(rect.width, rect.height);
      }
    });
    this.#observer.observe(this.div);
  }
  get isResizable() {
    return !this.isEmpty() && this.#disableEditing;
  }
  render() {
    if (this.div) {
      return this.div;
    }
    let baseX, baseY;
    if (this.width) {
      baseX = this.x;
      baseY = this.y;
    }
    super.render();
    _editor.AnnotationEditor._l10nPromise.get("editor_ink2_aria_label").then(msg => this.div?.setAttribute("aria-label", msg));
    const [x, y, w, h] = this.#getInitialBBox();
    this.setAt(x, y, 0, 0);
    this.setDims(w, h);
    this.#createCanvas();
    if (this.width) {
      const [parentWidth, parentHeight] = this.parentDimensions;
      this.setAspectRatio(this.width * parentWidth, this.height * parentHeight);
      this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
      this.#isCanvasInitialized = true;
      this.#setCanvasDims();
      this.setDims(this.width * parentWidth, this.height * parentHeight);
      this.#redraw();
      this.div.classList.add("disabled");
    } else {
      this.div.classList.add("editing");
      this.enableEditMode();
    }
    this.#createObserver();
    return this.div;
  }
  #setCanvasDims() {
    if (!this.#isCanvasInitialized) {
      return;
    }
    const [parentWidth, parentHeight] = this.parentDimensions;
    this.canvas.width = Math.ceil(this.width * parentWidth);
    this.canvas.height = Math.ceil(this.height * parentHeight);
    this.#updateTransform();
  }
  setDimensions(width, height) {
    const roundedWidth = Math.round(width);
    const roundedHeight = Math.round(height);
    if (this.#realWidth === roundedWidth && this.#realHeight === roundedHeight) {
      return;
    }
    this.#realWidth = roundedWidth;
    this.#realHeight = roundedHeight;
    this.canvas.style.visibility = "hidden";
    const [parentWidth, parentHeight] = this.parentDimensions;
    this.width = width / parentWidth;
    this.height = height / parentHeight;
    this.fixAndSetPosition();
    if (this.#disableEditing) {
      this.#setScaleFactor(width, height);
    }
    this.#setCanvasDims();
    this.#redraw();
    this.canvas.style.visibility = "visible";
    this.fixDims();
  }
  #setScaleFactor(width, height) {
    const padding = this.#getPadding();
    const scaleFactorW = (width - padding) / this.#baseWidth;
    const scaleFactorH = (height - padding) / this.#baseHeight;
    this.scaleFactor = Math.min(scaleFactorW, scaleFactorH);
  }
  #updateTransform() {
    const padding = this.#getPadding() / 2;
    this.ctx.setTransform(this.scaleFactor, 0, 0, this.scaleFactor, this.translationX * this.scaleFactor + padding, this.translationY * this.scaleFactor + padding);
  }
  static #buildPath2D(bezier) {
    const path2D = new Path2D();
    for (let i = 0, ii = bezier.length; i < ii; i++) {
      const [first, control1, control2, second] = bezier[i];
      if (i === 0) {
        path2D.moveTo(...first);
      }
      path2D.bezierCurveTo(control1[0], control1[1], control2[0], control2[1], second[0], second[1]);
    }
    return path2D;
  }
  static #toPDFCoordinates(points, rect, rotation) {
    const [blX, blY, trX, trY] = rect;
    switch (rotation) {
      case 0:
        for (let i = 0, ii = points.length; i < ii; i += 2) {
          points[i] += blX;
          points[i + 1] = trY - points[i + 1];
        }
        break;
      case 90:
        for (let i = 0, ii = points.length; i < ii; i += 2) {
          const x = points[i];
          points[i] = points[i + 1] + blX;
          points[i + 1] = x + blY;
        }
        break;
      case 180:
        for (let i = 0, ii = points.length; i < ii; i += 2) {
          points[i] = trX - points[i];
          points[i + 1] += blY;
        }
        break;
      case 270:
        for (let i = 0, ii = points.length; i < ii; i += 2) {
          const x = points[i];
          points[i] = trX - points[i + 1];
          points[i + 1] = trY - x;
        }
        break;
      default:
        throw new Error("Invalid rotation");
    }
    return points;
  }
  static #fromPDFCoordinates(points, rect, rotation) {
    const [blX, blY, trX, trY] = rect;
    switch (rotation) {
      case 0:
        for (let i = 0, ii = points.length; i < ii; i += 2) {
          points[i] -= blX;
          points[i + 1] = trY - points[i + 1];
        }
        break;
      case 90:
        for (let i = 0, ii = points.length; i < ii; i += 2) {
          const x = points[i];
          points[i] = points[i + 1] - blY;
          points[i + 1] = x - blX;
        }
        break;
      case 180:
        for (let i = 0, ii = points.length; i < ii; i += 2) {
          points[i] = trX - points[i];
          points[i + 1] -= blY;
        }
        break;
      case 270:
        for (let i = 0, ii = points.length; i < ii; i += 2) {
          const x = points[i];
          points[i] = trY - points[i + 1];
          points[i + 1] = trX - x;
        }
        break;
      default:
        throw new Error("Invalid rotation");
    }
    return points;
  }
  #serializePaths(s, tx, ty, rect) {
    const paths = [];
    const padding = this.thickness / 2;
    const shiftX = s * tx + padding;
    const shiftY = s * ty + padding;
    for (const bezier of this.paths) {
      const buffer = [];
      const points = [];
      for (let j = 0, jj = bezier.length; j < jj; j++) {
        const [first, control1, control2, second] = bezier[j];
        const p10 = s * first[0] + shiftX;
        const p11 = s * first[1] + shiftY;
        const p20 = s * control1[0] + shiftX;
        const p21 = s * control1[1] + shiftY;
        const p30 = s * control2[0] + shiftX;
        const p31 = s * control2[1] + shiftY;
        const p40 = s * second[0] + shiftX;
        const p41 = s * second[1] + shiftY;
        if (j === 0) {
          buffer.push(p10, p11);
          points.push(p10, p11);
        }
        buffer.push(p20, p21, p30, p31, p40, p41);
        points.push(p20, p21);
        if (j === jj - 1) {
          points.push(p40, p41);
        }
      }
      paths.push({
        bezier: InkEditor.#toPDFCoordinates(buffer, rect, this.rotation),
        points: InkEditor.#toPDFCoordinates(points, rect, this.rotation)
      });
    }
    return paths;
  }
  #getBbox() {
    let xMin = Infinity;
    let xMax = -Infinity;
    let yMin = Infinity;
    let yMax = -Infinity;
    for (const path of this.paths) {
      for (const [first, control1, control2, second] of path) {
        const bbox = _util.Util.bezierBoundingBox(...first, ...control1, ...control2, ...second);
        xMin = Math.min(xMin, bbox[0]);
        yMin = Math.min(yMin, bbox[1]);
        xMax = Math.max(xMax, bbox[2]);
        yMax = Math.max(yMax, bbox[3]);
      }
    }
    return [xMin, yMin, xMax, yMax];
  }
  #getPadding() {
    return this.#disableEditing ? Math.ceil(this.thickness * this.parentScale) : 0;
  }
  #fitToContent() {
    let firstTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (this.isEmpty()) {
      return;
    }
    if (!this.#disableEditing) {
      this.#redraw();
      return;
    }
    const bbox = this.#getBbox();
    const padding = this.#getPadding();
    this.#baseWidth = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[2] - bbox[0]);
    this.#baseHeight = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[3] - bbox[1]);
    const width = Math.ceil(padding + this.#baseWidth * this.scaleFactor);
    const height = Math.ceil(padding + this.#baseHeight * this.scaleFactor);
    const [parentWidth, parentHeight] = this.parentDimensions;
    this.width = width / parentWidth;
    this.height = height / parentHeight;
    this.setAspectRatio(width, height);
    const prevTranslationX = this.translationX;
    const prevTranslationY = this.translationY;
    this.translationX = -bbox[0];
    this.translationY = -bbox[1];
    this.#setCanvasDims();
    this.#redraw();
    this.#realWidth = width;
    this.#realHeight = height;
    this.setDims(width, height);
    const unscaledPadding = firstTime ? padding / this.scaleFactor / 2 : 0;
    this.translate(prevTranslationX - this.translationX - unscaledPadding, prevTranslationY - this.translationY - unscaledPadding);
  }
  static deserialize(data, parent, uiManager) {
    if (data instanceof _annotation_layer.InkAnnotationElement) {
      return null;
    }
    const editor = super.deserialize(data, parent, uiManager);
    editor.thickness = data.thickness;
    editor.color = _util.Util.makeHexColor(...data.color);
    editor.opacity = data.opacity;
    const [pageWidth, pageHeight] = editor.pageDimensions;
    const width = editor.width * pageWidth;
    const height = editor.height * pageHeight;
    const scaleFactor = editor.parentScale;
    const padding = data.thickness / 2;
    editor.#disableEditing = true;
    editor.#realWidth = Math.round(width);
    editor.#realHeight = Math.round(height);
    const {
      paths,
      rect,
      rotation
    } = data;
    for (let {
      bezier
    } of paths) {
      bezier = InkEditor.#fromPDFCoordinates(bezier, rect, rotation);
      const path = [];
      editor.paths.push(path);
      let p0 = scaleFactor * (bezier[0] - padding);
      let p1 = scaleFactor * (bezier[1] - padding);
      for (let i = 2, ii = bezier.length; i < ii; i += 6) {
        const p10 = scaleFactor * (bezier[i] - padding);
        const p11 = scaleFactor * (bezier[i + 1] - padding);
        const p20 = scaleFactor * (bezier[i + 2] - padding);
        const p21 = scaleFactor * (bezier[i + 3] - padding);
        const p30 = scaleFactor * (bezier[i + 4] - padding);
        const p31 = scaleFactor * (bezier[i + 5] - padding);
        path.push([[p0, p1], [p10, p11], [p20, p21], [p30, p31]]);
        p0 = p30;
        p1 = p31;
      }
      const path2D = this.#buildPath2D(path);
      editor.bezierPath2D.push(path2D);
    }
    const bbox = editor.#getBbox();
    editor.#baseWidth = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[2] - bbox[0]);
    editor.#baseHeight = Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[3] - bbox[1]);
    editor.#setScaleFactor(width, height);
    return editor;
  }
  serialize() {
    if (this.isEmpty()) {
      return null;
    }
    const rect = this.getRect(0, 0);
    const color = _editor.AnnotationEditor._colorManager.convert(this.ctx.strokeStyle);
    return {
      annotationType: _util.AnnotationEditorType.INK,
      color,
      thickness: this.thickness,
      opacity: this.opacity,
      paths: this.#serializePaths(this.scaleFactor / this.parentScale, this.translationX, this.translationY, rect),
      pageIndex: this.pageIndex,
      rect,
      rotation: this.rotation,
      structTreeParentId: this._structTreeParentId
    };
  }
}
exports.InkEditor = InkEditor;

/***/ }),
/* 203 */
/***/ ((__unused_webpack_module, exports, __w_pdfjs_require__) => {



Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.StampEditor = void 0;
__w_pdfjs_require__(149);
__w_pdfjs_require__(152);
var _util = __w_pdfjs_require__(1);
var _editor = __w_pdfjs_require__(164);
var _display_utils = __w_pdfjs_require__(168);
var _annotation_layer = __w_pdfjs_require__(198);
class StampEditor extends _editor.AnnotationEditor {
  #bitmap = null;
  #bitmapId = null;
  #bitmapPromise = null;
  #bitmapUrl = null;
  #bitmapFile = null;
  #canvas = null;
  #observer = null;
  #resizeTimeoutId = null;
  #isSvg = false;
  #hasBeenAddedInUndoStack = false;
  static _type = "stamp";
  constructor(params) {
    super({
      ...params,
      name: "stampEditor"
    });
    this.#bitmapUrl = params.bitmapUrl;
    this.#bitmapFile = params.bitmapFile;
  }
  static initialize(l10n) {
    _editor.AnnotationEditor.initialize(l10n);
  }
  static get supportedTypes() {
    const types = ["apng", "avif", "bmp", "gif", "jpeg", "png", "svg+xml", "webp", "x-icon"];
    return (0, _util.shadow)(this, "supportedTypes", types.map(type => `image/${type}`));
  }
  static get supportedTypesStr() {
    return (0, _util.shadow)(this, "supportedTypesStr", this.supportedTypes.join(","));
  }
  static isHandlingMimeForPasting(mime) {
    return this.supportedTypes.includes(mime);
  }
  static paste(item, parent) {
    parent.pasteEditor(_util.AnnotationEditorType.STAMP, {
      bitmapFile: item.getAsFile()
    });
  }
  #getBitmapFetched(data) {
    let fromId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!data) {
      this.remove();
      return;
    }
    this.#bitmap = data.bitmap;
    if (!fromId) {
      this.#bitmapId = data.id;
      this.#isSvg = data.isSvg;
    }
    this.#createCanvas();
  }
  #getBitmapDone() {
    this.#bitmapPromise = null;
    this._uiManager.enableWaiting(false);
    if (this.#canvas) {
      this.div.focus();
    }
  }
  #getBitmap() {
    if (this.#bitmapId) {
      this._uiManager.enableWaiting(true);
      this._uiManager.imageManager.getFromId(this.#bitmapId).then(data => this.#getBitmapFetched(data, true)).finally(() => this.#getBitmapDone());
      return;
    }
    if (this.#bitmapUrl) {
      const url = this.#bitmapUrl;
      this.#bitmapUrl = null;
      this._uiManager.enableWaiting(true);
      this.#bitmapPromise = this._uiManager.imageManager.getFromUrl(url).then(data => this.#getBitmapFetched(data)).finally(() => this.#getBitmapDone());
      return;
    }
    if (this.#bitmapFile) {
      const file = this.#bitmapFile;
      this.#bitmapFile = null;
      this._uiManager.enableWaiting(true);
      this.#bitmapPromise = this._uiManager.imageManager.getFromFile(file).then(data => this.#getBitmapFetched(data)).finally(() => this.#getBitmapDone());
      return;
    }
    const input = document.createElement("input");
    input.type = "file";
    input.accept = StampEditor.supportedTypesStr;
    this.#bitmapPromise = new Promise(resolve => {
      input.addEventListener("change", async () => {
        if (!input.files || input.files.length === 0) {
          this.remove();
        } else {
          this._uiManager.enableWaiting(true);
          const data = await this._uiManager.imageManager.getFromFile(input.files[0]);
          this.#getBitmapFetched(data);
        }
        resolve();
      });
      input.addEventListener("cancel", () => {
        this.remove();
        resolve();
      });
    }).finally(() => this.#getBitmapDone());
    input.click();
  }
  remove() {
    if (this.#bitmapId) {
      this.#bitmap = null;
      this._uiManager.imageManager.deleteId(this.#bitmapId);
      this.#canvas?.remove();
      this.#canvas = null;
      this.#observer?.disconnect();
      this.#observer = null;
    }
    super.remove();
  }
  rebuild() {
    if (!this.parent) {
      if (this.#bitmapId) {
        this.#getBitmap();
      }
      return;
    }
    super.rebuild();
    if (this.div === null) {
      return;
    }
    if (this.#bitmapId) {
      this.#getBitmap();
    }
    if (!this.isAttachedToDOM) {
      this.parent.add(this);
    }
  }
  onceAdded() {
    this._isDraggable = true;
    this.div.focus();
  }
  isEmpty() {
    return !(this.#bitmapPromise || this.#bitmap || this.#bitmapUrl || this.#bitmapFile);
  }
  get isResizable() {
    return true;
  }
  render() {
    if (this.div) {
      return this.div;
    }
    let baseX, baseY;
    if (this.width) {
      baseX = this.x;
      baseY = this.y;
    }
    super.render();
    this.div.hidden = true;
    if (this.#bitmap) {
      this.#createCanvas();
    } else {
      this.#getBitmap();
    }
    if (this.width) {
      const [parentWidth, parentHeight] = this.parentDimensions;
      this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
    }
    return this.div;
  }
  #createCanvas() {
    const {
      div
    } = this;
    let {
      width,
      height
    } = this.#bitmap;
    const [pageWidth, pageHeight] = this.pageDimensions;
    const MAX_RATIO = 0.75;
    if (this.width) {
      width = this.width * pageWidth;
      height = this.height * pageHeight;
    } else if (width > MAX_RATIO * pageWidth || height > MAX_RATIO * pageHeight) {
      const factor = Math.min(MAX_RATIO * pageWidth / width, MAX_RATIO * pageHeight / height);
      width *= factor;
      height *= factor;
    }
    const [parentWidth, parentHeight] = this.parentDimensions;
    this.setDims(width * parentWidth / pageWidth, height * parentHeight / pageHeight);
    this._uiManager.enableWaiting(false);
    const canvas = this.#canvas = document.createElement("canvas");
    div.append(canvas);
    div.hidden = false;
    this.#drawBitmap(width, height);
    this.#createObserver();
    if (!this.#hasBeenAddedInUndoStack) {
      this.parent.addUndoableEditor(this);
      this.#hasBeenAddedInUndoStack = true;
    }
    this._uiManager._eventBus.dispatch("reporttelemetry", {
      source: this,
      details: {
        type: "editing",
        subtype: this.editorType,
        data: {
          action: "inserted_image"
        }
      }
    });
    this.addAltTextButton();
  }
  #setDimensions(width, height) {
    const [parentWidth, parentHeight] = this.parentDimensions;
    this.width = width / parentWidth;
    this.height = height / parentHeight;
    this.setDims(width, height);
    if (this._initialOptions?.isCentered) {
      this.center();
    } else {
      this.fixAndSetPosition();
    }
    this._initialOptions = null;
    if (this.#resizeTimeoutId !== null) {
      clearTimeout(this.#resizeTimeoutId);
    }
    const TIME_TO_WAIT = 200;
    this.#resizeTimeoutId = setTimeout(() => {
      this.#resizeTimeoutId = null;
      this.#drawBitmap(width, height);
    }, TIME_TO_WAIT);
  }
  #scaleBitmap(width, height) {
    const {
      width: bitmapWidth,
      height: bitmapHeight
    } = this.#bitmap;
    let newWidth = bitmapWidth;
    let newHeight = bitmapHeight;
    let bitmap = this.#bitmap;
    while (newWidth > 2 * width || newHeight > 2 * height) {
      const prevWidth = newWidth;
      const prevHeight = newHeight;
      if (newWidth > 2 * width) {
        newWidth = newWidth >= 16384 ? Math.floor(newWidth / 2) - 1 : Math.ceil(newWidth / 2);
      }
      if (newHeight > 2 * height) {
        newHeight = newHeight >= 16384 ? Math.floor(newHeight / 2) - 1 : Math.ceil(newHeight / 2);
      }
      const offscreen = new OffscreenCanvas(newWidth, newHeight);
      const ctx = offscreen.getContext("2d");
      ctx.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
      bitmap = offscreen.transferToImageBitmap();
    }
    return bitmap;
  }
  #drawBitmap(width, height) {
    width = Math.ceil(width);
    height = Math.ceil(height);
    const canvas = this.#canvas;
    if (!canvas || canvas.width === width && canvas.height === height) {
      return;
    }
    canvas.width = width;
    canvas.height = height;
    const bitmap = this.#isSvg ? this.#bitmap : this.#scaleBitmap(width, height);
    const ctx = canvas.getContext("2d");
    ctx.filter = this._uiManager.hcmFilter;
    ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, width, height);
  }
  #serializeBitmap(toUrl) {
    if (toUrl) {
      if (this.#isSvg) {
        const url = this._uiManager.imageManager.getSvgUrl(this.#bitmapId);
        if (url) {
          return url;
        }
      }
      const canvas = document.createElement("canvas");
      ({
        width: canvas.width,
        height: canvas.height
      } = this.#bitmap);
      const ctx = canvas.getContext("2d");
      ctx.drawImage(this.#bitmap, 0, 0);
      return canvas.toDataURL();
    }
    if (this.#isSvg) {
      const [pageWidth, pageHeight] = this.pageDimensions;
      const width = Math.round(this.width * pageWidth * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
      const height = Math.round(this.height * pageHeight * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
      const offscreen = new OffscreenCanvas(width, height);
      const ctx = offscreen.getContext("2d");
      ctx.drawImage(this.#bitmap, 0, 0, this.#bitmap.width, this.#bitmap.height, 0, 0, width, height);
      return offscreen.transferToImageBitmap();
    }
    return structuredClone(this.#bitmap);
  }
  #createObserver() {
    this.#observer = new ResizeObserver(entries => {
      const rect = entries[0].contentRect;
      if (rect.width && rect.height) {
        this.#setDimensions(rect.width, rect.height);
      }
    });
    this.#observer.observe(this.div);
  }
  static deserialize(data, parent, uiManager) {
    if (data instanceof _annotation_layer.StampAnnotationElement) {
      return null;
    }
    const editor = super.deserialize(data, parent, uiManager);
    const {
      rect,
      bitmapUrl,
      bitmapId,
      isSvg,
      accessibilityData
    } = data;
    if (bitmapId && uiManager.imageManager.isValidId(bitmapId)) {
      editor.#bitmapId = bitmapId;
    } else {
      editor.#bitmapUrl = bitmapUrl;
    }
    editor.#isSvg = isSvg;
    const [parentWidth, parentHeight] = editor.pageDimensions;
    editor.width = (rect[2] - rect[0]) / parentWidth;
    editor.height = (rect[3] - rect[1]) / parentHeight;
    if (accessibilityData) {
      editor.altTextData = accessibilityData;
    }
    return editor;
  }
  serialize() {
    let isForCopying = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (this.isEmpty()) {
      return null;
    }
    const serialized = {
      annotationType: _util.AnnotationEditorType.STAMP,
      bitmapId: this.#bitmapId,
      pageIndex: this.pageIndex,
      rect: this.getRect(0, 0),
      rotation: this.rotation,
      isSvg: this.#isSvg,
      structTreeParentId: this._structTreeParentId
    };
    if (isForCopying) {
      serialized.bitmapUrl = this.#serializeBitmap(true);
      serialized.accessibilityData = this.altTextData;
      return serialized;
    }
    const {
      decorative,
      altText
    } = this.altTextData;
    if (!decorative && altText) {
      serialized.accessibilityData = {
        type: "Figure",
        alt: altText
      };
    }
    if (context === null) {
      return serialized;
    }
    context.stamps ||= new Map();
    const area = this.#isSvg ? (serialized.rect[2] - serialized.rect[0]) * (serialized.rect[3] - serialized.rect[1]) : null;
    if (!context.stamps.has(this.#bitmapId)) {
      context.stamps.set(this.#bitmapId, {
        area,
        serialized
      });
      serialized.bitmap = this.#serializeBitmap(false);
    } else if (this.#isSvg) {
      const prevData = context.stamps.get(this.#bitmapId);
      if (area > prevData.area) {
        prevData.area = area;
        prevData.serialized.bitmap.close();
        prevData.serialized.bitmap = this.#serializeBitmap(false);
      }
    }
    return serialized;
  }
}
exports.StampEditor = StampEditor;

/***/ })
/******/ 	]);
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __w_pdfjs_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __w_pdfjs_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
var exports = __webpack_exports__;


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
Object.defineProperty(exports, "AbortException", ({
  enumerable: true,
  get: function () {
    return _util.AbortException;
  }
}));
Object.defineProperty(exports, "AnnotationEditorLayer", ({
  enumerable: true,
  get: function () {
    return _annotation_editor_layer.AnnotationEditorLayer;
  }
}));
Object.defineProperty(exports, "AnnotationEditorParamsType", ({
  enumerable: true,
  get: function () {
    return _util.AnnotationEditorParamsType;
  }
}));
Object.defineProperty(exports, "AnnotationEditorType", ({
  enumerable: true,
  get: function () {
    return _util.AnnotationEditorType;
  }
}));
Object.defineProperty(exports, "AnnotationEditorUIManager", ({
  enumerable: true,
  get: function () {
    return _tools.AnnotationEditorUIManager;
  }
}));
Object.defineProperty(exports, "AnnotationLayer", ({
  enumerable: true,
  get: function () {
    return _annotation_layer.AnnotationLayer;
  }
}));
Object.defineProperty(exports, "AnnotationMode", ({
  enumerable: true,
  get: function () {
    return _util.AnnotationMode;
  }
}));
Object.defineProperty(exports, "CMapCompressionType", ({
  enumerable: true,
  get: function () {
    return _util.CMapCompressionType;
  }
}));
Object.defineProperty(exports, "DOMSVGFactory", ({
  enumerable: true,
  get: function () {
    return _display_utils.DOMSVGFactory;
  }
}));
Object.defineProperty(exports, "FeatureTest", ({
  enumerable: true,
  get: function () {
    return _util.FeatureTest;
  }
}));
Object.defineProperty(exports, "GlobalWorkerOptions", ({
  enumerable: true,
  get: function () {
    return _worker_options.GlobalWorkerOptions;
  }
}));
Object.defineProperty(exports, "ImageKind", ({
  enumerable: true,
  get: function () {
    return _util.ImageKind;
  }
}));
Object.defineProperty(exports, "InvalidPDFException", ({
  enumerable: true,
  get: function () {
    return _util.InvalidPDFException;
  }
}));
Object.defineProperty(exports, "MissingPDFException", ({
  enumerable: true,
  get: function () {
    return _util.MissingPDFException;
  }
}));
Object.defineProperty(exports, "OPS", ({
  enumerable: true,
  get: function () {
    return _util.OPS;
  }
}));
Object.defineProperty(exports, "PDFDataRangeTransport", ({
  enumerable: true,
  get: function () {
    return _api.PDFDataRangeTransport;
  }
}));
Object.defineProperty(exports, "PDFDateString", ({
  enumerable: true,
  get: function () {
    return _display_utils.PDFDateString;
  }
}));
Object.defineProperty(exports, "PDFWorker", ({
  enumerable: true,
  get: function () {
    return _api.PDFWorker;
  }
}));
Object.defineProperty(exports, "PasswordResponses", ({
  enumerable: true,
  get: function () {
    return _util.PasswordResponses;
  }
}));
Object.defineProperty(exports, "PermissionFlag", ({
  enumerable: true,
  get: function () {
    return _util.PermissionFlag;
  }
}));
Object.defineProperty(exports, "PixelsPerInch", ({
  enumerable: true,
  get: function () {
    return _display_utils.PixelsPerInch;
  }
}));
Object.defineProperty(exports, "PromiseCapability", ({
  enumerable: true,
  get: function () {
    return _util.PromiseCapability;
  }
}));
Object.defineProperty(exports, "RenderingCancelledException", ({
  enumerable: true,
  get: function () {
    return _display_utils.RenderingCancelledException;
  }
}));
Object.defineProperty(exports, "SVGGraphics", ({
  enumerable: true,
  get: function () {
    return _api.SVGGraphics;
  }
}));
Object.defineProperty(exports, "UnexpectedResponseException", ({
  enumerable: true,
  get: function () {
    return _util.UnexpectedResponseException;
  }
}));
Object.defineProperty(exports, "Util", ({
  enumerable: true,
  get: function () {
    return _util.Util;
  }
}));
Object.defineProperty(exports, "VerbosityLevel", ({
  enumerable: true,
  get: function () {
    return _util.VerbosityLevel;
  }
}));
Object.defineProperty(exports, "XfaLayer", ({
  enumerable: true,
  get: function () {
    return _xfa_layer.XfaLayer;
  }
}));
Object.defineProperty(exports, "build", ({
  enumerable: true,
  get: function () {
    return _api.build;
  }
}));
Object.defineProperty(exports, "createValidAbsoluteUrl", ({
  enumerable: true,
  get: function () {
    return _util.createValidAbsoluteUrl;
  }
}));
Object.defineProperty(exports, "getDocument", ({
  enumerable: true,
  get: function () {
    return _api.getDocument;
  }
}));
Object.defineProperty(exports, "getFilenameFromUrl", ({
  enumerable: true,
  get: function () {
    return _display_utils.getFilenameFromUrl;
  }
}));
Object.defineProperty(exports, "getPdfFilenameFromUrl", ({
  enumerable: true,
  get: function () {
    return _display_utils.getPdfFilenameFromUrl;
  }
}));
Object.defineProperty(exports, "getXfaPageViewport", ({
  enumerable: true,
  get: function () {
    return _display_utils.getXfaPageViewport;
  }
}));
Object.defineProperty(exports, "isDataScheme", ({
  enumerable: true,
  get: function () {
    return _display_utils.isDataScheme;
  }
}));
Object.defineProperty(exports, "isPdfFile", ({
  enumerable: true,
  get: function () {
    return _display_utils.isPdfFile;
  }
}));
Object.defineProperty(exports, "loadScript", ({
  enumerable: true,
  get: function () {
    return _display_utils.loadScript;
  }
}));
Object.defineProperty(exports, "noContextMenu", ({
  enumerable: true,
  get: function () {
    return _display_utils.noContextMenu;
  }
}));
Object.defineProperty(exports, "normalizeUnicode", ({
  enumerable: true,
  get: function () {
    return _util.normalizeUnicode;
  }
}));
Object.defineProperty(exports, "renderTextLayer", ({
  enumerable: true,
  get: function () {
    return _text_layer.renderTextLayer;
  }
}));
Object.defineProperty(exports, "setLayerDimensions", ({
  enumerable: true,
  get: function () {
    return _display_utils.setLayerDimensions;
  }
}));
Object.defineProperty(exports, "shadow", ({
  enumerable: true,
  get: function () {
    return _util.shadow;
  }
}));
Object.defineProperty(exports, "updateTextLayer", ({
  enumerable: true,
  get: function () {
    return _text_layer.updateTextLayer;
  }
}));
Object.defineProperty(exports, "version", ({
  enumerable: true,
  get: function () {
    return _api.version;
  }
}));
var _util = __w_pdfjs_require__(1);
var _api = __w_pdfjs_require__(124);
var _display_utils = __w_pdfjs_require__(168);
var _text_layer = __w_pdfjs_require__(195);
var _annotation_editor_layer = __w_pdfjs_require__(196);
var _tools = __w_pdfjs_require__(165);
var _annotation_layer = __w_pdfjs_require__(198);
var _worker_options = __w_pdfjs_require__(176);
var _xfa_layer = __w_pdfjs_require__(201);
const pdfjsVersion = '3.11.174';
const pdfjsBuild = 'ce8716743';
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=pdf.js.map
},
'pdf/viewer/AnnotationLayerFactory':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class AnnotationLayerFactory {
        constructor(pdfjsViewer) {
            this.pdfjsViewer = pdfjsViewer;
            const eventBus = new this.pdfjsViewer.EventBus();
            this.pdfLinkService = new this.pdfjsViewer.PDFLinkService({
                eventBus,
                externalLinkTarget: this.pdfjsViewer.LinkTarget.BLANK
            });
        }
        createAnnotationLayerBuilder(options) {
            return new this.pdfjsViewer.AnnotationLayerBuilder({
                ...options,
                ...{
                    linkService: this.pdfLinkService,
                    downloadManager: new this.pdfjsViewer.DownloadManager(),
                }
            });
        }
    }
    return AnnotationLayerFactory;
});

},
'doccontrol/viewer/dojo/ViewOptionsToolbar':function(){
define([
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dojo/dom-class',
    'dojo/dom-construct',
    'dojo/on',
    'dojo/topic',
    'dojo/text!./template/ViewOptionsToolbar.html',
    'dijit/_WidgetBase',
    'dijit/form/NumberTextBox',
    'soso/sosox/ejs/_Templated',
    '../FileTypeViewable',
    '../Topics'
], function(
    declare,
    lang,
    domClass,
    domConstruct,
    on,
    topic,
    Template,
    WidgetBase,
    NumberTextBox,
    Templated,
    FileTypeViewable,
    TOPICS
) {
    var ViewOptionsToolbar = function(node) {
        var View = declare([WidgetBase, Templated], {
            eventHandles: [],
            zoom: null,
            templateString: Template,

            destroyRecursive: function() {
                this.inherited(arguments);
                this.eventHandles.forEach(eh => eh.remove());
                this.eventHandles = [];
            },

            postCreate: function() {
                this.inherited(arguments);

                this.zoom = new NumberTextBox({
                    'class': 'sos-form-textfield sos-form-textfield-s sos-form-textfield-with-suffix',
                    intermediateChanges: true
                }, this.zoomInput);

                this._initEvents();

                this._initSubscriptions();
            },

            _initEvents: function () {
                this.eventHandles.push(
                    on(this.zoom, 'keyup', lang.hitch(this, function (key) {
                        if (key.key === "Enter") {
                            topic.publish(TOPICS.DOCUMENT_VIEWER_ZOOM_SPECIFIC, this.zoom.get('value'));
                        }
                    })),
                    on(this.zoom, 'blur', lang.hitch(this, function () {
                        topic.publish(TOPICS.DOCUMENT_VIEWER_ZOOM_SPECIFIC, this.zoom.get('value'));
                    })),
                    on(this.zoomIn, 'click', lang.hitch(this, function () {
                        if (this.zoom.get('value')) {
                            topic.publish(TOPICS.DOCUMENT_VIEWER_ZOOM_IN);
                        }
                    })),
                    on(this.zoomOut, 'click', lang.hitch(this, function () {
                        if (this.zoom.get('value')) {
                            topic.publish(TOPICS.DOCUMENT_VIEWER_ZOOM_OUT);
                        }
                    })),
                    on(this.fitWidth, 'click', lang.hitch(this, function () {
                        if (this.zoom.get('value')) {
                            topic.publish(TOPICS.DOCUMENT_VIEWER_FIT_WIDTH);
                        }
                    })),
                    on(this.fitPage, 'click', lang.hitch(this, function () {
                        if (this.zoom.get('value')) {
                            topic.publish(TOPICS.DOCUMENT_VIEWER_FIT_PAGE);
                        }
                    })),
                    on(this.rotateClockwise, 'click', lang.hitch(this, function () {
                        if (this.zoom.get('value')) {
                            topic.publish(TOPICS.DOCUMENT_VIEWER_ROTATE_CLOCKWISE);
                        }
                    }))
                );
            },

            _initSubscriptions: function() {
                this.own(
                    topic.subscribe(TOPICS.DOCUMENT_VIEWER_ZOOM_VALUE, lang.hitch(this, function(value) {
                        this.zoom.set('value', value, false);
                    }))
                );
            },

            show: function() {
                domClass.remove(this.domNode, 'hidden');
            },

            hide: function() {
                domClass.add(this.domNode, 'hidden');
            }
        });

        this.view = new View({},  domConstruct.create('div', {}, node, 'only'));
    };

    ViewOptionsToolbar.prototype.hide = function() {
        this.view.hide();
    };

    ViewOptionsToolbar.prototype.show = function() {
        this.view.show();
    };

    ViewOptionsToolbar.prototype.destroy = function() {
        this.view.destroyRecursive();
    };

    return ViewOptionsToolbar;
});
},
'doccontrol/viewer/config/LocalStorageDefault':function(){
define(["require", "exports", "./Modes"], function (require, exports, MODES) {
    "use strict";
    const LocalStorageDefault = {
        LINE_WIDTH: 1,
        COLOR: '#000000',
        COLOR_FILLED: false,
        MODE: MODES.DRAG,
        TOOLBAR_STATE: {
            isVerbose: true,
            isUsersExpanded: false,
            isUsersOnlineExpanded: false,
            isDrawExpanded: false,
            isShapesExpanded: false,
            isStampsExpanded: false,
            isColorExpanded: false,
            isLineWidthExpanded: false,
            isLineStyleExpanded: false,
            isDeleteExpanded: false
        },
        LINE_STYLE: {
            solid: true,
            dotted: false,
            dashed: false,
            cloud: false
        }
    };
    return LocalStorageDefault;
});

},
'doccontrol/viewer/model/Factory':function(){
define([
    'api/contact/Config',
    'api/contact/Factory',
    'api/contact/data/Contact',
    'library/request/data/Handlers',
    'library/request/helper/DefaultUnauthorisedCallback',
    'library/request/dojo/URLConnectionProcessorBuilder',
    'library/request/URLConnectionBuilder',
    'library/request/URLResponseProcessorBuilder',
    '../request/Config',
    '../request/AnnotationGenerator',
    '../request/PrintableAnnotationGenerator'
], function(
    ContactConfig,
    ContactFactory,
    ContactVO,
    HandlersVO,
    DefaultUnauthorisedCallback,
    URLConnectionProcessorBuilder,
    URLConnectionBuilder,
    URLResponseProcessorBuilder,
    RequestConfig,
    AnnotationGenerator,
    PrintableAnnotationGenerator
) {
    const Factory = function() {};

    Factory.prototype.getAnnotationGenerator = function() {
        return new AnnotationGenerator(
            (new RequestConfig()).getUrl('service_annotation', 'v2/'),
            (new URLConnectionBuilder(
                new URLConnectionProcessorBuilder()
            )).build(),
            function (successHandler, errorHandler) {
                return function (response) {
                    if (response) {
                        successHandler(JSON.parse(response));
                    } else {
                        errorHandler();
                    }
                };
            }
        );
    };

    Factory.prototype.getPrintableAnnotationGenerator = function() {
        return new PrintableAnnotationGenerator(
            (new RequestConfig()).getUrl('service_annotation', 'v2/'),
            (new URLConnectionBuilder(
                new URLConnectionProcessorBuilder()
            )).build(),
            function (successHandler, errorHandler) {
                return function (response) {
                    if (response) {
                        successHandler(JSON.parse(response));
                    } else {
                        errorHandler();
                    }
                };
            }
        );
    };

    Factory.prototype.getAnnotatedTemporaryDocumentCreator = function() {
        return new AnnotationGenerator(
            (new RequestConfig()).getUrl('service_annotated_temporary_document', 'v2/'),
            (new URLConnectionBuilder(
                new URLConnectionProcessorBuilder()
            )).build(),
            function (successHandler, errorHandler) {
                return function (response) {
                    if (response) {
                        successHandler(JSON.parse(response));
                    } else {
                        errorHandler();
                    }
                };
            }
        );
    };

    Factory.prototype.getUrlConnectionBuilder = function() {
        if (!this.urlConnectionBuilder) {
            this.urlConnectionBuilder = new URLConnectionBuilder(
                new URLConnectionProcessorBuilder()
            );
        }

        return this.urlConnectionBuilder;
    };

    Factory.prototype.getUrlResponseProcessorBuilder = function() {
        if (!this.urlResponseProcessorBuilder) {
            this.urlResponseProcessorBuilder = new URLResponseProcessorBuilder();

        }

        return this.urlResponseProcessorBuilder;
    };

    Factory.prototype.getContactByEmail = function(email) {
        return new Promise((resolve) => {
            (new ContactFactory(
                new ContactConfig(),
                this.getUrlConnectionBuilder(),
                this.getUrlResponseProcessorBuilder()
            )).getContact().getByEmail(
                new HandlersVO(
                    resolve.bind(this),
                    () => {},
                    DefaultUnauthorisedCallback,
                    () => {},
                    () => {}
                ), (new ContactVO).setEmail(email)
            );
        });
    };

    return Factory;
});
},
'doccontrol/viewer/request/Config':function(){
define([
    'api/Config'
], function(requestConfig) {
    const Config = function () {
        this.base = requestConfig;
        this.base();

        this.service_annotation = 'doc-control/annotation';
        this.service_annotated_temporary_document = 'doc-control/annotation/temporary-document';
    };

    Config.prototype = Object.create(requestConfig.prototype);

    return Config;
});

},
'doccontrol/viewer/request/AnnotationGenerator':function(){
define([], function() {
    return class AnnotationGenerator {
        constructor(url, urlConnection, createResponseProcessorCallback) {
            this.url = url;
            this.urlConnection = urlConnection;
            this.createResponseProcessorCallback = createResponseProcessorCallback;
        }

        generate(handlers, md5, annotations, pins) {
            this.urlConnection.setUrl(this.url);
            this.urlConnection.setData(this._formatRequest(md5, annotations, pins));

            this.urlConnection.setSuccessHandler(
                this.createResponseProcessorCallback(handlers.getSuccess(), handlers.getError())
            );
            this.urlConnection.setUnauthorisedHandler(handlers.getUnauthorised());
            this.urlConnection.setProgressHandler(handlers.getProgress());
            this.urlConnection.setErrorHandler(handlers.getError());

            return this.urlConnection.post();
        }

        _formatRequest(md5, annotations, pins) {
            return {
                annotations: JSON.stringify(annotations),
                pins: JSON.stringify(pins),
                md5: md5
            };
        };
    };
});
},
'doccontrol/viewer/request/PrintableAnnotationGenerator':function(){
define(['./AnnotationGenerator'], function(AnnotationGenerator) {
    return class PrintableAnnotationGenerator extends AnnotationGenerator {
        _formatRequest(md5, annotations, pins) {
            const request = super._formatRequest(md5, annotations, pins);

            request.printable = 1;

            return request;
        }
    };
});
},
'library/DojoCookieWrapper':function(){
define([
    'dojo/cookie'
], function(cookie) {
    var DojoCookieWrapper = function() {
    };

    DojoCookieWrapper.prototype.set = function(name, value, options) {
        cookie(name, value, options);
    };

    DojoCookieWrapper.prototype.get = function(name) {
        return cookie(name);
    };

    return DojoCookieWrapper;
});
},
'library/JsonWrapper':function(){
define([
    'dojo/json'
], function(json) {
    var JsonWrapper = function() {};

    JsonWrapper.prototype.stringify = function(data) {
        return json.stringify(data);
    };

    JsonWrapper.prototype.parse = function(string) {
        return json.parse(string);
    };

    return JsonWrapper;
});
},
'spencer/user-config/storage/Local':function(){
define([], function() {
    const EXPIRE_NEVER = 5000;
    const ROOT_PATH = '/';

    const Local = function(defaultConfigs, cookie, json, prefix) {
        this.defaultConfigs = defaultConfigs;
        this.cookie = cookie;
        this.json = json;
        this.prefix = prefix;
    };

    Local.prototype.has = function(setting) {
        if (this.defaultConfigs.hasOwnProperty(setting)) {
            return true;
        }

        let value = this.cookie.get(this.prefix + setting);

        if (value) {
            try {
                let data = this.json.parse(value);

                if (typeof data === 'object' && data.hasOwnProperty('value')) {
                    return true;
                }
            } catch(e) {}
        }
        
        return false;
    };

    Local.prototype.get = function(setting) {
        if (!this.has(setting)) {
            throw new Error('User config setting with name ' + setting + ' not stored via Cookie');
        }

        try {
            return this.json.parse(this.cookie.get(this.prefix + setting)).value;
        } catch(e) {
            return this.defaultConfigs[setting];
        }

    };

    Local.prototype.set = function(setting, value, promise) {
        this.cookie.set(
            this.prefix + setting,
            this.json.stringify({
                value: value
            }),
            {expires: EXPIRE_NEVER, path: ROOT_PATH }
        );

        if (promise) {
            promise.resolve();
        }
    };

    return Local;
});
},
'style-guide/v1/doc-control/registration-details/DocumentRegister/FormPane':function(){
///<amd-dependency path="dojo/text!./template/FormPane.html" name="template" />
///<amd-dependency path="soso/sosox/ejs/_Templated" name="_Templated" />
define(["require", "exports", "dojo/text!./template/FormPane.html", "soso/sosox/ejs/_Templated", "spencer/data-manager/core/definition/Actions", "api/Factory", "style-guide/v1/layout/FormPane", "spencer/parse/BytesToMegabytes", "spencer/data-manager/Builder", "library/request/helper/DefaultUnauthorisedCallback", "doccontrol/extraction/management/DiagnosticTool", "api/project/filter/ExcludeInvisible", "./ExtractedData", "style-guide/v1/forms/FileDragDrop", "spencer/core/filter/Collection", "library/response/error/Forbidden", "library/request/data/Form", "library/request/data/Handlers", "@lib/doc-control/tree/NodeFromPath", "@lib/spencer/format/NodePath", "@lib/doc-control/tree/config/NodeTypes", "style-guide/v1/doc-control/project-node-select/FilteringNodeSelect", "soso/dijit/form/api/project/stage/SearchableSelect", "spencer/format/ProjectStageTitle", "api/project/data/ProjectStage", "style-guide/v1/navigation/ProjectTileContainer", "style-guide/v1/doc-control/registration-details/RegistrationDetails", "api/doccontrol/data/RegistrationDetails", "spencer/data-manager/data/Request", "./SmartRegisterProcessor", "style-guide/v1/doc-control/document/soft-link/Form", "style-guide/v1/doc-control/project-node-select/SuggestedNodeSelect", "@lib/doc-control/tree/data/Node", "dijit/_WidgetBase", "dojo/_base/config", "dojo/_base/declare", "dojo/dom-attr", "dojo/dom-class", "dojo/dom-construct", "dijit/focus", "dojo/html", "dojo/_base/lang", "dojo/on", "dojo/topic"], function (require, exports, template, _Templated, ACTIONS, ApiFactory, BaseFormPane, BytesToMegabytes, DataManagerBuilder, DefaultUnauthorisedCallback, DiagnosticTool, ExcludeInvisibleFilter, ExtractedData, FileDragDrop, FilterCollection, ForbiddenError, FormVO, HandlersVO, NodeFromPath, NodePathFormatter, NODE_TYPES, ProjectNodeFilteringSelect, ProjectStageSearchableSelect, ProjectStageTitleFormat, ProjectStageVO, ProjectTileContainer, RegistrationDetails, RegistrationDetailsVO, RequestData, SmartRegisterProcessor, SoftLinkForm, SuggestedProjectNodeFilteringSelect, TreeNodeVO, _WidgetBase, dojoConfig, dojoDeclare, domAttr, domClass, domConstruct, focusUtil, html, lang, on, topic) {
    "use strict";
    const FORM_PANE_DEFAULT_TITLE = 'Register Document', LOADING_FILE_UPLOAD = 'Uploading file (0%)...', LOADING_TEMPORARY_DOCUMENT = 'Fetching document details...', MAX_FILE_SIZE_BYTES = dojoConfig.uploadMaxFilesize, NOTIFICATION_ERROR_INVALID_FORM = 'Some registration details are invalid. Please address the highlighted errors and try again.', NOTIFICATION_ERROR_FIND_CREATE_FUNCTION_CHILD = 'There was an error when trying to create file location \':node\'. Please contact support for further assistance.', NOTIFICATION_ERROR_NODE_REFERENCE_MISSING = 'Could not register file to the selected location. Enter a \'File Location Reference\' to continue.', NOTIFICATION_ERROR_REGISTRATION_LOCATION_NOT_FOUND = 'There was an error when determining registration location', NOTIFICATION_ERROR_UPLOAD_FAILED = 'Failed to upload document, please try again. If this problem persists, please contact support.', NOTIFICATION_FUNCTION_LOCATION_FINDER_UID = 'Notification_FunctionLocationFinderUid', NOTIFICATION_SUCCESS_REGISTRATION_LOCATION_FOUND = 'Successfully determined registration location';
    class FormPane {
        constructor(properties = {}) {
            const View = FormPane.getView(properties);
            this.view = new View({});
        }
        open() {
            this.view.open();
            return this;
        }
        close() {
            this.view.close();
            return this;
        }
        reset() {
            this.view.reset();
            return this;
        }
        getRegistrationDetails() {
            return this.view.getRegistrationDetails();
        }
        setMyProjectsCollection(projectsCollection) {
            this.view.setMyProjectsCollection(projectsCollection);
            return this;
        }
        setData(data) {
            this.view.setData(data);
            return this;
        }
        setFile(file) {
            this.view.setFile(file);
            return this;
        }
        setCurrentContact(currentContact) {
            this.view.setCurrentContact(currentContact);
            return this;
        }
        allowPrivacyChanges() {
            this.view.allowPrivacyChanges();
            return this;
        }
        setPausableKeyboardShortcutWidgets(widgets) {
            this.view.setPausableKeyboardShortcutWidgets(widgets);
            return this;
        }
        setCallbackOnClose(callback) {
            this.view.setCallbackOnClose(callback);
            return this;
        }
        setCallbackOnRegister(callback) {
            this.view.setCallbackOnRegister(callback);
            return this;
        }
        setCallbackOnQuickRegister(callback) {
            this.view.setCallbackOnQuickRegister(callback);
            return this;
        }
        async validate() {
            return this.view.validate();
        }
        static getView(properties) {
            return dojoDeclare([_WidgetBase, _Templated], {
                allowTreeNodeSuggestions: false,
                privacyChangesAllowed: false,
                cancelledSmartRegistration: false,
                extractionComplete: false,
                settingInitialProjectStage: true,
                data: {},
                currentContact: null,
                templateTreeViewPK: null,
                documentName: null,
                documentViewer: null,
                emailFrom: null,
                formPaneTitle: FORM_PANE_DEFAULT_TITLE,
                fieldCollection: [],
                maxFileSizeBytes: MAX_FILE_SIZE_BYTES,
                dataManager: null,
                fileUploadRequest: null,
                keyboardShortcutWidgetsToReenable: [],
                md5: null,
                myProjectsCollection: [],
                nodeCollection: null,
                pauseableKeyboardShortcutWidgets: [],
                projectOverviewUrl: null,
                projectStagePK: null,
                projectStageTreeViewPK: null,
                requests: [],
                selectedNode: null,
                selectedTemplate: null,
                temporaryDocument: null,
                treeRequest: null,
                treeNodePathRequests: {},
                templateString: template,
                apiFactory: null,
                apiDocumentCollection: null,
                apiFunctionNodeLocationFinder: null,
                apiTemporaryFileUploader: null,
                apiTemplateOrganisationLocationFinder: null,
                apiTreeNodePath: null,
                elementDetectedLocationNotification: null,
                elementDetectedLocationNotificationPath: null,
                elementDiagnosticToolNotification: null,
                elementDiagnosticToolNotificationMessage: null,
                elementDiagnosticTool: null,
                elementErrorMessage: null,
                elementErrorMessageContainer: null,
                elementExtractedData: null,
                elementExtractedDataContainer: null,
                elementFileNameField: null,
                elementFileUploading: null,
                elementFileUploadingText: null,
                elementForbidden: null,
                elementForm: null,
                elementFunctionNodeSelectedNotice: null,
                elementInputProjectNode: null,
                elementLoading: null,
                elementMain: null,
                elementNodeSelectContainer: null,
                elementProjectStageSearchableSelect: null,
                elementProjectStageSelectContainer: null,
                elementProjectStageTitle: null,
                elementProjectTileContainer: null,
                elementRegisterButton: null,
                elementRegistrationDetailsNode: null,
                elementSmartLoading: null,
                elementSmartLoadingText: null,
                elementSoftLinkContainer: null,
                elementSoftLinkAlertDocumentName: null,
                elementSoftLinkAlertLocation: null,
                elementSoftLinkForm: null,
                elementTemplateNotification: null,
                elementTemplateNotificationExtended: null,
                elementTemplateNotificationName: null,
                elementUpload: null,
                elementUploadField: null,
                smartRegisterProcessor: null,
                projectStageTitleFormat: null,
                widgetDiagnosticTool: null,
                widgetExtractedData: null,
                widgetFileDragDrop: null,
                widgetFormPane: null,
                widgetProjectNodeFilteringSelect: null,
                widgetProjectStageSearchableSelect: null,
                widgetProjectTileContainer: null,
                widgetRegistrationDetails: null,
                widgetSoftLinkForm: null,
                callbackOnClose: function () { },
                callbackOnQuickRegister: function (registrationDetails) { },
                callbackOnRegister: function (registrationDetails) { },
                postMixInProperties: function () {
                    this.data.maxFileSizeBytes = this.maxFileSizeBytes;
                    this.data.formPaneTitle = this.formPaneTitle;
                    this.data.currentContact = this.currentContact;
                },
                postCreate: function () {
                    this.initModels();
                    this.initWidgets();
                    if (this.allowFunctionNodeSelection) {
                        this.allowFunctionNodeSelection();
                    }
                    this.initSmartRegisterProcessor();
                    this.initDiagnosticTool();
                },
                open: function () {
                    this.widgetFormPane.set('content', this.domNode);
                    this.disablePauseableKeyboardShortcutWidgets();
                    this.widgetFormPane.open();
                    if (this.nodeCollection) {
                        this.widgetProjectNodeFilteringSelect.setNodeCollection(this.nodeCollection);
                        if (this.projectStageTreeViewPK) {
                            this.widgetProjectNodeFilteringSelect.set('projectStageTreeViewPK', this.projectStageTreeViewPK);
                        }
                        this.showForm();
                    }
                    if (this.widgetProjectStageSearchableSelect.get('value') && !this.nodeCollection) {
                        this.getNodeCollection(this.widgetProjectStageSearchableSelect.get('value').getProjectStagePK());
                    }
                    this.showDocumentViewer();
                    if (!this.md5) {
                        if (this.file) {
                            this.handleFileUpload(this.file);
                        }
                        else {
                            this.showUploadElement();
                        }
                        return;
                    }
                    this.smartRegisterProcessor.start(this.md5)
                        .then(this.applySmartRegisterData.bind(this))
                        .catch(() => { })
                        .finally(() => this.showMain());
                },
                close: function () {
                    this.reset();
                    this.cancelRequests();
                    if (focusUtil.curNode) {
                        focusUtil.curNode.blur();
                    }
                    this.widgetFormPane.set('content', '');
                    this.widgetFormPane.close();
                    if (this.documentViewer) {
                        this.documentViewer.hide();
                    }
                    this.callbackOnClose();
                    this.enablePauseableKeyboardShortcutWidgets();
                },
                reset: function () {
                    this.setRegisterButtonDisabled(true);
                    this.cancelRequests();
                    this.setFormPaneTitle();
                    this.selectedTemplate = null;
                    this.templateTreeViewPK = null;
                    this.documentName = null;
                    this.elementErrorMessage.innerHTML = '';
                    this.elementErrorMessageContainer.className = 'sos-alert-error hide';
                    this.elementUploadField.value = null;
                    this.emailFrom = null;
                    this.extractionComplete = false;
                    this.file = null;
                    this.md5 = null;
                    this.messageId = null;
                    this.folderId = null;
                    this.nodeCollection = null;
                    this.selectedNode = null;
                    this.temporaryDocument = null;
                    if (this.widgetProjectTileContainer) {
                        this.widgetProjectTileContainer.reset();
                    }
                    domClass.add(this.elementExtractedDataContainer, 'hide');
                    this.widgetDiagnosticTool.reset();
                    this.widgetExtractedData.reset();
                    this.cancelledSmartRegistration = false;
                    this.hideDiagnosticToolNotification();
                    this.widgetProjectStageSearchableSelect.reset();
                    this.widgetProjectNodeFilteringSelect.reset();
                    this.widgetFormPane.reset();
                    this.widgetRegistrationDetails.reset();
                    this.widgetFileDragDrop.reset();
                    this.hideDetectedLocationNotification();
                    this.hideForm();
                    this.hideFunctionNodeSelectedNotice();
                    this.hideRegistrationLocation();
                    this.hideSmartLoading();
                    this.hideTemplateNotification();
                    this.hideTree();
                    this.hideUploadElement();
                    this.hideSoftLinkForm();
                },
                allowFunctionNodeSelection: function () {
                    this.widgetProjectNodeFilteringSelect.allowFunctionNodeSelection();
                    return this;
                },
                setMyProjectsCollection: function (myProjectsCollection) {
                    if (!myProjectsCollection.length) {
                        return;
                    }
                    this.myProjectsCollection = myProjectsCollection;
                    this.initProjectTileContainer();
                },
                setData: function (data) {
                    this.settingInitialProjectStage = true;
                    this.md5 = data.md5;
                    this.documentName = data.documentName || data.fileName || data.name || data.title;
                    this.projectStageTreeViewPK = data.projectStageTreeViewPK || null;
                    this.messageId = data.messageId || null;
                    this.folderId = data.folderId || null;
                    html.set(this.elementProjectStageTitle, this.formatProjectStageTitle(data.projectStageNumber, data.projectStageTitle));
                    if (data.date) {
                        this.widgetRegistrationDetails.setDate(data.date);
                    }
                    if (data.originatorContact) {
                        this.widgetRegistrationDetails.setOriginatorContact(data.originatorContact);
                    }
                    if (data.recipientContact) {
                        this.widgetRegistrationDetails.setRecipientContact(data.recipientContact);
                    }
                    if (data.currentContact) {
                        this.currentContact = data.currentContact;
                        this.widgetRegistrationDetails.setCurrentContact(data.currentContact);
                    }
                    this.setFormPaneTitle(this.documentName);
                    if (!this.md5) {
                        domClass.remove(this.elementUpload, 'hide');
                    }
                    else {
                        domClass.add(this.elementUpload, 'hide');
                    }
                    if (data.projectStagePK) {
                        if (this.projectStagePK != data.projectStagePK) {
                            this.projectStagePK = data.projectStagePK;
                            this.nodeCollection = null;
                        }
                        const selectedProjectStage = this.widgetProjectStageSearchableSelect.get('value');
                        if (!selectedProjectStage || selectedProjectStage.getProjectStagePK() !== data.projectStagePK) {
                            this.widgetProjectStageSearchableSelect.setProjectStagePK(data.projectStagePK);
                        }
                        else if (this.widgetProjectNodeFilteringSelect.get('selectedNode')?.getProjectStageTreeViewPK()
                            !== this.projectStageTreeViewPK) {
                            this.widgetProjectNodeFilteringSelect.set('projectStageTreeViewPK', this.projectStageTreeViewPK);
                        }
                    }
                    else {
                        this.projectStagePK = null;
                        this.nodeCollection = null;
                    }
                    this.widgetRegistrationDetails.setRegistrationDetails({
                        md5: this.md5
                    });
                    this.widgetRegistrationDetails.setTitle(this.documentName);
                    if (this.privacyChangesAllowed) {
                        this.widgetRegistrationDetails.allowPrivacyChanges();
                    }
                    this.emailFrom = data.emailFrom;
                },
                setFile: function (file) {
                    this.file = file;
                },
                setCurrentContact: function (currentContact) {
                    this.currentContact = currentContact;
                    this.widgetRegistrationDetails.setCurrentContact(currentContact);
                },
                setProjectStageTreeViewPK(projectStageTreeViewPK) {
                    this.projectStageTreeViewPK = projectStageTreeViewPK;
                },
                allowPrivacyChanges: function () {
                    this.privacyChangesAllowed = true;
                    if (this.widgetRegistrationDetails) {
                        this.widgetRegistrationDetails.allowPrivacyChanges();
                    }
                    return this;
                },
                getRegistrationDetails: function () {
                    let registrationDetails = this.widgetRegistrationDetails.getRegistrationDetails();
                    if (this.widgetExtractedData) {
                        const extractedData = this.widgetExtractedData.getData();
                        if (extractedData.length) {
                            registrationDetails.metadata = extractedData;
                        }
                    }
                    if (this.selectedNode) {
                        registrationDetails.treeViewPK = this.selectedNode.getProjectStageTreeViewPK();
                        registrationDetails.type = this.selectedNode.getType();
                    }
                    if (this.messageId) {
                        registrationDetails.messageId = this.messageId;
                    }
                    if (this.folderId) {
                        registrationDetails.folderId = this.folderId;
                    }
                    return registrationDetails;
                },
                enablePauseableKeyboardShortcutWidgets: function () {
                    this.keyboardShortcutWidgetsToReenable.forEach(widget => widget.enableKeyboardShortcuts());
                    this.keyboardShortcutWidgetsToReenable = [];
                },
                disablePauseableKeyboardShortcutWidgets: function () {
                    this.pauseableKeyboardShortcutWidgets.forEach(widget => {
                        if (widget.areKeyboardShortcutsEnabled()) {
                            this.keyboardShortcutWidgetsToReenable.push(widget);
                            widget.disableKeyboardShortcuts();
                        }
                    });
                },
                initModels: function () {
                    this.apiFactory = new ApiFactory();
                    const apiDocControlFactory = this.apiFactory.getDocControlFactory();
                    this.apiDocumentCollection = apiDocControlFactory.getDocumentCollection();
                    const apiDocControlTreeNodeFactory = this.apiFactory.getDocControlTreeNodeFactory();
                    this.apiTreeNodePath = apiDocControlTreeNodeFactory.getPath();
                    this.apiTemporaryFileUploader = this.apiFactory.getFileFactory().getTemporaryUploader();
                    this.apiTemplateOrganisationLocationFinder = this.apiFactory.getDocControlTemplateFactory().getTemplateOrganisationLocationFinder();
                    this.apiFunctionNodeLocationFinder = apiDocControlTreeNodeFactory.getFunctionNodeLocationFinder();
                    if (!this.dataManager) {
                        this.dataManager = DataManagerBuilder.build();
                    }
                },
                initWidgets: function () {
                    this.initFileUpload();
                    this.initProjectNodeSelect();
                    this.initFormPane();
                    this.initProjectStageSearchableSelect();
                    this.initRegistrationDetails();
                    this.initSoftLinkForm();
                    this.projectStageTitleFormat = new ProjectStageTitleFormat();
                    this.widgetExtractedData = new ExtractedData(this.elementExtractedData);
                },
                initSmartRegisterProcessor: function () {
                    this.smartRegisterProcessor = new SmartRegisterProcessor()
                        .setOnProgressUpdate((md5, processingStep) => {
                        this.hideUploadElement();
                        this.showSmartLoading(processingStep);
                    });
                },
                async applySmartRegisterData(smartRegisterData) {
                    this.selectedTemplate = smartRegisterData.getTemplate();
                    this.templateTreeViewPK = null;
                    this.populateExtractedRegistrationDetails(smartRegisterData);
                    this.prepareExtractedDataWidget(smartRegisterData);
                    const projectStage = smartRegisterData.getProjectStage() ?? this.widgetProjectStageSearchableSelect.get('value');
                    if (projectStage && this.selectedTemplate?.getProjectStageTreeViewPath()) {
                        try {
                            const projectTree = await this.dataManager.request(new RequestData(ACTIONS.TREE, {
                                projectStagePK: projectStage.getProjectStagePK()
                            })).getPromise();
                            const treeNode = NodeFromPath.find(projectTree, smartRegisterData.getTemplate().getProjectStageTreeViewPath(), [NODE_TYPES.HIDDEN, NODE_TYPES.MODULE, NODE_TYPES.TEMPLATE, NODE_TYPES.TEMPLATE_ORG]);
                            if (treeNode) {
                                this.templateTreeViewPK = treeNode.getProjectStageTreeViewPK();
                            }
                        }
                        catch (error) {
                            if (error instanceof ForbiddenError)
                                this.showForbidden();
                        }
                    }
                    else if (this.selectedTemplate?.getProjectStageTreeView()) {
                        this.templateTreeViewPK = this.selectedTemplate.getProjectStageTreeView().getProjectStageTreeViewPK();
                    }
                    else {
                        this.showTemplateNotificationExtended();
                    }
                    if (this.templateTreeViewPK) {
                        this.projectStageTreeViewPK = this.templateTreeViewPK;
                    }
                    if (smartRegisterData.getProjectStage()) {
                        this.widgetProjectStageSearchableSelect.setProjectStagePK(smartRegisterData.getProjectStage().getProjectStagePK());
                    }
                    else {
                        this.widgetProjectNodeFilteringSelect.set('projectStageTreeViewPK', this.projectStageTreeViewPK);
                    }
                    this.displayFunctionNodeNoticeIfApplicable();
                    this.hideSmartLoading();
                },
                populateExtractedRegistrationDetails: function (smartRegisterData) {
                    this.extractedRegistrationDetails = smartRegisterData.getExtractedRegistrationDetails();
                    if (this.widgetProjectNodeFilteringSelect.get('value')) {
                        this.populateRegistrationDetailsWidget(this.extractedRegistrationDetails);
                    }
                },
                prepareExtractedDataWidget: function (smartRegisterData) {
                    this.widgetExtractedData.reset();
                    this.widgetExtractedData.setTemplate(this.selectedTemplate);
                    const fieldCollection = smartRegisterData.getFieldCollection();
                    if (fieldCollection.length > 0) {
                        this.widgetExtractedData.setMd5(this.md5).setFieldCollection(fieldCollection);
                        this.fieldCollection = fieldCollection;
                        domClass.remove(this.elementExtractedDataContainer, 'hide');
                    }
                    this.showSmartNotification();
                    this.extractionComplete = true;
                },
                initDiagnosticTool() {
                    this.widgetDiagnosticTool = new DiagnosticTool((new BytesToMegabytes).convert(MAX_FILE_SIZE_BYTES, true), this.widgetFormPane);
                },
                onDiagnosticToolClick() {
                    this.widgetDiagnosticTool.setTemporaryDocument(this.temporaryDocument);
                    this.widgetDiagnosticTool.open();
                },
                handleFileUpload: function (file) {
                    this.setFormPaneTitle();
                    this.widgetRegistrationDetails.setTitle('');
                    this.showFileUploading(LOADING_FILE_UPLOAD, 0);
                    let name = file.name;
                    this.documentName = name;
                    this.setFormPaneTitle(name);
                    this.widgetRegistrationDetails.setTitle(name);
                    this.widgetRegistrationDetails.setFile(file);
                    this.uploadFile(file);
                },
                cancelFileUpload: function () {
                    if (this.fileUploadRequest) {
                        this.fileUploadRequest.cancel();
                        this.fileUploadRequest = null;
                        this.widgetFileDragDrop.reset();
                        this.setFormPaneTitle();
                        this.hideFileUploading();
                        this.showUploadElement();
                    }
                },
                hasRequirementsToEnableRegisterButton: function () {
                    if (!this.widgetProjectNodeFilteringSelect) {
                        return false;
                    }
                    return !!this.widgetProjectNodeFilteringSelect.get('selectedNode')
                        && this.extractionComplete;
                },
                cancelSmartRegistration() {
                    this.hideDiagnosticToolNotification();
                    this.hideSmartLoading();
                    this.hideTemplateNotification();
                    this.hideTree();
                    this.extractionComplete = true;
                    if (this.widgetProjectStageSearchableSelect.get('value') && this.nodeCollection) {
                        this.showTree();
                        this.showForm();
                    }
                },
                cacheTreeNodePath: function (node) {
                    const key = node.getProjectStagePK() + "-" + node.getProjectStageTreeViewPK();
                    if (this.treeNodePathRequests[key])
                        return;
                    this.treeNodePathRequests[key] = new Promise(resolve => resolve(NodePathFormatter.nodeToString(node)));
                },
                getTreeNodePath: function (node, onSuccess) {
                    const key = node.getProjectStagePK() + "-" + node.getProjectStageTreeViewPK();
                    if (!this.treeNodePathRequests[key]) {
                        this.treeNodePathRequests[key] = new Promise((resolve, reject) => {
                            const request = this.apiTreeNodePath.get(new HandlersVO((treeNodePath) => resolve(treeNodePath), () => { }, DefaultUnauthorisedCallback, () => reject(), () => reject()), node, true);
                            this.requests.push(request);
                        });
                    }
                    this.treeNodePathRequests[key].then((treeNodePath) => onSuccess(treeNodePath), () => this.hideForm());
                },
                onProjectStageFilterChange: async function (projectStage) {
                    if (!this.settingInitialProjectStage) {
                        this.widgetProjectNodeFilteringSelect.reset();
                        let registrationDetails = this.widgetRegistrationDetails.getRegistrationDetails();
                        this.resetRegistrationDetailsWidget();
                        this.widgetRegistrationDetails.setRegistrationDetails(registrationDetails);
                    }
                    if (!projectStage || !projectStage.getProjectStagePK()) {
                        this.projectStagePK = null;
                        this.nodeCollection = null;
                        this.hideTree();
                        return;
                    }
                    if (this.projectStagePK != projectStage.getProjectStagePK() || !this.nodeCollection) {
                        await this.getNodeCollection(projectStage.getProjectStagePK());
                    }
                    else {
                        this.populateNodeListings();
                    }
                    this.projectStagePK = projectStage.getProjectStagePK();
                    const projectStageTitle = this.formatProjectStageTitle(projectStage.getStageNumber(), projectStage.getTitle());
                    html.set(this.elementProjectStageTitle, projectStageTitle);
                    this.settingInitialProjectStage = false;
                    if (this.allowTreeNodeSuggestions) {
                        this.widgetProjectNodeFilteringSelect.populate(this.md5, projectStage.getProjectStagePK());
                    }
                    if (!this.templateTreeViewPK) {
                        if (this.selectedTemplate?.getProjectStageTreeViewPath()) {
                            try {
                                const projectTree = await this.dataManager.request(new RequestData(ACTIONS.TREE, {
                                    projectStagePK: projectStage.getProjectStagePK()
                                })).getPromise();
                                const treeNode = NodeFromPath.find(projectTree, this.selectedTemplate.getProjectStageTreeViewPath(), [NODE_TYPES.HIDDEN, NODE_TYPES.MODULE, NODE_TYPES.TEMPLATE, NODE_TYPES.TEMPLATE_ORG]);
                                if (treeNode) {
                                    this.cacheTreeNodePath(treeNode);
                                    this.templateTreeViewPK = treeNode.getProjectStageTreeViewPK();
                                }
                                else {
                                    this.templateTreeViewPK = null;
                                }
                            }
                            catch (error) {
                                this.templateTreeViewPK = null;
                                if (error instanceof ForbiddenError)
                                    this.showForbidden();
                            }
                        }
                        else if (this.selectedTemplate?.getProjectStageTreeView()) {
                            this.templateTreeViewPK = this.selectedTemplate.getProjectStageTreeView().getProjectStageTreeViewPK();
                        }
                    }
                    if (this.templateTreeViewPK) {
                        this.widgetProjectNodeFilteringSelect.set('projectStageTreeViewPK', this.templateTreeViewPK);
                    }
                    this.populateRegistrationDetailsWidget(this.extractedRegistrationDetails);
                },
                onNodeSelect: function (node) {
                    let registrationDetails = this.widgetRegistrationDetails.getRegistrationDetails();
                    this.resetRegistrationDetailsWidget();
                    this.selectedNode = node;
                    this.projectStageTreeViewPK = null;
                    this.setRegisterButtonDisabled(!this.hasRequirementsToEnableRegisterButton());
                    if (!node)
                        return;
                    this.cacheTreeNodePath(node);
                    this.getTreeNodePath(node, (path) => {
                        if (node.getProjectStageTreeViewPK() === this.templateTreeViewPK) {
                            this.showDetectedLocationNotification(path);
                            return;
                        }
                        this.hideDetectedLocationNotification();
                    });
                    this.widgetRegistrationDetails.enable();
                    this.widgetRegistrationDetails.setRegistrationDetails(lang.mixin({
                        title: this.documentName
                    }, registrationDetails, {
                        md5: this.md5,
                        projectStagePK: node.getProjectStage()?.getProjectStagePK() || node.getProjectStagePK(),
                        treeViewPK: node.getProjectStageTreeViewPK(),
                        type: node.getType(),
                        location: NodePathFormatter.nodeToString(node)
                    }));
                    this.projectStageTreeViewPK = node.getProjectStageTreeViewPK();
                    const selectedProjectStage = this.widgetProjectStageSearchableSelect.get('value');
                    if (selectedProjectStage) {
                        this.showForm();
                    }
                    this.populateRegistrationDetailsWidget(this.extractedRegistrationDetails);
                    this.displayFunctionNodeNoticeIfApplicable();
                },
                displayFunctionNodeNoticeIfApplicable: function () {
                    if (this.selectedNode?.getType() !== NODE_TYPES.FUNCTION) {
                        return this.hideFunctionNodeSelectedNotice();
                    }
                    this.showFunctionNodeSelectedNotice();
                },
                onTreeRequestSuccess: function (projectStageTree) {
                    this.nodeCollection = projectStageTree.getChildren();
                    this.populateNodeListings();
                },
                populateNodeListings: function () {
                    this.showTree();
                    this.showForm();
                    this.widgetProjectNodeFilteringSelect.setNodeCollection(this.nodeCollection);
                    if (this.projectStageTreeViewPK) {
                        this.widgetProjectNodeFilteringSelect.set('projectStageTreeViewPK', this.projectStageTreeViewPK);
                    }
                    // @todo - Rest of this function relates to SOS-35540 - reinstate once that has been addressed
                    return;
                    const projectStage = this.widgetProjectStageSearchableSelect.get('value');
                    const template = this.selectedTemplate;
                    if (!this.templateTreeViewPK || !template || !projectStage) {
                        return;
                    }
                    this.widgetProjectNodeFilteringSelect.showLoading('Finding node...');
                    const request = this.apiTemplateOrganisationLocationFinder.get(new HandlersVO()
                        .setSuccess((node) => {
                        this.selectedNode = node;
                        this.widgetProjectNodeFilteringSelect.hideLoading();
                        this.widgetProjectNodeFilteringSelect.highlight(node);
                    }).setError(() => {
                        this.widgetProjectNodeFilteringSelect.hideLoading();
                    }).setResetContent(() => {
                        this.selectedNode = null;
                        this.widgetProjectNodeFilteringSelect.hideLoading();
                        this.widgetProjectNodeFilteringSelect.setNodeCollection(this.nodeCollection);
                        this.hideDetectedLocationNotification();
                        this.widgetRegistrationDetails.disable();
                    }), template.getTemplatePK(), projectStage.getProjectStagePK(), this.emailFrom);
                    this.requests.push(request);
                },
                setPausableKeyboardShortcutWidgets: function (widgets) {
                    this.pauseableKeyboardShortcutWidgets = widgets;
                },
                setCallbackOnClose(callback) {
                    this.callbackOnClose = callback;
                },
                setCallbackOnRegister(callback) {
                    this.callbackOnRegister = callback;
                },
                setCallbackOnQuickRegister(callback) {
                    this.callbackOnQuickRegister = callback;
                },
                cancelLocationDetected: function () {
                    this.showTemplateNotificationExtended();
                    this.hideForm();
                },
                populateRegistrationDetailsWidget: function (extractedRegistrationDetails) {
                    if (extractedRegistrationDetails?.getRevision())
                        this.widgetRegistrationDetails.setRevision(extractedRegistrationDetails.getRevision());
                    if (extractedRegistrationDetails?.getReference())
                        this.widgetRegistrationDetails.setReference(extractedRegistrationDetails.getReference());
                    if (extractedRegistrationDetails?.getDate())
                        this.widgetRegistrationDetails.setDate(extractedRegistrationDetails.getDate());
                    if (extractedRegistrationDetails?.getTitle())
                        this.widgetRegistrationDetails.setTitle(extractedRegistrationDetails.getTitle());
                    if (extractedRegistrationDetails?.getDisciplineVO())
                        this.widgetRegistrationDetails.setDiscipline(extractedRegistrationDetails.getDisciplineVO().getDrawingDisciplinePK());
                    if (extractedRegistrationDetails?.getStatusVO())
                        this.widgetRegistrationDetails.setStatusCode(extractedRegistrationDetails.getStatusVO().getCode());
                    if (extractedRegistrationDetails?.getNodeReference())
                        this.widgetRegistrationDetails.setNodeReference(extractedRegistrationDetails.getNodeReference());
                },
                cancelRequests: function () {
                    this.cancelTreeRequest();
                    this.cancelSmartRegistration();
                },
                cancelSmartRequests: function () {
                    this.requests.forEach(request => {
                        request.cancel();
                    });
                    this.requests = [];
                    this.cancelledSmartRegistration = true;
                    this.cancelSmartRegistration();
                },
                processUploadedFile: function (file) {
                    this.fileUploadRequest = this.apiDocumentCollection.setFileKeys([file.getKey()]).create(new HandlersVO((temporaryDocuments) => {
                        this.fileUploadRequest = null;
                        this.md5 = temporaryDocuments[0].md5;
                        this.temporaryDocument = temporaryDocuments[0];
                        this.showDocumentViewer();
                        if (this.allowTreeNodeSuggestions && this.widgetProjectStageSearchableSelect.get('value')) {
                            this.widgetProjectNodeFilteringSelect.populate(this.md5, this.widgetProjectStageSearchableSelect.get('value').getProjectStagePK());
                        }
                        this.hideFileUploading();
                        this.smartRegisterProcessor.start(this.md5)
                            .then(this.applySmartRegisterData.bind(this))
                            .catch(() => { })
                            .finally(() => {
                            this.showMain();
                            this.setRegisterButtonDisabled(!this.hasRequirementsToEnableRegisterButton());
                        });
                    }, () => { }, DefaultUnauthorisedCallback, () => {
                        this.showErrorNotification(NOTIFICATION_ERROR_UPLOAD_FAILED);
                        this.reset();
                    }));
                    this.requests.push(this.fileUploadRequest);
                },
                getSelectedNode: function () {
                    return this.selectedNode;
                },
                getProjectStage: function () {
                    return this.widgetProjectStageSearchableSelect.get('value');
                },
                getSelectedLocationString: function () {
                    if (!this.selectedNode) {
                        return;
                    }
                    return this.formatProjectStageTitle(this.selectedNode.getProjectStage().getStageNumber(), this.selectedNode.getProjectStage().getTitle()) + ' / ' + NodePathFormatter.nodeToString(this.selectedNode);
                },
                setFormPaneTitle: function (documentName) {
                    if (!documentName) {
                        this.widgetFormPane.setTitle(this.data.formPaneTitle);
                        return;
                    }
                    if (this.documentViewer && this.md5) {
                        this.widgetFormPane.setTitle(this.data.formPaneTitle + ' - ');
                        this.widgetFormPane.setTitleLink(documentName, this.showDocumentViewer.bind(this), 'sos-icon sos-icon-before sos-icon-eye');
                    }
                    else {
                        this.widgetFormPane.setTitle(this.data.formPaneTitle + ' - <i>' + documentName + '</i>');
                    }
                },
                formatProjectStageTitle: function (projectStageNumber, projectStageTitle) {
                    return this.projectStageTitleFormat
                        .setStageNumber(projectStageNumber)
                        .setTitle(projectStageTitle)
                        .format();
                },
                getNodeCollection: async function (projectStagePK) {
                    this.nodeCollection = null;
                    if (this.widgetProjectNodeFilteringSelect) {
                        this.showLoading();
                        this.cancelTreeRequest();
                        try {
                            this.treeRequest = this.dataManager.request(new RequestData(ACTIONS.TREE, { projectStagePK: projectStagePK }));
                            const projectTree = await this.treeRequest.getPromise();
                            this.onTreeRequestSuccess(projectTree);
                        }
                        catch (error) {
                            if (error instanceof ForbiddenError)
                                this.showForbidden();
                        }
                    }
                },
                cancelTreeRequest: function () {
                    if (this.treeRequest) {
                        this.treeRequest.cancel();
                        this.treeRequest = null;
                    }
                },
                initProjectTileContainer: function () {
                    if (this.widgetProjectTileContainer) {
                        this.projectTileContainerSelectedEventHandle.remove();
                        this.widgetProjectTileContainer.destroyRecursive();
                        this.widgetProjectTileContainer = null;
                    }
                    domConstruct.empty(this.elementProjectTileContainer);
                    this.widgetProjectTileContainer = new ProjectTileContainer({
                        compactMode: true,
                        projectCollection: this.myProjectsCollection
                    }).placeAt(this.elementProjectTileContainer, 'first');
                    this.widgetProjectTileContainer.startup();
                    this.projectTileContainerSelectedEventHandle = this.widgetProjectTileContainer.on('selected', (projectStagePK) => {
                        this.widgetProjectStageSearchableSelect.setProjectStagePK(projectStagePK);
                        this.setRegisterButtonDisabled(true);
                    });
                },
                initProjectStageSearchableSelect: function () {
                    this.widgetProjectStageSearchableSelect = new ProjectStageSearchableSelect({
                        required: false,
                        onChange: this.onProjectStageFilterChange.bind(this),
                        placeholder: 'Select project or general stage...',
                        filterCollection: new FilterCollection().addFilter(new ExcludeInvisibleFilter())
                    }, this.elementProjectStageSearchableSelect);
                },
                initFileUpload: function () {
                    this.widgetFileDragDrop = new FileDragDrop({
                        fileLabel: 'file',
                        uploadLimitMegabytes: (new BytesToMegabytes).convert(MAX_FILE_SIZE_BYTES, true),
                        uploadLimitAttachmentCount: 1,
                        className: 'sos-form-file-drag-drop sos-form-input-stretch',
                        onFileRemoved: this.cancelFileUpload
                    }, this.elementUploadField);
                    on(this.widgetFileDragDrop, 'added', this.handleFileUpload.bind(this));
                    on(this.widgetFileDragDrop, 'reset', this.cancelFileUpload.bind(this));
                },
                initProjectNodeSelect: function () {
                    if (this.allowTreeNodeSuggestions) {
                        this.widgetProjectNodeFilteringSelect = new SuggestedProjectNodeFilteringSelect({
                            onNodeSelect: this.onNodeSelect.bind(this)
                        }, this.elementInputProjectNode);
                        return;
                    }
                    this.widgetProjectNodeFilteringSelect = new ProjectNodeFilteringSelect({
                        onNodeSelect: this.onNodeSelect.bind(this)
                    }, this.elementInputProjectNode);
                },
                resetRegistrationDetailsWidget: function () {
                    const ocd = this.widgetRegistrationDetails.getOriginatorContact();
                    const rcd = this.widgetRegistrationDetails.getRecipientContact();
                    this.widgetRegistrationDetails.reset();
                    this.widgetRegistrationDetails.setOriginatorContact(ocd);
                    this.widgetRegistrationDetails.setRecipientContact(rcd);
                },
                initRegistrationDetails: function () {
                    this.widgetRegistrationDetails = new RegistrationDetails({
                        currentContact: this.currentContact,
                        privacyChangesAllowed: this.privacyChangesAllowed,
                        documentViewer: this.documentViewer,
                        setRegisterButtonDisabled: this.setRegisterButtonDisabled.bind(this),
                        projectOverviewUrl: this.projectOverviewUrl
                    }, this.elementRegistrationDetailsNode);
                },
                initFormPane: function () {
                    this.widgetFormPane = new BaseFormPane({
                        parentForm: this.widgetFormPane,
                        title: this.data.formPaneTitle,
                        icon: 'sos-icon-folder-open',
                        width: 40,
                        onClose: () => {
                            this.callbackOnClose();
                            this.close();
                        }
                    });
                },
                initSoftLinkForm: function () {
                    this.widgetSoftLinkForm = new SoftLinkForm(this.apiFactory.getDocControlDocumentRevisionFactory().getLatest(), this.apiFactory.getDocControlDocumentTreeFactory().getNode(), this.apiFactory.getDocControlTreeNodeFactory().getPath(), this.apiFactory.getProjectStageFactory().getProjectStage(), this.apiFactory.getDocControlFactory().getTree(), this.apiFactory.getDocControlDocumentFactory().getSoftLink(), () => {
                        this.close();
                    });
                    this.widgetSoftLinkForm.setLocationClickCallback(() => {
                        this.close();
                    });
                    this.widgetSoftLinkForm.placeAt(this.elementSoftLinkForm);
                },
                validate: function () {
                    return new Promise((resolve, reject) => {
                        if (!this.widgetRegistrationDetails.isValid()) {
                            this.showErrorNotification(NOTIFICATION_ERROR_INVALID_FORM);
                            return reject();
                        }
                        resolve();
                    });
                },
                validateFunctionNode: function () {
                    return new Promise((resolve, reject) => {
                        if (this.selectedNode?.getType() !== NODE_TYPES.FUNCTION) {
                            return resolve(null);
                        }
                        const nodeReference = this.widgetRegistrationDetails.getRegistrationDetails()?.nodeReference;
                        if (!nodeReference) {
                            this.showErrorNotification(NOTIFICATION_ERROR_NODE_REFERENCE_MISSING);
                            return reject();
                        }
                        this.setRegisterButtonDisabled(true);
                        topic.publish('sos-system-notification-progress', 'Determining registration location...', NOTIFICATION_FUNCTION_LOCATION_FINDER_UID);
                        const request = this.apiFunctionNodeLocationFinder.get(new HandlersVO().setSuccess((node) => {
                            this.selectedNode = node;
                            topic.publish('sos-system-notification-progress-complete', NOTIFICATION_FUNCTION_LOCATION_FINDER_UID, NOTIFICATION_SUCCESS_REGISTRATION_LOCATION_FOUND, 'success', 3000);
                            resolve(node);
                        }).setError((e) => {
                            console.error(e);
                            this.showErrorNotification(NOTIFICATION_ERROR_FIND_CREATE_FUNCTION_CHILD.replace(':node', nodeReference));
                            this.setRegisterButtonDisabled(false);
                            topic.publish('sos-system-notification-progress-complete', NOTIFICATION_FUNCTION_LOCATION_FINDER_UID, NOTIFICATION_ERROR_REGISTRATION_LOCATION_NOT_FOUND, 'error');
                            reject();
                        }).setResetContent(() => {
                            this.selectedNode = null;
                            this.widgetProjectNodeFilteringSelect.unhighlight();
                            this.setRegisterButtonDisabled(false);
                            topic.publish('sos-system-notification-progress-complete', NOTIFICATION_FUNCTION_LOCATION_FINDER_UID, NOTIFICATION_ERROR_REGISTRATION_LOCATION_NOT_FOUND, 'error');
                            reject();
                        }).setAbort(reject), this.widgetProjectStageSearchableSelect.get('value').getProjectStagePK(), this.selectedNode.getProjectStageTreeViewPK(), nodeReference);
                        this.requests.push(request);
                    });
                },
                onRegisterClick: async function () {
                    this.setRegisterButtonDisabled(true);
                    const registrationDetails = this.widgetRegistrationDetails.getRegistrationDetails();
                    try {
                        await this.validate();
                        await this.validateFunctionNode().then((node) => {
                            if (node) {
                                registrationDetails.treeViewPK = node.getProjectStageTreeViewPK();
                                registrationDetails.type = node.getType();
                            }
                        });
                        this.callbackOnRegister(this.registrationDetailsToApiVO(registrationDetails));
                    }
                    catch (e) {
                        this.setRegisterButtonDisabled(false);
                    }
                },
                onQuickRegisterClick: function () {
                    const registrationDetails = this.getRegistrationDetails();
                    registrationDetails.quickRegister = true;
                    this.callbackOnQuickRegister(this.registrationDetailsToApiVO(registrationDetails));
                },
                registrationDetailsToApiVO: function (details) {
                    const registrationDetails = new RegistrationDetailsVO()
                        .setMd5(this.md5)
                        .setTreeViewPK(details.treeViewPK)
                        .setType(details.type)
                        .setPersonPK(details.personPK)
                        .setBranchOfficePK(details.branchOfficePK)
                        .setRecipientContact(details.recipientContact)
                        .setTitle(details.title)
                        .setDate(details.date)
                        .setIsPrivate(details.isPrivate)
                        .setDiscipline(details.discipline)
                        .setRevision(details.revision)
                        .setReference(details.reference)
                        .setStatus(details.status)
                        .setLocation(details.location)
                        .setProjectStagePK(details.projectStagePK)
                        .setQuickRegister(details.quickRegister);
                    if (!registrationDetails.getProjectStagePK()) {
                        registrationDetails.setProjectStagePK(this.widgetProjectStageSearchableSelect.get('value').getProjectStagePK());
                    }
                    if (this.widgetExtractedData) {
                        const extractedData = this.widgetExtractedData.getData();
                        if (extractedData.length) {
                            details.metadata = extractedData;
                        }
                    }
                    return registrationDetails;
                },
                uploadFile: function (file) {
                    this.fileUploadRequest = this.apiTemporaryFileUploader.upload(new HandlersVO((files) => {
                        if (files[0].isRegistered()) {
                            this.md5 = files[0].md5;
                            this.showSoftLinkForm();
                            this.widgetSoftLinkForm.setDocumentPK(files[0].documentPK);
                            this.widgetSoftLinkForm.reload();
                            this.widgetSoftLinkForm.setMd5(this.md5);
                            this.showDocumentViewer();
                            if (this.projectStagePK) {
                                this.widgetSoftLinkForm.setProjectStage(new ProjectStageVO().setProjectStagePK(this.projectStagePK));
                            }
                            if (this.projectStageTreeViewPK) {
                                this.widgetSoftLinkForm.setNode(new TreeNodeVO().setProjectStageTreeViewPK(this.projectStageTreeViewPK));
                            }
                        }
                        else {
                            this.showFileUploading(LOADING_TEMPORARY_DOCUMENT);
                            this.processUploadedFile(files[0]);
                        }
                    }, (loaded, total) => {
                        this.showFileUploading(LOADING_FILE_UPLOAD, Math.round((loaded / total) * 100));
                    }, DefaultUnauthorisedCallback), (new FormVO())
                        .setId('documentRegister')
                        .setFileKey('uploadedFiles')
                        .setFiles([file]));
                },
                showDocumentViewer: function () {
                    if (this.documentViewer && this.md5) {
                        this.documentViewer.setMd5(this.md5);
                        this.documentViewer.initInline();
                        this.documentViewer.execute();
                    }
                },
                setRegisterButtonDisabled: function (disabled) {
                    domAttr.set(this.elementRegisterButton, 'disabled', disabled);
                },
                showForm: function () {
                    domClass.add(this.elementLoading, 'hide');
                    domClass.add(this.elementForbidden, 'hide');
                    domClass.remove(this.elementForm, 'hide');
                    this.setRegisterButtonDisabled(!this.hasRequirementsToEnableRegisterButton());
                },
                showForbidden: function () {
                    domClass.add(this.elementLoading, 'hide');
                    domClass.add(this.elementForm, 'hide');
                    domClass.remove(this.elementForbidden, 'hide');
                },
                showLoading: function () {
                    domClass.add(this.elementForm, 'hide');
                    domClass.add(this.elementForbidden, 'hide');
                    domClass.remove(this.elementLoading, 'hide');
                },
                hideUploadElement: function () {
                    domClass.add(this.elementUpload, 'hide');
                },
                showUploadElement: function () {
                    domClass.add(this.elementMain, 'hide');
                    domClass.remove(this.elementUpload, 'hide');
                },
                hideTree: function () {
                    domClass.add(this.elementForm, 'hide');
                    domClass.add(this.elementLoading, 'hide');
                    domClass.add(this.elementNodeSelectContainer, 'hide');
                    domClass.add(this.elementForbidden, 'hide');
                },
                showTree: function () {
                    domClass.remove(this.elementNodeSelectContainer, 'hide');
                    this.widgetProjectNodeFilteringSelect.scrollToSelected();
                },
                showMain: function () {
                    domClass.remove(this.elementMain, 'hide');
                    domClass.add(this.elementFileUploading, 'hide');
                    domClass.add(this.elementSmartLoading, 'hide');
                    domClass.add(this.elementUpload, 'hide');
                    this.widgetProjectNodeFilteringSelect.scrollToSelected();
                },
                showFileUploading: function (text, percent) {
                    if (percent)
                        text = text.replace('0', percent.toString());
                    this.elementFileUploadingText.innerHTML = text;
                    domClass.add(this.elementUpload, 'hide');
                    domClass.add(this.elementMain, 'hide');
                    domClass.remove(this.elementFileUploading, 'hide');
                },
                hideFileUploading: function () {
                    domClass.add(this.elementFileUploading, 'hide');
                    domClass.remove(this.elementMain, 'hide');
                },
                showSmartLoading: function (text) {
                    this.elementSmartLoadingText.innerHTML = text;
                    domClass.add(this.elementMain, 'hide');
                    domClass.remove(this.elementSmartLoading, 'hide');
                },
                hideSmartLoading: function () {
                    domClass.add(this.elementSmartLoading, 'hide');
                    domClass.remove(this.elementMain, 'hide');
                    this.setRegisterButtonDisabled(!this.hasRequirementsToEnableRegisterButton());
                },
                hideRegistrationLocation: function () {
                    domClass.add(this.elementMain, 'hide');
                },
                hideTemplateNotification: function () {
                    domClass.add(this.elementTemplateNotification, 'hide');
                    domClass.add(this.elementTemplateNotificationExtended, 'hide');
                },
                showTemplateNotificationExtended: function () {
                    domClass.remove(this.elementTemplateNotificationExtended, 'hide');
                },
                showSmartNotification: function () {
                    if (!this.selectedTemplate) {
                        return;
                    }
                    this.elementTemplateNotificationName.innerHTML = this.selectedTemplate.getName();
                    domClass.remove(this.elementTemplateNotification, 'hide');
                },
                hideForm: function () {
                    domClass.add(this.elementForm, 'hide');
                },
                hideFunctionNodeSelectedNotice: function () {
                    domClass.add(this.elementFunctionNodeSelectedNotice, 'hide');
                },
                showFunctionNodeSelectedNotice: function () {
                    domClass.remove(this.elementFunctionNodeSelectedNotice, 'hide');
                },
                showErrorNotification: function (message) {
                    topic.publish('sos-system-notification', message, 'error', 3000);
                },
                hideDetectedLocationNotification: function () {
                    domClass.add(this.elementDetectedLocationNotification, 'hide');
                },
                showDetectedLocationNotification: function (path) {
                    this.elementDetectedLocationNotificationPath.innerHTML = path;
                    domClass.remove(this.elementDetectedLocationNotification, 'hide');
                },
                showDiagnosticToolNotification: function (message) {
                    if (this.temporaryDocument) {
                        this.elementDiagnosticToolNotificationMessage.innerHTML = message;
                        domClass.remove(this.elementDiagnosticToolNotification, 'hide');
                    }
                },
                hideDiagnosticToolNotification: function () {
                    this.elementDiagnosticToolNotificationMessage.innerHTML = '';
                    domClass.add(this.elementDiagnosticToolNotification, 'hide');
                },
                showSoftLinkForm: function () {
                    domClass.remove(this.elementSoftLinkContainer, 'hide');
                    domClass.add(this.elementMain, 'hide');
                    domClass.add(this.elementFileUploading, 'hide');
                    domClass.add(this.elementSmartLoading, 'hide');
                    domClass.add(this.elementUpload, 'hide');
                },
                hideSoftLinkForm: function () {
                    domClass.add(this.elementSoftLinkContainer, 'hide');
                },
                ...properties
            });
        }
    }
    return FormPane;
});

},
'spencer/data-manager/Builder':function(){
///<amd-dependency path="library/DojoObjectMerger" name="ObjectMerger" />
///<amd-dependency path="library/Lang" name="Lang" />
///<amd-dependency path="spencer/data-manager/core/request/ActionContainer" name="ActionContainer" />
///<amd-dependency path="spencer/data-manager/core/request/URLConfig" name="URLConfig" />
///<amd-dependency path="spencer/data-manager/core/request/URLParams" name="URLParams" />
///<amd-dependency path="spencer/data-manager/core/storage/web/SupportedEntities" name="SupportedEntities" />
///<amd-dependency path="spencer/data-manager/log/NullLogger" name="Logger" />
///<amd-dependency path="spencer/data-manager/Manager" name="Manager" />
///<amd-dependency path="spencer/data-manager/request/URLConnectionBuilderFactory" name="URLConnectionBuilderFactory" />
///<amd-dependency path="spencer/data-manager/storage/KeyGenerator" name="KeyGenerator" />
///<amd-dependency path="spencer/data-manager/storage/local-forage/Store" name="Store" />
///<amd-dependency path="spencer/data-manager/utility/UniqueID" name="UniqueID" />
///<amd-dependency path="vendor/localforage/dist/localforage" name="localForage" />
define(["require", "exports", "library/DojoObjectMerger", "library/Lang", "spencer/data-manager/core/request/ActionContainer", "spencer/data-manager/core/request/URLConfig", "spencer/data-manager/core/request/URLParams", "spencer/data-manager/core/storage/web/SupportedEntities", "spencer/data-manager/log/NullLogger", "spencer/data-manager/Manager", "spencer/data-manager/request/URLConnectionBuilderFactory", "spencer/data-manager/storage/KeyGenerator", "spencer/data-manager/storage/local-forage/Store", "spencer/data-manager/utility/UniqueID", "vendor/localforage/dist/localforage", "./core/Config", "library/PromiseFactory"], function (require, exports, ObjectMerger, Lang, ActionContainer, URLConfig, URLParams, SupportedEntities, Logger, Manager, URLConnectionBuilderFactory, KeyGenerator, Store, UniqueID, localForage, CONFIG, PromiseFactory) {
    "use strict";
    class Builder {
        static build() {
            const pf = new PromiseFactory();
            const om = new ObjectMerger();
            return new Manager(CONFIG, {}, pf, new ActionContainer(pf, new URLConnectionBuilderFactory(), URLConfig, URLParams), new Store(localForage, pf, new KeyGenerator(SupportedEntities, Builder.STORAGE_UID)), new Lang(), om, new UniqueID(), new Logger());
        }
    }
    Builder.STORAGE_UID = 'core_data_manager';
    return Builder;
});

},
'library/DojoObjectMerger':function(){
define([
    'dojo/_base/lang'
], function(lang) {
    var DojoObjectMerger = function() {
    };

    DojoObjectMerger.prototype.merge = function(object, properties) {
        lang.mixin(object, properties);
        return object;
    };

    return DojoObjectMerger
});
},
'spencer/data-manager/core/request/ActionContainer':function(){
define([
    '../definition/Actions',
    '../request/action/Address/CountryCollection',
    '../request/action/Address/CountyCollection',
    '../request/action/Client/SelectedFromCollection',
    '../request/action/CollectionFactory',
    '../request/action/Contact',
    '../request/action/Contact/Collection',
    '../request/action/Contract/ConditionCollection',
    '../request/action/Contract/TypeCollection',
    '../request/action/Dms/Stage/TreeTemplateCollection',
    '../request/action/Document/BulkRegister',
    '../request/action/Document/Latest',
    '../request/action/Document/Location',
    '../request/action/Document/Favourite',
    '../request/action/Document/Favourite/Create',
    '../request/action/Document/Favourite/Remove',
    '../request/action/Document/Revision/Search',
    '../request/action/Document/Revision/SetLatest',
    './action/Document/Revision/RevisionNumber',
    '../request/action/Document/Upload',
    '../request/action/File/Preview',
    '../request/action/File/Upload',
    '../request/action/Group/IsMemberOf',
    '../request/action/MemberCollection',
    '../request/action/Organisation/Branch-Office/Collection',
    '../request/action/Organisation/Collection',
    '../request/action/Organisation/IntranetOwnerCollection',
    '../request/action/Organisation/PersonCollection',
    '../request/action/Person',
    '../request/action/Person/Self',
    '../request/action/CreateProject',
    '../request/action/Project/Collection',
    '../request/action/Project/Edit',
    '../request/action/Project/general-stage/Create',
    '../request/action/Project/Project',
    '../request/action/Project/SaveEstimatedDates',
    '../request/action/Project/Site/CreateSite',
    '../request/action/Project/Site/Document/Collection',
    '../request/action/Project/Site/Document/DeleteDocument',
    '../request/action/Project/Site/Edit',
    '../request/action/Project/Site/Collection',
    '../request/action/Project/Stage/Budget/StatusCollection',
    '../request/action/Project/Stage/Budget',
    '../request/action/Project/Stage/Contract',
    '../request/action/Project/Stage/Lead',
    '../request/action/Project/Stage/Prequal',
    '../request/action/Project/Stage/TenderOffer',
    '../request/action/Project/Stage/Tender',
    '../request/action/Project/Stage/Intelligence',
    '../request/action/Project/Stage/CreateBudget',
    '../request/action/Project/Stage/CreateContract',
    '../request/action/Project/Stage/CreateIntelligence',
    '../request/action/Project/Stage/CreateLead',
    '../request/action/Project/Stage/CreateTender',
    '../request/action/Project/Stage/LeadTeam',
    '../request/action/Project/Stage/LeadTeamCollection',
    '../request/action/Project/Stage/CreatePrequal',
    '../request/action/Project/Stage/CreateTenderOffer',
    '../request/action/Project/Stage/Node',
    '../request/action/Project/Stage/NumberRangeCollection',
    '../request/action/Project/Stage/Prequal/ForCollection',
    '../request/action/Project/Stage/ProjectStage',
    '../request/action/Project/Stage/SaveBudget',
    '../request/action/Project/Stage/SaveContract',
    '../request/action/Project/Stage/SaveLead',
    '../request/action/Project/Stage/SavePrequal',
    '../request/action/Project/Stage/SaveTenderOffer',
    '../request/action/Project/Stage/SaveTender',
    '../request/action/Project/Stage/SaveIntelligence',
    '../request/action/Project/Stage/TypeCollection',
    '../request/action/Project/TenderTypeCollection',
    '../request/action/Team/Collection',
    '../request/action/Tree',
    'library/request/fetch/Factory',
    'library/request/FormDataWrapper'
], function(
    ACTIONS,
    CountryCollection,
    CountyCollection,
    ClientSelectedFromCollection,
    CollectionFactory,
    Contact,
    ContactCollection,
    ContractConditionCollection,
    ContractTypeCollection,
    TreeTemplateCollection,
    DocumentBulkRegister,
    DocumentLatest,
    DocumentLocation,
    FavouriteDocumentGet,
    FavouriteDocumentCreate,
    FavouriteDocumentRemove,
    DocumentRevisionSearch,
    DocumentRevisionSetLatest,
    DocumentRevisionNumber,
    DocumentUpload,
    FilePreview,
    FileUpload,
    IsMemberOfGroup,
    MemberCollection,
    OrganisationBranchOfficeCollection,
    OrganisationCollection,
    IntranetOwnerCollection,
    OrganisationPersonCollection,
    Person,
    PersonSelf,
    CreateProject,
    ProjectCollection,
    EditProject,
    CreateGeneralStage,
    Project,
    SaveEstimatedProjectDates,
    CreateProjectSite,
    ProjectSiteDocumentCollection,
    ProjectSiteDocumentDelete,
    EditProjectSite,
    ProjectSiteCollection,
    ProjectStageBudgetStatusCollection,
    ProjectStageBudget,
    ProjectStageContract,
    ProjectStageLead,
    ProjectStagePrequal,
    ProjectStageTenderOffer,
    ProjectStageTender,
    ProjectStageIntelligence,
    ProjectStageCreateBudget,
    ProjectStageCreateContract,
    ProjectStageCreateIntelligence,
    ProjectStageCreateLead,
    ProjectStageCreateTender,
    ProjectStageLeadTeam,
    ProjectStageLeadTeamCollection,
    ProjectStageCreatePrequal,
    ProjectStageCreateTenderOffer,
    ProjectStageNode,
    ProjectStageNumberRangeCollection,
    ProjectStagePrequalForCollection,
    ProjectStage,
    SaveBudgetStage,
    SaveContractStage,
    SaveLeadStage,
    SavePrequalStage,
    SaveTenderOfferStage,
    SaveTenderStage,
    SaveIntelligenceStage,
    TypeCollection,
    ProjectTenderTypeCollection,
    TeamCollection,
    Tree,
    FetchFactory,
    FormDataWrapper
) {
    const ERROR_UNSUPPORTED_ACTION = 'Unsupported data management action: ';
    const SUPPORTED_ACTIONS = [
        ACTIONS.ADDRESS_COUNTRY,
        ACTIONS.ADDRESS_COUNTY,
        ACTIONS.CLIENT_SELECTED_FROM_COLLECTION,
        ACTIONS.CONTACT,
        ACTIONS.CONTACT_COLLECTION,
        ACTIONS.CONTRACT_CONDITION_COLLECTION,
        ACTIONS.CONTRACT_TYPE_COLLECTION,
        ACTIONS.CREATE_BUDGET_STAGE,
        ACTIONS.CREATE_CONTRACT_STAGE,
        ACTIONS.CREATE_DOCUMENT_FAVOURITE,
        ACTIONS.CREATE_GENERAL_STAGE,
        ACTIONS.CREATE_INTELLIGENCE_STAGE,
        ACTIONS.CREATE_LEAD_STAGE,
        ACTIONS.CREATE_PREQUAL_STAGE,
        ACTIONS.CREATE_PROJECT,
        ACTIONS.CREATE_PROJECT_SITE,
        ACTIONS.CREATE_TENDER_OFFER_STAGE,
        ACTIONS.CREATE_TENDER_STAGE,
        ACTIONS.DOCUMENT_BULK_REGISTER,
        ACTIONS.DOCUMENT_LOCATION,
        ACTIONS.DOCUMENT_REVISION_SEARCH,
        ACTIONS.DOCUMENT_REVISION_SET_LATEST,
        ACTIONS.DOCUMENT_REVISION_NUMBER,
        ACTIONS.DOCUMENT_UPLOAD,
        ACTIONS.EDIT_PROJECT,
        ACTIONS.EDIT_PROJECT_SITE,
        ACTIONS.FAVOURITE_DOCUMENT_GET,
        ACTIONS.FILE_PREVIEW,
        ACTIONS.FILE_UPLOAD,
        ACTIONS.GROUP_COLLECTION,
        ACTIONS.GROUP_IS_MEMBER_OF,
        ACTIONS.GROUP_MEMBER_COLLECTION,
        ACTIONS.DOCUMENT_LATEST,
        ACTIONS.LEAD_TEAM,
        ACTIONS.LEAD_TEAM_COLLECTION,
        ACTIONS.MY_GROUP_COLLECTION,
        ACTIONS.MY_GROUP_MEMBER_COLLECTION,
        ACTIONS.ORGANISATION_BRANCH_OFFICE_COLLECTION,
        ACTIONS.ORGANISATION_COLLECTION,
        ACTIONS.ORGANISATION_INTRANET_OWNER_COLLECTION,
        ACTIONS.ORGANISATION_PERSON_COLLECTION,
        ACTIONS.PERSON,
        ACTIONS.PERSON_SELF,
        ACTIONS.PROJECT,
        ACTIONS.PROJECT_COLLECTION,
        ACTIONS.PROJECT_SITE_COLLECTION,
        ACTIONS.PROJECT_SITE_DOCUMENT_COLLECTION,
        ACTIONS.PROJECT_SITE_DOCUMENT_DELETE,
        ACTIONS.PROJECT_STAGE,
        ACTIONS.PROJECT_STAGE_BUDGET,
        ACTIONS.PROJECT_STAGE_BUDGET_STATUS_COLLECTION,
        ACTIONS.PROJECT_STAGE_COLLECTION,
        ACTIONS.PROJECT_STAGE_CONTRACT,
        ACTIONS.PROJECT_STAGE_LEAD,
        ACTIONS.PROJECT_STAGE_PREQUAL,
        ACTIONS.PROJECT_STAGE_TENDER_OFFER,
        ACTIONS.PROJECT_STAGE_TENDER,
        ACTIONS.PROJECT_STAGE_INTELLIGENCE,
        ACTIONS.PROJECT_STAGE_MEMBER_COLLECTION,
        ACTIONS.PROJECT_STAGE_NODE,
        ACTIONS.PROJECT_STAGE_NUMBER_RANGE_COLLECTION,
        ACTIONS.PROJECT_STAGE_PREQUAL_FOR_COLLECTION,
        ACTIONS.PROJECT_STAGE_TYPE_COLLECTION,
        ACTIONS.PROJECT_TENDER_TYPE_COLLECTION,
        ACTIONS.REMOVE_DOCUMENT_FAVOURITE,
        ACTIONS.SAVE_BUDGET_STAGE,
        ACTIONS.SAVE_ESTIMATED_PROJECT_DATES,
        ACTIONS.SAVE_CONTRACT_STAGE,
        ACTIONS.SAVE_LEAD_STAGE,
        ACTIONS.SAVE_PREQUAL_STAGE,
        ACTIONS.SAVE_TENDER_OFFER_STAGE,
        ACTIONS.SAVE_TENDER_STAGE,
        ACTIONS.SAVE_INTELLIGENCE_STAGE,
        ACTIONS.TEAM_COLLECTION,
        ACTIONS.TREE,
        ACTIONS.TREE_TEMPLATE_COLLECTION
    ];

    return class ActionContainer {
        constructor(promiseFactory, urlConnectionBuilderFactory, URL_CONFIG, URL_PARAMS) {
            this.promiseFactory = promiseFactory;
            this.urlConnectionBuilderFactory = urlConnectionBuilderFactory;
            this.urlConfig = URL_CONFIG;
            this.urlParams = URL_PARAMS;
            this.fetchFactory = new FetchFactory();
            this.collectionFactory = new CollectionFactory();
            this.actions = {};

            this._setupActions();
        }

        has(requestData) {
            return SUPPORTED_ACTIONS.indexOf(requestData.getAction()) >= 0;
        }

        get(requestData) {
            if (!this.has(requestData)) {
                throw ERROR_UNSUPPORTED_ACTION + requestData.getAction();
            }

            return this.actions[requestData.getAction()](requestData);
        }

        _setupActions() {
            this.actions[ACTIONS.ADDRESS_COUNTRY] = this._createCountryCollection.bind(this);
            this.actions[ACTIONS.ADDRESS_COUNTY] = this._createCountyCollection.bind(this);
            this.actions[ACTIONS.CLIENT_SELECTED_FROM_COLLECTION] = this._createClientSelectedFromCollection.bind(this);
            this.actions[ACTIONS.CONTACT] = this._createContact.bind(this);
            this.actions[ACTIONS.CONTACT_COLLECTION] = this._createContactCollection.bind(this);
            this.actions[ACTIONS.CONTRACT_CONDITION_COLLECTION] = this._createContractConditionCollection.bind(this);
            this.actions[ACTIONS.CONTRACT_TYPE_COLLECTION] = this._createContractTypeCollection.bind(this);
            this.actions[ACTIONS.CREATE_BUDGET_STAGE] = this._createProjectStageCreateBudgetStage.bind(this);
            this.actions[ACTIONS.CREATE_CONTRACT_STAGE] = this._createProjectStageCreateContractStage.bind(this);
            this.actions[ACTIONS.CREATE_DOCUMENT_FAVOURITE] = this._createFavouriteDocumentCreate.bind(this);
            this.actions[ACTIONS.CREATE_GENERAL_STAGE] = this._createGeneralStage.bind(this);
            this.actions[ACTIONS.CREATE_INTELLIGENCE_STAGE] = this._createProjectStageCreateIntelligenceStage.bind(this);
            this.actions[ACTIONS.CREATE_LEAD_STAGE] = this._createProjectStageCreateLeadStage.bind(this);
            this.actions[ACTIONS.CREATE_PREQUAL_STAGE] = this._createProjectStageCreatePrequalStage.bind(this);
            this.actions[ACTIONS.CREATE_PROJECT] = this._createCreateProject.bind(this);
            this.actions[ACTIONS.CREATE_PROJECT_SITE] = this._createProjectSite.bind(this);
            this.actions[ACTIONS.CREATE_TENDER_OFFER_STAGE] = this._createTenderOfferStage.bind(this);
            this.actions[ACTIONS.CREATE_TENDER_STAGE] = this._createProjectStageCreateTenderStage.bind(this);
            this.actions[ACTIONS.DOCUMENT_BULK_REGISTER] = this._createDocumentBulkRegister.bind(this);
            this.actions[ACTIONS.DOCUMENT_LATEST] = this._createDocumentLatest.bind(this);
            this.actions[ACTIONS.DOCUMENT_LOCATION] = this._createDocumentLocation.bind(this);
            this.actions[ACTIONS.DOCUMENT_REVISION_SEARCH] = this._createDocumentRevisionSearch.bind(this);
            this.actions[ACTIONS.DOCUMENT_REVISION_SET_LATEST] = this._createDocumentRevisionSetLatest.bind(this);
            this.actions[ACTIONS.DOCUMENT_REVISION_NUMBER] = this._createDocumentRevisionNumber.bind(this);
            this.actions[ACTIONS.DOCUMENT_UPLOAD] = this._createDocumentUpload.bind(this);
            this.actions[ACTIONS.EDIT_PROJECT] = this._createEditProject.bind(this);
            this.actions[ACTIONS.EDIT_PROJECT_SITE] = this._createEditProjectSite.bind(this);
            this.actions[ACTIONS.FAVOURITE_DOCUMENT_GET] = this._createFavouriteDocumentGet.bind(this);
            this.actions[ACTIONS.FILE_PREVIEW] = this._createFilePreview.bind(this);
            this.actions[ACTIONS.FILE_UPLOAD] = this._createFileUpload.bind(this);
            this.actions[ACTIONS.GROUP_COLLECTION] = this._createGroupCollection.bind(this);
            this.actions[ACTIONS.GROUP_IS_MEMBER_OF] = this._createGroupMemberOf.bind(this);
            this.actions[ACTIONS.GROUP_MEMBER_COLLECTION] = this._createGroupMemberCollection.bind(this);
            this.actions[ACTIONS.LEAD_TEAM] = this._createProjectStageLeadTeam.bind(this);
            this.actions[ACTIONS.LEAD_TEAM_COLLECTION] = this._createProjectStageLeadTeamCollection.bind(this);
            this.actions[ACTIONS.MY_GROUP_COLLECTION] = this._createMyGroupCollection.bind(this);
            this.actions[ACTIONS.MY_GROUP_MEMBER_COLLECTION] = this._createMyGroupMemberCollection.bind(this);
            this.actions[ACTIONS.ORGANISATION_BRANCH_OFFICE_COLLECTION] = this._createOrganisationBranchOfficeCollection.bind(this);
            this.actions[ACTIONS.ORGANISATION_COLLECTION] = this._createOrganisationCollection.bind(this);
            this.actions[ACTIONS.ORGANISATION_INTRANET_OWNER_COLLECTION] = this._createIntranetOwnerCollection.bind(this);
            this.actions[ACTIONS.ORGANISATION_PERSON_COLLECTION] = this._createOrganisationPersonCollection.bind(this);
            this.actions[ACTIONS.PERSON] = this._createPerson.bind(this);
            this.actions[ACTIONS.PERSON_SELF] = this._createPersonSelf.bind(this);
            this.actions[ACTIONS.PROJECT] = this._createProject.bind(this);
            this.actions[ACTIONS.PROJECT_COLLECTION] = this._createProjectCollection.bind(this);
            this.actions[ACTIONS.PROJECT_SITE_COLLECTION] = this._createProjectSiteCollection.bind(this);
            this.actions[ACTIONS.PROJECT_SITE_DOCUMENT_COLLECTION] = this._createProjectSiteDocumentCollection.bind(this);
            this.actions[ACTIONS.PROJECT_SITE_DOCUMENT_DELETE] = this._createProjectSiteDocumentDelete.bind(this);
            this.actions[ACTIONS.PROJECT_STAGE] = this._createProjectStage.bind(this);
            this.actions[ACTIONS.PROJECT_STAGE_BUDGET] = this._createProjectStageBudget.bind(this);
            this.actions[ACTIONS.PROJECT_STAGE_BUDGET_STATUS_COLLECTION] = this._createProjectStageBudgetStatusCollection.bind(this);
            this.actions[ACTIONS.PROJECT_STAGE_COLLECTION] = this._createProjectStageCollection.bind(this);
            this.actions[ACTIONS.PROJECT_STAGE_CONTRACT] = this._createProjectStageContract.bind(this);
            this.actions[ACTIONS.PROJECT_STAGE_MEMBER_COLLECTION] = this._createProjectStageMemberCollection.bind(this);
            this.actions[ACTIONS.PROJECT_STAGE_NODE] = this._createProjectStageNode.bind(this);
            this.actions[ACTIONS.PROJECT_STAGE_NUMBER_RANGE_COLLECTION] = this._createProjectStageNumberRangeCollection.bind(this);
            this.actions[ACTIONS.PROJECT_STAGE_LEAD] = this._createProjectStageLead.bind(this);
            this.actions[ACTIONS.PROJECT_STAGE_PREQUAL] = this._createProjectStagePrequal.bind(this);
            this.actions[ACTIONS.PROJECT_STAGE_PREQUAL_FOR_COLLECTION] = this._createProjectStagePrequalForCollection.bind(this);
            this.actions[ACTIONS.PROJECT_STAGE_TENDER_OFFER] = this._createProjectStageTenderOffer.bind(this);
            this.actions[ACTIONS.PROJECT_STAGE_INTELLIGENCE] = this._createProjectStageIntelligence.bind(this);
            this.actions[ACTIONS.PROJECT_STAGE_TENDER] = this._createProjectStageTender.bind(this);
            this.actions[ACTIONS.PROJECT_STAGE_TYPE_COLLECTION] = this._createProjectStageTypeCollection.bind(this);
            this.actions[ACTIONS.PROJECT_TENDER_TYPE_COLLECTION] = this._createProjectTenderTypeCollection.bind(this);
            this.actions[ACTIONS.REMOVE_DOCUMENT_FAVOURITE] = this._createFavouriteDocumentRemove.bind(this);
            this.actions[ACTIONS.SAVE_BUDGET_STAGE] = this._createSaveBudgetStage.bind(this);
            this.actions[ACTIONS.SAVE_CONTRACT_STAGE] = this._createSaveContractStage.bind(this);
            this.actions[ACTIONS.SAVE_ESTIMATED_PROJECT_DATES] = this._createSaveEstimatedProjectDates.bind(this);
            this.actions[ACTIONS.SAVE_LEAD_STAGE] = this._createSaveProjectStageLead.bind(this);
            this.actions[ACTIONS.SAVE_PREQUAL_STAGE] = this._createSavePrequalStage.bind(this);
            this.actions[ACTIONS.SAVE_TENDER_OFFER_STAGE] = this._createSaveTenderOfferStage.bind(this);
            this.actions[ACTIONS.SAVE_INTELLIGENCE_STAGE] = this._createSaveIntelligenceStage.bind(this);
            this.actions[ACTIONS.SAVE_TENDER_STAGE] = this._createSaveTenderStage.bind(this);
            this.actions[ACTIONS.TEAM_COLLECTION] = this._createTeamCollection.bind(this);
            this.actions[ACTIONS.TREE] = this._createTree.bind(this);
            this.actions[ACTIONS.TREE_TEMPLATE_COLLECTION] = this._createTreeTemplateCollection.bind(this);
        }

        _createCountryCollection(requestData) {
            return new CountryCollection(
                this.urlConfig[ACTIONS.ADDRESS_COUNTRY],
                requestData,
                this.fetchFactory
            );
        }

        _createCountyCollection(requestData) {
            return new CountyCollection(
                this.urlConfig[ACTIONS.ADDRESS_COUNTY],
                requestData,
                this.fetchFactory
            );
        }

        _createClientSelectedFromCollection(requestData) {
            return new ClientSelectedFromCollection(
                this.urlConfig[ACTIONS.CLIENT_SELECTED_FROM_COLLECTION],
                requestData,
                this.fetchFactory
            );
        }

        _createContact(requestData) {
            return new Contact(
                this.urlConfig[ACTIONS.CONTACT],
                requestData,
                this.fetchFactory
            );
        }

        _createContactCollection(requestData) {
            return new ContactCollection(
                this.urlConfig[ACTIONS.CONTACT_COLLECTION],
                requestData,
                this.fetchFactory
            );
        }

        _createContractConditionCollection(requestData) {
            return new ContractConditionCollection(
                this.urlConfig[ACTIONS.CONTRACT_CONDITION_COLLECTION],
                requestData,
                this.fetchFactory
            );
        }

        _createContractTypeCollection(requestData) {
            return new ContractTypeCollection(
                this.urlConfig[ACTIONS.CONTRACT_TYPE_COLLECTION],
                requestData,
                this.fetchFactory
            );
        }

        _createCreateProject(requestData) {
            return new CreateProject(
                this.urlConfig[ACTIONS.CREATE_PROJECT],
                requestData,
                this.fetchFactory,
                new FormDataWrapper()
            );
        }

        _createProjectSite(requestData) {
            return new CreateProjectSite(
                this.urlConfig[ACTIONS.CREATE_PROJECT_SITE],
                requestData,
                this.fetchFactory,
                new FormDataWrapper()
            );
        }

        _createDocumentBulkRegister(requestData) {
            return new DocumentBulkRegister(
                this.urlConfig[ACTIONS.DOCUMENT_BULK_REGISTER],
                this.urlConnectionBuilderFactory.get(),
                this.promiseFactory,
                requestData
            )
        }

        _createDocumentLatest(requestData) {
            return new DocumentLatest(
                this.urlConfig[ACTIONS.DOCUMENT_LATEST],
                requestData,
                this.fetchFactory
            )
        }

        _createDocumentLocation(requestData) {
            return new DocumentLocation(
                this.urlConfig[ACTIONS.DOCUMENT_LOCATION],
                this.urlConnectionBuilderFactory.get(),
                this.promiseFactory,
                requestData
            )
        }

        _createDocumentRevisionSetLatest(requestData) {
            return new DocumentRevisionSetLatest(
                this.urlConfig[ACTIONS.DOCUMENT_REVISION_SET_LATEST],
                requestData,
                this.fetchFactory
            );
        }

        _createDocumentRevisionSearch(requestData) {
            return new DocumentRevisionSearch(
                this.urlConfig[ACTIONS.DOCUMENT_REVISION_SEARCH],
                requestData,
                this.fetchFactory,
                new FormDataWrapper()
            );
        }

        _createDocumentRevisionNumber(requestData) {
            return new DocumentRevisionNumber(
                this.urlConfig[ACTIONS.DOCUMENT_REVISION_NUMBER],
                requestData,
                this.fetchFactory
            );
        }

        _createDocumentUpload(requestData) {
            return new DocumentUpload(
                this.urlConfig[ACTIONS.DOCUMENT_UPLOAD],
                this.urlConnectionBuilderFactory.get(),
                this.promiseFactory,
                requestData
            )
        }

        _createEditProject(requestData) {
            return new EditProject(
                this.urlConfig[ACTIONS.EDIT_PROJECT],
                requestData,
                this.fetchFactory
            );
        }

        _createFavouriteDocumentGet(requestData) {
            return new FavouriteDocumentGet(
                this.urlConfig[ACTIONS.FAVOURITE_DOCUMENT_GET],
                requestData,
                this.fetchFactory,
                new FormDataWrapper()
            );
        }

        _createEditProjectSite(requestData) {
            return new EditProjectSite(
                this.urlConfig[ACTIONS.EDIT_PROJECT_SITE],
                requestData,
                this.fetchFactory
            );
        }

        _createFilePreview(requestData) {
            return new FilePreview(
                this.urlConfig[ACTIONS.FILE_PREVIEW],
                requestData,
                this.fetchFactory
            );
        }

        _createFileUpload(requestData) {
            return new FileUpload(
                this.urlConfig[ACTIONS.FILE_UPLOAD],
                this.urlConnectionBuilderFactory.get(),
                this.promiseFactory,
                requestData
            );
        }

        _createGroupCollection(requestData) {
            return this.collectionFactory.get(
                this.urlConfig[ACTIONS.GROUP_COLLECTION],
                this.urlParams[ACTIONS.GROUP_COLLECTION],
                requestData,
                this.fetchFactory
            );
        }

        _createGroupMemberOf(requestData) {
            return new IsMemberOfGroup(
                this.urlConfig[ACTIONS.GROUP_IS_MEMBER_OF],
                requestData,
                this.fetchFactory
            );
        }

        _createGroupMemberCollection(requestData) {
            return new MemberCollection(
                this.urlConfig[ACTIONS.GROUP_MEMBER_COLLECTION],
                this.urlParams[ACTIONS.GROUP_MEMBER_COLLECTION],
                requestData,
                this.fetchFactory,
                this.collectionFactory
            );
        }

        _createMyGroupCollection(requestData) {
            return this.collectionFactory.get(
                this.urlConfig[ACTIONS.MY_GROUP_COLLECTION],
                this.urlParams[ACTIONS.MY_GROUP_COLLECTION],
                requestData,
                this.fetchFactory
            );
        }

        _createMyGroupMemberCollection(requestData) {
            return new MemberCollection(
                this.urlConfig[ACTIONS.MY_GROUP_MEMBER_COLLECTION],
                this.urlParams[ACTIONS.MY_GROUP_MEMBER_COLLECTION],
                requestData,
                this.fetchFactory,
                this.collectionFactory
            );
        }

        _createOrganisationBranchOfficeCollection(requestData) {
            return new OrganisationBranchOfficeCollection(
                this.urlConfig[ACTIONS.ORGANISATION_BRANCH_OFFICE_COLLECTION],
                requestData,
                this.fetchFactory
            );
        }

        _createOrganisationCollection(requestData) {
            return new OrganisationCollection(
                this.urlConfig[ACTIONS.ORGANISATION_COLLECTION],
                requestData,
                this.fetchFactory
            );
        }

        _createIntranetOwnerCollection(requestData) {
            return new IntranetOwnerCollection(
                this.urlConfig[ACTIONS.ORGANISATION_INTRANET_OWNER_COLLECTION],
                requestData,
                this.fetchFactory
            );
        }

        _createOrganisationPersonCollection(requestData) {
            return new OrganisationPersonCollection(
                this.urlConfig[ACTIONS.ORGANISATION_PERSON_COLLECTION],
                requestData,
                this.fetchFactory
            );
        }

        _createPerson(requestData) {
            return new Person(
                this.urlConfig[ACTIONS.PERSON],
                requestData,
                this.fetchFactory
            );
        }

        _createPersonSelf(requestData) {
            return new PersonSelf(
                this.urlConfig[ACTIONS.PERSON_SELF],
                requestData,
                this.fetchFactory
            );
        }

        _createProject(requestData) {
            return new Project(
                this.urlConfig[ACTIONS.PROJECT],
                requestData,
                this.fetchFactory
            );
        }

        _createProjectCollection(requestData) {
            return new ProjectCollection(
                this.urlConfig[ACTIONS.PROJECT_COLLECTION],
                requestData,
                this.fetchFactory
            );
        }

        _createProjectSiteCollection(requestData) {
            return new ProjectSiteCollection(
                this.urlConfig[ACTIONS.PROJECT_SITE_COLLECTION],
                requestData,
                this.fetchFactory
            );
        }

        _createProjectSiteDocumentCollection(requestData) {
            return new ProjectSiteDocumentCollection(
                this.urlConfig[ACTIONS.PROJECT_SITE_DOCUMENT_COLLECTION],
                requestData,
                this.fetchFactory
            );
        }

        _createProjectSiteDocumentDelete(requestData) {
            return new ProjectSiteDocumentDelete(
                this.urlConfig[ACTIONS.PROJECT_SITE_DOCUMENT_DELETE],
                requestData,
                this.fetchFactory
            );
        }

        _createProjectStage(requestData) {
            return new ProjectStage(
                this.urlConfig[ACTIONS.PROJECT_STAGE],
                requestData,
                this.fetchFactory
            );
        }

        _createProjectStageBudget(requestData) {
            return new ProjectStageBudget(
                this.urlConfig[ACTIONS.PROJECT_STAGE_BUDGET],
                requestData,
                this.fetchFactory
            );
        }

        _createProjectStageBudgetStatusCollection(requestData) {
            return new ProjectStageBudgetStatusCollection(
                this.urlConfig[ACTIONS.PROJECT_STAGE_BUDGET_STATUS_COLLECTION],
                requestData,
                this.fetchFactory
            );
        }

        _createProjectStageCollection(requestData) {
            return this.collectionFactory.get(
                this.urlConfig[ACTIONS.PROJECT_STAGE_COLLECTION],
                this.urlParams[ACTIONS.PROJECT_STAGE_COLLECTION],
                requestData,
                this.fetchFactory
            );
        }

        _createProjectStageContract(requestData) {
            return new ProjectStageContract(
                this.urlConfig[ACTIONS.PROJECT_STAGE_CONTRACT],
                requestData,
                this.fetchFactory
            );
        }

        _createProjectStageCreateBudgetStage(requestData) {
            return new ProjectStageCreateBudget(
                this.urlConfig[ACTIONS.CREATE_BUDGET_STAGE],
                requestData,
                this.fetchFactory,
                new FormDataWrapper()
            );
        }

        _createProjectStageCreateContractStage(requestData) {
            return new ProjectStageCreateContract(
                this.urlConfig[ACTIONS.CREATE_CONTRACT_STAGE],
                requestData,
                this.fetchFactory,
                new FormDataWrapper()
            );
        }

        _createFavouriteDocumentCreate(requestData) {
            return new FavouriteDocumentCreate(
                this.urlConfig[ACTIONS.CREATE_DOCUMENT_FAVOURITE],
                requestData,
                this.fetchFactory,
                new FormDataWrapper()
            );
        }

        _createGeneralStage(requestData) {
            return new CreateGeneralStage(
                this.urlConfig[ACTIONS.CREATE_GENERAL_STAGE],
                requestData,
                this.fetchFactory,
                new FormDataWrapper()
            );
        }

        _createProjectStageCreateIntelligenceStage(requestData) {
            return new ProjectStageCreateIntelligence(
                this.urlConfig[ACTIONS.CREATE_INTELLIGENCE_STAGE],
                requestData,
                this.fetchFactory,
                new FormDataWrapper()
            );
        }

        _createProjectStageCreateLeadStage(requestData) {
            return new ProjectStageCreateLead(
                this.urlConfig[ACTIONS.CREATE_LEAD_STAGE],
                requestData,
                this.fetchFactory,
                new FormDataWrapper()
            );
        }

        _createProjectStageCreateTenderStage(requestData) {
            return new ProjectStageCreateTender(
                this.urlConfig[ACTIONS.CREATE_TENDER_STAGE],
                requestData,
                this.fetchFactory,
                new FormDataWrapper()
            );
        }

        _createProjectStageLeadTeam(requestData) {
            return new ProjectStageLeadTeam(
                this.urlConfig[ACTIONS.LEAD_TEAM],
                requestData,
                this.fetchFactory
            )
        }

        _createProjectStageLeadTeamCollection(requestData) {
            return new ProjectStageLeadTeamCollection(
                this.urlConfig[ACTIONS.LEAD_TEAM_COLLECTION],
                requestData,
                this.fetchFactory
            )
        }

        _createProjectStageCreatePrequalStage(requestData) {
            return new ProjectStageCreatePrequal(
                this.urlConfig[ACTIONS.CREATE_PREQUAL_STAGE],
                requestData,
                this.fetchFactory,
                new FormDataWrapper()
            );
        }

        _createTenderOfferStage(requestData) {
            return new ProjectStageCreateTenderOffer(
                this.urlConfig[ACTIONS.CREATE_TENDER_OFFER_STAGE],
                requestData,
                this.fetchFactory,
                new FormDataWrapper()
            );
        }

        _createProjectStageNumberRangeCollection(requestData) {
            return new ProjectStageNumberRangeCollection(
                this.urlConfig[ACTIONS.PROJECT_STAGE_NUMBER_RANGE_COLLECTION],
                requestData,
                this.fetchFactory
            )
        }

        _createProjectStagePrequal(requestData) {
            return new ProjectStagePrequal(
                this.urlConfig[ACTIONS.PROJECT_STAGE_PREQUAL],
                requestData,
                this.fetchFactory
            );
        }

        _createProjectStageLead(requestData) {
            return new ProjectStageLead(
                this.urlConfig[ACTIONS.PROJECT_STAGE_LEAD],
                requestData,
                this.fetchFactory
            );
        }

        _createProjectStageTenderOffer(requestData) {
            return new ProjectStageTenderOffer(
                this.urlConfig[ACTIONS.PROJECT_STAGE_TENDER_OFFER],
                requestData,
                this.fetchFactory
            );
        }

        _createProjectStageTender(requestData) {
            return new ProjectStageTender(
                this.urlConfig[ACTIONS.PROJECT_STAGE_TENDER],
                requestData,
                this.fetchFactory
            );
        }

        _createProjectStageIntelligence(requestData) {
            return new ProjectStageIntelligence(
                this.urlConfig[ACTIONS.PROJECT_STAGE_INTELLIGENCE],
                requestData,
                this.fetchFactory
            );
        }

        _createProjectStagePrequalForCollection(requestData) {
            return new ProjectStagePrequalForCollection(
                this.urlConfig[ACTIONS.PROJECT_STAGE_PREQUAL_FOR_COLLECTION],
                requestData,
                this.fetchFactory
            );
        }

        _createProjectStageTypeCollection(requestData) {
            return new TypeCollection(
                this.urlConfig[ACTIONS.PROJECT_STAGE_TYPE_COLLECTION],
                requestData,
                this.fetchFactory
            );
        }

        _createProjectStageMemberCollection(requestData) {
            return new MemberCollection(
                this.urlConfig[ACTIONS.PROJECT_STAGE_MEMBER_COLLECTION],
                this.urlParams[ACTIONS.PROJECT_STAGE_MEMBER_COLLECTION],
                requestData,
                this.fetchFactory,
                this.collectionFactory
            );
        }

        _createProjectStageNode(requestData) {
            return new ProjectStageNode(
                this.urlConfig[ACTIONS.PROJECT_STAGE_NODE],
                requestData,
                this.fetchFactory
            );
        }

        _createProjectTenderTypeCollection(requestData) {
            return new ProjectTenderTypeCollection(
                this.urlConfig[ACTIONS.PROJECT_TENDER_TYPE_COLLECTION],
                requestData,
                this.fetchFactory
            );
        }

        _createFavouriteDocumentRemove(requestData) {
            return new FavouriteDocumentRemove(
                this.urlConfig[ACTIONS.REMOVE_DOCUMENT_FAVOURITE],
                requestData,
                this.fetchFactory
            );
        }

        _createTeamCollection(requestData) {
            return new TeamCollection(
                this.urlConfig[ACTIONS.TEAM_COLLECTION],
                requestData,
                this.fetchFactory
            )
        }

        _createSaveBudgetStage(requestData) {
            return new SaveBudgetStage(
                this.urlConfig[ACTIONS.SAVE_BUDGET_STAGE],
                requestData,
                this.fetchFactory
            );
        }

        _createSaveContractStage(requestData) {
            return new SaveContractStage(
                this.urlConfig[ACTIONS.SAVE_CONTRACT_STAGE],
                requestData,
                this.fetchFactory
            );
        }

        _createSaveEstimatedProjectDates(requestData) {
            return new SaveEstimatedProjectDates(
                this.urlConfig[ACTIONS.SAVE_ESTIMATED_PROJECT_DATES],
                requestData,
                this.fetchFactory
            );
        }

        _createSaveProjectStageLead(requestData) {
            return new SaveLeadStage(
                this.urlConfig[ACTIONS.SAVE_LEAD_STAGE],
                requestData,
                this.fetchFactory
            );
        }

        _createSavePrequalStage(requestData) {
            return new SavePrequalStage(
                this.urlConfig[ACTIONS.SAVE_PREQUAL_STAGE],
                requestData,
                this.fetchFactory
            );
        }

        _createSaveTenderOfferStage(requestData) {
            return new SaveTenderOfferStage(
                this.urlConfig[ACTIONS.SAVE_TENDER_OFFER_STAGE],
                requestData,
                this.fetchFactory
            );
        }

        _createSaveTenderStage(requestData) {
            return new SaveTenderStage(
                this.urlConfig[ACTIONS.SAVE_TENDER_STAGE],
                requestData,
                this.fetchFactory
            );
        }

        _createSaveIntelligenceStage(requestData) {
            return new SaveIntelligenceStage(
                this.urlConfig[ACTIONS.SAVE_INTELLIGENCE_STAGE],
                requestData,
                this.fetchFactory
            );
        }

        _createTree(requestData) {
            return new Tree(
                this.urlConfig[ACTIONS.TREE],
                requestData,
                this.fetchFactory
            );
        }

        _createTreeTemplateCollection(requestData) {
            return new TreeTemplateCollection(
                this.urlConfig[ACTIONS.TREE_TEMPLATE_COLLECTION],
                requestData,
                this.fetchFactory
            );
        }
    }
});

},
'spencer/data-manager/core/request/action/Address/CountryCollection':function(){
define([
    'spencer/core/parser/Country',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    CountryParser,
    RequestCanceller,
    ActionData
) {
    return class CountryCollection {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();

            this.countryParser = new CountryParser();
        }

        canAction() {
            return true;
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            let url = this.url;

            if (Object.keys(context).length) {
                url += '?' + this._prepareParams(context);
            }

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();

                return data.map(item => {
                    return this._parseData(item);
                });
            })

            return this.fetchWrapper.get(url);
        }

        _prepareParams(context) {
            const params = [];

            if (context['name']) {
                params.push('name=' + context['name']);
            }

            if (context['limit']) {
                params.push('limit=' + context['limit']);
            }

            if (context['offset'] || context['offset'] === 0) {
                params.push('offset=' + context['offset']);
            }

            return params.join('&');
        }

        _parseData(country) {
            return this.countryParser.parse(country);
        }
    }
});
},
'library/request/Canceller':function(){
define([], function() {
    const Canceller = function(urlCanceller) {
        this.urlCanceller = urlCanceller;
    };

    Canceller.prototype.cancel = function() {
        if (!this.urlCanceller) {
            return;
        }

        this.urlCanceller.cancel();
    };

    return Canceller;
});
},
'spencer/data-manager/data/Action':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Action {
        constructor(requestCanceller, promise, requestData) {
            this.requestCanceller = requestCanceller;
            this.promise = promise;
            this.requestData = requestData;
        }
        cancel() {
            this.requestCanceller.cancel();
        }
        getPromise() {
            return this.promise;
        }
        getRequestData() {
            return this.requestData;
        }
    }
    return Action;
});

},
'spencer/data-manager/core/request/action/Address/CountyCollection':function(){
define([
    'spencer/core/parser/County',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    CountyParser,
    RequestCanceller,
    ActionData
) {
    return class CountyCollection {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();

            this.countyParser = new CountyParser();
        }

        canAction() {
            return true;
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            let url = this.url;

            if (Object.keys(context).length) {
                url += '?' + this._prepareParams(context);
            }

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();

                return data.map(item => {
                    return this._parseData(item);
                });
            })

            return this.fetchWrapper.get(url);
        }

        _prepareParams(context) {
            const params = [];

            if (context['countryPK']) {
                params.push('countryPK=' + context['countryPK']);
            }

            if (context['name']) {
                params.push('name=' + context['name']);
            }

            if (context['limit']) {
                params.push('limit=' + context['limit']);
            }

            if (context['offset'] || context['offset'] === 0) {
                params.push('offset=' + context['offset']);
            }

            return params.join('&');
        }

        _parseData(county) {
            return this.countyParser.parse(county);
        }
    }
});
},
'spencer/data-manager/core/request/action/Client/SelectedFromCollection':function(){
define([
    'api/client/parser/SelectedFrom',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    SelectedFromParser,
    RequestCanceller,
    ActionData
) {
    return class SelectedFromCollection {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();

            this.selectedFromParser = new SelectedFromParser();
        }

        canAction() {
            return true;
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            let url = this.url;

            if (Object.keys(context).length) {
                url += '?' + this._prepareParams(context);
            }

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();

                return data.map(item => {
                    return this._parseData(item);
                });
            })

            return this.fetchWrapper.get(url);
        }

        _prepareParams(context) {
            const params = [];

            if (context['description']) {
                params.push('description=' + context['description']);
            }

            if (context['limit']) {
                params.push('limit=' + context['limit']);
            }

            if (context['offset'] || context['offset'] === 0) {
                params.push('offset=' + context['offset']);
            }

            return params.join('&');
        }

        _parseData(selectedFrom) {
            return this.selectedFromParser.parse(selectedFrom);
        }
    }
});
},
'api/client/parser/SelectedFrom':function(){
define([
    'spencer/client/data/SelectedFrom'
], function (
    SelectedFromVO
) {
    return class SelectedFrom {
        parse(data) {
            return new SelectedFromVO(
                data.clientSelectedFromPK,
                data.description
            );
        }
    }
});
},
'spencer/client/data/SelectedFrom':function(){
define([], function () {
    return class SelectedFrom {
        constructor(clientSelectedFromPK, description) {
            this.clientSelectedFromPK = clientSelectedFromPK;
            this.description = description;
        }

        getClientSelectedFromPK() {
            return this.clientSelectedFromPK;
        }

        getDescription() {
            return this.description;
        }
    }
});
},
'spencer/data-manager/core/request/action/CollectionFactory':function(){
define([
    './Collection'
], function (
    Collection
) {
    return class Factory {
        get(url, urlParams, requestData, fetchFactory) {
            return new Collection(url, urlParams, requestData, fetchFactory);
        }
    }
});
},
'spencer/data-manager/core/request/action/Collection':function(){
define([
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function(
    RequestCanceller,
    ActionData
) {
    return class Collection {
        constructor(url, urlParams, requestData, fetchFactory) {
            this.url = url;
            this.urlParams = urlParams;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();

            this.successHandler = response => response.json();
        }

        canAction() {
            return true;
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        setSuccessHandler(successHandler) {
            this.successHandler = successHandler;
        }

        async _request() {
            const context = this.requestData.getContext();
            const params = [];

            this.urlParams.forEach(key => {
                if (context[key]) {
                    params.push(`${key}=${context[key]}`);
                }
            });

            if (context['limit'] > 0 && context['offset'] >= 0) {
                params.push(`limit=${context['limit']}`);
                params.push(`offset=${context['offset']}`);
            }

            if (params.length) {
                this.url += '?' + params.join('&');
            }

            this.fetchWrapper.setSuccessHandler(this.successHandler);

            return this.fetchWrapper.get(this.url);
        }
    }
});
},
'spencer/data-manager/core/request/action/Contact':function(){
define([
    'api/contact/parser/Contact',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    ContactParser,
    RequestCanceller,
    ActionData
) {
    return class Contact {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
            this.contactParser = new ContactParser();
        }

        canAction() {
            return true;
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            let url = this.url;

            if (context['personPK']) {
                url += `?personPK=${context['personPK']}`;
            }

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();

                return data['collection']['items'].map(item => {
                    return this._parseData(item.data);
                });
            })

            return this.fetchWrapper.get(url);
        }

        _parseData(data) {
            const dataObject = {};

            data.forEach(datum => {
                dataObject[datum.name] = datum.value;
            });

            return this.contactParser.parse(dataObject);
        }
    }
});
},
'spencer/data-manager/core/request/action/Contact/Collection':function(){
define([
    'api/contact/parser/Contact',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    ContactParser,
    RequestCanceller,
    ActionData
) {
    return class Collection {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
            this.contactParser = new ContactParser();
        }

        canAction() {
            return true;
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            let url = this.url;

            if (Object.keys(context).length > 0) {
                let i = 0;

                Object.entries(context).forEach(([key, value]) => {
                    if (i === 0) {
                        i++;
                        return url += `?${key}=${value}`;
                    }

                    url += `&${key}=${value}`;
                    i++;
                });
            }

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();

                return data['collection']['items'].map(item => {
                    return this._parseData(item.data);
                });
            });

            return this.fetchWrapper.get(url);
        }

        _parseData(data) {
            const dataObject = {};

            data.forEach(datum => {
                dataObject[datum.name] = datum.value;
            });

            return this.contactParser.parse(dataObject);
        }
    }
});
},
'spencer/data-manager/core/request/action/Contract/ConditionCollection':function(){
define([
    'api/contract/parser/Condition',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    ConditionParser,
    RequestCanceller,
    ActionData
) {
    return class ConditionCollection {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();

            this.conditionParser = new ConditionParser();
        }

        canAction() {
            return true;
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            let url = this.url;

            if (Object.keys(context).length) {
                url += '?' + this._prepareParams(context);
            }

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();

                return data.map(item => {
                    return this._parseData(item);
                });
            })

            return this.fetchWrapper.get(url);
        }

        _prepareParams(context) {
            const params = [];

            if (context['description']) {
                params.push('description=' + context['description']);
            }

            if (context['limit']) {
                params.push('limit=' + context['limit']);
            }

            if (context['offset'] || context['offset'] === 0) {
                params.push('offset=' + context['offset']);
            }

            return params.join('&');
        }

        _parseData(condition) {
            return this.conditionParser.parse(condition);
        }
    }
});
},
'api/contract/parser/Condition':function(){
define([
    'spencer/contract/data/Condition'
], function (
    ConditionVO
) {
    return class Condition {
        parse(data) {
            return new ConditionVO(
                data.conditionOfContractPK,
                data.description
            );
        }
    }
});
},
'spencer/contract/data/Condition':function(){
define([], function () {
    return class Condition {
        constructor(conditionOfContractPK, description) {
            this.conditionOfContractPK = conditionOfContractPK;
            this.description = description;
        }

        getConditionOfContractPK() {
            return this.conditionOfContractPK;
        }

        getDescription() {
            return this.description;
        }
    }
});
},
'spencer/data-manager/core/request/action/Contract/TypeCollection':function(){
define([
    'api/contract/parser/Type',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    TypeParser,
    RequestCanceller,
    ActionData
) {
    return class TypeCollection {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();

            this.typeParser = new TypeParser();
        }

        canAction() {
            return true;
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            let url = this.url;

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();

                return data.map(item => {
                    return this._parseData(item);
                });
            })

            return this.fetchWrapper.get(url);
        }

        _parseData(type) {
            return this.typeParser.parse(type);
        }
    }
});
},
'api/contract/parser/Type':function(){
define([
    'spencer/contract/data/Type'
], function (
    TypeVO
) {
    return class Type {
        parse(data) {
            return new TypeVO(
                data.typeOfContractPK,
                data.description
            );
        }
    }
});
},
'spencer/contract/data/Type':function(){
define([], function () {
    return class Type {
        constructor(typeOfContractPK, description) {
            this.typeOfContractPK = typeOfContractPK;
            this.description = description;
        }

        getTypeOfContractPK() {
            return this.typeOfContractPK;
        }

        getDescription() {
            return this.description;
        }
    }
});
},
'spencer/data-manager/core/request/action/Dms/Stage/TreeTemplateCollection':function(){
define([
    'api/dms/stage/parser/TreeTemplate',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    TreeTemplateParser,
    RequestCanceller,
    ActionData
) {
    return class TreeTemplateCollection {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
            this.treeTemplateParser = new TreeTemplateParser();
        }

        canAction() {
            return true;
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            const url = this.url.concat('?'.concat(this._prepareParams(context)));

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();

                return data.map(item => {
                    return this._parseData(item);
                });
            });

            return this.fetchWrapper.get(url);
        }

        _prepareParams(context) {
            const queryString = new URLSearchParams();

            for (const key in context) {
                if (context.hasOwnProperty(key)) {
                    if (context[key]) {
                        queryString.append(key, context[key]);
                    }
                }
            }

            return queryString.toString();
        }

        _parseData(leadTeam) {
            return this.treeTemplateParser.parse(leadTeam);
        }
    }
});
},
'api/dms/stage/parser/TreeTemplate':function(){
define([
    'spencer/dms/stage/TreeTemplate'
], function (
    TreeTemplateVO
) {
    return class TreeTemplate {
        parse(data) {
            return new TreeTemplateVO(
                data.templatePK,
                data.templateName
            );
        }
    }
});
},
'spencer/dms/stage/TreeTemplate':function(){
define([], function () {
    return class TreeTemplate {
        constructor(
            templatePK,
            templateName
        ) {
            this.templatePK = templatePK;
            this.templateName = templateName;
        }

        getTemplatePK() {
            return this.templatePK;
        }

        getTemplateName() {
            return this.templateName;
        }
    }
});
},
'spencer/data-manager/core/request/action/Document/BulkRegister':function(){
define([
    'library/request/Canceller',
    'spencer/data-manager/data/Action',
    'spencer/data-manager/data/response/Response',
    'spencer/data-manager/helper/request/default-handlers/Methods'
], function (
    RequestCanceller,
    ActionData,
    ResponseData,
    DefaultHandlerMethods
) {
    const URL_PARAM_DOCUMENTS = 'documents';

    const Register = function(url, urlConnectionBuilder, promiseFactory, requestData) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.promiseFactory = promiseFactory;
        this.requestData = requestData;

        this.defaultHandlerMethods = new DefaultHandlerMethods();
    };

    Register.prototype.canAction = function() {
        const context = this.requestData.getContext();

        return !!context['documents']
            && context['documents'] !== null
            && context['documents'].length > 0;
    };

    Register.prototype.getAffected = function() {
        return [];
    };

    Register.prototype.action = function() {
        if (!this.canAction()) {
            throw 'Cannot Action';
        }

        const context = this.requestData.getContext();
        const promise = this.promiseFactory.get();
        const urlConnection = this.urlConnectionBuilder.build();
        const data = {};
        data[URL_PARAM_DOCUMENTS] = context['documents'].map(function(document) { return JSON.stringify(document); });

        urlConnection.setUrl(this.url);
        urlConnection.setData(data);

        urlConnection.setSuccessHandler(function() {
            promise.resolve(new ResponseData());
        }.bind(this));

        urlConnection.setUnauthorisedHandler(this.defaultHandlerMethods.getUnauthorised(promise));
        urlConnection.setErrorHandler(this.defaultHandlerMethods.getError(promise));

        return new ActionData(
            new RequestCanceller(urlConnection.post()),
            promise,
            this.requestData
        );
    };

    return Register;
});
},
'spencer/data-manager/data/response/Response':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Response {
        constructor(data) {
            this.data = data;
        }
        getData() {
            return this.data;
        }
    }
    return Response;
});

},
'spencer/data-manager/helper/request/default-handlers/Methods':function(){
define([
    'spencer/data-manager/data/response/Error',
    'spencer/data-manager/data/response/ErrorCancelled',
    'spencer/data-manager/data/response/ErrorForbidden',
    'spencer/data-manager/data/response/ErrorUnauthorised',
    'spencer/data-manager/data/response/ResponseEmpty'
], function(
    ErrorData,
    ErrorCancelledData,
    ErrorForbiddenData,
    ErrorUnauthorisedData,
    ResponseEmptyData
) {
    const DefaultHandlerMethods = function() {};

    DefaultHandlerMethods.prototype.getSuccess = function(successHandler, promise) {
        if (successHandler) {
            return successHandler;
        }

        return function() {
            promise.resolve(new ResponseEmptyData());
        };
    };

    DefaultHandlerMethods.prototype.getUnauthorised = function(promise) {
        return function() {
            promise.reject(new ErrorUnauthorisedData());
        };
    };

    DefaultHandlerMethods.prototype.getError = function(promise) {
        return function(error, description, status) {
            promise.reject(new ErrorData(error, description, status));
        };
    };

    DefaultHandlerMethods.prototype.getCancelled = function(promise) {
        return function() {
            promise.reject(new ErrorCancelledData());
        };
    };

    DefaultHandlerMethods.prototype.getForbidden = function(promise) {
        return function() {
            promise.reject(new ErrorForbiddenData());
        }
    };

    return DefaultHandlerMethods;
});
},
'spencer/data-manager/data/response/Error':function(){
define(["require", "exports", "./Config"], function (require, exports, CONFIG) {
    "use strict";
    const STATUS_UNKNOWN = -1;
    class Error {
        constructor(error = CONFIG.ERROR, description = 'An unknown error occurred', status = STATUS_UNKNOWN, cancelled = false, unauthorised = false) {
            this.error = error;
            this.description = description;
            this.status = status;
            this.cancelled = cancelled;
            this.unauthorised = unauthorised;
        }
        isCancelled() {
            return this.cancelled;
        }
        isUnauthorised() {
            return this.unauthorised;
        }
        getStatus() {
            return this.status;
        }
        getError() {
            return this.error;
        }
        getDescription() {
            return this.description;
        }
    }
    return Error;
});

},
'spencer/data-manager/data/response/Config':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    return {
        ERROR: 'unknown_error',
        ERROR_CONFLICT: 'error_conflict',
        ERROR_CANCELLED: 'request_cancelled',
        ERROR_INTERNAL_SERVER_ERROR: 'internal_server_error',
        ERROR_FORBIDDEN: 'user_forbidden',
        ERROR_UNAUTHORISED: 'user_unauthorised'
    };
});

},
'spencer/data-manager/data/response/ErrorCancelled':function(){
define(["require", "exports", "./Config", "./Error", "library/request/data/HTTPResponseCodes"], function (require, exports, CONFIG, Error, HTTPResponseCodes) {
    "use strict";
    class ErrorCancelled extends Error {
        constructor() {
            super(CONFIG.ERROR_CANCELLED, 'Request was cancelled', HTTPResponseCodes.cancelled, true);
        }
    }
    return ErrorCancelled;
});

},
'spencer/data-manager/data/response/ErrorForbidden':function(){
define(["require", "exports", "./Config", "./Error", "library/request/data/HTTPResponseCodes"], function (require, exports, CONFIG, Error, HTTPResponseCodes) {
    "use strict";
    class ErrorForbidden extends Error {
        constructor() {
            super(CONFIG.ERROR_UNAUTHORISED, 'User forbidden', HTTPResponseCodes.forbidden);
        }
    }
    return ErrorForbidden;
});

},
'spencer/data-manager/data/response/ErrorUnauthorised':function(){
define(["require", "exports", "./Config", "./Error", "library/request/data/HTTPResponseCodes"], function (require, exports, CONFIG, Error, HTTPResponseCodes) {
    "use strict";
    class ErrorUnauthorised extends Error {
        constructor() {
            super(CONFIG.ERROR_UNAUTHORISED, 'Invalid authorisation credentials', HTTPResponseCodes.unauthorized, false, true);
        }
    }
    return ErrorUnauthorised;
});

},
'spencer/data-manager/data/response/ResponseEmpty':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class ResponseEmpty {
        getData() {
            return [];
        }
    }
    return ResponseEmpty;
});

},
'spencer/data-manager/core/request/action/Document/Latest':function(){
/// <amd-dependency path="spencer/doc-control/parser/Revision" name="RevisionParser" />
/// <amd-dependency path="spencer/doc-control/parser/Status" name="StatusParser" />
define(["require", "exports", "spencer/doc-control/parser/Revision", "spencer/doc-control/parser/Status", "spencer/data-manager/data/Action"], function (require, exports, RevisionParser, StatusParser, ActionData) {
    "use strict";
    class Latest {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchFactory = fetchFactory;
            this.processor = fetchFactory.get();
            this.revisionParser = new RevisionParser(new StatusParser);
        }
        canAction() {
            const context = this.requestData.getContext();
            return !!context['documentPK'];
        }
        getAffected(entity) {
            return [];
        }
        action() {
            if (!this.canAction()) {
                throw 'Cannot Action';
            }
            return new ActionData(this.processor, this._request(), this.requestData);
        }
        async _request() {
            const context = this.requestData.getContext();
            this.processor.setSuccessHandler(async (response) => {
                const data = await response.json();
                return this.revisionParser.parse(data);
            });
            return this.processor.get(this.url.replace(':id', context['documentPK']));
        }
    }
    return Latest;
});

},
'spencer/data-manager/core/request/action/Document/Location':function(){
define([
    'library/request/Canceller',
    'spencer/data-manager/data/Action',
    'spencer/data-manager/data/response/Response',
    'spencer/data-manager/data/request/error/NoContext',
    'spencer/data-manager/helper/request/default-handlers/Methods'
], function(
    RequestCanceller,
    ActionData,
    ResponseData,
    NoContextError,
    DefaultHandlerMethods
) {
    const Location = function(url, urlConnectionBuilder, promiseFactory, requestData) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.promiseFactory = promiseFactory;
        this.requestData = requestData;

        this.defaultHandlerMethods = new DefaultHandlerMethods();
    };

    Location.prototype.canAction = function() {
        const context = this.requestData.getContext();

        return !!context['documentPK'];
    };

    Location.prototype.getAffected = function() {
        return [];
    };

    Location.prototype.action = function() {
        if (!this.canAction()) {
            throw 'Cannot Action';
        }

        const context = this.requestData.getContext();
        const promise = this.promiseFactory.get();
        const urlConnection = this.urlConnectionBuilder.build();

        urlConnection.setUrl(this.url.replace(':id', context.documentPK));

        urlConnection.setSuccessHandler(function(location) {
            promise.resolve(new ResponseData(JSON.parse(location)));
        }.bind(this));

        urlConnection.setUnauthorisedHandler(this.defaultHandlerMethods.getUnauthorised(promise));
        urlConnection.setErrorHandler(this.defaultHandlerMethods.getError(promise));

        return new ActionData(
            new RequestCanceller(urlConnection.get()),
            promise,
            this.requestData
        );
    };

    return Location;
});
},
'spencer/data-manager/data/request/error/NoContext':function(){
define([], function() {
    const NO_CONTEXT_MESSAGE = 'There was no context provided for the request';

    const NoContextError = function(message) {
        this.message = message || NO_CONTEXT_MESSAGE;
        this.name = 'NoContextError';
    };

    NoContextError.prototype = Object.create(Error.prototype);

    return NoContextError;
});
},
'spencer/data-manager/core/request/action/Document/Favourite':function(){
define(["require", "exports", "spencer/data-manager/data/Action", "library/request/data/HTTPResponseCodes"], function (require, exports, ActionData, HTTPResponseCodes) {
    "use strict";
    class Favourite {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchFactory = fetchFactory;
            this.processor = this.fetchFactory.get();
        }
        canAction() {
            const context = this.requestData.getContext();
            return !!context['documentPK']
                && context['documentPK'] !== null;
        }
        getAffected() {
            return [];
        }
        action() {
            if (!this.canAction()) {
                throw 'Incorrect context';
            }
            return new ActionData(this.processor, this.request(), this.requestData);
        }
        async request() {
            const context = this.requestData.getContext();
            this.processor.setSuccessHandler(async (response) => {
                const data = await response.json();
                return data.favourite;
            });
            this.processor.setHandler(HTTPResponseCodes.not_found, () => null);
            return this.processor.get(this.url + (context['documentPK']));
        }
    }
    return Favourite;
});

},
'spencer/data-manager/core/request/action/Document/Favourite/Create':function(){
define(["require", "exports", "spencer/data-manager/data/Action"], function (require, exports, ActionData) {
    "use strict";
    class Create {
        constructor(url, requestData, fetchFactory, formDataWrapper) {
            this.url = url;
            this.requestData = requestData;
            this.fetchFactory = fetchFactory;
            this.formDataWrapper = formDataWrapper;
            this.processor = this.fetchFactory.get();
        }
        canAction() {
            const context = this.requestData.getContext();
            return !!context['documentPK']
                && !!context['name']
                && !!context['url']
                && context['documentPK'] !== null
                && context['name'] !== null
                && context['url'] !== null;
        }
        getAffected() {
            return [];
        }
        action() {
            if (!this.canAction()) {
                throw 'Cannot Action';
            }
            return new ActionData(this.processor, this.request(), this.requestData);
        }
        async request() {
            const context = this.requestData.getContext();
            this.formDataWrapper.append('documentPK', context['documentPK']);
            this.formDataWrapper.append('name', context['name']);
            this.formDataWrapper.append('url', context['url']);
            this.processor.setSuccessHandler(async (response) => {
                const data = await response.json();
                return data.favourite;
            });
            return this.processor.post(this.url, { body: this.formDataWrapper.get() });
        }
    }
    return Create;
});

},
'spencer/data-manager/core/request/action/Document/Favourite/Remove':function(){
define(["require", "exports", "spencer/data-manager/data/Action", "library/request/data/HTTPResponseCodes"], function (require, exports, ActionData, HTTPResponseCodes) {
    "use strict";
    class Remove {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchFactory = fetchFactory;
            this.processor = this.fetchFactory.get();
        }
        canAction() {
            const context = this.requestData.getContext();
            return !!context['favouritePK']
                && context['favouritePK'] !== null;
        }
        getAffected() {
            return [];
        }
        action() {
            if (!this.canAction()) {
                throw 'Cannot Action';
            }
            return new ActionData(this.processor, this.request(), this.requestData);
        }
        async request() {
            const context = this.requestData.getContext();
            this.processor.setHandler(HTTPResponseCodes.not_found, () => null);
            return this.processor.del(this.url + (context['favouritePK']));
        }
    }
    return Remove;
});

},
'spencer/data-manager/core/request/action/Document/Revision/Search':function(){
/// <amd-dependency path="spencer/doc-control/parser/Revision" name="RevisionParser" />
/// <amd-dependency path="spencer/doc-control/parser/Status" name="StatusParser" />
define(["require", "exports", "spencer/doc-control/parser/Revision", "spencer/doc-control/parser/Status", "spencer/data-manager/data/Action", "spencer/data-manager/data/response/Error", "spencer/data-manager/data/response/ErrorInternalServerError", "library/request/data/HTTPResponseCodes", "spencer/data-manager/data/response/Response", "@lib/api/doc-control/revision/parser/SearchResultCollection", "@lib/api/doc-control/tree/parser/Node", "@lib/api/project/parser/ProjectStage"], function (require, exports, RevisionParser, StatusParser, ActionData, ErrorResponseData, ErrorInternalServerErrorResponseData, HTTPResponseCodes, ResponseData, SearchResultCollectionParser, NodeParser, ProjectStageParser) {
    "use strict";
    class Search {
        constructor(url, requestData, fetchFactory, formDataWrapper) {
            this.url = url;
            this.requestData = requestData;
            this.fetchFactory = fetchFactory;
            this.formDataWrapper = formDataWrapper;
            const revisionParser = new RevisionParser(new StatusParser());
            this.processor = this.fetchFactory.get();
            this.parser = new SearchResultCollectionParser(revisionParser, new NodeParser(revisionParser, new ProjectStageParser()));
        }
        canAction() {
            return true;
        }
        getAffected(entity) {
            return [];
        }
        action() {
            return new ActionData(this.processor, this.request(), this.requestData);
        }
        async request() {
            const context = this.requestData.getContext();
            if (context['filters'] || context['sorts']) {
                const query = this.createQuery(context['filters'], context['sorts']);
                Object.entries(query).forEach(([name, value]) => {
                    if (name.includes('[]')) {
                        value.forEach(item => {
                            this.formDataWrapper.append(name, item);
                            return;
                        });
                    }
                    else {
                        this.formDataWrapper.append(name, value);
                    }
                });
            }
            this.processor.setSuccessHandler(async (response) => {
                const data = await response.json();
                const results = {};
                results['collection'] = this.parser.parse(data.collection.items);
                results['total'] = data.total;
                return new ResponseData(results);
            });
            this.processor.setErrorHandler(async (response) => {
                if (response.status === HTTPResponseCodes.server_error) {
                    throw new ErrorInternalServerErrorResponseData();
                }
                throw new ErrorResponseData();
            });
            return this.processor.post(this.url, { body: this.formDataWrapper.get() });
        }
        createQuery(filters, sorts) {
            const query = filters;
            if (sorts) {
                sorts.getSorts().forEach(function (sort) {
                    query['sort'] = sort.getAttribute();
                    query['order'] = sort.getOrder();
                });
            }
            return query;
        }
    }
    return Search;
});

},
'spencer/data-manager/data/response/ErrorInternalServerError':function(){
define(["require", "exports", "./Config", "./Error", "library/request/data/HTTPResponseCodes"], function (require, exports, CONFIG, Error, HTTPResponseCodes) {
    "use strict";
    class ErrorInternalServerError extends Error {
        constructor() {
            super(CONFIG.ERROR_INTERNAL_SERVER_ERROR, 'Internal server error', HTTPResponseCodes.server_error, false, false);
        }
    }
    return ErrorInternalServerError;
});

},
'@lib/api/doc-control/revision/parser/SearchResultCollection':function(){
define(["require", "exports", "@lib/api/doc-control/revision/parser/SearchResult"], function (require, exports, SearchResultParser) {
    "use strict";
    class SearchResultCollection {
        constructor(revisionParser, nodeParser) {
            this.revisionParser = revisionParser;
            this.nodeParser = nodeParser;
            this.parser = new SearchResultParser(this.revisionParser, this.nodeParser);
        }
        parse(data) {
            return data.map(item => {
                const searchResult = new Map();
                item.data.forEach(property => searchResult.set(property.name, property.value));
                return this.parser.parse(searchResult);
            });
        }
    }
    return SearchResultCollection;
});

},
'@lib/api/doc-control/revision/parser/SearchResult':function(){
define(["require", "exports", "@lib/doc-control/revision/data/SearchResult"], function (require, exports, SearchResultVO) {
    "use strict";
    class SearchResult {
        constructor(revisionParser, nodeParser) {
            this.revisionParser = revisionParser;
            this.nodeParser = nodeParser;
        }
        parse(data) {
            if (data.size === 0) {
                throw new Error('Search result data needs to be provided');
            }
            if (!SearchResult.isDataComplete(data)) {
                throw new Error('Incomplete search result data provided');
            }
            return new SearchResultVO(this.revisionParser.parse(data.get('revision')), data.get('score'), data.get('pstvPath'), data.get('documentType'), this.nodeParser.parse(data.get('node')));
        }
        static isDataComplete(data) {
            return data.has('revision')
                && data.has('score')
                && data.has('pstvPath')
                && data.has('documentType')
                && data.has('node');
        }
    }
    return SearchResult;
});

},
'@lib/doc-control/revision/data/SearchResult':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class SearchResult {
        constructor(revision, score, pstvPath, documentType, node) {
            this.revision = revision;
            this.score = score;
            this.pstvPath = pstvPath;
            this.documentType = documentType;
            this.node = node;
        }
        getRevision() {
            return this.revision;
        }
        getScore() {
            return this.score;
        }
        getPstvPath() {
            return this.pstvPath;
        }
        getDocumentType() {
            return this.documentType;
        }
        getNode() {
            return this.node;
        }
    }
    return SearchResult;
});

},
'spencer/data-manager/core/request/action/Document/Revision/SetLatest':function(){
define(["require", "exports", "spencer/data-manager/data/Action"], function (require, exports, ActionData) {
    "use strict";
    class SetLatest {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchFactory = fetchFactory;
            this.processor = this.fetchFactory.get();
        }
        canAction() {
            const context = this.requestData.getContext();
            return !!context.revisionPK && !!context.documentPK;
        }
        getAffected(entity) {
            return [];
        }
        action() {
            if (!this.canAction()) {
                throw 'Invalid Context';
            }
            return new ActionData(this.processor, this.request(), this.requestData);
        }
        async request() {
            const context = this.requestData.getContext();
            return this.processor.patch(this.url.replace(':id', context['documentPK'])
                .replace(':revisionPK', context['revisionPK']));
        }
    }
    return SetLatest;
});

},
'spencer/data-manager/core/request/action/Document/Revision/RevisionNumber':function(){
define(["require", "exports", "spencer/data-manager/data/Action", "library/request/data/HTTPResponseCodes"], function (require, exports, ActionData, HTTPResponseCodes) {
    "use strict";
    class RevisionNumber {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchFactory = fetchFactory;
            this.processor = this.fetchFactory.get();
        }
        canAction() {
            const context = this.requestData.getContext();
            return !!context['documentPK']
                && !!context['revisionCollection']
                && context['revisionCollection'].length > 0;
        }
        getAffected(entity) {
            return [];
        }
        action() {
            if (!this.canAction()) {
                throw 'Invalid Context';
            }
            return new ActionData(this.processor, this.request(), this.requestData);
        }
        async request() {
            const context = this.requestData.getContext();
            const form = {
                revisionCollection: []
            };
            context['revisionCollection'].forEach(revision => {
                form.revisionCollection.push({
                    'revisionPK': revision.getRevisionPK(),
                    'revisionNumber': revision.getRevisionNumber()
                });
            });
            this.processor.setHandler(HTTPResponseCodes.bad_request, async (response) => {
                const e = new Error();
                Object.assign(e, await response.json());
                throw e;
            });
            return this.processor.patch(this.url.replace(':id', context['documentPK']), {
                body: JSON.stringify(form),
                headers: [['Content-Type', 'application/json']]
            });
        }
    }
    return RevisionNumber;
});

},
'spencer/data-manager/core/request/action/Document/Upload':function(){
define([
    'library/request/Canceller',
    'library/request/data/Form',
    'spencer/data-manager/data/Action',
    'spencer/data-manager/data/response/Response',
    'spencer/data-manager/helper/request/default-handlers/Methods'
], function (
    RequestCanceller,
    FormData,
    ActionData,
    ResponseData,
    DefaultHandlerMethods
) {
    const URL_PARAM_FILEKEYS = 'fileKeys[]';

    const Upload = function(url, urlConnectionBuilder, promiseFactory, requestData) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.promiseFactory = promiseFactory;
        this.requestData = requestData;

        this.defaultHandlerMethods = new DefaultHandlerMethods();
    };

    Upload.prototype.canAction = function() {
        const context = this.requestData.getContext();

        return !!context['fileKeys']
            && context['fileKeys'] !== null
            && context['fileKeys'].length > 0;
    };

    Upload.prototype.getAffected = function() {
        return [];
    };

    Upload.prototype.action = function() {
        if (!this.canAction()) {
            throw 'Cannot Action';
        }

        const context = this.requestData.getContext();
        const promise = this.promiseFactory.get();
        const urlConnection = this.urlConnectionBuilder.build();
        const query = {};
        query[URL_PARAM_FILEKEYS] = context['fileKeys'];

        urlConnection.setUrl(this.url);
        urlConnection.setQuery(query);

        urlConnection.setSuccessHandler(function(documents) {
            promise.resolve(new ResponseData(JSON.parse(documents)));
        }.bind(this));

        urlConnection.setUnauthorisedHandler(this.defaultHandlerMethods.getUnauthorised(promise));
        urlConnection.setErrorHandler(this.defaultHandlerMethods.getError(promise));

        return new ActionData(
            new RequestCanceller(urlConnection.post()),
            promise,
            this.requestData
        );
    };

    return Upload;
});
},
'spencer/data-manager/core/request/action/File/Preview':function(){
define([
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function(
    RequestCanceller,
    ActionData
) {
    return class FilePreview {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();

            this.successHandler = response => response.json();
        }

        canAction() {
            return !!this.requestData.getContext()['md5'];
        }

        getAffected() {
            return [];
        }

        action() {
            if (!this.canAction()) {
                throw 'Cannot Action';
            }

            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();

            this.fetchWrapper.setSuccessHandler(response => response.text());

            return this.fetchWrapper.get(this.url.replace(':md5', context['md5']));
        }
    }
});
},
'spencer/data-manager/core/request/action/File/Upload':function(){
define([
    'library/request/Canceller',
    'library/request/data/Form',
    'spencer/data-manager/data/Action',
    'spencer/data-manager/data/RequestWithProgress',
    'spencer/data-manager/data/response/Response',
    'spencer/data-manager/helper/request/default-handlers/Methods'
], function (
    RequestCanceller,
    FormData,
    ActionData,
    RequestWithProgress,
    ResponseData,
    DefaultHandlerMethods
) {
    const UPLOAD_FILES_FORM_ID = 'documentRegister';
    const UPLOADED_FILES_KEY = 'uploadedFiles[]';

    const Upload = function(url, urlConnectionBuilder, promiseFactory, requestData) {
        this.url = url;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.promiseFactory = promiseFactory;
        this.requestData = requestData;

        this.defaultHandlerMethods = new DefaultHandlerMethods();
    };

    Upload.prototype.canAction = function() {
        const context = this.requestData.getContext();

        return !!context['files']
            && context['files'] !== null
            && context['files'].length > 0;
    };

    Upload.prototype.getAffected = function() {
        return [];
    };

    Upload.prototype.action = function() {
        if (!this.canAction()) {
            throw 'Cannot Action';
        }

        const context = this.requestData.getContext();
        const promise = this.promiseFactory.get();
        const urlConnection = this.urlConnectionBuilder.build();

        urlConnection.setUrl(this.url);
        urlConnection.setForm(
            new FormData()
                .setId(UPLOAD_FILES_FORM_ID)
                .setFileKey(UPLOADED_FILES_KEY)
                .setFiles(context['files'])
        );

        urlConnection.setSuccessHandler(function(documents) {
            promise.resolve(new ResponseData(JSON.parse(documents)));
        });

        if (this.requestData instanceof RequestWithProgress) {
            urlConnection.setProgressHandler(this.requestData.getOnProgress());
        }
        urlConnection.setUnauthorisedHandler(this.defaultHandlerMethods.getUnauthorised(promise));
        urlConnection.setErrorHandler(this.defaultHandlerMethods.getError(promise));

        return new ActionData(
            new RequestCanceller(urlConnection.post()),
            promise,
            this.requestData
        );
    };

    return Upload;
});
},
'spencer/data-manager/data/RequestWithProgress':function(){
define(["require", "exports", "./Request"], function (require, exports, RequestInterface) {
    "use strict";
    class RequestWithProgress extends RequestInterface {
        constructor(action, context = {}, forceRefresh = false, onProgress) {
            super(action, context, forceRefresh);
            this.action = action;
            this.context = context;
            this.forceRefresh = forceRefresh;
            this.onProgress = onProgress;
        }
        getOnProgress() {
            return this.onProgress;
        }
    }
    return RequestWithProgress;
});

},
'spencer/data-manager/core/request/action/Group/IsMemberOf':function(){
/// <amd-dependency path="library/request/Canceller" name="RequestCanceller" />
/// <amd-dependency path="library/request/data/HTTPResponseCodes" name="HTTPResponseCodes" />
/// <amd-dependency path="library/request/exception/ErrorResponse" name="ErrorResponse" />
/// <amd-dependency path="library/request/exception/NoAccess" name="NoAccess" />
define(["require", "exports", "library/request/Canceller", "library/request/data/HTTPResponseCodes", "library/request/exception/ErrorResponse", "library/request/exception/NoAccess", "spencer/data-manager/data/Action"], function (require, exports, RequestCanceller, HTTPResponseCodes, ErrorResponse, NoAccess, ActionData) {
    "use strict";
    class IsMemberOf {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchFactory = fetchFactory;
            this.fetchWrapper = this.fetchFactory.get();
        }
        canAction() {
            const context = this.requestData.getContext();
            return context.isValid();
        }
        getAffected(entity) {
            return [];
        }
        action() {
            if (!this.canAction()) {
                throw 'Invalid Context';
            }
            return new ActionData(new RequestCanceller(this.fetchWrapper), this.request(), this.requestData);
        }
        async request() {
            this.fetchWrapper.setErrorHandler(() => {
                throw new ErrorResponse();
            });
            this.fetchWrapper.setHandler(HTTPResponseCodes.forbidden, () => {
                throw new NoAccess();
            });
            this.fetchWrapper.setSuccessHandler(async (response) => {
                return await response.json();
            });
            const context = this.requestData.getContext();
            const url = this.url.replace(':uid', context.getUid());
            return this.fetchWrapper.get(url);
        }
    }
    return IsMemberOf;
});

},
'library/request/exception/ErrorResponse':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class ErrorResponse extends Error {
    }
    return ErrorResponse;
});

},
'library/request/exception/NoAccess':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class NoAccess extends Error {
    }
    return NoAccess;
});

},
'spencer/data-manager/core/request/action/MemberCollection':function(){
define([], function () {
    return class MemberCollection {
        constructor(url, urlParams, requestData, fetchFactory, collectionFactory) {
            this.url = url;
            this.urlParams = urlParams;
            this.requestData = requestData;
            this.fetchFactory = fetchFactory;
            this.collectionFactory = collectionFactory;
        }

        canAction() {
            return !!this.requestData.getContext()['id'];
        }

        getAffected() {
            return [];
        }

        action() {
            if (!this.canAction()) {
                throw 'Cannot Action';
            }

            const collection = this.collectionFactory.get(
                this.url.replace(':id', this.requestData.getContext()['id']),
                this.urlParams,
                this.requestData,
                this.fetchFactory
            )

            collection.setSuccessHandler(async response => {
                const data = await response.json();

                return [...data['collection']['items']];
            });

            return collection.action();
        }
    }
});
},
'spencer/data-manager/core/request/action/Organisation/Branch-Office/Collection':function(){
define(["require", "exports", "spencer/data-manager/data/Action", "@lib/api/organisation/parser/branch-office/Collection"], function (require, exports, ActionData, OrganisationBranchOfficeCollectionParser) {
    "use strict";
    class Collection {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchFactory = fetchFactory;
            this.processor = this.fetchFactory.get();
            this.organisationBranchOffice = new OrganisationBranchOfficeCollectionParser();
        }
        canAction() {
            const context = this.requestData.getContext();
            return !!context['organisationPK'];
        }
        getAffected() {
            return [];
        }
        action() {
            if (!this.canAction()) {
                throw 'Cannot Action';
            }
            return new ActionData(this.processor, this.request(), this.requestData);
        }
        async request() {
            const context = this.requestData.getContext();
            const params = new URLSearchParams();
            if (context['isActive']) {
                params.append('isActive', context['isActive']);
            }
            this.processor.setSuccessHandler(async (response) => {
                const data = await response.json();
                return this.organisationBranchOffice.parse(data);
            });
            return this.processor.get(this.url.replace(':organisationPK', context['organisationPK']) + '?' + params.toString());
        }
    }
    return Collection;
});

},
'@lib/api/organisation/parser/branch-office/Collection':function(){
define(["require", "exports", "./BranchOffice"], function (require, exports, BranchOffice_1) {
    "use strict";
    class Collection {
        constructor() {
            this.branchOfficeParser = new BranchOffice_1.default();
        }
        parse(items) {
            const collection = [];
            items.forEach((item) => {
                const bo = this.branchOfficeParser.parse(item);
                collection.push(bo);
            });
            return collection;
        }
    }
    return Collection;
});

},
'@lib/api/organisation/parser/branch-office/BranchOffice':function(){
define(["require", "exports", "@lib/api/person/parser/Address", "@lib/spencer/core/data/BranchOffice"], function (require, exports, AddressParser, BranchOfficeVO) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    class BranchOffice {
        constructor() {
            this.addressParser = new AddressParser();
        }
        parse(item) {
            return (new BranchOfficeVO())
                .setAddress(this.addressParser.parse(item))
                .setBranchOfficePK(item.branchOfficePK)
                .setName(item.name || null)
                .setHeadOffice(item.isHeadOffice || false)
                .setTelephone(item.tel || null)
                .setActive(item.isActive || false);
        }
    }
    exports.default = BranchOffice;
});

},
'@lib/api/person/parser/Address':function(){
define(["require", "exports", "@lib/spencer/core/data/Address"], function (require, exports, AddressVO) {
    "use strict";
    class Address {
        parse(item) {
            const address = new AddressVO();
            address.setAddress1(item.address1 || null);
            address.setAddress2(item.address2 || null);
            address.setAddress3(item.address3 || null);
            address.setPostCode(item.postCode || null);
            address.setTown(item.town || null);
            return address;
        }
    }
    return Address;
});

},
'@lib/spencer/core/data/Address':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Address {
        constructor() {
            this.address1 = null;
            this.address2 = null;
            this.address3 = null;
            this.county = null;
            this.postCode = null;
            this.town = null;
        }
        setAddress1(address1) {
            this.address1 = address1;
            return this;
        }
        getAddress1() {
            return this.address1;
        }
        setAddress2(address2) {
            this.address2 = address2;
            return this;
        }
        getAddress2() {
            return this.address2;
        }
        setAddress3(address3) {
            this.address3 = address3;
            return this;
        }
        getAddress3() {
            return this.address3;
        }
        setTown(town) {
            this.town = town;
            return this;
        }
        getTown() {
            return this.town;
        }
        setCountryPK(countryPK) {
            this.countryPK = countryPK;
            return this;
        }
        getCountryPK() {
            return this.countryPK;
        }
        setCountry(country) {
            this.country = country;
            return this;
        }
        getCountry() {
            return this.country;
        }
        setCounty(county) {
            this.county = county;
            return this;
        }
        getCounty() {
            return this.county;
        }
        setCountyPK(countyPK) {
            this.countyPK = countyPK;
            return this;
        }
        getCountyPK() {
            return this.countyPK;
        }
        setPostCode(postCode) {
            this.postCode = postCode;
            return this;
        }
        getPostCode() {
            return this.postCode;
        }
        equals(address) {
            const county = this.county ? this.county.trim() : null;
            const incomingCounty = address.county ? address.county.trim() : null;
            const town = this.town ? this.town.trim() : null;
            const incomingTown = address.town ? address.town.trim() : null;
            return this.address1.trim() === address.address1.trim()
                && this.address2.trim() === address.address2.trim()
                && this.address3.trim() === address.address3.trim()
                && this.countryPK === address.countryPK
                && county === incomingCounty
                && this.country.trim() === address.country.trim()
                && this.countyPK === address.countyPK
                && this.postCode.trim() === address.postCode.trim()
                && town === incomingTown;
        }
        clone() {
            return new Address()
                .setAddress1(this.address1)
                .setAddress2(this.address2)
                .setAddress3(this.address3)
                .setTown(this.town)
                .setCountryPK(this.countryPK)
                .setCountry(this.country)
                .setCounty(this.county)
                .setCountyPK(this.countyPK)
                .setPostCode(this.postCode);
        }
    }
    return Address;
});

},
'@lib/spencer/core/data/BranchOffice':function(){
define(["require", "exports", "./Address"], function (require, exports, Address) {
    "use strict";
    class BranchOffice {
        constructor() {
            this.headOffice = false;
            this.active = null;
            this.address = new Address();
        }
        setAddress(address) {
            this.address = address;
            return this;
        }
        getAddress() {
            return this.address;
        }
        getBranchOfficePK() {
            return this.branchOfficePK;
        }
        setBranchOfficePK(branchOfficePK) {
            this.branchOfficePK = branchOfficePK;
            return this;
        }
        isHeadOffice() {
            return this.headOffice;
        }
        setHeadOffice(headOffice) {
            this.headOffice = headOffice;
            return this;
        }
        getName() {
            return this.name;
        }
        setName(name) {
            this.name = name;
            return this;
        }
        getTelephone() {
            return this.telephone;
        }
        setTelephone(telephone) {
            this.telephone = telephone;
            return this;
        }
        isActive() {
            return this.active;
        }
        setActive(active) {
            this.active = active;
            return this;
        }
    }
    return BranchOffice;
});

},
'spencer/data-manager/core/request/action/Organisation/Collection':function(){
define([
    'api/organisation/parser/Organisation',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    OrganisationParser,
    RequestCanceller,
    ActionData
) {
    return class Collection {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();

            this.organisationParser = new OrganisationParser();
        }

        canAction() {
            return true;
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            let url = this.url;

            if (Object.keys(context).length) {
                url += '?' + this._prepareParams(context);
            }

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();

                return data.map(item => {
                    return this._parseData(item);
                });
            })

            return this.fetchWrapper.get(url);
        }

        _prepareParams(context) {
            const params = [];

            if (context['name']) {
                params.push('name=' + context['name']);
            }

            if (context['type']) {
                params.push('type' + context['type']);
            }

            if (context['limit']) {
                params.push('limit=' + context['limit']);
            }

            if (context['offset'] || context['offset'] === 0) {
                params.push('offset=' + context['offset']);
            }

            return params.join('&');
        }

        _parseData(organisation) {
            return this.organisationParser.parse(organisation);
        }
    }
});
},
'spencer/data-manager/core/request/action/Organisation/IntranetOwnerCollection':function(){
define([
    'api/organisation/parser/Organisation',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    OrganisationParser,
    RequestCanceller,
    ActionData
) {
    return class IntranetOwnerCollection {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();

            this.organisationParser = new OrganisationParser();
        }

        canAction() {
            return true;
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            let url = this.url;

            if (context['name']) {
                url += '?name=' + context['name'];
            }

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();

                return data.map(item => {
                    return this._parseData(item);
                });
            })

            return this.fetchWrapper.get(url);
        }

        _parseData(organisation) {
            return this.organisationParser.parse(organisation);
        }
    }
});
},
'spencer/data-manager/core/request/action/Organisation/PersonCollection':function(){
define([
    'api/person/parser/Person',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    PersonParser,
    RequestCanceller,
    ActionData
) {
    return class PersonCollection {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();

            this.personParser = new PersonParser();
        }

        canAction() {
            return !!this.requestData.getContext()['organisationPK'];
        }

        getAffected() {
            return [];
        }

        action() {
            if (!this.canAction()) {
                throw 'Cannot Action';
            }

            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            let url = this.url.replace(':organisationPK', context['organisationPK']);

            if (Object.keys(context).length) {
                url += '?' + this._prepareParams(context);
            }

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();

                return data['collection']['items'].map(item => {
                    return this._parseData(item);
                });
            })

            return this.fetchWrapper.get(url);
        }

        _prepareParams(context) {
            const params = [];

            if (context['name']) {
                params.push('name=' + context['name']);
            }

            if (context['limit']) {
                params.push('limit=' + context['limit']);
            }

            if (context['offset'] || context['offset'] === 0) {
                params.push('offset=' + context['offset']);
            }

            return params.join('&');
        }

        _parseData(person) {
            return this.personParser.parse(person);
        }
    }
});
},
'spencer/data-manager/core/request/action/Person':function(){
define([
    'library/request/Canceller',
    'library/request/data/HTTPResponseCodes',
    'spencer/data-manager/data/Action'
], function (
    RequestCanceller,
    HTTP_RESPONSE_CODES,
    ActionData
) {
    return class Person {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
        }

        canAction() {
            return true;
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

         async _request() {
            const context = this.requestData.getContext();
            let url = this.url;

            if (context['email']) {
                url += `?email=${context['email']}`;
            }

            this.fetchWrapper.setSuccessHandler(async (response) => {
                const data = await response.json();

                return data['collection']['items'][0];
            });

            return this.fetchWrapper.get(url);
        }
    }
});
},
'spencer/data-manager/core/request/action/Person/Self':function(){
define([
    'library/request/Canceller',
    'library/request/data/HTTPResponseCodes',
    'spencer/data-manager/core/definition/Entities',
    'spencer/data-manager/data/Action'
], function (
    RequestCanceller,
    HTTP_RESPONSE_CODES,
    ENTITIES,
    ActionData
) {
    return class Self {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
        }

        canAction() {
            return true;
        }

        getAffected() {
            return [];
        }

        action(storageInterface) {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(storageInterface),
                this.requestData
            );
        }

        async _request(storageInterface) {
            if (!this.requestData.forceRefresh && await storageInterface.hasEntity(ENTITIES.PERSON_SELF, {})) {
                const entity = await storageInterface.getEntity(ENTITIES.PERSON_SELF, {});
                return entity.person;
            }

            return this._apiRequest(storageInterface);
        }

        async _apiRequest(storageInterface) {
            this.fetchWrapper.setSuccessHandler(async(response) => {
                const data = await response.json();

                storageInterface.updateEntity(
                    ENTITIES.PERSON_SELF,
                    {},
                    {
                        person: data['collection']['items'][0]
                    }
                );

                return data['collection']['items'][0];
            });

            return this.fetchWrapper.get(this.url);
        }
    }
});

},
'spencer/data-manager/core/definition/Entities':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    return {
        DOCUMENT: 'document',
        GROUP_MEMBER_COLLECTION: 'group-member-collection',
        MY_GROUP_MEMBER_COLLECTION: 'my-group-member-collection',
        PERSON_SELF: 'person-self',
        PROJECT_STAGE_MEMBER_COLLECTION: 'project-stage-member-collection',
        REVISION_TO_TREE_VIEW: 'revision-to-tree-view',
        TREE: 'tree'
    };
});

},
'spencer/data-manager/core/request/action/CreateProject':function(){
define([
    'library/request/Canceller',
    'library/request/exception/ErrorResponse',
    'library/request/exception/NoAccess',
    'spencer/core/parser/Project',
    'spencer/data-manager/data/Action'
], function (
    RequestCanceller,
    ErrorResponse,
    NoAccess,
    ProjectParser,
    ActionData
) {
    return class CreateContract {
        constructor(url, requestData, fetchFactory, formDataWrapper) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
            this.formData = formDataWrapper;

            this.projectParser = new ProjectParser();
        }

        canAction() {
            const context = this.requestData.getContext();

            return context.isValid();
        }

        getAffected() {
            return [];
        }

        action() {
            if (!this.canAction()) {
                throw 'Invalid Context';
            }

            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();

            this.formData.append('title', context.getProjectTitle());
            this.formData.append('ownerOrganisationPK', context.getProjectOwnerOrganisationPK());
            this.formData.append('clientOrganisationPK', context.getProjectClientOrganisationPK());
            this.formData.append('leadTeamPK', context.getLeadTeamPK());

            this._addOptionalFields(context);

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();

                return this.projectParser.parse(data);
            });

            this.fetchWrapper.setErrorHandler(async (error) => {
                const data = await error.json();
                throw new ErrorResponse(data.description);
            });

            this.fetchWrapper.setHandler(403, () => {
                throw new NoAccess();
            });

            return this.fetchWrapper.post(this.url, {body: this.formData.get()});
        }

        _addOptionalFields(context) {
            if (context.getEstimatedStartDate()) {
                this.formData.append('estimatedStartDate', context.getEstimatedStartDate());
            }

            if (context.getEstimatedCompletionDate()) {
                this.formData.append('estimatedCompletionDate', context.getEstimatedCompletionDate());
            }

            if (context.getProjectDescription()) {
                this.formData.append('description', context.getProjectDescription());
            }
        }
    }
});

},
'spencer/data-manager/core/request/action/Project/Collection':function(){
define([
    'api/project/parser/Project',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    ProjectParser,
    RequestCanceller,
    ActionData
) {
    return class Collection {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();

            this.projectParser = new ProjectParser();
        }

        canAction() {
            return true;
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            let url = this.url;

            if (Object.keys(context).length) {
                url += '?' + this._prepareParams(context);
            }

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();

                return data.map(item => {
                    return this._parseData(item);
                });
            })

            return this.fetchWrapper.get(url);
        }

        _prepareParams(context) {
            const params = [];

            if (context['query']) {
                params.push('query=' + context['query']);
            }

            return params.join('&');
        }

        _parseData(project) {
            return this.projectParser.parse(project);
        }
    }
});

},
'api/project/parser/Project':function(){
define([
    "../data/Project",
    "api/organisation/parser/Organisation",
    "spencer/core/parser/ProjectStageCollection"
], function (
    ProjectVO,
    OrganisationParser,
    ProjectStageCollectionParser
) {
    return class Project {
        constructor() {
            this.organisationParser = new OrganisationParser();
            this.projectStageCollectionParser = new ProjectStageCollectionParser();
        }

        parse(data) {
            const vo = new ProjectVO();
            vo.setProjectPK(data.projectPK)
                .setTitle(data.title);

            if (data.projectStageCollection) {
                vo.setProjectStageCollection(this.projectStageCollectionParser.parse(data.projectStageCollection));
            }

            if (data.clientOrganisation) {
                vo.setClientOrganisation(this.organisationParser.parse(data.clientOrganisation));
            }

            if (data.ownerOrganisation) {
                vo.setOwnerOrganisation(this.organisationParser.parse(data.ownerOrganisation));
            }

            if (data.description) {
                vo.setDescription(data.description);
            }

            if (data.estimatedStartDate) {
                vo.setEstimatedStartDate(new Date(data.estimatedStartDate));
            }

            if (data.estimatedCompletionDate) {
                vo.setEstimatedCompletionDate(new Date(data.estimatedCompletionDate));
            }

            return vo;
        }
    }
});

},
'api/project/data/Project':function(){
define(
    [],
    function () {
    return class Project {
        constructor() {
            this.projectPK = null;
            this.title = '';
            this.description = '';
            this.clientOrganisation = null;
            this.ownerOrganisation = null;
            this.estimatedStartDate = null;
            this.estimatedCompletionDate = null;
            this.projectStageCollection = null;
        }

        setProjectPK(projectPK) {
            this.projectPK = projectPK;
            return this;
        }

        getProjectPK() {
            return this.projectPK;
        }

        setTitle(title) {
            this.title = title;
            return this;
        }

        getTitle() {
            return this.title;
        }

        setDescription(description) {
            this.description = description;
            return this;
        }

        getDescription() {
            return this.description;
        }

        setClientOrganisation(clientOrganisation) {
            this.clientOrganisation = clientOrganisation;
            return this;
        }

        getClientOrganisation() {
            return this.clientOrganisation;
        }

        setOwnerOrganisation(ownerOrganisation) {
            this.ownerOrganisation = ownerOrganisation;
            return this;
        }

        getOwnerOrganisation() {
            return this.ownerOrganisation;
        }

        setEstimatedStartDate(startDate) {
            this.estimatedStartDate = startDate;
            return this;
        }

        getEstimatedStartDate() {
            return this.estimatedStartDate
        }

        setEstimatedCompletionDate(completionDate) {
            this.estimatedCompletionDate = completionDate;
            return this;
        }

        getEstimatedCompletionDate() {
            return this.estimatedCompletionDate;
        }

        setProjectStageCollection(projectStageCollection) {
            this.projectStageCollection = projectStageCollection;
            return this;
        }

        getProjectStageCollection() {
            return this.projectStageCollection;
        }

        equal(project) {
            const description = this.description ? this.description.replace(/\s+/g, '') : null;
            const incomingDescription = project.getDescription() ? project.getDescription().replace(/\s+/g, '') : null;
            const title = this.title ? this.title.replace(/\s+/g, '') : null;
            const incomingTitle = project.getTitle() ? project.getTitle().replace(/\s+/g, '') : null;
            const estStartDate = this.estimatedStartDate ? this.estimatedStartDate.getTime() : null;
            const incomingEstStartDate = project.getEstimatedStartDate() ? project.getEstimatedStartDate().getTime() : null;
            const estCompletionDate = this.estimatedCompletionDate ? this.estimatedCompletionDate.getTime() : null;
            const incomingEstCompletionDate = project.getEstimatedCompletionDate() ? project.getEstimatedCompletionDate().getTime() : null;
            const clientOrganisationPK = this.clientOrganisation ? this.clientOrganisation.getOrganisationPK() : null;
            const incomingClientOrganisationPK = project.getClientOrganisation() ? project.getClientOrganisation().getOrganisationPK() : null;

            return this.projectPK === project.getProjectPK()
                && title === incomingTitle
                && description === incomingDescription
                && clientOrganisationPK === incomingClientOrganisationPK
                && estStartDate === incomingEstStartDate
                && estCompletionDate === incomingEstCompletionDate;
        }

        clone() {
            return Object.assign(new Project(), this);
        }
    }
});

},
'spencer/data-manager/core/request/action/Project/Edit':function(){
define([
    'library/request/Canceller',
    'library/request/exception/ErrorResponse',
    'library/request/exception/NoAccess',
    'spencer/data-manager/data/Action'
], function (
    RequestCanceller,
    ErrorResponse,
    NoAccess,
    ActionData
) {
    return class Edit {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
        }

        canAction() {
            const context = this.requestData.getContext();

            return context.isValid();
        }

        getAffected() {
            return [];
        }

        action() {
            if (!this.canAction()) {
                throw 'Invalid Context';
            }

            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            const url = this.url + context.getProjectPK();
            const data = this._getData(context);

            this.fetchWrapper.setErrorHandler(() => {
                throw new ErrorResponse();
            });

            this.fetchWrapper.setHandler(403, () => {
                throw new NoAccess();
            });

            return this.fetchWrapper.put(url, {
                headers: {
                    'Content-Type': 'application/json'
                },
                body: data
            });
        }

        _getData(context) {
            const data = {
                'title': context.getTitle()
            };

            if (context.getDescription()) {
                data['description'] = context.getDescription();
            }

            if (context.getClientOrganisation()) {
                data['clientOrganisationPK'] = context.getClientOrganisation().getOrganisationPK();
            }

            if (context.getEstimatedStartDate()) {
                data['estimatedStartDate'] = context.getEstimatedStartDate();
            }

            if (context.getEstimatedCompletionDate()) {
                data['estimatedCompletionDate'] = context.getEstimatedCompletionDate();
            }

            return JSON.stringify(data);
        }
    }
});

},
'spencer/data-manager/core/request/action/Project/general-stage/Create':function(){
/// <amd-dependency path="api/doccontrol/parser/Revision" name="RevisionParser" />
/// <amd-dependency path="library/request/Canceller" name="RequestCanceller" />
/// <amd-dependency path="library/request/data/HTTPResponseCodes" name="HTTPResponseCodes" />
/// <amd-dependency path="library/request/exception/ErrorResponse" name="ErrorResponse" />
/// <amd-dependency path="library/request/exception/NoAccess" name="NoAccess" />
/// <amd-dependency path="spencer/data-manager/data/Action" name="ActionData" />
define(["require", "exports", "api/doccontrol/parser/Revision", "library/request/Canceller", "library/request/data/HTTPResponseCodes", "library/request/exception/ErrorResponse", "library/request/exception/NoAccess", "spencer/data-manager/data/Action", "@lib/api/doc-control/tree/parser/Node", "@lib/api/project/parser/ProjectStage"], function (require, exports, RevisionParser, RequestCanceller, HTTPResponseCodes, ErrorResponse, NoAccess, ActionData, NodeParser, ProjectStageParser) {
    "use strict";
    class Create {
        constructor(url, requestData, fetchFactory, formData) {
            this.url = url;
            this.requestData = requestData;
            this.fetchFactory = fetchFactory;
            this.formData = formData;
            this.fetchWrapper = fetchFactory.get();
            this.parser = new NodeParser(new RevisionParser(), new ProjectStageParser());
        }
        canAction() {
            const context = this.requestData.getContext();
            return !!context['name'];
        }
        getAffected(entity) {
            return [];
        }
        action() {
            if (!this.canAction()) {
                throw 'Invalid Context';
            }
            return new ActionData(new RequestCanceller(this.fetchWrapper), this.request(), this.requestData);
        }
        async request() {
            const context = this.requestData.getContext();
            this.formData.append('name', context['name']);
            this.fetchWrapper.setSuccessHandler(async (response) => {
                const data = await response.json();
                return this.parseData(data);
            });
            this.fetchWrapper.setHandler(HTTPResponseCodes.conflict, async (error) => {
                throw new ErrorResponse(await error.json());
            });
            this.fetchWrapper.setErrorHandler(() => {
                throw new ErrorResponse();
            });
            this.fetchWrapper.setHandler(HTTPResponseCodes.forbidden, () => {
                throw new NoAccess();
            });
            return this.fetchWrapper.post(this.url, { body: this.formData.get() });
        }
        parseData(node) {
            return this.parser.parse(node);
        }
    }
    return Create;
});

},
'spencer/data-manager/core/request/action/Project/Project':function(){
define([
    'api/project/parser/Project',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    ProjectParser,
    RequestCanceller,
    ActionData
) {
    return class Collection {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();

            this.projectParser = new ProjectParser();
        }

        canAction() {
            return true;
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            let url = this.url;

            if (Object.keys(context).length) {
                url += this._prepareParams(context);
            }

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();
                return this._parseData(data);
            })

            return this.fetchWrapper.get(url);
        }

        _prepareParams(context) {
            const params = [];

            if (context['id']) {
                params.push(context['id']);
            }

            return params.join('&');
        }

        _parseData(project) {
            return this.projectParser.parse(project);
        }
    }
});

},
'spencer/data-manager/core/request/action/Project/SaveEstimatedDates':function(){
/// <amd-dependency path="library/request/Canceller" name="RequestCanceller" />
/// <amd-dependency path="library/request/data/HTTPResponseCodes" name="HTTPResponseCodes" />
/// <amd-dependency path="library/request/exception/ErrorResponse" name="ErrorResponse" />
/// <amd-dependency path="library/request/exception/NoAccess" name="NoAccess" />
/// <amd-dependency path="spencer/data-manager/data/Action" name="ActionData" />
/// <amd-dependency path="spencer/date-time/Format" name="DateTimeFormatter" />
define(["require", "exports", "library/request/Canceller", "library/request/data/HTTPResponseCodes", "library/request/exception/ErrorResponse", "library/request/exception/NoAccess", "spencer/data-manager/data/Action", "spencer/date-time/Format"], function (require, exports, RequestCanceller, HTTPResponseCodes, ErrorResponse, NoAccess, ActionData, DateTimeFormatter) {
    "use strict";
    class SaveEstimatedDates {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchFactory = fetchFactory;
            this.fetchWrapper = this.fetchFactory.get();
        }
        canAction() {
            const context = this.requestData.getContext();
            return context.isValid();
        }
        getAffected(entity) {
            return [];
        }
        action() {
            if (!this.canAction()) {
                throw 'Invalid Context';
            }
            return new ActionData(new RequestCanceller(this.fetchWrapper), this._request(), this.requestData);
        }
        async _request() {
            this.fetchWrapper.setErrorHandler(() => {
                throw new ErrorResponse();
            });
            this.fetchWrapper.setHandler(HTTPResponseCodes.forbidden, () => {
                throw new NoAccess();
            });
            const context = this.requestData.getContext();
            const url = this.url.replace(':projectPK', context.getProjectPK().toString());
            return this.fetchWrapper.put(url, {
                headers: {
                    'Content-Type': 'application/json'
                },
                body: SaveEstimatedDates.getData(context)
            });
        }
        static getData(context) {
            const dateFormatter = new DateTimeFormatter();
            const startDate = context.getEstimatedStartDate();
            const endDate = context.getEstimatedCompletionDate();
            return JSON.stringify({
                'estimatedStartDate': startDate ? dateFormatter.toYYYYMMDD(startDate) : null,
                'estimatedCompletionDate': endDate ? dateFormatter.toYYYYMMDD(endDate) : null
            });
        }
    }
    return SaveEstimatedDates;
});

},
'spencer/data-manager/core/request/action/Project/Site/CreateSite':function(){
define([
    'api/project/parser/ProjectSite',
    'library/request/Canceller',
    'library/request/data/HTTPResponseCodes',
    'library/request/exception/ErrorResponse',
    'library/request/exception/NoAccess',
    'spencer/core/parser/Address',
    'spencer/data-manager/data/Action'
], function (
    ProjectSiteParser,
    RequestCanceller,
    HTTPResponseCodes,
    ErrorResponse,
    NoAccess,
    AddressParser,
    ActionData
) {
    return class CreateSite {
        constructor(url, requestData, fetchFactory, formDataWrapper) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
            this.formData = formDataWrapper;

            this.parser = new ProjectSiteParser(new AddressParser());
        }

        canAction() {
            const context = this.requestData.getContext();

            return context.isValid();
        }

        getAffected() {
            return [];
        }

        action() {
            if (!this.canAction()) {
                throw 'Invalid Context';
            }

            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();

            this.formData.append('projectPK', context.getProjectPK());
            this.formData.append('siteName', context.getSiteName());
            this.formData.append('countryPK', context.getCountryPK());
            this.formData.append('postCode', context.getPostCode());

            if (context.getTown()) {
                this.formData.append('town', context.getTown());
            }

            if (context.getAddress1()) {
                this.formData.append('address1', context.getAddress1());
            }

            if (context.getAddress2()) {
                this.formData.append('address2', context.getAddress2());
            }

            if (context.getAddress3()) {
                this.formData.append('address3', context.getAddress3());
            }

            if (context.getCountyPK()) {
                this.formData.append('countyPK', context.getCountyPK());
            }

            if (context.getSiteInstruction()) {
                this.formData.append('instructions', context.getSiteInstruction());
            }

            if (context.getDocuments().length > 0) {
                context.getDocuments().forEach(document => {
                    this.formData.append('documents[]', JSON.stringify(document))
                });
            }

            this.fetchWrapper.setErrorHandler(() => {
                throw new ErrorResponse()
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.forbidden, () => {
                throw new NoAccess()
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.bad_request, async error => {
                throw new ErrorResponse((await error.json()).description);
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.not_found, async error => {
                throw new ErrorResponse((await error.json()).description);
            });

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();
                return this.parser.parse(data);
            });

            return this.fetchWrapper.post(this.url, {body: this.formData.get()});
        }
    }
});

},
'spencer/data-manager/core/request/action/Project/Site/Document/Collection':function(){
define([
    'api/project/site/parser/Document',
    'library/request/Canceller',
    'library/request/data/HTTPResponseCodes',
    'library/request/exception/ErrorResponse',
    'library/request/exception/NoAccess',
    'spencer/data-manager/data/Action'
], function(
    DocumentParser,
    RequestCanceller,
    HTTPResponseCodes,
    ErrorResponse,
    NoAccess,
    ActionData
) {
    return class Collection {
        constructor(url, requestData, fetchFactory, formDataWrapper) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
            this.formData = formDataWrapper;

            this.parser = new DocumentParser();
        }

        canAction() {
            const context = this.requestData.getContext();

            return !!context['projectSitePK'];
        }

        getAffected() {
            return [];
        }

        action() {
            if (!this.canAction()) {
                throw 'Invalid Context';
            }

            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();

                return data.map(site => this.parser.parse(site));
            });

            return this.fetchWrapper.get(this._getUrl(context));
        }

        _getUrl(context) {
            return this.url.replace(':projectSitePK', context['projectSitePK']);
        }
    }
})
},
'api/project/site/parser/Document':function(){
define([
    '../data/Document'
], function(
    DocumentVO
) {
    return class Document {
        parse(data) {
            return new DocumentVO(
                data.projectSitePK,
                data.documentPK,
                data.personPK,
                data.title || '',
                data.md5 || ''
            );
        }
    }
})
},
'api/project/site/data/Document':function(){
define([], function() {
    return class Document {
        constructor(
            projectSitePK,
            documentPK,
            personPK,
            title = '',
            md5 = ''
        ) {
            this.projectSitePK = projectSitePK;
            this.documentPK = documentPK;
            this.personPK = personPK;
            this.title = title;
            this.md5 = md5;
        }

        getProjectSitePK() {
            return this.projectSitePK;
        }

        getDocumentPK() {
            return this.documentPK;
        }

        getPersonPK() {
            return this.personPK;
        }

        getTitle() {
            return this.title;
        }

        getMd5() {
            return this.md5;
        }
    }
});
},
'spencer/data-manager/core/request/action/Project/Site/Document/DeleteDocument':function(){
define([
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    RequestCanceller,
    ActionData
) {
    return class DeleteDocument {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
        }

        canAction() {
            const context = this.requestData.getContext();

            return !!context['projectSitePK']
                && !!context['documentPK'];
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();

            return this.fetchWrapper.del(this.url.replace(':projectSitePK', context['projectSitePK'])
                .replace(':documentPK', context['documentPK']));

        }
    }
});

},
'spencer/data-manager/core/request/action/Project/Site/Edit':function(){
define([
    'api/project/parser/ProjectSite',
    'library/request/Canceller',
    'library/request/data/HTTPResponseCodes',
    'library/request/exception/ErrorResponse',
    'library/request/exception/NoAccess',
    'spencer/core/parser/Address',
    'spencer/data-manager/data/Action'
], function (
    ProjectSiteParser,
    RequestCanceller,
    HTTPResponseCodes,
    ErrorResponse,
    NoAccess,
    AddressParser,
    ActionData
) {
    return class Edit {
        constructor(url, requestData, fetchFactory, formDataWrapper) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
            this.formData = formDataWrapper;

            this.parser = new ProjectSiteParser(new AddressParser());
        }

        canAction() {
            const context = this.requestData.getContext();

            return context.isValid();
        }

        getAffected() {
            return [];
        }

        action() {
            if (!this.canAction()) {
                throw 'Invalid Context';
            }

            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            let url = this.url + '/' + context.getProjectSitePK();

            if (context.getProjectPK()) {
                url += '?projectPK=' + context.getProjectPK();
            }

            this.fetchWrapper.setErrorHandler(() => {
                throw new ErrorResponse();
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.bad_request, async error => {
                throw new ErrorResponse((await error.json()).description);
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.not_found, async error => {
                throw new ErrorResponse((await error.json()).description);
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.forbidden, () => {
                throw new NoAccess()
            });

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();
                return this.parser.parse(data);
            });

            return this.fetchWrapper.put(url, {
                headers: {
                    'Content-Type': 'application/json'
                },
                body: this._getData(context)
            });
        }

        _getData(context) {
            const data = {};
            data['siteName'] = context.getSiteName();
            data['countryPK'] = context.getCountryPK();
            data['postCode'] = context.getPostCode();

            if (context.getTown()) {
                data['town'] = context.getTown();
            }

            if (context.getAddress1()) {
                data['address1'] = context.getAddress1();
            }

            if (context.getAddress2()) {
                data['address2'] = context.getAddress2();
            }

            if (context.getAddress3()) {
                data['address3'] = context.getAddress3();
            }

            if (context.getCountyPK()) {
                data['countyPK'] = context.getCountyPK();
            }

            if (context.getSiteInstruction()) {
                data['instructions'] = context.getSiteInstruction();
            }

            if (context.getDocuments().length > 0) {
                data['documents[]'] = context.getDocuments();
            }

            return JSON.stringify(data);
        }
    }
});

},
'spencer/data-manager/core/request/action/Project/Site/Collection':function(){
define([
    'api/project/parser/ProjectSite',
    'library/request/Canceller',
    'library/request/data/HTTPResponseCodes',
    'library/request/exception/ErrorResponse',
    'library/request/exception/NoAccess',
    'spencer/core/parser/Address',
    'spencer/data-manager/data/Action'
], function(
    ProjectSiteParser,
    RequestCanceller,
    HTTPResponseCodes,
    ErrorResponse,
    NoAccess,
    AddressParser,
    ActionData
) {
    return class Collection {
        constructor(url, requestData, fetchFactory, formDataWrapper) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
            this.formData = formDataWrapper;

            this.parser = new ProjectSiteParser(new AddressParser());
        }

        canAction() {
            return true;
        }

        getAffected() {
            return [];
        }

        action() {
            if (!this.canAction()) {
                throw 'Invalid Context';
            }

            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();

                return data.map(site => this.parser.parse(site));
            });

            return this.fetchWrapper.get(this._getUrl(context));
        }

        _getUrl(context) {
            if (Object.keys(context).length === 0) {
                return this.url;
            }

            return this.url + '?'
                + 'projectPK=' + context['projectPK'];
        }
    }
})
},
'spencer/data-manager/core/request/action/Project/Stage/Budget/StatusCollection':function(){
define([
    'api/project/stage/budget/parser/Status',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    StatusParser,
    RequestCanceller,
    ActionData
) {
    return class StatusCollection {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();

            this.statusParser = new StatusParser();
        }

        canAction() {
            return true;
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            let url = this.url;

            if (Object.keys(context).length) {
                url += '?' + this._prepareParams(context);
            }

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();

                return data.map(item => {
                    return this._parseData(item);
                });
            })

            return this.fetchWrapper.get(url);
        }

        _prepareParams(context) {
            const params = [];

            if (context['description']) {
                params.push('description=' + context['description']);
            }

            return params.join('&');
        }

        _parseData(status) {
            return this.statusParser.parse(status);
        }
    }
});

},
'api/project/stage/budget/parser/Status':function(){
define([
    'spencer/project/stage/budget/data/Status'
], function (
    StatusVO
) {
    return class Status {
        parse(data) {
            return new StatusVO(
                data.projectStageStatusID,
                data.description
            );
        }
    }
});

},
'spencer/project/stage/budget/data/Status':function(){
define([], function () {
    return class Status {
        constructor(
            projectStageStatusID,
            description
        ) {
            this.projectStageStatusID = projectStageStatusID;
            this.description = description;
        }

        getProjectStageStatusID() {
            return this.projectStageStatusID;
        }

        getDescription() {
            return this.description;
        }
    }
});

},
'spencer/data-manager/core/request/action/Project/Stage/Budget':function(){
define([
    'api/project/stage/parser/Budget',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    BudgetParser,
    RequestCanceller,
    ActionData
) {
    return class Budget {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();

            this.budgetParser = new BudgetParser();
        }

        canAction() {
            return !!this.requestData.getContext()['id'];
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            const url = this.url.replace(':projectStagePK', context['id']);

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();
                return this._parseData(data);
            })

            return this.fetchWrapper.get(url);
        }

        _parseData(data) {
            return this.budgetParser.parse(data);
        }
    }
});

},
'api/project/stage/parser/Budget':function(){
define([
    "../data/Budget",
    "api/project/stage/budget/parser/Status"
], function (
    BudgetVO,
    StatusParser
) {
    return class Budget {

        parse(data) {
            const vo = new BudgetVO(
                data.budgetPK,
                data.projectPK,
                data.projectStagePK,
                data.clientsBudget,
                data.costCentrePK
            );

            vo.setTitle(data.title || null)
                .setLeadTeamPK(data.leadTeamPK || null)
                .setTeamHistoryPK(data.teamHistoryPK || null)
                .setPreSubmissionNotes(data.preSubmissionNotes || null)
                .setPostSubmissionNotes(data.postSubmissionNotes || null)
                .setVisible(data.visible)
                .setActive(data.active);

            if (data.budgetStatus) {
                vo.setBudgetStatus(new StatusParser().parse(data.budgetStatus));
            }

            if (data.receivedDate) {
                const receivedDate = new Date(data.receivedDate);
                receivedDate.setHours(0,0,0,0);
                vo.setReceivedDate(receivedDate);
            }

            if (data.submissionDate) {
                const submissionDate = new Date(data.submissionDate);
                submissionDate.setHours(0,0,0,0);
                vo.setSubmissionDate(submissionDate);
            }

            return vo;
        }
    }
});

},
'api/project/stage/data/Budget':function(){
define([], function() {
    return class Budget {
        constructor(
            budgetPK,
            projectPK,
            projectStagePK,
            clientsBudget,
            costCentrePK
        ) {
            this.budgetPK = budgetPK;
            this.projectPK = projectPK;
            this.projectStagePK = projectStagePK;
            this.clientsBudget = clientsBudget;
            this.costCentrePK = costCentrePK;

            this.budgetStatus = null;
            this.receivedDate = null;
            this.submissionDate = null;
            this.preSubmissionNotes = null;
            this.postSubmissionNotes = null;
            this.title = null;
            this.active = true;
            this.visible = true;
            this.leadTeamPK = null;
            this.teamHistoryPK = null;
        }

        getBudgetPK() {
            return this.budgetPK;
        }

        getProjectPK() {
            return this.projectPK;
        }

        getProjectStagePK() {
            return this.projectStagePK;
        }

        getClientsBudget() {
            return this.clientsBudget;
        }

        getCostCentrePK() {
            return this.costCentrePK;
        }

        setBudgetStatus(budgetStatus) {
            this.budgetStatus = budgetStatus;
            return this;
        }

        getBudgetStatus() {
            return this.budgetStatus;
        }

        setReceivedDate(receivedDate) {
            this.receivedDate = receivedDate;
            return this;
        }

        getReceivedDate() {
            return this.receivedDate;
        }

        setSubmissionDate(submissionDate) {
            this.submissionDate = submissionDate;
            return this;
        }

        getSubmissionDate() {
            return this.submissionDate;
        }

        setPreSubmissionNotes(preSubmissionNotes) {
            this.preSubmissionNotes = preSubmissionNotes;
            return this;
        }

        getPreSubmissionNotes() {
            return this.preSubmissionNotes;
        }

        setPostSubmissionNotes(postSubissionNotes) {
            this.postSubmissionNotes = postSubissionNotes;
            return this;
        }

        getPostSubmissionNotes() {
            return this.postSubmissionNotes;
        }

        setActive(active) {
            this.active = active;
            return this;
        }

        isActive() {
            return this.active;
        }

        setVisible(visible) {
            this.visible = visible;
            return this;
        }

        isVisible() {
            return this.visible;
        }

        setLeadTeamPK(leadTeamPK) {
            this.leadTeamPK = leadTeamPK;
            return this;
        }

        getLeadTeamPK() {
            return this.leadTeamPK;
        }

        setTeamHistoryPK(teamHistoryPK) {
            this.teamHistoryPK = teamHistoryPK;
            return this;
        }

        getTeamHistoryPK() {
            return this.teamHistoryPK;
        }

        setTitle(title) {
            this.title = title;
            return this;
        }

        getTitle() {
            return this.title;
        }

        clone() {
            return Object.assign(new Budget(), this);
        }

        equals(data) {
            const receivedDate = this.receivedDate ? this.receivedDate.getTime() : null;
            const incomingReceivedDate = data.getReceivedDate() ? this.receivedDate.getTime() : null;
            const submissionDate = this.submissionDate ? this.submissionDate.getTime() : null;
            const incomingSubmissionDate = data.getSubmissionDate() ? this.getSubmissionDate().getTime() : null;
            const title = this.title ? this.title.replace(/\s+/g, '') : null;
            const incomingTitle = data.getTitle() ? data.getTitle().replace(/\s+/g, '') : null;
            const postSubmissionNotes = this.postSubmissionNotes ? this.postSubmissionNotes.replace(/\s+/g, '') : null;
            const incomingPostSubmissionNotes = data.getPostSubmissionNotes() ? data.getPostSubmissionNotes().replace(/\s+/g, '') : null;
            const preSubmissionNotes = this.preSubmissionNotes ? this.preSubmissionNotes.replace(/\s+/g, '') : null;
            const incomingPreSubmissionNotes = data.getPreSubmissionNotes() ? data.getPreSubmissionNotes().replace(/\s+/g, '') : null;

            return this.budgetPK === data.getBudgetPK()
                && this.projectPK === data.getProjectPK()
                && this.projectStagePK === data.getProjectStagePK()
                && this.clientsBudget == data.getClientsBudget()
                && this.costCentrePK === data.getCostCentrePK()
                && this.budgetStatus.projectStageStatusID === data.getBudgetStatus().getProjectStageStatusID()
                && receivedDate === incomingReceivedDate
                && submissionDate === incomingSubmissionDate
                && this.teamHistoryPK === data.getTeamHistoryPK()
                && title === incomingTitle
                && postSubmissionNotes === incomingPostSubmissionNotes
                && preSubmissionNotes === incomingPreSubmissionNotes
                && this.visible === data.isVisible()
                && this.active === data.isActive();
        }
    }
})

},
'spencer/data-manager/core/request/action/Project/Stage/Contract':function(){
define([
    'api/project/stage/parser/Contract',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    ProjectParser,
    RequestCanceller,
    ActionData
) {
    return class Contract {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();

            this.projectParser = new ProjectParser();
        }

        canAction() {
            return !!this.requestData.getContext()['id'];
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            const url = this.url.replace(':projectStagePK', context['id']);

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();
                return this._parseData(data);
            })

            return this.fetchWrapper.get(url);
        }

        _parseData(project) {
            return this.projectParser.parse(project);
        }
    }
});

},
'api/project/stage/parser/Contract':function(){
define([
    "../data/Contract"
], function (
    ContractVO
) {
    return class Project {

        parse(data) {
            const vo = new ContractVO(
                data.projectStagePK,
                data.projectPK,
                data.originalValue,
                data.phase,
                data.costCentrePK
            );

            vo.setTitle(data.title || null)
                .setLeadTeamPK(data.leadTeamPK || null)
                .setTeamHistoryPK(data.teamHistoryPK || null)
                .setContractPK(data.contractPK || null)
                .setNotes(data.notes || null)
                .setActive(data.active)
                .setVisible(data.visible);

            if (data.awardDate) {
                const awardDate = new Date(data.awardDate);
                awardDate.setHours(0,0,0,0);
                vo.setAwardDate(awardDate);
            }

            if (data.startDate) {
                const startDate = new Date(data.startDate);
                startDate.setHours(0,0,0,0);
                vo.setStartDate(startDate);
            }

            if (data.targetCompletionDate) {
                const targetCompletionDate = new Date(data.targetCompletionDate);
                targetCompletionDate.setHours(0,0,0,0);
                vo.setTargetCompletionDate(targetCompletionDate);
            }

            if (data.title) {
                vo.setTitle(data.title);
            }

            return vo;
        }
    }
});

},
'api/project/stage/data/Contract':function(){
define([], function() {
    return class Contract {
        constructor(
            projectStagePK,
            projectPK,
            originalValue,
            phase,
            costCentrePK
        ) {
            this.projectStagePK = projectStagePK;
            this.projectPK = projectPK;
            this.originalValue = originalValue;
            this.phase = phase;
            this.costCentrePK = costCentrePK;

            this.contractPK = null;
            this.awardDate = null;
            this.startDate = null;
            this.notes = null;
            this.targetCompletionDate = null;
            this.active = true;
            this.visible = true;
            this.leadTeamPK = null;
            this.teamHistoryPK = null;
            this.title = null;
        }

        getProjectStagePK() {
            return this.projectStagePK;
        }

        getProjectPK() {
            return this.projectPK;
        }

        getOriginalValue() {
            return this.originalValue;
        }

        getPhase() {
            return this.phase;
        }

        getCostCentrePK() {
            return this.costCentrePK;
        }

        setAwardDate(awardDate) {
            this.awardDate = awardDate;
            return this;
        }

        getAwardDate() {
            return this.awardDate;
        }

        setContractPK(contractPK) {
            this.contractPK = contractPK;
            return this;
        }

        getContractPK() {
            return this.contractPK;
        }

        setStartDate(startDate) {
            this.startDate = startDate;
            return this;
        }

        getStartDate() {
            return this.startDate;
        }

        setNotes(notes) {
            this.notes = notes;
            return this;
        }

        getNotes() {
            return this.notes;
        }

        setTargetCompletionDate(targetCompletionDate) {
            this.targetCompletionDate = targetCompletionDate;
            return this;
        }

        getTargetCompletionDate() {
            return this.targetCompletionDate;
        }

        setActive(active) {
            this.active = active;
            return this;
        }

        isActive() {
            return this.active;
        }

        setVisible(visible) {
            this.visible = visible;
            return this;
        }

        isVisible() {
            return this.visible;
        }

        setLeadTeamPK(leadTeamPK) {
            this.leadTeamPK = leadTeamPK;
            return this;
        }

        getLeadTeamPK() {
            return this.leadTeamPK;
        }

        setTeamHistoryPK(teamHistoryPK) {
            this.teamHistoryPK = teamHistoryPK;
            return this;
        }

        getTeamHistoryPK() {
            return this.teamHistoryPK;
        }

        setTitle(title) {
            this.title = title;
            return this;
        }

        getTitle() {
            return this.title;
        }

        clone() {
            return Object.assign(new Contract(), this);
        }

        equals(data) {
            const awardDate = this.awardDate ? this.awardDate.getTime() : null;
            const incomingAwardDate = data.getAwardDate() ? data.getAwardDate().getTime() : null;
            const startDate = this.startDate ? this.startDate.getTime() : null;
            const incomingStartDate = data.getStartDate() ? data.getStartDate().getTime() : null;
            const targetCompletionDate = data.getTargetCompletionDate() ? data.getTargetCompletionDate().getTime() : null;
            const incomingTargetCompletionDate = data.getTargetCompletionDate() ? data.getTargetCompletionDate().getTime() : null;
            const title = this.title ? this.title.replace(/\s+/g, '') : null;
            const incomingTitle = data.getTitle() ? data.getTitle().replace(/\s+/g, '') : null;
            const notes = this.notes ? this.notes.replace(/\s+/g, '') : null;
            const incomingNotes = data.getNotes() ? data.getNotes().replace(/\s+/g, '') : null;

            return this.projectStagePK === data.getProjectStagePK()
                && this.projectPK === data.getProjectPK()
                && this.originalValue == data.getOriginalValue()
                && this.phase === data.getPhase()
                && this.costCentrePK == data.getCostCentrePK()
                && this.contractPK === data.getContractPK()
                && awardDate === incomingAwardDate
                && startDate === incomingStartDate
                && notes === incomingNotes
                && targetCompletionDate === incomingTargetCompletionDate
                && this.active === data.isActive()
                && this.visible === data.isVisible()
                && this.leadTeamPK === data.getLeadTeamPK()
                && this.teamHistoryPK === data.getTeamHistoryPK()
                && title === incomingTitle;
        }
    }
})

},
'spencer/data-manager/core/request/action/Project/Stage/Lead':function(){
define([
    'api/project/stage/parser/Lead',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    LeadParser,
    RequestCanceller,
    ActionData
) {
    return class Lead {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();

            this.leadParser = new LeadParser();
        }

        canAction() {
            return !!this.requestData.getContext()['id'];
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            let url = this.url;

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();
                return this._parseData(data);
            })

            return this.fetchWrapper.get(url.replace(':projectStagePK', context['id']));
        }

        _parseData(data) {
            return this.leadParser.parse(data);
        }
    }
});

},
'api/project/stage/parser/Lead':function(){
define([
    "../data/Lead"
], function (
    LeadVO
) {
    return class Lead {
        parse(data) {
            const vo = new LeadVO(
                data.leadPK,
                data.projectPK,
                data.projectStagePK,
                data.clientsBudget,
                data.costCentrePK
            );

            vo.setNotes(data.notes || null)
                .setTitle(data.title || null)
                .setActive(data.active)
                .setVisible(data.visible)
                .setLeadTeamPK(data.leadTeamPK || null)
                .setTeamHistoryPK(data.teamHistoryPK || null)
                .setStatus(data.status || null)
                .setTenderDueMonth(data.tenderDueMonth || null)
                .setTenderDueQuarter(data.tenderDueQuarter || null)
                .setTenderDueYear(data.tenderDueYear || null);

            if (data.tenderDueDate) {
                const tenderDueDate = new Date(data.tenderDueDate);
                tenderDueDate.setHours(0,0,0,0);
                vo.setTenderDueDate(tenderDueDate);
            }

            return vo;
        }
    }
});

},
'api/project/stage/data/Lead':function(){
define([], function() {
    return class Lead {
        constructor(
            leadPK,
            projectPK,
            projectStagePK,
            clientsBudget,
            costCentrePK
        ) {
            this.leadPK = leadPK;
            this.projectPK = projectPK;
            this.projectStagePK = projectStagePK;
            this.clientsBudget = clientsBudget;
            this.costCentrePK = costCentrePK;

            this.active = true;
            this.leadTeamPK = null;
            this.notes = null;
            this.status = null;
            this.teamHistoryPK = null;
            this.tenderDueMonth = null;
            this.tenderDueQuarter = null;
            this.tenderDueYear = null;
            this.tenderDueDate = null;
            this.title = null;
            this.visible = true;
        }

        getLeadPK() {
            return this.leadPK;
        }

        getProjectPK() {
            return this.projectPK;
        }

        getProjectStagePK() {
            return this.projectStagePK;
        }

        getClientsBudget() {
            return this.clientsBudget;
        }

        getCostCentrePK() {
            return this.costCentrePK;
        }

        setActive(active) {
            this.active = active;
            return this;
        }

        isActive() {
            return this.active;
        }

        setLeadTeamPK(leadTeamPK) {
            this.leadTeamPK = leadTeamPK;
            return this;
        }

        getLeadTeamPK() {
            return this.leadTeamPK;
        }

        setNotes(notes) {
            this.notes = notes;
            return this;
        }

        getNotes() {
            return this.notes;
        }

        setStatus(status) {
            this.status = status;
            return this;
        }

        getStatus() {
            return this.status;
        }

        setTeamHistoryPK(teamHistoryPK) {
            this.teamHistoryPK = teamHistoryPK;
            return this;
        }

        getTeamHistoryPK() {
            return this.teamHistoryPK;
        }

        setTenderDueMonth(tenderDueMonth) {
            this.tenderDueMonth = tenderDueMonth;
            return this;
        }

        getTenderDueMonth() {
            return this.tenderDueMonth;
        }

        setTenderDueQuarter(tenderDueQuarter) {
            this.tenderDueQuarter = tenderDueQuarter;
            return this;
        }

        getTenderDueQuarter() {
            return this.tenderDueQuarter
        }

        setTenderDueYear(tenderDueYear) {
            this.tenderDueYear = tenderDueYear;
            return this;
        }

        getTenderDueYear() {
            return this.tenderDueYear;
        }

        setTenderDueDate(tenderDueDate) {
            this.tenderDueDate = tenderDueDate;
            return this;
        }

        getTenderDueDate() {
            return this.tenderDueDate;
        }

        setTitle(title) {
            this.title = title;
            return this;
        }

        getTitle() {
            return this.title;
        }

        setVisible(visible) {
            this.visible = visible;
            return this;
        }

        isVisible() {
            return this.visible;
        }

        clone() {
            return Object.assign(new Lead(), this);
        }

        equals(data) {
            const notes = this.notes ? this.notes.replace(/\s+/g, '') : null;
            const incomingNotes = data.getNotes() ? data.getNotes().replace(/\s+/g, '') : null;
            const title = this.getTitle() ? this.getTitle().replace(/\s+/g, '') : null;
            const incomingTitle = data.getTitle() ? data.getTitle().replace(/\s+/g, '') : null;

            return this.leadPK === data.getLeadPK()
                && this.projectPK === data.getProjectPK()
                && this.projectStagePK === data.getProjectStagePK()
                && this.clientsBudget == data.getClientsBudget()
                && this.costCentrePK === data.getCostCentrePK()
                && this.active === data.isActive()
                && this.leadTeamPK === data.getLeadTeamPK()
                && notes === incomingNotes
                && this.status === data.getStatus()
                && this.teamHistoryPK === data.getTeamHistoryPK()
                && this.tenderDueMonth === data.getTenderDueMonth()
                && this.tenderDueYear == data.getTenderDueYear()
                && title === incomingTitle
                && this.visible === data.isVisible();
        }
    }
})

},
'spencer/data-manager/core/request/action/Project/Stage/Prequal':function(){
define([
    'api/project/stage/parser/Prequal',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    PrequalParser,
    RequestCanceller,
    ActionData
) {
    return class Prequal {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();

            this.prequalParser = new PrequalParser();
        }

        canAction() {
            return true;
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            const url = this.url.replace(':projectStagePK', context['id']);

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();
                return this._parseData(data);
            })

            return this.fetchWrapper.get(url);
        }

        _parseData(data) {
            return this.prequalParser.parse(data);
        }
    }
});

},
'api/project/stage/parser/Prequal':function(){
define([
    "../data/Prequal",
    "api/project/stage/budget/parser/Status",
    "api/project/stage/prequal/parser/For"
], function (
    PrequalVO,
    StatusParser,
    PrequalForParser
) {
    return class Budget {

        parse(data) {
            const vo = new PrequalVO(
                data.prequalPK,
                data.projectPK,
                data.projectStagePK,
                data.clientsBudget,
                data.costCentrePK
            );

            vo.setTitle(data.title || null)
                .setActive(data.active)
                .setVisible(data.visible)
                .setPreSubmissionNotes(data.preSubmissionNotes || null)
                .setPostSubmissionNotes(data.postSubmissionNotes || null)
                .setLeadTeamPK(data.leadTeamPK || null)
                .setTeamHistoryPK(data.teamHistoryPK || null);

            if (data.receivedDate) {
                const receivedDate = new Date(data.receivedDate);
                receivedDate.setHours(0,0,0,0);
                vo.setReceivedDate(receivedDate);
            }

            if (data.submissionDate) {
                const submissionDate = new Date(data.submissionDate);
                submissionDate.setHours(0,0,0,0);
                vo.setSubmissionDate(submissionDate);
            }

            if (data.tenderDueDate) {
                const tenderDueDate = new Date(data.tenderDueDate);
                tenderDueDate.setHours(0,0,0,0);
                vo.setTenderDueDate(tenderDueDate);
            }

            if (data.prequalStatus) {
                vo.setPrequalStatus(new StatusParser().parse(data.prequalStatus));
            }

            if (data.prequalFor) {
                vo.setPrequalFor(new PrequalForParser().parse(data.prequalFor));
            }

            return vo;
        }
    }
});

},
'api/project/stage/data/Prequal':function(){
define([], function() {
    return class Prequal {
        constructor(
            prequalPK,
            projectPK,
            projectStagePK,
            clientsBudget,
            costCentrePK
        ) {
            this.prequalPK = prequalPK;
            this.projectPK = projectPK;
            this.projectStagePK = projectStagePK;
            this.clientsBudget = clientsBudget;
            this.costCentrePK = costCentrePK;

            this.prequalStatus = null;
            this.prequalFor = null;
            this.receivedDate = null;
            this.submissionDate = null;
            this.tenderDueDate = null;
            this.preSubmissionNotes = null;
            this.postSubmissionNotes = null;
            this.title = null;
            this.active = true;
            this.visible = true;
            this.leadTeamPK = null;
            this.teamHistoryPK = null;
        }

        getPrequalPK() {
            return this.prequalPK;
        }

        getProjectPK() {
            return this.projectPK;
        }

        getProjectStagePK() {
            return this.projectStagePK;
        }

        getClientsBudget() {
            return this.clientsBudget;
        }

        getCostCentrePK() {
            return this.costCentrePK;
        }

        setPrequalStatus(prequalStatus) {
            this.prequalStatus = prequalStatus;
            return this;
        }

        getPrequalStatus() {
            return this.prequalStatus;
        }

        setPrequalFor(prequalFor) {
            this.prequalFor = prequalFor;
            return this;
        }

        getPrequalFor() {
            return this.prequalFor;
        }

        setReceivedDate(receivedDate) {
            this.receivedDate = receivedDate;
            return this;
        }

        getReceivedDate() {
            return this.receivedDate;
        }

        setSubmissionDate(submissionDate) {
            this.submissionDate = submissionDate;
            return this;
        }

        getSubmissionDate() {
            return this.submissionDate;
        }

        setTenderDueDate(tenderDueDate) {
            this.tenderDueDate = tenderDueDate;
            return this;
        }

        getTenderDueDate() {
            return this.tenderDueDate;
        }

        setPreSubmissionNotes(preSubmissionNotes) {
            this.preSubmissionNotes = preSubmissionNotes;
            return this;
        }

        getPreSubmissionNotes() {
            return this.preSubmissionNotes;
        }

        setPostSubmissionNotes(postSubissionNotes) {
            this.postSubmissionNotes = postSubissionNotes;
            return this;
        }

        getPostSubmissionNotes() {
            return this.postSubmissionNotes;
        }

        setActive(active) {
            this.active = active;
            return this;
        }

        isActive() {
            return this.active;
        }

        setVisible(visible) {
            this.visible = visible;
            return this;
        }

        isVisible() {
            return this.visible;
        }

        setLeadTeamPK(leadTeamPK) {
            this.leadTeamPK = leadTeamPK;
            return this;
        }

        getLeadTeamPK() {
            return this.leadTeamPK;
        }

        setTeamHistoryPK(teamHistoryPK) {
            this.teamHistoryPK = teamHistoryPK;
            return this;
        }

        getTeamHistoryPK() {
            return this.teamHistoryPK;
        }

        setTitle(title) {
            this.title = title;
            return this;
        }

        getTitle() {
            return this.title;
        }

        clone() {
            return Object.assign(new Prequal(), this);
        }

        equals(data) {
            const title = this.title ? this.title.replace(/\s+/g, '') : null;
            const incomingTitle = data.getTitle() ? data.getTitle().replace(/\s+/g, '') : null;
            const preSubmissionNotes = this.preSubmissionNotes ? this.preSubmissionNotes.replace(/\s+/g, '') : null;
            const incomingPreSubmissionNotes = data.getPreSubmissionNotes() ? data.getPreSubmissionNotes().replace(/\s+/g, '') : null;
            const postSubmissionNotes = this.postSubmissionNotes ? this.postSubmissionNotes.replace(/\s+/g, '') : null;
            const incomingPostSubmissionNotes = data.getPostSubmissionNotes() ? data.getPostSubmissionNotes().replace(/\s+/g, '') : null;
            const receivedDate = this.receivedDate ? this.receivedDate.getTime() : null;
            const incomingReceivedDate = data.getReceivedDate() ? data.getReceivedDate().getTime() : null;
            const tenderDueDate = this.tenderDueDate ? this.tenderDueDate.getTime() : null;
            const incomingTenderDueDate = data.tenderDueDate ? data.tenderDueDate.getTime() : null;
            const submissionDate = this.submissionDate ? this.submissionDate.getTime() : null;
            const incomingSubmissionDate = data.getSubmissionDate() ? data.getSubmissionDate().getTime() : null;

            return this.prequalPK === data.getPrequalPK()
                && this.projectPK === data.getProjectPK()
                && this.projectStagePK === data.getProjectStagePK()
                && this.clientsBudget == data.getClientsBudget()
                && this.costCentrePK === data.getCostCentrePK()
                && this.prequalStatus.getProjectStageStatusID() === data.getPrequalStatus().getProjectStageStatusID()
                && this.prequalFor.getPrequalForID() === data.getPrequalFor().getPrequalForID()
                && receivedDate === incomingReceivedDate
                && submissionDate === incomingSubmissionDate
                && tenderDueDate === incomingTenderDueDate
                && preSubmissionNotes === incomingPreSubmissionNotes
                && postSubmissionNotes === incomingPostSubmissionNotes
                && title === incomingTitle
                && this.active === data.isActive()
                && this.visible === data.isVisible()
                && this.leadTeamPK === data.getLeadTeamPK()
                && this.teamHistoryPK === data.getTeamHistoryPK();
        }
    }
})

},
'api/project/stage/prequal/parser/For':function(){
define([
    'spencer/project/stage/prequal/data/For'
], function (
    ForVO
) {
    return class For {
        parse(data) {
            return new ForVO(
                data.prequalForID,
                data.description
            );
        }
    }
});

},
'spencer/project/stage/prequal/data/For':function(){
define([], function () {
    return class For {
        constructor(
            prequalForID,
            description
        ) {
            this.prequalForID = prequalForID;
            this.description = description;
        }

        getPrequalForID() {
            return this.prequalForID;
        }

        getDescription() {
            return this.description;
        }
    }
});

},
'spencer/data-manager/core/request/action/Project/Stage/TenderOffer':function(){
define([
    'api/project/stage/parser/TenderOffer',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    TenderOfferParser,
    RequestCanceller,
    ActionData
) {
    return class TenderOffer {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();

            this.tenderOfferParser = new TenderOfferParser();
        }

        canAction() {
            return !!this.requestData.getContext()['id'];
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            const url = this.url.replace(':projectStagePK', context['id']);

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();
                return this._parseData(data);
            })

            return this.fetchWrapper.get(url);
        }

        _parseData(data) {
            return this.tenderOfferParser.parse(data);
        }
    }
});

},
'api/project/stage/parser/TenderOffer':function(){
define([
    "../data/TenderOffer"
], function (
    TenderOfferVO
) {
    return class TenderOffer {
        parse(data) {
            const vo = new TenderOfferVO(
                data.tenderOfferPK,
                data.projectPK,
                data.projectStagePK,
                data.clientsBudget,
                data.costCentrePK
            );

            vo.setTitle(data.title || null)
                .setVotedTo(data.votedTo || null)
                .setPreSubmissionNotes(data.preSubmissionNotes || null)
                .setPostSubmissionNotes(data.postSubmissionNotes || null)
                .setActive(data.active)
                .setVisible(data.visible)
                .setLeadTeamPK(data.leadTeamPK || null)
                .setTeamHistoryPK(data.teamHistoryPK || null);

            if (data.receivedDate) {
                const receivedDate = new Date(data.receivedDate);
                receivedDate.setHours(0,0,0,0);
                vo.setReceivedDate(receivedDate);
            }

            if (data.tenderDueDate) {
                const tenderDueDate = new Date(data.tenderDueDate);
                tenderDueDate.setHours(0,0,0,0);
                vo.setTenderDueDate(tenderDueDate);
            }

            return vo;
        }
    }
});

},
'api/project/stage/data/TenderOffer':function(){
define([], function() {
    return class TenderOffer {
        constructor(
            tenderOfferPK,
            projectPK,
            projectStagePK,
            clientsBudget,
            costCentrePK
        ) {
            this.tenderOfferPK = tenderOfferPK;
            this.projectPK = projectPK;
            this.projectStagePK = projectStagePK;
            this.clientsBudget = clientsBudget;
            this.costCentrePK = costCentrePK;

            this.votedTo = null;
            this.receivedDate = null;
            this.tenderDueDate = null;
            this.preSubmissionNotes = null;
            this.postSubmissionNotes = null;
            this.title = null;
            this.active = true;
            this.visible = true;
            this.leadTeamPK = null;
            this.teamHistoryPK = null;
        }

        getTenderOfferPK() {
            return this.tenderOfferPK;
        }

        getProjectPK() {
            return this.projectPK;
        }

        getProjectStagePK() {
            return this.projectStagePK;
        }

        getClientsBudget() {
            return this.clientsBudget;
        }

        getCostCentrePK() {
            return this.costCentrePK;
        }

        setVotedTo(votedTo) {
            this.votedTo = votedTo;
            return this;
        }

        getVotedTo() {
            return this.votedTo;
        }

        setReceivedDate(receivedDate) {
            this.receivedDate = receivedDate;
            return this;
        }

        getReceivedDate() {
            return this.receivedDate;
        }

        setSubmissionDate(submissionDate) {
            this.submissionDate = submissionDate;
            return this;
        }

        getSubmissionDate() {
            return this.submissionDate;
        }

        setTenderDueDate(tenderDueDate) {
            this.tenderDueDate = tenderDueDate;
            return this;
        }

        getTenderDueDate() {
            return this.tenderDueDate;
        }

        setPreSubmissionNotes(preSubmissionNotes) {
            this.preSubmissionNotes = preSubmissionNotes;
            return this;
        }

        getPreSubmissionNotes() {
            return this.preSubmissionNotes;
        }

        setPostSubmissionNotes(postSubissionNotes) {
            this.postSubmissionNotes = postSubissionNotes;
            return this;
        }

        getPostSubmissionNotes() {
            return this.postSubmissionNotes;
        }

        setActive(active) {
            this.active = active;
            return this;
        }

        isActive() {
            return this.active;
        }

        setVisible(visible) {
            this.visible = visible;
            return this;
        }

        isVisible() {
            return this.visible;
        }

        setLeadTeamPK(leadTeamPK) {
            this.leadTeamPK = leadTeamPK;
            return this;
        }

        getLeadTeamPK() {
            return this.leadTeamPK;
        }

        setTeamHistoryPK(teamHistoryPK) {
            this.teamHistoryPK = teamHistoryPK;
            return this;
        }

        getTeamHistoryPK() {
            return this.teamHistoryPK;
        }

        setTitle(title) {
            this.title = title;
            return this;
        }

        getTitle() {
            return this.title;
        }

        clone() {
            return Object.assign(new TenderOffer(), this);
        }

        equals(data) {
            const title = this.title ? this.title.replace(/\s+/g, '') : null;
            const incomingTitle = data.getTitle() ? data.getTitle().replace(/\s+/g, '') : null;
            const preSubmissionNotes = this.preSubmissionNotes ? this.preSubmissionNotes.replace(/\s+/g, '') : null;
            const incomingPreSubmissionNotes = data.getPreSubmissionNotes() ? data.getPreSubmissionNotes().replace(/\s+/g, '') : null;
            const postSubmissionNotes = this.postSubmissionNotes ? this.postSubmissionNotes.replace(/\s+/g, '') : null;
            const incomingPostSubmissionNotes = data.getPostSubmissionNotes() ? data.getPostSubmissionNotes().replace(/\s+/g, '') : null;
            const receivedDate = this.receivedDate ? this.receivedDate.getTime() : null;
            const incomingReceivedDate = data.getReceivedDate() ? data.getReceivedDate().getTime() : null;
            const tenderDueDate = this.tenderDueDate ? this.tenderDueDate.getTime() : null;
            const incomingTenderDueDate = data.getTenderDueDate() ? data.getTenderDueDate().getTime() : null;

            return this.tenderOfferPK === data.getTenderOfferPK()
                && this.projectPK === data.getProjectPK()
                && this.projectStagePK === data.getProjectStagePK()
                && this.clientsBudget == data.getClientsBudget()
                && this.costCentrePK === data.getCostCentrePK()
                && this.votedTo === data.getVotedTo()
                && receivedDate === incomingReceivedDate
                && tenderDueDate === incomingTenderDueDate
                && preSubmissionNotes === incomingPreSubmissionNotes
                && postSubmissionNotes === incomingPostSubmissionNotes
                && title === incomingTitle
                && this.active === data.isActive()
                && this.visible === data.isVisible()
                && this.leadTeamPK === data.getLeadTeamPK()
                && this.teamHistoryPK === data.getTeamHistoryPK();
        }
    }
})

},
'spencer/data-manager/core/request/action/Project/Stage/Tender':function(){
define([
    'api/project/stage/parser/Tender',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    TenderParser,
    RequestCanceller,
    ActionData
) {
    return class Tender {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();

            this.parser = new TenderParser();
        }

        canAction() {
            return !!this.requestData.getContext()['id'];
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            const url = this.url.replace(':projectStagePK', context['id']);

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();
                return this._parseData(data);
            })

            return this.fetchWrapper.get(url);
        }

        _parseData(data) {
            return this.parser.parse(data);
        }
    }
});

},
'api/project/stage/parser/Tender':function(){
define([
    "../data/Tender",
    "api/project/stage/budget/parser/Status"
], function (
    TenderVO,
    StatusParser
) {
    return class Tender {
        parse(data) {
            const vo = new TenderVO(
                data.tenderPK,
                data.projectPK,
                data.projectStagePK,
                data.clientsBudget,
                data.costCentrePK
            );

            if (data.receivedDate) {
                const receivedDate = new Date(data.receivedDate);
                receivedDate.setHours(0,0,0,0);
                vo.setReceivedDate(receivedDate);
            }

            if (data.submissionDate) {
                const submissionDate = new Date(data.submissionDate);
                submissionDate.setHours(0,0,0,0);
                vo.setSubmissionDate(submissionDate);
            }

            if (data.tenderStatus) {
                vo.setTenderStatus(new StatusParser().parse(data.tenderStatus));
            }

            vo.setPreSubmissionNotes(data.preSubmissionNotes || null)
                .setPostSubmissionNotes(data.postSubmissionNotes || null)
                .setTitle(data.title || null)
                .setActive(data.active)
                .setVisible(data.visible)
                .setLeadTeamPK(data.leadTeamPK || null)
                .setTeamHistoryPK(data.teamHistoryPK || null);

            return vo;
        }
    }
});

},
'api/project/stage/data/Tender':function(){
define([], function() {
    return class Tender {
        constructor(
            tenderPK,
            projectPK,
            projectStagePK,
            clientsBudget,
            costCentrePK
        ) {
            this.tenderPK = tenderPK;
            this.projectPK = projectPK;
            this.projectStagePK = projectStagePK;
            this.clientsBudget = clientsBudget;
            this.costCentrePK = costCentrePK;

            this.receivedDate = null;
            this.submissionDate = null;
            this.tenderStatus = null;
            this.preSubmissionNotes = null;
            this.postSubmissionNotes = null;
            this.title = null;
            this.active = true;
            this.visible = true;
            this.leadTeamPK = null;
            this.teamHistoryPK = null;
        }

        getTenderPK() {
            return this.tenderPK;
        }

        getProjectPK() {
            return this.projectPK;
        }

        getProjectStagePK() {
            return this.projectStagePK;
        }

        getClientsBudget() {
            return this.clientsBudget;
        }

        getCostCentrePK() {
            return this.costCentrePK;
        }

        setReceivedDate(receivedDate) {
            this.receivedDate = receivedDate;
            return this;
        }

        getReceivedDate() {
            return this.receivedDate;
        }

        setSubmissionDate(submissionDate) {
            this.submissionDate = submissionDate;
            return this;
        }

        getSubmissionDate() {
            return this.submissionDate;
        }

        getTenderStatus() {
            return this.tenderStatus;
        }

        setTenderStatus(tenderStatus) {
            this.tenderStatus = tenderStatus;
            return this;
        }

        setPreSubmissionNotes(preSubmissionNotes) {
            this.preSubmissionNotes = preSubmissionNotes;
            return this;
        }

        getPreSubmissionNotes() {
            return this.preSubmissionNotes;
        }

        setPostSubmissionNotes(postSubissionNotes) {
            this.postSubmissionNotes = postSubissionNotes;
            return this;
        }

        getPostSubmissionNotes() {
            return this.postSubmissionNotes;
        }

        setActive(active) {
            this.active = active;
            return this;
        }

        isActive() {
            return this.active;
        }

        setVisible(visible) {
            this.visible = visible;
            return this;
        }

        isVisible() {
            return this.visible;
        }

        setLeadTeamPK(leadTeamPK) {
            this.leadTeamPK = leadTeamPK;
            return this;
        }

        getLeadTeamPK() {
            return this.leadTeamPK;
        }

        setTeamHistoryPK(teamHistoryPK) {
            this.teamHistoryPK = teamHistoryPK;
            return this;
        }

        getTeamHistoryPK() {
            return this.teamHistoryPK;
        }

        setTitle(title) {
            this.title = title;
            return this;
        }

        getTitle() {
            return this.title;
        }

        clone() {
            return Object.assign(new Tender(), this);
        }

        equals(data) {
            const title = this.title ? this.title.replace(/\s+/g, '') : null;
            const incomingTitle = data.getTitle() ? data.getTitle().replace(/\s+/g, '') : null;
            const preSubmissionNotes = this.preSubmissionNotes ? this.preSubmissionNotes.replace(/\s+/g, '') : null;
            const incomingPreSubmissionNotes = data.getPreSubmissionNotes() ? data.getPreSubmissionNotes().replace(/\s+/g, '') : null;
            const postSubmissionNotes = this.postSubmissionNotes ? this.postSubmissionNotes.replace(/\s+/g, '') : null;
            const incomingPostSubmissionNotes = data.getPostSubmissionNotes() ? data.getPostSubmissionNotes().replace(/\s+/g, '') : null;
            const receivedDate = this.receivedDate ? this.receivedDate.getTime() : null;
            const incomingReceivedDate = data.getReceivedDate() ? data.getReceivedDate().getTime() : null;
            const submissionDate = this.submissionDate ? this.submissionDate.getTime() : null;
            const incomingSubmissionDate = data.getSubmissionDate() ? data.getSubmissionDate().getTime() : null;

            return this.tenderPK === data.getTenderPK()
                && this.projectPK === data.getProjectPK()
                && this.projectStagePK === data.getProjectStagePK()
                && this.clientsBudget == data.getClientsBudget()
                && this.costCentrePK === data.getCostCentrePK()
                && receivedDate === incomingReceivedDate
                && submissionDate === incomingSubmissionDate
                && this.tenderStatus.getProjectStageStatusID() === data.getTenderStatus()
                && preSubmissionNotes === incomingPreSubmissionNotes
                && postSubmissionNotes === incomingPostSubmissionNotes
                && title === incomingTitle
                && this.active === data.isActive()
                && this.visible === data.isVisible()
                && this.leadTeamPK === data.getLeadTeamPK()
                && this.teamHistoryPK === data.getTeamHistoryPK();
        }
    }
})

},
'spencer/data-manager/core/request/action/Project/Stage/Intelligence':function(){
define([
    'api/project/stage/parser/Intelligence',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    Parser,
    RequestCanceller,
    ActionData
) {
    return class Intelligence {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();

            this.parser = new Parser();
        }

        canAction() {
            return true;
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            const url = this.url.replace(':projectStagePK', context['id']);

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();
                return this._parseData(data);
            })

            return this.fetchWrapper.get(url);
        }

        _parseData(data) {
            return this.parser.parse(data);
        }
    }
});

},
'api/project/stage/parser/Intelligence':function(){
define([
    "../data/Intelligence"
], function (
    IntelligenceVO
) {
    return class Intelligence {
        parse(data) {
            const vo = new IntelligenceVO(
                data.intelligencePK,
                data.projectPK,
                data.projectStagePK,
                data.costCentrePK
            );

            vo.setTitle(data.title || null)
                .setLeadTeamPK(data.leadTeamPK || null)
                .setTeamHistoryPK(data.teamHistoryPK || null)
                .setAnticipatedValue(data.anticipatedValue || 0.00)
                .setStatus(data.status || null)
                .setVisible(data.visible)
                .setActive(data.active);

            return vo;
        }
    }
});

},
'api/project/stage/data/Intelligence':function(){
define([], function() {
    return class Intelligence {
        constructor(
            intelligencePK,
            projectPK,
            projectStagePK,
            costCentrePK
        ) {
            this.intelligencePK = intelligencePK;
            this.projectPK = projectPK;
            this.projectStagePK = projectStagePK;
            this.costCentrePK = costCentrePK;

            this.anticipatedValue = 0.00;
            this.status = null;
            this.title = null;
            this.active = true;
            this.visible = true;
            this.leadTeamPK = null;
            this.teamHistoryPK = null;
        }

        getIntelligencePK() {
            return this.intelligencePK;
        }

        getProjectPK() {
            return this.projectPK;
        }

        getProjectStagePK() {
            return this.projectStagePK;
        }

        getCostCentrePK() {
            return this.costCentrePK;
        }

        setActive(active) {
            this.active = active;
            return this;
        }

        isActive() {
            return this.active;
        }

        setAnticipatedValue(value) {
            this.anticipatedValue = value;
            return this;
        }

        getAnticipatedValue() {
            return this.anticipatedValue;
        }

        setStatus(status) {
            this.status = status;
            return this;
        }

        getStatus() {
            return this.status;
        }

        setVisible(visible) {
            this.visible = visible;
            return this;
        }

        isVisible() {
            return this.visible;
        }

        setLeadTeamPK(leadTeamPK) {
            this.leadTeamPK = leadTeamPK;
            return this;
        }

        getLeadTeamPK() {
            return this.leadTeamPK;
        }

        setTeamHistoryPK(teamHistoryPK) {
            this.teamHistoryPK = teamHistoryPK;
            return this;
        }

        getTeamHistoryPK() {
            return this.teamHistoryPK;
        }

        setTitle(title) {
            this.title = title;
            return this;
        }

        getTitle() {
            return this.title;
        }

        clone() {
            return Object.assign(new Intelligence(), this);
        }

        equals(data) {
            const title = this.getTitle() ? this.getTitle().replace(/\s+/g, '') : null;
            const incomingTitle = data.getTitle() ? data.getTitle().replace(/\s+/g, '') : null;

            return this.intelligencePK === data.getIntelligencePK()
                && this.projectPK === data.getProjectPK()
                && this.projectStagePK === data.getProjectStagePK()
                && this.costCentrePK === data.getCostCentrePK()
                && this.anticipatedValue == data.getAnticipatedValue()
                && this.status === data.getStatus()
                && title === incomingTitle
                && this.active === data.isActive()
                && this.visible === data.isVisible()
                && this.leadTeamPK === data.getLeadTeamPK()
                && this.teamHistoryPK === data.getTeamHistoryPK();
        }
    }
})

},
'spencer/data-manager/core/request/action/Project/Stage/CreateBudget':function(){
define([
    'library/request/Canceller',
    'library/request/data/HTTPResponseCodes',
    'library/request/exception/ErrorResponse',
    'library/request/exception/NoAccess',
    'spencer/data-manager/data/Action'
], function (
    RequestCanceller,
    HTTPResponseCodes,
    ErrorResponse,
    NoAccess,
    ActionData
) {
    return class CreatePrequal {
        constructor(url, requestData, fetchFactory, formDataWrapper) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
            this.formData = formDataWrapper;
        }

        canAction() {
            const context = this.requestData.getContext();

            return context.isValid();
        }

        getAffected() {
            return [];
        }

        action() {
            if (!this.canAction()) {
                throw 'Invalid Context';
            }

            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();

            this.formData.append('title', context.getTitle());
            this.formData.append('projectPK', context.getProjectPK());
            this.formData.append('budgetStatusPK', context.getProjectStageBudgetStatusPK());
            this.formData.append('receivedDate', context.getReceivedDate());
            this.formData.append('leadTeamPK', context.getLeadTeam());
            this.formData.append('treeTemplatePK', context.getTreeTemplatePK());
            this.formData.append('visible', context.getVisible());
            this.formData.append('isActive', context.getIsActive());
            this.formData.append('clientsBudget', context.getClientsBudget());

            if (context.getSubmissionDate()) {
                this.formData.append('submissionDate', context.getSubmissionDate());
            }

            if (context.getPreSubmissionNotes()) {
                this.formData.append('preSubmissionNotes', context.getPreSubmissionNotes());
            }

            if (context.getPostSubmissionNotes()) {
                this.formData.append('postSubmissionNotes', context.getPostSubmissionNotes());
            }

            this.fetchWrapper.setHandler(HTTPResponseCodes.forbidden, () => {
                throw new NoAccess()
            });

            this.fetchWrapper.setErrorHandler(async (error) => {
                const data = await error.json();
                throw new ErrorResponse(data.description);
            });

            return this.fetchWrapper.post(this.url, {body: this.formData.get()});
        }
    }
});

},
'spencer/data-manager/core/request/action/Project/Stage/CreateContract':function(){
/// <amd-dependency path="library/request/Canceller" name="RequestCanceller" />
/// <amd-dependency path="library/request/data/HTTPResponseCodes" name="HTTPResponseCodes" />
/// <amd-dependency path="library/request/exception/ErrorResponse" name="ErrorResponse" />
/// <amd-dependency path="library/request/exception/NoAccess" name="NoAccess" />
/// <amd-dependency path="spencer/data-manager/data/Action" name="ActionData" />
define(["require", "exports", "library/request/Canceller", "library/request/data/HTTPResponseCodes", "library/request/exception/ErrorResponse", "library/request/exception/NoAccess", "spencer/data-manager/data/Action"], function (require, exports, RequestCanceller, HTTPResponseCodes, ErrorResponse, NoAccess, ActionData) {
    "use strict";
    class CreateContract {
        constructor(url, requestData, fetchFactory, formDataWrapper) {
            this.url = url;
            this.requestData = requestData;
            this.fetchFactory = fetchFactory;
            this.formDataWrapper = formDataWrapper;
            this.fetchWrapper = this.fetchFactory.get();
        }
        canAction() {
            const context = this.requestData.getContext();
            return context.isValid();
        }
        getAffected(entity) {
            return [];
        }
        action() {
            if (!this.canAction()) {
                throw 'Invalid Context';
            }
            return new ActionData(new RequestCanceller(this.fetchWrapper), this._request(), this.requestData);
        }
        async _request() {
            const context = this.requestData.getContext();
            this.formDataWrapper.append('title', context.getTitle());
            this.formDataWrapper.append('projectPK', context.getProjectPK());
            this.formDataWrapper.append('awardDate', context.getAwardDate());
            this.formDataWrapper.append('startDate', context.getStartDate());
            this.formDataWrapper.append('notes', context.getNotes() || '');
            this.formDataWrapper.append('phase', context.getPhase());
            this.formDataWrapper.append('leadTeamPK', context.getLeadTeam());
            this.formDataWrapper.append('treeTemplatePK', context.getTreeTemplatePK());
            this.formDataWrapper.append('visible', context.getVisible());
            this.formDataWrapper.append('isActive', context.getIsActive());
            this._addOptionalFields(context);
            this.fetchWrapper.setErrorHandler(() => {
                throw new ErrorResponse();
            });
            this.fetchWrapper.setHandler(HTTPResponseCodes.bad_request, async (error) => {
                throw new ErrorResponse(await error.json());
            });
            this.fetchWrapper.setErrorHandler(async (error) => {
                const data = await error.json();
                throw new ErrorResponse(data.description);
            });
            this.fetchWrapper.setHandler(HTTPResponseCodes.forbidden, () => {
                throw new NoAccess();
            });
            return this.fetchWrapper.post(this.url, { body: this.formDataWrapper.get() });
        }
        _addOptionalFields(context) {
            if (!!context.getTargetCompletionDate()) {
                this.formDataWrapper.append('targetCompletionDate', context.getTargetCompletionDate());
            }
            if (!!context.getOriginalValue()) {
                this.formDataWrapper.append('originalValue', context.getOriginalValue());
            }
        }
    }
    return CreateContract;
});

},
'spencer/data-manager/core/request/action/Project/Stage/CreateIntelligence':function(){
define([
    'library/request/Canceller',
    'library/request/data/HTTPResponseCodes',
    'library/request/exception/ErrorResponse',
    'library/request/exception/NoAccess',
    'spencer/data-manager/data/Action'
], function(
    RequestCanceller,
    HTTPResponseCodes,
    ErrorResponse,
    NoAccess,
    ActionData
) {
    return class CreateIntelligence {
        constructor(url, requestData, fetchFactory, formDataWrapper) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
            this.formData = formDataWrapper;
        }

        canAction() {
            const context = this.requestData.getContext();

            return context.isValid();
        }

        getAffected() {
            return [];
        }

        action() {
            if (!this.canAction()) {
                throw 'Invalid Context';
            }

            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();

            this.formData.append('title', context.getTitle());
            this.formData.append('projectPK', context.getProjectPK());
            this.formData.append('leadTeamPK', context.getLeadTeamPK());
            this.formData.append('treeTemplatePK', context.getTreeTemplatePK());
            this.formData.append('visible', context.isVisible());
            this.formData.append('isActive', context.isActive());

            if (context.getFollowUpDate()) {
                this.formData.append('followUpDate', this.getDate(context.getFollowUpDate()));
            }

            this._addOptionalFields(context);

            this.fetchWrapper.setErrorHandler(() => {
                throw new ErrorResponse();
            });

            this.fetchWrapper.setErrorHandler(async error => {
                const data = await error.json()
                throw new ErrorResponse(data.description);
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.forbidden, () => {
                throw new NoAccess();
            });

            return this.fetchWrapper.post(this.url, {body: this.formData.get()});
        }

        getDate(date) {
            const dateTimeFormat = new Intl.DateTimeFormat('en-GB', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            }).formatToParts(date);

            let year;
            let month;
            let day;

            dateTimeFormat.forEach(({type, value}) => {
                switch (type) {
                    case "day":
                        day = value;
                    case "month":
                        month = value;
                    case "year":
                        year = value;
                }
            });
            
            return day + '-' + month + '-' + year;
        }

        _addOptionalFields(context) {
            if (!!context.getAnticipatedValue()) {
                this.formData.append('anticipatedValue', context.getAnticipatedValue());
            }

            if (!!context.getStatus()) {
                this.formData.append('status', context.getStatus());
            }
        }
    }
});

},
'spencer/data-manager/core/request/action/Project/Stage/CreateLead':function(){
define([
    'library/request/Canceller',
    'library/request/data/HTTPResponseCodes',
    'library/request/exception/ErrorResponse',
    'library/request/exception/NoAccess',
    'spencer/data-manager/data/Action'
], function (
    RequestCanceller,
    HTTPResponseCodes,
    ErrorResponse,
    NoAccess,
    ActionData
) {
    return class CreateLead {
        constructor(url, requestData, fetchFactory, formDataWrapper) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
            this.formData = formDataWrapper;
        }

        canAction() {
            const context = this.requestData.getContext();

            return context.isValid();
        }

        getAffected() {
            return [];
        }

        action() {
            if (!this.canAction()) {
                throw 'Invalid Context';
            }

            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();

            this.formData.append('title', context.getTitle());
            this.formData.append('projectPK', context.getProjectPK());
            this.formData.append('leadTeamPK', context.getLeadTeamPK());
            this.formData.append('treeTemplatePK', context.getTreeTemplatePK());
            this.formData.append('visible', context.getVisible());
            this.formData.append('isActive', context.getIsActive());

            if (context.getDateUpdated()) {
                this.formData.append('dateUpdated', this.getDate(context.getDateUpdated()));
            }

            this._addOptionalFields(context);

            this.fetchWrapper.setErrorHandler(async error => {
                const data = await error.json()
                throw new ErrorResponse(data.description);
            }); 

            this.fetchWrapper.setHandler(HTTPResponseCodes.bad_request, async error => {
                throw new ErrorResponse(await error.json());
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.forbidden, () => {
                throw new NoAccess()
            });

            return this.fetchWrapper.post(this.url, {body: this.formData.get()});
        }

        _addOptionalFields(context) {
            if (!!context.getClientBudget()) {
                this.formData.append('clientBudget', context.getClientBudget());
            }

            if (!!context.getNotes()) {
                this.formData.append('notes', context.getNotes());
            }

            if (!!context.getTenderDueDate()) {
                const tenderDueDate = context.getTenderDueDate();

                if (tenderDueDate['month'] && tenderDueDate['year']) {
                    this.formData.append('tenderDueDate', tenderDueDate['month'] + '-' + tenderDueDate['year']);
                }
            }

            if (!!context.getStatus()) {
                this.formData.append('status', context.getStatus());
            }
        }

        getDate(date) {
            const dateTimeFormat = new Intl.DateTimeFormat('en-GB', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
            }).formatToParts(date);

            let year;
            let month;
            let day;

            dateTimeFormat.forEach(({type, value}) => {
                switch (type) {
                    case "day":
                        day = value;
                    case "month":
                        month = value;
                    case "year":
                        year = value;
                }
            });

            return day + '-' + month + '-' + year;
        }
    }
});

},
'spencer/data-manager/core/request/action/Project/Stage/CreateTender':function(){
define([
    'library/request/Canceller',
    'library/request/data/HTTPResponseCodes',
    'library/request/exception/ErrorResponse',
    'library/request/exception/NoAccess',
    'spencer/data-manager/data/Action'
], function (
    RequestCanceller,
    HTTPResponseCodes,
    ErrorResponse,
    NoAccess,
    ActionData
) {
    return class CreateTender {
        constructor(url, requestData, fetchFactory, formDataWrapper) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
            this.formData = formDataWrapper;
        }

        canAction() {
            const context = this.requestData.getContext();

            return context.isValid();
        }

        getAffected() {
            return [];
        }

        action() {
            if (!this.canAction()) {
                throw 'Invalid Context';
            }

            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();

            this.formData.append('title', context.getTitle());
            this.formData.append('projectPK', context.getProjectPK());
            this.formData.append('receivedDate', context.getReceivedDate());
            this.formData.append('submissionDate', context.getSubmissionDate());
            this.formData.append('tenderStatusPK', context.getTenderStatusPK());
            this.formData.append('clientsBudget', context.getClientsBudget());
            this.formData.append('leadTeamPK', context.getLeadTeamPK());
            this.formData.append('treeTemplatePK', context.getTreeTemplatePK());
            this.formData.append('visible', context.getVisible());
            this.formData.append('isActive', context.getIsActive());

            if (!!context.getPostSubmissionNotes()) {
                this.formData.append('postSubmissionNotes', context.getPostSubmissionNotes());
            }

            if (!!context.getPreSubmissionNotes()) {
                this.formData.append('preSubmissionNotes', context.getPreSubmissionNotes());
            }

            this.fetchWrapper.setErrorHandler(() => {
                throw new ErrorResponse();
            });

            this.fetchWrapper.setErrorHandler(async error => {
                const data = await error.json()
                throw new ErrorResponse(data.description);
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.forbidden, () => {
                throw new NoAccess();
            });

            return this.fetchWrapper.post(this.url, {body: this.formData.get()});
        }
    }
});

},
'spencer/data-manager/core/request/action/Project/Stage/LeadTeam':function(){
define([
    'api/project/stage/parser/LeadTeam',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    LeadTeamParser,
    RequestCanceller,
    ActionData
) {
    return class LeadTeamCollection {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();

            this.leadTeamParser = new LeadTeamParser();
        }

        canAction() {
            return true;
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            let url = this.url;

            if (Object.keys(context).length) {
                url += this._prepareParams(context);
            }

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();

                return this._parseData(data);
            })

            return this.fetchWrapper.get(url);
        }

        _prepareParams(context) {
            const params = [];

            if (context['id']) {
                params.push(context['id']);
            }

            return params.join('&');
        }

        _parseData(leadTeam) {
            return this.leadTeamParser.parse(leadTeam);
        }
    }
});

},
'api/project/stage/parser/LeadTeam':function(){
define([
    'spencer/project/stage/data/LeadTeam'
], function (
    LeadTeamVO
) {
    return class LeadTeam {
        parse(data) {
            const fromDate = new Date(data.fromDate);
            fromDate.setHours(0,0,0,0);
            return new LeadTeamVO(
                data.teamHistoryPK,
                data.teamPK,
                fromDate,
                data.name,
                data.code,
                data.teamLeaderPersonPK,
                data.divisionPK
            );
        }
    }
});

},
'spencer/project/stage/data/LeadTeam':function(){
define([], function () {
    return class LeadTeam {
        constructor(
            teamHistoryPK,
            teamPK,
            fromDate,
            name,
            code,
            teamLeaderPersonPK,
            divisionPK
        ) {
            this.teamHistoryPK = teamHistoryPK;
            this.teamPK = teamPK;
            this.fromDate = fromDate;
            this.name = name;
            this.code = code;
            this.teamLeaderPersonPK = teamLeaderPersonPK;
            this.divisionPK = divisionPK;
        }

        getTeamHistoryPK() {
            return this.teamHistoryPK;
        }

        getTeamPK() {
            return this.teamPK;
        }

        getFromDate() {
            return this.fromDate
        }

        getName() {
            return this.name;
        }

        getCode() {
            return this.code;
        }

        getTeamLeaderPersonPK() {
            return this.teamLeaderPersonPK;
        }

        getDivisionPK() {
            return this.divisionPK;
        }
    }
});
},
'spencer/data-manager/core/request/action/Project/Stage/LeadTeamCollection':function(){
define([
    'api/project/stage/parser/LeadTeam',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    LeadTeamParser,
    RequestCanceller,
    ActionData
) {
    return class LeadTeamCollection {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();

            this.leadTeamParser = new LeadTeamParser();
        }

        canAction() {
            return true;
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            let url = this.url;

            if (Object.keys(context).length) {
                url += '?' + this._prepareParams(context);
            }

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();

                return data.map(item => {
                    return this._parseData(item);
                });
            })

            return this.fetchWrapper.get(url);
        }

        _prepareParams(context) {
            const params = [];

            if (context.getOrganisationPK()) {
                params.push('organisationPK=' + context.getOrganisationPK());
            }

            if (context.getName()) {
                params.push('name=' + context.getName());
            }

            if (context.getLimit()) {
                params.push('limit=' + context.getLimit());
            }

            if (context.getOffset()) {
                params.push('offset=' + context.getOffset());
            }

            return params.join('&');
        }

        _parseData(leadTeam) {
            return this.leadTeamParser.parse(leadTeam);
        }
    }
});
},
'spencer/data-manager/core/request/action/Project/Stage/CreatePrequal':function(){
define([
    'library/request/Canceller',
    'library/request/data/HTTPResponseCodes',
    'library/request/exception/ErrorResponse',
    'library/request/exception/NoAccess',
    'spencer/data-manager/data/Action'
], function (
    RequestCanceller,
    HTTPResponseCodes,
    ErrorResponse,
    NoAccess,
    ActionData
) {
    return class CreatePrequal {
        constructor(url, requestData, fetchFactory, formDataWrapper) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
            this.formData = formDataWrapper;
        }

        canAction() {
            const context = this.requestData.getContext();

            return context.isValid();
        }

        getAffected() {
            return [];
        }

        action() {
            if (!this.canAction()) {
                throw 'Invalid Context';
            }

            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();

            this.formData.append('title', context.getTitle());
            this.formData.append('projectPK', context.getProjectPK());
            this.formData.append('prequalStatusPK', context.getPrequalStatusPK());
            this.formData.append('receivedDate', context.getReceivedDate());
            this.formData.append('leadTeamPK', context.getLeadTeam());
            this.formData.append('treeTemplatePK', context.getTreeTemplatePK());
            this.formData.append('visible', context.getVisible());
            this.formData.append('isActive', context.getIsActive());

            if (context.getTenderDueDate()) {
                this.formData.append('tenderDueDate', context.getTenderDueDate());
            }
            if (context.getSubmissionDate()) {
                this.formData.append('submissionDate', context.getSubmissionDate());
            }

            if (context.getClientsBudget()) {
                this.formData.append('clientsBudget', context.getClientsBudget());
            }

            if (context.getPrequalForPK()) {
                this.formData.append('prequalForPK', context.getPrequalForPK());
            }

            if (context.getPreSubmissionNotes()) {
                this.formData.append('preSubmissionNotes', context.getPreSubmissionNotes());
            }

            if (context.getPostSubmissionNotes()) {
                this.formData.append('postSubmissionNotes', context.getPostSubmissionNotes());
            }

            this.fetchWrapper.setErrorHandler(async error => {
                const data = await error.json()
                throw new ErrorResponse(data.description);
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.bad_request, async error => {
                throw new ErrorResponse(await error.json());
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.forbidden, () => {
                throw new NoAccess()
            });

            return this.fetchWrapper.post(this.url, {body: this.formData.get()});
        }
    }
});

},
'spencer/data-manager/core/request/action/Project/Stage/CreateTenderOffer':function(){
define([
    'library/request/Canceller',
    'library/request/data/HTTPResponseCodes',
    'library/request/exception/ErrorResponse',
    'library/request/exception/NoAccess',
    'spencer/data-manager/data/Action'
], function (
    RequestCanceller,
    HTTPResponseCodes,
    ErrorResponse,
    NoAccess,
    ActionData
) {
    return class CreateTenderOffer {
        constructor(url, requestData, fetchFactory, formDataWrapper) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
            this.formData = formDataWrapper;
        }

        canAction() {
            const context = this.requestData.getContext();
            return context.isValid();
        }

        getAffected() {
            return [];
        }

        action() {
            if (!this.canAction()) {
                throw 'Invalid Context';
            }

            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();

            this.formData.append('title', context.getTitle());
            this.formData.append('projectPK', context.getProjectPK());
            this.formData.append('receivedDate', context.getReceivedDate());
            this.formData.append('leadTeamPK', context.getLeadTeam());
            this.formData.append('treeTemplatePK', context.getTreeTemplatePK());
            this.formData.append('visible', context.getVisible());
            this.formData.append('isActive', context.getIsActive());

            if (context.getTenderDueDate()) {
                this.formData.append('tenderDueDate', context.getTenderDueDate());
            }

            if (context.getVotedTo()) {
                this.formData.append('votedTo', context.getVotedTo());
            }

            if (context.getClientsBudget()) {
                this.formData.append('clientsBudget', context.getClientsBudget());
            }

            if (context.getPreSubmissionNotes()) {
                this.formData.append('preSubmissionNotes', context.getPreSubmissionNotes());
            }

            if (context.getPostSubmissionNotes()) {
                this.formData.append('postSubmissionNotes', context.getPostSubmissionNotes());
            }

            this.fetchWrapper.setErrorHandler(async error => {
                const data = await error.json()
                throw new ErrorResponse(data.description);
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.bad_request, async error => {
                throw new ErrorResponse(await error.json());
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.forbidden, () => {
                throw new NoAccess();
            });

            return this.fetchWrapper.post(this.url, {body: this.formData.get()});
        }
    }
});

},
'spencer/data-manager/core/request/action/Project/Stage/Node':function(){
/// <amd-dependency path="spencer/doc-control/parser/Revision" name="RevisionParser" />
define(["require", "exports", "spencer/doc-control/parser/Revision", "spencer/data-manager/data/Action", "@lib/api/doc-control/tree/parser/Node", "@lib/api/project/parser/ProjectStage"], function (require, exports, RevisionParser, ActionData, NodeParser, ProjectStageParser) {
    "use strict";
    class Node {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchFactory = fetchFactory;
            this.fetchProcessor = this.fetchFactory.get();
            this.nodeParser = new NodeParser(new RevisionParser(), new ProjectStageParser());
        }
        canAction() {
            const context = this.requestData.getContext();
            return !!context['projectStagePK']
                || !!context['treeViewPK'];
        }
        getAffected(entity) {
            return [];
        }
        action() {
            if (!this.canAction()) {
                throw 'Cannot Action';
            }
            return new ActionData(this.fetchProcessor, this.request(), this.requestData);
        }
        request() {
            const context = this.requestData.getContext();
            let url = this.url.replace(':projectStagePK', context['projectStagePK'])
                .replace(':treeViewPK', context['treeViewPK']);
            if (context['includeChildren']) {
                url = url.concat('/includeChildren');
            }
            this.fetchProcessor.setSuccessHandler(async (response) => {
                const data = await response.json();
                return this.nodeParser.parse(data);
            });
            return this.fetchProcessor.get(url);
        }
    }
    return Node;
});

},
'spencer/data-manager/core/request/action/Project/Stage/NumberRangeCollection':function(){
define([
    'api/project/stage/parser/NumberRange',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    NumberRangeParser,
    RequestCanceller,
    ActionData
) {
    return class NumberRangeCollection {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();

            this.numberRangeParser = new NumberRangeParser();
        }

        canAction() {
            return true;
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            let url = this.url;

            if (Object.keys(context).length) {
                url += '?' + this._prepareParams(context);
            }

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();

                return data.map(item => {
                    return this._parseData(item);
                });
            })

            return this.fetchWrapper.get(url);
        }

        _prepareParams(context) {
            const params = [];

            if (context['name']) {
                params.push('name=' + context['name']);
            }

            return params.join('&');
        }

        _parseData(numberRange) {
            return this.numberRangeParser.parse(numberRange);
        }
    }
});
},
'api/project/stage/parser/NumberRange':function(){
define([
    'spencer/project/stage/data/NumberRange'
], function (
    NumberRangeVO
) {
    return class NumberRange {
        parse(data) {
            return new NumberRangeVO(
                data.stageNumberRangePK,
                data.name,
                data.type,
                data.rangeStart,
                data.rangeEnd
            );
        }
    }
});
},
'spencer/project/stage/data/NumberRange':function(){
define([], function () {
    return class NumberRange {
        constructor(
            stageNumberRangePK,
            name,
            type,
            rangeStart,
            rangeEnd
        ) {
            this.stageNumberRangePK = stageNumberRangePK;
            this.name = name;
            this.type = type;
            this.rangeStart = rangeStart;
            this.rangeEnd = rangeEnd;
        }

        getStageNumberRangePK() {
            return this.stageNumberRangePK;
        }

        getName() {
            return this.name;
        }

        getType() {
            return this.type;
        }

        getRangeStart() {
            return this.rangeStart;
        }

        getRangeEnd() {
            return this.rangeEnd;
        }
    }
});
},
'spencer/data-manager/core/request/action/Project/Stage/Prequal/ForCollection':function(){
define([
    'api/project/stage/prequal/parser/For',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    ForParser,
    RequestCanceller,
    ActionData
) {
    return class ForCollection {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();

            this.forParser = new ForParser();
        }

        canAction() {
            return true;
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            let url = this.url;

            if (Object.keys(context).length) {
                url += '?' + this._prepareParams(context);
            }

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();

                return data.map(item => {
                    return this._parseData(item);
                });
            })

            return this.fetchWrapper.get(url);
        }

        _prepareParams(context) {
            const params = [];

            if (context['description']) {
                params.push('description=' + context['description']);
            }

            return params.join('&');
        }

        _parseData(f) {
            return this.forParser.parse(f);
        }
    }
});

},
'spencer/data-manager/core/request/action/Project/Stage/ProjectStage':function(){
define([
    'library/request/Canceller',
    'spencer/core/parser/ProjectStage',
    'spencer/data-manager/data/Action'
], (
    RequestCanceller,
    ProjectStageParser,
    ActionData
) => {
    return class ProjectStage {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchProcessor = fetchFactory.get();
            this.projectStageParser = new ProjectStageParser;
        }

        canAction() {
            const context = this.requestData.getContext();

            return 'projectStagePK' in context
                && !!context.projectStagePK
        }

        getAffected() {
            return [];
        }

        action() {
            if (!this.canAction()) {
                throw 'Invalid context provided, a projectStagePK must be present in context'
            }

            return new ActionData(
                new RequestCanceller(this.fetchProcessor),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            this.fetchProcessor.setSuccessHandler(async response => {
                const json = await response.json();

                return this.projectStageParser.parse(json);
            });

            this.fetchProcessor.setErrorHandler(async response => {
                return response;
            });

            const context = this.requestData.getContext();

            return this.fetchProcessor.get(this.url.replace(':id', context.projectStagePK));
        }
    }
})
},
'spencer/data-manager/core/request/action/Project/Stage/SaveBudget':function(){
define([
    'library/request/data/HTTPResponseCodes',
    'library/request/Canceller',
    'library/request/exception/ErrorResponse',
    'library/request/exception/NoAccess',
    'spencer/data-manager/data/Action'
], function (
    HTTPResponseCodes,
    RequestCanceller,
    ErrorResponse,
    NoAccess,
    ActionData
) {
    return class SaveBudget {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
        }

        canAction() {
            const context = this.requestData.getContext();

            return context.isValid();
        }

        getAffected() {
            return [];
        }

        action() {
            if (!this.canAction()) {
                throw 'Invalid Context';
            }

            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            const url = this.url.replace(':projectStagePK', context.getProjectStagePK());
            const data = this._getData(context);

            this.fetchWrapper.setErrorHandler(() => {
                throw new ErrorResponse();
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.forbidden, () => {
                throw new NoAccess();
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.bad_request, async error => {
                throw new ErrorResponse(await error.json());
            });

            return this.fetchWrapper.put(url, {
                headers: {
                    'Content-Type': 'application/json'
                },
                body: data
            });
        }

        _getData(context) {
            const data = {
                'title': context.getTitle(),
                'projectPK': context.getProjectPK(),
                'budgetStatusPK': context.getBudgetStatusPK(),
                'receivedDate': context.getReceivedDate(),
                'leadTeamPK': context.getLeadTeam(),
                'visible': context.getVisible(),
                'isActive': context.getIsActive(),
                'clientsBudget': context.getClientsBudget()
            }

            if (context.getSubmissionDate()) {
                data['submissionDate'] = context.getSubmissionDate();
            }

            if (context.getPreSubmissionNotes()) {
                data['preSubmissionNotes'] = context.getPreSubmissionNotes();
            }

            if (context.getPostSubmissionNotes()) {
                data['postSubmissionNotes'] = context.getPostSubmissionNotes();
            }

            return JSON.stringify(data);
        }
    }
});

},
'spencer/data-manager/core/request/action/Project/Stage/SaveContract':function(){
define([
    'library/request/data/HTTPResponseCodes',
    'library/request/Canceller',
    'library/request/exception/ErrorResponse',
    'library/request/exception/NoAccess',
    'spencer/data-manager/data/Action'
], function (
    HTTPResponseCodes,
    RequestCanceller,
    ErrorResponse,
    NoAccess,
    ActionData
) {
    return class SaveContract {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
        }

        canAction() {
            const context = this.requestData.getContext();

            return context.isValid();
        }

        getAffected() {
            return [];
        }

        action() {
            if (!this.canAction()) {
                throw 'Invalid Context';
            }

            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            const url = this.url.replace(':projectStagePK', context.getProjectStagePK());
            const data = this._getData(context);

            this.fetchWrapper.setErrorHandler(() => {
                throw new ErrorResponse();
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.forbidden, () => {
                throw new NoAccess();
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.bad_request, async error => {
                throw new ErrorResponse(await error.json());
            });

            return this.fetchWrapper.put(url, {
                headers: {
                    'Content-Type': 'application/json'
                },
                body: data
            });
        }

        _getData(context) {
            const data = {
                'title': context.getTitle(),
                'projectPK': context.getProjectPK(),
                'awardDate': context.getAwardDate(),
                'startDate': context.getStartDate(),
                'notes': context.getNotes() || '',
                'phase': context.getPhase(),
                'leadTeamPK': context.getLeadTeam(),
                'visible': context.getVisible(),
                'isActive': context.getIsActive(),
                'targetCompletionDate': context.getTargetCompletionDate(),
                'originalValue': context.getOriginalValue()
            }

            return JSON.stringify(data);
        }
    }
});

},
'spencer/data-manager/core/request/action/Project/Stage/SaveLead':function(){
define([
    'library/request/data/HTTPResponseCodes',
    'library/request/Canceller',
    'library/request/exception/ErrorResponse',
    'library/request/exception/NoAccess',
    'spencer/data-manager/data/Action'
], function (
    HTTPResponseCodes,
    RequestCanceller,
    ErrorResponse,
    NoAccess,
    ActionData
) {
    return class SaveLead {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
        }

        canAction() {
            const context = this.requestData.getContext();

            return context.isValid();
        }

        getAffected() {
            return [];
        }

        action() {
            if (!this.canAction()) {
                throw 'Invalid Context';
            }

            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            const url = this.url.replace(':projectStagePK', context.getProjectStagePK());
            const data = this._getData(context);

            this.fetchWrapper.setErrorHandler(() => {
                throw new ErrorResponse();
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.forbidden, () => {
                throw new NoAccess();
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.bad_request, async error => {
                throw new ErrorResponse(await error.json());
            });

            return this.fetchWrapper.put(url, {
                headers: {
                    'Content-Type': 'application/json'
                },
                body: data
            });
        }

        _getData(context) {
            const data = {
                'title': context.getTitle(),
                'projectPK': context.getProjectPK(),
                'leadTeamPK': context.getLeadTeam(),
                'visible': context.getVisible(),
                'isActive': context.getIsActive()
            }

            if (!!context.getClientsBudget()) {
                data['clientsBudget'] = context.getClientsBudget();
            }

            if (!!context.getNotes()) {
                data['notes'] = context.getNotes();
            }

            if (!!context.getTenderDueDate()) {
                const tenderDueDate = context.getTenderDueDate();

                if (tenderDueDate['month'] && tenderDueDate['year']) {
                    data['tenderDueDate'] = tenderDueDate['month'] + '-' + tenderDueDate['year'];
                }
            }

            if (!!context.getStatus()) {
                data['status'] = context.getStatus();
            }

            return JSON.stringify(data);
        }
    }
});

},
'spencer/data-manager/core/request/action/Project/Stage/SavePrequal':function(){
define([
    'library/request/data/HTTPResponseCodes',
    'library/request/Canceller',
    'library/request/exception/ErrorResponse',
    'library/request/exception/NoAccess',
    'spencer/data-manager/data/Action'
], function (
    HTTPResponseCodes,
    RequestCanceller,
    ErrorResponse,
    NoAccess,
    ActionData
) {
    return class SavePrequal {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
        }

        canAction() {
            const context = this.requestData.getContext();

            return context.isValid();
        }

        getAffected() {
            return [];
        }

        action() {
            if (!this.canAction()) {
                throw 'Invalid Context';
            }

            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            const url = this.url.replace(':projectStagePK', context.getProjectStagePK());
            const data = this._getData(context);

            this.fetchWrapper.setErrorHandler(() => {
                throw new ErrorResponse();
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.forbidden, () => {
                throw new NoAccess();
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.bad_request, async error => {
                throw new ErrorResponse(await error.json());
            });

            return this.fetchWrapper.put(url, {
                headers: {
                    'Content-Type': 'application/json'
                },
                body: data
            });
        }

        _getData(context) {
            const data = {
                'title': context.getTitle(),
                'projectPK': context.getProjectPK(),
                'prequalStatusPK': context.getPrequalStatusPK(),
                'receivedDate': context.getReceivedDate(),
                'prequalForPK': context.getPrequalForPK(),
                'leadTeamPK': context.getLeadTeam(),
                'visible': context.getVisible(),
                'isActive': context.getIsActive()
            }

            if (context.getTenderDueDate()) {
                data['tenderDueDate'] = context.getTenderDueDate();
            }

            if (context.getSubmissionDate()) {
                data['submissionDate'] = context.getSubmissionDate();
            }

            if (context.getClientsBudget()) {
                data['clientsBudget'] = context.getClientsBudget();
            }

            if (context.getPreSubmissionNotes()) {
                data['preSubmissionNotes'] = context.getPreSubmissionNotes();
            }

            if (context.getPostSubmissionNotes()) {
                data['postSubmissionNotes'] = context.getPostSubmissionNotes();
            }

            return JSON.stringify(data);
        }
    }
});

},
'spencer/data-manager/core/request/action/Project/Stage/SaveTenderOffer':function(){
define([
    'library/request/data/HTTPResponseCodes',
    'library/request/Canceller',
    'library/request/exception/ErrorResponse',
    'library/request/exception/NoAccess',
    'spencer/data-manager/data/Action'
], function (
    HTTPResponseCodes,
    RequestCanceller,
    ErrorResponse,
    NoAccess,
    ActionData
) {
    return class SaveTenderOffer {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
        }

        canAction() {
            const context = this.requestData.getContext();
            return context.isValid();
        }

        getAffected() {
            return [];
        }

        action() {
            if (!this.canAction()) {
                throw 'Invalid Context';
            }

            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            const url = this.url.replace(':projectStagePK', context.getProjectStagePK());
            const data = this._getData(context);

            this.fetchWrapper.setErrorHandler(() => {
                throw new ErrorResponse();
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.forbidden, () => {
                throw new NoAccess();
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.bad_request, async error => {
                throw new ErrorResponse(await error.json());
            });

            return this.fetchWrapper.put(url, {
                headers: {
                    'Content-Type': 'application/json'
                },
                body: data
            });
        }

        _getData(context) {
            const data = {
                'title': context.getTitle(),
                'projectPK': context.getProjectPK(),
                'receivedDate': context.getReceivedDate(),
                'leadTeamPK': context.getLeadTeam(),
                'visible': context.getVisible(),
                'isActive': context.getIsActive()
            }

            if (context.getVotedTo()) {
                data['votedTo'] = context.getVotedTo();
            }

            if (context.getTenderDueDate()) {
                data['tenderDueDate'] = context.getTenderDueDate();
            }

            if (context.getClientsBudget()) {
                data['clientsBudget'] = context.getClientsBudget();
            }

            if (context.getPreSubmissionNotes()) {
                data['preSubmissionNotes'] = context.getPreSubmissionNotes();
            }

            if (context.getPostSubmissionNotes()) {
                data['postSubmissionNotes'] = context.getPostSubmissionNotes();
            }

            return JSON.stringify(data);
        }
    }
});

},
'spencer/data-manager/core/request/action/Project/Stage/SaveTender':function(){
define([
    'library/request/data/HTTPResponseCodes',
    'library/request/Canceller',
    'library/request/exception/ErrorResponse',
    'library/request/exception/NoAccess',
    'spencer/data-manager/data/Action'
], function (
    HTTPResponseCodes,
    RequestCanceller,
    ErrorResponse,
    NoAccess,
    ActionData
) {
    return class SaveTenderOffer {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
        }

        canAction() {
            const context = this.requestData.getContext();

            return context.isValid();
        }

        getAffected() {
            return [];
        }

        action() {
            if (!this.canAction()) {
                throw 'Invalid Context';
            }

            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            const url = this.url.replace(':projectStagePK', context.getProjectStagePK());
            const data = this._getData(context);

            this.fetchWrapper.setErrorHandler(() => {
                throw new ErrorResponse();
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.forbidden, () => {
                throw new NoAccess();
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.bad_request, async error => {
                throw new ErrorResponse(await error.json());
            });

            return this.fetchWrapper.put(url, {
                headers: {
                    'Content-Type': 'application/json'
                },
                body: data
            });
        }

        _getData(context) {
            const data = {
                'title': context.getTitle(),
                'projectPK': context.getProjectPK(),
                'receivedDate': context.getReceivedDate(),
                'leadTeamPK': context.getLeadTeam(),
                'visible': context.getVisible(),
                'isActive': context.getIsActive()
            }

            if (context.getSubmissionDate()) {
                data['submissionDate'] = context.getSubmissionDate();
            }

            if (context.getTenderStatus()) {
                data['tenderStatusPK'] = context.getTenderStatus();
            }

            if (context.getClientsBudget()) {
                data['clientsBudget'] = context.getClientsBudget();
            }

            if (context.getPreSubmissionNotes()) {
                data['preSubmissionNotes'] = context.getPreSubmissionNotes();
            }

            if (context.getPostSubmissionNotes()) {
                data['postSubmissionNotes'] = context.getPostSubmissionNotes();
            }

            return JSON.stringify(data);
        }
    }
});

},
'spencer/data-manager/core/request/action/Project/Stage/SaveIntelligence':function(){
define([
    'library/request/data/HTTPResponseCodes',
    'library/request/Canceller',
    'library/request/exception/ErrorResponse',
    'library/request/exception/NoAccess',
    'spencer/data-manager/data/Action'
], function (
    HTTPResponseCodes,
    RequestCanceller,
    ErrorResponse,
    NoAccess,
    ActionData
) {
    return class SaveBudget {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
        }

        canAction() {
            const context = this.requestData.getContext();

            return context.isValid();
        }

        getAffected() {
            return [];
        }

        action() {
            if (!this.canAction()) {
                throw 'Invalid Context';
            }

            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            const url = this.url.replace(':projectStagePK', context.getProjectStagePK());
            const data = this._getData(context);

            this.fetchWrapper.setErrorHandler(() => {
                throw new ErrorResponse();
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.forbidden, () => {
                throw new NoAccess();
            });

            this.fetchWrapper.setHandler(HTTPResponseCodes.bad_request, async error => {
                throw new ErrorResponse(await error.json());
            });

            return this.fetchWrapper.put(url, {
                headers: {
                    'Content-Type': 'application/json'
                },
                body: data
            });
        }

        _getData(context) {
            const data = {
                'title': context.getTitle(),
                'projectPK': context.getProjectPK(),
                'leadTeamPK': context.getLeadTeam(),
                'visible': context.getVisible(),
                'isActive': context.getIsActive()
            }

            if (context.getStatus()) {
                data['status'] = context.getStatus();
            }

            if (context.getAnticipatedValue()) {
                data['anticipatedValue'] = context.getAnticipatedValue();
            }

            return JSON.stringify(data);
        }
    }
});

},
'spencer/data-manager/core/request/action/Project/Stage/TypeCollection':function(){
define([
    '@lib/api/project/stage/parser/Type',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function(
    StageTypeParser,
    RequestCanceller,
    ActionData
) {
    return class TypeCollection {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
            this.parser = new StageTypeParser();
        }

        canAction() {
            return true;
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        setSuccessHandler(successHandler) {
            this.successHandler = successHandler;
        }

        async _request() {
            const context = this.requestData.getContext();
            const params = [];

            if (context['filter']) {
                params.push(`filter=${context['filter']}`);
            }

            if (context['limit'] > 0 && context['offset'] >= 0) {
                params.push(`limit=${context['limit']}`);
                params.push(`offset=${context['offset']}`);
            }

            if (params.length) {
                this.url += '?' + params.join('&');
            }

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();

                return data.map(item => {
                    return this.parser.parse(item);
                });
            });

            return this.fetchWrapper.get(this.url);
        }
    }
});
},
'@lib/api/project/stage/parser/Type':function(){
define(["require", "exports", "@lib/spencer/project/stage/data/Type"], function (require, exports, TypeVO) {
    "use strict";
    class Type {
        parse(type) {
            return new TypeVO(type.stage_id, type.name);
        }
    }
    return Type;
});

},
'@lib/spencer/project/stage/data/Type':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Type {
        constructor(stagePK, name) {
            this.stagePK = stagePK;
            this.name = name;
        }
        getStagePK() {
            return this.stagePK;
        }
        getName() {
            return this.name;
        }
    }
    return Type;
});

},
'spencer/data-manager/core/request/action/Project/TenderTypeCollection':function(){
define([
    'api/project/parser/TenderType',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    TenderTypeParser,
    RequestCanceller,
    ActionData
) {
    return class TenderTypeCollection {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();

            this.tenderTypeParser = new TenderTypeParser();
        }

        canAction() {
            return true;
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            let url = this.url;

            if (Object.keys(context).length) {
                url += '?' + this._prepareParams(context);
            }

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();

                return data.map(item => {
                    return this._parseData(item);
                });
            })

            return this.fetchWrapper.get(url);
        }

        _prepareParams(context) {
            const params = [];

            if (context['description']) {
                params.push('description=' + context['description']);
            }

            return params.join('&');
        }

        _parseData(tenderType) {
            return this.tenderTypeParser.parse(tenderType);
        }
    }
});
},
'api/project/parser/TenderType':function(){
define([
    'spencer/project/data/TenderType'
], function (
    TenderTypeVO
) {
    return class TenderType {
        parse(data) {
            return new TenderTypeVO(
                data.tenderTypePK,
                data.description
            );
        }
    }
});
},
'spencer/project/data/TenderType':function(){
define([], function () {
    return class TenderType {
        constructor(tenderTypePK, description) {
            this.tenderTypePK = tenderTypePK;
            this.description = description;
        }

        getTenderTypePK() {
            return this.tenderTypePK;
        }

        getDescription() {
            return this.description;
        }
    }
});
},
'spencer/data-manager/core/request/action/Team/Collection':function(){
define([
    '@lib/api/project/parser/Team',
    'library/request/Canceller',
    'spencer/data-manager/data/Action'
], function (
    TeamParser,
    RequestCanceller,
    ActionData
) {
    return class Collection {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchWrapper = fetchFactory.get();
            this.parser = new TeamParser();
        }

        canAction() {
            return true;
        }

        getAffected() {
            return [];
        }

        action() {
            return new ActionData(
                new RequestCanceller(this.fetchWrapper),
                this._request(),
                this.requestData
            );
        }

        async _request() {
            const context = this.requestData.getContext();
            const params = [];

            if (context['filter']) {
                params.push(`filter=${context['filter']}`);
            }

            if (context['organisationPK']) {
                params.push(`organisationPK=${context['organisationPK']}`);
            }

            if (context['limit'] > 0 && context['offset'] >= 0) {
                params.push(`limit=${context['limit']}`);
                params.push(`offset=${context['offset']}`);
            }

            if (params.length) {
                this.url += '?' + params.join('&');
            }

            this.fetchWrapper.setSuccessHandler(async response => {
                const data = await response.json();

                return data.map(item => {
                    return this.parser.parse(item);
                });
            });

            return this.fetchWrapper.get(this.url);
        }
    }
});
},
'@lib/api/project/parser/Team':function(){
define(["require", "exports", "@lib/spencer/project/data/Team"], function (require, exports, TeamVO) {
    "use strict";
    class Team {
        parse(team) {
            return new TeamVO(team.teamPK, team.name);
        }
    }
    return Team;
});

},
'@lib/spencer/project/data/Team':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Team {
        constructor(teamPK, name) {
            this.teamPK = teamPK;
            this.name = name;
        }
        getTeamPK() {
            return this.teamPK;
        }
        getName() {
            return this.name;
        }
    }
    return Team;
});

},
'spencer/data-manager/core/request/action/Tree':function(){
/// <amd-dependency path="spencer/doc-control/parser/Revision" name="RevisionParser" />
/// <amd-dependency path="library/response/error/Forbidden" name="ForbiddenError" />
define(["require", "exports", "spencer/doc-control/parser/Revision", "library/response/error/Forbidden", "library/request/data/HTTPResponseCodes", "spencer/data-manager/data/Action", "@lib/api/doc-control/tree/parser/Node", "@lib/api/project/parser/ProjectStage"], function (require, exports, RevisionParser, ForbiddenError, HTTP_RESPONSE_CODES, ActionData, NodeParser, ProjectStageParser) {
    "use strict";
    class Tree {
        constructor(url, requestData, fetchFactory) {
            this.url = url;
            this.requestData = requestData;
            this.fetchFactory = fetchFactory;
            this.fetchProcessor = this.fetchFactory.get();
            this.nodeParser = new NodeParser(new RevisionParser(), new ProjectStageParser());
        }
        canAction() {
            const context = this.requestData.getContext();
            return !!context['projectStagePK'];
        }
        getAffected(entity) {
            return [];
        }
        action() {
            if (!this.canAction()) {
                throw 'Cannot Action';
            }
            return new ActionData(this.fetchProcessor, this.request(), this.requestData);
        }
        request() {
            const context = this.requestData.getContext();
            this.fetchProcessor.setSuccessHandler(async (response) => {
                const data = await response.json();
                return this.nodeParser.parse(data);
            });
            this.fetchProcessor.setHandler(HTTP_RESPONSE_CODES.forbidden, () => {
                throw new ForbiddenError();
            });
            return this.fetchProcessor.get(this.url.replace(':projectStagePK', context.projectStagePK));
        }
    }
    return Tree;
});

},
'library/request/FormDataWrapper':function(){
define(['@lib/request/FormDataWrapper'], function(FDW) {
    return FDW;
})
},
'spencer/data-manager/core/request/URLConfig':function(){
define([
    '../definition/Actions',
    'api/address/Config',
    'api/client/Config',
    'api/contact/Config',
    'api/contract/Config',
    'api/doccontrol/Config',
    'api/doccontrol/document/revision/Config',
    'api/doccontrol/document/tree/Config',
    'api/doccontrol/search/Config',
    'api/favourite/Config',
    'api/file/Config',
    'api/organisation/Config',
    'api/person/Config',
    'api/project/Config',
    'api/project/site/Config'
], function (
    ACTIONS,
    APIAddressConfig,
    APIClientConfig,
    APIContactConfig,
    APIContractConfig,
    APIDocumentControlConfig,
    APIDocumentRevisionConfig,
    APIDocumentTreeConfig,
    APIDocumentSearchConfig,
    APIFavouriteConfig,
    APIFileConfig,
    APIOrganisationConfig,
    APIPersonConfig,
    APIProjectConfig,
    APIProjectSiteConfig
) {
    const r = {};
    const addressConfig = new APIAddressConfig();
    const clientConfig = new APIClientConfig();
    const contactConfig = new APIContactConfig();
    const contractConfig = new APIContractConfig();
    const docControlConfig = new APIDocumentControlConfig();
    const documentTreeConfig = new APIDocumentTreeConfig();
    const documentRevisionConfig = new APIDocumentRevisionConfig();
    const documentSearchConfig = new APIDocumentSearchConfig();
    const fileConfig = new APIFileConfig();
    const organisationConfig = new APIOrganisationConfig();
    const personConfig = new APIPersonConfig();
    const projectConfig = new APIProjectConfig();
    const projectSiteConfig = new APIProjectSiteConfig();
    const favouriteConfig = new APIFavouriteConfig();

    r[ACTIONS.ADDRESS_COUNTRY] = addressConfig.getUrl('api_address_country', 'v2/');
    r[ACTIONS.ADDRESS_COUNTY] = addressConfig.getUrl('api_address_county', 'v2/');
    r[ACTIONS.CLIENT_SELECTED_FROM_COLLECTION] = clientConfig.getUrl('api_selected_from_collection', 'v2/');
    r[ACTIONS.CLIENT_CONTACT_REPORT_ORGANISATION_COLLECTION] = clientConfig.getUrl('api_contact_report_organisation_collection', 'v2/');
    r[ACTIONS.CLIENT_CONTACT_REPORT_PERSON_CONTACTED] = clientConfig.getUrl('api_contact_report_person_contacted_collection', 'v2/');
    r[ACTIONS.CLIENT_CONTACT_REPORT_PERSON_CONTACTED_BY] = clientConfig.getUrl('api_contact_report_person_contacted_by_collection', 'v2/');
    r[ACTIONS.CLIENT_CONTACT_REPORT_PROJECT_STAGE] = clientConfig.getUrl('api_contact_report_project_stage_collection', 'v2/');
    r[ACTIONS.CONTACT] = contactConfig.getUrl('api_contact');
    r[ACTIONS.CONTACT_COLLECTION] = contactConfig.getUrl('api_contact');
    r[ACTIONS.CONTRACT_CONDITION_COLLECTION] = contractConfig.getUrl('api_condition_collection', 'v2/');
    r[ACTIONS.CONTRACT_TYPE_COLLECTION] = contractConfig.getUrl('api_type_collection', 'v2/');
    r[ACTIONS.CREATE_BUDGET_STAGE] = projectConfig.getUrl('api_project_stage_budget', 'v2/');
    r[ACTIONS.CREATE_CONTRACT_STAGE] = projectConfig.getUrl('api_project_stage_contract', 'v2/');
    r[ACTIONS.CREATE_DOCUMENT_FAVOURITE] = favouriteConfig.getUrl('api_favourite_document', 'v2/');
    r[ACTIONS.CREATE_GENERAL_STAGE] = projectConfig.getUrl('api_general_stage', 'v2/');
    r[ACTIONS.CREATE_INTELLIGENCE_STAGE] = projectConfig.getUrl('api_project_stage_intelligence', 'v2/');
    r[ACTIONS.CREATE_LEAD_STAGE] = projectConfig.getUrl('api_project_stage_lead', 'v2/');
    r[ACTIONS.CREATE_PREQUAL_STAGE] = projectConfig.getUrl('api_project_stage_prequal', 'v2/');
    r[ACTIONS.CREATE_PROJECT] = projectConfig.getUrl('api_project', 'v2/');
    r[ACTIONS.CREATE_PROJECT_SITE] = projectConfig.getUrl('api_project_site_create', 'v2/');
    r[ACTIONS.CREATE_TENDER_OFFER_STAGE] = projectConfig.getUrl('api_project_stage_tender_offer', 'v2/');
    r[ACTIONS.CREATE_TENDER_STAGE] = projectConfig.getUrl('api_project_stage_tender', 'v2/');
    r[ACTIONS.PROJECT_STAGE_TENDER] = projectConfig.getUrl('api_get_project_stage_tender', 'v2/');
    r[ACTIONS.DOCUMENT_BULK_REGISTER] = docControlConfig.getUrl('api_doc_control_temporary_document_bulk_register');
    r[ACTIONS.DOCUMENT_LATEST] = documentRevisionConfig.getUrl('api_doc_control_document_revision_latest', 'v2/');
    r[ACTIONS.DOCUMENT_LOCATION] = documentTreeConfig.getUrl('api_doc_control_document_tree_node', 'v2/');
    r[ACTIONS.DOCUMENT_REVISION_SET_LATEST] = documentRevisionConfig.getUrl('api_doc_control_document_revision_set_latest', 'v2/');
    r[ACTIONS.DOCUMENT_REVISION_SEARCH] = documentSearchConfig.getUrl('api_doc_control_search_revision_collection', 'v2/');
    r[ACTIONS.DOCUMENT_REVISION_NUMBER] = documentRevisionConfig.getUrl('api_doc_control_document_revision_number', 'v2/');
    r[ACTIONS.DOCUMENT_UPLOAD] = docControlConfig.getUrl('api_doc_control_document');
    r[ACTIONS.EDIT_PROJECT] = projectConfig.getUrl('api_project', 'v2/');
    r[ACTIONS.EDIT_PROJECT_SITE] = projectConfig.getUrl('api_project_site_create', 'v2/');
    r[ACTIONS.FAVOURITE_DOCUMENT_GET] = favouriteConfig.getUrl('api_favourite_document', 'v2/')
    r[ACTIONS.FILE_PREVIEW] = fileConfig.getUrl('api_preview', 'v2/');
    r[ACTIONS.FILE_UPLOAD] = fileConfig.getUrl('api_temporary');
    r[ACTIONS.GROUP_COLLECTION] = '/v2/group';
    r[ACTIONS.GROUP_IS_MEMBER_OF] = '/v2/group/:uid/is-member-of';
    r[ACTIONS.GROUP_MEMBER_COLLECTION] = '/v2/group/:id/member';
    r[ACTIONS.LEAD_TEAM] = projectConfig.getUrl('api_project_stage_lead_team', 'v2/');
    r[ACTIONS.LEAD_TEAM_COLLECTION] = projectConfig.getUrl('api_project_stage_lead_team', 'v2/');
    r[ACTIONS.MY_GROUP_COLLECTION] = '/v2/my-group';
    r[ACTIONS.MY_GROUP_MEMBER_COLLECTION] = '/v2/my-group/:id/member';
    r[ACTIONS.ORGANISATION_BRANCH_OFFICE_COLLECTION] = '/v2/organisation/:organisationPK/branch-office';
    r[ACTIONS.ORGANISATION_COLLECTION] = organisationConfig.getUrl('api_organisation', 'v2/')
    r[ACTIONS.ORGANISATION_INTRANET_OWNER_COLLECTION] = organisationConfig.getUrl('api_organisation_intranet_owner', 'v2/');
    r[ACTIONS.ORGANISATION_PERSON_COLLECTION] = organisationConfig.getUrl('api_organisation_person_collection', 'v2/');
    r[ACTIONS.PERSON] = personConfig.getUrl('api_person', 'v2/');
    r[ACTIONS.PERSON_SELF] = personConfig.getUrl('api_person_self', 'v2/');
    r[ACTIONS.PROJECT] = projectConfig.getUrl('api_project', 'v2/');
    r[ACTIONS.PROJECT_COLLECTION] = projectConfig.getUrl('api_project_collection', 'v2/');
    r[ACTIONS.PROJECT_SITE_COLLECTION] = projectSiteConfig.getUrl('api_project_site', 'v2/');
    r[ACTIONS.PROJECT_SITE_DOCUMENT_COLLECTION] = projectSiteConfig.getUrl('api_project_site_document_collection', 'v2/')
    r[ACTIONS.PROJECT_SITE_DOCUMENT_DELETE] = projectSiteConfig.getUrl('api_project_site_document', 'v2/')
    r[ACTIONS.PROJECT_STAGE_BUDGET] = projectConfig.getUrl('api_get_project_stage_budget', 'v2/');
    r[ACTIONS.PROJECT_STAGE_BUDGET_STATUS_COLLECTION] = projectConfig.getUrl('api_project_stage_budget_status_collection', 'v2/');
    r[ACTIONS.PROJECT_STAGE] = '/v2/project-stage/:id';
    r[ACTIONS.PROJECT_STAGE_INTELLIGENCE] = projectConfig.getUrl('api_get_project_stage_intelligence', 'v2/');
    r[ACTIONS.PROJECT_STAGE_COLLECTION] = projectConfig.getUrl('api_project_stage', 'v2/');
    r[ACTIONS.PROJECT_STAGE_CONTRACT] = projectConfig.getUrl('api_get_project_stage_contract', 'v2/');
    r[ACTIONS.PROJECT_STAGE_MEMBER_COLLECTION] = projectConfig.getUrl('api_project_stage_member_collection', 'v2/');
    r[ACTIONS.PROJECT_STAGE_MEMBER_COLLECTION] = '/v2/project-stage/:id/member';
    r[ACTIONS.PROJECT_STAGE_NODE] = docControlConfig.getUrl('api_doc_control_project_tree_node', 'v2/');
    r[ACTIONS.PROJECT_STAGE_NUMBER_RANGE_COLLECTION] = projectConfig.getUrl('api_project_stage_number_range_collection', 'v2/');
    r[ACTIONS.PROJECT_STAGE_PREQUAL] = projectConfig.getUrl('api_project_stage_prequal', 'v2/');
    r[ACTIONS.PROJECT_STAGE_LEAD] = projectConfig.getUrl('api_get_project_stage_lead', 'v2/');
    r[ACTIONS.PROJECT_STAGE_PREQUAL] = projectConfig.getUrl('api_get_project_stage_prequal', 'v2/');
    r[ACTIONS.PROJECT_STAGE_PREQUAL_FOR_COLLECTION] = projectConfig.getUrl('api_project_stage_prequal_for_collection', 'v2/');
    r[ACTIONS.PROJECT_STAGE_TENDER_OFFER] = projectConfig.getUrl('api_get_project_stage_tender_offer', 'v2/');
    r[ACTIONS.PROJECT_STAGE_TYPE_COLLECTION] = projectConfig.getUrl('api_project_stage_type_collection', 'v2/');
    r[ACTIONS.PROJECT_TENDER_TYPE_COLLECTION] = projectConfig.getUrl('api_project_tender_type_collection', 'v2/');
    r[ACTIONS.REMOVE_DOCUMENT_FAVOURITE] = favouriteConfig.getUrl('api_favourite', 'v2/');
    r[ACTIONS.SAVE_BUDGET_STAGE] = projectConfig.getUrl('api_put_project_stage_budget', 'v2/');
    r[ACTIONS.SAVE_CONTRACT_STAGE] = projectConfig.getUrl('api_put_project_stage_contract', 'v2/');
    r[ACTIONS.SAVE_ESTIMATED_PROJECT_DATES] = projectConfig.getUrl('api_put_project_estimated_dates', 'v2/');
    r[ACTIONS.SAVE_LEAD_STAGE] = projectConfig.getUrl('api_put_project_stage_lead', 'v2/');
    r[ACTIONS.SAVE_PREQUAL_STAGE] = projectConfig.getUrl('api_put_project_stage_prequal', 'v2/');
    r[ACTIONS.SAVE_TENDER_OFFER_STAGE] = projectConfig.getUrl('api_put_project_stage_tender_offer', 'v2/');
    r[ACTIONS.SAVE_TENDER_STAGE] = projectConfig.getUrl('api_put_project_stage_tender', 'v2/');
    r[ACTIONS.SAVE_INTELLIGENCE_STAGE] = projectConfig.getUrl('api_get_project_stage_intelligence', 'v2/');
    r[ACTIONS.TEAM_COLLECTION] = '/v2/team';
    r[ACTIONS.TREE] = docControlConfig.getUrl('api_doc_control_project_tree', 'v2/');
    r[ACTIONS.TREE_STRUCTURE] = docControlConfig.getUrl('api_doc_control_project_tree_structure', 'v2/');
    r[ACTIONS.TREE_TEMPLATE_COLLECTION] = 'v2/tree/template'

    return r;
});

},
'api/client/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    return class Config extends apiConfig {
        constructor(rootUrl) {
            super(rootUrl);
            this.api_selected_from_collection = 'client/selected-from';
            this.api_contact_report_organisation_collection = 'client/contact-report/organisation';
            this.api_contact_report_person_contacted_collection = 'client/contact-report/contacted/person';
            this.api_contact_report_person_contacted_by_collection = 'client/contact-report/originator/person';
            this.api_contact_report_project_stage_collection = 'client/contact-report/project-stage';
            this.api_project_stage = 'project-stage/';
        }
    };
});

},
'api/contract/Config':function(){
define([
    '../Config'
], function(apiConfig) {
    return class Config extends apiConfig {
        constructor(rootUrl) {
            super(rootUrl);

            this.api_condition_collection = 'contract/condition';
            this.api_type_collection = 'contract/type';
        }
    };
});

},
'api/project/site/Config':function(){
define([
    '../../Config'
], function(apiConfig) {
    return class Config extends apiConfig {
        constructor(rootUrl) {
            super(rootUrl);

            this.api_project_site = 'project/site';
            this.api_project_site_document = 'project/site/:projectSitePK/document/:documentPK';
            this.api_project_site_document_collection = 'project/site/:projectSitePK/document';
        }
    }
})
},
'spencer/data-manager/core/request/URLParams':function(){
define([
    '../definition/Actions'
], function(
    ACTIONS
) {
    const urlParams = {};
    urlParams[ACTIONS.GROUP_COLLECTION] = ['name'];
    urlParams[ACTIONS.GROUP_MEMBER_COLLECTION] = [];
    urlParams[ACTIONS.MY_GROUP_COLLECTION] = ['name'];
    urlParams[ACTIONS.MY_GROUP_MEMBER_COLLECTION] = [];
    urlParams[ACTIONS.PROJECT_STAGE_COLLECTION] = ['search'];
    urlParams[ACTIONS.PROJECT_STAGE_MEMBER_COLLECTION] = [];

    return urlParams;
})
},
'spencer/data-manager/core/storage/web/SupportedEntities':function(){
define([
    "spencer/data-manager/core/definition/Entities"
], function(
    ENTITIES
) {
    const KEY_SEPARATOR = "_";
    const SUPPORTED_ENTITIES = {};

    const isSetAndNotEmpty = function(data, field) {
        return data && data.hasOwnProperty(field) && !!data[field];
    };

    SUPPORTED_ENTITIES[ENTITIES.GROUP_MEMBER_COLLECTION] = {
        hasSufficientData: function(data) {
            return isSetAndNotEmpty(data, 'id');
        },
        generate: function(data) {
            return ENTITIES.GROUP_MEMBER_COLLECTION + KEY_SEPARATOR + data['id'];
        }
    };

    SUPPORTED_ENTITIES[ENTITIES.MY_GROUP_MEMBER_COLLECTION] = {
        hasSufficientData: function(data) {
            return isSetAndNotEmpty(data, 'id');
        },
        generate: function(data) {
            return ENTITIES.MY_GROUP_MEMBER_COLLECTION + KEY_SEPARATOR + data['id'];
        }
    };

    SUPPORTED_ENTITIES[ENTITIES.PERSON_SELF] = {
        hasSufficientData: function() {
            return true;
        },
        generate: function() {
            return ENTITIES.PERSON_SELF;
        }
    };

    SUPPORTED_ENTITIES[ENTITIES.PROJECT_STAGE_MEMBER_COLLECTION] = {
        hasSufficientData: function(data) {
            return isSetAndNotEmpty(data, 'id');
        },
        generate: function(data) {
            return ENTITIES.PROJECT_STAGE_MEMBER_COLLECTION + KEY_SEPARATOR + data['id'];
        }
    };

    SUPPORTED_ENTITIES[ENTITIES.TREE] = {
        hasSufficientData: (data) => isSetAndNotEmpty(data, 'projectStagePK'),
        generate: (data) => ENTITIES.TREE + KEY_SEPARATOR + data['projectStagePK']
    };

    return SUPPORTED_ENTITIES;
});

},
'spencer/data-manager/log/NullLogger':function(){
define([], function() {
    const NullLogger = function() {};

    NullLogger.prototype.info = function(message) {};

    NullLogger.prototype.warn = function(message) {};

    NullLogger.prototype.error = function(message) {};

    return NullLogger;
});
},
'spencer/data-manager/Manager':function(){
define([
    './data/event/Event',
    './data/event-recorder/Recording',
    './data/event-recorder/RequestEvent',
    './data/Subscription',
    './data/SubscriptionEmitter',
    './event/Identifiers',
    './request/action/StorageInterface',
    './subscription/WildCard'
], function(
    EventData,
    EventRecordingData,
    EventRecorderRequestEventData,
    SubscriptionData,
    SubscriptionEmitterData,
    EVENT_IDENTIFIERS,
    StorageInterface,
    WildCard
) {
    const LOG_CATEGORY_CONFIG_BASED_UPDATE = 'CONFIG BASED UPDATE';
    const LOG_CATEGORY_CONSUMER_ERROR = 'CONSUMER ERROR';
    const LOG_CATEGORY_REQUEST = 'REQUEST';
    const LOG_CATEGORY_STORAGE = 'STORAGE';
    const LOG_CATEGORY_SUBSCRIPTION = 'SUBSCRIPTION';
    const LOG_START_TRANSACTION = 'START_TRANSACTION';
    const LOG_END_TRANSACTION = 'END_TRANSACTION';
    const ERROR_EVENT_RECORDING_DOES_NOT_EXIST = 'Event recording does not exist for ticket: ';
    const ERROR_EVENT_WATCHER_DOES_NOT_EXIST = 'Event watcher does not exist for ticket: ';
    const ERROR_ENTITY_NOT_FOUND = 'Entity not found';
    const ERROR_ENTITY_NOT_STORED = 'Entity not stored';
    const ERROR_INVALID_ACTION_CONTEXT = 'Invalid action context';
    const ERROR_TRANSACTION_NOT_STARTED = 'Transaction not started';
    const ERROR_UNSUPPORTED_ACTION = 'Unsupported action';

    const Manager = function(
        config,
        initialData,
        promiseFactory,
        requestActionContainer,
        store,
        lang,
        objectMerger,
        uniqueIDGenerator,
        logger
    ) {
        this.transactionCount = 0;

        this.config = config;
        this.promiseFactory = promiseFactory;
        this.requestActionContainer = requestActionContainer;
        this.store = store;
        this.lang = lang;
        this.objectMerger = objectMerger;
        this.uniqueIDGenerator = uniqueIDGenerator;
        this.logger = logger;

        this.eventRecordings = {};
        this.eventWatchers = [];
        this.subscriptions = {};
        this.storageInterface = new StorageInterface(
            function(entity, context) {
                return this.store.has(entity, context);
            }.bind(this),
            function(entity, context) {
                const p = this.promiseFactory.get();

                this.store.has(entity, context).then(function(has) {
                    if (!has) {
                        this._logError(LOG_CATEGORY_STORAGE, ERROR_ENTITY_NOT_STORED);

                        p.reject(ERROR_ENTITY_NOT_STORED);
                        return;
                    }

                    this.store.get(entity, context).then(
                        function(data) {
                            p.resolve(data);
                        },
                        function() {
                            p.reject();
                        }
                    );
                }.bind(this));

                return p;
            }.bind(this),
            function(entity, context, data) {
                const p = this.promiseFactory.get();

                const groupId = this._generateEventGroupId();

                this._triggerEventWatchers(EVENT_IDENTIFIERS.STORAGE_UPDATE_START, {}, groupId);

                this._updateEntity(entity, context, data, groupId).then(function() {
                    this._triggerEventWatchers(EVENT_IDENTIFIERS.STORAGE_UPDATE_COMPLETE, {}, groupId);

                    p.resolve();
                }.bind(this));

                return p;
            }.bind(this),
            function(query) {
                return this.store.query(query);
            }.bind(this),
            function(entity, context) {
                const p = this.promiseFactory.get();

                this.store.has(entity, context).then(function(has) {
                    if (!has) {
                        p.resolve();
                        return;
                    }

                    this.store.get(entity, context).then(function(data) {
                        const groupId = this._generateEventGroupId();

                        this._triggerEventWatchers(EVENT_IDENTIFIERS.STORAGE_UPDATE_START, {}, groupId);

                        this._removeEntity(entity, context).then(function() {
                            this._notifySubscribers(entity, data, {}, groupId);
                            this._triggerEventWatchers(EVENT_IDENTIFIERS.STORAGE_UPDATE_COMPLETE, {}, groupId);
                            p.resolve();
                        }.bind(this));
                    }.bind(this));
                }.bind(this));

                return p;
            }.bind(this),
            this.store.clear.bind(this.store),
            function() {
                return this.startTransaction();
            }.bind(this),
            function() {
                this.endTransaction();
            }.bind(this)
        );
        this.currentTransactionId = null;

        this._updateEntitiesThatHaveConfigsMatchingTheRequest = function(requestData, requestAction, eventGroupId) {
            const promise = this.promiseFactory.get();

            this._preloadAffectedDataInStorageForMatchedConfigs(requestData, requestAction).then(function(affectedData) {
                const action = requestData.getAction();
                const promises = [];

                for (let i = 0; i < this.config.length; i++) {
                    if (this.config[i].action === action) {
                        const affected = requestAction.getAffected(this.config[i].entity);

                        this._logInfo(
                            LOG_CATEGORY_CONFIG_BASED_UPDATE,
                            'Number of affected ' + this.config[i].entity.toUpperCase() + ' entity is ' + affected.length
                        );

                        for(let j = 0; j < affected.length; j++) {
                            promises.push(
                                this._updateEntityBasedOnConfigRequestMatch(
                                    requestData,
                                    this.config[i],
                                    affectedData[i],
                                    affected[j],
                                    eventGroupId
                                )
                            );
                        }
                    }
                }

                this.promiseFactory.get().all(promises).then(function() {
                    promise.resolve();
                });
            }.bind(this));

            return promise;
        };

        this._preloadAffectedDataInStorageForMatchedConfigs = function(requestData, requestAction) {
            const affectedData = {};
            const loadEntitiesPromises = [];
            for (let i = 0; i < this.config.length; i++) {
                if (this.config[i].action === requestData.getAction()) {
                    affectedData[i] = {};
                    if (this.config[i].subjectEntity) {
                        const p = this._loadEntities(
                            this.config[i].subjectEntity, requestAction.getAffected(this.config[i].subjectEntity)
                        );

                        p.then(function(data) {
                            affectedData[i][this.config[i].subjectEntity] = data;
                        }.bind(this));

                        loadEntitiesPromises.push(p);
                    }
                }
            }

            const returnedPromise = this.promiseFactory.get();
            this.promiseFactory.get().all(loadEntitiesPromises).then(function() {
                returnedPromise.resolve(affectedData);
            });
            return returnedPromise;
        };

        this._loadEntities = function(entity, contexts) {
            const hasPromises = [];
            const contextsToLoad = [];
            for(let j = 0; j < contexts.length; j++) {
                const p = this.store.has(entity, contexts[j]);

                p.then(function(has) {
                    if (!has) {
                        return;
                    }

                    contextsToLoad.push(contexts[j]);
                }.bind(this));

                hasPromises.push(p);
            }

            const getPromises = [];
            const entityData = [];
            this.promiseFactory.get().all(hasPromises).then(function() {
                for(let j = 0; j < contextsToLoad.length; j++) {
                    const p = this.store.get(entity, contextsToLoad[j]);

                    p.then(function(data) {
                        entityData.push(data);
                    }.bind(this));

                    getPromises.push(p);
                }
            }.bind(this));

            const returnedPromise = this.promiseFactory.get();
            this.promiseFactory.get().all(getPromises).then(function() {
                returnedPromise.resolve(entityData);
            });
            return returnedPromise;
        };

        this._updateEntityBasedOnConfigRequestMatch = function(requestData, config, affectedData, affectedEntityContext, eventGroupId) {
            const entity = config.entity;
            const promise = this.promiseFactory.get();

            this.store.has(entity, affectedEntityContext).then(function(has) {
                if (!has) {
                    this._logWarning(LOG_CATEGORY_STORAGE, ERROR_ENTITY_NOT_FOUND);

                    if (this._isRequestContextAvailable(config.requiredContext, affectedEntityContext)) {
                        this._updateEntityUsingMatchedConfig(
                            this._extractObjectKeys(affectedEntityContext, config.requiredContext),
                            config,
                            affectedEntityContext,
                            requestData,
                            eventGroupId
                        ).then(function() {
                            promise.resolve();
                        });

                        return;
                    }

                    promise.resolve();
                    return;
                }

                this._logInfo(
                    LOG_CATEGORY_CONFIG_BASED_UPDATE,
                    'Config based entity updates for ' + entity.toUpperCase() + ' entity'
                );

                if (this._isRequestContextAvailable(config.requiredContext, affectedEntityContext)) {
                    this._logInfo(
                        LOG_CATEGORY_CONFIG_BASED_UPDATE,
                        'Config match for ' + entity.toUpperCase() + ' entity to update ' + config.entity.toUpperCase() + ' entity'
                    );

                    this._updateEntityUsingMatchedConfig(
                        this._extractObjectKeys(affectedEntityContext, config.requiredContext),
                        config,
                        affectedData,
                        requestData,
                        eventGroupId
                    ).then(function() {
                        promise.resolve();
                    });
                    return;
                }

                promise.resolve();
            }.bind(this));

            return promise;
        };

        this._isRequestContextAvailable = function(requiredContext, availableContext) {
            return this._objectHasKeys(availableContext, requiredContext);
        };

        this._areObjectsEqual = function(objectOne, objectTwo) {
            return this.lang.isEqual(objectOne, objectTwo);
        };

        this._notifySubscribers = function(entity, oldData, newData, eventGroupId) {
            if (!this.subscriptions.hasOwnProperty(entity)) {
                this._logInfo(
                    LOG_CATEGORY_SUBSCRIPTION,
                    'No subscriptions for ' + entity.toUpperCase() + ' entity'
                );
                return;
            }

            for(let uid in this.subscriptions[entity]) {
                const subscriptionContext = this.subscriptions[entity][uid].getSubscriptionRequest().getContext();

                if (
                    this.subscriptions[entity].hasOwnProperty(uid) &&
                    this.subscriptions[entity][uid].getSubscriptionRequest().getEntity() === entity &&
                    (this._objectContainsObject(oldData, subscriptionContext) || this._objectContainsObject(newData, subscriptionContext))
                ) {
                    this.subscriptions[entity][uid].getSubscriptionRequest().setContext(
                        this._createUpdatedSubscriptionContext(subscriptionContext, newData)
                    );

                    const events = this.subscriptions[entity][uid].getEmitter().getEvents();

                    if (events.length > 0) {
                        this._logInfo(
                            LOG_CATEGORY_SUBSCRIPTION,
                            'Subscription triggered for ' + entity.toUpperCase() + ' entity'
                        );

                        for (let i = 0; i < events.length; i++) {
                            events[i](newData, oldData);
                        }
                    }

                    this._triggerEventWatchers(
                        EVENT_IDENTIFIERS.SUBSCRIPTION_TRIGGERED,
                        {subscription: this.subscriptions[entity][uid]},
                        eventGroupId
                    );
                }
            }
        };

        this._createUpdatedSubscriptionContext = function(subscriptionContext, newData) {
            const newSubscriptionContext = {};
            for(let property in subscriptionContext) {
                if (subscriptionContext.hasOwnProperty(property)) {
                    if (
                        !newData.hasOwnProperty(property) ||
                        newData[property] === null ||
                        this._isWildCard(subscriptionContext[property])
                    ) {
                        newSubscriptionContext[property] = subscriptionContext[property];
                        continue;
                    }

                    newSubscriptionContext[property] = newData[property];
                }
            }
            return newSubscriptionContext;
        };

        this._objectHasKeys = function(object, keys) {
            for(let i = 0; i < keys.length; i++) {
                if (!object.hasOwnProperty(keys[i])) {
                    return false;
                }
            }

            return true;
        };

        this._extractObjectKeys = function(object, keys) {
            const r = {};
            for(let i = 0; i < keys.length; i++) {
                if (object.hasOwnProperty(keys[i])) {
                    r[keys[i]] = object[keys[i]];
                }
            }

            return r;
        };

        this._objectContainsObject = function(objectA, objectB) {
            for(let i in objectB) {
                if (
                    objectB.hasOwnProperty(i) &&
                    (!objectA.hasOwnProperty(i) || (objectA[i] !== objectB[i] && !this._isWildCard(objectB[i])))
                ) {
                    return false;
                }
            }

            return true;
        };

        this._isWildCard = function(object) {
            return object instanceof WildCard;
        };

        this._updateEntityUsingMatchedConfig = function(entityContext, config, affectedData, requestData, eventGroupId) {
            const entity = config.entity;
            const configData = config.data;
            const promise = this.promiseFactory.get();
            let stored = this.lang.clone(entityContext);
            let merged = this.lang.clone(entityContext);

            this.store.has(entity, entityContext).then(function(has) {
                if (has) {
                    let subjectsData = [];
                    if (config.subjectEntity) {
                        subjectsData = affectedData[config.subjectEntity];

                        if (!subjectsData.length) {
                            this._logWarning(
                                LOG_CATEGORY_STORAGE,
                                'Subject does not exist in store'
                            );

                            if (config.hasOwnProperty('remove') && config.remove === true) {
                                this._removeEntity(entity, entityContext).then(function() {
                                    this._notifySubscribers(entity, stored, merged, eventGroupId);
                                    promise.resolve();
                                }.bind(this));
                            } else {
                                promise.resolve();
                            }

                            return;
                        }
                    }

                    this.store.get(entity, entityContext).then(function(data) {
                        stored = data;
                        merged = this.lang.clone(stored);

                        for(let property in configData) {
                            if (configData.hasOwnProperty(property)) {
                                if (typeof configData[property] === 'function') {
                                    if (subjectsData.length) {
                                        const originalValue = stored[property];
                                        for(let i in subjectsData) {
                                            if (subjectsData.hasOwnProperty(i)) {
                                                merged[property] = configData[property]({request: requestData, subjectData: subjectsData[i], storedData: stored});

                                                stored[property] = merged[property];
                                            }
                                        }
                                        stored[property] = originalValue;
                                        continue;
                                    }

                                    merged[property] = configData[property]({request: requestData, subjectData: {}, storedData: stored});
                                } else {
                                    merged[property] = configData[property];
                                }
                            }
                        }

                        if (this._areObjectsEqual(stored, merged)) {
                            this._logInfo(
                                LOG_CATEGORY_STORAGE,
                                'Objects are equal, store not updated'
                            );

                            if (config.hasOwnProperty('remove') && config.remove === true) {
                                this._removeEntity(entity, entityContext).then(function() {
                                    this._notifySubscribers(entity, stored, merged, eventGroupId);
                                    promise.resolve();
                                }.bind(this));
                            } else {
                                promise.resolve();
                            }

                            return;
                        }

                        this._logInfo(
                            LOG_CATEGORY_STORAGE,
                            'Stored object updated'
                        );


                        if (config.hasOwnProperty('remove') && config.remove === true) {
                            this._removeEntity(entity, entityContext).then(function() {
                                this._notifySubscribers(entity, stored, merged, eventGroupId);
                                promise.resolve();
                            }.bind(this))
                        } else {
                            this._storeEntity(entity, merged).then(
                                function() {
                                    this._notifySubscribers(entity, stored, merged, eventGroupId);
                                    promise.resolve();
                                }.bind(this)
                            );
                        }
                    }.bind(this));

                    return;
                }

                for(let property in configData) {
                    if (configData.hasOwnProperty(property)) {
                        if (typeof configData[property] !== 'function') {
                            merged[property] = configData[property];
                        }
                    }
                }

                this._logInfo(
                    LOG_CATEGORY_STORAGE,
                    'Object stored'
                );

                if (config.hasOwnProperty('remove') && config.remove === true) {
                    this._removeEntity(entity, entityContext).then(function() {
                        this._notifySubscribers(entity, stored, merged, eventGroupId);
                        promise.resolve();
                    }.bind(this))
                } else {
                    this._storeEntity(entity, merged).then(function() {
                        this._notifySubscribers(entity, stored, merged, eventGroupId);
                        promise.resolve();
                    }.bind(this));
                }
            }.bind(this));

            return promise;
        };

        this._updateEntity = function(entity, context, data, eventGroupId) {
            const p = this.promiseFactory.get();

            this.store.has(entity, context).then(function(has) {
                let stored = {};
                let merged = {};

                if (has) {
                    this.store.get(entity, context).then(function(storedData) {
                        stored = storedData;
                        merged = this.objectMerger.merge(
                            this.lang.clone(stored),
                            data
                        );

                        if (this._areObjectsEqual(stored, merged)) {
                            this._logInfo(
                                LOG_CATEGORY_STORAGE,
                                'Objects are equal, store not updated'
                            );
                            p.resolve();
                            return;
                        }

                        this._logInfo(
                            LOG_CATEGORY_STORAGE,
                            'Stored object updated'
                        );

                        this._storeEntity(entity, merged).then(function() {
                            this._notifySubscribers(entity, stored, merged, eventGroupId);
                            p.resolve();
                        }.bind(this));
                    }.bind(this));

                    return;
                }

                merged = this.objectMerger.merge(context, data);

                this._logInfo(
                    LOG_CATEGORY_STORAGE,
                    'Object stored'
                );

                this._storeEntity(entity, merged).then(function() {
                    this._notifySubscribers(entity, stored, merged, eventGroupId);
                    p.resolve();
                }.bind(this));
            }.bind(this));

            return p;
        };

        this._storeEntity = function(entity, data) {
            const promise = this.promiseFactory.get();

            this.store.canStore(entity, data).then(function(canStore) {
                if (!canStore) {
                    this._logWarning(LOG_CATEGORY_STORAGE, 'Entity ' + entity + ' could not be stored');
                    promise.resolve();
                    return;
                }

                this.store.store(entity, data).then(function() {
                    promise.resolve();
                });
            }.bind(this));

            return promise;
        };

        this._removeEntity = function(entity, context) {
            const promise = this.promiseFactory.get();

            this.store.remove(entity, context).then(function() {
                this._logInfo(LOG_CATEGORY_STORAGE, 'Object removed');
                promise.resolve();
            }.bind(this));

            return promise;
        };

        this._logError = function(category, message) {
            this.logger.error('DATA MANAGER[' + category + '] - ' + message);
        };

        this._logWarning = function(category, message) {
            this.logger.warn('DATA MANAGER[' + category + '] - ' + message);
        };

        this._logInfo = function(category, message) {
            this.logger.info('DATA MANAGER[' + category + '] - ' + message);
        };

        this._setInitialData = function() {
            for(let entity in initialData) {
                if (initialData.hasOwnProperty(entity)) {
                    for(let i = 0; i < initialData[entity].length; i++) {
                        this.getStorage().updateEntity(entity, initialData[entity][i], initialData[entity][i]);
                    }
                }
            }
        };

        this._notifyEventRecordersOfRequest = function(request, action) {
            for(let ticket in this.eventRecordings) {
                if (this.eventRecordings.hasOwnProperty(ticket)) {
                    this.eventRecordings[ticket].requestEvents.push(
                        new EventRecorderRequestEventData(request, action)
                    );
                }
            }
        };

        this._generateEventGroupId = function() {
            return this.uniqueIDGenerator.generate();
        };

        this._triggerEventWatchers = function(id, data, groupId) {
            for(let ticket in this.eventWatchers) {
                if (this.eventWatchers.hasOwnProperty(ticket)) {
                    this.eventWatchers[ticket].getOnEvent()(
                        new EventData(id, data, groupId, this.currentTransactionId)
                    );
                }
            }
        };
    };

    Manager.prototype.startUp = function() {
        this.store.removeObsoleteData();
        this._setInitialData();
    };

    Manager.prototype.getStorage = function() {
        return this.storageInterface;
    };

    Manager.prototype.subscribe = function(subscriptionRequest) {
        if (!this.subscriptions.hasOwnProperty(subscriptionRequest.getEntity())) {
            this.subscriptions[subscriptionRequest.getEntity()] = {};
        }

        const uid = this.uniqueIDGenerator.generate();

        this.subscriptions[subscriptionRequest.getEntity()][uid] = new SubscriptionData(
            uid,
            subscriptionRequest,
            new SubscriptionEmitterData()
        );

        this._logInfo(
            LOG_CATEGORY_SUBSCRIPTION,
            'Subscribed to ' + subscriptionRequest.getEntity().toUpperCase() + ' entity'
        );

        return this.subscriptions[subscriptionRequest.getEntity()][uid];
    };

    Manager.prototype.unsubscribe = function(subscription) {
        const entity = subscription.getSubscriptionRequest().getEntity();
        const uid = subscription.getUid();

        if (!this.subscriptions.hasOwnProperty(entity)) {
            return;
        }

        if (!this.subscriptions[entity].hasOwnProperty(uid)) {
            return;
        }

        delete this.subscriptions[entity][uid];

        this._logInfo(
            LOG_CATEGORY_SUBSCRIPTION,
            'Unsubscribed from ' + entity.toUpperCase() + ' entity'
        );
    };

    Manager.prototype.request = function(requestData) {
        const groupId = this._generateEventGroupId();
        this._triggerEventWatchers(EVENT_IDENTIFIERS.REQUEST_START, {request: requestData}, groupId);

        if (!this.requestActionContainer.has(requestData)) {
            this._logError(LOG_CATEGORY_CONSUMER_ERROR, ERROR_UNSUPPORTED_ACTION);

            throw ERROR_UNSUPPORTED_ACTION;
        }

        const requestAction = this.requestActionContainer.get(requestData);

        this._logInfo(
            LOG_CATEGORY_REQUEST,
            'New request for ' + requestData.getAction().toUpperCase() + ' action'
        );

        if (!requestAction.canAction()) {
            this._logError(LOG_CATEGORY_CONSUMER_ERROR, ERROR_INVALID_ACTION_CONTEXT);

            throw ERROR_INVALID_ACTION_CONTEXT;
        }

        this._updateEntitiesThatHaveConfigsMatchingTheRequest(requestData, requestAction, groupId).then(function() {
            this._triggerEventWatchers(EVENT_IDENTIFIERS.REQUEST_COMPLETE, {request: requestData}, groupId);
        }.bind(this));

        this._triggerEventWatchers(EVENT_IDENTIFIERS.REQUEST_ACTION_START, {request: requestData}, groupId);

        const actionData = requestAction.action(this.getStorage());

        actionData.getPromise().then(function(response) {
            this._triggerEventWatchers(EVENT_IDENTIFIERS.REQUEST_ACTION_COMPLETE, {action: actionData, response: response}, groupId);
        }.bind(this), function() {});

        this._notifyEventRecordersOfRequest(requestData, actionData);

        return actionData;
    };

    Manager.prototype.startTransaction = function() {
        this.transactionCount++;

        this._logInfo(
            LOG_START_TRANSACTION,
            'Attempting to start a transaction, now '
            + this.transactionCount + ' consumer(s) transacting'
        );

        if(!this.currentTransactionId) {
            this.currentTransactionId = this.uniqueIDGenerator.generate();

            this._logInfo(
                LOG_START_TRANSACTION,
                'Transaction started with new UID ' + this.currentTransactionId
            );
        } else {
            this._logInfo(
                LOG_START_TRANSACTION,
                'Using existing transaction with UID ' + this.currentTransactionId
            );
        }

        this._triggerEventWatchers(EVENT_IDENTIFIERS.TRANSACTION_START, {}, null);

        return this.currentTransactionId;
    };

    Manager.prototype.endTransaction = function() {
        if (!this.currentTransactionId) {
            throw ERROR_TRANSACTION_NOT_STARTED;
        }

        this.transactionCount--;

        this._logInfo(
            LOG_END_TRANSACTION,
            'Attempting to end the transaction with UID ' + this.currentTransactionId + ', now ' +
            this.transactionCount + ' consumer(s) transacting'
        );

        if(this.transactionCount > 0) {
            this._logInfo(
                LOG_END_TRANSACTION,
                'Transaction with UID ' + this.currentTransactionId + ' not ended, '
                + this.transactionCount + ' other consumer(s) still using this transaction'
            );
            return;
        }

        if(this.transactionCount === 0) {
            this._triggerEventWatchers(EVENT_IDENTIFIERS.TRANSACTION_END, {}, null);

            this._logInfo(
                LOG_END_TRANSACTION,
                'Transaction with UID ' + this.currentTransactionId + ' ended as there are ' +
                'no other consumers using this transaction'
            );

            this.currentTransactionId = null;
        }
    };

    Manager.prototype.addEventWatcher = function(eventWatcher) {
        const ticket = this.uniqueIDGenerator.generate();

        this.eventWatchers[ticket] = eventWatcher;

        return ticket;
    };

    Manager.prototype.removeEventWatcher = function(ticket) {
        if (!this.eventWatchers.hasOwnProperty(ticket)) {
            throw ERROR_EVENT_WATCHER_DOES_NOT_EXIST + ticket;
        }

        delete this.eventWatchers[ticket];
    };

    Manager.prototype.startEventRecorder = function() {
        const ticket = this.uniqueIDGenerator.generate();

        this.eventRecordings[ticket] = {
            'requestEvents': []
        };

        return ticket;
    };

    Manager.prototype.endEventRecorder = function(ticket) {
        if (!this.eventRecordings.hasOwnProperty(ticket)) {
            throw ERROR_EVENT_RECORDING_DOES_NOT_EXIST + ticket;
        }

        const ed = new EventRecordingData(this.eventRecordings[ticket].requestEvents);

        delete this.eventRecordings[ticket];

        return ed;
    };

    return Manager;
});

},
'spencer/data-manager/data/event/Event':function(){
define([], function() {
    const Event = function(id, data, groupId, transactionId) {
        this.id = id;
        this.data = data || {};
        this.groupId = groupId || null;
        this.transactionId = transactionId || null;
    };

    Event.prototype.getId = function() {
        return this.id;
    };

    Event.prototype.getData = function() {
        return this.data;
    };

    Event.prototype.getGroupId = function() {
        return this.groupId;
    };

    Event.prototype.getTransactionId = function() {
        return this.transactionId;
    };

    return Event;
});
},
'spencer/data-manager/data/event-recorder/Recording':function(){
define([], function() {
    const Recording = function(requestEvents) {
        this.requestEvents = requestEvents;
    };

    Recording.prototype.getRequestEvents = function() {
        return this.requestEvents;
    };

    return Recording;
});
},
'spencer/data-manager/data/event-recorder/RequestEvent':function(){
define([], function() {
    const Request = function(request, action) {
        this.request = request;
        this.action = action;
    };

    Request.prototype.getInitialRequest = function() {
        return this.request;
    };

    Request.prototype.getResultingAction = function() {
        return this.action;
    };

    return Request;
});
},
'spencer/data-manager/data/Subscription':function(){
define([], function() {
    const Subscription = function(uid, subscriptionRequest, emitter) {
        this.uid = uid;
        this.subscriptionRequest = subscriptionRequest;
        this.emitter = emitter;
    };

    Subscription.prototype.getUid = function() {
        return this.uid;
    };

    Subscription.prototype.getSubscriptionRequest = function() {
        return this.subscriptionRequest;
    };

    Subscription.prototype.getEmitter = function() {
        return this.emitter;
    };

    return Subscription;
});
},
'spencer/data-manager/data/SubscriptionEmitter':function(){
define([], function() {
    const SubscriptionEmitter = function() {
        this.events = [];
    };

    SubscriptionEmitter.prototype.addEvent = function(func) {
        this.events.push(func);
        return this;
    };

    SubscriptionEmitter.prototype.getEvents = function() {
        return this.events;
    };

    return SubscriptionEmitter;
});
},
'spencer/data-manager/event/Identifiers':function(){
define([], function() {
    return {
        REQUEST_ACTION_START: 'request-action-start',
        REQUEST_ACTION_COMPLETE: 'request-action-complete',
        REQUEST_START: 'request-start',
        REQUEST_COMPLETE: 'request-complete',
        STORAGE_UPDATE_START: 'storage-update-start',
        STORAGE_UPDATE_COMPLETE: 'storage-update-complete',
        SUBSCRIPTION_TRIGGERED: 'subscription-triggered',
        TRANSACTION_START: 'transaction-start',
        TRANSACTION_END: 'transaction-end'
    };
});
},
'spencer/data-manager/request/action/StorageInterface':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class StorageInterface {
        constructor(hasEntityFunc, getEntityFunc, updateEntityFunc, queryFunc, removeFunc, clearFunc, startTransactionFunc, endTransactionFunc) {
            this.hasEntityFunc = hasEntityFunc;
            this.getEntityFunc = getEntityFunc;
            this.updateEntityFunc = updateEntityFunc;
            this.queryFunc = queryFunc;
            this.removeFunc = removeFunc;
            this.clearFunc = clearFunc;
            this.startTransactionFunc = startTransactionFunc;
            this.endTransactionFunc = endTransactionFunc;
        }
        hasEntity(entity, context) {
            return this.hasEntityFunc(entity, context);
        }
        getEntity(entity, context) {
            return this.getEntityFunc(entity, context);
        }
        updateEntity(entity, context, data) {
            return this.updateEntityFunc(entity, context, data);
        }
        query(query) {
            return this.queryFunc(query);
        }
        remove(entity, context) {
            return this.removeFunc(entity, context);
        }
        clear() {
            return this.clearFunc();
        }
        startTransaction() {
            return this.startTransactionFunc();
        }
        endTransaction() {
            this.endTransactionFunc();
        }
    }
    return StorageInterface;
});

},
'spencer/data-manager/subscription/WildCard':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class WildCard {
    }
    return WildCard;
});

},
'spencer/data-manager/request/URLConnectionBuilderFactory':function(){
define([
    'library/request/URLConnectionBuilder',
    'library/request/dojo/URLConnectionProcessorBuilder'
], function(
    URLConnectionBuilder,
    URLConnectionProcessorBuilder
) {
    const URLConnectionBuilderFactory = function() {};

    URLConnectionBuilderFactory.prototype.get = function() {
        return new URLConnectionBuilder(
            new URLConnectionProcessorBuilder()
        );
    };

    return URLConnectionBuilderFactory;
});
},
'spencer/data-manager/storage/KeyGenerator':function(){
define([], function() {
    const KEY_SEPARATOR = '_';
    const KEY_SEPARATOR_REPLACEMEMT = '-';
    const ERROR_UNSUPPORTED_ENTITY = 'Key generation not supported for entity: ';
    const ERROR_INSUFFICIENT_DATA = 'Insufficient data for key generation';
    const SYSTEM_WIDE_PREFIX = 'system_wide_data_manager';

    const KeyGenerator = function(supportedEntities, systemTag, applicationVersion, currentPerson) {
        this.systemTag = systemTag;
        this.keyPrefix = systemTag;
        this.supportedEntities = supportedEntities;

        if(applicationVersion) {
            this.keyPrefix = applicationVersion.replace(KEY_SEPARATOR, KEY_SEPARATOR_REPLACEMEMT) + KEY_SEPARATOR + this.keyPrefix;
        }

        if (currentPerson && currentPerson.getPersonPK()) {
            this.keyPrefix += KEY_SEPARATOR + currentPerson.getPersonPK();
        }

        this._getPrefix = function() {
            if (!this.keyPrefix) {
                return '';
            }

            return this.keyPrefix + KEY_SEPARATOR;
        };

        this._stripPrefixFromKey = function(key) {
            if (!this.keyPrefix) {
                return key;
            }

            return key.replace(this.keyPrefix + KEY_SEPARATOR, '');
        };

        this._stripDataFromKey = function(key) {
            if (key.indexOf(KEY_SEPARATOR) > 0) {
                return key.substring(0, key.indexOf(KEY_SEPARATOR));
            }

            return key;
        };
    };

    KeyGenerator.prototype.isSupportedEntity = function(entity) {
        return this.supportedEntities.hasOwnProperty(entity);
    };

    KeyGenerator.prototype.isSystemKey = function(key) {
        return key.indexOf(this.systemTag) !== -1;
    };

    KeyGenerator.prototype.isCurrentKey = function(key) {
        return key.indexOf(this._getPrefix()) === 0;
    };

    KeyGenerator.prototype.canGenerate = function(entity, data) {
        return this.isSupportedEntity(entity) && this.supportedEntities[entity].hasSufficientData(data);
    };

    KeyGenerator.prototype.generate = function(entity, data) {
        let prefix = this._getPrefix();

        if (!this.isSupportedEntity(entity)) {
            throw ERROR_UNSUPPORTED_ENTITY + entity;
        }

        if (!this.supportedEntities[entity].hasSufficientData(data)) {
            throw ERROR_INSUFFICIENT_DATA;
        }

        if (this.supportedEntities[entity].isSystemWide) {
            prefix = SYSTEM_WIDE_PREFIX + KEY_SEPARATOR;
        }

        return prefix + this.supportedEntities[entity].generate(data);
    };

    KeyGenerator.prototype.getEntityForKey = function(key) {
        if (!key) {
            return null;
        }

        let entity = this._stripDataFromKey(this._stripPrefixFromKey(key));

        if (!this.isSupportedEntity(entity)) {
            return null;
        }

        return entity;
    };

    return KeyGenerator;
});

},
'spencer/data-manager/storage/local-forage/Store':function(){
define([], function() {
    const ERROR_DATA_NOT_FOUND = 'Data not found';
    const ERROR_EMPTY_QUERY = 'Empty query';
    const ERROR_UNSUPPORTED_QUERY = 'Query not supported';
    const SUPPORTED_QUERIES = ['entity', 'data'];

    const Store = function(localForage, promiseFactory, keyGenerator) {
        this.localForage = localForage;
        this.promiseFactory = promiseFactory;
        this.keyGenerator = keyGenerator;

        this._verifyQuery = function(query) {
            let queryCount = 0;
            for(let attr in query) {
                if (query.hasOwnProperty(attr)) {
                    queryCount++;

                    if (SUPPORTED_QUERIES.indexOf(attr) === -1) {
                        throw ERROR_UNSUPPORTED_QUERY;
                    }
                }
            }

            if (!queryCount) {
                throw ERROR_EMPTY_QUERY;
            }
        };

        this._getKeysForEntity = function(entity) {
            const p = this.promiseFactory.get();

            this.localForage.keys().then(function(keys) {
                const matchedKeys = [];
                for(let i = 0; i < keys.length; i++) {
                    if (this.keyGenerator.getEntityForKey(keys[i]) === entity) {
                        matchedKeys.push(keys[i]);
                    }
                }

                p.resolve(matchedKeys);
            }.bind(this));

            return p;
        };

        this._getDataForKeys = function(keys) {
            const p = this.promiseFactory.get();
            const data = [];

            const promises = [];
            for(let i = 0; i < keys.length; i++) {
                const p = this.localForage.getItem(keys[i]).then(function(value) {
                    data.push(value);
                }.bind(this));

                promises.push(p);
            }

            this.promiseFactory.get().all(promises).then(function() {
                p.resolve(data);
            }.bind(this));
            return p;
        };

        this._filterDataOnField = function(data, field, value) {
            const r = [];
            for(let i in data) {
                if (
                    data.hasOwnProperty(i) &&
                    data[i].hasOwnProperty(field) &&
                    JSON.stringify(data[i][field]) === JSON.stringify(value)
                ) {
                    r.push(data[i]);
                }
            }
            return r;
        };
    };

    Store.prototype.has = function(entity, context) {
        const p = this.promiseFactory.get();

        if (!this.keyGenerator.canGenerate(entity, context)) {
            p.resolve(false);
            return p;
        }

        this.localForage.getItem(this.keyGenerator.generate(entity, context), function(err, value) {
            p.resolve(!err && !!value);
        });

        return p;
    };

    Store.prototype.get = function(entity, context) {
        const p = this.promiseFactory.get();

        if (!this.keyGenerator.canGenerate(entity, context)) {
            p.reject(ERROR_DATA_NOT_FOUND);
            return p;
        }

        this.localForage.getItem(this.keyGenerator.generate(entity, context), function(err, value) {
            if (err && !!value) {
                p.reject(ERROR_DATA_NOT_FOUND);
                return;
            }

            p.resolve(value);
        });

        return p;
    };

    Store.prototype.query = function(query) {
        this._verifyQuery(query);

        const p = this.promiseFactory.get();

        this._getKeysForEntity(query['entity']).then(function(keys) {
            this._getDataForKeys(keys).then(function(data) {
                if (query.hasOwnProperty('data')) {
                    const dataFilter = query['data'];
                    for(let i in dataFilter) {
                        if (dataFilter.hasOwnProperty(i)) {
                            data = this._filterDataOnField(data, i, dataFilter[i]);
                        }
                    }
                }

                p.resolve(data);
            }.bind(this));
        }.bind(this));

        return p;
    };

    Store.prototype.canStore = function(entity, data) {
        const p = this.promiseFactory.get();

        p.resolve(this.keyGenerator.canGenerate(entity, data));

        return p;
    };

    Store.prototype.store = function(entity, data) {
        return this.localForage.setItem(this.keyGenerator.generate(entity, data), data);
    };

    Store.prototype.storeCollection = async function(entity, context, data) {
        return this.localForage.setItem(this.keyGenerator.generate(entity, context), data);
    };

    Store.prototype.remove = function(entity, context) {
        return this.localForage.removeItem(this.keyGenerator.generate(entity, context));
    };

    Store.prototype.removeObsoleteData = function() {
        this.localForage.keys().then(function(keys) {
            keys.forEach(function(key) {
                if (!this.keyGenerator.isSystemKey(key) || this.keyGenerator.isCurrentKey(key)) {
                    return;
                }

                this.localForage.removeItem(key);
            }.bind(this));
        }.bind(this));
    };

    Store.prototype.clear = function() {
        return this.localForage.clear();
    };

    return Store;
});

},
'spencer/data-manager/utility/UniqueID':function(){
define([
    'spencer/utility/RandomStringGenerator'
], function(
    RandomStringGenerator
) {
    const LENGTH = 32;

    const UniqueID = function() {
        this.randomStringGenerator = new RandomStringGenerator(LENGTH);
    };

    UniqueID.prototype.generate = function() {
        return this.randomStringGenerator.generate();
    };

    return UniqueID;
});
},
'spencer/data-manager/core/Config':function(){
define(["require", "exports", "spencer/data-manager/core/definition/Actions"], function (require, exports, ACTIONS) {
    "use strict";
    const config = [
        {
            action: ACTIONS.CREATE_DOCUMENT_FAVOURITE,
            requiredContext: ['revisionPK'],
            data: {
                'documentPK': context => context['documentPK'],
                'name': context => context['name']
            }
        },
        {
            action: ACTIONS.FAVOURITE_DOCUMENT_GET,
            requiredContext: ['documentPK'],
            data: {
                'documentPK': context => context['documentPK']
            }
        },
        {
            action: ACTIONS.REMOVE_DOCUMENT_FAVOURITE,
            requiredContext: ['favouritePK'],
            data: {
                'favouritePK': context => context['favouritePK']
            }
        }
    ];
    return config;
});

},
'doccontrol/extraction/management/DiagnosticTool':function(){
/// <amd-dependency path="soso/sosox/ejs/_Templated" name="_Templated" />
/// <amd-dependency path="dojo/text!./template/DiagnosticTool.html" name="template" />
define(["require", "exports", "soso/sosox/ejs/_Templated", "dojo/text!./template/DiagnosticTool.html", "api/doccontrol/Config", "api/doccontrol/Factory", "api/doccontrol/file/QrReader/Factory", "api/doccontrol/template/Config", "api/doccontrol/template/Factory", "api/doccontrol/template/parser/Template", "api/file/Config", "api/file/Factory", "spencer/parse/BytesToMegabytes", "library/request/helper/DefaultUnauthorisedCallback", "style-guide/v1/doc-control/registration-details/DocumentRegister/ExtractedData", "style-guide/v1/forms/FileDragDrop", "style-guide/v1/layout/FormPane", "library/request/data/Form", "@lib/request/data/HTTPResponseCodes", "library/request/data/Handlers", "library/request/URLConnectionBuilder", "library/request/dojo/URLConnectionProcessorBuilder", "library/request/URLResponseProcessorBuilder", "dijit/_WidgetBase", "dojo/_base/declare", "spencer/utility/RandomStringGenerator"], function (require, exports, _Templated, template, APIDocControlConfig, APIDocControlFactory, APIDocControlFileQRReaderFactory, APIDocControlTemplateConfig, APIDocControlTemplateFactory, APIDocControlTemplateParser, APIFileConfig, APIFileFactory, BytesToMegabytes, DefaultUnauthorisedCallback, ExtractedData, FileDragDrop, FormPane, FormVO, HTTP_RESPONSE_CODES, HandlersVO, URLConnectionBuilder, URLConnectionProcessorBuilder, URLResponseProcessorBuilder, _WidgetBase, declare, RandomStringGenerator) {
    "use strict";
    var ViewState;
    (function (ViewState) {
        ViewState[ViewState["FILE_SELECT"] = 0] = "FILE_SELECT";
        ViewState[ViewState["FILE_SIZE_ERROR"] = 1] = "FILE_SIZE_ERROR";
        ViewState[ViewState["FILE_UPLOADING"] = 2] = "FILE_UPLOADING";
        ViewState[ViewState["FILE_ERROR"] = 3] = "FILE_ERROR";
        ViewState[ViewState["QR_CODE_SCANNING"] = 4] = "QR_CODE_SCANNING";
        ViewState[ViewState["QR_CODE_FOUND"] = 5] = "QR_CODE_FOUND";
        ViewState[ViewState["QR_CODE_NOT_FOUND"] = 6] = "QR_CODE_NOT_FOUND";
        ViewState[ViewState["QR_CODE_INVALID"] = 7] = "QR_CODE_INVALID";
        ViewState[ViewState["QR_CODE_INCOMPATIBLE_FILE_TYPE"] = 8] = "QR_CODE_INCOMPATIBLE_FILE_TYPE";
        ViewState[ViewState["QR_CODE_ERROR"] = 9] = "QR_CODE_ERROR";
        ViewState[ViewState["TEMPLATE_SEARCH"] = 10] = "TEMPLATE_SEARCH";
        ViewState[ViewState["TEMPLATE_NOT_FOUND"] = 11] = "TEMPLATE_NOT_FOUND";
        ViewState[ViewState["TEMPLATE_FOUND"] = 12] = "TEMPLATE_FOUND";
        ViewState[ViewState["TEMPLATE_NO_FIELDS"] = 13] = "TEMPLATE_NO_FIELDS";
        ViewState[ViewState["TEMPLATE_ERROR"] = 14] = "TEMPLATE_ERROR";
        ViewState[ViewState["EXTRACT_PROCESSING"] = 15] = "EXTRACT_PROCESSING";
        ViewState[ViewState["EXTRACT_DATA_FOUND"] = 16] = "EXTRACT_DATA_FOUND";
        ViewState[ViewState["EXTRACT_ERROR"] = 17] = "EXTRACT_ERROR";
    })(ViewState || (ViewState = {}));
    const UPLOADED_FILES_KEY = 'uploadedFiles';
    const ROUTE_HANDLE_EDIT_TEMPLATE = 'EDIT_TEMPLATE';
    const IGNORE_CACHE = true;
    class DiagnosticTool {
        constructor(uploadLimitMegabytes, parentForm = null) {
            this.uploadLimitMegabytes = uploadLimitMegabytes;
            const View = this.getView();
            this.view = new View({
                parentForm: parentForm,
                uploadLimitMegabytes: this.uploadLimitMegabytes,
            });
        }
        open() {
            this.view.open();
        }
        close() {
            this.view.close();
        }
        setTemporaryDocument(temporaryDocument) {
            this.view.setTemporaryDocument(temporaryDocument);
        }
        setRouteContainer(routeContainer) {
            this.view.setRouteContainer(routeContainer);
        }
        reset() {
            this.view.reset();
        }
        getView() {
            return declare([_WidgetBase, _Templated], {
                apiDocControlFactory: null,
                apiDocControlFileQRReaderFactory: null,
                apiDocControlTemplateParser: null,
                apiFileFactory: null,
                apiTemplateFactory: null,
                data: {
                    uploadLimitMegabytes: null,
                },
                elementAnchorFoundTemplate: null,
                elementAnchorFoundTemplateContainer: null,
                elementDiagnosticToolForm: null,
                elementExtractedData: null,
                elementFileSizeError: null,
                elementQRContent: null,
                elementReset: null,
                elementSectionExtractedData: null,
                elementSectionResults: null,
                elementSectionTroubleshootQR: null,
                elementSectionTroubleshootExtractedData: null,
                elementSectionUploadFile: null,
                elementSectionQRData: null,
                elementStatusDataExtraction: null,
                elementStatusDataExtractionIcon: null,
                elementStatusFileUpload: null,
                elementStatusFileUploadIcon: null,
                elementStatusFindTemplate: null,
                elementStatusFindTemplateIcon: null,
                elementStatusFoundTemplate: null,
                elementStatusQRCodeScanning: null,
                elementStatusQRCodeScanningIcon: null,
                elementStatusVerifyQRCodeData: null,
                elementStatusVerifyQRCodeDataIcon: null,
                elementUploadField: null,
                parentForm: null,
                routeContainer: null,
                uploadLimitMegabytes: null,
                templateString: template,
                widgetExtractedData: null,
                widgetFileDragDrop: null,
                widgetFormPane: null,
                md5: null,
                temporaryDocument: null,
                requests: [],
                formId: null,
                postCreate() {
                    this.formId = `diagnosticToolForm_${(new RandomStringGenerator()).generate()}`;
                    this.elementDiagnosticToolForm.id = this.formId;
                    this.inherited(this.postCreate, arguments);
                    this.initModels();
                    this.initWidgets();
                    this.setState(ViewState.FILE_SELECT);
                },
                initModels() {
                    this.apiDocControlFactory = new APIDocControlFactory(new APIDocControlConfig(), new URLConnectionBuilder(new URLConnectionProcessorBuilder()), new URLResponseProcessorBuilder());
                    this.apiFileFactory = new APIFileFactory(new APIFileConfig(), new URLConnectionBuilder(new URLConnectionProcessorBuilder()), new URLResponseProcessorBuilder());
                    this.apiDocControlTemplateParser = new APIDocControlTemplateParser();
                    this.apiTemplateFactory = new APIDocControlTemplateFactory(new APIDocControlTemplateConfig(), new URLConnectionBuilder(new URLConnectionProcessorBuilder()), new URLResponseProcessorBuilder());
                    this.apiDocControlFileQRReaderFactory = new APIDocControlFileQRReaderFactory();
                },
                initWidgets() {
                    this.widgetFormPane = new FormPane({
                        title: 'Diagnostic Tool',
                        icon: 'sos-icon-spanner',
                        content: this.domNode,
                        parentForm: this.parentForm,
                        onClose: () => {
                            this.reset();
                        }
                    });
                    this.widgetFileDragDrop = new FileDragDrop({
                        fileLabel: 'file',
                        uploadLimitMegabytes: this.data.uploadLimitMegabytes,
                        uploadLimitAttachmentCount: 1,
                        showTable: false,
                        className: 'sos-form-file-drag-drop sos-form-input-stretch'
                    }, this.elementUploadField);
                    this.widgetFileDragDrop.on('added', this.processFile.bind(this));
                    this.widgetExtractedData = new ExtractedData(this.elementExtractedData, true, false);
                },
                postMixInProperties() {
                    this.inherited(this.postMixInProperties, arguments);
                    this.data.uploadLimitMegabytes = this.uploadLimitMegabytes;
                },
                open() {
                    this.widgetFormPane.open();
                    if (this.temporaryDocument) {
                        this.readQRCode(this.temporaryDocument.getMd5());
                    }
                },
                close() {
                    this.widgetFormPane.close();
                },
                setTemporaryDocument(temporaryDocument) {
                    this.temporaryDocument = temporaryDocument;
                    this.elementReset.setAttribute('hidden', 'hidden');
                },
                setRouteContainer(routeContainer) {
                    this.routeContainer = routeContainer;
                    this.elementAnchorFoundTemplateContainer.removeAttribute('hidden');
                },
                reset() {
                    this.elementFileSizeError.setAttribute('hidden', 'hidden');
                    this.elementReset.removeAttribute('hidden');
                    this.elementSectionExtractedData.setAttribute('hidden', 'hidden');
                    this.elementSectionQRData.setAttribute('hidden', 'hidden');
                    this.elementSectionResults.setAttribute('hidden', 'hidden');
                    this.elementSectionUploadFile.setAttribute('hidden', 'hidden');
                    this.elementSectionTroubleshootQR.setAttribute('hidden', 'hidden');
                    this.elementSectionTroubleshootExtractedData.setAttribute('hidden', 'hidden');
                    this.elementStatusFoundTemplate.setAttribute('hidden', 'hidden');
                    this.elementStatusFileUpload.innerHTML = '-';
                    this.elementStatusFileUploadIcon.setAttribute('class', '');
                    this.elementStatusQRCodeScanning.innerHTML = '-';
                    this.elementStatusQRCodeScanningIcon.setAttribute('class', '');
                    this.elementStatusVerifyQRCodeData.innerHTML = '-';
                    this.elementStatusVerifyQRCodeDataIcon.setAttribute('class', '');
                    this.elementStatusFindTemplate.innerHTML = '-';
                    this.elementStatusFindTemplateIcon.setAttribute('class', '');
                    this.elementStatusDataExtraction.innerHTML = '-';
                    this.elementStatusDataExtractionIcon.setAttribute('class', '');
                    this.widgetFileDragDrop.reset();
                    this.elementAnchorFoundTemplate.href = null;
                    this.elementQRContent.innerText = '';
                    this.widgetExtractedData.reset();
                    this.requests.forEach(request => request.cancel());
                    this.requests = [];
                    this.temporarydocument = null;
                    this.setState(ViewState.FILE_SELECT);
                },
                onResetClick() {
                    this.reset();
                },
                processFile(file) {
                    if ((new BytesToMegabytes()).convert(file.size) > this.uploadLimitMegabytes) {
                        this.setState(ViewState.FILE_SIZE_ERROR);
                        return;
                    }
                    this.uploadFile(file);
                },
                uploadFile(file) {
                    this.setState(ViewState.FILE_UPLOADING, { uploadPercent: 0 });
                    const request = this.apiFileFactory.getTemporaryUploader().upload(new HandlersVO((result) => {
                        if (result[0].isRegistered()) {
                            this.readQRCode(result[0].getMD5());
                            return;
                        }
                        const request = this.apiDocControlFactory.getDocumentCollection().setFileKeys([result[0].getKey()]).create(new HandlersVO((temporaryDocuments) => {
                            this.readQRCode(temporaryDocuments[0].getMd5());
                        }, () => { }, DefaultUnauthorisedCallback, () => {
                            this.setState(ViewState.FILE_ERROR);
                        }));
                        this.requests.push(request);
                    }, (loaded, total) => {
                        const percent = Math.round((loaded / total) * 100);
                        this.setState(ViewState.FILE_UPLOADING, { uploadPercent: percent });
                    }, DefaultUnauthorisedCallback, () => {
                        this.setState(ViewState.FILE_ERROR);
                    }), new FormVO()
                        .setId(this.formId)
                        .setFileKey(UPLOADED_FILES_KEY)
                        .setFiles([file]));
                    this.requests.push(request);
                },
                readQRCode(md5) {
                    this.setState(ViewState.QR_CODE_SCANNING);
                    const request = this.apiDocControlFileQRReaderFactory.getQRCodeReader().get(new HandlersVO((qrContent) => {
                        this.setState(ViewState.QR_CODE_FOUND, { qrContent: qrContent });
                        let parsedQRContent = null;
                        try {
                            parsedQRContent = JSON.parse(qrContent);
                        }
                        catch (e) { }
                        if (!parsedQRContent || !parsedQRContent.reference) {
                            this.setState(ViewState.QR_CODE_INVALID);
                            return;
                        }
                        this.getTemplate(md5, this.apiDocControlTemplateParser.parse(parsedQRContent));
                    }, () => { }, DefaultUnauthorisedCallback, (error) => {
                        if (error.status == HTTP_RESPONSE_CODES.unprocessable_content) {
                            this.setState(ViewState.QR_CODE_INCOMPATIBLE_FILE_TYPE);
                            return;
                        }
                        this.setState(ViewState.QR_CODE_ERROR);
                    }).setNoContent(() => {
                        this.setState(ViewState.QR_CODE_NOT_FOUND);
                    }), md5);
                    this.requests.push(request);
                },
                getTemplate(md5, template) {
                    this.setState(ViewState.TEMPLATE_SEARCH);
                    const request = this.apiTemplateFactory.getTemplate().get(new HandlersVO((template) => {
                        this.setState(ViewState.TEMPLATE_FOUND, { template: template });
                        if (!template.getFieldCollection().length) {
                            this.setState(ViewState.TEMPLATE_NO_FIELDS);
                            return;
                        }
                        this.extractContent(md5, template);
                    }, () => { }, DefaultUnauthorisedCallback, (error, description, statusCode) => {
                        if (statusCode == HTTP_RESPONSE_CODES.not_found) {
                            this.setState(ViewState.TEMPLATE_NOT_FOUND);
                            return;
                        }
                        this.setState(ViewState.TEMPLATE_ERROR);
                    }), template);
                    this.requests.push(request);
                },
                extractContent(md5, template) {
                    this.setState(ViewState.EXTRACT_PROCESSING);
                    const request = this.apiTemplateFactory.getExtractor().extract(new HandlersVO((fieldCollection) => {
                        this.setState(ViewState.EXTRACT_DATA_FOUND, { md5: md5, fieldCollection: fieldCollection });
                    }, () => { }, DefaultUnauthorisedCallback, () => {
                        this.setState(ViewState.EXTRACT_ERROR);
                    }), md5, template.getTemplatePK(), IGNORE_CACHE);
                    this.requests.push(request);
                },
                setState(viewState, data) {
                    switch (viewState) {
                        case ViewState.FILE_SELECT:
                        case ViewState.FILE_SIZE_ERROR:
                            this.elementSectionUploadFile.removeAttribute('hidden');
                            if (viewState === ViewState.FILE_SIZE_ERROR) {
                                this.elementFileSizeError.removeAttribute('hidden');
                            }
                            break;
                        default:
                            this.elementSectionUploadFile.setAttribute('hidden', 'hidden');
                            this.elementReset.removeAttribute('hidden');
                            this.elementSectionResults.removeAttribute('hidden');
                            this.elementQRContent.removeAttribute('hidden');
                            this.setStatusText(viewState, data);
                            if (data?.qrContent) {
                                this.elementQRContent.innerHTML = data.qrContent;
                                this.elementSectionQRData.removeAttribute('hidden');
                            }
                            if (data?.template)
                                this.widgetExtractedData.setTemplate(data?.template);
                            if (data?.md5)
                                this.widgetExtractedData.setMd5(data?.md5);
                            if (data?.fieldCollection) {
                                this.widgetExtractedData.setFieldCollection(data?.fieldCollection);
                                this.elementSectionExtractedData.removeAttribute('hidden');
                            }
                    }
                },
                setStatusText(viewState, data) {
                    const sosIconProcessing = 'sos-icon sos-icon-animation-spin-smooth sos-icon-refresh';
                    const sosIconError = 'sos-icon sos-icon-close';
                    const sosIconCheck = 'sos-icon sos-icon-check';
                    const sosIconWarning = 'sos-icon sos-icon-warning';
                    const unknownError = 'An unknown error occurred, please contact support.';
                    const incompatibleFileTypeError = 'File type is not supported.';
                    switch (viewState) {
                        case ViewState.FILE_UPLOADING:
                            this.elementStatusFileUpload.innerHTML = this.formatUploadingText(data);
                            this.elementStatusFileUploadIcon.setAttribute('class', sosIconProcessing);
                            return;
                        case ViewState.QR_CODE_SCANNING:
                            this.elementStatusFileUpload.innerHTML = 'File successfully uploaded.';
                            this.elementStatusFileUploadIcon.setAttribute('class', sosIconCheck);
                            this.elementStatusQRCodeScanning.innerHTML = 'Scanning for QR code...';
                            this.elementStatusQRCodeScanningIcon.setAttribute('class', sosIconProcessing);
                            return;
                        case ViewState.QR_CODE_INCOMPATIBLE_FILE_TYPE:
                            this.elementStatusQRCodeScanning.innerHTML = incompatibleFileTypeError;
                            this.elementStatusQRCodeScanningIcon.setAttribute('class', sosIconError);
                            return;
                        case ViewState.QR_CODE_ERROR:
                            this.elementStatusQRCodeScanning.innerHTML = unknownError;
                            this.elementStatusQRCodeScanningIcon.setAttribute('class', sosIconError);
                            this.elementSectionTroubleshootQR.removeAttribute('hidden');
                            return;
                        case ViewState.QR_CODE_NOT_FOUND:
                            this.elementStatusQRCodeScanning.innerHTML = 'QR code not found.';
                            this.elementStatusQRCodeScanningIcon.setAttribute('class', sosIconError);
                            this.elementSectionTroubleshootQR.removeAttribute('hidden');
                            return;
                        case ViewState.QR_CODE_FOUND:
                            this.elementStatusQRCodeScanning.innerHTML = 'QR code found.';
                            this.elementStatusQRCodeScanningIcon.setAttribute('class', sosIconCheck);
                            return;
                        case ViewState.QR_CODE_INVALID:
                            this.elementStatusVerifyQRCodeData.innerHTML = 'Template reference value not found in data (see QR data section below).';
                            this.elementStatusVerifyQRCodeDataIcon.setAttribute('class', sosIconError);
                            return;
                        case ViewState.TEMPLATE_SEARCH:
                            this.elementStatusVerifyQRCodeData.innerHTML = 'QR code data verified (see QR data section below).';
                            this.elementStatusVerifyQRCodeDataIcon.setAttribute('class', sosIconCheck);
                            this.elementStatusFindTemplate.innerHTML = 'Searching for template relating to QR code reference...';
                            this.elementStatusFindTemplateIcon.setAttribute('class', sosIconProcessing);
                            return;
                        case ViewState.TEMPLATE_ERROR:
                            this.elementStatusFindTemplate.innerHTML = unknownError;
                            this.elementStatusFindTemplateIcon.setAttribute('class', sosIconError);
                            return;
                        case ViewState.TEMPLATE_NOT_FOUND:
                            this.elementStatusFindTemplate.innerHTML = 'Template not found.';
                            this.elementStatusFindTemplateIcon.setAttribute('class', sosIconError);
                            return;
                        case ViewState.TEMPLATE_FOUND:
                            this.elementStatusFindTemplate.innerHTML = 'Template found for reference "' + data.template.reference + '"';
                            this.elementStatusFindTemplateIcon.setAttribute('class', sosIconCheck);
                            this.elementStatusFoundTemplate.removeAttribute('hidden');
                            if (this.routeContainer) {
                                this.elementAnchorFoundTemplate.href = this.routeContainer.get(ROUTE_HANDLE_EDIT_TEMPLATE, {
                                    'templatePK': data.template.templatePK,
                                });
                            }
                            return;
                        case ViewState.TEMPLATE_NO_FIELDS:
                            this.elementStatusDataExtraction.innerHTML = 'Template has no fields defined.';
                            this.elementStatusDataExtractionIcon.setAttribute('class', sosIconError);
                            return;
                        case ViewState.EXTRACT_PROCESSING:
                            this.elementStatusDataExtraction.innerHTML = 'Extracting data using template...';
                            this.elementStatusDataExtractionIcon.setAttribute('class', sosIconProcessing);
                            return;
                        case ViewState.EXTRACT_ERROR:
                            this.elementStatusDataExtraction.innerHTML = unknownError;
                            this.elementStatusDataExtractionIcon.setAttribute('class', sosIconError);
                            this.elementSectionTroubleshootExtractedData.removeAttribute('hidden');
                            return;
                        case ViewState.EXTRACT_DATA_FOUND:
                            const fieldsWithNoData = data ? data.fieldCollection.filter(field => !field.ocrValue).length : 0;
                            if (fieldsWithNoData > 0) {
                                this.elementStatusDataExtraction.innerHTML = fieldsWithNoData + ' field' + (fieldsWithNoData === 1 ? '' : 's') + ' returned no data (see extracted data section below).';
                                this.elementStatusDataExtractionIcon.setAttribute('class', sosIconWarning);
                                this.elementSectionTroubleshootExtractedData.removeAttribute('hidden');
                                return;
                            }
                            this.elementStatusDataExtraction.innerHTML = 'Data extracted, see extracted data section below.';
                            this.elementStatusDataExtractionIcon.setAttribute('class', sosIconCheck);
                            return;
                    }
                },
                formatUploadingText(data) {
                    return 'Uploading file' + (data?.hasOwnProperty('uploadPercent') ? ' (' + data.uploadPercent + '%)' : '') + '...';
                }
            });
        }
    }
    return DiagnosticTool;
});

},
'api/doccontrol/file/QrReader/Factory':function(){
define([
    './QRCodeReader',
    './Config',
    'library/request/fetch/Factory'
], function(
    QRCodeReader,
    Config,
    FetchFactory
) {
    const Factory = function() {
        this.config = new Config();
    };

    Factory.prototype.getQRCodeReader = function() {
        return new QRCodeReader(
            this.config.getUrl('api_doc_control_file_qr_code_reader', 'v2/'),
            new FetchFactory()
        );
    };

    return Factory;
});
},
'api/doccontrol/file/QrReader/QRCodeReader':function(){
define([
    'library/request/data/HTTPResponseCodes'
], function(HTTPResponseCodes) {
    const QRCodeReader = function(url, fetchFactory) {
        this.url = url;
        this.fetchFactory = fetchFactory;
    };

    QRCodeReader.prototype.get = function(handlers, md5) {
        const fetchProcessor = this.fetchFactory.get();
        fetchProcessor.setSuccessHandler(async response => {
            handlers.getSuccess()(await response.json());
        });
        fetchProcessor.setHandler(HTTPResponseCodes.no_content, handlers.getNoContent());
        fetchProcessor.setErrorHandler(handlers.getError());

        fetchProcessor.get(this.url.replace(':md5', md5))
            .catch(e => {
                if (!fetchProcessor.isCancelled()) handlers.getError()?.(e);
                if (fetchProcessor.isCancelled()) handlers.getAbort()?.(e);
            });

        return fetchProcessor;
    };

    return QRCodeReader;
});
},
'api/doccontrol/file/QrReader/Config':function(){
define([
    'api/Config'
], function(apiConfig) {
    const Config = function (rootUrl) {
        this.base = apiConfig;
        this.base(rootUrl);
        this.api_doc_control_file_qr_code_reader = 'doc-control/file/:md5/qr-code';
    };

    Config.prototype = Object.create(apiConfig.prototype);

    return Config;
});
},
'style-guide/v1/doc-control/registration-details/DocumentRegister/ExtractedData':function(){
///<amd-dependency path="dojo/text!./template/ExtractedData.html" name="template" />
///<amd-dependency path="soso/sosox/ejs/_Templated" name="_Templated" />
define(["require", "exports", "dojo/text!./template/ExtractedData.html", "soso/sosox/ejs/_Templated", "spencer/doc-control/template/revision/data/Metadata", "doccontrol/document/template/Initialiser", "dijit/_WidgetBase", "dojo/_base/declare", "dojo/dom-attr", "dojo/dom-class", "dojo/_base/query"], function (require, exports, template, _Templated, Metadata, TemplateInitialiser, _WidgetBase, dojoDeclare, domAttr, domClass, query) {
    "use strict";
    class ExtractedData {
        constructor(attachPoint, disableViewer = false, showHeader = true) {
            const view = ExtractedData.getView();
            this.view = new view({
                disableViewer: disableViewer,
                showHeader: showHeader
            }, attachPoint);
        }
        setMd5(md5) {
            this.view.setMd5(md5);
            return this;
        }
        setTemplate(template) {
            this.view.setTemplate(template);
            return this;
        }
        setFieldCollection(fieldCollection) {
            this.view.setFieldCollection(fieldCollection);
            return this;
        }
        getData() {
            return this.view.getData();
        }
        reset() {
            this.view.reset();
        }
        static getView() {
            return dojoDeclare([_WidgetBase, _Templated], {
                disableViewer: false,
                templateString: template,
                template: null,
                md5: null,
                showHeader: true,
                data: {
                    disableViewer: false,
                    metadataCollection: [],
                    showHeader: true
                },
                postMixInProperties: function () {
                    this.inherited(this.postMixInProperties, arguments);
                    this.data.disableViewer = this.disableViewer;
                    this.data.showHeader = this.showHeader;
                },
                setMd5: function (md5) {
                    this.md5 = md5;
                },
                setTemplate: function (template) {
                    this.template = template;
                },
                setFieldCollection: function (fieldCollection) {
                    this.data.metadataCollection = fieldCollection.map((field) => new Metadata(this.md5, field.templateFieldPK, field.name, typeof field.value == 'string' ? field.value.trim() : field.value, field.image, typeof field.ocrValue == 'string' ? field.ocrValue.trim() : field.ocrValue));
                    this.render();
                },
                reset: function () {
                    this.data.metadataCollection = [];
                    this.render();
                },
                getData: function () {
                    return this.data.metadataCollection.map((metadata) => {
                        if (this['metadataValue_' + metadata.getTemplateFieldPK()]) {
                            metadata.setValue(this['metadataValue_' + metadata.getTemplateFieldPK()].value.trim());
                        }
                        return metadata;
                    }).filter(metadata => metadata.getValue() || metadata.getOCRValue());
                },
                _viewDefinition: function (e) {
                    TemplateInitialiser
                        .setViewOnly()
                        .setTemplate(this.template)
                        .focusOnField(domAttr.get(e.target, 'data-id'))
                        .execute(this.md5);
                },
                _collapseField: function (e) {
                    const fieldPK = domAttr.get(e.target, 'data-id');
                    domClass.add(e.target, 'hide');
                    query('.show-button-'.concat(fieldPK)).removeClass('hide');
                    query('.field-row-'.concat(fieldPK)).addClass('hide');
                },
                _expandField: function (e) {
                    const fieldPK = domAttr.get(e.target, 'data-id');
                    domClass.add(e.target, 'hide');
                    query('.hide-button-'.concat(fieldPK)).removeClass('hide');
                    query('.field-row-'.concat(fieldPK)).removeClass('hide');
                },
                _collapseAll: function () {
                    query('.show-all-button').removeClass('hide');
                    query('.hide-all-button').addClass('hide');
                    query('.show-button').removeClass('hide');
                    query('.hide-button').addClass('hide');
                    query('.field-row').addClass('hide');
                },
                _expandAll: function () {
                    query('.hide-all-button').removeClass('hide');
                    query('.show-all-button').addClass('hide');
                    query('.hide-button').removeClass('hide');
                    query('.show-button').addClass('hide');
                    query('.field-row').removeClass('hide');
                }
            });
        }
    }
    return ExtractedData;
});

},
'doccontrol/document/template/Initialiser':function(){
define([
    './Controller',
    './Topics',
    './TopicSubscriber',
    './dojo/Container',
    './model/Factory',
    './model/Viewer',
    'library/DojoTopicWrapper',
    'library/request/data/Handlers',
    'library/request/helper/DefaultUnauthorisedCallback',
    'spencer/utility/Binder'
], function(
    Controller,
    TOPICS,
    TopicSubscriber,
    WidgetContainer,
    Factory,
    ViewerModel,
    Topic,
    HandlersVO,
    DefaultUnauthorisedCallback,
    Binder
) {
    return {
        initialised: false,
        topic: null,
        viewerModel: null,
        widgetContainer: null,
        binder: null,
        viewOnly: false,

        template: null,
        focusOnTemplateFieldPK: null,

        execute: function(data) {
            this._init();

            if (typeof data === 'string') {
                this.viewerModel.getDocumentDetails(
                    new HandlersVO(
                        function success(documentDetails) {
                            this.topic.publish(TOPICS.DOCUMENT_TEMPLATE_VIEWER_VIEW, documentDetails);

                            if (this.viewOnly) {
                                this.widgetContainer.get('templater').setViewOnlyMode();
                            }

                            if (this.template) {
                                this.widgetContainer.get('templater').setTemplate(this.template);
                            }

                            if (this.focusOnTemplateFieldPK) {
                                this.widgetContainer.get('templater').focusOnField(this.focusOnTemplateFieldPK);
                            }
                        }.bind(this),
                        function progress() {},
                        DefaultUnauthorisedCallback,
                        function error() {},
                        function abort() {}
                    ),
                    data
                );

            } else {
                data.getTitle = function() { return data.name; };
                data.getFileType = function() { return data.type; };
                data.getSize = function() { return data.size; };

                this.topic.publish(TOPICS.DOCUMENT_TEMPLATE_VIEWER_VIEW_LOCAL, data);
            }

            return this;
        },

        setTemplate: function(template) {
            this.template = template;
            return this;
        },

        setViewOnly: function() {
            this.viewOnly = true;
            return this;
        },

        focusOnField: function(templateFieldPK) {
            this.focusOnTemplateFieldPK = templateFieldPK;
            return this;
        },

        setFieldNameStore: function(store) {
            this._init();
            this.widgetContainer.get('templater').setFieldNameStore(store);

            return this;
        },

        getTemplate: function() {
            this._init();

            return this.widgetContainer.get('templater').getTemplate();
        },

        getFieldCollection() {
            this._init();

            return this.widgetContainer.get('templater').getFieldCollection();
        },

        _init: function() {
            if (this.initialised === false) {
                this.viewerModel = new ViewerModel(new Factory());
                this.widgetContainer = new WidgetContainer();
                this.topic = new Topic();
                this.binder = new Binder();

                this.controller = new Controller(
                    this.viewerModel,
                    this.widgetContainer,
                    this.binder
                );

                (new TopicSubscriber(
                    this.topic,
                    this.binder,
                    this.controller
                )).startup();

                this.initialised = true;
            }
        }
    };
});
},
'doccontrol/document/template/Controller':function(){
define([
    './FileType',
    'api/doccontrol/template/parser/Template',
    'library/PromiseFactory',
    'library/request/data/Handlers',
    'library/request/helper/DefaultUnauthorisedCallback',
    'pdf/request/data/Handlers',
    'spencer/doc-control/data/Revision',
    'spencer/doc-control/format/url/DownloadRevision',
    'spencer/doc-control/format/url/DownloadTemporaryDocument',
    'spencer/format/MimeType'
], function(
    FileType,
    TemplateParser,
    PromiseFactory,
    HandlersVO,
    DefaultUnauthorisedCallback,
    PdfHandlersVO,
    RevisionVO,
    DownloadRevisionUrl,
    DownloadTemporaryDocumentUrl,
    MimeTypeFormatter
) {
    const Controller = function(viewerModel, widgetContainer, binder) {
        this.viewerModel = viewerModel;
        this.widgetContainer = widgetContainer;
        this.binder = binder;
        this.mimeTypeFormatter = new MimeTypeFormatter();

        this.documentDetails = null;

        this._fetchError =  function(error) {
            if (error && error.name && error.name == 'InvalidPDFException')  {
                this._renderError(error);
                return;
            }

            this.widgetContainer.get('viewer')
                && this.widgetContainer.get('viewer').showNetworkErrorMessage
                && this.widgetContainer.get('viewer').showNetworkErrorMessage();

            this._hideTemplater();
        };

        this._renderError =  function(error) {
            this.widgetContainer.get('view-toolbar')
                && this.widgetContainer.get('view-toolbar').hide
                && this.widgetContainer.get('view-toolbar').hide();

            this.widgetContainer.get('viewer')
                && this.widgetContainer.get('viewer').showRenderErrorMessage
                && this.widgetContainer.get('viewer').showRenderErrorMessage();

            this._hideTemplater();
        };

        this._unauthorised = function() {
            this.widgetContainer.get('viewer')
                && this.widgetContainer.get('viewer').showUnauthorisedMessage
                && this.widgetContainer.get('viewer').showUnauthorisedMessage();

            this._hideTemplater();
        };

        this._password = function(updatePasswordCallback, reason) {
            const prompt = this.viewerModel.constants.PASSWORD_RESPONSES[reason];
            this.widgetContainer.get('viewer').showPasswordForm(prompt)
                .then(function (password) {
                    updatePasswordCallback(password);
                });
        };

        this._gone = function() {
            this.widgetContainer.get('viewer')
                && this.widgetContainer.get('viewer').showDeletedMessage
                && this.widgetContainer.get('viewer').showDeletedMessage();

            this._hideTemplater();
        };

        this._hideTemplater = function() {
            this.widgetContainer.get('templater')
                && this.widgetContainer.get('templater').hide
                && this.widgetContainer.get('templater').hide();
        };

        this._imageFetchSuccess = function(dataUrl) {
            this._logViewIfRevision();

            this._viewImage(dataUrl);
        };

        this._pdfFetchSuccess = function(pdf) {
            this._logViewIfRevision();

            this._viewPdf(pdf);
        };

        this._logViewIfRevision = function() {
            if (this.documentDetails && this.documentDetails.getDocumentType() === 'Revision') {
                this.viewerModel.logView(
                    new HandlersVO(),
                    (new RevisionVO).setRevisionPK(this.documentDetails.getId())
                );
            }
        };

        this._showViewOptionsToolbar = function() {
            this.widgetContainer.get('view-toolbar').show();
            this.widgetContainer.get('viewer').showToolbar();
        };

        this._viewImage = function(dataUrl) {
            this.widgetContainer.get('templater');
            this._showViewOptionsToolbar();

            this.widgetContainer.get('viewer').setImage(dataUrl)
                .then(this.binder.bindScope(this._postCalculateScale, this))
                .then(
                    this.binder.bindScope(this._postRender, this),
                    this.binder.bindScope(this._renderError, this)
                );
        };

        this._viewPdf = function(pdfDocument) {
            this.widgetContainer.get('templater');
            this._showViewOptionsToolbar();

            this.widgetContainer.get('viewer').setPdf(pdfDocument)
                .then(this.binder.bindScope(this._postCalculateScale, this))
                .then(
                    this.binder.bindScope(this._postRender, this),
                    this.binder.bindScope(this._renderError, this)
                );
        };

        this._postCalculateScale = function(scale) {
            this.widgetContainer.get('templater').setScale(scale);
            this.widgetContainer.get('view-toolbar').scale(scale);
            this.widgetContainer.get('viewer').scale(scale);
            return this.widgetContainer.get('viewer').render();
        };

        this._postRender = function(canvas) {
            this.widgetContainer.get('templater').setPageNumber(this.widgetContainer.get('viewer').getPageNumber());
            this.widgetContainer.get('templater').setViewer(this.widgetContainer.get('viewer'));
            this.widgetContainer.get('templater').setSource(canvas);
            this.widgetContainer.get('view-toolbar').enable();
        };

        this._disable = function() {
            this.widgetContainer.get('view-toolbar').disable();
            this.widgetContainer.get('templater').disable();
        };
    };

    Controller.prototype.view = function(documentDetails) {
        this.documentDetails = documentDetails;

        if (FileType.isValid(documentDetails.getFileType())) {
            this.widgetContainer.get('dialog-toolbar', documentDetails);
            this._disable();

            const url = (documentDetails.getDocumentType() === 'Revision'
                    ? new DownloadRevisionUrl()
                    : new DownloadTemporaryDocumentUrl()
            ).setId(documentDetails.getId()).format();

            if (FileType.isImage(documentDetails.getFileType())) {
                const fileHandlers = new HandlersVO(
                    this.binder.bindScope(this._imageFetchSuccess, this),
                    function progress() {},
                    this.binder.bindScope(this._unauthorised, this),
                    this.binder.bindScope(this._fetchError, this),
                    function abort() {}
                );
                fileHandlers.setGone(this.binder.bindScope(this._gone, this));

                this.viewerModel.getFile(fileHandlers, url);

            } else {
                this.viewerModel.getPdf(
                    new PdfHandlersVO(
                        this.binder.bindScope(this._pdfFetchSuccess, this),
                        this.binder.bindScope(this._fetchError, this),
                        this.binder.bindScope(this._unauthorised, this),
                        function abort() {},
                        this.binder.bindScope(this._password, this),
                        this.binder.bindScope(this._gone, this)
                    ),
                    url
                );
            }

        } else {
            this.widgetContainer.get('notification').error('UNSUPPORTED_FILE_TYPE_ERROR', {
                mimetype: this.mimeTypeFormatter.format(documentDetails.getFileType())
            });
        }
    };

    Controller.prototype.viewLocal = function(file) {
        if (FileType.isImage(file.type)) {
            this.widgetContainer.get('dialog-toolbar', file);
            this._disable();

            this.viewerModel.getImageFromFile(
                new HandlersVO(
                    this.binder.bindScope(this._viewImage, this),
                    function progress() {},
                    DefaultUnauthorisedCallback,
                    function error(error) {
                        console.log('get image from file error', error);
                    }
                ),
                file
            );

        } else if (FileType.isPdf(file.type)) {
            this.widgetContainer.get('dialog-toolbar', file);
            this._disable();

            this.viewerModel.getPdfFromFile(
                new HandlersVO(
                    this.binder.bindScope(
                        function success(dataUrl) {
                            this.viewerModel.getPdf(
                                new PdfHandlersVO(
                                    this.binder.bindScope(this._viewPdf, this),
                                    this.binder.bindScope(this._renderError, this),
                                    this.binder.bindScope(this._unauthorised, this),
                                    function abort() {},
                                    this.binder.bindScope(this._password, this),
                                    this.binder.bindScope(this._gone, this)
                                ),
                                dataUrl
                            );
                        },
                        this
                    ),
                    function progress() {},
                    function unauthorised() {},
                    function error(error) {
                        console.log('get pdf from file error', error);
                    }
                ),
                file
            );

        } else {
            this.widgetContainer.get('notification').error('UNSUPPORTED_FILE_TYPE_ERROR', {
                mimetype: this.mimeTypeFormatter.format(file.type)
            });
        }
    };

    Controller.prototype.render = function() {
        this._disable();

        this.widgetContainer.get('viewer').render()
            .then(this.binder.bindScope(this._postRender, this));
    };

    Controller.prototype.fitWidth = function() {
        this._disable();

        this.widgetContainer.get('viewer').fitToWidth()
            .then(this.binder.bindScope(this._postCalculateScale, this))
            .then(this.binder.bindScope(this._postRender, this));
    };

    Controller.prototype.fitPage = function() {
        this._disable();

        this.widgetContainer.get('viewer').fitToPage()
            .then(this.binder.bindScope(this._postCalculateScale, this))
            .then(this.binder.bindScope(this._postRender, this));
    };

    Controller.prototype.rotate = function(rotation) {
        this._disable();

        this.widgetContainer.get('templater').setRotation(rotation);
        this.widgetContainer.get('viewer').rotate(rotation);
        this.widgetContainer.get('viewer').render()
            .then(this.binder.bindScope(this._postRender, this));
    };

    Controller.prototype.scale = function(scale) {
        this._disable();

        this._postCalculateScale(scale)
            .then(this.binder.bindScope(this._postRender, this));
    };

    Controller.prototype.defineField = function() {
        this.startFieldDefinition();
        this.widgetContainer.get('templater').createNewField();
    };

    Controller.prototype.startFieldDefinition = function() {
        this.widgetContainer.get('viewer').enterSelectionMode();
    };

    Controller.prototype.endFieldDefinition = function() {
        this.widgetContainer.get('viewer').exitSelectionMode();
    };

    Controller.prototype.hide = function() {
        this.widgetContainer.get('viewer').hide();
    };

    return Controller;
});
},
'doccontrol/document/template/FileType':function(){
define(['doccontrol/viewer/FileTypeViewable'], function(FileTypeViewable) {
    const CORRESPONDENCE = 'message/rfc822';
    const IMAGE = 'image';
    const MEDIA = ['video', 'audio'];
    const PDF = 'application/pdf';

    return {
        isImage: function(fileType) {
            return fileType.toLowerCase().indexOf(IMAGE) == 0;
        },

        isPdf: function(fileType) {
            return fileType.toLowerCase() === PDF;
        },

        isValid: function(fileType) {
            return fileType.toLowerCase() !== CORRESPONDENCE
                && !MEDIA.some(function(v) { return fileType.toLowerCase().indexOf(v) >= 0; })
                && (new FileTypeViewable().isViewable(fileType.toLowerCase()));
        }
    }
});
},
'spencer/doc-control/format/url/DownloadRevision':function(){
define([
], function() {
    const DownloadRevision = function() {
        this.viewerUrl = baseUrl + 'v1/doc-control/revision/:id/file';
        this.id = null;
    };

    DownloadRevision.prototype.setId = function(id) {
        this.id = id;
        return this;
    };

    DownloadRevision.prototype.format = function() {
        return this.viewerUrl.replace(':id', this.id);
    };

    return DownloadRevision;
});
},
'spencer/doc-control/format/url/DownloadTemporaryDocument':function(){
define([
], function() {
    const DownloadTemporaryDocument = function() {
        this.viewerUrl = baseUrl + 'v1/doc-control/temporary-document/:id/file';
        this.id = null;
    };

    DownloadTemporaryDocument.prototype.setId = function(id) {
        this.id = id;
        return this;
    };

    DownloadTemporaryDocument.prototype.format = function() {
        return this.viewerUrl.replace(':id', this.id);
    };

    return DownloadTemporaryDocument;
});
},
'doccontrol/document/template/Topics':function(){
define([], function() {
    return {
        DOCUMENT_TEMPLATE_VIEWER_DEFINE_FIELD: '/document/template/viewer/define/field',
        DOCUMENT_TEMPLATE_VIEWER_FIELD_DEFINITION_END: '/document/template/viewer/end/field/definition',
        DOCUMENT_TEMPLATE_VIEWER_FIELD_DEFINITION_START: '/document/template/viewer/field/definition/start',
        DOCUMENT_TEMPLATE_VIEWER_FIT_PAGE: '/document/template/viewer/fit/page',
        DOCUMENT_TEMPLATE_VIEWER_FIT_WIDTH: '/document/template/viewer/fit/width',
        DOCUMENT_TEMPLATE_VIEWER_HIDE: '/document/template/viewer/hide',
        DOCUMENT_TEMPLATE_VIEWER_RENDER: '/document/template/viewer/render',
        DOCUMENT_TEMPLATE_VIEWER_ROTATE: '/document/template/viewer/rotate',
        DOCUMENT_TEMPLATE_VIEWER_SCALE: '/document/template/viewer/scale',
        DOCUMENT_TEMPLATE_VIEWER_VIEW: '/document/template/viewer/view',
        DOCUMENT_TEMPLATE_VIEWER_VIEW_LOCAL: '/document/template/viewer/view/local'
    };
});
},
'doccontrol/document/template/TopicSubscriber':function(){
define(['./Topics'], function(TOPICS) {
    const TopicSubscriber = function(topicWrapper, binder, Controller) {
        this.topicWrapper = topicWrapper;
        this.binder = binder;
        this.controller = Controller;
    };

    TopicSubscriber.prototype.startup = function() {
        this.topicWrapper.subscribe(
            TOPICS.DOCUMENT_TEMPLATE_VIEWER_VIEW,
            this.binder.bindScope(this.controller.view, this.controller)
        );
        this.topicWrapper.subscribe(
            TOPICS.DOCUMENT_TEMPLATE_VIEWER_VIEW_LOCAL,
            this.binder.bindScope(this.controller.viewLocal, this.controller)
        );
        this.topicWrapper.subscribe(
            TOPICS.DOCUMENT_TEMPLATE_VIEWER_RENDER,
            this.binder.bindScope(this.controller.render, this.controller)
        );
        this.topicWrapper.subscribe(
            TOPICS.DOCUMENT_TEMPLATE_VIEWER_FIT_WIDTH,
            this.binder.bindScope(this.controller.fitWidth, this.controller)
        );
        this.topicWrapper.subscribe(
            TOPICS.DOCUMENT_TEMPLATE_VIEWER_FIT_PAGE,
            this.binder.bindScope(this.controller.fitPage, this.controller)
        );
        this.topicWrapper.subscribe(
            TOPICS.DOCUMENT_TEMPLATE_VIEWER_SCALE,
            this.binder.bindScope(this.controller.scale, this.controller)
        );
        this.topicWrapper.subscribe(
            TOPICS.DOCUMENT_TEMPLATE_VIEWER_ROTATE,
            this.binder.bindScope(this.controller.rotate, this.controller)
        );
        this.topicWrapper.subscribe(
            TOPICS.DOCUMENT_TEMPLATE_VIEWER_DEFINE_FIELD,
            this.binder.bindScope(this.controller.defineField, this.controller)
        );
        this.topicWrapper.subscribe(
            TOPICS.DOCUMENT_TEMPLATE_VIEWER_FIELD_DEFINITION_START,
            this.binder.bindScope(this.controller.startFieldDefinition, this.controller)
        );
        this.topicWrapper.subscribe(
            TOPICS.DOCUMENT_TEMPLATE_VIEWER_FIELD_DEFINITION_END,
            this.binder.bindScope(this.controller.endFieldDefinition, this.controller)
        );
        this.topicWrapper.subscribe(
            TOPICS.DOCUMENT_TEMPLATE_VIEWER_HIDE,
            this.binder.bindScope(this.controller.hide, this.controller)
        );
    };

    return TopicSubscriber;
});
},
'doccontrol/document/template/dojo/Container':function(){
define([
    './DialogToolbar',
    './Templater',
    './Viewer',
    './ViewToolbar',
    'doccontrol/viewer/dojo/FileTypeTile',
    'style-guide/v1/notifications/Notification'
], function(
    DialogToolbar,
    Templater,
    Viewer,
    ViewToolbar,
    FileTypeTile,
    Notification
) {
    const DIALOG_TOOLBAR = 'dialog-toolbar';
    const NOTIFICATION = 'notification';
    const TEMPLATER = 'templater';
    const VIEWER = 'viewer';
    const VIEW_TOOLBAR = 'view-toolbar';

    const Container = function() {
        this.dialogToolbarWidget = null;
        this.notificationWidget = null;
        this.templaterWidget = null;
        this.viewerWidget = null;
        this.viewToolbarWidget = null;

        const _getDialogToolbarWidget = function(documentDetails) {
            if (!this.dialogToolbarWidget || this.dialogToolbarWidget.view._destroyed) {
                this.dialogToolbarWidget = new DialogToolbar({
                    document: documentDetails
                }, _getViewerWidget.bind(this)().getDialogToolbarNode());
            }

            return this.dialogToolbarWidget;
        };

        const _getNotificationWidget = function() {
            if (!this.notificationWidget) {
                this.notificationWidget = new Notification(
                    'doccontrol/document/template/dojo/templates/notification/',
                    {
                        UNSUPPORTED_FILE_TYPE_ERROR: 'UnsupportedFileTypeError.html'
                    }
                );
            }
            return this.notificationWidget;
        };

        const _getTemplaterWidget = function() {
            if (!this.templaterWidget || this.templaterWidget.view._destroyed) {
                this.templaterWidget = new Templater(_getViewerWidget.bind(this)(), _getViewerWidget.bind(this)().getTemplaterNode());
            }

            return this.templaterWidget;
        };

        const _getViewerWidget = function() {
            if (!this.viewerWidget || this.viewerWidget.view._destroyed) {
                this.viewerWidget = new Viewer();
            }

            return this.viewerWidget;
        };

        const _getViewToolbarWidget = function() {
            if (!this.viewToolbarWidget || this.viewToolbarWidget.view._destroyed) {
                this.viewToolbarWidget = new ViewToolbar(_getViewerWidget.bind(this)().getViewOptionsToolbarNode());
            }

            return this.viewToolbarWidget;
        };

        this.supportedWidgets = {};
        this.supportedWidgets[DIALOG_TOOLBAR] = _getDialogToolbarWidget.bind(this);
        this.supportedWidgets[NOTIFICATION] = _getNotificationWidget.bind(this);
        this.supportedWidgets[TEMPLATER] = _getTemplaterWidget.bind(this);
        this.supportedWidgets[VIEWER] = _getViewerWidget.bind(this);
        this.supportedWidgets[VIEW_TOOLBAR] = _getViewToolbarWidget.bind(this);
    };

    Container.prototype.has = function(name) {
        return this.supportedWidgets[name] !== undefined;
    };

    Container.prototype.get = function(name, documentDetails) {
        if (!this.has(name)) {
            throw new Error('No widget exists named "' + name + '"');
        }

        return this.supportedWidgets[name](documentDetails);
    };

    return Container;
});
},
'doccontrol/document/template/dojo/DialogToolbar':function(){
define([
    '../Topics',
    'doccontrol/viewer/dojo/FileTypeTile',
    'dojo/_base/declare',
    'dojo/dom-construct',
    'dojo/text!./templates/DialogToolbar.html',
    'dojo/topic',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated'
], function(
    TOPICS,
    FileTypeTile,
    declare,
    domConstruct,
    Template,
    topic,
    WidgetBase,
    Templated
) {
    const DialogToolbar = function(data, node) {
        const View = declare([WidgetBase, Templated], {
            data: data,

            templateString: Template,

            postCreate: function() {
                this.inherited(arguments);

                new FileTypeTile({
                    data: {
                        name: this.data.document.getTitle(),
                        fileType: this.data.document.getFileType(),
                        fileSize: this.data.document.getSize()
                    }
                }, this.fileTypeContainer);
            }
        });

        this.view = new View({}, domConstruct.create('div', {}, node, 'only'));
        this.view.startup();
    };

    return DialogToolbar;
});
},
'doccontrol/document/template/dojo/Templater':function(){
define([
    '../Topics',
    './TemplateField',
    './TemplateFieldReadOnly',
    './TemplateForm',
    'api/doccontrol/template/parser/Template',
    'api/doccontrol/template/parser/Field',
    'dojo/_base/declare',
    'dojo/dom-class',
    'dojo/dom-construct',
    'dojo/on',
    'dojo/text!./templates/Templater.html',
    'dojo/topic',
    'dijit/_WidgetBase',
    'dijit/_Templated'
], function(
    TOPICS,
    TemplateField,
    TemplateFieldReadOnly,
    TemplateForm,
    TemplateParser,
    FieldParser,
    declare,
    domClass,
    domConstruct,
    on,
    Template,
    topic,
    _WidgetBase,
    Templated
) {
    const Templater = function(viewer, node) {
        const View = declare([_WidgetBase, Templated], {
            templateString: Template,

            template: null,
            name: null,
            templatePK: null,
            fields: [],
            form: null,
            fieldNameStore: null,
            fieldDataTypeStore: null,
            scale: 1,
            containsDeletedFields: false,
            viewOnlyMode: false,
            pageNumber: 1,
            viewer: viewer,
            fieldToEdit: null,

            postCreate: function() {
                this.inherited(arguments);

                this.form = new TemplateForm(this.fieldForm);
                this.form.on('new', function(data) {
                    const templateField = new TemplateField(
                        {
                            templateFieldPK: data.templateFieldPK,
                            name: data.name,
                            x: data.x,
                            y: data.y,
                            width: data.width,
                            height: data.height,
                            rotation: data.rotation,
                            dataType: data.dataType,
                            pageNumber: data.pageNumber
                        },
                        domConstruct.create('tr', {}, this.tableBody)
                    );

                    if (!this.viewOnlyMode) {
                        domClass.remove(this.defineAnother, 'hidden');
                    }

                    templateField.on('destroy', function() {
                        this.templateFieldDestroyHandler(templateField);
                    }.bind(this));

                    templateField.on('edit', function() {
                        this.edit(templateField);
                    }.bind(this));

                    this.fields.push(templateField);
                    this.form.hide();

                    domClass.remove(this.fieldContainer, 'hidden');
                    domClass.remove(this.emptyState, 'sos-empty-state-show');

                    topic.publish(TOPICS.DOCUMENT_TEMPLATE_VIEWER_FIELD_DEFINITION_END);
                }.bind(this));

                this.form.on('update', function() {
                    this.form.hide();
                    domClass.remove(this.fieldContainer, 'hidden');
                    domClass.remove(this.emptyState, 'sos-empty-state-show');
                    topic.publish(TOPICS.DOCUMENT_TEMPLATE_VIEWER_FIELD_DEFINITION_END);
                }.bind(this));

                this.form.on('cancel', function() {
                    this.form.hide();
                    domClass.remove(this.fieldContainer, 'hidden');
                    topic.publish(TOPICS.DOCUMENT_TEMPLATE_VIEWER_FIELD_DEFINITION_END);
                }.bind(this));

                this._createScrollEvents();
            },

            _createScrollEvents: function() {
                let touch = false;
                let lastClientX;
                let lastClientY;

                this.domNode.addEventListener('touchstart', function (evt) {
                    touch = true;
                    lastClientX = evt.touches[0].clientX;
                    lastClientY = evt.touches[0].clientY;
                });
                this.domNode.addEventListener('touchend', function(evt) {
                    touch = false;
                });
                this.domNode.addEventListener('touchmove', function(evt) {
                    if (touch) {
                        this.scrollLeft += (lastClientX - evt.changedTouches[0].clientX);
                        lastClientX = evt.changedTouches[0].clientX;
                        this.scrollTop += (lastClientY - evt.changedTouches[0].clientY);
                        lastClientY = evt.changedTouches[0].clientY;
                    }
                });
            },

            _clearFieldTable: function() {
                this.fields = [];
                this.template = null;
                domClass.remove(this.intialState, 'sos-empty-state-show');
                domConstruct.empty(this.tableBody);
                this.containsDeletedFields = false;
            },

            createNewField: function() {
                domClass.add(this.fieldContainer, 'hidden');
                this.form.show(this.fields);
            },

            defineField: function() {
                topic.publish(TOPICS.DOCUMENT_TEMPLATE_VIEWER_DEFINE_FIELD);
            },

            edit: function(templateField) {
                domClass.add(this.fieldContainer, 'hidden');
                topic.publish(TOPICS.DOCUMENT_TEMPLATE_VIEWER_FIELD_DEFINITION_START);

                if (this.viewer.getPageNumber() === templateField.getData().pageNumber) {
                    this.form.show(this.fields, templateField);
                    return;
                }

                this.viewer.setPageNumber(templateField.getData().pageNumber);
                this.fieldToEdit = templateField;
            },

            getData: function() {
                this.form.reset();

                return {
                    templatePK: this.templatePK,
                    fieldCollection: this.getDataFromFields(this.fields)
                };
            },

            getDataFromFields: function(fields) {
                return fields.map(function(field) {
                    return field.getData();
                });
            },

            hide: function() {
                domClass.add(this.domNode, 'hidden');
            },

            hasUnsavedChanges: function() {
                if (this.viewOnlyMode) {
                    return false;
                }

                if (this.containsDeletedFields) {
                    return true;
                }

                return this.fields.some(function(field) {
                    return field.hasUnsavedChanges();
                });
            },

            setFieldNameStore: function(store) {
                this.form.setFieldNameStore(store);
                this.fieldNameStore = store;
            },

            setRotation: function(rotation) {
                this.form.setRotation(rotation);
            },

            setScale: function(scale) {
                this.form.setScale(scale);
            },

            setSource: function(source) {
                this.form.setSource(source);
                if (this.fieldToEdit && this.viewer.getPageNumber() === this.fieldToEdit.getData().pageNumber) {
                    this.form.show(this.fields, this.fieldToEdit);
                    this.fieldToEdit = null;
                }
            },

            setViewOnlyMode: function() {
                this.viewOnlyMode = true;
                this.form.setViewOnlyMode();

                domClass.remove(this.intialState, 'sos-empty-state-show');
                domConstruct.empty(this.tableBody);

                domClass.remove(this.emptyState, 'sos-empty-state-show');
                domClass.add(this.emptyStateReadOnly, 'sos-empty-state-show');
            },

            setTemplate: function(template) {
                this.templatePK = template.templatePK;

                const savedFieldCollection = template.getFieldCollection();
                for (let i = 0; i < savedFieldCollection.length; i++) {
                    for (let j = 0; j < this.fields.length; j++) {
                        if (savedFieldCollection[i].name === this.fields[j].getData().name.label) {
                            this.fields[j].update(savedFieldCollection[i]);
                        }
                    }
                }

                if (this.viewOnlyMode) {
                    this.fields = savedFieldCollection.map((field) => {
                        if (field.name && typeof field.name == "string") {
                            field.name = { refersTo: field.refersTo || null, label: field.name };
                        }

                        const templateField = new TemplateFieldReadOnly(
                            field,
                            domConstruct.create('tr', {}, this.tableBody)
                        );

                        templateField.on('view', function() {
                            this._viewField(templateField);
                        }.bind(this));

                        return templateField;
                    });
                } else {
                    this.fields = savedFieldCollection.map((field) => {
                        if (field.name && typeof field.name == "string") {
                            field.name = {refersTo: field.refersTo || null, label: field.name};
                        }

                        const templateField = new TemplateField(
                            field,
                            domConstruct.create('tr', {}, this.tableBody)
                        );

                        templateField.on('destroy', function () {
                            this.templateFieldDestroyHandler(templateField);
                        }.bind(this));

                        templateField.on('edit', function () {
                            this.edit(templateField);
                        }.bind(this));

                        templateField.setChangesSaved();

                        return templateField;
                    });
                }

                domClass.remove(this.intialState, 'sos-empty-state-show');

                if (this.fields.length > 0) {
                    domClass.remove(this.fieldContainer, 'hidden');

                    if (this.viewOnlyMode) {
                        domClass.remove(this.emptyStateReadOnly, 'sos-empty-state-show');
                    } else {
                        domClass.remove(this.defineAnother, 'hidden');
                        domClass.remove(this.emptyState, 'sos-empty-state-show');
                    }
                } else {
                    this._showEmptyState();
                }
            },

            focusOnField: function(templateFieldPK) {
                this._viewField(this.fields.find(field => field.getData().templateFieldPK === parseInt(templateFieldPK)));
            },

            getTemplate: function() {
                const data = this.getData();

                if (data.fieldCollection) {
                    data.fieldCollection = data.fieldCollection.filter((field) => !field.hasUnsavedChanges);
                }
                
                return new TemplateParser().parse(data);
            },

            getFieldCollection: function() {
                const p = new FieldParser();

                return this.getDataFromFields(this.fields).map((field) => p.parse(field));
            },

            setFieldsSaved: function() {
                this.containsDeletedFields = false;

                this.fields.map(function(field) {
                    field.setChangesSaved();
                });
            },

            setPageNumber: function (pageNumber) {
                this.form.setCurrentPageNumber(pageNumber);
            },

            templateFieldDestroyHandler: function(templateField) {
                this.containsDeletedFields = this.fields.some(function(field, index) {
                    if (field == templateField) {
                        this.fields.splice(index, 1);

                        if (templateField.hasBeenSaved()) {
                            return true;
                        }

                        return this.containsDeletedFields;
                    }
                }, this);

                if (this.fields.length == 0) {
                    this._showEmptyState();
                }
            },

            update: function(data) {
                domConstruct.empty(this.tableBody);
                this.fields.forEach(function(field) {
                    field.destroy();
                });

                this.templatePK = data.templatePK;
                this.fields = data.getFieldCollection().map(function(field) {
                    if (field.name && typeof field.name == "string") {
                        field.name = { refersTo: field.refersTo || null, label: field.name };
                    }

                    const templateField = new TemplateField(
                        field,
                        domConstruct.create('tr', {}, this.tableBody)
                    );

                    templateField.on('destroy', function() {
                        this.templateFieldDestroyHandler(templateField);
                    }.bind(this));

                    templateField.on('edit', function() {
                        this.edit(templateField);
                    }.bind(this));

                    return templateField;
                }.bind(this));

                if (this.viewOnlyMode) {
                    return;
                }

                if (this.fields.length > 0) {
                    domClass.remove(this.defineAnother, 'hidden');
                } else {
                    this._showEmptyState();
                }
            },

            _showEmptyState: function() {
                if (this.viewOnlyMode) {
                    domClass.add(this.emptyStateReadOnly, 'sos-empty-state-show');
                } else {
                    domClass.add(this.emptyState, 'sos-empty-state-show');
                    domClass.add(this.defineAnother, 'hidden');
                }
            },

            _viewField: function(templateField) {
                this.fieldToEdit = templateField;

                domClass.remove(this.fieldContainer, 'hidden');
                topic.publish(TOPICS.DOCUMENT_TEMPLATE_VIEWER_FIELD_DEFINITION_START);

                if (this.viewer.getPageNumber() === templateField.getData().pageNumber) {
                    this.form.show(this.fields, templateField);
                    return;
                }

                this.viewer.setPageNumber(templateField.getData().pageNumber);
                this.fieldToEdit = templateField;
            },
        });

        this.view = new View({}, node);
        this.view.startup();
    };

    Templater.prototype.createNewField = function() {
        this.view.createNewField();
    };

    Templater.prototype.disable = function() {
        this.view.form.disable();
    };

    Templater.prototype.getData = function() {
        return this.view.getData();
    };

    Templater.prototype.isTemplateSelected = function() {
        return !domClass.contains(this.view.intialState, 'sos-empty-state-show');
    };

    Templater.prototype.hide = function() {
        this.view.hide();
    };

    Templater.prototype.hasUnsavedChanges = function() {
        return this.view.hasUnsavedChanges();
    };

    Templater.prototype.setFieldNameStore = function(store) {
        this.view.setFieldNameStore(store);
    };

    Templater.prototype.setRotation = function(rotation) {
        this.view.setRotation(rotation);
    };

    Templater.prototype.setScale = function(scale) {
        this.view.setScale(scale);
    };

    Templater.prototype.setSource = function(sourceCanvas) {
        this.view.setSource(sourceCanvas);
    };

    Templater.prototype.setViewOnlyMode = function() {
        this.view.setViewOnlyMode();
    };

    Templater.prototype.setTemplate = function(template) {
        this.view.setTemplate(template);
    };

    Templater.prototype.getFieldCollection = function() {
        return this.view.getFieldCollection();
    };

    Templater.prototype.setPageNumber = function (pageNumber) {
        this.view.setPageNumber(pageNumber);
    };

    Templater.prototype.getTemplate = function() {
        return this.view.getTemplate();
    };

    Templater.prototype.focusOnField = function(templateFieldPK) {
        return this.view.focusOnField(templateFieldPK);
    };

    Templater.prototype.setFieldsSaved = function() {
        this.view.setFieldsSaved();
    };

    Templater.prototype.setViewer = function (viewer) {
        this.view.viewer = viewer;
    }

    Templater.prototype.update = function(data) {
        this.view.update(data);
    };

    return Templater;
});
},
'doccontrol/document/template/dojo/TemplateField':function(){
define([
    'dojo/_base/declare',
    'dojo/dom-class',
    'dojo/dom-construct',
    'dojo/html',
    'dojo/text!./templates/TemplateField.html',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated'
], function(
    declare,
    domClass,
    domConstruct,
    html,
    Template,
    WidgetBase,
    Templated
) {
    const TemplateField = function (data, node) {
        const View = declare([WidgetBase, Templated], {
            templateString: Template,

            data: data,

            postCreate: function() {
                if (this.data.templateFieldPK) {
                    this.data.hasUnsavedChanges = false;
                    domClass.remove(this.name, 'unsaved-changes');
                } else {
                    this.data.hasUnsavedChanges = true;
                    domClass.add(this.name, 'unsaved-changes');
                }
            },

            delete: function() {
                this.emit('destroy');
                domConstruct.destroy(this.domNode);
                this.destroy();
            },

            getData: function() {
                return this.data;
            },

            hasUnsavedChanges: function() {
                return this.data.hasUnsavedChanges;
            },

            edit: function() {
                this.emit('edit');
            },

            setChangesSaved: function() {
                this.data.hasUnsavedChanges = false;
                domClass.remove(this.name, 'unsaved-changes');
            },

            update: function(data) {
                this.determineSavedStatus(data);

                this.data.templateFieldPK = data.templateFieldPK;
                this.data.x = data.x;
                this.data.y = data.y;
                this.data.width = data.width;
                this.data.height = data.height;
                this.data.rotation = data.rotation;
                this.data.name = data.name;
                this.data.dataType = data.dataType;
                this.data.pageNumber = data.pageNumber;
                if (typeof data.name == "string") {
                    this.data.name = { refersTo: data.refersTo, label: data.name }
                }
                this.data.refersTo = null;
                this.data.content = data.content;
                if (this.name && this.data.name && typeof this.data.name.label == "string") {
                    html.set(this.name, this.data.name.label.trim());
                }
            },

            determineSavedStatus: function(data) {
                if (
                    parseFloat(this.data.x).toFixed(1) !== parseFloat(data.x).toFixed(1) ||
                    parseFloat(this.data.y).toFixed(1) !== parseFloat(data.y).toFixed(1) ||
                    parseFloat(this.data.width).toFixed(1) !== parseFloat(data.width).toFixed(1) ||
                    parseFloat(this.data.height).toFixed(1) !== parseFloat(data.height).toFixed(1) ||
                    parseInt(this.data.rotation) !== parseInt(data.rotation) ||
                    this.data.name !== data.name ||
                    this.data.dataType !== data.dataType
                ) {
                    this.data.hasUnsavedChanges = true;
                    domClass.add(this.name, 'unsaved-changes');
                }
            },

            hasBeenSaved: function() {
                return !!this.data.templateFieldPK;
            }
        });

        this.view = new View({}, node);
        this.view.startup();
    };

    TemplateField.prototype.hasBeenSaved = function() {
        return this.view.hasBeenSaved();
    };

    TemplateField.prototype.hasUnsavedChanges = function() {
        return this.view.hasUnsavedChanges();
    };

    TemplateField.prototype.setChangesSaved = function() {
        this.view.setChangesSaved();
    };

    TemplateField.prototype.destroy = function() {
        this.view.destroy();
    };

    TemplateField.prototype.on = function(event, callback) {
        this.view.on(event, callback);
    };

    TemplateField.prototype.getData = function() {
        return this.view.getData();
    };

    TemplateField.prototype.update = function(data) {
        this.view.update(data);
    };

    return TemplateField;
});


},
'doccontrol/document/template/dojo/TemplateFieldReadOnly':function(){
define([
    'dojo/_base/declare',
    'dojo/text!./templates/TemplateFieldReadOnly.html',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated'
], function(
    declare,
    Template,
    WidgetBase,
    Templated
) {
    const TemplateFieldReadOnly = function (data, node) {
        const View = declare([WidgetBase, Templated], {
            templateString: Template,

            data: data,

            getData: function() {
                return this.data;
            },

            view: function() {
                this.emit('view');
            }
        });

        this.view = new View({}, node);
        this.view.startup();
    };

    TemplateFieldReadOnly.prototype.on = function(event, callback) {
        this.view.on(event, callback);
    };

    TemplateFieldReadOnly.prototype.getData = function() {
        return this.view.getData();
    };

    return TemplateFieldReadOnly;
});


},
'doccontrol/document/template/dojo/TemplateForm':function(){
define([
    '../Topics',
    'dojo/_base/declare',
    'dojo/dom-class',
    'dojo/dom-construct',
    'dojo/text!./templates/TemplateForm.html',
    'dojo/topic',
    'dijit/_WidgetBase',
    'dijit/form/ComboBox',
    'ocr/dojo/Processor',
    'soso/dijit/form/api/doccontrol/template/field/DataTypeSelect',
    'soso/dijit/form/api/doccontrol/template/PresetFieldSelector',
    'soso/sosox/ejs/_Templated'
], function(
    TOPICS,
    declare,
    domClass,
    domConstruct,
    Template,
    topic,
    _WidgetBase,
    ComboBox,
    OcrProcessor,
    DataTypeSelect,
    PresetFieldSelector,
    Templated
) {
    const TemplateForm = function(node) {
        const View = declare([_WidgetBase, Templated], {
            templateString: Template,
            data: {
                templateFieldPK: null,
                name: {},
                x: null,
                y: null,
                width: null,
                height: null,
                rotation: 0,
                dataType: null,
                pageNumber: 1
            },
            existingFields: [],
            field: null,
            rotation: 0,
            scale: 1,
            source: null,
            pageNumber: 1,
            currentPageNumber: 1,
            editMode: false,
            viewOnlyMode: false,

            elementPresetField: null,
            elementPresetFieldDescription: null,
            elementFieldNameContainer: null,
            elementFieldTypeContainer: null,

            presetInput: null,
            fieldNameInput: null,
            fieldTypeInput: null,

            postCreate: function() {
                this.inherited(arguments);

                this.fieldNameInput = new ComboBox({
                    'class':'sos-form-filtering-select',
                    required: true,
                    immediateChanges: true,
                    missingMessage: 'Please enter a field name',
                    searchAttr: 'label',
                    validator: function(value) {
                        return value.trim().length > 0
                            && this.existingFields.filter(function(field) { return field.getData().name.label == value.trim(); }).length == 0;
                    }.bind(this),
                    invalidMessage: 'Field names must be unique'
                }, this.fieldName);

                this.fieldTypeInput = new DataTypeSelect({}, this.fieldType);

                this.presetInput = new PresetFieldSelector(this.elementPresetField);
                this.presetInput.on('change', presetField => {
                    if (!presetField) {
                        this.elementPresetFieldDescription.setAttribute('hidden', true);
                        this.elementFieldNameContainer.removeAttribute('hidden');
                        this.elementFieldTypeContainer.removeAttribute('hidden');
                        return;
                    }

                    this.elementPresetFieldDescription.innerHTML = presetField.getDescription();
                    this.elementPresetFieldDescription.removeAttribute('hidden');
                    this.elementFieldNameContainer.setAttribute('hidden', true);
                    this.elementFieldTypeContainer.setAttribute('hidden', true);
                    this.fieldNameInput.set('item', presetField);
                    this.fieldTypeInput.set('value', presetField.getType());
                });
            },

            cancel: function() {
                this.editMode = false;

                this.emit('cancel');
            },

            disable: function() {
                if (this.ocrProcessor) {
                    this.ocrProcessor.disable();
                }
            },

            confirm: function() {
                this.editMode = false;

                if (this.validate()) {
                    this.data.name = this.fieldNameInput.get('item') || { refersTo: null, label: this.fieldNameInput.get('value') };
                    this.data.dataType = this.fieldTypeInput.get('value');
                    this.data.pageNumber = this.pageNumber;

                    if (this.field) {
                        this.field.update(this.data);
                        this.emit('update', this.field);
                    } else {
                        this.emit('new', this.data);
                    }
                }
            },

            hide: function() {
                domClass.add(this.domNode, 'hidden');
                this.reset();
            },

            normalise: function(box) {
                const x = box.x  / this.scale;
                const y = box.y / this.scale;
                const width = box.width / this.scale;
                const height = box.height / this.scale;

                switch ((360 + this.rotation - box.rotation) % 360) {
                    case 90:
                        return {
                            x: y,
                            y: (this.source.width / this.scale)  - x - width,
                            width: height,
                            height: width,
                            rotation: box.rotation
                        };

                    case 180:
                        return {
                            x: (this.source.width / this.scale) - x - width,
                            y: (this.source.height / this.scale) - y - height,
                            width: width,
                            height: height,
                            rotation: box.rotation
                        };

                    case 270:
                        return {
                            x: (this.source.height / this.scale) - y - height,
                            y: x,
                            width: height,
                            height: width,
                            rotation: box.rotation
                        };

                    default:
                        return {
                            x: x,
                            y: y,
                            width: width,
                            height: height,
                            rotation: box.rotation
                        };

                }
            },

            populate: function() {
                if (!this.ocrProcessor) {
                    return;
                }

                this.editMode = true;

                const data = this.field.getData();
                this.fieldNameInput.set('item', data.name);
                this.fieldTypeInput.set('value', data.dataType);
                this.data.name = data.name;
                this.data.dataType = data.dataType;
                this.data.pageNumber = data.pageNumber;
                this.data.templateFieldPK = data.templateFieldPK;
                this.data.rotation = data.rotation || 0;

                const box = {
                    x: data.x,
                    y: data.y,
                    width: data.width,
                    height: data.height,
                    rotation: data.rotation
                };

                this.ocrProcessor.select(this.transform(box));
            },

            reset: function() {
                domClass.add(this.missingSelectionError, 'hidden');
                this.presetInput.reset();
                this.elementPresetFieldDescription.setAttribute('hidden', true);
                this.elementFieldNameContainer.removeAttribute('hidden');
                this.elementFieldTypeContainer.removeAttribute('hidden');
                this.fieldNameInput.reset();
                this.fieldTypeInput.reset();
                this.data = {
                    templateFieldPK: null,
                    name: {},
                    x: null,
                    y: null,
                    width: null,
                    height: null,
                    rotation: this.rotation,
                    dataType: null,
                    pageNumber: 1
                };
                this.field = null;

                if (this.ocrProcessor) {
                    this.ocrProcessor.reset();
                }
            },

            select: function(box) {
                this.editMode = true;
                this.pageNumber = this.currentPageNumber;

                if (this.ocrProcessor.isEnabled()) {
                    this.ocrProcessor.drawSelectionBox(box);

                    this.updateDimensions(this.normalise(box));
                }
            },

            setRotation: function(rotation) {
                this.rotation = rotation;
                this.ocrProcessor.setRotation(rotation);
            },

            setScale: function(scale) {
                this.scale = scale;
            },

            setCurrentPageNumber: function (pageNumber) {
                this.currentPageNumber = pageNumber;

                if (this.editMode) {
                    this.toggleSelectBox();
                }
            },

            toggleSelectBox: function () {
                if (this.currentPageNumber !== this.pageNumber) {
                    this.ocrProcessor.hideSelectionBox();
                } else {
                    this.ocrProcessor.showSelectionBox();
                }
            },

            setSource: function(source) {
                this.source = source;

                if (!this.ocrProcessor) {
                    this.ocrProcessor = new OcrProcessor(source);
                    this.ocrProcessor.readOnly();
                    this.ocrProcessor.placeAt(this.ocrContainer);

                    this.ocrProcessor.after('select', this.select.bind(this), true);

                } else {
                    this.ocrProcessor.setSource(source);
                }

                if (this.viewOnlyMode) {
                    this.ocrProcessor.setViewOnlyMode();
                }

                if (this.data.x) {
                    this.ocrProcessor.drawSelectionBox(this.transform(this.data));
                }
            },

            setViewOnlyMode: function() {
                this.viewOnlyMode = true;
                domClass.add(this.domNode, 'hidden');
            },

            setExistingFields: function(existingFields) {
                this.existingFields = existingFields;
            },

            setField: function(field) {
                this.field = field;
            },

            setFieldNameStore: function(store) {
                this.fieldNameInput.set('store', store);
            },

            show: function() {
                if (this.field) {
                    this.populate();
                }

                if (!this.viewOnlyMode) {
                    domClass.remove(this.domNode, 'hidden');
                }
            },

            transform: function(box) {
                const x = box.x  * this.scale;
                const y = box.y * this.scale;
                const width = box.width * this.scale;
                const height = box.height * this.scale;

                switch ((360 + this.rotation - box.rotation) % 360) {
                    case 90:
                        return {
                            x: this.source.width - y - height,
                            y: x,
                            width: height,
                            height: width,
                            rotation: box.rotation
                        };

                    case 180:
                        return {
                            x: this.source.width - x - width,
                            y: this.source.height - y - height,
                            width: width,
                            height: height,
                            rotation: box.rotation
                        };

                    case 270:
                        return {
                            x: y,
                            y: this.source.height - x - width,
                            width: height,
                            height: width,
                            rotation: box.rotation
                        };

                    default:
                        return {
                            x: x,
                            y: y,
                            width: width,
                            height: height,
                            rotation: box.rotation
                        };
                }
            },

            updateDimensions: function(box) {
                this.data.x = box.x;
                this.data.y = box.y;
                this.data.width = box.width;
                this.data.height = box.height;
                this.data.rotation = (box.rotation === undefined) ? this.rotation : box.rotation;
            },

            validate: function() {
                const areaDefined = this.data.width > 0 && this.data.height > 0;
                domClass.toggle(this.missingSelectionError, 'hidden', areaDefined);

                this.fieldNameInput._hasBeenBlurred = true;
                return this.fieldNameInput.validate() && areaDefined;
            }
        });

        this.view = new View({}, node);
        this.view.startup();
    };

    TemplateForm.prototype.disable = function() {
        this.view.disable();
    };

    TemplateForm.prototype.hide = function() {
        this.view.hide();
    };

    TemplateForm.prototype.on = function(event, callback) {
        this.view.on(event, callback);
    };

    TemplateForm.prototype.reset = function() {
        this.view.reset();
    };

    TemplateForm.prototype.setFieldNameStore = function(store) {
        this.view.setFieldNameStore(store);
    };

    TemplateForm.prototype.setRotation = function(rotation) {
        this.view.setRotation(rotation);
    };

    TemplateForm.prototype.setScale = function(scale) {
        this.view.setScale(scale);
    };

    TemplateForm.prototype.setSource = function(source) {
        this.view.setSource(source);
    };

    TemplateForm.prototype.setPageNumber = function (pageNumber) {
        this.view.pageNumber = pageNumber;
    };

    TemplateForm.prototype.setCurrentPageNumber = function (pageNumber) {
        this.view.setCurrentPageNumber(pageNumber);
    };

    TemplateForm.prototype.setViewOnlyMode = function() {
        this.view.setViewOnlyMode();
    };

    TemplateForm.prototype.show = function(existingFields, field) {
        this.view.setExistingFields(existingFields.filter(function(existingField) { return field != existingField; }));
        this.view.setField(field);
        this.view.show();
    };

    return TemplateForm;
});
},
'dijit/form/ComboBox':function(){
define([
	"dojo/_base/declare", // declare
	"./ValidationTextBox",
	"./ComboBoxMixin"
], function(declare, ValidationTextBox, ComboBoxMixin){

	// module:
	//		dijit/form/ComboBox

	return declare("dijit.form.ComboBox", [ValidationTextBox, ComboBoxMixin], {
		// summary:
		//		Auto-completing text box
		//
		// description:
		//		The drop down box's values are populated from an class called
		//		a data provider, which returns a list of values based on the characters
		//		that the user has typed into the input box.
		//		If OPTION tags are used as the data provider via markup,
		//		then the OPTION tag's child text node is used as the widget value
		//		when selected.  The OPTION tag's value attribute is ignored.
		//		To set the default value when using OPTION tags, specify the selected
		//		attribute on 1 of the child OPTION tags.
		//
		//		Some of the options to the ComboBox are actually arguments to the data
		//		provider.
	});
});

},
'ocr/dojo/Processor':function(){
define([
    'dojo/_base/declare',
    'dojo/aspect',
    'dojo/dom-class',
    'dojo/dom-construct',
    'dojo/dom-style',
    'dojo/html',
    'dojo/on',
    'dojo/text!./template/Processor.html',
    'dijit/_TemplatedMixin',
    'ocr/dojo/_SelectionMixin',
    'ocr/parser/CircleCharacter',
    'vendor/tesseract.js/dist/tesseract.min'
], function(
    declare,
    aspect,
    domClass,
    domConstruct,
    domStyle,
    html,
    on,
    Template,
    Templated,
    _SelectionMixin,
    CircleCharacterParser,
    tesseract
) {
    const Processor = function(source) {
        const CONFIDENCE_THRESHOLD = 80;

        const View = declare([_SelectionMixin, Templated], {
            templateString: Template,
            rotation: 0,
            enabled: false,
            queuedSelection: null,

            postCreate: function() {
                this.setSource(source);
                this.enable();
                this.inherited(arguments);

                this.targetCtx = this.target.getContext('2d');

                this.own(on(this.copyBtn, 'click', this.copy.bind(this)));

                this.createScrollEvents(this.result);
            },

            createScrollEvents: function(domNode) {
                let touch = false;
                let lastClientX;
                let lastClientY;

                domNode.addEventListener('touchstart', function (evt) {
                    touch = true;
                    lastClientX = evt.touches[0].clientX;
                    lastClientY = evt.touches[0].clientY;
                    evt.stopPropagation();
                });
                domNode.addEventListener('touchend', function(evt) {
                    touch = false;
                    evt.stopPropagation();
                });
                domNode.addEventListener('touchmove', function(evt) {
                    if (touch) {
                        this.scrollLeft += (lastClientX - evt.changedTouches[0].clientX);
                        lastClientX = evt.changedTouches[0].clientX;
                        this.scrollTop += (lastClientY - evt.changedTouches[0].clientY);
                        lastClientY = evt.changedTouches[0].clientY;
                        evt.stopPropagation();
                    }
                });
            },

            complete: function(data) {
                this.progressBar.value = 1;
                domClass.add(this.progressBar, 'complete');
                html.set(this.progressText, 'Processed');

                this.result.value = CircleCharacterParser.parse(data.text);

                domClass.remove(this.extractedContentContainer, 'hidden');

                domClass.toggle(this.confidenceNotification, 'hidden', data.confidence >= CONFIDENCE_THRESHOLD);
            },

            copy: function() {
                try {
                    this.result.select();
                    document.execCommand('copy');
                    this.result.blur();
                } catch (err) {
                    alert('Please use Ctrl/Cmd + C to copy');
                }
            },

            disable: function() {
                this.enabled = false;
            },

            enable: function() {
                this.enabled = true;

                if (this.queuedSelection) {
                    this.select(this.queuedSelection);
                    this.queuedSelection = null;
                }
            },

            error: function(error) {
                console.error(error);

                domClass.add(this.progressContainer, 'hidden');
                domClass.add(this.extractedContentContainer, 'hidden');
                this.result.value = '';
            },

            process: function(imageCanvas) {
                this.reset();

                domClass.remove(this.progressContainer, 'hidden');
                domClass.remove(this.selectedAreaContainer, 'hidden');

                return new Promise(async function(resolve, reject) {
                    const worker = await tesseract.createWorker('eng', 1, {
                        workerPath: require.toUrl('vendor/tesseract.js/dist/worker.min.js'),
                        corePath: require.toUrl('vendor/tesseract.js-core/'),
                        logger: this.progress.bind(this)
                    });
                    try {
                        const result = await worker.recognize(imageCanvas);
                        result.data.text = result.data.text.trim();
                        this.complete(result.data);
                        resolve(result.data);

                        await worker.terminate();
                    } catch(err) {
                        this.error(err);
                        reject(err);
                    }
                }.bind(this));
            },

            progress: function(packet) {
                if (packet.status === 'recognizing text') {
                    this.progressBar.value = packet.progress;

                    html.set(
                        this.progressText,
                        'Processing: ' + ((this.progressBar.value / this.progressBar.max) * 100).toFixed(0) + '%'
                    );
                }
            },

            readOnly: function() {
                this.result.readOnly = true;
            },

            reset: function() {
                domClass.add(this.progressContainer, 'hidden');
                domClass.add(this.selectedAreaContainer, 'hidden');
                domClass.add(this.extractedContentContainer, 'hidden');
                domClass.add(this.confidenceNotification, 'hidden');
                this.result.value = '';

                this.progressBar.max = 1;
                domClass.remove(this.progressBar, 'complete');
                this.progressBar.removeAttribute('value');
                html.set(this.progressText, 'Initialising...');
                this.clearSelection();
                this.queuedSelection = null;
            },

            select: function(box) {
                if (this.enabled) {
                    const croppedImage = this.inherited(arguments);

                    const rotation = (360 + this.rotation - box.rotation) % 360;

                    if (rotation) {
                        const tempCanvas = domConstruct.create('canvas', {height: croppedImage.height, width: croppedImage.width});
                        tempCanvas.getContext('2d').putImageData(croppedImage, 0, 0);

                        this.target.width = rotation % 180 ? croppedImage.height : croppedImage.width;
                        this.target.height = rotation % 180 ? croppedImage.width : croppedImage.height;

                        this.targetCtx.save();
                        this.targetCtx.translate(this.target.width / 2, this.target.height / 2);
                        this.targetCtx.rotate(-rotation * Math.PI / 180);
                        this.targetCtx.drawImage(tempCanvas, -tempCanvas.width / 2, -tempCanvas.height / 2);
                        this.targetCtx.restore();

                        domConstruct.destroy(tempCanvas);

                    } else {
                        this.target.width = croppedImage.width;
                        this.target.height = croppedImage.height;
                        this.targetCtx.clearRect(0, 0, this.target.width, this.target.height);
                        this.targetCtx.putImageData(croppedImage, 0, 0);
                    }

                    domClass.remove(this.selectedAreaContainer, 'hidden');
                    this.showSelectionBox();

                    return this.process(this.target);

                } else {
                    this.queuedSelection = box; // @todo replace queuedSelection stuff with promises
                }
            },

            setRotation: function(rotation) {
                this.rotation = rotation;
            }
        });

        this.view = new View({});
        this.view.startup();

        this.domNode = this.view.domNode;
    };

    Processor.prototype.after = function(methodName, advisingFunction, receiveArguments) {
        aspect.after(this.view, methodName, advisingFunction, receiveArguments);
    };

    Processor.prototype.before = function(methodName, advisingFunction, receiveArguments) {
        aspect.before(this.view, methodName, advisingFunction, receiveArguments);
    };

    Processor.prototype.clearSelection = function() {
        this.view.clearSelection();
    };

    Processor.prototype.drawSelectionBox = function(box) {
        this.view.drawSelectionBox(box);
    };

    Processor.prototype.showSelectionBox = function () {
        this.view.showSelectionBox();
    };

    Processor.prototype.hideSelectionBox = function () {
        this.view.hideSelectionBox();
    };

    Processor.prototype.destroy = function() {
        this.view.destroy();
    };

    Processor.prototype.createScrollEvents = function(domNode) {
        this.view.createScrollEvents(domNode);
    };

    Processor.prototype.disable = function() {
        this.view.disable();
    };

    Processor.prototype.isEnabled = function() {
        return this.view.enabled;
    };

    Processor.prototype.placeAt = function(node) {
        this.view.placeAt(node);
    };

    Processor.prototype.readOnly = function() {
        this.view.readOnly();
    };

    Processor.prototype.setViewOnlyMode = function () {
        this.view.setViewOnlyMode();
    }

    Processor.prototype.reset = function() {
        this.view.reset();
    };

    Processor.prototype.select = function(box) {
        return this.view.select(box);
    };

    Processor.prototype.setRotation = function(rotation) {
        this.view.setRotation(rotation);
    };

    Processor.prototype.setSource = function(source) {
        this.view.setSource(source);
        this.view.enable();
    };

    return Processor;
});
},
'ocr/dojo/_SelectionMixin':function(){
define([
    'dojo/_base/declare',
    'dojo/dom-class',
    'dojo/dom-construct',
    'dojo/dom-style',
    'dojo/on',
    'dijit/_WidgetBase',
    'vendor/fabric/dist/index'
], function(
    declare,
    domClass,
    domConstruct,
    domStyle,
    on,
    WidgetBase,
    fabric
) {
    const KEY_ESCAPE = 27;

    return declare([WidgetBase], {
        _source: null,
        _scrollContainer: null,
        _sourceCtx: null,
        _selectionCanvas: null,
        _selectionCanvasContainer: null,
        _calculatedCanvasScale: null,
        _escPressEvent: null,
        _startPoint: null,
        hideOnPage: false,
        viewOnlyMode: false,

        clearSelection: function() {
            this._selectionCanvas.getObjects().forEach(selection => this._selectionCanvas.remove(selection));
        },

        destroy: function() {
            if (!this._beingDestroyed) {
                this.inherited(arguments);

                this._removeEvents();
            }
        },

        drawSelectionBox: function(box) {
            if (this.hideOnPage) {
                this._selectionCanvas.remove(box);
                return;
            }

            if(!this.viewOnlyMode) {
                this.clearSelection();
            }

            const region = new fabric.Rect({
                left: box.x,
                x: box.x,
                top: box.y,
                y: box.y,
                originX: 'left',
                originY: 'top',
                width: box.width,
                height: box.height,
                angle: 0,
                fill: 'rgba(42, 0, 210, 0.5)',
                hasControls: !this.viewOnlyMode,
                hoverCursor: 'default',
                transparentCorners: false,
                cornerColor: 'red',
                borderColor: 'red',
                cornerSize: 8,
                borderDashArray: [6],
                _controlsVisibility: { mtr: false },
                lockRotation: true,
                lockSkewingX: true,
                lockSkewingY: true,
                lockMovementX: this.viewOnlyMode,
                lockMovementY: this.viewOnlyMode,
                globalCompositeOperation: 'difference',
                selectable: !this.viewOnlyMode,
                editable: !this.viewOnlyMode
            });

            this._selectionCanvas.add(region);
            this._selectionCanvas.setActiveObject(region);
            this._selectionCanvas.renderAll();

        },

        showSelectionBox: function () {
            this.hideOnPage = false;
        },

        hideSelectionBox: function () {
            this.hideOnPage = true;
        },

        getSelection: function(box) {
            return this._sourceCtx.getImageData(
                box.x / this._calculatedCanvasScale,
                box.y / this._calculatedCanvasScale,
                (box.width / this._calculatedCanvasScale) || 1,
                (box.height / this._calculatedCanvasScale) || 1
            );
        },

        select: function(box) {
            this.clearSelection();
            return this.getSelection(box);
        },

        setSource: function(source) {
            if (!(source instanceof HTMLCanvasElement)) {
                throw new Error('Source canvas must be specified');
            }

            this._source = source;
            this._sourceCtx = this._source.getContext('2d');

            domConstruct.destroy(this._selectionCanvasContainer);
            const selectionCanvas = domConstruct.create('canvas', {
                height: this._source.height,
                width: this._source.width,
                style: this._source.style
            }, this._source, 'after');

            this._calculatedCanvasScale = selectionCanvas.getBoundingClientRect().width / selectionCanvas.width;

            this._selectionCanvas = new fabric.Canvas(selectionCanvas, {
                uniformScaling: false,
                selection: false,
                defaultCursor: 'crosshair',
                globalCompositeOperation: 'difference'
            });

            this._selectionCanvasContainer = this._selectionCanvas.wrapperEl;
            domClass.add(this._selectionCanvasContainer, 'selection-canvas-container');

            this._selectionCanvas.backgroundImage = new fabric.Image(
                this._source,
                {
                    originX: 'left',
                    originY: 'top',
                    scaleX: this._calculatedCanvasScale,
                    scaleY: this._calculatedCanvasScale
                }
            );

            if (this.viewOnlyMode) {
                this._selectionCanvas.set('defaultCursor', 'default');
            }

            this._locateScrollContainer();

            this._createSelectionEvents();
        },

        setViewOnlyMode: function () {
            this._selectionCanvas.set('defaultCursor', 'default');
            this.viewOnlyMode = true;
        },

        _removeEvents: function() {
            if (this._escPressEvent) {
                this._escPressEvent.remove();
            }
        },

        _createSelectionEvents: function() {
            this._removeEvents();

            this._selectionCanvas.on('mouse:down', o => {
                if (o.target) {
                    return;
                }

                if (!this.viewOnlyMode) {
                    this.clearSelection();

                    this._startPoint = this._getPointer(o.e);

                    this.region = new fabric.Rect({
                        left: this._startPoint.x,
                        x: this._startPoint.x,
                        top: this._startPoint.y,
                        y: this._startPoint.y,
                        originX: 'left',
                        originY: 'top',
                        width: 1,
                        height: 1,
                        angle: 0,
                        fill: 'rgba(42, 0, 210, 0.5)',
                        stroke: '#47CDE2',
                        strokeDashArray: [6],
                        editable: false,
                        selectable: false,
                        hoverCursor: 'crosshair',
                        globalCompositeOperation: 'difference'
                    });
                    this._selectionCanvas.add(this.region);
                } else {
                    this._selectionCanvas.setActiveObject(this._selectionCanvas.getObjects()[0]);
                    this._selectionCanvas.renderAll();
                }
            });

            this._selectionCanvas.on('mouse:move', o => {
                if (!this.region || this.viewOnlyMode) {
                    return;
                }

                this._scrollCanvas(o.e);

                const pointer = this._getPointer(o.e);
                const endPoint = {
                    x: Math.max(pointer.x, 0),
                    y: Math.max(pointer.y, 0)
                };
                const dX = Math.abs(endPoint.x - this._startPoint.x);
                const dY = Math.abs(endPoint.y - this._startPoint.y);

                this.region.set({
                    left: Math.min(endPoint.x, this._startPoint.x),
                    top: Math.min(endPoint.y, this._startPoint.y),
                    width: dX,
                    height: dY
                }).setCoords();
                this._selectionCanvas.renderAll();
            });

            this._selectionCanvas.on('mouse:up', o => {
                if (!this.region || this.viewOnlyMode) {
                    return;
                }

                const pointer = this._getPointer(o.e);
                const endPoint = {
                    x: Math.max(pointer.x, 0),
                    y: Math.max(pointer.y, 0)
                };
                this.region.set({
                    x: Math.min(endPoint.x, this._startPoint.x),
                    y: Math.min(endPoint.y, this._startPoint.y),
                    strokeWidth: 0,
                    editable: true,
                    selectable: true
                });

                this.select(this.region);
                this.region = null;
            });

            this._selectionCanvas.on('object:modified', o => {
                if (!o.e) {
                    return;
                }

                o.target.set({
                    width: o.target.getScaledWidth(),
                    height: o.target.getScaledHeight(),
                    x: o.target.left,
                    y: o.target.top
                });
                this.select(o.target);
            });

            this._selectionCanvas.on('object:scaling', o => {
                this._scrollCanvas(o.e);
            });

            this._selectionCanvas.on('object:moving', o => {
                this._scrollCanvas(o.e);
            });

            this._escPressEvent = on(document.body, 'keyup', e => {
                if (this.region && (e.which === KEY_ESCAPE || e.code === KEY_ESCAPE)) {
                    this.region = null;
                    this.clearSelection();
                }
            }, false);
        },

        _getPointer: function(evt) {
            return {
                x: evt.clientX - this._source.getBoundingClientRect().left,
                y: evt.clientY - this._source.getBoundingClientRect().top
            };
        },

        _isScrollContainer: function(domNode) {
            return (domNode.scrollWidth > domNode.offsetWidth || domNode.scrollHeight > domNode.offsetHeight)
                && (['auto', 'scroll'].indexOf(domStyle.get(domNode, 'overflow')) != -1
                    || ['auto', 'scroll'].indexOf(domStyle.get(domNode, 'overflow-x')) != -1
                    || ['auto', 'scroll'].indexOf(domStyle.get(domNode, 'overflow-y')) != -1
                );
        },

        _locateScrollContainer: function() {
            let element = this._source;

            while (element && (element = element.parentNode)) {
                if (this._isScrollContainer(element)) {
                    this._scrollContainer = element;
                    return;
                }
            }

            this._scrollContainer = null;
        },

        _scrollBy: function(x, y) {
            if (this._scrollContainer == document.body) {
                window.scrollBy(x, y);

            } else {
                this._scrollContainer.scrollLeft += x;
                this._scrollContainer.scrollTop += y;
            }
        },

        _scrollCanvas: function(evt) {
            if (this._scrollContainer) {
                let scrollX = 0, scrollY = 0;
                const scrollContainerBoundaries = this._scrollContainer.getBoundingClientRect();
                const clientY = (evt.changedTouches) ? evt.changedTouches[0].clientY : evt.clientY;
                const clientX = (evt.changedTouches) ? evt.changedTouches[0].clientX : evt.clientX;
                const SCROLL_MARGIN = 50;
                const SCROLL_INTERVAL = 10;

                /** Down **/
                if (clientY >= scrollContainerBoundaries.top + this._scrollContainer.clientHeight - SCROLL_MARGIN) {
                    scrollY = SCROLL_INTERVAL;
                }

                /** Up **/
                if (clientY <= scrollContainerBoundaries.top + SCROLL_MARGIN) {
                    scrollY = -SCROLL_INTERVAL;
                }

                /** Right **/
                if (clientX >= scrollContainerBoundaries.left + this._scrollContainer.clientWidth - SCROLL_MARGIN) {
                    scrollX = SCROLL_INTERVAL;
                }

                /** Left **/
                if (clientX <= scrollContainerBoundaries.left + SCROLL_MARGIN) {
                    scrollX = -SCROLL_INTERVAL;
                }

                if (scrollX || scrollY) {
                    this._scrollBy(scrollX, scrollY);
                }
            }
        }
    });
});
},
'ocr/parser/CircleCharacter':function(){
define([], function() {
    return {
        parse: function (value) {
            return value
                .replace(/\b[oO0](\d)/g, '0$1')
                .replace(/(\d)[oO0](\d)/g, '$10$2')
                .replace(/[oO0](\d)/g, '0$1')
                .replace(/[oO0]([A-Z])/g, 'O$1')
                .replace(/[oO0]([a-z])/g, 'o$1')
                .replace(/(\d)[oO0]([^a-z0-9])/gi, '$10$2')
                .replace(/(\d)[oO0]\b/g, '$10')
                .replace(/([a-z])[oO0]([^a-z0-9])/gi, '$1o$2')
                .replace(/([a-z])[oO0]\b/gi, '$1o')
                .replace(/([A-Z]{2})[oO0]([^a-zA-Z0-9])/g, '$1O$2')
                .replace(/([A-Z]{2})[oO0]\b/g, '$1O')
                .replace(/([^a-z0-9])[oO0]([^a-z0-9])/gi, '$10$2')
                .replace(/([^a-z0-9])[oO0]\b/gi, '$10')
                .replace(/\b[oO0]([^a-z0-9])/gi, '0$1')
                .replace(/([a-z])[oO0]{2}([a-z])/gi, '$1oo$2')
                .replace(/([A-Z])[oO0]{2}([A-Z])/g, '$1OO$2')
                .replace(/([^a-z])[oO0]{2}([^a-z])/gi, '$100$2')
                .replace(/([^a-z])[oO0]{2}\b/gi, '$100')
            ;
        }
    };
});
},
'soso/dijit/form/api/doccontrol/template/field/DataTypeSelect':function(){
define([
    'dojo/_base/declare',
    'dojo/store/Memory',
    'dijit/form/Select',
    'library/request/data/Handlers',
    'library/request/helper/DefaultUnauthorisedCallback',
    './../ModelFactory'
], function(
    declare,
    Memory,
    Select,
    HandlersVO,
    DefaultUnauthorisedCallback,
    TemplateModelFactory
) {
    const DEFAULT_VALUE = 'text';

    return declare([Select], {
        'class': 'sos-form-select',
        required: true,
        labelAttr: 'formattedType',
        missingMessage: 'Please select a field type',

        postCreate: function() {
            this.inherited(arguments);
            this._getStore().then((store) => {
                this.set('store', store);
                this.set('value', DEFAULT_VALUE);
            });
        },

        reset: function() {
            this.inherited(arguments);
            this.set('value', DEFAULT_VALUE);
        },

        _getStore: function() {
            return new Promise((resolve, reject) => {
                new TemplateModelFactory().getFieldModel().fetchDataTypes(
                    new HandlersVO(
                        function success(dataTypes) {
                            const store = new Memory({
                                data: JSON.parse(dataTypes),
                                idProperty: 'type'
                            });

                            resolve(store);
                        },
                        function progress() {},
                        DefaultUnauthorisedCallback,
                        reject,
                        function abort() {}
                    )
                );
            });
        }
    });
});
},
'dijit/form/Select':function(){
define([
	"dojo/_base/array", // array.forEach
	"dojo/_base/declare", // declare
	"dojo/dom-attr", // domAttr.set
	"dojo/dom-class", // domClass.add domClass.remove domClass.toggle
	"dojo/dom-geometry", // domGeometry.setMarginBox
	"dojo/i18n", // i18n.getLocalization
	"dojo/keys",
	"dojo/_base/lang", // lang.hitch
	"dojo/on",
	"dojo/sniff", // has("ie")
	"./_FormSelectWidget",
	"../_HasDropDown",
	"../DropDownMenu",
	"../MenuItem",
	"../MenuSeparator",
	"../Tooltip",
	"../_KeyNavMixin",
	"../registry", // registry.byNode
	"dojo/text!./templates/Select.html",
	"dojo/i18n!./nls/validate"
], function(array, declare, domAttr, domClass, domGeometry, i18n, keys, lang, on, has,
			_FormSelectWidget, _HasDropDown, DropDownMenu, MenuItem, MenuSeparator, Tooltip, _KeyNavMixin, registry, template){

	// module:
	//		dijit/form/Select

	var _SelectMenu = declare("dijit.form._SelectMenu", DropDownMenu, {
		// summary:
		//		An internally-used menu for dropdown that allows us a vertical scrollbar

		// Override Menu.autoFocus setting so that opening a Select highlights the current value.
		autoFocus: true,

		buildRendering: function(){
			this.inherited(arguments);

			this.domNode.setAttribute("role", "listbox");
		},

		postCreate: function(){
			this.inherited(arguments);

			// stop mousemove from selecting text on IE to be consistent with other browsers
			this.own(on(this.domNode, "selectstart", function(evt){
				evt.preventDefault();
				evt.stopPropagation();
			}));
		},

		focus: function(){
			// summary:
			//		Overridden so that the previously selected value will be focused instead of only the first item
			var found = false,
				val = this.parentWidget.value;
			if(lang.isArray(val)){
				val = val[val.length - 1];
			}
			if(val){ // if focus selected
				array.forEach(this.parentWidget._getChildren(), function(child){
					if(child.option && (val === child.option.value)){ // find menu item widget with this value
						found = true;
						this.focusChild(child, false); // focus previous selection
					}
				}, this);
			}
			if(!found){
				this.inherited(arguments); // focus first item by default
			}
		}
	});

	var Select = declare("dijit.form.Select" + (has("dojo-bidi") ? "_NoBidi" : ""), [_FormSelectWidget, _HasDropDown, _KeyNavMixin], {
		// summary:
		//		This is a "styleable" select box - it is basically a DropDownButton which
		//		can take a `<select>` as its input.

		baseClass: "dijitSelect dijitValidationTextBox",

		templateString: template,

		_buttonInputDisabled: has("ie") ? "disabled" : "", // allows IE to disallow focus, but Firefox cannot be disabled for mousedown events

		// required: Boolean
		//		Can be true or false, default is false.
		required: false,

		// state: [readonly] String
		//		"Incomplete" if this select is required but unset (i.e. blank value), "" otherwise
		state: "",

		// message: String
		//		Currently displayed error/prompt message
		message: "",

		// tooltipPosition: String[]
		//		See description of `dijit/Tooltip.defaultPosition` for details on this parameter.
		tooltipPosition: [],

		// emptyLabel: string
		//		What to display in an "empty" dropdown
		emptyLabel: "&#160;", // &nbsp;

		// _isLoaded: Boolean
		//		Whether or not we have been loaded
		_isLoaded: false,

		// _childrenLoaded: Boolean
		//		Whether or not our children have been loaded
		_childrenLoaded: false,

		// labelType: String
		//		Specifies how to interpret the labelAttr in the data store items.
		//		Can be "html" or "text".
		labelType: "html",

		_fillContent: function(){
			// summary:
			//		Set the value to be the first, or the selected index
			this.inherited(arguments);
			// set value from selected option
			if(this.options.length && !this.value && this.srcNodeRef){
				var si = this.srcNodeRef.selectedIndex || 0; // || 0 needed for when srcNodeRef is not a SELECT
				this._set("value", this.options[si >= 0 ? si : 0].value);
			}
			// Create the dropDown widget
			this.dropDown = new _SelectMenu({ id: this.id + "_menu", parentWidget: this });
			domClass.add(this.dropDown.domNode, this.baseClass.replace(/\s+|$/g, "Menu "));
		},

		_getMenuItemForOption: function(/*_FormSelectWidget.__SelectOption*/ option){
			// summary:
			//		For the given option, return the menu item that should be
			//		used to display it.  This can be overridden as needed
			if(!option.value && !option.label){
				// We are a separator (no label set for it)
				return new MenuSeparator({ownerDocument: this.ownerDocument});
			}else{
				// Just a regular menu option
				var click = lang.hitch(this, "_setValueAttr", option);
				var item = new MenuItem({
					option: option,
					label: (this.labelType === 'text' ? (option.label || '').toString()
						.replace(/&/g, '&amp;').replace(/</g, '&lt;') :
						option.label) || this.emptyLabel,
					onClick: click,
					ownerDocument: this.ownerDocument,
					dir: this.dir,
					textDir: this.textDir,
					disabled: option.disabled || false
				});
				item.focusNode.setAttribute("role", "option");
				return item;
			}
		},

		_addOptionItem: function(/*_FormSelectWidget.__SelectOption*/ option){
			// summary:
			//		For the given option, add an option to our dropdown.
			//		If the option doesn't have a value, then a separator is added
			//		in that place.
			if(this.dropDown){
				this.dropDown.addChild(this._getMenuItemForOption(option));
			}
		},

		_getChildren: function(){
			if(!this.dropDown){
				return [];
			}
			return this.dropDown.getChildren();
		},

		focus: function(){
			// Override _KeyNavMixin::focus(), which calls focusFirstChild().
			// We just want the standard form widget behavior.
			if(!this.disabled && this.focusNode.focus){
				try{
					this.focusNode.focus();
				}catch(e){
					/*squelch errors from hidden nodes*/
				}
			}
		},

		focusChild: function(/*dijit/_WidgetBase*/ widget){
			// summary:
			//		Sets the value to the given option, used during search by letter.
			// widget:
			//		Reference to option's widget
			// tags:
			//		protected
			if(widget){
				this.set('value', widget.option);
			}
		},

		_getFirst: function(){
			// summary:
			//		Returns the first child widget.
			// tags:
			//		abstract extension
			var children = this._getChildren();
			return children.length ? children[0] : null;
		},

		_getLast: function(){
			// summary:
			//		Returns the last child widget.
			// tags:
			//		abstract extension
			var children = this._getChildren();
			return children.length ? children[children.length-1] : null;
		},

		childSelector: function(/*DOMNode*/ node){
			// Implement _KeyNavMixin.childSelector, to identify focusable child nodes.
			// If we allowed a dojo/query dependency from this module this could more simply be a string "> *"
			// instead of this function.

			var node = registry.byNode(node);
			return node && node.getParent() == this.dropDown;
		},

		onKeyboardSearch: function(/*dijit/_WidgetBase*/ item, /*Event*/ evt, /*String*/ searchString, /*Number*/ numMatches){
			// summary:
			//		When a key is pressed that matches a child item,
			//		this method is called so that a widget can take appropriate action is necessary.
			// tags:
			//		protected
			if(item){
				this.focusChild(item);
			}
		},

		_loadChildren: function(/*Boolean*/ loadMenuItems){
			// summary:
			//		Resets the menu and the length attribute of the button - and
			//		ensures that the label is appropriately set.
			// loadMenuItems: Boolean
			//		actually loads the child menu items - we only do this when we are
			//		populating for showing the dropdown.

			if(loadMenuItems === true){
				// this.inherited destroys this.dropDown's child widgets (MenuItems).
				// Avoid this.dropDown (Menu widget) having a pointer to a destroyed widget (which will cause
				// issues later in _setSelected). (see #10296)
				if(this.dropDown){
					delete this.dropDown.focusedChild;
					this.focusedChild = null;
				}
				if(this.options.length){
					this.inherited(arguments);
				}else{
					// Drop down menu is blank but add one blank entry just so something appears on the screen
					// to let users know that they are no choices (mimicing native select behavior)
					array.forEach(this._getChildren(), function(child){
						child.destroyRecursive();
					});
					var item = new MenuItem({
						ownerDocument: this.ownerDocument,
						label: this.emptyLabel
					});
					this.dropDown.addChild(item);
				}
			}else{
				this._updateSelection();
			}

			this._isLoaded = false;
			this._childrenLoaded = true;

			if(!this._loadingStore){
				// Don't call this if we are loading - since we will handle it later
				this._setValueAttr(this.value, false);
			}
		},

		_refreshState: function(){
			if(this._started){
				this.validate(this.focused);
			}
		},

		startup: function(){
			this.inherited(arguments);
			this._refreshState(); // after all _set* methods have run
		},

		_setValueAttr: function(value){
			this.inherited(arguments);
			domAttr.set(this.valueNode, "value", this.get("value"));
			this._refreshState();	// to update this.state
		},

		_setNameAttr: "valueNode",

		_setDisabledAttr: function(/*Boolean*/ value){
			this.inherited(arguments);
			this._refreshState();	// to update this.state
		},

		_setRequiredAttr: function(/*Boolean*/ value){
			this._set("required", value);
			this.focusNode.setAttribute("aria-required", value);
			this._refreshState();	// to update this.state
		},

		_setOptionsAttr: function(/*Array*/ options){
			this._isLoaded = false;
			this._set('options', options);
		},

		_setDisplay: function(/*String*/ newDisplay){
			// summary:
			//		sets the display for the given value (or values)

			var lbl = (this.labelType === 'text' ? (newDisplay || '')
					.replace(/&/g, '&amp;').replace(/</g, '&lt;') :
					newDisplay) || this.emptyLabel;
			this.containerNode.innerHTML = '<span role="option" aria-selected="true" class="dijitReset dijitInline ' + this.baseClass.replace(/\s+|$/g, "Label ") + '">' + lbl + '</span>';
		},

		validate: function(/*Boolean*/ isFocused){
			// summary:
			//		Called by oninit, onblur, and onkeypress, and whenever required/disabled state changes
			// description:
			//		Show missing or invalid messages if appropriate, and highlight textbox field.
			//		Used when a select is initially set to no value and the user is required to
			//		set the value.

			var isValid = this.disabled || this.isValid(isFocused);
			this._set("state", isValid ? "" : (this._hasBeenBlurred ? "Error" : "Incomplete"));
			this.focusNode.setAttribute("aria-invalid", isValid ? "false" : "true");
			var message = isValid ? "" : this._missingMsg;
			if(message && this.focused && this._hasBeenBlurred){
				Tooltip.show(message, this.domNode, this.tooltipPosition, !this.isLeftToRight());
			}else{
				Tooltip.hide(this.domNode);
			}
			this._set("message", message);
			return isValid;
		},

		isValid: function(/*Boolean*/ /*===== isFocused =====*/){
			// summary:
			//		Whether or not this is a valid value.  The only way a Select
			//		can be invalid is when it's required but nothing is selected.
			return (!this.required || this.value === 0 || !(/^\s*$/.test(this.value || ""))); // handle value is null or undefined
		},

		reset: function(){
			// summary:
			//		Overridden so that the state will be cleared.
			this.inherited(arguments);
			Tooltip.hide(this.domNode);
			this._refreshState();	// to update this.state
		},

		postMixInProperties: function(){
			// summary:
			//		set the missing message
			this.inherited(arguments);
			this._missingMsg = i18n.getLocalization("dijit.form", "validate", this.lang).missingMessage;
		},

		postCreate: function(){
			this.inherited(arguments);

			// stop mousemove from selecting text on IE to be consistent with other browsers
			this.own(on(this.domNode, "selectstart", function(evt){
				evt.preventDefault();
				evt.stopPropagation();
			}));

			this.domNode.setAttribute("aria-expanded", "false");

			// Prevent _KeyNavMixin from calling stopPropagation() on left and right arrow keys, thus breaking
			// navigation when Select inside Toolbar.
			var keyNavCodes = this._keyNavCodes;
			delete keyNavCodes[keys.LEFT_ARROW];
			delete keyNavCodes[keys.RIGHT_ARROW];
		},

		_setStyleAttr: function(/*String||Object*/ value){
			this.inherited(arguments);
			domClass.toggle(this.domNode, this.baseClass.replace(/\s+|$/g, "FixedWidth "), !!this.domNode.style.width);
		},

		isLoaded: function(){
			return this._isLoaded;
		},

		loadDropDown: function(/*Function*/ loadCallback){
			// summary:
			//		populates the menu
			this._loadChildren(true);
			this._isLoaded = true;
			loadCallback();
		},

		destroy: function(preserveDom){
			if(this.dropDown && !this.dropDown._destroyed){
				this.dropDown.destroyRecursive(preserveDom);
				delete this.dropDown;
			}
			Tooltip.hide(this.domNode);	// in case Select (or enclosing Dialog) destroyed while tooltip shown
			this.inherited(arguments);
		},

		_onFocus: function(){
			this.validate(true);	// show tooltip if second focus of required tooltip, but no selection
			// Note: not calling superclass _onFocus() to avoid _KeyNavMixin::_onFocus() setting tabIndex --> -1
		},

		_onBlur: function(){
			Tooltip.hide(this.domNode);
			this.inherited(arguments);
			this.validate(false);
		}
	});

	if(has("dojo-bidi")){
		Select = declare("dijit.form.Select", Select, {
			_setDisplay: function(/*String*/ newDisplay){
				this.inherited(arguments);
				this.applyTextDir(this.containerNode);
			}
		});
	}

	Select._Menu = _SelectMenu;	// for monkey patching

	// generic event helper to ensure the dropdown items are loaded before the real event handler is called
	function _onEventAfterLoad(method){
		return function(evt){
			if(!this._isLoaded){
				this.loadDropDown(lang.hitch(this, method, evt));
			}else{
				this.inherited(method, arguments);
			}
		};
	}
	Select.prototype._onContainerKeydown = _onEventAfterLoad("_onContainerKeydown");
	Select.prototype._onContainerKeypress = _onEventAfterLoad("_onContainerKeypress");

	return Select;
});

},
'dijit/form/_FormSelectWidget':function(){
define([
	"dojo/_base/array", // array.filter array.forEach array.map array.some
	"dojo/_base/Deferred",
	"dojo/aspect", // aspect.after
	"dojo/data/util/sorter", // util.sorter.createSortFunction
	"dojo/_base/declare", // declare
	"dojo/dom", // dom.setSelectable
	"dojo/dom-class", // domClass.toggle
	"dojo/_base/kernel",	// _scopeName
	"dojo/_base/lang", // lang.delegate lang.isArray lang.isObject lang.hitch
	"dojo/query", // query
	"dojo/when",
	"dojo/store/util/QueryResults",
	"./_FormValueWidget"
], function(array, Deferred, aspect, sorter, declare, dom, domClass, kernel, lang, query, when,
			QueryResults, _FormValueWidget){

	// module:
	//		dijit/form/_FormSelectWidget

	/*=====
	var __SelectOption = {
		// value: String
		//		The value of the option.  Setting to empty (or missing) will
		//		place a separator at that location
		// label: String
		//		The label for our option.  It can contain html tags.
		// selected: Boolean
		//		Whether or not we are a selected option
		// disabled: Boolean
		//		Whether or not this specific option is disabled
	};
	=====*/

	var _FormSelectWidget = declare("dijit.form._FormSelectWidget", _FormValueWidget, {
		// summary:
		//		Extends _FormValueWidget in order to provide "select-specific"
		//		values - i.e., those values that are unique to `<select>` elements.
		//		This also provides the mechanism for reading the elements from
		//		a store, if desired.

		// multiple: [const] Boolean
		//		Whether or not we are multi-valued
		multiple: false,

		// options: __SelectOption[]
		//		The set of options for our select item.  Roughly corresponds to
		//		the html `<option>` tag.
		options: null,

		// store: dojo/store/api/Store
		//		A store to use for getting our list of options - rather than reading them
		//		from the `<option>` html tags.   Should support getIdentity().
		//		For back-compat store can also be a dojo/data/api/Identity.
		store: null,
		_setStoreAttr: function(val){
			if(this._created){		// don't repeat work that will happen in postCreate()
				this._deprecatedSetStore(val);
			}
		},

		// query: object
		//		A query to use when fetching items from our store
		query: null,
		_setQueryAttr: function(query){
			if(this._created){		// don't repeat work that will happen in postCreate()
				this._deprecatedSetStore(this.store, this.selectedValue, {query: query});
			}
		},

		// queryOptions: object
		//		Query options to use when fetching from the store
		queryOptions: null,
		_setQueryOptionsAttr: function(queryOptions){
			if(this._created){		// don't repeat work that will happen in postCreate()
				this._deprecatedSetStore(this.store, this.selectedValue, {queryOptions: queryOptions});
			}
		},

		// labelAttr: String?
		//		The entries in the drop down list come from this attribute in the dojo.store items.
		//		If ``store`` is set, labelAttr must be set too, unless store is an old-style
		//		dojo.data store rather than a new dojo/store.
		labelAttr: "",

		// onFetch: Function
		//		A callback to do with an onFetch - but before any items are actually
		//		iterated over (i.e. to filter even further what you want to add)
		onFetch: null,

		// sortByLabel: Boolean
		//		Flag to sort the options returned from a store by the label of
		//		the store.
		sortByLabel: true,


		// loadChildrenOnOpen: Boolean
		//		By default loadChildren is called when the items are fetched from the
		//		store.  This property allows delaying loadChildren (and the creation
		//		of the options/menuitems) until the user clicks the button to open the
		//		dropdown.
		loadChildrenOnOpen: false,

		// onLoadDeferred: [readonly] dojo.Deferred
		//		This is the `dojo.Deferred` returned by setStore().
		//		Calling onLoadDeferred.then() registers your
		//		callback to be called only once, when the prior setStore completes.
		onLoadDeferred: null,

		getOptions: function(/*anything*/ valueOrIdx){
			// summary:
			//		Returns a given option (or options).
			// valueOrIdx:
			//		If passed in as a string, that string is used to look up the option
			//		in the array of options - based on the value property.
			//		(See dijit/form/_FormSelectWidget.__SelectOption).
			//
			//		If passed in a number, then the option with the given index (0-based)
			//		within this select will be returned.
			//
			//		If passed in a dijit/form/_FormSelectWidget.__SelectOption, the same option will be
			//		returned if and only if it exists within this select.
			//
			//		If passed an array, then an array will be returned with each element
			//		in the array being looked up.
			//
			//		If not passed a value, then all options will be returned
			//
			// returns:
			//		The option corresponding with the given value or index.
			//		null is returned if any of the following are true:
			//
			//		- A string value is passed in which doesn't exist
			//		- An index is passed in which is outside the bounds of the array of options
			//		- A dijit/form/_FormSelectWidget.__SelectOption is passed in which is not a part of the select

			// NOTE: the compare for passing in a dijit/form/_FormSelectWidget.__SelectOption checks
			//		if the value property matches - NOT if the exact option exists
			// NOTE: if passing in an array, null elements will be placed in the returned
			//		array when a value is not found.
			var opts = this.options || [];

			if(valueOrIdx == null){
				return opts; // __SelectOption[]
			}
			if(lang.isArrayLike(valueOrIdx)){
				return array.map(valueOrIdx, function(item){
					return this.getOptions(item);
				}, this); // __SelectOption[]
			}
			if(lang.isString(valueOrIdx)){
				valueOrIdx = { value: valueOrIdx };
			}
			if(lang.isObject(valueOrIdx)){
				// We were passed an option - so see if it's in our array (directly),
				// and if it's not, try and find it by value.

				if(!array.some(opts, function(option, idx){
					for(var a in valueOrIdx){
						if(!(a in option) || option[a] != valueOrIdx[a]){ // == and not === so that 100 matches '100'
							return false;
						}
					}
					valueOrIdx = idx;
					return true; // stops iteration through opts
				})){
					valueOrIdx = -1;
				}
			}
			if(valueOrIdx >= 0 && valueOrIdx < opts.length){
				return opts[valueOrIdx]; // __SelectOption
			}
			return null; // null
		},

		addOption: function(/*__SelectOption|__SelectOption[]*/ option){
			// summary:
			//		Adds an option or options to the end of the select.  If value
			//		of the option is empty or missing, a separator is created instead.
			//		Passing in an array of options will yield slightly better performance
			//		since the children are only loaded once.
			array.forEach(lang.isArrayLike(option) ? option : [option], function(i){
				if(i && lang.isObject(i)){
					this.options.push(i);
				}
			}, this);
			this._loadChildren();
		},

		removeOption: function(/*String|__SelectOption|Number|Array*/ valueOrIdx){
			// summary:
			//		Removes the given option or options.  You can remove by string
			//		(in which case the value is removed), number (in which case the
			//		index in the options array is removed), or select option (in
			//		which case, the select option with a matching value is removed).
			//		You can also pass in an array of those values for a slightly
			//		better performance since the children are only loaded once.
			//		For numeric option values, specify {value: number} as the argument.
			var oldOpts = this.getOptions(lang.isArrayLike(valueOrIdx) ? valueOrIdx : [valueOrIdx]);
			array.forEach(oldOpts, function(option){
				// We can get null back in our array - if our option was not found.  In
				// that case, we don't want to blow up...
				if(option){
					this.options = array.filter(this.options, function(node){
						return (node.value !== option.value || node.label !== option.label);
					});
					this._removeOptionItem(option);
				}
			}, this);
			this._loadChildren();
		},

		updateOption: function(/*__SelectOption|__SelectOption[]*/ newOption){
			// summary:
			//		Updates the values of the given option.  The option to update
			//		is matched based on the value of the entered option.  Passing
			//		in an array of new options will yield better performance since
			//		the children will only be loaded once.
			array.forEach(lang.isArrayLike(newOption) ? newOption : [newOption], function(i){
				var oldOpt = this.getOptions({ value: i.value }), k;
				if(oldOpt){
					for(k in i){
						oldOpt[k] = i[k];
					}
				}
			}, this);
			this._loadChildren();
		},

		setStore: function(store, selectedValue, fetchArgs){
			kernel.deprecated(this.declaredClass+"::setStore(store, selectedValue, fetchArgs) is deprecated. Use set('query', fetchArgs.query), set('queryOptions', fetchArgs.queryOptions), set('store', store), or set('value', selectedValue) instead.", "", "2.0");
			this._deprecatedSetStore(store, selectedValue, fetchArgs);
		},

		_deprecatedSetStore: function(store, selectedValue, fetchArgs){
			// summary:
			//		Sets the store you would like to use with this select widget.
			//		The selected value is the value of the new store to set.  This
			//		function returns the original store, in case you want to reuse
			//		it or something.
			// store: dojo/store/api/Store
			//		The dojo.store you would like to use - it MUST implement getIdentity()
			//		and MAY implement observe().
			//		For backwards-compatibility this can also be a data.data store, in which case
			//		it MUST implement dojo/data/api/Identity,
			//		and MAY implement dojo/data/api/Notification.
			// selectedValue: anything?
			//		The value that this widget should set itself to *after* the store
			//		has been loaded
			// fetchArgs: Object?
			//		Hash of parameters to set filter on store, etc.
			//
			//		- query: new value for Select.query,
			//		- queryOptions: new value for Select.queryOptions,
			//		- onFetch: callback function for each item in data (Deprecated)
			var oStore = this.store;
			fetchArgs = fetchArgs || {};

			if(oStore !== store){
				// Our store has changed, so cancel any listeners on old store (remove for 2.0)
				var h;
				while((h = this._notifyConnections.pop())){
					h.remove();
				}

				// For backwards-compatibility, accept dojo.data store in addition to dojo.store.store.  Remove in 2.0.
				if(!store.get){
					lang.mixin(store, {
						_oldAPI: true,
						get: function(id){
							// summary:
							//		Retrieves an object by it's identity. This will trigger a fetchItemByIdentity.
							//		Like dojo.store.DataStore.get() except returns native item.
							var deferred = new Deferred();
							this.fetchItemByIdentity({
								identity: id,
								onItem: function(object){
									deferred.resolve(object);
								},
								onError: function(error){
									deferred.reject(error);
								}
							});
							return deferred.promise;
						},
						query: function(query, options){
							// summary:
							//		Queries the store for objects.   Like dojo/store/DataStore.query()
							//		except returned Deferred contains array of native items.
							var deferred = new Deferred(function(){
								if(fetchHandle.abort){
									fetchHandle.abort();
								}
							});
							deferred.total = new Deferred();
							var fetchHandle = this.fetch(lang.mixin({
								query: query,
								onBegin: function(count){
									deferred.total.resolve(count);
								},
								onComplete: function(results){
									deferred.resolve(results);
								},
								onError: function(error){
									deferred.reject(error);
								}
							}, options));
							return new QueryResults(deferred);
						}
					});

					if(store.getFeatures()["dojo.data.api.Notification"]){
						this._notifyConnections = [
							aspect.after(store, "onNew", lang.hitch(this, "_onNewItem"), true),
							aspect.after(store, "onDelete", lang.hitch(this, "_onDeleteItem"), true),
							aspect.after(store, "onSet", lang.hitch(this, "_onSetItem"), true)
						];
					}
				}
				this._set("store", store);			// Our store has changed, so update our notifications
			}

			// Remove existing options (if there are any)
			if(this.options && this.options.length){
				this.removeOption(this.options);
			}

			// Cancel listener for updates to old (dojo.data) store
			if(this._queryRes && this._queryRes.close){
				this._queryRes.close();
			}

			// Cancel listener for updates to new (dojo.store) store
			if(this._observeHandle && this._observeHandle.remove){
				this._observeHandle.remove();
				this._observeHandle = null;
			}

			// If user has specified new query and query options along with this new store, then use them.
			if(fetchArgs.query){
				this._set("query", fetchArgs.query);
			}
			if(fetchArgs.queryOptions){
				this._set("queryOptions", fetchArgs.queryOptions);
			}

			// Add our new options
			if(store && store.query){
				this._loadingStore = true;
				this.onLoadDeferred = new Deferred();

				// Run query
				// Save result in this._queryRes so we can cancel the listeners we register below
				this._queryRes = store.query(this.query, this.queryOptions);
				when(this._queryRes, lang.hitch(this, function(items){

					if(this.sortByLabel && !fetchArgs.sort && items.length){
						if(store.getValue){
							// Old dojo.data API to access items, remove for 2.0
							items.sort(sorter.createSortFunction([
								{
									attribute: store.getLabelAttributes(items[0])[0]
								}
							], store));
						}else{
							// TODO: remove sortByLabel completely for 2.0?  It can be handled by queryOptions: {sort: ... }.
							var labelAttr = this.labelAttr;
							items.sort(function(a, b){
								return a[labelAttr] > b[labelAttr] ? 1 : b[labelAttr] > a[labelAttr] ? -1 : 0;
							});
						}
					}

					if(fetchArgs.onFetch){
						items = fetchArgs.onFetch.call(this, items, fetchArgs);
					}

					// TODO: Add these guys as a batch, instead of separately
					array.forEach(items, function(i){
						this._addOptionForItem(i);
					}, this);

					// Register listener for store updates
					if(this._queryRes.observe){
						// observe returns yet another handle that needs its own explicit gc
						this._observeHandle = this._queryRes.observe(lang.hitch(this, function(object, deletedFrom, insertedInto){
							if(deletedFrom == insertedInto){
								this._onSetItem(object);
							}else{
								if(deletedFrom != -1){
									this._onDeleteItem(object);
								}
								if(insertedInto != -1){
									this._onNewItem(object);
								}
							}
						}), true);
					}

					// Set our value (which might be undefined), and then tweak
					// it to send a change event with the real value
					this._loadingStore = false;
					this.set("value", "_pendingValue" in this ? this._pendingValue : selectedValue);
					delete this._pendingValue;

					if(!this.loadChildrenOnOpen){
						this._loadChildren();
					}else{
						this._pseudoLoadChildren(items);
					}
					this.onLoadDeferred.resolve(true);
					this.onSetStore();
				}), lang.hitch(this, function(err){
					console.error('dijit.form.Select: ' + err.toString());
					this.onLoadDeferred.reject(err);
				}));
			}
			return oStore;	// dojo/data/api/Identity
		},

		_setValueAttr: function(/*anything*/ newValue, /*Boolean?*/ priorityChange){
			// summary:
			//		set the value of the widget.
			//		If a string is passed, then we set our value from looking it up.
			if(!this._onChangeActive){
				priorityChange = null;
			}
			if(this._loadingStore){
				// Our store is loading - so save our value, and we'll set it when
				// we're done
				this._pendingValue = newValue;
				return;
			}
			if(newValue == null){
				return;
			}
			if(lang.isArrayLike(newValue)){
				newValue = array.map(newValue, function(value){
					return lang.isObject(value) ? value : { value: value };
				}); // __SelectOption[]
			}else if(lang.isObject(newValue)){
				newValue = [newValue];
			}else{
				newValue = [
					{ value: newValue }
				];
			}
			newValue = array.filter(this.getOptions(newValue), function(i){
				return i && i.value;
			});
			var opts = this.getOptions() || [];
			if(!this.multiple && (!newValue[0] || !newValue[0].value) && !!opts.length){
				newValue[0] = opts[0];
			}
			array.forEach(opts, function(opt){
				opt.selected = array.some(newValue, function(v){
					return v.value === opt.value;
				});
			});
			var val = array.map(newValue, function(opt){
				return opt.value;
			});

			if(typeof val == "undefined" || typeof val[0] == "undefined"){
				return;
			} // not fully initialized yet or a failed value lookup
			var disp = array.map(newValue, function(opt){
				return opt.label;
			});
			this._setDisplay(this.multiple ? disp : disp[0]);
			this.inherited(arguments, [ this.multiple ? val : val[0], priorityChange ]);
			this._updateSelection();
		},

		_getDisplayedValueAttr: function(){
			// summary:
			//		returns the displayed value of the widget
			var ret = array.map([].concat(this.get('selectedOptions')), function(v){
				if(v && "label" in v){
					return v.label;
				}else if(v){
					return v.value;
				}
				return null;
			}, this);
			return this.multiple ? ret : ret[0];
		},

		_setDisplayedValueAttr: function(label){
			// summary:
			//		Sets the displayed value of the widget
			this.set('value', this.getOptions(typeof label == "string" ? { label: label } : label));
		},

		_loadChildren: function(){
			// summary:
			//		Loads the children represented by this widget's options.
			//		reset the menu to make it populatable on the next click
			if(this._loadingStore){
				return;
			}
			array.forEach(this._getChildren(), function(child){
				child.destroyRecursive();
			});
			// Add each menu item
			array.forEach(this.options, this._addOptionItem, this);

			// Update states
			this._updateSelection();
		},

		_updateSelection: function(){
			// summary:
			//		Sets the "selected" class on the item for styling purposes
			this.focusedChild = null;
			this._set("value", this._getValueFromOpts());
			var val = [].concat(this.value);
			if(val && val[0]){
				var self = this;
				array.forEach(this._getChildren(), function(child){
					var isSelected = array.some(val, function(v){
						return child.option && (v === child.option.value);
					});
					if(isSelected && !self.multiple){
						self.focusedChild = child;
					}
					domClass.toggle(child.domNode, this.baseClass.replace(/\s+|$/g, "SelectedOption "), isSelected);
					child.domNode.setAttribute("aria-selected", isSelected ? "true" : "false");
				}, this);
			}
		},

		_getValueFromOpts: function(){
			// summary:
			//		Returns the value of the widget by reading the options for
			//		the selected flag
			var opts = this.getOptions() || [];
			if(!this.multiple && opts.length){
				// Mirror what a select does - choose the first one
				var opt = array.filter(opts, function(i){
					return i.selected;
				})[0];
				if(opt && opt.value){
					return opt.value;
				}else{
					opts[0].selected = true;
					return opts[0].value;
				}
			}else if(this.multiple){
				// Set value to be the sum of all selected
				return array.map(array.filter(opts, function(i){
					return i.selected;
				}), function(i){
					return i.value;
				}) || [];
			}
			return "";
		},

		// Internal functions to call when we have store notifications come in
		_onNewItem: function(/*item*/ item, /*Object?*/ parentInfo){
			if(!parentInfo || !parentInfo.parent){
				// Only add it if we are top-level
				this._addOptionForItem(item);
			}
		},
		_onDeleteItem: function(/*item*/ item){
			var store = this.store;
			this.removeOption({value: store.getIdentity(item) });
		},
		_onSetItem: function(/*item*/ item){
			this.updateOption(this._getOptionObjForItem(item));
		},

		_getOptionObjForItem: function(item){
			// summary:
			//		Returns an option object based off the given item.  The "value"
			//		of the option item will be the identity of the item, the "label"
			//		of the option will be the label of the item.

			// remove getLabel() call for 2.0 (it's to support the old dojo.data API)
			var store = this.store,
				label = (this.labelAttr && this.labelAttr in item) ? item[this.labelAttr] : store.getLabel(item),
				value = (label ? store.getIdentity(item) : null);
			return {value: value, label: label, item: item}; // __SelectOption
		},

		_addOptionForItem: function(/*item*/ item){
			// summary:
			//		Creates (and adds) the option for the given item
			var store = this.store;
			if(store.isItemLoaded && !store.isItemLoaded(item)){
				// We are not loaded - so let's load it and add later.
				// Remove for 2.0 (it's the old dojo.data API)
				store.loadItem({item: item, onItem: function(i){
					this._addOptionForItem(i);
				},
					scope: this});
				return;
			}
			var newOpt = this._getOptionObjForItem(item);
			this.addOption(newOpt);
		},

		constructor: function(params /*===== , srcNodeRef =====*/){
			// summary:
			//		Create the widget.
			// params: Object|null
			//		Hash of initialization parameters for widget, including scalar values (like title, duration etc.)
			//		and functions, typically callbacks like onClick.
			//		The hash can contain any of the widget's properties, excluding read-only properties.
			// srcNodeRef: DOMNode|String?
			//		If a srcNodeRef (DOM node) is specified, replace srcNodeRef with my generated DOM tree

			//		Saves off our value, if we have an initial one set so we
			//		can use it if we have a store as well (see startup())
			this._oValue = (params || {}).value || null;
			this._notifyConnections = [];	// remove for 2.0
		},

		buildRendering: function(){
			this.inherited(arguments);
			dom.setSelectable(this.focusNode, false);
		},

		_fillContent: function(){
			// summary:
			//		Loads our options and sets up our dropdown correctly.  We
			//		don't want any content, so we don't call any inherit chain
			//		function.
			if(!this.options){
				this.options =
					this.srcNodeRef
						? query("> *", this.srcNodeRef).map(
						function(node){
							if(node.getAttribute("type") === "separator"){
								return { value: "", label: "", selected: false, disabled: false };
							}
							return {
								value: (node.getAttribute("data-" + kernel._scopeName + "-value") || node.getAttribute("value")),
								label: String(node.innerHTML),
								// FIXME: disabled and selected are not valid on complex markup children (which is why we're
								// looking for data-dojo-value above.  perhaps we should data-dojo-props="" this whole thing?)
								// decide before 1.6
								selected: node.getAttribute("selected") || false,
								disabled: node.getAttribute("disabled") || false
							};
						},
						this)
						: [];
			}
			if(!this.value){
				this._set("value", this._getValueFromOpts());
			}else if(this.multiple && typeof this.value == "string"){
				this._set("value", this.value.split(","));
			}
		},

		postCreate: function(){
			// summary:
			//		sets up our event handling that we need for functioning
			//		as a select
			this.inherited(arguments);

			// Make our event connections for updating state
			aspect.after(this, "onChange", lang.hitch(this, "_updateSelection"));

			//		Connects in our store, if we have one defined
			var store = this.store;
			if(store && (store.getIdentity || store.getFeatures()["dojo.data.api.Identity"])){
				// Temporarily set our store to null so that it will get set
				// and connected appropriately
				this.store = null;
				this._deprecatedSetStore(store, this._oValue, {query: this.query, queryOptions: this.queryOptions});
			}

			this._storeInitialized = true;
		},

		startup: function(){
			// summary:
			this._loadChildren();
			this.inherited(arguments);
		},

		destroy: function(){
			// summary:
			//		Clean up our connections

			var h;
			while((h = this._notifyConnections.pop())){
				h.remove();
			}

			// Cancel listener for store updates
			if(this._queryRes && this._queryRes.close){
				this._queryRes.close();
			}

			// Cancel listener for updates to new (dojo.store) store
			if(this._observeHandle && this._observeHandle.remove){
				this._observeHandle.remove();
				this._observeHandle = null;
			}

			this.inherited(arguments);
		},

		_addOptionItem: function(/*__SelectOption*/ /*===== option =====*/){
			// summary:
			//		User-overridable function which, for the given option, adds an
			//		item to the select.  If the option doesn't have a value, then a
			//		separator is added in that place.  Make sure to store the option
			//		in the created option widget.
		},

		_removeOptionItem: function(/*__SelectOption*/ /*===== option =====*/){
			// summary:
			//		User-overridable function which, for the given option, removes
			//		its item from the select.
		},

		_setDisplay: function(/*String or String[]*/ /*===== newDisplay =====*/){
			// summary:
			//		Overridable function which will set the display for the
			//		widget.  newDisplay is either a string (in the case of
			//		single selects) or array of strings (in the case of multi-selects)
		},

		_getChildren: function(){
			// summary:
			//		Overridable function to return the children that this widget contains.
			return [];
		},

		_getSelectedOptionsAttr: function(){
			// summary:
			//		hooks into this.attr to provide a mechanism for getting the
			//		option items for the current value of the widget.
			return this.getOptions({ selected: true });
		},

		_pseudoLoadChildren: function(/*item[]*/ /*===== items =====*/){
			// summary:
			//		a function that will "fake" loading children, if needed, and
			//		if we have set to not load children until the widget opens.
			// items:
			//		An array of items that will be loaded, when needed
		},

		onSetStore: function(){
			// summary:
			//		a function that can be connected to in order to receive a
			//		notification that the store has finished loading and all options
			//		from that store are available
		}
	});

	/*=====
	_FormSelectWidget.__SelectOption = __SelectOption;
	=====*/

	return _FormSelectWidget;
});

},
'dojo/data/util/sorter':function(){
define(["../../_base/lang"], function(lang){
	// module:
	//		dojo/data/util/sorter
	// summary:
	//		TODOC

var sorter = {};
lang.setObject("dojo.data.util.sorter", sorter);

sorter.basicComparator = function(	/*anything*/ a,
													/*anything*/ b){
	// summary:
	//		Basic comparison function that compares if an item is greater or less than another item
	// description:
	//		returns 1 if a > b, -1 if a < b, 0 if equal.
	//		'null' values (null, undefined) are treated as larger values so that they're pushed to the end of the list.
	//		And compared to each other, null is equivalent to undefined.

	//null is a problematic compare, so if null, we set to undefined.
	//Makes the check logic simple, compact, and consistent
	//And (null == undefined) === true, so the check later against null
	//works for undefined and is less bytes.
	var r = -1;
	if(a === null){
		a = undefined;
	}
	if(b === null){
		b = undefined;
	}
	if(a == b){
		r = 0;
	}else if(a > b || a == null){
		r = 1;
	}
	return r; //int {-1,0,1}
};

sorter.createSortFunction = function(	/* attributes[] */sortSpec, /*dojo/data/api/Read*/ store){
	// summary:
	//		Helper function to generate the sorting function based off the list of sort attributes.
	// description:
	//		The sort function creation will look for a property on the store called 'comparatorMap'.  If it exists
	//		it will look in the mapping for comparisons function for the attributes.  If one is found, it will
	//		use it instead of the basic comparator, which is typically used for strings, ints, booleans, and dates.
	//		Returns the sorting function for this particular list of attributes and sorting directions.
	// sortSpec:
	//		A JS object that array that defines out what attribute names to sort on and whether it should be descenting or asending.
	//		The objects should be formatted as follows:
	// |	{
	// |		attribute: "attributeName-string" || attribute,
	// |		descending: true|false;   // Default is false.
	// |	}
	// store:
	//		The datastore object to look up item values from.

	var sortFunctions=[];

	function createSortFunction(attr, dir, comp, s){
		//Passing in comp and s (comparator and store), makes this
		//function much faster.
		return function(itemA, itemB){
			var a = s.getValue(itemA, attr);
			var b = s.getValue(itemB, attr);
			return dir * comp(a,b); //int
		};
	}
	var sortAttribute;
	var map = store.comparatorMap;
	var bc = sorter.basicComparator;
	for(var i = 0; i < sortSpec.length; i++){
		sortAttribute = sortSpec[i];
		var attr = sortAttribute.attribute;
		if(attr){
			var dir = (sortAttribute.descending) ? -1 : 1;
			var comp = bc;
			if(map){
				if(typeof attr !== "string" && ("toString" in attr)){
					 attr = attr.toString();
				}
				comp = map[attr] || bc;
			}
			sortFunctions.push(createSortFunction(attr,
				dir, comp, store));
		}
	}
	return function(rowA, rowB){
		var i=0;
		while(i < sortFunctions.length){
			var ret = sortFunctions[i++](rowA, rowB);
			if(ret !== 0){
				return ret;//int
			}
		}
		return 0; //int
	}; // Function
};

return sorter;
});

},
'dijit/DropDownMenu':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/keys", // keys
	"dojo/text!./templates/Menu.html",
	"./_MenuBase"
], function(declare, keys, template, _MenuBase){

	// module:
	//		dijit/DropDownMenu

	return declare("dijit.DropDownMenu", _MenuBase, {
		// summary:
		//		A menu, without features for context menu (Meaning, drop down menu)

		templateString: template,

		baseClass: "dijitMenu",

		// Arrow key navigation
		_onUpArrow: function(){
			this.focusPrev();
		},
		_onDownArrow: function(){
			this.focusNext();
		},
		_onRightArrow: function(/*Event*/ evt){
			this._moveToPopup(evt);
			evt.stopPropagation();
			evt.preventDefault();
		},
		_onLeftArrow: function(/*Event*/ evt){
			if(this.parentMenu){
				if(this.parentMenu._isMenuBar){
					this.parentMenu.focusPrev();
				}else{
					this.onCancel(false);
				}
			}else{
				evt.stopPropagation();
				evt.preventDefault();
			}
		}
	});
});

},
'dijit/_MenuBase':function(){
define([
	"dojo/_base/array", // array.indexOf
	"dojo/_base/declare", // declare
	"dojo/dom", // dom.isDescendant domClass.replace
	"dojo/dom-attr",
	"dojo/dom-class", // domClass.replace
	"dojo/_base/lang", // lang.hitch
	"dojo/mouse", // mouse.enter, mouse.leave
	"dojo/on",
	"dojo/window",
	"./a11yclick",
	"./registry",
	"./_Widget",
	"./_CssStateMixin",
	"./_KeyNavContainer",
	"./_TemplatedMixin"
], function(array, declare, dom, domAttr, domClass, lang, mouse, on, winUtils, a11yclick,
			registry, _Widget, _CssStateMixin, _KeyNavContainer, _TemplatedMixin){

	// module:
	//		dijit/_MenuBase

	return declare("dijit._MenuBase", [_Widget, _TemplatedMixin, _KeyNavContainer, _CssStateMixin], {
		// summary:
		//		Abstract base class for Menu and MenuBar.
		//		Subclass should implement _onUpArrow(), _onDownArrow(), _onLeftArrow(), and _onRightArrow().

		// selected: dijit/MenuItem
		//		Currently selected (a.k.a. highlighted) MenuItem, or null if no MenuItem is selected.
		//		If a submenu is open, will be set to MenuItem that displayed the submenu.   OTOH, if
		//		this Menu is in passive mode (i.e. hasn't been clicked yet), will be null, because
		//		"selected" is not merely "hovered".
		selected: null,
		_setSelectedAttr: function(item){
			if(this.selected != item){
				if(this.selected){
					this.selected._setSelected(false);
					this._onChildDeselect(this.selected);
				}
				if(item){
					item._setSelected(true);
				}
				this._set("selected", item);
			}
		},

		// activated: [readonly] Boolean
		//		This Menu has been clicked (mouse or via space/arrow key) or opened as a submenu,
		//		so mere mouseover will open submenus.  Focusing a menu via TAB does NOT automatically make it active
		//		since TAB is a navigation operation and not a selection one.
		//		For Windows apps, pressing the ALT key focuses the menubar menus (similar to TAB navigation) but the
		//		menu is not active (ie no dropdown) until an item is clicked.
		activated: false,
		_setActivatedAttr: function(val){
			domClass.toggle(this.domNode, "dijitMenuActive", val);
			domClass.toggle(this.domNode, "dijitMenuPassive", !val);
			this._set("activated", val);
		},

		// parentMenu: [readonly] Widget
		//		pointer to menu that displayed me
		parentMenu: null,

		// popupDelay: Integer
		//		After a menu has been activated (by clicking on it etc.), number of milliseconds before hovering
		//		(without clicking) another MenuItem causes that MenuItem's popup to automatically open.
		popupDelay: 500,

		// passivePopupDelay: Integer
		//		For a passive (unclicked) Menu, number of milliseconds before hovering (without clicking) will cause
		//		the popup to open.  Default is Infinity, meaning you need to click the menu to open it.
		passivePopupDelay: Infinity,

		// autoFocus: Boolean
		//		A toggle to control whether or not a Menu gets focused when opened as a drop down from a MenuBar
		//		or DropDownButton/ComboButton.   Note though that it always get focused when opened via the keyboard.
		autoFocus: false,

		childSelector: function(/*DOMNode*/ node){
			// summary:
			//		Selector (passed to on.selector()) used to identify MenuItem child widgets, but exclude inert children
			//		like MenuSeparator.  If subclass overrides to a string (ex: "> *"), the subclass must require dojo/query.
			// tags:
			//		protected

			var widget = registry.byNode(node);
			return node.parentNode == this.containerNode && widget && widget.focus;
		},

		postCreate: function(){
			var self = this,
				matches = typeof this.childSelector == "string" ? this.childSelector : lang.hitch(this, "childSelector");
			this.own(
				on(this.containerNode, on.selector(matches, mouse.enter), function(){
					self.onItemHover(registry.byNode(this));
				}),
				on(this.containerNode, on.selector(matches, mouse.leave), function(){
					self.onItemUnhover(registry.byNode(this));
				}),
				on(this.containerNode, on.selector(matches, a11yclick), function(evt){
					self.onItemClick(registry.byNode(this), evt);
					evt.stopPropagation();
				}),
				on(this.containerNode, on.selector(matches, "focusin"), function(){
					self._onItemFocus(registry.byNode(this));
				})
			);
			this.inherited(arguments);
		},

		onKeyboardSearch: function(/*MenuItem*/ item, /*Event*/ evt, /*String*/ searchString, /*Number*/ numMatches){
			// summary:
			//		Attach point for notification about when a menu item has been searched for
			//		via the keyboard search mechanism.
			// tags:
			//		protected
			this.inherited(arguments);
			if(!!item && (numMatches == -1 || (!!item.popup && numMatches == 1))){
				this.onItemClick(item, evt);
			}
		},

		_keyboardSearchCompare: function(/*dijit/_WidgetBase*/ item, /*String*/ searchString){
			// summary:
			//		Compares the searchString to the widget's text label, returning:
			//		-1: a high priority match and stop searching
			//		 0: no match
			//		 1: a match but keep looking for a higher priority match
			// tags:
			//		private
			if(!!item.shortcutKey){
				// accessKey matches have priority
				return searchString == item.shortcutKey.toLowerCase() ? -1 : 0;
			}
			return this.inherited(arguments) ? 1 : 0; // change return value of -1 to 1 so that searching continues
		},

		onExecute: function(){
			// summary:
			//		Attach point for notification about when a menu item has been executed.
			//		This is an internal mechanism used for Menus to signal to their parent to
			//		close them, because they are about to execute the onClick handler.  In
			//		general developers should not attach to or override this method.
			// tags:
			//		protected
		},

		onCancel: function(/*Boolean*/ /*===== closeAll =====*/){
			// summary:
			//		Attach point for notification about when the user cancels the current menu
			//		This is an internal mechanism used for Menus to signal to their parent to
			//		close them.  In general developers should not attach to or override this method.
			// tags:
			//		protected
		},

		_moveToPopup: function(/*Event*/ evt){
			// summary:
			//		This handles the right arrow key (left arrow key on RTL systems),
			//		which will either open a submenu, or move to the next item in the
			//		ancestor MenuBar
			// tags:
			//		private

			if(this.focusedChild && this.focusedChild.popup && !this.focusedChild.disabled){
				this.onItemClick(this.focusedChild, evt);
			}else{
				var topMenu = this._getTopMenu();
				if(topMenu && topMenu._isMenuBar){
					topMenu.focusNext();
				}
			}
		},

		_onPopupHover: function(/*Event*/ /*===== evt =====*/){
			// summary:
			//		This handler is called when the mouse moves over the popup.
			// tags:
			//		private

			// if the mouse hovers over a menu popup that is in pending-close state,
			// then stop the close operation.
			// This can't be done in onItemHover since some popup targets don't have MenuItems (e.g. ColorPicker)

			// highlight the parent menu item pointing to this popup (in case user temporarily moused over another MenuItem)
			this.set("selected", this.currentPopupItem);

			// cancel the pending close (if there is one) (in case user temporarily moused over another MenuItem)
			this._stopPendingCloseTimer();
		},

		onItemHover: function(/*MenuItem*/ item){
			// summary:
			//		Called when cursor is over a MenuItem.
			// tags:
			//		protected

			// Don't do anything unless user has "activated" the menu by:
			//		1) clicking it
			//		2) opening it from a parent menu (which automatically activates it)

			if(this.activated){
				this.set("selected", item);
				if(item.popup && !item.disabled && !this.hover_timer){
					this.hover_timer = this.defer(function(){
						this._openItemPopup(item);
					}, this.popupDelay);
				}
			}else if(this.passivePopupDelay < Infinity){
				if(this.passive_hover_timer){
					this.passive_hover_timer.remove();
				}
				this.passive_hover_timer = this.defer(function(){
					this.onItemClick(item, {type: "click"});
				}, this.passivePopupDelay);
			}

			this._hoveredChild = item;

			item._set("hovering", true);
		},

		_onChildDeselect: function(item){
			// summary:
			//		Called when a child MenuItem becomes deselected.   Setup timer to close its popup.

			this._stopPopupTimer();

			// Setup timer to close all popups that are open and descendants of this menu.
			// Will be canceled if user quickly moves the mouse over the popup.
			if(this.currentPopupItem == item){
				this._stopPendingCloseTimer();
				this._pendingClose_timer = this.defer(function(){
					this._pendingClose_timer = null;
					this.currentPopupItem = null;
					item._closePopup(); // this calls onClose
				}, this.popupDelay);
			}
		},

		onItemUnhover: function(/*MenuItem*/ item){
			// summary:
			//		Callback fires when mouse exits a MenuItem
			// tags:
			//		protected

			if(this._hoveredChild == item){
				this._hoveredChild = null;
			}

			if(this.passive_hover_timer){
				this.passive_hover_timer.remove();
				this.passive_hover_timer = null;
			}

			item._set("hovering", false);
		},

		_stopPopupTimer: function(){
			// summary:
			//		Cancels the popup timer because the user has stop hovering
			//		on the MenuItem, etc.
			// tags:
			//		private

			if(this.hover_timer){
				this.hover_timer = this.hover_timer.remove();
			}
		},

		_stopPendingCloseTimer: function(){
			// summary:
			//		Cancels the pending-close timer because the close has been preempted
			// tags:
			//		private
			if(this._pendingClose_timer){
				this._pendingClose_timer = this._pendingClose_timer.remove();
			}
		},

		_getTopMenu: function(){
			// summary:
			//		Returns the top menu in this chain of Menus
			// tags:
			//		private
			for(var top = this; top.parentMenu; top = top.parentMenu){}
			return top;
		},

		onItemClick: function(/*dijit/_WidgetBase*/ item, /*Event*/ evt){
			// summary:
			//		Handle clicks on an item.
			// tags:
			//		private

			if(this.passive_hover_timer){
				this.passive_hover_timer.remove();
			}

			this.focusChild(item);

			if(item.disabled){
				return false;
			}

			if(item.popup){
				this.set("selected", item);
				this.set("activated", true);
				var byKeyboard = /^key/.test(evt._origType || evt.type) ||
					(evt.clientX == 0 && evt.clientY == 0);	// detects accessKey like ALT+SHIFT+F, where type is "click"
				this._openItemPopup(item, byKeyboard);
			}else{
				// before calling user defined handler, close hierarchy of menus
				// and restore focus to place it was when menu was opened
				this.onExecute();

				// user defined handler for click
				item._onClick ? item._onClick(evt) : item.onClick(evt);
			}
		},

		_openItemPopup: function(/*dijit/MenuItem*/ from_item, /*Boolean*/ focus){
			// summary:
			//		Open the popup to the side of/underneath the current menu item, and optionally focus first item
			// tags:
			//		protected

			if(from_item == this.currentPopupItem){
				// Specified popup is already being shown, so just return
				return;
			}
			if(this.currentPopupItem){
				// If another popup is currently shown, then close it
				this._stopPendingCloseTimer();
				this.currentPopupItem._closePopup();
			}
			this._stopPopupTimer();

			var popup = from_item.popup;
			popup.parentMenu = this;

			// detect mouseover of the popup to handle lazy mouse movements that temporarily focus other menu items\c
			this.own(this._mouseoverHandle = on.once(popup.domNode, "mouseover", lang.hitch(this, "_onPopupHover")));

			var self = this;
			from_item._openPopup({
				parent: this,
				orient: this._orient || ["after", "before"],
				onCancel: function(){ // called when the child menu is canceled
					if(focus){
						// put focus back on my node before focused node is hidden
						self.focusChild(from_item);
					}

					// close the submenu (be sure this is done _after_ focus is moved)
					self._cleanUp();
				},
				onExecute: lang.hitch(this, "_cleanUp", true),
				onClose: function(){
					// Remove handler created by onItemHover
					if(self._mouseoverHandle){
						self._mouseoverHandle.remove();
						delete self._mouseoverHandle;
					}
				}
			}, focus);

			this.currentPopupItem = from_item;

			// TODO: focusing a popup should clear tabIndex on Menu (and it's child MenuItems), so that neither
			// TAB nor SHIFT-TAB returns to the menu.  Only ESC or ENTER should return to the menu.
		},

		onOpen: function(/*Event*/ /*===== e =====*/){
			// summary:
			//		Callback when this menu is opened.
			//		This is called by the popup manager as notification that the menu
			//		was opened.
			// tags:
			//		private

			this.isShowingNow = true;
			this.set("activated", true);
		},

		onClose: function(){
			// summary:
			//		Callback when this menu is closed.
			//		This is called by the popup manager as notification that the menu
			//		was closed.
			// tags:
			//		private

			this.set("activated", false);
			this.set("selected", null);
			this.isShowingNow = false;
			this.parentMenu = null;
		},

		_closeChild: function(){
			// summary:
			//		Called when submenu is clicked or focus is lost.  Close hierarchy of menus.
			// tags:
			//		private
			this._stopPopupTimer();

			if(this.currentPopupItem){
				// If focus is on a descendant MenuItem then move focus to me,
				// because IE doesn't like it when you display:none a node with focus,
				// and also so keyboard users don't lose control.
				// Likely, immediately after a user defined onClick handler will move focus somewhere
				// else, like a Dialog.
				if(this.focused){
					domAttr.set(this.selected.focusNode, "tabIndex", this.tabIndex);
					this.selected.focusNode.focus();
				}

				// Close all popups that are open and descendants of this menu
				this.currentPopupItem._closePopup();
				this.currentPopupItem = null;
			}
		},

		_onItemFocus: function(/*MenuItem*/ item){
			// summary:
			//		Called when child of this Menu gets focus from:
			//
			//		1. clicking it
			//		2. tabbing into it
			//		3. being opened by a parent menu.
			//
			//		This is not called just from mouse hover.

			if(this._hoveredChild && this._hoveredChild != item){
				this.onItemUnhover(this._hoveredChild);	// any previous mouse movement is trumped by focus selection
			}
			this.set("selected", item);
		},

		_onBlur: function(){
			// summary:
			//		Called when focus is moved away from this Menu and it's submenus.
			// tags:
			//		protected

			this._cleanUp(true);
			this.inherited(arguments);
		},

		_cleanUp: function(/*Boolean*/ clearSelectedItem){
			// summary:
			//		Called when the user is done with this menu.  Closes hierarchy of menus.
			// tags:
			//		private

			this._closeChild(); // don't call this.onClose since that's incorrect for MenuBar's that never close
			if(typeof this.isShowingNow == 'undefined'){ // non-popup menu doesn't call onClose
				this.set("activated", false);
			}

			if(clearSelectedItem){
				this.set("selected", null);
			}
		}
	});
});

},
'dijit/_KeyNavContainer':function(){
define([
	"dojo/_base/array", // array.forEach
	"dojo/_base/declare", // declare
	"dojo/dom-attr", // domAttr.set
	"dojo/_base/kernel", // kernel.deprecated
	"dojo/keys", // keys.END keys.HOME
	"dojo/_base/lang", // lang.hitch
	"./registry",
	"./_Container",
	"./_FocusMixin",
	"./_KeyNavMixin"
], function(array, declare, domAttr, kernel, keys, lang, registry, _Container, _FocusMixin, _KeyNavMixin){


	// module:
	//		dijit/_KeyNavContainer

	return declare("dijit._KeyNavContainer", [_FocusMixin, _KeyNavMixin, _Container], {
		// summary:
		//		A _Container with keyboard navigation of its children.
		// description:
		//		Provides normalized keyboard and focusing code for Container widgets.
		//		To use this mixin, call connectKeyNavHandlers() in postCreate().
		//		Also, child widgets must implement a focus() method.

		connectKeyNavHandlers: function(/*keys[]*/ prevKeyCodes, /*keys[]*/ nextKeyCodes){
			// summary:
			//		Deprecated.  You can call this in postCreate() to attach the keyboard handlers to the container,
			//		but the preferred method is to override _onLeftArrow() and _onRightArrow(), or
			//		_onUpArrow() and _onDownArrow(), to call focusPrev() and focusNext().
			// prevKeyCodes: keys[]
			//		Key codes for navigating to the previous child.
			// nextKeyCodes: keys[]
			//		Key codes for navigating to the next child.
			// tags:
			//		protected

			// TODO: remove for 2.0, and make subclasses override _onLeftArrow, _onRightArrow etc. instead.

			var keyCodes = (this._keyNavCodes = {});
			var prev = lang.hitch(this, "focusPrev");
			var next = lang.hitch(this, "focusNext");
			array.forEach(prevKeyCodes, function(code){
				keyCodes[code] = prev;
			});
			array.forEach(nextKeyCodes, function(code){
				keyCodes[code] = next;
			});
			keyCodes[keys.HOME] = lang.hitch(this, "focusFirstChild");
			keyCodes[keys.END] = lang.hitch(this, "focusLastChild");
		},

		startupKeyNavChildren: function(){
			kernel.deprecated("startupKeyNavChildren() call no longer needed", "", "2.0");
		},

		startup: function(){
			this.inherited(arguments);
			array.forEach(this.getChildren(), lang.hitch(this, "_startupChild"));
		},

		addChild: function(/*dijit/_WidgetBase*/ widget, /*int?*/ insertIndex){
			this.inherited(arguments);
			this._startupChild(widget);
		},

		_startupChild: function(/*dijit/_WidgetBase*/ widget){
			// summary:
			//		Setup for each child widget.
			// description:
			//		Sets tabIndex=-1 on each child, so that the tab key will
			//		leave the container rather than visiting each child.
			//
			//		Note: if you add children by a different method than addChild(), then need to call this manually
			//		or at least make sure the child's tabIndex is -1.
			//
			//		Note: see also _LayoutWidget.setupChild(), which is also called for each child widget.
			// tags:
			//		private

			widget.set("tabIndex", "-1");
		},

		_getFirst: function(){
			// summary:
			//		Returns the first child.
			// tags:
			//		abstract extension
			var children = this.getChildren();
			return children.length ? children[0] : null;
		},

		_getLast: function(){
			// summary:
			//		Returns the last descendant.
			// tags:
			//		abstract extension
			var children = this.getChildren();
			return children.length ? children[children.length - 1] : null;
		},

		focusNext: function(){
			// summary:
			//		Focus the next widget
			// tags:
			//		protected
			this.focusChild(this._getNextFocusableChild(this.focusedChild, 1));
		},

		focusPrev: function(){
			// summary:
			//		Focus the last focusable node in the previous widget
			//		(ex: go to the ComboButton icon section rather than button section)
			// tags:
			//		protected
			this.focusChild(this._getNextFocusableChild(this.focusedChild, -1), true);
		},

		childSelector: function(/*DOMNode*/ node){
			// Implement _KeyNavMixin.childSelector, to identify focusable child nodes.
			// If we allowed a dojo/query dependency from this module this could more simply be a string "> *"
			// instead of this function.

			var node = registry.byNode(node);
			return node && node.getParent() == this;
		}
	});
});

},
'dijit/_KeyNavMixin':function(){
define([
	"dojo/_base/array", // array.forEach
	"dojo/_base/declare", // declare
	"dojo/dom-attr", // domAttr.set
	"dojo/keys", // keys.END keys.HOME, keys.LEFT_ARROW etc.
	"dojo/_base/lang", // lang.hitch
	"dojo/on",
	"dijit/registry",
	"dijit/_FocusMixin"        // to make _onBlur() work
], function(array, declare, domAttr, keys, lang, on, registry, _FocusMixin){

	// module:
	//		dijit/_KeyNavMixin

	return declare("dijit._KeyNavMixin", _FocusMixin, {
		// summary:
		//		A mixin to allow arrow key and letter key navigation of child or descendant widgets.
		//		It can be used by dijit/_Container based widgets with a flat list of children,
		//		or more complex widgets like dijit/Tree.
		//
		//		To use this mixin, the subclass must:
		//
		//			- Implement  _getNext(), _getFirst(), _getLast(), _onLeftArrow(), _onRightArrow()
		//			  _onDownArrow(), _onUpArrow() methods to handle home/end/left/right/up/down keystrokes.
		//			  Next and previous in this context refer to a linear ordering of the descendants used
		//			  by letter key search.
		//			- Set all descendants' initial tabIndex to "-1"; both initial descendants and any
		//			  descendants added later, by for example addChild()
		//			- Define childSelector to a function or string that identifies focusable descendant widgets
		//
		//		Also, child widgets must implement a focus() method.

		/*=====
		 // focusedChild: [protected readonly] Widget
		 //		The currently focused child widget, or null if there isn't one
		 focusedChild: null,

		 // _keyNavCodes: Object
		 //		Hash mapping key code (arrow keys and home/end key) to functions to handle those keys.
		 //		Usually not used directly, as subclasses can instead override _onLeftArrow() etc.
		 _keyNavCodes: {},
		 =====*/

		// tabIndex: String
		//		Tab index of the container; same as HTML tabIndex attribute.
		//		Note then when user tabs into the container, focus is immediately
		//		moved to the first item in the container.
		tabIndex: "0",

		// childSelector: [protected abstract] Function||String
		//		Selector (passed to on.selector()) used to identify what to treat as a child widget.   Used to monitor
		//		focus events and set this.focusedChild.   Must be set by implementing class.   If this is a string
		//		(ex: "> *") then the implementing class must require dojo/query.
		childSelector: null,

		postCreate: function(){
			this.inherited(arguments);

			// Set tabIndex on this.domNode.  Will be automatic after #7381 is fixed.
			domAttr.set(this.domNode, "tabIndex", this.tabIndex);

			if(!this._keyNavCodes){
				var keyCodes = this._keyNavCodes = {};
				keyCodes[keys.HOME] = lang.hitch(this, "focusFirstChild");
				keyCodes[keys.END] = lang.hitch(this, "focusLastChild");
				keyCodes[this.isLeftToRight() ? keys.LEFT_ARROW : keys.RIGHT_ARROW] = lang.hitch(this, "_onLeftArrow");
				keyCodes[this.isLeftToRight() ? keys.RIGHT_ARROW : keys.LEFT_ARROW] = lang.hitch(this, "_onRightArrow");
				keyCodes[keys.UP_ARROW] = lang.hitch(this, "_onUpArrow");
				keyCodes[keys.DOWN_ARROW] = lang.hitch(this, "_onDownArrow");
			}

			var self = this,
				childSelector = typeof this.childSelector == "string"
					? this.childSelector
					: lang.hitch(this, "childSelector");
			this.own(
				on(this.domNode, "keypress", lang.hitch(this, "_onContainerKeypress")),
				on(this.domNode, "keydown", lang.hitch(this, "_onContainerKeydown")),
				on(this.domNode, "focus", lang.hitch(this, "_onContainerFocus")),
				on(this.containerNode, on.selector(childSelector, "focusin"), function(evt){
					self._onChildFocus(registry.getEnclosingWidget(this), evt);
				})
			);
		},

		_onLeftArrow: function(){
			// summary:
			//		Called on left arrow key, or right arrow key if widget is in RTL mode.
			//		Should go back to the previous child in horizontal container widgets like Toolbar.
			// tags:
			//		extension
		},

		_onRightArrow: function(){
			// summary:
			//		Called on right arrow key, or left arrow key if widget is in RTL mode.
			//		Should go to the next child in horizontal container widgets like Toolbar.
			// tags:
			//		extension
		},

		_onUpArrow: function(){
			// summary:
			//		Called on up arrow key. Should go to the previous child in vertical container widgets like Menu.
			// tags:
			//		extension
		},

		_onDownArrow: function(){
			// summary:
			//		Called on down arrow key. Should go to the next child in vertical container widgets like Menu.
			// tags:
			//		extension
		},

		focus: function(){
			// summary:
			//		Default focus() implementation: focus the first child.
			this.focusFirstChild();
		},

		_getFirstFocusableChild: function(){
			// summary:
			//		Returns first child that can be focused.

			// Leverage _getNextFocusableChild() to skip disabled children
			return this._getNextFocusableChild(null, 1);	// dijit/_WidgetBase
		},

		_getLastFocusableChild: function(){
			// summary:
			//		Returns last child that can be focused.

			// Leverage _getNextFocusableChild() to skip disabled children
			return this._getNextFocusableChild(null, -1);	// dijit/_WidgetBase
		},

		focusFirstChild: function(){
			// summary:
			//		Focus the first focusable child in the container.
			// tags:
			//		protected

			this.focusChild(this._getFirstFocusableChild());
		},

		focusLastChild: function(){
			// summary:
			//		Focus the last focusable child in the container.
			// tags:
			//		protected

			this.focusChild(this._getLastFocusableChild());
		},

		focusChild: function(/*dijit/_WidgetBase*/ widget, /*Boolean*/ last){
			// summary:
			//		Focus specified child widget.
			// widget:
			//		Reference to container's child widget
			// last:
			//		If true and if widget has multiple focusable nodes, focus the
			//		last one instead of the first one
			// tags:
			//		protected

			if(!widget){
				return;
			}

			if(this.focusedChild && widget !== this.focusedChild){
				this._onChildBlur(this.focusedChild);	// used to be used by _MenuBase
			}
			widget.set("tabIndex", this.tabIndex);	// for IE focus outline to appear, must set tabIndex before focus
			widget.focus(last ? "end" : "start");

			// Don't set focusedChild here, because the focus event should trigger a call to _onChildFocus(), which will
			// set it.   More importantly, _onChildFocus(), which may be executed asynchronously (after this function
			// returns) needs to know the old focusedChild to set its tabIndex to -1.
		},

		_onContainerFocus: function(evt){
			// summary:
			//		Handler for when the container itself gets focus.
			// description:
			//		Initially the container itself has a tabIndex, but when it gets
			//		focus, switch focus to first child.
			//
			//		TODO for 2.0 (or earlier): Instead of having the container tabbable, always maintain a single child
			//		widget as tabbable, Requires code in startup(), addChild(), and removeChild().
			//		That would avoid various issues like #17347.
			// tags:
			//		private

			// Note that we can't use _onFocus() because switching focus from the
			// _onFocus() handler confuses the focus.js code
			// (because it causes _onFocusNode() to be called recursively).
			// Also, _onFocus() would fire when focus went directly to a child widget due to mouse click.

			// Ignore spurious focus events:
			//	1. focus on a child widget bubbles on FF
			//	2. on IE, clicking the scrollbar of a select dropdown moves focus from the focused child item to me
			if(evt.target !== this.domNode || this.focusedChild){
				return;
			}

			this.focus();
		},

		_onFocus: function(){
			// When the container gets focus by being tabbed into, or a descendant gets focus by being clicked,
			// set the container's tabIndex to -1 (don't remove as that breaks Safari 4) so that tab or shift-tab
			// will go to the fields after/before the container, rather than the container itself
			domAttr.set(this.domNode, "tabIndex", "-1");

			this.inherited(arguments);
		},

		_onBlur: function(evt){
			// When focus is moved away the container, and its descendant (popup) widgets,
			// then restore the container's tabIndex so that user can tab to it again.
			// Note that using _onBlur() so that this doesn't happen when focus is shifted
			// to one of my child widgets (typically a popup)

			// TODO: for 2.0 consider changing this to blur whenever the container blurs, to be truthful that there is
			// no focused child at that time.

			domAttr.set(this.domNode, "tabIndex", this.tabIndex);
			if(this.focusedChild){
				this.focusedChild.set("tabIndex", "-1");
				this.lastFocusedChild = this.focusedChild;
				this._set("focusedChild", null);
			}
			this.inherited(arguments);
		},

		_onChildFocus: function(/*dijit/_WidgetBase*/ child){
			// summary:
			//		Called when a child widget gets focus, either by user clicking
			//		it, or programatically by arrow key handling code.
			// description:
			//		It marks that the current node is the selected one, and the previously
			//		selected node no longer is.

			if(child && child != this.focusedChild){
				if(this.focusedChild && !this.focusedChild._destroyed){
					// mark that the previously focusable node is no longer focusable
					this.focusedChild.set("tabIndex", "-1");
				}

				// mark that the new node is the currently selected one
				child.set("tabIndex", this.tabIndex);
				this.lastFocused = child;		// back-compat for Tree, remove for 2.0
				this._set("focusedChild", child);
			}
		},

		_searchString: "",
		// multiCharSearchDuration: Number
		//		If multiple characters are typed where each keystroke happens within
		//		multiCharSearchDuration of the previous keystroke,
		//		search for nodes matching all the keystrokes.
		//
		//		For example, typing "ab" will search for entries starting with
		//		"ab" unless the delay between "a" and "b" is greater than multiCharSearchDuration.
		multiCharSearchDuration: 1000,

		onKeyboardSearch: function(/*dijit/_WidgetBase*/ item, /*Event*/ evt, /*String*/ searchString, /*Number*/ numMatches){
			// summary:
			//		When a key is pressed that matches a child item,
			//		this method is called so that a widget can take appropriate action is necessary.
			// tags:
			//		protected
			if(item){
				this.focusChild(item);
			}
		},

		_keyboardSearchCompare: function(/*dijit/_WidgetBase*/ item, /*String*/ searchString){
			// summary:
			//		Compares the searchString to the widget's text label, returning:
			//
			//			* -1: a high priority match  and stop searching
			//		 	* 0: not a match
			//		 	* 1: a match but keep looking for a higher priority match
			// tags:
			//		private

			var element = item.domNode,
				text = item.label || (element.focusNode ? element.focusNode.label : '') || element.innerText || element.textContent || "",
				currentString = text.replace(/^\s+/, '').substr(0, searchString.length).toLowerCase();

			return (!!searchString.length && currentString == searchString) ? -1 : 0; // stop searching after first match by default
		},

		_onContainerKeydown: function(evt){
			// summary:
			//		When a key is pressed, if it's an arrow key etc. then it's handled here.
			// tags:
			//		private

			var func = this._keyNavCodes[evt.keyCode];
			if(func){
				func(evt, this.focusedChild);
				evt.stopPropagation();
				evt.preventDefault();
				this._searchString = ''; // so a DOWN_ARROW b doesn't search for ab
			}else if(evt.keyCode == keys.SPACE && this._searchTimer && !(evt.ctrlKey || evt.altKey || evt.metaKey)){
				evt.stopImmediatePropagation(); // stop a11yclick and _HasDropdown from seeing SPACE if we're doing keyboard searching
				evt.preventDefault(); // stop IE from scrolling, and most browsers (except FF) from sending keypress
				this._keyboardSearch(evt, ' ');
			}
		},

		_onContainerKeypress: function(evt){
			// summary:
			//		When a printable key is pressed, it's handled here, searching by letter.
			// tags:
			//		private

			// Ignore:
			// 		- duplicate events on firefox (ex: arrow key that will be handled by keydown handler)
			//		- control sequences like CMD-Q.
			//		- the SPACE key (only occurs on FF)
			//
			// Note: if there's no search in progress, then SPACE should be ignored.   If there is a search
			// in progress, then SPACE is handled in _onContainerKeyDown.
			if(evt.charCode <= keys.SPACE || evt.ctrlKey || evt.altKey || evt.metaKey){
				return;
			}

			evt.preventDefault();
			evt.stopPropagation();

			this._keyboardSearch(evt, String.fromCharCode(evt.charCode).toLowerCase());
		},

		_keyboardSearch: function(/*Event*/ evt, /*String*/ keyChar){
			// summary:
			//		Perform a search of the widget's options based on the user's keyboard activity
			// description:
			//		Called on keypress (and sometimes keydown), searches through this widget's children
			//		looking for items that match the user's typed search string.  Multiple characters
			//		typed within 1 sec of each other are combined for multicharacter searching.
			// tags:
			//		private
			var
				matchedItem = null,
				searchString,
				numMatches = 0,
				search = lang.hitch(this, function(){
					if(this._searchTimer){
						this._searchTimer.remove();
					}
					this._searchString += keyChar;
					var allSameLetter = /^(.)\1*$/.test(this._searchString);
					var searchLen = allSameLetter ? 1 : this._searchString.length;
					searchString = this._searchString.substr(0, searchLen);
					// commented out code block to search again if the multichar search fails after a smaller timeout
					//this._searchTimer = this.defer(function(){ // this is the "failure" timeout
					//	this._typingSlowly = true; // if the search fails, then treat as a full timeout
					//	this._searchTimer = this.defer(function(){ // this is the "success" timeout
					//		this._searchTimer = null;
					//		this._searchString = '';
					//	}, this.multiCharSearchDuration >> 1);
					//}, this.multiCharSearchDuration >> 1);
					this._searchTimer = this.defer(function(){ // this is the "success" timeout
						this._searchTimer = null;
						this._searchString = '';
					}, this.multiCharSearchDuration);
					var currentItem = this.focusedChild || null;
					if(searchLen == 1 || !currentItem){
						currentItem = this._getNextFocusableChild(currentItem, 1); // skip current
						if(!currentItem){
							return;
						} // no items
					}
					var stop = currentItem;
					do{
						var rc = this._keyboardSearchCompare(currentItem, searchString);
						if(!!rc && numMatches++ == 0){
							matchedItem = currentItem;
						}
						if(rc == -1){ // priority match
							numMatches = -1;
							break;
						}
						currentItem = this._getNextFocusableChild(currentItem, 1);
					}while(currentItem && currentItem != stop);
					// commented out code block to search again if the multichar search fails after a smaller timeout
					//if(!numMatches && (this._typingSlowly || searchLen == 1)){
					//	this._searchString = '';
					//	if(searchLen > 1){
					//		// if no matches and they're typing slowly, then go back to first letter searching
					//		search();
					//	}
					//}
				});

			search();
			// commented out code block to search again if the multichar search fails after a smaller timeout
			//this._typingSlowly = false;
			this.onKeyboardSearch(matchedItem, evt, searchString, numMatches);
		},

		_onChildBlur: function(/*dijit/_WidgetBase*/ /*===== widget =====*/){
			// summary:
			//		Called when focus leaves a child widget to go
			//		to a sibling widget.
			//		Used to be used by MenuBase.js (remove for 2.0)
			// tags:
			//		protected
		},

		_getNextFocusableChild: function(child, dir){
			// summary:
			//		Returns the next or previous focusable descendant, compared to "child".
			//		Implements and extends _KeyNavMixin._getNextFocusableChild() for a _Container.
			// child: Widget
			//		The current widget
			// dir: Integer
			//		- 1 = after
			//		- -1 = before
			// tags:
			//		abstract extension

			var wrappedValue = child;
			do{
				if(!child){
					child = this[dir > 0 ? "_getFirst" : "_getLast"]();
					if(!child){ break; }
				}else{
					child = this._getNext(child, dir);
				}
				if(child != null && child != wrappedValue && child.isFocusable()){
					return child;	// dijit/_WidgetBase
				}
			}while(child != wrappedValue);
			// no focusable child found
			return null;	// dijit/_WidgetBase
		},

		_getFirst: function(){
			// summary:
			//		Returns the first child.
			// tags:
			//		abstract extension

			return null;	// dijit/_WidgetBase
		},

		_getLast: function(){
			// summary:
			//		Returns the last descendant.
			// tags:
			//		abstract extension

			return null;	// dijit/_WidgetBase
		},

		_getNext: function(child, dir){
			// summary:
			//		Returns the next descendant, compared to "child".
			// child: Widget
			//		The current widget
			// dir: Integer
			//		- 1 = after
			//		- -1 = before
			// tags:
			//		abstract extension

			if(child){
				child = child.domNode;
				while(child){
					child = child[dir < 0 ? "previousSibling" : "nextSibling"];
					if(child  && "getAttribute" in child){
						var w = registry.byNode(child);
						if(w){
							return w; // dijit/_WidgetBase
						}
					}
				}
			}
			return null;	// dijit/_WidgetBase
		}
	});
});

},
'dijit/MenuItem':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/dom", // dom.setSelectable
	"dojo/dom-attr", // domAttr.set
	"dojo/dom-class", // domClass.toggle
	"dojo/_base/kernel", // kernel.deprecated
	"dojo/sniff", // has("ie")
	"dojo/_base/lang", // lang.hitch
	"./_Widget",
	"./_TemplatedMixin",
	"./_Contained",
	"./_CssStateMixin",
	"dojo/text!./templates/MenuItem.html"
], function(declare, dom, domAttr, domClass, kernel, has, lang,
			_Widget, _TemplatedMixin, _Contained, _CssStateMixin, template){

	// module:
	//		dijit/MenuItem

	var MenuItem = declare("dijit.MenuItem" + (has("dojo-bidi") ? "_NoBidi" : ""),
		[_Widget, _TemplatedMixin, _Contained, _CssStateMixin], {
		// summary:
		//		A line item in a Menu Widget

		// Make 3 columns
		// icon, label, and expand arrow (BiDi-dependent) indicating sub-menu
		templateString: template,

		baseClass: "dijitMenuItem",

		// label: String
		//		Menu text as HTML
		label: "",
		_setLabelAttr: function(val){
			this._set("label", val);
			var shortcutKey = "";
			var text;
			var ndx = val.search(/{\S}/);
			if(ndx >= 0){
				shortcutKey = val.charAt(ndx + 1);
				var prefix = val.substr(0, ndx);
				var suffix = val.substr(ndx + 3);
				text = prefix + shortcutKey + suffix;
				val = prefix + '<span class="dijitMenuItemShortcutKey">' + shortcutKey + '</span>' + suffix;
			}else{
				text = val;
			}
			this.domNode.setAttribute("aria-label", text + " " + this.accelKey);
			this.containerNode.innerHTML = val;
			this._set('shortcutKey', shortcutKey);
		},

		/*=====
		// shortcutKey: [readonly] String
		//		Single character (underlined when the parent Menu is focused) used to navigate directly to this widget,
		//		also known as [a mnemonic](http://en.wikipedia.org/wiki/Mnemonics_(keyboard%29).
		//		This is denoted in the label by surrounding the single character with {}.
		//		For example, if label="{F}ile", then shortcutKey="F".
		shortcutKey: "",
		=====*/

		// iconClass: String
		//		Class to apply to DOMNode to make it display an icon.
		iconClass: "dijitNoIcon",
		_setIconClassAttr: { node: "iconNode", type: "class" },

		// accelKey: String
		//		Text for the accelerator (shortcut) key combination, a control, alt, etc. modified keystroke meant to
		//		execute the menu item regardless of where the focus is on the page.
		//
		//		Note that although Menu can display accelerator keys, there is no infrastructure to actually catch and
		//		execute those accelerators.
		accelKey: "",

		// disabled: Boolean
		//		If true, the menu item is disabled.
		//		If false, the menu item is enabled.
		disabled: false,

		_fillContent: function(/*DomNode*/ source){
			// If button label is specified as srcNodeRef.innerHTML rather than
			// this.params.label, handle it here.
			if(source && !("label" in this.params)){
				this._set('label', source.innerHTML);
			}
		},

		buildRendering: function(){
			this.inherited(arguments);
			var label = this.id + "_text";
			domAttr.set(this.containerNode, "id", label); // only needed for backward compat
			if(this.accelKeyNode){
				domAttr.set(this.accelKeyNode, "id", this.id + "_accel"); // only needed for backward compat
			}
			dom.setSelectable(this.domNode, false);
		},

		onClick: function(/*Event*/){
			// summary:
			//		User defined function to handle clicks
			// tags:
			//		callback
		},

		focus: function(){
			// summary:
			//		Focus on this MenuItem
			try{
				if(has("ie") == 8){
					// needed for IE8 which won't scroll TR tags into view on focus yet calling scrollIntoView creates flicker (#10275)
					this.containerNode.focus();
				}
				this.focusNode.focus();
			}catch(e){
				// this throws on IE (at least) in some scenarios
			}
		},

		_setSelected: function(selected){
			// summary:
			//		Indicate that this node is the currently selected one
			// tags:
			//		private

			domClass.toggle(this.domNode, "dijitMenuItemSelected", selected);
		},

		setLabel: function(/*String*/ content){
			// summary:
			//		Deprecated.   Use set('label', ...) instead.
			// tags:
			//		deprecated
			kernel.deprecated("dijit.MenuItem.setLabel() is deprecated.  Use set('label', ...) instead.", "", "2.0");
			this.set("label", content);
		},

		setDisabled: function(/*Boolean*/ disabled){
			// summary:
			//		Deprecated.   Use set('disabled', bool) instead.
			// tags:
			//		deprecated
			kernel.deprecated("dijit.Menu.setDisabled() is deprecated.  Use set('disabled', bool) instead.", "", "2.0");
			this.set('disabled', disabled);
		},

		_setDisabledAttr: function(/*Boolean*/ value){
			// summary:
			//		Hook for attr('disabled', ...) to work.
			//		Enable or disable this menu item.

			this.focusNode.setAttribute('aria-disabled', value ? 'true' : 'false');
			this._set("disabled", value);
		},

		_setAccelKeyAttr: function(/*String*/ value){
			// summary:
			//		Hook for attr('accelKey', ...) to work.
			//		Set accelKey on this menu item.

			if(this.accelKeyNode){
				this.accelKeyNode.style.display = value ? "" : "none";
				this.accelKeyNode.innerHTML = value;
				//have to use colSpan to make it work in IE
				domAttr.set(this.containerNode, 'colSpan', value ? "1" : "2");
			}
			this._set("accelKey", value);
		}
	});

	if(has("dojo-bidi")){
		MenuItem = declare("dijit.MenuItem", MenuItem, {
			_setLabelAttr: function(val){
				this.inherited(arguments);
				if(this.textDir === "auto"){
					this.applyTextDir(this.textDirNode);
				}
			}
		});
	}

	return MenuItem;
});

},
'dijit/_Contained':function(){
define([
	"dojo/_base/declare", // declare
	"./registry"	// registry.getEnclosingWidget(), registry.byNode()
], function(declare, registry){

	// module:
	//		dijit/_Contained

	return declare("dijit._Contained", null, {
		// summary:
		//		Mixin for widgets that are children of a container widget
		// example:
		//	|	// make a basic custom widget that knows about its parents
		//	|	declare("my.customClass",[dijit._WidgetBase, dijit._Contained],{});

		_getSibling: function(/*String*/ which){
			// summary:
			//		Returns next or previous sibling
			// which:
			//		Either "next" or "previous"
			// tags:
			//		private
			var p = this.getParent();
			return (p && p._getSiblingOfChild && p._getSiblingOfChild(this, which == "previous" ? -1 : 1)) || null;	// dijit/_WidgetBase
		},

		getPreviousSibling: function(){
			// summary:
			//		Returns null if this is the first child of the parent,
			//		otherwise returns the next element sibling to the "left".

			return this._getSibling("previous"); // dijit/_WidgetBase
		},

		getNextSibling: function(){
			// summary:
			//		Returns null if this is the last child of the parent,
			//		otherwise returns the next element sibling to the "right".

			return this._getSibling("next"); // dijit/_WidgetBase
		},

		getIndexInParent: function(){
			// summary:
			//		Returns the index of this widget within its container parent.
			//		It returns -1 if the parent does not exist, or if the parent
			//		is not a dijit/_Container

			var p = this.getParent();
			if(!p || !p.getIndexOfChild){
				return -1; // int
			}
			return p.getIndexOfChild(this); // int
		}
	});
});

},
'dijit/MenuSeparator':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/dom", // dom.setSelectable
	"./_WidgetBase",
	"./_TemplatedMixin",
	"./_Contained",
	"dojo/text!./templates/MenuSeparator.html"
], function(declare, dom, _WidgetBase, _TemplatedMixin, _Contained, template){

	// module:
	//		dijit/MenuSeparator

	return declare("dijit.MenuSeparator", [_WidgetBase, _TemplatedMixin, _Contained], {
		// summary:
		//		A line between two menu items

		templateString: template,

		buildRendering: function(){
			this.inherited(arguments);
			dom.setSelectable(this.domNode, false);
		},

		isFocusable: function(){
			// summary:
			//		Override to always return false
			// tags:
			//		protected

			return false; // Boolean
		}
	});
});

},
'soso/dijit/form/api/doccontrol/template/ModelFactory':function(){
define([
    'api/doccontrol/template/Factory',
    'api/doccontrol/template/Config',
    'library/request/dojo/URLConnectionProcessorBuilder',
    'library/request/URLConnectionBuilder',
    'library/request/URLResponseProcessorBuilder'
], function(
    TemplateFactory,
    TemplateConfig,
    URLConnectionProcessorBuilder,
    URLConnectionBuilder,
    URLResponseProcessorBuilder
) {
    const ModelFactory = function() {
        this.templateFactory = new TemplateFactory(
            new TemplateConfig(),
            new URLConnectionBuilder(new URLConnectionProcessorBuilder()),
            new URLResponseProcessorBuilder()
        );
    };

    ModelFactory.prototype.getModel = function() {
        return this.templateFactory.getTemplate();
    };

    ModelFactory.prototype.getModelCollection = function() {
        return this.templateFactory.getTemplateCollection();
    };

    ModelFactory.prototype.getFieldModel = function() {
        return this.templateFactory.getField();
    };

    ModelFactory.prototype.getOrganisationModelCollection = function() {
        return this.templateFactory.getOrganisationCollection();
    };

    ModelFactory.prototype.getDocumentTypeCollectionModel = function() {
        return this.templateFactory.getDocumentTypeCollection();
    }

    ModelFactory.prototype.getPersonModelCollection = function() {
        return this.templateFactory.getPersonCollection();
    };

    return ModelFactory;
});
},
'soso/dijit/form/api/doccontrol/template/PresetFieldSelector':function(){
define(["require", "exports", "dojo/_base/declare", "style-guide/v1/forms/searchable-select/Selector", "style-guide/v1/forms/searchable-select/Menu", "@lib/doc-control/document/template/field/PresetFieldCollectionBuilder"], function (require, exports, dojoDeclare, Selector, Menu, PresetFieldCollectionBuilder) {
    "use strict";
    class PresetFieldSelector {
        constructor(domNode) {
            const view = PresetFieldSelector.getView();
            this.view = new view({}, domNode);
            this.domNode = this.view.domNode;
        }
        on(event, handler) {
            this.view.on(event, handler);
        }
        reset() {
            this.view.reset();
        }
        static getView() {
            return dojoDeclare([Selector], {
                placeholder: 'Select preset...',
                fieldPresetCollection: [],
                postCreate: function () {
                    this.fieldPresetCollection = new PresetFieldCollectionBuilder().get();
                    this.limit = this.fieldPresetCollection.length + 1;
                    this.inherited(this.postCreate, arguments);
                },
                query: function (promise, options) {
                    if (options.filter) {
                        promise.resolve(this.fieldPresetCollection.filter((fieldPreset) => {
                            return fieldPreset.getLabel().toLowerCase().includes(options.filter.toLowerCase());
                        }));
                        return;
                    }
                    promise.resolve(this.fieldPresetCollection);
                },
                _createMenu: function () {
                    this.menu = new Menu({
                        fieldPresetCollection: this.fieldPresetCollection,
                        filterCollection: this.filterCollection,
                        searchAttr: this.searchAttr,
                        limit: this.limit,
                        query: this.query,
                        icon: this.icon,
                        onClick: this._onClick.bind(this),
                        onClose: this._onClose.bind(this)
                    }, this.menuElement);
                    this.menu.on('NO_RESULTS_FOUND', (e) => this._invalidate());
                },
                searchAttr: function (fieldPreset) {
                    return fieldPreset.getLabel();
                }
            });
        }
    }
    return PresetFieldSelector;
});

},
'style-guide/v1/forms/searchable-select/Selector':function(){
define([
    './Menu',
    'dijit/_WidgetBase',
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/Evented',
    'dojo/on',
    'dojo/text!./template/Selector.html',
    'soso/sosox/ejs/_Templated'
], function(
    Menu,
    WidgetBase,
    declare,
    domAttr,
    domClass,
    Evented,
    on,
    template,
    Templated
) {
    return declare([WidgetBase, Templated, Evented], {
        templateString: template,

        disabled: false,
        filterCollection: null,
        icon: null,
        lastEmittedValue: null,
        lastSearch: '',
        limit: null,
        query: null,
        required: false,
        searchAttr: null,
        validationPrompt: null,
        validationPromptRight: false,

        postCreate: function() {
            this._createMenu();

            if (this.validationPromptRight) {
                this.validationPrompt.classList.add('sos-form-textfield-validation-prompt-right');
            }

            if(this.required) {
                domAttr.set(this.valueField, 'required', 'required');
            }
        },

        reset: function() {
            this.set('value', '');
            this._clear();
        },

        onChange: function() {},

        onBlur: function() {},

        onFocus: function() {},

        onKeyUp: function() {},

        validate: function() {
            if(this.required && !this.value) {
                domClass.add(this.domNode, 'sos-form-searchable-select-error');
            }

            return !this.required || !!this.value;
        },

        disable: function() {
            this.valueField.disabled = true;
            this.disabled = true;
        },

        enable: function() {
            this.valueField.disabled = false;
            this.disabled = false;
        },

        isDisabled: function() {
            return this.disabled && this.valueField.disabled;
        },

        setCompact: function() {
            this.domNode.classList.add('sos-form-filtering-select-s');
            this.valueField.classList.add('sos-form-textfield-s');
            this.dropDownElement.classList.add('sos-form-textfield-suffix-s');
        },

        destroyRecursive: function() {
            if (this.menu) {
                this.menu.destroyRecursive();
                this.menu = null;
            }

            if (this.domNode) {
                this.inherited(arguments);
                this.domNode.remove();
                this.domNode.innerHTML = '';
                this.domNode = null;
            }

            this.onChange = null;
        },

        _openMenu: function() {
            domClass.remove(this.domNode ,'sos-form-searchable-select-error');

            if(this.disabled) {
                return;
            }

            this.menu.open();
        },

        _toggleMenu: function() {
            if(!this.menu.isOpen()) {
                domClass.remove(this.domNode ,'sos-form-searchable-select-error');

                if(this.disabled) {
                    return;
                }
            }

            this.menu.isOpen() ?
                this.menu.close() :
                this.menu.open();
        },

        _search: function(e) {
            const value = e.target.value;

            if (!(e instanceof InputEvent) || value === '') {
                this.value = null;
                this.onChange(null);
                this.emit('change', null);
                this.domNode.classList.remove('sos-form-searchable-select-error');
                return;
            }

            if(!value.trim() && this.lastSearch !== value.trim()) {
                this.onChange(null);
                this.emit('change', null);
            }

            if(this.lastSearch === value.trim()) {
                return;
            }

            this.menu.search(value.trim());
            this.lastSearch = value.trim();
            this.onKeyUp(this.lastSearch);
        },

        _clear: function() {
            this.value = null;
            this.lastSearch = '';
            if (!this.required) {
                this.domNode.classList.remove('sos-form-searchable-select-error');
            }
        },

        _createMenu: function() {
            this.menu = new Menu({
                filterCollection: this.filterCollection,
                searchAttr: this.searchAttr,
                limit: this.limit,
                query: this.query,
                icon: this.icon,
                onClick: this._onClick.bind(this),
                onClose: this._onClose.bind(this)
            }, this.menuElement);

            this.menu.on('NO_RESULTS_FOUND', (e) => this._invalidate());
        },

        _onClick: function(result) {
            this.set('value', result);
            this.lastSearch = '';
        },

        _onClose: function() {
            const fieldValue = this.valueField.value.trim();

            const currentValue = this._getValueFieldText(
                this.get('value')
            ).trim();

            if(!fieldValue) {
                this.value = null;
            }

            if(fieldValue !== currentValue) {
                this.value = null;
            }

            if(this.value !== this.lastEmittedValue) {
                this.onChange(this.value);
                this.emit('change', this.value);
            }

            this.lastEmittedValue = this.value;
        },

        _invalidate: function() {
            this.domNode.classList.add('sos-form-searchable-select-error');
        },

        _setPlaceholderAttr: function(placeholder) {
            domAttr.set(
                this.valueField,
                'placeholder',
                placeholder
            );
        },

        _getValueAttr: function() {
            return this.value;
        },

        _setValueAttr: function(value) {
            domClass.remove(this.domNode ,'sos-form-searchable-select-error');
            this._setValueFieldText(value);
            this.lastSearch = this._getValueFieldText(value);
            this.value = value;
        },

        _getValueFieldText: function(value) {
            if(!value) {
                return '';
            }

            if(this.searchAttr instanceof Function) {
                return this.searchAttr(value);
            } else {
                return value[this.searchAttr];
            }
        },

        _setValueFieldText: function(value) {
            this.valueField.value = this._getValueFieldText(value);
        },

        _setDisabledAttr: function(disabled) {
            this.disabled = disabled;

            if(disabled) {
                domAttr.set(this.valueField, 'disabled', 'disabled');
            } else {
                domAttr.remove(this.valueField, 'disabled');
            }
        },

        _getDisplayedValueAttr: function() {
            return this.valueField.value.trim();
        },

        _setRequiredAttr: function(required) {
            this.required = required;
        }
    });
});

},
'style-guide/v1/forms/searchable-select/Menu':function(){
define([
    './Result',
    'dijit/_WidgetBase',
    'dojo/_base/declare',
    'dojo/Deferred',
    'dojo/dom-class',
    'dojo/dom-geometry',
    'dojo/on',
    'dojo/Evented',
    'dojo/text!./template/Menu.html',
    'soso/sosox/ejs/_Templated'
], function(
    Result,
    WidgetBase,
    declare,
    Deferred,
    domClass,
    domGeometry,
    on,
    Evented,
    template,
    Templated
) {
    return declare([WidgetBase, Templated, Evented], {
        templateString: template,
        minSearchLength: 2,
        filter: '',
        filterCollection: null,
        offset: null,
        loading: null,
        moreResultsToShow: true,
        scrollableContainer: null,
        noResultsFound: null,
        loadingContainer: null,
        limit: null,
        icon: null,
        windowHeightAdjustment: 0,

        constructor: function() {
            this.results = [];
        },

        postCreate: function() {
            this.clickListener = on.pausable(
                window,
                'mousedown',
                function(e) {
                    if(!this._isMenuElement(e.target)) {
                        this.close();
                    }
                }.bind(this)
            );

            this.clickListener.pause();
        },

        open: function() {
            if(this.isOpen()) {
                return;
            }

            domClass.add(this.domNode, 'open');
            this._reset();
            this.clickListener.resume();
            this._request();
            this._ensureInView();
        },

        close: function() {
            if(!this.isOpen()) {
                return;
            }

            domClass.remove(this.domNode, 'open');
            this.clickListener.pause();
            this.onClose();
        },

        isOpen: function() {
            return domClass.contains(
                this.domNode,
                'open'
            );
        },

        search: function(value) {
            if (!(value?.length >= this.minSearchLength)) {
                this.close();
                return;
            }

            if(!this.isOpen()) {
                domClass.add(this.domNode, 'open');
                this.clickListener.resume();
                this._reset();
            }
            this.searchTimeout && clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(function() {
                this._applyFilter(value)
            }.bind(this), 500);
        },

        destroyRecursive: function() {
            if (this.clickListener) {
                this.clickListener.remove();
                this.clickListener = null;
            }

            this._destroyResults();
            this.inherited(arguments);
            this.domNode.remove();
            this.domNode.innerHTML = '';
            this.domNode = null;
        },

        _applyFilter: function(filter) {
            this._reset();
            this.filter = filter;
            this._request();
        },

        _scroll: function(e) {
            e.stopPropagation();

            if(!this.moreResultsToShow || this.loading) {
                return;
            }

            if(this._isScrolledToBottom(e)) {
                this.offset += this.limit;
                this._request();
            }
        },

        _request: function() {
            this.loading = true;

            const requestPromise = new Deferred();

            requestPromise.then(function(results) {
                this.loading = false;
                this._loadResults(results);
                this._highlightFilteredText();
                setTimeout(function() {
                    this._ensureInView();
                }.bind(this));
            }.bind(this));

            this.query(requestPromise, {
                filter: this.filter,
                limit: this.limit,
                offset: this.offset,
                filterCollection: this.filterCollection
            });
        },

        _loadResults: function(results) {
            if(!results.length || results.length < this.limit) {
                this.moreResultsToShow = false;
                domClass.add(this.loadingContainer, 'no-more-results');

                if (!results.length && !this.results.length) {
                    domClass.add(this.noResultsFound, 'show');
                    this.emit('NO_RESULTS_FOUND');
                }
            }

            results.forEach(this._createWidget.bind(this));
        },

        _createWidget: function(result) {
            const widget = new Result({
                data: {
                    icon: this.icon,
                    result: result,
                    searchAttr: this.searchAttr
                },
                onClick: this._onClick.bind(this)
            });

            widget.placeAt(this.resultsContainer);
            this.results.push(widget);
        },

        _onClick: function(result) {
            this.filter = result.getDisplayedValue();
            this.onClick(result.data.result);
            this.close();
        },

        _reset: function() {
            this.loading = false;
            this.moreResultsToShow = true;
            this.offset = 0;
            this.filter = '';
            this.scrollableContainer.scrollTop = 0;
            domClass.remove(this.noResultsFound, 'show');
            domClass.remove(this.loadingContainer, 'no-more-results');

            this._destroyResults();
        },

        _destroyResults: function() {
            this.results.forEach(function(result) {
                result.destroyRecursive();
            });

            this.results =  [];
            this.resultsContainer.innerHTML = '';
        },

        _isMenuElement: function(element) {
            return this.domNode.parentNode.contains(element);
        },

        _highlightFilteredText: function() {
            this.results.forEach(function(result) {
                result.removeHighlight();
            });

            this.results.forEach(function(result) {
                if(this.filter && this.filter.trim()) {
                    result.applyHighlight(this.filter);
                }
            }.bind(this));
        },

        _isScrolledToBottom: function(e) {
            return e.target.scrollTop >= e.target.scrollHeight
                - e.target.offsetHeight - 30;
        },

        _ensureInView: function() {
            const windowHeight = window.innerHeight + this.windowHeightAdjustment;
            const menuPosition = domGeometry.position(this.domNode);
            const menuBottom = menuPosition.y + menuPosition.h;

            if(menuBottom > windowHeight) {
                this.domNode.scrollIntoView(false);
            }
        }
    });
});
},
'style-guide/v1/forms/searchable-select/Result':function(){
define([
    'dijit/_WidgetBase',
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dojo/dom-class',
    'dojo/text!./template/Result.html',
    'soso/sosox/ejs/_Templated'
], function(
    WidgetBase,
    declare,
    lang,
    domClass,
    template,
    Templated
) {
    return declare([WidgetBase, Templated], {
        templateString: template,
        textContainer: null,

        data: {
            searchAttr: null,
            result: {}
        },

        onClick: function() {},

        _onClick: function() {
            this.onClick(this);
        },

        getDisplayedValue: function() {
            if(this.data.searchAttr instanceof Function) {
                return this.data.searchAttr(this.data.result);
            } else {
                return this.data.result[this.data.searchAttr];
            }
        },

        applyHighlight: function(filter) {
            let originalText = this.getDisplayedValue();

            const expression = new RegExp('(' + filter + ')', 'ig');
            this.textContainer.innerHTML = originalText.replace(expression, '<span class="highlight">$1</span>');
        },

        removeHighlight: function() {
            this.textContainer.innerHTML = this.getDisplayedValue();
        },

        destroyRecursive: function() {
            this.inherited(arguments);
            this.domNode.remove();
            this.domNode.innerHTML = '';
            this.domNode = null;
        },

        _getSelectedAttr: function() {
            return this.isSelected();
        },
    });
});
},
'@lib/doc-control/document/template/field/PresetFieldCollectionBuilder':function(){
define(["require", "exports", "@lib/doc-control/document/template/field/preset/DrawingDiscipline", "@lib/doc-control/document/template/field/preset/NodeReference", "@lib/doc-control/document/template/field/preset/ProjectNumber", "@lib/doc-control/document/template/field/preset/Reference", "@lib/doc-control/document/template/field/preset/RelevantDate", "@lib/doc-control/document/template/field/preset/RevisionNumber", "@lib/doc-control/document/template/field/preset/RevisionNumberWithStatus", "@lib/doc-control/document/template/field/preset/Status", "@lib/doc-control/document/template/field/preset/Title"], function (require, exports, DrawingDiscipline, NodeReference, ProjectNumber, Reference, RelevantDate, RevisionNumber, RevisionNumberWithStatus, Status, Title) {
    "use strict";
    class PresetFieldCollection {
        get() {
            return [
                new Title(),
                new RelevantDate(),
                new ProjectNumber(),
                new Reference(),
                new RevisionNumber(),
                new RevisionNumberWithStatus(),
                new Status(),
                new DrawingDiscipline(),
                new NodeReference()
            ];
        }
    }
    return PresetFieldCollection;
});

},
'@lib/doc-control/document/template/field/preset/DrawingDiscipline':function(){
define(["require", "exports", "@lib/doc-control/document/template/field/PresetField", "@lib/doc-control/document/template/field/RegistrationFields", "@lib/doc-control/document/template/field/DataTypes"], function (require, exports, PresetField, REGISTRATION_FIELDS, DATA_TYPE) {
    "use strict";
    class DrawingDiscipline extends PresetField {
        constructor() {
            super(REGISTRATION_FIELDS.DISCIPLINE, 'Drawing Discipline', 'A drawing discipline code for a drawing type document', DATA_TYPE.TEXT);
        }
    }
    return DrawingDiscipline;
});

},
'@lib/doc-control/document/template/field/PresetField':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class PresetField {
        constructor(refersTo, label, description, type) {
            this.refersTo = refersTo;
            this.label = label;
            this.description = description;
            this.type = type;
        }
        getRefersTo() {
            return this.refersTo;
        }
        getLabel() {
            return this.label;
        }
        getDescription() {
            return this.description;
        }
        getType() {
            return this.type;
        }
    }
    return PresetField;
});

},
'@lib/doc-control/document/template/field/RegistrationFields':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    return {
        TITLE: 'title',
        DATE: 'date',
        REFERENCE: 'reference',
        REVISION: 'revision',
        REVISION_WITH_STATUS: 'revisionWithStatus',
        STATUS: 'status',
        DISCIPLINE: 'discipline',
        PROJECT_NUMBER: 'projectNumber',
        NODE_REFERENCE: 'nodeReference'
    };
});

},
'@lib/doc-control/document/template/field/DataTypes':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    return {
        CONTRACT_NUMBER: 'contract_number',
        DATE: 'date',
        NUMBER: 'number',
        TEXT: 'text'
    };
});

},
'@lib/doc-control/document/template/field/preset/NodeReference':function(){
define(["require", "exports", "@lib/doc-control/document/template/field/PresetField", "@lib/doc-control/document/template/field/RegistrationFields", "@lib/doc-control/document/template/field/DataTypes"], function (require, exports, PresetField, REGISTRATION_FIELDS, DATA_TYPE) {
    "use strict";
    class NodeReference extends PresetField {
        constructor() {
            super(REGISTRATION_FIELDS.NODE_REFERENCE, 'File Location Reference', 'A reference used to name created file locations', DATA_TYPE.TEXT);
        }
    }
    return NodeReference;
});

},
'@lib/doc-control/document/template/field/preset/ProjectNumber':function(){
define(["require", "exports", "@lib/doc-control/document/template/field/PresetField", "@lib/doc-control/document/template/field/RegistrationFields", "@lib/doc-control/document/template/field/DataTypes"], function (require, exports, PresetField, REGISTRATION_FIELDS, DATA_TYPE) {
    "use strict";
    class ProjectNumber extends PresetField {
        constructor() {
            super(REGISTRATION_FIELDS.PROJECT_NUMBER, 'Project Number', 'A contract number for a project stage e.g. "C1234"', DATA_TYPE.CONTRACT_NUMBER);
        }
    }
    return ProjectNumber;
});

},
'@lib/doc-control/document/template/field/preset/Reference':function(){
define(["require", "exports", "@lib/doc-control/document/template/field/PresetField", "@lib/doc-control/document/template/field/RegistrationFields", "@lib/doc-control/document/template/field/DataTypes"], function (require, exports, PresetField, REGISTRATION_FIELDS, DATA_TYPE) {
    "use strict";
    class Reference extends PresetField {
        constructor() {
            super(REGISTRATION_FIELDS.REFERENCE, 'Reference', 'A reference', DATA_TYPE.TEXT);
        }
    }
    return Reference;
});

},
'@lib/doc-control/document/template/field/preset/RelevantDate':function(){
define(["require", "exports", "@lib/doc-control/document/template/field/PresetField", "@lib/doc-control/document/template/field/RegistrationFields", "@lib/doc-control/document/template/field/DataTypes"], function (require, exports, PresetField, REGISTRATION_FIELDS, DATA_TYPE) {
    "use strict";
    class RelevantDate extends PresetField {
        constructor() {
            super(REGISTRATION_FIELDS.DATE, 'Relevant Date', 'A date relevant to the documents creation', DATA_TYPE.DATE);
        }
    }
    return RelevantDate;
});

},
'@lib/doc-control/document/template/field/preset/RevisionNumber':function(){
define(["require", "exports", "@lib/doc-control/document/template/field/PresetField", "@lib/doc-control/document/template/field/RegistrationFields", "@lib/doc-control/document/template/field/DataTypes"], function (require, exports, PresetField, REGISTRATION_FIELDS, DATA_TYPE) {
    "use strict";
    class RevisionNumber extends PresetField {
        constructor() {
            super(REGISTRATION_FIELDS.REVISION, 'Revision Number', 'A revision number', DATA_TYPE.TEXT);
        }
    }
    return RevisionNumber;
});

},
'@lib/doc-control/document/template/field/preset/RevisionNumberWithStatus':function(){
define(["require", "exports", "@lib/doc-control/document/template/field/PresetField", "@lib/doc-control/document/template/field/RegistrationFields", "@lib/doc-control/document/template/field/DataTypes"], function (require, exports, PresetField, REGISTRATION_FIELDS, DATA_TYPE) {
    "use strict";
    class RevisionNumberWithStatus extends PresetField {
        constructor() {
            super(REGISTRATION_FIELDS.REVISION_WITH_STATUS, 'Revision Number with Status', 'A revision number that will be concatenated with a status code if one is extracted', DATA_TYPE.TEXT);
        }
    }
    return RevisionNumberWithStatus;
});

},
'@lib/doc-control/document/template/field/preset/Status':function(){
define(["require", "exports", "@lib/doc-control/document/template/field/PresetField", "@lib/doc-control/document/template/field/RegistrationFields", "@lib/doc-control/document/template/field/DataTypes"], function (require, exports, PresetField, REGISTRATION_FIELDS, DATA_TYPE) {
    "use strict";
    class Status extends PresetField {
        constructor() {
            super(REGISTRATION_FIELDS.STATUS, 'Status', 'A status code for a revisionable or drawing type document', DATA_TYPE.TEXT);
        }
    }
    return Status;
});

},
'@lib/doc-control/document/template/field/preset/Title':function(){
define(["require", "exports", "@lib/doc-control/document/template/field/PresetField", "@lib/doc-control/document/template/field/RegistrationFields", "@lib/doc-control/document/template/field/DataTypes"], function (require, exports, PresetField, REGISTRATION_FIELDS, DATA_TYPE) {
    "use strict";
    class Title extends PresetField {
        constructor() {
            super(REGISTRATION_FIELDS.TITLE, 'Title', 'The title of the document', DATA_TYPE.TEXT);
        }
    }
    return Title;
});

},
'doccontrol/document/template/dojo/Viewer':function(){
define([
    '../Topics',
    'dojo/_base/declare',
    'dojo/Deferred',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/dom-construct',
    'dojo/dom-style',
    'dojo/html',
    'dojo/text!./templates/ViewerDialog.html',
    'dojo/topic',
    'dijit/form/NumberTextBox',
    'soso/sosox/ejs/_Templated',
    'style-guide/v1/layout/DojoDialog',
    'doccontrol/viewer/dojo/_resizeMixin',
    'doccontrol/viewer/dojo/_scalingMixin',
    'pdf/Viewer'
], function(
    TOPICS,
    declare,
    Deferred,
    domAttr,
    domClass,
    domConstruct,
    domStyle,
    html,
    DialogTemplate,
    topic,
    NumberTextBox,
    Templated,
    DojoDialog,
    _resizeMixin,
    _scalingMixin,
    pdfViewer
) {
    const Viewer = function() {
        const View = declare([DojoDialog, _resizeMixin, _scalingMixin, Templated], {
            templateString: DialogTemplate,
            draggable: false,

            totalPages: 1,
            page: 1,
            scale: null,
            rotate: 0,
            passwordPromise: null,
            pageNumberToChangeToOnLoad: null,

            postCreate: function() {
                this.inherited(arguments);
                this._createScrollEvents();
            },

            _createScrollEvents: function() {
                let touch = false;
                let lastClientX;
                let lastClientY;

                this.scrollContainer.addEventListener('touchstart', function(evt) {
                    touch = true;
                    lastClientX = evt.touches[0].clientX;
                    lastClientY = evt.touches[0].clientY;
                });
                this.scrollContainer.addEventListener('touchend', function(evt) {
                    touch = false;
                });
                this.scrollContainer.addEventListener('touchmove', function(evt) {
                    if (touch && !this._isInSelectionMode()) {
                        this.scrollContainer.scrollLeft += (lastClientX - evt.changedTouches[0].clientX);
                        lastClientX = evt.changedTouches[0].clientX;
                        this.scrollContainer.scrollTop += (lastClientY - evt.changedTouches[0].clientY);
                        lastClientY = evt.changedTouches[0].clientY;
                    }
                }.bind(this));
            },

            destroyRecursive: function() {
                this.inherited(arguments);
                domConstruct.destroy(this.domNode);

                if (this.passwordPromise) {
                    this.passwordPromise.cancel();
                    delete this.passwordPromise;
                }
            },

            _isInSelectionMode: function() {
                return domClass.contains(this.documentWorkspace, 'selection-source-container');
            },

            enterSelectionMode: function() {
                domClass.add(this.documentWorkspace, 'selection-source-container');
            },

            exitSelectionMode: function() {
                domClass.remove(this.documentWorkspace, 'selection-source-container');
            },

            fitToPage: function() {
                this.scaleDirection = this.constants.SCALE_DIRECTION_PAGE;
                return this._calculateScale();
            },

            fitToWidth: function() {
                this.scaleDirection = this.constants.SCALE_DIRECTION_WIDTH;
                return this._calculateScale();
            },

            hideViewer: function() {
                topic.publish(TOPICS.DOCUMENT_TEMPLATE_VIEWER_HIDE);
            },

            hide: function() {
                this.inherited(arguments).then(this.destroyRecursive.bind(this));
            },

            hideLoading: function() {
                domClass.add(this.loadingContainer, 'hidden');
            },

            render: function() {
                this._hideDocument();
                this._showRendering();
                this.scrollContainer.scrollTop = 0;
                this._determineFooterVisibility();
                this._disableFooter();

                if (this.image) {
                    return this._renderImage();
                }

                if (this.pdfDocument) {
                    return this._renderPdf();
                }

                // returns rejected promise for invalid file type.... shouldn't be needed? Handled in TopicSubscriber
                return new Promise(function(resolve, reject) {
                    reject('Invalid file type');
                });
            },

            setDataUrl: function(dataUrl) {
                this.pdfDocument = null;
                this.rotate = 0;
                this.page = 1;

                this.imgCanvas = domConstruct.create('canvas', {}, this.documentNode, 'only');
                this.imgCtx = this.imgCanvas.getContext('2d');

                return new Promise(function(resolve, reject) {
                    this.image = new Image();
                    this.image.onload = function() {
                        this.fitToPage().then(resolve);
                    }.bind(this);
                    this.image.onerror = reject;
                    this.image.src = dataUrl;
                }.bind(this));
            },

            setPdf: function(pdfDocument) {
                this.pdfDocument = pdfDocument;
                this.image = null;

                this.page = 1;
                this.rotate = 0;
                this.totalPages = parseInt(this.pdfDocument.numPages);
                this.pageCount.textContent = this.totalPages;
                this._createPageInput();

                return this.fitToPage();
            },

            setPageNumber: function(pageNumber) {
                if (this.pageInput) {
                    this.pageInput.set('value', pageNumber);
                } else {
                    this.pageNumberToChangeToOnLoad = pageNumber;
                }
            },

            showDeletedMessage: function() {
                domClass.add(this.loading, 'hidden');
                domClass.remove(this.deletedMessage, 'hidden');
            },

            showNetworkErrorMessage: function() {
                domClass.add(this.loading, 'hidden');
                domClass.remove(this.networkErrorMessage, 'hidden');
            },

            showRenderErrorMessage: function() {
                domClass.add(this.loading, 'hidden');
                domClass.remove(this.renderErrorMessage, 'hidden');
            },

            showPasswordForm: function(prompt) {
                if (this.passwordPromise) {
                    domClass.add(this.passwordInputValidationContainer, 'sos-form-textfield-validation-error');
                    html.set(this.passwordPrompt, prompt);
                }

                domClass.add(this.loading, 'hidden');
                domClass.remove(this.passwordForm, 'hidden');
                this.passwordInput.value = '';
                this.passwordInput.focus();

                return this.passwordPromise = new Deferred();
            },

            showUnauthorisedMessage: function() {
                domClass.add(this.loading, 'hidden');
                domClass.remove(this.unauthorisedMessage, 'hidden');
            },

            showProcessingMessage: function() {
                domClass.remove(this.processingContainer, 'hidden');
            },

            hideProcessingMessage: function() {
                domClass.add(this.processingContainer, 'hidden');
            },

            showToolbar: function() {
                domClass.add(this.dialogContent, 'toolbar-showing');
                this._automargin();
            },

            _automargin: function() {
                domStyle.set(
                    this.documentWorkspace,
                    'margin-top',
                    Math.max(0, Math.floor((this._getScrollContainerContentHeight() - this.documentHeight) / 2)) + 'px'
                );
            },

            _calculateScale: function() {
                if (this.image) {
                    const width = this.rotate % 180 === 0 ? this.image.naturalWidth : this.image.naturalHeight;
                    const height = this.rotate % 180 === 0 ? this.image.naturalHeight : this.image.naturalWidth;

                    this.scale = this._getCalculatedScale(width, height);

                    return new Promise(function(resolve, reject) {
                        resolve(this.scale);
                    }.bind(this));
                }

                if (this.pdfDocument) {
                    return this.pdfDocument.getPage(this.page).then(function (page) {
                        const rotate = (page.rotate + this.rotate) % 360;

                        const originalSize = page.getViewport({ scale: 1, rotation: rotate });

                        return this.scale = this._getCalculatedScale(originalSize.width, originalSize.height);
                    }.bind(this));
                }
            },

            _createPageInput: function() {
                this.pageInput = new NumberTextBox({
                    'class': 'sos-form-textfield sos-form-textfield-s sos-form-textfield-validation sos-form-textfield-validation-s',
                    style: 'min-width: 4em; width: 4em',
                    constraints: { min: 1, max: this.totalPages },
                    value: 1
                }, this.pageInputNode);

                this.pageInput.on('keyup', function(key) {
                    if (key.key === 'Enter') {
                        this.pageInput._hasBeenBlurred = true;
                        if (this.pageInput.validate()) {
                            this.page = parseInt(this.pageInput.get('value'));
                            topic.publish(TOPICS.DOCUMENT_TEMPLATE_VIEWER_RENDER);
                        }
                    }
                }.bind(this));

                this.pageInput.on('change', function(value) {
                    this.pageInput._hasBeenBlurred = true;
                    if (this.pageInput.validate()) {
                        this.page = parseInt(value);
                        topic.publish(TOPICS.DOCUMENT_TEMPLATE_VIEWER_RENDER);
                    }
                }.bind(this));
            },

            _determineFooterVisibility: function() {
                domClass.toggle(this.domNode, 'multipage', this.totalPages > 1);
            },

            _disableFooter: function() {
                domAttr.set(this.nextButton, 'disabled', true);
                domAttr.set(this.previousButton, 'disabled', true);
                if (this.pageInput) {
                    this.pageInput.set('disabled', true);
                }
            },

            _enableFooter: function() {
                domAttr.set(this.nextButton, 'disabled', this.page === this.totalPages);
                domAttr.set(this.previousButton, 'disabled', this.page === 1);
                if (this.pageInput) {
                    this.pageInput.set('disabled', false);
                }
            },

            _next: function() {
                if (this.page >= this.totalPages) {
                    return;
                }
                this.page++;
                this.pageInput.set('value', this.page);
            },

            _previous: function() {
                if (this.page <= 1) {
                    return;
                }
                this.page--;
                this.pageInput.set('value', this.page);
            },

            _renderImage: function() {
                let width = this.image.naturalWidth * this.scale;
                let height = this.image.naturalHeight * this.scale;
                if (this.rotate % 180 !== 0) {
                    width = this.image.naturalHeight * this.scale;
                    height = this.image.naturalWidth * this.scale;
                }

                this.imgCanvas.width = width;
                this.imgCanvas.height = height;

                this.imgCtx.translate(width / 2, height / 2);
                this.imgCtx.rotate(this.rotate * Math.PI / 180);
                this.imgCtx.drawImage(
                    this.image,
                    -this.image.naturalWidth * this.scale / 2,
                    -this.image.naturalHeight * this.scale / 2,
                    this.image.naturalWidth * this.scale,
                    this.image.naturalHeight * this.scale
                );

                // this.imgCtx.rotate(-this.rotate * Math.PI / 180);
                // this.imgCtx.translate(-width / 2, -height / 2); // @todo - check if resetting the ctx is required for region selection

                domStyle.set(this.documentWorkspace, {
                    width: width + 'px',
                    height: height + 'px'
                });

                this.documentHeight = height;
                this._automargin();

                this.hideLoading();
                this._hideRendering();
                this._showDocument();

                return new Promise(function(resolve, reject) {
                    resolve(this.imgCanvas);
                }.bind(this));
            },

            _renderPdf: function() {
                domConstruct.empty(this.documentNode);
                this._showRendering();

                return this.pdfDocument.getPage(this.page).then(function(page) {
                    const viewport = page.getViewport({ scale: this.scale, rotation: (page.rotate + this.rotate) % 360 });

                    domStyle.set(this.documentWorkspace, {
                        height: Math.floor(viewport.height) + 'px',
                        width: Math.floor(viewport.width) + 'px'
                    });

                    this.documentHeight = viewport.height;
                    this._automargin();

                    return (new pdfViewer(this.documentNode)).view(page, this.scale, this.rotate);
                }.bind(this)).then(function(canvas) {
                    this._hideRendering();
                    this._showDocument();
                    this._enableFooter();

                    if (this.pageNumberToChangeToOnLoad) {
                        this.setPageNumber(this.pageNumberToChangeToOnLoad);
                        this.pageNumberToChangeToOnLoad = null;
                    }

                    return canvas;
                }.bind(this));
            },

            _hideRendering: function() {
                domClass.add(this.loadingContainer, 'hidden');
                domClass.add(this.rendering, 'hidden');
            },

            _showRendering: function() {
                domClass.add(this.loadingContainer, 'hidden');
                domClass.remove(this.rendering, 'hidden');
            },

            _hideDocument: function() {
                domClass.add(this.documentNode, 'hidden');
                domClass.add(this.contentContainer, 'invisible');
            },

            _showDocument: function() {
                domClass.remove(this.documentNode, 'hidden');
                domClass.remove(this.contentContainer, 'invisible');
            },

            _setPassword: function() {
                this.passwordPromise.resolve(this.passwordInput.value);
            }
        });

        this.view = new View();
        this.view.startup();
        this.view.show();
    };

    Viewer.prototype.enterSelectionMode = function() {
        this.view.enterSelectionMode();
    };

    Viewer.prototype.exitSelectionMode = function() {
        this.view.exitSelectionMode();
    };

    Viewer.prototype.fitToPage = function() {
        return this.view.fitToPage();
    };

    Viewer.prototype.fitToWidth = function() {
        return this.view.fitToWidth();
    };

    Viewer.prototype.getDialogToolbarNode = function() {
        return this.view.dialogToolbarNode;
    };

    Viewer.prototype.getTemplaterNode = function() {
        return this.view.templaterNode;
    };

    Viewer.prototype.getViewOptionsToolbarNode = function() {
        return this.view.viewOptionsToolbarNode;
    };

    Viewer.prototype.getScale = function() {
        return this.view.scale;
    };

    Viewer.prototype.getPageNumber = function() {
        return this.view.page;
    };

    Viewer.prototype.setPageNumber = function (pageNumber) {
        this.view.setPageNumber(pageNumber);
    };

    Viewer.prototype.hide = function() {
        this.view.hide();
    };

    Viewer.prototype.render = function() {
        return this.view.render();
    };

    Viewer.prototype.rotate = function(rotation) {
        this.view.rotate = rotation;
    };

    Viewer.prototype.scale = function(scale) {
        this.view.scale = scale;
    };

    Viewer.prototype.setImage = function(dataUrl) {
        return this.view.setDataUrl(dataUrl);
    };

    Viewer.prototype.setPdf = function(pdfDocument) {
        return this.view.setPdf(pdfDocument);
    };

    Viewer.prototype.showDeletedMessage = function() {
        this.view.showDeletedMessage();
    };

    Viewer.prototype.showNetworkErrorMessage = function() {
        this.view.showNetworkErrorMessage();
    };

    Viewer.prototype.showRenderErrorMessage = function() {
        this.view.showRenderErrorMessage();
    };

    Viewer.prototype.showPasswordForm = function(prompt) {
        return this.view.showPasswordForm(prompt);
    };

    Viewer.prototype.showUnauthorisedMessage = function() {
        this.view.showUnauthorisedMessage();
    };

    Viewer.prototype.showProcessingMessage = function() {
        this.view.showProcessingMessage();
    };

    Viewer.prototype.hideProcessingMessage = function() {
        this.view.hideProcessingMessage();
    };

    Viewer.prototype.showToolbar = function() {
        this.view.showToolbar();
    };

    return Viewer;
});
},
'style-guide/v1/layout/DojoDialog':function(){
define([
    'dojo/dom-class',
    'dojo/on',
    'dojo/query',
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dijit/Dialog',
    'dijit/DialogUnderlay',
    './_dialogCheckerMixin',
    'dojo/NodeList-dom'
], function(
    domClass,
    on,
    query,
    declare,
    lang,
    Dialog,
    DialogUnderlay,
    _dialogCheckerMixin
) {
    const CLASSNAME_HIDE_SCROLLBARS = 'sos-dialog-hide-scroll-bars';

    /**
     * @deprecated please use style-guide/v1/layout/Dialog
     */
    return declare('style-guide.v1.layout.dialog', [Dialog, _dialogCheckerMixin], {
        underlayClickHandle: null,

        show: function() {
            query('html').addClass('sos-dialog-hide-scroll-bars');
            domClass.replace(this.domNode, 'sos-dialog-open', 'hide');
            this.inherited(arguments);

            if (this.closable) {
                this.underlayClickHandle = on(DialogUnderlay._singleton, 'click', lang.hitch(this, this.hide));
            }
        },

        hide: function() {
            const promise = this.inherited(arguments);
            domClass.replace(this.domNode, 'hide', 'sos-dialog-open');

            if (!this.areDialogsOpen()) {
                query('html').removeClass(CLASSNAME_HIDE_SCROLLBARS);
            }

            if (this.underlayClickHandle) {
                this.underlayClickHandle.remove();
            }

            return promise;
        }
    });
});


},
'dijit/Dialog':function(){
define([
	"require",
	"dojo/_base/array", // array.forEach array.indexOf array.map
	"dojo/aspect",
	"dojo/_base/declare", // declare
	"dojo/Deferred", // Deferred
	"dojo/dom", // dom.isDescendant
	"dojo/dom-class", // domClass.add domClass.contains
	"dojo/dom-geometry", // domGeometry.position
	"dojo/dom-style", // domStyle.set
	"dojo/_base/fx", // fx.fadeIn fx.fadeOut
	"dojo/i18n", // i18n.getLocalization
	"dojo/keys",
	"dojo/_base/lang", // lang.mixin lang.hitch
	"dojo/on",
	"dojo/ready",
	"dojo/sniff", // has("ie") has("opera") has("dijit-legacy-requires")
	"dojo/touch",
	"dojo/window", // winUtils.getBox, winUtils.get
	"dojo/dnd/Moveable", // Moveable
	"dojo/dnd/TimedMoveable", // TimedMoveable
	"./focus",
	"./_base/manager", // manager.defaultDuration
	"./_Widget",
	"./_TemplatedMixin",
	"./_CssStateMixin",
	"./form/_FormMixin",
	"./_DialogMixin",
	"./DialogUnderlay",
	"./layout/ContentPane",
	"./layout/utils",
	"dojo/text!./templates/Dialog.html",
	"./a11yclick",	// template uses ondijitclick
	"dojo/i18n!./nls/common"
], function(require, array, aspect, declare, Deferred,
			dom, domClass, domGeometry, domStyle, fx, i18n, keys, lang, on, ready, has, touch, winUtils,
			Moveable, TimedMoveable, focus, manager, _Widget, _TemplatedMixin, _CssStateMixin, _FormMixin, _DialogMixin,
			DialogUnderlay, ContentPane, utils, template){

	// module:
	//		dijit/Dialog

	var resolvedDeferred = new Deferred();
	resolvedDeferred.resolve(true);

	function nop(){}

	var _DialogBase = declare("dijit._DialogBase" + (has("dojo-bidi") ? "_NoBidi" : ""), [_TemplatedMixin, _FormMixin, _DialogMixin, _CssStateMixin], {
		templateString: template,

		baseClass: "dijitDialog",

		cssStateNodes: {
			closeButtonNode: "dijitDialogCloseIcon"
		},

		// Map widget attributes to DOMNode attributes.
		_setTitleAttr: { node: "titleNode", type: "innerHTML" },

		// open: [readonly] Boolean
		//		True if Dialog is currently displayed on screen.
		open: false,

		// duration: Integer
		//		The time in milliseconds it takes the dialog to fade in and out
		duration: manager.defaultDuration,

		// refocus: Boolean
		//		A Toggle to modify the default focus behavior of a Dialog, which
		//		is to re-focus the element which had focus before being opened.
		//		False will disable refocusing. Default: true
		refocus: true,

		// autofocus: Boolean
		//		A Toggle to modify the default focus behavior of a Dialog, which
		//		is to focus on the first dialog element after opening the dialog.
		//		False will disable autofocusing. Default: true
		autofocus: true,

		// _firstFocusItem: [private readonly] DomNode
		//		The pointer to the first focusable node in the dialog.
		//		Set by `dijit/_DialogMixin._getFocusItems()`.
		_firstFocusItem: null,

		// _lastFocusItem: [private readonly] DomNode
		//		The pointer to which node has focus prior to our dialog.
		//		Set by `dijit/_DialogMixin._getFocusItems()`.
		_lastFocusItem: null,

		// draggable: Boolean
		//		Toggles the movable aspect of the Dialog. If true, Dialog
		//		can be dragged by it's title. If false it will remain centered
		//		in the viewport.
		draggable: true,
		_setDraggableAttr: function(/*Boolean*/ val){
			// Avoid _WidgetBase behavior of copying draggable attribute to this.domNode,
			// as that prevents text select on modern browsers (#14452)
			this._set("draggable", val);
		},

		// maxRatio: Number
		//		Maximum size to allow the dialog to expand to, relative to viewport size
		maxRatio: 0.9,

		// closable: Boolean
		//		Dialog show [x] icon to close itself, and ESC key will close the dialog.
		closable: true,
		_setClosableAttr: function(val){
			this.closeButtonNode.style.display = val ? "" : "none";
			this._set("closable", val);
		},

		postMixInProperties: function(){
			var _nlsResources = i18n.getLocalization("dijit", "common");
			lang.mixin(this, _nlsResources);
			this.inherited(arguments);
		},

		postCreate: function(){
			domStyle.set(this.domNode, {
				display: "none",
				position: "absolute"
			});
			this.ownerDocumentBody.appendChild(this.domNode);

			this.inherited(arguments);

			aspect.after(this, "onExecute", lang.hitch(this, "hide"), true);
			aspect.after(this, "onCancel", lang.hitch(this, "hide"), true);
			on(this.closeButtonNode, touch.press, function(e){
				e.stopPropagation();
			});

			this._modalconnects = [];
		},

		onLoad: function(){
			// summary:
			//		Called when data has been loaded from an href.
			//		Unlike most other callbacks, this function can be connected to (via `dojo.connect`)
			//		but should *not* be overridden.
			// tags:
			//		callback

			// when href is specified we need to reposition the dialog after the data is loaded
			// and find the focusable elements
			this.resize();
			this._position();

			if(this.autofocus && DialogLevelManager.isTop(this)){
				this._getFocusItems();
				focus.focus(this._firstFocusItem);
			}

			this.inherited(arguments);
		},

		focus: function(){
			this._getFocusItems();
			focus.focus(this._firstFocusItem);
		},

		_endDrag: function(){
			// summary:
			//		Called after dragging the Dialog. Saves the position of the dialog in the viewport,
			//		and also adjust position to be fully within the viewport, so user doesn't lose access to handle
			var nodePosition = domGeometry.position(this.domNode),
				viewport = winUtils.getBox(this.ownerDocument);
			nodePosition.y = Math.min(Math.max(nodePosition.y, 0), (viewport.h - nodePosition.h));
			nodePosition.x = Math.min(Math.max(nodePosition.x, 0), (viewport.w - nodePosition.w));
			this._relativePosition = nodePosition;
			this._position();
		},

		_setup: function(){
			// summary:
			//		Stuff we need to do before showing the Dialog for the first
			//		time (but we defer it until right beforehand, for
			//		performance reasons).
			// tags:
			//		private

			var node = this.domNode;

			if(this.titleBar && this.draggable){
				this._moveable = new ((has("ie") == 6) ? TimedMoveable // prevent overload, see #5285
					: Moveable)(node, { handle: this.titleBar });
				aspect.after(this._moveable, "onMoveStop", lang.hitch(this, "_endDrag"), true);
			}else{
				domClass.add(node, "dijitDialogFixed");
			}

			this.underlayAttrs = {
				dialogId: this.id,
				"class": array.map(this["class"].split(/\s/),function(s){
					return s + "_underlay";
				}).join(" "),
				_onKeyDown: lang.hitch(this, "_onKey"),
				ownerDocument: this.ownerDocument
			};
		},

		_size: function(){
			// TODO: remove for 2.0
			this.resize();
		},

		_position: function(){
			// summary:
			//		Position the dialog in the viewport.  If no relative offset
			//		in the viewport has been determined (by dragging, for instance),
			//		center the dialog.  Otherwise, use the Dialog's stored relative offset,
			//		clipped to fit inside the viewport (which may have been shrunk).
			//		Finally, adjust position according to viewport's scroll.

			if(!domClass.contains(this.ownerDocumentBody, "dojoMove")){    // don't do anything if called during auto-scroll
				var node = this.domNode,
					viewport = winUtils.getBox(this.ownerDocument),
					p = this._relativePosition,
					bb = domGeometry.position(node),
					l = Math.floor(viewport.l + (p ? Math.min(p.x, viewport.w - bb.w) : (viewport.w - bb.w) / 2)),
					t = Math.floor(viewport.t + (p ? Math.min(p.y, viewport.h - bb.h) : (viewport.h - bb.h) / 2));

				domStyle.set(node, {
					left: l + "px",
					top: t + "px"
				});
			}
		},

		_onKey: function(/*Event*/ evt){
			// summary:
			//		Handles the keyboard events for accessibility reasons
			// tags:
			//		private

			if(evt.keyCode == keys.TAB){
				this._getFocusItems();
				var node = evt.target;
				if(this._firstFocusItem == this._lastFocusItem){
					// don't move focus anywhere, but don't allow browser to move focus off of dialog either
					evt.stopPropagation();
					evt.preventDefault();
				}else if(node == this._firstFocusItem && evt.shiftKey){
					// if we are shift-tabbing from first focusable item in dialog, send focus to last item
					focus.focus(this._lastFocusItem);
					evt.stopPropagation();
					evt.preventDefault();
				}else if(node == this._lastFocusItem && !evt.shiftKey){
					// if we are tabbing from last focusable item in dialog, send focus to first item
					focus.focus(this._firstFocusItem);
					evt.stopPropagation();
					evt.preventDefault();
				}
			}else if(this.closable && evt.keyCode == keys.ESCAPE){
				this.onCancel();
				evt.stopPropagation();
				evt.preventDefault();
			}
		},

		show: function(){
			// summary:
			//		Display the dialog
			// returns: dojo/promise/Promise
			//		Promise object that resolves when the display animation is complete

			if(this.open){
				return resolvedDeferred.promise;
			}

			if(!this._started){
				this.startup();
			}

			// first time we show the dialog, there's some initialization stuff to do
			if(!this._alreadyInitialized){
				this._setup();
				this._alreadyInitialized = true;
			}

			if(this._fadeOutDeferred){
				// There's a hide() operation in progress, so cancel it, but still call DialogLevelManager.hide()
				// as though the hide() completed, in preparation for the DialogLevelManager.show() call below.
				this._fadeOutDeferred.cancel();
				DialogLevelManager.hide(this);
			}

			// Recenter Dialog if user scrolls browser.  Connecting to document doesn't work on IE, need to use window.
			// Be sure that event object doesn't get passed to resize() method, because it's expecting an optional
			// {w: ..., h:...} arg.
			var win = winUtils.get(this.ownerDocument);
			this._modalconnects.push(on(win, "scroll", lang.hitch(this, "resize", null)));

			this._modalconnects.push(on(this.domNode, "keydown", lang.hitch(this, "_onKey")));

			domStyle.set(this.domNode, {
				opacity: 0,
				display: ""
			});

			this._set("open", true);
			this._onShow(); // lazy load trigger

			this.resize();
			this._position();

			// fade-in Animation object, setup below
			var fadeIn;

			this._fadeInDeferred = new Deferred(lang.hitch(this, function(){
				fadeIn.stop();
				delete this._fadeInDeferred;
			}));
			this._fadeInDeferred.then(undefined, nop);	// avoid spurious CancelError message to console

			// If delay is 0, code below will delete this._fadeInDeferred instantly, so grab promise while we can.
			var promise = this._fadeInDeferred.promise;

			fadeIn = fx.fadeIn({
				node: this.domNode,
				duration: this.duration,
				beforeBegin: lang.hitch(this, function(){
					DialogLevelManager.show(this, this.underlayAttrs);
				}),
				onEnd: lang.hitch(this, function(){
					if(this.autofocus && DialogLevelManager.isTop(this)){
						// find focusable items each time dialog is shown since if dialog contains a widget the
						// first focusable items can change
						this._getFocusItems();
						focus.focus(this._firstFocusItem);
					}
					this._fadeInDeferred.resolve(true);
					delete this._fadeInDeferred;
				})
			}).play();

			return promise;
		},

		hide: function(){
			// summary:
			//		Hide the dialog
			// returns: dojo/promise/Promise
			//		Promise object that resolves when the display animation is complete

			// If we haven't been initialized yet then we aren't showing and we can just return.
			// Likewise if we are already hidden, or are currently fading out.
			if(!this._alreadyInitialized || !this.open){
				return resolvedDeferred.promise;
			}
			if(this._fadeInDeferred){
				this._fadeInDeferred.cancel();
			}

			// fade-in Animation object, setup below
			var fadeOut;

			this._fadeOutDeferred = new Deferred(lang.hitch(this, function(){
				fadeOut.stop();
				delete this._fadeOutDeferred;
			}));
			this._fadeOutDeferred.then(undefined, nop);	// avoid spurious CancelError message to console

			// fire onHide when the promise resolves.
			this._fadeOutDeferred.then(lang.hitch(this, 'onHide'));

			// If delay is 0, code below will delete this._fadeOutDeferred instantly, so grab promise while we can.
			var promise = this._fadeOutDeferred.promise;

			fadeOut = fx.fadeOut({
				node: this.domNode,
				duration: this.duration,
				onEnd: lang.hitch(this, function(){
					this.domNode.style.display = "none";
					DialogLevelManager.hide(this);
					this._fadeOutDeferred.resolve(true);
					delete this._fadeOutDeferred;
				})
			}).play();

			if(this._scrollConnected){
				this._scrollConnected = false;
			}
			var h;
			while(h = this._modalconnects.pop()){
				h.remove();
			}

			if(this._relativePosition){
				delete this._relativePosition;
			}
			this._set("open", false);

			return promise;
		},

		resize: function(dim){
			// summary:
			//		Called with no argument when viewport scrolled or viewport size changed.  Adjusts Dialog as
			//		necessary to keep it visible.
			//
			//		Can also be called with an argument (by dojox/layout/ResizeHandle etc.) to explicitly set the
			//		size of the dialog.
			// dim: Object?
			//		Optional dimension object like {w: 200, h: 300}

			if(this.domNode.style.display != "none"){

				this._checkIfSingleChild();

				if(!dim){
					if(this._shrunk){
						// If we earlier shrunk the dialog to fit in the viewport, reset it to its natural size
						if(this._singleChild){
							if(typeof this._singleChildOriginalStyle != "undefined"){
								this._singleChild.domNode.style.cssText = this._singleChildOriginalStyle;
								delete this._singleChildOriginalStyle;
							}
						}
						array.forEach([this.domNode, this.containerNode, this.titleBar, this.actionBarNode], function(node){
							if(node){	// because titleBar may not be defined
								domStyle.set(node, {
									position: "static",
									width: "auto",
									height: "auto"
								});
							}
						});
						this.domNode.style.position = "absolute";
					}

					// If necessary, shrink Dialog to fit in viewport and have some space around it
					// to indicate that it's a popup.  This will also compensate for possible scrollbars on viewport.
					var viewport = winUtils.getBox(this.ownerDocument);
					viewport.w *= this.maxRatio;
					viewport.h *= this.maxRatio;

					var bb = domGeometry.position(this.domNode);
					this._shrunk = false;
					// First check and limit width, because limiting the width may increase the height due to word wrapping.
					if(bb.w >= viewport.w){
						dim = {
							w: viewport.w
						};
						domGeometry.setMarginBox(this.domNode, dim);
						bb = domGeometry.position(this.domNode);
						this._shrunk = true;
					}
					// Now check and limit the height
					if(bb.h >= viewport.h){
						if(!dim){
							dim = {
								w: bb.w
							};
						}
						dim.h = viewport.h;
						this._shrunk = true;
					}
					if(dim){
						if(!dim.w){
							dim.w = bb.w;
						}
						if(!dim.h){
							dim.h = bb.h;
						}
					}
				}

				// Code to run if user has requested an explicit size, or the shrinking code above set an implicit size
				if(dim){
					// Set this.domNode to specified size
					domGeometry.setMarginBox(this.domNode, dim);

					// And then size this.containerNode
					var layoutNodes = [];
					if(this.titleBar){
						layoutNodes.push({domNode: this.titleBar, region: "top"});
					}
					if(this.actionBarNode){
						layoutNodes.push({domNode: this.actionBarNode, region: "bottom"});
					}
					var centerSize = {domNode: this.containerNode, region: "center"};
					layoutNodes.push(centerSize);

					var contentDim = utils.marginBox2contentBox(this.domNode, dim);
					utils.layoutChildren(this.domNode, contentDim, layoutNodes);

					// And then if this.containerNode has a single layout widget child, size it too.
					// Otherwise, make this.containerNode show a scrollbar if it's overflowing.
					if(this._singleChild){
						var cb = utils.marginBox2contentBox(this.containerNode, centerSize);
						// note: if containerNode has padding singleChildSize will have l and t set,
						// but don't pass them to resize() or it will doubly-offset the child
						this._singleChild.resize({w: cb.w, h: cb.h});
						// TODO: save original size for restoring it on another show()?
					}else{
						this.containerNode.style.overflow = "auto";
						this._layoutChildren();		// send resize() event to all child widgets
					}
				}else{
					this._layoutChildren();		// send resize() event to all child widgets
				}

				if(!has("touch") && !dim){
					// If the user has scrolled the viewport then reposition the Dialog.  But don't do it for touch
					// devices, because it will counteract when a keyboard pops up and then the browser auto-scrolls
					// the focused node into view.
					this._position();
				}
			}
		},

		_layoutChildren: function(){
			// Override _ContentPaneResizeMixin._layoutChildren because even when there's just a single layout child
			// widget, sometimes we don't want to size it explicitly (i.e. to pass a dim argument to resize())

			array.forEach(this.getChildren(), function(widget){
				if(widget.resize){
					widget.resize();
				}
			});
		},

		destroy: function(){
			if(this._fadeInDeferred){
				this._fadeInDeferred.cancel();
			}
			if(this._fadeOutDeferred){
				this._fadeOutDeferred.cancel();
			}
			if(this._moveable){
				this._moveable.destroy();
			}
			var h;
			while(h = this._modalconnects.pop()){
				h.remove();
			}

			DialogLevelManager.hide(this);

			this.inherited(arguments);
		}
	});

	if(has("dojo-bidi")){
		_DialogBase = declare("dijit._DialogBase", _DialogBase, {
			_setTitleAttr: function(/*String*/ title){
				this._set("title", title);
				this.titleNode.innerHTML = title;
				this.applyTextDir(this.titleNode);
			},

			_setTextDirAttr: function(textDir){
				if(this._created && this.textDir != textDir){
					this._set("textDir", textDir);
					this.set("title", this.title);
				}
			}
		});
	}

	var Dialog = declare("dijit.Dialog", [ContentPane, _DialogBase], {
		// summary:
		//		A modal dialog Widget.
		// description:
		//		Pops up a modal dialog window, blocking access to the screen
		//		and also graying out the screen Dialog is extended from
		//		ContentPane so it supports all the same parameters (href, etc.).
		// example:
		// |	<div data-dojo-type="dijit/Dialog" data-dojo-props="href: 'test.html'"></div>
		// example:
		// |	var foo = new Dialog({ title: "test dialog", content: "test content" });
		// |	foo.placeAt(win.body());
		// |	foo.startup();
	});
	Dialog._DialogBase = _DialogBase;	// for monkey patching and dojox/widget/DialogSimple

	var DialogLevelManager = Dialog._DialogLevelManager = {
		// summary:
		//		Controls the various active "levels" on the page, starting with the
		//		stuff initially visible on the page (at z-index 0), and then having an entry for
		//		each Dialog shown.

		_beginZIndex: 950,

		show: function(/*dijit/_WidgetBase*/ dialog, /*Object*/ underlayAttrs){
			// summary:
			//		Call right before fade-in animation for new dialog.
			//		Saves current focus, displays/adjusts underlay for new dialog,
			//		and sets the z-index of the dialog itself.
			//
			//		New dialog will be displayed on top of all currently displayed dialogs.
			//
			//		Caller is responsible for setting focus in new dialog after the fade-in
			//		animation completes.

			// Save current focus
			ds[ds.length - 1].focus = focus.curNode;

			// Set z-index a bit above previous dialog
			var zIndex = ds[ds.length - 1].dialog ? ds[ds.length - 1].zIndex + 2 : Dialog._DialogLevelManager._beginZIndex;
			domStyle.set(dialog.domNode, 'zIndex', zIndex);

			// Display the underlay, or if already displayed then adjust for this new dialog
			DialogUnderlay.show(underlayAttrs, zIndex - 1);

			ds.push({dialog: dialog, underlayAttrs: underlayAttrs, zIndex: zIndex});
		},

		hide: function(/*dijit/_WidgetBase*/ dialog){
			// summary:
			//		Called when the specified dialog is hidden/destroyed, after the fade-out
			//		animation ends, in order to reset page focus, fix the underlay, etc.
			//		If the specified dialog isn't open then does nothing.
			//
			//		Caller is responsible for either setting display:none on the dialog domNode,
			//		or calling dijit/popup.hide(), or removing it from the page DOM.

			if(ds[ds.length - 1].dialog == dialog){
				// Removing the top (or only) dialog in the stack, return focus
				// to previous dialog

				ds.pop();

				var pd = ds[ds.length - 1];	// the new active dialog (or the base page itself)

				// Adjust underlay
				if(ds.length == 1){
					// Returning to original page.  Hide the underlay.
					DialogUnderlay.hide();
				}else{
					// Popping back to previous dialog, adjust underlay.
					DialogUnderlay.show(pd.underlayAttrs, pd.zIndex - 1);
				}

				// Adjust focus.
				// TODO: regardless of setting of dialog.refocus, if the exeucte() method set focus somewhere,
				// don't shift focus back to button.  Note that execute() runs at the start of the fade-out but
				// this code runs later, at the end of the fade-out.  Menu has code like this.
				if(dialog.refocus){
					// If we are returning control to a previous dialog but for some reason
					// that dialog didn't have a focused field, set focus to first focusable item.
					// This situation could happen if two dialogs appeared at nearly the same time,
					// since a dialog doesn't set it's focus until the fade-in is finished.
					var focus = pd.focus;
					if(pd.dialog && (!focus || !dom.isDescendant(focus, pd.dialog.domNode))){
						pd.dialog._getFocusItems();
						focus = pd.dialog._firstFocusItem;
					}

					if(focus){
						// Refocus the button that spawned the Dialog.   This will fail in corner cases including
						// page unload on IE, because the dijit/form/Button that launched the Dialog may get destroyed
						// before this code runs.  (#15058)
						try{
							focus.focus();
						}catch(e){
						}
					}
				}
			}else{
				// Removing a dialog out of order (#9944, #10705).
				// Don't need to mess with underlay or z-index or anything.
				var idx = array.indexOf(array.map(ds, function(elem){
					return elem.dialog;
				}), dialog);
				if(idx != -1){
					ds.splice(idx, 1);
				}
			}
		},

		isTop: function(/*dijit/_WidgetBase*/ dialog){
			// summary:
			//		Returns true if specified Dialog is the top in the task
			return ds[ds.length - 1].dialog == dialog;
		}
	};

	// Stack representing the various active "levels" on the page, starting with the
	// stuff initially visible on the page (at z-index 0), and then having an entry for
	// each Dialog shown.
	// Each element in stack has form {
	//		dialog: dialogWidget,
	//		focus: returnFromGetFocus(),
	//		underlayAttrs: attributes to set on underlay (when this widget is active)
	// }
	var ds = Dialog._dialogStack = [
		{dialog: null, focus: null, underlayAttrs: null}    // entry for stuff at z-index: 0
	];

	// If focus was accidentally removed from the dialog, such as if the user clicked a blank
	// area of the screen, or clicked the browser's address bar and then tabbed into the page,
	// then refocus.   Won't do anything if focus was removed because the Dialog was closed, or
	// because a new Dialog popped up on top of the old one, or when focus moves to popups
	focus.watch("curNode", function(attr, oldNode, node){
 		// Note: if no dialogs, ds.length==1 but ds[ds.length-1].dialog is null
		var topDialog = ds[ds.length - 1].dialog;

		// If a node was focused, and there's a Dialog currently showing, and not in the process of fading out...
		// Ignore focus events on other document though because it's likely an Editor inside of the Dialog.
		if(node && topDialog && !topDialog._fadeOutDeferred && node.ownerDocument == topDialog.ownerDocument){
			// If the node that was focused is inside the dialog or in a popup, even a context menu that isn't
			// technically a descendant of the the dialog, don't do anything.
			do{
				if(node == topDialog.domNode || domClass.contains(node, "dijitPopup")){ return; }
			}while(node = node.parentNode);

			// Otherwise, return focus to the dialog.  Use a delay to avoid confusing dijit/focus code's
			// own tracking of focus.
			topDialog.focus();
		}
	});

	// Back compat w/1.6, remove for 2.0
	if(has("dijit-legacy-requires")){
		ready(0, function(){
			var requires = ["dijit/TooltipDialog"];
			require(requires);	// use indirection so modules not rolled into a build
		});
	}

	return Dialog;
});

},
'dojo/dnd/Moveable':function(){
define([
	"../_base/array", "../_base/declare", "../_base/lang", "../dom", "../dom-class", "../Evented",
	"../has", "../on", "../topic", "../touch", "./common", "./Mover", "../_base/window"
], function(array, declare, lang, dom, domClass, Evented, has, on, topic, touch, dnd, Mover, win){

// module:
//		dojo/dnd/Moveable

var touchActionPropertyName;
var setTouchAction = function () {};

function setTouchActionPropertyName() {
	if ("touchAction" in document.body.style) {
		touchActionPropertyName = "touchAction";
	}
	else if ("msTouchAction" in document.body.style) {
		touchActionPropertyName = "msTouchAction";
	}
	setTouchAction = function setTouchAction(/* Node */ node, /* string */ action) {
		node.style[touchActionPropertyName] = action;
	}
	setTouchAction(arguments[0], arguments[1]);
}

if (has("touch-action")) {
	// Ensure that the logic to determine "touchActionPropertyName" runs
	setTouchAction = setTouchActionPropertyName;
}

var Moveable = declare("dojo.dnd.Moveable", [Evented], {
	// summary:
	//		an object, which makes a node movable

	// object attributes (for markup)
	handle: "",
	delay: 0,
	skip: false,

	constructor: function(node, params){
		// node: Node
		//		a node (or node's id) to be moved
		// params: Moveable.__MoveableArgs?
		//		optional parameters
		this.node = dom.byId(node);
		setTouchAction(this.node, "none");
		if(!params){ params = {}; }
		this.handle = params.handle ? dom.byId(params.handle) : null;
		if(!this.handle){ this.handle = this.node; }
		this.delay = params.delay > 0 ? params.delay : 0;
		this.skip  = params.skip;
		this.mover = params.mover ? params.mover : Mover;
		this.events = [
			on(this.handle, touch.press, lang.hitch(this, "onMouseDown")),
			// cancel text selection and text dragging
			on(this.handle, "dragstart",   lang.hitch(this, "onSelectStart")),
			on(this.handle, "selectstart",   lang.hitch(this, "onSelectStart"))
		];
	},

	// markup methods
	markupFactory: function(params, node, Ctor){
		return new Ctor(node, params);
	},

	// methods
	destroy: function(){
		// summary:
		//		stops watching for possible move, deletes all references, so the object can be garbage-collected
		array.forEach(this.events, function(handle){ handle.remove(); });
		setTouchAction(this.node, "");
		this.events = this.node = this.handle = null;
	},

	// mouse event processors
	onMouseDown: function(e){
		// summary:
		//		event processor for onmousedown/ontouchstart, creates a Mover for the node
		// e: Event
		//		mouse/touch event
		if(this.skip && dnd.isFormElement(e)){ return; }
		if(this.delay){
			this.events.push(
				on(this.handle, touch.move, lang.hitch(this, "onMouseMove")),
				on(this.handle.ownerDocument, touch.release, lang.hitch(this, "onMouseUp"))
			);
			this._lastX = e.pageX;
			this._lastY = e.pageY;
		}else{
			this.onDragDetected(e);
		}
		e.stopPropagation();
		e.preventDefault();
	},
	onMouseMove: function(e){
		// summary:
		//		event processor for onmousemove/ontouchmove, used only for delayed drags
		// e: Event
		//		mouse/touch event
		if(Math.abs(e.pageX - this._lastX) > this.delay || Math.abs(e.pageY - this._lastY) > this.delay){
			this.onMouseUp(e);
			this.onDragDetected(e);
		}
		e.stopPropagation();
		e.preventDefault();
	},
	onMouseUp: function(e){
		// summary:
		//		event processor for onmouseup, used only for delayed drags
		// e: Event
		//		mouse event
		for(var i = 0; i < 2; ++i){
			this.events.pop().remove();
		}
		e.stopPropagation();
		e.preventDefault();
	},
	onSelectStart: function(e){
		// summary:
		//		event processor for onselectevent and ondragevent
		// e: Event
		//		mouse event
		if(!this.skip || !dnd.isFormElement(e)){
			e.stopPropagation();
			e.preventDefault();
		}
	},

	// local events
	onDragDetected: function(/*Event*/ e){
		// summary:
		//		called when the drag is detected;
		//		responsible for creation of the mover
		new this.mover(this.node, e, this);
	},
	onMoveStart: function(/*Mover*/ mover){
		// summary:
		//		called before every move operation
		topic.publish("/dnd/move/start", mover);
		domClass.add(win.body(), "dojoMove");
		domClass.add(this.node, "dojoMoveItem");
	},
	onMoveStop: function(/*Mover*/ mover){
		// summary:
		//		called after every move operation
		topic.publish("/dnd/move/stop", mover);
		domClass.remove(win.body(), "dojoMove");
		domClass.remove(this.node, "dojoMoveItem");
	},
	onFirstMove: function(/*===== mover, e =====*/){
		// summary:
		//		called during the very first move notification;
		//		can be used to initialize coordinates, can be overwritten.
		// mover: Mover
		// e: Event

		// default implementation does nothing
	},
	onMove: function(mover, leftTop /*=====, e =====*/){
		// summary:
		//		called during every move notification;
		//		should actually move the node; can be overwritten.
		// mover: Mover
		// leftTop: Object
		// e: Event
		this.onMoving(mover, leftTop);
		var s = mover.node.style;
		s.left = leftTop.l + "px";
		s.top  = leftTop.t + "px";
		this.onMoved(mover, leftTop);
	},
	onMoving: function(/*===== mover, leftTop =====*/){
		// summary:
		//		called before every incremental move; can be overwritten.
		// mover: Mover
		// leftTop: Object

		// default implementation does nothing
	},
	onMoved: function(/*===== mover, leftTop =====*/){
		// summary:
		//		called after every incremental move; can be overwritten.
		// mover: Mover
		// leftTop: Object

		// default implementation does nothing
	}
});

/*=====
Moveable.__MoveableArgs = declare([], {
	// handle: Node||String
	//		A node (or node's id), which is used as a mouse handle.
	//		If omitted, the node itself is used as a handle.
	handle: null,

	// delay: Number
	//		delay move by this number of pixels
	delay: 0,

	// skip: Boolean
	//		skip move of form elements
	skip: false,

	// mover: Object
	//		a constructor of custom Mover
	mover: dnd.Mover
});
=====*/

return Moveable;
});

},
'dojo/dnd/common':function(){
define(["../sniff", "../_base/kernel", "../_base/lang", "../dom"],
	function(has, kernel, lang, dom){

// module:
//		dojo/dnd/common

var exports = lang.getObject("dojo.dnd", true);
/*=====
// TODO: for 2.0, replace line above with this code.
var exports = {
	// summary:
	//		TODOC
};
=====*/

exports.getCopyKeyState = function(evt){
	return evt[has("mac") ? "metaKey" : "ctrlKey"]
};

exports._uniqueId = 0;
exports.getUniqueId = function(){
	// summary:
	//		returns a unique string for use with any DOM element
	var id;
	do{
		id = kernel._scopeName + "Unique" + (++exports._uniqueId);
	}while(dom.byId(id));
	return id;
};

exports._empty = {};

exports.isFormElement = function(/*Event*/ e){
	// summary:
	//		returns true if user clicked on a form element
	var t = e.target;
	if(t.nodeType == 3 /*TEXT_NODE*/){
		t = t.parentNode;
	}
	return " a button textarea input select option ".indexOf(" " + t.tagName.toLowerCase() + " ") >= 0;	// Boolean
};

return exports;
});

},
'dojo/dnd/Mover':function(){
define([
	"../_base/array", "../_base/declare", "../_base/lang", "../sniff", "../_base/window",
	"../dom", "../dom-geometry", "../dom-style", "../Evented", "../on", "../touch", "./common", "./autoscroll"
], function(array, declare, lang, has, win, dom, domGeom, domStyle, Evented, on, touch, dnd, autoscroll){

// module:
//		dojo/dnd/Mover

return declare("dojo.dnd.Mover", [Evented], {
	// summary:
	//		an object which makes a node follow the mouse, or touch-drag on touch devices.
	//		Used as a default mover, and as a base class for custom movers.

	constructor: function(node, e, host){
		// node: Node
		//		a node (or node's id) to be moved
		// e: Event
		//		a mouse event, which started the move;
		//		only pageX and pageY properties are used
		// host: Object?
		//		object which implements the functionality of the move,
		//	 	and defines proper events (onMoveStart and onMoveStop)
		this.node = dom.byId(node);
		this.marginBox = {l: e.pageX, t: e.pageY};
		this.mouseButton = e.button;
		var h = (this.host = host), d = node.ownerDocument;

		function stopEvent(e){
			e.preventDefault();
			e.stopPropagation();
		}

		this.events = [
			// At the start of a drag, onFirstMove is called, and then the following
			// listener is disconnected.
			on(d, touch.move, lang.hitch(this, "onFirstMove")),

			// These are called continually during the drag
			on(d, touch.move, lang.hitch(this, "onMouseMove")),

			// And these are called at the end of the drag
			on(d, touch.release,  lang.hitch(this, "onMouseUp")),

			// cancel text selection and text dragging
			on(d, "dragstart",   stopEvent),
			on(d.body, "selectstart", stopEvent)
		];

		// Tell autoscroll that a drag is starting
		autoscroll.autoScrollStart(d);

		// notify that the move has started
		if(h && h.onMoveStart){
			h.onMoveStart(this);
		}
	},
	// mouse event processors
	onMouseMove: function(e){
		// summary:
		//		event processor for onmousemove/ontouchmove
		// e: Event
		//		mouse/touch event
		autoscroll.autoScroll(e);
		var m = this.marginBox;
		this.host.onMove(this, {l: m.l + e.pageX, t: m.t + e.pageY}, e);
		e.preventDefault();
		e.stopPropagation();
	},
	onMouseUp: function(e){
		if(has("webkit") && has("mac") && this.mouseButton == 2 ?
				e.button == 0 : this.mouseButton == e.button){ // TODO Should condition be met for touch devices, too?
			this.destroy();
		}
		e.preventDefault();
		e.stopPropagation();
	},
	// utilities
	onFirstMove: function(e){
		// summary:
		//		makes the node absolute; it is meant to be called only once.
		//		relative and absolutely positioned nodes are assumed to use pixel units
		var s = this.node.style, l, t, h = this.host;
		switch(s.position){
			case "relative":
			case "absolute":
				// assume that left and top values are in pixels already
				l = Math.round(parseFloat(s.left)) || 0;
				t = Math.round(parseFloat(s.top)) || 0;
				break;
			default:
				s.position = "absolute";	// enforcing the absolute mode
				var m = domGeom.getMarginBox(this.node);
				// event.pageX/pageY (which we used to generate the initial
				// margin box) includes padding and margin set on the body.
				// However, setting the node's position to absolute and then
				// doing domGeom.marginBox on it *doesn't* take that additional
				// space into account - so we need to subtract the combined
				// padding and margin.  We use getComputedStyle and
				// _getMarginBox/_getContentBox to avoid the extra lookup of
				// the computed style.
				var b = win.doc.body;
				var bs = domStyle.getComputedStyle(b);
				var bm = domGeom.getMarginBox(b, bs);
				var bc = domGeom.getContentBox(b, bs);
				l = m.l - (bc.l - bm.l);
				t = m.t - (bc.t - bm.t);
				break;
		}
		this.marginBox.l = l - this.marginBox.l;
		this.marginBox.t = t - this.marginBox.t;
		if(h && h.onFirstMove){
			h.onFirstMove(this, e);
		}

		// Disconnect touch.move that call this function
		this.events.shift().remove();
	},
	destroy: function(){
		// summary:
		//		stops the move, deletes all references, so the object can be garbage-collected
		array.forEach(this.events, function(handle){ handle.remove(); });
		// undo global settings
		var h = this.host;
		if(h && h.onMoveStop){
			h.onMoveStop(this);
		}
		// destroy objects
		this.events = this.node = this.host = null;
	}
});

});

},
'dojo/dnd/autoscroll':function(){
define(["../_base/lang", "../sniff", "../_base/window", "../dom-geometry", "../dom-style", "../window"],
	function(lang, has, win, domGeom, domStyle, winUtils){

// module:
//		dojo/dnd/autoscroll

var exports = {
	// summary:
	//		Used by dojo/dnd/Manager to scroll document or internal node when the user
	//		drags near the edge of the viewport or a scrollable node
};
lang.setObject("dojo.dnd.autoscroll", exports);

exports.getViewport = winUtils.getBox;

exports.V_TRIGGER_AUTOSCROLL = 32;
exports.H_TRIGGER_AUTOSCROLL = 32;

exports.V_AUTOSCROLL_VALUE = 16;
exports.H_AUTOSCROLL_VALUE = 16;

// These are set by autoScrollStart().
// Set to default values in case autoScrollStart() isn't called. (back-compat, remove for 2.0)
var viewport,
	doc = win.doc,
	maxScrollTop = Infinity,
	maxScrollLeft = Infinity;

exports.autoScrollStart = function(d){
	// summary:
	//		Called at the start of a drag.
	// d: Document
	//		The document of the node being dragged.

	doc = d;
	viewport = winUtils.getBox(doc);

	// Save height/width of document at start of drag, before it gets distorted by a user dragging an avatar past
	// the document's edge
	var html = win.body(doc).parentNode;
	maxScrollTop = Math.max(html.scrollHeight - viewport.h, 0);
	maxScrollLeft = Math.max(html.scrollWidth - viewport.w, 0);	// usually 0
};

exports.autoScroll = function(e){
	// summary:
	//		a handler for mousemove and touchmove events, which scrolls the window, if
	//		necessary
	// e: Event
	//		mousemove/touchmove event

	// FIXME: needs more docs!
	var v = viewport || winUtils.getBox(doc), // getBox() call for back-compat, in case autoScrollStart() wasn't called
		html = win.body(doc).parentNode,
		dx = 0, dy = 0;
	if(e.clientX < exports.H_TRIGGER_AUTOSCROLL){
		dx = -exports.H_AUTOSCROLL_VALUE;
	}else if(e.clientX > v.w - exports.H_TRIGGER_AUTOSCROLL){
		dx = Math.min(exports.H_AUTOSCROLL_VALUE, maxScrollLeft - html.scrollLeft);	// don't scroll past edge of doc
	}
	if(e.clientY < exports.V_TRIGGER_AUTOSCROLL){
		dy = -exports.V_AUTOSCROLL_VALUE;
	}else if(e.clientY > v.h - exports.V_TRIGGER_AUTOSCROLL){
		dy = Math.min(exports.V_AUTOSCROLL_VALUE, maxScrollTop - html.scrollTop);	// don't scroll past edge of doc
	}
	window.scrollBy(dx, dy);
};

exports._validNodes = {"div": 1, "p": 1, "td": 1};
exports._validOverflow = {"auto": 1, "scroll": 1};

exports.autoScrollNodes = function(e){
	// summary:
	//		a handler for mousemove and touchmove events, which scrolls the first available
	//		Dom element, it falls back to exports.autoScroll()
	// e: Event
	//		mousemove/touchmove event

	// FIXME: needs more docs!

	var b, t, w, h, rx, ry, dx = 0, dy = 0, oldLeft, oldTop;

	for(var n = e.target; n;){
		if(n.nodeType == 1 && (n.tagName.toLowerCase() in exports._validNodes)){
			var s = domStyle.getComputedStyle(n),
				overflowX = (s.overflowX.toLowerCase() in exports._validOverflow),
				overflowY = (s.overflowY.toLowerCase() in exports._validOverflow);
			if(overflowX || overflowY){
				b = domGeom.getContentBox(n, s);
				t = domGeom.position(n, true);
			}
			// overflow-x
			if(overflowX){
				w = Math.min(exports.H_TRIGGER_AUTOSCROLL, b.w / 2);
				rx = e.pageX - t.x;
				if(has("webkit") || has("opera")){
					// FIXME: this code should not be here, it should be taken into account
					// either by the event fixing code, or the domGeom.position()
					// FIXME: this code doesn't work on Opera 9.5 Beta
					rx += win.body().scrollLeft;
				}
				dx = 0;
				if(rx > 0 && rx < b.w){
					if(rx < w){
						dx = -w;
					}else if(rx > b.w - w){
						dx = w;
					}
					oldLeft = n.scrollLeft;
					n.scrollLeft = n.scrollLeft + dx;
				}
			}
			// overflow-y
			if(overflowY){
				//console.log(b.l, b.t, t.x, t.y, n.scrollLeft, n.scrollTop);
				h = Math.min(exports.V_TRIGGER_AUTOSCROLL, b.h / 2);
				ry = e.pageY - t.y;
				if(has("webkit") || has("opera")){
					// FIXME: this code should not be here, it should be taken into account
					// either by the event fixing code, or the domGeom.position()
					// FIXME: this code doesn't work on Opera 9.5 Beta
					ry += win.body().scrollTop;
				}
				dy = 0;
				if(ry > 0 && ry < b.h){
					if(ry < h){
						dy = -h;
					}else if(ry > b.h - h){
						dy = h;
					}
					oldTop = n.scrollTop;
					n.scrollTop  = n.scrollTop  + dy;
				}
			}
			if(dx || dy){ return; }
		}
		try{
			n = n.parentNode;
		}catch(x){
			n = null;
		}
	}
	exports.autoScroll(e);
};

return exports;

});

},
'dojo/dnd/TimedMoveable':function(){
define(["../_base/declare", "./Moveable" /*=====, "./Mover" =====*/], function(declare, Moveable /*=====, Mover =====*/){
	// module:
	//		dojo/dnd/TimedMoveable

	/*=====
	var __TimedMoveableArgs = declare([Moveable.__MoveableArgs], {
		// timeout: Number
		//		delay move by this number of ms,
		//		accumulating position changes during the timeout
		timeout: 0
	});
	=====*/

	// precalculate long expressions
	var oldOnMove = Moveable.prototype.onMove;

	return declare("dojo.dnd.TimedMoveable", Moveable, {
		// summary:
		//		A specialized version of Moveable to support an FPS throttling.
		//		This class puts an upper restriction on FPS, which may reduce
		//		the CPU load. The additional parameter "timeout" regulates
		//		the delay before actually moving the moveable object.

		// object attributes (for markup)
		timeout: 40,	// in ms, 40ms corresponds to 25 fps

		constructor: function(node, params){
			// summary:
			//		an object that makes a node moveable with a timer
			// node: Node||String
			//		a node (or node's id) to be moved
			// params: __TimedMoveableArgs
			//		object with additional parameters.

			// sanitize parameters
			if(!params){ params = {}; }
			if(params.timeout && typeof params.timeout == "number" && params.timeout >= 0){
				this.timeout = params.timeout;
			}
		},

		onMoveStop: function(/*Mover*/ mover){
			if(mover._timer){
				// stop timer
				clearTimeout(mover._timer);
				// reflect the last received position
				oldOnMove.call(this, mover, mover._leftTop);
			}
			Moveable.prototype.onMoveStop.apply(this, arguments);
		},
		onMove: function(/*Mover*/ mover, /*Object*/ leftTop){
			mover._leftTop = leftTop;
			if(!mover._timer){
				var _t = this;	// to avoid using dojo.hitch()
				mover._timer = setTimeout(function(){
					// we don't have any pending requests
					mover._timer = null;
					// reflect the last received position
					oldOnMove.call(_t, mover, mover._leftTop);
				}, this.timeout);
			}
		}
	});
});

},
'dijit/DialogUnderlay':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/_base/lang", // lang.hitch
	"dojo/aspect", // aspect.after
	"dojo/dom-attr", // domAttr.set
	"dojo/dom-style", // domStyle.getComputedStyle
	"dojo/on",
	"dojo/window", // winUtils.getBox, winUtils.get
	"./_Widget",
	"./_TemplatedMixin",
	"./BackgroundIframe",
	"./Viewport",
	"./main" // for back-compat, exporting dijit._underlay (remove in 2.0)
], function(declare, lang, aspect, domAttr, domStyle, on,
			winUtils, _Widget, _TemplatedMixin, BackgroundIframe, Viewport, dijit){

	// module:
	//		dijit/DialogUnderlay

	var DialogUnderlay = declare("dijit.DialogUnderlay", [_Widget, _TemplatedMixin], {
		// summary:
		//		A component used to block input behind a `dijit/Dialog`.
		//
		//		Normally this class should not be instantiated directly, but rather shown and hidden via
		//		DialogUnderlay.show() and DialogUnderlay.hide().  And usually the module is not accessed directly
		//		at all, since the underlay is shown and hidden by Dialog.DialogLevelManager.
		//
		//		The underlay itself can be styled based on and id:
		//	|	#myDialog_underlay { background-color:red; }
		//
		//		In the case of `dijit.Dialog`, this id is based on the id of the Dialog,
		//		suffixed with _underlay.

		// Template has two divs; outer div is used for fade-in/fade-out, and also to hold background iframe.
		// Inner div has opacity specified in CSS file.
		templateString: "<div class='dijitDialogUnderlayWrapper'><div class='dijitDialogUnderlay' tabIndex='-1' data-dojo-attach-point='node'></div></div>",

		// Parameters on creation or updatable later

		// dialogId: String
		//		Id of the dialog.... DialogUnderlay's id is based on this id
		dialogId: "",

		// class: String
		//		This class name is used on the DialogUnderlay node, in addition to dijitDialogUnderlay
		"class": "",

		// This will get overwritten as soon as show() is call, but leave an empty array in case hide() or destroy()
		// is called first.   The array is shared between instances but that's OK because we never write into it.
		_modalConnects: [],

		_setDialogIdAttr: function(id){
			domAttr.set(this.node, "id", id + "_underlay");
			this._set("dialogId", id);
		},

		_setClassAttr: function(clazz){
			this.node.className = "dijitDialogUnderlay " + clazz;
			this._set("class", clazz);
		},

		postCreate: function(){
			// Append the underlay to the body
			this.ownerDocumentBody.appendChild(this.domNode);

			this.own(on(this.domNode, "keydown", lang.hitch(this, "_onKeyDown")));

			this.inherited(arguments);
		},

		layout: function(){
			// summary:
			//		Sets the background to the size of the viewport
			//
			// description:
			//		Sets the background to the size of the viewport (rather than the size
			//		of the document) since we need to cover the whole browser window, even
			//		if the document is only a few lines long.
			// tags:
			//		private

			var is = this.node.style,
				os = this.domNode.style;

			// hide the background temporarily, so that the background itself isn't
			// causing scrollbars to appear (might happen when user shrinks browser
			// window and then we are called to resize)
			os.display = "none";

			// then resize and show
			var viewport = winUtils.getBox(this.ownerDocument);
			os.top = viewport.t + "px";
			os.left = viewport.l + "px";
			is.width = viewport.w + "px";
			is.height = viewport.h + "px";
			os.display = "block";
		},

		show: function(){
			// summary:
			//		Show the dialog underlay
			this.domNode.style.display = "block";
			this.open = true;
			this.layout();
			this.bgIframe = new BackgroundIframe(this.domNode);

			var win = winUtils.get(this.ownerDocument);
			this._modalConnects = [
				Viewport.on("resize", lang.hitch(this, "layout")),
				on(win, "scroll", lang.hitch(this, "layout"))
			];

		},

		hide: function(){
			// summary:
			//		Hides the dialog underlay

			this.bgIframe.destroy();
			delete this.bgIframe;
			this.domNode.style.display = "none";
			while(this._modalConnects.length){ (this._modalConnects.pop()).remove(); }
			this.open = false;
		},

		destroy: function(){
			while(this._modalConnects.length){ (this._modalConnects.pop()).remove(); }
			this.inherited(arguments);
		},

		_onKeyDown: function(){
			// summary:
			//		Extension point so Dialog can monitor keyboard events on the underlay.
		}
	});

	DialogUnderlay.show = function(/*Object*/ attrs, /*Number*/ zIndex){
		// summary:
		//		Display the underlay with the given attributes set.  If the underlay is already displayed,
		//		then adjust it's attributes as specified.
		// attrs:
		//		The parameters to create DialogUnderlay with.
		// zIndex:
		//		zIndex of the underlay

		var underlay = DialogUnderlay._singleton;
		if(!underlay || underlay._destroyed){
			underlay = dijit._underlay = DialogUnderlay._singleton = new DialogUnderlay(attrs);
		}else{
			if(attrs){ underlay.set(attrs); }
		}
		domStyle.set(underlay.domNode, 'zIndex', zIndex);
		if(!underlay.open){
			underlay.show();
		}
	};

	DialogUnderlay.hide = function(){
		// summary:
		//		Hide the underlay.

		// Guard code in case the underlay widget has already been destroyed
		// because we are being called during page unload (when all widgets are destroyed)
		var underlay = DialogUnderlay._singleton;
		if(underlay && !underlay._destroyed){
			underlay.hide();
		}
	};

	return DialogUnderlay;
});

},
'doccontrol/document/template/dojo/ViewToolbar':function(){
define([
    '../Topics',
    'dojo/_base/declare',
    'dojo/dom-class',
    'dojo/dom-construct',
    'dojo/text!./templates/ViewToolbar.html',
    'dojo/topic',
    'dijit/_WidgetBase',
    'dijit/form/NumberTextBox',
    'soso/sosox/ejs/_Templated'
], function(
    TOPICS,
    declare,
    domClass,
    domConstruct,
    Template,
    topic,
    WidgetBase,
    NumberTextBox,
    Templated
) {
    const ViewToolbar = function(node) {
        const View = declare([WidgetBase, Templated], {
            constants: {
                MIN_ZOOM: 1,
                ZOOM_INTERVAL: 10,
                SCALE_DIRECTION_WIDTH: 'width',
                SCALE_DIRECTION_PAGE: 'page',
                ROTATION_INTERVAL: 90
            },

            zoom: null,

            rotation: 0,

            templateString: Template,

            postCreate: function() {
                this.inherited(arguments);

                this.zoom = new NumberTextBox({
                    'class': 'sos-form-textfield sos-form-textfield-s sos-form-textfield-with-suffix sos-form-textfield-with-suffix-unit sos-form-textfield-validation sos-form-textfield-validation-s',
                    constraints: { min: this.constants.MIN_ZOOM },
                    value: 100
                }, this.zoomInput);

                this._initEvents();
            },

            _initEvents: function() {
                this.zoom.on('change', function(value) {
                    if (this.validate()) {
                        topic.publish(TOPICS.DOCUMENT_TEMPLATE_VIEWER_SCALE, value / 100);
                    }
                });
                this.zoom.on('keyup', function(key) {
                    if (key.key === "Enter") {
                        this._hasBeenBlurred = true;
                        if (this.validate()) {
                            topic.publish(TOPICS.DOCUMENT_TEMPLATE_VIEWER_SCALE, this.get('value') / 100);
                        }
                    }
                });
            },

            show: function() {
                domClass.remove(this.domNode, 'hidden');
            },

            hide: function() {
                domClass.add(this.domNode, 'hidden');
            },

            toggle: function() {
                domClass.toggle(this.domNode, 'hidden');
            },

            disable: function() {
                this.zoom.set('disabled', true);
                domClass.add(this.zoomInBtn, 'disabled');
                domClass.add(this.zoomOutBtn, 'disabled');
                domClass.add(this.fitWidthBtn, 'disabled');
                domClass.add(this.fitPageBtn, 'disabled');
                domClass.add(this.rotateBtn, 'disabled');
            },

            enable: function() {
                this.zoom.set('disabled', false);
                domClass.remove(this.zoomInBtn, 'disabled');
                domClass.remove(this.zoomOutBtn, 'disabled');
                domClass.remove(this.fitWidthBtn, 'disabled');
                domClass.remove(this.fitPageBtn, 'disabled');
                domClass.remove(this.rotateBtn, 'disabled');
            },

            fitWidth: function() {
                if (!domClass.contains(this.fitWidthBtn, 'disabled')) {
                    topic.publish(TOPICS.DOCUMENT_TEMPLATE_VIEWER_FIT_WIDTH);
                }
            },

            fitPage: function() {
                if (!domClass.contains(this.fitPageBtn, 'disabled')) {
                    topic.publish(TOPICS.DOCUMENT_TEMPLATE_VIEWER_FIT_PAGE);
                }
            },

            zoomIn: function() {
                if (!domClass.contains(this.zoomInBtn, 'disabled')) {
                    topic.publish(
                        TOPICS.DOCUMENT_TEMPLATE_VIEWER_SCALE,
                        (this.zoom.get('value') + this.constants.ZOOM_INTERVAL) / 100
                    );
                }
            },

            zoomOut: function() {
                if (!domClass.contains(this.zoomOutBtn, 'disabled')) {
                    topic.publish(
                        TOPICS.DOCUMENT_TEMPLATE_VIEWER_SCALE,
                        Math.max(this.zoom.get('value') - this.constants.ZOOM_INTERVAL, this.constants.MIN_ZOOM) / 100
                    );
                }
            },

            rotate: function() {
                if (!domClass.contains(this.rotateBtn, 'disabled')) {
                    this.rotation = (this.rotation + this.constants.ROTATION_INTERVAL) % 360;
                    topic.publish(TOPICS.DOCUMENT_TEMPLATE_VIEWER_ROTATE, this.rotation);
                }
            }
        });

        this.view = new View({},  domConstruct.create('div', {}, node, 'only'));
        this.view.startup();
    };

    ViewToolbar.prototype.hide = function() {
        this.view.hide();
    };

    ViewToolbar.prototype.show = function() {
        this.view.enable();
        this.view.show();
    };

    ViewToolbar.prototype.disable = function() {
        this.view.disable();
    };

    ViewToolbar.prototype.enable = function() {
        this.view.enable();
    };

    ViewToolbar.prototype.scale = function(scale) {
        this.view.zoom.set('value', scale * 100, false);
    };

    return ViewToolbar;
});
},
'doccontrol/document/template/model/Factory':function(){
define([
    'api/doccontrol/Config',
    'api/doccontrol/DocumentDetails',
    'api/doccontrol/RevisionAccessLog',
    'api/doccontrol/parser/AccessLog',
    'api/doccontrol/parser/DocumentDetails',
    'api/doccontrol/template/Config',
    'api/doccontrol/template/Factory',
    'api/file/Downloader',
    'api/file/parser/blob/ToDataUrl',
    'api/file/request/DownloadURLResponseProcessorBuilder',
    'api/parser/Collection',
    'library/request/dojo/URLConnectionProcessorBuilder',
    'library/request/URLConnectionBuilder',
    'library/request/URLResponseProcessorBuilder',
    'pdf/Retriever',
    'spencer/parse/JSONParser'
], function(
    Config,
    DocumentDetails,
    RevisionAccessLog,
    AccessLogParser,
    DocumentDetailsParser,
    TemplateConfig,
    TemplateFactory,
    FileDownloader,
    BlobToDataUrlParser,
    ResponseProcessorBuilder,
    CollectionParser,
    URLConnectionProcessorBuilder,
    URLConnectionBuilder,
    URLResponseProcessorBuilder,
    pdfFetcher,
    JSONParser
) {
    const Factory = function() {
        this.config = new Config();
        this.urlConnectionBuilder = new URLConnectionBuilder(new URLConnectionProcessorBuilder());
        this.urlResponseProcessorBuilder = new URLResponseProcessorBuilder();
    };

    Factory.prototype.getResponseProcessorBuilder = function() {
        return new ResponseProcessorBuilder();
    };

    Factory.prototype.getDocumentDetails = function() {
        return new DocumentDetails(
            this.config.getUrl('api_doc_control_document_details', 'v2/'),
            this.urlConnectionBuilder,
            new JSONParser(
                new DocumentDetailsParser()
            ),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getPdfFetcher = function() {
        return new pdfFetcher();
    };

    Factory.prototype.getFileFetcher = function() {
        return new FileDownloader(
            this.urlConnectionBuilder,
            this.getDataUrlParser()
        );
    };

    Factory.prototype.getDataUrlParser = function() {
        return new BlobToDataUrlParser(new FileReader());
    };

    Factory.prototype.getRevisionAccessLog = function() {
        return new RevisionAccessLog(
            this.config.getUrl('api_doc_control_revision_access_log'),
            this.urlConnectionBuilder,
            new CollectionParser(new AccessLogParser()),
            this.urlResponseProcessorBuilder
        );
    };

    Factory.prototype.getTemplateFactory = function() {
        return new TemplateFactory(
            new TemplateConfig(),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    return Factory;
});
},
'api/file/Downloader':function(){
define(['./request/DownloadURLResponseProcessorBuilder'], function(DownloadURLResponseProcessorBuilder) {
    const FORMAT = 'blob';

    const Downloader = function(urlConnectionBuilder, parser) {
        this.parser = parser;
        this.urlConnectionBuilder = urlConnectionBuilder;
        this.urlResponseProcessorBuilder = new DownloadURLResponseProcessorBuilder();
    };

    Downloader.prototype.download = function(handlers, href) {
        const urlConnection = this.urlConnectionBuilder.build()
            .setUrl(href)
            .setFormat(FORMAT)
            .setSuccessHandler(
                this.urlResponseProcessorBuilder.createProcessor(
                    this.parser,
                    handlers.getSuccess(),
                    handlers.getError()
                )
            )
            .setErrorHandler(handlers.getError())
            .setGoneHandler(handlers.getGone())
            .setUnauthorisedHandler(handlers.getUnauthorised())
            .setAbortHandler(handlers.getAbort());

        return urlConnection.get();
    };

    return Downloader;
});
},
'api/file/request/DownloadURLResponseProcessorBuilder':function(){
define([], function() {
    const DownloadURLResponseProcessorBuilder = function() {};

    DownloadURLResponseProcessorBuilder.prototype.createProcessor = function(parser, successHandler, errorHandler) {
        return function(data) {
            if (!parser) {
                try {
                    if (typeof successHandler == "function") {
                        successHandler(data);
                    }
                } catch (error) {
                    if (typeof errorHandler == "function") {
                        errorHandler(error);
                    }
                }
            } else {
                parser.parse(data, successHandler, errorHandler);
            }
        }
    };

    return DownloadURLResponseProcessorBuilder;
});
},
'api/file/parser/blob/ToDataUrl':function(){
define(['../FileReader'], function(FileReader) {
    const ToDataUrl = function(Reader) {
        this.base = FileReader;
        this.base(Reader);

        this.read = function(blob) {
            this.reader.readAsDataURL(blob);
        };
    };

    ToDataUrl.prototype = Object.create(FileReader.prototype);

    return ToDataUrl;
});
},
'api/file/parser/FileReader':function(){
define([], function() {
    const FileReader = function(Reader) {
        this.reader = Reader;

        this.read = function(file) {
            throw new Error('Abstract function "read" not implemented');
        };
    };

    FileReader.prototype.parse = function(file, successHandler, errorHandler) {
        const reader = this.reader;
        reader.onload = function(evt) {
            try {
                if (typeof successHandler == "function") {
                    successHandler(reader.result);
                }
            } catch (error) {
                if (typeof errorHandler == "function") {
                    errorHandler(error);
                }
            }
        };
        reader.onerror = function(evt) {
            if (typeof errorHandler == "function") {
                errorHandler(reader.error);
            }
        };

        try {
            this.read(file);
        } catch (error) {
            if (typeof errorHandler == "function") {
                errorHandler(error);
            }
        }
    };

    return FileReader;
});
},
'pdf/Retriever':function(){
define([
    'pdfjs-dist/build/pdf'
], function(pdfjs) {
    var Retriever = function() {
        this.constants = {
            PDF_WORKER_URL: 'pdfjs-dist/build/pdf.worker.js',
            PASSWORD_RESPONSES: {},
            UNAUTHORISED_ERROR_CODE: 403,
            GONE_ERROR_CODE: 410
        };
        this.constants.PASSWORD_RESPONSES[pdfjs.PasswordResponses.INCORRECT_PASSWORD] = 'Password is incorrect';
        this.constants.PASSWORD_RESPONSES[pdfjs.PasswordResponses.NEED_PASSWORD] = 'Password is required';
    };

    /** @return PDFDocumentLoadingTask **/
    Retriever.prototype.get = function(handlers, src) {
        let pending = true;

        pdfjs.GlobalWorkerOptions.workerSrc = require.toUrl(this.constants.PDF_WORKER_URL);
        var pdfDocumentLoadingTask = pdfjs.getDocument({
            url: src,
            httpHeaders: { "Accept": "application/pdf", "X-Requested-With": "XMLHttpRequest" },
            verbosity: 0
        });

        const passwordHandler = handlers.getPassword();
        if (passwordHandler && typeof passwordHandler === 'function') {
            pdfDocumentLoadingTask.onPassword = passwordHandler;
        }

        pdfDocumentLoadingTask.promise.then(function(pdf) {
            if (pending) {
                pending = false;

                const successHandler = handlers.getSuccess();
                if (successHandler && typeof successHandler === 'function') {
                    successHandler(pdf);
                }
            }
        }).catch(function(error) {
            if (pending) {
                pending = false;

                if (error.status === this.constants.UNAUTHORISED_ERROR_CODE) {
                    const unauthorisedHandler = handlers.getUnauthorised();
                    if (unauthorisedHandler && typeof unauthorisedHandler === 'function') {
                        unauthorisedHandler();
                    }
                    return;
                }

                if (error.status === this.constants.GONE_ERROR_CODE) {
                    const goneHandler = handlers.getGone();
                    if (goneHandler && typeof goneHandler === 'function') {
                        goneHandler();
                    }
                    return;
                }

                const errorHandler = handlers.getError();
                if (errorHandler && typeof errorHandler === 'function') {
                    errorHandler(error);
                }
            }
        }.bind(this));

        pdfDocumentLoadingTask.cancel = function() {
            if (pending) {
                pending = false;
                this.destroy();
                const abortHandler = handlers.getAbort();
                if (abortHandler && typeof abortHandler === 'function') {
                    abortHandler();
                }
            }
        };

        return pdfDocumentLoadingTask;
    };

    return Retriever;
});


},
'doccontrol/document/template/model/Viewer':function(){
define([], function() {
    const Viewer = function(factory) {
        this.pdfFetcher = factory.getPdfFetcher();
        this.fileFetcher = factory.getFileFetcher();
        this.documentDetails = factory.getDocumentDetails();
        this.templateFactory = factory.getTemplateFactory();
        this.revisionAccessLog = factory.getRevisionAccessLog();
        this.responseProcessorBuilder = factory.getResponseProcessorBuilder();
        this.dataUrlParser = factory.getDataUrlParser();

        this.requests = [];

        this.constants = {
            PASSWORD_RESPONSES: this.pdfFetcher.constants.PASSWORD_RESPONSES
        };

        this._cancel = function() {
            this.requests.forEach(function(request) {
                request.cancel();
            });
            this.requests = [];
        }
    };

    Viewer.prototype.getDocumentDetails = function(handlers, md5) {
        this._cancel();
        this.requests.push(this.documentDetails.get(handlers, md5));
    };

    Viewer.prototype.getPdf = function(handlers, href) {
        this.requests.push(this.pdfFetcher.get(handlers, href));
    };

    Viewer.prototype.getFile = function(handlers, href) {
        this.requests.push(this.fileFetcher.download(handlers, href));
    };

    Viewer.prototype.getImageFromFile = function(handlers, file) {
        const processor = this.responseProcessorBuilder.createProcessor(
            this.dataUrlParser,
            handlers.getSuccess(),
            handlers.getError()
        );
        processor(file);
    };

    Viewer.prototype.getPdfFromFile = function(handlers, file) {
        const processor = this.responseProcessorBuilder.createProcessor(
            this.dataUrlParser,
            handlers.getSuccess(),
            handlers.getError()
        );
        processor(file);
    };

    Viewer.prototype.cancel = function() {
        this._cancel();
    };

    Viewer.prototype.logView = function(handlers, revisionVO) {
        this.revisionAccessLog.logView(handlers, revisionVO);
    };

    return Viewer;
});
},
'spencer/utility/Binder':function(){
define([], function() {
    const Binder = function() {};

    Binder.prototype.bindScope = function(func, scope) {
        const funcArguments = [];
        for (let i = 2; i < arguments.length; ++i) {
            funcArguments[i - 2] = arguments[i];
        }

        return func.bind.apply(func, [].concat([scope], funcArguments));
    };

    return Binder;
});
},
'dojo/_base/query':function(){
define(["../query", "./NodeList"], function(query){
	// module:
	//		dojo/_base/query

	/*=====
	return {
		// summary:
		//		Deprecated.   Use dojo/query instead.
	};
	=====*/

	return query;
});

},
'style-guide/v1/forms/FileDragDrop':function(){
define([
    'dojo/dom',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/dom-construct',
    'dojo/dom-style',
    'dojo/Evented',
    'dojo/on',
    'dojo/sniff',
    'dojo/topic',
    'dojo/_base/event',
    'dojo/_base/lang',
    'dojo/_base/declare',
    'dojox/html/entities',
    'spencer/parse/BytesToMegabytes',
    'style-guide/v1/forms/FileDragDropLimitSummary',
    'style-guide/v1/forms/FileDragDropTableRow',
    'dijit/_WidgetBase',
    'dojo/text!./templates/FileDragDrop.html',
    'soso/sosox/ejs/_Templated'
], function(
    dom,
    domAttr,
    domClass,
    domConstruct,
    domStyle,
    Evented,
    on,
    has,
    topic,
    event,
    lang,
    declare,
    htmlEntities,
    BytesToMegabytes,
    LimitSummary,
    TableRow,
    _WidgetBase,
    template,
    _TemplatedMixin
) {
    const DEFAULT_FILE_LABEL = 'attachment';

    return declare('style-guide.v1.forms.file-drag-drop', [_WidgetBase, _TemplatedMixin, Evented], {
        NOTIFICATION_DISPLAY_TIME: 7000,

        data: {
            dragDropEnabled: true,
            hideFormMode: false,
            hideButtonMode: false,
            smallButtons: false
        },

        templateString: template,

        fileLabel: DEFAULT_FILE_LABEL,
        fileStatusMessageUploaded: 'Uploaded',
        fileInputName: 'uploadedFiles[]',
        disabled: false,
        hideFormMode: false,
        hideButtonMode: false,
        smallButtons: false,
        showTable: true,
        addAttachmentsInput: null,
        fileInput: null,
        dragDropArea: null,
        clearAttachmentsInput: null,
        table: null,
        tableHeader: null,
        existingFilesTableBody: null,
        newFilesTableBody: null,
        existingFilesTableRows: [],
        newFilesTableRows: [],
        existingFiles: [],
        newFiles: [],

        limitSummary: null,
        uploadLimitMegabytes: null,
        uploadLimitAttachmentCount: null,

        buildRendering: function() {
            this.data.dragDropEnabled = this._isDragAndDropCapable();
            this.data.hideFormMode = this.hideFormMode;
            this.data.hideButtonMode = this.hideButtonMode;
            this.data.smallButtons = this.smallButtons;
            this.data.fileLabel = this.fileLabel;
            this.data.uploadLimitAttachmentCount = this.uploadLimitAttachmentCount;

            this.inherited(arguments);
        },

        postMixInProperties: function () {
            this.setCustomViewHelpers({
                capitalise: function(value) {
                    return value.charAt(0).toUpperCase() + value.slice(1);
                }
            });
        },

        postCreate: function() {
            this._initEvents();

            if (!this.hideFormMode) {
                this.limitSummary = new LimitSummary({
                    fileLabel: this.fileLabel,
                    dragDropEnabled: this._isDragAndDropCapable(),
                    uploadMegabytesLimit: this.uploadLimitMegabytes,
                    attachmentCountLimit: this.uploadLimitAttachmentCount
                }, dom.byId(this.limitSummary));
                this.limitSummary.setFileCount(0);
            }

            if (this.uploadLimitMegabytes === null) {
                console.error('Upload uploadLimitMegabytes must be set on file drag drop');
            }

            if (this.uploadLimitAttachmentCount === null) {
                console.error('Upload uploadLimitAttachmentCount must be set on file drag drop');
            }
            
            domAttr.set(this.fileInput, 'name', this.fileInputName);

            for(let i = 0; i < this.existingFiles.length; i++) {
                this._addExistingFile(this.existingFiles[i]);
            }

            if (!this.showTable) {
                domStyle.set(this.table, 'display', 'none');
                domStyle.set(this.tableHeader, 'display', 'none');
            }
        },

        addFiles: function(files) {
            this._addFiles(files, null);
        },
        
        markNewFileAsUploaded: function(index) {
            const file = this.newFiles[index],
                row = this.newFilesTableRows[index];

            if (row) {
                this._removeTableRow(this.newFilesTableRows, index);
                this._addExistingFileTableRow(file);
            }
        },

        remove: function(file) {
            this.removeAtIndex(this.newFiles.indexOf(file));
        },

        removeAtIndex: function(index) {
            this._removeTableRow(this.newFilesTableRows, index);

            this.onFileRemoved(this.newFiles[index], index);

            if (this.newFiles[index]) {
                this.newFiles.splice(index, 1);
            }
            if (this.limitSummary) {
                this.limitSummary.setFileCount(this.newFiles.length);
            }

            if (this._checkForNoFiles()) {
                this._reset();
            }
        },

        reset: function() {
            this._reset();
        },

        onFileRemoved: function(file) {
            // Override
        },

        openFileInput: function() {
            const mouseEvt = document.createEvent('MouseEvents');
            mouseEvt.initEvent('click', true, false);
            this.fileInput.dispatchEvent(mouseEvt);
        },

        _isDragAndDropCapable: function() {
            return !has('ie') && !has('trident');
        },

        _initEvents: function() {
            on(this.addAttachmentsInput, 'click', lang.hitch(this, this._addAttachmentsClick));

            if (this._isDragAndDropCapable()) {
                on(this.fileInput, ['dragover', 'dragenter'], lang.hitch(this, this._highlightDragDropArea));
                on(this.fileInput, ['dragleave, drop'], lang.hitch(this, this._unhighlightDragDropArea));
                on(this.fileInput, 'drop', lang.hitch(this, this._dropFile));
                on(this.fileInput, 'change', lang.hitch(this, this._fileInputChange));
            }

            on(this.clearAttachmentsInput, 'click', lang.hitch(this, function(e) {
                event.stop(e);

                this._reset();
            }));
        },
        
        _setDisabledAttr: function(disabled) {
            this.disabled = disabled;
            
            domAttr.set(this.fileInput, 'disabled', disabled);
            domAttr.set(this.addAttachmentsInput, 'disabled', disabled);
            domAttr.set(this.clearAttachmentsInput, 'disabled', disabled);
        },

        _reset: function() {
            if (this.limitSummary) {
                this.limitSummary.setFileCount(0);
            }
            this.clearAttachmentsInput.disabled = true;

            this.existingFiles = [];
            this.newFiles = [];
            this._clearFileInput();

            domClass.remove(this.table, 'sos-form-file-drag-drop-table-populated');
            while(this.existingFilesTableRows.length > 0) {
                this._removeTableRow(this.existingFilesTableRows, 0);
            }
            while(this.newFilesTableRows.length > 0) {
                this._removeTableRow(this.newFilesTableRows, 0);
            }
            this.emit('reset');
        },

        _clearFileInput: function() {
            this.fileInput.value = '';
        },
        
        _addAttachmentsClick: function(e) {
            // Open the file browser
            const mouseEvt = document.createEvent('MouseEvents');
            mouseEvt.initEvent('click', true, false);
            this.fileInput.dispatchEvent(mouseEvt);
            
            event.stop(e);
        },

        _highlightDragDropArea: function() {
            if (this.disabled || !this.dragDropArea) {
                return;
            }

            domClass.add(this.dragDropArea, 'sos-form-file-drag-drop-area-prompt-drag-over');
        },

        _unhighlightDragDropArea: function() {
            if (!this.dragDropArea) {
                return;
            }

            domClass.remove(this.dragDropArea, 'sos-form-file-drag-drop-area-prompt-drag-over');
        },

        _dropFile: function(e) {
            e.preventDefault();
            this._addFiles(e.dataTransfer.files, e);
        },

        _fileInputChange: function(e) {
            this._addFiles(e.currentTarget.files, e);
        },

        _addFiles: function(files, e) {
            if (this._doesNewFileCountExceedCountLimit(files)) {
                this._showFileCountError();

                if (e) {
                    event.stop(e);
                }
            } else if (this._doNewFilesExceedSizeLimit(files)) {
                this._showFileSizeError();

                if (e) {
                    event.stop(e);
                }
            } else {
                for(let i = 0; i < files.length; i++) {
                    if (this._isNewFileEmpty(files[i])) {
                        this._showFileIsEmptyError(files[i].name);
                    } else if (this._doesNewFileAlreadyExist(files[i])) {
                        this._showFileAlreadySelectedError(files[i].name);
                    }  else {
                        this._addNewFile(files[i]);
                    }
                }

                if (this._shouldShowFileCountWarning()) {
                    this._showFileCountWarning();
                }
            }

            this._clearFileInput();
        },

        _isNewFileEmpty: function(newFile) {
            return newFile.size === 0;
        },

        _shouldShowFileCountWarning: function() {
            return this.newFiles.length === this.uploadLimitAttachmentCount && this.uploadLimitAttachmentCount > 1;
        },

        _doesNewFileCountExceedCountLimit: function(newFiles) {
            return newFiles.length + this.newFiles.length > this.uploadLimitAttachmentCount;
        },

        _doNewFilesExceedSizeLimit: function(newFiles) {
            const bytesToMegabytesParser = new BytesToMegabytes();

            for(let i = 0; i < newFiles.length; i++) {
                if (bytesToMegabytesParser.bytesToMegabytes(newFiles[i].size) > this.uploadLimitMegabytes) {
                    return true;
                }
            }
            return false;
        },

        _doesNewFileAlreadyExist: function(newFile) {
            for(let i = 0; i < this.newFiles.length; i++) {
                if (
                    newFile.name === this.newFiles[i].name &&
                    newFile.lastModified === this.newFiles[i].lastModified &&
                    newFile.size === this.newFiles[i].size &&
                    newFile.type === this.newFiles[i].type
                ) {
                    return true;
                }
            }

            return false;
        },

        _addNewFile: function(file) {
            this.newFiles.push(file);

            this.clearAttachmentsInput.disabled = false;

            if (this.limitSummary) {
                this.limitSummary.setFileCount(this.newFiles.length);
            }

            this._addNewFileTableRow(file);

            this.emit('added', file);
        },
        
        _addNewFileTableRow: function(file) {
            const n = this._createTableRow(
                domConstruct.create('tr', {}, this.newFilesTableBody), 
                file, 
                false
            );

            on(n.removeAttachmentButton, 'click', lang.hitch(this, function() {
                this.remove(file);
            }));

            this.newFilesTableRows.push(n);

            domClass.add(this.table, 'sos-form-file-drag-drop-table-populated');
        },

        _addExistingFile: function(file) {
            this.clearAttachmentsInput.disabled = false;

            this._addExistingFileTableRow(file);
        },

        _addExistingFileTableRow: function(file) {
            const n = this._createTableRow(
                domConstruct.create('tr', {}, this.existingFilesTableBody), 
                file, 
                true
            );

            on(n.removeAttachmentButton, 'click', lang.hitch(this, function() {
                const newFileIndex = this.newFiles.indexOf(file);
                const existingFileIndex = this.existingFiles.indexOf(file);

                this._removeTableRow(this.existingFilesTableRows, existingFileIndex);

                this.newFiles.splice(newFileIndex, 1);
                this.existingFiles.splice(existingFileIndex, 1);

                if (this.limitSummary) {
                    this.limitSummary.setFileCount(this.existingFiles.length);
                }

                if (this._checkForNoFiles()) {
                    this._reset();
                }

                this.onFileRemoved(file, existingFileIndex);
            }));

            if (!this.existingFiles.includes(file)) {
                this.existingFiles.push(file);
            }

            this.existingFilesTableRows.push(n);

            domClass.add(this.table, 'sos-form-file-drag-drop-table-populated');
        },
        
        _createTableRow: function(container, file, uploaded) {
            return new TableRow({
                data:{
                    name: file.name,
                    type: file.type,
                    size: file.size,
                    uploaded: uploaded,
                    statusMessageUploaded: this.fileStatusMessageUploaded
                }
            }, container);
        },

        _removeTableRow: function(rows, index) {
            if (rows[index]) {
                domConstruct.destroy(rows[index].domNode);
                rows[index].destroy();
                rows.splice(index, 1);
            }
        },

        _checkForNoFiles: function() {
            return this.newFiles.length === 0 && this.existingFiles.length === 0;
        },

        /*
         * NOTIFICATIONS
         */

        _showFileAlreadySelectedError: function(name) {
            topic.publish(
                'sos-system-notification',
                'File "' + htmlEntities.encode(name) + '" is already attached.',
                'error',
                this.NOTIFICATION_DISPLAY_TIME
            );
        },

        _showFileIsEmptyError: function(name) {
            topic.publish(
                'sos-system-notification',
                'File "' + htmlEntities.encode(name) + '" contains no data and has therefore not been attached.',
                'error',
                this.NOTIFICATION_DISPLAY_TIME
            );
        },

        _showFileCountError: function() {
            topic.publish(
                'sos-system-notification',
                'Cannot add more than ' + htmlEntities.encode(this.uploadLimitAttachmentCount.toString()) + ' files.',
                'error',
                this.NOTIFICATION_DISPLAY_TIME
            );
        },

        _showFileCountWarning: function() {
            topic.publish(
                'sos-system-notification',
                'You have reached the attachment amount limit (' + htmlEntities.encode(this.uploadLimitAttachmentCount.toString()) + ').',
                'warning',
                this.NOTIFICATION_DISPLAY_TIME
            );
        },

        _showFileSizeError: function() {
            topic.publish(
                'sos-system-notification',
                'Uploaded files cannot exceed ' + htmlEntities.encode(this.uploadLimitMegabytes.toString()) + 'MB.',
                'error',
                this.NOTIFICATION_DISPLAY_TIME
            );
        }
    })
});

},
'dojox/html/entities':function(){
define(["dojo/_base/lang"], function(lang) {
	// dojox.html.entities.html [public] Array
	//		Entity characters for HTML, represented as an array of
	//		character code, entity name (minus & and ; wrapping.
	//		The function wrapper is to fix global leking with the build tools.
	var dhe = lang.getObject("dojox.html.entities",true);	
	
	var _applyEncodingMap = function(str, map){
		// summary:
		//		Private internal function for performing encoding of entity characters.
		// tags:
		//		private
	
		// Check to see if we have genned and cached a regexp for this map yet
		// If we have, use it, if not, gen it, cache, then use.
		var mapper, regexp;
		if(map._encCache &&
			map._encCache.regexp &&
			map._encCache.mapper &&
			map.length == map._encCache.length){
			mapper = map._encCache.mapper;
			regexp = map._encCache.regexp;
		}else{
			mapper = {};
			regexp = ["["];
			var i;
			for(i = 0; i < map.length; i++){
				mapper[map[i][0]] = "&" + map[i][1] + ";";
				regexp.push(map[i][0]);
			}
			regexp.push("]");
			regexp = new RegExp(regexp.join(""), "g");
			map._encCache = {
				mapper: mapper,
				regexp: regexp,
				length: map.length
			};
		}
		str = str.replace(regexp, function(c){
			return mapper[c];
		});
		return str;
	};
	
	var _applyDecodingMap = function(str, map){
		// summary:
		//		Private internal function for performing decoding of entity characters.
		// tags:
		//		private
		var mapper, regexp;
		if(map._decCache &&
			map._decCache.regexp &&
			map._decCache.mapper &&
			map.length == map._decCache.length){
			mapper = map._decCache.mapper;
			regexp = map._decCache.regexp;
		}else{
			mapper = {};
			regexp = ["("];
			var i;
			for(i = 0; i < map.length; i++){
				var e = "&" + map[i][1] + ";";
				if(i){regexp.push("|");}
				mapper[e] = map[i][0];
				regexp.push(e);
			}
			regexp.push(")");
			regexp = new RegExp(regexp.join(""), "g");
			map._decCache = {
				mapper: mapper,
				regexp: regexp,
				length: map.length
			};
		}
		str = str.replace(regexp, function(c){
			return mapper[c];
		});
		return str;
	};

	dhe.html = [
		["\u0026","amp"], ["\u0022","quot"],["\u003C","lt"], ["\u003E","gt"],
		["\u00A0","nbsp"]
	];
	
	// dojox.html.entities.latin [public] Array
	//		Entity characters for Latin characters and similar, represented as an array of
	//		character code, entity name (minus & and ; wrapping.
	dhe.latin = [
		["\u00A1","iexcl"],["\u00A2","cent"],["\u00A3","pound"],["\u20AC","euro"],
		["\u00A4","curren"],["\u00A5","yen"],["\u00A6","brvbar"],["\u00A7","sect"],
		["\u00A8","uml"],["\u00A9","copy"],["\u00AA","ordf"],["\u00AB","laquo"],
		["\u00AC","not"],["\u00AD","shy"],["\u00AE","reg"],["\u00AF","macr"],
		["\u00B0","deg"],["\u00B1","plusmn"],["\u00B2","sup2"],["\u00B3","sup3"],
		["\u00B4","acute"],["\u00B5","micro"],["\u00B6","para"],["\u00B7","middot"],
		["\u00B8","cedil"],["\u00B9","sup1"],["\u00BA","ordm"],["\u00BB","raquo"],
		["\u00BC","frac14"],["\u00BD","frac12"],["\u00BE","frac34"],["\u00BF","iquest"],
		["\u00C0","Agrave"],["\u00C1","Aacute"],["\u00C2","Acirc"],["\u00C3","Atilde"],
		["\u00C4","Auml"],["\u00C5","Aring"],["\u00C6","AElig"],["\u00C7","Ccedil"],
		["\u00C8","Egrave"],["\u00C9","Eacute"],["\u00CA","Ecirc"],["\u00CB","Euml"],
		["\u00CC","Igrave"],["\u00CD","Iacute"],["\u00CE","Icirc"],["\u00CF","Iuml"],
		["\u00D0","ETH"],["\u00D1","Ntilde"],["\u00D2","Ograve"],["\u00D3","Oacute"],
		["\u00D4","Ocirc"],["\u00D5","Otilde"],["\u00D6","Ouml"],["\u00D7","times"],
		["\u00D8","Oslash"],["\u00D9","Ugrave"],["\u00DA","Uacute"],["\u00DB","Ucirc"],
		["\u00DC","Uuml"],["\u00DD","Yacute"],["\u00DE","THORN"],["\u00DF","szlig"],
		["\u00E0","agrave"],["\u00E1","aacute"],["\u00E2","acirc"],["\u00E3","atilde"],
		["\u00E4","auml"],["\u00E5","aring"],["\u00E6","aelig"],["\u00E7","ccedil"],
		["\u00E8","egrave"],["\u00E9","eacute"],["\u00EA","ecirc"],["\u00EB","euml"],
		["\u00EC","igrave"],["\u00ED","iacute"],["\u00EE","icirc"],["\u00EF","iuml"],
		["\u00F0","eth"],["\u00F1","ntilde"],["\u00F2","ograve"],["\u00F3","oacute"],
		["\u00F4","ocirc"],["\u00F5","otilde"],["\u00F6","ouml"],["\u00F7","divide"],
		["\u00F8","oslash"],["\u00F9","ugrave"],["\u00FA","uacute"],["\u00FB","ucirc"],
		["\u00FC","uuml"],["\u00FD","yacute"],["\u00FE","thorn"],["\u00FF","yuml"],
		["\u0192","fnof"],["\u0391","Alpha"],["\u0392","Beta"],["\u0393","Gamma"],
		["\u0394","Delta"],["\u0395","Epsilon"],["\u0396","Zeta"],["\u0397","Eta"],
		["\u0398","Theta"], ["\u0399","Iota"],["\u039A","Kappa"],["\u039B","Lambda"],
		["\u039C","Mu"],["\u039D","Nu"],["\u039E","Xi"],["\u039F","Omicron"],
		["\u03A0","Pi"],["\u03A1","Rho"],["\u03A3","Sigma"],["\u03A4","Tau"],
		["\u03A5","Upsilon"],["\u03A6","Phi"],["\u03A7","Chi"],["\u03A8","Psi"],
		["\u03A9","Omega"],["\u03B1","alpha"],["\u03B2","beta"],["\u03B3","gamma"],
		["\u03B4","delta"],["\u03B5","epsilon"],["\u03B6","zeta"],["\u03B7","eta"],
		["\u03B8","theta"],["\u03B9","iota"],["\u03BA","kappa"],["\u03BB","lambda"],
		["\u03BC","mu"],["\u03BD","nu"],["\u03BE","xi"],["\u03BF","omicron"],
		["\u03C0","pi"],["\u03C1","rho"],["\u03C2","sigmaf"],["\u03C3","sigma"],
		["\u03C4","tau"],["\u03C5","upsilon"],["\u03C6","phi"],["\u03C7","chi"],
		["\u03C8","psi"],["\u03C9","omega"],["\u03D1","thetasym"],["\u03D2","upsih"],
		["\u03D6","piv"],["\u2022","bull"],["\u2026","hellip"],["\u2032","prime"],
		["\u2033","Prime"],["\u203E","oline"],["\u2044","frasl"],["\u2118","weierp"],
		["\u2111","image"],["\u211C","real"],["\u2122","trade"],["\u2135","alefsym"],
		["\u2190","larr"],["\u2191","uarr"],["\u2192","rarr"],["\u2193","darr"],
		["\u2194","harr"],["\u21B5","crarr"],["\u21D0","lArr"],["\u21D1","uArr"],
		["\u21D2","rArr"],["\u21D3","dArr"],["\u21D4","hArr"],["\u2200","forall"],
		["\u2202","part"],["\u2203","exist"],["\u2205","empty"],["\u2207","nabla"],
		["\u2208","isin"],["\u2209","notin"],["\u220B","ni"],["\u220F","prod"],
		["\u2211","sum"],["\u2212","minus"],["\u2217","lowast"],["\u221A","radic"],
		["\u221D","prop"],["\u221E","infin"],["\u2220","ang"],["\u2227","and"],
		["\u2228","or"],["\u2229","cap"],["\u222A","cup"],["\u222B","int"],
		["\u2234","there4"],["\u223C","sim"],["\u2245","cong"],["\u2248","asymp"],
		["\u2260","ne"],["\u2261","equiv"],["\u2264","le"],["\u2265","ge"],
		["\u2282","sub"],["\u2283","sup"],["\u2284","nsub"],["\u2286","sube"],
		["\u2287","supe"],["\u2295","oplus"],["\u2297","otimes"],["\u22A5","perp"],
		["\u22C5","sdot"],["\u2308","lceil"],["\u2309","rceil"],["\u230A","lfloor"],
		["\u230B","rfloor"],["\u2329","lang"],["\u232A","rang"],["\u25CA","loz"],
		["\u2660","spades"],["\u2663","clubs"],["\u2665","hearts"],["\u2666","diams"],
		["\u0152","OElig"],["\u0153","oelig"],["\u0160","Scaron"],["\u0161","scaron"],
		["\u0178","Yuml"],["\u02C6","circ"],["\u02DC","tilde"],["\u2002","ensp"],
		["\u2003","emsp"],["\u2009","thinsp"],["\u200C","zwnj"],["\u200D","zwj"],
		["\u200E","lrm"],["\u200F","rlm"],["\u2013","ndash"],["\u2014","mdash"],
		["\u2018","lsquo"],["\u2019","rsquo"],["\u201A","sbquo"],["\u201C","ldquo"],
		["\u201D","rdquo"],["\u201E","bdquo"],["\u2020","dagger"],["\u2021","Dagger"],
		["\u2030","permil"],["\u2039","lsaquo"],["\u203A","rsaquo"]
	];
	
	dhe.encode = function(str/*string*/, m /*array?*/){
		// summary:
		//		Function to obtain an entity encoding for a specified character
		// str:
		//		The string to process for possible entity encoding.
		// m:
		//		An optional list of character to entity name mappings (array of
		//		arrays).  If not provided, it uses the and Latin entities as the
		//		set to map and escape.
		// tags:
		//		public
		if(str){
			if(!m){
				// Apply the basic mappings.  HTML should always come first when decoding
				// as well.
				str = _applyEncodingMap(str, dhe.html);
				str = _applyEncodingMap(str, dhe.latin);
	
			}else{
				str = _applyEncodingMap(str, m);
			}
		}
		return str;
	};
	
	dhe.decode = function(str/*string*/, m /*array?*/){
		// summary:
		//		Function to obtain an entity encoding for a specified character
		// str:
		//		The string to process for possible entity encoding to decode.
		// m:
		//		An optional list of character to entity name mappings (array of
		//		arrays).  If not provided, it uses the HTML and Latin entities as the
		//		set to map and decode.
		// tags:
		//		public
		if(str){
			if(!m){
				// Apply the basic mappings.  HTML should always come first when decoding
				// as well.
				str = _applyDecodingMap(str, dhe.html);
				str = _applyDecodingMap(str, dhe.latin);
	
			}else{
				str = _applyDecodingMap(str, m);
			}
		}
		return str;
	};
	return dhe;
});


},
'style-guide/v1/forms/FileDragDropLimitSummary':function(){
define([
    'dojo/dom',
    'dojo/dom-class',
    'dojo/on',
    'dojo/_base/lang',
    'dojo/_base/declare',
    'dijit/_WidgetBase',
    'dojo/text!./templates/FileDragDropLimitSummary.html',
    'soso/sosox/ejs/_Templated'
], function(dom, domClass, on, lang, declare, _WidgetBase, template, _TemplatedMixin) {
    const DEFAULT_FILE_LABEL = 'attachment';

    return declare('style-guide.v1.forms.file-drag-drop-limit-summary', [_WidgetBase, _TemplatedMixin], {
        templateString: template,

        dragDropEnabled: true,
        uploadMegabytesLimit: null,
        attachmentCountLimit: null,
        fileLabel: DEFAULT_FILE_LABEL,

        data: {
            dragDropEnabled: true,
            uploadMegabytesLimit: null,
            attachmentCountLimit: null,
            fileCount: null,
            remainingFileCount: null
        },

        postMixInProperties: function () {
            this.data.fileLabel = this.fileLabel;

            this.setCustomViewHelpers({
                capitalise: function(value) {
                    return value.charAt(0).toUpperCase() + value.slice(1);
                }
            });
        },

        setFileCount: function(fileCount) {
            this.data.dragDropEnabled = this.dragDropEnabled;
            this.data.uploadMegabytesLimit = this.uploadMegabytesLimit;
            this.data.attachmentCountLimit = this.attachmentCountLimit;
            this.data.fileCount = fileCount;
            this.data.remainingFileCount = this.attachmentCountLimit - fileCount;

            this.render();
        }
    })
});

},
'style-guide/v1/forms/FileDragDropTableRow':function(){
define([
    "spencer/format/Megabytes",
    "spencer/parse/FilenameToExtension",
    'dijit/_WidgetBase',
    'dojo/_base/declare',
    'dojo/text!./templates/FileDragDropTableRow.html',
    'soso/sosox/ejs/_Templated',
    'style-guide/v1/icons/FileToIconClass'
], function(
    Megabytes,
    FilenameToExtension,
    _WidgetBase,
    declare,
    template,
    _TemplatedMixin,
    FileToIconClass
) {
    return declare('style-guide.v1.forms.file-drag-drop-table-row', [_WidgetBase, _TemplatedMixin], {
        templateString: template,

        data: {
            name: null,
            type: null,
            size: 0, 
            uploaded: false,
            statusMessageUploaded: 'Uploaded'
        },
        removeAttachmentButton: null,

        postMixInProperties: function() {
            this.inherited(arguments);
            this.setCustomViewHelpers({
                megabytes: new Megabytes(),
                filenameToExtension: new FilenameToExtension(),
                fileToIconClass: new FileToIconClass()
            });
        }
    });
});

},
'@lib/doc-control/tree/NodeFromPath':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class NodeFromPath {
        static find(treeNode, path, ignoredNodeTypes = []) {
            if (!Array.isArray(path) || path.length === 0)
                return null;
            let found = null;
            if (treeNode.isRootNode()) {
                const children = treeNode.getChildren();
                for (let i = 0; i < children.length; i++) {
                    found = NodeFromPath.find(children[i], path, ignoredNodeTypes);
                    if (found)
                        return found;
                }
                return null;
            }
            if (!ignoredNodeTypes.includes(treeNode.getType())
                && NodeFromPath.stripExampleDocumentReferenceAndReferenceFormatFromName(treeNode).toLowerCase() === path[0].toLowerCase()) {
                if (path.length === 1)
                    return treeNode;
                const children = treeNode.getChildren();
                for (let i = 0; i < children.length; i++) {
                    found = NodeFromPath.find(children[i], path.slice(1), ignoredNodeTypes);
                    if (found)
                        return found;
                }
            }
            return null;
        }
        static stripExampleDocumentReferenceAndReferenceFormatFromName(node) {
            if (!node.getReferenceFormat())
                return node.getName().replace(/^(.*) \(e\.g\. .+\)$/, '$1');
            const referencePrefix = node.getReferenceFormat().split('%')[0];
            const regex = new RegExp(`^(.*) \\((${referencePrefix}.+|e\.g\. .+)\\)$`);
            return node.getName().replace(regex, '$1');
        }
    }
    return NodeFromPath;
});

},
'soso/dijit/form/api/project/stage/SearchableSelect':function(){
define([
    'api/project/Factory',
    'api/project/Config',
    'api/project/data/ProjectStage',
    'dojo/_base/declare',
    'library/request/data/Handlers',
    'library/request/dojo/URLConnectionProcessorBuilder',
    'library/request/helper/DefaultUnauthorisedCallback',
    'library/request/URLConnectionBuilder',
    'library/request/URLResponseProcessorBuilder',
    'spencer/core/filter/Collection',
    'style-guide/v1/forms/searchable-select/Selector',
    '../StageTitleFormatter'
], function(
    ProjectFactory,
    ProjectConfig,
    ProjectStageVO,
    declare,
    HandlersVO,
    URLConnectionProcessorBuilder,
    DefaultUnauthorisedCallback,
    URLConnectionBuilder,
    URLResponseProcessorBuilder,
    FilterCollection,
    Selector,
    ProjectStageTitleFormatter
) {
    return declare([Selector], {
        placeholder: 'Select project stage...',
        icon: 'folder-closed',
        limit: 10,
        validationPromptRight: false,
        filterCollection: new FilterCollection(),

        getProjectStagePK: function() {
            return this.value ? this.value.getProjectStagePK() : null;
        },

        setProjectStagePK: function(projectStagePK) {
            if(!this.projectStage) {
                this.projectStage = (new ProjectFactory(
                    new ProjectConfig(),
                    new URLConnectionBuilder(
                        new URLConnectionProcessorBuilder()
                    ),
                    new URLResponseProcessorBuilder()
                )).getProjectStage();
            }

            const projectStageVO = (new ProjectStageVO()).setProjectStagePK(projectStagePK);
            this.value = projectStageVO;

            this.projectStage.get(
                new HandlersVO(
                    function success(projectStage) {
                        this.set('value', projectStage);
                        this.onChange(projectStage);
                    }.bind(this),
                    function progress(){},
                    DefaultUnauthorisedCallback,
                    function error(response){
                        console.error(response)
                        this.reset();
                    },
                    function abort() {
                    }

                ),
                projectStageVO
            )
        },

        query: function(promise, options) {
            if(!this.projectStageCollection) {
                this.projectStageCollection = (new ProjectFactory(
                    new ProjectConfig(),
                    new URLConnectionBuilder(
                        new URLConnectionProcessorBuilder()
                    ),
                    new URLResponseProcessorBuilder()
                )).getProjectStageCollection();
            }

            this.projectStageCollection.setQuery(options.filter);
            this.projectStageCollection.setLimit(options.limit || this.limit);
            this.projectStageCollection.setOffset(options.offset);
            this.projectStageCollection.fetch(
                new HandlersVO(
                    function success(response) {
                        promise.resolve(response);
                    },
                    function progress(){},
                    function unauthorised(){
                        promise.reject();
                        DefaultUnauthorisedCallback();
                    },
                    function error(response){
                        promise.reject();
                        console.error(response)
                    },
                    function abort() {
                        promise.reject();
                    }
                ),
                this.filterCollection
            );
        },

        searchAttr: function(projectStage) {
            return (new ProjectStageTitleFormatter()).format(projectStage);
        },

        isValid: function() {
            return this.validate();
        }
    });
});

},
'style-guide/v1/doc-control/registration-details/RegistrationDetails':function(){
define([
    'dojo/_base/declare',
    'dojo/text!./template/RegistrationDetails.html',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated',
    'style-guide/v1/doc-control/registration-details/Correspondence',
    'style-guide/v1/doc-control/registration-details/Default',
    'style-guide/v1/doc-control/registration-details/Drawing',
    'style-guide/v1/doc-control/registration-details/Revisionable',
    'style-guide/v1/doc-control/registration-details/RevisionableFromFunction'
], function(
    declare,
    template,
    _WidgetBase,
    _Templated,
    CorrespondenceForm,
    DefaultForm,
    DrawingForm,
    RevisionableForm,
    RevisionableFromFunctionForm
) {
    const NODE_TYPE_CORRESPONDENCE = 'correspondence';
    const NODE_TYPE_DRAWING = 'drawing';
    const NODE_TYPE_REVISIONABLE = 'revisionable';
    const NODE_TYPE_FUNCTION = 'function';

    return declare([_WidgetBase, _Templated], {
        documentViewer: null,
        originatorContactData: null,
        recipientContactData: null,
        currentContact: null,
        registrationDetails: null,
        elementForm: null,
        form: null,
        file: null,
        templateString: template,
        setRegisterButtonDisabled: null,
        privacyChangesAllowed: false,
        projectOverviewUrl: null,
        disabled: true,

        isValid: function() {
            if (!this.form) {
                return false;
            }

            return this.form.isValid();
        },

        getError: function() {
            return this.form.getError();
        },

        setRegistrationDetails: function(registrationDetails) {
            this.registrationDetails = registrationDetails;

            this.render();
        },

        getRegistrationDetails: function() {
            if (this.form && this.isValid()) {
                this._updateRegistrationDetails(this.form.getDetails());
            }

            return this.registrationDetails;
        },

        setDate: function(date) {
            if (this.form) {
                this.form.setDate(date);
            }

            this.date = date;
        },

        setDiscipline: function(discipline) {
            this.registrationDetails.discipline = discipline;

            if (this.form && this.form.setDiscipline) {
                this.form.setDiscipline(discipline);
            }
        },

        setOriginatorContact: function(originatorContactData) {
            this.originatorContactData = originatorContactData;

            this.render();
        },

        getOriginatorContact: function() {
            return this.originatorContactData;
        },

        setRecipientContact: function(recipientContactData) {
            this.recipientContactData = recipientContactData;

            this.render();
        },

        setReference: function(reference) {
            if (this.form && typeof this.form.setReference == 'function') {
                this.form.setReference(reference);
            }
        },

        setNodeReference: function(nodeReference) {
            if (this.form && typeof this.form.setNodeReference === 'function') {
                this.form.setNodeReference(nodeReference);
            }
        },

        setRevision: function(revision) {
            if (this.form && typeof this.form.setRevision == 'function') {
                this.form.setRevision(revision);
            }
        },

        setStatus: function(status) {
            this.registrationDetails.status = status;
        },

        setStatusCode: function(statusCode) {
            if (this.form && typeof this.form.setStatusCode == 'function') {
                this.form.setStatusCode(statusCode);
            }
        },

        getRecipientContact: function() {
            return this.recipientContactData;
        },

        setCurrentContact: function(currentContact) {
            this.currentContact = currentContact;

            this.render();
        },

        setFile: function(file) {
            this.file = file;
            return this;
        },

        setTitle: function(title) {
            if(this.form) {
                this.form.setTitle(title);
            }

            return this;
        },

        removeError: function() {
            if (this.form) {
                this.form.removeError();
            }
        },

        reset: function() {
            this.originatorContactData = null;
            this.registrationDetails = null;
            this.disabled = true;
            this.removeError();

            this.render();
        },

        render: function() {
            this.inherited(arguments);

            this._initForm();

            if(this.privacyChangesAllowed) {
                this.form.allowPrivacyChanges();
            }
        },

        invalidateReferenceNumber: function(errorMessage) {
            this.form.invalidateReferenceNumber(errorMessage);
        },

        invalidateRevisionNumber: function(errorMessage) {
            this.form.invalidateRevisionNumber(errorMessage);
        },

        allowPrivacyChanges: function() {
            this.privacyChangesAllowed = true;

            if(this.form) {
                this.form.allowPrivacyChanges();
            }

            return this;
        },

        disable: function() {
            this.disabled = true;
            this.render();
            this.setRegisterButtonDisabled(true);
        },

        enable: function() {
            this.disabled = false;
        },

        _initForm: function() {
            if (!this.registrationDetails || !this.registrationDetails.type) {
                this._prepareEmptyDefaultForm();
                this._resetRegistrationDetails();
                return;
            }

            switch (this.registrationDetails.type.toLowerCase()) {
                case(NODE_TYPE_CORRESPONDENCE):
                    this._prepareCorrespondenceForm();
                    this._resetRegistrationDetails();
                    return;
                case(NODE_TYPE_DRAWING):
                    this._prepareDrawingForm();
                    this._resetRegistrationDetails();
                    return;
                case(NODE_TYPE_FUNCTION):
                    this._prepareRevisionableFromFunctionForm();
                    this._resetRegistrationDetails();
                    return;
                case(NODE_TYPE_REVISIONABLE):
                    this._prepareRevisionableForm();
                    this._resetRegistrationDetails();
                    return;
                default:
                    this._prepareDefaultForm();
                    this._resetRegistrationDetails();
                    return;
            }
        },

        _resetRegistrationDetails: function () {
            this.registrationDetails = {}
        },

        _updateRegistrationDetails: function(details) {
            if (details.personPK) {
                this.registrationDetails.personPK = details.personPK;
            }

            if (details.branchOfficePK) {
                this.registrationDetails.branchOfficePK = details.branchOfficePK;
            }

            if (details.originatorContact) {
                this.registrationDetails.originatorContact = details.originatorContact;
            }

            if (details.recipientContact) {
                this.registrationDetails.recipientContact = details.recipientContact;
            }

            if (details.title) {
                this.registrationDetails.title = details.title;
            }

            if (details.date) {
                this.registrationDetails.date = details.date;
            }

            this.registrationDetails.isPrivate = Boolean(details.isPrivate);

            if (details.discipline) {
                this.registrationDetails.discipline = details.discipline;
            }

            if (details.disciplineVO) {
                this.registrationDetails.disciplineVO = details.disciplineVO;
            }

            if (details.status) {
                this.registrationDetails.status = details.status;
            }

            if (details.statusVO) {
                this.registrationDetails.statusVO = details.statusVO;
            }

            if (details.revision) {
                this.registrationDetails.revision = details.revision;
            }

            if (details.reference) {
                this.registrationDetails.reference = details.reference;
            }

            if (details.md5) {
                this.registrationDetails.md5 = details.md5;
            }

            if (details.treeViewPK) {
                this.registrationDetails.treeViewPK = details.treeViewPK;
            }

            if (details.type) {
                this.registrationDetails.type = details.type;
            }

            if (details.nodeReference) this.registrationDetails.nodeReference = details.nodeReference;

            if (details.location) {
                this.registrationDetails.location = details.location;
            }

            if (details.projectStagePK) {
                this.registrationDetails.projectStagePK = details.projectStagePK;
            }
        },

        _prepareEmptyDefaultForm: function() {
            this.form = new DefaultForm({
                disabled: this.disabled,
                currentContact: this.currentContact,
                privacyChangesAllowed: this.privacyChangesAllowed,
                originatorContact: this._getOriginatorContactData()
            }, this.elementForm);
        },

        _prepareDefaultForm: function() {
            this.form = new DefaultForm({
                disabled: this.disabled,
                title: this.registrationDetails.title,
                originatorContact: this._getOriginatorContactData(),
                currentContact: this.currentContact,
                date: this.registrationDetails.date || this.date || null,
                isPrivate: this.registrationDetails.isPrivate,
                md5: this.registrationDetails.md5,
                projectStageTreeViewPK: this.registrationDetails.treeViewPK,
                type: this.registrationDetails.type,
                location: this.registrationDetails.location,
                projectStagePK: this.registrationDetails.projectStagePK
            }, this.elementForm);
        },

        _prepareDrawingForm: function() {
            this.form = new DrawingForm({
                documentViewer: this.documentViewer,
                title: this.registrationDetails.title,
                originatorContact: this._getOriginatorContactData(),
                currentContact: this.currentContact,
                date: this.registrationDetails.date || this.date || null,
                isPrivate: this.registrationDetails.isPrivate,
                discipline: this.registrationDetails.discipline || null,
                status: this.registrationDetails.status || null,
                statusVO: this.registrationDetails.statusVO || null,
                revision: this.registrationDetails.revision || null,
                reference: this.registrationDetails.reference || null,
                setRegisterButtonDisabled: this.setRegisterButtonDisabled,
                projectOverviewUrl: this.projectOverviewUrl,
                projectStagePK: this.registrationDetails.projectStagePK,
                projectStageTreeViewPK: this.registrationDetails.treeViewPK,
                md5: this.registrationDetails.md5,
                type: this.registrationDetails.type,
                location: this.registrationDetails.location
            }, this.elementForm);
        },

        _prepareRevisionableFromFunctionForm: function() {
            this.form = new RevisionableFromFunctionForm({
                documentViewer: this.documentViewer,
                title: this.registrationDetails.title,
                originatorContact: this._getOriginatorContactData(),
                currentContact: this.currentContact,
                date: this.registrationDetails.date || this.date || null,
                isPrivate: this.registrationDetails.isPrivate,
                status: this.registrationDetails.status || null,
                statusVO: this.registrationDetails.statusVO || null,
                revision: this.registrationDetails.revision || null,
                reference: this.registrationDetails.reference || null,
                projectStagePK: this.registrationDetails.projectStagePK,
                projectStageTreeViewPK: this.registrationDetails.treeViewPK,
                md5: this.registrationDetails.md5,
                type: this.registrationDetails.type,
                nodeReference: this.registrationDetails.nodeReference,
                location: this.registrationDetails.location
            }, this.elementForm);
        },

        _prepareRevisionableForm: function() {
            this.form = new RevisionableForm({
                documentViewer: this.documentViewer,
                title: this.registrationDetails.title,
                originatorContact: this._getOriginatorContactData(),
                currentContact: this.currentContact,
                date: this.registrationDetails.date || this.date || null,
                isPrivate: this.registrationDetails.isPrivate,
                status: this.registrationDetails.status || null,
                statusVO: this.registrationDetails.statusVO || null,
                revision: this.registrationDetails.revision || null,
                reference: this.registrationDetails.reference || null,
                setRegisterButtonDisabled: this.setRegisterButtonDisabled,
                projectOverviewUrl: this.projectOverviewUrl,
                projectStagePK: this.registrationDetails.projectStagePK,
                projectStageTreeViewPK: this.registrationDetails.treeViewPK,
                md5: this.registrationDetails.md5,
                type: this.registrationDetails.type,
                location: this.registrationDetails.location
            }, this.elementForm);
        },

        _prepareCorrespondenceForm: function() {
            this.form = new CorrespondenceForm({
                title: this.registrationDetails.title,
                originatorContact: this._getOriginatorContactData(),
                recipientContact: this._getRecipientContactData(),
                currentContact: this.currentContact,
                date: this.registrationDetails.date || this.date || null,
                isPrivate: this.registrationDetails.isPrivate,
                reference: this.registrationDetails.reference || null,
                md5: this.registrationDetails.md5,
                projectStageTreeViewPK: this.registrationDetails.treeViewPK,
                type: this.registrationDetails.type,
                location: this.registrationDetails.location,
                projectStagePK: this.registrationDetails.projectStagePK
            }, this.elementForm);
        },

        _getOriginatorContactData: function() {
            return (this.registrationDetails && this.registrationDetails.originatorContact)
                || this.originatorContactData
                || this.currentContact
                || null;
        },

        _getRecipientContactData: function() {
            if (this.registrationDetails.recipientContact) {
                return this.registrationDetails.recipientContact;
            }

            return this.recipientContactData;
        }
    });
});


},
'style-guide/v1/doc-control/registration-details/Correspondence':function(){
define([
    './Base',
    'api/Factory',
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/text!./template/Correspondence.html',
    'dijit/form/DateTextBox',
    'dijit/form/Select',
    'soso/dijit/form/api/contact/FilteringSelect',
    'soso/sosox/ejs/_Templated',
    'spencer/date-time/Format',
    'style-guide/v1/forms/searchable-select/Selector',
    'library/request/data/Handlers',
    'library/request/helper/DefaultUnauthorisedCallback',
    'spencer/format/BranchOfficeEmail',
    'spencer/format/PersonDisplayName',
    'spencer/format/OrganisationDisplayName'
], function(
    Base,
    ApiFactory,
    declare,
    domAttr,
    domClass,
    template,
    DateTextBox,
    Select,
    ContactFilteringSelect,
    _Templated,
    DateTimeFormat,
    SearchableSelect,
    Handlers,
    DefaultUnauthorisedCallback,
    BranchOfficeEmailFormatter,
    PersonDisplayNameFormatter,
    OrganisationNameFormatter
) {
    return declare('style-guide.v1.forms.registration-details.drawing', [Base, _Templated], {
        dateTimeFormat: null,
        elementInputDate: null,
        elementInputOriginator: null,
        elementInputTitle: null,
        elementInputIsPrivate: null,
        elementInputRecipient: null,
        elementInputReference: null,
        elementTitleValidation: null,
        elementReferenceError: null,
        elementReferenceValidation: null,
        elementRevisionNumberError: null,
        elementRevisionValidation: null,
        error: '',
        inputDate: null,
        inputOriginator: null,
        inputRecipient: null,
        date: null,
        title: null,
        originatorContact: null,
        recipientPK: null,
        isPrivate: null,
        discipline: null,
        reference: null,
        md5: null,
        projectStageTreeViewPK: null,
        type: null,
        location: null,
        projectStagePK: null,

        templateString: template,

        postCreate: function() {
            this.inherited(arguments);

            this.dateTimeFormat = new DateTimeFormat();

            this._initForm();
        },

        getDetails: function() {
            const originator = this.inputOriginator.get('value');
            const recipient = this.inputRecipient.get('item');

            return {
                personPK: originator ? originator.getPersonPK() : null,
                branchOfficePK: originator ? originator.getBranchOfficePK() : null,
                originatorContact: originator,
                recipientContact: recipient,
                title: domAttr.get(this.elementInputTitle, 'value'),
                date: this.dateTimeFormat.toLocaleISOString(this.inputDate.get('value')),
                isPrivate: domAttr.get(this.elementInputIsPrivate, 'checked'),
                reference: domAttr.get(this.elementInputReference, 'value'),
                md5: this.md5,
                treeViewPK: this.projectStageTreeViewPK,
                type: this.type,
                location: this.location,
                projectStagePK: this.projectStagePK,
            };
        },

        getError: function() {
            return this.error;
        },

        removeError: function() {
            this.error = '';
        },

        isValid: function() {
            if (this.inputOriginator.get('value') &&
                domAttr.get(this.elementInputTitle, 'value') !== '' &&
                domAttr.get(this.elementInputReference, 'value') !== '' &&
                this.inputDate.get('value')
            ) {
                return true;
            }

            this._validate();
            return false;
        },

        setTitle: function(title) {
            this.title = title;
            domAttr.set(this.elementInputTitle, 'value', title);
            return this;
        },

        setReference: function(reference) {
            domAttr.set(this.elementInputReference, 'value', reference);
            return this;
        },

        setDate: function(date) {
            if (date instanceof Date) {
                this.inputDate.set('value', date);
                return this;
            }

            this.inputDate.set('displayedValue', date);
            this.inputDate._hasBeenBlurred = true;
            this.inputDate.validate();
            return this;
        },

        _validate: function() {
            this.inputOriginator.validate();
            this.inputRecipient.validate();
            this.inputDate.validate();

            if (domAttr.get(this.elementInputTitle, 'value')) {
                domClass.remove(this.elementTitleValidation, 'sos-form-textfield-validation-error');
            } else {
                domClass.add(this.elementTitleValidation, 'sos-form-textfield-validation-error');
            }

            this.elementReferenceError.innerHTML = 'Document Reference Number is required';
            if (domAttr.get(this.elementInputReference, 'value')) {
                domClass.remove(this.elementReferenceValidation, 'sos-form-textfield-validation-error');
            } else {
                domClass.add(this.elementReferenceValidation, 'sos-form-textfield-validation-error');
            }
        },

        _initForm: function() {
            this._initInputDate();
            this._initDocumentOriginatorFilteringSelect();
            this._initRecipientFilteringSelect();

            this._initFormValues();
        },

        _initDocumentOriginatorFilteringSelect: function() {
            const api = (new ApiFactory())
                .getContactFactory()
                .getContactCollection();

            const branchOfficeEmailFormatter = new BranchOfficeEmailFormatter(
                new OrganisationNameFormatter()
            );

            const personDisplayNameFormatter = new PersonDisplayNameFormatter();

            this.inputOriginator = new SearchableSelect({
                searchAttr: function(result) {
                    branchOfficeEmailFormatter.reset();
                    personDisplayNameFormatter.reset();

                    if(result.organisationPK) {
                        branchOfficeEmailFormatter.setOrganisationName(result.organisation || null);
                        branchOfficeEmailFormatter.setName(result.name || null);
                        branchOfficeEmailFormatter.setEmail(result.email || null);

                        return branchOfficeEmailFormatter.format();
                    }

                    personDisplayNameFormatter.setDisplayName(result.preferredName || result.displayName || result.name || null);
                    personDisplayNameFormatter.setJobTitle(result.jobTitle || null);
                    personDisplayNameFormatter.setOrganisation(result.organisation || null);

                    return personDisplayNameFormatter.format();
                },
                query: function(promise, options) {
                    api.setLimit(options.limit);
                    api.setOffset(options.offset);
                    api.setQuery(options.filter);

                    api.fetch(
                        new Handlers(
                            function success(response) {
                                promise.resolve(response);
                            },
                            function progress() {},
                            DefaultUnauthorisedCallback
                        )
                    );
                },
                icon: function(result) {
                    if(result.personPK) {
                        return 'user-o';
                    }

                    if(result.organisationPK) {
                        return 'building-o';
                    }
                },
                limit: 50,
                required: true,
                disabled: this.disabled
            }, this.elementInputOriginator);

            if (this.originatorContact) {
                this.inputOriginator.set('value', this.originatorContact);
            }
        },

        _initRecipientFilteringSelect: function() {
            this.inputRecipient = new ContactFilteringSelect({
                autoComplete: false,
                'class': 'sos-form-filtering-select'
            }, this.elementInputRecipient);

            if (this.recipientContact) {
                this.inputRecipient.setContactVO(this.recipientContact);
            }
        },

        _initInputDate: function() {
            this.inputDate = new DateTextBox({
                'class': 'sos-date-text-box',
                'constraints':{
                    'datePattern':'dd/MM/yyyy'
                },
                'placeHolder':'Select date',
                'value' : this.date ? this.date : new Date(),
                dropDownPosition: ['below'],
                required: true
            }, this.elementInputDate);
            this.inputDate.startup();
        },

        _initFormValues: function() {
            if (this.title) {
                domAttr.set(this.elementInputTitle, 'value', this.title);
            }

            if (this.isPrivate) {
                domAttr.set(this.elementInputIsPrivate, 'checked', 'checked');
            }

            if (this.reference) {
                domAttr.set(this.elementInputReference, 'value', this.reference);
            }
        },

        _setOriginatorToCurrentPerson: function() {
            this.inputOriginator.set('value', this.currentContact);
        }
    });
});

},
'style-guide/v1/doc-control/registration-details/Base':function(){
define([
    'dojo/_base/declare',
    'dojo/dom-class',
    'dijit/_WidgetBase'
], function(
    declare,
    domClass,
    WidgetBase
) {
   return declare(WidgetBase, {
       privacyToggle: null,
       currentContact: null,
       setToMeElement: null,

       postCreate: function() {
           this.inherited(arguments);
           if (this.setToMeElement && !this.currentContact) {
               this.setToMeElement.setAttribute('hidden', true);
           }
       },

       allowPrivacyChanges: function() {
           if(domClass.contains(this.privacyToggle, 'hide')) {
               domClass.remove(this.privacyToggle, 'hide');
           }

           return this;
       },

       invalidateReferenceNumber: function(errorMessage) {
           if (this.elementReferenceError) {
               this.elementReferenceError.innerHTML = errorMessage;
           }
           if (this.elementReferenceValidation) {
               domClass.add(this.elementReferenceValidation, 'sos-form-textfield-validation-error');
           }
       },

       invalidateRevisionNumber: function(errorMessage) {
           if (this.elementRevisionNumberError) {
               this.elementRevisionNumberError.innerHTML = errorMessage;
           }
           if (this.elementRevisionValidation) {
               domClass.add(this.elementRevisionValidation, 'sos-form-textfield-validation-error');
           }
       }
   });
});
},
'dijit/form/DateTextBox':function(){
define([
	"dojo/_base/declare", // declare
	"../Calendar",
	"./_DateTimeTextBox"
], function(declare, Calendar, _DateTimeTextBox){

	// module:
	//		dijit/form/DateTextBox

	return declare("dijit.form.DateTextBox", _DateTimeTextBox, {
		// summary:
		//		A validating, serializable, range-bound date text box with a drop down calendar
		// example:
		// |	new DateTextBox({value: new Date(2009, 0, 20)})
		// example:
		// |	<input data-dojo-type='dijit/form/DateTextBox' value='2009-01-20'>

		baseClass: "dijitTextBox dijitComboBox dijitDateTextBox",
		popupClass: Calendar,
		_selector: "date",

		// Prevent scrollbar on Calendar dropdown.  On iPad it often gets a scrollbar unnecessarily because Viewport
		// thinks the keyboard is showing.  Even if the keyboard is showing, it disappears when the calendar gets focus.
		maxHeight: Infinity,

		// value: Date
		//		The value of this widget as a JavaScript Date object, with only year/month/day specified.
		//		If specified in markup, use the format specified in `stamp.fromISOString`.
		//		set("value", ...) accepts either a Date object or a string.
		value: new Date("")	// value.toString()="NaN"
	});
});

},
'dijit/Calendar':function(){
define([
	"dojo/_base/array", // array.map
	"dojo/date",
	"dojo/date/locale",
	"dojo/_base/declare", // declare
	"dojo/dom-attr", // domAttr.get
	"dojo/dom-class", // domClass.add domClass.contains domClass.remove domClass.toggle
	"dojo/dom-construct",	// create
	"dojo/_base/kernel", // kernel.deprecated
	"dojo/keys", // keys
	"dojo/_base/lang", // lang.hitch
	"dojo/on",
	"dojo/sniff", // has("ie")
	"./CalendarLite",
	"./_Widget",
	"./_CssStateMixin",
	"./_TemplatedMixin",
	"./form/DropDownButton"
], function(array, date, local, declare, domAttr, domClass, domConstruct, kernel, keys, lang, on, has,
			CalendarLite, _Widget, _CssStateMixin, _TemplatedMixin, DropDownButton){

	// module:
	//		dijit/Calendar

	// _Widget for deprecated methods like setAttribute()
	var Calendar = declare("dijit.Calendar", [CalendarLite, _Widget, _CssStateMixin], {
		// summary:
		//		A simple GUI for choosing a date in the context of a monthly calendar.
		//
		// description:
		//		See CalendarLite for general description.   Calendar extends CalendarLite, adding:
		//
		//		- month drop down list
		//		- keyboard navigation
		//		- CSS classes for hover/mousepress on date, month, and year nodes
		//		- support of deprecated methods (will be removed in 2.0)

		baseClass: "dijitCalendar",

		// Set node classes for various mouse events, see dijit._CssStateMixin for more details
		cssStateNodes: {
			"decrementMonth": "dijitCalendarArrow",
			"incrementMonth": "dijitCalendarArrow",
			"previousYearLabelNode": "dijitCalendarPreviousYear",
			"nextYearLabelNode": "dijitCalendarNextYear"
		},

		setValue: function(/*Date*/ value){
			// summary:
			//		Deprecated.   Use set('value', ...) instead.
			// tags:
			//		deprecated
			kernel.deprecated("dijit.Calendar:setValue() is deprecated.  Use set('value', ...) instead.", "", "2.0");
			this.set('value', value);
		},

		_createMonthWidget: function(){
			// summary:
			//		Creates the drop down button that displays the current month and lets user pick a new one

			return new Calendar._MonthDropDownButton({
				id: this.id + "_mddb",
				tabIndex: -1,
				onMonthSelect: lang.hitch(this, "_onMonthSelect"),
				lang: this.lang,
				dateLocaleModule: this.dateLocaleModule
			}, this.monthNode);
		},

		postCreate: function(){
			this.inherited(arguments);

			// Events specific to Calendar, not used in CalendarLite
			this.own(
				on(this.domNode, "keydown", lang.hitch(this, "_onKeyDown")),
				on(this.dateRowsNode, "mouseover", lang.hitch(this, "_onDayMouseOver")),
				on(this.dateRowsNode, "mouseout", lang.hitch(this, "_onDayMouseOut")),
				on(this.dateRowsNode, "mousedown", lang.hitch(this, "_onDayMouseDown")),
				on(this.dateRowsNode, "mouseup", lang.hitch(this, "_onDayMouseUp"))
			);
		},

		_onMonthSelect: function(/*Number*/ newMonth){
			// summary:
			//		Handler for when user selects a month from the drop down list
			// tags:
			//		protected

			// move to selected month, bounding by the number of days in the month
			// (ex: jan 31 --> feb 28, not feb 31)
			var date = new this.dateClassObj(this.currentFocus);
			date.setDate(1);
			date.setMonth(newMonth);
			var daysInMonth = this.dateModule.getDaysInMonth(date);
			var currentDate = this.currentFocus.getDate();
			date.setDate(Math.min(currentDate, daysInMonth));
			this._setCurrentFocusAttr(date);
		},

		_onDayMouseOver: function(/*Event*/ evt){
			// summary:
			//		Handler for mouse over events on days, sets hovered style
			// tags:
			//		protected

			// event can occur on <td> or the <span> inside the td,
			// set node to the <td>.
			var node =
				domClass.contains(evt.target, "dijitCalendarDateLabel") ?
					evt.target.parentNode :
					evt.target;

			if(node && (
				(node.dijitDateValue && !domClass.contains(node, "dijitCalendarDisabledDate"))
					|| node == this.previousYearLabelNode || node == this.nextYearLabelNode
				)){
				domClass.add(node, "dijitCalendarHoveredDate");
				this._currentNode = node;
			}
		},

		_onDayMouseOut: function(/*Event*/ evt){
			// summary:
			//		Handler for mouse out events on days, clears hovered style
			// tags:
			//		protected

			if(!this._currentNode){
				return;
			}

			// if mouse out occurs moving from <td> to <span> inside <td>, ignore it
			if(evt.relatedTarget && evt.relatedTarget.parentNode == this._currentNode){
				return;
			}
			var cls = "dijitCalendarHoveredDate";
			if(domClass.contains(this._currentNode, "dijitCalendarActiveDate")){
				cls += " dijitCalendarActiveDate";
			}
			domClass.remove(this._currentNode, cls);
			this._currentNode = null;
		},

		_onDayMouseDown: function(/*Event*/ evt){
			var node = evt.target.parentNode;
			if(node && node.dijitDateValue && !domClass.contains(node, "dijitCalendarDisabledDate")){
				domClass.add(node, "dijitCalendarActiveDate");
				this._currentNode = node;
			}
		},

		_onDayMouseUp: function(/*Event*/ evt){
			var node = evt.target.parentNode;
			if(node && node.dijitDateValue){
				domClass.remove(node, "dijitCalendarActiveDate");
			}
		},

		handleKey: function(/*Event*/ evt){
			// summary:
			//		Provides keyboard navigation of calendar.
			// description:
			//		Called from _onKeyDown() to handle keydown on a stand alone Calendar,
			//		and also from `dijit/form/_DateTimeTextBox` to pass a keydown event
			//		from the `dijit/form/DateTextBox` to be handled in this widget
			// returns:
			//		False if the key was recognized as a navigation key,
			//		to indicate that the event was handled by Calendar and shouldn't be propagated
			// tags:
			//		protected
			var increment = -1,
				interval,
				newValue = this.currentFocus;
			switch(evt.keyCode){
				case keys.RIGHT_ARROW:
					increment = 1;
				//fallthrough...
				case keys.LEFT_ARROW:
					interval = "day";
					if(!this.isLeftToRight()){
						increment *= -1;
					}
					break;
				case keys.DOWN_ARROW:
					increment = 1;
				//fallthrough...
				case keys.UP_ARROW:
					interval = "week";
					break;
				case keys.PAGE_DOWN:
					increment = 1;
				//fallthrough...
				case keys.PAGE_UP:
					interval = evt.ctrlKey || evt.altKey ? "year" : "month";
					break;
				case keys.END:
					// go to the next month
					newValue = this.dateModule.add(newValue, "month", 1);
					// subtract a day from the result when we're done
					interval = "day";
				//fallthrough...
				case keys.HOME:
					newValue = new this.dateClassObj(newValue);
					newValue.setDate(1);
					break;
				default:
					return true;
			}

			if(interval){
				newValue = this.dateModule.add(newValue, interval, increment);
			}

			this._setCurrentFocusAttr(newValue);

			return false;
		},

		_onKeyDown: function(/*Event*/ evt){
			// summary:
			//		For handling keydown events on a stand alone calendar
			if(!this.handleKey(evt)){
				evt.stopPropagation();
				evt.preventDefault();
			}
		},

		onValueSelected: function(/*Date*/ /*===== date =====*/){
			// summary:
			//		Deprecated.   Notification that a date cell was selected.  It may be the same as the previous value.
			// description:
			//		Formerly used by `dijit/form/_DateTimeTextBox` (and thus `dijit/form/DateTextBox`)
			//		to get notification when the user has clicked a date.  Now onExecute() (above) is used.
			// tags:
			//		protected
		},

		onChange: function(value){
			this.onValueSelected(value);	// remove in 2.0
		},

		getClassForDate: function(/*===== dateObject, locale =====*/){
			// summary:
			//		May be overridden to return CSS classes to associate with the date entry for the given dateObject,
			//		for example to indicate a holiday in specified locale.
			// dateObject: Date
			// locale: String?
			// tags:
			//		extension

			/*=====
			 return ""; // String
			 =====*/
		}
	});

	Calendar._MonthDropDownButton = declare("dijit.Calendar._MonthDropDownButton", DropDownButton, {
		// summary:
		//		DropDownButton for the current month.    Displays name of current month
		//		and a list of month names in the drop down

		onMonthSelect: function(){
		},

		postCreate: function(){
			this.inherited(arguments);
			this.dropDown = new Calendar._MonthDropDown({
				id: this.id + "_mdd", //do not change this id because it is referenced in the template
				onChange: this.onMonthSelect
			});
		},
		_setMonthAttr: function(month){
			// summary:
			//		Set the current month to display as a label
			var monthNames = this.dateLocaleModule.getNames('months', 'wide', 'standAlone', this.lang, month);
			this.dropDown.set("months", monthNames);

			// Set name of current month and also fill in spacer element with all the month names
			// (invisible) so that the maximum width will affect layout.   But not on IE6 because then
			// the center <TH> overlaps the right <TH> (due to a browser bug).
			this.containerNode.innerHTML =
				(has("ie") == 6 ? "" : "<div class='dijitSpacer'>" + this.dropDown.domNode.innerHTML + "</div>") +
					"<div class='dijitCalendarMonthLabel dijitCalendarCurrentMonthLabel'>" + monthNames[month.getMonth()] + "</div>";
		}
	});

	Calendar._MonthDropDown = declare("dijit.Calendar._MonthDropDown", [_Widget, _TemplatedMixin, _CssStateMixin], {
		// summary:
		//		The list-of-months drop down from the MonthDropDownButton

		// months: String[]
		//		List of names of months, possibly w/some undefined entries for Hebrew leap months
		//		(ex: ["January", "February", undefined, "April", ...])
		months: [],

		baseClass: "dijitCalendarMonthMenu dijitMenu",

		templateString: "<div data-dojo-attach-event='ondijitclick:_onClick'></div>",

		_setMonthsAttr: function(/*String[]*/ months){
			this.domNode.innerHTML = "";
			array.forEach(months, function(month, idx){
				var div = domConstruct.create("div", {
					className: "dijitCalendarMonthLabel",
					month: idx,
					innerHTML: month
				}, this.domNode);
				div._cssState = "dijitCalendarMonthLabel";	// trigger _CSSStateMixin magic; property, not attribute.
			}, this);
		},

		_onClick: function(/*Event*/ evt){
			this.onChange(domAttr.get(evt.target, "month"));
		},

		onChange: function(/*Number*/ /*===== month =====*/){
			// summary:
			//		Callback when month is selected from drop down
		}
	});

	return Calendar;
});

},
'dijit/CalendarLite':function(){
define([
	"dojo/_base/array", // array.forEach array.map
	"dojo/_base/declare", // declare
	"dojo/cldr/supplemental", // cldrSupplemental.getFirstDayOfWeek
	"dojo/date", // date
	"dojo/date/locale",
	"dojo/date/stamp", // stamp.fromISOString
	"dojo/dom", // dom.setSelectable
	"dojo/dom-class", // domClass.contains
	"dojo/dom-attr",
	"dojo/_base/lang", // lang.getObject, lang.hitch
	"dojo/on",
	"dojo/sniff", // has("ie") has("webkit")
	"dojo/string", // string.substitute
	"./_WidgetBase",
	"./_TemplatedMixin",
	"dojo/text!./templates/Calendar.html",
	"./a11yclick",	// not used directly, but template has ondijitclick in it
	"./hccss"    // not used directly, but sets CSS class on <body>
], function(array, declare, cldrSupplemental, date, locale, stamp, dom, domClass, domAttr, lang, on, has, string, _WidgetBase, _TemplatedMixin, template){


	// module:
	//		dijit/CalendarLite

	var CalendarLite = declare("dijit.CalendarLite", [_WidgetBase, _TemplatedMixin], {
		// summary:
		//		Lightweight version of Calendar widget aimed towards mobile use
		//
		// description:
		//		A simple GUI for choosing a date in the context of a monthly calendar.
		//		This widget can't be used in a form because it doesn't serialize the date to an
		//		`<input>` field.  For a form element, use dijit/form/DateTextBox instead.
		//
		//		Note that the parser takes all dates attributes passed in the
		//		[RFC 3339 format](http://www.faqs.org/rfcs/rfc3339.html), e.g. `2005-06-30T08:05:00-07:00`
		//		so that they are serializable and locale-independent.
		//
		//		Also note that this widget isn't keyboard accessible; use dijit.Calendar for that
		// example:
		//	|	var calendar = new dijit.CalendarLite({}, dojo.byId("calendarNode"));
		//
		// example:
		//	|	<div data-dojo-type="dijit/CalendarLite"></div>

		// Template for main calendar
		templateString: template,

		// Template for cell for a day of the week (ex: M)
		dowTemplateString: '<th class="dijitReset dijitCalendarDayLabelTemplate" role="columnheader" scope="col"><span class="dijitCalendarDayLabel">${d}</span></th>',

		// Templates for a single date (ex: 13), and for a row for a week (ex: 20 21 22 23 24 25 26)
		dateTemplateString: '<td class="dijitReset" role="gridcell" data-dojo-attach-point="dateCells"><span class="dijitCalendarDateLabel" data-dojo-attach-point="dateLabels"></span></td>',
		weekTemplateString: '<tr class="dijitReset dijitCalendarWeekTemplate" role="row">${d}${d}${d}${d}${d}${d}${d}</tr>',

		// value: Date
		//		The currently selected Date, initially set to invalid date to indicate no selection.
		value: new Date(""),
		// TODO: for 2.0 make this a string (ISO format) rather than a Date

		// datePackage: String
		//		JavaScript namespace to find calendar routines.	 If unspecified, uses Gregorian calendar routines
		//		at dojo/date and dojo/date/locale.
		datePackage: "",
		//		TODO: for 2.0, replace datePackage with dateModule and dateLocalModule attributes specifying MIDs,
		//		or alternately just get rid of this completely and tell user to use module ID remapping
		//		via require

		// dayWidth: String
		//		How to represent the days of the week in the calendar header. See locale
		dayWidth: "narrow",

		// tabIndex: String
		//		Order fields are traversed when user hits the tab key
		tabIndex: "0",

		// dayOffset: Integer
		//		(Optional) The first day of week override. By default the first day of week is determined
		//		for the current locale (extracted from the CLDR).
		//		Special value -1 (default value), means use locale dependent value.
		dayOffset: -1,

		// currentFocus: Date
		//		Date object containing the currently focused date, or the date which would be focused
		//		if the calendar itself was focused.   Also indicates which year and month to display,
		//		i.e. the current "page" the calendar is on.
		currentFocus: new Date(),

		// Put the summary to the node with role=grid
		_setSummaryAttr: "gridNode",

		baseClass: "dijitCalendar dijitCalendarLite",

		_isValidDate: function(/*Date*/ value){
			// summary:
			//		Runs various tests on the value, checking that it's a valid date, rather
			//		than blank or NaN.
			// tags:
			//		private
			return value && !isNaN(value) && typeof value == "object" &&
				value.toString() != this.constructor.prototype.value.toString();
		},

		_getValueAttr: function(){
			// summary:
			//		Support get('value')

			// this.value is set to 1AM, but return midnight, local time for back-compat
			var storedVal = this._get("value");
			if(storedVal && !isNaN(storedVal)){
				var value = new this.dateClassObj(storedVal);
				value.setHours(0, 0, 0, 0);

				// If daylight savings pushes midnight to the previous date, fix the Date
				// object to point at 1am so it will represent the correct day. See #9366
				if(value.getDate() < storedVal.getDate()){
					value = this.dateModule.add(value, "hour", 1);
				}
				return value;
			}else{
				return null;
			}
		},

		_setValueAttr: function(/*Date|Number*/ value, /*Boolean*/ priorityChange){
			// summary:
			//		Support set("value", ...)
			// description:
			//		Set the current date and update the UI.  If the date is disabled, the value will
			//		not change, but the display will change to the corresponding month.
			// value:
			//		Either a Date or the number of seconds since 1970.
			// tags:
			//		protected
			if(typeof value == "string"){
				value = stamp.fromISOString(value);
			}
			value = this._patchDate(value);

			if(this._isValidDate(value) && !this.isDisabledDate(value, this.lang)){
				this._set("value", value);

				// Set focus cell to the new value.   Arguably this should only happen when there isn't a current
				// focus point.   This will also repopulate the grid to new month/year if necessary.
				this.set("currentFocus", value);

				// Mark the selected date
				this._markSelectedDates([value]);

				if(this._created && (priorityChange || typeof priorityChange == "undefined")){
					this.onChange(this.get('value'));
				}
			}else{
				// clear value, and mark all dates as unselected
				this._set("value", null);
				this._markSelectedDates([]);
			}
		},

		_patchDate: function(/*Date|Number*/ value){
			// summary:
			//		Convert Number into Date, or copy Date object.   Then, round to nearest day,
			//		setting to 1am to avoid issues when DST shift occurs at midnight, see #8521, #9366)
			if(value || value === 0){
				value = new this.dateClassObj(value);
				value.setHours(1, 0, 0, 0);
			}
			return value;
		},

		_setText: function(node, text){
			// summary:
			//		This just sets the content of node to the specified text.
			//		Can't do "node.innerHTML=text" because of an IE bug w/tables, see #3434.
			// tags:
			//		private
			while(node.firstChild){
				node.removeChild(node.firstChild);
			}
			node.appendChild(node.ownerDocument.createTextNode(text));
		},

		_populateGrid: function(){
			// summary:
			//		Fills in the calendar grid with each day (1-31).
			//		Call this on creation, when moving to a new month.
			// tags:
			//		private

			var month = new this.dateClassObj(this.currentFocus);
			month.setDate(1);
			month = this._patchDate(month);	// needed if currentFocus is start or end of DST, see #17033

			var firstDay = month.getDay(),
				daysInMonth = this.dateModule.getDaysInMonth(month),
				daysInPreviousMonth = this.dateModule.getDaysInMonth(this.dateModule.add(month, "month", -1)),
				today = new this.dateClassObj(),
				dayOffset = this.dayOffset >= 0 ? this.dayOffset : cldrSupplemental.getFirstDayOfWeek(this.lang);
			if(dayOffset > firstDay){
				dayOffset -= 7;
			}

			// If they didn't provide a summary, change the default summary to match with the new month
			if(!this.summary){
				var monthNames = this.dateLocaleModule.getNames('months', 'wide', 'standAlone', this.lang, month)
				this.gridNode.setAttribute("summary", monthNames[month.getMonth()]);
			}

			// Mapping from date (as specified by number returned from Date.valueOf()) to corresponding <td>
			this._date2cell = {};

			// Iterate through dates in the calendar and fill in date numbers and style info
			array.forEach(this.dateCells, function(template, idx){
				var i = idx + dayOffset;
				var date = new this.dateClassObj(month),
					number, clazz = "dijitCalendar", adj = 0;

				if(i < firstDay){
					number = daysInPreviousMonth - firstDay + i + 1;
					adj = -1;
					clazz += "Previous";
				}else if(i >= (firstDay + daysInMonth)){
					number = i - firstDay - daysInMonth + 1;
					adj = 1;
					clazz += "Next";
				}else{
					number = i - firstDay + 1;
					clazz += "Current";
				}

				if(adj){
					date = this.dateModule.add(date, "month", adj);
				}
				date.setDate(number);

				if(!this.dateModule.compare(date, today, "date")){
					clazz = "dijitCalendarCurrentDate " + clazz;
				}

				if(this.isDisabledDate(date, this.lang)){
					clazz = "dijitCalendarDisabledDate " + clazz;
					template.setAttribute("aria-disabled", "true");
				}else{
					clazz = "dijitCalendarEnabledDate " + clazz;
					template.removeAttribute("aria-disabled");
					template.setAttribute("aria-selected", "false");
				}

				var clazz2 = this.getClassForDate(date, this.lang);
				if(clazz2){
					clazz = clazz2 + " " + clazz;
				}

				template.className = clazz + "Month dijitCalendarDateTemplate";

				// Each cell has an associated integer value representing it's date
				var dateVal = date.valueOf();
				this._date2cell[dateVal] = template;
				template.dijitDateValue = dateVal;

				// Set Date string (ex: "13").

				var localizedDate = date.getDateLocalized ? date.getDateLocalized(this.lang) : date.getDate()
				this._setText(this.dateLabels[idx], localizedDate);
				domAttr.set(template, 'aria-label', locale.format(date, {
					selector: 'date',
					formatLength: 'long'
				}));
			}, this);
		},

		_populateControls: function(){
			// summary:
			//		Fill in localized month, and prev/current/next years
			// tags:
			//		protected

			var month = new this.dateClassObj(this.currentFocus);
			month.setDate(1);

			// set name of this month
			this.monthWidget.set("month", month);

			var y = month.getFullYear() - 1;
			var d = new this.dateClassObj();
			array.forEach(["previous", "current", "next"], function(name){
				d.setFullYear(y++);
				this._setText(this[name + "YearLabelNode"],
					this.dateLocaleModule.format(d, {selector: 'year', locale: this.lang}));
			}, this);
		},

		goToToday: function(){
			// summary:
			//		Sets calendar's value to today's date
			this.set('value', new this.dateClassObj());
		},

		constructor: function(params /*===== , srcNodeRef =====*/){
			// summary:
			//		Create the widget.
			// params: Object|null
			//		Hash of initialization parameters for widget, including scalar values (like title, duration etc.)
			//		and functions, typically callbacks like onClick.
			//		The hash can contain any of the widget's properties, excluding read-only properties.
			// srcNodeRef: DOMNode|String?
			//		If a srcNodeRef (DOM node) is specified, replace srcNodeRef with my generated DOM tree

			this.dateModule = params.datePackage ? lang.getObject(params.datePackage, false) : date;
			this.dateClassObj = this.dateModule.Date || Date;
			this.dateLocaleModule = params.datePackage ? lang.getObject(params.datePackage + ".locale", false) : locale;
		},

		_createMonthWidget: function(){
			// summary:
			//		Creates the drop down button that displays the current month and lets user pick a new one

			return CalendarLite._MonthWidget({
				id: this.id + "_mddb",
				lang: this.lang,
				dateLocaleModule: this.dateLocaleModule
			}, this.monthNode);
		},

		buildRendering: function(){
			// Markup for days of the week (referenced from template)
			var d = this.dowTemplateString,
				dayNames = this.dateLocaleModule.getNames('days', this.dayWidth, 'standAlone', this.lang),
				dayOffset = this.dayOffset >= 0 ? this.dayOffset : cldrSupplemental.getFirstDayOfWeek(this.lang);
			this.dayCellsHtml = string.substitute([d, d, d, d, d, d, d].join(""), {d: ""}, function(){
				return dayNames[dayOffset++ % 7];
			});

			// Markup for dates of the month (referenced from template), but without numbers filled in
			var r = string.substitute(this.weekTemplateString, {d: this.dateTemplateString});
			this.dateRowsHtml = [r, r, r, r, r, r].join("");

			// Instantiate from template.
			// dateCells and dateLabels arrays filled when _Templated parses my template.
			this.dateCells = [];
			this.dateLabels = [];
			this.inherited(arguments);

			dom.setSelectable(this.domNode, false);

			var dateObj = new this.dateClassObj(this.currentFocus);

			this.monthWidget = this._createMonthWidget();

			this.set('currentFocus', dateObj, false);	// draw the grid to the month specified by currentFocus
		},

		postCreate: function(){
			this.inherited(arguments);
			this._connectControls();
		},

		_connectControls: function(){
			// summary:
			//		Set up connects for increment/decrement of months/years
			// tags:
			//		protected

			var connect = lang.hitch(this, function(nodeProp, part, amount){
				this[nodeProp].dojoClick = true;
				return on(this[nodeProp], "click", lang.hitch(this, function(){
					this._setCurrentFocusAttr(this.dateModule.add(this.currentFocus, part, amount));
				}));
			});

			this.own(
				connect("incrementMonth", "month", 1),
				connect("decrementMonth", "month", -1),
				connect("nextYearLabelNode", "year", 1),
				connect("previousYearLabelNode", "year", -1)
			);
		},

		_setCurrentFocusAttr: function(/*Date*/ date, /*Boolean*/ forceFocus){
			// summary:
			//		If the calendar currently has focus, then focuses specified date,
			//		changing the currently displayed month/year if necessary.
			//		If the calendar doesn't have focus, updates currently
			//		displayed month/year, and sets the cell that will get focus
			//		when Calendar is focused.
			// forceFocus:
			//		If true, will focus() the cell even if calendar itself doesn't have focus

			var oldFocus = this.currentFocus,
				oldCell = this._getNodeByDate(oldFocus);
			date = this._patchDate(date);

			this._set("currentFocus", date);

			// If the focus is on a different month than the current calendar month, switch the displayed month.
			// Also will populate the grid initially, on Calendar creation.
			if(!this._date2cell || this.dateModule.difference(oldFocus, date, "month") != 0){
				this._populateGrid();
				this._populateControls();
				this._markSelectedDates([this.value]);
			}

			// set tabIndex=0 on new cell, and focus it (but only if Calendar itself is focused)
			var newCell = this._getNodeByDate(date);
			newCell.setAttribute("tabIndex", this.tabIndex);
			if(this.focused || forceFocus){
				newCell.focus();
			}

			// set tabIndex=-1 on old focusable cell
			if(oldCell && oldCell != newCell){
				if(has("webkit")){    // see #11064 about webkit bug
					oldCell.setAttribute("tabIndex", "-1");
				}else{
					oldCell.removeAttribute("tabIndex");
				}
			}
		},

		focus: function(){
			// summary:
			//		Focus the calendar by focusing one of the calendar cells
			this._setCurrentFocusAttr(this.currentFocus, true);
		},

		_onDayClick: function(/*Event*/ evt){
			// summary:
			//		Handler for day clicks, selects the date if appropriate
			// tags:
			//		protected
			evt.stopPropagation();
			evt.preventDefault();
			for(var node = evt.target; node && !node.dijitDateValue && node.dijitDateValue !== 0; node = node.parentNode){
				;
			}
			if(node && !domClass.contains(node, "dijitCalendarDisabledDate")){
				this.set('value', node.dijitDateValue);
			}
		},

		_getNodeByDate: function(/*Date*/ value){
			// summary:
			//		Returns the cell corresponding to the date, or null if the date is not within the currently
			//		displayed month.
			value = this._patchDate(value);
			return value && this._date2cell ? this._date2cell[value.valueOf()] : null;
		},

		_markSelectedDates: function(/*Date[]*/ dates){
			// summary:
			//		Marks the specified cells as selected, and clears cells previously marked as selected.
			//		For CalendarLite at most one cell is selected at any point, but this allows an array
			//		for easy subclassing.

			// Function to mark a cell as selected or unselected
			function mark(/*Boolean*/ selected, /*DomNode*/ cell){
				domClass.toggle(cell, "dijitCalendarSelectedDate", selected);
				cell.setAttribute("aria-selected", selected ? "true" : "false");
			}

			// Clear previously selected cells.
			array.forEach(this._selectedCells || [], lang.partial(mark, false));

			// Mark newly selected cells.  Ignore dates outside the currently displayed month.
			this._selectedCells = array.filter(array.map(dates, this._getNodeByDate, this), function(n){
				return n;
			});
			array.forEach(this._selectedCells, lang.partial(mark, true));
		},

		onChange: function(/*Date*/ /*===== date =====*/){
			// summary:
			//		Called only when the selected date has changed
		},

		isDisabledDate: function(/*===== dateObject, locale =====*/){
			// summary:
			//		May be overridden to disable certain dates in the calendar e.g. `isDisabledDate=dojo.date.locale.isWeekend`
			// dateObject: Date
			// locale: String?
			// tags:
			//		extension
			/*=====
			 return false; // Boolean
			 =====*/
		},

		getClassForDate: function(/*===== dateObject, locale =====*/){
			// summary:
			//		May be overridden to return CSS classes to associate with the date entry for the given dateObject,
			//		for example to indicate a holiday in specified locale.
			// dateObject: Date
			// locale: String?
			// tags:
			//		extension

			/*=====
			 return ""; // String
			 =====*/
		}
	});

	CalendarLite._MonthWidget = declare("dijit.CalendarLite._MonthWidget", _WidgetBase, {
		// summary:
		//		Displays name of current month padded to the width of the month
		//		w/the longest name, so that changing months doesn't change width.
		//
		//		Create as:
		// |	new Calendar._MonthWidget({
		// |			lang: ...,
		// |			dateLocaleModule: ...
		// |		})

		_setMonthAttr: function(month){
			// summary:
			//		Set the current month to display as a label
			var monthNames = this.dateLocaleModule.getNames('months', 'wide', 'standAlone', this.lang, month),
				spacer =
					(has("ie") == 6 ? "" : "<div class='dijitSpacer'>" +
						array.map(monthNames,function(s){
							return "<div>" + s + "</div>";
						}).join("") + "</div>");

			// Set name of current month and also fill in spacer element with all the month names
			// (invisible) so that the maximum width will affect layout.   But not on IE6 because then
			// the center <TH> overlaps the right <TH> (due to a browser bug).
			this.domNode.innerHTML =
				spacer +
					"<div class='dijitCalendarMonthLabel dijitCalendarCurrentMonthLabel'>" +
					monthNames[month.getMonth()] + "</div>";
		}
	});

	return CalendarLite;
});

},
'dijit/form/DropDownButton':function(){
define([
	"dojo/_base/declare", // declare
	"dojo/_base/kernel",
	"dojo/_base/lang", // hitch
	"dojo/query", // query
	"../registry", // registry.byNode
	"../popup", // dijit.popup2.hide
	"./Button",
	"../_Container",
	"../_HasDropDown",
	"dojo/text!./templates/DropDownButton.html",
	"../a11yclick"	// template uses ondijitclick
], function(declare, kernel, lang, query, registry, popup, Button, _Container, _HasDropDown, template){

	// module:
	//		dijit/form/DropDownButton

	return declare("dijit.form.DropDownButton", [Button, _Container, _HasDropDown], {
		// summary:
		//		A button with a drop down
		//
		// example:
		// |	<button data-dojo-type="dijit/form/DropDownButton">
		// |		Hello world
		// |		<div data-dojo-type="dijit/Menu">...</div>
		// |	</button>
		//
		// example:
		// |	var button1 = new DropDownButton({ label: "hi", dropDown: new dijit.Menu(...) });
		// |	win.body().appendChild(button1);
		//

		baseClass: "dijitDropDownButton",

		templateString: template,

		_fillContent: function(){
			// Overrides _TemplatedMixin#_fillContent().
			// My inner HTML possibly contains both the button label and/or a drop down widget, like
			// <DropDownButton>  <span>push me</span>  <Menu> ... </Menu> </DropDownButton>

			var source = this.srcNodeRef;
			var dest = this.containerNode;
			if(source && dest){
				while(source.hasChildNodes()){
					var child = source.firstChild;
					if(child.hasAttribute && (child.hasAttribute("data-dojo-type") || child.hasAttribute("dojoType") ||
							child.hasAttribute("data-" + kernel._scopeName + "-type") ||
							child.hasAttribute(kernel._scopeName + "Type"))){
						// The parser hasn't gotten to this node yet, so save it in a wrapper <div>
						// and then grab the instantiated widget in startup().
						this.dropDownContainer = this.ownerDocument.createElement("div");
						this.dropDownContainer.appendChild(child);
					}else{
						dest.appendChild(child);
					}
				}
			}
		},

		startup: function(){
			if(this._started){
				return;
			}

			// the child widget from srcNodeRef is the dropdown widget.  Insert it in the page DOM,
			// make it invisible, and store a reference to pass to the popup code.
			if(!this.dropDown && this.dropDownContainer){
				this.dropDown = registry.byNode(this.dropDownContainer.firstChild);
				delete this.dropDownContainer;
			}
			if(this.dropDown){
				popup.hide(this.dropDown);
			}

			this.inherited(arguments);
		},

		isLoaded: function(){
			// Returns whether or not we are loaded - if our dropdown has an href,
			// then we want to check that.
			var dropDown = this.dropDown;
			return (!!dropDown && (!dropDown.href || dropDown.isLoaded));
		},

		loadDropDown: function(/*Function*/ callback){
			// Default implementation assumes that drop down already exists,
			// but hasn't loaded it's data (ex: ContentPane w/href).
			// App must override if the drop down is lazy-created.
			var dropDown = this.dropDown;
			var handler = dropDown.on("load", lang.hitch(this, function(){
				handler.remove();
				callback();
			}));
			dropDown.refresh();		// tell it to load
		},

		isFocusable: function(){
			// Overridden so that focus is handled by the _HasDropDown mixin, not by
			// the _FormWidget mixin.
			return this.inherited(arguments) && !this._mouseDown;
		}
	});
});

},
'dijit/form/_DateTimeTextBox':function(){
define([
	"dojo/date", // date date.compare
	"dojo/date/locale", // locale.regexp
	"dojo/date/stamp", // stamp.fromISOString stamp.toISOString
	"dojo/_base/declare", // declare
	"dojo/_base/lang", // lang.getObject
	"./RangeBoundTextBox",
	"../_HasDropDown",
	"dojo/text!./templates/DropDownBox.html"
], function(date, locale, stamp, declare, lang, RangeBoundTextBox, _HasDropDown, template){

	// module:
	//		dijit/form/_DateTimeTextBox

	new Date("X"); // workaround for #11279, new Date("") == NaN

	var _DateTimeTextBox = declare("dijit.form._DateTimeTextBox", [RangeBoundTextBox, _HasDropDown], {
		// summary:
		//		Base class for validating, serializable, range-bound date or time text box.

		templateString: template,

		// hasDownArrow: [const] Boolean
		//		Set this textbox to display a down arrow button, to open the drop down list.
		hasDownArrow: true,

		// Set classes like dijitDownArrowButtonHover depending on mouse action over button node
		cssStateNodes: {
			"_buttonNode": "dijitDownArrowButton"
		},

		/*=====
		// constraints: _DateTimeTextBox.__Constraints
		//		Despite the name, this parameter specifies both constraints on the input
		//		(including starting/ending dates/times allowed) as well as
		//		formatting options like whether the date is displayed in long (ex: December 25, 2005)
		//		or short (ex: 12/25/2005) format.  See `dijit/form/_DateTimeTextBox.__Constraints` for details.
		constraints: {},
		======*/

		// The constraints without the min/max properties. Used by the compare() method
		_unboundedConstraints: {},

		// Override ValidationTextBox.pattern.... we use a reg-ex generating function rather
		// than a straight regexp to deal with locale  (plus formatting options too?)
		pattern: locale.regexp,

		// datePackage: String
		//		JavaScript namespace to find calendar routines.	 If unspecified, uses Gregorian calendar routines
		//		at dojo/date and dojo/date/locale.
		datePackage: "",
		//		TODO: for 2.0, replace datePackage with dateModule and dateLocalModule attributes specifying MIDs,
		//		or alternately just get rid of this completely and tell user to use module ID remapping
		//		via require

		postMixInProperties: function(){
			this.inherited(arguments);
			this._set("type", "text"); // in case type="date"|"time" was specified which messes up parse/format
		},

		// Override _FormWidget.compare() to work for dates/times
		compare: function(/*Date*/ val1, /*Date*/ val2){
			var isInvalid1 = this._isInvalidDate(val1);
			var isInvalid2 = this._isInvalidDate(val2);
			if (isInvalid1 || isInvalid2){
				return (isInvalid1 && isInvalid2) ? 0 : (!isInvalid1 ? 1 : -1);
			}
			// Format and parse the values before comparing them to make sure that only the parts of the
			// date that will make the "round trip" get compared.
			var fval1 = this.format(val1, this._unboundedConstraints),
				fval2 = this.format(val2, this._unboundedConstraints),
				pval1 = this.parse(fval1, this._unboundedConstraints),
				pval2 = this.parse(fval2, this._unboundedConstraints);

			return fval1 == fval2 ? 0 : date.compare(pval1, pval2, this._selector);
		},

		// flag to _HasDropDown to make drop down Calendar width == <input> width
		autoWidth: true,

		format: function(/*Date*/ value, /*locale.__FormatOptions*/ constraints){
			// summary:
			//		Formats the value as a Date, according to specified locale (second argument)
			// tags:
			//		protected
			if(!value){ return ''; }
			return this.dateLocaleModule.format(value, constraints);
		},

		"parse": function(/*String*/ value, /*locale.__FormatOptions*/ constraints){
			// summary:
			//		Parses as string as a Date, according to constraints
			// tags:
			//		protected

			return this.dateLocaleModule.parse(value, constraints) || (this._isEmpty(value) ? null : undefined);	 // Date
		},

		// Overrides ValidationTextBox.serialize() to serialize a date in canonical ISO format.
		serialize: function(/*anything*/ val, /*Object?*/ options){
			if(val.toGregorian){
				val = val.toGregorian();
			}
			return stamp.toISOString(val, options);
		},

		// dropDownDefaultValue: Date
		//		The default value to focus in the popupClass widget when the textbox value is empty.
		dropDownDefaultValue : new Date(),

		// value: Date
		//		The value of this widget as a JavaScript Date object.  Use get("value") / set("value", val) to manipulate.
		//		When passed to the parser in markup, must be specified according to `dojo/date/stamp.fromISOString()`
		value: new Date(""),	// value.toString()="NaN"

		_blankValue: null,	// used by filter() when the textbox is blank

		// popupClass: [protected extension] String
		//		Name of the popup widget class used to select a date/time.
		//		Subclasses should specify this.
		popupClass: "", // default is no popup = text only


		// _selector: [protected extension] String
		//		Specifies constraints.selector passed to dojo.date functions, should be either
		//		"date" or "time".
		//		Subclass must specify this.
		_selector: "",

		constructor: function(params /*===== , srcNodeRef =====*/){
			// summary:
			//		Create the widget.
			// params: Object|null
			//		Hash of initialization parameters for widget, including scalar values (like title, duration etc.)
			//		and functions, typically callbacks like onClick.
			//		The hash can contain any of the widget's properties, excluding read-only properties.
			// srcNodeRef: DOMNode|String?
			//		If a srcNodeRef (DOM node) is specified, replace srcNodeRef with my generated DOM tree

			params = params || {};
			this.dateModule = params.datePackage ? lang.getObject(params.datePackage, false) : date;
			this.dateClassObj = this.dateModule.Date || Date;
			if(!(this.dateClassObj instanceof Date)){
				this.value = new this.dateClassObj(this.value);
			}
			this.dateLocaleModule = params.datePackage ? lang.getObject(params.datePackage+".locale", false) : locale;
			this._set('pattern', this.dateLocaleModule.regexp);
			this._invalidDate = this.constructor.prototype.value.toString();
		},

		buildRendering: function(){
			this.inherited(arguments);

			if(!this.hasDownArrow){
				this._buttonNode.style.display = "none";
			}

			// If hasDownArrow is false, we basically just want to treat the whole widget as the
			// button.
			if(!this.hasDownArrow){
				this._buttonNode = this.domNode;
				this.baseClass += " dijitComboBoxOpenOnClick";
			}
		},

		_setConstraintsAttr: function(/*Object*/ constraints){
			constraints.selector = this._selector;
			constraints.fullYear = true; // see #5465 - always format with 4-digit years
			var fromISO = stamp.fromISOString;
			if(typeof constraints.min == "string"){
				constraints.min = fromISO(constraints.min);
				if(!(this.dateClassObj instanceof Date)){
					constraints.min = new this.dateClassObj(constraints.min);
				}
			}
			if(typeof constraints.max == "string"){
				constraints.max = fromISO(constraints.max);
				if(!(this.dateClassObj instanceof Date)){
					constraints.max = new this.dateClassObj(constraints.max);
				}
			}
			this.inherited(arguments);
			this._unboundedConstraints = lang.mixin({}, this.constraints, {min: null, max: null});
		},

		_isDefinitelyOutOfRange: function(){
			var returnValue = this.inherited(arguments);
			var isOutOfRange = false;
			var inputDate;
			var inputYear;
			var inputYearMax;
			var inputYearMin;
			var maxDate;
			var minDate;

			if(returnValue && (this.constraints.min || this.constraints.max)){
				var dateRegExp = new RegExp(this._lastRegExp);
				inputDate = dateRegExp.exec(this._lastInputEventValue);
				if (inputDate != null) {
					inputYear = inputDate[3];

					if(this.constraints.min){
						minDate = this.constraints.min instanceof Date ?
							this.constraints.min : new Date(String(this.constraints.min));
						minYear = minDate.getFullYear();
						inputYearMax = parseInt((inputYear + '9999').substr(0, 4), 10);
						isOutOfRange = inputYearMax < minYear;
					}

					if(!isOutOfRange && this.constraints.max){
						maxDate = this.constraints.max instanceof Date ?
							this.constraints.max : new Date(String(this.constraints.max));
						maxYear = maxDate.getFullYear();
						inputYearMin = parseInt((inputYear + '0000').substr(0, 4), 10);
						isOutOfRange = inputYearMin > maxYear;
					}

					returnValue = isOutOfRange;
				}
			}

			return returnValue;
		},

		_isInvalidDate: function(/*Date*/ value){
			// summary:
			//		Runs various tests on the value, checking for invalid conditions
			// tags:
			//		private
			return !value || isNaN(value) || typeof value != "object" || value.toString() == this._invalidDate;
		},

		_setValueAttr: function(/*Date|String*/ value, /*Boolean?*/ priorityChange, /*String?*/ formattedValue){
			// summary:
			//		Sets the date on this textbox. Note: value can be a JavaScript Date literal or a string to be parsed.
			if(value !== undefined){
				if(typeof value == "string"){
					value = stamp.fromISOString(value);
				}
				if(this._isInvalidDate(value)){
					value = null;
				}
				if(value instanceof Date && !(this.dateClassObj instanceof Date)){
					value = new this.dateClassObj(value);
				}
			}
			this.inherited(arguments, [value, priorityChange, formattedValue]);
			if(this.value instanceof Date){
				this.filterString = "";
			}

			// Set the dropdown's value to match, unless we are being updated due to the user navigating the TimeTextBox
			// dropdown via up/down arrow keys.
			if(priorityChange !== false && this.dropDown){
				this.dropDown.set('value', value, false);
			}
		},

		_set: function(attr, value){
			// Avoid spurious watch() notifications when value is changed to new Date object w/the same value
			if(attr == "value"){
				if(value instanceof Date && !(this.dateClassObj instanceof Date)){
					value = new this.dateClassObj(value);
				}
				var oldValue = this._get("value");
				if(oldValue instanceof this.dateClassObj && this.compare(value, oldValue) == 0){
					return;
				}
			}
			this.inherited(arguments);
		},

		_setDropDownDefaultValueAttr: function(/*Date*/ val){
			if(this._isInvalidDate(val)){
				// convert null setting into today's date, since there needs to be *some* default at all times.
				 val = new this.dateClassObj();
			}
			this._set("dropDownDefaultValue", val);
		},

		openDropDown: function(/*Function*/ callback){
			// rebuild drop down every time, so that constraints get copied (#6002)
			if(this.dropDown){
				this.dropDown.destroy();
			}
			var PopupProto = lang.isString(this.popupClass) ? lang.getObject(this.popupClass, false) : this.popupClass,
				textBox = this,
				value = this.get("value");
			this.dropDown = new PopupProto({
				onChange: function(value){
					// this will cause InlineEditBox and other handlers to do stuff so make sure it's last
					textBox.set('value', value, true);
				},
				id: this.id + "_popup",
				dir: textBox.dir,
				lang: textBox.lang,
				value: value,
				textDir: textBox.textDir,
				currentFocus: !this._isInvalidDate(value) ? value : this.dropDownDefaultValue,
				constraints: textBox.constraints,
				filterString: textBox.filterString, // for TimeTextBox, to filter times shown
				datePackage: textBox.datePackage,
				isDisabledDate: function(/*Date*/ date){
					// summary:
					//		disables dates outside of the min/max of the _DateTimeTextBox
					return !textBox.rangeCheck(date, textBox.constraints);
				}
			});

			this.inherited(arguments);
		},

		_getDisplayedValueAttr: function(){
			return this.textbox.value;
		},

		_setDisplayedValueAttr: function(/*String*/ value, /*Boolean?*/ priorityChange){
			this._setValueAttr(this.parse(value, this.constraints), priorityChange, value);
		}
	});


	/*=====
	 _DateTimeTextBox.__Constraints = declare([RangeBoundTextBox.__Constraints, locale.__FormatOptions], {
		 // summary:
		 //		Specifies both the rules on valid/invalid values (first/last date/time allowed),
		 //		and also formatting options for how the date/time is displayed.
		 // example:
		 //		To restrict to dates within 2004, displayed in a long format like "December 25, 2005":
		 //	|		{min:'2004-01-01',max:'2004-12-31', formatLength:'long'}
	 });
	 =====*/

	return _DateTimeTextBox;
});

},
'soso/dijit/form/api/contact/FilteringSelect':function(){
define([
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dojo/on',
    'soso/dijit/form/FilteringSelect',
    './Formatter',
    './StoreFactory',
    'spencer/contact/config/ContactTypes'
], function(
    declare,
    lang,
    on,
    FilteringSelect,
    Formatter,
    ContactStoreFactory,
    ContactTypes
) {
    const ContactFilteringSelect = declare('soso.form.api.contact.FilteringSelect', [FilteringSelect], {
        organisationPK: null,
        contactType: null,
        filterPeopleWithEmail: null,
        labelFunction: null,
        queryExpr: '*${0}*',
        onChangeCallBack: null,
        useOrganisationPreferredName: false,

        postMixInProperties: function() {
            this.inherited(arguments);
            this.pageSize = parseInt(this.pageSize) || 10;
            this.labelFunc = this.labelFunction || lang.hitch(this, '_formatContactName') || this.labelFunc;
            this.useLabelFunctionForItem = true;

            this.set('store', this._createContactStore());
        },

        postCreate: function() {
            this.inherited(arguments);
            on(this, 'change', lang.hitch(this, function() {
                if (typeof this.onChangeCallBack === 'function') {
                    this.onChangeCallBack(this.get('item'));
                }
            }));
        },

        setContactVO: function (item, triggerOnChange) {
            this.set('item', (item.getContactPK() ? item : null), triggerOnChange);
        },

        setOrganisationPK: function(organisationPK) {
            this.organisationPK = organisationPK;

            this.set('store', this._createContactStore());
        },

        setFilterPeopleWIthEmail: function(filterPeopleWithEmail) {
            this.filterPeopleWithEmail = filterPeopleWithEmail;

            this.set('store', this._createContactStore());
        },

        _formatContactName: function (item) {
            if (!item) {
                return '';
            }

            return (new Formatter({})).formatLabel(item, this.useOrganisationPreferredName);
        },

        _createContactStore: function() {
            const csf = new ContactStoreFactory({
                organisationPK: this.organisationPK,
                contactType: this.contactType,
                filterPeopleWithEmail: this.filterPeopleWithEmail
            });

            return csf.get();
        }
    });

    ContactFilteringSelect.constants = {CONTACT_TYPES: ContactTypes};

    return ContactFilteringSelect;
});
},
'soso/dijit/form/api/contact/Formatter':function(){
define([
    'dojo/_base/declare',
    'spencer/format/BranchOfficeEmail',
    'spencer/format/PersonDisplayName'
], function(
    declare,
    BranchOfficeEmail,
    PersonDisplayNameFormat
) {
    return declare('soso.form.api.contact.Formatter', [], {
        formatLabel: function (item, useOrganisationPreferredName) {
            if (item.hasOwnProperty('isBranchOffice') && item.isBranchOffice()) {
                return this._formatBranchOffice(item);
            }

            const nameFormat = this._setUpPersonFormat(item, useOrganisationPreferredName);

            if (item.email) {
                return nameFormat.format() + ' (' + item.email + ')';
            }

            return nameFormat.format();
        },

        formatItemLabel: function (item, useOrganisationPreferredName) {
            if (item.hasOwnProperty('isBranchOffice') && item.isBranchOffice()) {
                return this._formatBranchOffice(item);
            }

            if (item.type === 'group' || item.type === 'myGroup') {
                return item.name;
            }

            return this._setUpPersonFormat(item, useOrganisationPreferredName).format();
        },

        _formatBranchOffice: function(item) {
            const branchOfficeEmailFormat = new BranchOfficeEmail();
            branchOfficeEmailFormat.setOrganisationName(item.organisation || null);
            branchOfficeEmailFormat.setName(item.name || null);
            branchOfficeEmailFormat.setEmail(item.email || null);

            return branchOfficeEmailFormat.format();
        },

        _setUpPersonFormat: function(item, useOrganisationPreferredName) {
            const nameFormat = new PersonDisplayNameFormat(useOrganisationPreferredName);
            nameFormat.setDisplayName(item.preferredName || item.displayName || item.name || null);
            nameFormat.setJobTitle(item.jobTitle || null);
            nameFormat.setOrganisation(item.organisation || null);
            nameFormat.setOrganisationPreferredName(item.organisationPreferredName || null)
            return nameFormat;
        }
    });
});
},
'spencer/format/BranchOfficeEmail':function(){
define([
    './OrganisationDisplayName'
], function(OrganisationDisplayName) {
    const BranchOfficeEmail = function() {
        this.orgDisplayName = new OrganisationDisplayName();
        this.name = null;
        this.email = null;
    };

    BranchOfficeEmail.prototype.setOrganisationPreferredName = function(organisationPreferredName) {
        this.orgDisplayName.setPreferredName(organisationPreferredName);
        return this;
    };

    BranchOfficeEmail.prototype.setOrganisationName = function(organisationName) {
        this.orgDisplayName.setName(organisationName);
        return this;
    };

    BranchOfficeEmail.prototype.setName = function(name) {
        this.name = name;
        return this;
    };

    BranchOfficeEmail.prototype.setEmail = function(email) {
        this.email = email;
        return this;
    };

    BranchOfficeEmail.prototype.format = function() {
        return this.name + ' - ' + this.orgDisplayName.format() + ' - ' + this.email;
    };

    BranchOfficeEmail.prototype.reset = function() {
        this.orgDisplayName.reset();
        this.name = null;
        this.email = null;

        return this;
    };

    return BranchOfficeEmail;
});

},
'spencer/format/OrganisationDisplayName':function(){
define([
], function() {
    const OrganisationDisplayName = function() {
        this.preferredName = null;
        this.name = null;
    };

    OrganisationDisplayName.prototype.setPreferredName = function(preferredName) {
        this.preferredName = preferredName;
        return this;
    };

    OrganisationDisplayName.prototype.setName = function(name) {
        this.name = name;
        return this;
    };

    OrganisationDisplayName.prototype.format = function() {
        if (this.preferredName) {
            return this.preferredName;
        }
        return this.name;
    };

    OrganisationDisplayName.prototype.reset = function() {
        this.preferredName = null;
        this.name = null;

        return this;
    };

    return OrganisationDisplayName;
});
},
'soso/dijit/form/api/contact/StoreFactory':function(){
define([
    'dojo/_base/declare',
    'dojo/_base/lang',
    'soso/dojo/store/JsonRestApi',
    'api/contact/data/Contact',
    'api/contact/parser/Contact',
    'library/request/data/Handlers',
    'library/request/helper/DefaultUnauthorisedCallback',
    'spencer/format/OrganisationDisplayName',
    'spencer/format/PersonDisplayName',
    './ModelFactory'
], function(
    declare,
    lang,
    JsonRestApi,
    ContactVO,
    ContactParser,
    HandlersVO,
    DefaultUnauthorisedCallback,
    OrganisationDisplayName,
    PersonDisplayNameFormat,
    ContactModelFactory
) {
    return declare('soso.form.api.contact.StoreFactory', [], {
        contactModel: null,
        contactCollectionModel: null,
        organisationPK: null,
        contactType: null,
        filterPeopleWithEmail: null,

        constructor: function(kwArgs){
            lang.mixin(this, kwArgs);

            this._setupModels();
        },

        get: function () {
            return this._createContactStore();
        },

        _createHandlersVO: function () {
            return new HandlersVO(
                () => {},
                null,
                DefaultUnauthorisedCallback,
                function (error, description) {
                    console.log(error);
                    console.log(description);
                }
            )
        },

        _createContactStore: function () {
            return new JsonRestApi({
                idProperty: 'contactPK',
                searchAttr: 'name',
                resultParser: new ContactParser(),
                getModel: this.contactModel,
                getFunction: 'get',
                getFunctionArgsCreator: lang.hitch(this, function (id) {
                    var cvo = new ContactVO();
                    cvo.setContactPK(id);

                    return [
                        this._createHandlersVO(),
                        cvo
                    ];
                }),
                queryModel: this.contactCollectionModel,
                queryFunction: 'fetch',
                queryFunctionArgs: [
                    this._createHandlersVO()
                ]
            });
        },

        _setupModels: function() {
            const contactBuilder = this._createContactModelFactory();
            this.contactModel = contactBuilder.getModel();
            this.contactCollectionModel = contactBuilder.getModelCollection();

            this.contactCollectionModel.setOrganisationPK(this.organisationPK);
            this.contactCollectionModel.setType(this.contactType);
            this.contactCollectionModel.setFilterPeopleWIthEmail(this.filterPeopleWithEmail);
        },

        _createContactModelFactory: function() {
            return new ContactModelFactory();
        }
    });
});
},
'soso/dijit/form/api/contact/ModelFactory':function(){
define([
    'dojo/_base/declare',
    'api/contact/Factory',
    'api/contact/Config',
    'library/request/dojo/URLConnectionProcessorBuilder',
    'library/request/URLConnectionBuilder',
    'library/request/URLResponseProcessorBuilder'
], function(
    declare,
    ContactFactory,
    ContactConfig,
    URLConnectionProcessorBuilder,
    URLConnectionBuilder,
    URLResponseProcessorBuilder
) {
    return declare('soso.form.api.contact.ModelFactory', [], {
        contactFactory: null,

        constructor: function() {
            this.inherited(arguments);
            this.contactFactory = this._createContactFactory();
        },

        getModel: function() {
            return this.contactFactory.getContact();
        },

        getModelCollection: function() {
            return this.contactFactory.getContactCollection();
        },

        _createContactFactory: function () {
            return new ContactFactory(
                new ContactConfig(),
                new URLConnectionBuilder(
                    new URLConnectionProcessorBuilder()
                ),
                new URLResponseProcessorBuilder()
            );
        }
    });
});
},
'style-guide/v1/doc-control/registration-details/Default':function(){
define([
    './Base',
    'api/Factory',
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/text!./template/Default.html',
    'dijit/form/DateTextBox',
    'soso/sosox/ejs/_Templated',
    'spencer/date-time/Format',
    'style-guide/v1/forms/searchable-select/Selector',
    'library/request/data/Handlers',
    'library/request/helper/DefaultUnauthorisedCallback',
    'spencer/format/BranchOfficeEmail',
    'spencer/format/PersonDisplayName',
    'spencer/format/OrganisationDisplayName'
], function(
    Base,
    ApiFactory,
    declare,
    domAttr,
    domClass,
    template,
    DateTextBox,
    _Templated,
    DateTimeFormat,
    SearchableSelect,
    Handlers,
    DefaultUnauthorisedCallback,
    BranchOfficeEmailFormatter,
    PersonDisplayNameFormatter,
    OrganisationNameFormatter
) {
    return declare('style-guide.v1.forms.registration-details.default', [Base, _Templated], {
        dateTimeFormat: null,
        elementInputDate: null,
        elementInputOriginator: null,
        elementInputTitle: null,
        elementInputIsPrivate: null,
        elementTitleValidation: null,
        error: '',
        inputDate: null,
        inputOriginator: null,
        date: null,
        disabled: false,
        title: null,
        isPrivate: null,
        originatorContact: null,
        md5: null,
        projectStageTreeViewPK: null,
        type: null,
        location: null,
        projectStagePK: null,

        templateString: template,

        postCreate: function() {
            this.inherited(arguments);

            this.dateTimeFormat = new DateTimeFormat();

            this._initDocumentOriginatorFilteringSelect();
            this._initInputDate();
            this._initSimpleInputs();
        },

        getDetails: function() {
            const originator = this.inputOriginator.get('value');

            return {
                personPK: originator ? originator.getPersonPK() : null,
                branchOfficePK: originator ? originator.getBranchOfficePK() : null,
                originatorContact: originator,
                title: domAttr.get(this.elementInputTitle, 'value'),
                date: this.dateTimeFormat.toLocaleISOString(this.inputDate.get('value')),
                isPrivate: domAttr.get(this.elementInputIsPrivate, 'checked'),
                md5: this.md5,
                treeViewPK: this.projectStageTreeViewPK,
                type: this.type,
                location: this.location,
                projectStagePK: this.projectStagePK,
            };
        },

        getError: function() {
            return this.error;
        },

        removeError: function() {
            this.error = '';
        },

        isValid: function() {
            if (
                this.inputOriginator.get('value') &&
                domAttr.get(this.elementInputTitle, 'value') !== '' &&
                this.inputDate.get('value')
            ) {
                return true;
            }

            this._validate();

            return false;
        },

        setTitle: function(title) {
            this.title = title;
            domAttr.set(this.elementInputTitle, 'value', title);
            return this;
        },

        setDate: function(date) {
            if (date instanceof Date) {
                this.inputDate.set('value', date);
                return this;
            }

            this.inputDate.set('displayedValue', date);
            this.inputDate._hasBeenBlurred = true;
            this.inputDate.validate();
            return this;
        },

        _validate: function() {
            this.inputOriginator.validate();
            this.inputDate.validate();

            if (domAttr.get(this.elementInputTitle, 'value')) {
                domClass.remove(this.elementTitleValidation, 'sos-form-textfield-validation-error');
            } else {
                domClass.add(this.elementTitleValidation, 'sos-form-textfield-validation-error');
            }
        },

        _initDocumentOriginatorFilteringSelect: function() {
            const api = (new ApiFactory())
                .getContactFactory()
                .getContactCollection();

            const branchOfficeEmailFormatter = new BranchOfficeEmailFormatter(
                new OrganisationNameFormatter()
            );

            const personDisplayNameFormatter = new PersonDisplayNameFormatter();

            this.inputOriginator = new SearchableSelect({
                searchAttr: function(result) {
                    branchOfficeEmailFormatter.reset();
                    personDisplayNameFormatter.reset();

                    if(result.organisationPK) {
                        branchOfficeEmailFormatter.setOrganisationName(result.organisation || null);
                        branchOfficeEmailFormatter.setName(result.name || null);
                        branchOfficeEmailFormatter.setEmail(result.email || null);

                        return branchOfficeEmailFormatter.format();
                    }

                    personDisplayNameFormatter.setDisplayName(result.preferredName || result.displayName || result.name || null);
                    personDisplayNameFormatter.setJobTitle(result.jobTitle || null);
                    personDisplayNameFormatter.setOrganisation(result.organisation || null);

                    return personDisplayNameFormatter.format();
                },
                query: function(promise, options) {
                    api.setLimit(options.limit);
                    api.setOffset(options.offset);
                    api.setQuery(options.filter);

                    api.fetch(
                        new Handlers(
                            function success(response) {
                                promise.resolve(response);
                            },
                            function progress() {},
                            DefaultUnauthorisedCallback
                        )
                    );
                },
                icon: function(result) {
                    if(result.personPK) {
                        return 'user-o';
                    }

                    if(result.organisationPK) {
                        return 'building-o';
                    }
                },
                limit: 50,
                required: true,
                disabled: this.disabled
            }, this.elementInputOriginator);

            if (this.originatorContact) {
                this.inputOriginator.set('value', this.originatorContact);
            }
        },

        _initInputDate: function() {
            this.inputDate = new DateTextBox({
                'class': 'sos-date-text-box',
                constraints: {
                    'datePattern':'dd/MM/yyyy'
                },
                disabled: this.disabled,
                placeHolder: 'Select date',
                value: this.date ? this.date : new Date(),
                dropDownPosition: ['below'],
                required: true
            }, this.elementInputDate);

            this.inputDate.startup();
        },

        _initSimpleInputs: function() {
            if (this.title) {
                domAttr.set(this.elementInputTitle, 'value', this.title);
            }

            if (this.isPrivate) {
                domAttr.set(this.elementInputIsPrivate, 'checked', 'checked');
            }

            domAttr.set(this.elementInputIsPrivate, 'disabled', this.disabled);

            if (this.disabled) {
                domAttr.set(this.elementInputTitle, 'disabled', 'disabled');
                domAttr.set(this.setToMeElement, 'disabled', 'disabled');
            } else {
                domAttr.remove(this.elementInputTitle, 'disabled');
                domAttr.remove(this.setToMeElement, 'disabled');
            }
        },

        _setOriginatorToCurrentPerson: function() {
            if(this.disabled) {
                return;
            }

            this.inputOriginator.set('value', this.currentContact);
        }
    });
});

},
'style-guide/v1/doc-control/registration-details/Drawing':function(){
define([
    './Base',
    'api/Factory',
    'api/doccontrol/filter/DocumentReference',
    'api/doccontrol/filter/ProjectStagePK',
    'api/doccontrol/filter/ProjectStageTreeViewPK',
    'api/doccontrol/revision-details/filter/DocumentType',
    'doc-control/config/Regex',
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/store/Memory',
    'dojo/text!./template/Drawing.html',
    'dojo/text!style-guide/v1/doc-control/template/InvalidRevisionNumberFormat.html',
    'dijit/form/DateTextBox',
    'dijit/form/FilteringSelect',
    'library/request/data/Handlers',
    'library/request/helper/DefaultUnauthorisedCallback',
    'soso/sosox/ejs/_Templated',
    'spencer/date-time/Format',
    'spencer/doc-control/format/url/ProjectListingQuery',
    'spencer/core/filter/Collection',
    'spencer/format/BranchOfficeEmail',
    'spencer/format/PersonDisplayName',
    'spencer/format/OrganisationDisplayName',
    'style-guide/v1/forms/searchable-select/Selector'
], function(
    Base,
    APIFactory,
    DocumentReferenceFilter,
    ProjectStagePKFilter,
    ProjectStageTreeViewPKFilter,
    DocumentTypeFilter,
    REGEX,
    declare,
    domAttr,
    domClass,
    Memory,
    template,
    invalidRevisionNumberFormat,
    DateTextBox,
    FilteringSelect,
    HandlersData,
    DefaultUnauthorisedCallback,
    _Templated,
    DateTimeFormat,
    ProjectListingQueryUrl,
    FilterCollection,
    BranchOfficeEmailFormatter,
    PersonDisplayNameFormatter,
    OrganisationNameFormatter,
    SearchableSelect
) {
    const ERROR_PRIVATE_DOCUMENT_IN_COLLECTION = 'PRIVATE_DOCUMENT_IN_COLLECTION';

    return declare('style-guide.v1.forms.registration-details.drawing', [Base, _Templated], {
        availableStatusCollection: null,
        dateTimeFormat: null,
        disciplineSelect: null,
        documentViewer: null,
        statusSelect: null,
        elementDisciplineSelect: null,
        elementStatusSelect: null,
        elementInputOriginator: null,
        elementInputDate: null,
        elementInputTitle: null,
        elementInputIsPrivate: null,
        elementInputReference: null,
        elementInputRevision: null,
        elementTitleValidation: null,
        elementReferenceError: null,
        elementReferenceHasPrivateRevision: null,
        elementReferenceValidation: null,
        elementRevisionValidation: null,
        error: '',
        inputDate: null,
        inputOriginator: null,
        date: null,
        title: null,
        setRegisterButtonDisabled: null,
        originatorContact: null,
        isPrivate: null,
        discipline: null,
        status: null,
        revision: null,
        reference: null,
        revisionDetailsFactory: null,
        md5: null,
        projectStageTreeViewPK: null,
        type: null,
        location: null,
        projectStagePK: null,
        projectOverviewUrl: null,
        elementProjectListingLinkAnchor: null,

        revisionCollectionRequest: null,
        revisionCollectionRequestTimeout: null,

        templateString: template,

        postCreate: function() {
            this.inherited(arguments);

            this.apiFactory = new APIFactory();

            this.revisionDetailsFactory = this.apiFactory.getDocControlRevisionDetailsFactory();

            this.availableStatusCollection = this.apiFactory
                .getDocControlTreeNodeFactory()
                .getAvailableStatusCollection();

            this.dateTimeFormat = new DateTimeFormat();

            this._initForm();

            this.apiDocumentRevisionCollection = this.apiFactory.getDocControlDocumentRevisionFactory().getCollection();

            if (this.reference) {
                this._onReferenceInput();
            }
        },

        getDetails: function() {
            const originator = this.inputOriginator.get('value');

            return {
                personPK: originator ? originator.getPersonPK() : null,
                branchOfficePK: originator ? originator.getBranchOfficePK() : null,
                originatorContact: originator,
                title: domAttr.get(this.elementInputTitle, 'value'),
                date: this.dateTimeFormat.toLocaleISOString(this.inputDate.get('value')),
                isPrivate: domAttr.get(this.elementInputIsPrivate, 'checked'),
                discipline: this.disciplineSelect.get('value'),
                disciplineVO: this.disciplineSelect.get('item'),
                status: domAttr.get(this.statusSelect, 'value'),
                statusVO: this.statusSelect.get('item'),
                revision: domAttr.get(this.elementInputRevision, 'value'),
                reference: domAttr.get(this.elementInputReference, 'value'),
                md5: this.md5,
                treeViewPK: this.projectStageTreeViewPK,
                type: this.type,
                location: this.location,
                projectStagePK: this.projectStagePK,
            };
        },

        getError: function() {
            return this.error;
        },

        removeError: function() {
            this.error = '';
        },

        isValid: function() {
            if (
                this.inputOriginator.get('value') &&
                domAttr.get(this.elementInputTitle, 'value') !== '' &&
                domAttr.get(this.elementInputReference, 'value') !== '' &&
                domAttr.get(this.elementInputRevision, 'value') !== '' &&
                this.inputDate.get('value') &&
                this.disciplineSelect.isValid() &&
                this.statusSelect.isValid()
            ) {
                if (!this._isRevisionNumberValid()) {
                    this.error = invalidRevisionNumberFormat;
                    return false;
                }
                return true;
            }

            this._validate();

            return false;
        },

        setTitle: function(title) {
            this.title = title;
            domAttr.set(this.elementInputTitle, 'value', title);
            return this;
        },

        setReference: function(reference) {
            domAttr.set(this.elementInputReference, 'value', reference);
            return this;
        },

        setDate: function(date) {
            if (date instanceof Date) {
                this.inputDate.set('value', date);
                return this;
            }

            this.inputDate.set('displayedValue', date);
            this.inputDate._hasBeenBlurred = true;
            this.inputDate.validate();
            return this;
        },

        setRevision: function(revision) {
            domAttr.set(this.elementInputRevision, 'value', revision);
            return this;
        },

        setDiscipline: function(discipline) {
            this.discipline = discipline;

            if (this.drawingDisciplineStore) this.disciplineSelect.set('item', this.drawingDisciplineStore.get(this.discipline));
        },

        setStatusCode: function(statusCode) {
            this.statusCode = statusCode;

            if (this.statusStore) {
                const result = this.statusStore.query({ code: statusCode });
                if (result.total == 1) {
                    this.statusSelect.set('item', result[0]);
                }
            }
        },

        _onReferenceInput: function() {
            if (typeof this.setRegisterButtonDisabled === 'function') {
                this.setRegisterButtonDisabled(false);
            }

            this._hideExistingReferenceNotification();
            this._hideExistingRevisionNumberNotification();
            this._hideExistingPrivateRevisionNotification();

            this.existingRevisionCollection = null;
            if (this.revisionCollectionRequestTimeout) {
                clearTimeout(this.revisionCollectionRequestTimeout);
            }

            if (this.revisionCollectionRequest) {
                this.revisionCollectionRequest.cancel();
            }

            const reference = domAttr.get(this.elementInputReference, 'value');
            if (reference && this.projectStagePK && this.projectStageTreeViewPK) {
                this.revisionCollectionRequestTimeout = setTimeout(() => {
                    this._requestRevisionByReferenceAndNode(reference);
                }, 1000)
            }
        },

        _requestRevisionByReferenceAndNode: function(reference) {
            const filterCollection = new FilterCollection()
                .addFilter(new DocumentReferenceFilter(reference))
                .addFilter(new ProjectStageTreeViewPKFilter(this.projectStageTreeViewPK))
                .addFilter(new ProjectStagePKFilter(this.projectStagePK));

            this.revisionCollectionRequest = this.apiDocumentRevisionCollection.get(
                new HandlersData(
                    function success(revisionCollection) {
                        if (!revisionCollection || revisionCollection.length === 0) {
                            return;
                        }

                        this._showExistingReferenceNotification();
                        this.existingRevisionCollection = revisionCollection;

                        if (domAttr.get(this.elementInputRevision, 'value')) {
                            this._validateRevision();
                        }
                    }.bind(this),
                    null,
                    DefaultUnauthorisedCallback,
                    function error(error, description) {
                        if (error === ERROR_PRIVATE_DOCUMENT_IN_COLLECTION) {
                            if (typeof this.setRegisterButtonDisabled === 'function') {
                                this.setRegisterButtonDisabled(true);
                            }

                            if (this.projectOverviewUrl) {
                                const url = (new ProjectListingQueryUrl(this.projectOverviewUrl))
                                    .setProjectStagePK(this.projectStagePK)
                                    .setProjectStageTreeViewPK(this.projectStageTreeViewPK)
                                    .setNodeType(this.type)
                                    .format();

                                domAttr.set(this.elementProjectListingLinkAnchor, 'href', url);
                                domClass.remove(this.elementProjectListingLinkAnchor, 'hide');
                            } else {
                                domClass.add(this.elementProjectListingLinkAnchor, 'hide');
                            }

                            this._showExistingPrivateRevisionNotification();
                            return;
                        }

                        console.error(error, description);
                    }.bind(this)
                ),
                filterCollection
            )
        },

        _hideExistingReferenceNotification: function() {
            domClass.add(this.elementReferenceExists, 'hide');
        },

        _showExistingReferenceNotification: function() {
            domClass.remove(this.elementReferenceExists, 'hide');
        },

        _hideExistingPrivateRevisionNotification: function() {
            domClass.add(this.elementReferenceHasPrivateRevision, 'hide');
        },

        _showExistingPrivateRevisionNotification: function() {
            domClass.remove(this.elementReferenceHasPrivateRevision, 'hide');
        },

        _onViewExistingClick: function() {
            if (!this.existingRevisionCollection) {
                return;
            }

            const latestRevision = this.existingRevisionCollection.find(revision => revision.isLatest());

            this.documentViewer.setRevisionPK(latestRevision.getRevisionPK());
            this.documentViewer.setFileType(latestRevision.getFileType());
            this.documentViewer.initRevisionSidebar().execute();
        },

        _revisionNumberIsUnique: function(revisionNumber) {
            this._hideExistingRevisionNumberNotification();
            if (!this.existingRevisionCollection || !revisionNumber) {
                return true;
            }

            if (
                this.existingRevisionCollection.some(revision => revision.getRevisionNumber() === revisionNumber)) {
                this._showExistingRevisionNumberNotification();
                return false;
            }
            return true;
        },

        _hideExistingRevisionNumberNotification: function() {
            domClass.add(this.elementRevisionExists, 'hide');
        },

        _showExistingRevisionNumberNotification: function() {
            domClass.remove(this.elementRevisionExists, 'hide');
        },

        _isRevisionNumberValid: function() {
            const value = domAttr.get(this.elementInputRevision, 'value');
            return value && REGEX.REVISION_NUMBER_VALIDATION.test(value) && this._revisionNumberIsUnique(value);
        },

        _validate: function() {
            this.inputOriginator.validate();
            this.inputDate.validate();

            this.disciplineSelect._hasBeenBlurred = true;
            this.disciplineSelect.validate();

            this.statusSelect._hasBeenBlurred = true;
            this.statusSelect.validate();

            this._validateTitle();
            this._validateReference();
            this._validateRevision();
        },

        _validateTitle: function() {
            if (domAttr.get(this.elementInputTitle, 'value')) {
                domClass.remove(this.elementTitleValidation, 'sos-form-textfield-validation-error');
            } else {
                domClass.add(this.elementTitleValidation, 'sos-form-textfield-validation-error');
            }
        },

        _validateReference: function() {
            this.elementReferenceError.innerHTML = 'Document Reference Number is required';
            if (domAttr.get(this.elementInputReference, 'value')) {
                domClass.remove(this.elementReferenceValidation, 'sos-form-textfield-validation-error');
            } else {
                domClass.add(this.elementReferenceValidation, 'sos-form-textfield-validation-error');
            }
        },

        _validateRevision: function() {
            const revisionNumber = domAttr.get(this.elementInputRevision, 'value');

            if (!revisionNumber) {
                this.elementRevisionNumberError.innerHTML = 'Revision Number is required';
                domClass.add(this.elementRevisionValidation, 'sos-form-textfield-validation-error');
                return false;
            }

            if (!this._revisionNumberIsUnique(revisionNumber)) {
                this._showExistingRevisionNumberNotification();
                return false;
            }

            this._hideExistingRevisionNumberNotification();

            if (!REGEX.REVISION_NUMBER_VALIDATION.test(revisionNumber)) {
                this.elementRevisionNumberError.innerHTML = 'Revision Number is not a valid format';
                domClass.add(this.elementRevisionValidation, 'sos-form-textfield-validation-error');
                return false;
            }

            domClass.remove(this.elementRevisionValidation, 'sos-form-textfield-validation-error');
            return true;
        },

        _initForm: function() {
            this._initDrawingDisciplineSelect();
            this._initStatusSelect();
            this._initInputDate();
            this._initDocumentOriginatorFilteringSelect();

            this._initFormValues();
        },

        _initDrawingDisciplineSelect: function() {
            this.disciplineSelect = new FilteringSelect({
                'class': 'sos-form-filtering-select',
                labelFunc: item => item.discipline,
                searchAttr: 'discipline',
                labelAttr: 'discipline',
                required: true
            }, this.elementDisciplineSelect);

            this.revisionDetailsFactory.getDrawingDisciplineCollection().fetch(
                new HandlersData(
                    (drawingDisciplines) => {
                        this.drawingDisciplineStore = new Memory({
                            idProperty: 'drawingDisciplinePK',
                            data: drawingDisciplines
                        });
                        this.disciplineSelect.set('store', this.drawingDisciplineStore);

                        if (this.discipline) this.disciplineSelect.set('item', this.drawingDisciplineStore.get(this.discipline));
                    },
                    null,
                    DefaultUnauthorisedCallback,
                    function (error, description) {
                        console.error(error, description);
                    }
                )
            );
        },

        _initStatusSelect: function() {
            this.statusSelect = new FilteringSelect({
                'class': 'sos-form-filtering-select',
                labelFunc: item => item.description,
                searchAttr: 'description',
                labelAttr: 'description',
                required: true
            }, this.elementStatusSelect);

            this.availableStatusCollection.fetch(
                new HandlersData(
                    (statuses) => {
                        this.statusStore = new Memory({
                            idProperty: 'statusPK',
                            data: statuses
                        });
                        this.statusSelect.set('store', this.statusStore);

                        if (this.status) {
                            this.statusSelect.set('item', this.statusStore.get(this.status));
                        } else if (this.statusCode) {
                            const result = this.statusStore.query({ code: this.statusCode });
                            if (result.total == 1) {
                                this.statusSelect.set('item', result[0]);
                            }
                        }
                    },
                    null,
                    DefaultUnauthorisedCallback,
                    function (error, description) {
                        console.error(error, description);
                    }
                ),
                this.projectStagePK,
                this.projectStageTreeViewPK
            );
        },

        _initDocumentOriginatorFilteringSelect: function() {
            const api = this.apiFactory
                .getContactFactory()
                .getContactCollection();

            const branchOfficeEmailFormatter = new BranchOfficeEmailFormatter(
                new OrganisationNameFormatter()
            );

            const personDisplayNameFormatter = new PersonDisplayNameFormatter();

            this.inputOriginator = new SearchableSelect({
                searchAttr: function(result) {
                    branchOfficeEmailFormatter.reset();
                    personDisplayNameFormatter.reset();

                    if(result.organisationPK) {
                        branchOfficeEmailFormatter.setOrganisationName(result.organisation || null);
                        branchOfficeEmailFormatter.setName(result.name || null);
                        branchOfficeEmailFormatter.setEmail(result.email || null);

                        return branchOfficeEmailFormatter.format();
                    }

                    personDisplayNameFormatter.setDisplayName(result.preferredName || result.displayName || result.name || null);
                    personDisplayNameFormatter.setJobTitle(result.jobTitle || null);
                    personDisplayNameFormatter.setOrganisation(result.organisation || null);

                    return personDisplayNameFormatter.format();
                },
                query: function(promise, options) {
                    api.setLimit(options.limit);
                    api.setOffset(options.offset);
                    api.setQuery(options.filter);

                    api.fetch(
                        new HandlersData(
                            function success(response) {
                                promise.resolve(response);
                            },
                            function progress() {},
                            DefaultUnauthorisedCallback
                        )
                    );
                },
                icon: function(result) {
                    if(result.personPK) {
                        return 'user-o';
                    }

                    if(result.organisationPK) {
                        return 'building-o';
                    }
                },
                limit: 50,
                required: true,
                disabled: this.disabled
            }, this.elementInputOriginator);

            if (this.originatorContact) {
                this.inputOriginator.set('value', this.originatorContact);
            }
        },

        _initInputDate: function() {
            this.inputDate = new DateTextBox({
                'class': 'sos-date-text-box',
                'constraints':{
                    'datePattern':'dd/MM/yyyy'
                },
                'placeHolder':'Select date',
                'value' : this.date ? this.date : new Date(),
                dropDownPosition: ['below'],
                required: true
            }, this.elementInputDate);
            this.inputDate.startup();
        },

        _initFormValues: function() {
            if (this.title) {
                domAttr.set(this.elementInputTitle, 'value', this.title);
            }

            if (this.isPrivate) {
                domAttr.set(this.elementInputIsPrivate, 'checked', 'checked');
            }

            if (this.reference) {
                domAttr.set(this.elementInputReference, 'value', this.reference);
            }

            if (this.revision) {
                domAttr.set(this.elementInputRevision, 'value', this.revision);
            }
        },

        _setOriginatorToCurrentPerson: function() {
            this.inputOriginator.set('value', this.currentContact);
        }
    });
});

},
'spencer/doc-control/format/url/ProjectListingQuery':function(){
define([
    'project-listing/config/Route',
    'spencer/utility/HashRouteGenerator'
], function(
    ProjectListingRoute,
    HashRouteGenerator
) {
    const DEFAULT_PAGE = 1,
        DEFAULT_LIMIT = 15,
        DEFAULT_SORT_ATTRIBUTE = 'date',
        DEFAULT_SORT_DIRECTION = 'desc',
        LISTING_TYPE = {
            Other: 'DOCUMENT_LISTING',
            Correspondence: 'CORRESPONDENCE_LISTING',
            Drawing: 'DRAWING_LISTING',
            Revisionable: 'REVISIONABLE_LISTING'
        },
        URL_SLASH = '/';

    const ComposeQuery = function(projectOverviewRoute) {
        this.projectOverviewUrl = baseUrl + projectOverviewRoute;
        this.projectStagePK = null;
        this.projectStageTreeViewPK = null;
        this.nodeType = null;
        this.hashRouteGenerator  = new HashRouteGenerator();

        this._generateParamString = function() {
            const params = {
                projectStagePK: this.projectStagePK,
                projectStageTreeViewPK: this.projectStageTreeViewPK,
                page: DEFAULT_PAGE,
                limit: DEFAULT_LIMIT,
                softAttribute: DEFAULT_SORT_ATTRIBUTE,
                sortDirection: DEFAULT_SORT_DIRECTION,
            };

            let paramString = '';
            for(let paramName in params) {
                if (params.hasOwnProperty(paramName)) {
                    paramString += URL_SLASH + paramName + URL_SLASH + params[paramName];
                }
            }
            return paramString;
        };
    };

    ComposeQuery.prototype.setProjectStagePK = function(projectStagePK) {
        this.projectStagePK = projectStagePK;
        return this;
    };

    ComposeQuery.prototype.setProjectStageTreeViewPK = function(projectStageTreeViewPK) {
        this.projectStageTreeViewPK = projectStageTreeViewPK;
        return this;
    };

    ComposeQuery.prototype.setNodeType = function(nodeType) {
        this.nodeType = nodeType;
        return this;
    };

    ComposeQuery.prototype.format = function() {
        return this.projectOverviewUrl +
            this.hashRouteGenerator.generate(ProjectListingRoute[LISTING_TYPE[this.nodeType]]) +
            this._generateParamString();
    };

    return ComposeQuery;
});
},
'project-listing/config/Route':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    return {
        BASKET: 'basket',
        CORRESPONDENCE_LISTING: 'correspondence',
        CORRESPONDENCE_LISTING_QUERY: '^correspondence\/(.+)',
        DASHBOARD: 'dashboard',
        DOCUMENT_LISTING: 'document-listing',
        DOCUMENT_LISTING_QUERY: '^document-listing\/(.+)',
        DRAWING_LISTING: 'drawing-listing',
        DRAWING_LISTING_QUERY: '^drawing-listing\/(.+)',
        FOLDER_LISTING: 'folder-listing',
        FOLDER_LISTING_QUERY: 'folder-listing\/(.+)',
        LISTING_PLACEHOLDER: ':listingType/projectStagePK/:projectStagePK/projectStageTreeViewPK/:projectStageTreeViewPK/page/1/limit/:limit',
        MIXED_LISTING: 'mixed-listing',
        MIXED_LISTING_QUERY: '^mixed-listing\/(.+)',
        MULTI_NODE_LISTING: 'multi-node-listing/projectStagePK/:projectStagePK/type/:type',
        MULTI_NODE_LISTING_QUERY: '^multi-node-listing\/(projectStagePK\/\\d+\/type\/\\w+\/.+)',
        NO_ACCESS_LISTING: 'no-access-listing/projectStagePK/:projectStagePK/projectStageTreeViewPK/:projectStageTreeViewPK',
        PROJECT_DELIVERY: 'project-delivery/projectStagePK/:projectStagePK/today/:today',
        PROJECT_STAGE: 'project-stage',
        PROJECT_STAGE_QUERY: '^project-stage\/(.+)',
        REGISTRATION_BASKET_LISTING: 'registration-basket',
        REGISTRATION_BASKET_LISTING_QUERY: 'registration-basket\/(.+)',
        REPORT: '/reports/report/index/name/:name/type/:type?projectStagePK=:projectStagePK',
        REVISIONABLE_LISTING: 'revisionable-listing',
        REVISIONABLE_LISTING_QUERY: '^revisionable-listing\/(.+)',
        SUPER_SEARCH: 'super-search',
        SUPER_SEARCH_RESULT_ORGANISATION: 'super-search/organisation/:organisationPK',
        SUPER_SEARCH_RESULT_PERSON: 'super-search/organisation/:organisationPK/person/:personPK'
    };
});

},
'style-guide/v1/doc-control/registration-details/Revisionable':function(){
define([
    './Base',
    'api/Factory',
    'api/doccontrol/filter/DocumentReference',
    'api/doccontrol/filter/ProjectStagePK',
    'api/doccontrol/filter/ProjectStageTreeViewPK',
    'api/doccontrol/revision-details/filter/DocumentType',
    'doc-control/config/Regex',
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/store/Memory',
    'dojo/text!style-guide/v1/doc-control/template/InvalidRevisionNumberFormat.html',
    'dojo/text!./template/Revisionable.html',
    'dijit/form/DateTextBox',
    'dijit/form/FilteringSelect',
    'library/request/data/Handlers',
    'library/request/helper/DefaultUnauthorisedCallback',
    'soso/sosox/ejs/_Templated',
    'spencer/date-time/Format',
    'spencer/doc-control/format/url/ProjectListingQuery',
    'spencer/core/data/ProjectStage',
    'spencer/core/filter/Collection',
    'spencer/format/BranchOfficeEmail',
    'spencer/format/PersonDisplayName',
    'spencer/format/OrganisationDisplayName',
    'style-guide/v1/forms/searchable-select/Selector'
], function(
    Base,
    ApiFactory,
    DocumentReferenceFilter,
    ProjectStagePKFilter,
    ProjectStageTreeViewPKFilter,
    DocumentTypeFilter,
    REGEX,
    declare,
    domAttr,
    domClass,
    Memory,
    invalidRevisionNumberFormat,
    template,
    DateTextBox,
    FilteringSelect,
    HandlersData,
    DefaultUnauthorisedCallback,
    _Templated,
    DateTimeFormat,
    ProjectListingQueryUrl,
    ProjectStageVO,
    FilterCollection,
    BranchOfficeEmailFormatter,
    PersonDisplayNameFormatter,
    OrganisationNameFormatter,
    SearchableSelect
) {
    const ERROR_PRIVATE_DOCUMENT_IN_COLLECTION = 'PRIVATE_DOCUMENT_IN_COLLECTION';

    return declare('style-guide.v1.forms.registration-details.drawing', [Base, _Templated], {
        apiFactory: null,
        apiDocumentRevisionCollection: null,
        availableStatusCollection: null,
        dateTimeFormat: null,
        documentViewer: null,
        statusSelect: null,
        elementReferenceHasPrivateRevision: null,
        existingRevision: null,
        existingRevisionCollection: null,
        elementStatusSelect: null,
        elementInputDate: null,
        elementInputOriginator: null,
        elementInputTitle: null,
        elementInputIsPrivate: null,
        elementInputReference: null,
        elementInputRevision: null,
        elementTitleValidation: null,
        elementReferenceError: null,
        elementReferenceExists: null,
        elementRevisionExists: null,
        elementReferenceValidation: null,
        elementRevisionValidation: null,
        error: '',
        inputDate: null,
        inputOriginator: null,
        date: null,
        title: null,
        originatorContact: null,
        isPrivate: null,
        projectStagePK: null,
        projectStageTreeViewPK: null,
        setRegisterButtonDisabled: null,
        status: null,
        revision: null,
        reference: null,
        md5: null,
        type: null,
        location: null,
        projectOverviewUrl: null,
        elementProjectListingLinkAnchor: null,

        revisionCollectionRequest: null,
        revisionCollectionRequestTimeout: null,

        templateString: template,

        postCreate: function() {
            this.inherited(arguments);

            this.apiFactory = new ApiFactory();
            this.availableStatusCollection = this.apiFactory
                .getDocControlTreeNodeFactory()
                .getAvailableStatusCollection();

            this.dateTimeFormat = new DateTimeFormat();

            this._initForm();

            this.apiDocumentRevisionCollection = this.apiFactory.getDocControlDocumentRevisionFactory().getCollection();

            if (this.reference) {
                this._onReferenceInput();
            }
        },

        getDetails: function() {
            const originator = this.inputOriginator.get('value');

            return {
                personPK: originator ? originator.getPersonPK() : null,
                branchOfficePK: originator ? originator.getBranchOfficePK() : null,
                originatorContact: originator,
                title: domAttr.get(this.elementInputTitle, 'value'),
                date: this.dateTimeFormat.toLocaleISOString(this.inputDate.get('value')),
                isPrivate: domAttr.get(this.elementInputIsPrivate, 'checked'),
                status: domAttr.get(this.statusSelect, 'value'),
                statusVO: this.statusSelect.get('item'),
                revision: domAttr.get(this.elementInputRevision, 'value'),
                reference: domAttr.get(this.elementInputReference, 'value'),
                md5: this.md5,
                treeViewPK: this.projectStageTreeViewPK,
                type: this.type,
                location: this.location,
                projectStagePK: this.projectStagePK,
            };
        },

        getError: function() {
            return this.error;
        },

        removeError: function() {
            this.error = '';
        },

        isValid: function() {
            this._validate();

            if (
                this.inputOriginator.get('value') &&
                domAttr.get(this.elementInputTitle, 'value') !== '' &&
                domAttr.get(this.elementInputReference, 'value') !== '' &&
                domAttr.get(this.elementInputRevision, 'value') !== '' &&
                this.inputDate.get('value') &&
                this.statusSelect.isValid() &&
                this._revisionNumberIsUnique()
            ) {
                if (!this._isRevisionNumberValid()) {
                    this.error = invalidRevisionNumberFormat;
                    return false;
                }
                return true;
            }

            return false;
        },

        setTitle: function(title) {
            this.title = title;
            domAttr.set(this.elementInputTitle, 'value', title);
            return this;
        },

        setReference: function(reference) {
            domAttr.set(this.elementInputReference, 'value', reference);
            return this;
        },

        setDate: function(date) {
            if (date instanceof Date) {
                this.inputDate.set('value', date);
                return this;
            }

            this.inputDate.set('displayedValue', date);
            this.inputDate._hasBeenBlurred = true;
            this.inputDate.validate();
            return this;
        },

        setRevision: function(revision) {
            domAttr.set(this.elementInputRevision, 'value', revision);
            return this;
        },

        setStatusCode: function(statusCode) {
            this.statusCode = statusCode;

            if (this.statusStore) this.statusSelect.set('item', this.statusStore.query({ code: statusCode }));
        },

        _onReferenceInput: function() {
            if (typeof this.setRegisterButtonDisabled === 'function') {
                this.setRegisterButtonDisabled(false);
            }

            this._hideExistingReferenceNotification();
            this._hideExistingRevisionNumberNotification();
            this._hideExistingPrivateRevisionNotification();

            this.existingRevisionCollection = null;
            if (this.revisionCollectionRequestTimeout) {
                clearTimeout(this.revisionCollectionRequestTimeout);
            }

            if (this.revisionCollectionRequest) {
                this.revisionCollectionRequest.cancel();
            }

            const reference = domAttr.get(this.elementInputReference, 'value');
            if (reference && this.projectStagePK && this.projectStageTreeViewPK) {
                this.revisionCollectionRequestTimeout = setTimeout(() => {
                    this._requestRevisionByReferenceAndNode(reference);
                }, 1000)
            }
        },

        _requestRevisionByReferenceAndNode: function(reference) {
            const filterCollection = new FilterCollection()
                .addFilter(new DocumentReferenceFilter(reference))
                .addFilter(new ProjectStageTreeViewPKFilter(this.projectStageTreeViewPK))
                .addFilter(new ProjectStagePKFilter(this.projectStagePK));

            this.revisionCollectionRequest = this.apiDocumentRevisionCollection.get(
                new HandlersData(
                    function success(revisionCollection) {
                        if (!revisionCollection || revisionCollection.length === 0) {
                            if (domAttr.get(this.elementInputRevision, 'value')) {
                                this._validateRevisionNumber();
                            }
                            return;
                        }

                        this._showExistingReferenceNotification();
                        this.existingRevisionCollection = revisionCollection;

                        if (domAttr.get(this.elementInputRevision, 'value')) {
                            this._validateRevisionNumber();
                        }
                    }.bind(this),
                    null,
                    DefaultUnauthorisedCallback,
                    function error(error, description) {
                        if (error === ERROR_PRIVATE_DOCUMENT_IN_COLLECTION) {
                            if (typeof this.setRegisterButtonDisabled === 'function') {
                                this.setRegisterButtonDisabled(true);
                            }

                            if (this.projectOverviewUrl) {
                                const url = (new ProjectListingQueryUrl(this.projectOverviewUrl))
                                    .setProjectStagePK(this.projectStagePK)
                                    .setProjectStageTreeViewPK(this.projectStageTreeViewPK)
                                    .setNodeType(this.type)
                                    .format();

                                domAttr.set(this.elementProjectListingLinkAnchor, 'href', url);
                                domClass.remove(this.elementProjectListingLinkAnchor, 'hide');
                            } else {
                                domClass.add(this.elementProjectListingLinkAnchor, 'hide');
                            }

                            this._showExistingPrivateRevisionNotification();
                            return;
                        }

                        console.error(error, description);
                    }.bind(this)
                ),
                filterCollection
            )
        },

        _hideExistingReferenceNotification: function() {
            domClass.add(this.elementReferenceExists, 'hide');
        },

        _showExistingReferenceNotification: function() {
            domClass.remove(this.elementReferenceExists, 'hide');
        },

        _onViewExistingClick: function() {
            if (!this.existingRevisionCollection) {
                return;
            }

            const latestRevision = this.existingRevisionCollection.find(revision => revision.isLatest());

            this.documentViewer.setRevisionPK(latestRevision.getRevisionPK());
            this.documentViewer.setFileType(latestRevision.getFileType());
            this.documentViewer.initRevisionSidebar().execute();
        },

        _isRevisionNumberValid: function() {
            const value = domAttr.get(this.elementInputRevision, 'value');
            return value && value.match(REGEX.REVISION_NUMBER_VALIDATION) && this._revisionNumberIsUnique(value);
        },

        _validate: function() {
            this.inputOriginator.validate();
            this.inputDate.validate();

            if (domAttr.get(this.elementInputTitle, 'value')) {
                domClass.remove(this.elementTitleValidation, 'sos-form-textfield-validation-error');
            } else {
                domClass.add(this.elementTitleValidation, 'sos-form-textfield-validation-error');
            }

            this.elementReferenceError.innerHTML = 'Document Reference Number is required';
            if (domAttr.get(this.elementInputReference, 'value')) {
                domClass.remove(this.elementReferenceValidation, 'sos-form-textfield-validation-error');
            } else {
                domClass.add(this.elementReferenceValidation, 'sos-form-textfield-validation-error');
            }

            if (domAttr.get(this.elementInputRevision, 'value')) {
                domClass.remove(this.elementRevisionValidation, 'sos-form-textfield-validation-error');
            } else {
                domClass.add(this.elementRevisionValidation, 'sos-form-textfield-validation-error');
            }

            this.statusSelect._hasBeenBlurred = true;
            this.statusSelect.validate();
        },

        _validateRevisionNumber: function() {
            const revisionNumber = domAttr.get(this.elementInputRevision, 'value');

            if (!revisionNumber) {
                this.elementRevisionNumberError.innerHTML = 'Revision Number is required';
                domClass.add(this.elementRevisionValidation, 'sos-form-textfield-validation-error');
                return false;
            }

            if (!this._revisionNumberIsUnique(revisionNumber)) {
                this._showExistingRevisionNumberNotification();
                return false;
            }

            this._hideExistingRevisionNumberNotification();

            if (!revisionNumber.match(REGEX.REVISION_NUMBER_VALIDATION)) {
                this.elementRevisionNumberError.innerHTML = 'Revision Number is not a valid format';
                domClass.add(this.elementRevisionValidation, 'sos-form-textfield-validation-error');
                return false;
            }

            domClass.remove(this.elementRevisionValidation, 'sos-form-textfield-validation-error');
            return true;
        },

        _revisionNumberIsUnique: function(revisionNumber) {
            if (!this.existingRevisionCollection || !revisionNumber) {
                return true;
            }

            return !this.existingRevisionCollection.some(revision => revision.getRevisionNumber() === revisionNumber);
        },

        _hideExistingRevisionNumberNotification: function() {
            domClass.add(this.elementRevisionExists, 'hide');
        },

        _showExistingRevisionNumberNotification: function() {
            domClass.remove(this.elementRevisionExists, 'hide');
        },

        _hideExistingPrivateRevisionNotification: function() {
            domClass.add(this.elementReferenceHasPrivateRevision, 'hide');
        },

        _showExistingPrivateRevisionNotification: function() {
            domClass.remove(this.elementReferenceHasPrivateRevision, 'hide');
        },

        _initForm: function() {
            this._initStatusSelect();
            this._initInputDate();
            this._initDocumentOriginatorFilteringSelect();

            this._initFormValues();
        },

        _initStatusSelect: function() {
            this.statusSelect = new FilteringSelect({
                'class': 'sos-form-filtering-select',
                labelFunc: item => item.description,
                searchAttr: 'description',
                labelAttr: 'description',
                required: true
            }, this.elementStatusSelect);

            this._populateStatusSelectOptionsAndValue();
        },

        _populateStatusSelectOptionsAndValue: function() {
            this.availableStatusCollection.fetch(
                this._getAvailableStatusCollectionHandlers(),
                this.projectStagePK,
                this.projectStageTreeViewPK
            );
        },

        _getAvailableStatusCollectionHandlers: function() {
            return new HandlersData(
                (statuses) => {
                    this.statusStore = new Memory({
                        idProperty: 'statusPK',
                        data: statuses
                    });
                    this.statusSelect.set('store', this.statusStore);

                    if (this.status) {
                        this.statusSelect.set('item', this.statusStore.get(this.status));
                    } else if (this.statusCode) {
                        const result = this.statusStore.query({ code: this.statusCode });
                        if (result.total == 1) {
                            this.statusSelect.set('item', result[0]);
                        }
                    }
                },
                null,
                DefaultUnauthorisedCallback,
                function (error, description) {
                    console.error(error, description);
                }
            );
        },

        _initDocumentOriginatorFilteringSelect: function() {
            const api = this.apiFactory
                .getContactFactory()
                .getContactCollection();

            const branchOfficeEmailFormatter = new BranchOfficeEmailFormatter(
                new OrganisationNameFormatter()
            );

            const personDisplayNameFormatter = new PersonDisplayNameFormatter();

            this.inputOriginator = new SearchableSelect({
                searchAttr: function(result) {
                    branchOfficeEmailFormatter.reset();
                    personDisplayNameFormatter.reset();

                    if(result.organisationPK) {
                        branchOfficeEmailFormatter.setOrganisationName(result.organisation || null);
                        branchOfficeEmailFormatter.setName(result.name || null);
                        branchOfficeEmailFormatter.setEmail(result.email || null);

                        return branchOfficeEmailFormatter.format();
                    }

                    personDisplayNameFormatter.setDisplayName(result.preferredName || result.displayName || result.name || null);
                    personDisplayNameFormatter.setJobTitle(result.jobTitle || null);
                    personDisplayNameFormatter.setOrganisation(result.organisation || null);

                    return personDisplayNameFormatter.format();
                },
                query: function(promise, options) {
                    api.setLimit(options.limit);
                    api.setOffset(options.offset);
                    api.setQuery(options.filter);

                    api.fetch(
                        new HandlersData(
                            function success(response) {
                                promise.resolve(response);
                            },
                            function progress() {},
                            DefaultUnauthorisedCallback
                        )
                    );
                },
                icon: function(result) {
                    if(result.personPK) {
                        return 'user-o';
                    }

                    if(result.organisationPK) {
                        return 'building-o';
                    }
                },
                limit: 50,
                required: true,
                disabled: this.disabled
            }, this.elementInputOriginator);

            if (this.originatorContact) {
                this.inputOriginator.set('value', this.originatorContact);
            }
        },

        _initInputDate: function() {
            this.inputDate = new DateTextBox({
                'class': 'sos-date-text-box',
                'constraints':{
                    'datePattern':'dd/MM/yyyy'
                },
                'placeHolder':'Select date',
                'value' : this.date ? this.date : new Date(),
                dropDownPosition: ['below'],
                required: true
            }, this.elementInputDate);
            this.inputDate.startup();
        },

        _initFormValues: function() {
            if (this.title) {
                domAttr.set(this.elementInputTitle, 'value', this.title);
            }

            if (this.isPrivate) {
                domAttr.set(this.elementInputIsPrivate, 'checked', 'checked');
            }

            if (this.reference) {
                domAttr.set(this.elementInputReference, 'value', this.reference);
            }

            if (this.revision && REGEX.REVISION_NUMBER_VALIDATION.test(this.revision)) {
                domAttr.set(this.elementInputRevision, 'value', this.revision);
            }
        },

        _setOriginatorToCurrentPerson: function() {
            this.inputOriginator.set('value', this.currentContact);
        }
    });
});

},
'style-guide/v1/doc-control/registration-details/RevisionableFromFunction':function(){
define([
    './Revisionable',
    'dojo/_base/declare',
    'dojo/store/Memory',
    'dojo/text!./template/RevisionableFromFunction.html',
    'dijit/form/FilteringSelect',
    'library/request/data/Handlers',
    'library/request/helper/DefaultUnauthorisedCallback'
], function(
    Revisionable,
    declare,
    Memory,
    template,
    FilteringSelect,
    HandlersData,
    DefaultUnauthorisedCallback
) {
    return declare([Revisionable], {
        templateString: template,
        elementInputNodeReference: null,
        elementNodeReferenceValidation: null,
        nodeReference: null,

        isValid: function() {
            return this.inherited(arguments) && !!this.elementInputNodeReference.value;
        },

        getDetails: function() {
            return Object.assign({nodeReference: this.elementInputNodeReference.value}, this.inherited(arguments));
        },

        setNodeReference: function(nodeReference) {
            this.elementInputNodeReference.value = nodeReference;
            return this;
        },

        _initFormValues: function() {
            this.inherited(arguments);

            if (this.nodeReference) this.elementInputNodeReference.value = this.nodeReference;
        },

        _populateStatusSelectOptionsAndValue: function() {
            this.availableStatusCollection.onlyRevisionable().fetch(
                this._getAvailableStatusCollectionHandlers(),
                this.projectStagePK,
                this.projectStageTreeViewPK
            );
        },

        _validate: function() {
            this.elementNodeReferenceValidation.classList.toggle(
                'sos-form-textfield-validation-error',
                !this.elementInputNodeReference.value
            );

            this.inherited(arguments);
        }
    });
});

},
'style-guide/v1/doc-control/registration-details/DocumentRegister/SmartRegisterProcessor':function(){
define(["require", "exports", "library/request/helper/DefaultUnauthorisedCallback", "style-guide/v1/doc-control/registration-details/DocumentRegister/DocumentEventProcessor", "@lib/doc-control/document/template/FieldCollection", "library/request/data/Handlers", "@lib/request/data/HTTPResponseCodes", "ocr/parser/Date", "api/project/Config", "api/project/Factory", "api/project/data/ProjectStage", "api/doccontrol/file/QrReader/Factory", "api/doccontrol/revision-details/Factory", "@lib/doc-control/document/template/field/RegistrationFields", "./SmartRegisterData", "spencer/doc-control/data/Status", "api/doccontrol/template/Config", "api/doccontrol/template/Factory", "api/doccontrol/template/parser/Template", "api/doccontrol/tree/node/Builder", "library/request/URLConnectionBuilder", "library/request/dojo/URLConnectionProcessorBuilder", "library/request/URLResponseProcessorBuilder"], function (require, exports, DefaultUnauthorisedCallback, DocumentEventProcessor, FieldCollection, HandlersVO, HTTPResponseCodes, OCRDateParser, ProjectConfig, ProjectFactory, ProjectStageVO, QRReaderFactory, RevisionDetailsFactory, REGISTRATION_FIELDS, SmartRegisterData, StatusVO, TemplateConfig, TemplateFactory, TemplateParser, TreeNodeBuilder, URLConnectionBuilder, URLConnectionProcessorBuilder, URLResponseProcessorBuilder) {
    "use strict";
    const PROCESSING_STEP = {
        DETECTING_TREE_NODES: 'Detecting Location...',
        EXTRACTION: 'Extracting content...',
        QR_CODE: 'Searching for QR code...',
        TEMPLATE: 'Retrieving template...'
    };
    const CANCELLED_MESSAGE = 'Smart Registration cancelled by user';
    class SmartRegisterProcessor {
        onProgressUpdate(md5, progressStatus) { }
        onDocumentEventUpdate(smartRegisterData) { }
        onSuggestedNodesUpdate(smartRegisterData) { }
        constructor(apiProjectStage = new ProjectFactory(new ProjectConfig(), new URLConnectionBuilder(new URLConnectionProcessorBuilder()), new URLResponseProcessorBuilder()).getProjectStage(), apiQRCodeReader = (new QRReaderFactory()).getQRCodeReader(), apiTreeNodeDetector = new TreeNodeBuilder().getTreeNodeFactory().getDetector(), ocrTemplateFactory = new TemplateFactory(new TemplateConfig(), new URLConnectionBuilder(new URLConnectionProcessorBuilder()), new URLResponseProcessorBuilder()), ocrTemplateParser = new TemplateParser(), documentEventProcessor = new DocumentEventProcessor()) {
            this.apiProjectStage = apiProjectStage;
            this.apiQRCodeReader = apiQRCodeReader;
            this.apiTreeNodeDetector = apiTreeNodeDetector;
            this.ocrTemplateFactory = ocrTemplateFactory;
            this.ocrTemplateParser = ocrTemplateParser;
            this.documentEventProcessor = documentEventProcessor;
            this.requests = {};
            this.nodeDetectionRequests = {};
            this.cache = {};
            this.ocrTemplate = this.ocrTemplateFactory.getTemplate();
            this.ocrTemplateExtractor = this.ocrTemplateFactory.getExtractor();
            const revisionDetailsFactory = new RevisionDetailsFactory(new TemplateConfig(), new URLConnectionBuilder(new URLConnectionProcessorBuilder()), new URLResponseProcessorBuilder());
            this.apiDrawingDiscipline = revisionDetailsFactory.getDrawingDiscipline();
            this.documentEventProcessor
                .setQRProcessingComplete(async (md5, event) => {
                const document = this.getCachedResult(md5);
                if (!event?.data?.templatePK) {
                    this.onDocumentEventUpdate(document);
                    return;
                }
                if (document.getTemplate()) {
                    return;
                }
                try {
                    const parsedQrCodeContent = this.ocrTemplateParser.parse(event.data);
                    this.getCachedResult(md5).setQrCodeContent(parsedQrCodeContent);
                    this.getTemplate(md5, parsedQrCodeContent).then(() => {
                        this.onDocumentEventUpdate(this.getCachedResult(md5));
                    });
                }
                catch (e) { }
            })
                .setOnOCRProcessingComplete((md5, event) => {
                const document = this.getCachedResult(md5);
                if (document.getFieldCollection().length !== 0 || !event?.data?.fieldCollection) {
                    this.onDocumentEventUpdate(document);
                    return;
                }
                const fieldCollection = event.data.fieldCollection;
                document.setFieldCollection(fieldCollection);
                this.parseFieldCollection(md5, fieldCollection);
                Promise.all([
                    this.extractProjectStage(md5, fieldCollection),
                    this.extractDrawingDiscipline(md5, fieldCollection),
                    this.extractStatus(md5, fieldCollection)
                ]).finally(() => this.onDocumentEventUpdate(this.getCachedResult(md5)));
            })
                .setOnNodeDetectionSuccess(async (md5, event) => {
                if (this.nodeDetectionRequests.hasOwnProperty(md5)) {
                    const key = this.generateNodeDetectionRequestKey(md5, this.nodeDetectionRequests[md5].projectStagePK);
                    if (this.requests.hasOwnProperty(key)) {
                        delete this.requests[key];
                    }
                    this.detectTreeNodes(md5, this.nodeDetectionRequests[md5].projectStagePK, this.nodeDetectionRequests[md5].fileKey);
                }
            })
                .setOnError((md5, event) => {
                this.onDocumentEventUpdate(this.getCachedResult(md5));
            });
        }
        async start(md5) {
            return new Promise(async (resolve, reject) => {
                if (this.requests.hasOwnProperty(md5) && !this.requests[md5].isCancelled()) {
                    return reject(`Document already Processing`);
                }
                delete this.requests[md5];
                try {
                    const qrCodeData = await this.readQRCode(md5);
                    if (this.requests[md5]?.isCancelled?.())
                        return reject(CANCELLED_MESSAGE);
                    if (!qrCodeData)
                        return resolve(this.getCachedResult(md5));
                    const template = await this.getTemplate(md5, qrCodeData);
                    if (this.requests[md5]?.isCancelled?.())
                        return reject(CANCELLED_MESSAGE);
                    if (!template)
                        return resolve(this.getCachedResult(md5));
                    await this.extractContent(md5, template.getTemplatePK());
                    if (this.requests[md5]?.isCancelled?.())
                        return reject(CANCELLED_MESSAGE);
                    resolve(this.getCachedResult(md5));
                }
                catch (e) {
                    this.documentEventProcessor.start(md5);
                    reject('Awaiting background processing results');
                }
            });
        }
        stop(md5) {
            this.requests[md5]?.cancel();
            if (this.nodeDetectionRequests[md5]?.projectStagePK) {
                const key = this.generateNodeDetectionRequestKey(md5, this.nodeDetectionRequests[md5].projectStagePK);
                this.requests[key]?.cancel();
            }
            this.documentEventProcessor.stop(md5);
        }
        cancel() {
            this.documentEventProcessor.cancel();
            for (const md5 in this.requests) {
                if (this.requests[md5].hasOwnProperty('cancel')) {
                    this.requests[md5].cancel();
                }
            }
            this.nodeDetectionRequests = {};
            this.requests = {};
        }
        setOnProgressUpdate(handler) {
            this.onProgressUpdate = handler;
            return this;
        }
        setOnDocumentEventUpdate(handler) {
            this.onDocumentEventUpdate = handler;
            return this;
        }
        setOnSuggestedNodesUpdate(handler) {
            this.onSuggestedNodesUpdate = handler;
            return this;
        }
        detectTreeNodes(md5, projectStagePK, fileKey = null) {
            const key = this.generateNodeDetectionRequestKey(md5, projectStagePK);
            if (this.requests[key]) {
                return;
            }
            this.onProgressUpdate(md5, PROCESSING_STEP.DETECTING_TREE_NODES);
            this.getCachedResult(md5).setSuggestedNodes([]);
            this.requests[key] = this.apiTreeNodeDetector.get(new HandlersVO((suggestedNodes) => {
                delete this.requests[key];
                this.getCachedResult(md5)
                    .setProjectStagePKForSuggestedNodes(projectStagePK)
                    .setSuggestedNodes(suggestedNodes);
                this.onSuggestedNodesUpdate(this.getCachedResult(md5));
            }, () => { }, DefaultUnauthorisedCallback, (error) => {
                delete this.requests[key];
                console.error(error);
                this.getCachedResult(md5)
                    .setProjectStagePKForSuggestedNodes(projectStagePK)
                    .setSuggestedNodes([]);
                this.onSuggestedNodesUpdate(this.getCachedResult(md5));
            }).setAccepted(() => {
                this.listenForNodeDetectionEvents(md5, projectStagePK, fileKey);
            }), fileKey || md5, projectStagePK);
            this.nodeDetectionRequests[md5] = { projectStagePK: projectStagePK, fileKey: fileKey || md5 };
        }
        listenForNodeDetectionEvents(md5, projectStagePK, fileKey = null) {
            this.nodeDetectionRequests[md5] = { projectStagePK: projectStagePK, fileKey: fileKey };
            this.documentEventProcessor.start(md5);
        }
        isNodeDetectionStep(step) {
            return step === PROCESSING_STEP.DETECTING_TREE_NODES;
        }
        readQRCode(md5) {
            this.onProgressUpdate(md5, PROCESSING_STEP.QR_CODE);
            return new Promise((resolve, reject) => {
                this.requests[md5] = this.apiQRCodeReader.get(new HandlersVO((qrCodeContent) => {
                    delete this.requests[md5];
                    try {
                        qrCodeContent = JSON.parse(qrCodeContent);
                        if (!qrCodeContent || !qrCodeContent.reference) {
                            return resolve();
                        }
                        const parsedQrCodeContent = this.ocrTemplateParser.parse(qrCodeContent);
                        this.getCachedResult(md5).setQrCodeContent(parsedQrCodeContent);
                        resolve(parsedQrCodeContent);
                    }
                    catch (e) {
                        resolve();
                    }
                }, () => { }, DefaultUnauthorisedCallback, (error) => {
                    delete this.requests[md5];
                    if (error?.status === HTTPResponseCodes.not_found) {
                        return reject();
                    }
                    resolve();
                }, resolve).setNoContent(() => {
                    delete this.requests[md5];
                    resolve();
                }), md5);
            });
        }
        getTemplate(md5, templateContent) {
            this.onProgressUpdate(md5, PROCESSING_STEP.TEMPLATE);
            return new Promise((resolve) => {
                this.requests[md5] = this.ocrTemplate.get(new HandlersVO((template) => {
                    delete this.requests[md5];
                    this.getCachedResult(md5).setTemplate(template);
                    resolve(template);
                }, () => { }, DefaultUnauthorisedCallback, () => {
                    delete this.requests[md5];
                    resolve();
                }, resolve), templateContent);
            });
        }
        extractContent(md5, templatePK) {
            this.onProgressUpdate(md5, PROCESSING_STEP.EXTRACTION);
            return new Promise((resolve, reject) => {
                this.requests[md5] = this.ocrTemplateExtractor.extract(new HandlersVO((fieldCollection) => {
                    delete this.requests[md5];
                    this.getCachedResult(md5).setFieldCollection(fieldCollection);
                    this.parseFieldCollection(md5, fieldCollection);
                    Promise.all([
                        this.extractProjectStage(md5, fieldCollection),
                        this.extractDrawingDiscipline(md5, fieldCollection),
                        this.extractStatus(md5, fieldCollection),
                        this.extractRevisionWithStatus(md5, fieldCollection)
                    ]).then(() => resolve()).catch(() => resolve());
                }, () => { }, DefaultUnauthorisedCallback, (error, description, statusCode) => {
                    delete this.requests[md5];
                    if (statusCode === HTTPResponseCodes.not_found) {
                        return reject();
                    }
                    resolve();
                }, resolve), md5, templatePK);
            });
        }
        extractProjectStage(md5, fieldCollection) {
            const extractedProjectNumber = FieldCollection.getExtractedProjectNumber(fieldCollection);
            return new Promise(async (resolve) => {
                if (extractedProjectNumber) {
                    try {
                        await this.extractProject(md5, extractedProjectNumber);
                    }
                    catch (e) { }
                }
                resolve();
            });
        }
        extractDrawingDiscipline(md5, fieldCollection) {
            return new Promise((resolve) => {
                const extractedDiscipline = FieldCollection.getExtractedDrawingDiscipline(fieldCollection);
                if (!extractedDiscipline) {
                    return resolve();
                }
                this.apiDrawingDiscipline.getByCode(extractedDiscipline)
                    .then((drawingDiscipline) => {
                    this.getCachedResult(md5).getExtractedRegistrationDetails().setDisciplineVO(drawingDiscipline);
                    resolve();
                }).catch(() => resolve());
            });
        }
        extractStatus(md5, fieldCollection) {
            return new Promise((resolve) => {
                const extractedStatus = FieldCollection.getExtractedStatus(fieldCollection);
                if (extractedStatus) {
                    this.getCachedResult(md5)
                        .getExtractedRegistrationDetails()
                        .setStatusVO((new StatusVO()).setCode(extractedStatus));
                }
                resolve();
            });
        }
        extractRevisionWithStatus(md5, fieldCollection) {
            return new Promise((resolve) => {
                const extractedRevisionWithStatus = FieldCollection.getExtractedRevisionWithStatus(fieldCollection);
                if (extractedRevisionWithStatus) {
                    this.getCachedResult(md5).getExtractedRegistrationDetails()
                        .setRevision(extractedRevisionWithStatus);
                }
                resolve();
            });
        }
        async extractProject(md5, extractedProjectNumber) {
            await new Promise((resolve) => {
                this.requests[md5] = this.apiProjectStage.get(new HandlersVO((projectStage) => {
                    delete this.requests[md5];
                    if (projectStage && projectStage.hasOwnProperty('projectStagePK')) {
                        this.getCachedResult(md5).setProjectStage(projectStage);
                        this.getCachedResult(md5)
                            .getExtractedRegistrationDetails()
                            .setProjectStagePK(projectStage.getProjectStagePK());
                    }
                    resolve();
                }, () => { }, DefaultUnauthorisedCallback, () => {
                    delete this.requests[md5];
                    resolve();
                }, resolve), new ProjectStageVO().setStageNumber(extractedProjectNumber));
            });
        }
        generateNodeDetectionRequestKey(md5, projectStagePK) {
            return md5 + projectStagePK;
        }
        getCachedResult(md5) {
            if (!this.cache.hasOwnProperty(md5)) {
                this.cache[md5] = (new SmartRegisterData(md5));
            }
            return this.cache[md5];
        }
        invalidateCache(md5) {
            if (this.cache.hasOwnProperty(md5)) {
                delete this.cache[md5];
            }
        }
        parseFieldCollection(md5, fieldCollection) {
            fieldCollection.forEach((field) => {
                if (!field.hasOwnProperty('refersTo'))
                    return;
                switch (field.refersTo) {
                    case REGISTRATION_FIELDS.REVISION:
                        this.getCachedResult(md5).getExtractedRegistrationDetails().setRevision(field.value);
                        break;
                    case REGISTRATION_FIELDS.REFERENCE:
                        this.getCachedResult(md5).getExtractedRegistrationDetails().setReference(field.value);
                        break;
                    case REGISTRATION_FIELDS.DATE:
                        try {
                            this.getCachedResult(md5).getExtractedRegistrationDetails().setDate(OCRDateParser.parse(field.value));
                        }
                        catch (e) {
                            this.getCachedResult(md5).getExtractedRegistrationDetails().setDate(field.value);
                        }
                        break;
                    case REGISTRATION_FIELDS.TITLE:
                        this.getCachedResult(md5).getExtractedRegistrationDetails().setTitle(field.value);
                        break;
                    case REGISTRATION_FIELDS.NODE_REFERENCE:
                        this.getCachedResult(md5).getExtractedRegistrationDetails().setNodeReference(field.value);
                        break;
                }
            });
        }
    }
    return SmartRegisterProcessor;
});

},
'style-guide/v1/doc-control/registration-details/DocumentRegister/DocumentEventProcessor':function(){
define(["require", "exports", "@lib/doc-control/document/event/type/NodeDetection", "@lib/doc-control/document/event/type/OCRProcessing", "@lib/doc-control/document/event/type/QRProcessing", "@lib/request/socket/Socket", "library/request/socket/adapter/SocketIOSingleton", "dojo/_base/config"], function (require, exports, NodeDetectionEventType, OCRProcessingEventType, QRProcessingEventType, Socket, SocketAdapterSingleton, config) {
    "use strict";
    class DocumentEventProcessor {
        constructor(socket = new Socket(SocketAdapterSingleton.getInstance(config.socketUrl))) {
            this.socket = socket;
            this.receivedEventHandlers = [];
            this.subscribedMd5s = [];
        }
        onError(md5, event) { }
        onQRProcessingComplete(md5, event) { }
        onOCRProcessingComplete(md5, event) { }
        onNodeDetectionSuccess(md5, event) { }
        setOnError(handler) {
            this.onError = handler;
            return this;
        }
        setQRProcessingComplete(handler) {
            this.onQRProcessingComplete = handler;
            return this;
        }
        setOnOCRProcessingComplete(handler) {
            this.onOCRProcessingComplete = handler;
            return this;
        }
        setOnNodeDetectionSuccess(handler) {
            this.onNodeDetectionSuccess = handler;
            return this;
        }
        async start(md5) {
            if (this.subscribedMd5s.includes(md5))
                return;
            try {
                if (!this.receivedEventHandlers.includes(md5)) {
                    await this.socket.subscribe('/document/event/receive', (event) => {
                        this.processReceivedDocumentEvent(md5, event);
                    });
                    this.receivedEventHandlers.push(md5);
                }
                await this.socket.send('/document/event/subscribe', { md5: md5, personPK: config.personPK }, (events) => {
                    events.forEach((event) => this.processReceivedDocumentEvent(md5, event));
                });
                this.subscribedMd5s.push(md5);
            }
            catch (err) {
                console.error(err);
            }
        }
        stop(md5) {
            if (!this.subscribedMd5s.includes(md5))
                return;
            this.socket.send('/document/event/unsubscribe', {
                md5: md5,
                personPK: config.personPK
            });
            this.subscribedMd5s.splice(this.subscribedMd5s.indexOf(md5), 1);
        }
        cancel() {
            this.subscribedMd5s.forEach(md5 => {
                this.socket.send('/document/event/unsubscribe', {
                    md5: md5,
                    personPK: config.personPK
                });
            });
            this.subscribedMd5s = [];
        }
        processReceivedDocumentEvent(md5, event) {
            if (NodeDetectionEventType.isError(event) ||
                OCRProcessingEventType.isError(event) ||
                QRProcessingEventType.isError(event)) {
                if (event.md5 === md5)
                    this.onError(md5, event);
                return;
            }
            if (NodeDetectionEventType.isSuccess(event) && event.md5 === md5) {
                this.onNodeDetectionSuccess(md5, event);
                return;
            }
            if (OCRProcessingEventType.isComplete(event) && event.md5 === md5) {
                this.onOCRProcessingComplete(md5, event);
                return;
            }
            if (QRProcessingEventType.isComplete(event) && event.md5 === md5) {
                this.onQRProcessingComplete(md5, event);
                return;
            }
        }
    }
    return DocumentEventProcessor;
});

},
'@lib/doc-control/document/event/type/NodeDetection':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class NodeDetection {
        static isNodeDetection(event) {
            return event.type === NodeDetection.type && !!event.state;
        }
        static isError(event) {
            return NodeDetection.isNodeDetection(event) && event.state === NodeDetection.error;
        }
        static isSuccess(event) {
            return NodeDetection.isNodeDetection(event) && event.state === NodeDetection.processed;
        }
        static isComplete(event) {
            return NodeDetection.isError(event) || NodeDetection.isSuccess(event);
        }
    }
    NodeDetection.type = 'NodeDetection';
    NodeDetection.processed = 'processed';
    NodeDetection.error = 'error';
    return NodeDetection;
});

},
'@lib/doc-control/document/event/type/OCRProcessing':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class OCRProcessing {
        static isOcrProcessing(event) {
            return event.type === OCRProcessing.type && !!event.state;
        }
        static isError(event) {
            return OCRProcessing.isOcrProcessing(event) && event.state === OCRProcessing.error;
        }
        static isSuccess(event) {
            return OCRProcessing.isOcrProcessing(event) && event.state === OCRProcessing.finished;
        }
        static isComplete(event) {
            return OCRProcessing.isError(event) || OCRProcessing.isSuccess(event);
        }
    }
    OCRProcessing.type = 'OCR';
    OCRProcessing.finished = 'finish';
    OCRProcessing.error = 'error';
    return OCRProcessing;
});

},
'@lib/doc-control/document/event/type/QRProcessing':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class QRProcessing {
        static isQrProcessing(event) {
            return event.type === QRProcessing.type && !!event.state;
        }
        static isError(event) {
            return QRProcessing.isQrProcessing(event) && event.state === QRProcessing.error;
        }
        static isSuccess(event) {
            return QRProcessing.isQrProcessing(event) && event.state === QRProcessing.finished;
        }
        static isComplete(event) {
            return QRProcessing.isError(event) || QRProcessing.isSuccess(event);
        }
    }
    QRProcessing.type = 'QR';
    QRProcessing.finished = 'finish';
    QRProcessing.error = 'error';
    return QRProcessing;
});

},
'@lib/request/socket/Socket':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Socket {
        constructor(adapter) {
            this.adapter = adapter;
        }
        send(name, value, acknowledgeCallback = null) {
            return this.adapter.send(name, value, acknowledgeCallback);
        }
        subscribe(name, event) {
            return this.adapter.subscribe(name, event);
        }
        open() {
            return this.adapter.open();
        }
        close() {
            this.adapter.close();
        }
        isConnected() {
            return this.adapter.isConnected();
        }
    }
    return Socket;
});

},
'library/request/socket/adapter/SocketIOSingleton':function(){
define(["require", "exports", "./SocketIO"], function (require, exports, SocketIO) {
    "use strict";
    class PersistentSocket extends SocketIO {
        close() {
            console.error('Attempting to close a persistent socket connection');
        }
    }
    class SocketIOSingleton {
        constructor() { }
        static getInstance(url, attemptToReconnect) {
            if (!SocketIOSingleton.socket) {
                SocketIOSingleton.socket = new PersistentSocket(url, attemptToReconnect);
            }
            return SocketIOSingleton.socket;
        }
    }
    SocketIOSingleton.socket = null;
    return SocketIOSingleton;
});

},
'library/request/socket/adapter/SocketIO':function(){
/// <amd-dependency path="vendor/socket.io/client-dist/socket.io" name="IO" />
define(["require", "exports", "vendor/socket.io/client-dist/socket.io", "@lib/request/socket/adapter/events/SocketIO"], function (require, exports, IO, SocketIOEvents) {
    "use strict";
    class SocketIO {
        constructor(url, reconnection) {
            this.url = url;
            this.EVENTS = {};
            this.socket = null;
            this.reconnection = reconnection !== undefined && !!reconnection;
            this.EVENTS = SocketIOEvents;
        }
        open() {
            if (!this.socket) {
                this.socket = IO.connect(this.url, { reconnection: this.reconnection });
                return new Promise((resolve, reject) => {
                    this.socket.on(this.EVENTS.CONNECT, resolve);
                    this.socket.on(this.EVENTS.CONNECT_ERROR, reject);
                });
            }
            if (!this.isConnected()) {
                this.socket.io.connect();
                return new Promise((resolve, reject) => {
                    this.socket.on(this.EVENTS.CONNECT, resolve);
                    this.socket.on(this.EVENTS.CONNECT_ERROR, reject);
                });
            }
            return new Promise((resolve) => resolve());
        }
        close() {
            if (!this.isConnected()) {
                return;
            }
            this.socket.disconnect();
            this.socket = null;
        }
        async send(name, value, acknowledgeCallback) {
            await this.open();
            if (typeof acknowledgeCallback === "function") {
                this.socket.emit(name, value, acknowledgeCallback);
                return;
            }
            this.socket.emit(name, value);
        }
        async subscribe(name, event) {
            await this.open();
            this.socket.on(name, event);
        }
        isConnected() {
            return this.socket && this.socket.connected;
        }
    }
    return SocketIO;
});

},
'vendor/socket.io/client-dist/socket.io':function(){
/*!
 * Socket.IO v4.8.1
 * (c) 2014-2024 Guillermo Rauch
 * Released under the MIT License.
 */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.io = factory());
})(this, (function () { 'use strict';

  function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
    return n;
  }
  function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return _arrayLikeToArray(r);
  }
  function _construct(t, e, r) {
    if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments);
    var o = [null];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && _setPrototypeOf(p, r.prototype), p;
  }
  function _defineProperties(e, r) {
    for (var t = 0; t < r.length; t++) {
      var o = r[t];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
  }
  function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
      writable: !1
    }), e;
  }
  function _createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
      if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var n = 0,
          F = function () {};
        return {
          s: F,
          n: function () {
            return n >= r.length ? {
              done: !0
            } : {
              done: !1,
              value: r[n++]
            };
          },
          e: function (r) {
            throw r;
          },
          f: F
        };
      }
      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o,
      a = !0,
      u = !1;
    return {
      s: function () {
        t = t.call(r);
      },
      n: function () {
        var r = t.next();
        return a = r.done, r;
      },
      e: function (r) {
        u = !0, o = r;
      },
      f: function () {
        try {
          a || null == t.return || t.return();
        } finally {
          if (u) throw o;
        }
      }
    };
  }
  function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function (n) {
      for (var e = 1; e < arguments.length; e++) {
        var t = arguments[e];
        for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
      return n;
    }, _extends.apply(null, arguments);
  }
  function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
      return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
  }
  function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
  }
  function _isNativeFunction(t) {
    try {
      return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
      return "function" == typeof t;
    }
  }
  function _isNativeReflectConstruct() {
    try {
      var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function () {
      return !!t;
    })();
  }
  function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
  }
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
      return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
  }
  function _toConsumableArray(r) {
    return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
  }
  function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r || "default");
      if ("object" != typeof i) return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }
  function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function _typeof(o) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
      return typeof o;
    } : function (o) {
      return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
  }
  function _unsupportedIterableToArray(r, a) {
    if (r) {
      if ("string" == typeof r) return _arrayLikeToArray(r, a);
      var t = {}.toString.call(r).slice(8, -1);
      return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
  }
  function _wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return _wrapNativeSuper = function (t) {
      if (null === t || !_isNativeFunction(t)) return t;
      if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
      if (void 0 !== r) {
        if (r.has(t)) return r.get(t);
        r.set(t, Wrapper);
      }
      function Wrapper() {
        return _construct(t, arguments, _getPrototypeOf(this).constructor);
      }
      return Wrapper.prototype = Object.create(t.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), _setPrototypeOf(Wrapper, t);
    }, _wrapNativeSuper(t);
  }

  var PACKET_TYPES = Object.create(null); // no Map = no polyfill
  PACKET_TYPES["open"] = "0";
  PACKET_TYPES["close"] = "1";
  PACKET_TYPES["ping"] = "2";
  PACKET_TYPES["pong"] = "3";
  PACKET_TYPES["message"] = "4";
  PACKET_TYPES["upgrade"] = "5";
  PACKET_TYPES["noop"] = "6";
  var PACKET_TYPES_REVERSE = Object.create(null);
  Object.keys(PACKET_TYPES).forEach(function (key) {
    PACKET_TYPES_REVERSE[PACKET_TYPES[key]] = key;
  });
  var ERROR_PACKET = {
    type: "error",
    data: "parser error"
  };

  var withNativeBlob$1 = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
  var withNativeArrayBuffer$2 = typeof ArrayBuffer === "function";
  // ArrayBuffer.isView method is not defined in IE10
  var isView$1 = function isView(obj) {
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
  };
  var encodePacket = function encodePacket(_ref, supportsBinary, callback) {
    var type = _ref.type,
      data = _ref.data;
    if (withNativeBlob$1 && data instanceof Blob) {
      if (supportsBinary) {
        return callback(data);
      } else {
        return encodeBlobAsBase64(data, callback);
      }
    } else if (withNativeArrayBuffer$2 && (data instanceof ArrayBuffer || isView$1(data))) {
      if (supportsBinary) {
        return callback(data);
      } else {
        return encodeBlobAsBase64(new Blob([data]), callback);
      }
    }
    // plain string
    return callback(PACKET_TYPES[type] + (data || ""));
  };
  var encodeBlobAsBase64 = function encodeBlobAsBase64(data, callback) {
    var fileReader = new FileReader();
    fileReader.onload = function () {
      var content = fileReader.result.split(",")[1];
      callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
  };
  function toArray(data) {
    if (data instanceof Uint8Array) {
      return data;
    } else if (data instanceof ArrayBuffer) {
      return new Uint8Array(data);
    } else {
      return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
    }
  }
  var TEXT_ENCODER;
  function encodePacketToBinary(packet, callback) {
    if (withNativeBlob$1 && packet.data instanceof Blob) {
      return packet.data.arrayBuffer().then(toArray).then(callback);
    } else if (withNativeArrayBuffer$2 && (packet.data instanceof ArrayBuffer || isView$1(packet.data))) {
      return callback(toArray(packet.data));
    }
    encodePacket(packet, false, function (encoded) {
      if (!TEXT_ENCODER) {
        TEXT_ENCODER = new TextEncoder();
      }
      callback(TEXT_ENCODER.encode(encoded));
    });
  }

  // imported from https://github.com/socketio/base64-arraybuffer
  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
  // Use a lookup table to find the index.
  var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
  for (var i = 0; i < chars.length; i++) {
    lookup$1[chars.charCodeAt(i)] = i;
  }
  var decode$1 = function decode(base64) {
    var bufferLength = base64.length * 0.75,
      len = base64.length,
      i,
      p = 0,
      encoded1,
      encoded2,
      encoded3,
      encoded4;
    if (base64[base64.length - 1] === '=') {
      bufferLength--;
      if (base64[base64.length - 2] === '=') {
        bufferLength--;
      }
    }
    var arraybuffer = new ArrayBuffer(bufferLength),
      bytes = new Uint8Array(arraybuffer);
    for (i = 0; i < len; i += 4) {
      encoded1 = lookup$1[base64.charCodeAt(i)];
      encoded2 = lookup$1[base64.charCodeAt(i + 1)];
      encoded3 = lookup$1[base64.charCodeAt(i + 2)];
      encoded4 = lookup$1[base64.charCodeAt(i + 3)];
      bytes[p++] = encoded1 << 2 | encoded2 >> 4;
      bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
      bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
  };

  var withNativeArrayBuffer$1 = typeof ArrayBuffer === "function";
  var decodePacket = function decodePacket(encodedPacket, binaryType) {
    if (typeof encodedPacket !== "string") {
      return {
        type: "message",
        data: mapBinary(encodedPacket, binaryType)
      };
    }
    var type = encodedPacket.charAt(0);
    if (type === "b") {
      return {
        type: "message",
        data: decodeBase64Packet(encodedPacket.substring(1), binaryType)
      };
    }
    var packetType = PACKET_TYPES_REVERSE[type];
    if (!packetType) {
      return ERROR_PACKET;
    }
    return encodedPacket.length > 1 ? {
      type: PACKET_TYPES_REVERSE[type],
      data: encodedPacket.substring(1)
    } : {
      type: PACKET_TYPES_REVERSE[type]
    };
  };
  var decodeBase64Packet = function decodeBase64Packet(data, binaryType) {
    if (withNativeArrayBuffer$1) {
      var decoded = decode$1(data);
      return mapBinary(decoded, binaryType);
    } else {
      return {
        base64: true,
        data: data
      }; // fallback for old browsers
    }
  };
  var mapBinary = function mapBinary(data, binaryType) {
    switch (binaryType) {
      case "blob":
        if (data instanceof Blob) {
          // from WebSocket + binaryType "blob"
          return data;
        } else {
          // from HTTP long-polling or WebTransport
          return new Blob([data]);
        }
      case "arraybuffer":
      default:
        if (data instanceof ArrayBuffer) {
          // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
          return data;
        } else {
          // from WebTransport (Uint8Array)
          return data.buffer;
        }
    }
  };

  var SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
  var encodePayload = function encodePayload(packets, callback) {
    // some packets may be added to the array while encoding, so the initial length must be saved
    var length = packets.length;
    var encodedPackets = new Array(length);
    var count = 0;
    packets.forEach(function (packet, i) {
      // force base64 encoding for binary packets
      encodePacket(packet, false, function (encodedPacket) {
        encodedPackets[i] = encodedPacket;
        if (++count === length) {
          callback(encodedPackets.join(SEPARATOR));
        }
      });
    });
  };
  var decodePayload = function decodePayload(encodedPayload, binaryType) {
    var encodedPackets = encodedPayload.split(SEPARATOR);
    var packets = [];
    for (var i = 0; i < encodedPackets.length; i++) {
      var decodedPacket = decodePacket(encodedPackets[i], binaryType);
      packets.push(decodedPacket);
      if (decodedPacket.type === "error") {
        break;
      }
    }
    return packets;
  };
  function createPacketEncoderStream() {
    return new TransformStream({
      transform: function transform(packet, controller) {
        encodePacketToBinary(packet, function (encodedPacket) {
          var payloadLength = encodedPacket.length;
          var header;
          // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
          if (payloadLength < 126) {
            header = new Uint8Array(1);
            new DataView(header.buffer).setUint8(0, payloadLength);
          } else if (payloadLength < 65536) {
            header = new Uint8Array(3);
            var view = new DataView(header.buffer);
            view.setUint8(0, 126);
            view.setUint16(1, payloadLength);
          } else {
            header = new Uint8Array(9);
            var _view = new DataView(header.buffer);
            _view.setUint8(0, 127);
            _view.setBigUint64(1, BigInt(payloadLength));
          }
          // first bit indicates whether the payload is plain text (0) or binary (1)
          if (packet.data && typeof packet.data !== "string") {
            header[0] |= 0x80;
          }
          controller.enqueue(header);
          controller.enqueue(encodedPacket);
        });
      }
    });
  }
  var TEXT_DECODER;
  function totalLength(chunks) {
    return chunks.reduce(function (acc, chunk) {
      return acc + chunk.length;
    }, 0);
  }
  function concatChunks(chunks, size) {
    if (chunks[0].length === size) {
      return chunks.shift();
    }
    var buffer = new Uint8Array(size);
    var j = 0;
    for (var i = 0; i < size; i++) {
      buffer[i] = chunks[0][j++];
      if (j === chunks[0].length) {
        chunks.shift();
        j = 0;
      }
    }
    if (chunks.length && j < chunks[0].length) {
      chunks[0] = chunks[0].slice(j);
    }
    return buffer;
  }
  function createPacketDecoderStream(maxPayload, binaryType) {
    if (!TEXT_DECODER) {
      TEXT_DECODER = new TextDecoder();
    }
    var chunks = [];
    var state = 0 /* State.READ_HEADER */;
    var expectedLength = -1;
    var isBinary = false;
    return new TransformStream({
      transform: function transform(chunk, controller) {
        chunks.push(chunk);
        while (true) {
          if (state === 0 /* State.READ_HEADER */) {
            if (totalLength(chunks) < 1) {
              break;
            }
            var header = concatChunks(chunks, 1);
            isBinary = (header[0] & 0x80) === 0x80;
            expectedLength = header[0] & 0x7f;
            if (expectedLength < 126) {
              state = 3 /* State.READ_PAYLOAD */;
            } else if (expectedLength === 126) {
              state = 1 /* State.READ_EXTENDED_LENGTH_16 */;
            } else {
              state = 2 /* State.READ_EXTENDED_LENGTH_64 */;
            }
          } else if (state === 1 /* State.READ_EXTENDED_LENGTH_16 */) {
            if (totalLength(chunks) < 2) {
              break;
            }
            var headerArray = concatChunks(chunks, 2);
            expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
            state = 3 /* State.READ_PAYLOAD */;
          } else if (state === 2 /* State.READ_EXTENDED_LENGTH_64 */) {
            if (totalLength(chunks) < 8) {
              break;
            }
            var _headerArray = concatChunks(chunks, 8);
            var view = new DataView(_headerArray.buffer, _headerArray.byteOffset, _headerArray.length);
            var n = view.getUint32(0);
            if (n > Math.pow(2, 53 - 32) - 1) {
              // the maximum safe integer in JavaScript is 2^53 - 1
              controller.enqueue(ERROR_PACKET);
              break;
            }
            expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
            state = 3 /* State.READ_PAYLOAD */;
          } else {
            if (totalLength(chunks) < expectedLength) {
              break;
            }
            var data = concatChunks(chunks, expectedLength);
            controller.enqueue(decodePacket(isBinary ? data : TEXT_DECODER.decode(data), binaryType));
            state = 0 /* State.READ_HEADER */;
          }
          if (expectedLength === 0 || expectedLength > maxPayload) {
            controller.enqueue(ERROR_PACKET);
            break;
          }
        }
      }
    });
  }
  var protocol$1 = 4;

  /**
   * Initialize a new `Emitter`.
   *
   * @api public
   */

  function Emitter(obj) {
    if (obj) return mixin(obj);
  }

  /**
   * Mixin the emitter properties.
   *
   * @param {Object} obj
   * @return {Object}
   * @api private
   */

  function mixin(obj) {
    for (var key in Emitter.prototype) {
      obj[key] = Emitter.prototype[key];
    }
    return obj;
  }

  /**
   * Listen on the given `event` with `fn`.
   *
   * @param {String} event
   * @param {Function} fn
   * @return {Emitter}
   * @api public
   */

  Emitter.prototype.on = Emitter.prototype.addEventListener = function (event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
  };

  /**
   * Adds an `event` listener that will be invoked a single
   * time then automatically removed.
   *
   * @param {String} event
   * @param {Function} fn
   * @return {Emitter}
   * @api public
   */

  Emitter.prototype.once = function (event, fn) {
    function on() {
      this.off(event, on);
      fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
  };

  /**
   * Remove the given callback for `event` or all
   * registered callbacks.
   *
   * @param {String} event
   * @param {Function} fn
   * @return {Emitter}
   * @api public
   */

  Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function (event, fn) {
    this._callbacks = this._callbacks || {};

    // all
    if (0 == arguments.length) {
      this._callbacks = {};
      return this;
    }

    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;

    // remove all handlers
    if (1 == arguments.length) {
      delete this._callbacks['$' + event];
      return this;
    }

    // remove specific handler
    var cb;
    for (var i = 0; i < callbacks.length; i++) {
      cb = callbacks[i];
      if (cb === fn || cb.fn === fn) {
        callbacks.splice(i, 1);
        break;
      }
    }

    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) {
      delete this._callbacks['$' + event];
    }
    return this;
  };

  /**
   * Emit `event` with the given args.
   *
   * @param {String} event
   * @param {Mixed} ...
   * @return {Emitter}
   */

  Emitter.prototype.emit = function (event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1),
      callbacks = this._callbacks['$' + event];
    for (var i = 1; i < arguments.length; i++) {
      args[i - 1] = arguments[i];
    }
    if (callbacks) {
      callbacks = callbacks.slice(0);
      for (var i = 0, len = callbacks.length; i < len; ++i) {
        callbacks[i].apply(this, args);
      }
    }
    return this;
  };

  // alias used for reserved events (protected method)
  Emitter.prototype.emitReserved = Emitter.prototype.emit;

  /**
   * Return array of callbacks for `event`.
   *
   * @param {String} event
   * @return {Array}
   * @api public
   */

  Emitter.prototype.listeners = function (event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
  };

  /**
   * Check if this emitter has `event` handlers.
   *
   * @param {String} event
   * @return {Boolean}
   * @api public
   */

  Emitter.prototype.hasListeners = function (event) {
    return !!this.listeners(event).length;
  };

  var nextTick = function () {
    var isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) {
      return function (cb) {
        return Promise.resolve().then(cb);
      };
    } else {
      return function (cb, setTimeoutFn) {
        return setTimeoutFn(cb, 0);
      };
    }
  }();
  var globalThisShim = function () {
    if (typeof self !== "undefined") {
      return self;
    } else if (typeof window !== "undefined") {
      return window;
    } else {
      return Function("return this")();
    }
  }();
  var defaultBinaryType = "arraybuffer";
  function createCookieJar() {}

  function pick(obj) {
    for (var _len = arguments.length, attr = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      attr[_key - 1] = arguments[_key];
    }
    return attr.reduce(function (acc, k) {
      if (obj.hasOwnProperty(k)) {
        acc[k] = obj[k];
      }
      return acc;
    }, {});
  }
  // Keep a reference to the real timeout functions so they can be used when overridden
  var NATIVE_SET_TIMEOUT = globalThisShim.setTimeout;
  var NATIVE_CLEAR_TIMEOUT = globalThisShim.clearTimeout;
  function installTimerFunctions(obj, opts) {
    if (opts.useNativeTimers) {
      obj.setTimeoutFn = NATIVE_SET_TIMEOUT.bind(globalThisShim);
      obj.clearTimeoutFn = NATIVE_CLEAR_TIMEOUT.bind(globalThisShim);
    } else {
      obj.setTimeoutFn = globalThisShim.setTimeout.bind(globalThisShim);
      obj.clearTimeoutFn = globalThisShim.clearTimeout.bind(globalThisShim);
    }
  }
  // base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
  var BASE64_OVERHEAD = 1.33;
  // we could also have used `new Blob([obj]).size`, but it isn't supported in IE9
  function byteLength(obj) {
    if (typeof obj === "string") {
      return utf8Length(obj);
    }
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * BASE64_OVERHEAD);
  }
  function utf8Length(str) {
    var c = 0,
      length = 0;
    for (var i = 0, l = str.length; i < l; i++) {
      c = str.charCodeAt(i);
      if (c < 0x80) {
        length += 1;
      } else if (c < 0x800) {
        length += 2;
      } else if (c < 0xd800 || c >= 0xe000) {
        length += 3;
      } else {
        i++;
        length += 4;
      }
    }
    return length;
  }
  /**
   * Generates a random 8-characters string.
   */
  function randomString() {
    return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
  }

  // imported from https://github.com/galkn/querystring
  /**
   * Compiles a querystring
   * Returns string representation of the object
   *
   * @param {Object}
   * @api private
   */
  function encode(obj) {
    var str = '';
    for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
        if (str.length) str += '&';
        str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
      }
    }
    return str;
  }
  /**
   * Parses a simple querystring into an object
   *
   * @param {String} qs
   * @api private
   */
  function decode(qs) {
    var qry = {};
    var pairs = qs.split('&');
    for (var i = 0, l = pairs.length; i < l; i++) {
      var pair = pairs[i].split('=');
      qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
  }

  var TransportError = /*#__PURE__*/function (_Error) {
    function TransportError(reason, description, context) {
      var _this;
      _this = _Error.call(this, reason) || this;
      _this.description = description;
      _this.context = context;
      _this.type = "TransportError";
      return _this;
    }
    _inheritsLoose(TransportError, _Error);
    return TransportError;
  }( /*#__PURE__*/_wrapNativeSuper(Error));
  var Transport = /*#__PURE__*/function (_Emitter) {
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */
    function Transport(opts) {
      var _this2;
      _this2 = _Emitter.call(this) || this;
      _this2.writable = false;
      installTimerFunctions(_this2, opts);
      _this2.opts = opts;
      _this2.query = opts.query;
      _this2.socket = opts.socket;
      _this2.supportsBinary = !opts.forceBase64;
      return _this2;
    }
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */
    _inheritsLoose(Transport, _Emitter);
    var _proto = Transport.prototype;
    _proto.onError = function onError(reason, description, context) {
      _Emitter.prototype.emitReserved.call(this, "error", new TransportError(reason, description, context));
      return this;
    }
    /**
     * Opens the transport.
     */;
    _proto.open = function open() {
      this.readyState = "opening";
      this.doOpen();
      return this;
    }
    /**
     * Closes the transport.
     */;
    _proto.close = function close() {
      if (this.readyState === "opening" || this.readyState === "open") {
        this.doClose();
        this.onClose();
      }
      return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */;
    _proto.send = function send(packets) {
      if (this.readyState === "open") {
        this.write(packets);
      }
    }
    /**
     * Called upon open
     *
     * @protected
     */;
    _proto.onOpen = function onOpen() {
      this.readyState = "open";
      this.writable = true;
      _Emitter.prototype.emitReserved.call(this, "open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */;
    _proto.onData = function onData(data) {
      var packet = decodePacket(data, this.socket.binaryType);
      this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */;
    _proto.onPacket = function onPacket(packet) {
      _Emitter.prototype.emitReserved.call(this, "packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */;
    _proto.onClose = function onClose(details) {
      this.readyState = "closed";
      _Emitter.prototype.emitReserved.call(this, "close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */;
    _proto.pause = function pause(onPause) {};
    _proto.createUri = function createUri(schema) {
      var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    };
    _proto._hostname = function _hostname() {
      var hostname = this.opts.hostname;
      return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    };
    _proto._port = function _port() {
      if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) {
        return ":" + this.opts.port;
      } else {
        return "";
      }
    };
    _proto._query = function _query(query) {
      var encodedQuery = encode(query);
      return encodedQuery.length ? "?" + encodedQuery : "";
    };
    return Transport;
  }(Emitter);

  var Polling = /*#__PURE__*/function (_Transport) {
    function Polling() {
      var _this;
      _this = _Transport.apply(this, arguments) || this;
      _this._polling = false;
      return _this;
    }
    _inheritsLoose(Polling, _Transport);
    var _proto = Polling.prototype;
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */
    _proto.doOpen = function doOpen() {
      this._poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */;
    _proto.pause = function pause(onPause) {
      var _this2 = this;
      this.readyState = "pausing";
      var pause = function pause() {
        _this2.readyState = "paused";
        onPause();
      };
      if (this._polling || !this.writable) {
        var total = 0;
        if (this._polling) {
          total++;
          this.once("pollComplete", function () {
            --total || pause();
          });
        }
        if (!this.writable) {
          total++;
          this.once("drain", function () {
            --total || pause();
          });
        }
      } else {
        pause();
      }
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */;
    _proto._poll = function _poll() {
      this._polling = true;
      this.doPoll();
      this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */;
    _proto.onData = function onData(data) {
      var _this3 = this;
      var callback = function callback(packet) {
        // if its the first message we consider the transport open
        if ("opening" === _this3.readyState && packet.type === "open") {
          _this3.onOpen();
        }
        // if its a close packet, we close the ongoing requests
        if ("close" === packet.type) {
          _this3.onClose({
            description: "transport closed by the server"
          });
          return false;
        }
        // otherwise bypass onData and handle the message
        _this3.onPacket(packet);
      };
      // decode payload
      decodePayload(data, this.socket.binaryType).forEach(callback);
      // if an event did not trigger closing
      if ("closed" !== this.readyState) {
        // if we got data we're not polling
        this._polling = false;
        this.emitReserved("pollComplete");
        if ("open" === this.readyState) {
          this._poll();
        }
      }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */;
    _proto.doClose = function doClose() {
      var _this4 = this;
      var close = function close() {
        _this4.write([{
          type: "close"
        }]);
      };
      if ("open" === this.readyState) {
        close();
      } else {
        // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
      }
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */;
    _proto.write = function write(packets) {
      var _this5 = this;
      this.writable = false;
      encodePayload(packets, function (data) {
        _this5.doWrite(data, function () {
          _this5.writable = true;
          _this5.emitReserved("drain");
        });
      });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */;
    _proto.uri = function uri() {
      var schema = this.opts.secure ? "https" : "http";
      var query = this.query || {};
      // cache busting is forced
      if (false !== this.opts.timestampRequests) {
        query[this.opts.timestampParam] = randomString();
      }
      if (!this.supportsBinary && !query.sid) {
        query.b64 = 1;
      }
      return this.createUri(schema, query);
    };
    return _createClass(Polling, [{
      key: "name",
      get: function get() {
        return "polling";
      }
    }]);
  }(Transport);

  // imported from https://github.com/component/has-cors
  var value = false;
  try {
    value = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
  } catch (err) {
    // if XMLHttp support is disabled in IE then it will throw
    // when trying to create
  }
  var hasCORS = value;

  function empty() {}
  var BaseXHR = /*#__PURE__*/function (_Polling) {
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */
    function BaseXHR(opts) {
      var _this;
      _this = _Polling.call(this, opts) || this;
      if (typeof location !== "undefined") {
        var isSSL = "https:" === location.protocol;
        var port = location.port;
        // some user agents have empty `location.port`
        if (!port) {
          port = isSSL ? "443" : "80";
        }
        _this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
      }
      return _this;
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */
    _inheritsLoose(BaseXHR, _Polling);
    var _proto = BaseXHR.prototype;
    _proto.doWrite = function doWrite(data, fn) {
      var _this2 = this;
      var req = this.request({
        method: "POST",
        data: data
      });
      req.on("success", fn);
      req.on("error", function (xhrStatus, context) {
        _this2.onError("xhr post error", xhrStatus, context);
      });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */;
    _proto.doPoll = function doPoll() {
      var _this3 = this;
      var req = this.request();
      req.on("data", this.onData.bind(this));
      req.on("error", function (xhrStatus, context) {
        _this3.onError("xhr poll error", xhrStatus, context);
      });
      this.pollXhr = req;
    };
    return BaseXHR;
  }(Polling);
  var Request = /*#__PURE__*/function (_Emitter) {
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */
    function Request(createRequest, uri, opts) {
      var _this4;
      _this4 = _Emitter.call(this) || this;
      _this4.createRequest = createRequest;
      installTimerFunctions(_this4, opts);
      _this4._opts = opts;
      _this4._method = opts.method || "GET";
      _this4._uri = uri;
      _this4._data = undefined !== opts.data ? opts.data : null;
      _this4._create();
      return _this4;
    }
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */
    _inheritsLoose(Request, _Emitter);
    var _proto2 = Request.prototype;
    _proto2._create = function _create() {
      var _this5 = this;
      var _a;
      var opts = pick(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
      opts.xdomain = !!this._opts.xd;
      var xhr = this._xhr = this.createRequest(opts);
      try {
        xhr.open(this._method, this._uri, true);
        try {
          if (this._opts.extraHeaders) {
            // @ts-ignore
            xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
            for (var i in this._opts.extraHeaders) {
              if (this._opts.extraHeaders.hasOwnProperty(i)) {
                xhr.setRequestHeader(i, this._opts.extraHeaders[i]);
              }
            }
          }
        } catch (e) {}
        if ("POST" === this._method) {
          try {
            xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
          } catch (e) {}
        }
        try {
          xhr.setRequestHeader("Accept", "*/*");
        } catch (e) {}
        (_a = this._opts.cookieJar) === null || _a === void 0 ? void 0 : _a.addCookies(xhr);
        // ie6 check
        if ("withCredentials" in xhr) {
          xhr.withCredentials = this._opts.withCredentials;
        }
        if (this._opts.requestTimeout) {
          xhr.timeout = this._opts.requestTimeout;
        }
        xhr.onreadystatechange = function () {
          var _a;
          if (xhr.readyState === 3) {
            (_a = _this5._opts.cookieJar) === null || _a === void 0 ? void 0 : _a.parseCookies(
            // @ts-ignore
            xhr.getResponseHeader("set-cookie"));
          }
          if (4 !== xhr.readyState) return;
          if (200 === xhr.status || 1223 === xhr.status) {
            _this5._onLoad();
          } else {
            // make sure the `error` event handler that's user-set
            // does not throw in the same tick and gets caught here
            _this5.setTimeoutFn(function () {
              _this5._onError(typeof xhr.status === "number" ? xhr.status : 0);
            }, 0);
          }
        };
        xhr.send(this._data);
      } catch (e) {
        // Need to defer since .create() is called directly from the constructor
        // and thus the 'error' event can only be only bound *after* this exception
        // occurs.  Therefore, also, we cannot throw here at all.
        this.setTimeoutFn(function () {
          _this5._onError(e);
        }, 0);
        return;
      }
      if (typeof document !== "undefined") {
        this._index = Request.requestsCount++;
        Request.requests[this._index] = this;
      }
    }
    /**
     * Called upon error.
     *
     * @private
     */;
    _proto2._onError = function _onError(err) {
      this.emitReserved("error", err, this._xhr);
      this._cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */;
    _proto2._cleanup = function _cleanup(fromError) {
      if ("undefined" === typeof this._xhr || null === this._xhr) {
        return;
      }
      this._xhr.onreadystatechange = empty;
      if (fromError) {
        try {
          this._xhr.abort();
        } catch (e) {}
      }
      if (typeof document !== "undefined") {
        delete Request.requests[this._index];
      }
      this._xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */;
    _proto2._onLoad = function _onLoad() {
      var data = this._xhr.responseText;
      if (data !== null) {
        this.emitReserved("data", data);
        this.emitReserved("success");
        this._cleanup();
      }
    }
    /**
     * Aborts the request.
     *
     * @package
     */;
    _proto2.abort = function abort() {
      this._cleanup();
    };
    return Request;
  }(Emitter);
  Request.requestsCount = 0;
  Request.requests = {};
  /**
   * Aborts pending requests when unloading the window. This is needed to prevent
   * memory leaks (e.g. when using IE) and to ensure that no spurious error is
   * emitted.
   */
  if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") {
      // @ts-ignore
      attachEvent("onunload", unloadHandler);
    } else if (typeof addEventListener === "function") {
      var terminationEvent = "onpagehide" in globalThisShim ? "pagehide" : "unload";
      addEventListener(terminationEvent, unloadHandler, false);
    }
  }
  function unloadHandler() {
    for (var i in Request.requests) {
      if (Request.requests.hasOwnProperty(i)) {
        Request.requests[i].abort();
      }
    }
  }
  var hasXHR2 = function () {
    var xhr = newRequest({
      xdomain: false
    });
    return xhr && xhr.responseType !== null;
  }();
  /**
   * HTTP long-polling based on the built-in `XMLHttpRequest` object.
   *
   * Usage: browser
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest
   */
  var XHR = /*#__PURE__*/function (_BaseXHR) {
    function XHR(opts) {
      var _this6;
      _this6 = _BaseXHR.call(this, opts) || this;
      var forceBase64 = opts && opts.forceBase64;
      _this6.supportsBinary = hasXHR2 && !forceBase64;
      return _this6;
    }
    _inheritsLoose(XHR, _BaseXHR);
    var _proto3 = XHR.prototype;
    _proto3.request = function request() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      _extends(opts, {
        xd: this.xd
      }, this.opts);
      return new Request(newRequest, this.uri(), opts);
    };
    return XHR;
  }(BaseXHR);
  function newRequest(opts) {
    var xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
      if ("undefined" !== typeof XMLHttpRequest && (!xdomain || hasCORS)) {
        return new XMLHttpRequest();
      }
    } catch (e) {}
    if (!xdomain) {
      try {
        return new globalThisShim[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
      } catch (e) {}
    }
  }

  // detect ReactNative environment
  var isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
  var BaseWS = /*#__PURE__*/function (_Transport) {
    function BaseWS() {
      return _Transport.apply(this, arguments) || this;
    }
    _inheritsLoose(BaseWS, _Transport);
    var _proto = BaseWS.prototype;
    _proto.doOpen = function doOpen() {
      var uri = this.uri();
      var protocols = this.opts.protocols;
      // React Native only supports the 'headers' option, and will print a warning if anything else is passed
      var opts = isReactNative ? {} : pick(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
      if (this.opts.extraHeaders) {
        opts.headers = this.opts.extraHeaders;
      }
      try {
        this.ws = this.createSocket(uri, protocols, opts);
      } catch (err) {
        return this.emitReserved("error", err);
      }
      this.ws.binaryType = this.socket.binaryType;
      this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */;
    _proto.addEventListeners = function addEventListeners() {
      var _this = this;
      this.ws.onopen = function () {
        if (_this.opts.autoUnref) {
          _this.ws._socket.unref();
        }
        _this.onOpen();
      };
      this.ws.onclose = function (closeEvent) {
        return _this.onClose({
          description: "websocket connection closed",
          context: closeEvent
        });
      };
      this.ws.onmessage = function (ev) {
        return _this.onData(ev.data);
      };
      this.ws.onerror = function (e) {
        return _this.onError("websocket error", e);
      };
    };
    _proto.write = function write(packets) {
      var _this2 = this;
      this.writable = false;
      // encodePacket efficient as it uses WS framing
      // no need for encodePayload
      var _loop = function _loop() {
        var packet = packets[i];
        var lastPacket = i === packets.length - 1;
        encodePacket(packet, _this2.supportsBinary, function (data) {
          // Sometimes the websocket has already been closed but the browser didn't
          // have a chance of informing us about it yet, in that case send will
          // throw an error
          try {
            _this2.doWrite(packet, data);
          } catch (e) {}
          if (lastPacket) {
            // fake drain
            // defer to next tick to allow Socket to clear writeBuffer
            nextTick(function () {
              _this2.writable = true;
              _this2.emitReserved("drain");
            }, _this2.setTimeoutFn);
          }
        });
      };
      for (var i = 0; i < packets.length; i++) {
        _loop();
      }
    };
    _proto.doClose = function doClose() {
      if (typeof this.ws !== "undefined") {
        this.ws.onerror = function () {};
        this.ws.close();
        this.ws = null;
      }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */;
    _proto.uri = function uri() {
      var schema = this.opts.secure ? "wss" : "ws";
      var query = this.query || {};
      // append timestamp to URI
      if (this.opts.timestampRequests) {
        query[this.opts.timestampParam] = randomString();
      }
      // communicate binary support capabilities
      if (!this.supportsBinary) {
        query.b64 = 1;
      }
      return this.createUri(schema, query);
    };
    return _createClass(BaseWS, [{
      key: "name",
      get: function get() {
        return "websocket";
      }
    }]);
  }(Transport);
  var WebSocketCtor = globalThisShim.WebSocket || globalThisShim.MozWebSocket;
  /**
   * WebSocket transport based on the built-in `WebSocket` object.
   *
   * Usage: browser, Node.js (since v21), Deno, Bun
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket
   * @see https://caniuse.com/mdn-api_websocket
   * @see https://nodejs.org/api/globals.html#websocket
   */
  var WS = /*#__PURE__*/function (_BaseWS) {
    function WS() {
      return _BaseWS.apply(this, arguments) || this;
    }
    _inheritsLoose(WS, _BaseWS);
    var _proto2 = WS.prototype;
    _proto2.createSocket = function createSocket(uri, protocols, opts) {
      return !isReactNative ? protocols ? new WebSocketCtor(uri, protocols) : new WebSocketCtor(uri) : new WebSocketCtor(uri, protocols, opts);
    };
    _proto2.doWrite = function doWrite(_packet, data) {
      this.ws.send(data);
    };
    return WS;
  }(BaseWS);

  /**
   * WebTransport transport based on the built-in `WebTransport` object.
   *
   * Usage: browser, Node.js (with the `@fails-components/webtransport` package)
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/WebTransport
   * @see https://caniuse.com/webtransport
   */
  var WT = /*#__PURE__*/function (_Transport) {
    function WT() {
      return _Transport.apply(this, arguments) || this;
    }
    _inheritsLoose(WT, _Transport);
    var _proto = WT.prototype;
    _proto.doOpen = function doOpen() {
      var _this = this;
      try {
        // @ts-ignore
        this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
      } catch (err) {
        return this.emitReserved("error", err);
      }
      this._transport.closed.then(function () {
        _this.onClose();
      })["catch"](function (err) {
        _this.onError("webtransport error", err);
      });
      // note: we could have used async/await, but that would require some additional polyfills
      this._transport.ready.then(function () {
        _this._transport.createBidirectionalStream().then(function (stream) {
          var decoderStream = createPacketDecoderStream(Number.MAX_SAFE_INTEGER, _this.socket.binaryType);
          var reader = stream.readable.pipeThrough(decoderStream).getReader();
          var encoderStream = createPacketEncoderStream();
          encoderStream.readable.pipeTo(stream.writable);
          _this._writer = encoderStream.writable.getWriter();
          var read = function read() {
            reader.read().then(function (_ref) {
              var done = _ref.done,
                value = _ref.value;
              if (done) {
                return;
              }
              _this.onPacket(value);
              read();
            })["catch"](function (err) {});
          };
          read();
          var packet = {
            type: "open"
          };
          if (_this.query.sid) {
            packet.data = "{\"sid\":\"".concat(_this.query.sid, "\"}");
          }
          _this._writer.write(packet).then(function () {
            return _this.onOpen();
          });
        });
      });
    };
    _proto.write = function write(packets) {
      var _this2 = this;
      this.writable = false;
      var _loop = function _loop() {
        var packet = packets[i];
        var lastPacket = i === packets.length - 1;
        _this2._writer.write(packet).then(function () {
          if (lastPacket) {
            nextTick(function () {
              _this2.writable = true;
              _this2.emitReserved("drain");
            }, _this2.setTimeoutFn);
          }
        });
      };
      for (var i = 0; i < packets.length; i++) {
        _loop();
      }
    };
    _proto.doClose = function doClose() {
      var _a;
      (_a = this._transport) === null || _a === void 0 ? void 0 : _a.close();
    };
    return _createClass(WT, [{
      key: "name",
      get: function get() {
        return "webtransport";
      }
    }]);
  }(Transport);

  var transports = {
    websocket: WS,
    webtransport: WT,
    polling: XHR
  };

  // imported from https://github.com/galkn/parseuri
  /**
   * Parses a URI
   *
   * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
   *
   * See:
   * - https://developer.mozilla.org/en-US/docs/Web/API/URL
   * - https://caniuse.com/url
   * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
   *
   * History of the parse() method:
   * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
   * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
   * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
   *
   * @author Steven Levithan <stevenlevithan.com> (MIT license)
   * @api private
   */
  var re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
  var parts = ['source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'];
  function parse(str) {
    if (str.length > 8000) {
      throw "URI too long";
    }
    var src = str,
      b = str.indexOf('['),
      e = str.indexOf(']');
    if (b != -1 && e != -1) {
      str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    }
    var m = re.exec(str || ''),
      uri = {},
      i = 14;
    while (i--) {
      uri[parts[i]] = m[i] || '';
    }
    if (b != -1 && e != -1) {
      uri.source = src;
      uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
      uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
      uri.ipv6uri = true;
    }
    uri.pathNames = pathNames(uri, uri['path']);
    uri.queryKey = queryKey(uri, uri['query']);
    return uri;
  }
  function pathNames(obj, path) {
    var regx = /\/{2,9}/g,
      names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == '/' || path.length === 0) {
      names.splice(0, 1);
    }
    if (path.slice(-1) == '/') {
      names.splice(names.length - 1, 1);
    }
    return names;
  }
  function queryKey(uri, query) {
    var data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function ($0, $1, $2) {
      if ($1) {
        data[$1] = $2;
      }
    });
    return data;
  }

  var withEventListeners = typeof addEventListener === "function" && typeof removeEventListener === "function";
  var OFFLINE_EVENT_LISTENERS = [];
  if (withEventListeners) {
    // within a ServiceWorker, any event handler for the 'offline' event must be added on the initial evaluation of the
    // script, so we create one single event listener here which will forward the event to the socket instances
    addEventListener("offline", function () {
      OFFLINE_EVENT_LISTENERS.forEach(function (listener) {
        return listener();
      });
    }, false);
  }
  /**
   * This class provides a WebSocket-like interface to connect to an Engine.IO server. The connection will be established
   * with one of the available low-level transports, like HTTP long-polling, WebSocket or WebTransport.
   *
   * This class comes without upgrade mechanism, which means that it will keep the first low-level transport that
   * successfully establishes the connection.
   *
   * In order to allow tree-shaking, there are no transports included, that's why the `transports` option is mandatory.
   *
   * @example
   * import { SocketWithoutUpgrade, WebSocket } from "engine.io-client";
   *
   * const socket = new SocketWithoutUpgrade({
   *   transports: [WebSocket]
   * });
   *
   * socket.on("open", () => {
   *   socket.send("hello");
   * });
   *
   * @see SocketWithUpgrade
   * @see Socket
   */
  var SocketWithoutUpgrade = /*#__PURE__*/function (_Emitter) {
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */
    function SocketWithoutUpgrade(uri, opts) {
      var _this;
      _this = _Emitter.call(this) || this;
      _this.binaryType = defaultBinaryType;
      _this.writeBuffer = [];
      _this._prevBufferLen = 0;
      _this._pingInterval = -1;
      _this._pingTimeout = -1;
      _this._maxPayload = -1;
      /**
       * The expiration timestamp of the {@link _pingTimeoutTimer} object is tracked, in case the timer is throttled and the
       * callback is not fired on time. This can happen for example when a laptop is suspended or when a phone is locked.
       */
      _this._pingTimeoutTime = Infinity;
      if (uri && "object" === _typeof(uri)) {
        opts = uri;
        uri = null;
      }
      if (uri) {
        var parsedUri = parse(uri);
        opts.hostname = parsedUri.host;
        opts.secure = parsedUri.protocol === "https" || parsedUri.protocol === "wss";
        opts.port = parsedUri.port;
        if (parsedUri.query) opts.query = parsedUri.query;
      } else if (opts.host) {
        opts.hostname = parse(opts.host).host;
      }
      installTimerFunctions(_this, opts);
      _this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
      if (opts.hostname && !opts.port) {
        // if no port is specified manually, use the protocol default
        opts.port = _this.secure ? "443" : "80";
      }
      _this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
      _this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : _this.secure ? "443" : "80");
      _this.transports = [];
      _this._transportsByName = {};
      opts.transports.forEach(function (t) {
        var transportName = t.prototype.name;
        _this.transports.push(transportName);
        _this._transportsByName[transportName] = t;
      });
      _this.opts = _extends({
        path: "/engine.io",
        agent: false,
        withCredentials: false,
        upgrade: true,
        timestampParam: "t",
        rememberUpgrade: false,
        addTrailingSlash: true,
        rejectUnauthorized: true,
        perMessageDeflate: {
          threshold: 1024
        },
        transportOptions: {},
        closeOnBeforeunload: false
      }, opts);
      _this.opts.path = _this.opts.path.replace(/\/$/, "") + (_this.opts.addTrailingSlash ? "/" : "");
      if (typeof _this.opts.query === "string") {
        _this.opts.query = decode(_this.opts.query);
      }
      if (withEventListeners) {
        if (_this.opts.closeOnBeforeunload) {
          // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
          // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
          // closed/reloaded)
          _this._beforeunloadEventListener = function () {
            if (_this.transport) {
              // silently close the transport
              _this.transport.removeAllListeners();
              _this.transport.close();
            }
          };
          addEventListener("beforeunload", _this._beforeunloadEventListener, false);
        }
        if (_this.hostname !== "localhost") {
          _this._offlineEventListener = function () {
            _this._onClose("transport close", {
              description: "network connection lost"
            });
          };
          OFFLINE_EVENT_LISTENERS.push(_this._offlineEventListener);
        }
      }
      if (_this.opts.withCredentials) {
        _this._cookieJar = createCookieJar();
      }
      _this._open();
      return _this;
    }
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */
    _inheritsLoose(SocketWithoutUpgrade, _Emitter);
    var _proto = SocketWithoutUpgrade.prototype;
    _proto.createTransport = function createTransport(name) {
      var query = _extends({}, this.opts.query);
      // append engine.io protocol identifier
      query.EIO = protocol$1;
      // transport name
      query.transport = name;
      // session id if we already have one
      if (this.id) query.sid = this.id;
      var opts = _extends({}, this.opts, {
        query: query,
        socket: this,
        hostname: this.hostname,
        secure: this.secure,
        port: this.port
      }, this.opts.transportOptions[name]);
      return new this._transportsByName[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */;
    _proto._open = function _open() {
      var _this2 = this;
      if (this.transports.length === 0) {
        // Emit error on next tick so it can be listened to
        this.setTimeoutFn(function () {
          _this2.emitReserved("error", "No transports available");
        }, 0);
        return;
      }
      var transportName = this.opts.rememberUpgrade && SocketWithoutUpgrade.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
      this.readyState = "opening";
      var transport = this.createTransport(transportName);
      transport.open();
      this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */;
    _proto.setTransport = function setTransport(transport) {
      var _this3 = this;
      if (this.transport) {
        this.transport.removeAllListeners();
      }
      // set up transport
      this.transport = transport;
      // set up transport listeners
      transport.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", function (reason) {
        return _this3._onClose("transport close", reason);
      });
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */;
    _proto.onOpen = function onOpen() {
      this.readyState = "open";
      SocketWithoutUpgrade.priorWebsocketSuccess = "websocket" === this.transport.name;
      this.emitReserved("open");
      this.flush();
    }
    /**
     * Handles a packet.
     *
     * @private
     */;
    _proto._onPacket = function _onPacket(packet) {
      if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
        this.emitReserved("packet", packet);
        // Socket is live - any packet counts
        this.emitReserved("heartbeat");
        switch (packet.type) {
          case "open":
            this.onHandshake(JSON.parse(packet.data));
            break;
          case "ping":
            this._sendPacket("pong");
            this.emitReserved("ping");
            this.emitReserved("pong");
            this._resetPingTimeout();
            break;
          case "error":
            var err = new Error("server error");
            // @ts-ignore
            err.code = packet.data;
            this._onError(err);
            break;
          case "message":
            this.emitReserved("data", packet.data);
            this.emitReserved("message", packet.data);
            break;
        }
      }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */;
    _proto.onHandshake = function onHandshake(data) {
      this.emitReserved("handshake", data);
      this.id = data.sid;
      this.transport.query.sid = data.sid;
      this._pingInterval = data.pingInterval;
      this._pingTimeout = data.pingTimeout;
      this._maxPayload = data.maxPayload;
      this.onOpen();
      // In case open handler closes socket
      if ("closed" === this.readyState) return;
      this._resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */;
    _proto._resetPingTimeout = function _resetPingTimeout() {
      var _this4 = this;
      this.clearTimeoutFn(this._pingTimeoutTimer);
      var delay = this._pingInterval + this._pingTimeout;
      this._pingTimeoutTime = Date.now() + delay;
      this._pingTimeoutTimer = this.setTimeoutFn(function () {
        _this4._onClose("ping timeout");
      }, delay);
      if (this.opts.autoUnref) {
        this._pingTimeoutTimer.unref();
      }
    }
    /**
     * Called on `drain` event
     *
     * @private
     */;
    _proto._onDrain = function _onDrain() {
      this.writeBuffer.splice(0, this._prevBufferLen);
      // setting prevBufferLen = 0 is very important
      // for example, when upgrading, upgrade packet is sent over,
      // and a nonzero prevBufferLen could cause problems on `drain`
      this._prevBufferLen = 0;
      if (0 === this.writeBuffer.length) {
        this.emitReserved("drain");
      } else {
        this.flush();
      }
    }
    /**
     * Flush write buffers.
     *
     * @private
     */;
    _proto.flush = function flush() {
      if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
        var packets = this._getWritablePackets();
        this.transport.send(packets);
        // keep track of current length of writeBuffer
        // splice writeBuffer and callbackBuffer on `drain`
        this._prevBufferLen = packets.length;
        this.emitReserved("flush");
      }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */;
    _proto._getWritablePackets = function _getWritablePackets() {
      var shouldCheckPayloadSize = this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
      if (!shouldCheckPayloadSize) {
        return this.writeBuffer;
      }
      var payloadSize = 1; // first packet type
      for (var i = 0; i < this.writeBuffer.length; i++) {
        var data = this.writeBuffer[i].data;
        if (data) {
          payloadSize += byteLength(data);
        }
        if (i > 0 && payloadSize > this._maxPayload) {
          return this.writeBuffer.slice(0, i);
        }
        payloadSize += 2; // separator + packet type
      }
      return this.writeBuffer;
    }
    /**
     * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
     *
     * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
     * `write()` method then the message would not be buffered by the Socket.IO client.
     *
     * @return {boolean}
     * @private
     */
    /* private */;
    _proto._hasPingExpired = function _hasPingExpired() {
      var _this5 = this;
      if (!this._pingTimeoutTime) return true;
      var hasExpired = Date.now() > this._pingTimeoutTime;
      if (hasExpired) {
        this._pingTimeoutTime = 0;
        nextTick(function () {
          _this5._onClose("ping timeout");
        }, this.setTimeoutFn);
      }
      return hasExpired;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */;
    _proto.write = function write(msg, options, fn) {
      this._sendPacket("message", msg, options, fn);
      return this;
    }
    /**
     * Sends a message. Alias of {@link Socket#write}.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */;
    _proto.send = function send(msg, options, fn) {
      this._sendPacket("message", msg, options, fn);
      return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */;
    _proto._sendPacket = function _sendPacket(type, data, options, fn) {
      if ("function" === typeof data) {
        fn = data;
        data = undefined;
      }
      if ("function" === typeof options) {
        fn = options;
        options = null;
      }
      if ("closing" === this.readyState || "closed" === this.readyState) {
        return;
      }
      options = options || {};
      options.compress = false !== options.compress;
      var packet = {
        type: type,
        data: data,
        options: options
      };
      this.emitReserved("packetCreate", packet);
      this.writeBuffer.push(packet);
      if (fn) this.once("flush", fn);
      this.flush();
    }
    /**
     * Closes the connection.
     */;
    _proto.close = function close() {
      var _this6 = this;
      var close = function close() {
        _this6._onClose("forced close");
        _this6.transport.close();
      };
      var cleanupAndClose = function cleanupAndClose() {
        _this6.off("upgrade", cleanupAndClose);
        _this6.off("upgradeError", cleanupAndClose);
        close();
      };
      var waitForUpgrade = function waitForUpgrade() {
        // wait for upgrade to finish since we can't send packets while pausing a transport
        _this6.once("upgrade", cleanupAndClose);
        _this6.once("upgradeError", cleanupAndClose);
      };
      if ("opening" === this.readyState || "open" === this.readyState) {
        this.readyState = "closing";
        if (this.writeBuffer.length) {
          this.once("drain", function () {
            if (_this6.upgrading) {
              waitForUpgrade();
            } else {
              close();
            }
          });
        } else if (this.upgrading) {
          waitForUpgrade();
        } else {
          close();
        }
      }
      return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */;
    _proto._onError = function _onError(err) {
      SocketWithoutUpgrade.priorWebsocketSuccess = false;
      if (this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening") {
        this.transports.shift();
        return this._open();
      }
      this.emitReserved("error", err);
      this._onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */;
    _proto._onClose = function _onClose(reason, description) {
      if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
        // clear timers
        this.clearTimeoutFn(this._pingTimeoutTimer);
        // stop event from firing again for transport
        this.transport.removeAllListeners("close");
        // ensure transport won't stay open
        this.transport.close();
        // ignore further transport communication
        this.transport.removeAllListeners();
        if (withEventListeners) {
          if (this._beforeunloadEventListener) {
            removeEventListener("beforeunload", this._beforeunloadEventListener, false);
          }
          if (this._offlineEventListener) {
            var i = OFFLINE_EVENT_LISTENERS.indexOf(this._offlineEventListener);
            if (i !== -1) {
              OFFLINE_EVENT_LISTENERS.splice(i, 1);
            }
          }
        }
        // set ready state
        this.readyState = "closed";
        // clear session id
        this.id = null;
        // emit close event
        this.emitReserved("close", reason, description);
        // clean buffers after, so users can still
        // grab the buffers on `close` event
        this.writeBuffer = [];
        this._prevBufferLen = 0;
      }
    };
    return SocketWithoutUpgrade;
  }(Emitter);
  SocketWithoutUpgrade.protocol = protocol$1;
  /**
   * This class provides a WebSocket-like interface to connect to an Engine.IO server. The connection will be established
   * with one of the available low-level transports, like HTTP long-polling, WebSocket or WebTransport.
   *
   * This class comes with an upgrade mechanism, which means that once the connection is established with the first
   * low-level transport, it will try to upgrade to a better transport.
   *
   * In order to allow tree-shaking, there are no transports included, that's why the `transports` option is mandatory.
   *
   * @example
   * import { SocketWithUpgrade, WebSocket } from "engine.io-client";
   *
   * const socket = new SocketWithUpgrade({
   *   transports: [WebSocket]
   * });
   *
   * socket.on("open", () => {
   *   socket.send("hello");
   * });
   *
   * @see SocketWithoutUpgrade
   * @see Socket
   */
  var SocketWithUpgrade = /*#__PURE__*/function (_SocketWithoutUpgrade) {
    function SocketWithUpgrade() {
      var _this7;
      _this7 = _SocketWithoutUpgrade.apply(this, arguments) || this;
      _this7._upgrades = [];
      return _this7;
    }
    _inheritsLoose(SocketWithUpgrade, _SocketWithoutUpgrade);
    var _proto2 = SocketWithUpgrade.prototype;
    _proto2.onOpen = function onOpen() {
      _SocketWithoutUpgrade.prototype.onOpen.call(this);
      if ("open" === this.readyState && this.opts.upgrade) {
        for (var i = 0; i < this._upgrades.length; i++) {
          this._probe(this._upgrades[i]);
        }
      }
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */;
    _proto2._probe = function _probe(name) {
      var _this8 = this;
      var transport = this.createTransport(name);
      var failed = false;
      SocketWithoutUpgrade.priorWebsocketSuccess = false;
      var onTransportOpen = function onTransportOpen() {
        if (failed) return;
        transport.send([{
          type: "ping",
          data: "probe"
        }]);
        transport.once("packet", function (msg) {
          if (failed) return;
          if ("pong" === msg.type && "probe" === msg.data) {
            _this8.upgrading = true;
            _this8.emitReserved("upgrading", transport);
            if (!transport) return;
            SocketWithoutUpgrade.priorWebsocketSuccess = "websocket" === transport.name;
            _this8.transport.pause(function () {
              if (failed) return;
              if ("closed" === _this8.readyState) return;
              cleanup();
              _this8.setTransport(transport);
              transport.send([{
                type: "upgrade"
              }]);
              _this8.emitReserved("upgrade", transport);
              transport = null;
              _this8.upgrading = false;
              _this8.flush();
            });
          } else {
            var err = new Error("probe error");
            // @ts-ignore
            err.transport = transport.name;
            _this8.emitReserved("upgradeError", err);
          }
        });
      };
      function freezeTransport() {
        if (failed) return;
        // Any callback called by transport should be ignored since now
        failed = true;
        cleanup();
        transport.close();
        transport = null;
      }
      // Handle any error that happens while probing
      var onerror = function onerror(err) {
        var error = new Error("probe error: " + err);
        // @ts-ignore
        error.transport = transport.name;
        freezeTransport();
        _this8.emitReserved("upgradeError", error);
      };
      function onTransportClose() {
        onerror("transport closed");
      }
      // When the socket is closed while we're probing
      function onclose() {
        onerror("socket closed");
      }
      // When the socket is upgraded while we're probing
      function onupgrade(to) {
        if (transport && to.name !== transport.name) {
          freezeTransport();
        }
      }
      // Remove all listeners on the transport and on self
      var cleanup = function cleanup() {
        transport.removeListener("open", onTransportOpen);
        transport.removeListener("error", onerror);
        transport.removeListener("close", onTransportClose);
        _this8.off("close", onclose);
        _this8.off("upgrading", onupgrade);
      };
      transport.once("open", onTransportOpen);
      transport.once("error", onerror);
      transport.once("close", onTransportClose);
      this.once("close", onclose);
      this.once("upgrading", onupgrade);
      if (this._upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") {
        // favor WebTransport
        this.setTimeoutFn(function () {
          if (!failed) {
            transport.open();
          }
        }, 200);
      } else {
        transport.open();
      }
    };
    _proto2.onHandshake = function onHandshake(data) {
      this._upgrades = this._filterUpgrades(data.upgrades);
      _SocketWithoutUpgrade.prototype.onHandshake.call(this, data);
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */;
    _proto2._filterUpgrades = function _filterUpgrades(upgrades) {
      var filteredUpgrades = [];
      for (var i = 0; i < upgrades.length; i++) {
        if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
      }
      return filteredUpgrades;
    };
    return SocketWithUpgrade;
  }(SocketWithoutUpgrade);
  /**
   * This class provides a WebSocket-like interface to connect to an Engine.IO server. The connection will be established
   * with one of the available low-level transports, like HTTP long-polling, WebSocket or WebTransport.
   *
   * This class comes with an upgrade mechanism, which means that once the connection is established with the first
   * low-level transport, it will try to upgrade to a better transport.
   *
   * @example
   * import { Socket } from "engine.io-client";
   *
   * const socket = new Socket();
   *
   * socket.on("open", () => {
   *   socket.send("hello");
   * });
   *
   * @see SocketWithoutUpgrade
   * @see SocketWithUpgrade
   */
  var Socket$1 = /*#__PURE__*/function (_SocketWithUpgrade) {
    function Socket(uri) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var o = _typeof(uri) === "object" ? uri : opts;
      if (!o.transports || o.transports && typeof o.transports[0] === "string") {
        o.transports = (o.transports || ["polling", "websocket", "webtransport"]).map(function (transportName) {
          return transports[transportName];
        }).filter(function (t) {
          return !!t;
        });
      }
      return _SocketWithUpgrade.call(this, uri, o) || this;
    }
    _inheritsLoose(Socket, _SocketWithUpgrade);
    return Socket;
  }(SocketWithUpgrade);

  Socket$1.protocol;

  function getDefaultExportFromCjs (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  var browser = {exports: {}};

  var ms;
  var hasRequiredMs;
  function requireMs() {
    if (hasRequiredMs) return ms;
    hasRequiredMs = 1;
    var s = 1000;
    var m = s * 60;
    var h = m * 60;
    var d = h * 24;
    var w = d * 7;
    var y = d * 365.25;

    /**
     * Parse or format the given `val`.
     *
     * Options:
     *
     *  - `long` verbose formatting [false]
     *
     * @param {String|Number} val
     * @param {Object} [options]
     * @throws {Error} throw an error if val is not a non-empty string or a number
     * @return {String|Number}
     * @api public
     */

    ms = function ms(val, options) {
      options = options || {};
      var type = _typeof(val);
      if (type === 'string' && val.length > 0) {
        return parse(val);
      } else if (type === 'number' && isFinite(val)) {
        return options["long"] ? fmtLong(val) : fmtShort(val);
      }
      throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
    };

    /**
     * Parse the given `str` and return milliseconds.
     *
     * @param {String} str
     * @return {Number}
     * @api private
     */

    function parse(str) {
      str = String(str);
      if (str.length > 100) {
        return;
      }
      var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
      if (!match) {
        return;
      }
      var n = parseFloat(match[1]);
      var type = (match[2] || 'ms').toLowerCase();
      switch (type) {
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
          return n * y;
        case 'weeks':
        case 'week':
        case 'w':
          return n * w;
        case 'days':
        case 'day':
        case 'd':
          return n * d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
          return n * h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
          return n * m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
          return n * s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
          return n;
        default:
          return undefined;
      }
    }

    /**
     * Short format for `ms`.
     *
     * @param {Number} ms
     * @return {String}
     * @api private
     */

    function fmtShort(ms) {
      var msAbs = Math.abs(ms);
      if (msAbs >= d) {
        return Math.round(ms / d) + 'd';
      }
      if (msAbs >= h) {
        return Math.round(ms / h) + 'h';
      }
      if (msAbs >= m) {
        return Math.round(ms / m) + 'm';
      }
      if (msAbs >= s) {
        return Math.round(ms / s) + 's';
      }
      return ms + 'ms';
    }

    /**
     * Long format for `ms`.
     *
     * @param {Number} ms
     * @return {String}
     * @api private
     */

    function fmtLong(ms) {
      var msAbs = Math.abs(ms);
      if (msAbs >= d) {
        return plural(ms, msAbs, d, 'day');
      }
      if (msAbs >= h) {
        return plural(ms, msAbs, h, 'hour');
      }
      if (msAbs >= m) {
        return plural(ms, msAbs, m, 'minute');
      }
      if (msAbs >= s) {
        return plural(ms, msAbs, s, 'second');
      }
      return ms + ' ms';
    }

    /**
     * Pluralization helper.
     */

    function plural(ms, msAbs, n, name) {
      var isPlural = msAbs >= n * 1.5;
      return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
    }
    return ms;
  }

  /**
   * This is the common logic for both the Node.js and web browser
   * implementations of `debug()`.
   */

  function setup(env) {
    createDebug.debug = createDebug;
    createDebug["default"] = createDebug;
    createDebug.coerce = coerce;
    createDebug.disable = disable;
    createDebug.enable = enable;
    createDebug.enabled = enabled;
    createDebug.humanize = requireMs();
    createDebug.destroy = destroy;
    Object.keys(env).forEach(function (key) {
      createDebug[key] = env[key];
    });

    /**
    * The currently active debug mode names, and names to skip.
    */

    createDebug.names = [];
    createDebug.skips = [];

    /**
    * Map of special "%n" handling functions, for the debug "format" argument.
    *
    * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
    */
    createDebug.formatters = {};

    /**
    * Selects a color for a debug namespace
    * @param {String} namespace The namespace string for the debug instance to be colored
    * @return {Number|String} An ANSI color code for the given namespace
    * @api private
    */
    function selectColor(namespace) {
      var hash = 0;
      for (var i = 0; i < namespace.length; i++) {
        hash = (hash << 5) - hash + namespace.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
      }
      return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
    }
    createDebug.selectColor = selectColor;

    /**
    * Create a debugger with the given `namespace`.
    *
    * @param {String} namespace
    * @return {Function}
    * @api public
    */
    function createDebug(namespace) {
      var prevTime;
      var enableOverride = null;
      var namespacesCache;
      var enabledCache;
      function debug() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        // Disabled?
        if (!debug.enabled) {
          return;
        }
        var self = debug;

        // Set `diff` timestamp
        var curr = Number(new Date());
        var ms = curr - (prevTime || curr);
        self.diff = ms;
        self.prev = prevTime;
        self.curr = curr;
        prevTime = curr;
        args[0] = createDebug.coerce(args[0]);
        if (typeof args[0] !== 'string') {
          // Anything else let's inspect with %O
          args.unshift('%O');
        }

        // Apply any `formatters` transformations
        var index = 0;
        args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
          // If we encounter an escaped % then don't increase the array index
          if (match === '%%') {
            return '%';
          }
          index++;
          var formatter = createDebug.formatters[format];
          if (typeof formatter === 'function') {
            var val = args[index];
            match = formatter.call(self, val);

            // Now we need to remove `args[index]` since it's inlined in the `format`
            args.splice(index, 1);
            index--;
          }
          return match;
        });

        // Apply env-specific formatting (colors, etc.)
        createDebug.formatArgs.call(self, args);
        var logFn = self.log || createDebug.log;
        logFn.apply(self, args);
      }
      debug.namespace = namespace;
      debug.useColors = createDebug.useColors();
      debug.color = createDebug.selectColor(namespace);
      debug.extend = extend;
      debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.

      Object.defineProperty(debug, 'enabled', {
        enumerable: true,
        configurable: false,
        get: function get() {
          if (enableOverride !== null) {
            return enableOverride;
          }
          if (namespacesCache !== createDebug.namespaces) {
            namespacesCache = createDebug.namespaces;
            enabledCache = createDebug.enabled(namespace);
          }
          return enabledCache;
        },
        set: function set(v) {
          enableOverride = v;
        }
      });

      // Env-specific initialization logic for debug instances
      if (typeof createDebug.init === 'function') {
        createDebug.init(debug);
      }
      return debug;
    }
    function extend(namespace, delimiter) {
      var newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
      newDebug.log = this.log;
      return newDebug;
    }

    /**
    * Enables a debug mode by namespaces. This can include modes
    * separated by a colon and wildcards.
    *
    * @param {String} namespaces
    * @api public
    */
    function enable(namespaces) {
      createDebug.save(namespaces);
      createDebug.namespaces = namespaces;
      createDebug.names = [];
      createDebug.skips = [];
      var i;
      var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
      var len = split.length;
      for (i = 0; i < len; i++) {
        if (!split[i]) {
          // ignore empty strings
          continue;
        }
        namespaces = split[i].replace(/\*/g, '.*?');
        if (namespaces[0] === '-') {
          createDebug.skips.push(new RegExp('^' + namespaces.slice(1) + '$'));
        } else {
          createDebug.names.push(new RegExp('^' + namespaces + '$'));
        }
      }
    }

    /**
    * Disable debug output.
    *
    * @return {String} namespaces
    * @api public
    */
    function disable() {
      var namespaces = [].concat(_toConsumableArray(createDebug.names.map(toNamespace)), _toConsumableArray(createDebug.skips.map(toNamespace).map(function (namespace) {
        return '-' + namespace;
      }))).join(',');
      createDebug.enable('');
      return namespaces;
    }

    /**
    * Returns true if the given mode name is enabled, false otherwise.
    *
    * @param {String} name
    * @return {Boolean}
    * @api public
    */
    function enabled(name) {
      if (name[name.length - 1] === '*') {
        return true;
      }
      var i;
      var len;
      for (i = 0, len = createDebug.skips.length; i < len; i++) {
        if (createDebug.skips[i].test(name)) {
          return false;
        }
      }
      for (i = 0, len = createDebug.names.length; i < len; i++) {
        if (createDebug.names[i].test(name)) {
          return true;
        }
      }
      return false;
    }

    /**
    * Convert regexp to namespace
    *
    * @param {RegExp} regxep
    * @return {String} namespace
    * @api private
    */
    function toNamespace(regexp) {
      return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, '*');
    }

    /**
    * Coerce `val`.
    *
    * @param {Mixed} val
    * @return {Mixed}
    * @api private
    */
    function coerce(val) {
      if (val instanceof Error) {
        return val.stack || val.message;
      }
      return val;
    }

    /**
    * XXX DO NOT USE. This is a temporary stub function.
    * XXX It WILL be removed in the next major release.
    */
    function destroy() {
      console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
    }
    createDebug.enable(createDebug.load());
    return createDebug;
  }
  var common = setup;

  /* eslint-env browser */
  browser.exports;
  (function (module, exports) {
    /**
     * This is the web browser implementation of `debug()`.
     */

    exports.formatArgs = formatArgs;
    exports.save = save;
    exports.load = load;
    exports.useColors = useColors;
    exports.storage = localstorage();
    exports.destroy = function () {
      var warned = false;
      return function () {
        if (!warned) {
          warned = true;
          console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
        }
      };
    }();

    /**
     * Colors.
     */

    exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];

    /**
     * Currently only WebKit-based Web Inspectors, Firefox >= v31,
     * and the Firebug extension (any Firefox version) are known
     * to support "%c" CSS customizations.
     *
     * TODO: add a `localStorage` variable to explicitly enable/disable colors
     */

    // eslint-disable-next-line complexity
    function useColors() {
      // NB: In an Electron preload script, document will be defined but not fully
      // initialized. Since we know we're in Chrome, we'll just detect this case
      // explicitly
      if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
        return true;
      }

      // Internet Explorer and Edge do not support colors.
      if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
        return false;
      }

      // Is webkit? http://stackoverflow.com/a/16459606/376773
      // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
      return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance ||
      // Is firebug? http://stackoverflow.com/a/398120/376773
      typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) ||
      // Is firefox >= v31?
      // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
      typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 ||
      // Double check webkit in userAgent just in case we are in a worker
      typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }

    /**
     * Colorize log arguments if enabled.
     *
     * @api public
     */

    function formatArgs(args) {
      args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);
      if (!this.useColors) {
        return;
      }
      var c = 'color: ' + this.color;
      args.splice(1, 0, c, 'color: inherit');

      // The final "%c" is somewhat tricky, because there could be other
      // arguments passed either before or after the %c, so we need to
      // figure out the correct index to insert the CSS into
      var index = 0;
      var lastC = 0;
      args[0].replace(/%[a-zA-Z%]/g, function (match) {
        if (match === '%%') {
          return;
        }
        index++;
        if (match === '%c') {
          // We only are interested in the *last* %c
          // (the user may have provided their own)
          lastC = index;
        }
      });
      args.splice(lastC, 0, c);
    }

    /**
     * Invokes `console.debug()` when available.
     * No-op when `console.debug` is not a "function".
     * If `console.debug` is not available, falls back
     * to `console.log`.
     *
     * @api public
     */
    exports.log = console.debug || console.log || function () {};

    /**
     * Save `namespaces`.
     *
     * @param {String} namespaces
     * @api private
     */
    function save(namespaces) {
      try {
        if (namespaces) {
          exports.storage.setItem('debug', namespaces);
        } else {
          exports.storage.removeItem('debug');
        }
      } catch (error) {
        // Swallow
        // XXX (@Qix-) should we be logging these?
      }
    }

    /**
     * Load `namespaces`.
     *
     * @return {String} returns the previously persisted debug modes
     * @api private
     */
    function load() {
      var r;
      try {
        r = exports.storage.getItem('debug');
      } catch (error) {
        // Swallow
        // XXX (@Qix-) should we be logging these?
      }

      // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
      if (!r && typeof process !== 'undefined' && 'env' in process) {
        r = process.env.DEBUG;
      }
      return r;
    }

    /**
     * Localstorage attempts to return the localstorage.
     *
     * This is necessary because safari throws
     * when a user disables cookies/localstorage
     * and you attempt to access it.
     *
     * @return {LocalStorage}
     * @api private
     */

    function localstorage() {
      try {
        // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
        // The Browser also has localStorage in the global context.
        return localStorage;
      } catch (error) {
        // Swallow
        // XXX (@Qix-) should we be logging these?
      }
    }
    module.exports = common(exports);
    var formatters = module.exports.formatters;

    /**
     * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
     */

    formatters.j = function (v) {
      try {
        return JSON.stringify(v);
      } catch (error) {
        return '[UnexpectedJSONParseError]: ' + error.message;
      }
    };
  })(browser, browser.exports);
  var browserExports = browser.exports;
  var debugModule = /*@__PURE__*/getDefaultExportFromCjs(browserExports);

  var debug$3 = debugModule("socket.io-client:url"); // debug()
  /**
   * URL parser.
   *
   * @param uri - url
   * @param path - the request path of the connection
   * @param loc - An object meant to mimic window.location.
   *        Defaults to window.location.
   * @public
   */
  function url(uri) {
    var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var loc = arguments.length > 2 ? arguments[2] : undefined;
    var obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
      if ("/" === uri.charAt(0)) {
        if ("/" === uri.charAt(1)) {
          uri = loc.protocol + uri;
        } else {
          uri = loc.host + uri;
        }
      }
      if (!/^(https?|wss?):\/\//.test(uri)) {
        debug$3("protocol-less url %s", uri);
        if ("undefined" !== typeof loc) {
          uri = loc.protocol + "//" + uri;
        } else {
          uri = "https://" + uri;
        }
      }
      // parse
      debug$3("parse %s", uri);
      obj = parse(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
      if (/^(http|ws)$/.test(obj.protocol)) {
        obj.port = "80";
      } else if (/^(http|ws)s$/.test(obj.protocol)) {
        obj.port = "443";
      }
    }
    obj.path = obj.path || "/";
    var ipv6 = obj.host.indexOf(":") !== -1;
    var host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
  }

  var withNativeArrayBuffer = typeof ArrayBuffer === "function";
  var isView = function isView(obj) {
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
  };
  var toString = Object.prototype.toString;
  var withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && toString.call(Blob) === "[object BlobConstructor]";
  var withNativeFile = typeof File === "function" || typeof File !== "undefined" && toString.call(File) === "[object FileConstructor]";
  /**
   * Returns true if obj is a Buffer, an ArrayBuffer, a Blob or a File.
   *
   * @private
   */
  function isBinary(obj) {
    return withNativeArrayBuffer && (obj instanceof ArrayBuffer || isView(obj)) || withNativeBlob && obj instanceof Blob || withNativeFile && obj instanceof File;
  }
  function hasBinary(obj, toJSON) {
    if (!obj || _typeof(obj) !== "object") {
      return false;
    }
    if (Array.isArray(obj)) {
      for (var i = 0, l = obj.length; i < l; i++) {
        if (hasBinary(obj[i])) {
          return true;
        }
      }
      return false;
    }
    if (isBinary(obj)) {
      return true;
    }
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) {
      return hasBinary(obj.toJSON(), true);
    }
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key) && hasBinary(obj[key])) {
        return true;
      }
    }
    return false;
  }

  /**
   * Replaces every Buffer | ArrayBuffer | Blob | File in packet with a numbered placeholder.
   *
   * @param {Object} packet - socket.io event packet
   * @return {Object} with deconstructed packet and list of buffers
   * @public
   */
  function deconstructPacket(packet) {
    var buffers = [];
    var packetData = packet.data;
    var pack = packet;
    pack.data = _deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
      packet: pack,
      buffers: buffers
    };
  }
  function _deconstructPacket(data, buffers) {
    if (!data) return data;
    if (isBinary(data)) {
      var placeholder = {
        _placeholder: true,
        num: buffers.length
      };
      buffers.push(data);
      return placeholder;
    } else if (Array.isArray(data)) {
      var newData = new Array(data.length);
      for (var i = 0; i < data.length; i++) {
        newData[i] = _deconstructPacket(data[i], buffers);
      }
      return newData;
    } else if (_typeof(data) === "object" && !(data instanceof Date)) {
      var _newData = {};
      for (var key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          _newData[key] = _deconstructPacket(data[key], buffers);
        }
      }
      return _newData;
    }
    return data;
  }
  /**
   * Reconstructs a binary packet from its placeholder packet and buffers
   *
   * @param {Object} packet - event packet with placeholders
   * @param {Array} buffers - binary buffers to put in placeholder positions
   * @return {Object} reconstructed packet
   * @public
   */
  function reconstructPacket(packet, buffers) {
    packet.data = _reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
  }
  function _reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
      var isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
      if (isIndexValid) {
        return buffers[data.num]; // appropriate buffer (should be natural order anyway)
      } else {
        throw new Error("illegal attachments");
      }
    } else if (Array.isArray(data)) {
      for (var i = 0; i < data.length; i++) {
        data[i] = _reconstructPacket(data[i], buffers);
      }
    } else if (_typeof(data) === "object") {
      for (var key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          data[key] = _reconstructPacket(data[key], buffers);
        }
      }
    }
    return data;
  }

  /**
   * These strings must not be used as event names, as they have a special meaning.
   */
  var RESERVED_EVENTS$1 = ["connect",
  // used on the client side
  "connect_error",
  // used on the client side
  "disconnect",
  // used on both sides
  "disconnecting",
  // used on the server side
  "newListener",
  // used by the Node.js EventEmitter
  "removeListener" // used by the Node.js EventEmitter
  ];
  /**
   * Protocol version.
   *
   * @public
   */
  var protocol = 5;
  var PacketType;
  (function (PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
  })(PacketType || (PacketType = {}));
  /**
   * A socket.io Encoder instance
   */
  var Encoder = /*#__PURE__*/function () {
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */
    function Encoder(replacer) {
      this.replacer = replacer;
    }
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */
    var _proto = Encoder.prototype;
    _proto.encode = function encode(obj) {
      if (obj.type === PacketType.EVENT || obj.type === PacketType.ACK) {
        if (hasBinary(obj)) {
          return this.encodeAsBinary({
            type: obj.type === PacketType.EVENT ? PacketType.BINARY_EVENT : PacketType.BINARY_ACK,
            nsp: obj.nsp,
            data: obj.data,
            id: obj.id
          });
        }
      }
      return [this.encodeAsString(obj)];
    }
    /**
     * Encode packet as string.
     */;
    _proto.encodeAsString = function encodeAsString(obj) {
      // first is type
      var str = "" + obj.type;
      // attachments if we have them
      if (obj.type === PacketType.BINARY_EVENT || obj.type === PacketType.BINARY_ACK) {
        str += obj.attachments + "-";
      }
      // if we have a namespace other than `/`
      // we append it followed by a comma `,`
      if (obj.nsp && "/" !== obj.nsp) {
        str += obj.nsp + ",";
      }
      // immediately followed by the id
      if (null != obj.id) {
        str += obj.id;
      }
      // json data
      if (null != obj.data) {
        str += JSON.stringify(obj.data, this.replacer);
      }
      return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */;
    _proto.encodeAsBinary = function encodeAsBinary(obj) {
      var deconstruction = deconstructPacket(obj);
      var pack = this.encodeAsString(deconstruction.packet);
      var buffers = deconstruction.buffers;
      buffers.unshift(pack); // add packet info to beginning of data list
      return buffers; // write all the buffers
    };
    return Encoder;
  }();
  /**
   * A socket.io Decoder instance
   *
   * @return {Object} decoder
   */
  var Decoder = /*#__PURE__*/function (_Emitter) {
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */
    function Decoder(reviver) {
      var _this;
      _this = _Emitter.call(this) || this;
      _this.reviver = reviver;
      return _this;
    }
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */
    _inheritsLoose(Decoder, _Emitter);
    var _proto2 = Decoder.prototype;
    _proto2.add = function add(obj) {
      var packet;
      if (typeof obj === "string") {
        if (this.reconstructor) {
          throw new Error("got plaintext data when reconstructing a packet");
        }
        packet = this.decodeString(obj);
        var isBinaryEvent = packet.type === PacketType.BINARY_EVENT;
        if (isBinaryEvent || packet.type === PacketType.BINARY_ACK) {
          packet.type = isBinaryEvent ? PacketType.EVENT : PacketType.ACK;
          // binary packet's json
          this.reconstructor = new BinaryReconstructor(packet);
          // no attachments, labeled binary but no binary data to follow
          if (packet.attachments === 0) {
            _Emitter.prototype.emitReserved.call(this, "decoded", packet);
          }
        } else {
          // non-binary full packet
          _Emitter.prototype.emitReserved.call(this, "decoded", packet);
        }
      } else if (isBinary(obj) || obj.base64) {
        // raw binary data
        if (!this.reconstructor) {
          throw new Error("got binary data when not reconstructing a packet");
        } else {
          packet = this.reconstructor.takeBinaryData(obj);
          if (packet) {
            // received final buffer
            this.reconstructor = null;
            _Emitter.prototype.emitReserved.call(this, "decoded", packet);
          }
        }
      } else {
        throw new Error("Unknown type: " + obj);
      }
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */;
    _proto2.decodeString = function decodeString(str) {
      var i = 0;
      // look up type
      var p = {
        type: Number(str.charAt(0))
      };
      if (PacketType[p.type] === undefined) {
        throw new Error("unknown packet type " + p.type);
      }
      // look up attachments if type binary
      if (p.type === PacketType.BINARY_EVENT || p.type === PacketType.BINARY_ACK) {
        var start = i + 1;
        while (str.charAt(++i) !== "-" && i != str.length) {}
        var buf = str.substring(start, i);
        if (buf != Number(buf) || str.charAt(i) !== "-") {
          throw new Error("Illegal attachments");
        }
        p.attachments = Number(buf);
      }
      // look up namespace (if any)
      if ("/" === str.charAt(i + 1)) {
        var _start = i + 1;
        while (++i) {
          var c = str.charAt(i);
          if ("," === c) break;
          if (i === str.length) break;
        }
        p.nsp = str.substring(_start, i);
      } else {
        p.nsp = "/";
      }
      // look up id
      var next = str.charAt(i + 1);
      if ("" !== next && Number(next) == next) {
        var _start2 = i + 1;
        while (++i) {
          var _c = str.charAt(i);
          if (null == _c || Number(_c) != _c) {
            --i;
            break;
          }
          if (i === str.length) break;
        }
        p.id = Number(str.substring(_start2, i + 1));
      }
      // look up json data
      if (str.charAt(++i)) {
        var payload = this.tryParse(str.substr(i));
        if (Decoder.isPayloadValid(p.type, payload)) {
          p.data = payload;
        } else {
          throw new Error("invalid payload");
        }
      }
      return p;
    };
    _proto2.tryParse = function tryParse(str) {
      try {
        return JSON.parse(str, this.reviver);
      } catch (e) {
        return false;
      }
    };
    Decoder.isPayloadValid = function isPayloadValid(type, payload) {
      switch (type) {
        case PacketType.CONNECT:
          return isObject(payload);
        case PacketType.DISCONNECT:
          return payload === undefined;
        case PacketType.CONNECT_ERROR:
          return typeof payload === "string" || isObject(payload);
        case PacketType.EVENT:
        case PacketType.BINARY_EVENT:
          return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && RESERVED_EVENTS$1.indexOf(payload[0]) === -1);
        case PacketType.ACK:
        case PacketType.BINARY_ACK:
          return Array.isArray(payload);
      }
    }
    /**
     * Deallocates a parser's resources
     */;
    _proto2.destroy = function destroy() {
      if (this.reconstructor) {
        this.reconstructor.finishedReconstruction();
        this.reconstructor = null;
      }
    };
    return Decoder;
  }(Emitter);
  /**
   * A manager of a binary event's 'buffer sequence'. Should
   * be constructed whenever a packet of type BINARY_EVENT is
   * decoded.
   *
   * @param {Object} packet
   * @return {BinaryReconstructor} initialized reconstructor
   */
  var BinaryReconstructor = /*#__PURE__*/function () {
    function BinaryReconstructor(packet) {
      this.packet = packet;
      this.buffers = [];
      this.reconPack = packet;
    }
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */
    var _proto3 = BinaryReconstructor.prototype;
    _proto3.takeBinaryData = function takeBinaryData(binData) {
      this.buffers.push(binData);
      if (this.buffers.length === this.reconPack.attachments) {
        // done with buffer list
        var packet = reconstructPacket(this.reconPack, this.buffers);
        this.finishedReconstruction();
        return packet;
      }
      return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */;
    _proto3.finishedReconstruction = function finishedReconstruction() {
      this.reconPack = null;
      this.buffers = [];
    };
    return BinaryReconstructor;
  }();
  function isNamespaceValid(nsp) {
    return typeof nsp === "string";
  }
  // see https://caniuse.com/mdn-javascript_builtins_number_isinteger
  var isInteger = Number.isInteger || function (value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
  };
  function isAckIdValid(id) {
    return id === undefined || isInteger(id);
  }
  // see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
  function isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
  }
  function isDataValid(type, payload) {
    switch (type) {
      case PacketType.CONNECT:
        return payload === undefined || isObject(payload);
      case PacketType.DISCONNECT:
        return payload === undefined;
      case PacketType.EVENT:
        return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && RESERVED_EVENTS$1.indexOf(payload[0]) === -1);
      case PacketType.ACK:
        return Array.isArray(payload);
      case PacketType.CONNECT_ERROR:
        return typeof payload === "string" || isObject(payload);
      default:
        return false;
    }
  }
  function isPacketValid(packet) {
    return isNamespaceValid(packet.nsp) && isAckIdValid(packet.id) && isDataValid(packet.type, packet.data);
  }

  var parser = /*#__PURE__*/Object.freeze({
    __proto__: null,
    protocol: protocol,
    get PacketType () { return PacketType; },
    Encoder: Encoder,
    Decoder: Decoder,
    isPacketValid: isPacketValid
  });

  function on(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
      obj.off(ev, fn);
    };
  }

  var debug$2 = debugModule("socket.io-client:socket"); // debug()
  /**
   * Internal events.
   * These events can't be emitted by the user.
   */
  var RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
  });
  /**
   * A Socket is the fundamental class for interacting with the server.
   *
   * A Socket belongs to a certain Namespace (by default /) and uses an underlying {@link Manager} to communicate.
   *
   * @example
   * const socket = io();
   *
   * socket.on("connect", () => {
   *   console.log("connected");
   * });
   *
   * // send an event to the server
   * socket.emit("foo", "bar");
   *
   * socket.on("foobar", () => {
   *   // an event was received from the server
   * });
   *
   * // upon disconnection
   * socket.on("disconnect", (reason) => {
   *   console.log(`disconnected due to ${reason}`);
   * });
   */
  var Socket = /*#__PURE__*/function (_Emitter) {
    /**
     * `Socket` constructor.
     */
    function Socket(io, nsp, opts) {
      var _this;
      _this = _Emitter.call(this) || this;
      /**
       * Whether the socket is currently connected to the server.
       *
       * @example
       * const socket = io();
       *
       * socket.on("connect", () => {
       *   console.log(socket.connected); // true
       * });
       *
       * socket.on("disconnect", () => {
       *   console.log(socket.connected); // false
       * });
       */
      _this.connected = false;
      /**
       * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
       * be transmitted by the server.
       */
      _this.recovered = false;
      /**
       * Buffer for packets received before the CONNECT packet
       */
      _this.receiveBuffer = [];
      /**
       * Buffer for packets that will be sent once the socket is connected
       */
      _this.sendBuffer = [];
      /**
       * The queue of packets to be sent with retry in case of failure.
       *
       * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
       * @private
       */
      _this._queue = [];
      /**
       * A sequence to generate the ID of the {@link QueuedPacket}.
       * @private
       */
      _this._queueSeq = 0;
      _this.ids = 0;
      /**
       * A map containing acknowledgement handlers.
       *
       * The `withError` attribute is used to differentiate handlers that accept an error as first argument:
       *
       * - `socket.emit("test", (err, value) => { ... })` with `ackTimeout` option
       * - `socket.timeout(5000).emit("test", (err, value) => { ... })`
       * - `const value = await socket.emitWithAck("test")`
       *
       * From those that don't:
       *
       * - `socket.emit("test", (value) => { ... });`
       *
       * In the first case, the handlers will be called with an error when:
       *
       * - the timeout is reached
       * - the socket gets disconnected
       *
       * In the second case, the handlers will be simply discarded upon disconnection, since the client will never receive
       * an acknowledgement from the server.
       *
       * @private
       */
      _this.acks = {};
      _this.flags = {};
      _this.io = io;
      _this.nsp = nsp;
      if (opts && opts.auth) {
        _this.auth = opts.auth;
      }
      _this._opts = _extends({}, opts);
      if (_this.io._autoConnect) _this.open();
      return _this;
    }
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */
    _inheritsLoose(Socket, _Emitter);
    var _proto = Socket.prototype;
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */
    _proto.subEvents = function subEvents() {
      if (this.subs) return;
      var io = this.io;
      this.subs = [on(io, "open", this.onopen.bind(this)), on(io, "packet", this.onpacket.bind(this)), on(io, "error", this.onerror.bind(this)), on(io, "close", this.onclose.bind(this))];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */;
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */
    _proto.connect = function connect() {
      if (this.connected) return this;
      this.subEvents();
      if (!this.io["_reconnecting"]) this.io.open(); // ensure open
      if ("open" === this.io._readyState) this.onopen();
      return this;
    }
    /**
     * Alias for {@link connect()}.
     */;
    _proto.open = function open() {
      return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */;
    _proto.send = function send() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      args.unshift("message");
      this.emit.apply(this, args);
      return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */;
    _proto.emit = function emit(ev) {
      var _a, _b, _c;
      if (RESERVED_EVENTS.hasOwnProperty(ev)) {
        throw new Error('"' + ev.toString() + '" is a reserved event name');
      }
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      args.unshift(ev);
      if (this._opts.retries && !this.flags.fromQueue && !this.flags["volatile"]) {
        this._addToQueue(args);
        return this;
      }
      var packet = {
        type: PacketType.EVENT,
        data: args
      };
      packet.options = {};
      packet.options.compress = this.flags.compress !== false;
      // event ack callback
      if ("function" === typeof args[args.length - 1]) {
        var id = this.ids++;
        debug$2("emitting packet with ack id %d", id);
        var ack = args.pop();
        this._registerAckCallback(id, ack);
        packet.id = id;
      }
      var isTransportWritable = (_b = (_a = this.io.engine) === null || _a === void 0 ? void 0 : _a.transport) === null || _b === void 0 ? void 0 : _b.writable;
      var isConnected = this.connected && !((_c = this.io.engine) === null || _c === void 0 ? void 0 : _c._hasPingExpired());
      var discardPacket = this.flags["volatile"] && !isTransportWritable;
      if (discardPacket) {
        debug$2("discard packet as the transport is not currently writable");
      } else if (isConnected) {
        this.notifyOutgoingListeners(packet);
        this.packet(packet);
      } else {
        this.sendBuffer.push(packet);
      }
      this.flags = {};
      return this;
    }
    /**
     * @private
     */;
    _proto._registerAckCallback = function _registerAckCallback(id, ack) {
      var _this2 = this;
      var _a;
      var timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
      if (timeout === undefined) {
        this.acks[id] = ack;
        return;
      }
      // @ts-ignore
      var timer = this.io.setTimeoutFn(function () {
        delete _this2.acks[id];
        for (var i = 0; i < _this2.sendBuffer.length; i++) {
          if (_this2.sendBuffer[i].id === id) {
            debug$2("removing packet with ack id %d from the buffer", id);
            _this2.sendBuffer.splice(i, 1);
          }
        }
        debug$2("event with ack id %d has timed out after %d ms", id, timeout);
        ack.call(_this2, new Error("operation has timed out"));
      }, timeout);
      var fn = function fn() {
        // @ts-ignore
        _this2.io.clearTimeoutFn(timer);
        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }
        ack.apply(_this2, args);
      };
      fn.withError = true;
      this.acks[id] = fn;
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */;
    _proto.emitWithAck = function emitWithAck(ev) {
      var _this3 = this;
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }
      return new Promise(function (resolve, reject) {
        var fn = function fn(arg1, arg2) {
          return arg1 ? reject(arg1) : resolve(arg2);
        };
        fn.withError = true;
        args.push(fn);
        _this3.emit.apply(_this3, [ev].concat(args));
      });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */;
    _proto._addToQueue = function _addToQueue(args) {
      var _this4 = this;
      var ack;
      if (typeof args[args.length - 1] === "function") {
        ack = args.pop();
      }
      var packet = {
        id: this._queueSeq++,
        tryCount: 0,
        pending: false,
        args: args,
        flags: _extends({
          fromQueue: true
        }, this.flags)
      };
      args.push(function (err) {
        if (packet !== _this4._queue[0]) {
          // the packet has already been acknowledged
          return;
        }
        var hasError = err !== null;
        if (hasError) {
          if (packet.tryCount > _this4._opts.retries) {
            debug$2("packet [%d] is discarded after %d tries", packet.id, packet.tryCount);
            _this4._queue.shift();
            if (ack) {
              ack(err);
            }
          }
        } else {
          debug$2("packet [%d] was successfully sent", packet.id);
          _this4._queue.shift();
          if (ack) {
            for (var _len5 = arguments.length, responseArgs = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
              responseArgs[_key5 - 1] = arguments[_key5];
            }
            ack.apply(void 0, [null].concat(responseArgs));
          }
        }
        packet.pending = false;
        return _this4._drainQueue();
      });
      this._queue.push(packet);
      this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */;
    _proto._drainQueue = function _drainQueue() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      debug$2("draining queue");
      if (!this.connected || this._queue.length === 0) {
        return;
      }
      var packet = this._queue[0];
      if (packet.pending && !force) {
        debug$2("packet [%d] has already been sent and is waiting for an ack", packet.id);
        return;
      }
      packet.pending = true;
      packet.tryCount++;
      debug$2("sending packet [%d] (try n°%d)", packet.id, packet.tryCount);
      this.flags = packet.flags;
      this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */;
    _proto.packet = function packet(_packet) {
      _packet.nsp = this.nsp;
      this.io._packet(_packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */;
    _proto.onopen = function onopen() {
      var _this5 = this;
      debug$2("transport is open - connecting");
      if (typeof this.auth == "function") {
        this.auth(function (data) {
          _this5._sendConnectPacket(data);
        });
      } else {
        this._sendConnectPacket(this.auth);
      }
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */;
    _proto._sendConnectPacket = function _sendConnectPacket(data) {
      this.packet({
        type: PacketType.CONNECT,
        data: this._pid ? _extends({
          pid: this._pid,
          offset: this._lastOffset
        }, data) : data
      });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */;
    _proto.onerror = function onerror(err) {
      if (!this.connected) {
        this.emitReserved("connect_error", err);
      }
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */;
    _proto.onclose = function onclose(reason, description) {
      debug$2("close (%s)", reason);
      this.connected = false;
      delete this.id;
      this.emitReserved("disconnect", reason, description);
      this._clearAcks();
    }
    /**
     * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
     * the server.
     *
     * @private
     */;
    _proto._clearAcks = function _clearAcks() {
      var _this6 = this;
      Object.keys(this.acks).forEach(function (id) {
        var isBuffered = _this6.sendBuffer.some(function (packet) {
          return String(packet.id) === id;
        });
        if (!isBuffered) {
          // note: handlers that do not accept an error as first argument are ignored here
          var ack = _this6.acks[id];
          delete _this6.acks[id];
          if (ack.withError) {
            ack.call(_this6, new Error("socket has been disconnected"));
          }
        }
      });
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */;
    _proto.onpacket = function onpacket(packet) {
      var sameNamespace = packet.nsp === this.nsp;
      if (!sameNamespace) return;
      switch (packet.type) {
        case PacketType.CONNECT:
          if (packet.data && packet.data.sid) {
            this.onconnect(packet.data.sid, packet.data.pid);
          } else {
            this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
          }
          break;
        case PacketType.EVENT:
        case PacketType.BINARY_EVENT:
          this.onevent(packet);
          break;
        case PacketType.ACK:
        case PacketType.BINARY_ACK:
          this.onack(packet);
          break;
        case PacketType.DISCONNECT:
          this.ondisconnect();
          break;
        case PacketType.CONNECT_ERROR:
          this.destroy();
          var err = new Error(packet.data.message);
          // @ts-ignore
          err.data = packet.data.data;
          this.emitReserved("connect_error", err);
          break;
      }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */;
    _proto.onevent = function onevent(packet) {
      var args = packet.data || [];
      debug$2("emitting event %j", args);
      if (null != packet.id) {
        debug$2("attaching ack callback to event");
        args.push(this.ack(packet.id));
      }
      if (this.connected) {
        this.emitEvent(args);
      } else {
        this.receiveBuffer.push(Object.freeze(args));
      }
    };
    _proto.emitEvent = function emitEvent(args) {
      if (this._anyListeners && this._anyListeners.length) {
        var listeners = this._anyListeners.slice();
        var _iterator = _createForOfIteratorHelper(listeners),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var listener = _step.value;
            listener.apply(this, args);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      _Emitter.prototype.emit.apply(this, args);
      if (this._pid && args.length && typeof args[args.length - 1] === "string") {
        this._lastOffset = args[args.length - 1];
      }
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */;
    _proto.ack = function ack(id) {
      var self = this;
      var sent = false;
      return function () {
        // prevent double callbacks
        if (sent) return;
        sent = true;
        for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
          args[_key6] = arguments[_key6];
        }
        debug$2("sending ack %j", args);
        self.packet({
          type: PacketType.ACK,
          id: id,
          data: args
        });
      };
    }
    /**
     * Called upon a server acknowledgement.
     *
     * @param packet
     * @private
     */;
    _proto.onack = function onack(packet) {
      var ack = this.acks[packet.id];
      if (typeof ack !== "function") {
        debug$2("bad ack %s", packet.id);
        return;
      }
      delete this.acks[packet.id];
      debug$2("calling ack %s with %j", packet.id, packet.data);
      // @ts-ignore FIXME ack is incorrectly inferred as 'never'
      if (ack.withError) {
        packet.data.unshift(null);
      }
      // @ts-ignore
      ack.apply(this, packet.data);
    }
    /**
     * Called upon server connect.
     *
     * @private
     */;
    _proto.onconnect = function onconnect(id, pid) {
      debug$2("socket connected with id %s", id);
      this.id = id;
      this.recovered = pid && this._pid === pid;
      this._pid = pid; // defined only if connection state recovery is enabled
      this.connected = true;
      this.emitBuffered();
      this.emitReserved("connect");
      this._drainQueue(true);
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */;
    _proto.emitBuffered = function emitBuffered() {
      var _this7 = this;
      this.receiveBuffer.forEach(function (args) {
        return _this7.emitEvent(args);
      });
      this.receiveBuffer = [];
      this.sendBuffer.forEach(function (packet) {
        _this7.notifyOutgoingListeners(packet);
        _this7.packet(packet);
      });
      this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */;
    _proto.ondisconnect = function ondisconnect() {
      debug$2("server disconnect (%s)", this.nsp);
      this.destroy();
      this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */;
    _proto.destroy = function destroy() {
      if (this.subs) {
        // clean subscriptions to avoid reconnections
        this.subs.forEach(function (subDestroy) {
          return subDestroy();
        });
        this.subs = undefined;
      }
      this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */;
    _proto.disconnect = function disconnect() {
      if (this.connected) {
        debug$2("performing disconnect (%s)", this.nsp);
        this.packet({
          type: PacketType.DISCONNECT
        });
      }
      // remove socket from pool
      this.destroy();
      if (this.connected) {
        // fire events
        this.onclose("io client disconnect");
      }
      return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */;
    _proto.close = function close() {
      return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */;
    _proto.compress = function compress(_compress) {
      this.flags.compress = _compress;
      return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */;
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */
    _proto.timeout = function timeout(_timeout) {
      this.flags.timeout = _timeout;
      return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */;
    _proto.onAny = function onAny(listener) {
      this._anyListeners = this._anyListeners || [];
      this._anyListeners.push(listener);
      return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */;
    _proto.prependAny = function prependAny(listener) {
      this._anyListeners = this._anyListeners || [];
      this._anyListeners.unshift(listener);
      return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */;
    _proto.offAny = function offAny(listener) {
      if (!this._anyListeners) {
        return this;
      }
      if (listener) {
        var listeners = this._anyListeners;
        for (var i = 0; i < listeners.length; i++) {
          if (listener === listeners[i]) {
            listeners.splice(i, 1);
            return this;
          }
        }
      } else {
        this._anyListeners = [];
      }
      return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */;
    _proto.listenersAny = function listenersAny() {
      return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */;
    _proto.onAnyOutgoing = function onAnyOutgoing(listener) {
      this._anyOutgoingListeners = this._anyOutgoingListeners || [];
      this._anyOutgoingListeners.push(listener);
      return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */;
    _proto.prependAnyOutgoing = function prependAnyOutgoing(listener) {
      this._anyOutgoingListeners = this._anyOutgoingListeners || [];
      this._anyOutgoingListeners.unshift(listener);
      return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */;
    _proto.offAnyOutgoing = function offAnyOutgoing(listener) {
      if (!this._anyOutgoingListeners) {
        return this;
      }
      if (listener) {
        var listeners = this._anyOutgoingListeners;
        for (var i = 0; i < listeners.length; i++) {
          if (listener === listeners[i]) {
            listeners.splice(i, 1);
            return this;
          }
        }
      } else {
        this._anyOutgoingListeners = [];
      }
      return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */;
    _proto.listenersAnyOutgoing = function listenersAnyOutgoing() {
      return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */;
    _proto.notifyOutgoingListeners = function notifyOutgoingListeners(packet) {
      if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
        var listeners = this._anyOutgoingListeners.slice();
        var _iterator2 = _createForOfIteratorHelper(listeners),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var listener = _step2.value;
            listener.apply(this, packet.data);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    };
    return _createClass(Socket, [{
      key: "disconnected",
      get: function get() {
        return !this.connected;
      }
    }, {
      key: "active",
      get: function get() {
        return !!this.subs;
      }
    }, {
      key: "volatile",
      get: function get() {
        this.flags["volatile"] = true;
        return this;
      }
    }]);
  }(Emitter);

  /**
   * Initialize backoff timer with `opts`.
   *
   * - `min` initial timeout in milliseconds [100]
   * - `max` max timeout [10000]
   * - `jitter` [0]
   * - `factor` [2]
   *
   * @param {Object} opts
   * @api public
   */
  function Backoff(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
  }
  /**
   * Return the backoff duration.
   *
   * @return {Number}
   * @api public
   */
  Backoff.prototype.duration = function () {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
      var rand = Math.random();
      var deviation = Math.floor(rand * this.jitter * ms);
      ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
  };
  /**
   * Reset the number of attempts.
   *
   * @api public
   */
  Backoff.prototype.reset = function () {
    this.attempts = 0;
  };
  /**
   * Set the minimum duration
   *
   * @api public
   */
  Backoff.prototype.setMin = function (min) {
    this.ms = min;
  };
  /**
   * Set the maximum duration
   *
   * @api public
   */
  Backoff.prototype.setMax = function (max) {
    this.max = max;
  };
  /**
   * Set the jitter
   *
   * @api public
   */
  Backoff.prototype.setJitter = function (jitter) {
    this.jitter = jitter;
  };

  var debug$1 = debugModule("socket.io-client:manager"); // debug()
  var Manager = /*#__PURE__*/function (_Emitter) {
    function Manager(uri, opts) {
      var _this;
      var _a;
      _this = _Emitter.call(this) || this;
      _this.nsps = {};
      _this.subs = [];
      if (uri && "object" === _typeof(uri)) {
        opts = uri;
        uri = undefined;
      }
      opts = opts || {};
      opts.path = opts.path || "/socket.io";
      _this.opts = opts;
      installTimerFunctions(_this, opts);
      _this.reconnection(opts.reconnection !== false);
      _this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
      _this.reconnectionDelay(opts.reconnectionDelay || 1000);
      _this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
      _this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
      _this.backoff = new Backoff({
        min: _this.reconnectionDelay(),
        max: _this.reconnectionDelayMax(),
        jitter: _this.randomizationFactor()
      });
      _this.timeout(null == opts.timeout ? 20000 : opts.timeout);
      _this._readyState = "closed";
      _this.uri = uri;
      var _parser = opts.parser || parser;
      _this.encoder = new _parser.Encoder();
      _this.decoder = new _parser.Decoder();
      _this._autoConnect = opts.autoConnect !== false;
      if (_this._autoConnect) _this.open();
      return _this;
    }
    _inheritsLoose(Manager, _Emitter);
    var _proto = Manager.prototype;
    _proto.reconnection = function reconnection(v) {
      if (!arguments.length) return this._reconnection;
      this._reconnection = !!v;
      if (!v) {
        this.skipReconnect = true;
      }
      return this;
    };
    _proto.reconnectionAttempts = function reconnectionAttempts(v) {
      if (v === undefined) return this._reconnectionAttempts;
      this._reconnectionAttempts = v;
      return this;
    };
    _proto.reconnectionDelay = function reconnectionDelay(v) {
      var _a;
      if (v === undefined) return this._reconnectionDelay;
      this._reconnectionDelay = v;
      (_a = this.backoff) === null || _a === void 0 ? void 0 : _a.setMin(v);
      return this;
    };
    _proto.randomizationFactor = function randomizationFactor(v) {
      var _a;
      if (v === undefined) return this._randomizationFactor;
      this._randomizationFactor = v;
      (_a = this.backoff) === null || _a === void 0 ? void 0 : _a.setJitter(v);
      return this;
    };
    _proto.reconnectionDelayMax = function reconnectionDelayMax(v) {
      var _a;
      if (v === undefined) return this._reconnectionDelayMax;
      this._reconnectionDelayMax = v;
      (_a = this.backoff) === null || _a === void 0 ? void 0 : _a.setMax(v);
      return this;
    };
    _proto.timeout = function timeout(v) {
      if (!arguments.length) return this._timeout;
      this._timeout = v;
      return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */;
    _proto.maybeReconnectOnOpen = function maybeReconnectOnOpen() {
      // Only try to reconnect if it's the first time we're connecting
      if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) {
        // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
      }
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */;
    _proto.open = function open(fn) {
      var _this2 = this;
      debug$1("readyState %s", this._readyState);
      if (~this._readyState.indexOf("open")) return this;
      debug$1("opening %s", this.uri);
      this.engine = new Socket$1(this.uri, this.opts);
      var socket = this.engine;
      var self = this;
      this._readyState = "opening";
      this.skipReconnect = false;
      // emit `open`
      var openSubDestroy = on(socket, "open", function () {
        self.onopen();
        fn && fn();
      });
      var onError = function onError(err) {
        debug$1("error");
        _this2.cleanup();
        _this2._readyState = "closed";
        _this2.emitReserved("error", err);
        if (fn) {
          fn(err);
        } else {
          // Only do this if there is no fn to handle the error
          _this2.maybeReconnectOnOpen();
        }
      };
      // emit `error`
      var errorSub = on(socket, "error", onError);
      if (false !== this._timeout) {
        var timeout = this._timeout;
        debug$1("connect attempt will timeout after %d", timeout);
        // set timer
        var timer = this.setTimeoutFn(function () {
          debug$1("connect attempt timed out after %d", timeout);
          openSubDestroy();
          onError(new Error("timeout"));
          socket.close();
        }, timeout);
        if (this.opts.autoUnref) {
          timer.unref();
        }
        this.subs.push(function () {
          _this2.clearTimeoutFn(timer);
        });
      }
      this.subs.push(openSubDestroy);
      this.subs.push(errorSub);
      return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */;
    _proto.connect = function connect(fn) {
      return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */;
    _proto.onopen = function onopen() {
      debug$1("open");
      // clear old subs
      this.cleanup();
      // mark as open
      this._readyState = "open";
      this.emitReserved("open");
      // add new subs
      var socket = this.engine;
      this.subs.push(on(socket, "ping", this.onping.bind(this)), on(socket, "data", this.ondata.bind(this)), on(socket, "error", this.onerror.bind(this)), on(socket, "close", this.onclose.bind(this)),
      // @ts-ignore
      on(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */;
    _proto.onping = function onping() {
      this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */;
    _proto.ondata = function ondata(data) {
      try {
        this.decoder.add(data);
      } catch (e) {
        this.onclose("parse error", e);
      }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */;
    _proto.ondecoded = function ondecoded(packet) {
      var _this3 = this;
      // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
      nextTick(function () {
        _this3.emitReserved("packet", packet);
      }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */;
    _proto.onerror = function onerror(err) {
      debug$1("error", err);
      this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */;
    _proto.socket = function socket(nsp, opts) {
      var socket = this.nsps[nsp];
      if (!socket) {
        socket = new Socket(this, nsp, opts);
        this.nsps[nsp] = socket;
      } else if (this._autoConnect && !socket.active) {
        socket.connect();
      }
      return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */;
    _proto._destroy = function _destroy(socket) {
      var nsps = Object.keys(this.nsps);
      for (var _i = 0, _nsps = nsps; _i < _nsps.length; _i++) {
        var nsp = _nsps[_i];
        var _socket = this.nsps[nsp];
        if (_socket.active) {
          debug$1("socket %s is still active, skipping close", nsp);
          return;
        }
      }
      this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */;
    _proto._packet = function _packet(packet) {
      debug$1("writing packet %j", packet);
      var encodedPackets = this.encoder.encode(packet);
      for (var i = 0; i < encodedPackets.length; i++) {
        this.engine.write(encodedPackets[i], packet.options);
      }
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */;
    _proto.cleanup = function cleanup() {
      debug$1("cleanup");
      this.subs.forEach(function (subDestroy) {
        return subDestroy();
      });
      this.subs.length = 0;
      this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */;
    _proto._close = function _close() {
      debug$1("disconnect");
      this.skipReconnect = true;
      this._reconnecting = false;
      this.onclose("forced close");
    }
    /**
     * Alias for close()
     *
     * @private
     */;
    _proto.disconnect = function disconnect() {
      return this._close();
    }
    /**
     * Called when:
     *
     * - the low-level engine is closed
     * - the parser encountered a badly formatted packet
     * - all sockets are disconnected
     *
     * @private
     */;
    _proto.onclose = function onclose(reason, description) {
      var _a;
      debug$1("closed due to %s", reason);
      this.cleanup();
      (_a = this.engine) === null || _a === void 0 ? void 0 : _a.close();
      this.backoff.reset();
      this._readyState = "closed";
      this.emitReserved("close", reason, description);
      if (this._reconnection && !this.skipReconnect) {
        this.reconnect();
      }
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */;
    _proto.reconnect = function reconnect() {
      var _this4 = this;
      if (this._reconnecting || this.skipReconnect) return this;
      var self = this;
      if (this.backoff.attempts >= this._reconnectionAttempts) {
        debug$1("reconnect failed");
        this.backoff.reset();
        this.emitReserved("reconnect_failed");
        this._reconnecting = false;
      } else {
        var delay = this.backoff.duration();
        debug$1("will wait %dms before reconnect attempt", delay);
        this._reconnecting = true;
        var timer = this.setTimeoutFn(function () {
          if (self.skipReconnect) return;
          debug$1("attempting reconnect");
          _this4.emitReserved("reconnect_attempt", self.backoff.attempts);
          // check again for the case socket closed in above events
          if (self.skipReconnect) return;
          self.open(function (err) {
            if (err) {
              debug$1("reconnect attempt error");
              self._reconnecting = false;
              self.reconnect();
              _this4.emitReserved("reconnect_error", err);
            } else {
              debug$1("reconnect success");
              self.onreconnect();
            }
          });
        }, delay);
        if (this.opts.autoUnref) {
          timer.unref();
        }
        this.subs.push(function () {
          _this4.clearTimeoutFn(timer);
        });
      }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */;
    _proto.onreconnect = function onreconnect() {
      var attempt = this.backoff.attempts;
      this._reconnecting = false;
      this.backoff.reset();
      this.emitReserved("reconnect", attempt);
    };
    return Manager;
  }(Emitter);

  var debug = debugModule("socket.io-client"); // debug()
  /**
   * Managers cache.
   */
  var cache = {};
  function lookup(uri, opts) {
    if (_typeof(uri) === "object") {
      opts = uri;
      uri = undefined;
    }
    opts = opts || {};
    var parsed = url(uri, opts.path || "/socket.io");
    var source = parsed.source;
    var id = parsed.id;
    var path = parsed.path;
    var sameNamespace = cache[id] && path in cache[id]["nsps"];
    var newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    var io;
    if (newConnection) {
      debug("ignoring socket cache for %s", source);
      io = new Manager(source, opts);
    } else {
      if (!cache[id]) {
        debug("new io instance for %s", source);
        cache[id] = new Manager(source, opts);
      }
      io = cache[id];
    }
    if (parsed.query && !opts.query) {
      opts.query = parsed.queryKey;
    }
    return io.socket(parsed.path, opts);
  }
  // so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
  // namespace (e.g. `io.connect(...)`), for backward compatibility
  _extends(lookup, {
    Manager: Manager,
    Socket: Socket,
    io: lookup,
    connect: lookup
  });

  return lookup;

}));
//# sourceMappingURL=socket.io.js.map

},
'@lib/request/socket/adapter/events/SocketIO':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    var SocketIO;
    (function (SocketIO) {
        SocketIO["CONNECT"] = "connect";
        SocketIO["CONNECT_ERROR"] = "connect_error";
        SocketIO["DISCONNECT"] = "disconnect";
    })(SocketIO || (SocketIO = {}));
    return SocketIO;
});

},
'@lib/doc-control/document/template/FieldCollection':function(){
define(["require", "exports", "@lib/doc-control/document/template/field/RegistrationFields"], function (require, exports, REGISTRATION_FIELDS) {
    "use strict";
    class FieldCollection {
        static getExtractedProjectNumber(fieldCollection) {
            const field = fieldCollection.find((field) => {
                return field.refersTo === REGISTRATION_FIELDS.PROJECT_NUMBER
                    || field.dataType === this.FIELD_TYPE_CONTRACT_NUMBER
                    || field.name === this.FIELD_NAME_PROJECT_NUMBER;
            });
            return field?.value || '';
        }
        static getExtractedDrawingDiscipline(fieldCollection) {
            const field = fieldCollection.find((field) => {
                return field.refersTo === REGISTRATION_FIELDS.DISCIPLINE;
            });
            return field?.value || '';
        }
        static getExtractedStatus(fieldCollection) {
            const field = fieldCollection.find((field) => {
                return field.refersTo === REGISTRATION_FIELDS.STATUS;
            });
            return field?.value || '';
        }
        static getExtractedRevisionWithStatus(fieldCollection) {
            const revisionWithStatusField = fieldCollection.find((field) => {
                return field.refersTo === REGISTRATION_FIELDS.REVISION_WITH_STATUS;
            });
            const status = this.getExtractedStatus(fieldCollection);
            if (revisionWithStatusField) {
                if (!status)
                    return revisionWithStatusField.value;
                return `${revisionWithStatusField.value}-${status}`;
            }
            return '';
        }
    }
    FieldCollection.FIELD_NAME_PROJECT_NUMBER = 'Project Number';
    FieldCollection.FIELD_TYPE_CONTRACT_NUMBER = 'contract_number';
    return FieldCollection;
});

},
'ocr/parser/Date':function(){
define([], function() {
    return {
        parse: function(date) {
            if (date instanceof Date) {
                if (isNaN(date.getTime())) throw new RangeError('Invalid Date');

                return date;
            }

            const match = this.extractDayMonthYear(date)

            const result = match
                ? this.dayMonthYearToDate(match[1], match[2], match[3])
                : new Date(date);

            if (isNaN(result.getTime())) throw new RangeError('Invalid Date');

            return result;
        },

        extractDayMonthYear: function(date) {
            return date.replaceAll(' ', '').match(/\b(\d{1,2})\D(\d{1,2})\D(\d{4}|\d{2})/);
        },

        dayMonthYearToDate: function(day, month, year) {
            return new Date(
                parseInt(year) < 100 ? parseInt(year) + 2000 : year,
                month - 1,
                day
            );
        }
    };
});
},
'style-guide/v1/doc-control/registration-details/DocumentRegister/SmartRegisterData':function(){
define(["require", "exports", "api/doccontrol/data/RegistrationDetails"], function (require, exports, RegistrationDetailsVO) {
    "use strict";
    class SmartRegisterData {
        constructor(md5, extractedRegistrationDetails = new RegistrationDetailsVO) {
            this.md5 = md5;
            this.extractedRegistrationDetails = extractedRegistrationDetails;
            this.fieldCollection = [];
            this.projectStage = null;
            this.suggestedNodes = [];
            this.projectStagePKForSuggestedNodes = null;
        }
        getMd5() {
            return this.md5;
        }
        setQrCodeContent(qrCodeContent) {
            this.qrCodeContent = qrCodeContent;
            return this;
        }
        getQrCodeContent() {
            return this.qrCodeContent;
        }
        setTemplate(template) {
            this.template = template;
            return this;
        }
        getTemplate() {
            return this.template;
        }
        setFieldCollection(fieldCollection) {
            this.fieldCollection = fieldCollection;
            return this;
        }
        getFieldCollection() {
            return this.fieldCollection;
        }
        setProjectStage(projectStage) {
            this.projectStage = projectStage;
            return this;
        }
        getProjectStage() {
            return this.projectStage;
        }
        setSuggestedNodes(suggestedNodes) {
            this.suggestedNodes = suggestedNodes;
            return this;
        }
        getSuggestedNodes() {
            return this.suggestedNodes;
        }
        getProjectStagePKForSuggestedNodes() {
            return this.projectStagePKForSuggestedNodes;
        }
        setProjectStagePKForSuggestedNodes(projectStagePK) {
            this.projectStagePKForSuggestedNodes = projectStagePK;
            return this;
        }
        getExtractedRegistrationDetails() {
            return this.extractedRegistrationDetails;
        }
    }
    return SmartRegisterData;
});

},
'api/doccontrol/tree/node/Builder':function(){
define([
    './Config',
    './Factory',
    'library/request/URLConnectionBuilder',
    'library/request/URLResponseProcessorBuilder',
    'library/request/dojo/URLConnectionProcessorBuilder',
], function(
    Config,
    Factory,
    URLConnectionBuilder,
    URLResponseProcessorBuilder,
    URLConnectionProcessorBuilder
) {
    const Builder = function() {
        this.urlConnectionBuilder = new URLConnectionBuilder(
            new URLConnectionProcessorBuilder()
        );

        this.urlResponseProcessorBuilder = new URLResponseProcessorBuilder();
    };

    Builder.prototype.getTreeNodeFactory = function() {
        return new Factory(
            new Config(),
            this.urlConnectionBuilder,
            this.urlResponseProcessorBuilder
        );
    };

    return Builder;
});

},
'style-guide/v1/doc-control/project-node-select/SuggestedNodeSelect':function(){
define([
    './FilteringNodeSelect',
    './SuggestedNodeListing',
    '@lib/doc-control/tree/data/Node',
    'dojo/_base/config',
    'dojo/_base/declare',
    'dojo/dom-class',
    'dojo/on',
    'dojo/text!./template/SuggestedNodeSelect.html',
    'dojox/widget/TitleGroup',
    'dijit/TitlePane',
    'lodash',
    'style-guide/v1/doc-control/registration-details/DocumentRegister/SmartRegisterProcessor'
], function(
    FilteringNodeSelect,
    SuggestedNodeListing,
    NodeVO,
    config,
    declare,
    domClass,
    on,
    template,
    AccordionContainer,
    ContentPane,
    lodash,
    SmartRegisterProcessor
) {
    const VIRTUAL_ROOT_NODE = 'VIRTUAL ROOT NODE';
    const SELECT_NODE_MANUALLY_SUGGESTION_TIMEOUT = 10000;
    const SUGGESTED_NODE_TIMEOUT = 30000;

    return declare([FilteringNodeSelect], {
        accordionContainer: null,
        detectorModel: null,
        filteringNodeSelectNode: null,
        md5: null,
        tmpFileKey: null,
        messageError: null,
        messageInfo: null,
        noneFoundContainer: null,
        nodeListingsAccordionPane: null,
        projectStagePK: null,
        smartRegisterProcessor: null,
        suggestedLocationsAccordionNode: null,
        suggestedLocationsNode: null,
        suggestedNodes: null,
        suggestedNodeListingWidget: null,
        suggestedNodeAccordionPane: null,
        templateString: template,
        timeoutError: null,
        timeoutInfo: null,

        postCreate: function() {
            this.inherited(arguments);

            this._setupAccordion();
            this._setupSuggestedNodeListing();
            this._setupSmartProcessor();
            this._setupEvents();
        },

        populate: function(md5, projectStagePK, tmpFileKey) {
            this._resetToInitialState();

            if (!md5 || !projectStagePK) {
                try {
                    this.accordionContainer.removeChild(this.suggestedNodeAccordionPane);
                } catch (e) {}
                this.suggestedNodeAccordionPane.set('open', false);
                this.nodeListingsAccordionPane.set('open', true);
                return;
            }

            this.md5 = md5;
            this.projectStagePK = projectStagePK;
            this.tmpFileKey = tmpFileKey ?? null;
            this._detectNodes();
        },

        reset: function() {
            this.inherited(arguments);

            this._resetTimeouts();
            this._hideMessageError();
            this._hideMessageInfo();
            this.md5 = null;
            this.projectStagePK = null;
            this.tmpFileKey = null;
            this.suggestedNodes = null;
        },

        _resetTimeouts: function() {
            clearTimeout(this.timeoutError);
            clearTimeout(this.timeoutInfo);
        },

        _resetToInitialState() {
            this.md5 = null;
            this.projectStagePK = null;
            this.tmpFileKey = null;
            this.accordionContainer.addChild(this.suggestedNodeAccordionPane, 'first');
            this.suggestedNodeAccordionPane.set('open', true);
            this.nodeListingsAccordionPane.set('open', false);

            domClass.remove(this.noneFoundContainer, 'sos-empty-state-show');
            this.showLoading();
            this.suggestedNodeListingWidget.reset();
            this.suggestedNodeListingWidget.render();
        },

        _selectNode(node) {
            this.nodeListingWidget.highlightNode(node?.getProjectStageTreeViewPK?.() || node?.treeViewPK || node?.projectStageTreeViewPK || null);
            this.suggestedNodeListingWidget.highlightNode(node?.getProjectStageTreeViewPK?.() || node?.treeViewPK || node?.projectStageTreeViewPK || null);

            this.inherited(arguments);
        },

        _setupAccordion: function() {
            this.accordionContainer = new AccordionContainer({}, this.accordionContainerNode);
            this.suggestedNodeAccordionPane = new ContentPane({
                title: 'Suggested Folders',
                content: this.suggestedLocationsAccordionNode,
                open: true
            });
            this.nodeListingsAccordionPane = new ContentPane({
                title: 'All Folders',
                content: this.filteringNodeSelectNode,
                open: false
            });

            this.accordionContainer.addChild(this.suggestedNodeAccordionPane);
            this.accordionContainer.addChild(this.nodeListingsAccordionPane);
        },

        _setupSuggestedNodeListing: function() {
            this.suggestedNodeListingWidget = new SuggestedNodeListing({}, this.suggestedLocationsNode);

            on(this.suggestedNodeListingWidget, 'selected, nodeSelect', (node) => {
                this.selectedNode = node;
                this.nodeListingWidget.set('selectedProjectStageTreeViewPK', node.getProjectStageTreeViewPK());
            });

            on(this.suggestedNodeListingWidget, 'refresh', () => {
                this.suggestedNodeListingWidget.reset();
                this.suggestedNodeListingWidget.setSuggestedNodeCollection(this.suggestedNodes);
            });
        },

        _setupSmartProcessor: function() {
            this.smartRegisterProcessor = new SmartRegisterProcessor();
            this.smartRegisterProcessor.setOnSuggestedNodesUpdate((smartRegisterData) => {
                if (smartRegisterData.getMd5() !== this.md5
                    || smartRegisterData.getProjectStagePKForSuggestedNodes() !== this.projectStagePK
                ) {
                    return;
                }

                this._resetTimeouts();
                this.hideLoading();
                this._hideMessageInfo();
                this._hideMessageError();

                const suggestedNodes = this._hydrate(smartRegisterData.getSuggestedNodes());

                if (suggestedNodes.length === 0) {
                    this._showNoneFound();
                    return;
                }

                if (!this.suggestedNodes) {
                    domClass.remove(this.noneFoundContainer, 'sos-empty-state-show');
                    this.suggestedNodes = suggestedNodes;
                    this.suggestedNodeListingWidget.setSuggestedNodeCollection(suggestedNodes);
                    return;
                }

                if (!lodash.isEqual(this.suggestedNodes, suggestedNodes)) {
                    this.suggestedNodes = suggestedNodes;
                    this.suggestedNodeListingWidget.showRefreshButton();
                }
            });
        },

        _setupEvents: function() {
            on(this.nodeListingWidget, 'highlighted', function() {
                this.suggestedNodeAccordionPane.set('open', false);
                this.nodeListingsAccordionPane.set('open', true);
            }.bind(this));
        },

        _detectNodes: function() {
            this._resetTimeouts();

            this.smartRegisterProcessor.listenForNodeDetectionEvents(
                this.md5,
                this.projectStagePK,
                this.fileKey || null
            );

            this.smartRegisterProcessor.detectTreeNodes(this.md5, this.projectStagePK, this.tmpFileKey || null);

            this.timeoutInfo = setTimeout(this._showMessageInfo.bind(this), SELECT_NODE_MANUALLY_SUGGESTION_TIMEOUT);

            this.timeoutError = setTimeout(
                () => {
                    this.hideLoading();
                    this._hideMessageInfo();
                    this._showMessageError();
                },
                SUGGESTED_NODE_TIMEOUT
            );
        },

        _showNoneFound: function() {
            this.hideLoading();
            domClass.add(this.noneFoundContainer, 'sos-empty-state-show');
            this.suggestedNodeAccordionPane.set('open', false);
            this.nodeListingsAccordionPane.set('open', true);
        },

        _hydrate: function(suggestedNodes) {
            const parentNode = new NodeVO()
                .setName(VIRTUAL_ROOT_NODE)
                .setIsActive(true);

            return suggestedNodes.map(sn => {
                const cloned = Object.assign(new NodeVO(), sn.getNode())
                    .setName(`${sn.getFolderName()} -> ${sn.getNode().getName()}`)
                    .setParent(parentNode)
                    .setIsActive(true);
                sn.setNode(cloned);

                return sn;
            });
        },

        _hideMessageError: function() {
            domClass.add(this.messageError, 'hide');
        },

        _showMessageError: function() {
            domClass.remove(this.messageError, 'hide');
        },

        _hideMessageInfo: function() {
            domClass.add(this.messageInfo, 'hide');
        },

        _showMessageInfo: function() {
            domClass.remove(this.messageInfo, 'hide');
        }
    });
});
},
'style-guide/v1/doc-control/project-node-select/SuggestedNodeListing':function(){
define([
    './NodeListing',
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/text!./template/SuggestedNodeListing.html'
], function(
    NodeListing,
    declare,
    domAttr,
    domClass,
    template
) {
    const CONFIDENCE_THRESHOLD = 5;

    return declare([NodeListing], {
        templateString: template,
        suggestedNodeCollection: [],

        postMixInProperties: function() {
            this.inherited(arguments);

            this.setCustomViewHelpers({
                getConfidence: (node) => {
                    let c = this.suggestedNodeCollection.find(
                        sn => sn.getNode().getProjectStageTreeViewPK() === parseInt(node.treeViewPK)
                    );

                    if (!c) {
                        return 0;
                    }

                    c = c.getConfidence();
                    c = Math.round(c);

                    return c < CONFIDENCE_THRESHOLD ? `< ${CONFIDENCE_THRESHOLD}` : c;
                }
            });
        },

        setSuggestedNodeCollection: function(suggestedNodeCollection) {
            this.suggestedNodeCollection = suggestedNodeCollection;
            this.nodeCollection = suggestedNodeCollection.map(suggestedNode => suggestedNode.getNode());
            this.data.menuItems = suggestedNodeCollection.map(sn => this._makeMenuItem(sn.getNode())) || [];

            this.render();

            if (suggestedNodeCollection) {
                domClass.remove(this.suggestedItemsHeader, 'hidden');
            }
        },

        getSuggestedNodeCollection: function() {
            return this.suggestedNodeCollection;
        },

        reset: function() {
            this.inherited(arguments);
            domClass.add(this.suggestedItemsHeader, 'hidden');
            domClass.add(this.refreshItemsHeader, 'hidden');
        },

        showRefreshButton: function() {
            domClass.remove(this.refreshItemsHeader, 'hidden');
        },

        _onNodeClick: function(e) {
            let node = e.target;
            if (!domAttr.has(node, 'data-node-tree-view-pk')) {
                node = e.target.closest('a[data-node-tree-view-pk]');
            }

            this._selectNode('selected', node);
        },

        _onRefreshClick: function() {
            this.emit('refresh');
        }
    });
});
},
'dojox/widget/TitleGroup':function(){
define(["dojo", "dijit/registry", "dijit/_Widget", "dijit/TitlePane"], function(dojo, registry, widget, titlepane){
	
	var tp = titlepane.prototype,
		lookup = function(){
			// generic handler function for click and keypress
			var parent = this._dxfindParent && this._dxfindParent();
			parent && parent.selectChild(this);
		}
	;
	
	// this might hide this uberprivate function from the docparser.
	tp._dxfindParent = function(){
		// summary:
		//		TitlePane's MUST be first-children of a TitleGroup. only used by
		//		`dojox.widget.TitleGroup`. Finds a possible parent TitleGroup of a TitlePane
		var n = this.domNode.parentNode;
		if(n){
			n = registry.getEnclosingWidget(n);
			return n && n instanceof dojox.widget.TitleGroup && n;
		}
		return n;
	};

	// if we click our own title, hide everyone
	dojo.connect(tp, "_onTitleClick", lookup);
	dojo.connect(tp, "_onTitleKey", function(e){
		// if we're tabbing through the items in a group, don't do toggles.
		// if we hit enter, let it happen.
		if(!(e && e.type && e.type == "keypress" && e.charOrCode == dojo.keys.TAB)){
			lookup.apply(this, arguments);
		}
	});
		
	return dojo.declare("dojox.widget.TitleGroup", dijit._Widget, {
		// summary:
		//		A container which controls a series of `dijit.TitlePane`s,
		//		allowing one to be visible and hiding siblings
		// description:
		//		A container which controls a series of `dijit.TitlePane`s,
		//		allowing one to be visible and hiding siblings. Behaves similarly
		//		to a `dijit.layout.AccordionContainer` in that the children
		//		are all stacked, though merges the TitlePane behavior of
		//		variable height
		// example:
		//	|	var group = new dojox.widget.TitleGroup().placeAt(dojo.body());
		//	|	new dijit.TitlePane({ title:"One" }, "fromsource").placeAt(group);
		//	|	new dijit.TitlePane({ title:"Remote", href:"foo.html" }).placeAt(group);
		
		"class":"dojoxTitleGroup",

		addChild: function(widget, position){
			// summary:
			//		Add a passed widget reference to this container at an optional
			//		position index.
			// widget: dijit.TitlePane
			//		A widget reference to add
			// position: String|Int?
			//		An optional index or position to pass. defaults to "last"
			return widget.placeAt(this.domNode, position); // dijit.TitlePane
		},
		
		removeChild: function(widget){
			// summary:
			//		Remove the passed widget from this container. Does not destroy
			//		child.
			
			this.domNode.removeChild(widget.domNode);
			return widget;
		},
		
		selectChild: function(widget){
			// summary:
			//		close all found titlePanes within this group, excluding
			//		the one the we pass to select
			widget && dojo.query("> .dijitTitlePane", this.domNode).forEach(function(n){
				var tp = registry.byNode(n);
				tp && tp !== widget && tp.open && tp.toggle(); // could race if open is set onEnd of slide
			});
			return widget; // dijit/TitlePane
		}
	
	});

});

},
'vendor/lodash/lodash':function(){
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

},
'style-guide/v1/doc-control/document/revise/FormPaneWrapper':function(){
define(["require", "exports", "api/doccontrol/document/Config", "api/doccontrol/document/Factory", "api/doccontrol/document/revision/Config", "api/doccontrol/document/revision/Factory", "api/doccontrol/document/tree/Config", "api/doccontrol/document/tree/Factory", "api/doccontrol/drawing-discipline/Config", "api/doccontrol/drawing-discipline/Factory", "api/doccontrol/revision/Config", "api/doccontrol/revision/Factory", "api/doccontrol/tree/node/Config", "api/doccontrol/tree/node/Factory", "style-guide/v1/doc-control/document/revise/FormPane", "api/project-stage/Config", "api/project-stage/Factory", "library/request/URLConnectionBuilder", "library/request/dojo/URLConnectionProcessorBuilder", "library/request/URLResponseProcessorBuilder"], function (require, exports, DocControlDocumentConfig, DocControlDocumentFactory, DocControlDocumentRevisionConfig, DocControlDocumentRevisionFactory, DocControlDocumentTreeConfig, DocControlDocumentTreeFactory, DocControlDrawingDisciplineConfig, DocControlDrawingDisciplineFactory, DocControlRevisionConfig, DocControlRevisionFactory, DocControlTreeNodeConfig, DocControlTreeNodeFactory, DocumentReviseFormPane, ProjectStageConfig, ProjectStageFactory, URLConnectionBuilder, URLConnectionProcessorBuilder, URLResponseProcessorBuilder) {
    "use strict";
    class FormPaneWrapper {
        constructor(documentViewer = null) {
            this.widget = new DocumentReviseFormPane(this.getDocControlTreeNodeFactory().getAvailableStatusCollection(), this.getDocControlDocumentRevisionFactory().getLatest(), this.getDocControlDocumentTreeFactory().getNode(), this.getDocControlTreeNodeFactory().getPath(), this.getProjectStageFactory().getProjectStage(), this.getDocControlDrawingDisciplineFactory().getCollection(), this.getDocControlRevisionFactory().getOriginator(), this.getDocControlDocumentFactory().getReviser(), documentViewer);
        }
        open() {
            this.widget.open();
        }
        close() {
            this.widget.close();
        }
        setDocumentPK(documentPK) {
            this.widget.setDocumentPK(documentPK);
        }
        setTemporaryDocument(temporaryDocument) {
            this.widget.setTemporaryDocument(temporaryDocument);
        }
        setViewRevisionCallback(viewRevisionCallback) {
            this.widget.setViewRevisionCallback(viewRevisionCallback);
        }
        setOnSuccessCallback(onSuccessCallback) {
            this.widget.setOnSuccessCallback(onSuccessCallback);
        }
        setOnCloseCallback(onCloseCallback) {
            this.widget.setOnCloseCallback(onCloseCallback);
        }
        setOpenViewerCallback(callback) {
            this.widget.setOpenViewerCallback(callback);
        }
        setOpenNodeCallback(callback) {
            this.widget.setOpenNodeCallback(callback);
        }
        setSoftLinkCallback(callback) {
            this.widget.setSoftLinkCallback(callback);
        }
        reload() {
            this.widget.reload();
        }
        allowPrivacyChanges() {
            this.widget.allowPrivacyChanges();
        }
        getUrlConnectionBuilder() {
            if (!this.urlConnectionBuilder) {
                this.urlConnectionBuilder = new URLConnectionBuilder(new URLConnectionProcessorBuilder());
            }
            return this.urlConnectionBuilder;
        }
        ;
        getUrlResponseProcessorBuilder() {
            if (!this.urlResponseProcessorBuilder) {
                this.urlResponseProcessorBuilder = new URLResponseProcessorBuilder();
            }
            return this.urlResponseProcessorBuilder;
        }
        ;
        getDocControlTreeNodeFactory() {
            if (!this.documentControlTreeNodeFactory) {
                this.documentControlTreeNodeFactory = new DocControlTreeNodeFactory(new DocControlTreeNodeConfig(), this.getUrlConnectionBuilder(), this.getUrlResponseProcessorBuilder());
            }
            return this.documentControlTreeNodeFactory;
        }
        ;
        getDocControlDocumentRevisionFactory() {
            return new DocControlDocumentRevisionFactory(new DocControlDocumentRevisionConfig(), this.getUrlConnectionBuilder(), this.getUrlResponseProcessorBuilder());
        }
        ;
        getDocControlDocumentTreeFactory() {
            return new DocControlDocumentTreeFactory(new DocControlDocumentTreeConfig(), this.getUrlConnectionBuilder(), this.getUrlResponseProcessorBuilder());
        }
        ;
        getProjectStageFactory() {
            return new ProjectStageFactory(new ProjectStageConfig(), this.getUrlConnectionBuilder(), this.getUrlResponseProcessorBuilder());
        }
        ;
        getDocControlDrawingDisciplineFactory() {
            return new DocControlDrawingDisciplineFactory(new DocControlDrawingDisciplineConfig(), this.getUrlConnectionBuilder(), this.getUrlResponseProcessorBuilder());
        }
        ;
        getDocControlRevisionFactory() {
            return new DocControlRevisionFactory(new DocControlRevisionConfig(), this.getUrlConnectionBuilder(), this.getUrlResponseProcessorBuilder());
        }
        ;
        getDocControlDocumentFactory() {
            return new DocControlDocumentFactory(new DocControlDocumentConfig(), this.getUrlConnectionBuilder(), this.getUrlResponseProcessorBuilder());
        }
        ;
    }
    return FormPaneWrapper;
});

},
'style-guide/v1/doc-control/document/revise/FormPane':function(){
define([
    'dojo/_base/declare',
    'style-guide/v1/doc-control/document/revise/Form',
    'style-guide/v1/layout/FormPane',
    '@lib/request/data/Handlers'
], function(
    declare,
    Form,
    FormPaneWidget,
    Handlers
) {
    const FormPane = function(
        availableStatusCollection,
        latestRevisionForDocument,
        nodeForDocument,
        nodePath,
        projectStage,
        disciplineCollection,
        originatorForRevision,
        reviser,
        documentViewer
    ) {
        this.view = new (declare(FormPaneWidget, {
            icon: 'sos-icon-folder-open',
            title: 'Revise Document',
            'class': 'revise-document-form-pane',
            width: 40,
            form: null,
            allowingPrivacyChanges: null,
            documentViewer: documentViewer,

            open: function() {
                if(!this.form) {
                    this.form = new Form(
                        availableStatusCollection,
                        latestRevisionForDocument,
                        nodeForDocument,
                        nodePath,
                        projectStage,
                        disciplineCollection,
                        originatorForRevision,
                        reviser
                    );

                    if(this.allowingPrivacyChanges) {
                        this.form.allowPrivacyChanges();
                    }
                }

                this.set('content', this.form.view.domNode);
                this.inherited(arguments);
                return this;
            },

            close: function() {
                this.set('content', '');
                this.inherited(arguments);

                if (this.latestRevisionCanceller) this.latestRevisionCanceller.cancel();
                if (this.documentViewer) this.documentViewer.close();

                this.onClose();
                return this;
            },

            setDocumentPK: function(documentPK) {
                if (this.latestRevisionCanceller) this.latestRevisionCanceller.cancel();

                this.latestRevisionCanceller = latestRevisionForDocument.get(
                    new Handlers(
                        revision => {
                            if (this.onOpenCompleteHandler) this.onOpenCompleteHandler.remove();
                            if (this.documentViewer) this.documentViewer.openInline(revision.getMd5());
                        },
                        () => {}
                    ),
                    documentPK
                );

                this.form.setDocumentPK(documentPK);
                return this;
            },

            setTemporaryDocument: function(temporaryDocument) {
                this.form.setTemporaryDocument(temporaryDocument);
            },

            setViewRevisionCallback: function(viewRevisionCallback) {
                this.form.setViewRevisionCallback(viewRevisionCallback);
                return this;
            },

            setOnSuccessCallback: function(onSuccessCallback) {
                this.form.setOnSuccessCallback(onSuccessCallback);
                return this;
            },

            setOnCloseCallback: function(onClose) {
                this.onClose = onClose;
                return this;
            },

            onClose: function () {},

            setOpenViewerCallback: function(callback) {
                this.form.setOpenViewerCallback(callback);
                return this;
            },

            setOpenNodeCallback: function(callback) {
                this.form.setOpenNodeCallback(callback);
                return this;
            },

            setSoftLinkCallback: function(callback) {
                this.form.setSoftLinkCallback(callback);
                return this;
            },

            reload: function() {
                this.form.reload();
                return this;
            },

            allowPrivacyChanges: function() {
                if(this.form) {
                    this.form.allowPrivacyChanges();
                }

                this.allowingPrivacyChanges = true;
                return this;
            },

            onOpenComplete: function() {
                if (this.documentViewer) {
                    this.documentViewer.initInline();
                    this.documentViewer.showInitialiser(() => {
                        if (this.latestRevisionCanceller) this.latestRevisionCanceller.cancel();
                    });
                }
            }
        }));
    };

    FormPane.prototype.open = function() {
        this.view.open();
        return this;
    };

    FormPane.prototype.close = function() {
        this.view.close();
        return this;
    };

    FormPane.prototype.setDocumentPK = function(documentPK) {
        this.view.setDocumentPK(documentPK);
        return this;
    };

    FormPane.prototype.setTemporaryDocument = function(temporaryDocument) {
        this.view.setTemporaryDocument(temporaryDocument);
        return this;
    };

    FormPane.prototype.setViewRevisionCallback = function(viewRevisionCallback) {
        this.view.setViewRevisionCallback(viewRevisionCallback);
        return this;
    };

    FormPane.prototype.setOnSuccessCallback = function(onSuccessCallback) {
        this.view.setOnSuccessCallback(onSuccessCallback);
        return this;
    };

    FormPane.prototype.setOnCloseCallback = function(onCloseCallback) {
        this.view.setOnCloseCallback(onCloseCallback);
        return this;
    };

    FormPane.prototype.setOpenViewerCallback = function(callback) {
        this.view.setOpenViewerCallback(callback);
        return this;
    };

    FormPane.prototype.setOpenNodeCallback = function(callback) {
        this.view.setOpenNodeCallback(callback);
        return this;
    };

    FormPane.prototype.setSoftLinkCallback = function(callback) {
        this.view.setSoftLinkCallback(callback);
        return this;
    };

    FormPane.prototype.reload = function() {
        this.view.reload();
        return this;
    };

    FormPane.prototype.allowPrivacyChanges = function() {
        this.view.allowPrivacyChanges();
        return this;
    };

    return FormPane;
});
},
'style-guide/v1/doc-control/document/revise/Form':function(){
define([
    'style-guide/v1/doc-control/document/revise/FormWidget'
], function(
    FormWidget
) {
    const Form = function(
        availableStatusCollection,
        latestRevisionForDocument,
        nodeForDocument,
        nodePath,
        projectStage,
        disciplineCollection,
        originatorForRevision,
        reviser
    ) {
        this.view = new FormWidget({
            availableStatusCollectionModel: availableStatusCollection,
            latestRevisionForDocumentModel: latestRevisionForDocument,
            nodeForDocumentModel: nodeForDocument,
            nodePathModel: nodePath,
            projectStageModel: projectStage,
            disciplineCollectionModel: disciplineCollection,
            originatorForRevisionModel: originatorForRevision,
            reviserModel: reviser
        });
    };

    Form.prototype.setDocumentPK = function(documentPK) {
        this.view.setDocumentPK(documentPK);
        return this;
    };

    Form.prototype.setTemporaryDocument = function(temporaryDocument) {
        this.view.setTemporaryDocument(temporaryDocument);
        return this;
    };

    Form.prototype.setViewRevisionCallback = function(viewRevisionCallback) {
        this.view.setViewRevisionCallback(viewRevisionCallback);
        return this;
    };

    Form.prototype.setOnSuccessCallback = function(onSuccessCallback) {
        this.view.setOnSuccessCallback(onSuccessCallback);
        return this;
    };

    Form.prototype.setOpenViewerCallback = function(callback) {
        this.view.setOpenViewerCallback(callback);
        return this;
    };

    Form.prototype.setOpenNodeCallback = function(callback) {
        this.view.setOpenNodeCallback(callback);
        return this;
    };

    Form.prototype.setSoftLinkCallback = function(callback) {
        this.view.setSoftLinkCallback(callback);
        return this;
    };

    Form.prototype.reload = function() {
        this.view.reload();
        return this;
    };

    Form.prototype.allowPrivacyChanges = function() {
        this.view.allowPrivacyChanges();
        return this;
    };

    return Form;
});
},
'style-guide/v1/doc-control/document/revise/FormWidget':function(){
define([
    'api/doccontrol/revision/Config',
    'doc-control/config/Regex',
    'dijit/form/FilteringSelect',
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/store/Memory',
    'dojo/text!./template/Form.html',
    'dojo/text!style-guide/v1/doc-control/document/revise/template/FileAlreadyExistsNotification.html',
    'dojo/topic',
    'library/request/data/Form',
    'library/request/data/Handlers',
    'library/request/fetch/Factory',
    'library/request/helper/DefaultUnauthorisedCallback',
    'soso/sosox/ejs/ejs',
    'style-guide/v1/doc-control/document/update-details/FormWidget'
], function(
    DocControlRevisionConfig,
    REGEX,
    FilteringSelect,
    declare,
    domAttr,
    domClass,
    Memory,
    template,
    fileAlreadyExistsTemplate,
    topic,
    FormVO,
    Handlers,
    FetchFactory,
    DefaultUnauthorisedCallback,
    ejs,
    UpdateDetailsFormWidget
) {
    const ERROR_MESSAGE = 'Something went wrong, please try again. If the problem persists please contact support';
    const MAX_FILE_SIZE_BYTES = 262144000;
    const URL_REVISION_NUMBER_INCREMENT = 'api_doc_control_revision_revision_number_increment';
    const NOTIFICATION_UID = 'documentReviseFormPane';

    return declare([UpdateDetailsFormWidget], {
        templateString: template,

        docControlRevisionConfig: null,

        revisionNumberField: null,
        revisionNumberFieldContainer: null,
        revisionNumberFieldValidationMessage: null,

        fileNameFieldContainer: null,
        uploadedFile: null,

        setTitleToFileNameLink: null,

        fileUploadButton: null,
        fileUploadContainer: null,

        temporaryDocumentContainer: null,
        temporaryDocumentName: null,

        postCreate: function() {
            this.inherited(arguments);

            this.docControlRevisionConfig = new DocControlRevisionConfig();
            this.fetchProcessor = new FetchFactory().get();
        },

        render: function() {
            this.inherited(arguments);

            if (this.temporaryDocument) this._showTemporaryDocumentElement();
        },

        validate: function() {
            if (!this.submitButton) {
                return false;
            }

            const valid = this._validateFileUpload() && this._validateRevisionNumberField();

            if (!valid) {
                return false;
            }

            return this.inherited(arguments);
        },

        reset: function() {
            this.uploadedFile = null;
            this.temporaryDocument = null;
            this.inherited(arguments);
        },

        setOpenViewerCallback: function(callback) {
            this.openViewer = callback;
        },

        setOpenNodeCallback: function(callback) {
            this.openNode = callback;
        },

        setSoftLinkCallback: function(callback) {
            this.softLink = callback;
        },

        setTemporaryDocument: function(temporaryDocument) {
            this.temporaryDocument = temporaryDocument;
        },

        _showTemporaryDocumentElement: function() {
            if (this.fileUploadContainer) domClass.add(this.fileUploadContainer, 'hide');
            if (this.fileNameField) this.fileNameField.value = this.temporaryDocument.name;
            if (this.temporaryDocumentContainer) domClass.remove(this.temporaryDocumentContainer, 'hide');
            this.temporaryDocumentName.innerHTML = this.temporaryDocument.name;
        },

        _prepareSubmitData: function() {
            const data = this.inherited(arguments);

            if (this.temporaryDocument) {
                data.temporaryDocumentPK = this.temporaryDocument.temporaryDocumentPK;
            }

            if (this.revisionNumberField) {
                data.revisionNumber = this.revisionNumberField.value;
            }

            data.fileName = this.fileNameField.value;

            return data;
        },

        _prepareSubmitForm: function() {
            if (this.temporaryDocument) return;

            const form = new FormVO();

            form.setId('reviseDocumentForm');
            form.setFileKey('revisionFile');
            form.setFiles([this.uploadedFile]);

            return form;
        },

        _validateRevisionNumberField: function() {
            if (!this.revisionNumberField) {
                return true;
            }

            if (this.data.revision.getRevisionNumber() === this.revisionNumberField.value) {
                domClass.add(this.revisionNumberFieldContainer,'sos-form-textfield-validation-error');
                this.revisionNumberFieldValidationMessage.innerHTML = 'Enter the next revision number';
                return false;
            }

            if (!REGEX.REVISION_NUMBER_VALIDATION.test(this.revisionNumberField.value)) {
                domClass.add(this.revisionNumberFieldContainer,'sos-form-textfield-validation-error');
                this.revisionNumberFieldValidationMessage.innerHTML = 'Revision number is not a valid format';
                return false;
            }

            domClass.remove(this.revisionNumberFieldContainer, 'sos-form-textfield-validation-error');
            return true;
        },

        _validateFileUpload: function() {
            if (this.temporaryDocument) return true;

            if (!this.uploadedFile) {
                if (!domClass.contains(this.fileNameFieldContainer, 'sos-form-textfield-validation-error')) {
                    domClass.add(this.fileNameFieldContainer, 'sos-form-textfield-validation-error');
                }
                return false;
            }

            domClass.remove(this.fileNameFieldContainer, 'sos-form-textfield-validation-error');
            return true;
        },

        _populateRelevantDateField: function() {
            this.relevantDateSelect.set('value', new Date(), false);
        },

        _handleFileUpload: function(e) {
            this.fileNameField.value = '';
            this.uploadedFile = null;

            domAttr.set(this.setTitleToFileNameLink, 'disabled', 'disabled');

            if (e.target.files.length) {
                const file = e.target.files[0];

                if (file.size > MAX_FILE_SIZE_BYTES) {
                    topic.publish(
                        'sos-system-notification',
                        'The requested file was too large. ' +
                        'If you require files larger than 250MB uploading, please contact support.',
                        'error'
                    );
                    e.target.value = null;
                } else {
                    this.uploadedFile = file;
                    domClass.remove(this.fileNameFieldContainer, 'sos-form-textfield-validation-error');
                    this.fileNameField.value = e.target.value.replace(/^.*[\\\/]/, '');
                    domAttr.remove(this.setTitleToFileNameLink, 'disabled');
                }
            }
        },

        _prepareDocumentCardData: function(revision, projectStage, path) {
            return this.cardParser.parse(revision)
                .setShowRegistrationInfo(true)
                .setProjectStage(
                    this.helper.projectStageDisplayName(projectStage)
                )
                .setNodeName(path)
                .setMd5(revision.getMd5())
                .setIsRootNode(true)
                .setStatusDescription(
                    revision.getStatus().getDescription()
                );
        },

        _setTitleToFileName: function() {
            if (this.uploadedFile) {
                this.titleField.value = this.fileNameField.value;
            }
        },

        _populateRevisionNumber: async function(revision) {
            if (this.revisionNumberField) {
                let url = this.docControlRevisionConfig.getUrl(URL_REVISION_NUMBER_INCREMENT, 'v2/');

                this.fetchProcessor.setSuccessHandler(response => response.json());
                this.fetchProcessor.setErrorHandler(() => {
                    topic.publish(
                        'sos-system-notification',
                        ERROR_MESSAGE,
                        'error'
                    );
                });

                this.revisionNumberField.value = (await this.fetchProcessor.get(url.replace(':revisionPK', revision.getRevisionPK())))['revisionNumber'];
            }
        },

        _uploadFile: function() {
            const mouseEvt = document.createEvent('MouseEvents');

            mouseEvt.initEvent("click", true, false);
            this.fileUploadButton.dispatchEvent(mouseEvt);
        },

        _displayFileUploadField: function() {
            domClass.remove(this.fileUploadContainer, 'hide');
            if (this.uploadedFile) {
                domAttr.remove(this.setTitleToFileNameLink, 'disabled');
            } else {
                domAttr.set(this.setTitleToFileNameLink, 'disabled', 'disabled');
            }
        },

        _submit: function() {
            if (!this.validate()) {
                return;
            }

            topic.publish(
                'sos-system-notification-progress',
                'Revising document...',
                NOTIFICATION_UID
            );

            this.reviserModel.revise(
                new Handlers(
                    function success(response) {
                        topic.publish(
                            'sos-system-notification-progress-cancel',
                            NOTIFICATION_UID
                        );

                        this.onSuccess(JSON.parse(response).revisionPK);
                    }.bind(this),
                    function() {},
                    DefaultUnauthorisedCallback,
                    function error(error, description) {
                        topic.publish(
                            'sos-system-notification-progress-cancel',
                            NOTIFICATION_UID
                        );

                        if (error === 'FILE_ALREADY_EXISTS') {
                            const data = {
                                originalTitle: description.originalTitle,
                                location: description.location
                            };

                            topic.publish(
                                'sos-system-notification',
                                ejs.render(fileAlreadyExistsTemplate, data),
                                'error'
                            );

                            document.getElementsByClassName('file-already-exists-original-title')[0].addEventListener('click', function() {
                                this.openViewer(description.revisionPK, description.md5);
                                topic.publish('sos-system-notification-close-all');
                            }.bind(this));

                            document.getElementsByClassName('file-already-exists-location')[0].addEventListener('click', function() {
                                this.openNode(
                                    description.projectStagePK,
                                    description.projectStageTreeViewPK,
                                    description.nodeType
                                );
                                topic.publish('sos-system-notification-close-all');
                            }.bind(this));

                            document.getElementsByClassName('file-already-exists-soft-link')[0].addEventListener('click', function() {
                                this.softLink(description.documentPK);
                                topic.publish('sos-system-notification-close-all');
                            }.bind(this));
                        } else {
                            topic.publish(
                                'sos-system-notification',
                                description,
                                'error'
                            );
                        }
                    }.bind(this)
                ),
                this.documentPK,
                this._prepareSubmitData(),
                this._prepareSubmitForm()
            );
        },

        _determineNavigationVisibility: function() {}
    });
});
},
'soso/sosox/ejs/ejs':function(){
define([
    "dojo/_base/lang",
    "vendor/ejs/ejs",
    "./Helpers"
], function(
    lang,
    ejs,
    Helpers
) {
    return {
        render: function(template, data, customViewHelpers){
            if (data === undefined) {
                data = {};
            }

            if (customViewHelpers === undefined) {
                customViewHelpers = {};
            }

            var helpers = lang.mixin(new Helpers, customViewHelpers);

            return ejs.render(template, lang.mixin(helpers, data));
        }
    };
});
},
'style-guide/v1/doc-control/document/update-details/FormWidget':function(){
define([
    'dijit/_WidgetBase',
    'dijit/form/DateTextBox',
    'dijit/form/FilteringSelect',
    'dojo/_base/declare',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/Evented',
    'dojo/store/Memory',
    'dojo/text!./template/Form.html',
    'dojo/text!style-guide/v1/layout/templates/DocumentCard.html',
    'dojo/topic',
    'library/request/data/Handlers',
    'library/request/helper/DefaultUnauthorisedCallback',
    'soso/dijit/form/api/OrganisationFilteringSelect',
    'soso/dijit/form/api/PeopleFilteringSelect',
    'soso/sosox/ejs/_Templated',
    'soso/sosox/ejs/Helpers',
    'spencer/date-time/Format',
    'style-guide/v1/doc-control/document/update-details/DocumentCard',
    'style-guide/v1/layout/parser/DocumentCard',
], function(
    _WidgetBase,
    DateTextBox,
    FilteringSelect,
    declare,
    domAttr,
    domClass,
    Evented,
    Memory,
    template,
    DocumentCardTemplate,
    topic,
    Handlers,
    DefaultUnauthorisedCallback,
    OrganisationFilterSelect,
    PersonFilterSelect,
    _Templated,
    Helpers,
    DateTimeFormatter,
    DocumentCard,
    DocumentCardParser
) {
    return declare([_WidgetBase, _Templated, Evented], {
        templateString: template,

        documentPK: null,
        data: {
            revision: null,
            node: null
        },
        currentRevisionIndex: null,
        revisionList: [],

        disciplineFilterSelectContainer: null,
        documentCardContainer: null,
        fileNameField: null,
        formContainer: null,
        navigationContainer: null,
        nextButton: null,
        organisationFilterSelectContainer: null,
        personFilterSelectContainer: null,
        previousButton: null,
        referenceField: null,
        relevantDateSelectContainer: null,
        statusFilterSelectContainer: null,
        titleField: null,

        disciplineFilter: null,
        organisationFilter: null,
        personFilter: null,
        relevantDateSelect: null,
        statusFilter: null,

        cardParser: null,
        dateTimeFormatter: null,
        helper: null,

        availableStatusCollectionModel: null,
        disciplineCollectionModel: null,
        latestRevisionCanceller: null,
        latestRevisionForDocumentModel: null,
        nodeForDocumentCanceller: null,
        nodeForDocumentModel: null,
        nodePathCanceller: null,
        nodePathModel: null,
        originatorForRevisionModel: null,
        privacyChangesAllowed: false,
        projectStageCanceller: null,
        projectStageModel: null,
        reviserModel: null,

        postCreate: function() {
            this._createPersonFilter();
            this._createOrganisationFilter();
            this._createRelevantDateSelect();
            this._createDisciplineFilter();
            this._createStatusFilter();

            this.cardParser = new DocumentCardParser(DocumentCardTemplate);
            this.helper = new Helpers();
            this.dateTimeFormatter = new DateTimeFormatter();
        },

        setDocumentPK: function(documentPK) {
            this.documentPK = documentPK;

            if (this.revisionList.length) {
                this.currentRevisionIndex = this.revisionList.findIndex(revision => documentPK === revision.getDocumentPK());
                this._determineNavigationVisibility();
            }

            return this;
        },

        setRevisionList: function(revisionList) {
            this.revisionList = revisionList;
            this.navigationContainer.classList.remove('hide');
            return this;
        },

        cancel: function() {
            this._cancelPreviousRequests();
        },

        reload: function() {
            this.reset();
            this._cancelPreviousRequests();

            if (!this.documentPK) return;

            this.latestRevisionCanceller = this.latestRevisionForDocumentModel.get(
                this._getLatestRevisionHandlers(),
                this.documentPK
            );
        },

        reset: function() {
            this.set('disabled', false);

            this.data = {
                revision: null,
                node: null
            };

            this.personFilter.set('item', null);
            this.organisationFilter.set('item', null);
            this.statusFilter.reset();
            this.disciplineFilter.reset();
            this.relevantDateSelect.reset();

            this.render();
        },

        allowPrivacyChanges: function() {
            this.privacyChangesAllowed = true;
            return this;
        },

        setViewRevisionCallback: function(viewRevisionCallback) {
            this.viewRevision = viewRevisionCallback;
            return this;
        },

        viewRevision: null,

        setOnSubmitCallback: function(onSubmitCallback) {
            this.onSubmit = onSubmitCallback;
            return this;
        },
        onSubmit: function() {},

        setOnSuccessCallback: function(onSuccessCallback) {
            this.onSuccess = onSuccessCallback;
            return this;
        },
        onSuccess: function() {},

        setOnErrorCallback: function(onErrorCallback) {
            this.onError = onErrorCallback;
            return this;
        },
        onError: function() {},

        validate: function() {
            if (!this.submitButton) {
                return false;
            }

            if (!this.titleField.value.trim()) {
                return false;
            }

            if (this.fileNameField && !this.fileNameField.value.trim()) {
                return false;
            }

            if (!this.referenceField.value.trim() && this.referenceField.hasAttribute('required')) {
                return false;
            }

            if (this.disciplineFilterSelectContainer && !this.disciplineFilter.get('value')) {
                return false;
            }

            if (!domClass.contains(this.personFilterSelectContainer, 'hide')) {
                if (!this.personFilter.get('value')) {
                    this.personFilter._hasBeenBlurred = true;
                    this.personFilter.validate();
                    return false;
                }
            }

            if (!domClass.contains(this.organisationFilterSelectContainer, 'hide')) {
                if (!this.organisationFilter.get('value')) {
                    this.organisationFilter._hasBeenBlurred = true;
                    this.organisationFilter.validate();
                    return false;
                }
            }

            if (!this.relevantDateSelect.get('value')) {
                return false;
            }

            return true;
        },

        _setDisabledAttr: function(value) {
            this.inherited(arguments);

            if (this.titleField) this.titleField.disabled = value;
            if (this.fileNameField) this.fileNameField.disabled = value;
            if (this.referenceField) this.referenceField.disabled = value;
            if (this.disciplineFilter) this.disciplineFilter.disabled = value;
            if (this.personFilter) this.personFilter.set('disabled', value);
            if (this.organisationFilter) this.organisationFilter.set('disabled', value);
            if (this.relevantDateSelect) this.relevantDateSelect.set('disabled', value);
            if (this.privateCheckbox) this.privateCheckbox.disabled = value;
            if (this.submitButton) this.submitButton.disabled = value;
        },

        _getProjectStageModelHandlers: function(revision, node, path) {
            return new Handlers(
                function success(projectStage) {
                    this.data.revision = revision;
                    this.data.node = node;
                    this.render(this.data);

                    this._prepareForm(revision, node, path, projectStage);
                }.bind(this),
                function progress() {},
                this._showGenericError.bind(this),
                this._showGenericError.bind(this)
            );
        },

        _getNodePathModelHandlers: function(revision, node) {
            return new Handlers(
                function success(path) {
                    this.projectStageCanceller = this.projectStageModel.get(
                        this._getProjectStageModelHandlers(revision, node, path),
                        node.getProjectStagePK()
                    )
                }.bind(this),
                function progress() {},
                this._showGenericError.bind(this),
                this._showGenericError.bind(this)
            )
        },

        _getNodeForDocumentHandlers: function(revision) {
            return new Handlers(
                function success(node) {
                    this.nodePathCanceller = this.nodePathModel.get(
                        this._getNodePathModelHandlers(revision, node),
                        node
                    )
                }.bind(this),
                function progress() {},
                this._showGenericError.bind(this),
                this._showGenericError.bind(this)
            );
        },

        _getLatestRevisionHandlers: function() {
            return new Handlers(
                function success(revision) {
                    this.nodeForDocumentCanceller = this.nodeForDocumentModel.get(
                        this._getNodeForDocumentHandlers(revision),
                        this.documentPK
                    )
                }.bind(this),
                function progress() {},
                this._showGenericError.bind(this),
                this._showGenericError.bind(this)
            );
        },

        _cancelPreviousRequests: function() {
            this.latestRevisionCanceller && this.latestRevisionCanceller.cancel();
            this.nodeForDocumentCanceller && this.nodeForDocumentCanceller.cancel();
            this.nodePathCanceller && this.nodePathCanceller.cancel();
            this.projectStageCanceller && this.projectStageCanceller.cancel();
        },

        _prepareForm: function(revision, node, path, projectStage) {
            this._createDocumentCard(revision, projectStage, path);

            this.relevantDateSelect.placeAt(this.relevantDateSelectContainer);
            this.personFilter.placeAt(this.personFilterSelectContainer);
            this.organisationFilter.placeAt(this.organisationFilterSelectContainer);
            if (this.statusFilterSelectContainer) {
                this.statusFilter.placeAt(this.statusFilterSelectContainer);
            }

            if (node.getType() === 'Drawing') {
                this.disciplineFilter.placeAt(this.disciplineFilterSelectContainer);
                this.disciplineFilter.set('value', revision.getDisciplinePK(), false);
            }

            this._populateRelevantDateField(revision);
            this._populateOriginatorField(revision);
            this._determineNavigationVisibility();

            if (this.statusFilterSelectContainer) {
                this._populateStatusFilter(revision, node);
            }

            if (this.privacyChangesAllowed) {
                if (domClass.contains(this.privacyToggle, 'hide')) {
                    domClass.remove(this.privacyToggle, 'hide');
                }
            }
        },

        _showGenericError: function() {
            topic.publish(
                'sos-system-notification',
                'Something went wrong. Please contact support.',
                'error'
            );
        },

        _populateRelevantDateField: function(revision) {
            this.relevantDateSelect.set('value', revision.getRevisionDate() || new Date(), false);
        },

        _populateOriginatorField: function(revision) {
            this.originatorForRevisionModel.get(
                new Handlers(
                    function success(originator) {
                        if (originator.getPerson()) {
                            this.personFilter.set('value', originator.getPerson().getPersonPK(), false);
                        }

                        if (!originator.getPerson()) {
                            this._showOrganisationFilterSelect();
                            this.organisationFilter.set('value', originator.getOrganisation().getOrganisationPK(), false);
                        }
                    }.bind(this),
                    function() {},
                    DefaultUnauthorisedCallback,
                    function() {}
                ),
                revision.getRevisionPK()
            );
        },

        _populateStatusFilter: function(revision, node) {
            this.availableStatusCollectionModel.fetch(
                new Handlers(
                    function success(collection) {
                        this.statusFilter.set('disabled', false);

                        this.statusFilter.set('store', new Memory({
                            data: collection,
                            idProperty: 'statusPK'
                        }));

                        this.statusFilter.set('value', revision.getStatus().getStatusPK(), false);
                    }.bind(this),
                    function() {},
                    DefaultUnauthorisedCallback,
                    function() {}
                ),
                node.getProjectStagePK(),
                node.getProjectStageTreeViewPK()
            );
        },

        _submit: function() {
            if (!this.validate()) {
                return;
            }

            this.set('disabled', true);

            const submitData = this._prepareSubmitData();
            const submitForm = this._prepareSubmitForm();

            this.onSubmit();

            this.reviserModel.revise(
                new Handlers(
                    this.onSuccess.bind(this),
                    () => {},
                    DefaultUnauthorisedCallback,
                    (error, description) => {
                        this.set('disabled', false);
                        this.onError(error, description);
                    }
                ),
                this.documentPK,
                submitData,
                submitForm
            );
        },

        _prepareSubmitData: function() {
            let originalExtension = '';

            if (this.data.revision.getRealName()) {
                if (this.data.revision.getRealName().indexOf('.') !== -1) {
                    originalExtension = this.data.revision.getRealName().substring(
                        this.data.revision.getRealName().lastIndexOf('.')
                    );
                }
            }

            const data = {
                title: this.titleField.value,
                reference: this.referenceField.value,
                relevantDate: this.dateTimeFormatter.toLocaleISOString(this.relevantDateSelect.get('value')),
                private: this.privateCheckbox.checked ? 1 : 0
            };

            if (this.fileNameField) {
                data.fileName = this.fileNameField.value + originalExtension;
            }

            if (!domClass.contains(this.personFilterSelectContainer, 'hide')) {
                data.personFromPK = this.personFilter.get('value');
            }

            if (!domClass.contains(this.organisationFilterSelectContainer, 'hide')) {
                data.organisationFromPK = this.organisationFilter.get('value');
            }

            if (this.disciplineFilter) {
                data.disciplinePK = this.disciplineFilter.get('value');
            }

            if (this.statusFilter.get('value')) {
                data.statusPK = this.statusFilter.get('value');
            }

            return data;
        },

        _prepareSubmitForm: function() {},

        _createDocumentCard: function(revision, projectStage, path) {
            const card = this._prepareDocumentCardData(revision, projectStage, path);
            if (this.viewRevision) card.setViewClickCallbackName('viewClick');

            new DocumentCard({
                data: {
                    card: card
                },
                viewClick: this.viewRevision
            }).placeAt(this.documentCardContainer);
        },

        _prepareDocumentCardData: function(revision, projectStage, path) {
            return this.cardParser.parse(revision)
                .setShowRegistrationInfo(true)
                .setProjectStage(
                    this.helper.projectStageDisplayName(projectStage)
                )
                .setNodeName(path)
                .setMd5(revision.getMd5())
                .setIsRootNode(true);
        },

        _createDisciplineFilter: function() {
            this.disciplineFilter = new FilteringSelect({
                required: true,
                placeholder: 'Select Drawing Discipline',
                'class': 'sos-form-filtering-select',
                labelAttr: 'discipline',
                searchAttr: 'discipline',
                pageSize: 10,
                disabled: 'disabled',
                onChange: this.validate.bind(this),
                destroy: function() {},
                destroyRecursive: function() {}
            });

            this._loadDisciplineStore();
        },

        _createStatusFilter: function() {
            this.statusFilter = new FilteringSelect({
                required: true,
                placeholder: 'Select Status',
                'class': 'sos-form-filtering-select',
                labelAttr: 'description',
                searchAttr: 'description',
                pageSize: 10,
                disabled: 'disabled',
                onChange: this.validate.bind(this),
                destroy: function() {},
                destroyRecursive: function() {}
            });
        },

        _createPersonFilter: function() {
            this.personFilter = new PersonFilterSelect({
                autoComplete: false,
                required: true,
                includeLabour: true,
                placeholder: 'Search for a Person...',
                'class': 'sos-form-filtering-select',
                onChange: this.validate.bind(this),
                destroyRecursive: function() {}
            });
        },

        _createOrganisationFilter: function() {
            this.organisationFilter = new OrganisationFilterSelect({
                autoComplete: false,
                required: true,
                'class': 'sos-form-filtering-select',
                placeholder: 'Search for an Organisation...',
                onChange: this.validate.bind(this),
                destroyRecursive: function() {}
            });
        },

        _createRelevantDateSelect: function() {
            this.relevantDateSelect = new DateTextBox({
                'class': 'sos-date-text-box',
                constraints: {
                    'datePattern': 'dd/MM/yyyy'
                },
                placeHolder: 'Select date',
                dropDownPosition: ['below'],
                required: true,
                onChange: this.validate.bind(this),
                destroyRecursive: function() {}
            });
        },

        _loadDisciplineStore: function() {
            const onError = function() {
                topic.publish(
                    'sos-system-notification',
                    'Unable to load available drawing disciplines. Please contact support.',
                    'error'
                );
            };

            this.disciplineCollectionModel.get(
                new Handlers(
                    function success(disciplines) {
                        this.disciplineFilter.set('disabled', false);

                        this.disciplineFilter.set('store', new Memory({
                            data: disciplines,
                            idProperty: 'drawingDisciplinePK'
                        }));
                    }.bind(this),
                    function () {},
                    onError,
                    onError
                )
            );
        },

        _showOrganisationFilterSelect: function() {
            domClass.remove(this.organisationFilterSelectContainer, 'hide');
            domClass.add(this.personFilterSelectContainer, 'hide');
        },

        _showPersonFilterSelect: function() {
            domClass.add(this.organisationFilterSelectContainer, 'hide');
            domClass.remove(this.personFilterSelectContainer, 'hide');
        },

        _determineNavigationVisibility: function() {
            this.navigationContainer.classList.add('hide');
            this.previousButton.classList.add('hide');
            this.nextButton.classList.add('hide');

            if (!this.revisionList.length) {
                return;
            }

            this.navigationContainer.classList.remove('hide');

            if (this.currentRevisionIndex >= 0) {
                if (this.currentRevisionIndex > 0) {
                    this.previousButton.classList.remove('hide');
                }

                if (this.currentRevisionIndex < this.revisionList.length - 1) {
                    this.nextButton.classList.remove('hide');
                }
            }
        },

        _previousDocument: function() {
            if (this.currentRevisionIndex === 0) {
                return;
            }

            --this.currentRevisionIndex;
            this._showCurrentDocument();
            this.emit('documentChange', this.revisionList[this.currentRevisionIndex].getDocumentPK());
        },

        _nextDocument: function() {
            if (this.currentRevisionIndex === this.revisionList.length - 1) {
                return;
            }

            ++this.currentRevisionIndex;
            this._showCurrentDocument();

            this.emit('documentChange', this.revisionList[this.currentRevisionIndex].getDocumentPK());
        },

        _showCurrentDocument: function() {
            this.documentPK = this.revisionList[this.currentRevisionIndex].getDocumentPK();
            this.reload();
            this._determineNavigationVisibility();
        }
    });
});
},
'soso/dijit/form/api/OrganisationFilteringSelect':function(){
define([
    'dojo/_base/declare',
    'dojo/_base/lang',
    'dojo/on',
    'spencer/format/OrganisationDisplayName',
    'soso/dojo/store/JsonRestApi',
    'soso/dijit/form/FilteringSelect',
    'api/organisation/Builder',
    'api/organisation/Config',
    'api/organisation/filter/ExcludeInactive',
    'api/organisation/filter/IntranetOwner',
    'api/organisation/filter/ProjectStage',
    'api/organisation/filter/OrganisationType',
    'api/organisation/sort/Name',
    'spencer/core/data/Organisation',
    'spencer/core/filter/Collection',
    'spencer/core/parser/Organisation',
    'spencer/core/sort/Collection',
    'library/request/URLConnectionBuilder',
    'library/request/URLResponseProcessorBuilder',
    'library/request/data/Handlers',
    'library/request/dojo/URLConnectionProcessorBuilder',
    'library/request/helper/DefaultUnauthorisedCallback'
], function(
    declare,
    lang,
    on,
    Formatter,
    JsonRestApi,
    FilteringSelect,
    OrganisationBuilder,
    OrganisationConfig,
    ExcludeInactiveFilter,
    IntranetOwnerFilter,
    ProjectStageFilter,
    OrganisationTypeFilter,
    NameSort,
    OrganisationVO,
    FilterCollection,
    OrganisationParser,
    SortCollection,
    URLConnectionBuilder,
    URLResponseProcessorBuilder,
    HandlersVO,
    URLConnectionProcessorBuilder,
    DefaultUnauthorisedCallback
) {
    return declare('soso.dijit.form.api.OrganisationFilteringSelect', [FilteringSelect], {
        DEFAULT_PAGE_SIZE: 10,
        DEFAULT_QUERY_EXPR: '*${0}*',

        configFile: null,
        labelFunction: null,
        pageSize: null,
        onChangeCallBack: null,
        onSearchCallBack: null,
        organisationBuilder: null,
        organisationPK: null,
        searchAttr: null,
        sortByName: false,
        store: null,
        useLabelFunctionForItem: true,
        queryExpr: null,
        excludeInactive: false,
        excludeIntranetOwners: false,
        includeOnlyIntranetOwners: false,
        organisationType: null,
        projectStage: null,

        postMixInProperties: function() {
            this.configFile = this.configFile || new OrganisationConfig();
            this.pageSize = parseInt(this.pageSize) || this.DEFAULT_PAGE_SIZE;
            this.labelFunc = this.labelFunction || lang.hitch(this, '_formatOrganisation');
            this.useLabelFunctionForItem = true;
            this.queryExpr = this.queryExpr || this.DEFAULT_QUERY_EXPR;

            this._createOrganisationBuilder();

            if (!this.store) {
                this._createStore();
            }

            this.searchAttr = this.searchAttr || this.store.searchAttr;

            this.inherited(arguments);
        },

        postCreate: function() {
            this.inherited(arguments);

            on(this, 'change', lang.hitch(this, function() {
                if (typeof this.onChangeCallBack === 'function') {
                    this.onChangeCallBack(this.get('item'));
                }
            }));

            on(this, 'search', lang.hitch(this, function() {
                if (typeof this.onSearchCallBack === 'function') {
                    this.onSearchCallBack(this.get('item'));
                }
            }));
        },

        setOrganisationVO: function (organisationVO, triggerOnChange) {
            this.set('item', organisationVO, triggerOnChange);
        },

        reset: function() {
            this.inherited(arguments);

            this.set('value', null);
            this.set('item', null);
        },

        _createOrganisationBuilder: function() {
            this.organisationBuilder = new OrganisationBuilder(
                this.configFile,
                new URLConnectionBuilder(
                    new URLConnectionProcessorBuilder()
                ),
                new URLResponseProcessorBuilder()
            );
        },

        _createStore: function () {
            this.set('store', this._createOrganisationStore());
        },

        _formatOrganisation: function (item) {
            if (item === null || item === undefined) {
                return '';
            }

            var formatter = new Formatter();
            formatter.setPreferredName(item.preferredName || null);
            formatter.setName(item.name || null);
            return formatter.format();
        },

        _createHandlersVO: function () {
            return new HandlersVO(
                null,
                null,
                DefaultUnauthorisedCallback,
                function (error, description) {
                    console.log(error);
                    console.log(description);
                }
            )
        },

        _createOrganisationStore: function () {
            var ovo = new OrganisationVO();
            ovo.setOrganisationPK(this.organisationPK);

            return new JsonRestApi({
                idProperty: 'organisationPK',
                searchAttr: 'name',
                resultParser: new OrganisationParser(),
                getModel: this.organisationBuilder.getOrganisation(),
                getFunction: 'get',
                getFunctionArgsCreator: lang.hitch(this, function (id) {
                    var ovo = new OrganisationVO;
                    ovo.setOrganisationPK(id);

                    return [
                        this._createHandlersVO(),
                        ovo
                    ];
                }),
                queryModel: this.organisationBuilder.getOrganisationCollection(),
                queryFunction: 'fetch',
                queryFunctionArgsCreator: this._buildQuery.bind(this)
            });
        },

        _buildQuery: function(query, options) {
            const fc = this._buildFilterCollection();
            const sc = new SortCollection();

            if (this.sortByName) {
                sc.addSort(new NameSort().ascending());
            }

            return [this._createHandlersVO(), fc, sc];
        },

        _buildFilterCollection: function() {
            const fc = new FilterCollection();

            if (this.excludeIntranetOwners) {
                fc.addFilter(new IntranetOwnerFilter().excludeIntranetOwners());
            } else if (this.includeOnlyIntranetOwners) {
                fc.addFilter(new IntranetOwnerFilter().includeOnlyIntranetOwners());
            }

            if (this.excludeInactive) {
                fc.addFilter(new ExcludeInactiveFilter());
            }

            if (this.organisationType) {
                fc.addFilter(new OrganisationTypeFilter().setOrganisationTypeName(this.organisationType));
            }

            if (this.projectStage) {
                fc.addFilter(new ProjectStageFilter().setProjectStagePK(this.projectStage));
            }

            return fc;
        }
    });
});
},
'api/organisation/Builder':function(){
define([
    './Factory',
    'library/request/fetch/Factory'
], function(Factory, FetchFactory) {
    /**
     * Deprecated use Factory instead.
     */
    var Builder = function(config, urlConnectionBuilder, urlResponseProcessorBuilder) {
        this.factory = new Factory(
            config,
            new FetchFactory(),
            urlConnectionBuilder,
            urlResponseProcessorBuilder
        );
    };

    Builder.prototype.getOrganisationCollection = function() {
        return this.factory.getOrganisationCollection();
    };

    Builder.prototype.getOrganisation = function() {
        return this.factory.getOrganisation();
    };

    Builder.prototype.getOrganisationTypeCollection = function() {
        return this.factory.getOrganisationTypeCollection();
    };

    return Builder;
});
},
'spencer/core/sort/Collection':function(){
define([], function() {
    const Collection = function() {
        this.sorts = [];
    };

    Collection.prototype.addSort = function(sort) {
        this.sorts.push(sort);
        return this;
    };

    Collection.prototype.getSorts = function() {
        return this.sorts;
    };

    Collection.prototype.hasSortForClass = function(constructor) {
        for (let i in this.sorts) {
            if (this.sorts.hasOwnProperty(i)) {
                if (this.sorts[i] instanceof constructor) {
                    return true;
                }
            }
        }

        return false;
    };

    Collection.prototype.getSortByClass = function(constructor) {
        for (let i in this.sorts) {
            if (this.sorts.hasOwnProperty(i)) {
                if (this.sorts[i] instanceof constructor) {
                    return this.sorts[i];
                }
            }
        }

        return null;
    };

    return Collection;
});
},
'style-guide/v1/doc-control/document/update-details/DocumentCard':function(){
define([
    'dojo/_base/declare',
    'dijit/_WidgetBase',
    'soso/sosox/ejs/_Templated',
    'dojo/text!./template/DocumentCard.html'
], function(
    declare,
    WidgetBase,
    Templated,
    template
) {
    return declare([WidgetBase, Templated], {
        templateString: template,

        data: {},

        viewClick: null
    });
});
},
'doccontrol/viewer/dojo/InitialisingScreen':function(){
/// <amd-dependency path="dojo/text!./template/InitialisingScreen.html" name="template" />
/// <amd-dependency path="soso/sosox/ejs/_Templated" name="_Templated" />
define(["require", "exports", "dojo/text!./template/InitialisingScreen.html", "soso/sosox/ejs/_Templated", "dijit/_WidgetBase", "dojo/_base/declare"], function (require, exports, template, _Templated, _WidgetBase, declare) {
    "use strict";
    class InitialisingScreen {
        constructor(onCancelClick, inline = false, screenWidthPercentage) {
            const View = this.getView(inline, screenWidthPercentage);
            const element = document.createElement('div');
            document.body.appendChild(element);
            this.view = new View({ onCancelClick: onCancelClick }, element);
        }
        destroy() {
            document.body.removeChild(this.view.domNode);
            this.view.destroy();
        }
        getView(inline, screenWidthPercentage) {
            return declare([_WidgetBase, _Templated], {
                data: {
                    inline: inline,
                    width: screenWidthPercentage
                },
                templateString: template,
                onCancelClick: null,
                _onCancelClick: function () {
                    if (this.onCancelClick)
                        this.onCancelClick();
                }
            });
        }
    }
    return InitialisingScreen;
});

},
'doccontrol/viewer/model/Viewer':function(){
define([
    'library/request/data/Handlers',
    'library/request/helper/DefaultUnauthorisedCallback'
], function(
    HandlersVO,
    DefaultUnauthorisedCallback
) {
    var Viewer = function(docControlBuilder, pdfFetcher, fileDownloader, MetaDataCollection) {
        this.revision = docControlBuilder.getRevision();
        this.documentDetails = docControlBuilder.getDocumentDetails();
        this.documentRevisionCollection = docControlBuilder.getDocumentRevisionCollection();
        this.revisionTransmittalCollection = docControlBuilder.getRevisionTransmittalCollection();
        this.linkedRevisionCollection = docControlBuilder.getLinkedRevisionCollection();
        this.temporaryDocument = docControlBuilder.getTemporaryDocument();
        this.correspondence = docControlBuilder.getCorrespondence();
        this.temporaryDocumentCorrespondence = docControlBuilder.getTemporaryDocumentCorrespondence();
        this.softLinkCollection = docControlBuilder.getSoftLinkCollection();
        this.softLinkEventCollection = docControlBuilder.getSoftLinkEventCollection();
        this.moveCollection = docControlBuilder.getMoveCollection();
        this.noteCollection = docControlBuilder.getNoteCollection();
        this.revisionAccessLog = docControlBuilder.getRevisionAccessLog();
        this.revisionRegistrationLocation = docControlBuilder.getRevisionRegistrationLocation();
        this.revisionTreeNodeCollectionParser = docControlBuilder.getRevisionTreeNodeCollectionParser();
        this.pdfFetcher = pdfFetcher;
        this.fileDownloader = fileDownloader;
        this.metaDataCollection = MetaDataCollection;

        this.requestPromises = [];
        this.documentLoadingTask = null;

        this.constants = {
            PASSWORD_RESPONSES: pdfFetcher.constants.PASSWORD_RESPONSES
        };
    };

    Viewer.prototype.logView = function(revisionVO) {
        this.revisionAccessLog.logView(
            new HandlersVO(
                function success() {},
                function progress() {},
                DefaultUnauthorisedCallback
            ),
            revisionVO
        );
    };

    Viewer.prototype.logDownload = function(revisionVO) {
        this.revisionAccessLog.logDownload(
            new HandlersVO(
                function success() {},
                function progress() {},
                DefaultUnauthorisedCallback
            ),
            revisionVO
        );
    };

    Viewer.prototype.getRevision = function(handlers, revisionVO) {
        this.requestPromises.push(this.revision.get(handlers, revisionVO));
    };

    Viewer.prototype.getDocumentRevisionCollection = function(handlers, revisionVO) {
        this.requestPromises.push(this.documentRevisionCollection.fetch(handlers, revisionVO));
    };

    Viewer.prototype.getTransmittalCollection = function(handlers, revisionVO) {
        this.requestPromises.push(this.revisionTransmittalCollection.fetch(handlers, revisionVO));
    };

    Viewer.prototype.getLinkedRevisionCollection = function(handlers, revisionVO) {
        this.requestPromises.push(this.linkedRevisionCollection.fetch(handlers, revisionVO));
    };

    Viewer.prototype.getAccessLogCollection = function(handlers, revisionVO) {
        this.requestPromises.push(this.revisionAccessLog.fetch(handlers, revisionVO));
    };

    Viewer.prototype.getSoftLinkCollection = function(handlers, documentPK) {
        this.requestPromises.push(this.softLinkCollection.get(handlers, documentPK));
    };

    Viewer.prototype.getSoftLinkEventCollection = function(handlers, documentPK) {
        this.requestPromises.push(this.softLinkEventCollection.get(handlers, documentPK));
    };

    Viewer.prototype.getMoveCollection = function(handlers, documentPK) {
        this.requestPromises.push(this.moveCollection.get(handlers, documentPK));
    };

    Viewer.prototype.getNoteCollection = function(handlers, documentPK) {
        this.requestPromises.push(this.noteCollection.get(handlers, documentPK));
    };

    Viewer.prototype.getCorrespondence = function(handlers, revisionVO) {
        this.requestPromises.push(this.correspondence.get(handlers, revisionVO));
    };

    Viewer.prototype.getTemporaryDocumentCorrespondence = function(handlers, temporaryDocument) {
        this.requestPromises.push(this.temporaryDocumentCorrespondence.get(handlers, temporaryDocument));
    };

    Viewer.prototype.getTemporaryDocument = function(handlers, temporaryDocumentVO) {
        this.requestPromises.push(this.temporaryDocument.get(handlers, temporaryDocumentVO));
    };

    Viewer.prototype.getPdf = function(handlers, href) {
        this.documentLoadingTask = this.pdfFetcher.get(handlers, href);
    };

    Viewer.prototype.getRevisionRegistrationLocationCollection = function(handlers, revisionCollection) {
        this.requestPromises.push(this.revisionRegistrationLocation.fetch(handlers, revisionCollection));
    };

    Viewer.prototype.getRevisionTreeNodeCollection = function(revisionCollection, treeNodeCollection) {
        return this.revisionTreeNodeCollectionParser.parse(revisionCollection, treeNodeCollection);
    };

    Viewer.prototype.cancelAllRequests = function() {
        this.requestPromises.forEach(function(promise) {
            promise.cancel();
        });
        this.requestPromises = [];

        this.documentLoadingTask?.destroy?.();
    };

    Viewer.prototype.cancelGetDocument = function() {
        this.documentLoadingTask?.cancel?.();
    };

    Viewer.prototype.getFile = function(handlers, href) {
        this.documentLoadingTask = this.fileDownloader.download(handlers, href);
        this.requestPromises.push(this.documentLoadingTask);
    };

    Viewer.prototype.getDocumentDetails = function(handlers, md5) {
        this.requestPromises.push(this.documentDetails.get(handlers, md5))
    };

    Viewer.prototype.getRevisionMetaData = function(handlers, md5) {
        this.requestPromises.push(this.metaDataCollection.get(handlers, md5))
    };

    return Viewer;
});
},
'doccontrol/viewer/model/Annotation':function(){
define(['../socket/Events'], function(SocketEvents) {
    const Annotation = function(
        socket,
        annotationGenerator,
        printableAnnotationGenerator,
        annotatedTemporaryDocumentCreator
    ) {
        this.socket = socket;
        this.annotationGenerator = annotationGenerator;
        this.printableAnnotationGenerator = printableAnnotationGenerator;
        this.annotatedTemporaryDocumentCreator = annotatedTemporaryDocumentCreator;
        this.connectedUsers = [];

        this.generationRequest = null;

        this.roomName = null;
    };

    Annotation.prototype.joinRoom = function(room) {
        this.roomName = room;
        try {
            this.socket.send(SocketEvents.DOCUMENT_ANNOTATION_JOIN, room);
        } catch (e) {
            console.error(e);
        }
    };

    Annotation.prototype.disconnect = function() {
        if (this.roomName) {
            try {
                this.socket.send(SocketEvents.DOCUMENT_ANNOTATION_LEAVE, this.roomName);
            } catch (e) {
                console.error(e);
            }
        }
        this.roomName = null;
    };

    Annotation.prototype.sendAnnotation = function(annotation) {
        try {
            this.socket.send(SocketEvents.DOCUMENT_ANNOTATION_ADD, annotation);
        } catch (e) {
            console.error(e);
        }
    };

    Annotation.prototype.sendModifiedAnnotation = function(annotation) {
        try {
            this.socket.send(SocketEvents.DOCUMENT_ANNOTATION_MODIFY, annotation);
        } catch (e) {
            console.error(e);
        }
    };

    Annotation.prototype.deleteAnnotation = function(annotation) {
        try {
            this.socket.send(SocketEvents.DOCUMENT_ANNOTATION_DELETE, annotation);
        } catch (e) {
            console.error(e);
        }
    };

    Annotation.prototype.clearAllAnnotations = function(data) {
        try {
            this.socket.send(SocketEvents.DOCUMENT_ANNOTATION_CLEAR_ALL, data);
        } catch (e) {
            console.error(e);
        }
    };

    Annotation.prototype.connect = function() {
        return this.socket.open();
    };

    Annotation.prototype.generate = function(handlers, md5, annotations, pins) {
        this.generationRequest = this.annotationGenerator.generate(handlers, md5, annotations, pins);
    };

    Annotation.prototype.generatePrintable = function(handlers, md5, annotations, pins) {
        this.generationRequest = this.printableAnnotationGenerator.generate(handlers, md5, annotations, pins);
    };

    Annotation.prototype.generateTemporaryDocument = function(handlers, md5, annotations, pins) {
        this.generationRequest = this.annotatedTemporaryDocumentCreator.generate(handlers, md5, annotations, pins);
    };

    Annotation.prototype.setConnectedUsers = function(userCollection) {
        this.connectedUsers = userCollection;
    };

    Annotation.prototype.addConnectedUser = function(user) {
        let exists = false;
        for (let i = 0; i < this.connectedUsers.length; i++) {
            if (this.connectedUsers[i].personPK === user.personPK) {
                exists = true;
                break;
            }
        }

        if (!exists) {
            this.connectedUsers.push(user);
        }
    };

    Annotation.prototype.removeConnectedUser = function(user) {
        for (let i = 0; i < this.connectedUsers.length; i++) {
            if (this.connectedUsers[i].personPK === user.personPK) {
                this.connectedUsers.splice(i, 1);
                return;
            }
        }
    };

    Annotation.prototype.getConnectedUsers = function() {
       return this.connectedUsers;
    };

    Annotation.prototype.cancelRequests = function() {
        if (this.generationRequest) {
            this.generationRequest.cancel();
            this.generationRequest = null;
        }
    };

    Annotation.prototype.cancelRequestsAndDisconnect = function() {
        this.disconnect();
        this.cancelRequests();
    };

    Annotation.prototype.getUsersFromRoom = function(room) {
        let users = [];

        let pageCollection = room.pageCollection;
        for (let i = 0; i < pageCollection.length; i++) {
            let annotationStack = pageCollection[i].annotations;
            for (let j = 0; j < annotationStack.length; j++) {
                if (!annotationStack[j].hasOwnProperty('user')) {
                    break;
                }

                if (!users.some(function(user) { return user.personPK === annotationStack[j].user.personPK; })) {
                    users.push(annotationStack[j].user);
                }
            }
        }

        return users;
    };

    return Annotation;
});
},
'doccontrol/viewer/socket/Events':function(){
define([], function() {
    return {
        DOCUMENT_ANNOTATION_ADD: "/document/annotation/add",
        DOCUMENT_ANNOTATION_DELETE: "/document/annotation/delete",
        DOCUMENT_ANNOTATION_CLEAR_ALL: "/document/annotation/clear-all",
        DOCUMENT_ANNOTATION_JOIN: "/document/annotation/join",
        DOCUMENT_ANNOTATION_LEAVE: "/document/annotation/leave",
        DOCUMENT_ANNOTATION_MODIFY: "/document/annotation/modify",
        DOCUMENT_ANNOTATION_USERS_SET: "/document/annotation/users/set",
        DOCUMENT_ANNOTATION_USER_CONNECT: "/document/annotation/user/connect",
        DOCUMENT_ANNOTATION_USER_DISCONNECT: "/document/annotation/user/disconnect"
    };
});
},
'doccontrol/viewer/model/Information':function(){
define([
    '../Topics',
    'library/request/data/Handlers',
    'library/request/helper/DefaultUnauthorisedCallback'
], function(
    Topics,
    HandlersVO,
    DefaultUnauthorisedCallback
) {
    return class Information {
        constructor(topic) {
            this.topic = topic;
            this.viewerWidget = null;
            this.viewerModel = null;
        }

        setViewerWidget(viewerWidget) {
            this.viewerWidget = viewerWidget;
            return this;
        }

        setViewerModel(viewerModel) {
            this.viewerModel = viewerModel;
            return this;
        }

        setRevision(revision) {
            this.revision = revision;
            return this;
        }

        populate(onSuccess) {
            return Promise.allSettled([
                this._getMetaDataCollection(),
                this._getAccessLogCollection(),
                this._getDocumentRevisionCollection(),
                this._getSoftLinkCollection(),
                this._getSoftLinkEventCollection(),
                this._getTransmittalCollection(),
                this._getMoveCollection(),
                this._getLinkedRevisionCollection(),
                this._getNoteCollection()
            ]).then(onSuccess).catch(this._getUnauthorisedHandler.bind(this));
        }

        _getUnauthorisedHandler(e) {
            console.error(e);
            this.topic.publish(Topics.DOCUMENT_VIEWER_DISABLE_INFORMATION_DOWNLOAD);
        }

        _getAccessLogCollection() {
            return new Promise((resolve, reject) => {
                this.viewerModel.getAccessLogCollection(
                    new HandlersVO(
                        function(accessLogCollection) {
                            this.viewerWidget.getInformation().setAccessLogs(accessLogCollection);
                            resolve();
                        }.bind(this),
                        function() {},
                        reject,
                        function() {},
                        function() {}
                    ),
                    this.revision
                );
            });
        }

        _getDocumentRevisionCollection() {
            return new Promise((resolve, reject) => {
                this.viewerModel.getDocumentRevisionCollection(
                    new HandlersVO(
                        function (documentRevisionCollection) {
                            this.viewerWidget.getInformation().setDocumentRevisionCollection(documentRevisionCollection);
                            if (this.viewerWidget.supportsRevisionSidebar()) {
                                this.topic.publish(Topics.DOCUMENT_VIEWER_SHOW_REVISION_SIDEBAR, documentRevisionCollection, this.revision);
                            }
                            resolve();
                        }.bind(this),
                        function() {},
                        reject,
                        function() {},
                        function() {}
                    ),
                    this.revision
                );
            });
        }

        _getSoftLinkCollection() {
            return new Promise((resolve, reject) => {
                this.viewerModel.getSoftLinkCollection(
                    new HandlersVO(
                        function(softLinkCollection) {
                            this.viewerWidget.getInformation().setSoftLinkCollection(softLinkCollection);
                            resolve();
                        }.bind(this),
                        function() {},
                        reject,
                        function() {},
                        function() {}
                    ),
                    this.revision.getDocumentPK()
                );
            });
        }

        _getSoftLinkEventCollection() {
            return new Promise((resolve, reject) => {
                this.viewerModel.getSoftLinkEventCollection(
                    new HandlersVO(
                        function(softLinkEventCollection) {
                            this.viewerWidget.getInformation().setSoftLinkEventCollection(softLinkEventCollection);
                            resolve();
                        }.bind(this),
                        function() {},
                        reject,
                        function() {},
                        function() {}
                    ),
                    this.revision.getDocumentPK()
                );
            });
        }

        _getTransmittalCollection() {
            return new Promise((resolve, reject) => {
                this.viewerModel.getTransmittalCollection(
                    new HandlersVO(
                        function(transmittalCollection) {
                            this.viewerWidget.getInformation().setTransmittalCollection(transmittalCollection);
                            resolve();
                        }.bind(this),
                        function() {},
                        reject,
                        function() {},
                        function() {}
                    ),
                    this.revision
                );
            });
        }

        _getMoveCollection() {
            return new Promise((resolve, reject) => {
                this.viewerModel.getMoveCollection(
                    new HandlersVO(
                        function(moveCollection) {
                            this.viewerWidget.getInformation().setMoveCollection(moveCollection);
                            resolve();
                        }.bind(this),
                        function() {},
                        reject,
                        function() {},
                        function() {}
                    ),
                    this.revision.getDocumentPK()
                );
            });
        }

        _getLinkedRevisionCollection() {
            return new Promise((resolve, reject) => {
                return this.viewerModel.getLinkedRevisionCollection(
                    new HandlersVO(
                        function(linkedRevisionCollection) {
                            if (linkedRevisionCollection.length > 0) {
                                this.viewerModel.getRevisionRegistrationLocationCollection(
                                    new HandlersVO(
                                        function(locationCollection) {
                                            this.viewerWidget.getInformation().setLinkedRevisionTreeNodeCollection(
                                                this.viewerModel.getRevisionTreeNodeCollection(
                                                    linkedRevisionCollection,
                                                    locationCollection
                                                )
                                            );

                                            resolve();
                                        }.bind(this),
                                        function() {},
                                        DefaultUnauthorisedCallback,
                                        function() {},
                                        function() {}
                                    ),
                                    linkedRevisionCollection
                                );
                            } else {
                                this.viewerWidget.getInformation().setLinkedRevisionTreeNodeCollection([]);
                                resolve();
                            }
                        }.bind(this),
                        function() {},
                        reject,
                        function() {},
                        function() {}
                    ),
                    this.revision
                );
            });
        }

        _getNoteCollection() {
            return new Promise((resolve, reject) => {
                this.viewerModel.getNoteCollection(
                    new HandlersVO(
                        function(noteCollection) {
                            this.viewerWidget.getInformation().setNoteCollection(noteCollection);
                            resolve();
                        }.bind(this),
                        function() {},
                        reject,
                        function() {},
                        function() {}
                    ),
                    this.revision.getDocumentPK()
                );
            });
        }

        _getMetaDataCollection() {
            return new Promise((resolve, reject) => {
                this.viewerModel.getRevisionMetaData(
                    new HandlersVO(
                        function success(metaData) {
                            this.viewerWidget.getInformation().setMetaDataCollection(metaData);
                            resolve();
                        }.bind(this),
                        function progress() {},
                        reject,
                        function error() {},
                        function abort() {}
                    ), this.revision.getMd5()
                )
            });
        }
    };
});
},
'doccontrol/viewer/observable/Container':function(){
define([
    './PageData',
    './ConnectedUsers'
], function(
    PageData,
    ConnectedUsers
) {
    var Container = function(ObservableWrapper) {
        this.constants = {
            PAGE_DATA: 'page-data',
            CONNECTED_USERS: 'connected-users'
        };

        this.supportedObservables = {};
        this.supportedObservables[this.constants.PAGE_DATA] = new PageData(ObservableWrapper);
        this.supportedObservables[this.constants.CONNECTED_USERS] = new ConnectedUsers(ObservableWrapper);
    };

    Container.prototype.has = function(name) {
        return this.supportedObservables[name] !== undefined;
    };

    Container.prototype.get = function(name) {
        if (!this.has(name)) {
            throw new Error('No observable exists named "' + name + '"');
        }

        return this.supportedObservables[name];
    };

    return Container;
});
},
'doccontrol/viewer/observable/PageData':function(){
define(["require", "exports", "library/Observable"], function (require, exports, Observable) {
    "use strict";
    class PageData extends Observable {
        constructor() {
            super(...arguments);
            this.name = 'PageData';
        }
    }
    return PageData;
});

},
'library/Observable':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class Observable {
        constructor(wrapper) {
            this.wrapper = wrapper;
        }
        get() {
            return this.wrapper.get(this.name);
        }
        set(value) {
            this.wrapper.set(this.name, value);
        }
        addObserver(callback) {
            return this.wrapper.observe(this.name, callback);
        }
    }
    return Observable;
});

},
'doccontrol/viewer/observable/ConnectedUsers':function(){
define(["require", "exports", "library/Observable"], function (require, exports, Observable) {
    "use strict";
    class ConnectedUsers extends Observable {
        constructor() {
            super(...arguments);
            this.name = 'ConnectedUsers';
        }
    }
    return ConnectedUsers;
});

},
'doccontrol/viewer/state-machine/Factory':function(){
define([
    './JavascriptStateMachine',
    './JavascriptStateMachineConfig',
    './state-handler/Container',
    './state-handler/View',
    './state-handler/MediaView',
    './state-handler/CorrespondenceView',
    './state-handler/AnnotationModeDrag',
    './state-handler/AnnotationModeFreehand',
    './state-handler/AnnotationModeHighlight',
    './state-handler/AnnotationModeLine',
    './state-handler/AnnotationModeSelect',
    './state-handler/AnnotationModeEllipse',
    './state-handler/AnnotationModeRectangle',
    './state-handler/AnnotationModeHexagon',
    './state-handler/AnnotationModePolygon',
    './state-handler/AnnotationModeHighlightRegion',
    './state-handler/AnnotationModeArrow',
    './state-handler/AnnotationModeText',
    './state-handler/AnnotationModePin',
    './transition-handler/ViewAnnotationOptionsShow',
    './transition-handler/Container',
    './transition-handler/ViewShow',
    './transition-handler/MediaViewShow',
    './transition-handler/CorrespondenceViewShow'
], function(
    StateMachine,
    StateMachineConfig,
    StateHandlerContainer,
    StateHandlerView,
    StateHandlerMediaView,
    StateHandlerCorrespondenceView,
    StateHandlerAnnotationModeDrag,
    StateHandlerAnnotationModeFreehand,
    StateHandlerAnnotationModeHighlight,
    StateHandlerAnnotationModeLine,
    StateHandlerAnnotationModeSelect,
    StateHandlerAnnotationModeEllipse,
    StateHandlerAnnotationModeRectangle,
    StateHandlerAnnotationModeHexagon,
    StateHandlerAnnotationModePolygon,
    StateHandlerAnnotationModeHighlightRegion,
    StateHandlerAnnotationModeArrow,
    StateHandlerAnnotationModeText,
    StateHandlerAnnotationModePin,
    TransitionHandlerViewAnnotationOptionsShow,
    TransitionHandlerContainer,
    TransitionHandlerViewShow,
    TransitionHandlerMediaViewShow,
    TransitionHandlerCorrespondenceViewShow
) {
    var Factory = function(
        containerWidget,
        viewerModel,
        annotationModel,
        informationModel
    ) {
        this.containerWidget = containerWidget;
        this.viewerModel = viewerModel;
        this.annotationModel = annotationModel;
        this.informationModel = informationModel;

        this._getStateHandlerContainer = function() {
            return new StateHandlerContainer(
                this._getViewStateHandler(),
                this._getMediaViewStateHandler(),
                this._getCorrespondenceViewStateHandler(),
                this._getAnnotationModeDragStateHandler(),
                this._getAnnotationModeFreehandStateHandler(),
                this._getAnnotationModeHighlightStateHandler(),
                this._getAnnotationModeLineStateHandler(),
                this._getAnnotationModeSelectStateHandler(),
                this._getAnnotationModeEllipseStateHandler(),
                this._getAnnotationModeRectangleStateHandler(),
                this._getAnnotationModeHexagonStateHandler(),
                this._getAnnotationModePolygonStateHandler(),
                this._getAnnotationModeHighlightRegionStateHandler(),
                this._getAnnotationModeArrowStateHandler(),
                this._getAnnotationModeTextStateHandler(),
                this._getAnnotationModePinStateHandler()
            );
        };

        this._getTransitionHandlerContainer = function() {
            return new TransitionHandlerContainer(
                this._getViewAnnotationOptionsShowTransitionHandler(),
                this._getViewShowTransitionHandler(),
                this._getMediaViewShowTransitionHandler(),
                this._getCorrespondenceViewShowTransitionHandler()
            );
        };

        this._getViewAnnotationOptionsShowTransitionHandler = function() {
            return new TransitionHandlerViewAnnotationOptionsShow(this.containerWidget);
        };

        this._getViewShowTransitionHandler = function() {
            return new TransitionHandlerViewShow(
                this.containerWidget,
                this.viewerModel,
                this.annotationModel,
                this.informationModel
            );
        };

        this._getMediaViewShowTransitionHandler = function() {
            return new TransitionHandlerMediaViewShow(
                this.containerWidget,
                this.viewerModel,
                this.informationModel
            );
        };

        this._getCorrespondenceViewShowTransitionHandler = function() {
            return new TransitionHandlerCorrespondenceViewShow(
                this.containerWidget,
                this.viewerModel,
                this.informationModel
            );
        };

        this._getViewStateHandler = function() {
            return new StateHandlerView(
                this.containerWidget
            );
        };

        this._getMediaViewStateHandler = function() {
            return new StateHandlerMediaView(
                this.containerWidget
            );
        };

        this._getCorrespondenceViewStateHandler = function() {
            return new StateHandlerCorrespondenceView(
                this.containerWidget
            );
        };

        this._getAnnotationModeDragStateHandler = function() {
            return new StateHandlerAnnotationModeDrag(
                this.containerWidget
            );
        };

        this._getAnnotationModeFreehandStateHandler = function() {
            return new StateHandlerAnnotationModeFreehand(
                this.containerWidget
            );
        };

        this._getAnnotationModeHighlightStateHandler = function() {
            return new StateHandlerAnnotationModeHighlight(
                this.containerWidget
            );
        };

        this._getAnnotationModeLineStateHandler = function() {
            return new StateHandlerAnnotationModeLine(
                this.containerWidget
            );
        };

        this._getAnnotationModeSelectStateHandler = function() {
            return new StateHandlerAnnotationModeSelect(
                this.containerWidget
            );
        };

        this._getAnnotationModeEllipseStateHandler = function() {
            return new StateHandlerAnnotationModeEllipse(
                this.containerWidget
            );
        };

        this._getAnnotationModeRectangleStateHandler = function() {
            return new StateHandlerAnnotationModeRectangle(
                this.containerWidget
            );
        };

        this._getAnnotationModeHexagonStateHandler = function() {
            return new StateHandlerAnnotationModeHexagon(
                this.containerWidget
            );
        };

        this._getAnnotationModePolygonStateHandler = function() {
            return new StateHandlerAnnotationModePolygon(
                this.containerWidget
            );
        };

        this._getAnnotationModeHighlightRegionStateHandler = function() {
            return new StateHandlerAnnotationModeHighlightRegion(
                this.containerWidget
            );
        };

        this._getAnnotationModeArrowStateHandler = function() {
            return new StateHandlerAnnotationModeArrow(
                this.containerWidget
            );
        };

        this._getAnnotationModeTextStateHandler = function() {
            return new StateHandlerAnnotationModeText(
                this.containerWidget
            );
        };

        this._getAnnotationModePinStateHandler = function() {
            return new StateHandlerAnnotationModePin(
                this.containerWidget
            );
        };
    };

    Factory.prototype.getStateMachine = function() {
        return new StateMachine(
            new StateMachineConfig(
                this._getStateHandlerContainer(),
                this._getTransitionHandlerContainer()
            )
        );
    };

    return Factory;
});
},
'doccontrol/viewer/state-machine/JavascriptStateMachine':function(){
define([
    'vendor/javascript-state-machine/dist/state-machine'
], function(StateMachine) {
    var JavascriptStateMachine = function(config) {
        this.base = StateMachine;
        this.base(config);
    };

    JavascriptStateMachine.prototype = Object.create(StateMachine.prototype);

    JavascriptStateMachine.prototype.getCurrentState = function() {
        return this.state;
    };

    return JavascriptStateMachine;
});
},
'doccontrol/viewer/state-machine/JavascriptStateMachineConfig':function(){
define([
    './States',
    './Transitions',
    'spencer/utility/Binder',
    'doccontrol/viewer/config/Modes'
], function (
    States,
    Transitions,
    Binder,
    MODES
) {
   var JavascriptStateMachineConfig = function(
       stateContainer,
       transitionContainer
   ) {
       var binder = new Binder();

       var viewTransition = transitionContainer.get(Transitions.VIEW_SHOW);
       var mediaViewTransition = transitionContainer.get(Transitions.MEDIA_VIEW_SHOW);
       var annotationOptionsViewTransition = transitionContainer.get(Transitions.VIEW_ANNOTATION_OPTIONS_SHOW);
       var correspondenceViewTransition = transitionContainer.get(Transitions.CORRESPONDENCE_VIEW_SHOW);

       var viewState = stateContainer.get(States.VIEW);
       var mediaViewState = stateContainer.get(States.MEDIA_VIEW);
       var correspondenceViewState = stateContainer.get(States.CORRESPONDENCE_VIEW);
       var annotationModeDragState = stateContainer.get(States.ANNOTATION_MODE_DRAG);
       var annotationModeFreehandState = stateContainer.get(States.ANNOTATION_MODE_FREEHAND);
       var annotationModeHighlightState = stateContainer.get(States.ANNOTATION_MODE_HIGHLIGHT);
       var annotationModeLineState = stateContainer.get(States.ANNOTATION_MODE_LINE);
       var annotationModeSelectState = stateContainer.get(States.ANNOTATION_MODE_SELECT);
       var annotationModeEllipseState = stateContainer.get(States.ANNOTATION_MODE_ELLIPSE);
       var annotationModeRectangleState = stateContainer.get(States.ANNOTATION_MODE_RECTANGLE);
       var annotationModeHexagonState = stateContainer.get(States.ANNOTATION_MODE_HEXAGON);
       var annotationModePolygonState = stateContainer.get(States.ANNOTATION_MODE_POLYGON);
       var annotationModeHighlightRegionState = stateContainer.get(States.ANNOTATION_MODE_HIGHLIGHT_REGION);
       var annotationModeArrowState = stateContainer.get(States.ANNOTATION_MODE_ARROW);
       var annotationModeTextState = stateContainer.get(States.ANNOTATION_MODE_TEXT);
       var annotationModePinState = stateContainer.get(States.ANNOTATION_MODE_PIN);

       this.init = States.INITIAL;

       this.transitions = [
           {name: Transitions.VIEW_SHOW, from: [States.INITIAL], to: States.VIEW},
           {name: Transitions.MEDIA_VIEW_SHOW, from: [States.INITIAL], to: States.MEDIA_VIEW},
           {name: Transitions.VIEW_HIDE, from: '*', to: States.INITIAL},
           {name: Transitions.CORRESPONDENCE_VIEW_SHOW, from: [States.INITIAL, States.CORRESPONDENCE_VIEW], to: States.CORRESPONDENCE_VIEW},
           {name: Transitions.VIEW_ANNOTATION_OPTIONS_SHOW, from: '*', to: (mode) => {
               switch (mode) {
                   case MODES.DRAG:
                       return States.ANNOTATION_MODE_DRAG;
                   case MODES.SELECT:
                       return States.ANNOTATION_MODE_SELECT;
                   case MODES.PENCIL:
                       return States.ANNOTATION_MODE_FREEHAND;
                   case MODES.HIGHLIGHTER:
                       return States.ANNOTATION_MODE_HIGHLIGHT;
                   case MODES.LINE:
                       return States.ANNOTATION_MODE_LINE;
                   case MODES.ARROW:
                       return States.ANNOTATION_MODE_ARROW;
                   case MODES.RECTANGLE:
                       return States.ANNOTATION_MODE_RECTANGLE;
                   case MODES.ELLIPSE:
                       return States.ANNOTATION_MODE_ELLIPSE;
                   case MODES.HEXAGON:
                       return States.ANNOTATION_MODE_HEXAGON;
                   case MODES.POLYGON:
                       return States.ANNOTATION_MODE_POLYGON;
                   case MODES.HIGHLIGHT_REGION:
                       return States.ANNOTATION_MODE_HIGHLIGHT_REGION;
                   case MODES.TEXT:
                       return States.ANNOTATION_MODE_TEXT;
                   case MODES.PIN:
                       return States.ANNOTATION_MODE_PIN;
                   default:
                       return States.ANNOTATION_MODE_DRAG;
               }
           }},
           {name: Transitions.VIEW_ANNOTATION_OPTIONS_HIDE, from: '*', to: States.VIEW},
           {name: Transitions.ANNOTATION_MODE_DRAG_ENABLE, from: '*', to: States.ANNOTATION_MODE_DRAG},
           {name: Transitions.ANNOTATION_MODE_FREEHAND_ENABLE, from: '*', to: States.ANNOTATION_MODE_FREEHAND},
           {name: Transitions.ANNOTATION_MODE_HIGHLIGHT_ENABLE, from: '*', to: States.ANNOTATION_MODE_HIGHLIGHT},
           {name: Transitions.ANNOTATION_MODE_LINE_ENABLE, from: '*', to: States.ANNOTATION_MODE_LINE},
           {name: Transitions.ANNOTATION_MODE_SELECT_ENABLE, from: '*', to: States.ANNOTATION_MODE_SELECT},
           {name: Transitions.ANNOTATION_MODE_ELLIPSE_ENABLE, from: '*', to: States.ANNOTATION_MODE_ELLIPSE},
           {name: Transitions.ANNOTATION_MODE_RECTANGLE_ENABLE, from: '*', to: States.ANNOTATION_MODE_RECTANGLE},
           {name: Transitions.ANNOTATION_MODE_HEXAGON_ENABLE, from: '*', to: States.ANNOTATION_MODE_HEXAGON},
           {name: Transitions.ANNOTATION_MODE_POLYGON_ENABLE, from: '*', to: States.ANNOTATION_MODE_POLYGON},
           {name: Transitions.ANNOTATION_MODE_HIGHLIGHT_REGION_ENABLE, from: '*', to: States.ANNOTATION_MODE_HIGHLIGHT_REGION},
           {name: Transitions.ANNOTATION_MODE_ARROW_ENABLE, from: '*', to: States.ANNOTATION_MODE_ARROW},
           {name: Transitions.ANNOTATION_MODE_TEXT_ENABLE, from: '*', to: States.ANNOTATION_MODE_TEXT},
           {name: Transitions.ANNOTATION_MODE_PIN_ENABLE, from: '*', to: States.ANNOTATION_MODE_PIN}
       ];

       this.methods = {};
       this.methods['onBeforeViewShow'] = binder.bindScope(viewTransition.onBefore, viewTransition);
       this.methods['onViewShow'] = binder.bindScope(viewTransition.onTransition, viewTransition);

       this.methods['onEnterView'] = binder.bindScope(viewState.onEnter, viewState);
       this.methods['onLeaveView'] = binder.bindScope(viewState.onLeave, viewState);

       this.methods['onBeforeMediaViewShow'] = binder.bindScope(mediaViewTransition.onBefore, mediaViewTransition);
       this.methods['onMediaViewShow'] = binder.bindScope(mediaViewTransition.onTransition, mediaViewTransition);

       this.methods['onBeforeViewAnnotationOptionsShow'] = binder.bindScope(annotationOptionsViewTransition.onBefore, annotationOptionsViewTransition);

       this.methods['onEnterMediaView'] = binder.bindScope(mediaViewState.onEnter, mediaViewState);
       this.methods['onLeaveMediaView'] = binder.bindScope(mediaViewState.onLeave, mediaViewState);

       this.methods['onBeforeCorrespondenceViewShow'] = binder.bindScope(correspondenceViewTransition.onBefore, correspondenceViewTransition);
       this.methods['onCorrespondenceViewShow'] = binder.bindScope(correspondenceViewTransition.onTransition, correspondenceViewTransition);

       this.methods['onEnterCorrespondenceView'] = binder.bindScope(correspondenceViewState.onEnter, correspondenceViewState);
       this.methods['onLeaveCorrespondenceView'] = binder.bindScope(correspondenceViewState.onLeave, correspondenceViewState);

       this.methods['onEnterAnnotationModeDrag'] = binder.bindScope(annotationModeDragState.onEnter, annotationModeDragState);
       this.methods['onLeaveAnnotationModeDrag'] = binder.bindScope(annotationModeDragState.onLeave, annotationModeDragState);

       this.methods['onEnterAnnotationModeFreehand'] = binder.bindScope(annotationModeFreehandState.onEnter, annotationModeFreehandState);
       this.methods['onLeaveAnnotationModeFreehand'] = binder.bindScope(annotationModeFreehandState.onLeave, annotationModeFreehandState);

       this.methods['onEnterAnnotationModeHighlight'] = binder.bindScope(annotationModeHighlightState.onEnter, annotationModeHighlightState);
       this.methods['onLeaveAnnotationModeHighlight'] = binder.bindScope(annotationModeHighlightState.onLeave, annotationModeHighlightState);

       this.methods['onEnterAnnotationModeText'] = binder.bindScope(annotationModeTextState.onEnter, annotationModeTextState);
       this.methods['onLeaveAnnotationModeText'] = binder.bindScope(annotationModeTextState.onLeave, annotationModeTextState);

       this.methods['onEnterAnnotationModePin'] = binder.bindScope(annotationModePinState.onEnter, annotationModePinState);
       this.methods['onLeaveAnnotationModePin'] = binder.bindScope(annotationModePinState.onLeave, annotationModePinState);

       this.methods['onEnterAnnotationModeLine'] = binder.bindScope(annotationModeLineState.onEnter, annotationModeLineState);
       this.methods['onLeaveAnnotationModeLine'] = binder.bindScope(annotationModeLineState.onLeave, annotationModeLineState);

       this.methods['onEnterAnnotationModeSelect'] = binder.bindScope(annotationModeSelectState.onEnter, annotationModeSelectState);
       this.methods['onLeaveAnnotationModeSelect'] = binder.bindScope(annotationModeSelectState.onLeave, annotationModeSelectState);

       this.methods['onEnterAnnotationModeRectangle'] = binder.bindScope(annotationModeRectangleState.onEnter, annotationModeRectangleState);
       this.methods['onLeaveAnnotationModeRectangle'] = binder.bindScope(annotationModeRectangleState.onLeave, annotationModeRectangleState);

       this.methods['onEnterAnnotationModeHexagon'] = binder.bindScope(annotationModeHexagonState.onEnter, annotationModeHexagonState);
       this.methods['onLeaveAnnotationModeHexagon'] = binder.bindScope(annotationModeHexagonState.onLeave, annotationModeHexagonState);

       this.methods['onEnterAnnotationModePolygon'] = binder.bindScope(annotationModePolygonState.onEnter, annotationModePolygonState);
       this.methods['onLeaveAnnotationModePolygon'] = binder.bindScope(annotationModePolygonState.onLeave, annotationModePolygonState);

       this.methods['onEnterAnnotationModeHighlightRegion'] = binder.bindScope(annotationModeHighlightRegionState.onEnter, annotationModeHighlightRegionState);
       this.methods['onLeaveAnnotationModeHighlightRegion'] = binder.bindScope(annotationModeHighlightRegionState.onLeave, annotationModeHighlightRegionState);

       this.methods['onEnterAnnotationModeEllipse'] = binder.bindScope(annotationModeEllipseState.onEnter, annotationModeEllipseState);
       this.methods['onLeaveAnnotationModeEllipse'] = binder.bindScope(annotationModeEllipseState.onLeave, annotationModeEllipseState);

       this.methods['onEnterAnnotationModeArrow'] = binder.bindScope(annotationModeArrowState.onEnter, annotationModeArrowState);
       this.methods['onLeaveAnnotationModeArrow'] = binder.bindScope(annotationModeArrowState.onLeave, annotationModeArrowState);
   };

   return JavascriptStateMachineConfig;
});
},
'doccontrol/viewer/state-machine/Transitions':function(){
define([], function() {
    return {
        ANNOTATION_MODE_DRAG_ENABLE: 'annotation-mode-drag-enable',
        ANNOTATION_MODE_FREEHAND_ENABLE: 'annotation-mode-freehand-enable',
        ANNOTATION_MODE_HIGHLIGHT_ENABLE: 'annotation-mode-highlight-enable',
        ANNOTATION_MODE_LINE_ENABLE: 'annotation-mode-line-enable',
        ANNOTATION_MODE_SELECT_ENABLE: 'annotation-mode-select-enable',
        ANNOTATION_MODE_ELLIPSE_ENABLE: 'annotation-mode-ellipse-enable',
        ANNOTATION_MODE_ARROW_ENABLE: 'annotation-mode-arrow-enable',
        ANNOTATION_MODE_RECTANGLE_ENABLE: 'annotation-mode-rectangle-enable',
        ANNOTATION_MODE_HEXAGON_ENABLE: 'annotation-mode-hexagon-enable',
        ANNOTATION_MODE_POLYGON_ENABLE: 'annotation-mode-polygon-enable',
        ANNOTATION_MODE_HIGHLIGHT_REGION_ENABLE: 'annotation-mode-highlight-region-enable',
        ANNOTATION_MODE_TEXT_ENABLE: 'annotation-mode-text-enable',
        ANNOTATION_MODE_PIN_ENABLE: 'annotation-mode-pin-enable',
        ANNOTATION_SHOW: 'annotation-show',
        CORRESPONDENCE_VIEW_SHOW: 'correspondence-view-show',
        EMAIL_VIEW_LOADING_SHOW: 'email-view-loading-show',
        EMAIL_VIEW_SHOW: 'email-view-show',
        MEDIA_VIEW_SHOW: 'media-view-show',
        VIEW_SHOW: 'view-show',
        VIEW_ANNOTATION_OPTIONS_HIDE: 'view-annotation-options-hide',
        VIEW_ANNOTATION_OPTIONS_SHOW: 'view-annotation-options-show',
        VIEW_LOADING_ERROR_SHOW: 'view-load-error-show',
        VIEW_LOADING_SHOW: 'view-loading-show',
        VIEW_HIDE: 'view-hide',
        VIEW_RENDERING_ERROR_SHOW: 'view-render-error-show',
        VIEW_RENDERING_SHOW: 'view-rendering-show'
    };
});
},
'doccontrol/viewer/state-machine/state-handler/Container':function(){
define([
    '../States'
], function(STATES) {
    var Container = function(
        viewState,
        mediaViewState,
        correspondenceViewState,
        annotationModeDragState,
        annotationModeFreehandState,
        annotationModeHighlightState,
        annotationModeLineState,
        annotationModeSelectState,
        annotationModeEllipseState,
        annotationModeRectangleState,
        annotationModeHexagonState,
        annotationModePolygonState,
        annotationModeHighlightRegionState,
        annotationModeArrowState,
        annotationModeTextState,
        annotationModePinState
    ) {
        this.supportedStates = {};
        this.supportedStates[STATES.VIEW] = viewState;
        this.supportedStates[STATES.MEDIA_VIEW] = mediaViewState;
        this.supportedStates[STATES.CORRESPONDENCE_VIEW] = correspondenceViewState;
        this.supportedStates[STATES.ANNOTATION_MODE_DRAG] = annotationModeDragState;
        this.supportedStates[STATES.ANNOTATION_MODE_FREEHAND] = annotationModeFreehandState;
        this.supportedStates[STATES.ANNOTATION_MODE_HIGHLIGHT] = annotationModeHighlightState;
        this.supportedStates[STATES.ANNOTATION_MODE_LINE] = annotationModeLineState;
        this.supportedStates[STATES.ANNOTATION_MODE_SELECT] = annotationModeSelectState;
        this.supportedStates[STATES.ANNOTATION_MODE_ELLIPSE] = annotationModeEllipseState;
        this.supportedStates[STATES.ANNOTATION_MODE_RECTANGLE] = annotationModeRectangleState;
        this.supportedStates[STATES.ANNOTATION_MODE_HEXAGON] = annotationModeHexagonState;
        this.supportedStates[STATES.ANNOTATION_MODE_POLYGON] = annotationModePolygonState;
        this.supportedStates[STATES.ANNOTATION_MODE_HIGHLIGHT_REGION] = annotationModeHighlightRegionState;
        this.supportedStates[STATES.ANNOTATION_MODE_ARROW] = annotationModeArrowState;
        this.supportedStates[STATES.ANNOTATION_MODE_TEXT] = annotationModeTextState;
        this.supportedStates[STATES.ANNOTATION_MODE_PIN] = annotationModePinState;
    };

    Container.prototype.has = function(state) {
        return this.supportedStates[state] !== undefined;
    };

    Container.prototype.get = function(state) {
        if (!this.has(state)) {
            throw new Error('No state exists named "' + state + '"');
        }

        return this.supportedStates[state];
    };

    return Container;
});
},
'doccontrol/viewer/state-machine/state-handler/View':function(){
define([
    '../States'
], function(
    STATES
) {
    var View = function(
        containerWidget
    ) {
        this.containerWidget = containerWidget;

        this.widgetView = null;
    };

    View.prototype.onLeave = function(lifecycle) {};

    View.prototype.onEnter = function(lifecycle) {
        this.widgetView = this.containerWidget.get('view');

        this.widgetView.hideAnnotationsToolbar();

        if (lifecycle.from === STATES.INITIAL) {
            this.widgetView.show();
        }
    };

    return View;
});
},
'doccontrol/viewer/state-machine/state-handler/MediaView':function(){
define([
    '../States'
], function(
    STATES
) {
    var MediaView = function(
        containerWidget
    ) {
        this.containerWidget = containerWidget;

        this.widgetView = null;
    };

    MediaView.prototype.onLeave = function(lifecycle) {
    };

    MediaView.prototype.onEnter = function(lifecycle) {
        if (lifecycle.from === STATES.INITIAL) {
            this.widgetView = this.containerWidget.get('media-view');
            this.widgetView.show();
        }
    };

    return MediaView;
});
},
'doccontrol/viewer/state-machine/state-handler/CorrespondenceView':function(){
define([
    '../States'
], function(
    STATES
) {
    var CorrespondenceView = function(
        containerWidget
    ) {
        this.containerWidget = containerWidget;

        this.widgetView = null;
    };

    CorrespondenceView.prototype.onLeave = function(lifecycle) {
    };

    CorrespondenceView.prototype.onEnter = function(lifecycle) {
        if (lifecycle.from === STATES.INITIAL) {
            this.widgetView = this.containerWidget.get('correspondence-view');
            this.widgetView.show();
        }
    };

    return CorrespondenceView;
});
},
'doccontrol/viewer/state-machine/state-handler/AnnotationModeDrag':function(){
define(['./ToStateChecker'], function(ToStateChecker) {
    var AnnotationModeDrag = function(
        containerWidget
    ) {
        this.containerWidget = containerWidget;

        this.widgetAnnotationWorkspace = null;
        this.annotationToolbar = null;
        this.widgetView = null;

        this.toStateChecker = new ToStateChecker();
    };

    AnnotationModeDrag.prototype.onLeave = function(lifecycle) {
        if (this.widgetAnnotationWorkspace) {
            this.annotationToolbar.hideDrag();
            this.widgetView.disableDragMode();

            if (!this.toStateChecker.isAnnotation(lifecycle)) {
                this.widgetAnnotationWorkspace.hideAnnotation();
                this.annotationToolbar.hide();
            }
        }
    };

    AnnotationModeDrag.prototype.onEnter = function(lifecycle) {
        this.widgetAnnotationWorkspace = this.containerWidget.get('annotation-workspace');
        this.annotationToolbar = this.containerWidget.get('view-annotation-toolbar');
        this.widgetView = this.containerWidget.get('view');

        this.widgetAnnotationWorkspace.enterDragMode();
        this.annotationToolbar.showDrag();

        this.widgetView.enableDragMode();
    };

    return AnnotationModeDrag;
});
},
'doccontrol/viewer/state-machine/state-handler/ToStateChecker':function(){
define(['../States'], function(STATES) {
    const ToStateChecker = function() {};

    ToStateChecker.prototype.isAnnotation = function(lifecycle) {
        return lifecycle.to === STATES.ANNOTATION_MODE_DRAG
            || lifecycle.to === STATES.ANNOTATION_MODE_FREEHAND
            || lifecycle.to === STATES.ANNOTATION_MODE_HIGHLIGHT
            || lifecycle.to === STATES.ANNOTATION_MODE_TEXT
            || lifecycle.to === STATES.ANNOTATION_MODE_PIN
            || lifecycle.to === STATES.ANNOTATION_MODE_LINE
            || lifecycle.to === STATES.ANNOTATION_MODE_SELECT
            || lifecycle.to === STATES.ANNOTATION_MODE_RECTANGLE
            || lifecycle.to === STATES.ANNOTATION_MODE_HEXAGON
            || lifecycle.to === STATES.ANNOTATION_MODE_POLYGON
            || lifecycle.to === STATES.ANNOTATION_MODE_HIGHLIGHT_REGION
            || lifecycle.to === STATES.ANNOTATION_MODE_ELLIPSE
            || lifecycle.to === STATES.ANNOTATION_MODE_ARROW;
    };

    ToStateChecker.prototype.supportsCloudStyle = function(lifecycle) {
        return lifecycle.to === STATES.ANNOTATION_MODE_LINE
            || lifecycle.to === STATES.ANNOTATION_MODE_POLYGON;
    };

    ToStateChecker.prototype.isPin = function(lifecycle) {
        return lifecycle.to === STATES.ANNOTATION_MODE_PIN;
    };

    return ToStateChecker;
});
},
'doccontrol/viewer/state-machine/state-handler/AnnotationModeFreehand':function(){
define(['./ToStateChecker'], function(ToStateChecker) {
    var AnnotationModeFreehand = function(
        containerWidget
    ) {
        this.containerWidget = containerWidget;

        this.widgetAnnotationWorkspace = null;
        this.annotationToolbar = null;

        this.toStateChecker = new ToStateChecker();
    };

    AnnotationModeFreehand.prototype.onLeave = function(lifecycle) {
        if (this.widgetAnnotationWorkspace) {
            this.annotationToolbar.hideFreehand();

            if (!this.toStateChecker.isAnnotation(lifecycle)) {
                this.widgetAnnotationWorkspace.hideAnnotation();
                this.annotationToolbar.hide();
            }
        }
    };

    AnnotationModeFreehand.prototype.onEnter = function(lifecycle) {
        this.widgetAnnotationWorkspace = this.containerWidget.get('annotation-workspace');
        this.annotationToolbar = this.containerWidget.get('view-annotation-toolbar');

        this.widgetAnnotationWorkspace.enterFreehandMode();
        this.annotationToolbar.showFreehand();
    };

    return AnnotationModeFreehand;
});
},
'doccontrol/viewer/state-machine/state-handler/AnnotationModeHighlight':function(){
define(['./ToStateChecker'], function(ToStateChecker) {
    const AnnotationModeHighlight = function(
        containerWidget
    ) {
        this.containerWidget = containerWidget;

        this.widgetAnnotationWorkspace = null;
        this.annotationToolbar = null;

        this.toStateChecker = new ToStateChecker();
    };

    AnnotationModeHighlight.prototype.onLeave = function(lifecycle) {
        if (this.widgetAnnotationWorkspace) {
            this.annotationToolbar.hideHighlight();

            if (!this.toStateChecker.isAnnotation(lifecycle)) {
                this.widgetAnnotationWorkspace.hideAnnotation();
                this.annotationToolbar.hide();
            }
        }
    };

    AnnotationModeHighlight.prototype.onEnter = function(lifecycle) {
        this.widgetAnnotationWorkspace = this.containerWidget.get('annotation-workspace');
        this.annotationToolbar = this.containerWidget.get('view-annotation-toolbar');

        this.widgetAnnotationWorkspace.enterHighlightMode();
        this.annotationToolbar.showHighlight();
    };

    return AnnotationModeHighlight;
});
},
'doccontrol/viewer/state-machine/state-handler/AnnotationModeLine':function(){
define(['./ToStateChecker'], function(ToStateChecker) {
    var AnnotationModeLine = function(
        containerWidget
    ) {
        this.containerWidget = containerWidget;

        this.widgetAnnotationWorkspace = null;
        this.annotationToolbar = null;

        this.toStateChecker = new ToStateChecker();
    };

    AnnotationModeLine.prototype.onLeave = function(lifecycle) {
        if (this.widgetAnnotationWorkspace) {
            this.annotationToolbar.hideLine();

            if (!this.toStateChecker.isAnnotation(lifecycle)) {
                this.widgetAnnotationWorkspace.hideAnnotation();
                this.annotationToolbar.hide();
            }

            if (!this.toStateChecker.supportsCloudStyle(lifecycle)) {
                this.annotationToolbar.disableCloudStyle();
            }
        }
    };

    AnnotationModeLine.prototype.onEnter = function(lifecycle) {
        this.widgetAnnotationWorkspace = this.containerWidget.get('annotation-workspace');
        this.annotationToolbar = this.containerWidget.get('view-annotation-toolbar');

        this.annotationToolbar.enableCloudStyle();

        this.widgetAnnotationWorkspace.enterLineMode();
        this.annotationToolbar.showLine();
    };

    return AnnotationModeLine;
});
},
'doccontrol/viewer/state-machine/state-handler/AnnotationModeSelect':function(){
define(['./ToStateChecker'], function(ToStateChecker) {
    var AnnotationModeSelect = function(
        containerWidget
    ) {
        this.containerWidget = containerWidget;

        this.widgetAnnotationWorkspace = null;
        this.annotationToolbar = null;

        this.toStateChecker = new ToStateChecker();
    };

    AnnotationModeSelect.prototype.onLeave = function(lifecycle) {
        if (this.widgetAnnotationWorkspace) {
            this.widgetAnnotationWorkspace.exitSelectMode();
            this.annotationToolbar.hideSelect();

            if (!this.toStateChecker.isAnnotation(lifecycle)) {
                this.widgetAnnotationWorkspace.hideAnnotation();
                this.annotationToolbar.hide();
            }

            if (this.containerWidget.get('view-annotation-pin-sidebar').isOpen()) {
                if (this.toStateChecker.isPin(lifecycle)) {
                    this.containerWidget.get('view-annotation-pin-sidebar').reset();
                } else {
                    this.containerWidget.get('view-annotation-pin-sidebar').hide();
                }
            }
        }
    };

    AnnotationModeSelect.prototype.onEnter = function(lifecycle) {
        this.widgetAnnotationWorkspace = this.containerWidget.get('annotation-workspace');
        this.annotationToolbar = this.containerWidget.get('view-annotation-toolbar');

        this.widgetAnnotationWorkspace.enterSelectMode();
        this.annotationToolbar.showSelect();
    };

    return AnnotationModeSelect;
});
},
'doccontrol/viewer/state-machine/state-handler/AnnotationModeEllipse':function(){
define(['./ToStateChecker'], function(ToStateChecker) {
    var AnnotationModeEllipse = function(
        containerWidget
    ) {
        this.containerWidget = containerWidget;

        this.widgetAnnotationWorkspace = null;
        this.annotationToolbar = null;

        this.toStateChecker = new ToStateChecker();
    };

    AnnotationModeEllipse.prototype.onLeave = function(lifecycle) {
        if (this.widgetAnnotationWorkspace) {
            this.annotationToolbar.hideEllipse();

            if (!this.toStateChecker.isAnnotation(lifecycle)) {
                this.widgetAnnotationWorkspace.hideAnnotation();
                this.annotationToolbar.hide();
            }
        }
    };

    AnnotationModeEllipse.prototype.onEnter = function(lifecycle) {
        this.widgetAnnotationWorkspace = this.containerWidget.get('annotation-workspace');
        this.annotationToolbar = this.containerWidget.get('view-annotation-toolbar');

        this.widgetAnnotationWorkspace.enterEllipseMode();
        this.annotationToolbar.showEllipse();
    };

    return AnnotationModeEllipse;
});
},
'doccontrol/viewer/state-machine/state-handler/AnnotationModeRectangle':function(){
define(['./ToStateChecker'], function(ToStateChecker) {
    var AnnotationModeRectangle = function(
        containerWidget
    ) {
        this.containerWidget = containerWidget;

        this.widgetAnnotationWorkspace = null;
        this.annotationToolbar = null;

        this.toStateChecker = new ToStateChecker();
    };

    AnnotationModeRectangle.prototype.onLeave = function(lifecycle) {
        if (this.widgetAnnotationWorkspace) {
            this.annotationToolbar.hideRectangle();

            if (!this.toStateChecker.isAnnotation(lifecycle)) {
                this.widgetAnnotationWorkspace.hideAnnotation();
                this.annotationToolbar.hide();
            }
        }
    };

    AnnotationModeRectangle.prototype.onEnter = function(lifecycle) {
        this.widgetAnnotationWorkspace = this.containerWidget.get('annotation-workspace');
        this.annotationToolbar = this.containerWidget.get('view-annotation-toolbar');

        this.widgetAnnotationWorkspace.enterRectangleMode();
        this.annotationToolbar.showRectangle();
    };

    return AnnotationModeRectangle;
});
},
'doccontrol/viewer/state-machine/state-handler/AnnotationModeHexagon':function(){
define(['./ToStateChecker'], function(ToStateChecker) {
    const AnnotationModeHexagon = function(
        containerWidget
    ) {
        this.containerWidget = containerWidget;

        this.widgetAnnotationWorkspace = null;
        this.annotationToolbar = null;

        this.toStateChecker = new ToStateChecker();
    };

    AnnotationModeHexagon.prototype.onLeave = function(lifecycle) {
        if (this.widgetAnnotationWorkspace) {
            this.annotationToolbar.hideHexagon();

            if (!this.toStateChecker.isAnnotation(lifecycle)) {
                this.widgetAnnotationWorkspace.hideAnnotation();
                this.annotationToolbar.hide();
            }
        }
    };

    AnnotationModeHexagon.prototype.onEnter = function(lifecycle) {
        this.widgetAnnotationWorkspace = this.containerWidget.get('annotation-workspace');
        this.annotationToolbar = this.containerWidget.get('view-annotation-toolbar');

        this.widgetAnnotationWorkspace.enterHexagonMode();
        this.annotationToolbar.showHexagon();
    };

    return AnnotationModeHexagon;
});
},
'doccontrol/viewer/state-machine/state-handler/AnnotationModePolygon':function(){
define(['./ToStateChecker'], function(ToStateChecker) {
    const AnnotationModePolygon = function(
        containerWidget
    ) {
        this.containerWidget = containerWidget;

        this.widgetAnnotationWorkspace = null;
        this.annotationToolbar = null;

        this.toStateChecker = new ToStateChecker();
    };

    AnnotationModePolygon.prototype.onLeave = function(lifecycle) {
        if (this.widgetAnnotationWorkspace) {
            this.annotationToolbar.hidePolygon();
            this.widgetAnnotationWorkspace.cancelPendingPolygon();

            if (!this.toStateChecker.isAnnotation(lifecycle)) {
                this.widgetAnnotationWorkspace.hideAnnotation();
                this.annotationToolbar.hide();
            }

            if (!this.toStateChecker.supportsCloudStyle(lifecycle)) {
                this.annotationToolbar.disableCloudStyle();
            }
        }
    };

    AnnotationModePolygon.prototype.onEnter = function(lifecycle) {
        this.widgetAnnotationWorkspace = this.containerWidget.get('annotation-workspace');
        this.annotationToolbar = this.containerWidget.get('view-annotation-toolbar');

        this.annotationToolbar.enableCloudStyle();

        this.widgetAnnotationWorkspace.enterPolygonMode();
        this.annotationToolbar.showPolygon();
    };

    return AnnotationModePolygon;
});
},
'doccontrol/viewer/state-machine/state-handler/AnnotationModeHighlightRegion':function(){
define(['./ToStateChecker'], function(ToStateChecker) {
    const AnnotationModeHighlightRegion = function(
        containerWidget
    ) {
        this.containerWidget = containerWidget;

        this.widgetAnnotationWorkspace = null;
        this.annotationToolbar = null;

        this.toStateChecker = new ToStateChecker();
    };

    AnnotationModeHighlightRegion.prototype.onLeave = function(lifecycle) {
        if (this.widgetAnnotationWorkspace) {
            this.annotationToolbar.hideHighlightRegion();

            if (!this.toStateChecker.isAnnotation(lifecycle)) {
                this.widgetAnnotationWorkspace.hideAnnotation();
                this.annotationToolbar.hide();
            }
        }
    };

    AnnotationModeHighlightRegion.prototype.onEnter = function(lifecycle) {
        this.widgetAnnotationWorkspace = this.containerWidget.get('annotation-workspace');
        this.annotationToolbar = this.containerWidget.get('view-annotation-toolbar');

        this.widgetAnnotationWorkspace.enterHighlightRegionMode();
        this.annotationToolbar.showHighlightRegion();
    };

    return AnnotationModeHighlightRegion;
});
},
'doccontrol/viewer/state-machine/state-handler/AnnotationModeArrow':function(){
define(['./ToStateChecker'], function(ToStateChecker) {
    var AnnotationModeArrow = function(
        containerWidget
    ) {
        this.containerWidget = containerWidget;

        this.widgetAnnotationWorkspace = null;
        this.annotationToolbar = null;

        this.toStateChecker = new ToStateChecker();
    };

    AnnotationModeArrow.prototype.onLeave = function(lifecycle) {
        if (this.widgetAnnotationWorkspace) {
            this.annotationToolbar.hideArrow();

            if (!this.toStateChecker.isAnnotation(lifecycle)) {
                this.widgetAnnotationWorkspace.hideAnnotation();
                this.annotationToolbar.hide();
            }
        }
    };

    AnnotationModeArrow.prototype.onEnter = function(lifecycle) {
        this.widgetAnnotationWorkspace = this.containerWidget.get('annotation-workspace');
        this.annotationToolbar = this.containerWidget.get('view-annotation-toolbar');

        this.widgetAnnotationWorkspace.enterArrowMode();
        this.annotationToolbar.showArrow();
    };

    return AnnotationModeArrow;
});
},
'doccontrol/viewer/state-machine/state-handler/AnnotationModeText':function(){
define(['./ToStateChecker'], function(ToStateChecker) {
    var AnnotationModeText = function(
        containerWidget
    ) {
        this.containerWidget = containerWidget;

        this.widgetAnnotationWorkspace = null;
        this.annotationToolbar = null;

        this.toStateChecker = new ToStateChecker();
    };

    AnnotationModeText.prototype.onLeave = function(lifecycle) {
        if (this.widgetAnnotationWorkspace) {
            this.widgetAnnotationWorkspace.exitTextMode();
            this.annotationToolbar.hideText();

            if (!this.toStateChecker.isAnnotation(lifecycle)) {
                this.annotationToolbar.hide();
                this.widgetAnnotationWorkspace.hideAnnotation();
            }
        }
    };

    AnnotationModeText.prototype.onEnter = function(lifecycle) {
        this.widgetAnnotationWorkspace = this.containerWidget.get('annotation-workspace');
        this.annotationToolbar = this.containerWidget.get('view-annotation-toolbar');

        this.widgetAnnotationWorkspace.enterTextMode();
        this.annotationToolbar.showText();
    };

    return AnnotationModeText;
});
},
'doccontrol/viewer/state-machine/state-handler/AnnotationModePin':function(){
define(['./ToStateChecker'], function(ToStateChecker) {
    const AnnotationModePin = function(
        containerWidget
    ) {
        this.containerWidget = containerWidget;

        this.widgetAnnotationWorkspace = null;
        this.annotationToolbar = null;

        this.toStateChecker = new ToStateChecker();
    };

    AnnotationModePin.prototype.onLeave = function(lifecycle) {
        if (this.widgetAnnotationWorkspace) {
            this.annotationToolbar.hidePin();
            this.containerWidget.get('view-annotation-pin-sidebar').hide(); // @todo check if pin details are dirty and warn user about data loss somewhere in logic flow
            this.widgetAnnotationWorkspace.deselectActivePin();

            if (!this.toStateChecker.isAnnotation(lifecycle)) {
                this.annotationToolbar.hide();
                this.widgetAnnotationWorkspace.hideAnnotation();
            }
        }
    };

    AnnotationModePin.prototype.onEnter = function() {
        this.widgetAnnotationWorkspace = this.containerWidget.get('annotation-workspace');
        this.annotationToolbar = this.containerWidget.get('view-annotation-toolbar');

        this.widgetAnnotationWorkspace.enterPinMode();
        this.annotationToolbar.showPin();
    };

    return AnnotationModePin;
});
},
'doccontrol/viewer/state-machine/transition-handler/ViewAnnotationOptionsShow':function(){
define(['../state-handler/ToStateChecker'], function(ToStateChecker) {
    const AnnotationViewOptions = function(containerWidget) {
        this.containerWidget = containerWidget;
        this.toStateChecker = new ToStateChecker();
    };

    AnnotationViewOptions.prototype.onBefore = function(lifecycle) {
        this.widgetView = this.containerWidget.get('view');
        this.widgetAnnotationWorkspace = this.containerWidget.get('annotation-workspace');
        this.annotationToolbar = this.containerWidget.get('view-annotation-toolbar');

        this.annotationToolbar.show();
        if (!this.toStateChecker.supportsCloudStyle(lifecycle)) {
            this.annotationToolbar.disableCloudStyle();
        }
        this.widgetAnnotationWorkspace.showAnnotation();
        this.widgetView.showAnnotationsToolbar();
        this.widgetView.exitOcrMode();
    };

    return AnnotationViewOptions;
});
},
'doccontrol/viewer/state-machine/transition-handler/Container':function(){
define([
    '../Transitions'
], function(TRANSITIONS) {
    var Container = function(
        annotationOptionsViewShowTransition,
        viewShowTransition,
        mediaViewShowTransition,
        correspondenceViewShowTransition
    ) {
        this.supportedTransitions = {};
        this.supportedTransitions[TRANSITIONS.VIEW_ANNOTATION_OPTIONS_SHOW] = annotationOptionsViewShowTransition;
        this.supportedTransitions[TRANSITIONS.VIEW_SHOW] = viewShowTransition;
        this.supportedTransitions[TRANSITIONS.MEDIA_VIEW_SHOW] = mediaViewShowTransition;
        this.supportedTransitions[TRANSITIONS.CORRESPONDENCE_VIEW_SHOW] = correspondenceViewShowTransition;
    };

    Container.prototype.has = function(transition) {
        return this.supportedTransitions[transition] !== undefined;
    };

    Container.prototype.get = function(transition) {
        if (!this.has(transition)) {
            throw new Error('No transition exists named "' + transition + '"');
        }

        return this.supportedTransitions[transition];
    };

    return Container;
});
},
'doccontrol/viewer/state-machine/transition-handler/ViewShow':function(){
define([
    'doccontrol/viewer/FileTypeViewable',
    'library/request/data/Handlers',
    'library/request/helper/DefaultUnauthorisedCallback',
    'pdf/request/data/Handlers',
    'spencer/utility/Binder'
], function(
    FileTypeViewable,
    HandlersVO,
    DefaultUnauthorisedCallback,
    PdfHandlersVO,
    Binder
) {
    const ViewShow = function(
        containerWidget,
        viewerModel,
        annotationModel,
        informationModel
    ) {
        this.containerWidget = containerWidget;
        this.viewerModel = viewerModel;
        this.annotationModel = annotationModel;
        this.informationModel = informationModel;
        this.viewerWidget = null;
        this.annotationWorkspace = null;

        this.binder = new Binder();
        this.fileTypeViewable = new FileTypeViewable();
    };

    ViewShow.prototype.onBefore = function() {
        this.viewerWidget = this.containerWidget.get('view', true);
        this.containerWidget.get('view-options-toolbar', true);
        this.viewerNavigationWidget = this.containerWidget.get('navigation-bar', true);

        this.viewerDialogToolbar = this.containerWidget.get('dialog-toolbar', true);
        this.annotationWorkspace = this.containerWidget.get('annotation-workspace', true);
        this.containerWidget.get('view-annotation-pin-sidebar', true);
        this.annotationToolbar = this.containerWidget.get('view-annotation-toolbar', true);
    };

    ViewShow.prototype.onTransition = function(lifecycle, fileType, href, revisionVO, temporaryDocumentVO, previousDocument, nextDocument) {
        this.viewerWidget.setReloadHref(href);
        this.viewerDialogToolbar.setHref(href);

        if (previousDocument) {
            this.viewerWidget.showNavigation();
            this.viewerNavigationWidget.show();
            this.viewerNavigationWidget.setPreviousDocument(previousDocument);
        }

        if (nextDocument) {
            this.viewerWidget.showNavigation();
            this.viewerNavigationWidget.show();
            this.viewerNavigationWidget.setNextDocument(nextDocument);
        }

        this.viewerWidget.startLongLoadMessageTimer();

        if (temporaryDocumentVO) {
            this.viewerModel.getTemporaryDocument(
                new HandlersVO(
                    function(temporaryDocument) {
                        this.viewerDialogToolbar
                            .hideTitleLoading()
                            .supportsOcr()
                            .supportsAnnotations()
                            .determineInformationShowing()
                            .setTemporaryDocument(temporaryDocument);
                        this.viewerWidget.setTemporaryDocument(temporaryDocument);

                        if (this.annotationWorkspace) {
                            this.annotationWorkspace.setMd5(temporaryDocument.getMd5());
                        }
                    }.bind(this),
                    function() {},
                    DefaultUnauthorisedCallback,
                    function() {},
                    function() {}
                ),
                temporaryDocumentVO
            );
        } else {
            this.viewerModel.getRevision(
                new HandlersVO(
                    function(revision) {
                        this.viewerDialogToolbar
                            .hideTitleLoading()
                            .supportsOcr()
                            .supportsAnnotations()
                            .supportsInformation()
                            .determineInformationShowing()
                            .setRevision(revision);

                        if (this.annotationWorkspace) {
                            this.annotationWorkspace.setMd5(revision.getMd5());
                        }

                        this.viewerWidget.setRevision(revision);

                        const informationWidget = this.viewerWidget.getInformation();

                        this.informationModel.setViewerWidget(this.viewerWidget)
                            .setViewerModel(this.viewerModel)
                            .setRevision(revision)
                            .populate(informationWidget.setInformationLoaded.bind(informationWidget));
                    }.bind(this),
                    function() {},
                    DefaultUnauthorisedCallback,
                    function() {},
                    function() {}
                ),
                revisionVO
            );
        }

        if (!this.fileTypeViewable.isViewable(fileType)) {
            this.viewerWidget.showBlacklistedMessage();
            return;
        }

        if (fileType.split('/')[0] === 'image') {
            this.viewerWidget.viewAsImage();
            const fileHandlers = new HandlersVO(
                function success(dataUrl) {
                    if (revisionVO) {
                        this.viewerModel.logView(revisionVO);
                    }

                    this.viewerWidget.setDataUrl(dataUrl);
                }.bind(this),
                function progress() {},
                function unauthorised() {
                    this.viewerWidget.showUnauthorisedMessage();
                    this.annotationModel.disconnect();
                }.bind(this),
                function error() {
                    this.viewerWidget.showErrorMessage();
                    this.annotationModel.disconnect();
                }.bind(this),
                function abort() {
                    this.annotationModel.disconnect();
                }.bind(this)
            );
            fileHandlers.setGone(function() {
                this.viewerWidget.showDeletedMessage();
            }.bind(this));

            this.viewerModel.getFile(fileHandlers, href);

            return;
        }

        this.viewerModel.getPdf(
            new PdfHandlersVO(
                function success(pdf) {
                    if (revisionVO) {
                        this.viewerModel.logView(revisionVO);
                    }

                    this.viewerWidget.setPdfDocument(pdf);
                }.bind(this),
                function error() {
                    this.viewerWidget.showErrorMessage();
                    this.annotationModel.disconnect();
                }.bind(this),
                function unauthorised() {
                    this.viewerWidget.showUnauthorisedMessage();
                    this.annotationModel.disconnect();
                }.bind(this),
                function abort() {
                    this.annotationModel.disconnect();
                }.bind(this),
                function password(updatePasswordCallback, reason) {
                    const prompt = this.viewerModel.constants.PASSWORD_RESPONSES[reason];
                    this.viewerWidget.showPasswordForm(prompt).then(function(password) {
                        updatePasswordCallback(password);
                    });
                }.bind(this),
                function gone() {
                    this.viewerWidget.showDeletedMessage();
                }.bind(this)
            ),
            href
        );
    };

    return ViewShow;
});
},
'doccontrol/viewer/state-machine/transition-handler/MediaViewShow':function(){
define([
    'doccontrol/viewer/FileTypeViewable',
    'library/request/data/Handlers',
    'library/request/helper/DefaultUnauthorisedCallback',
    'spencer/utility/Binder'
], function(
    FileTypeViewable,
    HandlersVO,
    DefaultUnauthorisedCallback,
    Binder
) {
    const MediaViewShow = function(
        containerWidget,
        viewerModel,
        informationModel
    ) {
        this.containerWidget = containerWidget;
        this.viewerModel = viewerModel;
        this.informationModel = informationModel;

        this.viewerWidget = null;
        this.mediaToolbar = null;

        this.binder = new Binder();
        this.fileTypeViewable = new FileTypeViewable();
    };

    MediaViewShow.prototype.onBefore = function() {
        this.viewerWidget = this.containerWidget.get('media-view', true);
        this.mediaToolbar = this.containerWidget.get('dialog-toolbar', true);
        this.viewerNavigationWidget = this.containerWidget.get('navigation-bar', true);
    };

    MediaViewShow.prototype.onTransition = function(lifecycle, fileType, href, revisionVO, temporaryDocumentVO, previousDocument, nextDocument) {
        this.mediaToolbar.setHref(href);

        this.viewerWidget.setFileType(fileType);

        const fileHandlers = new HandlersVO(
            function success(dataUrl) {
                if (revisionVO) {
                    this.viewerModel.logView(revisionVO);
                }

                this.viewerWidget.setDataUrl(dataUrl);
            }.bind(this),
            function progress() {},
            function unauthorised() {
                this.viewerWidget.showUnauthorisedMessage();
            }.bind(this),
            function error() {
                this.viewerWidget.showErrorMessage();
            }.bind(this),
            function abort() {
                this.viewerWidget.setReloadHref(href);
            }.bind(this)
        );
        fileHandlers.setGone(function() {
            this.viewerWidget.showDeletedMessage();
        }.bind(this));

        this.viewerModel.getFile(fileHandlers, href);

        if (previousDocument) {
            this.viewerWidget.showNavigation();
            this.viewerNavigationWidget.show();
            this.viewerNavigationWidget.setPreviousDocument(previousDocument);
        }

        if (nextDocument) {
            this.viewerWidget.showNavigation();
            this.viewerNavigationWidget.show();
            this.viewerNavigationWidget.setNextDocument(nextDocument);
        }

        if (!this.fileTypeViewable.isViewable(fileType)) {
            this.viewerWidget.showBlacklistedMessage();
        }

        if (temporaryDocumentVO) {
            this.viewerModel.getTemporaryDocument(
                new HandlersVO(
                    function(temporaryDocument) {
                        this.mediaToolbar.hideTitleLoading()
                            .determineInformationShowing()
                            .setTemporaryDocument(temporaryDocument)
                    }.bind(this),
                    function() {},
                    DefaultUnauthorisedCallback,
                    function() {},
                    function() {}
                ),
                temporaryDocumentVO
            );
        } else {
            this.viewerModel.getRevision(
                new HandlersVO(
                    function(revision) {
                        const informationWidget = this.viewerWidget.getInformation().setRevision(revision);

                        this.mediaToolbar.hideTitleLoading()
                            .supportsInformation()
                            .determineInformationShowing()
                            .setRevision(revision);

                        this.informationModel.setViewerWidget(this.viewerWidget)
                            .setViewerModel(this.viewerModel)
                            .setRevision(revision)
                            .populate(informationWidget.setInformationLoaded.bind(informationWidget));
                    }.bind(this),
                    function() {},
                    DefaultUnauthorisedCallback,
                    function() {},
                    function() {}
                ),
                revisionVO
            );
        }
    };

    return MediaViewShow;
});
},
'doccontrol/viewer/state-machine/transition-handler/CorrespondenceViewShow':function(){
define([
    'library/request/data/Handlers',
    'library/request/helper/DefaultUnauthorisedCallback',
    'spencer/utility/Binder'
], function(
    HandlersVO,
    DefaultUnauthorisedCallback,
    Binder
) {
    const CorrespondenceViewShow = function(
        containerWidget,
        viewerModel,
        informationModel
    ) {
        this.containerWidget = containerWidget;
        this.viewerModel = viewerModel;
        this.informationModel = informationModel;

        this.binder = new Binder();
    };

    CorrespondenceViewShow.prototype.onBefore = function(lifecycle) {
        this.viewerWidget = this.containerWidget.get('correspondence-view', true);
        this.mediaToolbar = this.containerWidget.get('dialog-toolbar', true);
        this.viewerNavigationWidget = this.containerWidget.get('navigation-bar', true);
    };

    CorrespondenceViewShow.prototype.onTransition = function(lifecycle, fileType, href, revisionVO, temporaryDocumentVO, previousDocument, nextDocument) {
        this.mediaToolbar.setHref(href);

        this.viewerWidget.setFileType(fileType);

        if (previousDocument) {
            this.viewerWidget.showNavigation();
            this.viewerNavigationWidget.show();
            this.viewerNavigationWidget.setPreviousDocument(previousDocument);
        }

        if (nextDocument) {
            this.viewerWidget.showNavigation();
            this.viewerNavigationWidget.show();
            this.viewerNavigationWidget.setNextDocument(nextDocument);
        }


        if (temporaryDocumentVO && temporaryDocumentVO.getTemporaryDocumentPK()) {
            this.viewerModel.getTemporaryDocument(
                new HandlersVO(
                    function(temporaryDocument) {
                        this.mediaToolbar.hideTitleLoading()
                            .determineInformationShowing()
                            .setTemporaryDocument(temporaryDocument);
                    }.bind(this),
                    function() {},
                    DefaultUnauthorisedCallback,
                    function() {},
                    function() {}
                ),
                temporaryDocumentVO
            );

            this.viewerModel.getTemporaryDocumentCorrespondence(
                new HandlersVO(
                    function success(correspondence) {
                        this.viewerWidget.setCorrespondence(correspondence);
                        this.viewerWidget.hideLoadingCorrespondence();

                        var revisions = correspondence.getRevisions();
                        if (revisions.length > 0) {
                            this.viewerModel.getRevisionRegistrationLocationCollection(
                                new HandlersVO(
                                    function(nodeCollection) {
                                        this.viewerWidget.setRegistrationLocations(nodeCollection);
                                    }.bind(this),
                                    function() {},
                                    DefaultUnauthorisedCallback,
                                    function() {},
                                    function() {}
                                ),
                                revisions
                            );
                        }
                    }.bind(this),
                    function progress() {},
                    function unauthorised() {
                        this.viewerWidget.showUnauthorisedMessage();
                    }.bind(this),
                    function error() {},
                    function abort() {}
                ),
                temporaryDocumentVO
            );
        } else {
            this.viewerModel.getRevision(
                new HandlersVO(
                    function (revision) {
                        const informationWidget = this.viewerWidget.getInformation().setRevision(revision);

                        this.mediaToolbar.hideTitleLoading()
                            .supportsInformation()
                            .determineInformationShowing()
                            .setRevision(revision);

                        this.informationModel.setViewerWidget(this.viewerWidget)
                            .setViewerModel(this.viewerModel)
                            .setRevision(revision)
                            .populate(informationWidget.setInformationLoaded.bind(informationWidget));
                    }.bind(this),
                    function() {},
                    DefaultUnauthorisedCallback,
                    function() {},
                    function() {}
                ),
                revisionVO
            );

            const correspondenceHandlers = new HandlersVO(
                function success(correspondence) {
                    this.viewerModel.logView(revisionVO);

                    this.viewerWidget.setCorrespondence(correspondence);
                    this.viewerWidget.hideLoadingCorrespondence();

                    var revisions = correspondence.getRevisions();
                    if (revisions.length > 0) {
                        this.viewerModel.getRevisionRegistrationLocationCollection(
                            new HandlersVO(
                                function(nodeCollection) {
                                    this.viewerWidget.setRegistrationLocations(nodeCollection);
                                }.bind(this),
                                function() {},
                                DefaultUnauthorisedCallback,
                                function() {},
                                function() {}
                            ),
                            revisions
                        );
                    }
                }.bind(this),
                function progress() {},
                function unauthorised() {
                    this.viewerWidget.showUnauthorisedMessage();
                }.bind(this),
                function error() {
                    this.viewerWidget.showErrorMessage();
                }.bind(this),
                function abort() {}
            );

            correspondenceHandlers.setGone(function() {
                this.viewerWidget.showDeletedMessage();
            }.bind(this));

            this.viewerModel.getCorrespondence(correspondenceHandlers, revisionVO);
        }
    };

    return CorrespondenceViewShow;
});
},
'doccontrol/viewer/socket/Subscriber':function(){
define([
    './Events',
    '../Topics'
], function(
    EVENTS,
    Topics
) {
    const Subscriber = function(socket, topic, binder, mixin) {
        this.socket = socket;
        this.topic = topic;
        this.binder = binder;
        this.EVENTS = mixin({}, EVENTS, socket.EVENTS);

        this.started = false;
    };

    Subscriber.prototype.startup = function() {
        if (this.started) {
            return;
        }

        this.socket.subscribe(
            this.EVENTS.DOCUMENT_ANNOTATION_ADD,
            this.binder.bindScope(
                function(data) {
                    this.topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_RECEIVED, data);
                },
                this
            )
        );

        this.socket.subscribe(
            this.EVENTS.DOCUMENT_ANNOTATION_JOIN,
            this.binder.bindScope(
                function(data) {
                    this.topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_INITIAL_SOCKET_RECEIVED, data);
                },
                this
            )
        );

        this.socket.subscribe(
            this.EVENTS.DOCUMENT_ANNOTATION_MODIFY,
            this.binder.bindScope(
                function(data) {
                    this.topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_RECEIVED_MODIFIED, data);
                },
                this
            )
        );

        this.socket.subscribe(
            this.EVENTS.DOCUMENT_ANNOTATION_DELETE,
            this.binder.bindScope(
                function(data) {
                    this.topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_RECEIVED_DELETED, data);
                },
                this
            )
        );

        this.socket.subscribe(
            this.EVENTS.DOCUMENT_ANNOTATION_CLEAR_ALL,
            this.binder.bindScope(
                function() {
                    this.topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_RECEIVED_CLEARED);
                },
                this
            )
        );

        this.socket.subscribe(
            this.EVENTS.DISCONNECT,
            this.binder.bindScope(
                function() {
                    this.topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_DISCONNECTED);
                },
                this
            )
        );

        this.socket.subscribe(
            this.EVENTS.DOCUMENT_ANNOTATION_USER_CONNECT,
            this.binder.bindScope(
                function(user) {
                    this.topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_USER_CONNECT, user);
                },
                this
            )
        );

        this.socket.subscribe(
            this.EVENTS.DOCUMENT_ANNOTATION_USER_DISCONNECT,
            this.binder.bindScope(
                function(user) {
                    this.topic.publish(Topics.DOCUMENT_VIEWER_ANNOTATION_SOCKET_USER_DISCONNECT, user);
                },
                this
            )
        );

        this.started = true;
    };

    return Subscriber;
});
},
'doccontrol/viewer/data-manager/Factory':function(){
define([
    'library/DojoObjectMerger',
    'library/PromiseFactory',
    'library/Lang',
    'project-listing/model/data-manager/Config',
    'project-listing/model/data-manager/storage/web-storage/SupportedEntities',
    'spencer/data-manager/log/NullLogger',
    'spencer/data-manager/Manager',
    'spencer/data-manager/storage/KeyGenerator',
    'spencer/data-manager/storage/local-forage/Store',
    'spencer/data-manager/utility/UniqueID',
    'spencer/utility/BlobFactory',
    'vendor/localforage/dist/localforage'
], function(
    ObjectMerger,
    PromiseFactory,
    Lang,
    CONFIG,
    SupportedEntities,
    Logger,
    Manager,
    KeyGenerator,
    Store,
    UniqueID,
    BlobFactory,
    localForage
) {
    const STORAGE_UID = 'document_viewer_data_manager';

    class Factory {
        constructor(actionContainer) {
            this.actionContainer = actionContainer;
        }

        get() {
            const pf = new PromiseFactory();

            return new Manager(
                CONFIG,
                {},
                pf,
                this.actionContainer,
                new Store(
                    localForage,
                    pf,
                    new KeyGenerator(
                        SupportedEntities,
                        STORAGE_UID,
                        null
                    )
                ),
                new Lang(),
                new ObjectMerger(),
                new UniqueID(),
                new Logger()
            )
        };
    }

    return Factory;
});
},
'project-listing/model/data-manager/Config':function(){
define([
    'project-listing/model/data-manager/definition/Actions',
    'project-listing/model/data-manager/definition/Entities'
], function(
    ACTIONS,
    ENTITIES
) {
    return [
        {
            action: ACTIONS.DOCUMENT_MERGE,
            entity: ENTITIES.REVISION_TO_TREE_VIEW,
            requiredContext: ['fromDocumentLatestRevisionPK', 'fromDocumentProjectStagePK', 'fromDocumentProjectStageTreeViewPK'],
            data: {
                revisionPK: context => context.request.getContext()['fromDocumentLatestRevisionPK'],
                projectStagePK: context => context.request.getContext()['fromDocumentProjectStagePK'],
                projectStageTreeViewPK: context => context.request.getContext()['fromDocumentProjectStageTreeViewPK']
            }
        },
        {
            action: ACTIONS.DOCUMENT_MERGE,
            entity: ENTITIES.REVISION_TO_TREE_VIEW,
            requiredContext: ['toDocumentLatestRevisionPK', 'toDocumentProjectStagePK', 'toDocumentProjectStageTreeViewPK'],
            data: {
                revisionPK: context => context.request.getContext()['toDocumentLatestRevisionPK'],
                projectStagePK: context => context.request.getContext()['toDocumentProjectStagePK'],
                projectStageTreeViewPK: context => context.request.getContext()['toDocumentProjectStageTreeViewPK']
            }
        },
        {
            action: ACTIONS.DOCUMENT_MERGE,
            entity: ENTITIES.DOCUMENT,
            requiredContext: ['md5'],
            data: {
                md5: context => context['md5']
            }
        },
        {
            action: ACTIONS.CREATE_DOCUMENT_ALERT,
            entity: ENTITIES.REVISION,
            requiredContext: ['revisionPK'],
            data: {
                'isAlert': true,
                'isFavourited': false
            }
        },
        {
            action: ACTIONS.REMOVE_DOCUMENT_ALERT,
            entity: ENTITIES.REVISION,
            requiredContext: ['revisionPK'],
            data: {
                'isAlert': false
            }
        },
        {
            action: ACTIONS.REVISION_RETIRE,
            entity: ENTITIES.REVISION,
            requiredContext: ['revisionPK'],
            data: {
                'markedForDeletion': true
            }
        },
        {
            action: ACTIONS.FAVOURITE_DOCUMENT_CREATE,
            entity: ENTITIES.REVISION,
            requiredContext: ['revisionPK'],
            data: {
                'isFavourited': true,
                'isAlert': false
            }
        },
        {
            action: ACTIONS.FAVOURITE_DOCUMENT_REMOVE,
            entity: ENTITIES.REVISION,
            requiredContext: ['revisionPK'],
            data: {
                'isFavourited': false
            }
        },
        {
            action: ACTIONS.PROJECT_STAGE,
            entity: ENTITIES.PROJECT_STAGE,
            data: {
                'projectStage': true
            }
        }
    ];
});
},
'project-listing/model/data-manager/definition/Actions':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    return {
        ADD_FOLDER: 'add-folder',
        CHECK_RECEIVING_DOCUMENT_SEARCH_ALERTS: 'check-receiving-document-search-alerts',
        CHECK_RECEIVING_TREE_NODE_ALERTS: 'check-receiving-tree-node-alerts',
        CREATE_DOCUMENT_ALERT: 'create-document-alert',
        CREATE_DOCUMENT_SEARCH_ALERT: 'create-document-search-alert',
        CREATE_TREE_NODE_ALERT: 'create-tree-node-alert',
        COPY_NODE: 'copy-node',
        COPY_NODE_ORGANISATION: 'copy-node-organisation',
        DELETE_SOFT_LINK: 'delete-soft-link',
        DOCUMENT_ALERT: 'document-alert',
        DOCUMENT_MERGE: 'document-merge',
        DOCUMENT_REVISION_COLLECTION: 'document-revision-collection',
        DOWNLOAD_LISTING_CSV: 'download-listing-csv',
        FAVOURITE_DOCUMENT: 'favourite-document',
        FAVOURITE_DOCUMENT_CREATE: 'favourite-document-create',
        FAVOURITE_DOCUMENT_REMOVE: 'favourite-remove',
        FAVOURITE_DOCUMENT_SEARCH: 'favourite-document-search',
        FAVOURITE_DOCUMENT_SEARCH_CREATE: 'favourite-document-search-create',
        FAVOURITE_DOCUMENT_SEARCH_REMOVE: 'favourite-document-search-remove',
        FAVOURITE_TREE_NODE: 'favourite-tree-node',
        FAVOURITE_TREE_NODE_CREATE: 'favourite-tree-node-create',
        FAVOURITE_TREE_NODE_REMOVE: 'favourite-tree-node-remove',
        GET_ATTACHMENTS_FOR_REVISION: 'get-attachments-for-revision',
        GET_TEMPORARY_DOCUMENT_FILE: 'get-temporary-document-file',
        GET_REVISION_FILE: 'get-revision-file',
        MULTI_NODE_LISTING_VIEW: 'multi-node-listing-view',
        PROJECT_STAGE_DELIVERY: 'project-stage-delivery',
        PROJECT_STAGE: 'project-stage',
        PROJECT_STAGE_COLLECTION: 'project-stage-collection',
        PROJECT_STAGE_TIMESHEET_COST_CENTRE: 'project-stage-timesheet-cost-centre',
        REGISTRATION_BASKET_REMOVE_ALL: 'registration-basket-remove-all',
        REMOVE_DOCUMENT_ALERT: 'remove-document-alert',
        REMOVE_DOCUMENT_SEARCH_ALERT: 'remove-document-search-alert',
        REMOVE_TREE_NODE_ALERT: 'remove-tree-node-alert',
        RETIREMENT_COLLECTION: 'retirement-collection',
        REVISION: 'revision',
        REVISION_COLLECTION: 'revision-collection',
        REVISION_RETIRE: 'revision-retire',
        REVISION_SEARCH: 'revision-search',
        SET_MULTI_NODE_LISTING_NODES: 'set-multi-node-listing-nodes',
        STRUCTURE: 'structure',
        TEMPORARY_DOCUMENT_COLLECTION: 'temporary-document-collection',
        TEMPORARY_DOCUMENT_HIDE: 'temporary-document-hide',
        TEMPORARY_DOCUMENT_REGISTER: 'temporary_document_register',
        MULTI_SEARCH_QUERY: 'multi-search-query',
        MULTI_SEARCH_ORGANISATION_BY_TRADE_QUERY: 'multi-search-trade-query'
    };
});

},
'project-listing/model/data-manager/definition/Entities':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    return {
        DOCUMENT: 'document',
        DOCUMENT_SEARCH_ALERT: 'document-search-alert',
        FAVOURITE_DOCUMENT_SEARCH: 'favourite-document-search',
        FAVOURITE_TREE_NODE: 'favourite-tree-node',
        PROJECT_STAGE: 'project-stage',
        REVISION: 'revision',
        REVISION_RETIREMENT: 'revision-retirement',
        REVISION_TO_TREE_VIEW: 'revision-to-tree-view',
        TEMPORARY_DOCUMENT: 'temporary-document',
        TREE_NODE_ALERT: 'tree-node-alert'
    };
});

},
'project-listing/model/data-manager/storage/web-storage/SupportedEntities':function(){
define([
    'project-listing/model/data-manager/definition/Entities'
], function(
    ENTITIES
) {
    const KEY_SEPARATOR = '_';
    const PARAMETER_DOCUMENT_PK = 'documentPK';
    const PARAMETER_FAVOURITE_PK = 'favouritePK';
    const PARAMETER_PROJECT_STAGE_PK = 'projectStagePK';
    const PARAMETER_REVISION_PK = 'revisionPK';
    const PARAMETER_REVISION_PKS = 'revisionPKs';
    const PARAMETER_REVISION_RETIREMENT_PK = 'revisionRetirementPK';
    const PARAMETER_TEMPORARY_DOCUMENT_PK = 'temporaryDocumentPK';
    const PARAMETER_TREE_VIEW_PK = 'treeViewPK';
    const SUPPORTED_ENTITIES = {};

    const _isSetAndNotEmpty = function(data, field) {
        return data && data.hasOwnProperty(field) && !!data[field];
    };

    SUPPORTED_ENTITIES[ENTITIES.FAVOURITE_DOCUMENT_SEARCH] = {
        hasSufficientData: function(data) {
            return _isSetAndNotEmpty(data, PARAMETER_FAVOURITE_PK);
        },
        generate: function(data) {
            return ENTITIES.FAVOURITE_DOCUMENT_SEARCH + KEY_SEPARATOR + data[PARAMETER_FAVOURITE_PK]
        }
    };

    SUPPORTED_ENTITIES[ENTITIES.FAVOURITE_TREE_NODE] = {
        hasSufficientData: function(data) {
            return _isSetAndNotEmpty(data, 'favouritePK')
                && _isSetAndNotEmpty(data, 'projectStagePK')
                && _isSetAndNotEmpty(data, 'treeViewPK')
                && _isSetAndNotEmpty(data, 'name')
        },
        generate: function(data) {
            return ENTITIES.FAVOURITE_TREE_NODE + KEY_SEPARATOR + data['favouritePK']
        }
    };

    SUPPORTED_ENTITIES[ENTITIES.REVISION] = {
        hasSufficientData: function(data) {
            return _isSetAndNotEmpty(data, PARAMETER_REVISION_PK) || _isSetAndNotEmpty(data, PARAMETER_REVISION_PKS);
        },
        generate: function(data) {
            return ENTITIES.REVISION + KEY_SEPARATOR + data[PARAMETER_REVISION_PK];
        }
    };

    SUPPORTED_ENTITIES[ENTITIES.REVISION_RETIREMENT] = {
        hasSufficientData: function(data) {
            return _isSetAndNotEmpty(data, PARAMETER_REVISION_RETIREMENT_PK);
        },
        generate: function(data) {
            return ENTITIES.REVISION_RETIREMENT + KEY_SEPARATOR + data[PARAMETER_REVISION_RETIREMENT_PK];
        }
    };

    SUPPORTED_ENTITIES[ENTITIES.REVISION_TO_TREE_VIEW] = {
        hasSufficientData: function(data) {
            return _isSetAndNotEmpty(data, PARAMETER_REVISION_PK)
                && _isSetAndNotEmpty(data, PARAMETER_PROJECT_STAGE_PK)
                && _isSetAndNotEmpty(data, PARAMETER_TREE_VIEW_PK);
        },
        generate: function(data) {
            return ENTITIES.REVISION_TO_TREE_VIEW + KEY_SEPARATOR + data[PARAMETER_REVISION_PK] + KEY_SEPARATOR + data[PARAMETER_PROJECT_STAGE_PK] + KEY_SEPARATOR + data[PARAMETER_TREE_VIEW_PK];
        }
    };

    SUPPORTED_ENTITIES[ENTITIES.TEMPORARY_DOCUMENT] = {
        hasSufficientData: function(data) {
            return _isSetAndNotEmpty(data, PARAMETER_TEMPORARY_DOCUMENT_PK);
        },
        generate: function(data) {
            return ENTITIES.TEMPORARY_DOCUMENT + KEY_SEPARATOR + data[PARAMETER_TEMPORARY_DOCUMENT_PK];
        }
    };

    SUPPORTED_ENTITIES[ENTITIES.DOCUMENT_SEARCH_ALERT] = {
        hasSufficientData: function(data) {
            return _isSetAndNotEmpty(data, 'alertPK');
        },
        generate: function(data) {
            return ENTITIES.DOCUMENT_SEARCH_ALERT + KEY_SEPARATOR + data['alertPK'];
        }
    };

    SUPPORTED_ENTITIES[ENTITIES.TREE_NODE_ALERT] = {
        hasSufficientData: function(data) {
            return _isSetAndNotEmpty(data, 'alertPK');
        },
        generate: function(data) {
            return ENTITIES.TREE_NODE_ALERT + KEY_SEPARATOR + data['alertPK'];
        }
    };

    SUPPORTED_ENTITIES[ENTITIES.PROJECT_STAGE] = {
        hasSufficientData: function (data) {
            return _isSetAndNotEmpty(data, 'projectStagePK');
        },
        generate: function (data) {
            return ENTITIES.PROJECT_STAGE + KEY_SEPARATOR + data['projectStagePK']
        }
    }

    return SUPPORTED_ENTITIES;
});
},
'spencer/utility/BlobFactory':function(){
define([], function() {
    const BlobFactory = function() {};

    BlobFactory.prototype.get = function(blobParts, options) {
        return new Blob(blobParts, options);
    };

    return BlobFactory;
});

},
'library/DojoObservableWrapper':function(){
define([
    'dojo/Stateful'
], function(Stateful) {
    var DojoObservableWrapper = function() {
        this.stateful = new Stateful();
    };

    DojoObservableWrapper.prototype.get = function(property) {
        return this.stateful.get(property);
    };

    DojoObservableWrapper.prototype.set = function(property, value) {
        this.stateful.set(property, value);
    };

    DojoObservableWrapper.prototype.observe = function(property, callback) {
        return this.stateful.watch(property, callback);
    };

    return DojoObservableWrapper;
});
},
'spencer/data-manager/request/Container':function(){
define([], function() {
    const Container = function() {
        this.actionContainers = [];

        this._hasAction = function(request) {
            return this.actionContainers.some(function(actionContainer) {
                return actionContainer.has(request);
            }.bind(this));
        };

        this._getActionContainer = function(request) {
            if (this.actionContainers.length === 0) {
                throw 'No actions found';
            }

            const action = request.getAction();
            if (!this._hasAction(request)) {
                throw 'Unsupported data management action: ' + action;
            }

            let foundActionContainer;

            this.actionContainers.some(function(actionContainer) {
                if (actionContainer.has(request)) {
                    foundActionContainer = actionContainer;
                    return true;
                }
            }.bind(this));

            return foundActionContainer;
        }
    };

    Container.prototype.addActionContainer = function(manager) {
        this.actionContainers.push(manager);
        return this;
    };

    Container.prototype.get = function(request) {
        return this._getActionContainer(request).get(request);
    };

    Container.prototype.has = function(request) {
        return this._hasAction(request);
    };

    return Container;
});
},
'project-listing/helper/FilterRouteGenerator':function(){
define(["require", "exports"], function (require, exports) {
    "use strict";
    class FilterRouteGenerator {
        generate(route, params) {
            for (let i in params) {
                if (params.hasOwnProperty(i)) {
                    route += '/' + i + '/' + params[i];
                }
            }
            return route;
        }
    }
    return FilterRouteGenerator;
});

},
'spencer/routing/Container':function(){
define([], function() {
    const RouteContainer = function(routes) {
        this.routes = routes;
    };

    RouteContainer.prototype.get = function(key, data, optionalParameters, queryStringParameters) {
        if (!this.has(key)) {
            throw new Error('No route exists named "' + key + '"');
        }

        let route = this.routes[key];

        if (data) {
            for (let i in data) {
                if (data.hasOwnProperty(i)) {
                    route = route.replace(':' + i, encodeURIComponent(data[i]));
                }
            }
        }

        if (optionalParameters) {
            for (let i in optionalParameters) {
                if (!optionalParameters.hasOwnProperty(i)) {
                    continue;
                }

                const current = optionalParameters[i];

                if (current instanceof Array) {
                    route += '/' + encodeURIComponent(i) + '/' + current.map((value) => encodeURIComponent(value));
                    continue;
                }

                route += '/' + encodeURIComponent(i) + '/' + encodeURIComponent(current);
            }
        }

        if (queryStringParameters && Object.keys(queryStringParameters).length > 0) {
            if (!route.includes('?')) {
                route += '?';
            } else {
                route += '&';
            }

            for (let i in queryStringParameters) {
                if (!queryStringParameters.hasOwnProperty(i)) {
                    continue;
                }

                const current = queryStringParameters[i];
                if (current instanceof Array) {
                    route += current.map(function(value) {
                        if (i.endsWith('[]')) {
                            i = i.slice(0, -2);
                        }
                        return encodeURIComponent(i) + '[]=' + encodeURIComponent(value) + '&';
                    }).join('');
                    continue;
                }

                route += encodeURIComponent(i) + '=' + encodeURIComponent(current) + '&';
            }

            route = route.slice(0, route.length - 1);
        }

        return route;
    };

    RouteContainer.prototype.has = function(key) {
        return !!this.routes && this.routes.hasOwnProperty(key);
    };

    return RouteContainer;
});
},
'style-guide/v1/navigation/Header':function(){
define([
    'library/request/data/Handlers',
    'api/diary/data/DiaryNote',
    'api/search/filter/IncludeContactsWithoutEmail',
    'dojo/cookie',
    'dojo/dom',
    'dojo/dom-attr',
    'dojo/dom-class',
    'dojo/dom-construct',
    'dojo/dom-geometry',
    'dojo/keys',
    'dojo/query',
    'dojo/on',
    'dojo/topic',
    'dojo/_base/array',
    'dojo/_base/declare',
    'dojo/_base/event',
    'dojo/_base/lang',
    'dojo/_base/window',
    'dijit/focus',
    'dijit/_WidgetBase',
    'spencer/core/filter/Collection',
    'style-guide/v1/contacts/HorizontalStackedList',
    'style-guide/v1/favourites/VerticalList',
    'style-guide/v1/layout/KeyboardShortcutToggleTopics'
], function(
    HandlersVO,
    DiaryNoteVO,
    includeContactsWithoutEmailFilter,
    dojoCookie,
    dom, domAttr,
    domClass,
    domConstruct,
    domGeometry,
    keys,
    query,
    on,
    topic,
    array,
    declare,
    event,
    lang,
    win,
    focusUtil,
    WidgetBase,
    FilterCollection,
    HorizontalStackedContactList,
    VerticalFavouriteList,
    KeyboardShortcutToggleTopics
) {
    const CONTACT_SEARCH_DELAY = 300;
    const CONTACT_SEARCH_DELAY_SHORT_QUERY = 1000;
    const CONTACT_SEARCH_QUERY_MINIMUM_LENGTH = 2;
    const CONTACT_SEARCH_SHORT_QUERY_LENGTH = 4;

    return declare('style-guide.v1.navigation.header', [WidgetBase], {
        /*
         * TOPICS
         */

        TOPIC_REQUEST_DIALOG_CLOSURE: 'sos-system-dialog-close',

        /*
         * CSS CLASS
         */

        CSS_MOBILE_MENU_SUB_OPEN: 'sos-navigation-header-mobile-menu-system-sub-open',
        CSS_DIARY_NOTE_OPEN: 'sos-navigation-header-diary-note-navigation-open',
        CSS_CONTACT_SEARCH_OPEN: 'sos-navigation-header-contact-search-navigation-open',
        CSS_CONTACT_SEARCH_PLACEHOLDER_SHOW: 'sos-navigation-header-contact-search-placeholder-show',
        CSS_CONTACT_SEARCH_FOOTER_SHOW: 'sos-navigation-header-contact-search-footer-open',
        CSS_CONTACT_SEARCH_PAGINATION_SHOW: 'sos-navigation-header-contact-search-footer-show',

        /*
         * PAGE IDs
         */

        ID_HEADER_SYSTEM: 'sosNavigationHeaderSystem',
        ID_MOBILE_MENU: 'sosNavigationHeaderMobile',
        ID_CONTACT_SEARCH_FOOTER_MOBILE: 'sosNavigationHeaderSearchContactsMobileFooter',
        ID_CONTACT_SEARCH_NO_RESULTS: 'sosNavigationHeaderContactSearchNoResults',
        ID_CONTACT_SEARCH_NO_RESULTS_MOBILE: 'sosNavigationHeaderSearchContactsMobileNoResults',
        ID_CONTACT_SEARCH_PROMPT: 'sosNavigationHeaderContactSearchPrompt',
        ID_CONTACT_SEARCH_LOADING: 'sosNavigationHeaderSearchContactsLoading',
        ID_CONTACT_SEARCH_LOADING_MOBILE: 'sosNavigationHeaderSearchContactsMobileLoading',
        ID_CONTACT_SEARCH_PAGINATION: 'sosNavigationHeaderContactSearchPagination',
        ID_CONTACT_SEARCH_PAGINATION_PREV: 'sosNavigationHeaderContactSearchPaginationPrev',
        ID_CONTACT_SEARCH_PAGINATION_NEXT: 'sosNavigationHeaderContactSearchPaginationNext',

        /*
         * KEY CODES
         */

         KEY_CODE_C: 67,
         KEY_CODE_D: 68,
         KEY_CODE_N: 78,
         KEY_CODE_S: 83,

        /*
         * API
         */

        diaryNoteApi: null,
        favouriteApi: null,
        favouriteAlertApi: null,
        searchContactCollectionApi: null,

        diaryNoteSaveHandlersVO: null,
        favouriteFetchHandlersVO: null,
        favouriteAlertFetchHandlersVO: null,
        searchContactCollectionFetchHandlersVO: null,

        favouriteFetchCanceller: null,
        favouriteAlertFetchCanceller: null,
        searchContactCollectionFetchCanceller: null,
        searchContactCollectionFetchTimeout: null,

        /*
         * WIDGETS
         */

        horizontalStackedContactList: null,
        horizontalStackedContactListMobile: null,

        verticalFavouriteList: null,
        verticalFavouriteListMobile: null,

        verticalFavouriteAlertList: null,
        verticalFavouriteAlertListMobile: null,

        contactNavigationEvents: [],

        routeContainer: null,

        /*
         * INIT
         */

        postCreate: function() {
            this.initDialogManagement();

            this.initMobileSubmenuClickDisplay();

            this.initDiaryNoteApi();

            this.initDiaryNote();

            this.initDiaryNoteMobile();

            this.initSearchContactCollectionApi();

            this.initContactSearch();

            this.initContactSearchMobile();

            this.initFavouriteApi();

            this.initFavourites();

            this.initFavouritesMobile();

            this.initFavouriteAlertApi();

            this.initFavouriteAlerts();

            this.initFavouriteAlertsMobile();

            this.initMenuIntent();
        },

        /*
         * DIALOG MANAGEMENT
         */

        initDialogManagement: function() {
            // On body click close all dialogs
            on(win.body(), 'click', lang.hitch(this, this.requestDialogClosure));

            // On mouse over favourite and account menus close all dialogs
            if (dom.byId('sosNavigationHeaderFavouriteAlerts')) {
                on(query('li', dom.byId('sosNavigationHeaderFavouriteAlerts')), 'mouseover', lang.hitch(this, this.requestDialogClosure));
            }

            if (dom.byId('sosNavigationHeaderFavourites')) {
                on(query('li', dom.byId('sosNavigationHeaderFavourites')), 'mouseover', lang.hitch(this, this.requestDialogClosure));
            }

            var diaryNote = dom.byId('sosNavigationHeaderDiaryNote');
            if (diaryNote) {
                on(diaryNote, 'mouseover', lang.hitch(this, function() {
                    this.hideContactSearch(dom.byId('sosNavigationHeaderContactSearch'));
                    this.showDiaryNote(diaryNote);
                }));
            }

            var contactSearch = dom.byId('sosNavigationHeaderContactSearch');
            if (contactSearch) {
                on(contactSearch, 'mouseover', lang.hitch(this, function() {
                    this.hideDiaryNote(dom.byId('sosNavigationHeaderDiaryNote'));
                    this.showContactSearch(contactSearch);
                }));
            }

            if (dom.byId('sosNavigationHeaderAccountPrefs')) {
                on(dom.byId('sosNavigationHeaderAccountPrefs'), 'mouseover', lang.hitch(this, this.requestDialogClosure));
            }
        },

        /*
         * MOBILE MENU
         */

        initMobileSubmenuClickDisplay: function() {
            on(query('a.root, a.submenu, a.myAccount', dom.byId(this.ID_MOBILE_MENU)), 'click', lang.hitch(this, function(e) {
                if (domClass.contains(e.target, this.CSS_MOBILE_MENU_SUB_OPEN)) {
                    domClass.remove(e.target, this.CSS_MOBILE_MENU_SUB_OPEN);
                } else {
                    domClass.add(e.target, this.CSS_MOBILE_MENU_SUB_OPEN);
                }

                event.stop(e);
            }));
        },

        /*
         * DIARY NOTE
         */

        initDiaryNoteApi: function() {
            this.diaryNoteSaveHandlersVO = new HandlersVO(
                lang.hitch(this, this.onDiaryNoteSuccess),
                null,
                lang.hitch(this, this.onDiaryNoteUnauthorized),
                lang.hitch(this, this.onDiaryNoteError)
            );
        },

        initDiaryNote: function() {
            var diaryNote = dom.byId('sosNavigationHeaderDiaryNote');

            if (diaryNote) {
                var diaryNoteInput = query('input', diaryNote)[0];
                var diaryNoteButton = query('a', diaryNote)[0];

                if (diaryNoteButton && diaryNoteInput) {
                    // Stop events when clicking on the dialog
                    // so win.body on click doesnt close the dialog
                    on(diaryNote, 'click', function(e) {
                        event.stop(e);
                    });

                    on(diaryNoteButton, 'click', lang.hitch(this, function(e) {
                        if (this.isDiaryNoteOpen(diaryNote)) {
                            this.hideDiaryNote(diaryNote);
                        } else {
                            this.requestDialogClosure();

                            this.showDiaryNote(diaryNote);

                            focusUtil.focus(diaryNoteInput);
                        }

                        // Stop the event from continuing
                        // or it will hit the win.body click
                        event.stop(e);
                    }));

                    on(diaryNoteInput, 'focus', lang.hitch(this, function() {
                        this.showDiaryNote(diaryNote);
                    }));

                    topic.subscribe(this.TOPIC_REQUEST_DIALOG_CLOSURE, lang.hitch(this, function() {
                        this.hideDiaryNote(diaryNote);
                    }));

                    on(diaryNoteInput, 'keyup', lang.hitch(this, function(e) {
                        var charOrCode = e.charCode || e.keyCode;
                        var note = domAttr.get(e.target, 'value');

                        if (charOrCode == keys.ENTER || charOrCode == keys.ESCAPE) {
                            this.hideDiaryNote(diaryNote);

                            if (charOrCode == keys.ENTER && note &&  note != '') {
                                this.saveDiaryNote(note);

                                domAttr.set(diaryNoteInput, 'value', '');
                            }
                        }
                    }));

                    // Keyboard shortcut
                    var keyOrder = [this.KEY_CODE_D, this.KEY_CODE_N];
                    var keysPressed = [];

                    on(win.body(), 'keyup', lang.hitch(this, function(e) {
                        keysPressed.push(e.keyCode);

                        if (
                            !this.isUserFocusedOnInput() &&
                            this.arraysAreEqual(keysPressed, keyOrder)
                        ) {
                            this.requestDialogClosure();

                            this.showDiaryNote(diaryNote);

                            focusUtil.focus(diaryNoteInput);
                        } else if (
                            keysPressed[0] != keyOrder[0] ||
                            keysPressed.length >= keyOrder.length
                        ) {
                            keysPressed = []
                        }
                    }));

                    // Submit button
                    on(dom.byId('sosNavigationHeaderDiaryNoteSubmit'), 'click', lang.hitch(this, function(e) {
                        var note = domAttr.get(diaryNoteInput,  'value');

                        if (note && note != '') {
                            this.hideDiaryNote(diaryNote);

                            this.saveDiaryNote(note);

                            domAttr.set(diaryNoteInput, 'value', '');
                        }

                        event.stop(e);
                    }));

                    on(dom.byId('sosNavigationHeaderDiaryNoteInput'), 'focus', () => topic.publish(KeyboardShortcutToggleTopics.TOPIC_REQUEST_DISABLE_SHORTCUTS));

                    on(dom.byId('sosNavigationHeaderDiaryNoteInput'), 'blur', () => topic.publish(KeyboardShortcutToggleTopics.TOPIC_REQUEST_ENABLE_SHORTCUTS));

                    on(dom.byId('sosNavigationHeaderContactSearchInput'), 'focus', () => topic.publish(KeyboardShortcutToggleTopics.TOPIC_REQUEST_DISABLE_SHORTCUTS));

                    on(dom.byId('sosNavigationHeaderContactSearchInput'), 'blur', () => topic.publish(KeyboardShortcutToggleTopics.TOPIC_REQUEST_ENABLE_SHORTCUTS));
                }
            }
        },

        initDiaryNoteMobile: function() {
            var diaryNote = dom.byId('sosNavigationHeaderDiaryNoteMobile');

            if (diaryNote) {
                var diaryNoteInput =  query('input', diaryNote)[0];
                var diaryNoteSubmit = query('button.sos-navigation-header-diary-note-submit', diaryNote)[0];
                var diaryNoteCancel =  query('button.sos-navigation-header-diary-note-cancel', diaryNote)[0];
                var diaryNoteButton = query('a', diaryNote)[0];

                if (diaryNoteButton && diaryNoteInput) {
                    on(diaryNoteButton, 'click', lang.hitch(this, function() {
                        this.showDiaryNote(diaryNote);

                        focusUtil.focus(diaryNoteInput);
                    }));

                    on(diaryNoteInput, 'keyup', lang.hitch(this, function(e) {
                        var charOrCode = e.charCode || e.keyCode;
                        var note = domAttr.get(e.target, 'value');

                        if (charOrCode == keys.ENTER || charOrCode == keys.ESCAPE) {
                            this.hideDiaryNote(diaryNote);

                            if (charOrCode == keys.ENTER && note && note != '') {
                                this.saveDiaryNote(note);

                                domAttr.set(diaryNoteInput, 'value', '');
                            }
                        }
                    }));
                }

                if (diaryNoteSubmit && diaryNoteCancel) {
                    on(diaryNoteSubmit, 'click', lang.hitch(this, function() {
                        var note = domAttr.get(diaryNoteInput, 'value');

                        if (note && note != '') {
                            this.hideDiaryNote(diaryNote);
                            this.saveDiaryNote(note);
                            domAttr.set(diaryNoteInput, 'value', '');
                        }
                    }));

                    on(diaryNoteCancel, 'click', lang.hitch(this, function() {
                        this.hideDiaryNote(diaryNote);
                        domAttr.set(diaryNoteInput, 'value', '');
                    }));
                }
            }
        },

        showDiaryNote: function(diaryNote) {
            domClass.add(diaryNote, this.CSS_DIARY_NOTE_OPEN);
        },

        hideDiaryNote: function(diaryNote) {
            if (!this.navigationHeaderDiaryNoteWidgetExists()) {
                return;
            }

            domClass.remove(diaryNote, this.CSS_DIARY_NOTE_OPEN);
        },

        isDiaryNoteOpen: function(diaryNote) {
            return domClass.contains(diaryNote, this.CSS_DIARY_NOTE_OPEN);
        },

        navigationHeaderDiaryNoteWidgetExists: function() {
            return dom.byId('sosNavigationHeaderDiaryNote') || dom.byId('sosNavigationHeaderDiaryNoteMobile');
        },

        saveDiaryNote: function(note) {
            var vo = new DiaryNoteVO();
            vo.setNote(note);
            vo.setDiaryDate(this.createTodaysDate());

            this.diaryNoteApi.save(vo, this.diaryNoteSaveHandlersVO);
        },

        onDiaryNoteSuccess: function() {
            topic.publish('sos-system-notification', 'Diary note saved', 'success', 3000);
        },

        onDiaryNoteUnauthorized: function() {
            topic.publish('sos-system-notification', 'Authentication failed for diary note save', 'error', 0);

            console.error('User not authorized to save diary note');
        },

        onDiaryNoteError: function() {
            topic.publish('sos-system-notification', 'Sorry, failed to save diary note', 'error', 0);

            console.error('Failed to save diary note');
        },

        /*
         * CONTACT SEARCH
         */

        DEFAULT_CONTACT_SEARCH_OFFSET: 0,
        DEFAULT_CONTACT_SEARCH_LIMIT: 5,

        contactSearchQuery: null,
        contactSearchOffset: null,
        contactSearchLimit: null,

        contactSearchResults: [],

        initSearchContactCollectionApi: function() {
            this.searchContactCollectionFetchHandlersVO = new HandlersVO(
                lang.hitch(this, this.onSearchContactCollectionFetchSuccess),
                lang.hitch(this, this.onSearchContactCollectionFetchProgress),
                lang.hitch(this, this.onSearchContactCollectionFetchUnauthorized),
                lang.hitch(this, this.onSearchContactCollectionFetchError)
            );

            this.contactSearchOffset = this.DEFAULT_CONTACT_SEARCH_OFFSET;
            this.contactSearchLimit = this.DEFAULT_CONTACT_SEARCH_LIMIT;
        },

        initContactSearch: function() {
            var contactSearch = dom.byId('sosNavigationHeaderContactSearch');

            if (contactSearch) {
                var contactSearchInput = query('input', contactSearch)[0];
                var contactSearchButton = query('a', contactSearch)[0];

                if (contactSearchButton && contactSearchInput) {
                    on(contactSearchButton, 'click', lang.hitch(this, function(e) {
                        if (this.isContactSearchOpen(contactSearch)) {
                            this.hideContactSearch(contactSearch);
                        } else {
                            this.requestDialogClosure();

                            this.showContactSearchWithPrompt(contactSearch);

                            domAttr.set(contactSearchInput, 'value', '');

                            this.clearSearchContactCollection();

                            this.hideContactSearchPagination();

                            this.searchContactCollectionResetPagination();

                            focusUtil.focus(contactSearchInput);

                            // Stop the event from continuing
                            // or it will hit the win.body click
                            event.stop(e);
                        }
                    }));

                    on(contactSearchInput, 'focus', lang.hitch(this, function() {
                        this.showContactSearchWithPrompt(contactSearch);
                    }));

                    topic.subscribe(this.TOPIC_REQUEST_DIALOG_CLOSURE, lang.hitch(this, function() {
                        var contactSearchInput = query('input', contactSearch)[0];

                        if (focusUtil.curNode != contactSearchInput) {
                            this.hideContactSearch(contactSearch);
                        }
                    }));

                    on(contactSearchInput, 'keyup', lang.hitch(this, function(e) {
                        var charOrCode = e.charCode || e.keyCode;
                        var queryString = domAttr.get(e.target, 'value');

                        if (focusUtil.curNode == contactSearchInput) {
                            this._removeMultipleEvents(this.contactNavigationEvents);
                        }

                        if (charOrCode == keys.ESCAPE) {
                            focusUtil.curNode.blur();

                            this.hideContactSearch(contactSearch);
                        } else if (this.contactSearchResults.length > 0 && charOrCode == keys.DOWN_ARROW) {
                            var contactCardResults = query('.sos-contact-card-horizontal-keyboard-focus');
                            var contactCardClass = '.sos-contact-card-horizontal-keyboard-focus';
                            this.contactNavigationEvents = this._addContactNavigationEvents(
                                contactCardResults,
                                contactCardClass
                            );
                            this._removeContactNavigationOnHover(contactCardResults, contactCardClass);
                        } else {
                            if (this.contactSearchQuery != queryString) {
                                this.newContactSearchQuery(queryString);
                            }
                        }
                    }));

                    on(contactSearchInput, 'paste', lang.hitch(this, function() {
                        // Value isnt updated right away on an input
                        // so we have to add a slight delay
                        setTimeout(lang.hitch(this, function() {
                            if (this.contactSearchQuery != contactSearchInput.value) {
                                this.newContactSearchQuery(contactSearchInput.value);
                            }
                        }), 100);
                    }));

                    on(contactSearchInput, 'focus', lang.hitch(this, function(e) {
                        if (e.target.value != '' && this.contactSearchResults.length > 0) {
                            this.hideAllPlaceholders();
                        }
                    }));

                    // Pagination
                    on(dom.byId(this.ID_CONTACT_SEARCH_PAGINATION_PREV), 'click', lang.hitch(this, function(e) {
                        this.searchContactCollectionPrevPage();

                        event.stop(e);
                    }));
                    on(dom.byId(this.ID_CONTACT_SEARCH_PAGINATION_NEXT), 'click', lang.hitch(this, function(e) {
                        this.searchContactCollectionNextPage();

                        event.stop(e);
                    }));

                    // Keyboard shortcut
                    var keyOrder = [this.KEY_CODE_S, this.KEY_CODE_C];
                    var keysPressed = [];

                    on(win.body(), 'keyup', lang.hitch(this, function(e) {
                        keysPressed.push(e.keyCode);

                        if (!this.isUserFocusedOnInput() && this.arraysAreEqual(keysPressed, keyOrder)) {
                            this.requestDialogClosure();

                            this.showContactSearchWithPrompt(contactSearch);

                            domAttr.set(contactSearchInput, 'value', '');

                            this.clearSearchContactCollection();

                            focusUtil.focus(contactSearchInput);
                        } else if (
                            keysPressed[0] != keyOrder[0] ||
                            keysPressed.length >= keyOrder.length
                        ) {
                            keysPressed = []
                        }
                    }));

                    // Horizontal stacked contact list
                    this.horizontalStackedContactList = new HorizontalStackedContactList(
                        {
                            clickable: true,
                            resultClickDefaultBehaviour: true,
                            viewDocumentsLink: this.routeContainer.get('VIEW_DOCUMENTS'),
                            personResultLink: this.routeContainer.get('PERSON_RESULT_LINK'),
                            organisationResultLink: this.routeContainer.get('ORGANISATION_RESULT_LINK'),
                        },
                        dom.byId('sosNavigationHeaderContactSearchList')
                    );
                }
            }
        },

        initContactSearchMobile: function() {
            var contactSearch = dom.byId('sosNavigationHeaderSearchContactsMobile');

            if (contactSearch) {
                var contactSearchInput =  query('input', contactSearch)[0];
                var contactSearchButton = query('a', contactSearch)[0];
                var contactSearchClose =  query(
                    '.sos-navigation-header-contact-search-close',
                    contactSearch
                )[0];

                if (contactSearchButton && contactSearchInput) {
                    on(contactSearchButton, 'click', lang.hitch(this, function() {
                        this.showContactSearchWithPrompt(contactSearch);

                        domAttr.set(contactSearchInput, 'value', '');

                        this.clearSearchContactCollection();

                        focusUtil.focus(contactSearchInput);
                    }));

                    on(contactSearchInput, 'keyup', lang.hitch(this, function(e) {
                        const query = domAttr.get(e.target, 'value');

                        this.contactSearchQuery = query;

                        if (
                            query &&
                            query !== '' &&
                            query.length >= CONTACT_SEARCH_QUERY_MINIMUM_LENGTH
                        ) {
                            this.contactSearchResults = [];

                            this.searchContactCollectionFetchDelayed();
                        } else {
                            this.searchContactCollectionFetchCancel();

                            this.clearSearchContactCollection();
                        }
                    }));
                }

                if (contactSearchClose) {
                    on(contactSearchClose, 'click', lang.hitch(this, function() {
                        this.hideContactSearch(contactSearch);
                    }));
                }

                // Horizontal stacked contact list
                this.horizontalStackedContactListMobile = new HorizontalStackedContactList(
                    {
                        clickable: true,
                        resultClickDefaultBehaviour: true,
                        viewDocumentsLink: this.routeContainer.get('VIEW_DOCUMENTS'),
                        personResultLink: this.routeContainer.get('PERSON_RESULT_LINK'),
                        organisationResultLink: this.routeContainer.get('ORGANISATION_RESULT_LINK')
                    },
                    dom.byId('sosNavigationHeaderSearchContactsMobileList')
                );

                // More
                on(dom.byId('sosNavigationHeaderSearchContactsMobileMore'), 'click', lang.hitch(this, function(e) {
                    this.searchContactCollectionNextPage();

                    event.stop(e);
                }));
            }
        },

        showContactSearch: function(contactSearch) {
            domClass.add(contactSearch, this.CSS_CONTACT_SEARCH_OPEN);
        },

        showContactSearchWithPrompt: function(contactSearch) {
            this.showContactSearch(contactSearch);

            this.showPromptPlaceholder();
        },

        hideContactSearch: function(contactSearch) {
            domClass.remove(contactSearch, this.CSS_CONTACT_SEARCH_OPEN);
            this.closeTooltips();
            this.searchContactCollectionFetchCancel();
        },

        closeTooltips: function() {
            this.horizontalStackedContactList.closeTooltips();
            this.horizontalStackedContactListMobile.closeTooltips();
        },

        isContactSearchOpen: function(contactSearch) {
            return domClass.contains(contactSearch, this.CSS_CONTACT_SEARCH_OPEN);
        },

        searchContactCollectionNextPage: function() {
            this.closeTooltips();
            this.contactSearchOffset += this.DEFAULT_CONTACT_SEARCH_LIMIT;

            this.searchContactCollectionFetch();
        },

        searchContactCollectionPrevPage: function() {
            this.closeTooltips();
            if (this.contactSearchOffset > 0) {
                this.contactSearchOffset -= this.DEFAULT_CONTACT_SEARCH_LIMIT;

                this.searchContactCollectionFetch();
            }
        },

        searchContactCollectionResetPagination: function() {
            this.contactSearchOffset = this.DEFAULT_CONTACT_SEARCH_OFFSET;
            this.contactSearchLimit = this.DEFAULT_CONTACT_SEARCH_LIMIT;
        },

        searchContactCollectionFetchDelayed: function() {
            if (this.searchContactCollectionFetchTimeout) {
                clearTimeout(this.searchContactCollectionFetchTimeout);
            }

            this.searchContactCollectionFetchTimeout = setTimeout(
                this.searchContactCollectionFetch.bind(this),
                this.contactSearchQuery.length <= CONTACT_SEARCH_SHORT_QUERY_LENGTH ? CONTACT_SEARCH_DELAY_SHORT_QUERY : CONTACT_SEARCH_DELAY
            );
        },

        searchContactCollectionFetch: function() {
            this.searchContactCollectionFetchCancel();

            const fc = new FilterCollection().addFilter(new includeContactsWithoutEmailFilter);

            this.searchContactCollectionApi.setQuery(this.contactSearchQuery);
            this.searchContactCollectionApi.setOffset(this.contactSearchOffset);
            this.searchContactCollectionApi.setLimit(this.contactSearchLimit);
            this.searchContactCollectionFetchCanceller = this.searchContactCollectionApi.fetch(this.searchContactCollectionFetchHandlersVO, fc);

            this.showLoadingPlaceholder();
        },

        searchContactCollectionFetchCancel: function() {
            if (this.searchContactCollectionFetchCanceller) {
                this.searchContactCollectionFetchCanceller.cancel();
                this.searchContactCollectionFetchCanceller = null;
            }
        },

        onSearchContactCollectionFetchSuccess: function(contacts) {
            this.searchContactCollectionFetchCanceller = null;

            this.displaySearchContactCollection(contacts);

            if (contacts.length == 0) {
                this.showNoResultsPlaceholder();

                if (this.contactSearchResults.length == 0) {
                    this.hideContactSearchPagination();

                    this.searchContactCollectionResetPagination();
                } else {
                    this.showContactSearchPagination();
                }
            } else {
                this.hideAllPlaceholders();

                this.showContactSearchPagination();
            }
        },

        onSearchContactCollectionFetchProgress: function() {
        },

        onSearchContactCollectionFetchUnauthorized: function() {
            this.searchContactCollectionFetchCanceller = null;
        },

        onSearchContactCollectionFetchError: function() {
            this.searchContactCollectionFetchCanceller = null;
        },

        displaySearchContactCollection: function(contacts) {
            if (contacts.length == this.DEFAULT_CONTACT_SEARCH_LIMIT) {
                this.enableContactSearchPaginationNext();
                this.showContactSearchFooter();
            } else {
                this.disableContactSearchPaginationNext();
                this.hideContactSearchFooter();
            }

            this.contactSearchResults = this.contactSearchResults.concat(contacts);

            this.horizontalStackedContactList.setContacts(contacts);
            this.horizontalStackedContactListMobile.setContacts(this.contactSearchResults);
        },

        clearSearchContactCollection: function() {
            this.hideContactSearchFooter();

            this.contactSearchResults = [];

            this.horizontalStackedContactList.setContacts([]);
            this.horizontalStackedContactListMobile.setContacts([]);
        },

        hideAllPlaceholders: function() {
            domClass.remove(dom.byId(this.ID_CONTACT_SEARCH_NO_RESULTS), this.CSS_CONTACT_SEARCH_PLACEHOLDER_SHOW);
            domClass.remove(dom.byId(this.ID_CONTACT_SEARCH_PROMPT), this.CSS_CONTACT_SEARCH_PLACEHOLDER_SHOW);
            domClass.remove(dom.byId(this.ID_CONTACT_SEARCH_NO_RESULTS_MOBILE), this.CSS_CONTACT_SEARCH_PLACEHOLDER_SHOW);
            domClass.remove(dom.byId(this.ID_CONTACT_SEARCH_LOADING), this.CSS_CONTACT_SEARCH_PLACEHOLDER_SHOW);
            domClass.remove(dom.byId(this.ID_CONTACT_SEARCH_LOADING_MOBILE), this.CSS_CONTACT_SEARCH_PLACEHOLDER_SHOW);
        },

        showNoResultsPlaceholder: function() {
            this.hideAllPlaceholders();

            domClass.add(dom.byId(this.ID_CONTACT_SEARCH_NO_RESULTS), this.CSS_CONTACT_SEARCH_PLACEHOLDER_SHOW);
            domClass.add(dom.byId(this.ID_CONTACT_SEARCH_NO_RESULTS_MOBILE), this.CSS_CONTACT_SEARCH_PLACEHOLDER_SHOW);
        },

        showPromptPlaceholder: function() {
            this.hideAllPlaceholders();

            domClass.add(dom.byId(this.ID_CONTACT_SEARCH_PROMPT), this.CSS_CONTACT_SEARCH_PLACEHOLDER_SHOW);
        },

        showLoadingPlaceholder: function() {
            this.hideAllPlaceholders();

            domClass.add(dom.byId(this.ID_CONTACT_SEARCH_LOADING_MOBILE), this.CSS_CONTACT_SEARCH_PLACEHOLDER_SHOW);
            domClass.add(dom.byId(this.ID_CONTACT_SEARCH_LOADING), this.CSS_CONTACT_SEARCH_PLACEHOLDER_SHOW);
        },

        showContactSearchPagination: function() {
            domClass.add(dom.byId(this.ID_CONTACT_SEARCH_PAGINATION), this.CSS_CONTACT_SEARCH_PAGINATION_SHOW);

            if (this.contactSearchOffset == 0) {
                this.disableContactSearchPaginationPrevious();
            } else {
                this.enableContactSearchPaginationPrevious();
            }
        },

        disableContactSearchPaginationPrevious: function () {
            domAttr.set(dom.byId(this.ID_CONTACT_SEARCH_PAGINATION_PREV), 'disabled', 'disabled');
        },

        enableContactSearchPaginationPrevious: function () {
            domAttr.remove(dom.byId(this.ID_CONTACT_SEARCH_PAGINATION_PREV), 'disabled');
        },

        disableContactSearchPaginationNext: function () {
            domAttr.set(dom.byId(this.ID_CONTACT_SEARCH_PAGINATION_NEXT), 'disabled', 'disabled');
        },

        enableContactSearchPaginationNext: function () {
            domAttr.remove(dom.byId(this.ID_CONTACT_SEARCH_PAGINATION_NEXT), 'disabled');
        },

        hideContactSearchPagination: function() {
            domClass.remove(dom.byId(this.ID_CONTACT_SEARCH_PAGINATION), this.CSS_CONTACT_SEARCH_PAGINATION_SHOW);
        },

        showContactSearchFooter: function() {
            domClass.add(dom.byId(this.ID_CONTACT_SEARCH_FOOTER_MOBILE), this.CSS_CONTACT_SEARCH_FOOTER_SHOW);
        },

        hideContactSearchFooter: function() {
            domClass.remove(dom.byId(this.ID_CONTACT_SEARCH_FOOTER_MOBILE), this.CSS_CONTACT_SEARCH_FOOTER_SHOW);
        },

        newContactSearchQuery: function(query) {
            this.contactSearchQuery = query;

            if (query !== '' && query.length >= CONTACT_SEARCH_QUERY_MINIMUM_LENGTH) {
                this.contactSearchResults = [];

                this.searchContactCollectionResetPagination();

                this.searchContactCollectionFetchDelayed();
            } else {
                this.searchContactCollectionFetchCancel();

                this.clearSearchContactCollection();

                this.showPromptPlaceholder();

                this.hideContactSearchPagination();

                this.searchContactCollectionResetPagination();
            }
        },

        /*
         * FAVOURITES
         */

        initFavouriteApi: function() {
            this.favouriteFetchHandlersVO = new HandlersVO(
                lang.hitch(this, this.onFavouriteFetchSuccess),
                lang.hitch(this, this.onFavouriteFetchProgress),
                lang.hitch(this, this.onFavouriteFetchUnauthorized),
                lang.hitch(this, this.onFavouriteFetchError)
            );
        },

        initFavourites: function() {
            this.favouriteApi.fetch(this.favouriteFetchHandlersVO);
        },

        initFavouritesMobile: function() {
            on(query('a.sos-navigation-header-favourites', dom.byId(this.ID_MOBILE_MENU)), 'click', lang.hitch(this, function(e) {
                if (domClass.contains(e.target, this.CSS_MOBILE_MENU_SUB_OPEN)) {
                    domClass.remove(e.target, this.CSS_MOBILE_MENU_SUB_OPEN);
                } else {
                    domClass.add(e.target, this.CSS_MOBILE_MENU_SUB_OPEN);
                }

                event.stop(e);
            }));
        },

        onFavouriteFetchSuccess: function(favourites) {
            this.verticalFavouriteList = new VerticalFavouriteList(
                {},
                dom.byId('sosNavigationHeaderFavouriteList')
            );

            this.verticalFavouriteList.setFavourites(favourites);

            this.verticalFavouriteListMobile = new VerticalFavouriteList(
                {},
                dom.byId('sosNavigationHeaderFavouriteMobileList')
            );

            this.verticalFavouriteListMobile.setFavourites(favourites);
        },

        onFavouriteFetchProgress: function() {
        },

        onFavouriteFetchUnauthorized: function() {
            this.favouriteFetchCanceller = null;
        },

        onFavouriteFetchError: function() {
            this.favouriteFetchCanceller = null;
        },

        /*
         * ALERTS
         */

        initFavouriteAlertApi: function() {
            this.favouriteAlertFetchHandlersVO = new HandlersVO(
                lang.hitch(this, this.onFavouriteAlertFetchSuccess),
                lang.hitch(this, this.onFavouriteAlertFetchProgress),
                lang.hitch(this, this.onFavouriteAlertFetchUnauthorized),
                lang.hitch(this, this.onFavouriteAlertFetchError)
            );
        },

        initFavouriteAlerts: function() {
            this.favouriteAlertApi.fetch(this.favouriteAlertFetchHandlersVO);
        },

        initFavouriteAlertsMobile: function() {
            on(query('a.sos-navigation-header-alerts', dom.byId(this.ID_MOBILE_MENU)), 'click', lang.hitch(this, function(e) {
                if (domClass.contains(e.target, this.CSS_MOBILE_MENU_SUB_OPEN)) {
                    domClass.remove(e.target, this.CSS_MOBILE_MENU_SUB_OPEN);
                } else {
                    domClass.add(e.target, this.CSS_MOBILE_MENU_SUB_OPEN);
                }

                event.stop(e);
            }));
        },

        onFavouriteAlertFetchSuccess: function(alerts) {
            this.verticalFavouriteAlertsList = new VerticalFavouriteList(
                {},
                dom.byId('sosNavigationHeaderFavouriteAlertList')
            );

            this.verticalFavouriteAlertsList.setAlerts(alerts);

            this.verticalFavouriteAlertListMobile = new VerticalFavouriteList(
                {},
                dom.byId('sosNavigationHeaderAlertMobileList')
            );

            this.verticalFavouriteAlertListMobile.setAlerts(alerts);
        },

        onFavouriteAlertFetchProgress: function() {
        },

        onFavouriteAlertFetchUnauthorized: function() {
            this.favouriteAlertFetchCanceller = null;
        },

        onFavouriteAlertFetchError: function() {
            this.favouriteAlertFetchCanceller = null;
        },

        /*
         * UTILS
         */

        requestDialogClosure: function() {
            topic.publish(this.TOPIC_REQUEST_DIALOG_CLOSURE);
        },

        arraysAreEqual: function(array1, array2) {
            if (array1.length != array2.length) {
                return false;
            }

            for (var i = 0; i < array1.length; i++) {
                if (array1[i] != array2[i]) {
                    return false;
                }
            }

            return true;
        },

        createTodaysDate: function() {
            var date = new Date();
            return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
        },

        isUserFocusedOnInput: function() {
            return focusUtil.curNode != null;
        },

        /*
         * MENU INTENT
         */

        rootListItemTimeout: null,
        activeListItem: null,
        lastEnteredListItem: null,
        mouseHasLeftTheMenu: false,
        isMovingTowardsActiveListItemMenu: false,
        isMouseOverSubmenu: false,
        mouseIsStaticTimeoutId: null,
        mouseCoordinateLog: [],

        AMOUNT_OF_TIME_UNTIL_MOUSE_STATIC_ROOT: 250,
        AMOUNT_OF_TIME_UNTIL_MOUSE_STATIC: 75,
        MOUSE_LOCS_TRACKED: 3,
        HIT_TEST_RECTANGLE_BUFFER_X: 10,
        HIT_TEST_RECTANGLE_BUFFER_Y: 25,

        CSS_MENU_OPEN: 'open',
        CSS_HEADER_NO_JAVASCRIPT: 'sos-navigation-header-system-no-javascript',
        CSS_ROOT_LINK: 'root',

        DOM_MENU: 'ul',
        DOM_MENU_ELEMENT: 'li',
        DOM_ROOT_LINK: 'a',

        initMenuIntent: function() {
            var menu = dom.byId(this.ID_HEADER_SYSTEM);

            // Make menu javascript enabled
            domClass.remove(menu, this.CSS_HEADER_NO_JAVASCRIPT);

            var elements = query(this.DOM_MENU_ELEMENT, menu);

            for (var i = 0; i < elements.length; i++) {
                var el = elements[i];

                var isRoot = query(this.DOM_ROOT_LINK + '.' + this.CSS_ROOT_LINK, el).length > 0;

                if (!isRoot) {
                    on(el, 'mouseenter', lang.hitch(this, this.onListItemMouseEnter));
                    on(el, 'mouseleave', lang.hitch(this, this.onListItemMouseLeave));
                } else {
                    on(el, 'mouseenter', lang.hitch(this, this.onRootListItemMouseEnter));
                    on(el, 'mouseleave', lang.hitch(this, this.onRootListItemMouseLeave));
                }
            }

            on(menu, 'mouseleave', lang.hitch(this, this.onMenuMouseLeave));

            on(win.body(), 'mousemove', lang.hitch(this, this.onDocumentMouseMove));
            on(win.doc, 'mouseout', lang.hitch(this, this.onWindowDocumentMouseOut));
        },

        onWindowDocumentMouseOut: function(e) {
            var from = e.relatedTarget || e.toElement;
            if (!from || from.nodeName == 'HTML') {
                this.hideAllMenus(query(this.DOM_MENU_ELEMENT, dom.byId(this.ID_HEADER_SYSTEM)));
            }
        },

        onListItemMouseEnter: function(e) {
            var listItem = e.target;

            this.mouseHasLeftTheMenu = false;
            this.lastEnteredListItem = listItem;

            if (this.mouseIsStaticTimeoutId) {
                return;
            }

            if (!this.isMovingTowardsActiveListItemMenu) {
                if (this.activeListItem) {
                    this.hideMenu(this.activeListItem);
                }

                if (domClass.contains(e.target, this.CSS_ROOT_LINK)) {
                    this.activeListItem = null;
                } else {
                    this.activeListItem = listItem;
                }

                this.showMenu(listItem);
            }
        },

        onRootListItemMouseEnter: function(e) {
            if (this.rootListItemTimeout) {
                clearTimeout(this.rootListItemTimeout);
            }

            this.rootListItemTimeout = setTimeout(lang.hitch(this, function() {
                this.mouseHasLeftTheMenu = false;

                // Hide other roots
                var rootAnchors = query(
                    this.DOM_ROOT_LINK + '.' + this.CSS_ROOT_LINK,
                    dom.byId(this.ID_HEADER_SYSTEM)
                );

                for (var i = 0; i < rootAnchors.length; i++) {
                    this.hideMenu(rootAnchors[i].parentElement);
                }

                this.requestDialogClosure();

                this.showMenu(e.target);
            }), this.AMOUNT_OF_TIME_UNTIL_MOUSE_STATIC_ROOT);
        },

        onRootListItemMouseLeave: function(e) {
            if (this.rootListItemTimeout) {
                clearTimeout(this.rootListItemTimeout);
            }

            this.rootListItemTimeout = setTimeout(lang.hitch(this, function() {
                if (!this.activeListItem) {
                    this.hideMenu(e.target);
                }
            }), this.AMOUNT_OF_TIME_UNTIL_MOUSE_STATIC_ROOT);
        },

        onListItemMouseLeave: function(e) {
            this.lastEnteredListItem = null;
        },

        onMenuMouseLeave: function() {
            this.mouseHasLeftTheMenu = true;

            if (this.mouseIsStaticTimeoutId) {
                return;
            }

            if (!this.isMovingTowardsActiveListItemMenu && !this.isMouseOverSubmenu && this.activeListItem != null) {
                this.hideAllMenus(query(this.DOM_MENU_ELEMENT, dom.byId(this.ID_HEADER_SYSTEM)));
                this.closeTooltips();

                this.activeListItem = null;
                this.lastEnteredListItem = null;
            }
        },

        onDocumentMouseMove: function(e) {
            this.isMouseOverSubmenu = false;
            var result = false;

            if (this.activeListItem) {
                if (this.mouseIsStaticTimeoutId) {
                    clearTimeout(this.mouseIsStaticTimeoutId);
                    this.mouseIsStaticTimeoutId = null;
                }

                var previous = null;
                if (this.mouseCoordinateLog.length) {
                    previous = this.mouseCoordinateLog[this.mouseCoordinateLog.length - 1];
                }
                var current = {x: e.pageX, y: e.pageY};

                this.mouseCoordinateLog.push(current);

                if (this.mouseCoordinateLog.length > this.MOUSE_LOCS_TRACKED) {
                    this.mouseCoordinateLog.shift();
                }

                // Get the UL element (if we dont have one theres no submenu)
                var unorderedList = query(this.DOM_MENU, this.activeListItem)[0];
                if (unorderedList) {
                    var coords = domGeometry.position(unorderedList);

                    // When the page is scrolled, 'current' is the absolute position, 'coords' is the viewpoint position
                    var navCoords = domGeometry.position(query(' > ' + this.DOM_MENU, dom.byId(this.ID_HEADER_SYSTEM))[0]);
                    coords.y = (coords.y - navCoords.y);

                    if (this.hitTestRectangularBounds(current, coords)) {
                        this.isMouseOverSubmenu = true;
                        result = true;
                    } else {
                        // If mouse is static for a certain period of time
                        this.mouseIsStaticTimeoutId = setTimeout(
                            lang.hitch(this, this.mouseHasBecomeStatic),
                            this.AMOUNT_OF_TIME_UNTIL_MOUSE_STATIC
                        );

                        if (previous) {
                            result = this.hitTestTriangularBounds(
                                current,
                                previous,
                                {x: coords.x, y: coords.y},
                                {x: coords.x, y: coords.y + coords.h}
                            );
                        }
                    }
                }
            }

            this.isMovingTowardsActiveListItemMenu = result;
        },

        mouseHasBecomeStatic: function() {
            this.isMovingTowardsActiveListItemMenu = false;
            this.mouseIsStaticTimeoutId = null;

            if (this.mouseHasLeftTheMenu) {
                this.onMenuMouseLeave();
                return;
            }

            if (this.activeListItem && this.lastEnteredListItem && this.activeListItem != this.lastEnteredListItem) {
                this.hideMenu(this.activeListItem);
                this.showMenu(this.lastEnteredListItem);

                this.activeListItem = this.lastEnteredListItem;
            }
        },

        hitTestRectangularBounds: function(point, bounds) {
            return point.x >= bounds.x &&
                   point.x <= bounds.x + (bounds.w + this.HIT_TEST_RECTANGLE_BUFFER_X) &&
                   point.y >= bounds.y &&
                   point.y <= bounds.y + (bounds.h + this.HIT_TEST_RECTANGLE_BUFFER_Y)
        },

        hitTestTriangularBounds: function(point, vertex1, vertex2, vertex3) {
            var alpha = ((vertex2.y - vertex3.y) * (point.x - vertex3.x) + (vertex3.x - vertex2.x) * (point.y - vertex3.y)) /
                        ((vertex2.y - vertex3.y) * (vertex1.x - vertex3.x) + (vertex3.x - vertex2.x) * (vertex1.y - vertex3.y));
            var beta = ((vertex3.y - vertex1.y) * (point.x - vertex3.x) + (vertex1.x - vertex3.x) * (point.y - vertex3.y)) /
                       ((vertex2.y - vertex3.y) * (vertex1.x - vertex3.x) + (vertex3.x - vertex2.x) * (vertex1.y - vertex3.y));
            var gamma = 1.0 - alpha - beta;

            return alpha > 0 && beta > 0 && gamma > 0;
        },

        showMenu: function(listItem) {
            domClass.add(listItem, this.CSS_MENU_OPEN);
        },

        hideMenu: function(listItem) {
            domClass.remove(listItem, this.CSS_MENU_OPEN);
        },

        hideAllMenus: function(listItems) {
            for (var i = 0; i < listItems.length; i++) {
                this.hideMenu(listItems[i]);
            }
        },
        _removeMultipleEvents: function(eventArray) {
            array.forEach(eventArray, function(event) {
                event.remove();
            })
        },

        _addContactNavigationEvents: function(contactNodes, contactResultsClass) {
            var currentNode = contactNodes[0];
            focusUtil.focus(currentNode);

            return query(contactResultsClass).on('keyup', lang.hitch(this, function(e) {
                var charOrCode = e.charCode || e.keyCode;
                this._preventWindowFromScrolling(charOrCode);

                if (charOrCode == keys.DOWN_ARROW) {
                    currentNode = this._focusOnNextSibling(currentNode);
                } else if (charOrCode == keys.UP_ARROW) {
                    currentNode = this._focusOnPreviousSibling(currentNode);
                } else if (charOrCode == keys.ESCAPE) {
                    this.hideContactSearch(dom.byId('sosNavigationHeaderSearchContactsMobile'));
                }
            }));
        },

        _preventWindowFromScrolling: function(charOrCode) {
            var preventScrollingEventHandler = on(window, "keydown", function(e) {
                if(charOrCode == keys.DOWN_ARROW || charOrCode == keys.UP_ARROW) {
                    e.preventDefault();
                    preventScrollingEventHandler.remove();
                }
            });
        },

        _focusOnNextSibling: function(currentNode) {
            focusUtil.curNode.blur();
            if (currentNode.nextElementSibling) {
                currentNode = currentNode.nextElementSibling;
            }
            focusUtil.focus(currentNode);
            return currentNode;
        },

        _focusOnPreviousSibling: function(currentNode) {
            focusUtil.curNode.blur();
            if (currentNode.previousElementSibling) {
                currentNode = currentNode.previousElementSibling;
            }
            focusUtil.focus(currentNode);
            return currentNode;
        },

        _removeContactNavigationOnHover: function(contactCardResults) {
            array.forEach(contactCardResults, function(contactCard) {
                on(contactCard, 'mouseover', lang.hitch(this, function(e) {
                    if (focusUtil.curNode) {
                        focusUtil.curNode.blur();
                    }
                }));
            }, this);
        }
    });
});

},
'api/diary/data/DiaryNote':function(){
define([], function() {
    var DiaryNote = function() {
        this.diaryNotePK = null;
        this.projectStagePK = null;
        this.note = null;
        this.personPKCreated = null;
        this.diaryDate = null;
        this.timeCreated = null;
    };

    DiaryNote.prototype.getDiaryNotePK = function() {
        return this.diaryNotePK;
    };

    DiaryNote.prototype.setDiaryNotePK = function(diaryNotePK) {
        this.diaryNotePK = diaryNotePK;
    };

    DiaryNote.prototype.getProjectStagePK = function() {
        return this.projectStagePK;
    };

    DiaryNote.prototype.setProjectStagePK = function(projectStagePK) {
        this.projectStagePK = projectStagePK;
    };

    DiaryNote.prototype.getNote = function() {
        return this.note;
    };

    DiaryNote.prototype.setNote = function(note) {
        this.note = note;
    };

    DiaryNote.prototype.getPersonPKCreated = function() {
        return this.personPKCreated;
    };

    DiaryNote.prototype.setPersonPKCreated = function(personPKCreated) {
        this.personPKCreated = personPKCreated;
    };

    DiaryNote.prototype.getDiaryDate = function() {
        return this.diaryDate;
    };

    DiaryNote.prototype.setDiaryDate = function(diaryDate) {
        this.diaryDate = diaryDate;
    };

    DiaryNote.prototype.getTimeCreated = function() {
        return this.timeCreated;
    };

    DiaryNote.prototype.setTimeCreated = function(timeCreated) {
        this.timeCreated = timeCreated;
    };
    
    return DiaryNote;
});

},
'style-guide/v1/contacts/HorizontalStackedList':function(){
define([
    'api/contact/data/Contact',
    'api/search/data/Contact',
    'dojo/_base/declare',
    'dojo/_base/event',
    'dojo/dom-attr',
    'dojo/Evented',
    'dijit/_WidgetBase',
    'dojo/text!./templates/HorizontalStackedList.html',
    'dojo/text!./templates/ExtendedTradeList.html',
    'soso/sosox/ejs/_Templated',
    'style-guide/v1/tooltip/Tooltip',
    'vendor/ejs/ejs'
], function(
    Contact,
    SearchContact,
    declare,
    event,
    domAttr,
    Evented,
    _WidgetBase,
    template,
    ExtendedTradeListTemplate,
    _TemplatedMixin,
    Tooltip,
    ejs
) {
    const SEARCH_CONTACT_TYPE_EMPLOYEE = 'Employee';
    const SEARCH_CONTACT_TYPE_ORGANISATION = 'Organisation';
    const SEARCH_CONTACT_TYPE_SUBCONTRACTOR = 'Subcontractor';

    return declare('style-guide.v1.contacts.horizontal-stacked-list', [_WidgetBase, _TemplatedMixin, Evented], {
        clickable: false,
        contacts: [],
        resultClickDefaultBehaviour: false,
        organisationResultLink: null,
        personResultLink: null,
        templateString: template,
        tradeTooltip: null,
        viewDocumentsLink: null,

        data: {
            clickable: false,
            contacts: [],
            resultClickDefaultBehaviour: false,
            isClientInstance: dojoConfig.isClientInstance
        },

        setContacts: function(contacts) {
            this.contacts = contacts;

            this._initTemplateSettingData();
            this._initContactData(contacts);

            this.render();
        },

        showTrades: function(e) {
            const index = domAttr.get(e.currentTarget, 'data-index');
            this.closeTooltips();
            this.tradeTooltip = new Tooltip({
                'class': 'extended-trade-list',
                target: e.currentTarget,
                postition: 'left',
                data: {
                    content: ejs.render(
                        ExtendedTradeListTemplate,
                        {
                            trades: this.data.contacts[index].trades
                        }
                    )
                },
                closeToDismiss: true
            });
        },

        closeTooltips: function() {
            if (this.tradeTooltip) {
                this.tradeTooltip.close();
            }
        },

        _initTemplateSettingData: function() {
            this.data.clickable = this.clickable;
            this.data.resultClickDefaultBehaviour = this.resultClickDefaultBehaviour;
            this.data.canViewDocuments = !!this.viewDocumentsLink;
        },

        _initContactData: function(contacts) {
            const r = [];
            for (let i = 0; i < contacts.length; i++) {
                if (contacts[i] instanceof Contact) {
                    r.push(this._contactToTemplateData(contacts[i]));
                } else if (contacts[i] instanceof SearchContact) {
                    r.push(this._searchContactToTemplateData(contacts[i]));
                } else {
                    console.error('Unsupported contact data');
                }
            }
            this.data.contacts = r;
        },

        _contactToTemplateData: function(contact) {
            return this._createContactTemplateData(
                this._getCardTypeClassFromContact(contact),
                contact.getEmail(),
                contact.getContactPK(),
                contact.getJobTitle(),
                contact.getPreferredName() ? contact.getPreferredName() : contact.getName(),
                contact.getOrganisation(),
                this._getContactType(contact),
                [],
                contact.getImageUrl(),
                null
            );
        },

        _searchContactToTemplateData: function(searchContact) {
            return this._createContactTemplateData(
                this._getCardTypeClassFromSearchContact(searchContact),
                null,
                searchContact.getId(),
                searchContact.getJobTitle(),
                searchContact.getPreferredName() ? searchContact.getPreferredName() : searchContact.getName(),
                searchContact.getOrganisation(),
                searchContact.getType(),
                searchContact.getTrades(),
                searchContact.getImageURL(),
                searchContact.getTelephone()
            );
        },

        _createContactTemplateData: function(
            cardType,
            email,
            id,
            jobTitle,
            name,
            organisation,
            type,
            trades,
            imageUrl,
            telephone
        ) {
            return {
                cardType: cardType,
                email: email,
                id: id,
                jobTitle: jobTitle,
                name: name,
                organisation: organisation,
                type: type,
                trades: trades || [],
                imageUrl: imageUrl || null,
                telephone: telephone || null
            };
        },

        _getContactType: function(contact) {
            if (contact.isBranchOffice()) {
                return 'Branch Office';
            }

            if (contact.isExternal()) {
                return 'External'
            }

            if (contact.isSc()) {
                return 'Subcontractor'
            }

            return '';
        },

        _getCardTypeClassFromContact: function(contact) {
            let cardTypeClass = 'sos-contact-card-horizontal-';

            if (contact.isBranchOffice()) {
                return cardTypeClass + 'organisation';
            } else if (!contact.isExternal()) {
                return cardTypeClass + 'spencer-employee';
            } else if (contact.isSc()) {
                return cardTypeClass + 'subcontractor';
            }

            return cardTypeClass + 'external-person';
        },

        _getCardTypeClassFromSearchContact: function(searchContact) {
            let cardTypeClass = 'sos-contact-card-horizontal-';

            if (searchContact.getType() === SEARCH_CONTACT_TYPE_ORGANISATION) {
                return cardTypeClass + 'organisation';
            } else if (searchContact.getType() === SEARCH_CONTACT_TYPE_EMPLOYEE) {
                return cardTypeClass + 'spencer-employee';
            } else if (searchContact.getType() === SEARCH_CONTACT_TYPE_SUBCONTRACTOR) {
                return cardTypeClass + 'subcontractor';
            }

            return cardTypeClass + 'external-person';
        },

        _onContactClick: function(e) {
            this.emit('selected', this._getContactForID(domAttr.get(e.currentTarget, 'data-id')));

            event.stop(e);
        },

        _redirectToResultLink: function(e) {
            e.stopPropagation();

            const contact = this._getContactForID(domAttr.get(e.currentTarget, 'data-id'));
            if (contact.personPK) {
                window.location.href = this.personResultLink
                    .replace(':organisationPK', contact.organisationPK)
                    .replace(':personPK', contact.personPK);
                return;
            }

            window.location.href = this.organisationResultLink
                .replace(':organisationPK', contact.organisationPK);
        },

        _onViewDocumentsClick: function(e) {
            e.stopPropagation();

            const c = this._getContactForID(domAttr.get(e.currentTarget, 'data-id'));

            if (c.getType() === SEARCH_CONTACT_TYPE_ORGANISATION) {
                window.location.href = this.viewDocumentsLink
                    .replace(':originator', encodeURIComponent('["' + c.getName() + '"]'))
                    .concat('/interchangeableOriginatorRecipient/true/page/1/limit/15');
                return;
            }

            window.location.href = this.viewDocumentsLink
                .replace(':originator', encodeURIComponent('["' + c.getName() + ' - ' + c.getOrganisation() + '"]'))
                .concat('/interchangeableOriginatorRecipient/true/page/1/limit/15');
        },

        _getContactForID: function(id) {
            for (let i = 0; i < this.contacts.length; i++) {
                if (
                    (this.contacts[i] instanceof Contact &&
                    this.contacts[i].getContactPK() === parseInt(id)) ||
                    (this.contacts[i] instanceof SearchContact &&
                    this.contacts[i].getId() === id)
                ) {
                    return this.contacts[i];
                }
            }

            return null;
        }
    });
});

},
'style-guide/v1/favourites/VerticalList':function(){
define([
    './EmptyItem',
    './Item',
    'dojo/dom-construct',
    'dojo/_base/declare',
    'dijit/_WidgetBase',
    'dojo/text!./templates/VerticalList.html',
    'soso/sosox/ejs/_Templated'
], function(
    EmptyItem,
    Item,
    domConstruct,
    declare,
    _WidgetBase,
    template,
    _TemplatedMixin
) {
    return declare('style-guide.v1.favourites.VerticalList', [_WidgetBase, _TemplatedMixin], {
        templateString: template,
        _favouriteTypeFavourite: "favourite",
        _favouriteTypeAction: "action",
        _favouriteTypeAlert: "alert",

        data: {
            favourites: [],
            type: this._favouriteTypeFavourite
        },

        setFavourites: function(favourites) {
            favourites.forEach(function(favourite) {
                new Item({
                    data: {favourite: favourite}
                }, domConstruct.create('li', null, this.list, 'last'))
            }.bind(this));

            if (favourites.length === 0) {
                new EmptyItem({
                    data: {type: this._favouriteTypeFavourite}
                }, domConstruct.create('li', null, this.list))
            }
        },

        setAlerts: function(alerts) {
            alerts.forEach(function(alert) {
                new Item({
                    data: {favourite: alert}
                }, domConstruct.create('li', null, this.list, 'last'))
            }.bind(this));

            if (alerts.length === 0) {
                new EmptyItem({
                    data: {type: this._favouriteTypeAlert}
                }, domConstruct.create('li', null, this.list))
            }
        },

        setActions: function(actions) {
            actions.forEach(function(action) {
                new Item({
                    data: {favourite: action}
                }, domConstruct.create('li', null, this.list, 'last'))
            }.bind(this));

            if (actions.length === 0) {
                new EmptyItem({
                    data: {type: this._favouriteTypeAction}
                }, domConstruct.create('li', null, this.list))
            }
        }
    })
});

},
'style-guide/v1/favourites/EmptyItem':function(){
define([
    'dojo/_base/declare',
    'dojo/text!./templates/EmptyItem.html',
    './Item'
], function(
    declare,
    template,
    Item
) {
    return declare('style-guide.v1.favourites.Item', Item, {
        templateString: template,

        _favouriteTypeFavourite: 'favourite',

        data: {
            type: this._favouriteTypeFavourite
        }
    })
});

},
'style-guide/v1/favourites/Item':function(){
define([
    'dojo/_base/declare',
    "dojo/_base/event",
    'dijit/_WidgetBase',
    'dojo/text!./templates/Item.html',
    'soso/sosox/ejs/_Templated'
], function(
    declare,
    event,
    _WidgetBase,
    template,
    _TemplatedMixin
) {
    const MISSING_TREE_NODE_MESSAGE = 'The location no longer exists for this :type.  Please delete it and add a new one if required.';
    const ALERT_LIST_TYPE = 'Alert';
    const ACTION_LIST_TYPE = 'Action';
    const ACTION_MESSAGE_TYPE = 'action';
    const ALERT_MESSAGE_TYPE = 'alert';
    const FAVOURITE_MESSAGE_TYPE = 'favourite';

    return declare('style-guide.v1.favourites.Item', [_WidgetBase, _TemplatedMixin], {
        templateString: template,

        data: {
            favourite: null,
        },

        postMixInProperties: function() {
            this.inherited(arguments);

            this.setCustomViewHelpers({
                isValid: function(){
                    if (this.data.favourite.url || this.data.favourite.projectStageTreeViewPK || this.data.favourite.type === 'Document Search') {
                        return true;
                    }
                    return false;
                }.bind(this),
                getIcon: (favouriteList) => {
                    if (favouriteList === ALERT_LIST_TYPE) {
                        return 'sos-icon-bell';
                    }

                    return 'sos-icon-star';
                }
            });
        },

        _click: function(evt) {
            let type = FAVOURITE_MESSAGE_TYPE;

            if (this.data.favourite.list === ALERT_LIST_TYPE) {
                type = ALERT_MESSAGE_TYPE;
            } else if (this.data.favourite.list === ACTION_LIST_TYPE) {
                type = ACTION_MESSAGE_TYPE;
            }

            event.stop(evt);

            alert(MISSING_TREE_NODE_MESSAGE.replace(':type', type));
        }
    })
});

},
'style-guide/v1/layout/KeyboardShortcutToggleTopics':function(){
define([], function() {
    return {
        TOPIC_REQUEST_ENABLE_SHORTCUTS: 'sos-system-disable-shortcuts',
        TOPIC_REQUEST_DISABLE_SHORTCUTS: 'sos-system-enable-shortcuts'
    }
});
},
'style-guide/v1/notifications/SystemNotificationQueue':function(){
define([
    'dojo/_base/declare',
    'dojo/_base/window',
    'dojo/dom-construct',
    'dojo/topic',
    'dijit/_WidgetBase',
    './SystemNotification'
], function(
    declare,
    win,
    domConstruct,
    topic,
    WidgetBase,
    SystemNotification
) {
    return declare('style-guide.v1.navigation.system-notification-queue', [WidgetBase], {
        CSS_CLASS_CONTAINER: 'sos-v1 sos-notification-container',

        TOPIC_CREATE: 'sos-system-notification',
        TOPIC_CREATE_PROGRESS: 'sos-system-notification-progress',
        TOPIC_UPDATE_PROGRESS: 'sos-system-notification-progress-update',
        TOPIC_CANCEL_PROGRESS: 'sos-system-notification-progress-cancel',
        TOPIC_UPDATE_MESSAGE: 'sos-system-notification-message-update',
        TOPIC_COMPLETE_PROGRESS: 'sos-system-notification-progress-complete',
        TOPIC_CLOSE_ALL: 'sos-system-notification-close-all',
        TOPIC_READY: 'sos-system-notification-ready',

        TYPE_INFORMATION: 'information',
        TYPE_SUCCESS: 'success',
        TYPE_ERROR: 'error',
        TYPE_WARNING: 'warning',
        TYPE_PROGRESS: 'progress',

        container: null,

        notifications: [],
        progressNotifications: {},

        containerPlacementNode: win.body(),

        postCreate: function() {
            this.container = domConstruct.create('div', {
                'class': this.CSS_CLASS_CONTAINER
            }, this.containerPlacementNode);

            // Create standard
            topic.subscribe(this.TOPIC_CREATE, function(message, type, autoHideTime, imageURL, clickCallback) {
                if (this.isValidType(type)) {
                    var placeholder = domConstruct.create('p', {}, this.container, 'last');
                    this.notifications.push(new SystemNotification({data:{
                        message: message,
                        type: type,
                        autoHideTime: autoHideTime,
                        imageURL: imageURL,
                        clickCallback: clickCallback
                    }}, placeholder));
                }
            }.bind(this));

            // Close all
            topic.subscribe(this.TOPIC_CLOSE_ALL, function(config) {
                var _notifications = [];
                for (var i = 0; i < this.notifications.length; i++) {
                    if (this.notifications[i]) {
                        var hide = typeof config === "undefined" || typeof config.type === "undefined" || this.notifications[i].getType() == config.type;

                        if (hide) {
                            if (typeof config !== "undefined" && typeof config.duration !== "undefined") {
                                this.notifications[i].ANIMATION_FADE_DURATION = config.duration;
                            }

                            this.notifications[i].hide();
                        } else {
                            _notifications.push(this.notifications[i]);
                        }
                    }
                }

                this.notifications = _notifications;
            }.bind(this));

            // Create progress
            topic.subscribe(this.TOPIC_CREATE_PROGRESS, function(message, uid, notificationData) {
                var placeholder = domConstruct.create('p', {}, this.container, 'first');

                const defaultData = {
                    message: message,
                    type: this.TYPE_PROGRESS
                };

                this.progressNotifications[uid] = new SystemNotification({data: {
                    ...defaultData, ...(notificationData && typeof notificationData == 'object' ? notificationData : {})
                }}, placeholder);

                this.progressNotifications[uid].setProgress(50);
            }.bind(this));

            // Update progress
            topic.subscribe(this.TOPIC_UPDATE_PROGRESS, function(uid, percentage) {
                if (this.progressNotifications[uid]) {
                    this.progressNotifications[uid].setProgress(percentage);
                }
            }.bind(this));

            // Update message
            topic.subscribe(this.TOPIC_UPDATE_MESSAGE, function(uid, message) {
                if (this.progressNotifications[uid]) {
                    this.progressNotifications[uid].setMessage(message);
                }
            }.bind(this));

            // Cancel progress
            topic.subscribe(this.TOPIC_CANCEL_PROGRESS, function(uid) {
                if (this.progressNotifications[uid]) {
                    this.progressNotifications[uid].hide();
                }
            }.bind(this));

            // Complete progress
            topic.subscribe(this.TOPIC_COMPLETE_PROGRESS, function(uid, message, type, autoHideTime) {
                if (this.progressNotifications[uid]) {
                    this.progressNotifications[uid].redisplay(message, type, autoHideTime);
                }
            }.bind(this));

            topic.publish(this.TOPIC_READY);
        },

        isValidType: function(type) {
            return type === this.TYPE_INFORMATION ||
                type === this.TYPE_SUCCESS ||
                type === this.TYPE_ERROR ||
                type === this.TYPE_WARNING ||
                type === this.TYPE_PROGRESS
        }
    });
});

},
'style-guide/v1/notifications/SystemNotification':function(){
define([
    'dojo/dom',
    'dojo/dom-construct',
    'dojo/dom-geometry',
    'dojo/dom-style',
    'dojo/html',
    'dojo/query',
    'dojo/fx/easing',
    'dojo/on',
    'dojo/_base/declare',
    'dojo/_base/fx',
    'dijit/_WidgetBase',
    'dojo/text!./templates/SystemNotification.html',
    'soso/sosox/ejs/_Templated',
    'dojox/html/entities',
    'spencer/encoding/HTML'
], function(
    dom,
    domConstruct,
    domGeometry,
    domStyle,
    html,
    query,
    easing,
    on,
    declare,
    fx,
    _WidgetBase,
    template,
    _TemplatedMixin,
    dojoHtmlEntities,
    HTMLEncoding
) {
    return declare('style-guide.v1.navigation.system-notification', [_WidgetBase, _TemplatedMixin], {
        ANIMATION_FADE_DURATION: 300,
        ANIMATION_PROGRESS_UPDATE_DURATION: 3000,

        WHITE_LIST_REPLACEMENTS: ['&amp;pound;', '£', '&amp;', '&'],
        WHITE_LIST_HTML_TAGS: ['b', 'br', 'i', 'span', 'a'],

        templateString: template,
        templateMessage: null,
        templateProgressBarWidth: 0,

        progressAnimationHandle: null,
        htmlEncoder: null,

        data: {
            message: '',
            type: '',
            autoHideTime: 0,
            clickCallback: null
        },

        buildRendering: function() {
            this.data.message = this._getHTMLEncoder().encode(this.data.message);

            this.inherited(arguments);
        },

        postCreate: function() {
            if (this.data.autoHideTime > 0) {
                this._setUpAutoHide(this.data.autoHideTime);
            }

            if (this.data.clickCallback) {
                domStyle.set(this.domNode, 'cursor', 'pointer');
            }

            var coords = domGeometry.getMarginBox(this._getProgressBar());
            this.templateProgressBarWidth = coords.w;
        },

        setMessage: function(message) {
            this.data.message = this._getHTMLEncoder().encode(message);
            html.set(this.templateMessage, this.data.message);
        },

        setProgress: function(percentage, message) {
            this._cancelAutoHide();

            if (message) {
                this.data.message = this._getHTMLEncoder().encode(message);
                this.render();
            }

            // Calculate animation duration to be percentage of bar width change of the total animation time
            var currentWidth = domGeometry.getMarginBox(this._getProgressBar()).w;
            var duration = this.ANIMATION_PROGRESS_UPDATE_DURATION * ((currentWidth / this.templateProgressBarWidth) - (percentage / 100));

            // Calculate end width (percentage of the original width)
            var endWidth = this.templateProgressBarWidth * (percentage / 100);

            this.progressAnimationHandle = fx.animateProperty({
                node: this._getProgressBar(),
                duration: duration,
                properties: {width:{end: endWidth, units: 'px'}},
                easing: easing.linear
            });

            this.progressAnimationHandle.play();
        },

        redisplay: function(message, type, autoHideTime) {
            this._cancelAutoHide();

            this.data.message = this._getHTMLEncoder().encode(message);
            this.data.type = type;
            this.data.autoHideTime = autoHideTime;

            this.render();

            if (this.data.autoHideTime > 0) {
                this._setUpAutoHide(this.data.autoHideTime);
            }
        },

        hide: function(e) {
            if (typeof e !== 'undefined') {
                e.stopPropagation();
            }
            this._dismissNotification();
        },

        getType: function() {
            return this.data.type;
        },

        _cancelAutoHide: function() {
            if (this.progressAnimationHandle) {
                this.progressAnimationHandle.stop();
                this.progressAnimationHandle = null;
            }
        },

        _getProgressBar: function() {
            return query('.sos-notification-progress-bar', this.domNode)[0];
        },

        _setUpAutoHide: function(time) {
            this._cancelAutoHide();

            this.progressAnimationHandle = fx.animateProperty({
                node: this._getProgressBar(),
                duration: time,
                properties: {width: 0},
                easing: easing.linear,
                onEnd: this._dismissNotification.bind(this)
            });

            this.progressAnimationHandle.play();
        },

        _dismissNotification: function() {
            this._cancelAutoHide();

            fx.fadeOut({
                node: this.domNode,
                duration: this.ANIMATION_FADE_DURATION,
                onEnd: function() {
                    domStyle.set(this.domNode, 'display', 'none');

                    if (this.data.type !== 'progress') {
                        domConstruct.destroy(this.domNode);
                        this.destroy();
                    }
                }.bind(this)
            }).play();
        },

        _getHTMLEncoder: function() {
            if (!this.htmlEncoder) {
                this.htmlEncoder = new HTMLEncoding(dojoHtmlEntities);
                this.htmlEncoder.setReplacements(this.WHITE_LIST_REPLACEMENTS)
                    .setHTMLTagWhiteList(this.WHITE_LIST_HTML_TAGS);
            }

            return this.htmlEncoder;
        },

        _clickCallback: function() {
            if (this.data.clickCallback) {
                this._dismissNotification();
                this.data.clickCallback();
            }
        }
    });
});

},
'spencer/encoding/HTML':function(){
define([
], function() {
    var HTML = function(htmlEntitiesEncoder) {
        /* dojox/html/entities */
        this.htmlEntitiesEncoder = htmlEntitiesEncoder;
        /* Example: ['&pound;', '£'] */
        this.replacements = [];
        /* Example: ['a', 'br'] */
        this.htmlTagWhiteList = [];

        this.voidElements = [
            'area',
            'base',
            'br',
            'col',
            'command',
            'embed',
            'hr',
            'img',
            'input',
            'keygen',
            'link',
            'meta',
            'param',
            'source',
            'track',
            'wbr'
        ];

        this.applyReplacements = function(encodedString) {
            for (var i = 0; i + 1 < this.replacements.length; i = i + 2) {
                encodedString = encodedString.replace(new RegExp(this.replacements[i], 'g'), this.replacements[i + 1]);
            }

            return encodedString;
        };

        this.reinstateWhiteListHTMLTags = function(encodedString) {
            for (var tagIndex in this.htmlTagWhiteList) {
                if (this.htmlTagWhiteList.hasOwnProperty(tagIndex)) {
                    var tag = this.htmlTagWhiteList[tagIndex];
                    if (this.isVoidElement(tag)) {
                        var elements = encodedString.match(this.createWholeVoidElementRegExp(tag));

                        if (elements) {
                            for (var i = 0; i < elements.length; i++) {
                                var decoded = this.decodeEncodedString(elements[i]);
                                encodedString = encodedString.replace(elements[i], decoded);
                            }
                        }
                    } else {
                        encodedString = this.decodeAllTagsInEncodedString(tag, encodedString);
                    }
                }
            }

            return encodedString;
        };

        this.isVoidElement = function(tag) {
            return this.voidElements.indexOf(tag) >= 0;
        };

        this.decodeAllTagsInEncodedString = function(tag, encodedString) {
            var elements = this.getAllElementsForTag(tag, encodedString);

            if (elements) {
                for (var i = 0; i < elements.length; i++) {
                    encodedString = encodedString.replace(elements[i], this.decodeElement(tag, elements[i]));
                }
            }

            return encodedString;
        };

        this.getAllElementsForTag = function(tag, encodedString) {
            return encodedString.match(
                this.createWholeElementRegExp(tag)
            );
        };

        this.decodeElement = function(tag, element) {
            var openingTagMatch = element.match(this.createOpeningTagRegExp(tag));
            var closingTagMatch = element.match(this.createClosingTagRegExp(tag));

            return element.replace(openingTagMatch[0], this.decodeEncodedString(openingTagMatch[0]))
                .replace(closingTagMatch[0], this.decodeEncodedString(closingTagMatch[0]));
        };

        this.decodeEncodedString = function(encodedString) {
            return this.htmlEntitiesEncoder.decode(encodedString);
        };

        this.createWholeElementRegExp = function(tag) {
            return new RegExp(
                '&lt;' + tag + '(&gt;|\\s.*?&gt;).*?&lt;/' + tag + '&gt;',
                'g'
            );
        };

        this.createWholeVoidElementRegExp = function(tag) {
            return new RegExp(
                '&lt;' + tag + '.*?/&gt;',
                'g'
            );
        };

        this.createOpeningTagRegExp = function(tag) {
            return new RegExp(
                '^&lt;' + tag + '(&gt;|\\s.*?&gt;)'
            );
        };

        this.createClosingTagRegExp = function(tag) {
            return new RegExp(
                '&lt;/' + tag + '&gt;$'
            );
        };
    };

    HTML.prototype.setReplacements = function(replacements) {
        this.replacements = replacements;
        return this;
    };

    HTML.prototype.setHTMLTagWhiteList = function(htmlTagWhiteList) {
        this.htmlTagWhiteList = htmlTagWhiteList;
        return this;
    };

    HTML.prototype.encode = function(string) {
        return this.applyReplacements(
            this.reinstateWhiteListHTMLTags(
                this.htmlEntitiesEncoder.encode(string)
            )
        );
    };

    return HTML;
});
},
'user/data/User':function(){
define([], function() {
    var User = function() {
        this.person = null;
        this.username = null;
        this.email = null;
        this.profilePictureURL = null;
    };

    User.prototype.getPerson = function() {
        return this.person;
    };

    User.prototype.setPerson = function(person) {
        this.person = person;
        return this;
    };

    User.prototype.getUsername = function() {
        return this.username;
    };

    User.prototype.setUsername = function(username) {
        this.username = username;
        return this;
    };

    User.prototype.getEmail = function() {
        return this.email;
    };

    User.prototype.setEmail = function(email) {
        this.email = email;
        return this;
    };

    User.prototype.getProfilePictureURL = function() {
        return this.profilePictureURL;
    };

    User.prototype.setProfilePictureURL = function(profilePictureURL) {
        this.profilePictureURL = profilePictureURL;
        return this;
    };

    return User;
});

},
'url:contactdetailspopup/templates/WorkingHours.html':"<div class=\"working-hours-grid-container\">\n  <div class=\"header\">\n    <div>M</div>\n    <div>T</div>\n    <div>W</div>\n    <div>Th</div>\n    <div>F</div>\n    <div>Sa</div>\n    <div>Su</div>\n  </div>\n  <div class=\"body\">\n    <div class=\"monday\"></div>\n    <div class=\"tuesday\"></div>\n    <div class=\"wednesday\"></div>\n    <div class=\"thursday\"></div>\n    <div class=\"friday\"></div>\n    <div class=\"saturday\"></div>\n    <div class=\"sunday\"></div>\n  </div>\n</div>\n",
'url:dijit/templates/TooltipDialog.html':"<div role=\"alertdialog\" tabIndex=\"-1\">\n\t<div class=\"dijitTooltipContainer\" role=\"presentation\">\n\t\t<div data-dojo-attach-point=\"contentsNode\" class=\"dijitTooltipContents dijitTooltipFocusNode\">\n\t\t\t<div data-dojo-attach-point=\"containerNode\"></div>\n\t\t\t${!actionBarTemplate}\n\t\t</div>\n\t</div>\n\t<div class=\"dijitTooltipConnector\" role=\"presentation\" data-dojo-attach-point=\"connectorNode\"></div>\n</div>\n",
'url:doccontrol/viewer/dojo/template/LineWidthPicker.html':"<ul class=\"sos-side-navigation-sub-menu line-width-picker\">\n    <% for (let i = 0; i < lineWidths.length; i++) { %>\n        <li class=\"sos-side-navigation-item <%= lineWidths[i] == selected ? 'active' : '' %>\">\n            <a data-dojo-attach-event=\"click: _selectLineWidth\"\n               data-line-width=\"<%= lineWidths[i] %>\"\n            ><%= lineWidths[i] %>px</a>\n            <div style=\"height: <%= lineWidths[i] %>px\"></div>\n        </li>\n    <% } %>\n</ul>",
'url:doccontrol/viewer/dojo/template/LineStylePicker.html':"<ul class=\"sos-side-navigation-sub-menu line-style-picker\">\n    <li class=\"sos-side-navigation-item <%= selected.solid ? 'active' : '' %>\">\n        <a data-dojo-attach-event=\"click: _selectStyleSolid\">Solid</a>\n        <div style=\"height: 3px\"></div>\n    </li>\n    <li class=\"sos-side-navigation-item <%= selected.dotted ? 'active' : '' %>\">\n        <a data-dojo-attach-event=\"click: _selectStyleDotted\">Dotted</a>\n        <div style=\"height: 3px; background: repeating-linear-gradient(90deg,black 0 3px,#0000 0 6px)\"></div>\n    </li>\n    <li class=\"sos-side-navigation-item <%= selected.dashed ? 'active' : '' %>\">\n        <a data-dojo-attach-event=\"click: _selectStyleDashed\">Dashed</a>\n        <div style=\"height: 3px; background: repeating-linear-gradient(90deg,black 0 6px,#0000 0 12px)\"></div>\n    </li>\n    <li data-dojo-attach-point=\"elementCloudItem\" class=\"sos-side-navigation-item <%= selected.cloud ? 'active' : '' %>\" <%= cloudEnabled ? '' : 'disabled' %>>\n        <a data-dojo-attach-event=\"click: _selectStyleCloud\">Cloud</a>\n        <div style=\"background: none; letter-spacing: -1px; overflow: hidden\">\n            &#9696;&#9696;&#9696;&#9696;&#9696;&#9696;&#9696;\n        </div>\n    </li>\n</ul>",
'url:doccontrol/viewer/dojo/template/UsersRow.html':"<li class=\"sos-side-navigation-item\">\n    <label class=\"user-cell sos-form-checkbox\" title=\"Toggle annotations\">\n        <input type=\"checkbox\" data-dojo-attach-event=\"change: _toggleUserAnnotations\" <%= person.isHidden ? 'checked' : '' %>>\n        <span></span>\n    </label>\n    <img class=\"user-cell\" title=\"<%= personFormatter(person); %>\" src=\"<%= person.avatar.replace(/(&amp;amp;)|(&amp;)/g, '&') %>\" />\n    <div class=\"user-cell user\" title=\"<%= personFormatter(person); %>\"><%= personFormatter(person); %></div>\n</li>",
'url:doccontrol/viewer/dojo/template/CurrentUserRow.html':"<li class=\"sos-side-navigation-item\">\n    <label class=\"user-cell sos-form-checkbox\" title=\"Toggle annotations\">\n        <input type=\"checkbox\" data-dojo-attach-event=\"change: _toggleUserAnnotations\" <%= person.isHidden ? 'checked' : '' %>>\n        <span></span>\n    </label>\n    <img class=\"user-cell\" title=\"You\" src=\"<%= person.avatar.replace(/(&amp;amp;)|(&amp;)/g, '&') %>\" />\n    <div class=\"user-cell user\" title=\"You\">You</div>\n</li>",
'url:doccontrol/viewer/dojo/template/Users.html':"<ul class=\"sos-side-navigation-sub-menu\">\n    <li data-dojo-attach-point=\"elementCurrentUserContainer\"></li>\n    <li class=\"sos-side-navigation-item <%= connectedUsersExpanded ? 'expanded' : '' %>\">\n        <a class=\"sos-icon sos-icon-circle\"\n           title=\"<%= connectedUsers.length %> user<%= connectedUsers.length == 1 ? '' : 's' %> online\"\n           data-dojo-attach-event=\"click: _onConnectedUsersClick\"><span class=\"text\">Online (<%= connectedUsers.length %>)</span></a>\n        <div class=\"sos-side-navigation-expand-click-region\"></div>\n    </li>\n    <li class=\"sos-side-navigation-sub-menu-container <%= connectedUsersExpanded ? 'expanded' : '' %>\">\n        <ul class=\"sos-side-navigation-sub-menu\" data-dojo-attach-point=\"elementConnectedUsersContainer\"></ul>\n    </li>\n    <li class=\"sos-side-navigation-item <%= pastContributorsExpanded ? 'expanded' : '' %>\">\n        <a class=\"sos-icon sos-icon-clock\"\n           title=\"<%= pastContributors.length %> past contributor<%= pastContributors.length == 1 ? '' : 's' %>\"\n           data-dojo-attach-event=\"click: _onPastContributorsClick\"><span class=\"text\">Past Contributors (<%= pastContributors.length %>)</span></a>\n        <div class=\"sos-side-navigation-expand-click-region\"></div>\n    </li>\n    <li class=\"sos-side-navigation-sub-menu-container <%= pastContributorsExpanded ? 'expanded' : '' %>\">\n        <ul class=\"sos-side-navigation-sub-menu\" data-dojo-attach-point=\"elementPastContributorsContainer\"></ul>\n    </li>\n</ul>",
'url:doccontrol/viewer/dojo/template/NotificationContainer.html':"<div data-dojo-attach-point=\"notificationContainer\">\n\n</div>",
'url:doccontrol/viewer/dojo/template/notification/InlineFloatingNotification.html':"<div class=\"document-viewer-notification\">\n    <span class=\"sos-icon sos-icon-bell\"></span> <%= message %>\n</div>",
'url:doccontrol/viewer/dojo/template/AnnotationToolbar.html':"<div data-toolbar-state-flag=\"isVerbose\" class=\"hidden annotation-toolbar <%= toolbarState.isVerbose ? 'verbose' :  '' %>\">\n    <div class=\"document-viewer-notification-container\" data-dojo-attach-point=\"elementNotificationContainer\"></div>\n    <ul data-dojo-attach-point=\"elementNavigation\" class=\"sos-side-navigation sos-side-navigation-compact\">\n        <li class=\"sos-side-navigation-item toggle-width\">\n            <a data-dojo-attach-point=\"elementToggleWidth\" class=\"sos-icon sos-icon-toggle-on tooltip-target\" data-tooltip-content=\"Click to collapse toolbar\">\n                <span class=\"text\">Collapse</span>\n            </a>\n        </li>\n        <li data-toolbar-state-flag=\"isUsersExpanded\" class=\"sos-side-navigation-item <%= toolbarState.isUsersExpanded ? 'expanded' : 'expandable' %> tooltip-target\" data-tooltip-content=\"View and manage connected users\">\n            <a data-dojo-attach-point=\"elementConnectedUserIcon\" class=\"sos-icon sos-icon-users\" data-dojo-attach-event=\"click: _onParentOnlyClick\">\n                <span class=\"text\">Connected Users</span>\n            </a>\n            <div class=\"sos-side-navigation-expand-click-region\"></div>\n        </li>\n        <li data-toolbar-state-flag=\"isUsersExpanded\" class=\"sos-side-navigation-sub-menu-container <%= toolbarState.isUsersExpanded ? 'expanded' : 'expandable' %> connected-users\">\n            <div data-dojo-attach-point=\"elementConnectedUsers\"></div>\n        </li>\n        <li data-dojo-attach-point=\"elementToolDrag\" class=\"sos-side-navigation-item tooltip-target\" data-tooltip-content=\"Click, hold and drag around the document to navigate\">\n            <a class=\"sos-icon sos-icon-hand-open\"><span class=\"text\">Hand</span></a>\n        </li>\n        <li data-dojo-attach-point=\"elementToolSelect\" class=\"sos-side-navigation-item tooltip-target\" data-tooltip-content=\"Click and hold to select a set of annotations\">\n            <a class=\"sos-icon sos-icon-mouse-pointer\"><span class=\"text\">Select</span></a>\n        </li>\n        <li data-toolbar-state-flag=\"isDrawExpanded\" class=\"sos-side-navigation-item <%= toolbarState.isDrawExpanded ? 'expanded' : 'expandable' %> tooltip-target\" data-tooltip-content=\"Expand for different drawing options\">\n            <a class=\"sos-icon sos-icon-pencil\" data-dojo-attach-event=\"click: _onParentOnlyClick\"><span class=\"text\">Draw</span></a>\n            <div class=\"sos-side-navigation-expand-click-region\"></div>\n        </li>\n        <li data-toolbar-state-flag=\"isDrawExpanded\" class=\"sos-side-navigation-sub-menu-container <%= toolbarState.isDrawExpanded ? 'expanded' : 'expandable' %>\">\n            <ul class=\"sos-side-navigation-sub-menu\">\n                <li data-dojo-attach-point=\"elementToolFreehand\" class=\"sos-side-navigation-item tooltip-target\" data-tooltip-content=\"Click and hold to draw free hand (hold shift key to use straight lines)\">\n                    <a class=\"sos-icon sos-icon-pencil\"><span class=\"text\">Pencil</span></a>\n                </li>\n                <li data-dojo-attach-point=\"elementToolText\" class=\"sos-side-navigation-item tooltip-target\" data-tooltip-content=\"Clicking on the document places a text annotation which you can then start typing in\">\n                    <a class=\"sos-icon sos-icon-text-height\"><span class=\"text\">Text</span></a>\n                </li>\n                <li data-dojo-attach-point=\"elementToolHighlight\" class=\"sos-side-navigation-item tooltip-target\" data-tooltip-content=\"Click and hold to highlight free hand (hold shift key to use straight lines)\">\n                    <a class=\"sos-icon sos-icon-pencil-square\"><span class=\"text\">Highlighter</span></a>\n                </li>\n                <li data-toolbar-state-flag=\"isShapesExpanded\" class=\"sos-side-navigation-item <%= toolbarState.isShapesExpanded ? 'expanded' : 'expandable' %> tooltip-target\" data-tooltip-content=\"Expand for a list of shapes you can create (change the colour via the colour tool)\">\n                    <a class=\"sos-icon sos-icon-shapes\" data-dojo-attach-event=\"click: _onParentOnlyClick\">\n                        <span class=\"text\">Shapes</span>\n                    </a>\n                    <div class=\"sos-side-navigation-expand-click-region\"></div>\n                </li>\n                <li data-toolbar-state-flag=\"isShapesExpanded\" class=\"sos-side-navigation-sub-menu-container <%= toolbarState.isShapesExpanded ? 'expanded' : 'expandable' %>\">\n                    <ul class=\"sos-side-navigation-sub-menu\">\n                        <li data-dojo-attach-point=\"elementToolLine\" class=\"sos-side-navigation-item tooltip-target\" data-tooltip-content=\"Click and hold to draw a line (hold the shift key to draw a straight line)\">\n                            <a class=\"sos-icon sos-icon-minus\"><span class=\"text\">Line</span></a>\n                        </li>\n                        <li data-dojo-attach-point=\"elementToolArrow\" class=\"sos-side-navigation-item tooltip-target\" data-tooltip-content=\"Click and hold to draw an arrow (hold the shift key to draw a straight arrow)\">\n                            <a class=\"sos-icon sos-icon-arrow-right\"><span class=\"text\">Arrow</span></a>\n                        </li>\n                        <li data-dojo-attach-point=\"elementToolRectangle\" class=\"sos-side-navigation-item tooltip-target\" data-tooltip-content=\"Click and hold to draw a rectangle (hold shift key to draw a square)\">\n                            <a class=\"sos-icon sos-icon-square\"><span class=\"text\">Rectangle</span></a>\n                        </li>\n                        <li data-dojo-attach-point=\"elementToolEllipse\" class=\"sos-side-navigation-item tooltip-target\" data-tooltip-content=\"Click and hold to draw an ellipsis (hold shift key to draw a circle)\">\n                            <a class=\"sos-icon sos-icon-circle-o\"><span class=\"text\">Ellipse</span></a>\n                        </li>\n                        <li data-dojo-attach-point=\"elementToolHexagon\" class=\"sos-side-navigation-item tooltip-target\" data-tooltip-content=\"Click and hold to draw a hexagon shape (hold shift key to make all sides the same length)\">\n                            <a class=\"sos-icon sos-icon-ascii sos-icon-ascii-hexagon\">\n                                <span class=\"text\">Hexagon</span>\n                            </a>\n                        </li>\n                        <li data-dojo-attach-point=\"elementToolPolygon\" class=\"sos-side-navigation-item tooltip-target\" data-tooltip-content=\"Click to start drawing a polygon shape, click again to add new points, double click or click the starting point to complete\">\n                            <a class=\"sos-icon sos-icon-ascii sos-icon-ascii-parallelogram\">\n                                <span class=\"text\">Polygon</span>\n                            </a>\n                        </li>\n                        <li data-dojo-attach-point=\"elementToolHighlightRegion\" class=\"sos-side-navigation-item tooltip-target\" data-tooltip-content=\"Click and hold to highlight a section (hold shift key to draw a square)\">\n                            <a class=\"sos-icon sos-icon-pencil-square\">\n                                <span class=\"text\">Highlight Region</span>\n                            </a>\n                        </li>\n                    </ul>\n                </li>\n                <li data-toolbar-state-flag=\"isStampsExpanded\" class=\"sos-side-navigation-item <%= toolbarState.isStampsExpanded ? 'expanded' : 'expandable' %> tooltip-target\" data-tooltip-content=\"Allows you to select a stamp to place on the document\">\n                    <a class=\"sos-icon sos-icon-picture\" data-dojo-attach-event=\"click: _onParentOnlyClick\"><span class=\"text\">Stamps</span></a>\n                    <div class=\"sos-side-navigation-expand-click-region\"></div>\n                </li>\n                <li data-toolbar-state-flag=\"isStampsExpanded\" class=\"sos-side-navigation-sub-menu-container <%= toolbarState.isStampsExpanded ? 'expanded' : 'expandable' %>\">\n                    <ul class=\"sos-side-navigation-sub-menu\">\n                        <li class=\"sos-side-navigation-item\">\n                            <a class=\"sos-icon sos-icon-upload\"><span class=\"text\">Upload</span></a>\n                            <input class=\"document-viewer-file-input\"\n                                   data-dojo-attach-event=\"change: _onAddImageChange\"\n                                   data-dojo-attach-point=\"elementToolImageUpload\"\n                                   accept=\"image/*\"\n                                   type=\"file\"/>\n                        </li>\n                        <li class=\"sos-side-navigation-item\" data-tooltip-content=\"Capture and insert an image from a device\">\n                            <a class=\"sos-icon sos-icon-camera\" data-dojo-attach-point=\"openCaptureDialogBtn\">\n                                <span class=\"text\">Capture</span>\n                            </a>\n                        </li>\n                        <% for (let i = 0; i < stamps.length; i++) { %>\n                            <li class=\"sos-side-navigation-item tooltip-target\" data-tooltip-content=\"Insert '<%= stamps[i].name %>' stamp\">\n                                <a class=\"image-preview-dropdown-button\"\n                                   data-dojo-attach-event=\"click: _onStampClicked\"\n                                   data-stamp=\"<%= stamps[i].name %>\"\n                                ><span class=\"image-container\"><img src=\"<%= stamps[i].href %>\" alt=\"<%= stamps[i].name %>\"></span><span class=\"dropdown-label\"><%= stamps[i].name %></span></a>\n                            </li>\n                        <% } %>\n                    </ul>\n                </li>\n                <li data-dojo-attach-point=\"elementToolPin\" class=\"sos-side-navigation-item tooltip-target\" data-tooltip-content=\"Allows you to place a pin on the document, that can then be managed with the popup menu\">\n                    <a class=\"sos-icon sos-icon-pin\"><span class=\"text\">Pin</span></a>\n                </li>\n            </ul>\n        </li>\n        <li data-toolbar-state-flag=\"isColorExpanded\" class=\"sos-side-navigation-item sos-side-navigation-item-separated-icon <%= toolbarState.isColorExpanded ? 'expanded' : 'expandable' %> tooltip-target\" data-tooltip-content=\"Allows you to change the colour of the tool you are working with (text, draw and shapes)\">\n            <a class=\"dropdown-header\" data-dojo-attach-event=\"click: _onParentOnlyClick\">\n                <span data-dojo-attach-point=\"elementColorIcon\" class=\"sos-icon sos-icon-droplet color-select-icon\"></span>\n                <div class=\"sos-side-navigation-item-separated-icon-label\">Colour</div>\n            </a>\n            <div class=\"sos-side-navigation-expand-click-region\"></div>\n        </li>\n        <li data-toolbar-state-flag=\"isColorExpanded\" class=\"sos-side-navigation-sub-menu-container <%= toolbarState.isColorExpanded ? 'expanded' : 'expandable' %>\">\n            <ul class=\"sos-side-navigation-sub-menu\">\n                <li data-dojo-attach-point=\"elementColorPicker\"></li>\n                <div>\n                    <label class=\"sos-form-checkbox\" title=\"Enable colour fill\">\n                        <input data-toolbar-state-flag=\"isColorFilled\" type=\"checkbox\" data-dojo-attach-event=\"change: _onFillChanged\" <%= isColorFilled ? 'checked' : '' %>/>\n                        <span>Fill</span>\n                    </label>\n                </div>\n            </ul>\n        </li>\n        <li data-toolbar-state-flag=\"isLineWidthExpanded\" class=\"sos-side-navigation-item <%= toolbarState.isLineWidthExpanded ? 'expanded' : 'expandable' %> tooltip-target\" data-tooltip-content=\"Allows you to select a thickness for the lines you draw\">\n            <a class=\"sos-icon sos-icon-bars-asc\" data-dojo-attach-event=\"click: _onParentOnlyClick\">\n                <span class=\"text\">Line Thickness (<span data-dojo-attach-point=\"elementLineThicknessIndicator\"></span>px)</span>\n            </a>\n            <div class=\"sos-side-navigation-expand-click-region\"></div>\n        </li>\n        <li data-toolbar-state-flag=\"isLineWidthExpanded\" class=\"sos-side-navigation-sub-menu-container <%= toolbarState.isLineWidthExpanded ? 'expanded' : 'expandable' %>\">\n            <ul class=\"sos-side-navigation-sub-menu\" data-dojo-attach-point=\"elementLineThicknessPicker\"></ul>\n        </li>\n        <li data-toolbar-state-flag=\"isLineStyleExpanded\" class=\"sos-side-navigation-item <%= toolbarState.isLineStyleExpanded ? 'expanded' : 'expandable' %> tooltip-target\" data-tooltip-content=\"Allows you to select a style for the lines you draw\">\n            <a class=\"sos-icon sos-icon-list-ol\" data-dojo-attach-event=\"click: _onParentOnlyClick\">\n                <span class=\"text\">Line Style</span>\n            </a>\n            <div class=\"sos-side-navigation-expand-click-region\"></div>\n        </li>\n        <li data-toolbar-state-flag=\"isLineStyleExpanded\" class=\"sos-side-navigation-sub-menu-container <%= toolbarState.isLineStyleExpanded ? 'expanded' : 'expandable' %>\">\n            <ul class=\"sos-side-navigation-sub-menu\" data-dojo-attach-point=\"elementLineStylePicker\"></ul>\n        </li>\n        <li data-toolbar-state-flag=\"isDeleteExpanded\" class=\"sos-side-navigation-item <%= toolbarState.isDeleteExpanded ? 'expanded' : 'expandable' %> tooltip-target\" data-tooltip-content=\"Expand for different delete options\">\n            <a class=\"sos-icon sos-icon-trash\" data-dojo-attach-event=\"click: _onParentOnlyClick\"><span class=\"text\">Delete</span></a>\n            <div class=\"sos-side-navigation-expand-click-region\"></div>\n        </li>\n        <li data-toolbar-state-flag=\"isDeleteExpanded\" class=\"sos-side-navigation-sub-menu-container <%= toolbarState.isDeleteExpanded ? 'expanded' : 'expandable' %>\">\n            <ul class=\"sos-side-navigation-sub-menu\">\n                <li data-dojo-attach-point=\"elementToolDeleteSelection\" class=\"sos-side-navigation-item tooltip-target\" data-tooltip-content=\"Clicking this deletes any items you have selected\">\n                    <a disabled=\"disabled\" class=\"sos-icon sos-icon-eraser\"><span class=\"text\">Selection</span></a>\n                </li>\n                <li data-dojo-attach-point=\"elementToolClear\" class=\"sos-side-navigation-item tooltip-target\" data-tooltip-content=\"Clicking this will clear all annotations across all pages\">\n                    <a class=\"sos-icon sos-icon-trash\"><span class=\"text\">All</span></a>\n                </li>\n            </ul>\n        </li>\n    </ul>\n</div>",
'url:style-guide/v1/color-picker/template/LimitedColorPicker.html':"<div class=\"sos-limited-color-picker-container\">\n    <% for (let i = 0; i < colors.length; i++) { %>\n        <a class=\"color-option <%= colors[i] === selected ? 'selected' : '' %>\"\n           data-dojo-attach-event=\"click: _selectColor\"\n           data-color=\"<%= colors[i] %>\"\n           <%= disabled ? 'disabled' : '' %>\n           style=\"background: <%= colors[i] %>\"></a>\n    <% } %>\n</div>",
'url:style-guide/v1/tooltip/template/Tooltip.html':"<div class=\"sos-tooltip\">\n    <div class=\"sos-tooltip-content\">\n        <span class=\"sos-icon sos-icon-close\" data-dojo-attach-point=\"closeIcon\"></span>\n\n        <%- content %>\n    </div>\n    <div data-dojo-attach-point=\"arrow\" class=\"sos-tooltip-arrow\"></div>\n</div>",
'url:style-guide/v1/media/templates/AddCaptureDialog.html':"<div class=\"capture-dialog\">\n    <div data-dojo-attach-point=\"elementLoadingCaptureFeedContainer\">\n        <div class=\"sos-layout-dialog-content\">\n                <button class=\"sos-btn sos-btn-s sos-btn-secondary sos-btn-capture-settings sos-btn-icon sos-icon-cog\"\n                        data-dojo-attach-event=\"click: _onCaptureSettingMenuClick\">\n                    Change Device</button>\n            <div class=\"capture-loading-container\">\n                <p class=\"loading-state\">\n                    <span class=\"sos-icon sos-icon-animation-spin-smooth sos-icon-refresh\"></span>\n                    <br>\n                    <span>Loading Camera Feed...</span>\n                </p>\n            </div>\n        </div>\n    </div>\n    <div data-dojo-attach-point=\"elementPreviewCaptureContainer\" hidden>\n        <div class=\"sos-layout-dialog-content\">\n            <button class=\"sos-btn sos-btn-s sos-btn-secondary sos-btn-capture-settings sos-btn-icon sos-icon-cog\"\n                    data-dojo-attach-event=\"click: _onCaptureSettingMenuClick\">\n                    Change Device</button>\n            <video class=\"capture-content-sizing\" data-dojo-attach-point=\"elementCaptureVideo\"></video>\n        </div>\n        <div class=\"sos-layout-dialog-footer\">\n            <button class=\"sos-btn sos-btn-secondary\" data-dojo-attach-event=\"click: _closeCaptureDialog\">Cancel</button>\n            <button class=\"sos-btn sos-btn-icon sos-icon-camera right\" data-dojo-attach-event=\"click: _onCaptureImageClick\">Capture</button>\n        </div>\n    </div>\n    <div data-dojo-attach-point=\"elementInsertCaptureContainer\" hidden>\n        <div class=\"sos-layout-dialog-content\">\n            <img class=\"capture-content-sizing\" data-dojo-attach-point=\"elementCapturedImage\" alt=\"captured image from camera\" src=\"\">\n        </div>\n        <div class=\"sos-layout-dialog-footer\">\n            <button class=\"sos-btn sos-btn-secondary\" data-dojo-attach-event=\"click: _closeCaptureDialog\">Cancel</button>\n            <button class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-camera\" data-dojo-attach-event=\"click: _onRecaptureButtonClick\">Recapture</button>\n            <button class=\"sos-btn sos-btn-icon sos-icon-toggle-right right\" data-dojo-attach-event=\"click: _onInsertImageButtonClick\">Insert</button>\n        </div>\n    </div>\n</div>",
'url:style-guide/v1/layout/templates/Dialog.html':"<div class=\"sos-layout-dialog-responsive\">\n    <div class=\"sos-layout-dialog-container ${additionalClass}\">\n        <div class=\"sos-layout-dialog-close-button-container\">\n            <div class=\"sos-layout-dialog-title\" data-dojo-attach-point=\"elementTitle\">${titleString}</div>\n            <span class=\"close-button\" data-dojo-attach-event=\"click: _onCloseClick\">close</span>\n        </div>\n        <div class=\"sos-layout-dialog-content-wrapper\" data-dojo-attach-point=\"elementContent\"></div>\n    </div>\n</div>",
'url:style-guide/v1/menus/templates/ContextMenu.html':"<ul class=\"sos-context-menu hidden\"></ul>",
'url:style-guide/v1/menus/templates/ContextMenuItem.html':"<li class=\"sos-context-menu-item\" title=\"<%= titleText %>\" data-dojo-attach-event=\"onmouseenter: _onMouseEnter, onmousedown: _onClick\">\n    <% if (icon) { %>\n        <span data-dojo-attach-point=\"iconContainer\" class=\"sos-icon sos-icon-<%= icon %>\"></span>\n    <% } else { %>\n        <span data-dojo-attach-point=\"iconContainer\"></span>\n    <% } %>\n    <span><%= text; %></span>\n\n    <div data-dojo-attach-point=\"menuNode\" class=\"menu-container\"></div>\n    <div></div>\n    <span data-dojo-attach-point=\"caretNode\" class=\"sos-icon sos-icon-caret-right\"></span>\n</li>",
'url:doccontrol/viewer/dojo/template/AnnotationWorkspace.html':"<canvas data-dojo-attach-point=\"annotationCanvas\"></canvas>\n",
'url:doccontrol/viewer/dojo/template/notification/AnnotationsHaveChanged.html':"<div class=\"notification-overlay\">\n    <div class=\"notification-overlay-content\">\n        <span class=\"sos-icon sos-icon-information\"></span>\n        <p>The annotations for the current document have changed.</p>\n        <p>If you wish to include these modifications please restart the registration process.</p>\n        <p><button class=\"sos-btn sos-btn-secondary\">Ok</button></p>\n    </div>\n</div>",
'url:doccontrol/viewer/dojo/template/notification/ConnectionError.html':"<div class=\"notification-overlay hidden\">\n    <div class=\"notification-overlay-content\">\n        <p class=\"sos-icon-orange\"><span class=\"sos-icon sos-icon-warning\" /></p>\n        <p>We are currently unable to communicate with the server.</p>\n        <p>Please check your network connection and try connecting again using the button below.</p>\n        <p>If you are still unable to connect, please contact support.</p>\n        <p><button class=\"sos-btn sos-btn-secondary\">Connect</button></p>\n    </div>\n</div>",
'url:doccontrol/viewer/dojo/template/notification/Disconnected.html':"<div class=\"notification-overlay hidden\">\n    <div class=\"notification-overlay-content\">\n        <p class=\"sos-icon-orange\"><span class=\"sos-icon sos-icon-warning\" /></p>\n        <p>Communication with the server has been interrupted.</p>\n        <p>You can reconnect by using the button below.</p>\n        <p><button class=\"sos-btn sos-btn-secondary\">Reconnect</button></p>\n    </div>\n</div>",
'url:doccontrol/viewer/dojo/template/notification/GeneratingAnnotatedDocument.html':"<div class=\"notification-overlay\">\n    <div class=\"notification-overlay-content\">\n        <p class=\"loading-state\">\n            <span class=\"sos-icon sos-icon-animation-spin-smooth sos-icon-refresh\"></span>\n        </p>\n        <p>Generating Annotated Document...</p>\n        <button class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-close\">Cancel</button>\n    </div>\n</div>",
'url:doccontrol/viewer/dojo/template/ViewerDialog.html':"<div class=\"sos-v1 sos-layout-dialog document-viewer-dialog\">\n    <div class=\"dialogTemplateContainer\">\n        <div class=\"title-bar-container\">\n            <div class=\"document-viewer-tools\">\n                <div id=\"dialogToolbar\" class=\"dialog-toolbar-container\"></div>\n                <a class=\"sos-layout-dialog-close-button\" data-dojo-attach-point=\"elementCloseButton\" data-dojo-attach-event=\"click: _onCloseClick\">\n                    <div class=\"button-container\">\n                        <span class=\"sos-icon sos-icon-close\">Close</span>\n                    </div>\n                </a>\n            </div>\n        </div>\n\n        <div id=\"viewOptionsToolbar\"></div>\n        <div id=\"navigationBar\"></div>\n\n        <div data-dojo-attach-point=\"elementContentContainer\" class=\"sos-layout-dialog-content-container\"></div>\n    </div>\n</div>",
'url:doccontrol/viewer/dojo/information/template/AddNoteDialog.html':"<div class=\"sos-v1\">\n    <div class=\"add-note-dialog-content\">\n        <div data-dojo-attach-point=\"noteContentNode\"></div>\n        <div class=\"sos-layout-dialog-footer\" data-dojo-attach-point=\"actionButtons\">\n            <button class=\"sos-btn sos-btn-secondary\" data-dojo-attach-event=\"click: hide\">Cancel</button>\n            <button class=\"sos-btn sos-btn-icon sos-icon-save\" style=\"float: right;\" data-dojo-attach-event=\"click: _saveNote\" data-dojo-attach-point=\"submitNode\">Save note</button>\n        </div>\n    </div>\n</div>",
'url:dijit/form/templates/TextBox.html':"<div class=\"dijit dijitReset dijitInline dijitLeft\" id=\"widget_${id}\" role=\"presentation\"\n\t><div class=\"dijitReset dijitInputField dijitInputContainer\"\n\t\t><input class=\"dijitReset dijitInputInner\" data-dojo-attach-point='textbox,focusNode' autocomplete=\"off\"\n\t\t\t${!nameAttrSetting} type='${type}'\n\t/></div\n></div>\n",
'url:dijit/templates/Tooltip.html':"<div class=\"dijitTooltip dijitTooltipLeft\" id=\"dojoTooltip\" data-dojo-attach-event=\"mouseenter:onMouseEnter,mouseleave:onMouseLeave\"\n\t><div class=\"dijitTooltipConnector\" data-dojo-attach-point=\"connectorNode\"></div\n\t><div class=\"dijitTooltipContainer dijitTooltipContents\" data-dojo-attach-point=\"containerNode\" role='alert'></div\n></div>\n",
'url:dijit/form/templates/ValidationTextBox.html':"<div class=\"dijit dijitReset dijitInline dijitLeft\"\n\tid=\"widget_${id}\" role=\"presentation\"\n\t><div class='dijitReset dijitValidationContainer'\n\t\t><input class=\"dijitReset dijitInputField dijitValidationIcon dijitValidationInner\" value=\"&#935; \" type=\"text\" tabIndex=\"-1\" readonly=\"readonly\" role=\"presentation\"\n\t/></div\n\t><div class=\"dijitReset dijitInputField dijitInputContainer\"\n\t\t><input class=\"dijitReset dijitInputInner\" data-dojo-attach-point='textbox,focusNode' autocomplete=\"off\"\n\t\t\t${!nameAttrSetting} type='${type}'\n\t/></div\n></div>\n",
'url:soso/dijit/form/templates/ValidationTextarea.html':"<div class=\"dijit dijitReset dijitInline dijitLeft\" id=\"widget_${id}\" role=\"presentation\"\n\t><textarea ${!nameAttrSetting} data-dojo-attach-point=\"focusNode,containerNode,textbox\"\n        class=\"sos-form-textarea dijitTextBox dijitTextArea dijitExpandingTextArea\" autocomplete=\"off\"></textarea\n    ><div class=\"sos-form-textarea-validation-tag\"></div\n    ><br /><label data-dojo-attach-point=\"validationPrompt\" class=\"sos-form-textarea-validation-prompt\"></label\n></div>",
'url:doccontrol/viewer/dojo/information/template/AccessLogEventRow.html':"<div data-event-type=\"<%= getEventType() %>\">\n    <div class=\"sos-document-viewer-event-row\"><%- formatDescription() %></div>\n</div>",
'url:doccontrol/viewer/dojo/information/template/EventRow.html':"<div data-event-type=\"<%= getEventType() %>\">\n    <div class=\"sos-accordion-pane\" data-dojo-attach-point=\"accordion\"><%= formatDescription() %></div>\n</div>",
'url:dijit/templates/TitlePane.html':"<div>\n\t<div data-dojo-attach-event=\"ondijitclick:_onTitleClick, onkeydown:_onTitleKey\"\n\t\t\tclass=\"dijitTitlePaneTitle\" data-dojo-attach-point=\"titleBarNode\" id=\"${id}_titleBarNode\">\n\t\t<div class=\"dijitTitlePaneTitleFocus\" data-dojo-attach-point=\"focusNode\">\n\t\t\t<span data-dojo-attach-point=\"arrowNode\" class=\"dijitInline dijitArrowNode\" role=\"presentation\"></span\n\t\t\t><span data-dojo-attach-point=\"arrowNodeInner\" class=\"dijitArrowNodeInner\"></span\n\t\t\t><span data-dojo-attach-point=\"titleNode\" class=\"dijitTitlePaneTextNode\"></span>\n\t\t</div>\n\t</div>\n\t<div class=\"dijitTitlePaneContentOuter\" data-dojo-attach-point=\"hideNode\" role=\"presentation\">\n\t\t<div class=\"dijitReset\" data-dojo-attach-point=\"wipeNode\" role=\"presentation\">\n\t\t\t<div class=\"dijitTitlePaneContentInner\" data-dojo-attach-point=\"containerNode\" role=\"region\" id=\"${id}_pane\" aria-labelledby=\"${id}_titleBarNode\">\n\t\t\t\t<!-- nested divs because wipeIn()/wipeOut() doesn't work right on node w/padding etc.  Put padding on inner div. -->\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>\n",
'url:doccontrol/viewer/dojo/information/template/RevisionHistoryEventRow.html':"<div data-event-type=\"<%= getEventType() %>\">\n    <div class=\"sos-accordion-pane\" data-dojo-attach-point=\"accordion\">\n        <table class=\"sos-table\">\n            <tbody>\n                <tr>\n                    <th class=\"text-align-right\">Name</th>\n                    <td>\n                        <%= revision.getRealName(); %>\n                        <% if (revision) { %>\n                            <% if (currentlyViewingRevision && revision.getRevisionPK() === currentlyViewingRevision.getRevisionPK()) { %>\n                                <div class=\"pill\">\n                                    <span class=\"sos-icon sos-icon-eye\">Currently Viewing</span>\n                                </div>\n                            <% } %>\n                            <% if (revision.isLatest()) { %>\n                                <div class=\"pill pill-primary\">\n                                    <span class=\"sos-icon sos-icon-clock\">Latest Revision</span>\n                                </div>\n                            <% } %>\n                        <% } %>\n                    </td>\n                </tr>\n                <tr>\n                    <th class=\"text-align-right\">Title</th>\n                    <% if (revision.isMarkedAsPrivate()) { %>\n                        <td>\n                            <a href=\"<%= revisionDownloadUrl(revision.getRevisionPK()) %>\"\n                               data-dojo-attach-event=\"click: viewDocument\"\n                               data-revision-pk=\"<%= revision.getRevisionPK() %>\"\n                               data-file-type=\"<%= revision.getFileType() %>\"\n                               data-md5=\"<%= revision.getMd5() %>\">\n                                <%= revision.getTitle(); %>\n                            </a>\n                        </td>\n                        <td class=\"sos-icon-private-document\"><span class=\"sos-icon\" /></td>\n                    <% } else { %>\n                        <td colspan=\"2\">\n                            <a href=\"<%= revisionDownloadUrl(revision.getRevisionPK()) %>\"\n                               data-dojo-attach-event=\"click: viewDocument\"\n                               data-revision-pk=\"<%= revision.getRevisionPK() %>\"\n                               data-file-type=\"<%= revision.getFileType() %>\"\n                               data-md5=\"<%= revision.getMd5() %>\">\n                                <%= revision.getTitle(); %>\n                            </a>\n                        </td>\n                    <% } %>\n                </tr>\n                <tr>\n                    <th class=\"text-align-right\">Size</th>\n                    <td><%= megabytesFormatter(revision.getFileSize()); %></td>\n                </tr>\n                <tr>\n                    <th class=\"text-align-right\">File Type</th>\n                    <td>\n                        <span class=\"sos-icon <%= fileTypeIcon(revision.getFileType()); %>\"></span>\n                        <%= mimeTypeFormatter(revision.getFileType())?.toUpperCase() ?? '-'; %>\n                    </td>\n                </tr>\n                <tr>\n                    <th class=\"text-align-right\">Person</th>\n                    <td>\n                        <%- historyActionFormatter(revision) %> by\n                        <%= personFormatter(revision.getPersonUploader()); %>\n                        <%= originatorFormatter(revision); %>\n                    </td>\n                </tr>\n                <tr>\n                    <th class=\"text-align-right\">Date Uploaded</th>\n                    <td><%= dateFormatter(revision.getDateUploaded(), true); %></td>\n                </tr>\n                <tr>\n                    <th class=\"text-align-right\">Revision Date</th>\n                    <td><%= dateFormatter(revision.getRevisionDate()); %></td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>",
'url:doccontrol/viewer/dojo/information/template/TransmittalEventRow.html':"<div data-event-type=\"<%= getEventType() %>\">\n    <div class=\"sos-accordion-pane\" data-dojo-attach-point=\"accordion\">\n        <table class=\"sos-table\">\n            <tbody>\n                <tr>\n                    <td>Distributed By</td>\n                    <td><%= contactFormatter(transmittal.getSender()); %></td>\n                </tr>\n                <tr>\n                    <td>Date</td>\n                    <td><%= dateFormatter(transmittal.getDateTransmitted()); %></td>\n                </tr>\n                <tr>\n                    <td>Recipients</td>\n                    <td>\n                        <ul>\n                            <% let recipients = transmittal.getRecipients(); %>\n                            <% for (let j in recipients) { %>\n                                <% if (recipients.hasOwnProperty(j)) { %>\n                                    <li><%= contactFormatter(recipients[j]); %></li>\n                                <% } %>\n                            <% } %>\n                        </ul>\n                    </td>\n                </tr>\n                <tr>\n                    <td>Comment</td>\n                    <% if (transmittal.getEmailRevisionPK()) { %>\n                        <td><a href=\"<%= overviewDocumentUrl(transmittal.getEmailRevisionPK()) %>\" target=\"_blank\">View Correspondence</a></td>\n                    <% } else { %>\n                        <td><%= transmittal.getComment(); %></td>\n                    <% } %>\n                </tr>\n                <tr>\n                    <td>Other Documents</td>\n                    <td>\n                        <% let revisions = transmittal.getRevisions(); %>\n                        <% if (revisions.length) { %>\n                        <ul>\n                            <% for (let j in revisions) { %>\n                            <% if (revisions.hasOwnProperty(j)) { %>\n                            <li>\n                                <a href=\"<%= revisionDownloadUrl(revisions[j].getRevisionPK()) %>\"\n                                   data-dojo-attach-event=\"click: viewDocument\"\n                                   data-revision-pk=\"<%= revisions[j].getRevisionPK() %>\"\n                                   data-file-type=\"<%= revisions[j].getFileType() %>\"\n                                   data-md5=\"<%= revisions[j].getMd5() %>\">\n                                    <%= revisions[j].getTitle(); %>\n                                </a>\n                            </li>\n                            <% } %>\n                            <% } %>\n                        </ul>\n                        <% } else { %>\n                            -\n                        <% } %>\n                    </td>\n                </tr>\n            </tbody>\n        </table>\n    </div>\n</div>",
'url:dijit/form/templates/Button.html':"<span class=\"dijit dijitReset dijitInline\" role=\"presentation\"\n\t><span class=\"dijitReset dijitInline dijitButtonNode\"\n\t\tdata-dojo-attach-event=\"ondijitclick:__onClick\" role=\"presentation\"\n\t\t><span class=\"dijitReset dijitStretch dijitButtonContents\"\n\t\t\tdata-dojo-attach-point=\"titleNode,focusNode\"\n\t\t\trole=\"button\" aria-labelledby=\"${id}_label\"\n\t\t\t><span class=\"dijitReset dijitInline dijitIcon\" data-dojo-attach-point=\"iconNode\"></span\n\t\t\t><span class=\"dijitReset dijitToggleButtonIconChar\">&#x25CF;</span\n\t\t\t><span class=\"dijitReset dijitInline dijitButtonText\"\n\t\t\t\tid=\"${id}_label\"\n\t\t\t\tdata-dojo-attach-point=\"containerNode\"\n\t\t\t></span\n\t\t></span\n\t></span\n\t><input ${!nameAttrSetting} type=\"${type}\" value=\"${value}\" class=\"dijitOffScreen\"\n\t\tdata-dojo-attach-event=\"onclick:_onClick\"\n\t\ttabIndex=\"-1\" aria-hidden=\"true\" data-dojo-attach-point=\"valueNode\"\n/></span>\n",
'url:dijit/form/templates/CheckBox.html':"<div class=\"dijit dijitReset dijitInline\" role=\"presentation\"\n\t><input\n\t \t${!nameAttrSetting} type=\"${type}\" role=\"${type}\" aria-checked=\"false\" ${checkedAttrSetting}\n\t\tclass=\"dijitReset dijitCheckBoxInput\"\n\t\tdata-dojo-attach-point=\"focusNode\"\n\t \tdata-dojo-attach-event=\"ondijitclick:_onClick\"\n/></div>\n",
'url:doccontrol/viewer/dojo/information/template/Chronological.html':"<div>\n    <div class=\"chronological-settings\">\n        <label class=\"sos-form-checkbox\"><input type=\"checkbox\" data-dojo-attach-point=\"displayAccessLogs\"><span></span>Access Logs</label>\n        <label class=\"sos-form-checkbox\"><input type=\"checkbox\" data-dojo-attach-point=\"displaySoftLinks\"><span></span>Soft Links</label>\n        <label class=\"sos-form-checkbox\"><input type=\"checkbox\" data-dojo-attach-point=\"displayMoves\"><span></span>Moves</label>\n        <label class=\"sos-form-checkbox\"><input type=\"checkbox\" data-dojo-attach-point=\"displayNotes\"><span></span>Notes</label>\n        <label class=\"sos-form-checkbox\"><input type=\"checkbox\" data-dojo-attach-point=\"displayTransmittals\"><span></span>Transmittals</label>\n        <label class=\"sos-form-checkbox\"><input type=\"checkbox\" data-dojo-attach-point=\"displayRevisionHistory\"><span></span>Revision History</label>\n    </div>\n    <div class=\"sos-accordion\" data-dojo-attach-point=\"eventContainer\"></div>\n    <p class=\"sos-empty-state\" data-dojo-attach-point=\"emptyState\">\n        <span class=\"sos-icon sos-icon-file\">No document events to display for the given filters.</span>\n    </p>\n</div>",
'url:doccontrol/viewer/dojo/information/template/RevisionHistoryTable.html':"<div>\n    <div class=\"<%= currentUserIsDocControlAdmin ? 'display-grid grid-cols-2' : ''; %> align-items-center mb-6\">\n        <% if (location.projectStageTreeViewPK) { %>\n            <div>\n                <label class=\"sos-icon sos-icon-folder m-0\">Location:</label>\n                <a class=\"sos-icon sos-icon-external-link\"\n                   href=\"<%= location.href; %>\"\n                   target=\"_blank\"><%= location.projectStageTitle; %> / <%= location.name; %></a>\n            </div>\n        <% } %>\n        <% if (currentUserIsDocControlAdmin) { %>\n            <div class=\"text-align-right\">\n                <button class=\"sos-btn sos-btn-icon sos-icon-pencil-paper sos-btn-s m-0\" data-dojo-attach-point=\"editRevisionNumbersButton\" data-dojo-attach-event=\"click: _enableEditForm\">Edit Revision Numbers</button>\n                <div data-dojo-attach-point=\"editingStateButtons\" class=\"hidden\">\n                    <button class=\"sos-btn sos-btn-s sos-btn-icon sos-icon-close sos-btn-secondary m-0\"\n                            data-dojo-attach-event=\"click: _disableEditForm\">Cancel</button>\n                    <button class=\"sos-btn sos-btn-s sos-btn-icon sos-icon-save sos-btn-confirm m-0 ml-6\"\n                            data-dojo-attach-event=\"click: _saveRevisionNumbersClick\">Save Changes</button>\n                </div>\n            </div>\n        <% } %>\n    </div>\n    <table class=\"document-information-table sos-table <%= documentRevisionCollection === null ? 'sos-table-ghost' : ''; %>\">\n        <tbody class=\"document-information-table-body\">\n            <% if (documentRevisionCollection && documentRevisionCollection.length) { %>\n                <% const md5sDisplayed = []; %>\n                <% documentRevisionCollection.forEach((revision) => { %>\n                    <% if (md5sDisplayed.indexOf(revision.getMd5()) === -1) { %>\n                        <tr>\n                            <td colspan=\"9\" class=\"sos-sub-heading-row py-6 revision-number-cell\">\n                                <% if (location.isRevisionable) { %>\n                                    <strong>Revision:</strong>\n                                    <div class=\"sos-form-textfield-validation dynamic-revision-text-box-container m-0 mr-6 hidden\">\n                                        <input data-md5=\"<%= revision.getMd5(); %>\"\n                                               type=\"text\"\n                                               class=\"sos-form-textfield sos-form-textfield-s sos-form-textfield-validation sos-form-textfield-validation-s dynamic-revision-text-box\"\n                                               required\n                                               pattern=\"<%= revisionNumberPattern; %>\"\n                                               value=\"<%= revision.getRevisionNumber(); %>\"\n                                        />\n                                        <div class=\"sos-form-textfield-validation-tag sos-form-textfield-validation-tag-s\"></div>\n                                    </div>\n                                    <span class=\"revision-number-static mr-6\"><%= revision.getRevisionNumber() ?? '-'; %></span>\n                                <% } %>\n\n                                <label class=\"sos-form-radio latest-revision-radio-button-container white-space-no-wrap m-0 mr-6 display-none\">\n                                    <input class=\"latest-revision-radio-button m-0\"\n                                           type=\"radio\"\n                                           name=\"latestRevisionRadio\"\n                                           value=\"<%= revision.getRevisionPK(); %>\"\n                                           <%= revision && revision.isLatest() ? ' checked' : ''; %>\n                                           <%= revision && revision.isMarkedForDeletion() ? ' disabled' : ''; %> />\n                                    <span class=\"ml-0 my-0 mr-6\"></span>Latest\n                                </label>\n\n                                <% const isCurrentlyViewing = currentlyViewingRevision && currentlyViewingRevision.getMd5() === revision.getMd5(); %>\n                                <% if (!isCurrentlyViewing) { %>\n                                    <a href=\"<%= revisionDownloadUrl(revision.getRevisionPK()); %>\"\n                                       data-dojo-attach-event=\"click: _viewDocument\"\n                                       data-revision-pk=\"<%= revision.getRevisionPK(); %>\"\n                                       data-file-type=\"<%= revision.getFileType(); %>\"\n                                       data-md5=\"<%= revision.getMd5(); %>\"\n                                       title=\"View revision\"\n                                       class=\"sos-icon sos-icon-eye mr-6\"\n                                    >View</a>\n                                <% } %>\n                                <div class=\"display-inline-block float-right\">\n                                    <% if (revision.isLatest()) { %>\n                                        <div class=\"pill pill-primary\" title=\"This is the latest revision\">\n                                            <span class=\"sos-icon sos-icon-clock\">Latest Revision</span>\n                                        </div>\n                                    <% } %>\n                                    <% if (isCurrentlyViewing) { %>\n                                        <div class=\"pill\" title=\"Revision currently being displayed in the viewer\">\n                                            <span class=\"sos-icon sos-icon-eye\">Currently Viewing</span>\n                                        </div>\n                                    <% } %>\n                                    <span class=\"pill pill-secondary\" title=\"File type\">\n                                        <span class=\"sos-icon <%= fileTypeIcon(revision.getFileType()); %>\"></span> <%= mimeTypeFormatter(revision.getFileType())?.toUpperCase(); %>\n                                    </span>\n                                        <span class=\"pill pill-secondary\" title=\"File size\">\n                                        <span class=\"sos-icon sos-icon-file\"></span>\n                                        <%= megabytesFormatter(revision.getFileSize()); %>\n                                    </span>\n                                        <span class=\"pill pill-secondary\" title=\"File uploaded on <%= dateFormatter(revision.getDateUploaded(), true); %>\">\n                                        <span class=\"sos-icon sos-icon-upload\"></span>\n                                        <%= dateFormatter(revision.getDateUploaded(), true); %>\n                                    </span>\n                                    <% if (revision.isMarkedAsPrivate()) { %>\n                                        <div class=\"pill pill-warning\" title=\"Revision is marked as private\">\n                                            <span class=\"sos-icon sos-icon-lock\">Private</span>\n                                        </div>\n                                    <% } %>\n                                </div>\n                            </td>\n                        </tr>\n                        <tr>\n                            <% if (location.isRevisionable) { %>\n                                <th>Reference</th>\n                            <% } %>\n                            <th>Revision Date</th>\n                            <% if (location.isRevisionable) { %>\n                                <th>Status</th>\n                            <% } %>\n                            <th>Private</th>\n                            <th>Event Date</th>\n                            <th>Event Description</th>\n                        </tr>\n                        <% md5sDisplayed.push(revision.getMd5()); %>\n                    <% } %>\n                    <tr class=\"document-information-table-row\">\n                        <% if (location.isRevisionable) { %>\n                            <td><%= revision.getReference() ?? '-'; %></td>\n                        <% } %>\n                        <td><%= revision.getRevisionDate() ? dateFormatter(revision.getRevisionDate()) : '-'; %></td>\n                        <% if (location.isRevisionable) { %>\n                            <td><%= revision.getStatus()?.getDescription() ?? '-'; %></td>\n                        <% } %>\n                        <td><%= revision.isMarkedAsPrivate() ? 'Yes' : 'No'; %></td>\n                        <td><%= dateFormatter(revision.getDateUploaded(), true); %></td>\n                        <td>\n                            <%- historyActionFormatter(revision) %> by\n                            <strong><%= personFormatter(revision.getPersonUploader()); %></strong>\n                            <%= originatorFormatter(revision); %>\n                        </td>\n                    </tr>\n                <% }); %>\n            <% } else if (documentRevisionCollection === null) { %>\n                <tr class=\"sos-table-ghost-row\">\n                    <% if (location.isRevisionable) { %>\n                        <td></td>\n                        <td></td>\n                    <% } %>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                </tr>\n                <tr class=\"sos-table-ghost-row\">\n                    <% if (location.isRevisionable) { %>\n                        <td></td>\n                        <td></td>\n                    <% } %>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                </tr>\n                <tr class=\"sos-table-ghost-row\">\n                    <% if (location.isRevisionable) { %>\n                        <td></td>\n                        <td></td>\n                    <% } %>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                    <td></td>\n                </tr>\n            <% } %>\n        </tbody>\n    </table>\n    <% if (documentRevisionCollection && documentRevisionCollection.length === 0) { %>\n        <p class=\"sos-empty-state sos-empty-state-show\">\n            <span class=\"sos-icon sos-icon-clock\">No history to display for this revision.</span>\n        </p>\n    <% } %>\n</div>",
'url:doccontrol/viewer/dojo/template/ViewInformation.html':"<div class=\"scroll-container\">\n    <div data-dojo-attach-point=\"loadingContainer\" class=\"loading-container twelve columns centered first last\">\n        <p class=\"loading-state information-loading\">\n            <span class=\"sos-icon sos-icon-animation-spin-smooth sos-icon-refresh\"></span>\n            <br />\n            Loading Information...\n        </p>\n    </div>\n    <div class=\"information-content-header hidden\" data-dojo-attach-point=\"informationHeader\">\n        <label class=\"view hide-mobile-width\">View:</label>\n        <div class=\"sos-form-select-inline\">\n            <label>\n                <input type=\"radio\"\n                       name=\"information-view\"\n                       value=\"standard\"\n                       data-dojo-attach-event=\"change: _onViewChange\"\n                       checked />\n                <span class=\"sos-icon sos-icon-menu adjust-mobile-width\"><span class=\"hide-mobile-width\">Standard</span></span>\n            </label>\n            <label>\n                <input type=\"radio\"\n                       name=\"information-view\"\n                       value=\"chronological\"\n                       data-dojo-attach-event=\"change: _onViewChange\" />\n                <span class=\"sos-icon sos-icon-clock adjust-mobile-width\"><span class=\"hide-mobile-width\">Chronological</span></span>\n            </label>\n        </div>\n        <button class=\"sos-btn sos-btn-s sos-btn-secondary sos-btn-icon sos-icon-expand\"\n                data-dojo-attach-event=\"click: _onExpandAllClick\">Expand<span class=\"hide-mobile-width\">&nbsp;All</span></button>\n        <button class=\"sos-btn sos-btn-s sos-btn-secondary sos-btn-icon sos-icon-compress\"\n                data-dojo-attach-event=\"click: _onCollapseAllClick\">Collapse<span class=\"hide-mobile-width\">&nbsp;All</span></button>\n    </div>\n    <div class=\"information-content-container\">\n        <div class=\"row hidden non-chronological-view-container\" data-dojo-attach-point=\"tableView\">\n            <div class=\"twelve columns non-chronological-content\">\n                <% if (latestRevision && revision && latestRevision.getRevisionPK() !== revision.getRevisionPK()) { %>\n                    <div class=\"information-notification-container\" data-dojo-attach-point=\"latestRevisionNotification\">\n                        <p class=\"sos-alert-information-s\">\n                            This document has been updated.\n                            <a href=\"<%= revisionDownloadUrl(latestRevision.getRevisionPK()) %>\"\n                               data-dojo-attach-event=\"click: viewDocument\"\n                               data-revision-pk=\"<%= latestRevision.getRevisionPK() %>\"\n                               data-file-type=\"<%= latestRevision.getFileType() %>\"\n                               data-md5=\"<%= latestRevision.getMd5() %>\">Click here</a>\n                            to view the <strong>latest revision</strong> of this document.\n                        </p>\n                    </div>\n                <% } %>\n                <% if (latestRevisionIsPrivate && !userHasAccess) { %>\n                    <div class=\"information-notification-container\">\n                        <p class=\"sos-alert-information-s\">\n                            This document has been updated, but you do not currently have access to view it.\n                        </p>\n                    </div>\n                <% } %>\n                <div class=\"sos-accordion\">\n                    <% if (metaDataCollection && metaDataCollection.length) { %>\n                        <div class=\"sos-accordion-pane\" data-title=\"Additional Metadata\">\n                            <table class=\"sos-table\">\n                                <thead>\n                                    <tr>\n                                        <th>Name</th>\n                                        <th>Value</th>\n                                    </tr>\n                                </thead>\n                                <tbody>\n                                    <% metaDataCollection.forEach(function(metaData) { %>\n                                        <tr>\n                                            <td><%= metaData.getName() %></td>\n                                            <td><%= metaData.getValue() %></td>\n                                        </tr>\n                                    <% }) %>\n                                </tbody>\n                            </table>\n                        </div>\n                    <% } %>\n\n                    <div class=\"sos-accordion-pane\" data-title=\"<%= informationPanes.DOCUMENT_HISTORY %>\">\n                        <div class=\"document-history-accordion\" data-dojo-attach-point=\"revisionHistoryTableNode\"></div>\n                    </div>\n\n                    <div class=\"sos-accordion-pane\" data-title=\"Soft Links\">\n                        <table class=\"sos-table <%= softLinks === null ? 'sos-table-ghost' : '' %>\">\n                            <thead>\n                            <tr>\n                                <th>Title</th>\n                                <th>Location</th>\n                                <th>Soft Linked By</th>\n                            </tr>\n                            </thead>\n                            <tbody>\n                            <% if (softLinks && softLinks.length) { %>\n                                <% for (let i = 0; i < softLinks.length; i++) { %>\n                                <tr>\n                                    <td><%= softLinks[i].getTitle() %></td>\n                                    <td><%= locationFormatter(softLinks[i].getLocation()) %></td>\n                                    <td><%= personFormatter(softLinks[i].getPerson()) %></td>\n                                </tr>\n                                <% } %>\n                            <% } else if (softLinks === null) { %>\n                                <tr class=\"sos-table-ghost-row\">\n                                    <td></td>\n                                    <td></td>\n                                    <td></td>\n                                </tr>\n                                <tr class=\"sos-table-ghost-row\">\n                                    <td></td>\n                                    <td></td>\n                                    <td></td>\n                                </tr>\n                                <tr class=\"sos-table-ghost-row\">\n                                    <td></td>\n                                    <td></td>\n                                    <td></td>\n                                </tr>\n                            <% } %>\n                            </tbody>\n                        </table>\n                        <% if (softLinks !== null && softLinks.length === 0) { %>\n                            <p class=\"sos-empty-state sos-empty-state-show\">\n                                <span class=\"sos-icon sos-icon-files-copy\">No soft links to display for this revision.</span>\n                            </p>\n                        <% } %>\n\n                    </div>\n                    <div class=\"sos-accordion-pane\" data-title=\"Moves\">\n\n                        <table class=\"sos-table <%= moveCollection === null ? 'sos-table-ghost' : '' %>\">\n                            <thead>\n                                <tr>\n                                    <th>Destination</th>\n                                    <th>Date Moved</th>\n                                    <th>Moved By</th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                            <% if (moveCollection && moveCollection.length) { %>\n                                <% for (let i = 0; i < moveCollection.length; i++) { %>\n                                    <tr>\n                                        <td><%= moveCollection[i].getDestination() %></td>\n                                        <td><%= dateFormatter(moveCollection[i].getTimeCreated()) %></td>\n                                        <td><%= personFormatter(moveCollection[i].getPerson()) %></td>\n                                    </tr>\n                                <% } %>\n                            <% } else if (moveCollection === null) { %>\n                                <tr class=\"sos-table-ghost-row\">\n                                    <td></td>\n                                    <td></td>\n                                    <td></td>\n                                </tr>\n                                <tr class=\"sos-table-ghost-row\">\n                                    <td></td>\n                                    <td></td>\n                                    <td></td>\n                                </tr>\n                                <tr class=\"sos-table-ghost-row\">\n                                    <td></td>\n                                    <td></td>\n                                    <td></td>\n                                </tr>\n                            <% } %>\n                            </tbody>\n                        </table>\n                        <% if (moveCollection !== null && moveCollection.length === 0) { %>\n                            <p class=\"sos-empty-state sos-empty-state-show\">\n                                <span class=\"sos-icon sos-icon-move\">No moves to display for this revision.</span>\n                            </p>\n                        <% } %>\n\n                    </div>\n                    <div class=\"sos-accordion-pane\" data-title=\"Linked Documents\">\n\n                        <table class=\"sos-table <%= linkedRevisionTreeNodeCollection === null ? 'sos-table-ghost' : '' %>\">\n                            <thead>\n                            <tr>\n                                <th>Name</th>\n                                <th colspan=\"2\">Title</th>\n                                <th class=\"sos-text-numeric sos-table-cell-numeric\">Size</th>\n                                <th>File Type</th>\n                                <th>Person</th>\n                                <th>Date</th>\n                            </tr>\n                            </thead>\n                            <tbody>\n                                <% if (linkedRevisionTreeNodeCollection && linkedRevisionTreeNodeCollection.length) { %>\n                                    <% for (var i in linkedRevisionTreeNodeCollection) { %>\n                                        <% if (linkedRevisionTreeNodeCollection.hasOwnProperty(i)) { %>\n                                            <% let linkedRevision = linkedRevisionTreeNodeCollection[i].getRevision(); %>\n                                            <tr>\n                                                <td><%= linkedRevision.getRealName(); %></td>\n                                                <% if (linkedRevision.isMarkedAsPrivate()) { %>\n                                                    <td>\n                                                        <a href=\"<%= revisionDownloadUrl(linkedRevision.getRevisionPK()) %>\"\n                                                           data-dojo-attach-event=\"click: viewDocument\"\n                                                           data-revision-pk=\"<%= linkedRevision.getRevisionPK() %>\"\n                                                           data-file-type=\"<%= linkedRevision.getFileType() %>\"\n                                                           data-md5=\"<%= linkedRevision.getMd5() %>\">\n                                                            <%= locationFormatter(linkedRevisionTreeNodeCollection[i].getTreeNode()) %> -\n                                                            <%= linkedRevision.getTitle(); %>\n                                                        </a>\n                                                    </td>\n                                                    <td class=\"sos-icon-private-document\"><span class=\"sos-icon\" /></td>\n                                                <% } else { %>\n                                                    <td colspan=\"2\">\n                                                        <a href=\"<%= revisionDownloadUrl(linkedRevision.getRevisionPK()) %>\"\n                                                           data-dojo-attach-event=\"click: viewDocument\"\n                                                           data-revision-pk=\"<%= linkedRevision.getRevisionPK() %>\"\n                                                           data-file-type=\"<%= linkedRevision.getFileType() %>\"\n                                                           data-md5=\"<%= linkedRevision.getMd5() %>\">\n                                                            <%= locationFormatter(linkedRevisionTreeNodeCollection[i].getTreeNode()) %> -\n                                                            <%= linkedRevision.getTitle(); %>\n                                                        </a>\n                                                    </td>\n                                                <% } %>\n                                                <td class=\"sos-text-numeric sos-table-cell-numeric\">\n                                                    <%= megabytesFormatter(linkedRevision.getFileSize()); %>\n                                                </td>\n                                                <td><%= mimeTypeFormatter(linkedRevision.getFileType()); %></td>\n                                                <td><%= personFormatter(linkedRevision.getPersonSender()); %></td>\n                                                <td><%= dateFormatter(linkedRevision.getDateUploaded()); %></td>\n                                            </tr>\n                                        <% } %>\n                                    <% } %>\n                                <% } else if (linkedRevisionTreeNodeCollection === null) { %>\n                                    <tr class=\"sos-table-ghost-row\">\n                                        <td></td>\n                                        <td colspan=\"2\"></td>\n                                        <td></td>\n                                        <td></td>\n                                        <td></td>\n                                        <td></td>\n                                    </tr>\n                                    <tr class=\"sos-table-ghost-row\">\n                                        <td></td>\n                                        <td colspan=\"2\"></td>\n                                        <td></td>\n                                        <td></td>\n                                        <td></td>\n                                        <td></td>\n                                    </tr>\n                                    <tr class=\"sos-table-ghost-row\">\n                                        <td></td>\n                                        <td colspan=\"2\"></td>\n                                        <td></td>\n                                        <td></td>\n                                        <td></td>\n                                        <td></td>\n                                    </tr>\n                                <% } %>\n                            </tbody>\n                        </table>\n                        <% if (linkedRevisionTreeNodeCollection !== null && linkedRevisionTreeNodeCollection.length === 0) { %>\n                            <p class=\"sos-empty-state sos-empty-state-show\">\n                                <span class=\"sos-icon sos-icon-link\">No linked documents to display for this revision.</span>\n                            </p>\n                        <% } %>\n\n                    </div>\n                    <div class=\"sos-accordion-pane\" data-title=\"Transmittals\">\n\n                        <table class=\"sos-table <%= transmittalCollection === null ? 'sos-table-ghost' : '' %>\">\n                            <thead>\n                            <tr>\n                                <th>Distributed By</th>\n                                <th>Date</th>\n                                <th>Recipients</th>\n                                <th>Comment</th>\n                                <th>Other Documents</th>\n                            </tr>\n                            </thead>\n                            <tbody>\n                            <% if (transmittalCollection && transmittalCollection.length) { %>\n                                <% for (let i in transmittalCollection) { %>\n                                    <% if (transmittalCollection.hasOwnProperty(i)) { %>\n                                        <tr>\n                                            <td><%= contactFormatter(transmittalCollection[i].getSender()); %></td>\n                                            <td><%= dateFormatter(transmittalCollection[i].getDateTransmitted()); %></td>\n                                            <td>\n                                                <ul>\n                                                    <% let recipients = transmittalCollection[i].getRecipients(); %>\n                                                    <% for (let j in recipients) { %>\n                                                        <% if (recipients.hasOwnProperty(j)) { %>\n                                                            <li><%= contactFormatter(recipients[j]); %></li>\n                                                        <% } %>\n                                                    <% } %>\n                                                </ul>\n                                            </td>\n                                            <% if (transmittalCollection[i].getEmailRevisionPK()) { %>\n                                                <td><a href=\"<%= overviewDocumentUrl(transmittalCollection[i].getEmailRevisionPK()) %>\" target=\"_blank\">View Correspondence</a></td>\n                                            <% } else { %>\n                                                <td><%= transmittalCollection[i].getComment(); %></td>\n                                            <% } %>\n                                            <td>\n                                                <% let revisions = transmittalCollection[i].getRevisions(); %>\n                                                <% if (revisions.length) { %>\n                                                    <ul>\n                                                        <% for (let j in revisions) { %>\n                                                            <% if (revisions.hasOwnProperty(j)) { %>\n                                                                <li>\n                                                                    <a href=\"<%= revisionDownloadUrl(revisions[j].getRevisionPK()) %>\"\n                                                                       data-dojo-attach-event=\"click: viewDocument\"\n                                                                       data-revision-pk=\"<%= revisions[j].getRevisionPK() %>\"\n                                                                       data-file-type=\"<%= revisions[j].getFileType() %>\"\n                                                                       data-md5=\"<%= revisions[j].getMd5() %>\">\n                                                                        <%= revisions[j].getTitle(); %>\n                                                                    </a>\n                                                                </li>\n                                                            <% } %>\n                                                        <% } %>\n                                                    </ul>\n                                                <% } else { %>\n                                                    -\n                                                <% } %>\n                                            </td>\n                                        </tr>\n                                    <% } %>\n                                <% } %>\n                            <% } else if (transmittalCollection === null) { %>\n                                <tr class=\"sos-table-ghost-row\">\n                                    <td></td>\n                                    <td></td>\n                                    <td></td>\n                                    <td></td>\n                                    <td></td>\n                                </tr>\n                                <tr class=\"sos-table-ghost-row\">\n                                    <td></td>\n                                    <td></td>\n                                    <td></td>\n                                    <td></td>\n                                    <td></td>\n                                </tr>\n                                <tr class=\"sos-table-ghost-row\">\n                                    <td></td>\n                                    <td></td>\n                                    <td></td>\n                                    <td></td>\n                                    <td></td>\n                                </tr>\n                            <% } %>\n                            </tbody>\n                        </table>\n                        <% if (transmittalCollection !== null && transmittalCollection.length === 0) { %>\n                            <p class=\"sos-empty-state sos-empty-state-show\">\n                                <span class=\"sos-icon sos-icon-envelope\">No transmittals to display for this revision.</span>\n                            </p>\n                        <% } %>\n                    </div>\n                    <div class=\"sos-accordion-pane notes-accordion\" data-title=\"Notes\">\n                        <div data-dojo-attach-point=\"addNoteDialogNode\"></div>\n                        <table class=\"sos-table <%= noteCollection === null ? 'sos-table-ghost' : '' %>\">\n                            <thead>\n                                <tr>\n                                    <th>Note</th>\n                                    <th>Date Added</th>\n                                    <th>Added By</th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                            <% if (noteCollection && noteCollection.length) { %>\n                                <% noteCollection.forEach(function(note) { %>\n                                    <tr>\n                                        <td><%- noteFormatter(note.getNote()) %></td>\n                                        <td><%= dateFormatter(note.getTimeCreated()) %></td>\n                                        <td><%= personFormatter(note.getPerson()) %></td>\n                                    </tr>\n                                <% }) %>\n                            <% } else if (noteCollection === null) { %>\n                                <tr class=\"sos-table-ghost-row\">\n                                    <td></td>\n                                    <td></td>\n                                    <td></td>\n                                </tr>\n                                <tr class=\"sos-table-ghost-row\">\n                                    <td></td>\n                                    <td></td>\n                                    <td></td>\n                                </tr>\n                                <tr class=\"sos-table-ghost-row\">\n                                    <td></td>\n                                    <td></td>\n                                    <td></td>\n                                </tr>\n                            <% } %>\n                            </tbody>\n                        </table>\n                        <% if (noteCollection !== null && noteCollection.length === 0) { %>\n                            <p class=\"sos-empty-state sos-empty-state-show mb-0\">\n                                <span class=\"sos-icon sos-icon-file\">No notes to display for this document.</span>\n                            </p>\n                        <% } %>\n                        <button class=\"sos-btn sos-btn-icon sos-icon-plus add-note-button float-r mx-0\" data-dojo-attach-event=\"click: _showAddNoteDialog\">Add Note</button>\n                    </div>\n\n                    <div class=\"sos-accordion-pane\" data-title=\"Access Log\">\n                        <table class=\"sos-table <%= accessLogs === null ? 'sos-table-ghost' : '' %>\">\n                            <thead>\n                            <tr>\n                                <th>Name</th>\n                                <th>Date</th>\n                                <th>Access Type</th>\n                            </tr>\n                            </thead>\n                            <tbody>\n                            <% if (accessLogs && accessLogs.length) { %>\n                                <% for (var i in accessLogs) { %>\n                                    <% if (accessLogs.hasOwnProperty(i)) { %>\n                                        <tr>\n                                            <td><%= personFormatter(accessLogs[i].getPerson()); %></td>\n                                            <td><%= dateFormatter(accessLogs[i].getDate()); %></td>\n                                            <td>\n                                                <% if (accessLogs[i].getType() === 'view') { %>\n                                                    <span class=\"sos-icon sos-icon-eye\">View</span>\n                                                <% } else if (accessLogs[i].getType() === 'download') { %>\n                                                    <span class=\"sos-icon sos-icon-download\">Download</span>\n                                                <% } else { %>\n                                                    <%= accessLogs[i].getType() ?? '-'; %>\n                                                <% } %>\n                                            </td>\n                                        </tr>\n                                    <% } %>\n                                <% } %>\n                            <% } else if (accessLogs === null) { %>\n                                <tr class=\"sos-table-ghost-row\">\n                                    <td></td>\n                                    <td></td>\n                                    <td></td>\n                                </tr>\n                                <tr class=\"sos-table-ghost-row\">\n                                    <td></td>\n                                    <td></td>\n                                    <td></td>\n                                </tr>\n                                <tr class=\"sos-table-ghost-row\">\n                                    <td></td>\n                                    <td></td>\n                                    <td></td>\n                                </tr>\n                            <% } %>\n                            </tbody>\n                        </table>\n                        <% if (accessLogs !== null && accessLogs.length === 0) { %>\n                            <p class=\"sos-empty-state sos-empty-state-show\">\n                                <span class=\"sos-icon sos-icon-file\">No access logs to display for this revision.</span>\n                            </p>\n                        <% } %>\n                    </div>\n                </div>\n            </div>\n        </div>\n\n        <div class=\"row chronological-view-container hidden\" data-dojo-attach-point=\"chronologicalViewNode\"></div>\n    </div>\n</div>\n",
'url:doccontrol/viewer/dojo/template/CorrespondenceViewer.html':"<div class=\"sos-layout-dialog-content\">\n    <div data-dojo-attach-point=\"loadingContainer\" class=\"loading-container twelve columns centered first last\">\n        <p data-dojo-attach-point=\"loading\" class=\"loading-state\">\n            <span class=\"sos-icon sos-icon-animation-spin-smooth sos-icon-refresh\"></span>\n            <br />\n            Loading...\n            <br />\n            <br />\n            <button class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-close\"\n                    data-dojo-attach-point=\"elementCancel\"\n                    data-dojo-attach-event=\"click: _onCancelClick\">Cancel</button>\n        </p>\n\n        <p data-dojo-attach-point=\"errorMessage\" class=\"hidden error-message\">\n            Sorry, this message could not be retrieved from the server.\n            <br />\n            If this problem persists, please contact support.\n        </p>\n\n        <p data-dojo-attach-point=\"unauthorisedMessage\" class=\"hidden error-message\">\n            You do not have permission to view this document.\n        </p>\n\n        <p data-dojo-attach-point=\"deletedMessage\" class=\"hidden error-message\">\n            Sorry, you cannot view this document as it has been deleted.\n        </p>\n    </div>\n\n    <div class=\"information-container hidden\" data-dojo-attach-point=\"informationContainer\"></div>\n\n    <div class=\"content-container message-container hidden\" data-dojo-attach-point=\"messageContainer\">\n        <div id=\"viewRevisionHistorySidebar\"></div>\n        <div class=\"scroll-container\" data-dojo-attach-point=\"scrollContainer\">\n            <div class=\"correspondence-body\" data-dojo-attach-point=\"correspondenceBody\">\n                <% if (correspondence) { %>\n                    <div class=\"overflow-y-auto\">\n                        <table class=\"sos-table\">\n                            <tbody>\n                            <tr>\n                                <th class=\"text-align-right\">From</th>\n                                <td><%- correspondence.getFrom() %></td>\n                            </tr>\n                            <tr>\n                                <th class=\"text-align-right\">To</th>\n                                <td><%- correspondence.getTo() %></td>\n                            </tr>\n                            <% if (correspondence.getCC()) { %>\n                                <tr>\n                                    <th class=\"text-align-right\">CC</th>\n                                    <td><%- correspondence.getCC() %></td>\n                                </tr>\n                            <% } %>\n                            <tr>\n                                <th class=\"text-align-right\">Subject</th>\n                                <td><%- correspondence.getSubject() %></td>\n                            </tr>\n                            <tr>\n                                <th class=\"text-align-right\">Date</th>\n                                <td><%= date(correspondence.getDate(), { selector: 'date', locale: 'en-gb', datePattern: 'dd/MM/yyyy HH:mm' }) %></td>\n                            </tr>\n                            <% if (correspondence.getRegistrationLocation()) { %>\n                                <tr>\n                                    <th class=\"text-align-right\">Location</th>\n                                    <td><%= formatLocation(correspondence.getRegistrationLocation()) %></td>\n                                </tr>\n                            <% } %>\n                            <% if (correspondence.getRevisionPK()) { %>\n                                <tr>\n                                    <th class=\"text-align-right\">Options</th>\n                                    <td>\n                                        <a class=\"sos-icon sos-icon-print\" href=\"<%= viewPrintableEmailUrl(correspondence.getRevisionPK()) %>\" target=\"_blank\">View printable version</a>\n                                    </td>\n                                </tr>\n                            <% } %>\n                            </tbody>\n                        </table>\n                    </div>\n                    <br />\n                    <% var revisions = correspondence.getRevisions(); %>\n                    <% var temporaryDocuments = correspondence.getTemporaryDocuments(); %>\n                    <% if (revisions.length > 0 || temporaryDocuments.length > 0) { %>\n                        <table class=\"sos-table\">\n                            <thead>\n                                <tr>\n                                    <th>\n                                        Attachments\n                                        <div class=\"right\">\n                                            <a class=\"sos-icon sos-icon-download\" data-dojo-attach-event=\"click: _onDownloadAllAsZipClick\">Download all as zip</a>\n                                                -\n                                            <a class=\"sos-icon sos-icon-shopping-basket\" data-dojo-attach-event=\"click: _onAddAttachmentsToCurrentBasketClick\">Add Attachments to Current Basket</a>\n                                        </div>\n                                    </th>\n                                    <th>Action</th>\n                                </tr>\n                            </thead>\n                            <tbody>\n                                <% for (var i in revisions) { %>\n                                    <% if (revisions.hasOwnProperty(i)) { %>\n                                        <% var revision = revisions[i]; %>\n                                        <tr>\n                                            <td>\n                                                <a href=\"<%= revisionDownloadUrl(revision.getRevisionPK()) %>\"\n                                                   data-dojo-attach-event=\"click: viewDocument\"\n                                                   data-revision-pk=\"<%= revision.getRevisionPK() %>\"\n                                                   data-file-type=\"<%= revision.getFileType() %>\"\n                                                   data-md5=\"<%= revision.getMd5() %>\">\n                                                    <%= registrationLocations[i] ? formatLocation(registrationLocations[i]) + ' - ' : '' %>\n                                                    <%= revision.getRealName() %>\n                                                </a>\n                                            </td>\n                                            <td></td>\n                                        </tr>\n                                    <% } %>\n                                <% } %>\n\n                                <% for (var j in temporaryDocuments) { %>\n                                    <% if (temporaryDocuments.hasOwnProperty(j)) { %>\n                                        <% var temporaryDocument = temporaryDocuments[j]; %>\n                                        <tr>\n                                            <td>\n                                                <small>[Not Registered]</small>\n                                                <a href=\"<%= temporaryDocumentDownloadUrl(temporaryDocument.getTemporaryDocumentPK()) %>\"\n                                                   data-dojo-attach-event=\"click: viewDocument\"\n                                                   data-temporary-document-pk=\"<%= temporaryDocument.getTemporaryDocumentPK() %>\"\n                                                   data-file-type=\"<%= temporaryDocument.getType() %>/<%= temporaryDocument.getSubType() %>\"\n                                                   data-md5=\"<%= temporaryDocument.getMd5() %>\">\n                                                    <%= temporaryDocument.getName() %>\n                                                </a>\n                                            </td>\n                                            <td><a href=\"<%= linkPersonUrl(temporaryDocument.getTemporaryDocumentPK(), correspondence.getEmailPK()) %>\">Register</a></td>\n                                        </tr>\n                                    <% } %>\n                                <% } %>\n                            </tbody>\n                        </table>\n                    <% } %>\n                    <hr />\n                    <%- correspondence.getContents() %>\n                <% } %>\n            </div>\n        </div>\n    </div>\n</div>\n",
'url:style-guide/v1/file-tray/template/Bar.html':"<div class=\"sos-file-tray-bar\" data-dojo-attach-point=\"container\" data-dojo-attach-event=\"dragenter: _onDragEnter, dragleave: _onDragLeave\">\n    <div class=\"sos-file-tray-bar-head\"\n         draggable=\"true\"\n         data-dojo-attach-point=\"buttonOpenClose\"\n         data-dojo-attach-event=\"click: _onButtonClick, dragstart: _onDragStart, drag: _onDrag, dragend: _onDragEnd\">\n        <span class=\"sos-icon sos-icon-arrows-vertical\" draggable=\"false\">Drag to Resize</span>\n        <span class=\"sos-file-tray-bar-open-text\" draggable=\"false\">Open Basket</span>\n        <span class=\"sos-file-tray-bar-close-text\" draggable=\"false\">Close Basket</span>\n        <span class=\"sos-file-tray-bar-center\">\n            <span class=\"sos-icon sos-icon-shopping-basket\" data-dojo-attach-point=\"containerItemCount\"></span>\n        </span>\n        <span class=\"sos-file-tray-bar-center sos-icon sos-icon-animation-spin-smooth-before sos-icon-refresh hide\"\n              data-dojo-attach-point=\"containerAddingItem\">Adding files...</span>\n    </div>\n    <div class=\"sos-file-tray-bar-body\">\n        <div data-dojo-attach-point=\"elementBasketSidebar\"></div>\n        <div data-dojo-attach-point=\"elementMainView\"></div>\n        <div data-dojo-attach-point=\"elementSavedBasketView\"></div>\n        <div data-dojo-attach-point=\"elementSplitBasketView\"></div>\n    </div>\n\n    <div class=\"sos-file-tray-bar-drag-image\" data-dojo-attach-point=\"elementDragImage\"></div>\n</div>",
'url:style-guide/v1/drag-and-drop/template/Cursor.html':"<div class=\"sos-drag-and-drop-cursor\">\n    <span class=\"drag-cursor-action-icon <%= documentClass %>\"></span>\n    <span class=\"sos-icon <%= !isMultiple && classString ? classString : (isMultiple ? 'sos-icon-files-copy' : 'sos-icon-file') %>\"><%- encode(text) %></span>\n</div>",
'url:style-guide/v1/file-tray/template/BasketSidebar.html':"<div class=\"sos-file-tray-body-basket-sidebar\">\n    <div class=\"file-tray-sidebar-item\" data-dojo-attach-point=\"current\" data-dojo-attach-event=\"click: _onSidebarItemCurrentClick\">\n        <span class=\"sos-icon sos-icon-shopping-basket\"></span>\n        Current Basket (<%= currentBasketCount %>)\n    </div>\n    <div class=\"file-tray-sidebar-item\" data-dojo-attach-event=\"click: _onSidebarItemSavedBasketsClick\">\n        <span class=\"sos-icon sos-icon-folder\"></span>\n        Saved Baskets\n        <span class=\"sos-icon sos-icon-chevron-<%= savedBasketsExpanded ? 'down' : 'left' %>\"></span>\n    </div>\n    <% if (loading && savedBasketsExpanded) { %>\n        <div class=\"file-tray-sidebar-empty\">Loading baskets...</div>\n    <% } %>\n    <% if (error && savedBasketsExpanded) { %>\n        <div class=\"file-tray-sidebar-empty\">Error loading baskets</div>\n    <% } %>\n    <% if (!loading && !baskets.length && savedBasketsExpanded) { %>\n        <div class=\"file-tray-sidebar-empty\">No saved baskets</div>\n    <% } %>\n    <div class=\"sidebar-child-container\" data-dojo-attach-point=\"childContainer\">\n        <% if (!loading && !error && savedBasketsExpanded) { %>\n            <% baskets.forEach((basket) => { %>\n                <div class=\"file-tray-sidebar-item file-tray-sidebar-item-saved-basket\"\n                     data-dojo-attach-event=\"click: _onSidebarItemSavedBasketClick\"\n                     data-id=\"<%= basket.id %>\">\n                    <span><%= basket.getName() %> (<%= basket.getCount() %>)</span>\n                    <% if (basket.getCollaborators().length) { %>\n                        <div class=\"text-align-center align-self-center\"\n                             title=\"<%= basket.getCollaborators().length %> collaborator<%= basket.getCollaborators().length === 1 ? '' : 's' %>\">\n                            <span class=\"sos-icon sos-icon-user<%= basket.getCollaborators().length === 1 ? '' : 's' %>\"></span>\n                        </div>\n                    <% } %>\n                </div>\n            <% }); %>\n        <% } %>\n    </div>\n    <div class=\"file-tray-sidebar-item\" data-dojo-attach-event=\"click: _onSidebarItemUploadingFilesClick\">\n        <span class=\"sos-icon sos-icon-upload\"></span>\n        Uploading (<%= uploadingFiles.length %>)\n        <span class=\"sos-icon sos-icon-chevron-<%= uploadingFilesExpanded ? 'down' : 'left' %>\"></span>\n    </div>\n    <% if (!uploadingFiles.length && uploadingFilesExpanded) { %>\n        <div class=\"file-tray-sidebar-empty\">No uploads in progress</div>\n    <% } %>\n    <div class=\"sidebar-child-container no-wrap\">\n        <% if (uploadingFilesExpanded) { %>\n            <% uploadingFiles.forEach((file) => { %>\n                <div class=\"file-tray-sidebar-item\"\n                     data-id=\"<%= file.id %>\"\n                     data-dojo-attach-event=\"click: _onSidebarItemUploadingFileClick\"\n                     title=\"Cancel upload for <%= file.name %>\">\n                    <span class=\"file-tray-sidebar-item-ellipsis\"><%= file.name %></span>\n                    <% if (file.error) { %>\n                        (error)\n                    <% } else { %>\n                        (<span data-id-upload-progress=\"<%= file.id %>\"><%= file.progress %></span>%)\n                    <% } %>\n                </div>\n            <% }); %>\n        <% } %>\n    </div>\n</div>",
'url:style-guide/v1/layout/templates/DialogConfirm.html':"<div>\n    <div class=\"sos-layout-dialog-content\">\n        <p><%= message ?? 'Are you sure you want to continue?' %></p>\n    </div>\n    <div class=\"sos-layout-dialog-footer display-grid grid-cols-2\">\n        <div>\n            <button class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-close\"\n                    data-dojo-attach-point=\"closeButtonElement\"\n                    data-dojo-attach-event=\"click: _onCloseClick\">Cancel</button>\n        </div>\n        <div class=\"text-align-right\">\n            <button class=\"sos-btn sos-btn-<%= isNegativeAction ? 'negative' : 'confirm' %> sos-btn-icon sos-icon-<%= confirmIcon ?? 'check' %>\"\n                    data-dojo-attach-point=\"confirmButtonElement\"\n                    data-dojo-attach-event=\"click: _onConfirmClick\"><%= confirmText ?? 'Confirm' %></button>\n        </div>\n    </div>\n</div>",
'url:style-guide/v1/file-tray/template/Current.html':"<div class=\"sos-file-tray-body-container\">\n    <div class=\"sos-file-tray-bar-body-header\">\n        <div class=\"heading-container\">\n            <div>\n                <div class=\"heading\">\n                    <span class=\"sos-icon sos-icon-shopping-basket mr-6\"></span>Current Basket\n                </div>\n            </div>\n            <div>\n                <button class=\"sos-btn sos-btn-s sos-btn-secondary sos-btn-icon sos-icon-download\"\n                        data-dojo-attach-event=\"click: _onDownloadCSVClick\"\n                        data-dojo-attach-point=\"buttonDownloadCSV\"\n                        disabled><span class=\"hide-low-width\">Download </span>CSV</button>\n                <button class=\"sos-btn sos-btn-s sos-btn-secondary sos-btn-icon sos-icon-fork\"\n                        data-dojo-attach-event=\"click: _onSplitBasketClick\"\n                        data-dojo-attach-point=\"buttonSplitBasket\"\n                        disabled>Split<span class=\"hide-low-width\"> Basket</span></button>\n                <button class=\"sos-btn sos-btn-s sos-btn-confirm sos-btn-icon sos-icon-save\"\n                        data-dojo-attach-event=\"click: _onSaveBasketClick\"\n                        data-dojo-attach-point=\"buttonSaveBasket\"\n                        disabled>Save<span class=\"hide-low-width\"> Basket</span></button>\n                <button class=\"sos-btn sos-btn-s sos-btn-negative sos-btn-icon sos-icon-trash\"\n                        data-dojo-attach-event=\"click: _onEmptyFileTrayClick\"\n                        data-dojo-attach-point=\"buttonEmptyFileTray\"\n                        disabled>Empty<span class=\"hide-low-width\"> Basket</span></button>\n            </div>\n        </div>\n        <div class=\"display-inline-block\">\n            <div class=\"sos-form-textfield-with-prefix-flex\">\n                <label class=\"sos-form-textfield-prefix sos-form-textfield-prefix-s\">Filter<span class=\"hide-low-width\"> documents</span></label><input\n                    class=\"sos-form-textfield sos-form-textfield-s sos-form-textfield-prefixed\"\n                    data-dojo-attach-event=\"input: _onFilterInput\"\n                    data-dojo-attach-point=\"textFieldFilter\"\n                    type=\"search\"\n                    disabled\n                    value=\"\" />\n            </div>\n        </div>\n        <button class=\"sos-btn sos-btn-s sos-btn-secondary sos-btn-icon sos-icon-refresh\"\n                data-dojo-attach-event=\"click: _onRefreshClick\"\n                data-dojo-attach-point=\"buttonRefresh\">Refresh</button>\n        <button class=\"sos-btn sos-btn-s sos-btn-secondary sos-btn-icon sos-icon-upload\"\n                data-dojo-attach-event=\"click: _onUploadFileClick\"\n                data-dojo-attach-point=\"buttonUpload\">Upload<span class=\"hide-low-width\"> File</span></button>\n        <form id=\"fileTrayFileUploadForm\">\n            <input type=\"file\" class=\"hide\" multiple\n                   data-dojo-attach-event=\"change: _onInputFileChange\"\n                   data-dojo-attach-point=\"inputFile\">\n        </form>\n    </div>\n    <div class=\"sos-file-tray-bar-body-items\"\n         data-dojo-attach-point=\"elementBodyItems\"\n         data-dojo-attach-event=\"dragover: _onBodyDragOver, drop: _onBodyDrop, dragleave: _onBodyDragLeave\">\n        <div class=\"row collapse sos-file-tray-bar-body-items-controls hide\" data-dojo-attach-point=\"elementBodyControls\">\n            <div class=\"twelve columns\">\n                <span>Select <a data-dojo-attach-event=\"click: _onSelectAllClick\" title=\"Select all files\">All</a> | <a data-dojo-attach-event=\"click: _onSelectNoneClick\" title=\"Deselect all files\">None</a></span>\n                <span class=\"sos-file-tray-bar-view-switch\">\n                    <a class=\"sos-anchor-th hide\"\n                       title=\"Switch to the card view\"\n                       data-dojo-attach-event=\"click: _onCardViewClick\"\n                       data-dojo-attach-point=\"buttonCardView\"><span class=\"hide-low-width\">Switch to </span>Card View</a>\n                    <a class=\"sos-anchor-list\"\n                       title=\"Switch to the table view\"\n                       data-dojo-attach-event=\"click: _onTableViewClick\"\n                       data-dojo-attach-point=\"buttonTableView\"><span class=\"hide-low-width\">Switch to </span>Table View</a>\n                </span>\n                <div class=\"sos-drop-down-button\">\n                    <button class=\"sos-btn sos-btn-secondary sos-btn-s sos-btn-icon sos-icon-share\"\n                            data-dojo-attach-point=\"buttonActionSelectedDocuments\"\n                            disabled=\"disabled\">Actions for <strong>selected documents</strong></button>\n                    <div class=\"sos-drop-down-button-content\">\n                        <button class=\"sos-btn sos-btn-secondary sos-btn-secondary sos-btn-s sos-btn-icon sos-icon-upload\"\n                                data-dojo-attach-point=\"buttonBulkExtractDocuments\"\n                                data-dojo-attach-event=\"click:_bulkExtract\"\n                                disabled=\"disabled\">Bulk Extract</button>\n                        <button class=\"sos-btn sos-btn-secondary sos-btn-secondary sos-btn-s sos-btn-icon sos-icon-files-copy\"\n                                data-dojo-attach-point=\"buttonBulkSoftLinkDocuments\"\n                                data-dojo-attach-event=\"click:_bulkSoftLink\"\n                                disabled>Bulk Soft Link</button>\n                        <button class=\"sos-btn sos-btn-secondary sos-btn-s sos-btn-icon sos-icon-download\"\n                                data-dojo-attach-point=\"buttonDownloadZip\"\n                                data-dojo-attach-event=\"click:_downloadZip\">Download as ZIP</button>\n                        <button class=\"sos-btn sos-btn-secondary sos-btn-s sos-btn-icon sos-icon-download\"\n                                data-dojo-attach-point=\"buttonDownloadZip\"\n                                data-dojo-attach-event=\"click:_downloadZipOfPdfs\">Download as ZIP of PDFs</button>\n                        <button class=\"sos-btn sos-btn-secondary sos-btn-s sos-btn-icon sos-icon-envelope\"\n                                data-dojo-attach-point=\"buttonEmailSelected\"\n                                data-dojo-attach-event=\"click:_emailSelected\">Attach to New Email</button>\n                        <button class=\"sos-btn sos-btn-secondary sos-btn-s sos-btn-icon sos-icon-shopping-basket\"\n                                data-dojo-attach-point=\"buttonSaveSelectedAsNewBasket\"\n                                data-dojo-attach-event=\"click: _saveSelectedAsNewBasketClick\">Save as New Basket</button>\n                        <button class=\"sos-btn sos-btn-secondary sos-btn-s sos-btn-icon sos-icon-shopping-basket\"\n                                data-dojo-attach-point=\"buttonAddToExistingBasket\"\n                                data-dojo-attach-event=\"click: _addToExistingBasketClick\">Add to Existing Basket</button>\n                    </div>\n                </div>\n                <div data-dojo-attach-point=\"containerContextButtons\"></div>\n            </div>\n        </div>\n        <div class=\"item-collection-wrapper\">\n            <div data-dojo-attach-point=\"containerItemCollection\"></div>\n        </div>\n        <p data-dojo-attach-point=\"elementEmptyState\" class=\"sos-empty-state sos-empty-state-show\">\n            <span class=\"sos-icon sos-icon-file\">\n                There are no items in your basket.\n                <br />\n                <br />\n                <i class=\"sos-icon sos-icon-information\"></i> Select one or more files using the <b>\"Upload File\"</b> button above or <b>drag and drop</b> a file from other areas of the system or your desktop.\n            </span>\n        </p>\n    </div>\n</div>",
'url:style-guide/v1/layout/templates/FormPane.html':"<div class=\"sos-form-pane\">\n    <div data-dojo-attach-point=\"formPaneContent\" class=\"sos-form-pane-content\">\n        <table class=\"sos-form-pane-header\">\n            <tr>\n                <% if (icon) { %>\n                    <td class=\"icon\">\n                        <span data-dojo-attach-point=\"elementIcon\" class=\"sos-icon <%= icon %>\"></span>\n                    </td>\n                <% } %>\n                <td class=\"title\">\n                    <span data-dojo-attach-point=\"elementTitle\"></span><a data-dojo-attach-point=\"elementTitleLink\"></a>\n                </td>\n                <td class=\"close\">\n                    <a data-dojo-attach-point=\"elementClose\" class=\"sos-icon sos-icon-times\">close</a>\n                </td>\n            </tr>\n        </table>\n        <div class=\"sos-form-pane-body <%= additionalClass %>\" data-dojo-attach-point=\"contentNode\">\n            <div data-dojo-attach-point=\"loadingContainer\">\n                <div>\n                    <p class=\"loading-state\">\n                        <span class=\"sos-icon sos-icon-animation-spin-smooth sos-icon-refresh\"></span><br />\n                        <span data-dojo-attach-point=\"loadingText\">Loading</span>\n                    </p>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>",
'url:style-guide/v1/layout/templates/StackPane.html':"<div class=\"sos-v1 sos-stack-pane disable-animation\">\n    <div class=\"sos-stack-pane-content\" data-dojo-attach-point=\"contentNode\">\n        <div data-dojo-attach-point=\"loadingState\">\n            <p class=\"loading-state\">\n                <span class=\"sos-icon sos-icon-animation-spin-smooth sos-icon-refresh\"></span><br />\n                <span data-dojo-attach-point=\"loadingText\">Loading...</span>\n            </p>\n        </div>\n    </div>\n</div>",
'url:style-guide/v1/doc-control/document/bulk-soft-link/template/Form.html':"<div class=\"height-100\">\n    <div class=\"display-flex flex-direction-column flex-grow-1 height-100\">\n        <div class=\"display-grid grid-cols-2\">\n            <div>\n                <button class=\"sos-btn sos-btn-s sos-btn-secondary select-location-button sos-btn-icon sos-icon-folder-open mt-0 ml-0\"\n                        data-dojo-attach-point=\"elementSetSelectedLocationButton\"\n                        data-dojo-attach-event=\"click: _onSetSelectedLocationClick\"\n                        disabled>Set Selected Location</button>\n            </div>\n            <div class=\"text-align-right\">\n                <button class=\"sos-btn sos-btn-s sos-btn-negative sos-btn-icon sos-icon-trash reset-location-button mt-0 mx-0\"\n                        data-dojo-attach-point=\"elementRemoveSelectedButton\"\n                        data-dojo-attach-event=\"click: _onRemoveSelectedClick\"\n                        disabled>Remove Selected</button>\n            </div>\n        </div>\n\n        <div class=\"overflow-y-auto\">\n            <div data-dojo-attach-point=\"elementTable\"></div>\n        </div>\n\n        <div class=\"text-align-right my-12\">\n            <button data-dojo-attach-event=\"click: _onSubmitClick\"\n                    data-dojo-attach-point=\"elementSubmitButton\"\n                    disabled\n                    class=\"sos-btn sos-btn-confirm sos-btn-icon sos-icon-files-copy m-0\">Soft Link</button>\n        </div>\n    </div>\n</div>",
'url:style-guide/v1/doc-control/document/bulk-soft-link/template/LocationForm.html':"<div>\n    <h4 class=\"mt-0\">Select Project Stage</h4>\n    <div data-dojo-attach-point=\"elementProjectStage\"></div>\n    <div data-dojo-attach-point=\"elementInactiveProjectStageWarning\" class=\"sos-alert-warning mt-12 display-none\">\n        The selected project stage is <strong>inactive</strong>.\n        <br />\n        <br />\n        You can still soft link documents here, however, unless the 'Search inactive projects'\n        filter is applied, the document will not appear in search results.\n    </div>\n\n    <div data-dojo-attach-point=\"elementUnauthorisedProjectStageError\" class=\"sos-alert-error mt-12 display-none\">\n        This project stage is <strong>restricted</strong> and you have not been granted access.\n    </div>\n\n    <div data-dojo-attach-point=\"elementNodeSelectContainer\" class=\"display-none\">\n        <h4>Select Location</h4>\n        <div data-dojo-attach-point=\"elementNodeSelect\"></div>\n    </div>\n\n    <div class=\"text-align-right mt-12\">\n        <button data-dojo-attach-event=\"click: _onSubmitClick\"\n                data-dojo-attach-point=\"elementSubmitButton\"\n                disabled\n                class=\"sos-btn sos-btn-confirm sos-btn-icon sos-icon-pencil-paper m-0\">Set Location</button>\n    </div>\n</div>",
'url:dijit/form/templates/DropDownBox.html':"<div class=\"dijit dijitReset dijitInline dijitLeft\"\n\tid=\"widget_${id}\"\n\trole=\"combobox\"\n\taria-haspopup=\"true\"\n\tdata-dojo-attach-point=\"_popupStateNode\"\n\t><div class='dijitReset dijitRight dijitButtonNode dijitArrowButton dijitDownArrowButton dijitArrowButtonContainer'\n\t\tdata-dojo-attach-point=\"_buttonNode\" role=\"presentation\"\n\t\t><input class=\"dijitReset dijitInputField dijitArrowButtonInner\" value=\"&#9660; \" type=\"text\" tabIndex=\"-1\" readonly=\"readonly\" role=\"button presentation\" aria-hidden=\"true\"\n\t\t\t${_buttonInputDisabled}\n\t/></div\n\t><div class='dijitReset dijitValidationContainer'\n\t\t><input class=\"dijitReset dijitInputField dijitValidationIcon dijitValidationInner\" value=\"&#935; \" type=\"text\" tabIndex=\"-1\" readonly=\"readonly\" role=\"presentation\"\n\t/></div\n\t><div class=\"dijitReset dijitInputField dijitInputContainer\"\n\t\t><input class='dijitReset dijitInputInner' ${!nameAttrSetting} type=\"${type}\" autocomplete=\"off\"\n\t\t\tdata-dojo-attach-point=\"textbox,focusNode\" role=\"textbox\"\n\t/></div\n></div>\n",
'url:style-guide/v1/doc-control/project-node-select/template/FilteringNodeSelect.html':"<div class=\"filtering-node-select\" style=\"position: relative;\">\n    <div class=\"loading-overlay hidden\" data-dojo-attach-point=\"loadingNode\">\n        <p class=\"loading-state\">\n            <span class=\"sos-icon sos-icon-animation-spin-smooth sos-icon-refresh\"></span>\n            <br />\n            <span data-dojo-attach-point=\"loadingMessage\">Loading...</span>\n        </p>\n    </div>\n    <div class=\"filtering-node-select-filter-wrapper\">\n        <input type=\"text\" data-dojo-attach-point=\"filterInput\" data-dojo-attach-event=\"keyup: _onFilterInputKeyUp\" class=\"sos-form-textfield\" />\n    </div>\n    <div data-dojo-attach-point=\"nodeListingWrapper\">\n        <div data-dojo-attach-point=\"nodeListingContainer\"></div>\n    </div>\n</div>\n",
'url:style-guide/v1/doc-control/project-node-select/template/NodeListing.html':"<div>\n    <ul class=\"sos-node-listing\" data-dojo-attach-point=\"nodeListing\">\n        <% if (!menuItems || !menuItems.length) { %>\n            <li class=\"display-grid align-items-center text-align-center height-100 p-12\">\n                <div>\n                    <i class=\"sos-icon sos-icon-folder font-size-large\"></i>\n                    <br>\n                    This document tree is empty.\n                </div>\n            </li>\n        <% } else { %>\n            <% for (let i in menuItems) { %>\n                <% if (menuItems.hasOwnProperty(i)) { %>\n                    <li data-dom-node-tree-view-pk=\"<%= menuItems[i].treeViewPK %>\"\n                        title=\"<%= menuItems[i].isDisabled ? 'Folder is inactive' : '' %>\"\n                        class=\"sos-node-listing-item\n                            <%= menuItems[i].isSelectable ? 'selectable' : '' %>\n                            <%= menuItems[i].isDisabled ? 'filtering-node-select-disabled' : '' %>\n                            <%= menuItems[i].children.length ? 'expandable' : '' %>\"\n                        style=\"left:<%= menuItems[i].increment %>;width: calc(100% - <%= menuItems[i].increment %>)\">\n                        <% if (menuItems[i].isSelectable) { %>\n                            <a data-dojo-attach-event=\"click: _onNodeClick\"\n                               data-node-tree-view-pk=\"<%= menuItems[i].treeViewPK %>\"\n                               data-node-title=\"<%= menuItems[i].name %>\"\n                               data-node-type=\"<%= menuItems[i].type %>\"\n                               title=\"Select <%= menuItems[i].name %>\"\n                               class=\"sos-icon <%= menuItems[i].icon %>\"><%= menuItems[i].name %></a>\n                        <% } else { %>\n                            <% if (menuItems[i].children && menuItems[i].children.length > 0) { %>\n                                <a data-node-tree-view-pk=\"<%= menuItems[i].treeViewPK %>\"\n                                   data-node-expanded=\"<%= menuItems[i].expanded %>\"\n                                   data-dojo-attach-event=\"click: _onExpandNodeClick\"\n                                   class=\"sos-icon <%= menuItems[i].icon %> non-selectable\"><%= menuItems[i].name %></a>\n                            <% } else { %>\n                                <span class=\"sos-icon <%= menuItems[i].icon %>\"><%= menuItems[i].name %></span>\n                            <% } %>\n                        <% } %>\n                        <% if (menuItems[i].children && menuItems[i].children.length > 0) { %>\n                            <div title=\"Expand Node\"\n                               class=\"sos-node-listing-expand-click-region sos-icon <%= menuItems[i].expanded ? 'sos-icon-minus' : 'sos-icon-plus' %>\"\n                               data-node-tree-view-pk=\"<%= menuItems[i].treeViewPK %>\"\n                               data-node-expanded=\"<%= menuItems[i].expanded %>\"\n                               data-dojo-attach-event=\"click: _onExpandNodeClick\"></div>\n                        <% } %>\n                    </li>\n                <% } %>\n            <% } %>\n        <% } %>\n    </ul>\n    <div class=\"sos-node-listing-selected-node-text\">\n        Selected: <i data-dojo-attach-point=\"selectedNodeText\"><%= noSelectedNodeText %></i>\n        <span data-dojo-attach-point=\"scrollToNodeContainer\" class=\"hide\">(<a title=\"Scroll to the selected folder\" data-dojo-attach-event=\"click: _onScrollToNodeClick\">scroll to folder</a>)</span>\n    </div>\n</div>",
'url:style-guide/v1/doc-control/document/bulk-soft-link/template/Table.html':"<table class=\"sos-table sos-table-sticky\">\n    <thead>\n        <tr>\n            <th class=\"text-align-center width-0\">\n                <label class=\"sos-form-checkbox\"><input type=\"checkbox\"\n                                                        <%= documents.length === 0 ? 'disabled' : ''; %>\n                                                        data-dojo-attach-point=\"elementMasterCheckbox\"\n                                                        data-dojo-attach-event=\"change: _onMasterCheckboxChange\"><span></span></label>\n            </th>\n            <th class=\"width-8\"></th>\n            <th>Title</th>\n            <th>Location</th>\n            <th>Validation</th>\n            <th class=\"width-8\"></th>\n        </tr>\n    </thead>\n    <tbody>\n        <% if (documents.length == 0) { %>\n            <tr>\n                <td colspan=\"6\" class=\"p-0\">\n                    <p class=\"sos-empty-state sos-empty-state-show border-none m-0\">\n                        <span class=\"sos-icon sos-icon-file\">No documents available.</span>\n                    </p>\n                </td>\n            </tr>\n        <% } else { %>\n            <% for (let i in documents) { %>\n                <tr data-document-pk=\"<%= documents[i].documentPK; %>\">\n                    <td class=\"text-align-center\">\n                        <label class=\"sos-form-checkbox\"><input type=\"checkbox\"\n                                                                data-document-pk=\"<%= documents[i].documentPK; %>\"\n                                                                data-dojo-attach-event=\"change: _onCheckboxChange\"><span></span></label>\n                    </td>\n                    <td class=\"text-align-center\">\n                        <span class=\"sos-icon <%= documents[i].iconClass %> <%= documents[i].colourClass %>-foreground\"></span>\n                        <%= fileExtension(documents[i].realName) %>\n                    </td>\n                    <td class=\"sos-table-cell-multi-line-text title\">\n                        <input type=\"hidden\" value=\"<%= documents[i].title; %>\" />\n                        <input type=\"text\"\n                               class=\"sos-form-textfield sos-form-textfield-s width-100 m-0\"\n                               value=\"<%= documents[i].title; %>\" />\n                    </td>\n                    <td data-project-stage-pk=\"\"\n                        data-project-stage-tree-view-pk=\"\"\n                        class=\"sos-table-cell-multi-line-text location\">\n                        <span class=\"location-text\"></span>\n                        <span class=\"edit-button display-none\">\n                            [<a class=\"sos-icon sos-icon-pencil\"\n                                title=\"Edit location to place soft link for this document\"\n                                data-document-pk=\"<%= documents[i].documentPK; %>\"\n                                data-dojo-attach-event=\"click: _onSelectLocationClick\">Edit</a>]\n                        </span>\n                        <a class=\"set-button sos-icon sos-icon-folder-open\"\n                           title=\"Set location to place soft link for this document\"\n                           data-document-pk=\"<%= documents[i].documentPK; %>\"\n                           data-dojo-attach-event=\"click: _onSelectLocationClick\">Select Location</a>\n                    </td>\n                    <td class=\"sos-table-cell-multi-line-text validation\">\n                        <span class=\"sos-icon\"></span><span class=\"description\">-</span>\n                    </td>\n                    <td class=\"text-align-center\">\n                        <a class=\"sos-icon sos-icon-trash\"\n                           title=\"Remove document\"\n                           data-document-pk=\"<%= documents[i].documentPK; %>\"\n                           data-dojo-attach-event=\"click: _onRemoveClick\">Remove</a>\n                    </td>\n                </tr>\n            <% } %>\n        <% } %>\n    </tbody>\n</table>",
'url:style-guide/v1/doc-control/document/soft-link/template/Form.html':"<div class=\"soft-link-document-form\">\n    <p data-dojo-attach-point=\"loadingState\" class=\"loading-state\">\n        <span class=\"sos-icon sos-icon-animation-spin-smooth sos-icon-refresh\"></span>\n        <br />\n        Loading...\n    </p>\n\n    <div data-dojo-attach-point=\"notPermittedErrorContainer\" class=\"hide\">\n        <div class=\"sos-alert-error\">\n            You are not permitted to soft link this document.\n        </div>\n    </div>\n\n    <div class=\"hide\" data-dojo-attach-point=\"documentCardContainer\"></div>\n\n    <div class=\"hide\" data-dojo-attach-point=\"projectStageFilteringSelectContainer\">\n        <h4 class=\"mb-0\">Select Project Stage</h4>\n        <div data-dojo-attach-point=\"projectStageFilteringSelect\"></div>\n\n        <div class=\"sos-alert-warning hide error-container\" data-dojo-attach-point=\"inactiveProjectStageWarningContainer\">\n            The selected project stage is <strong>inactive</strong>.\n            <br />\n            <br />\n            You can still soft link documents here, however, unless the 'Search inactive projects'\n            filter is applied, the document will not appear in search results.\n        </div>\n    </div>\n\n    <div class=\"sos-alert-error hide error-container\" data-dojo-attach-point=\"unauthorisedProjectStageError\">\n        This project stage is <strong>restricted</strong> and you have not been granted access.\n    </div>\n\n    <div data-dojo-attach-point=\"filteringNodeSelectContainer\" class=\"hide\">\n        <h4>Select Location</h4>\n    </div>\n\n    <div data-dojo-attach-point=\"errorContainer\" class=\"hide error-container\">\n        <div class=\"sos-alert-error\">\n            <span data-dojo-attach-point=\"errorSpan\"></span>\n        </div>\n    </div>\n\n    <div data-dojo-attach-point=\"titleFieldContainer\" class=\"hide\">\n        <h4>Document Information</h4>\n        <label class=\"ml-0\">Document Title</label>\n        <br />\n        <input type=\"text\" class=\"sos-form-textfield width-100 mx-0\" data-dojo-attach-point=\"titleField\"/>\n    </div>\n\n    <div class=\"sos-form-pane-body-buttons\">\n        <button data-dojo-attach-event=\"click: _submit\" data-dojo-attach-point=\"submitButton\" disabled=\"disabled\" class=\"sos-btn sos-btn-confirm sos-btn-icon sos-icon-pencil-paper hide\">Create Soft Link</button>\n    </div>\n</div>",
'url:style-guide/v1/layout/templates/DocumentCard.html':"<div class=\"sos-layout-document-card <%= isCompact() ? 'sos-layout-document-card-compact': '' %>\">\n    <div class=\"sos-layout-document-card-meta <%= getFileTypeColourClass() %>\">\n        <p>\n            <span class=\"sos-icon <%= getFileTypeIconClass() %>\"></span>\n            <br />\n            <%= getExtension().toUpperCase() %>\n        </p>\n        <p><%= getFileSize() %></p>\n    </div>\n\n    <div class=\"sos-layout-document-card-body\">\n        <% if (isMarkedAsPrivate()) { %>\n            <div class=\"sos-icon sos-icon-private-document\"></div>\n        <% } %>\n\n        <div class=\"sos-layout-document-card-title\" title=\"<%= getTitle() %>\">\n            <%= getTitle() %>\n        </div>\n\n        <% if (getPersonUploader() || getDateUploaded() || getShowRegistrationInfo()) { %>\n            <div class=\"sos-layout-document-card-info\">\n                <% if (getShowRegistrationInfo()) { %>\n                    <% if (getProjectStage()) { %>\n                        <p>\n                            <span class=\"sos-icon sos-icon-check-square-solid\"></span>\n                            <a href=\"<%= baseUrl %>project-overview#mixed-listing/md5/<%= getMd5() %>/includeInactiveProjectStages/true\"\n                               title=\"<%= getProjectStage() %> <%= generateDocumentNodePath(getNodeName(), isRootNode()) %>\"\n                                <% if (getLocationClickCallbackName()) { %>\n                                    data-dojo-attach-event=\"click: <%= getLocationClickCallbackName() %>\">\n                                <% } %>\n                            >\n                                <%= getProjectStage() %> <%= isCompact() || isMarkedAsPrivate() ? generateDocumentNodePath(getNodeName(), isRootNode()) : '' %>\n                            </a>\n                        </p>\n                        <% if (!isCompact() && !isMarkedAsPrivate() && getNodeName()) { %>\n                            <p class=\"node-path\">\n                                <span class=\"sos-icon sos-icon-folder-open\"></span>\n                                <a href=\"<%= baseUrl %>project-overview#mixed-listing/md5/<%= getMd5() %>/includeInactiveProjectStages/true\"\n                                   title=\"<%= getProjectStage() %> <%= generateDocumentNodePath(getNodeName(), isRootNode()) %>\"\n                                    <% if (getLocationClickCallbackName()) { %>\n                                        data-dojo-attach-event=\"click: <%= getLocationClickCallbackName() %>\">\n                                    <% } %>\n                                >\n                                    <%= generateDocumentNodePath(getNodeName(), isRootNode()) %>\n                                </a>\n                            </p>\n                        <% } %>\n                    <% } else { %>\n                        <p><span class=\"sos-icon sos-icon-square\"></span><span>Not Registered</span></p>\n                    <% } %>\n                <% } %>\n\n                <% if (getPersonUploader()) { %>\n                    <p>Uploaded by: <strong title=\"<%= getPersonUploader().getDisplayName() %>\"><%= getPersonUploader().getDisplayName() %></strong></p>\n                <% } %>\n\n                <% if (getDateUploaded()) { %>\n                    <% var formattedDate = date(getDateUploaded(), { locale: 'en-gb', formatLength: 'short' }); %>\n                    <p>Uploaded on: <strong title=\"<%= formattedDate %>\"><%= formattedDate %></strong></p>\n                <% } %>\n\n                <% if (getStatusDescription()) { %>\n                    <p>Status: <strong title=\"<%= getStatusDescription(); %>\"><%= getStatusDescription(); %></strong></p>\n                <% } %>\n            </div>\n        <% } %>\n    </div>\n\n    <% if (getRegisterClickCallbackName()) { %>\n        <div class=\"sos-layout-document-card-button\"\n             data-md5=\"<%= getMd5() %>\"\n             data-dojo-attach-event=\"click: <%= getRegisterClickCallbackName() %>\">\n            <a class=\"sos-layout-document-card-button-text\"\n               data-md5=\"<%= getMd5() %>\">\n                    <span class=\"sos-icon sos-icon-folder-open\"\n                          data-md5=\"<%= getMd5() %>\"></span> Register\n            </a>\n        </div>\n    <% } %>\n\n    <% if (getUploadToDocControlClickCallbackName()) { %>\n        <div class=\"sos-layout-document-card-button\"\n             data-md5=\"<%= getMd5() %>\"\n             data-dojo-attach-event=\"click: <%= getUploadToDocControlClickCallbackName() %>\">\n            <a class=\"sos-layout-document-card-button-text\"\n               data-md5=\"<%= getMd5() %>\">\n                    <span class=\"sos-icon sos-icon-folder-open\"\n                          data-md5=\"<%= getMd5() %>\"></span> Upload To Doc Control\n            </a>\n        </div>\n    <% } %>\n\n    <% if (getViewClickCallbackName()) { %>\n        <div class=\"sos-layout-document-card-button\"\n             data-md5=\"<%= getMd5() %>\"\n             data-revision-id=\"<%= getRevisionPK() %>\"\n             data-file-type=\"<%= getFileType() %>\"\n             data-temporary-document-id=\"<%= getTemporaryDocumentPK() %>\"\n             data-dojo-attach-event=\"click: <%= getViewClickCallbackName() %>\">\n            <a class=\"sos-layout-document-card-button-text\"\n               data-md5=\"<%= getMd5() %>\"\n               data-revision-id=\"<%= getRevisionPK() %>\"\n               data-file-type=\"<%= getFileType() %>\"\n               data-temporary-document-id=\"<%= getTemporaryDocumentPK() %>\">\n                <span class=\"sos-icon sos-icon-eye\"\n                      data-md5=\"<%= getMd5() %>\"\n                      data-revision-id=\"<%= getRevisionPK() %>\"\n                      data-file-type=\"<%= getFileType() %>\"\n                      data-temporary-document-id=\"<%= getTemporaryDocumentPK() %>\"></span> View\n            </a>\n        </div>\n    <% } %>\n\n    <% if (getDownloadLink() && getDownloadClickCallbackName()) { %>\n        <% if (!getUploadToDocControlClickCallbackName()) { %>\n            <div class=\"sos-layout-document-card-button\">\n                <a href=\"<%= getDownloadLink() %>\"\n                   id=\"<%= getMd5() %>\"\n                   class=\"sos-layout-document-card-button-text\"\n                   title=\"Download <%= getTitle() %>\"\n                   data-dojo-attach-event=\"click: <%= getDownloadClickCallbackName() %>\">\n                    <span class=\"sos-icon sos-icon-download\"></span> Download\n                </a>\n            </div>\n        <% } else { %>\n            <div class=\"sos-layout-document-card-button\">\n                <a href=\"<%= getDownloadLink() %>\"\n                   id=\"<%= getMd5() %>\"\n                   class=\"sos-layout-document-card-button-text\"\n                   title=\"Download <%= getTitle() %>\"\n                   data-dojo-attach-event=\"click: <%= getDownloadClickCallbackName() %>\"\n                   download=\"<%= getDownloadName() %>\">\n                    <span class=\"sos-icon sos-icon-download\"></span> Download\n                </a>\n            </div>\n        <% } %>\n    <% } else if (getDownloadLink()) { %>\n        <% if (!getUploadToDocControlClickCallbackName()) { %>\n            <div class=\"sos-layout-document-card-button\">\n                <a href=\"<%= getDownloadLink() %>\"\n                    id=\"<%= getMd5() %>\"\n                    class=\"sos-layout-document-card-button-text\"\n                    title=\"Download <%= getTitle() %>\">\n                    <span class=\"sos-icon sos-icon-download\"></span> Download\n                </a>\n            </div>\n        <% } else { %>\n            <div class=\"sos-layout-document-card-button\">\n                <a href=\"<%= getDownloadLink() %>\"\n                   id=\"<%= getMd5() %>\"\n                   class=\"sos-layout-document-card-button-text\"\n                   title=\"Download <%= getTitle() %>\"\n                   download=\"<%= getDownloadLink() %>\">\n                    <span class=\"sos-icon sos-icon-download\"></span> Download\n                </a>\n            </div>\n        <% } %>\n    <% } %>\n\n    <% if (getSelectClickCallbackName()) { %>\n        <div class=\"sos-layout-document-card-button\"\n             data-md5=\"<%= getMd5() %>\"\n             data-revision-id=\"<%= getRevisionPK() %>\"\n             data-temporary-document-id=\"<%= getTemporaryDocumentPK() %>\"\n             data-dojo-attach-event=\"click: <%= getSelectClickCallbackName() %>\">\n            <a data-md5=\"<%= getMd5() %>\"\n               data-revision-id=\"<%= getRevisionPK() %>\"\n               data-temporary-document-id=\"<%= getTemporaryDocumentPK() %>\"\n               title=\"Select <%= getTitle() %>\">\n                <span class=\"sos-layout-document-card-button-text\"\n                      data-md5=\"<%= getMd5() %>\"\n                      data-revision-id=\"<%= getRevisionPK() %>\"\n                      data-temporary-document-id=\"<%= getTemporaryDocumentPK() %>\">\n                   <span class=\"sos-icon sos-icon-plus\"\n                         data-md5=\"<%= getMd5() %>\"\n                         data-revision-id=\"<%= getRevisionPK() %>\"\n                         data-temporary-document-id=\"<%= getTemporaryDocumentPK() %>\"></span>\n                   Select\n                </span>\n            </a>\n        </div>\n    <% } %>\n\n    <% if (getRemoveClickCallbackName()) { %>\n        <div class=\"sos-layout-document-card-button\"\n             data-md5=\"<%= getMd5() %>\"\n             data-revision-id=\"<%= getRevisionPK() %>\"\n             data-temporary-document-id=\"<%= getTemporaryDocumentPK() %>\"\n             data-dojo-attach-event=\"click: <%= getRemoveClickCallbackName() %>\">\n            <a data-md5=\"<%= getMd5() %>\"\n               data-revision-id=\"<%= getRevisionPK() %>\"\n               data-temporary-document-id=\"<%= getTemporaryDocumentPK() %>\"\n               title=\"Remove <%= getTitle() %>\">\n                <span class=\"sos-layout-document-card-button-text\"\n                      data-md5=\"<%= getMd5() %>\"\n                      data-revision-id=\"<%= getRevisionPK() %>\"\n                      data-temporary-document-id=\"<%= getTemporaryDocumentPK() %>\">\n                    <span class=\"sos-icon sos-icon-close\"\n                          data-md5=\"<%= getMd5() %>\"\n                          data-revision-id=\"<%= getRevisionPK() %>\"\n                          data-temporary-document-id=\"<%= getTemporaryDocumentPK() %>\"></span>\n                    Remove\n                </span>\n            </a>\n        </div>\n    <% } %>\n</div>",
'url:style-guide/v1/doc-control/document/soft-link/template/DocumentCard.html':"<div>\n    <%- render(card.getTemplate(), card); %>\n</div>",
'url:style-guide/v1/file-tray/template/ContextButtonContainer.html':"<div class=\"sos-drop-down-button\">\n    <% if (buttons.length > 0) { %>\n        <button class=\"sos-btn sos-btn-secondary sos-btn-s sos-btn-icon sos-icon-share\"\n                data-dojo-attach-point=\"buttonActionSelectedDocuments\">Actions for <strong><%= contextName %></strong></button>\n        <div class=\"sos-drop-down-button-content\">\n            <% for(var i = 0; i < buttons.length; i++) { %>\n                <button class=\"sos-btn sos-btn-s sos-btn-secondary <%= buttons[i].getIconClass() ? 'sos-btn-icon' : ''; %> <%= buttons[i].getIconClass(); %>\"\n                        data-dojo-attach-event=\"click: _onButtonClick\"\n                        data-index=\"<%= i %>\"\n                        <%= buttons[i].doesRequireSelectedFiles() && selectedItemCount === 0 ? 'disabled' : '' %>\n                        title=\"<%= buttons[i].getTitle(); %>\"><%= buttons[i].getLabel(); %></button>\n            <% } %>\n        </div>\n    <% } %>\n</div>",
'url:style-guide/v1/file-tray/template/ItemCollection.html':"<div>\n    <% if (items.length) { %>\n        <% if (displayMode === 'table') { %>\n            <div data-dojo-attach-point=\"elementItemContainer\">\n                <% if (hasRegisteredItems) { %>\n                    <h5 class=\"no-margin-top\">Registered</h5>\n                    <table>\n                        <tr>\n                            <th class=\"checkbox\"></th>\n                            <th class=\"icon\"></th>\n                            <th class=\"name\">Name</th>\n                            <th>Size</th>\n                            <th>Revision Number</th>\n                            <th>Reference</th>\n                            <th></th>\n                            <th></th>\n                            <th></th>\n                            <th></th>\n                        </tr>\n                        <tbody>\n                            <% for(var i = 0; i < items.length; i++) { %>\n                                <% if (items[i].isRegistered) { %>\n                                    <%- render(items[i].templateTableRow, items[i].data) %>\n                                <% } %>\n                            <% } %>\n                        </tbody>\n                    </table>\n                <% } %>\n                <% if (hasUnregisteredItems) { %>\n                    <h5>Not Registered</h5>\n                    <table>\n                        <tr>\n                            <th class=\"checkbox\"></th>\n                            <th class=\"icon\"></th>\n                            <th class=\"name\">Name</th>\n                            <th>Size</th>\n                            <th></th>\n                            <th></th>\n                            <th></th>\n                        </tr>\n                        <tbody>\n                            <% for(var i = 0; i < items.length; i++) { %>\n                                <% if (!items[i].isRegistered) { %>\n                                    <%- render(items[i].templateTableRow, items[i].data) %>\n                                <% } %>\n                            <% } %>\n                        </tbody>\n                    </table>\n                <% } %>\n            </div>\n        <% } else { %>\n            <div data-dojo-attach-point=\"elementItemContainer\">\n                <% for(var i = 0; i < items.length; i++) { %>\n                    <%- render(items[i].templateCard, items[i].data) %>\n                <% } %>\n            </div>\n        <% } %>\n    <% } %>\n    <% if (itemTotal) { %>\n        <p class=\"sos-file-tray-bar-item-count-summary\">\n            <% if (items.length === itemTotal) { %>\n                Showing all files\n            <% } else { %>\n                Showing <%= items.length %> of <%= itemTotal %> file<%= itemTotal > 1 ? 's' : '' %>\n            <% } %>\n        </p>\n    <% } %>\n\n    <div data-dojo-attach-point=\"elementDragAndDropCursor\"></div>\n</div>",
'url:style-guide/v1/file-tray/template/card/Revision.html':"<div class=\"sos-file-tray-bar-body-item <%= selected ? 'sos-file-tray-bar-body-item-selected' : '' %>\"\n     draggable=\"true\"\n     data-dojo-attach-event=\"dragstart: _onDragStart\"\n     data-icon-class=\"<%= iconClass %>\"\n     data-id=\"<%= id %>\"\n     data-file-name=\"<%= (title || fileName) ? (title || fileName) : '[No File Name]' %>\">\n    <div class=\"sos-layout-document-card sos-layout-document-card-compact\" title=\"<%= (title || fileName) ? (title || fileName) : '[No File Name]' %>\">\n        <div class=\"sos-layout-document-card-meta <%= colourClass %>\">\n            <p>\n                <span class=\"sos-icon <%= iconClass %>\"></span>\n                <br />\n                <%= fileExtension %>\n            </p>\n            <p><%= fileSize %></p>\n        </div>\n\n        <div class=\"sos-layout-document-card-body\">\n            <% if (isPrivate) { %>\n                <div class=\"sos-icon sos-icon-private-document\"></div>\n            <% } %>\n            <p class=\"sos-layout-document-card-title\">\n                <%= (title || fileName) ? (title || fileName) : '[No File Name]' %>\n            </p>\n            <div class=\"sos-layout-document-card-info\">\n                <p>Revision Number: <strong><%= revisionNumber ? revisionNumber : 'n/a' %></strong></p>\n                <p>Reference: <strong><%= reference ? reference : '-' %></strong></p>\n            </div>\n        </div>\n\n        <div class=\"sos-layout-document-card-button\">\n            <a class=\"sos-layout-document-card-button-text\"\n               draggable=\"false\"\n               data-dojo-attach-event=\"click: _onViewClick\"\n               data-id=\"<%= id %>\"\n               title=\"View <%= (title || fileName) ? (title || fileName) : '[Unknown File]' %>\">\n                <span class=\"sos-icon sos-icon-eye\"></span> View\n            </a>\n        </div>\n\n        <% if (!isDeleted) { %>\n            <div class=\"sos-layout-document-card-button\">\n                <a class=\"sos-layout-document-card-button-text\"\n                   draggable=\"false\"\n                   href=\"<%= downloadUrl %>\"\n                   title=\"Download <%= (title || fileName) ? (title || fileName) : '[Unknown File]' %>\">\n                    <span class=\"sos-icon sos-icon-download\"></span> Download\n                </a>\n            </div>\n        <% } %>\n    </div>\n    <table class=\"sos-file-tray-bar-body-item-controls\">\n        <tr>\n            <td class=\"left\">\n                <label class=\"sos-form-checkbox no-margin\"><input data-id=\"<%= id %>\" data-dojo-attach-event=\"change: _onCheckboxChange\" type=\"checkbox\" <%= selected ? 'checked' : '' %> /><span></span></label>\n            </td>\n            <td class=\"right\">\n                <a class=\"sos-anchor-view\"\n                   draggable=\"false\"\n                   data-dojo-attach-event=\"click: _onViewDetailsClick\"\n                   data-id=\"<%= id %>\"\n                   title=\"View details for <%= (title || fileName) ? (title || fileName) : '[Unknown File]' %>\">Details</a>\n                <a class=\"sos-anchor-delete\"\n                   data-id=\"<%= id %>\"\n                   data-dojo-attach-event=\"click: _onRemoveClick\"\n                   draggable=\"false\">Remove</a>\n            </td>\n        </tr>\n    </table>\n</div>",
'url:style-guide/v1/file-tray/template/card/TemporaryDocument.html':"<div class=\"sos-file-tray-bar-body-item <%= selected ? 'sos-file-tray-bar-body-item-selected' : '' %>\"\n     draggable=\"true\"\n     data-dojo-attach-event=\"dragstart: _onDragStart\"\n     data-icon-class=\"<%= iconClass %>\"\n     data-id=\"<%= id %>\"\n     data-file-name=\"<%= fileName ? fileName : '[No File Name]' %>\">\n    <div class=\"sos-layout-document-card sos-layout-document-card-compact\" title=\"<%= fileName ? fileName : '[No File Name]' %>\">\n        <div class=\"sos-layout-document-card-meta <%= colourClass %>\">\n            <p>\n                <span class=\"sos-icon <%= iconClass %>\"></span>\n                <br />\n                <%= fileExtension %>\n            </p>\n            <p><%= fileSize %></p>\n        </div>\n\n        <div class=\"sos-layout-document-card-body\">\n            <p class=\"sos-layout-document-card-title\">\n                <%= fileName ? fileName : '[No File Name]' %>\n            </p>\n            <div class=\"sos-layout-document-card-info\">\n                <p>Not Registered</p>\n            </div>\n        </div>\n\n        <div class=\"sos-layout-document-card-button\">\n            <a class=\"sos-layout-document-card-button-text\"\n               draggable=\"false\"\n               data-dojo-attach-event=\"click: _onViewClick\"\n               data-id=\"<%= id %>\"\n               title=\"View <%= fileName ? fileName : '[Unknown File]' %>\">\n                <span class=\"sos-icon sos-icon-eye\"></span> View\n            </a>\n        </div>\n\n        <div class=\"sos-layout-document-card-button\">\n            <a class=\"sos-layout-document-card-button-text\"\n               draggable=\"false\"\n               href=\"<%= downloadUrl %>\"\n               title=\"Download <%= fileName ? fileName : '[Unknown File]' %>\">\n                <span class=\"sos-icon sos-icon-download\"></span> Download\n            </a>\n        </div>\n    </div>\n    <table class=\"sos-file-tray-bar-body-item-controls\">\n        <tr>\n            <td class=\"left\">\n                <label class=\"sos-form-checkbox no-margin\"><input data-id=\"<%= id %>\" data-dojo-attach-event=\"change: _onCheckboxChange\" type=\"checkbox\" <%= selected ? 'checked' : '' %> /><span></span></label>\n            </td>\n            <td class=\"right\">\n                <a class=\"sos-anchor-delete\"\n                   data-id=\"<%= id %>\"\n                   data-dojo-attach-event=\"click: _onRemoveClick\"\n                   draggable=\"false\">Remove</a>\n            </td>\n        </tr>\n    </table>\n</div>",
'url:style-guide/v1/file-tray/template/table-row/Revision.html':"<tr class=\"<%= selected ? 'sos-file-tray-bar-body-item-selected' : '' %>\"\n    draggable=\"true\"\n    data-dojo-attach-event=\"dragstart: _onDragStart\"\n    data-icon-class=\"<%= iconClass %>\"\n    data-id=\"<%= id %>\"\n    data-file-name=\"<%= (title || fileName) ? (title || fileName) : '[No File Name]' %>\">\n    <td><label class=\"sos-form-checkbox no-margin\"><input data-id=\"<%= id %>\" data-dojo-attach-event=\"change: _onCheckboxChange\" type=\"checkbox\" <%= selected ? 'checked' : '' %> /><span></span></label></td>\n    <td class=\"icon <%= isDefaultColourClass ? '' : colourClass + '-foreground' %>\"><span class=\"sos-icon <%= iconClass %>\"></span></td>\n    <td>\n        <%= (title || fileName) ? (title || fileName) : '[No File Name]' %>\n        <% if (isPrivate) { %>\n            <span class=\"pill pill-warning\"><span class=\"sos-icon sos-icon-lock\"></span>Private</span>\n        <% } %>\n    </td>\n    <td><%= fileSize %></td>\n    <td><%= revisionNumber ? revisionNumber : 'n/a' %></td>\n    <td><%= reference ? reference : '-' %></td>\n    <td class=\"text-align-center\">\n        <% if (!isDeleted) { %>\n            <a class=\"sos-anchor-download\"\n               draggable=\"false\"\n               href=\"<%= downloadUrl %>\"\n               title=\"Download <%= (title || fileName) ? (title || fileName) : '[Unknown File]' %>\">Download</a>\n        <% } %>\n    </td>\n    <td class=\"text-align-center\">\n        <a class=\"sos-anchor-view\"\n           draggable=\"false\"\n           data-dojo-attach-event=\"click: _onViewClick\"\n           data-id=\"<%= id %>\"\n           title=\"View <%= (title || fileName) ? (title || fileName) : '[Unknown File]' %>\">View</a>\n    </td>\n    <td class=\"text-align-center\">\n        <a class=\"sos-anchor-view\"\n           draggable=\"false\"\n           data-dojo-attach-event=\"click: _onViewDetailsClick\"\n           data-id=\"<%= id %>\"\n           title=\"View details for <%= (title || fileName) ? (title || fileName) : '[Unknown File]' %>\">Details</a>\n    </td>\n    <td class=\"text-align-center\">\n        <a class=\"sos-anchor-delete\"\n           data-id=\"<%= id %>\"\n           data-dojo-attach-event=\"click: _onRemoveClick\"\n           draggable=\"false\">Remove</a>\n    </td>\n</tr>",
'url:style-guide/v1/file-tray/template/table-row/TemporaryDocument.html':"<tr class=\"<%= selected ? 'sos-file-tray-bar-body-item-selected' : '' %>\"\n    draggable=\"true\"\n    data-dojo-attach-event=\"dragstart: _onDragStart\"\n    data-icon-class=\"<%= iconClass %>\"\n    data-id=\"<%= id %>\"\n    data-file-name=\"<%= fileName ? fileName : '[No File Name]' %>\">\n    <td><label class=\"sos-form-checkbox no-margin\"><input data-id=\"<%= id %>\" data-dojo-attach-event=\"change: _onCheckboxChange\" type=\"checkbox\" <%= selected ? 'checked' : '' %> /><span></span></label></td>\n    <td class=\"icon <%= isDefaultColourClass ? '' : colourClass + '-foreground' %>\"><span class=\"sos-icon <%= iconClass %>\"></span></td>\n    <td>\n        <%= fileName ? fileName : '[No File Name]' %>\n    </td>\n    <td><%= fileSize %></td>\n    <td class=\"text-align-center\">\n        <a class=\"sos-anchor-download\"\n           draggable=\"false\"\n           href=\"<%= downloadUrl %>\"\n           title=\"Download <%= fileName ? fileName : '[Unknown File]' %>\">Download</a>\n    </td>\n    <td class=\"text-align-center\">\n        <a class=\"sos-anchor-view\"\n           draggable=\"false\"\n           data-dojo-attach-event=\"click: _onViewClick\"\n           data-id=\"<%= id %>\"\n           title=\"View <%= fileName ? fileName : '[Unknown File]' %>\">View</a>\n    </td>\n    <td class=\"text-align-center\">\n        <a class=\"sos-anchor-delete\"\n           data-id=\"<%= id %>\"\n           data-dojo-attach-event=\"click: _onRemoveClick\"\n           draggable=\"false\">Remove</a>\n    </td>\n</tr>",
'url:style-guide/v1/file-tray/template/SavedBasket.html':"<div class=\"sos-file-tray-body-container sos-file-tray-saved-basket hidden\">\n    <% if (error) { %>\n        <p class=\"loading-state\">\n            <span class=\"sos-icon sos-icon-error\"></span>\n            <br />\n            Sorry, the basket failed to load.\n            <br />\n            Please try again, if the problem persists contact support.\n        </p>\n    <% } else { %>\n        <div class=\"sos-file-tray-bar-body-header\">\n            <div class=\"heading-container\">\n                <div>\n                    <div class=\"heading\">\n                        <span class=\"sos-icon sos-icon-folder mr-6\"></span>Saved Basket\n                    </div>\n                </div>\n                <div class=\"text-align-right\">\n                    <% if (basket) { %>\n                        <div class=\"display-inline-block mr-6\">\n                            <% const collaborators = basket.getCollaborators(); %>\n                            <% if (isOwner) { %>\n                                <% if (collaborators.length) { %>\n                                    <%= collaborators.length %> collaborator<%= collaborators.length === 1 ? '' : 's' %>\n                                        [ <a class=\"sos-icon sos-icon-pencil\"\n                                             data-dojo-attach-event=\"click: _onCollaborateClick\"\n                                             title=\"Add and remove collaborators\">Edit</a> ]\n                                <% } else { %>\n                                    <button class=\"sos-btn sos-btn-s sos-btn-secondary sos-btn-icon sos-icon-users\"\n                                            data-dojo-attach-event=\"click: _onCollaborateClick\"\n                                            title=\"Add collaborators\"\n                                    <%= loading ? 'disabled' : '' %>>Collaborate</button>\n                                <% } %>\n                            <% } else { %>\n                                <strong>Owner:</strong> <%= basket.getOwner().getDisplayName() %>\n                                <% if (collaborators.length > 1) { %>\n                                    [ <a class=\"sos-icon sos-icon-users\"\n                                         data-dojo-attach-event=\"click: _onCollaborateClick\"\n                                         title=\"View collaborators\">View Collaborators</a> ]\n                                <% } %>\n                            <% } %>\n                        </div>\n                    <% } %>\n                    <button class=\"sos-btn sos-btn-s sos-btn-secondary sos-btn-icon sos-icon-download\"\n                            data-dojo-attach-event=\"click: _onDownloadCSVClick\"\n                            <%= loading ? 'disabled' : '' %>><span class=\"hide-low-width\">Download </span>CSV</button>\n                    <button class=\"sos-btn sos-btn-s sos-btn-secondary sos-btn-icon sos-icon-fork\"\n                            data-dojo-attach-event=\"click: _onSplitBasketClick\"\n                            <%= loading ? 'disabled' : '' %>>Split<span class=\"hide-low-width\"> Basket</span></button>\n                    <% if (isOwner) { %>\n                        <button class=\"sos-btn sos-btn-s sos-btn-primary sos-btn-icon sos-icon-pencil\"\n                                data-dojo-attach-event=\"click: _onRenameClick\"\n                                <%= loading ? 'disabled' : '' %>>Rename</button>\n                    <% } %>\n                    <button class=\"sos-btn sos-btn-s sos-btn-negative sos-btn-icon sos-icon-<%= isOwner ? 'trash' : 'close' %>\"\n                            data-dojo-attach-event=\"click: _onDeleteClick\"\n                            data-dojo-attach-point=\"deleteButton\"\n                            title=\"<%= isOwner ? 'Delete this basket' : 'Remove yourself from the collaborators' %>\"\n                            <%= loading ? 'disabled' : '' %>><%= isOwner ? 'Delete' : 'Remove' %></button>\n                </div>\n            </div>\n            <button class=\"sos-btn sos-btn-s sos-btn-primary sos-btn-icon sos-icon-plus\"\n                    data-dojo-attach-point=\"buttonAddAllToBasket\"\n                    data-dojo-attach-event=\"click: _addAllToCurrentBasketClick\"\n                    <%= loading ? 'disabled' : '' %>>Add to Current Basket</button>\n            <button class=\"sos-btn sos-btn-s sos-btn-primary sos-btn-icon sos-icon-plus\" disabled\n                    data-dojo-attach-point=\"buttonAddToBasket\"\n                    data-dojo-attach-event=\"click: _addToCurrentBasketClick\">Add Selected to Current Basket</button>\n            <button class=\"sos-btn sos-btn-s sos-btn-primary sos-btn-icon sos-icon-envelope\" disabled\n                    data-dojo-attach-point=\"buttonAttachToEmail\"\n                    data-dojo-attach-event=\"click: _attachToEmailClick\">Email Selected</button>\n            <button class=\"sos-btn sos-btn-s sos-btn-negative sos-btn-icon sos-icon-trash\" disabled\n                    data-dojo-attach-point=\"buttonRemoveSelected\"\n                    data-dojo-attach-event=\"click: _onRemoveSelectedClick\">Remove Selected</button>\n        </div>\n        <% if (loading) { %>\n            <p class=\"loading-state\">\n                <span class=\"sos-icon sos-icon-animation-spin-smooth sos-icon-refresh\"></span>\n                <br />\n                Loading Basket...\n            </p>\n        <% } else { %>\n            <div class=\"saved-basket-content\">\n                <div class=\"sos-file-tray-bar-body-items\">\n                    <div class=\"heading mb-12\">\n                        <span data-dojo-attach-point=\"basketName\"><%= basket ? basket.getName() : '' %></span>\n                    </div>\n                    <div class=\"row collapse sos-file-tray-bar-body-items-controls\">\n                        <div class=\"twelve columns\">\n                            <span>Select <a data-dojo-attach-event=\"click: _onSelectAllClick\" title=\"Select all documents\">All</a> | <a data-dojo-attach-event=\"click: _onSelectNoneClick\" title=\"Deselect all documents\">None</a></span>\n                            <span class=\"sos-file-tray-bar-view-switch\">\n                                <a class=\"sos-anchor-th hide\"\n                                   title=\"Switch to the card view\"\n                                   data-dojo-attach-event=\"click: _onCardViewClick\"\n                                   data-dojo-attach-point=\"buttonCardView\"><span class=\"hide-low-width\">Switch to </span>Card View</a>\n                                <a class=\"sos-anchor-list\"\n                                   title=\"Switch to the table view\"\n                                   data-dojo-attach-event=\"click: _onTableViewClick\"\n                                   data-dojo-attach-point=\"buttonTableView\"><span class=\"hide-low-width\">Switch to </span>Table View</a>\n                            </span>\n                        </div>\n                    </div>\n                    <div data-dojo-attach-point=\"itemCollection\"></div>\n                </div>\n            </div>\n        <% } %>\n    <% } %>\n</div>",
'url:style-guide/v1/file-tray/template/SplitBasket.html':"<div class=\"sos-file-tray-body-container sos-file-tray-split-basket display-none\">\n    <div class=\"sos-file-tray-bar-body-header\">\n        <div class=\"heading-container\">\n            <div>\n                <div class=\"heading\"><span class=\"sos-icon sos-icon-fork mr-6\"></span>Split Basket: <span data-dojo-attach-point=\"elementBasketName\"></span></div>\n            </div>\n            <div>\n                <span data-dojo-attach-point=\"elementSummary\"></span>\n                <button class=\"sos-btn sos-btn-s sos-btn-secondary sos-btn-icon sos-icon-users\"\n                        disabled\n                        data-dojo-attach-point=\"elementCollaboratorsButton\"\n                        data-dojo-attach-event=\"click: _onCollaboratorsClick\"\n                        title=\"Share the created basket(s) with other people\">Collaborators</button>\n                <button class=\"sos-btn sos-btn-s sos-btn-confirm sos-btn-icon sos-icon-fork\"\n                        disabled\n                        data-dojo-attach-point=\"elementSplitBasketButton\"\n                        data-dojo-attach-event=\"click: _onSplitBasketClick\">Split Basket</button>\n                <button class=\"sos-btn sos-btn-s sos-btn-negative sos-btn-icon sos-icon-trash m-0 ml-6\"\n                        data-dojo-attach-event=\"click: _onDeleteAllBasketsClick\"\n                        data-dojo-attach-point=\"elementDeleteAllBasketsButton\"\n                        disabled>Delete<span class=\"hide-medium-width\"> All</span> Baskets</button>\n            </div>\n        </div>\n        <div class=\"display-grid grid-cols-min-content-1fr\">\n            <div>\n                <div class=\"display-inline-block\">\n                    <div class=\"sos-form-textfield-with-prefix-flex\">\n                        <label class=\"sos-form-textfield-prefix sos-form-textfield-prefix-s min-width-0\">Filter<span class=\"hide-medium-width\"> documents</span></label><input\n                            class=\"sos-form-textfield sos-form-textfield-s sos-form-textfield-prefixed\"\n                            data-dojo-attach-point=\"elementFilterText\"\n                            data-dojo-attach-event=\"input: _onFilterInput\"\n                            type=\"search\"\n                            value=\"\" />\n                    </div>\n                </div>\n            </div>\n            <div class=\"display-flex justify-content-right\">\n                <div class=\"sos-form-textfield-with-prefix-flex mr-12\">\n                    <label class=\"sos-form-textfield-prefix sos-form-textfield-prefix-s\"><span class=\"hide-medium-width\">Basket </span>Prefix</label><input\n                        class=\"sos-form-textfield sos-form-textfield-s sos-form-textfield-prefixed\"\n                        data-dojo-attach-point=\"elementBasketPrefixText\"\n                        data-dojo-attach-event=\"keyup: _onBasketPrefixKeyUp\"\n                        type=\"text\"\n                        value=\"\" />\n                </div>\n                <input class=\"sos-form-textfield sos-form-textfield-s sos-form-textfield-prefixed width-25 m-0\"\n                       data-dojo-attach-event=\"keyup: _onBasketNameKeyUp\"\n                       data-dojo-attach-point=\"elementBasketNameText\"\n                       placeholder=\"Basket name...\"\n                       type=\"text\"\n                       value=\"\" />\n                <button class=\"sos-btn sos-btn-s sos-btn-secondary sos-btn-icon sos-icon-plus my-0 ml-2\"\n                        data-dojo-attach-event=\"click: _onAddBasketClick\"\n                        data-dojo-attach-point=\"elementAddBasketButton\"\n                        disabled>Add<span class=\"hide-medium-width\"> Basket</span></button>\n                <button class=\"sos-btn sos-btn-s sos-btn-secondary sos-btn-icon sos-icon-plus m-0 ml-12\"\n                        data-dojo-attach-event=\"click: _onAddMultipleBasketsClick\"\n                        data-dojo-attach-point=\"elementAddMultipleBasketsButton\"\n                        disabled>Add Multiple<span class=\"hide-medium-width\"> Baskets</span></button>\n            </div>\n        </div>\n    </div>\n    <div class=\"sos-file-tray-split-basket-content overflow-x-auto overflow-y-auto\"\n         data-dojo-attach-point=\"elementTableContainer\">\n        <div class=\"sos-file-tray-bar-body-items p-0\">\n            <div>\n                <table data-dojo-attach-point=\"elementTable\"></table>\n            </div>\n        </div>\n    </div>\n    <div class=\"sos-file-tray-split-basket-message display-none\" data-dojo-attach-point=\"elementProcessingMessageContainer\">\n        <span class=\"sos-icon sos-icon-animation-spin-smooth sos-icon-refresh\"></span>\n        <div class=\"mt-12\">Creating baskets...</div>\n    </div>\n    <div class=\"sos-file-tray-split-basket-message display-none\" data-dojo-attach-point=\"elementSuccessMessageContainer\">\n        <span class=\"sos-icon sos-icon-check\"></span>\n        <div class=\"mt-12\">Baskets created, <a data-dojo-attach-event=\"click: _onReturnClick\">return to your current basket</a>.</div>\n    </div>\n</div>",
'url:style-guide/v1/file-tray/dialog/template/CollaboratorsDialog.html':"<div>\n    <div class=\"sos-layout-dialog-content\">\n        <div data-dojo-attach-point=\"formNode\"></div>\n    </div>\n    <div class=\"sos-layout-dialog-footer display-grid grid-cols-2\">\n        <div>\n            <button class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-close\"\n                    data-dojo-attach-point=\"closeButton\"\n                    data-dojo-attach-event=\"click: _onCloseClick\">Cancel</button>\n        </div>\n        <div class=\"text-align-right\">\n            <button class=\"sos-btn sos-btn-confirm sos-btn-icon sos-icon-save\"\n                    disabled\n                    data-dojo-attach-point=\"saveButton\"\n                    data-dojo-attach-event=\"click: _onSaveClick\">Save Collaborators</button>\n        </div>\n    </div>\n</div>",
'url:style-guide/v1/file-tray/dialog/template/CollaboratorsForm.html':"<div>\n    <div data-dojo-attach-point=\"helpTextNode\" class=\"sos-help-text sos-help-text-arrow-bottom mx-0 mt-0\">\n        <p>\n            Select people to share this basket with.\n            <br />\n            <br />\n            The people selected will be given the rights to <strong>view</strong> and\n            <strong>add</strong>/<strong>remove documents</strong> from the basket.\n        </p>\n    </div>\n    <div data-dojo-attach-point=\"personSelectNode\"></div>\n    <div class=\"min-height-160px\">\n        <div data-dojo-attach-point=\"collaboratorsTableNode\"></div>\n    </div>\n</div>",
'url:style-guide/v1/file-tray/dialog/template/CollaboratorsTable.html':"<table class=\"sos-table\">\n    <tr>\n        <th>Name</th>\n        <% if (!readOnly) { %>\n            <th class=\"width-15\"></th>\n        <% } %>\n    </tr>\n    <% if (collaborators.length) { %>\n        <% for (let i = 0; i < collaborators.length; i++) { %>\n            <tr>\n                <td><%= collaborators[i].displayName %></td>\n                <% if (!readOnly) { %>\n                    <td class=\"text-align-center\">\n                        <a class=\"sos-icon sos-icon-trash\"\n                           data-person-pk=\"<%= collaborators[i].personPK %>\"\n                           data-dojo-attach-event=\"click: _onRemoveClick\"\n                           title=\"Remove collaborator\">Remove</a>\n                    </td>\n                <% } %>\n            </tr>\n        <% } %>\n    <% } else { %>\n        <tr>\n            <td colspan=\"<%= readOnly ? 1 : 2 %>\" class=\"p-0\">\n                <p class=\"sos-empty-state sos-empty-state-show border-none m-0\">\n                    <span class=\"sos-icon sos-icon-user\">No collaborators assigned.</span>\n                </p>\n            </td>\n        </tr>\n    <% } %>\n</table>",
'url:style-guide/v1/file-tray/template/SplitBasketTable.html':"<table class=\"<%= baskets.length ? 'enabled' : '' %>\">\n    <thead class=\"position-sticky top-0 left-0 z-index-1\">\n        <tr>\n            <th rowspan=\"4\" class=\"sos-file-tray-split-basket-horizontal-separator-row\"></th>\n            <% if (baskets.length) { %>\n                <% for (let i in baskets) { %>\n                    <th class=\"text-align-center\">\n                        <span><%= basketPrefix %></span><span data-basket-id=\"<%= i %>\"><%= baskets[i].name %></span>\n                    </th>\n                <% } %>\n            <% } else { %>\n                <td></td>\n            <% } %>\n        </tr>\n        <tr>\n            <% if (baskets.length) { %>\n                <% for (let i in baskets) { %>\n                    <th class=\"text-align-center white-space-no-wrap\">\n                        <a class=\"sos-icon sos-icon-pencil\"\n                           data-id=\"<%= i %>\"\n                           data-dojo-attach-event=\"click: _onRenameClick\"\n                           title=\"Rename this basket\">Rename</a> |\n                        <a class=\"sos-icon sos-icon-trash\"\n                           data-id=\"<%= i %>\"\n                           data-dojo-attach-event=\"click: _onRemoveClick\"\n                           title=\"Remove this basket\">Remove</a>\n                    </th>\n                <% } %>\n            <% } else { %>\n                <td></td>\n            <% } %>\n        </tr>\n        <tr>\n            <% if (baskets.length) { %>\n                <% for (let i in baskets) { %>\n                    <th class=\"text-align-center white-space-no-wrap\">\n                        <a title=\"Select all documents for this basket\"\n                           data-id=\"<%= i %>\"\n                           data-dojo-attach-event=\"click: _onBasketSelectAllClick\">All</a> |\n                        <a title=\"Deselect all documents for this basket\"\n                           data-id=\"<%= i %>\"\n                           data-dojo-attach-event=\"click: _onBasketSelectNoneClick\">None</a>\n                    </th>\n                <% } %>\n            <% } else { %>\n                <td></td>\n            <% } %>\n        </tr>\n        <tr>\n            <% if (baskets.length) { %>\n                <% for (let i in baskets) { %>\n                    <th class=\"text-align-center sos-file-tray-split-basket-horizontal-separator-row\">\n                        <% if (!baskets[i].revisions.length) { %>\n                            <span class=\"sos-icon sos-icon-close sos-colours-error-foreground\"></span>\n                        <% } else { %>\n                            <span class=\"sos-icon sos-icon-check sos-colours-success-foreground\"></span>\n                        <% } %>\n                        <%= baskets[i].revisions.length %> document<%= baskets[i].revisions.length === 1 ? '' : 's' %>\n                    </th>\n                <% } %>\n            <% } else { %>\n                <td class=\"sos-file-tray-split-basket-horizontal-separator-row\"></td>\n            <% } %>\n        </tr>\n    </thead>\n    <tbody>\n        <% for (let i in revisions) { %>\n            <tr class=\"<%= shownRevisionPKs.indexOf(revisions[i].getRevisionPK()) >= 0 ? '' : 'display-none' %>\">\n                <th class=\"white-space-no-wrap position-sticky top-0 left-0 z-index-0 sos-file-tray-split-basket-vertical-separator-row\">\n                    <span class=\"sos-icon <%= fileTypeToIconClass(revisions[i].getFileType()) %> <%= fileTypeToColourClass(revisions[i].getFileType()) %>\"></span>\n                    <%= revisions[i].getTitle(); %>\n                    <% if (baskets.length) { %>\n                        <span class=\"ml-6\">[ <a title=\"Select all baskets for this document\"\n                           data-md5=\"<%= revisions[i].getMd5(); %>\"\n                           data-dojo-attach-event=\"click: _onRevisionSelectAllClick\">All</a> |\n                        <a title=\"Deselect all baskets for this document\"\n                           data-md5=\"<%= revisions[i].getMd5(); %>\"\n                           data-dojo-attach-event=\"click: _onRevisionSelectNoneClick\">None</a> ]</span>\n                    <% } %>\n                </th>\n                <% for (let j in baskets) { %>\n                    <td class=\"text-align-center\">\n                        <label class=\"sos-form-checkbox\"><input type=\"checkbox\"\n                                                                <%= baskets[j].revisions.some((r) => (revisions[i].getMd5() === r.getMd5())) ? 'checked' : '' %>\n                                                                data-id=\"<%= j %>\"\n                                                                data-md5=\"<%= revisions[i].getMd5(); %>\"\n                                                                data-dojo-attach-event=\"change: _onCheckboxChange\" /><span></span></label>\n                    </td>\n                <% } %>\n                <% if (!baskets.length && parseInt(i) === 0) { %>\n                    <td rowspan=\"<%= revisions.length %>\" class=\"px-0 py-12\">\n                        <p class=\"sos-empty-state sos-empty-state-show border-none m-0 sos-colours-grey-foreground\">\n                            <span class=\"sos-icon sos-icon-shopping-basket\">\n                                No baskets added, enter a name for a basket above\n                                and press the <strong>[return]</strong> key.\n                            </span>\n                        </p>\n                    </td>\n                <% } %>\n            </tr>\n        <% } %>\n    </tbody>\n</table>",
'url:style-guide/v1/file-tray/template/SplitBasketRename.html':"<div>\n    <div class=\"sos-layout-dialog-content min-height-0\">\n        <label class=\"sos-label-required mx-0\">Name</label>\n        <br />\n        <input type=\"text\" class=\"sos-form-textfield sos-form-textfield-s m-0 mt-6 width-100\"\n               data-dojo-attach-event=\"input: _onBasketNameInput, keyup: _onBasketNameKeyUp\"\n               data-dojo-attach-point=\"elementBasketName\" />\n    </div>\n    <div class=\"sos-layout-dialog-footer\">\n        <div class=\"display-grid grid-cols-2\">\n            <div>\n                <button class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-close\"\n                        data-dojo-attach-event=\"click: _onCancelClick\">Cancel</button>\n            </div>\n            <div class=\"text-align-right\">\n                <button class=\"sos-btn sos-btn-confirm sos-btn-icon sos-icon-pencil-paper\"\n                        disabled\n                        data-dojo-attach-point=\"elementRenameButton\"\n                        data-dojo-attach-event=\"click: _onRenameClick\">Rename</button>\n            </div>\n        </div>\n    </div>\n</div>\n",
'url:style-guide/v1/file-tray/template/SplitBasketAddMultipleBaskets.html':"<div>\n    <div class=\"sos-layout-dialog-content min-height-0\">\n        <textarea class=\"sos-form-textarea m-0 mb-6 width-100\"\n               data-dojo-attach-event=\"input: _onBasketNamesInput\"\n               data-dojo-attach-point=\"elementBasketNames\"></textarea>\n        <span class=\"color-grey text-sm sos-icon sos-icon-information\">Use a comma-separated or newline-separated list of basket names.</span>\n    </div>\n    <div class=\"sos-layout-dialog-footer\">\n        <div class=\"display-grid grid-cols-2\">\n            <div>\n                <button class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-close\"\n                        data-dojo-attach-event=\"click: _onCancelClick\">Cancel</button>\n            </div>\n            <div class=\"text-align-right\">\n                <button class=\"sos-btn sos-btn-confirm sos-btn-icon sos-icon-plus\"\n                        disabled\n                        data-dojo-attach-point=\"elementAddBasketsButton\"\n                        data-dojo-attach-event=\"click: _onAddBasketsClick\">Add Baskets</button>\n            </div>\n        </div>\n    </div>\n</div>\n",
'url:style-guide/v1/file-tray/dialog/template/BasketSelectDialog.html':"<div>\n    <div class=\"sos-layout-dialog-content\">\n        <div>\n            <div data-dojo-attach-point=\"selectNode\"></div>\n        </div>\n    </div>\n    <div class=\"sos-layout-dialog-footer display-grid grid-cols-2\">\n        <div>\n            <button class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-close\"\n                    data-dojo-attach-event=\"click: _onCloseClick\">Cancel</button>\n        </div>\n        <div class=\"text-align-right\">\n            <button class=\"sos-btn sos-btn-confirm sos-btn-icon sos-icon-save\" disabled\n                    data-dojo-attach-point=\"selectButton\"\n                    data-dojo-attach-event=\"click: _onSelectClick\">Add to Basket</button>\n        </div>\n    </div>\n</div>",
'url:style-guide/v1/file-tray/dialog/template/NameBasketDialog.html':"<div>\n    <div class=\"sos-layout-dialog-content\">\n        <label class=\"m-0 sos-label-required\">Basket Name</label>\n        <div data-dojo-attach-point=\"nameInputNode\"></div>\n\n        <div data-dojo-attach-point=\"collaboratorsContainerNode\" class=\"display-none\">\n            <div data-dojo-attach-point=\"addCollaboratorsContainerNode\" class=\"pt-12 text-align-right\">\n                <a class=\"sos-icon sos-icon-users\"\n                   title=\"Share this basket with other people\"\n                   data-dojo-attach-point=\"addCollaboratorsButton\">Add Collaborators</a>\n            </div>\n            <div data-dojo-attach-point=\"collaboratorsFormContainerNode\" class=\"pt-12 display-none\">\n                <label class=\"m-0\">Collaborators</label>\n                <div data-dojo-attach-point=\"collaboratorsFormNode\"></div>\n            </div>\n        </div>\n    </div>\n    <div class=\"sos-layout-dialog-footer display-grid grid-cols-2\">\n        <div>\n            <button class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-close\"\n                    data-dojo-attach-point=\"closeButton\"\n                    data-dojo-attach-event=\"click: _onCloseClick\">Cancel</button>\n        </div>\n        <div class=\"text-align-right\">\n            <button class=\"sos-btn sos-btn-confirm sos-btn-icon sos-icon-save\"\n                    disabled\n                    data-dojo-attach-point=\"saveButton\"\n                    data-dojo-attach-event=\"click: _onSaveClick\">Save Basket</button>\n        </div>\n    </div>\n</div>",
'url:doccontrol/viewer/dojo/template/FileTypeTile.html':"<div>\n    <% if (fileType) { %>\n        <div data-dojo-attach-point=\"fileTypeContainer\" class=\"view-type-container <%= fileTypeToColourClass(fileType) %>\">\n            <span data-dojo-attach-point=\"fileIcon\" class=\"sos-icon viewer-icon <%= fileTypeToIconClass(fileType) %>\">\n                <span><%= mimeTypeFormatter(fileType).toUpperCase() + ' ' + megabytesFormatter(fileSize) %></span>\n            </span>\n        </div>\n    <% } else { %>\n        <div data-dojo-attach-point=\"fileTypeContainer\" class=\"view-type-container\"></div>\n    <% } %>\n</div>\n",
'url:doccontrol/viewer/dojo/template/MediaViewerBody.html':"<div>\n    <p data-dojo-attach-point=\"errorMessage\" class=\"hidden error-message\">\n        Sorry, this media cannot be viewed in this browser.<br />\n        Please download and open this media on your computer/device.\n    </p>\n    <% if (mediaType) { %>\n        <div data-dojo-attach-point=\"mediaContainer\" class=\"media-container\">\n            <% if (mediaType == 'video') { %>\n                <video data-dojo-attach-point=\"media\" controls>\n                    <source data-dojo-attach-point=\"src\" src=\"<%= href %>\" type=\"<%= fileType %>\" />\n                </video>\n\n            <% } else if (mediaType == 'audio') { %>\n                <audio data-dojo-attach-point=\"media\" controls>\n                    <source data-dojo-attach-point=\"src\" src=\"<%= href %>\" type=\"<%= fileType %>\" />\n                </audio>\n            <% } %>\n        </div>\n    <% } %>\n</div>",
'url:doccontrol/viewer/dojo/template/MediaViewer.html':"<div class=\"sos-layout-dialog-content\">\n    <div data-dojo-attach-point=\"loadingContainer\" class=\"loading-container\">\n        <div data-dojo-attach-point=\"loading\" class=\"loading-state\">\n            <span class=\"sos-icon sos-icon-animation-spin-smooth sos-icon-refresh\"></span>\n            <br />\n            <br />\n            <span>Loading...</span>\n            <br />\n            <br />\n            <button class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-close\"\n                    data-dojo-attach-point=\"elementCancel\"\n                    data-dojo-attach-event=\"click: _onCancelClick\">Cancel</button>\n        </div>\n        <p data-dojo-attach-point=\"longLoadMessage\" class=\"sos-alert-information hidden\">\n            This document is taking a long time to load.\n            <br />\n            <br />\n            Consider using the <strong>\"Download\" button</strong> above and opening this document on your computer/device.\n        </p>\n\n        <div data-dojo-attach-point=\"errorMessage\" class=\"hidden error-container\">\n            <p class=\"error-message\">\n                Sorry, this media could not be retrieved from the server.\n                <br />\n                If this problem persists, please contact support.\n            </p>\n        </div>\n\n        <div data-dojo-attach-point=\"unauthorisedMessage\" class=\"hidden error-container\">\n            <p class=\"error-message\">You do not have permission to view this document.</p>\n        </div>\n\n        <div data-dojo-attach-point=\"deletedMessage\" class=\"hidden error-container\">\n            <p class=\"error-message\">Sorry, you cannot view this document as it has been deleted.</p>\n        </div>\n\n        <div data-dojo-attach-point=\"abortMessage\" class=\"hidden error-container\">\n            <p class=\"error-message\">\n                You've clicked the <strong>\"Download\" button</strong>.\n                <br />\n                The document will not be loaded in the viewer to reduce network traffic.\n                <br />\n                You can reload the document in viewer by clicking the button below.\n                <br/>\n                <button class=\"sos-btn sos-btn-secondary\" data-dojo-attach-event=\"click:_reload\">Reload</button>\n            </p>\n        </div>\n    </div>\n\n    <div class=\"information-container hidden\" data-dojo-attach-point=\"informationContainer\"></div>\n\n    <div class=\"content-container media-content-container\" data-dojo-attach-point=\"contentContainer\">\n        <div class=\"scroll-container\" data-dojo-attach-point='scrollContainer'>\n            <div class=\"media-content-alignment-container\" data-dojo-attach-point=\"bodyContainer\"></div>\n        </div>\n    </div>\n</div>",
'url:style-guide/v1/favourites/templates/AddFavouriteDialog.html':"<div class=\"sos-layout-dialog-content-container add-favourite-dialog\">\n    <form>\n        <div class=\"sos-layout-dialog-content sos-form-textfield-validation\">\n            <label class=\"sos-label-required add-favourite-name\" for=\"addFavouriteName\">Favourite Name</label>\n            <input class=\"sos-form-textfield sos-form-textfield-validation add-favourite-name\" id=\"addFavouriteName\" data-dojo-attach-point=\"addFavouriteInput\" type=\"text\" placeholder=\"Name\" required/>\n            <div class=\"sos-form-textfield-validation-tag\"></div>\n        </div>\n\n        <div class=\"sos-layout-dialog-footer\">\n            <button\n                    class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-close\"\n                    data-dojo-attach-point=\"cancelButton\"\n                    data-dojo-attach-event=\"click: close\"\n                    type=\"button\"\n            >Cancel</button>\n            <button\n                    class=\"sos-btn sos-btn-confirm sos-btn-icon sos-icon-plus right add-favourite\"\n                    data-dojo-attach-point=\"addButton\"\n                    data-dojo-attach-event=\"click: _addFavourite\"\n                    type=\"submit\"\n            >Add Favourite</button>\n        </div>\n    </form>\n</div>",
'url:doccontrol/viewer/dojo/template/DialogToolbar.html':"<div class=\"dialog-toolbar\">\n    <div data-dojo-attach-point=\"fileTypeContainer\"></div>\n\n    <% if (markedAsPrivate) { %>\n        <div class=\"sos-icon-private-document\">\n            <span class=\"sos-icon\" />\n        </div>\n    <% } %>\n\n    <div class=\"view-title-container\">\n        <div <%= titleLoading ? 'class=\"file-title-loading\"' : '' %> data-dojo-attach-point=\"fileTitle\"></div>\n    </div>\n\n    <% if (supportsOcr) { %>\n        <a data-dojo-attach-event=\"click: toggleOcr\">\n            <div data-dojo-attach-point=\"ocr\" class=\"button-container disabled\">\n                <span class=\"sos-icon sos-icon-magic adjust-low-width\">\n                    <span class=\"hide-low-width\">OCR</span>\n                </span>\n            </div>\n        </a>\n    <% } %>\n\n    <div class=\"button-container dropdown-header hide-mobile-width\" data-dojo-attach-point=\"registerDropdownNode\" hidden>\n        <span class=\"sos-icon sos-icon-chevron-down dropdown-header\">Register</span>\n        <div class=\"dropdown-content\">\n            <ul>\n                <li>\n                    <a>\n                        <div class=\"button-container\"\n                             data-dojo-attach-point=\"registerFileButton\"\n                             data-dojo-attach-event=\"click: onRegisterFileClick\">\n                            <span class=\"sos-icon sos-icon-folder-open\">Original File</span>\n                        </div>\n                    </a>\n                </li>\n                <li>\n                    <a>\n                        <div class=\"button-container\"\n                             data-dojo-attach-point=\"registerAnnotationsButton\"\n                             data-dojo-attach-event=\"click: onRegisterAnnotatedClick\">\n                            <span class=\"sos-icon sos-icon-folder-open\">Annotated File</span>\n                        </div>\n                    </a>\n                </li>\n                <li>\n                    <a>\n                        <div class=\"button-container\"\n                             data-dojo-attach-point=\"reviseAnnotationsButton\"\n                             data-dojo-attach-event=\"click: onReviseAnnotatedClick\">\n                            <span class=\"sos-icon sos-icon-folder-open\">Annotated File as new Revision</span>\n                        </div>\n                    </a>\n                </li>\n            </ul>\n        </div>\n    </div>\n\n    <% if (supportsAnnotations) { %>\n        <a data-dojo-attach-event=\"click: toggleAnnotationOptions\">\n            <div data-dojo-attach-point=\"annotationOptions\" class=\"button-container disabled\">\n                <span class=\"sos-icon sos-icon-pencil-paper adjust-low-width\">\n                    <span class=\"sos-icon sos-icon-existing-annotations adjust-low-width <%= !hasAnnotations ? 'hidden' : '' %>\"\n                          data-dojo-attach-point=\"existingAnnotationsIcon\"></span>\n                    <span class=\"hide-low-width\">Annotations</span>\n                </span>\n            </div>\n        </a>\n    <% } %>\n\n    <% if (isExportableToPDF || supportsAnnotations) { %>\n        <div class=\"button-container dropdown-header\" data-dojo-attach-point=\"downloadDropDownNode\">\n            <span class=\"sos-icon sos-icon-chevron-down dropdown-header\">Download</span>\n            <div class=\"dropdown-content\">\n                <ul>\n                    <li data-dojo-attach-point=\"downloadAnnotatedButton\">\n                        <div class=\"button-container\" data-dojo-attach-event=\"click: downloadAnnotations\">\n                            <span class=\"sos-icon sos-icon-download\">Annotated File</span>\n                        </div>\n                    </li>\n                    <li>\n                        <div class=\"button-container\" data-dojo-attach-event=\"click: downloadFile\">\n                            <span class=\"sos-icon sos-icon-download\">Original File</span>\n                        </div>\n                    </li>\n                    <% if (isExportableToPDF) { %>\n                        <li>\n                            <div class=\"button-container\" data-dojo-attach-event=\"click: downloadPDF\">\n                                <span class=\"sos-icon sos-icon-download\">PDF Export</span>\n                            </div>\n                        </li>\n                    <% } %>\n                </ul>\n            </div>\n        </div>\n    <% } else { %>\n        <a data-dojo-attach-point=\"downloadButtonNode\">\n            <div data-dojo-attach-event=\"click: downloadFile\" data-dojo-attach-point=\"download\" class=\"button-container\">\n                <span class=\"sos-icon sos-icon-download\">Download</span>\n            </div>\n        </a>\n    <% } %>\n\n    <div class=\"button-container dropdown-header\" data-dojo-attach-point=\"shareMenu\">\n        <span class=\"sos-icon sos-icon-chevron-down dropdown-header\">Share<span class=\"hide-low-width\">&nbsp;via</span>...</span>\n        <div class=\"dropdown-content\">\n            <ul>\n                <li>\n                    <div class=\"button-container disabled\" data-dojo-attach-point=\"shareLinkButtonNode\">\n                        <span class=\"sos-icon sos-icon-create-link\"\n                              data-dojo-attach-event=\"click: _shareViaLink\">Link</span>\n                    </div>\n                </li>\n                <li>\n                    <div class=\"button-container\">\n                        <span class=\"sos-icon sos-icon-envelope\" data-dojo-attach-event=\"click: _shareToEmailClick\">Email</span>\n                    </div>\n                </li>\n                <% if (supportsAnnotations) { %>\n                    <li>\n                        <div class=\"button-container\" data-dojo-attach-event=\"click: _shareAnnotatedExportToEmailClick\">\n                            <span class=\"sos-icon sos-icon-envelope\">Email (Annotated Version)</span>\n                        </div>\n                    </li>\n                <% } %>\n                <li>\n                    <div class=\"button-container\">\n                        <span class=\"sos-icon sos-icon-shopping-basket\" data-dojo-attach-event=\"click: _addToBasket\">Add To Basket</span>\n                    </div>\n                </li>\n            </ul>\n        </div>\n    </div>\n\n\n    <% if (isExportableToPDF || supportsAnnotations) { %>\n        <a>\n            <div data-dojo-attach-point=\"printMenu\" data-dojo-attach-event=\"click: printFile\" class=\"button-container\">\n                <span class=\"sos-icon sos-icon-print adjust-low-width\"><span class=\"hide-low-width\">Print</span></span>\n            </div>\n        </a>\n    <% } %>\n\n    <% if (supportsInformation) { %>\n        <a data-dojo-attach-event=\"click: toggleInformation\">\n            <div data-dojo-attach-point=\"information\" class=\"button-container\">\n                <span class=\"sos-icon sos-icon-information adjust-mobile-width\">\n                    <span class=\"sos-icon sos-icon-information-notification <%= !hasNotification ? 'hidden' : '' %> adjust-mobile-width\"\n                          data-dojo-attach-point=\"informationNotificationIcon\"></span>\n                    <span class=\"hide-mobile-width\">Information</span>\n                </span>\n            </div>\n        </a>\n    <% } %>\n\n    <div class=\"button-container disabled\" data-dojo-attach-point=\"favouriteContainerNode\">\n        <button class=\"favourite-document-button disabled\"\n                data-dojo-attach-event=\"click: favouriteFile\"\n                data-dojo-attach-point=\"favouriteButtonNode\"\n                disabled>\n            <span class=\"sos-icon <%= !isFavourite ? 'sos-icon-empty-star' : 'sos-icon-star' %> adjust-low-width\"\n                  data-dojo-attach-point=\"favouriteSpanNode\">\n                <span class=\"hide-low-width\"><%= !isFavourite ? 'Favourite' : 'Unfavourite' %></span>\n            </span>\n        </button>\n    </div>\n</div>",
'url:doccontrol/viewer/dojo/template/NavigationBar.html':"<div class=\"navigation-container hidden\">\n    <a class=\"navigate-previous hidden\"\n       data-dojo-attach-event=\"click:_navigatePrevious\"\n       data-dojo-attach-point=\"previousLink\"><span data-dojo-attach-point=\"previousLabel\">Prev<span class=\"hide-mobile-width\">ious</span></span></a>\n    <a class=\"navigate-next hidden\"\n       data-dojo-attach-event=\"click:_navigateNext\"\n       data-dojo-attach-point=\"nextLink\"><span data-dojo-attach-point=\"nextLabel\">Next</span></a>\n</div>",
'url:doccontrol/viewer/dojo/pin/template/Sidebar.html':"<div class=\"hidden annotation-pin-sidebar\">\n    <div class=\"pin-sidebar-header\">\n        <div class=\"pin-sidebar-title\">\n            <span class=\"sos-icon sos-icon-pin\" data-dojo-attach-point=\"pinTitleNode\">Pins</span>\n        </div>\n        <button data-dojo-attach-point=\"deleteBtn\" data-dojo-attach-event=\"click: _delete\">\n            <span class=\"sos-icon sos-icon-trash\">Delete</span>\n        </button>\n        <button data-dojo-attach-event=\"click: _close\">\n            <span class=\"sos-icon sos-icon-close\">Close</span>\n        </button>\n    </div>\n    <div class=\"pin-sidebar-content\" data-dojo-attach-point=\"scrollContainer\" data-dojo-attach-event=\"scroll: _onScroll\">\n        <div data-dojo-attach-point=\"attachmentsAccordionNode\" class=\"sos-accordion pin-sidebar-attachments-accordion\">\n            <div data-dojo-attach-point=\"attachmentsContainer\">\n                <div data-dojo-attach-point=\"attachmentsNode\"></div>\n            </div>\n        </div>\n\n        <div data-dojo-attach-point=\"commentThreadNode\" class=\"pin-comment-thread\"></div>\n\n        <p data-dojo-attach-point=\"emptyState\" class=\"sos-empty-state\">\n            <span class=\"sos-icon sos-icon-pin\">No pin selected.</span>\n        </p>\n\n        <div class=\"new-comment-notification-container hidden\" data-dojo-attach-point=\"newCommentNotification\">\n            <div class=\"new-comment-notification\" data-dojo-attach-event=\"click: _scrollToBottom\">\n                <span class=\"sos-icon sos-icon-arrow-down\">new comment(s)</span>\n            </div>\n        </div>\n    </div>\n    <div class=\"pin-sidebar-footer\">\n        <textarea class=\"sos-form-textarea\" data-dojo-attach-point=\"textInputNode\" placeholder=\"Comment on this pin\"></textarea>\n        <button data-dojo-attach-point=\"commentBtn\" class=\"sos-btn sos-btn-confirm sos-btn-icon sos-icon-paper-plane\" data-dojo-attach-event=\"click: _comment\">Add comment</button>\n    </div>\n</div>\n",
'url:style-guide/v1/doc-control/attachment/templates/Row.html':"<tr>\n    <td>\n        <span class=\"sos-icon <%= fileTypeToIconClass(file.getFileType()) %>\"></span>\n        <a href=\"<%= generateDocumentViewerUrl(file.getMd5()) %>\" target=\"_blank\" title=\"<%= getAttachmentName(file) %>\"><%= getAttachmentName(file) %></a>\n    </td>\n    <td><a class=\"sos-icon sos-icon-trash\" data-dojo-attach-event=\"click: _remove\">Remove</a></td>\n</tr>",
'url:style-guide/v1/doc-control/audio-record/dojo/templates/DialogButton.html':"<button class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-microphone\"\n        data-dojo-attach-event=\"click:_onOpenClick\">Record Audio</button>",
'url:style-guide/v1/doc-control/audio-record/dojo/templates/Dialog.html':"<div>\n    <div data-dojo-attach-point=\"dialog\">\n        <div class=\"sos-layout-dialog-content\">\n            <div data-dojo-attach-point=\"recorderNode\"></div>\n        </div>\n    </div>\n</div>",
'url:style-guide/v1/doc-control/audio-record/dojo/templates/Recorder.html':"<div class=\"sos-form-audio-recorder\">\n    <div class=\"sos-layout-dialog-content\">\n        <div class=\"sos-form-audio-icon-status\">\n            <span data-dojo-attach-point=\"recordIcon\"\n                  class=\"sos-icon sos-icon-microphone-slash\"></span>\n            <span data-dojo-attach-point=\"waitingIcon\"\n                  class=\"sos-icon sos-icon-animation-spin-smooth-before sos-icon-refresh disabled hidden\"></span>\n            <span data-dojo-attach-point=\"stopIcon\"\n                  class=\"sos-icon sos-icon-microphone hidden\"></span>\n            <span data-dojo-attach-point=\"playIcon\"\n                  data-dojo-attach-event=\"click:_play\"\n                  class=\"sos-icon sos-icon-play hidden\"></span>\n            <span data-dojo-attach-point=\"pauseIcon\"\n                  data-dojo-attach-event=\"click:_pause\"\n                  class=\"sos-icon sos-icon-pause hidden\"></span>\n        </div>\n        <div class=\"sos-form-audio-progression\">\n            <span data-dojo-attach-point=\"durationNode\" class=\"audio-duration\">00:00</span>\n            <div data-dojo-attach-point=\"progressBar\" class=\"upload-progress-bar hidden\">\n                <div class=\"upload-progress-bar-value\"></div>\n            </div>\n        </div>\n        <div class=\"sos-form-audio-instructions\">\n            <p data-dojo-attach-point=\"instructions\"></p>\n        </div>\n    </div>\n    <div data-dojo-attach-point=\"buttonContainer\" class=\"sos-layout-dialog-footer\">\n        <button data-dojo-attach-point=\"cancelBtn\" data-dojo-attach-event=\"click:_cancel\"\n                class=\"sos-btn sos-btn-secondary sos-btn-icon\">Cancel</button>\n        <button data-dojo-attach-point=\"resetBtn\" data-dojo-attach-event=\"click:_reset\"\n                class=\"sos-btn sos-btn-negative sos-btn-icon sos-icon-reset left hidden\">Reset</button>\n        <button data-dojo-attach-point=\"recordBtn\" data-dojo-attach-event=\"click:_record\"\n                class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-microphone right\">Record</button>\n        <button data-dojo-attach-point=\"stopBtn\" data-dojo-attach-event=\"click:_stop\"\n                class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-microphone-slash hidden right\">Stop</button>\n        <button data-dojo-attach-point=\"playBtn\" data-dojo-attach-event=\"click:_play\"\n                class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-play hidden\">Play</button>\n        <button data-dojo-attach-point=\"pauseBtn\" data-dojo-attach-event=\"click:_pause\"\n                class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-pause hidden\">Pause</button>\n        <button data-dojo-attach-point=\"cancelUploadBtn\" data-dojo-attach-event=\"click:_cancelUpload\"\n                class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-reset hidden\">Cancel Upload</button>\n        <button data-dojo-attach-point=\"uploadBtn\" data-dojo-attach-event=\"click:_upload\"\n                class=\"sos-btn sos-btn-icon sos-icon-cloud-upload right hidden\">Upload</button>\n        <form id=\"<%= formID %>\"></form>\n    </div>\n</div>",
'url:style-guide/v1/doc-control/file-upload/dojo/templates/Uploader.html':"<div class=\"sos-form-upload-btn\">\n    <form id=\"fileUploadForm\">\n        <input type=\"file\" data-dojo-attach-point=\"uploadHTMLNode\" multiple />\n    </form>\n    <button class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-upload\" data-dojo-attach-event=\"click: selectFile\" data-dojo-attach-point=\"uploadButton\">Upload from your computer</button>\n</div>",
'url:style-guide/v1/doc-control/attachment/templates/Attachments.html':"<div>\n    <table class=\"sos-table sos-doc-control-attachment-table\">\n        <colgroup>\n            <col />\n            <col class=\"sos-doc-control-attachments-remove\" />\n        </colgroup>\n        <thead>\n            <tr>\n                <th>Attachments</th>\n                <th><a class=\"sos-icon sos-icon-trash\" data-dojo-attach-event=\"click: _clear\">Clear</a></th>\n            </tr>\n        </thead>\n        <tbody data-dojo-attach-point=\"tbodyNode\">\n            <tr class=\"sos-empty-state\">\n                <td colspan=\"2\">No attached items.</td>\n            </tr>\n        </tbody>\n    </table>\n    <div class=\"sos-doc-control-attachment-button-container\">\n        <div class=\"sos-drop-down-button\">\n            <button class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-plus\">Add Attachment</button>\n            <div class=\"sos-drop-down-button-content\">\n                <div data-dojo-attach-point=\"selectorNode\"></div>\n                <div data-dojo-attach-point=\"audioRecorderNode\"></div>\n                <div>\n                    <button class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-camera\" data-dojo-attach-point=\"openCaptureDialogBtn\">Capture</button>\n                </div>\n                <div data-dojo-attach-point=\"uploadNode\"></div>\n                <form id=\"<%= formID %>\"></form>\n            </div>\n        </div>\n    </div>\n</div>",
'url:style-guide/v1/forms/templates/DocumentSelector.html':"<div>\n    <div data-dojo-attach-point=\"documentSelectorContainer\"></div>\n    <button class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-files-copy\"\n            data-dojo-attach-event=\"click: _onOpenClick\"\n            data-dojo-attach-point=\"openButton\">Select From Document Control</button>\n</div>",
'url:doc-control/document-selector/dojo/template/DocumentSelector.html':"<div class=\"sos-layout-dialog-section-wrapper\">\n    <div class=\"document-selector-file-browser-container pt-24 pb-6 px-12\">\n        <div data-dojo-attach-point=\"documentSelectorFileBrowserContainer\"></div>\n    </div>\n    <div class=\"document-selector-dialog-footer px-24 py-9\" data-dojo-attach-point=\"dialogFooter\">\n        <div data-dojo-attach-point=\"documentSelectorSelectedDocumentsContainer\"></div>\n    </div>\n</div>",
'url:doc-control/document-selector/dojo/template/SelectedDocuments.html':"<div class=\"selected-document-container d-grid height-100\">\n    <div class=\"selected-document-content d-grid height-100\">\n        <div class=\"selected-document-bar width-100 d-flex items-center\">\n            <strong data-dojo-attach-point=\"elementDocumentsSelectedCount\">0 Documents Selected</strong>\n            <button\n                    class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-eye my-3\"\n                    data-dojo-attach-event=\"click: _toggleShowSelected\"\n                    data-dojo-attach-point=\"elementShowHideButton\"\n                    disabled\n            >\n                Show Selected Documents\n            </button>\n            <button\n                    class=\"sos-btn sos-btn-confirm sos-btn-icon sos-icon-check my-3 mr-0\"\n                    data-dojo-attach-event=\"click: _confirmSelection\"\n                    data-dojo-attach-point=\"elementConfirmSelectionButton\"\n                    disabled\n            >\n                Confirm Selection\n            </button>\n        </div>\n        <div class=\"selected-document-details width-100 my-12 mx-0 p-0 overflow-y-auto display-none\" data-dojo-attach-point=\"elementSelectedDocuments\">\n            <table class=\"sos-table sos-table-sticky\">\n                <thead>\n                    <tr>\n                        <th>Title</th>\n                        <th>Uploaded By</th>\n                        <th>Upload Date</th>\n                        <th></th>\n                    </tr>\n                </thead>\n                <tbody data-dojo-attach-point=\"elementTableBody\"></tbody>\n            </table>\n        </div>\n    </div>\n</div>",
'url:doc-control/document-selector/dojo/template/SelectedDocumentRow.html':"<tr>\n    <td>\n        <span class=\"sos-icon <%= fileIconClass(revision.getFileType()) %>\"></span><%= revision.getTitle(); %>\n    </td>\n    <td><%= uploadedByFormatter(revision); %></td>\n    <td><%= dateFormatter(revision.getDateUploaded()); %></td>\n    <td class=\"text-align-center\">\n        <a class=\"sos-icon sos-icon-minus\"\n           data-revision-id=\"<%= revision.getRevisionPK(); %>\"\n           data-dojo-attach-event=\"click: _removeRevision\">Remove</a>\n    </td>\n</tr>",
'url:style-guide/v1/navigation/templates/ProjectTileContainer.html':"<table class=\"sos-project-tile-container <%= compactMode ? 'sos-project-tile-container-s' : '' %>\">\n    <tr>\n        <td class=\"sos-project-tile-container-button-cell\">\n            <button class=\"sos-icon sos-icon-chevron-left\"\n                    disabled\n                    data-dojo-attach-point=\"previousButton\"\n                    data-dojo-attach-event=\"click: _onPreviousButtonClick\"></button>\n        </td>\n        <td class=\"sos-project-tile-container-content\" data-dojo-attach-point=\"mask\">\n            <% if (projectCollection.length) { %>\n                <div>\n                    <table data-dojo-attach-point=\"subject\">\n                        <tr>\n                            <% for (var i = 0; i < projectCollection.length; i++) { %>\n                                <td>\n                                    <% if (disabled) { %>\n                                        <span class=\"sos-project-tile sos-project-tile-disabled <%= compactMode ? 'sos-project-tile-s' : '' %> sos-icon sos-icon-arrow-down\"><%= projectCollection[i].stageNumber %> - <%= projectCollection[i].title %></span>\n                                    <% } else { %>\n                                        <% const LENGTH = 45; %>\n                                        <% let title = projectCollection[i].stageNumber + \" - \" + projectCollection[i].title; %>\n                                        <a class=\"sos-project-tile <%= compactMode ? 'sos-project-tile-s' : '' %> sos-icon sos-icon-arrow-down\"\n                                           data-dojo-attach-event=\"click: _onProjectStageSelected\"\n                                           data-project-stage-pk=\"<%= projectCollection[i].projectStagePK %>\">\n                                            <% if (title.length > LENGTH) { %>\n                                                <%= title.substr(0, LENGTH) + '...'; %>\n                                            <% } else { %>\n                                                <%= title; %>\n                                            <% } %>\n                                        </a>\n                                    <% } %>\n                                </td>\n                            <% } %>\n                        </tr>\n                    </table>\n                </div>\n            <% } else { %>\n                <p class=\"sos-empty-state sos-empty-state-show\">\n                    <span class=\"sos-icon sos-icon-spencer-project\">\n                        No projects exist in \"My Projects\".\n                        <a href=\"<% baseUrl %>/prefs/user/\" target=\"_blank\" title=\"Go to My Preferences\">Click here</a> to add some.\n                    </span>\n                </p>\n            <% } %>\n        </td>\n        <td class=\"sos-project-tile-container-button-cell\">\n            <% if (projectCollection.length && !disabled) { %>\n                <button class=\"sos-icon sos-icon-chevron-right\"\n                        data-dojo-attach-point=\"nextButton\"\n                        data-dojo-attach-event=\"click: _onNextButtonClick\"></button>\n            <% } else { %>\n                <button class=\"sos-icon sos-icon-chevron-right\"\n                        data-dojo-attach-point=\"nextButton\"\n                        disabled></button>\n            <% } %>\n        </td>\n    </tr>\n</table>",
'url:style-guide/v1/doc-control/template/FileBrowser.html':"<div class=\"sos-navigation-explorer file-browser-content pb-6 height-100\">\n    <% if (showLoading) { %>\n        <p class=\"loading-state\">\n            <span class=\"sos-icon sos-icon-animation-spin-smooth sos-icon-refresh\"></span>\n            <br />\n            Loading <%= (selectedProjectStage) ? 'folders' : 'projects' %>...\n        </p>\n    <% } else if (!selectedNode) { %>\n        <div class=\"file-browser-content-view file-browser-content-project-view height-100\">\n            <div class=\"file-browser-content-header width-100\">\n                <label class=\"my-0 mx-12\">Project Stage</label>\n                <div data-dojo-attach-point=\"projectStageFilterInput\"></div>\n            </div>\n            <div class=\"file-browser-content-body px-12 width-100 height-100\">\n                <div data-dojo-attach-point=\"projectTileContainerNode\"></div>\n            </div>\n        </div>\n    <% } else { %>\n        <div class=\"sos-navigation-explorer-content file-browser-content-view file-browser-content-file-view px-12 height-100\">\n            <div class=\"file-browser-content-header pb-6 pt-3 px-3 width-100\">\n                <ol class=\"sos-navigation-breadcrumb auto-style-leaf px-0\">\n                    <li>\n                        <span class=\"sos-navigation-breadcrumb-home sos-icon-folder\"><a data-dojo-attach-event=\"click:openDocControl\">Doc Control</a></span>\n                        <span class=\"sos-navigation-breadcrumb-separator\"></span>\n                    </li>\n                    <li>\n                        <span>\n                            <a data-dojo-attach-event=\"click:_clickProjectStage\"\n                               data-id=\"<%= selectedProjectStage.getProjectStagePK() %>\"><%= selectedProjectStage.getTitle() %></a>\n                        </span>\n                        <span class=\"sos-navigation-breadcrumb-separator\"></span>\n                    </li>\n                    <% nodeBreadcrumb.forEach((node) => { %>\n                        <% if (node.getParent()) { %>\n                            <li>\n                                <span>\n                                    <a data-dojo-attach-event=\"click:openBreadcrumbNode\"\n                                       data-id=\"<%= node.getProjectStageTreeViewPK() %>\"><%= node.getName() %></a>\n                                </span>\n                                <span class=\"sos-navigation-breadcrumb-separator\"></span>\n                            </li>\n                        <% } %>\n                    <% }) %>\n                </ol>\n                <div data-dojo-attach-point=\"documentFilterContainer\">\n                    <label class=\"sos-form-textfield-prefix sos-form-textfield-prefix-s m-0\">Filter</label>\n                    <div data-dojo-attach-point=\"documentFilterNode\"></div>\n                </div>\n            </div>\n            <div class=\"file-browser-content-body overflow-y-auto p-6\">\n                <% if (selectedNode.getChildren().length > 0) { %>\n                    <div class=\"sos-navigation-explorer-content-body sos-navigation-explorer-content-body-medium mb-6 width-100\">\n                        <% selectedNode.getChildren().forEach((child) => { %>\n                            <div>\n                                <a title=\"<%= child.name %> (<%= child.documentCount %> document<%= child.documentCount === 1 ? '' : 's' %>)\"\n                                class=\"<%= child.documentCount ? 'populated' : '' %>\"\n                                   data-dojo-attach-event=\"click:openChild\"\n                                   data-id=\"<%= child.getProjectStageTreeViewPK() %>\">\n                                    <span class=\"sos-icon sos-icon-doc-control-<%= child.type?.toLowerCase?.() %> <%= child.documentCount > 0 ? 'populated' : '' %>\"></span>\n                                    <span><%= summarise(child.name) %></span>\n                                </a>\n                            </div>\n                        <% }) %>\n                    </div>\n                <% } %>\n                <div class=\"sos-navigation-explorer-content-body\" data-dojo-attach-point=\"revisionContainer\"></div>\n            </div>\n        </div>\n    <% } %>\n</div>",
'url:style-guide/v1/doc-control/template/RevisionContainer.html':"<div class=\"sos-navigation-explorer-content-body width-100\">\n    <% if (showLoading) { %>\n        <p class=\"loading-state\">\n            <span class=\"sos-icon sos-icon-animation-spin-smooth sos-icon-refresh\"></span>\n            <br />\n            Loading files...\n        </p>\n    <% } else if (shouldDisplayRevisionTable(selectedNode)) { %>\n        <table class=\"sos-table sos-table-sticky\">\n            <thead>\n                <tr>\n                    <% let columnCount = 3; %>\n                    <th>Title</th>\n                    <th>Uploaded By</th>\n                    <th>Upload Date</th>\n                    <% if (isRevisable(selectedNode)) { %>\n                        <th>Reference<% columnCount++; %></th>\n                        <% if (isDrawing(selectedNode)) { %>\n                            <th>Discipline<% columnCount++; %></th>\n                        <% } %>\n                        <th>Revision<% columnCount++; %></th>\n                        <th>Status<% columnCount++; %></th>\n                    <% } %>\n                    <% if (revisionCollection.length !== 0) { %>\n                        <th><% columnCount++; %></th>\n                    <% } %>\n                </tr>\n            </thead>\n            <tbody>\n            <% if (revisionCollection.length === 0) { %>\n                <tr class=\"sos-empty-state\">\n                    <td colspan=\"<%= columnCount %>\" class=\"sos-icon sos-icon-file\">No documents could be found.</td>\n                </tr>\n            <% } %>\n            <% revisionCollection.forEach(revision => { %>\n                <tr>\n                    <td>\n                        <span class=\"sos-icon <%= fileIconClass(revision.getFileType()) %>\"></span><%= revision.getTitle() %>\n                    </td>\n                    <td><%= formatUploadedBy(revision) %></td>\n                    <td><%= formatDate(revision.getDateUploaded()) %></td>\n                    <% if (isRevisable(selectedNode)) { %>\n                        <td><%= revision.getReference() %></td>\n                        <% if (isDrawing(selectedNode)) { %>\n                            <td><%= revision.getDiscipline() %></td>\n                        <% } %>\n                        <td><%= revision.getRevisionNumber() %></td>\n                        <td><%= revision.getStatus()?.getDescription?.() %></td>\n                    <% } %>\n                    <td class=\"text-align-center\">\n                        <a class=\"sos-icon sos-icon-plus\"\n                           data-revision-id=\"<%= revision.getRevisionPK() %>\"\n                           data-dojo-attach-event=\"click: selectRevision\">Select</a>\n                    </td>\n                </tr>\n            <% }) %>\n            </tbody>\n        </table>\n    <% } %>\n</div>",
'url:doccontrol/viewer/dojo/pin/template/Comment.html':"<div>\n    <div class=\"pin-comment-header\">\n        <p>\n            <strong data-dojo-attach-point=\"displayNameNode\"><%= comment.getDisplayName(); %></strong>\n            <span data-dojo-attach-point=\"relativeTime\"></span>\n        </p>\n        <div class=\"pin-comment-content\">\n            <blockquote>\n                <%- formatComment(comment.getText()); %>\n            </blockquote>\n        </div>\n    </div>\n</div>\n",
'url:spencer/date-time/templates/RelativeTime.html':"<span dir=\"ltr\"><%= text != null ? (prefix ? prefix : '') + text : '' %></span>",
'url:doccontrol/viewer/dojo/template/RevisionHistorySidebar.html':"<div class=\"revision-history-sidebar\">\n    <div class=\"revision-history-sidebar-content\">\n        <div class=\"history-sidebar-header\">Revision History</div>\n        <div class=\"history-sidebar-content\">\n            <% if (revisionCollection.length) { %>\n                <% revisionCollection.forEach(function(revision) { %>\n                    <a class=\"history-sidebar-row\"\n                        href=\"<%= revisionDownloadUrl(revision.getRevisionPK()) %>\"\n                        data-dojo-attach-event=\"click: viewDocument\"\n                        data-revision-pk=\"<%= revision.getRevisionPK() %>\"\n                        data-file-type=\"<%= revision.getFileType() %>\"\n                        data-md5=\"<%= revision.getMd5() %>\">\n                        <div class=\"history-sidebar-top-row\">\n                            <div class=\"revision-number\">\n                                <% if (currentRevision && currentRevision.getRevisionPK() === revision.getRevisionPK()) { %>\n                                    <span class=\"sos-icon sos-icon-eye\"></span>\n                                <% } %>\n                                <% if (revision.isLatest()) { %>\n                                    <span class=\"sos-icon sos-icon-latest-revision sos-icon-exclamation-circle\"></span>\n                                <% } %>\n                                <%= revision.getRevisionNumber() || revision.getTitle() %>\n                            </div>\n                            <div><%= formatDate(revision.getDateUploaded()) %></div>\n                        </div>\n                        <div class=\"upload-person\"><%= formatPerson(revision.getPersonUploader()) %></div>\n                    </a>\n                <% }); %>\n            <% } else { %>\n                <p>Error loading document history. Please reload the Document Viewer.</p>\n            <% } %>\n        </div>\n    </div>\n</div>",
'url:doccontrol/viewer/dojo/template/SignatureNotification.html':"<p class=\"sos-alert-information signature-notification\">\n    <a title=\"Dismiss this alert\" class=\"sos-alert-dismiss-btn\" data-dojo-attach-event=\"click: _manuallyDismiss\">dismiss</a>\n    This page contains a signature.\n    <a data-dojo-attach-event=\"click: download\">Download</a> and open in pdf viewer to see it.\n</p>",
'url:doccontrol/viewer/dojo/template/ViewerDialogBody.html':"<div class=\"sos-layout-dialog-content\" id=\"dialogContainer\">\n    <div data-dojo-attach-point=\"loadingContainer\" class=\"loading-container twelve columns centered first last\">\n        <div data-dojo-attach-point=\"passwordForm\" class=\"hidden password-form\">\n            This document cannot be viewed without the correct password.<br />\n            <div data-dojo-attach-point=\"passwordInputValidationContainer\" class=\"sos-form-textfield-validation\">\n                <input class=\"sos-form-textfield\" type=\"password\" autocomplete=\"off\" aria-autocomplete=\"none\" data-dojo-attach-point=\"passwordInput\" />\n                <div class=\"sos-form-textfield-validation-tag\"></div>\n                <br />\n                <label data-dojo-attach-point=\"passwordPrompt\" class=\"sos-form-textfield-validation-prompt\"></label>\n            </div>\n            <button class=\"sos-btn sos-btn-secondary\" data-dojo-attach-event=\"click: _setPassword\">Submit</button>\n        </div>\n\n        <div data-dojo-attach-point=\"loading\" class=\"loading-state\">\n            <span class=\"sos-icon sos-icon-animation-spin-smooth sos-icon-refresh\"></span>\n            <br />\n            <br />\n            <span>Loading...</span>\n            <br />\n            <br />\n            <button class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-close\"\n                    data-dojo-attach-point=\"elementCancel\"\n                    data-dojo-attach-event=\"click: _onCancelClick\">Cancel</button>\n        </div>\n        <p data-dojo-attach-point=\"longLoadMessage\" class=\"sos-alert-information long-load-message hidden\">\n            This document is taking a long time to load.\n            <br />\n            <br />\n            Consider using the <strong>\"Download\" button</strong> above and opening this document on your computer/device.\n        </p>\n\n        <p data-dojo-attach-point=\"unauthorisedMessage\" class=\"hidden error-message\">\n            You do not have permission to view this document.\n        </p>\n\n        <p data-dojo-attach-point=\"errorMessage\" class=\"hidden error-message\">\n            Sorry, this document cannot be viewed online.\n            <br />\n            Use the <strong>\"Download\" button</strong> above and open this document on your computer/device.\n        </p>\n\n        <p data-dojo-attach-point=\"deletedMessage\" class=\"hidden error-message\">\n            Sorry, you cannot view this document as it has been deleted.\n        </p>\n\n        <p data-dojo-attach-point=\"abortMessage\" class=\"hidden error-message\">\n            You've clicked the <strong>\"Download\" button</strong>.\n            <br />\n            The document will not be loaded in the viewer to reduce network traffic.\n            <br />\n            You can reload the document in viewer by clicking the button below.\n            <br/>\n            <button class=\"sos-btn sos-btn-secondary\" data-dojo-attach-event=\"click: _reload\">Reload</button>\n        </p>\n    </div>\n\n    <div data-dojo-attach-point=\"rendering\" class=\"rendering-container hidden\">\n        <div class=\"rendering-state\">\n            <span class=\"sos-icon sos-icon-animation-spin-smooth sos-icon-refresh\"></span>\n            <br />\n            <br />\n            <span>Rendering...</span>\n        </div>\n    </div>\n\n    <div class=\"information-container hidden\" data-dojo-attach-point=\"informationContainer\"></div>\n\n    <div class=\"content-container invisible\" data-dojo-attach-point=\"contentContainer\">\n        <div class=\"viewAnnotationOptionsTools\"></div>\n        <div id=\"viewRevisionHistorySidebar\"></div>\n        <div class=\"scroll-container annotation-grid-workspace\" data-dojo-attach-point='scrollContainer'>\n            <div id=\"annotationWorkspace\" class=\"document-workspace\" data-dojo-attach-point=\"documentWorkspace\">\n                <div class=\"document\" data-dojo-attach-point=\"documentNode\"></div>\n            </div>\n        </div>\n        <div id=\"viewAnnotationPinSidebar\"></div>\n\n        <div class=\"sos-layout-dialog-footer-container footer-grid-layout\" data-dojo-attach-point=\"navigationFooter\">\n            <div>\n                <button data-dojo-attach-event=\"click: _previous\"\n                   class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-previous-page\"\n                   disabled\n                   data-dojo-attach-point=\"previousButton\">Prev<span class=\"hide-mobile-width\">ious</span></button>\n            </div>\n            <div class=\"count-container\">\n                <div>\n                    <span>Page:</span>\n                    <div data-dojo-attach-point=\"numberInput\"></div>/ <span data-dojo-attach-point=\"pageCount\"></span>\n                </div>\n            </div>\n            <div>\n                <button data-dojo-attach-event=\"click: _next\"\n                   class=\"sos-btn sos-btn-secondary sos-btn-icon-after sos-icon-next-page-after\"\n                   disabled\n                   data-dojo-attach-point=\"nextButton\">Next</button>\n            </div>\n        </div>\n    </div>\n</div>",
'url:doccontrol/viewer/dojo/template/ViewOptionsToolbar.html':"<div class=\"view-options-container hidden\">\n    <div class=\"zoom-count-container\">\n        <div data-dojo-attach-point=\"zoomInput\"></div><label class=\"sos-form-textfield-suffix sos-form-textfield-suffix-s\">%</label>\n    </div>\n    <div data-dojo-attach-point=\"zoomIn\" class=\"button-container\">\n        <span class=\"sos-icon sos-icon-search-plus adjust-mobile-width\">\n            <span class=\"hide-mobile-width\">Zoom In</span>\n        </span>\n    </div>\n    <div data-dojo-attach-point=\"zoomOut\" class=\"button-container\">\n        <span class=\"sos-icon sos-icon-search-minus adjust-mobile-width\">\n            <span class=\"hide-mobile-width\">Zoom out</span>\n        </span>\n    </div>\n    <div data-dojo-attach-point=\"fitWidth\" class=\"button-container\">\n        <span class=\"sos-icon sos-icon-arrows-horizontal adjust-mobile-width\">\n            <span class=\"hide-mobile-width\">Fit Width</span>\n        </span>\n    </div>\n    <div data-dojo-attach-point=\"fitPage\" class=\"button-container\">\n        <span class=\"sos-icon sos-icon-arrows-alt adjust-mobile-width\">\n            <span class=\"hide-mobile-width\">Fit Page</span>\n        </span>\n    </div>\n    <div data-dojo-attach-point=\"rotateClockwise\" class=\"button-container\">\n        <span class=\"sos-icon sos-icon-rotate-right adjust-mobile-width\">\n            <span class=\"hide-mobile-width\">Rotate</span>\n    </div>\n</div>",
'url:style-guide/v1/doc-control/registration-details/DocumentRegister/template/FormPane.html':"<div class=\"register-document\">\n    <div data-dojo-attach-point=\"elementUpload\" class=\"hide\">\n        <h4 class=\"m-0\">Upload File</h4>\n        <input data-dojo-attach-point=\"elementUploadField\" type=\"file\">\n    </div>\n\n    <p data-dojo-attach-point=\"elementFileUploading\" class=\"smart-register-document-loading-state hide\">\n        <span class=\"sos-icon sos-icon-animation-spin-smooth sos-icon-refresh\"></span>\n        <br />\n        <span data-dojo-attach-point=\"elementFileUploadingText\" class=\"large-font\"></span>\n        <br />\n        <button data-dojo-attach-event=\"click: cancelFileUpload\"\n                class=\"sos-btn sos-btn-s sos-btn-secondary sos-btn-icon sos-icon-close\">Cancel</button>\n    </p>\n\n    <p data-dojo-attach-point=\"elementSmartLoading\" class=\"smart-register-document-loading-state hide\">\n        <span class=\"sos-icon sos-icon-animation-spin-smooth sos-icon-refresh\"></span>\n        <br />\n        <span data-dojo-attach-point=\"elementSmartLoadingText\" class=\"large-font\"></span>\n        <br />\n        <button data-dojo-attach-event=\"click: cancelSmartRequests\"\n                class=\"sos-btn sos-btn-s sos-btn-secondary sos-btn-icon sos-icon-close\">Cancel</button>\n    </p>\n\n    <div data-dojo-attach-point=\"elementMain\" class=\"hide\">\n        <p class=\"sos-alert-success hide\" data-dojo-attach-point=\"elementTemplateNotification\">\n            QR Code Detected. Using template <b data-dojo-attach-point=\"elementTemplateNotificationName\"></b> to automatically extract data.\n            <span class=\"hide\" data-dojo-attach-point=\"elementDetectedLocationNotification\">\n                The location <b data-dojo-attach-point=\"elementDetectedLocationNotificationPath\"></b> has been automatically detected.\n            </span>\n            <span class=\"hide\" data-dojo-attach-point=\"elementTemplateNotificationExtended\">\n                Please check all details and fill in any missing information before clicking <%= formPaneTitle %>.\n            </span>\n        </p>\n        <p class=\"sos-alert-information hide\" data-dojo-attach-point=\"elementDiagnosticToolNotification\">\n            <span data-dojo-attach-point=\"elementDiagnosticToolNotificationMessage\"></span>\n            If you suspect this to be a mistake, try using the\n            <a class=\"sos-icon sos-icon-spanner\" data-dojo-attach-event=\"click: onDiagnosticToolClick\">Diagnostic Tool</a>\n            to determine the issue.\n        </p>\n        <h4 class=\"m-0\">Select Project</h4>\n        <div class=\"project-stage-select-container\" data-dojo-attach-point=\"elementProjectStageSelectContainer\">\n            <div data-dojo-attach-point=\"elementProjectTileContainer\"></div>\n            <div data-dojo-attach-point=\"elementProjectStageSearchableSelect\"></div>\n        </div>\n        <div class=\"hide\" data-dojo-attach-point=\"elementNodeSelectContainer\">\n            <h4 class=\"mt-0\">Select Folder</h4>\n            <h5 data-dojo-attach-point=\"elementSelectNodeSubHeader\"></h5>\n            <p class=\"sos-alert-information hide\" data-dojo-attach-point=\"elementFunctionNodeSelectedNotice\">\n                <strong>\"Add File\" selected as registration location.</strong><br />\n                The registration location for this document will be automatically selected based on the File Location Reference\n                below. Should a file for the given file location reference not yet exist, one will be created for you.\n            </p>\n            <div data-dojo-attach-point=\"elementInputProjectNode\"></div>\n        </div>\n        <div data-dojo-attach-point=\"elementLoading\" class=\"hide\">\n            <h4>Select Folder</h4>\n            <p class=\"register-document-loading-state\">\n                <span class=\"sos-icon sos-icon-animation-spin-smooth sos-icon-refresh\"></span>\n                <br />\n                <span class=\"large-font\">Loading tree...</span>\n            </p>\n        </div>\n        <div data-dojo-attach-point=\"elementForbidden\" class=\"register-document-forbidden-state hide\">\n            <p class=\"sos-alert-warning\">Restricted Access</p>\n            <p>\n                You do not have access to <strong data-dojo-attach-point=\"elementProjectStageTitle\">this project</strong>. However if you wish to register this document,\n                click <strong>Quick Register</strong> to place the document in <strong>\"Not sure where to put this\"</strong>.\n            </p>\n            <br />\n            <button title=\"Place file in Not sure where to this\"\n                    data-dojo-attach-event=\"click: onQuickRegisterClick\"\n                    class=\"sos-btn sos-btn-confirm sos-btn-icon sos-icon-folder-open\">Quick Register</button>\n        </div>\n        <div data-dojo-attach-point=\"elementForm\" class=\"hide\">\n            <div data-dojo-attach-point=\"elementRegistrationDetailsNode\"></div>\n\n            <div class=\"sos-alert-error hide\" data-dojo-attach-point=\"elementErrorMessageContainer\">\n                <div data-dojo-attach-point=\"elementErrorMessage\"></div>\n            </div>\n\n            <div data-dojo-attach-point=\"elementExtractedDataContainer\">\n                <div data-dojo-attach-point=\"elementExtractedData\"></div>\n            </div>\n\n            <div class=\"sos-form-pane-body-buttons\">\n                <button disabled data-dojo-attach-event=\"click: onRegisterClick\"\n                        data-dojo-attach-point=\"elementRegisterButton\"\n                        title=\"<%= formPaneTitle %>\"\n                        class=\"sos-btn sos-btn-confirm sos-btn-icon sos-icon-folder-open\"><%= formPaneTitle %></button>\n                <br />\n            </div>\n        </div>\n    </div>\n\n    <div data-dojo-attach-point=\"elementSoftLinkContainer\" class=\"hide\">\n        <p class=\"sos-alert-information-s\">\n            The uploaded file is <strong>already registered</strong>. See registration information below.\n            <br />\n            Optionally, use the form to create a soft link to the document.\n        </p>\n        <div data-dojo-attach-point=\"elementSoftLinkForm\"></div>\n    </div>\n</div>\n",
'url:doccontrol/extraction/management/template/DiagnosticTool.html':"<section class=\"diagnostic-tool\">\n    <section data-dojo-attach-point=\"elementSectionUploadFile\" hidden>\n        <h4 class=\"mt-0\">Upload File</h4>\n        <p class=\"sos-alert-information-s\">\n            Select a file which you wish to verify.\n            The file should contain a <strong>valid QR code</strong> relating to a <strong>template</strong> in the system.\n        </p>\n        <p class=\"sos-alert-error-s\" data-dojo-attach-point=\"elementFileSizeError\" hidden>\n            The file selected is too large.\n            File size must be smaller than <%= uploadLimitMegabytes %>mb.\n        </p>\n        <form data-dojo-attach-point=\"elementDiagnosticToolForm\">\n            <input data-dojo-attach-point=\"elementUploadField\" type=\"file\" />\n        </form>\n    </section>\n    <section data-dojo-attach-point=\"elementSectionResults\" hidden>\n        <a class=\"sos-anchor-back\" data-dojo-attach-event=\"click: onResetClick\" data-dojo-attach-point=\"elementReset\" >Upload another file</a>\n        <h4>Result</h4>\n        <table class=\"sos-table\">\n            <tr>\n                <th>Job</th>\n                <th>Status</th>\n            </tr>\n            <tr>\n                <td>File Upload</td>\n                <td>\n                    <span data-dojo-attach-point=\"elementStatusFileUploadIcon\"></span>\n                    <span data-dojo-attach-point=\"elementStatusFileUpload\">-</span>\n                </td>\n            </tr>\n            <tr>\n                <td>QR Code Scan</td>\n                <td>\n                    <span data-dojo-attach-point=\"elementStatusQRCodeScanningIcon\"></span>\n                    <span data-dojo-attach-point=\"elementStatusQRCodeScanning\">-</span>\n                </td>\n            </tr>\n            <tr>\n                <td>Verify QR Code Data</td>\n                <td>\n                    <span data-dojo-attach-point=\"elementStatusVerifyQRCodeDataIcon\"></span>\n                    <span data-dojo-attach-point=\"elementStatusVerifyQRCodeData\">-</span>\n                </td>\n            </tr>\n            <tr>\n                <td>Find Template</td>\n                <td>\n                    <span data-dojo-attach-point=\"elementStatusFindTemplateIcon\"></span>\n                    <span data-dojo-attach-point=\"elementStatusFindTemplate\">-</span>\n                    <span data-dojo-attach-point=\"elementStatusFoundTemplate\" hidden>\n                        <span data-dojo-attach-point=\"elementAnchorFoundTemplateContainer\">(<a data-dojo-attach-point=\"elementAnchorFoundTemplate\" target=\"_blank\"><span class=\"sos-icon sos-icon-external-link\">Manage Template</span></a>).</span>\n                    </span>\n                </td>\n            </tr>\n            <tr>\n                <td>Data Extraction</td>\n                <td>\n                    <span data-dojo-attach-point=\"elementStatusDataExtractionIcon\"></span>\n                    <span data-dojo-attach-point=\"elementStatusDataExtraction\">-</span>\n                </td>\n            </tr>\n        </table>\n    </section>\n    <section data-dojo-attach-point=\"elementSectionQRData\" hidden>\n        <h5>QR Data</h5>\n        <pre class=\"sos-well\" data-dojo-attach-point=\"elementQRContent\"></pre>\n    </section>\n    <section data-dojo-attach-point=\"elementSectionTroubleshootQR\" hidden>\n        <h5>Troubleshooting</h5>\n        <div class=\"sos-alert-information-s\">\n            <p>To ensure that the system reads the QR code correctly...</p>\n            <ul>\n                <li>Ensure the QR code is not too small</li>\n                <li>Ensure the QR code has a high resolution</li>\n                <li>The QR code should not be placed near or obstructed by other objects</li>\n                <li>Do not modify the QR code in any way apart from increasing it's size</li>\n            </ul>\n        </div>\n    </section>\n    <section data-dojo-attach-point=\"elementSectionExtractedData\" hidden>\n        <h5>Extracted Data</h5>\n        <div data-dojo-attach-point=\"elementExtractedData\"></div>\n    </section>\n    <section data-dojo-attach-point=\"elementSectionTroubleshootExtractedData\" hidden>\n        <h5>Troubleshooting</h5>\n        <div class=\"sos-alert-information-s\">\n            <p>To ensure that the system can accurately extract text via OCR...</p>\n            <ul>\n                <li>The text should be within the defined template field</li>\n                <li>Text must be legible, scanned documents can sometimes decrease the quality</li>\n                <li>The text should be a standard font</li>\n            </ul>\n        </div>\n    </section>\n</section>",
'url:style-guide/v1/doc-control/registration-details/DocumentRegister/template/ExtractedData.html':"<div class=\"extracted-data-container\">\n    <% if (showHeader) { %>\n        <h4>Extracted Data</h4>\n    <% } %>\n    <table class=\"sos-table\">\n        <thead>\n        <tr>\n            <th>Field</th>\n            <th class=\"value\">Value</th>\n            <% if (!disableViewer) { %>\n                <th>Definition</th>\n            <% } %>\n            <th class=\"sos-table-cell-align-center\">\n                <% if (metadataCollection.length == 0) { %>\n                    <a class=\"sos-icon sos-icon-arrow-down\" disabled>Show</a>\n                <% } else { %>\n                    <a class=\"sos-icon sos-icon-arrow-up hide-all-button hide\" data-dojo-attach-event=\"click: _collapseAll\">Hide</a>\n                    <a class=\"sos-icon sos-icon-arrow-down show-all-button\" data-dojo-attach-event=\"click: _expandAll\">Show</a>\n                <% } %>\n            </th>\n        </tr>\n        </thead>\n        <tbody>\n            <% if (metadataCollection.length) { %>\n                <% metadataCollection.forEach(function(metadata) { %>\n                    <tr>\n                        <td class=\"capitalise\"><%= metadata.getName() %></td>\n                        <td>\n                            <textarea data-dojo-attach-point=\"metadataValue_<%= metadata.getTemplateFieldPK() %>\"\n                                      class=\"sos-form-textarea\"><%= metadata.getValue() %></textarea>\n                        </td>\n                        <% if (!disableViewer) { %>\n                            <td class=\"sos-table-cell-align-center\">\n                                <a class=\"sos-icon sos-icon-eye\"\n                                   data-dojo-attach-event=\"click: _viewDefinition\"\n                                   data-id=\"<%= metadata.getTemplateFieldPK() %>\">View</a>\n                            </td>\n                        <% } %>\n                        <td class=\"sos-table-cell-align-center\">\n                            <a class=\"sos-icon sos-icon-arrow-up hide-button hide-button-<%= metadata.getTemplateFieldPK() %> hide\"\n                               data-id=\"<%= metadata.getTemplateFieldPK() %>\"\n                               data-dojo-attach-event=\"click: _collapseField\">Hide</a>\n                            <a class=\"sos-icon sos-icon-arrow-down show-button show-button-<%= metadata.getTemplateFieldPK() %>\"\n                               data-id=\"<%= metadata.getTemplateFieldPK() %>\"\n                               data-dojo-attach-event=\"click: _expandField\">Show</a>\n                        </td>\n                    </tr>\n                    <tr class=\"field-row field-row-<%= metadata.getTemplateFieldPK() %> hide\">\n                        <td class=\"extracted-field-preview-cell\" colspan=\"<%= disableViewer ? '3' : '4' %>\">\n                            <img class=\"extracted-field-preview\" src=\"<%= metadata.getImage() %>\">\n                        </td>\n                    </tr>\n                <% }); %>\n            <% } %>\n        </tbody>\n    </table>\n    <% if (metadataCollection.length == 0) { %>\n        <p class=\"sos-empty-state sos-empty-state-show\">\n            <span class=\"sos-icon sos-icon-file\">No Extracted data to show.</span>\n        </p>\n    <% } %>\n</div>",
'url:doccontrol/document/template/dojo/templates/DialogToolbar.html':"<div class=\"dialog-toolbar\">\n    <div data-dojo-attach-point=\"fileTypeContainer\"></div>\n    <div class=\"view-title-container\">\n        <div><%= document.getTitle() %></div>\n    </div>\n</div>",
'url:doccontrol/document/template/dojo/templates/TemplateField.html':"<tr>\n    <td data-dojo-attach-point=\"name\"><%= name.label %></td>\n    <td class=\"text-align-center\"><a class=\"sos-icon sos-icon-pencil\" data-dojo-attach-event=\"click: edit\">Edit</a></td>\n    <td class=\"text-align-center\"><a class=\"sos-icon sos-icon-trash\" data-dojo-attach-event=\"click: delete\">Delete</a></td>\n</tr>",
'url:doccontrol/document/template/dojo/templates/TemplateFieldReadOnly.html':"<tr>\n    <td data-dojo-attach-point=\"name\"><%= name.label %></td>\n    <td class=\"text-align-center\"><a class=\"sos-icon sos-icon-eye\" data-dojo-attach-event=\"click: view\">View</a></td>\n</tr>",
'url:doccontrol/document/template/dojo/templates/TemplateForm.html':"<div class=\"field-form hidden\">\n    <h1>Define Field</h1>\n    <div data-dojo-attach-point=\"ocrContainer\"></div>\n\n    <div class=\"mb-12\">\n        <label class=\"field-label sos-label-optional mx-0\">Field Preset</label>\n        <input data-dojo-attach-point=\"elementPresetField\" type=\"text\" />\n        <p class=\"sos-alert-information-s my-12\" data-dojo-attach-point=\"elementPresetFieldDescription\" hidden></p>\n    </div>\n\n    <p data-dojo-attach-point=\"elementFieldNameContainer\">\n        <label class=\"field-label mx-0\">Field Name</label>\n        <input data-dojo-attach-point=\"fieldName\" type=\"text\" />\n    </p>\n\n    <p data-dojo-attach-point=\"elementFieldTypeContainer\">\n        <label class=\"field-label mx-0\">Field Type</label>\n        <input data-dojo-attach-point=\"fieldType\" type=\"text\" />\n    </p>\n\n    <p data-dojo-attach-point=\"missingSelectionError\" class=\"sos-alert-error-s my-12 hidden\">\n        Make sure you have selected a region of the document for the corresponding field.\n    </p>\n\n    <div class=\"confirmation-container\">\n        <button data-dojo-attach-event=\"click: cancel\" class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-close m-0\">Cancel</button>\n        <button data-dojo-attach-event=\"click: confirm\" class=\"sos-btn sos-btn-confirm sos-btn-icon sos-icon-pencil-paper m-0\">Confirm</button>\n    </div>\n</div>",
'url:ocr/dojo/template/Processor.html':"<div class=\"sos-v1 sos-ocr-capture\">\n    <div data-dojo-attach-point=\"progressContainer\" class=\"sos-well mb-12 hidden\">\n        <span data-dojo-attach-point=\"progressText\" class=\"progress-text\">Initialising...</span>\n        <progress data-dojo-attach-point=\"progressBar\"></progress>\n    </div>\n\n    <p data-dojo-attach-point=\"confidenceNotification\" class=\"sos-alert-warning-s my-12\">\n        If the recognised text is not accurate, try using the <strong>zoom</strong> buttons and selecting the region again.\n    </p>\n\n    <div data-dojo-attach-point=\"selectedAreaContainer\" class=\"selected-area-container mb-12 hidden\">\n        <label class=\"mx-0\">Selected Area Preview</label>\n        <canvas data-dojo-attach-point=\"target\" class=\"target\"></canvas>\n    </div>\n    <div data-dojo-attach-point=\"extractedContentContainer\" class=\"extracted-content-container mb-12 hidden\">\n        <label class=\"mx-0\">Extracted Content</label>\n        <textarea data-dojo-attach-point=\"result\" class=\"sos-form-textarea\"></textarea>\n        <button data-dojo-attach-point=\"copyBtn\" class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-files-copy\">Copy to Clipboard</button>\n        <br />\n    </div>\n</div>",
'url:dijit/templates/Menu.html':"<table class=\"dijit dijitMenu dijitMenuPassive dijitReset dijitMenuTable\" role=\"menu\" tabIndex=\"${tabIndex}\"\n\t   cellspacing=\"0\">\n\t<tbody class=\"dijitReset\" data-dojo-attach-point=\"containerNode\"></tbody>\n</table>\n",
'url:dijit/templates/MenuItem.html':"<tr class=\"dijitReset\" data-dojo-attach-point=\"focusNode\" role=\"menuitem\" tabIndex=\"-1\">\n\t<td class=\"dijitReset dijitMenuItemIconCell\" role=\"presentation\">\n\t\t<span role=\"presentation\" class=\"dijitInline dijitIcon dijitMenuItemIcon\" data-dojo-attach-point=\"iconNode\"></span>\n\t</td>\n\t<td class=\"dijitReset dijitMenuItemLabel\" colspan=\"2\" data-dojo-attach-point=\"containerNode,textDirNode\"\n\t\trole=\"presentation\"></td>\n\t<td class=\"dijitReset dijitMenuItemAccelKey\" style=\"display: none\" data-dojo-attach-point=\"accelKeyNode\"></td>\n\t<td class=\"dijitReset dijitMenuArrowCell\" role=\"presentation\">\n\t\t<span data-dojo-attach-point=\"arrowWrapper\" style=\"visibility: hidden\">\n\t\t\t<span class=\"dijitInline dijitIcon dijitMenuExpand\"></span>\n\t\t\t<span class=\"dijitMenuExpandA11y\">+</span>\n\t\t</span>\n\t</td>\n</tr>\n",
'url:dijit/templates/MenuSeparator.html':"<tr class=\"dijitMenuSeparator\" role=\"separator\">\n\t<td class=\"dijitMenuSeparatorIconCell\">\n\t\t<div class=\"dijitMenuSeparatorTop\"></div>\n\t\t<div class=\"dijitMenuSeparatorBottom\"></div>\n\t</td>\n\t<td colspan=\"3\" class=\"dijitMenuSeparatorLabelCell\">\n\t\t<div class=\"dijitMenuSeparatorTop dijitMenuSeparatorLabel\"></div>\n\t\t<div class=\"dijitMenuSeparatorBottom\"></div>\n\t</td>\n</tr>\n",
'url:dijit/form/templates/Select.html':"<table class=\"dijit dijitReset dijitInline dijitLeft\"\n\tdata-dojo-attach-point=\"_buttonNode,tableNode,focusNode,_popupStateNode\" cellspacing='0' cellpadding='0'\n\trole=\"listbox\" aria-haspopup=\"true\"\n\t><tbody role=\"presentation\"><tr role=\"presentation\"\n\t\t><td class=\"dijitReset dijitStretch dijitButtonContents\" role=\"presentation\"\n\t\t\t><div class=\"dijitReset dijitInputField dijitButtonText\"  data-dojo-attach-point=\"containerNode,textDirNode\" role=\"presentation\"></div\n\t\t\t><div class=\"dijitReset dijitValidationContainer\"\n\t\t\t\t><input class=\"dijitReset dijitInputField dijitValidationIcon dijitValidationInner\" value=\"&#935; \" type=\"text\" tabIndex=\"-1\" readonly=\"readonly\" role=\"presentation\"\n\t\t\t/></div\n\t\t\t><input type=\"hidden\" ${!nameAttrSetting} data-dojo-attach-point=\"valueNode\" value=\"${value}\" aria-hidden=\"true\"\n\t\t/></td\n\t\t><td class=\"dijitReset dijitRight dijitButtonNode dijitArrowButton dijitDownArrowButton dijitArrowButtonContainer\"\n\t\t\tdata-dojo-attach-point=\"titleNode\" role=\"presentation\"\n\t\t\t><input class=\"dijitReset dijitInputField dijitArrowButtonInner\" value=\"&#9660; \" type=\"text\" tabIndex=\"-1\" readonly=\"readonly\" role=\"presentation\"\n\t\t\t\t${_buttonInputDisabled}\n\t\t/></td\n\t></tr></tbody\n></table>\n",
'url:style-guide/v1/forms/searchable-select/template/Result.html':"<div class=\"result\" data-dojo-attach-event=\"click: _onClick\">\n    <% text = searchAttr instanceof Function ? searchAttr(result) : result[searchAttr]; %>\n\n    <% if(icon) { %>\n        <span class=\"sos-icon sos-icon-<%= icon instanceof Function ? icon(result) : icon; %>\"></span>\n    <% } %>\n\n    <div title=\"<%= text; %>\" class=\"text-container\" data-dojo-attach-point=\"textContainer\">\n        <%= text %>\n    </div>\n</div>",
'url:style-guide/v1/forms/searchable-select/template/Menu.html':"<div class=\"sos-form-searchable-select-menu\">\n    <div data-dojo-attach-event=\"scroll: _scroll\" class=\"scrollable-container\" data-dojo-attach-point=\"scrollableContainer\">\n        <div class=\"results\" data-dojo-attach-point=\"resultsContainer\"></div>\n        <div class=\"loading-container loading\" data-dojo-attach-point=\"loadingContainer\">\n            <span class=\"loading-text\">Loading results...</span>\n        </div>\n    </div>\n\n    <div data-dojo-attach-point=\"noResultsFound\" class=\"no-results-found\">\n        <span>No results found</span>\n    </div>\n</div>",
'url:style-guide/v1/forms/searchable-select/template/Selector.html':"<div class=\"sos-form-searchable-select sos-form-textfield-validation\">\n    <input type=\"search\" data-dojo-attach-point=\"valueField\" data-dojo-attach-event=\"input: _search, onblur: _onBlur, onfocus: _onFocus\" class=\"sos-form-textfield sos-form-textfield-with-suffix\" value=\"\" placeholder=\"Filter...\"/>\n    <div class=\"sos-form-searchable-select-error-icon\">\n        <span class=\"sos-icon sos-icon-error\"></span>\n    </div>\n    <label data-dojo-attach-event=\"click: _toggleMenu\" data-dojo-attach-point=\"dropDownElement\" class=\"sos-form-textfield-suffix\">\n        <span class=\"sos-icon sos-icon-chevron-down\"></span>\n    </label>\n    <div class=\"sos-form-textfield-validation-tag\"></div>\n    <label data-dojo-attach-point=\"validationPrompt\" class=\"sos-form-textfield-validation-prompt\">This field is required</label>\n    <div data-dojo-attach-point=\"menuElement\"></div>\n</div>",
'url:doccontrol/document/template/dojo/templates/Templater.html':"<div class=\"template-container\">\n    <div data-dojo-attach-point=\"fieldContainer\" class=\"field-container\">\n        <h1>Fields</h1>\n        <table class=\"sos-table\">\n            <thead>\n                <tr>\n                    <th>Name</th>\n                    <th colspan=\"2\">Actions</th>\n                </tr>\n            </thead>\n            <tbody data-dojo-attach-point=\"tableBody\">\n            </tbody>\n        </table>\n        <p data-dojo-attach-point=\"intialState\" class=\"sos-empty-state sos-empty-state-show\">\n            <span>Loading fields...</span>\n        </p>\n        <p data-dojo-attach-point=\"emptyState\" class=\"sos-empty-state\">\n            <span>No fields defined.<br /><a data-dojo-attach-event=\"click: defineField\" class=\"sos-icon sos-icon-magic\">Define a field</a></span>\n        </p>\n        <p data-dojo-attach-point=\"emptyStateReadOnly\" class=\"sos-empty-state\">\n            <span>No fields defined.</span>\n        </p>\n        <p data-dojo-attach-point=\"defineAnother\" class=\"define-another hidden\">\n            <button data-dojo-attach-event=\"click: defineField\" class=\"sos-btn sos-btn-s sos-btn-secondary sos-icon sos-icon-plus m-0\">Define Field</button>\n        </p>\n    </div>\n\n    <div data-dojo-attach-point=\"fieldForm\"></div>\n</div>",
'url:doccontrol/document/template/dojo/templates/ViewerDialog.html':"<div class=\"dijitDialog sos-v1 sos-layout-dialog document-viewer-dialog document-template-dialog\" role=\"dialog\" data-dojo-attach-point=\"allContent\" aria-labelledby=\"${id}_title\">\n    <div class=\"dialogTemplateContainer\">\n        <div class=\"main-tools-container\">\n            <div class=\"document-viewer-tools\">\n                <div data-dojo-attach-point=\"dialogToolbarNode\" class=\"dialog-toolbar-container\"></div>\n                <a class=\"sos-layout-dialog-close-button\" data-dojo-attach-point=\"closeButtonNode\" tabindex=\"1\" data-dojo-attach-event=\"click: hideViewer\">\n                    <div class=\"button-container\">\n                        <span class=\"sos-icon sos-icon-close\">Close</span>\n                    </div>\n                </a>\n            </div>\n        </div>\n\n        <div data-dojo-attach-point=\"containerNode\" class=\"sos-layout-dialog-content-container dijitDialogPaneContent\">\n            <div class=\"sos-layout-dialog-content\" data-dojo-attach-point=\"dialogContent\">\n                <div data-dojo-attach-point=\"viewOptionsToolbarNode\"></div>\n                <div data-dojo-attach-point=\"loadingContainer\" class=\"loading-container twelve columns centered first last\">\n                    <div data-dojo-attach-point=\"passwordForm\" class=\"hidden password-form\">\n                        This document cannot be viewed without the correct password.<br />\n                        <div data-dojo-attach-point=\"passwordInputValidationContainer\" class=\"sos-form-textfield-validation\">\n                            <input class=\"sos-form-textfield\" type=\"password\" autocomplete=\"off\" aria-autocomplete=\"none\" data-dojo-attach-point=\"passwordInput\" />\n                            <div class=\"sos-form-textfield-validation-tag\"></div>\n                            <br />\n                            <label data-dojo-attach-point=\"passwordPrompt\" class=\"sos-form-textfield-validation-prompt\"></label>\n                        </div>\n                        <button class=\"sos-btn sos-btn-secondary\" data-dojo-attach-event=\"click:_setPassword\">Submit</button>\n                    </div>\n\n                    <p data-dojo-attach-point=\"loading\" class=\"loading-state\">\n                        <span class=\"sos-icon sos-icon-animation-spin-smooth sos-icon-refresh\"></span>\n                        <br />\n                        Loading...\n                    </p>\n\n                    <p data-dojo-attach-point=\"unauthorisedMessage\" class=\"hidden error-message\">\n                        You do not have permission to view this document.\n                    </p>\n\n                    <p data-dojo-attach-point=\"networkErrorMessage\" class=\"hidden error-message\">\n                        Sorry, this document cannot be opened.<br />\n                        This may be caused by a network issue, please check your network connection and try again.<br />\n                        If this problem persists, please contact the helpdesk.\n                    </p>\n\n                    <p data-dojo-attach-point=\"renderErrorMessage\" class=\"hidden error-message\">\n                        Sorry, this document cannot be opened.<br />\n                        If this document can be opened on your computer/device please contact the helpdesk for further investigation.\n                    </p>\n\n                    <p data-dojo-attach-point=\"deletedMessage\" class=\"hidden error-message\">\n                        Sorry, you cannot view this document as it has been deleted.\n                    </p>\n                </div>\n\n                <div data-dojo-attach-point=\"rendering\" class=\"rendering-container hidden\">\n                    <div class=\"rendering-state\">\n                        <span class=\"sos-icon sos-icon-animation-spin-smooth sos-icon-refresh\"></span>\n                        <br />\n                        <br />\n                        <span>Rendering...</span>\n                    </div>\n                </div>\n\n                <div class=\"content-container invisible\" data-dojo-attach-point=\"contentContainer\">\n                    <div class=\"scroll-container\" data-dojo-attach-point='scrollContainer'>\n                        <div class=\"document-workspace\" data-dojo-attach-point=\"documentWorkspace\">\n                            <div class=\"document\" data-dojo-attach-point=\"documentNode\"></div>\n                        </div>\n                    </div>\n\n                    <div class=\"sos-layout-dialog-footer-container footer-grid-layout\" data-dojo-attach-point=\"navigationFooter\">\n                        <div>\n                            <button data-dojo-attach-event=\"click: _previous\"\n                               class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-previous-page\"\n                               disabled\n                               data-dojo-attach-point=\"previousButton\">Previous</button>\n                        </div>\n                        <div class=\"count-container\">\n                            <div>\n                                <span>Page:</span>\n                                <div data-dojo-attach-point=\"pageInputNode\"></div>/ <span data-dojo-attach-point=\"pageCount\"></span>\n                            </div>\n                        </div>\n                        <div>\n                            <button data-dojo-attach-event=\"click: _next\"\n                               class=\"sos-btn sos-btn-secondary sos-btn-icon-after sos-icon-next-page-after\"\n                               disabled\n                               data-dojo-attach-point=\"nextButton\">Next</button>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n            <div data-dojo-attach-point=\"templaterNode\"></div>\n        </div>\n        ${!actionBarTemplate}\n    </div>\n</div>\n",
'url:dijit/templates/Dialog.html':"<div class=\"dijitDialog\" role=\"dialog\" aria-labelledby=\"${id}_title\">\n\t<div data-dojo-attach-point=\"titleBar\" class=\"dijitDialogTitleBar\">\n\t\t<span data-dojo-attach-point=\"titleNode\" class=\"dijitDialogTitle\" id=\"${id}_title\"\n\t\t\t\trole=\"heading\" level=\"1\"></span>\n\t\t<span data-dojo-attach-point=\"closeButtonNode\" class=\"dijitDialogCloseIcon\" data-dojo-attach-event=\"ondijitclick: onCancel\" title=\"${buttonCancel}\" role=\"button\" tabindex=\"-1\">\n\t\t\t<span data-dojo-attach-point=\"closeText\" class=\"closeText\" title=\"${buttonCancel}\">x</span>\n\t\t</span>\n\t</div>\n\t<div data-dojo-attach-point=\"containerNode\" class=\"dijitDialogPaneContent\"></div>\n\t${!actionBarTemplate}\n</div>\n\n",
'url:doccontrol/document/template/dojo/templates/ViewToolbar.html':"<div class=\"view-options-container row hidden\">\n    <div class=\"document-viewer-tools\">\n        <div class=\"zoom-count-container\">\n            <div data-dojo-attach-point=\"zoomInput\"></div>\n            <label class=\"sos-form-textfield-suffix sos-form-textfield-suffix-s\">%</label>\n        </div>\n        <div class=\"button-container\" data-dojo-attach-event=\"click: zoomIn\" data-dojo-attach-point=\"zoomInBtn\">\n            <span class=\"sos-icon sos-icon-search-plus\">Zoom In</span>\n        </div>\n        <div class=\"button-container\" data-dojo-attach-event=\"click: zoomOut\"  data-dojo-attach-point=\"zoomOutBtn\">\n            <span class=\"sos-icon sos-icon-search-minus\">Zoom out</span>\n        </div>\n        <div class=\"button-container\" data-dojo-attach-event=\"click: fitWidth\"  data-dojo-attach-point=\"fitWidthBtn\">\n            <span class=\"sos-icon sos-icon-arrows-horizontal\">Fit Width</span>\n        </div>\n        <div class=\"button-container\" data-dojo-attach-event=\"click: fitPage\"  data-dojo-attach-point=\"fitPageBtn\">\n            <span class=\"sos-icon sos-icon-arrows-alt\">Fit Page</span>\n        </div>\n        <div class=\"button-container\" data-dojo-attach-event=\"click: rotate\" data-dojo-attach-point=\"rotateBtn\">\n            <span class=\"sos-icon sos-icon-rotate-right\">Rotate</span>\n        </div>\n    </div>\n</div>",
'url:style-guide/v1/forms/templates/FileDragDropLimitSummary.html':"<p>\n    <% if (fileCount == 0) { %>\n        <% if (attachmentCountLimit > 1) { %>\n            There are <b>no <%= fileLabel %>s</b>.\n            You can attach up to <b><%= attachmentCountLimit %> <%= fileLabel %>s</b>\n        <% } else { %>\n            You can add a single file\n        <% } %>\n        with a <b><%= uploadMegabytesLimit %>MB</b> limit.\n    <% } else { %>\n        <% if (fileCount == 1) { %>\n            There is <b>1 <%= fileLabel %></b>.\n        <% } else { %>\n            There are <b><%= fileCount %> <%= fileLabel %>>s</b>.\n        <% } %>\n\n        <% if (fileCount == attachmentCountLimit) { %>\n            You have reached the <%= fileLabel %> count limit.\n        <% } else { %>\n            You can attach <b><%= remainingFileCount %></b> more\n            out of <%= attachmentCountLimit %> files with a <b><%= uploadMegabytesLimit %>MB</b> limit.\n        <% } %>\n    <% } %>\n    <% if (dragDropEnabled) { %>\n        <br />\n        Drag & Drop file<%= attachmentCountLimit == 1 ? '' : 's' %> here or use the 'Add <%= capitalise(fileLabel) %>s' button to browse & attach.\n    <% } %>\n</p>",
'url:style-guide/v1/forms/templates/FileDragDropTableRow.html':"<tr>\n    <td>\n        <% if (uploaded) { %>\n            <span class=\"sos-icon sos-icon-check\"><%= statusMessageUploaded %></span>\n        <% } else { %>\n            <span class=\"sos-icon sos-icon-list-ul\">Added to upload queue</span>\n        <% } %>\n    </td>\n    <td>\n        <%= name %>\n    </td>\n    <td class=\"sos-table-cell-align-right\">\n        <% if (filenameToExtension.parse(name)) { %>\n            .<%= filenameToExtension.parse(name).toUpperCase() %>\n        <% } %>\n        <span class=\"sos-icon <%= fileToIconClass.getClass({ type: type }) %>\"></span>\n    </td>\n    <td class=\"sos-table-cell-align-right\">\n        <%= megabytes.format(size) %>\n    </td>\n    <td class=\"sos-table-cell-align-center\">\n        <a data-dojo-attach-point=\"removeAttachmentButton\" class=\"sos-icon sos-icon-close\">Remove</a>\n    </td>\n</tr>",
'url:style-guide/v1/forms/templates/FileDragDrop.html':"<div class=\"sos-form-file-drag-drop <%= hideFormMode ? 'button-only-mode' : '' %>\">\n    <% if (hideFormMode) { %>\n        <input data-dojo-attach-point=\"fileInput\" type=\"file\" multiple />\n\n        <button data-dojo-attach-point=\"addAttachmentsInput\"\n                title=\"Add <%= capitalise(fileLabel) %>\"\n                class=\"sos-btn <%= smallButtons ? 'sos-btn-s' : '' %> sos-btn-secondary sos-btn-icon sos-icon-plus <%= hideButtonMode ? 'hide' : '' %>\">Add <%= capitalise(fileLabel) %><%= uploadLimitAttachmentCount > 1 ? 's' : '' %></button>\n    <% } else { %>\n        <div class=\"sos-form-file-drag-drop-form\">\n            <div class=\"sos-form-file-drag-drop-form-area\">\n                <div data-dojo-attach-point=\"dragDropArea\" class=\"sos-form-file-drag-drop-form-area-prompt <%= dragDropEnabled ? 'enabled' : 'disabled' %>\">\n                    <div class=\"sos-icon sos-icon-upload\"></div>\n                    <div data-dojo-attach-point=\"limitSummary\"></div>\n                </div>\n                <input data-dojo-attach-point=\"fileInput\" type=\"file\" <%= uploadLimitAttachmentCount > 1 ? 'multiple' : '' %> />\n            </div>\n\n            <button data-dojo-attach-point=\"addAttachmentsInput\"\n                    title=\"Add <%= capitalise(fileLabel) %>s\"\n                    class=\"sos-btn <%= smallButtons ? 'sos-btn-s' : '' %> sos-btn-secondary sos-btn-icon sos-icon-plus <%= hideButtonMode ? 'hide' : '' %>\">Add <%= capitalise(fileLabel) %><%= uploadLimitAttachmentCount > 1 ? 's' : '' %></button>\n        </div>\n    <% } %>\n\n    <div data-dojo-attach-point=\"tableHeader\" class=\"sos-form-file-drag-drop-table-header <%= uploadLimitAttachmentCount == 1 ? 'hide' : ''%>\">\n        <button data-dojo-attach-point=\"clearAttachmentsInput\" title=\"Clear <%= capitalise(fileLabel) %>s\" class=\"sos-btn sos-btn-negative mx-0\" disabled>Clear <%= capitalise(fileLabel) %>s</button>\n    </div>\n\n    <table data-dojo-attach-point=\"table\" class=\"sos-table sos-form-file-drag-drop-table\">\n        <thead>\n            <tr>\n                <th>Status</th>\n                <th>Document Title</th>\n                <th class=\"sos-table-header-align-right\">File Type</th>\n                <th class=\"sos-table-header-align-right\">Document Size</th>\n                <th></th>\n            </tr>\n        </thead>\n        <tbody data-dojo-attach-point=\"existingFilesTableBody\">\n        </tbody>\n        <tbody data-dojo-attach-point=\"newFilesTableBody\">\n        </tbody>\n    </table>\n</div>\n",
'url:style-guide/v1/doc-control/registration-details/template/RegistrationDetails.html':"<div class=\"registration-details\">\n    <div data-dojo-attach-point=\"extractContentNode\"></div>\n    <div data-dojo-attach-point=\"elementForm\"></div>\n</div>",
'url:style-guide/v1/doc-control/registration-details/template/Correspondence.html':"<div class=\"sos-form-default-node sos-form-prioritise-required\">\n    <h4>Document Information</h4>\n    <label class=\"sos-label-required\">Title / Name / Subject</label>\n    <br />\n    <div data-dojo-attach-point=\"elementTitleValidation\" class=\"sos-form-textfield-validation\">\n        <input class=\"sos-form-textfield\" type=\"text\" data-dojo-attach-point=\"elementInputTitle\"/>\n        <div class=\"sos-form-textfield-validation-tag\"></div>\n        <br />\n        <label class=\"sos-form-textfield-validation-prompt\">Title is required</label>\n    </div>\n    <br />\n    <label class=\"sos-label-required\">Document Reference Number</label>\n    <br />\n    <div data-dojo-attach-point=\"elementReferenceValidation\" class=\"sos-form-textfield-validation\">\n        <input class=\"sos-form-textfield\" type=\"text\" data-dojo-attach-point=\"elementInputReference\"/>\n        <div class=\"sos-form-textfield-validation-tag\"></div>\n        <br />\n        <label class=\"sos-form-textfield-validation-prompt\" data-dojo-attach-point=\"elementReferenceError\">Document Reference Number is required</label>\n    </div>\n    <br />\n    <label class=\"sos-label-required\">Relevant / Event Date</label>\n    <br />\n    <input class=\"sos-form-textfield\" type=\"text\" data-dojo-attach-point=\"elementInputDate\"/>\n    <br />\n    <div data-dojo-attach-point=\"privacyToggle\" class=\"hide\">\n        <label class=\"sos-form-checkbox sos-label-optional\">Private <i>(Show this document to only people I select)</i>\n            <input data-dojo-attach-point=\"elementInputIsPrivate\" type=\"checkbox\" /><span></span>\n        </label>\n    </div>\n\n    <h4>Registration Information</h4>\n    <label class=\"sos-label-required\">Document Originator</label>\n    <a class=\"set-to-me\" data-dojo-attach-point=\"setToMeElement\" data-dojo-attach-event=\"click: _setOriginatorToCurrentPerson\">Set to me</a>\n    <br />\n    <div data-dojo-attach-point=\"elementInputOriginator\"></div>\n    <br />\n    <label>Recipient</label>\n    <br />\n    <div data-dojo-attach-point=\"elementInputRecipient\"></div>\n</div>",
'url:dijit/templates/Calendar.html':"<div class=\"dijitCalendarContainer dijitInline\" role=\"presentation\" aria-labelledby=\"${id}_mddb ${id}_year\">\n\t<div class=\"dijitReset dijitCalendarMonthContainer\" role=\"presentation\">\n\t\t<div class='dijitReset dijitCalendarArrow dijitCalendarDecrementArrow' data-dojo-attach-point=\"decrementMonth\">\n\t\t\t<img src=\"${_blankGif}\" alt=\"\" class=\"dijitCalendarIncrementControl dijitCalendarDecrease\" role=\"presentation\"/>\n\t\t\t<span data-dojo-attach-point=\"decreaseArrowNode\" class=\"dijitA11ySideArrow\">-</span>\n\t\t</div>\n\t\t<div class='dijitReset dijitCalendarArrow dijitCalendarIncrementArrow' data-dojo-attach-point=\"incrementMonth\">\n\t\t\t<img src=\"${_blankGif}\" alt=\"\" class=\"dijitCalendarIncrementControl dijitCalendarIncrease\" role=\"presentation\"/>\n\t\t\t<span data-dojo-attach-point=\"increaseArrowNode\" class=\"dijitA11ySideArrow\">+</span>\n\t\t</div>\n\t\t<div data-dojo-attach-point=\"monthNode\" class=\"dijitInline\"></div>\n\t</div>\n\t<table cellspacing=\"0\" cellpadding=\"0\" role=\"grid\" data-dojo-attach-point=\"gridNode\">\n\t\t<thead>\n\t\t\t<tr role=\"row\">\n\t\t\t\t${!dayCellsHtml}\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody data-dojo-attach-point=\"dateRowsNode\" data-dojo-attach-event=\"ondijitclick: _onDayClick\" class=\"dijitReset dijitCalendarBodyContainer\">\n\t\t\t\t${!dateRowsHtml}\n\t\t</tbody>\n\t</table>\n\t<div class=\"dijitReset dijitCalendarYearContainer\" role=\"presentation\">\n\t\t<div class=\"dijitCalendarYearLabel\">\n\t\t\t<span data-dojo-attach-point=\"previousYearLabelNode\" class=\"dijitInline dijitCalendarPreviousYear\" role=\"button\"></span>\n\t\t\t<span data-dojo-attach-point=\"currentYearLabelNode\" class=\"dijitInline dijitCalendarSelectedYear\" role=\"button\" id=\"${id}_year\"></span>\n\t\t\t<span data-dojo-attach-point=\"nextYearLabelNode\" class=\"dijitInline dijitCalendarNextYear\" role=\"button\"></span>\n\t\t</div>\n\t</div>\n</div>\n",
'url:dijit/form/templates/DropDownButton.html':"<span class=\"dijit dijitReset dijitInline\"\n\t><span class='dijitReset dijitInline dijitButtonNode'\n\t\tdata-dojo-attach-event=\"ondijitclick:__onClick\" data-dojo-attach-point=\"_buttonNode\"\n\t\t><span class=\"dijitReset dijitStretch dijitButtonContents\"\n\t\t\tdata-dojo-attach-point=\"focusNode,titleNode,_arrowWrapperNode,_popupStateNode\"\n\t\t\trole=\"button\" aria-haspopup=\"true\" aria-labelledby=\"${id}_label\"\n\t\t\t><span class=\"dijitReset dijitInline dijitIcon\"\n\t\t\t\tdata-dojo-attach-point=\"iconNode\"\n\t\t\t></span\n\t\t\t><span class=\"dijitReset dijitInline dijitButtonText\"\n\t\t\t\tdata-dojo-attach-point=\"containerNode\"\n\t\t\t\tid=\"${id}_label\"\n\t\t\t></span\n\t\t\t><span class=\"dijitReset dijitInline dijitArrowButtonInner\"></span\n\t\t\t><span class=\"dijitReset dijitInline dijitArrowButtonChar\">&#9660;</span\n\t\t></span\n\t></span\n\t><input ${!nameAttrSetting} type=\"${type}\" value=\"${value}\" class=\"dijitOffScreen\" tabIndex=\"-1\"\n\t\tdata-dojo-attach-event=\"onclick:_onClick\" data-dojo-attach-point=\"valueNode\" aria-hidden=\"true\"\n/></span>\n",
'url:style-guide/v1/doc-control/registration-details/template/Default.html':"<div class=\"sos-form-default-node sos-form-prioritise-required\">\n    <h4>Document Information</h4>\n    <label class=\"sos-label-required\">Document Originator</label>\n    <a class=\"set-to-me\" data-dojo-attach-point=\"setToMeElement\" data-dojo-attach-event=\"click: _setOriginatorToCurrentPerson\">Set to me</a>\n    <br />\n    <div data-dojo-attach-point=\"elementInputOriginator\"></div>\n    <br />\n    <label class=\"sos-label-required\">Title</label>\n    <br />\n    <div data-dojo-attach-point=\"elementTitleValidation\" class=\"sos-form-textfield-validation\">\n        <input class=\"sos-form-textfield\" type=\"text\" data-dojo-attach-point=\"elementInputTitle\"/>\n        <div class=\"sos-form-textfield-validation-tag\"></div>\n        <br />\n        <label class=\"sos-form-textfield-validation-prompt\">Title is required</label>\n    </div>\n    <br />\n    <label class=\"sos-label-required\">Event Date</label>\n    <br />\n    <input class=\"sos-form-textfield\" type=\"text\" data-dojo-attach-point=\"elementInputDate\"/>\n    <br />\n\n    <div data-dojo-attach-point=\"privacyToggle\" class=\"hide\">\n        <label class=\"sos-form-checkbox sos-label-optional\">Private <i>(Show this document to only people I select)</i>\n            <input data-dojo-attach-point=\"elementInputIsPrivate\" type=\"checkbox\" /><span></span>\n        </label>\n    </div>\n</div>",
'url:style-guide/v1/doc-control/registration-details/template/Drawing.html':"<div class=\"sos-form-default-node sos-form-prioritise-required\">\n    <h4>Document Information</h4>\n    <label class=\"sos-label-required\">Title / Name / Subject</label>\n    <br />\n    <div data-dojo-attach-point=\"elementTitleValidation\" class=\"sos-form-textfield-validation\">\n        <input class=\"sos-form-textfield\"\n               type=\"text\"\n               data-dojo-attach-point=\"elementInputTitle\"\n               data-dojo-attach-event=\"keyup: _validateTitle\" />\n        <div class=\"sos-form-textfield-validation-tag\"></div>\n        <br />\n        <label class=\"sos-form-textfield-validation-prompt\">Title is required</label>\n    </div>\n    <br />\n    <label class=\"sos-label-required\">Document Reference Number</label>\n    <br />\n    <div data-dojo-attach-point=\"elementReferenceValidation\" data-dojo-attach-event=\"input: _onReferenceInput\" class=\"sos-form-textfield-validation\">\n        <input class=\"sos-form-textfield\"\n               type=\"text\"\n               data-dojo-attach-point=\"elementInputReference\"\n               data-dojo-attach-event=\"keyup: _validateReference\"/>\n        <div class=\"sos-form-textfield-validation-tag\"></div>\n        <br />\n        <label class=\"sos-form-textfield-validation-prompt\" data-dojo-attach-point=\"elementReferenceError\">Document Reference Number is required</label>\n    </div>\n    <p class=\"sos-alert-information-s alert-validation hide\" data-dojo-attach-point=\"elementReferenceExists\">\n        A revision with the provided reference already exists in the selected folder\n        <a data-dojo-attach-event=\"click: _onViewExistingClick\">View Existing</a>\n    </p>\n    <p class=\"sos-alert-error-s alert-validation hide\" data-dojo-attach-point=\"elementReferenceHasPrivateRevision\">\n        A private document already exists in the selected folder for the given reference. This cannot be revised on the current interface. A document controller can assist with revising the existing document\n        <a class=\"hide\" data-dojo-attach-point=\"elementProjectListingLinkAnchor\" target=\"_blank\"> via Office Overview</a>.\n    </p>\n    <br />\n    <label class=\"sos-label-required\">Discipline</label>\n    <br />\n    <select data-dojo-attach-point=\"elementDisciplineSelect\"></select>\n    <br />\n    <label class=\"sos-label-required\">Date Sent</label>\n    <br />\n    <input class=\"sos-form-textfield\" type=\"text\" data-dojo-attach-point=\"elementInputDate\"/>\n    <br />\n    <div data-dojo-attach-point=\"privacyToggle\" class=\"hide\">\n        <label class=\"sos-form-checkbox sos-label-optional\">Private <i>(Show this document to only people I select)</i>\n            <input data-dojo-attach-point=\"elementInputIsPrivate\" type=\"checkbox\" /><span></span>\n        </label>\n    </div>\n\n    <h4>Revision Information</h4>\n    <label class=\"sos-label-required\">Revision Number</label>\n    <br />\n    <div data-dojo-attach-point=\"elementRevisionValidation\" class=\"sos-form-textfield-validation\">\n        <input class=\"sos-form-textfield\"\n               type=\"text\"\n               data-dojo-attach-point=\"elementInputRevision\"\n               data-dojo-attach-event=\"input: _validateRevision\" />\n        <div class=\"sos-form-textfield-validation-tag\"></div>\n        <br />\n        <label data-dojo-attach-point=\"elementRevisionNumberError\" class=\"sos-form-textfield-validation-prompt\">\n            Revision Number is required\n        </label>\n    </div>\n    <p class=\"sos-alert-error-s alert-validation hide\" data-dojo-attach-point=\"elementRevisionExists\">\n        A revision with the provided reference and revision number already exists in the selected folder\n        <a data-dojo-attach-event=\"click: _onViewExistingClick\">View Existing</a>\n    </p>\n    <br />\n    <label class=\"sos-label-required\">Current Status</label>\n    <br />\n    <select data-dojo-attach-point=\"elementStatusSelect\"></select>\n\n    <h4>Registration Information</h4>\n    <label class=\"sos-label-required\">Document Originator</label>\n    <a class=\"set-to-me\" data-dojo-attach-point=\"setToMeElement\" data-dojo-attach-event=\"click: _setOriginatorToCurrentPerson\">Set to me</a>\n    <br />\n    <div data-dojo-attach-point=\"elementInputOriginator\"></div>\n</div>",
'url:style-guide/v1/doc-control/template/InvalidRevisionNumberFormat.html':"<div class=\"document-move-invalid-revision-number-error\">\n    <p>The revision number contains invalid characters.</p>\n    <p>Revision numbers can only contain alphanumeric (a-Z / 0-9) characters, dashes (-) and full stops (.).</p>\n</div>\n",
'url:style-guide/v1/doc-control/registration-details/template/Revisionable.html':"<div class=\"sos-form-default-node sos-form-prioritise-required\">\n    <h4>Document Information</h4>\n    <label class=\"sos-label-required\">Title / Name / Subject</label>\n    <br />\n    <div data-dojo-attach-point=\"elementTitleValidation\" class=\"sos-form-textfield-validation\">\n        <input class=\"sos-form-textfield\" type=\"text\" data-dojo-attach-point=\"elementInputTitle\"/>\n        <div class=\"sos-form-textfield-validation-tag\"></div>\n        <br />\n        <label class=\"sos-form-textfield-validation-prompt\">Title is required</label>\n    </div>\n    <br />\n    <label class=\"sos-label-required\">Document Reference Number</label>\n    <br />\n    <div data-dojo-attach-point=\"elementReferenceValidation\" class=\"sos-form-textfield-validation\">\n        <input class=\"sos-form-textfield\" data-dojo-attach-event=\"input: _onReferenceInput\" type=\"text\" data-dojo-attach-point=\"elementInputReference\"/>\n        <div class=\"sos-form-textfield-validation-tag\"></div>\n        <br />\n        <label class=\"sos-form-textfield-validation-prompt\" data-dojo-attach-point=\"elementReferenceError\">Document Reference Number is required</label>\n    </div>\n    <p class=\"sos-alert-information-s alert-validation hide\" data-dojo-attach-point=\"elementReferenceExists\">\n        A revision with the provided reference already exists in the selected node\n        <a data-dojo-attach-event=\"click: _onViewExistingClick\">View Existing</a>\n    </p>\n    <p class=\"sos-alert-error-s alert-validation hide\" data-dojo-attach-point=\"elementReferenceHasPrivateRevision\">\n        A private document already exists in the selected node for the given reference. This cannot be revised on the current interface. A document controller can assist with revising the existing document\n        <a data-dojo-attach-point=\"elementProjectListingLinkAnchor\" target=\"_blank\"> via Office Overview</a>.\n    </p>\n    <br />\n    <label class=\"sos-label-required\">Date Sent</label>\n    <br />\n    <input class=\"sos-form-textfield\" type=\"text\" data-dojo-attach-point=\"elementInputDate\"/>\n    <br />\n    <div data-dojo-attach-point=\"privacyToggle\" class=\"hide\">\n        <label class=\"sos-form-checkbox sos-label-optional\">Private <i>(Show this document to only people I select)</i>\n            <input data-dojo-attach-point=\"elementInputIsPrivate\" type=\"checkbox\" /><span></span>\n        </label>\n    </div>\n\n    <h4>Revision Information</h4>\n    <label class=\"sos-label-required\">Revision Number</label>\n    <br />\n    <div data-dojo-attach-point=\"elementRevisionValidation\" class=\"sos-form-textfield-validation\">\n        <input class=\"sos-form-textfield\" type=\"text\" data-dojo-attach-point=\"elementInputRevision\" data-dojo-attach-event=\"input: _validateRevisionNumber\"/>\n        <div class=\"sos-form-textfield-validation-tag\"></div>\n        <br />\n        <label data-dojo-attach-point=\"elementRevisionNumberError\" class=\"sos-form-textfield-validation-prompt\">\n            Revision Number is required\n        </label>\n    </div>\n    <p class=\"sos-alert-error-s alert-validation hide\" data-dojo-attach-point=\"elementRevisionExists\">\n        A revision with the provided reference and revision number already exists in the selected node\n        <a data-dojo-attach-event=\"click: _onViewExistingClick\">View Existing</a>\n    </p>\n    <br />\n    <label class=\"sos-label-required\">Current Status</label>\n    <br />\n    <select data-dojo-attach-point=\"elementStatusSelect\"></select>\n\n    <h4>Registration Information</h4>\n    <label class=\"sos-label-required\">Document Originator</label>\n    <a class=\"set-to-me\" data-dojo-attach-point=\"setToMeElement\" data-dojo-attach-event=\"click: _setOriginatorToCurrentPerson\">Set to me</a>\n    <br />\n    <div data-dojo-attach-point=\"elementInputOriginator\"></div>\n</div>",
'url:style-guide/v1/doc-control/registration-details/template/RevisionableFromFunction.html':"<div class=\"sos-form-default-node sos-form-prioritise-required\">\n    <h4>Document Information</h4>\n    <label class=\"sos-label-required\">Title / Name / Subject</label>\n    <br />\n    <div data-dojo-attach-point=\"elementTitleValidation\" class=\"sos-form-textfield-validation\">\n        <input class=\"sos-form-textfield\" type=\"text\" data-dojo-attach-point=\"elementInputTitle\"/>\n        <div class=\"sos-form-textfield-validation-tag\"></div>\n        <br />\n        <label class=\"sos-form-textfield-validation-prompt\">Title is required</label>\n    </div>\n    <br />\n    <label class=\"sos-label-required\">Document Reference Number</label>\n    <br />\n    <div data-dojo-attach-point=\"elementReferenceValidation\" class=\"sos-form-textfield-validation\">\n        <input class=\"sos-form-textfield\" data-dojo-attach-event=\"input: _onReferenceInput\" type=\"text\" data-dojo-attach-point=\"elementInputReference\"/>\n        <div class=\"sos-form-textfield-validation-tag\"></div>\n        <br />\n        <label class=\"sos-form-textfield-validation-prompt\" data-dojo-attach-point=\"elementReferenceError\">Document Reference Number is required</label>\n    </div>\n    <p class=\"sos-alert-information-s alert-validation hide\" data-dojo-attach-point=\"elementReferenceExists\">\n        A revision with the provided reference already exists in the selected node\n        <a data-dojo-attach-event=\"click: _onViewExistingClick\">View Existing</a>\n    </p>\n    <p class=\"sos-alert-error-s alert-validation hide\" data-dojo-attach-point=\"elementReferenceHasPrivateRevision\">\n        A private document already exists in the selected node for the given reference. This cannot be revised on the current interface. A document controller can assist with revising the existing document\n        <a data-dojo-attach-point=\"elementProjectListingLinkAnchor\" target=\"_blank\"> via Office Overview</a>.\n    </p>\n    <br />\n    <label class=\"sos-label-required\">Date Sent</label>\n    <br />\n    <input class=\"sos-form-textfield\" type=\"text\" data-dojo-attach-point=\"elementInputDate\"/>\n    <br />\n    <div data-dojo-attach-point=\"privacyToggle\" class=\"hide\">\n        <label class=\"sos-form-checkbox sos-label-optional\">Private <i>(Show this document to only people I select)</i>\n            <input data-dojo-attach-point=\"elementInputIsPrivate\" type=\"checkbox\" /><span></span>\n        </label>\n    </div>\n\n    <h4>Revision Information</h4>\n    <label class=\"sos-label-required\">Revision Number</label>\n    <br />\n    <div data-dojo-attach-point=\"elementRevisionValidation\" class=\"sos-form-textfield-validation\">\n        <input class=\"sos-form-textfield\" type=\"text\" data-dojo-attach-point=\"elementInputRevision\" data-dojo-attach-event=\"input: _validateRevisionNumber\"/>\n        <div class=\"sos-form-textfield-validation-tag\"></div>\n        <br />\n        <label data-dojo-attach-point=\"elementRevisionNumberError\" class=\"sos-form-textfield-validation-prompt\">\n            Revision Number is required\n        </label>\n    </div>\n    <p class=\"sos-alert-error-s alert-validation hide\" data-dojo-attach-point=\"elementRevisionExists\">\n        A revision with the provided reference and revision number already exists in the selected node\n        <a data-dojo-attach-event=\"click: _onViewExistingClick\">View Existing</a>\n    </p>\n    <br />\n    <label class=\"sos-label-required\">Current Status</label>\n    <br />\n    <select data-dojo-attach-point=\"elementStatusSelect\"></select>\n\n    <h4>Registration Information</h4>\n    <label class=\"sos-label-required\">Document Originator</label>\n    <a class=\"set-to-me\" data-dojo-attach-point=\"setToMeElement\" data-dojo-attach-event=\"click: _setOriginatorToCurrentPerson\">Set to me</a>\n    <br />\n    <div data-dojo-attach-point=\"elementInputOriginator\"></div>\n\n    <h4>Location Information</h4>\n    <label class=\"sos-label-required\">File Location Reference</label>\n    <br />\n    <div data-dojo-attach-point=\"elementNodeReferenceValidation\" class=\"sos-form-textfield-validation\">\n        <input class=\"sos-form-textfield\" type=\"text\" data-dojo-attach-point=\"elementInputNodeReference\" />\n        <div class=\"sos-form-textfield-validation-tag\"></div>\n        <br />\n        <label class=\"sos-form-textfield-validation-prompt\">File Location Reference is required</label>\n    </div>\n</div>\n",
'url:style-guide/v1/doc-control/project-node-select/template/SuggestedNodeListing.html':"<div>\n    <p class=\"sos-alert-information-s mb-0 hidden\" data-dojo-attach-point=\"refreshItemsHeader\">\n        Updated suggestions have been found,\n        <a data-dojo-attach-event=\"click: _onRefreshClick\">click here</a> to refresh.\n    </p>\n    <div class=\"suggested-items-header hidden\" data-dojo-attach-point=\"suggestedItemsHeader\">\n        <div class=\"header-item-location\">Node</div>\n        <div class=\"header-item-confidence\">Confidence</div>\n    </div>\n    <ul class=\"sos-node-listing suggested-node-listing\" data-dojo-attach-point=\"nodeListing\">\n        <% for (let i in menuItems) { %>\n            <% if (menuItems.hasOwnProperty(i)) { %>\n                <li data-dom-node-tree-view-pk=\"<%= menuItems[i].treeViewPK %>\"\n                    class=\"sos-node-listing-item\">\n                    <a data-dojo-attach-event=\"click: _onNodeClick\"\n                       data-node-tree-view-pk=\"<%= menuItems[i].treeViewPK %>\"\n                       data-node-title=\"<%= menuItems[i].name %>\"\n                       data-node-type=\"<%= menuItems[i].type %>\"\n                       title=\"Select <%= menuItems[i].name %>\">\n                            <div class=\"sos-icon <%= menuItems[i].icon %> node-item-name\"><%= menuItems[i].name %></div>\n                            <div class=\"node-item-confidence\"><%= getConfidence(menuItems[i]); %>%</div>\n                    </a>\n                </li>\n            <% } %>\n        <% } %>\n    </ul>\n</div>",
'url:style-guide/v1/doc-control/project-node-select/template/SuggestedNodeSelect.html':"<div class=\"suggested-node-select-container\">\n    <div data-dojo-attach-point=\"suggestedLocationsAccordionNode\">\n        <div class=\"loading-overlay hidden\" data-dojo-attach-point=\"loadingNode\">\n            <p class=\"loading-state\">\n                <span class=\"sos-icon sos-icon-animation-spin-smooth sos-icon-refresh\"></span>\n                <br />\n                <span data-dojo-attach-point=\"loadingMessage\">Loading...</span>\n            </p>\n        </div>\n        <p class=\"sos-alert-information hide\" data-dojo-attach-point=\"messageInfo\">\n            Determining suggested folders is taking longer than expected,\n            you can continue to wait or select a folder manually by expanding <b>\"All Locations\"</b> below.\n        </p>\n        <p class=\"sos-alert-error mt-12 hide\" data-dojo-attach-point=\"messageError\">\n            Sorry, we're unable to determine the suggested folders for this file.\n            <br />\n            Select a folder manually by expanding <b>\"All Locations\"</b> below.\n            <br />\n            Contact support for assistance.\n        </p>\n        <p class=\"sos-empty-state\" data-dojo-attach-point=\"noneFoundContainer\">\n            <span class=\"sos-icon sos-icon-close\">Could not suggest any locations.</span>\n        </p>\n        <div class=\"filtering-node-select filtering-node-select-auto-height\">\n            <div data-dojo-attach-point=\"suggestedLocationsNode\"></div>\n        </div>\n    </div>\n    <div class=\"filtering-node-select\" data-dojo-attach-point=\"filteringNodeSelectNode\">\n        <div class=\"filtering-node-select-filter-wrapper\">\n            <input type=\"text\" data-dojo-attach-point=\"filterInput\" data-dojo-attach-event=\"keyup: _onFilterInputKeyUp\" class=\"sos-form-textfield\" />\n        </div>\n        <div data-dojo-attach-point=\"nodeListingWrapper\">\n            <div data-dojo-attach-point=\"nodeListingContainer\"></div>\n        </div>\n    </div>\n\n    <div class=\"sos-accordion\" data-dojo-attach-point=\"accordionContainerNode\"></div>\n</div>\n",
'url:style-guide/v1/doc-control/document/revise/template/Form.html':"<div class=\"revise-document-form\">\n    <% if(!revision) { %>\n        <span class=\"sos-icon sos-icon-animation-spin-smooth sos-icon-refresh\" data-dojo-attach-point=\"loadingIcon\"></span>\n    <% } %>\n\n    <% if(revision) { %>\n        <div data-dojo-attach-point=\"documentCardContainer\"></div>\n\n        <form id=\"reviseDocumentForm\">\n            <div class=\"sos-form-file-group\" data-dojo-attach-point=\"fileUploadContainer\">\n                <label class=\"sos-label-required\">\n                    File (Max 250MB)\n                </label>\n                <div class=\"sos-form-textfield-validation\" data-dojo-attach-point=\"fileNameFieldContainer\">\n                    <input data-dojo-attach-point=\"fileNameField\"\n                           type=\"text\"\n                           class=\"sos-form-textfield\"\n                           placeholder=\"Upload new document.\"\n                           data-dojo-attach-event=\"click: _uploadFile\"\n                           readonly\n                    />\n                    <div class=\"sos-form-textfield-validation-tag\"></div>\n                </div>\n\n                <div class=\"sos-btn btn-file\">\n                    <span>Browse</span>\n                    <input type=\"file\" data-dojo-attach-event=\"change: _handleFileUpload\" data-dojo-attach-point=\"fileUploadButton\">\n                </div>\n            </div>\n\n            <div class=\"sos-form-file-group hide\" data-dojo-attach-point=\"temporaryDocumentContainer\">\n                <h5 class=\"sos-icon sos-icon-file\" data-dojo-attach-point=\"temporaryDocumentName\"></h5>\n            </div>\n\n            <label class=\"sos-label-required\">\n                Title / Name / Subject\n                <a disabled=\"disabled\"\n                   class=\"set-title-to-file-name\"\n                   data-dojo-attach-point=\"setTitleToFileNameLink\"\n                   data-dojo-attach-event=\"click: _setTitleToFileName\">Set to file name</a>\n            </label>\n            <div class=\"sos-form-textfield-validation\">\n                <input type=\"text\"\n                       class=\"sos-form-textfield sos-form-textfield-validation\"\n                       data-dojo-attach-event=\"change: validate\"\n                       data-dojo-attach-point=\"titleField\"\n                       value=\"<%= revision.getTitle(); %>\"\n                       required\n                />\n                <div class=\"sos-form-textfield-validation-tag\"></div>\n                <label class=\"sos-form-textfield-validation-prompt\">\n                    This field is required.\n                </label>\n            </div>\n\n            <% if(node.getType() === 'Revisionable' || node.getType() === 'Drawing') { %>\n                <label class=\"sos-label-required\">Document Reference</label>\n                <div class=\"sos-form-textfield-validation\">\n                    <input type=\"text\"\n                           class=\"sos-form-textfield sos-form-textfield-validation\"\n                           data-dojo-attach-event=\"change: validate\"\n                           data-dojo-attach-point=\"referenceField\"\n                           value=\"<%= revision.getReference(); %>\"\n                           required\n                    />\n                    <div class=\"sos-form-textfield-validation-tag\"></div>\n                    <label class=\"sos-form-textfield-validation-prompt\">\n                        This field is required.\n                    </label>\n                </div>\n\n                <label class=\"sos-label-required\">Revision Number</label>\n                <div class=\"sos-form-textfield-validation\" data-dojo-attach-point=\"revisionNumberFieldContainer\">\n                    <input type=\"text\"\n                           class=\"sos-form-textfield sos-form-textfield-validation\"\n                           data-dojo-attach-event=\"change: validate\"\n                           data-dojo-attach-point=\"revisionNumberField\"\n                           required\n                    />\n                    <div class=\"sos-form-textfield-validation-tag\"></div>\n                    <label class=\"sos-form-textfield-validation-prompt\" data-dojo-attach-point=\"revisionNumberFieldValidationMessage\">\n                        Enter the next revision number\n                    </label>\n                </div>\n\n                <label class=\"sos-label-required\">Current Status</label>\n                <div data-dojo-attach-point=\"statusFilterSelectContainer\"></div>\n            <% } else { %>\n                <label class=\"sos-label-optional\">Document Reference</label>\n                <div class=\"sos-form-textfield-validation\">\n                    <input type=\"text\"\n                           class=\"sos-form-textfield sos-form-textfield-validation\"\n                           data-dojo-attach-event=\"change: validate\"\n                           data-dojo-attach-point=\"referenceField\"\n                           value=\"<%= revision.getReference(); %>\"\n                    />\n                </div>\n            <% } %>\n\n            <% if(node.getType() === 'Drawing') { %>\n                <label class=\"sos-label-required\">Drawing Discipline</label>\n                <div data-dojo-attach-point=\"disciplineFilterSelectContainer\"></div>\n            <% } %>\n\n            <div data-dojo-attach-point=\"personFilterSelectContainer\">\n                <label class=\"sos-label-required\">\n                    Document Originator\n                    <a class=\"select-organisation-toggle sos-icon sos-icon-office\"\n                       data-dojo-attach-event=\"click: _showOrganisationFilterSelect\">Select an organisation instead</a>\n                </label>\n            </div>\n\n            <div data-dojo-attach-point=\"organisationFilterSelectContainer\" class=\"hide\">\n                <label class=\"sos-label-required\">\n                    Document Originator\n                    <a class=\"select-person-toggle sos-icon sos-icon-user\"\n                       data-dojo-attach-event=\"click: _showPersonFilterSelect\">Select a person instead</a>\n                </label>\n            </div>\n\n            <label class=\"sos-label-required\">Relevant/Event Date</label>\n            <div data-dojo-attach-point=\"relevantDateSelectContainer\"></div>\n\n            <div data-dojo-attach-point=\"privacyToggle\" class=\"hide\">\n                <label class=\"sos-form-checkbox\">\n                    <input data-dojo-attach-point=\"privateCheckbox\"\n                    <%= revision.isPrivate() ? 'checked' : ''; %> type=\"checkbox\" />\n                    <span></span>\n                    Show document to only the people I select\n                </label>\n            </div>\n        </form>\n\n        <div class=\"sos-form-pane-body-buttons\">\n            <button class=\"sos-btn sos-btn-confirm sos-btn-icon sos-icon-pencil-paper\"\n                    data-dojo-attach-event=\"click: _submit\"\n                    data-dojo-attach-point=\"submitButton\"\n            >Revise Document</button>\n        </div>\n    <% } %>\n</div>",
'url:style-guide/v1/doc-control/document/revise/template/FileAlreadyExistsNotification.html':"The uploaded file already exists on the system as <a class=\"sos-notification-link file-already-exists-original-title\"><%= originalTitle %></a> located in <a class=\"sos-notification-link file-already-exists-location\"><%= location %></a>. You can create a <a class=\"sos-notification-link file-already-exists-soft-link\">soft link</a> for the uploaded file.",
'url:style-guide/v1/doc-control/document/update-details/template/Form.html':"<div class=\"update-document-details-form\">\n    <div class=\"update-document-details-form-navigation-container hide\" data-dojo-attach-point=\"navigationContainer\">\n        <p class=\"sos-icon sos-icon-arrow-left-circle text-link update-document-details-form-previous-button mb-6 hide\" data-dojo-attach-point=\"previousButton\" data-dojo-attach-event=\"click:_previousDocument\">Previous</p>\n        <p class=\"sos-icon-after sos-icon-arrow-right-circle-after text-link update-document-details-form-next-button mb-6 hide\" data-dojo-attach-point=\"nextButton\" data-dojo-attach-event=\"click:_nextDocument\">Next</p>\n    </div>\n\n    <% if (!revision) { %>\n        <span class=\"sos-icon sos-icon-animation-spin-smooth sos-icon-refresh\"></span>\n    <% } else { %>\n        <div data-dojo-attach-point=\"documentCardContainer\"></div>\n\n        <form>\n            <label class=\"sos-label-required\">Title / Name / Subject</label>\n            <div class=\"sos-form-textfield-validation\">\n                <input type=\"text\"\n                       class=\"sos-form-textfield sos-form-textfield-validation\"\n                       data-dojo-attach-event=\"change: validate\"\n                       data-dojo-attach-point=\"titleField\"\n                       value=\"<%= revision.getTitle(); %>\"\n                       required\n                />\n                <div class=\"sos-form-textfield-validation-tag\"></div>\n                <label class=\"sos-form-textfield-validation-prompt\">\n                    This field is required.\n                </label>\n            </div>\n\n            <% if (revision.getMd5()) { %>\n                <label class=\"sos-label-required\">File Name</label>\n                <div class=\"sos-form-textfield-validation file-name-field-container\">\n                    <% const hasExtension = revision.getRealName().indexOf('.') !== -1; %>\n\n                    <% if (!hasExtension) { %>\n                    <input type=\"text\"\n                           class=\"sos-form-textfield sos-form-textfield-validation\"\n                           data-dojo-attach-event=\"change: validate\"\n                           data-dojo-attach-point=\"fileNameField\"\n                           value=\"<%= revision.getRealName(); %>\"\n                           required\n                    />\n                    <div class=\"sos-form-textfield-validation-tag\"></div>\n                    <% } else { %>\n                    <input type=\"text\"\n                           class=\"sos-form-textfield sos-form-textfield-validation sos-form-textfield-with-suffix sos-form-textfield-with-suffix-unit\"\n                           data-dojo-attach-event=\"change: validate\"\n                           data-dojo-attach-point=\"fileNameField\"\n                           value=\"<%= revision.getRealName().substring(0, revision.getRealName().lastIndexOf('.')); %>\"\n                           required\n                    />\n                    <div class=\"sos-form-textfield-validation-tag\"></div>\n                    <label class=\"sos-form-textfield-suffix sos-form-textfield-suffix-unit\">\n                        <%= revision.getRealName().substring(revision.getRealName().lastIndexOf('.')).toLowerCase(); %>\n                    </label>\n                    <% } %>\n                    <label class=\"sos-form-textfield-validation-prompt\">\n                        This field is required.\n                    </label>\n                </div>\n            <% } %>\n\n            <% if (node.getType() === 'Revisionable' || node.getType() === 'Drawing') { %>\n                <label class=\"sos-label-required\">Document Reference</label>\n                <div class=\"sos-form-textfield-validation\">\n                    <input type=\"text\"\n                           class=\"sos-form-textfield sos-form-textfield-validation\"\n                           data-dojo-attach-event=\"change: validate\"\n                           data-dojo-attach-point=\"referenceField\"\n                           value=\"<%= revision.getReference(); %>\"\n                           required\n                    />\n                    <div class=\"sos-form-textfield-validation-tag\"></div>\n                    <label class=\"sos-form-textfield-validation-prompt\">\n                        This field is required.\n                    </label>\n                </div>\n\n                <label class=\"sos-label-required\">Current Status</label>\n                <div data-dojo-attach-point=\"statusFilterSelectContainer\"></div>\n            <% } else { %>\n                <label class=\"sos-label-optional\">Document Reference</label>\n                <div class=\"sos-form-textfield-validation\">\n                    <input type=\"text\"\n                           class=\"sos-form-textfield sos-form-textfield-validation\"\n                           data-dojo-attach-event=\"change: validate\"\n                           data-dojo-attach-point=\"referenceField\"\n                           value=\"<%= revision.getReference(); %>\"\n                    />\n                </div>\n            <% } %>\n\n            <% if (node.getType() === 'Drawing') { %>\n                <label class=\"sos-label-required\">Drawing Discipline</label>\n                <div data-dojo-attach-point=\"disciplineFilterSelectContainer\"></div>\n            <% } %>\n\n            <div data-dojo-attach-point=\"personFilterSelectContainer\">\n                <label class=\"sos-label-required\">\n                    Document Originator\n                    <a class=\"select-organisation-toggle sos-icon sos-icon-office\"\n                       data-dojo-attach-event=\"click: _showOrganisationFilterSelect\">Select an organisation instead</a>\n                </label>\n            </div>\n\n            <div data-dojo-attach-point=\"organisationFilterSelectContainer\" class=\"hide\">\n                <label class=\"sos-label-required\">\n                    Document Originator\n                    <a class=\"select-person-toggle sos-icon sos-icon-user\"\n                       data-dojo-attach-event=\"click: _showPersonFilterSelect\">Select a person instead</a>\n                </label>\n            </div>\n\n            <label class=\"sos-label-required\">Relevant/Event Date</label>\n            <div data-dojo-attach-point=\"relevantDateSelectContainer\"></div>\n\n            <div data-dojo-attach-point=\"privacyToggle\" class=\"hide\">\n                <label class=\"sos-form-checkbox\">\n                    <input data-dojo-attach-point=\"privateCheckbox\"\n                    <%= revision.isPrivate() ? 'checked' : ''; %> type=\"checkbox\" />\n                    <span></span>\n                    Show document to only the people I select\n                </label>\n            </div>\n        </form>\n\n        <div class=\"sos-form-pane-body-buttons\">\n            <button class=\"sos-btn sos-btn-confirm sos-btn-icon sos-icon-pencil-paper\"\n                    data-dojo-attach-event=\"click: _submit\"\n                    data-dojo-attach-point=\"submitButton\">Update Document Details</button>\n        </div>\n    <% } %>\n</div>",
'url:style-guide/v1/doc-control/document/update-details/template/DocumentCard.html':"<div>\n    <%- render(card.getTemplate(), card); %>\n</div>",
'url:doccontrol/viewer/dojo/template/InitialisingScreen.html':"<div class=\"sos-v1 document-viewer-initialising-screen <%= inline ? 'inline' : '' %> <%= width ? `width-${width}` : '' %>\">\n    <div>\n        <span class=\"sos-icon sos-icon-animation-spin-smooth sos-icon-refresh display-inline-block\"></span>\n        <br />\n        <br />\n        <span>Initialising document viewer...</span>\n        <br />\n        <br />\n        <button class=\"sos-btn sos-btn-secondary sos-btn-icon sos-icon-close\"\n                data-dojo-attach-event=\"click: _onCancelClick\">Cancel</button>\n    </div>\n</div>",
'url:style-guide/v1/contacts/templates/HorizontalStackedList.html':"<div class=\"<%= contacts.length > 0 ? 'sos-contact-card-horizontal-stack sos-contact-cards' : '' %>\">\n    <% for (var i = 0; i < contacts.length; i++) { %>\n        <% if (clickable) {%>\n            <a class=\"sos-contact-card-horizontal sos-contact-card-horizontal-clickable <%= contacts[i].cardType %> sos-contact-card-horizontal-keyboard-focus\"\n               data-id=\"<%= contacts[i].id %>\"\n               data-dojo-attach-event=\"click: <%= resultClickDefaultBehaviour ? '_redirectToResultLink' : '_onContactClick' %>\">\n                <% if (!contacts[i].imageUrl) { %>\n                    <div class=\"sos-contact-card-icon\"></div>\n                <% } else { %>\n                    <img class=\"sos-contact-card-image\" src=\"<%= contacts[i].imageUrl %>\" title=\"<%= contacts[i].name %>\" />\n                <% } %>\n                <div class=\"sos-contact-card-details <%= isClientInstance ? 'contact-card-dc-client' : '' %>\">\n                    <span class=\"sos-contact-card-horizontal-type\"><%= contacts[i].type %></span>\n                    <span class=\"sos-contact-card-horizontal-name\">\n                        <%= contacts[i].name %>\n                    </span>\n                    <% if (contacts[i].email) { %>\n                        <span class=\"sos-contact-card-horizontal-email\">(<%= contacts[i].email %>)</span>\n                    <% } %>\n                    <div class=\"sos-contact-card-horizontal-about\">\n                        <% if (contacts[i].type == 'Organisation') { %>\n                            <% if (contacts[i].trades.length > 1) { %>\n                                <%= contacts[i].trades[0] %> <span data-index=\"<%= i; %>\" data-dojo-attach-event=\"mouseenter: showTrades\">(View All)</span>\n                            <% } else { %>\n                                <%= contacts[i].trades[0] %>\n                            <% } %>\n                        <% } else { %>\n                            <% if (contacts[i].jobTitle) { %>\n                                <%= contacts[i].jobTitle %> <i>at</i>\n                            <% } %>\n                            <%= contacts[i].organisation ? contacts[i].organisation : '[No Organisation]' %>\n                        <% } %>\n                    </div>\n                    <% if (canViewDocuments) { %>\n                        <div class=\"sos-contact-card-horizontal-view-docs\" data-dojo-attach-event=\"click: _onViewDocumentsClick\" data-id=\"<%= contacts[i].id %>\">View Documents</div>\n                    <% } %>\n                    <div class=\"sos-contact-card-horizontal-tel\"><%= contacts[i].telephone ? 'Tel: ' + contacts[i].telephone : '' %></div>\n                </div>\n            </a>\n        <%} else { %>\n            <div class=\"sos-contact-card-horizontal <%= contacts[i].cardType %> sos-contact-card-horizontal-keyboard-focus\" data-id=\"<%= contacts[i].id %>\">\n                <div class=\"sos-contact-card-icon\"></div>\n                <div class=\"sos-contact-card-details <%= isClientInstance ? 'contact-card-dc-client' : '' %>\">\n                    <span class=\"sos-contact-card-horizontal-type\"><%= contacts[i].type %></span>\n                    <span class=\"sos-contact-card-horizontal-name\">\n                        <%= contacts[i].name %>\n                    </span>\n                    <div class=\"sos-contact-card-horizontal-about\">\n                        <% if (contacts[i].type == 'Organisation') { %>\n                            <%= contacts[i].trades.join(', ') %>\n                        <% } else { %>\n                            <% if (contacts[i].jobTitle) { %>\n                                <%= contacts[i].jobTitle %> <i>at</i>\n                            <% } %>\n                            <%= contacts[i].organisation ? contacts[i].organisation : '[No Organisation]' %>\n                        <% } %>\n                        <% if (canViewDocuments) { %>\n                            <div class=\"sos-contact-card-horizontal-view-docs\" data-dojo-attach-event=\"click: _onViewDocumentsClick\" data-id=\"<%= contacts[i].id %>\">View Documents</div>\n                        <% } %>\n                        <div class=\"sos-contact-card-horizontal-tel\"><%= contacts[i].telephone ? 'Tel: ' + contacts[i].telephone : '' %></div>\n                    </div>\n                </div>\n            </div>\n        <% } %>\n    <% } %>\n    <% if (contacts.length > 0) { %>\n        <br />\n    <% } %>\n</div>\n",
'url:style-guide/v1/contacts/templates/ExtendedTradeList.html':"<ul>\n    <% for (i in trades) { %>\n        <li><%= trades[i]%></li>\n    <% } %>\n</ul>",
'url:style-guide/v1/favourites/templates/EmptyItem.html':"<li class=\"sos-favourite-vertical-list-empty-item sos-favourite-vertical-list-<%= type; %>-empty-item height-auto p-0\">\n    <p class=\"sos-empty-state sos-empty-state-show border-none height-auto py-12 m-0\">\n        <span class=\"sos-icon <%= getIcon(type); %>\">No <%= type; %>s found.</span>\n    </p>\n</li>\n",
'url:style-guide/v1/favourites/templates/Item.html':"<li>\n    <% if (isValid()) { %>\n        <a href=\"<%= baseUrl %>myoffice/favourite.php?action=invoke&favouritePK=<%= favourite.favouritePK %>\">\n            <span class=\"sos-icon <%= getIcon(favourite.list) %> mx-6\"></span><%= favourite.name %>\n        </a>\n    <% } else { %>\n        <a data-dojo-attach-event=\"click: _click\"><span class=\"sos-icon <%= getIcon(favourite.list) %> mx-6\"></span><%= favourite.name %></a>\n    <% }%>\n</li>",
'url:style-guide/v1/favourites/templates/VerticalList.html':"<ul data-dojo-attach-point=\"list\" class=\"sos-favourite-vertical-list sos-favourite-vertical-list-scrollable\"></ul>\n",
'url:style-guide/v1/notifications/templates/SystemNotification.html':"<p class=\"sos-notification-<%= type %> sos-notification-count-down sos-notification-inline\"\n   data-dojo-attach-event=\"click: _clickCallback\"\n>\n    <% if ((type == 'progress' && typeof hideable !== 'undefined' && hideable) || type != 'progress') { %>\n        <a title=\"Close this notification\" class=\"sos-notification-close-btn\" data-dojo-attach-event=\"click: hide\">\n            <%= type == 'progress' ? 'hide' : 'close' %>\n        </a>\n    <% } %>\n\n    <% if (typeof imageURL !== 'undefined' && imageURL) { %>\n        <img src=\"<%= imageURL %>\" />\n    <% } %>\n\n    <span class=\"inline-block\" data-dojo-attach-point=\"templateMessage\"><%- message %></span>\n\n    <span class=\"sos-notification-progress-bar\" data-dojo-attach-point=\"templateProgressBar\"></span>\n</p>\n",
'*now':function(r){r(['dojo/i18n!*preload*layer/nls/main*["ar","ca","cs","da","de","el","en-gb","en-us","es-es","fi-fi","fr-fr","he-il","hu","it-it","ja-jp","ko-kr","nl-nl","nb","pl","pt-br","pt-pt","ru","sk","sl","sv","th","tr","zh-tw","zh-cn","ROOT"]']);}
}});
define("layer/main", [], 1);
